(function() {
    'use strict';

    angular
        .module('app.core', [
            'ngAnimate',
            'ngAria',
            'ngCookies',
            'ngMessages',
            'ngResource',
            'ngSanitize',
            'ngMaterial',
            'ngStorage',
            'firebase',
            'angular-chartist',
            'chart.js',
            'md.data.table',
            'gridshore.c3js.chart',
            'nvd3',
            'pascalprecht.translate',
            'timer',
            'ui.router',
            'textAngular',
            'ui.sortable',
            'ng-sortable',
            'xeditable',
            'moment-picker',
            'lfNgMdFileInput',
            'slugifier',
            'angularMoment',
            'fixed.table.header',
            'sortable',
            'ui.swiper'
        ]);
})();
/* eslint-disable angular/json-functions */
(function () {
    'use strict';

    angular
        .module('app.core')
        .controller('EditConceptsController', EditConceptsController);

    /** @ngInject */
    function EditConceptsController($mdDialog, DataF, AppF, $rootScope, errAlertS, successAlertS, $log, $firebaseObject) {
        var vm = this;
        vm.centersData = AppF.centersData;
        vm.conceptsToCompare = [];
        vm.conceptsLoaded = {};
        vm.fields = [];
        vm.getConcepts = function (searchKey) {
            // , fid: { $nin: vm.conceptsToCompare }
            var thisProject = { project: { name: 1, fid: 1, center: 1, key: 1 } };
            return new Promise(function (resolve, reject) {
                DataF.api.autocompleteMongo(searchKey, "concepts", ["name", "key", "id_human"], thisProject).then(function (items) {
                    resolve(items.sort(function (a, b) { return a.name.localeCompare(b.name) }));
                }).catch(function (err) {
                    reject(err);
                });
            })
        }
        vm.setCalculation = function (conceptIndex) {
            try {
                var conceptIdSource = vm.conceptsToCompare[0];
                var calculationSourceIndex = vm.calcSelected[conceptIdSource];
                var calculationDataSource = vm.conceptsLoaded[conceptIdSource].calculations[calculationSourceIndex];
                if (angular.isUndefined(calculationDataSource)) {
                    throw new Error("Calculation data source is undefined");
                }
                var conceptIdDestiny = vm.conceptsToCompare[conceptIndex];
                var calculationDestinyIndex = vm.calcSelected[conceptIdDestiny];
                var calculationDataDestiny = vm.conceptsLoaded[conceptIdDestiny].calculations[calculationDestinyIndex];
                if (angular.isUndefined(calculationDataDestiny)) {
                    throw new Error("Calculation data destiny is undefined");
                }
                var sourceFields = calculationDataSource.fields;
                var destinyFields = calculationDataDestiny.fields;
                if ((!angular.isArray(sourceFields)) || (!angular.isArray(destinyFields))) {
                    throw new Error("Fields data is not an array");
                }
                var newFields = [];
                for (var f = 0; f < sourceFields.length; f++) {
                    var sourceField = sourceFields[f];
                    var thisDestinyField = destinyFields.find(function (item) { return item.id == sourceField.id; });
                    if (angular.isUndefined(thisDestinyField)) {
                        thisDestinyField = JSON.parse(JSON.stringify(sourceField));
                        delete thisDestinyField.accumulator;
                    }
                    thisDestinyField.name = sourceField.name;
                    thisDestinyField.formule = sourceField.formule;
                    thisDestinyField.outputType = sourceField.outputType;
                    delete thisDestinyField.hidden;
                    if (sourceField.hidden) {
                        thisDestinyField.hidden = true;
                    }
                    delete thisDestinyField.positions;
                    if (sourceField.hasOwnProperty('positions')) {
                        thisDestinyField.positions = sourceField.positions;
                    }
                    delete thisDestinyField.validation;
                    if (sourceField.hasOwnProperty('validation')) {
                        thisDestinyField.validation = sourceField.validation;
                    }
                    delete thisDestinyField.customValidation;
                    if (sourceField.hasOwnProperty('customValidation')) {
                        thisDestinyField.customValidation = sourceField.customValidation;
                    }
                    delete thisDestinyField.process;
                    if (sourceField.hasOwnProperty('process')) {
                        thisDestinyField.process = sourceField.process;
                    }
                    newFields.push(thisDestinyField);
                }
                $rootScope.loadingProgress = true;
                $log.log(angular.isArray(vm.conceptsLoaded[conceptIdDestiny].calculations), vm.conceptsLoaded[conceptIdDestiny].calculations.length, vm.conceptsLoaded[conceptIdDestiny].calculations);

                var updates = {};
                updates[vm.conceptsLoaded[conceptIdDestiny].calculations.length + "/fields"] = newFields;
                updates[vm.conceptsLoaded[conceptIdDestiny].calculations.length + "/conceptType"] = 'default';
                updates[vm.conceptsLoaded[conceptIdDestiny].calculations.length + "/directive"] = false;
                updates[vm.conceptsLoaded[conceptIdDestiny].calculations.length + "/disabledEdit"] = true;
                updates[(vm.conceptsLoaded[conceptIdDestiny].calculations.length - 1) + "/conceptType"] = 'custom';
                updates[(vm.conceptsLoaded[conceptIdDestiny].calculations.length - 1) + "/disabledEdit"] = null;
                updates[(vm.conceptsLoaded[conceptIdDestiny].calculations.length - 1) + "/validations/0"] = { condition: 'customField.applyLastCalculation', operator: 'equal', 'value': '#number:1' };
                AppF.root.child("catalogs/concepts/collection/" + conceptIdDestiny + "/calculations/").update(updates).then(function () {
                    successAlertS("Calculation fields copied successfully");
                    return loadConcepts()
                }).then(function () {
                    $rootScope.loadingProgress = false;
                    vm.compareCalculations();
                }).catch(function (err) {
                    $rootScope.loadingProgress = false;
                    errAlertS(err);
                })
            } catch (error) {
                $rootScope.loadingProgress = false;
                errAlertS(error);
            }
        }
        vm.compareCalculations = function () {
            var thisFields = [];
            var fieldByCalcId = {};
            for (var i = 0; i < vm.conceptsToCompare.length; i++) {
                var lastFieldId = undefined;
                var conceptId = vm.conceptsToCompare[i]
                var thisConcept = vm.conceptsLoaded[conceptId];
                if (thisConcept && angular.isDefined(vm.calcSelected[conceptId]) && angular.isArray(thisConcept.calculations[vm.calcSelected[conceptId]].fields)) {
                    var calcFields = thisConcept.calculations[vm.calcSelected[conceptId]].fields;
                    for (var j = 0; j < calcFields.length; j++) {
                        var thisField = calcFields[j];
                        var index = thisFields.findIndex(function (item) { return item.id == thisField.id; });
                        if (index == -1) {
                            index = thisFields.length
                            if (angular.isDefined(lastFieldId)) {
                                var posibleIndex = thisFields.findIndex(function (item) { return item.id == lastFieldId; });
                                if (posibleIndex > -1) {
                                    index = posibleIndex + 1
                                }
                            }
                            thisFields.splice(index, 0, { id: thisField.id, calculations: {} });
                        }
                        if (angular.isUndefined(fieldByCalcId[thisField.id])) {
                            fieldByCalcId[thisField.id] = [];
                        }
                        Object.keys(thisField).forEach(function (key) {
                            if (fieldByCalcId[thisField.id].indexOf(key) == -1) {
                                fieldByCalcId[thisField.id].push(key)
                            }
                        })
                        thisFields[index].calculations[conceptId] = thisField;
                        lastFieldId = thisField.id;
                    }
                }
            }
            $log.log(fieldByCalcId)
            for (var t = 0; t < thisFields.length; t++) {
                var allFields = fieldByCalcId[thisFields[t].id];
                for (var f = 0; f < allFields.length; f++) {
                    var thisFieldName = allFields[f];
                    var thisValue = undefined;
                    var allSame = true;
                    for (var calc in thisFields[t].calculations) {
                        if (angular.isUndefined(thisValue)) {
                            thisValue = thisFields[t].calculations[calc][thisFieldName];
                        }
                        if (thisValue !== thisFields[t].calculations[calc][thisFieldName]) {
                            allSame = false;
                            break;
                        }
                    }
                    thisFields[t].same = thisFields[t].same || {};
                    thisFields[t].same[thisFieldName] = allSame;
                }
            }
            $log.log(thisFields);
            vm.fields = thisFields;
        }
        var loadConcepts = function () {
            return new Promise(function (resolve, reject) {
                try {
                    var promises = [];
                    var indexes = [];
                    for (var i = 0; i < vm.conceptsToCompare.length; i++) {
                        if (!vm.conceptsLoaded.hasOwnProperty(vm.conceptsToCompare[i])) {
                            promises.push($firebaseObject(AppF.root.child("catalogs/concepts/collection/" + vm.conceptsToCompare[i])).$loaded());
                            indexes.push(vm.conceptsToCompare[i])
                        }
                    }
                    Promise.all(promises).then(function (snaps) {
                        for (var i = 0; i < snaps.length; i++) {
                            vm.conceptsLoaded[indexes[i]] = snaps[i]
                        }
                        $log.log(vm.conceptsLoaded);
                        resolve(true)
                    }).catch(reject)
                } catch (error) {
                    reject(error)
                }
            });
        }
        function getAllConcepts(concept, addAll) {
            return new Promise(function (resolve, reject) {
                var data = [];
                if (addAll) {
                    var params = {
                        key: concept.key,
                        project: { fid: 1 }
                    };
                    $rootScope.D.api.get('concepts', params).then(function (resp) {
                        resolve(resp.data.map(function (item) { return item.fid }))
                    }).catch(reject);
                } else {
                    data = [concept.fid];
                    resolve(data)
                }
            })
        }
        vm.addConceptForCompare = function (concept, addAll) {
            getAllConcepts(concept, addAll).then(function (thisConceptsIds) {
                var anyAdded = false;
                for (var t = 0; t < thisConceptsIds.length; t++) {
                    var thisConceptId = thisConceptsIds[t];
                    if (vm.conceptsToCompare.findIndex(function (item) { return item == thisConceptId; }) == -1) {
                        vm.conceptsToCompare.push(thisConceptId);
                        $rootScope.loadingProgress = true;
                        $rootScope.$evalAsync()
                        anyAdded = true;

                    }
                }
                if (anyAdded) {
                    loadConcepts().then(function () {
                        vm.conceptSelected = undefined;
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync()
                    }).catch(function (err) {
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync()
                        errAlertS(err)
                    });
                }
                vm.conceptSelected = undefined;
            }).catch(errAlertS);


        }
        vm.hide = function () {
            $mdDialog.hide();
        };
        vm.cancel = function () {
            $mdDialog.cancel();
        };
    }
}());

(function () {
    'use strict';

    angular
        .module('app.clients', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {

        // State
        $stateProvider
            .state('app.processes', {
                abstract: true,
                url: '/processes'
            })
            .state('app.organization', {
                abstract: true,
                url: '/organization'
            })

            .state('app.organization.firms', {
                url: '/firms',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/clients/views/firms/firms.html',
                        controller: 'FBListsController'
                    }
                },
                bodyClass: 'clients'
            })
            .state('app.organization.firms.update', {
                url: '/update/:firmId',
                params: {
                    firm: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/clients/views/firms/firm.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'clients'
            })
            .state('app.organization.firms.read', {
                url: '/read/:firmId',
                params: {
                    firm: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/clients/views/firms/firm.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'clients'
            })

            .state('app.processes.stampedRecords', {
                url: '/stampedRecords/:payrollId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/clients/views/operations/stampedRecords.html',
                        controller: 'MongoListsController'
                    }
                },
                bodyClass: 'clients'
            })
            .state('app.processes.xmlBillsRequests', {
                url: '/xmlBillsRequests/',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/clients/views/xmlBillsRequests/xmlBillsRequests.html',
                        controller: 'MongoListsController'
                    }
                },
                bodyClass: 'clients'
            })
            .state('app.processes.attendanceLists', {
                url: '/attendanceLists/:payrollId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/clients/views/operations/attendanceLists.html',
                        controller: 'MongoListsController'
                    }
                },
                bodyClass: 'clients'
            })
            .state('app.processes.attendanceLists.update', {
                url: '/update/:calendar/:period',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/clients/views/operations/attendanceList.html',
                        controller: 'AttendanceListController as alCtrl'
                    }
                },
                bodyClass: 'clients'
            })
            .state('app.processes.attendanceLists.read', {
                url: '/read/:calendar/:period',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/clients/views/operations/attendanceList.html',
                        controller: 'AttendanceListController as alCtrl'
                    }
                },
                bodyClass: 'clients'
            })
            .state('app.processes.operations', {
                url: '/operations/:payrollId?calendarYear&period',
                params: {
                    operations: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/clients/views/operations/operations.html',
                        controller: 'MongoListsController'
                    }
                },
                bodyClass: 'clients'
            })
            .state('app.processes.operations.update', {
                url: '/update/:operationType/:operationId',
                params: {
                    operation: null,
                    operations: null
                },
                views: {
                    'content@app': {
                        templateUrl: function ($stateParams) {
                            return 'app/main/clients/views/operation/operation-' + $stateParams.operationType + '.html';
                        },
                        //templateUrl: 'app/main/clients/views/operation/operation.html',
                        controller: 'OperationController'
                    }
                },
                bodyClass: 'clients'
            })
            .state('app.processes.operations.edit', {
                url: '/edit/ordinary/:operationId',
                params: {
                    operation: null,
                    operations: null,
                    operationType: 'ordinary'
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/clients/views/newoperation/ordinary.html',
                        controller: 'Operation2NDController'
                    }
                },
                bodyClass: 'clients'
            })
            .state('app.processes.operations.editSettlement', {
                url: '/edit/settlement/:operationId',
                params: {
                    operation: null,
                    operations: null,
                    operationType: 'settlement'
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/clients/views/newoperation/settlement.html',
                        controller: 'Operation3RDController'
                    }
                },
                bodyClass: 'clients'
            })
            .state('app.processes.operations.editSpecial', {
                url: '/edit/:operationType/:operationId',
                params: {
                    operation: null,
                    operations: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/clients/views/newoperation/special.html',
                        controller: 'Operation4THController'
                    }
                },
                bodyClass: 'clients'
            })
            .state('app.processes.operations.read', {
                url: '/read/:operationType/:operationId',
                params: {
                    operation: null,
                    operations: null
                },
                views: {
                    'content@app': {
                        templateUrl: function ($stateParams) {
                            return 'app/main/clients/views/operation/operation-' + $stateParams.operationType + '.html';
                        },
                        //templateUrl: 'app/main/clients/views/operation/operation.html',
                        controller: 'OperationController'
                    }
                },
                bodyClass: 'clients'
            })
            .state('app.processes.bills', {
                url: '/bills',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/clients/views/bills/bills.html',
                        controller: 'MongoListsController'
                    }
                },
                bodyClass: 'bills'
            })
            .state('app.processes.xmlSatMetas', {
                url: '/xmlSatMetas',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/clients/views/xmlSatMetas/xmlSatMetas.html',
                        controller: 'MongoListsController'
                    }
                },
                bodyClass: 'xmlSatMetas'
            })
            .state('app.processes.reports', {
                url: '/reports',
                params: {
                    reports: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/clients/views/reports/reports.html',
                        controller: 'FBListsController'
                    }
                },
                bodyClass: 'clients'
            })
            .state('app.processes.closeOperations', {
                url: '/closeOperations',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/clients/views/closeOperations/closeOperations.html',
                        controller: 'FBListsController'
                    }
                },
                bodyClass: 'clients'
            })
            .state('app.processes.closeOperations.update', {
                url: '/update/:closeOperationId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/clients/views/closeOperations/closeOperation.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'clients'
            })
            .state('app.processes.closeOperations.read', {
                url: '/read/:closeOperationId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/clients/views/closeOperations/closeOperation.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'clients'
            })
            .state('app.organization.ccs', {
                url: '/ccs/:payrollId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/clients/views/ccs/ccs.html',
                        controller: 'FBListsController'
                    }
                },
                params: {
                    payrollId: 'all'
                },
                bodyClass: 'clients'
            })
            .state('app.organization.ccs.update', {
                url: '/update/:ccId',
                params: {
                    'cc': null,
                    'project_id': null,
                    'name': null,
                    'union_id': null,
                    'healthCare': null,
                    'rp_id': null,
                    'place': null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/clients/views/ccs/cc.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'clients'
            })
            .state('app.organization.ccs.read', {
                url: '/read/:ccId',
                params: {
                    cc: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/clients/views/ccs/cc.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'clients'
            })
            .state('app.organization.companiesRecords', {
                url: '/companiesRecords',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/clients/views/companies-records/companies-records.html',
                        controller: 'FBListsController'
                    }
                },
                bodyClass: 'clients'
            })
            .state('app.organization.companiesRecords.read', {
                url: '/read/:companiesRecordId',
                params: {
                    companiesRecord: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/clients/views/companies-records/companies-record.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'clients'
            })
            .state('app.organization.companiesRecords.update', {
                url: '/update/:companiesRecordId',
                params: {
                    companiesRecord: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/clients/views/companies-records/companies-record.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'clients'
            })
            .state('app.organization.payrolls', {
                url: '/payrolls/:firmId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/clients/views/payrolls/payrolls.html',
                        controller: 'FBListsController'
                    }
                },
                params: {
                    firmId: 'all'
                },
                bodyClass: 'clients'
            })
            .state('app.organization.payrolls.update', {
                url: '/update/:payrollId',
                params: {
                    payroll: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/clients/views/payrolls/payroll.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'clients'
            })
            .state('app.organization.payrolls.read', {
                url: '/read/:payrollId',
                params: {
                    payroll: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/clients/views/payrolls/payroll.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'clients'
            })
            .state('app.organization.positions', {
                url: '/positions/:payrollId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/clients/views/positions/positions.html',
                        controller: 'FBListsController'
                    }
                },
                params: {
                    payrollId: 'all'
                },
                bodyClass: 'clients'
            })
            .state('app.organization.positions.update', {
                url: '/update/:positionId',
                params: {
                    position: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/clients/views/positions/position.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'clients'
            })
            .state('app.organization.positions.read', {
                url: '/read/:positionId',
                params: {
                    position: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/clients/views/positions/position.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'clients'
            })
            .state('app.organization.departments', {
                url: '/departments/:payrollId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/clients/views/departments/departments.html',
                        controller: 'FBListsController'
                    }
                },
                params: {
                    payrollId: 'all'
                },
                bodyClass: 'clients'
            })
            .state('app.organization.departments.update', {
                url: '/update/:departmentId',
                params: {
                    department: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/clients/views/departments/department.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'clients'
            })
            .state('app.organization.departments.read', {
                url: '/read/:departmentId',
                params: {
                    department: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/clients/views/departments/department.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'clients'
            })
            .state('app.processes.incidencesRequests', {
                url: '/incidencesRequests/:payrollId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/clients/views/incidencesRequests/incidencesRequests.html',
                        controller: 'FBListsController'
                    }
                },
                bodyClass: 'clients'
            })
            .state('app.processes.incidencesRequests.update', {
                url: '/update/:incidencesRequestId',
                params: {
                    incidence: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/clients/views/incidencesRequests/incidencesRequest.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'clients'
            })
            .state('app.processes.incidencesRequests.read', {
                url: '/read/:incidencesRequestId',
                params: {
                    incidence: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/clients/views/incidencesRequests/incidencesRequest.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'clients'
            })
            .state('app.processes.folios', {
                url: '/folios',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/clients/views/folios/folios.html',
                        controller: 'FoliosController'
                    }
                },
                bodyClass: 'clients'
            })
            .state('app.processes.incidences', {
                url: '/incidences/:payrollId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/clients/views/incidences/incidences.html',
                        controller: 'MongoListsController'
                    }
                },
                bodyClass: 'clients'
            })
            .state('app.processes.incidences.update', {
                url: '/update/:payrollCalendarId/:incidenceId',
                params: {
                    incidence: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/clients/views/incidences/incidence.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'clients'
            })
            .state('app.processes.incidences.read', {
                url: '/read/:payrollCalendarId/:incidenceId',
                params: {
                    incidence: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/clients/views/incidences/incidence.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'clients'
            })
            .state('app.processes.confirmIncidences', {
                url: '/confirm-incidences',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/clients/views/incidences/confirm-incidences.html',
                        controller: 'FBListsController'
                    }
                },
                bodyClass: 'clients'
            })
            .state('app.processes.confirmIncidences.confirm', {
                url: '/confirm/:confirmIncidenceId',
                params: {
                    confirmIncidence: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/clients/views/incidences/incidence.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'clients'
            })
            .state('app.processes.confirmIncidences.read', {
                url: '/read/:confirmIncidenceId',
                params: {
                    confirmIncidence: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/clients/views/incidences/incidence.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'clients'
            })
            .state('app.organization.projects', {
                url: '/projects/:firmId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/clients/views/projects/projects.html',
                        controller: 'FBListsController'
                    }
                },
                params: {
                    firmId: 'all'
                },
                bodyClass: 'clients'
            })
            .state('app.organization.projects.update', {
                url: '/update/:projectId',
                params: {
                    project: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/clients/views/projects/project.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'clients'
            })
            .state('app.organization.projects.read', {
                url: '/read/:projectId',
                params: {
                    project: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/clients/views/projects/project.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'clients'
            })
            .state('app.organization.rps', {
                url: '/rps/:companiesRecordId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/clients/views/rps/rps.html',
                        controller: 'FBListsController'
                    }
                },
                params: {
                    companiesRecordId: 'all'
                },
                bodyClass: 'clients'
            })
            .state('app.organization.rps.update', {
                url: '/update/:rpId',
                params: {
                    rp: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/clients/views/rps/rp.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'clients'
            })
            .state('app.organization.rps.read', {
                url: '/read/:rpId',
                params: {
                    rp: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/clients/views/rps/rp.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'clients'
            })
            .state('app.processes.payrollCalendars', {
                url: '/payrollCalendars/:payrollId',
                // params: {
                //     // @todo:carlos checar estos params (son necesarios?)
                //     payrollCalendars: null,
                //     payrollSelected: null
                // },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/clients/views/payrollCalendars/payrollCalendars.html',
                        controller: 'FBListsController'
                    }
                },
                bodyClass: 'clients'
            })
            .state('app.processes.payrollCalendars.update', {
                url: '/update/:payrollCalendarId',
                params: {
                    payrollCalendar: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/clients/views/payrollCalendars/payrollCalendar.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'clients'
            })
            .state('app.processes.payrollCalendars.read', {
                url: '/read/:payrollCalendarId',
                params: {
                    payrollCalendar: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/clients/views/payrollCalendars/payrollCalendar.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'clients'
            })
            .state('app.processes.periods', {
                url: '/periods/:payrollId/:payrollCalendarId',
                params: {
                    //     // @todo checar estos params (son necesarios?)
                    //     payrollCalendars: null,
                    payroll: null,
                    payrollCalendar: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/clients/views/periods/periods.html',
                        controller: 'FBListsController'
                    }
                },
                bodyClass: 'clients'
            })
            .state('app.idse-panel', {
                abstract: true,
                url: '/idsePanel'
            })
            .state('app.idse-panel.batchRecords', {
                url: '/batchRecords',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/clients/views/batchRecords/batchRecords.html',
                        controller: 'MongoListsController'
                    }
                },
                bodyClass: 'batchRecords'
            })
            .state('app.idse-panel.rpIdseRecords', {
                url: '/rpIdseRecords',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/clients/views/rpIdseRecords/rpIdseRecords.html',
                        controller: 'MongoListsController'
                    }
                },
                bodyClass: 'rpIdseRecords'
            })
            .state('app.idse-panel.rpIdseRecords.edit', {
                url: '/:rpIdseRecordId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/clients/views/rpIdseRecords/rpIdseRecord.html',
                        controller: 'MongoDetailController'
                    }
                },
                bodyClass: 'rpIdseRecords'
            })
            .state('app.idse-panel.rpIdseRecords.read', {
                url: '/:rpIdseRecordId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/clients/views/rpIdseRecords/rpIdseRecord.html',
                        controller: 'MongoDetailController'
                    }
                },
                bodyClass: 'rpIdseRecords'
            })
            .state('app.apps-sync', {
                abstract: true,
                url: '/appsSync'
            })
            // syncEmployeeRecords
            .state('app.apps-sync.syncEmployeeRecords', {
                url: '/syncEmployeeRecords',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/clients/views/syncEmployeeRecords/syncEmployeeRecords.html',
                        controller: 'MongoListsController'
                    }
                },
                bodyClass: 'syncEmployeeRecords'
            })
            //humandCatalogs
            .state('app.apps-sync.humandCatalogs', {
                url: '/humandCatalogs',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/clients/views/humandCatalogs/humandCatalogs.html',
                        controller: 'MongoListsController'
                    }
                },
                bodyClass: 'humandCatalogs'
            })
            .state('app.apps-sync.humandCatalogs.edit', {
                url: '/:humandCatalogId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/clients/views/humandCatalogs/humandCatalog.html',
                        controller: 'MongoDetailController'
                    }
                },
                bodyClass: 'humandCatalogs'
            })
            .state('app.apps-sync.humandCatalogs.read', {
                url: '/:humandCatalogId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/clients/views/humandCatalogs/humandCatalog.html',
                        controller: 'MongoDetailController'
                    }
                },
                bodyClass: 'humandCatalogs'
            });
        $translatePartialLoaderProvider.addPart('app/main/clients');
    }
})();
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getDataForLayoutsSantanderV2', getDataForLayoutsSantanderV2);

    function getDataForLayoutsSantanderV2($filter, $log, AppF) {
        return function getDataForLayoutsSantanderV2Fn(params) {
            return new Promise(function (resolve, reject) {
                try {
                    var payroll = params.payroll ? params.payroll.fb : undefined;
                    var period = params.period ? params.period.fb : undefined;
                    var calendar = params.calendar;
                    var bankAccount = params.bankAccount;
                    var date = params.date;
                    var paymentForms = params.paymentForms;
                    var employees = params.employees;
                    var areAll = params.areAll;
                    var allEmployeesO = params.allEmployeesO;
                    var processId = params.tabSelected;
                    var operationType = params.operationType;
                    var calc = params.calc;
                    var validations = [
                        [date, 'Seleccione la fecha en la que realizara la dispersion'],
                        [bankAccount.chargeAccount, 'Se necesita el numero de cuenta de la cuenta configurada']
                    ];
                    for (var d = 0; d < validations.length; d++) {
                        var validation = validations[d];
                        if (angular.isUndefined(validation[0])) {
                            throw validation[1];
                        }
                    }
                    var thisCenter = AppF.center.toUpperCase();
                    var fileName = $filter('getDispFileName')('DISP_' + thisCenter, undefined, bankAccount, payroll, calendar, period);
                    var data = {
                        success: {
                            head: {
                                date: date,
                                account: bankAccount.chargeAccount
                            },
                            body: []
                        },
                        error: [],
                        filename: fileName
                    };
                    var defaultPaymentForm = paymentForms.find(function (value) {
                        return value.key === 'transfer';
                    });
                    for (var i = 0; i < employees.length; i++) {
                        try {
                            var employee = allEmployeesO[employees[i].$id];
                            var totals = $filter('discountDispersionExempts')(calc[employee.$id], processId);
                            var total = totals.totalNoExempts;
                            var card;
                            try {
                                card = $filter('getEmployeeAccount')(employee, processId, operationType, defaultPaymentForm._id);
                            } catch (error) {
                                var thisError;
                                if (areAll) {
                                    $log.debug(error);
                                } else {
                                    thisError = error;
                                }
                                throw thisError;
                            }
                            if (total > 0 && card.bank === bankAccount.bank) {
                                if ([9, 10, 11].indexOf(card.thisAccount.toString().length) === -1) {
                                    throw 'El empleado ' + employee.data.name + ' no tiene una cuenta valida';
                                }
                                var totalAmount = Math.round($filter('roundNumber')(total) * 100);
                                data.success.body.push({
                                    employeeId: employees[i].$id,
                                    total: totalAmount,
                                    account: card.thisAccount
                                });
                            }
                        } catch (error) {
                            if (angular.isDefined(error)) {
                                data.error.push(error);
                            }
                        }
                    }
                    resolve(data);
                } catch (error) {
                    reject(error);
                }
            });

        };
    }
}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getDataForLayoutsSantanderSpeiV2', getDataForLayoutsSantanderSpeiV2);

    function getDataForLayoutsSantanderSpeiV2($filter, $log, AppF) {
        return function getDataForLayoutsSantanderSpeiV2Fn(params) {
            return new Promise(function (resolve, reject) {
                try {
                    var payroll = params.payroll ? params.payroll.fb : undefined;
                    var period = params.period ? params.period.fb : undefined;
                    var calendar = params.calendar;
                    var bankAccount = params.bankAccount;
                    var date = params.date;
                    var paymentForms = params.paymentForms;
                    var employees = params.employees;
                    var areAll = params.areAll;
                    var allEmployeesO = params.allEmployeesO;
                    var processId = params.tabSelected;
                    var operationType = params.operationType;
                    var calc = params.calc;
                    var banks = params.banks;
                    var validations = [
                        [date, 'Seleccione la fecha en la que realizara la dispersion'],
                        [bankAccount.chargeAccount, 'Se necesita el numero de cuenta de la cuenta configurada']
                    ];
                    for (var d = 0; d < validations.length; d++) {
                        var validation = validations[d];
                        if (angular.isUndefined(validation[0])) {
                            throw validation[1];
                        }
                    }
                    var thisCenter = AppF.center.toUpperCase();
                    var fileName = $filter('getDispFileName')('DISP_' + thisCenter, undefined, bankAccount, payroll, calendar, period);
                    var data = {
                        success: {
                            head: {
                                date: date,
                                account: bankAccount.chargeAccount
                            },
                            body: []
                        },
                        error: [],
                        filename: fileName
                    };
                    var defaultPaymentForm = paymentForms.find(function (value) {
                        return value.key === 'transfer';
                    });
                    for (var i = 0; i < employees.length; i++) {
                        try {
                            var employee = allEmployeesO[employees[i].$id];
                            var totals = $filter('discountDispersionExempts')(calc[employee.$id], processId);
                            var total = totals.totalNoExempts;
                            var card;
                            try {
                                card = $filter('getEmployeeAccount')(employee, processId, operationType, defaultPaymentForm._id);
                            } catch (error) {
                                var thisError;
                                if (areAll) {
                                    $log.debug(error);
                                } else {
                                    thisError = error;
                                }
                                throw thisError;
                            }
                            if (total > 0 && card.thisAccount.toString().length === 18) {
                                var employeeBank = card.bank;
                                if (angular.isUndefined(employeeBank) || employeeBank === '') {
                                    throw 'El empleado ' + employee.data.name + ' no tiene un banco seleccionado';
                                }
                                var thisBank = banks.find(function (item) {
                                    return item._id === employeeBank;
                                });
                                if (angular.isUndefined(thisBank) || angular.isUndefined(thisBank.extraFields) || angular.isUndefined(thisBank.extraFields.santander)) {
                                    throw 'El banco del empleado ' + employee.data.name + ' no tienen el código para el layout';
                                }
                                var totalAmount = Math.round($filter('roundNumber')(total) * 100);
                                data.success.body.push({
                                    employeeId: employees[i].$id,
                                    total: totalAmount,
                                    account: card.thisAccount,
                                    bankCode: thisBank.extraFields.santander
                                });
                            }
                        } catch (error) {
                            if (angular.isDefined(error)) {
                                data.error.push(error);
                            }
                        }
                    }
                    resolve(data);
                } catch (error) {
                    reject(error);
                }
            });

        };
    }
}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getDataForLayoutsSantanderSpei', getDataForLayoutsSantanderSpei);

    function getDataForLayoutsSantanderSpei($log, $filter, AppF) {

        return getDataForLayoutsSantanderSpeiFn;
        function getDataForLayoutsSantanderSpeiFn(params) {
            return new Promise(function (resolve, reject) {
                try {
                    var employees = params.employees;
                    var allEmployeesO = params.allEmployeesO;
                    var processId = params.tabSelected;
                    var calc = params.calc;
                    var paymentForms = params.paymentForms;
                    var payroll = params.payroll ? params.payroll.fb : undefined;
                    var period = params.period ? params.period.fb : undefined;
                    var calendar = params.calendar;
                    var operationType = params.operationType;
                    var date = params.date;
                    var bankAccount = params.bankAccount;
                    var banks = params.banks;
                    resolve(getDataForLayouts(employees, allEmployeesO, bankAccount, banks, calc, paymentForms, processId, payroll, period, calendar, operationType, date, params.areAll));
                } catch (error) {
                    reject(error);
                }
            });
        }
        function getDataForLayouts(employees, allEmployeesO, bankAccount, banks, calc, paymentForms, processId, payroll, period, calendar, operationType, date, areAll) {
            var thisCenter = AppF.center.toUpperCase();
            var fileName = $filter('getDispFileName')('DISP_' + thisCenter, 'SPEI', bankAccount, payroll, calendar, period);
            var data = {
                success: {
                    body: []
                },
                error: [],
                filename: fileName
            };
            var granTotal = 0;
            var character = 'á, é, í, ó, ú, Á, É, Í, Ó, Ú, ü, ö, Á, É, Í, Ó, Ú, Ñ';
            var defaultPaymentForm = paymentForms.find(function (value) {
                return value.key === 'transfer';
            });
            for (var i = 0; i < employees.length; i++) {
                try {
                    var employee = allEmployeesO[employees[i].$id];
                    var totals = $filter('discountDispersionExempts')(calc[employee.$id], processId);
                    var total = totals.totalNoExempts;
                    var card;
                    try {
                        card = $filter('getEmployeeAccount')(employee, processId, operationType, defaultPaymentForm._id);
                    } catch (error) {
                        var thisError;
                        if (areAll) {
                            $log.debug(error);
                        } else {
                            thisError = error;
                        }
                        throw thisError;
                    }
                    if (total > 0 && card.thisAccount.toString().length === 18) {
                        var employeeBank = card.bank;
                        if (angular.isUndefined(employeeBank) || employeeBank === '') {
                            throw 'El empleado ' + employee.data.name + ' no tiene un banco seleccionado';
                        }
                        var thisBank = banks.find(function (item) {
                            return item._id === employeeBank;
                        });
                        if (angular.isUndefined(thisBank) || angular.isUndefined(thisBank.extraFields) || angular.isUndefined(thisBank.extraFields.santander)) {
                            throw 'El banco del empleado ' + employee.data.name + ' no tienen el código para el layout';
                        }
                        var totalNumber = $filter('roundNumber')(total);
                        var totalAmount = Math.round(totalNumber * 100);
                        granTotal += totalAmount;
                        data.success.body.push([$filter('cleanString')(employee.data.name, character), totalAmount, card.thisAccount, thisBank.extraFields.santander]);
                    }
                } catch (error) {
                    if (angular.isDefined(error)) {
                        data.error.push(error);
                    }
                }
            }
            granTotal = Math.round(granTotal * 100) / 100;
            data.success.head = [bankAccount.chargeAccount, moment(date).format('DDMMYY')];
            return data;
        }
    }
}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getDataForLayoutsSantander', getDataForLayoutsSantander);

    function getDataForLayoutsSantander($filter) {

        return getDataForLayoutsSantanderFn;

        function getDataForLayoutsSantanderFn(params) {
            return new Promise(function (resolve, reject) {
                try {
                    var payrollId = params.payrollId;
                    var bankAccounts = params.banksAccounts;
                    var banks = params.banks;
                    var employees = params.employeesSelected;
                    var allEmployeesO = params.allEmployeesO;
                    var bank = params.bank;
                    var tabSelected = params.tabSelected;
                    var calc = params.calc;
                    var paymentForms = params.paymentForms;
                    var payroll = params.payroll.fb;
                    var period = params.period.fb;
                    var calendar = params.calendar;
                    var process = params.processes.find(function (process) {
                        return process.id === tabSelected;
                    });
                    if (!process) {
                        throw 'No se encontró el nombre del proceso';
                    }
                    var type = process.name;
                    $filter('getDataBankAccount')(payrollId, bankAccounts, type, bank._id).then(function (resp) {
                        if (angular.isDefined(resp.message)) {
                            var params = {
                                error: []
                            }
                            params.error.push(resp.message);
                            resolve(params);
                        } else {
                            if (angular.isUndefined(resp.banxicoPlace)) {
                                throw 'No se encontró la plaza banxico';
                            } else if (angular.isUndefined(resp.branchOffice)) {
                                throw 'No se encontró la banco receptor';
                            } else if (angular.isUndefined(resp.chargeAccount)) {
                                throw 'No se encontró la cuenta de cargo';
                            } else {
                                resolve(getDataForLayouts(employees, allEmployeesO, bank._id, banks, resp, calc, paymentForms, tabSelected, payroll, period, calendar, bankAccounts, process));
                            }
                        }
                    }).catch(function (error) {
                        reject(error);
                    })
                } catch (error) {
                    reject(error);
                }
            })
        }
        function getDataForLayouts(employees, allEmployeesO, bankId, banks, bankAccount, calc, paymentForms, tabSelected, payroll, period, calendar, bankAccounts, process) {
            var payrollBanksAccounts = $filter('getFromObject')(payroll, 'processes.' + process.name + '.bankAccounts', []);
            var thisBankAccount = bankAccounts.find(function (item) {
                if (payrollBanksAccounts.indexOf(item._id) > -1) {
                    return item.bank === bankId;
                } else {
                    return false;
                }
            });
            var data = {
                success: [],
                error: [],
                filename: "DISP_" + thisBankAccount.name + "_" + calendar + "_" + payroll.data.class + "_" + payroll.data.name + "_" + (('' + period.period).length > 9 ? period.period : '0' + period.period)
            };
            for (var i = 0; i < employees.length; i++) {
                var employee = allEmployeesO[employees[i].$id];
                var totals = $filter('discountDispersionExempts')(calc[employee.$id], tabSelected);
                var total = totals.totalNoExempts;
                if (total > 0) {
                    try {
                        if (angular.isUndefined(employee.data.cards) || !angular.isArray(employee.data.cards)) {
                            throw 'El empleado ' + employee.data.name + ' no tiene asignado una cuenta de banco';
                        }
                        var bankEmployee = banks.find(function (value) {
                            return value._id === employee.data.cards[0].bank;
                        });
                        if (bankEmployee && bankEmployee._id === bankId) {

                            var account = (employee.data.cards.length > 0 && angular.isDefined(employee.data.cards[0].number)) ? employee.data.cards[0].number : false;
                            if (!account) {
                                throw 'El empleado ' + employee.data.name + ' no tiene cuenta para SPEI';
                            }
                            if (account.toString().length !== 18) {
                                throw 'El empleado ' + employee.data.name + ' no tiene una cuenta valida';
                            }
                            if (!bankEmployee.santanderCode) {
                                throw 'El empleado ' + employee.data.name + ' no cuenta con la configuración de su banco asignado [' + bankEmployee.name + ']';
                            }
                            var defaultPaymentForm = paymentForms.find(function (value) {
                                return value.key === 'transfer';
                            });
                            var totalNumber = $filter('roundNumber')(total);
                            var employeePaymentForm = $filter('getEmployeePaymentForm')(employee.paymentForms, process.id)
                            if (angular.isUndefined(employeePaymentForm) || employeePaymentForm === defaultPaymentForm._id) {
                                data.success.push({
                                    chargeAccount: bankAccount.chargeAccount,
                                    account: account,
                                    bankReceiving: bankEmployee.santanderCode,
                                    employee: employee.data.name,
                                    branchOffice: bankAccount.branchOffice,
                                    totalAmount: Math.round(totalNumber * 100) + '',
                                    place: bankAccount['banxicoPlace']
                                });
                            }
                        } else {
                            throw 'La cuenta seleccionada del empleado ' + employee.data.name + ' no aplica para SPEI';
                        }
                    } catch (error) {
                        data.error.push(error);
                    }
                }
            }
            return data;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getDataForLayoutsSantander', getDataForLayoutsSantander);

    function getDataForLayoutsSantander($filter, $log, AppF) {

        return getDataForLayoutsSantanderFn;

        function getDataForLayoutsSantanderFn(params) {
            return new Promise(function (resolve, reject) {
                try {
                    resolve(getDataForLayouts(params));
                } catch (error) {
                    reject(error);
                }
            });
        }
        function getDataForLayouts(params) {
            var employees = params.employees;
            var allEmployeesO = params.allEmployeesO;
            var processId = params.tabSelected;
            var calc = params.calc;
            var paymentForms = params.paymentForms;
            var payroll = params.payroll ? params.payroll.fb : undefined;
            var period = params.period ? params.period.fb : undefined;
            var calendar = params.calendar;
            var bankAccount = params.bankAccount;
            var operationType = params.operationType;
            var date = moment(params.date);
            var month = (date.utc().month() + 1);
            var days = date.utc().date();
            var thisCenter = AppF.center.toUpperCase();
            var fileName = $filter('getDispFileName')('DISP_' + thisCenter, undefined, bankAccount, payroll, calendar, period);
            var data = {
                success: {
                    head: {
                        chargeAccount: bankAccount.chargeAccount,
                        date: (month > 9 ? month : '0' + month) + '' + (days > 9 ? '' : '0') + days + '' + date.utc().year()
                    },
                    body: []
                },
                error: [],
                filename: fileName
            };
            var totalAmount = 0;
            var defaultPaymentForm = paymentForms.find(function (value) {
                return value.key === 'transfer';
            });
            for (var i = 0; i < employees.length; i++) {
                try {
                    var employee = allEmployeesO[employees[i].$id];
                    var totals = $filter('discountDispersionExempts')(calc[employee.$id], processId);
                    var total = totals.totalNoExempts;
                    var card;
                    try {
                        card = $filter('getEmployeeAccount')(employee, processId, operationType, defaultPaymentForm._id);
                    } catch (error) {
                        var thisError;
                        if (params.areAll) {
                            $log.debug(error);
                        } else {
                            thisError = error;
                        }
                        throw thisError;
                    }
                    if (total > 0 && card.bank === bankAccount.bank) {
                        if ([9, 10, 11].indexOf(card.thisAccount.toString().length) === -1) {
                            throw 'El empleado ' + employee.data.name + ' no tiene una cuenta valida';
                        }
                        var totalNumber = $filter('roundNumber')(total);
                        var character = 'á, é, í, ó, ú, Á, É, Í, Ó, Ú, ü, ö, Á, É, Í, Ó, Ú, Ñ';
                        var number = (data.success.body.length === 0) ? data.success.body.length + 2 : data.success.body.length + 1;
                        data.success.body.push({
                            type: '2',
                            number: number,
                            employeeNumber: employee.data.employeeNumber.toString(),
                            name: employee.data.info.names,
                            paternalSurname: $filter('cleanString')($filter('getFromObject')(employee.data, 'info.paternalSurname', ''), character),
                            maternalSurname: $filter('cleanString')($filter('getFromObject')(employee.data, 'info.maternalSurname', ''), character),
                            employee: $filter('cleanString')($filter('getFromObject')(employee.data, 'info.names', ''), character),
                            account: card.thisAccount + '',
                            totalAmount: Math.round(totalNumber * 100) + '',
                            concept: (processId === 'fiscal') ? '01' : '08'
                        });
                        totalAmount = totalAmount + totalNumber;

                    }
                } catch (error) {
                    if (angular.isDefined(error)) {
                        data.error.push(error);
                    }
                }
            }
            data.success.footer = {
                totalAmount: Math.round(totalAmount * 100) + ''
            };
            return data;
        }
    }
}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getDataForLayoutsKuspitSpei', getDataForLayoutsKuspitSpei);

    function getDataForLayoutsKuspitSpei($log, $filter, AppF) {

        return getDataForLayoutsKuspitSpeiFn;
        function getDataForLayoutsKuspitSpeiFn(params) {
            return new Promise(function (resolve, reject) {
                try {
                    var employees = params.employees;
                    var allEmployeesO = params.allEmployeesO;
                    var processId = params.tabSelected;
                    var calc = params.calc;
                    var paymentForms = params.paymentForms;
                    var payroll = params.payroll ? params.payroll.fb : undefined;
                    var period = params.period ? params.period.fb : undefined;
                    var calendar = params.calendar;
                    var operationType = params.operationType;
                    var bankAccount = params.bankAccount;
                    var date = params.date;
                    var banks = params.banks;
                    resolve(getDataForLayouts(employees, allEmployeesO, banks, calc, paymentForms, processId, payroll, period, calendar, operationType, date, bankAccount, params.areAll));
                } catch (error) {
                    reject(error);
                }
            });
        }
        function getDataForLayouts(employees, allEmployeesO, banks, calc, paymentForms, processId, payroll, period, calendar, operationType, date, bankAccount, areAll) {
            var thisCenter = AppF.center.toUpperCase();

            var fileName = $filter('getDispFileName')('DISP_' + thisCenter, 'SPEI', bankAccount, payroll, calendar, period);
            var data = {
                success: {
                    body: []
                },
                error: [],
                filename: fileName
            };
            var granTotal = 0;
            var character = 'á, é, í, ó, ú, Á, É, Í, Ó, Ú, ü, ö, Á, É, Í, Ó, Ú, Ñ';
            var defaultPaymentForm = paymentForms.find(function (value) {
                return value.key === 'transfer';
            });
            for (var i = 0; i < employees.length; i++) {
                try {
                    var employee = allEmployeesO[employees[i].$id];
                    var totals = $filter('discountDispersionExempts')(calc[employee.$id], processId);
                    var total = totals.totalNoExempts;
                    var card;
                    try {
                        card = $filter('getEmployeeAccount')(employee, processId, operationType, defaultPaymentForm._id);
                    } catch (error) {
                        var thisError;
                        if (areAll) {
                            $log.debug(error);
                        } else {
                            thisError = error;
                        }
                        throw thisError;
                    }
                    if (total > 0 && card.thisAccount.toString().length === 18) {
                        var employeeBank = card.bank;
                        if (angular.isUndefined(employeeBank) || employeeBank === '') {
                            throw 'El empleado ' + employee.data.name + ' no tiene un banco seleccionado';
                        }
                        var thisBank = banks.find(function (item) {
                            return item._id === employeeBank;
                        });
                        if (angular.isUndefined(thisBank) || angular.isUndefined(thisBank.extraFields) || angular.isUndefined(thisBank.extraFields.kuspit)) {
                            throw 'El banco del empleado ' + employee.data.name + ' no tienen el código para el layout';
                        }
                        var totalNumber = $filter('roundNumber')(total);
                        var totalAmount = Math.round(totalNumber * 100) / 100;
                        granTotal += totalAmount;
                        data.success.body.push([$filter('cleanString')(employee.data.name, character), totalAmount, card.thisAccount, thisBank.extraFields.kuspit]);
                    }
                } catch (error) {
                    if (angular.isDefined(error)) {
                        data.error.push(error);
                    }
                }
            }
            granTotal = Math.round(granTotal * 100) / 100;
            data.success.head = [moment(date).format('DD/MM/YYYY'), granTotal];
            return data;
        }
    }
}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getDataForLayoutsHsbcTxt', getDataForLayoutsHsbcTxt);

    function getDataForLayoutsHsbcTxt($filter, $log, AppF) {

        return getDataForLayoutsHsbcTxtFn;
        function getDataForLayoutsHsbcTxtFn(params) {
            return new Promise(function (resolve, reject) {
                try {
                    var employees = params.employees;
                    var allEmployeesO = params.allEmployeesO;
                    var processId = params.tabSelected;
                    var calc = params.calc;
                    var paymentForms = params.paymentForms;
                    var payroll = params.payroll ? params.payroll.fb : undefined;
                    var period = params.period ? params.period.fb : undefined;
                    var calendar = params.calendar;
                    var operationType = params.operationType;
                    var date = params.date;
                    var bankAccount = params.bankAccount;
                    resolve(getDataForLayouts(employees, allEmployeesO, calc, paymentForms, processId, payroll, period, calendar, operationType, date, bankAccount, params.areAll));
                } catch (error) {
                    reject(error);
                }
            });
        }
        function getDataForLayouts(employees, allEmployeesO, calc, paymentForms, processId, payroll, period, calendar, operationType, date, bankAccount, areAll) {
            if (angular.isUndefined(bankAccount) || !bankAccount.hasOwnProperty('accountCharge')) {
                throw 'No existe la cuenta o no se tiene la cuenta a cargo';
            }
            var thisCenter = AppF.center.toUpperCase();

            var fileName = $filter('getDispFileName')('DISP_' + thisCenter, undefined, bankAccount, payroll, calendar, period);
            var endDate = moment(date);
            var conceptNameH = 'NOM ' + (payroll ? payroll.data.class + ' ' : '') + endDate.format('DD') + ' ' + $filter('uppercase')(endDate.format('MMM'));
            var conceptNameR = 'NOM ' + endDate.format('DD') + ' ' + $filter('uppercase')(endDate.format('MMM'));
            conceptNameR = conceptNameR.replace('.', '');
            conceptNameH = conceptNameH.replace('.', '');

            var data = {
                success: {
                    body: []
                },
                error: [],
                filename: fileName
            };
            var count = 0;
            var granTotal = 0;
            var defaultPaymentForm = paymentForms.find(function (value) {
                return value.key === 'transfer';
            });
            for (var i = 0; i < employees.length; i++) {
                try {
                    var employee = allEmployeesO[employees[i].$id];
                    var totals = $filter('discountDispersionExempts')(calc[employee.$id], processId);
                    var total = totals.totalNoExempts;
                    var card;
                    try {
                        card = $filter('getEmployeeAccount')(employee, processId, operationType, defaultPaymentForm._id);
                    } catch (error) {
                        var thisError;
                        if (areAll) {
                            $log.debug(error);
                        } else {
                            thisError = error;
                        }
                        throw thisError;
                    }
                    if (total > 0 && card.bank === bankAccount.bank) {
                        if (!$filter('getFromObject')(employee.data, 'employeeNumber')) {
                            throw 'El empleado ' + employee.data.name + ' no tiene asignado el numero de empleado';
                        }
                        if (card.thisAccount.toString().length !== 10) {
                            throw 'El empleado ' + employee.data.name + ' no tiene los dígitos de la cuenta valida';
                        }
                        var totalNumber = $filter('roundNumber')(total);
                        var character = 'á, é, í, ó, ú, Á, É, Í, Ó, Ú, ü, ö, Á, É, Í, Ó, Ú, Ñ';
                        var arrayNames = employee.data.info.names.split(' ');
                        var name = arrayNames[0];
                        name += (employee.data.info.paternalSurname ? ' ' + employee.data.info.paternalSurname : (employee.data.info.maternalSurname ? ' ' + employee.data.info.maternalSurname : ''));
                        if (name.length > 26) {
                            var thisName = name.split('');
                            thisName.length = 26;
                            name = thisName.join('');
                        }
                        count++;
                        var totalAmount = Math.round(totalNumber * 100);
                        granTotal += totalAmount;
                        data.success.body.push({
                            account: card.thisAccount + '',
                            total: totalAmount,
                            name: $filter('cleanString')(name, character),
                            ref: conceptNameR
                        });
                    }
                } catch (error) {
                    if (angular.isDefined(error)) {
                        data.error.push(error);
                    }
                }
            }
            data.success.head = {
                accountCharge: bankAccount.accountCharge,
                granTotal: granTotal,
                count: count,
                date: moment(date).format('DDMMYYYY'),
                concept: conceptNameH
            };
            return data;
        }
    }
}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getDataForLayoutsHsbcSpei', getDataForLayoutsHsbcSpei);

    function getDataForLayoutsHsbcSpei(AppF, $filter, $log) {
        return function getDataForLayoutsHsbcSpeiFn(params) {
            return new Promise(function (resolve, reject) {
                try {
                    var payroll = params.payroll ? params.payroll.fb : undefined;
                    var period = params.period ? params.period.fb : undefined;
                    var calendar = params.calendar;
                    var bankAccount = params.bankAccount;
                    var date = params.date;
                    var paymentForms = params.paymentForms;
                    var employees = params.employees;
                    var allEmployeesO = params.allEmployeesO;
                    var processId = params.tabSelected;
                    var operationType = params.operationType;
                    var calc = params.calc;
                    var validations = [
                        [date, 'Seleccione la fecha en la que realizara la dispersion'],
                        [bankAccount.accountCharge, 'Se necesita el numero de cuenta de la cuenta configurada']
                    ];
                    for (var d = 0; d < validations.length; d++) {
                        var validation = validations[d];
                        if (angular.isUndefined(validation[0])) {
                            throw validation[1];
                        }
                    }
                    var query = AppF.root.child('catalogs/companiesRecords/collection/' + bankAccount.companiesRecord + '/data/rfc').once('value');
                    query.then(function (snap) {
                        if (!snap.exists()) {
                            throw 'Esta empresa no tiene la razón social';
                        }
                        var thisCenter = AppF.center.toUpperCase();
                        var fileName = $filter('getDispFileName')('DISP_' + thisCenter, 'SPEI', bankAccount, payroll, calendar, period);
                        var data = {
                            success: {
                                head: {
                                    rfc: snap.val(),
                                    date: date,
                                    account: bankAccount.accountCharge,
                                    lote: 'PAGOP' + period.period,
                                    ref: 'PAGONOMINA' + period.period
                                },
                                body: []
                            },
                            error: [],
                            filename: fileName
                        };
                        var defaultPaymentForm = paymentForms.find(function (value) {
                            return value.key === 'transfer';
                        });
                        for (var i = 0; i < employees.length; i++) {
                            try {
                                var employee = allEmployeesO[employees[i].$id];
                                var totals = $filter('discountDispersionExempts')(calc[employee.$id], processId);
                                var total = totals.totalNoExempts;
                                var card;
                                try {
                                    card = $filter('getEmployeeAccount')(employee, processId, operationType, defaultPaymentForm._id);
                                } catch (error) {
                                    var thisError;
                                    if (params.areAll) {
                                        $log.debug(error);
                                    } else {
                                        thisError = error;
                                    }
                                    throw thisError;
                                }
                                if (total > 0 && card.thisAccount.toString().length === 18) {
                                    var totalNumber = $filter('roundNumber')(total);
                                    data.success.body.push({
                                        employeeId: employees[i].$id,
                                        account: card.thisAccount + '',
                                        amount: totalNumber.toFixed(2)
                                    });
                                }
                            } catch (error) {
                                if (angular.isDefined(error)) {
                                    data.error.push(error);
                                }
                            }
                        }
                        resolve(data);
                    }).catch(reject);
                } catch (error) {
                    reject(error);
                }
            });

        };
    }
}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getDataForLayoutsHsbc', getDataForLayoutsHsbc);

    function getDataForLayoutsHsbc($filter, $log, AppF) {

        return getDataForLayoutsHsbcFn;
        function getDataForLayoutsHsbcFn(params) {
            return new Promise(function (resolve, reject) {
                try {
                    var employees = params.employees;
                    var allEmployeesO = params.allEmployeesO;
                    var processId = params.tabSelected;
                    var calc = params.calc;
                    var paymentForms = params.paymentForms;
                    var payroll = params.payroll ? params.payroll.fb : undefined;
                    var period = params.period ? params.period.fb : undefined;
                    var calendar = params.calendar;
                    var operationType = params.operationType;
                    var date = params.date;
                    var bankAccount = params.bankAccount;
                    resolve(getDataForLayouts(employees, allEmployeesO, calc, paymentForms, processId, payroll, period, calendar, operationType, date, bankAccount, params.areAll));
                } catch (error) {
                    reject(error);
                }
            });
        }
        function getDataForLayouts(employees, allEmployeesO, calc, paymentForms, processId, payroll, period, calendar, operationType, date, bankAccount, areAll) {
            if (angular.isUndefined(bankAccount) || !bankAccount.hasOwnProperty('accountCharge')) {
                throw 'No existe la cuenta o no se tiene la cuenta a cargo';
            }
            var thisCenter = AppF.center.toUpperCase();
            var fileName = $filter('getDispFileName')('DISP_' + thisCenter, undefined, bankAccount, payroll, calendar, period);
            var endDate = moment(date);
            var conceptNameH = 'NOM ' + endDate.format('DD') + ' ' + $filter('uppercase')(endDate.format('MMM'));
            var conceptNameR = 'NOM ' + endDate.format('DD') + ' ' + $filter('uppercase')(endDate.format('MMM'));
            conceptNameR = conceptNameR.replace('.', '');
            conceptNameH = conceptNameH.replace('.', '');
            var data = {
                success: {
                    body: []
                },
                error: [],
                filename: fileName
            };
            var count = 0;
            var granTotal = 0;
            var defaultPaymentForm = paymentForms.find(function (value) {
                return value.key === 'transfer';
            });
            for (var i = 0; i < employees.length; i++) {
                try {
                    var employee = allEmployeesO[employees[i].$id];
                    var totals = $filter('discountDispersionExempts')(calc[employee.$id], processId);
                    var total = totals.totalNoExempts;
                    var card;
                    try {
                        card = $filter('getEmployeeAccount')(employee, processId, operationType, defaultPaymentForm._id);
                    } catch (error) {
                        var thisError;
                        if (areAll) {
                            $log.debug(error);
                        } else {
                            thisError = error;
                        }
                        throw thisError;
                    }
                    if (total > 0 && card.bank === bankAccount.bank) {
                        if (!$filter('getFromObject')(employee.data, 'employeeNumber')) {
                            throw 'El empleado ' + employee.data.name + ' no tiene asignado el numero de empleado';
                        }
                        if (card.thisAccount.toString().length !== 10) {
                            throw 'El empleado ' + employee.data.name + ' no tiene los dígitos de la cuenta valida';
                        }
                        var totalNumber = $filter('roundNumber')(total);
                        var character = 'á, é, í, ó, ú, Á, É, Í, Ó, Ú, ü, ö, Á, É, Í, Ó, Ú, Ñ';
                        var arrayNames = employee.data.info.names.split(' ');
                        var name = arrayNames[0];
                        name += (employee.data.info.paternalSurname ? ' ' + employee.data.info.paternalSurname : (employee.data.info.maternalSurname ? ' ' + employee.data.info.maternalSurname : ''));
                        if (name.length > 26) {
                            var thisName = name.split('');
                            thisName.length = 26;
                            name = thisName.join('');
                        }
                        count++;
                        var totalAmount = Math.round(totalNumber * 100) / 100;
                        granTotal += totalAmount;
                        data.success.body.push({
                            account: card.thisAccount + '',
                            total: totalAmount.toFixed(2),
                            name: $filter('cleanString')(name, character),
                            ref: conceptNameR
                        });
                    }
                } catch (error) {
                    if (angular.isDefined(error)) {
                        data.error.push(error);
                    }
                }
            }
            granTotal = Math.round(granTotal * 100) / 100;
            data.success.head = ['MXPRLF', 'F', bankAccount.accountCharge, granTotal.toFixed(2), count, moment(date).format('DDMMYYYY'), '', conceptNameH];
            return data;
        }
    }
}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getDataForLayoutsBanorteSpei', getDataForLayoutsBanorteSpei);

    function getDataForLayoutsBanorteSpei(AppF, DataF, $log, $filter, $timeout) {

        return getDataForLayoutsBanorteSpeiFn;

        function getDataForLayoutsBanorteSpeiFn(params) {
            return new Promise(function (resolve, reject) {
                var data = {};
                try {
                    var employees = params.employees;
                    var allEmployeesO = params.allEmployeesO;
                    var processId = params.tabSelected;
                    var calc = params.calc;
                    var paymentForms = params.paymentForms;
                    var payroll = params.payroll ? params.payroll.fb : undefined;
                    var period = params.period ? params.period.fb : undefined;
                    var operationType = params.operationType;
                    console.log(operationType, 'operationType');
                    var bankAccount = params.bankAccount;
                    var processName = params.processName;
                    var date = params.date;
                    var calendar = params.calendar;
                    var payrollId = params.payrollId;
                    if (processId === 'fiscal' && operationType === 'asimilated') {
                        processName = 'ASIMILADOS';
                    } else if (processId === 'fiscal' && operationType === 'ptuRecord') {
                        processName = 'PTU';
                    }
                    var validations = [
                        [date, 'Seleccione la fecha en la que realizara la dispersion'],
                        [bankAccount.issuer, 'Se necesita la emisora de la cuenta configurada'],
                        [bankAccount.accountCharge, 'Se necesita el numero de cuenta de la cuenta configurada']
                    ];
                    for (var d = 0; d < validations.length; d++) {
                        var validation = validations[d];
                        if (angular.isUndefined(validation[0])) {
                            throw validation[1];
                        }
                    }
                    data = getDataForLayouts(employees, allEmployeesO, calc, paymentForms, processId, payroll, period, calendar, operationType, bankAccount, params.banks, params.areAll);
                    if (data.success.body.length === 0) {
                        throw 'No hay ningún empleado con la cuenta de ' + bankAccount.bankData.name;
                    }
                    data.success.header = {
                        issuer: bankAccount.issuer,
                        date: date,
                        account: bankAccount.accountCharge
                    };
                    var generate = {
                        bankAccountId: bankAccount._id,
                        type: processName,
                        payrollId: payrollId ? payrollId : 'any',
                        payrollName: payroll ? payroll.data.name : 'many'
                    };
                    generateNumber(generate).then(function (resp) {
                        if (angular.isUndefined(resp.folio)) {
                            throw 'Error al generar el folio';
                        }
                        data.success.header.number = resp.folio;
                        resolve(data);
                    }).catch(function (error) {
                        if (!angular.isArray(data.error)) {
                            data.error = [];
                        }
                        data.error.push(error);
                        reject(data.error);
                    });
                } catch (error) {
                    if (!angular.isArray(data.error)) {
                        data.error = [];
                    }
                    data.error.push(error);
                    reject(data.error);
                }
            });
        }
        function getDataForLayouts(employees, allEmployeesO, calc, paymentForms, tabSelected, payroll, period, calendar, operationType, bankAccount, banks, areAll) {
            var thisCenter = AppF.center.toUpperCase();
            var data = {
                success: { body: [] },
                error: [],
                filename: $filter('getDispFileName')('DISP_' + thisCenter, 'SPEI', bankAccount, payroll, calendar, period)
            };
            var defaultPaymentForm = paymentForms.find(function (value) {
                return value.key === 'transfer';
            });
            for (var i = 0; i < employees.length; i++) {
                try {
                    var employee = allEmployeesO[employees[i].$id];
                    var totals = $filter('discountDispersionExempts')(calc[employee.$id], tabSelected);
                    var total = totals.totalNoExempts;
                    var card;
                    try {
                        card = $filter('getEmployeeAccount')(employee, tabSelected, operationType, defaultPaymentForm._id);
                    } catch (error) {
                        var thisError;
                        if (areAll) {
                            $log.debug(error);
                        } else {
                            thisError = error;
                        }
                        throw thisError;
                    }
                    if (total > 0 && card.thisAccount.toString().length === 18) {
                        if (!$filter('getFromObject')(employee, 'data.employeeNumber', false)) {
                            throw 'El empleado ' + employee.data.name + ' no tiene asignado un numero de empleado';
                        }
                        var employeeBank = card.bank;
                        if (angular.isUndefined(employeeBank) || employeeBank === '') {
                            throw 'El empleado ' + employee.data.name + ' no tiene un banco seleccionado';
                        }
                        var thisBank = banks.find(function (item) {
                            return item._id === employeeBank;
                        });
                        if (angular.isUndefined(thisBank) || angular.isUndefined(thisBank.extraFields) || angular.isUndefined(thisBank.extraFields.banorte)) {
                            throw 'El banco del empleado ' + employee.data.name + ' con el banco ' + thisBank.name + ' no tienen el código para el layout';
                        }
                        var roundTotal = Math.round($filter('roundNumber')(total) * 100);
                        if (('' + roundTotal).length > 15) {
                            throw 'El empleado ' + employee.data.name + ' excede los 13 dígitos de los números enteros de totales';
                        }
                        var obj = {
                            employeeId: employees[i].$id,
                            account: card.thisAccount,
                            total: roundTotal,
                            bankCode: thisBank.extraFields.banorte
                        };
                        data.success.body.push(obj);
                    }
                } catch (error) {
                    if (angular.isDefined(error)) {
                        data.error.push(error);
                    }
                }
            }
            return data;
        }
        function generateNumber(data) {
            return new Promise(function (resolve, reject) {
                var idFolio = AppF.root.child('catalogs/folios/collection').push().key;
                var taskObj = {
                    'type': 'getIssuersNextFolio',
                    'payroll': data.payrollId,
                    'payrollName': data.payrollName,
                    'recordId': idFolio,
                    'profileObj': DataF.getTimeObject(),
                    'issuers': {}
                };
                taskObj.issuers[data.bankAccountId] = data.type;
                AppF.root.child('queue1/tasks').push(taskObj).then(function () {
                    $log.log('se crea tarea para folio satisfactoriamente');
                    var error;
                    var ref = AppF.root.child('catalogs/folios/collection/' + idFolio);
                    var execute = false;
                    ref.on('value', function (snap) {
                        if (!error) {
                            var value = snap.val();
                            if (value !== null) {
                                execute = true;
                                ref.off();
                                resolve(value.folios[data.bankAccountId]);
                            }
                        }
                    });
                    $timeout(function () {
                        if (!execute) {
                            error = true;
                            reject('El servidor a excedido el tiempo de respuesta');
                        }
                    }, 10000, false);
                }).catch(function (error) {
                    $log.error(error, 'error al crear tarea para folios');
                    reject('No se pudo crear el registro inténtelo nuevamente');
                });
            });
        }
    }
}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getDataForLayoutsBanorte', getDataForLayoutsBanorte);

    function getDataForLayoutsBanorte(AppF, DataF, $log, $filter, $timeout) {

        return getDataForLayoutsBanorteFn;

        function getDataForLayoutsBanorteFn(params) {
            return new Promise(function (resolve, reject) {
                try {
                    var employees = params.employees;
                    var allEmployeesO = params.allEmployeesO;
                    var processId = params.tabSelected;
                    var calc = params.calc;
                    var paymentForms = params.paymentForms;
                    var payroll = params.payroll;
                    var period = params.period;
                    var operationType = params.operationType;
                    var bankAccount = params.bankAccount;
                    var processName = params.processName;
                    var date = params.date;
                    var payrollId = params.payrollId;
                    if (processId === 'fiscal' && operationType === 'asimilated') {
                        processName = 'ASIMILADOS';
                    } else if (processId === 'fiscal' && operationType === 'ptuRecord') {
                        processName = 'PTU';
                    }
                    var data = getDataForLayouts(processName, employees, allEmployeesO, calc, paymentForms, processId, payroll, period, operationType, bankAccount, params.areAll);
                    var error = angular.fromJson(angular.toJson(data.error));
                    delete data.error;
                    if (data.footer.totalEmployees > 0) {
                        if (angular.isDefined(bankAccount) && angular.isDefined(bankAccount.issuer)) {
                            var pag = {
                                header: {
                                    issuer: bankAccount.issuer,
                                    date: moment(date).format('YYYY/MM/DD'),
                                    totalPayment: data.footer.totalEmployees,
                                    totalAmount: $filter('roundNumber')(data.footer.totalAmount * 100)
                                },
                                body: data.body
                            };
                            for (var k in pag.header) {
                                if (pag.header.hasOwnProperty(k)) {
                                    var value = (angular.isNumber(pag.header[k])) ? pag.header[k].toString() : pag.header[k];
                                    var converterString = value.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '');
                                    if (k === 'totalAmount' && converterString.length > 15) {
                                        throw 'El total de la operación excede los 13 dígitos de los números enteros permitidos';
                                    }
                                    pag.header[k] = converterString;
                                }
                            }
                            var generate = {
                                bankAccountId: bankAccount._id,
                                type: processName,
                                payrollId: payrollId ? payrollId : 'any',
                                payrollName: payroll ? payroll.fb.data.name : 'many'
                            };
                            generateNumber(generate).then(function (resp) {
                                if (angular.isDefined(resp.folio)) {
                                    pag.header.number = resp.folio.toString();
                                    var params = {
                                        success: pag
                                    };
                                    if (error.length > 0) {
                                        params.error = error;
                                    }
                                    resolve(params);
                                }
                            }).catch(function (error) {
                                reject(error);
                            });
                        } else {
                            error.unshift('El banco no tiene asignado una emisora');
                            resolve({ error: error });
                        }
                    } else {
                        error.unshift('No hay ningún empleado con la cuenta de ' + bankAccount.bankData.name);
                        resolve({ error: error });
                    }
                } catch (error) {
                    reject(error);
                }
            });
        }
        function getDataForLayouts(processName, employees, allEmployeesO, calc, paymentForms, tabSelected, payroll, period, operationType, bankAccount, areAll) {
            var data = {
                header: {
                    payroll: payroll ? payroll.fb.data.name : '',
                    class: payroll ? payroll.fb.data.class : '',
                    type: 'Formas de Pago Nomina',
                    period: period ? period.fb.period : undefined,
                    dateStart: period ? period.fb.startString : undefined,
                    dateEnd: period ? period.fb.endString : undefined,
                    process: processName,
                    date: moment().format('DD/MM/YYYY'),
                    hour: moment().format('HH:mm:ss'),
                    businessName: []
                },
                body: {},
                footer: {},
                error: []
            };
            var count = {};
            var totalEmployees = 0;
            var defaultPaymentForm = paymentForms.find(function (value) {
                return value.key === 'transfer';
            });
            for (var i = 0; i < employees.length; i++) {
                try {
                    var employee = allEmployeesO[employees[i].$id];
                    var totals = $filter('discountDispersionExempts')(calc[employee.$id], tabSelected);
                    var total = totals.totalNoExempts;
                    var card;
                    try {
                        card = $filter('getEmployeeAccount')(employee, tabSelected, operationType, defaultPaymentForm._id);
                    } catch (error) {
                        var thisError;
                        if (areAll) {
                            $log.debug(error);
                        } else {
                            thisError = error;
                        }
                        throw thisError;
                    }
                    if (total > 0 && card.bank === bankAccount.bank) {
                        if (card.thisAccount.toString().length > 10) {
                            throw 'El empleado ' + employee.data.name + ' no tiene una cuenta valida';
                        }
                        if (!$filter('getFromObject')(employee, 'data.employeeNumber', false)) {
                            throw 'El empleado ' + employee.data.name + ' no tiene asignado un numero de empleado';
                        }
                        if (angular.isUndefined(count[bankAccount.bankData.name])) {
                            count[bankAccount.bankData.name] = 0;
                        }
                        if (angular.isUndefined(data.body[bankAccount.bankData.name])) {
                            data.body[bankAccount.bankData.name] = {
                                body: [],
                                footer: {}
                            };
                        }
                        count[bankAccount.bankData.name] = count[bankAccount.bankData.name] + total;
                        totalEmployees++;
                        var roundTotal = Math.round($filter('roundNumber')(total) * 100);
                        var converterString = ($filter('number')(roundTotal)).replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '');
                        if (converterString.length > 15) {
                            throw 'El empleado ' + employee.data.name + ' excede los 13 dígitos de los números enteros de totales';
                        }
                        var obj = {
                            number: employee.data.employeeNumber.toString(),
                            account: card.thisAccount.toString(),
                            total: converterString
                        };
                        data.body[bankAccount.bankData.name].body.push(obj);
                        data.body[bankAccount.bankData.name].footer = {
                            count: data.body[bankAccount.bankData.name].body.length, total: count[bankAccount.bankData.name]
                        };
                    }
                } catch (error) {
                    if (angular.isDefined(error)) {
                        data.error.push(error);
                    }
                }

            }
            var totalAmount = 0;
            for (var amount in count) {
                totalAmount = totalAmount + count[amount];
            }
            data.footer = { totalEmployees: totalEmployees, totalAmount: totalAmount };
            return data;
        }
        function generateNumber(data) {
            return new Promise(function (resolve, reject) {
                var idFolio = AppF.root.child('catalogs/folios/collection').push().key;
                var taskObj = {
                    'type': 'getIssuersNextFolio',
                    'payroll': data.payrollId,
                    'payrollName': data.payrollName,
                    'recordId': idFolio,
                    'profileObj': DataF.getTimeObject(),
                    'issuers': {}
                };
                taskObj.issuers[data.bankAccountId] = data.type;
                $log.log(taskObj);
                AppF.root.child('queue1/tasks').push(taskObj).then(function () {
                    $log.log('se crea tarea para folio satisfactoriamente');
                    var error;
                    var ref = AppF.root.child('catalogs/folios/collection/' + idFolio);
                    var execute = false;
                    ref.on('value', function (snap) {
                        if (!error) {
                            var value = snap.val();
                            if (value !== null) {
                                execute = true;
                                ref.off();
                                resolve(value.folios[data.bankAccountId]);
                            }
                        }
                    });
                    $timeout(function () {
                        if (!execute) {
                            error = true;
                            reject('El servidor a excedido el tiempo de respuesta');
                        }
                    }, 10000, false);
                }).catch(function (error) {
                    $log.error(error, 'error al crear tarea para folios');
                    reject('No se pudo crear el registro inténtelo nuevamente');
                });
            });
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getDataForLayoutsBancomerSpei', getDataForLayoutsBancomerSpei);

    function getDataForLayoutsBancomerSpei($filter, $log, AppF) {

        return getDataForLayoutsBancomerSpeiFn;
        function getDataForLayoutsBancomerSpeiFn(params) {
            return new Promise(function (resolve, reject) {
                try {
                    var employees = params.employees;
                    var allEmployeesO = params.allEmployeesO;
                    var processId = params.tabSelected;
                    var calc = params.calc;
                    var paymentForms = params.paymentForms;
                    var payroll = params.payroll ? params.payroll.fb : undefined;
                    var period = params.period ? params.period.fb : undefined;
                    var calendar = params.calendar;
                    var operationType = params.operationType;
                    var bankAccount = params.bankAccount;
                    resolve(getDataForLayouts(employees, allEmployeesO, calc, paymentForms, processId, payroll, period, calendar, operationType, bankAccount, params.areAll));
                } catch (error) {
                    reject(error);
                }
            });
        }
        function getDataForLayouts(employees, allEmployeesO, calc, paymentForms, processId, payroll, period, calendar, operationType, bankAccount, areAll) {
            var thisCenter = AppF.center;
            var fileName = $filter('getDispFileName')('DISP_' + thisCenter, 'SPEI', bankAccount, payroll, calendar, period);
            var data = {
                success: [],
                error: [],
                filename: fileName
            };
            var defaultPaymentForm = paymentForms.find(function (value) {
                return value.key === 'transfer';
            });
            for (var i = 0; i < employees.length; i++) {
                try {
                    var employee = allEmployeesO[employees[i].$id];
                    var totals = $filter('discountDispersionExempts')(calc[employee.$id], processId);
                    var total = totals.totalNoExempts;
                    var card;
                    try {
                        card = $filter('getEmployeeAccount')(employee, processId, operationType, defaultPaymentForm._id);
                    } catch (error) {
                        var thisError;
                        if (areAll) {
                            $log.debug(error);
                        } else {
                            thisError = error;
                        }
                        throw thisError;
                    }
                    if (total > 0 && card.thisAccount.toString().length === 18) {
                        var totalNumber = $filter('roundNumber')(total);
                        data.success.push({
                            employeeId: employees[i].$id,
                            account: card.thisAccount + '',
                            amount: Math.round(totalNumber * 100) + ''
                        });

                    }

                } catch (error) {
                    if (angular.isDefined(error)) {
                        data.error.push(error);
                    }
                }

            }
            return data;
        }
    }
}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getDataForLayoutsBancomerNetcashMasivosSpei', getDataForLayoutsBancomerNetcashMasivosSpei);

    function getDataForLayoutsBancomerNetcashMasivosSpei($filter, $log, AppF) {
        return getDataForLayoutsBancomerNetcashMasivosSpeiFn;
        function getDataForLayoutsBancomerNetcashMasivosSpeiFn(params) {
            return new Promise(function (resolve, reject) {
                try {
                    var employees = params.employees;
                    var allEmployeesO = params.allEmployeesO;
                    var processId = params.tabSelected;
                    var calc = params.calc;
                    var paymentForms = params.paymentForms;
                    var payroll = params.payroll ? params.payroll.fb : undefined;
                    var period = params.period ? params.period.fb : undefined;
                    var calendar = params.calendar;
                    var operationType = params.operationType;
                    var bankAccount = params.bankAccount;
                    var numerAccountEmp = params.bankAccount.acountEmp;
                    var ref = params.bankAccount.ref;
                    resolve(getDataForLayouts(employees, allEmployeesO, calc, paymentForms, processId, payroll, period, calendar, operationType, bankAccount, params.areAll, numerAccountEmp, params, ref));
                } catch (error) {
                    reject(error);
                }
            });
        }
        function getDataForLayouts(employees, allEmployeesO, calc, paymentForms, processId, payroll, period, calendar, operationType, bankAccount, areAll, numerAccountEmp, params, ref) {
            var thisCenter = AppF.center;
            var fileName = $filter('getDispFileName')('DISP_' + thisCenter, 'SPEI', bankAccount, payroll, calendar, period);
            var data = {
                success: [],
                error: [],
                filename: fileName
            };
            var defaultPaymentForm = paymentForms.find(function (value) {
                return value.key === 'transfer';
            });
            for (var i = 0; i < employees.length; i++) {
                try {
                    var employee = allEmployeesO[employees[i].$id];
                    var totals = $filter('discountDispersionExempts')(calc[employee.$id], processId);
                    var total = totals.totalNoExempts;
                    var card;
                    try {
                        card = $filter('getEmployeeAccount')(employee, processId, operationType, defaultPaymentForm._id);
                    } catch (error) {
                        var thisError;
                        if (areAll) {
                            $log.debug(error);
                        } else {
                            thisError = error;
                        }
                        throw thisError;
                    }
                    if (total > 0 && card.thisAccount.toString().length === 18) {
                        var totalNumber = $filter('roundNumber')(total);
                        var employeeBank = card.bank;
                        if (angular.isUndefined(employeeBank) || employeeBank === '') {
                            throw 'El empleado ' + employee.data.name + ' no tiene un banco seleccionado';
                        }
                        var thisBank = params.banks.find(function (item) {
                            return item._id === employeeBank;
                        });
                        if (angular.isUndefined(thisBank) || angular.isUndefined(thisBank.extraFields) || angular.isUndefined(thisBank.extraFields.bancomermasivo)) {
                            throw 'El banco del empleado ' + employee.data.name + ' no tienen el código para el layout';
                        }

                        data.success.push({
                            AccountEmp: numerAccountEmp,
                            bankCode: thisBank.extraFields.bancomermasivo,
                            divisa: 'MXP',
                            typeAccount: '40',
                            motive: 'PAGO SPEI',
                            ref: ref,
                            disponible: 'H',
                            employeeId: employees[i].$id,
                            employeeName: employees[i].data.name,
                            account: card.thisAccount + '',
                            amount: totalNumber
                        });

                    }

                } catch (error) {
                    if (angular.isDefined(error)) {
                        data.error.push(error);
                    }
                }

            }
            return data;
        }
    }
}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getDataForLayoutsBancomer232', getDataForLayoutsBancomer232);

    function getDataForLayoutsBancomer232($filter, $log, $state) {
        return function getDataForLayoutsBancomer232Fn(params) {
            return new Promise(function (resolve, reject) {
                try {
                    $log.log('Parametros Data', params);
                    var bankAccount = params.bankAccount;
                    var date = params.date ? params.date : moment().valueOf();
                    var paymentForms = params.paymentForms;
                    var employees = params.employees;
                    var allEmployeesO = params.allEmployeesO;
                    var processId = params.tabSelected;
                    var operationType = $state.params.operationType;
                    var calc = params.calc;
                    var payroll = params.payrollId;
                    var period = params.period;

                    var codeLegend;
                    if (operationType === 'ordinary' || operationType === 'extraordinary' || operationType === 'settlement') {
                        codeLegend = 'R05';
                    } else if (operationType === 'ptuRecord') {
                        codeLegend = 'R22';
                    } else if (operationType === 'chrisBonusRecord') {
                        codeLegend = 'R16'
                    }

                    var validations = [
                        [date, 'Seleccione la fecha en la que realizara la dispersion'],
                        [bankAccount.NumberContract, 'Se necesita el número de contrato de empresa '],
                        [bankAccount.codeLegend, 'Se necesita el código de leyenda configurado']
                    ];
                    for (var d = 0; d < validations.length; d++) {
                        var validation = validations[d];
                        if (angular.isUndefined(validation[0])) {
                            throw validation[1];
                        }
                    }
                    var defaultPaymentForm = paymentForms.find(function (value) {
                        return value.key === 'transfer';
                    });


                    var data = {
                        success:
                        {
                            head: {
                                applicationDate: date,
                                NumberContract: bankAccount.NumberContract,
                                codeLegend: codeLegend,
                                payrollId: payroll,
                                period: period.fb
                            },
                            body: []
                        },
                        error: []
                    }

                    var totalAmount = 0;
                    for (var i = 0; i < employees.length; i++) {
                        try {
                            var employee = allEmployeesO[employees[i].$id];
                            var totals = $filter('discountDispersionExempts')(calc[employee.$id], processId);
                            var total = totals.totalNoExempts;
                            var card;
                            card = $filter('getEmployeeAccount')(employee, processId, operationType, defaultPaymentForm._id);
                            var lengthBank = bankAccount.bankData.accountLength ? bankAccount.bankData.accountLength : 10;
                            if (total > 0 && card.bank === bankAccount.bank) {
                                if (card.thisAccount.toString().length !== lengthBank) {
                                    throw 'El empleado ' + employee.data.name + ' no tiene los dígitos de la cuenta valida';
                                }
                                var totalNumber = $filter('roundNumber')(total);

                                data.success.body.push({
                                    employeesId: employees[i].$id,
                                    account: card.thisAccount,
                                    amount: totalNumber,
                                    totalAmount: Math.round(totalNumber * 100)
                                });
                                totalAmount = totalAmount + totalNumber;

                            }
                        } catch (error) {
                            if (angular.isDefined(error)) {
                                data.error.push(error);
                            }
                        }

                    }
                    data.success.head.totalAmount = Math.round(totalAmount * 100)
                    resolve(data)

                } catch (error) {
                    reject(error);
                }
            });

        };
    }
}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getDataForLayoutsBancomer', getDataForLayoutsBancomer);

    function getDataForLayoutsBancomer($filter, $log, AppF) {

        return getDataForLayoutsBancomerFn;
        function getDataForLayoutsBancomerFn(params) {
            return new Promise(function (resolve, reject) {
                try {
                    var employees = params.employees;
                    var allEmployeesO = params.allEmployeesO;
                    var processId = params.tabSelected;
                    var calc = params.calc;
                    var paymentForms = params.paymentForms;
                    var payroll = params.payroll ? params.payroll.fb : undefined;
                    var period = params.period ? params.period.fb : undefined;
                    var calendar = params.calendar;
                    var operationType = params.operationType;
                    var bankAccount = params.bankAccount;
                    resolve(getDataForLayouts(employees, allEmployeesO, calc, paymentForms, processId, payroll, period, calendar, operationType, bankAccount, params.areAll));
                } catch (error) {
                    reject(error);
                }
            });
        }
        function getDataForLayouts(employees, allEmployeesO, calc, paymentForms, processId, payroll, period, calendar, operationType, bankAccount, areAll) {
            var thisCenter = AppF.center.toUpperCase();
            var fileName = $filter('getDispFileName')('DISP_' + thisCenter, undefined, bankAccount, payroll, calendar, period);
            var data = {
                success: [],
                error: [],
                filename: fileName
            };
            var defaultPaymentForm = paymentForms.find(function (value) {
                return value.key === 'transfer';
            });
            for (var i = 0; i < employees.length; i++) {
                try {
                    var employee = allEmployeesO[employees[i].$id];
                    var totals = $filter('discountDispersionExempts')(calc[employee.$id], processId);
                    var total = totals.totalNoExempts;
                    var card;
                    try {
                        card = $filter('getEmployeeAccount')(employee, processId, operationType, defaultPaymentForm._id);
                    } catch (error) {
                        var thisError;
                        if (areAll) {
                            $log.debug(error);
                        } else {
                            thisError = error;
                        }
                        throw thisError;
                    }
                    if (total > 0 && card.bank === bankAccount.bank && card.thisAccount.toString().length !== 18) {
                        if (angular.isDefined($filter('getFromObject')(employee.data, 'rfc'))) {
                            if (employee.data.rfc.length > 16) { throw 'El empleado ' + employee.data.name + ' no tiene los dígitos del RFC valido'; }
                        } else {
                            throw 'El empleado ' + employee.data.name + ' no tiene asignado el RFC';
                        }
                        if (card.thisAccount.toString().length !== 10 && card.thisAccount.toString().length !== 11) {
                            throw 'El empleado ' + employee.data.name + ' no tiene los dígitos de la cuenta valida';
                        }
                        var totalNumber = $filter('roundNumber')(total);
                        data.success.push({
                            employeeId: employees[i].$id,
                            account: card.thisAccount + '',
                            amount: Math.round(totalNumber * 100) + ''
                        });

                    }
                } catch (error) {
                    if (angular.isDefined(error)) {
                        data.error.push(error);
                    }
                }

            }
            return data;
        }
    }
}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getDataForLayoutsBancoAzteca', getDataForLayoutsBancoAzteca);

    function getDataForLayoutsBancoAzteca($filter, $log) {
        return function getDataForLayoutsBancoAztecaFn(params) {
            return new Promise(function (resolve, reject) {
                try {
                    var bankAccount = params.bankAccount;
                    var paymentForms = params.paymentForms;
                    var employees = params.employees;
                    var allEmployeesO = params.allEmployeesO;
                    var processId = params.tabSelected;
                    var operationType = params.operationType;
                    var calc = params.calc;
                    var payroll = params.payroll ? params.payroll.fb : undefined;
                    var period = params.period ? params.period.fb : undefined;


                    var validations = [
                        [bankAccount.loadAccountNumber, 'Se necesita el numero de cuenta cargo'],
                        [bankAccount.nameLoadAccountNumber, 'Se necesita el nombre del titular cuenta cargo'],
                        [bankAccount.rfcHolder, 'Se necesita el rfc del titular'],
                        [bankAccount.beneficiaryAccountType, 'Se necesita el tipo de cuenta beneficiario '],
                        [bankAccount.paymentLegend, 'Se necesita leyenda de abono'],
                        [bankAccount.chargeLegend, 'Se necesita leyenda de cargo']
                    ];
                    for (var d = 0; d < validations.length; d++) {
                        var validation = validations[d];
                        if (angular.isUndefined(validation[0])) {
                            throw validation[1];
                        }
                    }
                    var defaultPaymentForm = paymentForms.find(function (value) {
                        return value.key === 'transfer';
                    });


                    var data = {
                        success:
                        {
                            head: {
                                period: period.period,
                                namePayroll: payroll.data.name,
                                center: payroll.center,
                                classPayroll: payroll.data.class,
                                cuentaCargo: bankAccount.loadAccountNumber,
                                nombreCuentaCargo: bankAccount.nameLoadAccountNumber,
                                rfcTitular: bankAccount.rfcHolder,
                                tipoCuentaBeneficiario: bankAccount.beneficiaryAccountType,
                                leyendaAbono: bankAccount.paymentLegend,
                                leyendaCargo: bankAccount.chargeLegend
                            },
                            body: []
                        },
                        error: []
                    }

                    for (var i = 0; i < employees.length; i++) {
                        try {
                            var employee = allEmployeesO[employees[i].$id];
                            var totals = $filter('discountDispersionExempts')(calc[employee.$id], processId);
                            var total = totals.totalNoExempts;
                            var card;
                            try {
                                card = $filter('getEmployeeAccount')(employee, processId, operationType, defaultPaymentForm._id);
                            } catch (error) {
                                var thisError;
                                if (params.areAll) {
                                    $log.debug(error);
                                } else {
                                    thisError = error;
                                }
                                throw thisError;
                            }
                            if (total > 0 && card.bank === bankAccount.bank) {

                                //? para cuenta tiene que ser 14 dígitos

                                var lengthBank = bankAccount.bankData.accountLength ? bankAccount.bankData.accountLength : 10;

                                if (card.thisAccount.toString().length !== lengthBank) {
                                    throw 'El empleado ' + employee.data.name + ' no tiene los dígitos de la cuenta valida';
                                }
                                var totalNumber = $filter('roundNumber')(total) * 100 / 100;
                                data.success.body.push({
                                    employeeId: employees[i].$id,
                                    account: card.thisAccount,
                                    total: totalNumber
                                });

                            }
                        } catch (error) {
                            if (angular.isDefined(error)) {
                                data.error.push(error);
                            }
                        }

                    }

                    resolve(data)

                } catch (error) {
                    reject(error);
                }
            });

        };
    }
}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getDataForLayoutsBanamexV2', getDataForLayoutsBanamexV2);

    function getDataForLayoutsBanamexV2($filter, $log, AppF) {
        return function getDataForLayoutsBanamexV2Fn(params) {
            return new Promise(function (resolve, reject) {
                $log.log('getDataForLayoutsBanamexV2 filter params', params);
                try {
                    var payroll = params.payroll ? params.payroll.fb : undefined;
                    var period = params.period ? params.period.fb : undefined;
                    var calendar = params.calendar;
                    var bankAccount = params.bankAccount;
                    var date = params.date;
                    var consecutive = params.consecutive;
                    var refAlfa = params.refAlfa;
                    var paymentForms = params.paymentForms;
                    var employees = params.employees;
                    var allEmployeesO = params.allEmployeesO;
                    var processId = params.tabSelected;
                    var operationType = params.operationType;
                    var calc = params.calc;
                    var validations = [
                        [date, 'Seleccione la fecha en la que realizara la dispersion'],
                        [consecutive, 'No se inserto el consecutivo necesario para la dispersion'],
                        [refAlfa, 'No se inserto la referencia alfanumerica necesaria para la dispersion'],
                        [bankAccount.clientNumber, 'Se necesita el numero de cliente de la cuenta configurada'],
                        [bankAccount.account, 'Se necesita el numero de cuenta de la cuenta configurada'],
                        [bankAccount.companiesRecord, 'Este cuenta no tiene una empresa asignada'],
                        [payroll.data.class, 'Debe poner el numero de clase de nomina']
                    ];
                    for (var d = 0; d < validations.length; d++) {
                        var validation = validations[d];
                        if (angular.isUndefined(validation[0])) {
                            throw validation[1];
                        }
                    }
                    var query = AppF.root.child('catalogs/companiesRecords/collection/' + bankAccount.companiesRecord + '/data/businessName').once('value');
                    query.then(function (snap) {
                        if (!snap.exists()) {
                            throw 'Esta empresa no tiene la razón social';
                        }
                        var thisCenter = AppF.center.toUpperCase();

                        var fileName = $filter('getDispFileName')('DISP_' + thisCenter, undefined, bankAccount, payroll, calendar, period);
                        var data = {
                            success: {
                                head: {
                                    businessName: snap.val(),
                                    consecutive: consecutive,
                                    refAlfa: refAlfa,
                                    name: bankAccount.nameClient,
                                    descriptionTitle: bankAccount.description,
                                    date: date,
                                    class: payroll.data.class,
                                    clientNumber: bankAccount.clientNumber,
                                    sucursal: bankAccount.sucursal,
                                    account: bankAccount.account,
                                    description: 'P' + period.period
                                },
                                body: []
                            },
                            error: [],
                            filename: fileName
                        };

                        var totalAmount = 0;
                        var defaultPaymentForm = paymentForms.find(function (value) {
                            return value.key === 'transfer';
                        });
                        for (var i = 0; i < employees.length; i++) {
                            try {
                                var employee = allEmployeesO[employees[i].$id];
                                var totals = $filter('discountDispersionExempts')(calc[employee.$id], processId);
                                var total = totals.totalNoExempts;
                                var card;
                                try {
                                    card = $filter('getEmployeeAccount')(employee, processId, operationType, defaultPaymentForm._id);
                                } catch (error) {
                                    var thisError;
                                    if (params.areAll) {
                                        $log.debug(error);
                                    } else {
                                        thisError = error;
                                    }
                                    throw thisError;
                                }
                                if (total > 0 && card.bank === bankAccount.bank) {
                                    if ([9, 10, 11].indexOf(card.thisAccount.toString().length) === -1) {
                                        throw 'El empleado ' + employee.data.name + ' no tiene una cuenta valida';
                                    }
                                    var totalNumber = $filter('roundNumber')(total);
                                    data.success.body.push({
                                        employeeId: employees[i].$id,
                                        account: card.thisAccount + '',
                                        totalAmount: Math.round(totalNumber * 100) + ''
                                    });
                                    totalAmount = totalAmount + totalNumber;

                                }
                            } catch (error) {
                                if (angular.isDefined(error)) {
                                    data.error.push(error);
                                }
                            }
                        }
                        data.success.head.totalAmount = Math.round(totalAmount * 100) + '';
                        resolve(data);

                    }).catch(reject);
                } catch (error) {
                    reject(error);
                }
            });

        };
    }
}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getDataForLayoutsBanamexSpeiV2', getDataForLayoutsBanamexSpeiV2);

    function getDataForLayoutsBanamexSpeiV2(AppF, $filter, $log) {

        var TAG = '[BANAMEX SPEI V2]';

        function nowISO() {
            try { return (new Date()).toISOString(); } catch (e) { return '' + new Date(); }
        }

        // todo a $log.log()
        function log(step, obj) {
            if (angular.isUndefined(obj)) {
                $log.log(TAG, nowISO(), step);
                return;
            }
            $log.log(TAG, nowISO(), step, obj);
        }

        function normalizeError(err) {
            if (angular.isUndefined(err) || err === null) {
                return { message: 'Error desconocido (undefined/null)', raw: err };
            }
            if (angular.isString(err)) {
                return { message: err, raw: err };
            }
            if (err && err.message) {
                return { message: err.message, raw: err };
            }
            try {
                return { message: JSON.stringify(err), raw: err };
            } catch (e) {
                return { message: ('' + err), raw: err };
            }
        }

        function pushEmployeeError(data, employee, employeeId, step, err) {
            var info = normalizeError(err);
            var name = (employee && employee.data && employee.data.name) ? employee.data.name : '(sin nombre)';
            data.error.push({
                employeeId: employeeId,
                employeeName: name,
                step: step,
                message: info.message,
                raw: info.raw
            });

            // LOG DEL ERROR POR EMPLEADO (clave)
            log('EMP_ERROR ' + step, {
                employeeId: employeeId,
                employeeName: name,
                message: info.message,
                raw: info.raw
            });
        }

        function requireDefined(val, msg) {
            if (angular.isUndefined(val)) throw msg;
        }

        function safeStr(val, max) {
            max = max || 120;
            try {
                var s = (angular.isObject(val) ? JSON.stringify(val) : (val + ''));
                if (s.length > max) return s.slice(0, max) + '...';
                return s;
            } catch (e) {
                return '' + val;
            }
        }

        return function getDataForLayoutsBanamexSpeiV2Fn(params) {

            return new Promise(function (resolve, reject) {

                try {
                    log('INICIO', {
                        areAll: !!params.areAll,
                        tabSelected: params.tabSelected,
                        operationType: params.operationType,
                        employeesLen: (params.employees && params.employees.length) || 0
                    });

                    var payroll = params.payroll ? params.payroll.fb : undefined;
                    var period = params.period ? params.period.fb : undefined;
                    var calendar = params.calendar;
                    var bankAccount = params.bankAccount || {};
                    var date = params.date;
                    var consecutive = params.consecutive;
                    var refAlfa = params.refAlfa;
                    var paymentForms = params.paymentForms || [];
                    var employees = params.employees || [];
                    var allEmployeesO = params.allEmployeesO || {};
                    var processId = params.tabSelected;
                    var operationType = params.operationType;
                    var calc = params.calc || {};
                    var banks = params.banks || [];

                    // ============================
                    // VALIDACIONES (GLOBAL) + LOG
                    // ============================
                    var validations = [
                        ['date', date, 'Seleccione la fecha en la que realizara la dispersion'],
                        ['consecutive', consecutive, 'No se inserto el consecutivo necesario para la dispersion'],
                        ['refAlfa', refAlfa, 'No se inserto la referencia alfanumerica necesaria para la dispersion'],
                        ['bankAccount.clientNumber', bankAccount.clientNumber, 'Se necesita el numero de cliente de la cuenta configurada'],
                        ['bankAccount.account', bankAccount.account, 'Se necesita el numero de cuenta de la cuenta configurada'],
                        ['bankAccount.companiesRecord', bankAccount.companiesRecord, 'Esta cuenta no tiene una empresa asignada'],
                        ['payroll.data.class', (payroll && payroll.data && payroll.data.class), 'Debe poner el numero de clase de nomina']
                    ];

                    for (var d = 0; d < validations.length; d++) {
                        if (angular.isUndefined(validations[d][1])) {
                            log('VALIDATION_FAIL', { field: validations[d][0], message: validations[d][2] });
                            return reject(validations[d][2]);
                        }
                    }
                    log('VALIDATION_OK');

                    // ============================
                    // paymentForm default
                    // ============================
                    var defaultPaymentForm;
                    for (var pf = 0; pf < paymentForms.length; pf++) {
                        if (paymentForms[pf].key === 'transfer') {
                            defaultPaymentForm = paymentForms[pf];
                            break;
                        }
                    }
                    log('PAYMENTFORM_TRANSFER', {
                        found: !!defaultPaymentForm,
                        id: defaultPaymentForm && defaultPaymentForm._id,
                        key: defaultPaymentForm && defaultPaymentForm.key
                    });

                    // ============================
                    // FIREBASE: razón social
                    // ============================
                    var businessPath = 'catalogs/companiesRecords/collection/' + bankAccount.companiesRecord + '/data/businessName';
                    log('FB_READ_BUSINESSNAME', { path: businessPath });

                    AppF.root.child(businessPath).once('value')
                        .then(function (snap) {

                            log('FB_SNAPSHOT', {
                                exists: snap.exists(),
                                valuePreview: snap.exists() ? safeStr(snap.val(), 80) : '(no existe)'
                            });

                            if (!snap.exists()) {
                                throw 'Esta empresa no tiene la razón social';
                            }

                            var thisCenter = (AppF.center || '').toUpperCase();
                            var fileName = $filter('getDispFileName')('DISP_' + thisCenter, 'SPEI', bankAccount, payroll, calendar, period);

                            var data = {
                                success: {
                                    head: {
                                        businessName: snap.val(),
                                        consecutive: consecutive,
                                        refAlfa: refAlfa,
                                        name: bankAccount.nameClient,
                                        descriptionTitle: bankAccount.description,
                                        date: date,
                                        class: payroll.data.class,
                                        clientNumber: bankAccount.clientNumber,
                                        sucursal: bankAccount.sucursal,
                                        account: bankAccount.account,
                                        description: 'P' + period.period
                                    },
                                    body: []
                                },
                                error: [],
                                filename: fileName
                            };

                            log('HEAD_READY', {
                                filename: fileName,
                                businessName: safeStr(data.success.head.businessName, 60),
                                class: data.success.head.class,
                                description: data.success.head.description
                            });

                            var totalAmount = 0;

                            // ============================
                            // LOOP EMPLEADOS
                            // ============================
                            for (var i = 0; i < employees.length; i++) {

                                var employeeId = employees[i] && employees[i].$id;

                                // log por empleado (arranque)
                                log('EMP_START', { i: i, employeeId: employeeId });

                                try {

                                    // 1) buscar empleado
                                    var employee = allEmployeesO[employeeId];
                                    requireDefined(employee, 'Empleado no encontrado en allEmployeesO');
                                    log('EMP_FOUND', { employeeId: employeeId, name: employee.data && employee.data.name });

                                    // 2) calc
                                    requireDefined(calc[employee.$id], 'No existe calc para el empleado');
                                    log('EMP_CALC_FOUND', { employeeId: employeeId });

                                    var totals = $filter('discountDispersionExempts')(calc[employee.$id], processId);
                                    requireDefined(totals, 'discountDispersionExempts devolvió vacío');

                                    var total = totals.totalNoExempts;
                                    log('EMP_TOTALS', {
                                        employeeId: employeeId,
                                        totalNoExempts: total,
                                        processId: processId
                                    });

                                    // 3) obtener cuenta (getEmployeeAccount)
                                    var card;
                                    try {
                                        card = $filter('getEmployeeAccount')(employee, processId, operationType, defaultPaymentForm && defaultPaymentForm._id);
                                        log('EMP_ACCOUNT_OK', {
                                            employeeId: employeeId,
                                            bank: card && card.bank,
                                            thisAccount: card && card.thisAccount
                                        });
                                    } catch (errAcc) {
                                        log('EMP_ACCOUNT_THROW', {
                                            employeeId: employeeId,
                                            areAll: !!params.areAll,
                                            err: normalizeError(errAcc)
                                        });

                                        if (params.areAll) {
                                            pushEmployeeError(data, employee, employeeId, 'getEmployeeAccount', errAcc);
                                            continue;
                                        }
                                        throw errAcc;
                                    }

                                    requireDefined(card, 'getEmployeeAccount no devolvió card');
                                    requireDefined(card.thisAccount, 'Cuenta bancaria no encontrada (card.thisAccount)');

                                    var accountStr = (card.thisAccount + '');
                                    log('EMP_ACCOUNT_STR', { employeeId: employeeId, len: accountStr.length });

                                    // 4) regla del layout
                                    if (total > 0 && accountStr.length === 18) {

                                        var employeeBank = card.bank;
                                        if (angular.isUndefined(employeeBank) || employeeBank === '') {
                                            throw 'El empleado ' + employee.data.name + ' no tiene un banco seleccionado';
                                        }

                                        // buscar banco
                                        var thisBank;
                                        for (var b = 0; b < banks.length; b++) {
                                            if (banks[b]._id === employeeBank) {
                                                thisBank = banks[b];
                                                break;
                                            }
                                        }

                                        if (angular.isUndefined(thisBank) ||
                                            angular.isUndefined(thisBank.extraFields) ||
                                            angular.isUndefined(thisBank.extraFields.banamexV2)) {
                                            throw 'El banco del empleado ' + employee.data.name + ' no tiene el código banamexV2 para el layout';
                                        }

                                        var totalNumber = $filter('roundNumber')(total);

                                        data.success.body.push({
                                            employeeId: employeeId,
                                            account: accountStr,
                                            bankCode: thisBank.extraFields.banamexV2,
                                            totalAmount: (Math.round(totalNumber * 100) + '')
                                        });

                                        totalAmount = totalAmount + totalNumber;

                                        log('EMP_PUSH_OK', {
                                            employeeId: employeeId,
                                            bankCode: thisBank.extraFields.banamexV2,
                                            totalNumber: totalNumber,
                                            totalAmountRunning: totalAmount
                                        });

                                    } else {
                                        log('EMP_SKIP', {
                                            employeeId: employeeId,
                                            reason: {
                                                total: total,
                                                accountLen: accountStr.length,
                                                rule: 'require total>0 and accountLen===18'
                                            }
                                        });
                                    }

                                } catch (errEmp) {
                                    pushEmployeeError(
                                        data,
                                        allEmployeesO[employeeId],
                                        employeeId,
                                        'employeeLoop',
                                        errEmp
                                    );
                                }
                            }

                            data.success.head.totalAmount = (Math.round(totalAmount * 100) + '');
                            log('FIN_OK', { bodyLen: data.success.body.length, errorLen: data.error.length, totalAmount: data.success.head.totalAmount });
                            resolve(data);
                        })
                        .catch(function (err) {
                            var info = normalizeError(err);
                            log('ERROR_GLOBAL_PROMISE', { message: info.message, raw: info.raw });
                            reject(info.message);
                        });

                } catch (error) {
                    var info2 = normalizeError(error);
                    log('ERROR_GENERAL_TRY', { message: info2.message, raw: info2.raw });
                    reject(info2.message);
                }
            });
        };
    }
}());

(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getDataForLayoutsBanamexSpei', getDataForLayoutsBanamexSpei);

    function getDataForLayoutsBanamexSpei(AppF, $filter, $log) {
        return function getDataForLayoutsBanamexSpeiFn(params) {
            return new Promise(function (resolve, reject) {
                try {
                    var payroll = params.payroll ? params.payroll.fb : undefined;
                    var period = params.period ? params.period.fb : undefined;
                    var calendar = params.calendar;
                    var bankAccount = params.bankAccount;
                    var date = params.date;
                    var consecutive = params.consecutive;
                    var paymentForms = params.paymentForms;
                    var employees = params.employees;
                    var allEmployeesO = params.allEmployeesO;
                    var processId = params.tabSelected;
                    var operationType = params.operationType;
                    var calc = params.calc;
                    var validations = [
                        [date, 'Seleccione la fecha en la que realizara la dispersion'],
                        [consecutive, 'No se inserto el consecutivo necesario para la dispersion'],
                        [bankAccount.clientNumber, 'Se necesita el numero de cliente de la cuenta configurada'],
                        [bankAccount.account, 'Se necesita el numero de cuenta de la cuenta configurada'],
                        [bankAccount.companiesRecord, 'Este cuenta no tiene una empresa asignada'],
                        [payroll.data.class, 'Debe poner el numero de clase de nomina']
                    ];
                    for (var d = 0; d < validations.length; d++) {
                        var validation = validations[d];
                        if (angular.isUndefined(validation[0])) {
                            throw validation[1];
                        }
                    }
                    var query = AppF.root.child('catalogs/companiesRecords/collection/' + bankAccount.companiesRecord + '/data/businessName').once('value');
                    query.then(function (snap) {
                        if (!snap.exists()) {
                            throw 'Esta empresa no tiene la razón social';
                        }
                        var thisCenter = AppF.center.toUpperCase();
                        var fileName = $filter('getDispFileName')('DISP_' + thisCenter, 'SPEI', bankAccount, payroll, calendar, period);
                        var data = {
                            success: {
                                head: {
                                    businessName: snap.val(),
                                    consecutive: consecutive,
                                    date: date,
                                    class: payroll.data.class,
                                    clientNumber: bankAccount.clientNumber,
                                    account: bankAccount.account,
                                    description: 'P' + period.period
                                },
                                body: []
                            },
                            error: [],
                            filename: fileName
                        };
                        var totalAmount = 0;
                        var defaultPaymentForm = paymentForms.find(function (value) {
                            return value.key === 'transfer';
                        });
                        for (var i = 0; i < employees.length; i++) {
                            try {
                                var employee = allEmployeesO[employees[i].$id];
                                var totals = $filter('discountDispersionExempts')(calc[employee.$id], processId);
                                var total = totals.totalNoExempts;
                                var card;
                                try {
                                    card = $filter('getEmployeeAccount')(employee, processId, operationType, defaultPaymentForm._id);
                                } catch (error) {
                                    var thisError;
                                    if (params.areAll) {
                                        $log.debug(error);
                                    } else {
                                        thisError = error;
                                    }
                                    throw thisError;
                                }
                                if (total > 0 && card.thisAccount.toString().length === 18) {
                                    var employeeBank = card.bank;
                                    if (angular.isUndefined(employeeBank) || employeeBank === '') {
                                        throw 'El empleado ' + employee.data.name + ' no tiene un banco seleccionado';
                                    }
                                    var thisBank = params.banks.find(function (item) {
                                        return item._id === employeeBank;
                                    });
                                    if (angular.isUndefined(thisBank) || angular.isUndefined(thisBank.extraFields) || angular.isUndefined(thisBank.extraFields.banamex)) {
                                        throw 'El banco del empleado ' + employee.data.name + ' no tienen el código para el layout';
                                    }
                                    var totalNumber = $filter('roundNumber')(total);
                                    data.success.body.push({
                                        employeeId: employees[i].$id,
                                        account: card.thisAccount + '',
                                        bankCode: thisBank.extraFields.banamex,
                                        totalAmount: Math.round(totalNumber * 100) + ''
                                    });
                                    totalAmount = totalAmount + totalNumber;

                                }
                            } catch (error) {
                                if (angular.isDefined(error)) {
                                    data.error.push(error);
                                }
                            }
                        }
                        data.success.head.totalAmount = Math.round(totalAmount * 100) + '';
                        resolve(data);
                    }).catch(reject);
                } catch (error) {
                    reject(error);
                }
            });

        };
    }
}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getDataForLayoutsBanamex', getDataForLayoutsBanamex);

    function getDataForLayoutsBanamex($filter, $log, AppF) {
        return function getDataForLayoutsBanamexFn(params) {
            return new Promise(function (resolve, reject) {
                try {
                    var payroll = params.payroll ? params.payroll.fb : undefined;
                    var period = params.period ? params.period.fb : undefined;
                    var calendar = params.calendar;
                    var bankAccount = params.bankAccount;
                    var date = params.date;
                    var consecutive = params.consecutive;
                    var paymentForms = params.paymentForms;
                    var employees = params.employees;
                    var allEmployeesO = params.allEmployeesO;
                    var processId = params.tabSelected;
                    var operationType = params.operationType;
                    var calc = params.calc;
                    var validations = [
                        [date, 'Seleccione la fecha en la que realizara la dispersion'],
                        [consecutive, 'No se inserto el consecutivo necesario para la dispersion'],
                        [bankAccount.clientNumber, 'Se necesita el numero de cliente de la cuenta configurada'],
                        [bankAccount.account, 'Se necesita el numero de cuenta de la cuenta configurada'],
                        [bankAccount.companiesRecord, 'Este cuenta no tiene una empresa asignada'],
                        [payroll.data.class, 'Debe poner el numero de clase de nomina']
                    ];
                    for (var d = 0; d < validations.length; d++) {
                        var validation = validations[d];
                        if (angular.isUndefined(validation[0])) {
                            throw validation[1];
                        }
                    }
                    var query = AppF.root.child('catalogs/companiesRecords/collection/' + bankAccount.companiesRecord + '/data/businessName').once('value');
                    query.then(function (snap) {
                        if (!snap.exists()) {
                            throw 'Esta empresa no tiene la razón social';
                        }
                        var thisCenter = AppF.center.toUpperCase();

                        var fileName = $filter('getDispFileName')('DISP_' + thisCenter, undefined, bankAccount, payroll, calendar, period);
                        var data = {
                            success: {
                                head: {
                                    businessName: snap.val(),
                                    consecutive: consecutive,
                                    date: date,
                                    class: payroll.data.class,
                                    clientNumber: bankAccount.clientNumber,
                                    account: bankAccount.account,
                                    description: 'P' + period.period
                                },
                                body: []
                            },
                            error: [],
                            filename: fileName
                        };

                        var totalAmount = 0;
                        var defaultPaymentForm = paymentForms.find(function (value) {
                            return value.key === 'transfer';
                        });
                        for (var i = 0; i < employees.length; i++) {
                            try {
                                var employee = allEmployeesO[employees[i].$id];
                                var totals = $filter('discountDispersionExempts')(calc[employee.$id], processId);
                                var total = totals.totalNoExempts;
                                var card;
                                try {
                                    card = $filter('getEmployeeAccount')(employee, processId, operationType, defaultPaymentForm._id);
                                } catch (error) {
                                    var thisError;
                                    if (params.areAll) {
                                        $log.debug(error);
                                    } else {
                                        thisError = error;
                                    }
                                    throw thisError;
                                }
                                if (total > 0 && card.bank === bankAccount.bank) {
                                    if ([9, 10, 11, 18].indexOf(card.thisAccount.toString().length) === -1) {
                                        throw 'El empleado ' + employee.data.name + ' no tiene una cuenta valida';
                                    }
                                    var totalNumber = $filter('roundNumber')(total);
                                    data.success.body.push({
                                        employeeId: employees[i].$id,
                                        account: card.thisAccount + '',
                                        totalAmount: Math.round(totalNumber * 100) + ''
                                    });
                                    totalAmount = totalAmount + totalNumber;

                                }
                            } catch (error) {
                                if (angular.isDefined(error)) {
                                    data.error.push(error);
                                }
                            }
                        }
                        data.success.head.totalAmount = Math.round(totalAmount * 100) + '';
                        resolve(data);

                    }).catch(reject);
                } catch (error) {
                    reject(error);
                }
            });

        };
    }
}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getDataForLayoutsBajio', getDataForLayoutsBajio);

    function getDataForLayoutsBajio($filter) {
        return function getDataForLayoutsBajioFn(params) {
            return new Promise(function (resolve, reject) {
                try {
                    var bankAccount = params.bankAccount;
                    var date = params.date;
                    var consecutive = params.consecutive;
                    var paymentForms = params.paymentForms;
                    var employees = params.employees;
                    var allEmployeesO = params.allEmployeesO;
                    var processId = params.tabSelected;
                    var operationType = params.operationType;
                    var calc = params.calc;

                    var validations = [
                        [date, 'Seleccione la fecha en la que realizara la dispersion'],
                        [consecutive, 'No se inserto el consecutivo necesario para la dispersion'],
                        [bankAccount.affinityGroup, 'Se necesita el numero de grupo de afinidad'],
                        [bankAccount.account, 'Se necesita el numero de cuenta de la empresa configurada']
                    ];
                    for (var d = 0; d < validations.length; d++) {
                        var validation = validations[d];
                        if (angular.isUndefined(validation[0])) {
                            throw validation[1];
                        }
                    }
                    var defaultPaymentForm = paymentForms.find(function (value) {
                        return value.key === 'transfer';
                    });


                    var data = {
                        success:
                        {
                            head: {
                                consecutive: consecutive,
                                aplicationDate: date,
                                affinityGroup: bankAccount.affinityGroup,
                                account: bankAccount.account.toString(),
                                numberConsecutive: '010000001030S900',
                                valorBody: '02000000',
                                referencia: bankAccount.reference
                            },
                            body: []
                        },
                        error: []
                    }

                    for (var i = 0; i < employees.length; i++) {
                        try {
                            var employee = allEmployeesO[employees[i].$id];
                            var totals = $filter('discountDispersionExempts')(calc[employee.$id], processId);
                            var total = totals.totalNoExempts;
                            var card;
                            card = $filter('getEmployeeAccount')(employee, processId, operationType, defaultPaymentForm._id);
                            var lengthBank = bankAccount.bankData.accountLength ? bankAccount.bankData.accountLength : 10;
                            if (total > 0 && card.bank === bankAccount.bank) {

                                if (card.thisAccount.toString().length !== lengthBank) {
                                    throw 'El empleado ' + employee.data.name + ' no tiene los dígitos de la cuenta valida';
                                }
                                var totalNumber = $filter('roundNumber')(total);


                                // var arrayName = [employee[i].names];
                                // if (employee[i].paternalSurname) {
                                //     arrayName.push(employee[i].paternalSurname)
                                // }
                                // if (employee[i].maternalSurname) {
                                //     arrayName.push(employee[i].maternalSurname)
                                // }
                                // var finalName = arrayName.join(' ');

                                data.success.body.push({
                                    employeeNames: employees[i].$id,
                                    account: card.thisAccount,
                                    amount: totalNumber
                                });

                            }
                        } catch (error) {
                            if (angular.isDefined(error)) {
                                data.error.push(error);
                            }
                        }

                    }

                    resolve(data)

                } catch (error) {
                    reject(error);
                }
            });

        };
    }
}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getDataForLayoutsAztecaSpei', getDataForLayoutsAztecaSpei);

    function getDataForLayoutsAztecaSpei(AppF, DataF, $log, $filter) {

        return function getDataForLayoutsAztecaSpeiFn(params) {
            return new Promise(function (resolve, reject) {

                try {
                    var payroll = params.payroll ? params.payroll.fb : undefined;
                    var employees = params.employees;
                    var allEmployeesO = params.allEmployeesO;
                    var period = params.period ? params.period.fb : undefined;
                    var calc = params.calc;
                    var processId = params.tabSelected;
                    var banks = params.banks;
                    var operationType = params.operationType;
                    var paymentForms = params.paymentForms;
                    var bankAccount = params.bankAccount;
                    var validations = [
                        [bankAccount.loadAccountNumber, 'Se necesita el numero de cuenta cargo'],
                        [bankAccount.nameLoadAccountNumber, 'Se necesita el nombre del titular cuenta cargo'],
                        [bankAccount.rfcHolder, 'Se necesita el rfc del titular'],
                        [bankAccount.beneficiaryAccountType, 'Se necesita el tipo de cuenta beneficiario '],
                        [bankAccount.paymentLegend, 'Se necesita leyenda de abono'],
                        [bankAccount.chargeLegend, 'Se necesita leyenda de cargo']
                    ];
                    for (var d = 0; d < validations.length; d++) {
                        var validation = validations[d];
                        if (angular.isUndefined(validation[0])) {
                            throw validation[1];
                        }
                    }
                    var data = {
                        success:
                        {
                            head: {
                                period: period.period,
                                namePayroll: payroll.data.name,
                                center: payroll.center,
                                classPayroll: payroll.data.class,
                                cuentaCargo: bankAccount.loadAccountNumber,
                                nombreCuentaCargo: bankAccount.nameLoadAccountNumber,
                                rfcTitular: bankAccount.rfcHolder,
                                tipoCuentaBeneficiario: bankAccount.beneficiaryAccountType,
                                leyendaAbono: bankAccount.paymentLegend,
                                leyendaCargo: bankAccount.chargeLegend
                            },
                            body: []
                        },
                        error: []
                    }
                    var defaultPaymentForm = paymentForms.find(function (value) {
                        return value.key === 'transfer';
                    });
                    for (var i = 0; i < employees.length; i++) {
                        try {
                            var employee = allEmployeesO[employees[i].$id];
                            var totals = $filter('discountDispersionExempts')(calc[employee.$id], processId);
                            var total = totals.totalNoExempts;
                            var card;
                            try {
                                card = $filter('getEmployeeAccount')(employee, processId, operationType, defaultPaymentForm._id);
                            } catch (error) {
                                var thisError;
                                if (params.areAll) {
                                    $log.debug(error);
                                } else {
                                    thisError = error;
                                }
                                throw thisError;
                            }
                            if (total > 0 && card.thisAccount.toString().length === 18) {
                                if (!$filter('getFromObject')(employee, 'data.employeeNumber', false)) {
                                    throw 'El empleado ' + employee.data.name + ' no tiene asignado un numero de empleado';
                                }
                                var employeeBank = card.bank;
                                if (angular.isUndefined(employeeBank) || employeeBank === '') {
                                    throw 'El empleado ' + employee.data.name + ' no tiene un banco seleccionado';
                                }
                                var thisBank = banks.find(function (item) {
                                    return item._id === employeeBank;
                                });
                                if (angular.isUndefined(thisBank) || angular.isUndefined(thisBank.extraFields) || angular.isUndefined(thisBank.extraFields.azteca)) {
                                    throw 'El banco del empleado ' + employee.data.name + ' con el banco ' + thisBank.name + ' no tienen el código para el layout';
                                }
                                var roundTotal = $filter('roundNumber')(total) * 100 / 100;
                                if (('' + roundTotal).length > 15) {
                                    throw 'El empleado ' + employee.data.name + ' excede los 13 dígitos de los números enteros de totales';
                                }
                                data.success.body.push({
                                    employeeId: employees[i].$id,
                                    account: card.thisAccount,
                                    total: roundTotal,
                                    bankCode: thisBank.extraFields.azteca
                                });
                            }
                        } catch (error) {
                            if (angular.isDefined(error)) {
                                data.error.push(error);
                            }
                        }
                    }
                    resolve(data)

                } catch (error) {
                    reject(error);
                }
            });
        };
    }
}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .controller('SendPayrollReceiptController', SendPayrollReceiptController);

    function SendPayrollReceiptController($scope, $log, $mdDialog, errAlertS, $rootScope, ApiV2F, ApiV3F, selected, operationRef, AppF, operation) {
        var vm = this;
        vm.close = function () { $mdDialog.hide(); };

        vm.sentList = [];
        vm.sentCount = 0;
        vm.employeesData = [];
        vm.unsynced = [];
        vm.sendReceipt
        var selMap = Object.create(null);
        for (var i = 0; i < (selected || []).length; i++) {
            var s = selected[i] || {};
            var sid = s.$id || s.id;
            if (sid) selMap[sid] = s;
        }

        function receiptsSent() {
            vm.sentList = []; vm.employeesData = []; vm.unsynced = []; vm.sentCount = 0;
            if (!selected || !selected.length) return;

            var tasks = [];
            var ids = [];

            for (var k = 0; k < selected.length; k++) {
                var emp = selected[k] || {};
                var id = emp.$id || emp.id;
                if (!id) continue;

                (function (idCopy) {
                    tasks.push(Promise.all([
                        AppF.root.child(operationRef + '/' + idCopy).once('value'), // operación
                        AppF.root.child('catalogs/employees/collection/' + idCopy + '/sync/execute/humand').once('value') // flag
                    ]));
                    ids.push(idCopy);
                })(id);
            }

            Promise.all(tasks).then(function (pairs) {
                for (var j = 0; j < pairs.length; j++) {
                    var id = ids[j];
                    var sel = selMap[id] || {};
                    var name = (sel.data && sel.data.name) || sel.name || id;
                    var opSnap = pairs[j][0];
                    var humandSnap = pairs[j][1];
                    var opNode = opSnap.exists() ? (opSnap.val() || {}) : {};
                    vm.sendReceipt = true;
                    var isSynced = !!opNode.receiptSentHumand;
                    var canSend = humandSnap.exists() && !!humandSnap.val();

                    if (isSynced) {
                        vm.sentList.push({ id: id, name: name, sent: opNode.receiptSentHumand, _sending: false, operation: (operation && operation.$id) || null });
                    } else if (canSend) {
                        vm.employeesData.push({ idEmployee: id, data: { name: name }, operationId: (operation && operation.$id) || null });
                    } else {
                        vm.unsynced.push({ id: id, data: { name: name } });
                    }
                }

                vm.sentCount = vm.sentList.length;
                $scope.$applyAsync();
                $log.info('Enviados (sincronizados):', vm.sentList);
                $log.info('Por enviar (flag humand):', vm.employeesData);
                $log.info('Sin flag humand:', vm.unsynced);
            }).catch(function (err) {
                $log.error('receiptsSent error:', err);
            });
        }

        vm.resendOne = function ($index, emp) {
            if (!emp || !emp.id) return;
            emp._sending = true;

            AppF.root.child('catalogs/employees/collection/' + emp.id + '/sync/execute/humand')
                .once('value')
                .then(function (snap) {
                    var canSend = snap.exists() && !!snap.val();
                    if (!canSend) {
                        errAlertS('No se puede reenviar, por que el empleado no esta sincronizado con humand')
                        return;
                    }
                    vm.sentList.splice($index, 1);
                    vm.sentCount = vm.sentList.length;
                    var exists = false;
                    for (var i = 0; i < vm.employeesData.length; i++) {
                        var e = vm.employeesData[i] || {};
                        var eid = e.$id || e.id || e.idEmployee;
                        if (eid === emp.id) {
                            exists = true; break;
                        }
                    }
                    if (!exists) {
                        var original = selMap[emp.id];
                        var name = (original && original.data && original.data.name) || emp.name || emp.id;
                        vm.employeesData.push({ idEmployee: emp.id, data: { name: name }, operationId: (operation && operation.$id) || null });
                    }
                })
                .catch(function (err) {
                    $log.error('resendOne error:', err);
                })
                .finally(function () {
                    emp._sending = false;
                    $scope.$applyAsync();
                });
        };
        vm.confirm = function () {
            if (!vm.employeesData || !vm.employeesData.length) return;

            vm.sending = true;

            var tasks = vm.employeesData.map(function (emp) {
                emp._sending = true;
                emp._ok = false;
                emp._error = false;
                var thisData = { employeeId: emp.idEmployee, operationId: emp.operationId };
                return ApiV3F.post('syncApps/sendBill/humand', thisData)
                    .then(function (resp) {
                        if (!(resp && angular.isDefined(resp.data.id))) {
                            var err = resp.data;
                            emp._error = angular.isObject(err) ? err.msg || err.message || err.error : JSON.stringify(err);
                            return;
                        }
                        var today = moment().valueOf();
                        var ref = AppF.root.child(
                            operationRef + '/' + emp.idEmployee + '/receiptSentHumand'
                        );
                        return ref.set(today).then(function () {
                            vm.sendReceipt = true;
                            var idx = vm.employeesData.indexOf(emp);
                            emp._ok = true;
                            if (idx > -1) {
                                vm.employeesData.splice(idx, 1);
                            }
                            var name = (emp.data && emp.data.name) || emp.name || emp.idEmployee;

                            vm.sentList.push({ id: emp.idEmployee, name: name, sent: today, _sending: false, operation: (operation && operation.$id) || null });
                            vm.sentCount = vm.sentList.length;
                            if ($scope && $scope.$applyAsync) {
                                $scope.$applyAsync();
                            }
                        });
                    })
                    .catch(function (err) {
                        if (err.data) {
                            err = err.data
                        }
                        emp._error = angular.isObject(err) ? err.msg || err.message || err.error : JSON.stringify(err);;
                        $log.error('sync error', err);
                    })
                    .finally(function () {
                        emp._sending = false;
                        if ($scope && $scope.$applyAsync) $scope.$applyAsync();
                    });
            });

            Promise.all(tasks).then(function () {
                vm.sending = false;
                if ($scope && $scope.$applyAsync) {
                    $scope.$applyAsync();
                }
            });
        };

        function init() {
            receiptsSent();
            vm.selected = selected;
            $log.log(vm.sentCount)
        }

        init();
    }
})();

(function () {
    'use strict';
    angular
        .module('app.clients')
        .filter('validateEvents', validateEvents)

    function validateEvents(AppF, objsToArrayFilter, getActiveEmployeesFilter, $log, $q, loopEachFilter, DataF) {

        return validateEventsFn;

        function validateEventsFn(records, employees, employeeEvents) {
            return new Promise(function (resolve, reject) {
                if (angular.isUndefined(employees)) {
                    employees = {};
                }
                if (angular.isUndefined(employeeEvents)) {
                    employeeEvents = {};
                }
                var processed = [];
                var employeeNumbers = [];
                records = records.sort(function (a, b) {
                    return a.Empleado - b.Empleado;
                });
                for (var r = 0; r < records.length && processed.length < 20; r++) {
                    if (!records[r].processed) {
                        records[r].processed = true;
                        if (!angular.isArray(records[r].errors)) {
                            records[r].errors = [];
                        }
                        if (records[r].errors.length === 0) {
                            processed.push(r);
                            if (employeeNumbers.indexOf(records[r].Empleado) === -1 && !employees.hasOwnProperty(records[r].Empleado)) {
                                employeeNumbers.push(records[r].Empleado);
                            }
                        }
                    }
                }
                if (processed.length === 0) {
                    resolve(records);
                } else {
                    var params = {
                        'data.employeeNumber': angular.toJson({ $in: employeeNumbers }),
                        'project': angular.toJson({ 'data.name': 1, 'data.employeeNumber': 1, 'fid': 1, 'data.enroleDate': 1, 'data.seniorityDate': 1 })
                    };
                    DataF.api.get('employees', params).then(function (resp) {
                        for (var r = 0; r < resp.data.length; r++) {
                            var employee = resp.data[r];
                            employees[employee.data.employeeNumber] = employee;
                        }
                        var newProcessed = [];
                        var employeeIds = {};
                        for (var p = 0; p < processed.length; p++) {
                            var index = processed[p];
                            var record = records[index];
                            if (employees.hasOwnProperty(record.Empleado)) {
                                record.employee = angular.fromJson(angular.toJson(employees[record.Empleado]));
                                var enroleDate = record.employee.data.seniorityDate ? record.employee.data.seniorityDate : record.employee.data.enroleDate;
                                if (record.Fecha.valueOf() < enroleDate) {
                                    record.errors.push('La fecha del evento no puede ser menor a la fecha de alta/antigüedad del empleado')
                                }
                            } else {
                                record.errors.push('No se encontró el empleado');
                            }
                            if (record.errors.length === 0) {
                                newProcessed.push(index);
                                if ((!employeeIds.hasOwnProperty(record.employee.fid)) && (!employeeEvents.hasOwnProperty(record.employee.fid))) {
                                    employeeIds[record.employee.fid] = DataF.models.action('salaries', 'getVacationsEvents/' + record.employee.fid, {})
                                }
                            }
                        }
                        processed = newProcessed;
                        var promise = Object.keys(employeeIds).length > 0 ? $q.all(employeeIds) : Promise.all([]);
                        return promise;
                    }).then(function (resp) {
                        if (!angular.isArray(resp)) {
                            loopEachFilter(resp, function (data, index) {
                                employeeEvents[index] = data.data;
                            })
                        }
                        for (var p = 0; p < processed.length; p++) {
                            var index = processed[p];
                            var record = records[index];
                            record.events = employeeEvents[record.employee.fid];
                        }
                        resolve(validateEventsFn(records, employees, employeeEvents));
                    }).catch(reject);
                }
            })
        }
    }
}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .controller('vacationsRecordsHumandController', vacationsRecordsHumandController);

    function vacationsRecordsHumandController($scope, ListsF, ApiV3F, $rootScope, AppF, $mdDialog, DataF, $filter, errAlertS, successAlertS, $log, selected, $q) {
        var vm = this;
        vm.L = ListsF;
        vm.employeeNotBalanced = [];
        vm.employeeNoSync = [];
        vm.employeeBalanced = [];

        function isHumandEnabled(emp) {
            return emp && emp.sync && emp.sync.execute && emp.sync.execute.humand;
        }

        function employeeVacationHumand(employee) {
            var totalVacation = (employee && employee.data && employee.data.lastHolEv) ? employee.data.lastHolEv.total : 0;
            vm.tdsystemDaysHolidays = totalVacation;

            return ApiV3F.get('syncApps/getHolidaysBalance/humand/' + employee.$id)
                .then(function (resp) {
                    var data = resp && resp.data ? resp.data.currentBalance : undefined;
                    if (data === totalVacation) {
                        vm.employeeBalanced.push(employee);
                    } else {
                        employee.humanDaysHolidays = data;
                        vm.employeeNotBalanced.push(employee);
                    }
                })
                .catch(function (error) {
                    employee.errorMessage = (error && error.data && error.data.message) || 'No esta sincronizado con humand';
                    vm.employeeNoSync.push(employee);
                });
        }

        function synchronizedHumand() {
            $rootScope.loadingProgress = true;

            if (!selected || !selected.length) {
                $rootScope.loadingProgress = false;
                if ($scope && $scope.$applyAsync) $scope.$applyAsync();
                return;
            }

            var jobs = [];
            angular.forEach(selected, function (emp) {
                if (isHumandEnabled(emp)) {
                    jobs.push(employeeVacationHumand(emp));
                } else {
                    emp.errorMessage = 'Por favor de sincronizar con humand';
                    vm.employeeNoSync.push(emp);
                }
            });

            $q.all(jobs).finally(function () {
                $rootScope.loadingProgress = false;
                if ($scope && $scope.$applyAsync) $scope.$applyAsync();
            });
        }

        vm.close = function () {
            $mdDialog.hide();
        };

        vm.sendBalance = function () {
            if (!vm.employeeNotBalanced || !vm.employeeNotBalanced.length) return;
            $rootScope.loadingProgress = true;
            var syncPromises = [];
            var pending = angular.copy(vm.employeeNotBalanced);
            angular.forEach(pending, function (emp) {
                var p = ApiV3F.get('syncApps/syncHolidays/humand/' + emp.$id)
                    .then(function (resp) {
                        if (resp && resp.data && resp.data.success) {
                            for (var i = 0; i < vm.employeeNotBalanced.length; i++) {
                                if (vm.employeeNotBalanced[i].$id === emp.$id) {
                                    vm.employeeNotBalanced.splice(i, 1);
                                    break;
                                }
                            }
                            vm.employeeBalanced.push(emp);
                        }
                    })
                    .catch(function (error) {
                        $log.warn('errores de sync humand', error);
                        emp.errorMessage = 'Error al sincronizar con Humand';
                    });
                syncPromises.push(p);
            });
            $q.all(syncPromises).finally(function () {
                $rootScope.loadingProgress = false;
                if ($scope && $scope.$applyAsync) $scope.$applyAsync();
            });
        };

        function init() { synchronizedHumand(); }
        init();

        $log.log('Entro por el records humand');
    }
})();

(function () {
    'use strict';

    angular
        .module('app.clients')
        .controller('ImportEventsController', ImportEventsController);

    function ImportEventsController($scope, ListsF, $log, $rootScope, AppF, $mdDialog, DataF, $filter, errAlertS, successAlertS, $timeout) {
        var vm = this;
        vm.L = ListsF;
        vm.eventTypes = AppF.eventTypes;
        var currentStep = 1;
        vm.permissionToAccessAllPayrolls = AppF.permissionToAccessAllPayrolls;
        vm.headersError = false;
        $scope.close = function () {
            $mdDialog.hide();
        };
        function uploadCsv() {
            var files = vm.filesArray;
            if (angular.isArray(files) && files.length > 0) {
                vm.loading = true;
                var formData = new FormData();
                formData.append('file', files[0].lfFile);
                var promises = [
                    DataF.files.csvToJson(formData)
                ];
                Promise.all(promises).then(function (resp) {
                    $log.log(resp);
                    var data = resp[0].data.map(function (item, index) {
                        item.recordNumber = index + 1;
                        item.Empleado = ('' + item.Empleado).replace(new RegExp(',', 'g'), '')
                        item.Cantidad = ('' + item.Cantidad).replace(new RegExp(',', 'g'), '')
                        item.Empleado = parseInt(item.Empleado);
                        item.Cantidad = parseFloat(item.Cantidad);
                        item.Evento = parseInt(item.Evento);
                        item.Fecha = moment(item.Fecha, 'DD-MM-YYYY');
                        item.errors = [];
                        if (isNaN(item.Empleado)) {
                            item.errors.push('Numero de empleado no valido')
                        }
                        if (isNaN(item.Cantidad)) {
                            item.errors.push('Formato de cantidad no valido')
                        }
                        if (!item.Fecha.isValid()) {
                            item.errors.push('La fecha no es valida')
                        }
                        var ids = vm.eventTypes.map(function (item) {
                            return item.id;
                        })
                        var eventTypeId = ids.indexOf(item.Evento)
                        if (eventTypeId === -1) {
                            item.errors.push('El tipo de evento no es valido')
                        } else {
                            item.eventType = vm.eventTypes[eventTypeId];
                        }
                        return item;
                    });
                    return $filter('validateEvents')(data);
                }).then(function (data) {
                    vm.data = data;
                    vm.loading = false;
                    $scope.$evalAsync(function () {
                        $timeout(function () { }, 0, false);
                    });
                }).catch(function (error) {
                    errAlertS(error);
                    vm.loading = false;
                    $scope.$evalAsync(function () {
                        $timeout(function () { }, 0, false);
                    });
                });
            }
        }
        function saveEventsOfEmployee(recordsToSave) {
            return new Promise(function (resolve, reject) {
                if (recordsToSave.length === 0) {
                    resolve(true);
                } else {
                    try {
                        var thisEmployee = recordsToSave.pop();
                        var events = thisEmployee.events.filter(function (item) {
                            return item.fixed;
                        });
                        var eventsToSave = thisEmployee.eventsToSave.reduce(function (current, item) {
                            var thisEvent = { date: item.Fecha.valueOf(), event: item.eventType.realName };
                            thisEvent[item.eventType.property] = item.Cantidad;
                            if (thisEvent.event === 'Aniversario') {
                                thisEvent.year = parseInt(item.Fecha.format('YYYY'))
                            }
                            var index = current.findIndex(function (thisItem) {
                                var flag = false;
                                if (thisItem.event === thisEvent.event) {
                                    flag = thisEvent.event === 'Aniversario' ? thisEvent.year === thisItem.year : thisEvent.date === thisItem.date;
                                }
                                return flag;
                            })
                            if (index > -1) {
                                current[index] = thisEvent;
                            } else {
                                current.push(thisEvent);
                            }
                            return current;
                        }, events);
                        eventsToSave = eventsToSave.map(function (item) {
                            var obj = {
                                event: item.event,
                                date: item.date
                            };
                            var property = ['earned', 'prescribed', 'enjoyed'];
                            for (var p = 0; p < property.length; p++) {
                                var thisProperty = property[p];
                                if (item.hasOwnProperty(thisProperty)) {
                                    obj[thisProperty] = item[thisProperty];
                                }
                            }
                            return obj;
                        })
                        eventsToSave = eventsToSave.sort(function (a, b) {
                            return a.date - b.date;
                        });
                        var promise = AppF.root.child('catalogs/employees/collection/' + thisEmployee.employeeId + '/vacationsEvents').set(eventsToSave)
                        promise.then(function () {
                            resolve(saveEventsOfEmployee(recordsToSave));
                        }).catch(reject)
                    } catch (error) {
                        reject(error);
                    }
                }
            });
        }

        vm.saveEvents = function () {
            vm.loading = true;
            var recordsToSave = vm.data.filter(function (item) {
                return (!item.hasOwnProperty('errors')) || item.errors.length === 0;
            }).reduce(function (current, record) {
                var index = current.findIndex(function (item) { return item.employeeId === record.employee.fid; })
                if (index === -1) {
                    index = current.length;
                    current.push({ employeeId: record.employee.fid, events: record.events, eventsToSave: [] })
                }
                current[index].eventsToSave.push(record);
                return current;
            }, []);
            $log.log(recordsToSave);
            $scope.$evalAsync();
            saveEventsOfEmployee(recordsToSave).then(function () {
                vm.loading = false;
                successAlertS('Se importaron los eventos con éxito');
                $mdDialog.hide();
            }).catch(errAlertS).then(function () {
                vm.loading = false;
                $scope.$evalAsync(function () {
                    $timeout(function () { }, 0, false);
                });
            });
        };
        var stepperChange = $rootScope.$on('stepCalled', function (event, step) {
            if (step === 2 && currentStep === 1) {
                uploadCsv();
            }
            currentStep = step;
        });
        var onDestroy = $rootScope.$on('$destroy', function () {
            stepperChange();
            onDestroy();
        });
    }
})();
(function(){
    'use strict';

    angular
        .module('app.core')
        .filter('cardsBelongToBanorte', cardsBelongToBanorte)

    function cardsBelongToBanorte(

    ){

        return cardsBelongToBanorteFn;

        /**
         * @description Checa si la tarjeta (16 digitos) de todos los empleados que se mandan sean de Banorte y que estén preparados para Interface
         * @param {Employee[]} employees 
         * @param {Boolean|null} dontValidate (opcional) 
         * @returns {Boolean | Object} True o Objeto con problemas detectados por cada empleado
         */
        function cardsBelongToBanorteFn(employees, dontValidate){
            dontValidate = (angular.isDefined(dontValidate)) ? dontValidate : false;
            var problems = {};
            var problem = false;
            var fiscalIssuer = false;
            for(var e in employees){
                if(!fiscalIssuer) fiscalIssuer = employees[e]['payroll-fiscalIssuer'];
                if(employees[e].data){
                    if(employees[e].data.cards){
                        if(employees[e].data.cards[0]){
                            if(['581fc77f1c77d8d33925ea3d'].indexOf(employees[e].data.cards[0].bank) == -1){
                                problem = true;
                                problems[employees[e].$id] = 'su tarjeta no pertenece a Banorte';
                                if(dontValidate) return false;
                            } // TODO: mejorar forma de verificar banco
                            if((employees[e].data.cards[0].number + '').length !== 16){
                                problem = true;
                                problems[employees[e].$id] = 'su tarjeta no tiene 16 dígitos';
                                if(dontValidate) return false;
                            }
                            if(!employees[e].data.cards[0].emit){
                                problem = true;
                                problems[employees[e].$id] = 'su cuenta es para vinculación';
                                if(dontValidate) return false;
                            }
                            if(employees[e]['payroll-fiscalIssuer'] !== fiscalIssuer){
                                problem = true;
                                problems[employees[e].$id] = 'tiene una emisora fiscal distinta';
                                if(dontValidate) return false;
                            }
                        }
                    }
                }
            }
            return (problem) ? problems : true;
        }
    }

}());
(function(){
    'use strict';

    angular
        .module('app.core')
        .filter('cardsBelongToBancomer', cardsBelongToBancomer)

    function cardsBelongToBancomer(

    ){

        return cardsBelongToBancomerFn;

        /**
         * @description Checa si la tarjeta (16 digitos) de todos los empleados que se mandan sean de Bancomer y que estén preparados para Interface
         * @param {Employee[]} employees 
         * @returns {Boolean}
         */
        function cardsBelongToBancomerFn(employees){
            for(var e in employees){
                if(employees[e].data){
                    if(employees[e].data.cards){
                        if(employees[e].data.cards[0]){
                            if(['58ce51ef23552a1c2c216507'].indexOf(employees[e].data.cards[0].bank) == -1 // TODO: mejorar forma de verificar banco
                            || (employees[e].data.cards[0].number * '').length !== 16
                            || !employees[e].data.cards[0].emit){
                                return false;
                            }
                        }
                    }
                }
            }
            return true;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.employees', [])
        .config(employees);

    /** @ngInject */
    function employees(
        $stateProvider,
        $translatePartialLoaderProvider
    ) {
        // State
        $stateProvider
            .state('app.captures', {
                abstract: true,
                url: '/captures'
            })
            .state('app.movements', {
                abstract: true,
                url: '/movements'
            })
            .state('app.rh', {
                abstract: true,
                url: '/rh'
            })
            // employees
            .state('app.captures.employees', {
                url: '/employees/:payrollId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employees/views/employees/employees.html',
                        controller: 'MongoListsController'
                    }
                },
                bodyClass: 'employees'
            })

            .state('app.captures.employees.enrole', {
                url: '/enrole/:employeeId/:movementId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employees/views/employees/employee.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'employees'
            })
            .state('app.captures.employees.reEntry', {
                url: '/reEntry/:employeeId/:movementId',
                params: {
                    forCurp: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employees/views/employees/reentry.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'employees'
            })
            .state('app.captures.employees.dismiss', {
                url: '/dismiss/:employeeId/:movementId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employees/views/dismissesRecords/dismissesRecord.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'employees'
            })

            .state('app.captures.employees.mds', {
                url: '/mds/:employeeId/:movementId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employees/views/mdsRecords/mdsRecord.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'employees'
            })
            .state('app.captures.employees.read', {
                url: '/read/:employeeId/:movementId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employees/views/employees/employee.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'employees'
            })
            .state('app.captures.employees.update', {
                url: '/update/:employeeId/:movementId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employees/views/employees/employee.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'employees'
            })
            .state('app.captures.employees.especialEdit', {
                url: '/especialEdit/:employeeId/:movementId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employees/views/employees/special.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'employees'
            })
            // logs
            .state('app.movements.logs', {
                url: '/logs/:payrollId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employees/views/logs/logs.html',
                        controller: 'MongoListsController'
                    }
                },
                bodyClass: 'employees'
            })
            // movements
            .state('app.movements.movements', {
                url: '/movements/:payrollId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employees/views/movements/movements.html',
                        controller: 'MongoListsController'
                    }
                },
                bodyClass: 'employees'
            })
            .state('app.movements.movements.read', {
                url: '/read/:employeeId/:movementId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employees/views/movements/movement.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'employees'
            })
            .state('app.movements.movements.update', {
                url: '/update/:employeeId/:movementId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employees/views/movements/movement.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'employees'
            })
            .state('app.movements.movements.createHistoricMovement', {
                url: '/createHistoricMovement/:movementId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employees/views/movements/movement-historic.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'employees'
            })
            // credits
            .state('app.captures.credits', {
                url: '/credits/:payrollId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employees/views/credits/credits.html',
                        controller: 'MongoListsController'
                    }
                },
                bodyClass: 'employees'
            })
            .state('app.captures.credits.create', {
                url: '/create/:creditId/:payrollId/:employeeId/:type/:factor/:comments/:noCredit',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employees/views/credits/credit.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'employees'
            })
            .state('app.captures.credits.read', {
                url: '/read/:employeeId/:creditId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employees/views/credits/credit.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'employees'
            })
            .state('app.captures.credits.update', {
                url: '/update/:employeeId/:creditId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employees/views/credits/credit.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'employees'
            })
            // groupings
            .state('app.captures.groupings', {
                url: '/groupings',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employees/views/groupings/groupings.html',
                        controller: 'FBListsController'
                    }
                },
                bodyClass: 'employees'
            })
            .state('app.captures.groupings.create', {
                url: '/create/:groupingId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employees/views/groupings/grouping.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'employees'
            })
            .state('app.captures.groupings.read', {
                url: '/read/:groupingId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employees/views/groupings/grouping.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'employees'
            })
            .state('app.captures.groupings.update', {
                url: '/update/:groupingId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employees/views/groupings/grouping.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'employees'
            })
            .state('app.captures.loans', {
                url: '/loans',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employees/views/loans/loans.html',
                        controller: 'FBListsController'
                    }
                },
                bodyClass: 'employees'
            })
            .state('app.captures.loans.create', {
                url: '/create/:loanId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employees/views/loans/loan.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'employees'
            })
            .state('app.captures.loans.read', {
                url: '/read/:employeeId/:loanId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employees/views/loans/loan.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'employees'
            })
            .state('app.captures.loans.update', {
                url: '/update/:employeeId/:loanId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employees/views/loans/loan.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'employees'
            })
            .state('app.rh.contracts', {
                url: '/contracts',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employees/views/contracts/contracts.html',
                        controller: 'MongoListsController'
                    }
                },
                bodyClass: 'contracts'
            })
            .state('app.rh.contracts.edit', {
                url: '/:contractId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employees/views/contracts/contract.html',
                        controller: 'MongoDetailController'
                    }
                },
                bodyClass: 'contracts'
            })

            .state('app.rh.employeeBirths', {
                url: '/employeeBirths/:payrollId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employees/views/employeeBirths/employeeBirths.html',
                        controller: 'MongoListsController'
                    }
                },
                bodyClass: 'employeeBirths'
            })
            .state('app.rh.employeeBirths.read', {
                url: '/read/:employeeId/:movementId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employees/views/employeeBirths/employeeBirth.html',
                        controller: 'MongoDetailController'
                    }
                },
                bodyClass: 'employees'
            })

            .state('app.rh.anniversaryEmployees', {
                url: '/anniversaryEmployees/:payrollId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employees/views/anniversaryEmployees/anniversaryEmployees.html',
                        controller: 'MongoListsController'
                    }
                },
                bodyClass: 'anniversaryEmployees'
            })
            .state('app.rh.anniversaryEmployees.read', {
                url: '/read/:employeeId/:movementId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employees/views/anniversaryEmployees/anniversaryEmployee.html',
                        controller: 'MongoDetailController'
                    }
                },
                bodyClass: 'anniversaryEmployees'
            })

            .state('app.rh.saludRecords', {
                url: '/saludRecords',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employees/views/saludRecords/saludRecords.html',
                        controller: 'MongoListsController'
                    }
                },
                bodyClass: 'saludRecords'
            })
            .state('app.rh.saludRecords.edit', {
                url: '/:saludRecordId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employees/views/saludRecords/saludRecord.html',
                        controller: 'MongoDetailController'
                    }
                },
                bodyClass: 'saludRecords'
            })
            // healthcareRecords
            .state('app.rh.employeesVacationsRecords', {
                url: '/employeesVacationsRecords/',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employees/views/employeesVacationsRecords/employeesVacationsRecords.html',
                        controller: 'MongoListsController'
                    }
                },
                bodyClass: 'employees'
            })
            .state('app.rh.employeesVacationsRecords.read', {
                url: '/read/:employeeId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employees/views/employeesVacationsRecords/employeesVacationsRecord.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'employees'
            })
            .state('app.rh.employeesVacationsRecords.update', {
                url: '/update/:employeeId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employees/views/employeesVacationsRecords/employeesVacationsRecord.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'employees'
            })
            .state('app.rh.personalInfoEmployees', {
                url: '/personalInfoEmployees',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employees/views/personalInfoEmployees/personalInfoEmployees.html',
                        controller: 'MongoListsController'
                    }
                },
                bodyClass: 'employees'
            })
            .state('app.rh.personalInfoEmployees.read', {
                url: '/read/:employeeId/:movementId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employees/views/personalInfoEmployees/personalInfoEmployee.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'employees'
            })
            .state('app.rh.personalInfoEmployees.update', {
                url: '/update/:employeeId/:movementId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employees/views/personalInfoEmployees/personalInfoEmployee.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'employees'
            })
            .state('app.rh.employeeFiles', {
                url: '/employeeFiles',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employees/views/employeeFiles/employeeFiles.html',
                        controller: 'MongoListsController'
                    }
                },
                bodyClass: 'employees'
            })
            .state('app.rh.employeeFiles.read', {
                url: '/read/:employeeId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employees/views/employeeFiles/employeeFile.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'employees'
            })
            .state('app.rh.employeeFiles.update', {
                url: '/update/:employeeId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employees/views/employeeFiles/employeeFile.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'employees'
            })
            .state('app.rh.documentTypes', {
                url: '/documentTypes',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employees/views/documentTypes/documentTypes.html',
                        controller: 'MongoListsController'
                    }
                },
                bodyClass: 'documentTypes'
            })
            .state('app.rh.documentTypes.edit', {
                url: '/:documentTypeId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employees/views/documentTypes/documentType.html',
                        controller: 'MongoDetailController'
                    }
                },
                bodyClass: 'documentTypes'
            })
            // noEmployees
            .state('app.rh.kardexEmployees', {
                url: '/kardexEmployees',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employees/views/kardexEmployees/kardexEmployees.html',
                        controller: 'MongoListsController'
                    }
                },
                bodyClass: 'employees'
            })
            .state('app.rh.kardexEmployees.read', {
                url: '/read/:employeeId/:movementId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employees/views/kardexEmployees/kardexEmployee.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'employees'
            })
            // enroles & re-entrys
            .state('app.movements.enroles', {
                url: '/enroles',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employees/views/enroles/enroles.html',
                        controller: 'FBListsController'
                    }
                },
                bodyClass: 'employees'
            })
            .state('app.movements.enroles.read', {
                url: '/read/:employeeId/:movementId?redirectTo',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employees/views/employees/employee.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'employees'
            })
            .state('app.movements.enroles.update', {
                url: '/update/:employeeId/:movementId?redirectTo',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employees/views/enroles/enrole.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'employees'
            })
            // dismisses
            .state('app.movements.dismissesRecords', {
                url: '/dismissesRecords',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employees/views/dismissesRecords/dismissesRecords.html',
                        controller: 'FBListsController'
                    }
                },
                bodyClass: 'employees'
            })
            .state('app.movements.dismissesRecords.read', {
                url: '/read/:employeeId/:movementId?redirectTo',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employees/views/dismissesRecords/dismissesRecord.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'employees'
            })
            .state('app.movements.dismissesRecords.update', {
                url: '/update/:employeeId/:movementId?redirectTo',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employees/views/dismissesRecords/dismissesRecord.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'employees'
            })
            .state('app.movements.idseAutoRecords', {
                url: '/idseAutoRecords',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employees/views/idseAutoRecords/idseAutoRecords.html',
                        controller: 'MongoListsController'
                    }
                },
                bodyClass: 'employees'
            })
            .state('app.movements.idseAutoRecords.update', {
                url: '/update/:employeeId/:movementId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employees/views/idseAutoRecords/idseAutoRecord.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'employees'
            })
            // dismissesUnconfirmed
            .state('app.movements.dismissesUnconfirmedRecords', {
                url: '/dismissesUnconfirmedRecords',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employees/views/dismissesUnconfirmedRecords/dismissesUnconfirmedRecords.html',
                        controller: 'FBListsController'
                    }
                },
                bodyClass: 'employees'
            })
            .state('app.movements.dismissesUnconfirmedRecords.read', {
                url: '/read/:employeeId/:movementId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employees/views/dismissesUnconfirmedRecords/dismissesUnconfirmedRecord.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'employees'
            })
            .state('app.movements.dismissesUnconfirmedRecords.update', {
                url: '/update/:employeeId/:movementId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employees/views/dismissesUnconfirmedRecords/dismissesUnconfirmedRecord.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'employees'
            })
            // mds
            .state('app.movements.mdsRecords', {
                url: '/mdsRecords',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employees/views/mdsRecords/mdsRecords.html',
                        controller: 'FBListsController'
                    }
                },
                bodyClass: 'employees'
            })
            .state('app.movements.mdsRecords.read', {
                url: '/read/:employeeId/:movementId?redirectTo',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employees/views/mdsRecords/mdsRecord.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'employees'
            })
            .state('app.movements.mdsRecords.update', {
                url: '/update/:employeeId/:movementId?redirectTo',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employees/views/mdsRecords/mdsRecord.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'employees'
            })
            // variables
            .state('app.movements.variables', {
                url: '/variables',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employees/views/variables/variables.html',
                        controller: 'FBListsController'
                    }
                },
                bodyClass: 'employees'
            })
            .state('app.movements.variables.read', {
                url: '/read/:employeeId/:movementId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employees/views/movements/movement.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'employees'
            })
            // enroleAccounts
            .state('app.movements.enroleAccounts', {
                url: '/enroleAccounts',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employees/views/enroleAccounts/enroleAccounts.html',
                        controller: 'FBListsController'
                    }
                },
                bodyClass: 'employees'
            })
            // aniversaryRecords <- nuevo
            .state('app.movements.aniversaryRecords', {
                url: '/aniversaryRecords/:payrollId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employees/views/aniversaryRecords/aniversaryRecords.html',
                        controller: 'FBListsController'
                    }
                },
                bodyClass: 'employees',
                params: {
                    payrollId: 'all'
                }
            })
            .state('app.movements.aniversaryRecords.apply', {
                url: '/apply/:aniversaryRecordId/:date/:sd/:sbc',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employees/views/aniversaryRecords/aniversaryRecord.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'employees'
            })
            // healthcareRecords
            .state('app.captures.healthcareRecords', {
                url: '/healthcareRecords/:payrollId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employees/views/healthcareRecords/healthcareRecords.html',
                        controller: 'MongoListsController'
                    }
                },
                bodyClass: 'employees'
            })
            .state('app.captures.healthcareRecords.read', {
                url: '/read/:employeeId/:movementId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employees/views/employees/employee.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'employees'
            })
            // idseRecords
            .state('app.movements.idseRecords', {
                url: '/idseRecords',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employees/views/idseRecords/idseRecords.html',
                        controller: 'FBListsController'
                    }
                },
                bodyClass: 'employees'
            })
            .state('app.movements.idseRecords.read', {
                url: '/read/:employeeId/:movementId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employees/views/movements/movement.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'employees'
            })
            // noEmployees
            .state('app.captures.noEmployees', {
                url: '/noEmployees/:payrollId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employees/views/noEmployees/noEmployees.html',
                        controller: 'MongoListsController'
                    }
                },
                bodyClass: 'employees'
            })
            .state('app.captures.noEmployees.read', {
                url: '/read/:employeeId/:movementId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employees/views/employees/employee.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'employees'
            })
            // realSalaryRecords
            .state('app.captures.realSalaryRecords', {
                url: '/realSalaryRecords/:payrollId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employees/views/realSalaryRecords/realSalaryRecords.html',
                        controller: 'MongoListsController'
                    }
                },
                bodyClass: 'employees'
            })
            .state('app.captures.realSalaryRecords.read', {
                url: '/read/:employeeId/:movementId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employees/views/employees/employee.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'employees'
            })
            // revisions
            .state('app.movements.revisions', {
                url: '/revisions',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employees/views/revisions/revisions.html',
                        controller: 'FBListsController'
                    }
                },
                bodyClass: 'employees'
            })
            .state('app.movements.revisions.review', {
                url: '/review/:employeeId/:movementId?redirectTo',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employees/views/revisions/revision.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'employees'
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/employees');
    }
})();
(function () {
    'use strict';

    angular
        .module('app.employees')
        .controller('UploadManyFilesController', UploadManyFilesController);

    /** @ngInject */
    function UploadManyFilesController($scope, $rootScope, $timeout, $log, errAlertS, $q, AppF, ListsF, $mdDialog, getFromObjectFilter, ApiV2F, $http, $window, $document) {
        var vm = this;
        var processing = false;
        var uploading = false;
        var results = {};
        vm.allFiles = [];
        vm.docTypes = [];
        vm.allFilesByEmployee = [];
        vm.showUpload = true;
        vm.permissionToAccessAllPayrolls = AppF.permissionToAccessAllPayrolls;
        vm.allPayrolls = ListsF.allPayrolls;
        vm.payrolls = ListsF.payrolls;
        function hide() {
            $mdDialog.hide();
        }
        function processFiles() {
            vm.showUpload = false;
            $rootScope.loadingProgress = true;
            vm.allFiles = vm.allFiles.concat(vm.massiveFiles);
            $rootScope.$evalAsync();
            $timeout(function () {
                vm.massiveFilesApi.removeAll();
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
                $timeout(function () {
                    validateFiles();
                }, 0)
            }, 0)
        }

        function downlandKeys(path, params) {
            $log.log('params', path, params)
            var obj = {
                center: AppF.center
            }
            $log.log('entro por la descarga');
            $rootScope.loadingProgress = true;
            var promises = []
            promises.push($http({
                method: 'POST',
                url: $window.__env.serviceWorkerUrl + "interface/getkeys",
                responseType: 'arraybuffer',
                data: obj
            }));

            Promise.all(promises).then(function (response) {
                $log.log('response', response);
                if (response.length > 0) {
                    for (var r = 0; r < response.length; r++) {
                        var headers = response[r].headers();
                        var filename = headers['x-filename'] || 'archivo.csv';
                        var contentType = headers['content-type'] || 'text/csv';

                        try {
                            var blob = new Blob([response[r].data], {
                                type: contentType
                            });
                            var url = $window.URL.createObjectURL(blob);
                            var linkElement = $document[0].createElement('a');
                            linkElement.setAttribute('href', url);
                            linkElement.setAttribute('download', filename);
                            linkElement.click();
                            $rootScope.loadingProgress = false;
                            $rootScope.$evalAsync(function () {
                                $log.debug('generatePdf finished');
                            });
                        } catch (ex) {
                            $log.error("Error creando el archivo:", ex);
                            throw ex + " error descargando el archivo";
                        }
                    }
                } else {
                    throw "No se pudo descargar archivo";
                }
            }).catch(function (err) {
                var error;
                try {
                    if (angular.isString(err)) {
                        error = err;
                    } else {
                        var message = new TextDecoder("utf-8").decode(err.data);
                        error = angular.fromJson(message);
                    }
                } catch (e) {
                    error = "Ocurrió un error desconocido al intentar decodificar la respuesta.";
                }
                errAlertS(error);
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
            });

        }
        function uploadingFiles() {
            if (!uploading) {
                uploading = true;
                var promises = [];
                for (var f = 0; f < vm.allFiles.length && promises.length < 1; f++) {
                    if (vm.allFiles[f].ready && !vm.allFiles[f].uploading) {
                        vm.allFiles[f].uploading = true;
                        promises.push(uploadingFile(vm.allFiles[f]));
                    }
                }
                if (promises.length > 0) {
                    $rootScope.loadingProgress = true;
                    Promise.all(promises).then(function () {
                        uploading = false;
                        uploadingFiles();
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync();
                        $timeout(function () { }, 0)
                    }).catch(function (error) {
                        errAlertS(error);
                        uploading = false;
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync();
                        $timeout(function () { }, 0)
                    });
                } else {
                    uploading = false;
                }
            }
        }
        function uploadingFile(thisFile) {
            return new Promise(function (resolve) {
                try {
                    var queries = {};
                    if ((angular.isUndefined(results['employeeFiles' + thisFile.data.employee.$id]) || (!angular.isArray(results['employeeFiles' + thisFile.data.employee.$id]))) && angular.isUndefined(queries['employeeFiles' + thisFile.data.employee.$id])) {
                        queries['employeeFiles' + thisFile.data.employee.$id] = ListsF.loadList('employeeFiles', 'catalogs/employeeFiles/collection/' + thisFile.data.employee.$id, undefined, 'array', 'employeeForFiles' + thisFile.data.employee.$id);
                    }
                    var query = Object.keys(queries).length === 0 ? Promise.all([]) : $q.all(queries);
                    var employeeFileId;
                    var optimizedTask;
                    query.then(function (resp) {
                        if (!angular.isArray(resp)) {
                            for (var r in resp) {
                                results[r] = resp[r];
                            }
                        }
                        thisFile.data.files = results['employeeFiles' + thisFile.data.employee.$id];
                        $log.log(thisFile.data.files);
                        var promises = [];
                        if (angular.isArray(thisFile.data.files) && thisFile.data.files.$loaded()) {
                            promises.push(thisFile.data.files.$loaded());
                        }
                        return Promise.all(promises);
                    }).then(function () {
                        var thisFiles = angular.isArray(thisFile.data.files) ? thisFile.data.files : [];
                        var hasOther = thisFiles.findIndex(function (item) {
                            return item.documentType === thisFile.data.documentType.key;
                        });
                        var doIt = (thisFile.data.documentType.allowMany || (!thisFile.data.documentType.allowMany && hasOther === -1)) ? true : false;
                        if (!doIt) {
                            throw 'Solo se puede tener un documento de este tipo'
                        }
                        employeeFileId = thisFile.data.documentType.key + '_' + moment().format('YYMMDDHHss');
                        var obj = { '$id': thisFile.data.employee.$id };
                        return $rootScope.C.uploadFile([thisFile], obj, employeeFileId, false, true);
                    }).then(function (imageObj) {
                        var update = {
                            employeeId: thisFile.data.employee.$id,
                            path: imageObj.path,
                            url: imageObj.url,
                            documentType: thisFile.data.documentType.key,
                            created: $rootScope.D.getTimeObject()
                        };
                        optimizedTask = { "type": "five-queue", "action": "optimizePdf", url: imageObj.path }
                        return $rootScope.F.root.child('catalogs/employeeFiles/collection/' + thisFile.data.employee.$id + '/' + employeeFileId).update(update);
                    }).then(function () {
                        thisFile.uploaded = true;
                        if (angular.isDefined(optimizedTask)) {
                            return ApiV2F.post('tasks/add', optimizedTask)
                        } else {
                            return Promise.all([]);
                        }
                    }).then(function () {
                        resolve();
                    }).catch(function (error) {
                        thisFile.error = AppF.getErrorMessage(error);
                        resolve();
                    })
                } catch (error) {
                    thisFile.error = AppF.getErrorMessage(error);
                    resolve();
                }
            })

        }
        function validateFiles() {
            if (!processing) {
                processing = true;
                var promises = [];
                for (var f = 0; f < vm.allFiles.length && promises.length < 5; f++) {
                    if (!vm.allFiles[f].process) {
                        vm.allFiles[f].process = true;
                        promises.push(validateFile(vm.allFiles[f]));
                    }
                }
                if (promises.length > 0) {
                    $rootScope.loadingProgress = true;
                    Promise.all(promises).then(function () {
                        processing = false;
                        validateFiles();
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync();
                        $timeout(function () { }, 0)
                    }).catch(function (error) {
                        errAlertS(error);
                        processing = false;
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync();
                        $timeout(function () { }, 0)
                    });
                } else {
                    processing = false;
                    var dictionary = {};
                    var filesGrouped = vm.allFiles.reduce(function (current, item) {
                        var employeeName = getFromObjectFilter(item, 'data.employee.data.name', 'SIN EMPLEADO');
                        if (dictionary[employeeName] > -1) {
                            current[dictionary[employeeName]].push(item);
                        } else {
                            dictionary[employeeName] = current.length;
                            current.push([item]);
                        }
                        return current;
                    }, []);
                    vm.allFilesByEmployee = Object.keys(dictionary).sort(function (a, b) {
                        if (a === 'SIN EMPLEADO') {
                            return 1;
                        } else if (b === 'SIN EMPLEADO') {
                            return -1;
                        } else {
                            return a.localeCompare(b);
                        }
                    }).map(function (name) {
                        var obj = {};
                        obj.name = name;
                        obj.files = filesGrouped[dictionary[name]];
                        return obj;
                    })
                    $log.log(vm.allFilesByEmployee);
                }
            }
        }
        function validateFile(thisFile) {
            return new Promise(function (resolve) {
                try {
                    thisFile.process = true;
                    var queries = {};
                    var fileNameArray = thisFile.lfFileName.split('_');
                    if (thisFile.lfFile.size > 4000000) {
                        throw "El archivo excede el tamaño permitido"
                    }
                    if (fileNameArray.length < 2) {
                        throw 'Nombre no tiene formato valido para procesarlo';
                    }
                    var documentTypeKey = fileNameArray[1].split('.')[0];
                    thisFile.data = { employeeNumber: parseFloat(fileNameArray[0]), documentTypeKey: documentTypeKey };
                    var number;
                    if (fileNameArray.length >= 3) {
                        var thisNumber = parseInt(fileNameArray[2]);
                        if ((!isNaN(thisNumber)) && isFinite(thisNumber)) {
                            number = thisNumber
                        }
                    }
                    thisFile.data.number = number;
                    if (isNaN(thisFile.data.employeeNumber) || !isFinite(thisFile.data.employeeNumber)) {
                        throw 'Formato de numero de empleado invalido';
                    }
                    if (angular.isUndefined(results['employeeNumber' + thisFile.data.employeeNumber]) && angular.isUndefined(queries['employeeNumber' + thisFile.data.employeeNumber])) {
                        queries['employeeNumber' + thisFile.data.employeeNumber] = AppF.root.child('catalogs/employees/collection').orderByChild('data/employeeNumber').equalTo(thisFile.data.employeeNumber).once('value')
                    }
                    var thisPromise = Object.keys(queries).length === 0 ? Promise.all([]) : $q.all(queries);
                    thisPromise.then(function (resp) {
                        if (!angular.isArray(resp)) {
                            for (var r in resp) {
                                results[r] = [];
                                resp[r].forEach(function (childSnap) {
                                    var obj = childSnap.val();
                                    obj.$id = childSnap.key;
                                    results[r].push(obj)
                                });
                            }
                        }
                        var employee = results['employeeNumber' + thisFile.data.employeeNumber];
                        if (angular.isUndefined(employee) || employee.length === 0) {
                            throw 'No se encontró el empleado';
                        } else if (employee.length > 1) {
                            throw 'Se encontró diferentes empleados con el mismo numero';
                        }
                        thisFile.data.employee = employee[0];
                        var documentTypeIndex = vm.docTypes.findIndex(function (item) {
                            return item.key.toLowerCase() === thisFile.data.documentTypeKey.toLowerCase();
                        });
                        if (documentTypeIndex === -1) {
                            throw 'No se encontró el tipo de documento';
                        }
                        thisFile.data.documentType = vm.docTypes[documentTypeIndex];
                        if (angular.isNumber(thisFile.data.number) && !thisFile.data.documentType.allowMany) {
                            throw 'No se permiten varios documentos de este tipo';
                        }
                        thisFile.ready = true;
                        resolve(true);
                    }).catch(function (error) {
                        thisFile.error = AppF.getErrorMessage(error);
                        resolve();
                    })
                } catch (error) {
                    thisFile.error = AppF.getErrorMessage(error);
                    resolve();
                }
            });
        }
        function payrollUpdated() {
            vm.docTypes = [];
            if (vm.payroll) {
                $rootScope.loadingProgress = true;
                var query = AppF.root.child('catalogs/payrolls/collection/' + vm.payroll + '/firm').once('value');
                var firm;
                query.then(function (resp) {
                    if (!resp.exists()) {
                        throw 'No se encuentra el dato de la empresa';
                    }
                    firm = resp.val();
                    var queryM = { center: AppF.center, type: angular.toJson({ $in: ['generals', 'generalsRequired'] }), project: angular.toJson({ allowMany: 1, type: 1, name: 1, firm: 1, key: 1 }), firm: angular.toJson({ $in: ['global', firm] }) };
                    return $rootScope.D.api.get('documentTypes', queryM)
                }).then(function (resp) {
                    var allDocTypes = resp.data;
                    var docTypes = allDocTypes.filter(function (item) {
                        return [firm, 'global'].indexOf(item.firm) > -1;
                    });
                    vm.docTypes = docTypes;
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync()
                }).catch(function (error) {
                    $log.error(error);
                    errAlertS(error);
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync()
                });
            }
        }
        vm.processFiles = processFiles;
        vm.center = AppF.center;
        vm.payrollUpdated = payrollUpdated;
        vm.uploadingFiles = uploadingFiles;
        vm.downlandKeys = downlandKeys;
        vm.hide = hide;
    }
}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .controller('disableValidationsForEmployeesController', disableValidationsForEmployeesController);

    function disableValidationsForEmployeesController(
        $log,
        $mdDialog,
        selected,
        AppF,
        $rootScope,
        successAlertS
    ) {
        var vm = this;
        $log.log('entro por el controlador de de disableValidationsForEmployees')
        function init() {
            vm.selected = selected;
            $log.log(selected)
        }

        vm.deleteValidEmployees = function () {
            $rootScope.loadingProgress = true;
            for (var i = 0; i < selected.length; i++) {
                var idEmployee = selected[i];
                AppF.root.child('catalogs/employees/collection/' + idEmployee.$id + '/ignoreValidation').set(vm.validations);
                $log.log(selected[i]);
            }
            $rootScope.loadingProgress = false;
            $rootScope.$evalAsync();
            $mdDialog.hide();
            successAlertS('Validaciones deshabilitadas con éxito' + ' ' + selected.length + ' ' + 'empleados');

        }
        vm.cancel = function () {
            $mdDialog.hide();
        }
        init();
    }
}
)();


(function () {
    'use strict';

    angular
        .module('app.employees')
        .controller('ImportCreditsController', ImportCreditsController);

    /** @ngInject */
    function ImportCreditsController($mdDialog, $q, locals, $log, DataF, AppF, $scope, scope, ApiV3F, $rootScope, successAlertS, $timeout, errAlertS) {
        var vm = this;
        vm.preview = false;
        vm.downloadTemplate = downloadTemplate;
        vm.onFilePicked = onFilePicked;
        vm.valid = [];
        vm.errors = [];

        function downloadTemplate() {
            // AJUSTADO: Las cabeceras ahora están en camelCase para ser consistentes.
            var content =
                "claseNomina,numeroEmpleado,fechaDeInicio,tipoCredito,factorCredito,numeroCredito,comentarios\n" +
                "NOMINA_A,EMP001,2025-10-25,cuota fija,1500.00,CRD-0001,Descuento quincenal\n" +
                "NOMINA_A,EMP002,2025-10-28,porcentaje,900.00,CRD-0002,\n";
            var blob = new Blob([content], { type: "text/csv;charset=utf-8;" });
            var a = document.createElement('a');
            a.href = URL.createObjectURL(blob);
            a.download = "credits_template_import.csv";
            a.click();
            URL.revokeObjectURL(a.href);
        }

        /**
         * NO SE NECESITAN CAMBIOS AQUÍ.
         * La lógica de $q.all sigue siendo válida porque la nueva validación
         * está ahora encapsulada dentro de la promesa que devuelve `validEmployees`.
         */
        function onFilePicked(files) {
            if (!files || !files.length) return;
            var fd = new FormData();
            fd.append('file', files[0]);

            vm.preview = true;
            vm.valid = [];
            vm.errors = [];
            $rootScope.loadingProgress = true;

            ApiV3F.post('files/preview', fd, true).then(function (resp) {
                var rows = resp.data.rows;

                var promises = rows.map(function (row) {
                    // Creamos una cadena de promesas unificada para cada fila.
                    // Esto nos permite manejar tanto validaciones síncronas como asíncronas
                    // con un solo bloque .catch().

                    return $q.when() // Inicia la cadena de promesas.
                        .then(function () {
                            // ===============================================================
                            // PASO 1: Nueva validación síncrona (10 dígitos).
                            // ===============================================================
                            if (!row.numeroCredito || String(row.numeroCredito).trim().length !== 10) {
                                // Si falla, rechazamos la promesa. Esto detiene la cadena aquí
                                // y salta directamente al bloque .catch() de abajo.
                                return $q.reject('El Número de Crédito ingresado **' + row.numeroCredito + '** ' + 'debe tener 10 dígitos.');
                            }
                            // ===============================================================

                            // PASO 2: Si la validación anterior pasó, continuamos con las
                            // validaciones asíncronas que ya teníamos.
                            return $q.all({
                                employeeValidation: validEmployees(row),
                                payroll: validPayroll(row.claseNomina)
                            });
                        })
                        .then(function (results) {
                            $log.log('Validaciones exitosas para', results.payroll);
                            // PASO 3 (ÉXITO): Este bloque solo se ejecuta si TODAS las
                            // validaciones anteriores (síncronas y asíncronas) fueron exitosas.
                            vm.valid.push({
                                payroll: row.claseNomina,
                                idPayroll: results.payroll.payrollId,
                                dateInit: row.fechaDeInicio,
                                numberEmployee: row.numeroEmpleado,
                                comentarios: row.comentarios,
                                typeCredit: row.tipoCredito,
                                factorCredit: row.factorCredito,
                                numeroCredito: row.numeroCredito,
                                name: results.employeeValidation.employeeData.data.name,
                                idEmployee: results.employeeValidation.employeeData.fid,
                                rp: results.employeeValidation.employeeData.rp,
                                validCredit: results.employeeValidation.activarCredito,
                                sd: results.employeeValidation.employeeData.data.salary.sd ? results.employeeValidation.employeeData.data.salary.sd : 0,
                                sbc: results.employeeValidation.employeeData.data.salary.sbc ? results.employeeValidation.employeeData.data.salary.sbc : 0,
                                sdr: results.employeeValidation.employeeData.data.salary.sdr ? results.employeeValidation.employeeData.data.salary.sdr : 0,
                                nss: results.employeeValidation.employeeData.data.nss ? results.employeeValidation.employeeData.data.nss : 'N/A',
                                cc: results.employeeValidation.employeeData.cc
                            });
                        })
                        .catch(function (errorMsg) {
                            // PASO FINAL (ERROR): Este bloque .catch() atrapará CUALQUIER
                            // error que ocurra en CUALQUIER punto de la cadena.
                            vm.errors.push({
                                error: errorMsg,
                                data: row
                            });
                        });
                });

                // Espera a que todas las filas terminen de procesarse (éxito o error).
                $q.all(promises).finally(function () {
                    $rootScope.loadingProgress = false;
                });

            }).catch(function (err) {
                $log.error('preview error', err);
                $rootScope.loadingProgress = false;
            });
        }

        /**
         * AJUSTADO: Ahora encadena la validación de créditos.
         * Esta función solo se resuelve si el empleado existe Y el crédito es válido.
         */
        function validEmployees(credit) {
            var employees = credit.numeroEmpleado;
            var numParsed = Number(employees);
            var filter = isFinite(numParsed) ? numParsed : employees;
            var params = {
                'data.employeeNumber': angular.toJson({ $in: [filter] }),
                'project': angular.toJson({ 'data.name': 1, 'data.nss': 1, 'data.employeeNumber': 1, 'data.salary.sd': 1, 'data.salary.sbc': 1, 'data.salary.sdr': 1, 'cc': 1, 'fid': 1, 'rp': 1 })
            };

            return DataF.api.get('employees', params).then(function (resp) {
                if (resp.data.length) {
                    var employeeData = resp.data[0];
                    // Llama a `validCredits` para obtener la bandera
                    return validCredits(employeeData.fid, credit.fechaDeInicio).then(function (activar) {
                        $log.log('Empleado válido:', employeeData, 'Activar crédito:', activar);
                        // Resuelve la promesa con un objeto que contiene ambas piezas de información.
                        return {
                            employeeData: employeeData,
                            activarCredito: activar
                        };
                    });
                } else {
                    return $q.reject('El empleado "' + employees + '" no existe.');
                }
            });
        }

        function validPayroll(classPayrolls) {
            $log.log('Validando clase de nómina', classPayrolls);
            return $q(function (resolve, reject) {
                AppF.root.child('catalogs/payrolls/collection').orderByChild('data/class').equalTo(classPayrolls).once('value').then(function (snap) {
                    if (snap.exists()) {
                        var obj = {
                            payrollId: Object.keys(snap.val())[0]
                        }
                        resolve(obj);

                    } else {
                        reject('La clase de nómina "' + classPayrolls + '" no existe.');
                    }
                }, function (error) {
                    reject('Error al validar la clase de nómina: ' + error.message);
                });
            });
        }

        /**
         * AJUSTADO: Ahora rechaza la promesa si el crédito no es válido.
         * Esto permite que el .catch() en onFilePicked funcione correctamente.
         */
        function validCredits(idEmployee, dateCredit) {
            return DataF.api.get('credits', { employee: idEmployee }).then(function (resp) {
                var newCreditDate = moment(dateCredit).startOf('day').valueOf();
                // Por defecto, el crédito se activa.
                var activar = true;
                for (var i = 0; i < resp.data.length; i++) {
                    var existingCreditDate = moment(resp.data[i].data.date).startOf('day').valueOf();
                    if (newCreditDate <= existingCreditDate) {
                        $log.log(newCreditDate)
                        activar = false;
                        break;
                    }
                }
                return activar;
            });
        }


        vm.import = function () {
            // 1. Verificamos si hay algo que importar.
            if (!vm.valid || vm.valid.length === 0) {
                errAlertS('No hay créditos válidos para importar'); // Opcional: mostrar alerta
                return;
            }

            $rootScope.loadingProgress = true;

            // 2. Creamos un arreglo que contendrá todas las promesas de guardado.
            var importPromises = vm.valid.map(function (employee) {
                var query = {
                    center: AppF.center,
                    created: DataF.getTimeObject(),
                    data: {
                        account: employee.numeroCredito,
                        factor: employee.factorCredit,
                        name: employee.name,
                        nss: employee.nss,
                        sd: employee.sd,
                        sdr: employee.sdr,
                        sbc: employee.sbc,
                        type: employee.typeCredit
                    },
                    employee: employee.idEmployee,
                    payroll: employee.idPayroll,
                    rp: employee.rp,
                    valid: employee.validCredit,
                    cc: employee.cc,
                    detailExtra: 'Fue importado este credito'
                };
                $log.log('Preparando importación para empleado:', employee.numberEmployee);

                // 3. Agregamos la promesa de guardado al arreglo.
                return AppF.root.child('catalogs/credits/collection').push(query);
            });

            // 4. Usamos $q.all para esperar a que TODAS las promesas del arreglo se completen.
            $q.all(importPromises).then(function () {
                // ÉXITO: Este bloque se ejecuta solo si TODOS los créditos se guardaron correctamente.
                successAlertS('Éxito: Todos los ' + vm.valid.length + ' créditos fueron importados, por favor de recargar.');
                $log.log('Éxito: Todos los ' + vm.valid.length + ' créditos fueron importados.');

                // Aquí puedes mostrar una notificación de éxito (ej. un toast).
                // AppF.toast.show('¡' + vm.valid.length + ' créditos importados con éxito!');


            }).catch(function (error) {
                // ERROR: Este bloque se ejecuta si ALGUNA de las operaciones de guardado falla.
                $log.error('Error durante la importación de créditos:', error);

                // Aquí debes mostrar una notificación de error al usuario.
                // AppF.toast.showError('Ocurrió un error. La importación no pudo completarse.');

            }).finally(function () {
                // FINALMENTE: Este bloque se ejecuta siempre, ya sea éxito o error.
                // Es el lugar perfecto para ocultar el indicador de carga.
                $rootScope.loadingProgress = false;
                $timeout(function () { $rootScope.$evalAsync(); }, 0, false);
                $mdDialog.hide();
            });
        };

        $scope.close = function () {
            $mdDialog.hide();
        }

        vm.close = function () {
            $mdDialog.hide();
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('getEmpInfonavitData', getEmpInfonavitData)

    function getEmpInfonavitData($localStorage, ApiV2F, DataF, AppF, $log) {

        return getEmpInfonavitDataFn;

        function getDataFromStorage(thisValue, thisAction) {
            var data;
            if (thisAction === 'validate') {
                var key = thisAction + thisValue;
                var storedData = $localStorage[key];
                try {
                    storedData = angular.fromJson(storedData)
                } catch (error) {
                    $log.log(error);
                    storedData = undefined;
                }
                if (angular.isDefined(storedData) && storedData.data && storedData.data.data) {
                    var storedTime = moment(storedData.timestamp);
                    var now = moment();
                    if (now.diff(storedTime, 'days') < 10) {
                        data = storedData.data;
                    } else {
                        delete $localStorage[key];
                    }
                }
            }
            return data;
        }

        // /catalogs/employees / collection / -LfCXsYPFasnDxQSA3jx / data / enroleDate
        function validateEmployee(thisValue, action) {
            return new Promise(function (resolve, reject) {
                if (action === 'download') {
                    try {
                        var params = {
                            employee: thisValue,
                            sort: '-created.atTime',
                            size: 2,
                            project: angular.toJson({ 'created.atTime': 1, 'data.date': 1 })
                        };
                        $log.log('id del empleado', thisValue)
                        DataF.api.get('p/credits', params).then(function (resp) {
                            var credits = resp.data.data;
                            AppF.root.child('catalogs/employees/collection/' + thisValue + '/data/enroleDate').once('value').then(function (snap) {
                                var enroleDate = snap.val();
                                var creditDate = credits[0].data.date;
                                var minorDate = moment(enroleDate).isBefore(creditDate) ? enroleDate : creditDate;
                                if (credits.length === 1) {
                                    var thisDate = moment(minorDate).add(5, 'days');
                                    if (thisDate.valueOf() > AppF.serverTimeStamp) {
                                        throw 'El crédito debe tener al menos 5 días de antigüedad para poder descargar el aviso';
                                    }
                                }
                            }).catch(reject)
                            var flag = true;
                            resolve(flag)
                        }).catch(reject)
                    } catch (error) {
                        reject(error);
                    }
                } else {
                    resolve(true);
                }
            })
        }
        function getEmpInfonavitDataFn(thisValue, action) {
            return new Promise(function (resolve, reject) {
                var creditData;
                if (angular.isDefined(thisValue)) {
                    try {
                        var promises = [];
                        validateEmployee(thisValue, action).then(function () {
                            creditData = getDataFromStorage(thisValue, action);
                            if (angular.isUndefined(creditData)) {
                                var path = (action === 'validate' ? 'employees/validateCredit/' : 'employees/getCreditData/') + thisValue
                                promises.push(ApiV2F.get(path));
                            }
                            return Promise.all(promises)
                        }).then(function (resp) {
                            if (resp.length > 0) {
                                creditData = resp[0].data;
                                if (action === 'validate' && creditData.credit) {
                                    var key = action + thisValue;
                                    $localStorage[key] = angular.toJson({ timestamp: moment().valueOf(), data: creditData });
                                }
                            }
                            resolve(creditData);
                        }).catch(reject)
                    } catch (error) {
                        reject(error);
                    }
                } else {
                    resolve(creditData);
                }
            })
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.employees')
        .controller('DisabledCreditsController', DisabledCreditsController);

    function DisabledCreditsController(selected, $mdDialog, $log, getThem, $rootScope, successAlertS, errAlertS, $timeout) {
        var vm = this;
        vm.close = function () {
            $mdDialog.cancel();
        }

        function init() {
            $log.log('creditos desactivados', selected)
        }

        function sleep(time) {
            return new Promise(function (resolve) {
                $timeout(function () {
                    resolve(true);
                }, time);
            })
        }

        vm.confirmDisable = function (liquidatedCredit) {
            var itemMsg = selected.length > 1 ? selected.length + ' créditos' : ' 1 crédito';
            var liquidatedCredits = liquidatedCredit ? liquidatedCredit : null;
            $rootScope.loadingProgress = true;
            $rootScope.$evalAsync();
            var requests = {};
            for (var c = 0; c < selected.length; c++) {
                var credit = selected[c];
                requests['catalogs/credits/collection/' + credit.$id + '/valid'] = false;
                requests['catalogs/credits/collection/' + credit.$id + '/liquidatedCredit'] = liquidatedCredits;
            }
            $rootScope.F.root.update(requests).then(function () {
                successAlertS('Se deshabilitaron ' + itemMsg + ' correctamente')
                return sleep(3000);
            }).then(function () {
                $log.log('getTheme', getThem());
                return getThem()
            }).then(function () {
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
                $mdDialog.hide();
            }).catch(function (error) {
                errAlertS(error);
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
            });
            $log.log('Entro por el modal de desactivar creditos', selected, liquidatedCredit);
        }
        $log.log('entro al modal')
        init()
    }
})();

(function () {
    'use strict';

    angular
        .module('app.employees')
        .controller('CheckCreditController', CheckCreditController);

    function CheckCreditController(action, creditData, $mdDialog, errAlertS, $rootScope, DataF, $q, AppF, ListsF, getEmpInfonavitDataFilter, $filter) {
        var vm = this;
        function close() {
            $mdDialog.cancel();
        }
        function reset() {
            delete vm.creditData;
            delete vm.selectedEmployee;
            delete vm.valueToSearch;
            delete vm.searchEmployee;
        }

        function checkCredit(thisValue) {
            $rootScope.loadingProgress = true;
            getEmpInfonavitDataFilter(thisValue, action).then(function (creditData) {
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
                vm.creditData = creditData;
            }).catch(function (error) {
                errAlertS(error);
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
            })
        }
        function descargarAviso(data) {
            var link = document.createElement('a');
            link.href = 'data:application/pdf;base64,' + data;
            link.download = 'AvisoRetención.pdf';
            link.click();
        }
        function autocompleteListM(search, catalog, fields) {
            return $q(function (resolve, reject) {
                var extraQuerys = { 'status': { '$ne': 5 }, 'data.nss': { $exists: true }, 'center': AppF.center };
                if (!AppF.permissionToAccessAllPayrolls) {
                    extraQuerys = { cc: { $in: $filter('getArrayOfIds')($filter('getFromObject')(ListsF, 'userCcs.' + AppF.profile.uid, [])) } };
                }
                DataF.api.autocompleteMongo(search, catalog, fields, extraQuerys).then(function (items) {
                    resolve(items);
                }).catch(function (err) {
                    errAlertS(err);
                    reject(err);
                });
            });
        }
        vm.title = action === 'validate' ? 'Verificar créditos Infonavit' : 'Descargar avisos Infonavit';
        vm.action = action;
        vm.creditData = creditData;
        vm.close = close;
        vm.reset = reset;
        vm.checkCredit = checkCredit;
        vm.descargarAviso = descargarAviso;
        vm.autocompleteListM = autocompleteListM;
    }
})();

(function () {
    'use strict';

    angular
        .module('app.config', [])
        .config(config);

    /** @ngInject */
    function config(
        $stateProvider,
        $translatePartialLoaderProvider
    ) {
        // State
        $stateProvider
            .state('app.config', {
                abstract: true,
                url: '/config'
            })
            .state('app.config.holidays', {
                url: '/holidays/:year',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/config/views/holidays/holidays.html',
                        controller: 'FBListsController'
                    }
                },
                bodyClass: 'config'
            })
            .state('app.config.holidays.update', {
                url: '/update/:holidayId',
                params: {
                    holiday: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/config/views/holidays/holiday.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'config'
            })
            .state('app.config.holidays.read', {
                url: '/read/:holidayId',
                params: {
                    user: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/config/views/holidays/holiday.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'config'
            })
            .state('app.config.users', {
                url: '/users/:firmId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/config/views/users/users.html',
                        controller: 'FBListsController'
                    }
                },
                params: {
                    firmId: 'all'
                },
                bodyClass: 'config'
            })
            .state('app.config.users.update', {
                url: '/update/:userId',
                params: {
                    user: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/config/views/users/user.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'config'
            })
            .state('app.config.users.read', {
                url: '/read/:userId',
                params: {
                    user: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/config/views/users/user.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'config'
            })
            .state('app.config.calcFields', {
                url: '/calcFields',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/config/views/calc-fields/calc-fields.html',
                        controller: 'FBListsController'
                    }
                },
                bodyClass: 'config'
            })
            .state('app.config.calcFields.update', {
                url: '/update/:calcFieldId',
                params: {
                    user: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/config/views/calc-fields/calc-field.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'config'
            })
            .state('app.config.calcFields.read', {
                url: '/read/:calcFieldId',
                params: {
                    user: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/config/views/calc-fields/calc-field.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'config'
            })
            .state('app.config.imports', {
                url: '/imports',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/config/views/imports/imports.html',
                        controller: 'FBListsController'
                    }
                },
                bodyClass: 'config'
            })
            .state('app.config.imports.update', {
                url: '/update/:importId',
                params: {
                    import: null,
                    imports: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/config/views/imports/import.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'config'
            })
            .state('app.config.imports.read', {
                url: '/read/:importId',
                params: {
                    import: null,
                    imports: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/config/views/imports/import.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'config'
            })
            .state('app.config.paymentSchemas', {
                url: '/paymentSchemas',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/config/views/paymentSchemas/paymentSchemas.html',
                        controller: 'FBListsController'
                    }
                },
                bodyClass: 'config'
            })
            .state('app.config.paymentSchemas.update', {
                url: '/update/:paymentSchemaId',
                params: {
                    paymentSchema: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/config/views/paymentSchemas/paymentSchema.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'config'
            })
            .state('app.config.paymentSchemas.read', {
                url: '/read/:paymentSchemaId',
                params: {
                    paymentSchema: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/config/views/paymentSchemas/paymentSchema.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'config'
            })
            .state('app.config.permissions', {
                url: '/permissions',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/config/views/permissions/permissions.html',
                        controller: 'PermissionsController',
                        controllerAs: 'PermCtrl'
                    }
                },
                bodyClass: 'config'
            })
            .state('app.config.globalNotifications', {
                url: '/globalNotifications',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/config/views/globalNotifications/globalNotification.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'config'
            })
            // .state('app.config.globalNotifications.detail', {
            //     url: '/:globalNotificationId',
            //     views: {
            //         'content@app': {
            //             templateUrl: 'app/main/config/views/globalNotifications/globalNotification.html',
            //             controller: 'FBDetailController'
            //         }
            //     },
            //     bodyClass: 'config'
            // })
            .state('app.config.notifications', {
                url: '/notifications/:profileId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/config/views/notifications/notifications.html',
                        controller: 'FBListController'
                    }
                },
                bodyClass: 'config'
            })
            .state('app.config.notifications.detail', {
                url: '/notifications',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/config/views/notifications/notification.html',
                        controller: 'FBListController'
                    }
                },
                bodyClass: 'config'
            })
            .state('app.config.profile', {
                url: '/profile',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/config/views/profile/profile.html',
                        controller: 'ProfileController'
                    }
                },
                bodyClass: 'config'
            })
            // @todo:backlog pasar esta parte de constantes a la nueva estructura
            .state('app.config.constants', {
                url: '/constants',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/config/views/constants/constants.html',
                        controller: 'ConstantsController'
                    }
                },
                bodyClass: 'config'
            })
            .state('app.config.constants.update', {
                url: '/:by/:byId/:payrollId/:constantId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/config/views/constant/constant.html',
                        controller: 'ConstantController'
                    }
                },
                bodyClass: 'config'
            })
            // @todo:backlog pasar esta parte de benefits a la nueva estructura
            .state('app.config.benefits', {
                url: '/benefits/:typeId',
                params: {
                    by: 'default'
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/config/views/benefits/benefits.html',
                        controller: 'FBListsController'
                    }
                },
                bodyClass: 'config'
            })
            .state('app.config.benefits.update', {
                url: '/update/:benefitId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/config/views/benefits/benefit.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'config'
            })
            .state('app.config.benefits.read', {
                url: '/read/:benefitId',
                params: {
                    cc: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/config/views/benefits/benefit.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'clients'
            })
            // @todo:backlog pasar esta parte de benefits a la nueva estructura
            .state('app.config.operationConstants', {
                url: '/operationConstants/:typeId',
                params: {
                    by: 'default'
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/config/views/operationConstants/operationConstants.html',
                        controller: 'FBListsController'
                    }
                },
                bodyClass: 'config'
            })
            .state('app.config.operationConstants.update', {
                url: '/update/:operationConstantId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/config/views/operationConstants/operationConstant.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'config'
            })
            .state('app.config.operationConstants.read', {
                url: '/read/:operationConstantId',
                params: {
                    cc: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/config/views/operationConstants/operationConstant.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'clients'
            })
            .state('app.config.involvedRecords', {
                url: '/involvedRecords',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/config/views/involvedRecords/involvedRecords.html',
                        controller: 'FBListsController'
                    }
                },
                bodyClass: 'config'
            })
            .state('app.config.involvedRecords.update', {
                url: '/update/:involvedRecordId',
                params: {
                    involvedRecord: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/config/views/involvedRecords/involvedRecord.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'config'
            })
            .state('app.config.involvedRecords.read', {
                url: '/read/:involvedRecordId',
                params: {
                    involvedRecord: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/config/views/involvedRecords/involvedRecord.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'config'
            })
            .state('app.config.modules', {
                url: '/modules',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/config/views/modules/modules.html',
                        controller: 'MongoListsController'
                    }
                },
                bodyClass: 'config'
            })
            .state('app.config.modules.edit', {
                url: '/:moduleId',
                params: {
                    module: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/config/views/modules/module.html',
                        controller: 'MongoDetailController'
                    }
                },
                bodyClass: 'config'
            })
            .state('app.config.groups', {
                url: '/groups',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/config/views/groups/groups.html',
                        controller: 'FBListsController'
                    }
                },
                bodyClass: 'config'
            })
            .state('app.config.groups.update', {
                url: '/update/:groupId',
                params: {
                    group: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/config/views/groups/group.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'config'
            })
            .state('app.config.groups.read', {
                url: '/read/:groupId',
                params: {
                    group: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/config/views/groups/group.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'config'
            })
            .state('app.config.incidencesTypes', {
                url: '/incidencesTypes/:payrollId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/config/views/incidences-types/incidences-types.html',
                        controller: 'FBListsController'
                    }
                },
                bodyClass: 'clients'
            })
            .state('app.config.incidencesTypes.update', {
                url: '/update/:incidencesTypeId',
                params: {
                    incidencesType: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/config/views/incidences-types/incidences-type.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'clients'
            })
            .state('app.config.incidencesTypes.read', {
                url: '/read/:incidencesTypeId',
                params: {
                    incidencesType: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/config/views/incidences-types/incidences-type.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'clients'
            })
            .state('app.config.concepts', {
                url: '/concepts/:payrollId',
                params: {
                    payrollId: 'all'
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/config/views/concepts/concepts.html',
                        controller: 'MongoListsController'
                    }
                },
                bodyClass: 'clients'
            })
            .state('app.config.concepts.update', {
                url: '/update/:conceptId',
                params: {
                    concept: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/config/views/concepts/concept.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'clients'
            })

            .state('app.config.accountingAccounts', {
                url: '/accountingAccounts',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/config/views/accountingAccounts/accountingAccounts.html',
                        controller: 'MongoListsController'
                    }
                },
                bodyClass: 'accountingAccounts'
            })
            .state('app.config.accountingAccounts.edit', {
                url: '/:accountingAccountId',
                params: {
                    accountingAccount: null,
                    accountingAccounts: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/config/views/accountingAccounts/accountingAccount.html',
                        controller: 'MongoDetailController'
                    }
                },
                bodyClass: 'accountingAccount'
            })

            .state('app.config.accountingAccounts.read', {
                url: '/read/:accountingAccountId',
                params: {
                    accountingAccount: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/config/views/accountingAccounts/accountingAccount.html',
                        controller: 'MongoDetailController'
                    }
                },
                bodyClass: 'accountingAccount'
            })

            .state('app.config.tickets', {
                url: '/tickets',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/config/views/tickets/tickets.html',
                        controller: 'MongoListsController'
                    }
                },
                bodyClass: 'tickets'
            })
            .state('app.config.tickets.edit', {
                url: '/:ticketId',
                params: {
                    ticket: null,
                    tickets: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/config/views/tickets/ticket.html',
                        controller: 'MongoDetailController'
                    }
                },
                bodyClass: 'clients'
            })
            .state('app.config.tickets.read', {
                url: '/read/:ticketId',
                params: {
                    ticket: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/config/views/tickets/ticket.html',
                        controller: 'MongoDetailController'
                    }
                },
                bodyClass: 'clients'
            })


            .state('app.config.archivedTickets', {
                url: '/archivedTickets',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/config/views/archivedTickets/archivedTickets.html',
                        controller: 'MongoListsController'
                    }
                },
                bodyClass: 'tickets'
            })
            //Conceptos
            .state('app.config.concepts.read', {
                url: '/read/:conceptId',
                params: {
                    concept: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/config/views/concepts/concept.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'clients'
            })


            //Variables accountingAccount
            .state('app.config.accountAccVars', {
                url: '/accountAccVars',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/config/views/accountAccVars/accountAccVars.html',
                        controller: 'FBListsController'
                    }
                },
                bodyClass: 'clients'
            })
            .state('app.config.accountAccVars.update', {
                url: '/update/:accountAccVarId',
                params: {
                    accountAccVar: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/config/views/accountAccVars/accountAccVar.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'clients'
            })

            .state('app.config.accountAccVars.read', {
                url: '/read/:accountAccVarId',
                params: {
                    accountAccVar: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/config/views/accountAccVars/accountAccVar.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'clients'
            })

            .state('app.config.processConfigs', {
                url: '/processConfigs',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/config/views/processConfigs/processConfigs.html',
                        controller: 'FBListsController'
                    }
                },
                bodyClass: 'clients'
            })
            .state('app.config.processConfigs.update', {
                url: '/update/:processConfigId',
                params: {
                    processConfig: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/config/views/processConfigs/processConfig.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'clients'
            })
            .state('app.config.processConfigs.read', {
                url: '/read/:processConfigId',
                params: {
                    processConfig: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/config/views/processConfigs/processConfig.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'clients'
            })
            .state('app.config.payrollConfigs', {
                url: '/payrollConfigs',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/config/views/payrollConfigs/payrollConfigs.html',
                        controller: 'FBListsController'
                    }
                },
                bodyClass: 'clients'
            })
            .state('app.config.payrollConfigs.update', {
                url: '/update/:payrollConfigId',
                params: {
                    payrollConfig: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/config/views/payrollConfigs/payrollConfig.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'clients'
            })
            .state('app.config.payrollConfigs.read', {
                url: '/read/:payrollConfigId',
                params: {
                    payrollConfig: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/config/views/payrollConfigs/payrollConfig.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'clients'
            })
            .state('app.config.customFields', {
                url: '/customFields',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/config/views/customFields/customFields.html',
                        controller: 'FBListsController'
                    }
                },
                bodyClass: 'clients'
            })
            .state('app.config.customFields.update', {
                url: '/update/:customFieldId',
                params: {
                    customField: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/config/views/customFields/customField.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'clients'
            })
            .state('app.config.customFields.read', {
                url: '/read/:customFieldId',
                params: {
                    customField: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/config/views/customFields/customField.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'clients'
            })
            .state('app.config.emailImages', {
                url: '/emailImages',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/config/views/emailImages/emailImages.html',
                        controller: 'FBListsController'
                    }
                },
                bodyClass: 'clients'
            })
            .state('app.config.emailImages.update', {
                url: '/update/:emailImageId',
                params: {
                    ticket: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/config/views/emailImages/emailImage.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'clients'
            })
            .state('app.config.emailImages.read', {
                url: '/read/:emailImageId',
                params: {
                    ticket: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/config/views/emailImages/sliderImage.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'clients'
            })
            .state('app.config.sliderImages', {
                url: '/sliderImages',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/config/views/sliderImages/sliderImages.html',
                        controller: 'FBListsController'
                    }
                },
                bodyClass: 'clients'
            })
            .state('app.config.sliderImages.update', {
                url: '/update/:sliderImageId',
                params: {
                    ticket: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/config/views/sliderImages/sliderImage.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'clients'
            })
            .state('app.config.sliderImages.read', {
                url: '/read/:sliderImageId',
                params: {
                    ticket: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/config/views/sliderImages/sliderImage.html',
                        controller: 'FBDetailController'
                    }
                },
                bodyClass: 'clients'
            })

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/config');
    }
})();
(function(){
    'use strict';

    angular
        .module('app.config')
        .filter('filterGroups', filterGroups)

    function filterGroups(){

        return filterGroupsFn;

        function filterGroupsFn(query, groups){
            var fgroups = [];
            if (query) {
                for (var gg = 0; gg < groups.length; gg++) {
                    if(groups[gg].hasOwnProperty('$id')){
                        var group = groups[gg];
                        // console.log(group, query, fgroups, groups,"WTF");
                        if (group.name.indexOf(query) !== -1) fgroups.push(group.name);
                    }
                }
            }
            return fgroups;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.config')
        .filter('availableGroups', availableGroups);

    function availableGroups($log, AppF) {

        return availableGroupsFn;

        function availableGroupsFn(groups, userFirm) {
            console.log(groups, userFirm)
            if (angular.isArray(groups) && userFirm) {
                var availableGroups = [];
                var onlyClients = [];
                for (var g = 0; g < groups.length; g++) {
                    if (groups.hasOwnProperty(g)) {
                        if (groups[g].hasOwnProperty('$id')) {
                            if (groups[g].groupForClient) {
                                onlyClients.push(groups[g]);
                            } else {
                                availableGroups.push(groups[g]);
                            }
                        }
                    }
                }
                return AppF.isDistributor(userFirm) ? availableGroups : onlyClients;
            }
            return groups;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.config')
        .controller('ChangePasswordController', ChangePasswordController);

    function ChangePasswordController($mdDialog, $rootScope, $http, userId, $window, $log, successAlertS, errAlertS) {
        var vm = this;
        vm.closeDialog = function () {
            $mdDialog.hide();
        };
        vm.validatePass = function () {
            $log.log(vm.password, vm.repassword);
            if (vm.password && vm.repassword) {
                if (vm.password === vm.repassword) {
                    vm.passwordForm['password'].$setValidity('unmatch', true);
                    vm.passwordForm['repassword'].$setValidity('unmatch', true);
                } else {
                    vm.passwordForm['password'].$setValidity('unmatch', false);
                    vm.passwordForm['repassword'].$setValidity('unmatch', false);
                }
            }
        };
        vm.doIt = function () {
            if (vm.password && vm.password !== '') {
                try {
                    $rootScope.loadingProgress = true;
                    var data = {
                        userId: userId,
                        password: vm.password
                    };
                    $http({
                        method: 'POST',
                        url: $window.__env.serviceWorkerUrl + 'fb/changeUserPassword/',
                        data: data,
                        transformRequest: function (obj) {
                            var str = [];
                            for (var p in obj) {
                                if (angular.isNumber(obj[p]) || angular.isString(obj[p])) {
                                    str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
                                } else if (angular.isObject(obj[p]) && obj[p].length) {
                                    for (var j = 0; j < obj[p].length; j++) {
                                        str.push(encodeURIComponent(p) + '=' + encodeURIComponent(angular.toJson(obj[p][j])));
                                    }
                                } else {
                                    str.push(encodeURIComponent(p) + '=' + angular.toJson(obj[p]));
                                }

                            }
                            return str.join('&');
                        },
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded'
                        }
                    }).then(function (response) {
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync();
                        $log.debug(response, 'Response for change password');
                        successAlertS('Se cambio la contraseña con éxito');
                    }, function (err) {
                        errAlertS(err);
                        $log.error(err);
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync();
                    });
                } catch (error) {
                    errAlertS(error);
                    $log.error(error);
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                }
            }
            $mdDialog.hide();
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('formTicket', formTicket);


    /** @ngInject */
    function formTicket(AppF, DataF, ListsF, $log, msNavigationService, $timeout, $q) {
        return {
            replace: true,
            scope: {
                ticket: '=',
                form: '=',
                files: '=',
                removeUpload: '=',
                editAllPermission: '='
            },
            restrict: 'E',
            templateUrl: 'app/main/config/views/tickets/forms/form-ticket.html',
            link: function ($scope) {
                $scope.F = AppF;
                $scope.L = ListsF;
                $scope.actions = {};
                $scope.addTracking = function (trackingMsg) {
                    if (!angular.isArray($scope.ticket.trackings)) {
                        $scope.ticket.trackings = [];
                    }
                    $scope.ticket.trackings.unshift({
                        msg: trackingMsg,
                        created: DataF.getTimeObject()
                    });
                    $log.log($scope.ticket.trackings);
                    delete $scope.actions.newTracking;
                    delete $scope.actions.showAddTracking;
                };
            }
        };
    }
}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .controller('ImportOperationConstantsController', ImportOperationConstantsController);

    function ImportOperationConstantsController($scope, ListsF, $log, $rootScope, AppF, $mdDialog, DataF, $filter, errAlertS, successAlertS, $timeout, permissions) {
        var vm = this;
        var currentStep = 1;
        vm.constanPeriods = AppF.constanPeriods
        vm.applicationTypes = [null, 'Aplicación automática', 'No aplicar', 'Campo personalizado'];
        $scope.close = function () {
            $mdDialog.hide();
        };
        function uploadCsv() {
            var files = vm.filesArray;
            if (angular.isArray(files) && files.length > 0) {
                vm.loading = true;
                var formData = new FormData();
                formData.append('file', files[0].lfFile);
                DataF.files.csvToJson(formData).then(function (resp) {
                    return $filter('formatAndValidateOpeConstToImport')(resp.data, permissions);
                }).then(function (data) {
                    vm.data = data;
                    vm.loading = false;
                    $scope.$evalAsync(function () {
                        $timeout(function () { }, 0, false);
                    });
                }).catch(function (error) {
                    errAlertS(error);
                    vm.loading = false;
                    $scope.$evalAsync(function () {
                        $timeout(function () { }, 0, false);
                    });
                });
            }
        }
        vm.applyCalculations = function () {
            vm.loading = true;
            $scope.$evalAsync();
            $filter('applyOperationConstants')(vm.data).then(function () {
                successAlertS('Se importaron las constantes con éxito');
                $mdDialog.hide();
            }).catch(errAlertS).then(function () {
                vm.loading = false;
                $scope.$evalAsync(function () {
                    $timeout(function () { }, 0, false);
                });
            });
        };
        var stepperChange = $rootScope.$on('stepCalled', function (event, step) {
            if (step === 2 && currentStep === 1) {
                uploadCsv();
            }
            currentStep = step;
        });
        var onDestroy = $rootScope.$on('$destroy', function () {
            stepperChange();
            onDestroy();
        });
    }
})();
(function () {
    'use strict';
    angular
        .module('app.clients')
        .filter('formatAndValidateOpeConstToImport', formatAndValidateOpeConstToImport);

    function formatAndValidateOpeConstToImport($log, ListsF, AppF, getFromObjectFilter, DataF, CatalogsF) {
        // Se mantiene el orden para que coincida con la nueva lógica de aplicación
        var permissionsType = [
            null,
            'payroll',
            'cc',
            'employee'
        ];
        var constantTypeArr = [ // Renombrado para evitar colisión con la variable local
            null,
            'automaticApply',
            'notApply',
            'customField'
        ];
        var objsConfig = [
            null,
            { obj: 'payrolls', field: 'class', idField: '$id', name: 'name' },
            { obj: 'ccs', field: '$id', idField: '$id', name: 'name' },
            { obj: 'employees', field: 'data.employeeNumber', parseInt: true, idField: 'fid', name: 'data.name' }
        ];

        function getElementToApply(objs, type, value) {
            var thisConfig = objsConfig[type];
            var thisObj = objs[thisConfig.obj].find(function (item) {
                var thisValue = getFromObjectFilter(item, thisConfig.field);
                if (thisConfig.parseInt) {
                    value = parseInt(value);
                }
                return thisValue === value;
            });
            if (angular.isDefined(thisObj)) {
                thisObj.idField = getFromObjectFilter(thisObj, thisConfig.idField);
                thisObj.name = getFromObjectFilter(thisObj, thisConfig.name);
            }
            return thisObj;
        }

        function geCCAndPayroll() {
            if (AppF.permissionToAccessAllPayrolls) {
                return undefined;
            } else {
                var ccArray = [];
                var payrollArray = [];
                if (angular.isArray(AppF.ccsByPayrollsOfUser)) {
                    for (var j = 0; j < AppF.ccsByPayrollsOfUser.length; j++) {
                        var thisPayroll = AppF.ccsByPayrollsOfUser[j];
                        if (angular.isArray(thisPayroll.ccs)) {
                            if (thisPayroll.ccs.indexOf('all') > -1) {
                                payrollArray.push(thisPayroll.$id);
                            } else {
                                ccArray = ccArray.concat(thisPayroll.ccs);
                            }
                        }
                    }
                }
                var obj = angular.toJson([{ '$or': [{ cc: { $in: ccArray } }, { payroll: { $in: payrollArray } }] }]);
                return obj;
            }
        }

        return formatAndValidateOpeConstToImportFn;

        function formatAndValidateOpeConstToImportFn(fileData, permissions) {
            return new Promise(function (resolve, reject) {
                try {
                    var data = [];
                    var objs = {
                        payrolls: AppF.permissionToAccessAllPayrolls ? ListsF.allPayrolls : ListsF.payrolls,
                        ccs: AppF.permissionToAccessAllPayrolls ? getFromObjectFilter(ListsF, 'ccs') : getFromObjectFilter(ListsF, 'userCcs.' + AppF.profile.uid),
                        employees: []
                    };
                    var queries = [];
                    var ccsAndPayrolls;
                    var thisFields = CatalogsF.customFields.filter(function (item) {
                        if (angular.isArray(item.groups) && item.groups.length > 0) {
                            return (item.groups.findIndex(function (item) {
                                return (AppF.groupsOfUser.indexOf(item) > -1);
                            }) > -1);
                        }
                        return true;
                    });
                    if (angular.isArray(fileData) && fileData.length > 0) {
                        var count = 0;
                        data = fileData.map(function (item) {
                            count++;
                            item.recordNumber = count;
                            item.errors = [];
                            try {
                                item.center = AppF.center;
                                // MODIFICACIÓN SOLICITADA:
                                item.constantType = parseInt(item['Tipo_constante']);
                                item.applicationType = parseInt(item['Tipo_aplicacion']);

                                // Validación de Tipo_aplicacion (ahora en applicationType)
                                if (isNaN(item.applicationType) || [1, 2, 3].indexOf(item.applicationType) === -1) {
                                    throw 'El tipo de Elemento no es valido';
                                }
                                if (!permissions[permissionsType[item.applicationType]]) {
                                    throw 'No tiene permiso para subir este tipo de Elemento';
                                }

                                // Validación de Tipo_constante (ahora en constantType)
                                if (isNaN(item.constantType) || [1, 2, 3].indexOf(item.constantType) === -1) {
                                    throw 'El tipo de aplicación no es valido';
                                }

                                if (item.applicationType === 3) {
                                    if (angular.isUndefined(ccsAndPayrolls)) {
                                        ccsAndPayrolls = geCCAndPayroll();
                                    }
                                    var params = {
                                        'data.employeeNumber:number': parseInt(item['Aplicar_a']),
                                        '$and': ccsAndPayrolls,
                                        'project': angular.toJson({ fid: 1, 'data.employeeNumber': 1, 'data.name': 1, 'payroll': 1 })
                                    };
                                    queries.push(DataF.api.get('employees', params));
                                }

                                if (item.constantType === 1) {
                                    var per;
                                    if (item.Periodicidad) {
                                        switch (item.Periodicidad) {
                                            case "1": per = 'period'; break;
                                            case "2": per = 'endOfMonth'; break;
                                            case "3": per = 'startOfMonth'; break;
                                            case "4": per = 'employeeBirthday'; break;
                                            case "5": per = 'employeeAniversary'; break;
                                        }
                                        item.periodicity = per;
                                    } else {
                                        throw 'La periodicidad es requerida para constantes de aplicación automática';
                                    }
                                } else if (item.Periodicidad) {
                                    // Si tiene periodicidad pero no es tipo 1 (automática)
                                    throw 'La periodicidad solo es valida para constantes de aplicación automática';
                                }
                            } catch (error) {
                                item.errors.push(error);
                            }
                            return item;
                        });
                    }

                    var promisesIndex = [];
                    Promise.all(queries).then(function (resp) {
                        if (resp.length > 0) {
                            for (var r = 0; r < resp.length; r++) {
                                var thisResp = resp[r];
                                if (angular.isArray(thisResp.data) && thisResp.data.length > 0) {
                                    objs.employees.push(thisResp.data[0]);
                                }
                            }
                        }
                        var promises = [];
                        for (var d = 0; d < data.length; d++) {
                            var item = data[d];
                            try {
                                if (item.errors.length === 0) {
                                    var elementToApply = getElementToApply(objs, item.applicationType, item['Aplicar_a']);
                                    if (angular.isUndefined(elementToApply)) {
                                        throw 'No se encontró el elemento seleccionado o no tiene permiso para acceder a ese recurso';
                                    }
                                    item.elementToApply = elementToApply;

                                    if (item.constantType === 3) {
                                        var thisField = thisFields.find(function (field) {
                                            return field.key === item['Elemento'];
                                        });
                                        if (angular.isDefined(thisField)) {
                                            thisField.$id = thisField.key;
                                            item.constant = thisField;
                                        }
                                    } else {
                                        var thisPayroll = item.applicationType === 1 ? item.elementToApply.$id : item.elementToApply.payroll;
                                        var incidence = ListsF.incidencesTypes.find(function (incidenceType) {
                                            return incidenceType.$id === item['Elemento'] && thisPayroll === incidenceType.payroll && incidenceType.constant;
                                        });
                                        if (angular.isUndefined(incidence)) {
                                            incidence = ListsF.incidencesTypes.find(function (incidenceType) {
                                                return incidenceType.$id === item['Elemento'] && incidenceType.payroll === 'global' && incidenceType.constant;
                                            });
                                        }
                                        if (angular.isDefined(incidence)) {
                                            item.constant = incidence;
                                        }
                                    }

                                    if (angular.isUndefined(item.constant)) {
                                        throw 'No existe la Elemento a aplicar';
                                    }

                                    var thisValue = item['Valor'];
                                    thisValue = thisValue.toString().replaceAll(',', '').replaceAll('$', '').replaceAll(' ', '');
                                    thisValue = parseFloat(thisValue);
                                    if (isNaN(thisValue)) {
                                        throw 'El valor ingresado no es valido';
                                    }
                                    item.value = Math.round(thisValue * 10000) / 10000;

                                    var params = {
                                        'itemId': item.elementToApply.idField,
                                        'constantType': constantTypeArr[item.constantType],
                                        'type': permissionsType[item.applicationType],
                                        'project': angular.toJson({ fid: 1 })
                                    };
                                    params[item.constantType === 3 ? 'customField.key' : 'incidencesType'] = item.constant.$id;
                                    promises.push(DataF.api.get('operationConstants', params));
                                    promisesIndex.push(d);
                                }
                            } catch (error) {
                                item.errors.push(error);
                            }
                        }
                        return Promise.all(promises);
                    }).then(function (resp) {
                        for (var r = 0; r < resp.length; r++) {
                            var rInd = promisesIndex[r];
                            var thisResp = resp[r].data;
                            if (angular.isArray(thisResp) && thisResp.length > 0) {
                                data[rInd].fid = thisResp[0].fid;
                            }
                        }
                        resolve(data);
                    }).catch(reject);
                } catch (error) {
                    reject(error);
                }
            });
        }
    }
}());
(function () {
    'use strict';
    angular
        .module('app.clients')
        .filter('applyOperationConstants', applyOperationConstants);

    function applyOperationConstants($log, DataF, AppF) {
        var permissionsType = [
            null,
            'payroll',
            'cc',
            'employee'
        ];
        var constantType = [
            null,
            'automaticApply',
            'notApply',
            'customField'
        ];

        return applyOperationConstantsFn;

        function applyOperationConstantsFn(data) {
            return new Promise(function (resolve, reject) {
                try {
                    var promises = [];
                    for (var d = 0; d < data.length; d++) {
                        var record = data[d];
                        if (record.errors.length === 0) {
                            var objToSave = {
                                'itemId': record.elementToApply.idField,
                                'constantType': constantType[record.constantType],
                                'type': permissionsType[record.applicationType],
                                'name': record.elementToApply.name
                            };
                            if (record.constantType === 3) {
                                objToSave.customField = {
                                    key: record.constant.$id,
                                    value: record.value
                                };
                            } else {
                                objToSave.incidencesType = record.constant.$id;
                                if (record.applicationType === 1) {
                                    var per;
                                    switch (record.Periodicidad) {
                                        case "1":
                                            per = 'period'
                                            break;
                                        case "2":
                                            per = 'endOfMonth'
                                            break;
                                        case "3":
                                            per = 'startOfMonth'
                                            break;
                                        case "4":
                                            per = 'employeeBirthday'
                                            break;
                                        case "5":
                                            per = 'employeeAniversary'
                                            break;
                                    }
                                    $log.log('Aplicación automática', record.Periodicidad);
                                    objToSave.automaticApply = {
                                        each: per,
                                        value: record.value
                                    };
                                } else {
                                    objToSave.notApply = {
                                        automatic: true
                                    };
                                }
                            }
                            objToSave.center = record.center;
                            objToSave[record.fid ? 'updated' : 'created'] = DataF.getTimeObject();
                            if (!record.fid) {
                                record.fid = AppF.root.child('catalogs/operationConstants/collection').push().key;
                            }
                            $log.log('Guardado', objToSave);
                            promises.push(AppF.root.child('catalogs/operationConstants/collection/' + record.fid).update(objToSave));
                        }else{
                            $log.log('Registro con errores', record);
                        }
                    }
                    Promise.all(promises).then(function () {
                        resolve(true);
                    }).catch(reject);
                } catch (error) {
                    $log.log(error);
                    reject(error);
                }
            });
        }
    }
}());
(function(){
    'use strict';

    angular
        .module('app.config')
        .filter('watchersForImport', watchersForImport)

    function watchersForImport(){

        return watchersForImportFn;

        function watchersForImportFn(needed, required, inputTypes, type){
            var watchThis = { // specials de empleados default hardcoded
                paths: (type == 'employees') ? ['dataFromImport.id', 'dataFromImport.estatus','dataFromImport.nss'] : [],
                fields: (type == 'employees') ? ['id','estatus','nss'] : []
            };
            for(var r in required){
                watchThis.fields.push(required[r]);
                watchThis.paths.push('dataFromImport.'+required[r]);
                if(inputTypes.fbAutocompletes.hasOwnProperty(required[r])){
                    watchThis.fields.push(required[r] + '-object');
                    watchThis.paths.push('dataFromImport.'+required[r] + '-object');
                }
            }
            
            return watchThis
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.config')
        .filter('validateRowImport', validateRowImport)

    function validateRowImport(
        AppF,
        $rootScope,
        loopEachFilter
    ) {

        return validateRowImportFn;

        function validateRowImportFn(row, requiredFields, inputTypes, type) {
            if (!row.hasOwnProperty('config')) row.config = {
                validations: {}
            };
            if (angular.isUndefined(row.config)) row.config = {};
            row.config.valid = true;
            delete row.config.validations["sd"];
            delete row.config.validations["sdc"];
            delete row.config.validations["nss"];
            // required
            for (var f in requiredFields) {
                var field = requiredFields[f];
                //Funcion para crear el nombre y el nombre del beneficiario
                var compoundFields = {
                    name: ['apellido_paterno', 'apellido_materno', 'nombre'],
                };
                loopEachFilter(compoundFields, function (compoundField, key) {
                    if (compoundField.indexOf(field) !== -1) {
                        var objArray = [];
                        for (var c = 0; c < compoundField.length; c++) {
                            if (angular.isString(row[compoundField[c]]) && row[compoundField[c]] !== '') {
                                objArray.push(row[compoundField[c]].trim());
                            }
                        }
                        if (objArray.length > 0) {
                            row[key] = objArray.join(' ');
                        }
                    }
                });
                // if (['nombre', 'apellido_materno', 'apellido_paterno'].indexOf(field) !== -1) {
                //     var paternalSurname = (row['apellido_paterno']) ? row['apellido_paterno'] : '';
                //     var maternalSurname = (row['apellido_materno']) ? row['apellido_materno'] : '';
                //     var name = (row['nombre']) ? row['nombre'] : '';
                //     row['name'] = paternalSurname + " " + maternalSurname + " " + name;
                // }
                // si no tiene mensaje de validación le pone el de campo requerido
                if (!row.config.validations[field]) row.config.validations[field] = 'campo requerido';
                // unique removal if not anymore
                if (inputTypes.unique[field]) {
                    if (angular.isUndefined(row[field + '-unique'])) {
                        delete row.config.validations[field];
                    }
                }
                if (field == 'cc_id') { // especial para empleados y movimientos
                    if (row.hasOwnProperty('cc_id')) {
                        if (row['cc_id'] != null && angular.isDefined(row['cc_id'])) {
                            delete row.config.validations[field];
                        }
                        if (row['cc_id'] != null) {
                            $rootScope.L.loadList("ccs", "catalogs/ccs/collection/" + row["cc_id"] + "/data/rp_id", false, "object", "ccs" + row["cc_id"]).then(function (ccdata) {
                                var val = ccdata.$value;
                                console.log(ccdata);
                                if (val !== null) {
                                    row['rp'] = val;
                                    $rootScope.L.loadList("rps", "catalogs/rps/collection/" + val + "/data/name", false, "object", "rps" + val).then(function (rpData) {
                                        if (rpData !== null) {
                                            var thisRp = rpData.$value;
                                            row['rp-rp'] = thisRp;
                                            console.log(thisRp);
                                            if (thisRp != "00000000000") {
                                                console.log(row.sd, row.sbc, row.nss);
                                                if (typeof (row.sd) == "undefined" || row.sd == "" || row.sd == null) {
                                                    console.log("no sd")
                                                    row.config.valid = false;
                                                    row.config.validations["sd"] = "Campo Requerido";
                                                }
                                                if (typeof (row.sbc) == "undefined" || row.sbc == "" || row.sbc == null) {
                                                    console.log("no sbc")
                                                    row.config.valid = false;
                                                    row.config.validations["sdc"] = "Campo Requerido";
                                                }
                                                if (typeof (row.nss) == "undefined" || row.nss == "" || row.nss == null) {
                                                    console.log("no nss")
                                                    row.config.valid = false;
                                                    row.config.validations["nss"] = "Campo Requerido";
                                                }
                                            } else {
                                                row.config.createMovement = true;
                                            }
                                        } else {
                                            row['rp-rp'] = null;
                                            row.config.valid = false;
                                            row.config.validations['rp-rp'] = 'Centro de costo no tiene rp'
                                        }
                                    });
                                } else {
                                    row['rp'] = null
                                    row.config.valid = false;
                                    row.config.validations['rp'] = 'centro de costo no tiene rp';
                                }
                            }).catch(function (error) {
                                $log.error(error);
                            })
                        } else {
                            row['rp'] = null
                            row.config.valid = false;
                            row.config.validations['rp'] = 'centro de costo no tiene rp';
                        }
                    }
                } else if (field == 'nominas_id') { // especial para nominas
                    if (row.hasOwnProperty('nominas_id')) {
                        if (row['nominas_id'] != null && angular.isDefined(row['nominas_id'])) {
                            delete row.config.validations[field];
                        }
                        if (row['nominas_id'] != null) {
                            $rootScope.L.loadList("rps", "catalogs/payrolls/collection/" + row['nominas_id'] + "/firm", false, "object", "payrolls" + row['nominas_id']).then(function (payrollData) {
                                var val = payrollData.$value;
                                // console.log(val, "WTF MEN")
                                if (val !== null) {
                                    row['firm'] = val;
                                } else {
                                    row['firm'] = null
                                    row.config.valid = false;
                                    row.config.validations['firm'] = 'nómina no tiene cliente';
                                }
                            });
                        } else {
                            row['firm'] = null
                            row.config.valid = false;
                            row.config.validations['firm'] = 'nómina no tiene cliente';
                        }
                    }
                } else if (field == 'rps_id') {

                    if (typeof (row[field]) !== "undefined" && row[field] != null && row[field] != "") {
                        console.log(row[field], "este es el rp del movimiento con la nomina", row["name"]);
                        delete row.config.validations[field];
                        var promise;
                        if (!isNaN(row[field])) {
                            var isArray = true;
                            promise = $rootScope.L.loadList("rps", "catalogs/rps/collection/", false, "array", "rps" + row[field], [{ q: "orderByChild", v: "created/sqlId" }, { q: "equalTo", v: row[field] }]);
                        } else {
                            promise = $rootScope.L.loadList("rps", "catalogs/rps/collection/" + row[field] + "/data/name", false, "object", "rps" + row[field]);
                        }

                        promise.then(function (rpData) {
                            var val = null;
                            if (isArray) {
                                if (typeof (rpData) == "object" && typeof (rpData.length) == "number" && rpData.length > 0 && typeof (rpData[0].data) == "object" && typeof (rpData[0].data.name) != "undefined") {
                                    val = rpData[0].data.name;
                                }
                            } else {
                                val = rpData.$value;
                            }
                            if (val !== null) {
                                var thisRp = val;
                                row['rp-rp'] = thisRp;
                                console.log(thisRp);
                                if (thisRp != "00000000000") {
                                    console.log(row.sd, row.sbc, row.nss);
                                    if (typeof (row.sd) == "undefined" || row.sd == "" || row.sd == null) {
                                        console.log("no sd")
                                        row.config.valid = false;
                                        row.config.validations["sd"] = "Campo Requerido";
                                    }
                                    if (typeof (row.sbc) == "undefined" || row.sbc == "" || row.sbc == null) {
                                        console.log("no sbc")
                                        row.config.valid = false;
                                        row.config.validations["sdc"] = "Campo Requerido";
                                    }
                                    if (typeof (row.nss) == "undefined" || row.nss == "" || row.nss == null) {
                                        console.log("no nss")
                                        row.config.valid = false;
                                        row.config.validations["nss"] = "Campo Requerido";
                                    }
                                } else {
                                    row.config.createMovement = true;
                                }
                            } else {
                                row['rp-rp'] = null;
                                row.config.valid = false;
                                row.config.validations['rp-rp'] = 'Centro de costo no tiene rp'
                            }
                        }).catch(function (error) {
                            $log.error(error);
                        })
                    } else {
                        row['rp'] = null
                        row.config.valid = false;
                        row.config.validations['rp'] = 'Rp es requerido';
                    }
                } else {
                    if (['sd', 'sbc'].indexOf(field) !== -1 && type == 'employees') {
                        if (!row.nss || row.nss == null || row.nss == 'NULL') { // si empleado está asegurado
                            delete row.config.validations[field]; // entonces no es requerido
                        }
                        if (row[field] || row[field] !== null) {
                            delete row.config.validations[field];
                        }
                    } else if (inputTypes.fbAutocompletes.hasOwnProperty(field)) {
                        if (row[field + '-object']) {
                            if (row[field + '-object'].hasOwnProperty('$id')) {
                                row[field] = row[field + '-object'].$id;
                                row[field + '-name'] = row[field + '-object'].name;
                                delete row.config.validations[field];
                            }
                        } else if (angular.isDefined(row[field]) && row[field] != null) {
                            delete row.config.validations[field];
                        }
                    } else if (inputTypes.mongoAutocompletes.hasOwnProperty(field)) {
                        if (row[field + '-object']) {
                            if (row[field + '-object'].hasOwnProperty('_id')) {
                                row[field] = row[field + '-object']._id;
                                row[field + '-name'] = row[field + '-object'].name;
                                delete row.config.validations[field];
                            }
                        } else if (angular.isDefined(row[field]) && row[field] != null) {
                            delete row.config.validations[field];
                        }
                    } else if (inputTypes.datepickers.hasOwnProperty(field)) {
                        if (moment(row[field]).isValid()) {
                            delete row.config.validations[field];
                        }
                    } else {
                        if (angular.isDefined(row[field]) && row[field] != null) {
                            if (inputTypes.inputs[field]) {
                                if (inputTypes.inputs[field] == 'text') {
                                    if (angular.isString(row[field])) {
                                        if (inputTypes.unique[field]) {
                                            if (angular.isUndefined(row[field + '-unique'])) {
                                                delete row.config.validations[field];
                                            }
                                        } else {
                                            delete row.config.validations[field];
                                        }
                                    } else if (row[field]) {
                                        row.config.validations[field] = 'campo debe ser texto';
                                    }
                                } else {
                                    if (angular.isNumber(row[field])) {
                                        if (inputTypes.unique[field]) {
                                            if (angular.isUndefined(row[field + '-unique'])) {
                                                delete row.config.validations[field];
                                            }
                                        } else {
                                            delete row.config.validations[field];
                                        }
                                    } else if (row[field]) {
                                        row.config.validations[field] = 'campo debe ser número';
                                    }
                                }
                            }
                        } else {
                            row.config.validations[field] = 'campo requerido';
                        }
                    }
                }
            }

            // este codigo sirve para poner valida la columna si se permiten excepciones, descomentar para modificar pues el estado valid no sirve en los botones
            // if(row.config.permiteException){
            //     row.config.valid = true;
            // } else {
            if (Object.keys(row.config.validations).length) {
                row.config.valid = false;
                return row;
            }
            row.config.valid = true;
            // }
            return row;
        }
    }

}());
(function(){
    'use strict';

    angular
        .module('app.config')
        .filter('objectToRawValidation', objectToRawValidation)

    function objectToRawValidation(){

        return objectToRawValidationFn;

        function objectToRawValidationFn(validations){
            var raw = '';

            var c = 0;
            angular.forEach(validations, function(value, field){
                c++;
                raw += value;
                if(c !== Object.keys(validations).length){
                    raw += ' ,';
                }
            })

            return raw;
        }
    }

}());
(function(){
    'use strict';

    angular
        .module('app.config')
        .filter('importsReferenceObject', importsReferenceObject)

    function importsReferenceObject(){

        return importsReferenceObjectFn;

        function importsReferenceObjectFn(dataToImport, type){
            var refObj = {
                employees: null,
                movements: null,
                credits: null
            };
            if(dataToImport.employees){
                if(Object.keys(dataToImport.employees).length){
                    refObj.employees = {};
                    for(var uid in dataToImport.employees){
                        refObj.employees[uid] = true;
                    }
                }
            }
            if(dataToImport.movements){
                if(Object.keys(dataToImport.movements).length){
                    refObj.movements = {};
                    for(var mid in dataToImport.movements){
                        refObj.movements[mid] = true;
                    }
                }
            }
            if(dataToImport.credits){
                if(Object.keys(dataToImport.credits).length){
                    refObj.credits = {};
                    for(var cid in dataToImport.credits){
                        refObj.credits[cid] = true;
                    }
                }
            }
            return refObj;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.config')
        .filter('importNeededFields', importNeededFields)

    function importNeededFields(AppF) {

        return importNeededFieldsFn;

        function importNeededFieldsFn(type, getArray, inputType, required) {
            var requiredArray = {
                employees: [
                    'nominas_id',
                    'cc_id',
                    'nombre',
                    'apellido_paterno',
                    'fecha_de_nacimiento',
                    'rfc',
                    'curp',
                    'puestos_id',
                    'codigo_postal_sat',
                    'estatus'
                ],
                movements: [
                    'empleados_id',
                    'rps_id',
                    'nominas_id',
                    'movimiento',
                    'fecha',
                    'status'
                ],
                credits: [
                    'nominas_id',
                    'empleados_id',
                    'fecha_de_inicio',
                    'tipo_credito',
                    'factor_credito',
                    'numero_credito'
                ]
            };
            var inputTypes = {
                employees: {
                    unique: {
                    },
                    disabled: [
                        // 'el_dia'
                    ],
                    inputs: {
                        id: 'number',
                        estatus: 'number',
                        apellido_paterno: 'text',
                        apellido_materno: 'text',
                        nombre: 'text',
                        rfc: 'text',
                        curp: 'text',
                        nss: 'text',
                        umf: 'text',
                        sd: 'number',
                        sbc: 'number',
                        sueldo_diario_real: 'number',
                        nombre_de_la_calle: 'text',
                        numero: 'text',
                        numero_int: 'text',
                        referencia: 'text',
                        colonia: 'text',
                        codigo_postal: 'text',
                        codigo_postal_sat: 'text',
                        telefono_fijo: 'text',
                        telefono_celular: 'text',
                        tarjeta: 'text',
                        beneficiario: 'text',
                        parentesco: 'text',
                        porcentaje: 'number',
                        comentarios: 'text'
                    },
                    fbAutocompletes: {
                        nominas_id: {
                            getRef: 'lists/payrolls/all/<v>/name',
                            listRef: 'lists/payrolls/center/' + AppF.center,
                            getFullRef: 'catalogs/payrolls/collection',
                            parent: 'payrolls',
                            by: 'name'
                        },
                        cc_id: {
                            getRef: 'lists/ccs/all/<v>/name',
                            listRef: 'lists/ccs/payroll/<z>nominas_id</z>',
                            getFullRef: 'catalogs/ccs/collection',
                            parent: 'ccs',
                            child: '<z>nominas_id</z>',
                            by: 'name'
                        },
                        puestos_id: {
                            getRef: 'lists/positions/all/<v>/name',
                            listRef: 'lists/positions/payroll/<z>nominas_id</z>',
                            getFullRef: 'catalogs/positions/collection',
                            parent: 'positions',
                            child: '<z>nominas_id</z>',
                            by: 'name'
                        }
                    },
                    mongoAutocompletes: {
                        tipo_de_via_id: {
                            catalog: 'streetTypes',
                            selectUse: '_id',
                            query: {
                                humansiteCode: '<v>'
                            }
                        },
                        tipo_contrato: {
                            catalog: 'documentTypes',
                            query: {
                                key: '<v>',
                                center: AppF.center,
                                type: 'contract'
                            },
                            selectUse: '_id'
                        },
                        tipo_de_trabajador: {
                            catalog: 'workerTypes',
                            query: {
                                humansiteCode: '<v>'
                            },
                            selectUse: 'humansiteCode'
                        },
                        estados_id: {
                            catalog: 'states',
                            selectUse: '_id',
                            query: {
                                humansiteCode: '<v>'
                            }
                        },
                        municipios_id: {
                            catalog: 'towns',
                            selectUse: '_id',
                            query: {
                                humansiteCode: '<v>'
                            }
                        },
                        banco_emisor: {
                            catalog: 'banks',
                            selectUse: '_id',
                            query: {
                                humansiteCode: '<v>'
                            }
                        }
                    },
                    datepickers: {
                        fecha_de_alta_imss: true,
                        fecha_de_antiguedad: true,
                        fecha_de_nacimiento: true,
                        alta_salud: true,
                        baja_salud: true
                    },
                    switchs: {
                        tarjeta_emitida: true,
                        emision_de_tarjeta: true,
                        prestaciones_de_ley: true,
                        salud: true
                    },
                    special: {}
                },
                movements: {
                    unique: {
                        //     id: {
                        //         query: 'created/sqlId',
                        //         ref: 'catalogs/movements/collection'
                        //     }
                    },
                    disabled: [
                        'id'
                    ],
                    inputs: {
                        id: 'number',
                        sd: 'number',
                        sbc: 'number',
                        movimiento: 'number',
                        umf: 'text',
                        lote: 'text',
                        comentarios: 'text',
                        status: 'number',
                        nss: 'text',
                        apellido_paterno: 'text',
                        apellido_materno: 'text',
                        nombre: 'text'
                    },
                    fbAutocompletes: {
                        empleados_id: {
                            getRef: 'lists/employees/all/<v>/name',
                            listRef: 'lists/employees/all',
                            getFullRef: 'catalogs/employees/collection',
                            parent: 'employees',
                            child: 'all',
                            by: 'name'
                        },
                        rps_id: {
                            getRef: 'lists/rps/all/<v>/name',
                            listRef: 'lists/rps/all',
                            getFullRef: 'catalogs/rps/collection',
                            parent: 'rps',
                            child: 'all',
                            by: 'name'
                        },
                        nominas_id: {
                            getRef: 'lists/payrolls/all/<v>/name',
                            listRef: 'lists/payrolls/center/' + AppF.center,
                            getFullRef: 'catalogs/payrolls/collection',
                            parent: 'payrolls',
                            child: 'all',
                            by: 'name'
                        }
                    },
                    mongoAutocompletes: {
                        tipo_de_baja: {
                            catalog: 'dismissTypes',
                            selectUse: '_id',
                            query: {
                                humansiteCode: '<v>'
                            }
                        },
                        tipo_de_trabajador: {
                            catalog: 'workerTypes',
                            query: {
                                humansiteCode: '<v>'
                            },
                            selectUse: 'humansiteCode'
                        },
                        jornada: {
                            catalog: 'workDays',
                            query: {
                                humansiteCode: '<v>'
                            },
                            selectUse: 'humansiteCode'
                        },
                        tipo_de_salario: {
                            catalog: 'salaryTypes',
                            query: {
                                humansiteCode: '<v>'
                            },
                            selectUse: 'humansiteCode'
                        }
                    },
                    datepickers: {
                        fecha: true,
                        respuesta: true
                    },
                    switchs: {
                        //     paga_sueldo_en_nomina: true
                    },
                    special: {
                        status: 'getLastMovement' // get last movement of employees and set it or set default
                    }
                },
                credits: {
                    unique: {
                        numero_credito: {
                            query: 'data/account',
                            ref: 'catalogs/credits/collection'
                        }
                    },
                    disabled: [],
                    inputs: {
                        id: 'number',
                        tipo_credito: 'text', // F.creditTypes
                        factor_credito: 'number',
                        numero_credito: 'text',
                        comentarios: 'text'
                    },
                    datepickers: {
                        fecha_de_inicio: true
                    },
                    fbAutocompletes: {
                        nominas_id: {
                            namePath: 'name',
                            getRef: 'lists/payrolls/all/<v>/name',
                            listRef: 'lists/payrolls/center/' + AppF.center,
                            orderBy: 'class',
                            getFullRef: 'lists/payrolls/center/{center}',
                            parent: 'payrolls',
                            child: 'all',
                            by: 'name',
                            extraFieldsFullRef: [
                                { path: 'center', value: function () { return AppF.center; } }
                            ]
                        },
                        empleados_id: {
                            getRef: 'lists/employees/all/<v>/name',
                            listRef: 'lists/employees/all',
                            getFullRef: 'catalogs/employees/collection',
                            parent: 'employees',
                            // namePath: 'data.name', // si no se usa, el default es 'data.name'
                            child: 'all',
                            by: 'name'
                        }
                    },
                    mongoAutocompletes: {},
                    switchs: {},
                    special: {}
                }
            };

            var neededArray = {
                employees: [
                    'estatus',
                    'nominas_id',
                    'cc_id',
                    'fecha_de_alta_imss',
                    'fecha_de_antiguedad',
                    'apellido_paterno',
                    'apellido_materno',
                    'nombre',
                    'fecha_de_nacimiento',
                    'rfc',
                    'curp',
                    'nss',
                    'umf',
                    'sd',
                    'sbc',
                    'sueldo_diario_real',
                    'prestaciones_de_ley',
                    'puestos_id',
                    'tipo_de_via_id',
                    'tipo_contrato',
                    'nombre_de_la_calle',
                    'numero',
                    'colonia',
                    'estados_id',
                    'municipios_id',
                    'codigo_postal',
                    'codigo_postal_sat',
                    'telefono_fijo',
                    'telefono_celular',
                    'tarjeta',
                    'beneficiario',
                    'parentesco',
                    'porcentaje',
                    'banco_emisor',
                    'salud',
                    'alta_salud',
                    'baja_salud',
                    'comentarios',
                    'tipo_de_trabajador'
                ],
                movements: [
                    'empleados_id',
                    'rps_id',
                    'nominas_id',
                    'movimiento',
                    'sd',
                    'sbc',
                    'fecha',
                    'lote',
                    'respuesta',
                    'tipo_de_baja',
                    'comentarios',
                    'status',
                    'tipo_de_salario',
                    'umf',
                    'nss',
                    'apellido_paterno',
                    'apellido_materno',
                    'nombre',
                    'jornada',
                    'tipo_de_trabajador'
                ],
                credits: [
                    // 'id',
                    'nominas_id',
                    'empleados_id',
                    'fecha_de_inicio',
                    'tipo_credito',
                    'factor_credito',
                    'numero_credito',
                    'comentarios'
                ]
            };
            var neededObjectMap = {
                employees: {
                    'id': 'createdByMigration:created/sqlId',
                    'estatus': 'status',
                    'nominas_id': 'payroll',
                    'cc_id': 'cc', // temporal
                    'firm': 'firm', // added by filters
                    'fecha_de_alta_imss': 'dateToTime:data/enroleDate',
                    'fecha_de_antiguedad': 'seniorityDate:data/seniorityDate',
                    'apellido_paterno': 'toUpperCase:data/info/paternalSurname',
                    'apellido_materno': 'toUpperCase:data/info/maternalSurname',
                    'nombre': 'toUpperCase:data/info/names',
                    'fecha_de_nacimiento': 'dateToTime:data/info/birth/date',
                    'rfc': 'data/rfc',
                    'curp': 'data/curp',
                    'nss': 'nss:data/nss',
                    'umf': 'toUmf:data/health/umf',
                    'sd': 'data/salary/sd',
                    'sbc': 'data/salary/sbc',
                    'sueldo_diario_real': 'toFloat:data/salary/sdr',
                    'puestos_id': 'data/position',
                    'tipo_de_trabajador': 'data/workerType',
                    'descripcion_puesto': 'toUpperCase:data/jobDescription',
                    'tipo_de_via_id': 'data/info/residence/address/streetType',
                    'tipo_contrato': 'contractType',
                    'nombre_de_la_calle': 'toUpperCase:data/info/residence/address/street',
                    'numero': 'toUpperCase:data/info/residence/address/externalNumber',
                    'numero_int': 'toUpperCase:data/info/residence/address/internalNumber',
                    'fraccionamiento': 'toUpperCase:data/info/residence/houseDevelop',
                    'referencia': 'data/info/residence/address/reference',
                    'colonia': 'toUpperCase:data/info/residence/address/neighborhood',
                    'estados_id': 'data/info/residence/state',
                    'municipios_id': 'data/info/residence/town',
                    'codigo_postal': 'data/info/residence/address/zipCode',
                    'codigo_postal_sat': 'data/zpCodeSat',
                    'telefono_fijo': 'activatePhone:Casa:data/info/phones',
                    'telefono_celular': 'activatePhone:Celular:data/info/phones',
                    'correo': 'activateEmail:data/info/emails/0/email',
                    'tarjeta': 'activateCard:data/cards/0/number',
                    'estado_civil': 'data/maritalStatus',
                    'beneficiario': 'toUpperCase:data/info/beneficiaries/0/name',
                    'parentesco': 'data/info/beneficiaries/0/relationship',
                    'porcentaje': 'data/info/beneficiaries/0/percent',
                    'emision_de_tarjeta': 'data/cards/0/emit',
                    'prestaciones_de_ley': 'customBenefits',
                    'tarjeta_emitida': 'data/cards/0/emmitedYet',
                    'banco_emisor': 'activateCard:data/cards/0/bank',
                    'salud': 'data/health/benefit',
                    'alta_salud': 'dateToTime:data/health/initDate',
                    'baja_salud': 'dateToTime:data/health/endDate',
                    'comentarios': 'data/comments',
                    // especiales
                    'rp': 'rp',
                    'name': 'toUpperCase:data/name',
                    'nombres': 'toUpperCase:data/names'
                },
                movements: {
                    'id': 'createdByMigration:created/sqlId',
                    'empleados_id': 'employee',
                    'nss': 'nss:info/nss',
                    'apellido_paterno': 'toUpperCase:info/paternalSurname',
                    'apellido_materno': 'toUpperCase:info/maternalSurname',
                    'nombre': 'toUpperCase:info/names',
                    'rps_id': 'rp',
                    'nominas_id': 'payroll',
                    'movimiento': 'toInt:data/type',
                    'sd': 'toFloat:data/sd',
                    'sbc': 'toFloat:data/sbc',
                    'umf': 'toUmf:info/umf',
                    'fecha': 'dateToTime:data/date',
                    'lote': 'receivedByMigration:received/batch',
                    'respuesta': 'archivedByMigration:archived/date',
                    'tipo_de_salario': 'data/salaryType',
                    'jornada': 'data/workDay',
                    'tipo_de_trabajador': 'data/workerType',
                    'tipo_de_baja': 'data/dismissType',
                    'comentarios': 'data/comments',
                    'status': 'status',
                    'employee-rp': 'employee-rp',
                    'cc': 'cc'
                },
                credits: {
                    'id': 'createdByMigration:created/sqlId',
                    'nominas_id': 'payroll',
                    'empleados_id': 'employee',
                    'fecha_de_inicio': 'dateToTime:data/date',
                    'tipo_credito': 'data/type',
                    'factor_credito': 'data/factor',
                    'numero_credito': 'data/account',
                    'comentarios': 'data/comments',
                    // especial
                    'valid': 'valid',
                    'rp': 'rp',
                    'cc': 'cc'
                }
            };

            //type, getArray, inputType, required
            //employees,true, false, true
            if (getArray && required) {
                return requiredArray[type];
            }

            if (type && inputType) {
                return inputTypes[type];
            } else {
                if (!type && !getArray) {
                    return neededObjectMap;
                } else {
                    if (!type && getArray) {
                        return neededArray;
                    } else if (type && !getArray) {
                        return neededObjectMap[type];
                    } else { // if(type && getArray)
                        return neededArray[type];
                    }
                }
            }
        }
    }

}());
(function(){
    'use strict';

    angular
        .module('app.config')
        .filter('importTypeName', importTypeName)

    function importTypeName(){

        return importTypeNameFn;

        function importTypeNameFn(type, singular){
            var typeName = 'N/A';
            switch(type){
                case 'employees': typeName = (singular)?'Empleado':'Empleados'; break;
                case 'movements': typeName = (singular)?'Movimiento':'Movimientos'; break;
                case 'credits':   typeName = (singular)?'Crédito':'Créditos'; break;
                
            }
            return typeName;
        }
    }

}());
(function(){
    'use strict';

    angular
        .module('app.config')
        .filter('importStatusName', importStatusName)

    function importStatusName(){

        return importStatusNameFn;

        function importStatusNameFn(status){
            var statusName;

            switch(status){
                case 1: statusName = 'Creado / Con Datos'; break;
                case 2: statusName = 'Actualizado / Revisado'; break;
                case 3: statusName = 'Importado'; break;
                case -1: statusName = 'Deshecho'; break;
            }

            return statusName;
        }
    }

}());
(function(){
    'use strict';

    angular
        .module('app.config')
        .filter('getDismissTypeMid', getDismissTypeMid)

    function getDismissTypeMid(){

        return getDismissTypeMidFn;

        function getDismissTypeMidFn(id){
            var map = {
                1: '57ae30b8526f8d1704ef3dbc',
                2: '57ae30b8526f8d1704ef3dbd',
                3: '57ae30b8526f8d1704ef3dbe',
                4: '57ae30b8526f8d1704ef3dbf',
                5: '57ae30b8526f8d1704ef3dc0',
                6: '57ae30b8526f8d1704ef3dc1',
                7: '57ae30b8526f8d1704ef3dc2',
                8: '57ae30b8526f8d1704ef3dc3',
                9: '57ae30b8526f8d1704ef3dc4',
                A: '57ae30b8526f8d1704ef3dc5'
            }
            
            return (map.hasOwnProperty(id)) ? map[id] : id;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.config')
        .filter('formatDataToImport', formatDataToImport)


    function formatDataToImport(
        $q,
        AppF,
        $log,
        DataF,
        getFromObjectFilter
    ) {
        var setInPath = function (row, path, value) {
            var paths = path.split('/');
            var pathInRow = row;
            for (var p in paths) {
                if (p == 0) {
                    if (!pathInRow.hasOwnProperty(paths[0])) {
                        pathInRow[paths[0]] = {};
                    }
                    if (p == paths.length - 1) {
                        pathInRow[paths[0]] = angular.copy(value);
                    }
                }
                if (p == 1) {
                    if (!pathInRow[paths[0]].hasOwnProperty(paths[1])) {
                        pathInRow[paths[0]][paths[1]] = {};
                    }
                    if (p == paths.length - 1) {
                        pathInRow[paths[0]][paths[1]] = angular.copy(value);
                    }
                }
                if (p == 2) {
                    if (!pathInRow[paths[0]][paths[1]].hasOwnProperty(paths[2])) {
                        pathInRow[paths[0]][paths[1]][paths[2]] = {};
                    }
                    if (p == paths.length - 1) {
                        pathInRow[paths[0]][paths[1]][paths[2]] = angular.copy(value);
                    }
                }
                if (p == 3) {
                    if (!pathInRow[paths[0]][paths[1]][paths[2]].hasOwnProperty(paths[3])) {
                        pathInRow[paths[0]][paths[1]][paths[2]][paths[3]] = {};
                    }
                    if (p == paths.length - 1) {
                        pathInRow[paths[0]][paths[1]][paths[2]][paths[3]] = angular.copy(value);
                    }
                }
                if (p == 4) {
                    if (!pathInRow[paths[0]][paths[1]][paths[2]][paths[3]].hasOwnProperty(paths[4])) {
                        pathInRow[paths[0]][paths[1]][paths[2]][paths[3]][paths[4]] = {};
                    }
                    if (p == paths.length - 1) {
                        pathInRow[paths[0]][paths[1]][paths[2]][paths[3]][paths[4]] = angular.copy(value);
                    }
                }
                if (p == 5) {
                    if (!pathInRow[paths[0]][paths[1]][paths[2]][paths[3]][paths[4]].hasOwnProperty(paths[5])) {
                        pathInRow[paths[0]][paths[1]][paths[2]][paths[3]][paths[4]][paths[5]] = {};
                    }
                    if (p == paths.length - 1) {
                        pathInRow[paths[0]][paths[1]][paths[2]][paths[3]][paths[4]][paths[5]] = angular.copy(value);
                    }
                }
            }
        }

        var getValueFromArray = function (stringArray, prevId) {
            var array = stringArray.split(',');
            for (var a = 0; a < array.length; a++) {
                var rowA = array[a].split('>');
                if (rowA[0] == prevId) {
                    if (prevId != "null") return rowA[1];
                    else return false;
                }
            }
            return false;
        }

        var constructImport = function (rowRaw, actions, type) {
            var row = {};
            for (var field in actions[type]) {
                var actionPath = actions[type][field];
                if (actionPath.indexOf(':') !== -1) {
                    var actionsPath = actionPath.split(':');
                    var action = actionsPath[0];
                    var path = '';
                    var value = null;
                    switch (action) {
                        case 'createdByMigration':
                            path = actionsPath[1];
                            value = rowRaw[field];
                            setInPath(row, path, value);
                            setInPath(row, 'created/by', AppF.profile.uid);
                            setInPath(row, 'created/onBehalfOf', AppF.center);
                            setInPath(row, 'created/atTime', firebase.database.ServerValue.TIMESTAMP);
                            break;
                        case 'receivedByMigration':
                            path = actionsPath[1];
                            value = rowRaw[field];
                            setInPath(row, path, value);
                            setInPath(row, 'received/by', AppF.profile.uid);
                            setInPath(row, 'received/onBehalfOf', AppF.center);
                            setInPath(row, 'received/atTime', firebase.database.ServerValue.TIMESTAMP);
                            break;
                        case 'archivedByMigration':
                            path = actionsPath[1];
                            // value = rowRaw[field];
                            value = (moment(rowRaw[field]).isValid()) ? moment(rowRaw[field]).valueOf() : null;
                            setInPath(row, path, value);
                            setInPath(row, 'archived/by', AppF.profile.uid);
                            setInPath(row, 'archived/onBehalfOf', AppF.center);
                            setInPath(row, 'archived/atTime', firebase.database.ServerValue.TIMESTAMP);
                            break;
                        case 'toInt':
                            path = actionsPath[1];
                            if (rowRaw[field]) {
                                value = parseInt(rowRaw[field]);
                                setInPath(row, path, value);
                            }
                            break;
                        case 'toUpperCase':
                            path = actionsPath[1];
                            if (rowRaw[field]) {
                                value = ('' + rowRaw[field]).toUpperCase();
                                setInPath(row, path, value);
                            }
                            break;
                        case 'boolean':
                            path = actionsPath[1];
                            value = (rowRaw[field]) ? true : false;
                            setInPath(row, path, value);
                            break;

                        case 'toUmf':
                            path = actionsPath[1];
                            value = rowRaw[field]
                            if (angular.isNumber(value) || (angular.isString(value) && value !== '')) {
                                value = '' + value;
                                value = value.padStart(3, '0');
                                setInPath(row, path, value);
                            }
                            break;
                        case 'toFloat':
                            path = actionsPath[1];
                            if (rowRaw[field]) value = parseFloat(rowRaw[field]);
                            else value = null;
                            setInPath(row, path, value);
                            break;
                        case 'activatePhone':
                            var ptype = actionsPath[1];
                            path = actionsPath[2];
                            value = rowRaw[field];
                            if ((angular.isString(value) && value !== '') || angular.isNumber(value)) {
                                value = '' + value;
                                var exists = getFromObjectFilter(row, path + '/0', undefined, undefined, '/');
                                var index = 0;
                                if (angular.isDefined(exists)) {
                                    index = 1;
                                }
                                setInPath(row, path + '/' + index + '/phone', value);
                                setInPath(row, path + '/' + index + '/active', true);
                                setInPath(row, path + '/' + index + '/type', ptype);
                            }
                            break;
                        case 'activateCard':
                            path = actionsPath[1];
                            value = rowRaw[field];
                            if ((angular.isString(value) && value !== '') || angular.isNumber(value)) {
                                value = '' + value;
                                setInPath(row, path, value);
                                setInPath(row, 'data/cards/0/active', true);
                            }
                            break;
                        case 'activateEmail':
                            path = actionsPath[1];
                            value = rowRaw[field];
                            if (angular.isString(value) && value !== '') {
                                setInPath(row, path, value);
                                setInPath(row, 'data/info/emails/0/active', true);
                                setInPath(row, 'data/info/emails/0/type', 'Personal');
                            }
                            break;
                        case 'nss':
                            path = actionsPath[1];
                            value = rowRaw[field];
                            if (angular.isString(value) || angular.isNumber(value)) {
                                value = '' + value;
                                value = value.padStart(11, '0');
                            } else {
                                value = null;
                            }
                            setInPath(row, path, value);
                            break;
                        case 'seniorityDate':
                            path = actionsPath[1];
                            value = (moment(rowRaw[field]).isValid()) ? moment(rowRaw[field]).valueOf() : null;
                            if (angular.isNumber(value)) {
                                setInPath(row, 'hasSeniorityDate', true);
                                setInPath(row, path, value);
                            } else {
                                setInPath(row, 'hasSeniorityDate', false);
                            }
                            break;
                        case 'dateToTime':
                            path = actionsPath[1];
                            value = (moment(rowRaw[field]).isValid()) ? moment(rowRaw[field]).valueOf() : null;
                            setInPath(row, path, value);
                            break;
                        case 'fromArray':
                            var stringArray = actionsPath[1];
                            path = actionsPath[2];
                            var prevId = rowRaw[field];
                            value = getValueFromArray(stringArray, prevId);
                            setInPath(row, path, value);
                            break;
                        case 'writeThis':
                            value = actionsPath[1];
                            path = actionsPath[2];
                            setInPath(row, path, value);
                            break;
                    }
                } else {
                    var path2 = angular.copy(actionPath);
                    var value2 = rowRaw[field];
                    $log.log(field, path2, value2, angular.isDefined(value2));
                    if (angular.isString(path2) && angular.isDefined(value2)) {
                        setInPath(row, path2, value2);
                    }
                }
            }
            return row;
        }

        var constructDefaultMovement = function (uid, employee, movementType, dismiss) {
            console.log(movementType)
            var movement;
            if (!dismiss) {
                var comments = 'Movimiento de alta default generado automáticamente para importación de empleado sin nss',
                    status = movementType.status ? movementType.status : 4,
                    type = 6;
                if (angular.isDefined(movementType.name)) {
                    comments = 'Movimiento de ' + movementType.name + ' inicial generado automáticamente para importación de empleado sin id (del sistema anterior) en status ' + movementType.status;
                    status = movementType.status;
                    type = movementType.type;
                }
                movement = {
                    created: DataF.getTimeObject(),
                    employee: uid,
                    // rps_id: "setInEmployee:id:rps:rp", // solo funciona con rp originales se seteara el rp de cada empleado por separado
                    payroll: employee.payroll,
                    cc: employee.cc,
                    rp: employee.rp,
                    'employee-rp': employee.rp,
                    data: {
                        type: type,
                        sd: employee.data.salary.sd ? employee.data.salary.sd : null,
                        sbc: employee.data.salary.sbc ? employee.data.salary.sbc : null,
                        sdr: employee.data.salary.sdr ? employee.data.salary.sdr : null,
                        date: employee.data.enroleDate,
                        comments: comments,
                        workerType: employee.data.workerType || 1,
                        workDay: 0,
                        salaryType: 2
                    },
                    info: {},
                    status: status
                };
            } else {
                var comments2 = 'Movimiento de baja default generado automáticamente para importación de empleado sin nss',
                    status2 = 4,
                    type2 = 2;
                if (angular.isDefined(movementType.name)) {
                    comments2 = 'Movimiento de ' + movementType.name + ' inicial generado automáticamente para importación de empleado sin id (del sistema anterior) en status ' + movementType.status;
                    status2 = movementType.status;
                    type2 = movementType.type;
                }
                movement = {
                    created: DataF.getTimeObject(),
                    employee: uid,
                    payroll: employee.payroll,
                    'employee-rp': employee.rp,
                    cc: employee.cc,
                    rp: employee.rp,
                    data: {
                        type: type2,
                        dismissType: dismiss.dismissType,
                        paySalaryInPayrol: dismiss.paySalaryInPayrol,
                        sd: employee.data.salary.sd ? employee.data.salary.sd : null,
                        sbc: employee.data.salary.sbc ? employee.data.salary.sbc : null,
                        sdr: employee.data.salary.sdr,
                        date: employee.data.dismissDate,
                        comments: comments2,
                        workerType: employee.data.workerType || 1,
                        workDay: 0,
                        salaryType: 2
                    },
                    info: {},
                    status: status2
                };
            }

            if (angular.isDefined(employee.data.info.maternalSurname)) movement.info.maternalSurname = angular.copy(employee.data.info.maternalSurname);
            if (angular.isDefined(employee.data.info.paternalSurname)) movement.info.paternalSurname = angular.copy(employee.data.info.paternalSurname);
            if (angular.isDefined(employee.data.info.names)) movement.info.names = angular.copy(employee.data.info.names);
            if (angular.isDefined(employee.data.name)) movement.info.name = angular.copy(employee.data.name);
            if (angular.isDefined(employee.data.nss)) movement.info.nss = angular.copy(employee.data.nss);
            if (angular.isDefined(employee.data.health.umf)) movement.info.umf = angular.copy(employee.data.health.umf);

            return movement;
        }

        return formatDataToImportFn;

        function formatDataToImportFn(data, actions, type) {
            var promise = $q.defer();

            try {
                var dataReady = {
                    employees: {},
                    movements: {},
                    credits: {}
                };

                for (var d in data) {
                    var uid = AppF.root.child('catalogs/' + type + '/collection').push().key;
                    if (data[d]["rp-rp"] == "00000000000") {
                        delete data[d].sd;
                        delete data[d].sbc;
                        delete data[d].nss;
                    }
                    dataReady[type][uid] = constructImport(data[d], actions, type);
                    $log.debug(dataReady[type][uid], type + ' constructed');
                    if (type == 'employees' && !dataReady.employees[uid].data.salary.sdr && dataReady.employees[uid].data.salary.sd) {
                        dataReady.employees[uid].data.salary.sdr = dataReady.employees[uid].data.salary.sd;
                    }
                    // if(type == 'movements'){ // se setea en 5 si es una baja y esta en status 4
                    //     if(dataReady.movements[uid].data.type == 2 && dataReady.movements[uid].status == 4){
                    //         dataReady.movements[uid].status = 5;
                    //     }
                    // }
                    if (type == 'employees' && data[d].config.createMovement) {
                        var mid = AppF.root.child('catalogs/movements/collection').push().key;
                        dataReady.movements[mid] = constructDefaultMovement(uid, dataReady.employees[uid], false, false);
                        console.log(dataReady.movements[mid])
                        var dismiss = false;
                        if (angular.isDefined(data[d].fecha_de_baja_imss) && moment(data[d].fecha_de_baja_imss).isValid()) {
                            $log.debug(data[d].fecha_de_baja_imss, "valid dismissDate");
                            var mid1 = AppF.root.child('catalogs/movements/collection').push().key;
                            dismiss = {
                                // dismissType: getDismissTypeMidFilter(data[d].tipo_de_baja),
                                dismissType: data[d].tipo_de_baja,
                                paySalaryInPayrol: (data[d].paga_sueldo_en_nomina),
                                rehirable: (data[d].recontratable)
                            }
                            if (!dismiss.rehirable) {
                                dismiss.reason = data[d].motivo
                            }
                            dataReady.movements[mid1] = constructDefaultMovement(uid, dataReady.employees[uid], false, dismiss);
                        }

                        if (!dataReady.employees[uid].hasOwnProperty('movements')) dataReady.employees[uid].movements = {};
                        dataReady.employees[uid].movements[mid] = {
                            d: dataReady.movements[mid].data.date,
                            s: 4,
                            t: 6,
                            p: dataReady.movements[mid].payroll
                        };
                        dataReady.employees[uid].data.enroleDate = angular.copy(dataReady.movements[mid].data.date);
                        if (dismiss) {
                            dataReady.employees[uid].movements[mid1] = {
                                d: dataReady.movements[mid1].data.date,
                                s: 4,
                                t: 2,
                                p: dataReady.movements[mid1].payroll
                            };
                            dataReady.employees[uid].data.dismissDate = angular.copy(dataReady.movements[mid1].data.date);
                            // si la fecha de baja es mayor a la de alta, se da de baja al empleado
                            if (dataReady.movements[mid1].data.date > dataReady.movements[mid].data.date) {
                                dataReady.employees[uid].status = 5;
                            }
                        }
                    }
                    if (type == 'employees' && data[d].config.createMovementType) {
                        // dataReady.employees[uid].created = DataF.getTimeObject();
                        var mid2 = AppF.root.child('catalogs/movements/collection').push().key;
                        dataReady.movements[mid2] = constructDefaultMovement(uid, dataReady.employees[uid], {
                            status: dataReady[type][uid].status || 1,
                            type: 6,
                            name: 'alta'
                        });
                        if (!dataReady.employees[uid].hasOwnProperty('movements')) dataReady.employees[uid].movements = {};
                        dataReady.employees[uid].movements[mid2] = {
                            d: dataReady.movements[mid2].data.date,
                            s: dataReady[type][uid].status || 1,
                            t: 6,
                            p: dataReady.movements[mid2].payroll
                        };
                        dataReady.employees[uid].data.enroleDate = angular.copy(dataReady.movements[mid2].data.date);
                    }
                    if (type == 'employees') { // se agregan los campos por default
                        var workerType = parseInt(data[d].tipo_de_trabajador);
                        dataReady.employees[uid].data.salary.type = 2;
                        dataReady.employees[uid].data.workDay = 0;
                        dataReady.employees[uid].data.workerType = (!isNaN(workerType)) && isFinite(workerType) ? workerType : 1;
                    }
                }

                promise.resolve(dataReady);
            } catch (err) {
                $log.error(err);
                promise.reject(err);
            }

            return promise.promise;
        }
    }
}());
(function () {
    'use strict';

    angular
        .module('app.config')
        .filter('filterDataFromImport', filterDataFromImport)

    function filterDataFromImport(
        AppF,
        DataF,
        $q,
        $log,
        errAlertS,
        pathInObjFilter
    ) {

        return filterDataFromImportFn;

        function filterDataFromImportFn(data, type, inputTypes) {
            var dataFiltered = angular.copy(data);
            var promiseG = $q.defer();
            var dataImportedHeaders = Object.keys(dataFiltered[0]);
            var fbTasks = [];
            var mTasks = [];
            var promises = [];
            var dontRepeatData = {};
            for (var d = 0; d < dataFiltered.length; d++) {
                var item = angular.copy(dataFiltered[d]);
                var actions = {
                    employees: function () {
                        dataFiltered[d].id = null;
                    },
                    movements: function () {
                        dataFiltered[d].id = null;
                        if (angular.isString(dataFiltered[d].status) && dataFiltered[d].status !== '' && !isNaN(dataFiltered[d].status)) {
                            dataFiltered[d].status = parseInt(dataFiltered[d].status);
                        } else {
                            dataFiltered[d].status = 4;
                        }
                        if (!dontRepeatData['employee-rp']) { dontRepeatData['employee-rp'] = {}; }
                        if (!dontRepeatData['cc']) { dontRepeatData['cc'] = {}; }
                        // obtener el rp del empleado para compararlo con los movimientos al final
                        var mainTask = {
                            index: d,
                            type: 'fbId',
                            value: item.empleados_id
                        };
                        var employeeRPTask = Object.assign({
                            ref: 'catalogs/employees/collection/' + item.empleados_id + '/rp',
                            field: 'employee-rp',
                            path: 'rp'
                        }, mainTask);
                        var employeeCCTask = Object.assign({
                            ref: 'catalogs/employees/collection/' + item.empleados_id + '/cc',
                            field: 'cc',
                            path: 'cc'
                        }, mainTask);
                        if (!dontRepeatData['employee-rp'].hasOwnProperty(employeeRPTask.value)) {
                            dontRepeatData['employee-rp'][employeeRPTask.value] = false;
                        }
                        if (!dontRepeatData['cc'].hasOwnProperty(employeeCCTask.value)) {
                            dontRepeatData['cc'][employeeCCTask.value] = false;
                        }
                        fbTasks.push(employeeRPTask);
                        fbTasks.push(employeeCCTask);
                    },
                    credits: function () {
                        dataFiltered[d].valid = false;
                        if (!dontRepeatData['rp']) dontRepeatData['rp'] = {};
                        if (!dontRepeatData['cc']) dontRepeatData['cc'] = {};
                        // obtener el rp y cc del empleado
                        var employeeRPTask1 = {
                            index: d,
                            field: 'rp',
                            path: 'rp',
                            type: 'fbQuery'
                        };
                        var employeeRPTask2 = {
                            index: d,
                            field: 'cc',
                            path: 'cc',
                            type: 'fbQuery'
                        };
                        if (!isNaN(item.empleados_id)) { // old id
                            employeeRPTask1.orderBy = 'data/employeeNumber';
                            employeeRPTask2.orderBy = 'data/employeeNumber';
                            employeeRPTask1.ref = 'catalogs/employees/collection';
                            employeeRPTask2.ref = 'catalogs/employees/collection';
                            employeeRPTask1.value = parseInt(item.empleados_id);
                            employeeRPTask2.value = parseInt(item.empleados_id);
                        } else { // new id
                            employeeRPTask1.ref = 'catalogs/employees/collection/' + item.empleados_id;
                            employeeRPTask2.ref = 'catalogs/employees/collection/' + item.empleados_id;
                            employeeRPTask1.value = item.empleados_id;
                            employeeRPTask2.value = item.empleados_id;
                        }

                        if (!dontRepeatData['rp'].hasOwnProperty(employeeRPTask1.value)) {
                            dontRepeatData['rp'][employeeRPTask1.value] = false;
                        }
                        if (!dontRepeatData['cc'].hasOwnProperty(employeeRPTask2.value)) {
                            dontRepeatData['cc'][employeeRPTask2.value] = false;
                        }
                        fbTasks.push(employeeRPTask1);
                        fbTasks.push(employeeRPTask2);
                        dataFiltered[d]['rp'] = null;
                        dataFiltered[d]['cc'] = null;
                    }
                };
                actions[type]();
                for (var h = 0; h < dataImportedHeaders.length; h++) {
                    var field = dataImportedHeaders[h];
                    if (item[field] === '') {
                        dataFiltered[d][field] = null;
                    }
                    if (item[field].search('Ñ') !== -1) {
                        item[field] = item[field].replace(/Ñ/g, 'Ñ');
                        dataFiltered[d][field] = angular.copy(item[field]);
                    }
                    if (item[field].search('�') !== -1) {
                        item[field] = item[field].replace(/�/g, 'Ñ');
                        dataFiltered[d][field] = angular.copy(item[field]);
                    }
                    if (inputTypes.inputs.hasOwnProperty(field)) {
                        if (inputTypes.inputs[field] === 'number') {
                            item[field] = parseFloat(item[field]);
                            dataFiltered[d][field] = angular.copy(item[field]);
                        }
                    }
                    if (inputTypes.fbAutocompletes.hasOwnProperty(field)) {
                        if (angular.isDefined(item[field])) {
                            if (item[field] === '') {
                                dataFiltered[d][field] = null;
                            } else {
                                var task = {
                                    index: d,
                                    field: field,
                                    type: 'fbId', // default
                                    value: item[field],
                                    ref: angular.copy(inputTypes.fbAutocompletes[field].getRef)
                                };
                                if (!dontRepeatData[field]) dontRepeatData[field] = {};
                                dontRepeatData[field][item[field]] = false;
                                if (!isNaN(item[field]) || inputTypes.fbAutocompletes[field].orderBy) {
                                    if (inputTypes.fbAutocompletes[field].parseInt) {
                                        task.value = parseInt(item[field]);
                                    }
                                    if (inputTypes.fbAutocompletes[field].orderBy) {
                                        task.type = 'fbQuery';
                                        task.setId = true;
                                        task.orderBy = inputTypes.fbAutocompletes[field].orderBy;
                                    } else {
                                        task.type = 'oldId';
                                    }
                                    task.oldId = item[field];
                                    task.path = inputTypes.fbAutocompletes[field].namePath;
                                    var thisFullRef = inputTypes.fbAutocompletes[field].getFullRef;
                                    var extraFieldsFullRef = angular.isArray(inputTypes.fbAutocompletes[field].extraFieldsFullRef) ? inputTypes.fbAutocompletes[field].extraFieldsFullRef : [];
                                    for (var i = 0; i < extraFieldsFullRef.length; i++) {
                                        var thisField = extraFieldsFullRef[i];
                                        var value = thisField.value;
                                        if (angular.isFunction(value)) {
                                            value = value();
                                        }
                                        thisFullRef = thisFullRef.replace("{" + thisField.path + "}", value);
                                    }
                                    task.ref = thisFullRef;
                                }
                                if (task.ref.search('<v>') > -1) {
                                    if (isNaN(item[field])) {
                                        task.ref = task.ref.replace('<v>', item[field]);
                                    }
                                }
                                if (task.ref.search('<z>') > -1) {
                                    var relFieldZ = task.ref.match(/<z>(.*?)<\/z>/g) + '';
                                    var relField = relFieldZ.replace('<z>', '');
                                    relField = relField.replace('</z>', '');
                                    task.ref = task.ref.replace(relFieldZ, item[relField]);
                                }
                                fbTasks.push(task);
                                dataFiltered[d][field] = angular.copy(item[field]);
                            }
                        }
                    } else if (inputTypes.mongoAutocompletes.hasOwnProperty(field)) {
                        if (angular.isDefined(item[field])) {
                            if (item[field] === "") {
                                dataFiltered[d][field] = null;
                            } else {
                                var mtask = {
                                    index: d,
                                    field: field,
                                    type: 'mongoId',
                                    value: item[field],
                                    catalog: inputTypes.mongoAutocompletes[field].catalog,
                                    query: inputTypes.mongoAutocompletes[field].query
                                };
                                if (!dontRepeatData[field]) dontRepeatData[field] = {};
                                dontRepeatData[field][item[field]] = false;
                                if (!isNaN(item[field]) && Object.keys(mtask.query).length > 0) {
                                    var hsC = JSON.parse(JSON.stringify(mtask.query));
                                    mtask.oldId = item[field];
                                    mtask.type = 'oldId';
                                    var thisQueryField = {};
                                    for (var param in hsC) {
                                        var thisValue = hsC[param];
                                        if (thisValue.indexOf('<v>') > -1) {
                                            thisValue = thisValue.replace('<v>', item[field])
                                        }
                                        thisQueryField[param] = thisValue;
                                    }
                                    mtask.query = thisQueryField;
                                } else {
                                    mtask.query = {
                                        _id: item[field]
                                    };
                                }
                                mTasks.push(mtask);
                                dataFiltered[d][field] = angular.copy(item[field]);
                            }
                        }
                    } else if (inputTypes.switchs.hasOwnProperty(field)) {
                        if (angular.isDefined(item[field]) && item[field] !== '') {
                            $log.log(field, item[field]);
                            dataFiltered[d][field] = (item[field] === "1" || item[field] === "true") ? true : false;
                        }
                    } else if (inputTypes.inputs.hasOwnProperty(field)) {
                        if (angular.isDefined(item[field])) {
                            if (inputTypes.inputs[field] === 'number') {
                                if (inputTypes.unique[field]) {
                                    if (isNaN(item[field]) || item[field] === '') {
                                        dataFiltered[d][field] = null;
                                    } else {
                                        var fbutask = {
                                            index: d,
                                            field: field,
                                            type: 'fbUnique',
                                            value: parseFloat(item[field]),
                                            ref: inputTypes.unique[field].ref,
                                            query: inputTypes.unique[field].query
                                        };
                                        if (!dontRepeatData[field]) dontRepeatData[field] = {};
                                        dontRepeatData[field][item[field]] = false;
                                        fbTasks.push(fbutask);
                                        dataFiltered[d][field] = parseFloat(angular.copy(item[field]));
                                    }
                                }
                                else {
                                    if (isNaN(item[field]) || item[field] === '') {
                                        dataFiltered[d][field] = null;
                                    } else {
                                        dataFiltered[d][field] = parseFloat(angular.copy(item[field]) + '');
                                    }
                                }
                            } else {
                                if (inputTypes.unique[field]) {
                                    if (isNaN(item[field]) || item[field] === '') {
                                        dataFiltered[d][field] = null;
                                    } else {
                                        var fbutask2 = {
                                            index: d,
                                            field: field,
                                            type: 'fbUnique',
                                            value: item[field],
                                            ref: inputTypes.unique[field].ref,
                                            query: inputTypes.unique[field].query
                                        };
                                        if (!dontRepeatData[field]) dontRepeatData[field] = {};
                                        dontRepeatData[field][item[field]] = false;
                                        fbTasks.push(fbutask2);
                                        dataFiltered[d][field] = angular.copy(item[field]);
                                    }
                                }
                                else {
                                    if (item[field] === '') {
                                        dataFiltered[d][field] = null;
                                    } else {
                                        if (isNaN(item[field])) {
                                            dataFiltered[d][field] = null;
                                        }
                                        dataFiltered[d][field] = angular.copy(item[field]) + '';
                                    }
                                }
                            }
                        }
                    } else if (inputTypes.datepickers.hasOwnProperty(field)) {
                        if (angular.isDefined(item[field])) {
                            dataFiltered[d][field] = moment(item[field], ['DD/MM/YY HH:mm', 'DD/MM/YYYY HH:mm:ss', 'DD-MM-YYYY HH:mm:ss', 'YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD', 'DD/MM/YYYY', 'DD/MM/YY'], true);
                            if (dataFiltered[d][field].isValid()) {
                                dataFiltered[d][field] = dataFiltered[d][field].toDate();
                            } else {
                                dataFiltered[d][field] = null;
                            }
                        }
                    }
                }
            }
            $log.log(angular.fromJson(angular.toJson(mTasks)));

            var insertMTaskPromise = function (ind2, fieldN, task) {
                var prom2 = $q.defer();
                var status = false;
                var prop = inputTypes.mongoAutocompletes[fieldN].selectUse;
                if (task.type === 'mongoId') {
                    if (task.query && task.query._id) {
                        prom2.notify('About to DataF catalog ' + task.catalog);
                        if (!dontRepeatData[fieldN][task.value]) {
                            dontRepeatData[fieldN][task.value] = {
                                promise: DataF.api.get(task.catalog + '/' + task.query._id)
                            };
                        }
                        dontRepeatData[fieldN][task.value].promise.then(function (data) {
                            if (data.data) {
                                dataFiltered[ind2][fieldN + '-name'] = data.data.name;
                                dataFiltered[ind2][fieldN + '-object'] = {
                                    name: data.data.name
                                };
                                dataFiltered[ind2][fieldN + '-object'][prop] = task.query._id;
                                status = true;
                                dontRepeatData[fieldN][task.value].name = dataFiltered[ind2][fieldN + '-name'];
                                dontRepeatData[fieldN][task.value].object = dataFiltered[ind2][fieldN + '-object'];
                                dontRepeatData[fieldN][task.value][prop] = task.query._id;
                            } else {
                                dataFiltered[ind2][fieldN] = false;
                                dataFiltered[ind2][fieldN + '-name'] = null;
                                dataFiltered[ind2][fieldN + '-object'] = null;
                            }
                            prom2.resolve({
                                status: status,
                                task: task,
                                i: ind2,
                                field: fieldN
                            });
                        }, function (err) {
                            $log.error(err, 'Something went wrong in request to mongo:', task);
                            prom2.reject(err);
                        });
                    } else {
                        return false;
                    }
                } else {
                    if (task.oldId) {
                        prom2.notify('About to DataF old id catalog ' + task.catalog);
                        if (!dontRepeatData[fieldN][task.value]) {
                            dontRepeatData[fieldN][task.value] = {
                                promise: DataF.api.get(task.catalog, task.query)
                            };
                        }
                        dontRepeatData[fieldN][task.value].promise.then(function (data2) {
                            if (data2.data[0]) {
                                dataFiltered[ind2][fieldN] = data2.data[0][prop];
                                dataFiltered[ind2][fieldN + '-name'] = data2.data[0].name;
                                dataFiltered[ind2][fieldN + '-object'] = {
                                    name: data2.data[0].name
                                };
                                dataFiltered[ind2][fieldN + '-object'][prop] = data2.data[0][prop];
                                status = true;
                                dontRepeatData[fieldN][task.value].name = dataFiltered[ind2][fieldN + '-name'];
                                dontRepeatData[fieldN][task.value].object = dataFiltered[ind2][fieldN + '-object']
                                dontRepeatData[fieldN][task.value][prop] = dataFiltered[ind2][fieldN];
                            } else {
                                dataFiltered[ind2][fieldN] = false;
                                dataFiltered[ind2][fieldN + '-name'] = null;
                                dataFiltered[ind2][fieldN + '-object'] = null;
                            }
                            prom2.resolve({
                                status: status,
                                task: task,
                                i: ind2,
                                field: fieldN
                            });
                        }, function (err) {
                            $log.error(err, 'Something went wrong in request to mongo:', task);
                            prom2.reject(err);
                        });
                    } else {
                        return false;
                    }
                }

                return promises.push(prom2.promise);
            }

            var insertFBTaskPromise = function (ref, ind, fieldN, task, typeOfTask) {
                // insertFBTaskPromise(fbtask.ref, parseInt(fbtask.index + ''), fbtask.field, fbtask, fbtask.type);
                // catalogs/payrolls/collection 0 "nominas_id" {} fbQuery
                var prom;
                var status = false;
                if (typeOfTask === 'fbId') { // with listRef
                    prom = $q.defer();
                    // $log.debug(ref, task, i, fieldN, 'ref, task, i, field to be inserted in FB promises');
                    prom.notify('About to FB ref ' + ref);
                    if (!dontRepeatData[fieldN][task.value]) {
                        AppF.root.child(ref).once('value', function (snap) {
                            var val = snap.val();
                            // dataFiltered[ind][fieldN] = task.value;
                            if (val !== null) {
                                if (angular.isUndefined(dataFiltered[ind][fieldN])) {
                                    dataFiltered[ind][fieldN] = val;
                                }
                                dataFiltered[ind][fieldN + '-name'] = val;
                                dataFiltered[ind][fieldN + '-object'] = { name: val, $id: task.value };
                                // $log.debug('name of ref from FB', dataFiltered[ind][fieldN], dataFiltered[ind][fieldN + '-name']);
                                status = true;
                                dontRepeatData[fieldN][task.value] = {
                                    $id: dataFiltered[ind][fieldN],
                                    name: dataFiltered[ind][fieldN + '-name'],
                                    object: dataFiltered[ind][fieldN + '-object']
                                };
                            } else {
                                dataFiltered[ind][fieldN + '-name'] = null;
                                dataFiltered[ind][fieldN + '-object'] = null;
                                // $log.debug('name of ' + fieldN + ' not found in FB ref: ' +  ref, task);
                            }
                            prom.resolve({
                                status: status,
                                task: task,
                                ref: ref,
                                i: ind,
                                field: fieldN
                            });
                        }, function (err) {
                            $log.error(err, 'Something went wrong in request to ref:', ref);
                            prom.reject(err);
                        });
                    } else {
                        dataFiltered[ind][fieldN] = dontRepeatData[fieldN][task.value].$id;
                        dataFiltered[ind][fieldN + '-name'] = dontRepeatData[fieldN][task.value].name;
                        dataFiltered[ind][fieldN + '-object'] = dontRepeatData[fieldN][task.value].object;
                        prom.resolve({
                            status: status,
                            task: task,
                            i: ind,
                            field: fieldN
                        });
                    }
                    promises.push(prom.promise);
                    return true;
                } else
                    if (typeOfTask === 'oldId') { // oldId with fullRef
                        prom = $q.defer();
                        // $log.debug(ref, task, i, fieldN, 'ref, task, i, field to be inserted in FB promises OLD');
                        prom.notify('About to FB oldId ref ' + ref + ' -> ' + task.oldId);
                        var oldId = (angular.isString(task.oldId)) ? parseInt(task.oldId) : task.oldId;
                        var path = (task.path) ? task.path : 'data.name';
                        if (!dontRepeatData[fieldN][task.value]) {
                            AppF.root.child(ref).orderByChild('data/created/sqlId').equalTo(oldId).once('value', function (snaps2) {
                                var supVal = snaps2.val();
                                if (supVal !== null) {
                                    snaps2.forEach(function (snap) {
                                        var val = snap.val();
                                        dataFiltered[ind][fieldN] = snap.key;
                                        if (val) {
                                            var pathOfName = pathInObjFilter(val, path);
                                            if (fieldN === 'empleados_id') {
                                                dataFiltered[ind][fieldN + '-name'] = (pathOfName) ? pathOfName : null;
                                            } else {
                                                dataFiltered[ind][fieldN + '-name'] = (pathOfName) ? pathOfName : null;
                                            }

                                            dataFiltered[ind][fieldN + '-object'] = (pathOfName) ? { name: pathOfName, $id: snap.key } : { name: '' };
                                            // $log.debug('name of ref from FB', dataFiltered[ind][fieldN], dataFiltered[ind][fieldN + '-name']);
                                            status = (pathOfName);
                                            dontRepeatData[fieldN][task.value] = {
                                                $id: snap.key,
                                                name: dataFiltered[ind][fieldN + '-name'],
                                                object: dataFiltered[ind][fieldN + '-object']
                                            };
                                        }
                                        else {
                                            dataFiltered[ind][fieldN + '-name'] = null;
                                            dataFiltered[ind][fieldN + '-object'] = null;
                                            // $log.debug('name of oldId ' + fieldN + ' not found in FB ref: ' + ref, task);
                                        }
                                    });
                                } else {
                                    dataFiltered[ind][fieldN] = null; // 
                                    dataFiltered[ind][fieldN + '-name'] = null;
                                    dataFiltered[ind][fieldN + '-object'] = null;
                                }
                                prom.resolve({
                                    status: status,
                                    task: task,
                                    ref: ref,
                                    i: ind,
                                    field: fieldN
                                });

                            }, function (err) {
                                $log.error(err, 'Something went wrong in request to ref:', ref);
                                prom.reject(err);
                            });
                        } else {
                            dataFiltered[ind][fieldN] = dontRepeatData[fieldN][task.value].$id;
                            dataFiltered[ind][fieldN + '-name'] = dontRepeatData[fieldN][task.value].name;
                            dataFiltered[ind][fieldN + '-object'] = dontRepeatData[fieldN][task.value].object;
                            prom.resolve({
                                status: status,
                                task: task,
                                i: ind,
                                field: fieldN
                            });
                        }
                        promises.push(prom.promise);
                        return true;
                    } else
                        if (typeOfTask === 'fbUnique') { // just id
                            prom = $q.defer();
                            prom.notify('About to FB unique ref ' + ref + ' -> ' + task.value);
                            AppF.root.child(ref).orderByChild(task.query).equalTo(task.value).limitToFirst(1).once('value', function (snaps) {
                                var isNotOk = snaps.val();
                                if (isNotOk === null) {
                                    status = true;
                                } else {
                                    if (!dataFiltered[ind].hasOwnProperty('config')) { dataFiltered[ind].config = { validations: {} }; }
                                    dataFiltered[ind].config.validations[fieldN] = 'registro importado previamente';
                                    dataFiltered[ind].config.valid = false;
                                    snaps.forEach(function (rr) {
                                        dataFiltered[ind][fieldN + '-unique'] = {
                                            old: angular.copy(task.value),
                                            new: rr.key
                                        };
                                    });
                                }
                                prom.resolve({
                                    status: status,
                                    task: task,
                                    ref: ref,
                                    i: ind,
                                    field: fieldN
                                });
                            }, function (err) {
                                $log.error(err, 'Something went wrong in request to ref unique:', ref);
                                prom.reject(err);
                            });
                            promises.push(prom.promise);
                            return true;
                        } else
                            if (typeOfTask === 'fbQuery') { // full query
                                prom = $q.defer();
                                // $log.debug(ref, task, i, fieldN, 'ref, task, i, field to be inserted in FB promises');
                                prom.notify('About to FB ref ' + ref);
                                if (!dontRepeatData[fieldN][task.value]) {
                                    if (task.orderBy) {
                                        AppF.root.child(ref).orderByChild(task.orderBy).equalTo(task.value).limitToFirst(1).once('value', function (records) {
                                            if (records.val() !== null) {
                                                // dataFiltered[ind][fieldN] = dontRepeatData[fieldN][task.value].$id;
                                                // dataFiltered[ind][fieldN + '-name'] = dontRepeatData[fieldN][task.value].name;
                                                // dataFiltered[ind][fieldN + '-object'] = dontRepeatData[fieldN][task.value].object;
                                                records.forEach(function (record) {
                                                    var val = pathInObjFilter(record.val(), task.path);
                                                    if (task.setId) {
                                                        dataFiltered[ind][fieldN] = record.key;
                                                        dataFiltered[ind][fieldN + '-name'] = val;
                                                        dataFiltered[ind][fieldN + '-object'] = { name: val, $id: record.key };
                                                    } else {
                                                        dataFiltered[ind][fieldN] = val;
                                                    }
                                                    dontRepeatData[fieldN][task.value] = dataFiltered[ind][fieldN];
                                                    status = true;
                                                    prom.resolve({
                                                        status: status,
                                                        task: task,
                                                        ref: ref,
                                                        i: ind,
                                                        field: fieldN
                                                    });
                                                });
                                            } else {
                                                status = false;
                                                dataFiltered[ind][fieldN] = null;
                                                $log.error('Something went wrong in request to ref in fbQuery:', ref, task);
                                                errAlertS('No se encuentra ' + task.path + ' de registro ' + task.value);
                                                prom.resolve({
                                                    status: status,
                                                    task: task,
                                                    ref: ref,
                                                    i: ind,
                                                    field: fieldN
                                                });
                                                // prom.reject();
                                            }
                                        }, function (err) {
                                            $log.error(err, 'Something went wrong in request to ref in fbQuery:', ref);
                                            prom.reject(err);
                                        });
                                    } else {
                                        AppF.root.child(ref).child(task.path).once('value', function (valueNeeded) {
                                            if (valueNeeded.val() !== null) {
                                                var val = valueNeeded.val();
                                                dataFiltered[ind][fieldN] = val;
                                                status = true;
                                                dontRepeatData[fieldN][task.value] = dataFiltered[ind][fieldN];
                                                prom.resolve({
                                                    status: status,
                                                    task: task,
                                                    ref: ref,
                                                    i: ind,
                                                    field: fieldN
                                                });
                                            } else {
                                                status = false;
                                                dataFiltered[ind][fieldN] = null;
                                                $log.error('Something went wrong in request to ref in fbQuery:', ref, task);
                                                errAlertS('No se encuentra ' + task.path + ' de registro ' + task.value);
                                                prom.resolve({
                                                    status: status,
                                                    task: task,
                                                    ref: ref,
                                                    i: ind,
                                                    field: fieldN
                                                });
                                                // prom.reject();
                                            }
                                        }, function (err) {
                                            $log.error(err, 'Something went wrong in request to ref in fbQuery 2:', ref);
                                            prom.reject(err);
                                        });
                                    }
                                } else {
                                    dataFiltered[ind][fieldN] = dontRepeatData[fieldN][task.value];
                                    prom.resolve({
                                        status: status,
                                        task: task,
                                        i: ind,
                                        field: fieldN
                                    });
                                }
                                promises.push(prom.promise);
                                return true;
                            }
                return false;
            }

            for (var ii in fbTasks) {
                var fbtask = fbTasks[ii];
                insertFBTaskPromise(fbtask.ref, parseInt(fbtask.index + ''), fbtask.field, fbtask, fbtask.type);
            }

            for (var iii in mTasks) {
                var motask = mTasks[iii];
                insertMTaskPromise(parseInt(motask.index + ''), motask.field, motask);
            }

            $q.all(promises)
                .then(function () {
                    promiseG.resolve(dataFiltered);
                }).catch(function (err) {
                    errAlertS(err);
                    promiseG.reject(err);
                });

            return promiseG.promise;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.core')
        .filter('onlySatIncidences', onlySatIncidences)

    function onlySatIncidences() {

        return onlySatIncidencesFn;

        function onlySatIncidencesFn(array) {
            var incidences=[];
            angular.forEach(array,function(incidence,key){
                if(!incidence.isConcept){
                    incidences.push(incidence)
                }
            })
            return incidences;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.config')
        .filter('getUsersOfGroup', getUsersOfGroup)

    function getUsersOfGroup() {

        return getUsersOfGroupFn;

        function getUsersOfGroupFn(users) {
            var newUsers = [];
            angular.forEach(users, function(user, index) {
                newUsers.push(index);
            })
            return newUsers;
        }
    }
}());
(function(){
    'use strict';

    angular
        .module('app.config')
        .filter('notificableActions', notificableActions)

    function notificableActions(){

        return notificableActionsFn;

        function notificableActionsFn(actions){
            var notificableActions = [];
            for(var a in actions){
                var action = a;
                if(['update', 'create', 'remove', 'archive', 'deleteCredit', 'review', 'sendIdse', 'sendSua', 'editCredit'].indexOf(action) !== -1) notificableActions.push(action);
            }

            return notificableActions;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.config')
        // .directive ('filterConstantsClients', filterConstantsClients)
        .directive ('filterConstantsPayrolls', filterConstantsPayrolls)
        .directive ('filterConstantsCcs', filterConstantsCcs)
        .directive ('filterConstantsEmployees', filterConstantsEmployees)
        .directive ('filterConstantsPlacesofwork', filterConstantsPlacesofwork)
        ;

    /** @ngInject */
    // function filterConstantsClients() {
    //     return {
    //         restrict: 'A',
    //         replace: true,
    //         templateUrl: 'app/main/config/views/constants/filters/clients.html'
    //     }
    // }
    /** @ngInject */
    function filterConstantsPayrolls() {
        return {
            restrict: 'A',
            replace: true,
            templateUrl: 'app/main/config/views/constants/filters/payrolls.html'
        }
    }
    /** @ngInject */
    function filterConstantsCcs() {
        return {
            restrict: 'A',
            replace: true,
            templateUrl: 'app/main/config/views/constants/filters/ccs.html'
        }
    }
    /** @ngInject */
    function filterConstantsEmployees() {
        return {
            restrict: 'A',
            replace: true,
            templateUrl: 'app/main/config/views/constants/filters/employees.html'
        }
    }
    /** @ngInject */
    function filterConstantsPlacesofwork() {
        return {
            restrict: 'A',
            replace: true,
            templateUrl: 'app/main/config/views/constants/filters/placesofwork.html'
        }
    }

} ());
(function(){
    'use strict';

    angular
        .module('app.config')
        .filter('constantsBy', constantsBy)

    function constantsBy(){

        return constantsByFn;

        function constantsByFn(tabName){
            var byName = '';
            switch(tabName){
                case 'general': byName = 'Generales'; break;
                case 'placeOfWork': byName = 'por Lugar de Trabajo'; break;
                case 'payroll': byName = 'por Nómina'; break;
                case 'cc': byName = 'por CC'; break;
                case 'employee': byName = 'por Empleado'; break;
            }

            return byName;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .controller('responseXmlController', responseXmlController);

    function responseXmlController(
        $mdDialog,
        selected,
        ListsF,
        AppF,
        $rootScope,
        successAlertS,
        $log,
        ApiV3F,
        $q,
        errAlertS
    ) {
        var vm = this;
        vm.close = function () {
            $mdDialog.cancel();
        };
        function updateSatMeta(xmlSatMeta) {
            var status;
            if (xmlSatMeta.requestId && !xmlSatMeta.responseIds) {
                status = 1;
            }
            if (xmlSatMeta.requestId && xmlSatMeta.responseIds) {
                status = 5;
            }
            if (!xmlSatMeta.requestId && !xmlSatMeta.responseIds) {
                status = 0;
            }
            var data = { status: status };
            $log.log(data, 'data to update status');
            return ApiV3F.put('api/xmlSatMetas/' + xmlSatMeta._id, data).then(function () {
                var task = {
                    type: "xml-sat-metas-queue",
                    action: "retrySatXmlProcessing",
                    data: {
                        dateEnd: xmlSatMeta.endDate,
                        companiesRecordId: xmlSatMeta.companiesRecordId,
                        timestamp: xmlSatMeta.timestamp,
                        xmlStatus: xmlSatMeta.xmlStatus
                    }
                };
                $log.log('Se agrego actualizo la cola', task);
                return ApiV3F.post('queue/add', task)
            })
        }

        vm.answer = function () {
            var promises = [];
            $log.log('Tareas seleccionada para reintentar:', selected);
            $rootScope.loadingProgress = true;
            angular.forEach(selected, function (xmlSatMeta) {
                promises.push(updateSatMeta(xmlSatMeta))
            });
            $q.all(promises).then(function () {
                $mdDialog.hide();
                successAlertS('Se agregaron a la cola de tareas, esto puede tardar algunos minutos.');
            }).catch(function (err) {
                $log.error('Error en alguna petición', err);
                errAlertS('Ocurrió un error al procesar alguna compañía.');
            }).finally(function () {
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
            });
        };
    }


})();
(function(){
    'use strict';

    angular
        .module('app.clients')
        .filter('periodsHaveActiveOperations', periodsHaveActiveOperations)

    function periodsHaveActiveOperations(
        AppF,
        $q
    ){

        function queryOperationsOfPeriod(period, payroll, year){
            var promise = $q.defer();
            // las extraordinarias no pertenecen a ningún periodo
            var ref = 'catalogs/operations/ordinary/' + payroll + '/' + year + '/collection';
            var operationIds = [];
            AppF.root.child(ref).orderByChild('period').equalTo(period).once('value', function(results){
                var activeOperations = [];
                results.forEach(function(snap){
                    var operation = snap.val();
                    if(operation != null){ // si tiene status diferente a -1 o 0 se considera activa o true
                        operationIds.push(snap.key);
                        activeOperations.push(operation.status > 0);
                    } else {
                        activeOperations.push(false);
                    }
                });
                // hacer validacion y reject o resolve -> si no hay alguna activa = true
                if(activeOperations.indexOf(true) == -1){
                    // no tiene operaciones activas
                    promise.resolve({
                        activeOperations: false,
                        operationIds: operationIds,
                        period: period
                    });
                } else {
                    // tiene operaciones activas
                    promise.resolve({
                        activeOperations: true,
                        operationIds: operationIds,
                        period: period
                    });
                }
            }, function(err){
                promise.reject(err);
            })
            return promise.promise;
        }

        return periodsHaveActiveOperationsFn;

        function periodsHaveActiveOperationsFn(periods, payroll, year){
            var haveActiveOperations = $q.defer();
            var requests = [];
            for(var p in periods){
                var period = periods[p];
                requests.push(queryOperationsOfPeriod(period.period, payroll, year));
            }
            $q.all(requests).then(function(all){
                // console.log(all, all.indexOf(false), "NICE");
                var haveOperations = false;
                var operationIds = {};
                for(var a in all){
                    var activeOperationsOfPeriod = all[a];
                    if(activeOperationsOfPeriod.activeOperations){
                        haveOperations = true;
                    }
                    operationIds[activeOperationsOfPeriod.period] = activeOperationsOfPeriod.operationIds;
                } 
                haveActiveOperations.resolve({
                    activeOperations: haveOperations,
                    operationIds: operationIds
                });
            }, function(err){
                haveActiveOperations.reject(err);
            });
            return haveActiveOperations.promise;
        }
    }

}());
(function(){
    'use strict';

    angular
        .module('app.clients')
        .filter('getFirstDateOfPeriods', getFirstDateOfPeriods)

    function getFirstDateOfPeriods(){

        return getFirstDateOfPeriodsFn;

        function getFirstDateOfPeriodsFn(periods){
            var dates = {
                first: 99999999999999999,
                last: 0,
                firstString: '',
                lastString: ''
            }
            for(var p in periods){
                if(periods[p].start < dates.first) {
                    dates.first = periods[p].start;
                    dates.firstString = moment(periods[p].start).format('DD/MM/YYYY');
                }
                if(periods[p].end > dates.last) {
                    dates.last = periods[p].end;
                    dates.lastString = moment(periods[p].end).format('DD/MM/YYYY');
                }
            }

            return dates;
        }
    }

}());
(function(){
    'use strict';

    angular
        .module('app.clients')
        .filter('operationsOfPeriod', operationsOfPeriod);

    function operationsOfPeriod(){

        return operationsOfPeriodFn;

        function operationsOfPeriodFn(operations, period){
            var operationsS = [];
            for(var o in operations){
                var operation = operations[o];
                
                if(operation.period == period) {
                    operationsS.push(operation);
                }
            }
            return operationsS;
        }
    }

}());
(function(){
    'use strict';

    angular
        .module('app.clients')
        .filter('nameOfStatusOperation', nameOfStatusOperation)

    function nameOfStatusOperation(AppF){

        return nameOfStatusOperationFn;

        function nameOfStatusOperationFn(status, path){
            var pathName = (path) ? path : 'name';
            for(var s in AppF.operationStatatuss){
                if(status == -1) return 'Sin abrir';
                if(AppF.operationStatatuss[s].id == status) return AppF.operationStatatuss[s][pathName];
            }
            return '';
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getFromObjectField', getFromObjectField);

    function getFromObjectField(loopEachFilter) {

        return getFromObjectFieldFn;

        function getFromObjectFieldFn(obj, field, defaultValue) {
            var value;
            if (angular.isObject(obj) && obj !== null && angular.isString(field)) {
                loopEachFilter(obj, function (data) {
                    if (angular.isDefined(data) && angular.isDefined(data[field])) {
                        value = data[field];
                    } else {
                        value = defaultValue;
                    }
                });
            } else {
                value = angular.isDefined(defaultValue) ? defaultValue : "N/A";
            }
            return value;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module ('app.clients')
        .directive ('filterOperationsCalendars', filterOperationsCalendars)
        .directive ('filterOperationsPeriods', filterOperationsPeriods)
        .directive ('filterOperationsStatus', filterOperationsStatus)
        ;


    /** @ngInject */
    function filterOperationsCalendars() {
        return {
            restrict: 'A',
            replace: true,
            templateUrl: 'app/main/clients/views/operations/filters/calendars.html'
        }
    }
    /** @ngInject */
    function filterOperationsPeriods() {
        return {
            restrict: 'A',
            replace: true,
            templateUrl: 'app/main/clients/views/operations/filters/periods.html'
        }
    }
    /** @ngInject */
    function filterOperationsStatus() {
        return {
            restrict: 'A',
            replace: true,
            templateUrl: 'app/main/clients/views/operations/filters/status.html'
        }
    }

} ());
(function(){
    'use strict';

    angular
        .module('app.clients')
        .filter('datesOfPeriod', datesOfPeriod)

    function datesOfPeriod(dateFilter){

        return datesOfPeriodFn;

        function datesOfPeriodFn(period, periods){
            var dates = '';
            for(var p in periods){
                var periodo = periods[p];
                if(periodo.period == period) dates += dateFilter(periodo.start,'dd/MM/yyyy') + ' - ' + dateFilter(periodo.end,'dd/MM/yyyy');
            }
            return dates;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('checkOpeOrdinaryAccess', checkOpeOrdinaryAccess)

    function checkOpeOrdinaryAccess(DataF) {

        return checkOpeOrdinaryAccessFn;

        function checkOpeOrdinaryAccessFn(operation) {
            return new Promise(function (resolve, reject) {
                try {
                    var promises = [];
                    var period = parseInt(operation.period) - 1;
                    if (operation.status < 3 && period > 0) {
                        promises.push(DataF.api.get('operations', { operationType: 'ordinary', payroll: operation.payroll, 'calendar': 'parseNumber' + operation.calendar, 'period': 'parseNumber' + period }))
                    }
                    Promise.all(promises).then(function (resp) {
                        if (resp.length > 0 && resp[0].data.length > 0) {
                            var previousOperation = resp[0].data[0];
                            if (previousOperation.status < 3) {
                                throw 'Se debe cerrar la operación anterior para poder trabajar con la siguiente';
                            }
                        }
                        resolve(true)
                    }).catch(reject)
                } catch (error) {
                    reject(error)
                }
            })
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .controller('ForceBillsController', ForceBillsController);

    function ForceBillsController($log, AppF, $rootScope, operation, $mdDialog, successAlertS, errAlertS) {
        var vm = this;

        function init() {
            vm.operations();
        }

        vm.operations = function () {
            var dataEmployee = operation.employees;
            var list = []
            for (var key in dataEmployee) {
                dataEmployee[key].$id = key;
                list.push(dataEmployee[key]);
            }
            var employeeError = [];
            for (var i = 0; i < list.length; i++) {
                if (list[i].status !== 5) {
                    var err;
                    if (list[i].errorMsg) {
                        err = list[i].errorMsg.split(',')[0];
                    }
                    var message = list[i].errorMsg;
                    AppF.root.child('catalogs/employees/collection/' + list[i].$id).once('value').then(function (resp) {
                        var obj = {
                            name: resp.val().data.name,
                            error: err ? err : 'error en los detalles',
                            msgError: message ? message : 'error en los detalles'
                        };
                        employeeError.push(obj);
                    });
                }
            }
            vm.employeeError = employeeError;
        }

        vm.saveBills = function () {
            $rootScope.loadingProgress = true;
            $rootScope.$evalAsync();
            var path;
            var operationType = operation.operationType || 'ordinary';
            if (operationType === 'ordinary') {
                path = "catalogs/operations/ordinary/" + operation.payroll + "/" + operation.calendar + "/collection/" + operation.fid + "/status"
            } else {
                path = "catalogs/operations/" + operation.operationType + "/all/" + operation.fid + "/status"
            }
            var promise = AppF.root.child(path).set(6)
            promise.then(function (resp) {
                $log.log('promises', resp)
                $mdDialog.hide();
                $rootScope.$evalAsync();
                $rootScope.loadingProgress = false;
                successAlertS('Se ha cambiado el status correctamente')
            }).catch(function (error) {
                $rootScope.$evalAsync();
                $rootScope.loadingProgress = false;
                errAlertS(error);
            })
        }

        vm.close = function () {
            $mdDialog.hide();
        }


        init()
    }
})();
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('validateMovements', validateMovements);

    function validateMovements($filter, $log) {
        return validateMovementsFn;
        function validateMovementsFn(lastMovementInMovements, lastMovementInEmployee, thisEmployee, movements, payrollId) {
            if (angular.isDefined(lastMovementInMovements) && angular.isDefined(lastMovementInEmployee) && lastMovementInEmployee.$id !== lastMovementInMovements.$id) {
                if (lastMovementInEmployee.d > lastMovementInMovements.data.date && lastMovementInEmployee.p !== lastMovementInMovements.payroll) {
                    $log.debug(thisEmployee.data.name, 'tiene un movimiento con id', lastMovementInEmployee.$id, 'y fecha', $filter('date')(lastMovementInEmployee.d, 'shortDate'), 'mayor al movimiento con id', lastMovementInMovements.$id, 'con fecha', $filter('date')(lastMovementInMovements.data.date, 'shortDate'));
                    var founded = $filter('filter')(movements, {
                        $id: lastMovementInMovements.$id
                    });
                    if (founded.length) {
                        var index = movements.indexOf(founded[0]);
                        movements.splice(index, 1);
                    } else {
                        $log.error('No se encontró el movimiento de', thisEmployee.data.name, 'en sus movementsGrouped');
                    }
                } else if (lastMovementInEmployee.d > lastMovementInMovements.data.date && lastMovementInEmployee.p === lastMovementInMovements.payroll) {
                    $log.error(thisEmployee.data.name, 'tiene un movimiento registrado en employee.movements con id', lastMovementInEmployee.$id, ' de esta nomina que no se añadió a la consulta de movimientos');
                } else if (lastMovementInEmployee.d < lastMovementInMovements.data.date) {
                    $log.error(thisEmployee.data.name, 'tiene un movimiento registrado en movements con id', lastMovementInMovements.$id, 'que no se encuentra registrado en employee.movements');
                }
            } else if (angular.isDefined(lastMovementInEmployee) && lastMovementInEmployee.t !== 2 && lastMovementInEmployee.p === payrollId && lastMovementInEmployee.$id !== lastMovementInMovements.$id) {
                $log.error(thisEmployee.data.name, 'tiene un movimiento registrado en employee.movements de esta nomina que no se añadió a la consulta de movimientos', lastMovementInEmployee);
            }
            movements = $filter('orderBy')(movements, ['data.date', 'data.type']);
            var lastDate;
            var removeIndex = [];
            for (var v = 0; v < movements.length; v++) {
                var thisMovement = movements[v];
                var thisDate = moment(thisMovement.data.date);
                if (angular.isUndefined(lastDate)) {
                    lastDate = thisDate.format('DD-MM-YYYY');
                } else {
                    if (lastDate === thisDate.format('DD-MM-YYYY')) {
                        removeIndex.push(v - 1);
                    } else {
                        lastDate = thisDate.format('DD-MM-YYYY');
                    }
                }
            }
            for (var i = removeIndex.length - 1; i >= 0; i--) {
                movements.splice(removeIndex[i], 1);
            }
            return movements;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('transformCalculations', transformCalculations);

    function transformCalculations($log, clearObjectFilter, loopEachFilter, getFromObjectFilter) {

        return transformCalculationsFn;
        function transformCalculationsFn(dispersion) {
            var dispersionT;
            if (angular.isObject(dispersion) && dispersion !== null) {
                dispersionT = clearObjectFilter(dispersion);
                // $log.log(dispersionT, dispersion);
                loopEachFilter(getFromObjectFilter(dispersionT, 'employeesData.calculations', {}), function (employeeCalculations, employeeId) {
                    loopEachFilter(employeeCalculations, function (calculation, conceptKey) {
                        if (angular.isString(calculation)) {
                            dispersionT.employeesData.calculations[employeeId][conceptKey] = angular.fromJson(calculation);
                        }
                    });
                });
            }
            return dispersionT;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('setThisBankAccounts', setThisBankAccounts);

    function setThisBankAccounts(MongoF, loopEachFilter, errAlertS) {

        return setThisBankAccountsFn;

        function setThisBankAccountsFn(payroll, operationType) {
            var obj = {};
            if (operationType === 'asimilated') {
                payroll.processes.FISCAL.bankAccounts = payroll.processes.ASIMILADOS.bankAccounts || [];
            }
            if (operationType === 'ptuRecord' && payroll.processes.PTU && payroll.processes.PTU.companiesRecord) {
                payroll.processes.FISCAL.bankAccounts = payroll.processes.PTU.bankAccounts || [];
            }
            loopEachFilter(payroll.processes, function (data, item) {
                if (angular.isDefined(data.bankAccounts)) {
                    obj[data.id] = [];
                    for (var b = 0; b < data.bankAccounts.length; b++) {
                        var bankAccountId = data.bankAccounts[b];
                        var thisBankAccount = MongoF.bankAccounts.find(function (item) {
                            return item._id === bankAccountId;
                        });
                        if (angular.isDefined(thisBankAccount)) {
                            var tmp = angular.fromJson(angular.toJson(thisBankAccount));
                            tmp.bankData = MongoF.banks.find(function (item) {
                                return item._id === tmp.bank;
                            });
                            if (angular.isDefined(tmp.bankData)) {
                                obj[data.id].push(tmp);
                            } else {
                                errAlertS('No se encontró el banco de la cuenta con id:' + tmp._id);
                            }
                        }
                    }
                }
            });
            return obj;
        }
    }

}());
/* eslint-disable angular/timeout-service */
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('setOperationWatcher', setOperationWatcher);

    function setOperationWatcher($q, $log, getFromObjectFilter, $timeout) {

        return setOperationWatcherFn;

        function setOperationWatcherFn(objData, objName, lastValueToCheck, thisScope, addForAction, watchers, firstIgnored, timestamps) {
            var validateTimeStamps = angular.isObject(timestamps);
            if (angular.isArray(objData.actions)) {
                objData.actions.map(function (action) {
                    if (angular.isObject(action) && action.field && action.action) {
                        var key = objName + action.field;
                        var thisValue = angular.toJson(getFromObjectFilter(objData.fb, action.field));
                        lastValueToCheck[key] = thisValue;
                    }
                })
            }
            return $q(function (resolve) {
                var watcherType;
                function callBack() {
                    var thisTimesStamp
                    if (validateTimeStamps) {
                        thisTimesStamp = new Date().valueOf();
                        timestamps[objName] = thisTimesStamp;
                    }
                    if (watcherType === 'angularFire' || (watcherType === 'angular' && firstIgnored[objName])) {
                        $timeout(function () {
                            if ((!validateTimeStamps) || timestamps[objName] <= thisTimesStamp) {
                                for (var a = 0; a < objData.actions.length; a++) {
                                    var thisAction = objData.actions[a]
                                    if (angular.isString(thisAction)) {
                                        addForAction(thisAction, objData.fb, objData.executeCalculation);
                                    } else if (angular.isObject(thisAction) && thisAction.field && thisAction.action) {
                                        var key = objName + thisAction.field;
                                        var thisValue = angular.toJson(objData.fb[thisAction.field]);
                                        if (lastValueToCheck[key] !== thisValue) {
                                            lastValueToCheck[key] = thisValue;
                                            addForAction(thisAction.action, objData.fb, objData.executeCalculation, undefined, thisAction.params);
                                        }
                                    }
                                }
                            }
                        }, validateTimeStamps ? 1000 : 0);
                    } else {
                        firstIgnored[objName] = true;
                    }
                }
                if (angular.isUndefined(watchers[objName]) && objData.watch) {
                    if (angular.isUndefined(firstIgnored[objName])) {
                        firstIgnored[objName] = false;
                    }
                    watchers[objName] = true;
                    if (angular.isFunction(objData.fb.$watch)) {
                        watcherType = 'angularFire';
                        watchers[objName] = objData.fb.$watch(callBack);
                    } else {
                        watcherType = 'angular';
                        watchers[objName] = thisScope.$watch(function () {
                            return objData.fb;
                        }, callBack, true);
                    }
                }
                resolve(true);
            });
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('setOperationActions', setOperationActions);

    function setOperationActions() {

        return setOperationActionsFn;

        function allMyEmployeesInStatus(operation, status, allEmployees, thisEmployees) {
            var employees = thisEmployees;
            if (allEmployees.length === thisEmployees.length) {
                employees = allEmployees;
            }
            var allInStatus = true;
            if (angular.isDefined(employees) && angular.isDefined(operation)) {
                for (var i = 0; i < employees.length; i++) {
                    if (operation.employees && operation.employees[employees[i].$id] && operation.employees[employees[i].$id].status !== status) {
                        allInStatus = false;
                        i = employees.length;
                    }
                }
            }
            return allInStatus;
        }
        

        function setOperationActionsFn(operation, lastActivePeriod, operationPermissions, calendar, defaultStatus, allEmployees, thisEmployees, employeesStatusByOp, opstatusByEmployeeStatus) {
            var opStatusNotCalc = 3;
            var actions = {};
            actions.operationStatusByEmployees = defaultStatus;
            if (operationPermissions.closeOperation) {
                actions.previousEmployeeStatus = 1;
                actions.previousIncidencesStatus = 1;
                actions.previousOperationStatus = 2;
                actions.nextEmployeeStatus = 3;
                actions.nextIncidenceStatus = 3;
                actions.nextOperationStatus = 3;
                actions.showCloseOpButton = true;
            } else if (operationPermissions.sendOperationToFinalRevision) {
                actions.previousEmployeeStatus = 0;
                actions.previousIncidencesStatus = 0;
                actions.previousOperationStatus = 1;
                actions.nextEmployeeStatus = 2;
                actions.nextIncidenceStatus = 2;
                actions.nextOperationStatus = 2.5;
                actions.showRevisionOpButton = true;
            } else if (operationPermissions.sendOperationToRevision) {
                actions.previousEmployeeStatus = 0;
                actions.previousIncidencesStatus = 0;
                actions.previousOperationStatus = -1;
                actions.nextEmployeeStatus = 1;
                actions.nextIncidenceStatus = 1;
                actions.nextOperationStatus = 2;
                actions.showRevisionOpButton = true;
            }
            var r = (lastActivePeriod.period ? lastActivePeriod.period : 0) - operation.period;
            if (r === 1 && operation.status === 3 && lastActivePeriod.calendar === calendar) {
                actions.showReopenButton = true;
            } else {
                delete actions.showReopenButton;
            }
            //console.log($scope.showReopenButton);
            if (actions.showRevisionOpButton) {
                //si tiene permiso para revisar la nomina pero la nomina ya no esta en un status para revisar entonces no mostrarnos le botón de revisar
                if (operation.status > 2) {
                    delete actions.showRevisionOpButton;
                }
                //Si todos mis empleados están en el siguiente estado que corresponde ya no mostramos el botón
                if (actions.showRevisionOpButton) {
                    if (allMyEmployeesInStatus(operation, actions.nextEmployeeStatus, allEmployees, thisEmployees)) {
                        delete actions.showRevisionOpButton;
                    }
                }
            }
            if (actions.showCloseOpButton) {
                delete actions.showRevisionOpButton;
                //si tiene permiso para revisar la nomina pero la nomina ya no esta en un status para revisar entonces no mostrarnos le botón de revisar
                if (operation.status > 2.5) {
                    delete actions.showCloseOpButton;
                }
                //Si todos mis empleados están en el siguiente estado que corresponde ya no mostramos el botón
                if (actions.showCloseOpButton) {
                    if (allMyEmployeesInStatus(operation, actions.nextEmployeeStatus, allEmployees, thisEmployees)) {
                        delete actions.showCloseOpButton;
                    }
                }
            }
            if (operation.status > 0 && operation.status < opStatusNotCalc) {
                var status = {};
                var nextStatus = employeesStatusByOp[operation.status].nextStatus;
                for (var a = 0; a < nextStatus.length; a++) {
                    status[nextStatus[a]] = allMyEmployeesInStatus(operation, nextStatus[a], allEmployees, thisEmployees);
                }
                for (var s in status) {
                    if (status[s]) {
                        if (opstatusByEmployeeStatus[s] > actions.operationStatusByEmployees) {
                            actions.operationStatusByEmployees = opstatusByEmployeeStatus[s];
                        }
                    }
                }
            }
            return actions;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('setCreditIncidences', setCreditIncidences)

    function setCreditIncidences(AppF, errAlertS, getFromObjectFilter, $log) {

        return setCreditIncidencesFn;

        function setCreditIncidencesFn(employees, allEmployees, concepts, incidencesRef, calendar, period, operation, opType, opTypeId) {
            var incidencesOfCredit = [];
            if ((angular.isDefined(operation) && !getFromObjectFilter(operation, 'movement.paySalaryInPayrol', false)) || angular.isUndefined(operation)) {
                var incidenceObj = {};
                var employeesCreditData = employees;
                var conceptForCredit = concepts.find(function (concept) {
                    return concept.forCredit === true;
                });
                if (angular.isDefined(conceptForCredit)) {
                    for (var c = 0; c < employeesCreditData.length; c++) {
                        var thisEmployee = allEmployees[employeesCreditData[c].$id];
                        if (!thisEmployee.isClosed && angular.isObject(thisEmployee.creditData) && thisEmployee.creditData !== null) {
                            incidenceObj = {
                                $id: AppF.root.child(incidencesRef).push().key,
                                status: 0,
                                calendar: parseInt(calendar),
                                period: parseInt(period.period),
                                employee: thisEmployee.creditData.employee,
                                incidenceType: conceptForCredit.$id,
                                payroll: thisEmployee.creditData.payroll,
                                type: 'system',
                                value: 1,
                                date: thisEmployee.creditData.data.date,
                                comments: 'Incidencia Automática de Infonavit'
                            };
                            if (angular.isDefined(opType) && opType !== 'payroll') {
                                incidenceObj.operationType = opType;
                                incidenceObj[opType] = opTypeId;
                            }
                            incidencesOfCredit.push(incidenceObj);
                        }
                    }
                } else {
                    errAlertS('No se encontró la incidencia para crear el crédito del empleado, por favor añada la incidencia');
                }
            }

            return incidencesOfCredit;
        }
    }
}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('resolveBankFileRoute', resolveBankFileRoute);

    function resolveBankFileRoute($log) {
        return function (bankAccount) {
            if (!bankAccount) {
                return '';
            }
            var bank = bankAccount.bankData || {};
            if (bankAccount.idlayoutBank) {
                var layoutConfig = bankAccount.bankData.configLayouts.filter(function (resp) {
                    return resp.idLayout === bankAccount.idlayoutBank;
                })
                if (layoutConfig.length > 0 && angular.isArray(layoutConfig) && layoutConfig[0].spei) {
                    $log.log('Entro por la version nueva de configuracion de bancos y es spei');
                    return layoutConfig[0].pathFileDispersion || ((bank.name || '') + '_spei');
                }

                if (layoutConfig.length > 0 && angular.isArray(layoutConfig) && !layoutConfig[0].spei) {
                    $log.log('Entro por la version nueva de configuracion de bancos');
                    return layoutConfig[0].pathFileDispersion || (bank.name || '');
                }
            }
            if (bankAccount.isSpei) {
                $log.log('Entro por la version anterior de configuracion de bancos y es spei');
                return bankAccount.fileRouteSpei || bank.fileRouteSpei || ((bank.name || '') + '_spei');
            }
            return bankAccount.fileRoute || bank.fileRoute || (bank.name || '');
        };
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('orderByObjectForFields', orderByObjectForFields);

    function orderByObjectForFields(loopEachFilter) {

        return orderByObjectForFieldsFn;

        function orderByObjectForFieldsFn(obj, field, ignore) {
            var arreglo = [];
            loopEachFilter(obj, function (value) {
               if(angular.isUndefined(value[field]) || !value[field]){
                    loopEachFilter(value, function(calc, key){
                        if(angular.isObject(calc) && key !== ignore) value.showBottomEyes = true;
                    })
                    arreglo = arreglo.concat(value);
               }
            });
            return arreglo;
        }
    }
}());
(function(){
    'use strict';

    angular
        .module('app.clients')
        .filter('operationStatusNameModal', operationStatusNameModal)

    function operationStatusNameModal(AppF){

        return operationStatusNameModalFn;

        function operationStatusNameModalFn(status){
            var statusName = '';
            for(var s in AppF.operationStatatuss){
                if(AppF.operationStatatuss[s].id == status) statusName = AppF.operationStatatuss[s];
            }
            return statusName;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('moveOperation', moveOperation);

    function moveOperation($q, AppF, moveEmployeeFilter, clearObjectFilter, errAlertS) {

        return moveOperationFn;

        function moveOperationFn(operation, proccess, operationEmployees, calculations, operationStatus, employeeStatus, incidenceStatus, refs) {
            return $q(function (resolve) {
                // moveEmployeeFn(operation, employee, employeeCalculations, dispersionId, employeeStatus, incidenceStatus, refs)
                var dispersionId = operation.dispersion;
                var promises = [];
                if (angular.isUndefined(dispersionId)) {
                    dispersionId = AppF.root.child().ref(refs.dispersion).push().key;
                    var dispersionObj = {};
                    dispersionObj[dispersionId] = {
                        data: {
                            calendar: '',
                            payroll: '',
                            period: '',
                            supposedDate: ''
                        },
                        proccess: clearObjectFilter(proccess),
                        status: 0
                    };
                    promises.push(AppF.root.child().ref(refs.dispersion).update(dispersionObj));
                }
                Promise.all(promises).then(function () {
                    promises = [];
                    if (angular.isArray(operationEmployees)) {
                        for (var o = 0; o < operationEmployees.length; o++) {
                            var thisEmployee = operationEmployees[o];
                            promises.push(moveEmployeeFilter(operation, thisEmployee, calculations[thisEmployee.$id], dispersionId, employeeStatus, incidenceStatus, refs));
                        }
                    }
                    return Promise.all(promises);
                }).then(function (employeesUpdated) {
                    
                }).catch(function (error) {
                    errAlertS(error);
                });
            });
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('moveEmployees', moveEmployees);

    function moveEmployees($filter, $q, AppF) {
        // employees,
        // opObjs,
        // refs,
        // calculations,
        // dispersionId,
        // fiscalEmployees,
        // allEmployeesO,
        // employeeStatus,
        // onlyPrevision,
        // operation,
        // operationStatus,
        // nextOperation,
        // nextOperationPeriod,
        // incidenceStatus,
        // action,
        // operationType,
        // extra,
        // operationObj,
        // rejectedIncidences,
        // employeesMovements,
        function moveEmployeesByBatch(data, resps) {
            return new Promise(function (resolve, reject) {
                try {
                    resps = angular.isArray(resps) ? resps : [];
                    if (angular.isArray(data.employeesP) && data.employeesP.length > 0) {
                        var promises = [];
                        while (data.employeesP.length > 0 && promises.length < 10) {
                            var employeeData = data.employeesP.shift();
                            var extra = angular.fromJson(angular.toJson(data.extra));
                            var rejectedIncidencesSaved, currentRejectedIncidences;
                            if (data.operationType === 'ordinary') {
                                rejectedIncidencesSaved = $filter('getFromObject')(data.opObjs.dispersion.fb, 'employeesData.rejectedIncidences.' + employeeData.$id);
                                currentRejectedIncidences = $filter('getFromObject')(data.rejectedIncidences, employeeData.$id);
                            }
                            var currentMovements, operationMovement;
                            if (data.operationType === 'settlement') {
                                operationMovement = data.operation.movement;
                                currentMovements = $filter('getArrayFromObject')(data.employeesMovements[employeeData.$id].val(), undefined, true);
                            }
                            var thisDispersion = $filter('getFromObject')(data.opObjs.dispersion, 'fb.employees.' + employeeData.$id);
                            var thisEmployee = data.allEmployeesO[employeeData.$id];
                            if (data.operationStatus >= 3) {
                                var exist = data.fiscalEmployees.findIndex(function (item) {
                                    return item.$id === employeeData.$id;
                                });
                                extra.isFiscalEmployee = exist > -1 ? true : false;//log para encontrar el bug que hace que no se guarden los datos correctamente;
                                extra.companiesRecords = data.operationObj.filter(function (item) {
                                    return (item.id !== 'fiscal' || exist > -1) ? true : false;
                                }).map(function (item) {
                                    if (angular.isUndefined(extra.companiesRecord)) {
                                        extra.companiesRecord = item.companiesRecord;
                                    }
                                    return { opType: item.id, companiesRecordId: item.companiesRecord };
                                });
                            }
                            if ((data.operationStatus >= 3 && angular.isUndefined(thisDispersion) && data.operation.employees[employeeData.$id].status < 5) || (data.operationStatus < 3 && data.operation.employees[employeeData.$id].status !== data.employeeStatus)) {
                                var statusOp = data.employeeStatus;
                                if (data.onlyPrevision) {
                                    statusOp = 5;
                                }
                                promises.push($filter('moveEmployee')(
                                    data.operation,
                                    thisEmployee,
                                    data.calculations[employeeData.$id],
                                    data.dispersionId,
                                    statusOp,
                                    data.incidenceStatus,
                                    data.operationStatus,
                                    data.refs,
                                    currentRejectedIncidences,
                                    data.nextOperation,
                                    data.nextOperationPeriod,
                                    rejectedIncidencesSaved,
                                    operationMovement,
                                    currentMovements,
                                    data.action,
                                    angular.isObject(extra) ? JSON.parse(JSON.stringify(extra)) : undefined,
                                    data.opObjs.period.fb,
                                    data.operationType,
                                    data.generateDismissMovement
                                ));
                            }
                        }
                        Promise.all(promises).then(function (resp) {
                            resps = resps.concat(resp);
                            resolve(moveEmployeesByBatch(data, resp));
                        }).catch(reject);
                    } else {
                        resolve(resps);
                    }
                } catch (error) {
                    reject(error);
                }
            });
        }
        // employees,
        // opObjs,
        // refs,
        // calculations,
        // dispersionId,
        // fiscalEmployees,
        // allEmployeesO,
        // employeeStatus,
        // onlyPrevision,
        // operation,
        // operationStatus,
        // nextOperation,
        // nextOperationPeriod,
        // incidenceStatus,
        // action,
        // operationType,
        // periodSelected,
        // calendar,
        // allRejected
        function moveEmployeesFn(data) {
            return new Promise(function (resolve, reject) {
                try {
                    data.operationObj = {};
                    data.extra = {};
                    if (data.operationStatus >= 3) {
                        var process = data.opObjs.process.fb;
                        data.operationObj = process.filter(function (item) {
                            return (item.id && item.companiesRecord && (item.id !== 'fiscal' || data.fiscalEmployees.length > 0)) ? true : false;
                        });
                        data.extra = {
                            accuDate: data.periodSelected.accuDate,
                            operationId: data.operation.$id,
                            period: data.periodSelected.period,
                            calendar: data.calendar,
                            operationType: data.operationType
                        };
                    }
                    if (angular.isDefined(data.allRejected)) {
                        data.rejectedIncidences = $filter('groupByField')(data.allRejected, 'employeeId');
                    }

                    if (['ordinary', 'settlement'].indexOf(data.operationType) === -1) {
                        data.extra.specialDate = data.operation.specialDate;
                        data.extra.specialPeriod = data.operation.specialPeriod;
                    }
                    var promise;
                    if (data.operationType === 'settlement') {
                        var promises = {};
                        $filter('loopEach')(data.opObjs.operation.fb.employees, function (employeeData, employeeId) {
                            promises[employeeId] = AppF.root.child('catalogs/employees/collection/' + employeeId + '/movements').once('value')
                        });
                        if (Object.keys(promises).length > 0) {
                            promise = $q.all(promises);
                        }
                    }
                    if (angular.isUndefined(promise)) {
                        promise = Promise.all([]);
                    }
                    promise.then(function (employeesMovements) {
                        if (!angular.isArray(employeesMovements)) {
                            data.employeesMovements = employeesMovements;
                        }
                        data.employeesP = data.employees.slice();
                        resolve(moveEmployeesByBatch(data));
                    }).catch(reject);
                } catch (error) {
                    reject(error);
                }
            });
        }
        return moveEmployeesFn;
    }
}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('moveEmployee', moveEmployee);

    function moveEmployee($rootScope, $q, clearObjectFilter, AppF, $log, $filter, errAlertS, loopEachFilter, DataF, getFromObjectFilter) {
        var incidenceActions = {
            delete: function () {
                return null;
            },
            create: function (incidence, incidenceStatus, employee, extra, currentPeriod) {
                var tempIncidence = clearObjectFilter(incidence);
                tempIncidence.status = incidenceStatus;
                tempIncidence.rp = employee.rp;
                tempIncidence.companiesRecord = extra.companiesRecord || null;
                tempIncidence.closeOn = extra.operationType || null;
                if (angular.isUndefined(getFromObjectFilter(tempIncidence, 'date'))) {
                    tempIncidence.date = currentPeriod.start;
                }
                return tempIncidence;
            },
            update: function (thisIncidence, incidenceStatus, employee, extra, currentPeriod, operation, incidencesRef) {
                var updates = {};
                updates[incidencesRef + '/' + thisIncidence.$id + '/status'] = incidenceStatus;
                updates[incidencesRef + '/' + thisIncidence.$id + '/period'] = operation.period;
                if (incidenceStatus >= 3 && angular.isUndefined(getFromObjectFilter(thisIncidence, 'date'))) {
                    updates[incidencesRef + '/' + thisIncidence.$id + '/date'] = currentPeriod.start;
                }
                if (incidenceStatus >= 3 && extra.operationType) {
                    updates[incidencesRef + '/' + thisIncidence.$id + '/closeOn'] = extra.operationType;
                    updates[incidencesRef + '/' + thisIncidence.$id + '/' + extra.operationType] = operation.$id;
                }
                updates[incidencesRef + '/' + thisIncidence.$id + '/rp'] = employee.rp;
                updates[incidencesRef + '/' + thisIncidence.$id + '/companiesRecord'] = extra.companiesRecord || null;
                return updates;
            }
        };
        //var employeeStatus = [0, 1, 2, 3]; //Abierto, Cerrado por encargado, Cerrado por cliente, Cerrado
        //var operationStatus = [1, 2, 2.5, 3]; //Abierta, En Revision por cliente, En Revision por ejecutivo, Cerrada
        //var incidenceStatus = [0, 1, 2, 3]; //Por aplicar, En revision, En revision, Aplicada
        function getIncidencesUpdates(employee, incidenceStatus, operationStatus, incidencesRef, operation, rejectedIncidences, currentPeriod, extra) {
            var updates = {};
            var thisIncidences = angular.isArray(employee.incidences) ? employee.incidences : [];
            for (var i = 0; i < thisIncidences.length; i++) {
                var thisIncidence = thisIncidences[i];
                var action = ['system', 'constant'].indexOf(thisIncidence.type) > -1 && !thisIncidence.notCreated ? (incidenceStatus >= 3 ? 'create' : 'delete') : 'update';
                var thisUpdates = incidenceActions[action](thisIncidence, incidenceStatus, employee, extra, currentPeriod, operation, incidencesRef);
                if (action === 'update') {
                    updates = Object.assign(updates, thisUpdates);
                } else {
                    updates[incidencesRef + '/' + thisIncidence.$id] = thisUpdates
                }
            }
            if (operationStatus === 2.5 && angular.isDefined(rejectedIncidences)) {
                loopEachFilter(rejectedIncidences, function (data, key) {
                    updates['incidences/' + data.payroll + '/' + data.calendar + '/' + key] = null;
                });
            }
            return updates;
        }
        function getEmployeeDataToSave(employee) {
            var dataToSave = {};
            var fields = ['sdr', 'sd', 'sbc', 'nss', 'fiscalPositionData', 'positionData', 'satContractType', 'accounts', 'enroleDate', 'seniorityDate', 'dismissDate', 'department'];
            for (var f = 0; f < fields.length; f++) {
                var thisField = fields[f];
                if (angular.isDefined(employee[thisField]) && employee[thisField] !== null) {
                    dataToSave[thisField] = employee[thisField];
                }
            }
            return dataToSave;
        }
        var fieldsToRemove = {
            dailySalary: ["dailySalary", "dailySalariesWithInc", "dailySalariesForImss", "dailySalariesForImssNoInc", "dailySalaries"],
            workedDays: ["activeDays"],
            absences: ["allAbsences", "allAbsencesNoV"]
        }
        function getDispersionUpdates(employee, employeeCalculations, operation, dispersionId, employeeStatus, refs, action, extra, operationType) {
            var employeeId = employee.$id;
            var updates = {};
            if (employeeStatus >= 3 && angular.isDefined(employeeCalculations)) {
                if (angular.isDefined(extra)) {
                    extra.rp = employee.rp;
                    extra.cc = employee.cc;
                    extra.department = employee.department;
                    extra.payroll = employee.payroll;
                    extra.idDispersion = dispersionId;
                    extra.employeeId = employeeId;
                    extra.created = DataF.getTimeObject();
                    extra.action = 'add';
                }
                var thisEmployeeCalculation = {};
                loopEachFilter(employeeCalculations, function (data, index) {
                    delete data.needToBalanceFiscal;
                    delete data.needToBalanceSocialPrevision;
                    delete data.rejectedAmount;
                    var newData;
                    if (angular.isUndefined(fieldsToRemove[index])) {
                        newData = clearObjectFilter(data);
                    } else if (angular.isArray(fieldsToRemove[index])) {
                        newData = clearObjectFilter(data);
                        for (var f = 0; f < fieldsToRemove[index].length; f++) {
                            delete newData[fieldsToRemove[index][f]];
                        }
                    }
                    if (angular.isDefined(newData)) {
                        loopEachFilter(newData, function (data, key) {
                            if (angular.isObject(data)) {
                                delete newData[key].positions;
                                delete newData[key].accumulator;
                            }
                        })
                        thisEmployeeCalculation[index] = angular.toJson(newData);
                    }
                    var fields = {};
                    loopEachFilter(data, function (calculations, index) {
                        if (angular.isObject(calculations) && angular.isDefined(calculations.result) && !angular.isObject(calculations.result)) {
                            fields[index] = calculations.result;
                        }
                    });
                    extra[index] = fields;
                });
                updates[refs.dispersion + '/' + dispersionId + '/employeesData/calculations/' + employeeId] = clearObjectFilter(thisEmployeeCalculation);
                updates[refs.dispersion + '/' + dispersionId + '/employees/' + employeeId] = getEmployeeDataToSave(employee, employeeCalculations, operation, operationType);
            } else if (action === 'reOpenClosed') {
                if (angular.isDefined(extra)) {
                    extra.action = 'delete';
                }
                updates[refs.dispersion + '/' + dispersionId + '/employeesData/calculations/' + employeeId] = null;
                updates[refs.dispersion + '/' + dispersionId + '/employeesData/rejectedIncidences/' + employeeId] = null;
                updates[refs.dispersion + '/' + dispersionId + '/employees/' + employeeId] = null;
            }
            var status = employeeStatus;
            if (action === 'reOpenClosed') {
                status = 0;
            }
            updates[refs.operations + '/' + operation.$id + '/employees/' + employeeId + '/status'] = status;
            var obj = {
                updates: updates,
                updatesM: extra
            };
            return obj;
        }
        function getMovementsUpdate(employee, movement, employeeStatus, movements, operation, generateDismissMovement) {
            var employeeId = employee.$id;
            var updates = {};
            var movementCreated = false;
            if (employeeStatus >= 3 && angular.isDefined(movement)) {
                var existsAny = movements.find(function (item) {
                    return item.d === movement.date;
                });
                movements = movements.sort(function (a, b) {
                    return a.d - b.d;
                });
                var lastMovement = movements[movements.length - 1];
                if (angular.isUndefined(existsAny) && lastMovement.t !== 2 && operation.payroll === employee.payroll && generateDismissMovement) {
                    movementCreated = true;
                    movement.type = 2;
                    movement.fromSettlement = operation.$id;
                    var mid = AppF.root.child('catalogs/movements/collection').push().key;
                    updates['catalogs/movements/collection/' + mid] = {
                        'cc': employee.cc,
                        'created': DataF.getTimeObject(),
                        'data': movement,
                        'employee': employeeId,
                        'info': {
                            'maternalSurname': getFromObjectFilter(employee.data, 'info.maternalSurname', null),
                            'name': employee.data.name,
                            'names': employee.data.info.names,
                            'nss': getFromObjectFilter(employee.data, 'nss', null),
                            'paternalSurname': getFromObjectFilter(employee.data, 'info.paternalSurname', null),
                            'umf': getFromObjectFilter(employee.data, 'health.umf', null)
                        },
                        'payroll': employee.payroll,
                        'rp': employee.rp,
                        'status': 2,
                        'approved': DataF.getTimeObject()
                    };
                    updates['catalogs/employees/collection/' + employeeId + '/data/comments'] = angular.isDefined(movement.comments) ? movement.comments : null;
                    updates['catalogs/employees/collection/' + employeeId + '/data/health/endDate'] = new Date().valueOf();
                    updates['catalogs/employees/collection/' + employeeId + '/data/dismissDate'] = movement.date;
                    updates['catalogs/employees/collection/' + employeeId + '/movement/archiveDate'] = null;
                    updates['catalogs/employees/collection/' + employeeId + '/movement/batch'] = null;
                    updates['catalogs/employees/collection/' + employeeId + '/movement/comments'] = angular.isDefined(movement.comments) ? movement.comments : null;
                    updates['catalogs/employees/collection/' + employeeId + '/movement/date'] = movement.date;
                    updates['catalogs/employees/collection/' + employeeId + '/movement/type'] = 2;
                    updates['catalogs/employees/collection/' + employeeId + '/movement/fromSettlement'] = operation.$id;
                    updates['catalogs/employees/collection/' + employeeId + '/movement/uid'] = mid;
                    updates['catalogs/employees/collection/' + employeeId + '/movement/rehirable'] = angular.isDefined(movement.rehirable) ? movement.rehirable : null;
                    updates['catalogs/employees/collection/' + employeeId + '/movement/dismissType'] = movement.dismissType;
                    updates['catalogs/employees/collection/' + employeeId + '/movements/' + mid + '/d'] = movement.date;
                    updates['catalogs/employees/collection/' + employeeId + '/movements/' + mid + '/p'] = employee.payroll;
                    updates['catalogs/employees/collection/' + employeeId + '/movements/' + mid + '/s'] = 2;
                    updates['catalogs/employees/collection/' + employeeId + '/movements/' + mid + '/t'] = 2;
                    updates['catalogs/employees/collection/' + employeeId + '/status'] = 2;
                } else {
                    if (angular.isDefined(getFromObjectFilter(operation, 'movementTypes')) && operation.movementTypes !== 'settlementId') {
                        updates['catalogs/movements/collection/' + operation.movementTypes + '/data/fromSettlement'] = operation.$id;
                    }
                }
            }
            updates['catalogs/employees/collection/' + employeeId + '/updated'] = new Date().valueOf();
            return { updates: updates, movementCreated: movementCreated };
        }
        function sendNotification(sendNotification, employeeId) {
            return new Promise(function (resolve) {
                try {
                    if (sendNotification) {
                        //se hace la consulta del empleado a la base de datos
                        AppF.root.child("catalogs/employees/collection/" + employeeId).once('value').then(function (resultado) {
                            var employee = resultado.val();
                            var promises = [
                                $filter('getEmployeeDataObjects')(employee) //filtro donde trae la información del empleado, el filtro ds una promesa
                            ];
                            Promise.all(promises).then(function (resp) {
                                var dataNeededByTemplate = resp[0]
                                var action = $filter('typeName')(2, false, true);
                                //función para las notificaciones.
                                AppF.notifyUsers('movement', action, employee.status, employee.movement.uid, employee, false, dataNeededByTemplate).then(function () {
                                    resolve(true);
                                }).catch(function (error) {
                                    $log.error(error);
                                    resolve(false);
                                });
                            })
                        })
                    } else {
                        resolve(true);
                    }
                } catch (error) {
                    $log.error(error);
                    resolve(true);
                }
            });
        }

        function executeMongoActions(dispersionF, operation, employee) {
            return new Promise(function (resolve, reject) {
                var promises = [];
                var action = getFromObjectFilter(dispersionF, 'updatesM.action');
                if (["delete", "add"].indexOf(action) > -1) {
                    var query = {
                        operationId: operation.$id,
                        employeeId: employee.$id
                    };
                    promises.push($rootScope.D.api.delete('deleteByFields/calculations', query));
                }
                Promise.all(promises).then(function () {
                    promises = [];
                    if (action === 'add') {
                        delete dispersionF.updatesM.action;
                        promises.push($rootScope.D.api.addWithUnique('calculations', dispersionF.updatesM));
                    }
                    return Promise.all(promises);
                }).then(function () {
                    resolve(true);
                }).catch(reject)
            });
        }

        function moveEmployeeFn(operation, employee, employeeCalculations, dispersionId, employeeStatus, incidenceStatus, operationStatus, refs, rejectedIncidences, nextOperation, nextPeriod, currentRejectInc, movement, currentMovement, action, extra, currentPeriod, operationType, generateDismissMovement) {
            return $q(function (resolve) {
                try {
                    var updates = getIncidencesUpdates(employee, incidenceStatus, operationStatus, refs.incidences, operation, currentRejectInc, currentPeriod, extra);
                    var dispersionF = getDispersionUpdates(employee, employeeCalculations, operation, dispersionId, employeeStatus, refs, action, extra, operationType);
                    updates = Object.assign(updates, dispersionF.updates);
                    var movementUpdates = getMovementsUpdate(employee, movement, employeeStatus, currentMovement, operation, generateDismissMovement)
                    updates = Object.assign(updates, movementUpdates.updates);
                    if (angular.isDefined(rejectedIncidences) && angular.isArray(rejectedIncidences) && rejectedIncidences.length > 0 && operationStatus >= 3 && angular.isDefined(nextOperation) && angular.isDefined(nextPeriod)) {
                        for (var i = 0; i < rejectedIncidences.length; i++) {
                            var key = AppF.root.child(refs.incidences).push().key;
                            var value = {};
                            var incidenceObj = {
                                status: 0,
                                calendar: parseInt(nextOperation.calendar),
                                period: parseInt(nextOperation.period),
                                employee: rejectedIncidences[i].employeeId,
                                incidenceType: rejectedIncidences[i].conceptId,
                                payroll: nextOperation.payroll,
                                type: 'system',
                                value: rejectedIncidences[i].qty,
                                date: nextPeriod.start,
                                notCreated: true,
                                isRejected: true,
                                extra: rejectedIncidences[i].extra || null,
                                comments: 'Incidencia rechazada generada automáticamente'
                            };
                            value['incidences/' + nextOperation.payroll + '/' + nextOperation.calendar + '/' + key] = incidenceObj;
                            value[refs.dispersion + '/' + dispersionId + '/employeesData/rejectedIncidences/' + rejectedIncidences[i].employeeId + '/' + key] = {
                                calendar: nextOperation.calendar,
                                period: nextOperation.period,
                                payroll: nextOperation.payroll,
                                i: rejectedIncidences[i].conceptId,
                                k: rejectedIncidences[i].conceptKey,
                                n: rejectedIncidences[i].name,
                                v: rejectedIncidences[i].qty
                            };
                            updates = Object.assign(updates, value);
                        }
                    } else if (angular.isDefined(rejectedIncidences) && angular.isArray(rejectedIncidences) && rejectedIncidences.length > 0 && operationStatus <= 3) {
                        $log.log(rejectedIncidences);
                    }
                    executeMongoActions(dispersionF, operation, employee).then(function () {
                        return AppF.root.update(updates);
                    }).then(function () {
                        return sendNotification(movementUpdates.movementCreated, employee.$id);
                    }).then(function () {
                        resolve(true);
                    }).catch(function (error) {
                        errAlertS(error);
                        resolve(false);
                    });
                } catch (error) {
                    errAlertS(error);
                    resolve(false);
                }
            });
        }
        return moveEmployeeFn;
    }
}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('mapArray', mapArray);

    function mapArray(getFromObjectFilter) {

        return mapArrayFn;

        function mapArrayFn(arreglo, fields, extra) {

            var nuevoArreglo = [];
            var fieldsArray = fields.split(',');
            if (angular.isArray(arreglo)) {
                nuevoArreglo = arreglo.map(function (item) {
                    var newItem = {};
                    for (var f = 0; f < fieldsArray.length; f++) {
                        newItem[fieldsArray[f]] = getFromObjectFilter(item, fieldsArray[f]);
                    }
                    if (angular.isObject(extra)) {
                        newItem = Object.assign(newItem, extra);
                    }
                    return newItem;
                });
            }
            return nuevoArreglo;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('isForThisOperation', isForThisOperation);

    function isForThisOperation(getArrayOfIdsFilter, AppF) {
        return isForThisOperationFn;
        function isForThisOperationFn(thisEmployee, operationEmployee, employeeIsClosed, ccs) {
            var valid = false;
            if (AppF.permissionToAccessAllPayrolls) {
                valid = true;
            } else {
                var ccsIdsArray = getArrayOfIdsFilter(ccs, '$id');
                if (employeeIsClosed && ccsIdsArray.indexOf(operationEmployee.cc) > -1) { //Si ya existe el nodo de dispersion de empleados se filtran los empleados de acuerdo al cc que se registro en la operación al momento de hacer la dispersion
                    valid = true;
                } else if (!employeeIsClosed) { //Si no existe el nodo se filtran los empleados de acuerdo a los ccs a los que se tienen permiso
                    for (var m in thisEmployee.movements) {
                        if (thisEmployee.movements.hasOwnProperty(m)) {
                            if (ccsIdsArray.indexOf(thisEmployee.movements[m].cc) > -1) {
                                valid = true;
                            }
                        }
                    }
                }
            }
            return valid;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getWorkedDaysAccountantMethod', getWorkedDaysAccountantMethod)

    function getWorkedDaysAccountantMethod(getDaysMatrixOfMovementsFilter) {

        return getWorkedDaysAccountantMethodFn;

        function getWorkedDaysAccountantMethodFn(startOfPeriod, endOfPeriod, daysOfPeriod, activeMovements) {
            var matrix = getDaysMatrixOfMovementsFilter(startOfPeriod, endOfPeriod, daysOfPeriod, activeMovements);
            var wd = {
                wd: matrix.wd(),
                dismisses: matrix.daysRestedByDismisses.days,
                enroles: matrix.daysAddedByEnroles.days,
                dayWorth: matrix.dayWorth
            };
            return wd;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getTotalsOfOperations', getTotalsOfOperations);

    function getTotalsOfOperations($log, getTotalOfArrayFieldFilter, getFromObjectFilter, currencyFilter, errAlertS) {
        return getTotalsOfOperationsFn;

        function getTotalType(concept) {
            var fields = getFromObjectFilter(concept, 'calculations.0.fields', []);
            var type = 'currency';
            var valueField = fields.find(function (item) {
                return item.id === 'value';
            });
            if (angular.isDefined(valueField) && angular.isDefined(valueField.outputType)) {
                type = valueField.outputType;
            }
            return type;
        }

        function getTotalsOfOperationsFn(calculations, process, conceptsByID, otherProccess, dispersion, operationIsClose) {
            if (operationIsClose) {
                return getFromObjectFilter(dispersion, 'total', {});
            } else {
                var incidenceTypeCalculated = {};
                var totals = {};
                for (var p = 0; p < process.length; p++) {
                    if (!process[p].notCalculate && angular.isArray(process[p].concepts)) {
                        var proConcepts = process[p].concepts;
                        for (var c = 0; c < proConcepts.length; c++) {
                            var proC = proConcepts[c];
                            var concept = conceptsByID[proC.$id];
                            if (angular.isDefined(concept) && concept.showTotal) {
                                if (angular.isUndefined(totals[proC.$id])) {
                                    totals[proC.$id] = {};
                                }
                                if (angular.isUndefined(incidenceTypeCalculated[proC.$id])) {
                                    incidenceTypeCalculated[proC.$id] = true;
                                    totals[proC.$id].value = getTotalOfArrayFieldFilter(calculations, conceptsByID[proC.$id].key + '.value.result');
                                    totals[proC.$id].type = getTotalType(concept);
                                    if (concept.type === 'incidenceType' || concept.nature === 'deduction') {
                                        var totalNormal = getTotalOfArrayFieldFilter(calculations, conceptsByID[proC.$id].key + '.valueNormal.result');
                                        var total = getTotalOfArrayFieldFilter(calculations, conceptsByID[proC.$id].key + '.value.result');
                                        var rejected = getTotalOfArrayFieldFilter(calculations, conceptsByID[proC.$id].key + '.rejectedIncidences.result');
                                        if (concept.type === 'incidenceType') {
                                            totals[proC.$id].fast = Math.round((total - totalNormal - rejected) * 10000) / 10000;
                                            totals[proC.$id].normal = totalNormal;
                                            if (angular.isArray(otherProccess)) {
                                                for (var o = 0; o < otherProccess.length; o++) {
                                                    var procId = otherProccess[o].id;
                                                    totals[proC.$id][procId + 'Value'] = getTotalOfArrayFieldFilter(calculations, conceptsByID[proC.$id].key + '.' + procId + 'Value.result');
                                                    if (concept.nature === 'deduction') {
                                                        totals[proC.$id][procId + 'ValueNoRejected'] = getTotalOfArrayFieldFilter(calculations, conceptsByID[proC.$id].key + '.' + procId + 'ValueNoRejected.result');
                                                        totals[proC.$id][procId + 'ValueRejected'] = getTotalOfArrayFieldFilter(calculations, conceptsByID[proC.$id].key + '.' + procId + 'ValueRejected.result');
                                                    }
                                                }
                                            }
                                        }
                                        if (concept.nature === 'deduction') {
                                            totals[proC.$id].valueRejected = rejected;
                                            totals[proC.$id].valueNoRejected = Math.round((total - rejected) * 10000) / 10000;
                                        }

                                        // 'real': ['value', 'rejectedIncidences', 'valueNoRejected'],
                                        // 'fiscal': ['fiscalValue', 'fiscalValueRejected', 'fiscalValueNoRejected'],
                                        // 'socialPrevision': ['socialPrevisionValue', 'socialPrevisionValueRejected', 'socialPrevisionValueNoRejected']

                                    }
                                    if(angular.isArray(conceptsByID[proC.$id].otherTotals)){
                                        var otherTotals = conceptsByID[proC.$id].otherTotals;
                                        for(var o = 0; o < otherTotals.length; o++){
                                            totals[proC.$id][otherTotals[o]] = getTotalOfArrayFieldFilter(calculations, conceptsByID[proC.$id].key + '.'+otherTotals[o]+'.result');
                                        }
                                    }

                                    // else if (concept.type === 'incidenceType' && concept.nature == 'percepction') {

                                    //     totals[proC.$id].fiscal = getTotalOfArrayFieldFilter(calculations, conceptsByID[proC.$id].key + '.fiscalValue.result');
                                    //     totals[proC.$id].socialPrevision = getTotalOfArrayFieldFilter(calculations, conceptsByID[proC.$id].key + '.socialPrevisionValue.result');

                                    // } else if (concept.nature === 'deduction') {
                                    //     var totalNormal = getTotalOfArrayFieldFilter(calculations, conceptsByID[proC.$id].key + '.valueNormal.result');
                                    //     var total = getTotalOfArrayFieldFilter(calculations, conceptsByID[proC.$id].key + '.value.result');
                                    //     var rejected = getTotalOfArrayFieldFilter(calculations, conceptsByID[proC.$id].key + '.rejectedIncidences.result');
                                    //     totals[proC.$id].fast = total - totalNormal - rejected;
                                    //     totals[proC.$id].normal = totalNormal;
                                    //     if (concept.type === 'incidenceType') {
                                    //         totals[proC.$id].fiscal = getTotalOfArrayFieldFilter(calculations, conceptsByID[proC.$id].key + '.fiscalValue.result');
                                    //         totals[proC.$id].socialPrevision = getTotalOfArrayFieldFilter(calculations, conceptsByID[proC.$id].key + '.socialPrevisionValue.result');
                                    //     }
                                    // }
                                }
                            } else if (angular.isUndefined(concept)) {
                                errAlertS('No se encuentra el concepto con id:' + proC.$id);
                            }
                        }
                    }
                }
                return totals;
            }

        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getTotalOfObject', getTotalOfObject);

    function getTotalOfObject(loopEachFilter, $log) {

        return getTotalOfObjectFn;

        function getTotalOfObjectFn(object) {
            var total = 0;
            var arreglo = [];
            var isNotNumber = false;
            loopEachFilter(object, function (number, index) {
                if (!isNaN(parseFloat(number))) {
                    total += parseFloat(number);
                } else if (angular.isObject(number)) {
                    isNotNumber = true;
                    arreglo.push(number);
                }
            });
            if (isNotNumber) {
                return arreglo;
            } else {
                return total;
            }
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getTotalOfIncidencesByType', getTotalOfIncidencesByType)

    function getTotalOfIncidencesByType(loopEachFilter) {

        return getTotalOfIncidencesByTypeFn;

        function getTotalOfIncidencesByTypeFn(data) {
            var total = 0;
            var fast = 0;
            var normal = 0;

            loopEachFilter(data, function (arreglo, itType) {
                if (angular.isArray(arreglo)) {
                    for (var a = 0; a < arreglo.length; a++) {
                        var deduction = arreglo[a];
                        if (deduction.type === 'fast') {
                            fast += parseInt(deduction.value);
                        } else {
                            normal += parseInt(deduction.value);
                        }
                        total += parseInt(deduction.value);
                    }
                }
            });
            return {
                fast: fast,
                total: total,
                normal: normal
            };
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getTotalIncidencesPayment', getTotalIncidencesPayment);

    function getTotalIncidencesPayment($log) {

        return getTotalIncidencesPaymentFn;

        function getTotalIncidencesPaymentFn(incidences, sdr, sd) {
            var real = 0;
            var fiscal = 0;
            var totalDays = 0;
            for (var i = 0; i < incidences.length; i++) {
                var thisIncidence = incidences[i];
                if (['140bis', 'illness'].indexOf(thisIncidence.incType) === -1) {
                    real += sdr;
                    fiscal += sd;
                    totalDays += 1;
                } else {
                    var flag = true;
                    if (thisIncidence.incType === 'illness') {
                        var now = moment(thisIncidence.date).startOf('day');
                        var startDate = moment(thisIncidence.startDate).startOf('day').add(3, 'days');
                        flag = now.valueOf() >= startDate.valueOf();
                    }
                    if (flag) {
                        real += (sdr * 0.6);
                        fiscal += (sd * 0.6);
                        totalDays += 1;
                    }
                }
            }
            real = Math.round(real * 1000) / 1000;
            fiscal = Math.round(fiscal * 1000) / 1000;
            var data = { real: real, fiscal: fiscal, totalDays: totalDays };
            return data;
        }
    }
}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getTotalBalanced', getTotalBalanced);

    function getTotalBalanced($log) {

        return getTotalBalancedFn;

        function getTotalBalancedFn(needToBalanceThis, calcResult, lastCalcResult, lastProccessTotal, otherLastProccessTotal, employeeId, loopTimes) {
            if (angular.isDefined(calcResult)) {
                calcResult = calcResult * 100;
            }
            if (angular.isDefined(lastCalcResult)) {
                lastCalcResult = lastCalcResult * 100;
            }
            if (angular.isDefined(lastProccessTotal)) {
                lastProccessTotal = lastProccessTotal * 100;
            }
            if (angular.isDefined(otherLastProccessTotal)) {
                otherLastProccessTotal = otherLastProccessTotal * 100;
            }
            var totalBalanced = calcResult;
            lastCalcResult = angular.isDefined(lastCalcResult) ? lastCalcResult : 0;
            if (angular.isDefined(otherLastProccessTotal) && otherLastProccessTotal <= 0 && loopTimes > 3) {
                var amountTotalLast = (otherLastProccessTotal * -1) + lastCalcResult;
                if (amountTotalLast < totalBalanced) {
                    totalBalanced = amountTotalLast;
                }
            }
            if (needToBalanceThis) {
                var maxAmountToDiscount = lastProccessTotal + lastCalcResult;
                if (maxAmountToDiscount < 0) {
                    totalBalanced = 0;
                } else if (maxAmountToDiscount < totalBalanced) {
                    totalBalanced = maxAmountToDiscount;
                }
            }
            totalBalanced = totalBalanced / 100;
            return totalBalanced;

        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getSalaryByActiveDays', getSalaryByActiveDays)

    function getSalaryByActiveDays(getFromObjectFilter, $log) {

        return getSalaryByActiveDaysFn;

        function getSalaryByActiveDaysFn(activeDays, employee) {
            var days = {};
            var defaultSalaries = {
                sd: getFromObjectFilter(employee, 'data.salary.sd', 0),
                sbc: getFromObjectFilter(employee, 'data.salary.sbc', 0),
                sdr: getFromObjectFilter(employee, 'data.salary.sdr', 0)
            };
            if (angular.isArray(activeDays)) {
                for (var a = 0; a < activeDays.length; a++) {
                    var thisActiveDays = activeDays[a];
                    var startDate = moment(thisActiveDays.start);
                    var endDate = moment(thisActiveDays.end);
                    while (startDate <= endDate) {
                        var tempDate = startDate.clone();
                        tempDate.add(1, 'days');
                        tempDate.subtract(1, 'ms');
                        var salaryObj = {
                            sd: getFromObjectFilter(thisActiveDays.startMovement, 'data.sd', defaultSalaries.sd),
                            sbc: getFromObjectFilter(thisActiveDays.startMovement, 'data.sbc', defaultSalaries.sbc),
                            sdr: getFromObjectFilter(thisActiveDays.startMovement, 'data.sdr', defaultSalaries.sdr),
                            start: startDate.valueOf(),
                            end: tempDate.valueOf(),
                            isAbsences: false
                        }
                        days[startDate.format('DD-MM-YYYY')] = salaryObj;
                        startDate.add(1, 'days');
                    }
                }
            }
            return days;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getSalariesTotal', getSalariesTotal);

    function getSalariesTotal(loopEachFilter, $log) {

        return getSalariesTotalFn;

        function getSalariesTotalFn(salariesObj, fieldOrValue, validationField, dayValue) {
            var total = 0;
            var thisDayValue = 1;
            if (angular.isDefined(dayValue)) {
                thisDayValue = dayValue;
            }
            if (angular.isObject(salariesObj)) {
                loopEachFilter(salariesObj, function (salaryObj) {
                    if (!salaryObj[validationField]) {
                        var thisValue = fieldOrValue;
                        if (salaryObj.hasOwnProperty(fieldOrValue)) {
                            thisValue = salaryObj[fieldOrValue];
                        }
                        if (!isNaN(parseFloat(thisValue))) {
                            total += (parseFloat(thisValue) * thisDayValue);
                        }
                    }
                });
            }
            total = parseFloat(total.toFixed(4))
            return total;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getSalariesByDayWithAbsences', getSalariesByDayWithAbsences)

    function getSalariesByDayWithAbsences(loopEachFilter, errAlertS, $log) {

        return getSalariesByDayWithAbsencesFn;

        function getSalariesByDayWithAbsencesFn(absencesIncidences, realDailySalariesByDay, maxAbsencesAllowed) {
            // $log.log(arguments);
            var salaries = angular.fromJson(angular.toJson(realDailySalariesByDay));
            if (isNaN(maxAbsencesAllowed) || maxAbsencesAllowed < 0) {
                maxAbsencesAllowed = 999999999;
            }
            var discounted = 0;
            var notDated = 0;
            //Se verifica que existan las incidencias que descuentan faltas para acomodarlas en los dias activos del empleado
            if (angular.isArray(absencesIncidences)) {
                for (var a = 0; a < absencesIncidences.length && discounted < maxAbsencesAllowed; a++) {
                    var thisInc = absencesIncidences[a];
                    //Se checa si la incidencia tiene fecha para descontarla ese dia
                    if (angular.isDefined(thisInc.date)) {
                        var day = moment(thisInc.date);
                        var count = 0;
                        //Se el total de faltas de esa incidencia de faltas
                        while (count < thisInc.value && discounted < maxAbsencesAllowed) {
                            //se cambia la flag de falta a true si existe esa fecha en el calendario y si no se habia marcado previamente como falta
                            if (angular.isDefined(salaries[day.format('DD-MM-YYYY')]) && !salaries[day.format('DD-MM-YYYY')].isAbsences) {
                                salaries[day.format('DD-MM-YYYY')].isAbsences = true;
                                discounted++;
                            } else {
                                //si no se encuentra esa fecha se alamacena en un contador para despues descontarla de los otros dias activos
                                notDated = notDated + 1;
                            }
                            day.add(1, 'days');
                            count++;
                        }
                    } else {
                        //Se almacenan en el contador para despues descontarla en los otros dias activos
                        notDated = notDated + thisInc.value;
                    }
                }
                // console.log(notDated,discounted,maxAbsencesAllowed);
                //Si hay incidencias a descontar sin fecha se checan los dias que aun no se han marcado como ausencias
                if (notDated > 0) {
                    loopEachFilter(salaries, function (data, day) {
                        if (notDated > 0 && !data.isAbsences && discounted < maxAbsencesAllowed) {
                            salaries[day].isAbsences = true;
                            notDated = notDated - 1;
                        }
                    });
                }
                if (notDated > 0) {
                    $log.error('No se pudieron descontar ' + notDated + ' ausencias, el máximo permitido es de ' + maxAbsencesAllowed);
                }
            }
            return salaries;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getRowFromTables', getRowFromTables);

    function getRowFromTables(MongoF) {
        return getRowFromTablesFn;
        function getRowFromTablesFn(gravableBase, table, type) {
            var record = {};
            if (angular.isArray(MongoF[table])) {
                var tableRecords = MongoF[table];
                tableRecords = tableRecords.sort(function (a, b) {
                    return a.upperLimit - b.upperLimit;
                });
                if (type === 'SEMANAL' || type === 'semanal') {
                    type = 'weekly';
                } else {
                    type = 'monthly';
                }
                var thisTable = tableRecords.filter(function (item) {
                    return item.type === type;
                });
                var index = thisTable.findIndex(function (item) {
                    return item.upperLimit >= gravableBase;
                });
                if (index > -1) {
                    record = thisTable[index];
                } else {
                    record = thisTable[thisTable.length - 1];
                }
            }
            return record;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getProcessOfPayrollForSettlement', getProcessOfPayrollForSettlement);

    function getProcessOfPayrollForSettlement(errAlertS, $log, objsToArrayFilter, $filter, orderByFilter, getFromObjectFilter) {

        return getProcessOfPayrollForSettlementFn;

        function getProcessOfPayrollForSettlementFn(schema, processConfig, dispersion, operationIsClosed, concepts, payroll, operationType) {
            var proccess = [];
            if (operationIsClosed) {
                var processCheck = $filter('getFromObject')(dispersion, 'data.process');
                if (angular.isUndefined(processCheck)) {
                    errAlertS('No se encontraron los procesos en la dispersion');
                }
                proccess = processCheck;
            } else {
                var procSchema = $filter('getFromObject')(schema, 'data.processes');
                var procConfig = $filter('getFromObject')(processConfig, 'processes');
                var newProcSchema = [];
                if (angular.isDefined(procSchema)) {
                    if (angular.isArray($filter('getFromObject')(procSchema, 'complements'))) {
                        var complements = $filter('getFromObject')(procSchema, 'complements');
                        var newComplements = [];
                        for (var c = 0; c < complements.length; c++) {
                            complements[c].id = complements[c].type;
                            var index = procConfig.findIndex(function (thisItem) {
                                return thisItem.id === complements[c].type
                            })
                            if (index > -1) {
                                newComplements.push(complements[c])
                            }
                        }
                        if (newComplements.length > 0) {
                            newProcSchema = newProcSchema.concat(complements);
                        }
                    }
                    if (angular.isDefined($filter('getFromObject')(procSchema, 'fiscal'))) {
                        var fiscalData = $filter('getFromObject')(procSchema, 'fiscal');
                        var index = procConfig.findIndex(function (thisItem) {
                            return thisItem.id === 'fiscal'
                        })
                        if (fiscalData.active && index > -1) {
                            fiscalData.id = 'fiscal';
                            newProcSchema.push(fiscalData);
                        }
                    }
                    if (angular.isDefined($filter('getFromObject')(procSchema, 'real'))) {
                        var realData = $filter('getFromObject')(procSchema, 'real');
                        realData.id = 'real';
                        var index = procConfig.findIndex(function (thisItem) {
                            return thisItem.id === 'real'
                        })
                        if (index > -1) {
                            newProcSchema.push(realData);
                        }
                    }
                }
                var procs = [procConfig, newProcSchema];
                var props = ['concepts', 'incidences', 'totals'];
                var processKeys = {};
                for (var p = 0; p < procs.length; p++) {
                    var thisProcs = procs[p];
                    if (angular.isArray(thisProcs)) {
                        for (var t = 0; t < thisProcs.length; t++) {
                            var thisPro = angular.fromJson(angular.toJson(thisProcs[t]));
                            if (processKeys.hasOwnProperty(thisPro.id)) {
                                var index = processKeys[thisPro.id];
                                for (var pr = 0; pr < props.length; pr++) {
                                    if (thisPro.hasOwnProperty(props[pr])) {
                                        var current = [];
                                        if (angular.isDefined(index) && proccess[index].hasOwnProperty(props[pr])) {
                                            current = proccess[index][props[pr]];
                                        }
                                        var next = orderByFilter(objsToArrayFilter(thisPro[props[pr]]), 'order');
                                        var integer = 0;
                                        var idsPending = [];
                                        for (var n = 0; n < next.length; n++) {
                                            var thisNext = next[n];
                                            var existent = current.find(function (item) {
                                                return thisNext.$id === item.$id;
                                            });
                                            if (angular.isDefined(existent)) {
                                                integer = existent.order - 1;
                                                for (var j = 0; j < idsPending.length; j++) {
                                                    current[idsPending[j]].order = (current[idsPending[j]].order + integer);
                                                }
                                                idsPending = [];
                                            } else {
                                                var order = thisNext.order + '';
                                                if (order.length == 1) {
                                                    thisNext.order = thisNext.order / 10;
                                                } else if (order.length === 2) {
                                                    thisNext.order = thisNext.order / 100;
                                                } else {
                                                    thisNext.order = thisNext.order / 1000;
                                                }
                                                current.push(thisNext);
                                                idsPending.push(current.length - 1);
                                            }
                                        }
                                        for (var k = 0; k < idsPending.length; k++) {
                                            current[idsPending[k]].order = (current[idsPending[k]].order + integer);
                                        }
                                        proccess[index][props[pr]] = orderByFilter(current, 'order');
                                    }
                                }
                            } else {
                                proccess.push(thisPro);
                                processKeys[thisPro.id] = proccess.length - 1;
                                for (var pr = 0; pr < props.length; pr++) {
                                    if (thisPro.hasOwnProperty(props[pr])) {
                                        proccess[proccess.length - 1][props[pr]] = orderByFilter(objsToArrayFilter(proccess[proccess.length - 1][props[pr]]), 'order');
                                    }
                                }
                            }
                        }
                    }
                }
                var error = [];
                for (var p = 0; p < proccess.length; p++) {
                    if (['fiscal', 'socialPrevision'].indexOf(proccess[p].id) > -1) {
                        var proc = proccess[p].name;
                        if (operationType === 'asimilated' && proccess[p].id === 'fiscal') {
                            proc = 'ASIMILADOS';
                            proccess[p].realId = 'asimilated';
                        } else if (operationType === 'ptuRecord' && proccess[p].id === 'fiscal') {
                            proc = 'PTU';
                            proccess[p].realId = 'ptu';
                        }
                        if (angular.isDefined(getFromObjectFilter(payroll.processes[proc], 'companiesRecord'))) {
                            proccess[p].companiesRecord = payroll.processes[proc].companiesRecord;
                        } else if (operationType === 'ptuRecord' && proccess[p].id === 'fiscal' && angular.isDefined(getFromObjectFilter(payroll.processes[proccess[p].name], 'companiesRecord'))) {
                            proccess[p].companiesRecord = payroll.processes[proccess[p].name].companiesRecord;
                        } else {
                            error.push('La nomina ' + payroll.data.name + ' no tiene asignado una empresa en el proceso ' + proc);
                        }
                    }
                }

                if (error.length > 0) {
                    for (var e = 0; e < error.length; e++) {
                        errAlertS(error[e]);
                    }
                    proccess = [];
                }
            }
            $log.log(proccess)
            return proccess;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getProcessOfPayroll', getProcessOfPayroll);

    function getProcessOfPayroll(AppF, errAlertS, $log, objsToArrayFilter, $filter, getFromObjectFilter) {

        return getProcessOfPayrollFn;

        function getProcessOfPayrollFn(schema, dispersion, operationIsClosed, payroll, isLastOperation, allConcepts) {
            var proccess = [];
            if (operationIsClosed) {
                var processCheck = $filter('getFromObject')(dispersion, 'data.process');
                if (angular.isUndefined(processCheck)) {
                    errAlertS('No se encontró el proceso en la dispersion');
                }
                proccess = processCheck;
            } else {
                if (angular.isDefined(schema) && angular.isDefined(schema.data) && angular.isDefined(schema.data.processes)) {
                    var processes = schema.data.processes;
                    if (angular.isDefined(processes.real) && processes.real.active) {
                        proccess.push({ id: 'real', name: 'REAL', order: 1, concepts: objsToArrayFilter(processes.real.concepts), totals: objsToArrayFilter(processes.real.totals, false, 'id') });
                    }
                    if (angular.isDefined(processes.fiscal) && processes.fiscal.active) {
                        var thisConcepts = processes.fiscal.concepts;
                        if (isLastOperation && (!payroll.dontDoAnualAdjustment)) {
                            var afterThisConcept = allConcepts.find(function (item) {
                                return item.key === 'isr';
                            })
                            if (angular.isUndefined(afterThisConcept)) {
                                afterThisConcept = allConcepts.find(function (item) {
                                    return item.key === 'fiscalPerceptions';
                                });
                            }
                            if (!afterThisConcept) {
                                errAlertS('No se encontró el concepto después del cual insertar los ajustes anuales');
                            }
                            var anualAsjustementConceptsByCenter = {
                                "tds": "-MpP9V_Hez47ZJksZTre",
                                "integratio": "-NRy2aUchFAHOlM__ov2",
                                "manopco": "-NWDgfLfnUfzwqeyu1O3",
                                "maritur": "-NnLfEdCV_6goyozDnYH",
                                "maravilla": "-NoHRi7uIJR1fakVs-B4",
                                "grupocorerepe": "-O5K9oPbXLqe15xooB51",
                                "solad": "-OAXgUd65TExWUYGYSfV",
                                "halford": "-OBbE25ux424KmOLF-30"
                            }
                            if (angular.isDefined(anualAsjustementConceptsByCenter[AppF.center])) {
                                var anualAjustementConceptId = anualAsjustementConceptsByCenter[AppF.center];
                                thisConcepts[anualAjustementConceptId] = {
                                    active: true,
                                    default: false,
                                    hiddenColumn: false,
                                    order: (thisConcepts[afterThisConcept.$id].order + 1)
                                }
                            }
                        }
                        thisConcepts = objsToArrayFilter(thisConcepts);
                        proccess.push({ id: 'fiscal', name: 'FISCAL', defaultIncidences: processes.fiscal.defaultIncidences, disableCalc: processes.fiscal.disableCalc, order: 2, concepts: thisConcepts, incidences: objsToArrayFilter(processes.fiscal.incidences), totals: objsToArrayFilter(processes.fiscal.totals, false, 'id') });
                    }
                    if (angular.isDefined(processes.complements) && angular.isArray(processes.complements)) {
                        for (var p = 0; p < processes.complements.length; p++) {
                            if (processes.complements[p].active) {
                                var obj = {
                                    id: processes.complements[p].type,
                                    defaultIncidences: processes.complements[p].defaultIncidences ? true : false,
                                    disableCalc: processes.complements[p].disableCalc,
                                    name: processes.complements[p].name, order: (p + 1) * 10,
                                    concepts: objsToArrayFilter(processes.complements[p].concepts),
                                    incidences: objsToArrayFilter(processes.complements[p].incidences),
                                    totals: objsToArrayFilter(processes.complements[p].totals, false, 'id')
                                }
                                if (getFromObjectFilter(processes.complements[p], 'alias')) {
                                    obj.alias = processes.complements[p].alias;
                                }
                                proccess.push(obj);
                            }
                        }
                    }
                    if (angular.isDefined(processes.others) && processes.others.active) {
                        proccess.push({ id: 'others', name: 'OTROS', defaultIncidences: processes.fiscal.defaultIncidences, disableCalc: processes.others.disableCalc, order: 2, concepts: objsToArrayFilter(processes.others.concepts), totals: objsToArrayFilter(processes.others.totals, false, 'id') });
                    }
                    var error = [];
                    for (var p = 0; p < proccess.length; p++) {
                        if (['fiscal', 'socialPrevision'].indexOf(proccess[p].id) > -1) {
                            if (angular.isDefined(getFromObjectFilter(payroll.processes[proccess[p].name], 'companiesRecord'))) {
                                proccess[p].concepts = proccess[p].concepts.filter(function (item) {
                                    var response;
                                    if (item.payrolls) {
                                        response = item.payrolls.indexOf(payroll.$id) > -1;
                                    }
                                    if (!item.payrolls) {
                                        response = item
                                    }
                                    return response

                                });
                                proccess[p].companiesRecord = payroll.processes[proccess[p].name].companiesRecord;
                            } else {
                                error.push("La nomina " + payroll.data.name + " no tiene asignado una empresa en el proceso " + proccess[p].name);
                            }
                        }
                    }
                    if (error.length > 0) {
                        for (var e = 0; e < error.length; e++) {
                            errAlertS(error[e]);
                        }
                        proccess = [];
                    }
                } else {
                    errAlertS('No se encontró el proceso en el esquema');
                }
            }
            var extras = getFromObjectFilter(schema.data.processes, 'real.extras');
            if (angular.isDefined(extras)) {
                var realIndex = proccess.findIndex(function (item) {
                    return item.id === 'real';
                })
                if (realIndex > -1) {
                    proccess[realIndex].extras = objsToArrayFilter(extras);
                } else {
                    proccess.push({ id: 'real', extras: objsToArrayFilter(extras) })
                }
            }
            return proccess;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getProcessForOperation', getProcessForOperation);

    function getProcessForOperation(errAlertS, $log, objsToArrayFilter, $filter) {
        function getFastIncidences(item) {
            return item.type === 'fast';
        }
        function searchEmployee(item) {
            return this.indexOf(item.$id) > -1;
        }
        function getFromClosed(dispersion, payrollProcess) {
            var process;
            if (angular.isObject(dispersion) && angular.isObject(dispersion.data) && angular.isArray(dispersion.data.process)) {
                process = dispersion.data.process;
                for (var pr = 0; pr < process.length; pr++) {
                    var procOfP = payrollProcess.find(function (item) {
                        return item.id === process[pr].id;
                    })
                    if (angular.isDefined(procOfP) && procOfP.hasOwnProperty('extras') && angular.isArray(procOfP.extras)) {
                        process[pr].extras = procOfP.extras;
                    }
                    if (angular.isArray(process[pr].concepts)) {
                        var concepts = process[pr].concepts;
                        for (var c = 0; c < concepts.length; c++) {
                            process[pr].concepts[c].$id = process[pr].concepts[c].id;
                        }
                    } else {
                        process[pr].concepts = [];
                    }
                    if (angular.isArray(process[pr].totals)) {
                        var totals = process[pr].totals;
                        for (var t = 0; t < totals.length; t++) {
                            if (angular.isDefined(process[pr].totals[t].id)) {
                                process[pr].totals[t].$id = process[pr].totals[t].id;
                            }
                        }
                    } else {
                        process[pr].totals = [];
                    }
                }
            }
            return process;
        }

        function getFromPayroll(payrollProcess, allIncidences, conceptsById, employeesOperation, processIncidences) {
            var process = [];
            if (angular.isArray(payrollProcess)) {
                var incidencesByConcepts = $filter('groupByField')(allIncidences, 'incidenceType');
                var errors = [];
                for (var p = 0; p < payrollProcess.length; p++) {
                    var thisP = angular.fromJson(angular.toJson(payrollProcess[p]));
                    if (!thisP.disableCalc && angular.isArray(thisP.concepts)) {
                        var thisConcepts = thisP.concepts;
                        delete thisP.concepts;
                        process.push(thisP);
                        thisP.concepts = [];
                        for (var t = 0; t < thisConcepts.length; t++) {
                            var thisConcept = thisConcepts[t];
                            if ((thisConcept.$id === 'sys_perceptions' || thisConcept.$id === 'sys_deductions') && thisP.id === 'real') {
                                var thisIncidencesByConcepts = angular.fromJson(angular.toJson(incidencesByConcepts));
                                var type = thisConcept.$id === 'sys_perceptions' ? 'perception' : 'deduction';
                                $filter('loopEach')(thisIncidencesByConcepts, function (incidences, incidenceId) {
                                    if (conceptsById.hasOwnProperty(incidenceId) && conceptsById[incidenceId].type === 'incidenceType') {
                                        var employeesId = $filter('getArrayOfIds')(incidences, 'employee');
                                        var employeeOfOperation = employeesOperation.find(searchEmployee, employeesId);
                                        if (conceptsById[incidenceId].nature === type && angular.isDefined(employeeOfOperation)) {
                                            delete incidencesByConcepts[incidenceId];
                                            var fastIncidences = incidences.filter(getFastIncidences);
                                            var concepts = [];
                                            if (fastIncidences.length !== incidences.length) {
                                                var normalObject = {
                                                    '$id': incidenceId,
                                                    'id': incidenceId,
                                                    'name': $filter('getFromObject')(conceptsById, incidenceId + '.name', 'S/N'),
                                                    'key': $filter('getFromObject')(conceptsById, incidenceId + '.key', 'S/N'),
                                                    'nature': $filter('getFromObject')(conceptsById, incidenceId + '.nature', 'S/N'),
                                                    'conceptType': $filter('getFromObject')(conceptsById, incidenceId + '.type', 'S/N'),
                                                    'hiddenColumn': thisConcept.hiddenColumn,
                                                    'showTotal': $filter('getFromObject')(conceptsById, incidenceId + '.showTotal', false),
                                                    'inputType': $filter('getFromObject')(conceptsById, incidenceId + '.inputType', 'currency'),
                                                    'hiddenField': $filter('getFromObject')(conceptsById, incidenceId + '.hiddenField', false),
                                                    'allowNegative': $filter('getFromObject')(conceptsById, incidenceId + '.allowNegative', false),
                                                    'type': 'normal',
                                                    'order': thisConcept.order,
                                                    'hc': $filter('getFromObject')(conceptsById, incidenceId + '.id_human', null),
                                                    'sc': $filter('getFromObject')(conceptsById, incidenceId + '.satCode', null)
                                                };
                                                concepts.push(normalObject);
                                            }
                                            if (fastIncidences.length > 0) {
                                                var fastObject = {
                                                    '$id': incidenceId,
                                                    'id': incidenceId,
                                                    'name': $filter('getFromObject')(conceptsById, incidenceId + '.name', 'S/N'),
                                                    'key': $filter('getFromObject')(conceptsById, incidenceId + '.key', 'S/N'),
                                                    'nature': $filter('getFromObject')(conceptsById, incidenceId + '.nature', 'S/N'),
                                                    'conceptType': $filter('getFromObject')(conceptsById, incidenceId + '.type', 'S/N'),
                                                    'hiddenColumn': thisConcept.hiddenColumn,
                                                    'showTotal': $filter('getFromObject')(conceptsById, incidenceId + '.showTotal', false),
                                                    'inputType': $filter('getFromObject')(conceptsById, incidenceId + '.inputType', 'currency'),
                                                    'hiddenField': $filter('getFromObject')(conceptsById, incidenceId + '.hiddenField', false),
                                                    'allowNegative': $filter('getFromObject')(conceptsById, incidenceId + '.allowNegative', false),
                                                    'type': 'fast',
                                                    'order': thisConcept.order,
                                                    'hc': $filter('getFromObject')(conceptsById, incidenceId + '.id_human', null),
                                                    'sc': $filter('getFromObject')(conceptsById, incidenceId + '.satCode', null)
                                                };
                                                concepts.push(fastObject);
                                            }
                                            thisP.concepts = thisP.concepts.concat(concepts);
                                        }
                                    } else if (conceptsById.hasOwnProperty(incidenceId) && conceptsById[incidenceId].type !== 'incidenceType') {
                                        $log.log('Non incidenceType incidence');
                                    } else {
                                        errors.push('No se encontró el concepto con ID:' + incidenceId + ' de la incidencia');
                                    }
                                });
                            } else if ((thisConcept.$id === 'sys_perceptions' || thisConcept.$id === 'sys_deductions') && thisP.id !== 'real') {
                                var incidences = processIncidences[thisP.id];
                                if (angular.isObject(incidences)) {
                                    $filter('loopEach')(incidences, function (incidence, incidenceId) {
                                        if ((thisConcept.$id === 'sys_perceptions' && incidence.nature === 'perception') || (thisConcept.$id === 'sys_deductions' && incidence.nature === 'deduction')) {
                                            var normalObject = {
                                                '$id': incidenceId,
                                                'id': incidenceId,
                                                'name': $filter('getFromObject')(conceptsById, incidenceId + '.name', 'S/N'),
                                                'key': $filter('getFromObject')(conceptsById, incidenceId + '.key', 'S/N'),
                                                'nature': $filter('getFromObject')(conceptsById, incidenceId + '.nature', 'S/N'),
                                                'conceptType': $filter('getFromObject')(conceptsById, incidenceId + '.type', 'S/N'),
                                                'hiddenColumn': thisConcept.hiddenColumn,
                                                'showTotal': $filter('getFromObject')(conceptsById, incidenceId + '.showTotal', false),
                                                'inputType': $filter('getFromObject')(conceptsById, incidenceId + '.inputType', 'currency'),
                                                'hiddenField': $filter('getFromObject')(conceptsById, incidenceId + '.hiddenField', false),
                                                'allowNegative': $filter('getFromObject')(conceptsById, incidenceId + '.allowNegative', false),
                                                'ignore': true,
                                                'order': thisConcept.order,
                                                'hc': $filter('getFromObject')(conceptsById, incidenceId + '.id_human', null),
                                                'sc': $filter('getFromObject')(conceptsById, incidenceId + '.satCode', null)
                                            };
                                            thisP.concepts.push(normalObject);
                                        }
                                    });
                                }
                            } else if (conceptsById.hasOwnProperty(thisConcept.$id)) {
                                thisConcept.id = thisConcept.$id;
                                thisConcept.name = $filter('getFromObject')(conceptsById, thisConcept.$id + '.name', 'S/N');
                                thisConcept.key = $filter('getFromObject')(conceptsById, thisConcept.$id + '.key', 'S/N');
                                thisConcept.nature = $filter('getFromObject')(conceptsById, thisConcept.$id + '.nature', 'S/N');
                                thisConcept.conceptType = $filter('getFromObject')(conceptsById, thisConcept.$id + '.type', 'S/N');
                                thisConcept.showTotal = $filter('getFromObject')(conceptsById, thisConcept.$id + '.showTotal', false);
                                thisConcept.inputType = $filter('getFromObject')(conceptsById, thisConcept.$id + '.inputType', 'currency');
                                thisConcept.hiddenField = $filter('getFromObject')(conceptsById, thisConcept.$id + '.hiddenField', false);
                                thisP.concepts.push(thisConcept);
                            } else {
                                errors.push('No se encontró el concepto con ID:' + thisConcept.$id);
                            }
                        }
                    }
                    if (!thisP.disableCalc) {
                        if (angular.isArray(thisP.totals)) {
                            for (var t = 0; t < thisP.totals.length; t++) {
                                thisP.totals[t].id = thisP.totals[t].$id;
                            }
                        }
                        if (angular.isArray(thisP.incidences)) {
                            for (var t = 0; t < thisP.incidences.length; t++) {
                                thisP.incidences[t].id = thisP.incidences[t].$id;
                            }
                        }
                    }
                }
                if (errors.length > 0) {
                    errAlertS(errors);
                }
                process.push({
                    id: 'rejectedIncidences',
                    name: 'Incidencias Rechazadas',
                    notCalculate: true
                });
            }
            return process;
        }
        return getProcessForOperationFn;

        function getProcessForOperationFn(payrollProcess, allIncidences, conceptsById, processIncidences, employeesOperation, dispersion, operationIsClosed) {
            employeesOperation = angular.isDefined(employeesOperation) ? employeesOperation : [];
            var process;
            if (operationIsClosed) {
                process = getFromClosed(dispersion, payrollProcess);
            } else {
                process = getFromPayroll(payrollProcess, allIncidences, conceptsById, employeesOperation, processIncidences);
            }
            return process;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getPeriodsAndCalendarForOpe', getPeriodsAndCalendarForOpe);

    function getPeriodsAndCalendarForOpe($log, AppF, ListsF, cleanArrayOfDataFilter, userHasPermissionFilter) {
        return getPeriodsAndCalendarForOpeFn;
        function getPeriodsAndCalendarForOpeFn(payroll, calendar, date, getPeriods, showNextMonth) {
            return new Promise(function (resolve, reject) {
                var utc = moment.utc(moment(date).format('DD-MM-YYYY') + ' 00:00 -0500', 'DD-MM-YYYY HH:mm Z');
                var thisDate = utc.valueOf();
                var originalCalendar = parseInt(calendar);
                var thisCalendar = originalCalendar;
                var diffDate = false;
                var moveToClosedPeriods = userHasPermissionFilter(AppF.groupsOfUser, AppF.permissions, 'moveToClosedPeriods', 'processes.operations');
                var promises = [];
                if (!moveToClosedPeriods) {
                    promises.push(AppF.root.child('/lists/closeOperations/center/' + AppF.center).orderByChild('date').limitToLast(1).once('value'))
                }
                Promise.all(promises).then(function (resp) {
                    promises = [];
                    var initDate = 0;
                    if (resp.length > 0) {
                        resp[0].forEach(function (childSnap) {
                            initDate = childSnap.val().date;
                        });
                    }
                    if (initDate > date) {
                        thisDate = moment(initDate).add(1, 'day').valueOf();
                        diffDate = true;
                        if (getPeriods) {
                            promises.push(AppF.root.child('catalogs/payrollCalendars/' + payroll + '/calendars').orderByChild('data/endDate').startAt(thisDate).limitToFirst(1).once('value'));
                        }
                    }
                    return Promise.all(promises);
                }).then(function (resp) {
                    if (resp.length > 0) {
                        resp[0].forEach(function (childSnap) {
                            if (childSnap.val().data.active) {
                                thisCalendar = parseInt(childSnap.val().data.year);
                            }
                        });
                    }
                    promises = [];
                    if (diffDate || getPeriods) {
                        var endM = moment(thisDate);
                        if (showNextMonth) {
                            endM.add(1, 'month');
                        }
                        endM.endOf('month');
                        var query = [{ q: 'orderByChild', v: 'accuDate' }, { q: 'startAt', v: thisDate }, { q: 'endAt', v: endM.valueOf() }];
                        promises.push(ListsF.loadList('periods', 'catalogs/payrollCalendars/' + payroll + '/periods/' + thisCalendar, undefined, 'array', 'allPeriodOf-' + payroll + 'of' + calendar + 'from:' + thisDate + 'to:' + endM.valueOf(), query));
                    }
                    return Promise.all(promises);
                }).then(function (resp) {
                    var periods = [];
                    if (resp.length > 0 && resp[0].length > 0) {
                        periods = cleanArrayOfDataFilter(resp[0]);
                    }
                    var obj = {
                        exist: diffDate,
                        calendar: originalCalendar,
                        newCalendar: thisCalendar
                    };
                    if (originalCalendar !== thisCalendar) {
                        obj.newCalendar = thisCalendar;
                    }
                    if (periods.length > 0) {
                        obj.periods = periods;
                    }
                    resolve(obj);
                }).catch(reject);
            });
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getOperationForNotification', getOperationForNotification)

    function getOperationForNotification($q, $log, AppF, DataF) {

        return getOperationForNotificationFn;

        function getOperationForNotificationFn(operation, operationTab, moveBack, operationStatusName, comment, operationType) {
            var promise = $q.defer();
            try {
                var querys = {};
                var plainData = {};
                operation = angular.fromJson(angular.toJson(operation));
                plainData.styles = {
                    td: 'border-bottom: 1px dotted #282c37; margin-right: 5px; margin-bottom: 5px; padding: 0px !important; ',
                    strong: 'font-weight: 600;',
                    br: 'line-height: 5px',
                    hidden: 'display: none !important; visibility: hidden !important;'
                };
                plainData.realSpan = 1;
                querys.payrollClass = AppF.root.child('catalogs/payrolls/collection').child(operation.payroll).child('data/class').once('value');
                querys.payrollName = AppF.root.child('lists/payrolls/all').child(operation.payroll).child('name').once('value');
                querys.payrollPaymentFrequency = AppF.root.child('catalogs/payrolls/collection').child(operation.payroll).child('paymentFrequency').once('value');
                querys.createdBy = AppF.root.child('profiles').child(operation.created.by).child('data/name').once('value');
                querys.capturedBy = AppF.root.child('profiles').child(AppF.profile.uid).child('data/name').once('value');
                $q.all(querys).then(function (allData) {
                    plainData.payrollName = allData.payrollName.val();
                    plainData.payrollClass = allData.payrollClass.val();
                    plainData.createdBy = allData.createdBy.val();
                    plainData.capturedBy = allData.capturedBy.val();
                    plainData.payrollPaymentFrequency = allData.payrollPaymentFrequency.val();
                    var subQuerys = {};
                    subQuerys.paymentFrequenciesRecordName = DataF.api.get('paymentFrequenciesRecords/' + plainData.payrollPaymentFrequency);
                    plainData.operationType = angular.isDefined(operationTab) ? operationTab : 'ordinary';
                    plainData.action = moveBack ? 'regresada' : 'actualizada';
                    plainData.statusName = operationStatusName;
                    plainData.center = AppF.center;
                    plainData.msg = ' actualizo a ' + operationStatusName + ' la ';
                    if (moveBack) {
                        plainData.msg = ' regreso a ' + operationStatusName + ' la ';
                    }
                    if (angular.isDefined(operation) && angular.isDefined(operation.comments)) {
                        delete operation.comments;
                    }
                    plainData.operation = operation;
                    plainData.operation = angular.fromJson(angular.toJson(operation));
                    if (plainData.operation.hasOwnProperty('specialPeriod')) {
                        plainData.operation.period = plainData.operation.specialPeriod;
                    }
                    plainData.operation.comment = comment;
                    return $q.all(subQuerys);
                }).then(function (allSubData) {
                    if (allSubData.paymentFrequenciesRecordName.data) {
                        var paymentFrequenciesRecordName = allSubData.paymentFrequenciesRecordName.data.name;
                        if (angular.isString(operationType)) {
                            var thisOpeType = AppF.operationTypes.find(function (item) { return item.id === operationType; });
                            if (angular.isObject(thisOpeType) && thisOpeType.name) {
                                paymentFrequenciesRecordName = thisOpeType.name;
                            }
                        }
                        plainData.paymentFrequenciesRecordName = paymentFrequenciesRecordName;
                        promise.resolve(plainData);
                    } else {
                        promise.reject('No se encontro registro de frecuencia de pago');
                    }
                }).catch(function (err) {
                    promise.reject(err);
                });
            } catch (error) {
                promise.reject(error);
            }
            return promise.promise;
        }
    }
}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getNextOperation', getNextOperation);

    function getNextOperation($log, AppF) {
        function getNextOperation(operation, payrollId, calendarId, refs) {
            return new Promise(function (resolve, reject) {
                var nextOperation;
                var nextCalendar = parseInt(calendarId) + 1;
                AppF.root.child(refs.operations).orderByChild('period').equalTo(operation.period + 1).once('value').then(function (snap) {
                    snap.forEach(function (childSnapshot) {
                        nextOperation = childSnapshot.val();
                        nextOperation.$id = childSnapshot.key;
                    });
                    var promises = [];
                    if (angular.isUndefined(nextOperation)) {
                        var calendarRef = 'catalogs/payrollCalendars/' + operation.payroll + '/calendars';
                        promises.push(AppF.root.child(calendarRef + '/' + nextCalendar).once('value'));
                    }
                    return Promise.all(promises);
                }).then(function (resp) {
                    var promises = [];
                    if (resp.length > 0) {
                        if (resp[0].exists()) {
                            var nextOperationsRef = 'catalogs/operations/ordinary/' + payrollId + '/' + nextCalendar + '/collection';
                            promises.push(AppF.root.child(nextOperationsRef).orderByChild('period').limitToFirst(1).once('value'))
                        } else {
                            throw 'No existe calendario para la siguiente nomina';
                        }
                    }
                    return Promise.all(promises);
                }).then(function (resp) {
                    if (resp.length > 0) {
                        resp[0].forEach(function (childSnapshot) {
                            nextOperation = childSnapshot.val();
                            nextOperation.$id = childSnapshot.key;
                        });
                    }
                    if (angular.isUndefined(nextOperation)) {
                        throw 'No se encontró la siguiente operación';
                    }
                    resolve(nextOperation);
                }).catch(reject);
            });
        }
        return getNextOperationFn;

        function getNextOperationFn(operation, payrollId, calendarId, operationType, refs) {
            return new Promise(function (resolve) {
                var response = {};
                getNextOperation(operation, payrollId, calendarId, refs).then(function (operation) {
                    response.operation = operation;
                    return AppF.root.child('catalogs/payrollCalendars/' + operation.payroll + '/periods/' + operation.calendar + '/' + operation.period).once('value');
                }).then(function (snap) {
                    var period;
                    if (snap.exists()) {
                        period = snap.val();
                        period.$id = snap.key;
                    }
                    if (angular.isUndefined(period)) {
                        throw 'No encontró el periodo de la siguiente operación';
                    }
                    response.period = period;
                    resolve(response);
                }).catch(function (error) {
                    $log.log(error);
                    response = { error: error };
                    resolve(response);
                });
            });
        }
    }
}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getMovementsFromEmploye', getMovementsFromEmploye);

    function getMovementsFromEmploye($rootScope, $q, loopEachFilter, AppF) {

        return getMovementsFromEmployeFn;

        function getMovementsFromEmployeFn(payrollId, operation, from, to) {
            var employeeId;
            var employees = [];
            loopEachFilter(operation.employees, function (data, idEmployee) {
                employeeId = idEmployee;
                employees.push(idEmployee);
            })
            return $q(function (resolve, reject) {
                var queryAggregate = [{
                    '$match': {
                        'employee': { '$in': employees },
                        'payroll': payrollId,
                        'data.date': {
                            '$lt': from
                        },
                        'status': {
                            '$gt': 1
                        }
                    }
                },
                {
                    '$sort': {
                        'employee': 1,
                        'data.date': -1
                    }
                },
                {
                    '$group': {
                        '_id': '$employee',
                        'mid': {
                            '$first': '$_id'
                        },
                        'cc': {
                            '$first': '$cc'
                        },
                        'data': {
                            '$first': '$data'
                        },
                        'info': {
                            '$first': '$info'
                        },
                        'fid': {
                            '$first': '$fid'
                        },
                        'payroll': {
                            '$first': '$payroll'
                        },
                        'rp': {
                            '$first': '$rp'
                        },
                        'status': {
                            '$first': '$status'
                        }
                    }
                },
                {
                    '$match': {
                        'data.type': {
                            '$ne': 2
                        }
                    }
                }];
                var paramsLastMovement = {
                    query: angular.toJson(queryAggregate)
                };
                var queryAggregateLast = [
                    {
                        '$match': {
                            'employee': { '$in': employees },
                            payroll: payrollId,
                            'data.date': {
                                '$gt': from - 1,
                                '$lt': to + 1
                            },
                            status: {
                                '$gt': 1
                            }
                        }
                    },
                    {
                        '$sort': {
                            'employee': 1
                        }
                    },
                    {
                        '$group': {
                            '_id': '$employee',
                            'movements': { '$push': "$$ROOT" }
                        }
                    },
                    {
                        '$unwind': {
                            'path': '$movements'
                        }
                    },
                    {
                        '$replaceRoot': { 'newRoot': { '$mergeObjects': ['$movements', '$$ROOT'] } }
                    }
                ];
                var paramsBetweenMovements = {
                    query: angular.toJson(queryAggregateLast)
                };
                var promises = [
                    $rootScope.D.api.post('aggregate/movements', paramsLastMovement),
                    $rootScope.D.api.post('aggregate/movements', paramsBetweenMovements)
                ];
                $q.all(promises).then(function (resp) {
                    var lastMovements = resp[0].data;
                    var betweenMovements = resp[1].data;
                    for (var l = 0; l < lastMovements.length; l++) {
                        lastMovements[l].employee = lastMovements[l]._id;
                        lastMovements[l]._id = lastMovements[l].mid;
                        var nss = lastMovements[l].info.nss;
                        delete lastMovements[l].mid;
                        lastMovements[l].$id = lastMovements[l].fid;
                        delete lastMovements[l].created;
                        delete lastMovements[l].updated;
                        delete lastMovements[l].archived;
                        delete lastMovements[l].received;
                        delete lastMovements[l].approved;
                        delete lastMovements[l].info;
                        delete lastMovements[l].fid;
                        delete lastMovements[l]._id;
                        delete lastMovements[l].employeeData;
                        delete lastMovements[l].movements;
                        if (nss) {
                            lastMovements[l].data.nss = nss;
                        }
                    }
                    for (var b = 0; b < betweenMovements.length; b++) {
                        betweenMovements[b].$id = betweenMovements[b].fid;
                        var nss2 = betweenMovements[b].info.nss;
                        delete betweenMovements[b].created;
                        delete betweenMovements[b].updated;
                        delete betweenMovements[b].archived;
                        delete betweenMovements[b].received;
                        delete betweenMovements[b].approved;
                        delete betweenMovements[b].info;
                        delete betweenMovements[b].fid;
                        delete betweenMovements[b]._id;
                        delete betweenMovements[b].employeeData;
                        delete betweenMovements[b].movements;
                        if (nss2) {
                            betweenMovements[b].data.nss = nss2;
                        }

                    }
                    var allMovements = lastMovements.concat(betweenMovements);
                    if (operation.movement && angular.isDefined(employeeId)) {

                        allMovements.sort(function (a, b) {
                            return a.data.date - b.data.date;
                        });
                        if (allMovements.length > 0 && allMovements[allMovements.length - 1].data.type === 2) {
                            allMovements[allMovements.length - 1].data.paySalaryInPayrol = true;
                            allMovements[allMovements.length - 1].data.date = operation.movement.date;
                        } else {
                            var thisM = {
                                $id: AppF.root.child('catalogs/movements/collection').push().key,
                                cc: operation.employees[employeeId].cc,
                                data: angular.fromJson(angular.toJson(operation.movement)),
                                employee: employeeId,
                                payroll: payrollId,
                                rp: operation.employees[employeeId].rp,
                                status: 2,
                                bySystem: true
                            };
                            thisM.data.paySalaryInPayrol = true;
                            thisM.data.type = 2;
                            allMovements.push(thisM);
                        }


                        // var thisM = allMovements.findIndex(function (item) {
                        //     return item.employee === employeeId && operation.movement.date === item.data.date;
                        // });
                        // if (thisM < 0) {

                        // } else {

                        // }
                    }
                    resolve({ movements: allMovements });
                }).catch(function (error) {
                    reject(error);
                });
            });
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getMovementsForSpecial', getMovementsForSpecial);

    function getMovementsForSpecial($rootScope, $q, $log) {

        return getMovementsForSpecialFn;

        function getMovementsForSpecialFn(payrollId, from, to) {


            return $q(function (resolve, reject) {
                var initialMatch = {};
                if (angular.isObject(payrollId) && Object.keys(payrollId).length > 0) {
                    initialMatch = payrollId;
                } else if (angular.isString(payrollId)) {
                    initialMatch.payroll = payrollId;
                }
                var queryAggregateLast = [
                    { '$match': Object.assign(initialMatch, { 'data.date': { '$lt': from }, 'status': { '$gt': 1 } }) },
                    { '$sort': { 'employee': 1, 'data.date': -1 } },
                    {
                        '$group': {
                            '_id': '$employee',
                            'mid': { '$first': '$_id' },
                            'cc': { '$first': '$cc' },
                            'data': { '$first': '$data' },
                            'fid': { '$first': '$fid' },
                            'payroll': { '$first': '$payroll' },
                            'rp': { '$first': '$rp' },
                            'status': { '$first': '$status' },
                            'info': { '$first': '$info' }
                        }
                    },
                    { '$match': { 'data.type': { '$ne': 2 } } },
                    { '$project': { 'created': 0, 'updated': 0, 'archived': 0, 'received': 0, 'approved': 0 } },
                    { '$addFields': { 'data.nss': '$info.nss', name: '$info.name' } },
                    { '$project': { 'info': 0 } }
                ];
                var paramsLastMovement = {
                    query: angular.toJson(queryAggregateLast)
                };
                $log.log(angular.toJson(queryAggregateLast))
                var queryAggregateBetween = [
                    { '$match': Object.assign(initialMatch, { 'data.date': { '$gt': from - 1, '$lt': to + 1 }, status: { '$gt': 1 } }) },
                    { '$project': { 'created': 0, 'updated': 0, 'archived': 0, 'received': 0, 'approved': 0 } },
                    { '$sort': { 'employee': 1, 'data.type': -1, 'data.date': -1 } },
                    { '$group': { _id: { employee: '$employee', mType: '$data.type' }, mov: { $first: '$$ROOT' } } },
                    { '$unwind': '$mov' },
                    { $replaceRoot: { newRoot: "$mov" } },
                    { '$addFields': { 'data.nss': '$info.nss', name: '$info.name' } },
                    { '$project': { 'info': 0 } }
                ];
                var paramsBetweenMovements = {
                    query: angular.toJson(queryAggregateBetween)
                };
                $log.log(angular.toJson(queryAggregateBetween))
                var promises = [
                    $rootScope.D.api.post('aggregate/movements', paramsLastMovement),
                    $rootScope.D.api.post('aggregate/movements', paramsBetweenMovements)
                ];
                $q.all(promises).then(function (resp) {
                    var movements = resp.reduce(function (current, item, currInd) {
                        if (angular.isArray(item.data) && item.data.length > 0) {
                            current = current.concat(item.data.map(function (movement) {
                                if (currInd === 0) {
                                    movement.employee = movement._id;
                                    movement._id = movement.mid;
                                    delete movement.mid;
                                    movement.$id = movement.fid;
                                    delete movement.fid;
                                } else {
                                    movement.$id = movement.fid;
                                    delete movement.fid;
                                }
                                movement.data.paySalaryInPayrol = true;
                                return movement;
                            }))
                        }
                        return current;
                    }, []);
                    $log.log(movements);
                    resolve(movements)
                }).catch(function (error) {
                    reject(error);
                });
            });
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getMovementsD', getMovementsD);

    function getMovementsD($rootScope, $q, $log) {

        return getMovementsDFn;

        function getMovementsDFn(payrollId, from, to, employeeProject) {


            return $q(function (resolve, reject) {
                var initialMatch = {};
                if (angular.isObject(payrollId) && Object.keys(payrollId).length > 0) {
                    initialMatch = payrollId;
                } else if (angular.isString(payrollId)) {
                    initialMatch.payroll = payrollId;
                }
                var queryAggregate = [
                    { '$match': Object.assign(initialMatch, { 'data.date': { '$lt': from }, 'status': { '$gt': 1 } }) },
                    { '$sort': { 'employee': 1, 'data.date': -1 } },
                    {
                        '$group': {
                            '_id': '$employee',
                            'mid': { '$first': '$_id' },
                            'cc': { '$first': '$cc' },
                            'data': { '$first': '$data' },
                            'fid': { '$first': '$fid' },
                            'payroll': { '$first': '$payroll' },
                            'rp': { '$first': '$rp' },
                            'status': { '$first': '$status' },
                            'info': { '$first': '$info' }
                        }
                    },
                    { '$match': { 'data.type': { '$ne': 2 } } },
                    {
                        '$facet': {
                            "movements": [
                                { '$project': { 'created': 0, 'updated': 0, 'archived': 0, 'received': 0, 'approved': 0 } },
                                { '$addFields': { 'data.nss': '$info.nss' } },
                                { '$project': { 'info': 0 } }

                            ],
                            "employees": [
                                { '$project': { 'mid': 1 } },
                                { '$lookup': { 'from': 'employees', 'localField': '_id', 'foreignField': 'fid', 'as': 'employeeData' } },
                                { '$unwind': { 'path': '$employeeData' } },
                                { '$replaceRoot': { 'newRoot': { '$mergeObjects': ['$employeeData', '$$ROOT'] } } }
                            ]
                        }
                    }
                ];
                if (employeeProject) {
                    queryAggregate[4].$facet.employees.push({ '$project': Object.assign({ fid: 1 }, employeeProject) });
                }
                var paramsLastMovement = {
                    query: angular.toJson(queryAggregate)
                };
                var queryAggregateLast = [
                    { '$match': Object.assign(initialMatch, { 'data.date': { '$gt': from - 1, '$lt': to + 1 }, status: { '$gt': 1 } }) },
                    { '$sort': { 'employee': 1 } },
                    {
                        '$facet': {
                            "movements": [
                                { '$project': { 'created': 0, 'updated': 0, 'archived': 0, 'received': 0, 'approved': 0 } },
                                { '$addFields': { 'data.nss': '$info.nss' } },
                                { '$project': { 'info': 0 } }
                            ],
                            "employees": [
                                { '$group': { '_id': '$employee' } },
                                { '$lookup': { 'from': 'employees', 'localField': '_id', 'foreignField': 'fid', 'as': 'employeeData' } },
                                { '$unwind': { 'path': '$employeeData' } },
                                { '$replaceRoot': { 'newRoot': { '$mergeObjects': ['$employeeData', '$$ROOT'] } } }
                            ]
                        }
                    }
                ];
                if (employeeProject) {
                    queryAggregateLast[2].$facet.employees.push({ '$project': Object.assign({ fid: 1 }, employeeProject) });
                }
                var paramsBetweenMovements = {
                    query: angular.toJson(queryAggregateLast)
                };
                var promises = [
                    $rootScope.D.api.post('aggregate/movements', paramsLastMovement),
                    $rootScope.D.api.post('aggregate/movements', paramsBetweenMovements)
                ];
                $q.all(promises).then(function (resp) {
                    var employees = {};
                    var allMovements = [];
                    var lastMovements = resp[0].data[0].movements;
                    var lastEmployees = resp[0].data[0].employees;
                    for (var le = 0; le < lastEmployees.length; le++) {
                        var thisEmployee = lastEmployees[le];
                        if (!employees.hasOwnProperty(thisEmployee.fid)) {
                            thisEmployee.$id = thisEmployee.fid;
                            employees[thisEmployee.$id] = thisEmployee;
                        }
                    }
                    for (var l = 0; l < lastMovements.length; l++) {
                        if (employees.hasOwnProperty(lastMovements[l]._id)) {
                            lastMovements[l].employee = lastMovements[l]._id;
                            lastMovements[l]._id = lastMovements[l].mid;
                            delete lastMovements[l].mid;
                            lastMovements[l].$id = lastMovements[l].fid;
                            delete lastMovements[l].fid;
                            allMovements.push(lastMovements[l]);
                        }

                    }
                    var betweenMovements = resp[1].data[0].movements;
                    var betweenEmployees = resp[1].data[0].employees;
                    for (var be = 0; be < betweenEmployees.length; be++) {
                        var thisEmployee2 = betweenEmployees[be];
                        if (!employees.hasOwnProperty(thisEmployee2.fid)) {
                            thisEmployee2.$id = thisEmployee2.fid;
                            employees[thisEmployee2.$id] = thisEmployee2;
                        }
                    }
                    for (var b = 0; b < betweenMovements.length; b++) {
                        if (employees.hasOwnProperty(betweenMovements[b].employee)) {
                            betweenMovements[b].$id = betweenMovements[b].fid;
                            delete betweenMovements[b].fid;
                            allMovements.push(betweenMovements[b]);
                        }
                    }
                    $log.log(allMovements)
                    var response = { movements: allMovements, employees: employees };
                    resolve(response);
                }).catch(function (error) {
                    reject(error);
                });
            });
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getIncidencesTotals', getIncidencesTotals)

    function getIncidencesTotals() {

        return getIncidencesTotalsFn;

        function getIncidencesTotalsFn(incidences) {
            var total = 0;
            var fast = 0;
            var normal = 0;
            if(angular.isArray(incidences)){
                for(var i=0;i<incidences.length;i++){
                    var incidence=incidences[i];
                    if (incidence.type === 'fast') {
                        fast += parseInt(incidence.value);
                    } else {
                        normal += parseInt(incidence.value);
                    }
                    total += parseInt(incidence.value);
                }
            }
            return {
                fast: fast,
                total: total,
                normal: normal
            };
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getIncidencesOfSpecial', getIncidencesOfSpecial);

    function getIncidencesOfSpecial($log) {

        return getIncidencesOfSpecialFn;

        function getIncidencesOfSpecialFn(allIncidences, defaultIncidences, creditIncidences, constantIncidences, specialId, opType) {
            var incidences = [];
            if (angular.isArray(allIncidences)) {
                for (var a = 0; a < allIncidences.length; a++) {
                    var incidence = allIncidences[a];
                    delete incidence.automaticAsignation;
                    if ((incidence.hasOwnProperty(opType) && incidence[opType] === specialId)) {
                        incidences.push(incidence);
                    }
                }
            }

            if (angular.isArray(creditIncidences)) {
                incidences = incidences.concat(creditIncidences);
            }
            if (angular.isArray(constantIncidences)) {
                incidences = incidences.concat(constantIncidences);
            }
            if (angular.isArray(defaultIncidences)) {
                incidences = incidences.concat(defaultIncidences);
            }
            return incidences;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getIncidencesOfSettlement', getIncidencesOfSettlement);

    function getIncidencesOfSettlement($log, getAutoIncidencesFilter) {

        return getIncidencesOfSettlementFn;

        function getIncidencesOfSettlementFn(allIncidences, defaultIncidences, creditIncidences, constantIncidences, settlementId, allEmployees, conceptsById, paymentSchema, employeesOperation, payrollId) {
            var incidences = [];
            if (angular.isArray(allIncidences)) {
                for (var a = 0; a < allIncidences.length; a++) {
                    var incidence = allIncidences[a];
                    delete incidence.automaticAsignation;
                    if ((incidence.hasOwnProperty('settlement') && incidence.settlement === settlementId) || ((!incidence.hasOwnProperty('operationType')) && incidence.status < 3) || (incidence.status >= 3 && incidence.hasOwnProperty('closeOn') && incidence.closeOn === 'settlement')) {
                        incidences.push(incidence);
                    }
                }
            }
            if (paymentSchema && conceptsById && employeesOperation && payrollId) {
                incidences = incidences.concat(getAutoIncidencesFilter(allEmployees, incidences, conceptsById, paymentSchema, employeesOperation, payrollId));
            }
            if (angular.isArray(creditIncidences)) {
                incidences = incidences.concat(creditIncidences);
            }
            if (angular.isArray(constantIncidences)) {
                incidences = incidences.concat(constantIncidences);
            }
            if (angular.isArray(defaultIncidences)) {
                incidences = incidences.concat(defaultIncidences);
            }
            return incidences;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getIncidencesOfOperation', getIncidencesOfOperation);

    function getIncidencesOfOperation($log, getAutoIncidencesFilter) {

        return getIncidencesOfOperationFn;

        function getIncidencesOfOperationFn(allIncidences, appliedIncidences, period, otherIncidences, allEmployees, isClosed, conceptsById, paymentSchema, employeesOperation, payrollId) {
            var incidences = [];
            if (angular.isArray(allIncidences)) {
                for (var a = 0; a < allIncidences.length; a++) {
                    var incidence = allIncidences[a];
                    delete incidence.created;
                    delete incidence.updated;
                    delete incidence.automaticAsignation;
                    if (!incidence.hasOwnProperty('operationType')) {
                        if (isClosed && incidence.status >= 3) {
                            incidences.push(incidence);
                        } else if (!isClosed && incidence.status < 3) {
                            var thisEmployee;
                            if (angular.isObject(allEmployees) && angular.isObject(allEmployees[incidence.employee])) {
                                thisEmployee = allEmployees[incidence.employee];
                            }
                            if (incidence.period <= period || (angular.isDefined(thisEmployee) && thisEmployee.dismissEmployee)) {
                                incidences.push(incidence);
                            }
                        }
                    }
                }
            }
            if (paymentSchema && conceptsById && employeesOperation && payrollId) {
                incidences = incidences.concat(getAutoIncidencesFilter(allEmployees, incidences, conceptsById, paymentSchema, employeesOperation, payrollId));
            }
            if (angular.isArray(appliedIncidences)) {
                for (var j = 0; j < appliedIncidences.length; j++) {
                    var incidenceApplied = appliedIncidences[j];
                    delete incidenceApplied.created;
                    delete incidenceApplied.updated;
                    delete incidenceApplied.automaticAsignation;
                    incidenceApplied.$id = incidenceApplied.fid;
                    if (!incidenceApplied.hasOwnProperty('operationType') && (angular.isUndefined(incidenceApplied.closeOn) || incidenceApplied.closeOn === 'ordinary')) {
                        incidences.push(incidenceApplied);
                    }
                }
            }
            for (var o = 0; o < otherIncidences.length; o++) {
                if (angular.isArray(otherIncidences[o])) {
                    incidences = incidences.concat(otherIncidences[o]);
                }
            }
            return incidences;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getIncidencesD', getIncidencesD);

    function getIncidencesD($q, ListsF, getIncidencesOfThisPeriodFilter, getAppliedIncidencesFilter) {

        return getIncidencesDFn;

        function getIncidencesDFn(period, operationIsClosed, incidencesRef) {
            var deferred = $q.defer();
            var incidencesQueries = [];
            //Si la sabana esta cerrada se obtienen las incidencias de ese periodo y se filtran aquellas que si fueron aplicadas
            if (operationIsClosed) {
                //console.log("Getting incidences of a closed operation");
                incidencesQueries = [{
                    q: 'orderByChild',
                    v: 'period'
                },
                {
                    q: 'equalTo',
                    v: period
                }];
                //$scope.unfilteredIncidences = $firebaseArray(root.child($scope.incidencesRef).orderByChild('period').equalTo($scope.periodNumber));
                ListsF.loadList('incidences', incidencesRef, undefined, 'array', 'incidences-' + period + incidencesRef, incidencesQueries).then(function (incidences) {
                    deferred.resolve({
                        unfilteredIncidences: incidences,
                        incidences: getAppliedIncidencesFilter(incidences)
                    });
                }).catch(function (error) {
                    deferred.reject(error);
                });
            } else { //Si la sabana aun no esta cerrada se obtiene las incidencias de las cuales ya se confirmo que se aplicaran y que no se han aplicado para después filtrar las del periodo correspondiente
                //console.log("Getting incidences of a not closed operation");
                incidencesQueries = [{
                    q: 'orderByChild',
                    v: 'status'
                }, {
                    q: 'startAt',
                    v: 0
                }, {
                    q: 'endAt',
                    v: 2
                }];
                // $scope.unfilteredIncidences = $firebaseArray(root.child($scope.incidencesRef).orderByChild('status').startAt(0).endAt(2));
                ListsF.loadList('incidences', incidencesRef, undefined, 'array', 'incidences-' + 0 + '-' + 2, incidencesQueries).then(function (incidences) {
                    deferred.resolve({
                        unfilteredIncidences: incidences,
                        incidences: getIncidencesOfThisPeriodFilter(incidences, period)
                    });
                }, function (error) {
                    deferred.reject(error);
                });
            }
            return deferred.promise;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getFromTable', getFromTable);

    function getFromTable() {
        return getFromTableFn;
        function getFromTableFn(table, sbc) {
            var percent = 0;
            var upperLimit = 0;
            if (angular.isArray(table) && table.length > 0 && sbc > 0) {
                var count = -1;
                do {
                    count++;
                    percent = table[count].percent;
                    upperLimit = table[count].upperLimit;
                } while (sbc > upperLimit && count < table.length - 1);
            }
            // $log.log(table, percent, sbc);
            return percent;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getFiscalEmployeesD', getFiscalEmployeesD);

    function getFiscalEmployeesD($log) {

        return getFiscalEmployeesDFn;

        function getFiscalEmployeesDFn(dispersion, employeesOperation, ccs, rps) {
            var fiscalEmployees = [];
            if (angular.isDefined(dispersion) && Object.keys(dispersion).length > 0) {
                $log.log('Aquí obtendremos los empleados fiscales de los cálculos');
            } else {
                for (var e = 0; e < employeesOperation.length; e++) {
                    var thisEmployee = employeesOperation[e];
                    var isFiscal = false;
                    if (angular.isDefined(thisEmployee.movements)) {
                        for (var m in thisEmployee.movements) {
                            if (thisEmployee.movements.hasOwnProperty(m)) {
                                var cc = thisEmployee.movements[m].cc;
                                if (angular.isDefined(cc)) {
                                    var thisCC = ccs.find(function (item) {
                                        return item.$id === cc;
                                    });
                                    if (angular.isDefined(thisCC)) {
                                        var thisRp = rps.find(function (item) {
                                            return item.$id === thisCC.data['rp_id'];
                                        });
                                        if (angular.isDefined(thisRp)) {
                                            isFiscal = thisRp.data.name !== '00000000000';
                                        }
                                    }
                                }
                            }
                        }
                    }
                    if (isFiscal) {
                        fiscalEmployees.push(thisEmployee);
                    }
                }
            }
            return fiscalEmployees;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getEmployeesAndDataForOperationD', getEmployeesAndDataForOperationD);

    function getEmployeesAndDataForOperationD(getEmployeeOfMovementFilter, loopEachFilter, $q) {
        return getEmployeesAndDataForOperationDFn;

        function getEmployeesAndDataForOperationDFn(movementsGroupedByEmployee, dispersion, payrollId, operation, period, myCcs) {
            return $q(function (resolve) {
                var dispersionEmployees = {};
                var operationEmployees = {};
                if (angular.isObject(dispersion) && angular.isObject(dispersion.calculations)) {
                    dispersionEmployees = dispersion.calculations;
                }
                if (angular.isObject(operation.employees)) {
                    operationEmployees = operation.employees;
                }
                var promises = {};
                loopEachFilter(movementsGroupedByEmployee, function (movements, employeeId) {
                    promises[employeeId] = getEmployeeOfMovementFilter(employeeId, movements, period, payrollId, myCcs, operationEmployees[employeeId], dispersionEmployees[employeeId]);
                });
                $q.all(promises).then(function (employeesRes) {
                    var allEmployees = [];
                    var operationEmployees = [];
                    var fbEmployees = [];
                    var ccs = [];
                    var rps = [];
                    var credits = [];
                    loopEachFilter(movementsGroupedByEmployee, function (movements, employeeId) {
                        if (angular.isDefined(employeesRes[employeeId])) {
                            var thisEmployeeObj = employeesRes[employeeId];
                            allEmployees.push(thisEmployeeObj.employee);
                            fbEmployees.push(thisEmployeeObj.employeeObj);
                            for (var c = 0; c < thisEmployeeObj.ccs.length; c++) {
                                var indexCc = ccs.findIndex(function (item) {
                                    return thisEmployeeObj.ccs[c].$id === item.$id;
                                });
                                if (indexCc === -1) {
                                    ccs.push(thisEmployeeObj.ccs[c]);
                                }
                            }
                            for (var r = 0; r < thisEmployeeObj.rps.length; r++) {
                                var indexRp = rps.findIndex(function (item) {
                                    return thisEmployeeObj.rps[r].$id === item.$id;
                                });
                                if (indexRp === -1) {
                                    rps.push(thisEmployeeObj.rps[r]);
                                }
                            }
                            credits.push(thisEmployeeObj.credits);
                            if (thisEmployeeObj.valid) {
                                operationEmployees.push(thisEmployeeObj.employee);
                            }
                        }
                    });
                    var finalResponse = {
                        allEmployees: allEmployees,
                        operationEmployees: operationEmployees,
                        fbEmployees: fbEmployees,
                        credits: credits,
                        employeesCcs: ccs,
                        rps: rps
                    };
                    resolve(finalResponse);
                });
            });
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getEmployeeOfMovement', getEmployeeOfMovement);

    function getEmployeeOfMovement($filter, $log, $q) {
        return getEmployeeOfMovementFn;
        function resolveError(resolve, error, employeeId) {
            var response;
            if (angular.isUndefined(error) || angular.isString(error)) {
                response = error;
            } else {
                response = 'No pudo cargar el empleado con id' + employeeId;
                $log.error(employeeId, error);
            }
            resolve(response);
        }
        function getEmployeeOfMovementFn(employeeId, movements, payrollId, employeeIsClosed, calendarId, opObjs, cleanedObjs) {
            return $q(function (resolve) {
                try {
                    var flags = {
                        employeeIsClosed: employeeIsClosed,
                        dismissEmployee: false
                    };
                    var promise = $filter('getAndSetEmployeeData')(employeeId, movements, payrollId, calendarId, 'ordinary', opObjs, cleanedObjs, flags);
                    promise.then(function (thisEmployee) {
                        //Se establece la configuración de las prestaciones;
                        if (!employeeIsClosed) {
                            var realSeniorityDate = thisEmployee.data.realSeniorityDate;
                            if (angular.isUndefined(realSeniorityDate)) {
                                realSeniorityDate = thisEmployee.data.seniorityDate;
                            }
                            if (angular.isUndefined(realSeniorityDate)) {
                                realSeniorityDate = thisEmployee.data.enroleDate;
                            }
                            thisEmployee.fiscalBenefitConfig = $filter('getFactorFromBenefits')(thisEmployee.benefitData, thisEmployee.data.enroleDate, thisEmployee.periodData.end, undefined, true);
                            thisEmployee.realBenefitConfig = $filter('getFactorFromBenefits')(thisEmployee.benefitData, realSeniorityDate, thisEmployee.periodData.end, undefined, true);
                        }
                        //Se establece los últimos cálculos del año si se esta realizando el calculo anual de operaciones
                        var thisCalculations = $filter('getFromObject')(opObjs.finalCalculations, 'fb.' + employeeId);
                        if (angular.isObject(thisCalculations) && angular.isArray(thisCalculations.calculations)) {
                            thisCalculations.calculations = thisCalculations.calculations.sort(function (a, b) {
                                return a.month - b.month;
                            });
                        }
                        thisEmployee.finalCalculations = thisCalculations;
                        //Se establece la información de la ultima operación
                        var operationId = $filter('getFromObject')(opObjs.allOperations, 'fb.employees.' + thisEmployee.$id);
                        var lastOperationData = $filter('getFromObject')(opObjs.allOperations, 'fb.operation.' + operationId);
                        if (angular.isDefined(lastOperationData) && angular.isDefined(opObjs.lastPeriodData) && angular.isDefined(opObjs.lastPeriodData.fb)) {
                            delete lastOperationData.employees;
                            var accuDateOrdinary;
                            var accuDateLast;
                            var ordinaryAccuDate = $filter('getFromObject')(opObjs.lastPeriodData.fb, 'accuDate');
                            var lastAccuDate = $filter('getFromObject')(lastOperationData, 'accuDate');
                            if (angular.isNumber(ordinaryAccuDate)) {
                                accuDateOrdinary = moment(ordinaryAccuDate)
                            }
                            if (angular.isNumber(lastAccuDate)) {
                                accuDateLast = moment(lastAccuDate)
                            }
                            if (employeeId === '-Nqn2LPJK_1TZQemqTJE') {
                                $log.log(lastOperationData, opObjs.lastOperation.fb, ordinaryAccuDate, lastAccuDate, accuDateOrdinary.format('MM'), accuDateLast.format('MM'))
                            }
                            if (angular.isDefined(accuDateOrdinary) && angular.isDefined(accuDateLast) && accuDateOrdinary.format('MM') !== accuDateLast.format('MM')) {
                                lastOperationData.isAdjustment = false;
                            } else {
                                //Puesto que pudo haber obtenido datos de operaciones de muy atrás se valida si es o no ajuste en base a la operación inmediata anterior
                                lastOperationData.isAdjustment = opObjs.lastOperation && opObjs.lastOperation.fb && opObjs.lastOperation.fb.isAdjustment;
                            }
                        }
                        thisEmployee.lastOperationData = lastOperationData;
                        resolve(thisEmployee);
                    }).catch(function (error) {
                        resolveError(resolve, error, employeeId);
                    });
                } catch (error) {
                    resolveError(resolve, error, employeeId);
                }

            });
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getEmployeeForSpecial', getEmployeeForSpecial);

    function getEmployeeForSpecial($filter, $log, $q, AppF) {
        return getEmployeeForOpeFn;
        function resolveError(resolve, error, employeeId) {
            var response;
            if (angular.isUndefined(error) || angular.isString(error)) {
                response = error;
            } else {
                response = 'No pudo cargar el empleado con id' + employeeId;
                $log.error(employeeId, error);
            }
            resolve(response);
        }
        function getEmployeeForOpeFn(employeeId, movements, payrollId, employeeIsClosed, calendarId, opObjs, cleanedObjs, setFiscal, operationType) {
            return $q(function (resolve) {
                try {
                    var flags = {
                        forceOperationEmployee: AppF.operationTypesRelaxed.concat(['extraordinary']).indexOf(operationType) > -1 ? true : false,
                        setFiscal: setFiscal,
                        employeeIsClosed: employeeIsClosed,
                        forceCheckAndLoadData: AppF.operationTypesRelaxed.concat(['ptuRecord', 'extraordinary']).indexOf(operationType) > -1 ? true : false,
                        forceValid: operationType === 'ptuDistributionRecord' ? false : true,
                        setLastMovement: operationType === 'chrisBonusRecord'
                    };
                    var promise = $filter('getAndSetEmployeeData')(employeeId, movements, payrollId, calendarId, operationType, opObjs, cleanedObjs, flags);
                    promise.then(function (thisEmployee) {
                        //Se establece la configuración de las prestaciones;
                        if (!employeeIsClosed) {
                            var realSeniorityDate;
                            if (thisEmployee.data.realSeniorityDate) {
                                realSeniorityDate = thisEmployee.data.realSeniorityDate;
                            } else if (thisEmployee.data.seniorityDate) {
                                realSeniorityDate = thisEmployee.data.seniorityDate;
                            } else {
                                realSeniorityDate = thisEmployee.data.enroleDate;
                            }
                            thisEmployee.fiscalBenefitConfig = $filter('getFactorFromBenefits')(thisEmployee.benefitData, thisEmployee.data.seniorityDate ? thisEmployee.data.seniorityDate : thisEmployee.data.enroleDate, thisEmployee.periodData.end, undefined, true);
                            thisEmployee.realBenefitConfig = $filter('getFactorFromBenefits')(thisEmployee.benefitData, realSeniorityDate, thisEmployee.periodData.end, undefined, true);
                        }
                        //Se establece la información de la ultima operación
                        var operationId = $filter('getFromObject')(opObjs.allOperations, 'fb.employees.' + thisEmployee.$id);
                        var lastOperationData = $filter('getFromObject')(opObjs.allOperations, 'fb.operation.' + operationId);
                        if (angular.isDefined(lastOperationData)) {
                            delete lastOperationData.employees;
                            //como se recuperan solo las operaciones del mes aunque sea de ajuste es decir el ultimo pues se calcula con todos los datos del periodo
                            thisEmployee.operationData.isAdjustment = lastOperationData.isAdjustment;
                            delete lastOperationData.isAdjustment;
                        } else if (operationType === 'extraordinary') {
                            thisEmployee.operationData.isFirstAndNoOpeExtraordinary = true;
                        }
                        thisEmployee.lastOperationData = lastOperationData;
                        resolve(thisEmployee);
                    }).catch(function (error) {
                        resolveError(resolve, error, employeeId);
                    });
                } catch (error) {
                    resolveError(resolve, error, employeeId);
                }

            });
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getEmployeeForOpe', getEmployeeForOpe);

    function getEmployeeForOpe($filter, $log, $q) {
        return getEmployeeForOpeFn;
        function resolveError(resolve, error, employeeId) {
            var response;
            if (angular.isUndefined(error) || angular.isString(error)) {
                response = error;
            } else {
                response = 'No pudo cargar el empleado con id' + employeeId;
                $log.error(employeeId, error);
            }
            resolve(response);
        }
        function getEmployeeForOpeFn(employeeId, movements, payrollId, employeeIsClosed, calendarId, opObjs, cleanedObjs) {
            return $q(function (resolve) {
                try {
                    var flags = {
                        employeeIsClosed: employeeIsClosed
                    };
                    var promise = $filter('getAndSetEmployeeData')(employeeId, movements, payrollId, calendarId, 'settlement', opObjs, cleanedObjs, flags);
                    promise.then(function (thisEmployee) {
                        var movement;
                        if (!employeeIsClosed) {
                            movement = thisEmployee.movements.find(function (item) {
                                return item.data.type === 2;
                            });
                        }
                        //Se establece la configuración de las prestaciones
                        var benefitConfig = {};
                        if (angular.isObject(movement) && angular.isObject(movement.data) && movement.data.hasOwnProperty('b')) {
                            benefitConfig = {
                                factor: movement.data.b.f,
                                christmasBonus: movement.data.b.c,//aguinaldo,
                                daysOfVacation: movement.data.b.h,//vacaciones,
                                prime: movement.data.b.p,//prima,
                                othersTotal: movement.data.b.o,//otros,
                                years: movement.data.b.y, //Años de antigüedad
                                realYears: movement.data.b.ry || movement.data.b.y//Años de antigüedad reales
                            };
                        } else if (!employeeIsClosed) {
                            benefitConfig = $filter('getFactorFromBenefits')(thisEmployee.benefitData, thisEmployee.data.seniorityDate ? thisEmployee.data.seniorityDate : thisEmployee.data.enroleDate, opObjs.operation.fb.movement.date, undefined, true);
                        }
                        thisEmployee.realBenefitConfig = angular.fromJson(angular.toJson(benefitConfig));
                        thisEmployee.fiscalBenefitConfig = benefitConfig;
                        if (angular.isNumber(thisEmployee.data.realSeniorityDate)) {
                            thisEmployee.realBenefitConfig = !employeeIsClosed ? $filter('getFactorFromBenefits')(thisEmployee.benefitData, thisEmployee.data.realSeniorityDate, opObjs.operation.fb.movement.date, undefined, true) : {};
                        }
                        // thisEmployee.fiscalBenefitConfig = angular.fromJson(angular.toJson(benefitConfig));
                        //Se establece la información de la ultima operación
                        var lastOperationData;
                        if (angular.isDefined(opObjs.lastOperation) && angular.isDefined(opObjs.lastOperation.fb)) {
                            lastOperationData = $filter('clearObject')(opObjs.lastOperation.fb);
                            delete lastOperationData.employees;
                        }
                        thisEmployee.lastOperationData = lastOperationData;
                        resolve(thisEmployee);
                    }).catch(function (error) {
                        resolveError(resolve, error, employeeId);
                    });
                } catch (error) {
                    resolveError(resolve, error, employeeId);
                }
            });
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getEmployeeCalculations', getEmployeeCalculations);

    function getEmployeeCalculations($rootScope, $q, loopEachFilter, $log) {

        return getEmployeeCalculationsFn;

        function getEmployeeCalculationsFn(employeeIds, payroll, procs, momentObj) {
            return $q(function (resolve, reject) {
                var fiscalCompany;
                loopEachFilter(procs, function (data, key) {
                    if (data.id === 'fiscal' && data.hasOwnProperty('companiesRecord')) {
                        fiscalCompany = data.companiesRecord;
                    }
                });
                if (angular.isDefined(fiscalCompany)) {
                    var branches = [];
                    var startDate = moment().startOf('year');

                    if (!momentObj) {
                        startDate = moment();
                    } else {
                        startDate = momentObj;
                    }
                    startDate.startOf('year');
                    var endDate = startDate.clone();
                    endDate.endOf('year');
                    var startTimeStamp = startDate.valueOf();
                    var endTimStamp = endDate.valueOf();
                    while (startDate.valueOf() < endDate.valueOf()) {
                        branches.push({ case: { $lte: ['$accuDate', startDate.endOf('month').valueOf()] }, then: startDate.format('MM') });
                        startDate.add(5, 'days');
                    }
                    var params = {
                        query: angular.toJson([
                            {
                                $match: {
                                    'employeeId': { '$in': employeeIds },
                                    // 'payroll': payroll,
                                    'companiesRecords.companiesRecordId': fiscalCompany,
                                    'accuDate': { '$gte': startTimeStamp, '$lte': endTimStamp },
                                    'operationType': { '$in': ['ordinary', 'chrisBonusRecord', 'extraordinary', 'ptuRecord'] }
                                }
                            },
                            { $sort: { 'accuDate': 1 } },
                            {
                                $addFields: {
                                    month: {
                                        $switch: {
                                            branches: branches,
                                            default: '00'
                                        }
                                    }
                                }
                            },
                            { $sort: { employeeId: 1, accuDate: 1 } },
                            {
                                $group: {
                                    _id: { employeeId: '$employeeId', month: '$month' },
                                    //calculations: { $push: '$$ROOT' },
                                    gravableBase: { $sum: '$gravableBase.value' },
                                    extraTimeDiff: { $sum: '$gravableBase.extraTimeDiff' },
                                    isrRetained: { $sum: '$isr.isrOfPeriodToRetain' },
                                    isrRetainedBonus: { $sum: '$isrBonus.isrOfPeriodToRetain' },
                                    isrPtuRetained: { $sum: '$isrPTU.isrOfPeriodToRetain' },
                                    isrPtuRetainedIntegratio: { $sum: '$PTUIsr.fiscalValue' },
                                    fiscalPerceptions: { $sum: '$fiscalPerceptions.wSalary' },
                                    subCaused: { $sum: '$subsidy.subCausedToRep' }
                                }
                            },
                            {
                                $group: {
                                    _id: '$_id.employeeId',
                                    gravableBase: { $sum: '$gravableBase' },
                                    extraTimeDiff: { $sum: '$extraTimeDiff' },
                                    isrRetained: { $sum: { $add: ['$isrRetained', '$isrRetainedBonus', '$isrPtuRetained', '$isrPtuRetainedIntegratio'] } },
                                    fiscalPerceptions: { $sum: '$fiscalPerceptions' },
                                    subCaused: { $sum: '$subCaused' },
                                    count: { $sum: 1 },
                                    calculations: {
                                        $push: {
                                            month: '$_id.month',
                                            gravableBase: '$gravableBase',
                                            extraTimeDiff: '$extraTimeDiff',
                                            isrRetained: { $add: ['$isrRetained', '$isrRetainedBonus', '$isrPtuRetained'] },
                                            fiscalPerceptions: '$fiscalPerceptions',
                                            subCaused: '$subCaused'
                                        }
                                    }
                                }
                            }
                        ])
                    };
                    $rootScope.D.api.post('aggregate/calculations', params).then(function (resp) {
                        var data = {};
                        if (angular.isArray(resp.data)) {
                            for (var d = 0; d < resp.data.length; d++) {
                                data[resp.data[d]._id] = resp.data[d];
                            }
                        }
                        resolve(data);
                    }).catch(function (error) {
                        $log.log(error);
                        reject("Error al consultar los últimos datos");
                    });
                } else {
                    resolve({});
                }
            });
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getEmployeeAccount', getEmployeeAccount);

    function getEmployeeAccount($log, getEmployeePaymentFormFilter) {

        return getEmployeeAccountFn;

        function getEmployeeAccountFn(employee, processId, operationType, defaultPaymentFormId) {
            console.log(employee)
            console.log(employee.paymentForms, processId, operationType)
            var employeePaymentForm = getEmployeePaymentFormFilter(employee.paymentForms, processId, operationType);
            console.log('empleados', employeePaymentForm)
            if (angular.isDefined(employeePaymentForm) && employeePaymentForm !== defaultPaymentFormId) {
                throw 'La forma de pago de este ' + employee.data.name + ' no es transferencia';
            }
            if (!angular.isArray(employee.accounts) && employee.accounts.length === 0) {
                throw 'El empleado ' + employee.data.name + ' no tiene cuentas validas registradas';
            }
            var card = employee.accounts.find(function (item) {
                return item.procId === processId;
            });
            if (angular.isUndefined(card)) {
                throw employee.data.name + ' no tiene ninguna cuenta configurada para este proceso';
            } else {
                card.thisAccount = card.number;
            }
            return card;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getDispFileName', getDispFileName);

    function getDispFileName() {

        return getDispFileNameFn;

        function getDispFileNameFn(init, end, bankAccount, payroll, calendar, period) {
            var fileName = angular.isString(init) ? init : '';
            fileName += '_' + bankAccount.name;
            if (angular.isObject(payroll)) {
                fileName += '_' + payroll.data.class + '_' + payroll.data.name;
            }
            if (calendar) {
                fileName += '_' + calendar;
            }
            if (period) {
                fileName = fileName + '_' + (('' + period.period).length > 9 ? period.period : '0' + period.period);
            }
            fileName += angular.isString(end) ? '_' + end : '';
            return fileName;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getDefaultIncidences', getDefaultIncidences);

    function getDefaultIncidences(loopEachFilter, AppF, DataF) {

        return getDefaultIncidencesFn;

        function getDefaultIncidencesFn(opType, operation, calendar, period, isClosed) {
            var incidences = [];
            if (!isClosed) {
                if (angular.isDefined(operation) && angular.isDefined(operation.incidences) && angular.isDefined(operation.employees)) {
                    loopEachFilter(operation.incidences, function (value, incidenceId) {
                        if (value === true) {
                            loopEachFilter(operation.employees, function (data, idEmployee) {
                                var incidence = {
                                    '$id': AppF.root.child('incidences').push().key,
                                    employee: idEmployee,
                                    incidenceType: incidenceId,
                                    period: parseInt(period),
                                    calendar: parseInt(calendar),
                                    value: 1,
                                    type: 'system',
                                    status: 0,
                                    operationType: opType,
                                    comments: 'Incidencia generada por el sistema',
                                    created: DataF.getTimeObject()
                                };
                                incidence[opType] = operation.$id;
                                incidences.push(incidence);
                            });
                        }
                    });
                }
            }
            console.log(incidences)
            return incidences;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getDataBankAccount', getDataBankAccount)

    function getDataBankAccount(ListsF, $filter, $log) {

        return getDataBankAccountFn;

        function getDataBankAccountFn(payrollId, bankAccountsAll, type, bankId) {
            return new Promise(function(resolve, reject){
                var promises = [
                    ListsF.loadList('payrolls', 'catalogs/payrolls/collection/'+payrollId+'/processes/', undefined, 'array', 'process'+payrollId)
                ];
                Promise.all(promises).then(function(snap){
                    var payroll = $filter('cleanArrayOfData')(snap[0]);
                    if(payroll.length){
                        var bankAccount = payroll.find(function(value){
                            return value.$id === type;
                        });
                        if(angular.isDefined(bankAccount) && angular.isArray(bankAccount.bankAccounts)){
                            var data = [];
                            for(var i = 0; i < bankAccount.bankAccounts.length; i++){
                                var findBank = bankAccountsAll.find(function(value){
                                    return value._id === bankAccount.bankAccounts[i];
                                });
                                if(angular.isDefined(findBank) && findBank.bank === bankId){
                                    data.push(findBank);
                                    break;
                                }
                            }
                            if(data.length > 0){
                                resolve(findBank);
                            }else{
                                resolve({message:'No se encontró el registro de banco en la configuración del proceso'});
                            }
                        }else{
                            resolve({message:'No se encontró empresa configurada en el proceso'});
                        }
                    }else{
                        resolve({message:'No se encontró ningún registro de la nómina'});
                    }
                }).catch(function(error){
                    $log.error(error);
                    reject('Ocurrió un error al obtener la información de la nómina');
                })
            })           
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getConstantsOfEmployee', getConstantsOfEmployee);

    function getConstantsOfEmployee(ListsF, $log, $q, $rootScope) {

        return getConstantsOfEmployeeFn;

        function getConstantsOfEmployeeFn(employee) {
            return $q(function (resolve, reject) {
                var query = {
                    'itemId': angular.toJson({ $in: ['default', employee.payroll, employee.cc, employee.$id] }),
                    'constantType': angular.toJson({ $in: ['automaticApply', 'notApply', 'customField'] })
                };
                $rootScope.D.api.get('operationConstants', query).then(function (thisResp) {
                    var constantsPriority = {
                        'default': 1,
                        'payroll': 11,
                        'cc': 21,
                        'employee': 31
                    };
                    var all2 = [];
                    for (var s = 0; s < thisResp.data.length; s++) {
                        var thisObject = thisResp.data[s];
                        thisObject.priority = constantsPriority[thisObject.type];
                        thisObject.$id = thisObject.fid;
                        all2.push(thisObject);
                    }
                    all2 = all2.sort(function (a, b) {
                        return b.priority - a.priority;
                    });
                    var uniques = [];
                    var items = all2.filter(function (item) {
                        var value = item.incidencesType || item.customField.key;
                        if (uniques.indexOf(value) === -1) {
                            uniques.push(value);
                            return true;
                        }
                        return false;
                    });
                    resolve(items);
                }).catch(reject);
            });
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getConstantsIncidences', getConstantsIncidences)

    function getConstantsIncidences(orderByFilter, $log, AppF, getFromObjectFilter) {

        return getConstantsIncidencesFn;

        function getConstantsIncidencesFn(employees, allEmployees, calendar, period, payroll, incidences, conceptsById, opType, opTypeId, operation, lastOperation) {
            var automaticApply = [];
            var constantsFilter = {};
            if (angular.isArray(employees)) {
                for (var e = 0; e < employees.length; e++) {
                    var employee = allEmployees[employees[e].$id];
                    if (!employee.isClosed) {
                        var constants = angular.isArray(employee.constants) ? employee.constants.slice() : [];
                        constantsFilter[employee.$id] = [];
                        constants = orderByFilter(constants.filter(function (item) {
                            return ['automaticApply', 'notApply'].indexOf(item.constantType) > -1;
                        }), '-priority');
                        if (angular.isArray(constants)) {
                            for (var c = 0; c < constants.length; c++) {
                                var thisConstant = constants[c];
                                if (thisConstant.constantType === 'automaticApply' && angular.isDefined(thisConstant.incidencesType)) {
                                    var autoApplyObj = thisConstant.automaticApply;
                                    var createValidation = {
                                        'period': function () {
                                            return true;
                                        },
                                        'endOfMonth': function () {
                                            return operation && operation.isAdjustment;
                                        },
                                        'startOfMonth': function () {
                                            return angular.isUndefined(lastOperation) || Object.keys(lastOperation).length === 0 || lastOperation.isAdjustment;
                                        },
                                        'employeeBirthday': function () {
                                            var flag = false;
                                            if (!employee.birthday) {
                                                var birthday = getFromObjectFilter(employee.data, 'info.birth.date');
                                                if (angular.isDefined(birthday)) {
                                                    var birthMoment = moment(employee.data.info.birth.date);
                                                    var yearsDiff = moment(employee.periodData.end).diff(birthMoment, 'years');
                                                    birthMoment.add(yearsDiff, 'years');
                                                    employee.birthday = birthMoment;
                                                    flag = employee.periodData.start <= employee.birthday.valueOf() && employee.birthday.valueOf() <= employee.periodData.end;
                                                }
                                            } else {
                                                flag = employee.periodData.start <= employee.birthday.valueOf() && employee.birthday.valueOf() <= employee.periodData.end;
                                            }
                                            return flag;
                                        },
                                        'employeeAniversary': function () {
                                            var flag = false;
                                            if (!employee.$employeeAniversary) {
                                                var employeeAniversary = employee.data.seniorityDate ? employee.data.seniorityDate : employee.data.enroleDate;
                                                if (angular.isDefined(employeeAniversary)) {
                                                    var enroleMoment = moment(employeeAniversary);
                                                    var yearsDiff = moment(employee.periodData.end).diff(enroleMoment, 'years');
                                                    if (yearsDiff < 1) {
                                                        yearsDiff = 1;
                                                    }
                                                    enroleMoment.add(yearsDiff, 'years');
                                                    employee.$employeeAniversary = enroleMoment.valueOf();
                                                }
                                            }
                                            flag = employee.periodData.start <= employee.$employeeAniversary && employee.$employeeAniversary <= employee.periodData.end;
                                            return flag;
                                        }
                                    };
                                    var create = createValidation[autoApplyObj.each]();
                                    if (create && angular.isDefined(autoApplyObj.from) && autoApplyObj.from > period.end) {
                                        create = false;
                                    }
                                    if (create && angular.isDefined(autoApplyObj.to) && autoApplyObj.to < period.start) {
                                        create = false;
                                    }
                                    if (create && angular.isDefined(conceptsById[constants[c].incidencesType]) && (conceptsById[constants[c].incidencesType].payroll === 'global' || conceptsById[constants[c].incidencesType].payroll === payroll)) {
                                        var exists = constantsFilter[employee.$id].filter(function (value) {
                                            return value.incidencesType === constants[c].incidencesType;
                                        });
                                        if (exists.length === 0) {
                                            constantsFilter[employee.$id].push(constants[c]);
                                            if (getFromObjectFilter(conceptsById[constants[c].incidencesType], 'processes.' + opType, false)) {
                                                var incidenceObj = {
                                                    $id: AppF.root.child(incidences).push().key,
                                                    status: 0,
                                                    calendar: parseInt(calendar),
                                                    period: parseInt(period.period),
                                                    employee: employee.$id,
                                                    incidenceType: constants[c].incidencesType,
                                                    payroll: payroll,
                                                    process: false,
                                                    type: 'constant',
                                                    value: parseFloat((constants[c].automaticApply && constants[c].automaticApply.value) ? constants[c].automaticApply.value : 0),
                                                    date: period.start,
                                                    comments: 'Incidencia Automática por Constante'
                                                };
                                                if (opType !== 'payroll') {
                                                    incidenceObj.operationType = opType;
                                                    incidenceObj[opType] = opTypeId;
                                                }
                                                automaticApply.push(incidenceObj);
                                            }
                                        }
                                    }
                                }

                            }
                        }
                    }
                }
            }
            return automaticApply;
        }
    }
}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getConstantsForCustomField', getConstantsForCustomField);

    function getConstantsForCustomField($filter) {

        return getConstantsForCustomFieldFn;

        function getConstantsForCustomFieldFn(value, field) {
            var thisConstants = [];
            var customField = {};
            var constants = $filter('orderBy')($filter('filter')(value, field), "-priority");
            if(angular.isArray(constants)){
                for(var c = 0; c < constants.length; c++){
                    var exists = thisConstants.filter(function (value) {
                        return value.customField.key === constants[c].customField.key ;
                    })
                    if(exists.length === 0){
                        thisConstants.push(constants[c]);
                        customField[constants[c].customField.key] = constants[c].customField.value;
                    }
                }
            }
            return customField;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getConceptsForPayroll', getConceptsForPayroll);

    function getConceptsForPayroll() {
        return getConceptsForPayrollFn;
        function getConceptsForPayrollFn(data, params) {
            var concepts = [];
            for (var i = 0; i < data.length; i++) {
                if (data[i].type === params.type && data[i].allowManual === params.allowManual && (data[i].payroll === params.payroll || data[i].payroll === 'global')) {
                    if ((params.hasOwnProperty('process') && angular.isDefined(data[i].processes) && data[i].processes[params.process]) || !params.hasOwnProperty('process')) {
                        concepts.push(data[i]);
                    }
                }
            }
            var conceptsOfPayroll = [];
            var seenKeys = {};
            for (var c = 0; c < concepts.length; c++) {
                var concept = concepts[c];
                if (!seenKeys[concept.key]) {
                    seenKeys[concept.key] = concept;
                } else if (concept.payroll !== 'global' && seenKeys[concept.key].payroll === 'global') {
                    seenKeys[concept.key] = concept;
                }

            }
            conceptsOfPayroll = Object.values(seenKeys);
            conceptsOfPayroll = conceptsOfPayroll.filter(function (item) {
                if (!item.payrollsRemoved) {
                    return true
                }
                return !item.payrollsRemoved.includes(params.payroll);
            });
            return conceptsOfPayroll;
        }
    }
}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getCompaniesName', getCompaniesName);

    function getCompaniesName(AppF, ListsF, $filter, $log) {

        return getCompaniesNameFn;

        function getCompaniesNameFn(payrollId, type, action, bankAccountsAll, bank) {
            return new Promise(function (resolve, reject) {
                var promises = [
                    ListsF.loadList('payrolls', 'catalogs/payrolls/collection/' + payrollId + '/processes/', undefined, 'array', 'process' + payrollId + type)
                ];
                var execute = {
                    paymentForm: function (payroll, type) {
                        return (angular.isDefined(payroll.companiesRecord)) ? payroll : { message: 'No se encontró cuenta configurada en el proceso ' + type };
                    },
                    layoutBanks: function (payroll, type, bankAccountsAll) {
                        var bankAccount = execute.paymentForm(payroll, type);
                        var response;
                        if (angular.isDefined(bankAccount.message)) {
                            response = bankAccount;
                        } else {
                            if (bank) {
                                if (angular.isObject(bankAccount) && angular.isArray(bankAccount.bankAccounts)) {
                                    for (var b = 0; b < bankAccount.bankAccounts.length && angular.isUndefined(response); b++) {
                                        var founded = bankAccountsAll.find(function (value) {
                                            return value._id === bankAccount.bankAccounts[b];
                                        });
                                        if (angular.isDefined(founded) && founded.bank === bank._id) {
                                            response = founded;
                                        }
                                    }
                                }
                            } else {
                                var bankAccountId = bankAccount.bankAccounts[0];
                                response = bankAccountsAll.find(function (value) {
                                    return value._id === bankAccountId;
                                });
                            }
                            if (angular.isUndefined(response)) {
                                response = { message: 'No se encontró ningún registro de la cuenta en el listado de la cuenta de bancos' };
                            }
                        }
                        return response;
                    }
                };
                Promise.all(promises).then(function (snap) {
                    var payrolls = $filter('cleanArrayOfData')(snap[0]);
                    var payroll = payrolls.find(function (value) {
                        return value.$id === type;
                    });
                    if (angular.isUndefined(payroll) && type === 'PTU') {
                        payroll = payrolls.find(function (value) {
                            return value.$id === 'FISCAL';
                        });
                    }
                    if (angular.isDefined(payroll)) {
                        var data = {};
                        if (angular.isDefined(action) && execute.hasOwnProperty(action.function)) {
                            data[action.function] = execute[action.function](payroll, type, bankAccountsAll);
                        }
                        $log.log(data);
                        if (angular.isDefined(action) && data.hasOwnProperty(action.function) && angular.isDefined(data[action.function].message)) {
                            resolve(data[action.function]);
                        } else {
                            if (angular.isDefined($filter('getFromObject')(payroll, 'companiesRecord'))) {
                                getBusinessName(payroll.companiesRecord, type).then(function (response) {
                                    if (angular.isDefined(action) && data.hasOwnProperty(action.function)) {
                                        response[action.name] = data[action.function];
                                    }
                                    resolve(response);
                                });
                            } else {
                                resolve({ message: 'No se encontró empresa configurada en el proceso' });
                            }
                        }
                    } else {
                        resolve({ message: 'No se encontró ningún registro de la nómina' });
                    }
                }).catch(function (error) {
                    $log.error(error);
                    reject('Ocurrió un error al obtener la información de la nómina');
                });
            });
        }
        function getBusinessName(companyRecord, type) {
            return new Promise(function (resolve, reject) {
                AppF.root.child('catalogs/companiesRecords/collection/' + companyRecord).once('value').then(function (snap) {
                    if (snap.exists()) {
                        var data = snap.val();
                        resolve(data);
                    } else {
                        resolve({ message: 'No hay ninguna cuenta asignada en la nómina en ' + type });
                    }
                }).catch(function (error) {
                    $log.error(error);
                    reject('Ocurrió un error al momento de obtener el nombre de la empresa');
                });
            });
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getBusinessName', getBusinessName)

    function getBusinessName(AppF, ListsF, $filter, $log) {

        return getBusinessNameFn;

        function getBusinessNameFn(payrollId, bankAccountsAll, type, action) {
            return new Promise(function (resolve, reject) {
                var promises = [
                    ListsF.loadList('payrolls', 'catalogs/payrolls/collection/' + payrollId + '/processes/', undefined, 'array', 'process' + payrollId)
                ];
                Promise.all(promises).then(function (snap) {
                    var payroll = $filter('cleanArrayOfData')(snap[0]);
                    if (payroll.length) {
                        var bankAccount = payroll.find(function (value) {
                            return value.$id === type;
                        });
                        if (angular.isDefined(bankAccount) && angular.isArray(bankAccount.bankAccounts)) {
                            var bankAccountId = bankAccount.bankAccounts[0];
                            var companyRecord = bankAccountsAll.find(function (value) {
                                return value._id === bankAccountId;
                            });
                            if (angular.isDefined(companyRecord)) {
                                getBusinessName(companyRecord, type).then(function (response) {
                                    if (['layout', 'settlement'].indexOf(action) > -1) {
                                        response.bankAccount = companyRecord;
                                    } else if (action === 'paymentForm') {
                                        response.banks = bankAccount;
                                    }
                                    resolve(response);
                                })
                            } else {
                                resolve({ message: 'No se encontró ningún registro de la cuenta en el listado de la cuenta de bancos' });
                            }
                        } else {
                            resolve({ message: 'No se encontró empresa configurada en el proceso' });
                        }
                    } else {
                        resolve({ message: 'No se encontró ningún registro de la nómina' });
                    }
                }).catch(function (error) {
                    $log.error(error);
                    reject('Ocurrió un error al obtener la información de la nómina');
                })
            })
        }
        function getBusinessName(companyRecord, type) {
            return new Promise(function (resolve, reject) {
                AppF.root.child('catalogs/companiesRecords/collection/' + companyRecord.companiesRecord).once('value').then(function (snap) {
                    if (snap.exists()) {
                        var data = snap.val();
                        resolve(data);
                    } else {
                        resolve({ message: 'No hay ninguna cuenta asignada en la nómina en ' + type });
                    }
                }).catch(function (error) {
                    $log.error(error);
                    reject('Ocurrió un error al momento de obtener la cuenta de bancos');
                })
            })
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getBimonthlyDays', getBimonthlyDays);

    function getBimonthlyDays() {

        return getBimonthlyDaysFn;

        function getBimonthlyDaysFn(date) {
            var thisDate = moment(date);
            var numberOfM = thisDate.month();
            numberOfM = numberOfM + 1;
            var isFirst = numberOfM % 2;
            numberOfM = numberOfM + (isFirst ? -1 : -2);
            thisDate.month(numberOfM);
            thisDate.startOf("month");
            var endDate = thisDate.clone();
            endDate.add(1, "month");
            endDate.endOf("month");
            var diff = endDate.diff(thisDate, "days") + 1
            return diff;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getAutoIncidences', getAutoIncidences);

    function getAutoIncidences(AppF, $log, getFromObjectFilter) {

        return getAutoIncidencesFn;

        function getAutoIncidencesFn(allEmployees, incidences, conceptsByKey, paymentSchema, operation, payroll) {
            var automaticApply = [];
            var done = {};
            var procs = getFromObjectFilter(paymentSchema.data, 'processes.complements', []);
            for (var i = 0; i < incidences.length; i++) {
                var incidence = incidences[i];
                var employee = allEmployees[incidence.employee];
                var incidenceType = conceptsByKey[incidence.incidenceType];
                var employeeOperation = operation[incidence.employee];
                if (angular.isDefined(employee) && angular.isDefined(incidenceType) && angular.isDefined(employeeOperation) && employeeOperation.status < 3 && !employee.isClosed && angular.isArray(incidenceType.generateAuto)) {
                    for (var g = 0; g < incidenceType.generateAuto.length; g++) {
                        var thisIncConfig = incidenceType.generateAuto[g];
                        var autoIncidence = conceptsByKey[thisIncConfig.incidenceType];
                        if (angular.isDefined(autoIncidence) && (autoIncidence.payroll === 'global' || autoIncidence.payroll === payroll) && !done.hasOwnProperty(incidence.employee + '-' + thisIncConfig.incidenceType)) {
                            var doit = true;
                            if (thisIncConfig.validation && thisIncConfig.validation !== '') {
                                doit = false;
                                try {
                                    doit = eval(thisIncConfig.validation);
                                } catch (error) {
                                    doit = false;
                                }
                            }
                            if (doit) {
                                var incidenceObj = {
                                    $id: AppF.root.child('incidences').push().key,
                                    status: 0,
                                    calendar: incidence.calendar,
                                    period: incidence.period,
                                    employee: incidence.employee,
                                    incidenceType: thisIncConfig.incidenceType,
                                    payroll: incidence.payroll,
                                    process: false,
                                    type: 'system',
                                    value: 1,
                                    date: incidence.date,
                                    comments: 'Incidencia Automática por Referencia'
                                };
                                automaticApply.push(incidenceObj);
                                done[incidence.employee + '-' + thisIncConfig.incidenceType] = true;
                            }
                        }
                    }

                }
            }
            return automaticApply;
        }
    }
}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getAndSetEmployeeData', getAndSetEmployeeData);

    function getAndSetEmployeeData($q, ListsF, $filter, MongoF, $log, DataF) {
        function filterById(item) {
            return item[this.field] === this.key;
        }
        var employeeFromMovActionAfter = {
            chrisBonusRecord: function (thisEmployee, employeeIsClosed) {
                if (thisEmployee.lastMovementData && !employeeIsClosed) {
                    var movement = thisEmployee.lastMovementData;
                    if (movement.data.sdr) {
                        thisEmployee.data.salary.sdr = movement.data.sdr;
                    }
                    if (movement.data.sbc) {
                        thisEmployee.data.salary.sbc = movement.data.sbc;
                    }
                    if (movement.data.sd) {
                        thisEmployee.data.salary.sd = movement.data.sd;
                    }
                    if (movement.data.nss) {
                        thisEmployee.data.nss = movement.data.nss
                    }
                    if (movement.data.department) {
                        thisEmployee.data.department = movement.data.department
                    }
                }
            }
        }
        var employeeFromMovAction = {
            ptuDistributionRecord: function (thisEmployee, employeeIsClosed, operation, dispersionEmployee, operationEmployee) {
                if (angular.isObject(operationEmployee)) {
                    for (var key in operationEmployee) {
                        if (operationEmployee.hasOwnProperty(key)) {
                            thisEmployee[key] = operationEmployee[key];
                        }
                    }
                }
            },
            settlement: function (thisEmployee, employeeIsClosed, operation) {
                if (employeeIsClosed) {
                    var movementFromOpe = $filter('getFromObject')(operation, 'movement');
                    if (angular.isDefined(movementFromOpe)) {
                        thisEmployee.data.salary.type = movementFromOpe.salaryType;
                        thisEmployee.data.salary.sdr = movementFromOpe.sdr;
                        thisEmployee.data.department = movementFromOpe.department;
                        thisEmployee.data.salary.sd = movementFromOpe.sd || undefined;
                        thisEmployee.data.salary.sbc = movementFromOpe.sbc || undefined;
                        thisEmployee.data.comments = movementFromOpe.comments;
                        thisEmployee.data.position = movementFromOpe.position;
                        if (angular.isDefined(movementFromOpe.enroleDate)) {
                            thisEmployee.data.enroleDate = movementFromOpe.enroleDate;
                        }
                        if (angular.isDefined(movementFromOpe.seniorityDate)) {
                            thisEmployee.data.seniorityDate = movementFromOpe.seniorityDate;
                            thisEmployee.hasSeniorityDate = true;
                        } else {
                            delete thisEmployee.data.seniorityDate;
                            thisEmployee.hasSeniorityDate = false;
                        }
                        if (angular.isDefined(movementFromOpe.department)) {
                            thisEmployee.data.department = movementFromOpe.department;
                        }
                    }
                } else {
                    var movement = thisEmployee.movements.find(function (item) {
                        return item.data.type === 2;
                    });
                    if (angular.isDefined(movement) && !movement.bySystem) {
                        thisEmployee.cc = movement.cc;
                        thisEmployee.payroll = movement.payroll;
                        thisEmployee.rp = movement.rp;
                        thisEmployee.data.salary.type = movement.data.salaryType;
                        thisEmployee.data.salary.sdr = movement.data.sdr;
                        thisEmployee.data.department = movement.data.department;
                        thisEmployee.data.salary.sd = movement.data.sd || undefined;
                        thisEmployee.data.salary.sbc = movement.data.sbc || undefined;
                        thisEmployee.data.comments = movement.data.comments;
                        thisEmployee.data.position = movement.data.position;
                        thisEmployee.movement = movement.data;
                        if (angular.isDefined(movement.data.enroleDate)) {
                            thisEmployee.data.enroleDate = movement.data.enroleDate;
                        }
                        if (angular.isDefined(movement.data.seniorityDate)) {
                            thisEmployee.data.seniorityDate = movement.data.seniorityDate;
                            thisEmployee.hasSeniorityDate = true;
                        } else {
                            delete thisEmployee.data.seniorityDate;
                            thisEmployee.hasSeniorityDate = false;
                        }
                        if (angular.isDefined(movement.data.department)) {
                            thisEmployee.data.department = movement.data.department;
                        }
                    }
                }
            }
        };
        var getFn = {
            lastMovementData: function (employee, cleanedObjs, opObjs) {
                var params = {
                    'employee': employee.$id,
                    'data.date': { $lt: opObjs.operation.fb.specialDate },
                    'payroll': cleanedObjs.payroll.$id,
                    'sort': angular.toJson({ 'data.date': -1 })
                };
                return DataF.api.get('one/movements', params);
            },
            rpData: function (employee) { return ListsF.loadList('rps', 'catalogs/rps/collection/' + employee.movements[0].rp, undefined, 'object', 'catalogs/rps/collection/' + employee.movements[0].rp); },
            ccData: function (employee) { return ListsF.loadList('ccs', 'catalogs/ccs/collection/' + employee.movements[0].cc, undefined, 'object', 'catalogs/ccs/collection/' + employee.movements[0].cc); },
            benefitData: function (employee) { return $filter('getBenefitsOfItem')(employee); },
            creditData: function (employee) { return ListsF.loadList('credits', 'lists/credits/active/' + employee.$id, undefined, 'array', 'creditsActive/' + employee.$id); },
            constants: function (employee) { return $filter('getConstantsOfEmployee')(employee); },
            positionData: function (employee) { return ListsF.loadList('positions', 'lists/positions/all/' + employee.data.position, undefined, 'object', 'positionOf' + employee.$id); },
            departmentName: function (employee) { return ListsF.loadList('departments', 'lists/departments/all/' + employee.department + '/name', undefined, 'object', 'departmentName' + employee.department); },
            satContractType: function (employee) {
                var params = {
                    query: angular.toJson([
                        { $match: { employee: employee.$id } },
                        { $sort: { 'startDate': -1 } },
                        { $limit: 1 },
                        { $addFields: { 'documentType_id': { $toObjectId: '$documentType' } } },
                        { $lookup: { from: 'documentTypes', localField: 'documentType_id', foreignField: '_id', as: 'documentData' } },
                        { $unwind: '$documentData' },
                        { $project: { 'satContractType': '$documentData.satContractTypeData.id' } }
                    ])
                };
                return DataF.api.post('aggregate/documents', params);
            },
            fiscalPositionData: function (employee) { return ListsF.loadList('positions', 'lists/positions/all/' + employee.positionData.fiscalPosition, undefined, 'object', 'positionFiscalOf' + employee.$id); },
            companiesRecord: function (employee) { return ListsF.loadList('companiesRecords', 'catalogs/companiesRecords/collection/' + employee.rpData.companiesRecord, undefined, 'object', 'companiesRecords-' + employee.rpData.companiesRecord); }
        };
        var setFn = {
            lastMovementData: function (resp) { return $filter('getFromObject')(resp, 'data.data.0', {}); },
            creditData: function (resp) { return angular.isArray(resp) && resp.length > 0 ? resp[0] : undefined; },
            constants: 'array',
            positionData: function (resp) {
                var obj = { name: 'S/P', isFiscal: true };
                if (angular.isObject(resp) && resp.name) {
                    obj.name = resp.name;
                    obj.isFiscal = resp.isFiscal ? true : false;
                    if (!resp.isFiscal) {
                        obj.fiscalPosition = resp.fiscalPosition;
                    }
                }
                return obj;
            },
            departmentName: function (resp) {
                var name = 'Sin Departamento';
                if (resp.$value) {
                    name = resp.$value;
                }
                return name;
            },
            satContractType: function (resp) { return angular.isArray(resp.data) && resp.data.length > 0 && angular.isDefined(resp.data[0].satContractType) ? resp.data[0].satContractType : undefined; },
            fiscalPositionData: function (resp) { return { name: (resp && resp.name) ? resp.name : 'S/P' }; },
            fiscalPositionData2: function (employee) { return employee.positionData; },
            accounts: function (employee, cleanedObjs) {
                var obj = [];
                var accounts = $filter('getFromObject')(employee.data, 'cards', []);
                if (angular.isArray(accounts) && accounts.length > 0) {
                    for (var e = 0; e < cleanedObjs.employeeProcess.length; e++) {
                        var thisProcess = cleanedObjs.employeeProcess[e];
                        if ((thisProcess.id === 'fiscal' && employee.isFiscal) || thisProcess.id !== 'fiscal') {
                            var thisAccount;
                            if (thisProcess.realId !== thisProcess.id) {
                                thisAccount = accounts.find(function (item) {
                                    return item.process === thisProcess.realId;
                                });
                            }
                            if (angular.isUndefined(thisAccount)) {
                                thisAccount = accounts.find(function (item) {
                                    return item.process === thisProcess.id;
                                });
                            }
                            if (angular.isUndefined(thisAccount)) {
                                thisAccount = accounts.find(function (item) {
                                    return !item.process;
                                });
                            }
                            if (angular.isUndefined(thisAccount)) {
                                thisAccount = accounts[0];
                            }
                            if (angular.isDefined(thisAccount)) {
                                var number = thisAccount.emit ? thisAccount.account : thisAccount.number;
                                if (angular.isDefined(number) && angular.isDefined(thisAccount.bank)) {
                                    obj.push({
                                        procId: thisProcess.id,
                                        bank: thisAccount.bank,
                                        number: number
                                    });
                                }
                            }
                        }
                    }
                }

                return obj;
            },
            dismissDate: function (employee) {
                var movement = angular.isArray(employee.movements) && employee.movements.length > 0 ? employee.movements[employee.movements.length - 1] : undefined;//Se obtiene el ultimo movimiento del empleado
                var data = angular.isDefined(movement) && angular.isDefined(movement.data) && movement.data.type === 2 ? movement.data : employee.data;//se valida si ese movimiento es de baja, si no se obtiene el dato del empleado
                var dismissDate = angular.isNumber(data.date) ? data.date : data.dismissDate;//Se valida que si es el ultimo movimiento de baja se obtiene el dato de la fecha de baja de lo contrario se obtiene el dato del empleado
                return dismissDate;
            },
            enroleDate: function (employee) {
                var movement = angular.isArray(employee.movements) && employee.movements.length > 0 ? employee.movements[0] : undefined;
                var data = angular.isDefined(movement) && angular.isDefined(movement.data) ? movement.data : employee.data;
                var enroleDate = angular.isNumber(data.seniorityDate) ? data.seniorityDate : data.enroleDate;
                return enroleDate;
            },
            sdr: function (employee) { return $filter('getFromObject')(employee.data, 'salary.sdr'); },
            department: function (employee) { return $filter('getFromObject')(employee.data, 'department'); },
            sd: function (employee) { return $filter('getFromObject')(employee.data, 'salary.sd'); },
            sbc: function (employee) { return $filter('getFromObject')(employee.data, 'salary.sbc'); },
            nss: function (employee, cleanedObjs, opObjs, operationType) {
                var nss;
                var movement = angular.isArray(employee.movements) && employee.movements.length > 0 ? employee.movements[0] : undefined;
                if (operationType === 'ptuRecord' && angular.isUndefined($filter('getFromObject')(movement.data, 'nss'))) {
                    movement = employee.movements.find(function (thisMov) {
                        return angular.isDefined($filter('getFromObject')(thisMov.data, 'nss'));
                    });
                }
                if (movement) {
                    nss = $filter('getFromObject')(movement.data, 'nss');
                } else if (movement && movement.payroll === cleanedObjs.payroll.$id) {
                    nss = $filter('getFromObject')(employee.data, 'nss');
                }
                return nss;
            },
            place: function (employee) { return MongoF.placesOfWorkRecords.find(filterById, { key: $filter('getFromObject')(employee.rpData, 'data.placesOfWorkRecord'), field: '_id' }); },
            ccPlace: function (employee) { return MongoF.placesOfWorkRecords.find(filterById, { key: $filter('getFromObject')(employee.ccData, 'data.place'), field: '_id' }); },
            state: function (employee) { return MongoF.states.find(filterById, { key: $filter('getFromObject')(employee.place, 'state_id'), field: '_id' }) },
            geoZone: function (employee) { return $filter('getFromObject')(MongoF.geoZones.find(filterById, { key: $filter('getFromObject')(employee.place, 'geoZone_id'), field: '_id' }), 'name'); },
            minimumWageOfEmployee: function (employee, cleanedObjs, opObjs) { return (angular.isString(employee.geoZone) ? $filter('getFromObject')(opObjs.minimumWageRecords.fb, 'minimumVariables.' + employee.geoZone.replace(/ /g, '-')) : undefined); },
            cyvRecords: function (employee, cleanedObjs) { return (angular.isString(employee.geoZone) ? $filter('getFromObject')(cleanedObjs.cyvRecordsData, employee.geoZone.replace(/ /g, '-')) : undefined); },
            customField: function (employee) { return angular.isArray(employee.constants) ? $filter('getConstantsForCustomField')(employee.constants, 'customField') : {}; }
        };
        function processFields(fields, thisEmployee, cleanedObjs, opObjs, operationType) {
            return new Promise(function (resolve, reject) {
                var promises = [];
                var pendingToSet = [];
                for (var f = 0; f < fields.length; f++) {
                    var thisField = fields[f];
                    var nameFn = thisField.alias || thisField.path;
                    if (angular.isUndefined(thisEmployee[thisField.path])) {
                        if (angular.isFunction(getFn[nameFn]) && (angular.isUndefined(thisField.getValidation) || thisField.getValidation)) {
                            promises.push(getFn[nameFn](thisEmployee, cleanedObjs, opObjs));
                            pendingToSet.push(thisField);
                        } else if (angular.isFunction(setFn[nameFn]) && (angular.isUndefined(thisField.getValidation) || thisField.getValidation)) {
                            var value = setFn[nameFn](thisEmployee, cleanedObjs, opObjs, operationType);
                            if (angular.isDefined(value)) {
                                thisEmployee[thisField.path] = value;
                            }
                        }
                    }
                }
                Promise.all(promises).then(function (resp) {
                    for (var p = 0; p < pendingToSet.length; p++) {
                        var thisField = pendingToSet[p];
                        var nameFn = thisField.alias || thisField.path;
                        var thisResp = resp[p];
                        var value;
                        if (angular.isFunction(setFn[nameFn])) {
                            value = setFn[nameFn](thisResp, cleanedObjs, opObjs, operationType);
                        } else if (setFn[nameFn] === 'array') {
                            value = angular.isArray(thisResp) ? thisResp.slice() : [];
                        } else {
                            value = $filter('clearObject')(thisResp);
                        }
                        if (angular.isDefined(value)) {
                            thisEmployee[thisField.path] = value;
                        }
                    }
                    resolve(true);
                }).catch(reject);
            });
        }
        function getExternalData(thisEmployee, employee, employeeIsClosed, opObjs, cleanedObjs, operationType, flags) {
            return $q(function (resolve, reject) {
                thisEmployee.objsToWatch = {};//Cuando se quiera observar algún cambio se mete a este objeto para que luego se establezca los parámetros de observación
                thisEmployee.objsToWatch['employee-' + employee.$id] = { fb: employee, actions: ['setEmployeeData'] };
                var isOpen = !employeeIsClosed;
                var fields = [
                    { path: 'rpData' },
                    { path: 'ccData' },
                    { path: 'benefitData', getValidation: isOpen },
                    { path: 'creditData', getValidation: isOpen },
                    { path: 'constants', getValidation: isOpen },
                    { path: 'positionData', getValidation: isOpen },
                    { path: 'department', getValidation: isOpen }
                ];
                if (flags.setLastMovement) {
                    fields.push({ path: 'lastMovementData', getValidation: isOpen });
                }
                processFields(fields, thisEmployee, cleanedObjs, opObjs, operationType).then(function () {
                    if (angular.isDefined(employeeFromMovActionAfter[operationType])) {
                        employeeFromMovActionAfter[operationType](thisEmployee, flags.employeeIsClosed, opObjs.operation.fb, $filter('getFromObject')(opObjs.dispersion, 'fb.employees.' + thisEmployee.$id));
                    }
                    thisEmployee.isFiscal = flags.setFiscal ? true : $filter('getFromObject')(thisEmployee, 'rpData.data.name') !== '00000000000';
                    var isOpenAndNeedContractType = (isOpen && thisEmployee.isFiscal && ['asimilated', 'special', 'ptuDistributionRecord'].indexOf(operationType) === -1) ? true : false;
                    var fiscalPosNeeded = (isOpenAndNeedContractType && thisEmployee.positionData && (!thisEmployee.positionData.isFiscal) && thisEmployee.positionData.fiscalPosition) ? true : false;
                    fields = [
                        { path: 'place' },
                        { path: 'ccPlace' },
                        { path: 'state' },
                        { path: 'geoZone', getValidation: isOpen },
                        { path: 'stateSatCode', getValidation: isOpen },
                        { path: 'minimumWageOfEmployee', getValidation: isOpen },
                        { path: 'cyvRecords', getValidation: isOpen },
                        { path: 'customField', getValidation: isOpen },
                        { path: 'satContractType', getValidation: isOpenAndNeedContractType },
                        { path: 'fiscalPositionData', getValidation: fiscalPosNeeded },
                        { path: 'fiscalPositionData', getValidation: isOpenAndNeedContractType, alias: 'fiscalPositionData2' },
                        { path: 'companiesRecord' },
                        { path: 'accounts' },
                        { path: 'enroleDate' },
                        { path: 'dismissDate' },
                        { path: 'sdr' },
                        { path: 'sd', getValidation: isOpenAndNeedContractType },
                        { path: 'sbc', getValidation: isOpenAndNeedContractType },
                        { path: 'nss', getValidation: isOpenAndNeedContractType },
                        { path: 'departmentName', getValidation: angular.isDefined(thisEmployee.department) }
                    ];
                    return processFields(fields, thisEmployee, cleanedObjs, opObjs, operationType);
                }).then(function () {
                    if (isOpen) {
                        if (angular.isUndefined(thisEmployee.place)) {
                            throw 'La plaza del centro de costo ' + thisEmployee.ccData.data.name + ' no fue encontrada';
                        } else if (angular.isUndefined(thisEmployee.geoZone)) {
                            throw 'No se encontró la geoZona del empleado';
                        }
                    }
                    console.log(ListsF)
                    resolve(thisEmployee);
                }).catch(reject);
            });
        }
        function getAndSetEmployeeDataFn(employeeId, movements, payrollId, calendarId, operationType, opObjs, cleanedObjs, flags) {
            return $q(function (resolve, reject) {
                try {
                    var operationEmployee = $filter('getFromObject')(opObjs.operation.fb, 'employees.' + employeeId, {});
                    var period = cleanedObjs.period;
                    var ccs = cleanedObjs.ccs;
                    var employee = opObjs.employees.fb[employeeId];
                    var tempId = employee.$id;
                    if (!angular.isObject(employee) || employee === null) {
                        throw 'No se encontraron los datos del empleado con id ' + employeeId;
                    }
                    if (['ptuDistributionRecord', 'ptuRecord'].indexOf(operationType) > -1) {
                        employee.movements = movements;
                    }
                    if (angular.isUndefined(employee.movements)) {
                        throw ('Empleado con ID:' + employeeId + ' no existe o no tiene movimientos');
                    }
                    var thisEmployee = $filter('clearObject')(employee);
                    thisEmployee.$id = tempId;
                    var employeeDispData = $filter('getFromObject')(opObjs.dispersion, 'fb.employees.' + thisEmployee.$id, {});
                    var checkAndLoadData = flags.employeeIsClosed || flags.forceCheckAndLoadData ? true : false;
                    var thisPeriod = {
                        start: period.start,
                        end: period.end
                    };
                    if (operationType === 'chrisBonusRecord') {
                        var accuDate = moment($filter('getFromObject')(opObjs.operation.fb, 'accuDate'));
                        thisPeriod = {
                            start: accuDate.startOf('year').valueOf(),
                            end: accuDate.endOf('year').valueOf()
                        }
                    } else if (operationType === 'ptuDistributionRecord') {
                        var accuDate2 = moment($filter('getFromObject')(opObjs.operation.fb, 'specialDate'));
                        thisPeriod = {
                            start: accuDate2.subtract(1, 'year').startOf('year').valueOf(),
                            end: accuDate2.endOf('year').valueOf()
                        }
                    }
                    if ((!flags.employeeIsClosed) && (!flags.forceCheckAndLoadData)) {
                        var movementFiltered = $filter('filterMovementsOperation')(thisEmployee, thisPeriod, movements, payrollId);
                        thisEmployee.movements = movementFiltered.movements;
                        thisEmployee.dismissEmployee = angular.isDefined(flags.dismissEmployee) ? flags.dismissEmployee : movementFiltered.dismissEmployee;
                        if (thisEmployee.movements.length > 0) {
                            checkAndLoadData = true;
                        }
                    }
                    if (!checkAndLoadData) {
                        $log.info(employee.data.name + ' con ID:' + employeeId + ' no es valido para esta operación', movements);
                        throw undefined;
                    }
                    //Si antes de ejecutar la consulta de datos externos hay que cambiar algún dato en el empleado se llama esta acción para actualizar el empleado según los datos guardados, este se ejecuta en todas las operaciones
                    if (angular.isDefined(employeeFromMovAction[operationType])) {
                        employeeFromMovAction[operationType](thisEmployee, flags.employeeIsClosed, opObjs.operation.fb, $filter('getFromObject')(opObjs.dispersion, 'fb.employees.' + thisEmployee.$id), operationEmployee);
                    }
                    var valid = flags.forceValid ? true : false;
                    if (!valid) {
                        valid = $filter('isForThisOperation')(thisEmployee, operationEmployee, flags.employeeIsClosed, ccs);
                    }
                    var promises = [];
                    thisEmployee = Object.assign(thisEmployee, employeeDispData);
                    if (angular.isArray(movements) && movements.length > 0) {
                        var thisMovement = movements.shift();
                        if (angular.isObject(thisMovement)) {
                            if (thisMovement.cc) {
                                thisEmployee.cc = thisMovement.cc;
                            }
                            if (thisMovement.payroll) {
                                thisEmployee.payroll = thisMovement.payroll;
                            }
                            if (thisMovement.rp) {
                                thisEmployee.rp = thisMovement.rp;
                            }
                        }
                    }
                    if (valid || operationType === 'ptuDistributionRecord') {
                        thisEmployee.movements = flags.employeeIsClosed || flags.forceOperationEmployee ? [operationEmployee] : thisEmployee.movements;
                        promises.push(getExternalData(thisEmployee, employee, flags.employeeIsClosed, opObjs, cleanedObjs, operationType, flags));
                    }
                    Promise.all(promises).then(function () {
                        thisEmployee.payroll
                        thisEmployee.operationType = operationType;
                        thisEmployee.forOperation = valid;
                        thisEmployee.calendar = calendarId;
                        thisEmployee.periodData = period;
                        thisEmployee.isClosed = flags.employeeIsClosed;
                        thisEmployee.payrollData = cleanedObjs.payroll;
                        thisEmployee.paymentFrequencyData = cleanedObjs.paymentFrequency;
                        thisEmployee.nfdRecordsData = cleanedObjs.nfdRecords;
                        thisEmployee.imssRecordData = cleanedObjs.imssRecordData;
                        thisEmployee.minimumWageRecords = cleanedObjs.minimumWageRecords;
                        // console.log(thisEmployee.minimumWageOfEmployee)
                        if (operationType === 'ptuDistributionRecord') {
                            var oldPtu = $filter('getFromObject')(opObjs.oldPtuEmployees, 'fb.' + employeeId, [])
                            thisEmployee.oldPtu = oldPtu;
                        }
                        var incidencesChecked = $filter('getFromObject')(opObjs.incidencesChecked, 'fb.' + thisEmployee.$id, [])
                        if (incidencesChecked.length > 0) {
                            thisEmployee.incidencesChecked = incidencesChecked.map(function (item) {
                                var name = $filter('getFromObject')(opObjs.conceptsById, 'fb.' + item.incidenceType + '.name', 'S/N')
                                return {
                                    d: $filter('date')(item.date),
                                    dt: item.date,
                                    it: name,
                                    v: item.value
                                }
                            })
                        }
                        thisEmployee.minimumWageRecords.umaRecord = $filter('getFromObject')(thisEmployee.customField, 'umaValue', thisEmployee.minimumWageRecords.umaRecord);
                        //Se establece la información actual de la operación
                        var operationData = $filter('clearObject')(opObjs.operation.fb);
                        delete operationData.employees;
                        thisEmployee.operationData = operationData;
                        thisEmployee.lastPeriodData = $filter('clearObject')($filter('getFromObject')(opObjs.lastPeriodData, 'fb'));
                        //Se establecen los últimos calculo de la operación
                        thisEmployee.lastPeriodCalculation = $filter('getFromObject')(opObjs.lastDispersion, 'fb.employeesData.calculations.' + thisEmployee.$id);
                        // $log.log(thisEmployee);
                        resolve(thisEmployee);
                    }).catch(reject);
                } catch (error) {
                    reject(error);
                }
            });

        }
        return getAndSetEmployeeDataFn;
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getAffectDaysIncidencesN', getAffectDaysIncidencesN)

    function getAffectDaysIncidencesN($log) {

        return getAffectDaysIncidencesNFn;

        function getAffectDaysIncidencesNFn(incidences, conceptsById) {
            var incidencesAffect = [];
            if (angular.isArray(incidences)) {
                for (var i = 0; i < incidences.length; i++) {
                    var thisIncidence = angular.fromJson(angular.toJson(incidences[i]));
                    var thisConcept = conceptsById[thisIncidence.incidenceType];
                    if (angular.isDefined(thisConcept) && thisConcept.validateDays) {
                        var obj = {
                            'value': thisIncidence.value,
                            'it': thisIncidence.incidenceType,
                            'itName': thisConcept.name
                        }
                        if (angular.isDefined(thisIncidence.date)) {
                            obj.date = thisIncidence.date;
                        }
                        incidencesAffect.push(obj);
                    }
                }
            }
            return incidencesAffect;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('formatIncidencesForModal', formatIncidencesForModal);

    function formatIncidencesForModal(getSomethingOfArrayFBFilter, incidenceTypeNameFilter, filterFilter, orderByFilter, translateFilter) {

        return formatIncidencesForModalFn;

        function formatIncidencesForModalFn(incidences, incidencesTypes, search) {
            var newIncidences = [];
            if (angular.isArray(incidences)) {
                for (var i = 0; i < incidences.length; i++) {
                    var thisIncidence = angular.fromJson(angular.toJson(incidences[i]));
                    // { { incidence.incidenceType | getSomethingOfArrayFB: incidencesTypes: "name": "N/A": "$id" } }
                    // { { incidence.type | incidenceTypeName } }
                    // 'c.'+(incidence.incidenceType | getSomethingOfArrayFB:incidencesTypes:"nature":"N/A":"$id") | translate
                    thisIncidence.incidenceName = getSomethingOfArrayFBFilter(thisIncidence.incidenceType, incidencesTypes, 'name', 'N/A');
                    thisIncidence.typeName = incidenceTypeNameFilter(thisIncidence.type);
                    thisIncidence.natureName = translateFilter('c.' + getSomethingOfArrayFBFilter(thisIncidence.incidenceType, incidencesTypes, 'nature', 'N/A'));
                    newIncidences.push(thisIncidence);
                }
                newIncidences = orderByFilter(filterFilter(newIncidences, search), 'date');
            }
            return newIncidences;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('filterMovementsOperation', filterMovementsOperation);

    function filterMovementsOperation($filter) {
        return filterMovementsOperationFn;
        function filterMovementsOperationFn(thisEmployee, period, movements, payrollId) {
            //Se valida que el usuario exista preguntando si existe e nodo movimientos de lo contrario es un empleado invalido
            var lastMovementInEmployee = $filter('getLastMovemenBeforeDate')(thisEmployee.movements, period.start, payrollId);
            var lastMovementInMovements = $filter('getLastMovemenBeforeDate')(movements, period.start);
            if (lastMovementInEmployee.length) {
                lastMovementInEmployee = lastMovementInEmployee[0];
            } else {
                lastMovementInEmployee = undefined;
            }
            if (lastMovementInMovements.length) {
                lastMovementInMovements = lastMovementInMovements[0];
            } else {
                lastMovementInMovements = undefined;
            }
            movements = $filter('validateMovements')(lastMovementInMovements, lastMovementInEmployee, thisEmployee, movements, payrollId);
            var activeDays = $filter('activeDaysFromMovements')($filter('orderBy')(movements, 'data.date'), period, []);
            var thisMovements = [];
            var dismissEmployee = false;
            activeDays.sort(function (a, b) {
                return b.start - a.start;
            });
            var addToActiveDays = true;
            angular.forEach(activeDays, function (activeDay) {
                if (activeDay.hasOwnProperty('startMovement') && [6, 8].indexOf(activeDay.startMovement.data.type) > -1) {
                    dismissEmployee = false;
                }
                if (angular.isDefined(activeDay.endMovement) && angular.isDefined(activeDay.endMovement.data)) {
                    if (activeDay.endMovement.data.type === 2 && !activeDay.endMovement.data.paySalaryInPayrol) {
                        addToActiveDays = false;
                    }
                }
                if (addToActiveDays) {
                    var obj, movement;
                    if (activeDay.startMovementId) {
                        obj = $filter('getObjectOfArrayById')(activeDay.startMovementId, thisMovements);
                        if (obj === null) {
                            movement = $filter('getObjectOfArrayById')(activeDay.startMovementId, movements);
                            if (movement !== null) {
                                thisMovements.push(movement);
                            }
                        }
                    }
                    if (activeDay.endMovementId) {
                        obj = $filter('getObjectOfArrayById')(activeDay.endMovementId, thisMovements);
                        if (obj === null) {
                            movement = $filter('getObjectOfArrayById')(activeDay.endMovementId, movements);
                            if (movement !== null) {
                                thisMovements.push(movement);
                            }
                        }
                        dismissEmployee = (activeDay.endMovement.data.type === 2);
                    }
                }
                if (!addToActiveDays && activeDay.hasOwnProperty('startMovement') && [6, 8].indexOf(activeDay.startMovement.data.type) > -1) {
                    addToActiveDays = true;
                }
            });
            return { movements: thisMovements, dismissEmployee: dismissEmployee };
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('filterEmployeesForOperation', filterEmployeesForOperation);

    function filterEmployeesForOperation() {

        return filterEmployeesForOperationFn;

        function filterEmployeesForOperationFn(employees, search) {
            var searchByEmployee = false;
            var searchEmployee, searchByCc;
            if (angular.isDefined(search.employee) && search.cc !== '') {
                searchByEmployee = true;
                searchEmployee = search.employee.toUpperCase();
            }
            if (angular.isDefined(search.cc) && search.cc !== '') {
                searchByCc = true;
            }
            var thisEmployees = [];
            for (var e = 0; e < employees.length; e++) {
                var item = employees[e];
                var flag = true;
                if (searchByEmployee) {
                    flag = false;
                    if (angular.isDefined(item.data) && angular.isDefined(item.data.name)) {
                        flag = item.data.name.indexOf(searchEmployee) > -1;
                    }
                }
                if (flag && searchByCc) {
                    flag = false;
                    if (angular.isObject(item.movements)) {
                        for (var m in item.movements) {
                            if (item.movements[m].cc === search.cc) {
                                flag = true;
                            }
                        }
                    }
                }
                if (flag) {
                    thisEmployees.push(employees[e]);
                }
            }
            return thisEmployees;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('discountDispersionExempts', discountDispersionExempts);

    function discountDispersionExempts() {

        return discountDispersionExemptsFn;

        function discountDispersionExemptsFn(employeeCalculations, process) {
            var total = (process === 'fiscal') ? employeeCalculations.fiscalTotal.value.result : employeeCalculations.socialPrevisionTotal.value.result;
            var dispersionExempt = Object.keys(employeeCalculations).reduce(function (current, item) {
                if (angular.isObject(employeeCalculations[item]) && employeeCalculations[item].hasOwnProperty('dispersionExempt')) {
                    current += (process === 'fiscal') ? employeeCalculations[item].fiscalValue.result : employeeCalculations[item].socialPrevisionValue.result;
                }
                return current;
            }, 0);
            dispersionExempt = Math.round(dispersionExempt * 100) / 100;
            total = Math.round(total * 100) / 100;
            return {
                total: total,
                exempt: dispersionExempt,
                totalNoExempts: total - dispersionExempt
            };
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('convertNumberToString', convertNumberToString);

    function convertNumberToString() {

        return convertNumberToStringFn;

        function convertNumberToStringFn(num, currency) {
            currency = currency || {};
            var data = {
                numero: num,
                enteros: Math.floor(num),
                centavos: (((Math.round(num * 100)) - (Math.floor(num) * 100))),
                letrasCentavos: '',
                letrasMonedaPlural: currency.plural || 'PESOS',//'PESOS', 'Dólares', 'Bolívares', 'etcs'
                letrasMonedaSingular: currency.singular || 'PESO', //'PESO', 'Dólar', 'Bolivar', 'etc'
                letrasMonedaCentavoPlural: currency.centPlural || 'M.N',
                letrasMonedaCentavoSingular: currency.centSingular || 'M.N'
            };

            if (data.centavos > 0) {
                data.letrasCentavos = (function () {
                    if (data.centavos == 1)
                        return data.centavos + '/100 ' + data.letrasMonedaCentavoSingular;
                    else
                        return data.centavos + '/100 ' + data.letrasMonedaCentavoPlural;
                })();
            };

            if (data.enteros == 0)
                return 'CERO ' + data.letrasMonedaPlural + ' ' + data.letrasCentavos;
            if (data.enteros == 1)
                return Billones(data.enteros) + ' ' + data.letrasMonedaSingular + ' ' + data.letrasCentavos;
            else
                return Billones(data.enteros) + ' ' + data.letrasMonedaPlural + ' ' + data.letrasCentavos;
        }
        function Unidades(num) {
            switch (num) {
                case 1: return 'UN';
                case 2: return 'DOS';
                case 3: return 'TRES';
                case 4: return 'CUATRO';
                case 5: return 'CINCO';
                case 6: return 'SEIS';
                case 7: return 'SIETE';
                case 8: return 'OCHO';
                case 9: return 'NUEVE';
            }
            return '';
        }
        function Decenas(num) {
            var decena = Math.floor(num / 10);
            var unidad = num - (decena * 10);
            switch (decena) {
                case 1:
                    switch (unidad) {
                        case 0: return 'DIEZ';
                        case 1: return 'ONCE';
                        case 2: return 'DOCE';
                        case 3: return 'TRECE';
                        case 4: return 'CATORCE';
                        case 5: return 'QUINCE';
                        default: return 'DIECI' + Unidades(unidad);
                    }
                case 2:
                    switch (unidad) {
                        case 0: return 'VEINTE';
                        default: return 'VEINTI' + Unidades(unidad);
                    }
                case 3: return DecenasY('TREINTA', unidad);
                case 4: return DecenasY('CUARENTA', unidad);
                case 5: return DecenasY('CINCUENTA', unidad);
                case 6: return DecenasY('SESENTA', unidad);
                case 7: return DecenasY('SETENTA', unidad);
                case 8: return DecenasY('OCHENTA', unidad);
                case 9: return DecenasY('NOVENTA', unidad);
                case 0: return Unidades(unidad);
            }
        }
        function DecenasY(strSin, numUnidades) {
            if (numUnidades > 0)
                return strSin + ' Y ' + Unidades(numUnidades)

            return strSin;
        }
        function Centenas(num) {
            var centenas = Math.floor(num / 100);
            var decenas = num - (centenas * 100);

            switch (centenas) {
                case 1:
                    if (decenas > 0)
                        return 'CIENTO ' + Decenas(decenas);
                    return 'CIEN';
                case 2: return 'DOSCIENTOS ' + Decenas(decenas);
                case 3: return 'TRESCIENTOS ' + Decenas(decenas);
                case 4: return 'CUATROCIENTOS ' + Decenas(decenas);
                case 5: return 'QUINIENTOS ' + Decenas(decenas);
                case 6: return 'SEISCIENTOS ' + Decenas(decenas);
                case 7: return 'SETECIENTOS ' + Decenas(decenas);
                case 8: return 'OCHOCIENTOS ' + Decenas(decenas);
                case 9: return 'NOVECIENTOS ' + Decenas(decenas);
            }

            return Decenas(decenas);
        }
        function Seccion(num, divisor, strSingular, strPlural) {
            var cientos = Math.floor(num / divisor)
            var resto = num - (cientos * divisor)

            var letras = '';

            if (cientos > 0)
                if (cientos > 1)
                    letras = Centenas(cientos) + ' ' + strPlural;
                else
                    letras = strSingular;

            if (resto > 0)
                letras += '';

            return letras;
        }
        function Miles(num) {
            var divisor = 1000;
            var cientos = Math.floor(num / divisor)
            var resto = num - (cientos * divisor)

            var strMiles = Seccion(num, divisor, 'UN MIL', 'MIL');
            var strCentenas = Centenas(resto);

            if (strMiles == '')
                return strCentenas;

            return strMiles + ' ' + strCentenas;
        }
        function Millones(num) {
            var divisor = 1000000;
            var cientos = Math.floor(num / divisor)
            var resto = num - (cientos * divisor)

            var strMillones = Seccion(num, divisor, 'UN MILLON', 'MILLONES');
            var strMiles = Miles(resto);

            if (strMillones == '')
                return strMiles;

            return strMillones + ' ' + strMiles;
        }
        function Billones(num) {
            var divisor = 1000000000000;
            var cientos = Math.floor(num / divisor);
            var resto = num - (cientos * divisor);

            var strBillones = Seccion(num, divisor, 'UN BILLON', 'BILLONES');
            var strMilMillones = MilMillones(resto);

            if (strBillones === '')
                return strMilMillones;

            return strBillones + ' ' + strMilMillones;
        }
        function MilMillones(num) {
            var divisor = 1000000000;
            var cientos = Math.floor(num / divisor);
            var resto = num - (cientos * divisor);
            var strMilMillones = Seccion(num, divisor, 'UN MIL', 'MIL');
            if (cientos > 0 && resto === 0)
                strMilMillones += ' MILLONES';
            var strMillones = Millones(resto);

            if (strMilMillones === '')
                return strMillones;

            return strMilMillones + ' ' + strMillones;
        }
    }
}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('combineDailyAndAbsencesDays', combineDailyAndAbsencesDays)

    function combineDailyAndAbsencesDays($log) {

        return combineDailyAndAbsencesDaysFn;

        function combineDailyAndAbsencesDaysFn(realDailySalaries, dailyAbsences) {
            var dailySalaries=angular.fromJson(angular.toJson(realDailySalaries));
            for (var d in dailyAbsences) {
                if (dailySalaries[d] === "undefined") {
                    dailySalaries[d] = dailyAbsences[d];
                } else {
                    dailySalaries[d] = Object.assign({}, dailySalaries[d], dailyAbsences[d]);
                }
            }
            return dailySalaries;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('combineArraysOfObject', combineArraysOfObject);

    function combineArraysOfObject(loopEachFilter) {

        return combineArraysOfObjectFn;

        function combineArraysOfObjectFn(obj, ignoreSome) {
            var arreglo = [];
            loopEachFilter(obj, function (esteArreglo, index) {
                if (angular.isArray(esteArreglo) && (!angular.isArray(ignoreSome) || (angular.isArray(ignoreSome) && ignoreSome.indexOf(index) === -1))) {
                    arreglo = arreglo.concat(esteArreglo);
                }
            });
            return arreglo;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('checkAccountAndNumber', checkAccountAndNumber);

    function checkAccountAndNumber($log, loopEachFilter, getEmployeePaymentFormFilter, getFromObjectFilter, MongoF, errAlertS) {
        return checkAccountAndNumberFn;
        function checkAccountAndNumberFn(employees, processType, operationType, calculations) {
            var errors = [];
            var employeesIds = angular.isObject(employees) ? Object.keys(employees) : [];
            if (employeesIds.length > 0) {
                for (var e = 0; e < employeesIds.length; e++) {
                    try {
                        var employeeId = employeesIds[e];
                        var employee = employees[employeeId];
                        for (var p = 0; p < processType.length; p++) {
                            var thisProcessType = processType[p];
                            var employeePaymentForm = getEmployeePaymentFormFilter(employee.paymentForms, thisProcessType.id, operationType);
                            var paymentForm = MongoF.paymentForms.find(function (value) {
                                return value._id === employeePaymentForm
                            });
                            if (angular.isUndefined(paymentForm)) {
                                paymentForm = { key: 'transfer' };
                            }
                            var finalAmount = getFromObjectFilter(calculations[employee.$id], thisProcessType.id + 'Total.value.result', 0);
                            if (paymentForm.key === 'transfer' && finalAmount > 0) {
                                if ((!angular.isArray(employee.accounts)) || employee.accounts.length === 0) {
                                    errors.push('El empleado ' + employee.data.name + ' no tiene cuenta asignada para el proceso ' + thisProcessType.name);
                                } else if ((thisProcessType.id === 'fiscal' && employee.isFiscal) || thisProcessType.id !== 'fiscal') {
                                    var thisAccount = employee.accounts.findIndex(function (item) {
                                        return item.procId === thisProcessType.id;
                                    });
                                    if (thisAccount === -1) {
                                        errors.push('El empleado ' + employee.data.name + ' no tiene cuenta asignada para el proceso ' + thisProcessType.name);
                                    }
                                }
                            }
                            if (angular.isUndefined(getFromObjectFilter(employee, 'data.employeeNumber'))) {
                                errors.push('El empleado ' + employee.data.name + ' no tiene número de empleado asignado');
                            }
                        }
                    } catch (error) {
                        errors.push(error);
                    }
                }
            } else {
                errors.push('No se encontró datos de los empleados')
            }
            var existErrors = errors.length > 0 ? true : false;
            if (existErrors) {
                errAlertS(errors);
            }
            return !existErrors;
        }
    }

}());
(function () {
    'use strict';
    angular
        .module('app.clients')
        .filter('calculateEmployee', calculateEmployee);
    function calculateEmployee($q, $log, $localStorage, pathInObjFilter, loopEachFilter, $filter, errAlertS, AppF) {
        var allBalance = {
            all: false
        };
        var balanceMap = {};
        function isNextToBalance(conceptId, map) {
            var flag = false;
            if (angular.isArray(map)) {
                map = $filter('orderBy')(map, 'order');
                var index = map.findIndex(function (item) {
                    return item.conceptId === conceptId;
                });
                if (index > -1) {
                    if ((index + 1) === map.length) {
                        flag = true;
                    } else {
                        var allTrue = true;
                        for (var i = index + 1; i < map.length; i++) {
                            if (!map[i].balanced) {
                                allTrue = false;
                            }
                        }
                        flag = allTrue;
                    }
                }
            }
            return flag;
        }
        function findConcept(item) {
            return item.$id === this;
        }
        function addFiscalCalc(fields, thisPro, mainField, proceses, concept, conceptsByKey, employee) {
            var fiscalCalcIndex = fields.findIndex(function (item) {
                return item.id === 'fiscalCalc';
            });
            var fiscalCalc;
            if (fiscalCalcIndex === -1) {
                fiscalCalcIndex = fields.findIndex(function (item) {
                    return angular.isDefined(item.process);
                });
                if (fiscalCalcIndex === -1) { fiscalCalcIndex = fields.length; }
                fiscalCalc = {
                    id: 'fiscalCalc',
                    name: 'CALCULO FISCAL',
                    function: 'calc',
                    outputType: mainField.outputType
                };
                fields.splice(fiscalCalcIndex, 0, fiscalCalc);
            } else {
                fiscalCalc = fields[fiscalCalcIndex];
            }
            if (proceses.length > 1 && concept.nature === 'perception') {
                fiscalCalc.validation = 'fiscalIncidences.findIndex(findConcept, concept.$id) > -1 || (processById.fiscal.defaultIncidences && (!angular.isArray(processById.socialPrevision.incidences) || processById.socialPrevision.incidences.findIndex(findConcept, concept.$id)==-1))';
            } else if (proceses.length > 1 && concept.nature === 'deduction') {
                fiscalCalc.validation = 'fiscalIncidences.findIndex(findConcept, concept.$id) > -1 || ($filter("getFromObject")(data.beforeCalculations, "socialPrevisionTotal.value.result", 0) <= 0) && isNextToBalance(concept.$id, balanceMap.socialPrevision, data.employee.$id) || (processById.fiscal.defaultIncidences && (!angular.isArray(processById.socialPrevision.incidences) || processById.socialPrevision.incidences.findIndex(findConcept, concept.$id)==-1))';
            } else {
                fiscalCalc.validation = 'true';
            }
            if ((angular.isUndefined(fiscalCalc.formule) || (proceses.length === 1 && fiscalCalc.formule.indexOf('//doNotOverwrite') === -1))) {
                fiscalCalc.formule = 'data.thisCalculation.value.result';
            }
            fields[fiscalCalcIndex] = fiscalCalc;
            var fiscalValueIndex = fields.findIndex(function (item) {
                return item.id === 'fiscalValue';
            });
            var fiscalValidation = 'angular.isDefined($filter("getFromObject")(data.thisCalculation,"fiscalCalc.result"))';
            var fiscalAccumulator;
            if (fiscalValueIndex === -1 && concept.nature === 'perception') {
                fiscalValueIndex = fiscalCalcIndex + 1;
                fiscalAccumulator = $filter('getFromObject')(conceptsByKey, 'fiscalPerceptions.$id');
                fields.splice(fiscalValueIndex, 0, {
                    'validation': fiscalValidation,
                    'formule': 'data.thisCalculation.fiscalCalc.result',
                    'function': 'calc',
                    'process': thisPro.id,
                    'id': 'fiscalValue',
                    'name': 'TOTAL FISCAL',
                    'outputType': 'currency',
                    'accumulator': fiscalAccumulator
                });
            } else if (fiscalValueIndex === -1 && concept.nature === 'deduction') {
                fiscalValueIndex = fiscalCalcIndex + 1;
                fiscalAccumulator = $filter('getFromObject')(conceptsByKey, 'fiscalDeductions.$id');
                fields.splice(fiscalValueIndex, 0, {
                    'validation': fiscalValidation,
                    'hidden': true,
                    'formule': 'data.employee.startToBalance && $filter("getFromObject")(data.beforeCalculations,"fiscalTotal.value.result",0)<=0 && isNextToBalance(concept.$id,balanceMap.fiscal,data.employee.$id)',
                    'function': 'calc',
                    'process': thisPro.id,
                    'id': 'needToBalanceFiscal',
                    'name': 'BALANCEAR FISCAL',
                    'outputType': 'boolean'
                }, {
                    'validation': fiscalValidation,
                    'formule': 'getTotalBalanced',
                    'function': 'filter',
                    'process': thisPro.id,
                    'id': 'fiscalValue',
                    'name': 'TOTAL FISCAL',
                    'params': [
                        'thisCalculation.needToBalanceFiscal.result',//needToBalanceThis
                        'thisCalculation.fiscalCalc.result',  //calcResult
                        'beforeCalculations.' + concept.key + '.fiscalValue.result',//lastCalcResult
                        'beforeCalculations.fiscalTotal.value.result',//lastProccessTotal
                        'beforeCalculations.socialPrevisionTotal.value.result',//otherLastProccessTotal
                        'employee.$id',
                        'loopTimes'
                    ],
                    'outputType': 'currency',
                    'accumulator': fiscalAccumulator
                }, {
                    'validation': fiscalValidation,
                    'formule': 'data.thisCalculation.fiscalValue.result > data.thisCalculation.valueNoRejected.result ? data.thisCalculation.valueNoRejected.result : data.thisCalculation.fiscalValue.result',
                    'hidden': true,
                    'function': 'calc',
                    'process': thisPro.id,
                    'id': 'fiscalValueNoRejected',
                    'name': 'TOTAL FISCAL NORMAL',
                    'outputType': 'currency'
                }, {
                    'validation': fiscalValidation,
                    'formule': 'data.thisCalculation.fiscalValue.result -data.thisCalculation.fiscalValueNoRejected.result',
                    'hidden': true,
                    'function': 'calc',
                    'process': thisPro.id,
                    'id': 'fiscalValueRejected',
                    'name': 'TOTAL FISCAL DE RECHAZADA',
                    'outputType': 'currency'
                });
            }
            var gravableIndex = fields.findIndex(function (item) {
                return item.id === 'gravable';
            });
            var ignoreGravable = fields.findIndex(function (item) {
                return item.id === 'ignoreGravable';
            });
            if (gravableIndex === -1 && ignoreGravable == -1 && concept.nature === 'perception') {
                var gravableBaseAccumulator = $filter('getFromObject')(conceptsByKey, 'gravableBase.$id');
                var indexForGravable = fields.findIndex(function (item) {
                    return item.id === 'exempt';
                });
                if (indexForGravable === -1) {
                    indexForGravable = fiscalValueIndex;
                    fields.splice(fiscalValueIndex + 1, 0, {
                        'validation': fiscalValidation,
                        'formule': '0',
                        'process': thisPro.id,
                        'function': 'calc',
                        'id': 'exempt',
                        'name': 'PARTE EXENTA',
                        'outputType': 'currency'
                    });
                    indexForGravable++;
                }
                indexForGravable++;
                if (angular.isDefined(gravableBaseAccumulator)) {
                    fields.splice(indexForGravable, 0, {
                        'validation': fiscalValidation,
                        'accumulator': gravableBaseAccumulator,
                        'formule': 'data.thisCalculation.fiscalValue.result - $filter("getFromObject")(data.thisCalculation.exempt, "result", 0) < 0 ? 0 : data.thisCalculation.fiscalValue.result - $filter("getFromObject")(data.thisCalculation.exempt, "result", 0)',
                        'function': 'calc',
                        'process': thisPro.id,
                        'id': 'gravable',
                        'name': 'PARTE GRAVADA',
                        'outputType': 'currency'
                    });
                }
            }
            if (concept.nature === 'perception') {
                var isnBaseAccumulator = $filter('getFromObject')(conceptsByKey, 'isnBase.$id');
                if (angular.isDefined(isnBaseAccumulator)) {
                    var exemptIsnIndex = fields.findIndex(function (item) {
                        return item.id === 'isnExempt';
                    });
                    var gravableIsnIndex = fields.findIndex(function (item) {
                        return item.id === 'isnGravable';
                    });
                    if (exemptIsnIndex === -1) {
                        exemptIsnIndex = gravableIsnIndex === -1 ? fields.length : gravableIsnIndex;
                        fields.splice(exemptIsnIndex, 0, {
                            'validation': fiscalValidation,
                            'formule': 'angular.isArray($filter("getFromObject")(data.employee,"state.exemptIsnConcepts")) && data.employee.state.exemptIsnConcepts.indexOf(concept.$id) > -1 ? data.thisCalculation.fiscalValue.result : 0',
                            'function': 'calc',
                            'process': thisPro.id,
                            'id': 'isnExempt',
                            'name': 'PARTE EXENTA ISN',
                            'outputType': 'currency'
                        });
                    }

                    if (gravableIsnIndex === -1) {
                        exemptIsnIndex++;
                        fields.splice(exemptIsnIndex, 0, {
                            'validation': fiscalValidation,
                            'accumulator': isnBaseAccumulator,
                            'formule': 'data.thisCalculation.fiscalValue.result - $filter("getFromObject")(data.thisCalculation.isnExempt, "result", 0) < 0 ? 0 : data.thisCalculation.fiscalValue.result - $filter("getFromObject")(data.thisCalculation.isnExempt, "result", 0)',
                            'function': 'calc',
                            'process': thisPro.id,
                            'id': 'isnGravable',
                            'name': 'PARTE GRAVADA ISN',
                            'outputType': 'currency'
                        });
                    }
                }
            }



            var indexField = 0;
            for (var f = 0; f < fields.length; f++) {
                if (fields[f].process === thisPro.id) {
                    if (!fields[f].validation) {
                        fields[f].validation = fiscalValidation;
                    }
                    if (!fields[f].hidden) {
                        indexField = f;
                    }
                }

            }
            fields[indexField].ilb = true;
            return fields;
        }
        function addSocialPrevisionCalc(fields, thisPro, mainField, process, concept, conceptsByKey, employee) {
            var socialPrevCalcIndex = fields.findIndex(function (item) {
                return item.id === 'socialPrevisionCalc';
            });
            if (socialPrevCalcIndex === -1 && concept.nature === 'deduction') {
                socialPrevCalcIndex = fields.findIndex(function (item) {
                    return item.process === 'socialPrevision';
                });
                if (socialPrevCalcIndex === -1) {
                    socialPrevCalcIndex = fields.length;
                }
                fields.splice(socialPrevCalcIndex, 0, {
                    'formule': '$filter("getFromObject")(data.thisCalculation.value,"result",0)-$filter("getFromObject")(data.thisCalculation.fiscalValue,"result",0)',
                    'hidden': true,
                    'function': 'calc',
                    'id': 'socialPrevisionCalc',
                    'name': 'CALCULO PREVISION',
                    'outputType': 'currency'
                }, {
                    'formule': 'data.employee.startToBalance && $filter("getFromObject")(data.beforeCalculations,"socialPrevisionTotal.value.result",0)<=0 && isNextToBalance(concept.$id, balanceMap.socialPrevision,data.employee.$id)',
                    'hidden': true,
                    'function': 'calc',
                    'id': 'needToBalanceSocialPrevision',
                    'name': 'BALANCEAR PREVISION',
                    'outputType': 'boolean'
                });
            }
            var socialPrevValueIndex = fields.findIndex(function (item) {
                return item.id === 'socialPrevisionValue';
            });
            var socialPrevAccumulator;
            if (socialPrevValueIndex === -1 && concept.nature === 'perception') {
                socialPrevValueIndex = socialPrevCalcIndex > -1 ? socialPrevCalcIndex + 2 : fields.length;
                socialPrevAccumulator = $filter('getFromObject')(conceptsByKey, 'socialPrevisionPerceptions.$id');
                fields.splice(socialPrevValueIndex, 0, {
                    'formule': '$filter("getFromObject")(data.thisCalculation,"value.result",0)-$filter("getFromObject")(data.thisCalculation,"fiscalValue.result",0)',
                    'function': 'calc',
                    'id': 'socialPrevisionValue',
                    'name': 'TOTAL COMPLEMENTO',
                    'outputType': 'currency',
                    'accumulator': socialPrevAccumulator
                });
            } else if (socialPrevValueIndex === -1 && concept.nature === 'deduction') {
                socialPrevValueIndex = socialPrevCalcIndex > -1 ? socialPrevCalcIndex + 2 : fields.length;
                socialPrevAccumulator = $filter('getFromObject')(conceptsByKey, 'socialPrevisionDeductions.$id');
                fields.splice(socialPrevValueIndex, 0, {
                    'formule': 'getTotalBalanced',
                    'function': 'filter',
                    'id': 'socialPrevisionValue',
                    'name': 'TOTAL COMPLEMENTO',
                    'params': [
                        'thisCalculation.needToBalanceSocialPrevision.result',//needToBalanceThis
                        'thisCalculation.socialPrevisionCalc.result',  //calcResult
                        'beforeCalculations.' + concept.key + '.socialPrevisionValue.result',//lastCalcResult
                        'beforeCalculations.socialPrevisionTotal.value.result',//lastProccessTotal
                        'undefined',
                        'employee.$id'
                    ],
                    'outputType': 'currency',
                    'accumulator': socialPrevAccumulator
                }, {
                    'formule': '$filter("getFromObject")(data.thisCalculation,"valueNoRejected.result",0)-$filter("getFromObject")(data.thisCalculation,"fiscalValueNoRejected.result",0)',
                    'hidden': true,
                    'function': 'calc',
                    'id': 'socialPrevisionValueNoRejected',
                    'name': 'TOTAL COMPLEMENTO NORMAL',
                    'outputType': 'currency'
                }, {
                    'formule': 'data.thisCalculation.socialPrevisionValue.result-data.thisCalculation.socialPrevisionValueNoRejected.result',
                    'hidden': true,
                    'function': 'calc',
                    'id': 'socialPrevisionValueRejected',
                    'name': 'TOTAL COMPLEMENTO RECHAZADA',
                    'outputType': 'currency'
                });
            }
            var socialPrevisionValidation = '$filter("getFromObject")(data.thisCalculation.socialPrevisionValue,"result",0) !== 0';
            for (var f = 0; f < fields.length; f++) {
                if (fields[f].process === thisPro.id && !fields[f].hasOwnProperty('validation')) {
                    fields[f].validation = socialPrevisionValidation;
                }
            }
            return fields;

        }
        function addOtherFields(fields, outputType, calcType, isFiscalValid, concept, fiscalIncidences, conceptsById, conceptsByKey, proceses, employee) {
            var otherFields = [];
            if (calcType === 'incidenceType') {
                if (concept.allowManual && concept.validateDays) {
                    otherFields.push({
                        'formule': '($filter("getFromObject")(data.calculations.workedDays,"availableDays.result",0)+data.thisCalculation.fastIncidences.result<0)?0:($filter("getFromObject")(data.calculations.workedDays,"availableDays.result",0)+data.thisCalculation.fastIncidences.result)',
                        'function': 'calc',
                        'hidden': true,
                        'id': 'availableFast',
                        'name': 'INCIDENCIAS RÁPIDAS DISPONIBLES',
                        'outputType': outputType ? outputType : 'currency'
                    });
                }
                otherFields.push({
                    'hidden': true,
                    'function': 'calc',
                    'id': 'valueNormal',
                    'name': 'TOTAL NORMALES'
                }, {
                    'hidden': true,
                    'formule': concept.allowManual ? 'data.thisCalculation.totalIncidences.result-data.thisCalculation.fastIncidences.result' : 'data.thisCalculation.totalIncidences.result',
                    'function': 'calc',
                    'id': 'normalIncidences',
                    'name': 'INCIDENCIAS NORMALES',
                    'outputType': outputType ? outputType : 'currency'
                }, {
                    'formule': 'calculateTotal',
                    'function': 'filter',
                    'id': 'totalIncidences',
                    'name': 'TOTAL DE INCIDENCIAS',
                    'outputType': outputType ? outputType : 'currency',
                    'params': [
                        'incidences',
                        'undefined'
                    ]
                });
                if (concept.allowManual) {
                    otherFields.push({
                        'formule': 'calculateTotal',
                        'function': 'filter',
                        'id': 'fastIncidences',
                        'name': 'INCIDENCIAS RÁPIDAS',
                        'outputType': outputType ? outputType : 'currency',
                        'params': [
                            'incidences',
                            '#text:fast'
                        ]
                    });
                }
                if (concept.nature === 'deduction') {
                    otherFields.push({
                        'formule': 'calculateTotal',
                        'function': 'filter',
                        'id': 'rejectedIncidences',
                        'name': 'INCIDENCIAS RECHAZADAS',
                        'outputType': outputType ? outputType : 'currency',
                        'params': [
                            'rejectedIncidences',
                            'undefined'
                        ]
                    }, {
                        'formule': '(data.thisCalculation.value.result - data.thisCalculation.rejectedIncidences.result) < 0 ? 0 : (data.thisCalculation.value.result - data.thisCalculation.rejectedIncidences.result)',
                        'function': 'calc',
                        'hidden': true,
                        'id': 'valueNoRejected',
                        'name': 'TOTAL DEL PERIODO',
                        'outputType': 'currency'
                    });
                }
            } else if (calcType === 'accumulator') {
                if (concept.nature === 'deduction') {
                    otherFields.push({
                        'formule': 'calculateTotal',
                        'function': 'filter',
                        'id': 'rejectedIncidences',
                        'name': 'INCIDENCIAS RECHAZADAS',
                        'outputType': outputType ? outputType : 'currency',
                        'params': [
                            'rejectedIncidences',
                            'undefined'
                        ]
                    }, {
                        'formule': '(data.thisCalculation.value.result - data.thisCalculation.rejectedIncidences.result) < 0 ? 0 : (data.thisCalculation.value.result - data.thisCalculation.rejectedIncidences.result)',
                        'function': 'calc',
                        'hidden': true,
                        'id': 'valueNoRejected',
                        'name': 'TOTAL DEL PERIODO',
                        'outputType': 'currency'
                    });
                }
                otherFields.push({
                    'formule': 'getTotalOfObject',
                    'function': 'filter',
                    'id': 'value',
                    'name': 'TOTAL',
                    'outputType': outputType ? outputType : 'currency',
                    'params': [
                        'thisCalculation.data'
                    ]
                });
            } else {
                if (concept.nature === 'deduction') {
                    otherFields.push({
                        'formule': 'calculateTotal',
                        'function': 'filter',
                        'id': 'rejectedIncidences',
                        'name': 'INCIDENCIAS RECHAZADAS',
                        'outputType': outputType ? outputType : 'currency',
                        'params': [
                            'rejectedIncidences',
                            'undefined'
                        ]
                    });
                }
            }
            if (angular.isUndefined(fields)) {
                fields = [];
            }
            var mainField = fields.find(function (item) {
                return item.id === 'value';
            });
            for (var o = 0; o < otherFields.length; o++) {
                var thisField = otherFields[o];
                var index = fields.findIndex(function (item) {
                    return thisField.id === item.id;
                });
                if (index === -1) {
                    if (thisField.id === 'valueNormal') {
                        var mainFormula = mainField.formule.replace('data.thisCalculation.totalIncidences.result', 'data.thisCalculation.normalIncidences.result');
                        var mainOutputType = mainField.outputType;
                        thisField.formule = mainFormula;
                        thisField.outputType = mainOutputType;
                        fields.splice(fields.length - 1, 0, thisField);
                    } else if (thisField.id === 'valueNoRejected') {
                        var indexValue = fields.findIndex(function (item) {
                            return item.id === 'value';
                        });
                        fields.splice(indexValue + 1, 0, thisField);
                        // fields.push(angular.fromJson(angular.toJson(thisField)));
                    } else {
                        fields.unshift(angular.fromJson(angular.toJson(thisField)));
                    }
                }
            }
            if (calcType === 'incidenceType') {//los tipos de incidencias deben repartirse en los procesos que se calculan
                if (mainField.formule.indexOf('+data.thisCalculation.rejectedIncidences.result') === -1 && concept.nature === 'deduction') {
                    mainField.formule = '(' + mainField.formule + ')+data.thisCalculation.rejectedIncidences.result';
                }
                var isDorP = false;
                if (angular.isObject(mainField) && angular.isObject(conceptsById[mainField.accumulator]) && angular.isDefined(conceptsById[mainField.accumulator].key)) {
                    isDorP = (conceptsById[mainField.accumulator].key.indexOf('perceptions') > -1 || conceptsById[mainField.accumulator].key.indexOf('deductions') > -1);
                }
                var processesValue = [];
                if (isDorP && angular.isArray(proceses)) {
                    for (var p = 0; p < proceses.length; p++) {
                        var thisPro = proceses[p];
                        if ((thisPro.id === 'fiscal' && isFiscalValid) || thisPro.id !== 'fiscal') {
                            switch (thisPro.id) {
                                case 'fiscal':
                                    fields = addFiscalCalc(fields, thisPro, mainField, proceses, concept, conceptsByKey, employee);
                                    break;
                                case 'socialPrevision':
                                    fields = addSocialPrevisionCalc(fields, thisPro, mainField, proceses, concept, conceptsByKey, employee);
                                    break;
                            }
                            processesValue.push(thisPro.id);
                        }
                    }
                }
                var rejectedFieldIndex = fields.findIndex(function (item) {
                    return item.id === 'rejectedAmount';
                });
                if (concept.nature === 'deduction' && rejectedFieldIndex === -1 && isDorP && angular.isArray(proceses) && proceses.length > 0) {
                    var processesValueText = '';
                    if (angular.isArray(processesValue) && processesValue.length > 0) {
                        for (var c = 0; c < processesValue.length; c++) {
                            processesValueText = processesValueText + '-$filter("getFromObject")(data.thisCalculation,"' + processesValue[c] + 'Value.result",0)';
                        }
                    }
                    fields.push({
                        'formule': '$filter("getFromObject")(data.thisCalculation,"value.result",0)' + processesValueText,
                        'function': 'calc',
                        'id': 'rejectedAmount',
                        'name': 'MONTO RECHAZADO',
                        'outputType': 'currency'
                    });
                }
                fields = fields.filter(function (item) {
                    return !item.process || processesValue.indexOf(item.process) > -1;
                });
            }
            return fields;
        }
        function getThisFieldResult(field, data) {
            var result;
            if (field == 'null') {
                result = null;
            } else if (field === 'undefined') {
                result = undefined;
            } else if (field.indexOf('#text:') > -1) {
                result = field.replace('#text:', '');
            } else if (field.indexOf('#number:') > -1) {
                var number = field.replace('#number:', '');
                number = isNaN(parseFloat(number)) ? 0 : parseFloat(number);
                result = number;
            } else {
                result = $filter('getFromObject')(data, field);
            }
            return result;
        }
        function getFields(fieldString) {
            var thiFields = [];
            if (angular.isString(fieldString)) {
                var stringArray = fieldString.split(',');
                for (var s = 0; s < stringArray.length; s++) {
                    var thisField = stringArray[s].split(':');
                    if (thisField.length >= 2) {
                        var obj = {
                            n: thisField[0],
                            p: thisField[1]
                        };
                        if (thisField.length > 2) {
                            obj.t = thisField[2];
                        }
                        thiFields.push(obj);
                    }
                }
            } else if (angular.isArray(fieldString)) {
                thiFields = fieldString;
            }
            return thiFields;
        }
        function getStringOfFields(thisObject, fields) {
            var text = '';
            if (angular.isObject(thisObject) && thisObject !== null && angular.isArray(fields)) {
                text = [];
                for (var i = 0; i < fields.length; i++) {
                    var thisField = fields[i];
                    var value = $filter('getFromObject')(thisObject, thisField.p);
                    if (angular.isDefined(value)) {
                        switch (thisField.t) {
                            case 'date':
                                value = $filter('date')(value);
                                break;
                        }
                        text.push(thisField.n + ':' + value + '');
                    }
                }
                text = text.join(', ');
            }
            return text;
        }
        function formatField(calcField) {
            switch (calcField.outputType) {
                case 'date':
                    var thisDate = moment(calcField.result);
                    if (thisDate.isValid()) {
                        thisDate = thisDate.format('DD-MM-YYYY');
                    } else {
                        thisDate = 'Fecha no valida';
                    }
                    calcField.formatted = thisDate;
                    break;
                case 'integer':
                    calcField.formatted = $filter('number')(calcField.result, 0);
                    calcField.result = parseInt(calcField.result);
                    break;
                case 'float':
                    var numberOfDigits = 2;
                    if (angular.isDefined(calcField.positions)) {
                        numberOfDigits = calcField.positions;
                    }
                    calcField.formatted = $filter('number')(calcField.result, numberOfDigits);
                    var def = 10000;
                    if (angular.isDefined(calcField.positions) && !isNaN(parseInt(calcField.positions))) {
                        var thisPositions = parseInt(calcField.positions);
                        def = "1";
                        for (var i = 0; i < thisPositions; i++) {
                            def += "0";
                        }
                    } else if (['imssResult', 'value', 'fiscalValue', 'fiscalCalc', 'calc'].indexOf(calcField.id) > -1) {
                        def = 100;
                    }
                    calcField.result = Math.round(parseFloat(calcField.result) * def) / def;
                    break;
                case 'currency':
                    calcField.formatted = $filter('currency')(calcField.result);
                    calcField.result = Math.round(calcField.result * 100) / 100;
                    break;
                case 'string':
                    calcField.formatted = '' + calcField.result;
                    break;
                case 'boolean':
                    calcField.formatted = calcField.result ? true : false;
                    break;
                case 'percent':
                    calcField.formatted = Math.round((calcField.result * 100) * 10000) / 10000 + '%';
                    break;
                case 'array':
                case 'object':
                case 'arrayOfObject':
                    var thisFields = getFields(calcField.fields);
                    if (calcField.outputType === 'object') {
                        calcField.formatted = getStringOfFields(calcField.result, thisFields);
                        delete calcField.fields;
                    } else {
                        calcField.fields = thisFields;
                    }
                    break;
                default:
                    break;
            }
            delete calcField.outputType;
        }
        function executeEachField(data, calcToExec, concept, fiscalIncidences, proceses, processById) {
            for (var f = 0; f < calcToExec.fields.length; f++) {
                var thisField = angular.fromJson(angular.toJson(calcToExec.fields[f]));
                var result;
                var execute = true;
                if (angular.isDefined(thisField.validation) && thisField.validation !== '') {
                    try {
                        execute = eval(thisField.validation);
                    } catch (error) {
                        $log.error('Error al evaluar validación', error);
                        execute = false;
                    }
                }
                if (execute) {
                    try {
                        switch (thisField.function) {
                            case 'calc':
                                result = eval(thisField.formule);
                                break;
                            case 'filter':
                                var arrayResults = [];
                                if (angular.isArray(thisField.params)) {
                                    for (var t = 0; t < thisField.params.length; t++) {
                                        arrayResults.push(getThisFieldResult(thisField.params[t], data));
                                    }
                                }
                                if (arrayResults.length === 0) {
                                    result = $filter(thisField.formule)();
                                }
                                if (arrayResults.length === 1) {
                                    result = $filter(thisField.formule)(arrayResults[0]);
                                }
                                if (arrayResults.length === 2) {
                                    result = $filter(thisField.formule)(arrayResults[0], arrayResults[1]);
                                }
                                if (arrayResults.length === 3) {
                                    result = $filter(thisField.formule)(arrayResults[0], arrayResults[1], arrayResults[2]);
                                }
                                if (arrayResults.length === 4) {
                                    result = $filter(thisField.formule)(arrayResults[0], arrayResults[1], arrayResults[2], arrayResults[3]);
                                }
                                if (arrayResults.length === 5) {
                                    result = $filter(thisField.formule)(arrayResults[0], arrayResults[1], arrayResults[2], arrayResults[3], arrayResults[4]);
                                }
                                if (arrayResults.length === 6) {
                                    result = $filter(thisField.formule)(arrayResults[0], arrayResults[1], arrayResults[2], arrayResults[3], arrayResults[4], arrayResults[5]);
                                }
                                if (arrayResults.length === 7) {
                                    result = $filter(thisField.formule)(arrayResults[0], arrayResults[1], arrayResults[2], arrayResults[3], arrayResults[4], arrayResults[5], arrayResults[6]);
                                }
                                break;
                            case 'field':
                                result = $filter('getFromObject')(data, thisField.formule);
                                break;
                        }
                    } catch (error) {
                        $log.error('Error en ' + concept.name + ' en el campo ' + thisField.name + ' con la formula ' + thisField.formule, error);
                        result = 0;
                        throw 'Error en ' + concept.name + ' en el campo ' + thisField.name + ' con la formula ' + thisField.formule;
                    }
                    data.thisCalculation[calcToExec.fields[f].id] = {
                        result: result,
                        name: thisField.name,
                        outputType: thisField.outputType,
                        positions: thisField.positions
                    };
                    if (thisField.hidden) {
                        data.thisCalculation[calcToExec.fields[f].id].hidden = true;
                    }
                    if (thisField.ilb) {
                        data.thisCalculation[calcToExec.fields[f].id].ilb = true;
                    }
                    if (angular.isDefined(thisField.fields)) {
                        data.thisCalculation[calcToExec.fields[f].id].fields = thisField.fields;
                    }
                    formatField(data.thisCalculation[calcToExec.fields[f].id]);
                    if (angular.isDefined(thisField.accumulator)) {
                        data.thisCalculation[calcToExec.fields[f].id].accumulator = thisField.accumulator;
                    }
                }
            }
            if (concept.type === 'incidenceType' && angular.isUndefined(data.thisCalculation.fiscalValue)) {
                delete fiscalIncidences[concept.$id];
            }
            return data.thisCalculation;
        }
        function getFieldToListenValue(field, data) {
            if (field.indexOf('#filter:') > -1) {
                var filter = field.replace('#filter:', '');
                var paramsIndex = filter.indexOf('#params:');
                var objResults = [];
                if (paramsIndex > -1) {
                    var params = filter.substring(paramsIndex);
                    filter = filter.replace(params, '');
                    params = params.replace('#params:', '');
                    params = params.split(',');
                    for (var p = 0; p < params.length; p++) {
                        objResults.push(getThisFieldResult(params[p], data));
                    }
                }
                var result = '';
                if (objResults.length === 0) {
                    result = $filter(filter)();
                }
                if (objResults.length === 1) {
                    result = $filter(filter)(objResults[0]);
                }
                if (objResults.length === 2) {
                    result = $filter(filter)(objResults[0], objResults[1]);
                }
                if (objResults.length === 3) {
                    result = $filter(filter)(objResults[0], objResults[1], objResults[2]);
                }
                if (objResults.length === 4) {
                    result = $filter(filter)(objResults[0], objResults[1], objResults[2], objResults[3]);
                }
                if (objResults.length === 5) {
                    result = $filter(filter)(objResults[0], objResults[1], objResults[2], objResults[3], objResults[4]);
                }
                if (objResults.length === 6) {
                    result = $filter(filter)(objResults[0], objResults[1], objResults[2], objResults[3], objResults[4], objResults[5]);
                }
                if (objResults.length === 7) {
                    result = $filter(filter)(objResults[0], objResults[1], objResults[2], objResults[3], objResults[4], objResults[5], objResults[6]);
                }
                return angular.toJson(result);
            } else {
                return angular.toJson($filter('getFromObject')(data, field));
            }
        }
        function executeCalculation(employee, calculations, oldCalculations, calcToExec, dataUsedToCalc, concept, conceptsById, conceptsByKey, isFiscalValid, fiscalIncidences, isFirst, proceses, processById, loopTimes) {
            var data = {
                employee: employee,
                calculations: calculations,
                beforeCalculations: isFirst ? {} : oldCalculations,
                conceptsById: conceptsById,
                concept: concept,
                loopTimes: loopTimes,
                thisCalculation: {
                    name: concept.name,
                    conceptId: concept.$id
                }
            };
            if (concept.hiddenCalc) {
                data.thisCalculation.hc = true;
            }

            var filteredIncidences = $filter('filterIncidencesRejected')(employee.incidencesByType[concept.$id]);
            data.incidences = filteredIncidences.notRejected;
            data.rejectedIncidences = filteredIncidences.rejected;
            if (concept.type === 'incidenceType') {
                if (angular.isArray(calcToExec.fields)) {
                    calcToExec.fields = addOtherFields(calcToExec.fields, concept.inputType, concept.type, isFiscalValid, concept, fiscalIncidences, conceptsById, conceptsByKey, proceses, employee);
                }
            } else if (concept.type === 'accumulator') {
                if (angular.isDefined(calculations[concept.key])) {
                    data.thisCalculation = Object.assign(data.thisCalculation, calculations[concept.key]);
                }
                calcToExec.fields = addOtherFields(calcToExec.fields, concept.inputType, concept.type, isFiscalValid, concept, fiscalIncidences, conceptsById, conceptsByKey, proceses, employee);
            }
            try {
                if (calcToExec.directive) {
                    data.thisCalculation = Object.assign(data.thisCalculation, $filter(calcToExec.directive)(employee));
                } else if (angular.isArray(calcToExec.fields)) {
                    data.thisCalculation = Object.assign(data.thisCalculation, executeEachField(data, calcToExec, concept, fiscalIncidences, proceses, processById));
                } else {
                    throw 'Nothing to calc';
                }
            } catch (error) {
                throw error
            }
            if (angular.isUndefined(dataUsedToCalc)) {
                dataUsedToCalc = {};
            }
            if (angular.isArray(concept.fieldsToListen)) {

                for (var c = 0; c < concept.fieldsToListen.length; c++) {
                    var thisField = concept.fieldsToListen[c];
                    dataUsedToCalc[thisField] = getFieldToListenValue(thisField, data);
                }
            }
            return {
                dataUsedToCalc: dataUsedToCalc,
                calculations: data.thisCalculation
            };
        }
        function filterCalculation(item) {
            var is;
            loopEachFilter(this.condition, function (value, field) {
                if (angular.isUndefined(is)) {
                    is = true;
                }
                if (item[field] !== value) {
                    is = false;
                }
                return;
            });
            return is;
        }
        function getThisCalculation(employee, concept, processes) {
            var calculationToExecute;
            if (angular.isUndefined(AppF.calculationOfEmployee[employee.$id])) {
                AppF.calculationOfEmployee[employee.$id] = {};
            }
            if (angular.isDefined(AppF.calculationOfEmployee[employee.$id][concept.$id])) {
                calculationToExecute = AppF.calculationOfEmployee[employee.$id][concept.$id];
            } else {
                if (angular.isObject(concept) && angular.isArray(concept.calculations)) {
                    var valuesToFind = [
                        { conceptType: 'employeeId', employeeId: employee.$id },
                        { conceptType: 'groupId', groupId: employee.$id },
                        { conceptType: 'ccId', ccId: employee.cc },
                        { conceptType: 'payrollId', payrollId: employee.payroll },
                        { conceptType: 'default' }
                    ];
                    var thisCalculations = $filter('orderBy')([].concat(concept.calculations));
                    for (var i = 0; i < valuesToFind.length; i++) {
                        calculationToExecute = thisCalculations.find(filterCalculation, { condition: valuesToFind[i] });
                        if (angular.isDefined(calculationToExecute)) {
                            i = valuesToFind.length;
                        }
                    }
                    if (angular.isUndefined(calculationToExecute) || calculationToExecute.conceptType === 'default') {
                        var customValidations = [].concat(concept.calculations).filter(function (item) {
                            return item.conceptType === 'custom';
                        });
                        for (var c = 0; c < customValidations.length; c++) {
                            var thisCalc = customValidations[c];
                            if (angular.isArray(thisCalc.validations)) {
                                var valid = true;
                                for (var v = 0; v < thisCalc.validations.length && valid; v++) {
                                    var thisValidation = thisCalc.validations[v];
                                    var getValueOfEmployee = $filter('getFromObject')(employee, thisValidation.condition);
                                    if (thisValidation.value === 'true') {
                                        thisValidation.value = true;
                                    } else if (thisValidation.value === 'false') {
                                        thisValidation.value = false;
                                    } else if (thisValidation.value === 'undefined') {
                                        thisValidation.value = undefined;
                                    } else if (thisValidation.value == 'null') {
                                        thisValidation.value = null;
                                    } else if (angular.isString(thisValidation.value) && thisValidation.value.search('#number:') > -1) {
                                        var thisValue = thisValidation.value.replace('#number:', '');
                                        thisValue = parseFloat(thisValue);
                                        thisValidation.value = isNaN(thisValue) ? 0 : thisValue;
                                    }
                                    switch (thisValidation.operator) {
                                        case 'notEqual':
                                            if (getValueOfEmployee === thisValidation.value) {
                                                valid = false;
                                            }
                                            break;
                                        default:
                                            if (getValueOfEmployee !== thisValidation.value) {
                                                valid = false;
                                            }
                                            break;
                                    }
                                }
                                if (valid) {
                                    c = customValidations.length;
                                    calculationToExecute = thisCalc;
                                }
                            }
                        }
                    }
                    if (angular.isDefined(calculationToExecute)) {
                        AppF.calculationOfEmployee[employee.$id][concept.$id] = calculationToExecute;
                    }
                }
            }
            return angular.fromJson(angular.toJson(calculationToExecute));
        }
        function calculate(employee, currenCalculations, oldCalculations, dataUsedToCalc, concept, conceptsById, conceptsByKey, isFiscalValid, fiscalIncidences, isFirst, processes, processById, loopTimes) {
            var calculationToExecute = getThisCalculation(employee, concept, processes);
            if (angular.isDefined(calculationToExecute) || concept.type === 'accumulator') {
                return executeCalculation(employee, currenCalculations, oldCalculations, calculationToExecute || {}, dataUsedToCalc, concept, conceptsById, conceptsByKey, isFiscalValid, fiscalIncidences, isFirst, processes, processById, loopTimes);
            } else {
                return {
                    dataUsedToCalc: dataUsedToCalc,
                    calculations: {
                        value: { result: 0, type: 'currency', name: concept.name + '[Error]' }
                    }
                };
            }
        }
        function calculationChange(employee, calculation, oldCalculations, dataUsedToCal, concept, conceptsById) {
            var hasChange = false;
            var data = {
                employee: employee,
                calculations: calculation,
                beforeCalculations: oldCalculations,
                conceptsById: conceptsById,
                thisCalculation: angular.isDefined(calculation[concept.key]) ? calculation[concept.key] : {}
            };
            if (angular.isDefined(dataUsedToCal[concept.key])) {
                if (!angular.isArray(concept.fieldsToListen)) {
                    concept.fieldsToListen = [];
                }
                if (concept.type === 'incidenceType') {
                    var fieldsToAdd = [
                        'employee.incidencesByType.' + concept.$id //Cuando es una incidencia, por default se esta escuchando si el objecto donde se guardan todos ha cambiado
                    ];
                    if (concept.validateDays && concept.allowManual) { //Cuando son incidencias que afectan dias, se escucha el calculo de dias trabajados para validar los máximos que se pueden poner en las incidencias rápidas
                        fieldsToAdd.push('calculations.workedDays.availableDays.result');
                    } else if (!concept.validateDays && concept.nature === 'deduction') {//Cuando son incidencias que descuentan y que no validan dias, es decir que pueden balancearse se escucha los totales para que se ejecute el balanceo en caso de ser necesario
                        fieldsToAdd.push('beforeCalculations.fiscalTotal.value.result');
                        fieldsToAdd.push('beforeCalculations.socialPrevisionTotal.value.result');
                        fieldsToAdd.push('employee.startToBalance');
                    }
                    for (var f = 0; f < fieldsToAdd.length; f++) {
                        var field = fieldsToAdd[f];
                        if (concept.fieldsToListen.indexOf(field) === -1) {
                            concept.fieldsToListen.push(field);
                        }
                    }
                }
                if (concept.type === 'accumulator') {
                    var accumulatorField = 'thisCalculation.data';//En los acumuladores se guarda la información en el data, por lo que se escucha los cambios en ese objeto para disparar el calculo
                    if (concept.fieldsToListen.indexOf(accumulatorField) === -1) {
                        concept.fieldsToListen.push(accumulatorField);
                    }
                }
                if (angular.isArray(concept.fieldsToListen)) {//Se añaden los campos a escuchar por default según el tipo de concepto
                    for (var c = 0; c < concept.fieldsToListen.length && !hasChange; c++) {
                        var thisField = concept.fieldsToListen[c];
                        if (dataUsedToCal[concept.key][thisField] !== getFieldToListenValue(thisField, data)) {
                            hasChange = true;
                        }
                    }
                }
            } else {
                hasChange = true;
                dataUsedToCal[concept.key] = {};
            }
            return hasChange;
        }
        function checkCalculations(employee, calculations, dataUsedToCalc, fastIncidences, process, processById, concepts, conceptsByKey, loopTimes, isFirst, startToBalance) {
            try {
                employee.startToBalance = startToBalance;
                loopTimes = angular.isUndefined(loopTimes) ? 1 : loopTimes + 1;
                var dataHasChange = false;
                var thisCalculations = {};
                var proccessConcepts = {};
                var rejectedIncidences = [];
                var conceptsExecuted = {};
                var fiscalProccess = process.find(function (item) {
                    return item.id === 'fiscal';
                });
                var fiscalIncidences = [];
                if (angular.isObject(fiscalProccess) && angular.isArray(fiscalProccess.incidences)) {
                    fiscalIncidences = fiscalProccess.incidences;
                }
                var otherProcess = employee.processes;
                if (employee.processes.length === 1 && employee.processes[0].id === 'fiscal') {
                    var enableSalaryAdjustment = $filter('getFromObject')(employee, 'payrollData.enableSalaryAdjusment', false);
                    var sd = $filter('getFromObject')(employee.data, 'salary.sd');
                    if (angular.isDefined(sd) && !enableSalaryAdjustment) {
                        employee.data.salary.sdr = sd;
                    }
                }
                var proccessCount = 0;//VARIABLE PARA ORDENAR
                for (var p = 0; p < process.length; p++) {
                    if (!process[p].notCalculate && angular.isArray(process[p].concepts)) {
                        var proConcepts = process[p].concepts.sort(function (a, b) {
                            return a.order - b.order;
                        });
                        var doit = true;
                        if (process[p].id === 'fiscal' && !employee.isFiscal) {
                            doit = false;
                        }
                        for (var c = 0; c < proConcepts.length && doit; c++) {
                            var thisC = proConcepts[c];
                            var thisConcept = concepts[thisC.$id];
                            if (thisConcept.type === 'accumulator' && angular.isDefined(calculations) && angular.isDefined(calculations[thisConcept.key]) && angular.isDefined(calculations[thisConcept.key].data)) {
                                if (angular.isUndefined(thisCalculations[thisConcept.key])) {
                                    thisCalculations[thisConcept.key] = {};
                                }
                                if (angular.isUndefined(thisCalculations[thisConcept.key].data)) {
                                    thisCalculations[thisConcept.key].data = {};
                                }
                                thisCalculations[thisConcept.key].data = Object.assign(calculations[thisConcept.key].data, thisCalculations[thisConcept.key].data);
                            }
                            if (!thisC.ignore && (thisConcept.type !== 'incidenceType' || (thisConcept.type === 'incidenceType' && angular.isUndefined(conceptsExecuted[thisConcept.$id]) && angular.isArray(employee.incidencesByType[thisConcept.$id]) && employee.incidencesByType[thisConcept.$id].length > 0))) {
                                conceptsExecuted[thisConcept.$id] = true;
                                if (calculationChange(employee, thisCalculations, calculations, dataUsedToCalc, thisConcept, concepts)) {
                                    dataHasChange = true;
                                    var thisCalc = calculate(employee, thisCalculations, calculations, dataUsedToCalc[thisConcept.key], thisConcept, concepts, conceptsByKey, angular.isObject(fiscalProccess) && employee.isFiscal, fiscalIncidences, isFirst, otherProcess, processById, loopTimes);
                                    thisCalculations[thisConcept.key] = thisCalc.calculations;
                                    dataUsedToCalc[thisConcept.key] = thisCalc.dataUsedToCalc;
                                } else if (angular.isUndefined(thisCalculations[thisConcept.key]) && angular.isDefined(calculations[thisConcept.key])) {
                                    thisCalculations[thisConcept.key] = calculations[thisConcept.key];
                                } else if (angular.isDefined(thisCalculations[thisConcept.key]) && angular.isDefined(calculations[thisConcept.key])) {
                                    thisCalculations[thisConcept.key] = Object.assign(calculations[thisConcept.key], thisCalculations[thisConcept.key]);
                                }
                                thisCalculations[thisConcept.key].order = proccessCount;
                                if (angular.isDefined(thisCalculations[thisConcept.key]) && angular.isDefined(thisCalculations[thisConcept.key].fastIncidences)) {
                                    if (angular.isUndefined(fastIncidences)) {
                                        fastIncidences = {};
                                    }
                                    fastIncidences[thisC.$id] = thisCalculations[thisConcept.key].fastIncidences.result;
                                }
                                $filter('loopEach')(calculations[thisConcept.key], function (result) {
                                    if (angular.isObject(result) && result !== null && angular.isDefined(result.accumulator) && angular.isDefined(concepts[result.accumulator])) {
                                        var keyAccumulator = concepts[result.accumulator].key;
                                        if (angular.isUndefined(thisCalculations[keyAccumulator])) {
                                            thisCalculations[keyAccumulator] = {};
                                        }
                                        if (angular.isUndefined(thisCalculations[keyAccumulator].data)) {
                                            thisCalculations[keyAccumulator].data = {};
                                        }
                                        delete thisCalculations[keyAccumulator].data[thisConcept.key];
                                        if (angular.isDefined(calculations[keyAccumulator]) && angular.isDefined(calculations[keyAccumulator].data) && angular.isDefined(calculations[keyAccumulator].data[thisConcept.key])) {
                                            delete calculations[keyAccumulator].data[thisConcept.key];
                                        }
                                    }
                                });
                                $filter('loopEach')(thisCalculations[thisConcept.key], function (result) {
                                    if (angular.isObject(result) && result !== null && angular.isDefined(result.accumulator) && angular.isDefined(concepts[result.accumulator])) {
                                        var keyAccumulator = concepts[result.accumulator].key;
                                        if (angular.isUndefined(thisCalculations[keyAccumulator])) {
                                            thisCalculations[keyAccumulator] = {};
                                        }
                                        if (angular.isUndefined(thisCalculations[keyAccumulator].data)) {
                                            thisCalculations[keyAccumulator].data = {};
                                        }
                                        thisCalculations[keyAccumulator].data[thisConcept.key] = result.result;
                                    }
                                });
                                var fiscalIncidence = fiscalIncidences.find(function (item) {
                                    return item.$id === thisConcept.$id;
                                });
                                for (var o = 0; o < otherProcess.length; o++) {
                                    if (thisCalculations[thisConcept.key].hasOwnProperty(otherProcess[o].id + 'Value') || (otherProcess[o].id === 'fiscal' && thisConcept.nature === 'deduction' && !thisConcept.validateDays && thisConcept.type !== 'incidenceType')) {
                                        if (angular.isUndefined(proccessConcepts[otherProcess[o].id])) {
                                            proccessConcepts[otherProcess[o].id] = {};
                                        }
                                        var valueField = 'value';
                                        var order = c - 1000;
                                        var isFiscal = true;
                                        if (thisCalculations[thisConcept.key].hasOwnProperty(otherProcess[o].id + 'Value')) {
                                            valueField = otherProcess[o].id + 'Value';
                                            order = $filter('getFromObject')(fiscalIncidence, 'order', 1000);
                                            isFiscal = false;
                                        }
                                        proccessConcepts[otherProcess[o].id][thisConcept.$id] = {
                                            conceptId: thisConcept.$id,
                                            name: thisConcept.name,
                                            conceptKey: thisConcept.key,
                                            nature: thisConcept.nature,
                                            value: thisCalculations[thisConcept.key][valueField].result,
                                            balanced: thisCalculations[thisConcept.key][valueField].result <= 0,
                                            order: order,
                                            isFiscal: isFiscal
                                        };
                                    }
                                }
                                if (thisCalculations[thisConcept.key].hasOwnProperty('rejectedAmount')) {
                                    var rejectedIncidenceAmount = $filter('getFromObject')(thisCalculations[thisConcept.key], 'rejectedAmount.result', 0);
                                    if (rejectedIncidenceAmount > 0 || rejectedIncidenceAmount < 0) {
                                        rejectedIncidences.push({
                                            conceptId: $filter('getFromObject')(thisCalculations[thisConcept.key], 'rejectedAmountConceptId.result', thisConcept.$id),
                                            conceptKey: $filter('getFromObject')(thisCalculations[thisConcept.key], 'rejectedAmountKey.result', thisConcept.key),
                                            name: thisConcept.name,
                                            qty: rejectedIncidenceAmount,
                                            extra: $filter('getFromObject')(thisCalculations[thisConcept.key], 'rejectedExtra.result', {}),
                                            employeeId: employee.$id,
                                            employeeName: employee.data.name
                                        });
                                    }
                                }
                            }
                            proccessCount++;
                        }
                    }
                }
                // $log.log(angular.fromJson(angular.toJson(calculations)));
                $filter('loopEach')(calculations, function (data, conceptKey) {
                    if (angular.isUndefined(thisCalculations[conceptKey])) {
                        $filter('loopEach')(data, function (result) {
                            if (angular.isObject(result) && result !== null && angular.isDefined(result.accumulator) && angular.isDefined(concepts[result.accumulator])) {
                                var keyAccumulator = concepts[result.accumulator].key;
                                if (angular.isDefined(thisCalculations[keyAccumulator]) && angular.isDefined(thisCalculations[keyAccumulator].data)) {
                                    dataHasChange = true;
                                    delete thisCalculations[keyAccumulator].data[conceptKey];
                                }
                            }
                        });
                        if (angular.isDefined(data.fastIncidences) && angular.isDefined(fastIncidences)) {
                            fastIncidences[data.conceptId] = undefined;
                        }
                    }
                });
                var keysToDelete = [];
                $filter('loopEach')(thisCalculations, function (data, conceptKey) {
                    if (!data.hasOwnProperty('value')) {
                        keysToDelete.push(conceptKey);
                    }
                });
                for (var k = 0; k < keysToDelete.length; k++) {
                    delete thisCalculations[keysToDelete[k]];
                }
                $filter('loopEach')(proccessConcepts, function (concepts, process) {
                    $filter('loopEach')(concepts, function (concept, conceptId) {
                        if (angular.isUndefined(balanceMap[process])) {
                            balanceMap[process] = [];
                        }
                        if (concept.nature === 'deduction') {
                            var mapIndex = balanceMap[process].findIndex(function (item) {
                                return item.conceptId === conceptId;
                            });
                            if (mapIndex === -1) {
                                if (process === 'fiscal') {
                                    balanceMap[process].unshift(concept);
                                } else {
                                    balanceMap[process].push(concept);
                                }
                            } else {
                                balanceMap[process][mapIndex] = concept;
                            }
                        }
                    });
                    balanceMap[process] = $filter('orderBy')(balanceMap[process], 'order');
                });
                allBalance.all = true;
                for (var t = 0; t < otherProcess.length; t++) {
                    allBalance[otherProcess[t].id] = true;
                    if (angular.isArray(balanceMap[otherProcess[t].id])) {
                        var data = balanceMap[otherProcess[t].id];
                        for (var d = 0; d < data.length; d++) {
                            if (!data[d].balanced) {
                                allBalance.all = false;
                                allBalance[otherProcess[t].id] = false;
                            }
                        }
                    }
                }
                if (dataHasChange || !startToBalance) {
                    if (!dataHasChange) {
                        startToBalance = true;
                    }
                    if (loopTimes >= 50) {
                        var conc = {};
                        $filter('loopEach')(proccessConcepts, function (concepts, process) {
                            conc[process] = {};
                            $filter('loopEach')(concepts, function (concept, conceptId) {
                                if (!concept.isFiscal) {
                                    conc[process][conceptId] = concept;
                                }
                            });
                        });
                        return { error: true, msg: 'No se pudo completar el calculo del empleado ' + employee.data.name + ' con ID:' + employee.$id, calculations: thisCalculations, dataUsedToCalc: dataUsedToCalc, fastIncidences: fastIncidences, processIncidences: conc, rejectedIncidences: rejectedIncidences };
                    } else {
                        return checkCalculations(employee, thisCalculations, dataUsedToCalc, fastIncidences, process, processById, concepts, conceptsByKey, loopTimes, undefined, startToBalance);
                    }
                } else {
                    var conc = {};
                    $filter('loopEach')(proccessConcepts, function (concepts, process) {
                        conc[process] = {};
                        $filter('loopEach')(concepts, function (concept, conceptId) {
                            if (!concept.isFiscal) {
                                conc[process][conceptId] = concept;
                            }
                        });
                    });
                    return { calculations: thisCalculations, dataUsedToCalc: dataUsedToCalc, fastIncidences: fastIncidences, processIncidences: conc, rejectedIncidences: rejectedIncidences };
                }
            } catch (error) {
                $log.error(error);
                return { error: true, msg: 'No se pudo completar el calculo del empleado ' + employee.data.name + ' con ID:' + employee.$id };
            }
        }
        function calculateEmployeeFn(employee, calculations, dataUsedToCalc, fastIncidencesP, rejectedIncidencesP, processIncidencesP, opObjs) {
            var fastIncidences = angular.fromJson(angular.toJson(fastIncidencesP));
            var rejectedIncidences = angular.fromJson(angular.toJson(rejectedIncidencesP));
            var processIncidences = angular.fromJson(angular.toJson(processIncidencesP));
            var thisCalculation;
            try {
                if (angular.isUndefined(calculations)) {
                    calculations = {};
                    dataUsedToCalc = {};
                }
                var oldEmployeeData = $filter('getFromObject')(AppF.operationData[opObjs.operation.fb.$id], employee.$id);
                if (angular.toJson(employee) !== oldEmployeeData) {
                    $filter('loopEach')(balanceMap, function (data, key) {
                        balanceMap[key] = [];
                    });
                    fastIncidences = {};
                    var processById = {};
                    for (var p = 0; p < opObjs.process.fb.length; p++) {
                        processById[opObjs.process.fb[p].id] = opObjs.process.fb[p];
                    }
                    thisCalculation = checkCalculations(employee, calculations, dataUsedToCalc, fastIncidences, opObjs.process.fb, processById, opObjs.conceptsById.fb, opObjs.conceptsByKey.fb, undefined, true);
                    if (!thisCalculation.error) {
                        $filter('setInObjectPath')('operationData.' + opObjs.operation.fb.$id + '.' + employee.$id, AppF, angular.toJson(employee), true, true);
                    }
                } else {
                    thisCalculation = { calculations: calculations, dataUsedToCalc: dataUsedToCalc, fastIncidences: fastIncidences, processIncidences: processIncidences, rejectedIncidences: rejectedIncidences };
                }
            } catch (error) {
                $log.error(error);
                thisCalculation = { error: true, msg: 'No se pudo completar el calculo del empleado ' + employee.data.name + ' con ID:' + employee.$id };
            }
            return thisCalculation;
        }
        return calculateEmployeeFn;
    }
}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('bankLayoutDateRange', bankLayoutDateRange);

    function bankLayoutDateRange($filter, AppF) {
        return function (bank, periodEnd, serverTime, opts) {
            opts = opts || {};
            var maxDays = angular.isNumber(opts.maxDays) ? opts.maxDays : 15;
            var minDays = angular.isNumber(opts.minDays) ? opts.minDays : 15;
            var maxDate = AppF.holydaysInMexico.getDateOfXLabourDaysFromNow(maxDays, periodEnd).date;
            var bankName = $filter('lowercase')((bank && bank.name) || '');
            var minDate;
            if (bankName === 'hsbc') {
                minDate = moment(serverTime || new Date()).toDate();
            } else {
                minDate = AppF.holydaysInMexico.getDateOfXLabourDaysSinceNow(minDays, periodEnd).date;
            }
            return { minDate: minDate, maxDate: maxDate };
        };
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('askForLoanUpdate', askForLoanUpdate);

    function askForLoanUpdate(AppF, $q, $log, errAlertS, successAlertS, $mdDialog) {
        return askForLoanUpdateFn;
        function confirmLoanUpdate(employeesWithLoans) {
            return new Promise(function (resolve, reject) {
                var content = 'Se detecto que el empleado se encuentra en una nomina diferente de la que se encuentran los prestamos generados, desea actualizar los prestamos?';
                if (employeesWithLoans.length > 1) {
                    content = 'Se detecto que los empleados se encuentra en una nomina diferente de la que se encuentran los prestamos generados, desea actualizar los prestamos?';
                }
                var confirm = $mdDialog.confirm().
                    title('Actualizar información de prestamos')
                    .textContent(content)
                    .ariaLabel('Está Seguro(a)?')
                    .ok('Actualizar')
                    .cancel('No hacer nada, los actualizare manualmente');
                $mdDialog.show(confirm).then(function () {
                    try {
                        var promises = employeesWithLoans.reduce(function (currentP, employee) {
                            var updates = employee.loans.reduce(function (currentU, loan) {
                                currentU[loan.$id + '/payroll'] = employee.payroll;
                                currentU[loan.$id + '/cc'] = employee.cc;
                                currentU[loan.$id + '/rp'] = employee.rp;
                                currentU[loan.$id + '/autoIncUpdate'] = new Date().valueOf();
                                return currentU;
                            }, {});
                            currentP.push(AppF.root.child('catalogs/loans/collection').update(updates));
                            return currentP;
                        }, []);
                        Promise.all(promises).then(function () {
                            resolve(true);
                        }).catch(reject);
                    } catch (error) {
                        reject(error);
                    }
                }).catch(function () {
                    resolve(false);
                });
            });
        }
        function askForLoanUpdateFn(employees) {
            return new Promise(function (resolve) {
                try {
                    if (angular.isArray(employees) && employees.length > 0) {
                        var queries = employees.reduce(function (current, employee) {
                            if (!current.hasOwnProperty(employee.$id)) {
                                current[employee.$id] = AppF.root.child('catalogs/loans/collection').orderByChild('employee').equalTo(employee.$id).once('value');
                            }
                            return current;
                        }, {});
                        $q.all(queries).then(function (resp) {
                            var employeesWithLoans = employees.reduce(function (current, employee) {
                                var snap = resp[employee.$id];
                                var loans = [];
                                snap.forEach(function (childSnap) {
                                    var thisLoan = childSnap.val();
                                    if (thisLoan.payroll !== employee.payroll && thisLoan.valid) {
                                        thisLoan.$id = childSnap.key;
                                        loans.push(thisLoan);
                                    }
                                });
                                if (loans.length > 0) {
                                    employee.loans = loans;
                                    current.push(employee);
                                }
                                return current;
                            }, []);
                            var promises = [];
                            if (employeesWithLoans.length > 0) {
                                promises.push(confirmLoanUpdate(employeesWithLoans));
                            }
                            return Promise.all(promises);
                        }).then(function (resp) {
                            if (resp.length > 0 && resp[0]) {
                                successAlertS('Se actualizo con éxito la información de prestamos del empleado');
                            }
                            resolve(true);
                        }).catch(function (error) {
                            $log.error(error);
                            errAlertS('Error al actualizar los prestamos del empleado, se debe actualizar prestamos manualmente');
                            resolve(true);
                        });
                    } else {
                        resolve(true);
                    }
                } catch (error) {
                    $log.error(error);
                    errAlertS('Error al actualizar los prestamos del empleado, se debe actualizar prestamos manualmente');
                    resolve(true);
                }
            });
        }
    }

}());
(function () {
    'use strict';
    angular
        .module('app.clients')
        .filter('applyCalculationsV2', applyCalculationsV2);

    function applyCalculationsV2($rootScope, $log, $timeout, DataF, AppF, setInObjectPathFilter) {

        function setRowAndHeaders(record, i, obj, head, headerToSet, processHeader, conceptSetted, conceptsByKey) {
            var thisValue = record[head.name];
            if (angular.isFunction(head.from)) {
                thisValue = head.from(record);
            }
            if (angular.isArray(head.fieldToSave) && angular.isDefined(thisValue) && ((!angular.isNumber(thisValue)) || thisValue !== 0)) {
                for (var f = 0; f < head.fieldToSave.length; f++) {
                    setInObjectPathFilter(head.fieldToSave[f], obj, thisValue, true, true);
                    if (processHeader) {
                        var objPathArr = head.fieldToSave[f].split('.');
                        if (objPathArr.length > 1) {
                            var thisConcept = conceptsByKey[objPathArr[0]];
                            if (thisConcept && !conceptSetted[thisConcept.id]) {
                                conceptSetted[thisConcept.id] = true;
                                var thisObjHead = {
                                    id: thisConcept.id,
                                    conceptType: thisConcept.type,
                                    key: thisConcept.key,
                                    name: thisConcept.name,
                                    order: i,
                                    showTotal: true
                                };
                                if (angular.isDefined(thisConcept.nature)) {
                                    thisObjHead.nature = thisConcept.nature;
                                }
                                headerToSet.concepts.push(thisObjHead);
                            }
                        }
                    }
                }
            }
        }

        return applyCalculationsV2Fn;

        function applyCalculationsV2Fn(records, headers, extra, conceptsByKey, headerToSet, id, accuDates) {
            return new Promise(function (resolve, reject) {
                var processHeader = true;
                var processed = [];
                var promises = [];
                var conceptSetted = {};
                var limit = 50;
                if (angular.isUndefined(id)) {
                    id = AppF.root.child('catalogs/importAccuRecords/collection').push().key;
                    var importObj = {
                        payroll: extra.payroll,
                        operationType: extra.operationType ? extra.operationType : 'ordinary',
                        importId: id,
                        companiesRecord: extra.companiesRecord,
                        accuDate: (records.length > 0 && records[0].Fecha) ? records[0].Fecha.format('DD-MM-YYYY') : '',
                        created: DataF.getTimeObject()
                    };
                    limit = 51;
                    processed.push(undefined);
                    promises.push(AppF.root.child('catalogs/importAccuRecords/collection/' + id).set(importObj));
                }
                var obj = {
                    payroll: extra.payroll,
                    operationType: extra.operationType ? extra.operationType : 'ordinary',
                    importId: id,
                    companiesRecords: [{ opType: 'fiscal', companiesRecordId: extra.companiesRecord }],
                    created: DataF.getTimeObject(),
                    fiscalTotal: { imported: true }
                };
                accuDates = accuDates ? accuDates : {};
                for (var r = 0; r < records.length && processed.length < limit; r++) {
                    if (!records[r].applied && records[r].errors.length === 0) {
                        processed.push(r);
                        var record = records[r];
                        var thisObj = angular.fromJson(angular.toJson(obj));
                        accuDates[record.Fecha.valueOf()] = true;
                        for (var i = 0; i < headers.length; i++) {
                            var head = headers[i];
                            if (processHeader && angular.isUndefined(headerToSet)) {
                                headerToSet = {
                                    companiesRecord: extra.companiesRecord,
                                    concepts: [],
                                    importId: id,
                                    id: 'fiscal',
                                    name: 'FISCAL',
                                    operationType: extra.operationType ? extra.operationType : 'ordinary'
                                };
                            }
                            setRowAndHeaders(record, i, thisObj, head, headerToSet, processHeader, conceptSetted, conceptsByKey);
                        }
                        promises.push(DataF.api.addWithUnique('calculations', thisObj, false));
                    }
                }
                if (processed.length === 0) {
                    var updates = {};
                    for (var accuDate in accuDates) {
                        if (accuDates.hasOwnProperty(accuDate)) {
                            var thisHeadersData = angular.fromJson(angular.toJson(headerToSet));
                            thisHeadersData.accuDate = parseInt(accuDate);
                            updates[AppF.root.child('catalogs/dispersion/collection').push().key] = thisHeadersData;
                        }
                    }
                    $log.log(updates);
                    resolve(AppF.root.child('lists/dispersions/companiesRecords/' + extra.companiesRecord).update(updates));
                } else {
                    Promise.all(promises).then(function () {
                        var count = 0;
                        for (var p = 0; p < processed.length; p++) {
                            var index = processed[p];
                            if (index > -1) {
                                count++;
                                records[index].applied = true;
                            }
                        }
                        return AppF.root.child('catalogs/importAccuRecords/collection/' + id + '/count').push(count);
                    }).then(function () {
                        $rootScope.$evalAsync();
                        $timeout(function () {
                            resolve(applyCalculationsV2Fn(records, headers, extra, conceptsByKey, headerToSet, id, accuDates));
                        }, 0, false);
                    }).catch(reject);
                }
            });
        }
    }
}());
/**
 * @description Consulta un dato en cualquier documento de FB 
 * @param {string} route Recibe la ruta completa donde se va hacer la consulta ejemplo 'catalogs/rps/collection/'${key}'/active'
 * @return {promise} Regresa una promesa tipo Boolean
 */
(function () {
    'use strict';
    angular
        .module('app.clients')
        .filter('applyCalculations', applyCalculations);

    function applyCalculations($rootScope, $log, $timeout, DataF, AppF) {

        return applyCalculationsFn;

        function applyCalculationsFn(records, headers, companiesRecord, operationType, conceptsByKey, id, accuDates) {
            return new Promise(function (resolve, reject) {
                id = id ? id : AppF.root.child('catalogs/operations').push().key;
                var processed = [];
                var promises = [];
                operationType = operationType ? operationType : 'ordinary';
                accuDates = accuDates ? accuDates : {};
                for (var r = 0; r < records.length && processed.length < 50; r++) {
                    if (!records[r].applied && records[r].errors.length === 0) {
                        processed.push(r);
                        var record = records[r];
                        var obj = {
                            payroll: records[r].payroll.$id,
                            operationType: operationType,
                            importId: id,
                            employeeId: record.employee.fid,
                            accuDate: record.FechaM.valueOf(),
                            companiesRecords: [{ opType: 'fiscal', companiesRecordId: companiesRecord }],
                            created: DataF.getTimeObject()
                        };
                        if (record.Periodo && !isNaN(parseInt(record.Periodo))) {
                            obj.period = parseInt(record.Periodo);
                        }
                        accuDates[record.FechaM.valueOf()] = true;
                        for (var i = 0; i < headers.length; i++) {
                            var head = headers[i];
                            if (['Empleado', 'Fecha'].indexOf(head.rowName) === -1 && head.hasOwnProperty('key') && head.hasOwnProperty('field')) {
                                if (!obj.hasOwnProperty(head.key)) {
                                    obj[head.key] = {};
                                }
                                var value = parseFloat(record[head.rowName]);
                                if (!isNaN(value) && value !== 0) {
                                    obj[head.key][head.field] = value;
                                }
                            }
                        }
                        if (!obj.hasOwnProperty('fiscalTotal')) {
                            obj.fiscalTotal = { imported: true };
                        }
                        promises.push(DataF.api.addWithUnique('calculations', obj, false));
                    }
                }
                if (processed.length === 0) {
                    var headersData = {
                        companiesRecord: companiesRecord,
                        concepts: [],
                        importId: id,
                        id: 'fiscal',
                        name: 'FISCAL',
                        operationType: operationType
                    };
                    var conceptsMap = {};
                    for (var h = 0; h < headers.length; h++) {
                        var thisHead = headers[h];
                        if (['Empleado', 'Fecha'].indexOf(thisHead.rowName) === -1 && thisHead.hasOwnProperty('key') && thisHead.hasOwnProperty('field')) {
                            if (conceptsByKey.hasOwnProperty(thisHead.key) && !conceptsMap.hasOwnProperty(thisHead.key)) {
                                conceptsMap[thisHead.key] = true;
                                var thisObjHead = {
                                    // default: conceptsByKey[thisHead.key].default,
                                    // active: conceptsByKey[thisHead.key].active,
                                    // hiddenColumn: conceptsByKey[thisHead.key].hiddenColumn,
                                    // inputType: conceptsByKey[thisHead.key].inputType,
                                    // hiddenField: conceptsByKey[thisHead.key].hiddenField,
                                    id: conceptsByKey[thisHead.key].id,
                                    conceptType: conceptsByKey[thisHead.key].type,
                                    key: conceptsByKey[thisHead.key].key,
                                    name: conceptsByKey[thisHead.key].name,
                                    order: h,
                                    showTotal: true
                                };
                                if (angular.isDefined(conceptsByKey[thisHead.key].nature)) {
                                    thisObjHead.nature = conceptsByKey[thisHead.key].nature;
                                }
                                headersData.concepts.push(thisObjHead);
                            }
                        }
                    }
                    var updates = {};
                    for (var accuDate in accuDates) {
                        if (accuDates.hasOwnProperty(accuDate)) {
                            var thisHeadersData = angular.fromJson(angular.toJson(headersData));
                            thisHeadersData.accuDate = parseInt(accuDate);
                            updates[AppF.root.child('catalogs/dispersion/collection').push().key] = thisHeadersData;
                        }
                    }
                    $log.log(updates);
                    resolve(AppF.root.child('lists/dispersions/companiesRecords/' + companiesRecord).update(updates));
                } else {
                    Promise.all(promises).then(function () {
                        for (var p = 0; p < processed.length; p++) {
                            var index = processed[p];
                            var record = records[index];
                            record.applied = true;
                        }
                        $rootScope.$evalAsync();
                        $timeout(function () {
                            resolve(applyCalculationsFn(records, headers, companiesRecord, operationType, conceptsByKey, id, accuDates));
                        }, 0, false);
                    }).catch(reject);
                }
            });
        }
    }
}());
/* eslint-disable angular/window-service */
/* eslint-disable angular/document-service */
(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('BankLayoutService', BankLayoutService);

    function BankLayoutService($rootScope, $http, $filter, $log) {

        // ===============================
        // PRIVATE
        // ===============================

        function downloadArrayBuffer(response, opts) {
            var headers = response.headers();
            var filename = headers['x-filename'] || (opts && opts.filename) || 'layout';
            var contentType = headers['content-type'] || 'application/octet-stream';

            var linkElement = document.createElement('a');
            var blobArray = [];

            if ((opts && opts.addUtf8BomForCsv) &&
                contentType.indexOf('text/csv') > -1 &&
                contentType.indexOf('utf-8') > -1) {
                blobArray.push('\ufeff');
            }

            blobArray.push(response.data);

            var blob = new Blob(blobArray, { type: contentType });
            var url = window.URL.createObjectURL(blob);

            linkElement.setAttribute('href', url);
            linkElement.setAttribute('download', filename);

            linkElement.dispatchEvent(new MouseEvent('click', {
                view: window,
                bubbles: true,
                cancelable: false
            }));
        }


        // ===============================
        // PUBLIC
        // ===============================

        function generate(data, ctx) {
            try {

                var filterName = $filter('convertToCamelCase')(
                    'get_data_for_layouts_' + data.fileRoute
                );

                var filterExists = $filter('getFilterIfExists')(filterName);

                if (!filterExists) {
                    throw 'No existe el archivo de layout del banco seleccionado';
                }

                $rootScope.loadingProgress = true;

                var employees = $filter('orderBy')(ctx.fiscalEmployees || [], ctx.order);

                if (ctx.tabSelected === 'socialPrevision') {
                    employees = $filter('orderBy')(ctx.operationEmployees || [], ctx.order);
                }

                var areAll = false;
                var thisEmployees = data.employeesSelected;

                if (!angular.isArray(thisEmployees) || thisEmployees.length === 0) {
                    thisEmployees = employees;
                    areAll = true;
                }

                var process =
                    (ctx.opProcessList || []).find(function (v) {
                        return v.id === ctx.tabSelected;
                    }) || {};

                var bankName = angular.lowercase(data.fileRoute);

                var params = {
                    processes: ctx.processes,
                    payrollId: ctx.payrollId,
                    banksAccounts: ctx.banksAccounts,
                    banks: ctx.banks,
                    bank: data.bank,
                    bankAccount: data.bankAccount,
                    employees: thisEmployees,
                    areAll: areAll,
                    allEmployeesO: ctx.allEmployeesO,
                    payroll: ctx.payroll,
                    period: ctx.periodOverride || ctx.period,
                    calendar: ctx.calendar,
                    calc: ctx.calc,
                    paymentForms: ctx.paymentForms,
                    processName: process.name,
                    tabSelected: ctx.tabSelected,
                    operationType: ctx.operationType
                };

                $filter('loopEach')(data.extraParams, function (value, index) {
                    params[index] = value;
                });

                $log.debug('[BankLayoutService] filter:', filterName, 'params:', params);


                return $filter(filterName)(params)

                    .then(function (resp) {

                        if (resp && angular.isArray(resp.error) && resp.error.length > 0) {
                            throw resp.error;
                        }

                        if (!resp || angular.isUndefined(resp.success)) {
                            throw 'No existe ningún registro para layout de ' +
                            (data.bank && data.bank.name ? data.bank.name : 'banco');
                        }

                        if (angular.isArray(resp.success) && resp.success.length === 0) {
                            throw 'No existe ningún registro para layout de ' + data.bank.name;
                        }

                        if (angular.isObject(resp.success) &&
                            angular.isDefined(resp.success.body) &&
                            resp.success.body.length === 0) {

                            throw 'No existe ningún registro para layout de ' + data.bank.name;
                        }


                        var objData = {
                            data: angular.toJson(resp.success),
                            bankName: $filter('convertToCamelCase')(bankName)
                        };

                        if (angular.isDefined(resp.filename)) {
                            objData.filename = resp.filename;
                        }


                        return $http({
                            method: 'POST',
                            url: ctx.serviceWorkerUrl + 'interface/pag/layout/dispersion',
                            responseType: 'arraybuffer',
                            data: objData
                        })

                            .then(function (response) {

                                downloadArrayBuffer(
                                    response,
                                    { addUtf8BomForCsv: !!ctx.addUtf8BomForCsv }
                                );

                                $rootScope.loadingProgress = false;

                                $rootScope.$evalAsync(function () {
                                    $log.debug('[BankLayoutService] generate finished');
                                });

                                return true;

                            })

                            .catch(function (err) {

                                try {

                                    var message = new TextDecoder('utf-8').decode(err.data);
                                    var json = angular.fromJson(message);

                                    throw (json && (json.data || json)) || json;

                                } finally {

                                    $rootScope.loadingProgress = false;
                                    $rootScope.$evalAsync();
                                }

                            });

                    })

                    .catch(function (e) {

                        $rootScope.loadingProgress = false;
                        throw e;

                    });

            } catch (e) {

                $rootScope.loadingProgress = false;
                return Promise.reject(e);

            }
        }


        // ===============================
        // EXPORT
        // ===============================

        return {
            generate: generate
        };

    }

}());

(function () {
    'use strict';

    angular
        .module('app.core')
        .service('BankLayoutFlow', BankLayoutFlow);
    function BankLayoutFlow($filter, BankLayoutService, BankDateDialog, $log) {
        var ROUTES_NEED_DATE = {
            banorte: true,
            banorte_spei: true,
            bajio: true,
            hsbc: true,
            hsbc_spei: true,
            banamex: true,
            banamex_spei: true,
            banamex_v2: true,
            banamex_spei_v2: true,
            bancomer232: true,
            bancomer232_spei: true,
            kuspit_spei: true,
            santander: true,
            santander_spei: true,
            santander_v2: true,
            santander_spei_v2: true
        };

        function needsDateAndMaxDays(fileRoute) {
            var route = (fileRoute || '').toLowerCase();
            return { needDate: !!ROUTES_NEED_DATE[route], maxDays: 15 };
        }

        this.run = function (event, bankAccount, employeesSelected, ctx) {
            return Promise.resolve().then(function () {
                if (!bankAccount) {
                    throw new Error('BankLayoutFlow.run: bankAccount es requerido');
                }
                if (!ctx) {
                    throw new Error('BankLayoutFlow.run: ctx es requerido');
                }
                var bank = bankAccount.bankData;
                var data = {
                    event: event,
                    bank: bank,
                    bankAccount: bankAccount,
                    employeesSelected: employeesSelected,
                    extraParams: (ctx && ctx.extraParams) ? ctx.extraParams : undefined
                };
                data.fileRoute = $filter('resolveBankFileRoute')(bankAccount);
                var rule = needsDateAndMaxDays(data.fileRoute);
                var goGenerate = function (finalData) {
                    return BankLayoutService.generate(finalData, ctx);
                };

                if (!rule.needDate) {
                    return goGenerate(data);
                }

                var dateRange = $filter('bankLayoutDateRange')(
                    data.bank,
                    ctx.periodEnd,
                    ctx.serverTime,
                    { minDays: 15, maxDays: rule.maxDays }
                );

                return BankDateDialog.open(data, dateRange, goGenerate);

            }).catch(function (e) {
                $log.error('[BankLayoutFlow] error:', e);
                return Promise.reject(e);
            });
        };
    }
}());

/* eslint-disable angular/document-service */
(function () {
  'use strict';

  angular
    .module('app.clients')
    .service('BankDateDialog', BankDateDialog);

  function BankDateDialog($mdDialog, $log) {

    function getFields(params) {
      var fields =
        params &&
        params.bankAccount &&
        params.bankAccount.bankData &&
        params.bankAccount.bankData.fields;

      return angular.isArray(fields) ? fields : [];
    }
    function getRequiredModalFields(params) {
      var fields = getFields(params);
      return fields.filter(function (f) {
        return f && f.requiredModal === true;
      });
    }

    // function hasRequiredModalFields(params) {
    //   return getRequiredModalFields(params).length > 0;
    // }

    this.open = function (params, dateRange, onConfirm) {
      try {
        if (!params) return Promise.reject(new Error('BankDateDialog.open: params es requerido'));
        if (!dateRange) return Promise.reject(new Error('BankDateDialog.open: dateRange es requerido'));
        if (typeof onConfirm !== 'function') return Promise.reject(new Error('BankDateDialog.open: onConfirm debe ser función'));

        var modalFields = getRequiredModalFields(params);
        $log.log('[BankDateDialog] modalFields found:', modalFields);
        var shouldOpen = modalFields.length > 0;

        $log.debug('[BankDateDialog] modalFields:', modalFields);
        if (!shouldOpen) {
          return Promise.resolve(onConfirm(params));
        }

        return $mdDialog.show({
          templateUrl: 'app/main/clients/views/newoperation/dialogs/date.html',
          locals: {
            minDate: dateRange.minDate,
            maxDate: dateRange.maxDate,
            params: params,
            onConfirm: onConfirm,
            modalFields: modalFields,
            allFields: getFields(params)
          },
          controller: [
            '$scope', 'minDate', 'maxDate', 'params', 'onConfirm', 'modalFields', 'allFields',
            function ($scope, minDate, maxDate, params, onConfirm, modalFields, allFields) {
              $scope.bank = params.bank;
              $scope.minDate = minDate;
              $scope.maxDate = maxDate;
              $scope.modalFields = modalFields;
              $scope.allFields = allFields;
              $scope.model = {};
              $scope.onlyWeekdaysPredicate = function (date) {
                var day = date.getDay();
                return day >= 1 && day <= 5;
              };
              $scope.layoutBanks = function (thisParams) {
                var extraParams = angular.extend({}, thisParams);
                extraParams.modal = angular.copy($scope.model);
                var finalParams = angular.extend({}, params, { extraParams: extraParams });
                return Promise.resolve(onConfirm(finalParams))
                  .finally(function () {
                    $mdDialog.hide();
                  });
              };

              $scope.cancel = function () {
                $mdDialog.hide();
              };
            }
          ],
          parent: angular.element(document.body),
          targetEvent: params.event,
          clickOutsideToClose: true
        });

      } catch (e) {
        $log.error('[BankDateDialog] error:', e);
        return Promise.reject(e);
      }
    };
  }
}());

(function () {
    'use strict';

    angular
        .module('app.clients')
        .factory('confirmOperationS', confirmOperationS);

    /** @ngInject */
    function confirmOperationS($log, operationStatusNameModalFilter, $mdDialog, $document) {
        return function (ev, action, params, $scope, opObjs, operationEmployeesF, operationType) {
            $log.log(params);
            var operationStatus = $scope.nextOperationStatus;
            var msg;
            var statusName = {};
            var moveBack = false;
            if (angular.isDefined(action) && (action === 'moveBackOperation' || action === 'reOpenClosed')) {
                operationStatus = $scope.previousOperationStatus;
                moveBack = true;
                switch (operationStatus) {
                    case 2.5:
                        statusName.name = 'En revisión por ejecutivo';
                        statusName.msg = 'Se eliminara la dispersión y las incidencias generadas por el sistema y se regresará la operación a revisión por el ejecutivo para validación de las incidencias';
                        break;
                    case 2:
                        statusName.name = 'En revisión por cliente';
                        statusName.msg = 'Se regresará la operación a revisión por el cliente para validación de las incidencias';
                        break;
                    case 1:
                        statusName.name = 'Abierta';
                        statusName.msg = 'Se reabrirá la operación para poder capturar las incidencias';
                        break;
                }
            }
            if (action === 'reOpenClosed') {
                msg = 'Reabrir Operación';
            } else if (action === 'moveBackOperation') {
                msg = 'Abrir Operación';
            } else {
                msg = 'Cerrar Operación';
                statusName = operationStatusNameModalFilter(operationStatus);
            }
            $mdDialog.show({
                templateUrl: 'app/main/clients/views/newoperation/dialogs/close-operation.html',
                parent: angular.element($document.body),
                locals: {
                    moveBack: moveBack,
                    statusName: statusName,
                    operation: opObjs.operation.fb,
                    msg: msg,
                    operationType: operationType,
                    operationStatus: operationStatus,
                    params: params,
                    operationEmployeesF: operationEmployeesF,
                    opObjs: opObjs,
                    action: action
                },
                controller: 'ConfirmOperationController',
                controllerAs: 'ConfOpeCtrl',
                targetEvent: ev,
                clickOutsideToClose: false
            });
        };
    }
}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .factory('billOperationS', billOperationS);

    /** @ngInject */
    function billOperationS($log, $mdDialog, errAlertS, successAlertS, $document) {
        function getEmployeesToBill(selected, fiscalEmployees, operation) {
            var employees = fiscalEmployees;
            var all = true;
            if (angular.isArray(selected) && selected.length > 0) {
                employees = selected;
                all = false;
            }
            var pending = [];
            var toReBill = [];
            for (var e = 0; e < employees.length; e++) {
                var thisEmployee = employees[e];
                var status = operation.employees[thisEmployee.$id].status;
                var billId = operation.employees[thisEmployee.$id].billId;
                if (angular.isDefined(billId)) {
                    toReBill.push(thisEmployee);
                } else if (status < 5) {
                    pending.push(thisEmployee);
                }
            }
            var title = pending.length ? 'Timbrar ' : 'Re-timbrar ';
            title += (pending.length ? pending.length : toReBill.length) + ' empleado(s)';
            var msg = '';
            if (pending.length && all && pending.length === employees.length) {
                msg = 'Se realizara el timbrado de los empleados de esta operación ¿Desea continuar?';
            } else if (pending.length && all) {
                msg = 'Se realizara el timbrado de los empleados pendientes por timbrar de esta operación ¿Desea continuar?';
            } else if (pending.length && !all) {
                msg = 'Se realizara el timbrado de los empleados seleccionados que aun no se han timbrado ¿Desea continuar?';
            } else if (!pending.length && all) {
                msg = 'Todos los empleados se encuentran timbrados, si continua se retimbrarán todos los empleados de esta operación ¿Desea continuar?';
            } else {
                msg = 'El(los) empleado(s) seleccionados están timbrados, si continua, se retimbrarán el(los) empleados seleccionados ¿Desea continuar?';
            }
            return {
                msg: msg,
                title: title,
                employees: toReBill,
                pending: pending,
                all: all
            };
        }

        return function (ev, $scope, opObjs) {
            opObjs.operation.fb.$loaded().then(function () {
                var period = $scope.operation.period;
                var calendarYear = $scope.operation.calendar;
                if (!(period && calendarYear)) {
                    throw new Error('No se han encontrado los datos del periodo y año calendario, Contacte al administrador del sistema');
                }
                $log.log('Informacion de la operacion cargada', $scope.operation);
                var data = getEmployeesToBill($scope.selected, $scope.fiscalEmployees, $scope.operation);
                if (data.pending.length === 0 && data.employees.length === 0) {
                    successAlertS('No es necesario timbrar o retimbrar ninguno de los empleados seleccionados');
                } else {
                    $mdDialog.show({
                        templateUrl: 'app/main/clients/views/newoperation/dialogs/bill-employees-confirm.html',
                        parent: angular.element($document.body),
                        controller: function (DataF) {
                            var vm = this;
                            vm.reBill = data.pending.length ? false : true;
                            vm.title = data.title;
                            vm.msg = data.msg;
                            vm.bill = function (updateEmployeeData) {
                                opObjs.operation.fb.$loaded().then(function () {
                                    if ($scope.operation.status === 4) {
                                        successAlertS('Esta operación ya esta en proceso de facturación');
                                        $mdDialog.hide();
                                    } else if (opObjs.operation.fb.status < 3) {
                                        errAlertS('Debe cerrar la nomina antes de realizar el timbrado de los datos')
                                        $mdDialog.hide();
                                    } else {
                                        data = getEmployeesToBill($scope.selected, $scope.fiscalEmployees, $scope.operation);
                                        var updates = {
                                            'billing': true,
                                            'status': 4,
                                            'billingDate': DataF.getCurrentServerTime(),
                                            'updateEmployeeData': updateEmployeeData ? updateEmployeeData : null,
                                            'FromBillOperationS': moment().valueOf()
                                        };
                                        if (!data.pending.length) {
                                            updates.reBill = true;
                                        }
                                        if (!data.all) {
                                            var employees = data.pending.length ? data.pending : data.employees;
                                            updates.thisEmployees = {};
                                            for (var e = 0; e < employees.length; e++) {
                                                updates.thisEmployees[employees[e].$id] = true;
                                            }
                                        }
                                        $log.log(updates);
                                        $scope.F.root.child($scope.refs.operations + '/' + opObjs.operation.fb.$id).update(updates).then(function () {
                                            successAlertS('Se inicio el proceso de facturación');
                                            $mdDialog.hide();
                                        }).catch(errAlertS);
                                    }
                                }).catch(function (error) {
                                    $log.error(error);
                                    $mdDialog.hide();
                                });

                            };
                            vm.cancel = function () {
                                $mdDialog.cancel();
                            };
                        },
                        controllerAs: 'BillEmpConfCtrl',
                        targetEvent: ev,
                        clickOutsideToClose: false
                    });
                }


            }).catch(function (error) {
                errAlertS(error);
            });
        };
    }
}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .controller('specialPayrollsController', specialPayrollsController);

    function specialPayrollsController(
        $scope,
        $rootScope,
        $mdDialog,
        successAlertS,
        errAlertS,
        $log,
        AppF,
        DataF,
        $timeout,
        ListsF,
        specialObject,
        type,
        opeConfig,
        getFromObjectFilter,
        getEmployeesOfPeriodFilter
    ) {
        $scope.type = type;
        if (angular.isDefined(specialObject)) {
            $scope.F.addMode = false;
            $scope.special = specialObject;
            if (angular.isDefined($scope.special.processConfigId)) {
                $scope.special.processConfig = $scope.special.processConfigId;
            }
        } else {
            $scope.special = {};
            $scope.F.addMode = true;
            if (angular.isDefined(AppF.search.$payroll) && AppF.search.$payroll !== 'all' && AppF.search.$payroll !== '') {
                $scope.special.payroll = AppF.search.$payroll;
            }
        }
        $scope.opeConfig = opeConfig;
        $scope.specialPayrolls = {};
        $scope.employees = [];
        $scope.processesConfig = [];
        $scope.processObj = {};
        $scope.payrollIncidences = [];
        function setDates() {
            if (type !== 'asimilated') {
                $scope.minDate = moment(AppF.serverTimeStamp).subtract('2', 'year').startOf('month').toDate();
            }
            $scope.disableDate = false;
            $scope.maxDate = moment(AppF.serverTimeStamp).add('2', 'month').endOf('month').toDate();
            if (type === 'extraordinary' && $scope.special.payroll) {
                var params = {
                    'payroll': $scope.special.payroll,
                    'operationType': 'ordinary',
                    'status': { $gte: 3 },
                    'sort': { calendar: -1, period: -1 }
                };
                $rootScope.D.api.get('one/operations', params).then(function (resp) {
                    var operations = resp.data.data;
                    var promises = [];
                    if (operations.length > 0) {
                        var thisOpe = operations[0];
                        promises.push($scope.F.root.child('catalogs/payrollCalendars/' + thisOpe.payroll + '/periods/' + thisOpe.calendar + '/' + thisOpe.period + '/end').once('value'));
                    }
                    return Promise.all(promises);
                }).then(function (resp) {
                    if (resp.length > 0 && resp[0].exists()) {
                        var thisDate = resp[0].val();
                        if ($scope.minDate.valueOf() < thisDate) {
                            $scope.minDate = moment(thisDate).startOf('day').toDate();
                        }
                    }
                }).catch(errAlertS);
            }
        }
        setDates();
        $scope.setAllEmployees = function () {
            for (var e = 0; e < $scope.employees.length; e++) {
                var data = $scope.employees[e];
                if (!(data.movement.type === 2 && data.status > 1)) {
                    if (!$scope.specialPayrolls.hasOwnProperty(data.fid)) {
                        $scope.specialPayrolls[data.fid] = { name: data.data.name, rp: data.rp, cc: data.cc, status: 0 };
                    }
                    $scope.employees[e].hidden = true;
                }
            }
        };
        var getDates = {
            chrisBonusRecord: function (specialDate) {
                var thisDate = moment(specialDate);
                return {
                    start: thisDate.startOf('year').valueOf(),
                    end: thisDate.endOf('year').valueOf()
                }
            },
            ptuRecord: function (specialDate) {
                var thisDate = moment(specialDate).subtract(1, 'year');
                return {
                    start: thisDate.startOf('year').valueOf(),
                    end: thisDate.endOf('year').valueOf()
                }
            }
        }
        function loadEmployees(payrollId, specialDate, type) {
            return new Promise(function (resolve, reject) {
                if (AppF.operationTypesRelaxed.concat(['extraordinary']).indexOf(type) > -1) {
                    var params = {
                        payroll: payrollId,
                        sort: 'data.name'
                    };
                    $rootScope.D.api.get('p/employees', params).then(function (resp) {
                        resolve(resp.data.data)
                    }).catch(reject);
                } else {
                    var dates = getDates[type](specialDate);
                    var project = { cc: '$lastMov.cc', rp: '$lastMov.rp', status: '$lastMov.status', movement: '$lastMov' }
                    getEmployeesOfPeriodFilter('', payrollId, dates.start, dates.end, project, true).then(function (employees) {
                        resolve(employees.map(function (item) {
                            if (item) {
                                item.data = {
                                    name: item.name
                                }
                                item.fid = item._id;
                            }
                            return item
                        }));
                    }).catch(reject);
                }
            })
        }
        $scope.loadList = function (payrollId, specialDate) {
            return new Promise(function (resolve, reject) {
                setDates();
                $scope.addPeriod(payrollId, $scope.special.specialDate, true).then(function () {
                    var promises = [];
                    if (payrollId && specialDate) {
                        promises.push(loadEmployees(payrollId, specialDate, type))
                    }
                    $scope.payrollIncidences = [];
                    if (type === 'chrisBonusRecord' && payrollId) {
                        var conceptsParams = {
                            'center': AppF.center,
                            'nature': 'deduction',
                            'validateDays': true,
                            'payroll': angular.toJson({ $in: [payrollId, 'global'] }),
                            'project': angular.toJson({ _id: 1, fid: 1, name: 1, key: 1, id_human: 1 }),
                            'type': 'incidenceType'
                        }
                        promises.push($rootScope.D.api.get('p/concepts', conceptsParams))
                    }
                    return Promise.all(promises);
                }).then(function (resp) {
                    var employees;
                    if (payrollId && specialDate) {
                        employees = resp.shift();
                    }
                    if (angular.isArray(employees) && employees.length > 0) {
                        $scope.employees = employees;
                        if (type === 'chrisBonusRecord' && angular.isUndefined(specialObject)) {
                            $scope.setAllEmployees();
                        }
                    }
                    if (resp.length > 0) {
                        $scope.payrollIncidences = resp.shift().data.data;
                    }
                    var promises = [];
                    if ($scope.processesConfig.length === 0) {
                        promises.push($scope.F.root.child('catalogs/processConfigs/collection').orderByChild('type').equalTo(type).once('value'));
                    }
                    return Promise.all(promises);
                }).then(function (resp) {
                    if (resp.length > 0) {
                        resp[0].forEach(function (childSnap) {
                            var pro = childSnap.val();
                            pro.id = childSnap.key;
                            if (pro.center === AppF.center) {
                                $scope.processesConfig.push(pro);
                            }
                        });
                    }
                    if ($scope.processesConfig.length === 0) {
                        throw 'No se encontró proceso de configuración';
                    } else {
                        var defaultP = $scope.processesConfig.find(function (item) {
                            return item.default;
                        });
                        if (angular.isDefined(defaultP) && angular.isUndefined($scope.special.processConfig)) {
                            $scope.special.processConfig = defaultP.id;
                            $scope.setConcepts(defaultP.id)
                        }

                        $rootScope.$evalAsync();
                        $timeout(function () {
                            resolve(true);
                        }, 0, false);
                    }
                }).catch(function (error) {
                    errAlertS(error);
                    $rootScope.$evalAsync();
                    $timeout(function () {
                        reject(error);
                    }, 0, false);
                });
            });

        };
        $scope.cancel = function () {
            $mdDialog.cancel();
        };
        $scope.addEmployee = function (employees, id, employeeData) {
            var index = findIndex(employees, id);
            if (index !== -1) {
                var data = employees[index];
                $scope.employees[index].hidden = true;
                var thisEmployeeData = { name: data.data.name, rp: data.rp, cc: data.cc, status: 0 };
                if (angular.isObject(employeeData) && employeeData !== null) {
                    thisEmployeeData = Object.assign(thisEmployeeData, employeeData)
                }
                $scope.specialPayrolls[data.fid] = thisEmployeeData;
                delete $scope.special.employee;
            }
        };
        $scope.removeEmployee = function (id) {
            var index = findIndex($scope.employees, id);
            if (index !== -1) {
                delete $scope.employees[index].hidden;
            }
            delete $scope.specialPayrolls[id];
        };
        function findIndex(employees, id) {
            var index = employees.findIndex(function (value) {
                return value.fid === id;
            });
            return index;
        }
        function getYear(payrollId, date) {
            return new Promise(function (resolve, reject) {
                if (['travelExpensesOpe', 'extraordinary', 'asimilated', 'special', 'advAndLoanOpe'].indexOf(type) > -1) {
                    $scope.F.root.child('catalogs/payrollCalendars/' + payrollId + '/calendars').orderByChild('data/endDate').startAt(date).limitToFirst(1).once('value').then(function (snap) {
                        if (snap.exists() && Object.keys(snap.val()).length > 0) {
                            resolve(Object.keys(snap.val())[0]);
                        } else {
                            throw 'No se encontró el año del calendario';
                        }
                    }).catch(function (error) {
                        reject(error);
                    });
                } else {
                    resolve(moment(date).format('YYYY'));
                }
            })
        }
        $scope.addPeriod = function (payrollId, date, dontShow) {
            return new Promise(function (resolve, reject) {
                if (angular.isDefined(payrollId) && angular.isDefined(date)) {
                    $scope.loadingPeriod = true;
                    $scope.$evalAsync();
                    var year;
                    getYear(payrollId, date).then(function (respYear) {
                        year = respYear;
                        var params = {
                            'payroll': payrollId,
                            operationType: type
                        };
                        if (['ptuRecord', 'chrisBonusRecord'].indexOf(type) > -1) {
                            params.calendar = 'parseNumber' + year;
                        } else {
                            params.specialDate = 'parseNumber' + date;
                        }
                        return $rootScope.D.api.get('operations', params);
                    }).then(function (resp) {
                        var exists = false;
                        var lastPeriod = 0;
                        var operations = getFromObjectFilter(resp, 'data', []);
                        for (var o = 0; o < operations.length; o++) {
                            if (operations[o].specialPeriod > lastPeriod) {
                                lastPeriod = operations[o].specialPeriod;
                            }
                            if (operations[o].fid !== $scope.special.$id && operations[o].specialDate === date && ['ptuRecord', 'chrisBonusRecord'].indexOf(type) === -1) {
                                exists = true;
                            }
                        }
                        if (exists && ['advAndLoanOpe', 'travelExpensesOpe'].indexOf(type) === -1) {
                            delete $scope.special.specialDate;
                            throw 'Ya hay una operación en esa fecha';
                        }
                        lastPeriod = lastPeriod + 1;
                        if (type === 'chrisBonusRecord' || type === 'ptuRecord') {
                            if (angular.isUndefined($scope.special.specialPeriod)) {
                                $scope.special.specialPeriod = lastPeriod;
                            }
                            var thisDate = moment();
                            if (type === 'ptuRecord') {
                                thisDate.subtract(1, 'y');
                            }
                            $scope.special.start = thisDate.startOf('year').valueOf();
                            $scope.special.end = thisDate.endOf('year').valueOf();
                        } else {
                            $scope.special.specialPeriod = moment(date).dayOfYear();
                        }
                        var ref;
                        ref = ListsF.loadList('payrollCalendars', 'catalogs/payrollCalendars/' + payrollId + '/periods/' + year, undefined, 'array', 'calendarsOf' + payrollId + 'From' + date,
                            [{ 'q': 'orderByChild', 'v': 'end' }, { 'q': 'startAt', 'v': date }, { 'q': 'limitToFirst', v: 1 }]);
                        return ref;
                    }).then(function (period) {
                        if (period.length > 0) {
                            $scope.special.period = parseInt(period[0].period);
                            $scope.special.calendar = parseInt(year);
                            $scope.loadingPeriod = false;
                            $scope.$evalAsync();
                            resolve(true);
                        } else {
                            throw 'No se encontró el calendario de la nómina';
                        }
                    }).catch(function (error) {
                        if (!dontShow) {
                            errAlertS(error);
                        }
                        $rootScope.$evalAsync();
                        $timeout(function () {
                            reject(error);
                            $scope.loadingPeriod = false;
                            $scope.$evalAsync();
                        }, 0, false);
                    });
                } else {
                    resolve(true);
                }
            });
        };
        $scope.setConcepts = function (id, action) {
            var doIt = true;
            var keys = [];
            if (angular.isUndefined($scope.special.incidences)) {
                $scope.special.incidences = {};
            }
            if (angular.isUndefined($scope.processObj[id])) {
                $scope.processObj[id] = [];
            } else {
                doIt = false;
                var incidences = $scope.processObj[id];
                var objIncidences = {};
                for (var i = 0; i < incidences.length; i++) {
                    objIncidences[incidences[i].$id] = true;
                }
                $scope.special.incidences = angular.fromJson(angular.toJson(objIncidences));
            }
            if (doIt) {
                var process = $scope.processesConfig.find(function (value) {
                    return value.id === id;
                });
                if (process) {
                    if (angular.isArray(process.processes)) {
                        var real = process.processes.find(function (value) {
                            return value.id === 'real';
                        });
                        if (real) {
                            var promises = [];
                            for (var key in real.incidences) {
                                promises.push($scope.F.root.child('catalogs/concepts/collection/' + key).once('value'));
                                keys.push(key);
                            }
                            Promise.all(promises).then(function (snap) {
                                if (snap.length > 0) {
                                    for (var i = 0; i < snap.length; i++) {
                                        var data = snap[i].val();
                                        data.$id = keys[i];
                                        $scope.processObj[id].push(data);
                                        if (angular.isUndefined(action) && action !== 'edit') {
                                            if (i === 0) {
                                                $scope.special.incidences = {};
                                            }
                                            $scope.special.incidences[keys[i]] = true;
                                        }
                                    }
                                }
                                $rootScope.$evalAsync();
                            }).catch(function (error) {
                                $log.error(error);
                            })
                        }
                    }
                } else {
                    errAlertS('No se encontró los procesos de configuración');
                }
            }
        }
        $scope.saveSpecialPayrolls = function (data, special) {
            var employees = {
                payroll: special.payroll,
                processConfigId: special.processConfig,
                status: 1,
                employees: angular.fromJson(angular.toJson(data)),
                created: DataF.getTimeObject(),
                specialDate: special.specialDate,
                specialPeriod: special.specialPeriod,
                incidences: special.incidences,
                absencesToCheck: special.absencesToCheck || null,
                start: special.start || null,
                end: special.end || null,
                period: special.period,
                center: AppF.center,
                calendar: parseInt(special.calendar)
            };
            if (angular.isDefined(special.payroll)) {
                for (var p in employees.employees) {
                    if (employees.employees.hasOwnProperty(p)) {
                        delete employees.employees[p].name;
                    }
                }
                var specialPayrollId = angular.isDefined($scope.special.$id) ? $scope.special.$id : $scope.F.root.child('catalogs/operations/' + type).push().key;
                $scope.F.root.child('catalogs/operations/' + type + '/all/' + specialPayrollId).update(employees).then(function () {
                    $scope.cancel();
                    $scope.goToDetail({ $id: specialPayrollId, payroll: special.payroll, operationType: type });
                    successAlertS('Se guardó los registros con éxito');
                }).catch(function (error) {
                    $scope.cancel();
                    $log.error('Ocurrió un error de' + error);
                    errAlertS('Ocurrió un error al guardar los datos');
                });
            }
        };
        if ($scope.special.hasOwnProperty('payroll') && $scope.special.hasOwnProperty('specialDate')) {
            $scope.loadList($scope.special.payroll, $scope.special.specialDate).then(function () {
                for (var employeeId in $scope.special.employees) {
                    if ($scope.special.employees.hasOwnProperty(employeeId)) {
                        $scope.addEmployee($scope.employees, employeeId, $scope.special.employees[employeeId]);
                    }
                }
                if ($scope.special.processConfig) {
                    $scope.setConcepts($scope.special.processConfig, 'edit');
                }
            }).catch(function (error) {
                $log.error(error);
            });
        }

    }
})();


(function () {
    'use strict';

    angular
        .module('app.clients')
        .controller('showIncidencesListController', showIncidencesListController);

    function showIncidencesListController(
        $scope,
        $rootScope,
        $filter,
        AppF,
        $mdDialog,
        $mdBottomSheet,
        confirmConfig,
        $log,
        successAlertS,
        errAlertS,
        $q,
        IncidencesF,
        employeeIndex,
        employees,
        employee,
        incidencesTypes,
        incidencesTypesForPayroll,
        operation,
        operationData,
        payroll,
        nextEmployeeStatus,
        opStatusNotCalc,
        readOnlyMode,
        operationIsClosed,
        $timeout,
        allEmployees,
        operationType,
        DataF
    ) {
        var settlementDate = $filter('getFromObject')(operation.movement, "date")
        var start = moment(operationData.start);
        var end = angular.isDefined(settlementDate) ? moment(settlementDate) : moment(operationData.end);
        if (['special', 'asimilated', 'extraordinary', 'ptuRecord', 'ptuDistributionRecord'].indexOf(operationType) > -1) {
            start = moment(operation.specialDate);
            end = moment(operation.specialDate);
        }
        AppF.minIncidenceRequestDate = new Date(start.utc().year(), start.utc().month(), start.utc().date());
        AppF.maxIncidenceRequestDate = new Date(end.utc().year(), end.utc().month(), end.utc().date());

        $scope.selectedIncidences = [];
        $scope.employeeIndex = employeeIndex;
        $scope.employees = employees;
        $scope.employee = employee;
        $scope.incidencesTypes = incidencesTypes;
        $scope.incidencesTypesForPayroll = incidencesTypesForPayroll;
        $scope.operation = operation;
        $scope.nextEmployeeStatus = nextEmployeeStatus;
        $scope.opStatusNotCalc = opStatusNotCalc;
        $scope.readOnlyMode = readOnlyMode;
        $scope.allEmployees = allEmployees;
        var blancIncidence = {};
        $scope.show = function (item, list) {
            if (item.type !== "system") {
                var idx = list.findIndex(function (incidence) {
                    return incidence.$id == item.$id;
                });
                if (idx > -1) {
                    list.splice(idx, 1);
                } else {
                    list.push(item);
                }
            }
        }
        $scope.check = function (item, list) {
            return list.findIndex(function (incidence) {
                return incidence.$id == item.$id;
            }) > -1;
        }
        $scope.deleteIncidence = function (e, incidences) {
            var msg = (!AppF.safeDelete.operation) ?
                'No podrá recuperar sus datos' :
                'Podrá recuperar sus datos en la papelera';
            var title = 'Quiere borrar ' + incidences.length + ' incidencias?';
            $mdDialog.show($mdDialog.confirm(confirmConfig)
                .title(title)
                .content(msg)
                .ariaLabel('Deleting')
                .targetEvent(e)
                .ok('Borrar')
                .cancel('Cancelar'))
                .then(function () {
                    var incidencesTotal = incidences.length;
                    $rootScope.loadingProgress = true;
                    deleteIncidence(incidences).then(function () {
                        $scope.selectedIncidences = [];
                        successAlertS('Se eliminaron ' + incidencesTotal + ' incidencia(s) con éxito');
                        $mdDialog.hide();
                    }).catch(function (error) {
                        errAlertS(error);
                    }).then(function () {
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync();
                    })
                }, function () {
                    $log.debug('Deleting Cancelled');
                }
                );
        }
        function deleteIncidence(incidences) {
            return $q(function (resolve, reject) {
                var updates = {};
                var checkRequest = {};
                angular.forEach(incidences, function (incidence, index) {
                    updates['incidences/' + incidence.payroll + '/' + incidence.calendar + '/' + incidence.$id] = null;
                    if (incidence.type == 'request') {
                        checkRequest[index] = AppF.root.child('catalogs/incidencesRequests/collection/' + incidence.request + '/incidences').once('value');
                    }
                });
                $q.all(checkRequest).then(function (data) {
                    angular.forEach(data, function (value, key) {
                        var incs = value.val();
                        var numOfRows = 0;
                        var match = false;
                        angular.forEach(incs, function (inc, k) {
                            numOfRows++;
                            if (k == incidences[key].$id) {
                                match = true;
                            }
                        });
                        if (match && numOfRows == 1) {
                            updates['catalogs/incidencesRequests/collection/' + incidences[key].request] = null;
                        } else {
                            // @todo: check if exists fields employees to incidenceRequests
                            updates['catalogs/incidencesRequests/collection/' + incidences[key].request + '/incidences/' + incidences[key].$id] = null;
                            updates['catalogs/incidencesRequests/collection/' + incidences[key].request + '/employees/' + incidences[key].employee] = null;
                        }
                    });
                    AppF.root.update(updates).then(function (snapshot) {
                        resolve(snapshot);
                    }, function (error) {
                        reject(error)
                    });
                });
            });
        }
        $scope.executeIncidenceFilter = function () {
            $scope.employeeIncidences = $filter('formatIncidencesForModal')(allEmployees[employees[$scope.employeeIndex].$id].incidences, $scope.incidencesTypes, $scope.incidencesFilter);
        }
        $scope.executeIncidenceFilter();
        $scope.openObject = function (ev, incidence, action) {
            var dataNeeded = [];
            $scope.action = action;
            if (!operationIsClosed) {
                var incidenceDate;
                var movementsOrdered = ['special', 'asimilated', 'extraordinary', 'ptuRecord', 'ptuDistributionRecord'].indexOf(operationType) > -1 ? {} : $filter('orderBy')($scope.allEmployees[$scope.employees[$scope.employeeIndex].$id].movements, 'd');
                var activeDays = ['special', 'asimilated', 'extraordinary', 'ptuRecord', 'ptuDistributionRecord'].indexOf(operationType) > -1 ? [] : $filter('activeDaysFromMovements')(movementsOrdered, operationData, []);
                if (['special', 'asimilated', 'extraordinary', 'ptuRecord', 'ptuDistributionRecord'].indexOf(operationType) > -1 || (operationType === 'settlement' && activeDays.length == 0)) {
                    incidenceDate = operation.specialDate;
                    if (moment(AppF.minIncidenceRequestDate).isAfter(moment(incidenceDate)) && operationType === 'settlement') {
                        AppF.minIncidenceRequestDate = moment(incidenceDate).toDate();
                    }
                    if (moment(AppF.maxIncidenceRequestDate).isBefore(moment(incidenceDate)) && operationType === 'settlement') {
                        AppF.maxIncidenceRequestDate = moment(incidenceDate).toDate();
                    }
                } else {
                    $log.log(activeDays)
                    incidenceDate = activeDays.length > 0 ? activeDays[0].start: null;
                }
                blancIncidence = {
                    automaticAsignation: true,
                    status: 0,
                    date: incidenceDate,
                    calendar: operation.calendar,
                    period: operation.period,
                    employee: $scope.employees[$scope.employeeIndex].$id,
                    payroll: payroll,
                    type: 'manual',
                    operationType: operationType || null,
                    comments: ''
                };
                if (angular.isDefined(operationType)) {
                    blancIncidence[operationType] = operation.$id || null;
                }
            }
            if (action == 'add') {
                $scope.F.addMode = true;
                $scope.incidence = angular.fromJson(angular.toJson(blancIncidence));
            } else {
                $scope.F.addMode = false;
                $scope.incidence = angular.fromJson(angular.toJson(incidence));
            }
            $rootScope.loadingProgress = true;
            $scope.M.loadNeeded(dataNeeded);
            $mdDialog.show({
                controller: 'DialogCtrl',
                locals: {
                    predefinedValue: undefined
                },
                templateUrl: 'app/main/clients/views/newoperation/dialogs/incidence.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                scope: $scope.$new(),
                clickOutsideToClose: true
            });
            $rootScope.loadingProgress = false;
            $scope.$evalAsync(function () {
                //$log.debug('open modal finished');
            });
        }
        $scope.saveIncidence = function (incidence) {
            incidence.updated = DataF.getTimeObject();
            saveIncidence(incidence).then(function () {
                successAlertS('Se guardó incidencia con éxito');
                $mdDialog.hide();
            })
        }
        function saveIncidence(incidence) {
            if (angular.isDefined(incidence.typeName) && angular.isDefined(incidence.incidenceName)) {
                delete incidence.typeName;
                delete incidence.incidenceName;
            }
            return AppF.root.child('incidences/' + incidence.payroll + '/' + incidence.calendar + '/' + incidence.$id).update($filter('clearObject')(incidence));
        }
        function checkMaxAllowValidation() {
            return new Promise(function (resolve, reject) {
                delete $scope.maxAllowed;
                try {
                    if ($scope.incidenceType.max) {
                        $scope.employeeSelected = allEmployees[employees[$scope.employeeIndex].$id]
                        if ($scope.incidenceType.getMax) {
                            var data = { employee: $scope.employeeSelected };
                            $scope.maxAllowed = eval($scope.incidenceType.max);
                        } else {
                            $scope.maxAllowed = $scope.incidenceType.max;
                        }
                    }
                    resolve(true);
                } catch (error) {
                    $scope.maxAllowed = 0;
                    reject(error);
                }
            });
        }
        $scope.checkIfValid = function (date, incidenceType, val) {
            $rootScope.loadingProgress = true;
            $timeout(function () {
                checkIncidenceTypeValidation(incidenceType).then(function () {
                    return checkDaysAvailables(date, incidenceType, val);
                }).then(function () {
                    return checkMaxAllowValidation();
                }).then(function () {
                    $log.log('Todo ok');
                }).catch(errAlertS).then(function () {
                    $rootScope.loadingProgress = false;
                    $timeout(function () { $rootScope.$evalAsync(); }, 0, false);
                });
            }, 0, false);
        }
        function checkDaysAvailables(date, incidenceType, val) {
            return new Promise(function (resolve, reject) {
                try {
                    if (incidenceType && date) {
                        val = (val) ? val : 1;
                        var incidenceAffect = $filter('getSomethingOfArrayFB')(incidenceType, $scope.incidencesTypes, 'validateDays');
                        // se checa que la incidencia afecte solamente dias activos
                        var incidence = {
                            date: date,
                            value: val,
                            employee: employee.$id,
                            payroll: payroll
                        };
                        var employeeIncidences = allEmployees[employees[$scope.employeeIndex].$id].incidences;
                        var affectDays = 'salary';
                        if (incidenceAffect) {
                            affectDays = 'days';
                        }
                        if (affectDays === 'salary' && operationType === 'settlement') {
                            resolve(true)
                        } else {
                            IncidencesF.checkIfValidActiveDates(incidence, affectDays).then(function () {
                                if (incidenceAffect) {
                                    for (var x = 0; x < val; x++) {
                                        var initDate = date + (AppF.oneDay * x); // * x dias empezando por 0
                                        if (x === (val - 1)) {
                                            // si es la ultima checar que la fecha no sobre pase el periodo
                                            if (initDate > operationData.end) {
                                                $scope.incidence.value = x + 1;
                                                $log.error('incidence with problem: ', { dateOfIncidence: initDate, end: operationData.end });
                                                throw 'Fecha ' + moment(initDate).format('DD/MM/YYYY') + ' es de otro periodo';
                                            }
                                        }
                                        for (var i = 0; angular.isArray(employeeIncidences) && i < employeeIncidences.length; i++) {
                                            var iAffect = $filter('getSomethingOfArrayFB')(employeeIncidences[i].incidenceType, $scope.incidencesTypes, 'validateDays');
                                            if (iAffect && employeeIncidences[i].date === initDate && employeeIncidences[i].employee === incidence.employee) {
                                                $log.error('incidence with problem: ', employeeIncidences[i]);
                                                throw 'Fecha ' + moment(initDate).format('DD/MM/YYYY') + ' ya tiene incidencia que afecta días';
                                            }
                                        }
                                    }
                                }
                                resolve(true);
                            }).catch(function (err) {
                                $scope.incidence.date = null;
                                reject(err);
                            });
                        }
                    } else {
                        resolve(true);
                    }
                } catch (error) {
                    $scope.incidence.date = null;
                    reject(error);
                }
            });

        }



        function checkIncidenceTypeValidation(incidenceType) {
            return new Promise(function (resolve, reject) {
                try {
                    if (incidenceType) {
                        var validations = $filter('getSomethingOfArrayFB')(incidenceType, $scope.incidencesTypes, 'validations');
                        $log.log(validations);
                        for (var v = 0; v < validations.length; v++) {
                            var thisValidation = validations[v];
                            var value = $filter('getFromObject')(allEmployees[employees[$scope.employeeIndex].$id], thisValidation.path);
                            var result = thisValidation.value;
                            if (result === 'null') {
                                result = null;
                            } else if (result === 'undefined') {
                                result = undefined;
                            }
                            else if (result.indexOf(':isNumber')) {
                                result = parseFloat(result.replace(':isNumber', ''));
                            }
                            var haveError = false;
                            if (thisValidation.operation === '=') {
                                haveError = (value !== result);
                            } if (thisValidation.operation === '!=') {
                                haveError = (value === result);
                            }
                            if (haveError) {
                                throw thisValidation.errorMsg;
                            }
                        }
                    }
                    resolve(true);
                } catch (error) {
                    delete $scope.incidence.incidenceType;
                    reject(error);
                }
            });
        }

        $scope.addIncidence = function (incidence) {
            if (!$scope.adding) {
                $scope.adding = true;
                addIncidence(incidence).then(function () {
                    $mdDialog.hide().then(function () {
                        $scope.adding = false;
                    });
                }).catch(function (error) {
                    $log.error(error);
                    $scope.adding = false;
                });
            }
        }
        function addIncidence(incidence) {
            return new Promise(function (resolve, reject) {
                $rootScope.loadingProgress = true;
                $scope.$evalAsync();
                $timeout(function () {
                    var typeIncideceAffect = $filter('getSomethingOfArrayFB')(incidence.incidenceType, $scope.incidencesTypes, 'validateDays');
                    var incidenceAffect = "salary";
                    if (typeIncideceAffect) {
                        incidenceAffect = "days";
                    }
                    IncidencesF.checkIfIncidenceRequestIsNeededAndCreateIt(incidence, incidenceAffect).then(function (iR) {
                        $log.log(iR);
                        var msg = (iR) ? 'Se creó una solicitud de incidencias masivas y varias incidencias para cada día' : 'Se creó Incidencia con éxito';
                        $rootScope.loadingProgress = false;
                        $scope.$evalAsync(function () {
                            //$log.debug('Incidencias creadas');
                        });
                        successAlertS(msg);
                        resolve(msg);
                    })
                        .catch(function (err) {
                            errAlertS(err);
                            $rootScope.loadingProgress = false;
                            $scope.$evalAsync(function () {
                                //$log.debug('error creando finished');
                            });
                            reject(err);
                        });
                }, 0, false);

            });
        }
        $scope.hideModal = function () {
            $mdBottomSheet.hide();
        };
        $scope.setEmployee = function (val) {
            $scope.employeeIndex = $scope.employeeIndex + val;
        };
        var incidencesWatcher = $scope.$watch(function () {
            return $scope.allEmployees[$scope.employees[$scope.employeeIndex].$id].incidences;
        }, function () {
            $scope.executeIncidenceFilter();
        });
        var incidenceTypeWatcher = $scope.$watch('incidence.incidenceType', function (val) {
            if (val) {
                $scope.incidenceType = $scope.incidencesTypesForPayroll.find(function (item) {
                    return item.$id === val;
                });
                $log.log($scope.incidenceType)
                if (angular.isDefined($scope.incidenceType.setValue) && $scope.F.addMode) {
                    $scope.incidence.value = $scope.incidenceType.defaultValue;
                }
            }
        });
        $scope.$on('$destroy', function () {
            incidencesWatcher();
            incidenceTypeWatcher();
        });
    }
})();


(function () {
    'use strict';

    angular
        .module('app.clients')
        .controller('showCalculationsListController', showCalculationsListController);

    function showCalculationsListController(
        $scope,
        $rootScope,
        $mdDialog,
        $mdBottomSheet,
        employeeIndex,
        employees,
        calculations,
        concepts,
        $localStorage,
        $filter
    ) {
        var fullHeight = $localStorage.fullHeightCalculations;
        fullHeight = (angular.isUndefined(fullHeight) || fullHeight === 'true' || fullHeight === true) ? true : false;
        $scope.F.fullHeight = fullHeight;
        $scope.F.allCalculationsOpened = false;
        $scope.employeeIndex = employeeIndex;
        $scope.employees = employees;
        $scope.view = 'cards';
        $scope.showAllCalculations = false;
        // $scope.calculations = calculations;
        $scope.concepts = concepts;
        $scope.active = false;
        $scope.filterCalculation = '';
        $scope.order = 'order';
        $scope.setViewCalculations = function (open) {
            if (angular.isArray($scope.calculations)) {
                $scope.calculations.map(function (item) {
                    return item.showData = (open ? true : false);
                })
            }
            $scope.F.allCalculationsOpened = open;
        }
        $scope.setAllCalculationViewStatus = function () {
            var allAreOpened = true;
            if (angular.isArray($scope.calculations)) {
                for (var c = 0; c < $scope.calculations.length && allAreOpened; c++) {
                    allAreOpened = $scope.calculations[c].showData;
                }
            }
            $scope.F.allCalculationsOpened = allAreOpened;
        }
        $scope.saveFullHeight = function (flag) {
            $localStorage.fullHeightCalculations = flag;
        }

        $scope.setCalculations = function () {
            var data = $filter('orderByObjectForFields')(calculations[$scope.employees[$scope.employeeIndex].$id], 'hc', 'value');
            $scope.calculations = $filter('filter')($filter('orderBy')(data, $scope.order), $scope.filterCalculation);
        };
        $scope.setEmployee = function (val) {
            $scope.employeeIndex = $scope.employeeIndex + val;
            $scope.setCalculations();
            $scope.setViewCalculations($scope.F.allCalculationsOpened);
        };
        $scope.setView = function (thisView) {
            $scope.view = thisView;
        }
        $scope.setOrder = function (order) {
            $scope.order = order;
            $scope.setCalculations();
        }
        $scope.hideModal = function () {
            $mdBottomSheet.hide();
        };

        $scope.openCalc = function (ev, index) {
            $scope.indexCalculation = index;
            $scope.calculation = $scope.calculations[$scope.indexCalculation];
            $scope.active = validateObject($scope.calculation);
            $scope.changeCalculation = function (n) {
                $scope.indexCalculation = $scope.indexCalculation + n;
                $scope.calculation = $scope.calculations[$scope.indexCalculation];
                $scope.active = validateObject($scope.calculation);
            }
            $mdDialog.show({
                controller: 'DialogCtrl',
                templateUrl: 'app/main/clients/views/newoperation/dialogs/calculations.html',
                locals: {
                    predefinedValue: undefined
                },
                parent: angular.element(document.body),
                targetEvent: ev,
                scope: $scope.$new(),
                clickOutsideToClose: true
            });
            $rootScope.loadingProgress = false;
            $scope.$evalAsync(function () {
                //$log.debug('calculation show finished');
            });
        };
        function validateObject(calculations) {
            var exists = false;
            if (angular.isDefined(calculations.data)) {
                exists = true;
            } else {
                for (var calculationId in calculations) {
                    var calc = calculations[calculationId];
                    if (angular.isDefined(calc.result) && !calc.hidden && (calc.name).toLowerCase() !== "total") {
                        exists = true;
                        break;
                    }
                }
            }
            return exists;
        }
        $scope.setCalculations();
    }
})();


(function () {
    'use strict';

    angular
        .module('app.clients')
        .controller('settlementsController', settlementsController);

    function settlementsController(
        $scope,
        DataF,
        $mdDialog,
        objsToArrayFilter,
        getFromObjectFilter,
        $q,
        getArrayOfIdsFilter,
        successAlertS,
        errAlertS,
        $log,
        employeeP,
        movement,
        operationId,
        action,
        AppF,
        userHasPermissionFilter,
        $rootScope,
        ApiV3F
    ) {
        $scope.employee = {};
        $scope.movement = angular.isDefined(movement) ? { data: movement } : {
            data: {
                rehirable: true
            }
        };
        $scope.dismissMovement = {
            employee: [],
            movementTypes: []
        };
        $scope.settlements = {};
        $scope.processesConfig = [];
        $scope.processObj = {};
        $scope.userHasPermissionProcessesConfig = userHasPermissionFilter(AppF.groupsOfUser, AppF.permissions, 'accessProcessesConfig', 'processes.operations');
        $scope.listsEmployees = function (searchQuery, ccs) {
            return $q(function (resolve, reject) {
                var flag = ($scope.F.permissionToAccessAllPayrolls) ? true : false;
                var params = { center: AppF.center };
                if (!flag) {
                    params.cc = { $in: getArrayOfIdsFilter(ccs) }
                }
                DataF.api.autocompleteMongo(searchQuery, "employees", ["data.name", "data.nss"], params).then(function (employees) {
                    resolve(employees);
                }, function (error) {
                    reject(error);
                })
            })
        }
        $scope.checkHasChristmasBonusF = function (incidences, payroll) {
            return new Promise(function (resolve) {
                $scope.settlementIncidences = [];
                var promises = [];
                var hasChristmasBonus = false;
                if (angular.isDefined(incidences)) {
                    var incidencesKeys = Object.keys(incidences).filter(function (key) {
                        return incidences[key] === true;
                    });
                    if (incidencesKeys.length > 0) {
                        promises.push(ApiV3F.get('api/concepts', { fid: JSON.stringify({ $in: incidencesKeys }), $fields: ['fid'], key: 'christmasBonus_settlement' }));
                    }
                }
                Promise.all(promises).then(function (resp) {
                    if (resp.length > 0 && resp[0].data.length > 0) {
                        hasChristmasBonus = true;
                    }
                    promises = [];
                    if (hasChristmasBonus) {
                        promises.push(ApiV3F.get('api/concepts', { payroll: JSON.stringify({ $in: ['global', payroll] }), center: AppF.center, validateDays: true, nature: 'deduction', $fields: ['fid', 'name', 'id_human'] }));
                    }
                    return Promise.all(promises)
                }).then(function (resp) {
                    if (resp.length > 0 && resp[0].data.length > 0) {
                        $scope.settlementIncidences = resp[0].data;
                    }
                    $scope.settlementHasChristmasBonusF = hasChristmasBonus;
                    $scope.$evalAsync();
                    resolve(true);
                }).catch(function (error) {
                    errAlertS(error);
                    resolve(true)
                });
            })
        }
        $scope.loadPayroll = function (movementId, data, processConfig, disableMonthlyBase, action) {
            $scope.minMovementDate = '';
            var employee = data.employee;
            var payroll;
            var promises = [];
            var employeeObj = {
                $id: employee.$id,
                data: {
                    name: employee.data.name,
                    enroleDate: (employee.seniorityDate) ? employee.seniorityDate : employee.data.enroleDate
                },
                payrollId: employee.payroll,
                cc: employee.cc,
                rp: employee.rp,
                status: 0,
                incidences: employee.incidences || {},
                absencesToCheck: employee.absencesToCheck || {},
                movementTypes: movementId || 'settlementId',
                disableMonthlyBase: disableMonthlyBase || undefined
            };
            if (movementId === 'settlementId') {
                AppF.readMode = false;
            } else {
                promises.push($scope.F.root.child('catalogs/movements/collection/' + movementId).once('value'));
            }
            Promise.all(promises).then(function (movSnap) {
                var mov = data.movementTypes.find(function (value) {
                    return value.$id === movementId;
                });
                if (movSnap.length > 0 && movSnap[0].exists()) {
                    var movements = movSnap[0].val();
                    var enroleDate = (movements.data.seniorityDate) ? movements.data.seniorityDate : movements.data.enroleDate;
                    if (angular.isDefined(movements.data.fromSettlement)) {
                        errAlertS("Este movimiento fue generado por un finiquito, no se puede realizar nuevamente");
                    }
                    if (!enroleDate) {
                        errAlertS("Este movimiento no puede utilizarse ya que no tiene la fecha de alta o de antigüedad anterior del empleado");
                    }
                    $scope.movement = { data: movements.data };
                    employeeObj.payroll = mov.name;
                    employeeObj.payrollId = mov.p;
                    employeeObj.cc = movements.cc;
                    employeeObj.rp = movements.rp;
                    employeeObj.data.enroleDate = enroleDate;
                    AppF.readMode = true;
                }
                return Promise.all([$scope.F.root.child('catalogs/payrolls/collection/' + employeeObj.payrollId).once('value')]);
            }).then(function (payrollSnap) {
                var query = [];
                if (payrollSnap.length > 0 && payrollSnap[0].exists()) {
                    payroll = payrollSnap[0].val();
                    query.push($scope.F.root.child('catalogs/paymentSchemas/collection/' + payroll.paymentSchema + '/processesConfigId').once('value'));
                }
                return Promise.all(query)
            }).then(function (paymentSchemaSnap) {
                if (paymentSchemaSnap.length > 0 && paymentSchemaSnap[0].exists() && angular.isDefined(payroll)) {
                    var settlementId = paymentSchemaSnap[0].val();
                    employeeObj.processConfig = (action === 'edit') ? processConfig : settlementId;
                    if (movementId === 'settlementId' || angular.isUndefined(movementId)) {
                        employeeObj.payroll = payroll.data.name;
                        if (angular.isUndefined(action)) {
                            $scope.movement = {
                                data: {
                                    dismissType: '',
                                    date: '',
                                    paySalaryInPayrol: 0,
                                    comments: '',
                                    rehirable: true
                                }
                            }
                            AppF.readMode = false;
                            $scope.disabledEmployee = false;

                        }
                    }
                    if (action === 'edit') {
                        $scope.disabledEmployee = true;
                    }
                    var thisDate = moment(data.lastMovement.d + AppF.oneDay);
                    $scope.minMovementDate = thisDate.toDate();
                    $rootScope.$evalAsync();
                    $scope.employee = employeeObj;
                    if (angular.isUndefined($scope.movement.data.sbc)) { $scope.movement.data.sbc = getFromObjectFilter(employee, 'data.salary.sbc', null); }
                    if (angular.isUndefined($scope.movement.data.salaryType)) { $scope.movement.data.salaryType = getFromObjectFilter(employee, 'data.salary.type', null); }
                    if (angular.isUndefined($scope.movement.data.sd)) { $scope.movement.data.sd = getFromObjectFilter(employee, 'data.salary.sd', null); }
                    if (angular.isUndefined($scope.movement.data.sdr)) { $scope.movement.data.sdr = getFromObjectFilter(employee, 'data.salary.sdr', null); }
                    if (angular.isUndefined($scope.movement.data.type)) { $scope.movement.data.type = 2; }
                    if (angular.isUndefined($scope.movement.data.workDay)) { $scope.movement.data.workDay = getFromObjectFilter(employee, 'data.workDay', null); }
                    if (angular.isUndefined($scope.movement.data.workerType)) { $scope.movement.data.workerType = getFromObjectFilter(employee, 'data.workerType', null); }
                    if (angular.isUndefined($scope.movement.data.position)) { $scope.movement.data.position = getFromObjectFilter(employee, 'data.position', null); }
                    if (angular.isUndefined($scope.movement.data.nss)) { $scope.movement.data.nss = getFromObjectFilter(employee, 'data.nss', null); }
                    getProcessConfig().then(function () {
                        $scope.setConcepts(employeeObj.processConfig, action)
                        $scope.checkHasChristmasBonusF(employeeObj.incidences, employeeObj.payrollId);
                    }).catch(function (error) {
                        $log.log(error);
                        errAlertS('Ocurrió un error al consultar los datos de los procesos de configuración');
                    })
                } else {
                    $scope.processConfigError = true;
                    $scope.employee = {};
                    $scope.processesConfig = [];
                    errAlertS('No se encontró configuración de finiquito en la nómina');
                }
            }).catch(function (error) {
                $log.error(error);
                errAlertS('Ocurrió un error al consultar los datos');
            })
        }
        $scope.loadMovements = function (employee, processConfig, disableMonthlyBase, action) {
            if ($scope.dismissMovement.movementTypes.length > 0) {
                $scope.dismissMovement.movementTypes = [];
                delete $scope.employee.movementTypes;
            }
            var movements = objsToArrayFilter(employee.movements);
            movements.sort(function (a, b) {
                return a.d - b.d;
            });
            var movementTypes = [];
            var payrolls = {};
            var promises = [];
            for (var i = movements.length - 1; i >= 0; i--) {
                if (movementTypes.length < 6 && movements[i].t === 2 && movements[i].s >= 2 && movements[i].s !== 2.2) {
                    movementTypes.push(movements[i]);
                    if (!payrolls.hasOwnProperty(movements[i].p)) {
                        payrolls[movements[i].p] = promises.length;
                        promises.push($scope.F.root.child('catalogs/payrolls/collection/' + movements[i].p + '/data/name').once('value'));
                    }
                }
            }
            Promise.all(promises).then(function (resp) {
                var lastMovement = movements[movements.length - 1];
                if (lastMovement.s <= 2.2 && lastMovement.s !== 2.1) {
                    lastMovement = movements[movements.length - 2]
                }
                for (var t = 0; t < movementTypes.length; t++) {
                    movementTypes[t].name = resp[payrolls[movementTypes[t].p]].val() || 'No encontrado';
                }
                if (lastMovement.t !== 2 || lastMovement.p !== employee.payrollId) {
                    movementTypes.push({ $id: 'settlementId', name: 'FINIQUITO ACTUAL' });
                }
                $scope.dismissMovement.lastMovement = lastMovement;
                $scope.dismissMovement.employee = employee || {};
                $scope.dismissMovement.movementTypes = angular.fromJson(angular.toJson(movementTypes));
                if (action === 'edit') {
                    var dataObj = {
                        employee: employee,
                        movementTypes: movementTypes,
                        lastMovement: lastMovement
                    }
                    $scope.loadPayroll(employee.movementTypes, dataObj, processConfig, disableMonthlyBase, action);
                }
            }).catch(function (error) {
                $log.error(error);
                errAlertS('Ocurrió un error al consultar los datos');
            })
        }
        if (angular.isDefined(employeeP)) {
            $scope.employeeSelected = employeeP;
            $scope.loadMovements(employeeP, employeeP.processConfig, employeeP.disableMonthlyBase, action);
        }
        function getProcessConfig() {
            return new Promise(function (resolve, reject) {
                $scope.F.root.child('catalogs/processConfigs/collection').orderByChild('type').equalTo('settlement').once('value').then(function (snap) {
                    snap.forEach(function (childSnapshot) {
                        var thisProccess = childSnapshot.val();
                        thisProccess.id = childSnapshot.key;
                        if (thisProccess.center === AppF.center) {
                            var exist = $scope.processesConfig.findIndex(function (value) {
                                return value.id === thisProccess.id;
                            });
                            if (exist === -1) {
                                $scope.processesConfig.push(thisProccess);
                            }
                        }
                    })
                    if ($scope.processesConfig.length > 0) {
                        resolve($scope.processesConfig)
                    } else {
                        reject('No se encontró registro de los procesos de configuración');
                    }
                }).catch(function (error) {
                    reject(error);
                })
            })
        }
        $scope.saveSettlements = function (employee, movement) {
            var employeeData = {};
            employeeData[employee.$id] = {
                cc: employee.cc,
                rp: employee.rp,
                status: employee.status,
                name: employee.data.name
            }
            $scope.settlements = {
                payroll: employee.payrollId,
                processConfigId: employee.processConfig,
                disableMonthlyBase: employee.disableMonthlyBase || null,
                movementTypes: employee.movementTypes,
                status: 1,
                center: AppF.center,
                employees: angular.fromJson(angular.toJson(employeeData)),
                created: DataF.getTimeObject(),
                movement: angular.fromJson(angular.toJson(movement.data)),
                incidences: employee.incidences,
                absencesToCheck: employee.absencesToCheck
            }
            var settlementId = angular.isDefined(operationId) ? operationId : $scope.F.root.child('catalogs/operations/settlement').push().key;
            $scope.F.root.child('catalogs/operations/settlement/all/' + settlementId).update($scope.settlements).then(function () {
                $scope.cancel();
                $scope.goToDetail({ $id: settlementId, payroll: employee.payrollId, operationType: 'settlement' });
                successAlertS('Se guardó los finiquitos con éxito');
            }).catch(function (error) {
                $scope.cancel();
                $log.error('Ocurrió un error de' + error);
                errAlertS('Ocurrió un error al guardar los datos');
            })
        }
        $scope.cancel = function () {
            $mdDialog.cancel();
        }
        $scope.setConcepts = function (id, action) {
            var doIt = true;
            var keys = [];
            if (angular.isUndefined($scope.employee.incidences)) {
                $scope.employee.incidences = {}
            }
            if (angular.isUndefined($scope.processObj[id])) {
                $scope.processObj[id] = [];
            } else {
                doIt = false;
                var incidences = $scope.processObj[id];
                var objIncidences = {};
                for (var i = 0; i < incidences.length; i++) {
                    objIncidences[incidences[i].$id] = true;
                }
                $scope.employee.incidences = angular.fromJson(angular.toJson(objIncidences));
            }
            if (doIt) {
                var process = $scope.processesConfig.find(function (value) {
                    return value.id === id;
                });
                if (process) {
                    if (angular.isArray(process.processes)) {
                        var real = process.processes.find(function (value) {
                            return value.id === 'real';
                        });
                        if (real) {
                            var promises = [];
                            for (var key in real.incidences) {
                                promises.push($scope.F.root.child('catalogs/concepts/collection/' + key).once('value'));
                                keys.push(key);
                            }
                            Promise.all(promises).then(function (snap) {
                                if (snap.length > 0) {
                                    for (var i = 0; i < snap.length; i++) {
                                        var data = snap[i].val();
                                        data.$id = keys[i];
                                        $scope.processObj[id].push(data);
                                        if (angular.isUndefined(action) && action !== 'edit') {
                                            if (i === 0) {
                                                $scope.employee.incidences = {};
                                            }
                                            $scope.employee.incidences[keys[i]] = true;
                                        }
                                    }
                                }
                                return $scope.checkHasChristmasBonusF($scope.employee.incidences, $scope.employee.payrollId);
                            }).then(function () {
                                $rootScope.$evalAsync();
                            }).catch(function (error) {
                                $log.error(error);
                            })
                        }
                    }
                } else {
                    errAlertS('No se encontró los procesos de configuración');
                }
            }
        }
    }
})();


/* eslint-disable angular/json-functions */
(function () {
    'use strict';

    angular
        .module('app.clients')
        .controller('PtuDistributionModalController', PtuDistributionModalController);

    function PtuDistributionModalController(
        $scope,
        $rootScope,
        $mdDialog,
        successAlertS,
        errAlertS,
        $log,
        AppF,
        DataF,
        $timeout,
        getMovementsDFilter,
        operation,
        geEmployeesByBatchFilter,
        groupByFieldFilter,
        loopEachFilter,
        activeDaysFromMovementsFilter,
        realWorkedDaysFilter,
        typeNameFilter
    ) {
        var vm = this;
        vm.debounceTime = AppF.debounceTime
        function init() {
            if (angular.isDefined(operation)) {
                AppF.addMode = false;
                vm.operation = operation;
                if (angular.isDefined(vm.operation.processConfigId)) {
                    vm.operation.processConfig = vm.operation.processConfigId;
                }
                if (vm.operation.companiesRecordId) {
                    loadIncidences();
                }
            } else {
                AppF.addMode = true;
                vm.operation = {};
            }
            Promise.all([loadProccessConfig()]).then(function () {
                $log.log('cargado');
                $rootScope.$evalAsync();
                $timeout(function () { }, 0, false);
            }).catch(errAlertS);
        }
        function loadProccessConfig() {
            return new Promise(function (resolve, reject) {
                AppF.root.child('catalogs/processConfigs/collection').orderByChild('type').equalTo('ptuDistributionRecord').once('value').then(function (resp) {
                    resp.forEach(function (childSnap) {
                        var pro = childSnap.val();
                        pro.id = childSnap.key;
                        if (pro.center === AppF.center) {
                            vm.processesConfig.push(pro);
                        }
                    });
                    if (vm.processesConfig.length === 0) {
                        throw 'No se encontró proceso de configuración';
                    } else {
                        var defaultP = vm.processesConfig.find(function (item) {
                            return item.default;
                        });
                        if (angular.isDefined(defaultP) && angular.isUndefined(vm.operation.processConfigId)) {
                            vm.operation.processConfigId = defaultP.id;
                        }
                        resolve(true);
                    }
                }).catch(reject);
            })
        }
        function cancel() {
            $mdDialog.cancel();
        }

        function loadIncidences() {
            if (angular.isDefined(vm.operation.companiesRecordId)) {
                var payrolls = AppF.permissionToAccessAllPayrolls ? $rootScope.L.allPayrolls : $rootScope.L.payrolls;
                var matchingPayrolls = new Set();
                angular.forEach(payrolls, function (payroll) {
                    var processes = payroll.processes;
                    angular.forEach(processes, function (process) {
                        if (process.companiesRecord === vm.operation.companiesRecordId) {
                            matchingPayrolls.add(payroll.$id);
                        }
                    });
                });
                var payrollsArray = Array.from(matchingPayrolls);
                payrollsArray.push('global');
                var conceptsParams = {
                    'center': AppF.center,
                    'nature': 'deduction',
                    'validateDays': true,
                    'project': angular.toJson({ _id: 1, fid: 1, name: 1, key: 1, id_human: 1 }),
                    'payroll': { $in: payrollsArray },
                    'type': 'incidenceType'
                }
                DataF.api.get('p/concepts', conceptsParams).then(function (resp) {
                    vm.payrollIncidences = resp.data.data;
                }).catch(function (error) {
                    errAlertS('Error al cargar incidencias');
                    $log.log('error al obtener incidencias', error);
                });
                $log.log('payrolls', payrollsArray);
            }
        }

        function loadEmployees() {

            loadIncidences();

            if (vm.operation.companiesRecordId && vm.operation.calendar) {
                removedEmployees = {};
                var allEmployees = {};
                var operationEmployees = [];
                var thisCalendar = moment(vm.operation.calendar, 'YYYY');
                var calendarStart = thisCalendar.startOf('year').valueOf();
                var calendarEnd = thisCalendar.endOf('year').valueOf()
                $rootScope.loadingProgress = true;
                AppF.root.child('catalogs/rps/collection').orderByChild('companiesRecord').equalTo(vm.operation.companiesRecordId).once('value').then(function (resp) {
                    var rps = [];
                    resp.forEach(function (childSnap) {
                        // var rp = childSnap.val();
                        // if (rp.active) {
                        rps.push(childSnap.key)
                        // }
                    });
                    if (rps.length === 0) {
                        throw 'No se encontraron rps con esta Compañia';
                    }
                    return getMovementsDFilter({ rp: { $in: rps } }, calendarStart, calendarEnd, { 'data.name': 1 })
                }).then(function (data) {
                    var employeesIds = [];
                    var payrolls = {};
                    var movementsByEmployee = groupByFieldFilter(data.movements, 'employee', false, 'data.date');
                    for (var employeeId in movementsByEmployee) {
                        var workedDays = realWorkedDaysFilter(activeDaysFromMovementsFilter(movementsByEmployee[employeeId], { start: calendarStart, end: calendarEnd }));
                        var employeeData = data.employees[employeeId];
                        if (workedDays >= 60) {
                            var lastMov = movementsByEmployee[employeeId][movementsByEmployee[employeeId] ? movementsByEmployee[employeeId].length - 1 : 0];
                            var movType = typeNameFilter(lastMov.data.type);
                            allEmployees[employeeId] = employeeData
                            operationEmployees.push({
                                employeeId: employeeId,
                                name: employeeData.data.name,
                                workedDays: parseFloat(workedDays.toFixed(4)),
                                status: 0,
                                cc: movementsByEmployee[employeeId][0].cc,
                                rp: movementsByEmployee[employeeId][0].rp,
                                movType: movType
                            })
                            payrolls[movementsByEmployee[employeeId][0].payroll] = true;
                            employeesIds.push(employeeId);
                        }
                    }
                    vm.operation.payroll = Object.keys(payrolls);
                    var fnQuery = function (employeeIdsP) {
                        var queryCalculations = [{
                            '$match': {
                                'accuDate': { '$gte': calendarStart, '$lte': calendarEnd },
                                'fiscalSalary.value': { '$exists': true },
                                'operationType': { '$in': ['ordinary', 'settlement'] },
                                'employeeId': {
                                    '$in': employeeIdsP
                                }
                            }
                        }, {
                            '$unwind': '$companiesRecords'
                        }, {
                            '$match': {
                                'companiesRecords.opType': 'fiscal',
                                'companiesRecords.companiesRecordId': vm.operation.companiesRecordId
                            }
                        }, {
                            '$group': { '_id': '$employeeId', 'totalFiscalSalary': { '$sum': '$fiscalSalary.value' }, 'totalVacations': { '$sum': '$vacations.fiscalValue' } }
                        }];
                        var thisQuery = {
                            query: angular.toJson(queryCalculations)
                        };
                        return thisQuery
                    }
                    return geEmployeesByBatchFilter($rootScope.D.api.post, 'aggregate/calculations', fnQuery, employeesIds);
                }).then(function (calculations) {
                    for (var r = 0; r < calculations.length; r++) {
                        var thisData = calculations[r];
                        var totalSalary = (thisData.totalFiscalSalary || 0) + (thisData.totalVacations || 0);
                        var index = operationEmployees.findIndex(function (item) {
                            return item.employeeId === thisData._id;
                        })
                        if (index > -1) {
                            operationEmployees[index].totalSalary = parseFloat(totalSalary.toFixed(4));
                        }
                    }
                    var finalEmployees = operationEmployees.sort(function (a, b) {
                        var result = (a.workedDays || 0) - (b.workedDays || 0);
                        if (result === 0) {
                            var fieldA = a.name || '';
                            var fieldB = b.name || '';
                            result = (fieldA + '').localeCompare(fieldB + '');
                        }
                        return result;
                    }).reduce(function (current, item) {
                        current[item.employeeId] = item;
                        return current;
                    }, {});
                    vm.employeesAvailable = finalEmployees;
                    return calculateFactors(true);
                }).then(function () {
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                    $timeout(function () { }, 0);
                }).catch(function (err) {
                    errAlertS(err);
                    $rootScope.loadingProgress = false;
                });
            }
        }


        function calculateFactors(notShowLoading) {
            return new Promise(function (resolve, reject) {
                if (vm.operation.totalAmount && vm.employeesAvailable) {
                    if (!notShowLoading) {
                        $rootScope.loadingProgress = true;
                    }
                    var employeesIds = Object.keys(vm.employeesAvailable);
                    var incidencesTypes = [];
                    loopEachFilter(vm.operation.absencesToCheck, function (incidence, incidenceId) {
                        if (incidence) {
                            incidencesTypes.push(incidenceId);
                        }
                    });
                    var fnQuery = function (employeeIdsP) {
                        var thisCalendar = moment(vm.operation.calendar, 'YYYY');
                        var params = {
                            employee: angular.toJson({ $in: employeeIdsP }),
                            incidenceType: angular.toJson({ $in: incidencesTypes }),
                            date: angular.toJson({ $gte: thisCalendar.startOf('year').valueOf(), $lte: thisCalendar.endOf('year').valueOf() }),
                            companiesRecord: vm.operation.companiesRecordId,
                            project: angular.toJson({ value: 1, date: 1, fid: 1, employee: 1 })
                        };
                        return params;
                    }
                    var promise = incidencesTypes.length > 0 ? geEmployeesByBatchFilter($rootScope.D.api.get, 'incidences', fnQuery, employeesIds) : Promise.all([]);
                    promise.then(function (incidences) {
                        var incidencesToDiscount = incidences.reduce(function (current, item) {
                            if (!current.hasOwnProperty(item.employee)) {
                                current[item.employee] = 0;
                            }
                            current[item.employee] += item.value;
                            return current;
                        }, {})
                        var totalSalary = 0;
                        var totalDays = 0;
                        var newEmployees = {};
                        loopEachFilter(vm.employeesAvailable, function (employee, employeeId) {
                            var daysToDiscount = incidencesToDiscount[employeeId] || 0;
                            var thisEmployee = JSON.parse(JSON.stringify(employee));
                            thisEmployee.daysToDiscount = daysToDiscount;
                            thisEmployee.workedDays = (thisEmployee.workedDays || 0);
                            thisEmployee.totalDaysNoAbs = thisEmployee.workedDays - daysToDiscount;
                            if (thisEmployee.totalDaysNoAbs >= 60 && !removedEmployees[employeeId]) {
                                if (vm.operation.employees && vm.operation.employees[employeeId] && vm.operation.employees[employeeId].totalSalary) {
                                    thisEmployee.totalSalary = vm.operation.employees[employeeId].totalSalary;
                                }
                                // if ((!angular.isNumber(thisEmployee.workedDays)) || (!thisEmployee.workedDays > 0)) {
                                //     if (!vm.editEmployees.hasOwnProperty(thisEmployee.employeeId)) {
                                //         vm.editEmployees[thisEmployee.employeeId] = {};
                                //     }
                                //     vm.editEmployees[thisEmployee.employeeId].workedDays = true;
                                // }
                                if ((!angular.isNumber(thisEmployee.totalSalary)) || (!thisEmployee.totalSalary > 0)) {
                                    if (!vm.editEmployees.hasOwnProperty(thisEmployee.employeeId)) {
                                        vm.editEmployees[thisEmployee.employeeId] = {};
                                    }
                                    vm.editEmployees[thisEmployee.employeeId].totalSalary = true;
                                }
                                newEmployees[employeeId] = thisEmployee;
                                totalSalary += (thisEmployee.totalSalary || 0);
                                totalDays += thisEmployee.totalDaysNoAbs;
                                // employeesIds.push(employeeId);
                            }
                        });
                        vm.operation.employees = newEmployees;
                        vm.operation.totalSalary = parseFloat(totalSalary.toFixed(6));
                        vm.operation.totalDays = parseFloat(totalDays.toFixed(6));
                        var halfAmount = vm.operation.totalAmount / 2;
                        var dayFactor = halfAmount / vm.operation.totalDays;
                        var salaryFactor = halfAmount / vm.operation.totalSalary;
                        vm.operation.dayFactor = parseFloat(dayFactor.toFixed(8));
                        vm.operation.salaryFactor = parseFloat(salaryFactor.toFixed(8));
                        if (!notShowLoading) {
                            $rootScope.loadingProgress = false;
                        }
                        resolve(true);
                        $rootScope.$evalAsync();
                        $timeout(function () { }, 0);
                    }).catch(function (error) {
                        if (!notShowLoading) {
                            errAlertS(error);
                        }
                        reject(error);
                        if (!notShowLoading) {
                            $rootScope.loadingProgress = false;
                        }
                        $rootScope.$evalAsync();
                        $timeout(function () { }, 0);
                    });
                } else {
                    resolve(true);
                }
            })

        }
        var removedEmployees = {}
        function removeEmployee(employeeId) {
            $log.log('eliminando empleado', employeeId);

            if (vm.operation.employees && vm.operation.employees[employeeId]) {
                delete vm.operation.employees[employeeId];
            }
            removedEmployees[employeeId] = true;
            calculateFactors();
        }
        function saveOperation(operation) {
            var operationId = angular.isDefined(vm.operation.$id) ? vm.operation.$id : $scope.F.root.child('catalogs/operations/ptuDistributionRecord').push().key;
            operation.specialDate = operation.specialDate ? operation.specialDate : moment().valueOf();
            operation.center = operation.center ? operation.center : AppF.center;
            operation.status = operation.status ? operation.status : 1;
            operation.payroll = operation.payroll ? operation.payroll : 'all';
            operation.created = operation.created ? operationId.created : $scope.D.getTimeObject();
            var updates = {};
            loopEachFilter(operation, function (value, key) {
                if (['$id', '_id', '$$hashKey'].indexOf(key) === -1) {
                    updates[key] = value;
                }
            })
            updates.created = DataF.getTimeObject();
            $log.log('updates', updates);
            $scope.F.root.child('catalogs/operations/ptuDistributionRecord/all/' + operationId).update(updates).then(function () {
                cancel();
                $scope.goToDetail({ $id: operationId, payroll: 'all', operationType: 'ptuDistributionRecord' });
                successAlertS('Se guardó los registros con éxito');
            }).catch(function (error) {
                cancel();
                $log.error('Ocurrió un error de' + error);
                errAlertS('Ocurrió un error al guardar los datos');
            });
        }
        vm.processesConfig = [];
        vm.payrollIncidences = [];
        vm.editEmployees = {};
        vm.cancel = cancel;
        vm.loadEmployees = loadEmployees;
        vm.loadIncidences = loadIncidences;
        vm.removeEmployee = removeEmployee;
        vm.calculateFactors = calculateFactors;
        vm.saveOperation = saveOperation;
        init();
    }
}
)();


(function () {
    'use strict';

    angular
        .module('app.clients')
        .controller('Operation4THController', Operation4THController);

    function Operation4THController(
        $scope,
        $rootScope,
        $state,
        $log,
        $q,
        errAlertS,
        AppF,
        $filter,
        $mdBottomSheet,
        $mdDialog,
        ListsF,
        DataF,
        CatalogsF,
        $timeout,
        successAlertS,
        $http,
        confirmConfig,
        $window,
        $document,
        startAfterInitFilter,
        confirmOperationS,
        billOperationS,
        ApiV3F,
        BankLayoutFlow
    ) {
        // si necesitas cargar catálogos de mongo pon sus nombres aquí
        var dataNeeded = ['subsidyRecords', 'isrRecords', 'cyvRecords', 'bankAccounts', 'paymentForms', 'banks', 'imssRecords', 'paymentFrequenciesRecords', 'directives', 'nfdRecords', 'placesOfWorkRecords', 'geoZones', 'states']; // ex: ['countries', 'states', 'regimes']
        var initiated = false;
        var $f = $filter;
        var backState = 'app.processes.operations';
        var watchers = {};
        var savingFastIncidences = {};
        var rejectIncidencesByEmployee = {};
        var processIncidencesByEmployee = {};
        var processIncidences = {};
        var firstIgnored = {};
        var dataUsedToCalc = {};
        var allEmployeesO = {};
        var opObjs = {};
        var incidenceTypeForPenDays;
        $scope.myPageOperation = 1;
        $scope.myPageFiscal = 1;
        $scope.myLimitOperation = 50;
        $scope.myLimitFiscal = 50;
        $scope.actionMessages = 'Iniciando..';
        $scope.operationProgress = 0;
        $scope.search = {};
        $scope.calculations = {};
        $scope.operationEmployeesFiltered = [];
        var operationEmployeesF = [];
        $scope.fastIncidences = {};
        $scope.rejectedIncidences = [];
        $scope.fiscalEmployeesFiltered = [];
        var fiscalEmployeesF = [];
        $scope.paginationOpe = [50];
        $scope.paginationFis = [50];
        $scope.selected = [];
        $scope.operationData = {};
        $scope.opStatusNotCalc = 3;
        $scope.order = ['data.enroleDate', 'data.name'];
        $scope.showProgress = true;
        $scope.employeesStatusByOp = {
            '1': {
                nextStatus: [1, 2, 3],
                status: 0
            },
            '2': {
                nextStatus: [2, 3],
                status: 1
            },
            '2.5': {
                nextStatus: [3],
                status: 2
            }
        };
        AppF.opstatusByEmployeeStatus = {
            '3': 3,
            '2': 2.5,
            '1': 2
        };
        AppF.notCalculate = false;
        AppF.calculationOfEmployee = {};
        AppF.operationData = {};
        var actionsQueue = [];
        $scope.executing = false;
        $scope.closeOperation = true;
        //INICIO DE LAS FUNCIONES
        function executeAction() {
            if (!$scope.executing && actionsQueue.length > 0) {
                $scope.executing = true;
                var promise;
                var action = actionsQueue[0][0];
                var fbData = actionsQueue[0][1];
                var executeCalculation = actionsQueue[0][2];
                var initTime = new Date().valueOf();
                $log.debug('Iniciando ' + action);
                try {
                    switch (action) {
                        case 'setVariablesOfOperation':
                            $scope.actionMessages = 'Estableciendo permisos de operación..';
                            setOperationVariables();
                            break;
                        case 'checkActionForThisOperation':
                            $scope.actionMessages = 'Escuchando cambios..';
                            var employeeId;
                            if (fbData.catalog === 'credits' && $scope.payrollId === fbData.data.payroll) {
                                employeeId = fbData.data.employee;
                                if (fbData.action === 'delete') {
                                    allEmployeesO[employeeId].creditData = undefined;
                                } else {
                                    allEmployeesO[employeeId].creditData = angular.fromJson(angular.toJson(fbData.data));
                                }
                            }
                            if (fbData.catalog === 'employees' && $scope.payrollId === fbData.data.payroll) {
                                employeeId = fbData.id;
                                opObjs.employees.fb[employeeId] = fbData.data;
                                opObjs.employees.fb[employeeId].$id = employeeId;
                                promise = addForAction('loadEmployees');
                            }
                            if (fbData.catalog === 'movements') {
                                var movement = fbData.data;
                                movement.$id = fbData.id;
                                validateMovement(movement, fbData.action);
                            }
                            break;
                        case 'setConceptsMap':
                            $scope.actionMessages = 'Generando conceptos..';
                            $f('setInObjectPath')('conceptsById.fb', opObjs, $filter('keyObjectAsKey')(opObjs.concepts.fb, '$id', undefined, 'order'), true, true);
                            var allConcepts = $filter('keyObjectAsKey')(opObjs.concepts.fb, 'key');
                            allConcepts = Object.assign(allConcepts, $filter('keyObjectAsKey')(opObjs.concepts.fb.filter(function (item) { return item.payroll === $scope.payrollId; }), 'key'));
                            $f('setInObjectPath')('conceptsByKey.fb', opObjs, allConcepts, true, true);
                            break;
                        case 'setPayrollOfEmployees':
                            $scope.actionMessages = 'Estableciendo datos de empleado..';
                            $f('loopEach')(allEmployeesO, function (employee, employeeId) {
                                if (employee.payroll === opObjs.payroll.fb.$id) {
                                    allEmployeesO[employeeId].payrollData = $f('clearObject')(opObjs.payroll.fb);
                                }
                            });
                            break;
                        case 'setThisBankAccounts':
                            $scope.actionMessages = 'Creando cuentas para este banco..';
                            $scope.thisBankAccounts = $filter('setThisBankAccounts')(opObjs.payroll.fb, $scope.operationType);
                            break;
                        case 'setOperationCcs':
                            $scope.actionMessages = 'Obteniendo centros de costo..';
                            $f('setInObjectPath')('employeesCcs.fb', opObjs, opObjs.myCcs.fb.filter(function (item) {
                                var thisPayroll = [];
                                if (angular.isArray(opObjs.operation.fb.payroll)) {
                                    thisPayroll = opObjs.operation.fb.payroll
                                }
                                return thisPayroll.indexOf(item.payroll) > -1
                            }), true, true);
                            $scope.employeesCcs = [];
                            if (operationEmployeesF.length > 0) {
                                var employeesCcs = [];
                                var ccs = opObjs.employeesCcs.fb;
                                for (var c = 0; c < ccs.length; c++) {
                                    for (var e = 0; e < operationEmployeesF.length; e++) {
                                        var filterCcs = operationEmployeesF[e].movements.filter(function (value) {
                                            return value.cc === ccs[c].$id
                                        });
                                        if (filterCcs.length > 0) {
                                            var exist = employeesCcs.filter(function (value) {
                                                return value.$id === ccs[c].$id;
                                            });
                                            if (exist.length === 0) employeesCcs.push(ccs[c]);
                                        }
                                    }
                                }
                                $scope.employeesCcs = employeesCcs;

                            }
                            break;
                        case 'setDispersion':
                            $scope.actionMessages = 'Leyendo información de la dispersion si existe..';
                            $f('setInObjectPath')('dispersion.fb', opObjs, $f('transformCalculations')(opObjs.dispersionF.fb), true, true);
                            break;
                        case 'setLastDispersion':
                            $scope.actionMessages = 'Leyendo información de la dispersion si existe..';
                            $f('setInObjectPath')('lastDispersion.fb', opObjs, $f('transformCalculations')(opObjs.lastDispersionF.fb), true, true);
                            break;
                        case 'setProccess':
                            $scope.actionMessages = 'Obteniendo esquema..';
                            $f('setInObjectPath')('processFromPayroll.fb', opObjs, $f('getProcessOfPayrollForSettlement')(undefined, opObjs.paymentSchema.fb, opObjs.dispersion.fb, opObjs.operation.fb.status >= $scope.opStatusNotCalc, undefined, opObjs.payroll.fb, $scope.operationType), true, true);
                            break;
                        case 'setIncidencesOfEmployees':
                            $scope.actionMessages = 'Generando sabana..';
                            $scope.defaultIncidences = $f('getDefaultIncidences')($scope.operationType, opObjs.operation.fb, opObjs.operation.fb.calendar, $f('getFromObject')(opObjs.period, 'fb.period'), opObjs.operation.fb.status >= $scope.opStatusNotCalc);
                            $f('setInObjectPath')('opIncidences.fb', opObjs, $f('getIncidencesOfSpecial')(opObjs.incidences.fb, $scope.defaultIncidences, [], $f('getFromObject')(opObjs, 'constantsIncidences.fb', []), $scope.operationId, $scope.operationType), true, true);
                            $f('setInObjectPath')('incidencesByEmployee.fb', opObjs, $f('groupByField')(opObjs.opIncidences.fb, 'employee', false, 'data.date'), true, true);
                            $f('setInObjectPath')('process.fb', opObjs, $f('getProcessForOperation')(opObjs.processFromPayroll.fb, opObjs.opIncidences.fb, opObjs.conceptsById.fb, processIncidences, operationEmployeesF, opObjs.dispersion.fb, opObjs.operation.fb.status >= 3), true, true);
                            $scope.process = opObjs.process.fb;
                            if (angular.isArray(operationEmployeesF)) {
                                for (var o = 0; o < operationEmployeesF.length; o++) {
                                    var employee = operationEmployeesF[o];
                                    var thisEmployeeId = employee.$id;
                                    allEmployeesO[thisEmployeeId].incidences = opObjs.incidencesByEmployee.fb[thisEmployeeId];
                                    allEmployeesO[thisEmployeeId].incidencesByType = $filter('groupByField')(opObjs.incidencesByEmployee.fb[thisEmployeeId], 'incidenceType', false, 'data.date');
                                    if (angular.isDefined(incidenceTypeForPenDays)) {
                                        if (allEmployeesO[thisEmployeeId].incidencesByType.hasOwnProperty(incidenceTypeForPenDays.$id)) {
                                            allEmployeesO[thisEmployeeId].pendingDaysIncidences = allEmployeesO[thisEmployeeId].incidencesByType[incidenceTypeForPenDays.$id];
                                        } else {
                                            allEmployeesO[thisEmployeeId].pendingDaysIncidences = []
                                        }

                                    }
                                }
                            }
                            break;
                        case 'setFastIncidencesTypes':
                            $scope.actionMessages = 'Obteniendo incidencias rápidas..';
                            $f('setInObjectPath')('incidencesTypes.fb', opObjs, $f('getConceptsForPayroll')(opObjs.concepts.fb, { 'type': 'incidenceType', 'allowManual': true, payroll: $scope.payrollId, process: $scope.operationType }), true, true);
                            $scope.incidencesTypes = opObjs.incidencesTypes.fb;
                            break;
                        case 'setEmployeesMovement':
                            $scope.actionMessages = 'Estableciendo movimientos..';
                            $f('setInObjectPath')('movementsByEmployee.fb', opObjs, $f('groupByField')(opObjs.movements.fb, 'employee', false, 'data.date'), true, true);
                            break;
                        case 'calculate':
                            $scope.actionMessages = 'Calculando empleados..';
                            if (opObjs.operation.fb.status >= $scope.opStatusNotCalc) {
                                $scope.actionMessages = 'Obteniendo cálculos de empleados..';
                            }
                            if (!AppF.notCalculate) {
                                promise = calculate();
                            }
                            break;
                        case 'reloadOperation':
                            if (opObjs.operation.fb.status <= 3) {
                                $log.log('se va a recargar');
                                $state.reload();
                            }
                            break;
                        case 'loadEmployees':
                            $scope.actionMessages = 'Obteniendo empleados para la sabana..';
                            promise = loadEmployees();
                            break;
                        case 'loadOtherOperationObjs':
                            $scope.actionMessages = 'Obteniendo datos..';
                            promise = $q(function (resolve, reject) {
                                ListsF.loadList('lastChange', 'settings/lastChange', undefined, 'object', 'latestActions').then(function (resp) {
                                    opObjs.latestCatalogActions = { fb: resp, watch: true, actions: ['checkActionForThisOperation'] };
                                    opObjs.operation.watch = true; //watch: true, actions: ['setVariablesOfOperation']
                                    opObjs.operation.actions = [{ action: 'reloadOperation', field: 'status' }, 'setVariablesOfOperation']; //watch: true, actions: ['setVariablesOfOperation']
                                    resolve(true);
                                }).catch(reject);
                            });
                            break;
                        case 'activeWatchers':
                            promise = activeWatchers();
                            break;
                    }
                    if (angular.isDefined(promise)) {
                        promise.then(function () {
                            $log.debug('Termino ' + action + ' en:' + ((new Date().valueOf()) - initTime) + 'ms');
                        }).catch(function (error) {
                            $log.error('Error en ' + action, error);
                        }).then(function () {
                            $scope.$evalAsync(function () {
                                finishCalculation(executeCalculation);
                            });
                        });
                    } else {
                        $log.debug('Termino ' + action + ' en:' + ((new Date().valueOf()) - initTime) + 'ms');
                        finishCalculation(executeCalculation);

                    }
                } catch (error) {
                    $log.error('Error en ' + action, error);
                    finishCalculation(executeCalculation);
                }
            } else {
                $scope.actionMessages = 'Todo listo...✓';
                $scope.firstFinished = true;
                $timeout(function () {
                    $scope.$evalAsync();
                    $timeout(function () {
                        $scope.showProgress = false;
                        $scope.actionMessages = '';
                        $scope.$evalAsync();
                    }, 1000, false);
                }, 0, false);
            }
        }
        function finishCalculation(executeCalculation) {
            var current = 0;
            if ($scope.operationProgress < 100) {
                current = $scope.operationProgress;
            }
            var missing = 100 - current;
            var thisProgress = missing / actionsQueue.length;
            $scope.operationProgress = current + thisProgress;
            actionsQueue.shift();
            $scope.executing = false;
            if (executeCalculation && !AppF.notCalculate) {
                addForAction('calculate');
            }
            $timeout(function () {
                executeAction();
            }, 0, false); //false to not run another digest

        }
        function addForAction(action, fbData, executeCalculation, notExecute) {
            var indexAction = actionsQueue.findIndex(function (item) {
                return item[0] === action;
            });
            if (indexAction <= 0) {
                actionsQueue.push([action, fbData, executeCalculation]);
                if (!notExecute) {
                    executeAction();
                }
            }
        }
        $scope.directCancel = function (uuid, ev) {
            $mdDialog.show($mdDialog
                .confirm(confirmConfig)
                .title('¿Desea cancelar la factura?')
                .htmlContent('Se va a cancelar la factura que no se puedo cancelar en el re timbrado anterior')
                .ariaLabel('Deleting')
                .targetEvent(ev)
                .ok('SI')
                .cancel('NO'))
                .then(function () {
                    cancelThisBill(uuid);
                }, function () {
                    $log.debug('Deleting Cancelled');
                });
        };
        function calculate() {
            return $q(function (resolve) {
                $timeout(function () {
                    $f('loopEach')(processIncidences, function (data, key) {
                        processIncidences[key] = {};
                    });
                    $scope.rejectedIncidences = [];
                    if (angular.isUndefined($scope.fastIncidences)) {
                        $scope.fastIncidences = {};
                    }
                    var auxProccess = opObjs.process.fb.filter(function (item) {
                        return item.id !== 'real' && item.id !== 'rejectedIncidences' && item.id !== 'others';
                    });

                    var msg = [];
                    $scope.hasErrors = false;
                    for (var o = 0; o < operationEmployeesF.length; o++) {
                        var employee = allEmployeesO[operationEmployeesF[o].$id];
                        var employeeId = employee.$id;
                        employee.processes = auxProccess;
                        if (!employee.isClosed) {
                            var calcData = $filter('calculateEmployee')(
                                employee,
                                $scope.calculations[employeeId],
                                dataUsedToCalc[employeeId],
                                $scope.fastIncidences[employeeId],
                                rejectIncidencesByEmployee[employeeId],
                                processIncidencesByEmployee[employeeId],
                                opObjs);
                            if (angular.isDefined(calcData.calculations)) {
                                if (angular.isUndefined($scope.calculations[employeeId])) {
                                    $scope.calculations[employeeId] = {};
                                }
                                $scope.calculations[employeeId] = calcData.calculations;
                                dataUsedToCalc[employeeId] = calcData.dataUsedToCalc;
                                $scope.fastIncidences[employeeId] = calcData.fastIncidences;
                                rejectIncidencesByEmployee[employeeId] = calcData.rejectedIncidences;
                                $scope.rejectedIncidences = $scope.rejectedIncidences.concat(rejectIncidencesByEmployee[employeeId]);
                                processIncidencesByEmployee[employeeId] = calcData.processIncidences;
                                $f('loopEach')(calcData.processIncidences, function (employeeIncidences, operationKey) {
                                    if (angular.isUndefined(processIncidences[operationKey])) {
                                        processIncidences[operationKey] = {};
                                    }
                                    processIncidences[operationKey] = Object.assign(processIncidences[operationKey], employeeIncidences);
                                });
                            }
                            if (angular.isObject(calcData) && calcData !== null && calcData.error && angular.isString(calcData.msg)) {
                                msg.push(calcData.msg);
                            }
                        } else {
                            var closeCalculations = $f('getFromObject')(opObjs.dispersion.fb, 'employeesData.calculations.' + employeeId, {});
                            $f('loopEach')(closeCalculations, function (data, key) {
                                if (data.fiscalValue) {
                                    if (angular.isUndefined(processIncidences.fiscal)) {
                                        processIncidences.fiscal = {};
                                    }
                                    if (angular.isUndefined(processIncidences.fiscal[data.conceptId])) {
                                        processIncidences.fiscal[data.conceptId] = {
                                            conceptId: data.conceptId,
                                            conceptKey: key,
                                            isFiscal: true,
                                            name: data.name,
                                            nature: opObjs.conceptsById.fb[data.conceptId] ? opObjs.conceptsById.fb[data.conceptId].nature : ''
                                        };
                                    }

                                }
                                if (data.socialPrevisionValue) {
                                    if (angular.isUndefined(processIncidences.socialPrevision)) {
                                        processIncidences.socialPrevision = {};
                                    }
                                    if (angular.isUndefined(processIncidences.socialPrevision[data.conceptId])) {
                                        processIncidences.socialPrevision[data.conceptId] = {
                                            conceptId: data.conceptId,
                                            conceptKey: key,
                                            name: data.name,
                                            nature: opObjs.conceptsById.fb[data.conceptId] ? opObjs.conceptsById.fb[data.conceptId].nature : ''
                                        };
                                    }

                                }
                            });
                        }
                    }
                    $scope.calculations = Object.assign($scope.calculations, $f('getFromObject')(opObjs.dispersion.fb, 'employeesData.calculations', {}));
                    $log.log(angular.fromJson(angular.toJson($scope.calculations)));
                    $f('loopEach')($f('getFromObject')(opObjs.dispersion.fb, 'employeesData.rejectedIncidences', {}), function (employeeIncidences, employeeId) {
                        $f('loopEach')(employeeIncidences, function (rejectInc) {
                            var incidence = {
                                conceptId: rejectInc.i,
                                conceptKey: rejectInc.k,
                                name: rejectInc.n,
                                qty: rejectInc.v,
                                employeeId: employeeId,
                                employeeName: $f('getFromObject')(allEmployeesO[employeeId], 'data.name', 'SIN NOMBRE')
                            };
                            $scope.rejectedIncidences.push(incidence);
                        });
                    });
                    if (msg.length > 0) {
                        $scope.hasErrors = true;
                        var text = '<h4>Se encontraron algunos errores en los cálculos de los empleados</h4><ul>';
                        for (var m = 0; m < msg.length; m++) {
                            text += '<li>' + msg[m] + '</li>';
                        }
                        text += '</ul>';
                        errAlertS(text);
                    }
                    if (opObjs.operation.fb.status < 3) {
                        opObjs.process.fb = $f('getProcessForOperation')(opObjs.processFromPayroll.fb, opObjs.opIncidences.fb, opObjs.conceptsById.fb, processIncidences, operationEmployeesF);
                        $scope.process = opObjs.process.fb;
                    }
                    $scope.operationTotals = $f('getTotalsOfOperations')($scope.calculations, opObjs.process.fb, opObjs.conceptsById.fb, auxProccess, opObjs.dispersion.fb, opObjs.operation.fb.status >= $scope.opStatusNotCalc);
                    $scope.$evalAsync();
                    $timeout(function () {
                        resolve(true);
                    }, 0, false)
                }, 0, false);
            });
        }
        var lastValueToCheck = {};
        function setWatcher(objData, objName) {
            $filter("setOperationWatcher")(objData, objName, lastValueToCheck, $scope, addForAction, watchers, firstIgnored)
        }
        function activeWatchers() {
            var promises = [];
            $f('loopEach')(opObjs, function (objData, objName) {
                promises.push(setWatcher(objData, objName));
            });
            return $q.all(promises);
        }
        function getConstantsIncidences() {
            var constants = [];
            if ($scope.operationType !== 'ptuDistributionRecord') {
                constants = $f('getConstantsIncidences')(operationEmployeesF, allEmployeesO, $scope.calendarId, opObjs.operation.fb.period, $scope.payrollId, $scope.refs.incidences, opObjs.conceptsById.fb, $scope.operationType, opObjs.operation.fb.$id, $filter('getFromObject')(opObjs.operation, 'fb', {}), $filter('getFromObject')(opObjs.lastOperation, 'fb', {}));
            }
            return constants;
        }
        function getAllEmployees(movementsGrouped) {
            return $q(function (resolve, reject) {
                var pendingToGet = [];
                var employeeData = $f('getFromObject')(opObjs.employees, 'fb', {});
                $f('loopEach')(movementsGrouped, function (data, employeeId) {
                    if (!employeeData.hasOwnProperty(employeeId)) {
                        if (pendingToGet.length < 50) {
                            pendingToGet.push(employeeId);
                        }
                    }
                });
                var query = [];
                if (pendingToGet.length > 0) {
                    var employeesDataQuery = {
                        page: 0.5,
                        size: 0.5,
                        'fid': {
                            '$in': pendingToGet
                        }
                    };
                    query.push($rootScope.D.api.get('p/employees', employeesDataQuery));
                }
                Promise.all(query).then(function (resp) {
                    if (resp.length > 0) {
                        var employeeData = $f('getFromObject')(resp[0], 'data.data', []);
                        for (var e = 0; e < employeeData.length; e++) {
                            if (angular.isUndefined(opObjs.employees)) {
                                opObjs.employees = {};
                            }
                            if (angular.isUndefined(opObjs.employees.fb)) {
                                opObjs.employees.fb = {};
                            }
                            opObjs.employees.fb[employeeData[e].fid] = employeeData[e];
                            opObjs.employees.fb[employeeData[e].fid].$id = employeeData[e].fid;
                        }
                        var thisEmployeeData = $f('getFromObject')(opObjs.employees, 'fb', {});
                        for (var p = 0; p < pendingToGet.length; p++) {
                            if (angular.isUndefined(thisEmployeeData[pendingToGet[p]])) {
                                if (angular.isUndefined(opObjs.employees)) {
                                    opObjs.employees = {};
                                }
                                if (angular.isUndefined(opObjs.employees.fb)) {
                                    opObjs.employees.fb = {};
                                }
                                opObjs.employees.fb[pendingToGet[p]] = {};
                                opObjs.employees.fb[pendingToGet[p]].$id = pendingToGet[p];
                            }
                        }
                    }
                    if (pendingToGet.length > 0) {
                        resolve(getAllEmployees(movementsGrouped));
                    } else {
                        resolve(opObjs.employees.fb);
                    }
                }).catch(reject);
            });
        }
        function loadEmployees() {
            return $q(function (resolve, reject) {
                var movementsGrouped;
                movementsGrouped = opObjs.operation.fb.employees;
                var employeeProcess = opObjs.processFromPayroll.fb.filter(function (item) {
                    return (item.id !== 'real' && item.id !== 'rejectedIncidences');
                }).map(function (item) {
                    return { id: item.id, name: item.name, realId: item.realId };
                });
                var cleanedObjs = {
                    period: $filter('getFromObject')(opObjs.period, 'fb'),
                    ccs: $filter('getFromObject')(opObjs.employeesCcs, 'fb'),
                    payroll: $filter('getFromObject')(opObjs.payroll, 'fb'),
                    paymentFrequency: $filter('getFromObject')(opObjs.paymentFrequency, 'fb'),
                    nfdRecords: $filter('clearObject')($scope.M.nfdRecords),
                    imssRecordData: $filter('getIMSSRowLast')($scope.calendarId, $scope.M.imssRecords),
                    cyvRecordsData: $filter('clearObject')(opObjs.getCyvTable.fb),
                    minimumWageRecords: $filter('clearObject')(opObjs.minimumWageRecords.fb),
                    employeeProcess: employeeProcess
                };
                getAllEmployees(movementsGrouped).then(function () {
                    var promises = {};
                    $f('loopEach')(movementsGrouped, function (movements, employeeId) {
                        var employeeStatus = $f('getFromObject')(opObjs.operation.fb, 'employees.' + employeeId + '.status');
                        promises[employeeId] = $f('getEmployeeForSpecial')(
                            employeeId,
                            opObjs.operation.fb.status >= $scope.opStatusNotCalc ? [movements] : opObjs.movementsByEmployee.fb[employeeId],
                            $scope.payrollId,
                            employeeStatus >= 3,
                            $scope.calendarId,
                            opObjs,
                            cleanedObjs,
                            $scope.operationType === 'chrisBonusRecord' ? false : true,
                            $scope.operationType
                        );
                    });
                    $q.all(promises).then(function (resp) {
                        allEmployeesO = resp;
                        var allEmployees = {};
                        var fiscalEmployees = [];
                        var operationEmployees = [];
                        var msg = [];
                        var oldOpEmpObj = angular.isDefined(opObjs.operation.fb) && angular.isDefined(opObjs.operation.fb.employees) ? opObjs.operation.fb.employees : {};
                        var newOpEmpObj = {};
                        $f('loopEach')(resp, function (employeeData, employeeId) {
                            newOpEmpObj[employeeId] = oldOpEmpObj[employeeId] ? oldOpEmpObj[employeeId] : {};
                            if (angular.isObject(employeeData)) {
                                var objsToWatch = employeeData.objsToWatch;
                                delete employeeData.objsToWatch;
                                allEmployees[employeeId] = employeeData;
                                var employeeObj = {
                                    '$id': employeeData.$id,
                                    'data': {
                                        'name': employeeData.data.name,
                                        'enroleDate': employeeData.data.enroleDate
                                    },
                                    movements: employeeData.movements
                                };
                                if (employeeData.forOperation) {
                                    if (employeeData.isFiscal) {
                                        fiscalEmployees.push(employeeObj);
                                    }
                                    operationEmployees.push(employeeObj);
                                }
                                newOpEmpObj[employeeId].cc = employeeData.movements[0].cc || null;
                                newOpEmpObj[employeeId].rp = employeeData.movements[0].rp || null;
                                $f('loopEach')(objsToWatch, function (obj, index) {
                                    if (!opObjs.hasOwnProperty(index)) {
                                        opObjs[index] = obj;
                                    }
                                });
                            } else if (angular.isString(employeeData)) {
                                msg.push(employeeData);
                            }
                            newOpEmpObj[employeeId].status = angular.isDefined(oldOpEmpObj[employeeId]) && angular.isDefined(oldOpEmpObj[employeeId].status) ? oldOpEmpObj[employeeId].status : 0;
                        });
                        if (opObjs.operation.fb.status < 3) {
                            opObjs.operation.fb.employees = newOpEmpObj;
                            opObjs.operation.fb.version = 2.0;
                        }
                        if (msg.length > 0) {
                            var text = '<h4>Se encontraron algunos problemas con los empleados</h4><ul>';
                            for (var m = 0; m < msg.length; m++) {
                                text += '<li>' + msg[m] + '</li>';
                            }
                            text += '</ul>';
                            errAlertS(text);
                        }
                        fiscalEmployeesF = fiscalEmployees;
                        operationEmployeesF = operationEmployees;
                        allEmployeesO = allEmployees;
                        $scope.filterEmployees();
                        var promises = [];
                        if (opObjs.operation.fb.status < 3) {
                            promises.push(opObjs.operation.fb.$save());
                        }
                        $log.log(allEmployeesO);
                        Promise.all(promises).then(function () {
                            if (angular.isUndefined(opObjs.constantsIncidences)) {
                                opObjs.constantsIncidences = { watch: true, actions: ['setIncidencesOfEmployees'] };
                            }
                            opObjs.constantsIncidences.fb = getConstantsIncidences();
                            addForAction('setIncidencesOfEmployees', opObjs.incidences.fb, false, true);
                            addForAction('calculate');
                            setOperationVariables();
                            resolve(true);
                        });
                    }).catch(function (error) {
                        reject(error);
                    });
                }).catch(reject);
            });
        }
        function moveEmployees(action, comments, periodSelected, paymentDate, pendingEmployees, newCalendar) {
            return $q(function (resolve, reject) {
                turnOffWatchers();
                var employeeStatus = $scope.nextEmployeeStatus;
                var incidenceStatus = $scope.nextIncidenceStatus;
                var operationStatus = $scope.nextOperationStatus;
                var operation = opObjs.operation.fb;
                var dispersionId = (angular.isDefined(operation) && angular.isDefined(operation.dispersion)) ? operation.dispersion : AppF.root.child($scope.refs.dispersion).push().key;
                var employees = (angular.isArray(pendingEmployees) && pendingEmployees.length > 0) ? pendingEmployees : operationEmployeesF;
                if (angular.isDefined(action) && (action === 'moveBackOperation' || action === 'reOpenClosed')) {
                    employeeStatus = $scope.previousEmployeeStatus;
                    incidenceStatus = $scope.previousIncidencesStatus;
                    operationStatus = $scope.previousOperationStatus;
                }
                var onlyPrevision;
                var fiscal = opObjs.process.fb.find(function (value) {
                    return value.id === "fiscal";
                });
                if (operationStatus >= 3 && ($scope.fiscalEmployees.length === 0 || !fiscal)) {
                    onlyPrevision = true;
                }
                var updates = {};
                updates[$scope.refs.operations + '/' + operation.$id + '/dispersion'] = dispersionId;
                if (comments !== '') {
                    updates[$scope.refs.operations + '/' + operation.$id + '/comments'] = comments;
                }
                AppF.root.update(updates).then(function () {
                    var data = {
                        employees: employees,
                        opObjs: opObjs,
                        refs: $scope.refs,
                        calculations: $scope.calculations,
                        dispersionId: dispersionId,
                        fiscalEmployees: $scope.fiscalEmployees,
                        allEmployeesO: allEmployeesO,
                        employeeStatus: employeeStatus,
                        onlyPrevision: onlyPrevision,
                        operation: operation,
                        operationStatus: operationStatus,
                        incidenceStatus: incidenceStatus,
                        action: action,
                        operationType: $scope.operationType,
                        periodSelected: periodSelected,
                        calendar: newCalendar
                    };
                    return $f('moveEmployees')(data);
                    // var promises = [];
                    // var extra = {};
                    // var operationObj = {
                    //     fiscal: {
                    //         exist: false
                    //     },
                    //     socialPrevision: {
                    //         exist: false
                    //     }
                    // };
                    // if (operationStatus >= 3) {
                    //     var process = opObjs.process.fb;
                    //     for (var p = 0; p < process.length; p++) {
                    //         if (process[p].id === 'fiscal' && $scope.fiscalEmployees.length > 0 && angular.isDefined(process[p].companiesRecord)) {
                    //             operationObj.fiscal.exist = true;
                    //             operationObj.fiscal.companiesRecord = process[p].companiesRecord;
                    //         }
                    //         if (process[p].id === 'socialPrevision' && angular.isDefined(process[p].companiesRecord)) {
                    //             operationObj.socialPrevision.exist = true;
                    //             operationObj.socialPrevision.companiesRecord = process[p].companiesRecord;
                    //         }
                    //     }
                    // }
                    // for (var e = 0; e < employees.length; e++) {
                    //     var thisDispersion = $f('getFromObject')(opObjs.dispersion.fb, 'employees.' + employees[e].$id);
                    //     var thisEmployee = allEmployeesO[employees[e].$id];
                    //     if (operationStatus >= 3) {
                    //         extra = {
                    //             companiesRecords: [],
                    //             accuDate: periodSelected.accuDate,
                    //             period: periodSelected.period,
                    //             calendar: newCalendar,
                    //             operationId: operation.$id,
                    //             operationType: $scope.operationType,
                    //             specialDate: operation.specialDate,
                    //             specialPeriod: operation.specialPeriod
                    //         }
                    //         if (operationObj.fiscal.exist) {
                    //             var exist = $scope.fiscalEmployees.find(function (value) {
                    //                 return value.$id === employees[e].$id;
                    //             });
                    //             if (angular.isDefined(exist)) {
                    //                 extra.companiesRecords.push({ opType: 'fiscal', companiesRecordId: operationObj.fiscal.companiesRecord });
                    //                 extra.companiesRecord = operationObj.fiscal.companiesRecord;
                    //             }
                    //         }
                    //         if (operationObj.socialPrevision.exist) {
                    //             extra.companiesRecords.push({ opType: 'socialPrevision', companiesRecordId: operationObj.socialPrevision.companiesRecord });
                    //             if (angular.isUndefined(extra.companiesRecord)) {
                    //                 extra.companiesRecord = operationObj.socialPrevision.companiesRecord;
                    //             }
                    //         }
                    //     }
                    //     if ((operationStatus >= 3 && angular.isUndefined(thisDispersion) && operation.employees[employees[e].$id].status < 5) || (operationStatus < 3 && operation.employees[employees[e].$id].status !== employeeStatus)) {
                    //         var statusOp = employeeStatus;
                    //         if (onlyPrevision) {
                    //             statusOp = 5;
                    //         }
                    //         promises.push($filter('moveEmployee')(operation, thisEmployee, $scope.calculations[employees[e].$id], dispersionId, statusOp, incidenceStatus, operationStatus, $scope.refs, undefined, undefined, undefined, undefined, undefined, undefined, action, extra, opObjs.period.fb, $scope.operationType));
                    //     }
                    // }
                    // return Promise.all(promises);
                }).then(function (response) {
                    return new Promise(function (resolve, reject) {
                        var thisPromises = [];
                        if (angular.isDefined(opObjs.operation.fb.dispersion)) {
                            thisPromises.push(ListsF.loadList('dispersions', $scope.refs.dispersion + '/' + opObjs.operation.fb.dispersion, undefined, 'object', 'dispersion-' + opObjs.operation.fb.dispersion));
                        }
                        Promise.all(thisPromises).then(function (resp) {
                            if (resp.length > 0 && angular.isObject(resp[0]) && resp[0] !== null) {
                                $f('setInObjectPath')('dispersion.fb', opObjs, $f('transformCalculations')(resp[0]), true, true);
                            }
                            var exists = (response.indexOf(false) !== -1) ? true : false;
                            if (exists) {
                                reject('No se pudo completar el cierre');
                            } else {
                                resolve(true);
                            }
                        });
                    });
                }).then(function () {
                    var updates = {};
                    var allEmployees = opObjs.operation.fb.employees;
                    var changeStatus = true;
                    for (var key in allEmployees) {
                        if (allEmployees[key].status < incidenceStatus) {
                            changeStatus = (action === 'moveBackOperation' || action === 'reOpenClosed') ? true : false;
                            break;
                        }
                    }
                    $log.log(changeStatus, incidenceStatus);
                    if (changeStatus || action === 'closePartial') {
                        updates[$scope.refs.operations + '/' + operation.$id + '/status'] = (!onlyPrevision) ? operationStatus : 7;
                    }
                    if (operationStatus >= 3) {
                        if ($scope.fiscalEmployees.length === 0) {
                            var findIndex = opObjs.process.fb.findIndex(function (value) {
                                return value.id === 'fiscal';
                            });
                            if (findIndex > -1) {
                                delete opObjs.process.fb[findIndex].companiesRecord;
                            }
                        }
                        var process = $f('clearObject')(opObjs.process.fb);
                        var obj = {
                            originalPeriod: opObjs.period.fb.period,
                            originalCalendar: parseInt(operation.calendar),
                            period: periodSelected.period,
                            calendar: newCalendar,
                            accuDate: periodSelected.accuDate,
                            payroll: operation.payroll,
                            process: process,
                            operationType: $scope.operationType
                        };
                        updates[$scope.refs.dispersion + '/' + dispersionId + '/data'] = obj;
                        updates[$scope.refs.dispersion + '/' + dispersionId + '/operation'] = operation.$id;
                        updates[$scope.refs.dispersion + '/' + dispersionId + '/status'] = 0;
                        updates[$scope.refs.dispersion + '/' + dispersionId + '/total'] = $scope.operationTotals;
                        updates[$scope.refs.operations + '/' + operation.$id + '/accuPeriod'] = periodSelected.period;
                        updates[$scope.refs.operations + '/' + operation.$id + '/accuCalendar'] = newCalendar;
                    }
                    if (action === 'reOpenClosed' && operationStatus === 2.5) {
                        $log.log('catalogs/dispersions/collection/' + dispersionId);
                        if (angular.isUndefined(pendingEmployees)) {
                            updates[$scope.refs.dispersion + '/' + dispersionId] = null;
                            updates[$scope.refs.operations + '/' + operation.$id + '/dispersion'] = null;
                        }
                    }
                    $log.log('Se actualizo status de operación');
                    return AppF.root.update(updates);
                }).then(function () {
                    var statusName = $filter('operationStatusNameModal')(operationStatus);
                    successAlertS('Status de Operación actualizada a ' + statusName.name);
                    setOperationVariables();
                    addForAction('activeWatchers', undefined, false, true);
                    resolve(true);
                }).catch(function (error) {
                    setOperationVariables();
                    addForAction('activeWatchers', undefined, false, true);
                    reject(error);
                });
            });
        }
        $scope.downloadBill = function (selected) {
            if (angular.isArray(selected) && selected.length > 0) {
                for (var e = 0; e < selected.length; e++) {
                    var billId = $filter('getFromObject')($scope.operation.employees, selected[e].$id + ".billId");
                    if (angular.isUndefined(billId)) {
                        errAlertS('El empleado ' + allEmployeesO[selected[e].$id].data.name + ' no tiene el recibo');
                    } else {
                        $rootScope.D.api.get("one/bills/", { "uuid": billId, project: angular.toJson({ "Comprobante.Total": 1 }) }).then(function (resp) {
                            var bill = resp.data;
                            if (bill.success && bill.data.length > 0 && bill.data[0]['Comprobante']) {
                                var amount = bill.data[0]['Comprobante']['Total'];
                                var total = $filter('convertNumberToString')(amount);
                                var params = {
                                    total: total,
                                    billId: bill.data[0]._id
                                }
                                downloadFile("interface/pdf/operation/invoice", params);
                            } else {
                                errAlertS("No se encontró datos de la factura");
                            }
                        }).catch(function (error) {
                            errAlertS(error);
                        })
                    }
                }
            } else {
                errAlertS("No se selecciono ningún empleado")
            }
        }
        function downloadFile(path, params) {
            $rootScope.loadingProgress = true;
            $http({
                method: 'POST',
                url: window.__env.serviceWorkerUrl + path,
                responseType: 'arraybuffer',
                data: params
            }).then(function (response) {
                var headers = response.headers();
                var filename = headers['x-filename'];
                var contentType = headers['content-type'];
                var linkElement = document.createElement('a');
                try {
                    var blob = new Blob([response.data], {
                        type: contentType
                    });
                    var url = window.URL.createObjectURL(blob);
                    linkElement.setAttribute('href', url);
                    linkElement.setAttribute("download", filename);
                    var clickEvent = new MouseEvent("click", {
                        "view": window,
                        "bubbles": true,
                        "cancelable": false
                    });
                    linkElement.dispatchEvent(clickEvent);
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync(function () {
                        $log.debug('generatePdf finished');
                    });
                } catch (ex) {
                    $log.error(ex, "error descargando el archivo");
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                }
            }).catch(function (err) {
                var message = new TextDecoder("utf-8").decode(err.data);
                var error = angular.fromJson(message);
                errAlertS(error.data || error.message);
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
            });
        }
        $scope.downloadZipBill = function (selected) {
            $rootScope.loadingProgress = true;
            if (angular.isUndefined(selected) || selected.length == 0) {
                selected = $scope.fiscalEmployees;
            }
            var totalPromises = [];
            var billsData = [];
            var employeeNumbers = [];
            for (var e = 0; e < selected.length; e++) {
                var billUid = $filter('getFromObject')($scope.operation.employees, selected[e].$id + ".billId");
                var status = $filter('getFromObject')($scope.operation.employees, selected[e].$id + ".status");
                if (angular.isUndefined(billUid)) {
                    if (status < 5) {
                        errAlertS('El empleado ' + allEmployeesO[selected[e].$id].data.name + ' no tiene el recibo');
                    }
                } else {
                    employeeNumbers.push(allEmployeesO[selected[e].$id].data.employeeNumber)
                    billsData.push({
                        employeeId: selected[e].$id,
                        bucketUrl: $filter('getFromObject')($scope.operation.employees, selected[e].$id + ".xmlUrl"),
                        fileName: $filter('getFromObject')($scope.operation.employees, selected[e].$id + ".fileName")
                    });
                    totalPromises.push($rootScope.D.api.get("one/bills/", { "uuid": billUid, project: angular.toJson({ "Comprobante.Total": 1 }) }));
                }
            }
            if (totalPromises.length > 0) {
                Promise.all(totalPromises).then(function (totalsResp) {
                    var employees = {};
                    if (selected.length > 0 && totalsResp.length === 0) {
                        throw "No se encontró los datos de la factura solicitado";
                    }
                    var employeeNumber = '';
                    if (employeeNumbers.length === 1) {
                        employeeNumber = '_' + employeeNumbers[0];
                    }
                    for (var t = 0; t < totalsResp.length; t++) {
                        billsData[t].total = $filter('convertNumberToString')(totalsResp[t].data.data[0]['Comprobante']['Total']);
                        billsData[t].billId = totalsResp[t].data.data[0]._id;
                        employees[billsData[t].employeeId] = billsData[t];
                    }
                    var thisCalendar = $filter('getFromObject')(opObjs.operation.fb, 'calendar') ? '_' + opObjs.operation.fb.calendar : '';
                    var thisPeriod = $filter('getFromObject')(opObjs.operation.fb, 'specialPeriod') ? '_' + $filter('zeroFill')(opObjs.operation.fb.specialPeriod, 3) : '';
                    var thisCenter = AppF.center.toUpperCase();
                    var thisFileName = thisCenter + thisCalendar + '_' + opObjs.payroll.fb.data.class + '_' + AppF.opeFilesName[$scope.operationType].fiscal + thisPeriod + employeeNumber;
                    var params = {
                        dispersionId: opObjs.operation.fb.dispersion,
                        operationId: opObjs.operation.fb.$id,
                        opType: $scope.operationType,
                        filename: thisFileName
                    }
                    if (selected.length > 0) {
                        params.employees = angular.toJson(employees);
                    }
                    downloadFile('models/bill/getBillZipAll', params);
                }).catch(function (error) {
                    errAlertS(error);
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                })
            } else {
                $rootScope.loadingProgress = false;
                errAlertS("No hay datos para importar")
            }

        }
        $scope.downloadZipBillOld = function (selected) {
            $rootScope.loadingProgress = true;
            if (selected.length == 0) {
                selected = $scope.fiscalEmployees;
            }
            var totalPromises = [];
            var billsData = [];
            for (var e = 0; e < selected.length; e++) {
                var billUid = $filter('getFromObject')($scope.operation.employees, selected[e].$id + ".billId");
                if (angular.isUndefined(billUid)) {
                    errAlertS('El empleado ' + allEmployeesO[selected[e].$id].data.name + ' no tiene el recibo');
                } else {
                    billsData.push({
                        employeeId: selected[e].$id,
                        bucketUrl: $filter('getFromObject')($scope.operation.employees, selected[e].$id + ".xmlUrl"),
                        fileName: $filter('getFromObject')($scope.operation.employees, selected[e].$id + ".fileName")
                    });
                    totalPromises.push($rootScope.D.api.get("one/bills/", { "uuid": billUid, project: angular.toJson({ "Comprobante.Total": 1 }) }));
                }
            }
            var decodeError = false;
            Promise.all(totalPromises).then(function (totalsResp) {
                var requestPromises = [];
                for (var t = 0; t < totalsResp.length; t++) {
                    billsData[t].total = $filter('convertNumberToString')(totalsResp[t].data.data[0]['Comprobante']['Total']);
                    billsData[t].billId = totalsResp[t].data.data[0]._id;
                    requestPromises.push($http({ method: 'POST', url: $window.__env.serviceWorkerUrl + 'models/bill/getBillZip', responseType: 'arraybuffer', data: billsData[t] }))
                }
                decodeError = true;
                return Promise.all(requestPromises);
            }).then(function (responses) {
                decodeError = false;
                for (var r = 0; r < responses.length; r++) {
                    var response = responses[r];
                    var headers = response.headers();
                    var filename = headers['x-filename'];
                    var contentType = headers['content-type'];
                    var linkElement = document.createElement('a');
                    try {
                        var blob = new Blob([response.data], {
                            type: contentType
                        });
                        var url = $window.URL.createObjectURL(blob);
                        linkElement.setAttribute('href', url);
                        linkElement.setAttribute("download", filename);
                        var clickEvent = new MouseEvent("click", {
                            "view": window,
                            "bubbles": true,
                            "cancelable": false
                        });
                        linkElement.dispatchEvent(clickEvent);
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync(function () {
                            $log.debug('generatePdf finished');
                        });
                    } catch (ex) {
                        $log.error(ex, "error descargando el archivo");
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync();
                    }
                }
            }).catch(function (error) {
                $log.error(error);
                if (decodeError) {
                    var message = new TextDecoder("utf-8").decode(error.data);
                    error = angular.fromJson(message).data;
                }
                errAlertS(error);
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
            })
        }
        $scope.moveAccuCompanies = function (ev) {
            $mdDialog.show({
                templateUrl: 'app/main/clients/views/newoperation/dialogs/companiesRecords.html',
                controller: function (scope, ListsF) {
                    scope.L = ListsF;
                    scope.confirm = function () {
                        $http.get(window.__env.serviceWorkerUrl + 'moveAccumulated/' + opObjs.operation.fb.$id + '/' + scope.companiesRecordId).then(function () {
                            $mdDialog.cancel();
                            successAlertS('Se movieron los acumulados')
                        }).catch(errAlertS);
                    };
                    scope.cancel = function () {
                        $mdDialog.cancel();
                    };
                },
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            });
        }
        $scope.downloadBills = function (ev, employees, billType) {
            if (angular.isArray(employees) && employees.length > 0) {
                $mdDialog.show({
                    templateUrl: 'app/main/clients/views/newoperation/dialogs/downloadBillConfirmation.html',
                    controller: function () {
                        var vm = this;
                        var billTypes = {
                            'prevision': 'Complemento',
                            'billNoBilled': 'Fiscal Provisional'
                        };
                        vm.billType = billTypes[billType];
                        vm.employeesCount = employees.length;
                        vm.cancel = $mdDialog.cancel;
                        vm.confirm = function (withCopy) {
                            var employeesIds = employees.map(function (item) {
                                return item.$id;
                            });
                            var url;
                            var params = {
                                employees: employeesIds,
                                dispersionId: opObjs.operation.fb.dispersion,
                                opType: $scope.operationType
                            };
                            if (billType === 'prevision') {
                                url = 'interface/pdf/operations/billPrevision';
                                params.operationId = opObjs.operation.fb.$id;
                                params.loop = withCopy ? 2 : 1;
                            } else {
                                var thisCalendar = $filter('getFromObject')(opObjs.operation.fb, 'calendar') ? '_' + opObjs.operation.fb.calendar : '';
                                var thisPeriod = $filter('getFromObject')(opObjs.operation.fb, 'specialPeriod') ? '_' + $filter('zeroFill')(opObjs.operation.fb.specialPeriod, 3) : '';
                                var thisCenter = AppF.center.toUpperCase();
                                var thisFileName = thisCenter + thisCalendar + '_' + opObjs.payroll.fb.data.class + '_' + AppF.opeFilesName[$scope.operationType].fiscal + '_SIMPLE' + thisPeriod;
                                url = 'interface/pdf/operation/invoiceNoBilled';
                                params.filename = thisFileName;
                                params.withCopy = withCopy;
                            }
                            downloadFile(url, params);
                            $mdDialog.hide();
                        };
                    },
                    controllerAs: 'downloadBillCtrl',
                    parent: angular.element($document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true
                });
            } else {
                errAlertS('No se selecciono ningún empleado');
            }
        };
        $scope.checkAccount = function (ev, action) {
            var employeeProcess = opObjs.processFromPayroll.fb.filter(function (item) {
                return (item.id !== 'real' && item.id !== 'rejectedIncidences');
            }).map(function (item) {
                return { id: item.id, name: item.name };
            });
            if ($f('checkAccountAndNumber')(allEmployeesO, employeeProcess, $scope.operationType, $scope.calculations)) {
                $f('getPeriodsAndCalendarForOpe')(opObjs.payroll.fb.$id, opObjs.operation.fb.calendar, opObjs.period.fb.accuDate, true).then(function (resp) {
                    if (!resp.periods) {
                        throw 'No hay periodos disponibles para almacenar la nomina';
                    }
                    $scope.confirmOperationAction(ev, action, resp);
                }).catch(errAlertS);
            }
        };


        $log.log('aguinaldo 2')
        $scope.sendPayrollReceipt = function (event, selected) {
            var operationRefData = $scope.refs.operations + '/' + opObjs.operation.fb.$id + '/employees'
            $mdDialog.show({
                templateUrl: 'app/main/clients/views/newoperation/controllers/dialog/sendPayrollReceipt.html',
                controller: 'SendPayrollReceiptController',
                controllerAs: 'sprCtrl',
                locals: {
                    selected: selected,
                    operationRef: operationRefData,
                    operation: opObjs.operation.fb
                },
                parent: angular.element($document.body),
                targetEvent: event,
                scope: $scope.$new(),
                clickOutsideToClose: false
            });
        }
        function validarSeleccion(selected) {
            if (!selected || !selected.length) return Promise.resolve(false);
            var opRef = $scope.refs.operations + '/' + opObjs.operation.fb.$id + '/employees';
            return AppF.root.child(opRef).once('value').then(function (snap) {
                var all = (snap && snap.val && snap.val()) || {};
                for (var i = 0; i < selected.length; i++) {
                    var emp = all[selected[i].$id];
                    if (!(emp && emp.billId)) return false;
                }
                return true;
            });
        }

        watchers = $scope.$watchCollection('selected', function (nuevo, anterior) {
            if (nuevo === anterior) {
                return;
            }
            validarSeleccion(nuevo).then(function (resp) {
                $scope.allowHumand = resp
            })
        });
        $scope.confirmOperationAction = function (ev, action, params) {
            params = (!angular.isObject(params)) ? {} : params;
            params.moveEmployees = moveEmployees;
            params.sendOperationNotification = sendOperationNotification;
            confirmOperationS(ev, action, params, $scope, opObjs, operationEmployeesF, $scope.operationType);
        };
        function sendOperationNotification(operation, status, moveBack, operationTab, operationStatusName, comments) {
            $filter('getOperationForNotification')(operation, operationTab, moveBack, operationStatusName, comments, $scope.operationType).then(function (operationData) {
                $log.log(operationData);
                return AppF.notifyUsers('operation', 'operations', status, operation.$id, operation, false, operationData);
            }).then(function () {
                $log.log('Notificación enviada');
            }).catch(function (error) {
                $log.error(error);
            });
        }
        function setOperationVariables() {
            $scope.operationStatusByEmployees = opObjs.operation.fb.status;
            if ($scope.operationPermissions.closeOperation && opObjs.operation.fb.status >= 3) {
                $scope.previousEmployeeStatus = 2;
                $scope.previousIncidencesStatus = 2;
                $scope.previousOperationStatus = 2.5;
            } else if ($scope.operationPermissions.closeOperation) {
                $scope.previousEmployeeStatus = 1;
                $scope.previousIncidencesStatus = 1;
                $scope.previousOperationStatus = 2;
                $scope.nextEmployeeStatus = 3;
                $scope.nextIncidenceStatus = 3;
                $scope.nextOperationStatus = 3;
                $scope.showCloseOpButton = true;
            } else if ($scope.operationPermissions.sendOperationToFinalRevision) {
                $scope.previousEmployeeStatus = 0;
                $scope.previousIncidencesStatus = 0;
                $scope.previousOperationStatus = 1;
                $scope.nextEmployeeStatus = 2;
                $scope.nextIncidenceStatus = 2;
                $scope.nextOperationStatus = 2.5;
                $scope.showRevisionOpButton = true;
            } else if ($scope.operationPermissions.sendOperationToRevision) {
                $scope.previousEmployeeStatus = 0;
                $scope.previousIncidencesStatus = 0;
                $scope.previousOperationStatus = -1;
                $scope.nextEmployeeStatus = 1;
                $scope.nextIncidenceStatus = 1;
                $scope.nextOperationStatus = 2;
                $scope.showRevisionOpButton = true;
            }
            if ([3, 5, 6, 7].indexOf(opObjs.operation.fb.status) > -1) {
                $scope.showReopenButton = true;
            } else {
                delete $scope.showReopenButton;
            }
            if ($scope.showRevisionOpButton) {
                //si tiene permiso para revisar la nomina pero la nomina ya no esta en un status para revisar entonces no mostramos le botón de revisar
                if (opObjs.operation.fb.status > 2) {
                    delete $scope.showRevisionOpButton;
                }
                //Si todos mis empleados están en el siguiente estado que corresponde ya no mostramos el botón
                if ($scope.showRevisionOpButton) {
                    if ($scope.allMyEmployeesInStatus($scope.nextEmployeeStatus)) {
                        delete $scope.showRevisionOpButton;
                    }
                }
            }
            if ($scope.showCloseOpButton) {
                delete $scope.showRevisionOpButton;
                //si tiene permiso para revisar la nomina pero la nomina ya no esta en un status para revisar entonces no mostramos le botón de revisar
                if (opObjs.operation.fb.status > 2.5) {
                    delete $scope.showCloseOpButton;
                }
                //Si todos mis empleados están en el siguiente estado que corresponde ya no mostramos el botón
                if ($scope.showCloseOpButton) {
                    if ($scope.allMyEmployeesInStatus($scope.nextEmployeeStatus) && opObjs.operation.fb.status >= 3) {
                        delete $scope.showCloseOpButton;
                    }
                }
            }
            if (opObjs.operation.fb.status > 0 && opObjs.operation.fb.status < $scope.opStatusNotCalc) {
                var status = {};
                var nextStatus = $scope.employeesStatusByOp[opObjs.operation.fb.status].nextStatus;
                for (var a = 0; a < nextStatus.length; a++) {
                    status[nextStatus[a]] = $scope.allMyEmployeesInStatus(nextStatus[a]);
                }
                for (var s in status) {
                    if (status[s]) {
                        if (AppF.opstatusByEmployeeStatus[s] > $scope.operationStatusByEmployees) {
                            $scope.operationStatusByEmployees = AppF.opstatusByEmployeeStatus[s];
                        }
                    }
                }
            }
            $scope.nextEmployeeStatus;
            $scope.failCloseOperation = false;
            if (opObjs.operation.fb.status < $scope.nextOperationStatus) {
                for (var i = 0; i < operationEmployeesF.length; i++) {
                    var employeeStatus = $f('getFromObject')(opObjs.operation.fb, 'employees.' + operationEmployeesF[i].$id + '.status', 0);
                    if (employeeStatus >= $scope.nextEmployeeStatus) {
                        $scope.failCloseOperation = true;
                    }
                }
            }
        }
        function validateMovement(movement, action) {
            if (angular.isObject(opObjs.movements) && angular.isArray(opObjs.movements.fb)) {
                var movementIndexFounded = opObjs.movements.fb.findIndex(function (item) {
                    return item.$id === movement.$id;
                });
                if (action === 'delete' && movementIndexFounded > 0) {
                    opObjs.movements.fb.splice(movementIndexFounded, 1);
                    addForAction('loadEmployees');
                } else {
                    if (isValidMovement(movement)) {
                        if (movementIndexFounded > -1) {
                            opObjs.movements.fb[movementIndexFounded] = angular.fromJson(angular.toJson(movement));
                        } else {
                            opObjs.movements.fb.push(movement);
                        }
                        addForAction('loadEmployees');
                    } else if (movementIndexFounded > -1) {
                        opObjs.movements.fb.splice(movementIndexFounded, 1);
                        addForAction('loadEmployees');
                    }
                }
            }
        }
        function isValidMovement(movement) {
            var isValid = false;
            if (movement.payroll === $scope.payrollId) {
                isValid = true;
            }
            if (isValid) {
                var movements = [movement];
                var lastMovements = $filter('getLastMovemenBeforeDate')(movements, opObjs.period.fb.start);
                var betweenMovements = $filter('getMovementsBetweenDates')(movements, opObjs.period.fb.start, opObjs.period.fb.end);
                if (lastMovements.length || betweenMovements.length) {
                    if (lastMovements.length) {
                        $log.debug('isValid because Last');
                    } else {
                        $log.debug('isValid because Between');
                    }
                    isValid = true;
                } else {
                    isValid = false;
                }
            }
            return isValid;
        }
        //FUNCIÓN PRINCIPAL QUE DISPARA TODO
        function init() {
            $scope.showProgress = true;
            initiated = true;
            $rootScope.loadingProgress = false;
            $scope.$evalAsync();
            $timeout(function () {
                // SI NO VIENE LOS PARÁMETROS EN LA URL SE REGRESA HACIA ATRÁS
                if (!$state.params.operationId || !$state.params.payrollId) {
                    errAlertS('No se tienen todos los parámetros necesarios para acceder a la nomina');
                    $scope.R.goToList();
                } else {
                    //Se obtienen los parámetros del url
                    $scope.readOnlyMode = ($state.current.url.indexOf('read') !== -1);
                    $scope.operationId = $state.params.operationId;
                    $scope.payrollId = $state.params.payrollId;
                    $scope.operationType = $state.params.operationType;
                    //SE OBTIENEN LOS PERMISOS DEL USUARIO PARA LAS OPERACIONES DE LA NOMINA
                    $scope.operationPermissions = $f('getOperationPermissions')();
                    // dataNeeded, operationId, periodId, calendarId, payrollId, operationType, operationIsClosed
                    //SE OBTIENEN LAS REFERENCIAS Y LOS DATOS PRINCIPALES DE LA OPERACIÓN
                    $scope.actionMessages = 'Obteniendo datos iniciales';
                    $f('getInitialDataOfSpecialOperation')(dataNeeded, $scope.operationId, $scope.payrollId, $scope.operationType, $scope.opStatusNotCalc).then(function (resp) {
                        $scope.operationProgress = 20;
                        $scope.refs = resp.refs;
                        opObjs = resp.fbObjs;
                        $log.log(resp)
                        $f('loopEach')(opObjs, function (objData, objIndex) {
                            if (angular.isDefined(objData.actions)) {
                                for (var a = 0; a < objData.actions.length; a++) {
                                    addForAction(objData.actions[a], objData.fb, undefined, true);
                                }
                            }
                            if (angular.isObject(objData) && objData.inScope && objData.fb) {
                                $scope[objIndex] = objData.fb;
                            }
                        });
                        if (opObjs.operation.fb.status < $scope.opStatusNotCalc) {
                            opObjs.incidences.watch = true;
                        }
                        $scope.calendarId = parseInt(opObjs.operation.fb.calendar);
                        $scope.periodId = parseInt(opObjs.operation.fb.period);
                        opObjs.incidences.executeCalculation = true;
                        opObjs.incidences.actions = ['setIncidencesOfEmployees'];
                        incidenceTypeForPenDays = opObjs.concepts.fb.find(function (item) {
                            return item.fdd;
                        });
                        addForAction('loadEmployees', undefined, false, true);
                        addForAction('setIncidencesOfEmployees', opObjs.incidences.fb, false, true);
                        addForAction('calculate', undefined, false, true);
                        addForAction('loadOtherOperationObjs', undefined, false, true);
                        addForAction('activeWatchers', undefined, false);
                        $scope.setTabName();
                    }).catch(function (error) {
                        errAlertS('Error al obtener la información general de la operación');
                        $log.error(error);
                    });
                }

            }, 0, false);

        }
        $scope.setTabName = function (tabName) {
            tabName = !tabName ? 'real' : tabName;
            $scope.selected = [];
            $scope.tabSelected = tabName;
        };
        $scope.goToList = function () {
            $window.history.back();
        };
        $scope.fastIncidenceUsed = function (incidenceTypeId) {
            var inUse = true;
            if (angular.isDefined(opObjs) && angular.isDefined(opObjs.process) && angular.isArray(opObjs.process.fb)) {
                var realP = opObjs.process.fb.find(function (item) {
                    return item.id === 'real';
                });
                if (angular.isDefined(realP)) {
                    inUse = false;
                    var isInConcepts = realP.concepts.find(function (item) {
                        return incidenceTypeId === item.$id && item.type === 'fast';
                    });
                    inUse = angular.isDefined(isInConcepts);
                }
            }
            return inUse;
        };
        $scope.addFastIncidenceColumn = function (incidenceType) {
            // opObjs.processFromPayroll
            if (angular.isDefined(opObjs) && angular.isDefined(opObjs.processFromPayroll) && angular.isArray(opObjs.processFromPayroll.fb)) {
                var realP = opObjs.processFromPayroll.fb.find(function (item) {
                    return item.id === 'real';
                });
                if (angular.isDefined(realP)) {
                    var nature = opObjs.conceptsById.fb[incidenceType].nature === 'perception' ? 'sys_perceptions' : 'sys_deductions';
                    var isInConcepts = realP.concepts.find(function (item) {
                        return item.$id === nature;
                    });
                    var order = 100;
                    if (angular.isDefined(isInConcepts)) {
                        order = isInConcepts.order;
                    }
                    if (angular.isDefined(opObjs) && angular.isDefined(opObjs.process) && angular.isArray(opObjs.process.fb)) {
                        var real = opObjs.process.fb.find(function (item) {
                            return item.id === 'real';
                        });
                        if (angular.isDefined(real) && angular.isArray(real.concepts)) {
                            var concept = {
                                '$id': incidenceType,
                                'id': incidenceType,
                                'name': $f('getFromObject')(opObjs.conceptsById.fb, incidenceType + '.name', 'S/N'),
                                'key': $filter('getFromObject')(opObjs.conceptsById.fb, incidenceType + '.key', 'S/N'),
                                'nature': $filter('getFromObject')(opObjs.conceptsById.fb, incidenceType + '.nature', 'S/N'),
                                'conceptType': $filter('getFromObject')(opObjs.conceptsById.fb, incidenceType + '.type', 'S/N'),
                                'hiddenColumn': $filter('getFromObject')(opObjs.conceptsById.fb, incidenceType + '.hiddenColumn', false),
                                'showTotal': $filter('getFromObject')(opObjs.conceptsById.fb, incidenceType + '.showTotal', false),
                                'inputType': $filter('getFromObject')(opObjs.conceptsById.fb, incidenceType + '.inputType', 'currency'),
                                'hiddenField': $filter('getFromObject')(opObjs.conceptsById.fb, incidenceType + '.hiddenField', false),
                                'allowNegative': $filter('getFromObject')(opObjs.conceptsById.fb, incidenceType + '.allowNegative', false),
                                'order': order,
                                'type': 'fast'
                            };
                            real.concepts.push(concept);
                        }
                    }

                }
            }
        };
        $scope.fireValidation = function (notCalculate) {
            AppF.notCalculate = notCalculate ? true : false;
            $scope.$evalAsync(function () {
                if (!AppF.notCalculate) {
                    addForAction('calculate');
                }
            });
        };
        $scope.allMyEmployeesInStatus = function (status, all) {
            var allInStatus = true;
            if (all) {
                $f('loopEach')(allEmployeesO, function (employee, employeeId) {
                    if (opObjs.operation.fb.employees && opObjs.operation.fb.employees[employeeId] && opObjs.operation.fb.employees[employeeId].status !== status) {
                        allInStatus = false;
                        return;
                    }
                });
            } else {
                for (var i = 0; i < operationEmployeesF.length; i++) {
                    if (opObjs.operation.fb.employees && opObjs.operation.fb.employees[operationEmployeesF[i].$id] && opObjs.operation.fb.employees[operationEmployeesF[i].$id].status !== status) {
                        allInStatus = false;
                        i = operationEmployeesF.length;
                    }
                }
            }
            return allInStatus;
        };
        $scope.setNextOrder = function (field, actualOrder) {
            var orderArray = [['data.enroleDate', 'data.name'], field, '-' + field];
            var index = orderArray.indexOf(actualOrder);
            if (index === -1) {
                index = 0;
            }
            var nextIndex = index + 1;
            if (nextIndex >= orderArray.length) {
                nextIndex = 0;
            }
            $scope.order = orderArray[nextIndex];
        };
        $scope.saveFastIncidence = function (employeeId, incidenceTypeId, incidenceQty) {
            var timeIdentifier = new Date().valueOf();
            savingFastIncidences[timeIdentifier] = true;
            var currentFast = [];
            if (angular.isDefined(opObjs.opIncidences) && angular.isArray(opObjs.opIncidences.fb)) {
                currentFast = opObjs.opIncidences.fb.filter(function (item) {
                    return item.employee === employeeId && item.type === 'fast' && item.incidenceType === incidenceTypeId && item[$scope.operationType] === $scope.operationId;
                });
            }
            var updates = {};
            if ((incidenceQty <= 0 && !opObjs.conceptsById.fb[incidenceTypeId].allowNegative) || incidenceQty == null || angular.isUndefined(incidenceQty)) {
                for (var c = 0; c < currentFast.length; c++) {
                    updates[currentFast[c].$id] = null;
                }
            } else {
                var affectDays = opObjs.conceptsById.fb[incidenceTypeId].validateDays;
                if (affectDays) {
                    if (incidenceQty > currentFast.length) {
                        var incidences = opObjs.incidencesByEmployee.fb[employeeId];
                        var affectedDate = [];
                        if (angular.isDefined(incidences) && angular.isArray(incidences)) {
                            for (var i = 0; i < incidences.length; i++) {
                                var affect = $filter('getSomethingOfArrayFB')(incidences[i].incidenceType, opObjs.concepts.fb, 'validateDays');
                                if (affect && incidences[i].date) {
                                    affectedDate.push(incidences[i].date);
                                }
                            }
                        }
                        var count = 0;
                        var moreDays = 0;
                        var result = incidenceQty - currentFast.length;
                        while (count < result) {
                            var days = moment(opObjs.period.fb.start).add(moreDays, 'days');
                            var exist = affectedDate.indexOf(days.valueOf());
                            moreDays++;
                            if (exist === -1) {
                                var incidenceKey = AppF.root.child($scope.refs.incidences).push().key;
                                var createIncidence = {
                                    payroll: $scope.payrollId,
                                    period: $scope.periodId,
                                    calendar: $scope.calendarId,
                                    status: 0,
                                    incidenceType: incidenceTypeId,
                                    employee: employeeId,
                                    date: days.valueOf(),
                                    type: 'fast',
                                    value: 1,
                                    center: AppF.center,
                                    operationType: $scope.operationType,
                                    comments: 'Incidencia Rápida',
                                    created: DataF.getTimeObject(undefined, undefined, true)
                                };
                                createIncidence[$scope.operationType] = $scope.operationId;
                                updates[incidenceKey] = createIncidence;
                                count++;
                            }
                        }
                    } else {
                        for (var x = 0; x < currentFast.length; x++) {
                            if ((x + 1) > incidenceQty) {
                                updates[currentFast[x].$id] = null;
                            }
                        }
                    }
                } else if (currentFast.length > 0) {
                    for (var cf = 0; cf < currentFast.length; cf++) {
                        if (cf === 0) {
                            updates[currentFast[cf].$id + '/value'] = incidenceQty;
                            updates[currentFast[cf].$id + '/updated'] = DataF.getTimeObject(undefined, undefined, true);
                        } else {
                            updates[currentFast[cf].$id] = null;
                        }
                    }
                } else if (currentFast.length === 0) {
                    var incidenceId = AppF.root.child($scope.refs.incidences).push().key;
                    var defaultIncidence = {
                        payroll: $scope.payrollId,
                        period: $scope.operationType === 'ptuDistributionRecord' ? null : $scope.periodId,
                        calendar: $scope.calendarId,
                        status: 0,
                        incidenceType: incidenceTypeId,
                        employee: employeeId,
                        type: 'fast',
                        operationType: $scope.operationType,
                        value: incidenceQty,
                        center: AppF.center,
                        comments: 'Incidencia Rápida',
                        created: DataF.getTimeObject(undefined, undefined, true)
                    };
                    defaultIncidence[$scope.operationType] = $scope.operationId;
                    updates[incidenceId] = defaultIncidence;
                }
            }
            console.log($scope.refs.incidences, updates);
            AppF.root.child($scope.refs.incidences).update(updates).then(function () {
                delete savingFastIncidences[timeIdentifier];
            });
        };
        $scope.exportReportPayroll = function () {
            var conceptsById = opObjs.conceptsById.fb;
            var calc = $scope.calculations;
            var headers = [];
            var employees = {};
            var valueObjs = {
                'real': ['value', 'rejectedIncidences', 'valueNoRejected'],
                'fiscal': ['fiscalValue', 'fiscalValueRejected', 'fiscalValueNoRejected'],
                'socialPrevision': ['socialPrevisionValue', 'socialPrevisionValueRejected', 'socialPrevisionValueNoRejected']
            };
            var headersField = {
                rejectedIncidences: 'valueRejected'
            }
            var totalObj = {};
            var totalAmountObj = {};
            var process = $scope.process.filter(function (item) {
                return ['rejectedIncidences'].indexOf(item.id) === -1;
            }).map(function (item) {
                return angular.copy(item);
            });
            var uniqueP = process.filter(function (item) {
                return ['real'].indexOf(item.id) === -1;
            });
            if (uniqueP.length === 1 && uniqueP[0].id === 'fiscal') {
                process = uniqueP;
            }
            process.forEach(function (thisProcess) {
                if (!totalObj[thisProcess.id]) {
                    totalObj[thisProcess.id] = {};
                    totalAmountObj[thisProcess.id] = { totals: [] };
                }
                if (angular.isArray(thisProcess.totals) && thisProcess.totals.length > 0) {
                    var totals = $filter('orderBy')(thisProcess.totals, 'order');
                    totals.forEach(function (total) {
                        if ($scope.operationTotals.hasOwnProperty(total.$id)) {
                            var operation = total.operation ? total.operation + 1 : 1;
                            totalAmountObj[thisProcess.id]['totals'].push({ name: total.name, total: $scope.operationTotals[total.$id][total.field] * operation });
                        } else {
                            totalAmountObj[thisProcess.id]['totals'].push({ name: total.name });
                        }
                    });
                }
                if (angular.isArray(thisProcess.concepts)) {
                    if (angular.isArray(thisProcess.extras)) {
                        thisProcess.extras.forEach(function (extra) {
                            extra.order = extra.order * 100;
                        });
                        thisProcess.concepts = thisProcess.concepts.concat(thisProcess.extras);
                    }
                    var thisProConcepts = thisProcess.concepts.filter(function (item) {
                        return item.$id && (!item.hiddenColumn || item.showOnReport);
                    });
                    if (thisProConcepts.length > 0) {
                        thisProConcepts.sort(function (a, b) {
                            return a.order - b.order;
                        })
                        var newConcepts = [
                            { name: "NO.", key: "number", order: -5 },
                            { name: "NOMBRE", key: "name", order: -3 },
                            { name: "CC", key: "cc", order: -2 },
                            { name: "PLAZA", key: "place", order: -1.8 },
                            { name: "DEPARTAMENTO", key: "department", order: -1.7 },
                            { name: "PUESTO", key: "position", order: -1.5 }
                        ];
                        if (thisProcess.id !== 'socialPrevision') {
                            newConcepts.splice(1, 0, { name: "NSS", key: "nss", order: -4 });
                        }
                        var procConcepts = {};
                        var payrollWithSubtotals = opObjs.payroll.fb.subtotal;
                        var newOrder = payrollWithSubtotals ? ['data.cc'].concat($scope.order) : $scope.order;
                        var employeesSort = $filter('orderBy')(operationEmployeesF, newOrder);
                        var subtotals = {};
                        var lastEmployeeIndex = undefined;
                        var hasAnyDepartment = false;
                        employeesSort.forEach(function (employeeSort, es) {
                            var employeeId = employeeSort.$id;
                            var employee = allEmployeesO[employeeId];
                            var employeeCalculation = calc[employee.$id] || {};
                            if (angular.isString(employee.departmentName)) {
                                hasAnyDepartment = true;
                            }
                            if (thisProcess.id !== "fiscal" || employee.isFiscal) {
                                if (!employees[employeeId]) {
                                    employees[employeeId] = {
                                        number: $filter("getFromObject")(employee, "data.employeeNumber", "N/A"),
                                        nss: employee.data.nss || '',
                                        name: employee.data.name,
                                        cc: employee.ccData.data.name,
                                        place: $filter("getFromObject")(employee, "ccPlace.name", "Sin plaza"),
                                        position: employee.positionData.name,
                                        department: employee.departmentName || 'Sin departamento',
                                        order: es,
                                        c: {}
                                    };
                                    if (employee.isFiscal) {
                                        employees[employeeId].isFiscal = true;
                                    }
                                }
                                thisProConcepts.forEach(function (concept, t) {
                                    var thisConcept = conceptsById[concept.$id] || concept;
                                    var name = concept.name || thisConcept.name;
                                    if (!procConcepts[name]) {
                                        procConcepts[name] = true;
                                        newConcepts.push({ name: name, order: t, key: thisProcess.id });
                                    }
                                    var total;
                                    if (thisConcept.key === 'perceptions' || thisConcept.key === 'fiscalPerceptions') {
                                        total = $filter('getFromObject')(employeeCalculation[thisConcept.key], 'wSalary.result');
                                        if (!totalObj[thisProcess.id][name]) {
                                            totalObj[thisProcess.id][name] = $filter('getFromObject')($scope.operationTotals[concept.$id], 'wSalary', 0);
                                        }
                                    } else {
                                        var valuesFields = thisConcept.type === 'incidenceType' ? valueObjs[thisProcess.id] : valueObjs.real;
                                        var rejectedName = name + ' RECHAZADO';
                                        if (!totalObj[thisProcess.id][name]) {
                                            if (thisConcept.showTotal) {
                                                var rejectedField = headersField[valuesFields[1]] || valuesFields[1];
                                                var rejectedT = thisConcept.nature === 'deduction' ? $filter('getFromObject')($scope.operationTotals[concept.$id], rejectedField, 0) : 0;
                                                if (thisConcept.nature === 'deduction' && rejectedT > 0) {
                                                    var noRejectedT = $filter('getFromObject')($scope.operationTotals[concept.$id], valuesFields[2], 0);
                                                    totalObj[thisProcess.id][rejectedName] = rejectedT;
                                                    totalObj[thisProcess.id][name] = noRejectedT;
                                                } else {
                                                    totalObj[thisProcess.id][name] = $filter('getFromObject')($scope.operationTotals[concept.$id], valuesFields[0], 0);
                                                }
                                            } else {
                                                totalObj[thisProcess.id][name] = "#isEmpty";
                                            }
                                        }
                                        var rejected = $filter('getFromObject')(employeeCalculation[thisConcept.key], valuesFields[1] + '.result', 0);
                                        if (rejected > 0) {
                                            total = $filter('getFromObject')(employeeCalculation[thisConcept.key], valuesFields[2] + '.result');
                                            if (!procConcepts[rejectedName]) {
                                                procConcepts[rejectedName] = true;
                                                newConcepts.push({ name: rejectedName, order: t - 0.5, key: thisProcess.id + "Rejected" });
                                            }
                                            if (!employees[employeeId].c[rejectedName]) {
                                                employees[employeeId].c[rejectedName] = {};
                                            }
                                            // if (rejected > total) {
                                            //     rejected = total;
                                            // }
                                            employees[employeeId].c[rejectedName][thisProcess.id + "Rejected"] = rejected;
                                        } else {
                                            total = $filter('getFromObject')(employeeCalculation[thisConcept.key], valuesFields[0] + '.result');
                                        }
                                    }
                                    if (angular.isDefined(total)) {
                                        employees[employeeId].c[name] = employees[employeeId].c[name] || {};
                                        employees[employeeId].c[name][thisProcess.id] = total;
                                        if (payrollWithSubtotals && thisConcept.showTotal) {
                                            subtotals[employeeSort.data.cc] = subtotals[employeeSort.data.cc] || {};
                                            subtotals[employeeSort.data.cc][name] = subtotals[employeeSort.data.cc][name] || 0;
                                            subtotals[employeeSort.data.cc][name] = subtotals[employeeSort.data.cc][name] + total;
                                        }
                                    }
                                    if (payrollWithSubtotals) {
                                        var previousEmployeeCc = angular.isDefined(lastEmployeeIndex) ? employeesSort[lastEmployeeIndex].data.cc : undefined;
                                        if (angular.isDefined(previousEmployeeCc) && previousEmployeeCc !== employeeSort.data.cc) {
                                            var isFiscal1 = allEmployeesO[employeesSort[lastEmployeeIndex].$id].rpData.data.name !== '00000000000' ? true : false;
                                            employees[previousEmployeeCc] = employees[previousEmployeeCc] || {
                                                order: es - .5,
                                                name: "#isSubtotal#SUBTOTAL " + allEmployeesO[employeesSort[lastEmployeeIndex].$id].ccData.data.name,
                                                number: "#isNull",
                                                nss: "#isNull",
                                                cc: '#isNull',
                                                isFiscal: isFiscal1,
                                                position: '#isNull',
                                                place: '#isNull',
                                                department: '#isNull',
                                                c: {}
                                            }
                                            employees[previousEmployeeCc].c[name] = employees[previousEmployeeCc].c[name] || {};
                                            employees[previousEmployeeCc].c[name][thisProcess.id] = $filter("getFromObject")(subtotals, previousEmployeeCc + "." + name, thisConcept.showTotal ? 0 : "#isEmpty");
                                        }
                                        if ((employeesSort.length - 1) === es) {
                                            var isFiscal2 = allEmployeesO[employeeSort.$id].rpData.data.name !== '00000000000' ? true : false;
                                            employees[employee.cc] = employees[employee.cc] || {
                                                order: es + .5,
                                                name: "#isSubtotal#SUBTOTAL " + employee.ccData.data.name,
                                                number: "#isNull",
                                                nss: "#isNull",
                                                cc: '#isNull',
                                                isFiscal: isFiscal2,
                                                position: '#isNull',
                                                place: '#isNull',
                                                department: '#isNull',
                                                c: {}
                                            };
                                            employees[employee.cc].c[name] = employees[employee.cc].c[name] || {};
                                            employees[employee.cc].c[name][thisProcess.id] = $filter("getFromObject")(subtotals, employee.cc + "." + name, thisConcept.showTotal ? 0 : "#isEmpty");
                                        }
                                    }
                                });
                                lastEmployeeIndex = es;
                            }
                        });
                        if (!hasAnyDepartment) {
                            var indexDepartment = newConcepts.findIndex(function (item) {
                                return item.key === 'department';
                            })
                            if (indexDepartment > -1) {
                                newConcepts.splice(indexDepartment, 1)
                            }
                        }
                        if (totalObj[thisProcess.id]) {
                            Object.keys(totalObj[thisProcess.id]).forEach(function (tt) {
                                var index = newConcepts.findIndex(function (value) {
                                    return value.name === tt;
                                });
                                if (index > -1 && angular.isDefined(totalObj[thisProcess.id][tt])) {
                                    if (angular.isArray(totalObj[thisProcess.id][tt])) {
                                        if (totalObj[thisProcess.id][tt].length > 0) {
                                            newConcepts[index].totalBill = totalObj[thisProcess.id][tt];
                                        }
                                    } else {
                                        newConcepts[index].totalAmount = totalObj[thisProcess.id][tt];
                                    }
                                }
                            });
                        }
                        newConcepts.sort(function (a, b) {
                            return a.order - b.order;
                        });
                        var objH = { name: thisProcess.name, key: thisProcess.id, concepts: newConcepts };
                        if (thisProcess.alias) {
                            objH.alias = thisProcess.alias;
                        }
                        if (totalAmountObj[thisProcess.id]['totals'].length > 0) {
                            objH.totals = totalAmountObj[thisProcess.id]['totals'];
                        }
                        headers.push(objH);
                    }
                }
            });
            var promises = [];
            var processId = [];
            headers.forEach(function (header) {
                if (['fiscal', 'socialPrevision'].indexOf(header.key) > -1) {
                    promises.push($filter('getCompaniesName')($scope.payrollId, header.name));
                    processId.push(header.name);
                }
            });

            Promise.all(promises).then(function (response) {
                if (response.length > 0) {
                    response.forEach(function (businessName, r) {
                        if (businessName.data) {
                            var indexH = headers.findIndex(function (value) {
                                return value.name === processId[r];
                            });
                            if (indexH > -1) {
                                headers[indexH].companiesRecord = businessName.data.businessName;
                            }
                        } else {
                            throw businessName.message;
                        }
                    });
                    var employeesTemp = Object.keys(employees).sort(function (a, b) {
                        return employees[a].order - employees[b].order;
                    }).map(function (item) {
                        return employees[item];
                    });
                    employees = employeesTemp;
                    var thisCalendar = $filter('getFromObject')(opObjs.operation.fb, 'calendar') ? '_' + opObjs.operation.fb.calendar : '';
                    var thisPeriod = $filter('getFromObject')(opObjs.operation.fb, 'specialPeriod') ? '_' + $filter('zeroFill')(opObjs.operation.fb.specialPeriod, 3) : '';
                    var thisCenter = AppF.center.toUpperCase();
                    var thisFileName = 'TOT_' + thisCenter + thisCalendar + '_' + opObjs.payroll.fb.data.class + '_' + opObjs.payroll.fb.data.name + thisPeriod;
                    var dataObj = {
                        info: {
                            payroll: opObjs.payroll.fb.data.class + ' ' + opObjs.payroll.fb.data.name + ' [' + $filter('getSomethingOfArrayM')(opObjs.payroll.fb.paymentFrequency, $scope.M.paymentFrequenciesRecords, 'name') + ']',
                            date: 'Incidencias del ' + $filter('date')(opObjs.operation.fb.specialDate, AppF.dateFormat),
                            period: 'Periodo ' + $filter('zeroFill')(opObjs.operation.fb.specialPeriod, 3)
                        },
                        footer: angular.toJson([{}, {}, {}, {}, { "NOMBRE": '#stylefooterstyle#LIC. ' + $filter('uppercased')(AppF.profile.data.name) }, { "NOMBRE": "#stylefooterstyle#EJECUTIVO DE CUENTAS" }]),
                        headers: angular.toJson(headers),
                        data: angular.toJson(employees),
                        filename: thisFileName
                    }
                    downloadFile("interface/exportDataWithMultiHeader", dataObj);
                } else {
                    throw "No se encontró ningún proceso";
                }
            }).catch(function (error) {
                errAlertS(error);
            });
        }
        $scope.filterEmployees = function () {
            $scope.selected = [];
            $scope.operationEmployees = $f('filterEmployeesForOperation')(operationEmployeesF, $scope.search);
            $scope.fiscalEmployees = $f('filterEmployeesForOperation')(fiscalEmployeesF, $scope.search);
        };
        $scope.openMenu = function ($mdOpenMenu, ev) {
            $mdOpenMenu(ev);
        };
        $scope.toggle = function (item, list) {
            var idx = list.findIndex(function (employee) {
                return employee.$id === item.$id;
            });
            if (idx > -1) {
                list.splice(idx, 1);
            } else {
                list.push(item);
            }
        };
        $scope.exists = function (item, list) {
            return list.findIndex(function (employee) {
                return employee.$id === item.$id;
            }) > -1;
        };
        $scope.showIncidencesListBottomSheet = function (event, employee) {
            AppF.notCalculate = true;
            var employeesObj;
            if ($scope.tabSelected === 'fiscal') {
                employeesObj = $f('orderBy')($scope.fiscalEmployees, $scope.order);
            } else {
                employeesObj = $f('orderBy')($scope.operationEmployees, $scope.order);
            }
            var employeeIndex = $filter('getIndexFromArray')(employeesObj, '$id', employee.$id);
            $mdBottomSheet.show({
                templateUrl: 'app/main/clients/views/newoperation/dialogs/bottom-incidences.html',
                locals: {
                    employeeIndex: employeeIndex,
                    employees: employeesObj,
                    employee: employee,
                    operation: opObjs.operation.fb,
                    incidencesTypes: opObjs.concepts.fb,
                    incidencesTypesForPayroll: opObjs.incidencesTypes.fb,
                    operationData: opObjs.period.fb,
                    payroll: $scope.payrollId,
                    nextEmployeeStatus: $scope.nextEmployeeStatus,
                    opStatusNotCalc: $scope.opStatusNotCalc,
                    readOnlyMode: $scope.readOnlyMode,
                    operationIsClosed: opObjs.operation.fb.status >= $scope.opStatusNotCalc,
                    allEmployees: allEmployeesO,
                    operationType: $scope.operationType
                },
                controller: 'showIncidencesListController',
                parent: '.md-tab-body',
                clickOutsideToClose: false,
                escapeToClose: true,
                targetEvent: event
            }).then(function () {
                //$log.debug(clickedItem)
            }).catch(function (error) {
                $log.debug('Incidences modal closed', error);
            }).then(function () {
                AppF.notCalculate = false;
                $scope.$evalAsync(function () {
                    addForAction('calculate');
                });
            });
        };
        $scope.showCalculationsListBottomSheet = function (event, employeeId) {
            var employeesObj;
            if ($scope.tabSelected === 'fiscal') {
                employeesObj = $f('orderBy')($scope.fiscalEmployees, $scope.order);
            } else {
                employeesObj = $f('orderBy')($scope.operationEmployees, $scope.order);
            }
            var employeeIndex = $filter('getIndexFromArray')(employeesObj, '$id', employeeId);
            $mdBottomSheet.show({
                templateUrl: 'app/main/clients/views/newoperation/dialogs/bottom-calculations.html',
                locals: {
                    employeeIndex: employeeIndex,
                    employees: employeesObj,
                    calculations: $scope.calculations,
                    concepts: opObjs.conceptsByKey.fb
                },
                controller: 'showCalculationsListController',
                parent: '.md-tab-body',
                clickOutsideToClose: false,
                escapeToClose: true,
                targetEvent: event,
                isLockedOpen: true
            }).then(function () {
                //$log.debug(clickedItem);
            }).catch(function (error) {
                $log.debug('Calculations modal closed', error);
            });
        };
        $scope.exportToExcel = function () {
            var dataToExport = angular.toJson($filter('generateIncidencesToImportV2')(operationEmployeesF, allEmployeesO, opObjs.payroll.fb, opObjs.period.fb, $scope.calendarId, opObjs.conceptsById.fb));
            var data = {
                data: dataToExport
            };
            CatalogsF.exportToExcel('interface/exportDataToCSV', data);
        };
        $scope.exportToExcelWithHeaders = function (tabSelected) {
            var dateText, payrollText, periodText;
            if ($scope.operationType === 'ptuDistributionRecord') {
                payrollText = $filter('nameOfL')(opObjs.operation.fb.companiesRecordId, $scope.L.companiesRecords) + ' - ' + opObjs.operation.fb.calendar;
                dateText = 'HOJA DE DISTRIBUCIÓN PTU';
                periodText = '';
            } else {
                payrollText = opObjs.payroll.fb.data.class + ' ' + opObjs.payroll.fb.data.name + ' [' + $filter('getSomethingOfArrayM')(opObjs.payroll.fb.paymentFrequency, $scope.M.paymentFrequenciesRecords, 'name') + ']';
                dateText = 'Incidencias de ' + $filter('date')(opObjs.operation.fb.specialDate, AppF.dateFormat);
                if ($scope.operationType === 'chrisBonusRecord') {
                    dateText = 'Incidencias del ' + $filter('date')(opObjs.operation.fb.start, AppF.dateFormat) + ' al ' + $filter('date')(opObjs.operation.fb.end, AppF.dateFormat)
                }
                periodText = 'Periodo ' + $filter('zeroFill')(opObjs.operation.fb.specialPeriod, 3)
            }
            var calculations = [];
            var headers = [
                [payrollText],
                [dateText],
                [periodText],
                ['']
            ];
            var processes = $scope.process.find(function (process) {
                return process.id === $scope.tabSelected;
            });
            if (!processes) {
                errAlertS('No se encontró el nombre del proceso');
                return false;
            }
            var type = processes.name;
            var employees = $f('orderBy')($scope.operationEmployees, $scope.order);
            if ($scope.tabSelected === 'fiscal') {
                employees = $f('orderBy')($scope.fiscalEmployees, $scope.order);
            }
            var calc = $scope.calculations;
            var conceptsById = opObjs.conceptsById.fb;
            var processName = opObjs.process.fb.find(function (value) {
                return value.id === tabSelected;
            });
            var process = $filter('orderBy')(processName.concepts || [], 'order');
            if (angular.isArray(processName.extras)) {
                process = process.concat(processName.extras)
            }
            var opeHeaders = {};
            for (var i = 0; i < employees.length; i++) {
                var employee = allEmployeesO[employees[i].$id];
                var obj = {};
                obj.NO = $filter("getFromObject")(employee, "data.employeeNumber", "N/A");
                obj.NSS = employee.data.nss ? employee.data.nss : '';
                obj.NOMBRE = employee.data.name;
                obj.CC = employee.ccData.data.name;
                obj.PUESTO = employee.positionData.name;
                if ($scope.operationType === 'ptuDistributionRecord') {
                    obj["ULT. MOV"] = $filter('getFromObject')($scope.operation.employees, employees[i].$id + ".movType", "S/M").toUpperCase();
                }
                var valueObjs = {
                    'real': ['value', 'rejectedIncidences', 'valueNoRejected'],
                    'fiscal': ['fiscalValue', 'fiscalValueRejected', 'fiscalValueNoRejected'],
                    'socialPrevision': ['socialPrevisionValue', 'socialPrevisionValueRejected', 'socialPrevisionValueNoRejected']
                }
                for (var p = 0; p < process.length; p++) {
                    if (angular.isDefined(process[p].$id) && (!process[p].hiddenColumn || process[p].showOnReport)) {
                        var thisConcept = angular.isDefined(conceptsById[process[p].$id]) ? conceptsById[process[p].$id] : process[p];
                        var name = angular.isDefined(process[p].name) ? process[p].name : thisConcept.name;
                        if ((thisConcept.key === 'perceptions' || thisConcept.key === 'fiscalPerceptions') && angular.isDefined($f('getFromObject')(calc[employee.$id][thisConcept.key], 'wSalary.result'))) {
                            var total = (calc[employee.$id][thisConcept.key]) ? calc[employee.$id][thisConcept.key].wSalary.result : 0;
                            obj[name] = total;
                            opeHeaders[name] = p;
                        } else {
                            var valuesFields = valueObjs.real;
                            if (thisConcept.type === 'incidenceType') {
                                valuesFields = valueObjs[tabSelected];
                            }
                            var rejected = $f('getFromObject')(calc[employee.$id][thisConcept.key], valuesFields[1] + '.result', 0);
                            if (rejected > 0) {
                                var noRejected = $f('getFromObject')(calc[employee.$id][thisConcept.key], valuesFields[2] + '.result', 0);
                                obj[name + ' RECHAZADO'] = rejected;
                                opeHeaders[name + ' RECHAZADO'] = (p - .5);
                                obj[name] = noRejected;
                                opeHeaders[name] = p;
                            } else {
                                var total = $f('getFromObject')(calc[employee.$id][thisConcept.key], valuesFields[0] + '.result', 0);
                                obj[name] = total;
                                opeHeaders[name] = p;
                            }
                        }
                    }
                }
                calculations.push(obj);
            }
            opeHeaders = $f('objsToArray')(opeHeaders).sort(function (a, b) {
                return a.value - b.value;
            });
            var newCalculations = [];
            for (var c = 0; c < calculations.length; c++) {
                var thisObj = calculations[c];
                var newObj = {};
                newObj.NO = thisObj.NO;
                if (tabSelected !== 'socialPrevision') {
                    newObj.NSS = thisObj.NSS;
                }
                newObj.NOMBRE = thisObj.NOMBRE;
                newObj.CC = thisObj.CC;
                newObj.PUESTO = thisObj.PUESTO;
                if ($scope.operationType === 'ptuDistributionRecord') {
                    newObj["ULT. MOV"] = thisObj["ULT. MOV"];
                }
                for (var h = 0; h < opeHeaders.length; h++) {
                    var thisHeader = opeHeaders[h];
                    newObj[thisHeader.$id] = thisObj[thisHeader.$id] || 0;
                }
                newCalculations.push(newObj);
            }
            calculations = newCalculations;
            var totalObj = {};
            var tabs = {
                real: ['value', 'valueRejected', 'valueNoRejected'],
                fiscal: ['fiscalValue', 'fiscalValueRejected', 'fiscalValueNoRejected'],
                socialPrevision: ['socialPrevisionValue', 'socialPrevisionValueRejected', 'socialPrevisionValueNoRejected']
            }
            for (var c = 0; c < process.length; c++) {
                if ($scope.operationTotals.hasOwnProperty(process[c].$id) && (!process[c].hiddenColumn || process[c].showOnReport)) {
                    if (angular.isDefined($scope.operationTotals[process[c].$id].value)) {
                        if (process[c].key === "fiscalPerceptions" || process[c].key === "perceptions") {
                            totalObj[process[c].name] = $scope.operationTotals[process[c].$id].wSalary;
                        } else {
                            totalObj[process[c].name] = $scope.operationTotals[process[c].$id].value;
                            var valuesFields = tabs.real;

                            var thisConcept = angular.isDefined(conceptsById[process[c].$id]) ? conceptsById[process[c].$id] : process[c];
                            if (thisConcept.type === 'incidenceType') {
                                valuesFields = tabs[tabSelected];
                                if (thisConcept.nature === 'deduction') {
                                    var rejected = $f('getFromObject')($scope.operationTotals[process[c].$id], valuesFields[1], 0);
                                    if (rejected > 0) {
                                        var noRejected = $f('getFromObject')($scope.operationTotals[process[c].$id], valuesFields[2], 0);
                                        totalObj[process[c].name + ' RECHAZADO'] = rejected;
                                        totalObj[process[c].name] = noRejected;
                                    } else {
                                        totalObj[process[c].name] = $f('getFromObject')($scope.operationTotals[process[c].$id], valuesFields[0], 0);
                                    }
                                }
                                if (thisConcept.nature === 'perception' || thisConcept.nature !== 'deduction') {
                                    totalObj[process[c].name] = $f('getFromObject')($scope.operationTotals[process[c].$id], valuesFields[0], 0);
                                }
                            }
                        }
                    } else {
                        totalObj[process[c].name] = '';
                    }
                }
            }

            calculations.push(totalObj);
            $log.log(calculations);
            var fields = opObjs.process.fb.find(function (data) {
                return data.id === tabSelected;
            });
            if (angular.isDefined(fields) && angular.isArray(fields.totals) && fields.totals.length > 0) {
                var totals = $filter('orderBy')(fields.totals, 'order');
                totals.unshift(
                    { $id: '', active: true, default: false, name: '' },
                    { $id: 'bill', active: true, default: false, name: 'FACTURACION' }
                );
                for (var i = 0; i < totals.length; i++) {
                    if ($scope.operationTotals.hasOwnProperty(totals[i].$id)) {
                        var operation = (angular.isDefined(totals[i].operation)) ? totals[i].operation + 1 : 1;
                        calculations.push({ NOMBRE: totals[i].name, CC: $scope.operationTotals[totals[i].$id][totals[i].field] * operation });
                    } else {
                        calculations.push({ NOMBRE: totals[i].name });
                    }
                }
            }

            var promises = [];
            if ($scope.tabSelected === 'fiscal' || $scope.tabSelected === 'socialPrevision') {
                if ($scope.tabSelected === 'fiscal' && $scope.operationType === 'asimilated') {
                    type = 'ASIMILADOS'
                } else if ($scope.tabSelected === 'fiscal' && $scope.operationType === 'ptuRecord') {
                    type = 'PTU'
                }
                promises.push($filter('getCompaniesName')($scope.payrollId, type));
            }
            Promise.all(promises).then(function (response) {
                var businessName = response[0];
                if (['fiscal', 'socialPrevision'].indexOf($scope.tabSelected) > -1) {
                    if (angular.isDefined(businessName.data)) {
                        headers.unshift([businessName.data.businessName]);
                    } else {
                        throw businessName.message;
                    }
                }
                calculations.push({}, {}, {}, {}, { "NOMBRE": 'LIC. ' + $filter('uppercased')(AppF.profile.data.name) }, { "NOMBRE": "EJECUTIVO DE CUENTAS" });
                var thisCalendar = $filter('getFromObject')(opObjs.operation.fb, 'calendar') ? '_' + opObjs.operation.fb.calendar : '';
                var thisPeriod = $filter('getFromObject')(opObjs.operation.fb, 'specialPeriod') ? '_' + $filter('zeroFill')(opObjs.operation.fb.specialPeriod, 3) : '';
                var thisCenter = AppF.center.toUpperCase();

                var thisFileName;
                if ($scope.operationType === 'ptuDistributionRecord') {
                    thisFileName = "DISTRIBUCION_PTU_" + $filter('nameOfL')(opObjs.operation.fb.companiesRecordId, $scope.L.companiesRecords) + '_' + opObjs.operation.fb.calendar;
                } else {
                    thisFileName = 'TOT_' + thisCenter + thisCalendar + '_' + opObjs.payroll.fb.data.class + '_' + opObjs.payroll.fb.data.name + thisPeriod;
                }
                var data = {
                    data: angular.toJson(calculations),
                    headers: angular.toJson(headers),
                    filename: thisFileName
                };
                CatalogsF.exportToExcel('interface/exportDataWithHeader', data);
            }).catch(function (error) {
                errAlertS(error);
            });
        };
        function sendBillByEmail(id, employeeId) {
            var employee = allEmployeesO[employeeId];
            return $http.get(window.__env.serviceWorkerUrl + 'sendBillOfEmployee/' + id + '?companiesRecordId=' + employee.rpData.companiesRecord).then(function (resp) {
                $log.log(resp);
                successAlertS(resp.data);
            }).catch(errAlertS);
        }
        $scope.sendManyByEmail = function (selected) {
            if (angular.isArray(selected) && selected.length > 0) {
                for (var e = 0; e < selected.length; e++) {
                    var billId = $filter('getFromObject')($scope.operation.employees, selected[e].$id + ".billId");
                    if (angular.isUndefined(billId)) {
                        errAlertS('El empleado ' + allEmployeesO[selected[e].$id].data.name + ' no tiene el recibo');
                    } else {
                        sendBillByEmail(billId, selected[e].$id)
                    }
                }
            } else {
                errAlertS("No se selecciono ningún empleado")
            }
        }
        $scope.generateAccountingAccount = function () {
            var process = $scope.process.find(function (process) {
                return process.id === $scope.tabSelected;
            });
            if (!process) {
                errAlertS('No se encontró el nombre del proceso');
                return false;
            }
            var data = {
                specialPeriod: opObjs.operation.fb.specialPeriod,
                operationType: $scope.operationType,
                operationId: opObjs.operation.fb.$id,
                dispersionId: opObjs.operation.fb.dispersion,
                payrollId: $scope.payrollId,
                calendar: $filter('getFromObject')(opObjs.operation.fb, 'calendar'),
                period: $filter('getFromObject')(opObjs.operation.fb, 'period'),
                process: process.id
            }
            $scope.C.exportToExcel('interface/exportAnyFiles', { data: angular.toJson([data]), nameF: 'exportAccount' });
        }

        $scope.generateAccountingAccountBy2 = function (process) {

            $log.log('generateAccountingAccountBy2 called', process);
            var data = {
                operationType: $scope.operationType,
                operationId: opObjs.operation.fb.$id,
                dispersionId: opObjs.operation.fb.dispersion,
                payroll: $scope.payrollId,
                payrollId: $scope.payrollId,
                calendar: $filter('getFromObject')(opObjs.operation.fb, 'calendar'),
                downloading: false,
                period: $filter('getFromObject')(opObjs.operation.fb, 'period'),
                process: process,
                processName: process.toUpperCase()
            }
            $scope.C.exportToExcel('interface/exportAccountingAccounts', { data: angular.toJson([data]), nameF: 'exportAccount' });
        };

        $scope.generateAccountingAccountCompaq = function (process) {
            $rootScope.loadingProgress = true;
            var data = {
                operationType: $scope.operationType,
                operationId: opObjs.operation.fb.$id,
                dispersionId: opObjs.operation.fb.dispersion,
                payroll: $scope.payrollId,
                payrollId: $scope.payrollId,
                calendar: $filter('getFromObject')(opObjs.operation.fb, 'calendar'),
                downloading: false,
                period: $filter('getFromObject')(opObjs.operation.fb, 'period'),
                process: process,
                processName: process.toUpperCase()
            }
            var obj = {
                data: angular.toJson([data]),
                nameF: 'exportAccount'
            };
            var path = 'interface/exportAccountingAccountsCompaq';
            $rootScope.C.exportToExcel(path, obj, true).then(function () {
                data.downloadingLayout = false;
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync()
            }).catch(function () {
                data.downloadingLayout = false;
                $scope.$evalAsync()
            });
        }


        $scope.exportPaymentForms = function () {
            var process = $scope.process.find(function (process) {
                return process.id === $scope.tabSelected;
            });
            if (!process) {
                errAlertS('No se encontró el nombre del proceso');
                return false;
            }
            var type = process.name;
            var employees = $f('orderBy')($scope.fiscalEmployees, $scope.order);
            if ($scope.tabSelected === 'socialPrevision') {
                employees = $f('orderBy')($scope.operationEmployees, $scope.order);
            }
            if ($scope.tabSelected === 'fiscal' && $scope.operationType === 'asimilated') {
                type = "ASIMILADOS";
            } else if ($scope.tabSelected === 'fiscal' && $scope.operationType === 'ptuRecord') {
                type = 'PTU';
            }
            $filter('getCompaniesName')($scope.payrollId, type, { function: 'paymentForm', name: 'banks' }).then(function (response) {
                var businessName = response;
                if (angular.isDefined(businessName.data)) {
                    var processName = process.alias || process.name;
                    if ($scope.tabSelected === 'fiscal' && $scope.operationType === 'asimilated') {
                        processName = "ASIMILADOS";
                    } else if ($scope.tabSelected === 'fiscal' && $scope.operationType === 'ptuRecord') {
                        processName = 'PTU';
                    } else if ($scope.operationType === 'chrisBonusRecord') {
                        processName = $scope.tabSelected;
                    }
                    var data = getDataForPaymentForms(processName, employees, response.banks.bankAccounts, $scope.operationType, process.id);
                    var error = angular.fromJson(angular.toJson(data.error));
                    delete data.error;
                    if (data.footer.totalEmployees > 0) {
                        $rootScope.loadingProgress = true;
                        var thisCalendar = $filter('getFromObject')(opObjs.operation.fb, 'calendar') ? '_' + opObjs.operation.fb.calendar : '';
                        var thisPeriod = $filter('getFromObject')(opObjs.operation.fb, 'specialPeriod') ? '_' + $filter('zeroFill')(opObjs.operation.fb.specialPeriod, 3) : '';
                        var thisCenter = AppF.center.toUpperCase();
                        data.filename = "RFP_" + businessName.data.name + "_" + thisCenter + thisCalendar + '_' + opObjs.payroll.fb.data.class + '_' + opObjs.payroll.fb.data.name + thisPeriod;
                        data.header.businessName = businessName.data.businessName;
                        var params = {
                            data: angular.toJson(data)
                        }
                        $http({
                            method: 'POST',
                            url: window.__env.serviceWorkerUrl + "interface/pdf/operations/paymentForms",
                            responseType: 'arraybuffer',
                            data: params
                        }).then(function (response) {
                            var headers = response.headers();
                            var filename = headers['x-filename'];
                            var contentType = headers['content-type'];
                            var linkElement = document.createElement('a');
                            try {
                                var blob = new Blob([response.data], {
                                    type: contentType
                                });
                                var url = window.URL.createObjectURL(blob);
                                linkElement.setAttribute('href', url);
                                linkElement.setAttribute("download", filename);
                                var clickEvent = new MouseEvent("click", {
                                    "view": window,
                                    "bubbles": true,
                                    "cancelable": false
                                });
                                linkElement.dispatchEvent(clickEvent);
                                $rootScope.loadingProgress = false;
                                $rootScope.$evalAsync(function () {
                                    $log.debug('generatePdf finished');
                                });
                            } catch (ex) {
                                $log.error(ex, "error descargando el archivo");
                                $rootScope.loadingProgress = false;
                                $rootScope.$evalAsync();
                            }
                        }).catch(function (err) {
                            errAlertS(err);
                            $rootScope.loadingProgress = false;
                            $rootScope.$evalAsync();
                        });
                        for (var i = 0; i < error.length; i++) {
                            errAlertS(error[i]);
                        }
                    } else {
                        if (Object.keys(data.body).length === 0 && error.length === 0) {
                            errAlertS('No se encontró ningún empleado con la cuenta seleccionada');
                        }
                        for (var i = 0; i < error.length; i++) {
                            errAlertS(error[i]);
                        }
                    }
                } else {
                    errAlertS(businessName.message);
                }
            }).catch(function (error) {
                errAlertS(error);
            });
        }
        function getDataForPaymentForms(type, employees, banksAccountId, operationType, processId) {
            var processName = {
                "chrisBonusRecord_PREVISION": 'COMPLEMENTO',
                "chrisBonusRecord_socialPrevision": 'COMPLEMENTO'
            }
            var pName = "";
            if (processName.hasOwnProperty(operationType + '_' + type)) {
                pName = processName[operationType + '_' + type];
            } else {
                pName = operationType ? $filter('translate')('b.' + operationType) : type
            }
            var data = {
                header: {
                    payroll: opObjs.payroll.fb.data.name,
                    class: opObjs.payroll.fb.data.class,
                    type: 'Formas de Pago Nomina',
                    period: $filter('zeroFill')(opObjs.operation.fb.specialPeriod, 3),
                    dateStart: moment(opObjs.operation.fb.specialDate).format('DD/MM/YYYY'),
                    dateEnd: moment(opObjs.operation.fb.specialDate).format('DD/MM/YYYY'),
                    process: pName,
                    date: moment().format('DD/MM/YYYY'),
                    hour: moment().format('HH:mm:ss'),
                    businessName: []
                },
                body: {},
                footer: {},
                error: []
            };
            var calc = $scope.calculations;
            var paymentForms = $scope.M.paymentForms;
            var paymentFormsObj = {};
            var totalObj = {};
            for (var p = 0; p < paymentForms.length; p++) {
                if (angular.isUndefined(data.body[paymentForms[p].name])) {
                    data.body[paymentForms[p].name] = {};
                }
                paymentFormsObj[paymentForms[p]._id] = {
                    name: paymentForms[p].name
                }
                if (angular.isUndefined(totalObj[paymentForms[p].name])) {
                    totalObj[paymentForms[p].name] = {};
                }
            }
            data.body['SPEI'] = {};
            totalObj['SPEI'] = {};
            var banksObj = {};
            if (angular.isArray(banksAccountId)) {
                for (var b = 0; b < banksAccountId.length; b++) {
                    var bankId = $scope.M.bankAccounts.find(function (value) {
                        return value._id === banksAccountId[b];
                    });
                    if (angular.isDefined(bankId) && !bankId.isSpei) {
                        var bankName = $scope.M.banks.find(function (value) {
                            return value._id === bankId.bank;
                        });
                        if (angular.isDefined(bankName)) {
                            if (angular.isUndefined(banksObj[bankName.name])) {
                                banksObj[bankName.name] = {}
                            }
                        }
                    }
                }
            }
            for (var i = 0; i < employees.length; i++) {
                var employee = allEmployeesO[employees[i].$id];
                var totals = $filter('discountDispersionExempts')(calc[employee.$id], $scope.tabSelected);
                var total = totals.totalNoExempts;
                if (total > 0) {
                    try {
                        if (!$filter("getFromObject")(employee, "data.employeeNumber", false)) {
                            throw 'El empleado ' + employee.data.name + ' no tiene asignado un numero de empleado';
                        }
                        var defaultPaymentForm = paymentForms.find(function (value) {
                            return value.key === 'transfer';
                        });

                        var employeePaymentForm = $filter('getEmployeePaymentForm')(employee.paymentForms, processId, operationType)
                        if (angular.isDefined(paymentFormsObj[employeePaymentForm || defaultPaymentForm._id])) {
                            var payment = paymentFormsObj[employeePaymentForm || defaultPaymentForm._id].name;
                            if (angular.isUndefined(employeePaymentForm) || employeePaymentForm === defaultPaymentForm._id) {
                                var card = $f('getEmployeeAccount')(employee, $scope.tabSelected, operationType, defaultPaymentForm._id);
                                var account = card.number;
                                var bank = $scope.M.banks.find(function (value) {
                                    return value._id === card.bank;
                                });
                                if (angular.isUndefined(account)) {
                                    throw 'El empleado ' + employee.data.name + ' no tiene asignado una cuenta de banco';
                                }
                                if (bank) {
                                    var max = (banksObj.hasOwnProperty(bank.name)) ? (angular.isDefined(bank.accountLength) ? [bank.accountLength] : [10, 11]) : [18];
                                    var movementType = (banksObj.hasOwnProperty(bank.name)) ? 'la transferencia' : 'SPEI';
                                    if (max.indexOf(account.toString().length) === -1) {
                                        throw 'El empleado ' + employee.data.name + ' no tiene cuenta asignada para ' + movementType;
                                    }
                                } else {
                                    throw 'El empleado ' + employee.data.name + ' no tiene asignado una cuenta de banco';
                                }
                                payment = (banksObj.hasOwnProperty(bank.name)) ? payment : 'SPEI';
                                if (angular.isUndefined(data.body[payment][bank.name])) {
                                    data.body[payment][bank.name] = {
                                        body: [],
                                        footer: {}
                                    };
                                }
                                if (angular.isUndefined(totalObj[payment][bank.name])) {
                                    totalObj[payment][bank.name] = 0;
                                }
                                if (angular.isUndefined(totalObj[payment].TOTALEMPLOYEES)) {
                                    totalObj[payment].TOTALEMPLOYEES = 0;
                                }
                                totalObj[payment].TOTALEMPLOYEES++;
                                totalObj[payment][bank.name] = totalObj[payment][bank.name] + total;

                                var obj = {
                                    number: employee.data.employeeNumber,
                                    name: employee.data.name,
                                    account: account,
                                    total: $filter('number')(total, 2)
                                };
                                data.body[payment][bank.name].body.push(obj);
                                data.body[payment][bank.name].footer = {
                                    employees: data.body[payment][bank.name].body.length, total: $filter('number')(totalObj[payment][bank.name], 2)
                                }
                            } else {
                                if (angular.isUndefined(totalObj[payment].TOTAL)) {
                                    totalObj[payment].TOTAL = 0;
                                }
                                if (angular.isUndefined(totalObj[payment].TOTALEMPLOYEES)) {
                                    totalObj[payment].TOTALEMPLOYEES = 0;
                                }
                                if (angular.isUndefined(data.body[payment].body)) {
                                    data.body[payment] = {
                                        body: [],
                                        footer: {}
                                    }
                                }
                                totalObj[payment].TOTALEMPLOYEES++;
                                totalObj[payment].TOTAL = totalObj[payment].TOTAL + total;
                                data.body[payment].body.push({
                                    number: employee.data.employeeNumber,
                                    name: employee.data.name,
                                    total: $filter('number')(total, 2)
                                });
                                data.body[payment].footer = {
                                    employees: data.body[payment].body.length, total: $filter('number')(totalObj[payment].TOTAL, 2)
                                };
                            }
                        }
                    } catch (error) {
                        data.error.push(error);
                    }
                }
            }
            var allEmployees = 0;
            var totalGeneral = 0;
            for (var c in totalObj) {
                if ($filter('objectsLength')(data.body[c]) > 0 && angular.isDefined(totalObj[c].TOTALEMPLOYEES)) {
                    allEmployees = allEmployees + totalObj[c].TOTALEMPLOYEES;
                    totalGeneral = totalGeneral + ((totalObj[c].TOTAL) ? totalObj[c].TOTAL : 0)
                    if (angular.isUndefined(totalObj[c].TOTAL)) {
                        var totals = 0;
                        for (var t in totalObj[c]) {
                            if (t !== 'TOTALEMPLOYEES') {
                                totals = totals + totalObj[c][t];
                            }
                        }
                        data.body[c].totals = { totalAmount: $filter('number')(totals, 2) };
                        totalGeneral = totalGeneral + totals;
                    }
                } else {
                    delete data.body[c];
                }
            }
            data.footer = {
                totalEmployees: allEmployees,
                totalGeneral: $filter('number')(totalGeneral, 2)
            }
            return data;
        }
        $scope.allHave = function (selected, path) {
            var allHave = false;
            if (angular.isArray(selected) && selected.length > 0) {
                allHave = true;
                for (var e = 0; e < selected.length && allHave; e++) {
                    var value = $filter('getFromObject')($scope.operation.employees, selected[e].$id + "." + path)
                    if (angular.isUndefined(value)) {
                        allHave = false;
                    }
                }
            }
            return allHave;
        }
        $scope.startToBill = function (ev) {
            billOperationS(ev, $scope, opObjs);
        }
        function getFileRequest(publicLink) {
            return new Promise(function (resolve, reject) {
                var xhr = new XMLHttpRequest();
                xhr.responseType = 'blob';
                xhr.onload = function (event) {
                    var blob = xhr.response;
                    resolve(blob);
                };
                xhr.open('GET', publicLink);
                xhr.send();
                xhr.addEventListener('error', reject);
                xhr.addEventListener('abort', reject);
            })
        }
        function cancelThisBill(uuid, dontStopLoading) {
            return new Promise(function (resolve) {
                ApiV3F.post('employees/cancelBill', { "uuid": uuid }).then(function (resp) {
                    if (!dontStopLoading) {
                        $rootScope.loadingProgress = false;
                    }
                    successAlertS(resp.data);
                    resolve(true);
                }).catch(function (error) {
                    if (!dontStopLoading) {
                        $rootScope.loadingProgress = false;
                    }
                    $log.error(error);
                    errAlertS(error);
                    resolve(false);
                })
            });
        }
        $scope.cancelToBill = function (selected, ev) {
            var title = "Esta seguro de cancelar la factura?"
            var msg = "La factura que se cancelara ya no tendrá validez, esta es una cancelación definitiva, si necesitas la factura, utiliza la opción de retimbrar";
            if (!angular.isArray(selected) || selected.length === 0) {
                title = "Esta seguro de cancelar todas las facturas?"
                msg = "Todas las facturas de esta operación sera canceladas y no tendrán validez, esta es una cancelación definitiva, si necesitas la factura, utiliza la opción de retimbrar";
            }
            $mdDialog.show($mdDialog
                .confirm(confirmConfig)
                .title(title)
                .htmlContent(msg)
                .ariaLabel('Deleting')
                .targetEvent(ev)
                .ok('SI')
                .cancel('NO'))
                .then(function () {
                    $rootScope.loadingProgress = true;
                    $scope.operation.$loaded().then(function () {
                        var promises = [];
                        var thisEmployees = !angular.isArray(selected) || selected.length === 0 ? $scope.fiscalEmployees : selected;
                        for (var t = 0; t < thisEmployees.length; t++) {
                            var uuid = $scope.operation.employees[thisEmployees[t].$id].billId
                            if (angular.isDefined(uuid) && $scope.operation.employees[thisEmployees[t].$id].status !== 3.5) {
                                promises.push(cancelThisBill(uuid, true));
                            }
                        }
                        return Promise.all(promises);
                    }).then(function (resp) {
                        $log.log(resp);
                        successAlertS("Se termino el proceso de cancelación de las facturas");
                    }).catch(function (error) {
                        $log.error(error);
                    }).then(function () {
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync();
                        $timeout(function () { }, 0, false);
                    });
                }, function () {
                    $log.debug('Deleting Cancelled');
                });
        };
        $scope.downloadManyFiles = function (selected, file) {
            if (angular.isArray(selected) && selected.length > 0) {
                var promises = [];
                var promisesIndex = [];
                for (var e = 0; e < selected.length; e++) {
                    var bucketUrl = $filter('getFromObject')($scope.operation.employees, selected[e].$id + "." + file);
                    var fileName = $filter('getFromObject')($scope.operation.employees, selected[e].$id + ".fileName");
                    if (angular.isUndefined(bucketUrl)) {
                        errAlertS('El empleado ' + allEmployeesO[selected[e].$id].data.name + ' no tiene la url definida');
                    } else {
                        promises.push(firebase.storage().ref().child(bucketUrl).getDownloadURL());
                        promisesIndex.push(fileName)
                    }
                }
                Promise.all(promises).then(function (resp) {
                    promises = [];
                    for (var r = 0; r < resp.length; r++) {
                        promises.push(getFileRequest(resp[r]));
                    }
                    return Promise.all(promises);
                }).then(function (blobs) {
                    for (var b = 0; b < blobs.length; b++) {
                        var url = window.URL.createObjectURL(blobs[b]);
                        var linkElement = document.createElement('a');
                        linkElement.setAttribute('href', url);
                        linkElement.setAttribute('download', promisesIndex[b]);
                        var clickEvent = new MouseEvent("click", {
                            "view": window,
                            "bubbles": true,
                            "cancelable": false
                        });
                        linkElement.dispatchEvent(clickEvent);
                    }
                }).catch(function (error) {
                    $log.log(error);
                    errAlertS('Error al obtener los archivos')
                });
            } else {
                errAlertS("No se selecciono ningún empleado")
            }
        }

        $scope.dowloadFile = function (bucketUrl) {
            var storageRef = firebase.storage().ref();
            var imagesRef = storageRef.child(bucketUrl);
            imagesRef.getDownloadURL().then(function (url) {
                var xhr = new XMLHttpRequest();
                xhr.responseType = 'blob';
                xhr.onload = function (event) {
                    var blob = xhr.response;
                    var url = window.URL.createObjectURL(blob);
                    var linkElement = document.createElement('a');
                    linkElement.setAttribute('href', url);
                    linkElement.setAttribute('download', 'new');
                    var clickEvent = new MouseEvent("click", {
                        "view": window,
                        "bubbles": true,
                        "cancelable": false
                    });
                    linkElement.dispatchEvent(clickEvent);
                };
                xhr.open('GET', url);
                xhr.send();
            }).catch(function (error) {
                switch (error.code) {
                    case 'storage/object-not-found':
                        errAlertS("No se encontró el documento")
                        break;
                    case 'storage/unauthorized':
                        errAlertS("No se tiene permiso para acceder al archivo")
                        break;
                    case 'storage/canceled':
                        errAlertS("El usuario cancelo el dato");
                        break;
                    case 'storage/unknown':
                        errAlertS('Error desconocido intente nuevamente')
                        break;
                }
            });
        }
        function buildCtx(periodOverride) {
            return {
                periodEnd: opObjs.period.fb.end,
                serverTime: $scope.D.getCurrentServerTime(),
                processes: $scope.process,
                payrollId: $scope.payrollId,
                banksAccounts: $scope.M.bankAccounts,
                banks: $scope.M.banks,
                fiscalEmployees: $scope.fiscalEmployees,
                operationEmployees: $scope.operationEmployees,
                order: $scope.order,
                tabSelected: $scope.tabSelected,
                allEmployeesO: allEmployeesO,
                payroll: opObjs.payroll,
                period: opObjs.period,
                periodOverride: periodOverride,
                calendar: opObjs.operation.fb.calendar,
                opProcessList: opObjs.process.fb,
                calc: $scope.calculations,
                paymentForms: $scope.M.paymentForms,
                operationType: $scope.operationType,
                serviceWorkerUrl: window.__env.serviceWorkerUrl,
                addUtf8BomForCsv: true
            };
        }
        $scope.layoutBanks = function (event, bankAccount, employeesSelected) {
            var ctx = buildCtx(undefined);
            BankLayoutFlow.run(event, bankAccount, employeesSelected, ctx).catch(function (err) {
                errAlertS(err);
            });
        };
        function addDate(params) {
            var bank = params.bank;
            var maxDate = AppF.holydaysInMexico.getDateOfXLabourDaysFromNow(15, opObjs.period.fb.end).date;
            var event = params.event;
            var minDate;
            if ($f('lowercase')(bank.name) === 'hsbc') {
                minDate = moment($scope.D.getCurrentServerTime()).toDate();
            } else {
                minDate = AppF.holydaysInMexico.getDateOfXLabourDaysSinceNow(15, opObjs.period.fb.end).date;
            }
            $mdDialog.show({
                templateUrl: 'app/main/clients/views/newoperation/dialogs/date.html',
                locals: {
                    minDate: minDate,
                    maxDate: maxDate
                },
                controller: function (scope, minDate, maxDate) {
                    scope.bank = params.bank;
                    scope.minDate = minDate;
                    scope.maxDate = maxDate;
                    scope.layoutBanks = function (thisParams) {
                        params.extraParams = thisParams;
                        layoutBanks(params);
                        scope.cancel();
                    }
                    scope.onlyWeekendsPredicate = function (date) {
                        var day = date.getDay();
                        return day === 1 || day === 2 || day === 3 || day === 4 || day === 5;
                    }
                    scope.cancel = function () {
                        $mdDialog.hide();
                    }
                },
                parent: angular.element(document.body),
                targetEvent: event,
                clickOutsideToClose: true
            });
        }

        function layoutBanks(data) {
            var filterName = $filter('convertToCamelCase')('get_data_for_layouts_' + data.fileRoute);
            var filter = $filter('getFilterIfExists')(filterName);
            if (!filter) {
                errAlertS("No existe el archivo de layout del banco seleccionado");
                return false;
            }
            $rootScope.loadingProgress = true;
            var employees = $f('orderBy')($scope.fiscalEmployees, $scope.order);
            if ($scope.tabSelected === 'socialPrevision') {
                employees = $f('orderBy')($scope.operationEmployees, $scope.order);
            }
            var bankName = angular.lowercase(data.fileRoute);
            var thisPeriod = {
                fb: {
                    dateStart: moment(opObjs.operation.fb.specialDate).format('DD-MM-YYYY'),
                    dateEnd: moment(opObjs.operation.fb.specialDate).format('DD-MM-YYYY'),
                    period: opObjs.operation.fb.specialPeriod
                }
            }
            var process = opObjs.process.fb.find(function (value) {
                return value.id === $scope.tabSelected;
            });
            var areAll = false;
            var thisEmployees = data.employeesSelected;
            if ((!angular.isArray(thisEmployees)) || thisEmployees.length === 0) {
                thisEmployees = employees;
                areAll = true;
            }
            var params = {
                processes: $scope.process,
                payrollId: $scope.payrollId,
                banksAccounts: $scope.M.bankAccounts,
                banks: $scope.M.banks,
                bank: data.bank,
                bankAccount: data.bankAccount,
                employees: thisEmployees,
                areAll: areAll,
                allEmployeesO: allEmployeesO,
                payroll: opObjs.payroll,
                period: thisPeriod,
                calendar: opObjs.operation.fb.calendar,
                calc: $scope.calculations,
                paymentForms: $scope.M.paymentForms,
                tabSelected: $scope.tabSelected,
                operationType: $scope.operationType,
                processName: process.name
            }
            $filter('loopEach')(data.extraParams, function (value, index) {
                params[index] = value;
            })
            $log.log('parantros data', params)
            $f(filterName)(params).then(function (resp) {
                $log.log('parantros data', params)

                if (angular.isDefined(resp.error) && angular.isArray(resp.error) && resp.error.length > 0) {
                    errAlertS(resp.error);
                }
                if (angular.isDefined(resp.success)) {
                    if (angular.isArray(resp.success) && resp.success.length === 0) {
                        throw "No existe ningún registro para layout de " + data.bank.name;
                    }
                    if (angular.isObject(resp.success) && angular.isDefined(resp.success.body) && resp.success.body.length === 0) {
                        throw "No existe ningún registro para layout de " + data.bank.name;
                    }
                    var objData = {
                        data: angular.toJson(resp.success),
                        bankName: $filter('convertToCamelCase')(bankName)
                    }
                    if (angular.isDefined(resp.filename)) {
                        objData.filename = resp.filename;
                    }
                    $http({
                        method: 'POST',
                        url: window.__env.serviceWorkerUrl + "interface/pag/layout/dispersion",
                        responseType: 'arraybuffer',
                        data: objData
                    }).then(function (response) {
                        var headers = response.headers();
                        var filename = headers['x-filename'];
                        var contentType = headers['content-type'];
                        var linkElement = document.createElement('a');
                        try {
                            var blobArray = [];
                            if (contentType.indexOf('text/csv') > -1 && contentType.indexOf('utf-8') > -1) {
                                blobArray.push('\ufeff')
                            }
                            blobArray.push(response.data);
                            var blob = new Blob(blobArray, {
                                type: contentType
                            });
                            var url = window.URL.createObjectURL(blob);
                            linkElement.setAttribute('href', url);
                            linkElement.setAttribute("download", filename);
                            var clickEvent = new MouseEvent("click", {
                                "view": window,
                                "bubbles": true,
                                "cancelable": false
                            });
                            linkElement.dispatchEvent(clickEvent);
                            $rootScope.loadingProgress = false;
                            $rootScope.$evalAsync(function () {
                                $log.debug('generate file .pag finished');
                            });
                        } catch (ex) {
                            $log.error(ex, "error descargando el archivo");
                            $rootScope.loadingProgress = false;
                            $rootScope.$evalAsync();
                        }
                    }).catch(function (err) {
                        var message = new TextDecoder("utf-8").decode(err.data);
                        var error = angular.fromJson(message);
                        errAlertS(error.data);
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync();
                    });
                } else {
                    errAlertS("No existe ningún registro para layout de " + data.bank.name);
                    $rootScope.loadingProgress = false;
                }
            }).catch(function (error) {
                $rootScope.loadingProgress = false;
                errAlertS(error);
            })
        }
        $scope.checkBankAccounts = function (bank, bankAccounts, tabSelected) {
            if (angular.isDefined(bank.hasLayout)) {
                var exist = false;
                var process = opObjs.process.fb.find(function (value) {
                    return value.id === tabSelected;
                });
                var processName = process.name;
                if (tabSelected === 'fiscal' && $scope.operationType === 'asimilated') {
                    processName = "ASIMILADOS";
                } else if ($scope.tabSelected === 'fiscal' && $scope.operationType === 'ptuRecord') {
                    processName = 'PTU';
                }
                var processBanks = $f('getFromObject')(opObjs.payroll.fb.processes[processName], 'bankAccounts');
                if (angular.isUndefined(processBanks) && $scope.tabSelected === 'fiscal' && $scope.operationType === 'ptuRecord' && angular.isUndefined($f('getFromObject')(opObjs.payroll.fb.processes[processName], 'companiesRecord'))) {
                    processBanks = $f('getFromObject')(opObjs.payroll.fb.processes.FISCAL, 'bankAccounts');
                }
                if (angular.isDefined(processBanks) && angular.isArray(processBanks) && processBanks.length > 0) {
                    var filterB = [];
                    for (var i = 0; i < processBanks.length; i++) {
                        var type = bankAccounts.find(function (value) {
                            return value._id === processBanks[i];
                        });
                        if (angular.isDefined(type)) {
                            filterB.push(type);
                        }
                    }
                    for (var f = 0; f < filterB.length; f++) {
                        if (filterB[f].bank === bank._id) {
                            exist = true;
                            break;
                        }
                    }
                }
            }
            return exist;
        }
        $scope.exportDispersionPaymentForms = function () {
            var process = $scope.process.find(function (process) {
                return process.id === $scope.tabSelected;
            });
            if (!process) {
                errAlertS('No se encontró el nombre del proceso');
                return false;
            }
            var type = process.name;
            var employees = $f('orderBy')($scope.fiscalEmployees, $scope.order);
            if ($scope.tabSelected === 'socialPrevision') {
                employees = $f('orderBy')($scope.operationEmployees, $scope.order);
            }
            $filter('getCompaniesName')($scope.payrollId, type, { function: 'paymentForm', name: 'banks' }).then(function (response) {
                var businessName = response;
                if (angular.isDefined(businessName.data)) {
                    var complements = (process.alias) ? process.alias : process.name;
                    var data = getDataForPaymentForms(complements, employees, response.banks.bankAccounts, process.id);
                    var error = angular.fromJson(angular.toJson(data.error));
                    $log.log('datos', data)
                    if (data.footer.totalEmployees > 0) {
                        $rootScope.loadingProgress = true
                        var path = 'employees/downloadFileDispersion'
                        ApiV3F.exportToExcel(path, data).then(function (resp) {
                            $log.log(resp)
                            if (resp) {
                                $rootScope.loadingProgress = false;
                                $rootScope.$evalAsync(function () {
                                    $log.debug('generatePdf finished');
                                });
                                successAlertS('Se ha descargado el archivo correctamente');
                            }
                        }).catch(function (error) {
                            $rootScope.loadingProgress = false;
                            $rootScope.$evalAsync(function () {
                                $log.debug('generatePdf finished');
                            })
                            errAlertS(error);
                        })
                    } else {
                        if (Object.keys(data.body).length === 0 && error.length === 0) {
                            errAlertS('No se encontró ningún empleado con la cuenta seleccionada');
                        }
                        for (var i = 0; i < error.length; i++) {
                            errAlertS(error[i]);
                        }
                    }
                } else {
                    if (businessName.message) {
                        errAlertS(businessName.message);
                    }
                }
            })
        }
        $scope.confirmSendEmail = function (ev, selected, process) {
            if (process === 'fiscal') {
                var uuids = [];
                var errors = [];
                for (var e = 0; e < selected.data.length; e++) {
                    var status = $filter('getFromObject')($scope.operation.employees, selected.data[e].$id + ".status");
                    var billUid = $filter('getFromObject')($scope.operation.employees, selected.data[e].$id + ".billId");
                    if (angular.isUndefined(billUid) && status === 5) {
                        errors.push('El empleado ' + allEmployeesO[selected.data[e].$id].data.name + ' no tiene el recibo');
                    } else if (status === 5) {
                        uuids.push({ uuid: billUid });
                    }
                }
                if (uuids.length === 0) {
                    errors.unshift('No se encontró ningún dato para enviar');
                    errAlertS(errors);
                    return false;
                }
                selected = uuids;
            }
            var cParams = {
                dispersionId: opObjs.operation.fb.dispersion,
                operationId: opObjs.operation.fb.$id,
                operationType: $scope.operationType,
                period: $filter('zeroFill')(opObjs.operation.fb.specialPeriod, 3),
                calendar: opObjs.operation.fb.calendar,
            }
            $filter('sendBillsEmail')(selected, process, undefined, ev, cParams, undefined)
        }


        function sendEmail(selected) {
            var uuids = [];
            var errors = [];
            for (var e = 0; e < selected.length; e++) {
                var status = $filter('getFromObject')($scope.operation.employees, selected[e].$id + ".status");
                var billUid = $filter('getFromObject')($scope.operation.employees, selected[e].$id + ".billId");
                if (angular.isUndefined(billUid) && status === 5) {
                    errors.push('El empleado ' + allEmployeesO[selected[e].$id].data.name + ' no tiene el recibo');
                } else if (status === 5) {
                    uuids.push(billUid);
                }
            }
            if (uuids.length === 0) {
                errors.unshift('No se encontró ningún dato para enviar');
                errAlertS(errors);
                return false;
            }
            var data = {
                uuids: uuids,
                nameF: 'getDataBillM',
                center: $scope.F.center
            };
            $rootScope.loadingProgress = true;
            $http.post($window.__env.serviceWorkerUrl + 'models/bill/sendEmailBillFilesG', data).then(function (resp) {
                var success = resp.data.success;
                var error = resp.data.error;
                if (success.length > 0) {
                    successAlertS('Se envió ' + success.length + ' correos de forma exitosa');
                }
                if (error.length > 0) {
                    errors = errors.concat(error);
                    throw error;
                } else {
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                }
            }).catch(function (error) {
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
                errAlertS(error);
            });
        }

        function sendEmailPrevision(selected) {
            var thisPeriod = $filter('getFromObject')(opObjs.operation.fb, 'specialPeriod') ? '_' + $filter('zeroFill')(opObjs.operation.fb.specialPeriod, 3) : '';
            var params = {
                dispersionId: opObjs.operation.fb.dispersion,
                operationId: opObjs.operation.fb.$id,
                opType: $scope.operationType,
                employees: [],
                message: 'Estimado(a) {employeeName} se anexa el siguiente archivo correspondiente al Periodo: ' + thisPeriod + ' del año: ' + opObjs.operation.fb.calendar + ', Proceso: ALTER'
            };
            for (var i = 0; i < selected.length; i++) {
                params.employees.push(selected[i].$id)
            }
            $rootScope.loadingProgress = true;
            $http.post($window.__env.serviceWorkerUrl + 'models/bill/sendEmailBillPrevision', params).then(function (resp) {
                var success = resp.data.success;
                var error = resp.data.error;
                if (success.length > 0) {
                    successAlertS('Se envió ' + success.length + ' correos de forma exitosa');
                }
                if (error.length > 0) {
                    throw error;
                } else {
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                }
            }).catch(function (error) {
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
                errAlertS(error);
            });
        }
        function turnOffWatchers(all) {
            for (var watcherKey in watchers) {
                if (watchers.hasOwnProperty(watcherKey)) {
                    if (angular.isFunction(watchers[watcherKey]) && (all || (!all && watcherKey !== 'onDestroy'))) {
                        watchers[watcherKey]();
                        delete watchers[watcherKey];
                    }
                }
            }
        }
        watchers.onDestroy = $scope.$on('$destroy', function () {
            turnOffWatchers(true);
        });
        startAfterInitFilter($scope, {}, initiated, init);
    }
})();
(function () {
    'use strict';

    angular
        .module('app.clients')
        .controller('Operation3RDController', Operation3RDController);

    function Operation3RDController(
        $scope,
        $rootScope,
        $state,
        $log,
        $q,
        errAlertS,
        AppF,
        $filter,
        $mdBottomSheet,
        $mdDialog,
        ListsF,
        DataF,
        CatalogsF,
        $timeout,
        successAlertS,
        $http,
        $window,
        confirmConfig,
        $document,
        startAfterInitFilter,
        cleanArrayOfDataFilter,
        confirmOperationS,
        billOperationS,
        apiv2,
        ApiV3F,
        BankLayoutFlow
    ) {
        // si necesitas cargar catálogos de mongo pon sus nombres aquí
        var dataNeeded = ['subsidyRecords', 'cyvRecords', 'isrRecords', 'bankAccounts', 'paymentForms', 'banks', 'imssRecords', 'paymentFrequenciesRecords', 'directives', 'nfdRecords', 'placesOfWorkRecords', 'geoZones', 'states']; // ex: ['countries', 'states', 'regimes']
        var initiated = false;
        var $f = $filter;
        var backState = 'app.processes.operations';
        var watchers = {};
        var savingFastIncidences = {};
        var rejectIncidencesByEmployee = {};
        var processIncidencesByEmployee = {};
        var processIncidences = {};
        var firstIgnored = {};
        var dataUsedToCalc = {};
        var allEmployeesO = {};
        var opObjs = {};
        var auxProccess = [];
        var incidenceTypeForPenDays;
        $scope.myPageOperation = 1;
        $scope.myPageFiscal = 1;
        $scope.myLimitOperation = 50;
        $scope.myLimitFiscal = 50;

        $scope.actionMessages = 'Iniciando..';
        $scope.operationProgress = 0;
        $scope.search = {};
        $scope.calculations = {};
        $scope.operationEmployeesFiltered = [];
        var operationEmployeesF = [];
        $scope.fastIncidences = {};
        $scope.rejectedIncidences = [];
        $scope.fiscalEmployeesFiltered = [];
        var fiscalEmployeesF = [];
        $scope.paginationOpe = [50, 100, 500, {
            label: 'Todos',
            value: function () {
                return $scope.operationEmployees.length;
            }
        }];
        $scope.paginationFis = [50, 100, 500, {
            label: 'Todos',
            value: function () {
                return $scope.fiscalEmployees.length;
            }
        }];
        $scope.selected = [];
        $scope.operationData = {};
        $scope.opStatusNotCalc = 3;
        $scope.order = ['data.enroleDate', 'data.name'];
        $scope.showProgress = true;
        $scope.employeesStatusByOp = {
            '1': {
                nextStatus: [1, 2, 3],
                status: 0
            },
            '2': {
                nextStatus: [2, 3],
                status: 1
            },
            '2.5': {
                nextStatus: [3],
                status: 2
            }
        };
        AppF.opstatusByEmployeeStatus = {
            '3': 3,
            '2': 2.5,
            '1': 2
        };
        AppF.notCalculate = false;
        AppF.calculationOfEmployee = {};
        AppF.operationData = {};
        var actionsQueue = [];
        $scope.executing = false;
        $scope.closeOperation = true;
        //INICIO DE LAS FUNCIONES
        function executeAction() {
            if (!$scope.executing && actionsQueue.length > 0) {
                $scope.executing = true;
                var promise;
                var action = actionsQueue[0][0];
                var fbData = actionsQueue[0][1];
                var executeCalculation = actionsQueue[0][2];
                var initTime = new Date().valueOf();
                $log.debug('Iniciando ' + action);
                try {
                    switch (action) {
                        case 'setVariablesOfOperation':
                            $scope.actionMessages = 'Estableciendo permisos de operación..';
                            setOperationVariables();
                            break;
                        case 'checkActionForThisOperation':
                            $scope.actionMessages = 'Escuchando cambios..';
                            var employeeId;
                            if (fbData.catalog === 'credits' && $scope.payrollId === fbData.data.payroll) {
                                employeeId = fbData.data.employee;
                                if (fbData.action === 'delete') {
                                    allEmployeesO[employeeId].creditData = undefined;
                                } else {
                                    allEmployeesO[employeeId].creditData = angular.fromJson(angular.toJson(fbData.data));
                                }
                            }
                            if (fbData.catalog === 'employees' && $scope.payrollId === fbData.data.payroll) {
                                employeeId = fbData.id;
                                opObjs.employees.fb[employeeId] = fbData.data;
                                opObjs.employees.fb[employeeId].$id = employeeId;
                                promise = addForAction('loadEmployees');
                            }
                            if (fbData.catalog === 'movements') {
                                var movement = fbData.data;
                                movement.$id = fbData.id;
                                validateMovement(movement, fbData.action);
                            }
                            break;
                        case 'setConceptsMap':
                            $scope.actionMessages = 'Generando conceptos..';
                            $f('setInObjectPath')('conceptsById.fb', opObjs, $filter('keyObjectAsKey')(opObjs.concepts.fb, '$id', undefined, 'order'), true, true);
                            var allConcepts = $filter('keyObjectAsKey')(opObjs.concepts.fb, 'key');
                            allConcepts = Object.assign(allConcepts, $filter('keyObjectAsKey')(opObjs.concepts.fb.filter(function (item) { return item.payroll === $scope.payrollId; }), 'key'));
                            $f('setInObjectPath')('conceptsByKey.fb', opObjs, allConcepts, true, true);
                            break;
                        case 'setPayrollOfEmployees':
                            $scope.actionMessages = 'Estableciendo datos de empleado..';
                            $f('loopEach')(allEmployeesO, function (employee, employeeId) {
                                if (employee.payroll === opObjs.payroll.fb.$id) {
                                    allEmployeesO[employeeId].payrollData = $f('clearObject')(opObjs.payroll.fb);
                                }
                            });
                            break;
                        case 'setThisBankAccounts':
                            $scope.actionMessages = 'Creando cuentas para este banco..';
                            $scope.thisBankAccounts = $filter('setThisBankAccounts')(opObjs.payroll.fb);
                            break;
                        case 'setOperationCcs':
                            $scope.actionMessages = 'Obteniendo centros de costo..';
                            $f('setInObjectPath')('employeesCcs.fb', opObjs, $f('filter')(opObjs.myCcs.fb, { payroll: $scope.payrollId }), true, true);
                            $scope.employeesCcs = [];
                            if (operationEmployeesF.length > 0) {
                                var employeesCcs = [];
                                var ccs = opObjs.employeesCcs.fb;
                                for (var c = 0; c < ccs.length; c++) {
                                    for (var e = 0; e < operationEmployeesF.length; e++) {
                                        var filterCcs = operationEmployeesF[e].movements.filter(function (value) {
                                            return value.cc === ccs[c].$id
                                        });
                                        if (filterCcs.length > 0) {
                                            var exist = employeesCcs.filter(function (value) {
                                                return value.$id === ccs[c].$id;
                                            });
                                            if (exist.length === 0) employeesCcs.push(ccs[c]);
                                        }
                                    }
                                }
                                $scope.employeesCcs = employeesCcs;
                            }
                            break;
                        case 'setDispersion':
                            $scope.actionMessages = 'Leyendo información de la dispersion si existe..';
                            $f('setInObjectPath')('dispersion.fb', opObjs, $f('transformCalculations')(opObjs.dispersionF.fb), true, true);
                            break;
                        case 'setLastDispersion':
                            $scope.actionMessages = 'Leyendo información de la dispersion si existe..';
                            $f('setInObjectPath')('lastDispersion.fb', opObjs, $f('transformCalculations')(opObjs.lastDispersionF.fb), true, true);
                            break;
                        case 'setProccess':
                            $scope.actionMessages = 'Obteniendo esquema..';
                            $f('setInObjectPath')('processFromPayroll.fb', opObjs, $f('getProcessOfPayrollForSettlement')($f('getFromObject')(opObjs.paymentSchema, 'fb'), opObjs.processConfig.fb, $f('getFromObject')(opObjs.dispersion, 'fb'), opObjs.operation.fb.status >= $scope.opStatusNotCalc, $f('getFromObject')(opObjs, 'concepts.fb', []), opObjs.payroll.fb), true, true);
                            break;
                        case 'setIncidences':
                            $scope.actionMessages = 'Obteniendo incidences..';
                            var pending = $f('getFromObject')(opObjs.pendingIncidences, 'fb', []).slice();
                            var applied = $f('getFromObject')(opObjs.incidencesApplied, 'fb', []).slice();
                            pending = pending.filter(function (item) {
                                return angular.isDefined(opObjs.conceptsById.fb[item.incidenceType]) && (opObjs.conceptsById.fb[item.incidenceType].key !== "diaspendientesdepago" || (opObjs.conceptsById.fb[item.incidenceType].key === "diaspendientesdepago" && item.date < opObjs.operation.fb.movement.date))
                            })
                            $f('setInObjectPath')('incidences.fb', opObjs, [].concat(pending, applied), true, true);
                            break;
                        case 'setIncidencesOfEmployees':
                            $scope.actionMessages = 'Generando sabana..';
                            $scope.defaultIncidences = $f('getDefaultIncidences')('settlement', opObjs.operation.fb, $f('getFromObject')(opObjs.calendar, 'fb.$id'), $f('getFromObject')(opObjs.period, 'fb.period'), opObjs.operation.fb.status >= $scope.opStatusNotCalc);
                            $f('setInObjectPath')('opIncidences.fb', opObjs, $f('getIncidencesOfSettlement')(opObjs.incidences.fb, $scope.defaultIncidences, $f('getFromObject')(opObjs, 'creditIncidences.fb', []), $f('getFromObject')(opObjs, 'constantsIncidences.fb'), opObjs.operation.fb.$id, allEmployeesO, opObjs.conceptsById.fb, $f('getFromObject')(opObjs.paymentSchema, 'fb'), opObjs.operation.fb.employees, $scope.payrollId), true, true);
                            $f('setInObjectPath')('incidencesByEmployee.fb', opObjs, $f('groupByField')(opObjs.opIncidences.fb, 'employee', false, 'data.date'), true, true);
                            $f('setInObjectPath')('process.fb', opObjs, $f('getProcessForOperation')(opObjs.processFromPayroll.fb, opObjs.opIncidences.fb, opObjs.conceptsById.fb, processIncidences, operationEmployeesF, $f('getFromObject')(opObjs.dispersion, 'fb'), opObjs.operation.fb.status >= 3), true, true);
                            $scope.process = opObjs.process.fb;
                            if (angular.isArray(operationEmployeesF)) {
                                for (var o = 0; o < operationEmployeesF.length; o++) {
                                    var employee = operationEmployeesF[o];
                                    var thisEmployeeId = employee.$id;
                                    allEmployeesO[thisEmployeeId].incidences = opObjs.incidencesByEmployee.fb[thisEmployeeId];
                                    allEmployeesO[thisEmployeeId].incidencesByType = $filter('groupByField')(opObjs.incidencesByEmployee.fb[thisEmployeeId], 'incidenceType', false, 'data.date');
                                    if (angular.isDefined(incidenceTypeForPenDays)) {
                                        if (allEmployeesO[thisEmployeeId].incidencesByType.hasOwnProperty(incidenceTypeForPenDays.$id)) {
                                            allEmployeesO[thisEmployeeId].pendingDaysIncidences = allEmployeesO[thisEmployeeId].incidencesByType[incidenceTypeForPenDays.$id];
                                        } else {
                                            allEmployeesO[thisEmployeeId].pendingDaysIncidences = []
                                        }

                                    }
                                }
                            }
                            break;
                        case 'setFastIncidencesTypes':
                            $scope.actionMessages = 'Obteniendo incidencias rápidas..';
                            $f('setInObjectPath')('incidencesTypes.fb', opObjs, $f('getConceptsForPayroll')(opObjs.concepts.fb, { 'type': 'incidenceType', 'allowManual': true, payroll: $scope.payrollId, process: 'settlement' }), true, true);
                            $scope.incidencesTypes = opObjs.incidencesTypes.fb;
                            break;
                        case 'setEmployeesMovement':
                            $scope.actionMessages = 'Estableciendo movimientos..';
                            $f('setInObjectPath')('movementsByEmployee.fb', opObjs, $f('groupByField')(opObjs.movements.fb, 'employee', false, 'data.date'), true, true);
                            break;
                        case 'calculate':
                            $scope.actionMessages = 'Calculando empleados..';
                            if (opObjs.operation.fb.status >= $scope.opStatusNotCalc) {
                                $scope.actionMessages = 'Obteniendo cálculos de empleados..';
                            }
                            if (!AppF.notCalculate) {
                                promise = calculate();
                            }
                            break;
                        case 'reloadOperation':
                            if (opObjs.operation.fb.status <= 3) {
                                $log.log('se va a recargar');
                                $state.reload();
                            }
                            break;
                        case 'loadEmployees':
                            $scope.actionMessages = 'Obteniendo empleados para la sabana..';
                            promise = loadEmployees();
                            break;
                        case 'activeWatchers':
                            promise = activeWatchers();
                            break;
                    }
                    if (angular.isDefined(promise)) {
                        promise.then(function () {
                            $log.debug('Termino ' + action + ' en:' + ((new Date().valueOf()) - initTime) + 'ms');
                        }).catch(function (error) {
                            $log.error('Error en ' + action, error);
                        }).then(function () {
                            $scope.$evalAsync(function () {
                                finishCalculation(executeCalculation);
                            });
                        });
                    } else {
                        $log.debug('Termino ' + action + ' en:' + ((new Date().valueOf()) - initTime) + 'ms');
                        finishCalculation(executeCalculation);

                    }
                } catch (error) {
                    $log.error('Error en ' + action, error);
                    finishCalculation(executeCalculation);
                }
            } else {
                $scope.actionMessages = 'Todo listo...✓';
                $scope.firstFinished = true;
                $timeout(function () {
                    $scope.$evalAsync();
                    $timeout(function () {
                        $scope.showProgress = false;
                        $scope.actionMessages = '';
                        $scope.$evalAsync();
                    }, 1000, false);
                }, 0, false);
            }
        }
        function finishCalculation(executeCalculation) {
            var current = 0;
            if ($scope.operationProgress < 100) {
                current = $scope.operationProgress;
            }
            var missing = 100 - current;
            var thisProgress = missing / actionsQueue.length;
            $scope.operationProgress = current + thisProgress;
            actionsQueue.shift();
            $scope.executing = false;
            if (executeCalculation && !AppF.notCalculate) {
                addForAction('calculate');
            }
            $timeout(function () {
                executeAction();
            }, 0, false); //false to not run another digest
        }
        function addForAction(action, fbData, executeCalculation, notExecute) {
            var indexAction = actionsQueue.findIndex(function (item) {
                return item[0] === action;
            });
            if (indexAction <= 0) {
                actionsQueue.push([action, fbData, executeCalculation]);
                if (!notExecute) {
                    executeAction();
                }
            }
        }
        function getDataForPaymentForms(type, employees, banksAccountId, processId) {
            var data = {
                header: {
                    payroll: opObjs.payroll.fb.data.name,
                    class: opObjs.payroll.fb.data.class,
                    type: 'Formas de Pago Nomina',
                    period: opObjs.period.fb.period,
                    dateStart: opObjs.period.fb.startString,
                    dateEnd: opObjs.period.fb.endString,
                    process: type,
                    date: moment().format('DD/MM/YYYY'),
                    hour: moment().format('HH:mm:ss'),
                    businessName: []
                },
                body: {},
                footer: {},
                error: []
            };
            var calc = $scope.calculations;
            var paymentForms = $scope.M.paymentForms;
            var paymentFormsObj = {};
            var totalObj = {};
            for (var p = 0; p < paymentForms.length; p++) {
                if (angular.isUndefined(data.body[paymentForms[p].name])) {
                    data.body[paymentForms[p].name] = {};
                }
                paymentFormsObj[paymentForms[p]._id] = {
                    name: paymentForms[p].name
                }
                if (angular.isUndefined(totalObj[paymentForms[p].name])) {
                    totalObj[paymentForms[p].name] = {};
                }
            }
            data.body['SPEI'] = {};
            totalObj['SPEI'] = {};
            var banksObj = {};
            if (angular.isArray(banksAccountId)) {
                for (var b = 0; b < banksAccountId.length; b++) {
                    var bankId = $scope.M.bankAccounts.find(function (value) {
                        return value._id === banksAccountId[b];
                    });
                    if (angular.isDefined(bankId) && !bankId.isSpei) {
                        var bankName = $scope.M.banks.find(function (value) {
                            return value._id === bankId.bank;
                        });
                        if (angular.isDefined(bankName)) {
                            if (angular.isUndefined(banksObj[bankName.name])) {
                                banksObj[bankName.name] = {}
                            }
                        }
                    }
                }
            }
            for (var i = 0; i < employees.length; i++) {
                var employee = allEmployeesO[employees[i].$id];
                // var total = ($scope.tabSelected === 'fiscal') ? calc[employee.$id].fiscalTotal.value.result : calc[employee.$id].socialPrevisionTotal.value.result;
                var totals = $filter('discountDispersionExempts')(calc[employee.$id], $scope.tabSelected);
                var total = totals.totalNoExempts;
                if (total > 0) {
                    try {
                        if (!$filter("getFromObject")(employee, "data.employeeNumber", false)) {
                            throw 'El empleado ' + employee.data.name + ' no tiene asignado un numero de empleado';
                        }
                        var defaultPaymentForm = paymentForms.find(function (value) {
                            return value.key === 'transfer';
                        });
                        var employeePaymentForm = $filter('getEmployeePaymentForm')(employee.paymentForms, processId)
                        if (angular.isDefined(paymentFormsObj[employeePaymentForm || defaultPaymentForm._id])) {
                            var payment = paymentFormsObj[employeePaymentForm || defaultPaymentForm._id].name;
                            if (angular.isUndefined(employeePaymentForm) || employeePaymentForm === defaultPaymentForm._id) {
                                var card = $f('getEmployeeAccount')(employee, $scope.tabSelected, 'ordinary', defaultPaymentForm._id);
                                var account = card.number;
                                var bank = $scope.M.banks.find(function (value) {
                                    return value._id === card.bank;
                                });
                                if (bank) {
                                    var max = (banksObj.hasOwnProperty(bank.name)) ? (angular.isDefined(bank.accountLength) ? [bank.accountLength] : [10, 11]) : [18];

                                    var movementType = (banksObj.hasOwnProperty(bank.name)) ? 'la transferencia' : 'SPEI';
                                    if (max.indexOf(account.toString().length) === -1) {
                                        throw 'El empleado ' + employee.data.name + ' no tiene cuenta asignada para ' + movementType;
                                    }
                                } else {
                                    throw 'El empleado ' + employee.data.name + ' no tiene asignado un banco a la cuenta';
                                }
                                payment = (banksObj.hasOwnProperty(bank.name)) ? payment : 'SPEI';
                                if (angular.isUndefined(data.body[payment][bank.name])) {
                                    data.body[payment][bank.name] = {
                                        body: [],
                                        footer: {}
                                    };
                                }
                                if (angular.isUndefined(totalObj[payment][bank.name])) {
                                    totalObj[payment][bank.name] = 0;
                                }
                                if (angular.isUndefined(totalObj[payment].TOTALEMPLOYEES)) {
                                    totalObj[payment].TOTALEMPLOYEES = 0;
                                }
                                totalObj[payment].TOTALEMPLOYEES++;
                                totalObj[payment][bank.name] = totalObj[payment][bank.name] + total;

                                var obj = {
                                    number: employee.data.employeeNumber,
                                    name: employee.data.name,
                                    account: account,
                                    total: $filter('number')(total, 2)
                                };
                                data.body[payment][bank.name].body.push(obj);
                                data.body[payment][bank.name].footer = {
                                    employees: data.body[payment][bank.name].body.length, total: $filter('number')(totalObj[payment][bank.name], 2)
                                }
                            } else {
                                if (angular.isUndefined(totalObj[payment].TOTAL)) {
                                    totalObj[payment].TOTAL = 0;
                                }
                                if (angular.isUndefined(totalObj[payment].TOTALEMPLOYEES)) {
                                    totalObj[payment].TOTALEMPLOYEES = 0;
                                }
                                if (angular.isUndefined(data.body[payment].body)) {
                                    data.body[payment] = {
                                        body: [],
                                        footer: {}
                                    }
                                }
                                totalObj[payment].TOTALEMPLOYEES++;
                                totalObj[payment].TOTAL = totalObj[payment].TOTAL + total;
                                data.body[payment].body.push({
                                    number: employee.data.employeeNumber,
                                    name: employee.data.name,
                                    total: $filter('number')(total, 2)
                                });
                                data.body[payment].footer = {
                                    employees: data.body[payment].body.length, total: $filter('number')(totalObj[payment].TOTAL, 2)
                                };
                            }
                        }
                    } catch (error) {
                        data.error.push(error);
                    }
                }
            }
            var allEmployees = 0;
            var totalGeneral = 0;
            for (var c in totalObj) {
                if ($filter('objectsLength')(data.body[c]) > 0 && angular.isDefined(totalObj[c].TOTALEMPLOYEES)) {
                    allEmployees = allEmployees + totalObj[c].TOTALEMPLOYEES;
                    totalGeneral = totalGeneral + ((totalObj[c].TOTAL) ? totalObj[c].TOTAL : 0)
                    if (angular.isUndefined(totalObj[c].TOTAL)) {
                        var tots = 0;
                        for (var t in totalObj[c]) {
                            if (t !== 'TOTALEMPLOYEES') {
                                tots = tots + totalObj[c][t];
                            }
                        }
                        data.body[c].totals = { totalAmount: $filter('number')(tots, 2) };
                        totalGeneral = totalGeneral + tots;
                    }
                } else {
                    delete data.body[c];
                }
            }
            data.footer = {
                totalEmployees: allEmployees,
                totalGeneral: $filter('number')(totalGeneral, 2)
            }
            return data;
        }
        $scope.exportDispersionPaymentForms = function () {
            var process = $scope.process.find(function (process) {
                return process.id === $scope.tabSelected;
            });
            if (!process) {
                errAlertS('No se encontró el nombre del proceso');
                return false;
            }
            var type = process.name;
            var employees = $f('orderBy')($scope.fiscalEmployees, $scope.order);
            if ($scope.tabSelected === 'socialPrevision') {
                employees = $f('orderBy')($scope.operationEmployees, $scope.order);
            }
            $filter('getCompaniesName')($scope.payrollId, type, { function: 'paymentForm', name: 'banks' }).then(function (response) {
                var businessName = response;
                if (angular.isDefined(businessName.data)) {
                    var complements = (process.alias) ? process.alias : process.name;
                    var data = getDataForPaymentForms(complements, employees, response.banks.bankAccounts, process.id);
                    var error = angular.fromJson(angular.toJson(data.error));
                    $log.log('datos', data)
                    if (data.footer.totalEmployees > 0) {
                        $rootScope.loadingProgress = true
                        var path = 'employees/downloadFileDispersion'
                        ApiV3F.exportToExcel(path, data).then(function (resp) {
                            $log.log(resp)
                            if (resp) {
                                $rootScope.loadingProgress = false;
                                $rootScope.$evalAsync(function () {
                                    $log.debug('generatePdf finished');
                                });
                                successAlertS('Se ha descargado el archivo correctamente');
                            }
                        }).catch(function (error) {
                            $rootScope.loadingProgress = false;
                            $rootScope.$evalAsync(function () {
                                $log.debug('generatePdf finished');
                            })
                            errAlertS(error);
                        })
                    } else {
                        if (Object.keys(data.body).length === 0 && error.length === 0) {
                            errAlertS('No se encontró ningún empleado con la cuenta seleccionada');
                        }
                        for (var i = 0; i < error.length; i++) {
                            errAlertS(error[i]);
                        }
                    }
                } else {
                    if (businessName.message) {
                        errAlertS(businessName.message);
                    }
                }
            })
        }

        function calculate() {
            return $q(function (resolve) {
                $timeout(function () {
                    $f('loopEach')(processIncidences, function (data, key) {
                        processIncidences[key] = {};
                    });
                    $scope.rejectedIncidences = [];
                    if (angular.isUndefined($scope.fastIncidences)) {
                        $scope.fastIncidences = {};
                    }
                    auxProccess = opObjs.process.fb.filter(function (item) {
                        return item.id !== 'real' && item.id !== 'rejectedIncidences' && item.id !== 'others';
                    });
                    var msg = [];
                    $scope.hasErrors = false;
                    for (var o = 0; o < operationEmployeesF.length; o++) {
                        var employee = allEmployeesO[operationEmployeesF[o].$id];
                        var employeeId = employee.$id;
                        employee.processes = auxProccess;
                        if (!employee.isClosed) {
                            var calcData = $filter('calculateEmployee')(
                                employee,
                                $scope.calculations[employeeId],
                                dataUsedToCalc[employeeId],
                                $scope.fastIncidences[employeeId],
                                rejectIncidencesByEmployee[employeeId],
                                processIncidencesByEmployee[employeeId],
                                opObjs);
                            if (angular.isDefined(calcData.calculations)) {
                                if (angular.isUndefined($scope.calculations[employeeId])) {
                                    $scope.calculations[employeeId] = {};
                                }
                                $scope.calculations[employeeId] = calcData.calculations;
                                dataUsedToCalc[employeeId] = calcData.dataUsedToCalc;
                                $scope.fastIncidences[employeeId] = calcData.fastIncidences;
                                rejectIncidencesByEmployee[employeeId] = calcData.rejectedIncidences;
                                $scope.rejectedIncidences = $scope.rejectedIncidences.concat(rejectIncidencesByEmployee[employeeId]);
                                processIncidencesByEmployee[employeeId] = calcData.processIncidences;
                                $f('loopEach')(calcData.processIncidences, function (employeeIncidences, operationKey) {
                                    if (angular.isUndefined(processIncidences[operationKey])) {
                                        processIncidences[operationKey] = {};
                                    }
                                    processIncidences[operationKey] = Object.assign(processIncidences[operationKey], employeeIncidences);
                                });
                            }
                            if (angular.isObject(calcData) && calcData !== null && calcData.error && angular.isString(calcData.msg)) {
                                msg.push(calcData.msg);
                            }
                        }
                    }
                    $scope.calculations = Object.assign($scope.calculations, $f('getFromObject')(opObjs.dispersion, 'fb.employeesData.calculations', {}));
                    $log.log($scope.calculations);
                    $f('loopEach')($f('getFromObject')(opObjs.dispersion, 'fb.employeesData.rejectedIncidences', {}), function (employeeIncidences, employeeId) {
                        $f('loopEach')(employeeIncidences, function (rejectInc) {
                            var incidence = {
                                conceptId: rejectInc.i,
                                conceptKey: rejectInc.k,
                                name: rejectInc.n,
                                qty: rejectInc.v,
                                employeeId: employeeId,
                                employeeName: $f('getFromObject')(allEmployeesO[employeeId], 'data.name', 'SIN NOMBRE')
                            };
                            $scope.rejectedIncidences.push(incidence);
                        });
                    });
                    if (msg.length > 0) {
                        $scope.hasErrors = true;
                        var text = '<h4>Se encontraron algunos errores en los cálculos de los empleados</h4><ul>';
                        for (var m = 0; m < msg.length; m++) {
                            text += '<li>' + msg[m] + '</li>';
                        }
                        text += '</ul>';
                        errAlertS(text);
                    }
                    if (opObjs.operation.fb.status < 3) {
                        opObjs.process.fb = $f('getProcessForOperation')(opObjs.processFromPayroll.fb, opObjs.opIncidences.fb, opObjs.conceptsById.fb, processIncidences, operationEmployeesF);
                        $scope.process = opObjs.process.fb;
                    }
                    $scope.operationTotals = $f('getTotalsOfOperations')($scope.calculations, opObjs.process.fb, opObjs.conceptsById.fb, auxProccess, $f('getFromObject')(opObjs.dispersion, 'fb'), opObjs.operation.fb.status >= $scope.opStatusNotCalc);
                    $scope.$evalAsync();
                    $timeout(function () {
                        resolve(true);
                    }, 0, false)
                }, 0, false);
            });
        }
        var lastValueToCheck = {};
        function setWatcher(objData, objName) {
            $filter("setOperationWatcher")(objData, objName, lastValueToCheck, $scope, addForAction, watchers, firstIgnored)
        }
        function activeWatchers() {
            var promises = [];
            $f('loopEach')(opObjs, function (objData, objName) {
                promises.push(setWatcher(objData, objName));
            });
            return $q.all(promises);
        }
        function setCreditIncidences() {
            var incidencesOfCredit = $f('setCreditIncidences')(operationEmployeesF, allEmployeesO, opObjs.concepts.fb, $scope.refs.incidences, $f('getFromObject')($scope.calendar, '$id'), $f('getFromObject')(opObjs.period, 'fb'), $f('getFromObject')(opObjs.operation, 'fb'), 'settlement', opObjs.operation.fb.$id);
            return incidencesOfCredit;
        }
        function getConstantsIncidences() {
            var constants = $f('getConstantsIncidences')(operationEmployeesF, allEmployeesO, $f('getFromObject')($scope.calendar, '$id'), opObjs.period.fb, $scope.payrollId, $scope.refs.incidences, opObjs.conceptsById.fb, 'settlement', opObjs.operation.fb.$id, $filter('getFromObject')(opObjs.operation, 'fb', {}), $filter('getFromObject')(opObjs.lastOperation, 'fb', {}));
            return constants;
        }
        function getAllEmployees(movementsGrouped) {
            return $q(function (resolve, reject) {
                var pendingToGet = [];
                var employeeData = $f('getFromObject')(opObjs.employees, 'fb', {});
                $f('loopEach')(movementsGrouped, function (data, employeeId) {
                    if (!employeeData.hasOwnProperty(employeeId)) {
                        if (pendingToGet.length < 50) {
                            pendingToGet.push(employeeId);
                        }
                    }
                });
                var query = [];
                if (pendingToGet.length > 0) {
                    var employeesDataQuery = {
                        page: 0.5,
                        size: 0.5,
                        'fid': {
                            '$in': pendingToGet
                        }
                    };
                    query.push($rootScope.D.api.get('p/employees', employeesDataQuery));
                }
                Promise.all(query).then(function (resp) {
                    if (resp.length > 0) {
                        var employeeData = $f('getFromObject')(resp[0], 'data.data', []);
                        for (var e = 0; e < employeeData.length; e++) {
                            if (angular.isUndefined(opObjs.employees)) {
                                opObjs.employees = {};
                            }
                            if (angular.isUndefined(opObjs.employees.fb)) {
                                opObjs.employees.fb = {};
                            }
                            opObjs.employees.fb[employeeData[e].fid] = employeeData[e];
                            opObjs.employees.fb[employeeData[e].fid].$id = employeeData[e].fid;
                        }
                        var thisEmployeeData = $f('getFromObject')(opObjs.employees, 'fb', {});
                        for (var p = 0; p < pendingToGet.length; p++) {
                            if (angular.isUndefined(thisEmployeeData[pendingToGet[p]])) {
                                if (angular.isUndefined(opObjs.employees)) {
                                    opObjs.employees = {};
                                }
                                if (angular.isUndefined(opObjs.employees.fb)) {
                                    opObjs.employees.fb = {};
                                }
                                opObjs.employees.fb[pendingToGet[p]] = {};
                                opObjs.employees.fb[pendingToGet[p]].$id = pendingToGet[p];
                            }
                        }
                    }
                    if (pendingToGet.length > 0) {
                        resolve(getAllEmployees(movementsGrouped));
                    } else {
                        resolve(opObjs.employees.fb);
                    }
                }).catch(reject);
            });
        }
        function loadEmployees() {
            return $q(function (resolve, reject) {
                var movementsGrouped;
                if (opObjs.operation.fb.status >= $scope.opStatusNotCalc) {
                    movementsGrouped = opObjs.operation.fb.employees;
                } else {
                    movementsGrouped = opObjs.movementsByEmployee.fb;
                }
                var employeeProcess = opObjs.processFromPayroll.fb.filter(function (item) {
                    return (item.id !== 'real' && item.id !== 'rejectedIncidences');
                }).map(function (item) {
                    return { id: item.id, name: item.name };
                });
                var cleanedObjs = {
                    period: $filter('getFromObject')(opObjs.period, 'fb'),
                    payroll: $filter('getFromObject')(opObjs.payroll, 'fb'),
                    ccs: $filter('getFromObject')(opObjs.employeesCcs, 'fb'),
                    paymentFrequency: $filter('getFromObject')(opObjs.paymentFrequency, 'fb'),
                    nfdRecords: $filter('clearObject')($scope.M.nfdRecords),
                    imssRecordData: $filter('getIMSSRowLast')($scope.calendarId, $scope.M.imssRecords),
                    cyvRecordsData: $filter('clearObject')(opObjs.getCyvTable.fb),
                    minimumWageRecords: $filter('clearObject')(opObjs.minimumWageRecords.fb),
                    employeeProcess: employeeProcess
                };
                getAllEmployees(movementsGrouped).then(function () {
                    var promises = {};
                    $f('loopEach')(movementsGrouped, function (movements, employeeId) {
                        var employeeStatus = $f('getFromObject')(opObjs.operation.fb, 'employees.' + employeeId + '.status');
                        promises[employeeId] = $f('getEmployeeForOpe')(
                            employeeId,
                            movements,
                            $scope.payrollId,
                            employeeStatus >= 3,
                            $scope.calendar.$id,
                            opObjs,
                            cleanedObjs
                        );
                    });
                    $q.all(promises).then(function (resp) {
                        allEmployeesO = resp;
                        var allEmployees = {};
                        var fiscalEmployees = [];
                        var operationEmployees = [];
                        var msg = [];
                        var oldOpEmpObj = angular.isDefined(opObjs.operation.fb) && angular.isDefined(opObjs.operation.fb.employees) ? opObjs.operation.fb.employees : {};
                        var newOpEmpObj = {};
                        $f('loopEach')(resp, function (employeeData, employeeId) {
                            newOpEmpObj[employeeId] = oldOpEmpObj[employeeId] ? oldOpEmpObj[employeeId] : {};
                            if (angular.isObject(employeeData)) {
                                var objsToWatch = employeeData.objsToWatch;
                                delete employeeData.objsToWatch;
                                allEmployees[employeeId] = employeeData;
                                var employeeObj = {
                                    '$id': employeeData.$id,
                                    'data': {
                                        'name': employeeData.data.name,
                                        'enroleDate': employeeData.data.enroleDate,
                                        'seniorityDate': employeeData.data.seniorityDate
                                    },
                                    movements: employeeData.movements
                                };
                                if (employeeData.forOperation) {
                                    if (employeeData.isFiscal) {
                                        fiscalEmployees.push(employeeObj);
                                    }
                                    operationEmployees.push(employeeObj);
                                }
                                newOpEmpObj[employeeId].cc = employeeData.movements[0].cc || null;
                                newOpEmpObj[employeeId].rp = employeeData.movements[0].rp || null;
                                $f('loopEach')(objsToWatch, function (obj, index) {
                                    if (!opObjs.hasOwnProperty(index)) {
                                        opObjs[index] = obj;
                                    }
                                });
                            } else if (angular.isString(employeeData)) {
                                msg.push(employeeData);
                            }
                            newOpEmpObj[employeeId].status = angular.isDefined(oldOpEmpObj[employeeId]) && angular.isDefined(oldOpEmpObj[employeeId].status) ? oldOpEmpObj[employeeId].status : 0;

                        });
                        if (opObjs.operation.fb.status < 3) {
                            opObjs.operation.fb.version = 2.0;
                        }
                        if (msg.length > 0) {
                            var text = '<h4>Se encontraron algunos problemas con los empleados</h4><ul>';
                            for (var m = 0; m < msg.length; m++) {
                                text += '<li>' + msg[m] + '</li>';
                            }
                            text += '</ul>';
                            errAlertS(text);
                        }
                        fiscalEmployeesF = fiscalEmployees;
                        operationEmployeesF = operationEmployees;
                        allEmployeesO = allEmployees;
                        $scope.filterEmployees();
                        var promises = [];
                        if (opObjs.operation.fb.status < 3) {
                            promises.push(opObjs.operation.fb.$save());
                        }
                        Promise.all(promises).then(function () {
                            if (angular.isUndefined(opObjs.creditIncidences)) {
                                opObjs.creditIncidences = { watch: true, actions: ['setIncidencesOfEmployees'] };
                            }
                            if (angular.isUndefined(opObjs.constantsIncidences)) {
                                opObjs.constantsIncidences = { watch: true, actions: ['setIncidencesOfEmployees'] };
                            }
                            opObjs.creditIncidences.fb = setCreditIncidences();
                            opObjs.constantsIncidences.fb = getConstantsIncidences();
                            addForAction('setIncidencesOfEmployees', opObjs.incidences.fb, false, true);
                            addForAction('setOperationCcs', opObjs.myCcs.fb, false, true);
                            addForAction('calculate');
                            setOperationVariables();
                            resolve(true);
                        });
                    }).catch(function (error) {
                        reject(error);
                    });
                }).catch(reject);
            });
        }
        $scope.startToBill = function (ev) {
            billOperationS(ev, $scope, opObjs);
        };
        function cancelThisBill(uuid, dontStopLoading) {
            return new Promise(function (resolve) {
                ApiV3F.post('employees/cancelBill', { "uuid": uuid }).then(function (resp) {
                    if (!dontStopLoading) {
                        $rootScope.loadingProgress = false;
                    }
                    successAlertS(resp.data);
                    resolve(true);
                }).catch(function (error) {
                    if (!dontStopLoading) {
                        $rootScope.loadingProgress = false;
                    }
                    $log.error(error);
                    errAlertS(error);
                    resolve(false);
                })
            });
        }
        $scope.cancelToBill = function (selected, ev) {
            var title = "Esta seguro de cancelar la factura?"
            var msg = "La factura que se cancelara ya no tendrá validez, esta es una cancelación definitiva, si necesitas la factura, utiliza la opción de retimbrar";
            if (!angular.isArray(selected) || selected.length === 0) {
                title = "Esta seguro de cancelar todas las facturas?"
                msg = "Todas las facturas de esta operación sera canceladas y no tendrán validez, esta es una cancelación definitiva, si necesitas la factura, utiliza la opción de retimbrar";
            }
            $mdDialog.show($mdDialog
                .confirm(confirmConfig)
                .title(title)
                .htmlContent(msg)
                .ariaLabel('Deleting')
                .targetEvent(ev)
                .ok('SI')
                .cancel('NO'))
                .then(function () {
                    $rootScope.loadingProgress = true;
                    $scope.operation.$loaded().then(function () {
                        var promises = [];
                        var thisEmployees = !angular.isArray(selected) || selected.length === 0 ? $scope.fiscalEmployees : selected;
                        for (var t = 0; t < thisEmployees.length; t++) {
                            var uuid = $scope.operation.employees[thisEmployees[t].$id].billId
                            if (angular.isDefined(uuid) && $scope.operation.employees[thisEmployees[t].$id].status !== 3.5) {
                                promises.push(cancelThisBill(uuid, true));
                            }
                        }
                        return Promise.all(promises);
                    }).then(function (resp) {
                        successAlertS("Se termino el proceso de cancelación de las facturas");
                    }).catch(function (error) {
                        $log.error(error);
                    }).then(function () {
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync();
                        $timeout(function () { }, 0, false);
                    });
                }, function () {
                    $log.debug('Deleting Cancelled');
                });
        };
        function moveEmployees(action, comments, periodSelected, paymentDate, pendingEmployees, newCalendar, generateDismissMovement) {
            return $q(function (resolve, reject) {
                turnOffWatchers();
                var employeeStatus = $scope.nextEmployeeStatus;
                var incidenceStatus = $scope.nextIncidenceStatus;
                var operationStatus = $scope.nextOperationStatus;
                opObjs.operation.fb.period = opObjs.period.fb.period;
                var operationId = opObjs.operation.fb.$id;
                var operation = $filter('clearObject')(opObjs.operation.fb);
                operation.$id = operationId;
                var dispersionId = (angular.isDefined(operation) && angular.isDefined(operation.dispersion)) ? operation.dispersion : AppF.root.child($scope.refs.dispersion).push().key;
                var employees = operationEmployeesF;
                if (angular.isDefined(action) && (action === 'moveBackOperation' || action === 'reOpenClosed')) {
                    employeeStatus = $scope.previousEmployeeStatus;
                    incidenceStatus = $scope.previousIncidencesStatus;
                    operationStatus = $scope.previousOperationStatus;
                }
                var updates = {};
                $scope.refs.operations = $scope.refs.settlements;
                updates[$scope.refs.operations + '/' + operation.$id + '/dispersion'] = dispersionId;
                if (comments !== '') {
                    updates[$scope.refs.operations + '/' + operation.$id + '/comments'] = comments;
                }
                var onlyPrevision;
                var fiscal = opObjs.process.fb.find(function (value) {
                    return value.id === 'fiscal';
                });
                if (operationStatus >= 3 && ($scope.fiscalEmployees.length === 0 || !fiscal)) {
                    onlyPrevision = true;
                }
                AppF.root.update(updates).then(function () {
                    var data = {
                        employees: employees,
                        opObjs: opObjs,
                        refs: $scope.refs,
                        calculations: $scope.calculations,
                        dispersionId: dispersionId,
                        fiscalEmployees: $scope.fiscalEmployees,
                        allEmployeesO: allEmployeesO,
                        employeeStatus: employeeStatus,
                        operation: operation,
                        operationStatus: operationStatus,
                        incidenceStatus: incidenceStatus,
                        action: action,
                        operationType: 'settlement',
                        periodSelected: periodSelected,
                        calendar: newCalendar,
                        onlyPrevision: onlyPrevision,
                        generateDismissMovement: generateDismissMovement
                    };
                    return $f('moveEmployees')(data);
                }).then(function (response) {
                    return new Promise(function (resolve, reject) {
                        var thisPromises = [];
                        if (angular.isDefined(opObjs.operation.fb.dispersion)) {
                            thisPromises.push(ListsF.loadList('dispersions', $scope.refs.dispersion + '/' + opObjs.operation.fb.dispersion, undefined, 'object', 'dispersion-' + opObjs.operation.fb.dispersion));
                        }
                        Promise.all(thisPromises).then(function (resp) {
                            if (resp.length > 0 && angular.isObject(resp[0]) && resp[0] !== null) {
                                $f('setInObjectPath')('dispersion.fb', opObjs, $f('transformCalculations')(resp[0]), true, true);
                            }
                            var exists = (response.indexOf(false) !== -1) ? true : false;
                            if (exists) {
                                reject('No se pudo completar el cierre');
                            } else {
                                resolve(true);
                            }
                        });
                    });
                }).then(function () {
                    var updates = {};
                    var allEmployees = opObjs.operation.fb.employees;
                    var changeStatus = true;
                    for (var key in allEmployees) {
                        if (allEmployees[key].status < incidenceStatus) {
                            break;
                        }
                    }
                    if (changeStatus) {
                        if (action === 'reOpenClosed') {
                            updates[$scope.refs.operations + '/' + operation.$id + '/status'] = 1;
                        } else {
                            updates[$scope.refs.operations + '/' + operation.$id + '/status'] = (!onlyPrevision) ? operationStatus : 7;
                        }
                    }
                    if (operationStatus >= 3) {
                        if ($scope.fiscalEmployees.length === 0) {
                            var findIndex = opObjs.process.fb.findIndex(function (value) {
                                return value.id === 'fiscal';
                            });
                            if (findIndex > -1) {
                                delete opObjs.process.fb[findIndex].companiesRecord;
                            }
                        }
                        var process = $f('clearObject')(opObjs.process.fb);
                        var obj = {
                            originalPeriod: opObjs.period.fb.period,
                            originalCalendar: parseInt(opObjs.calendar.fb.$id),
                            period: periodSelected.period,
                            calendar: newCalendar,
                            accuDate: periodSelected.accuDate,
                            payroll: operation.payroll,
                            process: process,
                            operationType: 'settlement'
                        };
                        updates[$scope.refs.dispersion + '/' + dispersionId + '/data'] = obj;
                        updates[$scope.refs.dispersion + '/' + dispersionId + '/operation'] = operation.$id;
                        updates[$scope.refs.dispersion + '/' + dispersionId + '/status'] = 0;
                        updates[$scope.refs.dispersion + '/' + dispersionId + '/total'] = $scope.operationTotals;
                    }
                    if (action === 'reOpenClosed' && operationStatus === 2.5) {
                        $log.log('catalogs/dispersions/collection/' + dispersionId);
                        updates[$scope.refs.dispersion + '/' + dispersionId] = null;
                        updates[$scope.refs.operations + '/' + operation.$id + '/dispersion'] = null;
                    }
                    $log.log('Se actualizo status de operación');
                    return AppF.root.update(updates);
                }).then(function () {
                    var updates = {};
                    if (operationStatus >= 3) {
                        updates['originalPeriod'] = opObjs.period.fb.period;
                        updates['originalCalendar'] = parseInt(opObjs.calendar.fb.$id);
                        updates['period'] = opObjs.period.fb.period;
                        updates['accuPeriod'] = periodSelected.period;
                        updates['accuCalendar'] = newCalendar;
                        updates['calendar'] = parseInt(opObjs.calendar.fb.$id);
                        updates['start'] = periodSelected.start;
                        updates['end'] = periodSelected.end;
                        if (paymentDate) {
                            updates['forceBillingDate'] = paymentDate;
                        }
                        $log.log($scope.refs.settlements + opObjs.operation.fb.$id, updates);
                        return AppF.root.child($scope.refs.settlements + opObjs.operation.fb.$id).update(updates);
                    } else {
                        return Promise.all([]);
                    }
                }).then(function () {
                    var thisPromises = [];
                    if (angular.isDefined(opObjs.operation.fb.dispersion)) {
                        thisPromises.push(ListsF.loadList('dispersions', $scope.refs.dispersion + '/' + opObjs.operation.fb.dispersion, undefined, 'object', 'dispersion-' + opObjs.operation.fb.dispersion));
                    }
                    return Promise.all(thisPromises)
                }).then(function (resp) {
                    if (resp.length > 0 && angular.isObject(resp[0]) && resp[0] !== null) {
                        $f('setInObjectPath')('dispersion.fb', opObjs, $f('transformCalculations')(resp[0]), true, true);
                    }
                    var statusName = $filter('operationStatusNameModal')(operationStatus);
                    addForAction('setProccess');
                    successAlertS('Status de Operación actualizada a ' + statusName.name);
                    setOperationVariables();
                    addForAction('activeWatchers', undefined, false);
                    resolve(true);
                }).catch(function (error) {
                    setOperationVariables();
                    addForAction('activeWatchers', undefined, false);
                    reject(error);
                });

            });
        }
        function buildCtx(periodOverride) {
            return {
                periodEnd: opObjs.period.fb.end,
                serverTime: $scope.D.getCurrentServerTime(),
                processes: $scope.process,
                payrollId: $scope.payrollId,
                banksAccounts: $scope.M.bankAccounts,
                banks: $scope.M.banks,
                fiscalEmployees: $scope.fiscalEmployees,
                operationEmployees: $scope.operationEmployees,
                order: $scope.order,
                tabSelected: $scope.tabSelected,
                allEmployeesO: allEmployeesO,
                payroll: opObjs.payroll,
                period: opObjs.period,
                periodOverride: periodOverride,
                calendar: opObjs.operation.fb.calendar,
                opProcessList: opObjs.process.fb,
                calc: $scope.calculations,
                paymentForms: $scope.M.paymentForms,
                operationType: $scope.operationType,
                serviceWorkerUrl: window.__env.serviceWorkerUrl,
                addUtf8BomForCsv: true
            };
        }

        $scope.layoutBanks = function (event, bankAccount, employeesSelected) {
            var ctx = buildCtx(undefined);
            BankLayoutFlow.run(event, bankAccount, employeesSelected, ctx).catch(function (err) {
                errAlertS(err);
            });
        };
        function addDate(params) {
            var bank = params.bank;
            var maxDate = AppF.holydaysInMexico.getDateOfXLabourDaysFromNow(365, opObjs.period.fb.end).date;
            var event = params.event;
            var minDate;
            if ($f('lowercase')(bank.name) === 'hsbc') {
                minDate = moment($scope.D.getCurrentServerTime()).toDate();
            } else {
                minDate = AppF.holydaysInMexico.getDateOfXLabourDaysSinceNow(15, opObjs.period.fb.end).date;
            }
            $mdDialog.show({
                templateUrl: 'app/main/clients/views/newoperation/dialogs/date.html',
                locals: {
                    minDate: minDate,
                    maxDate: maxDate
                },
                controller: function (scope, minDate, maxDate) {
                    scope.bank = params.bank;
                    scope.minDate = minDate;
                    scope.maxDate = maxDate;
                    scope.layoutBanks = function (thisParams) {
                        params.extraParams = thisParams;
                        layoutBanks(params);
                        scope.cancel();
                    }
                    scope.onlyWeekendsPredicate = function (date) {
                        var day = date.getDay();
                        return day === 1 || day === 2 || day === 3 || day === 4 || day === 5;
                    };
                    scope.cancel = function () {
                        $mdDialog.hide();
                    };
                },
                parent: angular.element(document.body),
                targetEvent: event,
                clickOutsideToClose: true
            });
        }
        function layoutBanks(data) {
            var filterName = $filter('convertToCamelCase')('get_data_for_layouts_' + data.fileRoute);
            var filter = $filter('getFilterIfExists')(filterName);
            if (!filter) {
                errAlertS("No existe el archivo de layout del banco seleccionado");
                return false;
            }
            $rootScope.loadingProgress = true;
            var employees = $f('orderBy')($scope.fiscalEmployees, $scope.order);
            if ($scope.tabSelected === 'socialPrevision') {
                employees = $f('orderBy')($scope.operationEmployees, $scope.order);
            }
            var bankName = angular.lowercase(data.fileRoute);
            var process = opObjs.process.fb.find(function (value) {
                return value.id === $scope.tabSelected;
            });
            var areAll = false;
            var thisEmployees = data.employeesSelected;
            if ((!angular.isArray(thisEmployees)) || thisEmployees.length === 0) {
                thisEmployees = employees;
                areAll = true;
            }
            var params = {
                processes: $scope.process,
                payrollId: $scope.payrollId,
                banksAccounts: $scope.M.bankAccounts,
                banks: $scope.M.banks,
                bank: data.bank,
                bankAccount: data.bankAccount,
                employees: thisEmployees,
                areAll: areAll,
                allEmployeesO: allEmployeesO,
                payroll: opObjs.payroll,
                period: opObjs.period,
                calendar: opObjs.operation.fb.calendar,
                calc: $scope.calculations,
                paymentForms: $scope.M.paymentForms,
                processName: process.name,
                tabSelected: $scope.tabSelected
            };
            $filter('loopEach')(data.extraParams, function (value, index) {
                params[index] = value;
            });
            $f(filterName)(params).then(function (resp) {
                if (angular.isDefined(resp.error) && angular.isArray(resp.error) && resp.error.length > 0) {
                    errAlertS(resp.error);
                }
                if (angular.isDefined(resp.success)) {
                    if (angular.isArray(resp.success) && resp.success.length === 0) {
                        throw "No existe ningún registro para layout de " + data.bank.name;
                    }
                    if (angular.isObject(resp.success) && angular.isDefined(resp.success.body) && resp.success.body.length === 0) {
                        throw "No existe ningún registro para layout de " + data.bank.name;
                    }
                    var objData = {
                        data: angular.toJson(resp.success),
                        bankName: $filter('convertToCamelCase')(bankName)
                    }
                    if (angular.isDefined(resp.filename)) {
                        objData.filename = resp.filename;
                    }
                    $http({
                        method: 'POST',
                        url: window.__env.serviceWorkerUrl + "interface/pag/layout/dispersion",
                        responseType: 'arraybuffer',
                        data: objData
                    }).then(function (response) {
                        var headers = response.headers();
                        var filename = headers['x-filename'];
                        var contentType = headers['content-type'];
                        var linkElement = document.createElement('a');
                        try {
                            var blobArray = [];
                            if (contentType.indexOf('text/csv') > -1 && contentType.indexOf('utf-8') > -1) {
                                blobArray.push('\ufeff')
                            }
                            blobArray.push(response.data);
                            var blob = new Blob(blobArray, {
                                type: contentType
                            });
                            var url = window.URL.createObjectURL(blob);
                            linkElement.setAttribute('href', url);
                            linkElement.setAttribute("download", filename);
                            var clickEvent = new MouseEvent("click", {
                                "view": window,
                                "bubbles": true,
                                "cancelable": false
                            });
                            linkElement.dispatchEvent(clickEvent);
                            $rootScope.loadingProgress = false;
                            $rootScope.$evalAsync(function () {
                                $log.debug('generate file .pag finished');
                            });
                        } catch (ex) {
                            $log.error(ex, "error descargando el archivo");
                            $rootScope.loadingProgress = false;
                            $rootScope.$evalAsync();
                        }
                    }).catch(function (err) {
                        var message = new TextDecoder("utf-8").decode(err.data);
                        var error = angular.fromJson(message);
                        errAlertS(error.data);
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync();
                    });
                } else {
                    errAlertS("No existe ningún registro para layout de " + data.bank.name);
                    $rootScope.loadingProgress = false;
                }
            }).catch(function (error) {
                $rootScope.loadingProgress = false;
                errAlertS(error);
            })
        }
        $scope.checkBankAccounts = function (bank, bankAccounts, tabSelected) {
            if (angular.isDefined(bank.hasLayout)) {
                var exist = false;
                var process = opObjs.process.fb.find(function (value) {
                    return value.id === tabSelected;
                });
                var processBanks = $f('getFromObject')(opObjs.payroll.fb.processes[process.name], 'bankAccounts');
                if (angular.isDefined(processBanks) && angular.isArray(processBanks) && processBanks.length > 0) {
                    var filterB = [];
                    for (var i = 0; i < processBanks.length; i++) {
                        var type = bankAccounts.find(function (value) {
                            return value._id === processBanks[i];
                        });
                        if (angular.isDefined(type)) {
                            filterB.push(type);
                        }
                    }
                    for (var f = 0; f < filterB.length; f++) {
                        if (filterB[f].bank === bank._id) {
                            exist = true;
                            break;
                        }
                    }
                }
            }
            return exist;
        };
        $scope.checkAccount = function (ev, action) {
            var employeeProcess = opObjs.processFromPayroll.fb.filter(function (item) {
                return (item.id !== 'real' && item.id !== 'rejectedIncidences');
            }).map(function (item) {
                return { id: item.id, name: item.name };
            });
            if ($f('checkAccountAndNumber')(allEmployeesO, employeeProcess, 'settlement', $scope.calculations)) {
                $f('getPeriodsAndCalendarForOpe')(opObjs.payroll.fb.$id, opObjs.calendar.fb.$id, opObjs.period.fb.accuDate, true, true).then(function (resp) {
                    if (!resp.periods) {
                        throw 'No hay periodos disponibles para almacenar la nomina';
                    }
                    $scope.confirmOperationAction(ev, action, resp);
                }).catch(errAlertS);
            }
        };
        $scope.directCancel = function (uuid, ev) {
            $mdDialog.show($mdDialog
                .confirm(confirmConfig)
                .title('¿Desea cancelar la factura?')
                .htmlContent('Se va a cancelar la factura que no se puedo cancelar en el re timbrado anterior')
                .ariaLabel('Deleting')
                .targetEvent(ev)
                .ok('SI')
                .cancel('NO'))
                .then(function () {
                    cancelThisBill(uuid);
                }, function () {
                    $log.debug('Deleting Cancelled');
                });
        };
        $scope.cancelToBill = function (selected, ev) {
            var title = "Esta seguro de cancelar la factura?"
            var msg = "La factura que se cancelara ya no tendrá validez, esta es una cancelación definitiva, si necesitas la factura, utiliza la opción de retimbrar";
            if (!angular.isArray(selected) || selected.length === 0) {
                title = "Esta seguro de cancelar todas las facturas?"
                msg = "Todas las facturas de esta operación sera canceladas y no tendrán validez, esta es una cancelación definitiva, si necesitas la factura, utiliza la opción de retimbrar";
            }
            $mdDialog.show($mdDialog
                .confirm(confirmConfig)
                .title(title)
                .htmlContent(msg)
                .ariaLabel('Deleting')
                .targetEvent(ev)
                .ok('SI')
                .cancel('NO'))
                .then(function () {
                    $rootScope.loadingProgress = true;
                    $scope.operation.$loaded().then(function () {
                        var promises = [];
                        var thisEmployees = !angular.isArray(selected) || selected.length === 0 ? $scope.fiscalEmployees : selected;
                        for (var t = 0; t < thisEmployees.length; t++) {
                            var uuid = $scope.operation.employees[thisEmployees[t].$id].billId
                            if (angular.isDefined(uuid) && $scope.operation.employees[thisEmployees[t].$id].status !== 3.5) {
                                promises.push(cancelThisBill(uuid, true));
                            }
                        }
                        return Promise.all(promises);
                    }).then(function (resp) {
                        $log.log(resp);
                        successAlertS("Se termino el proceso de cancelación de las facturas");
                    }).catch(function (error) {
                        $log.error(error);
                    }).then(function () {
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync();
                        $timeout(function () { }, 0, false);
                    });
                }, function () {
                    $log.debug('Deleting Cancelled');
                });
        }
        $scope.confirmOperationAction = function (ev, action, params) {
            params = (!angular.isObject(params)) ? {} : params;
            params.moveEmployees = moveEmployees;
            params.sendOperationNotification = sendOperationNotification;
            confirmOperationS(ev, action, params, $scope, opObjs, operationEmployeesF, 'settlement');
        };
        function sendOperationNotification(operation, status, moveBack, operationTab, operationStatusName, comments) {
            return $filter('getOperationForNotification')(operation, operationTab, moveBack, operationStatusName, comments).then(function (operationData) {
                return AppF.notifyUsers('operation', 'operations', status, operation.$id, operation, false, operationData);
            });
        }

        function validarSeleccion(selected) {
            if (!selected || !selected.length) return Promise.resolve(false);
            var opRef = $scope.refs.operations + '/' + opObjs.operation.fb.$id + '/employees';
            return AppF.root.child(opRef).once('value').then(function (snap) {
                var all = (snap && snap.val && snap.val()) || {};
                for (var i = 0; i < selected.length; i++) {
                    var emp = all[selected[i].$id];
                    if (!(emp && emp.billId)) return false;
                }
                return true;
            });
        }

        watchers = $scope.$watchCollection('selected', function (nuevo, anterior) {
            if (nuevo === anterior) {
                return;
            }
            validarSeleccion(nuevo).then(function (resp) {
                $scope.allowHumand = resp
            })
        });

        $scope.sendPayrollReceipt = function (event, selected) {
            var operationRefData = $scope.refs.operations + '/' + opObjs.operation.fb.$id + '/employees'
            $mdDialog.show({
                templateUrl: 'app/main/clients/views/newoperation/controllers/dialog/sendPayrollReceipt.html',
                controller: 'SendPayrollReceiptController',
                controllerAs: 'sprCtrl',
                locals: {
                    selected: selected,
                    operationRef: operationRefData,
                    operation: opObjs.operation.fb
                },
                parent: angular.element($document.body),
                targetEvent: event,
                scope: $scope.$new(),
                clickOutsideToClose: false
            });
        }

        $log.log('aguinaldo 1')

        $scope.generateAccountingAccountCompaq = function (process) {
            $rootScope.loadingProgress = true;
            var data = {
                operationType: 'settlement',
                operationId: opObjs.operation.fb.$id,
                dispersionId: opObjs.operation.fb.dispersion,
                payroll: $scope.payrollId,
                payrollId: $scope.payrollId,
                calendar: $filter('getFromObject')(opObjs.operation.fb, 'calendar'),
                downloading: false,
                period: $filter('getFromObject')(opObjs.operation.fb, 'period'),
                process: process,
                processName: process.toUpperCase()
            }
            var obj = {
                data: angular.toJson([data]),
                nameF: 'exportAccount'
            };
            var path = 'interface/exportAccountingAccountsCompaq';
            $rootScope.C.exportToExcel(path, obj, true).then(function () {
                data.downloadingLayout = false;
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync()
            }).catch(function () {
                data.downloadingLayout = false;
                $scope.$evalAsync()
            });
        }

        function setOperationVariables() {
            $scope.operationStatusByEmployees = opObjs.operation.fb.status;
            if ($scope.operationPermissions.closeOperation && opObjs.operation.fb.status >= 3) {
                $scope.previousEmployeeStatus = 2;
                $scope.previousIncidencesStatus = 2;
                $scope.previousOperationStatus = 2.5;
            } else if ($scope.operationPermissions.closeOperation) {
                $scope.previousEmployeeStatus = 1;
                $scope.previousIncidencesStatus = 1;
                $scope.previousOperationStatus = 2;
                $scope.nextEmployeeStatus = 3;
                $scope.nextIncidenceStatus = 3;
                $scope.nextOperationStatus = 3;
                $scope.showCloseOpButton = true;
            } else if ($scope.operationPermissions.sendOperationToFinalRevision) {
                $scope.previousEmployeeStatus = 0;
                $scope.previousIncidencesStatus = 0;
                $scope.previousOperationStatus = 1;
                $scope.nextEmployeeStatus = 2;
                $scope.nextIncidenceStatus = 2;
                $scope.nextOperationStatus = 2.5;
                $scope.showRevisionOpButton = true;
            } else if ($scope.operationPermissions.sendOperationToRevision) {
                $scope.previousEmployeeStatus = 0;
                $scope.previousIncidencesStatus = 0;
                $scope.previousOperationStatus = -1;
                $scope.nextEmployeeStatus = 1;
                $scope.nextIncidenceStatus = 1;
                $scope.nextOperationStatus = 2;
                $scope.showRevisionOpButton = true;
            }
            var r = (opObjs.nextOperation && opObjs.nextOperation.fb.period ? opObjs.nextOperation.fb.period : 0) - opObjs.operation.fb.period;
            if (opObjs.operation.fb.status >= 3 || opObjs.operation.fb.status <= 5) {
                $scope.showReopenButton = true;
            } else {
                delete $scope.showReopenButton;
            }
            //console.log($scope.showReopenButton);
            if ($scope.showRevisionOpButton) {
                //si tiene permiso para revisar la nomina pero la nomina ya no esta en un status para revisar entonces no mostramos le botón de revisar
                if (opObjs.operation.fb.status > 2) {
                    delete $scope.showRevisionOpButton;
                }
                //Si todos mis empleados están en el siguiente estado que corresponde ya no mostramos el botón
                if ($scope.showRevisionOpButton) {
                    if ($scope.allMyEmployeesInStatus($scope.nextEmployeeStatus)) {
                        delete $scope.showRevisionOpButton;
                    }
                }
            }
            if ($scope.showCloseOpButton) {
                delete $scope.showRevisionOpButton;
                //si tiene permiso para revisar la nomina pero la nomina ya no esta en un status para revisar entonces no mostramos le botón de revisar
                if (opObjs.operation.fb.status > 2.5) {
                    delete $scope.showCloseOpButton;
                }
                //Si todos mis empleados están en el siguiente estado que corresponde ya no mostramos el botón
                if ($scope.showCloseOpButton) {
                    if ($scope.allMyEmployeesInStatus($scope.nextEmployeeStatus)) {
                        delete $scope.showCloseOpButton;
                    }
                }
            }
            if (opObjs.operation.fb.status > 0 && opObjs.operation.fb.status < $scope.opStatusNotCalc) {
                var status = {};
                var nextStatus = $scope.employeesStatusByOp[opObjs.operation.fb.status].nextStatus;
                for (var a = 0; a < nextStatus.length; a++) {
                    status[nextStatus[a]] = $scope.allMyEmployeesInStatus(nextStatus[a]);
                }
            }
            $scope.nextEmployeeStatus;
            $scope.failCloseOperation = false;
            if (opObjs.operation.fb.status < $scope.nextOperationStatus) {
                for (var i = 0; i < operationEmployeesF.length; i++) {
                    var employeeStatus = $f('getFromObject')(opObjs.operation.fb, 'employees.' + operationEmployeesF[i].$id + '.status', 0);
                    if (employeeStatus >= $scope.nextEmployeeStatus) {
                        $scope.failCloseOperation = true;
                    }
                }
            }
        }
        function validateMovement(movement, action) {
            var movementIndexFounded = opObjs.movements.fb.findIndex(function (item) {
                return item.$id === movement.$id;
            });
            if (action === 'delete' && movementIndexFounded > 0) {
                opObjs.movements.fb.splice(movementIndexFounded, 1);
                addForAction('loadEmployees');
            } else {
                if (isValidMovement(movement)) {
                    if (movementIndexFounded > -1) {
                        opObjs.movements.fb[movementIndexFounded] = angular.fromJson(angular.toJson(movement));
                    } else {
                        opObjs.movements.fb.push(movement);
                    }
                    addForAction('loadEmployees');
                } else if (movementIndexFounded > -1) {
                    opObjs.movements.fb.splice(movementIndexFounded, 1);
                    addForAction('loadEmployees');
                }
            }
        }
        function isValidMovement(movement) {
            var isValid = false;
            if (movement.payroll === $scope.payrollId) {
                isValid = true;
            }
            if (isValid) {
                var movements = [movement];
                var lastMovements = $filter('getLastMovemenBeforeDate')(movements, opObjs.period.fb.start);
                var betweenMovements = $filter('getMovementsBetweenDates')(movements, opObjs.period.fb.start, opObjs.period.fb.end);
                if (lastMovements.length || betweenMovements.length) {
                    if (lastMovements.length) {
                        $log.debug('isValid because Last');
                    } else {
                        $log.debug('isValid because Between');
                    }
                    isValid = true;
                } else {
                    isValid = false;
                }
            }
            return isValid;
        }
        //FUNCIÓN PRINCIPAL QUE DISPARA TODO
        function init() {
            console.log('operation3rd')
            $scope.showProgress = true;
            initiated = true;
            $rootScope.loadingProgress = false;
            $scope.$evalAsync();
            $timeout(function () {
                // SI NO VIENE LOS PARÁMETROS EN LA URL SE REGRESA HACIA ATRÁS
                if (!$state.params.operationId) {
                    errAlertS('No se tienen todos los parametros necesarios para acceder a la nomina');
                    $scope.R.goToList();
                } else {
                    //Se obtienen los parámetros del url
                    $scope.readOnlyMode = ($state.current.url.indexOf('read') !== -1);
                    $scope.operationId = $state.params.operationId;
                    $scope.payrollId = $state.params.payrollId;
                    $scope.operationType = $state.params.operationType;
                    //SE OBTIENEN LOS PERMISOS DEL USUARIO PARA LAS OPERACIONES DE LA NOMINA
                    $scope.operationPermissions = $f('getOperationPermissions')();
                    // dataNeeded, operationId, periodId, calendarId, payrollId, operationType, operationIsClosed
                    //SE OBTIENEN LAS REFERENCIAS Y LOS DATOS PRINCIPALES DE LA OPERACIÓN
                    $scope.actionMessages = 'Obteniendo datos iniciales';
                    $f('getDataOfOperation')(dataNeeded, $scope.operationId, $scope.payrollId).then(function (resp) {
                        $log.log(resp);
                        $scope.operationProgress = 20;
                        $scope.refs = resp.refs;
                        opObjs = resp.fbObjs;
                        for (var o = 0; o < resp.objIndex.length; o++) {
                            var objIndex = resp.objIndex[o];
                            if (opObjs.hasOwnProperty(objIndex)) {
                                var objData = opObjs[objIndex];
                                if (angular.isDefined(objData.actions)) {
                                    for (var a = 0; a < objData.actions.length; a++) {
                                        addForAction(objData.actions[a], objData.fb, undefined, true);
                                    }
                                }
                                if (angular.isObject(objData) && objData.inScope && objData.fb) {
                                    $scope[objIndex] = objData.fb;
                                }
                            }
                        }
                        if (angular.isUndefined(opObjs.incidences)) {
                            opObjs.incidences = { fb: [] };
                        }
                        if (opObjs.operation.fb.status < $scope.opStatusNotCalc) {
                            opObjs.incidences.watch = true;
                        }
                        opObjs.incidences.executeCalculation = true;
                        opObjs.incidences.actions = ['setIncidencesOfEmployees'];
                        incidenceTypeForPenDays = opObjs.concepts.fb.find(function (item) {
                            return item.fdd;
                        });
                        addForAction('loadEmployees', undefined, false, true);
                        addForAction('setIncidencesOfEmployees', opObjs.incidences.fb, false, true);
                        addForAction('calculate', undefined, false, true);
                        addForAction('activeWatchers', undefined, false);
                        $scope.setTabName();
                    }).catch(function (error) {
                        errAlertS('Error al obtener la información general de la operación');
                        $log.error(error);
                    });
                }

            }, 0, false);

        }
        $scope.setTabName = function (tabName) {
            tabName = !tabName ? 'real' : tabName;
            $scope.selected = [];
            $scope.tabSelected = tabName;
        };
        $scope.goToList = function () {
            $window.history.back();
        };
        $scope.fastIncidenceUsed = function (incidenceTypeId) {
            var inUse = true;
            if (angular.isDefined(opObjs) && angular.isDefined(opObjs.process) && angular.isArray(opObjs.process.fb)) {
                var realP = opObjs.process.fb.find(function (item) {
                    return item.id === 'real';
                });
                if (angular.isDefined(realP)) {
                    inUse = false;
                    var isInConcepts = realP.concepts.find(function (item) {
                        return incidenceTypeId === item.$id && item.type === 'fast';
                    });
                    inUse = angular.isDefined(isInConcepts);
                }
            }
            return inUse;
        };
        $scope.addFastIncidenceColumn = function (incidenceType) {
            // opObjs.processFromPayroll
            if (angular.isDefined(opObjs) && angular.isDefined(opObjs.processFromPayroll) && angular.isArray(opObjs.processFromPayroll.fb)) {
                var realP = opObjs.processFromPayroll.fb.find(function (item) {
                    return item.id === 'real';
                });
                if (angular.isDefined(realP)) {
                    var nature = opObjs.conceptsById.fb[incidenceType].nature === 'perception' ? 'sys_perceptions' : 'sys_deductions';
                    var isInConcepts = realP.concepts.find(function (item) {
                        return item.$id === nature;
                    });
                    var order = 100;
                    if (angular.isDefined(isInConcepts)) {
                        order = isInConcepts.order;
                    }
                    if (angular.isDefined(opObjs) && angular.isDefined(opObjs.process) && angular.isArray(opObjs.process.fb)) {
                        var real = opObjs.process.fb.find(function (item) {
                            return item.id === 'real';
                        });
                        if (angular.isDefined(real) && angular.isArray(real.concepts)) {
                            var concept = {
                                '$id': incidenceType,
                                'id': incidenceType,
                                'name': $f('getFromObject')(opObjs.conceptsById.fb, incidenceType + '.name', 'S/N'),
                                'key': $filter('getFromObject')(opObjs.conceptsById.fb, incidenceType + '.key', 'S/N'),
                                'nature': $filter('getFromObject')(opObjs.conceptsById.fb, incidenceType + '.nature', 'S/N'),
                                'conceptType': $filter('getFromObject')(opObjs.conceptsById.fb, incidenceType + '.type', 'S/N'),
                                'hiddenColumn': $filter('getFromObject')(opObjs.conceptsById.fb, incidenceType + '.hiddenColumn', false),
                                'showTotal': $filter('getFromObject')(opObjs.conceptsById.fb, incidenceType + '.showTotal', false),
                                'inputType': $filter('getFromObject')(opObjs.conceptsById.fb, incidenceType + '.inputType', 'currency'),
                                'hiddenField': $filter('getFromObject')(opObjs.conceptsById.fb, incidenceType + '.hiddenField', false),
                                'allowNegative': $filter('getFromObject')(opObjs.conceptsById.fb, incidenceType + '.allowNegative', false),
                                'order': order,
                                'type': 'fast'
                            };
                            real.concepts.push(concept);
                        }
                    }

                }
            }
        };
        $scope.fireValidation = function (notCalculate) {
            AppF.notCalculate = notCalculate ? true : false;
            $scope.$evalAsync(function () {
                if (!AppF.notCalculate) {
                    addForAction('calculate');
                }
            });
        };
        $scope.allMyEmployeesInStatus = function (status, all) {
            var allInStatus = true;
            if (all) {
                $f('loopEach')(allEmployeesO, function (employee, employeeId) {
                    if (opObjs.operation.fb.employees && opObjs.operation.fb.employees[employeeId] && opObjs.operation.fb.employees[employeeId].status !== status) {
                        allInStatus = false;
                        return;
                    }
                });
            } else {
                for (var i = 0; i < operationEmployeesF.length; i++) {
                    if (opObjs.operation.fb.employees && opObjs.operation.fb.employees[operationEmployeesF[i].$id] && opObjs.operation.fb.employees[operationEmployeesF[i].$id].status !== status) {
                        allInStatus = false;
                        i = operationEmployeesF.length;
                    }
                }
            }
            return allInStatus;
        };
        $scope.setNextOrder = function (field, actualOrder) {
            var orderArray = [['data.enroleDate', 'data.name'], field, '-' + field];
            var index = orderArray.indexOf(actualOrder);
            if (index === -1) {
                index = 0;
            }
            var nextIndex = index + 1;
            if (nextIndex >= orderArray.length) {
                nextIndex = 0;
            }
            $scope.order = orderArray[nextIndex];
        };
        $scope.saveFastIncidence = function (employeeId, incidenceTypeId, incidenceQty) {
            var timeIdentifier = new Date().valueOf();
            savingFastIncidences[timeIdentifier] = true;
            var currentFast = [];
            if (angular.isDefined(opObjs.opIncidences) && angular.isArray(opObjs.opIncidences.fb)) {
                currentFast = opObjs.opIncidences.fb.filter(function (item) {
                    return item.employee === employeeId && item.type === 'fast' && item.incidenceType === incidenceTypeId && item[$scope.operationType] === $scope.operationId;
                });
            }
            var updates = {};
            if ((incidenceQty <= 0 && !opObjs.conceptsById.fb[incidenceTypeId].allowNegative) || incidenceQty == null || angular.isUndefined(incidenceQty)) {
                for (var c = 0; c < currentFast.length; c++) {
                    updates[currentFast[c].$id] = null;
                }
            } else {
                var affectDays = opObjs.conceptsById.fb[incidenceTypeId].validateDays;
                if (affectDays) {
                    if (incidenceQty > currentFast.length) {
                        var incidences = opObjs.incidencesByEmployee.fb[employeeId];
                        var affectedDate = [];
                        if (angular.isDefined(incidences) && angular.isArray(incidences)) {
                            for (var i = 0; i < incidences.length; i++) {
                                var affect = $filter('getSomethingOfArrayFB')(incidences[i].incidenceType, opObjs.concepts.fb, 'validateDays');
                                if (affect && incidences[i].date) {
                                    affectedDate.push(incidences[i].date);
                                }
                            }
                        }
                        var count = 0;
                        var moreDays = 0;
                        var result = incidenceQty - currentFast.length;
                        while (count < result) {
                            var days = moment(opObjs.period.fb.start).add(moreDays, 'days');
                            var exist = affectedDate.indexOf(days.valueOf());
                            moreDays++;
                            if (exist === -1) {
                                var incidenceKey = AppF.root.child($scope.refs.incidences).push().key;
                                var createIncidence = {
                                    payroll: $scope.payrollId,
                                    period: $scope.period.period,
                                    calendar: $scope.calendar.$id,
                                    status: 0,
                                    incidenceType: incidenceTypeId,
                                    employee: employeeId,
                                    date: days.valueOf(),
                                    type: 'fast',
                                    value: 1,
                                    center: AppF.center,
                                    comments: 'Incidencia Rápida',
                                    created: DataF.getTimeObject(undefined, undefined, true)
                                };
                                updates[incidenceKey] = createIncidence;
                                count++;
                            }
                        }
                    } else {
                        for (var x = 0; x < currentFast.length; x++) {
                            if ((x + 1) > incidenceQty) {
                                updates[currentFast[x].$id] = null;
                            }
                        }
                    }
                } else if (currentFast.length > 0) {
                    for (var cf = 0; cf < currentFast.length; cf++) {
                        if (cf === 0) {
                            updates[currentFast[cf].$id + '/value'] = incidenceQty;
                            updates[currentFast[cf].$id + '/updated'] = DataF.getTimeObject(undefined, undefined, true);
                        } else {
                            updates[currentFast[cf].$id] = null;
                        }
                    }
                } else if (currentFast.length === 0) {
                    var incidenceId = AppF.root.child($scope.refs.incidences).push().key;
                    var defaultIncidence = {
                        payroll: $scope.payrollId,
                        period: $scope.period.period,
                        calendar: $scope.calendar.$id,
                        status: 0,
                        incidenceType: incidenceTypeId,
                        employee: employeeId,
                        type: 'fast',
                        value: incidenceQty,
                        center: AppF.center,
                        comments: 'Incidencia Rápida',
                        created: DataF.getTimeObject(undefined, undefined, true)
                    };
                    updates[incidenceId] = defaultIncidence;
                }
            }
            AppF.root.child($scope.refs.incidences).update(updates).then(function () {
                delete savingFastIncidences[timeIdentifier];
            });
        };
        $scope.filterEmployees = function () {
            $scope.selected = [];
            $scope.operationEmployees = $f('filterEmployeesForOperation')(operationEmployeesF, $scope.search);
            $scope.fiscalEmployees = $f('filterEmployeesForOperation')(fiscalEmployeesF, $scope.search);
        };
        $scope.openMenu = function ($mdOpenMenu, ev) {
            $mdOpenMenu(ev);
        };
        $scope.toggle = function (item, list) {
            var idx = list.findIndex(function (employee) {
                return employee.$id === item.$id;
            });
            if (idx > -1) {
                list.splice(idx, 1);
            } else {
                list.push(item);
            }
        };
        $scope.exists = function (item, list) {
            return list.findIndex(function (employee) {
                return employee.$id === item.$id;
            }) > -1;
        };
        $scope.showIncidencesListBottomSheet = function (event, employee) {
            AppF.notCalculate = true;
            var employeesObj;
            if ($scope.tabSelected === 'fiscal') {
                employeesObj = $f('orderBy')($scope.fiscalEmployees, $scope.order);
            } else {
                employeesObj = $f('orderBy')($scope.operationEmployees, $scope.order);
            }
            var employeeIndex = $filter('getIndexFromArray')(employeesObj, '$id', employee.$id);
            opObjs.operation.fb.calendar = parseInt(opObjs.calendar.fb.$id);
            opObjs.operation.fb.period = parseInt(opObjs.period.fb.period);
            $mdBottomSheet.show({
                templateUrl: 'app/main/clients/views/newoperation/dialogs/bottom-incidences.html',
                locals: {
                    employeeIndex: employeeIndex,
                    employees: employeesObj,
                    employee: employee,
                    operation: opObjs.operation.fb,
                    incidencesTypes: opObjs.concepts.fb,
                    incidencesTypesForPayroll: opObjs.incidencesTypes.fb,
                    operationData: opObjs.period.fb,
                    payroll: $scope.payrollId,
                    nextEmployeeStatus: $scope.nextEmployeeStatus,
                    opStatusNotCalc: $scope.opStatusNotCalc,
                    readOnlyMode: $scope.readOnlyMode,
                    operationIsClosed: opObjs.operation.fb.status >= $scope.opStatusNotCalc,
                    allEmployees: allEmployeesO,
                    operationType: 'settlement'
                },
                controller: 'showIncidencesListController',
                parent: '.md-tab-body',
                clickOutsideToClose: false,
                escapeToClose: true,
                targetEvent: event
            }).then(function () {
                //$log.debug(clickedItem)
            }).catch(function (error) {
                $log.debug('Incidences modal closed', error);
            }).then(function () {
                AppF.notCalculate = false;
                $scope.$evalAsync(function () {
                    addForAction('calculate');
                });
            });
        };
        $scope.showCalculationsListBottomSheet = function (event, employeeId) {
            var employeesObj;
            if ($scope.tabSelected === 'fiscal') {
                employeesObj = $f('orderBy')($scope.fiscalEmployees, $scope.order);
            } else {
                employeesObj = $f('orderBy')($scope.operationEmployees, $scope.order);
            }
            var employeeIndex = $filter('getIndexFromArray')(employeesObj, '$id', employeeId);
            $mdBottomSheet.show({
                templateUrl: 'app/main/clients/views/newoperation/dialogs/bottom-calculations.html',
                locals: {
                    employeeIndex: employeeIndex,
                    employees: employeesObj,
                    calculations: $scope.calculations,
                    concepts: opObjs.conceptsByKey.fb
                },
                controller: 'showCalculationsListController',
                parent: '.md-tab-body',
                clickOutsideToClose: false,
                escapeToClose: true,
                targetEvent: event,
                isLockedOpen: true
            }).then(function () {
                //$log.debug(clickedItem);
            }).catch(function (error) {
                $log.debug('Calculations modal closed', error);
            });
        };
        $scope.allHave = function (selected, path) {
            var allHave = false;
            if (angular.isArray(selected) && selected.length > 0) {
                allHave = true;
                for (var e = 0; e < selected.length && allHave; e++) {
                    var value = $filter('getFromObject')($scope.operation.employees, selected[e].$id + "." + path)
                    if (angular.isUndefined(value)) {
                        allHave = false;
                    }
                }
            }
            return allHave;
        }
        $scope.downloadManyFiles = function (selected, file) {
            if (angular.isArray(selected) && selected.length > 0) {
                var promises = [];
                var promisesIndex = [];
                for (var e = 0; e < selected.length; e++) {
                    var bucketUrl = $filter('getFromObject')($scope.operation.employees, selected[e].$id + "." + file);
                    var fileName = $filter('getFromObject')($scope.operation.employees, selected[e].$id + ".fileName");
                    if (angular.isUndefined(bucketUrl)) {
                        errAlertS('El empleado ' + allEmployeesO[selected[e].$id].data.name + ' no tiene la url definida');
                    } else {
                        promises.push(firebase.storage().ref().child(bucketUrl).getDownloadURL());
                        promisesIndex.push(fileName)
                    }
                }
                Promise.all(promises).then(function (resp) {
                    promises = [];
                    for (var r = 0; r < resp.length; r++) {
                        promises.push(getFileRequest(resp[r]));
                    }
                    return Promise.all(promises);
                }).then(function (blobs) {
                    for (var b = 0; b < blobs.length; b++) {
                        var url = window.URL.createObjectURL(blobs[b]);
                        var linkElement = document.createElement('a');
                        linkElement.setAttribute('href', url);
                        linkElement.setAttribute('download', promisesIndex[b]);
                        var clickEvent = new MouseEvent("click", {
                            "view": window,
                            "bubbles": true,
                            "cancelable": false
                        });
                        linkElement.dispatchEvent(clickEvent);
                    }
                }).catch(function (error) {
                    $log.log(error);
                    errAlertS('Error al obtener los archivos')
                });
            } else {
                errAlertS("No se selecciono ningún empleado")
            }
        }
        function getFileRequest(publicLink) {
            return new Promise(function (resolve, reject) {
                var xhr = new XMLHttpRequest();
                xhr.responseType = 'blob';
                xhr.onload = function (event) {
                    var blob = xhr.response;
                    resolve(blob);
                };
                xhr.open('GET', publicLink);
                xhr.send();
                xhr.addEventListener('error', reject);
                xhr.addEventListener('abort', reject);
            })
        }
        $scope.sendManyByEmail = function (selected) {
            if (angular.isArray(selected) && selected.length > 0) {
                for (var e = 0; e < selected.length; e++) {
                    var billId = $filter('getFromObject')($scope.operation.employees, selected[e].$id + ".billId");
                    if (angular.isUndefined(billId)) {
                        errAlertS('El empleado ' + allEmployeesO[selected[e].$id].data.name + ' no tiene el recibo');
                    } else {
                        sendBillByEmail(billId, selected[e].$id)
                    }
                }
            } else {
                errAlertS("No se selecciono ningún empleado")
            }
        }
        $scope.exportToExcel = function () {
            var dataToExport = $filter('generateIncidencesToImportV2')(operationEmployeesF, allEmployeesO, opObjs.payroll.fb, opObjs.period.fb, $scope.calendar.$id, opObjs.conceptsById.fb);
            if (dataToExport.length > 0) {
                var data = {
                    data: angular.toJson(dataToExport)
                };
                CatalogsF.exportToExcel('interface/exportDataToCSV', data);
            } else {
                errAlertS('No se encontraron incidencias a importar');
            }
        };
        $scope.exportToExcelWithHeaders = function () {
            var employee = allEmployeesO[operationEmployeesF[0].$id];
            var movementDate = $filter('date')($filter("getFromObject")(opObjs.operation.fb, "movement.date", ""), AppF.dateFormat);
            var calculations = $scope.calculations[employee.$id];
            if (angular.isUndefined($filter("getFromObject")(calculations, "initEmployeeDate.value.result")) || angular.isUndefined($filter("getFromObject")(calculations, "initEmployeeDate.fiscal.result"))) {
                errAlertS('No se encontró la fecha de alta de ' + employee.data.name);
                return false;
            }
            var data = {
                headerRows: [
                    [opObjs.payroll.fb.data.class + '-' + opObjs.payroll.fb.data.name],
                    [$filter("getFromObject")(employee, "data.employeeNumber", "N/A") + ' - ' + employee.data.name]
                ],
                head: ['DESCRIPCION', 'C1', 'REAL', 'C2', 'C3', 'FISCAL', 'C4', 'COMPLEMENTO'],
                body: [
                    {
                        'DESCRIPCION': 'FECHA DE ALTA',
                        'REAL': $filter('date')(calculations.initEmployeeDate.value.result)
                    },
                    {
                        'DESCRIPCION': 'FECHA DE BAJA',
                        'REAL': movementDate
                    },
                    {
                        'DESCRIPCION': 'SALARIO DIARIO',
                        'REAL': $filter('roundNumber')(employee.data.salary.sdr)
                    },
                    {
                        'DESCRIPCION': 'AGUINALDO',
                        'REAL': employee.realBenefitConfig.christmasBonus
                    },
                    {
                        'DESCRIPCION': 'AÑOS',
                        'C1': $filter('roundNumber')(employee.realBenefitConfig.realYears),
                        'REAL': employee.realBenefitConfig.daysOfVacation
                    }
                ]
            }
            var calFiscal = false;
            var calPrevision = false;
            var process = opObjs.process.fb;
            for (var p = 0; p < process.length; p++) {
                if (process[p].id === 'fiscal') {
                    calFiscal = true;
                }
                if (process[p].id === 'socialPrevision') {
                    calPrevision = true;
                }
            }
            if (!calFiscal) {
                var newHead = data.head.filter(function (value, index) {
                    return [3, 4, 5].indexOf(index) === -1;
                })
                data.head = newHead;
            }
            if (!calPrevision) {
                var newHead = data.head.filter(function (value, index) {
                    return [6, 7].indexOf(index) === -1;
                })
                data.head = newHead;
            }
            if (calFiscal) {
                data.body[0]['FISCAL'] = $filter('date')(calculations.initEmployeeDate.fiscal.result);
                data.body[1]['FISCAL'] = movementDate;
                data.body[2]['FISCAL'] = employee.data.salary.sd;
                data.body[3]['FISCAL'] = employee.fiscalBenefitConfig.christmasBonus;
                data.body[4]['C3'] = $filter('roundNumber')(employee.fiscalBenefitConfig.realYears);
                data.body[4]['FISCAL'] = employee.fiscalBenefitConfig.daysOfVacation;
            }
            if (angular.isDefined($filter("getFromObject")(calculations, "holidays_settlement.daysForHolidays.result"))) {
                data.body.push({
                    'DESCRIPCION': 'DIAS PARA VACACIONES',
                    'C1': $filter("getFromObject")(calculations, "holidays_settlement.daysForHolidays.result", ""),
                    'REAL': moment($filter("getFromObject")(calculations, "holidays_settlement.initVacationDate.result")).format('DD/MM/YYYY')
                });
                if (calFiscal) {
                    data.body[data.body.length - 1]['C3'] = calculations.holidays_settlement.daysForHolidaysF.result;
                    data.body[data.body.length - 1]['FISCAL'] = moment($filter("getFromObject")(calculations, "holidays_settlement.initVacationDateF.result", 0)).format('DD/MM/YYYY');
                }
            } else {
                var index = data.body.findIndex(function (value) {
                    return value['DESCRIPCION'] === 'AÑOS';
                })
                data.body.splice(index, 1);
            }
            if (angular.isDefined($filter("getFromObject")(calculations, "christmasBonus_settlement.daysOfYear.result"))) {
                data.body.push({
                    'DESCRIPCION': 'DIAS PARA AGUINALDO',
                    'C1': calculations.christmasBonus_settlement.daysOfYear.result,
                    'REAL': moment($filter("getFromObject")(calculations, "christmasBonus_settlement.startSettlementDate.result")).format('DD/MM/YYYY')
                });
                if (calFiscal) {
                    data.body[data.body.length - 1]['C3'] = calculations.christmasBonus_settlement.daysOfYear.result;
                    data.body[data.body.length - 1]['FISCAL'] = moment($filter("getFromObject")(calculations, "christmasBonus_settlement.startSettlementDateF.result", 0)).format('DD/MM/YYYY');
                }
            } else {
                var index = data.body.findIndex(function (value) {
                    return value['DESCRIPCION'] === 'AGUINALDO';
                })
                data.body.splice(index, 1);
            }

            data.body.push({});

            var createDailySalary = false;
            var dailySalary = {
                'DESCRIPCION': 'SUELDO'
            };
            if (angular.isDefined($filter("getFromObject")(calculations, "workedDays.value.result")) && angular.isDefined($filter("getFromObject")(calculations, "dailySalary.value.result"))) {
                dailySalary['C1'] = calculations.workedDays.value.result;
                dailySalary['REAL'] = calculations.salary.value.result;
                createDailySalary = true;
            }
            if (angular.isDefined($filter("getFromObject")(calculations, "fiscalWorkedDays.value.result")) && angular.isDefined($filter("getFromObject")(calculations, "fiscalDailySalary.value.result"))) {
                dailySalary['C3'] = calculations.fiscalWorkedDays.value.result;
                dailySalary['FISCAL'] = calculations.fiscalSalary.value.result;
                createDailySalary = true;
            }
            if (createDailySalary) { data.body.push(dailySalary); }

            var deductions = [];
            var fiscalF = [];
            var socialPrevisionF = [];
            var billTotal = [];
            for (var i = 0; i < process.length; i++) {
                if (process[i].id === 'real') {
                    var allConcepts = angular.fromJson(angular.toJson(process[i].concepts));
                    var incidences = process[i].incidences;
                    var newOrder = [];
                    for (var x = 0; x < allConcepts.length; x++) {
                        var orderByConcept = incidences.find(function (value) {
                            return value.$id === allConcepts[x].$id || value.id === allConcepts[x].$id;
                        });
                        if (orderByConcept) {
                            allConcepts[x].order = orderByConcept.order;
                        } else {
                            allConcepts[x].order = allConcepts[x].order * 100;
                        }
                        newOrder.push(allConcepts[x]);
                    }
                    var concepts = $filter('orderBy')(newOrder || [], ['order', 'name']);
                    for (var c = 0; c < concepts.length; c++) {
                        if (concepts[c].conceptType === 'incidenceType' && concepts[c].nature === 'perception') {
                            var pro = {
                                'DESCRIPCION': concepts[c].name
                            }
                            if (angular.isDefined($filter("getFromObject")(calculations[concepts[c].key], "value.result")) && calculations[concepts[c].key].value.result > 0) {
                                pro['REAL'] = calculations[concepts[c].key].value.result;
                            }
                            if (angular.isDefined($filter("getFromObject")(calculations[concepts[c].key], "bonusDays.result")) && calculations[concepts[c].key].bonusDays.result > 0) {
                                pro['C1'] = calculations[concepts[c].key].bonusDays.result;
                            }
                            if (angular.isDefined($filter("getFromObject")(calculations[concepts[c].key], "holidays.result")) && calculations[concepts[c].key].holidays.result > 0) {
                                pro['C1'] = calculations[concepts[c].key].holidays.result;
                            }
                            if (angular.isDefined($filter("getFromObject")(calculations[concepts[c].key], "prime.result")) && calculations[concepts[c].key].prime.result > 0) {
                                pro['C1'] = calculations[concepts[c].key].prime.result;
                            }
                            if (angular.isDefined($filter("getFromObject")(calculations[concepts[c].key], "bonusDaysF.result")) && calculations[concepts[c].key].bonusDaysF.result > 0) {
                                pro['C3'] = calculations[concepts[c].key].bonusDaysF.result;
                            }
                            if (angular.isDefined($filter("getFromObject")(calculations[concepts[c].key], "holidaysF.result")) && calculations[concepts[c].key].holidaysF.result > 0) {
                                pro['C3'] = calculations[concepts[c].key].holidaysF.result;
                            }
                            if (angular.isDefined($filter("getFromObject")(calculations[concepts[c].key], "primeF.result")) && calculations[concepts[c].key].primeF.result > 0) {
                                pro['C3'] = calculations[concepts[c].key].primeF.result;
                            }
                            if (angular.isDefined($filter("getFromObject")(calculations[concepts[c].key], "fiscalValue.result")) && calculations[concepts[c].key].fiscalValue.result > 0) {
                                pro['FISCAL'] = calculations[concepts[c].key].fiscalValue.result;
                            }
                            data.body.push(pro);
                        }
                        if (concepts[c].conceptType === 'incidenceType' && concepts[c].nature === 'deduction') {
                            var value = $filter("getFromObject")(calculations[concepts[c].key], "value.result", 0);
                            var fiscalValue = $filter("getFromObject")(calculations[concepts[c].key], "fiscalValue.result", 0);
                            var complementValue = $filter("getFromObject")(calculations[concepts[c].key], "socialPrevisionValue.result", 0);
                            var valueNormal = $filter("getFromObject")(calculations[concepts[c].key], "valueNormal.result", 0);
                            if (value !== valueNormal) {
                                var valueRejected = value - valueNormal;
                                var fiscalValueRejected = $filter("getFromObject")(calculations[concepts[c].key], "fiscalValueRejected.result", 0);
                                var complementValueRejected = $filter("getFromObject")(calculations[concepts[c].key], "socialPrevisionValueRejected.result", 0);
                                var deductionsObjRejected = {
                                    'DESCRIPCION': concepts[c].name + ' RECHAZADO',
                                    'REAL': valueRejected,
                                    'FISCAL': fiscalValueRejected,
                                    'COMPLEMENTO': complementValueRejected
                                };
                                deductions.push(deductionsObjRejected);
                                var deductionsObj = {
                                    'DESCRIPCION': concepts[c].name,
                                    'REAL': value - valueRejected,
                                    'FISCAL': fiscalValue - fiscalValueRejected,
                                    'COMPLEMENTO': complementValue - complementValueRejected
                                };
                                deductions.push(deductionsObj);
                            } else if (value !== 0 || fiscalValue !== 0 || complementValue !== 0) {
                                var deductionsObj2 = {
                                    'DESCRIPCION': concepts[c].name,
                                    'REAL': value,
                                    'FISCAL': fiscalValue,
                                    'COMPLEMENTO': complementValue
                                };
                                deductions.push(deductionsObj2);
                            }
                        }
                    }
                }
                if (['fiscal', 'socialPrevision'].indexOf(process[i].id) > -1) {
                    if (process[i].id === 'fiscal' && angular.isDefined(process[i].totals)) {
                        var fiscalTotals = $filter('orderBy')(process[i].totals, 'order');
                        for (var f = 0; f < fiscalTotals.length; f++) {
                            if ($scope.operationTotals.hasOwnProperty(fiscalTotals[f].$id)) {
                                var operation = (angular.isDefined(fiscalTotals[f].operation)) ? fiscalTotals[f].operation + 1 : 1;
                                fiscalF.push({ name: fiscalTotals[f].name, fiscal: $scope.operationTotals[fiscalTotals[f].$id][fiscalTotals[f].field] * operation });
                            }
                        }
                    }
                    if (process[i].id === 'socialPrevision' && angular.isDefined(process[i].totals)) {
                        var objTotals = {};
                        var previsionTotals = $filter('orderBy')(process[i].totals, 'order');
                        for (var p = 0; p < previsionTotals.length; p++) {
                            if ($scope.operationTotals.hasOwnProperty(previsionTotals[p].$id)) {
                                if (calFiscal) {
                                    var bill = fiscalF.find(function (value) {
                                        return value.name === previsionTotals[p].name;
                                    });
                                    if (bill) {
                                        var operation = (angular.isDefined(previsionTotals[p].operation)) ? previsionTotals[p].operation + 1 : 1;
                                        var totalP = $scope.operationTotals[previsionTotals[p].$id][previsionTotals[p].field] * operation;
                                        objTotals = {
                                            name: bill.name,
                                            real: (bill.fiscal && totalP) ? bill.fiscal + totalP : bill.fiscal || totalP,
                                            fiscal: bill.fiscal || 0,
                                            prevision: $scope.operationTotals[previsionTotals[p].$id][previsionTotals[p].field]
                                        }
                                        socialPrevisionF.push(objTotals);
                                    }
                                } else {
                                    billTotal.push({
                                        'DESCRIPCION': previsionTotals[p].name,
                                        'REAL': $scope.operationTotals[previsionTotals[p].$id][previsionTotals[p].field],
                                        'COMPLEMENTO': $scope.operationTotals[previsionTotals[p].$id][previsionTotals[p].field]
                                    });
                                }
                            }
                        }
                    }
                }
            }

            for (var t = 0; t < fiscalF.length; t++) {
                var merge = socialPrevisionF.find(function (value) {
                    return value.name === fiscalF[t].name;
                });
                if (merge) {
                    billTotal.push({
                        'DESCRIPCION': merge.name,
                        'REAL': $filter('roundNumber')(merge.real),
                        'FISCAL': $filter('roundNumber')(merge.fiscal),
                        'COMPLEMENTO': $filter('roundNumber')(merge.prevision)
                    });
                } else {
                    billTotal.push({
                        'DESCRIPCION': fiscalF[t].name,
                        'REAL': $filter('roundNumber')(fiscalF[t].fiscal),
                        'FISCAL': $filter('roundNumber')(fiscalF[t].fiscal),
                    });
                }
            }
            if (angular.isDefined($filter("getFromObject")(calculations.fiscalAdjusment, "value.result")) && calculations.fiscalAdjusment.value.result !== 0) {
                data.body.push({
                    'DESCRIPCION': 'AJUSTE FISCAL',
                    'REAL': calculations.fiscalAdjusment.value.result
                });
            } else {
                data.body.push({});
            }
            if (angular.isDefined($filter("getFromObject")(calculations.socialPrevisionPerceptions, "value.result")) && calculations.socialPrevisionPerceptions.value.result > 0) {
                data.body.push({
                    'DESCRIPCION': 'COMPLEMENTO',
                    'COMPLEMENTO': calculations.socialPrevisionPerceptions.value.result
                });
            }
            var createTotalPerceptions = false;
            var totalPerceptions = {
                'DESCRIPCION': 'TOTAL PERCEPCIONES'
            }
            if (angular.isDefined($filter("getFromObject")(calculations.perceptions, "wSalary.result")) && calculations.perceptions.wSalary.result > 0) {
                totalPerceptions['REAL'] = calculations.perceptions.wSalary.result;
                createTotalPerceptions = true;
            }
            if (angular.isDefined($filter("getFromObject")(calculations.fiscalPerceptions, "wSalary.result")) && calculations.fiscalPerceptions.wSalary.result > 0) {
                totalPerceptions['FISCAL'] = calculations.fiscalPerceptions.wSalary.result;
                createTotalPerceptions = true;
            }
            if (angular.isDefined($filter("getFromObject")(calculations.socialPrevisionPerceptions, "value.result")) && calculations.socialPrevisionPerceptions.value.result > 0) {
                totalPerceptions['COMPLEMENTO'] = calculations.socialPrevisionPerceptions.value.result;
                createTotalPerceptions = true;
            }
            if (angular.isDefined($filter("getFromObject")(calculations.subsidy, "value.result")) && calculations.subsidy.value.result > 0) {
                data.body.push({ 'DESCRIPCION': 'SUBSIDIO', 'FISCAL': calculations.subsidy.value.result });
            }
            if (angular.isDefined($filter("getFromObject")(calculations.isrAdjustment, "value.result")) && calculations.isrAdjustment.value.result > 0) {
                data.body.push({ 'DESCRIPCION': 'AJUSTE DE ISR', 'FISCAL': calculations.isrAdjustment.value.result });
            }
            if (createTotalPerceptions) {
                data.body.push(totalPerceptions);
            }
            if (angular.isDefined($filter("getFromObject")(calculations.isr, "value.result")) && calculations.isr.value.result > 0) {
                data.body.push({ 'DESCRIPCION': 'ISR', 'FISCAL': calculations.isr.value.result });
            }
            if (angular.isDefined($filter("getFromObject")(calculations.isrSettlement, "value.result")) && calculations.isrSettlement.value.result > 0) {
                data.body.push({ 'DESCRIPCION': 'ISR LIQUIDACION', 'FISCAL': calculations.isrSettlement.value.result });
            }
            if (angular.isDefined($filter("getFromObject")(calculations.subsidyAdjustment, "value.result")) && calculations.subsidyAdjustment.value.result > 0) {
                data.body.push({ 'DESCRIPCION': 'AJUSTE DE SUBSIDIO', 'FISCAL': calculations.subsidyAdjustment.value.result });
            }
            if (angular.isDefined($filter("getFromObject")(calculations.socialSecurity, "value.result")) && calculations.socialSecurity.value.result > 0) {
                data.body.push({ 'DESCRIPCION': 'SEGURIDAD SOCIAL', 'FISCAL': calculations.socialSecurity.value.result });
            }
            if (deductions.length > 0) {
                data.body = data.body.concat(deductions);
            }
            var createTotal = {
                'DESCRIPCION': 'NETO'
            }
            if (angular.isDefined($filter("getFromObject")(calculations, "realTotal.value.result")) && calculations.realTotal.value.result !== 0) {
                createTotal['REAL'] = calculations.realTotal.value.result;
            }
            if (angular.isDefined($filter("getFromObject")(calculations, "fiscalTotal.value.result")) && calculations.fiscalTotal.value.result !== 0) {
                createTotal['FISCAL'] = calculations.fiscalTotal.value.result;
            }
            if (angular.isDefined($filter("getFromObject")(calculations, "socialPrevisionTotal.value.result")) && calculations.socialPrevisionTotal.value.result !== 0) {
                createTotal['COMPLEMENTO'] = calculations.socialPrevisionTotal.value.result;
            }
            var promises = [];
            var request = [];
            for (var p = 0; p < process.length; p++) {
                if (['fiscal', 'socialPrevision'].indexOf(process[p].id) > -1) {
                    promises.push($filter('getCompaniesName')($scope.payrollId, process[p].name))
                    request.push({ id: process[p].id, name: process[p].name });
                }
            }
            AppF.root.child('catalogs/ccs/collection/' + employee.cc + '/data/name').once('value').then(function (name) {
                if (name.exists()) {
                    data.headerRows.push([name.val()]);
                } else {
                    throw "No se encontró el centro de costo del empleado";
                }
                return Promise.all(promises);
            }).then(function (businessName) {
                if (businessName.length > 0) {
                    var error = false;
                    var business = {
                        'DESCRIPCION': 'DESCRIPCION',
                        'REAL': 'IMPORTE'
                    };
                    var background = {};
                    for (var e = 0; e < request.length; e++) {
                        if (angular.isDefined(businessName[e].message)) {
                            errAlertS(businessName[e].message + ' en la parte ' + request[e].name);
                            error = true;
                        }
                        if (angular.isDefined(businessName[e].data) && angular.isDefined(businessName[e].data.name)) {
                            if (request[e].id === 'fiscal') {
                                business['FISCAL'] = businessName[e].data.name;
                                background.f = businessName[e].data.name;
                            } else if (request[e].id === 'socialPrevision') {
                                business['COMPLEMENTO'] = businessName[e].data.name;
                                background.p = businessName[e].data.name;
                            }
                        }
                    }
                    if (!error) {
                        data.body.push(
                            {},
                            createTotal,
                            {}, {}, {},
                            { 'DESCRIPCION': 'FACTURACION' },
                            business
                        );
                        data.body = data.body.concat(billTotal);
                        var values = {
                            start: { date: 0 },
                            end: { date: 0 }
                        };
                        var promises = [];
                        if (angular.isArray(employee.incidences) && employee.incidences.length > 0) {
                            var incidences = angular.fromJson(angular.toJson(employee.incidences));
                            var createdF = incidences.filter(function (value) {
                                return angular.isDefined(value.created) && value.type === 'manual' || value.type === 'fast';
                            });
                            var updatedF = incidences.filter(function (value) {
                                return angular.isDefined(value.updated) && value.type === 'manual' || value.type === 'fast';
                            });
                            if (createdF) {
                                var created = $filter('orderBy')(createdF, '-created.atTime');
                                if (angular.isDefined($filter("getFromObject")(created[0], "created.atTime"))) {
                                    values.start.date = created[0].created.atTime;
                                    values.start.uid = created[0].created.by;
                                }
                            }
                            if (updatedF) {
                                var updated = $filter('orderBy')(updatedF, '-updated.atTime');
                                if (angular.isDefined($filter("getFromObject")(updated[0], "updated.atTime"))) {
                                    if (updated[0].updated.atTime > values.start.date) {
                                        values.start.date = updated[0].updated.atTime;
                                        values.start.uid = updated[0].updated.by;
                                    }
                                }
                            }
                            if ((createdF.length === 0 && updatedF.length === 0) || angular.isUndefined(values.start.uid)) {
                                promises.push(AppF.root.child('profiles/' + $filter("getFromObject")(opObjs.operation.fb, "created.by")).once('value'));
                            } else {
                                promises.push(AppF.root.child('profiles/' + values.start.uid).once('value'));
                            }
                        }
                        Promise.all(promises).then(function (snap) {
                            if (snap.length > 0 && snap[0].exists()) {
                                var profileData = snap[0].val();
                                data.body.push(
                                    {}, {}, {}, {},
                                    { 'DESCRIPCION': 'LIC. ' + angular.uppercase(profileData.data.name) },
                                    { 'DESCRIPCION': 'EJECUTIVO DE CUENTA' }
                                );
                                if (auxProccess.length === 1 && auxProccess[0].id === 'fiscal') {
                                    var headF = data.head.filter(function (value, index) {
                                        return [1, 2, 3].indexOf(index) === -1;
                                    });
                                    data.head = headF;
                                }
                                var thisCalendar = $filter('getFromObject')(opObjs.operation.fb, 'calendar') ? '_' + opObjs.operation.fb.calendar : '';
                                var thisPeriod = $filter('getFromObject')(opObjs.operation.fb, 'period') ? '_' + $filter('zeroFill')(opObjs.operation.fb.period, 2) : '';
                                var thisCenter = AppF.center.toUpperCase();
                                var thisFileName = 'TOT_' + thisCenter + thisCalendar + '_' + opObjs.payroll.fb.data.class + '_' + employee.data.name + thisPeriod + "_" + $filter("getFromObject")(employee.data, "employeeNumber", "00000");
                                var obj = {
                                    headers: angular.toJson(data.headerRows),
                                    head: angular.toJson(data.head),
                                    data: angular.toJson(data.body),
                                    filename: thisFileName,
                                    background: angular.toJson(background)
                                }
                                CatalogsF.exportToExcel('interface/exportDataToSettlements', obj);
                            } else {
                                errAlertS('No hay cálculos de operación a exportar');
                            }
                        }).catch(function (error) {
                            $log.error(error);
                            errAlertS('Ocurrió un error al consultar los datos');
                        });
                    }
                }
            }).catch(function (error) {
                errAlertS(error);
            })
            var object = {
                calculations: calculations,
                employee: employee.$id,
                operationId: opObjs.operation.fb.$id,
                created: moment().format('YYYY-MM-DD HH:mm:ss'),
                user: AppF.profile.data
            }
            if (opObjs.operation.fb.status < 3) {
                $scope.D.api.addWithUnique('settlementCalculations', object);
            }
        }
        $scope.generateAccountingAccount = function () {
            var process = $scope.process.find(function (process) {
                return process.id === $scope.tabSelected;
            });
            if (!process) {
                errAlertS('No se encontró el nombre del proceso');
                return false;
            }
            var data = {
                specialPeriod: opObjs.operation.fb.specialPeriod,
                operationType: 'settlement',
                operationId: opObjs.operation.fb.$id,
                dispersionId: opObjs.operation.fb.dispersion,
                payrollId: $scope.payrollId,
                calendar: $filter('getFromObject')(opObjs.operation.fb, 'calendar'),
                period: $filter('getFromObject')(opObjs.operation.fb, 'period'),
                process: process.id
            }
            $scope.C.exportToExcel('interface/exportAnyFiles', { data: angular.toJson([data]), nameF: 'exportAccount' });
        }
        $scope.generateAccountingAccountBy2 = function (process) {
            console.log(process)
            $log.log('generateAccountingAccountBy2 called', process);
            var data = {
                operationType: 'settlement',
                operationId: opObjs.operation.fb.$id,
                dispersionId: opObjs.operation.fb.dispersion,
                payroll: $scope.payrollId,
                payrollId: $scope.payrollId,
                calendar: $filter('getFromObject')(opObjs.operation.fb, 'calendar'),
                downloading: false,
                period: $filter('getFromObject')(opObjs.operation.fb, 'period'),
                process: process,
                processName: process.toUpperCase()
            }
            $scope.C.exportToExcel('interface/exportAccountingAccounts', { data: angular.toJson([data]), nameF: 'exportAccount' });
        };

        $scope.exportSettlementReport = function (tabName) {
            try {
                var processes = $scope.process.find(function (process) {
                    return process.id === $scope.tabSelected;
                });
                if (!processes) {
                    throw 'No se encontró el nombre del proceso';
                }
                var type = processes.name;
                var employees = $f('orderBy')($scope.fiscalEmployees, $scope.order);
                if ($scope.tabSelected === 'socialPrevision') {
                    employees = $f('orderBy')($scope.operationEmployees, $scope.order);
                }
                if (employees.length < 1) {
                    throw 'No hay datos del empleado a procesar';
                }
                var employee = allEmployeesO[employees[0].$id];
                var calculations = $scope.calculations[employee.$id];
                var paymentForms = $scope.M.paymentForms;
                var paymentFormsObj = {};
                var defaultPaymentForm = paymentForms.find(function (value) {
                    return value.key === 'transfer';
                });
                for (var p = 0; p < paymentForms.length; p++) {
                    paymentFormsObj[paymentForms[p]._id] = {
                        name: paymentForms[p].name
                    }
                }
                var employeePaymentForm = $filter('getEmployeePaymentForm')(employee.paymentForms, processes.id)
                var bankObj = {
                    paymentMethod: (employeePaymentForm) ? paymentFormsObj[employeePaymentForm].name : paymentFormsObj[defaultPaymentForm._id].name
                }
                var typeObj = {
                    'TRANSFERENCIA': 'numberAccount',
                    'INTERBANCARIA': 'clabe'
                };
                var card;
                if (['TRANSFERENCIA', 'INTERBANCARIA'].indexOf(bankObj.paymentMethod) > -1) {
                    card = $f('getEmployeeAccount')(employee, $scope.tabSelected, 'settlement', defaultPaymentForm._id)
                    bankObj[typeObj[bankObj.paymentMethod]] = card.number;
                }
                $filter('getCompaniesName')($scope.payrollId, type).then(function (response) {
                    if (angular.isDefined(response.data)) {
                        var bank;
                        if (angular.isDefined(card)) {
                            bank = $scope.M.banks.find(function (value) {
                                return value._id === card.bank;
                            });
                        }
                        var state;
                        if (angular.isDefined(employee.place)) {
                            state = $scope.M.states.find(function (value) {
                                return value._id === employee.place.state_id;
                            });
                        } else {
                            throw 'No se encontró la plaza de trabajo del centro de costo';
                        }
                        if (tabName === 'fiscal') {
                            var position;
                            AppF.root.child('lists/positions/payroll/' + $scope.payrollId + '/' + employee.data.position).once('value').then(function (snap) {
                                var query = [];
                                if (snap.exists()) {
                                    var positionObj = snap.val();
                                    if (positionObj.isFiscal === true) {
                                        position = positionObj.name;
                                    } else {
                                        query.push(AppF.root.child('lists/positions/payroll/' + $scope.payrollId + '/' + positionObj.fiscalPosition).once('value'));
                                    }
                                }
                                return Promise.all(query);
                            }).then(function (snapF) {
                                var namePosition = position;
                                if (snapF.length > 0 && snapF[0].exists()) {
                                    var p = snapF[0].val();
                                    namePosition = p.name;
                                }
                                var promises = [];
                                promises.push(AppF.root.child('catalogs/ccs/collection/' + employee.cc + '/data/name').once('value'));
                                Promise.all(promises).then(function (resp) {
                                    if (angular.isUndefined(namePosition)) {
                                        throw 'No se encontró el puesto del empleado';
                                    }
                                    var enroleDate = employee.data.enroleDate;
                                    if (employee.hasSeniorityDate === true) {
                                        if ($filter("getFromObject")(employee.data, "seniorityDate")) {
                                            enroleDate = employee.data.seniorityDate;
                                        } else {
                                            throw 'El empleado no tiene una fecha de antigüedad';
                                        }
                                    }
                                    var thisCalendar = $filter('getFromObject')(opObjs.operation.fb, 'calendar') ? '_' + opObjs.operation.fb.calendar : '';
                                    var thisPeriod = $filter('getFromObject')(opObjs.operation.fb, 'period') ? '_' + $filter('zeroFill')(opObjs.operation.fb.period, 2) : '';
                                    var thisCenter = AppF.center.toUpperCase();
                                    var thisFileName = 'CARTA_' + response.data.name + "_" + thisCenter + thisCalendar + '_' + opObjs.payroll.fb.data.class + '_' + employee.data.name + thisPeriod + '_' + $filter("getFromObject")(employee.data, "employeeNumber", "00000");
                                    var fiscal = {
                                        company: {
                                            name: response.data.businessName
                                        },
                                        employee: {
                                            numberEmployee: $filter("getFromObject")(employee.data, "employeeNumber", "00000"),
                                            name: employee.data.name,
                                            rfc: employee.data.rfc,
                                            position: namePosition,
                                            enroleDate: $filter('date')(enroleDate, AppF.dateFormat),
                                            movement: $filter('date')($filter("getFromObject")(opObjs.operation.fb, "movement.date", ""), AppF.dateFormat),
                                            nss: employee.data.nss,
                                            sd: employee.data.salary.sd,
                                            sbc: employee.data.salary.sbc
                                        },
                                        concepts: {},
                                        determination: {
                                            perceptions: [],
                                            deductions: [],
                                            totals: {}
                                        },
                                        filename: thisFileName
                                    }
                                    // if (angular.isDefined(enrole) && angular.isDefined(cancellation)) {
                                    //     fiscal.employee.workedDays = cancellation.diff(enrole, "days") + 1;
                                    // }
                                    fiscal.employee.workedDays = $filter("getFromObject")(calculations, "fiscalWorkedDays.value.result");
                                    if (angular.isUndefined(fiscal.employee.workedDays)) {
                                        fiscal.employee.workedDays = 0;
                                    }
                                    if (angular.isDefined($filter("getFromObject")(employee, "fiscalBenefitConfig.christmasBonus"))) {
                                        fiscal.employee.christmasBonus = employee.fiscalBenefitConfig.christmasBonus;
                                    }
                                    if (angular.isDefined($filter("getFromObject")(employee, "fiscalBenefitConfig.daysOfVacation"))) {
                                        fiscal.employee.daysOfVacation = employee.fiscalBenefitConfig.daysOfVacation;
                                    }
                                    var prime;
                                    if (angular.isDefined($filter("getFromObject")(employee, "fiscalBenefitConfig.prime"))) {
                                        fiscal.employee.prime = employee.fiscalBenefitConfig.prime;
                                        prime = employee.fiscalBenefitConfig.prime + '%';
                                    }
                                    fiscal.employee.payroll = opObjs.payroll.fb.data.class + ' ' + opObjs.payroll.fb.data.name;
                                    fiscal.employee.ccs = resp[0].val();
                                    fiscal.employee.paymentMethod = bankObj.paymentMethod;
                                    if (angular.isDefined(bankObj.numberAccount) && angular.isDefined(bank)) {
                                        fiscal.employee.numberAccount = bankObj.numberAccount;
                                        fiscal.employee.bankName = bank.name;
                                    }
                                    if (angular.isDefined(bankObj.clabe) && angular.isDefined(bank)) {
                                        fiscal.employee.clabe = bankObj.clabe;
                                        fiscal.employee.bankName = bank.name;
                                    }
                                    if (angular.isDefined($filter("getFromObject")(calculations, "christmasBonus_settlement.bonusDaysF.result"))) {
                                        fiscal.concepts.christmasBonus = calculations.christmasBonus_settlement.bonusDaysF.result;
                                    }
                                    if (angular.isDefined($filter("getFromObject")(calculations, "holidays_settlement.holidaysF.result"))) {
                                        fiscal.concepts.holidays = calculations.holidays_settlement.holidaysF.result;
                                    }
                                    if (angular.isDefined(prime)) {
                                        fiscal.concepts.prime = prime;
                                    }
                                    if (angular.isDefined($filter("getFromObject")(calculations, "fiscalWorkedDays.value.result")) && angular.isDefined($filter("getFromObject")(calculations, "fiscalDailySalary.value.result"))) {
                                        var salaryObj = { name: 'SUELDO', total: $filter('currency')(calculations.fiscalSalary.value.result), conceptId: opObjs.conceptsById.fb[calculations.fiscalSalary.conceptId].id_human, qty: fiscal.employee.workedDays };
                                        fiscal.determination.perceptions.push(salaryObj);
                                    }
                                    var process = opObjs.process.fb;
                                    var deductions = [];
                                    for (var i = 0; i < process.length; i++) {
                                        if (process[i].id === 'real') {
                                            var allConcepts = angular.fromJson(angular.toJson(process[i].concepts));
                                            var incidences = process[i].incidences;
                                            var newOrder = [];
                                            for (var x = 0; x < allConcepts.length; x++) {
                                                var orderByConcept = incidences.find(function (value) {
                                                    return value.$id === allConcepts[x].$id;
                                                });
                                                if (orderByConcept) {
                                                    allConcepts[x].order = orderByConcept.order;
                                                } else {
                                                    allConcepts[x].order = allConcepts[x].order * 100;
                                                }
                                                newOrder.push(allConcepts[x]);
                                            }
                                            var concepts = $filter('orderBy')(newOrder || [], 'order');
                                            var conceptsFixedQty = { 'christmasBonus_settlement': 'bonusDaysF.result', 'holidays_settlement': 'holidaysF.result', 'holidaysPrime_settlement': 'holidaysF.result' };
                                            for (var c = 0; c < concepts.length; c++) {
                                                if (concepts[c].conceptType === 'incidenceType' && concepts[c].nature === 'perception') {
                                                    if (angular.isDefined($filter("getFromObject")(calculations[concepts[c].key], "fiscalValue.result")) && calculations[concepts[c].key].fiscalValue.result > 0) {
                                                        var objToPush = { name: concepts[c].name, total: $filter('currency')(calculations[concepts[c].key].fiscalValue.result), conceptId: opObjs.conceptsById.fb[concepts[c].$id].id_human }
                                                        $log.log('total incidencias', calculations[concepts[c].key].totalIncidences.result);
                                                        if (conceptsFixedQty.hasOwnProperty(concepts[c].key)) {
                                                            var thisQty = $filter("getFromObject")(calculations[concepts[c].key], conceptsFixedQty[concepts[c].key]);
                                                            if (angular.isNumber(thisQty)) {
                                                                objToPush.qty = thisQty;
                                                            }
                                                        } else if (calculations[concepts[c].key].fiscalValue.result !== calculations[concepts[c].key].totalIncidences.result && !concepts[c].hiddenField) {
                                                            objToPush.qty = calculations[concepts[c].key].totalIncidences.result
                                                        }
                                                        fiscal.determination.perceptions.push(objToPush);
                                                    }
                                                }
                                                if (concepts[c].conceptType === 'incidenceType' && concepts[c].nature === 'deduction') {
                                                    if (angular.isDefined($filter("getFromObject")(calculations[concepts[c].key], "fiscalValue.result")) && calculations[concepts[c].key].fiscalValue.result !== 0) {
                                                        deductions.push({ name: concepts[c].name, total: $filter('currency')(calculations[concepts[c].key].fiscalValue.result), conceptId: opObjs.conceptsById.fb[concepts[c].$id].id_human });
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    if (angular.isDefined($filter("getFromObject")(calculations.subsidy, "value.result")) && calculations.subsidy.value.result > 0) {
                                        fiscal.determination.perceptions.push({ name: 'SUBSIDIO', total: $filter('currency')(calculations.subsidy.value.result), conceptId: opObjs.conceptsById.fb[calculations.subsidy.conceptId].id_human });
                                    }
                                    if (angular.isDefined($filter("getFromObject")(calculations.isrAdjustment, "value.result")) && calculations.isrAdjustment.value.result > 0) {
                                        fiscal.determination.perceptions.push({ name: 'AJUSTE DE ISR', total: $filter('currency')(calculations.isrAdjustment.value.result), conceptId: opObjs.conceptsById.fb[calculations.isrAdjustment.conceptId].id_human });
                                    }
                                    if (angular.isDefined($filter("getFromObject")(calculations.fiscalPerceptions, "wSalary.result")) && calculations.fiscalPerceptions.wSalary.result > 0) {
                                        fiscal.determination.totals.totalPerceptions = { name: 'TOTAL PERCEPCIONES', total: $filter('currency')($filter("getFromObject")(calculations.fiscalPerceptions, "wSalary.result", 0)) };
                                    }

                                    if (angular.isDefined($filter("getFromObject")(calculations.isr, "value.result")) && calculations.isr.value.result > 0) {
                                        fiscal.determination.deductions.push({ name: 'ISR', total: $filter('currency')(calculations.isr.value.result), conceptId: opObjs.conceptsById.fb[calculations.isr.conceptId].id_human });
                                    }
                                    if (angular.isDefined($filter("getFromObject")(calculations.isrSettlement, "value.result")) && calculations.isrSettlement.value.result > 0) {
                                        fiscal.determination.deductions.push({ name: 'ISR LIQUIDACIÓN', total: $filter('currency')(calculations.isrSettlement.value.result), conceptId: opObjs.conceptsById.fb[calculations.isrSettlement.conceptId].id_human });
                                    }
                                    if (angular.isDefined($filter("getFromObject")(calculations.subsidyAdjustment, "value.result")) && calculations.subsidyAdjustment.value.result > 0) {
                                        fiscal.determination.deductions.push({ name: 'AJUSTE DE SUBSIDIO', total: $filter('currency')(calculations.subsidyAdjustment.value.result), conceptId: opObjs.conceptsById.fb[calculations.isrSettlement.conceptId].id_human });
                                    }
                                    if (angular.isDefined($filter("getFromObject")(calculations.socialSecurity, "value.result")) && calculations.socialSecurity.value.result > 0) {
                                        fiscal.determination.deductions.push({ name: 'SEGURIDAD SOCIAL', total: $filter('currency')(calculations.socialSecurity.value.result), conceptId: opObjs.conceptsById.fb[calculations.socialSecurity.conceptId].id_human });
                                    }
                                    fiscal.determination.deductions = fiscal.determination.deductions.concat(deductions);
                                    if (angular.isDefined($filter("getFromObject")(calculations.fiscalDeductions, "value.result")) && calculations.fiscalDeductions.value.result !== 0) {
                                        fiscal.determination.totals.totalDeductions = { name: 'TOTAL DEDUCCIONES', total: $filter('currency')($filter("getFromObject")(calculations.fiscalDeductions, "value.result", 0)) };
                                    }
                                    if (angular.isDefined($filter("getFromObject")(calculations, "fiscalTotal.value.result"))) {
                                        var numberToString = (calculations.fiscalTotal.value.result > 0) ? $filter('convertNumberToString')(calculations.fiscalTotal.value.result) : 'CERO PESOS 0/100 M.N';
                                        fiscal.determination.totals.totalAmount = $filter('currency')(calculations.fiscalTotal.value.result);
                                        fiscal.determination.totals.totalAmountString = 'RECIBÍ DE ' + fiscal.company.name + ' LA CANTIDAD DE ' + $filter('currency')(calculations.fiscalTotal.value.result) + ' PESOS.(' + numberToString + ')';
                                    }
                                    if (state) {
                                        var movement = $filter("getFromObject")(opObjs.operation.fb, "movement.date", "");
                                        fiscal.placeIssue = employee.place.name + ', ' + state.name + '. ' + moment(movement).format('DD') + ' DE ' + $filter('uppercase')(moment(movement).format('MMMM')) + ' DE ' + moment(movement).format('YYYY');
                                    } else {
                                        throw 'No se encontró el estado a la que pertenece la plaza de trabajo';
                                    }
                                    var params = {
                                        data: angular.toJson(fiscal)
                                    }
                                    downloadFile("interface/pdf/operations/settlements/fiscalReport", params).then(function () {
                                        var log = {
                                            operationType: 'settlement',
                                            operationId: opObjs.operation.fb.$id,
                                            created: $scope.D.getTimeObject(true, undefined, true),
                                            employeeId: employee.$id,
                                            isr: transformForMongo(calculations.isr || {}),
                                            gravableBase: transformForMongo(calculations.gravableBase || {}),
                                            mensualizationFactor: transformForMongo(calculations.mensualizationFactor || {}),
                                            subsidy: transformForMongo(calculations.subsidy || {})
                                        };
                                        return $scope.D.api.addWithUnique('reportsLogs', log, false)
                                    })
                                }).then(function () {
                                    $log.log('payment report inserted');
                                }).catch(function (error) {
                                    $log.error(error);
                                });
                            }).catch(function (error) {
                                $log.error(error);
                                errAlertS(error);
                            })
                        } else if (tabName === 'socialPrevision') {
                            var thisCalendar = $filter('getFromObject')(opObjs.operation.fb, 'calendar') ? '_' + opObjs.operation.fb.calendar : '';
                            var thisPeriod = $filter('getFromObject')(opObjs.operation.fb, 'period') ? '_' + $filter('zeroFill')(opObjs.operation.fb.period, 2) : '';
                            var thisCenter = AppF.center.toUpperCase();
                            var thisFileName = 'CARTA_' + response.data.name + "_" + thisCenter + thisCalendar + '_' + opObjs.payroll.fb.data.class + '_' + employee.data.name + thisPeriod + '_' + $filter("getFromObject")(employee.data, "employeeNumber", "00000")
                            var promises = []
                            promises.push(AppF.root.child('catalogs/ccs/collection/' + employee.cc + '/data/name').once('value'));
                            Promise.all(promises).then(function (resp) {
                                var prevision = {
                                    company: {
                                        name: response.data.businessName
                                    },
                                    employee: {
                                        numberEmployee: employee.data.employeeNumber,
                                        name: employee.data.name,
                                        rfc: employee.data.rfc,
                                        payroll: opObjs.payroll.fb.data.class + ' ' + opObjs.payroll.fb.data.name,
                                        ccs: resp[0].val()
                                    },
                                    deductions: {},
                                    totals: {},
                                    filename: thisFileName
                                }

                                var process = opObjs.process.fb;
                                for (var i = 0; i < process.length; i++) {
                                    if (process[i].id === 'socialPrevision') {
                                        var allConcepts = angular.fromJson(angular.toJson(process[i].concepts));
                                        var concepts = $filter('orderBy')(allConcepts || [], 'order');
                                        for (var c = 0; c < concepts.length; c++) {
                                            if (concepts[c].conceptType === 'incidenceType' && concepts[c].nature === 'deduction') {
                                                if (angular.isDefined($filter("getFromObject")(calculations[concepts[c].key], "socialPrevisionValue.result")) && calculations[concepts[c].key].socialPrevisionValue.result > 0) {
                                                    prevision.deductions[opObjs.conceptsById.fb[concepts[c].$id].id_human] = {
                                                        name: concepts[c].name,
                                                        total: $filter('currency')(calculations[concepts[c].key].socialPrevisionValue.result)
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                                prevision.employee.paymentMethod = bankObj.paymentMethod;
                                if (angular.isDefined(bankObj.numberAccount) && angular.isDefined(bank)) {
                                    prevision.employee.numberAccount = bankObj.numberAccount;
                                    prevision.employee.bankName = bank.name;
                                }
                                prevision.totals = {
                                    socialPrevision: $filter('currency')($filter("getFromObject")(calculations.socialPrevisionPerceptions, "value.result", 0)),
                                    totalAmount: $filter('currency')($filter("getFromObject")(calculations.socialPrevisionTotal, "value.result", 0)),
                                    totalAmountString: 'RECIBÍ DE ' + prevision.company.name + ' LA CANTIDAD DE ' + $filter('currency')(calculations.socialPrevisionTotal.value.result) + ' PESOS.(' + $filter('convertNumberToString')(calculations.socialPrevisionTotal.value.result) + ')'
                                }
                                if (state) {
                                    var movement = $filter("getFromObject")(opObjs.operation.fb, "movement.date", "");
                                    prevision.placeIssue = employee.place.name + ', ' + state.name + '. ' + moment(movement).format('DD') + ' DE ' + $filter('uppercase')(moment(movement).format('MMMM')) + ' DE ' + moment(movement).format('YYYY');
                                } else {
                                    throw 'No se encontró el estado a la que pertenece la plaza de trabajo';
                                }
                                var params = {
                                    data: angular.toJson(prevision)
                                }
                                downloadFile("interface/pdf/operations/settlements/previsionReport", params);

                            })
                        }
                    } else {
                        errAlertS(response.message);
                    }
                });
            } catch (error) {
                errAlertS(error);
            }
        }
        function transformForMongo(obj) {
            var thisObj = {};
            if (typeof (obj) === 'object' && obj !== null) {
                $filter('loopEach')(obj, function (data, key) {
                    if (typeof (data) === 'object' && data !== null) {
                        if (data.hasOwnProperty('result')) {
                            thisObj[key] = data.result
                        }
                    } else if (['string', 'number'].indexOf(typeof (data)) > -1) {
                        thisObj[key] = data
                    }
                })
            }
            return thisObj;
        }
        $scope.downloadBill = function (selected) {
            if (angular.isArray(selected) && selected.length > 0) {
                for (var e = 0; e < selected.length; e++) {
                    var billId = $filter('getFromObject')($scope.operation.employees, selected[e].$id + ".billId");
                    if (angular.isUndefined(billId)) {
                        errAlertS('El empleado ' + allEmployeesO[selected[e].$id].data.name + ' no tiene el recibo');
                    } else {
                        $rootScope.D.api.get("one/bills/", { "uuid": billId, project: angular.toJson({ "Comprobante.Total": 1 }) }).then(function (resp) {
                            var bill = resp.data;
                            if (bill.success && bill.data.length > 0 && bill.data[0]['Comprobante']) {
                                var amount = bill.data[0]['Comprobante']['Total'];
                                var total = $filter('convertNumberToString')(amount);
                                var params = {
                                    total: total,
                                    billId: bill.data[0]._id
                                }
                                downloadFile("interface/pdf/operation/invoice", params);
                            } else {
                                errAlertS("No se encontró datos de la factura");
                            }
                        }).catch(function (error) {
                            errAlertS(error);
                        })
                    }
                }
            } else {
                errAlertS("No se selecciono ningún empleado")
            }
        }
        $scope.exportReportPayroll = function () {
            var conceptsById = opObjs.conceptsById.fb;
            var calc = $scope.calculations;
            var headers = [];
            var employees = {};
            var valueObjs = {
                'real': ['value', 'rejectedIncidences', 'valueNoRejected'],
                'fiscal': ['fiscalValue', 'fiscalValueRejected', 'fiscalValueNoRejected'],
                'socialPrevision': ['socialPrevisionValue', 'socialPrevisionValueRejected', 'socialPrevisionValueNoRejected']
            };
            var headersField = {
                rejectedIncidences: 'valueRejected'
            }
            var totalObj = {};
            var totalAmountObj = {};
            var process = $scope.process.filter(function (item) {
                return ['rejectedIncidences'].indexOf(item.id) === -1;
            }).map(function (item) {
                return angular.copy(item);
            });
            var uniqueP = process.filter(function (item) {
                return ['real'].indexOf(item.id) === -1;
            });
            if (uniqueP.length === 1 && uniqueP[0].id === 'fiscal') {
                process = uniqueP;
            }
            process.forEach(function (thisProcess) {
                if (!totalObj[thisProcess.id]) {
                    totalObj[thisProcess.id] = {};
                    totalAmountObj[thisProcess.id] = { totals: [] };
                }
                if (angular.isArray(thisProcess.totals) && thisProcess.totals.length > 0) {
                    var totals = $filter('orderBy')(thisProcess.totals, 'order');
                    totals.forEach(function (total) {
                        if ($scope.operationTotals.hasOwnProperty(total.$id)) {
                            var operation = total.operation ? total.operation + 1 : 1;
                            totalAmountObj[thisProcess.id]['totals'].push({ name: total.name, total: $scope.operationTotals[total.$id][total.field] * operation });
                        } else {
                            totalAmountObj[thisProcess.id]['totals'].push({ name: total.name });
                        }
                    });
                }
                if (angular.isArray(thisProcess.concepts)) {
                    if (angular.isArray(thisProcess.extras)) {
                        thisProcess.extras.forEach(function (extra) {
                            extra.order = extra.order * 100;
                        });
                        thisProcess.concepts = thisProcess.concepts.concat(thisProcess.extras);
                    }
                    var thisProConcepts = thisProcess.concepts.filter(function (item) {
                        return item.$id && (!item.hiddenColumn || item.showOnReport);
                    });
                    if (thisProConcepts.length > 0) {
                        thisProConcepts.sort(function (a, b) {
                            return a.order - b.order;
                        })
                        var newConcepts = [
                            { name: "NO.", key: "number", order: -5 },
                            { name: "NOMBRE", key: "name", order: -3 },
                            { name: "CC", key: "cc", order: -2 },
                            { name: "PLAZA", key: "place", order: -1.8 },
                            { name: "DEPARTAMENTO", key: "department", order: -1.7 },
                            { name: "PUESTO", key: "position", order: -1.5 }
                        ];
                        if (thisProcess.id !== 'socialPrevision') {
                            newConcepts.splice(1, 0, { name: "NSS", key: "nss", order: -4 });
                        }
                        var procConcepts = {};
                        var payrollWithSubtotals = false;
                        var newOrder = payrollWithSubtotals ? ['data.cc'].concat($scope.order) : $scope.order;
                        var employeesSort = $filter('orderBy')(operationEmployeesF, newOrder);
                        var subtotals = {};
                        var lastEmployeeIndex = undefined;
                        var hasAnyDepartment = false;
                        employeesSort.forEach(function (employeeSort, es) {
                            var employeeId = employeeSort.$id;
                            var employee = allEmployeesO[employeeId];
                            var employeeCalculation = calc[employee.$id] || {};
                            if (angular.isString(employee.departmentName)) {
                                hasAnyDepartment = true;
                            }
                            if (thisProcess.id !== "fiscal" || employee.isFiscal) {
                                if (!employees[employeeId]) {
                                    employees[employeeId] = {
                                        number: $filter("getFromObject")(employee, "data.employeeNumber", "N/A"),
                                        nss: employee.data.nss || '',
                                        name: employee.data.name,
                                        cc: employee.ccData.data.name,
                                        place: $filter("getFromObject")(employee, "ccPlace.name", "Sin plaza"),
                                        position: employee.positionData.name,
                                        department: employee.departmentName || 'Sin departamento',
                                        order: es,
                                        c: {}
                                    };
                                    if (employee.isFiscal) {
                                        employees[employeeId].isFiscal = true;
                                    }
                                }
                                thisProConcepts.forEach(function (concept, t) {
                                    var thisConcept = conceptsById[concept.$id] || concept;
                                    var name = concept.name || thisConcept.name;
                                    if (!procConcepts[name]) {
                                        procConcepts[name] = true;
                                        newConcepts.push({ name: name, order: t, key: thisProcess.id });
                                    }
                                    var total;
                                    if (thisConcept.key === 'perceptions' || thisConcept.key === 'fiscalPerceptions') {
                                        total = $filter('getFromObject')(employeeCalculation[thisConcept.key], 'wSalary.result');
                                        if (!totalObj[thisProcess.id][name]) {
                                            totalObj[thisProcess.id][name] = $filter('getFromObject')($scope.operationTotals[concept.$id], 'wSalary', 0);
                                        }
                                    } else {
                                        var valuesFields = thisConcept.type === 'incidenceType' ? valueObjs[thisProcess.id] : valueObjs.real;
                                        var rejectedName = name + ' RECHAZADO';
                                        if (!totalObj[thisProcess.id][name]) {
                                            if (thisConcept.showTotal) {
                                                var rejectedField = headersField[valuesFields[1]] || valuesFields[1];
                                                var rejectedT = thisConcept.nature === 'deduction' ? $filter('getFromObject')($scope.operationTotals[concept.$id], rejectedField, 0) : 0;
                                                if (thisConcept.nature === 'deduction' && rejectedT > 0) {
                                                    var noRejectedT = $filter('getFromObject')($scope.operationTotals[concept.$id], valuesFields[2], 0);
                                                    totalObj[thisProcess.id][rejectedName] = rejectedT;
                                                    totalObj[thisProcess.id][name] = noRejectedT;
                                                } else {
                                                    totalObj[thisProcess.id][name] = $filter('getFromObject')($scope.operationTotals[concept.$id], valuesFields[0], 0);
                                                }
                                            } else {
                                                totalObj[thisProcess.id][name] = "#isEmpty";
                                            }
                                        }
                                        var rejected = $filter('getFromObject')(employeeCalculation[thisConcept.key], valuesFields[1] + '.result', 0);
                                        if (rejected > 0) {
                                            total = $filter('getFromObject')(employeeCalculation[thisConcept.key], valuesFields[2] + '.result');
                                            if (!procConcepts[rejectedName]) {
                                                procConcepts[rejectedName] = true;
                                                newConcepts.push({ name: rejectedName, order: t - 0.5, key: thisProcess.id + "Rejected" });
                                            }
                                            if (!employees[employeeId].c[rejectedName]) {
                                                employees[employeeId].c[rejectedName] = {};
                                            }
                                            // if (rejected > total) {
                                            //     rejected = total;
                                            // }
                                            employees[employeeId].c[rejectedName][thisProcess.id + "Rejected"] = rejected;
                                        } else {
                                            total = $filter('getFromObject')(employeeCalculation[thisConcept.key], valuesFields[0] + '.result');
                                        }
                                    }
                                    if (angular.isDefined(total)) {
                                        employees[employeeId].c[name] = employees[employeeId].c[name] || {};
                                        employees[employeeId].c[name][thisProcess.id] = total;
                                        if (payrollWithSubtotals && thisConcept.showTotal) {
                                            subtotals[employeeSort.data.cc] = subtotals[employeeSort.data.cc] || {};
                                            subtotals[employeeSort.data.cc][name] = subtotals[employeeSort.data.cc][name] || 0;
                                            subtotals[employeeSort.data.cc][name] = subtotals[employeeSort.data.cc][name] + total;
                                        }
                                    }
                                    if (payrollWithSubtotals) {
                                        var previousEmployeeCc = angular.isDefined(lastEmployeeIndex) ? employeesSort[lastEmployeeIndex].data.cc : undefined;
                                        if (angular.isDefined(previousEmployeeCc) && previousEmployeeCc !== employeeSort.data.cc) {
                                            var isFiscal1 = allEmployeesO[employeesSort[lastEmployeeIndex].$id].rpData.data.name !== '00000000000' ? true : false;
                                            employees[previousEmployeeCc] = employees[previousEmployeeCc] || {
                                                order: es - .5,
                                                name: "#isSubtotal#SUBTOTAL " + allEmployeesO[employeesSort[lastEmployeeIndex].$id].ccData.data.name,
                                                number: "#isNull",
                                                nss: "#isNull",
                                                cc: '#isNull',
                                                isFiscal: isFiscal1,
                                                position: '#isNull',
                                                place: '#isNull',
                                                department: '#isNull',
                                                c: {}
                                            }
                                            employees[previousEmployeeCc].c[name] = employees[previousEmployeeCc].c[name] || {};
                                            employees[previousEmployeeCc].c[name][thisProcess.id] = $filter("getFromObject")(subtotals, previousEmployeeCc + "." + name, thisConcept.showTotal ? 0 : "#isEmpty");
                                        }
                                        if ((employeesSort.length - 1) === es) {
                                            var isFiscal2 = allEmployeesO[employeeSort.$id].rpData.data.name !== '00000000000' ? true : false;
                                            employees[employee.cc] = employees[employee.cc] || {
                                                order: es + .5,
                                                name: "#isSubtotal#SUBTOTAL " + employee.ccData.data.name,
                                                number: "#isNull",
                                                nss: "#isNull",
                                                cc: '#isNull',
                                                isFiscal: isFiscal2,
                                                position: '#isNull',
                                                place: '#isNull',
                                                department: '#isNull',
                                                c: {}
                                            };
                                            employees[employee.cc].c[name] = employees[employee.cc].c[name] || {};
                                            employees[employee.cc].c[name][thisProcess.id] = $filter("getFromObject")(subtotals, employee.cc + "." + name, thisConcept.showTotal ? 0 : "#isEmpty");
                                        }
                                    }
                                });
                                lastEmployeeIndex = es;
                            }
                        });
                        if (!hasAnyDepartment) {
                            var indexDepartment = newConcepts.findIndex(function (item) {
                                return item.key === 'department';
                            })
                            if (indexDepartment > -1) {
                                newConcepts.splice(indexDepartment, 1)
                            }
                        }
                        if (totalObj[thisProcess.id]) {
                            Object.keys(totalObj[thisProcess.id]).forEach(function (tt) {
                                var index = newConcepts.findIndex(function (value) {
                                    return value.name === tt;
                                });
                                if (index > -1 && angular.isDefined(totalObj[thisProcess.id][tt])) {
                                    if (angular.isArray(totalObj[thisProcess.id][tt])) {
                                        if (totalObj[thisProcess.id][tt].length > 0) {
                                            newConcepts[index].totalBill = totalObj[thisProcess.id][tt];
                                        }
                                    } else {
                                        newConcepts[index].totalAmount = totalObj[thisProcess.id][tt];
                                    }
                                }
                            });
                        }
                        newConcepts.sort(function (a, b) {
                            return a.order - b.order;
                        });
                        var objH = { name: thisProcess.name, key: thisProcess.id, concepts: newConcepts };
                        if (thisProcess.alias) {
                            objH.alias = thisProcess.alias;
                        }
                        if (totalAmountObj[thisProcess.id]['totals'].length > 0) {
                            objH.totals = totalAmountObj[thisProcess.id]['totals'];
                        }
                        headers.push(objH);
                    }
                }
            });
            var promises = [];
            var processId = [];
            headers.forEach(function (header) {
                if (['fiscal', 'socialPrevision'].indexOf(header.key) > -1) {
                    promises.push($filter('getCompaniesName')($scope.payrollId, header.name));
                    processId.push(header.name);
                }
            });

            Promise.all(promises).then(function (response) {
                if (response.length > 0) {
                    response.forEach(function (businessName, r) {
                        if (businessName.data) {
                            var indexH = headers.findIndex(function (value) {
                                return value.name === processId[r];
                            });
                            if (indexH > -1) {
                                headers[indexH].companiesRecord = businessName.data.businessName;
                            }
                        } else {
                            throw businessName.message;
                        }
                    });
                    var employeesTemp = Object.keys(employees).sort(function (a, b) {
                        return employees[a].order - employees[b].order;
                    }).map(function (item) {
                        return employees[item];
                    });
                    employees = employeesTemp;
                    var thisCalendar = $filter('getFromObject')(opObjs.operation.fb, 'calendar') ? '_' + opObjs.operation.fb.calendar : '';
                    var thisPeriod = $filter('getFromObject')(opObjs.operation.fb, 'period') ? '_' + $filter('zeroFill')(opObjs.operation.fb.period, 2) : '';
                    var thisCenter = AppF.center.toUpperCase();
                    var thisFileName = 'TOT_' + thisCenter + thisCalendar + '_' + opObjs.payroll.fb.data.class + '_' + opObjs.payroll.fb.data.name + thisPeriod;

                    var dataObj = {
                        info: {
                            payroll: opObjs.payroll.fb.data.class + ' ' + opObjs.payroll.fb.data.name + ' [' + $filter('getSomethingOfArrayM')(opObjs.payroll.fb.paymentFrequency, $scope.M.paymentFrequenciesRecords, 'name') + ']',
                            date: 'Incidencias del ' + $filter('date')(opObjs.period.fb.start, AppF.dateFormat) + ' al ' + $filter('date')(opObjs.period.fb.end, AppF.dateFormat),
                            period: 'Periodo ' + ($filter("getFromObject")(opObjs.operation.fb, "period") ? (opObjs.operation.fb.period > 9 ? opObjs.operation.fb.period : "0" + opObjs.operation.fb.period) : '')
                        },
                        footer: angular.toJson([{}, {}, {}, {}, { "NOMBRE": '#stylefooterstyle#LIC. ' + $filter('uppercased')(AppF.profile.data.name) }, { "NOMBRE": "#stylefooterstyle#EJECUTIVO DE CUENTAS" }]),
                        headers: angular.toJson(headers),
                        data: angular.toJson(employees),
                        filename: thisFileName
                    };
                    downloadFile("interface/exportDataWithMultiHeader", dataObj);
                } else {
                    throw "No se encontró ningún proceso";
                }
            }).catch(function (error) {
                errAlertS(error);
            });
        };
        $scope.downloadZipBill = function (selected) {
            $rootScope.loadingProgress = true;
            if (selected.length == 0) {
                selected = $scope.fiscalEmployees;
            }
            var totalPromises = [];
            var billsData = [];
            for (var e = 0; e < selected.length; e++) {
                var billUid = $filter('getFromObject')($scope.operation.employees, selected[e].$id + ".billId");
                if (angular.isUndefined(billUid)) {
                    errAlertS('El empleado ' + allEmployeesO[selected[e].$id].data.name + ' no tiene el recibo');
                } else {
                    billsData.push({
                        employeeId: selected[e].$id,
                        bucketUrl: $filter('getFromObject')($scope.operation.employees, selected[e].$id + ".xmlUrl"),
                        fileName: $filter('getFromObject')($scope.operation.employees, selected[e].$id + ".fileName")
                    });
                    totalPromises.push($rootScope.D.api.get("one/bills/", { "uuid": billUid, project: angular.toJson({ "Comprobante.Total": 1 }) }));
                }
            }
            var decodeError = false;
            Promise.all(totalPromises).then(function (totalsResp) {
                var requestPromises = [];
                for (var t = 0; t < totalsResp.length; t++) {
                    billsData[t].total = $filter('convertNumberToString')(totalsResp[t].data.data[0]['Comprobante']['Total']);
                    billsData[t].billId = totalsResp[t].data.data[0]._id;
                    requestPromises.push($http({ method: 'POST', url: $window.__env.serviceWorkerUrl + 'models/bill/getBillZip', responseType: 'arraybuffer', data: billsData[t] }))
                }
                decodeError = true;
                return Promise.all(requestPromises);
            }).then(function (responses) {
                decodeError = false;
                for (var r = 0; r < responses.length; r++) {
                    var response = responses[r];
                    var headers = response.headers();
                    var filename = headers['x-filename'];
                    var contentType = headers['content-type'];
                    var linkElement = document.createElement('a');
                    try {
                        var blob = new Blob([response.data], {
                            type: contentType
                        });
                        var url = $window.URL.createObjectURL(blob);
                        linkElement.setAttribute('href', url);
                        linkElement.setAttribute("download", filename);
                        var clickEvent = new MouseEvent("click", {
                            "view": window,
                            "bubbles": true,
                            "cancelable": false
                        });
                        linkElement.dispatchEvent(clickEvent);
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync(function () {
                            $log.debug('generatePdf finished');
                        });
                    } catch (ex) {
                        $log.error(ex, "error descargando el archivo");
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync();
                    }
                }
            }).catch(function (error) {
                $log.error(error);
                if (decodeError) {
                    var message = new TextDecoder("utf-8").decode(error.data);
                    error = angular.fromJson(message).data;
                }
                errAlertS(error);
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
            })
        }
        function downloadFile(path, params, useV2Api) {
            return new Promise(function (resolve, reject) {
                $rootScope.loadingProgress = true;
                var urlDefault = window.__env.serviceWorkerUrl;
                if (useV2Api) {
                    urlDefault = $window.location.protocol + '//' + apiv2[window.__env.mode] + '/';
                }
                $http({
                    method: 'POST',
                    url: urlDefault + path,
                    responseType: 'arraybuffer',
                    data: params
                }).then(function (response) {
                    var headers = response.headers();
                    var filename = headers['x-filename'];
                    var contentType = headers['content-type'];
                    var linkElement = document.createElement('a');
                    try {
                        var blob = new Blob([response.data], {
                            type: contentType
                        });
                        var url = window.URL.createObjectURL(blob);
                        linkElement.setAttribute('href', url);
                        linkElement.setAttribute("download", filename);
                        var clickEvent = new MouseEvent("click", {
                            "view": window,
                            "bubbles": true,
                            "cancelable": false
                        });
                        linkElement.dispatchEvent(clickEvent);
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync(function () {
                            $log.debug('generatePdf finished');
                            resolve(true);
                        });
                    } catch (ex) {
                        $log.error(ex, "error descargando el archivo");
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync();
                        reject(true);
                    }
                }).catch(function (err) {
                    var message = new TextDecoder("utf-8").decode(err.data);
                    var error = angular.fromJson(message);
                    errAlertS(error.data);
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                    reject(true);
                });
            })
        }
        $scope.confirmSendEmail = function (ev, selected, process) {
            if (process === 'fiscal') {
                var uuids = [];
                var errors = [];
                for (var e = 0; e < selected.data.length; e++) {
                    var status = $filter('getFromObject')($scope.operation.employees, selected.data[e].$id + ".status");
                    var billUid = $filter('getFromObject')($scope.operation.employees, selected.data[e].$id + ".billId");
                    if (angular.isUndefined(billUid) && status === 5) {
                        errors.push('El empleado ' + allEmployeesO[selected.data[e].$id].data.name + ' no tiene el recibo');
                    } else if (status === 5) {
                        uuids.push({ uuid: billUid });
                    }
                }
                if (uuids.length === 0) {
                    errors.unshift('No se encontró ningún dato para enviar');
                    errAlertS(errors);
                    return false;
                }
                selected = uuids;
            }
            var cParams = {
                dispersionId: opObjs.operation.fb.dispersion,
                operationId: opObjs.operation.fb.$id,
                operationType: 'settlement',
                period: $filter('zeroFill')(opObjs.operation.fb.period, 2),
                calendar: opObjs.operation.fb.calendar
            }
            $filter('sendBillsEmail')(selected, process, undefined, ev, cParams, undefined)
        }
        function turnOffWatchers(all) {
            for (var watcherKey in watchers) {
                if (watchers.hasOwnProperty(watcherKey)) {
                    if (angular.isFunction(watchers[watcherKey]) && (all || (!all && watcherKey !== 'onDestroy'))) {
                        watchers[watcherKey]();
                        delete watchers[watcherKey];
                    }
                }
            }
        }
        watchers.onDestroy = $scope.$on('$destroy', function () {
            turnOffWatchers(true);
        });
        startAfterInitFilter($scope, {}, initiated, init);

    }
})();
/* eslint-disable angular/json-functions */
/* eslint-disable angular/document-service */
/* eslint-disable angular/window-service */
/* eslint-disable angular/timeout-service */
(function () {
    'use strict';

    angular
        .module('app.clients')
        .controller('Operation2NDController', Operation2NDController);

    function Operation2NDController(
        ApiV3F,
        $scope,
        $rootScope,
        $state,
        $log,
        $q,
        errAlertS,
        AppF,
        $filter,
        $mdBottomSheet,
        $mdDialog,
        ListsF,
        DataF,
        CatalogsF,
        $timeout,
        successAlertS,
        $http,
        confirmConfig,
        $window,
        $document,
        startAfterInitFilter,
        confirmOperationS,
        billOperationS,
        apiv2,
        infoAlertS,
        BankLayoutFlow
    ) {
        // si necesitas cargar catálogos de mongo pon sus nombres aquí
        var dataNeeded = ['subsidyRecords', 'cyvRecords', 'isrRecords', 'bankAccounts', 'paymentForms', 'banks', 'imssRecords', 'paymentFrequenciesRecords', 'directives', 'nfdRecords', 'placesOfWorkRecords', 'geoZones', 'states']; // ex: ['countries', 'states', 'regimes']
        var initiated = false;
        var $f = $filter;
        var watchers = {};
        var savingFastIncidences = {};
        var rejectIncidencesByEmployee = {};
        var processIncidencesByEmployee = {};
        var processIncidences = {};
        var firstIgnored = {};
        var dataUsedToCalc = {};
        var allEmployeesO = {};
        var opObjs = {};
        var incidenceTypeForPenDays;
        $scope.myPageOperation = 1;
        $scope.myPageFiscal = 1;
        $scope.myLimitOperation = 50;
        $scope.myLimitFiscal = 50;

        $scope.actionMessages = 'Iniciando..';
        $scope.operationProgress = 0;
        $scope.search = {};
        $scope.calculations = {};
        $scope.operationEmployeesFiltered = [];
        var operationEmployeesF = [];
        $scope.fastIncidences = {};
        $scope.rejectedIncidences = [];
        $scope.fiscalEmployeesFiltered = [];
        var fiscalEmployeesF = [];
        $scope.paginationOpe = [50];
        $scope.paginationFis = [50];
        $scope.selected = [];
        $scope.operationData = {};
        $scope.opStatusNotCalc = 3;
        $scope.order = ['data.enroleDate', 'data.name'];
        $scope.showProgress = true;
        $scope.employeesStatusByOp = {
            '1': {
                nextStatus: [1, 2, 3],
                status: 0
            },
            '2': {
                nextStatus: [2, 3],
                status: 1
            },
            '2.5': {
                nextStatus: [3],
                status: 2
            }
        };
        AppF.opstatusByEmployeeStatus = {
            '3': 3,
            '2': 2.5,
            '1': 2
        };
        AppF.notCalculate = false;
        AppF.calculationOfEmployee = {};
        AppF.operationData = {};
        var actionsQueue = [];
        $scope.executing = false;
        $scope.closeOperation = true;
        var lastIncidencesClosedCount = 0;
        var queryLastIncidencesClosedDone = false;
        function waitForAppliedIncidencesToLoad() {
            return new Promise(function (resolve, reject) {
                var params = {
                    query: angular.toJson([
                        { $match: { period: parseInt($scope.periodId), status: { $gte: 3 }, payroll: $scope.payrollId, calendar: parseInt($scope.calendarId), operationType: { $exists: false } } },
                        { $group: { _id: null, totalIncidences: { $sum: 1 } } }
                    ])
                };
                DataF.api.post('aggregate/incidences', params).then(function (resp) {
                    var thisCount = resp.data.length > 0 && resp.data[0].totalIncidences ? resp.data[0].totalIncidences : 0;
                    $log.log("🚀 ~ thisCount:" + thisCount + ", lastIncidencesClosedCount:" + lastIncidencesClosedCount);
                    if (thisCount === lastIncidencesClosedCount) {
                        if (queryLastIncidencesClosedDone) {
                            resolve(true)
                        } else {
                            var incQueriesApplied = {
                                period: 'parseNumber' + $scope.periodId,
                                status: angular.toJson({ $gte: 3 }),
                                payroll: $scope.payrollId,
                                calendar: 'parseNumber' + $scope.calendarId,
                                operationType: { $exists: false }
                            };
                            DataF.api.get('incidences', incQueriesApplied).then(function (resp) {
                                opObjs.appliedIncidences = { fb: resp.data };
                                resolve(true)
                            }).catch(reject);
                        }
                    } else {
                        lastIncidencesClosedCount = thisCount;
                        queryLastIncidencesClosedDone = false;
                        $timeout(function () {
                            resolve(waitForAppliedIncidencesToLoad())
                        }, 10000)
                    }
                }).catch(reject);

            });

        }
        //INICIO DE LAS FUNCIONES
        function executeAction() {
            if (!$scope.executing && actionsQueue.length > 0) {
                $scope.executing = true;
                $scope.$evalAsync()
                var promise;
                var action = actionsQueue[0][0];
                var fbData = actionsQueue[0][1];
                var executeCalculation = actionsQueue[0][2];
                var actionsParams;
                if (actionsQueue[0].length > 3) {
                    actionsParams = actionsQueue[0][3]
                }
                var initTime = new Date().valueOf();
                $log.debug('Iniciando ' + action);
                try {
                    switch (action) {
                        case 'setVariablesOfOperation':
                            $scope.actionMessages = 'Estableciendo permisos de operación..';
                            setOperationVariables();
                            break;
                        case 'checkActionForThisOperation':
                            $scope.actionMessages = 'Escuchando cambios..';
                            var employeeId;
                            if (fbData.catalog === 'credits' && $scope.payrollId === fbData.data.payroll) {
                                employeeId = fbData.data.employee;
                                if (fbData.action === 'delete') {
                                    allEmployeesO[employeeId].creditData = undefined;
                                } else {
                                    allEmployeesO[employeeId].creditData = angular.fromJson(angular.toJson(fbData.data));
                                }
                            }
                            if (fbData.catalog === 'employees' && $scope.payrollId === fbData.data.payroll) {
                                employeeId = fbData.id;
                                opObjs.employees.fb[employeeId] = fbData.data;
                                opObjs.employees.fb[employeeId].$id = employeeId;
                                promise = addForAction('loadEmployees');
                            }
                            if (fbData.catalog === 'movements') {
                                var movement = fbData.data;
                                movement.$id = fbData.id;
                                validateMovement(movement, fbData.action);
                            }
                            break;
                        case 'setConceptsMap':
                            $scope.actionMessages = 'Generando conceptos..';
                            $f('setInObjectPath')('conceptsById.fb', opObjs, $filter('keyObjectAsKey')(opObjs.concepts.fb, '$id', undefined, 'order'), true, true);
                            var allConcepts = $filter('keyObjectAsKey')(opObjs.concepts.fb, 'key');
                            allConcepts = Object.assign(allConcepts, $filter('keyObjectAsKey')(opObjs.concepts.fb.filter(function (item) { return item.payroll === $scope.payrollId; }), 'key'));
                            $f('setInObjectPath')('conceptsByKey.fb', opObjs, allConcepts, true, true);
                            break;
                        case 'setPayrollOfEmployees':
                            $scope.actionMessages = 'Estableciendo datos de empleado..';
                            $f('loopEach')(allEmployeesO, function (employee, employeeId) {
                                if (employee.payroll === opObjs.payroll.fb.$id) {
                                    allEmployeesO[employeeId].payrollData = $f('clearObject')(opObjs.payroll.fb);
                                }
                            });
                            break;
                        case 'setThisBankAccounts':
                            $scope.actionMessages = 'Creando cuentas para este banco..';
                            $scope.thisBankAccounts = $filter('setThisBankAccounts')(opObjs.payroll.fb);
                            break;
                        case 'setOperationCcs':
                            $scope.actionMessages = 'Obteniendo centros de costo..';
                            $f('setInObjectPath')('employeesCcs.fb', opObjs, $f('filter')(opObjs.myCcs.fb, { payroll: $scope.payrollId }), true, true);
                            promise = new Promise(function (resolver, rejecter) {
                                $scope.employeesCcs = [];
                                var employeesCcs = [];
                                if (operationEmployeesF.length > 0) {
                                    var ccs = opObjs.employeesCcs.fb;
                                    for (var c = 0; c < ccs.length; c++) {
                                        for (var e = 0; e < operationEmployeesF.length; e++) {
                                            var filterCcs = operationEmployeesF[e].movements.filter(function (value) {
                                                return value.cc === ccs[c].$id
                                            });
                                            if (filterCcs.length > 0) {
                                                var exist = employeesCcs.filter(function (value) {
                                                    return value.$id === ccs[c].$id;
                                                });
                                                if (exist.length === 0) employeesCcs.push(ccs[c]);
                                            }
                                        }
                                    }
                                }
                                var rpsConsulted = {};
                                for (var ecc = 0; ecc < employeesCcs.length; ecc++) {
                                    if (employeesCcs[ecc].hasOwnProperty('rp_id') && employeesCcs[ecc].rp_id && !rpsConsulted.hasOwnProperty(employeesCcs[ecc].rp_id)) {
                                        rpsConsulted[employeesCcs[ecc].rp_id] = AppF.root.child('catalogs/rps/collection/' + employeesCcs[ecc].rp_id + '/data/shortName').once('value');
                                    }
                                }
                                var thisPromise = Object.keys(rpsConsulted).length > 0 ? $q.all(rpsConsulted) : Promise.all([])
                                thisPromise.then(function (rpNames) {
                                    for (var ecc = 0; ecc < employeesCcs.length; ecc++) {
                                        if (employeesCcs[ecc].hasOwnProperty('rp_id') && employeesCcs[ecc].rp_id) {
                                            employeesCcs[ecc].rpName = rpNames[employeesCcs[ecc].rp_id] && rpNames[employeesCcs[ecc].rp_id].val() ? rpNames[employeesCcs[ecc].rp_id].val() : '';
                                        }
                                    }
                                    $scope.employeesCcs = employeesCcs;
                                    resolver(true);
                                }).catch(rejecter);
                            })
                            break;
                        case 'setDispersion':
                            $scope.actionMessages = 'Leyendo información de la dispersion si existe..';
                            $f('setInObjectPath')('dispersion.fb', opObjs, $f('transformCalculations')(opObjs.dispersionF.fb), true, true);
                            break;
                        case 'setLastDispersion':
                            $scope.actionMessages = 'Leyendo información de la dispersion si existe..';
                            $f('setInObjectPath')('lastDispersion.fb', opObjs, $f('transformCalculations')(opObjs.lastDispersionF.fb), true, true);
                            break;
                        case 'setProccess':
                            $scope.actionMessages = 'Obteniendo esquema..';
                            $f('setInObjectPath')('processFromPayroll.fb', opObjs, $f('getProcessOfPayroll')(opObjs.paymentSchema.fb, opObjs.dispersion.fb, opObjs.operation.fb.status >= $scope.opStatusNotCalc, opObjs.payroll.fb, opObjs.isLastOperation.fb, opObjs.concepts.fb), true, true);
                            break;
                        case 'setIncidencesOfEmployees':
                            $scope.actionMessages = 'Consultando incidencias..';
                            promise = new Promise(function (resolve, reject) {
                                $scope.actionMessages = 'Actualizando datos..';
                                waitForAppliedIncidencesToLoad().then(function () {
                                    $scope.actionMessages = 'Generando sabana..';
                                    var otherIncidences = [
                                        $f('getFromObject')(opObjs, 'creditIncidences.fb', []),
                                        $f('getFromObject')(opObjs, 'constantsIncidences.fb', [])
                                    ];
                                    $f('setInObjectPath')('opIncidences.fb', opObjs, $f('getIncidencesOfOperation')(opObjs.incidences.fb, opObjs.appliedIncidences.fb, $scope.periodId, otherIncidences, allEmployeesO, opObjs.operation.fb.status >= $scope.opStatusNotCalc, opObjs.conceptsById.fb, opObjs.paymentSchema.fb, opObjs.operation.fb.employees, $scope.payrollId), true, true);
                                    $f('setInObjectPath')('incidencesByEmployee.fb', opObjs, $f('groupByField')(opObjs.opIncidences.fb, 'employee', false, 'data.date'), true, true);
                                    $f('setInObjectPath')('process.fb', opObjs, $f('getProcessForOperation')(opObjs.processFromPayroll.fb, opObjs.opIncidences.fb, opObjs.conceptsById.fb, processIncidences, operationEmployeesF, opObjs.dispersion.fb, opObjs.operation.fb.status >= 3), true, true);
                                    $scope.process = opObjs.process.fb;
                                    if (angular.isArray(operationEmployeesF)) {
                                        for (var o = 0; o < operationEmployeesF.length; o++) {
                                            var employee = operationEmployeesF[o];
                                            var thisEmployeeId = employee.$id;
                                            allEmployeesO[thisEmployeeId].incidences = opObjs.incidencesByEmployee.fb[thisEmployeeId];
                                            allEmployeesO[thisEmployeeId].incidencesByType = $filter('groupByField')(opObjs.incidencesByEmployee.fb[thisEmployeeId], 'incidenceType', false, 'data.date');
                                            if (angular.isDefined(incidenceTypeForPenDays)) {
                                                if (allEmployeesO[thisEmployeeId].incidencesByType.hasOwnProperty(incidenceTypeForPenDays.$id)) {
                                                    allEmployeesO[thisEmployeeId].pendingDaysIncidences = allEmployeesO[thisEmployeeId].incidencesByType[incidenceTypeForPenDays.$id];
                                                } else {
                                                    allEmployeesO[thisEmployeeId].pendingDaysIncidences = []
                                                }

                                            }
                                        }
                                    }
                                    resolve(true)
                                }).catch(reject)
                            })
                            break;
                        case 'setFastIncidencesTypes':
                            $scope.actionMessages = 'Obteniendo incidencias rápidas..';
                            $f('setInObjectPath')('incidencesTypes.fb', opObjs, $f('getConceptsForPayroll')(opObjs.concepts.fb, { 'type': 'incidenceType', 'allowManual': true, payroll: $scope.payrollId, process: 'payroll' }), true, true);
                            $scope.incidencesTypes = opObjs.incidencesTypes.fb;
                            break;
                        case 'setEmployeesMovement':
                            $scope.actionMessages = 'Estableciendo movimientos..';
                            $f('setInObjectPath')('movementsByEmployee.fb', opObjs, $f('groupByField')(opObjs.movements.fb, 'employee', false, 'data.date'), true, true);
                            break;
                        case 'calculate':
                            $scope.actionMessages = 'Calculando empleados..';
                            if (opObjs.operation.fb.status >= $scope.opStatusNotCalc) {
                                $scope.actionMessages = 'Obteniendo cálculos de empleados..';
                            }
                            if (!AppF.notCalculate) {
                                promise = calculate();
                            }
                            break;
                        case 'reloadOperation':
                            if (opObjs.operation.fb.status <= 3) {
                                $log.log('se va a recargar');
                                $state.reload();
                            }
                            break;
                        case 'loadEmployees':
                            $scope.actionMessages = 'Obteniendo empleados para la sabana..';
                            promise = loadEmployees(actionsParams);
                            break;
                        case 'loadOtherOperationObjs':
                            $scope.actionMessages = 'Obteniendo datos..';
                            promise = $q(function (resolve, reject) {
                                ListsF.loadList('lastChange', 'settings/lastChange', undefined, 'object', 'latestActions').then(function (resp) {
                                    opObjs.latestCatalogActions = { fb: resp, watch: true, actions: ['checkActionForThisOperation'] };
                                    opObjs.operation.watch = true; //watch: true, actions: ['setVariablesOfOperation']
                                    opObjs.operation.actions = [{ action: 'reloadOperation', field: 'status' }, 'setVariablesOfOperation', { action: 'loadEmployees', field: 'excludedEmployees', params: { forceDataLoad: false } }]; //watch: true, actions: ['setVariablesOfOperation']
                                    resolve(true);
                                }).catch(reject);
                            });
                            break;
                        case 'activeWatchers':
                            promise = activeWatchers();
                            break;
                    }
                    if (angular.isDefined(promise)) {
                        promise.then(function () {
                            $log.debug('Termino ' + action + ' en:' + ((new Date().valueOf()) - initTime) + 'ms');
                        }).catch(function (error) {
                            $log.error('Error en ' + action, error);
                        }).then(function () {
                            $scope.$evalAsync(function () {
                                finishCalculation(executeCalculation);
                            });
                        });
                    } else {
                        $log.debug('Termino ' + action + ' en:' + ((new Date().valueOf()) - initTime) + 'ms');
                        finishCalculation(executeCalculation);

                    }
                } catch (error) {
                    $log.error('Error en ' + action, error);
                    finishCalculation(executeCalculation);
                }
            } else if (!$scope.firstFinished) {
                $scope.actionMessages = 'Todo listo...✓';
                $scope.firstFinished = true;
                $timeout(function () {
                    $scope.$evalAsync();
                    $timeout(function () {
                        $scope.showProgress = false;
                        $scope.actionMessages = '';
                        $scope.$evalAsync();
                    }, 1000, false);
                }, 0, false);
            } else {
                $scope.$evalAsync();
            }
        }
        $scope.showExcludedModal = function (ev) {
            $mdDialog.show({
                templateUrl: 'app/main/clients/views/newoperation/dialogs/excluded-employee.html',
                controller: 'ExcludedEmployeesController',
                controllerAs: 'eemdCtrl',
                locals: {
                    operation: opObjs.operation.fb,
                    operationRef: $scope.refs.operations
                },
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            }).then(function () {
                $log.log('closed')
            }).catch(function (error) {
                if (error) {
                    errAlertS(error);
                }
            });
        }

        function validarSeleccion(selected) {
            if (!selected || !selected.length) return Promise.resolve(false);
            var opRef = $scope.refs.operations + '/' + opObjs.operation.fb.$id + '/employees';
            return AppF.root.child(opRef).once('value').then(function (snap) {
                var all = (snap && snap.val && snap.val()) || {};
                for (var i = 0; i < selected.length; i++) {
                    var emp = all[selected[i].$id];
                    if (!(emp && emp.billId)) return false;
                }
                return true;
            });
        }

        watchers = $scope.$watchCollection('selected', function (nuevo, anterior) {
            if (nuevo === anterior) {
                return;
            }
            validarSeleccion(nuevo).then(function (resp) {
                $scope.allowHumand = resp
            })
        });

        $scope.$on('$destroy', function () {
            if (watchers) {
                watchers();
            }
        });


        $scope.sendPayrollReceipt = function (event, selected) {
            var operationRefData = $scope.refs.operations + '/' + opObjs.operation.fb.$id + '/employees'
            $mdDialog.show({
                templateUrl: 'app/main/clients/views/newoperation/controllers/dialog/sendPayrollReceipt.html',
                controller: 'SendPayrollReceiptController',
                controllerAs: 'sprCtrl',
                locals: {
                    selected: selected,
                    operationRef: operationRefData,
                    operation: opObjs.operation.fb
                },
                parent: angular.element($document.body),
                targetEvent: event,
                scope: $scope.$new(),
                clickOutsideToClose: false
            });
        }

        function finishCalculation(executeCalculation) {
            var current = 0;
            if ($scope.operationProgress < 100) {
                current = $scope.operationProgress;
            }
            var missing = 100 - current;
            var thisProgress = missing / actionsQueue.length;
            $scope.operationProgress = current + thisProgress;
            actionsQueue.shift();
            $scope.executing = false;
            $scope.$evalAsync()
            if (executeCalculation && !AppF.notCalculate) {
                addForAction('calculate');
            }
            $timeout(function () {
                executeAction();
            }, 0, false); //false to not run another digest

        }
        function addForAction(action, fbData, executeCalculation, notExecute, actionParams) {
            var indexAction = actionsQueue.findIndex(function (item) {
                return item[0] === action;
            });
            if (indexAction <= 0) {
                var data = [action, fbData, executeCalculation, actionParams];
                actionsQueue.push(data);
                if (!notExecute) {
                    executeAction();
                }
            }
        }
        function calculate() {
            return $q(function (resolve) {
                $timeout(function () {
                    $f('loopEach')(processIncidences, function (data, key) {
                        processIncidences[key] = {};
                    });
                    $scope.rejectedIncidences = [];
                    if (angular.isUndefined($scope.fastIncidences)) {
                        $scope.fastIncidences = {};
                    }
                    var auxProccess = opObjs.process.fb.filter(function (item) {
                        return item.id !== 'real' && item.id !== 'rejectedIncidences' && item.id !== 'others';
                    });

                    var msg = [];
                    $scope.hasErrors = false;
                    $scope.hasAnualIsrCalculation = false;
                    for (var o = 0; o < operationEmployeesF.length; o++) {
                        var employee = allEmployeesO[operationEmployeesF[o].$id];
                        var employeeId = employee.$id;
                        employee.processes = auxProccess;
                        if (!employee.isClosed) {
                            var calcData = $filter('calculateEmployee')(
                                employee,
                                $scope.calculations[employeeId],
                                dataUsedToCalc[employeeId],
                                $scope.fastIncidences[employeeId],
                                rejectIncidencesByEmployee[employeeId],
                                processIncidencesByEmployee[employeeId],
                                opObjs);
                            if (angular.isDefined(calcData.calculations)) {
                                if (angular.isUndefined($scope.calculations[employeeId])) {
                                    $scope.calculations[employeeId] = {};
                                }
                                $scope.calculations[employeeId] = calcData.calculations;
                                dataUsedToCalc[employeeId] = calcData.dataUsedToCalc;
                                $scope.fastIncidences[employeeId] = calcData.fastIncidences;
                                rejectIncidencesByEmployee[employeeId] = calcData.rejectedIncidences;
                                $scope.rejectedIncidences = $scope.rejectedIncidences.concat(rejectIncidencesByEmployee[employeeId]);
                                processIncidencesByEmployee[employeeId] = calcData.processIncidences;
                                $f('loopEach')(calcData.processIncidences, function (employeeIncidences, operationKey) {
                                    if (angular.isUndefined(processIncidences[operationKey])) {
                                        processIncidences[operationKey] = {};
                                    }
                                    processIncidences[operationKey] = Object.assign(processIncidences[operationKey], employeeIncidences);
                                });
                                if ($scope.calculations[employeeId].anualIsr) {
                                    $scope.hasAnualIsrCalculation = true;
                                }
                            }
                            if (angular.isObject(calcData) && calcData !== null && calcData.error && angular.isString(calcData.msg)) {
                                msg.push(calcData.msg);
                            }
                        } else {
                            var closeCalculations = $f('getFromObject')(opObjs.dispersion.fb, 'employeesData.calculations.' + employeeId, {});
                            $f('loopEach')(closeCalculations, function (data, key) {
                                if (data.fiscalValue) {
                                    if (angular.isUndefined(processIncidences.fiscal)) {
                                        processIncidences.fiscal = {};
                                    }
                                    if (angular.isUndefined(processIncidences.fiscal[data.conceptId])) {
                                        processIncidences.fiscal[data.conceptId] = {
                                            conceptId: data.conceptId,
                                            conceptKey: key,
                                            isFiscal: true,
                                            name: data.name,
                                            nature: opObjs.conceptsById.fb[data.conceptId] ? opObjs.conceptsById.fb[data.conceptId].nature : ''
                                        };
                                    }

                                }
                                if (data.socialPrevisionValue) {
                                    if (angular.isUndefined(processIncidences.socialPrevision)) {
                                        processIncidences.socialPrevision = {};
                                    }
                                    if (angular.isUndefined(processIncidences.socialPrevision[data.conceptId])) {
                                        processIncidences.socialPrevision[data.conceptId] = {
                                            conceptId: data.conceptId,
                                            conceptKey: key,
                                            name: data.name,
                                            nature: opObjs.conceptsById.fb[data.conceptId] ? opObjs.conceptsById.fb[data.conceptId].nature : ''
                                        };
                                    }

                                }
                            });
                            if (closeCalculations.anualIsr) {
                                $scope.hasAnualIsrCalculation = true;
                            }
                        }
                    }
                    $scope.calculations = Object.assign($scope.calculations, $f('getFromObject')(opObjs.dispersion.fb, 'employeesData.calculations', {}));
                    $f('loopEach')($f('getFromObject')(opObjs.dispersion.fb, 'employeesData.rejectedIncidences', {}), function (employeeIncidences, employeeId) {
                        $f('loopEach')(employeeIncidences, function (rejectInc) {
                            var incidence = {
                                conceptId: rejectInc.i,
                                conceptKey: rejectInc.k,
                                name: rejectInc.n,
                                qty: rejectInc.v,
                                employeeId: employeeId,
                                employeeName: $f('getFromObject')(allEmployeesO[employeeId], 'data.name', 'SIN NOMBRE')
                            };
                            $scope.rejectedIncidences.push(incidence);
                        });
                    });
                    if (msg.length > 0) {
                        $scope.hasErrors = true;
                        var text = '<h4>Se encontraron algunos errores en los cálculos de los empleados</h4><ul>';
                        for (var m = 0; m < msg.length; m++) {
                            text += '<li>' + msg[m] + '</li>';
                        }
                        text += '</ul>';
                        errAlertS(text);
                    }
                    if (opObjs.operation.fb.status < 3) {
                        opObjs.process.fb = $f('getProcessForOperation')(opObjs.processFromPayroll.fb, opObjs.opIncidences.fb, opObjs.conceptsById.fb, processIncidences, operationEmployeesF);
                        $scope.process = opObjs.process.fb;
                    }
                    $scope.operationTotals = $f('getTotalsOfOperations')($scope.calculations, opObjs.process.fb, opObjs.conceptsById.fb, auxProccess, opObjs.dispersion.fb, opObjs.operation.fb.status >= $scope.opStatusNotCalc);
                    $scope.$evalAsync();
                    $timeout(function () {
                        resolve(true);
                    }, 0, false)
                }, 0, false);
            });
        }
        var timestamps = {};
        var lastValueToCheck = {};
        function setWatcher(objData, objName) {
            $filter("setOperationWatcher")(objData, objName, lastValueToCheck, $scope, addForAction, watchers, firstIgnored, timestamps)
        }
        function activeWatchers() {
            var promises = [];
            $f('loopEach')(opObjs, function (objData, objName) {
                promises.push(setWatcher(objData, objName));
            });
            return $q.all(promises);
        }
        function setCreditIncidences() {
            var incidencesOfCredit = $f('setCreditIncidences')(operationEmployeesF, allEmployeesO, opObjs.concepts.fb, $scope.refs.incidences, $scope.calendarId, opObjs.period.fb);
            return incidencesOfCredit;
        }
        function getConstantsIncidences() {
            var constants = $f('getConstantsIncidences')(operationEmployeesF, allEmployeesO, $scope.calendarId, opObjs.period.fb, $scope.payrollId, $scope.refs.incidences, opObjs.conceptsById.fb, 'payroll', undefined, $filter('getFromObject')(opObjs.operation, 'fb', {}), $filter('getFromObject')(opObjs.lastOperation, 'fb', {}));
            return constants;
        }


        function getAllEmployees(movementsGrouped) {
            return $q(function (resolve, reject) {
                var pendingToGet = [];
                var employeeData = $f('getFromObject')(opObjs.employees, 'fb', {});
                $f('loopEach')(movementsGrouped, function (data, employeeId) {
                    if (!employeeData.hasOwnProperty(employeeId)) {
                        if (pendingToGet.length < 50) {
                            pendingToGet.push(employeeId);
                        }
                    }
                });
                var query = [];
                if (pendingToGet.length > 0) {
                    var employeesDataQuery = {
                        page: 0.5,
                        size: 0.5,
                        'fid': {
                            '$in': pendingToGet
                        }
                    };
                    query.push($rootScope.D.api.get('p/employees', employeesDataQuery));
                }
                Promise.all(query).then(function (resp) {
                    if (resp.length > 0) {
                        var employeeData = $f('getFromObject')(resp[0], 'data.data', []);
                        for (var e = 0; e < employeeData.length; e++) {
                            if (angular.isUndefined(opObjs.employees)) {
                                opObjs.employees = {};
                            }
                            if (angular.isUndefined(opObjs.employees.fb)) {
                                opObjs.employees.fb = {};
                            }
                            opObjs.employees.fb[employeeData[e].fid] = employeeData[e];
                            opObjs.employees.fb[employeeData[e].fid].$id = employeeData[e].fid;
                        }
                        var thisEmployeeData = $f('getFromObject')(opObjs.employees, 'fb', {});
                        for (var p = 0; p < pendingToGet.length; p++) {
                            if (angular.isUndefined(thisEmployeeData[pendingToGet[p]])) {
                                if (angular.isUndefined(opObjs.employees)) {
                                    opObjs.employees = {};
                                }
                                if (angular.isUndefined(opObjs.employees.fb)) {
                                    opObjs.employees.fb = {};
                                }
                                opObjs.employees.fb[pendingToGet[p]] = {};
                                opObjs.employees.fb[pendingToGet[p]].$id = pendingToGet[p];
                            }
                        }
                    }
                    if (pendingToGet.length > 0) {
                        resolve(getAllEmployees(movementsGrouped));
                    } else {
                        resolve(opObjs.employees.fb);
                    }
                }).catch(reject);
            });
        }
        $scope.excludeEmployees = function ($event, selected) {
            var text = selected.length > 1 ? 'estos empleados' : 'este empleado';
            var confirm = $mdDialog.confirm(confirmConfig)
                .title('Excluir ' + selected.length + ' empleado(s) del calculo')
                .content('Esta seguro que desea realizar esta acción, al realizar esta acción no se realizará el calculo de ' + text + ' para este periodo ¿Desea continuar?')
                .ariaLabel('exclude employees')
                .ok('Aceptar')
                .cancel('Cancelar')

            $mdDialog.show(confirm).then(function () {
                var updates = {};
                for (var s = 0; s < selected.length; s++) {
                    updates[$scope.refs.operations + '/' + opObjs.operation.fb.$id + '/excludedEmployees/' + selected[s].$id] = true;
                }
                return AppF.root.update(updates);
            }).then(function () {
                $log.log('excluded')
            }).catch(function (error) {
                if (error) {
                    errAlertS(error)
                }
            });
        }
        function loadEmployees(params) {
            return $q(function (resolve, reject) {
                var forceDataLoad = true;
                if (angular.isObject(params) && angular.isDefined(params.forceDataLoad)) {
                    forceDataLoad = params.forceDataLoad;
                }
                if ($scope.firstFinished) {
                    $scope.showProgress = true;
                    $scope.operationProgress = 0;
                    $scope.actionMessages = "Actualizando Empleados"
                }
                var movementsGrouped;
                if (opObjs.operation.fb.status >= $scope.opStatusNotCalc) {
                    movementsGrouped = opObjs.operation.fb.employees;
                } else {
                    movementsGrouped = JSON.parse(JSON.stringify(opObjs.movementsByEmployee.fb));
                }
                if ($scope.firstFinished) {
                    $scope.operationProgress = 10;
                    $scope.actionMessages = "Lista Actualizada"
                }
                var employeeProcess = opObjs.processFromPayroll.fb.filter(function (item) {
                    return (item.id !== 'real' && item.id !== 'rejectedIncidences');
                }).map(function (item) {
                    return { id: item.id, name: item.name };
                });
                if ($scope.firstFinished) {
                    $scope.operationProgress = 20;
                    $scope.actionMessages = "Analizando información"
                }
                var cleanedObjs = {
                    period: $filter('getFromObject')(opObjs.period, 'fb'),
                    payroll: $filter('getFromObject')(opObjs.payroll, 'fb'),
                    ccs: $filter('getFromObject')(opObjs.employeesCcs, 'fb'),
                    paymentFrequency: $filter('getFromObject')(opObjs.paymentFrequency, 'fb'),
                    nfdRecords: $filter('clearObject')($scope.M.nfdRecords),
                    imssRecordData: $filter('getIMSSRowLast')($scope.calendarId, $scope.M.imssRecords),
                    cyvRecordsData: $filter('clearObject')(opObjs.getCyvTable.fb),
                    minimumWageRecords: $filter('clearObject')(opObjs.minimumWageRecords.fb),
                    employeeProcess: employeeProcess
                }
                if ($scope.firstFinished) {
                    $scope.operationProgress = 30;
                    $scope.actionMessages = "Excluyendo empleados"
                }
                var excludedEmployees = opObjs.operation.fb.excludedEmployees || {};
                for (var employeeId in excludedEmployees) {
                    delete movementsGrouped[employeeId]
                }
                if ($scope.firstFinished) {
                    $scope.operationProgress = 40;
                    $scope.actionMessages = "Consultando datos iniciales"
                }
                getAllEmployees(movementsGrouped).then(function () {
                    if ($scope.firstFinished) {
                        $scope.operationProgress = 50;
                        $scope.actionMessages = "Obteniendo información de empleados validos"
                    }
                    var promises = {};
                    var progressByEmployee = 30 / Object.keys(movementsGrouped).length;
                    $f('loopEach')(movementsGrouped, function (movements, employeeId) {
                        if ($scope.firstFinished) {
                            $scope.operationProgress = $scope.operationProgress + progressByEmployee;
                        }
                        if (!excludedEmployees[employeeId]) {
                            var employeeStatus = $f('getFromObject')(opObjs.operation.fb, 'employees.' + employeeId + '.status');
                            promises[employeeId] = new Promise(function (resolve) {
                                if (forceDataLoad || (!allEmployeesO[employeeId])) {
                                    resolve($f('getEmployeeOfMovement')(
                                        employeeId,
                                        movements,
                                        $scope.payrollId,
                                        employeeStatus >= 3,
                                        $scope.calendarId,
                                        opObjs,
                                        cleanedObjs
                                    ))
                                } else {
                                    resolve(allEmployeesO[employeeId])
                                }
                            })
                        }
                    });
                    if ($scope.firstFinished) {
                        $scope.operationProgress = 80;
                    }
                    $q.all(promises).then(function (resp) {
                        allEmployeesO = resp;
                        var allEmployees = {};
                        var fiscalEmployees = [];
                        var operationEmployees = [];
                        var msg = [];
                        var oldOpEmpObj = angular.isDefined(opObjs.operation.fb) && angular.isDefined(opObjs.operation.fb.employees) ? opObjs.operation.fb.employees : {};
                        var newOpEmpObj = {};
                        if ($scope.firstFinished) {
                            $scope.actionMessages = "Actualizando Vista";
                        }
                        $f('loopEach')(resp, function (employeeData, employeeId) {
                            if (angular.isObject(employeeData) || angular.isString(employeeData)) {
                                newOpEmpObj[employeeId] = oldOpEmpObj[employeeId] ? oldOpEmpObj[employeeId] : {};
                                newOpEmpObj[employeeId].status = angular.isDefined(oldOpEmpObj[employeeId]) && angular.isDefined(oldOpEmpObj[employeeId].status) ? oldOpEmpObj[employeeId].status : 0;
                            }
                            if (angular.isObject(employeeData)) {
                                var objsToWatch = employeeData.objsToWatch;
                                delete employeeData.objsToWatch;
                                allEmployees[employeeId] = employeeData;
                                var employeeObj = {
                                    '$id': employeeData.$id,
                                    'data': {
                                        'name': employeeData.data.name,
                                        'enroleDate': employeeData.data.enroleDate,
                                        'cc': employeeData.movements[0].cc
                                    },
                                    movements: employeeData.movements
                                };
                                if (employeeData.forOperation) {
                                    if (employeeData.isFiscal) {
                                        fiscalEmployees.push(employeeObj);
                                    }
                                    operationEmployees.push(employeeObj);
                                }
                                newOpEmpObj[employeeId].cc = employeeData.movements[0].cc || null;
                                newOpEmpObj[employeeId].rp = employeeData.movements[0].rp || null;
                                $f('loopEach')(objsToWatch, function (obj, index) {
                                    if (!opObjs.hasOwnProperty(index)) {
                                        opObjs[index] = obj;
                                    }
                                });
                                newOpEmpObj[employeeId].status = angular.isDefined(oldOpEmpObj[employeeId]) && angular.isDefined(oldOpEmpObj[employeeId].status) ? oldOpEmpObj[employeeId].status : 0;
                            } else if (angular.isString(employeeData)) {
                                msg.push(employeeData);
                            }
                        });
                        if (opObjs.operation.fb.status < 3) {
                            opObjs.operation.fb.employees = newOpEmpObj;
                            opObjs.operation.fb.version = 2.0;
                        }
                        if (msg.length > 0) {
                            var text = '<h4>Se encontraron algunos problemas con los empleados</h4><ul>';
                            for (var m = 0; m < msg.length; m++) {
                                text += '<li>' + msg[m] + '</li>';
                            }
                            text += '</ul>';
                            errAlertS(text);
                        }
                        fiscalEmployeesF = fiscalEmployees;
                        operationEmployeesF = operationEmployees;
                        allEmployeesO = allEmployees;
                        $log.log(allEmployeesO);
                        $scope.filterEmployees();
                        var promises = [];
                        if (opObjs.operation.fb.status < 3) {
                            opObjs.operation.fb.fromLoadEmployee = moment().valueOf();
                            promises.push(opObjs.operation.fb.$save());
                        }
                        if ($scope.firstFinished) {
                            $scope.operationProgress = 100;
                            $scope.actionMessages = "Empleados cargados correctamente"
                        }
                        Promise.all(promises).then(function () {
                            if (angular.isUndefined(opObjs.creditIncidences)) {
                                opObjs.creditIncidences = { watch: true, actions: ['setIncidencesOfEmployees'] };
                            }
                            if (angular.isUndefined(opObjs.constantsIncidences)) {
                                opObjs.constantsIncidences = { watch: true, actions: ['setIncidencesOfEmployees'] };
                            }
                            opObjs.creditIncidences.fb = setCreditIncidences();
                            opObjs.constantsIncidences.fb = getConstantsIncidences();
                            addForAction('setIncidencesOfEmployees', opObjs.incidences.fb, false, true);
                            addForAction('setOperationCcs', opObjs.myCcs.fb, false, true);
                            addForAction('calculate');
                            setOperationVariables();
                            if ($scope.firstFinished) {
                                $scope.showProgress = false;
                                $scope.actionMessages = '';
                            }
                            resolve(true);
                        });
                    }).catch(function (error) {
                        reject(error);
                    });
                }).catch(reject);
            });
        }
        function moveEmployees(action, comments, periodSelected, paymentDate, pendingEmployees) {
            return $q(function (resolve, reject) {
                turnOffWatchers();
                var employeeStatus = $scope.nextEmployeeStatus;
                var incidenceStatus = $scope.nextIncidenceStatus;
                var operationStatus = $scope.nextOperationStatus;
                var operation = opObjs.operation.fb;
                var dispersionId = (angular.isDefined(operation) && angular.isDefined(operation.dispersion)) ? operation.dispersion : AppF.root.child($scope.refs.dispersion).push().key;
                var employees = (angular.isArray(pendingEmployees) && pendingEmployees.length > 0) ? pendingEmployees : operationEmployeesF;
                var nextOperation;
                var nextOperationPeriod;
                var queries = [];
                if (angular.isDefined(action) && (action === 'moveBackOperation' || action === 'reOpenClosed')) {
                    employeeStatus = $scope.previousEmployeeStatus;
                    incidenceStatus = $scope.previousIncidencesStatus;
                    operationStatus = $scope.previousOperationStatus;
                }
                if (operationStatus >= 3) {
                    queries.push($filter('getNextOperation')(operation, $scope.payrollId, $scope.calendarId, $scope.operationType, $scope.refs));
                }
                var onlyPrevision;
                var fiscal = opObjs.process.fb.find(function (value) {
                    return value.id === 'fiscal';
                });
                if (operationStatus >= 3 && ($scope.fiscalEmployees.length === 0 || !fiscal)) {
                    onlyPrevision = true;
                }
                Promise.all(queries).then(function (resp) {
                    var secondQueries = [];
                    if (operationStatus >= 3) {
                        if (angular.isDefined(resp[0].operation)) {
                            nextOperation = resp[0].operation;
                            nextOperationPeriod = resp[0].period;
                        }
                        if (angular.isArray($scope.rejectedIncidences) && $scope.rejectedIncidences.length > 0) {
                            if (angular.isUndefined(nextOperation)) {
                                throw 1;
                            } else if (angular.isUndefined(nextOperationPeriod)) {
                                throw 2;
                            }
                        }
                    }
                    return Promise.all(secondQueries);
                }).then(function () {
                    var updates = {};
                    updates[$scope.refs.operations + '/' + operation.$id + '/dispersion'] = dispersionId;
                    updates[$scope.refs.operations + '/' + operation.$id + '/fromClosed'] = moment().valueOf();
                    if (comments !== '') {
                        updates[$scope.refs.operations + '/' + operation.$id + '/comments'] = comments;
                    }
                    return AppF.root.update(updates);
                }).then(function () {
                    var data = {
                        employees: employees,
                        opObjs: opObjs,
                        refs: $scope.refs,
                        calculations: $scope.calculations,
                        dispersionId: dispersionId,
                        fiscalEmployees: JSON.parse(JSON.stringify($scope.fiscalEmployees)),
                        allEmployeesO: allEmployeesO,
                        employeeStatus: employeeStatus,
                        onlyPrevision: onlyPrevision,
                        operation: operation,
                        operationStatus: operationStatus,
                        nextOperation: nextOperation,
                        nextOperationPeriod: nextOperationPeriod,
                        incidenceStatus: incidenceStatus,
                        action: action,
                        operationType: 'ordinary',
                        periodSelected: periodSelected,
                        calendar: operation.calendar,
                        allRejected: $scope.rejectedIncidences
                    };
                    return $f('moveEmployees')(data);
                }).then(function (response) {
                    return new Promise(function (resolve, reject) {
                        var thisPromises = [];
                        if (angular.isDefined(opObjs.operation.fb.dispersion)) {
                            thisPromises.push(ListsF.loadList('dispersions', $scope.refs.dispersion + '/' + opObjs.operation.fb.dispersion, undefined, 'object', 'dispersion-' + opObjs.operation.fb.dispersion));
                        }
                        Promise.all(thisPromises).then(function (resp) {
                            if (resp.length > 0 && angular.isObject(resp[0]) && resp[0] !== null) {
                                $f('setInObjectPath')('dispersion.fb', opObjs, $f('transformCalculations')(resp[0]), true, true);
                            }
                            var exists = (response.indexOf(false) !== -1) ? true : false;
                            if (exists) {
                                reject('No se pudo completar el cierre');
                            } else {
                                resolve(true);
                            }
                        });
                    });
                }).then(function () {
                    var updates = {};
                    var allEmployees = opObjs.operation.fb.employees;
                    var changeStatus = true;
                    for (var key in allEmployees) {
                        if (allEmployees[key].status < incidenceStatus) {
                            changeStatus = (action === 'moveBackOperation' || action === 'reOpenClosed') ? true : false;
                            break;
                        }
                    }
                    if (changeStatus || action === 'closePartial') {
                        updates[$scope.refs.operations + '/' + operation.$id + '/status'] = (!onlyPrevision) ? operationStatus : 7;
                    }
                    if (operationStatus >= 3) {
                        if ($scope.fiscalEmployees.length === 0) {
                            var findIndex = opObjs.process.fb.findIndex(function (value) {
                                return value.id === 'fiscal';
                            });
                            if (findIndex > -1) {
                                delete opObjs.process.fb[findIndex].companiesRecord;
                            }
                        }
                        var process = $f('clearObject')(opObjs.process.fb);
                        $filter('loopEach')(process, function (value, key) {
                            process[key] = value;
                            if (value.hasOwnProperty('companiesRecord')) {
                                process[key].updated = moment().valueOf()
                            }
                        })
                        var obj = {
                            originalPeriod: operation.period,
                            originalCalendar: operation.calendar,
                            period: periodSelected.period,
                            calendar: operation.calendar,
                            accuDate: periodSelected.accuDate,
                            payroll: operation.payroll,
                            process: process,
                            operationType: 'ordinary'
                        };
                        updates[$scope.refs.dispersion + '/' + dispersionId + '/data'] = obj;
                        updates[$scope.refs.dispersion + '/' + dispersionId + '/operation'] = operation.$id;
                        updates[$scope.refs.dispersion + '/' + dispersionId + '/status'] = 0;
                        updates[$scope.refs.dispersion + '/' + dispersionId + '/total'] = $scope.operationTotals;
                        updates[$scope.refs.operations + '/' + operation.$id + '/accuPeriod'] = periodSelected.period;
                        updates[$scope.refs.operations + '/' + operation.$id + '/fromClose2'] = moment().valueOf();
                        if (paymentDate) {
                            updates[$scope.refs.operations + '/' + operation.$id + '/forceBillingDate'] = paymentDate;
                        }
                        if (angular.isDefined(nextOperation)) {
                            if (nextOperation.calendar !== $scope.calendarId) {
                                updates['catalogs/payrollCalendars/' + $scope.payrollId + '/calendars/' + $scope.calendarId + '/data/active'] = false;
                            }
                        } else if (angular.isUndefined(nextOperation) && angular.isUndefined(nextOperationPeriod)) {
                            updates['catalogs/payrollCalendars/' + $scope.payrollId + '/calendars/' + $scope.calendarId + '/data/active'] = false;
                        }

                    }
                    if (action === 'reOpenClosed' && operationStatus === 2.5) {
                        if (angular.isUndefined(pendingEmployees)) {
                            updates[$scope.refs.dispersion + '/' + dispersionId] = null;
                            updates[$scope.refs.operations + '/' + operation.$id + '/dispersion'] = null;
                        }
                    }
                    if (angular.isDefined(nextOperation) && operationStatus >= 3 && nextOperation.status === -1) {
                        var route = 'catalogs/operations/ordinary/' + nextOperation.payroll + '/' + nextOperation.calendar + '/collection';
                        updates[route + '/' + nextOperation.$id + '/status'] = 1;
                    }
                    $log.log('Se actualizo status de operación');
                    return AppF.root.update(updates);
                }).then(function () {
                    var statusName = $filter('operationStatusNameModal')(operationStatus);
                    successAlertS('Status de Operación actualizada a ' + statusName.name);
                    setOperationVariables();
                    addForAction('activeWatchers', undefined, false, true);
                    resolve(true);
                }).catch(function (error) {
                    setOperationVariables();
                    addForAction('activeWatchers', undefined, false, true);
                    reject(error);
                });
            });
        }
        $scope.downloadBill = function (selected) {
            if (angular.isArray(selected) && selected.length > 0) {
                for (var e = 0; e < selected.length; e++) {
                    var billId = $filter('getFromObject')($scope.operation.employees, selected[e].$id + ".billId");
                    if (angular.isUndefined(billId)) {
                        errAlertS('El empleado ' + allEmployeesO[selected[e].$id].data.name + ' no tiene el recibo');
                    } else {
                        $rootScope.D.api.get("one/bills/", { "uuid": billId, project: angular.toJson({ "Comprobante.Total": 1 }) }).then(function (resp) {
                            var bill = resp.data;
                            if (bill.success && bill.data.length > 0 && bill.data[0]['Comprobante']) {
                                var amount = bill.data[0]['Comprobante']['Total'];
                                var total = $filter('convertNumberToString')(amount);
                                var params = {
                                    total: total,
                                    billId: bill.data[0]._id
                                }
                                downloadFile("interface/pdf/operation/invoice", params);
                            } else {
                                errAlertS("No se encontró datos de la factura");
                            }
                        }).catch(function (error) {
                            errAlertS(error);
                        })
                    }
                }
            } else {
                errAlertS("No se selecciono ningún empleado")
            }
        }
        $scope.downloadBills = function (ev, employees, billType) {
            if (angular.isArray(employees) && employees.length > 0) {
                $mdDialog.show({
                    templateUrl: 'app/main/clients/views/newoperation/dialogs/downloadBillConfirmation.html',
                    controller: function () {
                        var vm = this;
                        var billTypes = {
                            'prevision': 'Complemento',
                            'billNoBilled': 'Fiscal Provisional'
                        };
                        vm.billType = billTypes[billType];
                        vm.employeesCount = employees.length;
                        vm.cancel = $mdDialog.cancel;
                        vm.confirm = function (withCopy) {
                            var employeesIds = employees.map(function (item) {
                                return item.$id;
                            });
                            var url;
                            var params = {
                                employees: employeesIds,
                                dispersionId: opObjs.operation.fb.dispersion
                            };
                            if (billType === 'prevision') {
                                url = 'interface/pdf/operations/billPrevision';
                                params.operationId = opObjs.operation.fb.$id;
                                params.opType = 'ordinary';
                                params.loop = withCopy ? 2 : 1;
                            } else {
                                var thisCenter = AppF.center.toUpperCase();
                                var thisCalendar = $filter('getFromObject')(opObjs.operation.fb, 'calendar') ? '_' + opObjs.operation.fb.calendar : '';
                                var thisPeriod = $filter('getFromObject')(opObjs.operation.fb, 'period') ? '_' + $filter('zeroFill')(opObjs.operation.fb.period, 2) : '';
                                var thisFileName = thisCenter + thisCalendar + '_' + opObjs.payroll.fb.data.class + '_ORDINARI_SIMPLE' + thisPeriod;
                                url = 'interface/pdf/operation/invoiceNoBilled';
                                params.filename = thisFileName;
                                params.withCopy = withCopy;
                            }
                            downloadFile(url, params);
                            $mdDialog.hide();
                        };
                    },
                    controllerAs: 'downloadBillCtrl',
                    parent: angular.element($document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true
                });
            } else {
                errAlertS('No se selecciono ningún empleado');
            }
        }
        function downloadFile(path, params, useV2Api) {
            $rootScope.loadingProgress = true;
            var urlDefault = window.__env.serviceWorkerUrl;
            if (useV2Api) {
                urlDefault = $window.location.protocol + '//' + apiv2[window.__env.mode] + '/';
            }
            $http({
                method: 'POST',
                url: urlDefault + path,
                responseType: 'arraybuffer',
                data: params
            }).then(function (response) {
                var headers = response.headers();
                var filename = headers['x-filename'];
                var contentType = headers['content-type'];
                var linkElement = document.createElement('a');
                try {
                    var blob = new Blob([response.data], {
                        type: contentType
                    });
                    var url = window.URL.createObjectURL(blob);
                    linkElement.setAttribute('href', url);
                    linkElement.setAttribute("download", filename);
                    var clickEvent = new MouseEvent("click", {
                        "view": window,
                        "bubbles": true,
                        "cancelable": false
                    });
                    linkElement.dispatchEvent(clickEvent);
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync(function () {
                        $log.debug('generatePdf finished');
                    });
                } catch (ex) {
                    $log.error(ex, "error descargando el archivo");
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                }
            }).catch(function (err) {
                var message = new TextDecoder("utf-8").decode(err.data);
                var error = angular.fromJson(message);
                errAlertS(error.data || error.message);
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
            });
        }
        $scope.downloadZipBill = function (selected) {
            $rootScope.loadingProgress = true;
            if (angular.isUndefined(selected) || selected.length == 0) {
                selected = $scope.fiscalEmployees;
            }
            var totalPromises = [];
            var billsData = [];
            for (var e = 0; e < selected.length; e++) {
                var billUid = $filter('getFromObject')($scope.operation.employees, selected[e].$id + ".billId");
                var status = $filter('getFromObject')($scope.operation.employees, selected[e].$id + ".status");
                if (angular.isUndefined(billUid)) {
                    if (status < 5) {
                        errAlertS('El empleado ' + allEmployeesO[selected[e].$id].data.name + ' no tiene el recibo');
                    }
                } else {
                    billsData.push({
                        employeeId: selected[e].$id,
                        bucketUrl: $filter('getFromObject')($scope.operation.employees, selected[e].$id + ".xmlUrl"),
                        fileName: $filter('getFromObject')($scope.operation.employees, selected[e].$id + ".fileName")
                    });
                    totalPromises.push($rootScope.D.api.get("one/bills/", { "uuid": billUid, project: angular.toJson({ "Comprobante.Total": 1 }) }));
                }
            }
            if (totalPromises.length > 0) {
                Promise.all(totalPromises).then(function (totalsResp) {
                    var employees = {};
                    if (selected.length > 0 && totalsResp.length === 0) {
                        throw "No se encontró los datos de la factura solicitado";
                    }
                    for (var t = 0; t < totalsResp.length; t++) {
                        billsData[t].total = $filter('convertNumberToString')(totalsResp[t].data.data[0]['Comprobante']['Total']);
                        billsData[t].billId = totalsResp[t].data.data[0]._id;
                        employees[billsData[t].employeeId] = billsData[t];
                    }
                    var thisCalendar = $filter('getFromObject')(opObjs.operation.fb, 'calendar') ? '_' + opObjs.operation.fb.calendar : '';
                    var thisPeriod = $filter('getFromObject')(opObjs.operation.fb, 'period') ? '_' + $filter('zeroFill')(opObjs.operation.fb.period, 2) : '';
                    var thisCenter = AppF.center.toUpperCase();
                    var thisFileName = thisCenter + thisCalendar + '_' + opObjs.payroll.fb.data.class + '_ORDINARI' + thisPeriod;
                    var params = {
                        dispersionId: opObjs.operation.fb.dispersion,
                        operationId: opObjs.operation.fb.$id,
                        opType: 'ordinary',
                        filename: thisFileName
                    }
                    if (selected.length > 0) {
                        params.employees = angular.toJson(employees);
                    }
                    downloadFile('models/bill/getBillZipAll', params);
                }).catch(function (error) {
                    errAlertS(error);
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                })
            } else {
                $rootScope.loadingProgress = false;
                errAlertS("No hay datos para importar")
            }

        }

        $scope.checkAccount = function (ev, action) {
            var employeeProcess = opObjs.processFromPayroll.fb.filter(function (item) {
                return (item.id !== 'real' && item.id !== 'rejectedIncidences');
            }).map(function (item) {
                return { id: item.id, name: item.name };
            });
            if ($f('checkAccountAndNumber')(allEmployeesO, employeeProcess, undefined, $scope.calculations)) {
                $f('getPeriodsAndCalendarForOpe')(opObjs.payroll.fb.$id, opObjs.operation.fb.calendar, opObjs.period.fb.accuDate).then(function (resp) {
                    if (resp.exists && !resp.periods) {
                        throw 'No hay periodos disponibles para almacenar la nomina';
                    }
                    $scope.confirmOperationAction(ev, action, resp);
                }).catch(errAlertS);
            }
        };
        function sendOperationNotification(operation, status, moveBack, operationTab, operationStatusName, comments) {
            $filter('getOperationForNotification')(operation, operationTab, moveBack, operationStatusName, comments).then(function (operationData) {
                return AppF.notifyUsers('operation', 'operations', status, operation.$id, operation, false, operationData);
            }).then(function () {
                $log.log('Notificación enviada');
            }).catch(function (error) {
                $log.error(error);
            });
        }
        $scope.goToOperation = function (periodType) {
            if (initiated && $scope.periodId && $scope.refs && $scope.refs.operations) {
                var thisPeriod = $scope.periodId + periodType;
                if (thisPeriod > 0) {
                    var promise = AppF.root.child($scope.refs.operations).orderByChild('period').equalTo(thisPeriod).once('value');
                    promise.then(function (data) {
                        var thisOperation
                        data.forEach(function (childSnap) {
                            thisOperation = childSnap.val();
                            thisOperation.$id = childSnap.key;
                        })
                        if (angular.isDefined(thisOperation) && thisOperation.status > 0) {
                            var detailState = 'app.processes.operations.edit';
                            var params = {
                                'operationId': thisOperation.$id,
                                'payrollId': thisOperation.payroll,
                                'operationType': 'ordinary',
                                'calendarYear': thisOperation.calendar ? thisOperation.calendar : null,
                                'period': thisOperation.period ? thisOperation.period : null
                            };
                            $scope.F.goToState(detailState, params);
                        } else if (angular.isDefined(thisOperation)) {
                            throw 'La operación no ha sido abierta';
                        } else {
                            throw 'No hay operación disponible';
                        }
                    }).catch(errAlertS)
                } else {
                    errAlertS('No hay operación disponible');
                }
            }
        }
        $scope.confirmOperationAction = function (ev, action, params) {
            params = (!angular.isObject(params)) ? {} : params;
            params.moveEmployees = moveEmployees;
            params.sendOperationNotification = sendOperationNotification;
            confirmOperationS(ev, action, params, $scope, opObjs, operationEmployeesF, 'ordinary');
        };

        function setOperationVariables() {
            $scope.operationStatusByEmployees = opObjs.operation.fb.status;
            if ($scope.operationPermissions.closeOperation && opObjs.operation.fb.status >= 3) {
                $scope.previousEmployeeStatus = 2;
                $scope.previousIncidencesStatus = 2;
                $scope.previousOperationStatus = 2.5;
            } else if ($scope.operationPermissions.closeOperation) {
                $scope.previousEmployeeStatus = 1;
                $scope.previousIncidencesStatus = 1;
                $scope.previousOperationStatus = 2;
                $scope.nextEmployeeStatus = 3;
                $scope.nextIncidenceStatus = 3;
                $scope.nextOperationStatus = 3;
                $scope.showCloseOpButton = true;
            } else if ($scope.operationPermissions.sendOperationToFinalRevision) {
                $scope.previousEmployeeStatus = 0;
                $scope.previousIncidencesStatus = 0;
                $scope.previousOperationStatus = 1;
                $scope.nextEmployeeStatus = 2;
                $scope.nextIncidenceStatus = 2;
                $scope.nextOperationStatus = 2.5;
                $scope.showRevisionOpButton = true;
            } else if ($scope.operationPermissions.sendOperationToRevision) {
                $scope.previousEmployeeStatus = 0;
                $scope.previousIncidencesStatus = 0;
                $scope.previousOperationStatus = -1;
                $scope.nextEmployeeStatus = 1;
                $scope.nextIncidenceStatus = 1;
                $scope.nextOperationStatus = 2;
                $scope.showRevisionOpButton = true;
            }
            if ([3, 5, 6, 7].indexOf(opObjs.operation.fb.status) > -1 && $f('getFromObject')(opObjs.nextOperation, "fb.status", "3") < 3) {
                $scope.showReopenButton = true;
            } else {
                delete $scope.showReopenButton;
            }
            //console.log($scope.showReopenButton);
            if ($scope.showRevisionOpButton) {
                //si tiene permiso para revisar la nomina pero la nomina ya no esta en un status para revisar entonces no mostramos le botón de revisar
                if (opObjs.operation.fb.status > 2) {
                    delete $scope.showRevisionOpButton;
                }
                //Si todos mis empleados están en el siguiente estado que corresponde ya no mostramos el botón
                if ($scope.showRevisionOpButton) {
                    if ($scope.allMyEmployeesInStatus($scope.nextEmployeeStatus)) {
                        delete $scope.showRevisionOpButton;
                    }
                }
            }
            if ($scope.showCloseOpButton) {
                delete $scope.showRevisionOpButton;
                //si tiene permiso para revisar la nomina pero la nomina ya no esta en un status para revisar entonces no mostramos le botón de revisar
                if (opObjs.operation.fb.status > 2.5) {
                    delete $scope.showCloseOpButton;
                }
                //Si todos mis empleados están en el siguiente estado que corresponde ya no mostramos el botón
                if ($scope.showCloseOpButton) {
                    if ($scope.allMyEmployeesInStatus($scope.nextEmployeeStatus) && opObjs.operation.fb.status >= 3) {
                        delete $scope.showCloseOpButton;
                    }
                }
            }
            if (opObjs.operation.fb.status > 0 && opObjs.operation.fb.status < $scope.opStatusNotCalc) {
                var status = {};
                var nextStatus = $scope.employeesStatusByOp[opObjs.operation.fb.status].nextStatus;
                for (var a = 0; a < nextStatus.length; a++) {
                    status[nextStatus[a]] = $scope.allMyEmployeesInStatus(nextStatus[a]);
                }
                for (var s in status) {
                    if (status[s]) {
                        if (AppF.opstatusByEmployeeStatus[s] > $scope.operationStatusByEmployees) {
                            $scope.operationStatusByEmployees = AppF.opstatusByEmployeeStatus[s];
                        }
                    }
                }
            }
            $scope.nextEmployeeStatus;
            $scope.failCloseOperation = false;
            if (opObjs.operation.fb.status < $scope.nextOperationStatus) {
                for (var i = 0; i < operationEmployeesF.length; i++) {
                    var employeeStatus = $f('getFromObject')(opObjs.operation.fb, 'employees.' + operationEmployeesF[i].$id + '.status', 0);
                    if (employeeStatus >= $scope.nextEmployeeStatus) {
                        $scope.failCloseOperation = true;
                    }
                }
            }
        }
        function validateMovement(movement, action) {
            $log.log(movement, action);
            var movementIndexFounded;
            if (angular.isObject(opObjs.movements) && angular.isArray(opObjs.movements.fb)) {
                movementIndexFounded = opObjs.movements.fb.findIndex(function (item) {
                    return item.$id === movement.$id;
                });
            }
            if (action === 'delete' && movementIndexFounded > 0) {
                opObjs.movements.fb.splice(movementIndexFounded, 1);
                addForAction('loadEmployees');
            } else {
                if (isValidMovement(movement)) {
                    if (movementIndexFounded > -1) {
                        opObjs.movements.fb[movementIndexFounded] = angular.fromJson(angular.toJson(movement));
                    } else {
                        opObjs.movements.fb.push(movement);
                    }
                    addForAction('loadEmployees');
                } else if (movementIndexFounded > -1) {
                    opObjs.movements.fb.splice(movementIndexFounded, 1);
                    addForAction('loadEmployees');
                }
            }
        }
        function isValidMovement(movement) {
            var isValid = false;
            if (movement.payroll === $scope.payrollId) {
                isValid = true;
            }
            if (isValid) {
                var movements = [movement];
                var lastMovements = $filter('getLastMovemenBeforeDate')(movements, opObjs.period.fb.start);
                var betweenMovements = $filter('getMovementsBetweenDates')(movements, opObjs.period.fb.start, opObjs.period.fb.end);
                if (lastMovements.length || betweenMovements.length) {
                    if (lastMovements.length) {
                        $log.debug('isValid because Last');
                    } else {
                        $log.debug('isValid because Between');
                    }
                    isValid = true;
                } else {
                    isValid = false;
                }
            }
            return isValid;
        }
        //FUNCIÓN PRINCIPAL QUE DISPARA TODO
        function init() {
            $scope.showProgress = true;
            initiated = true;
            $rootScope.loadingProgress = false;
            $scope.$evalAsync();
            $timeout(function () {
                // SI NO VIENE LOS PARÁMETROS EN LA URL SE REGRESA HACIA ATRÁS
                if (!$state.params.operationId || !$state.params.calendarYear || !$state.params.period || !$state.params.payrollId) {
                    errAlertS('No se tienen todos los parámetros necesarios para acceder a la nomina');
                    $scope.R.goToList();
                } else {
                    //Se obtienen los parámetros del url
                    $scope.readOnlyMode = ($state.current.url.indexOf('read') !== -1);
                    $scope.operationId = $state.params.operationId;
                    $scope.periodId = parseInt($state.params.period);
                    $scope.calendarId = parseInt($state.params.calendarYear);
                    $scope.payrollId = $state.params.payrollId;
                    $scope.operationType = $state.params.operationType;
                    //SE OBTIENEN LOS PERMISOS DEL USUARIO PARA LAS OPERACIONES DE LA NOMINA
                    $scope.operationPermissions = $f('getOperationPermissions')();
                    // dataNeeded, operationId, periodId, calendarId, payrollId, operationType, operationIsClosed
                    //SE OBTIENEN LAS REFERENCIAS Y LOS DATOS PRINCIPALES DE LA OPERACIÓN
                    $scope.actionMessages = 'Obteniendo datos iniciales';
                    $f('getInitialDataOfOperation')(dataNeeded, $scope.operationId, $scope.periodId, $scope.calendarId, $scope.payrollId, $scope.operationType, $scope.opStatusNotCalc).then(function (resp) {
                        $scope.operationProgress = 20;
                        $scope.refs = resp.refs;
                        opObjs = resp.fbObjs;
                        $f('loopEach')(opObjs, function (objData, objIndex) {
                            if (angular.isDefined(objData.actions)) {
                                for (var a = 0; a < objData.actions.length; a++) {
                                    addForAction(objData.actions[a], objData.fb, undefined, true);
                                }
                            }
                            if (angular.isObject(objData) && objData.inScope && objData.fb) {
                                $scope[objIndex] = objData.fb;
                            }
                        });
                        if (opObjs.operation.fb.status < $scope.opStatusNotCalc) {
                            opObjs.incidences.watch = true;
                        }
                        opObjs.incidences.executeCalculation = true;
                        opObjs.incidences.actions = ['setIncidencesOfEmployees'];
                        incidenceTypeForPenDays = opObjs.concepts.fb.find(function (item) {
                            return item.fdd;
                        });
                        lastIncidencesClosedCount = $filter("getFromObject")(opObjs, "appliedIncidences.fb.length", 0)
                        addForAction('loadEmployees', undefined, false, true);
                        addForAction('setIncidencesOfEmployees', opObjs.incidences.fb, false, true);
                        addForAction('calculate', undefined, false, true);
                        addForAction('loadOtherOperationObjs', undefined, false, true);
                        addForAction('activeWatchers', undefined, false);
                        $scope.setTabName();
                    }).catch(function (error) {
                        errAlertS('Error al obtener la información general de la operación');
                        $log.error(error);
                    });
                }

            }, 0, false);

        }
        $scope.setTabName = function (tabName) {
            tabName = !tabName ? 'real' : tabName;
            $scope.selected = [];
            $scope.tabSelected = tabName;
        };
        $scope.goToList = function () {
            $window.history.back();
        };
        $scope.fastIncidenceUsed = function (incidenceTypeId) {
            var inUse = true;
            if (angular.isDefined(opObjs) && angular.isDefined(opObjs.process) && angular.isArray(opObjs.process.fb)) {
                var realP = opObjs.process.fb.find(function (item) {
                    return item.id === 'real';
                });
                if (angular.isDefined(realP)) {
                    inUse = false;
                    var isInConcepts = realP.concepts.find(function (item) {
                        return incidenceTypeId === item.$id && item.type === 'fast';
                    });
                    inUse = angular.isDefined(isInConcepts);
                }
            }
            return inUse;
        };
        $scope.addFastIncidenceColumn = function (incidenceType) {
            // opObjs.processFromPayroll
            if (angular.isDefined(opObjs) && angular.isDefined(opObjs.processFromPayroll) && angular.isArray(opObjs.processFromPayroll.fb)) {
                var realP = opObjs.processFromPayroll.fb.find(function (item) {
                    return item.id === 'real';
                });
                if (angular.isDefined(realP)) {
                    var nature = opObjs.conceptsById.fb[incidenceType].nature === 'perception' ? 'sys_perceptions' : 'sys_deductions';
                    var isInConcepts = realP.concepts.find(function (item) {
                        return item.$id === nature;
                    });
                    var order = 100;
                    if (angular.isDefined(isInConcepts)) {
                        order = isInConcepts.order;
                    }
                    if (angular.isDefined(opObjs) && angular.isDefined(opObjs.process) && angular.isArray(opObjs.process.fb)) {
                        var real = opObjs.process.fb.find(function (item) {
                            return item.id === 'real';
                        });
                        if (angular.isDefined(real) && angular.isArray(real.concepts)) {
                            var concept = {
                                '$id': incidenceType,
                                'id': incidenceType,
                                'name': $f('getFromObject')(opObjs.conceptsById.fb, incidenceType + '.name', 'S/N'),
                                'key': $filter('getFromObject')(opObjs.conceptsById.fb, incidenceType + '.key', 'S/N'),
                                'nature': $filter('getFromObject')(opObjs.conceptsById.fb, incidenceType + '.nature', 'S/N'),
                                'conceptType': $filter('getFromObject')(opObjs.conceptsById.fb, incidenceType + '.type', 'S/N'),
                                'hiddenColumn': $filter('getFromObject')(opObjs.conceptsById.fb, incidenceType + '.hiddenColumn', false),
                                'showTotal': $filter('getFromObject')(opObjs.conceptsById.fb, incidenceType + '.showTotal', false),
                                'inputType': $filter('getFromObject')(opObjs.conceptsById.fb, incidenceType + '.inputType', 'currency'),
                                'hiddenField': $filter('getFromObject')(opObjs.conceptsById.fb, incidenceType + '.hiddenField', false),
                                'allowNegative': $filter('getFromObject')(opObjs.conceptsById.fb, incidenceType + '.allowNegative', false),
                                'order': order,
                                'type': 'fast'
                            };
                            real.concepts.push(concept);
                        }
                    }

                }
            }
        };
        $scope.fireValidation = function (notCalculate) {
            AppF.notCalculate = notCalculate ? true : false;
            $scope.$evalAsync(function () {
                if (!AppF.notCalculate) {
                    addForAction('calculate');
                }
            });
        };
        $scope.allMyEmployeesInStatus = function (status, all) {
            var allInStatus = true;
            if (all) {
                $f('loopEach')(allEmployeesO, function (employee, employeeId) {
                    if (opObjs.operation.fb.employees && opObjs.operation.fb.employees[employeeId] && opObjs.operation.fb.employees[employeeId].status !== status) {
                        allInStatus = false;
                        return;
                    }
                });
            } else {
                for (var i = 0; i < operationEmployeesF.length; i++) {
                    if (opObjs.operation.fb.employees && opObjs.operation.fb.employees[operationEmployeesF[i].$id] && opObjs.operation.fb.employees[operationEmployeesF[i].$id].status !== status) {
                        allInStatus = false;
                        i = operationEmployeesF.length;
                    }
                }
            }
            return allInStatus;
        };
        $scope.generateAnualAdjustmentReport = function () {
            var data = [];
            var employeesOrder = $filter('orderBy')($scope.fiscalEmployees, $scope.order);
            var headers = ['employeeId', 'anualIncome', 'gravableBase', 'exemptAmount', 'needed', 'lowerLimit', 'lowerLimitExc', 'isrPercent', 'isrFee', 'fixedQuota', 'marginalTax', 'isrTable', 'anualSubsidy', 'isrAdjustment', 'isrRetained', 'finalIsr'];
            for (var e = 0; e < employeesOrder.length; e++) {
                var thisEmployee = employeesOrder[e];
                var employeeCalculations = $scope.calculations[thisEmployee.$id];
                var anualIncome = $filter('getFromObject')(employeeCalculations, 'anualIsr.anualIncome.result', 0);
                var gravableBase = $filter('getFromObject')(employeeCalculations, 'anualIsr.anualBase.result', 0);
                var exemptAmount = anualIncome - gravableBase;
                var needed = $filter('getFromObject')(employeeCalculations, 'anualIsr.doIsrAdjustment.result', false);
                var lowerLimit = needed ? $filter('getFromObject')(employeeCalculations, 'anualIsr.lowerLimit.result', null) : null;
                var lowerLimitExc = needed ? $filter('getFromObject')(employeeCalculations, 'anualIsr.lowerLimitExceded.result', null) : null;
                var isrPercent = needed ? $filter('getFromObject')(employeeCalculations, 'anualIsr.isrPercent.result', null) : null;
                var isrFee = needed ? $filter('getFromObject')(employeeCalculations, 'anualIsr.isrFee.result', null) : null;
                var fixedQuota = needed ? $filter('getFromObject')(employeeCalculations, 'anualIsr.isrRow.result.fixedQuota', null) : null;
                var marginalTax = needed ? $filter('getFromObject')(employeeCalculations, 'anualIsr.marginalTax.result', null) : null;
                var isrTable = needed ? $filter('getFromObject')(employeeCalculations, 'anualIsr.isrOfTable.result', null) : null;
                var anualSubsidy = needed ? $filter('getFromObject')(employeeCalculations, 'anualIsr.anualSubsidy.result', null) : null;
                var isrAdjustment = needed ? $filter('getFromObject')(employeeCalculations, 'anualIsr.isrAdjustment.result', null) : null;
                var isrRetained = needed ? $filter('getFromObject')(employeeCalculations, 'anualIsr.anualIsrRetained.result', null) : null;
                var finalIsr = needed ? $filter('getFromObject')(employeeCalculations, 'anualIsr.finalAmount.result', null) : null;
                data.push([thisEmployee.$id, anualIncome, gravableBase, exemptAmount, needed, lowerLimit, lowerLimitExc, isrPercent, isrFee, fixedQuota, marginalTax, isrTable, anualSubsidy, isrAdjustment, isrRetained, finalIsr])
            }
            $http({
                method: 'POST',
                url: window.__env.serviceWorkerUrl + "interface/exportAnualReport",
                responseType: 'arraybuffer',
                data: { headers: headers, data: data, filename: 'Reporte Ajuste Anual', extra: { payroll: $scope.payrollId } }
            }).then(function (response) {
                var headers = response.headers();
                var filename = headers['x-filename'];
                var contentType = headers['content-type'];
                var linkElement = document.createElement('a');
                try {
                    var blob = new Blob([response.data], {
                        type: contentType
                    });
                    var url = window.URL.createObjectURL(blob);
                    linkElement.setAttribute('href', url);
                    linkElement.setAttribute("download", filename);
                    var clickEvent = new MouseEvent("click", {
                        "view": window,
                        "bubbles": true,
                        "cancelable": false
                    });
                    linkElement.dispatchEvent(clickEvent);
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync(function () {
                        $log.debug('generatePdf finished');
                    });
                } catch (ex) {
                    $log.error(ex, "error descargando el archivo");
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                }
            }).catch(function (err) {
                errAlertS(err);
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
            });
        }
        $scope.setNextOrder = function (field, actualOrder) {
            var orderArray = [['data.enroleDate', 'data.name'], field, '-' + field];
            var index = orderArray.indexOf(actualOrder);
            if (index === -1) {
                index = 0;
            }
            var nextIndex = index + 1;
            if (nextIndex >= orderArray.length) {
                nextIndex = 0;
            }
            $scope.order = orderArray[nextIndex];
        };
        $scope.saveFastIncidence = function (employeeId, incidenceTypeId, incidenceQty) {
            var timeIdentifier = new Date().valueOf();
            savingFastIncidences[timeIdentifier] = true;
            var currentFast = [];
            if (angular.isDefined(opObjs.opIncidences) && angular.isArray(opObjs.opIncidences.fb)) {
                currentFast = opObjs.opIncidences.fb.filter(function (item) {
                    return item.employee === employeeId && item.type === 'fast' && item.incidenceType === incidenceTypeId && !item.hasOwnProperty('operationType') && item.status < 3;
                });
            }
            var updates = {};
            if ((incidenceQty <= 0 && !opObjs.conceptsById.fb[incidenceTypeId].allowNegative) || incidenceQty == null || angular.isUndefined(incidenceQty)) {
                for (var c = 0; c < currentFast.length; c++) {
                    updates[currentFast[c].$id] = null;
                }
            } else {
                var affectDays = opObjs.conceptsById.fb[incidenceTypeId].validateDays;
                if (affectDays) {
                    var maxDays = moment(opObjs.period.fb.end).diff(moment(opObjs.period.fb.start), 'days') + 1;
                    if (incidenceQty > maxDays) {
                        incidenceQty = maxDays;
                    }
                    if (incidenceQty > currentFast.length) {
                        var incidences = opObjs.incidencesByEmployee.fb[employeeId];
                        var affectedDate = [];
                        if (angular.isDefined(incidences) && angular.isArray(incidences)) {
                            for (var i = 0; i < incidences.length; i++) {
                                var affect = $filter('getSomethingOfArrayFB')(incidences[i].incidenceType, opObjs.concepts.fb, 'validateDays');
                                if (affect && incidences[i].date) {
                                    affectedDate.push(incidences[i].date);
                                }
                            }
                        }
                        var count = 0;
                        var moreDays = 0;
                        var result = incidenceQty - currentFast.length;
                        while (count < result) {
                            var days = moment(opObjs.period.fb.start).add(moreDays, 'days');
                            var exist = affectedDate.indexOf(days.valueOf());
                            moreDays++;
                            if (exist === -1) {
                                var incidenceKey = AppF.root.child($scope.refs.incidences).push().key;
                                var createIncidence = {
                                    payroll: $scope.payrollId,
                                    period: $scope.periodId,
                                    calendar: $scope.calendarId,
                                    status: 0,
                                    incidenceType: incidenceTypeId,
                                    employee: employeeId,
                                    date: days.valueOf(),
                                    type: 'fast',
                                    value: 1,
                                    center: AppF.center,
                                    comments: 'Incidencia Rápida',
                                    created: DataF.getTimeObject(undefined, undefined, true)
                                };
                                updates[incidenceKey] = createIncidence;
                                count++;
                            }
                        }
                    } else {
                        for (var x = 0; x < currentFast.length; x++) {
                            if ((x + 1) > incidenceQty) {
                                updates[currentFast[x].$id] = null;
                            }
                        }
                    }
                } else if (currentFast.length > 0) {
                    for (var cf = 0; cf < currentFast.length; cf++) {
                        if (cf === 0) {
                            updates[currentFast[cf].$id + '/value'] = incidenceQty;
                            updates[currentFast[cf].$id + '/updated'] = DataF.getTimeObject(undefined, undefined, true);
                        } else {
                            updates[currentFast[cf].$id] = null;
                        }
                    }
                } else if (currentFast.length === 0) {
                    var incidenceId = AppF.root.child($scope.refs.incidences).push().key;
                    var defaultIncidence = {
                        payroll: $scope.payrollId,
                        period: $scope.periodId,
                        calendar: $scope.calendarId,
                        status: 0,
                        incidenceType: incidenceTypeId,
                        employee: employeeId,
                        type: 'fast',
                        value: incidenceQty,
                        center: AppF.center,
                        comments: 'Incidencia Rápida',
                        created: DataF.getTimeObject(undefined, undefined, true)
                    };
                    updates[incidenceId] = defaultIncidence;
                }
            }
            AppF.root.child($scope.refs.incidences).update(updates).then(function () {
                delete savingFastIncidences[timeIdentifier];
            });
        };
        $scope.filterEmployees = function () {
            $scope.selected = [];
            $scope.operationEmployees = $f('filterEmployeesForOperation')(operationEmployeesF, $scope.search);
            $scope.fiscalEmployees = $f('filterEmployeesForOperation')(fiscalEmployeesF, $scope.search);
        };
        $scope.openMenu = function ($mdOpenMenu, ev) {
            $mdOpenMenu(ev);
        };
        $scope.toggle = function (item, list) {
            var idx = list.findIndex(function (employee) {
                return employee.$id === item.$id;
            });
            if (idx > -1) {
                list.splice(idx, 1);
            } else {
                list.push(item);
            }
        };
        $scope.exists = function (item, list) {
            return list.findIndex(function (employee) {
                return employee.$id === item.$id;
            }) > -1;
        };
        $scope.showIncidencesListBottomSheet = function (event, employee) {
            AppF.notCalculate = true;
            var employeesObj;
            if ($scope.tabSelected === 'fiscal') {
                employeesObj = $f('orderBy')($scope.fiscalEmployees, $scope.order);
            } else {
                employeesObj = $f('orderBy')($scope.operationEmployees, $scope.order);
            }
            var employeeIndex = $filter('getIndexFromArray')(employeesObj, '$id', employee.$id);
            $mdBottomSheet.show({
                templateUrl: 'app/main/clients/views/newoperation/dialogs/bottom-incidences.html',
                locals: {
                    employeeIndex: employeeIndex,
                    employees: employeesObj,
                    employee: employee,
                    operation: opObjs.operation.fb,
                    incidencesTypes: opObjs.concepts.fb,
                    incidencesTypesForPayroll: opObjs.incidencesTypes.fb,
                    operationData: opObjs.period.fb,
                    payroll: $scope.payrollId,
                    nextEmployeeStatus: $scope.nextEmployeeStatus,
                    opStatusNotCalc: $scope.opStatusNotCalc,
                    readOnlyMode: $scope.readOnlyMode,
                    operationIsClosed: opObjs.operation.fb.status >= $scope.opStatusNotCalc,
                    allEmployees: allEmployeesO,
                    operationType: undefined
                },
                controller: 'showIncidencesListController',
                parent: '.md-tab-body',
                clickOutsideToClose: false,
                escapeToClose: true,
                targetEvent: event
            }).then(function () {
                //$log.debug(clickedItem)
            }).catch(function (error) {
                $log.debug('Incidences modal closed', error);
            }).then(function () {
                AppF.notCalculate = false;
                $scope.$evalAsync(function () {
                    addForAction('calculate');
                });
            });
        };
        $scope.showCalculationsListBottomSheet = function (event, employeeId) {
            var employeesObj;
            if ($scope.tabSelected === 'fiscal') {
                employeesObj = $f('orderBy')($scope.fiscalEmployees, $scope.order);
            } else {
                employeesObj = $f('orderBy')($scope.operationEmployees, $scope.order);
            }
            var employeeIndex = $filter('getIndexFromArray')(employeesObj, '$id', employeeId);
            $mdBottomSheet.show({
                templateUrl: 'app/main/clients/views/newoperation/dialogs/bottom-calculations.html',
                locals: {
                    employeeIndex: employeeIndex,
                    employees: employeesObj,
                    calculations: $scope.calculations,
                    concepts: opObjs.conceptsByKey.fb
                },
                controller: 'showCalculationsListController',
                parent: '.md-tab-body',
                clickOutsideToClose: false,
                escapeToClose: true,
                targetEvent: event,
                isLockedOpen: true
            }).then(function () {
                //$log.debug(clickedItem);
            }).catch(function (error) {
                $log.debug('Calculations modal closed', error);
            });
        };
        $scope.exportToExcel = function () {
            var dataToExport = angular.toJson($filter('generateIncidencesToImportV2')(operationEmployeesF, allEmployeesO, opObjs.payroll.fb, opObjs.period.fb, $scope.calendarId, opObjs.conceptsById.fb));
            var data = {
                data: dataToExport
            };
            CatalogsF.exportToExcel('interface/exportDataToCSV', data);
        };
        $scope.exportReportPayroll = function () {
            var conceptsById = opObjs.conceptsById.fb;
            var calc = $scope.calculations;
            var headers = [];
            var employees = {};
            var valueObjs = {
                'real': ['value', 'rejectedIncidences', 'valueNoRejected'],
                'fiscal': ['fiscalValue', 'fiscalValueRejected', 'fiscalValueNoRejected'],
                'socialPrevision': ['socialPrevisionValue', 'socialPrevisionValueRejected', 'socialPrevisionValueNoRejected']
            };
            var headersField = {
                rejectedIncidences: 'valueRejected'
            }
            var totalObj = {};
            var totalAmountObj = {};
            var process = $scope.process.filter(function (item) {
                return ['rejectedIncidences'].indexOf(item.id) === -1;
            }).map(function (item) {
                return angular.copy(item);
            });
            var uniqueP = process.filter(function (item) {
                return ['real'].indexOf(item.id) === -1;
            });
            if (uniqueP.length === 1 && uniqueP[0].id === 'fiscal') {
                process = uniqueP;
            }
            process.forEach(function (thisProcess) {
                if (!totalObj[thisProcess.id]) {
                    totalObj[thisProcess.id] = {};
                    totalAmountObj[thisProcess.id] = { totals: [] };
                }
                if (angular.isArray(thisProcess.totals) && thisProcess.totals.length > 0) {
                    var totals = $filter('orderBy')(thisProcess.totals, 'order');
                    totals.forEach(function (total) {
                        if ($scope.operationTotals.hasOwnProperty(total.$id)) {
                            var operation = total.operation ? total.operation + 1 : 1;
                            totalAmountObj[thisProcess.id]['totals'].push({ name: total.name, total: $scope.operationTotals[total.$id][total.field] * operation });
                        } else {
                            totalAmountObj[thisProcess.id]['totals'].push({ name: total.name });
                        }
                    });
                }
                if (angular.isArray(thisProcess.concepts)) {
                    if (angular.isArray(thisProcess.extras)) {
                        thisProcess.extras.forEach(function (extra) {
                            extra.order = extra.order * 100;
                        });
                        thisProcess.concepts = thisProcess.concepts.concat(thisProcess.extras);
                    }
                    var thisProConcepts = thisProcess.concepts.filter(function (item) {
                        return item.$id && (!item.hiddenColumn || item.showOnReport);
                    });
                    if (thisProConcepts.length > 0) {
                        thisProConcepts.sort(function (a, b) {
                            return a.order - b.order;
                        })
                        var newConcepts = [
                            { name: "NO.", key: "number", order: -5 },
                            { name: "NOMBRE", key: "name", order: -3 },
                            { name: "CC", key: "cc", order: -2 },
                            { name: "PLAZA", key: "place", order: -1.8 },
                            { name: "DEPARTAMENTO", key: "department", order: -1.7 },
                            { name: "PUESTO", key: "position", order: -1.5 }
                        ];
                        if (thisProcess.id !== 'socialPrevision') {
                            newConcepts.splice(1, 0, { name: "NSS", key: "nss", order: -4 });
                        }
                        var procConcepts = {};
                        var payrollWithSubtotals = opObjs.payroll.fb.subtotal;
                        var newOrder = payrollWithSubtotals ? ['data.cc'].concat($scope.order) : $scope.order;
                        var employeesSort = $filter('orderBy')(operationEmployeesF, newOrder);
                        var subtotals = {};
                        var lastEmployeeIndex = undefined;
                        var hasAnyDepartment = false;
                        employeesSort.forEach(function (employeeSort, es) {
                            var employeeId = employeeSort.$id;
                            var employee = allEmployeesO[employeeId];
                            var employeeCalculation = calc[employee.$id] || {};
                            if (angular.isString(employee.departmentName)) {
                                hasAnyDepartment = true;
                            }
                            if (thisProcess.id !== "fiscal" || employee.isFiscal) {
                                if (!employees[employeeId]) {
                                    employees[employeeId] = {
                                        number: $filter("getFromObject")(employee, "data.employeeNumber", "N/A"),
                                        nss: employee.data.nss || '',
                                        name: employee.data.name,
                                        cc: employee.ccData.data.name,
                                        place: $filter("getFromObject")(employee, "ccPlace.name", "Sin plaza"),
                                        position: employee.positionData.name,
                                        department: employee.departmentName || 'Sin departamento',
                                        order: es,
                                        c: {}
                                    };
                                    if (employee.isFiscal) {
                                        employees[employeeId].isFiscal = true;
                                    }
                                }
                                thisProConcepts.forEach(function (concept, t) {
                                    var thisConcept = conceptsById[concept.$id] || concept;
                                    var name = concept.name || thisConcept.name;
                                    if (!procConcepts[name]) {
                                        procConcepts[name] = true;
                                        newConcepts.push({ name: name, order: t, key: thisProcess.id });
                                    }
                                    var total;
                                    if (thisConcept.key === 'perceptions' || thisConcept.key === 'fiscalPerceptions') {
                                        total = $filter('getFromObject')(employeeCalculation[thisConcept.key], 'wSalary.result');
                                        if (!totalObj[thisProcess.id][name]) {
                                            totalObj[thisProcess.id][name] = $filter('getFromObject')($scope.operationTotals[concept.$id], 'wSalary', 0);
                                        }
                                    } else {
                                        var valuesFields = thisConcept.type === 'incidenceType' ? valueObjs[thisProcess.id] : valueObjs.real;
                                        var rejectedName = name + ' RECHAZADO';
                                        if (!totalObj[thisProcess.id][name]) {
                                            if (thisConcept.showTotal) {
                                                var rejectedField = headersField[valuesFields[1]] || valuesFields[1];
                                                var rejectedT = thisConcept.nature === 'deduction' ? $filter('getFromObject')($scope.operationTotals[concept.$id], rejectedField, 0) : 0;
                                                if (thisConcept.nature === 'deduction' && rejectedT > 0) {
                                                    var noRejectedT = $filter('getFromObject')($scope.operationTotals[concept.$id], valuesFields[2], 0);
                                                    totalObj[thisProcess.id][rejectedName] = rejectedT;
                                                    totalObj[thisProcess.id][name] = noRejectedT;
                                                } else {
                                                    totalObj[thisProcess.id][name] = $filter('getFromObject')($scope.operationTotals[concept.$id], valuesFields[0], 0);
                                                }
                                            } else {
                                                totalObj[thisProcess.id][name] = "#isEmpty";
                                            }
                                        }
                                        var rejected = $filter('getFromObject')(employeeCalculation[thisConcept.key], valuesFields[1] + '.result', 0);
                                        if (rejected > 0) {
                                            total = $filter('getFromObject')(employeeCalculation[thisConcept.key], valuesFields[2] + '.result');
                                            if (!procConcepts[rejectedName]) {
                                                procConcepts[rejectedName] = true;
                                                newConcepts.push({ name: rejectedName, order: t - 0.5, key: thisProcess.id + "Rejected" });
                                            }
                                            if (!employees[employeeId].c[rejectedName]) {
                                                employees[employeeId].c[rejectedName] = {};
                                            }
                                            // if (rejected > total) {
                                            //     rejected = total;
                                            // }
                                            employees[employeeId].c[rejectedName][thisProcess.id + "Rejected"] = rejected;
                                        } else {
                                            total = $filter('getFromObject')(employeeCalculation[thisConcept.key], valuesFields[0] + '.result');
                                        }
                                    }
                                    if (angular.isDefined(total)) {
                                        employees[employeeId].c[name] = employees[employeeId].c[name] || {};
                                        employees[employeeId].c[name][thisProcess.id] = total;
                                        if (payrollWithSubtotals && thisConcept.showTotal) {
                                            subtotals[employeeSort.data.cc] = subtotals[employeeSort.data.cc] || {};
                                            subtotals[employeeSort.data.cc][name] = subtotals[employeeSort.data.cc][name] || 0;
                                            subtotals[employeeSort.data.cc][name] = subtotals[employeeSort.data.cc][name] + total;
                                        }
                                    }
                                    if (payrollWithSubtotals) {
                                        var previousEmployeeCc = angular.isDefined(lastEmployeeIndex) ? employeesSort[lastEmployeeIndex].data.cc : undefined;
                                        if (angular.isDefined(previousEmployeeCc) && previousEmployeeCc !== employeeSort.data.cc) {
                                            var isFiscal1 = allEmployeesO[employeesSort[lastEmployeeIndex].$id].rpData.data.name !== '00000000000' ? true : false;
                                            employees[previousEmployeeCc] = employees[previousEmployeeCc] || {
                                                order: es - .5,
                                                name: "#isSubtotal#SUBTOTAL " + allEmployeesO[employeesSort[lastEmployeeIndex].$id].ccData.data.name,
                                                number: "#isNull",
                                                nss: "#isNull",
                                                cc: '#isNull',
                                                isFiscal: isFiscal1,
                                                position: '#isNull',
                                                place: '#isNull',
                                                department: '#isNull',
                                                c: {}
                                            }
                                            employees[previousEmployeeCc].c[name] = employees[previousEmployeeCc].c[name] || {};
                                            employees[previousEmployeeCc].c[name][thisProcess.id] = $filter("getFromObject")(subtotals, previousEmployeeCc + "." + name, thisConcept.showTotal ? 0 : "#isEmpty");
                                        }
                                        if ((employeesSort.length - 1) === es) {
                                            var isFiscal2 = allEmployeesO[employeeSort.$id].rpData.data.name !== '00000000000' ? true : false;
                                            employees[employee.cc] = employees[employee.cc] || {
                                                order: es + .5,
                                                name: "#isSubtotal#SUBTOTAL " + employee.ccData.data.name,
                                                number: "#isNull",
                                                nss: "#isNull",
                                                cc: '#isNull',
                                                isFiscal: isFiscal2,
                                                position: '#isNull',
                                                place: '#isNull',
                                                department: '#isNull',
                                                c: {}
                                            };
                                            employees[employee.cc].c[name] = employees[employee.cc].c[name] || {};
                                            employees[employee.cc].c[name][thisProcess.id] = $filter("getFromObject")(subtotals, employee.cc + "." + name, thisConcept.showTotal ? 0 : "#isEmpty");
                                        }
                                    }
                                });
                                lastEmployeeIndex = es;
                            }
                        });
                        if (!hasAnyDepartment) {
                            var indexDepartment = newConcepts.findIndex(function (item) {
                                return item.key === 'department';
                            })
                            if (indexDepartment > -1) {
                                newConcepts.splice(indexDepartment, 1)
                            }
                        }
                        if (totalObj[thisProcess.id]) {
                            Object.keys(totalObj[thisProcess.id]).forEach(function (tt) {
                                var index = newConcepts.findIndex(function (value) {
                                    return value.name === tt;
                                });
                                if (index > -1 && angular.isDefined(totalObj[thisProcess.id][tt])) {
                                    if (angular.isArray(totalObj[thisProcess.id][tt])) {
                                        if (totalObj[thisProcess.id][tt].length > 0) {
                                            newConcepts[index].totalBill = totalObj[thisProcess.id][tt];
                                        }
                                    } else {
                                        newConcepts[index].totalAmount = totalObj[thisProcess.id][tt];
                                    }
                                }
                            });
                        }
                        newConcepts.sort(function (a, b) {
                            return a.order - b.order;
                        });
                        var objH = { name: thisProcess.name, key: thisProcess.id, concepts: newConcepts };
                        if (thisProcess.alias) {
                            objH.alias = thisProcess.alias;
                        }
                        if (totalAmountObj[thisProcess.id]['totals'].length > 0) {
                            objH.totals = totalAmountObj[thisProcess.id]['totals'];
                        }
                        headers.push(objH);
                    }
                }
            });
            var promises = [];
            var processId = [];
            headers.forEach(function (header) {
                if (['fiscal', 'socialPrevision'].indexOf(header.key) > -1) {
                    promises.push($filter('getCompaniesName')($scope.payrollId, header.name));
                    processId.push(header.name);
                }
            });

            Promise.all(promises).then(function (response) {
                if (response.length > 0) {
                    response.forEach(function (businessName, r) {
                        if (businessName.data) {
                            var indexH = headers.findIndex(function (value) {
                                return value.name === processId[r];
                            });
                            if (indexH > -1) {
                                headers[indexH].companiesRecord = businessName.data.businessName;
                            }
                        } else {
                            throw businessName.message;
                        }
                    });
                    var employeesTemp = Object.keys(employees).sort(function (a, b) {
                        return employees[a].order - employees[b].order;
                    }).map(function (item) {
                        return employees[item];
                    });
                    employees = employeesTemp;
                    var thisCalendar = $filter('getFromObject')(opObjs.operation.fb, 'calendar') ? '_' + opObjs.operation.fb.calendar : '';
                    var thisPeriod = $filter('getFromObject')(opObjs.operation.fb, 'period') ? '_' + $filter('zeroFill')(opObjs.operation.fb.period, 2) : '';
                    var thisCenter = AppF.center.toUpperCase();
                    var thisFileName = 'TOT_' + thisCenter + thisCalendar + '_' + opObjs.payroll.fb.data.class + '_' + opObjs.payroll.fb.data.name + thisPeriod;

                    var dataObj = {
                        info: {
                            payroll: opObjs.payroll.fb.data.class + ' ' + opObjs.payroll.fb.data.name + ' [' + $filter('getSomethingOfArrayM')(opObjs.payroll.fb.paymentFrequency, $scope.M.paymentFrequenciesRecords, 'name') + ']',
                            date: 'Incidencias del ' + $filter('date')(opObjs.period.fb.start, AppF.dateFormat) + ' al ' + $filter('date')(opObjs.period.fb.end, AppF.dateFormat),
                            period: 'Periodo ' + ($filter("getFromObject")(opObjs.operation.fb, "period") ? (opObjs.operation.fb.period > 9 ? opObjs.operation.fb.period : "0" + opObjs.operation.fb.period) : '')
                        },
                        footer: angular.toJson([{}, {}, {}, {}, { "NOMBRE": '#stylefooterstyle#LIC. ' + $filter('uppercased')(AppF.profile.data.name) }, { "NOMBRE": "#stylefooterstyle#EJECUTIVO DE CUENTAS" }]),
                        headers: angular.toJson(headers),
                        data: angular.toJson(employees),
                        filename: thisFileName
                    };
                    downloadFile("interface/exportDataWithMultiHeader", dataObj);
                } else {
                    throw "No se encontró ningún proceso";
                }
            }).catch(function (error) {
                errAlertS(error);
            });
        };
        function sendBillByEmail(id, employeeId) {
            var employee = allEmployeesO[employeeId];
            return $http.get(window.__env.serviceWorkerUrl + 'sendBillOfEmployee/' + id + '?companiesRecordId=' + employee.rpData.companiesRecord).then(function (resp) {
                $log.log(resp);
                successAlertS(resp.data);
            }).catch(errAlertS);
        }
        $scope.sendManyByEmail = function (selected) {
            if (angular.isArray(selected) && selected.length > 0) {
                for (var e = 0; e < selected.length; e++) {
                    var billId = $filter('getFromObject')($scope.operation.employees, selected[e].$id + ".billId");
                    if (angular.isUndefined(billId)) {
                        errAlertS('El empleado ' + allEmployeesO[selected[e].$id].data.name + ' no tiene el recibo');
                    } else {
                        sendBillByEmail(billId, selected[e].$id)
                    }
                }
            } else {
                errAlertS("No se selecciono ningún empleado")
            }
        }
        $scope.generateAccountingAccount = function () {
            var process = $scope.process.find(function (process) {
                return process.id === $scope.tabSelected;
            });
            if (!process) {
                errAlertS('No se encontró el nombre del proceso');
                return false;
            }
            var data = {
                operationType: 'ordinary',
                operationId: opObjs.operation.fb.$id,
                dispersionId: opObjs.operation.fb.dispersion,
                payrollId: $scope.payrollId,
                calendar: $filter('getFromObject')(opObjs.operation.fb, 'calendar'),
                period: $filter('getFromObject')(opObjs.operation.fb, 'period'),
                process: process.id
            }
            $scope.C.exportToExcel('interface/exportAnyFiles', { data: angular.toJson([data]), nameF: 'exportAccount' });

        }

        $scope.generateAccountingAccountBy2 = function (process) {
            console.log('proceso', process)
            var data = {
                operationType: 'ordinary',
                operationId: opObjs.operation.fb.$id,
                dispersionId: opObjs.operation.fb.dispersion,
                payroll: $scope.payrollId,
                payrollId: $scope.payrollId,
                calendar: $filter('getFromObject')(opObjs.operation.fb, 'calendar'),
                downloading: false,
                period: $filter('getFromObject')(opObjs.operation.fb, 'period'),
                process: process,
                processName: process.toUpperCase()
            }
            $scope.C.exportToExcel('interface/exportAccountingAccounts', { data: angular.toJson([data]), nameF: 'exportAccount' });
        };


        $scope.generateAccountingAccountCompaq = function (process) {
            $rootScope.loadingProgress = true;
            var data = {
                operationType: 'ordinary',
                operationId: opObjs.operation.fb.$id,
                dispersionId: opObjs.operation.fb.dispersion,
                payroll: $scope.payrollId,
                payrollId: $scope.payrollId,
                calendar: $filter('getFromObject')(opObjs.operation.fb, 'calendar'),
                downloading: false,
                period: $filter('getFromObject')(opObjs.operation.fb, 'period'),
                process: process,
                processName: process.toUpperCase()
            }
            var obj = {
                data: angular.toJson([data]),
                nameF: 'exportAccount'
            };
            console.log(obj)
            var path = 'interface/exportAccountingAccountsCompaq';
            $rootScope.C.exportToExcel(path, obj, true).then(function () {
                data.downloadingLayout = false;
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync()
            }).catch(function () {
                data.downloadingLayout = false;
                $scope.$evalAsync()
            });
        }







        $scope.exportPaymentForms = function () {
            var process = $scope.process.find(function (process) {
                return process.id === $scope.tabSelected;
            });
            if (!process) {
                errAlertS('No se encontró el nombre del proceso');
                return false;
            }
            var type = process.name;
            var employees = $f('orderBy')($scope.fiscalEmployees, $scope.order);
            if ($scope.tabSelected === 'socialPrevision') {
                employees = $f('orderBy')($scope.operationEmployees, $scope.order);
            }
            $filter('getCompaniesName')($scope.payrollId, type, { function: 'paymentForm', name: 'banks' }).then(function (response) {
                var businessName = response;
                if (angular.isDefined(businessName.data)) {
                    var complements = (process.alias) ? process.alias : process.name;
                    var data = getDataForPaymentForms(complements, employees, response.banks.bankAccounts, process.id);
                    $log.log('forma de pago xx', data)
                    var error = angular.fromJson(angular.toJson(data.error));
                    delete data.error;
                    if (data.footer.totalEmployees > 0) {
                        $rootScope.loadingProgress = true;
                        var thisCalendar = $filter('getFromObject')(opObjs.operation.fb, 'calendar') ? '_' + opObjs.operation.fb.calendar : '';
                        var thisPeriod = $filter('getFromObject')(opObjs.operation.fb, 'period') ? '_' + $filter('zeroFill')(opObjs.operation.fb.period, 2) : '';
                        var thisCenter = AppF.center.toUpperCase();
                        data.filename = "RFP_" + businessName.data.name + "_" + thisCenter + thisCalendar + '_' + opObjs.payroll.fb.data.class + '_' + opObjs.payroll.fb.data.name + thisPeriod
                        data.header.businessName = businessName.data.businessName;
                        var params = {
                            data: angular.toJson(data)
                        }
                        $http({
                            method: 'POST',
                            url: window.__env.serviceWorkerUrl + "interface/pdf/operations/paymentForms",
                            responseType: 'arraybuffer',
                            data: params
                        }).then(function (response) {
                            var headers = response.headers();
                            var filename = headers['x-filename'];
                            var contentType = headers['content-type'];
                            var linkElement = document.createElement('a');
                            try {
                                var blob = new Blob([response.data], {
                                    type: contentType
                                });
                                var url = window.URL.createObjectURL(blob);
                                linkElement.setAttribute('href', url);
                                linkElement.setAttribute("download", filename);
                                var clickEvent = new MouseEvent("click", {
                                    "view": window,
                                    "bubbles": true,
                                    "cancelable": false
                                });
                                linkElement.dispatchEvent(clickEvent);
                                $rootScope.loadingProgress = false;
                                $rootScope.$evalAsync(function () {
                                    $log.debug('generatePdf finished');
                                });
                            } catch (ex) {
                                $log.error(ex, "error descargando el archivo");
                                $rootScope.loadingProgress = false;
                                $rootScope.$evalAsync();
                            }
                        }).catch(function (err) {
                            errAlertS(err);
                            $rootScope.loadingProgress = false;
                            $rootScope.$evalAsync();
                        });
                        for (var i = 0; i < error.length; i++) {
                            errAlertS(error[i]);
                        }
                    } else {
                        if (Object.keys(data.body).length === 0 && error.length === 0) {
                            errAlertS('No se encontró ningún empleado con la cuenta seleccionada');
                        }
                        errAlertS(error);
                    }
                } else {
                    errAlertS(businessName.message);
                }
            }).catch(function (error) {
                errAlertS(error);
            });
        }


        $scope.exportDispersionPaymentForms = function () {
            var process = $scope.process.find(function (process) {
                return process.id === $scope.tabSelected;
            });
            if (!process) {
                errAlertS('No se encontró el nombre del proceso');
                return false;
            }
            var type = process.name;
            var employees = $f('orderBy')($scope.fiscalEmployees, $scope.order);
            if ($scope.tabSelected === 'socialPrevision') {
                employees = $f('orderBy')($scope.operationEmployees, $scope.order);
            }
            $filter('getCompaniesName')($scope.payrollId, type, { function: 'paymentForm', name: 'banks' }).then(function (response) {
                var businessName = response;
                if (angular.isDefined(businessName.data)) {
                    var complements = (process.alias) ? process.alias : process.name;
                    var data = getDataForPaymentForms(complements, employees, response.banks.bankAccounts, process.id);
                    var error = angular.fromJson(angular.toJson(data.error));
                    $log.log('datos', data)
                    if (data.footer.totalEmployees > 0) {
                        $rootScope.loadingProgress = true
                        var path = 'employees/downloadFileDispersion'
                        ApiV3F.exportToExcel(path, data).then(function (resp) {
                            $log.log(resp)
                            if (resp) {
                                $rootScope.loadingProgress = false;
                                $rootScope.$evalAsync(function () {
                                    $log.debug('generatePdf finished');
                                });
                                successAlertS('Se ha descargado el archivo correctamente');
                            }
                        }).catch(function (error) {
                            $rootScope.loadingProgress = false;
                            $rootScope.$evalAsync(function () {
                                $log.debug('generatePdf finished');
                            })
                            errAlertS(error);
                        })
                    } else {
                        if (Object.keys(data.body).length === 0 && error.length === 0) {
                            errAlertS('No se encontró ningún empleado con la cuenta seleccionada');
                        }
                        for (var i = 0; i < error.length; i++) {
                            errAlertS(error[i]);
                        }
                    }
                } else {
                    if (businessName.message) {
                        errAlertS(businessName.message);
                    }
                }
            })
        }




        function getDataForPaymentForms(type, employees, banksAccountId, processId) {
            var data = {
                header: {
                    payroll: opObjs.payroll.fb.data.name,
                    class: opObjs.payroll.fb.data.class,
                    type: 'Formas de Pago Nomina',
                    period: opObjs.period.fb.period,
                    dateStart: opObjs.period.fb.startString,
                    dateEnd: opObjs.period.fb.endString,
                    process: type,
                    date: moment().format('DD/MM/YYYY'),
                    hour: moment().format('HH:mm:ss'),
                    businessName: []
                },
                body: {},
                footer: {},
                error: []
            };
            var calc = $scope.calculations;
            var paymentForms = $scope.M.paymentForms;
            var paymentFormsObj = {};
            var totalObj = {};
            for (var p = 0; p < paymentForms.length; p++) {
                if (angular.isUndefined(data.body[paymentForms[p].name])) {
                    data.body[paymentForms[p].name] = {};
                }
                paymentFormsObj[paymentForms[p]._id] = {
                    name: paymentForms[p].name
                }
                if (angular.isUndefined(totalObj[paymentForms[p].name])) {
                    totalObj[paymentForms[p].name] = {};
                }
            }
            data.body['SPEI'] = {};
            totalObj['SPEI'] = {};
            var banksObj = {};
            if (angular.isArray(banksAccountId)) {
                for (var b = 0; b < banksAccountId.length; b++) {
                    var bankId = $scope.M.bankAccounts.find(function (value) {
                        return value._id === banksAccountId[b];
                    });
                    if (angular.isDefined(bankId) && !bankId.isSpei) {
                        var bankName = $scope.M.banks.find(function (value) {
                            return value._id === bankId.bank;
                        });
                        if (angular.isDefined(bankName)) {
                            if (angular.isUndefined(banksObj[bankName.name])) {
                                banksObj[bankName.name] = {}
                            }
                        }
                    }
                }
            }
            for (var i = 0; i < employees.length; i++) {
                var employee = allEmployeesO[employees[i].$id];
                // var total = ($scope.tabSelected === 'fiscal') ? calc[employee.$id].fiscalTotal.value.result : calc[employee.$id].socialPrevisionTotal.value.result;
                var totals = $filter('discountDispersionExempts')(calc[employee.$id], $scope.tabSelected);
                var total = totals.totalNoExempts;
                if (total > 0) {
                    try {
                        if (!$filter("getFromObject")(employee, "data.employeeNumber", false)) {
                            throw 'El empleado ' + employee.data.name + ' no tiene asignado un numero de empleado';
                        }
                        var defaultPaymentForm = paymentForms.find(function (value) {
                            return value.key === 'transfer';
                        });
                        var employeePaymentForm = $filter('getEmployeePaymentForm')(employee.paymentForms, processId)
                        if (angular.isDefined(paymentFormsObj[employeePaymentForm || defaultPaymentForm._id])) {
                            var payment = paymentFormsObj[employeePaymentForm || defaultPaymentForm._id].name;
                            if (angular.isUndefined(employeePaymentForm) || employeePaymentForm === defaultPaymentForm._id) {
                                var card = $f('getEmployeeAccount')(employee, $scope.tabSelected, 'ordinary', defaultPaymentForm._id);
                                var account = card.number;
                                var bank = $scope.M.banks.find(function (value) {
                                    return value._id === card.bank;
                                });
                                if (bank) {
                                    var max = (banksObj.hasOwnProperty(bank.name)) ? (angular.isDefined(bank.accountLength) ? [bank.accountLength] : [10, 11]) : [18];

                                    var movementType = (banksObj.hasOwnProperty(bank.name)) ? 'la transferencia' : 'SPEI';
                                    if (max.indexOf(account.toString().length) === -1) {
                                        throw 'El empleado ' + employee.data.name + ' no tiene cuenta asignada para ' + movementType;
                                    }
                                } else {
                                    throw 'El empleado ' + employee.data.name + ' no tiene asignado un banco a la cuenta';
                                }
                                payment = (banksObj.hasOwnProperty(bank.name)) ? payment : 'SPEI';
                                if (angular.isUndefined(data.body[payment][bank.name])) {
                                    data.body[payment][bank.name] = {
                                        body: [],
                                        footer: {}
                                    };
                                }
                                if (angular.isUndefined(totalObj[payment][bank.name])) {
                                    totalObj[payment][bank.name] = 0;
                                }
                                if (angular.isUndefined(totalObj[payment].TOTALEMPLOYEES)) {
                                    totalObj[payment].TOTALEMPLOYEES = 0;
                                }
                                totalObj[payment].TOTALEMPLOYEES++;
                                totalObj[payment][bank.name] = totalObj[payment][bank.name] + total;

                                var obj = {
                                    number: employee.data.employeeNumber,
                                    name: employee.data.name,
                                    account: account,
                                    total: $filter('number')(total, 2)
                                };
                                data.body[payment][bank.name].body.push(obj);
                                data.body[payment][bank.name].footer = {
                                    employees: data.body[payment][bank.name].body.length, total: $filter('number')(totalObj[payment][bank.name], 2)
                                }
                            } else {
                                if (angular.isUndefined(totalObj[payment].TOTAL)) {
                                    totalObj[payment].TOTAL = 0;
                                }
                                if (angular.isUndefined(totalObj[payment].TOTALEMPLOYEES)) {
                                    totalObj[payment].TOTALEMPLOYEES = 0;
                                }
                                if (angular.isUndefined(data.body[payment].body)) {
                                    data.body[payment] = {
                                        body: [],
                                        footer: {}
                                    }
                                }
                                totalObj[payment].TOTALEMPLOYEES++;
                                totalObj[payment].TOTAL = totalObj[payment].TOTAL + total;
                                data.body[payment].body.push({
                                    number: employee.data.employeeNumber,
                                    name: employee.data.name,
                                    total: $filter('number')(total, 2)
                                });
                                data.body[payment].footer = {
                                    employees: data.body[payment].body.length, total: $filter('number')(totalObj[payment].TOTAL, 2)
                                };
                            }
                        }
                    } catch (error) {
                        data.error.push(error);
                    }
                }
            }
            var allEmployees = 0;
            var totalGeneral = 0;
            for (var c in totalObj) {
                if ($filter('objectsLength')(data.body[c]) > 0 && angular.isDefined(totalObj[c].TOTALEMPLOYEES)) {
                    allEmployees = allEmployees + totalObj[c].TOTALEMPLOYEES;
                    totalGeneral = totalGeneral + ((totalObj[c].TOTAL) ? totalObj[c].TOTAL : 0)
                    if (angular.isUndefined(totalObj[c].TOTAL)) {
                        var tots = 0;
                        for (var t in totalObj[c]) {
                            if (t !== 'TOTALEMPLOYEES') {
                                tots = tots + totalObj[c][t];
                            }
                        }
                        data.body[c].totals = { totalAmount: $filter('number')(tots, 2) };
                        totalGeneral = totalGeneral + tots;
                    }
                } else {
                    delete data.body[c];
                }
            }
            data.footer = {
                totalEmployees: allEmployees,
                totalGeneral: $filter('number')(totalGeneral, 2)
            }
            return data;
        }
        $scope.allHave = function (selected, path) {
            var allHave = false;
            if (angular.isArray(selected) && selected.length > 0) {
                allHave = true;
                for (var e = 0; e < selected.length && allHave; e++) {
                    var value = $filter('getFromObject')($scope.operation.employees, selected[e].$id + "." + path)
                    if (angular.isUndefined(value)) {
                        allHave = false;
                    }
                }
            }
            return allHave;
        }
        $scope.startToBill = function (ev) {
            billOperationS(ev, $scope, opObjs);
        }
        function getFileRequest(publicLink) {
            return new Promise(function (resolve, reject) {
                var xhr = new XMLHttpRequest();
                xhr.responseType = 'blob';
                xhr.onload = function () {
                    var blob = xhr.response;
                    resolve(blob);
                };
                xhr.open('GET', publicLink);
                xhr.send();
                xhr.addEventListener('error', reject);
                xhr.addEventListener('abort', reject);
            })
        }
        function cancelThisBill(uuid, dontStopLoading) {
            return new Promise(function (resolve) {
                ApiV3F.post('employees/cancelBill', { "uuid": uuid }).then(function (resp) {
                    if (!dontStopLoading) {
                        $rootScope.loadingProgress = false;
                    }
                    successAlertS(resp.data);
                    resolve(true);
                }).catch(function (error) {
                    if (!dontStopLoading) {
                        $rootScope.loadingProgress = false;
                    }
                    $log.error(error);
                    errAlertS(error);
                    resolve(false);
                })
            });
        }
        $scope.directCancel = function (uuid, ev) {
            $mdDialog.show($mdDialog
                .confirm(confirmConfig)
                .title('¿Desea cancelar la factura?')
                .htmlContent('Se va a cancelar la factura que no se puedo cancelar en el re timbrado anterior')
                .ariaLabel('Deleting')
                .targetEvent(ev)
                .ok('SI')
                .cancel('NO'))
                .then(function () {
                    cancelThisBill(uuid);
                }, function () {
                    $log.debug('Deleting Cancelled');
                });
        };
        $scope.cancelToBill = function (selected, ev) {
            var title = "Esta seguro de cancelar la factura?"
            var msg = "La factura que se cancelara ya no tendrá validez, esta es una cancelación definitiva, si necesitas la factura, utiliza la opción de retimbrar";
            if (!angular.isArray(selected) || selected.length === 0) {
                title = "Esta seguro de cancelar todas las facturas?"
                msg = "Todas las facturas de esta operación sera canceladas y no tendrán validez, esta es una cancelación definitiva, si necesitas la factura, utiliza la opción de retimbrar";
            }
            $mdDialog.show($mdDialog
                .confirm(confirmConfig)
                .title(title)
                .htmlContent(msg)
                .ariaLabel('Deleting')
                .targetEvent(ev)
                .ok('SI')
                .cancel('NO'))
                .then(function () {
                    $rootScope.loadingProgress = true;
                    $scope.operation.$loaded().then(function () {
                        var promises = [];
                        var thisEmployees = !angular.isArray(selected) || selected.length === 0 ? $scope.fiscalEmployees : selected;
                        for (var t = 0; t < thisEmployees.length; t++) {
                            var uuid = $scope.operation.employees[thisEmployees[t].$id].billId
                            if (angular.isDefined(uuid) && $scope.operation.employees[thisEmployees[t].$id].status !== 3.5) {
                                promises.push(cancelThisBill(uuid, true));
                            }
                        }
                        return Promise.all(promises);
                    }).then(function () {
                        successAlertS("Se termino el proceso de cancelación de las facturas");
                    }).catch(function (error) {
                        $log.error(error);
                    }).then(function () {
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync();
                        $timeout(function () { }, 0, false);
                    });
                }, function () {
                    $log.debug('Deleting Cancelled');
                });
        }

        $scope.downloadManyFiles = function (selected, file) {
            if (angular.isArray(selected) && selected.length > 0) {
                var promises = [];
                var promisesIndex = [];
                for (var e = 0; e < selected.length; e++) {
                    var bucketUrl = $filter('getFromObject')($scope.operation.employees, selected[e].$id + "." + file);
                    var fileName = $filter('getFromObject')($scope.operation.employees, selected[e].$id + ".fileName");
                    if (angular.isUndefined(bucketUrl)) {
                        errAlertS('El empleado ' + allEmployeesO[selected[e].$id].data.name + ' no tiene la url definida');
                    } else {
                        promises.push(firebase.storage().ref().child(bucketUrl).getDownloadURL());
                        promisesIndex.push(fileName)
                    }
                }
                Promise.all(promises).then(function (resp) {
                    promises = [];
                    for (var r = 0; r < resp.length; r++) {
                        promises.push(getFileRequest(resp[r]));
                    }
                    return Promise.all(promises);
                }).then(function (blobs) {
                    for (var b = 0; b < blobs.length; b++) {
                        var url = window.URL.createObjectURL(blobs[b]);
                        var linkElement = document.createElement('a');
                        linkElement.setAttribute('href', url);
                        linkElement.setAttribute('download', promisesIndex[b]);
                        var clickEvent = new MouseEvent("click", {
                            "view": window,
                            "bubbles": true,
                            "cancelable": false
                        });
                        linkElement.dispatchEvent(clickEvent);
                    }
                }).catch(function (error) {
                    $log.error(error);
                    errAlertS('Error al obtener los archivos')
                });
            } else {
                errAlertS("No se selecciono ningún empleado")
            }
        }
        function buildCtx(periodOverride) {
            return {
                periodEnd: opObjs.period.fb.end,
                serverTime: $scope.D.getCurrentServerTime(),
                processes: $scope.process,
                payrollId: $scope.payrollId,
                banksAccounts: $scope.M.bankAccounts,
                banks: $scope.M.banks,
                fiscalEmployees: $scope.fiscalEmployees,
                operationEmployees: $scope.operationEmployees,
                order: $scope.order,
                tabSelected: $scope.tabSelected,
                allEmployeesO: allEmployeesO,
                payroll: opObjs.payroll,
                period: opObjs.period,
                periodOverride: periodOverride,
                calendar: opObjs.operation.fb.calendar,
                opProcessList: opObjs.process.fb,
                calc: $scope.calculations,
                paymentForms: $scope.M.paymentForms,
                operationType: $scope.operationType,
                serviceWorkerUrl: window.__env.serviceWorkerUrl,
                addUtf8BomForCsv: true
            };
        }

        $scope.layoutBanks = function (event, bankAccount, employeesSelected) {
            var ctx = buildCtx(undefined);
            BankLayoutFlow.run(event, bankAccount, employeesSelected, ctx).catch(function (err) {
                errAlertS(err);
            });
        };

        function addDate(params) {
            console.log(params)
            var bank = params.bank;
            var maxDate = AppF.holydaysInMexico.getDateOfXLabourDaysFromNow(15, opObjs.period.fb.end).date;
            var event = params.event;
            var minDate;
            if ($f('lowercase')(bank.name) === 'hsbc') {
                minDate = moment($scope.D.getCurrentServerTime()).toDate();
            } else {
                minDate = AppF.holydaysInMexico.getDateOfXLabourDaysSinceNow(15, opObjs.period.fb.end).date;
            }
            $mdDialog.show({
                templateUrl: 'app/main/clients/views/newoperation/dialogs/date.html',
                locals: {
                    minDate: minDate,
                    maxDate: maxDate
                },
                controller: function (scope, minDate, maxDate) {
                    scope.bank = params.bank;
                    scope.minDate = minDate;
                    scope.maxDate = maxDate;
                    scope.layoutBanks = function (thisParams) {
                        $log.log('extra parametros x: ', thisParams)
                        params.extraParams = thisParams;
                        layoutBanks(params);
                        scope.cancel();
                    }
                    scope.onlyWeekendsPredicate = function (date) {
                        var day = date.getDay();
                        return day === 1 || day === 2 || day === 3 || day === 4 || day === 5;
                    }
                    scope.cancel = function () {
                        $mdDialog.hide();
                    }
                },
                parent: angular.element(document.body),
                targetEvent: event,
                clickOutsideToClose: true
            });
        }
        function layoutBanks(data) {
            var filterName = $filter('convertToCamelCase')('get_data_for_layouts_' + data.fileRoute);
            var filter = $filter('getFilterIfExists')(filterName);
            if (!filter) {
                errAlertS("No existe el archivo de layout del banco seleccionado");
                return false;
            }
            $rootScope.loadingProgress = true;
            var employees = $f('orderBy')($scope.fiscalEmployees, $scope.order);
            if ($scope.tabSelected === 'socialPrevision') {
                employees = $f('orderBy')($scope.operationEmployees, $scope.order);
            }
            var bankName = angular.lowercase(data.fileRoute);
            var process = opObjs.process.fb.find(function (value) {
                return value.id === $scope.tabSelected;
            });
            var areAll = false;
            var thisEmployees = data.employeesSelected;
            if ((!angular.isArray(thisEmployees)) || thisEmployees.length === 0) {
                thisEmployees = employees;
                areAll = true;
            }
            var params = {
                processes: $scope.process,
                payrollId: $scope.payrollId,
                banksAccounts: $scope.M.bankAccounts,
                banks: $scope.M.banks,
                bank: data.bank,
                bankAccount: data.bankAccount,
                employees: thisEmployees,
                areAll: areAll,
                allEmployeesO: allEmployeesO,
                payroll: opObjs.payroll,
                period: opObjs.period,
                calendar: opObjs.operation.fb.calendar,
                calc: $scope.calculations,
                paymentForms: $scope.M.paymentForms,
                processName: process.name,
                tabSelected: $scope.tabSelected
            }
            $filter('loopEach')(data.extraParams, function (value, index) {
                params[index] = value;
            })
            $f(filterName)(params).then(function (resp) {
                $log.log('parantros data', resp)
                if (angular.isDefined(resp.error) && angular.isArray(resp.error) && resp.error.length > 0) {
                    errAlertS(resp.error);
                }
                if (angular.isDefined(resp.success)) {
                    if (angular.isArray(resp.success) && resp.success.length === 0) {
                        throw "No existe ningún registro para layout de " + data.bank.name;
                    }
                    if (angular.isObject(resp.success) && angular.isDefined(resp.success.body) && resp.success.body.length === 0) {
                        throw "No existe ningún registro para layout de " + data.bank.name;
                    }
                    var objData = {
                        data: angular.toJson(resp.success),
                        bankName: $filter('convertToCamelCase')(bankName)
                    }
                    if (angular.isDefined(resp.filename)) {
                        objData.filename = resp.filename;
                    }
                    $http({
                        method: 'POST',
                        url: window.__env.serviceWorkerUrl + "interface/pag/layout/dispersion",
                        responseType: 'arraybuffer',
                        data: objData
                    }).then(function (response) {
                        var headers = response.headers();
                        var filename = headers['x-filename'];
                        var contentType = headers['content-type'];
                        var linkElement = document.createElement('a');
                        try {
                            var blobArray = [];
                            // if (contentType.indexOf('text/csv') > -1 && contentType.indexOf('utf-8') > -1) {
                            //     blobArray.push('\ufeff');
                            // }
                            blobArray.push(response.data);
                            var blob = new Blob(blobArray, {
                                type: contentType
                            });
                            var url = window.URL.createObjectURL(blob);
                            linkElement.setAttribute('href', url);
                            linkElement.setAttribute("download", filename);
                            var clickEvent = new MouseEvent("click", {
                                "view": window,
                                "bubbles": true,
                                "cancelable": false
                            });
                            linkElement.dispatchEvent(clickEvent);
                            $rootScope.loadingProgress = false;
                            $rootScope.$evalAsync(function () {
                                $log.debug('generate file .pag finished');
                            });
                        } catch (ex) {
                            $log.error(ex, "error descargando el archivo");
                            $rootScope.loadingProgress = false;
                            $rootScope.$evalAsync();
                        }
                    }).catch(function (err) {
                        var message = new TextDecoder("utf-8").decode(err.data);
                        var error = angular.fromJson(message);
                        errAlertS(error);
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync();
                    });
                } else {
                    errAlertS("No existe ningún registro para layout de " + data.bank.name);
                    $rootScope.loadingProgress = false;
                }
            }).catch(function (error) {
                $rootScope.loadingProgress = false;
                errAlertS(error);
            })
        }
        $scope.checkBankAccounts = function (bank, bankAccounts, tabSelected) {
            if (angular.isDefined(bank.hasLayout)) {
                var exist = false;
                var process = opObjs.process.fb.find(function (value) {
                    return value.id === tabSelected;
                });
                var processBanks = $f('getFromObject')(opObjs.payroll.fb.processes[process.name], 'bankAccounts');
                if (angular.isDefined(processBanks) && angular.isArray(processBanks) && processBanks.length > 0) {
                    var filterB = [];
                    for (var i = 0; i < processBanks.length; i++) {
                        var type = bankAccounts.find(function (value) {
                            return value._id === processBanks[i];
                        });
                        if (angular.isDefined(type)) {
                            filterB.push(type);
                        }
                    }
                    for (var f = 0; f < filterB.length; f++) {
                        if (filterB[f].bank === bank._id) {
                            exist = true;
                            break;
                        }
                    }
                }
            }
            return exist;
        }
        $scope.confirmSendEmail = function (ev, selected, process) {
            if (process === 'fiscal') {
                var uuids = [];
                var errors = [];
                for (var e = 0; e < selected.data.length; e++) {
                    var status = $filter('getFromObject')($scope.operation.employees, selected.data[e].$id + ".status");
                    var billUid = $filter('getFromObject')($scope.operation.employees, selected.data[e].$id + ".billId");
                    if (angular.isUndefined(billUid) && status === 5) {
                        errors.push('El empleado ' + allEmployeesO[selected.data[e].$id].data.name + ' no tiene el recibo');
                    } else if (status === 5) {
                        uuids.push({ uuid: billUid });
                    }
                }
                if (uuids.length === 0) {
                    errors.unshift('No se encontró ningún dato para enviar');
                    errAlertS(errors);
                    return false;
                }
                selected = uuids;
            }
            var cParams = {
                dispersionId: opObjs.operation.fb.dispersion,
                operationId: opObjs.operation.fb.$id,
                operationType: 'ordinary',
                period: $filter('zeroFill')(opObjs.operation.fb.period, 2),
                calendar: opObjs.operation.fb.calendar
            }
            $filter('sendBillsEmail')(selected, process, undefined, ev, cParams, undefined)
        }
        $scope.getLayoutVales = function (voucherCompany, selected) {
            var thisEmployees = !angular.isArray(selected) || selected.length === 0 ? $scope.fiscalEmployees : selected;
            var tokaProduct, clientIdToka;
            var repeatedFields = {}
            var data = []
            for (var t = 0; t < thisEmployees.length; t++) {
                var idEmployee = thisEmployees[t].$id;
                var payroll = allEmployeesO[idEmployee].payrollData;
                var numberEmployee = allEmployeesO[idEmployee].data.employeeNumber
                if (angular.isDefined(voucherCompany)) {
                    clientIdToka = payroll.extraFields.tokaClientId;
                    tokaProduct = payroll.extraFields.tokaProduct;
                }
                var calculation = $scope.calculations[idEmployee];
                var voucherValue = $filter("getFromObject")(calculation, "voucher.fiscalValue.result", 0);
                if (voucherValue > 0) {
                    if (!repeatedFields.hasOwnProperty("productToka")) {
                        repeatedFields = { productToka: tokaProduct, clientIdToka: clientIdToka };
                    }
                    data.push({ n: numberEmployee, a: voucherValue })
                }
            }
            if (data.length == 0) {
                infoAlertS('No se encontraron datos para generar');
            } else {
                var objToSend = {
                    headers: { clientIdToka: 'ID', n: 'NOMINA', a: 'MONTO', productToka: 'PRODUCTO' },
                    repeatedFields: repeatedFields,
                    rows: data
                };
                downloadFile('files/getLayoutVoucher/toka', objToSend, true)
            }

        }

        function turnOffWatchers(all) {
            for (var watcherKey in watchers) {
                if (watchers.hasOwnProperty(watcherKey)) {
                    if (angular.isFunction(watchers[watcherKey]) && (all || (!all && watcherKey !== 'onDestroy'))) {
                        watchers[watcherKey]();
                        delete watchers[watcherKey];
                    }
                }
            }
        }
        watchers.onDestroy = $scope.$on('$destroy', function () {
            turnOffWatchers(true);
        });
        startAfterInitFilter($scope, {}, initiated, init);
    }
})();
(function () {
    'use strict';

    angular
        .module('app.clients')
        .controller('ExportAccsModalController', ExportAccsModalController);

    function ExportAccsModalController(
        dataToExport,
        $mdDialog,
        secondEndPoint,
        AppF,
        $log,
        $scope,
        $rootScope,
        DataF,
        errAlertS
    ) {
        var vm = this;
        vm.dataToExport = dataToExport;
        vm.debounceTime = AppF.debounceTime
        vm.statusTimbre = {};
        function init() {
        }
        function cancel() {
            $mdDialog.cancel();
        }
        function checkStatusOp() {
            var operationsIds = [];
            var promises = [];
            for (var d = 0; d < dataToExport.length; d++) {
                var thisData = dataToExport[d];
                if (operationsIds.indexOf(thisData.operationId) === -1) {
                    operationsIds.push(thisData.operationId);
                    var ref;
                    if (thisData.operationType === 'ordinary') {
                        ref = thisData.operationType + '/' + thisData.payroll + '/' + thisData.calendar + '/collection/' + thisData.operationId + '/status'
                    } else {
                        ref = thisData.operationType + '/all/' + thisData.operationId + '/status'
                    }
                    promises.push(AppF.root.child('catalogs/operations/' + ref).once("value"))
                }
            }
            Promise.all(promises).then(function (resp) {
                for (var r = 0; r < resp.length; r++) {
                    vm.statusTimbre[operationsIds[r]] = resp[r].val();
                }
            }).catch(errAlertS)
        }
        $log.log('dataToExport', vm.dataToExport);
        function downloadAccs(data) {
            data.downloading = true;
            var obj = {
                data: angular.toJson([data]),
                nameF: 'exportAccount'
            };
            var path = 'interface/exportAnyFiles';
            if (secondEndPoint) {
                path = 'interface/exportAccountingAccounts';
            }
            $rootScope.C.exportToExcel(path, obj, true).then(function () {
                data.downloading = false;
                $scope.$evalAsync()
            }).catch(function () {
                data.downloading = false;
                $scope.$evalAsync()
            });
        }

        vm.downlandLayout = function (data) {
            data.downloadingLayout = true;
            var obj = {
                data: angular.toJson([data]),
                nameF: 'exportAccount'
            };
            var path = 'interface/exportAccountingAccountsCompaq';
            $rootScope.C.exportToExcel(path, obj, true).then(function () {
                data.downloadingLayout = false;
                $scope.$evalAsync()
            }).catch(function () {
                data.downloadingLayout = false;
                $scope.$evalAsync()
            });
        }
        function permissionCompaqui() {
            var companiesRecords = [];
            var uniquePairs = {};
            var processesWithAccess = {};
            vm.access = false;
            var payrollPromises = vm.dataToExport.map(function (item) {
                return $scope.F.root.child('catalogs/payrolls/collection/' + item.payrollId)
                    .once("value")
                    .then(function (snapshot) {
                        return snapshot.val();
                    });
            });
            Promise.all(payrollPromises)
                .then(function (responses) {
                    responses.forEach(function (info) {
                        Object.keys(info.processes).forEach(function (processName) {
                            var process = info.processes[processName];
                            if (process.companiesRecord) {
                                var uniqueKey = process.companiesRecord + '|' + processName;
                                if (!uniquePairs[uniqueKey]) {
                                    companiesRecords.push({
                                        company: process.companiesRecord,
                                        name: processName
                                    });
                                    uniquePairs[uniqueKey] = true;
                                }
                            }
                        });
                    });
                    var queryPromises = companiesRecords.map(function (recordItem) {
                        var query = {
                            center: AppF.center,
                            companiesRecord: { $in: [recordItem.company] }
                        };

                        return DataF.api.get('accountingAccounts', query)
                            .then(function (response) {
                                if (response.data[0] && response.data[0].LayoutContpaqi) {
                                    processesWithAccess[recordItem.name] = true;
                                }
                            });
                    });
                    return Promise.all(queryPromises);
                })
                .then(function () {
                    vm.dataToExport.forEach(function (data) {
                        data.access = !!processesWithAccess[data.processName];
                    });
                })
                .catch(function (error) {
                    $log.log('Error in permissionCompaqui:', error);
                });
        }




        permissionCompaqui()
        vm.cancel = cancel;
        vm.downloadAccs = downloadAccs;
        checkStatusOp();
        init();
    }
}
)();


(function () {
    'use strict';

    angular
        .module('app.clients')
        .controller('ExcludedEmployeesController', ExcludedEmployeesController);

    function ExcludedEmployeesController($mdDialog, operationRef, operation, AppF, errAlertS, $log, $rootScope, userHasPermissionFilter) {
        var vm = this;
        var ids = [];
        var employeesIds = operation.excludedEmployees || {};
        vm.operationIsClosed = operation.status >= 3;
        vm.permissionToExcludeEmployees = userHasPermissionFilter(AppF.groupsOfUser, AppF.permissions, 'excludeEmployees', 'processes.operations');
        vm.showSaveButton = false;
        function init() {
            var promises = Object.keys(employeesIds).map(function (item) {
                ids.push(item);
                return AppF.root.child('catalogs/employees/collection/' + item + '/data/name').once('value');
            });
            Promise.all(promises).then(function (resp) {
                vm.employees = resp.map(function (snap, index) {
                    var thisName = "S/N";
                    if (snap.exists()) {
                        thisName = snap.val();
                    }
                    return { name: thisName, id: ids[index] }
                })
            }).catch(errAlertS)
        }
        function removeEmployeeFromExcluded(ind) {
            vm.employees.splice(ind, 1)
            vm.showSaveButton = true;
        }
        function saveExcludedEmployees() {
            var thisExcludedEmployees = vm.employees.reduce(function (current, item) {
                current[item.id] = true;
                return current;
            }, {})
            $rootScope.$loadingProgress = true;
            $rootScope.$evalAsync();
            var finalRef = operationRef + '/' + operation.$id + '/excludedEmployees';
            $log.log(finalRef)
            AppF.root.child(finalRef).set(thisExcludedEmployees).then(function () {
                $rootScope.$loadingProgress = false;
                $rootScope.$evalAsync();
                $mdDialog.hide(true);
            }).catch(errAlertS);
        }
        function cancel() {
            $mdDialog.cancel()
        }
        vm.removeEmployeeFromExcluded = removeEmployeeFromExcluded;
        vm.saveExcludedEmployees = saveExcludedEmployees;
        vm.cancel = cancel;
        init();
    }
})();


(function () {
    'use strict';
    angular
        .module('app.clients')
        .controller('ConfirmOperationController', ConfirmOperationController);
    function ConfirmOperationController(
        $rootScope,
        getFromObjectFilter,
        errAlertS,
        $mdDialog,
        $state,
        $log,
        statusName,
        msg,
        operationStatus,
        operationType,
        params,
        operationEmployeesF,
        moveBack,
        opObjs,
        action,
        AppF,
        $timeout
    ) {

        var vm = this;
        vm.dateView = AppF.dateView;
        // vm.debounceTime = AppF.debounceTime;
        vm.operationType = operationType;
        vm.statusName = statusName;
        vm.operation = opObjs.operation.fb;
        vm.comments = vm.operation.comments;
        vm.period = opObjs.period.fb;
        vm.periodSelected = '';
        vm.msg = msg;
        vm.rewriteComments = '';
        vm.retry = false;
        vm.message = '';
        vm.operationStatus = operationStatus;
        vm.selected = [];
        vm.pending = {};
        vm.showPaymentDate = true;
        if (operationType === 'settlement') {
            vm.generateDismissMovement = true;
        }
        delete vm.paymentDate;
        var maxPaymentDate = {
            tds: function (periodSelected) {
                // var accuDate = moment(periodSelected.accuDate);
                // accuDate.startOf('month');
                // if (accuDate.valueOf() > periodSelected.start) {
                //     vm.minPaymentDate = accuDate.toDate();
                // } else {
                //     $log.log('setting min from periodSelect', periodSelected.start);
                //     vm.minPaymentDate = moment(periodSelected.start).toDate();
                // }
                // accuDate.endOf('month');
                // if (accuDate.valueOf() < periodSelected.end) {
                //     vm.maxPaymentDate = accuDate.toDate();
                // } else {
                //     vm.maxPaymentDate = moment(periodSelected.end).toDate();
                // }
                // delete vm.paymentDate;
                vm.minPaymentDate = moment(periodSelected.start).toDate();
                vm.maxPaymentDate = moment(periodSelected.end).add(3, 'days').toDate();
            },
            integratio: function (periodSelected) {
                vm.minPaymentDate = moment(periodSelected.start).toDate();
                vm.maxPaymentDate = moment(periodSelected.end).add(3, 'days').toDate();
            },
            manopco: function (periodSelected) {
                vm.minPaymentDate = moment(periodSelected.start).toDate();
                vm.maxPaymentDate = moment(periodSelected.end).add(3, 'days').toDate();
            }
        };
        vm.setMinMaxPaymentDate = function (periodSelected, setBillingDate) {
            var thisCenter = AppF.center;
            if (!maxPaymentDate.hasOwnProperty(thisCenter)) {
                thisCenter = 'tds';
            }
            maxPaymentDate[thisCenter](periodSelected, setBillingDate);
            if (setBillingDate) {
                $rootScope.$evalAsync($timeout(function () {
                    var thisPaymentDay = moment(vm.maxPaymentDate.valueOf()).startOf('day').valueOf();
                    if (['ordinary', 'settlement'].indexOf(operationType) === -1 && vm.operation.specialDate >= vm.minPaymentDate.valueOf() && vm.operation.specialDate <= vm.maxPaymentDate.valueOf()) {
                        thisPaymentDay = vm.operation.specialDate;
                    }
                    vm.paymentDate = thisPaymentDay;
                }, 0, false));
            }
        };

        if (vm.operationStatus >= 3) {
            if (angular.isArray(params.periods)) {
                vm.periods = params.periods;
                vm.showPeriod = true;
            } else {
                vm.setMinMaxPaymentDate(opObjs.period.fb);
            }
        }
        if (action === 'reOpenClosed' && [3, 4, 5, 6, 7].indexOf(vm.operation.status) > -1 && operationType !== 'settlement') {
            vm.pendingEmployees = operationEmployeesF;
            // for (var e = 0; e < operationEmployeesF.length; e++) {
            //     var employeesP = vm.operation.employees;
            //     if (employeesP.hasOwnProperty(operationEmployeesF[e].$id) && ([3, 4].indexOf(employeesP[operationEmployeesF[e].$id].status) > -1 || (vm.operation.status === 7 && employeesP[operationEmployeesF[e].$id].status === 5))) {
            //         vm.pendingEmployees.push(operationEmployeesF[e]);
            //     }
            // }
        }
        vm.confirm = function () {
            $rootScope.loadingProgress = true;
            vm.disableButtons = true;
            var promises = [];
            if (operationType === 'settlement') {
                promises.push(getOtherSettlements(action, vm.operation, operationEmployeesF));
            }
            Promise.all(promises).then(function () {
                var response;
                if (action === 'closeOperation') {
                    var periodSelected = (angular.isObject(vm.periodSelected)) ? vm.periodSelected : vm.period;
                    if (angular.isDefined(periodSelected)) {
                        action = getFromObjectFilter(vm.operation, 'billingDate') ? 'closePartial' : undefined;
                        response = params.moveEmployees(action, vm.rewriteComments, periodSelected, vm.paymentDate, undefined, params.newCalendar, vm.generateDismissMovement);
                    } else {
                        errAlertS('No se encontró el periodo en el que se va acumular la operación');
                        $rootScope.loadingProgress = false;
                        return false;
                    }
                } else {
                    var employees = (vm.type === 'some') ? vm.selected : vm.pendingEmployees;
                    if (angular.isArray(employees) && employees.length === 0) {
                        errAlertS('No hay ningún empleado en el listado para realizar la apertura');
                        $rootScope.loadingProgress = false;
                        return false;
                    }
                    response = params.moveEmployees(action, vm.rewriteComments, undefined, undefined, employees, undefined, vm.generateDismissMovement);
                }
                return response;
            }).then(function () {
                if (operationType === 'ordinary') {
                    params.sendOperationNotification(opObjs.operation.fb, operationStatus, moveBack, 'ordinary', statusName.name, opObjs.operation.fb.comments);
                }
                vm.hide();
                $state.reload();
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
            }).catch(function (error) {
                var message;
                switch (error) {
                    case 1:
                        message = 'Se necesita la siguiente operación para continuar con el cerrado de la nómina';
                        break;
                    case 2:
                        message = 'No se encontró periodo de la siguiente operación';
                        break;
                    case 3:
                        message = 'No se puede cerrar la operación actual debido a que hay un finiquito cerrado con la misma fecha ' + moment(vm.operation.movement.date).format('DD/MM/YYYY');
                        break;
                    case 4:
                        message = 'No se puede cerrar la operación actual debido a que hay un finiquito cerrado con la misma fecha';
                        break;
                    default:
                        $log.error(error);
                        message = (action === 'reOpenClosed') ? 'No se pudo reabrir la nómina correctamente, inténtelo nuevamente' :
                            (action === 'moveBackOperation') ? 'No se pudo abrir la nómina correctamente, inténtelo nuevamente' :
                                'No se cerró la nómina correctamente, inténtelo nuevamente';
                        break;
                }
                errAlertS(message);
                vm.retry = true;
                vm.message = message;
                vm.disableButtons = false;
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
            });
        };
        function getOtherSettlements(action, currentOp, employees) {
            return new Promise(function (resolve, reject) {
                if (action === 'closeOperation') {
                    AppF.root.child('catalogs/operations/settlement/all/').orderByChild('movement/date').equalTo(currentOp.movement.date).once('value').then(function (snap) {
                        var existOther = false;
                        snap.forEach(function (childSnap) {
                            var employeesObj = childSnap.val().employees;
                            if (childSnap.key !== currentOp.$id && employeesObj.hasOwnProperty(employees[0].$id) && employeesObj[employees[0].$id].status >= 3) {
                                existOther = true;
                            }
                        });
                        if (existOther) {
                            throw 3;
                        }
                        return AppF.root.child('catalogs/movements/collection/' + currentOp.movementTypes + '/data/fromSettlement').once('value');
                    }).then(function (snap) {
                        if (snap.exists() && snap.val() !== currentOp.$id) {
                            throw 4;
                        }
                        resolve(true);
                    }).catch(function (error) {
                        reject(error);
                    });
                } else {
                    resolve(true);
                }
            });
        }
        vm.toggle = function (item, list) {
            var idx = list.findIndex(function (employee) {
                return employee.$id === item.$id;
            });
            if (idx > -1) {
                list.splice(idx, 1);
            } else {
                list.push(item);
            }
            if (vm.selected.length === vm.pendingEmployees.length) {
                vm.pending.selectedAllEmployee = true;
            } else {
                vm.pending.selectedAllEmployee = false;
            }
        };
        vm.exists = function (item, list) {
            return list.findIndex(function (employee) {
                return employee.$id === item.$id;
            }) > -1;
        };
        vm.selectedAll = function (check) {
            if (!check) {
                vm.selected = angular.fromJson(angular.toJson(vm.pendingEmployees));
            } else {
                vm.selected = [];
            }
        };
        vm.hide = function () {
            $mdDialog.hide();
        };
        vm.cancel = function () {
            $mdDialog.cancel();
        };
    }
})();


(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('verifyAllTrue', verifyAllTrue)

    function verifyAllTrue() {

        return verifyAllTrueFn;

        function verifyAllTrueFn(values) {
            var allAreTrue = true;
            if (typeof(values) == 'object') {
                var falseFounded = false;
                for (var v in values) {
                    if (!verifyAllTrueFn(values[v])) {
                        falseFounded = true;
                    }
                }
                allAreTrue = !falseFounded;
            } else if (typeof(values) == 'boolean') {
                allAreTrue = values;
            } else if (typeof(values) === 'string') {
                allAreTrue = (values === 'true');
            } else if (typeof(values) === 'number') {
                allAreTrue = (values === 1);
            }
            return allAreTrue;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('validateUndefined', validateUndefined)

    function validateUndefined() {

        return validateUndefinedFn;

        function validateUndefinedFn(dato, def) {
            if (typeof(dato) == "undefined") {
                return def;
            } else {
                return dato;
            }
        }
    }

}());
(function () {
    'use strict';
    angular
        .module('app.clients')
        .filter('validateCalculationsV2', validateCalculationsV2)

    function validateCalculationsV2(AppF, objsToArrayFilter, getActiveEmployeesFilter, $log, $q, loopEachFilter, DataF) {

        return validateCalculationsV2Fn;

        function validateCalculationsV2Fn(records, payrollCalendars, employees) {
            return new Promise(function (resolve, reject) {
                if (angular.isUndefined(employees)) {
                    employees = {};
                }
                var processed = [];
                var employeeNumbers = [];
                records = records.sort(function (a, b) {
                    return a.Empleado - b.Empleado;
                });
                for (var r = 0; r < records.length && processed.length < 50; r++) {
                    if (!records[r].processed) {
                        records[r].processed = true;
                        records[r].errors = [];
                        if (records[r].errors.length === 0) {
                            processed.push(r);
                            if (employeeNumbers.indexOf(records[r].Empleado) === -1 && !employees.hasOwnProperty(records[r].Empleado)) {
                                employeeNumbers.push(records[r].Empleado);
                            }
                        }
                    }
                }
                if (processed.length === 0) {
                    resolve(records);
                } else {
                    var params = {
                        'data.employeeNumber': angular.toJson({ $in: employeeNumbers }),
                        'project': angular.toJson({ 'data.name': 1, 'data.employeeNumber': 1, 'fid': 1 })
                    };
                    DataF.api.get('employees', params).then(function (resp) {
                        for (var r = 0; r < resp.data.length; r++) {
                            var employee = resp.data[r];
                            employees[employee.data.employeeNumber] = employee;
                        }
                        for (var p = 0; p < processed.length; p++) {
                            var index = processed[p];
                            var record = records[index];
                            if (employees.hasOwnProperty(record.Empleado)) {
                                record.employee = angular.fromJson(angular.toJson(employees[record.Empleado]));
                            } else {
                                record.errors.push('No se encontró el empleado');
                            }
                            var thisYear;
                            var calcDate = record.Fecha.valueOf();
                            loopEachFilter(payrollCalendars.calendars, function (dataCalendar, year) {
                                if (dataCalendar.data.startDate < calcDate && dataCalendar.data.endDate > calcDate) {
                                    thisYear = year;
                                }
                            });
                            if (angular.isUndefined(thisYear)) {
                                record.errors.push('No existe calendario para guardar este calculo');
                            } else {
                                var thisPeriod;
                                loopEachFilter(payrollCalendars.periods[thisYear], function (periodData, period) {
                                    if (periodData.start < calcDate && periodData.end > calcDate) {
                                        thisPeriod = period;
                                    }
                                });
                                record.Año = parseInt(thisYear);
                                record.calendar = parseInt(thisYear);
                                record.Periodo = parseInt(thisPeriod);
                            }
                            if (record['Sueldo_Neto'] !== record['Neto']) {
                                record.errors.push('Los datos no coinciden con el sueldo neto');
                            }
                        }
                        resolve(validateCalculationsV2Fn(records, payrollCalendars, employees));
                    }).catch(reject);
                }
            })
        }
    }
}());
/**
 * @description Consulta un dato en cualquier documento de FB 
 * @param {string} route Recibe la ruta completa donde se va hacer la consulta ejemplo 'catalogs/rps/collection/'${key}'/active'
 * @return {promise} Regresa una promesa tipo Boolean
 */
(function () {
    'use strict';
    angular
        .module('app.clients')
        .filter('validateCalculations', validateCalculations)

    function validateCalculations(AppF, DataF, objsToArrayFilter, getActiveEmployeesFilter, $log, $q, getFromObjectFilter) {

        return validateCalculationsFn;

        function validateCalculationsFn(records, employees, payrollsData) {
            return new Promise(function (resolve, reject) {
                if (angular.isUndefined(employees)) {
                    employees = {};
                }
                var processed = [];
                var employeeNumbers = [];
                payrollsData = payrollsData ? payrollsData : {};
                var promisesPayroll = {};
                records = records.sort(function (a, b) {
                    return a.Empleado - b.Empleado;
                });
                for (var r = 0; r < records.length && processed.length < 50; r++) {
                    if (!records[r].processed) {
                        records[r].processed = true;
                        records[r].errors = [];
                        if (records[r].errors.length === 0) {
                            processed.push(r);
                            if (employeeNumbers.indexOf(records[r].Empleado) === -1 && !employees.hasOwnProperty(records[r].Empleado)) {
                                employeeNumbers.push(records[r].Empleado);
                            }
                            if (!payrollsData.hasOwnProperty(records[r].Nomina) || !promisesPayroll.hasOwnProperty(records[r].Nomina)) {
                                promisesPayroll[records[r].Nomina] = AppF.root.child('catalogs/payrolls/collection').orderByChild('data/class').equalTo(records[r].Nomina).once('value');
                            }
                        }
                    }
                }
                if (processed.length === 0) {
                    resolve(records);
                } else {
                    var params = {
                        'data.employeeNumber': angular.toJson({ $in: employeeNumbers }),
                        'project': angular.toJson({ 'data.name': 1, 'data.employeeNumber': 1, 'fid': 1 })
                    };
                    var promises = [DataF.api.get('employees', params)];
                    if (Object.keys(promisesPayroll).length > 0) {
                        promises.push($q.all(promisesPayroll));
                    } else {
                        promises.push(Promise.all([]));
                    }
                    Promise.all(promises).then(function (resps) {
                        var payrollResp = angular.isArray(resps[1]) ? {} : resps[1];
                        for (var thisPayroll in payrollResp) {
                            if (payrollResp.hasOwnProperty(thisPayroll)) {
                                var payroll = false;
                                payrollResp[thisPayroll].forEach(function (childSnap) {
                                    payroll = childSnap.val();
                                    payroll.$id = childSnap.key;
                                });
                                payrollsData[thisPayroll] = payroll;
                            }
                        }
                        $log.log(payrollsData);
                        var resp = resps[0];
                        for (var r = 0; r < resp.data.length; r++) {
                            var employee = resp.data[r];
                            employees[employee.data.employeeNumber] = employee;
                        }
                        for (var p = 0; p < processed.length; p++) {
                            var index = processed[p];
                            var record = records[index];
                            if (employees.hasOwnProperty(record.Empleado)) {
                                record.employee = angular.fromJson(angular.toJson(employees[record.Empleado]))
                            } else {
                                record.errors.push("No se encontró el empleado");
                            }
                            if (payrollsData.hasOwnProperty(record.Nomina)) {
                                if (payrollsData[record.Nomina]) {
                                    record.payroll = payrollsData[record.Nomina];
                                } else {
                                    record.errors.push("No se encontró la nomina del calculo");
                                }
                            }
                        }
                        resolve(validateCalculationsFn(records, employees, payrollsData));
                    }).catch(reject);
                }
            })
        }
    }
}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('transformDispersionObj', transformDispersionObj)

    function transformDispersionObj(clearObjectFilter) {

        return transformDispersionObjFn;

        function transformDispersionObjFn(dispersion) {
            var dispersion = clearObjectFilter(dispersionObj);
            for (var cindex in dispersion.calculations) {
                var calculations = dispersion.calculations[cindex].calculations;
                for (var operationType in calculations) {
                    for (var concept in calculations[operationType]) {
                        for (var dataName in calculations[operationType][concept]['data']) {
                            if (typeof calculations[operationType][concept]['data'][dataName] == 'string') {
                                try {
                                    calculations[operationType][concept]['data'][dataName] = JSON.parse(calculations[operationType][concept]['data'][dataName]);
                                } catch (error) {
                                    $log.debug(error);
                                }
                            }
                        }
                        if (typeof(calculations[operationType][concept]['formulas']) != 'undefined') {
                            calculations[operationType][concept]['formulas'] = JSON.parse(calculations[operationType][concept]['formulas'])
                        }
                    }
                }
                dispersion.calculations[cindex].calculations = calculations;
            }
            return dispersion;
        }
    }

}());
(function(){
    'use strict';

    angular
        .module('app.clients')
        .filter('shownColumns', shownColumns)

    function shownColumns(){

        return shownColumnsFn;

        function shownColumnsFn(columns){
            var shown = {};
            for(var c in columns){
                var column = columns[c];
                if(column.show) shown[c] = column;
            }
            return shown;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('setOperationEmployeesStatus', setOperationEmployeesStatus)

    function setOperationEmployeesStatus() {

        return setOperationEmployeesStatusFn;

        /**
         * Setea el mapa de empleados con su status y cc en la operación, respeta si estos campos ya existen
         * @param {*} operation 
         * @param {*} employees 
         * @param {int} status 
         */
        function setOperationEmployeesStatusFn(operation, employees, status, forceStatus, deleteNotInList) {
            //operation, employees, status, forceStatus, deleteNotInList

            angular.forEach(employees, function(employee) {
                if (!operation.employees) operation.employees = {};
                if (!operation.employees[employee.$id]) {
                    operation.employees[employee.$id] = {
                        status: status,
                        cc: employee.cc
                    };
                } else {
                    if (!operation.employees[employee.$id].cc) operation.employees[employee.$id].cc = employee.cc;
                    if (!operation.employees[employee.$id].status || forceStatus) operation.employees[employee.$id].status = status;

                }
            });
            if (deleteNotInList) {
                for (var employeeId in operation.employees) {
                    var employeeFound = false;
                    for (var e in employees) {
                        var employee = employees[e];
                        if (employeeId == employee.$id) {
                            employeeFound = true;
                        }
                    }
                    if (!employeeFound) {
                        delete operation.employees[employeeId];
                    }
                }
            }
            return operation;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('setColumns', setColumns)

    function setColumns(
        getSomethingOfArrayMFilter,
        MongoF,
        translateFilter
    ) {

        return setColumnsFn;

        function setColumnsFn(incidencesByType, paymentSchema) {
            var columns = {};
            var defaultColumns = [{
                    uid: 'daysOfPeriod',
                    name: 'Dias del Periodo',
                    show: true
                },
                {
                    uid: 'workedDays',
                    name: 'Dias Trabajados',
                    show: true
                },
                {
                    uid: 'gravableBase',
                    name: 'base Gravable',
                    show: true
                },
                {
                    uid: 'limit',
                    name: 'Límite de Proceso',
                    show: false
                },
                {
                    uid: 'isr',
                    name: 'ISR',
                    show: true
                } // este es para el complemento
            ];
            // @todo agregar separadores y identificadores para los tipo de incidencia
            for (var p in paymentSchema.data.processes) {
                var process = paymentSchema.data.processes[p];
                if (p == 'complements') {
                    for (var c in process) { // each complement
                        var complement = process[c];
                        if (complement.active) {
                            columns[complement.name] = {};
                            columns[complement.name][complement.type] = {
                                uid: complement.type,
                                name: translateFilter('o.' + complement.type),
                                show: true
                            };
                        }
                        // columns[complement.name]['gravableBase'] = defaultColumns[2];
                        // columns[complement.name]['limit'] = defaultColumns[3];
                        // columns[complement.name]['isr'] = defaultColumns[4];
                    }

                } else { // real y fiscal
                    if (process.active) columns[process.name] = {};
                    if (p == 'fiscal') {
                        for (var i in process.incidences) {
                            var incidence = process.incidences[i];
                            if (incidence.active && !columns[process.name].hasOwnProperty(i)) {
                                columns[process.name][i] = {
                                    uid: i,
                                    name: getSomethingOfArrayMFilter(i, MongoF.satIncidencesTypes, 'name', false, '_id'),
                                    show: true
                                };
                            }

                        }
                    }
                    for (var ii in incidencesByType) { // incidences in incidencesByType
                        if (!columns[process.name].hasOwnProperty(ii)) {
                            columns[process.name][ii] = {
                                uid: ii,
                                name: getSomethingOfArrayMFilter(ii, MongoF.satIncidencesTypes, 'name', false, '_id'),
                                show: true
                            };
                        }
                    }
                    if (process.active) {
                        columns[process.name]['daysOfPeriod'] = defaultColumns[0];
                        columns[process.name]['workedDays'] = defaultColumns[1];
                        columns[process.name]['gravableBase'] = defaultColumns[2];
                        columns[process.name]['limit'] = defaultColumns[3];
                    }

                }
            }

            return columns;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('roundNumber', roundNumber)

    function roundNumber() {

        return roundNumberFn;

        function roundNumberFn(number, digits) {
            digits = digits ? digits : 2;
            var numberAux = '1';
            for (var i = 0; i < digits; i++) {
                numberAux += '0';
            }
            numberAux = parseInt(numberAux);
            var value = parseFloat(number);
            if (isNaN(value)) {
                value = 0;
            }
            return Math.round(number * numberAux) / numberAux;
        }
    }
}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('realWorkedDays', realWorkedDays);

    function realWorkedDays() {

        return realWorkedDaysFn;

        function realWorkedDaysFn(activeDays) {
            var workedDays = 0;
            angular.forEach(activeDays, function(activeDay, index) {
                var startObject = moment(activeDay.start);
                var endObject = moment(activeDay.end);
                activeDays[index].daysWorked = endObject.diff(startObject, "days") + 1;
                workedDays += (endObject.diff(startObject, "days") + 1-(activeDay.absences?activeDay.absences:0));
            })
            return workedDays;
        }
    }
}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('piramidateISR', piramidateISR)

    function piramidateISR(
        MongoF
    ) {

        return piramidateISRFn;

        function roundN(number) {
            return Math.round(number * 100) / 100;
        }

        function constructObject(netToReach, obj, record) {
            var newObj = {};
            if (obj) {
                newObj = angular.copy(obj);
                if (record) {
                    newObj.lowerLimit = roundN(record.lowerLimit); // 4210.72
                    newObj.upperLimit = roundN(record.upperLimit); // 7399.42
                    newObj.fixedFee = roundN(record.fixedFee); // 247.24
                    newObj.percentRate = roundN(record.percentFee); //10.88
                    newObj.exedent = roundN(newObj.newSubTotal - newObj.lowerLimit); //
                    newObj.marginalTax = roundN(newObj.exedent * (newObj.percentRate / 100)); //
                    newObj.isr = roundN(newObj.marginalTax + newObj.fixedFee); // 
                    newObj.newTotal = roundN(newObj.newSubTotal + newObj.isr); // 
                }
            } else {
                newObj = {
                    netToReach: roundN(netToReach),
                    newSubTotal: angular.copy(netToReach),
                    newTotal: 0,
                    lowerLimit: 0,
                    upperLimit: 0,
                    percentRate: 0,
                    fixedFee: 0,
                    exedent: 0,
                    marginalTax: 0,
                    isr: 0,
                    subsidyOfPeriod: 0
                }
            }
            return newObj;
        }

        function piramidateISRFn(netToReach) {
            var isrObj = constructObject(netToReach);

            var difference = 0;
            var newDifference = 0;
            var newDifference2 = 0;
            var isrRecordsSorted = MongoF.isrRecords.sort(function(a, b) {
                return a.lowerLimit - b.lowerLimit
            });



            for (var i in isrRecordsSorted) {
                var isrRecord = isrRecordsSorted[i];
                if (isrObj.newSubTotal >= isrRecord.lowerLimit && isrObj.newSubTotal <= isrRecord.upperLimit) { // (1) 6000
                    isrObj.newSubTotal = roundN(isrRecord.lowerLimit); // se iguala el subTotal al limite inferior // 4210.72
                    isrObj = constructObject(netToReach, isrObj, isrRecord);
                    difference = netToReach - isrObj.newTotal; // 
                    if (difference == 0) { // es justo lo que se requiere
                        isrObj.exedent = 0;
                        return isrObj;
                    } else if (difference < 0) { // hay que bajar al limite siguiente
                        if (isrRecordsSorted[i + 1]) isrObj.newSubTotal = isrRecordsSorted[i + 1].lowerLimit;
                    } else if (difference > 0) { // hay que checar que la diferencia no sea demaciada como para subir de limite
                        isrObj.newSubTotal += roundN(difference);
                        isrObj = constructObject(netToReach, isrObj, isrRecord);
                        newDifference = netToReach - isrObj.newTotal;
                        if (newDifference == 0) {
                            return isrObj;
                        } else if (newDifference < 0) {
                            isrObj.newSubTotal += roundN(newDifference);
                            isrObj = constructObject(netToReach, isrObj, isrRecord);
                            newDifference2 = netToReach - isrObj.newTotal;
                            if (newDifference2 == 0) {
                                return isrObj;
                            } else { //if(newDifference2 > 0 && newDifference2 < 1){
                                // @ todo preguntar que se hace con esta diferencia
                                // @ todo checar si esta bien calculado el isr piramidal
                                return isrObj;
                            }
                        } else { // es mayor que el limite del registro así que se tiene que pasar al limite siguiete
                            if (isrRecordsSorted[i + 1]) isrObj.newSubTotal = isrRecordsSorted[i + 1].lowerLimit;
                        }
                    }
                }
            }
            return false;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('perceptionsByEmployee', perceptionsByEmployee)

    function perceptionsByEmployee() {

        return perceptionsByEmployeeFn;

        function perceptionsByEmployeeFn(incidences, employees, fiscalIncidences) {
            var perceptions = {};
            for (var e in employees) {
                var employee = employees[e];
                if (employee.hasOwnProperty('$id')) {
                    perceptions[employee.$id] = [];
                    for (var i in incidences) {
                        var incidence = incidences[i];
                        if (incidence.employee == employee.$id) {
                            if (incidence.nature == 'perception') {
                                if (typeof(fiscalIncidences) === "object") {
                                    if (typeof(incidence.incidenceType) !== "undefined" && fiscalIncidences.indexOf(incidence.incidenceType) > -1) {
                                        perceptions[employee.$id].push(incidence);
                                    }
                                } else {
                                    perceptions[employee.$id].push(incidence);
                                }

                            }
                        }
                    }
                }
            }
            return perceptions;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('perceptions', perceptions)

    function perceptions(
        AppF,
        MongoF,
        getSomethingOfArrayFBFilter,
        getSomethingOfArrayMFilter
    ) {

        return perceptionsFn;

        function perceptionsFn(incidencesByType, isSatOrComplement) {
            var onlyPerceptions = {};
            for (var i in incidencesByType) {
                var nature = "";
                if (typeof(isSatOrComplement) !== "undefined") {
                    if (isSatOrComplement == "complement") {
                        nature = getSomethingOfArrayMFilter(i, MongoF.complementIncidencesTypes, 'nature', false, "_id");
                        if (nature === false) {
                            nature = getSomethingOfArrayFBFilter(i, AppF.incidencesTypes, 'nature', false);
                        }
                    } else {
                        nature = getSomethingOfArrayMFilter(i, MongoF.satIncidencesTypes, 'nature', false, "_id");
                    }
                } else {
                    nature = getSomethingOfArrayFBFilter(i, AppF.incidencesTypes, 'nature', false);
                }
                if (nature == 'perception') onlyPerceptions[i] = incidencesByType[i];
            }
            return onlyPerceptions;
        }
    }

}());
(function(){
    'use strict';

    angular
        .module('app.clients')
        .filter('operationStatusName', operationStatusName)

    function operationStatusName(AppF){

        return operationStatusNameFn;

        function operationStatusNameFn(status){
            var statusName = '';
            for(var s in AppF.operationStatatuss){
                if(AppF.operationStatatuss[s].id == status) statusName = AppF.operationStatatuss[s].name;
            }
            return statusName;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('onlyDispersionEmployees', onlyDispersionEmployees)

    function onlyDispersionEmployees() {

        return onlyDispersionEmployeesFn;

        function onlyDispersionEmployeesFn(employees, dispersion, hideNotSelected, reverse, operation) {
            var dEmployees = [];
            for (var e in employees) {
                if ((hideNotSelected || (operation.employees && operation.employees[employees[e].$id] && operation.employees[employees[e].$id].status > 3)) && dispersion && dispersion.hasOwnProperty('employees')) {
                    if (reverse) { // not dispersed employees
                        if (!dispersion.employees.hasOwnProperty(employees[e].$id)) {
                            employees[e].calculations = dispersion.calculations[employees[e].$id].calculations;
                            dEmployees.push(employees[e]);
                        }
                    } else {
                        if (dispersion.employees.hasOwnProperty(employees[e].$id)) {
                            employees[e].calculations = dispersion.calculations[employees[e].$id].calculations;
                            dEmployees.push(employees[e]);
                        }
                    }
                } else {
                    dEmployees.push(employees[e]);
                }
            }
            return dEmployees;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('onlyCalculationType', onlyCalculationType)

    function onlyCalculationType() {

        return onlyCalculationTypeFn;

        function onlyCalculationTypeFn(calculations, type) {
            var newArray = {};
            for (var c in calculations) {
                var thisCalc = calculations[c];
                if (typeof(thisCalc) == "object" && typeof(thisCalc.value) == "object" && thisCalc.value.nature === type) {
                    newArray[c] = thisCalc;
                }
            }
            return newArray;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('notAbsences', notAbsences)

    function notAbsences(AppF,getSomethingOfArrayFBFilter) {

        return notAbsencesFn;

        function notAbsencesFn(incidences) {
            var newIncidences = {};
            angular.forEach(incidences, function(value, i) {
                var affect = getSomethingOfArrayFBFilter(i, AppF.incidencesTypes, 'affect', false);
                if (affect != 'days') newIncidences[i] = value;
            })
            return newIncidences;
        }
    }

}());
angular.module('app.clients').filter('noWhiteSpace', function () {
    return function (input) {
        if (!input) return '';
        return input.replace(/\s+/g, '');
    };
});

angular.module('app.clients').filter('monthName', function () {
    return function (monthNumber) {
        if (!monthNumber && monthNumber !== 0) return '';

        var months = [
            'ENERO', 'FEBRERO', 'MARZO', 'ABRIL', 'MAYO', 'JUNIO',
            'JULIO', 'AGOSTO', 'SEPTIEMBRE', 'OCTUBRE', 'NOVIEMBRE', 'DICIEMBRE'
        ];
        return months[monthNumber - 1] || '';
    };
});
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('listenRps', listenRps)

    function listenRps(AppF) {

        return listenRpsFn;

        function listenRpsFn(employee) {
            if (!angular.isDefined(AppF.rpsData)) {
                AppF.rpsData = {};
            }
            if (employee.movements) {
                for (var e in employee.movements) {
                    if (typeof(employee.movements[e]) == 'object') {
                        var movement = employee.movements[e];
                        if (movement.rp) {
                            if (!angular.isDefined(AppF.rpsData[movement.rp])) {
                                AppF.rpsData[movement.rp] = AppF.root.child("catalogs/rps/collection").child(movement.rp).once("value");
                            }
                        }
                    }
                }
            }
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('listenMovements', listenMovements)

    function listenMovements(AppF) {

        return listenMovementsFn;

        function listenMovementsFn(movements) {
            if (!angular.isDefined(AppF.movements)) {
                AppF.movements = {};
            }
            angular.forEach(movements, function(movement, mkey) {
                if (!angular.isDefined(AppF.movements[movement.$id])) {
                    AppF.movements[movement.$id] = AppF.root.child("catalogs/movements/collection").child(movement.$id).once("value");
                }
            });
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('listenCredits', listenCredits)

    function listenCredits(AppF) {

        return listenCreditsFn;

        function keepListening(employeeId, periodEnd) {
            AppF.root.child("catalogs/credits/collection").orderByChild('employee').equalTo(employeeId).on("value", function(snapshot) {
                var credit = [];
                snapshot.forEach(function(childSnapshot) {
                    var obj = childSnapshot.val();
                    obj.$id = childSnapshot.key;
                    if (obj.valid && obj.data && obj.data.date <= periodEnd) {
                        credit.push(obj)
                    }
                });
                AppF.creditsData[employeeId] = credit;
            });
        }

        function getCredits(employeeId, periodEnd) {
            return new Promise(function(resolve, reject) {
                AppF.root.child("catalogs/credits/collection").orderByChild('employee').equalTo(employeeId).once("value").then(function(snapshot) {
                    var credit = [];
                    snapshot.forEach(function(childSnapshot) {
                        var obj = childSnapshot.val();
                        obj.$id = childSnapshot.key;
                        if (obj.valid && obj.data && obj.data.date <= periodEnd) {
                            credit.push(obj)
                        }
                    });
                    keepListening(employeeId, periodEnd);
                    resolve(credit)
                }, function(error) {
                    reject(error);
                });
            })
        }

        function listenCreditsFn(employee, period) {
            if (!angular.isDefined(AppF.creditsData)) {
                AppF.creditsData = {};
            }
            if (!angular.isDefined(AppF.creditsData[employee.$id])) {
                AppF.creditsData[employee.$id] = getCredits(employee.$id, period.end);
            }
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('listenConstants', listenConstants)

    function listenConstants(AppF, $firebaseArray) {

        return listenConstantsFn;

        function listenConstantsFn(employee) {
            var checkCategories = [{
                name: "cc",
                priority: 21
            }, {
                name: "employee",
                priority: 31
            }, {
                name: "general",
                priority: 1
            }, {
                name: "payroll",
                priority: 11
            }];
            if (!angular.isDefined(AppF.constants)) {
                AppF.constants = {};
            }
            angular.forEach(checkCategories, function(cat, index) {
                var category = cat.name;
                switch (category) {
                    case "employee":
                        if (!angular.isDefined(AppF.constants["employee/" + employee.$id])) {
                            AppF.constants["employee/" + employee.$id] = {
                                object: $firebaseArray(AppF.root.child("constants/employee").child(employee.payroll).orderByChild('employee').equalTo(employee.$id)),
                                priority: cat.priority
                            }
                        }
                        break;
                    case "general":
                        if (!angular.isDefined(AppF.constants.general)) {
                            AppF.constants.general = {
                                object: $firebaseArray(AppF.root.child("constants/general")),
                                priority: cat.priority
                            }
                        }
                        break;
                    case "payroll":
                    if (angular.isDefined(employee[category])) {
                        if (!angular.isDefined(AppF.constants[category + "/" + employee[category]])) {
                            AppF.constants[category + "/" + employee[category]] = {
                                object: $firebaseArray(AppF.root.child("constants").child(category).child(employee.payroll)),
                                priority: cat.priority
                            }
                        }
                    }
                        break;
                    case "cc": // and others (for future)
                        if (angular.isDefined(employee[category])) {
                            if (!angular.isDefined(AppF.constants[category + "/" + employee[category]])) {
                                AppF.constants[category + "/" + employee[category]] = {
                                    object: $firebaseArray(AppF.root.child("constants").child(category).child(employee.payroll).orderByChild(category).equalTo(employee[category])),
                                    priority: cat.priority
                                }
                            }
                        }
                        break;
                }
            });
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('listenCcs', listenCcs)

    function listenCcs(AppF) {

        return listenCcsFn;

        function listenCcsFn(employee, operationEmployee) {
            if (!angular.isDefined(AppF.ccsData)) {
                AppF.ccsData = {};
            }
            var ccsOfEmployee = [];
            for (var m in employee.movements) {
                if (employee.movements[m].cc) {
                    ccsOfEmployee.push(employee.movements[m].cc);
                }
            }
            if (employee.cc) {
                ccsOfEmployee.push(employee.cc);
            }
            for (var i = 0; i < ccsOfEmployee.length; i++) {
                var thisCc = ccsOfEmployee[i];
                if (!angular.isDefined(AppF.ccsData[thisCc])) {
                    AppF.ccsData[thisCc] = AppF.root.child("catalogs/ccs/collection").child(thisCc).once("value");
                }
            }

        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('incidencesByType', incidencesByType)

    function incidencesByType(
        getSomethingOfArrayMFilter,
        MongoF
    ) {

        return incidencesByTypeFn;

        function incidencesByTypeFn(incidences, employees, fast, all, constant, notInclude) {
            var incidencesFiltered = {};
            for (var i in incidences) {
                var incidence = incidences[i];
                var internalCode = incidence.incidenceType
                    //if (incidence.hasOwnProperty('$id') && internalCode) {
                if (all) {
                    if (notInclude) {
                        if (incidence.type != notInclude) {
                            // si no se tiene el tipo de incidencia se crea
                            if (!incidencesFiltered.hasOwnProperty(internalCode)) {
                                incidencesFiltered[internalCode] = {};
                            }
                            for (var e in employees) {
                                var employee = employees[e];
                                if (employee.hasOwnProperty('$id')) {
                                    if (!incidencesFiltered[internalCode].hasOwnProperty(employee.$id)) {
                                        incidencesFiltered[internalCode][employee.$id] = [];
                                    }
                                    if (incidence.employee == employee.$id) {
                                        incidencesFiltered[internalCode][employee.$id].push(incidence);
                                    }
                                }
                            }
                        }

                    } else {
                        // si no se tiene el tipo de incidencia se crea
                        if (!incidencesFiltered.hasOwnProperty(internalCode)) {
                            incidencesFiltered[internalCode] = {};
                        }
                        for (var e in employees) {
                            var employee = employees[e];
                            if (employee.hasOwnProperty('$id')) {
                                if (!incidencesFiltered[internalCode].hasOwnProperty(employee.$id)) {
                                    incidencesFiltered[internalCode][employee.$id] = [];
                                }
                                if (incidence.employee == employee.$id) {
                                    incidencesFiltered[internalCode][employee.$id].push(incidence);
                                }
                            }
                        }
                    }

                } else {
                    if (fast) {
                        if (incidence.type == 'fast') {
                            // si no se tiene el tipo de incidencia se crea
                            if (!incidencesFiltered.hasOwnProperty(internalCode)) {
                                incidencesFiltered[internalCode] = {};
                            }
                            for (var e in employees) {
                                var employee = employees[e];
                                if (employee.hasOwnProperty('$id')) {
                                    if (!incidencesFiltered[internalCode].hasOwnProperty(employee.$id)) {
                                        incidencesFiltered[internalCode][employee.$id] = {};
                                    }
                                    if (incidence.employee == employee.$id) {
                                        incidencesFiltered[internalCode][employee.$id] = incidence;
                                    }
                                }
                            }
                        }
                    } else if (constant) {
                        if (incidence.type == "constant") {
                            if (!incidencesFiltered.hasOwnProperty(internalCode)) {
                                incidencesFiltered[internalCode] = {};
                            }
                            for (var e in employees) {
                                var employee = employees[e];
                                if (employee.hasOwnProperty('$id')) {
                                    if (!incidencesFiltered[internalCode].hasOwnProperty(employee.$id)) {
                                        incidencesFiltered[internalCode][employee.$id] = {};
                                    }
                                    if (incidence.employee == employee.$id) {
                                        if (angular.isDefined(incidencesFiltered[internalCode][employee.$id].value)) {
                                            var value = parseFloat(incidencesFiltered[internalCode][employee.$id].value) + parseFloat(incidence.value);
                                            incidencesFiltered[internalCode][employee.$id].value = "" + value;
                                        } else {
                                            incidencesFiltered[internalCode][employee.$id] = incidence;
                                        }
                                    }

                                }
                            }
                        }
                    } else {
                        if (incidence.type !== 'fast') {
                            // si no se tiene el tipo de incidencia se crea
                            if (!incidencesFiltered.hasOwnProperty(internalCode)) {
                                incidencesFiltered[internalCode] = {};
                            }
                            for (var e in employees) {
                                var employee = employees[e];
                                if (employee.hasOwnProperty('$id')) {
                                    if (!incidencesFiltered[internalCode].hasOwnProperty(employee.$id)) {
                                        incidencesFiltered[internalCode][employee.$id] = [];
                                    }
                                    if (incidence.employee == employee.$id) {
                                        incidencesFiltered[internalCode][employee.$id].push(incidence);
                                    }
                                }
                            }
                        }
                    }
                }
                //}
            }

            return incidencesFiltered;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('incidencesByField', incidencesByField)

    function incidencesByField() {

        return incidencesByFieldFn;

        function incidencesByFieldFn(incidences, employees, groupByThisField, completeFields, includeQuery, fieldToQuery, fieldValue, arrayOrObject, fieldsToGroup) {
            //includeQuery: 0 o undefined - No filtran las incidences; 1 - Se filtran solo las incidencias con este valor, 2 - Se filtran solo las incidencias diferentes a este valor(Para que funciones es necesario los campos fieldToQuery y fieldValue)
            var incidencesFiltered = {};
            var incidencesField = {};
            angular.forEach(incidences, function(incidence) {
                var employeeFound = false;
                for (var e in employees) {
                    if (incidence.employee == employees[e].$id) {
                        employeeFound = true;
                    }
                }
                if (employeeFound) {
                    var proccess = true;
                    if (includeQuery && fieldToQuery && fieldValue) {
                        var hasThisValue = false;
                        if (typeof(fieldValue) == "object") {
                            if (typeof(fieldValue.length) !== "undefined") {
                                hasThisValue = fieldValue.indexOf(incidence[fieldToQuery]) > -1 ? true : false;
                            } else {
                                hasThisValue = typeof(fieldValue[incidence[fieldToQuery]]) !== "undefined" ? true : false;
                            }
                        } else {
                            hasThisValue = incidence[fieldToQuery] == fieldValue ? true : false;
                        }

                        switch (includeQuery) {
                            case 1:
                                proccess = hasThisValue;
                                break;
                            case 2:
                                proccess = !hasThisValue;
                                break;
                        }
                    }
                    if (proccess) {
                        incidencesField[incidence[groupByThisField]] = true;
                        if (!angular.isDefined(incidencesFiltered[incidence[groupByThisField]])) incidencesFiltered[incidence[groupByThisField]] = {};
                        switch (arrayOrObject) {
                            case "object":
                                if (!angular.isDefined(incidencesFiltered[incidence[groupByThisField]][incidence.employee])) {
                                    incidencesFiltered[incidence[groupByThisField]][incidence.employee] = angular.copy(incidence);
                                    incidencesFiltered[incidence[groupByThisField]][incidence.employee].$ids = [incidence.$id];
                                    delete incidencesFiltered[incidence[groupByThisField]][incidence.employee].$id;
                                    for (var f in fieldsToGroup) {
                                        var fieldToSeach = f;
                                        var fieldToGroup = fieldsToGroup[f];
                                        if (typeof(incidence[fieldToSeach]) !== "undefined") {
                                            incidencesFiltered[incidence[groupByThisField]][incidence.employee][fieldToGroup] = [incidence[fieldToSeach]];
                                            delete incidencesFiltered[incidence[groupByThisField]][incidence.employee][fieldToSeach];
                                        }
                                    }
                                } else {
                                    incidencesFiltered[incidence[groupByThisField]][incidence.employee].$ids.push(incidence.$id);
                                    incidencesFiltered[incidence[groupByThisField]][incidence.employee].value += incidence.value;
                                    for (var f in fieldsToGroup) {
                                        var fieldToSeach = f;
                                        var fieldToGroup = fieldsToGroup[f];
                                        if (typeof(incidence[fieldToSeach]) !== "undefined") {
                                            incidencesFiltered[incidence[groupByThisField]][incidence.employee][fieldToGroup].push(incidence[fieldToSeach]);
                                        }
                                    }
                                }
                                break;
                            default:
                                if (!angular.isDefined(incidencesFiltered[incidence[groupByThisField]][incidence.employee])) incidencesFiltered[incidence[groupByThisField]][incidence.employee] = [];
                                incidencesFiltered[incidence[groupByThisField]][incidence.employee].push(incidence);
                                break;
                        }

                    }
                }
            });
            if (completeFields) {
                angular.forEach(incidencesField, function(incidenceField, incidenceFielId) {
                    angular.forEach(employees, function(employee, eindex) {
                        if (!angular.isDefined(incidencesFiltered[incidenceFielId])) incidencesFiltered[incidenceFielId] = {};
                        switch (arrayOrObject) {
                            case "object":
                                if (!angular.isDefined(incidencesFiltered[incidenceFielId][employee.$id])) incidencesFiltered[incidenceFielId][employee.$id] = {
                                    value: 0
                                };
                                break;
                            default:
                                if (!angular.isDefined(incidencesFiltered[incidenceFielId][employee.$id])) incidencesFiltered[incidenceFielId][employee.$id] = [];
                                break;
                        }



                    });
                })
            }
            return incidencesFiltered;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('incidencesByEmployee', incidencesByEmployee)

    function incidencesByEmployee() {

        return incidencesByEmployeeFn;

        function incidencesByEmployeeFn(incidences, employees) {
            var employeesIncidences = {};
            angular.forEach(incidences, function(incidence, ikey) {
                angular.forEach(employees, function(employee, ekey) {
                    if (!angular.isDefined(employeesIncidences[employee.$id])) {
                        employeesIncidences[employee.$id] = [];
                    }
                    if(incidence.employee==employee.$id){
                        employeesIncidences[employee.$id].push(incidence);
                    }
                });
            });
            return employeesIncidences;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('incidenceAffect', incidenceAffect)

    function incidenceAffect(
        AppF,
        getSomethingOfArrayFBFilter
    ) {

        return incidenceAffectFn;

        function incidenceAffectFn(id, affect) {
            var result = getSomethingOfArrayFBFilter(id, AppF.incidencesTypes, 'affect', "");
            return result == affect;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('getTotalValueIncidences', getTotalValueIncidences)

    function getTotalValueIncidences() {

        return getTotalValueIncidencesFn;

        function getTotalValueIncidencesFn(allIncidences) {
            var total = 0;
            angular.forEach(allIncidences, function(incidence) {
                total += parseFloat(incidence.value);
            });
            return total;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getTotalOfTaxedExemptFormula', getTotalOfTaxedExemptFormula)

    function getTotalOfTaxedExemptFormula(replaceAllFilter, errAlertS, getConstantFormulaFilter) {

        return getTotalOfTaxedExemptFormulaFn;

        function getTotalOfTaxedExemptFormulaFn(total, value, formula, calcFields, employee, payroll, operation, umaRecord, constants) {
            console.log(total, value, formula);
            var valor = 0;
            var valueToReplace = undefined;
            if (typeof (formula) == "string") {
                // console.log(formula.search("\\$gravado"), formula.search("\\$exento"));
                if (formula.search("\\$gravado") > -1) {
                    valueToReplace = "gravado";
                } else if (formula.search("\\$exento") > -1) {
                    valueToReplace = "exento";
                } else {
                    errAlertS("Alguna de las formulas para el calculo de las partes exentas y gravadas no esta bien configurada")
                }
            } else {
                errAlertS("No se ha definido una configuracion para calcular las partes exentas y gravadas de alguna regla verifique la configuracion")
            }
            if (typeof (valueToReplace) !== "undefined") {
                var $total = typeof (total) == "number" ? total : 0;
                var $valor = typeof (value) == "number" ? value : 0;
                formula = replaceAllFilter(formula, "\\$" + valueToReplace, "valor");
                var getRealFormula = getConstantFormulaFilter(formula, calcFields, 1);
                if (getRealFormula.valid) {
                    var finalFormula = getRealFormula.formula;
                    try {
                        eval(finalFormula);
                    } catch (error) {
                        console.error(error);
                        errAlertS("Hay un error en la formula para el calculo de las partes exentas y gravadas");
                    }
                } else {
                    errAlertS("Hay un error en la formula para el calculo de las partes exentas y gravadas");
                }
                console.log(getRealFormula);
            }
            return valor;

        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('getTotalOfCalculations', getTotalOfCalculations)

    function getTotalOfCalculations() {

        return getTotalOfCalculationsFn;

        function getTotalOfCalculationsFn(calculations, nature) {
            var totals = {
                total: 0,
                onlyIncidencesAmount: 0
            };
            if (typeof(calculations) == "object") {
                for (var c in calculations) {
                    var thisCalc = calculations[c];
                    if (typeof(thisCalc) == "object" && typeof(thisCalc.value) == "object" && thisCalc.value.nature == nature && thisCalc.value.addToTotal) {
                        totals.total += thisCalc.value.total;
                        if (thisCalc.value.incidence) {
                            totals.onlyIncidencesAmount += thisCalc.value.total;
                        }
                    }
                }
            }
            return totals;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getTotalOfArrayField', getTotalOfArrayField)

    function getTotalOfArrayField() {
        //getTotalOfCaculations
        return getTotalOfArrayFieldFn;

        function getItem(array, callback) {
            if (angular.isArray(array)) {
                for (var i = 0; i < array.length; i++) {
                    callback(array[i]);
                }
            } else {
                angular.forEach(array, function (item) {
                    callback(item);
                })
            }
        }

        function getTotalOfArrayFieldFn(array, path) {
            var total = 0;

            getItem(array, function (item) {
                var value = 0;
                var pathToSum = path.split(".");
                var whereToSum = item;
                if (typeof (item) !== "undefined") {
                    for (var i = 0; i < pathToSum.length; i++) {
                        var field = pathToSum[i];
                        if (angular.isDefined(whereToSum[field])) {
                            if (i + 1 >= pathToSum.length) {
                                var typeOfVar = typeof (whereToSum[field]);
                                switch (typeOfVar) {
                                    case "number":
                                        if (!isNaN(whereToSum[field])) {
                                            value = whereToSum[field];
                                        }
                                        break;
                                    case "string":
                                        var valueParsed = parseFloat(whereToSum[field]);
                                        if (!isNaN(valueParsed)) value = valueParsed
                                        break;
                                }
                            } else {
                                whereToSum = whereToSum[field];
                            }
                        } else {
                            i = pathToSum.length;
                        }
                    }
                }
                total += value;
            });
            total = Math.round(total * 10000) / 10000;
            return total;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getTotalByConstant', getTotalByConstant)

    function getTotalByConstant(replaceAllFilter, getConstantFormulaFilter) {

        return getTotalByConstantFn;

        function getTotalByConstantFn(valor, constant, type, formula, fields, employee, payroll, operation, umaRecord, nfdRecord, minimumVariables, constants) {
            var data = {
                total: 0,
                formula: ""
            };
            switch (constant.affect.operator) {
                case "equalTo":
                    constant.affect.value = parseFloat(constant.affect.value);
                    data.formula = "(" + formula + ") = " + constant.affect.value;
                    data.total = constant.affect.value;
                    break;
                case "percentOf":
                    constant.affect.value = parseFloat(constant.affect.value);
                    data.formula = "(" + formula + ") * " + constant.affect.value + "/100 ";
                    data.total = valor * (constant.affect.value / 100);
                    break;
                case "sumTo":
                    constant.affect.value = parseFloat(constant.affect.value);
                    data.formula = "(" + formula + ") + " + constant.affect.value;
                    data.total = valor + constant.affect.value;
                    break;
                case "restTo":
                    constant.affect.value = parseFloat(constant.affect.value);
                    data.formula = "(" + formula + ") - " + constant.affect.value;
                    data.total = valor - constant.affect.value;
                    break;
                case "mutiply":
                    constant.affect.value = parseFloat(constant.affect.value);
                    data.formula = "(" + formula + ") * " + constant.affect.value;
                    data.total = valor * constant.affect.value;
                    break;
                case "divide":
                    constant.affect.value = parseFloat(constant.affect.value);
                    data.formula = "(" + formula + ") / " + constant.affect.value;
                    data.total = valor / constant.affect.value;
                    break;
                case "calcule":
                    if (type == "valor") {
                        var $valor = valor;
                    } else if (type == "total") {
                        var $total = valor;
                    }
                    data.formula = replaceAllFilter(constant.affect.value, "\\$" + type, "(" + formula + ")");
                    var getRealFormula = getConstantFormulaFilter(constant.affect.value, fields, 1);
                    if (getRealFormula.valid) {
                        data.total = eval(getRealFormula.formula);
                        if (isNaN(data.total)) {
                            data.total = 0;
                        }
                    } else {
                        data.total = 0;
                    }
                    break;
                default:
                    data.formula = formula;
                    data.total = valor;
                    break;
            }
            return data;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getSubsidyOfTable', getSubsidyOfTable)

    function getSubsidyOfTable(MongoF, DataF, $log, orderByFilter) {

        return getSubsidyOfTableFn;

        function getSubsidyOfTableFn(gravableBase, date, type) {
            if (angular.isArray(MongoF.subsidyRecords)) {
                type = type ? type : 'monthly';
                var year = angular.isDefined(date) ? moment(date) : moment(DataF.getCurrentServerTime());
                year = parseInt(year.format('YYYY'));
                var subsidyRecords = MongoF.subsidyRecords.slice().filter(function (item) {
                    return (item.type || 'monthly') === type;
                });
                var ordered = orderByFilter(subsidyRecords, ['-year', '-lowerLimit']);
                var thisRecord = ordered.find(function (item) {
                    return gravableBase >= item.lowerLimit && item.year === year;
                });
                if (angular.isUndefined(thisRecord)) {
                    thisRecord = ordered.find(function (item) {
                        return gravableBase >= item.lowerLimit && item.year < year;
                    });
                }
                if (angular.isUndefined(thisRecord)) {
                    thisRecord = ordered.find(function (item) {
                        return gravableBase >= item.lowerLimit;
                    });
                }
                if (angular.isDefined(thisRecord)) {
                    return thisRecord.subsidy;
                }
            }
            return 0;
        }
    }

}());
(function(){
    'use strict';

    angular
        .module('app.clients')
        .filter('getSubsidyOfPeriod', getSubsidyOfPeriod)

    function getSubsidyOfPeriod(){

        return getSubsidyOfPeriodFn;

        function getSubsidyOfPeriodFn(subsidyOfTable, mensualizationFactor, workedDays){
            var subsidy = 0;
            if(subsidyOfTable && mensualizationFactor && workedDays) subsidy = (subsidyOfTable/mensualizationFactor)*workedDays;
            return subsidy;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getSalaryByDay', getSalaryByDay)

    function getSalaryByDay(getActiveDayFilter) {

        return getSalaryByDayFn;

        function getSalaryByDayFn(activeDays, period) {
            var firstDay = moment(period.start);
            var lastDay = moment(period.end);
            var days = {};
            while (firstDay.valueOf() <= lastDay.valueOf()) {
                var founded = getActiveDayFilter(firstDay.valueOf(), activeDays);
                var endDate = moment(firstDay.valueOf()).add(1, "d");
                endDate.subtract(1, "ms");
                var salaryObj = {
                    rSd: 0,
                    rSbc: 0,
                    rSdr: 0,
                    start: firstDay.valueOf(),
                    end: endDate.valueOf(),
                    isActive: false,
                    isAbsences: false
                }
                if (founded.length) {
                    try {
                        salaryObj.rSd = founded[0].startMovement.data.sd ? founded[0].startMovement.data.sd : 0;
                        salaryObj.rSbc = founded[0].startMovement.data.sbc ? founded[0].startMovement.data.sbc : 0;
                        salaryObj.rSdr = founded[0].startMovement.data.sdr ? founded[0].startMovement.data.sdr : 0;
                        salaryObj.isActive = true;
                    } catch (error) {
                        console.error(error);
                    }
                }
                days[firstDay.format("DD-MM-YYYY")] = salaryObj;
                firstDay.add(1, "d");
            }
            return days;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('getPriorityMap', getPriorityMap)

    function getPriorityMap(orderByFilter, mergeObjectsOfArrayPropertiesFilter, filterFilter) {

        return getPriorityMapFn;

        function getPriorityMapFn(priorityMap, incidencesPrioritys, incidencesTypes, satIncidencesTypes, complementIncidencesTypes) {
            if (typeof(priorityMap) == "undefined") {
                priorityMap = {
                    FISCAL: {},
                    REAL: {}
                };
            }
            var thisIncidencesTypes = orderByFilter(mergeObjectsOfArrayPropertiesFilter(filterFilter(incidencesTypes, {
                nature: "deduction",
                affect: "salary"
            }), incidencesPrioritys, "$id", "incidenceType", "priority"), ["priority"]);
            var thisSatIncidencesTypes = orderByFilter(mergeObjectsOfArrayPropertiesFilter(filterFilter(satIncidencesTypes, {
                nature: "deduction",
                affect: "salary"
            }), incidencesPrioritys, "_id", "incidenceType", "priority"), ["priority"]);
            console.log(thisIncidencesTypes, thisSatIncidencesTypes);
            for (var i = 0; i < thisIncidencesTypes.length; i++) {
                priorityMap.REAL[thisIncidencesTypes[i].$id] = i;
            }
            for (var t = 0; t < thisSatIncidencesTypes.length; t++) {
                priorityMap.FISCAL[thisSatIncidencesTypes[t]._id] = t;
            }
            //console.log(priorityMap);
            return priorityMap;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('getPeriodEmployees', getPeriodEmployees)

    function getPeriodEmployees(orderByFilter, activeDaysFromMovementsFilter, getObjectOfArrayByIdFilter) {

        return getPeriodEmployeesFn;

        function getPeriodEmployeesFn(employees, period) {
            var periodEmployess = [];
            angular.forEach(employees, function(employee) {
                var activeDays = activeDaysFromMovementsFilter(orderByFilter(employee.movements, "data.date"), period, []);
                var movements = [];
                //console.log(activeDays,employee.$id);
                angular.forEach(activeDays, function(activeDay) {
                    var addToActiveDays = true;
                    if (angular.isDefined(activeDay.endMovement) && angular.isDefined(activeDay.endMovement.data)) {
                        if (activeDay.endMovement.data.type == 2 && !activeDay.endMovement.data.paySalaryInPayrol) {
                            addToActiveDays = false;
                        }
                    }
                    if (addToActiveDays) {
                        if (activeDay.startMovementId) {
                            var obj = getObjectOfArrayByIdFilter(activeDay.startMovementId, movements);
                            if (obj === null) {
                                var movement = getObjectOfArrayByIdFilter(activeDay.startMovementId, employee.movements);
                                if (movement !== null) {
                                    movements.push(movement);
                                }
                            }
                        }
                        if (activeDay.endMovementId) {
                            var obj = getObjectOfArrayByIdFilter(activeDay.endMovementId, movements);
                            if (obj === null) {
                                var movement = getObjectOfArrayByIdFilter(activeDay.endMovementId, employee.movements);
                                if (movement !== null) {
                                    movements.push(movement);
                                }
                            }
                        }
                    }
                });
                if (movements.length) {
                    employee.movements = movements;
                    periodEmployess.push(employee);
                }
            });
            return periodEmployess;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('getOperationPermissions', getOperationPermissions)

    function getOperationPermissions(AppF, userHasPermissionFilter) {

        return getOperationPermissionsFn;

        function getOperationPermissionsFn() {
            var operationPermissions = {};
            operationPermissions.sendOperationToRevision = userHasPermissionFilter(AppF.groupsOfUser, AppF.permissions, 'sendToReview', 'processes.operations');
            operationPermissions.sendOperationToFinalRevision = userHasPermissionFilter(AppF.groupsOfUser, AppF.permissions, 'sendToFinalRevision', 'processes.operations');
            operationPermissions.closeOperation = userHasPermissionFilter(AppF.groupsOfUser, AppF.permissions, 'sendPreBill', 'processes.operations');
            return operationPermissions;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getOperationDataObjects', getOperationDataObjects)

    function getOperationDataObjects(
        $q,
        AppF,
        DataF,
        $filter
    ) {
        //{data_operation_calendar}-{data_operation_period}

        return function (operation, operationTab, moveBack, operationStatusName, employees, comment) {
            console.log(employees);
            var promise = $q.defer();
            var querys = {};
            var plainData = {};
            // acc setings
            plainData.styles = {
                td: 'border-bottom: 1px dotted #282c37; margin-right: 5px; margin-bottom: 5px; padding: 0px !important; ',
                strong: 'font-weight: 600;',
                br: 'line-height: 5px',
                hidden: 'display: none !important; visibility: hidden !important;'
            };

            // salaries
            plainData.realSpan = 1;

            //plainData.operation = JSON.parse(JSON.stringify(operation));
            querys.payrollClass = AppF.root.child('catalogs/payrolls/collection').child(operation.payroll).child('data/class').once('value');
            querys.payrollName = AppF.root.child('lists/payrolls/all').child(operation.payroll).child('name').once('value');
            querys.payrollPaymentFrequency = AppF.root.child('catalogs/payrolls/collection').child(operation.payroll).child('paymentFrequency').once('value');
            querys.createdBy = AppF.root.child('profiles').child(operation.created.by).child('data/name').once('value');
            querys.capturedBy = AppF.root.child('profiles').child(AppF.profile.uid).child('data/name').once('value');

            $q.all(querys).then(function (allData) {
                plainData.center = AppF.center;
                plainData.payrollName = allData.payrollName.val();
                plainData.payrollClass = allData.payrollClass.val();
                plainData.createdBy = allData.createdBy.val();
                plainData.capturedBy = allData.capturedBy.val();
                plainData.payrollPaymentFrequency = allData.payrollPaymentFrequency.val();
                var subQuerys = {};
                subQuerys.paymentFrequenciesRecordName = DataF.api.get('paymentFrequenciesRecords/' + plainData.payrollPaymentFrequency);
                plainData.operationType = angular.isDefined(operationTab) ? operationTab : 'ordinary';
                plainData.action = moveBack ? 'regresada' : 'actualizada';
                plainData.statusName = operationStatusName;
                plainData.msg = ' actualizo a ' + operationStatusName + ' la ';
                if (moveBack) {
                    plainData.msg = ' regreso a ' + operationStatusName + ' la ';
                }
                plainData.operation = operation;
                plainData.operation.comment = comment;
                plainData.employees = [];
                var omitted = ["daily_salary", "deductions", "perceptions", "workedDays",];
                var sendEmailsToEmployees = $filter('userHasPermission')(AppF.groupsOfUser, AppF.permissions, 'sendEmailEmployees', 'processes.operations');
                if (typeof (employees) == "object" && sendEmailsToEmployees) {
                    for (var e = 0; e < employees.length; e++) {
                        var thisEmployee = employees[e];
                        var email = undefined;
                        if (typeof (thisEmployee.data) !== "undefined" && typeof (thisEmployee.data.info) !== "undefined" && typeof (thisEmployee.data.info.emails) !== "undefined") {
                            for (var m in thisEmployee.data.info.emails) {
                                var thisEmail = thisEmployee.data.info.emails[m];
                                if (typeof (thisEmail) == "object" && thisEmail.active === true) {
                                    email = thisEmail.email;
                                }
                            }
                        }
                        if (typeof (email) !== "undefined") {
                            var calculations = {};
                            var total = {}
                            var newCalculations = [];
                            if (typeof (thisEmployee.calculations) == "object" && typeof (thisEmployee.calculations.REAL) == "object") {
                                calculations = thisEmployee.calculations.REAL;
                                for (var c in calculations) {
                                    console.log(c);
                                    if (omitted.indexOf(c) == -1) {
                                        var thisCalculation = JSON.parse(JSON.stringify(calculations[c].value));
                                        console.log(thisCalculation);
                                        if (typeof (thisCalculation) == "object" && thisCalculation.type == "currency") {
                                            thisCalculation.name = $filter("uppercase")(thisCalculation.name);
                                            if (thisCalculation.nature == "deduction") {
                                                thisCalculation.total = $filter("currency")(thisCalculation.total * -1);
                                            } else {
                                                thisCalculation.total = $filter("currency")(thisCalculation.total)
                                            }
                                            if (c == "netRealSalary") {
                                                total = thisCalculation;
                                            } else {
                                                newCalculations.push(thisCalculation);
                                            }

                                        }
                                    }
                                }
                                calculations = $filter('orderBy')(newCalculations, ['weight', 'name']);
                            }
                            var thisEmployee = {
                                name: thisEmployee.data.name ? thisEmployee.data.name : "",
                                sd: thisEmployee.data.salary.sdr ? thisEmployee.data.salary.sdr : 0,
                                rfc: thisEmployee.data.rfc ? thisEmployee.data.rfc : "",
                                email: email,
                                calculations: calculations,
                                total: total
                            };
                            plainData.employees.push(thisEmployee);
                        }
                    }
                }


                $q.all(subQuerys).then(function (allSubData) {
                    if (allSubData.paymentFrequenciesRecordName.data) {
                        plainData.paymentFrequenciesRecordName = allSubData.paymentFrequenciesRecordName.data.name;
                        promise.resolve(plainData);
                    } else {
                        console.error('No se encontro registro de frecuencia de pago', allSubData.paymentFrequenciesRecordName, plainData.payrollPaymentFrequency);
                        promise.reject('No se encontro registro de frecuencia de pago')
                    }
                }, function (err2) {
                    promise.reject(err2);
                });
            }, function (err) {
                promise.reject(err);
            });

            return promise.promise;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getOperationCcs', getOperationCcs)

    function getOperationCcs() {

        return getOperationCcsFn;
        function getCcsIndex(item) {
            return item.$id == this;
        }
        function getOperationCcsFn(ccs, allowedCcs) {
            var thisCcs = [];
            for (var i = 0; i < ccs.length; i++) {
                var index = allowedCcs.findIndex(getCcsIndex, ccs[i].$id);
                if (index > -1) {
                    thisCcs.push(ccs[i]);
                }
            }
            return thisCcs;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('getNotAppliedIncidences', getNotAppliedIncidences)

    function getNotAppliedIncidences() {

        return getNotAppliedIncidencesFn;

        function getNotAppliedIncidencesFn(allIncidences) {
            var incidences = [];
            angular.forEach(allIncidences, function(incidence) {
                if (incidence.status >= 0 && incidence.status < 3) {
                    incidences.push(incidence);
                }
            });
            return incidences;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('getNeededIncidences', getNeededIncidences)

    function getNeededIncidences(filterFilter, errAlertS, setInObjectPathFilter) {

        return getNeededIncidencesFn;

        function getNeededIncidencesFn(incidencesTypes, complementIncidences, allProccess) {
            //console.log(incidencesTypes, complementIncidences, allProccess);
            var toQueryObjects = {
                incidencesTypes: incidencesTypes,
                complementIncidences: complementIncidences
            }
            var incidences = {};
            var necessaryIncidences = [{
                filter: {
                    directive: "001PF"
                },
                erroMsg: "No se encontro la incidencia de sueldo fiscal, favor de checar la configuracion",
                path: "fiscalSalaryIncidence",
                object: "incidencesTypes"
            }, {
                filter: {
                    directive: "002DF"
                },
                erroMsg: "No se encontro la incidencia de isr",
                path: "isrIncidence",
                object: "incidencesTypes"
            }, {
                filter: {
                    directive: "002PF"
                },
                erroMsg: "No se encontro la incidencia de subsidio",
                path: "subsidyIncidence",
                object: "incidencesTypes"
            }]
            for (var a in allProccess) {
                if (typeof(allProccess[a]) == "object") {
                    necessaryIncidences.push({
                        filter: {
                            forSalary: true,
                            process: allProccess[a].type
                        },
                        erroMsg: "No se encontro la incidencia para el complemento",
                        path: "complementSalaryIncidence." + allProccess[a].type,
                        object: "complementIncidences"
                    })
                }

            }
            //console.log(necessaryIncidences);
            for (var i = 0; i < necessaryIncidences.length; i++) {
                var thisIncidence = necessaryIncidences[i];
                var founded = filterFilter(toQueryObjects[thisIncidence.object], thisIncidence.filter, true);
                if (founded.length > 0) {
                    setInObjectPathFilter(thisIncidence.path, incidences, founded[0], true, true);
                } else {
                    errAlertS(thisIncidence.erroMsg);
                }
            }
            //console.log(incidences);
            return incidences;

        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('getMovements', getMovements)

    function getMovements($rootScope, groupByFieldFilter) {

        return getMovementsFn;

        function getMovementsFn(payrollId, from, to) {
            return new Promise(function(resolve, reject) {
                var queryAggregate = [{
                        '$match': {
                            'payroll': payrollId,
                            'data.date': {
                                '$lt': from
                            },
                            'status': {
                                '$gt': 1
                            }
                        }
                    },
                    {
                        '$sort': {
                            'employee': 1,
                            'data.date': -1
                        }
                    },
                    {
                        '$group': {
                            '_id': '$employee',
                            'mid': {
                                '$first': '$_id'
                            },
                            'approved': {
                                '$first': '$approved'
                            },
                            'archived': {
                                '$first': '$archived'
                            },
                            'cc': {
                                '$first': '$cc'
                            },
                            'created': {
                                '$first': '$created'
                            },
                            'data': {
                                '$first': '$data'
                            },
                            'fid': {
                                '$first': '$fid'
                            },
                            'info': {
                                '$first': '$info'
                            },
                            'payroll': {
                                '$first': '$payroll'
                            },
                            'received': {
                                '$first': '$received'
                            },
                            'rp': {
                                '$first': '$rp'
                            },
                            'status': {
                                '$first': '$status'
                            },
                            'updated': {
                                '$first': '$updated'
                            }
                        }
                    },
                    {
                        '$match': {
                            'data.type': {
                                '$ne': 2
                            },
                        }
                    }
                ];
                var paramsLastMovement = {
                    query: JSON.stringify(queryAggregate)
                };
                var paramsBetweenMovements = {
                    page: 0.5,
                    size: 0.5,
                    payroll: payrollId,
                    'data.date': {
                        '$gt': from - 1,
                        '$lt': to + 1
                    },
                    status: {
                        '$gt': 1
                    },
                    sort: 'employee'
                };
                var promises = [
                    $rootScope.D.api.post('aggregate/movements', paramsLastMovement),
                    $rootScope.D.api.get('p/movements', paramsBetweenMovements)
                ];
                Promise.all(promises).then(function(resp) {
                    //console.log(resp);
                    var lastMovements = resp[0].data;
                    var betweeenMovements = resp[1].data.data;
                    for (var l = 0; l < lastMovements.length; l++) {
                        lastMovements[l].employee = lastMovements[l]._id;
                        lastMovements[l]._id = lastMovements[l].mid;
                        delete lastMovements[l].mid;
                        lastMovements[l].$id = lastMovements[l].fid;
                    }
                    for (var b = 0; b < betweeenMovements.length; b++) {
                        betweeenMovements[b].$id = betweeenMovements[b].fid;
                    }
                    var allMovements = lastMovements.concat(betweeenMovements);
                    resolve(allMovements);
                }).catch(function(error) {
                    reject(error)
                })


            })
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getLastCalculations', getLastCalculations);

    function getLastCalculations($rootScope, ListsF, $log, DataF, clearObjectFilter, loopEachFilter) {

        return getLastCalculationsFn;

        function getCalculationOfDispersion(data, calculations, operationsData, lastEmployeesOperation) {
            return new Promise(function (resolve, reject) {
                if (data.length > 0) {
                    operationsData = operationsData ? operationsData : {};
                    lastEmployeesOperation = lastEmployeesOperation ? lastEmployeesOperation : {};
                    var operationPromises = [];
                    var operationIndexes = {};
                    var promises = [];
                    var length = 0;
                    calculations = calculations ? calculations : {};
                    for (var d = 0; d < data.length && promises.length < 50; d++) {
                        var thisDisData = data[d];
                        if (angular.isUndefined(lastEmployeesOperation[thisDisData.employeeId])) {
                            lastEmployeesOperation[thisDisData.employeeId] = [];
                        }
                        lastEmployeesOperation[thisDisData.employeeId].push(thisDisData.operationId);
                        if (!operationsData[thisDisData.operationId] && (!operationIndexes.hasOwnProperty(thisDisData.operationId))) {
                            operationIndexes[thisDisData.operationId] = { accuDate: thisDisData.accuDate, queueTime: thisDisData.queueTime };
                            var params = {
                                page: 0.5,
                                fid: thisDisData.operationId
                            };
                            operationPromises.push(DataF.api.get('p/operations', params));
                        }
                        promises.push(ListsF.loadList('dispersions', 'catalogs/dispersions/collection/' + thisDisData.idDispersion + '/employeesData/calculations/' + thisDisData.employeeId, undefined, 'object', 'calculationsOf-' + thisDisData.idDispersion + thisDisData.employeeId));
                    }
                    length = operationPromises.length;
                    promises = promises.concat(operationPromises);
                    Promise.all(promises).then(function (resp) {
                        var operations = resp.splice(resp.length - length, length);
                        for (var o = 0; o < operations.length; o++) {
                            if (angular.isArray(operations[o].data.data) && operations[o].data.data.length > 0) {
                                operationsData[operations[o].data.data[0].fid] = operations[o].data.data[0];
                                operationsData[operations[o].data.data[0].fid].accuDate = operationIndexes[operations[o].data.data[0].fid].accuDate
                                operationsData[operations[o].data.data[0].fid].queueTime = operationIndexes[operations[o].data.data[0].fid].queueTime
                            }
                        }
                        for (var r = 0; r < resp.length; r++) {
                            if (angular.isUndefined(calculations[data[r].employeeId])) {
                                calculations[data[r].employeeId] = {};
                            }
                            calculations[data[r].employeeId] = Object.assign(calculations[data[r].employeeId], resp[r]);
                        }
                        data.splice(0, resp.length);
                        resolve(getCalculationOfDispersion(data, calculations, operationsData, lastEmployeesOperation));
                    }).catch(reject);
                } else {
                    var temp = {};
                    loopEachFilter(lastEmployeesOperation, function (operations, employeeId) {
                        operations = operations.sort(function (a, b) {
                            var aOpe = operationsData[a];
                            var bOpe = operationsData[b];
                            if (aOpe.accuDate === bOpe.accuDate) {
                                return aOpe.queueTime - bOpe.queueTime;
                            } else {
                                return aOpe.accuDate - bOpe.accuDate;
                            }
                        });
                        temp[employeeId] = operations[operations.length - 1];
                    });
                    lastEmployeesOperation = temp;
                    resolve({ employeesData: { calculations: calculations }, operationsData: { operation: operationsData, employees: lastEmployeesOperation } });
                }
            });
        }

        function getLastCalculationsFn(employeeIds, operationType, accuDate, payroll) {
            var operationTypes = {
                'special': [],
                'extraordinary': ['ordinary', 'extraordinary'],
                'ordinary': ['ordinary', 'extraordinary', 'settlement'],
                'asimilated': ['asimilated'],
                'ptuRecord': [],
                'ptuDistributionRecord': ['ptuRecord'],
                'chrisBonusRecord': ['chrisBonusRecord']
            };
            return new Promise(function (resolve, reject) {
                var thisMatch = {
                    'payroll': payroll,
                    'employeeId': { '$in': employeeIds },
                    'operationType': { '$in': operationTypes[operationType] },
                    'fiscalPerceptions.value': { '$exists': true }
                };
                if (angular.isDefined(accuDate) && accuDate.end && accuDate.start) {
                    thisMatch.accuDate = { $gte: accuDate.start, $lte: accuDate.end };
                }
                var params = {
                    query: angular.toJson([
                        {
                            $match: thisMatch
                        },
                        { $sort: { 'accuDate': 1 } },
                        { $sort: { employeeId: 1, accuDate: 1, _id: 1 } },
                        {
                            $group: {
                                _id: { employeeId: '$employeeId', operationType: '$operationType' },
                                lastCalculation: { $last: '$$ROOT' }
                            }
                        },
                        { $replaceRoot: { newRoot: '$lastCalculation' } },
                        { $lookup: { from: 'operations', localField: 'operationId', foreignField: 'fid', as: 'operationData' } },
                        { $unwind: '$operationData' },
                        { $project: { employeeId: 1, idDispersion: 1, operationType: 1, operationId: 1, accuDate: 1, queueTime: '$created.atTime' } },
                        { $sort: { 'accuDate': 1, 'queueTime': 1 } }
                    ])
                };
                $rootScope.D.api.post('aggregate/calculations', params).then(function (resp) {
                    var data = [];
                    if (angular.isArray(resp.data)) {
                        data = resp.data;
                    }
                    resolve(getCalculationOfDispersion(data));
                }).catch(function (error) {
                    $log.log(error);
                    reject('Error al consultar los últimos datos');
                });
            });
        }
    }

}());
/* eslint-disable angular/json-functions */
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getInitialDataOfSpecialOperation', getInitialDataOfSpecialOperation);

    function getInitialDataOfSpecialOperation($q, MongoF, AppF, ListsF, $log, getLastCalculationsFilter, DataF, getMovementsForSpecialFilter, getMinimumWageOfDateFilter, getCyvTableFilter, geEmployeesByBatchFilter, loopEachFilter) {

        return getInitialDataOfSpecialOperationFn;

        function getInitialDataOfSpecialOperationFn(dataNeeded, operationId, payrollId, operationType, opStatusNotCalc) {
            return $q(function (resolve, reject) {
                var refs = {};
                //Se establecen las referencias y los datos que se ocuparan para obtener la información de la operación
                refs.operations = 'catalogs/operations/' + operationType + '/all/';
                refs.payrolls = 'catalogs/payrolls/collection';
                refs.incidencesTypes = 'catalogs/incidencesTypes/collection';
                refs.calcFields = 'catalogs/calcFields/collection';
                refs.processConfigs = 'catalogs/processConfigs/collection';
                refs.dispersion = 'catalogs/dispersions/collection';
                refs.concepts = '/lists/concepts/center/' + AppF.center;
                refs.movements = 'catalogs/movements/collection';
                //Se obtienen lo datos necesarios para los cálculos de las nominas
                var promises = [
                    MongoF.loadNeeded(dataNeeded), //catálogos de mongo
                    ListsF.loadList('operations', refs.operations, operationId, 'object', 'operation-' + operationType + '-' + operationId), //operación
                    ListsF.loadList('payrolls', refs.payrolls, payrollId, 'object', 'payroll-' + payrollId), //información de la nomina
                    ListsF.loadList('concepts', refs.concepts, false, 'array', 'conceptsCatalogs'), //concepts
                    ListsF.loadList('companiesRecords', undefined, undefined, undefined, 'companiesRecords', [{ q: 'orderByChild', v: 'center' }, { q: 'equalTo', v: function () { return AppF.center; } }])
                ];
                var absencesToCheck = [];
                var fbObjs = {};
                var employeeIds = [];
                var operationIsClosed;
                $q.all(promises).then(function (allR) {
                    fbObjs.operation = /**/{ fb: allR[1], inScope: true };
                    fbObjs.payroll = /****/{ fb: allR[2], actions: ['setPayrollOfEmployees', 'setThisBankAccounts'], inScope: true };
                    fbObjs.concepts = /***/{ fb: allR[3], actions: ['setFastIncidencesTypes', 'setConceptsMap'] };
                    fbObjs.myCcs = /******/{ fb: AppF.permissionToAccessAllPayrolls ? ListsF.ccs : ListsF.userCcs[AppF.profile.uid], actions: ['setOperationCcs'] };
                    var incQuery = [
                        { q: 'orderByChild', v: operationType },
                        { q: 'equalTo', v: operationId }
                    ];
                    for (var employee in allR[1].employees) {
                        employeeIds.push(employee);
                    }
                    refs.periods = 'catalogs/payrollCalendars/' + payrollId + '/periods/' + fbObjs.operation.fb.calendar;
                    refs.incidences = 'incidences/' + payrollId + '/' + fbObjs.operation.fb.calendar;
                    var fnQuery = function (employeesIdsP) {
                        return { fid: angular.toJson({ $in: employeesIdsP }) };
                    };
                    var otherPromises = [
                        ListsF.loadList('processConfigs', refs.processConfigs, fbObjs.operation.fb.processConfigId, 'object', 'paymentSchema-' + fbObjs.payroll.fb.paymentSchema),
                        ListsF.loadList('dispersions', refs.dispersion + '/' + fbObjs.operation.fb.dispersion, undefined, 'object', 'dispersion-' + fbObjs.operation.fb.dispersion),
                        getMinimumWageOfDateFilter(fbObjs.operation.fb.specialDate),
                        ListsF.loadList('incidences', refs.incidences, undefined, 'array', 'incidences-' + operationType + '-' + operationId, incQuery),
                        geEmployeesByBatchFilter(DataF.api.get, 'employees', fnQuery, JSON.parse(JSON.stringify(employeeIds))),
                        ListsF.loadList('periods', refs.periods, fbObjs.operation.fb.period, 'object', 'operationId' + operationId + 'period' + fbObjs.operation.fb.period), //información del periodo
                        DataF.api.get('paymentFrequenciesRecords/' + fbObjs.payroll.fb.paymentFrequency)
                    ];
                    if (operationType === 'ptuDistributionRecord') {
                        var thisCalendar = moment(fbObjs.operation.fb.calendar, 'YYYY').subtract(3, 'year').startOf('year');
                        var fnQUery = function (thisEmployeesP) {
                            var queryCalculations = [
                                { '$match': { 'accuDate': { '$gte': thisCalendar.valueOf() }, 'ptu.fiscalValue': { '$exists': true }, 'operationType': 'ptuRecord', 'employeeId': { '$in': thisEmployeesP } } },
                                { '$unwind': '$companiesRecords' },
                                { '$match': { 'companiesRecords.opType': 'fiscal', 'companiesRecords.companiesRecordId': fbObjs.operation.fb.companiesRecordId } },
                                { '$project': { total: '$ptu.fiscalValue', employeeId: 1, accuDate: 1 } }
                            ];
                            var thisQuery = { query: angular.toJson(queryCalculations) };
                            return thisQuery;
                        }
                        otherPromises.push(geEmployeesByBatchFilter(DataF.api.post, 'aggregate/calculations', fnQUery, JSON.parse(JSON.stringify(employeeIds))));
                    }
                    return $q.all(otherPromises)
                }).then(function (allR2) {
                    if (operationType === 'ptuDistributionRecord') {
                        var oldPtuEmployees = allR2[allR2.length - 1].reduce(function (current, item) {
                            if (!current.hasOwnProperty(item.employeeId)) {
                                current[item.employeeId] = [];
                            }
                            var thisEmployee = item.employeeId;
                            delete item.employeeId;
                            current[thisEmployee].push(item);
                            return current;
                        }, {})
                        if (Object.keys(oldPtuEmployees).length > 0) {
                            fbObjs.oldPtuEmployees = { fb: oldPtuEmployees }
                        }
                    }
                    var employees = allR2[4].reduce(function (current, employee) {
                        employee.$id = employee.fid;
                        current[employee.$id] = employee;
                        return current;
                    }, {});
                    fbObjs.dispersionF = /*********/{ fb: allR2[1], actions: ['setDispersion'] };
                    fbObjs.paymentSchema = /*******/{ fb: allR2[0], actions: ['setProccess'] };
                    fbObjs.minimumWageRecords = /**/{ fb: allR2[2] };
                    fbObjs.incidences = /**********/{ fb: allR2[3] };
                    fbObjs.period = /**************/{ fb: allR2[5], inScope: true };
                    fbObjs.paymentFrequency = /****/{ fb: allR2[6].data };
                    fbObjs.getCyvTable =/*********/ { fb: getCyvTableFilter(fbObjs.minimumWageRecords.fb, MongoF.cyvRecords, fbObjs.operation.fb.calendar) };
                    fbObjs.employees = /***********/{ fb: employees };
                    //Se obtienen todas las operaciones del mes en que se acumula;
                    var accuDatePeriod = {};
                    var thisMonth = moment(fbObjs.period.fb.accuDate || fbObjs.operation.fb.specialDate);
                    if (['chrisBonusRecord', 'ptuRecord', 'ptuDistributionRecord'].indexOf(operationType) > -1) {
                        accuDatePeriod.start = thisMonth.startOf('year').valueOf();
                        accuDatePeriod.end = thisMonth.endOf('year').valueOf();
                    } else if (operationType === 'extraordinary') {
                        accuDatePeriod.start = thisMonth.startOf('month').valueOf();
                        accuDatePeriod.end = thisMonth.endOf('month').valueOf();
                    } else {
                        accuDatePeriod.start = thisMonth.startOf('month').valueOf();
                        accuDatePeriod.end = thisMonth.endOf('month').valueOf();
                    }
                    operationIsClosed = fbObjs.operation.fb.status >= opStatusNotCalc;
                    promises = [
                        getLastCalculationsFilter(JSON.parse(JSON.stringify(employeeIds)), operationType, accuDatePeriod, payrollId)
                    ];
                    if (operationType === 'chrisBonusRecord') {
                        loopEachFilter(fbObjs.operation.fb.absencesToCheck, function (value, incidenceId) {
                            if (value) { absencesToCheck.push(incidenceId); }
                        })
                    }
                    if (absencesToCheck.length > 0 && operationType !== 'ptuDistributionRecord') {
                        var incidencesParams = {
                            employee: angular.toJson({ $in: JSON.parse(JSON.stringify(employeeIds)) }),
                            incidenceType: angular.toJson({ $in: absencesToCheck }),
                            status: 3,
                            payroll: payrollId,
                            date: angular.toJson({ $gte: accuDatePeriod.start, $lte: accuDatePeriod.end }),
                            project: angular.toJson({ incidenceType: 1, date: 1, employee: 1, value: 1 })
                        };
                        promises.push(DataF.api.get('p/incidences', incidencesParams));
                    }
                    if (!operationIsClosed) {
                        var match = {
                            // 'payroll': payrollId,
                            'employee': { $in: Object.keys(fbObjs.operation.fb.employees) }
                        }
                        if (operationType !== 'ptuDistributionRecord') {
                            match.payroll = payrollId;
                        }
                        var movementDates = {};
                        var thisMonthMovement = moment(fbObjs.period.fb.accuDate || fbObjs.operation.fb.specialDate);
                        if (operationType === 'chrisBonusRecord') {
                            movementDates.start = thisMonthMovement.startOf('year').valueOf();
                            movementDates.end = thisMonthMovement.endOf('year').valueOf();
                        } else if (['ptuRecord', 'ptuDistributionRecord'].indexOf(operationType) > -1) {
                            movementDates.start = thisMonthMovement.subtract(1, 'year').startOf('year').valueOf();
                            movementDates.end = thisMonthMovement.endOf('year').valueOf();
                        } else if (operationType === 'extraordinary') {
                            movementDates.start = fbObjs.period.fb.start;
                            movementDates.end = fbObjs.period.fb.end;
                        } else {
                            movementDates.start = thisMonthMovement.startOf('month').valueOf();
                            movementDates.end = thisMonthMovement.endOf('month').valueOf();
                        }
                        promises.push(getMovementsForSpecialFilter(match, movementDates.start, movementDates.end))
                    }
                    return $q.all(promises)
                }).then(function (allR3) {
                    var movements = (operationIsClosed) ? [] : allR3.pop();

                    if (absencesToCheck.length > 0 && operationType !== 'ptuDistributionRecord') {
                        var incidencesChecked = allR3.pop().data.data.reduce(function (current, item) {
                            if (!current.hasOwnProperty(item.employee)) {
                                current[item.employee] = [];
                            }
                            var thisEmployee = item.employee;
                            delete item.employee;
                            current[thisEmployee].push(item);
                            return current;
                        }, {})
                        if (Object.keys(incidencesChecked).length > 0) {
                            fbObjs.incidencesChecked = { fb: incidencesChecked }
                        }
                    }
                    fbObjs.allOperations = /*******/{ fb: allR3[0].operationsData };
                    fbObjs.lastDispersionF = /*****/{ fb: allR3[0], actions: ['setLastDispersion'] };
                    fbObjs.movements = /***********/{ fb: movements, watch: true, actions: ['setEmployeesMovement'] };

                    resolve({
                        refs: refs,
                        fbObjs: fbObjs
                    });
                }).catch(function (error) {
                    reject(error);
                });
            });
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getInitialDataOfOperation', getInitialDataOfOperation);

    function getInitialDataOfOperation($q, MongoF, AppF, ListsF, $log, getMovementsDFilter, DataF, getMinimumWageOfDateFilter, getCyvTableFilter, getEmployeeCalculationsFilter, getLastCalculationsFilter, loopEachFilter) {

        return getInitialDataOfOperationFn;

        function getInitialDataOfOperationFn(dataNeeded, operationId, periodId, calendarId, payrollId, operationType, opStatusNotCalc) {
            return $q(function (resolve, reject) {
                var refs = {};
                //Se establecen las referencias y los datos que se ocuparan para obtener la información de la operación
                refs.incidences = 'incidences/' + payrollId + '/' + calendarId;
                refs.operations = 'catalogs/operations/' + operationType + '/' + payrollId + '/' + calendarId + '/collection';
                refs.periods = 'catalogs/payrollCalendars/' + payrollId + '/periods/' + calendarId;
                refs.payrolls = 'catalogs/payrolls/collection';
                refs.incidencesTypes = 'catalogs/incidencesTypes/collection';
                refs.calcFields = 'catalogs/calcFields/collection';
                refs.paymentSchemas = 'catalogs/paymentSchemas/collection';
                refs.dispersion = 'catalogs/dispersions/collection';
                refs.concepts = '/lists/concepts/center/' + AppF.center;
                refs.movements = 'catalogs/movements/collection';
                var lastOperationQueries = [
                    { q: 'orderByChild', v: 'period' },
                    { q: 'equalTo', v: parseInt(periodId) - 1 }
                ];
                var nextDate;
                var nextCalendar;
                //Se obtienen lo datos necesarios para los cálculos de las nominas
                var promises = [
                    MongoF.loadNeeded(dataNeeded), //catálogos de mongo
                    ListsF.loadList('operations', refs.operations, operationId, 'object', 'operation-' + operationId), //operación
                    ListsF.loadList('payrolls', refs.payrolls, payrollId, 'object', 'payroll-' + payrollId), //información de la nomina
                    ListsF.loadList('calcFields', refs.calcFields), //campos de calculo
                    ListsF.loadList('periods', refs.periods, periodId, 'object', 'operationId' + operationId + 'period' + periodId), //información del periodo
                    ListsF.loadList('operations', refs.operations, false, 'array', 'lastOperationOf-' + operationId, lastOperationQueries), //ultima operación
                    ListsF.loadList('concepts', refs.concepts, false, 'array', 'conceptsCatalogs') //concepts
                    // ListsF.loadList('operations', refs.operations, false, 'array', 'nextOperationOf-' + operationId, nextOperationQueries) //ultima operación
                ];
                $q.all(promises).then(function (allR) {
                    var fbObjs = {};
                    fbObjs.operation = /*****************/{ fb: allR[1], inScope: true };
                    fbObjs.payroll = /*******************/{ fb: allR[2], actions: ['setPayrollOfEmployees', 'setThisBankAccounts'], inScope: true };
                    var operationIsClosed = fbObjs.operation.fb.status >= opStatusNotCalc;
                    fbObjs.calcFields = /****************/{ fb: allR[3] };
                    fbObjs.period = /********************/{ fb: allR[4], inScope: true };
                    if (allR[5].length > 0) {
                        fbObjs.lastOperation = /*************/{ fb: allR[5][0] };
                    }
                    fbObjs.concepts = /******************/{ fb: allR[6], actions: ['setFastIncidencesTypes', 'setConceptsMap'] };
                    if (AppF.permissionToAccessAllPayrolls) {
                        fbObjs.myCcs = /*********************/{ fb: ListsF.ccs, actions: ['setOperationCcs'] };
                    } else {
                        fbObjs.myCcs = /*********************/{ fb: ListsF.userCcs[AppF.profile.uid], actions: ['setOperationCcs'] };
                    }
                    nextDate = moment(fbObjs.period.fb.end).add('1', 'days');
                    var nextCalendarQuery = [
                        { q: 'orderByChild', v: 'data/endDate' },
                        { q: 'startAt', v: nextDate.valueOf() },
                        { q: 'limitToFirst', v: 1 }
                    ];
                    var otherPromises = [
                        ListsF.loadList('paymentSchemas', refs.paymentSchemas, fbObjs.payroll.fb.paymentSchema, 'object', 'paymentSchema-' + fbObjs.payroll.fb.paymentSchema),
                        DataF.api.get('paymentFrequenciesRecords/' + fbObjs.payroll.fb.paymentFrequency),
                        ListsF.loadList('dispersions', refs.dispersion + '/' + fbObjs.operation.fb.dispersion, undefined, 'object', 'dispersion-' + fbObjs.operation.fb.dispersion),
                        getMinimumWageOfDateFilter(fbObjs.period.fb.accuDate),
                        ListsF.loadList('calendars', 'catalogs/payrollCalendars/' + payrollId + '/calendars', undefined, 'array', payrollId + 'calendarFrom-' + nextDate.valueOf(), nextCalendarQuery)
                    ];
                    if (fbObjs.lastOperation) {
                        var period = fbObjs.lastOperation.fb.accuPeriod || fbObjs.lastOperation.fb.period;
                        otherPromises.unshift(ListsF.loadList('periods', refs.periods, period, 'object', payrollId + 'periodNumber-' + period));
                    }
                    var incQueriesNotApplied = [
                        { q: 'orderByChild', v: 'status' },
                        { q: 'startAt', v: 0 },
                        { q: 'endAt', v: 2 }
                    ];
                    otherPromises.push(ListsF.loadList('incidences', refs.incidences, undefined, 'array', 'incidences-' + '0-2' + periodId + '-' + refs.incidences, incQueriesNotApplied));
                    var incQueriesApplied = {
                        period: 'parseNumber' + periodId,
                        status: angular.toJson({ $gte: 3 }),
                        payroll: payrollId,
                        calendar: 'parseNumber' + calendarId,
                        operationType: { $exists: false }
                    };
                    otherPromises.push(DataF.api.get('incidences', incQueriesApplied));
                    if (!operationIsClosed) {
                        otherPromises.push(getMovementsDFilter(payrollId, fbObjs.period.fb.start, fbObjs.period.fb.end));
                    }
                    $q.all(otherPromises).then(function (allR2) {
                        var secondQueries = [];
                        var employeeIds = [];
                        if (fbObjs.lastOperation) {
                            fbObjs.lastPeriodData = /*********/{ fb: allR2.shift() };
                        }
                        fbObjs.dispersionF = /*********/{ fb: allR2[2], actions: ['setDispersion'] };
                        fbObjs.paymentSchema = /******/{ fb: allR2[0], actions: ['setProccess'] };
                        fbObjs.paymentFrequency = /******/{ fb: allR2[1].data };
                        fbObjs.minimumWageRecords = /******/{ fb: allR2[3] };
                        fbObjs.incidences = /*****/{ fb: allR2[5] };
                        fbObjs.appliedIncidences = /*****/{ fb: allR2[6].data };
                        fbObjs.getCyvTable = { fb: getCyvTableFilter(fbObjs.minimumWageRecords.fb, MongoF.cyvRecords, calendarId) };
                        if (!operationIsClosed) {
                            fbObjs.movements = /******/{ fb: allR2[7].movements, watch: true, actions: ['setEmployeesMovement'] };
                            fbObjs.employees = /******/{ fb: allR2[7].employees };
                            fbObjs.payroll.watch = true;
                            fbObjs.myCcs.watch = true;
                            loopEachFilter(allR2[7].employees, function (data, key) {
                                employeeIds.push(key);
                            });
                        }
                        if (allR2[4].length > 0) {
                            nextCalendar = allR2[4][0].$id;
                            var nextPeriodQuery = [
                                { q: 'orderByChild', v: 'end' },
                                { q: 'startAt', v: nextDate.valueOf() },
                                { q: 'limitToFirst', v: 1 }
                            ];
                            secondQueries.push(ListsF.loadList('periods', 'catalogs/payrollCalendars/' + payrollId + '/periods/' + nextCalendar, undefined, 'array', payrollId + 'periodFrom-' + nextDate.valueOf(), nextPeriodQuery));
                        }
                        fbObjs.isLastOperation = { fb: angular.isUndefined(nextCalendar) || parseInt(nextCalendar) !== parseInt(calendarId) ? true : false };
                        var periodDate = moment(fbObjs.period.fb.accuDate);
                        if (periodDate.month() < 4) {
                            periodDate.subtract(1, 'year');
                        }
                        if (angular.isUndefined(nextCalendar) || parseInt(nextCalendar) !== parseInt(calendarId) || periodDate.month() < 4) {
                            secondQueries.unshift(getEmployeeCalculationsFilter(employeeIds, payrollId, fbObjs.payroll.fb.processes, periodDate));//validar correctamente cuando trae los datos para hacer el ajuste anual
                        }

                        //Se obtienen los últimos cálculos del empleado desde la fecha de acumulación de la operación anterior, hasta el fin de mes de la operación actual;
                        var thisMonth = moment(fbObjs.period.fb.accuDate);
                        var accuDatePeriod = {
                            start: fbObjs.lastOperation ? fbObjs.lastPeriodData.fb.accuDate : thisMonth.startOf('month').valueOf(),
                            end: thisMonth.endOf('month').valueOf()
                        };
                        secondQueries.push(getLastCalculationsFilter(employeeIds, 'ordinary', accuDatePeriod, payrollId));

                        Promise.all(secondQueries).then(function (allR) {
                            if (angular.isUndefined(nextCalendar) || parseInt(nextCalendar) !== parseInt(calendarId) || periodDate.month() < 4) {
                                var finalCalculations = allR.shift();
                                fbObjs.finalCalculations = { fb: finalCalculations };
                            }
                            var lastDispersionObj = allR.pop();
                            fbObjs.allOperations = /*****/{ fb: lastDispersionObj.operationsData };
                            fbObjs.lastDispersionF = /*****/{ fb: lastDispersionObj, actions: ['setLastDispersion'] };
                            var thirdQueries = [];
                            if (allR.length > 0 && allR[0].length > 0) {
                                var nextOperationQuery = [
                                    { q: 'orderByChild', v: 'period' },
                                    { q: 'equalTo', v: allR[0][0].period }
                                ];
                                thirdQueries.push(ListsF.loadList('calendars', 'catalogs/operations/ordinary/' + payrollId + '/' + nextCalendar + '/collection', undefined, 'array', payrollId + 'operationFrom-' + nextDate.valueOf(), nextOperationQuery));
                            }
                            Promise.all(thirdQueries).then(function (allR) {
                                if (allR.length && allR[0].length) {
                                    fbObjs.nextOperation = /*************/{ fb: allR[0][0] };
                                }
                                resolve({
                                    refs: refs,
                                    fbObjs: fbObjs
                                });
                            }).catch(function (error) {
                                reject(error);
                            });
                        }).catch(function (error) {
                            reject(error);
                        });
                    }).catch(function (error) {
                        reject(error);
                    });
                }).catch(function (error) {
                    reject(error);
                });
            });
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('getIncidencesUpdatesFrom', getIncidencesUpdatesFrom)

    function getIncidencesUpdatesFrom() {
        var fromReferences = {
            loan: "catalogs/loans/collection/:loanId/incidences/:id"
        }

        return getIncidencesUpdatesFromFn;

        function getIncidencesUpdatesFromFn(incidence, fields, sameFields) {
            //console.log(incidence, fields, sameFields);
            sameFields = sameFields ? sameFields : true;
            var updates = {};
            if (incidence.from) {
                for (var catalog in incidence.from) {
                    if (typeof(fromReferences[catalog]) != "undefined") {
                        var ref = fromReferences[catalog];
                        var value = incidence.from[catalog];
                        if (typeof(value) == "object") {
                            for (var v in value) {
                                ref.replace(":" + v, value);
                            }
                        } else {
                            ref = ref.replace(":" + catalog + "Id", value)
                        }
                        ref = ref.replace(":id", incidence.$id);
                        var thisFields = fields;
                        if (!sameFields) {
                            thisFields = fields[catalog];
                        }
                        for (var f in thisFields) {
                            updates[ref + "/" + f] = thisFields[f];
                        }
                    } else {
                        throw ("No existe referencia para guardar el objeto " + catalog)
                    }
                }
            }
            return updates;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('getIncidencesUpdates', getIncidencesUpdates)

    function getIncidencesUpdates(
        getEmployeeCalculationValueFilter,
        AppF,
        clearObjectFilter
    ) {

        return getIncidencesUpdatesFn;

        function getIncidencesUpdatesFn(incidences, employees, status, incidencesRef, incidencesTypesToInclude) {
            var updates = {};
            for (var i = 0; i < incidences.length; i++) {
                var thisIncidence = incidences[i];
                if (incidencesTypesToInclude.indexOf(thisIncidence.type) > -1) {
                    var incidenceId;
                    if (typeof(thisIncidence.$id) == undefined) {
                        incidenceId = thisIncidence.$id;
                    } else {
                        incidenceId = AppF.root.child(incidencesRef).push().key;
                    }
                    updates[incidenceId] = clearObjectFilter(thisIncidence);
                    updates[incidenceId].status = status;
                }
            }
            return updates;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('getIncidencesTypesOfComplements', getIncidencesTypesOfComplements)

    function getIncidencesTypesOfComplements() {

        return getIncidencesTypesOfComplementsFn;

        function getIncidencesTypesOfComplementsFn(complementIncidencesTypes) {
            var incidencesTypesByComplement = {};
            for (var c = 0; c < complementIncidencesTypes.length; c++) {
                var thisComplementIncidenceType = complementIncidencesTypes[c];
                if (typeof(incidencesTypesByComplement[thisComplementIncidenceType.process]) == "undefined") incidencesTypesByComplement[thisComplementIncidenceType.process] = {};
                if (thisComplementIncidenceType.default) {
                    incidencesTypesByComplement[thisComplementIncidenceType.process][thisComplementIncidenceType.nature] = thisComplementIncidenceType._id;
                }
                if (typeof(thisComplementIncidenceType.incidencesTypes) == "object" && thisComplementIncidenceType.incidencesTypes.length) {
                    for (var it = 0; it < thisComplementIncidenceType.incidencesTypes.length; it++) {
                        incidencesTypesByComplement[thisComplementIncidenceType.process][thisComplementIncidenceType.incidencesTypes[it]] = thisComplementIncidenceType._id;
                    }
                }
            }
            return incidencesTypesByComplement;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getIncidencesOfThisPeriod', getIncidencesOfThisPeriod)

    function getIncidencesOfThisPeriod($log) {

        return getIncidencesOfThisPeriodFn;

        function getIncidencesOfThisPeriodFn(allIncidences, period, creditIncidences, constantIncidences) {
            // $log.log(creditIncidences);
            var incidences = [];
            angular.forEach(allIncidences, function (incidence) {
                if (incidence.period <= period) {
                    delete incidence.created;
                    delete incidence.updated;
                    delete incidence.automaticAsignation;
                    incidences.push(incidence);
                }
            });
            if (angular.isArray(creditIncidences)) {
                incidences = incidences.concat(creditIncidences);
            }
            if (angular.isArray(constantIncidences)) {
                incidences = incidences.concat(constantIncidences);
            }
            return incidences;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('getIncidencesForTaxes', getIncidencesForTaxes)

    function getIncidencesForTaxes() {

        return getIncidencesForTaxesFn;

        function getIncidencesForTaxesFn(calculations) {
            var objects = {};
            if (typeof(calculations) == "object") {
                for (var c in calculations) {
                    var thisCalculation = calculations[c];
                    if (typeof(thisCalculation) == "object" && typeof(thisCalculation.value) == "object") {
                        if (thisCalculation.value.nature == "perception" && !thisCalculation.value.ignoreForTaxes) {
                            objects[c] = calculations[c];
                        }
                    }
                }
            }
            return objects;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('getIncidences', getIncidences)

    function getIncidences($q, ListsF, getIncidencesOfThisPeriodFilter, getAppliedIncidencesFilter) {

        return getIncidencesFn;

        function getIncidencesFn(period, operationIsClosed, incidencesRef) {
            var deferred = $q.defer();
            var incidencesQueries = [];
            //Si la sabana esta cerrada se obtienen las incidencias de ese periodo y se filtran aquellas que si fueron aplicadas
            if (operationIsClosed) {
                //console.log("Getting incidences of a closed operation");
                incidencesQueries = [{
                        q: "orderByChild",
                        v: "period"
                    },
                    {
                        q: "equalTo",
                        v: period
                    }
                ]
                //$scope.unfilteredIncidences = $firebaseArray(root.child($scope.incidencesRef).orderByChild('period').equalTo($scope.periodNumber));
                ListsF.loadList("incidences", incidencesRef, undefined, "array", "incidences-" + period, incidencesQueries).then(function(incidences) {
                    deferred.resolve({
                        unfilteredIncidences: incidences,
                        incidences: getAppliedIncidencesFilter(incidences)
                    })
                }).catch(function(error) {
                    deferred.reject(error);
                });
            } else { //Si la sabana aun no esta cerrada se obtiene las incidencias de las cuales ya se confirmo que se aplicaran y que no se han aplicado para depues filtrar las del periodo correspondiente
                //console.log("Getting incidences of a not closed operation");
                incidencesQueries = [{
                    q: "orderByChild",
                    v: "status"
                }, {
                    q: "startAt",
                    v: 0
                }, {
                    q: "endAt",
                    v: 2
                }]
                // $scope.unfilteredIncidences = $firebaseArray(root.child($scope.incidencesRef).orderByChild('status').startAt(0).endAt(2));
                ListsF.loadList("incidences", incidencesRef, undefined, "array", "incidences-" + 0 + "-" + 2, incidencesQueries).then(function(incidences) {
                    deferred.resolve({
                        unfilteredIncidences: incidences,
                        incidences: getIncidencesOfThisPeriodFilter(incidences, period)
                    })
                }, function(error) {
                    deferred.reject(error);
                });
            }
            return deferred.promise;
        }
    }

}());
(function(){
    'use strict';

    angular
        .module('app.clients')
        .filter('getIncidenceProcess', getIncidenceProcess)

    function getIncidenceProcess(
        AppF
    ){

        return getIncidenceProcessFn;

        function getIncidenceProcessFn(internalCode){
            var processName = false;
            // @todo checar por prioridad:
            // hay que checar en constantes por empleado (1), por lugar de trabajo (2), cc (3) por nomina (4) y general (5)
            // en la configuracion de paymentShema y (6)
            // en la incidencia (en defaultProcess.real o .fiscal o .complement) (7)
            return processName;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getISRRow', getISRRow);

    function getISRRow(MongoF, DataF, $log, orderByFilter) {

        return getISRRowFn;

        function getISRRowFn(gravableBase, date, type) {
            if (angular.isArray(MongoF.isrRecords)) {
                type = type ? type : 'monthly';
                var year = angular.isDefined(date) ? moment(date) : moment(DataF.getCurrentServerTime());
                year = parseInt(year.format('YYYY'));
                var isrRecords = MongoF.isrRecords.slice().filter(function (item) {
                    return (item.type || 'monthly') === type;
                });
                var ordered = orderByFilter(isrRecords, ['-year', '-lowerLimit']);
                var thisRecord = ordered.find(function (item) {
                    return gravableBase >= item.lowerLimit && item.year === year;
                });
                if (angular.isUndefined(thisRecord)) {
                    thisRecord = ordered.find(function (item) {
                        return gravableBase >= item.lowerLimit && item.year < year;
                    });
                }
                if (angular.isUndefined(thisRecord)) {
                    thisRecord = ordered.find(function (item) {
                        return gravableBase >= item.lowerLimit;
                    });
                }
                if (angular.isDefined(thisRecord)) {
                    return thisRecord;
                }
            }
            return false;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('getIMSSRowLast', getIMSSRowLast)

    function getIMSSRowLast(MongoF,orderByFilter) {

        return getIMSSRowLastFn;

        function getIMSSRowLastFn(year, imssRecords) {
            var imssRecords = imssRecords ? imssRecords : MongoF.imssRecords;
            for (var i in imssRecords) {
                var imssRecord = imssRecords[i];
                if (parseInt(year) == parseInt(imssRecord.year)) return imssRecord;
            }
            imssRecords = orderByFilter(imssRecords, "-year");
            if (angular.isDefined(imssRecords[0]))
                return imssRecords[0];
            else
                return false;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('getIMSSRow', getIMSSRow)

    function getIMSSRow(MongoF) {

        return getIMSSRowFn;

        function getIMSSRowFn(year, imssRecords) {
            imssRecords = imssRecords ? imssRecords : MongoF.imssRecords;
            for (var i in imssRecords) {
                var imssRecord = imssRecords[i];
                if (parseInt(year) == parseInt(imssRecord.year)) return imssRecord;
            }
            return false;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('getHolydays', getHolydays)

    function getHolydays(getSomethingOfArrayFBFilter) {

        return getHolydaysFn;

        function getHolydaysFn(perceptions, incidencesTypes) {
            var days = 0;
            angular.forEach(perceptions, function(perception) {
                var directive = getSomethingOfArrayFBFilter(perception.incidenceType, incidencesTypes, "directive", false);
                if (directive == "001PRV") {
                    days += parseFloat(perception.value);
                }
            })
            //console.log(days);
            return days;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getGravableAmounts', getGravableAmounts)

    function getGravableAmounts(objsToArrayFilter, pathInObjFilter, getTotalOfArrayFieldFilter, AppF, getSomethingOfArrayFBFilter, getTotalOfTaxedExemptFormulaFilter) {

        return getGravableAmountsFn;

        function getRule(rule) {
            // console.log(rule, this);
            var incidences = rule.incidences ? rule.incidences : [];
            return incidences.indexOf(this) > -1;
        }

        function getGravableAmountsFn(calculations, gravableConfig, workedDays, mensualizationFactor, calcFields, employee, payroll, operation, umaRecord, constants) {
            var allAmounts = {};
            // console.log(employee);
            if (typeof (gravableConfig) == "object") {
                for (var i = 0; i < gravableConfig.length; i++) {
                    var config = gravableConfig[i];
                    var defaultAction = config.defaultConfig;
                    var rulesArray = objsToArrayFilter(config.rules ? config.rules : {});
                    var ignoreThisIds = [];
                    var amounts = [];
                    for (var calcId in calculations) {
                        if (ignoreThisIds.indexOf(calcId) == -1) {
                            var thisRule = undefined;
                            var searchRule = rulesArray.filter(getRule, calcId);
                            if (searchRule.length > 0) {
                                thisRule = searchRule[0];
                            }
                            var action = defaultAction;
                            var total = 0;
                            var value = 0;
                            var thisTotal = undefined;
                            var thisValue = undefined;
                            var ruleName = undefined;
                            var incidenceId = undefined;
                            var incidenceName = undefined;
                            var formula = undefined;
                            if (typeof (thisRule) !== "undefined") {
                                var incidencesNames = [];
                                var incidencesIds = [];
                                action = thisRule.config;
                                formula = thisRule.value;
                                ruleName = thisRule.name;
                                var arrayIncidences = thisRule.incidences ? thisRule.incidences : [];
                                for (var a = 0; a < arrayIncidences.length; a++) {
                                    var pathT = arrayIncidences[a] + ".value.total";
                                    var pathV = arrayIncidences[a] + ".value.value"
                                    thisTotal = pathInObjFilter(calculations, pathT);
                                    thisValue = pathInObjFilter(calculations, pathV);
                                    ignoreThisIds.push(arrayIncidences[a]);
                                    if (thisTotal !== false && !isNaN(thisTotal)) {
                                        total += thisTotal;
                                    }
                                    if (thisValue !== false && !isNaN(thisValue)) {
                                        value += thisValue;
                                    }
                                    incidencesIds.push(arrayIncidences[a]);
                                    incidencesNames.push(getSomethingOfArrayFBFilter(arrayIncidences[a], AppF.incidencesTypes, "name", arrayIncidences[a]));
                                }
                                incidenceName = incidencesNames.toString();
                                incidenceId = incidencesIds.toString();
                            } else {
                                ruleName = "DEFAULT";
                                incidenceId = calcId;
                                thisTotal = pathInObjFilter(calculations[calcId], "value.total");
                                thisValue = pathInObjFilter(calculations[calcId], "value.value");
                                if (thisTotal !== false && !isNaN(thisTotal)) {
                                    total += thisTotal;
                                }
                                if (thisValue !== false && !isNaN(thisValue)) {
                                    value += thisValue;
                                }
                                incidenceName = getSomethingOfArrayFBFilter(calcId, AppF.incidencesTypes, "name", calcId);
                            }
                            var amountObj = {
                                ruleName: ruleName,
                                incidenceId: incidenceId,
                                incidenceName: incidenceName,
                                taxed: 0,
                                exempt: 0
                            };
                            switch (action) {
                                case "taxed":
                                    amountObj.taxed = total;
                                    break;
                                case "exempt":
                                    amountObj.exempt = total;
                                    break;
                                case "partialTaxed":
                                    amountObj.taxed = getTotalOfTaxedExemptFormulaFilter(total, value, formula, calcFields, employee, payroll, operation, umaRecord, constants);
                                    if (amountObj.taxed > total) {
                                        amountObj.taxed = total;
                                    }
                                    amountObj.exempt = total - amountObj.taxed;
                                    break;
                                case "partialExempt":
                                    amountObj.exempt = getTotalOfTaxedExemptFormulaFilter(total, value, formula, calcFields, employee, payroll, operation, umaRecord, constants);
                                    if (amountObj.exempt > total) {
                                        amountObj.exempt = total;
                                    }
                                    amountObj.taxed = total - amountObj.exempt;
                                    break;
                            }
                            amounts.push(amountObj);
                        }
                    }
                    var periodGravableBase = getTotalOfArrayFieldFilter(amounts, "taxed");
                    var monthlyBase = 0;
                    if (periodGravableBase > 0 && workedDays.value.total > 0) {
                        monthlyBase = total / workedDays.value.total * mensualizationFactor;
                    }
                    allAmounts[config.incidencesType] = {
                        periodGravableBase: periodGravableBase,
                        amounts: amounts,
                        total: monthlyBase
                    }
                }
            }
            // console.log(allAmounts);
            // var formula;
            // if (typeof(gravableConfig) == "object" && typeof(gravableConfig.config) == "string") {
            //     action = gravableConfig.config;
            //     formula = gravableConfig.value;
            // }
            // switch (action) {
            //     case "taxed":
            //         amounts.taxed = total;
            //         amounts.exempt = 0;
            //         break;
            //     case "exempt":
            //         amounts.taxed = 0;
            //         amounts.exempt = total;
            //         break;
            // }
            // console.log(amounts);


            return allAmounts;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('getFixIncidences', getFixIncidences)

    function getFixIncidences(setInObjectPathFilter) {

        return getFixIncidencesFn;

        function getFixIncidencesFn(dispersion) {
            var ignoredCalculations = ["daily_salary", "deductions", "gravableBase", "netSalary", "perceptions", "workedDays", "socialPrevision"];
            var fixIncidences = {};
            if (typeof(dispersion.rejectedIncidences) == "object") {
                for (var rejectedId in dispersion.rejectedIncidences) {
                    var value = dispersion.rejectedIncidences[rejectedId];
                    value.$id = rejectedId;
                    var path = "rejectedIncidences." + value.employee + "." + value.incidenceType;
                    setInObjectPathFilter(path, fixIncidences, value, false, true);
                }
            }
            if (typeof(dispersion.calculations) == "object") {

                for (var employeeId in dispersion.calculations) {
                    if (typeof(dispersion.calculations[employeeId].calculations) == "object") {
                        for (var proccess in dispersion.calculations[employeeId].calculations) {
                            if (proccess !== "REAL") {
                                if (typeof(dispersion.calculations[employeeId].calculations[proccess]) == "object") {
                                    for (var incidenceType in dispersion.calculations[employeeId].calculations[proccess]) {
                                        if (ignoredCalculations.indexOf(incidenceType) < 0) {
                                            var thisProccess=proccess;
                                            if(proccess=="FISCAL"){
                                                thisProccess="fiscal";
                                            }
                                            var path = thisProccess + "." + incidenceType + "." + employeeId+"."+incidenceType;
                                            setInObjectPathFilter(path, fixIncidences, true, false, true);
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            return fixIncidences;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('getFiscalEmployees', getFiscalEmployees)

    function getFiscalEmployees(filterFilter) {

        return getFiscalEmployeesFn;

        function getFiscalEmployeesFn(employees, rps, actualEmployees, isClosed) {
            actualEmployees = actualEmployees ? actualEmployees : [];
            var fiscalEmployees = [];
            for (var e in employees) {
                if (typeof(employees[e]) === 'object') {
                    var employee = employees[e];
                    if (isClosed) {
                        if (typeof(employee.calculations.FISCAL) != "undefined") {
                            fiscalEmployees.push(employee)
                        }
                    } else {
                        var tempMovementsEmployee = [];
                        var hasFiscalOperation = false;
                        var employeeMovements = employee.movements ? JSON.parse(JSON.stringify(employee.movements)) : [];
                        if (employeeMovements) {
                            for (var em in employeeMovements) {
                                if (typeof(employeeMovements[em]) === 'object') {
                                    var movement = employeeMovements[em];
                                    var rpFounded = filterFilter(rps, {
                                        '$id': movement.rp
                                    });
                                    if (rpFounded.length) {
                                        var thisRp = rpFounded[0];
                                        if (thisRp.data.name !== '00000000000') {
                                            hasFiscalOperation = true;
                                            tempMovementsEmployee.push(movement);
                                        }
                                    }

                                }
                            }
                        }
                        if (hasFiscalOperation) {
                            var thisEmployee = JSON.parse(JSON.stringify(employee));
                            thisEmployee.movements = tempMovementsEmployee;
                            delete thisEmployee.calculations;
                            fiscalEmployees.push(thisEmployee);

                        }
                    }

                }
            }
            var indexesToDelete = [];
            for (var i = 0; i < actualEmployees.length; i++) {
                var thisEmployee = actualEmployees[i];
                var founded = filterFilter(fiscalEmployees, {
                    "$id": thisEmployee.$id
                });
                if (founded.length) {
                    //console.log("El employee esta en la lista de empleados nueva");
                    var index = fiscalEmployees.indexOf(founded[0]);
                    if (index > -1) {
                        //console.log("El empleado esta en el index", index);
                        //console.log(JSON.parse(JSON.stringify(actualEmployees[i])));
                        //console.log(JSON.parse(JSON.stringify(fiscalEmployees[index])));
                        actualEmployees[i] = Object.assign(actualEmployees[i], fiscalEmployees[index]);
                        fiscalEmployees.splice(index, 1);
                    }
                } else {
                    //console.log("El empleado no esta en la lista de empleados nueva asi que se eliminara");
                    indexesToDelete.push(i);
                }
            }
            for (var f = 0; f < fiscalEmployees.length; f++) {
                actualEmployees.push(fiscalEmployees[f]);
            }
            //console.log(actualEmployees);
            return actualEmployees;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getExtraHoursAmount', getExtraHoursAmount)

    function getExtraHoursAmount() {

        return getExtraHoursAmountFn;

        function getExtraHoursAmountFn(incidences, period, sundaySalaryByHour, salaryByHour) {
            //aqui va la formula con la que se calcula normalmente
            var extraHours = [];
            if (typeof (incidences) == "object") {
                angular.forEach(incidences, function (incidence) {
                    var date;
                    if (!incidence.date) {
                        if (moment(period.start).weekday() === 0) {
                            date = moment(period.start).add(1, 'day').valueOf();
                        } else {
                            date = period.start;
                        }
                    } else {
                        date = incidence.date;
                    }
                    var extraHour = {
                        value: incidence.value,
                        date: date,
                        dateObject: moment(date),
                        incidenceType: incidence.incidenceType,
                        type: incidence.type
                    };
                    extraHours.push(extraHour);
                });
            }
            var sundayHours = 0;
            var normalHours = 0;
            var fastSalary = 0;
            var total = 0;
            angular.forEach(extraHours, function (extraHour, key) {
                var salary = 0;
                if (extraHour.dateObject.isoWeekday() === 7) {
                    salary = parseFloat(extraHour.value) * sundaySalaryByHour * 2;
                    sundayHours += parseFloat(extraHour.value);
                } else {
                    salary = parseFloat(extraHour.value) * salaryByHour * 2;
                    normalHours += parseFloat(extraHour.value);
                }
                salary = Math.round(salary * 100) / 100
                if (extraHour.type == "fast") {
                    fastSalary += salary;
                }
                extraHours[key].salary = salary;
                total = total + salary;
            });
            return {
                sundayHours: sundayHours,
                normalHours: normalHours,
                fastSalary: fastSalary,
                total: total,
                extraHours: extraHours
            }

        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('getEmployeesOfMovementsForOperation', getEmployeesOfMovementsForOperation)

    function getEmployeesOfMovementsForOperation(ListsF, $filter, $log) {

        return getEmployeesOfMovementsForOperationFn;

        function getEmployeesOfMovementsForOperationFn(movementsGroupedByEmployee, dispersionEmployees, period) {
            return new Promise(function(resolve, reject) {
                var requests = [];
                var employeesToQuery = movementsGroupedByEmployee;
                var flagFromDispersion = false;
                if (typeof(dispersionEmployees) == "object") {
                    employeesToQuery = dispersionEmployees;
                    flagFromDispersion = true;
                }
                for (var m in employeesToQuery) {
                    requests.push(ListsF.loadList('employees', 'catalogs/employees/collection/', m, 'object', 'operationEmployees-' + m));
                }
                Promise.all(requests).then(function(employees) {
                    var validEmployees = [];
                    var employeesObj = [];
                    for (var e = 0; e < employees.length; e++) {
                        var tempId = employees[e].$id;
                        var thisEmployee = $filter('clearObject')(employees[e]);
                        thisEmployee.$id = tempId;
                        //Se valida que el usuario exista preguntando si existe e nodo movimientos de lo contrario es un empleado invalido
                        if (thisEmployee.hasOwnProperty('movements')) {
                            var validEmployee = false;
                            if (flagFromDispersion) {
                                if (typeof(dispersionEmployees[thisEmployee.$id].calculations) !== "undefined") {
                                    validEmployee = true;
                                    thisEmployee.calculations = dispersionEmployees[thisEmployee.$id].calculations;
                                }
                            } else {
                                var thisMovements = thisEmployee.movements;
                                var lastMovementInEmployee = $filter("getLastMovemenBeforeDate")(thisMovements, period.start);
                                var lastMovementInMovements = $filter("getLastMovemenBeforeDate")(movementsGroupedByEmployee[thisEmployee.$id], period.start);
                                if (lastMovementInEmployee.length) {
                                    lastMovementInEmployee = lastMovementInEmployee[0];
                                } else {
                                    lastMovementInEmployee = undefined;
                                }
                                if (lastMovementInMovements.length) {
                                    lastMovementInMovements = lastMovementInMovements[0];
                                } else {
                                    lastMovementInMovements = undefined;
                                }
                                if (typeof(lastMovementInMovements) !== "undefined" && typeof(lastMovementInEmployee) !== "undefined" && lastMovementInEmployee.$id != lastMovementInMovements.$id) {
                                    if (lastMovementInEmployee.d > lastMovementInMovements.data.date && lastMovementInEmployee.p != lastMovementInMovements.payroll) {
                                        $log.debug(thisEmployee.data.name, "tiene un movimiento con id", lastMovementInEmployee.$id, "y fecha", $filter("date")(lastMovementInEmployee.d, "shortDate"), "mayor al movimiento con id", lastMovementInMovements.$id, "con fecha", $filter("date")(lastMovementInMovements.data.date, "shortDate"))
                                        var founded = $filter("filter")(movementsGroupedByEmployee[thisEmployee.$id], {
                                            $id: lastMovementInMovements.$id
                                        });
                                        if (founded.length) {
                                            var index = movementsGroupedByEmployee[thisEmployee.$id].indexOf(founded[0]);
                                            movementsGroupedByEmployee[thisEmployee.$id].splice(index, 1);
                                        } else {
                                            $log.error("No se encontro el movimiento de", thisEmployee.data.name, "en sus movementsGrouped");
                                        }
                                    } else if (lastMovementInEmployee.d > lastMovementInMovements.data.date && lastMovementInEmployee.p == lastMovementInMovements.payroll) {
                                        $log.error(thisEmployee.data.name, "tiene un movimiento registrado en employee.movements con id", lastMovementInEmployee.$id, " de esta nomina que no se añadio a la consulta de movimientos")
                                    } else if (lastMovementInEmployee.d < lastMovementInMovements.data.date) {
                                        $log.error(thisEmployee.data.name, "tiene un movimiento registrado en movements con id", lastMovementInMovements.$id, "que no se encuentra registrado en employee.movements");
                                    }
                                } else if (typeof(lastMovementInEmployee) !== "undefined" && lastMovementInEmployee.t !== 2 && lastMovementInEmployee.p == $scope.payrollId && lastMovementInEmployee.$id != lastMovementInMovements.$id) {
                                    $log.error(thisEmployee.data.name, "tiene un movimiento registrado en employee.movements de esta nomina que no se añadio a la consulta de movimientos", lastMovementInEmployee);
                                }
                                thisEmployee.movements = movementsGroupedByEmployee[thisEmployee.$id];

                                var activeDays = $filter("activeDaysFromMovements")($filter("orderBy")(thisEmployee.movements, "data.date"), period, []);
                                var movements = [];
                                //console.log(activeDays,employee.$id);
                                angular.forEach(activeDays, function(activeDay) {
                                    var addToActiveDays = true;
                                    if (angular.isDefined(activeDay.endMovement) && angular.isDefined(activeDay.endMovement.data)) {
                                        if (activeDay.endMovement.data.type == 2 && !activeDay.endMovement.data.paySalaryInPayrol) {
                                            addToActiveDays = false;
                                        }
                                    }
                                    if (addToActiveDays) {
                                        if (activeDay.startMovementId) {
                                            var obj = $filter("getObjectOfArrayById")(activeDay.startMovementId, movements);
                                            if (obj === null) {
                                                var movement = $filter("getObjectOfArrayById")(activeDay.startMovementId, thisEmployee.movements);
                                                if (movement !== null) {
                                                    movements.push(movement);
                                                }
                                            }
                                        }
                                        if (activeDay.endMovementId) {
                                            var obj = $filter("getObjectOfArrayById")(activeDay.endMovementId, movements);
                                            if (obj === null) {
                                                var movement = $filter("getObjectOfArrayById")(activeDay.endMovementId, thisEmployee.movements);
                                                if (movement !== null) {
                                                    movements.push(movement);
                                                }
                                            }
                                        }
                                    }
                                });
                                if (movements.length) {
                                    thisEmployee.movements = movements;
                                    validEmployee = true;
                                }
                            }
                            if (validEmployee) {
                                validEmployees.push(thisEmployee);
                                employeesObj.push(employees[e]);
                            }
                        } else {
                            $log.error('Empleado con ID:' + thisEmployee.$id + ' no existe', movementsGroupedByEmployee[thisEmployee.$id]);
                        }
                    }
                    resolve({
                        validEmployees: validEmployees,
                        employeesObj: employeesObj
                    })
                }).catch(function(error) {
                    reject(error);
                });
            });
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('getEmployeesCcs', getEmployeesCcs)

    function getEmployeesCcs(getSomethingOfArrayFBFilter) {

        return getEmployeesCcsFn;

        function getEmployeesCcsFn(employees, ccs) {
            var employeesFiltered = [];
            angular.forEach(employees, function(employee) {
                var ccsOfEmployee = [];
                for (var m in employee.movements) {
                    if (employee.movements[m].cc) {
                        ccsOfEmployee.push(employee.movements[m].cc);
                    }

                }
                var isInArray = false;
                for (var i = 0; i < ccsOfEmployee.length; i++) {
                    var isInList = getSomethingOfArrayFBFilter(ccsOfEmployee[i], ccs, "name", false);
                    if (isInList !== false) {
                        isInArray = true;
                        i = ccsOfEmployee.length;
                    }
                }
                if (isInArray) {
                    employeesFiltered.push(employee);
                }
            })
            return employeesFiltered;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('getEmployeesAndDataForOperation', getEmployeesAndDataForOperation)

    function getEmployeesAndDataForOperation(ListsF, getEmployeesOfMovementsForOperationFilter, $q, AppF, getArrayOfIdsFilter, listenCreditsFilter, listenConstantsFilter, listenCcsFilter, listenRpsFilter) {
        return getEmployeesAndDataForOperationFn;

        function getEmployeesAndDataForOperationFn(movementsGroupedByEmployee, dispersion, operation, period, loadAllData, ccs) {
            return new Promise(function(resolve, reject) {
                var dispersionEmployees;
                if (typeof(dispersion) == "object" && typeof(dispersion.calculations) == "object") {
                    dispersionEmployees = dispersion.calculations;
                }
                getEmployeesOfMovementsForOperationFilter(movementsGroupedByEmployee, dispersionEmployees, period.start).then(function(resp) {
                    var operationEmployees;
                    var employeeObj;
                    console.log(resp);
                    if (AppF.permissionToAccessAllPayrolls) {
                        operationEmployees = resp.validEmployees;
                    } else {
                        var ccsIdsArray = getArrayOfIdsFilter(ccs, "$id");
                        if (typeof(dispersionEmployees) === "object") { //Si ya existe el nodo de dispersion de empleados se filtran los empleados de acuerdo al cc que se registro en la operación al momento de hacer la dispersion
                            operationEmployees = resp.validEmployees.filter(function(employee) {
                                var thisEmployeeCC;
                                var flag = false;
                                if (typeof(operation) == "object" && typeof(operation.employees) == "object" && typeof(operation.employees[employee.$id]) == "object") {
                                    thisEmployeeCC = operation.employees[employee.$id].cc;
                                }
                                if (typeof(thisEmployeeCC) !== "undefined") {
                                    flag = ccsIdsArray.indexOf(thisEmployeeCC) > -1;
                                }
                                return flag;
                            })
                        } else { //Si no existe el nodo se filtran los empledos de acuerdo a los ccs a los que se tienen permiso
                            operationEmployees = resp.validEmployees.filter(function(employee) {
                                return ccsIdsArray.indexOf(employee.cc) > -1;
                            })
                        }
                    }
                    var employeesIdsArray = getArrayOfIdsFilter(operationEmployees, "$id");
                    for (var i = 0; i < resp.validEmployees.length; i++) {
                        var thisEmployee = resp.validEmployees[i];
                        var ccEmployee = thisEmployee.cc;
                        if (typeof(dispersionEmployees) == "object" && typeof(dispersionEmployees[thisEmployee.$id]) == "object") {
                            ccEmployee = dispersionEmployees[thisEmployee.$id].cc;
                        }
                        if (typeof(ccEmployee) == "string") {
                            thisEmployee.cc = ccEmployee;
                        }
                        listenCcsFilter(thisEmployee);
                        listenRpsFilter(thisEmployee);
                        if (loadAllData && employeesIdsArray.indexOf(thisEmployee.$id) > -1) {
                            listenCreditsFilter(thisEmployee, period);
                            listenConstantsFilter(thisEmployee);
                        }
                    }
                    var allPromises = [
                        $q.all(AppF.rpsData),
                        $q.all(AppF.ccsData),
                        $q.all(function() {
                            var array = [];
                            angular.forEach(AppF.constants, function(constant) {
                                array.push(constant.object.$loaded());
                            });
                            return array;
                        }),
                        $q.all(AppF.creditsData)
                    ]
                    Promise.all(allPromises).then(function(employeesDataPromises) {
                        var ccs = [];
                        var rps = [];
                        angular.forEach(employeesDataPromises[0], function(snap, key) {
                            if (snap.exists()) {
                                var obj = snap.val();
                                obj.$id = key;
                                rps.push(obj);
                            }
                        });
                        angular.forEach(employeesDataPromises[1], function(snap, key) {
                            if (snap.exists()) {
                                var obj = snap.val();
                                obj.$id = key;
                                ccs.push(obj);
                            }
                        });
                        if (typeof(employeesDataPromises[3]) !== "undefined") {
                            for (var e in operationEmployees) {
                                operationEmployees[e].credit = employeesDataPromises[3][operationEmployees[e].$id];
                            }
                        }
                        var finalResponse = {
                            allEmployees: resp.validEmployees,
                            operationEmployees: operationEmployees,
                            employeeObj: employeeObj,
                            ccs: ccs,
                            rps: rps
                        };
                        resolve(finalResponse);
                    }).catch(function(error) {
                        reject(error);
                    });
                }).catch(function(error) {
                    reject(error);
                });
            })
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getEmployeePaymentForm', getEmployeePaymentForm)

    function getEmployeePaymentForm() {

        return getEmployeePaymentFormFn;

        function getEmployeePaymentFormFn(paymentForms, processP, operationType) {
            var paymentForm;
            var process = processP;
            if (processP === 'fiscal' && ['ptuRecord', 'asimilated'].indexOf(operationType) > -1) {
                process = operationType;
            }
            if (angular.isArray(paymentForms) && paymentForms.length > 0) {
                if (paymentForms.length === 1) {
                    paymentForm = paymentForms[0].type;
                } else {
                    var index = paymentForms.findIndex(function (item) {
                        return item.process === process;
                    })
                    if (index === -1) {
                        index = paymentForms.findIndex(function (item) {
                            return (!item.hasOwnProperty('process'));
                        })
                    }
                    if (index === -1) {
                        index = 0;
                    }
                    paymentForm = paymentForms[index].type;
                }
            }

            return paymentForm;
        }
    }

}());
(function(){
    'use strict';

    angular
        .module('app.clients')
        .filter('getEmployeeCalculationValue', getEmployeeCalculationValue)

    function getEmployeeCalculationValue(){

        return getEmployeeCalculationValueFn;

        function getEmployeeCalculationValueFn(employees, employeeId, incidenceType, complementOrProcess){
            for(var e in employees){
                var employee = employees[e];
                if(employee.$id == employeeId){
                    if(employee.hasOwnProperty('calculations')){
                        if(employee.calculations.hasOwnProperty(complementOrProcess)){
                            if(employee.calculations[complementOrProcess].hasOwnProperty(incidenceType)){
                                return employee.calculations[complementOrProcess][incidenceType].value.total + '';
                            }
                        }
                    }
                }
            }
            return false;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('getEachActiveDayOfPeriod', getEachActiveDayOfPeriod)

    function getEachActiveDayOfPeriod(
        setTimeOfDateFilter,
        AppF
    ) {

        return getEachActiveDayOfPeriodFn;

        function getEachActiveDayOfPeriodFn(activeDays, movementsEmployee, period, salaryRequested) {
            var realActiveDays = {};
            var startPeriod = moment(period.start);
            setTimeOfDateFilter(startPeriod, "start");
            var endPeriod = moment(period.end);
            setTimeOfDateFilter(endPeriod, "end");
            angular.forEach(activeDays, function(activeDay, key) {
                var startActiveDay = moment(activeDay.start);
                setTimeOfDateFilter(startActiveDay, "start");
                var endActiveDay = moment(activeDay.end);
                setTimeOfDateFilter(endActiveDay, "end");
                var days = endActiveDay.diff(startActiveDay, "days") + 1;
                var absences = [];
                angular.forEach(activeDay.absencesIncidences, function(abs, key) {
                    for (var i in parseInt(abs.value)) {
                        var tempDate = angular.copy(abs.date);
                    }
                });
                for (var i = 0; i < days; i++) {
                    realActiveDays[startActiveDay.valueOf()] = {}
                    if (movementsEmployee[activeDay.movementId]) {
                        angular.forEach(salariesRequested,function(salaryRequest){
                            
                        })
                        realActiveDays.real = AppF.movements.data.salary;
                    }
                }
            });
            return realActiveDays;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getDispersion', getDispersion)

    function getDispersion(ListsF, transformDispersionObjFilter) {

        return getDispersionFn;

        function getDispersionFn(operation, dispersionRef) {
            return new Promise(function (resolve, reject) {
                var dispersion;
                var dispersionQuery = [];
                if (typeof (operation.dispersion) !== "undefined") {
                    dispersionQuery.push(ListsF.loadList("dispersions", dispersionRef, operation.dispersion, "object", "dispersion-" + operation.dispersion))
                }
                Promise.all(dispersionQuery).then(function (resp) {
                    if (resp.length > 0) {
                        dispersion = transformDispersionObjFilter(resp[0]);
                    }
                    resolve({
                        dispersionObj: resp[0],
                        dispersion: dispersion
                    });
                })
            })
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getDaysMatrixOfMovements', getDaysMatrixOfMovements)

    function getDaysMatrixOfMovements(

    ) {

        return getDaysMatrixOfMovementsFn;

        /**
         * Model Matrix
         */
        function Matrix() {
            this.addDays = function (dayOfMovement) {
                var daysAdded;
                //cuando la fecha del movimiento corresponde a otro mes
                //console.log(this.lastDayInPeriod, this.firstDayInPeriod, dayOfMovement)
                if (this.lastDayInPeriod < this.firstDayInPeriod && dayOfMovement >= this.firstDayInPeriod) {
                    daysAdded = (this.daysOfMonth - dayOfMovement + this.lastDayInPeriod) + 1;
                } else {
                    daysAdded = (this.lastDayInPeriod - dayOfMovement) + 1;
                }
                //console.log(daysAdded);
                var daysAddedByEnrole = daysAdded * this.dayWorth;
                this.daysAddedByEnroles.days += new Number(parseFloat(daysAddedByEnrole).toFixed(2));
                this.movs.push(dayOfMovement);
                this.daysAddedByEnroles.enroles.push({
                    dayOfMovement: dayOfMovement,
                    daysAdded: daysAddedByEnrole
                });
            };
            this.removeDays = function (dayOfMovement) {
                var daysRested;

                if (this.lastDayInPeriod < this.firstDayInPeriod && dayOfMovement >= this.firstDayInPeriod) {
                    daysRested = this.daysOfMonth - dayOfMovement + this.lastDayInPeriod;
                } else {
                    if (this.lastDayInPeriod < dayOfMovement) {
                        dayOfMovement = this.lastDayInPeriod
                    }
                    daysRested = this.lastDayInPeriod - dayOfMovement;
                }
                var daysRestedByDismiss = daysRested * this.dayWorth;
                this.daysRestedByDismisses.days += new Number(parseFloat(daysRestedByDismiss).toFixed(2));
                this.movs.push(dayOfMovement * -1);
                this.daysRestedByDismisses.dismisses.push({
                    dayOfMovement: dayOfMovement,
                    daysRested: daysRestedByDismiss
                })
            };
            this.movs = [];
            this.firstDayOfPeriod;
            this.lastDayOfPeriod;
            this.dayWorth = 1;
            this.daysAddedByEnroles = {
                enroles: [],
                days: 0
            };
            this.daysRestedByDismisses = {
                dismisses: [],
                days: 0
            }
            this.wd = function () {
                return new Number(parseFloat(this.daysAddedByEnroles.days - this.daysRestedByDismisses.days).toFixed(2));
            }
        }

        /**
         * 
         * @param moment.timestamp startOfPeriod 'día en que empieza el periodo'
         * @param moment.timestamp endOfPeriod 'día en que termina el periodo'
         * @param number daysOfPeriod 'número de días del periodo'
         * @param {*} movements 'los movimientos activos del periodo, por default no toma las bajas que no se pagan en nómina'
         * @return {*} 'regresa la matrix de bajas y altas y el numero total de días que deben sumarse y restarse al algoritmo para días trabajados'
         */
        function getDaysMatrixOfMovementsFn(startOfPeriod, endOfPeriod, daysOfPeriod, movs) {
            var movements = JSON.parse(JSON.stringify(movs))
            var movementsStatus = {
                enroles: [6, 8],
                dismisses: [2]
            };
            var matrix = new Matrix();
            matrix.firstDayInPeriod = getDayOfPeriod(startOfPeriod, daysOfPeriod);
            matrix.lastDayInPeriod = getDayOfPeriod(endOfPeriod, daysOfPeriod);
            matrix.dayWorth = getDayWorth(daysOfPeriod);
            matrix.daysOfMonth = moment(startOfPeriod).daysInMonth();
            var firstMovement = false;
            for (var m in movements) {
                var movement = (movements[m].hasOwnProperty('endMovement')) && (movements[m].endMovement.t === 2 || movements[m].endMovement.data.type === 2) ?
                    movements[m].endMovement :
                    movements[m].startMovement;
                var movementDate = movement.d || movement.data.date;
                var movementType = movement.t || movement.data.type;
                movement.dd = moment(movementDate).format('DD/MM/YYYY');
                var dayOfMovement = getDayOfPeriod(movementDate < startOfPeriod ? movements[m].start : movementDate);
                if (!firstMovement) firstMovement = angular.copy(dayOfMovement);
                // si es el primer movimiento se agrega un movimiento extra
                if (firstMovement == dayOfMovement) {
                    // si el primer movimiento es una baja, 
                    // implica que ya estaba activo desde el inicio del periodo

                    if (movementsStatus.dismisses.indexOf(movementType) !== -1) {
                        // por lo que se suman los días desde el inicio hasta la baja
                        // y se agregan a los días sumados por altas
                        var thisDay = getDayOfPeriod(movements[m].start);
                        matrix.addDays(thisDay);
                    }
                    if (movementType == 7) {
                        matrix.addDays(dayOfMovement);
                    }
                }

                // si el movimiento es una baja
                if (movementsStatus.dismisses.indexOf(movementType) !== -1) {
                    matrix.removeDays(dayOfMovement);
                } else
                    // si el movimiento es una alta
                    if (movementsStatus.enroles.indexOf(movementType) !== -1) {
                        matrix.addDays(dayOfMovement);
                    }

            }
            return matrix;
        }

        /**
         * 
         * @param number date 
         * @param number daysOfPeriod *optional
         * @return 'regresa el día en numero considerando que si se introducen los días del periodo está pidiendo el primer o ultimo día para 7, 10, 14, 15, 30, 15.21 y 30.42. Si necesitan otro caso se tiene que programar'
         */
        function getDayOfPeriod(date, daysOfPeriod) {
            var dayNumber = parseInt(moment(date).format('DD'));

            if (daysOfPeriod) {
                switch (daysOfPeriod) {
                    case 7:
                    case 10:
                    case 14:
                        break;
                    case 15:
                    case 30:
                        switch (dayNumber) {
                            // same 1, 15, 16 & 30
                            case 28:
                            case 29:
                            case 31:
                                dayNumber = 30;
                                break;
                        }
                        break;
                    case 15.21:
                    case 30.42:
                        switch (dayNumber) {
                            // same 1
                            case 15:
                                dayNumber = 15;
                                break;
                            case 16:
                                dayNumber = 16;
                                break;
                            case 28:
                            case 29:
                            case 30:
                            case 31:
                                dayNumber = 30;
                                break;
                        }
                        break;
                }
            }

            return dayNumber;
        }

        /**
         * 
         * @param number daysOfPeriod 
         */
        function getDayWorth(daysOfPeriod) {
            var dayWorth = 1;
            switch (daysOfPeriod) {
                // 1 => 7, 10, 14, 15, 30
                case 15.21:
                case 30.42:
                    dayWorth = 1.014;
                    break;
            }
            return dayWorth;
        }
    }

}());
(function(){
    'use strict';

    angular
        .module('app.clients')
        .filter('getDataOfProcess', getDataOfProcess)

    function getDataOfProcess(){

        return getDataOfProcessFn;

        function getDataOfProcessFn(processes, looking){
            for(var p in processes){
                if(processes[p].hasOwnProperty('name')){
                    if(looking == processes[p].name) return processes[p];
                } else if(p == 'complements'){
                    for(var c in processes[p]){
                        if(processes[p][c].hasOwnProperty('name')){
                            if(looking == processes[p][c].name) return processes[p][c];
                        }
                    }
                }
            }
            return false;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getDataOfOperation', getDataOfOperation);

    function getDataOfOperation($q, MongoF, AppF, ListsF, $log, getMovementsFromEmployeFilter, DataF, loopEachFilter, getMinimumWageOfDateFilter, getFromObjectFilter, getCyvTableFilter, ApiV3F) {

        return getDataOfOperationFn;
        function setDato(fbObjs, objectsVal, responses) {
            for (var obj in responses) {
                if (objectsVal.hasOwnProperty(obj)) {
                    var value = responses[obj];
                    if (objectsVal[obj].hasOwnProperty('path')) {
                        value = getFromObjectFilter(value, objectsVal[obj].path);
                    }
                    if (angular.isDefined(value) && value !== null) {
                        fbObjs[obj] = { fb: value };
                        if (objectsVal[obj].hasOwnProperty('extra')) {
                            fbObjs[obj] = Object.assign(fbObjs[obj], objectsVal[obj].extra);
                        }
                    } else if (objectsVal[obj].hasOwnProperty('defaultValue')) {
                        fbObjs[obj] = { fb: objectsVal[obj].defaultValue };
                    } else if (objectsVal[obj].required) {
                        throw objectsVal[obj].msgError;
                    }
                }
            }
        }
        function getDataOfOperationFn(dataNeeded, operationId, payrollId) {
            return $q(function (resolve, reject) {
                var refs = {};
                var fbObjs = {};
                var promises = {};
                var objectsVal = {};
                var objIndex = [];
                var absencesToCheck = [];
                if (AppF.permissionToAccessAllPayrolls) {
                    fbObjs.myCcs = { fb: ListsF.ccs, actions: ['setOperationCcs'] };
                } else {
                    fbObjs.myCcs = { fb: ListsF.userCcs[AppF.profile.uid], actions: ['setOperationCcs'] };
                }
                objIndex.push('myCcs');
                //Se establecen las referencias y los datos que se ocuparan para obtener la información de la operación
                promises.needed = MongoF.loadNeeded(dataNeeded); //catálogos de mongo
                //Se carga la informacion del aguinaldo
                refs.settlements = 'catalogs/operations/settlement/all/';
                promises.operation = ListsF.loadList('settlements', refs.settlements, operationId, 'object', 'settlement' + operationId);
                objectsVal.operation = { extra: { inScope: true, actions: [{ action: 'reloadOperation', field: 'status' }, 'setVariablesOfOperation'], watch: true }, required: true, msgError: 'No se encontró una operación con esos datos' };
                objIndex.push('operation');
                //Se cargan todos los conceptos
                refs.concepts = '/lists/concepts/center/' + AppF.center;
                promises.concepts = ListsF.loadList('concepts', refs.concepts, undefined, 'array', 'conceptsCatalogs');
                objectsVal.concepts = { extra: { actions: ['setFastIncidencesTypes', 'setConceptsMap'] }, required: true, msgError: 'No se encontró registro de conceptos' };
                objIndex.push('concepts');
                //Se cargan la nomina a la cual corresponde el aguinaldo
                refs.payrolls = 'catalogs/payrolls/collection';
                promises.payroll = ListsF.loadList('payrolls', refs.payrolls, payrollId, 'object', 'payroll-' + payrollId);
                objectsVal.payroll = { extra: { actions: ['setPayrollOfEmployees', 'setThisBankAccounts'], inScope: true }, required: true, msgError: 'La nomina seleccionada no existe' };
                objIndex.push('payroll');
                var employeeId;
                $q.all(promises).then(function (resp) {
                    setDato(fbObjs, objectsVal, resp);
                    promises = {}, objectsVal = {};
                    loopEachFilter(fbObjs.operation.fb.employees, function (employee, key) {
                        employeeId = key;
                    });
                    if (angular.isUndefined(employeeId)) {
                        throw 'No se agregaron los empleados esta operación correctamente';
                    }
                    //Se obtiene el calendario al cual pertenece el aguinaldo
                    var calendarOfSettlement = [{ q: 'orderByChild', v: 'data/endDate' }, { q: 'startAt', v: fbObjs.operation.fb.movement.date }, { q: 'limitToFirst', v: 1 }];
                    refs.payrollCalendars = 'catalogs/payrollCalendars/' + payrollId + '/calendars';
                    promises.calendar = ListsF.loadList('payrollCalendars', refs.payrollCalendars, undefined, 'array', 'calendarOfSettlement-' + payrollId + '-' + fbObjs.operation.fb.movement.date, calendarOfSettlement);
                    objectsVal.calendar = { extra: { inScope: true }, path: '0', required: true, msgError: 'No se encontró calendario activo' };
                    objIndex.push('calendar');
                    refs.dispersion = 'catalogs/dispersions/collection';
                    //Se cargan los salarios minimos
                    var todayDate = moment().valueOf();
                    promises.minimumWageRecords = getMinimumWageOfDateFilter(todayDate);
                    objectsVal.minimumWageRecords = { required: true, msgError: 'No se encontró registro de salarios mínimos' };
                    objIndex.push('minimumWageRecords');
                    //Si el finiquito ya esta cerrado se obtiene la dispersion como las incidencias ya cerradas
                    if (fbObjs.operation.fb.status >= 3) {
                        //Se obtienen la dispersion
                        promises.dispersionF = ListsF.loadList('dispersion', refs.dispersion, fbObjs.operation.fb.dispersion, 'object', 'dispersion-' + fbObjs.operation.fb.dispersion);
                        objectsVal.dispersionF = { extra: { actions: ['setDispersion'] }, required: true, msgError: 'No se encontró la dispersion del aguinaldo' };
                        objIndex.push('dispersionF');
                    } else {//Si no esta cerrada la nomina se obtienen solamente las incidencias y en caso de que se necesite tambien los elementos para calcular la nomina
                        //Si no se va a pagar la nomina se obtiene la configuracion de pago de la nomina
                        if (!fbObjs.operation.fb.movement.paySalaryInPayrol) {
                            //Se obtiene el esquema de pago
                            refs.paymentSchemas = 'catalogs/paymentSchemas/collection';
                            promises.paymentSchema = ListsF.loadList('paymentSchemas', refs.paymentSchemas, fbObjs.payroll.fb.paymentSchema, 'object', 'paymentSchema-' + fbObjs.payroll.fb.paymentSchema);
                            objectsVal.paymentSchema = { extra: { actions: ['setProccess'] }, required: true, msgError: 'La nomina no tiene un esquema asignado o no existe' };
                            objIndex.push('paymentSchema');

                        }
                        //Se obtiene la frencuencia de pago
                        promises.paymentFrequency = DataF.api.get('paymentFrequenciesRecords/' + fbObjs.payroll.fb.paymentFrequency);
                        objectsVal.paymentFrequency = { path: 'data', required: true, msgError: 'La nomina no tiene una frecuencia de pago' };
                        objIndex.push('paymentFrequency');
                    }
                    //Se obtiene las incidencias
                    var incidencesQueries = [{ q: 'orderByChild', v: 'settlement' }, { q: 'equalTo', v: operationId }];
                    refs.incidencesApplied = 'lists/incidences/employee/' + employeeId + '/applied';
                    promises.incidencesApplied = ListsF.loadList('incidences', refs.incidencesApplied, undefined, 'array', 'incidencesFor-settlement-' + operationId, incidencesQueries)
                    objectsVal.incidencesApplied = { extra: { actions: ['setIncidences'], watch: true } };
                    objIndex.push('incidencesApplied');
                    //Se obtienen las incidencias
                    refs.pendingIncidences = 'lists/incidences/employee/' + employeeId + '/pending';
                    promises.pendingIncidences = ListsF.loadList('incidences', refs.pendingIncidences, undefined, 'array', 'pendingIncidencesOf-' + employeeId);
                    objectsVal.pendingIncidences = { extra: { actions: ['setIncidences'], watch: true } };
                    objIndex.push('pendingIncidences');
                    //Se obtiene la configuracion del aguinaldo
                    refs.processConfigs = 'catalogs/processConfigs/collection';
                    promises.processConfig = ListsF.loadList('processConfigs', refs.processConfigs, fbObjs.operation.fb.processConfigId, 'object', 'processConfig-' + fbObjs.operation.fb.processConfigId);
                    objectsVal.processConfig = { extra: { actions: ['setProccess'] }, required: true, msgError: 'No se encontró el proceso configurado para el finiquito' };
                    objIndex.push('processConfig');
                    //Se obtienen las incidencias de faltas que se utilizaran para calcular el finiquito
                    loopEachFilter(fbObjs.operation.fb.absencesToCheck, function (value, incidenceId) {
                        if (value) { absencesToCheck.push(incidenceId); }
                    })
                    if (absencesToCheck.length > 0) {
                        var dismissDate = moment(fbObjs.operation.fb.movement.date)
                        var thisYearStart = dismissDate.clone().startOf('year');
                        fbObjs.operation.fb.movement.date
                        var incidencesToDiscountParams = {
                            employee: employeeId,
                            incidenceType: angular.toJson({ $in: absencesToCheck }),
                            status: 3,
                            payroll: payrollId,
                            date: angular.toJson({ $gte: thisYearStart.valueOf(), $lte: dismissDate.valueOf() }),
                            $fields: ["incidenceType", "date", "employee", "value"]
                        };
                        promises.incidencesChecked = ApiV3F.get('api/incidences', incidencesToDiscountParams);
                        objectsVal.incidencesChecked = { path: 'data' };
                        objIndex.push('incidencesChecked');
                    }
                    return $q.all(promises);
                }).then(function (resp) {
                    setDato(fbObjs, objectsVal, resp);
                    if (angular.isDefined(getFromObjectFilter(fbObjs.incidencesChecked, 'fb'))) {
                        fbObjs.incidencesChecked.fb = getFromObjectFilter(fbObjs.incidencesChecked, 'fb', []).reduce(function (current, incidence) {
                            current[incidence.employee] = current[incidence.employee] || [];
                            current[incidence.employee].push(incidence);
                            return current;
                        }, {});
                    }
                    fbObjs.getCyvTable = { fb: getCyvTableFilter(resp.minimumWageRecords, MongoF.cyvRecords, fbObjs.calendar.fb.$id) };
                    promises = {}, objectsVal = {};
                    var periodOfSettlement = [{ q: 'orderByChild', v: 'end' }, { q: 'startAt', v: fbObjs.operation.fb.movement.date }, { q: 'limitToFirst', v: 1 }];
                    refs.periods = 'catalogs/payrollCalendars/' + payrollId + '/periods/' + fbObjs.calendar.fb.$id;
                    promises.period = ListsF.loadList('payrollCalendarsPeriods', refs.periods, undefined, 'array', 'periodOfSettlement' + payrollId + '-' + fbObjs.operation.fb.movement.date, periodOfSettlement);
                    objectsVal.period = { extra: { inScope: true }, path: '0', required: true, msgError: 'No se encontró periodo para este finiquito' };
                    objIndex.push('period');
                    return $q.all(promises);
                }).then(function (resp) {
                    setDato(fbObjs, objectsVal, resp);
                    //Se cambia la ruta de las incidencias para que se inserten correctamente
                    refs.incidences = 'incidences/' + payrollId + '/' + fbObjs.calendar.fb.$id;
                    //Si el finiquito ya esta cerrado pues simplemente se regresa la informacion del finiquito
                    if (fbObjs.operation.fb.status >= 3) {
                        refs.operations = refs.settlements;
                        resolve({ refs: refs, fbObjs: fbObjs, objIndex: objIndex });
                    } else if (!fbObjs.operation.fb.disableMonthlyBase) {
                        promises = {}, objectsVal = {};
                        var operationOfSettlement = [{ q: 'orderByChild', v: 'period' }, { q: 'equalTo', v: fbObjs.period.fb.period }];
                        refs.operations = 'catalogs/operations/ordinary/' + payrollId + '/' + fbObjs.calendar.fb.$id + '/collection';
                        promises.activeOperation = ListsF.loadList('operations', refs.operations, undefined, 'array', 'operationOfSettlement' + payrollId + '-' + fbObjs.period.fb.period, operationOfSettlement);
                        objectsVal.activeOperation = { path: '0', defaultValue: { status: 1, employees: {} }, msgError: 'No se encontró la operación para este finiquito' };
                        objIndex.push('activeOperation');
                        var lastPeriod = (parseInt(fbObjs.period.fb.period) - 1);
                        if (!isNaN(lastPeriod) && lastPeriod > 0) {
                            var lastOperationOfSettlement = [{ q: 'orderByChild', v: 'period' }, { q: 'equalTo', v: lastPeriod }];
                            promises.lastOperation = ListsF.loadList('operations', refs.operations, undefined, 'array', 'lastOperationOfSettlement' + payrollId + '-' + fbObjs.period.fb.period, lastOperationOfSettlement);
                            objectsVal.lastOperation = { path: '0' };
                            objIndex.push('lastOperation');
                        }
                        return $q.all(promises);
                    }
                }).then(function (resp) {
                    setDato(fbObjs, objectsVal, resp);
                    promises = {}, objectsVal = {};
                    fbObjs.operation.fb.isAdjustment = true;
                    if (fbObjs.activeOperation && fbObjs.activeOperation.fb.status >= 3 && angular.isDefined(getFromObjectFilter(fbObjs.activeOperation.fb, 'employees.' + employeeId))) {
                        fbObjs.lastOperation = fbObjs.activeOperation;
                        fbObjs.lastOperation.fb.isAdjustment = false;
                    }
                    var dispersionId = getFromObjectFilter(fbObjs.lastOperation, 'fb.dispersion');
                    if (angular.isDefined(dispersionId)) {
                        refs.operationDispersion = 'catalogs/dispersions/collection';
                        promises.lastDispersionF = ListsF.loadList('dispersions', refs.operationDispersion, dispersionId, 'object', 'dispersion-' + dispersionId);
                        objectsVal.lastDispersionF = { extra: { actions: ['setLastDispersion'] } };
                        objIndex.push('lastDispersionF');
                    }
                    promises.movements = getMovementsFromEmployeFilter(payrollId, fbObjs.operation.fb, fbObjs.period.fb.start, fbObjs.operation.fb.movement.date)
                    objectsVal.movements = { path: 'movements', extra: { actions: ['setEmployeesMovement'] } };
                    objIndex.push('movements');
                    return $q.all(promises);
                }).then(function (resp) {
                    setDato(fbObjs, objectsVal, resp);
                    promises = {}, objectsVal = {};
                    refs.operations = refs.settlements;
                    resolve({ refs: refs, fbObjs: fbObjs, objIndex: objIndex });
                }).catch(reject);
            });
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('getDailyAbsences', getDailyAbsences)

    function getDailyAbsences() {

        return getDailyAbsencesFn;

        function isValidDate(momentDay, activeDays, dailyAbsences) {
            var flag = true;
            if (dailyAbsences.hasOwnProperty(momentDay.format('DD-MM-YYYY'))) {
                flag = false;
            }
            if (flag) {
                var isBetween = false;
                for (var a in activeDays) {
                    if (momentDay.valueOf() >= activeDays[a].start && momentDay.valueOf() <= activeDays[a].end) {
                        isBetween = true;
                    }
                }
                if (!isBetween) {
                    flag = false;
                }
            }
            return flag;
        };

        function getDailyAbsencesFn(absencesIncidences, activeDays) {
            var dailyAbsences = {};
            var dated = [];
            var notDated = [];
            for (var i in absencesIncidences) {
                if (absencesIncidences[i].date) {
                    dated.push(absencesIncidences[i]);
                } else {
                    notDated.push(absencesIncidences[i]);
                }
            }
            for (var d in dated) {
                var thisDate = moment(dated[d].date);
                var thisDateEnd = moment(dated[d].date);
                thisDateEnd.add(1, 'd');
                thisDateEnd.subtract(1, 'ms');
                var salaryObj = {
                    sd: 0,
                    sbc: 0,
                    sdr: 0,
                    start: thisDate.valueOf(),
                    end: thisDateEnd.valueOf(),
                    isActive: true,
                    isAbsences: true
                };
                dailyAbsences[thisDate.format('DD-MM-YYYY')] = salaryObj;
            }
            for (var n in notDated) {
                var thisDate = notDated[n].phantomDate ? moment(notDated[n].phanthomDate) : false;
                if (!thisDate || !isValidDate(thisDate, activeDays, dailyAbsences)) {
                    var dateNotFounded = true;
                    var posibleDate;
                    var i = 0;
                    while (dateNotFounded && i < activeDays.length) {
                        posibleDate = moment(activeDays[i].start);
                        while (dateNotFounded && posibleDate.valueOf() < activeDays[i].end) {
                            if (isValidDate(posibleDate, activeDays, dailyAbsences)) {
                                dateNotFounded = false;
                            } else {
                                posibleDate.add(1, 'd');
                            }
                        }
                        i++;
                    }
                    if (!dateNotFounded) {
                        thisDate = posibleDate;
                    }
                }
                if (thisDate) {
                    var thisDateEnd = moment(thisDate.valueOf());
                    thisDateEnd.add(1, 'd');
                    thisDateEnd.subtract(1, 'ms');
                    var salaryObj = {
                        start: thisDate.valueOf(),
                        end: thisDateEnd.valueOf(),
                        isActive: true,
                        isAbsences: true
                    };
                    dailyAbsences[thisDate.format('DD-MM-YYYY')] = salaryObj;
                }
            }
            return dailyAbsences;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getCyvTable', getCyvTable);

    function getCyvTable($log, loopEachFilter) {

        return getCyvTableFn;

        function getCyvTableFn(minimumWageRecords, cyvRecordsP, year) {
            var cyvTable = {};
            var minimumVariables = angular.fromJson(angular.toJson(minimumWageRecords.minimumVariables));
            delete minimumVariables.year;
            var cyvRecords = cyvRecordsP.filter(function (item) {
                var thisYear = parseInt(year);
                if (!isNaN(thisYear)) {
                    return item.year === thisYear;
                } else {
                    return false;
                }
            });
            if (cyvRecords.length === 0) {
                var yearSetted;
                cyvRecords = cyvRecordsP.sort(function (a, b) {
                    return b.year - a.year;
                }).filter(function (item) {
                    if (angular.isUndefined(yearSetted)) {
                        yearSetted = item.year;
                    }
                    return yearSetted === item.year;
                })
            }
            loopEachFilter(minimumVariables, function (value, zone) {
                var thisTable = [];
                var thisValue = Math.round(value * 1.0493 * 10000) / 10000;
                for (var c = 0; c < cyvRecords.length; c++) {
                    var cyvRecord = cyvRecords[c];
                    var upperLimit = cyvRecord.upperLimit * (cyvRecord.measure === 'uma' ? minimumWageRecords.umaRecord : thisValue);
                    upperLimit = Math.round(upperLimit * 10000) / 10000;
                    thisTable.push({ percent: cyvRecord.percentFee, upperLimit: upperLimit, year: cyvRecord.year });
                }
                thisTable = thisTable.sort(function (a, b) {
                    return a.upperLimit - b.upperLimit;
                });
                cyvTable[zone] = thisTable;
            });
            $log.log(cyvTable);
            return cyvTable;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('getConstantsValue', getConstantsValue)

    function getConstantsValue(AppF, orderByFilter) {

        return getConstantsValueFn;

        function getConstantsValueFn(employeeConstants, incidenceType) {
            var constans = [];
            angular.forEach(employeeConstants, function(value, key) {
                if (angular.isDefined(AppF.constants[value])) {
                    angular.forEach(AppF.constants[value].object, function(constant, kconstant) {
                        if (constant.incidencesType == incidenceType) {
                            var cons = constant;
                            cons.priority = AppF.constants[value].priority;
                            constans.push(cons);
                        }
                    })
                }
            });
            constans = orderByFilter(constans, "priority");
            var finalConstant = {};
            angular.forEach(constans, function(value, key) {
                var newConstant = {
                    incidencesType: value.incidencesType,
                    priority: value.priority
                };
                angular.forEach(value.values, function(field, key) {
                    newConstant[field.label] = field.value;
                });
                angular.merge(finalConstant, newConstant);
            });
            return finalConstant;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('getConstantsOfObject', getConstantsOfObject)

    function getConstantsOfObject() {

        return getConstantsOfObjectFn;

        function getConstantsOfObjectFn(object, objectType) {
            var values = [];
            switch (objectType) {
                case "employee":
                    var employeesField = ["cc", "payroll"];
                    values.push("general");
                    values.push("employee/" + object.$id);
                    angular.forEach(employeesField, function(value, key) {
                        if (angular.isDefined(object[value])) {
                            values.push(value + "/" + object[value]);
                        }
                    });
                    break;
            }
            return values;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('getComplexIncidencesTypes', getComplexIncidencesTypes)

    function getComplexIncidencesTypes(
        MongoF,
        AppF
    ) {

        return getComplexIncidencesTypesFn;

        function getComplexIncidencesTypesFn() {
            if (AppF.complexIncidencesMap) {
                return AppF.complexIncidencesMap;
            }
            var complexIncidencesTypes = {
                system: [],
                default: [],
                special: {
                    perceptions: [],
                    deductions: []
                },
                simple: {
                    perceptions: [],
                    deductions: []
                }
            };

            var complexMap = {
                system: [ // son incidencias del sistema que se usan para hacer calculos diversos
                    'workedDays',
                    'daysOfPeriod',
                    'mensualization', // @todo agregar a la directiva de calculo las formulas
                    'gravableBase',
                    'isr' // of asimilated 
                ],
                default: [ // son las incidencias que se configuran por default en el proceso fiscal
                    '001', // sd, sdr (sueldos, salarios y jornales)
                    '017', // subsidio para el empleo
                    //'027', // imss patron
                    '043', // imss trabajador [001]
                    '044', // isr [002],
                    'socialPrevision',
                    'asimilated'
                ],
                extraordinary: { // incidencias que se pueden calcular en nóminas extraordinarias
                    fiscal: [
                        '002', // aguinaldo
                        '003', // PTU
                        'settlement' // finiquito es configurable
                    ],
                    complements: [ // todas las incidencias por ahora, si hay excepciones aqui iria el mapa
                        
                    ]
                },
                special: {
                    perceptions: [
                        // default automáticas
                        '001', // sd, sdr (sueldos, salarios y jornales) @siempre calculo
                        '017', // subsidio para el empleo @siempre calculo
                        '027', // imss patron @siempre calculo
                        // rápidas y por constante

                    ],
                    deductions: [
                        // default automáticas
                        '043', // imss trabajador [001]
                        '044', // isr [002]
                        // rápidas y por constante
                        '062' // ausentismo (faltas) //siempre por calculo
                    ]
                },
                simple: {
                    perceptions: [
                        // por constante, porcentaje o solo valor
                        '003', // PTU @siempre es por importe
                        '004', // rembolso de gastos medicos dentales y hospitalarios @no se maneja
                        '006', // caja de ahorro
                        '009', // contribuciones a cargo del trabajador pagadas por el patrón
                        '012', // seguro de gastos medicos mayores
                        '013', // cuotas sindicales pagadas por el patrón
                        '015', // becas para trabajadores y/o hijos 
                        '016', // otros
                        '023', // pagos por separación
                        '024', // seguro de retiro
                        '025', // indemnizaciones
                        '026', // rembolso por funeral
                        '028', // comisiones
                        '029', // vales de despensa
                        '030', // vales de restaurante
                        '031', // vales de gasolina
                        '032', // vales de ropa
                        '033', // ayuda para renta
                        '034', // ayuda para articulos escolares
                        '035', // ayuda para anteojos
                        '036', // ayuda para transporte
                        '037', // ayuda para gastos de funeral
                        '038', // otros ingresos por salarios
                        '010', // premio por puntualidad,
                        '005', // fondo de ahorro
                        //desde aqui pueden ser especiales
                        '002', // aguinaldo @puede ser por importe o por calculo
                        '011', // prima de seguro de vida @no se maneja
                        '014', // subsidios por incapacidad @no se maneja
                        '021', // prima vacacional @pude ser por importe o por calculo
                        '039', // jubilaciones, pensiones o haberes de retiro @no se maneja
                        '040', // ingreso por entidades federativas @no se maneja
                        '041', // ingreso por entidades federativas @no se maneja
                        '042', // ingreso pagado por entidades federativas @no se maneja
                        '019', // horas extras @puede ser por importe o por calculo
                        '020', // prima dominical, @puede ser por importe o por calculo
                        '022', // prima por antiguedad @puede ser por importe o por calculo    
                    ],
                    deductions: [
                        '054', // anticipo de salarios [012] @todo hacer el módulo de prestamos con descuentos automáticos o usar constantes
                        '045', // aportaciones al retiro, cesantia, vejez [003]
                        '046', // otros [004]
                        '047', // aportaciones a fondo de vivienda @todo checar con el conta [005]
                        '049', // pensión alimenticia @todo checar con el conta [007]
                        '050', // renta @todo checar con el conta [008],
                        '051', // prestamos provinientes del fondo nacional de la vivienda [009] @todo preguntar al conta
                        '056', // errores [014]
                        '055', // pagos hechos con exceso al trabajador [013]
                        '057', // perdidas [015]
                        '058', // averias [016]
                        '059', // adquisicion de articulos producidos por la empresa [017]
                        '060', // cuotas para la constitución de sociedades cooperativas [018] @todo preguntar al conta
                        '061', // cuotas sindicales [019] @todo preguntar al conta
                        '063', // cuotas obrero-patronales [021] @todo preguntar al conta
                        //desde aqui pueden ser especiales
                        '052', // pagos por crédito de vivienda [010] //siempre por calclo
                        '053', // pagos y abonos infonacot [011] //siempre por calculo
                        '048', // descuento por incapacidad [006] @no se maneja

                    ]
                }
            };
            for (var i in MongoF.satIncidencesTypes) {
                var incidencesType = MongoF.satIncidencesTypes[i];
                if (complexMap.special.perceptions.indexOf(incidencesType._id) !== -1) {
                    // esta en el mapa de claves del sat que necesitan incidencias complejas 
                    // (cada úna debe debe tener su directiva declarada en el dom)
                    complexIncidencesTypes.special.perceptions.push(incidencesType._id);
                } else if (complexMap.special.deductions.indexOf(incidencesType._id) !== -1) {
                    complexIncidencesTypes.special.deductions.push(incidencesType._id);
                } else if (complexMap.simple.perceptions.indexOf(incidencesType._id) !== -1) {
                    // valores simples o resultado de un porcentaje, 
                    // tomadas de incidencias por request o de constantes automáticos 
                    // (es declarada en el dom dinamicamente)
                    complexIncidencesTypes.simple.perceptions.push(incidencesType._id);
                } else if (complexMap.simple.deductions.indexOf(incidencesType._id) !== -1) {
                    complexIncidencesTypes.simple.deductions.push(incidencesType._id);
                }

            }
            // se ponen las incidencias del sistema y default
            complexIncidencesTypes.default = complexMap.default;
            complexIncidencesTypes.system = complexMap.system;
            return complexIncidencesTypes;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('getComplementData', getComplementData)

    function getComplementData(MongoF, AppF, getSomethingOfArrayMFilter, getSomethingOfArrayFBFilter) {

        return getComplementDataFn;

        function getComplementDataFn(idComplement, field, defaultValue) {
            var dato = getSomethingOfArrayMFilter(idComplement, MongoF.complementIncidencesTypes, field, false, "_id");
            if (dato === false) {
                dato = getSomethingOfArrayFBFilter(idComplement, AppF.incidencesTypes, field, defaultValue);
            }
            return dato;
        }
    }

}());
/**
 * @description Consulta un dato en cualquier documento de FB 
 * @param {string} route Recibe la ruta completa donde se va hacer la consulta ejemplo 'catalogs/rps/collection/'${key}'/active'
 * @return {promise} Regresa una promesa tipo Boolean
 */
(function () {
    'use strict';
    angular
        .module('app.clients')
        .filter('getCOnceptsByKeyAndField', getCOnceptsByKeyAndField);

    function getCOnceptsByKeyAndField($log, loopEachFilter) {

        return getCOnceptsByKeyAndFieldFn;

        function getCOnceptsByKeyAndFieldFn(concepts) {
            var thisConcepts = [];
            var thisConceptObj = {};
            if (angular.isArray(concepts)) {
                for (var c = 0; c < concepts.length; c++) {
                    var thisConcept = concepts[c];
                    if (angular.isUndefined(thisConceptObj[thisConcept.key])) {
                        thisConceptObj[thisConcept.key] = { nature: thisConcept.nature, type: thisConcept.type, id: thisConcept.$id, key: thisConcept.key, 'id_human': thisConcept['id_human'], name: thisConcept.name, fields: {} };
                    }
                    var otherFields = [];
                    var outputType = thisConcept.outputType ? thisConcept.outputType : 'currency';
                    switch (thisConcept.type) {
                        case 'incidenceType':
                            // if (thisConcept.allowManual) {
                            //     otherFields.push(
                            //         { 'id': 'availableFast', 'name': 'INCIDENCIAS RÁPIDAS DISPONIBLES', 'outputType': outputType },
                            //         { 'id': 'fastIncidences', 'name': 'INCIDENCIAS RÁPIDAS', 'outputType': outputType }
                            //     );
                            // }
                            otherFields.push(
                                // { 'id': 'valueNormal', 'name': 'TOTAL NORMALES', 'outputType': outputType },
                                // { 'id': 'normalIncidences', 'name': 'INCIDENCIAS NORMALES', 'outputType': outputType },
                                // { 'id': 'totalIncidences', 'name': 'TOTAL DE INCIDENCIAS', 'outputType': outputType },
                                { 'id': 'fiscalCalc', 'name': 'CALCULO FISCAL', 'outputType': 'currency' },
                                { 'id': 'fiscalValue', 'name': 'TOTAL FISCAL', 'outputType': 'currency' },
                                { 'id': 'socialPrevisionCalc', 'name': 'CALCULO PREVISION', 'outputType': 'currency' },
                                { 'id': 'socialPrevisionValue', 'name': 'TOTAL COMPLEMENTO', 'outputType': 'currency' }
                            );
                            // if (thisConcept.nature === 'deduction') {
                            //     otherFields.push(
                            //         { 'id': 'rejectedIncidences', 'name': 'INCIDENCIAS RECHAZADAS', 'outputType': outputType },
                            //         { 'id': 'valueNoRejected', 'name': 'TOTAL DEL PERIODO', 'outputType': 'currency' },
                            //         { 'id': 'fiscalValueNoRejected', 'name': 'TOTAL FISCAL NORMAL', 'outputType': 'currency' },
                            //         { 'id': 'fiscalValueRejected', 'name': 'TOTAL FISCAL DE RECHAZADA', 'outputType': 'currency' }
                            //     );
                            // }
                            if (thisConcept.nature === 'perception') {
                                otherFields.push(
                                    { 'id': 'exempt', 'name': 'PARTE EXENTA', 'outputType': 'currency' },
                                    { 'id': 'gravable', 'name': 'PARTE GRAVADA', 'outputType': 'currency' }
                                );
                            }
                            break;
                        case 'accumulator':
                            // if (thisConcept.nature === 'deduction') {
                            //     otherFields.push(
                            //         { 'id': 'rejectedIncidences', 'name': 'INCIDENCIAS RECHAZADAS', 'outputType': outputType },
                            //         { 'id': 'valueNoRejected', 'name': 'TOTAL DEL PERIODO', 'outputType': 'currency' }
                            //     );
                            // }
                            otherFields.push(
                                { 'id': 'value', 'name': 'TOTAL', 'outputType': outputType }
                            );
                            break;
                        default:
                        // otherFields.push({ id: 'rejectedIncidences', name: 'INCIDENCIAS RECHAZADAS', outputType: outputType });
                    }
                    if (thisConcept.key === 'fiscalDeductions') {
                        $log.log(thisConcept.type, thisConcept, otherFields);
                    }
                    // otherFields.push({ id: 'rejectedIncidences', name: 'INCIDENCIAS RECHAZADAS', outputType: outputType });
                    if (!angular.isArray(thisConcept.calculations)) {
                        thisConcept.calculations = [{ fields: otherFields }]
                    }
                    for (var a = 0; a < thisConcept.calculations.length; a++) {
                        if (!angular.isArray(thisConcept.calculations[a].fields)) {
                            thisConcept.calculations[a].fields = [];
                        }
                        thisConcept.calculations[a].fields = thisConcept.calculations[a].fields.concat(otherFields);
                        for (var f = 0; f < thisConcept.calculations[a].fields.length; f++) {
                            var thisField = thisConcept.calculations[a].fields[f];
                            if (angular.isUndefined(thisConceptObj[thisConcept.key].fields[thisField.id])) {
                                thisConceptObj[thisConcept.key].fields[thisField.id] = { name: thisField.name, outputType: thisField.outputType };
                            }
                        }
                    }
                }
            }
            loopEachFilter(thisConceptObj, function (dataP, conceptKey) {
                var data = angular.fromJson(angular.toJson(dataP));
                var fields = [];
                loopEachFilter(data.fields, function (fieldData, fieldId) {
                    fieldData.id = fieldId;
                    fields.push(fieldData);
                });
                data.fields = fields;
                thisConceptObj[conceptKey].fields = fields;
                data.key = conceptKey;
                thisConcepts.push(data);
            });
            return { obj: thisConceptObj, arr: thisConcepts };
        }
    }
}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('getBalanceIncidencesMapOfEmployee', getBalanceIncidencesMapOfEmployee)

    function getBalanceIncidencesMapOfEmployee(orderByFilter, getTotalOfArrayFieldFilter, setInObjectPathFilter) {

        return getBalanceIncidencesMapOfEmployeeFn;
        //AppF.balancedIncidences, AppF.priorityMap, AppF.balanceIncidenceMap, AppF.tempBalancedIncidences

        function getBalanceIncidencesMapOfEmployeeFn(map, balancedIncidences, process, employee, priorityMap) {
            //console.log(JSON.stringify(priorityMap));
            var path = process + "." + employee;
            setInObjectPathFilter(path, map, {}, false, true);
            var count = getTotalOfArrayFieldFilter(priorityMap, "priority");
            var incidenceToBalance = [];
            if (typeof(balancedIncidences[process]) !== "undefined") {
                for (var incidence in balancedIncidences[process][employee]) {
                    var obj = {
                        "incidence": incidence
                    }
                    if (typeof(priorityMap[incidence]) !== "undefined") {
                        obj.value = priorityMap[incidence].priority;
                    } else {
                        if (typeof(priorityMap[incidence]) == "undefined") priorityMap[incidence] = {};
                        priorityMap[incidence].priority = count;
                        obj.value = count;
                        count++;
                    }
                    incidenceToBalance.push(obj);
                }
            }
            //Se ordenan las incidencias por orden de balance los primeros en balancearse son los ultimos registros
            incidenceToBalance = orderByFilter(incidenceToBalance, "value");
            //console.log(incidenceToBalance)
            //Para saber si las incidencias anteriores estan balanceadas se establece la flag
            var beforeBalanced = false;
            //console.log(incidenceToBalance)
            for (var i = 0; i < incidenceToBalance.length; i++) {
                var thisIncidence = incidenceToBalance[i].incidence;
                map[process][employee][thisIncidence] = {
                    partBalanced: balancedIncidences[process][employee][thisIncidence].partBalanced, //Se establece si esta incidencia esta balanceada
                    totallyBalanced: balancedIncidences[process][employee][thisIncidence].totallyBalanced,
                    beforeBalanced: beforeBalanced //Se establace si la incidencia anterior esta balanceada
                };
                //Para el siguiente ciclo se establece que esta incidencia que es anterior a la siguiente esta o no balanceada
                //console.log(balancedIncidences[process][employee][thisIncidence]);
                beforeBalanced = balancedIncidences[process][employee][thisIncidence].partBalanced;
            }
            //Se ordenan las incidencias por orden de balance los primeros en balancearse son los primeros registros
            incidenceToBalance = orderByFilter(incidenceToBalance, "-value");
            //console.log(incidenceToBalance)
            //Se establece si la incidecia con mayor prioridad en el balanceo esta balanceada
            var afterBalanced = true;
            for (var a = 0; a < incidenceToBalance.length; a++) {
                var thisIncidence = incidenceToBalance[a].incidence;
                //se establece si la incidencia siguiente esta balanceada
                map[process][employee][thisIncidence].afterBalanced = afterBalanced;
                //Si existe alguna incidencia que previa a esta incidencia que no este balanceada aun se considera que aun estan por balancearse todas
                if (!balancedIncidences[process][employee][thisIncidence].totallyBalanced) {
                    afterBalanced = false;
                }
            }
            return;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('getBalanceIncidencesMap', getBalanceIncidencesMap)

    function getBalanceIncidencesMap(getBalanceIncidencesMapOfEmployeeFilter,$log) {

        return getBalanceIncidencesMapFn;
        //AppF.balancedIncidences, AppF.priorityMap, AppF.balanceIncidenceMap, AppF.tempBalancedIncidences

        function getBalanceIncidencesMapFn(balancedIncidences, priorityMap, oldBalanceMap, oldBalanceIncidences) {
            try {
                //console.log("into function")
                var t1 = JSON.stringify(balancedIncidences);
                var t2 = JSON.stringify(oldBalanceIncidences);
                if ((t1 != t2 || typeof(oldBalanceMap) == "undefined") && typeof(balancedIncidences) == "object") {
                    //console.log("calculating function")
                    var map = {};
                    for (var process in balancedIncidences) {
                        //console.log(process);
                        if (typeof(map[process]) == "undefined") map[process] = {};
                        for (var employee in balancedIncidences[process]) {
                            getBalanceIncidencesMapOfEmployeeFilter(map, balancedIncidences, process, employee, priorityMap);
                        }
                        // for (var employee in balancedIncidences[process]) {
                        //     //console.log(employee);
                        //     if (typeof(map[process][employee]) == "undefined") map[process][employee] = {};
                        //     var incidenceToBalance = [];
                        //     for (var incidence in balancedIncidences[process][employee]) {
                        //         //console.log(incidence);
                        //         if (typeof(priorityMap[process]) !== "undefined" && typeof(priorityMap[process][incidence]) !== "undefined") {
                        //             var obj = {
                        //                 "incidence": incidence,
                        //                 "value": priorityMap[process][incidence]
                        //             }
                        //             incidenceToBalance.push(obj);
                        //         }
                        //     }
                        //     //Se ordenan las incidencias por orden de balance los primeros en balancearse son los ultimos registros
                        //     incidenceToBalance = orderByFilter(incidenceToBalance, "value");
                        //     //console.log(incidenceToBalance)
                        //     //Para saber si las incidencias anteriores estan balanceadas se establece la flag
                        //     var beforeBalanced = false;
                        //     //console.log(incidenceToBalance)
                        //     for (var i = 0; i < incidenceToBalance.length; i++) {
                        //         var thisIncidence = incidenceToBalance[i].incidence;
                        //         map[process][employee][thisIncidence] = {
                        //             partBalanced: balancedIncidences[process][employee][thisIncidence].partBalanced, //Se establece si esta incidencia esta balanceada
                        //             totallyBalanced: balancedIncidences[process][employee][thisIncidence].totallyBalanced,
                        //             beforeBalanced: beforeBalanced //Se establace si la incidencia anterior esta balanceada
                        //         };
                        //         //Para el siguiente ciclo se establece que esta incidencia que es anterior a la siguiente esta o no balanceada
                        //         //console.log(balancedIncidences[process][employee][thisIncidence]);
                        //         beforeBalanced = balancedIncidences[process][employee][thisIncidence].partBalanced;
                        //     }
                        //     //Se ordenan las incidencias por orden de balance los primeros en balancearse son los primeros registros
                        //     incidenceToBalance = orderByFilter(incidenceToBalance, "-value");
                        //     //console.log(incidenceToBalance)
                        //     //Se establece si la incidecia con mayor prioridad en el balanceo esta balanceada
                        //     var afterBalanced = true;
                        //     for (var a = 0; a < incidenceToBalance.length; a++) {
                        //         var thisIncidence = incidenceToBalance[a].incidence;
                        //         //se establece si la incidencia siguiente esta balanceada
                        //         map[process][employee][thisIncidence].afterBalanced = afterBalanced;
                        //         //Si existe alguna incidencia que previa a esta incidencia que no este balanceada aun se considera que aun estan por balancearse todas
                        //         if (!balancedIncidences[process][employee][thisIncidence].totallyBalanced) {
                        //             afterBalanced = false;
                        //         }
                        //     }
                        // }
                    }
                    //console.log("returnin map");
                    return map;
                } else {
                    //console.log("returning oldBalanceMap")
                    return oldBalanceMap;
                }
            } catch (error) {
                $log.error(error);
                //console.log("reutrnun error", oldBalanceMap)
                return oldBalanceMap;
            }


        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('getAppliedIncidences', getAppliedIncidences)

    function getAppliedIncidences() {

        return getAppliedIncidencesFn;

        function getAppliedIncidencesFn(allIncidences) {
            var incidences = [];
            angular.forEach(allIncidences, function(incidence) {
                if (incidence.status >= 3) {
                    incidences.push(incidence);
                }
            });
            return incidences;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('getAllIndencesOfDaysByDate', getAllIndencesOfDaysByDate)

    function getAllIndencesOfDaysByDate(getSomethingOfArrayFBFilter) {

        return getAllIndencesOfDaysByDateFn;

        function getAllIndencesOfDaysByDateFn(allIncidences, incidencesTypes) {
            var incidencesByDate = {};
            for (var a in allIncidences) {
                var incidence = allIncidences[a];
                if (getSomethingOfArrayFBFilter(incidence.incidenceType, incidencesTypes, 'affect') == "days") {
                    var incidenceDate = moment(incidence.date);
                    if (incidencesByDate[incidenceDate.format("DD-MM-YYYY")] == undefined) {
                        incidencesByDate[incidenceDate.format("DD-MM-YYYY")] = {};
                    }
                    incidencesByDate[incidenceDate.format("DD-MM-YYYY")][incidence.$id] = incidence;
                }
            }
            return incidencesByDate;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('getAffectDaysIncidences', getAffectDaysIncidences)

    function getAffectDaysIncidences(
        incidenceAffectFilter
    ) {

        return getAffectDaysIncidencesFn;

        function getAffectDaysIncidencesFn(deductions) {
            var onlyAffectDays = [];
            for (var d in deductions) {
                // si afecta dias sumar el dia 
                var deduction = deductions[d];
                var affectDays = incidenceAffectFilter(deduction.incidenceType, 'days');
                if (affectDays) {
                    onlyAffectDays.push(deduction)
                }
            }
            return onlyAffectDays;
        }

    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('getActiveDay', getActiveDay)

    function getActiveDay() {

        return getActiveDayFn;

        function getActiveDayFn(day, activeDays) {
            var match = [];
            for (var a in activeDays) {
                var activeDay = activeDays[a];
                if (day >= activeDay.start && day <= activeDay.end) {
                    match.push(activeDay);
                }
            }
            return match;
        }
    }

}());
(function(){
    'use strict';

    angular
        .module('app.clients')
        .filter('getAbsencesIncidences', getAbsencesIncidences)

    function getAbsencesIncidences(
        incidenceAffectFilter
    ){

        return getAbsencesIncidencesFn;

        function getAbsencesIncidencesFn(deductions){
            var absences= [];
            for(var d in deductions){
                // si afecta dias sumar el dia 
                var deduction = deductions[d];
                var affectDays = incidenceAffectFilter(deduction.incidenceType, 'days');
                if(affectDays){
                   absences.push(deduction);
                } 
            }
            return absences;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('getAbsences', getAbsences)

    function getAbsences(
        incidenceAffectFilter
    ) {

        return getAbsencesFn;

        function getAbsencesFn(deductions) {
            var total = 0;
            var fast = 0;
            var normal = 0;
            for (var d in deductions) {
                // si afecta dias sumar el dia 
                var deduction = deductions[d];
                var affectDays = incidenceAffectFilter(deduction.incidenceType, 'days');
                if (affectDays) {
                    if (deduction.type === 'fast') {
                        fast += parseInt(deduction.value);
                    } else {
                        normal += parseInt(deduction.value);
                    }
                    total += parseInt(deduction.value);
                }
            }
            return {
                fast: fast,
                total: total,
                normal: normal
            };
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('generateIncidencesToImportV2', generateIncidencesToImportV2)

    function generateIncidencesToImportV2(orderByFilter, getFromObjectFilter, errAlertS, AppF) {

        return generateIncidencesToImportV2Fn;

        function generateIncidencesToImportV2Fn(operationEmployees, allEmployees, payroll, period, calendar, conceptById) {
            var newIncidences = [];
            var error = [];
            angular.forEach(operationEmployees, function (employee) {
                var value = allEmployees[employee.$id];
                if (angular.isDefined(value.incidences) && angular.isArray(value.incidences)) {
                    var thisIncidences = value.incidences;
                    angular.forEach(thisIncidences, function (incidence) {
                        var concepts = conceptById[incidence.incidenceType];
                        var code = concepts.key;
                        if (typeof (code) == "string") {
                            code = code.substring(0, 1);
                        }
                        if (code !== "V" && concepts.key && ['manual', 'request', 'fast'].indexOf(incidence.type) !== -1) {
                            var date = undefined;
                            if (typeof (incidence.date) !== "undefined") {
                                date = moment(incidence.date);
                            }
                            if (!concepts.validateDays) {
                                date = moment(period.start);
                            }
                            var data = {
                                "Grupo empresarial": AppF.center.toUpperCase(),
                                "Nomina": payroll.data.class,
                                "Proceso": "GENERAL",
                                "Empleado": getFromObjectFilter(value, "data.employeeNumber", "N/A"),
                                "Anio": calendar,
                                "Periodo": period.period,
                                "Incidencia": (concepts.id_human) ? concepts.id_human : 'N/A',
                                "Fecha": date ? date.format("DD/MM/YYYY") : "N/A",
                                "Monto": incidence.value
                            }
                            newIncidences.push(data);
                            if (angular.isUndefined(concepts.id_human)) {
                                var exists = error.filter(function (value) {
                                    return value.key === concepts.key;
                                });
                                if (exists.length === 0) {
                                    error.push({
                                        key: concepts.key,
                                        name: concepts.name,
                                    });
                                }
                            }
                        }
                    });
                }
                if (angular.isUndefined(value.data.employeeNumber) && angular.isDefined(value.incidences)) {
                    errAlertS("El empleado " + value.data.name + " no tiene número de empleado");
                }
            })
            for (var e = 0; e < error.length; e++) {
                errAlertS("El concepto " + error[e].name + " le hace falta el Código");
            }
            newIncidences = orderByFilter(newIncidences, "empleado");
            return newIncidences;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('generateIncidencesToImport', generateIncidencesToImport)

    function generateIncidencesToImport(orderByFilter, getSomethingOfArrayFBFilter, pathInObjFilter, errAlertS, AppF) {

        return generateIncidencesToImportFn;

        function getEmployee(item) {
            return item.$id == this;
        }

        function generateIncidencesToImportFn(allIncidences, payroll, period, employees, calendar) {
            var newIncidences = [];
            // var employeeDaysUsed = {};
            var datesObjets = {
                datesUsedP: {},
                lastDateUsedP: {},
                datesUsedD: {},
                lastDateUsedD: {}
            }
            var thisIncidences = [].concat(allIncidences);
            thisIncidences = orderByFilter(thisIncidences, ["employee", "date"]);
            angular.forEach(allIncidences, function (incidence) {
                var code = incidence.internalCode;
                if (typeof (code) == "string") {
                    code = code.substring(0, 1);
                }
                if (code !== "V" && incidence.internalCode && ['manual', 'request', 'fast'].indexOf(incidence.type) !== -1) {
                    var date = undefined;
                    if (typeof (incidence.date) !== "undefined") {
                        date = moment(incidence.date);
                    } else if (incidence.affect !== "days") {
                        date = moment(period.start);
                    } else {
                        var employeesFounded = employees.filter(getEmployee, incidence.employee);
                        if (employeesFounded.length > 0) {
                            var employee = employeesFounded[0];
                            var activeDays = pathInObjFilter(employee, "calculations.REAL.workedDays.data.activeDays");
                            var dateAvailable = undefined;
                            if (typeof (activeDays) == "object") {
                                var datesUsed = "";
                                var lastDateUsed = "";
                                if (incidence.nature == "perception") {
                                    datesUsed = "datesUsedP";
                                    lastDateUsed = "lastDateUsedP";
                                    // idFounded = datesPerceptionsUsed[incidence.employee].indexOf(lastDatesUsed[incidence.employee].format("DD/MM/YYYY"));
                                } else {
                                    datesUsed = "datesUsedD";
                                    lastDateUsed = "lastDateUsedD";
                                    // idFounded = dateDeductionsUsed[incidence.employee].indexOf(lastDatesUsed[incidence.employee].format("DD/MM/YYYY"));
                                }
                                if (typeof (datesObjets[datesUsed][incidence.employee]) == "undefined") {
                                    datesObjets[datesUsed][incidence.employee] = [];
                                }
                                for (var i = 0; i < activeDays.length && typeof (dateAvailable) == "undefined"; i++) {
                                    var thisActiveDay = activeDays[i];
                                    while (typeof (dateAvailable) == "undefined" && (typeof (datesObjets[lastDateUsed][incidence.employee]) == "undefined" || thisActiveDay.end > datesObjets[lastDateUsed][incidence.employee].valueOf())) {
                                        console.log(employee.data.name, typeof (datesObjets[lastDateUsed][incidence.employee]) == "undefined", datesObjets[lastDateUsed][incidence.employee], thisActiveDay.start)

                                        if (typeof (datesObjets[lastDateUsed][incidence.employee]) == "undefined" || datesObjets[lastDateUsed][incidence.employee].valueOf() < thisActiveDay.start) {
                                            console.log(employee.data.name, "Setted beacusae no setted before or setted")
                                            datesObjets[lastDateUsed][incidence.employee] = moment(thisActiveDay.start);
                                        }
                                        var idFounded = datesObjets[datesUsed][incidence.employee].indexOf(datesObjets[lastDateUsed][incidence.employee].format("DD/MM/YYYY"));
                                        console.log(datesObjets[lastDateUsed][incidence.employee].format("DD/MM/YYYY"), idFounded);
                                        if (idFounded == -1) {
                                            dateAvailable = moment(datesObjets[lastDateUsed][incidence.employee].valueOf());
                                        }
                                        datesObjets[lastDateUsed][incidence.employee].add(1, "days");
                                    }
                                }
                                console.log("dateAvailable", dateAvailable)
                                if (typeof (dateAvailable) == "undefined") {
                                    console.log(employee.data.name, activeDays)
                                    errAlertS("No se encontro fecha disponible para la incidencia del empleado " + employee.data.name)
                                } else {
                                    date = dateAvailable;
                                }
                            } else {
                                errAlertS("No se encuentras los dias activos del empleado " + employee.data.name)
                            }
                        } else {
                            errAlertS("No se encuentra el empleado con el id " + incidence.employee)
                        }

                        // if (typeof (employeeDaysUsed[incidence.employee]) == "undefined") {
                        //     employeeDaysUsed[incidence.employee] = 0;
                        // } else {
                        //     employeeDaysUsed[incidence.employee] = employeeDaysUsed[incidence.employee] + 1;
                        // }
                        // console.log(employeeDaysUsed[incidence.employee]);
                        // date = moment(period.start).add(employeeDaysUsed[incidence.employee], "days");
                    }

                    if (incidence.affect == "days" && typeof (date) !== "undefined") {
                        if (incidence.nature == "perception") {
                            if (typeof (datesObjets.datesUsedP[incidence.employee]) == "undefined") {
                                datesObjets.datesUsedP[incidence.employee] = [];
                            }
                            datesObjets.datesUsedP[incidence.employee].push(date.format("DD/MM/YYYY"))
                        } else {
                            if (typeof (datesObjets.datesUsedD[incidence.employee]) == "undefined") {
                                datesObjets.datesUsedD[incidence.employee] = [];
                            }
                            datesObjets.datesUsedD[incidence.employee].push(date.format("DD/MM/YYYY"))
                        }
                    }
                    var data = {
                        "Grupo empresarial": AppF.center.toUpperCase(),
                        Nomina: payroll.data.class,
                        "Proceso": "GENERAL",
                        Empleado: getSomethingOfArrayFBFilter(incidence.employee, employees, "data.employeeNumber", "N/A"),
                        Anio: calendar,
                        Periodo: period.period,
                        Incidencia: incidence.internalCode,
                        Fecha: date ? date.format("DD/MM/YYYY") : "N/A",
                        Monto: incidence.value
                    }
                    newIncidences.push(data);
                }
            })
            newIncidences = orderByFilter(newIncidences, "empleado");
            console.log(datesObjets)
            return newIncidences;
        }
    }

}());
(function () {
    'use strict';
    angular
        .module('app.clients')
        .filter('formatCalculationsToImportV2', formatCalculationsToImportV2);

    function formatCalculationsToImportV2(loopEachFilter, $log, getFromObjectFilter) {
        function set(row, config, headers) {
            if (angular.isArray(headers)) {
                var items = Object.keys(row).filter(function (item) {
                    return item.indexOf(config.extra) > -1;
                });
                for (var i = 0; i < items.length; i++) {
                    var thisItem = items[i];
                    var key = thisItem.replace(config.extra, '');
                    var thisConfig = {
                        name: thisItem,
                        fieldToSave: [key + config.fieldToSave],
                        order: config.order,
                        checkConcept: config.checkConcept ? true : false
                    };
                    headers.push(thisConfig);
                }
            }
        }
        function sum(row, config, headers) {
            var total = 0;
            if (angular.isArray(config.extra)) {
                for (var e = 0; e < config.extra.length; e++) {
                    total += parseFloat(getFromObjectFilter(row, config.extra[e], 0));
                }
            }
            row[config.name] = Math.round(total * 100) / 100;
            if (angular.isArray(headers)) {
                var thisConfig = {
                    name: config.name,
                    fieldToSave: config.fieldToSave,
                    order: config.order,
                    checkConcept: config.checkConcept ? true : false
                };
                headers.push(thisConfig);
            }
        }
        function rest(row, config, headers) {
            var total;
            if (angular.isArray(config.extra)) {
                for (var e = 0; e < config.extra.length; e++) {
                    var thisTotal = parseFloat(getFromObjectFilter(row, config.extra[e], 0));
                    if (angular.isUndefined(total)) {
                        total = thisTotal;
                    } else {
                        total -= thisTotal;
                    }
                }
            }
            row[config.name] = Math.round(total * 100) / 100;
            if (angular.isArray(headers)) {
                var thisConfig = {
                    name: config.name,
                    fieldToSave: config.fieldToSave,
                    order: config.order,
                    checkConcept: config.checkConcept ? true : false
                };
                headers.push(thisConfig);
            }
        }
        function getTotal(row, config, headers) {
            var concepts = Object.keys(row).filter(function (item) {
                return item.indexOf('/Gravado') > -1 || item.indexOf('/Exento') > -1;
            }).map(function (item) {
                return item.replace('/Gravado', '').replace('/Exento', '');
            }).filter(function (item, index, thisArray) {
                return thisArray.indexOf(item) === index;
            });
            for (var c = 0; c < concepts.length; c++) {
                var thisName = concepts[c] + config.name;
                sum(row, { name: thisName, order: config.order, extra: [concepts[c] + '/Gravado', concepts[c] + '/Exento'] });
                var thisFieldToSave = [];
                for (var f = 0; f < config.fieldToSave.length; f++) {
                    thisFieldToSave.push(concepts[c] + config.fieldToSave[f]);
                }
                if (angular.isArray(headers)) {
                    var thisConfig = {
                        name: thisName,
                        fieldToSave: thisFieldToSave,
                        order: config.order,
                        checkConcept: config.checkConcept ? true : false
                    };
                    headers.push(thisConfig);
                }
            }
        }
        function sumAll(row, config, headers) {
            var items = Object.keys(row).filter(function (item) {
                var flag = false;
                if (angular.isArray(config.extra)) {
                    var count = 0;
                    while (count < config.extra.length && !flag) {
                        flag = item.indexOf(config.extra[count]) > -1;
                        if (flag && angular.isArray(config.extraAvoid)) {
                            var thisIndex = config.extraAvoid.findIndex(function (thisItem) {
                                return item.indexOf(thisItem) > -1;
                            });
                            $log.log(item, config.extraAvoid, thisIndex);
                            flag = thisIndex === -1;
                        }
                        count++;
                    }
                }
                return flag;
            });
            var total = 0;
            for (var i = 0; i < items.length; i++) {
                var thisItem = items[i];
                total += parseFloat(getFromObjectFilter(row, thisItem, 0));
            }
            row[config.name] = Math.round(total * 100) / 100;
            if (angular.isArray(headers)) {
                var thisConfig = {
                    name: config.name,
                    fieldToSave: config.fieldToSave,
                    order: config.order,
                    checkConcept: config.checkConcept ? true : false
                };
                headers.push(thisConfig);
            }
        }
        var headersTemp = [
            { order: 1, name: 'Dias_trabajados', fieldToSave: ['fiscalWorkedDays.value', 'workedDays.availableDays', 'workedDays.value'] },
            { order: 2, name: 'Sueldo', fieldToSave: ['fiscalSalary.value'] },
            { order: 3, name: '/Gravado', checkConcept: true, fieldToSave: ['.gravable'], generateFrom: set, extra: '/Gravado' },
            { order: 3, name: '/Exento', checkConcept: true, fieldToSave: ['.exempt'], generateFrom: set, extra: '/Exento' },
            { order: 3, name: '/TotalP', checkConcept: true, fieldToSave: ['.fiscalValue'], generateFrom: getTotal },
            { order: 4, name: 'Subsidio_Entregado', fieldToSave: ['subsidy.value'] },
            { order: 4, name: 'Ajuste_ISR', fieldToSave: ['isrAdjustment.value'] },
            { order: 5, name: 'Subsidio_Reportado', fieldToSave: ['subsidy.subCausedToRep'] },
            { order: 6, name: 'Base_Gravable', fieldToSave: ['gravableBase.value'] },
            { order: 7, name: 'Percepciones', fieldToSave: ['fiscalPerceptions.value'], generateFrom: sumAll, extra: ['/TotalP', 'Subsidio_Entregado', 'Ajuste_ISR'] },
            { order: 8, name: 'Percepciones_con_salario', fieldToSave: ['fiscalPerceptions.wSalary'], generateFrom: sum, extra: ['Percepciones', 'Sueldo'] },
            { order: 9, name: '/TotalD', checkConcept: true, fieldToSave: ['.fiscalValue'], generateFrom: set, extra: '/TotalD' },
            { order: 10, name: 'ISR_PTU', fieldToSave: ['isrPTU.value', 'isrPTU.isrOfPeriodToRetain'] },
            { order: 10, name: 'ISR', fieldToSave: ['isr.value', 'isr.isrOfPeriodToRetain'] },
            { order: 11, name: 'CYV', fieldToSave: ['cyv.value', 'cyv.imssResult', 'CYV_REPORT.value', 'socialSecurity.cyv'] },
            { order: 12, name: 'IMSS_No_CYV', fieldToSave: ['IMSS_REPORT.value', 'socialSecurity.imssResult'] },
            { order: 13, name: 'Seguridad_Social', fieldToSave: ['socialSecurity.value'], generateFrom: sum, extra: ['CYV', 'IMSS_No_CYV'] },
            { order: 14, name: 'Deducciones', fieldToSave: ['fiscalDeductions.value'], generateFrom: sumAll, extra: ['/TotalD', 'Seguridad_Social', 'ISR'], extraAvoid: ['Ajuste_ISR'] },
            { order: 15, name: 'Sueldo_Neto', fieldToSave: ['fiscalTotal.value'], generateFrom: rest, extra: ['Percepciones_con_salario', 'Deducciones'] },
            { order: 16, name: 'Neto' }
        ];

        return formatCalculationsToImportV2;

        function formatCalculationsToImportV2(rows, concepts) {
            var data = [];
            var headers = [];
            var headersSet = false;
            if (angular.isArray(rows) && rows.length > 0) {
                var tempHeaders = Object.keys(rows[0]);
                for (var r = 0; r < rows.length; r++) {
                    var row = rows[r];
                    for (var t = 0; t < tempHeaders.length; t++) {
                        var thisValue = row[tempHeaders[t]];
                        if (tempHeaders[t] === 'Fecha') {
                            thisValue = moment(thisValue, ['DD-MM-YYYY', 'DD/MM/YYYY']);
                            thisValue = thisValue.isValid() ? thisValue : null;
                        } else {
                            thisValue = thisValue.replaceAll(',', '');
                            thisValue = thisValue.replaceAll('$', '');
                            thisValue = thisValue.replaceAll(' ', '');
                            thisValue = parseFloat(thisValue);
                            thisValue = isNaN(thisValue) ? 0 : thisValue;
                            thisValue = Math.round(thisValue * 100) / 100;
                        }
                        row[tempHeaders[t]] = thisValue;
                    }
                    for (var h = 0; h < headersTemp.length; h++) {
                        var thisHeader = headersTemp[h];
                        if (thisHeader.generateFrom) {
                            thisHeader.generateFrom(row, thisHeader, !headersSet ? headers : undefined);
                        } else if (!headersSet) {
                            headers.push(thisHeader);
                        }
                    }
                    row.recordNumber = r + 1;
                    data.push(row);
                    headersSet = true;
                }
            }
            for (var e = 0; e < headers.length; e++) {
                if (angular.isArray(headers[e].fieldToSave) && headers[e].checkConcept) {
                    var temp = [];
                    var errors = [];
                    for (var f = 0; f < headers[e].fieldToSave.length; f++) {
                        var thisField = headers[e].fieldToSave[f];
                        var thisFieldArray = thisField.split('.');
                        thisFieldArray[0] = thisFieldArray[0].trim();
                        var conceptFind = concepts.find(function (item) {
                            var arrayToCompare = [item['id_human'], item.key, item.$id, item.name];
                            return arrayToCompare.indexOf(thisFieldArray[0]) > -1;
                        });
                        if (angular.isUndefined(conceptFind)) {
                            conceptFind = concepts.find(function (item) {
                                thisFieldArray[0] = thisFieldArray[0].toUpperCase();
                                return item.name.indexOf(thisFieldArray[0]) > -1;
                            });
                        }
                        if (angular.isDefined(conceptFind)) {
                            thisFieldArray[0] = conceptFind.key;
                            temp.push(thisFieldArray.join('.'));
                        } else {
                            errors.push('El concepto ' + thisFieldArray[0] + ' no fue encontrado para esta nómina');
                        }
                    }
                    if (errors.length > 0) {
                        headers[e].error = errors.join(',');
                    }
                    if (temp.length > 0) {
                        headers[e].fieldToSave = temp;
                    }
                }
            }
            headers.push({ name: 'Empleado', order: 0, fieldToSave: ['employeeId'], from: function (row) { return row.employee.fid; } });
            headers.push({ name: 'Fecha', order: 0.5, fieldToSave: ['accuDate'], from: function (row) { return row.Fecha.valueOf(); } });
            headers.push({ name: 'Año', order: 0.5, fieldToSave: ['calendar'], from: function (row) { return row.calendar; } });
            headers.push({ name: 'Periodo', order: 0.5, fieldToSave: ['period'], from: function (row) { return row.Periodo; } });
            headers = headers.sort(function (a, b) {
                if (a.order === b.order) {
                    return (a.name).localeCompare(b.name);
                } else {
                    return a.order - b.order;
                }
            });
            $log.log(data, headers);
            return { data: data, headers: headers };
        }
    }
}());
(function () {
    'use strict';
    angular
        .module('app.clients')
        .filter('formatCalculationsToImport', formatCalculationsToImport);

    function formatCalculationsToImport(loopEachFilter) {

        return formatCalculationsToImportFn;

        function formatCalculationsToImportFn(fileData, concepts) {
            var data = [];
            var headers = [];
            var headersSet = false;
            if (angular.isArray(fileData)) {
                for (var f = 0; f < fileData.length; f++) {
                    var thisData = fileData[f];
                    if (!headersSet) {
                        headersSet = true;
                        loopEachFilter(thisData, function (data, key) {
                            var headersObj = {
                                rowName: key,
                                editable: false
                            };
                            if (['Empleado', 'Fecha', 'Nomina', 'Periodo'].indexOf(key) === -1) {
                                headersObj.editable = true;
                                var thisConcept;
                                var thisFieldArray = key.split('.');
                                var rowName = thisFieldArray[0];
                                if (concepts.obj.hasOwnProperty(rowName)) {
                                    thisConcept = concepts.obj[rowName];
                                }
                                if (angular.isUndefined(thisConcept)) {
                                    thisConcept = concepts.arr.find(function (item) {
                                        return item.id_human === rowName;
                                    });
                                }
                                var fieldToSave = undefined;
                                if (angular.isUndefined(thisConcept)) {
                                    rowName = rowName.toUpperCase();
                                    var keyWords = [
                                        { key: '_BG', field: 'gravable' },
                                        { key: 'BG', field: 'gravable' },
                                        { key: '_GRAVADO', field: 'gravable' },
                                        { key: 'GRAVADO', field: 'gravable' },
                                        { key: '_GRAVADA', field: 'gravable' },
                                        { key: 'GRAVADA', field: 'gravable' },
                                        { key: '_BE', field: 'exempt' },
                                        { key: 'BE', field: 'exempt' },
                                        { key: '_EXENTO', field: 'exempt' },
                                        { key: 'EXENTO', field: 'exempt' },
                                        { key: '_EXENTA', field: 'exempt' },
                                        { key: 'EXENTA', field: 'exempt' }
                                    ];
                                    for (var k = 0; k < keyWords.length && angular.isUndefined(fieldToSave); k++) {
                                        var thisKey = keyWords[k];
                                        if (rowName.indexOf(thisKey.key) > -1) {
                                            rowName = rowName.replace(thisKey.key, '');
                                            rowName = rowName.trim();
                                            fieldToSave = thisKey.field;
                                        }
                                    }
                                    thisConcept = concepts.arr.find(function (item) {
                                        return item.name === rowName;
                                    });
                                }
                                if (angular.isUndefined(thisConcept)) {
                                    var translateWords = [
                                        { key: 'IMSS', concept: 'SEGURIDAD SOCIAL' },
                                        { key: 'ISR', concept: 'ISR' },
                                        { key: 'INFONACOT', concept: 'FONACOT' }
                                    ];
                                    var keyFounded = undefined;
                                    for (var t = 0; t < translateWords.length && angular.isUndefined(keyFounded); t++) {
                                        var thisT = translateWords[t];
                                        if (rowName.indexOf(thisT.key) > -1) {
                                            keyFounded = true;
                                            thisConcept = concepts.arr.find(function (item) {
                                                return item.name.indexOf(thisT.concept) > -1;
                                            });
                                        }
                                    }
                                }
                                if (angular.isUndefined(thisConcept)) {
                                    thisConcept = concepts.arr.find(function (item) {
                                        return item.name.indexOf(rowName) > -1;
                                    });
                                }
                                if (angular.isDefined(thisConcept)) {
                                    headersObj.key = thisConcept.key;
                                    headersObj.name = thisConcept.name;
                                    headersObj.field = fieldToSave ? fieldToSave : 'fiscalValue';
                                    if (thisFieldArray.length > 1) {
                                        headersObj.field = thisFieldArray[1];
                                    }
                                }
                            }
                            headers.push(headersObj);
                        });
                    }
                    thisData.recordNumber = f + 1;
                    thisData.FechaM = moment(thisData.Fecha, ['DD-MM-YYYY', 'DD/MM/YYYY']);
                    thisData.Empleado = parseInt(thisData.Empleado);
                    data.push(thisData);
                }
            }
            return { data: data, headers: headers };
        }
    }
}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('fiscalIncidences', fiscalIncidences)

    function fiscalIncidences(
        MongoF,
        getSomethingOfArrayMFilter,
        AppF
    ) {

        return fiscalIncidencesFn;

        function fiscalIncidencesFn(incidences, employees) {
            var fiscal = {};
            // set first node level with incidenceTypesId
            // se agregan incidencias manuales y por request
            for (var i in incidences) {
                var incidence = incidences[i];
                // si no es default
                // @todo:mañana esta validacion debe ser dinamica del proceso getIncidenceProcess{}
                if (incidence.satIncidencesType) {
                    if (AppF.complexIncidencesMap.default.indexOf(incidence.satIncidencesType) == -1) {
                        var internalCode = incidence.satIncidencesType;
                        // se mete en el mapa de incidencias fiscales (normales)
                        if (!fiscal.hasOwnProperty(internalCode)) {
                            fiscal[internalCode] = {};
                        }
                        // set second node level with employeeId
                        for (var e in employees) {
                            var employee = employees[e];
                            if (incidence.employee == employee.$id) {
                                if (!fiscal[internalCode].hasOwnProperty(employee.$id)) {
                                    fiscal[internalCode][employee.$id] = [];
                                }
                                incidence.process = 'FISCAL';
                                fiscal[internalCode][employee.$id].push(incidence);
                            }
                        }

                    }
                }
            }

            return fiscal;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('filterIncidencesRejected', filterIncidencesRejected)

    function filterIncidencesRejected() {

        return filterIncidencesRejectedFn;

        function filterIncidencesRejectedFn(incidences) {
            var result = {
                rejected: [],
                notRejected: []
            }
            if (angular.isArray(incidences)) {
                for (var i = 0; i < incidences.length; i++) {
                    var thisIncidence = incidences[i];
                    if (thisIncidence.isRejected) {
                        result.rejected.push(thisIncidence);
                    } else {
                        result.notRejected.push(thisIncidence)
                    }
                }
            }
            return result;
        }
    }

}());
(function(){
    'use strict';

    angular
        .module('app.clients')
        .filter('fastIncidences', fastIncidences)

    function fastIncidences(){

        return fastIncidencesFn;

        function fastIncidencesFn(incidences){
            var fast = [];
            for(var i in incidences){
                var incidence = incidences[i];
                if(incidence.allowManual) fast.push(incidence);
            }
            return fast;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('directiveListeners', directiveListeners);

    function directiveListeners($q, $log, $filter, AppF, MongoF) {

        return directiveListenersFn;

        function directiveListenersFn(ngModel, directiveName, directiveScope, directiveProcces, directivePlace, objsToWatch, directiveFunctions, objsToWatchFilter) {
            //Se crea el id de la directiva
            //$log.debug("Creating", directiveName);
            var firstCalcDone = false;
            var dataUsedToCal = {};
            var directiveId = AppF.root.child('directives').push().key;
            var complementIncidenceType;
            var totalesFixed = {};
            var oldCalculationsResults = {};
            var loops = 0;
            //Se crea el array donde se almacenaran todas las funciones para realizar los calculos de cada directiva
            if (typeof (directiveFunctions.calculate) === 'undefined') directiveFunctions.calculate = {};
            //Se crea el array donde se alamacenaran la referencia para aquellas directivas que se crearon y deben ejecutar el primer calculo
            if (typeof (directiveFunctions.firstCalculation) === 'undefined') directiveFunctions.firstCalculation = {};
            //Se crea el array donde se alamcenaran las referencia de los datos que estaran en observacion
            if (typeof (directiveFunctions.directiveWatcher) === 'undefined') directiveFunctions.directiveWatcher = {};
            //se crea el arry donde se almacenaran las flags que indican que los calculos han terminado
            if (typeof (AppF.operationDataNeeded[directiveProcces][directiveScope.employeeId]) === 'undefined') {
                AppF.operationDataNeeded[directiveProcces][directiveScope.employeeId] = {};
            }
            if (typeof (AppF.operationDataNeeded[directiveProcces][directiveScope.employeeId][directivePlace]) === 'undefined') {
                AppF.operationDataNeeded[directiveProcces][directiveScope.employeeId][directivePlace] = {};
            }
            AppF.operationDataNeeded[directiveProcces][directiveScope.employeeId][directivePlace][directiveId] = false;
            //Se crea el array donde se almacenan los nombres de las directivas
            AppF.directiveIds[directiveId] = directiveName;
            //Funcion para verificar si los datos necesarios para calcular las directiva estan listos
            var getdataNeededLoaded = function () {
                //console.log(JSON.stringify(directiveScope.dataloaded), directiveName, directiveProcces)
                var loadedNeeded = $filter("verifyAllTrue")(directiveScope.dataloaded);
                if (loadedNeeded) {
                    //$log.debug('Data needed loaded for calculation of', directiveName, directiveProcces);
                }
                return loadedNeeded;
            };
            var fixTotal = function (calculation) {
                var response = true;
                try {
                    var value = calculation.value;
                    var total = value.total;
                    if (false && value.addToTotal && value.incidence && typeof (directiveScope.incidenceId) != "undefined" && total > 0) {
                        var nextComplement;
                        //@todo validar correctaente el siguiente complemento
                        for (var i = 0; i < AppF.paymentSchema.data.processes.complements.length; i++) {
                            if (AppF.paymentSchema.data.processes.complements[i].active && AppF.paymentSchema.data.processes.complements[i].name !== directiveProcces) {
                                nextComplement = AppF.paymentSchema.data.processes.complements[i];
                                i = AppF.paymentSchema.data.processes.complements.length;
                            }
                        }
                        var tempTotalesFixed = {};
                        var pathsToSet = {};
                        var path;
                        if (directiveProcces == "REAL") {
                            var thisIncidenceTypeData = AppF.incidenceTypeData[directiveScope.incidenceId];
                            if (typeof (nextComplement) != "undefined") {
                                complementIncidenceType = thisIncidenceTypeData[nextComplement.type];
                            }
                            var totalHandled = false;
                            var incidenceTotal = {
                                value: Math.round(total * 100) / 100,
                                from: directiveProcces
                            };
                            if (typeof (calculation.value.value) !== "undefined") {
                                incidenceTotal.realValue = calculation.value.value;
                            }
                            if (AppF.fiscalIncidences.indexOf(directiveScope.incidenceId) > -1 && typeof (AppF.allProcesses.fiscal) != "undefined" && typeof (AppF.fiscalEmployeesIds[directiveScope.employeeId]) != "undefined") {
                                path = "fiscal." + directiveScope.incidenceId + "." + directiveScope.employeeId + "." + directiveScope.incidenceId;
                                // $filter("setInObjectPath")(path, AppF.fixIncidences, incidenceTotal, true, true);
                                // tempTotalesFixed[path] = true;
                                pathsToSet[path] = incidenceTotal;
                                totalHandled = true;
                            } else if (typeof (complementIncidenceType) != "undefined" && !totalHandled) {
                                path = nextComplement.type + "." + complementIncidenceType + "." + directiveScope.employeeId + "." + directiveScope.incidenceId;
                                // $filter("setInObjectPath")(path, AppF.fixIncidences, incidenceTotal, true, true);
                                // tempTotalesFixed[path] = true;
                                pathsToSet[path] = incidenceTotal;
                                totalHandled = true;
                            }
                            if (!totalHandled) {
                                if (typeof (thisIncidenceTypeData.satIncidencesType) !== "undefined" && typeof (AppF.allProcesses.fiscal) != "undefined" && typeof (AppF.fiscalEmployeesIds[directiveScope.employeeId]) != "undefined") {
                                    path = "fiscal." + directiveScope.incidenceId + "." + directiveScope.employeeId + "." + directiveScope.incidenceId;
                                    // $filter("setInObjectPath")(path, AppF.fixIncidences, incidenceTotal, true, true);
                                    // tempTotalesFixed[path] = true;
                                    pathsToSet[path] = incidenceTotal;
                                    totalHandled = true;
                                } else {
                                    path = "rejectedIncidences." + directiveScope.employeeId + "." + directiveScope.incidenceId;
                                    // $filter("setInObjectPath")(path, AppF.fixIncidences, incidenceTotal, true, true);
                                    // tempTotalesFixed[path] = true;
                                    pathsToSet[path] = incidenceTotal;
                                    totalHandled = true;
                                }
                            }
                        } else {
                            if (calculation.value.nature == "deduction") {
                                if (typeof (objsToWatch) == "undefined") objsToWatch = [];
                                objsToWatch.push("needToBalance");
                            }
                            var nextProcess, incidenceTypeField, incidenceTypeFieldToValid;
                            if (directiveProcces == "FISCAL" && typeof (nextComplement) !== "undefined" && typeof (nextComplement.type) !== "undefined") {
                                nextProcess = nextComplement.type;
                                incidenceTypeField = nextComplement.type;
                                incidenceTypeFieldToValid = nextComplement.type;
                            } else if (typeof (AppF.fiscalEmployeesIds[directiveScope.employeeId]) !== "undefined") {
                                nextProcess = "fiscal";
                                incidenceTypeFieldToValid = "satIncidencesType"
                                incidenceTypeField = "$id";

                            }
                            var balanceObj = {
                                partBalanced: false,
                                totallyBalanced: false
                            }
                            if (typeof (directiveScope.incidenceId) != "undefined" && calculation.value.nature == "deduction") {
                                if (typeof (directiveScope.calculationsResults) !== "undefined") {
                                    for (var thisIncidenceId in directiveScope.calculationsResults) {
                                        var thisPath = directiveProcces + "." + directiveScope.employeeId + "." + thisIncidenceId;
                                        $filter("setInObjectPath")(thisPath, AppF.balancedIncidences, balanceObj, false, true);
                                        delete oldCalculationsResults[thisIncidenceId];
                                    }
                                }
                                for (var oldIncidenceId in oldCalculationsResults) {
                                    var oldPath = directiveProcces + "." + directiveScope.employeeId + "." + oldIncidenceId;
                                    if ($filter("pathInObj")(AppF.balancedIncidences, oldPath) !== false) {
                                        delete AppF.balancedIncidences[directiveProcces][directiveScope.employeeId][oldIncidenceId];
                                    }
                                }
                                oldCalculationsResults = typeof (directiveScope.calculationsResults) !== "undefined" ? JSON.parse(JSON.stringify(directiveScope.calculationsResults)) : {};
                            }
                            var needsToBalance = directiveScope.totalCalculations - calculation.value.total;
                            var possibleToBalance = 0;
                            var nextToBalance = false;
                            if (directiveScope.needToBalance && calculation.value.nature == "deduction" && directiveScope.exceeded < 0) {
                                var oldCalculationTotal = directiveScope.employeeCalculations[directiveScope.incidenceId] ? directiveScope.employeeCalculations[directiveScope.incidenceId].value.total : 0;
                                var totalNotThisTotal = directiveScope.exceeded + oldCalculationTotal
                                if (totalNotThisTotal > 0) {
                                    possibleToBalance = calculation.value.total - totalNotThisTotal;
                                } else {
                                    possibleToBalance = calculation.value.total;
                                }
                            }
                            var totalToBalance = needsToBalance + possibleToBalance;
                            var pendingToBalance = totalToBalance;
                            var pendingPossibleToBalance = possibleToBalance;
                            var pendingNeedsToBalance = needsToBalance;
                            var toOtherProccess = 0;
                            var rejected = 0;
                            var calculationsResults = typeof (directiveScope.calculationsResults) !== "undefined" ? $filter("objsToArray")(JSON.parse(JSON.stringify(directiveScope.calculationsResults))) : [];
                            var count = $filter("getTotalOfArrayField")(AppF.priorityMap, "priority");
                            for (var a = 0; a < calculationsResults.length; a++) {
                                if (typeof (AppF.priorityMap[calculationsResults[a].$id]) !== "undefined") {
                                    calculationsResults[a].priority = AppF.priorityMap[calculationsResults[a].$id].priority;
                                } else {
                                    if (typeof (AppF.priorityMap[calculationsResults[a].$id]) == "undefined") AppF.priorityMap[calculationsResults[a].$id] = {};
                                    AppF.priorityMap[calculationsResults[a].$id].priority = count;
                                    calculationsResults[a].priority = count;
                                    count++;
                                }
                            }
                            calculationsResults = $filter("orderBy")(calculationsResults, "-priority");
                            //console.log(calculationsResults, directiveProcces, directiveName, "this es calculation results");
                            for (var c = 0; c < calculationsResults.length; c++) {
                                nextToBalance = false;
                                var thisCalc = calculationsResults[c];
                                //console.log(JSON.parse(JSON.stringify(AppF.balancedIncidences)), directiveName)
                                if (calculation.value.nature == "deduction") {
                                    $filter("getBalanceIncidencesMapOfEmployee")(AppF.balanceIncidenceMap, AppF.balancedIncidences, directiveProcces, directiveScope.employeeId, AppF.priorityMap);
                                }
                                if (pendingPossibleToBalance > 0) {
                                    if (AppF.balanceIncidenceMap[directiveProcces][directiveScope.employeeId][thisCalc.$id].afterBalanced) {
                                        nextToBalance = true;
                                    }
                                }
                                var thisPossibleBalanced = 0;
                                var thisNeedBalanced = 0;
                                if (nextToBalance && pendingPossibleToBalance > 0) {
                                    if (pendingPossibleToBalance < thisCalc.value) {
                                        thisPossibleBalanced = pendingPossibleToBalance;
                                    } else {
                                        thisPossibleBalanced = thisCalc.value;
                                    }
                                }
                                pendingPossibleToBalance -= thisPossibleBalanced;
                                pendingToBalance -= thisPossibleBalanced;
                                var availableAmount = thisCalc.value - thisPossibleBalanced;
                                if (availableAmount > 0 && pendingNeedsToBalance > 0) {
                                    if (pendingNeedsToBalance < availableAmount) {
                                        thisNeedBalanced = pendingNeedsToBalance;
                                    } else {
                                        thisNeedBalanced = availableAmount;
                                    }
                                }
                                pendingNeedsToBalance -= thisNeedBalanced;
                                pendingToBalance -= thisNeedBalanced;
                                var valueToSend = thisPossibleBalanced + thisNeedBalanced;
                                if (valueToSend > 0) {
                                    var incidenceTotal = {
                                        value: Math.round(valueToSend * 100) / 100,
                                        from: directiveProcces
                                    };
                                    if (thisCalc.from !== "REAL" || typeof (nextProcess) == "undefined") {
                                        pathsToSet["rejectedIncidences." + directiveScope.employeeId + "." + thisCalc.$id] = incidenceTotal;
                                        rejected += valueToSend;
                                    } else if (typeof (AppF.incidenceTypeData[thisCalc.$id]) !== "undefined" && typeof (AppF.incidenceTypeData[thisCalc.$id][incidenceTypeFieldToValid]) !== "undefined") {
                                        var nextProcessIncidenceType = AppF.incidenceTypeData[thisCalc.$id][incidenceTypeField];
                                        pathsToSet[nextProcess + "." + nextProcessIncidenceType + "." + directiveScope.employeeId + "." + thisCalc.$id] = incidenceTotal;
                                        if (thisPossibleBalanced > 0) {
                                            toOtherProccess += thisPossibleBalanced;
                                        }
                                    } else if (thisCalc.isFiscal) {
                                        var founded = $filter("filter")(MongoF.complementIncidencesTypes, {
                                            process: nextProcess,
                                            default: true,
                                            nature: "deduction"
                                        });
                                        if (founded.length) {
                                            incidenceTotal.isFiscal = true;
                                            pathsToSet[nextProcess + "." + founded[0]._id + "." + directiveScope.employeeId + "." + thisCalc.$id] = incidenceTotal;
                                            if (thisPossibleBalanced > 0) {
                                                toOtherProccess += thisPossibleBalanced;
                                            }
                                        } else {
                                            pathsToSet["rejectedIncidences." + directiveScope.employeeId + "." + thisCalc.$id] = incidenceTotal;
                                            rejected += valueToSend;
                                        }
                                    } else {
                                        pathsToSet["rejectedIncidences." + directiveScope.employeeId + "." + thisCalc.$id] = incidenceTotal;
                                        rejected += valueToSend;
                                    }
                                }

                                if (calculation.value.nature == "deduction") {
                                    //console.log(thisPossibleBalanced);
                                    if (thisPossibleBalanced > 0) {
                                        //Se setean las flags en las incidencias balanceadas para establecer que una incidencia ha hecho una parte o todo su monto
                                        AppF.balancedIncidences[directiveProcces][directiveScope.employeeId][thisCalc.$id].partBalanced = true;
                                        AppF.balancedIncidences[directiveProcces][directiveScope.employeeId][thisCalc.$id].totallyBalanced = (valueToSend >= thisCalc.value);
                                    } else {
                                        AppF.balancedIncidences[directiveProcces][directiveScope.employeeId][thisCalc.$id].partBalanced = false;
                                        AppF.balancedIncidences[directiveProcces][directiveScope.employeeId][thisCalc.$id].totallyBalanced = false;
                                    }
                                }
                            }

                            var value = $filter("pathInObj")(AppF.balancedIncidences, directiveProcces + "." + directiveScope.employeeId);
                            // if (value) {
                            //     console.log(JSON.parse(JSON.stringify(AppF.balancedIncidences[directiveProcces][directiveScope.employeeId])), JSON.parse(JSON.stringify(pathsToSet)), directiveName)
                            // } else {
                            //     console.log(JSON.parse(JSON.stringify(pathsToSet)), directiveName)
                            // }
                            var possibleBalanced = possibleToBalance - pendingPossibleToBalance;
                            if (possibleBalanced > 0) {
                                calculation.value.total = calculation.value.total - possibleBalanced;
                            }
                            if (toOtherProccess > 0) {
                                calculation.value.toOtherProccess = toOtherProccess;
                            }
                            if (rejected > 0) {
                                calculation.value.rejected = rejected;
                            }
                        }
                        for (var path in pathsToSet) {
                            $filter("setInObjectPath")(path, AppF.fixIncidences, pathsToSet[path], true, true);
                            tempTotalesFixed[path] = true;
                        }
                        for (var path in totalesFixed) {
                            if (typeof (tempTotalesFixed[path]) == "undefined") {
                                $filter("setInObjectPath")(path, AppF.fixIncidences, undefined, true, true);
                            }
                        }
                        totalesFixed = tempTotalesFixed;
                    }
                    if (typeof (calculation.value.total) !== "undefined") {
                        var valuesToFormat = [{ value: calculation.value.total, field: "totalFormat" }];
                        if (typeof (calculation.value.fastValue) !== "undefined") {
                            calculation.value.normalValue = calculation.value.value - calculation.value.fastValue;
                        }
                        if (typeof (calculation.value.fastTotal) !== "undefined") {
                            calculation.value.normalTotal = calculation.value.total - calculation.value.fastTotal;
                            valuesToFormat.push({ value: calculation.value.fastTotal, field: "fastTotalFormat" });
                            valuesToFormat.push({ value: calculation.value.normalTotal, field: "normalTotalFormat" });
                        }
                        var format = calculation.value.type;

                        for (var v = 0; v < valuesToFormat.length; v++) {
                            var totalF;
                            switch (format) {
                                case "currency":
                                    totalF = $filter("currency")(valuesToFormat[v].value);
                                    break;
                                case "int":
                                default:
                                    totalF = valuesToFormat[v].value
                                    break;
                            }
                            calculation.value[valuesToFormat[v].field] = totalF;
                        }
                        if (directiveName == "Extra Hours Directive") { console.log(calculation); }

                    }
                    ngModel.$setViewValue(calculation);
                    //ngModel.$render();
                } catch (error) {
                    response = error;
                }
                return response;
            }
            //Funcion para llamar a que la directiva realice el calculo
            var calculate = function () {
                return $q(function (resolve, reject) {
                    try {
                        firstCalcDone = true;
                        //Se manda a calcular a la directiva
                        //$log.debug('init calculations of', directiveName, directiveProcces);
                        //Los datos ocupados para hacer el calculo se guardana para compararlos y detectar cambios
                        for (var o = 0; o < objsToWatch.length; o++) {
                            dataUsedToCal[objsToWatch[o]] = (angular.isDefined($filter("pathInObj")(directiveScope, objsToWatch[o])) ? $filter("pathInObj")(directiveScope, objsToWatch[o]) : undefined);
                        }
                        var calculation = directiveScope.calculate();
                        var fixTotalR = fixTotal(calculation);
                        if (fixTotalR === true) {
                            //En caso de que exista una referencia de primer calculo en el objeto de firstCalculation se elimina ya que el primer calculo fue realizado con exito
                            if (typeof (directiveFunctions.firstCalculation[directiveId + '-' + directiveScope.employeeId]) != "undefined") {
                                delete directiveFunctions.firstCalculation[directiveId + '-' + directiveScope.employeeId];
                            }
                            //Se muestra la flag de que los calculos fueron realizados
                            AppF.operationDataNeeded[directiveProcces][directiveScope.employeeId][directivePlace][directiveId] = true;
                            $log.debug('finishing calculations of', directivePlace);
                            resolve('Finished');
                            //$log.debug("resolving")
                        } else {
                            reject(fixTotalR);
                        }
                    } catch (error) {
                        reject(error);
                    }
                })
            }

            //Funcion para checar si se necesita recalcular la directiva en caso de haber cambiado los datos de los calculoss
            var checkObjDiferences = function () {
                var flag = false;
                var isBecauseBalance = false;
                for (var i = 0; i < objsToWatch.length; i++) {
                    if (objsToWatch[i] == "needToBalance") {
                        if ((directiveScope[objsToWatch[i]] == true) && loops < 20) {
                            var nextToBalance = false;
                            for (var incidenceId in directiveScope.calculationsResults) {
                                if (AppF.balanceIncidenceMap[directiveProcces][directiveScope.employeeId][incidenceId].afterBalanced) {
                                    nextToBalance = true;
                                }
                            }
                            if (nextToBalance) {
                                //console.log(directiveName, "need to balance beacuse", JSON.stringify(directiveScope.exceeded))
                                loops = loops + 1;
                                flag = true;
                                isBecauseBalance = true;
                                i = objsToWatch.length + 1;
                            }
                            if (loops >= 20) {
                                $log.error("loops avoided limit exceeded");
                            }
                        }
                    } else {
                        var newVal = $filter("pathInObj")(directiveScope, objsToWatch[i]); //directiveScope[objsToWatch[i]];
                        var oldVal = dataUsedToCal[objsToWatch[i]];
                        if (typeof (objsToWatchFilter) !== 'undefined' && typeof (objsToWatchFilter[objsToWatch[i]]) !== 'undefined') {
                            if (typeof (newVal) !== 'undefined') {
                                newVal = JSON.stringify($filter(objsToWatchFilter[objsToWatch[i]].filter)(newVal, objsToWatchFilter[objsToWatch[i]].param));
                            }
                            if (typeof (oldVal) !== 'undefined') {
                                oldVal = JSON.stringify($filter(objsToWatchFilter[objsToWatch[i]].filter)(oldVal, objsToWatchFilter[objsToWatch[i]].param));
                            }
                        } else {
                            if (typeof (newVal) !== 'undefined') {
                                newVal = JSON.stringify(newVal);
                            }
                            if (typeof (oldVal) !== 'undefined') {
                                oldVal = JSON.stringify(oldVal);
                            }
                        }
                        if (newVal !== oldVal) {
                            // if (objsToWatch[i] != "calculations" && objsToWatch[i] != "returnedConcepts") {
                            //     $log.debug('Differences in', objsToWatch[i], "of", directiveName, directiveProcces, newVal, oldVal);
                            // } else {
                            //     $log.debug('Differences in', objsToWatch[i], "of", directiveName, directiveProcces);
                            // }
                            flag = true;
                            i = objsToWatch.length + 1;
                        }
                    }
                }
                return {
                    flag: flag,
                    isBecauseBalance: isBecauseBalance
                };
            }
            var needToCalculate = function () {
                var flag = false;
                var isBecauseBalance = false;
                if (!directiveScope.notCalculate) {
                    if (!firstCalcDone) {
                        flag = true;
                    } else {
                        var hasDiferrences = checkObjDiferences();
                        flag = hasDiferrences.flag;
                        isBecauseBalance = hasDiferrences.isBecauseBalance;
                    }
                    if (flag) {
                        flag = getdataNeededLoaded();
                    }
                    if (flag) {
                        //$log.debug("Need to calculate", directiveName, directiveProcces, directiveScope.employeeId);
                    }
                    if (firstCalcDone && !isBecauseBalance) {
                        AppF.operationDataNeeded[directiveProcces][directiveScope.employeeId][directivePlace][directiveId] = !flag;
                    }
                }
                return {
                    flag: flag,
                    isBecauseBalance: isBecauseBalance,
                    place: AppF.levels.indexOf(directivePlace),
                    directivaName: directiveName,
                    directiveProcces: directiveProcces
                };
            }
            //Se agrega la referencia del calculo al mapa de llamados de funciones para calcular
            directiveFunctions.calculate[directiveId + '-' + directiveScope.employeeId] = calculate;

            //Si la directiva tiene que hacer calculos se agrega una referencia al mapa de hacer primer calculo para que se realice el calculo
            if (!directiveScope.notCalculate) {
                directiveFunctions.firstCalculation[directiveId + '-' + directiveScope.employeeId] = {
                    readyToCalc: getdataNeededLoaded,
                    directiveId: directiveId,
                    employeeId: directiveScope.employeeId
                };
            }

            //Se añaden los datos que seran observados al mapa de observaciones, para realizar un watcher por empleado y haciendo referencia a una directiva
            if (typeof (directiveFunctions.directiveWatcher[directiveScope.employeeId]) === 'undefined') directiveFunctions.directiveWatcher[directiveScope.employeeId] = {};
            if (typeof (directiveFunctions.directiveWatcher[directiveScope.employeeId][directiveId]) === 'undefined') directiveFunctions.directiveWatcher[directiveScope.employeeId][directiveId] = needToCalculate;
            //Se crea un evento que este escuchando el scope para eliminar la directiva en caso de ser eliminada y de esta manera no haya datos duplicados
            directiveScope.$on("$destroy", function () {
                try {
                    //$log.debug("About to Destroying", directiveName);
                    ngModel.$setViewValue(undefined);
                    ngModel.$render();
                    AppF.operationDataNeeded[directiveProcces][directiveScope.employeeId][directivePlace][directiveId] = true;
                    delete directiveFunctions.firstCalculation[directiveId + '-' + directiveScope.employeeId];
                    delete directiveFunctions.calculate[directiveId + '-' + directiveScope.employeeId];
                    delete directiveFunctions.directiveWatcher[directiveScope.employeeId][directiveId]
                    delete AppF.operationDataNeeded[directiveProcces][directiveScope.employeeId][directivePlace][directiveId];
                    var balancePath = directiveProcces + "." + directiveScope.employeeId + "." + directiveScope.incidenceId;
                    var balanceValue = $filter("pathInObj")(AppF.balancedIncidences, balancePath);
                    if (value) {
                        delete AppF.balancedIncidences[directiveProcces][directiveScope.employeeId][directiveScope.incidenceId];
                    }
                    for (var oldIncidenceId in oldCalculationsResults) {
                        var oldPath = directiveProcces + "." + directiveScope.employeeId + "." + oldIncidenceId;
                        if ($filter("pathInObj")(AppF.balancedIncidences, oldPath) !== false) {
                            delete AppF.balancedIncidences[directiveProcces][directiveScope.employeeId][oldIncidenceId];
                        }
                    }
                    for (var path in totalesFixed) {
                        var value = $filter("pathInObj")(AppF.fixIncidences, path);
                        if (value) {
                            $filter("setInObjectPath")(path, AppF.fixIncidences, undefined, true, true);
                        }
                    }
                    //$log.debug("Detroyed", directiveName);
                } catch (error) {
                    $log.debug(error);
                }
            });
            //$log.debug("init called", directiveName, directiveProcces);
            return directiveId;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('defaultFiscalIncidences', defaultFiscalIncidences);

    function defaultFiscalIncidences(
        getSomethingOfArrayMFilter,
        MongoF,
        AppF
    ) {

        return defaultFiscalIncidencesFn;

        function defaultFiscalIncidencesFn(employees, paymentShema, calendarYear, period, payrollId, dispersion) {
            var incidences = {};
            if (dispersion.hasOwnProperty('employees')) {
                for (var employeeId in dispersion.calculations) {
                    for (var internalCode in dispersion.calculations[employeeId].calculations.FISCAL) {
                        if (internalCode == "salary") {
                            dispersion.calculations[employeeId].calculations.FISCAL["001"] = dispersion.calculations[employeeId].calculations.FISCAL[internalCode]
                            internalCode = "001";
                        }
                        if (typeof(paymentShema.data.processes.fiscal.incidences[internalCode]) !== "undefined") {
                            if (typeof(incidences[internalCode]) == "undefined") {
                                incidences[internalCode] = {};
                            }
                            if (typeof(incidences[internalCode][employeeId]) == "undefined") {
                                incidences[internalCode][employeeId] = {
                                    automaticAsignation: true,
                                    status: 3,
                                    calendar: calendarYear,
                                    period: period.period + '',
                                    employee: employeeId,
                                    incidenceType: internalCode,
                                    payroll: payrollId,
                                    process: 'FISCAL',
                                    type: 'default',
                                    value: false, // need to be calculated by directives
                                    date: period.start, // @todo checar con el contador si aqui va el ultimo dia del periodo
                                    comments: 'Incidencia Automática Fiscal'
                                };
                            }
                        }
                    }
                }
            } else {
                // Create Them
                // set first node level with incidenceTypesId
                if (paymentShema) {
                    if (paymentShema.hasOwnProperty('data')) {
                        for (var internalCode in paymentShema.data.processes.fiscal.incidences) {
                            var incidenceD = paymentShema.data.processes.fiscal.incidences[internalCode];
                            if (incidenceD.default && incidenceD.active) {
                                incidences[internalCode] = {};
                                // set second node level with employeeId
                                for (var e in employees) {
                                    var employee = employees[e];
                                    // just one incidence for default incidences
                                    incidences[internalCode][employee.$id] = {
                                        automaticAsignation: true,
                                        status: 0,
                                        calendar: calendarYear,
                                        period: period.period + '',
                                        employee: employee.$id,
                                        incidenceType: internalCode,
                                        payroll: payrollId,
                                        process: 'FISCAL',
                                        type: 'default',
                                        value: false, // need to be calculated by directives
                                        date: moment().valueOf(), // @todo checar con el contador si aqui va el ultimo dia del periodo
                                        comments: 'Incidencia Automática Fiscal'
                                    };
                                }
                            }
                        }
                    }
                }
            }

            return incidences;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('deductionsByEmployee', deductionsByEmployee)

    function deductionsByEmployee(
        MongoF,
        getSomethingOfArrayMFilter
    ) {

        return deductionsByEmployeeFn;

        function deductionsByEmployeeFn(incidences, employees, fiscalIncidences) {
            var deductions = {};
            for (var e in employees) {
                var employee = employees[e];
                if (employee.hasOwnProperty('$id')) {
                    deductions[employee.$id] = [];
                    for (var i in incidences) {
                        var incidence = incidences[i];
                        if (incidence.employee == employee.$id) {
                            if (incidence.nature == 'deduction') {

                                if (typeof(fiscalIncidences) === "object") {
                                    // console.log(typeof(incidence.incidenceType) !== "undefined", fiscalIncidences.indexOf(incidence.incidenceType) > -1, typeof(incidence.incidenceType) !== "undefined" && fiscalIncidences.indexOf(incidence.incidenceType) > -1)
                                    if (typeof(incidence.incidenceType) !== "undefined" && fiscalIncidences.indexOf(incidence.incidenceType) > -1) {
                                        deductions[employee.$id].push(incidence);
                                    }
                                } else {
                                    deductions[employee.$id].push(incidence);
                                }
                            }
                        }
                    }
                }
            }
            return deductions;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('deductions', deductions)

    function deductions(
        AppF,
        MongoF,
        getSomethingOfArrayFBFilter,
        getSomethingOfArrayMFilter
    ) {

        return deductionsFn;

        function deductionsFn(incidencesByType, isSatOrComplement) {
            var onlyDeductions = {};
            for (var i in incidencesByType) {
                var nature = "";
                if (typeof(isSatOrComplement) !== "undefined") {
                    if (isSatOrComplement == "complement") {
                        nature = getSomethingOfArrayMFilter(i, MongoF.complementIncidencesTypes, 'nature', false, "_id");
                        if (nature === false) {
                            nature = getSomethingOfArrayFBFilter(i, AppF.incidencesTypes, 'nature', false);
                        }
                    } else {
                        nature = getSomethingOfArrayMFilter(i, MongoF.satIncidencesTypes, 'nature', false, "_id");
                    }
                } else {
                    nature = getSomethingOfArrayFBFilter(i, AppF.incidencesTypes, 'nature', false);
                }
                if (nature == 'deduction') onlyDeductions[i] = incidencesByType[i];
            }
            return onlyDeductions;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('createInfonavitIncidences', createInfonavitIncidences)

    function createInfonavitIncidences(errAlertS, getSomethingOfArrayFBFilter, pathInObjFilter) {

        return createInfonavitIncidencesFn;

        function createInfonavitIncidencesFn(incidences, incidencesTypes, employees, operation, calendar, payrollId, dispersion, period) {
            var infonavitId = false;
            for (var e in employees) {
                var employee = employees[e];
                var employeeClosed = false;
                if (dispersion && dispersion.employees[employee.$id]) {
                    employeeClosed = true;
                }
                if (infonavitId === false) {
                    infonavitId = getSomethingOfArrayFBFilter("010DR", incidencesTypes, "$id", false, "directive");
                }
                if (infonavitId) {
                    var path = "calculations." + employee.$id + ".calculations.REAL." + infonavitId;
                    var valueInDispersion = pathInObjFilter(dispersion, path);
                    var isInDispersion = (typeof(valueInDispersion) !== "undefined" && valueInDispersion !== false);
                    var hasCredit = (employee.credit && employee.credit.length > 0);
                    if (hasCredit || isInDispersion) {
                        var incidenceValue = 1;
                        if (isInDispersion) {
                            //console.log(valueInDispersion)
                            incidenceValue = valueInDispersion.value.total;
                        }
                        if (incidenceValue > 0) {
                            var incidenceObj = {
                                automaticAsignation: true,
                                status: 0,
                                calendar: calendar,
                                period: operation.period,
                                employee: employee.$id,
                                incidenceType: infonavitId,
                                payroll: payrollId,
                                process: false,
                                nature: 'deduction',
                                type: 'system',
                                value: incidenceValue, // need to be calculated by directives
                                date: period.start, // @todo checar con el contador si aqui va el ultimo dia del periodo
                                comments: 'Incidencia Automática de Infonavit'
                            };
                            incidences.push(incidenceObj);
                        }

                    }
                } else {
                    if (employee.credit && employee.credit.length > 0) {
                        errAlertS("No se encontro la incidencia para crear el credito del empleado, porfavor añada la incidencia");
                    }
                }
            }
            return incidences;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('createIncidencesByDay', createIncidencesByDay)

    function createIncidencesByDay(getAllIndencesOfDaysByDateFilter, clearObjectFilter) {

        return createIncidencesByDayFn;

        function createIncidencesByDayFn(incidence, activeDays, allIncidences, incidencesTypes, db, ref) {
            var incidences = {};
            var lastValue = incidence.$ids ? incidence.$ids.length : 0;
            var incidencesByDay = getAllIndencesOfDaysByDateFilter(allIncidences, incidencesTypes);
            for (var i = lastValue; i < incidence.value; i++) {
                var dayNotFounded = true;
                var activeDaysCounter = 0;
                while (dayNotFounded && activeDaysCounter < activeDays.length) {
                    var thisActiveDays = activeDays[activeDaysCounter];
                    var lastDay = moment(thisActiveDays.end);
                    var firstDay = moment(thisActiveDays.start);
                    while (dayNotFounded && firstDay.valueOf() <= lastDay.valueOf()) {
                        if (typeof(incidencesByDay[firstDay.format("DD-MM-YYYY")]) == "undefined") {
                            var newIncidence = angular.copy(incidence);
                            delete newIncidence.$ids;
                            delete newIncidence.dates;
                            newIncidence.phantomDate = firstDay.valueOf();
                            newIncidence.value = 1;
                            var incidenceId = db.child(ref).push().key;
                            incidences[incidenceId] = clearObjectFilter(newIncidence);
                            dayNotFounded = false;
                        }
                        firstDay.add(1, "d");
                    }
                    activeDaysCounter++;
                }
            }
            var count = 0;
            for (var i = incidence.value; i < lastValue; i++) {
                incidences[incidence.$ids[count]] = null;
                count++;
            }
            return incidences;
            //return {};
        }
    }

}());
(function(){
    'use strict';

    angular
        .module('app.clients')
        .filter('constructTotalsForDispersion', constructTotalsForDispersion)

    function constructTotalsForDispersion(){

        return constructTotalsForDispersionFn;

        function constructTotalsForDispersionFn(calculations, paymentSchema, payroll){
            var totals = {
                processes: {
                    REAL: 0,
                    FISCAL: 0,
                    complements: {}
                },
                toBill: {
                    brute: 0,
                    fee: 0,
                    net: 0
                }
            };
            // primero poner los complementos faltantes en 0
            for(var p in paymentSchema.data.processes.complements){
                var process = paymentSchema.data.processes.complements[p];
                if(process.active){
                    if(!totals.processes.complements.hasOwnProperty(process.name)){
                        totals.processes.complements[process.name] = 0;
                    }
                }
            }
            // totales para los procesos
            totals.processes['REAL'] = calculations['REAL'].netRealSalary.value.total;
            totals.toBill.brute = calculations['REAL'].netRealSalary.value.total;
            // totals.processes['FISCAL'] = calculations['FISCAL'].netSalary.value.total;
            // for(var c in totals.processes.complements){
            //     if(calculations[c]){
            //         if(calculations[c].hasOwnProperty('netComplement')){
            //             totals.processes.complements[c] = calculations[c].netComplement.value.total;
            //         } else {
            //             totals.processes.complements[c] = 0;
            //         }
            //     } else {
            //         totals.processes.complements[c] = 0;
            //     }
            // }
            // totales para prefactura individual @todo:carlos checar en constantes si la fee es diferente
            totals.toBill.fee = (payroll.data.fee/100) * totals.toBill.brute;
            totals.toBill.net = totals.toBill.fee + totals.toBill.brute;

            return totals;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('constructStatusNode', constructStatusNode)

    function constructStatusNode(
        DataF
    ) {

        return constructStatusNodeFn;

        function constructStatusNodeFn(operation, status, moveBack, comment) {
            var nodeName = '';
            switch (status) {
                case 0: nodeName = (moveBack) ? 'notOpened' : 'cancelled'; break;
                case 1: nodeName = (moveBack) ? 'notReviewed' : 'opened'; break;
                case 2: nodeName = (moveBack) ? 'notReviewed' : 'requested'; break;
                case 2.5: nodeName = (moveBack) ? 'notReviewed' : 'requestedFinal'; break;
                case 3: nodeName = (moveBack) ? 'notAuthorized' : 'reviewed'; break;
                case 4: nodeName = (moveBack) ? 'notPayed' : 'authorized'; break;
                case 5: nodeName = (moveBack) ? 'notConfirmed' : 'payed'; break;
                case 6: nodeName = (moveBack) ? 'notDispersed' : 'confirmed'; break;
                case 7: nodeName = (moveBack) ? 'notNotified' : 'dispersed'; break;
                case 8: nodeName = (moveBack) ? 'notArchived' : 'notified'; break;
                case 9: nodeName = 'archived'; break;
            }
            var timeObject = DataF.getTimeObject(true);
            if (operation[nodeName]) {
                if (moveBack) {
                    var key = moment().valueOf();
                    comment = comment ? comment : "";
                    if (typeof(operation[nodeName][key])==='undefined') {
                        operation[nodeName][key] = {};
                    }
                    operation[nodeName][key].by = timeObject.by;
                    operation[nodeName][key].comment = comment;

                } else {
                    angular.merge(operation[nodeName], timeObject);
                }
            } else {
                if (moveBack) {
                    operation[nodeName] = {};
                    var keyy = moment().valueOf();
                    comment = comment ? comment : "";
                    if (typeof(operation[nodeName][keyy])==='undefined') {
                        operation[nodeName][keyy] = {};
                    }
                    operation[nodeName][keyy].by = timeObject.by;
                    operation[nodeName][keyy].comment = comment;
                } else {
                    operation[nodeName] = timeObject
                }
            }

            return operation;
        }
    }

}());
(function(){
    'use strict';

    angular
        .module('app.clients')
        .filter('constructPreBill', constructPreBill)

    function constructPreBill(){
        return constructPreBillFn;
        function constructPreBillFn(employeesDispersion, paymentSchema, payroll){
            var preBill = {
                processes: {
                    REAL: 0,
                    FISCAL: 0,
                    complements: {}
                },
                feeTotal: 0,
                subTotal: 0,
                iva: 0,
                bruteTotal: 0,
                total: 0
            };
            // primero poner los complementos faltantes en 0
            for(var p in paymentSchema.data.processes.complements){
                var complement = paymentSchema.data.processes.complements[p];
                if(complement.active){
                    if(!preBill.processes.complements.hasOwnProperty(complement.name)){
                        preBill.processes.complements[complement.name] = 0;
                    }
                }
            }
            // ahora sumar los cálculos de cada empleado
            for(var e in employeesDispersion){
                var ed = employeesDispersion[e];
                // REAL
                preBill.processes['REAL'] += ed.totals.processes['REAL'];
                preBill.subTotal += ed.totals.processes['FISCAL'];
                // FISCAL
                preBill.processes['FISCAL'] += ed.totals.processes['FISCAL'];
                // complementos
                for(var c in ed.totals.processes.complements){
                    preBill.processes.complements[c] += ed.totals.processes.complements[c];
                    preBill.subTotal += ed.totals.processes.complements[c];
                }
                // TOTALES
                preBill.feeTotal += ed.totals.toBill.fee;
                preBill.bruteTotal += ed.totals.toBill.brute;
            }
            // TOTAL FINAL e IVA @todo checar con el conta si esta bien esto
            preBill.iva = (payroll.data.iva/100) * (preBill.subTotal + preBill.feeTotal);
            preBill.total = preBill.iva + preBill.subTotal + preBill.feeTotal;

            
            return preBill;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('constructIncidencesForDispersion', constructIncidencesForDispersion)

    function constructIncidencesForDispersion(
        getSomethingOfArrayMFilter,
        getIncidenceProcessFilter,
        MongoF
    ) {

        return constructIncidencesForDispersionFn;

        function constructIncidencesForDispersionFn(incidences, employeeId) {
            var incidencesForDispersion = {};
            for (var i in incidences) {
                var incidence = incidences[i];
                if (incidence.employee == employeeId) {
                    incidencesForDispersion[incidence.$id] = {
                        t: incidence.type ? incidence.type : "manual", // automatic, manual, request, past
                        i: incidence.incidenceType,
                        v: incidence.value, // value in $
                        p: (incidence.process) ? incidence.process : "real"
                    }
                    if (incidence.date) incidencesForDispersion[incidence.$id].d = incidence.date;
                }
            }

            return incidencesForDispersion;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('constructEmployeesDispertion', constructEmployeesDispertion)

    function constructEmployeesDispertion() {

        return constructEmployeesDispertionFn;

        function constructEmployeesDispertionFn(employees) {
            var dispersionData = {};
            for (var e in employees) {
                var employee = employees[e];
                dispersionData[employee.$id] = true;
            }
            return dispersionData;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('constructDispersionObject', constructDispersionObject)

    function constructDispersionObject(
        constructDispersionDataFilter,
        constructPreBillFilter,
        getOperationDatesFilter,
        constructEmployeesDispertionFilter
    ) {

        return constructDispersionObjectFn;

        function constructDispersionObjectFn(operation, employees, fiscalEmployees, payroll, paymentSchema, incidences, comments) {
            var dispersion = {
                operation: operation.$id,
                status: 0,
                data: {
                    payroll: operation.payroll,
                    calendar: operation.calendar,
                    period: operation.period,
                    supposedDate: getOperationDatesFilter()
                }
            };
            if (comments) dispersion.data.comments = comments;
            dispersion.calculations = constructDispersionDataFilter(employees, fiscalEmployees, incidences, payroll, paymentSchema);
            dispersion.preBill = constructPreBillFilter(dispersion.employees, paymentSchema, payroll);
            dispersion.employees = constructEmployeesDispertionFilter(employees);
            return dispersion;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('constructDispersionData', constructDispersionData)

    function constructDispersionData(
        constructIncidencesForDispersionFilter,
        constructTotalsForDispersionFilter,
        cleanCalculationsFilter,
        filterFilter
    ) {

        return constructDispersionDataFn;

        function constructDispersionDataFn(employees, fiscalEmployees, incidences, payroll, paymentSchema) {
            var dispersionData = {};
            for (var e in employees) {
                var employee = employees[e];
                if (fiscalEmployees) {
                    var founded = filterFilter(fiscalEmployees, {
                        $id: employee.$id
                    })
                    if (founded.length > 0) {
                        var thisEmployee = Object.assign(employee.calculations, founded[0].calculations);
                        console.log(thisEmployee);
                    }
                }
                dispersionData[employee.$id] = {
                    calculations: cleanCalculationsFilter(employee.calculations),
                    // incidences: constructIncidencesForDispersionFilter(incidences, employee.$id),
                    totals: constructTotalsForDispersionFilter(employee.calculations, paymentSchema, payroll)
                }
            }

            return dispersionData;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('constantsOfPayroll', constantsOfPayroll)

    function constantsOfPayroll(clearObjectFilter, filterFilter, orderByFilter) {

        return constantsOfPayrollFn;

        function constantsOfPayrollFn(payrollId, constants, calcFields) {
            var rutes = [
                "payroll/" + payrollId,
                "general"
            ]
            var payrollConstants = {};
            for (var r in rutes) {
                var rute = rutes[r];
                var thisConstant = constants[rute];
                if (typeof(thisConstant) !== "undefined" && typeof(thisConstant.object) !== "undefined" && typeof(thisConstant.object.length) !== "undefined" && thisConstant.object.length > 0) {
                    for (var i = 0; i < thisConstant.object.length; i++) {
                        var thisObjectConstant = clearObjectFilter(thisConstant.object[i]);
                        thisConstant.priority = thisConstant.priority;
                        if (typeof(payrollConstants[thisObjectConstant.type]) == "undefined") {
                            payrollConstants[thisObjectConstant.type] = [];
                        }
                        payrollConstants[thisObjectConstant.type].push(thisObjectConstant);
                    }
                }
            }
            var cons = {};
            var constantsOfProperty = payrollConstants.affectIncidenceProperty ? payrollConstants.affectIncidenceProperty : [];
            for (var i = 0; i < calcFields.length; i++) {
                var thisCalcField = calcFields[i];
                if (thisCalcField.object == "constants") {
                    var value = thisCalcField.defaultValue;
                    var constantsFounded = filterFilter(constantsOfProperty, {
                        affectProperty: {
                            property: thisCalcField.$id
                        }
                    }, true);
                    if (typeof(constantsFounded) !== "undefined" && constantsFounded.length > 0) {
                        var constantsOrdered = orderByFilter(constantsFounded, "-priority");
                        if (typeof(constantsOrdered[0].affectProperty) !== "undefined" && typeof(constantsOrdered[0].affectProperty.value) !== "undefined") {
                            value = constantsOrdered[0].affectProperty.value;
                        }
                    }
                    cons[thisCalcField.field] = value;
                }
            }
            payrollConstants.constants = cons;
            //console.log(payrollConstants);
            return payrollConstants;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('constantsByType', constantsByType)

    function constantsByType(constantsByEmployeeFilter,orderByFilter) {

        return constantsByTypeFn;

        function constantsByTypeFn(employees, constants) {
            var obj = {};
            var constantsOfEmployee = angular.copy(constantsByEmployeeFilter(employees, constants));
            angular.forEach(constantsOfEmployee,function(constants,employeeId){
                angular.forEach(constants,function(constant,iconstant){
                    if(!angular.isDefined(obj[constant.type])){
                        obj[constant.type]={};
                    }
                    if(!angular.isDefined(obj[constant.type][employeeId])){
                        obj[constant.type][employeeId]=[];
                    }
                     obj[constant.type][employeeId].push(constant);
                });
            });
            return obj;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('constantsByIncidences', constantsByIncidences)

    function constantsByIncidences(constantsByTypeFilter, orderByFilter, filterFilter, getSomethingOfArrayFBFilter,clearObjectFilter) {

        return constantsByIncidencesFn;

        function constantsByIncidencesFn(employees, constants, period, payroll, calendar, dispersion, calcFields, actualIncidences, incidencesTypes) {
            var obj = {};
            var affectIncidenceValueFiscal = {};
            var constantsOfEmployee = angular.copy(constantsByTypeFilter(employees, constants));
            //console.log(constantsOfEmployee);
            angular.forEach(constantsOfEmployee, function(employees, constantType) {
                angular.forEach(employees, function(constants, employeeId) {
                    constants = orderByFilter(constants, "-priority");
                    angular.forEach(constants, function(constant) {
                        if (!angular.isDefined(obj[constantType])) {
                            obj[constantType] = {};
                        }
                        //console.log(constant.incidencesType, employeeId);
                        if (typeof(constant.affect) != "undefined" && constant.affect.differentFiscalCalc) {
                            //console.log(constant.incidencesType, employeeId);
                            if (typeof(affectIncidenceValueFiscal[constant.incidencesType]) == "undefined") affectIncidenceValueFiscal[constant.incidencesType] = {};
                            if (typeof(affectIncidenceValueFiscal[constant.incidencesType][employeeId]) == "undefined") {
                                affectIncidenceValueFiscal[constant.incidencesType][employeeId] = JSON.parse(JSON.stringify(clearObjectFilter(constant)));
                                affectIncidenceValueFiscal[constant.incidencesType][employeeId].affect.operator = constant.affect.fiscalOperator;
                                affectIncidenceValueFiscal[constant.incidencesType][employeeId].affect.value = constant.affect.fiscalValue;
                            }
                        }
                        if (typeof(constant.incidencesType) != "undefined") {
                            if (!angular.isDefined(obj[constantType][constant.incidencesType])) {
                                obj[constantType][constant.incidencesType] = {};
                            }
                            if (!angular.isDefined(obj[constantType][constant.incidencesType][employeeId])) {
                                obj[constantType][constant.incidencesType][employeeId] = constant;
                            }
                        } else if (typeof(constant.affectProperty.property) != "undefined") {
                            if (!angular.isDefined(obj[constantType][employeeId])) {
                                obj[constantType][employeeId] = {};
                            }
                            if (!angular.isDefined(obj[constantType][employeeId][constant.affectProperty.property])) {
                                obj[constantType][employeeId][constant.affectProperty.property] = constant;
                            }
                        }
                    });
                });
            });
            // var affectIncidenceValueFiscalT = {};
            // console.log(affectIncidenceValueFiscal)
            // for (var incidencesType in affectIncidenceValueFiscal) {
            //     var thisSatIncidencesType = getSomethingOfArrayFBFilter(incidencesType, incidencesTypes, "satIncidencesType", false);
            //     if (thisSatIncidencesType) {
            //         affectIncidenceValueFiscalT[thisSatIncidencesType] = affectIncidenceValueFiscal[incidencesType];
            //     }
            // }
            obj.affectIncidenceValueFiscal = affectIncidenceValueFiscal;
            var automaticApply = [];
            var affectIncidenceProperty = {};
            if (obj.automaticApply) {
                angular.forEach(obj.automaticApply, function(employees, incidenceId) {
                    angular.forEach(employees, function(constant, employeeId) {
                        var employeeClosed = false;
                        if (dispersion && dispersion.employees[employeeId]) {
                            employeeClosed = true;
                        }
                        if (!employeeClosed) {
                            var exists = filterFilter(actualIncidences, {
                                type: 'constant',
                                incidenceType: constant.incidencesType,
                                employee: employeeId
                            });
                            if (!exists.length) {
                                var value = 0;
                                var thisDate = moment();
                                thisDate.milliseconds(0);
                                thisDate.seconds(0);
                                thisDate.minutes(0);
                                thisDate.hour(0);
                                if (obj.automaticApply[incidenceId][employeeId]) {
                                    value = obj.automaticApply[incidenceId][employeeId]["automaticApply"].value;
                                }
                                var incidenceObj = {
                                    automaticAsignation: true,
                                    status: 0,
                                    calendar: calendar,
                                    period: period.period,
                                    employee: employeeId,
                                    incidenceType: constant.incidencesType,
                                    payroll: payroll,
                                    process: false,
                                    type: 'constant',
                                    value: parseFloat(value), // need to be calculated by directives
                                    date: period.start, // @todo checar con el contador si aqui va el ultimo dia del periodo
                                    comments: 'Incidencia Automática por Constante'
                                };
                                automaticApply.push(incidenceObj);
                            }

                        }
                    });

                })
            }

            var con = {};
            var fieldIndex = {};
            for (var i = 0; i < calcFields.length; i++) {
                var thisCalcField = calcFields[i];
                if (thisCalcField.object == "constants") {
                    fieldIndex[thisCalcField.$id] = i;
                    con[thisCalcField.field] = thisCalcField.defaultValue;
                }
            }
            for (var e in employees) {
                var employeeClosed = false;
                if (dispersion && dispersion.employees[employees[e].$id]) {
                    employeeClosed = true;
                }
                if (!employeeClosed) {
                    affectIncidenceProperty[employees[e].$id] = JSON.parse(JSON.stringify(con));
                    if (obj.affectIncidenceProperty) {
                        for (var c in obj.affectIncidenceProperty[employees[e].$id]) {
                            var thiscalcF = obj.affectIncidenceProperty[employees[e].$id][c];
                            if (fieldIndex[c] > -1) {
                                affectIncidenceProperty[employees[e].$id][calcFields[fieldIndex[c]].field] = thiscalcF.affectProperty.value;
                            }
                        }
                    }
                }
            }

            obj.affectIncidenceProperty = affectIncidenceProperty;
            obj.automaticApply = automaticApply;
            //obj.affectIncidenceProperty = affectIncidenceProperty;
            return obj;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('constantsByEmployee', constantsByEmployee)

    function constantsByEmployee(getConstantsOfObjectFilter,orderByFilter) {

        return constantsByEmployeeFn;

        function constantsByEmployeeFn(employees, cons) {
            
            var constantsOfEmployee = {};
            angular.forEach(employees, function(employee, eindex) {
                var constantsRute = getConstantsOfObjectFilter(employee, "employee")
                constantsOfEmployee[employee.$id] = [];
                angular.forEach(constantsRute, function(constantRute) {
                    if (angular.isDefined(cons[constantRute])) {
                        angular.forEach(cons[constantRute].object,function(constant,value){
                            constant.priority=cons[constantRute].priority;
                            constantsOfEmployee[employee.$id].push(constant);
                        });
                    }
                })
            });
            return constantsOfEmployee;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('completeIncidencesTypeInformation', completeIncidencesTypeInformation)

    function completeIncidencesTypeInformation(getIncidencesTypesOfComplementsFilter) {

        return completeIncidencesTypeInformationFn;

        function completeIncidencesTypeInformationFn(incidencesTypesToComplete, complementIncidencesTypes) {
            //console.log(complementIncidencesTypes);
            var incidencesTypesOfComplements = getIncidencesTypesOfComplementsFilter(complementIncidencesTypes);
            // console.log(incidencesTypesOfComplements);
            for (var i = 0; i < incidencesTypesToComplete.length; i++) {
                var thisIncidenceType = incidencesTypesToComplete[i];
                for (var c in incidencesTypesOfComplements) {
                    var complementTypeId;
                    if (typeof(incidencesTypesOfComplements[c][thisIncidenceType.$id]) != "undefined") {
                        complementTypeId = incidencesTypesOfComplements[c][thisIncidenceType.$id];
                    } else if (typeof(incidencesTypesOfComplements[c][thisIncidenceType.nature]) !== "undefined") {
                        complementTypeId = incidencesTypesOfComplements[c][thisIncidenceType.nature];
                    } else {
                        complementTypeId = thisIncidenceType.$id;
                    }
                    if (typeof(complementTypeId) !== "undefined") {
                        incidencesTypesToComplete[i][c] = complementTypeId;
                    }
                }
            }
            //console.log(incidencesTypesToComplete);
            return incidencesTypesToComplete;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('completeIncidencesPrioritys', completeIncidencesPrioritys)

    function completeIncidencesPrioritys(getTotalOfArrayFieldFilter) {

        return completeIncidencesPrioritysFn;

        function completeIncidencesPrioritysFn(incidencesPriority, incidencesTypes, satIncidencesTypes, priorityMap) {
            // console.log("asdasdasd")
            priorityMap = priorityMap ? priorityMap : {};
            var incidencesPrioritysObjs = [{
                incidences: incidencesPriority,
                idField: "incidenceType",
                assignPriority: false
            }, {
                incidences: satIncidencesTypes,
                idField: "_id",
                assignPriority: true
            }, {
                incidences: incidencesTypes,
                idField: "$id",
                assignPriority: true
            }]
            var lowPriority = 20000;
            var highPriority = 10000;
            //console.log(count);
            for (var i = 0; i < incidencesPrioritysObjs.length; i++) {
                var thisObjs = incidencesPrioritysObjs[i];
                var incidences = thisObjs.incidences;
                var idField = thisObjs.idField;
                var assignPriority = thisObjs.assignPriority;
                //console.log(incidences, idField, assignPriority)
                if (typeof(incidences) == "object" && incidences.length) {
                    for (var a = 0; a < incidences.length; a++) {
                        //console.log(thisObj);
                        var thisObj = incidences[a];
                        var thisObjId = thisObj[idField];
                        if (typeof(priorityMap[thisObjId]) == "undefined") {
                            priorityMap[thisObjId] = {};
                            if (assignPriority) {
                                if (typeof(incidences[a].satIncidencesType) !== "undefined") {
                                    priorityMap[thisObjId].priority = lowPriority;
                                    lowPriority++;
                                } else {
                                    priorityMap[thisObjId].priority = highPriority;
                                    highPriority++;
                                }
                            } else {
                                // console.log("assgned false", idField)
                                priorityMap[thisObjId].priority = thisObj.priority;
                            }
                        }

                    }
                }
            }
            return priorityMap;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('completeIncidenceInformation', completeIncidenceInformation)

    function completeIncidenceInformation(getObjectOfArrayByIdFilter) {

        return completeIncidenceInformationFn;

        function completeIncidenceInformationFn(incidences, incidencesTypes, satIncidencesTypes) {
            angular.forEach(incidences, function(incidence, index) {
                var obj = getObjectOfArrayByIdFilter(incidence.incidenceType, incidencesTypes);
                if (obj) {
                    incidences[index].internalCode = obj.internal_code;
                    incidences[index].affect = obj.affect;
                    incidences[index].nature = obj.nature;
                    incidences[index].directive = obj.directive ? obj.directive : undefined;
                    if (typeof(obj.satIncidencesType) !== "undefined") {
                        var satObject = getObjectOfArrayByIdFilter(obj.satIncidencesType, satIncidencesTypes, "_id");
                        if (satObject) {
                            incidences[index].satIncidencesType=obj.satIncidencesType;
                            incidences[index].satAffect = satObject.affect;
                            incidences[index].satNature = satObject.nature;
                        }
                    }
                }
            });
            return incidences;
        }
    }

}());
(function(){
    'use strict';

    angular
        .module('app.clients')
        .filter('complementIncidences', complementIncidences)

    function complementIncidences(
        
    ){

        return complementIncidencesFn;

        function complementIncidencesFn(employees, paymentSchema, calendarYear, periodNumber, payrollId){
            var incidences = {};
            if(paymentSchema.hasOwnProperty('data')){
                for(var c in paymentSchema.data.processes.complements){
                    var complement = paymentSchema.data.processes.complements[c];
                    var cName = complement.type;
                    if(complement.active){
                        incidences[complement.name] = {};
                        incidences[complement.name][cName] = {};
                        for(var e in employees){
                            var employee = employees[e];
                            // setting incidences for setting later
                            incidences[complement.name][cName][employee.$id] = {
                                automaticAsignation: true,
                                status: 0,
                                calendar: calendarYear,
                                period: periodNumber + '',
                                employee: employee.$id,
                                incidenceType: complement.type,
                                payroll: payrollId,
                                process: complement.name,
                                type: 'complement',
                                value: false, // need to be calculated by directives
                                date: moment().valueOf(), // @todo checar con el contador si aqui va el ultimo dia del periodo
                                comments: 'Incidencia Automática de Complemento'
                            };
                        }
                    }
                }
            }
                
            return incidences;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('combineMovements', combineMovements)

    function combineMovements() {

        return combineMovementsFn;

        function combineMovementsFn(employees, movements) {
            angular.forEach(employees, function(employee, eindex) {
                angular.forEach(employee.movements, function(movement, imovement) {
                    if (angular.isDefined(movements[movement.$id])) {
                        employees[eindex].movements[imovement] = angular.merge(movement, movements[movement.$id]);
                    }
                });
            });
            return employees;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('combineAllIncidences', combineAllIncidences)

    function combineAllIncidences() {

        return combineAllIncidencesFn;

        function combineAllIncidencesFn(manualIncidences, automaticIncidences) {
            angular.forEach(automaticIncidences, function(incidence, index) {
                manualIncidences.push(incidence);
            });
            return manualIncidences;
        }
    }

}());
(function(){
    'use strict';

    angular
        .module('app.clients')
        .filter('cleanCalculations', cleanCalculations)

    function cleanCalculations(){

        return cleanCalculationsFn;

        function cleanCalculationsFn(calculations){
            var calculationsC = {};
            for(var processName in calculations){
                var calculationsOfProcess = calculations[processName];
                calculationsC[processName] = {};
                for(var incidenceCodeOrName in calculationsOfProcess){
                    calculationsC[processName][incidenceCodeOrName] = {
                        data: {},
                        value: {}
                    };
                    var calculation = calculationsOfProcess[incidenceCodeOrName];
                    for(var dataName in calculation.data){
                        var dato = calculation.data[dataName];
                        if(typeof dato == "string" || typeof dato == "number"){
                            calculationsC[processName][incidenceCodeOrName].data[dataName] = dato;
                        }else if(typeof dato == "object"){
                            calculationsC[processName][incidenceCodeOrName].data[dataName] = JSON.stringify(dato);
                        }
                    }
                    calculationsC[processName][incidenceCodeOrName].value = calculation.value;
                    if(typeof(calculation.formula)!="undefined"){
                        calculationsC[processName][incidenceCodeOrName].formula = calculation.formula;
                    }
                    if(typeof(calculation.formulas)=="string"){
                        calculationsC[processName][incidenceCodeOrName].formulas = calculation.formulas;
                    }else if(typeof(calculation.formulas)=="object"){
                        calculationsC[processName][incidenceCodeOrName].formulas = JSON.stringify(calculation.formulas);
                    }
                    
                }
            }
            return calculationsC;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('checkAllowDeleteFastIncidence', checkAllowDeleteFastIncidence)

    function checkAllowDeleteFastIncidence() {

        return checkAllowDeleteFastIncidenceFn;

        function checkAllowDeleteFastIncidenceFn(incidences) {
            var allow = true;
            angular.forEach(incidences, function(incidence) {
                if (incidence.$ids)
                    if (incidence.value != 0)
                        allow = false;

            });
            return allow;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('calculationsType', calculationsType)

    function calculationsType() {

        return calculationsTypeFn;

        function calculationsTypeFn(calculations, type) {
            return calculations;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('calculateTotalSalary', calculateTotalSalary)

    function calculateTotalSalary(orderByFilter) {

        return calculateTotalSalaryFn;

        function calculateTotalSalaryFn(salaries, workedDays, actualSalary, salaryType) {
            salaryType = salaryType ? salaryType : 'sdr';
            var totalSalary = 0;
            var salariesArray = [];
            for (var s in salaries) {
                salariesArray.push(salaries[s]);
            }
            var salariesOrdered = orderByFilter(salariesArray, ['-isActive', 'isAbsences', 'start']);
            var i = 0;
            while (i < workedDays && i<salariesOrdered.length && salariesOrdered[i].isActive && !salariesOrdered[i].isAbsences) {

                totalSalary += (salariesOrdered[i][salaryType] ? salariesOrdered[i][salaryType] : 0);
                i++;
            }
            var rest = workedDays-i;
            totalSalary += (rest * actualSalary);
            totalSalary = workedDays * actualSalary;
            return totalSalary;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('calculateTotal', calculateTotal)

    function calculateTotal($log) {

        return calculateTotalFn;

        function calculateTotalFn(array, type, field, notThis) {
            var total = 0;
            for (var a in array) {
                var incidence = array[a];
                var value = 0;
                var getValue = true;
                if (field && angular.isString(field)) {
                    if (angular.isDefined(incidence[field])) {
                        if (incidence[field] !== type) {
                            getValue = false;
                        }
                    } else {
                        getValue = false;
                    }
                } else if (type && angular.isString(type)) {
                    if (incidence.type != type) {
                        getValue = false;
                    }
                }
                if (getValue) {
                    if (angular.isDefined(incidence.value)) {
                        value = parseFloat(incidence.value);
                    }
                }
                total += value;
            }
            return total;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('calculateCredit2', calculateCredit2);

    function calculateCredit2($log, errAlertS, loopEachFilter) {

        var creditCalculations = {
            'porcentaje': function (credit, day, salaries, info, daysOfPeriod, nfdRecord) {
                var creditTotal = 0;
                if (info.formula === false) {
                    info.formula = '$sbc*$porcentaje*$workedDays';
                    info.percent = credit.factor;
                }
                var dailyAmortization = salaries.sbc * (credit.factor / 100);
                dailyAmortization = Math.round(dailyAmortization * 100) / 100;
                creditTotal = dailyAmortization * day;
                creditTotal = Math.round(creditTotal * 100) / 100;
                if (angular.isUndefined(info.dailyAmortization)) { info.dailyAmortization = []; }
                if (info.dailyAmortization.indexOf(dailyAmortization) < 0) { info.dailyAmortization.push(dailyAmortization); }
                return creditTotal;
            },
            'vsm': function (credit, day, salaries, info, daysOfPeriod, nfdRecord) {
                var creditTotal = 0;
                if (info.formula === false) {
                    info.formula = '($sbc*$factor*2)/' + daysOfPeriod + '*$workedDays';
                    info.creditFactor = credit.factor;
                    info.daysOfPeriod = daysOfPeriod;
                    info.NFD = nfdRecord;
                }
                var newDiscountFactor = nfdRecord ? nfdRecord : 0;
                var monthlyAmortization = newDiscountFactor * credit.factor;
                monthlyAmortization = Math.round(monthlyAmortization * 10000) / 10000;
                var bimonthlyAmortization = monthlyAmortization * 2;
                bimonthlyAmortization = Math.round(bimonthlyAmortization * 10000) / 10000;
                var dailyAmortization = bimonthlyAmortization / daysOfPeriod;
                dailyAmortization = Math.round(dailyAmortization * 10000) / 10000;
                creditTotal = dailyAmortization * day;
                creditTotal = Math.round(creditTotal * 10000) / 10000;
                if (angular.isUndefined(info.monthlyAmortization)) { info.monthlyAmortization = []; }
                if (info.monthlyAmortization.indexOf(monthlyAmortization) < 0) { info.monthlyAmortization.push(monthlyAmortization); }
                if (angular.isUndefined(info.bimonthlyAmortization)) { info.bimonthlyAmortization = []; }
                if (info.bimonthlyAmortization.indexOf(bimonthlyAmortization) < 0) { info.bimonthlyAmortization.push(bimonthlyAmortization); }
                if (angular.isUndefined(info.dailyAmortization)) { info.dailyAmortization = []; }
                if (info.dailyAmortization.indexOf(dailyAmortization) < 0) { info.dailyAmortization.push(dailyAmortization); }
                return creditTotal;
            },
            'cuota fija': function (credit, day, salaries, info, daysOfPeriod, nfdRecord) {
                var creditTotal = 0;
                if (info.formula === false) {
                    info.formula = '($fixedQuota*2)/' + daysOfPeriod + '*$workedDays';
                    info.fixedQuota = credit.factor;
                    info.daysOfPeriod = daysOfPeriod;
                }
                var monthlyAmortization = credit.factor;
                monthlyAmortization = Math.round(monthlyAmortization * 10000) / 10000;
                var bimonthlyAmortization = monthlyAmortization * 2;
                bimonthlyAmortization = Math.round(bimonthlyAmortization * 10000) / 10000;
                var dailyAmortization = bimonthlyAmortization / daysOfPeriod;
                dailyAmortization = Math.round(dailyAmortization * 10000) / 10000;
                creditTotal = dailyAmortization * day;
                creditTotal = Math.round(creditTotal * 10000) / 10000;
                if (angular.isUndefined(info.monthlyAmortization)) { info.monthlyAmortization = []; }
                if (info.monthlyAmortization.indexOf(monthlyAmortization) < 0) { info.monthlyAmortization.push(monthlyAmortization); }
                if (angular.isUndefined(info.bimonthlyAmortization)) { info.bimonthlyAmortization = []; }
                if (info.bimonthlyAmortization.indexOf(bimonthlyAmortization) < 0) { info.bimonthlyAmortization.push(bimonthlyAmortization); }
                if (angular.isUndefined(info.dailyAmortization)) { info.dailyAmortization = []; }
                if (info.dailyAmortization.indexOf(dailyAmortization) < 0) { info.dailyAmortization.push(dailyAmortization); }
                return creditTotal;
            }
        };
        return calculateCredit2Fn;



        function calculateByType(credit, day, salaries, info, daysOfPeriod, nfdRecord) {
            var creditTotal = 0;
            if (creditCalculations.hasOwnProperty(credit.type)) {
                creditTotal = creditCalculations[credit.type](credit, day, salaries, info, daysOfPeriod, nfdRecord);
            } else {
                errAlertS('No se encontró calculo para este tipo de crédito');
            }
            return creditTotal;
        }

        function calculateCredit2Fn(credit, dailySalaryR, operation, discountDays, nfdRecord, employeeName, creditCharged, lastPeriodData, lastOperationData) {
            var dailySalary = dailySalaryR ? angular.fromJson(angular.toJson(dailySalaryR)) : {};
            var info = {
                formula: false,
                total: 0,
                creditCharged: creditCharged,
                operationStart: operation.start
            };
            //Iniciar la sección para obtener el primer dia del bimestre
            var firstDateOFBimonthly = moment(operation.accuDate);
            info.firstDateOFBimonthly = firstDateOFBimonthly.format('DD-MM-YYYY');
            firstDateOFBimonthly.date(1);
            var thisMonthNumber = parseInt(firstDateOFBimonthly.format('MM'));
            info.thisMonthNumber = thisMonthNumber;
            var res = thisMonthNumber % 2;
            if (res === 0) {
                var bimonthlyNumber = (Math.floor(thisMonthNumber / 2) - 1) * 2;
                firstDateOFBimonthly.month(bimonthlyNumber);
            }
            var bimonthlyDays = firstDateOFBimonthly.daysInMonth();
            var tempDate = angular.copy(firstDateOFBimonthly);
            tempDate.add(1, 'M');
            bimonthlyDays += tempDate.daysInMonth();
            //termina sección para saber el primer dia del bimestre
            var daysInfonavit = 0;
            var initDate = credit.date;
            if (credit.hasOwnProperty('lastCreditDate')) {
                initDate = credit.lastCreditDate;
            }
            loopEachFilter(dailySalary, function (thisDailySalary) {
                if (thisDailySalary.start >= initDate && (!thisDailySalary.isAbsences || (thisDailySalary.isAbsences && !discountDays))) {
                    daysInfonavit++;
                    info.total += calculateByType(credit, 1, thisDailySalary, info, bimonthlyDays, nfdRecord);
                }
            });
            loopEachFilter(info, function (data, d) {
                if (angular.isObject(info[d])) {
                    info[d] = info[d].toString();
                }
            });
            info.total = Math.round(info.total * 10000) / 10000;
            info.creditType = credit.type;
            info.creditTotal = info.total;
            info.daysInfonavit = daysInfonavit;
            var chargeEnsure = false;
            var chargeMotive = "";
            var endDate = moment(operation.accuDate).startOf('date').valueOf();
            var startDate;
            if (angular.isObject(lastPeriodData) && angular.isObject(lastOperationData)) {
                startDate = moment(lastPeriodData.accuDate).add(1, 'day').startOf('day').valueOf();
            } else {
                startDate = moment(operation.accuDate).startOf('year').startOf('day').valueOf();
            }
            if (credit.hasOwnProperty('lastCreditDate')) {
                if (startDate <= credit.lastCreditDate && endDate >= credit.lastCreditDate) {
                    chargeMotive = "lastCreditDate in range " + startDate + " - " + endDate;
                    chargeEnsure = true;
                }
            } else if (startDate <= credit.date && endDate >= credit.date) {
                chargeMotive = "credit.date in range " + startDate + " - " + endDate;
                chargeEnsure = true;
            }
            if ((!chargeEnsure) && startDate <= firstDateOFBimonthly.valueOf() && endDate >= firstDateOFBimonthly.valueOf()) {
                chargeMotive = "firstDateOFBimonthly: " + firstDateOFBimonthly.valueOf() + " in range:" + startDate + " - " + endDate;
                chargeEnsure = true;
            }
            if (daysInfonavit > 0 && (chargeEnsure || !creditCharged)) {
                if (!chargeEnsure && !creditCharged) {
                    chargeMotive = "credit not charged yet in previous periods";
                }
                info.chargeMotive = chargeMotive;
                info.total += 15;
                info.ensure = 15;
            }
            if (isNaN(info.total)) {
                info.total = 0;
                errAlertS('Existe un error en el crédito No.' + credit.account + ' del empleado ' + employeeName + ', favor de verificar');
            }
            return info;
        }
    }
}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('calculateCredit', calculateCredit)

    function calculateCredit(orderByFilter, errAlertS) {

        return calculateCreditFn;

        function calculateByType(credit, day, salaries, info, daysOfPeriod, nfdRecord) {
            var creditTotal = 0;
            switch (credit.data.type) {
                case "porcentaje":
                    if (info.formula === false) {
                        info.formula = "$sbc*$porcentaje*$workedDays";
                        info.data.percent = credit.data.factor;
                    }
                    var dailyAmortization = salaries.sbc * (credit.data.factor / 100);
                    dailyAmortization = Math.round(dailyAmortization * 100) / 100;
                    creditTotal = dailyAmortization * day;
                    creditTotal = Math.round(creditTotal * 100) / 100;
                    if (typeof (info.data.dailyAmortization) == "undefined") info.data.dailyAmortization = [];
                    if (info.data.dailyAmortization.indexOf(dailyAmortization) < 0) info.data.dailyAmortization.push(dailyAmortization);
                    break;
                case "vsm":
                    if (info.formula === false) {
                        info.formula = "($sbc*$factor*2)/" + daysOfPeriod + "*$workedDays";
                        info.data.creditFactor = credit.data.factor;
                        info.data.daysOfPeriod = daysOfPeriod;
                        info.data.NFD = nfdRecord;
                    }
                    var newDiscountFactor = nfdRecord ? nfdRecord : 0;
                    var monthlyAmortization = newDiscountFactor * credit.data.factor;
                    monthlyAmortization = Math.round(monthlyAmortization * 10000) / 10000;
                    var bimonthlyAmortization = monthlyAmortization * 2;
                    bimonthlyAmortization = Math.round(bimonthlyAmortization * 10000) / 10000;
                    var dailyAmortization = bimonthlyAmortization / daysOfPeriod;
                    dailyAmortization = Math.round(dailyAmortization * 10000) / 10000;
                    creditTotal = dailyAmortization * day;
                    creditTotal = Math.round(creditTotal * 10000) / 10000;
                    if (typeof (info.data.monthlyAmortization) == "undefined") info.data.monthlyAmortization = [];
                    if (info.data.monthlyAmortization.indexOf(monthlyAmortization) < 0) info.data.monthlyAmortization.push(monthlyAmortization);
                    if (typeof (info.data.bimonthlyAmortization) == "undefined") info.data.bimonthlyAmortization = [];
                    if (info.data.bimonthlyAmortization.indexOf(bimonthlyAmortization) < 0) info.data.bimonthlyAmortization.push(bimonthlyAmortization);
                    if (typeof (info.data.dailyAmortization) == "undefined") info.data.dailyAmortization = [];
                    if (info.data.dailyAmortization.indexOf(dailyAmortization) < 0) info.data.dailyAmortization.push(dailyAmortization);
                    break;
                case "cuota fija":
                    if (info.formula === false) {
                        info.formula = "($fixedQuota*2)/" + daysOfPeriod + "*$workedDays";
                        info.data.fixedQuota = credit.data.factor;
                        info.data.daysOfPeriod = daysOfPeriod;
                    }
                    var monthlyAmortization = credit.data.factor;
                    monthlyAmortization = Math.round(monthlyAmortization * 10000) / 10000;
                    var bimonthlyAmortization = monthlyAmortization * 2;
                    bimonthlyAmortization = Math.round(bimonthlyAmortization * 10000) / 10000;
                    var dailyAmortization = bimonthlyAmortization / daysOfPeriod;
                    dailyAmortization = Math.round(dailyAmortization * 10000) / 10000;
                    creditTotal = dailyAmortization * day;
                    creditTotal = Math.round(creditTotal * 10000) / 10000;
                    if (typeof (info.data.monthlyAmortization) == "undefined") info.data.monthlyAmortization = [];
                    if (info.data.monthlyAmortization.indexOf(monthlyAmortization) < 0) info.data.monthlyAmortization.push(monthlyAmortization);
                    if (typeof (info.data.bimonthlyAmortization) == "undefined") info.data.bimonthlyAmortization = [];
                    if (info.data.bimonthlyAmortization.indexOf(bimonthlyAmortization) < 0) info.data.bimonthlyAmortization.push(bimonthlyAmortization);
                    if (typeof (info.data.dailyAmortization) == "undefined") info.data.dailyAmortization = [];
                    if (info.data.dailyAmortization.indexOf(dailyAmortization) < 0) info.data.dailyAmortization.push(dailyAmortization);
                    break;
            }
            return creditTotal;
        }

        function calculateCreditFn(credit, dailySalaryR, operation, constants, nfdRecord, employeeName) {
            var dailySalary = dailySalaryR ? JSON.parse(JSON.stringify(dailySalaryR)) : {};
            var info = {
                data: {},
                formula: false,
                total: 0
            }
            //inciar la seccion para obtener el primer dia del bimestre
            var firstDateOFBimonthly = moment(operation.start);
            firstDateOFBimonthly.date(1);
            var thisMonthNumber = parseInt(firstDateOFBimonthly.format('MM'));
            var res = thisMonthNumber % 2;
            if (res == 0) {
                var bimonthlyNumber = (Math.floor(thisMonthNumber / 2) - 1) * 2;
                firstDateOFBimonthly.month(bimonthlyNumber);
            }
            var bimonthlyDays = firstDateOFBimonthly.daysInMonth();
            var tempDate = angular.copy(firstDateOFBimonthly);
            tempDate.add(1, "M");
            bimonthlyDays += tempDate.daysInMonth();
            //termina seccion para saber el primer dia del bimestre
            var daysInfonavit = 0;
            //console.log(dailySalary.data.dailySalaries)
            for (var s in dailySalary.data.dailySalaries) {
                var thisdailySalary = dailySalary.data.dailySalaries[s];
                if (thisdailySalary.start >= credit.data.date && thisdailySalary.isActive) {
                    if (!thisdailySalary.isAbsences || (thisdailySalary.isAbsences && !constants.discountDaysInfonavit)) {
                        daysInfonavit++;
                        thisdailySalary.sd = thisdailySalary.rSd;
                        thisdailySalary.sbc = thisdailySalary.rSbc;
                        thisdailySalary.sdr = thisdailySalary.rSdr;
                        info.total += calculateByType(credit, 1, thisdailySalary, info, bimonthlyDays, nfdRecord);
                    }
                }
            }
            for (var d in info.data) {
                if (typeof (info.data[d]) == "object") {
                    info.data[d] = info.data[d].toString();
                }
            }
            info.total = Math.round(info.total * 10000) / 10000;
            info.data.creditType = credit.data.type;
            info.data.creditTotal = info.total;
            info.data.daysInfonavit = daysInfonavit;
            var chargeEnsure = false;
            if (operation.start <= credit.data.date && operation.end >= credit.data.date) {
                chargeEnsure = true;
            }
            if (!chargeEnsure) {
                if (operation.start <= firstDateOFBimonthly.valueOf() && operation.end >= firstDateOFBimonthly.valueOf()) {
                    chargeEnsure = true;
                }
            }
            if (chargeEnsure) {
                info.total += 15;
                info.data.ensure = 15;
            }
            // console.log(info);
            if (isNaN(info.total)) {
                info.total = 0;
                errAlertS("Existe un error en el credito No." + credit.data.account + " del empleado " + employeeName + ", favor de verificar")
            }
            return info;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('anyIsBalanced', anyIsBalanced)

    function anyIsBalanced() {

        return anyIsBalancedFn;

        function anyIsBalancedFn(employeeMapBalance, calculationsResults, log) {
            // console.log(employeeMapBalance, calculationsResults);
            var flag = false;
            if (typeof(calculationsResults) == "object") {
                for (var incidenceId in calculationsResults) {
                    if (typeof(employeeMapBalance) == "object" && typeof(employeeMapBalance[incidenceId]) == "object" && employeeMapBalance[incidenceId].partBalanced) {
                        flag = true;
                    }
                }
            }
            return flag;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('anyEmployeeHasCredit', anyEmployeeHasCredit)

    function anyEmployeeHasCredit() {

        return anyEmployeeHasCreditFn;

        function anyEmployeeHasCreditFn(employees) {
            var hasCredit = false;
            for (var e in employees) {
                if (employees[e].credit.length > 0) {
                    hasCredit = true;
                    return hasCredit;
                }
            }
            return hasCredit;
        }
    }

}());
angular.module('app.clients').filter('ageOfEmployees', function () {
    return function (birthDate) {
        if (angular.isDefined(birthDate) && birthDate) {
            var birthMoment = moment(birthDate, "DD-MM-YYYY");
            var currentYear = moment().year();
            var ageThisYear = currentYear - birthMoment.year();
            var numberData = ageThisYear > 0 ? ageThisYear : 'Este año no cumple'
            return numberData;
        }
    };
});

(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('activeDaysFromMovements', activeDaysFromMovements);

    function activeDaysFromMovements() {

        return activeDaysFromMovementsFn;

        function activeDaysFromMovementsFn(movements, period, pendingDays, inactiveDays) {

            if (angular.isArray(inactiveDays)) {
                inactiveDays = inactiveDays.filter(function (item) {
                    return (period.start <= item.date && item.date <= period.end);
                }).sort(function (a, b) {
                    return a.date - b.date;
                });
                var fakeMovements = [];
                for (var t = 0; t < inactiveDays.length; t++) {
                    var thisInactiveDay = inactiveDays[t];
                    var thisDate = moment(thisInactiveDay.date);
                    if (fakeMovements.length === 0 || fakeMovements[fakeMovements.length - 1].t === 8) {
                        fakeMovements.push({
                            t: 2,
                            d: thisDate.clone().subtract(1, 'd').valueOf(),
                            $id: t
                        });
                    }
                    var nextDay = thisDate.clone().add(1, 'day');
                    if ((t + 1 < inactiveDays.length) && !(nextDay.startOf('day').valueOf() <= inactiveDays[t + 1].date && inactiveDays[t + 1].date <= nextDay.endOf('day').valueOf())) {
                        fakeMovements.push({
                            t: 8,
                            d: thisDate.clone().add(1, 'day').valueOf(),
                            $id: t
                        });
                    } else if ((inactiveDays.length - 1) === t && fakeMovements[fakeMovements.length - 1].t === 2) {
                        fakeMovements.push({
                            t: 8,
                            d: thisDate.clone().add(1, 'd').valueOf(),
                            $id: t
                        });
                    }
                }
                console.log(fakeMovements);
                movements = movements.concat(fakeMovements).sort(function (a, b) {
                    var aDate = a.d || a.data.date;
                    var bDate = b.d || b.data.date;
                    return aDate - bDate;
                });
            }

            var activeDays = [],
                periodStartDate = moment(period.start),
                periodEndDate = moment(period.end),
                count = 0;
            angular.forEach(movements, function (movement) {
                var movDate = movement.d || movement.data.date;
                var movType = movement.t || movement.data.type;
                var movementDate = moment(movDate);
                count++;
                // se verifica que el movimiento no sea baja
                if (movType !== 2) {
                    // al crear una entrada se verifica que la anterior este cerrada si no esta cerrada se cierra
                    var lastIndex = activeDays.length;
                    if (lastIndex) {
                        if (angular.isUndefined(activeDays[lastIndex - 1].end)) {
                            var tempMovement = angular.copy(movementDate);
                            tempMovement.subtract(1, 'milliseconds');
                            activeDays[lastIndex - 1].end = tempMovement.valueOf();
                            activeDays[lastIndex - 1].endDate = tempMovement.format('DD-MM-YYYY');
                            activeDays[lastIndex - 1].endMovement = movement;
                            activeDays[lastIndex - 1].endMovementId = movement.$id || movement.fid;
                        }
                    }
                    // cada movimiento que no sea baja hace que se cree un registro de empleado activo

                    var thisDate = periodStartDate.clone();
                    if (movDate > period.start) {
                        thisDate = movementDate.clone();
                    }
                    if (activeDays.length == 0 && angular.isNumber(pendingDays)) {
                        thisDate.subtract(pendingDays, 'days');
                    }
                    // if (movDate > period.start) {
                    //     activeDays.push({
                    //         start: movementDate.valueOf(),
                    //         startDate: movementDate.format('DD-MM-YYYY'),
                    //         startMovement: movement,
                    //         startMovementId: movement.$id || movement.fid
                    //     });
                    // } else {
                    //     activeDays.push({
                    //         start: periodStartDate.valueOf(),
                    //         startDate: periodStartDate.format('DD-MM-YYYY'),
                    //         startMovement: movement,
                    //         startMovementId: movement.$id || movement.fid
                    //     });
                    // }

                    activeDays.push({
                        start: thisDate.valueOf(),
                        startDate: thisDate.format('DD-MM-YYYY'),
                        startMovement: movement,
                        startMovementId: movement.$id || movement.fid
                    });

                    if (count >= movements.length) {
                        var lastIndex2 = activeDays.length;
                        if (lastIndex2) {
                            activeDays[lastIndex2 - 1].end = periodEndDate.valueOf();
                            activeDays[lastIndex2 - 1].endDate = periodEndDate.format('DD-MM-YYYY');
                        }
                    }
                } else { // si este movimiento es baja entonces se establece como ultima fecha del los dias activos
                    var lastIndex3 = activeDays.length; //se encuentra el ultimo indice del arreglo
                    if (lastIndex3) { //si hay un ultimo indice se establece esta fecha como ultimo
                        if (angular.isUndefined(activeDays[lastIndex3 - 1].end)) {
                            activeDays[lastIndex3 - 1].end = movementDate.valueOf(); //se estable la fecha del movimiento de alta como ultima fecha
                            activeDays[lastIndex3 - 1].endDate = movementDate.format('DD-MM-YYYY');
                            activeDays[lastIndex3 - 1].endMovement = movement;
                            activeDays[lastIndex3 - 1].endMovementId = movement.$id || movement.fid;
                        }
                    }
                }
            });
            var tempActive = [];
            for (var i = 0; i < activeDays.length; i++) {
                var activeDay = activeDays[i];
                if (activeDay.end >= activeDay.start) {
                    tempActive.push(activeDay);
                }
            }
            activeDays = tempActive;
            return activeDays;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .directive('sheetTotalIsn', sheetTotalIsn);


    /** @ngInject */
    function sheetTotalIsn(
        $log
    ) {
        return {
            require: '?ngModel',
            restrict: 'A',
            scope: { // se meten aqui los datos que vaya a necesitar el cálculo
                rp: "=",
                fiscalSalary: "="
            },
            link: function(scope, ele, attrs, ngModel) {
                var calculate = function() {
                    var fiscalSalary = scope.fiscalSalary ? scope.fiscalSalary : 0;
                    var isnPercent = angular.isDefined(scope.rp.data)&&angular.isDefined(scope.rp.data.isn)?scope.rp.data.isn:0;
                    isnPercent = parseFloat(isnPercent) / 100;
                    var total = fiscalSalary * isnPercent;
                    total = Math.round(total * 100) / 100;
                    var calculation = {
                        data: {
                            isnPercent: isnPercent,
                        },
                        formula: '$totalSalary = $salary * $workedDays',
                        value: {
                            name: 'Impuesto Sobre Nomina',
                            total: total,
                            type: 'currency'
                        }
                    };
                    //$log.debug(calculation, 'total salary Calculation');
                    ngModel.$setViewValue(calculation);
                    ngModel.$render();
                }
                scope.$watch("rp", function(rp) {
                    if (angular.isDefined(rp)) scope.$emit("loaded");
                }, true);
                scope.$watchGroup(["fiscalSalary"], function(newV) {
                    if (angular.isDefined(newV[0])) scope.$emit("loaded");
                });
                scope.$on("loaded", function() {
                    if (angular.isDefined(scope.rp)) calculate();
                });
            }
        }
    }

}());
// (function () {
//     'use strict';

//     angular
//         .module ('app.clients')
//         .directive ('sheetTotalComplement', sheetTotalComplement);


//     /** @ngInject */
//     function sheetTotalComplement($log) {
//         return {
//             require: '?ngModel',
//             restrict: 'A',
//             scope: { // se meten aqui los datos que vaya a necesitar el cálculo
//                 gravableBase: '=',
//                 complementIsr: '=',
//                 complementLimit: '='
//             },
//             link: function(scope, ele, attrs, ngModel){
//                 var calculate = function(){
//                     var total = scope.gravableBase + scope.complementIsr;
//                     var calculation = {
//                         data: {
//                             total: total,
//                             isr: scope.complementIsr,
//                             gravableBase: scope.gravableBase,
//                             limit: scope.complementLimit
//                         },
//                         formula: '$netComplement = $gravableBase + $isr',
//                         value: {
//                             name: 'Neto del Complemento',
//                             total: total,
//                             type: 'currency'
//                         }
//                     };
//                     $log.debug(calculation, 'Total Complement Calculation');
//                     ngModel.$setViewValue(calculation);
//                     ngModel.$render();
//                 }

//                 watchers de propiedades
//                 scope.$watchGroup(['gravableBase','complementIsr', 'complementLimit'], function(newV, oldV){
//                     if(angular.isDefined(newV[0]) && angular.isDefined(newV[1]) && angular.isDefined(newV[2])) calculate();
//                 });

//             }
//         }
//     }

// } ());
(function () {
    'use strict';

    angular
        .module ('app.clients')
        .directive ('sheetTotalComplementOLD', sheetTotalComplementOLD);


    /** @ngInject */
    function sheetTotalComplementOLD($log) {
        return {
            require: '?ngModel',
            restrict: 'A',
            scope: { // se meten aqui los datos que vaya a necesitar el cálculo
                deductions: '=',
                socialPrevision: '='
            },
            link: function(scope, ele, attrs, ngModel){
                var calculate = function(){
                    var total =  scope.socialPrevision-scope.deductions;
                    total=Math.round(total * 100) / 100
                    var calculation = {
                        data: {
                            totalDeductions: scope.deductions ,
                            socialPrevision: scope.socialPrevision
                        },
                        formula: '$netComplement = $socialPrevision - $deductions',
                        value: {
                            name: 'Neto del Complemento',
                            total: total,
                            type: 'currency'
                        }
                    };
                    //$log.debug(calculation, 'Total Complement Calculation');
                    ngModel.$setViewValue(calculation);
                    ngModel.$render();
                }

                // watchers de propiedades
                scope.$watchGroup(['deductions','socialPrevision'], function(newV, oldV){
                    if(angular.isDefined(newV[0]) && angular.isDefined(newV[1])) calculate();
                });

            }
        }
    }

} ());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .directive('sheetSundayBonus', sheetSundayBonus);


    /** @ngInject */
    function sheetSundayBonus($log) {
        return {
            require: '?ngModel',
            restrict: 'A',
            scope: {

            },
            link: function(scope, ele, attrs, ngModel) {
                var calculate = function() {
                    var total = 0;
                    var calculation = {
                        data: {
                            //aqui van los datos que se regresa
                        },
                        formulas: [
                            //aqui van la formulas
                        ],
                        value: {
                            name: '',
                            total: total,
                            type: ''
                        }
                    };
                    ngModel.$setViewValue(calculation);
                    ngModel.$render();
                }


                // watchers de propiedades
                // scope.$watchGroup(['listen', 'listen2', 'listen3'], function(newV, oldV) {
                //     if (newV[0] && newV[1] && newV[2]) calculate();
                // });

                // watchers de arreglos
                // scope.$watch('deductions', function(deductions) {
                //     if (deductions && scope.sd) calculate();
                // }, true);
                //
                calculate()
            }
        }
    }

}());
// (function () {
//     'use strict';

//     angular
//         .module ('app.clients')
//         .directive ('sheetSocialPrevision', sheetSocialPrevision);

//     /** @ngInject */
//     function sheetSocialPrevision($log) {
//         return {
//             require: '?ngModel',
//             restrict: 'A',
//             scope: { // se meten aqui los datos que vaya a necesitar el cálculo
//                 sdr: '=',
//                 fiscalNet: '=',
//                 realNet: '=',
//                 complementLimit: '='
//             },
//             link: function(scope, ele, attrs, ngModel){
//                 var calculate = function(){
//                     var toReach = scope.realNet - scope.fiscalNet;
//                     var socialPrevisionTotal = toReach; // @todo checar si se aplica esto o es la diferencia (scope.sdr-(scope.fiscalNet/scope.workedDays)) * scope.workedDays;
//                     var socialPrevisionNet = (socialPrevisionTotal > scope.complementLimit) ? scope.complementLimit : socialPrevisionTotal;
//                     var complementExcedent = (socialPrevisionTotal > scope.complementLimit) ? socialPrevisionTotal - scope.complementLimit : 0;
                    
//                     var calculation = {
//                         data: {
//                             toReach: toReach,
//                             //workedDays: scope.workedDays,
//                             fiscalNet: scope.fiscalNet,
//                             realNet: scope.relNet,
//                             complementLimit: scope.complementLimit,
//                             complementExcedent: complementExcedent,
//                             socialPrevisionTotal: socialPrevisionTotal,
//                             socialPrevisionNet: socialPrevisionNet
//                         },
//                         formulas: [
//                             '$socialPrevisionTotal = ($sdr-($netFiscal/$workedDays))*workedDays',
//                             '$complementExcedent = ($socialPrevisionTotal > $complementLimit) ? $socialPrevisionTotal - $complementLimit : 0'
//                         ],
//                         value: {
//                             name: 'Previsión Social',
//                             total: socialPrevisionNet,
//                             type: 'currency'
//                         }
//                     };

//                     $log.debug(calculation, 'Social Prevision Calculation');
//                     ngModel.$setViewValue(calculation);
//                     ngModel.$render();
//                 }

//                 // watchers de propiedades
//                 // scope.$watchGroup(['sdr', 'sd', 'fiscalNet', 'realNet', 'workedDays', 'complementLimit'], function(newV, oldV){
//                 //     if(angular.isDefined(newV[0]) && angular.isDefined(newV[1]) && angular.isDefined(newV[2]) && angular.isDefined(newV[3]) && angular.isDefined(newV[4]) && angular.isDefined(newV[5])) calculate();
//                 // });

//                 scope.$watchGroup(['fiscalNet', 'realNet', 'complementLimit'], function(newV, oldV){
//                     if(angular.isDefined(newV[0]) && angular.isDefined(newV[1]) && angular.isDefined(newV[2])) calculate();
//                 });
//             }
//         }
//     }

// } ());
(function () {
    'use strict';

    angular
        .module ('app.clients')
        .directive ('sheetSavingFound', sheetSavingFound);


    /** @ngInject */
    function sheetSavingFound($log,AppF) {
        return {
            require: '?ngModel',
            restrict: 'A',
            scope: {
                sbc: '=',
                workedDays: '=',
                gravableBase: '=',
                calendarYear: '='
            },
            link: function(scope, ele, attrs, ngModel){
                AppF=AppF;
                var calculate = function(){
                    // @todo sacar la info del registro de imss, preguntar como, llenar data y formulas :)
                    var imssRecord = getIMSSRowFilter(scope.calendarYear);
                    if(imssRecord){
                        var imssFee = 1;
                        var patronalImss = 2;
                        var employeeImss = 3;
                        var netImss = patronalImss + employeeImss;
                        var calculation = {
                            data: {
                                imssFee: imssFee,
                                sbc: scope.sbc,
                                workedDays: scope.workedDays,
                                gravableBase: scope.gravableBase,
                                netImss: netImss,
                                employeeImss: employeeImss,
                                patronalImss: patronalImss
                            },
                            formula: '$netImss = $employeeImss + $patronalImss',
                            value: {
                                name: 'IMSS',
                                total: netImss,
                                type: 'currency'
                            }
                        };
                        //$log.debug(calculation, "calculation of IMSS in fiscal");
                        ngModel.$setViewValue(calculation);
                        ngModel.$render();
                    }
                };

                scope.$watchGroup(['F.constants'], function(newV, oldV){
                    if(newV[0]) calculate();
                });
            }
        }
    }

} ());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .directive('sheetRetirement', sheetRetirement);


    /** @ngInject */
    function sheetRetirement( $log) {
        return {
            require: '?ngModel',
            restrict: 'A',
            scope: {

            },
            link: function(scope, ele, attrs, ngModel) {
                var calculate = function() {
                   var total=0;
                    var calculation = {
                        data: {
                            //aqui van los datos que se regresa
                        },
                        formulas: [
                            //aqui van la formulas
                        ],
                        value: {
                            name: '',
                            total: total,
                            type: ''
                        }
                    };
                    ngModel.$setViewValue(calculation);
                    ngModel.$render();
                }


                // watchers de propiedades
                // scope.$watchGroup(['listen', 'listen2', 'listen3'], function(newV, oldV) {
                //     if (newV[0] && newV[1] && newV[2]) calculate();
                // });

                // watchers de arreglos
                // scope.$watch('deductions', function(deductions) {
                //     if (deductions && scope.sd) calculate();
                // }, true);
                //
                calculate()
            }
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .directive('sheetPtu', sheetPtu);


    /** @ngInject */
    function sheetPtu($log) {
        return {
            require: '?ngModel',
            restrict: 'A',
            scope: {

            },
            link: function(scope, ele, attrs, ngModel) {
                var calculate = function() {
                   var total=0;
                    var calculation = {
                        data: {
                            //aqui van los datos que se regresa
                        },
                        formulas: [
                            //aqui van la formulas
                        ],
                        value: {
                            name: '',
                            total: total,
                            type: ''
                        }
                    };
                    ngModel.$setViewValue(calculation);
                    ngModel.$render();
                }


                // watchers de propiedades
                // scope.$watchGroup(['listen', 'listen2', 'listen3'], function(newV, oldV) {
                //     if (newV[0] && newV[1] && newV[2]) calculate();
                // });

                // watchers de arreglos
                // scope.$watch('deductions', function(deductions) {
                //     if (deductions && scope.sd) calculate();
                // }, true);
                //
                calculate()
            }
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .directive('sheetPerceptionsFiscal', sheetPerceptionsFiscal);


    /** @ngInject */
    function sheetPerceptionsFiscal(incidenceAffectFilter, $log) {
        return {
            require: '?ngModel',
            restrict: 'AE',
            scope: {
                perceptions: '=',
                sd: '=',
                subsidy: '=',
                baseFiscalSalary: '='
            },
            link: function(scope, ele, attrs, ngModel) {
                var calculate = function() {
                    var perceptions = [];
                    var totalPerceptions = (scope.subsidy) ? scope.subsidy : 0;
                    totalPerceptions += scope.baseFiscalSalary;
                    for (var p in scope.perceptions) {
                        // si afecta dias sumar el dia 
                        var perception = angular.copy(scope.perceptions[p]);
                        var affectDays = incidenceAffectFilter(perception.incidenceType, 'days');
                        if (affectDays) {
                            perception.value = parseFloat(perception.value) * parseFloat(scope.sd);
                        } else {
                            perception.value = parseFloat(perception.value);
                        }
                        totalPerceptions += perception.value;
                        perceptions.push(perception);
                    }

                    var calculation = {
                        data: {
                            sd: scope.sd,
                            subsidy: scope.subsidy,
                            baseFiscalSalary: scope.baseFiscalSalary,
                            totalPerceptions: totalPerceptions,
                            perceptions: perceptions
                        },
                        formula: '$totalPerceptions = sum($perceptions) + $subsidy + $baseFiscalSalary',
                        value: {
                            name: 'Total de Percepciones',
                            total: totalPerceptions,
                            type: 'currency'
                        }
                    };

                    //$log.debug(calculation, "calculation for total Perceptions fiscal");
                    ngModel.$setViewValue(calculation);
                    ngModel.$render();
                }

                scope.$watchGroup(['sd', 'baseFiscalSalary', 'subsidy'], function(newV, oldV) {
                    if (angular.isDefined(newV[0]) && angular.isDefined(newV[1])) calculate();
                });

                scope.$watch('perceptions', function(perceptions) {
                    if (angular.isDefined(perceptions)) calculate();
                }, true);
                scope.$on("loaded", function() {
                    if (angular.isDefined(scope.sd) && angular.isDefined(scope.baseFiscalSalary) && angular.isDefined(perceptions)) calculate();
                })
            }
        }
    }

}());
(function () {
    'use strict';

    angular
        .module ('app.clients')
        .directive ('sheetLimit', sheetLimit);


    /** @ngInject */
    function sheetLimit(
        getDataOfProcessFilter, 
        $log
        ) {
        return {
            require: '?ngModel',
            restrict: 'A',
            scope: { // se meten aqui los datos que vaya a necesitar el cálculo
                paymentSchema: '=',
                complement: '='
            },
            link: function(scope, ele, attrs, ngModel){
                var calculate = function(){
                    if(scope.paymentSchema.hasOwnProperty('data')){
                        var dataOfProcess = getDataOfProcessFilter(scope.paymentSchema.data.processes, scope.complement);
                        if(dataOfProcess){
                            var limit = dataOfProcess.limit;
                            var calculation = {
                                data: {
                                    limit: limit
                                },
                                value: {
                                    name: 'Límite del proceso: ' + scope.complement,
                                    total: limit,
                                    type: 'currency'
                                }
                            };
                            //$log.debug(calculation, 'Limit Calculation of: ' + $scope.complement);
                            ngModel.$setViewValue(calculation);
                            ngModel.$render();
                        }   
                    }
                }

                // watchers de propiedades
                scope.$watch('paymentSchema', function(paymentSchema){
                    if(paymentSchema && scope.complement) calculate();
                }, true);

                scope.$watch('complement', function(complement){
                    if(complement && scope.paymentSchema) calculate;
                });
            }
        }
    }

} ());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .directive('sheetInfonatvit', sheetInfonatvit);


    /** @ngInject */
    function sheetInfonatvit($log, getIMSSRowFilter) {
        return {
            require: '?ngModel',
            restrict: 'A',
            scope: {
                sbc: '=',
                workedDays: '=',
                gravableBase: '=',
                calendarYear: '='
            },
            link: function(scope, ele, attrs, ngModel) {
                var calculate = function() {
                    //@todo sacar la info del registro de imss, preguntar como, llenar data y formulas :)
                    var imssRecord = getIMSSRowFilter(scope.calendarYear);
                    if (imssRecord) {
                        var imssFee = 1;
                        var patronalImss = 2;
                        var employeeImss = 3;
                        var netImss = patronalImss + employeeImss;
                        var calculation = {
                            data: {
                                imssFee: imssFee,
                                sbc: scope.sbc,
                                workedDays: scope.workedDays,
                                gravableBase: scope.gravableBase,
                                netImss: netImss,
                                employeeImss: employeeImss,
                                patronalImss: patronalImss
                            },
                            formula: '$netImss = $employeeImss + $patronalImss',
                            value: {
                                name: 'IMSS',
                                total: netImss,
                                type: 'currency'
                            }
                        }
                    }

                    //$log.debug(calculation, "calculation of IMSS in fiscal");
                    ngModel.$setViewValue(calculation);
                    ngModel.$render();
                };

                //@todo sacar la info del registro de imss, preguntar como, llenar data y formulas :)
                // scope.$watchGroup(['sbc','workedDays','gravableBase','calendarYear'], function(newV, oldV){
                //     if(newV[0] && newV[1] && newV[2] && newV[3]) calculate();
                //});
            }
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .directive('sheetInfonacot', sheetInfonacot);


    /** @ngInject */
    function sheetInfonacot($log) {
        return {
            require: '?ngModel',
            restrict: 'A',
            scope: {

            },
            link: function(scope, ele, attrs, ngModel) {
                var calculate = function() {
                    var total = 0;
                    var calculation = {
                        data: {
                            //aqui van los datos que se regresa
                        },
                        formulas: [
                            //aqui van la formulas
                        ],
                        value: {
                            name: '',
                            total: total,
                            type: ''
                        }
                    };
                    ngModel.$setViewValue(calculation);
                    ngModel.$render();
                }


                // watchers de propiedades
                // scope.$watchGroup(['listen', 'listen2', 'listen3'], function(newV, oldV) {
                //     if (newV[0] && newV[1] && newV[2]) calculate();
                // });

                // watchers de arreglos
                // scope.$watch('deductions', function(deductions) {
                //     if (deductions && scope.sd) calculate();
                // }, true);
                //
                calculate()
            }
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .directive('sheetIncapacitySubsidy', sheetIncapacitySubsidy);


    /** @ngInject */
    function sheetIncapacitySubsidy($log) {
        return {
            require: '?ngModel',
            restrict: 'A',
            scope: {

            },
            link: function(scope, ele, attrs, ngModel) {
                var calculate = function() {
                   var total=0;
                    var calculation = {
                        data: {
                            //aqui van los datos que se regresa
                        },
                        formulas: [
                            //aqui van la formulas
                        ],
                        value: {
                            name: '',
                            total: total,
                            type: ''
                        }
                    };
                    ngModel.$setViewValue(calculation);
                    ngModel.$render();
                }


                // watchers de propiedades
                // scope.$watchGroup(['listen', 'listen2', 'listen3'], function(newV, oldV) {
                //     if (newV[0] && newV[1] && newV[2]) calculate();
                // });

                // watchers de arreglos
                // scope.$watch('deductions', function(deductions) {
                //     if (deductions && scope.sd) calculate();
                // }, true);
                //
                calculate()
            }
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .directive('sheetIncapacityDiscount', sheetIncapacityDiscount);


    /** @ngInject */
    function sheetIncapacityDiscount($log) {
        return {
            require: '?ngModel',
            restrict: 'A',
            scope: {

            },
            link: function(scope, ele, attrs, ngModel) {
                var calculate = function() {
                    var total = 0;
                    var calculation = {
                        data: {
                            //aqui van los datos que se regresa
                        },
                        formulas: [
                            //aqui van la formulas
                        ],
                        value: {
                            name: '',
                            total: total,
                            type: ''
                        }
                    };
                    ngModel.$setViewValue(calculation);
                    ngModel.$render();
                }


                // watchers de propiedades
                // scope.$watchGroup(['listen', 'listen2', 'listen3'], function(newV, oldV) {
                //     if (newV[0] && newV[1] && newV[2]) calculate();
                // });

                // watchers de arreglos
                // scope.$watch('deductions', function(deductions) {
                //     if (deductions && scope.sd) calculate();
                // }, true);
                //
                calculate()
            }
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .directive('sheetHouseCredit', sheetHouseCredit);


    /** @ngInject */
    function sheetHouseCredit($log) {
        return {
            require: '?ngModel',
            restrict: 'A',
            scope: {

            },
            link: function(scope, ele, attrs, ngModel) {
                var calculate = function() {
                    var total = 0;
                    var calculation = {
                        data: {
                            //aqui van los datos que se regresa
                        },
                        formulas: [
                            //aqui van la formulas
                        ],
                        value: {
                            name: '',
                            total: total,
                            type: ''
                        }
                    };
                    ngModel.$setViewValue(calculation);
                    ngModel.$render();
                }


                // watchers de propiedades
                // scope.$watchGroup(['listen', 'listen2', 'listen3'], function(newV, oldV) {
                //     if (newV[0] && newV[1] && newV[2]) calculate();
                // });

                // watchers de arreglos
                // scope.$watch('deductions', function(deductions) {
                //     if (deductions && scope.sd) calculate();
                // }, true);
                //
                calculate()
            }
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .directive('sheetHolidayBonus', sheetHolidayBonus);


    /** @ngInject */
    function sheetHolidayBonus($log) {
        return {
            require: '?ngModel',
            restrict: 'A',
            scope: {

            },
            link: function(scope, ele, attrs, ngModel) {
                var calculate = function() {
                   var total=0;
                    var calculation = {
                        data: {
                            //aqui van los datos que se regresa
                        },
                        formulas: [
                            //aqui van la formulas
                        ],
                        value: {
                            name: '',
                            total: total,
                            type: ''
                        }
                    };
                    ngModel.$setViewValue(calculation);
                    ngModel.$render();
                }


                // watchers de propiedades
                // scope.$watchGroup(['listen', 'listen2', 'listen3'], function(newV, oldV) {
                //     if (newV[0] && newV[1] && newV[2]) calculate();
                // });

                // watchers de arreglos
                // scope.$watch('deductions', function(deductions) {
                //     if (deductions && scope.sd) calculate();
                // }, true);
                //
                calculate()
            }
        }
    }

}());
(function () {
    'use strict';

    angular
        .module ('app.clients')
        .directive ('sheetGravableBaseComplement', sheetGravableBaseComplement);


    /** @ngInject */
    function sheetGravableBaseComplement(
        piramidateISRFilter, 
        $log
    ) {
        return {
            require: '?ngModel',
            restrict: 'A',
            scope: { // se meten aqui los datos que vaya a necesitar el cálculo
                realNet: '=',
                fiscalNet: '=',
                complementLimit: '=',
                asimilatedTotal: '=',
                socialPrevisionTotal: '='
            },
            link: function(scope, ele, attrs, ngModel){
                var calculate = function(){
                    var toReach = scope.realNet - scope.fiscalNet;
                    var toReachReal = (toReach > scope.complementLimit) ? scope.complementLimit : toReach;
                    var subTotal = 0;
                    if(scope.asimilatedTotal){
                        subTotal = scope.asimilatedTotal;
                    } else if(scope.socialPrevisionTotal){
                        subTotal = scope.socialPrevisionTotal;
                    } else {
                        subTotal = angular.copy(toReachReal);
                    }
                    var complementISRRow = piramidateISRFilter(subTotal);
                    if(complementISRRow){
                        var gravableBase = complementISRRow.newSubTotal;
                        var complementExcedent = (gravableBase > scope.complementLimit) ? gravableBase - scope.complementLimit : 0;
                        var incidencesApplied = {}; // @todo incidencesAppliedFilter(allIncidences); // filter from all incidences (not fiscal + difference)
                        var calculation = {
                            data: {
                                realNet: scope.realNet,
                                fiscalNet: scope.fiscalNet,
                                complementLimit: scope.complementLimit,
                                complementExcedent: complementExcedent,
                                toReach: toReach,
                                toReachReal: toReachReal,
                                incidencesApplied: incidencesApplied,
                                gravableBase: gravableBase,
                                piramidalISR: complementISRRow
                            },
                            formulas: [
                                '$toReach = $realNet - $fiscalNet',
                                '$toReachReal = ($gravableBase > $complementLimit) ? $complementLimit : $gravableBase',
                                '$gravableBase = piramidateISR($toReachReal)',
                                '$complementExcedent = ($gravableBase > $complementLimit) ? $gravableBase - $complementLimit : 0'
                            ],
                            value: {
                                name: 'Base Gravable de Complemento',
                                total: gravableBase,
                                type: 'currency'
                            }
                        };
                        //$log.debug(calculation, 'Gravable Base Calculation');
                        ngModel.$setViewValue(calculation);
                        ngModel.$render();
                    }
                }

                // watchers de propiedades
                scope.$watchGroup(['realNet','fiscalNet', 'complementLimit'], function(newV, oldV){
                    if(angular.isDefined(newV[0]) && angular.isDefined(newV[1]) && angular.isDefined(newV[2])) calculate();
                });

                scope.$watchGroup(['asimilatedTotal', 'socialPrevisionTotal'], function(newV, oldV){
                    if(angular.isDefined(newV[0]) || angular.isDefined(newV[1])){
                        if(angular.isDefined(scope.realNet) && angular.isDefined(scope.fiscalNet) && angular.isDefined(scope.complementLimit)) calculate();
                    }
                });

            }
        }
    }

} ());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .directive('sheetFederalIncomeByOwn', sheetFederalIncomeByOwn);


    /** @ngInject */
    function sheetFederalIncomeByOwn( $log) {
        return {
            require: '?ngModel',
            restrict: 'A',
            scope: {

            },
            link: function(scope, ele, attrs, ngModel) {
                var calculate = function() {
                   var total=0;
                    var calculation = {
                        data: {
                            //aqui van los datos que se regresa
                        },
                        formulas: [
                            //aqui van la formulas
                        ],
                        value: {
                            name: '',
                            total: total,
                            type: ''
                        }
                    };
                    ngModel.$setViewValue(calculation);
                    ngModel.$render();
                }


                // watchers de propiedades
                // scope.$watchGroup(['listen', 'listen2', 'listen3'], function(newV, oldV) {
                //     if (newV[0] && newV[1] && newV[2]) calculate();
                // });

                // watchers de arreglos
                // scope.$watch('deductions', function(deductions) {
                //     if (deductions && scope.sd) calculate();
                // }, true);
                //
                calculate()
            }
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .directive('sheetFederalIncomeByOwnFederal', sheetFederalIncomeByOwnFederal);


    /** @ngInject */
    function sheetFederalIncomeByOwnFederal($log) {
        return {
            require: '?ngModel',
            restrict: 'A',
            scope: {

            },
            link: function(scope, ele, attrs, ngModel) {
                var calculate = function() {
                    var total = 0;
                    var calculation = {
                        data: {
                            //aqui van los datos que se regresa
                        },
                        formulas: [
                            //aqui van la formulas
                        ],
                        value: {
                            name: '',
                            total: total,
                            type: ''
                        }
                    };
                    ngModel.$setViewValue(calculation);
                    ngModel.$render();
                }


                // watchers de propiedades
                // scope.$watchGroup(['listen', 'listen2', 'listen3'], function(newV, oldV) {
                //     if (newV[0] && newV[1] && newV[2]) calculate();
                // });

                // watchers de arreglos
                // scope.$watch('deductions', function(deductions) {
                //     if (deductions && scope.sd) calculate();
                // }, true);
                //
                calculate()
            }
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .directive('sheetFederalIncomeByFederal', sheetFederalIncomeByFederal);


    /** @ngInject */
    function sheetFederalIncomeByFederal($log) {
        return {
            require: '?ngModel',
            restrict: 'A',
            scope: {

            },
            link: function(scope, ele, attrs, ngModel) {
                var calculate = function() {
                    var total = 0;
                    var calculation = {
                        data: {
                            //aqui van los datos que se regresa
                        },
                        formulas: [
                            //aqui van la formulas
                        ],
                        value: {
                            name: '',
                            total: total,
                            type: ''
                        }
                    };
                    ngModel.$setViewValue(calculation);
                    ngModel.$render();
                }


                // watchers de propiedades
                // scope.$watchGroup(['listen', 'listen2', 'listen3'], function(newV, oldV) {
                //     if (newV[0] && newV[1] && newV[2]) calculate();
                // });

                // watchers de arreglos
                // scope.$watch('deductions', function(deductions) {
                //     if (deductions && scope.sd) calculate();
                // }, true);
                //
                calculate()
            }
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .directive('sheetEnsureLifeBonus', sheetEnsureLifeBonus);


    /** @ngInject */
    function sheetEnsureLifeBonus($log) {
        return {
            require: '?ngModel',
            restrict: 'A',
            scope: {

            },
            link: function(scope, ele, attrs, ngModel) {
                var calculate = function() {
                   var total=0;
                    var calculation = {
                        data: {
                            //aqui van los datos que se regresa
                        },
                        formulas: [
                            //aqui van la formulas
                        ],
                        value: {
                            name: '',
                            total: total,
                            type: ''
                        }
                    };
                    ngModel.$setViewValue(calculation);
                    ngModel.$render();
                }


                // watchers de propiedades
                // scope.$watchGroup(['listen', 'listen2', 'listen3'], function(newV, oldV) {
                //     if (newV[0] && newV[1] && newV[2]) calculate();
                // });

                // watchers de arreglos
                // scope.$watch('deductions', function(deductions) {
                //     if (deductions && scope.sd) calculate();
                // }, true);
                //
                calculate()
            }
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .directive('sheetDeductionsFiscal', sheetDeductionsFiscal);


    /** @ngInject */
    function sheetDeductionsFiscal(incidenceAffectFilter, $log) {
        return {
            require: '?ngModel',
            restrict: 'AE',
            scope: {
                imss: '=',
                sd: '=',
                isr: '='
            },
            link: function(scope, ele, attrs, ngModel) {
                var calculate = function() {
                    var deductions = [];
                    var totalDeductions = (scope.isr) ? scope.isr : 0;
                    scope.imss = scope.imss ? scope.imss : 0
                    totalDeductions+=scope.imss;
                    var calculation = {
                        data: {
                            totalDeductions: totalDeductions,
                            deductions: deductions,
                            isr: scope.isr
                        },
                        formula: '$totalDeductions = sum($deductions) + $isr',
                        value: {
                            name: 'Total de Deducciones',
                            total: totalDeductions,
                            type: 'currency'
                        }
                    };
                    //$log.debug('accumulated deductions', calculation);
                    ngModel.$setViewValue(calculation);
                    ngModel.$render();
                }

                scope.$watchGroup(['sd', 'imss', 'isr'], function(newV, oldV) {
                    if (angular.isDefined(newV[0])) scope.$emit("loaded");
                });

                scope.$on("loaded", function() {
                    if (angular.isDefined(scope.sd)) calculate();
                })

            }
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .directive('sheetComplementIsr', sheetComplementIsr);


    /** @ngInject */
    function sheetComplementIsr($log,piramidateISRFilter) {
        return {
            require: '?ngModel',
            restrict: 'A',
            scope: { // se meten aqui los datos que vaya a necesitar el cálculo
                gravableBase: '='
            },
            link: function(scope, ele, attrs, ngModel) {
                var calculate = function() {
                    var complementISRRow = piramidateISRFilter(scope.gravableBase);
                    if (complementISRRow) {
                        var calculation = {
                            data: {
                                fixedFee: complementISRRow.fixedFee,
                                marginalTax: complementISRRow.marginalTax,
                                isr: complementISRRow.isr
                            },
                            value: {
                                name: 'ISR de Complemento',
                                total: complementISRRow.isr,
                                type: 'currency'
                            }
                        };

                        //$log.debug(calculation, 'Asimilated Calculation');
                        ngModel.$setViewValue(calculation);
                        ngModel.$render();
                    }
                }

                // watchers de propiedades
                scope.$watch(['gravableBase'], function(gravableBase) {
                    if (angular.isDefined(gravableBase)) calculate();
                },true);
            }
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .directive('sheetChristmasBonus', sheetChristmasBonus);


    /** @ngInject */
    function sheetChristmasBonus($log) {
        return {
            require: '?ngModel',
            restrict: 'A',
            scope: {

            },
            link: function(scope, ele, attrs, ngModel) {
                var calculate = function() {
                   var total=0;
                    var calculation = {
                        data: {
                            //aqui van los datos que se regresa
                        },
                        formulas: [
                            //aqui van la formulas
                        ],
                        value: {
                            name: '',
                            total: total,
                            type: ''
                        }
                    };
                    ngModel.$setViewValue(calculation);
                    ngModel.$render();
                }


                // watchers de propiedades
                // scope.$watchGroup(['listen', 'listen2', 'listen3'], function(newV, oldV) {
                //     if (newV[0] && newV[1] && newV[2]) calculate();
                // });

                // watchers de arreglos
                // scope.$watch('deductions', function(deductions) {
                //     if (deductions && scope.sd) calculate();
                // }, true);
                //
                calculate()
            }
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .directive('sheetBaseReal', sheetBaseReal);


    /** @ngInject */
    function sheetBaseReal() {
        return {
            require: '?ngModel',
            restrict: 'A',
            scope: {
                sdr: '=',
                workedDays: '=',
                dataloaded: '='
            },
            link: function(scope, ele, attrs, ngModel) {
                var calculate = function() {
                    var baseRealSalary = parseFloat(scope.sdr) * parseInt(scope.workedDays);
                    var calculation = {
                        data: {
                            sdr: scope.sdr,
                            workedDays: scope.workedDays,
                            baseRealSalary: baseRealSalary
                        },
                        formula: '$baseRealSalary = $sdr * $workedDays',
                        value: {
                            name: 'Salario Base Real',
                            total: baseRealSalary,
                            type: 'currency'
                        }
                    };
                    ngModel.$setViewValue(calculation);
                    ngModel.$render();
                };

                var startWatchers = function(ignoreFirst) {
                    var ignoreFirsts = {
                        workedDays: ignoreFirst
                    }
                    // scope.$watch("sdr", function(sdr) {
                    //     if (angular.isDefined(sdr) && angular.isDefined(scope.workedDays)) calculate();
                    // }, true)
                    scope.$watch("workedDays", function(workedDays) {
                        if (angular.isDefined(workedDays)) {
                            if (ignoreFirsts.workedDays) ignoreFirsts.workedDays = false;
                            else calculate();
                        }
                    }, true)
                }

                var listenerDataLoaded = scope.$watch('dataloaded', function(dataloaded) {
                    if (dataloaded) {
                        if (angular.isDefined(scope.workedDays)) {
                            calculate();
                            startWatchers(true);
                        } else {
                            startWatchers(false);
                        }
                        listenerDataLoaded();
                    }
                });


            }
        }
    }
}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .directive('sheetAsimilated', sheetAsimilated);

    /** @ngInject */
    function sheetAsimilated(
        $log,
        piramidateISRFilter
    ) {
        return {
            require: '?ngModel',
            restrict: 'A',
            scope: { // se meten aqui los datos que vaya a necesitar el cálculo
                gravableBase: '='
            },
            link: function(scope, ele, attrs, ngModel) {
                var calculate = function() {
                    var asimilatedISRRow = piramidateISRFilter(scope.gravableBase);
                    if (asimilatedISRRow) {
                        var isr = asimilatedISRRow.isr;
                        var subTotal = asimilatedISRRow.newSubTotal;
                        var total = asimilatedISRRow.newTotal;

                        var calculation = {
                            data: {
                                fixedFee: asimilatedISRRow.fixedFee,
                                marginalTax: asimilatedISRRow.marginalTax,
                                isr: isr,
                                subTotal: subTotal,
                                total: total
                            },
                            value: {
                                name: 'Asimilados',
                                total: subTotal,
                                type: 'currency'
                            }
                        };
                        //$log.debug(calculation, 'Asimilated Calculation');
                        ngModel.$setViewValue(calculation);
                        ngModel.$render();
                    }
                }

                // watchers de propiedades
                scope.$watch('gravableBase', function(gravableBase) {
                    if (angular.isDefined(gravableBase)) calculate();
                }, true);
            }
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .directive('sheetAntiquityBonus', sheetAntiquityBonus);


    /** @ngInject */
    function sheetAntiquityBonus($log) {
        return {
            require: '?ngModel',
            restrict: 'A',
            scope: {

            },
            link: function(scope, ele, attrs, ngModel) {
                var calculate = function() {
                    var total = 0;
                    
                    var calculation = {
                        data: {
                            //aqui van los datos que se regresa
                        },
                        formulas: [
                            //aqui van la formulas
                        ],
                        value: {
                            name: '',
                            total: total,
                            type: ''
                        }
                    };
                    ngModel.$setViewValue(calculation);
                    ngModel.$render();
                }


                // watchers de propiedades
                // scope.$watchGroup(['listen', 'listen2', 'listen3'], function(newV, oldV) {
                //     if (newV[0] && newV[1] && newV[2]) calculate();
                // });

                // watchers de arreglos
                // scope.$watch('deductions', function(deductions) {
                //     if (deductions && scope.sd) calculate();
                // }, true);
                //
                calculate()
            }
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .directive('sheetAdminServices', sheetAdminServices);


    /** @ngInject */
    function sheetAdminServices($log) {
        return {
            require: '?ngModel',
            restrict: 'A',
            scope: { // se meten aqui los datos que vaya a necesitar el cálculo
                realSalary: '=',
                payroll:'='
            },
            link: function(scope, ele, attrs, ngModel) {
                var calculate = function() {
                    var adminServicesPercent=angular.isDefined(scope.payroll.data)&&angular.isDefined(scope.payroll.data.fee)?scope.payroll.data.fee:0
                    adminServicesPercent=adminServicesPercent/100;
                    var total = scope.realSalary * adminServicesPercent; // @todo:carlos hacer bien la funcion que checa salarios por dia
                    var total=Math.round(total*100)/100;
                    var calculation = {
                        data: {
                            realSalary: scope.realSalary ,
                            adminServicesPercent: adminServicesPercent
                        },
                        formula: '$adminServices = $realSalary * $adminServicesPercent',
                        value: {
                            name: 'Servicios Administrativos',
                            total: total,
                            type: 'currency'
                        }
                    };
                    //$log.debug(calculation, 'total salary Calculation');
                    ngModel.$setViewValue(calculation);
                    ngModel.$render();
                }

                // watchers de propiedades
                scope.$watch("payroll",function(payroll){
                    if (angular.isDefined(payroll)) scope.$emit("loaded");
                },true)

                scope.$watchGroup(['realSalary'], function(newV, oldV) {
                    if (angular.isDefined(newV[0])) scope.$emit("loaded");
                });
                scope.$on("loaded",function(){
                    if(angular.isDefined(scope.payroll)&&angular.isDefined(scope.realSalary))calculate();
                })
            }
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .directive('sheetImssBoss', sheetImssBoss);


    /** @ngInject */
    function sheetImssBoss(
        getIMSSRowLastFilter,
        directiveListenersFilter,
        AppF
    ) {
        return {
            require: '?ngModel',
            restrict: 'A',
            scope: {
                sbc: '<',
                calendar: '<',
                workedDays: '<',
                imssRecords: '<',
                rp: '<',
                employeeId: '<',
                notCalculate: '<',
                dataloaded: '<',
                constants: '<',
                directiveFunctions: '=',
                process: '@',
                needToBalance: '<',
                incidenceId: '<',
                exceeded: '<',
                employeeCalculations: '<',
                minimumVariables: '<',
                umaRecord: '<'
            },
            link: function (scope, ele, attrs, ngModel) {
                scope.calculate = function () {
                    var imssRecord = getIMSSRowLastFilter(scope.calendar, scope.imssRecords);
                    scope.sbc = scope.sbc ? scope.sbc : 0;
                    scope.workedDays = scope.workedDays ? scope.workedDays : 0;
                    scope.smdf = scope.minimumVariables.A;

                    var fixedFeePercent = imssRecord.fixedFee ? imssRecord.fixedFee : 0;
                    var excessPercent = imssRecord.bossExcess ? imssRecord.bossExcess : 0;
                    var benefitsPercent = imssRecord.bossBenefits ? imssRecord.bossBenefits : 0;
                    var gmpPercent = imssRecord.gmpBoss ? imssRecord.gmpBoss : 0;
                    var ivPercent = imssRecord.ivaBoss ? imssRecord.ivaBoss : 0;
                    var riskPrimePercent = 0;
                    if (angular.isDefined(scope.rp)) {
                        if (angular.isDefined(scope.rp.data)) {
                            var riskPrimePercent = angular.isDefined(scope.rp.data.riskPrime) ? scope.rp.data.riskPrime : 0;
                        }
                    }

                    var daycarePercent = imssRecord.daycare ? imssRecord.daycare : 0;
                    var retirementPercent = imssRecord.retirement ? imssRecord.retirement : 0;
                    var cyvPercent = imssRecord.cyvBoss ? imssRecord.cyvBoss : 0;
                    var infonavitPercent = imssRecord.infonavit ? imssRecord.infonavit : 0;

                    fixedFeePercent = parseFloat(fixedFeePercent ? fixedFeePercent : 0) / 100;
                    excessPercent = parseFloat(excessPercent ? excessPercent : 0) / 100;
                    benefitsPercent = parseFloat(benefitsPercent ? benefitsPercent : 0) / 100;
                    gmpPercent = parseFloat(gmpPercent ? gmpPercent : 0) / 100;
                    ivPercent = parseFloat(ivPercent ? ivPercent : 0) / 100;
                    riskPrimePercent = parseFloat(riskPrimePercent ? riskPrimePercent : 0) / 100;
                    daycarePercent = parseFloat(daycarePercent ? daycarePercent : 0) / 100;
                    retirementPercent = parseFloat(retirementPercent ? retirementPercent : 0) / 100;
                    cyvPercent = parseFloat(cyvPercent ? cyvPercent : 0) / 100;
                    infonavitPercent = parseFloat(infonavitPercent ? infonavitPercent : 0) / 100;

                    var fixedFee = scope.smdf * scope.workedDays * fixedFeePercent;

                    var excess = (scope.sbc > (scope.smdf * 3)) ? (scope.sbc - (scope.smdf * 3)) * (excessPercent * scope.workedDays) : 0;

                    var benefits = scope.sbc * scope.workedDays * benefitsPercent;
                    var gmp = scope.sbc * scope.workedDays * gmpPercent;
                    var iv = scope.sbc * scope.workedDays * ivPercent;
                    var riskPrime = scope.sbc * scope.workedDays * riskPrimePercent;
                    var dayCare = scope.sbc * scope.workedDays * daycarePercent;
                    var retirement = scope.sbc * scope.workedDays * retirementPercent;
                    var cyv = scope.sbc * scope.workedDays * cyvPercent;
                    var infonavit = scope.sbc * scope.workedDays * infonavitPercent;
                    var total = fixedFee + excess + benefits + gmp + iv + riskPrime + dayCare + retirement + cyv + infonavit;

                    fixedFee = Math.round(fixedFee * 100) / 100
                    excess = Math.round(excess * 100) / 100
                    benefits = Math.round(benefits * 100) / 100
                    gmp = Math.round(gmp * 100) / 100
                    iv = Math.round(iv * 100) / 100
                    riskPrime = Math.round(riskPrime * 100) / 100
                    dayCare = Math.round(dayCare * 100) / 100
                    retirement = Math.round(retirement * 100) / 100
                    cyv = Math.round(cyv * 100) / 100
                    infonavit = Math.round(infonavit * 100) / 100
                    total = Math.round(total * 100) / 100

                    var calculation = {
                        data: {
                            fixedFeePercent: fixedFeePercent,
                            fixedFee: fixedFee,
                            excessPercent: excessPercent,
                            excess: excess,
                            benefitsPercent: benefitsPercent,
                            benefits: benefits,
                            gmpPercent: gmpPercent,
                            gmp: gmp,
                            ivPercent: ivPercent,
                            iv: iv,
                            riskPrimePercent: riskPrimePercent,
                            riskPrime: riskPrime,
                            daycarePercent: daycarePercent,
                            dayCare: dayCare,
                            retirementPercent: retirementPercent,
                            retirement: retirement,
                            cyvPercent: cyvPercent,
                            cyv: cyv,
                            infonavitPercent: infonavitPercent,
                            infonavit: infonavit,
                            total: total,
                            workedDays: scope.workedDays
                        },
                        formula: '',
                        value: {
                            name: 'IMSS',
                            total: total,
                            type: 'currency',
                            nature: 'perception',
                            addToTotal: true,
                            incidence: true,
                            weight: 10
                        }
                    };
                    scope.totalCalculations = total;
                    scope.calculationsResults = {};
                    scope.calculationsResults[scope.incidenceId] = {
                        "value": total,
                        "from": "REAL",
                        "isFiscal": true
                    }
                    //$log.debug(scope, calculation, "calculation of IMSS Worker")
                    // ngModel.$setViewValue(calculation);
                    // ngModel.$render();
                    return calculation;
                };
                var objsToWatch = ['calendar', 'sbc', 'workedDays', 'imssRecords', 'rp'];
                var directiveId = directiveListenersFilter(ngModel, 'Imss Boss Directive', scope, scope.process, 'fifth', objsToWatch, scope.directiveFunctions);
            }
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .directive('sheetSocialPrevision', sheetSocialPrevision);

    /** @ngInject */
    function sheetSocialPrevision(directiveListenersFilter, getApplyToEmployeeCalculationsFilter, getTotalOfArrayFieldFilter, pathInObjFilter) {
        return {
            require: '?ngModel',
            restrict: 'A',
            scope: { // se meten aqui los datos que vaya a necesitar el cálculo
                totalSalary: '<',
                fiscalSalary: '<',
                returnedConcepts: '<',
                employeeId: '<',
                notCalculate: '<',
                dataloaded: '<',
                constants: '<',
                directiveFunctions: '=',
                process: '@',
                needToBalance: '<',
                exceeded: '<',
                calculationsResults: '<'
            },
            link: function(scope, ele, attrs, ngModel) {
                // console.log(scope.employeeId);
                // console.log(scope.process);
                // console.log(scope.notCalculate);
                // console.log(scope.dataloaded);
                // console.log(scope.directiveFunctions);
                scope.calculate = function() {
                    //console.log(scope.returnedConcepts);
                    var totalCalculations = getTotalOfArrayFieldFilter(scope.calculationsResults, "value");
                    var totalSalary = scope.totalSalary && !isNaN(scope.totalSalary) ? scope.totalSalary : 0;
                    var fiscalSalary = scope.fiscalSalary && !isNaN(scope.fiscalSalary) ? scope.fiscalSalary : 0;
                    var applyToEmployeeCalculations = getApplyToEmployeeCalculationsFilter(scope.returnedConcepts);
                    var toAdd = {};
                    var toRest = {};
                    for (var index in applyToEmployeeCalculations) {
                        var thisCalc = applyToEmployeeCalculations[index];
                        var applyType = pathInObjFilter(thisCalc, "value.applyType");
                        if (applyType == "charge") {
                            toRest[index] = thisCalc;
                        } else if (applyType == "return") {
                            toAdd[index] = thisCalc;
                        }
                    }
                    //console.log(othersToAdd);
                    var othersToAdd = getTotalOfArrayFieldFilter(toAdd, "value.total");
                    var othersToRest = getTotalOfArrayFieldFilter(toRest, "value.total");
                    var total = totalSalary - fiscalSalary + othersToAdd - othersToRest + totalCalculations;
                    if (total > 0) {
                        total = Math.round(total * 100) / 100
                    }
                    if (totalCalculations > 0) {
                        totalCalculations = Math.round(totalCalculations * 100) / 100
                    }
                    if (othersToAdd > 0) {
                        othersToAdd = Math.round(othersToAdd * 100) / 100
                    }
                    if (othersToRest > 0) {
                        othersToRest = Math.round(othersToRest * 100) / 100
                    }
                    var calculation = {
                        data: {
                            totalSalary: totalSalary,
                            fiscalSalary: fiscalSalary,
                            othersToAdd: othersToAdd,
                            othersToRest: othersToRest,
                            othersIncidences: totalCalculations,
                            calculationsResults: scope.calculationsResults
                        },
                        formulas: [
                            "$totalSalary-$fiscalSalary+$othersToAdd-$othersToRest"
                        ],
                        value: {
                            name: 'Previsión Social',
                            total: total,
                            type: 'currency',
                            addToTotal: true,
                            incidence: false,
                            weight: 3,
                            nature: "perception"
                        }
                    };
                    //$log.debug(calculation, 'Social Prevision Calculation');
                    // ngModel.$setViewValue(calculation);
                    // ngModel.$render();
                    return calculation;
                }
                var objsToWatch = ['totalSalary', 'fiscalSalary', 'returnedConcepts', 'calculationsResults'];
                var filtersObjsToWatch = {
                    returnedConcepts: {
                        filter: 'getApplyToEmployeeCalculations',
                        param: ''
                    }
                }
                var directiveId = directiveListenersFilter(ngModel, 'Social Prevision Directive', scope, scope.process, 'second', objsToWatch, scope.directiveFunctions, filtersObjsToWatch);
            }
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .directive('sheetTotalReal', sheetTotalReal);


    /** @ngInject */
    function sheetTotalReal(
        translateFilter,
        directiveListenersFilter,
        $rootScope
    ) {
        return {
            require: '?ngModel',
            restrict: 'A',
            scope: {
                baseRealSalary: '<',
                totalPerceptions: '<',
                totalDeductions: '<',
                employeeId: '<',
                notCalculate: '<',
                dataloaded: '<',
                constants: '<',
                directiveFunctions: '=',
                process: '@',
                needToBalance:'<',
                exceeded:'<'
            },
            link: function(scope, ele, attrs, ngModel) {
                scope.calculate = function() {
                    var netRealSalary = scope.totalPerceptions - scope.totalDeductions;
                    var calculation = {
                        data: {
                            baseRealSalary: scope.baseRealSalary,
                            totalPerceptions: scope.totalPerceptions,
                            totalDeductions: scope.totalDeductions,
                            netRealSalary: netRealSalary,
                        },
                        formula: '$netRealSalary = $baseRealSalary + $totalPerceptions - $totalDeductions',
                        value: {
                            name: translateFilter('c.TOTAL_REAL'),
                            total: netRealSalary,
                            type: 'currency',
                            weight: 50
                        }
                    };
                    // ngModel.$setViewValue(calculation);
                    // ngModel.$render();
                    return calculation;
                };
                var objsToWatch = ['baseRealSalary', 'totalPerceptions', 'totalDeductions'];
                var directiveId = directiveListenersFilter(ngModel, 'Total Real Directive', scope, scope.process, 'seventh', objsToWatch, scope.directiveFunctions);
            }
        };
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .directive('sheetTotalFiscal', sheetTotalFiscal);


    /** @ngInject */
    function sheetTotalFiscal(
        directiveListenersFilter,
        $rootScope,
        setInObjectPathFilter,
        AppF
    ) {
        return {
            require: '?ngModel',
            restrict: 'A',
            scope: {
                baseRealSalary: '<',
                perceptions: '<',
                deductions: '<',
                employeeId: '<',
                notCalculate: '<',
                dataloaded: '<',
                constants: '<',
                directiveFunctions: '=',
                process: '@',
                needToBalance: '<',
                exceeded: '<'
            },
            link: function(scope, ele, attrs, ngModel) {
                scope.calculate = function() {
                    var netFiscalSalary = scope.perceptions - scope.deductions;
                    var calculation = {
                        data: {
                            //baseFiscalSalary: scope.baseFiscalSalary,
                            netFiscalSalary: netFiscalSalary,
                            perceptions: scope.perceptions,
                            deductions: scope.deductions
                        },
                        formula: '$netFiscalSalary = $perceptions-$deductions',
                        value: {
                            name: 'Salario Neto Fiscal',
                            total: netFiscalSalary,
                            type: 'currency',
                            weight: 50
                        }
                    };
                    //$log.debug(calculation, "calculation of net salary fiscal");
                    // ngModel.$setViewValue(calculation);
                    // ngModel.$render();
                    return calculation;

                }
                var objsToWatch = ['baseRealSalary', 'perceptions', 'deductions'];
                var directiveId = directiveListenersFilter(ngModel, 'Total Fiscal Directive', scope, scope.process, 'seventh', objsToWatch, scope.directiveFunctions);

            }
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .directive('sheetTotalComplement', sheetTotalComplement);


    /** @ngInject */
    function sheetTotalComplement(
        translateFilter,
        directiveListenersFilter,
        setInObjectPathFilter,
        AppF
    ) {
        return {
            require: '?ngModel',
            restrict: 'A',
            scope: {
                totalPerceptions: '<',
                totalDeductions: '<',
                employeeId: '<',
                notCalculate: '<',
                dataloaded: '<',
                constants: '<',
                directiveFunctions: '=',
                process: '@',
                needToBalance: '<',
                exceeded: '<'
            },
            link: function(scope, ele, attrs, ngModel) {
                scope.calculate = function() {
                    var netRealSalary = scope.totalPerceptions - scope.totalDeductions;
                    var calculation = {
                        data: {
                            totalPerceptions: scope.totalPerceptions,
                            totalDeductions: scope.totalDeductions
                        },
                        formula: '$netRealSalary = $baseRealSalary + $totalPerceptions - $totalDeductions',
                        value: {
                            name: translateFilter('c.TOTAL_REAL'),
                            total: netRealSalary,
                            type: 'currency',
                            weight: 50
                        }
                    };
                    return calculation;
                };
                var objsToWatch = ['totalPerceptions', 'totalDeductions'];
                var directiveId = directiveListenersFilter(ngModel, 'Total Complement Directive', scope, scope.process, 'seventh', objsToWatch, scope.directiveFunctions);
            }
        };
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .directive('sheetDeductionsReal', sheetDeductionsReal);


    /** @ngInject */
    function sheetDeductionsReal(
        translateFilter,
        directiveListenersFilter,
        getTotalOfCalculationsFilter
    ) {
        return {
            require: '?ngModel',
            restrict: 'AE',
            scope: {
                calculations: '<',
                employeeId: '<',
                notCalculate: '<',
                dataloaded: '<',
                constants: '<',
                directiveFunctions: '=',
                process: '@',
                needToBalance: '<',
                exceeded: '<'
            },
            link: function(scope, ele, attrs, ngModel) {
                scope.calculate = function() {
                    //console.log(scope.calculations);
                    var totals = getTotalOfCalculationsFilter(scope.calculations, "deduction");
                    var totalDeductions = Math.round(totals.total * 100) / 100;
                    var onlyIncidencesAmount = Math.round(totals.onlyIncidencesAmount * 100) / 100;;
                    var calculation = {
                        data: {
                            onlyIncidencesAmount: onlyIncidencesAmount
                        },
                        value: {
                            name: translateFilter('c.TOTAL_DEDUCTIONS'),
                            total: totalDeductions,
                            type: 'currency',
                            weight: 40
                        }
                    };
                    // ngModel.$setViewValue(calculation);
                    // ngModel.$render();
                    return calculation;
                };
                var objsToWatch = ['calculations'];
                var filtersObjsToWatch = {
                    calculations: {
                        filter: 'getTotalOfCalculations',
                        param: "deduction"
                    }
                };
                var directiveId = directiveListenersFilter(ngModel, 'Deductions Real Directive', scope, scope.process, 'sixth', objsToWatch, scope.directiveFunctions, filtersObjsToWatch);
            }
        };
    }
}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .directive('sheetSimpleFiscal', sheetSimpleFiscal);


    /** @ngInject */
    function sheetSimpleFiscal(
        calculateTotalFilter,
        getTotalByConstantFilter,
        getSomethingOfArrayFBFilter,
        directiveListenersFilter,
        getTotalOfArrayFieldFilter
    ) {
        return {
            require: '?ngModel',
            restrict: 'A',
            scope: {
                incidences: '<',
                calculationsResults: '<',
                incidenceId: '<',
                incidencesTypes: '<',
                constantsByValue: '<',
                employee: '<',
                payroll: '<',
                operation: '<',
                minimumVariables: '<',
                umaRecord: '<',
                nfdRecord: '<',
                calcFields: '<',
                employeeId: '<',
                notCalculate: '<',
                dataloaded: '<',
                constants: '<',
                directiveFunctions: '=',
                process: '@',
                nature: '@',
                needToBalance: '<',
                exceeded: '<',
                employeeCalculations: '<'
            },
            link: function (scope, ele, attrs, ngModel) {
                scope.calculate = function () {
                    // console.log(scope.calculationsResults)
                    //variables que se podran editar en la incidencia que afecta propiedad
                    var totalIncidences = calculateTotalFilter(scope.incidences);
                    scope.totalCalculations = getTotalOfArrayFieldFilter(scope.calculationsResults, "value");
                    //variables globales
                    var formula = '';
                    var data = {};
                    var total = 0;
                    //si hacen las validaciones correspondientes
                    if (scope.constantsByValue) {
                        // valor, constant, type, formula, fields, employee, payroll, operation, umaRecord, nfdRecord, minimumVariables, constants
                        var constantByValue = getTotalByConstantFilter(totalIncidences, scope.constantsByValue, 'valor', '$totalIncidencias', scope.calcFields, scope.employee, scope.payroll, scope.operation, scope.umaRecord, scope.nfdRecord, scope.minimumVariables, scope.constants);
                        total = constantByValue.total;
                        formula = constantByValue.formula;
                        data.incidences = scope.incidences;
                        data.totalIncidences = totalIncidences;
                    } else {
                        total = scope.totalCalculations;
                        formula = '$totalCalculos';
                        data.calculationsResults = scope.calculationsResults;
                        //se añade los datos de data que se ocuparon para calcular
                    }
                    var calculation = {
                        data: data,
                        formula: formula,
                        value: {
                            nature: scope.nature,
                            addToTotal: true,
                            name: getSomethingOfArrayFBFilter(scope.incidenceId, scope.incidencesTypes, 'name', 'N/A'),
                            total: total,
                            value: totalIncidences,
                            type: 'currency',
                            weight: 30,
                            incidence: true,
                        }
                    };
                    // ngModel.$setViewValue(calculation);
                    // ngModel.$render();
                    return calculation;
                };
                var objsToWatch = ['incidences', 'calculationsResults'];
                var directiveId = directiveListenersFilter(ngModel, 'Simple Fiscal Directive', scope, scope.process, 'fifth', objsToWatch, scope.directiveFunctions);
            }
        };
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .directive('sheetSimpleDeduction', sheetSimpleDeduction);


    /** @ngInject */
    function sheetSimpleDeduction(
        calculateTotalFilter,
        getTotalByConstantFilter,
        getSomethingOfArrayFBFilter,
        directiveListenersFilter,
        getTotalOfArrayFieldFilter,
        filterIncidencesRejectedFilter
    ) {
        return {
            require: '?ngModel',
            restrict: 'A',
            scope: {
                incidences: '<',
                incidenceId: '<',
                constantsByTotal: '<',
                constantsByValue: '<',
                incidencesTypes: '<',
                employee: '<',
                payroll: '<',
                operation: '<',
                minimumVariables: '<',
                umaRecord: '<',
                nfdRecord: '<',
                calcFields: '<',
                employeeId: '<',
                notCalculate: '<',
                dataloaded: '<',
                constants: '<',
                directiveFunctions: '=',
                process: '@',
                needToBalance: '<',
                exceeded: '<'
            },
            link: function (scope, ele, attrs, ngModel) {
                scope.calculate = function () {
                    //variables globales
                    var formula = '';
                    var data = {};
                    var total = 0;
                    var filteredIncidences = filterIncidencesRejectedFilter(scope.incidences);
                    scope.rejectedIncidences = filteredIncidences.rejected;
                    scope.incidencesFiltered = filteredIncidences.notRejected;
                    //variables que se podran editar en la incidencia que afecta propiedad
                    data.totalIncidences = calculateTotalFilter(scope.incidencesFiltered);
                    data.fastIncidences = calculateTotalFilter(scope.incidencesFiltered, 'fast');
                    data.constantIncidences = calculateTotalFilter(scope.incidencesFiltered, 'constant');
                    data.requestIncidences = calculateTotalFilter(scope.incidencesFiltered, 'request');
                    data.manualIncidences = calculateTotalFilter(scope.incidencesFiltered, 'manual');
                    data.systemIncidences = calculateTotalFilter(scope.incidencesFiltered, 'system');
                    if (data.constantIncidences < 1) {
                        delete data.constantIncidences;
                    }
                    if (data.requestIncidences < 1) {
                        delete data.requestIncidences;
                    }
                    if (data.manualIncidences < 1) {
                        delete data.manualIncidences;
                    }
                    if (data.systemIncidences < 1) {
                        delete data.systemIncidences;
                    }
                    //si hacen las validaciones correspondientes
                    if (scope.constantsByValue && data.totalIncidences > 0) {
                        // valor, constant, type, formula, fields, employee, payroll, operation, umaRecord, nfdRecord, minimumVariables, constants
                        var constantByValue = getTotalByConstantFilter(data.totalIncidences, scope.constantsByValue, 'valor', '$totalIncidences', scope.calcFields, scope.employee, scope.payroll, scope.operation, scope.umaRecord, scope.nfdRecord, scope.minimumVariables, scope.constants);
                        total = constantByValue.total;
                        formula = constantByValue.formula;
                    } else {
                        total = data.totalIncidences;
                        formula = '$totalIncidences';
                    }
                    var affect = getSomethingOfArrayFBFilter(scope.incidenceId, scope.incidencesTypes, 'affect', 'N/A');
                    //Si el tipo de incidencia afecta los dias, lo que se calcula se descuenta de los dias trabajados no del calculo que se realiza
                    var calculation = {
                        data: data,
                        formula: formula,
                        value: {
                            nature: 'deduction',
                            incidence: true,
                            name: getSomethingOfArrayFBFilter(scope.incidenceId, scope.incidencesTypes, 'name', 'N/A'),
                            total: total,
                            value: data.totalIncidences,
                            fastValue: data.fastIncidences,
                            weight: 30
                        }
                    };
                    if (affect == "days") {
                        calculation.data.amount = total;
                        calculation.value.total = data.totalIncidences;
                        calculation.value.fastTotal = data.fastIncidences;
                        calculation.value.type = "int";
                    } else {
                        calculation.value.addToTotal = true;
                        calculation.value.total = total;
                        var fastTotal = 0;
                        if (total > 0) {
                            fastTotal = total / data.totalIncidences * data.fastIncidences;
                        }
                        calculation.value.fastTotal = fastTotal
                        calculation.value.type = "currency";
                    }
                    var rejectedIncidencesTotal = getTotalOfArrayFieldFilter(scope.rejectedIncidences, "value");
                    if (rejectedIncidencesTotal > 0) {
                        calculation.data.rejectedIncidencesTotal = rejectedIncidencesTotal;
                        calculation.value.total += rejectedIncidencesTotal;
                    }
                    // console.log(calculation);
                    return calculation;
                };
                var objsToWatch = ['incidences'];
                directiveListenersFilter(ngModel, 'Simple Deduction Directive', scope, scope.process, 'fifth', objsToWatch, scope.directiveFunctions);
            }
        };
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .directive('sheetSimpleComplement', sheetSimpleComplement);


    /** @ngInject */
    function sheetSimpleComplement(
        calculateTotalFilter,
        getTotalByConstantFilter,
        getComplementDataFilter,
        directiveListenersFilter,
        getTotalOfArrayFieldFilter
    ) {
        return {
            require: '?ngModel',
            restrict: 'A',
            scope: {
                incidences: '<',
                calculationsResults: '<',
                incidenceId: '<',
                constantsByValue: '<',
                employee: '<',
                payroll: '<',
                operation: '<',
                minimumVariables: '<',
                umaRecord: '<',
                nfdRecord: '<',
                calcFields: '<',
                employeeId: '<',
                notCalculate: '<',
                dataloaded: '<',
                constants: '<',
                directiveFunctions: '=',
                process: '@',
                nature: '@',
                needToBalance: '<',
                exceeded: '<',
                employeeCalculations: '<'
            },
            link: function (scope, ele, attrs, ngModel) {
                scope.calculate = function () {
                    //variables que se podran editar en la incidencia que afecta propiedad
                    var totalIncidences = calculateTotalFilter(scope.incidences);
                    scope.totalCalculations = getTotalOfArrayFieldFilter(scope.calculationsResults, "value");
                    //variables globales
                    var formula = '';
                    var data = {};
                    var total = 0;
                    //si hacen las validaciones correspondientes
                    if (scope.constantsByValue) {
                        // valor, constant, type, formula, fields, employee, payroll, operation, umaRecord, nfdRecord, minimumVariables, constants
                        var constantByValue = getTotalByConstantFilter(totalIncidences, scope.constantsByValue, 'valor', '$totalIncidencias', scope.calcFields, scope.employee, scope.payroll, scope.operation, scope.umaRecord, scope.nfdRecord, scope.minimumVariables, scope.constants);
                        total = constantByValue.total;
                        formula = constantByValue.formula;
                        data.incidences = scope.incidences;
                        data.totalIncidences = totalIncidences;
                    } else {
                        total = scope.totalCalculations;
                        formula = '$totalCalculos';
                        data.calculationsResults = scope.calculationsResults;
                        //se añade los datos de data que se ocuparon para calcular
                    }

                    var calculation = {
                        data: data,
                        formula: formula,
                        value: {
                            nature: scope.nature,
                            addToTotal: true,
                            name: getComplementDataFilter(scope.incidenceId, 'name', 'N/A'),
                            total: total,
                            type: 'currency',
                            weight: 30,
                            incidence: true
                        }
                    };
                    // ngModel.$setViewValue(calculation);
                    // ngModel.$render();
                    return calculation;
                };
                var objsToWatch = ['incidences', 'calculationsResults'];
                var directiveId = directiveListenersFilter(ngModel, 'Simple Complement Directive', scope, scope.process, 'third', objsToWatch, scope.directiveFunctions);
            }
        };
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .directive('sheetImssWorker', sheetImssWorker);


    /** @ngInject */
    function sheetImssWorker(
        getIMSSRowLastFilter,
        calculateTotalFilter,
        directiveListenersFilter,
        $rootScope,
        AppF
    ) {
        return {
            require: '?ngModel',
            restrict: 'A',
            scope: {
                sbc: '<',
                calendar: '<',
                workedDays: '<',
                imssRecords: '<',
                employeeId: '<',
                notCalculate: '<',
                dataloaded: '<',
                constants: '<',
                directiveFunctions: '=',
                process: '@',
                needToBalance: '<',
                incidenceId: '<',
                exceeded: '<',
                employeeCalculations: '<',
                minimumVariables: '<',
                umaRecord: '<'
            },
            link: function (scope, ele, attrs, ngModel) {
                scope.calculate = function () {
                    var imssRecord = getIMSSRowLastFilter(scope.calendar, scope.imssRecords);
                    scope.sbc = scope.sbc ? scope.sbc : 0;
                    scope.workedDays = scope.workedDays ? scope.workedDays : 0;
                    scope.smdf = scope.minimumVariables.A;

                    var excessPercent = imssRecord.ensuredExcess ? imssRecord.ensuredExcess : 0;
                    var benefitsPercen = imssRecord.ensuredBenefits ? imssRecord.ensuredBenefits : 0;
                    var gmpPercent = imssRecord.gmpEnsured ? imssRecord.gmpEnsured : 0;
                    var ivPercent = imssRecord.ivaEnsured ? imssRecord.ivaEnsured : 0;
                    var cyvPercent = imssRecord.cyvEnsured ? imssRecord.cyvEnsured : 0;

                    excessPercent = parseFloat(excessPercent ? excessPercent : 0) / 100;
                    benefitsPercen = parseFloat(benefitsPercen ? benefitsPercen : 0) / 100;
                    gmpPercent = parseFloat(gmpPercent ? gmpPercent : 0) / 100;
                    ivPercent = parseFloat(ivPercent ? ivPercent : 0) / 100;
                    cyvPercent = parseFloat(cyvPercent ? cyvPercent : 0) / 100;

                    var excess = (scope.sbc > (scope.smdf * 3)) ? (scope.sbc - (scope.smdf * 3)) * (excessPercent * scope.workedDays) : 0;
                    var benefits = scope.sbc * scope.workedDays * benefitsPercen;
                    var gmp = scope.sbc * scope.workedDays * gmpPercent;
                    var iv = scope.sbc * scope.workedDays * ivPercent;
                    var cyv = scope.sbc * scope.workedDays * cyvPercent;

                    var excess = Math.round(excess * 100) / 100
                    var benefits = Math.round(benefits * 100) / 100
                    var gmp = Math.round(gmp * 100) / 100
                    var iv = Math.round(iv * 100) / 100
                    var cyv = Math.round(cyv * 100) / 100
                    var total = Math.round((excess + benefits + gmp + iv + cyv) * 100) / 100

                    var calculation = {
                        data: {
                            excessPercent: excessPercent,
                            excess: excess,
                            benefitsPercen: benefitsPercen,
                            benefits: benefits,
                            gmpPercent: gmpPercent,
                            gmp: gmp,
                            ivPercent: ivPercent,
                            iv: iv,
                            cyvPercent: cyvPercent,
                            cyv: cyv,
                            sbc: scope.sbc,
                            workedDays: scope.workedDays
                        },
                        formula: '',
                        value: {
                            name: 'IMSS',
                            total: total,
                            type: 'currency',
                            addToTotal: true,
                            nature: 'deduction',
                            incidence: true,
                            weight: 30,
                            applyToEmployee: true,
                            applyType: "return"
                        }
                    };
                    scope.totalCalculations = total;
                    scope.calculationsResults = {};
                    scope.calculationsResults[scope.incidenceId] = {
                        "value": total,
                        "from": "REAL",
                        "isFiscal": true
                    }
                    // ngModel.$setViewValue(calculation);
                    // ngModel.$render();
                    return calculation;

                };
                var objsToWatch = ['calendar', 'sbc', 'workedDays', 'imssRecords'];
                var directiveId = directiveListenersFilter(ngModel, 'Imss Worker Directive', scope, scope.process, 'fifth', objsToWatch, scope.directiveFunctions);
            }
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .directive('sheetAbsences', sheetAbsences);


    /** @ngInject */
    function sheetAbsences(
        getTotalValueIncidencesFilter,
        getSomethingOfArrayFBFilter,
        calculateTotalFilter,
        directiveListenersFilter
    ) {
        return {
            require: '?ngModel',
            restrict: 'A',
            scope: { // se meten aqui los datos que vaya a necesitar el cálculo
                sd: '<',
                incidences: '<',
                incidenceId: '<',
                constantsByTotal: '<',
                constantsByValue: '<',
                incidencesTypes: '<',
                employeeId: '<',
                notCalculate: '<',
                dataloaded: '<',
                constants: '<',
                directiveFunctions: '=',
                process: '@',
                needToBalance: '<',
                exceeded: '<'
            },
            link: function (scope, ele, attrs, ngModel) {
                scope.calculate = function () {
                    //variables globales
                    var formula = '$totalIncidences*$salary';
                    var data = {};
                    //variables que se podran editar en la incidencia que afecta propiedad
                    //se establece el total de incidencias siempre
                    data.days = getTotalValueIncidencesFilter(scope.incidences);
                    data.fastIncidences = calculateTotalFilter(scope.incidences, 'fast');
                    data.sd = scope.sd ? scope.sd : 0;
                    data.amount = data.days * data.sd;
                    //se añade los datos de data que se ocuparon para calcular
                    var calculation = {
                        data: data,
                        formula: formula,
                        value: {
                            name: getSomethingOfArrayFBFilter(scope.incidenceId, scope.incidencesTypes, 'name', 'N/A'),
                            total: data.days,
                            fastTotal: data.fastIncidences,
                            type: 'int',
                            incidence: true,
                            weight: 30
                        }
                    };
                    // ngModel.$setViewValue(calculation);
                    // ngModel.$render();
                    return calculation;
                };
                var objsToWatch = ['incidences', 'sd'];
                directiveListenersFilter(ngModel, 'Absences Directive', scope, scope.process, 'fifth', objsToWatch, scope.directiveFunctions);
            }
        };
    }
}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .directive('sheetPerceptionsReal', sheetPerceptionsReal);


    /** @ngInject */
    function sheetPerceptionsReal(
        translateFilter,
        directiveListenersFilter,
        getTotalOfCalculationsFilter
    ) {
        return {
            require: '?ngModel',
            restrict: 'AE',
            scope: {
                calculations: '<',
                employeeId: '<',
                notCalculate: '<',
                dataloaded: '<',
                constants: '<',
                directiveFunctions: '=',
                process: '@',
                needToBalance: '<',
                exceeded: '<'
            },
            link: function(scope, ele, attrs, ngModel) {
                scope.calculate = function() {
                    var totals = getTotalOfCalculationsFilter(scope.calculations, "perception");
                    //console.log(totals);
                    var totalPerceptions = Math.round(totals.total * 100) / 100;
                    var onlyIncidencesAmount = Math.round(totals.onlyIncidencesAmount * 100) / 100;
                    var calculation = {
                        data: {
                            onlyIncidencesAmount: onlyIncidencesAmount
                        },
                        value: {
                            name: translateFilter('c.TOTAL_PERCEPTIONS'),
                            total: totalPerceptions,
                            type: 'currency',
                            weight: 20
                        }
                    };
                    // ngModel.$setViewValue(calculation);
                    // ngModel.$render();
                    return calculation;

                };
                var objsToWatch = ['calculations'];
                var filtersObjsToWatch = {
                    calculations: {
                        filter: 'getTotalOfCalculations',
                        param: "perception"
                    }
                };
                var directiveId = directiveListenersFilter(ngModel, 'Perceptions Real Directive', scope, scope.process, 'sixth', objsToWatch, scope.directiveFunctions, filtersObjsToWatch);
            }
        };
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .directive('sheetIsr', sheetIsr);


    /** @ngInject */
    function sheetIsr(
        getISRRowFilter,
        $log,
        $rootScope,
        directiveListenersFilter
    ) {
        return {
            require: '?ngModel',
            restrict: 'A',
            scope: {
                gravableBase: '<',
                workedDays: '<',
                mensualizationFactor: '<',
                subsidyOfPeriod: '<',
                employeeId: '<',
                dataloaded: '<',
                notCalculate: '<',
                constants: '<',
                process: '@',
                directiveFunctions: '=',
                incidenceId: '<',
                needToBalance: '<',
                exceeded: '<',
                employeeCalculations: '<'
            },
            link: function(scope, ele, attrs, ngModel) {
                scope.calculate = function() {
                    var gravableBase = scope.gravableBase ? scope.gravableBase : 0.1;
                    var isrRow = getISRRowFilter(gravableBase);
                    if (isrRow) {
                        var exedent = gravableBase - isrRow.lowerLimit;
                        var marginalTax = exedent * (isrRow.percentFee / 100);
                        var isrCalculated = marginalTax + isrRow.fixedFee;
                        var isrOfPeriod = (isrCalculated / scope.mensualizationFactor) * scope.workedDays;
                        var isr = (isrOfPeriod > scope.subsidyOfPeriod) ? isrOfPeriod - scope.subsidyOfPeriod : 0;
                        var calculation = {
                            data: {
                                lowerLimit: Math.round(isrRow.lowerLimit * 100) / 100,
                                isrPercent: Math.round(isrRow.percentFee * 100) / 100,
                                isrFee: Math.round(isrRow.fixedFee * 100) / 100,
                                lowerLimitExedent: Math.round(exedent * 100) / 100,
                                marginalTax: Math.round(marginalTax * 100) / 100,
                                mensualizationFactor: scope.mensualizationFactor,
                                workedDays: scope.workedDays,
                                gravableBase: Math.round(gravableBase * 100) / 100,
                                isrCalculated: Math.round(isrCalculated * 100) / 100,
                                isrOfPeriod: Math.round(isrOfPeriod * 100) / 100,
                                isr: Math.round(isr * 100) / 100,
                                subsidyOfPeriod: Math.round(scope.subsidyOfPeriod * 100) / 100
                            },
                            formulas: [
                                '$lowerLimitExedent = $gravableBase - $lowerLimit',
                                '$marginalTax = $lowerLimitExedent * ($isrPercent/100)',
                                '$isrCalculated = $marginalTax + $isrFee',
                                '$isrOfPeriod = ($isrCalculated / $mensualizationFactor) * ',
                                '$isr = ($isrOfPeriod > $subsidyOfPeriod) ? $isrOfPeriod - $subsidyOfPeriod : 0'
                            ],
                            value: {
                                name: 'ISR',
                                total: isr,
                                type: 'currency',
                                addToTotal: true,
                                nature: 'deduction',
                                incidence: true,
                                applyToEmployee: true,
                                applyType: "return",
                                weight: 30
                            }
                        };
                        scope.totalCalculations = isr;
                        scope.calculationsResults = {};
                        scope.calculationsResults[scope.incidenceId] = {
                            "value": isr,
                            "from": "REAL",
                            "isFiscal": true
                        }
                        //$log.debug(calculation, "ISR Calculation");
                        // ngModel.$setViewValue(calculation);
                        // ngModel.$render();
                        return calculation;
                    } else {
                        throw "No existe registro de ISR";
                    }
                }
                var objsToWatch = ['gravableBase', 'mensualizationFactor', 'subsidyOfPeriod', 'workedDays'];
                var filtersObjsToWatch = {
                    gravableBase: {
                        filter: 'validateUndefined',
                        param: 0.1
                    },
                    subsidyOfPeriod: {
                        filter: 'validateUndefined',
                        param: 0
                    }
                }
                var directiveId = directiveListenersFilter(ngModel, 'Isr Directive', scope, scope.process, 'fifth', objsToWatch, scope.directiveFunctions, filtersObjsToWatch);
            }
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .directive('sheetSubsidy', sheetSubsidy);


    /** @ngInject */
    function sheetSubsidy(
        getSubsidyOfTableFilter,
        getSubsidyOfPeriodFilter,
        directiveListenersFilter,
        $rootScope
    ) {
        return {
            require: '?ngModel',
            restrict: 'A',
            scope: {
                gravableBase: '<',
                mensualizationFactor: '<',
                workedDays: '<',
                isrOfPeriod: '<',
                employeeId: '<',
                notCalculate: '<',
                dataloaded: '<',
                constants: '<',
                directiveFunctions: '=',
                process: '@',
                incidenceId: '<',
                needToBalance: '<',
                exceeded: '<',
                employeeCalculations: '<'
            },
            link: function (scope, ele, attrs, ngModel) {
                scope.calculate = function () {
                    scope.isrOfPeriod = scope.isrOfPeriod ? scope.isrOfPeriod : 0;
                    var subsidyOfTable = (scope.gravableBase) ? getSubsidyOfTableFilter(scope.gravableBase) : 0;
                    var subsidyOfPeriod = getSubsidyOfPeriodFilter(subsidyOfTable, scope.mensualizationFactor, scope.workedDays);
                    var subsidy = (subsidyOfPeriod > scope.isrOfPeriod) ? subsidyOfPeriod - scope.isrOfPeriod : 0;
                    var calculation = {
                        data: {
                            isrOfPeriod: Math.round(scope.isrOfPeriod * 100) / 100,
                            gravableBase: scope.gravableBase ? Math.round(scope.gravableBase * 100) / 100 : 0,
                            subsidyOfTable: Math.round(subsidyOfTable * 100) / 100,
                            subsidyOfPeriod: Math.round(subsidyOfPeriod * 100) / 100,
                            subsidy: Math.round(subsidy * 100) / 100,
                            workedDays: scope.workedDays,
                            mensualizationFactor: scope.mensualizationFactor
                        },
                        formula: '$subsidy = ($subsidyOfPeriod > $isrOfPeriod) ? $subsidyOfPeriod - $isrOfPeriod : 0',
                        value: {
                            name: 'Subsidio del Periodo',
                            total: subsidy,
                            type: 'currency',
                            value: 1,
                            weight: 10,
                            nature: 'perception',
                            addToTotal: true,
                            incidence: true,
                            applyToEmployee: true,
                            applyType: "charge",
                            ignoreForTaxes: true,
                        }
                    };
                    scope.totalCalculations = subsidy;
                    scope.calculationsResults = {};
                    scope.calculationsResults[scope.incidenceId] = {
                        "value": subsidy,
                        "from": "REAL",
                        "isFiscal": true
                    }
                    // ngModel.$setViewValue(calculation);
                    // ngModel.$render();
                    return calculation;
                }
                var objsToWatch = ['gravableBase', 'mensualizationFactor', 'workedDays', 'isrOfPeriod'];
                var filtersObjsToWatch = {
                    gravableBase: {
                        filter: 'validateUndefined',
                        param: 0
                    },
                    isrOfPeriod: {
                        filter: 'validateUndefined',
                        param: 0
                    }
                }
                var directiveId = directiveListenersFilter(ngModel, 'Subsidy Directive', scope, scope.process, 'fifth', objsToWatch, scope.directiveFunctions, filtersObjsToWatch);
            }
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .directive('sheetSimplePerception', sheetSimplePerception);


    /** @ngInject */
    function sheetSimplePerception(
        calculateTotalFilter,
        getTotalByConstantFilter,
        getSomethingOfArrayFBFilter,
        directiveListenersFilter,
        $rootScope
    ) {
        return {
            require: '?ngModel',
            restrict: 'A',
            scope: {
                incidences: '<',
                incidenceId: '<',
                constantsByTotal: '<',
                constantsByValue: '<',
                incidencesTypes: '<',
                employee: '<',
                payroll: '<',
                operation: '<',
                minimumVariables: '<',
                umaRecord: '<',
                nfdRecord: '<',
                calcFields: '<',
                employeeId: '<',
                notCalculate: '<',
                dataloaded: '<',
                constants: '<',
                directiveFunctions: '=',
                process: '@',
                needToBalance: '<',
                exceeded: '<'
            },
            link: function (scope, ele, attrs, ngModel) {
                scope.calculate = function () {
                    //variables globales
                    var formula = '';
                    var data = {};
                    var total = 0;

                    //variables que se podran editar en la incidencia que afecta propiedad
                    data.totalIncidences = calculateTotalFilter(scope.incidences);
                    data.fastIncidences = calculateTotalFilter(scope.incidences, 'fast');
                    data.constantIncidences = calculateTotalFilter(scope.incidences, 'constant');
                    data.requestIncidences = calculateTotalFilter(scope.incidences, 'request');
                    data.manualIncidences = calculateTotalFilter(scope.incidences, 'manual');
                    data.systemIncidences = calculateTotalFilter(scope.incidences, 'system');
                    //se establece el total de incidencias siempre
                    if (data.constantIncidences < 1) {
                        delete data.constantIncidences;
                    }
                    if (data.requestIncidences < 1) {
                        delete data.requestIncidences;
                    }
                    if (data.manualIncidences < 1) {
                        delete data.manualIncidences;
                    }
                    if (data.systemIncidences < 1) {
                        delete data.systemIncidences;
                    }
                    //si hacen las validaciones correspondientes
                    if (scope.constantsByValue && data.totalIncidences > 0) {
                        // valor, constant, type, formula, fields, employee, payroll, operation, umaRecord, nfdRecord, minimumVariables, constants
                        var constantByValue = getTotalByConstantFilter(data.totalIncidences, scope.constantsByValue, 'valor', '$totalIncidences', scope.calcFields, scope.employee, scope.payroll, scope.operation, scope.umaRecord, scope.nfdRecord, scope.minimumVariables, scope.constants);
                        total = constantByValue.total;
                        formula = constantByValue.formula;
                    } else {
                        total = data.totalIncidences;
                        formula = '$totalIncidences';
                        //se añade los datos de data que se ocuparon para calcular
                    }
                    var fastTotal = 0;
                    if (total > 0) {
                        fastTotal = total / data.totalIncidences * data.fastIncidences;
                    }
                    var calculation = {
                        data: data,
                        formula: formula,
                        value: {
                            nature: 'perception',
                            addToTotal: true,
                            incidence: true,
                            name: getSomethingOfArrayFBFilter(scope.incidenceId, scope.incidencesTypes, 'name', 'N/A'),
                            value: data.totalIncidences,
                            fastValue: data.fastIncidences,
                            fastTotal: fastTotal,
                            total: total,
                            type: 'currency',
                            weight: 10
                        }
                    };
                    // ngModel.$setViewValue(calculation);
                    // ngModel.$render();
                    return calculation;

                };
                var objsToWatch = ['incidences', 'employee.data.salary.sdr'];
                var directiveId = directiveListenersFilter(ngModel, 'Simple Perception Directive', scope, scope.process, 'fifth', objsToWatch, scope.directiveFunctions);
            }
        };
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .directive('sheetSimplePerceptionDay', sheetSimplePerceptionDay);


    /** @ngInject */
    function sheetSimplePerceptionDay(
        getTotalByConstantFilter,
        getSomethingOfArrayFBFilter,
        calculateTotalFilter,
        directiveListenersFilter
    ) {
        return {
            require: '?ngModel',
            restrict: 'A',
            scope: {
                incidences: '<',
                sd: '<',
                incidenceId: '<',
                constantsByTotal: '<',
                constantsByValue: '<',
                incidencesTypes: '<',
                employee: '<',
                payroll: '<',
                operation: '<',
                minimumVariables: '<',
                umaRecord: '<',
                nfdRecord: '<',
                calcFields: '<',
                employeeId: '<',
                notCalculate: '<',
                dataloaded: '<',
                constants: '<',
                directiveFunctions: '=',
                process: '@',
                needToBalance: '<',
                exceeded: '<'
            },
            link: function (scope, ele, attrs, ngModel) {
                scope.calculate = function () {
                    //variables globales
                    var formula = '';
                    var data = {};
                    var total = 0;
                    //variables que se podran editar en la incidencia que afecta propiedad
                    data.sd = scope.sd ? scope.sd : 0;
                    data.totalIncidences = calculateTotalFilter(scope.incidences);
                    data.fastIncidences = calculateTotalFilter(scope.incidences, 'fast');
                    data.constantIncidences = calculateTotalFilter(scope.incidences, 'constant');
                    data.requestIncidences = calculateTotalFilter(scope.incidences, 'request');
                    data.manualIncidences = calculateTotalFilter(scope.incidences, 'manual');
                    data.systemIncidences = calculateTotalFilter(scope.incidences, 'system');
                    //se establece el total de incidencias siempre
                    if (data.constantIncidences < 1) {
                        delete data.constantIncidences;
                    }
                    if (data.requestIncidences < 1) {
                        delete data.requestIncidences;
                    }
                    if (data.manualIncidences < 1) {
                        delete data.manualIncidences;
                    }
                    if (data.systemIncidences < 1) {
                        delete data.systemIncidences;
                    }
                    //se hacen las validaciones correspondientes
                    if (scope.constantsByValue) {
                        // valor, constant, type, formula, fields, employee, payroll, operation, umaRecord, nfdRecord, minimumVariables, constants
                        var constantByValue = getTotalByConstantFilter(data.totalIncidences, scope.constantsByValue, 'valor', '$days', scope.calcFields, scope.employee, scope.payroll, scope.operation, scope.umaRecord, scope.nfdRecord, scope.minimumVariables, scope.constants);
                        total = constantByValue.total;
                        formula = constantByValue.formula;
                    } else {
                        total = parseFloat(data.sd) * data.totalIncidences;
                        formula = '$days*$daylySalary';
                    }
                    var fastTotal = 0;
                    if (total > 0) {
                        fastTotal = total / data.totalIncidences * data.fastIncidences;
                    }
                    var calculation = {
                        data: data,
                        formula: formula,
                        value: {
                            name: getSomethingOfArrayFBFilter(scope.incidenceId, scope.incidencesTypes, 'name', 'N/A'),
                            total: total,
                            value: data.totalIncidences,
                            fastTotal: fastTotal,
                            fastValue: data.fastIncidences,
                            type: 'currency',
                            nature: 'perception',
                            addToTotal: true,
                            incidence: true,
                            weight: 10
                        }
                    };
                    console.log(calculation);
                    return calculation;
                };
                var objsToWatch = ['incidences', 'sd'];
                directiveListenersFilter(ngModel, 'Simple Perception Day Directive', scope, scope.process, 'fifth', objsToWatch, scope.directiveFunctions);
            }
        };
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .directive('sheetHolidays', sheetHolidays);


    /** @ngInject */
    function sheetHolidays(
        $filter
    ) {
        return {
            require: '?ngModel',
            restrict: 'A',
            scope: {
                incidences: '<',
                sd: '<',
                incidenceId: '<',
                constantsByTotal: '<',
                constantsByValue: '<',
                incidencesTypes: '<',
                employeeId: '<',
                notCalculate: '<',
                dataloaded: '<',
                constants: '<',
                directiveFunctions: '=',
                process: '@',
                needToBalance: '<',
                exceeded: '<'
            },
            link: function (scope, ele, attrs, ngModel) {
                scope.calculate = function () {
                    //variables globales
                    var formula = '$holydays*$daylySalary';
                    var data = {};
                    var total = 0;
                    //se establece el total de incidencias siempre
                    data.days = $filter("getTotalValueIncidences")(scope.incidences);
                    data.fastIncidences = $filter("calculateTotal")(scope.incidences, 'fast');
                    //se añade los datos de data que se ocuparon para calcular
                    data.sd = scope.sd ? scope.sd : 0;
                    total = parseFloat(data.sd) * data.days;
                    var calculation = {
                        data: data,
                        formula: formula,
                        value: {
                            name: $filter("getSomethingOfArrayFB")(scope.incidenceId, scope.incidencesTypes, 'name', 'N/A'),
                            total: total,
                            value: data.days,
                            fastTotal: data.fastIncidences * data.sd,
                            fastValue: data.fastIncidences,
                            type: 'currency',
                            nature: 'perception',
                            addToTotal: true,
                            incidence: true,
                            weight: 10
                        }
                    };
                    return calculation;
                };
                var objsToWatch = ['incidences', 'sd'];
                $filter("directiveListeners")(ngModel, 'Sheet Holiday Directive', scope, scope.process, 'fifth', objsToWatch, scope.directiveFunctions);
            }
        };
    }
}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .directive('sheetExtraHours', sheetExtraHours);


    /** @ngInject */
    function sheetExtraHours(
        $filter,
        directiveListenersFilter
    ) {
        return {
            require: '?ngModel',
            restrict: 'A',
            scope: {
                incidences: '<',
                sd: '<',
                period: '<',
                incidenceId: '<',
                constantsByTotal: '<',
                constantsByValue: '<',
                incidencesTypes: '<',
                employeeId: '<',
                notCalculate: '<',
                dataloaded: '<',
                constants: '<',
                directiveFunctions: '=',
                process: '@',
                needToBalance: '<',
                exceeded: '<',
                calculationsResults: '<'
            },
            link: function (scope, ele, attrs, ngModel) {
                scope.calculate = function () {
                    //variables globales
                    var formula = '($totalSundayHours*($salary/8*1.25)+$totalNormalHours*($salary/8))*2';
                    var data = {};
                    var total = 0;
                    //variables que se podran editar en la incidencia que afecta propiedad
                    var sd = scope.sd ? scope.sd : 0;
                    var sundaySalaryByHour = parseFloat(sd) * 1.25 / 8;
                    var salaryByHour = parseFloat(sd) / 8;
                    //se establece el total de incidencias siempre
                    data.hours = $filter("getTotalValueIncidences")(scope.incidences);
                    data.fastIncidences = $filter("calculateTotal")(scope.incidences, 'fast');
                    //Se ejecuta el calculo
                    var extraHoursData = $filter("getExtraHoursAmount")(scope.incidences, scope.period, sundaySalaryByHour, salaryByHour);
                    //se añade los datos de data que se ocuparon para calcular
                    total = extraHoursData.total;
                    data.normalHours = extraHoursData.normalHours;
                    data.salaryByHour = salaryByHour;
                    data.sundayHours = extraHoursData.sundayHours;
                    data.sundaySalaryByHour = sundaySalaryByHour;
                    data.extraHours = extraHoursData.extraHours;
                    var fastSalary = extraHoursData.fastSalary;
                    //Se redondean los campos utilizados
                    if (total > 0) {
                        total = Math.round(total * 100) / 100
                    }
                    if (fastSalary > 0) {
                        fastSalary = Math.round(fastSalary * 100) / 100
                    }
                    if (scope.process == "FISCAL") {
                        scope.totalCalculations = $filter("getTotalOfArrayField")(scope.calculationsResults, "value");
                    }
                    var calculation = {
                        data: data,
                        formula: formula,
                        value: {
                            name: $filter("getSomethingOfArrayFB")(scope.incidenceId, scope.incidencesTypes, 'name', 'N/A'),
                            value: data.hours,
                            total: total,
                            fastValue: data.hours - data.fastIncidences,
                            fastTotal: fastSalary,
                            type: 'currency',
                            nature: 'perception',
                            incidence: true,
                            addToTotal: true,
                            weight: 10
                        }
                    };
                    return calculation;
                };
                var objsToWatch = ['incidences', 'sd'];
                directiveListenersFilter(ngModel, 'Extra Hours Directive', scope, scope.process, 'fifth', objsToWatch, scope.directiveFunctions);
            }
        };
    }
}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .directive('sheetEmployeeInfonavit', sheetEmployeeInfonavit);


    /** @ngInject */
    function sheetEmployeeInfonavit(
        calculateCreditFilter,
        getSomethingOfArrayFBFilter,
        directiveListenersFilter,
        getTotalOfArrayFieldFilter,
        filterIncidencesRejectedFilter
    ) {
        return {
            require: '?ngModel',
            restrict: 'A',
            scope: {
                credit: '<',
                incidenceId: '<',
                operation: '<',
                dailySalary: '<',
                incidencesTypes: '<',
                employeeId: '<',
                notCalculate: '<',
                dataloaded: '<',
                constants: '<',
                directiveFunctions: '=',
                process: '@',
                needToBalance: '<',
                exceeded: '<',
                incidences: '<',
                employeeName: '<',
                nfdRecord: '<'
            },
            link: function (scope, ele, attrs, ngModel) {
                scope.calculate = function () {
                    //Directiva tipo deduccion por lo que se filtan las incidencias rechazadas
                    var filteredIncidences = filterIncidencesRejectedFilter(scope.incidences);
                    scope.rejectedIncidences = filteredIncidences.rejected;
                    scope.incidencesFiltered = filteredIncidences.notRejected;
                    //Variables a retornar
                    var data = {};
                    var formula = '';
                    var total = 0;
                    if (scope.credit.length) {
                        var credit = calculateCreditFilter(scope.credit[0], scope.dailySalary, scope.operation, scope.constants, scope.nfdRecord, scope.employeeName);
                        data = credit.data;
                        formula = credit.formula;
                        total = credit.total;
                    }
                    var calculation = {
                        data: data,
                        formula: formula,
                        value: {
                            name: getSomethingOfArrayFBFilter(scope.incidenceId, scope.incidencesTypes, 'name', 'N/A'),
                            total: total,
                            value: scope.credit.length,
                            fastTotal: 0,
                            type: 'currency',
                            nature: 'deduction',
                            addToTotal: true,
                            incidence: true,
                            weight: 21
                        }
                    };
                    //Se añade el calculo total de las rechzadas
                    var rejectedIncidencesTotal = getTotalOfArrayFieldFilter(scope.rejectedIncidences, "value")
                    if (rejectedIncidencesTotal > 0) {
                        calculation.data.totalReal = calculation.value.total;
                        calculation.data.rejectedIncidencesTotal = rejectedIncidencesTotal;
                        calculation.value.total += rejectedIncidencesTotal;
                    }
                    return calculation;
                };
                var objsToWatch = ['dailySalary', 'credit'];
                directiveListenersFilter(ngModel, 'Employee Infonavit Directive', scope, scope.process, 'fifth', objsToWatch, scope.directiveFunctions);
            }
        };
    }
}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .directive('sheetTotalSalary', sheetTotalSalary);


    /** @ngInject */
    function sheetTotalSalary(
        translateFilter,
        calculateTotalSalaryFilter,
        directiveListenersFilter
    ) {
        return {
            require: '?ngModel',
            restrict: 'A',
            scope: { // se meten aqui los datos que vaya a necesitar el cálculo
                sd: '<',
                sdr: '<',
                workedDays: '<',
                dailySalary: '<',
                employeeId: '<',
                notCalculate: '<',
                dataloaded: '<',
                constants: '<',
                directiveFunctions: '=',
                process: '@',
                needToBalance: '<',
                exceeded: '<'
            },
            link: function (scope, ele, attrs, ngModel) {
                scope.calculate = function () {
                    var salary = (scope.sd) ? scope.sd : (scope.sdr ? scope.sdr : 0);
                    var totalSalary = calculateTotalSalaryFilter(scope.dailySalary.data.dailySalaries, scope.workedDays.value.total, salary, 'sdr'); // @todo:carlos hacer bien la funcion que checa salarios por dia
                    if (totalSalary > 0) {
                        totalSalary = Math.round(totalSalary * 100) / 100;
                    }
                    var calculation = {
                        data: {
                            workedDays: scope.workedDays.value.total,
                            totalSalary: totalSalary,
                            salary: salary
                        },
                        formula: '$totalSalary = $salary * $workedDays',
                        value: {
                            nature: 'perception',
                            addToTotal: true,
                            value: 1,
                            name: translateFilter('c.TOTAL_SALARY'),
                            total: totalSalary,
                            type: 'currency',
                            incidence: false,
                            weight: 3
                        }
                    };
                    return calculation;
                };
                var objsToWatch = ['workedDays', 'sdr'];
                directiveListenersFilter(ngModel, 'Total Salary Directive', scope, scope.process, 'fourth', objsToWatch, scope.directiveFunctions);
            }
        };
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .directive('sheetGravableBase', sheetGravableBase);

    /** @ngInject */
    function sheetGravableBase($q, AppF, directiveListenersFilter, getSomethingOfArrayFBFilter, getIncidencesForTaxesFilter, getGravableAmountsFilter) {
        return {
            require: 'ngModel',
            restrict: 'A',
            scope: {
                calculations: '<',
                sd: '<',
                workedDays: '<',
                incidencesTypes: '<',
                mensualizationFactor: '<',
                employeeId: '<',
                notCalculate: '<',
                dataloaded: '<',
                constants: '<',
                directiveFunctions: '=',
                process: '@',
                needToBalance: '<',
                exceeded: '<',
                exemptTaxedConcepts: '<',
                calcFields: '<',
                employee: '<',
                payroll: '<',
                operation: '<',
                umaRecord: '<'
            },
            link: function (scope, ele, attrs, ngModel) {
                scope.calculate = function () {
                    scope.sd = scope.sd ? scope.sd : 0;
                    scope.mensualizationFactor ? scope.mensualizationFactor : 30.4;
                    var thisCalculations = getIncidencesForTaxesFilter(scope.calculations);
                    var gravableBase = getGravableAmountsFilter(thisCalculations, scope.exemptTaxedConcepts, scope.workedDays, scope.mensualizationFactor, scope.calcFields, scope.employee, scope.payroll, scope.operation, scope.umaRecord, scope.constants);
                    // console.log(scope.workedDays);
                    var calculation = {
                        data: {
                            mensualizationFactor: scope.mensualizationFactor,
                            workedDays: scope.workedDays.value.total
                        },
                        formulas: [],
                        value: {
                            name: 'Base Gravable',
                            total: 0,
                            type: 'currency'
                        }
                    };
                    for (var incidenceType in gravableBase) {
                        var total = gravableBase[incidenceType].total;
                        delete gravableBase[incidenceType].total;
                        calculation.data[getSomethingOfArrayFBFilter(incidenceType, scope.incidencesTypes, "name", "N/A")] = gravableBase[incidenceType];
                        calculation.value[incidenceType] = total;
                    }
                    return calculation;

                }
                var objsToWatch = ['workedDays', 'calculations'];
                var filtersObjsToWatch = {
                    calculations: {
                        filter: 'getIncidencesForTaxes'
                    }
                };
                directiveListenersFilter(ngModel, 'Gravable Base Directive', scope, scope.process, 'eight', objsToWatch, scope.directiveFunctions, filtersObjsToWatch);
            }
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .directive('sheetDailySalary', sheetDailySalary);


    /** @ngInject */
    function sheetDailySalary(
        $filter,
        directiveListenersFilter
    ) {
        return {
            require: '?ngModel',
            restrict: 'A',
            scope: {
                salary: '<',
                workedDays: '<',
                period: '<',
                deductions: '<',
                salaryType: '@',
                employeeId: '<',
                notCalculate: '<',
                dataloaded: '<',
                constants: '<',
                directiveFunctions: '=',
                process: '@',
                needToBalance: '<',
                exceeded: '<'
            },
            link: function (scope, ele, attrs, ngModel) {
                scope.calculate = function () {
                    // console.log(scope.salary);
                    var absencesIncidences = $filter('getAbsencesIncidences')(scope.deductions);
                    var realDailySalaries = $filter('getSalaryByDay')(scope.workedDays.data.activeDays, scope.period);
                    var dailyAbsences = $filter('getDailyAbsences')(absencesIncidences, scope.workedDays.data.activeDays);
                    var dailySalaries = JSON.parse(JSON.stringify(realDailySalaries));
                    for (var d in dailyAbsences) {
                        if (dailySalaries[d] === "undefined") {
                            dailySalaries[d] = dailyAbsences[d];
                        } else {
                            dailySalaries[d] = Object.assign({}, dailySalaries[d], dailyAbsences[d]);
                        }
                    };
                    var total = scope.salary[scope.salaryType] ? scope.salary[scope.salaryType] : 0;
                    var calculation = {
                        data: {
                            total: total,
                            realDailySalaries: realDailySalaries,
                            dailyAbsences: dailyAbsences,
                            dailySalaries: dailySalaries
                        },
                        value: {
                            name: $filter('translate')('c.DAILY_SALARY'),
                            total: total,
                            type: 'currency',
                            weight: 2
                        }
                    };
                    return calculation;

                };
                var objsToWatch = ['salary', 'workedDays', 'deductions'];
                var filtersObjsToWatch = {
                    deductions: {
                        filter: 'getAffectDaysIncidences'
                    }
                };
                directiveListenersFilter(ngModel, 'Daily Salary Directive', scope, scope.process, 'third', objsToWatch, scope.directiveFunctions, filtersObjsToWatch);
            }
        };
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .directive('sheetWorkedDays', sheetWorkedDays);


    /** @ngInject */
    function sheetWorkedDays(
        $filter,
        MongoF,
        directiveListenersFilter
    ) {
        return {
            require: '?ngModel',
            restrict: 'A',
            scope: {
                deductions: '<',
                period: '<',
                movements: '<',
                payroll: '<',
                perceptions: '<',
                incidencesTypes: '<',
                employeeId: '<',
                notCalculate: '<',
                dataloaded: '<',
                constants: '<',
                directiveFunctions: '=',
                process: '@',
                needToBalance: '<',
                exceeded: '<'
            },
            link: function (scope, ele, attrs, ngModel) {
                scope.M = MongoF;
                var getWorkedDays = function (startOfPeriod, endOfPeriod, daysOfPeriod, activeMovements) {
                    var matrix = $filter('getDaysMatrixOfMovements')(startOfPeriod, endOfPeriod, daysOfPeriod, activeMovements);
                    var wd = {
                        wd: matrix.wd(),
                        dismisses: matrix.daysRestedByDismisses.days,
                        enroles: matrix.daysAddedByEnroles.days,
                        dayWorth: matrix.dayWorth
                    };
                    return wd;
                };
                scope.calculate = function () {
                    //MongoF.loadNeeded(['paymentFrequenciesRecords']);
                    var movementsOrdered = $filter('orderBy')(scope.movements, 'data.date');
                    var absencesIncidences = $filter('getAbsencesIncidences')(scope.deductions);
                    var activeDays = $filter('activeDaysFromMovements')(movementsOrdered, scope.period, absencesIncidences);
                    var realWorkedDays = $filter('realWorkedDays')(activeDays);
                    var daysOfNaturalPeriod = $filter('timeDiff')(scope.period.start, scope.period.end, 'days') + 1;
                    var paymentFrequency = $filter('getObjectOfArrayById')(scope.payroll.paymentFrequency, MongoF.paymentFrequenciesRecords, '_id');
                    var holidays = $filter('getHolydays')(scope.perceptions, scope.incidencesTypes);
                    //console.log(holidays);
                    if (paymentFrequency) {
                        var daysOfFixedPeriod = paymentFrequency.days; // 30, 15, 14 o 7
                        var daysOfPeriod = (scope.payroll.data.typeOfDayForPayment === 'fixed') ? daysOfFixedPeriod : daysOfNaturalPeriod;
                        var allAbscences = $filter('getAbsences')(scope.deductions);
                        var absences = allAbscences.total;
                        var naturalWorkedDays = realWorkedDays;
                        naturalWorkedDays -= absences;
                        naturalWorkedDays -= holidays;
                        var workedDays = 0;
                        var workedDaysM = {};
                        if (scope.payroll.data.typeOfDayForPayment === 'fixed') {
                            workedDaysM = getWorkedDays(scope.period.start, scope.period.end, daysOfPeriod, activeDays);
                            if (naturalWorkedDays == 0) {
                                workedDays = 0;
                            } else {
                                workedDays = new Number(parseFloat(workedDaysM.wd - (absences * workedDaysM.dayWorth)).toFixed(2));
                                workedDays = new Number(parseFloat(workedDays - (holidays * workedDaysM.dayWorth)).toFixed(2));
                            }
                        } else {
                            // last way of doing it 
                            // var workedDays = parseInt(daysOfPeriod) - (parseInt(daysOfNaturalPeriod) - parseInt(realWorkedDays));
                            workedDays = parseInt(realWorkedDays);
                            workedDays -= absences;
                            workedDays -= holidays;
                        }
                        var calculation = {
                            data: {
                                typeOfDayForPayment: (scope.payroll.data.typeOfDayForPayment === 'fixed') ? 'Fijos' : 'Naturales',
                                daysOfFixedPeriod: daysOfFixedPeriod,
                                daysOfNaturalPeriod: daysOfNaturalPeriod,
                                daysOfPeriod: daysOfPeriod,
                                fastAbsences: allAbscences.fast,
                                normalAbscences: allAbscences.normal,
                                absences: absences,
                                holidays: holidays,
                                realWorkedDays: realWorkedDays,
                                activeDays: activeDays,
                                movements: movementsOrdered,
                                naturalWorkedDays: naturalWorkedDays,
                                workedDays: workedDays
                            },
                            formulas: [
                                '$daysOfPeriod = ($typeOfDayForPayment == "Fijos") ? $daysOfFixedPeriod : $daysOfNaturalPeriod',
                                '$workedDays = $daysAddedByEnroles - $daysDeductedByDismisses - $daysNotPaidInPayroll'
                            ],
                            value: {
                                name: $filter('translate')('c.DAYSWORKED'),
                                total: workedDays,
                                type: 'int',
                                weight: 1
                            }
                        };
                        if (scope.payroll.data.typeOfDayForPayment === 'fixed') {
                            calculation.data.daysAddedByEnroles = workedDaysM.enroles;
                            calculation.data.daysDeductedByDismisses = workedDaysM.dismisses;
                            calculation.data.dayWorth = workedDaysM.dayWorth;
                        }
                        // ngModel.$setViewValue(calculation);
                        // ngModel.$render();
                        return calculation;
                    } else {
                        throw "No existe registro de la frecuencia de pago";
                    }
                };
                var objsToWatch = ['deductions', 'movements', 'perceptions'];
                var filtersObjsToWatch = {
                    perceptions: {
                        filter: 'getHolydays',
                        param: scope.incidencesTypes
                    },
                    deductions: {
                        filter: 'getAffectDaysIncidences'
                    }
                };
                directiveListenersFilter(ngModel, 'Worked Days Directive', scope, scope.process, 'second', objsToWatch, scope.directiveFunctions, filtersObjsToWatch);
            }
        };
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .directive('sheetMensualizationFactor', sheetMensualizationFactor);


    /** @ngInject */
    function sheetMensualizationFactor() {
        return {
            require: '?ngModel',
            restrict: 'A',
            scope: {
                payroll: '<',
                period: '<',
                dataloaded: '<',
                constants: '<'
            },
            link: function (scope, ele, attrs, ngModel) {
                var calculate = function () {
                    if (scope.payroll.hasOwnProperty('data') && scope.period.hasOwnProperty('start')) {
                        var mensualizationFactor = (scope.payroll.data.typeOfDayForPayment === 'fixed') ? 30 : moment(scope.period.start).daysInMonth();
                        if (typeof (scope.constants) != "undefined" && typeof (scope.constants.mensualizationFactor) !== "undefined" && scope.constants.mensualizationFactor > 0) {
                            mensualizationFactor = scope.constants.mensualizationFactor;
                        }
                        ngModel.$setViewValue(mensualizationFactor);
                        ngModel.$render();
                    }
                };
                var listenerDataLoaded = scope.$watch('dataloaded', function (dataloaded) {
                    if (dataloaded) {
                        calculate();
                        listenerDataLoaded();
                    }
                }, true);
            }
        };
    }
}());

(function () {
    'use strict';

    angular
        .module ('app.clients')
        .directive ('formIncidencesRequest', formIncidencesRequest)
        .directive ('formIncidenceModal', formIncidenceModal)


    function formIncidencesRequest() {
        return {
            restrict: 'A',
            replace: false,
            scope: true,
            templateUrl: 'app/main/clients/views/incidencesRequests/forms/incidencesRequest.html'
        }
    }

    
    function formIncidenceModal() {
        return {
            restrict: 'A',
            replace: false,
            scope: true,
            templateUrl: 'app/main/clients/views/incidencesRequests/forms/incidence-modal.html'
        }
    }

} ());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('objsToArray', objsToArray)

    function objsToArray() {

        return objsToArrayFn;

        function objsToArrayFn(array, idKey, addId, setInValueProp) {
            var newArray = [];
            if (angular.isObject(array)) {
                angular.forEach(array, function (value, index) {
                    if (angular.isDefined(value) && value != null) {
                        if (setInValueProp || !angular.isObject(value)) {
                            var newObj = {};
                            newObj.value = value;
                            value = newObj;
                        }
                        value[idKey ? idKey : "$id"] = index;
                        if (addId) {
                            value[addId] = index;
                        }
                        newArray.push(value)
                    }
                });
            }
            return newArray;
        }
    }
}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('migrateLogs', migrateLogs)

    function migrateLogs(translateFilterFilter, loopEachFilter) {

        return migrateLogsFn;

        function migrateLogsFn(obj) {
            var logTranslation = translateFilterFilter(obj);
            var thisArray = [];
            loopEachFilter(logTranslation, function (value, key) {
                var thisObj = { key: key, value: value }
                thisArray.push(thisObj)
            })
            return thisArray;
        }
    }
}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('getTotalValideIncidences', getTotalValideIncidences)

    function getTotalValideIncidences() {

        return getTotalValideIncidencesFn;

        function getTotalValideIncidencesFn(incidences) {
            var total = 0;
            angular.forEach(incidences, function(incidence) {
                if(!incidence.remove){
                    total++;
                }
            });
            return total;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('getPeriodData', getPeriodData)

    function getPeriodData() {

        return getPeriodDataFn;

        function getPeriodDataFn(periodId, periods) {
            var p = {};
            angular.forEach(periods, function(period, index) {
                if (period.$id == periodId) {
                    p = period;
                    return false;
                }
            });
            return p;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.clients')
        .filter('getEmployeesObj', getEmployeesObj)

    function getEmployeesObj() {

        return getEmployeesObjFn;

        function getEmployeesObjFn(array) {
            var newArray = {};
            angular.forEach(array, function(value, index) {
                newArray[value]=true;
            });
            return newArray;
        }
    }

}());
/* eslint-disable no-unused-vars */
/**
 * @description Consulta un dato en cualquier documento de FB 
 * @param {string} route Recibe la ruta completa donde se va hacer la consulta ejemplo 'catalogs/rps/collection/'${key}'/active'
 * @return {promise} Regresa una promesa tipo Boolean
 */
(function () {
    'use strict';
    angular
        .module('app.clients')
        .filter('validateIncidences', validateIncidences)

    function validateIncidences(ListsF, DataF, AppF, objsToArrayFilter, getActiveEmployeesFilter, $log, $q, getFromObjectFilter) {

        return validateIncidencesFn;

        function validateIncidencesFn(records, operationType, payrollDefault, employees, payrollCalendars, activeOperations, periods, periodsIncidences, concepts) {
            return new Promise(function (resolve, reject) {
                if (angular.isUndefined(employees)) {
                    employees = {};
                }
                if (angular.isUndefined(payrollCalendars)) {
                    payrollCalendars = {};
                }
                if (angular.isUndefined(activeOperations)) {
                    activeOperations = {};
                }
                if (angular.isUndefined(periods)) {
                    periods = {};
                }
                if (angular.isUndefined(periodsIncidences)) {
                    periodsIncidences = {};
                }
                if (angular.isUndefined(concepts)) {
                    concepts = {};
                }
                var processed = [];
                var employeeNumbers = [];
                records = records.sort(function (a, b) {
                    return a.Empleado - b.Empleado;
                })
                var queryConcepts = [];
                var queryConceptsId = [];
                for (var r = 0; r < records.length && processed.length < 50; r++) {
                    if (!records[r].processed) {
                        records[r].processed = true;
                        records[r].errors = [];
                        var incidenceType = ListsF.incidencesTypes.find(function (item) {
                            return (item.id_human === records[r].Incidencia && item.payroll === records[r].payroll);
                        })
                        if (angular.isUndefined(incidenceType)) {
                            incidenceType = ListsF.incidencesTypes.find(function (item) {
                                return (item.id_human === records[r].Incidencia && item.payroll === 'global');
                            })
                        }
                        records[r].incidenceType = incidenceType;
                        if (angular.isUndefined(incidenceType)) {
                            records[r].errors.push('No se encontró el tipo de incidencia');
                        } else if (!incidenceType.allowManual || incidenceType.requireConfirmation) {
                            records[r].errors.push('No se permite ingresar este tipo de incidencia');
                        } else if (incidenceType.inputType === 'integer' && parseInt(records[r].Cantidad) !== records[r].Cantidad) {
                            records[r].errors.push('Esta incidencia solo admite enteros');
                        } else if ((!incidenceType.allowNegative) && parseFloat(records[r].Cantidad) < 0) {
                            records[r].errors.push('Esta incidencia solo admite números positivos');
                        } else if (incidenceType.validateDays) {
                            for (var i = 0; i < records.length; i++) {
                                if (r !== i && records[i].Fecha === records[r].Fecha && records[i].Empleado === records[r].Empleado && records[i].Incidencia === records[r].Incidencia) {
                                    records[r].errors.push('Ya existe una incidencia con la misma fecha', records[r].Fecha);
                                    break
                                }
                            }
                        }
                        if (operationType !== 'ptuDistributionRecord' && (!records[r].hasOwnProperty("FechaM") || !records[r].FechaM.isValid())) {
                            records[r].errors.push('El formato de la fecha no es valido');
                        }
                        if (isNaN(records[r].Cantidad)) {
                            records[r].errors.push('El formato de la cantidad no es valido');
                        }
                        if (records[r].errors.length === 0) {
                            processed.push(r);
                            if (employeeNumbers.indexOf(records[r].Empleado) === -1 && !employees.hasOwnProperty(records[r].Empleado)) {
                                employeeNumbers.push(records[r].Empleado)
                            }
                            if (!concepts.hasOwnProperty(records[r].incidenceType.$id)) {
                                queryConcepts.push(AppF.root.child('catalogs/concepts/collection/' + records[r].incidenceType.$id + '/processes').once('value'))
                                queryConceptsId.push(records[r].incidenceType.$id);
                            }
                        }
                    }
                }
                if (processed.length === 0) {
                    resolve(records);
                } else {
                    var params = { "data.employeeNumber": angular.toJson({ $in: employeeNumbers }) }
                    queryConcepts.push(DataF.api.get('employees', params))
                    Promise.all(queryConcepts).then(function (responses) {
                        var resp = responses.pop();
                        for (var r = 0; r < resp.data.length; r++) {
                            var employee = resp.data[r];
                            employee.movements = objsToArrayFilter(employee.movements);
                            employees[employee.data.employeeNumber] = employee;
                        }
                        for (var q = 0; q < queryConceptsId.length; q++) {
                            var thisConceptId = queryConceptsId[q];
                            concepts[thisConceptId] = responses[q].exists() ? responses[q].val() : {};
                        }
                        var newProcessed = [];
                        var thisPayrollCalendars = {};
                        var thisOpeType = angular.isUndefined(operationType) ? 'payroll' : operationType;
                        for (var p = 0; p < processed.length; p++) {
                            var index = processed[p];
                            var record = records[index];
                            var next = true;
                            var opeTypesAllowed = concepts[record.incidenceType.$id];
                            if (next) {
                                record.employee = angular.fromJson(angular.toJson(employees[record.Empleado]))
                                if (!opeTypesAllowed[thisOpeType]) {
                                    record.errors.push('Esta tipo de incidencia no se permite para este proceso');
                                    next = false;
                                }
                                if (!employees.hasOwnProperty(record.Empleado)) {
                                    record.errors.push("No se encontró el empleado");
                                    next = false;
                                }
                                if (operationType !== 'ptuDistributionRecord') {
                                    var untilDate = record.FechaM.clone();
                                    if (record.incidenceType.validateDays) {
                                        var days = record.Cantidad - 1;
                                        untilDate.add(days, 'day');
                                    }
                                    record.endDate = untilDate;
                                    var activeMovements = getActiveEmployeesFilter([record.employee], record.FechaM.valueOf(), untilDate.valueOf());
                                    if ((activeMovements.length > 0 && angular.isArray(activeMovements[0].movements) && activeMovements[0].movements.length > 0) || operationType === 'ptuRecord') {
                                        var payroll = payrollDefault;
                                        if (operationType !== 'ptuRecord') {
                                            record.activeMovements = activeMovements[0].movements;
                                            payroll = record.activeMovements[0].p;
                                        }
                                        record.payroll = payroll;
                                        newProcessed.push(index);
                                        if ((!payrollCalendars.hasOwnProperty(payroll)) && (!thisPayrollCalendars.hasOwnProperty(payroll))) {
                                            var activeCalendar = [{ q: 'orderByChild', v: 'data/active' }, { q: 'equalTo', v: true }, { q: 'limitToFirst', v: 1 }];
                                            var ref = 'catalogs/payrollCalendars/' + payroll + '/calendars';
                                            thisPayrollCalendars[payroll] = ListsF.loadList('payrollCalendars', ref, undefined, 'array', 'activeCalendarOf-' + payroll, activeCalendar);
                                        }
                                    } else {
                                        record.errors.push("No se encontraron movimientos activos de ese empleado");
                                    }
                                }

                            }
                        }
                        processed = newProcessed;
                        if (Object.keys(thisPayrollCalendars).length > 0) {
                            return $q.all(thisPayrollCalendars)
                        } else {
                            return Promise.all([])
                        }
                    }).then(function (payrollCalendarsR) {
                        if (!angular.isArray(payrollCalendarsR)) {
                            payrollCalendars = Object.assign(payrollCalendars, payrollCalendarsR);
                        }
                        var thisActiveOperations = {};
                        var thisPeriods = {};
                        if (operationType !== 'ptuDistributionRecord') {
                            for (var payroll in payrollCalendars) {
                                if (payrollCalendars.hasOwnProperty(payroll) && payrollCalendars[payroll].length > 0) {
                                    var calendar = payrollCalendars[payroll][0].$id;
                                    if (!activeOperations.hasOwnProperty(payroll) && !thisActiveOperations.hasOwnProperty(payroll)) {
                                        var activeOperation = [{ q: 'orderByChild', v: 'status' }, { q: 'startAt', v: 1 }, { q: 'endAt', v: 2.9 }, { q: 'limitToLast', v: 1 }];
                                        var refOpe = 'catalogs/operations/ordinary/' + payroll + '/' + calendar + '/collection';
                                        thisActiveOperations[payroll] = ListsF.loadList('operations', refOpe, undefined, 'array', 'activeOperationOf-' + payroll + 'year' + calendar, activeOperation);
                                    }
                                    if (!periods.hasOwnProperty(payroll) && !thisPeriods.hasOwnProperty(payroll)) {
                                        var refPer = 'catalogs/payrollCalendars/' + payroll + '/periods/' + calendar;
                                        thisPeriods[payroll] = ListsF.loadList('periods', refPer, undefined, 'array', 'periodOfYear-' + calendar + payroll);
                                    }
                                }
                            }
                        }
                        var promises = [];
                        if (Object.keys(thisActiveOperations).length > 0) {
                            promises.push($q.all(thisActiveOperations));
                        } else {
                            promises.push(Promise.all([]));
                        }
                        if (Object.keys(thisPeriods).length > 0) {
                            promises.push($q.all(thisPeriods));
                        } else {
                            promises.push(Promise.all([]));
                        }
                        return Promise.all(promises);
                    }).then(function (resp) {
                        var newProcessed = [];
                        var thisPeriodsIncidences = {};
                        if (operationType !== 'ptuDistributionRecord') {
                            if (!angular.isArray(resp[0])) {
                                activeOperations = Object.assign(activeOperations, resp[0]);
                            }
                            if (!angular.isArray(resp[1])) {
                                periods = Object.assign(periods, resp[1]);
                            }
                        }

                        for (var p = 0; p < processed.length; p++) {
                            var index = processed[p];
                            var record = records[index];
                            var activeOperation = getFromObjectFilter(activeOperations, record.payroll + ".0");
                            if (angular.isDefined(activeOperation)) {
                                var thisPeriods = getFromObjectFilter(periods, record.payroll, []);
                                thisPeriods.sort(function (a, b) {
                                    return a.start - b.start;
                                })
                                var activePeriod = thisPeriods.find(function (item) {
                                    return item.period === activeOperation.period;
                                });
                                if (angular.isDefined(activePeriod) && operationType !== 'ptuDistributionRecord') {
                                    var minDate = moment(activePeriod.start);
                                    if (record.FechaM >= minDate) {
                                        record.calendar = payrollCalendars[record.payroll][0].$id;
                                        var assignPeriod = thisPeriods.find(function (item) {
                                            return item.start <= record.FechaM.valueOf() && item.end > record.FechaM.valueOf();
                                        })
                                        if (angular.isDefined(assignPeriod)) {
                                            record.period = assignPeriod.period;
                                            var maxAllowed = undefined;
                                            if (record.incidenceType.max) {
                                                if (record.incidenceType.getMax) {
                                                    var data = { employee: record.employee };
                                                    maxAllowed = eval(record.incidenceType.max);
                                                } else {
                                                    maxAllowed = record.incidenceType.max;
                                                }
                                            }
                                            if (angular.isUndefined(maxAllowed) || record.Cantidad < maxAllowed) {
                                                if (record.incidenceType.validateDays && assignPeriod.end >= record.endDate.valueOf()) {
                                                    newProcessed.push(index);
                                                    var key = record.employee.fid + record.payroll + record.period;
                                                    if (!periodsIncidences.hasOwnProperty(key) && !thisPeriodsIncidences.hasOwnProperty(key)) {
                                                        var params = {
                                                            "period": angular.toJson({ $in: [record.period] }),
                                                            "employee": record.employee.fid
                                                        }
                                                        thisPeriodsIncidences[key] = DataF.api.get('incidences', params)
                                                    }
                                                } else if (record.incidenceType.validateDays && assignPeriod.end < record.endDate.valueOf()) {
                                                    record.errors.push("La incidencia abarca mas días que los asignables en el periodo");
                                                }
                                            } else {
                                                record.errors.push("No se puede ingresar mas de " + maxAllowed + " incidencia(s) de este tipo");
                                            }
                                        } else {
                                            record.errors.push("No se encontró un periodo para asignar la incidencia");
                                        }
                                    } else {
                                        record.errors.push("La fecha seleccionada no se encuentra en un periodo valido");
                                    }
                                } else if (operationType !== 'ptuDistributionRecord') {
                                    record.errors.push("No se encontró periodo activo del empleado");
                                }
                            } else if (operationType !== 'ptuDistributionRecord') {
                                record.errors.push("No se encontró calendario u operación activa del empleado");
                            }
                        }
                        processed = newProcessed;
                        if (Object.keys(thisPeriodsIncidences).length > 0) {
                            return $q.all(thisPeriodsIncidences)
                        } else {
                            return Promise.all([])
                        }
                    }).then(function (periodsIncidencesR) {
                        if (operationType === 'ptuDistributionRecord') {
                            if (!angular.isArray(periodsIncidencesR)) {
                                for (var periodIncs in periodsIncidencesR) {
                                    if (periodsIncidencesR.hasOwnProperty(periodIncs)) {
                                        var affectDaysIncidences = [];
                                        if (angular.isArray(periodsIncidencesR[periodIncs].data)) {
                                            var allIncidences = periodsIncidencesR[periodIncs].data;
                                            for (var a = 0; a < allIncidences.length; a++) {
                                                var thisIncidence = allIncidences[a];
                                                var incidenceType = ListsF.incidencesTypes.find(function (item) {
                                                    return item.$id == thisIncidence.incidenceType
                                                })
                                                if (angular.isDefined(incidenceType) && incidenceType.validateDays) {
                                                    affectDaysIncidences.push(thisIncidence)
                                                }
                                            }
                                        }
                                        periodsIncidences[periodIncs] = affectDaysIncidences;
                                    }
                                }
                            }

                            for (var p = 0; p < processed.length; p++) {
                                var index = processed[p];
                                var record = records[index];
                                var key = record.employee.fid + record.payroll + record.period;
                                var affectDInc = getFromObjectFilter(periodsIncidences, key, []);
                                var thereIsAny = affectDInc.find(function (item) {
                                    return item.date >= record.FechaM.valueOf() && item.date <= record.endDate.valueOf();
                                })
                                if (angular.isDefined(thereIsAny)) {
                                    record.errors.push("El empleado ya tiene alguna incidencia con esa fecha en ese periodo");
                                }
                            }
                        }
                        resolve(validateIncidencesFn(records, operationType, payrollDefault, employees, payrollCalendars, activeOperations, periods, periodsIncidences, concepts));
                    }).catch(reject);
                }
            })
        }
    }
}());
(function(){
    'use strict';

    angular
        .module('app.core')
        .filter('incidenceTypeName', incidenceTypeName)

    function incidenceTypeName(){

        return incidenceTypeNameFn;

        function incidenceTypeNameFn(type){
            var typeName = 'N/A';
            switch(type){
                case 'manual': typeName = 'Manual'; break;
                case 'fast': typeName = 'Rápida'; break;
                case 'automatic': typeName = 'Automática'; break;
                case 'request': typeName = 'Solicitud'; break;
                case 'constant': typeName = 'por Constante'; break;
                case 'system': typeName = 'Sistema'; break;
            }
            return typeName;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('incidenceStatusName', incidenceStatusName)

    function incidenceStatusName(AppF) {

        return incidenceStatusNameFn;

        function incidenceStatusNameFn(status) {
            var statusId = status;
            if (angular.isString(statusId)) {
                statusId = parseInt(statusId)
            }
            var indexKey = AppF.incidenceStatuss.findIndex(function (item) {
                return item.id === statusId;
            })
            var statusName = 'S/E';
            if (indexKey > -1) {
                statusName = AppF.incidenceStatuss[indexKey].name;
            }
            return statusName;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getIncidenceNotificationData', getIncidenceNotificationData)

    function getIncidenceNotificationData(
        $q,
        AppF,
        $filter
    ) {

        return getIncidenceNotificationDataFn;

        function getIncidenceNotificationDataFn(incidence) {
            var promise = $q.defer();
            var querys = {};
            var plainData = {};
            plainData.realSpan = 1;
            // acc setings
            plainData.styles = {
                td: 'border-bottom: 1px dotted #282c37; margin-right: 5px; margin-bottom: 5px; padding: 0px !important; ',
                strong: 'font-weight: 600;',
                br: 'line-height: 5px',
                hidden: 'display: none !important; visibility: hidden !important;'
            };

            querys.payrollName = AppF.root.child('lists/payrolls/all').child(incidence.payroll).child('name').once("value");
            querys.employeeName = AppF.root.child('catalogs/employees/collection').child(incidence.employee).child('data/name').once('value');
            querys.employeeNss = AppF.root.child('catalogs/employees/collection').child(incidence.employee).child('data/nss').once('value');
            querys.incidenceTypeName = AppF.root.child('lists/incidencesTypes/center/' + AppF.center).child(incidence.incidenceType).child('name').once('value');
            querys.createdBy = AppF.root.child('profiles').child(incidence.created.by).child('data/name').once('value');
            querys.capturedBy = AppF.root.child('profiles').child(AppF.profile.uid).child('data/name').once('value');
            var incidenceId = incidence.$id;
            plainData.incidence = $filter('clearObject')(incidence);
            if (typeof (incidenceId) !== 'undefined') {
                plainData.incidence.$id = incidenceId;
            }
            //data_incidence_date data_incidenceDate
            //data_incidence_status data_incidenceStatus

            //data_incidence_date|date:'dd-MM-yyyy',
            //data_incidence_status|incidenceStatusName,

            $q.all(querys).then(function (allData) {
                plainData.payrollName = allData.payrollName.val();
                plainData.employeeName = allData.employeeName.val();
                plainData.employeeNss = allData.employeeNss.val();
                plainData.incidenceTypeName = allData.incidenceTypeName.val();
                plainData.capturedBy = allData.capturedBy.val();
                plainData.createdBy = allData.createdBy.val();
                plainData.incidenceDate = $filter("date")(incidence.date, "dd-MM-yyyy");
                plainData.incidenceStatus = $filter("incidenceStatusName")(incidence.status)
                promise.resolve(plainData);

            }, function (err) {
                promise.reject(err);
            });

            return promise.promise;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .filter('getEmployeesOfPeriod', getEmployeesOfPeriod);

    function getEmployeesOfPeriod($rootScope, $q) {

        return getEmployeesOfPeriodFn;

        function getEmployeesOfPeriodFn(search, payrollId, from, to, extraFields, getMovements) {
            return $q(function (resolve, reject) {
                search = angular.isUndefined(search) ? '' : search;
                extraFields = angular.isUndefined(extraFields) || (!angular.isObject(extraFields)) ? ({}) : (extraFields);
                var queryAggregate = [
                    { $match: { 'payroll': payrollId, 'status': { $gt: 1 }, 'data.date': { $lte: to } } },
                    { $addFields: { "data.cc": "$cc", "data.rp": "$rp", "data.status": "$status", isBefore: { $cond: { if: { $lt: ['$data.date', from] }, then: true, else: false } } } },
                    { $sort: { 'employee': 1, 'data.date': 1 } },
                    {
                        $group:
                        {
                            _id: { 'employee': '$employee', 'isBefore': '$isBefore' },
                            lastMov: { $last: { $cond: ['$isBefore', '$data', '$$REMOVE'] } },
                            movs: { $push: { $cond: ['$isBefore', '$$REMOVE', '$data'] } },
                            isBefore: { $first: '$isBefore' },
                            employee: { $first: '$employee' }
                        }
                    },
                    { $match: { $or: [{ 'movs': { $exists: true, $not: { '$size': 0 } } }, { 'lastMov.type': { $ne: 2, $exists: true } }] } }

                ];
                if (getMovements) {
                    queryAggregate.push(
                        { $addFields: { movs: { $cond: [{ $isArray: "$movs" }, "$movs", []] } } },
                        { $project: { employee: 1, allMovs: { $concatArrays: [{ $cond: [{ $ifNull: ["$lastMov", false] }, ["$lastMov"], []] }, "$movs"] } } },
                        { $unwind: { path: "$allMovs", preserveNullAndEmptyArrays: true } },
                        { $sort: { employee: 1, "allMovs.date": 1 } }
                        // { $group: { _id: "$employee", lastMov: { $last: "$allMovs" } } }
                    )
                }
                queryAggregate.push(
                    { $group: { _id: '$employee', lastMov: { $last: "$allMovs" } } },
                    { $lookup: { from: 'employees', localField: '_id', foreignField: 'fid', as: 'employeeData' } },
                    { $unwind: '$employeeData' },
                    { $match: { $or: [{ 'employeeData.data.nss': { '$regex': '' + search, '$options': 'i' } }, { 'employeeData.data.name': { '$regex': '' + search, '$options': 'i' } }] } },
                    { $project: Object.assign(extraFields, { _id: 1, name: '$employeeData.data.name', nss: '$employeeData.data.nss', center: '$employeeData.center' }) }
                )
                var params = {
                    query: angular.toJson(queryAggregate)
                };
                $rootScope.D.api.post('aggregate/movements', params).then(function (resp) {
                    resolve(resp.data);
                }).catch(function (error) {
                    reject(error);
                });
            });
        }
    }

}());
/**
 * @description Consulta un dato en cualquier documento de FB 
 * @param {string} route Recibe la ruta completa donde se va hacer la consulta ejemplo 'catalogs/rps/collection/'${key}'/active'
 * @return {promise} Regresa una promesa tipo Boolean
 */
(function () {
    'use strict';
    angular
        .module('app.clients')
        .filter('formatIncidencesToImport', formatIncidencesToImport);

    function formatIncidencesToImport() {

        return formatIncidencesToImportFn;

        function formatIncidencesToImportFn(fileData, payroll, operationType) {
            var data = [];
            if (angular.isArray(fileData)) {
                for (var f = 0; f < fileData.length; f++) {
                    var thisData = fileData[f];
                    var thisQty = thisData.Cantidad;
                    thisQty = thisQty.replace(/\$/g, '');
                    thisQty = thisQty.replace(/,/g, '');
                    thisData.Cantidad = parseFloat(thisQty);
                    if (operationType !== "ptuDistributionRecord") {
                        thisData.FechaM = moment(thisData.Fecha, ['DD-MM-YYYY', 'DD/MM/YYYY']);
                        thisData.payroll = payroll;
                    }
                    thisData.Empleado = parseInt(thisData.Empleado);
                    thisData.recordNumber = f + 1;
                    thisData.Incidencia = thisData.Incidencia.trim();
                    data.push(thisData);
                }
            }
            return data;
        }
    }
}());
/**
 * @description Consulta un dato en cualquier documento de FB 
 * @param {string} route Recibe la ruta completa donde se va hacer la consulta ejemplo 'catalogs/rps/collection/'${key}'/active'
 * @return {promise} Regresa una promesa tipo Boolean
 */
(function () {
    'use strict';
    angular
        .module('app.clients')
        .filter('checkIfEnable', checkIfEnable)

    function checkIfEnable(AppF) {

        return checkIfEnableFn;

        function checkIfEnableFn(route) {
            return new Promise (function(resolve, reject){
                AppF.root.child(route).once('value').then(function(response){
                    var item = response.val();
                    resolve(item);
                }).catch(function(error){
                    reject(error);
                });
            })
        }
    }
}());
/**
 * @description Consulta un dato en cualquier documento de FB 
 * @param {string} route Recibe la ruta completa donde se va hacer la consulta ejemplo 'catalogs/rps/collection/'${key}'/active'
 * @return {promise} Regresa una promesa tipo Boolean
 */
(function () {
    'use strict';
    angular
        .module('app.clients')
        .filter('applyIncidences', applyIncidences)

    function applyIncidences($rootScope, $log, $timeout) {

        return applyIncidencesFn;

        function applyIncidencesFn(records, operationType, operationId, operationData) {
            return new Promise(function (resolve, reject) {
                var processed = [];
                var updates = {};
                for (var r = 0; r < records.length && processed.length < 50; r++) {
                    if (!records[r].applied && records[r].errors.length === 0) {
                        processed.push(r);
                        var record = records[r];
                        if (operationType === "ptuDistributionRecord") {
                            record.payroll = 'all';
                            record.calendar = operationData.calendar;
                        }
                        if (record.incidenceType.validateDays) {
                            for (var i = 0; i < record.Cantidad; i++) {
                                var id = $rootScope.F.root.child('incidences').push().key;
                                updates[record.payroll + '/' + record.calendar + '/' + id] = {
                                    calendar: parseInt(record.calendar),
                                    comments: record.Comentario || null,
                                    date: operationType === "ptuDistributionRecord" ? null : record.FechaM.valueOf(),
                                    employee: record.employee.fid,
                                    incidenceType: record.incidenceType.$id,
                                    payroll: record.payroll,
                                    period: operationType === "ptuDistributionRecord" ? null : parseInt(record.period),
                                    created: Object.assign({ comment: 'By import' }, $rootScope.D.getTimeObject()),
                                    status: 0,
                                    type: 'manual',
                                    value: 1
                                };
                                if (angular.isDefined(operationType)) {
                                    updates[record.payroll + '/' + record.calendar + '/' + id].operationType = operationType;
                                    updates[record.payroll + '/' + record.calendar + '/' + id][operationType] = operationId;
                                }
                                record.FechaM.add(1, 'day');
                            }
                        } else {
                            var id2 = $rootScope.F.root.child('incidences').push().key;
                            updates[record.payroll + '/' + record.calendar + '/' + id2] = {
                                calendar: parseInt(record.calendar),
                                comments: record.Comentario || null,
                                date: operationType === "ptuDistributionRecord" ? null : record.FechaM.valueOf(),
                                employee: record.employee.fid,
                                created: Object.assign({ comment: 'By import' }, $rootScope.D.getTimeObject()),
                                incidenceType: record.incidenceType.$id,
                                payroll: record.payroll,
                                period: operationType === "ptuDistributionRecord" ? null : parseInt(record.period),
                                status: 0,
                                type: 'manual',
                                value: record.Cantidad
                            };
                            if (angular.isDefined(operationType)) {
                                updates[record.payroll + '/' + record.calendar + '/' + id2].operationType = operationType;
                                updates[record.payroll + '/' + record.calendar + '/' + id2][operationType] = operationId;
                            }
                        }
                    }
                }
                $log.log(updates)
                if (processed.length === 0) {
                    resolve(true);
                } else {
                    $rootScope.F.root.child('incidences').update(updates).then(function () {
                        for (var p = 0; p < processed.length; p++) {
                            var index = processed[p];
                            var record = records[index];
                            record.applied = true;
                        }
                        $rootScope.$evalAsync();
                        $timeout(function () {
                            resolve(applyIncidencesFn(records, operationType, operationId));
                        }, 0, false)
                    }).catch(reject);
                }
            })
        }
    }
}());
(function () {
    'use strict';

    angular
        .module('app.catalogs', [])
        .config(config);

    /** @ngInject */
    function config(
        $stateProvider,
        $translatePartialLoaderProvider
    ) {
        // State
        $stateProvider
            .state('app.other', {
                abstract: true,
                url: '/other'
            })
            .state('app.locations', {
                abstract: true,
                url: '/locations'
            })
            .state('app.records', {
                abstract: true,
                url: '/records'
            })
            .state('app.other.banks', {
                url: '/banks',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/banks/banks.html',
                        controller: 'MongoListsController'
                    }
                },
                bodyClass: 'banks'
            })
            .state('app.other.banks.edit', {
                url: '/:bankId',
                params: {
                    bank: null,
                    banks: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/banks/bank.html',
                        controller: 'MongoDetailController'
                    }
                },
                bodyClass: 'banks'
            })
            .state('app.other.bankAccounts', {
                url: '/bankAccounts',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/bankAccounts/bankAccounts.html',
                        controller: 'MongoListsController'
                    }
                },
                bodyClass: 'banks'
            })
            .state('app.other.bankAccounts.edit', {
                url: '/:bankAccountId',
                params: {
                    bankAccount: null,
                    bankAccounts: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/bankAccounts/bankAccount.html',
                        controller: 'MongoDetailController'
                    }
                },
                bodyClass: 'banks'
            })
            .state('app.other.directives', {
                url: '/directives',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/directives/directives.html',
                        controller: 'MongoListsController'
                    }
                },
                bodyClass: 'directives'
            })
            .state('app.other.directives.edit', {
                url: '/:directiveId',
                params: {
                    directive: null,
                    directives: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/directives/directive.html',
                        controller: 'MongoDetailController'
                    }
                },
                bodyClass: 'directives'
            })
            .state('app.other.filters', {
                url: '/filters',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/filters/filters.html',
                        controller: 'MongoListsController'
                    }
                },
                bodyClass: 'filters'
            })
            .state('app.other.filters.edit', {
                url: '/:filterId',
                params: {
                    filter: null,
                    filters: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/filters/filter.html',
                        controller: 'MongoDetailController'
                    }
                },
                bodyClass: 'filters'
            })
            .state('app.other.paymentForms', {
                url: '/paymentForms',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/payment-forms/payment-forms.html',
                        controller: 'MongoListsController'
                    }
                },
                bodyClass: 'paymentForms'
            })
            .state('app.other.paymentForms.edit', {
                url: '/:paymentFormId',
                params: {
                    paymentForm: null,
                    paymentForms: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/payment-forms/payment-form.html',
                        controller: 'MongoDetailController'
                    }
                },
                bodyClass: 'paymentForms'
            })
            .state('app.locations.countriesRecords', {
                url: '/countriesRecords',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/countries-records/countries-records.html',
                        controller: 'MongoListsController'
                    }
                },
                bodyClass: 'countriesRecords'
            })
            .state('app.locations.countriesRecords.edit', {
                url: '/:countriesRecordId',
                params: {
                    countriesRecord: null,
                    countriesRecords: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/countries-records/countries-record.html',
                        controller: 'MongoDetailController'
                    }
                },
                bodyClass: 'countriesRecords'
            })
            .state('app.other.dismissTypes', {
                url: '/dismissTypes',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/dismiss-types/dismiss-types.html',
                        controller: 'MongoListsController'
                    }
                },
                bodyClass: 'dismissTypes'
            })
            .state('app.other.dismissTypes.edit', {
                url: '/:dismissTypeId',
                params: {
                    dismissType: null,
                    dismissTypes: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/dismiss-types/dismiss-type.html',
                        controller: 'MongoDetailController'
                    }
                },
                bodyClass: 'dismissTypes'
            })
            .state('app.locations.geoZones', {
                url: '/geoZones',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/geo-zones/geo-zones.html',
                        controller: 'MongoListsController'
                    }
                },
                bodyClass: 'geoZones'
            })
            .state('app.locations.geoZones.edit', {
                url: '/:geoZoneId',
                params: {
                    geoZone: null,
                    geoZones: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/geo-zones/geo-zone.html',
                        controller: 'MongoDetailController'
                    }
                },
                bodyClass: 'geoZones'
            })
            .state('app.records.imssRecords', {
                url: '/imssRecords',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/imss-records/imss-records.html',
                        controller: 'MongoListsController'
                    }
                },
                bodyClass: 'imssRecords'
            })
            .state('app.records.imssRecords.edit', {
                url: '/:imssRecordId',
                params: {
                    imssRecord: null,
                    imssRecords: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/imss-records/imss-record.html',
                        controller: 'MongoDetailController'
                    }
                },
                bodyClass: 'imssRecords'
            })
            .state('app.other.incidencesStatusRecords', {
                url: '/incidencesStatusRecords',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/incidences-status-records/incidences-status-records.html',
                        controller: 'MongoListsController'
                    }
                },
                bodyClass: 'incidencesStatusRecords'
            })
            .state('app.other.incidencesStatusRecords.edit', {
                url: '/:incidencesStatusRecordId',
                params: {
                    incidencesStatusRecord: null,
                    incidencesStatusRecords: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/incidences-status-records/incidences-status-record.html',
                        controller: 'MongoDetailController'
                    }
                },
                bodyClass: 'incidencesStatusRecords'
            })
            .state('app.records.isrRecords', {
                url: '/isrRecords',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/isr-records/isr-records.html',
                        controller: 'MongoListsController'
                    }
                },
                bodyClass: 'isrRecords'
            })
            .state('app.records.isrRecords.edit', {
                url: '/:isrRecordId',
                params: {
                    isrRecord: null,
                    isrRecords: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/isr-records/isr-record.html',
                        controller: 'MongoDetailController'
                    }
                },
                bodyClass: 'isrRecords'
            })
            .state('app.records.cyvRecords', {
                url: '/cyvRecords',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/cyv-records/cyv-records.html',
                        controller: 'MongoListsController'
                    }
                },
                bodyClass: 'cyvRecords'
            })
            .state('app.records.cyvRecords.edit', {
                url: '/:cyvRecordId',
                params: {
                    cyvRecord: null,
                    cyvRecords: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/cyv-records/cyv-record.html',
                        controller: 'MongoDetailController'
                    }
                },
                bodyClass: 'cyvRecords'
            })
            .state('app.other.issuers', {
                url: '/issuers',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/issuers/issuers.html',
                        controller: 'MongoListsController'
                    }
                },
                bodyClass: 'issuers'
            })
            .state('app.other.issuers.edit', {
                url: '/:issuerId',
                params: {
                    issuer: null,
                    issuers: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/issuers/issuer.html',
                        controller: 'MongoDetailController'
                    }
                },
                bodyClass: 'issuers'
            })
            .state('app.records.minimumWageRecords', {
                url: '/minimumWageRecords',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/minimum-wage-records/minimum-wage-records.html',
                        controller: 'MongoListsController'
                    }
                },
                bodyClass: 'minimumWageRecords'
            })
            .state('app.records.minimumWageRecords.edit', {
                url: '/:minimumWageRecordId',
                params: {
                    minimumWageRecord: null,
                    minimumWageRecords: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/minimum-wage-records/minimum-wage-record.html',
                        controller: 'MongoDetailController'
                    }
                },
                bodyClass: 'minimumWageRecords'
            })
            .state('app.records.umaRecords', {
                url: '/umaRecords',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/uma-records/uma-records.html',
                        controller: 'MongoListsController'
                    }
                },
                bodyClass: 'umaRecords'
            })
            .state('app.records.umaRecords.edit', {
                url: '/:umaRecordId',
                params: {
                    umaRecord: null,
                    umaRecords: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/uma-records/uma-record.html',
                        controller: 'MongoDetailController'
                    }
                },
                bodyClass: 'umaRecords'
            })
            .state('app.records.nfdRecords', {
                url: '/nfdRecords',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/nfd-records/nfd-records.html',
                        controller: 'MongoListsController'
                    }
                },
                bodyClass: 'nfdRecords'
            })
            .state('app.records.nfdRecords.edit', {
                url: '/:nfdRecordId',
                params: {
                    nfdRecord: null,
                    nfdRecords: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/nfd-records/nfd-record.html',
                        controller: 'MongoDetailController'
                    }
                },
                bodyClass: 'nfdRecords'
            })
            .state('app.other.monthForAccumulatedRecords', {
                url: '/monthForAccumulatedRecords',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/month-for-accumulated-records/month-for-accumulated-records.html',
                        controller: 'MongoListsController'
                    }
                },
                bodyClass: 'monthForAccumulatedRecords'
            })
            .state('app.other.monthForAccumulatedRecords.edit', {
                url: '/:monthForAccumulatedRecordId',
                params: {
                    monthForAccumulatedRecord: null,
                    monthForAccumulatedRecords: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/month-for-accumulated-records/month-for-accumulated-record.html',
                        controller: 'MongoDetailController'
                    }
                },
                bodyClass: 'monthForAccumulatedRecords'
            })
            .state('app.other.paymentFrequenciesRecords', {
                url: '/paymentFrequenciesRecords',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/payment-frequencies-records/payment-frequencies-records.html',
                        controller: 'MongoListsController'
                    }
                },
                bodyClass: 'paymentFrequenciesRecords'
            })
            .state('app.other.paymentFrequenciesRecords.edit', {
                url: '/:paymentFrequenciesRecordId',
                params: {
                    paymentFrequenciesRecord: null,
                    paymentFrequenciesRecords: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/payment-frequencies-records/payment-frequencies-record.html',
                        controller: 'MongoDetailController'
                    }
                },
                bodyClass: 'paymentFrequenciesRecords'
            })
            .state('app.other.paymentGroups', {
                url: '/paymentGroups',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/payment-groups/payment-groups.html',
                        controller: 'MongoListsController'
                    }
                },
                bodyClass: 'paymentGroups'
            })
            .state('app.other.paymentGroups.edit', {
                url: '/:paymentGroupId',
                params: {
                    paymentGroup: null,
                    paymentGroups: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/payment-groups/payment-group.html',
                        controller: 'MongoDetailController'
                    }
                },
                bodyClass: 'paymentGroups'
            })
            .state('app.locations.placesOfWorkRecords', {
                url: '/placesOfWorkRecords',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/places-of-work-records/places-of-work-records.html',
                        controller: 'MongoListsController'
                    }
                },
                bodyClass: 'placesOfWorkRecords'
            })
            .state('app.locations.placesOfWorkRecords.edit', {
                url: '/:placesOfWorkRecordId',
                params: {
                    placesOfWorkRecord: null,
                    placesOfWorkRecords: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/places-of-work-records/places-of-work-record.html',
                        controller: 'MongoDetailController'
                    }
                },
                bodyClass: 'placesOfWorkRecords'
            })
            .state('app.other.regimes', {
                url: '/regimes',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/regimes/regimes.html',
                        controller: 'MongoListsController'
                    }
                },
                bodyClass: 'regimes'
            })
            .state('app.other.regimes.edit', {
                url: '/:regimeId',
                params: {
                    regime: null,
                    regimes: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/regimes/regime.html',
                        controller: 'MongoDetailController'
                    }
                },
                bodyClass: 'regimes'
            })
            .state('app.other.riskClassesRecords', {
                url: '/riskClassesRecords',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/risk-classes-records/risk-classes-records.html',
                        controller: 'MongoListsController'
                    }
                },
                bodyClass: 'riskClassesRecords'
            })
            .state('app.other.riskClassesRecords.edit', {
                url: '/:riskClassesRecordId',
                params: {
                    riskClassesRecord: null,
                    riskClassesRecords: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/risk-classes-records/risk-classes-record.html',
                        controller: 'MongoDetailController'
                    }
                },
                bodyClass: 'riskClassesRecords'
            })
            .state('app.other.salaryTypes', {
                url: '/salaryTypes',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/salary-types/salary-types.html',
                        controller: 'MongoListsController'
                    }
                },
                bodyClass: 'salaryTypes'
            })
            .state('app.other.salaryTypes.edit', {
                url: '/:salaryTypeId',
                params: {
                    salaryType: null,
                    salaryTypes: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/salary-types/salary-type.html',
                        controller: 'MongoDetailController'
                    }
                },
                bodyClass: 'salaryTypes'
            })
            .state('app.locations.states', {
                url: '/states',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/states/states.html',
                        controller: 'MongoListsController'
                    }
                },
                bodyClass: 'states'
            })
            .state('app.locations.states.edit', {
                url: '/:stateId',
                params: {
                    state: null,
                    states: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/states/state.html',
                        controller: 'MongoDetailController'
                    }
                },
                bodyClass: 'states'
            })
            .state('app.records.subsidyRecords', {
                url: '/subsidyRecords',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/subsidy-records/subsidy-records.html',
                        controller: 'MongoListsController'
                    }
                },
                bodyClass: 'subsidyRecords'
            })
            .state('app.records.subsidyRecords.edit', {
                url: '/:subsidyRecordId',
                params: {
                    subsidyRecord: null,
                    subsidyRecords: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/subsidy-records/subsidy-record.html',
                        controller: 'MongoDetailController'
                    }
                },
                bodyClass: 'subsidyRecords'
            })

            .state('app.locations.placeTypes', {
                url: '/placeTypes',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/placeTypes/placeTypes.html',
                        controller: 'MongoListsController'
                    }
                },
                bodyClass: 'placeTypes'
            })
            .state('app.locations.placeTypes.edit', {
                url: '/:placeTypeId',
                params: {
                    placeType: null,
                    placeTypes: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/placeTypes/placeType.html',
                        controller: 'MongoDetailController'
                    }
                },
                bodyClass: 'placeType'
            })
            .state('app.locations.zipCodes', {
                url: '/zipCodes',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/zipCodes/zipCodes.html',
                        controller: 'MongoListsController'
                    }
                },
                bodyClass: 'zipCodes'
            })
            .state('app.locations.zipCodes.edit', {
                url: '/:zipCodeId',
                params: {
                    zipCode: null,
                    zipCodes: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/zipCodes/zipCode.html',
                        controller: 'MongoDetailController'
                    }
                },
                bodyClass: 'zipCode'
            })
            .state('app.locations.towns', {
                url: '/towns',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/towns/towns.html',
                        controller: 'MongoListsController'
                    }
                },
                bodyClass: 'towns'
            })
            .state('app.locations.towns.edit', {
                url: '/:townId',
                params: {
                    town: null,
                    towns: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/towns/town.html',
                        controller: 'MongoDetailController'
                    }
                },
                bodyClass: 'towns'
            })
            .state('app.other.workDays', {
                url: '/workDays',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/work-days/work-days.html',
                        controller: 'MongoListsController'
                    }
                },
                bodyClass: 'workDays'
            })
            .state('app.other.workDays.edit', {
                url: '/:workDayId',
                params: {
                    workDay: null,
                    workDays: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/work-days/work-day.html',
                        controller: 'MongoDetailController'
                    }
                },
                bodyClass: 'workDays'
            })
            .state('app.other.workerTypes', {
                url: '/workerTypes',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/worker-types/worker-types.html',
                        controller: 'MongoListsController'
                    }
                },
                bodyClass: 'workerTypes'
            })
            .state('app.other.workerTypes.edit', {
                url: '/:workerTypeId',
                params: {
                    workerType: null,
                    workerTypes: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/worker-types/worker-type.html',
                        controller: 'MongoDetailController'
                    }
                },
                bodyClass: 'workerTypes'
            })
            .state('app.other.unions', {
                url: '/unions',
                params: {
                    unions: null,
                    union: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/unions/unions.html',
                        controller: 'MongoListsController'
                    }
                },
                bodyClass: 'clients'
            })
            .state('app.other.unions.edit', {
                url: '/:unionId',
                params: {
                    unions: null,
                    union: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/unions/union.html',
                        controller: 'MongoDetailController'
                    }
                },
                bodyClass: 'clients'
            })
            .state('app.other.streetTypes', {
                url: '/streetTypes',
                params: {
                    streetTypes: null,
                    streetType: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/street-types/street-types.html',
                        controller: 'MongoListsController'
                    }
                },
                bodyClass: 'clients'
            })
            .state('app.other.streetTypes.edit', {
                url: '/:streetTypeId',
                params: {
                    streetTypes: null,
                    streetType: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/street-types/street-type.html',
                        controller: 'MongoDetailController'
                    }
                },
                bodyClass: 'clients'
            })
            .state('app.other.relationships', {
                url: '/relationships',
                params: {
                    relationship: null,
                    relationships: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/relationships/relationships.html',
                        controller: 'MongoListsController'
                    }
                },
                bodyClass: 'clients'
            })
            .state('app.other.relationships.edit', {
                url: '/:relationshipId',
                params: {
                    relationship: null,
                    relationships: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/relationships/relationship.html',
                        controller: 'MongoDetailController'
                    }
                },
                bodyClass: 'clients'
            })
            .state('app.other.societyTypes', {
                url: '/societyTypes',
                params: {
                    societyType: null,
                    societyTypes: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/societyTypes/societyTypes.html',
                        controller: 'MongoListsController'
                    }
                },
                bodyClass: 'clients'
            })
            .state('app.other.societyTypes.edit', {
                url: '/:societyTypeId',
                params: {
                    societyType: null,
                    societyTypes: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/societyTypes/societyType.html',
                        controller: 'MongoDetailController'
                    }
                },
                bodyClass: 'clients'
            });
        $translatePartialLoaderProvider.addPart('app/main/catalogs');
    }
})();
(function () {
    "use strict";

    angular
        .module("app.catalogs")
        .controller("BatchRecordModalController", BatchRecordModalController);

    function BatchRecordModalController($scope, $mdDialog, $rootScope, $log, batchRecord, action, AppF, ApiV2F, errAlertS, MongoF, successAlertS) {
        var vm = this;
        vm.batchRecord = batchRecord;
        vm.action = action;
        vm.statusBatchRecords = AppF.statusBatchRecords;
        vm.statusQueueBatchRecords = AppF.statusQueueBatchRecords;
        vm.batchDetails = [];
        vm.dismissTypes = MongoF.dismissTypes;
        vm.salaryTypes = MongoF.salaryTypes;
        vm.workerTypes = MongoF.workerTypes;
        vm.workDays = MongoF.workDays;
        vm.tasks = [];
        function init() {
            getBatchRecord();
            getBatchDetails();
            getTasks();
        }

        function getBatchRecord() {
            ApiV2F.get('api/batchRecords/' + batchRecord._id).then(function (response) {
                vm.batchRecord = response.data;
                $rootScope.$evalAsync();
            }).catch(errAlertS);
        }

        function getBatchDetails() {
            var query = { batchRecordFid: batchRecord.fid }
            ApiV2F.get('api/batchDetails', query).then(function (response) {
                vm.batchDetails = response.data.map(function (item) {
                    var names = [item.names];
                    if (item.paternalSurname) {
                        names.push(item.paternalSurname);
                    }
                    if (item.maternalSurname) {
                        names.push(item.maternalSurname);
                    }
                    item.name = names.join(' ');
                    return item;
                });
                $rootScope.$evalAsync();
            }).catch(errAlertS);
        }
        function getTasks() {
            var query = { batchRecordId: batchRecord.fid }
            ApiV2F.get('tasks/find', query).then(function (response) {
                vm.tasks = response.data.map(function (item) {
                    item.executionTime = item.opts.timestamp + item.opts.delay;
                    return item;
                });
                $rootScope.$evalAsync();
            }).catch(errAlertS);
        }
        vm.fireWebhook = function (elementId) {
            $rootScope.loadingProgress = true;
            ApiV2F.post('tasks/add', { "type": "five-queue", "action": "executeWebhook", element: 'batchRecord', elementId: elementId, force: true }).then(function () {
                successAlertS('Se enviara el webhook en unos momentos');
                $rootScope.loadingProgress = false;
            }).catch(function (error) {
                $rootScope.loadingProgress = false;
                errAlertS(error)
            });
        }

        vm.save = function (batchRecord, addTask) {
            $rootScope.loadingProgress = true;
            var data = Object.assign({}, batchRecord);
            var mId = data._id;
            delete data._id;
            ApiV2F.put('api/batchRecords/' + mId, data).then(function () {
                var promises = [];
                if (addTask) {
                    promises.push(ApiV2F.post('tasks/add', { "type": "one-queue", "action": "executeBatchRecordAction", "batchRecordId": data.fid }))
                }
                return Promise.all(promises);
            }).then(function () {
                $mdDialog.hide(true);
                successAlertS('Guardado correctamente');
                $rootScope.loadingProgress = false;
            }).catch(function (error) {
                $rootScope.loadingProgress = false;
                errAlertS(error)
            });
        }
        vm.cancel = function () {
            $mdDialog.cancel();
        };

        init();
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.todo', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.to-do', {
            url      : '/to-do',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/todo/todo.html',
                    controller : 'TodoController as vm'
                }
            },
            resolve  : {
                Tasks: function (msApi)
                {
                    return msApi.resolve('todo.tasks@get');
                },
                Tags : function (msApi)
                {
                    return msApi.resolve('todo.tags@get');
                }
            },
            bodyClass: 'todo'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/todo');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.todo')
        .controller('TaskDialogController', TaskDialogController);

    /** @ngInject */
    function TaskDialogController($mdDialog, Task, Tasks, event)
    {
        var vm = this;

        // Data
        vm.title = 'Edit Task';
        vm.task = angular.copy(Task);
        vm.tasks = Tasks;
        vm.newTask = false;

        if ( !vm.task )
        {
            vm.task = {
                'id'                : '',
                'title'             : '',
                'notes'             : '',
                'startDate'         : new Date(),
                'startDateTimeStamp': new Date().getTime(),
                'dueDate'           : '',
                'dueDateTimeStamp'  : '',
                'completed'         : false,
                'starred'           : false,
                'important'         : false,
                'deleted'           : false,
                'tags'              : []
            };
            vm.title = 'New Task';
            vm.newTask = true;
            vm.task.tags = [];
        }

        // Methods
        vm.addNewTask = addNewTask;
        vm.saveTask = saveTask;
        vm.deleteTask = deleteTask;
        vm.newTag = newTag;
        vm.closeDialog = closeDialog;

        //////////

        /**
         * Add new task
         */
        function addNewTask()
        {
            vm.tasks.unshift(vm.task);

            closeDialog();
        }

        /**
         * Save task
         */
        function saveTask()
        {
            // Dummy save action
            for ( var i = 0; i < vm.tasks.length; i++ )
            {
                if ( vm.tasks[i].id === vm.task.id )
                {
                    vm.tasks[i] = angular.copy(vm.task);
                    break;
                }
            }

            closeDialog();
        }

        /**
         * Delete task
         */
        function deleteTask()
        {
            var confirm = $mdDialog.confirm()
                .title('Are you sure?')
                .content('The Task will be deleted.')
                .ariaLabel('Delete Task')
                .ok('Delete')
                .cancel('Cancel')
                .targetEvent(event);

            $mdDialog.show(confirm).then(function ()
            {
                // Dummy delete action
                for ( var i = 0; i < vm.tasks.length; i++ )
                {
                    if ( vm.tasks[i].id === vm.task.id )
                    {
                        vm.tasks[i].deleted = true;
                        break;
                    }
                }
            }, function ()
            {
                // Cancel Action
            });
        }


        /**
         * New tag
         *
         * @param chip
         * @returns {{label: *, color: string}}
         */
        function newTag(chip)
        {
            var tagColors = ['#388E3C', '#F44336', '#FF9800', '#0091EA', '#9C27B0'];

            return {
                name : chip,
                label: chip,
                color: tagColors[Math.floor(Math.random() * (tagColors.length))]
            };
        }

        /**
         * Close dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.notes', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider)
    {
        $stateProvider.state('app.notes', {
            url    : '/notes',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/notes/notes.html',
                    controller : 'NotesController as vm'
                }
            },
            resolve: {
                Notes : function (NotesService)
                {
                    return NotesService.getData();
                },
                Labels: function (LabelsService)
                {
                    return LabelsService.getData();
                }
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/notes');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.notes')
        .controller('msNoteItemController', msNoteItemController)
        .directive('msNoteItem', msNoteItemDirective);

    /** @ngInject */
    function msNoteItemController($document)
    {
        var vm = this;
        var fontSizes = {
            '1': {
                fontSize  : 14,
                lineHeight: 19
            },
            '2': {
                fontSize  : 18,
                lineHeight: 28
            },
            '3': {
                fontSize  : 24,
                lineHeight: 36
            },
            '4': {
                fontSize  : 36,
                lineHeight: 48
            },
            '5': {
                fontSize  : 48,
                lineHeight: 60
            }
        };

        vm.element = [];
        vm.noFontResize = false;

        // Methods
        vm.updateDescriptionFontSize = updateDescriptionFontSize;

        //////

        function updateDescriptionFontSize()
        {
            if ( vm.noFontResize || !vm.note.description || vm.note.description === '' )
            {
                return;
            }

            var fontSize = '';
            var descWidth = Math.floor(vm.columnWidth - 52); // 48px paddings, + 4px tolerance
            var tmp = angular.element('<div style="visibility:hidden; font-size:10px;line-height: 10px;position:absolute;z-index:-1;white-space:pre-wrap;word-wrap: break-word;"></div>');
            tmp.appendTo($document.find('body'));

            fontSize = checkLineCount(sizeFromMaxWordCount());

            angular.element(vm.element).find('md-description').attr('font-size', fontSize);

            tmp.remove();

            function sizeFromMaxWordCount()
            {
                var words = vm.note.description.split(' ');

                var wordLengths = words.map(function (word)
                {
                    return tmp.text(word)[0].clientWidth;
                });

                var maxWordLength = Math.max.apply(Math, wordLengths);

                var maxPx = Math.floor((descWidth * 10) / maxWordLength);

                if ( maxPx < 18 )
                {
                    fontSize = 1;
                }
                else if ( 18 <= maxPx && maxPx < 24 )
                {
                    fontSize = 2;
                }
                else if ( 24 <= maxPx && maxPx < 36 )
                {
                    fontSize = 3;
                }
                else if ( 36 <= maxPx && maxPx < 48 )
                {
                    fontSize = 4;

                }
                else if ( maxPx >= 48 )
                {
                    fontSize = 5;
                }
                return fontSize;
            }

            function checkLineCount(sizeFromMaxWord)
            {
                var size = fontSizes[sizeFromMaxWord];
                var result;

                tmp.text(vm.note.description);
                tmp.width(descWidth);
                tmp.css({
                    'line-height': size.lineHeight + 'px',
                    'font-size'  : size.fontSize + 'px'
                });

                var lineCount = tmp[0].clientHeight / size.lineHeight;

                if ( 4 < lineCount && lineCount < 6 )
                {
                    result = 4;
                }
                else if ( 6 <= lineCount && lineCount < 9 )
                {
                    result = 3;
                }
                else if ( 9 <= lineCount && lineCount < 11 )
                {
                    result = 2;
                }
                else if ( 11 <= lineCount )
                {
                    result = 1;
                }
                else
                {
                    result = sizeFromMaxWord;
                }
                return result;
            }
        }
    }

    /** @ngInject */
    function msNoteItemDirective()
    {
        return {
            restrict        : 'A',
            controller      : 'msNoteItemController as MsNoteItem',
            templateUrl     : 'app/main/apps/notes/directives/ms-note-item/ms-note-item.html',
            require         : ['msNoteItem', '^msMasonry'],
            bindToController: {
                msNoteItem: '='
            },
            link            : function (scope, element, attributes, controllers)
            {

                var MsNoteItem = controllers[0];
                var msMasonry = controllers[1];

                MsNoteItem.element = element;
                MsNoteItem.note = MsNoteItem.msNoteItem;


                if ( angular.isDefined(attributes.noFontResize) )
                {
                    MsNoteItem.noFontResize = true;
                }

                scope.$watch('MsNoteItem.msNoteItem', function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        MsNoteItem.note = newVal;
                    }
                });

                scope.$on('msMasonryItem:startReLayout', function ()
                {
                    if ( MsNoteItem.noFontResize || MsNoteItem.columnWidth === msMasonry.columnWidth )
                    {
                        return;
                    }

                    MsNoteItem.columnWidth = msMasonry.columnWidth;

                    MsNoteItem.updateDescriptionFontSize();
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.notes')
        .controller('msNoteFormController', msNoteFormController)
        .directive('msNoteForm', msNoteFormDirective);

    /** @ngInject */
    function msNoteFormController($scope, NotesService, msUtils, $mdDialog, $timeout, LabelsService)
    {
        var MsNoteForm = this;
        var notes = NotesService.data;

        //Data
        MsNoteForm.type = '';
        MsNoteForm.defaultNote = {
            'id'         : '',
            'title'      : '',
            'description': '',
            'archive'    : false,
            'image'      : '',
            'color'      : '',
            'time'       : new Date().toISOString(),
            'reminder'   : null,
            'checklist'  : [],
            'labels'     : []
        };
        MsNoteForm.noteId = '';
        MsNoteForm.editNode = {};
        MsNoteForm.newCheckListItem = '';
        MsNoteForm.checkListForm = false;
        MsNoteForm.labels = LabelsService.data;

        MsNoteForm.ngFlowOptions = {
            singleFile: true
            // You can configure the ngFlow from here
            /*target                   : 'api/media/image',
             chunkSize                : 15 * 1024 * 1024,
             maxChunkRetries          : 1,
             simultaneousUploads      : 1,
             testChunks               : false,
             progressCallbacksInterval: 1000*/
        };
        MsNoteForm.ngFlow = {
            // ng-flow will be injected into here through its directive
            flow: {}
        };

        //Methods
        MsNoteForm.init = init;
        MsNoteForm.submit = submit;
        MsNoteForm.isNotValid = isNotValid;
        MsNoteForm.deleteNote = deleteNote;
        MsNoteForm.deleteImage = deleteImage;
        MsNoteForm.addChecklistItem = addChecklistItem;
        MsNoteForm.checklistFormToggle = checklistFormToggle;
        MsNoteForm.deleteCheckItem = deleteCheckItem;
        MsNoteForm.toggleArchive = toggleArchive;
        MsNoteForm.toggleInArray = msUtils.toggleInArray;
        MsNoteForm.exists = msUtils.exists;
        MsNoteForm.upload = upload;
        MsNoteForm.imageSuccess = imageSuccess;

        //////

        /**
         * Initialize
         */
        function init()
        {
            // If form type edit
            if ( MsNoteForm.type === 'edit' )
            {
                MsNoteForm.editNode = notes.getById(MsNoteForm.noteId);
                MsNoteForm.note = angular.copy(MsNoteForm.editNode);
            }
            // If form type new
            else
            {
                resetForm();
            }
        }

        /**
         * Watch New Note Form, reset form if it is closed
         */
        $scope.$on('MsNewNote:closed', function ()
        {
            resetForm();
        });

        /**
         * Reset Form
         */
        function resetForm()
        {
            $scope.$evalAsync(function ()
            {
                MsNoteForm.note = angular.copy(MsNoteForm.defaultNote);
                MsNoteForm.checkListForm = false;
            });
        }

        /**
         * Submit Form
         */
        function submit()
        {
            if ( MsNoteForm.type === 'new' )
            {
                add();
            }
            else if ( MsNoteForm.type === 'edit' )
            {
                save();
            }
        }

        /**
         * Add new note
         */
        function add()
        {
            if ( isNotValid() )
            {
                return;
            }

            MsNoteForm.note.id = msUtils.guidGenerator();
            MsNoteForm.note.time = new Date().toISOString();

            NotesService.addNote(angular.copy(MsNoteForm.note));

            MsNoteForm.note = angular.copy(MsNoteForm.defaultNote);

            $scope.$emit('MsNewNote:close');
        }

        /**
         * Save Note
         */
        function save()
        {
            if ( isNotValid() )
            {
                return;
            }
            NotesService.updateNote(MsNoteForm.note);
            $mdDialog.hide();
        }

        /**
         * Delete Note Image
         */
        function deleteImage()
        {
            MsNoteForm.note.image = '';
        }

        /**
         * Toggle Archive State
         */
        function toggleArchive()
        {
            if ( MsNoteForm.type === 'new' )
            {
                MsNoteForm.note.archive = true;
                submit();
            }
            else if ( MsNoteForm.type === 'edit' )
            {
                MsNoteForm.note.archive = !MsNoteForm.note.archive;
                save();
            }
        }

        /**
         * One of the image, title, description, checklist inputs are should be exist.
         * @returns {boolean}
         */
        function isNotValid()
        {
            return MsNoteForm.note.image === '' && MsNoteForm.note.title === '' && MsNoteForm.note.description === '' && MsNoteForm.note.checklist.length === 0;
        }

        /**
         * Delete Note
         * @param ev
         */
        function deleteNote(ev)
        {
            var confirm = $mdDialog.confirm()
                .title('Are you sure want to delete the note?')
                .htmlContent('the note will be deleted permanently.')
                .ariaLabel('delete note')
                .targetEvent(ev)
                .ok('OK')
                .cancel('CANCEL');

            $mdDialog.show(confirm).then(function ()
            {
                NotesService.deleteNote(MsNoteForm.note);
            });
        }

        /**
         * Add Checklist Item
         */
        function addChecklistItem()
        {
            if ( MsNoteForm.newCheckListItem === '' )
            {
                return;
            }

            MsNoteForm.note.checklist.push({
                checked: false,
                text   : MsNoteForm.newCheckListItem
            });

            MsNoteForm.newCheckListItem = '';

            focusChecklistInput();
        }

        /**
         * Checklist form toggle
         */
        function checklistFormToggle()
        {
            $scope.$evalAsync(function ()
            {
                MsNoteForm.checkListForm = !MsNoteForm.checkListForm;

                $timeout(function ()
                {
                    focusChecklistInput();
                });
            });
        }

        /**
         * Delete check item
         * @param item
         */
        function deleteCheckItem(item)
        {
            MsNoteForm.note.checklist.splice(MsNoteForm.note.checklist.indexOf(item), 1);
            focusChecklistInput();
        }

        /**
         * Focus checklist input
         */
        function focusChecklistInput()
        {
            angular.element('#new-checklist-item-input').focus();
        }

        /**
         * Upload
         */
        function upload()
        {
            // Set headers
            MsNoteForm.ngFlow.flow.opts.headers = {
                'X-Requested-With': 'XMLHttpRequest',
                //'X-XSRF-TOKEN'    : $cookies.get('XSRF-TOKEN')
            };

            MsNoteForm.ngFlow.flow.upload();
        }

        /**
         * Image Success
         * @param file
         * @param message
         */
        function imageSuccess(file, message)
        {
            var fileReader = new FileReader();

            fileReader.readAsDataURL(file.file);

            fileReader.onload = function (event)
            {
                file.url = event.target.result;

                $scope.$evalAsync(function ()
                {
                    MsNoteForm.note.image = file.url;
                });
            };

            file.type = 'image';
        }

        /**
         * Array prototype
         *
         * Get by id
         *
         * @param value
         * @returns {T}
         */
        Array.prototype.getById = function (value)
        {
            return this.filter(function (x)
            {
                return x.id === value;
            })[0];
        };

    }

    /** @ngInject */
    function msNoteFormDirective()
    {
        return {
            restrict    : 'EA',
            controller  : 'msNoteFormController',
            controllerAs: 'MsNoteForm',
            scope       : {
                noteType: '=',
                noteId  : '='
            },
            templateUrl : 'app/main/apps/notes/directives/ms-note-form/ms-note-form.html',
            link        : function (scope, element, attributes, MsNoteForm)
            {
                // Type
                MsNoteForm.type = scope.noteType;

                // Note id
                if ( angular.isDefined(scope.noteId) )
                {
                    MsNoteForm.noteId = scope.noteId;
                }

                MsNoteForm.init();

            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.notes')
        .controller('msNewNoteController', msNewNoteController)
        .directive('msNewNoteButton', msNewNoteButtonDirective)
        .directive('msNewNote', msNewNoteDirective);

    /** @ngInject */
    function msNewNoteController($scope, $document)
    {
        var MsNewNote = this;

        //Data
        MsNewNote.formVisible = false;
        MsNewNote.form = {
            title      : '',
            description: ''
        };

        //Methods
        MsNewNote.open = open;
        MsNewNote.close = close;
        MsNewNote.element = [];

        //////

        /**
         * Close Trigger
         */
        $scope.$on('MsNewNote:close', function ()
        {
            close();
        });

        /**
         * Open new note form
         */
        function open()
        {
            MsNewNote.element.addClass('form-visible');
            MsNewNote.element.find('textarea').focus();
            $document.on('click', outSideClick);
        }

        /**
         * Close new note form
         */
        function close()
        {
            MsNewNote.element.removeClass('form-visible');
            $scope.$broadcast('MsNewNote:closed');

            $document.off('click', outSideClick);
        }

        /**
         * Click Outside Event Handler
         * @param event
         */
        function outSideClick(event)
        {
            var isChild = MsNewNote.element.has(event.target).length > 0;
            var isSelf = MsNewNote.element[0] === event.target;
            var isMenu = angular.element(event.target).closest('md-menu-content').length > 0;
            var isCalendar = angular.element(event.target).closest('md-calendar').length > 0 || angular.element(event.target).closest('.md-datepicker-calendar-pane').length > 0 || angular.element(event.target).hasClass('md-scroll-mask');

            var isInside = isChild || isSelf || isMenu || isCalendar;

            if ( !isInside )
            {
                close();
            }
        }
    }

    /** @ngInject */
    function msNewNoteDirective()
    {
        return {
            restrict    : 'E',
            controller  : 'msNewNoteController',
            controllerAs: 'MsNewNote',
            templateUrl : 'app/main/apps/notes/directives/ms-new-note/ms-new-note.html',
            link        : function (scope, element, attributes, MsNewNote)
            {
                MsNewNote.element = element;
            }
        };
    }

    /** @ngInject */
    function msNewNoteButtonDirective()
    {
        return {
            restrict: 'EA',
            require : '^msNewNote',
            link    : function (scope, element, attributes, msNewNote)
            {
                element.on('click', function ()
                {
                    msNewNote.open();
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module ('app.core')
        .directive ('multipleWidget', multipleWidget)
        .directive ('counterWidget', counterWidget)
        .directive ('dashboardDataWidget', dashboardDataWidget)
        .directive ('operationsProgressByStatusDashboardWidget', operationsProgressByStatusDashboardWidget)
        .directive ('nowDashboardWidget', nowDashboardWidget);

    // general
    function multipleWidget(

    ){
        return {
            transclude: true,
            scope: {
                widget: '='
            },
            restrict: 'E',
            templateUrl: 'app/main/apps/dashboards/project/widgets/multiple-widget.html',
            replace: true
        }
    }

    function counterWidget(

    ){
        return {
            transclude: true,
            scope: {
                widget: '='
            },
            restrict: 'E',
            templateUrl: 'app/main/apps/dashboards/project/widgets/counter.html',
            link: function(scope, ele, attrs){
                scope.count = {
                    total: 0,
                    label: ''
                }
                var init = function(){
                    for(var d in scope.widget.data){
                        var dato = scope.widget.data[d];
                        scope.count.label = dato.key;
                        dato.getValue().then(function(total){
                            scope.count.total = total;
                        });
                    }
                }

                var initW = scope.$watch('widget', function(w){
                    if(w.hasOwnProperty('data')){
                        init(); initW();
                    }
                });
            }
        }
    }


    function dashboardDataWidget(
        $log,
        $rootScope,
        $filter,
        $q,
        pathInObjFilter,
        errAlertS,
        setInObjectPathFilter
    ) {
        return {
            transclude: true,
            scope: {
                widgetName: '=',
                tab: '=',
                data: '=',
                styles: '='
            },
            restrict: 'E',
            link: function(scope, ele, attrs){
                scope.listeners = {};
                var applyFilterWithDataNeeded = function(filter, data, allNeeded, promise){
                    var prom = $q.defer();
                    var dataa = [];
                    try {
                        switch(allNeeded.length){
                            case 1:
                                dataa[0] = pathInObjFilter(data, allNeeded[0]);
                                if(promise){
                                    $filter(filter)(dataa[0]).then(function(dd){
                                        prom.resolve(dd);
                                    });
                                } else {
                                    return $filter(filter)(dataa[0]);
                                }
                            break;
                            case 2:
                                dataa[0] = pathInObjFilter(data, allNeeded[0]);
                                dataa[1] = pathInObjFilter(data, allNeeded[1]);
                                if(promise){
                                    $filter(filter)(dataa[0], dataa[1]).then(function(dd){
                                        prom.resolve(dd);
                                    });
                                } else {
                                    return $filter(filter)(dataa[0], dataa[1]);
                                }
                            break;
                            case 3:
                                dataa[0] = pathInObjFilter(data, allNeeded[0]);
                                dataa[1] = pathInObjFilter(data, allNeeded[1]);
                                dataa[2] = pathInObjFilter(data, allNeeded[2]);
                                if(promise){
                                    $filter(filter)(dataa[0], dataa[1], dataa[2]).then(function(dd){
                                        prom.resolve(dd);
                                    });
                                } else {
                                    return $filter(filter)(dataa[0], dataa[1], dataa[2]);
                                }
                            break;
                            case 4:
                                dataa[0] = pathInObjFilter(data, allNeeded[0]);
                                dataa[1] = pathInObjFilter(data, allNeeded[1]);
                                dataa[2] = pathInObjFilter(data, allNeeded[2]);
                                dataa[3] = pathInObjFilter(data, allNeeded[3]);
                                if(promise){
                                    $filter(filter)(dataa[0], dataa[1], dataa[2], dataa[3]).then(function(dd){
                                        prom.resolve(dd);
                                    });
                                } else {
                                    return $filter(filter)(dataa[0], dataa[1], dataa[2], dataa[3]);
                                }
                            break;
                        }
                    } catch(err){
                        errAlertS(err);
                        prom.reject(err);
                    }
                    return prom.promise;
                }

                var listenDataAndFilterWidget = function(param, allNeeded, filter, promise){
                    scope.listeners[param] = scope.$watch('data.' +param, function(val){
                        var allOtherNeeded = true;
                        for(var a in allNeeded){
                            if(angular.isUndefined(scope.data[allNeeded[a]]) && allNeeded[a] !== param) allOtherNeeded = false;
                        }
                        if(val && allOtherNeeded){
                            if(promise){
                                if(filter){
                                    applyFilterWithDataNeeded(filter, scope.data, allNeeded, promise).then(function(data){
                                        scope.data = setInObjectPathFilter(param, scope.data, data);
                                        $log.debug('dataFilteredForWidget', {
                                            filter: filter,
                                            filteredData: data,
                                            param: param,
                                            allNeeded: allNeeded,
                                            from: 'promise filter'
                                        });
                                    });
                                }
                            } else {
                                if(filter){
                                    var data2 = applyFilterWithDataNeeded(filter, scope.data, allNeeded);
                                    scope.data = setInObjectPathFilter(param, scope.data, data2);
                                    $log.debug('dataFilteredForWidget2', {
                                        filter: filter,
                                        filteredData: data2,
                                        param: param,
                                        allNeeded: allNeeded,
                                        from: 'plain filter'
                                    });
                                }
                            }
                        }
                    });
                }

                var setlistenersForDataWidget = function(widgetConfig){
                    if(widgetConfig.data){
                        for(var d in widgetConfig.data){
                            var dato = widgetConfig.data[d];
                            var needed = (dato.dataNeeded) ? dato.dataNeeded : false;
                            if(needed){
                                // first listen if data needed
                                var allListeners = [];
                                for(var n in needed){
                                    listenDataAndFilterWidget(needed[n], needed, dato.filter, dato.promise);
                                    $log.debug('listenerSettedForParamInWidget', {
                                        widget: widgetConfig.name,
                                        param: needed[n],
                                        allNeeded: needed,
                                        filter: dato.filter,
                                        promise: dato.promise
                                    });
                                }
                            } else {
                                if(angular.isFunction(dato.value)){
                                    var value = dato.value();
                                    scope.data = setInObjectPathFilter(dato.key, scope.data, value);
                                    $log.debug('dataSettedFromConfig',{
                                        type: 'fn',
                                        widget: widgetConfig.name,
                                        param: dato.key,
                                        value: value
                                    });
                                } else {
                                    scope.data = setInObjectPathFilter(dato.key, scope.data, dato.value);
                                    $log.debug('dataSettedFromConfig',{
                                        type: 'plain',
                                        widget: widgetConfig.name,
                                        param: dato.key,
                                        value: dato.value
                                    });
                                }
                            }
                        }
                    }
                }

                var getAndListenDataForWidget = function(widgetName, tab){
                    if(tab){
                        if(angular.isDefined($rootScope.R.states.fb.dashboards_project.tabs[tab])){
                            scope.tabConfig = $rootScope.R.states.fb.dashboards_project.tabs[tab];
                            for(var w in scope.tabConfig.widgets){
                                if(scope.tabConfig.widgets[w].widgets){
                                    for(var ww in scope.tabConfig.widgets[w].widgets){
                                        if(scope.tabConfig.widgets[w].widgets[ww].name == widgetName){
                                            setlistenersForDataWidget(scope.tabConfig.widgets[w]);
                                        }
                                    }
                                } else {
                                    if(scope.tabConfig.widgets[w].name == widgetName){
                                        setlistenersForDataWidget(scope.tabConfig.widgets[w]);
                                    }
                                }
                            }
                        }
                    }
                }

                var setWidgetLayout = function(widgetConfig){
                    if(!scope.layout) scope.layout = {};
                    scope.styles.flex = (widgetConfig.flex) ? widgetConfig.flex : 100;
                    scope.styles.layout = (widgetConfig.layout) ? widgetConfig.layout : 'column';
                }

                var getWidgetLayout = function(widgetName, tab){
                    if(tab){
                        if(angular.isDefined($rootScope.R.states.fb.dashboards_project.tabs[tab])){
                            scope.tabConfig = $rootScope.R.states.fb.dashboards_project.tabs[tab];
                            for(var w in scope.tabConfig.widgets){
                                if(scope.tabConfig.widgets[w].widgets){
                                    for(var ww in scope.tabConfig.widgets[w].widgets){
                                        if(scope.tabConfig.widgets[w].widgets[ww].name == widgetName){
                                            setWidgetLayout(scope.tabConfig.widgets[w]);
                                        }
                                    }
                                } else {
                                    if(scope.tabConfig.widgets[w].name == widgetName){
                                        setWidgetLayout(scope.tabConfig.widgets[w]);
                                    }
                                }
                            }
                        }
                    }
                }

                var init = function(){
                    getAndListenDataForWidget(scope.widgetName,scope.tab);
                    getWidgetLayout(scope.widgetName,scope.tab);
                }

                var initW = scope.$watch('widgetName', function(wN){
                    if(wN) { init(); initW(); }
                });
            }
        }
    }

    // operations

    // payrolls

    // sideBar

    /** @ngInject */
    function nowDashboardWidget(
        $log,
        $interval
    ) {
        return {
            templateUrl: 'app/main/apps/dashboards/project/widgets/sidebar/now-dashboard-widget.html',
            restrict: 'AE',
            // transclude: true,
            replace: true,
            link: function(scope){
                $log.debug('now-dashboard-widget loaded');
                scope.nowWidget = {
                    now: {
                        second: '',
                        minute: '',
                        hour: '',
                        day: '',
                        month: '',
                        year: ''
                    },
                    ticker: function() {
                        var now = moment();
                        scope.nowWidget.now = {
                            second: now.format('ss'),
                            minute: now.format('mm'),
                            hour: now.format('HH'),
                            day: now.format('D'),
                            weekDay: now.format('dddd'),
                            month: now.format('MMMM'),
                            year: now.format('YYYY')
                        };
                    }
                };
                scope.nowWidget.ticker();

                var nowWidgetTicker = $interval(scope.nowWidget.ticker, 1000);

                scope.$on('$destroy', function() {
                    $interval.cancel(nowWidgetTicker);
                });
            }
        }
    }


    function operationsProgressByStatusDashboardWidget(

    ) {
        return {
            templateUrl: 'app/main/apps/dashboards/project/widgets/operations-progress-by-status-dashboard-widget.html',
            restrict: 'AE',
            // transclude: true,
            replace: true
        }
    }

} ());
(function(){
    'use strict';

    angular
        .module('app.core')
        .filter('getSalaryPositionCompositionByPayroll', getSalaryPositionCompositionByPayroll)

    function getSalaryPositionCompositionByPayroll(
        $q,
        $rootScope
    ){

        return getSalaryPositionCompositionByPayrollFn;

        function getSalaryPositionCompositionByPayrollFn(payrollPositions){
            var requestsStatPromises = {};
            var allPromises = [];
            var columns = [];
            for(var pId in payrollPositions){
                requestsStatPromises[pId] = $q.defer();
                $rootScope.F.root.child('stats/payrollPositionSDAverage').child(pId).on('value', function(snap){
                    var positionAverage = snap.val();
                    requestsStatPromises[pId].resolve(positionAverage);
                }, function(err){
                    requestsStatPromises[pId].reject(err);
                });
                allPromises.push(requestsStatPromises[pId].promise);
            }
            $q.all(allPromises).then(function(all){
                console.log(all, "ALL PROMISES FOR POSITION AVERAGE SALARY");
                for(var a in all){
                    columns.push({
                        id: 'SD promedio del puesto ' + payrollPositions[a].name,
                        values: all[a]
                    });
                }
                return columns;
            });


        }
    }

}());
(function(){
    'use strict';

    angular
        .module('app.core')
        .filter('getNewClientsFromRanges', getNewClientsFromRanges)

    function getNewClientsFromRanges(
        getMonthsFromRangeFilter,
        getArrayOfKeysFilter,
        $q,
        AppF
    ){

        return getNewClientsFromRangesFn;

        function getNewClientsFromRangesFn(from, to){
            // meses de rango de fechas en primera columna
            var months = getMonthsFromRangeFilter(from, to);
            var monthsLabels = getArrayOfKeysFilter(months, 'label');
            var columns = [];
            columns.push({
                id: 'x',
                values: monthsLabels
            });
            // total de clientes nuevos por mes de rango
            var promises = {};
            var allPromises = [];
            var clientsByMonth = [];
            for(var m in months){
                promises[months[m].label] = $q.defer();
                AppF.root.child('stats/newClientsByYearAndMonth').child(months[m].year).child(months[m].month).on('value', function(snap){
                    var clientsOfDate = snap.val();
                    if(!clientsOfDate) clientsOfDate = 0;
                    clientsByMonth.push(clientsOfDate);
                    promises[months[m].label].resolve(clientsOfDate);
                }, function(err){
                    promises[months[m].label].reject(err);
                });
                allPromises.push(promises[months[m].label].promise);
            }

            return $q.all(allPromises).then(function(all){
                console.log(all, "ALL PROMISES FOR NEW CLIENTS BY YEAR AND MONTH");
                columns.push({
                    id: 'clientesPorMes',
                    name: 'clientes por mes',
                    values: clientsByMonth
                });
                return columns;
            });
        }
    }

}());
(function(){
    'use strict';

    angular
        .module('app.core')
        .filter('getCountOfUsersByGroup', getCountOfUsersByGroup)

    function getCountOfUsersByGroup(
        $rootScope,
        $q,
        getArrayOfKeysFilter
    ){

        return getCountOfUsersByGroupFn;

        function getCountOfUsersByGroupFn(profiles, groups){
            // @todo
            // var labels = getArrayOfKeysFilter(groups, 'name');
            // var columns = [];

            // var promises = {};
            // var allPromises = [];
            // var counts = {};
            // for(var g in groups){
            //     promises[groups[g].label] = $q.defer();
            //     $rootScope.F.root.child('stats/newClientsByYearAndMonth').child(months[m].year).child(months[m].month).on('value', function(snap){
            //         var clientsOfDate = snap.val();
            //         if(!clientsOfDate) clientsOfDate = 0;
            //         clientsByMonth.push(clientsOfDate);
            //         promises[months[m].label].resolve(clientsOfDate);
            //     }, function(err){
            //         promises[months[m].label].reject(err);
            //     });
            //     allPromises.push(promises[months[m].label].promise);
            // }

            // return $q.all(allPromises).then(function(all){
            //     console.log(all, "ALL PROMISES FOR NEW CLIENTS BY YEAR AND MONTH");
            //     columns.push({
            //         id: 'clientesPorMes',
            //         name: 'clientes por mes',
            //         values: clientsByMonth
            //     });
            //     return columns;
            // });
        }
    }

}());
(function ()
{
    'use strict';

    angular
        .module('app.contacts', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        $stateProvider.state('app.contacts', {
            url    : '/contacts',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/contacts/contacts.html',
                    controller : 'ContactsController as vm'
                }
            },
            resolve: {
                Contacts: function (msApi)
                {
                    return msApi.resolve('contacts.contacts@get');
                },
                User: function (msApi)
                {
                    return msApi.resolve('contacts.user@get');
                }
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/contacts');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.contacts')
        .controller('ContactDialogController', ContactDialogController);

    /** @ngInject */
    function ContactDialogController($mdDialog, Contact, Contacts, User, msUtils)
    {
        var vm = this;

        // Data
        vm.title = 'Edit Contact';
        vm.contact = angular.copy(Contact);
        vm.contacts = Contacts;
        vm.user = User;
        vm.newContact = false;
        vm.allFields = false;

        if ( !vm.contact )
        {
            vm.contact = {
                'id'      : msUtils.guidGenerator(),
                'name'    : '',
                'lastName': '',
                'avatar'  : 'assets/images/avatars/profile.jpg',
                'nickname': '',
                'company' : '',
                'jobTitle': '',
                'email'   : '',
                'phone'   : '',
                'address' : '',
                'birthday': null,
                'notes'   : ''
            };

            vm.title = 'New Contact';
            vm.newContact = true;
            vm.contact.tags = [];
        }

        // Methods
        vm.addNewContact = addNewContact;
        vm.saveContact = saveContact;
        vm.deleteContactConfirm = deleteContactConfirm;
        vm.closeDialog = closeDialog;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.exists = msUtils.exists;

        //////////

        /**
         * Add new contact
         */
        function addNewContact()
        {
            vm.contacts.unshift(vm.contact);

            closeDialog();
        }

        /**
         * Save contact
         */
        function saveContact()
        {
            // Dummy save action
            for ( var i = 0; i < vm.contacts.length; i++ )
            {
                if ( vm.contacts[i].id === vm.contact.id )
                {
                    vm.contacts[i] = angular.copy(vm.contact);
                    break;
                }
            }

            closeDialog();
        }

        /**
         * Delete Contact Confirm Dialog
         */
        function deleteContactConfirm(ev)
        {
            var confirm = $mdDialog.confirm()
                .title('Are you sure want to delete the contact?')
                .htmlContent('<b>' + vm.contact.name + ' ' + vm.contact.lastName + '</b>' + ' will be deleted.')
                .ariaLabel('delete contact')
                .targetEvent(ev)
                .ok('OK')
                .cancel('CANCEL');

            $mdDialog.show(confirm).then(function ()
            {

                vm.contacts.splice(vm.contacts.indexOf(Contact), 1);

            });
        }

        /**
         * Close dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.calendar', [
            'ui.calendar'
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.calendar', {
            url      : '/calendar',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/calendar/calendar.html',
                    controller : 'CalendarController as vm'
                }
            },
            bodyClass: 'calendar'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/calendar');
    }
})();
(function ()
{
    'use strict';

    angular.module('app.calendar')
        .controller('EventFormDialogController', EventFormDialogController);

    /** @ngInject */
    function EventFormDialogController($scope,$mdDialog, dialogData)
    {
        var vm = this;

        // Data
        $scope.dialogData = dialogData;
        $scope.notifications = ['15 minutes before', '30 minutes before', '1 hour before'];

        // Methods
        $scope.saveEvent = saveEvent;
        $scope.closeDialog = closeDialog;

        init();

        //////////

        /**
         * Initialize
         */
        function init()
        {
            $scope.dialogTitle = ($scope.dialogData.type === 'add' ? 'Add Event' : 'Edit Event');

            // Edit
            if ( $scope.dialogData.calendarEvent )
            {
                // Clone the calendarEvent object before doing anything
                // to make sure we are not going to brake the Full Calendar
                $scope.calendarEvent = angular.copy($scope.dialogData.calendarEvent);

                // Convert moment.js dates to javascript date object
                if ( moment.isMoment($scope.calendarEvent.start) )
                {
                    $scope.calendarEvent.start = $scope.calendarEvent.start.toDate();
                }

                if ( moment.isMoment($scope.calendarEvent.end) )
                {
                    $scope.calendarEvent.end = $scope.calendarEvent.end.toDate();
                }
            }
            // Add
            else
            {
                // Convert moment.js dates to javascript date object
                if ( moment.isMoment($scope.dialogData.start) )
                {
                    $scope.dialogData.start = $scope.dialogData.start.toDate();
                }

                if ( moment.isMoment($scope.dialogData.end) )
                {
                    $scope.dialogData.end = $scope.dialogData.end.toDate();
                }

                $scope.calendarEvent = {
                    start        : $scope.dialogData.start,
                    end          : $scope.dialogData.end,
                    notifications: []
                };
            }
        }

        function saveEvent()
        {
            var response = {
                type         : $scope.dialogData.type,
                calendarEvent: $scope.calendarEvent
            };

            $mdDialog.hide(response);
        }

        /**
         * Close the dialog
         */
        function closeDialog()
        {
            $mdDialog.cancel();
        }
    }
})();

(function ()
{
    'use strict';

    angular.module('app.calendar')
        .controller('EventDetailDialogController', EventDetailDialogController);

    /** @ngInject */
    function EventDetailDialogController($scope,$mdDialog, calendarEvent, showEventFormDialog, event)
    {
        var vm = this;

        // Data
        $scope.calendarEvent = calendarEvent;

        // Methods
        $scope.editEvent = editEvent;
        $scope.closeDialog = closeDialog;

        //////////

        function closeDialog()
        {
            $mdDialog.hide();
        }

        function editEvent(calendarEvent)
        {
            showEventFormDialog('edit', calendarEvent, false, false, event);
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("app.employees")
        .controller("RfcValidatorController", RfcValidatorController);

    function RfcValidatorController(errAlertS, $rootScope, ApiV2F, $mdDialog) {
        var vm = this;
        function validarRfc() {
            try {
                var surname;
                if (angular.isDefined(vm.paternalSurname)) {
                    surname = vm.paternalSurname;
                }
                if (angular.isDefined(vm.maternalSurname)) {
                    surname += (angular.isDefined(vm.paternalSurname) ? ' ' : '') + vm.maternalSurname;
                }
                vm.nameAll = vm.names + ' ' + surname;
                if (angular.isDefined(vm.cp) && vm.cp !== '' && angular.isDefined(vm.rfc) && vm.rfc !== '' && angular.isDefined(vm.nameAll) && vm.nameAll !== '') {
                    var params = {
                        name: vm.nameAll,
                        zipCode: vm.cp
                    }
                    $rootScope.loadingProgress = true;
                    ApiV2F.post("employees/validateRfcData/" + vm.rfc, params).then(function (resp) {
                        vm.rfcData = resp.data;
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync();
                    }).catch(function (error) {
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync();
                        errAlertS(error);
                    })
                } else {
                    throw 'No se tienen todos los datos para hacer la consulta';
                }
            } catch (error) {
                if (error) {
                    errAlertS(error);
                }
            }
        }
        function reset() {
            console.log(vm)
            delete vm.rfcData;
            delete vm.names;
            delete vm.paternalSurname;
            delete vm.maternalSurname;
            delete vm.nameAll;
            delete vm.cp;
            delete vm.rfc;
            delete vm.nameAll;
        }
        function close() {
            $mdDialog.cancel();
        };
        vm.validarRfc = validarRfc;
        vm.reset = reset;
        vm.close = close;
    }
})();
(function () {
    "use strict";

    angular
        .module("app.employees")
        .controller("CifValidatorController", CifValidatorController);

    function CifValidatorController(errAlertS, $rootScope, ApiV2F, $mdDialog) {
        var vm = this;
        function validarCif() {
            if (angular.isDefined(vm.data.rfc) && angular.isDefined(vm.data.cif)) {
                $rootScope.loadingProgress = true;
                ApiV2F.post("employees/validateCif/" + vm.data.rfc, { cif: vm.data.cif }).then(function (resp) {
                    vm.cifData = resp.data;
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                }).catch(function (error) {
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                    errAlertS(error);
                })
            } else {
                errAlertS('No se proporcionaron todos los datos necesarios')
            }
        }
        function reset() {
            console.log(vm)
            delete vm.cifData;
            delete vm.data;
        }
        function close() {
            $mdDialog.cancel();
        };
        vm.validarCif = validarCif;
        vm.reset = reset;
        vm.close = close;
    }
})();
(function () {
    'use strict';

    angular
        .module('app.employees')
        .controller('RevisionController', RevisionController);

    /** @ngInject */
    function RevisionController(
        $scope,
        errAlertS,
        successAlertS,
        $mdDialog,
        $filter,
        confirmConfig,
        $rootScope,
        $log,
        MinMaxValiadationsForMovementFilter,
        checkForAddingPendingDaysFilter,
        checkValidFieldsModalFilter,
        $timeout,
        $stateParams,
        $state,
        $firebaseArray,
        AppF,
        DataF,
        $q
    ) {
        //inicializaciones
        var initiated = false;
        var firstSbcIgnored = false;
        var mapActions = {
            review: 1
        };
        var firstSbcIgnoredForChange;
        $scope.fiscalMovement = true;
        $scope.F.selectedCp = undefined;
        $scope.F.searchCp = undefined;
        $scope.rp = null;
        $scope.cc = null;
        $scope.geoZone = {};
        $scope.minMaxValidations = null;
        $scope.benefit = $rootScope.F.defaultBenefits;
        $scope.thisDetailWatchers = {};
        $scope.today = moment().toDate();
        $scope.minDate = new Date(1950, $scope.today.getMonth() - 2, $scope.today.getDate());
        var originalWorKerType;
        var originalContractId;
        $scope.isUndefined = function (data) {
            return angular.isUndefined(data)
        }
        //Functiones
        var checkActionStatus = function () {
            var flag = $filter('validateActionStatus')($scope.employee, $scope.F.active.menuAction, mapActions);
            if (angular.isString(flag)) {
                errAlertS(flag);
                $scope.goToList()
            } else {
                return flag;
            }
        };

        var checkBenefit = function () {
            $filter('getBenefitsOfItem')($scope.employee).then(function (benefit) {
                if (typeof ($scope.minMaxValidations) !== 'undefined') {
                    $scope.minMaxValidations.setBenefit(angular.fromJson(angular.toJson(benefit)));
                }
                $scope.benefit = angular.fromJson(angular.toJson(benefit));
                if (angular.isUndefined($scope.benefit.christmasBonusTable)) {
                    $scope.benefit.christmasBonusTable = [];
                }
                $scope.$evalAsync();
            });
        };
        var getZipCodeObj = function () {
            return new Promise(function (resolve, reject) {
                var zipCodeId = $filter('getFromObject')($scope.employee.data, 'info.residence.address.zipCodeId');
                if (angular.isDefined(zipCodeId)) {
                    $scope.D.api.get('zipCodes/' + zipCodeId).then(function (res) {
                        $scope.F.selectedCp = res.data;
                        resolve(true);
                    }, function (error) {
                        reject(error);
                    });
                } else {
                    $scope.F.searchCp = $filter('getFromObject')($scope.employee.data, 'info.residence.address.zipCode');
                    resolve(true);
                }
            });
        };
        //Se formatea la fecha min, max y thisDate a UTC
        var setMinDates = function () {
            switch ($scope.employee.movement.type) {
                case 6:
                case 8:
                    $scope.maxEnroleDate = $scope.minMaxValidations.maxEnroleDate;
                    $scope.minEnroleDate = $scope.minMaxValidations.minEnroleDate;
                    if (angular.isDefined($scope.employee.data.enroleDate)) {
                        var min = moment($scope.minEnroleDate.getFullYear() + '-' + ($scope.minEnroleDate.getMonth() + 1) + '-' + $scope.minEnroleDate.getDate() + ' 00:00 -0500', 'YYYY-MM-DD HH:mm Z');
                        var max = moment($scope.maxEnroleDate.getFullYear() + '-' + ($scope.maxEnroleDate.getMonth() + 1) + '-' + $scope.maxEnroleDate.getDate() + ' 00:00 -0500', 'YYYY-MM-DD HH:mm Z');
                        var thisDate = moment($scope.employee.data.enroleDate);
                        thisDate = moment(thisDate.utc().year() + '-' + (thisDate.utc().month() + 1) + '-' + thisDate.utc().date() + ' 00:00 -0500', 'YYYY-MM-DD HH:mm Z');
                        if (min.valueOf() > thisDate.valueOf() || max.valueOf() < thisDate.valueOf()) {
                            delete $scope.employee.data.enroleDate;
                        }
                    }
                    break;
                case 2:
                    $scope.minMovementDate = $scope.minMaxValidations.minDismissDate;
                    $scope.maxDismissDate = $scope.minMaxValidations.maxDismissDate;
                    if (angular.isDefined($scope.movement.data.date)) {
                        var min = moment($scope.minMovementDate.getFullYear() + '-' + ($scope.minMovementDate.getMonth() + 1) + '-' + $scope.minMovementDate.getDate() + ' 00:00 -0500', 'YYYY-MM-DD HH:mm Z');
                        var max = moment($scope.maxDismissDate.getFullYear() + '-' + ($scope.maxDismissDate.getMonth() + 1) + '-' + $scope.maxDismissDate.getDate() + ' 00:00 -0500', 'YYYY-MM-DD HH:mm Z');
                        var thisDate = moment($scope.movement.data.date);
                        thisDate = moment(thisDate.utc().year() + '-' + (thisDate.utc().month() + 1) + '-' + thisDate.utc().date() + ' 00:00 -0500', 'YYYY-MM-DD HH:mm Z');
                        if (min.valueOf() > thisDate.valueOf() || max.valueOf() < thisDate.valueOf()) {
                            delete $scope.movement.data.date;
                        }
                    }
                    break;
                case 7:
                    $scope.minMovementDate = $scope.minMaxValidations.minMdsDate;
                    $scope.maxMdsDate = $scope.minMaxValidations.maxMdsDate;
                    if (angular.isDefined($scope.movement.data.date)) {
                        var min = moment($scope.minMovementDate.getFullYear() + '-' + ($scope.minMovementDate.getMonth() + 1) + '-' + $scope.minMovementDate.getDate() + ' 00:00 -0500', 'YYYY-MM-DD HH:mm Z');
                        var max = moment($scope.maxMdsDate.getFullYear() + '-' + ($scope.maxMdsDate.getMonth() + 1) + '-' + $scope.maxMdsDate.getDate() + ' 00:00 -0500', 'YYYY-MM-DD HH:mm Z');
                        var thisDate = moment($scope.movement.data.date);
                        thisDate = moment(thisDate.utc().year() + '-' + (thisDate.utc().month() + 1) + '-' + thisDate.utc().date() + ' 00:00 -0500', 'YYYY-MM-DD HH:mm Z');
                        if (min.valueOf() > thisDate.valueOf() || max.valueOf() < thisDate.valueOf()) {
                            delete $scope.movement.data.date;
                        }
                    }
                    break;
            }
            $rootScope.$evalAsync();
        };

        function showLessSalaryModal() {
            return new Promise(function (resolve) {
                if (!firstSbcIgnoredForChange) {
                    firstSbcIgnoredForChange = true;
                    resolve(true)
                } else {
                    if ((angular.isNumber($scope.minMaxValidations.lastSd) && $scope.movement.data.sd && $scope.movement.data.sd < $scope.minMaxValidations.lastSd) || (angular.isNumber($scope.minMaxValidations.lastSbc) && $scope.movement.data.sbc && $scope.movement.data.sbc < $scope.minMaxValidations.minimumSbc)) {
                        var isSd = angular.isNumber($scope.minMaxValidations.lastSd) && $scope.movement.data.sd < $scope.minMaxValidations.lastSd;
                        var warning = 'El ' + (isSd ? 'salario diario' : 'salario base cotización') + ' que está registrando es menor al ' + (isSd ? 'salario diario' : 'salario base cotización') + ' anterior del trabajador.<br><br>' +
                            'Si continúa, el sistema guardará el nuevo ' + (isSd ? 'salario diario' : 'salario base cotización') + ' con un valor menor al previo.<br><br>' +
                            '¿Desea continuar con este cambio?';
                        $mdDialog.show(
                            $mdDialog.confirm(confirmConfig)
                                .title('Confirmar disminución de salario')
                                .htmlContent(warning)
                                .ariaLabel('confirmar cambio de salario')
                                .targetEvent(event)
                                .ok('Sí, continuar')
                                .cancel('Cancelar cambio')
                        ).then(function () {
                            $log.log('Usuario aceptó disminuir el salario');
                            resolve(true);
                        }).catch(function () {
                            $scope.movement.data.sd = '';
                            $scope.movement.data.sbc = '';
                            $log.log('Usuario canceló el cambio');
                            resolve(false);
                        });
                    } else {
                        resolve(true);
                    }
                }
            })
        }
        var setMinSalaries = function () {
            $scope.minimumWage = $scope.minMaxValidations.minimumWageByZone;
            $scope.lastSd = $scope.minMaxValidations.lastSd;
            $scope.minimumSd = $scope.minMaxValidations.minimumSd;
            $scope.lastSbc = $scope.minMaxValidations.lastSbc;
            $scope.minimumSbc = $scope.minMaxValidations.minimumSbc;
            $scope.maxSdOfLastSbc = $scope.minMaxValidations.maxSdOfLastSbc;
            $scope.factorSelected = $scope.minMaxValidations.factor;
            var sd = $filter('pathInObj')($filter('clearObject')($scope.movement), 'data.sd');
            var onlySd = $filter('pathInObj')($filter('clearObject')($scope.movement), 'data.onlySd');
            if (sd || onlySd) {
                if (angular.isUndefined($scope.movement.data.sbc)) {
                    $scope.movement.data.sbc = $scope.minMaxValidations.minimumSbc;
                    firstSbcIgnored = true;
                } else if (angular.isDefined($scope.movement.data.sbc) && $scope.movement.data.sbc < $scope.minMaxValidations.minimumSbc) {
                    $scope.movement.data.sbc = $scope.minMaxValidations.minimumSbc;
                    firstSbcIgnored = true;
                } else if (angular.isDefined($scope.movement.data.sbc) && $scope.movement.data.sbc > $scope.minMaxValidations.minimumSbc) {
                    if (firstSbcIgnored) {
                        $scope.movement.data.sbc = $scope.minMaxValidations.minimumSbc;
                    } else {
                        firstSbcIgnored = true;
                    }
                }
            }
            $scope.employee.data.if = $scope.minMaxValidations.factor;
            $scope.employee.data.b = $scope.minMaxValidations.b;
            showLessSalaryModal().then(function () {
                $timeout(function () {
                    $rootScope.$evalAsync();
                }, 0)
            }).catch(function (error) {
                if (error) {
                    errAlertS(error);
                }
            });
        };

        var setMinMaxValidations = function () {
            $scope.minimumWage = $scope.F.minimumVariables.A;
            $scope.minMaxValidations = new MinMaxValiadationsForMovementFilter($scope.employee, $scope.movement, $scope.benefit, undefined, $scope.movement.data.type === 8, $scope.geoZone, $scope.form);
            $scope.minMaxValidations.setMinDates().then(function () {
                setMinDates();
            });
            $scope.minMaxValidations.setMinSalaries($scope.movement.data.sd).then(function () {
                setMinSalaries();
            });
        };
        var initWatchers = function (movementType) {
            $log.log('watchers setted');
            if ([6, 8].indexOf(movementType) !== -1) {
                //Se observa el rp para setear las fechas minimas
                $scope.thisDetailWatchers.employeeRp = $scope.$watch('employee.rp', function (rp, rpOld) {
                    if (rp !== rpOld) {
                        $scope.minMaxValidations.setMinDates().then(function () {
                            setMinDates();
                        });
                    }
                });
                //Se observa el sd por si cambia para estabelcer los salarios minimos
                $scope.thisDetailWatchers.datesVariables = $scope.$watchGroup(['employee.hasSeniorityDate', 'employee.data.seniorityDate', 'employee.data.workDay'], function (newVal, oldVal) {
                    if (newVal[0] !== oldVal[0] || newVal[1] !== oldVal[1] || newVal[2] !== oldVal[2]) {
                        $rootScope.loadingProgress = true;
                        $timeout(function () {
                            $scope.minMaxValidations.setMinSalaries($scope.movement.data.sd).then(function () {
                                setMinSalaries();
                            }).catch(function (error) {
                                delete $scope.movement.data.sbc;
                                $log.error(error);
                                errAlertS('No se pudo calcular el intente volver a capturar el campo');
                            }).then(function () {
                                $rootScope.loadingProgress = false;
                            });
                        }, 0, false);
                    }
                    if (angular.isDefined(newVal[0]) && !newVal[0]) {
                        delete $scope.employee.data.seniorityDate;
                    }
                });
                //Si hubo cambios en el beneficio se calculan los factores nuevamente y tambien se recalculan
                $scope.thisDetailWatchers.holidaysTable = $scope.$watch('benefit', function (val, oldVal) {
                    if (val && angular.toJson(val) !== angular.toJson(oldVal)) {
                        if (typeof ($scope.minMaxValidations) !== 'undefined') {
                            $scope.minMaxValidations.setBenefit(angular.fromJson(angular.toJson($scope.benefit)));
                        }
                        if (val.holidays === 'default') {
                            $scope.benefit.holidaysTable = angular.fromJson(angular.toJson($scope.F.defaultBenefits.holidaysTable));
                            $scope.editHolidayTable = false;
                        }
                        if (angular.isObject($scope.benefit.holidaysTable)) {
                            for (var b in $scope.benefit.holidaysTable) {
                                if (typeof ($scope.benefit.holidaysTable[b].limit) !== 'undefined' && typeof ($scope.benefit.holidaysTable[b].value) !== 'undefined') {
                                    $scope.benefit.holidaysTable[b].factor = $filter('getFactorFromBenefits')($scope.benefit, null, null, $scope.benefit.holidaysTable[b].limit);
                                } else {
                                    $scope.benefit.holidaysTable[b].factor = '';

                                }
                            }
                        }
                        $rootScope.loadingProgress = true;
                        $timeout(function () {
                            $scope.minMaxValidations.setMinSalaries($scope.movement.data.sd).then(function () {
                                setMinSalaries();
                            }).catch(function (error) {
                                delete $scope.movement.data.sbc;
                                $log.error(error);
                                errAlertS('No se pudo calcular el intente volver a capturar el campo');
                            }).then(function () {
                                $rootScope.loadingProgress = false;
                            });
                        }, 0, false);
                    }
                }, true);

                //Si se selecciona que no se quieren editar las prestaciones regresa al que tiene por default
                $scope.thisDetailWatchers.minimunBenefitsChange = $scope.$watch('employee.customBenefits', function (value) {
                    if (!value) {
                        checkBenefit();
                    }
                });
                //Se observa la fecha de alta para establecer la fecha de antiguedad
                $scope.thisDetailWatchers.employeeEnroleDate = $scope.$watch('employee.data.enroleDate', function (enroleDate) {
                    if (enroleDate) {
                        $scope.movement.data.date = enroleDate;
                        var thisDate = moment(enroleDate).subtract(1, 'day');
                        $scope.enroleDateJS = thisDate.toDate();
                        var value = $filter('pathInObj')($filter('clearObject')($scope.employee), 'data.seniorityDate');
                        if (value && $scope.employee.data.seniorityDate > $scope.enroleDateJS.valueOf() && $scope.F.active.menuAction !== 'especialEdit') {
                            delete $scope.employee.data.seniorityDate;
                        }
                    }
                });
                //Se observa sus apellidos y nombres para setear su nombre completo
                $scope.thisDetailWatchers.employeeNames = $scope.$watchGroup(['employee.data.info.paternalSurname', 'employee.data.info.maternalSurname', 'employee.data.info.names'], function (names) {
                    if (names[0] || names[1] || names[2]) {
                        var thisName = $filter('getCompoundData')(names);
                        if (angular.isString(thisName)) {
                            $scope.employee.data.name = thisName;
                        }
                    }
                });
            }

            if (movementType !== 2) {
                //Se observa el sd por si cambia para estabelcer los salarios minimos
                $scope.thisDetailWatchers.movementVariables = $scope.$watchGroup(['movement.data.sd', 'movement.data.date', 'movement.data.onlySd'], function (newVal, oldVal) {
                    if (newVal[0] !== oldVal[0] || newVal[1] !== oldVal[1] || newVal[2] !== oldVal[2]) {
                        $scope.minMaxValidations.setMinSalaries($scope.movement.data.sd).then(function () {
                            setMinSalaries();
                        });
                    }
                });
            }
            $log.log(Object.keys($scope.thisDetailWatchers));
        };

        $scope.validateWorkerType = function () {
            var invalidChange = angular.isDefined(originalWorKerType) && originalWorKerType === 1 && $scope.employee.data.workerType !== originalWorKerType && $scope.F.active.menuAction !== 'especialEdit';
            if (invalidChange && [6, 8].indexOf($scope.employee.movement.type) > -1) {
                invalidChange = false;
            }
            if (invalidChange) {
                $scope.employee.data.workerType = originalWorKerType;
                errAlertS('No se puede seleccionar un tipo de trabajador diferente al actual');
            } else {
                $filter('getContractTypes')($scope);
            }
        };

        $scope.validateContractType = function () {
            if (angular.isDefined(originalContractId)) {
                var originalContractType = $scope.allDocumentTypes.find(function (item) {
                    return item._id === originalContractId;
                });
                var thisContractType = $scope.allDocumentTypes.find(function (item) {
                    return item._id === $scope.employee.contractType;
                });
                $log.log(originalContractType, thisContractType);
                // if (angular.isDefined(originalContractType) && angular.isDefined(thisContractType)) {
                // }
            }
        };

        var setDefaultValues = function () {
            if ($scope.employee.movement.type === 2) {
                if (angular.isUndefined($scope.movement.data)) {
                    $scope.movement.data = {};
                }
                $scope.movement.data.rehirable = true; // default
            }
        };
        var allReady = false;
        var redirectTo;
        $scope.goToList = function () {
            if (angular.isDefined(redirectTo)) {
                $state.go(redirectTo);
            } else {
                $scope.R.goToList();
            }
        }
        var init = function () {
            redirectTo = $stateParams.redirectTo;
            initiated = true;
            $rootScope.loadingProgress = true;
            checkActionStatus();
            var needed = [];
            needed.push($scope.dataNeededPromise);
            needed.push($scope.statesObjsPromise);
            needed.push($filter('getBenefitsOfItem')($scope.employee));
            needed.push(getZipCodeObj());
            Promise.all(needed).then(function (resp) {
                $log.log('All needed ready');
                $scope.benefit = resp[2];
                if (angular.isUndefined($scope.benefit.christmasBonusTable)) {
                    $scope.benefit.christmasBonusTable = [];
                }
                originalWorKerType = $scope.employee.data.workerType;
                originalContractId = $scope.employee.contractType;
                $log.log('Benefit setted');
                setMinMaxValidations();
                $log.log('Min Max setted');
                setDefaultValues();
                $log.log('Default Values setted');
                $scope.stateUpdated();
                $scope.payrollUpdated(true).then(function () {
                    $log.log('payrollUpdated');
                    return $scope.ccUpdated(true);
                }).then(function () {
                    $log.log('ccUpdated');
                    allReady = true;
                    initWatchers($scope.movement.data.type);
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                });
            }).catch(function (error) {
                $rootScope.loadingProgress = false;
                errAlertS(error);
            });
        };
        $scope.showListPending = function (event, form) {
            checkValidFieldsModalFilter(event, form);
        }
        $scope.cpSelected = function (cpSelected) {
            if (angular.isObject(cpSelected)) {
                if (angular.isUndefined($scope.employee.data.info)) {
                    $scope.employee.data.info = {};
                }
                if (angular.isUndefined($scope.employee.data.info.residence)) {
                    $scope.employee.data.info.residence = {};
                }
                if (angular.isUndefined($scope.employee.data.info.residence.address)) {
                    $scope.employee.data.info.residence.address = {};
                }
                $scope.employee.data.info.residence.state = cpSelected.stateId;
                $scope.employee.data.info.residence.town = cpSelected.townId;
                $scope.employee.data.info.residence.address.neighborhood = cpSelected.name;
                $scope.employee.data.info.residence.address.zipCode = cpSelected.cp;
                $scope.employee.data.info.residence.address.zipCodeId = cpSelected._id;
                $scope.stateUpdated();
            }
            $log.log(cpSelected);
        };
        $scope.payrollUpdated = function (firstChange) {
            return new Promise(function (resolve, reject) {
                var payroll = $scope.employee.payroll;
                if (!firstChange) {
                    delete $scope.employee.cc;
                    delete $scope.employee.rp;
                    delete $scope.employee.data.position;
                    delete $scope.employee.firm;
                }
                var promises = [];
                if (payroll) {
                    promises.push($scope.L.loadList('ccs', 'lists/ccs/payroll', payroll, 'array', 'payrollCcs'));
                    promises.push($scope.L.loadList('positions', 'lists/positions/payroll', payroll, 'array', 'payrollPositions'));
                    promises.push($scope.L.loadList('payrolls', 'catalogs/payrolls/collection/' + payroll, undefined, 'object', 'payroll-' + payroll));
                    promises.push($scope.L.loadList('departments', 'lists/departments/payroll', payroll, 'array', 'payrollDepartments'));
                }
                Promise.all(promises).then(function (resp) {
                    if ((!firstChange || typeof ($scope.employee.firm) === 'undefined')) {
                        $scope.employee.firm = resp[2].firm;
                    }
                    var ccs = resp[0];
                    $scope.payroll = resp[2];
                    var secondPromises = [];
                    for (var c = 0; c < ccs.length; c++) {
                        secondPromises.push($scope.L.loadList('rps', 'lists/rps/all', ccs[c]['rp_id'], 'object', 'rpCcs'));
                    }
                    if ($scope.payroll.specialServices) {
                        secondPromises.push($scope.L.loadList('firms', 'catalogs/firms/collection/' + $scope.payroll.firm + '/companies', undefined, 'array', 'companiesOf-' + $scope.payroll.firm));
                    }
                    secondPromises.push($filter('getContractTypes')($scope));
                    secondPromises.push($scope.L.loadList('proccess', 'catalogs/paymentSchemas/collection/' + $scope.payroll.paymentSchema + '/data/processes/complements', undefined, 'array', 'paymentSchemasProccess' + $scope.payroll.paymentSchema));
                    secondPromises.push($filter('getExtraFields')($scope.employee.firm));
                    Promise.all(secondPromises).then(function (resp) {
                        $scope.extraFields = resp.pop();
                        if (angular.isArray(resp[resp.length - 1]) && resp[resp.length - 1].length > 0) {
                            var activeComplements = resp[resp.length - 1].filter(function (item) {
                                return item.active;
                            });
                            if (activeComplements.length === 0) {
                                $scope.isOnlyFiscal = true;
                            } else {
                                $scope.isOnlyFiscal = false;
                            }
                        } else {
                            $scope.isOnlyFiscal = true;
                        }
                        $log.log($scope.isOnlyFiscal);
                        if (!firstChange) {
                            checkBenefit();
                        }
                        resolve(true);
                    }).catch(reject);
                }).catch(reject);
            });
        };
        $scope.ccUpdated = function (firstChange) {
            return new Promise(function (resolve, reject) {
                var cc = $scope.employee.cc;
                var promises = [];
                if (cc) {
                    promises.push($scope.L.loadList('ccs', 'catalogs/ccs/collection/' + cc + '/data', undefined, 'object', 'cc-' + cc));
                }
                Promise.all(promises).then(function (resp) {
                    $scope.cc = resp[0];
                    if (typeof ($scope.employee.data) === 'undefined') { $scope.employee.data = {}; }
                    if (typeof ($scope.employee.data.health) === 'undefined') { $scope.employee.data.health = {}; }
                    $scope.employee.data.health.benefit = (angular.isObject($scope.cc) && $scope.cc.healthCare) ? true : false; // cc has health benefit
                    var secondPromises = [];
                    var rp = (angular.isObject($scope.cc) && typeof ($scope.cc['rp_id']) !== 'undefined') ? $scope.cc['rp_id'] : undefined;
                    $scope.employee.rp = rp;
                    if (typeof (rp) !== 'undefined') {
                        secondPromises.push($scope.L.loadList('rps', 'lists/rps/all', rp, 'object', 'rpCcs'));
                    }
                    if ($scope.payroll.specialServices) {
                        secondPromises.push($scope.L.loadList('rps', 'catalogs/rps/collection/' + $scope.employee.rp + '/companies', undefined, 'array', 'companiesOf-' + $scope.employee.rp));
                    }
                    Promise.all(secondPromises).then(function (secondResp) {
                        console.log('Respuestas de las promesa', secondResp)
                        $scope.rp = secondResp[0] ? secondResp[0] : {};
                        if ($scope.rp.rp === '00000000000') {
                            $scope.fiscalMovement = false;
                            delete $scope.employee.data.nss;
                            delete $scope.employee.data.health.umf;
                            delete $scope.movement.data.sd;
                            delete $scope.movement.data.sbc;
                        } else {
                            $scope.fiscalMovement = true;
                        }
                        if (!firstChange) {
                            checkBenefit();
                        }
                        if (angular.isObject($scope.cc)) {
                            $scope.geoZone = {};
                            var place = $scope.cc.place;
                            var placesOfWorkRecords = $scope.M.placesOfWorkRecords;
                            var geoZones = $scope.M.geoZones;
                            var geoZoneId = "";
                            if (angular.isDefined(place)) {
                                var filterPlacesOfWorkRecords = placesOfWorkRecords.filter(function (places) {
                                    return places._id == place;
                                });
                                if (filterPlacesOfWorkRecords.length > 0 && angular.isDefined(filterPlacesOfWorkRecords[0].geoZone_id)) {
                                    geoZoneId = filterPlacesOfWorkRecords[0].geoZone_id;
                                    var filterGeoZones = geoZones.filter(function (geozones) {
                                        return geozones._id == geoZoneId;
                                    });
                                    if (filterGeoZones.length > 0) {
                                        $scope.geoZone = filterGeoZones[0];
                                    } else {
                                        errAlertS("No hay registros de zonas geográficas, favor de registralo");
                                    }
                                } else {
                                    errAlertS("En el lugar de trabajo no tiene asignado ninguna geozona, favor de asignarlos");
                                }
                            } else {
                                errAlertS("El centro de costo no tiene la plaza asignada");
                            }
                        }
                        //aqui va a ir la validacion
                        var promises = [];
                        $scope.minMaxValidations.geoZone = $scope.geoZone;
                        if (angular.isDefined($scope.minMaxValidations) && allReady) {
                            promises.push($scope.minMaxValidations.setMinDates());
                            promises.push($scope.minMaxValidations.setMinSalaries($scope.movement.data.sd));
                        }
                        Promise.all(promises).then(function (resp) {
                            if (resp.length > 0) {
                                setMinDates();
                                setMinSalaries();
                            }
                            resolve(true);
                        });
                    }).catch(reject);
                }).catch(reject);
            });
        };
        $scope.stateUpdated = function () {
            var value = $filter('pathInObj')($filter('clearObject')($scope.employee), 'data.info.residence.state');
            if (value) {
                $scope.M.getTownsByState(value);
            }
        };
        function enableLastCredit(employeeId) {
            $log.log('Activar el ultimo Credito')
            return new Promise(function (resolve, reject) {
                var consultas = $scope.F.root.child('/catalogs/credits/collection/').orderByChild('employee').equalTo(employeeId);
                var data = $firebaseArray(consultas);
                data.$loaded().then(function (resp) {
                    var promises = [];
                    var creditsOrdered = resp.sort(function (a, b) {
                        return b.data.date - a.data.date;
                    });
                    if (creditsOrdered.length > 0) {
                        var lastCredit = creditsOrdered[0];
                        if (lastCredit.$id && !lastCredit.liquidatedCredit) {
                            $log.log('ultimo Credito si pasa por aqui', lastCredit)
                            promises.push($scope.F.root.child('catalogs/credits/collection/' + lastCredit.$id + '/valid').set(true))
                        }
                    }
                    return Promise.all(promises);
                }).then(function () {
                    resolve(true);
                    data.$destroy();
                }).catch(function (error) {
                    $log.log(error);
                    resolve('Error al buscar la información');
                });
            });
        }
        $scope.approve = function (employee, movement) {
            $rootScope.loadingProgress = true;
            var employeeId = employee.$id;
            employee = $filter('clearObject')(employee);
            var movementId = movement.$id;
            movement = $filter('clearObject')(movement);
            var dismissConfig
            if (!employee.rp) {
                errAlertS('El Centro de Costo no tiene Registro Patronal, favor de asignarle uno antes de hacer ésta operación');
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
                return false;
            } else {
                $rootScope.$broadcast('stopDetailWatchers');
                movement.status = 2;
                if (!$scope.fiscalMovement) {
                    movement.status = 4;
                } else if (movement.data.type === 2) {
                    dismissConfig = $scope.M.dismissTypes.find(function (item) {
                        return item._id === movement.data.dismissType;
                    });
                    if (dismissConfig.defaultStatus) {
                        movement.status = dismissConfig.defaultStatus;
                    }
                }
                movement = $filter('prepareMovement')(movement, movementId, employee, employeeId, true, undefined, undefined, $scope.isOnlyFiscal);
                employee = $filter('prepareEmployee')(employee, employeeId, movement, movementId, false, true, false, $scope.isOnlyFiscal);
                //importante agregar el id al objeto para consulta de otros metodos getEmploteDData y getBenefit;
                employee.$id = employeeId;
                var promises = [
                    $filter('getEmployeeDataObjects')(employee)
                ];
                if ([6, 8].indexOf(movement.data.type) !== -1) {
                    promises.push($scope.F.saveBenefitOfEmployee($filter('getBenefitsOfItem')(employee), $scope.benefit, employeeId, $scope.D.getTimeObject(), !$scope.fiscalMovement, true));
                }
                Promise.all(promises).then(function (resp) {
                    //importante eliminar el id del empleado tras consulta para evitar fallos al momento de insertar con el update;
                    delete employee.$id;
                    var dataNeededByTemplate = resp[0];
                    var updates = {};
                    updates['movements/collection/' + movementId] = movement;
                    updates['employees/collection/' + employeeId] = employee;
                    //en caso de haber solicitado el guardado de los beneficios se añade el guardado al update;
                    if (angular.isObject(resp[1])) {
                        for (var index in resp[1]) {
                            if (resp[1].hasOwnProperty(index)) {
                                updates[index] = resp[1][index];
                            }
                        }
                    }
                    $log.log(updates);
                    $scope.F.root.child('catalogs').update(updates).then(function () {
                        var action = $filter('typeName')(movement.data.type, false, true);
                        var dontSend = false;
                        if (angular.isDefined(dismissConfig) && dismissConfig.disableNotification) {
                            dontSend = true;
                        }
                        $scope.F.notifyUsers('movement', action, 2, movement.$id, employee, dontSend, dataNeededByTemplate);
                        if (movement.data.type === 8) {
                            $scope.F.checkCreditStatus(employeeId);
                        }
                        if ([6, 8].indexOf(movement.data.type) > -1) {
                            $scope.F.setLastCertificateForNewEmployees(employeeId);
                            // if ($filter('getFromObject')($scope.payroll, 'generateEmployeeNumber', false)) {
                            $scope.F.setLastEmployeeNumber(employeeId);
                            // }
                        }
                        if (employee.movement.type === 2 && employee.status === 2) {
                            $scope.F.checkPayrollForDisable(employee.payroll);
                        }

                        var p = [];
                        if (employee.movement.type === 6 || employee.movement.type === 8) {
                            p.push(checkForAddingPendingDaysFilter(employee, employeeId, movementId));
                        }
                        Promise.all(p).then(function (resp) {
                            if (resp.length > 0) {
                                var msg = resp[0];
                                switch (msg) {
                                    case 1:
                                        msg = 'Se revisó y aprobó movimiento con éxito y se generaron las incidencias pendientes de pago automáticamente';
                                        break;
                                    case 2:
                                        msg = 'Se revisó y aprobó movimiento con éxito pero no se generaron las incidencias pendientes de pago automáticamente, hacer manual esta operación';
                                        break;
                                    case 3:
                                        msg = 'Se revisó y aprobó movimiento con éxito';
                                        break;
                                    case 4:
                                        msg = 'Se revisó y aprobó movimiento con éxito pero no se encontraron calendarios para el empleado';
                                        break;
                                    case 5:
                                        msg = 'Se revisó y aprobó movimiento con éxito pero no se encontraron operaciones abiertas para este empleado';
                                        break;
                                    case 6:
                                        msg = 'Se revisó y aprobó movimiento con éxito pero no se modificaron las incidencias pendientes de pago, checar esto manualmente';
                                        break;
                                    case 7:
                                        msg = 'Se revisó y aprobó movimiento con éxito pero no se eliminaron las incidencias pendientes de pago, porque ya se encuentra en un periodo cerrado';
                                        break;
                                    default:
                                        break;
                                }
                                successAlertS(msg);
                            } else {
                                successAlertS('Se revisó y aprobó movimiento con éxito');
                            }
                            var promises = [];
                            if (employee.movement.type === 6 || employee.movement.type === 8) {
                                var thisEmployee = angular.fromJson(angular.toJson(employee));
                                thisEmployee.$id = employeeId;
                                promises.push($filter('askForLoanUpdate')([thisEmployee]));
                                if (employee.movement.type === 8) {
                                    enableLastCredit(employeeId)
                                }
                            }
                            return Promise.all(promises);
                        }).then(function () {
                            $rootScope.loadingProgress = false;
                            $rootScope.$evalAsync(function () {
                                $log.debug('approve finished');
                            });
                            $scope.goToList()
                        }).catch(function (err) {
                            $log.error(err);
                            errAlertS(err);
                            $rootScope.loadingProgress = false;
                            $rootScope.$evalAsync(function () {
                                $log.debug('approve finished');
                            });
                        });
                    }).catch(function (err) {
                        errAlertS(err);
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync();
                    });
                }).catch(function (err) {
                    errAlertS(err);
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                });
            }
        };
        $scope.addEmail = function () {
            if (angular.isDefined($scope.employee.data.info.emails) && $scope.employee.data.info.emails.length) {
                $scope.employee.data.info.emails.push({
                    active: true
                });
            } else {
                $scope.employee.data.info.emails = [{
                    active: true
                }];
            }
        };
        $scope.addBeneficiary = function () {
            if (!angular.isArray($scope.employee.data.info.beneficiaries)) {
                $scope.employee.data.info.beneficiaries = [];
            }
            if ($scope.employee.data.info.beneficiaries.length < 3) {
                $scope.employee.data.info.beneficiaries.push({});
            } else {
                errAlertS('Solo se permiten 3 registros');
            }
        };
        $scope.addSpecialServices = function () {
            if (angular.isArray($scope.employee.specialServices)) {
                $scope.employee.specialServices.push({});
            } else {
                $scope.employee.specialServices = [{}];
            }
        };
        $scope.addPhone = function () {
            if (angular.isDefined($scope.employee.data.info.phones) && $scope.employee.data.info.phones.length) {
                $scope.employee.data.info.phones.push({
                    active: true
                });
            } else {
                $scope.employee.data.info.phones = [{
                    active: true
                }];
            }
        };
        $scope.removeEmail = function (index) {
            $scope.employee.data.info.emails.splice(index, 1);
            $scope.form.$setDirty()
        };
        $scope.removeSpecialService = function (index) {
            $scope.employee.specialServices.splice(index, 1);
            $scope.form.$setDirty()
        };
        $scope.removePhone = function (index) {
            $scope.employee.data.info.phones.splice(index, 1);
            $scope.form.$setDirty()
        };
        $scope.setTableAction = function (table, action) {
            $scope[table + 'Action'] = action;
            $rootScope.$evalAsync();
        };
        /** Observa cuando carga el empleado para setear defaults y validaciones  */
        if ($scope.objectLoaded) {
            if (!initiated) {
                init();
            }
        } else {
            $log.debug('setting watcher to mainObjLoaded');
            $scope.thisDetailWatchers.mainObjLoaded = $rootScope.$on('mainObjectLoaded', function () {
                if (!initiated) {
                    init();
                }
                $scope.thisDetailWatchers.mainObjLoaded();
                delete $scope.thisDetailWatchers.mainObjLoaded;
            });
        }
        $scope.searchEmployeesFirm = function (search) {
            // 1) Si no hay texto suficiente o no hay firm, devuelve SIEMPRE un array vacío
            if (!search || search.length < 4) return [];
            var firm = $scope.employee && $scope.employee.firm;
            if (!firm) return [];

            // 2) Llama a tu helper
            var res = AppF.autocompleteListM(
                search,
                'employees',
                ['data.name', 'data.nss', 'fid'],
                { firm: firm, center: AppF.center, status: { $ne: 5 } },
                DataF
            );

            // 3) Normaliza: si es array lo envuelve, si es promesa respeta, si viene null -> []
            return $q.when(res || []).then(function (items) {
                return items || [];
            });
        };



        $scope.selectedBoss = null;

        $scope.onEmployeeSelect = function (item) {
            if (item && item.fid) {
                $scope.employee.tdsystemBossId = item.fid || null;
            }
        };

        function searchBoss(fid) {
            if (!fid) {
                $scope.selectedBoss = null;
                return;
            }
            $scope.D.api.get('employees', {
                fid: fid,
                project: JSON.stringify({ 'data.name': '$data.name', 'data.fid': '$data.fid', 'data.nss': '$data.nss' })
            }).then(function (resp) {
                if (resp.data && resp.data.length) {
                    // Asegura el mismo shape que devuelven tus items
                    var doc = resp.data[0];
                    $scope.selectedBoss = doc; // <<=== OBJETO, no string
                } else {
                    $scope.selectedBoss = null;
                }
            });
        }

        // INIT: hidrata y luego observa cambios
        function initBoss() {
            // hidrata inmediatamente si ya hay fid
            searchBoss($scope.employee && $scope.employee.tdsystemBossId);

            // watch sin el filtro fid !== prev (importante para el primer render)
            var unwatch = $scope.$watch('employee.tdsystemBossId', function (fid) {
                if (fid) searchBoss(fid);
                else $scope.selectedBoss = null;
            });

            $scope.$on('$destroy', function () { unwatch && unwatch(); });
        }

        // Si employee es FirebaseObject, espera a que cargue
        if ($scope.employee && angular.isFunction($scope.employee.$loaded)) {
            $scope.employee.$loaded().then(initBoss);
        } else {
            initBoss();
        }




        /**Se Crean los watchers que estaran escuchando la desactivacion de los otros watchers*/
        $scope.thisDetailWatchers.employeeStopDetailWatchersEvent = $rootScope.$on('stopDetailWatchers', function () {
            for (var f in $scope.thisDetailWatchers) {
                if ($scope.thisDetailWatchers.hasOwnProperty(f)) {
                    $log.debug('stopping $watcher', f);
                    $scope.thisDetailWatchers[f]();
                }
            }
            $scope.thisDetailWatchers = {};
        });
        $scope.thisDetailWatchers.finalListeners = $scope.$on('$destroy', function () {
            for (var f in $scope.thisDetailWatchers) {
                if ($scope.thisDetailWatchers.hasOwnProperty(f)) {
                    $log.debug('stopping $watcher', f);
                    $scope.thisDetailWatchers[f]();
                }
            }
            $scope.thisDetailWatchers = {};
        });
    }

}());
(function () {
  'use strict';

  angular
    .module('app.employees')
    .controller('MovementsController', MovementsController)

  /** @ngInject */
  function MovementsController(
    $scope,
    $rootScope,
    $http,
    $mdDialog,
    DataF,
    confirmConfig,
    getArrayOfIdsFilter,
    $log,
    errAlertS,
    successAlertS,
    $filter,
    $document
  ) {
    $scope.setBySystem = function (movementId) {
      var updates = {};
      updates[movementId + "/archived/bySystem"] = true;
      updates[movementId + "/received/bySystem"] = true;
      $scope.F.root.child('catalogs/movements/collection').update(updates).then(function (done) {
        $scope.getThem(true);
        successAlertS('Se actualizo');
      }).catch(function (error) {
        $log.error(error);
      })
    };

    $scope.updateMovement = function (selected, e) {
      var updates = {};
      for (var s = 0; s < selected.length; s++) {
        var element = selected[s];
        updates['movements/collection/' + element.fid + '/status'] = 4;
        updates['employees/collection/' + element.employee + '/movements/' + element.fid + '/s'] = 4;
      }
      $scope.F.root.child('catalogs').update(updates).then(function () {
        successAlertS('Listo');
      });
    };

    $scope.confirmSetMovement = function (e, selected) {


      $mdDialog.show($mdDialog.confirm(confirmConfig)
        .title('Desea establecer este como el último movimiento del empleado?')
        .content('Al continuar los datos del movimiento serán establecidos en el empleado')
        .ariaLabel('Setting Movement')
        .targetEvent(e)
        .ok('Aceptar')
        .cancel('Cancelar'))
        .then(function () {
          $rootScope.loadingProgress = true;
          var movement = selected[0];
          var employeeId = movement.employee;
          var promises = [
            $scope.F.root.child('catalogs/employees/collection/' + employeeId).once('value')
          ];
          if ([7, 2].indexOf(movement.data.type) > -1) {
            var movementTypes = [6, 8];
            if (movement.data.type === 2) {
              movementTypes.push(7);
            }
            var params = {
              query: angular.toJson([
                { '$match': { 'payroll': movement.payroll, 'employee': employeeId, 'data.date': { '$lt': movement.data.date }, 'data.type': { '$in': movementTypes }, } },
                { '$addFields': { 'mType': { '$cond': { 'if': { '$eq': ['$data.type', 6] }, 'then': 8, 'else': '$data.type' } } } },
                { '$sort': { 'data.date': -1 } },
                { '$group': { '_id': '$mType', 'movement': { '$first': "$$ROOT" } } },
                { '$replaceRoot': { 'newRoot': { '$mergeObjects': ['$movement', '$$ROOT'] } } },
                { '$sort': { 'data.date': 1 } }
              ])
            };
            promises.push($rootScope.D.api.post('aggregate/movements', params))
          }
          Promise.all(promises).then(function (resp) {
            var movements = []
            if (resp.length > 1) {
              movements = resp[1].data.reduce(function (current, item) {
                if (item.mType !== 8) {
                  current.push(item)
                } else {
                  current = [item]
                }
                return current;
              }, []);
            }
            var snap = resp[0];
            if (snap.exists()) {
              movements.push(movement);
              var updates = {};
              for (var m = 0; m < movements.length; m++) {
                var thisMovement = movements[m];
                var movementData = angular.fromJson(angular.toJson(thisMovement.data));
                movementData.batch = $filter('getFromObject')(thisMovement, 'received.batch') || null;
                movementData.archiveDate = $filter('getFromObject')(thisMovement, 'archived.date') || null;
                movementData.uid = thisMovement.fid;
                updates['movement'] = movementData;
                updates['movements/' + thisMovement.fid] = {
                  p: thisMovement.payroll,
                  s: 4,
                  d: thisMovement.data.date,
                  t: thisMovement.data.type
                };
                if (thisMovement.data.seniorityDate) {
                  updates['data/seniorityDate'] = thisMovement.data.seniorityDate;
                }
                switch (thisMovement.data.type) {
                  case 6:
                  case 8:
                    updates['data/enroleDate'] = thisMovement.data.date;
                    updates['data/dismissDate'] = null;
                    updates['data/mdsDate'] = null;
                    updates['status'] = 4;
                    break;
                  case 2:
                    updates['data/dismissDate'] = thisMovement.data.date;
                    updates['status'] = 5;
                    break;
                  case 7:
                    updates['data/mdsDate'] = thisMovement.data.date;
                    updates['data/dismissDate'] = null;
                    updates['status'] = 4;
                    break;
                }
                updates['data/salary/sd'] = thisMovement.data.sd || null;
                updates['data/salary/sbc'] = thisMovement.data.sbc || null;
                updates['data/comments'] = thisMovement.data.comments || null;
                updates['data/nss'] = thisMovement.info.nss || null;

                if (angular.isDefined(thisMovement.data.workDay)) {
                  updates['data/workDay'] = thisMovement.data.workDay;
                }
                if (angular.isDefined(thisMovement.data.workerType)) {
                  updates['data/workerType'] = thisMovement.data.workerType;
                }
                if (angular.isDefined(thisMovement.data.salaryType)) {
                  updates['data/salary/type'] = thisMovement.data.salaryType;
                }
                if (angular.isDefined(thisMovement.data.position)) {
                  updates['data/position'] = thisMovement.data.position
                }
                updates['rp'] = thisMovement.rp;
                updates['payroll'] = thisMovement.payroll;
                if (angular.isDefined(thisMovement.cc)) {
                  updates['cc'] = thisMovement.cc;
                }
                updates['updated'] = DataF.getTimeObject();
              }
              $scope.F.root.child('catalogs/employees/collection/' + employeeId).update(updates).then(function () {
                successAlertS('Se actualizó la información del usuario correctamente');
                $rootScope.loadingProgress = false;
              }).catch(function (error) {
                $rootScope.loadingProgress = false;
                errAlertS('Error actualizando la información del empleado');
                $log.error(error);
              });
            } else {
              $rootScope.loadingProgress = false;
              errAlertS('El empleado del movimiento no fue encontrado en la base de datos');
            }
          }).catch(function (error) {
            $rootScope.loadingProgress = false;
            errAlertS(error);
          });
        }, function () {
          $log.debug('Deleting Cancelled');
        });

    }
    $scope.printPDF = function (e) {
      $mdDialog.show($mdDialog.confirm(confirmConfig)
        .title('Se generará un pdf de los movimiento(s) seleccionado(s)')
        .content('')
        .ariaLabel('Deleting')
        .targetEvent(e)
        .ok('Aceptar')
        .cancel('Cancelar'))
        .then(function () {
          try {
            var movementsId = getArrayOfIdsFilter($scope.selected);
            if (movementsId.length) {
              var finalUrl = 'interface/pdf/movements/' + movementsId.toString();
              $scope.F.downloadFile('GET', finalUrl)
            }
          } catch (error) {
            errAlertS(error)
          }
        }, function () {
          $log.debug('Deleting Cancelled');
        });
    }

    $scope.deleteMovements = function (event) {
      $rootScope.loadingProgress = true;
      var promises = [];
      for (var i = 0; i < $scope.selected.length; i++) {
        promises.push($scope.L.loadList('employees', 'catalogs/employees/collection/' + $scope.selected[i].employee + '/movement/uid', undefined, 'object', 'employeeMovementUid-' + $scope.selected[i].employee));
      }
      Promise.all(promises).then(function (resp) {
        var msg;
        var deleted = 0;
        for (var r = 0; r < resp.length; r++) {
          var index = r - deleted;
          if (resp[r].$value === $scope.selected[index].$id) {
            if (angular.isUndefined(msg)) {
              msg = '';
            }
            msg = msg + '<li>No se puede eliminar el ultimo movimiento de ' + $scope.selected[index].info.name + '</li>';
            $scope.selected.splice(index, 1);
            deleted++;
          }
        }
        $rootScope.loadingProgress = false;
        if (angular.isDefined(msg)) {
          msg = '<ul>' + msg + '</ul>';
          errAlertS(msg);
        }
        if ($scope.selected.length > 0) {
          $scope.deleteFb(event);
        }
      }).catch(function (error) {
        $rootScope.loadingProgress = false;
        errAlertS(error);
      });
    };

    var exportToExcel = function (url, data) {
      $http({
        method: 'POST',
        url: window.__env.serviceWorkerUrl + url,
        responseType: 'arraybuffer',
        params: data
      }).then(function (response) {
        var headers = response.headers();
        var filename = headers['x-filename'];
        var contentType = headers['content-type'];

        var linkElement = document.createElement('a');
        try {
          var blob = new Blob([response.data], {
            type: contentType
          });
          var url = window.URL.createObjectURL(blob);
          linkElement.setAttribute('href', url);
          linkElement.setAttribute("download", filename);
          var clickEvent = new MouseEvent("click", {
            "view": window,
            "bubbles": true,
            "cancelable": false
          });
          linkElement.dispatchEvent(clickEvent);
        } catch (ex) {
          $log.debug(ex, "error descargando el archivo");
        }
      }).catch(function (err) {
        errAlertS(err);
      });
    }

    // TODO:edgardo pasar esta funcion a FBListsCtrl y hacerlo genérico
    $scope.getExport = function () {
      var employees = $scope.selected;
      var data = {};
      var title = "";
      var msg = "";
      var url = "";
      data = {
        ref: "catalogs/movements/collection",
        querys: {}
      };
      title = "Se exportaran los movimientos del empleado";
      var employees = [];
      if ($scope.selected.length > 0) {
        msg = "Los registros seleccionados seran exportados";
        employees = $scope.selected;
      } else {
        msg = "Todos los datos listados seran exportados";
        employees = $scope.Z[$scope.F.active.menuName];
      }
      data.querys.employee = [];
      data.addData = {
        employee: {}
      };
      for (var a in employees) {
        if (employees[a].hasOwnProperty("$id")) {
          data.querys.employee.push(employees[a].$id);
          data.addData.employee[employees[a].$id] = {
            employee_name: employees[a].data.name
          };
        }
      }
      if ($scope.F.search.$['data.date:<']) {
        if (data.querys["data.date"] == undefined) {
          data.querys["data.date"] = {};
        }
        data.querys["data.date"].to = $scope.F.search.$['data.date:<'];
      }
      if ($scope.F.search.$['data.date:>']) {
        if (data.querys["data.date"] == undefined) {
          data.querys["data.date"] = {};
        }
        data.querys["data.date"].from = $scope.F.search.$['data.date:>'];
      }
      if ($scope.F.search.$['data.type']) {
        data.querys["data.type"] = $scope.F.search.$['data.type']
      }
      url = "interface/exportFBData";
      $mdDialog.show(
        $mdDialog.confirm(confirmConfig)
          .title(title)
          .content(msg)
          .ariaLabel('Cambiar Fechas')
          .ok('Aceptar')
          .cancel('Cancelar')
      ).then(function () {
        exportToExcel(url, data);
      });
    }
    $scope.importMovementsEmployees = function (ev) {
      $mdDialog.show({
        templateUrl: 'app/main/employees/views/importImms/importMovementImms.html',
        controller: 'importMovementImmsController',
        controllerAs: 'impCtrl',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true
      });
      $log.log('entro en el modal de movimientos')
    }

  }

}());

(function () {
    'use strict';

    angular
        .module('app.employees')
        .controller('HistoricMovementController', HistoricMovementController)

    /** @ngInject */
    function HistoricMovementController(
        $scope,
        $rootScope,
        $log,
        $firebaseObject,
        successAlertS,
        errAlertS,
        $q,
        clearObjectFilter,
        getArrayFromObjectFilter
    ) {

        /**@type watcher, dom
         * @description Carga el empleado cuando se selecciona en el formulario
         * @param {string} employeeId 
         */
        function loadEmployee(employeeId) {
            if (employeeId) {
                var employee = $firebaseObject($scope.F.root.child('catalogs/employees/collection').child(employeeId));
                employee.$loaded().then(function (employee) {
                    $scope.employee = clearObjectFilter(employee);
                });
            }
        }

        /**@type watcher, dom, formatter
         * @description Cuando carga el empleado, se inicializa el movimiento
         * @param {Employee} employee 
         */
        function initializeMovement(employee) {
            if (employee) {
                if (employee.data) {
                    $scope.movement.created = $scope.D.getTimeObject();
                    $scope.movement.created.type = 'manual';
                    $scope.movement.approved = $scope.D.getTimeObject();
                    $scope.movement.received = $scope.D.getTimeObject();
                    $scope.movement.archived = $scope.D.getTimeObject();
                    $scope.movement.status = 4;
                    $scope.movement.cc = employee.cc || null;

                    $scope.movement.info = {
                        maternalSurname: employee.data.info.maternalSurname || '',
                        names: employee.data.info.names,
                        nss: employee.data.nss || '',
                        paternalSurname: employee.data.info.paternalSurname || '',
                        umf: employee.data.health.umf || '',
                        name: employee.data.name
                    };
                    $scope.movement.data = {
                        comments: '',
                        // si no es mds, se guardan estos datos para saber cual era el salario en el momento en que se creo este movimiento
                        salaryType: JSON.parse(JSON.stringify(employee.data.salary.type)),
                        sbc: employee.data.salary.sbc ? JSON.parse(JSON.stringify(employee.data.salary.sbc)) : null,
                        sd: employee.data.salary.sd ? JSON.parse(JSON.stringify(employee.data.salary.sd)) : null,
                        sdr: employee.data.salary.sdr ? JSON.parse(JSON.stringify(employee.data.salary.sdr)) : null,
                        workDay: JSON.parse(JSON.stringify(employee.data.workDay)),
                        workerType: JSON.parse(JSON.stringify(employee.data.workerType))
                    };

                    $scope.lastMovementDate = 0;
                    for (var m in employee.movements) {
                        if (employee.movements[m].d > $scope.lastMovementDate) {
                            $scope.lastMovementDate = employee.movements[m].d;
                        }
                    }
                    if ($scope.lastMovementDate > 0) {
                        $scope.maxDate = moment($scope.lastMovementDate - $scope.F.oneDay).toDate();
                    }

                    // $log.debug('initializeMovement finished', {
                    //     movement: $scope.movement,
                    //     maxDate: $scope.maxDate,
                    //     lastMovementDate: $scope.lastMovementDate,
                    //     employee: employee
                    // });
                }
            }
        }

        /**@type watcher, dom, formatter
         * @description Setea variables por default si es baja
         * @param {MovementType} type 
         */
        function setDefaultIfDismiss(type) {
            $log.debug('setDefaultIfDismiss called');
            if (type && type == 2) {
                if (!$scope.movement.data) {
                    $scope.movement.data = {};
                }
                $scope.movement.data.rehirable = false;
                $scope.movement.data.paySalaryInPayrol = false;
                $log.debug('setDefaultIfDismiss finished setting default values');
            }
        }

        /**@type api, crud, special
         * @description Solamente crea un movimiento histórico, el servidor se encarga de crear el minimovement
         * @param {Movement} movement 
         */
        function createHistoricMovement(movement) {
            $log.debug('createHistoricMovement called');
            if (movement.status < 4) {
                movement.archived = null;
            }
            if (movement.status < 3) {
                movement.received = null;
            }
            if (movement.status < 2) {
                movement.approved = null;
            }
            if ($scope.bySystem) {
                if (angular.isObject(movement.received) && movement.received !== null) {
                    movement.received.bySystem = true;
                }
                if (angular.isObject(movement.archived) && movement.archived !== null) {
                    movement.archived.bySystem = true;
                }
            }

            $log.debug('about to createMovement', movement);
            $scope.D.models.action('movements', 'createHistoricMovement', {
                movement: movement
            }).then(function (res) {
                successAlertS(res.data.message);
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync(function () {
                    $log.debug('createHistoricMovement finished');
                });
                $scope.R.goToList();
            }).catch(function (err) {
                errAlertS(err);
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
            });
        }

        /**@type dom
         * @description Autocomplete de listados
         * @param {string} search lo que se desea buscar
         * @param {string} inList referencia de la hija
         */
        function autocompleteList(search, inList) {
            if (inList == 'employees/all') {
                return $q(function (resolve, reject) {
                    $scope.autocompleteMongo(search, 'employees').then(function (items) {
                        var newItems = [];
                        for (var i = 0; i < items.length; i++) {
                            var thisItem = items[i];
                            var obj = {
                                'name': thisItem.data.name,
                                '$id': thisItem.fid,
                                'nss': thisItem.data.nss,
                                'payroll': thisItem.payroll
                            };
                            newItems.push(obj);
                        }
                        console.log(newItems);
                        resolve(newItems);
                    }).catch(function (err) {
                        errAlertS(err);
                        reject(err);
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync();
                    });
                });
            } else {
                return new Promise(function (resolve, reject) {
                    var ref = $scope.F.root.child('lists').child(inList);
                    var searchQ = search.toUpperCase();
                    ref.orderByChild('name').startAt(searchQ).endAt(searchQ + '\uf8ff').once('value', function (snap) {
                        var value = snap.val();
                        if (value !== null) {
                            var array = getArrayFromObjectFilter(value, false, true);
                            resolve(array);
                        } else {
                            resolve([]);
                        }
                    }, function (err) {
                        reject(err);
                    });
                });
            }
        }

        $scope.autocompleteMongo = function (search, catalog, fields, extraQuerys) {
            return $q(function (resolve, reject) {
                $scope.D.api.autocompleteMongo(search, catalog, ['data.name', 'data.nss'], extraQuerys).then(function (items) {
                    resolve(items);
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync(function () {
                        $log.debug('getThem finished');
                    });
                }).catch(function (err) {
                    errAlertS(err);
                    reject(err);
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                });
            });
        };

        $scope.createHistoricMovement = createHistoricMovement;
        $scope.autocompleteList = autocompleteList;

        $scope.detailWatchers.movementEmployee = $scope.$watch('movement.employee', loadEmployee);
        $scope.detailWatchers.employee = $scope.$watch('employee', initializeMovement, true);
        $scope.detailWatchers.movementDataType = $scope.$watch('movement.data.type', setDefaultIfDismiss, true);

        var employeeStopDetailWatchersEvent = $rootScope.$on('stopDetailWatchers', function () {
            for (var f in $scope.detailWatchers) {
                //$log.debug('stopping $watcher', f);
                $scope.detailWatchers[f]();
            }
            employeeStopDetailWatchersEvent();
            finalListeners();
        });

        var finalListeners = $scope.$on("$destroy", function () {
            for (var f in $scope.detailWatchers) {
                //$log.debug('stopping $watcher', f);
                $scope.detailWatchers[f]();
            }
            employeeStopDetailWatchersEvent();
            finalListeners();
        });
    }

}());
(function () {
  "use strict";

  angular
    .module("app.employees")
    .controller("IdseAutoRecordsController", IdseAutoRecordsController);

  function IdseAutoRecordsController($scope, userHasPermissionFilter, $firebaseArray, AppF, $q, $timeout, $document, $filter, validateMovementFilter, startAfterInitFilter, $log, infoAlertS, confirmConfig, $mdDialog, errAlertS, successAlertS, $rootScope, getArrayOfIdsFilter) {
    var watchers = {};
    var initiated = false;
    var editBatchOnSend = false;
    function init() {
      editBatchOnSend = userHasPermissionFilter(AppF.groupsOfUser, AppF.permissions, 'editBatchOnSend', 'movements.idseAutoRecords');
    }
    $scope.getResponseOfMovements = function (e, selected, useV2) {
      $rootScope.loadingProgress = true;
      var ids = selected.map(function (item) {
        return item.fid;
      });
      var path = useV2 ? 'getBatchRecordData' : 'getResponseOfMovements';
      $scope.D.models.action('movements', path, { ids: ids }).then(function (res) {
        var result = res.data;
        if (result.msgError && angular.isArray(result.msgError) && result.msgError.length > 0) {
          errAlertS(result.msgError);
        }
        var total = result.ok + result.error;
        if (total > 0) {
          successAlertS('Se recibieron ' + total + ' movimientos, ' + result.ok + ' correcto(s) y ' + result.error + ' con error(es)');
          $scope.getThem();
        } else {
          infoAlertS('No se ha recibido ningún movimiento');
        }
        $rootScope.loadingProgress = false;
        $rootScope.$evalAsync(function () { });
      }).catch(function (err) {
        errAlertS(err);
        $rootScope.loadingProgress = false;
        $rootScope.$evalAsync();
      });
    }
    function sendToDismissesUnconfirmed(selected) {
      $log.debug('sendToDismissesUnconfirmed', selected);
      var selectedEMap = [];
      for (var e = 0; e < selected.length; e++) {
        selectedEMap.push({
          id: selected[e].employee,
          mId: selected[e].fid
        });
      }
      $rootScope.loadingProgress = true;
      $scope.D.models.action('employees', 'sendToDismissesUnconfirmed', {
        employees: selectedEMap
      }).then(function (response) {
        successAlertS(response.data.message, response.data.stay);
        $timeout(function () {
          $scope.getThem();
          $rootScope.loadingProgress = false;
          $rootScope.$evalAsync(function () {
            $log.debug('sendToDismissesUnconfirmed finished');
          });
        }, 2000)
      }).catch(function (err) {
        errAlertS(err);
        $rootScope.loadingProgress = false;
        $rootScope.$evalAsync();
      });
    }

    $scope.showModalSendToUnconfirmed = function (ev) {
      $log.debug('sendToUnconfirmedConfirm called');
      var selected = $scope.selected
      var confirm = $mdDialog.confirm(confirmConfig)
        .title('Desea mandar ' + selected.length + ' baja(s) a bajas por confirmar(s)?')
        .ariaLabel('Está Seguro(a)?')
        .targetEvent(ev)
        .ok('Mandar')
        .cancel('Cancelar');

      $mdDialog.show(confirm).then(function (answer) {
        $log.debug(answer, 'answer');
        sendToDismissesUnconfirmed(selected);
      }, function () {
        $log.debug('sendToUnconfirmedConfirm cancelled');
        return false;
      });
    }

    function getModal(e, selected, useV2, batch) {
      var confirmDialog;
      if (useV2 && (editBatchOnSend || batch)) {
        confirmDialog = {
          controllerAs: 'smdCtrl',
          controller: function ($scope, $mdDialog) {
            var vm = this;
            vm.showAddButton = editBatchOnSend;
            if (batch) {
              vm.addBatch = true;
              vm.showAddButton = false;
            }
            if (batch) {
              vm.data = { batch: batch };
            }
            vm.totalMovements = selected.length;
            vm.cancel = function () {
              $mdDialog.cancel();
            };
            vm.answer = function (data) {
              $mdDialog.hide(data);
            };
          },
          templateUrl: 'app/main/employees/views/idseAutoRecords/dialogs/sendMovements.html',
          parent: angular.element($document.body),
          targetEvent: e,
          clickOutsideToClose: false
        }
      } else {
        confirmDialog = $mdDialog
          .confirm(confirmConfig)
          .title('Desea enviar ' + selected.length + ' movimiento(s) a IDSE')
          .htmlContent('Se enviaran los movimientos seleccionados a IDSE')
          .ariaLabel('Sending to IDSE')
          .targetEvent(e)
          .ok('Enviar')
          .cancel('Cancelar')
      }
      return $mdDialog.show(confirmDialog)
    }

    $scope.sendMovements = function (e, selected, useV2, batch) {
      getModal(e, selected, useV2, batch).then(function (data) {
        $rootScope.loadingProgress = true;
        var ids = selected.map(function (item) {
          return item.fid;
        });
        var path;
        var params = { ids: ids };
        if (useV2) {
          path = 'sendMovementsV2';
          if (angular.isObject(data)) {
            for (var key in data) {
              params[key] = data[key];
            }
          }
        } else {
          path = 'sendMovements';
        }
        $scope.D.models.action('movements', path, params).then(function () {
          successAlertS('Se enviaron el(los) movimiento(s) con éxito');
          $scope.getThem();
          $rootScope.loadingProgress = false;
          $rootScope.$evalAsync(function () { });
        }).catch(function (err) {
          errAlertS(err);
          $rootScope.loadingProgress = false;
          $rootScope.$evalAsync();
        });
      }, function () {
        $log.debug('Deleting Cancelled');
      });
    }

    function validateMovements(movements, rp, movementType, errors) {
      return new Promise(function (resolve, reject) {
        if (angular.isArray(movements)) {
          if (movements.length > 0) {
            var thisMovement = movements.shift()
            validateMovementFilter(thisMovement, rp, movementType).then(function (result) {
              errors = errors ? errors : [];
              if (result.error) {
                errors.push(result.error);
              }
              resolve(validateMovements(movements, rp, movementType, errors));
            }).catch(reject);
          } else {
            resolve(errors);
          }
        } else {
          reject('No hay movimientos a validar');
        }
      })
    }

    $scope.getSuaInterface = function (selected, forceEnrole) {
      var thisSelected = [].concat(selected);
      validateMovements(thisSelected, selected[0].rp, selected[0].data.type).then(function (errors) {
        if (errors.length > 0) {
          throw errors;
        }
        var movementsType = selected[0].data.type;
        var mTypeIntercases = { 2: 'dismissesRecords', 6: 'enroles', 8: 'enroles', 7: 'mdsRecords' };
        var ids = getArrayOfIdsFilter(selected);
        var url = 'interface/sua2/' + mTypeIntercases[movementsType];
        var params = { ids: ids.toString(), recordType: 'movements' };
        if (forceEnrole) {
          params.forceEnrole = true;
        }
        $scope.F.downloadFile('POST', url, params);
      }).catch(errAlertS)
    }

    $scope.goToDetail = function (action, movement) {
      var catalogs = {
        6: "enroles",
        8: "enroles",
        7: "mdsRecords",
        2: "dismissesRecords"
      }
      var catalogName = catalogs[movement.data.type];
      if (angular.isUndefined(catalogName)) {
        errAlertS('No se encontró el detalle del catalogo')
      } else {
        $scope.R.goToDetail(null, action, { employeeId: movement.employee, movementId: movement.fid, redirectTo: 'app.movements.idseAutoRecords' }, catalogName)
      }
    }
    function cancelEmployeeLastMovement(movement) {
      return new Promise(function (resolve) {
        $scope.D.models.action('employees', 'cancelLastMovement', {
          employee: movement.employee,
          movement: movement.fid
        }).then(function (response) {
          resolve({ success: true, msg: response.data.message });
        }).catch(function (respError) {
          var err = respError.data;
          var msg = 'El movimiento de ' + movement.info.name + ' no pudo ser cancelado';
          if (angular.isString(err)) {
            msg += ' ya que ' + err;
          } else if (angular.isObject(err) && (err.msg || err.message)) {
            msg += ' ya que ' + (err.msg || err.message);
          } else {
            $log.error(msg, err)
          }
          resolve({ msg: msg })
        });
      })
    }
    function cancelEmployeesLastMovement(selected, results) {
      return new Promise(function (resolve, reject) {
        results = results || { errors: [], success: [] };
        if (selected.length > 0) {
          var thisMovements = selected.splice(0, selected.length > 30 ? 30 : selected.length);
          $log.log(thisMovements)
          var promises = thisMovements.map(function (item) {
            return cancelEmployeeLastMovement(item)
          })
          Promise.all(promises).then(function (resp) {
            for (var r = 0; r < resp.length; r++) {
              var thisResp = resp[r];
              results[thisResp.success ? 'success' : 'errors'].push(thisResp.msg);
            }
            resolve(cancelEmployeesLastMovement(selected, results));
          }).catch(reject)
        } else {
          resolve(results);
        }
      })
    }
    $scope.cancelLastMovement = function (event, selected) {
      if (!(selected.length > 0)) {
        infoAlertS('No se selecciono ningún movimiento');
      }
      $rootScope.loadingProgress = true;
      $rootScope.$evalAsync();
      var promises = {};
      for (var s = 0; s < selected.length; s++) {
        var movement = selected[s];
        promises[movement.employee] = $scope.F.root.child('catalogs/employees/collection/' + movement.employee + '/movements').once('value')
      }
      $q.all(promises).then(function (resp) {
        $rootScope.loadingProgress = false;
        $rootScope.$evalAsync();
        var content = "<ul>";
        for (var s = 0; s < selected.length; s++) {
          var movement = selected[s];
          $log.log(resp[movement.employee].val())
          var msg = Object.keys(resp[movement.employee].val()).length > 1 ? movement.info.name + ' se regresará al movimiento previo' : movement.info.name + ' se borrará ya que solo tiene un movimiento';
          content += '<li>' + msg + '</li>'
        }
        content += "</ul>";
        return $mdDialog.show($mdDialog.confirm(confirmConfig)
          .title('Quiere cancelar el último movimiento de ' + selected.length + ' empleado(s)?')
          .htmlContent(content)
          .ariaLabel('cancel movement')
          .targetEvent(event)
          .ok('Si')
          .cancel('No'))
      }).then(function () {
        $rootScope.loadingProgress = true;
        $rootScope.$evalAsync();
        return cancelEmployeesLastMovement(selected)
      }).then(function (result) {
        if (result.success.length > 0) {
          successAlertS('Se cancelaron ' + result.success.length + ' con éxito')
        }
        if (result.errors.length > 0) {
          errAlertS(result.errors);
        }
        return new Promise(function (resolve) { $timeout(function () { resolve(true) }, 5000) })
      }).then(function () {
        return $scope.getThem()
      }).then(function () {
        $rootScope.loadingProgress = false;
        $rootScope.$evalAsync();
        $log.log('terminado')
      }).catch(function (error) {
        if (error) {
          errAlertS(error);
        }
      })
    }

    $scope.printPDF = function (e) {
      $mdDialog.show($mdDialog.confirm(confirmConfig)
        .title('Se generará un pdf de los movimiento(s) seleccionado(s)')
        .content('')
        .ariaLabel('generating pdf')
        .targetEvent(e)
        .ok('Aceptar')
        .cancel('Cancelar'))
        .then(function () {
          try {
            var movementsId = getArrayOfIdsFilter($scope.selected);
            if (movementsId.length) {
              var finalUrl = 'interface/pdf/movements/' + movementsId.toString();
              $scope.F.downloadFile('GET', finalUrl)
            }
          } catch (error) {
            errAlertS(error);
          }
        }).catch(function () {
          $log.debug('Generate printPdf cancelled');
        });
    }

    $scope.archivedMovement = function (event, employee, status) {
      $mdDialog.show({
        templateUrl: 'app/main/employees/views/idseAutoRecords/dialogArchivate.html',
        controller: 'dialogArchivateController',
        controllerAs: 'ctrl',
        parent: angular.element($document.body),
        locals: { employee: employee, status: status, selected: $scope.selected.length },
        targetEvent: event,
        size: 'lg'
      }).then(function () {
        $scope.getThem();
      }).catch(function (error) {
        if (error) {
          errAlertS(error)
        }
      })
    }








    startAfterInitFilter($scope, watchers, initiated, init);
  }
})();

(function () {
    'use strict';
    angular
        .module('app.clients')
        .controller('dialogArchivateController', dialogArchivateController);

    function dialogArchivateController(employee, status, $scope, selected, $firebaseArray, $log, AppF, $mdDialog, DataF, $rootScope) {
        var vm = this;
        $scope.F = AppF;
        vm.noLote = '000000000';
        vm.selected = selected


        vm.archived = function (noLote) {
            vm.loading = true;
            var promises = employee.map(function (movement) {
                return processMovement(movement, noLote);
            });
            Promise.all(promises)
                .then(function () {
                    $log.log('Movimientos archivados correctamente');
                    vm.loading = false;
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                    $mdDialog.hide();
                })
                .catch(function (error) {
                    $log.error('Error al archivar movimientos:', error);
                    vm.loading = false;
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                    $mdDialog.hide();
                });
        };

        function processMovement(movementFounded, noLote) {
            var url = 'catalogs/employees/collection/' + movementFounded.employee + '/movements';
            var validLast = AppF.root.child(url);
            var data = $firebaseArray(validLast);

            return data.$loaded().then(function (resp) {
                var updates = {};
                var isLastMovements;
                var last = resp.pop();

                isLastMovements = last.$id === movementFounded.fid;

                var timeObj = DataF.getTimeObject();

                updates['movements/collection/' + movementFounded.fid + '/status'] = status === 1 ? 3 : 4;
                updates['employees/collection/' + movementFounded.employee + '/movements/' + movementFounded.fid + '/s'] = status === 1 ? 3 : 4;

                var receivedTimeObj = Object.assign({}, timeObj, { batch: noLote });
                updates['movements/collection/' + movementFounded.fid + '/received'] = receivedTimeObj;

                var archivedTimeObj = Object.assign({}, timeObj, { date: timeObj.atTime });
                updates['movements/collection/' + movementFounded.fid + '/archived'] = archivedTimeObj;

                if (isLastMovements) {
                    updates['employees/collection/' + movementFounded.employee + '/movement/batch'] = noLote;
                    updates['employees/collection/' + movementFounded.employee + '/movement/receivedDate'] = receivedTimeObj.atTime;
                    updates['employees/collection/' + movementFounded.employee + '/status'] = (movementFounded.data.type === 2 ? 5 : 4);
                    updates['employees/collection/' + movementFounded.employee + '/movement/archiveDate'] = archivedTimeObj.date;
                }
                return updateCatalog(updates);
            });
        }
        function updateCatalog(updates) {
            return $scope.F.root.child('catalogs/').update(updates);
        }
        vm.close = function () {
            $mdDialog.hide();
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.employees')
        .controller('LoansController', LoansController)

    /** @ngInject */
    function LoansController(
        $scope,
        $rootScope,
        $mdDialog,
        $filter,
        $firebaseObject,
        successAlertS,
        errAlertS,
        $log,
        AppF
    ) {
        $scope.deleteLoans = function (e) {
            var loans = JSON.parse(JSON.stringify($scope.selected));
            var updates = {};
            var count = loans.length;
            var deleteLoans = true;
            angular.forEach(loans, function (loan) {
                angular.forEach(loan.incidences, function (incidence, incidenceId) {
                    if (incidence.status >= 3) {
                        deleteLoans = false;
                    } else {
                        updates[loan.payroll + "/" + incidence.calendar + "/" + incidenceId] = null;
                    }
                });
            });
            if (deleteLoans) {
                $scope.delete(e, 1).then(function () {
                    $log.log(updates);
                    AppF.root.child("incidences").update(updates).then(function () {
                        successAlertS('Se borraron ' + count + ' Prestamo(s)');
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync(function () {
                            $log.debug('delete Loan and incidences finished');
                        });
                    }, errAlertS);
                }).catch(function (err) {
                    errAlertS(err);
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                });
            } else {
                errAlertS("No se pueden eliminar el prestamo una o varias incidencias ya se han aplicado");
            }
        }
        $scope.generateFile = function (event, employees, isXls) {
            try {
                if (!angular.isArray(employees) && employees.length === 0) {
                    throw 'Ningún empleado seleccionado';
                } else if (employees.length > 500) {
                    throw 'Seleccione menos empleados, Maximo limite de empleados es 500';
                }
                var confirm = $mdDialog.confirm().
                    title('Generar Reporte')
                    .textContent('Desea generar el reporte de vacaciones de ' + employees.length + ' empleados(s)')
                    .ariaLabel('Está Seguro(a)?')
                    .targetEvent(event)
                    .ok('OK')
                    .cancel('Cancelar');
                $mdDialog.show(confirm).then(function () {
                    try {
                        var extraParams = isXls ? { type: "xls" } : {};
                        extraParams.employeesIds = employees.map(function (item) {
                            return item.$id;
                        });
                        AppF.downloadFile('POST', "interface/exportLoansReport", extraParams);
                    } catch (error) {
                        errAlertS(error);
                    }
                }).catch(function () {
                    $log.log('$mdDialog cerrado');
                })
            } catch (error) {
                errAlertS(error);
            }
        };

    }

}());
(function () {
    'use strict';

    angular
        .module('app.employees')
        .controller('LoanController', LoanController);

    /** @ngInject */
    function LoanController(
        $filter,
        $scope,
        $log,
        $rootScope,
        $q,
        $firebaseObject,
        $firebaseArray,
        $mdDialog,
        $mdEditDialog,
        $timeout,
        successAlertS,
        errAlertS,
        AppF,
        confirmConfig,
        CalendarF,
        infoAlertS
    ) {
        var watchersObj = {};
        var initFlag = false;
        $scope.listWatchers = {};
        $scope.searchQuery = '';
        $scope.existPeriods = false;
        $scope.activeCalendar = false;
        $scope.allowEditDate = false;
        $scope.validIncidences = true;

        function init() {
            Promise.all([$scope.mainObjectLoaded]).then(function () {
                initValidWatcher();
            }).catch(function (err) {
                errAlertS(err);
            });
        }

        function getIncidencesUpdates(loan, loanId, newIncidences) {
            var updates = {};
            $filter('loopEach')(loan.incidences, function (thisIncidence, i) {
                var thisPayroll = thisIncidence.payroll || loan.payroll;
                var founded = $filter('filter')(newIncidences, {
                    calendar: thisIncidence.calendar,
                    period: thisIncidence.period,
                    payroll: thisPayroll
                });
                if (founded.length) {
                    var newIncidence = founded[0];
                    var index = newIncidences.indexOf(newIncidence);
                    newIncidences.splice(index, 1);
                    if (thisIncidence.status < 3) {
                        if (thisIncidence.value !== newIncidence.value) {
                            loan.incidences[i].value = newIncidence.value;
                            updates[thisPayroll + '/' + thisIncidence.calendar + '/' + i + '/value'] = newIncidence.value;
                        }
                        if (thisIncidence.date !== newIncidence.date) {
                            loan.incidences[i].date = newIncidence.date;
                            updates[thisPayroll + '/' + thisIncidence.calendar + '/' + i + '/date'] = newIncidence.date;
                        }
                        if (thisIncidence.status !== newIncidence.status) {
                            loan.incidences[i].status = newIncidence.status;
                            updates[thisPayroll + '/' + thisIncidence.calendar + '/' + i + '/status'] = newIncidence.status;
                        }
                        if (thisIncidence.comments !== newIncidence.comments) {
                            $log.log('change comment', thisIncidence.comments, newIncidence.comments);
                            loan.incidences[i].comments = newIncidence.comments;
                            if (newIncidence.comments === '') {
                                newIncidence.comments = 'Incidencia Automática de Amortización';
                            }
                            updates[thisPayroll + '/' + thisIncidence.calendar + '/' + i + '/comments'] = newIncidence.comments;
                        }
                    }
                } else {
                    delete loan.incidences[i];
                    updates[thisPayroll + '/' + thisIncidence.calendar + '/' + i] = null;
                }
            });
            for (var n = 0; n < newIncidences.length; n++) {
                var thisInc = newIncidences[n];
                var thisPayroll = thisInc.payroll || loan.payroll;
                var newIncidenceId = AppF.root.child('incidences/' + thisPayroll + '/' + thisInc.calendar).push().key;
                var incidenceObj = {
                    automaticAsignation: true,
                    status: thisInc.status,
                    from: {
                        loan: loanId
                    },
                    calendar: thisInc.calendar,
                    period: thisInc.period,
                    employee: loan.employee,
                    incidenceType: loan.data.incidenceType,
                    payroll: thisPayroll,
                    process: false,
                    nature: 'deduction',
                    type: 'system',
                    notCreated: true,
                    value: thisInc.value, //
                    date: thisInc.date, //
                    comments: thisInc.comments || 'Incidencia Automática de Amortización'
                };
                updates[thisPayroll + '/' + thisInc.calendar + '/' + newIncidenceId] = incidenceObj;
                if (typeof (loan.incidences) === 'undefined') {
                    loan.incidences = {};
                }
                loan.incidences[newIncidenceId] = thisInc;
            }
            return {
                updates: updates,
                loan: loan
            };
        }

        function editDate(event, incidence, incidences) {
            event.stopPropagation();
            var minDatePromise = CalendarF.getAvailablePeriodStartDate($scope.loan.payroll);
            var incidenceIndex = incidences.indexOf(incidence);
            minDatePromise.then(function (minDate) {
                var options = {
                    controller: ['$element', '$q', 'save', '$scope', function ($element, $q, save, $scope) {
                        function update() {
                            if ($scope.editDialog.$invalid) {
                                return $q.reject();
                            }
                            if (angular.isFunction(save)) {
                                return $q.when(save($scope.editDialog.input, $scope.calendar, $scope.period));
                            }
                            return $q.resolve();
                        }
                        this.dismiss = function () {
                            $element.remove();
                        };
                        this.getInput = function () {
                            return $scope.editDialog.input;
                        };
                        $scope.dismiss = this.dismiss;
                        $scope.submit = function () {
                            update().then(function () {
                                $scope.dismiss();
                            });
                        };
                    }],
                    targetEvent: event,
                    locals: {
                        save: function (input, calendar, period) {
                            incidence.date = input.$modelValue;
                            incidence.calendar = calendar;
                            incidence.period = period;
                        }
                    },
                    scope: {
                        model: incidence.date,
                        placeholder: 'Selecciona una fecha',
                        minDate: minDate,
                        payroll: $scope.loan.payroll,
                        incidences: incidences,
                        incidenceIndex: incidenceIndex
                    },
                    templateUrl: 'app/main/employees/views/loans/input-date.html'
                };
                var promise = $mdEditDialog.show(options);
                promise.then(function (ctrl) {
                    var input = ctrl.getInput();
                    input.$viewChangeListeners.push(function () {
                        //input.$setValidity('test', input.$modelValue);
                    });
                });
            }).catch(function (error) {
                errAlertS(error);
            });
        }

        function editComment(event, incidence) {
            event.stopPropagation();
            var options = {
                controller: ['$element', '$q', 'save', '$scope', function ($element, $q, save, $scope) {
                    function update() {
                        if ($scope.editDialog.$invalid) {
                            return $q.reject();
                        }
                        if (angular.isFunction(save)) {
                            return $q.when(save($scope.editDialog.input));
                        }
                        return $q.resolve();
                    }
                    this.dismiss = function () {
                        $element.remove();
                    };
                    this.getInput = function () {
                        return $scope.editDialog.input;
                    };
                    $scope.dismiss = this.dismiss;
                    $scope.submit = function () {
                        update().then(function () {
                            $scope.dismiss();
                        });
                    };
                }],
                targetEvent: event,
                locals: {
                    save: function (input) {
                        incidence.comments = input.$modelValue;
                    }
                },
                scope: {
                    model: incidence.comments,
                    placeholder: 'Agrega un comentario'
                },
                templateUrl: 'app/main/employees/views/loans/input-comments.html'
            };
            var promise = $mdEditDialog.show(options);
            promise.then(function (ctrl) {
                var input = ctrl.getInput();
                input.$viewChangeListeners.push(function () {
                    //input.$setValidity('test', input.$modelValue);
                });
            });
        }

        function createIncidences(loan, balance) {
            $log.log(loan);
            $rootScope.loadingProgress = true;
            try {
                var paid = $filter('getPaidOfApplied')(loan.incidences, true);
                balance = $filter('roundNumber')(angular.isDefined(balance) ? balance : loan.data.amount - paid);
                var thisDate;
                if (loan.incidences) {
                    for (var i in loan.incidences) {
                        if (loan.incidences[i].status > 3 || loan.incidences[i].status === -4) {
                            thisDate = loan.incidences[i].date;
                        }
                    }
                    if (angular.isUndefined(thisDate)) {
                        thisDate = loan.data.date;
                    }
                } else {
                    thisDate = loan.data.date;
                }
                generatePosibleIncidences(loan.payroll, thisDate, balance, loan.data.periodAmount).then(function (newIncidences) {
                    $scope.thisIncidences = [];
                    $filter('loopEach')(loan.incidences, function (thisIncidence) {
                        if (thisIncidence.status >= 3 || thisIncidence.status === -4) {
                            $scope.thisIncidences.push(thisIncidence);
                        }
                    });
                    $scope.thisIncidences = $scope.thisIncidences.concat(newIncidences);
                    $scope.validIncidences = true;
                    $rootScope.loadingProgress = false;

                    $scope.$evalAsync(function () {
                        $timeout(function () {
                        }, 0, false);
                        $log.debug('incidences generated');
                    });
                }).catch(function (error) {
                    $scope.validIncidences = false;
                    $log.error('error en generate posible');
                    if (angular.isString(error)) {
                        errAlertS(error);
                    } else {
                        $log.error(error);
                        errAlertS('No se pudo dar de alta el préstamo');
                    }
                    $rootScope.loadingProgress = false;
                    $scope.$evalAsync(function () {
                        $timeout(function () {
                        }, 0, false);
                    });
                });
            } catch (error) {
                errAlertS(error);
                $rootScope.loadingProgress = false;
                $scope.$evalAsync(function () {
                    $timeout(function () {
                    }, 0, false);
                });
            }

        }

        function generatePosibleIncidences(payroll, thisDate, total, periodAmount) {
            return new Promise(function (resolve, reject) {
                var incidencesNeeded = Math.ceil(total / periodAmount);
                var options = {
                    date: thisDate
                };
                $log.debug(incidencesNeeded, 'incidencesNeeded');
                CalendarF.getActiveOperations(payroll, incidencesNeeded, options).then(function (activeOperations) {
                    var posibleIncidences = [];
                    var status = $filter('getFromObject')(activeOperations[0], 'employees.' + $scope.employeeSelected.$id + '.status');
                    if (total > 0 && status >= 3) {
                        var nextOperation = activeOperations[0].end + AppF.oneDay;
                        infoAlertS('El empleado se encuentra cerrado en este periodo, el préstamo se empezará a descontar el próximo periodo');
                        resolve(generatePosibleIncidences(payroll, nextOperation, total, periodAmount));
                    } else {
                        for (var i = 0; i < activeOperations.length; i++) {
                            var amountToDiscount = periodAmount;
                            if (total < periodAmount) {
                                amountToDiscount = total;
                            }
                            amountToDiscount = $filter('roundNumber')(amountToDiscount);
                            total -= amountToDiscount;
                            var thisIncidence = {
                                date: activeOperations[i].start,
                                status: 0,
                                period: activeOperations[i].period,
                                calendar: activeOperations[i].calendar,
                                value: amountToDiscount,
                                payroll: payroll
                            };
                            posibleIncidences.push(thisIncidence);
                        }
                        resolve(posibleIncidences);
                    }
                }).catch(function (error) {
                    reject(error);
                });
            });
        }

        function loadIncidencesTypes(payrollId) {
            var query = {
                project: angular.toJson({ name: 1, fid: 1 }),
                payroll: angular.toJson({ $in: ['global', payrollId] }),
                amortizationAvailable: 'true:parseBool'
            };
            query.center = AppF.center;
            $rootScope.D.api.get('concepts', query).then(function (resp) {
                $scope.allIncidencesTypes = resp.data.map(function (item) {
                    item.$id = item.fid;
                    return item;
                });
                $rootScope.$evalAsync();
            }).catch(errAlertS);
        }

        function saveLoan(loan) {
            $rootScope.loadingProgress = true;
            var savePromise = [];
            loan.center = AppF.center;
            if (!loan.$id) {
                $log.debug('About to add new loan');
                savePromise.push($scope.add(loan, 1));
            } else {
                $log.debug('Updating loan');
            }
            Promise.all(savePromise).then(function (resp) {
                if (!loan.$id) {
                    var lid = resp[0].key;
                    loan.$id = lid;
                }
                var loanId = loan.$id;
                var loanAndIncidences = getIncidencesUpdates(loan, loanId, $scope.thisIncidences);
                $log.log(loanAndIncidences, 'loan and incidences updates');
                $scope.F.root.child('incidences').update(loanAndIncidences.updates).then(function () {
                    return $scope.save(loanAndIncidences.loan, 1);
                }).then(function () {
                    successAlertS('Se guardo el préstamo y actualizaron las incidencias');
                    $rootScope.loadingProgress = false;
                    if ($scope.F.settings.goToListOnCreate) { $scope.R.goToList(); }
                }).catch(function (error) {
                    if (angular.isString(error)) {
                        errAlertS(error);
                        $rootScope.loadingProgress = false;
                    } else {
                        errAlertS('No se pudo guardar el préstamo');
                        $log.error(error);
                        $rootScope.loadingProgress = false;
                    }
                });
            }).catch(function (error) {
                $log.error(error);
                $rootScope.loadingProgress = false;
                errAlertS('Error creando el crédito inténtelo nuevamente');
            });
        }

        function cancelIncidence(incidence) {
            var title = 'Desea cancelar esta incidencia?';
            var msg = 'Al cancelar la incidencia el monto de la incidencia ya no se cobrara';
            $mdDialog.show($mdDialog.confirm(confirmConfig)
                .title(title)
                .content(msg)
                .ariaLabel('Cancel incidence')
                .ok('Aceptar')
                .cancel('Cancelar'))
                .then(function () {
                    $log.debug('Cancel incidence');
                    incidence.status = -4;
                }, function () {
                    $log.debug('Denied cancel incidence');
                });
        }

        function validChange(valid) {
            if (valid) {
                createIncidences($scope.loan);
            } else {
                createIncidences($scope.loan, 0);
            }
        }

        function initValidWatcher() {

            watchersObj.loanIncidences = $scope.$watch('loan.incidences', function (newVal) {
                if (newVal) {
                    $scope.thisIncidences = $filter('getArrayFromObject')(JSON.parse(JSON.stringify(newVal)), false, true);
                }
            }, true);

            function confirmLoanUpdate() {
                return new Promise(function (resolve) {
                    var confirm = $mdDialog.confirm().
                        title('Actualizar información del préstamo')
                        .textContent('Se detecto que el empleado se encuentra en una nomina diferente a la en la que se encuentra el préstamo, desea actualizar la información?')
                        .ariaLabel('Está Seguro(a)?')
                        .ok('Actualizar')
                        .cancel('No actualizar');
                    $mdDialog.show(confirm).then(function () {
                        resolve(true);
                    }).catch(function () {
                        resolve(false);
                    });
                });
            }

            watchersObj.employee = $scope.$watch('loan.employee', function (employeeId, oldEmployeeId) {
                $log.debug('loan employee', employeeId, oldEmployeeId);
                if (employeeId) {
                    var thisEmployee;
                    var firedIncidences;
                    //$log.debug('Setting current SD & SBC in loan', employeeId);
                    $scope.employee = $firebaseObject($scope.F.root.child('catalogs/employees/collection').child(employeeId));
                    $scope.employee.$loaded().then(function (employee) {
                        thisEmployee = employee;
                        $scope.searchQuery = employee.data.name;
                        $scope.employeeSelected = employee;
                        $scope.loan.data.name = thisEmployee.data.name;
                        var promises = [];
                        if (!AppF.addMode && $scope.loan.payroll !== thisEmployee.payroll) {
                            promises.push(confirmLoanUpdate());
                            firedIncidences = true;
                        }
                        return Promise.all(promises);
                    }).then(function (resp) {
                        if (resp.length === 0 || resp[0]) {
                            if (angular.isDefined($scope.payroll) && angular.isObject($scope.loan.incidences)) {
                                $filter('loopEach')($scope.loan.incidences, function (incidence, key) {
                                    if (angular.isUndefined(incidence.payroll)) {
                                        $scope.loan.incidences[key].payroll = $scope.loan.payroll;
                                    }
                                });
                            }
                            $scope.loan.payroll = thisEmployee.payroll;
                            $scope.loan.cc = thisEmployee.cc;
                            $scope.loan.rp = thisEmployee.rp;
                            $scope.loan.data.nss = thisEmployee.data.nss;
                            $scope.loan.data.sd = (thisEmployee.data.salary.sd) ? thisEmployee.data.salary.sd : 0;
                            $scope.loan.data.sbc = (thisEmployee.data.salary.sbc) ? thisEmployee.data.salary.sbc : 0;
                            $scope.loan.data.sdr = (thisEmployee.data.salary.sdr) ? thisEmployee.data.salary.sdr : 0;
                        }
                        $scope.payroll = $firebaseObject($scope.F.root.child('catalogs/payrolls/collection').child($scope.loan.payroll));
                        loadIncidencesTypes($scope.loan.payroll);
                        $log.debug('Loan in addMode');
                        CalendarF.getAvailablePeriodStartDate($scope.loan.payroll).then(function (minDate) {
                            $scope.minDate = minDate;
                            $scope.allowEditDate = true;
                            if (firedIncidences) {
                                createIncidences($scope.loan);
                            }
                        }).catch(function (error) {
                            if (angular.isString(error)) {
                                errAlertS(error);
                            } else {
                                errAlertS('No se pudo obtener una fecha disponible');
                                $log.error(error);
                            }
                            $scope.allowEditDate = false;
                        });
                    });
                }
            });

            if ($scope.F.addMode) {
                watchersObj.createIncidences = $scope.$watchGroup(['loan.data.date', 'loan.data.amount', 'loan.data.periodAmount', 'loan.data.incidenceType', 'loan.payroll'], function () {
                    if ($scope.loan && $scope.loan.data && $scope.loan.data.date && $scope.loan.data.amount && $scope.loan.data.incidenceType && $scope.loan.data.periodAmount && $scope.loan.payroll) {
                        createIncidences($scope.loan);
                    }
                });
            }
        }

        $scope.editDate = editDate;
        $scope.saveLoan = saveLoan;
        $scope.cancelIncidence = cancelIncidence;
        $scope.editComment = editComment;
        $scope.validChange = validChange;

        $filter('startAfterInit')($scope, watchersObj, initFlag, init);
    }

}());
(function () {
    'use strict';

    angular
        .module('app.employees')
        .controller('kardexPhotoController', kardexPhotoController);

    function kardexPhotoController($mdDialog, $scope, $state, AppF, $log, $rootScope, errAlertS, $http, $window, photoEmployee, startAfterInitFilter) {
        var vm = this;
        vm.files = [];
        $scope.ok = function () {
            var employeeId = $state.params.employeeId;
            var promises = [];
            $rootScope.loadingProgress = true;
            angular.forEach($scope.files, function (fileWrapper) {
                var file = fileWrapper.lfFile;
                var fileNameArray = file.name.split('.');
                var newFileName = employeeId + '.' + fileNameArray[fileNameArray.length - 1];
                var storageRef = firebase.storage().ref('/photoProfile').child(newFileName);
                var uploadTask = storageRef.put(file);
                promises.push(uploadTask.then(function (snapshot) {
                    return snapshot.ref.getDownloadURL();
                }));
            });
            Promise.all(promises).then(function (downloadURLs) {
                return AppF.root.child('catalogs/employees/collection/' + employeeId + '/data').update({ photoEmployee: downloadURLs[0] })
            }).then(function () {
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync()
                $mdDialog.hide();
            }).catch(function (error) {
                errAlertS(error);
            });
        };
        $scope.cancel = function () {
            // Lógica para cancelar la carga de archivos
            $mdDialog.cancel();
        };

        $scope.downlandImg = function () {
            $scope.photoEmployees = photoEmployee
            var img = $scope.photoEmployees;
            $http.get(img, { responseType: 'arraybuffer' })
                .then(function (response) {
                    var blob = new Blob([response.data], { type: 'octet/stream' });
                    var link = document.createElement('a');
                    link.href = $window.URL.createObjectURL(blob);
                    link.download = 'imagen-descargada.jpg';
                    link.click();
                    $window.URL.revokeObjectURL(link.href);
                })
                .catch(function (error) {
                    $log.error('Error al descargar la imagen', error);
                });
        };
        var watchers = {}
        var initiated = false
        function init() {
            $scope.photoEmployees = photoEmployee
        }
        startAfterInitFilter($scope, watchers, initiated, init)
    }

})();

(function () {
    'use strict';
    angular.module('app.employees')
        .controller('KardexEmployeesController', KardexEmployeesController);
    function KardexEmployeesController($scope, startAfterInitFilter, $log, $filter, $state, $http, errAlertS, $localStorage, AppF, $rootScope) {
        var watchers = {};
        var initiated = false;
        $scope.view = angular.isDefined($localStorage.kardexEmployeeView) ? $localStorage.kardexEmployeeView : 'cards';
        $scope.templates = {
            cards: 'app/main/employees/views/kardexEmployees/views/cards.html',
            table: 'app/main/employees/views/kardexEmployees/views/table.html'
        };
        if ((!angular.isNumber(AppF.paginateV2)) || (AppF.paginateV2 % 12) > 0) {
            AppF.paginateV2 = 12;
        }
        $scope.paginations = [12, 24, 48, 96, 192, 384, 768];
        $scope.payrolls = [];

        $scope.setView = function (view) {
            $scope.view = view;
            $localStorage.kardexEmployeeView = view;
        }

        $scope.deleteFilters = function () {
            $scope.F.search[$scope.F.active.menuObjName] = '';
            $scope.F.orderMongo = ($scope.R.listOrder[$scope.F.active.menuName]) ? $scope.R.listOrder[$scope.F.active.menuName] : '$id';
            if ($scope.F && $scope.F.filters && angular.isDefined($scope.F.filters.kardexEmployees)) {
                $scope.F.filters.kardexEmployees = {};
            }
            $rootScope.$evalAsync()
            $scope.getThem();
        };

        function init() {
            if (AppF.permissionToAccessAllPayrolls) {
                $scope.payrolls = $scope.L.allPayrolls;
            } else {
                $scope.payrolls = $scope.L.payrolls
            }
        }
        startAfterInitFilter($scope, watchers, initiated, init);
    }
})();

(function () {
  'use strict';

  angular
    .module("app.employees")
    .controller("KardexEmployeeController", KardexEmployeeController);

  function KardexEmployeeController($scope, startAfterInitFilter, $log, $document, $filter, $state, $http, AppF, errAlertS, $timeout, $rootScope, $mdDialog, $window) {
    var watchers = {};
    var initiated = false;
    var firstEmployeeLoaded = false;
    $scope.employeeSelected = { data: { name: 'sin seleccionar' } };
    function init() {
      $scope.incidencias = []
      var promises = [$scope.dataNeededPromise, $scope.statesObjsPromise];
      Promise.all(promises).then(function () {
        $scope.employeeSelected = $scope.employee;
        setAvatarEmployee();
        $scope.prestamos1();
        $scope.cargarIncidencias();
        $scope.descargarExpediente();
        $scope.fieldExtra();
        $scope.yearsInCompany();
        return getExternalDataEmployee();
      }).then(function () {
        firstEmployeeLoaded = true;
        $timeout(function () { $scope.$evalAsync(); }, 0)
      }).catch(errAlertS);
    }

    function setAvatarEmployee() {
      $scope.avatarImage = $filter('getDefaultAvatarEmployee')($scope.employee);
    }
    $scope.templates = [
      { name: 'infomation.html', url: 'app/main/employees/views/kardexEmployees/contentTabs/infomation.html' },
      { name: 'contratos.html', url: 'app/main/employees/views/kardexEmployees/contentTabs/contratos.html' },
      { name: 'expedientes.html', url: 'app/main/employees/views/kardexEmployees/contentTabs/expedientes.html' },
      { name: 'incidense1.html', url: 'app/main/employees/views/kardexEmployees/contentTabs/incidense1.html' },
      { name: 'movimiento.html', url: 'app/main/employees/views/kardexEmployees/contentTabs/movimiento.html' },
      { name: 'vacaciones.html', url: 'app/main/employees/views/kardexEmployees/contentTabs/vacaciones.html' },
      { name: 'prestamos.html', url: 'app/main/employees/views/kardexEmployees/contentTabs/prestamos.html' },
      { name: 'infonavit.html', url: 'app/main/employees/views/kardexEmployees/contentTabs/infonavit.html' }

    ];
    $scope.informacion = $scope.templates[0];
    $scope.contratos = $scope.templates[1];
    $scope.expedientes = $scope.templates[2];
    $scope.incidencias111 = $scope.templates[3];
    $scope.movimiento = $scope.templates[4];
    $scope.vacaciones = $scope.templates[5];
    $scope.creditos = $scope.templates[6];
    $scope.infonavit = $scope.templates[7];


    $scope.template2 = function () {
      $scope.template = $scope.templates[1];
    };

    function getExternalDataEmployee() {
      return new Promise(function (resolve, reject) {
        var promesas = [
          //promesa numero 0
          $scope.F.root.child("catalogs/payrolls/collection/" + $scope.employee.payroll).once("value"),
          //promesa numero 1
          $scope.F.root.child("catalogs/positions/collection/" + $scope.employee.data.position).once("value")
        ];
        //promesa numero 2
        var zipCodeId = $filter('getFromObject')($scope.employee, 'data.info.residence.address.zipCodeId');
        if (angular.isDefined(zipCodeId)) {
          promesas.push($scope.D.api.get("zipCodes/" + $scope.employee.data.info.residence.address.zipCodeId));
        }
        Promise.all(promesas).then(function (resp) {
          resultadoPromesa(resp);
          resolve(true);
        }).catch(reject);
      })
    }
    function resultadoPromesa(resp) {
      try {
        var nominaData = resp[0].val();
        $scope.nomina = nominaData.data.name;
        var posicion = resp[1].val();
        $scope.position = posicion.data.name;
        if (resp.length > 1) {
          $scope.docilioData = resp[2].data;
          $scope.codigoPostal = resp[2].data.town;
        }
      } catch (error) {
        $log.log(error)
      }
    }
    var tabsActions = {
      vacaciones: 'cargarVacaciones',
      incidencias: 'cargarIncidencias',
      expedientes: 'descargarExpediente',
      creditos: 'cargarCreditos',
      movimientos: 'cargarMovimientos'
    }
    $scope.loadEmployee = function (employee) {
      if (firstEmployeeLoaded) {
        if (angular.isObject(employee) && employee !== null) {
          var promises = [
            $scope.F.root.child("catalogs/employees/collection/" + employee.$id).once("value")
          ]
          Promise.all(promises).then(function (resp) {
            if (!resp[0].exists()) {
              throw "No se encontró la información del empleado seleccionado"
            }
            var dataEmployee = resp[0].val();
            dataEmployee.$id = employee.fid;
            $scope.employee = dataEmployee;
            $state.go($scope.R.states.fb[$scope.F.active.menuName].read, { employeeId: dataEmployee.$id, movementId: dataEmployee.movement.uid }, { notify: false });
            setAvatarEmployee();
            return getExternalDataEmployee();
          }).then(function () {
            if (tabsActions.hasOwnProperty($scope.tabName)) {
              var functionName = tabsActions[$scope.tabName];
              $scope[functionName]();
            }
          }).catch(errAlertS);
        }
      }
    }
    $scope.setTabName = function (tabName) {
      $scope.currentTab = tabName;
    }
    $scope.selectedIndex = 0;

    $scope.descargarDocumento = function (url) {
      $http.get(url, { responseType: 'arraybuffer' })
        .then(function (response) {
          var blob = new Blob([response.data], { type: 'application/octet-stream' });
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = 'documento descargado.pdf';
          link.click();
        })
        .catch(function (error) {
          $log.error('Error al descargar el documento', error);
        });
    };

    $scope.descargarExpediente = function () {
      $scope.F.root.child("catalogs/employeeFiles/collection/" + $scope.employee.$id).once("value").then(function (response) {
        var queryM = { center: $scope.F.center, type: angular.toJson({ $in: ['generals', 'generalsRequired'] }), project: angular.toJson({ key: 1, name: 1 }) };
        var promises = [$rootScope.D.api.get('documentTypes', queryM)];
        Promise.all(promises).then(function (data) {
          $scope.dataFile = data[0].data;
          var exp = response.val();
          if (exp !== null) {
            $scope.files = Object.keys(exp).map(function (key) {
              var expediente = exp[key];
              var matchingFile = $scope.dataFile.find(function (file) {
                return file.key === expediente.documentType;
              });
              if (matchingFile) {
                expediente.documentName = matchingFile.name;
              }
              return expediente;
            });
          }
        });
      }).catch(function (error) {
        $log.error('No se pudo obtener los datos', error);
      });
    };

    $scope.cargarMovimientos = function () {
      $scope.isLoading = true;
      var payroll = $scope.F.permissionToAccessAllPayrolls ? undefined : $filter("getArrayOfIds")($scope.L.payrolls);
      $scope.D.api.get("movements", {
        payroll: payroll, employee: $scope.employee.$id, project: angular.toJson({ type: "$data.type", status: 1, sd: "$data.sd", sbc: "$data.sbc", date: "$data.date", payroll: 1 })
      }).then(function (response) {
        $scope.movimientos = response.data;
        $rootScope.$evalAsync();
        $scope.isLoading = false;
      }).catch(function (error) {
        $scope.isLoading = false;
        $log.log('error al cargar los movimientos', error)
      })
    }

    $scope.cargarIncidencias = function () {
      var promises = [];
      $scope.isLoadingIncidences = true;
      var query = { isIncapacity: 'true:parseBool', center: AppF.center, project: angular.toJson({ fid: 1, name: 1 }) }
      promises.push($scope.D.api.get('concepts', query))
      Promise.all(promises).then(function (respData) {
        var data = respData[0].data.map(function (item) {
          return item.fid
        })
        var initDate = moment().valueOf();
        var startDate = moment().subtract(30, 'days').valueOf();
        query = {
          employee: $scope.employee.$id,
          incidenceType: angular.toJson({ $in: data }),
          date: angular.toJson({ $gte: startDate, $lte: initDate })
        };
        $scope.D.api.get('incidences', query).then(function (resp) {
          $scope.incapacityIncidence = resp.data;
          $scope.isLoadingIncidences = false;
          $rootScope.$evalAsync();
        });

      })
    };

    $scope.cargarVacaciones = function () {
      $scope.D.models.action("salaries", "getVacationsEvents/" + $scope.employee.$id, {}).then(function (response) {
        $scope.vacations = response.data;
      }).catch(function (error) {
        $log.error('No se obtuvo la información de vacaciones', error)
      })
    }

    $scope.photoEmployee = function (ev) {
      $mdDialog.show({
        templateUrl: 'app/main/employees/views/kardexEmployees/kardexPhoto.html',
        controller: 'kardexPhotoController',
        controllerAs: 'phtoCrtl',
        locals: { photoEmployee: $scope.employee.data.photoEmployee },
        parent: angular.element($document.body),
        targetEvent: ev
      })
    }

    $scope.contratos1 = function () {
      $scope.isLoadingContracts = true;
      $scope.D.api.get('documents', { employee: $scope.employee.$id }).then(function (resp) {
        var contractEmployee = $scope.employee.$id;
        var dataContract = resp.data;
        for (var i = 0; i < dataContract.length; i++) {
          var typesContract = dataContract[i];
          if (typesContract.employee === contractEmployee) {
            $scope.isLoadingContracts = false
            $rootScope.$evalAsync();
            $scope.infoContract = resp.data;
            $scope.idDocument = typesContract._id;
          } else {
            $log.log('No tiene contratos')
          }
        }
      });
    }

    $scope.yearsInCompany = function () {
      var initDate = moment();
      var enroleDate = angular.isDefined($scope.employee.data.seniorityDate) ? ($scope.employee.data.seniorityDate) : ($scope.employee.data.enroleDate)
      var initEmployee = moment(enroleDate);
      var differenceInYears = initDate.diff(initEmployee, 'years', true);
      $scope.employeeYearsCompany = Math.round(differenceInYears * 100) / 100;
    }


    $scope.fieldExtra = function () {
      $filter('getExtraFields')($scope.employee.firm).then(function (extraFields) {
        var extraFieldsEmployee = [];
        for (var e = 0; e < extraFields.length; e++) {
          var thisExtraField = extraFields[e];
          if ($scope.employee.hasOwnProperty(thisExtraField.id)) {
            $log.log(thisExtraField)
            extraFieldsEmployee.push({ label: thisExtraField.label, value: $scope.employee[thisExtraField.id] })
          }
        }
        $scope.extraFields = extraFieldsEmployee;
      }).catch(function (error) {
        $log.log(error);
      });
    }


    $scope.prestamos1 = function () {
      $scope.F.root.child('/lists/loans/employee/' + $scope.employee.$id).orderByChild('valid').equalTo(true).once('value').then(function (response) {
        $scope.incidencesLoans = response.val();
        var loans = $scope.incidencesLoans;
        if (loans !== null) {
          $scope.incidencesLoansArray = Object.keys(loans).map(function (key) {
            loans[key].id = key;
            return loans[key];
          });

          Object.keys(loans).forEach(function (resp) {
            var idLoans = loans[resp].incidenceType;
            $scope.F.root.child('/catalogs/incidencesTypes/collection/' + idLoans).once('value').then(function (res) {
              var incidencesTypes = res.val();
              if (incidencesTypes !== null) {
                loans[resp].nameLoan = incidencesTypes.name;
                $scope.$apply();
              } else {
                $log.log('No tiene préstamos');
              }
            });
          });
        }
      });

      // crédito infonavit

      $scope.D.api.get("p/credits", { employee: $scope.employee.$id, sort: '-data.date', page: 1, size: 1 }).then(function (response) {
        $scope.infonavitCredits = response.data.data[0].data;
        $scope.validCredit = response.data.data[0].valid;
      }).catch(function (error) {
        $log.error('No cuenta com crédito', error);
      })
    };
    function getTemporalToken() {
      return new Promise(function (resolve, reject) {
        var temporalToken = $scope.F.root.child('catalogs/authTokens').push().key;
        var obj = {};
        obj[temporalToken] = {
          code: temporalToken,
          uid: $scope.F.profile.uid,
          type: 'temporal',
          from: 'kardexEmployeeAuthToken',
          restrictUrl: '/views/documents'
        };
        $scope.F.root.child('catalogs/authTokens').update(obj).then(function () {
          resolve(temporalToken);
        }).catch(reject);

      });
    }

    $scope.showDocument = function (documentId) {
      var openedWindows;
      $scope.D.models.action('documents', 'validateDocuments', { documentId: documentId }).then(function () {
        var promises = [];
        openedWindows = $window.open();
        Promise.all(promises)
      }).then(function () {
        return getTemporalToken();
      }).then(function (temporalToken) {
        var finalUrl = $window.__env.serviceWorkerUrl + 'views/documents?temporalToken=' + temporalToken + '&documentId=' + documentId + '&action=view';
        openedWindows.location = finalUrl;
      }).catch(function (err) {
        if (angular.isDefined(openedWindows)) {
          openedWindows.close();
        }
        errAlertS(err);
      });
    };
    $scope.downloadPhoto = function () {
      var img = $scope.employee.data.photoEmployee;
      $http.get(img, { responseType: 'arraybuffer' })
        .then(function (response) {
          var blob = new Blob([response.data], { type: 'octet/stream' });
          var link = $document.createElement('a');
          link.href = $window.URL.createObjectURL(blob);
          link.download = 'imagen-descargada.jpg';
          link.click();
          $window.URL.revokeObjectURL(link.href);
        })
        .catch(function (error) {
          $log.error('Error al descargar la imagen', error);
        });
    };
    $scope.printPage = function () {
      $window.print()
    }
    startAfterInitFilter($scope, watchers, initiated, init);
  }
})();

(function () {
    'use strict';
    angular
        .module('app.employees')
        .controller('importMovementImmsController', importMovementImmsController);

    function importMovementImmsController($mdDialog, ApiV3F, $scope, $q, $rootScope, errAlertS, DataF, AppF, ListsF, CalendarF, getEmployeesOfPeriodFilter, successAlertS, $log) {
        var vm = this;
        $scope.L = ListsF;
        $scope.F = AppF;
        $scope.C = CalendarF;
        vm.payrolls = [];
        vm.ccs = [];
        vm.getRp = function (payroll) {
            vm.rpData = [];
            AppF.root.child('catalogs/ccs/collection').orderByChild('payroll').equalTo(payroll).once('value').then(function (resp) {
                var data = resp.val() || {};
                var uniqueRpIds = [];
                var seen = {};
                angular.forEach(data, function (item) {
                    if (item.data && item.data.rp_id) {
                        var id = item.data.rp_id;
                        if (!seen[id]) {
                            seen[id] = true;
                            uniqueRpIds.push(id);
                        }
                    }
                });
                var promises = uniqueRpIds.map(function (id) {
                    return AppF.root.child('catalogs/rps/collection/' + id).once('value');
                });
                return $q.all(promises);
            })
                .then(function (snapshots) {
                    var results = [];
                    angular.forEach(snapshots, function (snap) {
                        var val = snap.val();
                        val.$id = snap.key;
                        if (val && val.data && val.data.name !== '00000000000') {
                            results.push(val);
                        }
                    });
                    vm.rpData = results;
                })
                .catch(function (error) {
                    $log.error("Error obteniendo RPs:", error);
                });
        };

        vm.getCCs = function () {
            var ccsList = [];
            var ccsQuery = $scope.F.root.child('catalogs/ccs/collection').orderByChild('data/rp_id').equalTo(vm.rp).once("value");
            ccsQuery.then(function (snapshot) {
                snapshot.forEach(function (childSnapshot) {
                    var item = childSnapshot.val();
                    if (item.payroll === vm.payroll) {
                        item.ccId = childSnapshot.key;
                        ccsList.push(item);
                    }
                    vm.ccs = ccsList;
                })
            }).catch(function (error) {
                $log.error("Error al obtener CCs:", error);
            });
        }




        // --- Inicialización ---
        vm.allEmployees = [];   // Todos los que trae la API
        vm.addedEmployees = []; // Los seleccionados para la tabla
        vm.searchText = "";
        vm.selectedEmployee = null;

        // --- 1. Obtener Empleados y Normalizar Datos ---
        vm.getEmployees = function (payroll, rp) {
            vm.allEmployees = []; // Limpiamos lista anterior
            DataF.api.get('employees', { payroll: payroll, rp: rp, project: angular.toJson({ 'fid': 1, 'data.salary.sd': 1, 'data.info.names': 1, 'cc': 1, 'data.workDay': 1, 'center': 1, 'firm': 1, 'data.position': 1, 'data.info.maternalSurname': 1, 'data.info.paternalSurname': 1, 'data.health.umf': 1, 'data.nss': 1, 'rp': 1, 'data.name': 1, 'data.rfc': 1, 'status': 1 }) }).then(function (resp) {

                if (resp.data && angular.isArray(resp.data)) {
                    vm.allEmployees = resp.data
                        .filter(function (emp) {
                            return (emp.data && emp.data.nss && emp.data.nss !== "");
                        })
                        .map(function (emp) {
                            var name = emp.data.name || 'Sin Nombre';
                            var nss = emp.data.nss;
                            emp.center = emp.center || 'Sin Centro';
                            emp.position = emp.data.position || 'Sin Puesto';
                            emp.sd = emp.data.salary.sd
                            emp.firm = emp.firm;
                            emp.status = emp.status;
                            emp.displayName = name;
                            emp.maternalSurname = emp.data.info.maternalSurname;
                            emp.paternalSurname = emp.data.info.paternalSurname;
                            emp.names = emp.data.info.names;
                            emp.cc = emp.cc;
                            emp.status = emp.status;
                            emp.displayNss = nss;
                            emp.workDay = emp.data.workDay;
                            emp.fid = emp.fid;
                            emp._searchQuery = name.toLowerCase() + ' ' + nss;
                            return emp;
                        });

                }
            }).catch(function (err) {
                $log.error("Error al obtener empleados", err);
            });
        };

        // --- 2. Filtro del Buscador (Optimizado) ---
        vm.querySearch = function (query) {
            var results = query ? vm.allEmployees.filter(createFilterFor(query)) : [];
            return results;
        };

        function createFilterFor(query) {
            var lowercaseQuery = query.toLowerCase();
            return function filterFn(item) {
                // Buscamos sobre la propiedad preparada anteriormente
                return (item._searchQuery.indexOf(lowercaseQuery) !== -1);
            };
        }

        // --- 3. Agregar un empleado (Al seleccionar en el autocomplete) ---
        vm.selectedItemChange = function (item) {
            if (item) {
                // Evitar duplicados por ID (_id)
                var exists = vm.addedEmployees.some(function (added) {
                    return added._id === item._id;
                });

                if (!exists) {
                    vm.addedEmployees.push(item);
                }

                // Resetear buscador
                vm.searchText = "";
                vm.selectedEmployee = null;
            }
        };

        // --- 4. Agregar Todos ---
        vm.addAllEmployees = function () {
            vm.addedEmployees = []
            if (!vm.allEmployees.length) {
                return;
            }
            angular.forEach(vm.allEmployees, function (emp) {
                var exists = vm.addedEmployees.some(function (added) {
                    return added._id === emp._id;

                });
                if (!exists && emp.status === 4) {
                    vm.addedEmployees.push(emp);
                }
            });
        };

        vm.selectedCount = 0;
        vm.updateSelectedCount = function () {
            var count = 0;

            // Recorremos los resultados
            angular.forEach(vm.processResults, function (item) {
                // OPCIÓN A: Si la tabla interna tiene SOLO UN registro (tu código actual)
                if (item.isSelected) {
                    count++;
                }
            });
            vm.selectedCount = count;
        };
        vm.removeEmployee = function (itemToRemove) {
            var index = vm.addedEmployees.indexOf(itemToRemove);
            if (index >= 0) {
                vm.addedEmployees.splice(index, 1);
            }
        };
        vm.processResults = [];
        vm.postData = function () {
            $rootScope.loadingProgress = true;
            var nssArray = vm.addedEmployees.map(function (emp) {
                return emp.data.nss;
            });

            var data = vm.rpData.filter(function (resp) {
                if (resp.$id === vm.rp) {
                    return resp;
                }
            })
            $log.log("RP seleccionado:", data);
            var obj = {
                rp: data[0].data.name,
                nss: nssArray,
                "user": "tdsystem",
                "password": "TUS75jb+2c,."
            };
            $log.log("NSS a enviar:", obj);
            ApiV3F.post('employees/employeesMovementImms', obj).then(function (resp) {
                var dataResp = resp.data.data;
                var listaFinal = [];
                if (dataResp) {
                    for (var i = 0; i < vm.addedEmployees.length; i++) {
                        var empData = vm.addedEmployees[i].data;
                        var info = vm.addedEmployees[i].data.info;
                        var empNss = empData.nss;

                        if (dataResp[empNss]) {
                            var movimientos = dataResp[empNss];
                            movimientos.sort(function (a, b) {
                                return new Date(b.fecha) - new Date(a.fecha);
                            });
                            var encontrados = {
                                2: false,
                                7: false,
                                8: false
                            };
                            movimientos.forEach(function (mov) {
                                var tipo = parseInt(mov.movto);
                                if ((tipo === 2 || tipo === 7 || tipo === 8) && !encontrados[tipo]) {
                                    mov.isSelected = true;
                                    encontrados[tipo] = true;
                                } else {
                                    mov.isSelected = false;
                                }
                            });
                            listaFinal.push({
                                sd: vm.addedEmployees[i].data.salary.sd,
                                fid: vm.addedEmployees[i].fid,
                                center: vm.addedEmployees[i].center,
                                names: info.names,
                                paternalSurname: info.paternalSurname,
                                maternalSurname: info.maternalSurname,
                                firm: vm.addedEmployees[i].firm,
                                cc: vm.addedEmployees[i].cc,
                                status: vm.addedEmployees[i].status,
                                workDay: vm.addedEmployees[i].workDay,
                                position: empData.position,
                                name: empData.name,
                                nss: empNss,
                                historial: movimientos,
                                ultimoStatus: movimientos[0].movto,
                                expanded: false
                            });
                        }
                    }
                }

                vm.processResults = listaFinal;
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
            }).catch(function (err) {
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
                errAlertS("Error al obtener movimientos desde la API.");
                $log.error("Error en postData", err);
            });
        };

        vm.getStatusClass = function (movto) {
            if (movto == 8) return 'status-success';
            if (movto == 2) return 'status-disabled';
            if (movto == 7) return 'status-warn';
            return 'status-warning';
        };

        vm.getMovtoLabel = function (movto) {
            switch (parseInt(movto)) {
                case 8: return "Reingreso";
                case 7: return "M. Salario";
                case 2: return "Baja";
                default: return "Movto " + movto;
            }
        };

        vm.prepareStep3 = function () {
            $rootScope.loadingProgress = true;
            vm.employeesToEdit = [];
            var promesasGlobales = [];

            angular.forEach(vm.processResults, function (empleadoOriginal) {
                var movimientosSeleccionados = empleadoOriginal.historial.filter(function (mov) {
                    return mov.isSelected === true;
                });

                if (movimientosSeleccionados.length > 0) {
                    var promesasDeValidacion = [];

                    angular.forEach(movimientosSeleccionados, function (mov) {
                        if (mov.fecha && angular.isString(mov.fecha)) {
                            mov.fechaObj = moment(mov.fecha).valueOf();
                        }
                        if (!mov.sd) {
                            mov.sd = parseFloat(empleadoOriginal.sd);
                        }
                        var promesaCheck = checkDuplicadoEnApi(empleadoOriginal.nss, mov.movto, mov.fechaObj, empleadoOriginal.names)
                            .then(function (existe) {
                                mov.isDuplicated = !!existe;
                                return mov;
                            });

                        promesasDeValidacion.push(promesaCheck);
                    });

                    var positionId = empleadoOriginal.position || 'sin_id';
                    var promesaFirebase = $q.when(
                        AppF.root.child('catalogs/positions/collection/' + positionId + '/data/name')
                            .once('value')
                    );
                    $log.log(positionId)

                    var promesaEmpleadoCompleto = $q.all([promesaFirebase, $q.all(promesasDeValidacion)])
                        .then(function (resultados) {
                            var snapshotPosition = resultados[0];
                            var positionName = snapshotPosition.val() || 'Sin Puesto';
                            return {
                                sd: empleadoOriginal.sd,
                                fid: empleadoOriginal.fid,
                                workDay: empleadoOriginal.workDay,
                                paternalSurname: empleadoOriginal.paternalSurname,
                                maternalSurname: empleadoOriginal.maternalSurname,
                                names: empleadoOriginal.names,
                                center: empleadoOriginal.center,
                                firm: empleadoOriginal.firm,
                                cc: empleadoOriginal.cc,
                                status: empleadoOriginal.status,
                                position: positionName,
                                positionId: positionId,
                                name: empleadoOriginal.name,
                                nss: empleadoOriginal.nss,
                                ultimoStatus: empleadoOriginal.ultimoStatus,
                                movimientos: movimientosSeleccionados,
                                expanded: true
                            };
                        });

                    promesasGlobales.push(promesaEmpleadoCompleto);
                }
            });

            $q.all(promesasGlobales).then(function (listaFinal) {
                vm.employeesToEdit = listaFinal;
                vm.finalArray();
                vm.areAllMovementsDuplicated();
                $rootScope.loadingProgress = false;
            }).catch(function (error) {
                $log.error("Error cargando step 3:", error);
                $rootScope.loadingProgress = false;
            });

        };




        vm.finalArray = function () {
            vm.employeesWithDuplicates = [];
            vm.employeesClean = [];
            angular.forEach(vm.employeesToEdit, function (emp) {
                var movimientosDuplicados = [];
                var movimientosLimpios = [];
                angular.forEach(emp.movimientos, function (mov) {
                    if (mov.movto === 2) {
                        vm.bajaT = true;
                    }
                    if (mov.isDuplicated) {
                        movimientosDuplicados.push(mov);
                    } else {
                        movimientosLimpios.push(mov);
                    }
                });

                if (movimientosDuplicados.length > 0) {
                    vm.employeesWithDuplicates.push(
                        angular.extend({}, emp, {
                            movimientos: movimientosDuplicados
                        })
                    );
                }

                if (movimientosLimpios.length > 0) {
                    vm.employeesClean.push(
                        angular.extend({}, emp, {
                            movimientos: movimientosLimpios
                        })
                    );
                }
            });
        };

        function checkDuplicadoEnApi(nss, typeM, dateM) {
            var start = moment(dateM).startOf('day').valueOf();
            var end = moment(dateM).endOf('day').valueOf();
            return DataF.api.get('movements', { 'info.nss': nss, 'data.type': typeM + ':parseNumber', 'data.date': JSON.stringify({ $gte: start, $lte: end }) }).then(function (resp) {
                if (resp.data && resp.data.length > 0) {
                    return true;
                } else {
                    return false;
                }
            }, function (err) {
                $log.log("Error verificando duplicado en API:", err);
                return false;
            });
        }

        vm.removeMovementFromEdit = function (empleado, index) {
            empleado.movimientos.splice(index, 1);
            if (empleado.movimientos.length === 0) {
                var empIndex = vm.employeesToEdit.indexOf(empleado);
                vm.employeesToEdit.splice(empIndex, 1);
            }
        };

        vm.guardarSeleccionados = function () {
            $rootScope.loadingProgress = true;
            var updates = {};
            var count = 0;
            $log.log(vm.employeesToEdit[0].movimientos)
            angular.forEach(vm.employeesToEdit, function (emp) {
                angular.forEach(emp.movimientos, function (mov) {
                    if (mov.isDuplicated) {
                        return;
                    }
                    var fechaObj = moment(mov.fechaObj).valueOf();
                    var fechaRec = moment(mov.fecha_hora_recepcion).valueOf();
                    mov.nss = emp.nss;
                    $log.log('movimiento a guardar', mov.sd ? mov.sd : undefined)
                    var dataPosition = emp.positionId;
                    var obj = {
                        center: emp.center,
                        employee: emp.fid,
                        rp: vm.rp || null,
                        payroll: vm.payroll || null,
                        status: 4,
                        firm: emp.firm || null,
                        cc: emp.cc || null,
                        data: {
                            date: fechaObj,
                            sdr: mov.sd ? parseFloat(mov.sd) : 0,
                            sd: mov.sd ? parseFloat(mov.sd) : 0,
                            sbc: parseFloat(mov.sbc),
                            salaryType: mov.tipo_sal,
                            type: mov.movto,
                            workDay: emp.workDay,
                            ext: mov.ext || null,
                            dismissType: mov.c_baja || null,
                            workerType: mov.tipo_trab,
                            paySalaryInPayrol: mov.movto === 2 ? true : null,
                            rehirable: mov.movto === 2 ? true : null,
                            position: dataPosition || '',
                            batch: String(mov.lote),
                            receivedDate: fechaRec,
                            comments: 'Movimientos importados manualmente desde el modal'
                        },
                        info: {
                            maternalSurname: emp.maternalSurname || '',
                            paternalSurname: emp.paternalSurname || '',
                            names: emp.names || '',
                            name: emp.name,
                            umf: mov.umf || '000',
                            nss: emp.nss
                        },
                        archived: {
                            date: fechaRec,
                            atTime: fechaRec,
                            by: AppF.user.uid,
                            hasConfirmationData: true
                        },
                        received: {
                            batch: String(mov.lote),
                            date: fechaRec,
                            atTime: fechaRec,
                            by: AppF.user.uid
                        },
                        approved: {
                            atTime: fechaRec,
                            by: AppF.user.uid
                        },
                        created: DataF.getTimeObject()
                    };
                    var batchData = {
                        batch: mov.lote,
                        certificate: mov.serial_certificado,
                        digitalPrint: mov.huella_digital,
                        digitalStamp: mov.sello_digital,
                        folio: mov.numero_folio,
                        comments: 'Movimientos importados manualmente desde el modal'
                    }
                    $log.log('Se guardo el empleado bien :)');
                    var newKey = AppF.root.child('catalogs/movements/collection').push().key;
                    updates['catalogs/batchesRecords/collection/' + String(mov.lote)] = batchData
                    updates['catalogs/movements/collection/' + newKey] = obj;
                    updates['catalogs/employees/collection/' + emp.fid + '/movements/' + newKey] = {
                        d: fechaObj,
                        p: vm.payroll,
                        s: 4,
                        t: mov.movto
                    }
                    count++;
                });
            });
            if (count === 0) {
                $rootScope.loadingProgress = false;
                errAlertS("No hay movimientos nuevos para guardar (posibles duplicados omitidos).");
                return;
            }
            AppF.root.update(updates).then(function () {
                $scope.close();
                $rootScope.$applyAsync(function () {
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                    successAlertS(count + " Movimientos importados correctamente.");
                    vm.employeesToEdit = [];
                    vm.processResults = [];
                });

            }, function (error) {
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
                $log.error("Error al guardar:", error);
                if (error.message && error.message.includes("undefined")) {
                    errAlertS("Error de datos: Algún campo obligatorio está vacío (undefined).");
                } else {
                    errAlertS("Error al guardar en Firebase");
                }
            });
        };

        var currentStep = 1;
        var stepperChange = $rootScope.$on('stepCalled', function (event, step) {
            if (step === 2 && currentStep === 1) {
                vm.postData();
                vm.getCCs();
            }
            if (step === 3 & currentStep === 2) {
                vm.prepareStep3();
            }
            currentStep = step;
        });
        var onDestroy = $scope.$on('destroy', function () {
            onDestroy();
            stepperChange();
        })


        $scope.close = function () {
            $mdDialog.hide();
        }



        vm.areAllMovementsDuplicated = function () {
            if (vm.employeesClean && vm.employeesClean.length > 0) {
                return false;
            }
            if (!vm.employeesWithDuplicates || vm.employeesWithDuplicates.length === 0) {
                return false;
            }
            var hayAlgunValido = vm.employeesWithDuplicates.some(function (emp) {
                return emp.movimientos.some(function (mov) {
                    return mov.isDuplicated === false;
                });
            });
            return !hayAlgunValido;
        };

        function init() {
            if (AppF.permissionToAccessAllPayrolls) {
                vm.payrolls = $scope.L.allPayrolls;
            } else {
                vm.payrolls = $scope.L.payrolls
            }
        }



        init();
    }

})();

(function() {
    'use strict';

    angular
        .module('app.employees')
        .controller('GroupingsController', GroupingsController)

    /** @ngInject */
    function GroupingsController(
        $scope,
        $log,
        $mdBottomSheet
    ) {

        function listOfEmployees(list){
            return new Promise(function(resolve, reject){
                var promises = [];
                var keys = [];
                var description = [];
                var queries = [list];
                for(var i = 0; i < queries.length; i++){
                    var employees = queries[i].employees;
                    for(var key in employees){
                        promises.push($scope.F.root.child('/lists/employees/all/'+key).once('value'));
                        keys.push(key);
                    }
                    description.push(queries[i].description);
                }
                Promise.all(promises).then(function(resp){
                    var items = [];
                    for (var r = 0; r < resp.length; r++) {
                        var data = resp[r].val();
                        data.$id = keys[r];
                        data.description = description[r];
                        items.push(data);
                    }
                    resolve(items);
                }).catch(function(error){
                    $log.error(error);
                    reject(error);
                });
            })
        }
        function showEmployees(event, employees) {
            $mdBottomSheet.show({
                templateUrl: 'app/main/employees/views/groupings/dialogs/list-employees.html',
                locals: {
                    employees: employees
                },
                controller: function(scope){
                    listOfEmployees(employees).then(function(response){
                        scope.employees = response;
                    }).catch(function(error){
                        $log.error(error);
                    })
                },
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                escapeToClose: true,
                targetEvent: event
            }).then(function() {
            }).catch(function(error) {
                $log.debug("Incidences modal closed", error);
            })
        }
        $scope.showEmployees = showEmployees;
    } 
}());

(function() {
    'use strict';

    angular
        .module('app.employees')
        .controller('GroupingController', GroupingController)

    /** @ngInject */
    function GroupingController(
        $scope,
        $rootScope,
        $log,
        $q,
        getArrayOfIdsFilter,
        successAlertS,
        errAlertS,
        $timeout,
        clearObjectFilter
    ) {
        var initiated = false;
        function init() {
            if(angular.isUndefined($scope.grouping.employees)){
                $scope.grouping.employees = {};
            }else{
                loadEmployees($scope.grouping.employees);
            }
        }
        function listsEmployees(searchQuery, ccs){
            return $q(function(resolve, reject) {
                var flag = ($scope.F.permissionToAccessAllPayrolls)?true:false;
                var params = {"data.nss":{$exists:true}};
                if(!flag){
                  params.cc = {$in:getArrayOfIdsFilter(ccs)}
                }
                $scope.autocompleteListM(searchQuery, "employees",["data.name","data.nss"],params).then(function(employees){
                    resolve(employees);
                }, function(error){
                    reject(error);
                })
            })   
        } 
        $scope.employees = [];
        function addEmployees(id){
            $scope.grouping.employees[id] = true; 
            var filter  =  $scope.employees;
            var exists = false;
            if(filter.length > 0){
                var value =  filter.filter(function(value) {
                    return value.$id == id;
                });
                if(value.length > 0){
                    exists = true;
                }
            }
            if(!exists){
                $scope.F.root.child('/lists/employees/all/'+id).once('value').then(function(response){
                    var data = response.val();
                    data.$id = id;
                    $timeout(function(){
                        $scope.employees.unshift(data);
                    },600);   
                }).catch(function(error){
                    $log.error(error);
                });
            } 
        }
        function loadEmployees(list){
            var promises = [];
            var keys = [];
            var queries = [];
            var value = {}
            for(var key in list){
                queries.push({employeeId: key, value : list[key]});
            }
            var employees = queries.filter(function (x) {
                if (value[x.employeeId]) return false;
                value[x.employeeId] = true;
                return true;
            });
            for(var i = 0; i < employees.length; i++){
                promises.push($scope.F.root.child('/lists/employees/all/'+employees[i].employeeId).once('value'));
                keys.push(employees[i].employeeId);
            }
            Promise.all(promises).then(function(resp){
                for (var r = 0; r < resp.length; r++) {
                    var data = resp[r].val();
                    data.$id = keys[r];
                    $scope.employees.push(data);
                }
            }).catch(function(error){
                $log.error(error);
            });
        }
        function removeEmployee(id, index){
            delete $scope.grouping.employees[id];
            $scope.employees.splice(index, 1);
        }
        function validateField(value, field, id, form){
            var alreadyExist = true;
            if(typeof (value) !== "undefined"){
                $scope.F.root.child('/catalogs/groupings/collection').once('value').then(function(response){
                    var data = response.val();
                    for(var key in data){
                        if(angular.lowercase(value) === angular.lowercase(data[key][field])){
                            if(id !== key){
                                alreadyExist = false;
                            }
                        }
                    }
                    $timeout(function(){
                        if(!alreadyExist){
                            form[field].$setValidity('validationError', false);
                        }else{
                            form[field].$setValidity('validationError', true);
                        }
                    },500);
                }).catch(function(error){
                    $log.error(error);
                })
            }         
        }
        function addAndCreateGroupings(grouping){
            $rootScope.loadingProgress = true;
            var updatesGroupings = {};
            var groupingId = $scope.F.root.child('catalogs/groupings/collection').push().key;
            grouping.created = $scope.D.getTimeObject();
            updatesGroupings['groupings/collection/' + groupingId] = grouping;

            $scope.F.root.child('catalogs').update(updatesGroupings).then(function () {
                successAlertS('Se creó Solicitud de Agrupaciones con éxito');
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync(function(){
                    $log.debug('addAndCreateGroupings finished');
                });
                $scope.R.goToList();
            }).catch(function (error) {
                errAlertS(error)
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
            });
        }
        function saveAndSetGroupings(groupings){
            var updatesGroupings = {};
            var groupingId = groupings.$id;
            var grouping = clearObjectFilter(groupings);
            updatesGroupings['groupings/collection/' + groupingId] = grouping;

            $scope.F.root.child('catalogs').update(updatesGroupings).then(function () {
                successAlertS('Se guardo Solicitud de Agrupaciones con éxito');
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync(function(){
                    $log.debug('saveAndSetGroupings finished');
                });
                $scope.R.goToList();
            }).catch(function (error) {
                errAlertS(error)
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
            });
        }
        $scope.addEmployees = addEmployees;
        $scope.listsEmployees = listsEmployees;
        $scope.removeEmployee = removeEmployee;
        $scope.validateField = validateField;
        $scope.addAndCreateGroupings = addAndCreateGroupings;
        $scope.saveAndSetGroupings = saveAndSetGroupings;
        if ($scope.objectLoaded) {
            if (!initiated) { init(); }
        } else {
            $log.debug('setting watcher to mainObjLoaded');
            $scope.detailWatchers.mainObjLoaded = $rootScope.$on('mainObjectLoaded', function () {
                if (!initiated) {
                    init();
                }
                $scope.detailWatchers.mainObjLoaded();
                delete $scope.detailWatchers.mainObjLoaded;
            });
        }
    }

}());

(function () {
    'use strict';

    angular
        .module('app.employees')
        .controller('EmployeesVacationsRecordsController', EmployeesVacationsRecordsController);

    /** @ngInject */
    function EmployeesVacationsRecordsController($scope, $document, $log, $state, $rootScope, successAlertS, errAlertS, AppF, $mdDialog) {
        var vm = this;
        vm.importEventsModal = function (ev) {
            $log.log('importCalculationsModal called');
            $mdDialog.show({
                controller: 'ImportEventsController',
                templateUrl: 'app/main/employees/views/employeesVacationsRecords/dialogs/import-events.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                controllerAs: 'impCalcCtrl',
                clickOutsideToClose: false
            }).then(function (answer) {
                $log.debug(answer, 'Import Calculations Modal answer');
            }, function () {
                $log.debug('Import Calculations Modal cancelled');
            });
        };
        vm.generateFile = function (event, employees, isXls) {
            try {
                if (!angular.isArray(employees) && employees.length === 0) {
                    throw 'Ningún empleado seleccionado';
                } else if (employees.length > 500) {
                    throw 'Seleccione menos empleados, Maximo limite de empleados es 500';
                }
                var confirm = $mdDialog.confirm().
                    title('Generar Reporte')
                    .textContent('Desea generar el reporte de vacaciones de ' + employees.length + ' empleados(s)')
                    .ariaLabel('Está Seguro(a)?')
                    .targetEvent(event)
                    .ok('OK')
                    .cancel('Cancelar');
                $mdDialog.show(confirm).then(function () {
                    try {
                        var extraParams = isXls ? { type: "xls" } : {};
                        extraParams.employeesIds = employees.map(function (item) {
                            return item.$id;
                        });
                        AppF.downloadFile('POST', "interface/exportVacationsReport", extraParams);
                    } catch (error) {
                        errAlertS(error);
                    }
                }).catch(function () {
                    $log.log('$mdDialog cerrado');
                })
            } catch (error) {
                errAlertS(error);
            }
        };

        $scope.vacationsRecordsHumand = function (event, selected) {
            $mdDialog.show({
                templateUrl: 'app/main/employees/views/employeesVacationsRecords/dialogs/vacationsRecordsHumand.html',
                controller: 'vacationsRecordsHumandController',
                controllerAs: 'vrCtrl',
                locals: {
                    selected: selected
                },
                parent: angular.element($document.body),
                targetEvent: event,
                scope: $scope.$new(),
                clickOutsideToClose: true
            });
        }



    }
}());
(function () {
    'use strict';

    angular
        .module('app.employees')
        .controller('EmployeesVacationsRecordController', EmployeesVacationsRecordController);

    /** @ngInject */
    function EmployeesVacationsRecordController($http, $window, $scope, confirmConfig, startAfterInitFilter, $log, $state, AppF, $mdDialog, $rootScope, successAlertS, errAlertS) {
        var detailWatchers = {};
        var initiated = false;
        var vm = this;
        function init() {
            var needed = [
                $scope.dataNeededPromise,
                $scope.statesObjsPromise,
                $scope.mainObjectLoaded
            ];
            Promise.all(needed).then(function () {
                vm.employeesVacationsRecord = {};
                if (angular.isDefined($scope.employee) && $scope.employee !== null && Object.keys($scope.employee).length > 0) {
                    vm.employee = $scope.employee;
                    vm.employee.fid = $scope.employee.$id;
                    vm.employeesVacationsRecord.employeeId = $scope.employee.$id;
                    vm.searchEmployee = $scope.employee.data.name;
                    vm.loadEvents(vm.employee).then(function () {
                        $log.log('Empleado cargado');
                        $rootScope.$evalAsync();
                    }).catch(errAlertS);
                }
            }).catch(function (error) {
                errAlertS(error);
            });
        }
        vm.eventsTypes = [
            { id: 'anniversary', name: 'Aniversario', field: 'earned' },
            { id: 'prescribed', name: 'Prescrito', field: 'prescribed' },
            { id: 'adjustment', name: 'Ajuste' }
        ];
        var fields = ['earned', 'prescribed', 'enjoyed'];
        function vEvents(item) {
            var event = { date: item.date, event: item.event };
            var founded = false;
            for (var f = 0; f < fields.length && !founded; f++) {
                if (item.hasOwnProperty(fields[f])) {
                    founded = true;
                    event[fields[f]] = item[fields[f]];
                }
            }
            if (!founded) {
                event = null;
            }
            return event;
        }
        vm.deleteEvent = function (date) {
            $mdDialog.show(
                $mdDialog.confirm(confirmConfig)
                    .title('Desea eliminar este evento')
                    .content('Al eliminar el evento las vacaciones del empleado se actualizaran')
                    .ariaLabel('Eliminar evento')
                    .ok('Aceptar')
                    .cancel('Cancelar')
            ).then(function () {
                var currentEvents = vm.vacationsEvents.filter(function (item) {
                    return item.fixed;
                });
                var index = currentEvents.findIndex(function (item) {
                    return date === item.date;
                });
                if (index > -1) {
                    currentEvents.splice(index, 1);
                    currentEvents = currentEvents.map(vEvents);
                    saveEvent(currentEvents);
                }
            }).catch(function () {
                $log.log('Acción cancelada');
            });
        };
        vm.addEvent = function () {
            try {
                var currentEvents = vm.vacationsEvents.filter(function (item) {
                    return item.fixed;
                });
                var index = currentEvents.findIndex(function (item) {
                    var flag = false;
                    if (vm.eventType.name === item.event) {
                        flag = (vm.eventType.id === 'anniversary' ? parseInt(vm.eventDate.year) === item.year : vm.eventDate === item.date);
                    }
                    return flag;
                });
                var obj = {};
                obj[vm.eventType.field ? vm.eventType.field : vm.adjustmentType] = vm.qty;
                obj.date = (vm.eventType.id === 'anniversary' ? vm.eventDate.date : vm.eventDate);
                obj.event = vm.eventType.name;
                if (index > -1) {
                    currentEvents[index] = obj;
                } else {
                    currentEvents.push(obj);
                }
                currentEvents = currentEvents.map(vEvents);
                saveEvent(currentEvents);
            } catch (error) {
                errAlertS(error);
            }
        };
        function saveEvent(currentEvents) {
            $rootScope.loadingProgress = true;
            AppF.root.child('catalogs/employees/collection/' + vm.employeesVacationsRecord.employeeId + '/vacationsEvents').set(currentEvents).then(function () {
                return vm.loadEvents(vm.employee, true);
            }).then(function () {
                successAlertS('Se actualizaron vacaciones con éxito');
                $rootScope.loadingProgress = false;
                vm.fireAddEvent(false);
            }).catch(function (error) {
                $rootScope.loadingProgress = false;
                errAlertS(error);
            });
        }
        vm.setAnniversaries = function (eventType) {
            vm.anniversaries = [];
            if (eventType.id === 'anniversary' && vm.employeeData) {
                var initDate = moment(vm.employeeData.data.realSeniorityDate ? vm.employeeData.data.realSeniorityDate : (vm.employeeData.data.seniorityDate ? vm.employeeData.data.seniorityDate : vm.employeeData.data.enroleDate));
                initDate.add(1, 'year');
                var now = moment();
                while (initDate < now) {
                    vm.anniversaries.push({ date: initDate.valueOf(), year: initDate.format('YYYY') });
                    initDate.add(1, 'year');
                }
            }
        };
        vm.exportVacations = function (type) {
            try {
                var extraParams = {
                    employeesIds: [vm.employeesVacationsRecord.employeeId],
                    type: type
                };
                AppF.downloadFile('POST', 'interface/exportVacationsReport', extraParams)
            } catch (error) {
                errAlertS(error)
            }
        };
        vm.fireAddEvent = function (showAddEvent) {
            vm.showAddEvent = showAddEvent;
            if (showAddEvent) {
                if (vm.employeeData) {
                    var initDate = vm.employeeData.data.realSeniorityDate ? vm.employeeData.data.realSeniorityDate : (vm.employeeData.data.seniorityDate ? vm.employeeData.data.seniorityDate : vm.employeeData.data.enroleDate);
                    $log.log(initDate);
                    vm.minDate = moment(initDate).toDate();
                }
                $log.log(showAddEvent);
            } else {
                delete vm.eventType;
                delete vm.eventDate;
                delete vm.qty;
                delete vm.adjustmentType;
            }
        };
        vm.loadEvents = function (employee, notSetEmpty) {
            $log.log(employee);
            return new Promise(function (resolve, reject) {
                if (!notSetEmpty) {
                    vm.vacationsEvents = [];
                    delete vm.employeeData;
                }
                if (angular.isObject(employee) && employee !== null) {
                    $state.go($scope.R.states.fb[$scope.F.active.menuName].update, { employeeId: vm.employeesVacationsRecord.employeeId }, { notify: false });
                    var promises = [
                        $scope.D.models.action('salaries', 'getVacationsEvents/' + vm.employeesVacationsRecord.employeeId, {}),
                        $scope.L.loadList('employee', 'catalogs/employees/collection/' + vm.employeesVacationsRecord.employeeId, undefined, 'object', 'employeeData-' + vm.employeesVacationsRecord.employeeId)
                    ];
                    Promise.all(promises).then(function (resp) {
                        vm.vacationsEvents = resp[0].data;
                        vm.employeeData = resp[1];
                        resolve(true);
                    }).catch(reject);
                } else {
                    vm.vacationsEvents = [];
                    resolve(true);
                }
            });
        };
        startAfterInitFilter($scope, detailWatchers, initiated, init);
    }
}());
(function () {
    'use strict';

    angular
        .module('app.employees')
        .controller('EnroleAccountsController', EnroleAccountsController);

    function EnroleAccountsController(
        $rootScope,
        $scope,
        $log,
        $mdDialog,
        errAlertS,
        successAlertS,
        getArrayOfIdsFilter,
        createLinkWithResponseFilter,
        decodeArrayBufferObjectFilter,
        cardsBelongToBanorteFilter,
        checkLayoutFilter,
        filterFilter,
        $document,
        $filter,
        $timeout,
        $q,
        AppF,
        confirmConfig
    ) {
        $scope.importAccounts = function (ev) {
            $log.debug('importAcccounts');
            $mdDialog.show({
                controller: function (scope, infoAlertS) {
                    scope.filesArray = [];
                    scope.ddate = moment().valueOf();
                    scope.executeFail = false;
                    scope.accounts = {
                        file: false,
                        accounts: []
                    };
                    scope.L = $scope.L;
                    scope.M = $scope.M;
                    $scope.F.loadingFile = false;
                    scope.close = function () {
                        $mdDialog.hide();
                        scope.removeUpload();
                    };

                    function importAccounts() {
                        return new Promise(function (resolve, reject) {
                            var indexesToUpdate = [];
                            var updates = {};
                            for (var a = 0; a < scope.accounts.accounts.length; a++) {
                                var thisAccount = scope.accounts.accounts[a];
                                if (!thisAccount.invalid && !thisAccount.executed) {
                                    indexesToUpdate.push(a);
                                    updates[thisAccount.idEmployee + '/data/cards/0/account'] = thisAccount['Cuenta'];
                                    if (Object.keys(updates).length > 500) {
                                        a = scope.accounts.accounts.length + 1;
                                    }
                                }
                            }
                            if (Object.keys(updates).length === 0) {
                                resolve(true);
                            } else {
                                AppF.root.child('catalogs/employees/collection').update(updates).then(function () {
                                    for (var i = 0; i < indexesToUpdate.length; i++) {
                                        scope.accounts.accounts[indexesToUpdate[i]].executed = true;
                                    }
                                    scope.$evalAsync();
                                    $timeout(function () {
                                        resolve(importAccounts());
                                    }, 0, false);
                                }).catch(reject);
                            }
                        });
                    }
                    scope.importAccounts = function () {
                        scope.executing = true;
                        scope.$evalAsync();
                        $timeout(function () {
                            importAccounts().then(function () {
                                scope.close();
                                successAlertS('Se realizo registro de cuentas correctamente');
                            }).catch(function (error) {
                                scope.executedFail = true;
                                errAlertS(error);
                            }).then(function () {
                                scope.executing = false;
                            });
                        }, 0, false);
                    };

                    scope.upload = function (files) {
                        var formData = new FormData();
                        $scope.F.loadingFile = true;
                        formData.append('file', files[0].lfFile);
                        var accounts;
                        $scope.D.files.csvToJson(formData).then(function (data) {
                            accounts = data.data;
                            if (!angular.isArray(accounts)) {
                                $log.error(accounts);
                                throw 'Error al obtener los datos del csv, vuelva a intentarlo';
                            } else if (accounts.length === 0) {
                                throw 'No se encontraron datos para exportar';
                            }
                            $log.log(accounts);
                            scope.accounts.file = true;
                            var promises = {};
                            for (var j = 0; j < accounts.length; j++) {
                                var employeeNumber = accounts[j]['No_Empleado'];
                                employeeNumber = parseInt(employeeNumber);
                                var query = [{ q: 'orderByChild', v: 'created/sqlId' }, { q: 'equalTo', v: employeeNumber }];
                                $log.log(query);
                                promises[employeeNumber] = scope.L.loadList('employees', 'catalogs/employees/collection', undefined, 'array', 'employeeByNumber' + employeeNumber, query);
                            }
                            return $q.all(promises);
                        }).then(function (employeesResp) {
                            scope.accounts.accounts = $filter('validateAccounts')(accounts, employeesResp);
                            $log.log(scope.accounts.accounts);
                            scope.$evalAsync(function () { });
                            $scope.F.loadingFile = false;
                            $timeout(function () { }, 0, false);
                        }).catch(function (err) {
                            errAlertS(err);
                            $scope.F.loadingFile = false;
                        });
                    };
                    // TODO: pasar a padre
                    scope.removeUpload = function () {
                        $log.debug('cancelling upload');
                        scope.filesArray = [];
                        scope.csvApi.removeAll();
                        scope.accounts = {
                            file: false,
                            accounts: []
                        };
                    };
                },
                templateUrl: 'app/main/employees/dialogs/import-accounts.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            }).then(function (answer) {
                $log.debug(answer, 'importAccounts answer');
            }, function () {
                $log.debug('importAccounts cancelled');
            });
        };
        /** @type Front, Api
         * @description bajo un confirm setea emmitedYet = true y le pone un objeto (emmitedAccount) para guardar historico de la última emisión a los empleados seleccionados
         * @param {Event} event 
         */
        function enroleAccounts(event) {
            $log.debug('enroleAccounts', $scope.selected, event);
            var employeesQty = $scope.selected.length;
            $mdDialog.show(
                $mdDialog.confirm()
                    .title('Desea ejecutar la alta de cuenta como emitida/registrada')
                    .textContent('Se actualizarán ' + employeesQty + ' empleado(s)')
                    .ariaLabel('Está seguro(a)?')
                    .targetEvent(event)
                    .ok('OK')
                    .cancel('Cancelar')
            ).then(function () {
                $rootScope.loadingProgress = true;
                var updates = $scope.selected.reduce(function (current, item) {
                    current[item.$id + '/data/cards/0/emmitedYet'] = true;
                    current[item.$id + '/updated'] = $scope.D.getTimeObject();
                    return current;
                }, {});
                AppF.root.child('catalogs/employees/collection').update(updates).then(function () {
                    successAlertS('Se archivaron ' + employeesQty + ' con éxito');
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync(function () {
                        $log.debug('enroleAccounts finished');
                    });
                }).catch(function (err) {
                    errAlertS(err);
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                });
            }).catch(function (err) {
                errAlertS(err);
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
            });
        }

        /** @type Front, Api, File
         * @description Obtiene prompt para sacar interface de alta de cuentas para BANORTE
         * @param {Event} event 
         * @returns
         */
        function getBanorteInterface(event) {
            $log.debug('getBanorteInterface', $scope.selected, event);
            var employees = ($scope.selected.length == $scope.F.paginate) ? $scope.Z[$scope.F.active.menuName] : $scope.selected,
                cardsBelong = cardsBelongToBanorte(employees);
            if (cardsBelong === true) {
                // se manda prompt para consecutivo de 2 dígitos
                var confirm = {
                    controller: 'DialogCtrl',
                    parent: angular.element(document.body),
                    targetEvent: event,
                    scope: $scope.$new(),
                    locals: {
                        predefinedValue: undefined
                    },
                    clickOutsideToClose: true,
                    templateUrl: 'app/main/employees/dialogs/interface-banorte-consecutive.html'
                };

                $mdDialog.show(confirm).then(function (consecutive) {
                    consecutive = consecutive.length == 2 ? consecutive : '0' + consecutive;
                    $log.debug(consecutive, 'consecutivo');
                    if (consecutive) {
                        $rootScope.loadingProgress = true;
                        $scope.D.interfaces.post('banorte', {
                            ids: getArrayOfIdsFilter(employees),
                            consecutive: consecutive
                        }).then(function (response) {
                            try {
                                createLinkWithResponseFilter(response);
                                $rootScope.loadingProgress = false;
                                $rootScope.$evalAsync(function () {
                                    $log.debug('getBanorteInterface finished');
                                });
                            } catch (ex) {
                                errAlertS(ex);
                                $rootScope.loadingProgress = false;
                                $rootScope.$evalAsync();
                            }
                        }).catch(function (err) {
                            var error = decodeArrayBufferObjectFilter(err.data); // needed for file api calls
                            errAlertS(error);
                            $rootScope.loadingProgress = false;
                            $rootScope.$evalAsync();
                        });
                    } else {
                        errAlertS('Por favor introduzca consecutivo para obtener la interface de alta de cuentas Banorte');
                    }
                });
            } else {
                var msg = 'Problemas: <br><ul>';
                for (var eid in cardsBelong) {
                    for (var e in employees) {
                        if (employees[e].$id == eid) {
                            msg += '<li>' + employees[e].data.name + ': ' + cardsBelong[eid] + '</li>';
                        }
                    }
                }
                msg += '</ul>'
                errAlertS(msg);
            }
        }

        /** @type Front, Invocation, Filter
         * @description Checa si todos los empleados tienen cuenta de Banorte
         * @param {Employee[]} employees 
         * @returns {Boolean}
         */
        function cardsBelongToBanorte(employees, dontValidate) {
            $log.debug('allBelongToBanorte fired');
            if (dontValidate) {
                if ($scope.selected.length != employees.length) {
                    $log.debug('allBelongToBanorteFilter withoutValidation called');
                    return cardsBelongToBanorteFilter(employees, dontValidate);
                }
            } else {
                $log.debug('allBelongToBanorteFilter called');
                return cardsBelongToBanorteFilter(employees);
            }
        }

        function getInterface(event, bank) {
            var check = checkLayoutFilter($scope.selected, bank, true);
            if (angular.isString(check)) {
                errAlertS(check);
            } else {
                var askFields = filterFilter(bank.fields, { askfor: true });
                var promises = [];
                if (angular.isDefined(askFields) && askFields.length > 0) {
                    var confirm = {
                        parent: angular.element(document.body),
                        targetEvent: event,
                        scope: $scope.$new(),
                        locals: {
                            fields: askFields,
                            bank: bank
                        },
                        clickOutsideToClose: true,
                        templateUrl: 'app/main/employees/dialogs/interface-bank.html',
                        controller: function (scope, fields, bank) {
                            scope.interfaceData = {};
                            scope.bank = bank;
                            scope.fields = fields;
                            scope.hide = function () {
                                $mdDialog.hide();
                            };
                            scope.cancel = function () {
                                $mdDialog.cancel();
                            };
                            scope.answer = function (answer) {
                                $mdDialog.hide(answer);
                            };
                        }
                    };
                    promises.push($mdDialog.show(confirm));
                }
                Promise.all(promises).then(function (resp) {
                    var thisResp = {};
                    if (angular.isArray(resp) && resp.length > 0) {
                        thisResp = resp[0];
                    }
                    thisResp.ids = getArrayOfIdsFilter($scope.selected);
                    $rootScope.loadingProgress = true;
                    $scope.D.interfaces.post('bank/emit/' + bank._id, thisResp).then(function (response) {
                        try {
                            createLinkWithResponseFilter(response);
                            $rootScope.loadingProgress = false;
                            $rootScope.$evalAsync(function () {
                                $log.debug('getBanorteInterface finished');
                            });
                        } catch (ex) {
                            errAlertS(ex);
                            $rootScope.loadingProgress = false;
                            $rootScope.$evalAsync();
                        }
                    }).catch(function (err) {
                        var error = decodeArrayBufferObjectFilter(err.data); // needed for file api calls
                        errAlertS(error);
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync();
                    });
                }).catch(function (error) {
                    if (angular.isDefined(error)) {
                        var msg = 'Error al solicitar la cuenta';
                        if (angular.isString(error)) {
                            msg = error;
                        } else if (angular.isObject(error) && angular.isString(error.msg)) {
                            msg = error.msg;
                        }
                        $log.error(error);
                        errAlertS(msg);
                    } else {
                        $log.info('Se cancelo la solicitud');
                    }
                });
            }
        }
        function cancelAccounts(e, employees) {
            var total = $scope.selected.length;
            $mdDialog.show($mdDialog.confirm(confirmConfig)
                .title("Se cancelarán " + total + ((total > 1) ? " solicitudes" : " solicitud"))
                .content("Se cancelaran las solicitudes seleccionadas, ¿Desea Continuar?")
                .ariaLabel('Deleting')
                .targetEvent(e)
                .ok('Si')
                .cancel('No'))
                .then(function () {
                    if (angular.isArray(employees)) {
                        $rootScope.loadingProgress = true;
                        var updates = {};
                        for (var i = 0; i < employees.length; i++) {
                            if (angular.isDefined(employees[i].data.cards)) {
                                var cards = angular.fromJson(angular.toJson(employees[i].data.cards));
                                cards.splice(0, 1);
                                if (cards.length > 0) {
                                    var obj = {};
                                    for (var c = 0; c < cards.length; c++) {
                                        if (!cards[c].emmitedYet) {
                                            cards[c].emmitedYet = true;
                                        }
                                        obj[c] = cards[c];
                                    }
                                    updates[employees[i].$id + '/data/cards'] = obj;
                                } else {
                                    updates[employees[i].$id + '/data/cards'] = null;
                                }
                            }
                        }
                        AppF.root.child('catalogs/employees/collection').update(updates).then(function () {
                            $rootScope.loadingProgress = false;
                            $rootScope.$evalAsync();
                            successAlertS("Se canceló " + total + " solicitud con éxito");
                        }).catch(function (error) {
                            $rootScope.loadingProgress = false;
                            $rootScope.$evalAsync();
                            $log.log(error);
                            errAlertS('Ocurrió un error al cancelar la solicitud');
                        });
                    }
                }, function () {
                    $log.debug('Cancel Cancelled');
                });
        }
        // funciones del $scope
        $scope.enroleAccounts = enroleAccounts;
        $scope.getBanorteInterface = getBanorteInterface;
        $scope.checkLayout = checkLayoutFilter;
        $scope.getInterface = getInterface;
        $scope.cancelAccounts = cancelAccounts;
        // $scope.cardsBelongToBanorte = cardsBelongToBanorte;

    }

}());
(function () {
    'use strict';

    angular
        .module('app.employees')
        .controller('EmployeeFilesController', EmployeeFilesController);

    /** @ngInject */
    function EmployeeFilesController($scope, $log, errAlertS, loopEachFilter, $document, $mdDialog) {
        var vm = this;
        vm.openUploadManyFiles = function (ev) {
            $mdDialog.show({
                templateUrl: 'app/main/employees/views/employeeFiles/dialogs/upload-many-files.html',
                parent: angular.element($document.body),
                controller: 'UploadManyFilesController',
                controllerAs: 'upManyCtrl',
                targetEvent: ev,
                clickOutsideToClose: false
            });
        }
        vm.getDownloadUrl = function (employeeFiles, employeeId) {
            var data = [];
            loopEachFilter(employeeFiles, function (value, filename) {
                data.push(filename);
            });
            if (data.length > 0) {
                data = data.sort();
                var ref = 'catalogs/employeeFiles/collection/' + employeeId + '/' + data[data.length - 1] + '/url';
                $scope.F.root.child(ref).once('value').then(function (snap) {
                    if (snap.exists()) {
                        var url = snap.val();
                        var linkElement = document.createElement('a');
                        linkElement.setAttribute('href', url);
                        linkElement.setAttribute('target', '_blank');
                        var clickEvent = new MouseEvent('click', {
                            'view': window,
                            'bubbles': true,
                            'cancelable': false
                        });
                        linkElement.dispatchEvent(clickEvent);
                    } else {
                        throw 'No se encontró la url del archivo';
                    }
                }).catch(errAlertS);
            } else {
                errAlertS('No existe ningún archivo');
            }

        };
    }
}());
(function () {
    'use strict';

    angular
        .module('app.employees')
        .controller('EmployeeFileController', EmployeeFileController);

    /** @ngInject */
    function EmployeeFileController($scope, startAfterInitFilter, $log, $state, $mdDialog, errAlertS, $rootScope, successAlertS, ApiV2F) {
        var detailWatchers = {};
        var initiated = false;
        var vm = this;
        vm.showUpload = false;
        function init() {
            var needed = [
                $scope.dataNeededPromise,
                $scope.statesObjsPromise,
                $scope.mainObjectLoaded
            ];
            Promise.all(needed).then(function () {
                vm.employeeFile = {};
                if (angular.isDefined($scope.employee) && $scope.employee !== null && Object.keys($scope.employee).length > 0) {
                    vm.employee = $scope.employee;
                    vm.employee.fid = $scope.employee.$id;
                    vm.employeeFile.employeeId = $scope.employee.$id;
                    vm.searchEmployee = $scope.employee.data.name;
                    vm.loadEmployee(vm.employee);
                }
            }).catch(function (error) {
                errAlertS(error);
            });
        }
        vm.loadEmployee = function (employee) {
            vm.docs = [];
            vm.docTypes = [];
            if (angular.isObject(employee) && employee !== null) {
                $state.go($scope.R.states.fb[$scope.F.active.menuName].update, { employeeId: employee.fid }, { notify: false });
                var queryM = { center: $scope.F.center, type: angular.toJson({ $in: ['generals', 'generalsRequired'] }), project: angular.toJson({ allowMany: 1, type: 1, name: 1, firm: 1, key: 1 }), firm: angular.toJson({ $in: ['global', $scope.employee.firm] }) };
                var promises = [
                    $scope.L.loadList('employeeFiles', 'catalogs/employeeFiles/collection/' + employee.$id, undefined, 'array', 'filesOfEmployee' + employee.$id),
                    $rootScope.D.api.get('documentTypes', queryM)
                ];
                Promise.all(promises).then(function (resp) {
                    vm.docs = resp[0];
                    var allDocTypes = resp[1].data;
                    var docTypes = allDocTypes.filter(function (item) {
                        return [employee.firm, 'global'].indexOf(item.firm) > -1;
                    });
                    vm.docTypes = docTypes;
                }).catch(function (error) {
                    $log.error(error);
                });
            }
        };
        vm.deleteFile = function (event, doc) {
            var confirm = $mdDialog.confirm().
                title('Desea eliminar archivo del expediente?')
                .textContent('Al aceptar esta operación el archivo sera eliminado y no podrá deshacer esta acción, desea continuar?')
                .ariaLabel('Está Seguro(a)?')
                .targetEvent(event)
                .ok('OK')
                .cancel('Cancelar');
            $mdDialog.show(confirm).then(function () {
                return $scope.C.removeFile(doc.path)
            }).then(function () {
                return $scope.F.root.child('catalogs/employeeFiles/collection/' + doc.employeeId + '/' + doc.$id).set(null);
            }).then(function () {
                successAlertS('El archivo fue eliminado');
            }).catch(function (err) {
                if (angular.isDefined(err)) {
                    errAlertS(err);
                }
            });
        };

        vm.uploadFile = function (files, employeeFile) {
            var docType = vm.docTypes.find(function (item) {
                return item.key === employeeFile.documentType;
            });
            var hasOther = vm.docs.find(function (item) {
                return item.documentType === employeeFile.documentType;
            });
            var optimizedTask;
            var doIt = (docType.allowMany || (!docType.allowMany && angular.isUndefined(hasOther))) ? true : false;
            if (doIt) {
                vm.uploading = true;
                var employeeFileId = employeeFile.documentType + '_' + moment().format('YYMMDDHHss');
                var obj = { '$id': employeeFile.employeeId };
                $scope.C.uploadFile(files, obj, employeeFileId, false, true).then(function (imageObj) {
                    var update = {
                        employeeId: employeeFile.employeeId,
                        path: imageObj.path,
                        url: imageObj.url,
                        documentType: employeeFile.documentType,
                        created: $scope.D.getTimeObject()
                    };
                    optimizedTask = { "type": "five-queue", "action": "optimizePdf", url: imageObj.path }
                    return $scope.F.root.child('catalogs/employeeFiles/collection/' + employeeFile.employeeId + '/' + employeeFileId).update(update);
                }).then(function () {
                    if (angular.isDefined(optimizedTask)) {
                        return ApiV2F.post('tasks/add', optimizedTask)
                    } else {
                        return Promise.all([]);
                    }
                }).then(function () {
                    delete employeeFile.documentType;
                    vm.showUpload = false;
                    vm.fileToUpload.removeAll();
                    successAlertS('Archivo agregado correctamente');
                }).catch(errAlertS).then(function () {
                    vm.uploading = false;
                });
            } else {
                errAlertS('Solo se puede tener un documento de este tipo');
            }
        };
        vm.exists = function (docType, allowMany, docs) {
            var flag = false;
            if (!allowMany) {
                flag = docs.findIndex(function (item) { return item.documentType === docType; }) > -1;
            }
            return flag;
        };
        startAfterInitFilter($scope, detailWatchers, initiated, init);
    }
}());


/* eslint-disable angular/document-service */
(function () {
  'use strict';

  angular
    .module('app.employees')
    .controller('EmployeeController', EmployeeController);

  function EmployeeController(
    $scope,
    $state,
    $rootScope,
    $filter,
    $log,
    errAlertS,
    MongoF,
    startAfterInitFilter,
    successAlertS,
    getSomethingOfArrayFBFilter,
    MinMaxValiadationsForMovementFilter,
    checkForAddingPendingDaysFilter,
    checkValidFieldsModalFilter,
    checkDisabilitiesEmployeeFilter,
    $mdDialog,
    $timeout,
    confirmConfig,
    ApiV2F,
    ApiV3F,
    AppF,
    $stateParams,
    DataF
  ) {
    var initiated = false;
    var lastMovementPromise;
    $scope.processes = [];
    $scope.F.selectedCp = undefined;
    $scope.F.searchCp = undefined;
    var mapActions = {
      update: [1, 2, 2.1, 3, 3.5, 4, 5],
      mds: [3, 4],
      enrole: false,
      reEntry: [3, 5],
      revision: 1,
      list: false,
      dismiss: [3, 4, 5],
      read: false
    };
    var mapUpdateSbc = {
      employees: {
        update: false
      }
    }
    var originalCc;
    var originalRp;
    var originalEnroleDate;
    var originalWorKerType;
    var originalContractId;
    var originalMovData = {
      date: { path: "data.date" },
      status: { path: "status" },
      batch: { path: "received.batch" }
    }
    $scope.thisDetailWatchers = {};
    $scope.geoZone = {};
    $scope.editArchived = false;
    var firstSbcIgnored = false;
    var firstSbcIgnoredForChange = false;
    var getEmployee = function () {
      return new Promise(function (resolve, reject) {
        var promises = [];
        if (['movements', 'idseAutoRecords'].indexOf($scope.F.active.menuName) > -1 && $scope.F.active.menuAction === 'update') {
          promises.push($scope.L.loadList('employees', 'catalogs/employees/collection', $scope.movement.employee, 'object', 'employee-' + $scope.movement.employee));
        } else if ($scope.F.active.menuName === 'aniversaryRecords') {
          promises.push($scope.L.loadList('employees', 'catalogs/employees/collection', $scope.aniversaryRecordId, 'object', 'employee-' + $scope.aniversaryRecordId));
        }
        Promise.all(promises).then(function (resp) {
          if (resp.length > 0) {
            $scope.employee = resp[0];
          }
          resolve(true);
        }).catch(reject)
      });
    };
    var checkActionStatus = function () {
      var flag = $filter('validateActionStatus')($scope.employee, $scope.F.active.menuAction, mapActions);
      if (angular.isString(flag)) {
        errAlertS(flag);
        $scope.goToList()
      } else {
        return flag;
      }
    };
    $scope.goToList = function () {
      if (angular.isDefined(redirectTo)) {
        $state.go(redirectTo);
      } else {
        $scope.R.goToList();
      }
    }
    var checkParams = function () {
      if ((!$scope.F.active.menuParams['movementId'] || $scope.F.active.menuParams['movementId'] === '') && $scope.employee.data.nss && ['especialEdit', 'read'].indexOf($scope.F.active.menuAction) !== -1) {
        errAlertS('Url incorrecta, faltan parámetros');
        $scope.goToList()
      }
    };
    var checkBenefit = function () {
      $log.log('checkCalled');
      $filter('getBenefitsOfItem')($scope.employee).then(function (benefit) {
        if (typeof ($scope.minMaxValidations) !== 'undefined') {
          $scope.minMaxValidations.setBenefit(angular.fromJson(angular.toJson(benefit)));
        }
        $scope.benefit = angular.fromJson(angular.toJson(benefit));
        if (angular.isUndefined($scope.benefit.christmasBonusTable)) {
          $scope.benefit.christmasBonusTable = [];
        }
        $scope.$evalAsync();
      });
    };
    var getLastApprovedMovementOfEmployee = function () {
      return new Promise(function (resolve, reject) {
        if ($scope.F.active.menuName == 'movements') {
          $scope.lastApprovedMovement = false;
        }
        if (typeof ($scope.lastApprovedMovement) === 'undefined') {
          var promises = [];
          if (typeof (lastMovementPromise) === 'undefined' && angular.isObject($scope.employee.movements) && $scope.employee.$id) {
            var validStatus = [3, 4];
            if ($scope.F.active.menuName === 'idseAutoRecords') {
              validStatus = [4];
            }
            var queries = {
              'page': 1,
              'size': 1,
              'sort': '-data.date',
              'employee': $scope.employee.$id,
              'status': {
                '$in': validStatus
              }
            };
            lastMovementPromise = $rootScope.D.api.get('p/movements', queries);
          }
          if (typeof (lastMovementPromise) !== 'undefined') {
            promises.push(lastMovementPromise);
          }
          Promise.all(promises).then(function (resp) {
            if (resp.length) {
              var movementResp = resp[0];
              if (movementResp.data.data.length > 0) {
                $scope.lastApprovedMovement = movementResp.data.data[0];
              } else {
                $scope.lastApprovedMovement = false;
              }
            } else {
              $scope.lastApprovedMovement = false;
            }
            resolve($scope.lastApprovedMovement);
          }).catch(function (error) {
            reject(error);
          });
        } else {
          resolve($scope.lastApprovedMovement);
        }
      });
    };
    var setApplyVariables = function () {
      return new Promise(function (resolve) {
        if ($scope.F.active.menuAction === 'apply') {
          $log.debug('its a variable, setting watcher to applyNeeded');
          $scope.thisDetailWatchers.applyNeeded = $scope.$watchGroup(['sd', 'sbc', 'date'], function (needed) {
            if (needed[0] && needed[1] && needed[2]) {
              $scope.thisDetailWatchers.applyNeeded(); // ya se asignaron valores asi que ya no necesitamos el watcher
              if (!$scope.movement) { $scope.movement = {}; }
              if (!$scope.movement.data) { $scope.movement.data = {}; }
              var sd = needed[0].replace('-', '.');
              sd = parseFloat(sd);
              var sbc = needed[1].replace('-', '.');
              sbc = parseFloat(sbc);
              $scope.movement.data.sd = sd;
              $scope.movement.data.sbc = sbc;
              $scope.movement.data.date = parseInt(needed[2]);
              $scope.movement.data.comments = 'MDS por Aniversario';
              $log.debug('movement set for aniversary', $scope.movement);
              resolve(true);
            }
          });
        } else {
          resolve(true);
        }
      });
    };
    var getZipCodeObj = function () {
      return new Promise(function (resolve, reject) {
        var zipCodeId = $filter('getFromObject')($scope.employee.data, 'info.residence.address.zipCodeId');
        if (angular.isDefined(zipCodeId)) {
          $scope.D.api.get('zipCodes/' + zipCodeId).then(function (res) {
            $scope.F.selectedCp = res.data;
            resolve(true);
          }, function (error) {
            reject(error);
          });
        } else {
          $scope.F.searchCp = $filter('getFromObject')($scope.employee.data, 'info.residence.address.zipCode')
          resolve(true);
        }
      });
    };
    var setMinDates = function () {
      if ($scope.F.active.menuName !== 'movements') {
        switch ($scope.F.active.menuAction) {
          case 'enrole':
          case 'reEntry':
            $scope.maxEnroleDate = $scope.minMaxValidations.maxEnroleDate;
            $scope.minEnroleDate = $scope.minMaxValidations.minEnroleDate;
            break;
          case 'dismiss':
            $scope.minMovementDate = $scope.minMaxValidations.minDismissDate;
            $scope.maxDismissDate = $scope.minMaxValidations.maxDismissDate;
            break;
          case 'mds':
            $scope.minMovementDate = $scope.minMaxValidations.minMdsDate;
            $scope.maxMdsDate = $scope.minMaxValidations.maxMdsDate;
            break;
          case 'apply': // aniversaries
            $scope.minMovementDate = $scope.minMaxValidations.minMdsDate;
            $scope.maxMdsDate = $scope.minMaxValidations.maxMdsDate;
            break;
          case 'update':
            switch ($scope.employee.movement.type) {
              case 6:
              case 8:
                $scope.maxEnroleDate = $scope.minMaxValidations.maxEnroleDate;
                $scope.minEnroleDate = $scope.minMaxValidations.minEnroleDate;
                break;
              case 2:
                $scope.minMovementDate = $scope.minMaxValidations.minDismissDate;
                $scope.maxDismissDate = $scope.minMaxValidations.maxDismissDate;
                break;
              case 7:
                $scope.minMovementDate = $scope.minMaxValidations.minMdsDate;
                $scope.maxMdsDate = $scope.minMaxValidations.maxMdsDate;
                break;
            }
            break;
        }
      }
      $rootScope.$evalAsync();
    };
    function showLessSalaryModal() {
      return new Promise(function (resolve) {
        if (!firstSbcIgnoredForChange) {
          firstSbcIgnoredForChange = true;
          resolve(true)
        } else {
          if ((angular.isNumber($scope.minMaxValidations.lastSd) && $scope.movement.data.sd && $scope.movement.data.sd < $scope.minMaxValidations.lastSd) || (angular.isNumber($scope.minMaxValidations.lastSbc) && $scope.movement.data.sbc && $scope.movement.data.sbc < $scope.minMaxValidations.lastSbc)) {
            var isSd = angular.isNumber($scope.minMaxValidations.lastSd) && $scope.movement.data.sd < $scope.minMaxValidations.lastSd;
            var warning = 'El ' + (isSd ? 'salario diario' : 'salario base cotización') + ' que está registrando es menor al ' + (isSd ? 'salario diario' : 'salario base cotización') + ' anterior del trabajador.<br>' + (isSd ? '' : 'Ten en cuenta que este empleado puede tener variables que no se han considerado en la integración<br>') +
              'Si continúa, el sistema guardará el nuevo ' + (isSd ? 'salario diario' : 'salario base cotización') + ' con un valor menor al previo.<br><br>' +
              '¿Desea continuar con este cambio?';
            $mdDialog.show(
              $mdDialog.confirm(confirmConfig)
                .title('Confirmar disminución de salario')
                .htmlContent(warning)
                .ariaLabel('confirmar cambio de salario')
                .targetEvent(event)
                .ok('Sí, continuar')
                .cancel('Cancelar cambio')
            ).then(function () {
              $log.log('Usuario aceptó disminuir el salario');
              resolve(true);
            }).catch(function () {
              $scope.movement.data.sd = '';
              $scope.movement.data.sbc = '';
              $log.log('Usuario canceló el cambio');
              resolve(false);
            });
          } else {
            resolve(true);
          }
        }
      })
    }
    var setMinSalaries = function () {
      $scope.minimumWage = $scope.minMaxValidations.minimumWageByZone;
      $scope.lastSd = $scope.minMaxValidations.lastSd;
      $scope.minimumSd = $scope.minMaxValidations.minimumSd;
      $scope.lastSbc = $scope.minMaxValidations.lastSbc;
      $scope.minimumSbc = $scope.minMaxValidations.minimumSbc;
      $scope.maxSdOfLastSbc = $scope.minMaxValidations.maxSdOfLastSbc;
      $scope.factorSelected = $scope.minMaxValidations.factor;
      var sd = $filter('pathInObj')($filter('clearObject')($scope.movement), 'data.sd');
      var onlySd = $filter('pathInObj')($filter('clearObject')($scope.movement), 'data.onlySd');
      var updateSbc = $filter('pathInObj')(mapUpdateSbc, $scope.F.active.menuName + '.' + $scope.F.active.menuAction, undefined, 'undefined');
      if (updateSbc === 'undefined') {
        updateSbc = true;
      }
      if ((sd || onlySd) && ($scope.F.active.menuAction !== 'especialEdit' || angular.isUndefined($scope.movement.data.sbc) || $scope.movement.data.sbc === '' || $scope.movement.data.sbc === null) && updateSbc) {
        if (angular.isUndefined($scope.movement.data.sbc) || $scope.movement.data.sbc === '' || $scope.movement.data.sbc === null) {
          $log.log('setting minimum sbc because it was empty');
          $scope.movement.data.sbc = $scope.minMaxValidations.minimumSbc;
          firstSbcIgnored = true;
        } else if (angular.isDefined($scope.movement.data.sbc) && $scope.movement.data.sbc < $scope.minMaxValidations.minimumSbc) {
          $log.log('setting minimum sbc because it was lower than minimum');
          $scope.movement.data.sbc = $scope.minMaxValidations.minimumSbc;
          firstSbcIgnored = true;
        } else if (angular.isDefined($scope.movement.data.sbc) && $scope.movement.data.sbc >= $scope.minMaxValidations.minimumSbc) {
          $log.log('sbc is greater than minimum but we need to check if the user changed it to a value lower than minimum and then back to a value greater than minimum, if that is the case we need to show the modal and set it to minimum if the user cancels');
          if (firstSbcIgnored) {
            $scope.movement.data.sbc = $scope.minMaxValidations.minimumSbc;
          }
          firstSbcIgnored = true;
        }
      }
      $scope.employee.data.if = $scope.minMaxValidations.factor;
      $scope.employee.data.b = $scope.minMaxValidations.b;
      showLessSalaryModal().then(function () {
        $rootScope.$evalAsync();
      }).catch(function (error) {
        if (error) {
          errAlertS(error);
        }
      });
    };
    var setMinMaxValidations = function () {
      return new Promise(function (resolve, reject) {
        $scope.minimumWage = $scope.F.minimumVariables.A;
        var couldBeTheSame = ($scope.aniversaryRecord && $scope.F.active.menuName === 'aniversaryRecords') || $scope.movement.data.aniversary ? true : false;
        $scope.minMaxValidations = new MinMaxValiadationsForMovementFilter($scope.employee, $scope.movement, $scope.benefit, couldBeTheSame, $scope.movement.data.type === 8, $scope.geoZone);
        var promises = [
          $scope.minMaxValidations.setMinDates(),
          $scope.minMaxValidations.setMinSalaries($scope.movement.data.sd)
        ];
        Promise.all(promises).then(function () {
          setMinDates();
          setMinSalaries();
          resolve(true);
        }).catch(reject);
      })
    };
    $scope.validateSbc = function () {
      showLessSalaryModal().then(function () {
        $rootScope.$evalAsync();
      }).catch(function (error) {
        if (error) {
          errAlertS(error);
        }
      });
    }
    var setDefaultValues = function () {
      if (['employees', 'dismissesRecords', 'mdsRecords', 'enroles', 'aniversariesRecords'].indexOf($scope.F.active.menuName) !== -1) {
        if ($scope.F.active.menuParams['movementId'] === 'new') {
          $log.debug('setting defaults for new movement', $scope.movement);
          $scope.employee.data.comments = '';
          if ($scope.F.active.menuAction === 'dismiss') {
            $scope.movement.data.rehirable = true; // default
          }
          if ($scope.F.active.menuAction === 'reEntry') {
            // delete $scope.employee.data.jobDescription;
            // var emails = $filter('pathInObj')($filter('clearObject')($scope.employee), 'data.info.emails');
            // if (emails === false || (angular.isObject(emails) && typeof (emails[0]) === 'undefined' && typeof (emails['0'] === 'undefined'))) {
            //     $filter('setInObjectPath')('data.info.emails', $scope.employee, [{
            //         active: true,
            //         type: 'Personal'
            //     }], true, true);
            // }
            delete $scope.employee.data.enroleDate;
          }
        }
      }
    };

    $scope.$watch("thisDetailWatchers", function (newVal, oldVal) {
      $log.log('watchers changed', newVal, oldVal);
    }, true);

    function initWatcher(watcher, actions) {
      switch (watcher) {
        case 'datesVariables':
          //Se observa el sd por si cambia para establecer los salarios mínimos
          $scope.thisDetailWatchers.datesVariables = $scope.$watchGroup(['employee.hasSeniorityDate', 'employee.data.seniorityDate', 'employee.data.workDay'], function (newVal, oldVal) {
            if (newVal[0] !== oldVal[0] || newVal[1] !== oldVal[1] || newVal[2] !== oldVal[2]) {
              $log.log('hasSeniorityDate or seniorityDate changed');
              $scope.minMaxValidations.setMinSalaries($scope.movement.data.sd).then(function () {
                setMinSalaries();
              });
            }
            if (angular.isDefined(newVal[0]) && !newVal[0]) {
              delete $scope.employee.data.seniorityDate;
            }
          });
          break;
        case 'employeeRp':
          //Se observa el rp para setear las fechas mínimas
          $scope.thisDetailWatchers.employeeRp = $scope.$watch('employee.rp', function (rp, rpOld) {
            if (rp !== rpOld) {
              $log.log('rp changed');
              $scope.minMaxValidations.setMinDates().then(function () {
                setMinDates();
              });
            }
          });
          break;
        case 'benefit':
          //Si hubo cambios en el beneficio se calculan los factores nuevamente y también se vuelven a calcular
          $scope.thisDetailWatchers.benefit = $scope.$watch('benefit', function (val, oldVal) {
            if (val && angular.toJson(val) !== angular.toJson(oldVal)) {
              $log.log('benefit changed');
              if (actions.indexOf('setBenefit') > -1 && typeof ($scope.minMaxValidations) !== 'undefined') {
                $scope.minMaxValidations.setBenefit(angular.fromJson(angular.toJson($scope.benefit)));
              }
              if (val.holidays === 'default') {
                $scope.benefit.holidaysTable = angular.fromJson(angular.toJson($scope.F.defaultBenefits.holidaysTable));
                $scope.editHolidayTable = false;
              }
              if (actions.indexOf('setHolidayTable') > -1 && angular.isObject($scope.benefit.holidaysTable)) {
                for (var b in $scope.benefit.holidaysTable) {
                  if (typeof ($scope.benefit.holidaysTable[b].limit) !== 'undefined' && typeof ($scope.benefit.holidaysTable[b].value) !== 'undefined') {
                    $scope.benefit.holidaysTable[b].factor = $filter('getFactorFromBenefits')($scope.benefit, null, null, $scope.benefit.holidaysTable[b].limit);
                  } else {
                    $scope.benefit.holidaysTable[b].factor = '';

                  }
                }
              }
              if (actions.indexOf('setMinSalaries') > -1) {
                $scope.minMaxValidations.setMinSalaries($scope.movement.data.sd).then(function () {
                  setMinSalaries();
                });
              }
            }
          }, true);
          break;
        case 'employeeEnroleDate':
          //Se observa la fecha de alta para establecer la fecha de antigüedad
          $scope.thisDetailWatchers.employeeEnroleDate = $scope.$watch('employee.data.enroleDate', function (enroleDate) {
            if (enroleDate) {
              $log.log('enroleDate changed');
              // if ($scope.F.active.menuAction !== 'specialEdit' || ($scope.F.active.menuAction !== 'specialEdit' && [6, 8].indexOf($scope.movement.data.type) > -1)) {
              if (actions.indexOf('setMovementDate') > -1) {
                $scope.movement.data.date = enroleDate;
              }
              if (actions.indexOf('setMinSeniorityDate') > -1) {
                var thisDate = moment(enroleDate - $scope.F.oneDay);
                $scope.enroleDateJS = moment(thisDate).toDate();
                var value = $filter('pathInObj')($filter('clearObject')($scope.employee), 'data.seniorityDate');
                if (value && $scope.employee.data.seniorityDate > $scope.enroleDateJS.valueOf() && $scope.F.active.menuAction !== 'especialEdit') {
                  delete $scope.employee.data.seniorityDate;
                }
              }
            }
          });
          break;
        case 'employeeDissmissDate':
          //Se observa la fecha de alta para establecer la fecha de antigüedad
          $scope.thisDetailWatchers.employeeDissmissDate = $scope.$watch('employee.data.dismissDate', function (dismissDate, oldDismissDate) {
            if (dismissDate && dismissDate !== oldDismissDate) {
              $scope.movement.data.date = dismissDate;
            }
          });
          break;
        case 'employeeMdsDate':
          //Se observa la fecha de alta para establecer la fecha de antigüedad
          $scope.thisDetailWatchers.employeeMdsDate = $scope.$watch('employee.data.mdsDate', function (mdsDate, oldMdsDate) {
            if (mdsDate && mdsDate !== oldMdsDate) {
              $scope.movement.data.date = mdsDate;
            }
          });
          break;
        case 'minimunBenefits':
          //Si se selecciona que no se quieren editar las prestaciones regresa al que tiene por default
          $scope.thisDetailWatchers.minimunBenefits = $scope.$watch('employee.customBenefits', function (value, oldValue) {
            if (!value && value !== oldValue) {
              $log.log('customBenefits changed');
              checkBenefit();
            }
          });
          break;
        case 'employeeNames':
          //Se observa sus apellidos y nombres para setear su nombre completo
          $scope.thisDetailWatchers.employeeNames = $scope.$watchGroup(['employee.data.info.paternalSurname', 'employee.data.info.maternalSurname', 'employee.data.info.names'], function (names) {
            if (names[0] || names[1] || names[2]) {
              $log.log('name changed');
              var thisName = $filter('getCompoundData')(names);
              if (angular.isString(thisName)) {
                $scope.employee.data.name = thisName;
              }
            }
          });
          break;
        case 'movementVariables':
          //Se observa el sd por si cambia para estabelcer los salarios minimos
          $scope.thisDetailWatchers.movementVariables = $scope.$watchGroup(['movement.data.sd', 'movement.data.date', 'movement.data.onlySd'], function (newVal, oldVal) {
            if (newVal[0] !== oldVal[0] || newVal[1] !== oldVal[1] || newVal[2] !== oldVal[2]) {
              $log.log('sd or date or onlySd of movement changed');
              // if (['especialEdit', 'aniversariesRecords', 'mds'].indexOf($scope.F.active.menuAction) > -1 || $scope.F.active.menuName === 'enroles') {
              if (actions.indexOf('setMinSalaries') > -1) {
                $scope.minMaxValidations.setMinSalaries($scope.movement.data.sd).then(function () {
                  setMinSalaries();
                });
              }
              var idEmpleado = $state.params.employeeId;
              if (actions.indexOf('validateEmployeeIncidences') > -1 && newVal[1]) {
                //Verificar si hay incidencias que afectan días a partir de fecha de baja para bloquear formulario y mandar alerta si las hay
                //Se suma un día en la fecha seleccionada para validar la baja
                var d = moment(newVal[1]);
                var newDate = d.add('1', 'days');
                $rootScope.loadingProgress = true;
                if (angular.isUndefined(idEmpleado)) {
                  idEmpleado = $scope.movement.employee;
                }
                if (angular.isUndefined(idEmpleado)) {
                  idEmpleado = $scope.employee.$id;
                }
                $scope.D.models.action('incidences', 'isThereIncidencesFromDate', {
                  date: newDate.valueOf(),
                  validateOnly: 'd',
                  employeeId: idEmpleado,
                  payrollId: $scope.employee.payroll
                }).then(function (response) {
                  if (!response.data.message) {
                    // todo bien
                    $log.log('todo bien respuesta de la incidencia', response.data.message)
                  } else {
                    // alertar y bloquear formulario
                    errAlertS(response.data.message);
                    $scope.movement.data.date = null;
                  }
                  $rootScope.loadingProgress = false;
                  $rootScope.$evalAsync();
                }).catch(function (err) {
                  errAlertS(err);
                  $rootScope.loadingProgress = false;
                  $rootScope.$evalAsync();
                });
              }
              if (actions.indexOf('validateEmployeeIncapacities') > -1 && newVal[1]) {
                // Verificar si hay incidencias que afectan días a partir de fecha de baja para bloquear formulario y mandar alerta si las hay
                //Se suma un día en la fecha seleccionada para validar la baja
                var fecha = newVal[1];
                $rootScope.loadingProgress = true;
                if (angular.isUndefined(idEmpleado)) {
                  idEmpleado = $scope.movement.employee;
                }
                if (angular.isUndefined(idEmpleado)) {
                  idEmpleado = $scope.employee.$id;
                }
                $log.log('este es el id del empleado', idEmpleado);
                checkDisabilitiesEmployeeFilter(idEmpleado, fecha).then(function (response) {
                  $log.log('datos', response)
                  if (!response) {//Si no hay no hace nada y si hay debe borrar la fecha y mandar un mensaje que en esa fecha el empleado tiene incapacidades
                    $log.log('excelente');
                  } else {
                    errAlertS('No se puede seleccionar esta fecha, por que existe incapacidades');
                    $scope.movement.data.date = null;
                  }
                  $rootScope.loadingProgress = false;
                  $rootScope.$evalAsync();
                }).catch(function (err) {
                  errAlertS(err);
                  $rootScope.loadingProgress = false;
                  $rootScope.$evalAsync();
                });
              }
              if (actions.indexOf('setEnroleDate') > -1 && newVal[1]) {
                $scope.employee.data.enroleDate = $scope.movement.data.date;
              }
            }
          });
          break;
      }
    }



    var initWatchers = function () {
      var watchers = {};
      var menuAction = $scope.F.active.menuAction;
      var menuName = $scope.F.active.menuName;
      // var posibleWatchers = {
      //     datesVariables: true,
      //     employeeRp: true,
      //     benefit: ['setBenefit', 'setHolidayTable', 'setMinSalaries'],
      //     employeeEnroleDate: ['setMovementDate', 'setMinSeniorityDate'],
      //     minimunBenefits: true,
      //     employeeNames: true,
      //     movementVariables: ['setMinSalaries', 'validateEmployeeIncidences', 'setEnroleDate','validateEmployeeIncapacities'],
      //     employeeDissmissDate: true,
      //     employeeMdsDate: true
      // };
      var movementType = $scope.movement.data.type;
      if (menuAction === 'dismiss' || (movementType === 2 && menuName === 'idseAutoRecords')) {
        watchers.movementVariables = ['validateEmployeeIncidences'];
      }
      if (menuAction === 'mds' || menuAction === 'apply' || (movementType === 7 && menuName === 'idseAutoRecords')) {
        watchers.movementVariables = ['setMinSalaries', 'validateEmployeeIncapacities'];
      }
      if (['especialEdit', 'reEntry', 'enrole'].indexOf(menuAction) > -1 || ([6, 8].indexOf(movementType) > -1 && menuName === 'idseAutoRecords')) {
        watchers.employeeRp = true;
        watchers.minimunBenefits = true;
        watchers.employeeNames = true;
        watchers.movementVariables = ['setMinSalaries'];
      }
      if (menuAction === 'especialEdit') {
        watchers.datesVariables = true;
        watchers.benefit = ['setBenefit', 'setHolidayTable', 'setMinSalaries'];
        watchers.employeeEnroleDate = ['setMinSeniorityDate'];
        if ([6, 8].indexOf($scope.movement.data.type) > -1) {
          watchers.employeeEnroleDate.push('setMovementDate');
        }
        if ($scope.movement.data.type === 2) {
          watchers.employeeDissmissDate = true;
        } if ($scope.movement.data.type === 7) {
          watchers.employeeMdsDate = true;
        }
      }
      if (['reEntry', 'enrole'].indexOf(menuAction) > -1 || ([6, 8].indexOf(movementType) > -1 && menuName === 'idseAutoRecords')) {
        watchers.employeeEnroleDate = ['setMovementDate', 'setMinSeniorityDate'];
        watchers.benefit = ['setBenefit', 'setHolidayTable'];
      }
      if (['enroles', 'mdsRecords'].indexOf(menuName) > -1 || ([6, 8, 7].indexOf(movementType) > -1 && menuName === 'idseAutoRecords')) {
        watchers.datesVariables = true;
        watchers.benefit = ['setBenefit', 'setHolidayTable', 'setMinSalaries'];
        watchers.minimunBenefits = true;
        watchers.movementVariables = ['validateEmployeeIncapacities'];
      }
      if (menuName === 'enroles' || ([6, 8].indexOf(movementType) > -1 && menuName === 'idseAutoRecords')) {
        watchers.employeeEnroleDate = ['setMinSeniorityDate'];
        watchers.movementVariables = ['setMinSalaries', 'setEnroleDate'];
        watchers.employeeNames = true;
      }
      if (menuName === 'mdsRecords' || (movementType === 7 && menuName === 'idseAutoRecords')) {
        watchers.movementVariables = ['setMinSalaries', 'validateEmployeeIncapacities'];
      }
      if (menuName === 'dismissesRecords' || (movementType === 2 && menuName === 'idseAutoRecords')) {
        watchers.movementVariables = ['validateEmployeeIncidences'];
      }
      if (menuName === 'employees' && menuAction === 'update') {
        watchers.benefit = ['setHolidayTable'];
        watchers.employeeEnroleDate = ['setMinSeniorityDate'];
        watchers.datesVariables = true;
        watchers.benefit = ['setBenefit', 'setMinSalaries'];
      }
      for (var watcher in watchers) {
        if (watchers.hasOwnProperty(watcher)) {
          initWatcher(watcher, watchers[watcher]);
        }
      }
    };

    function setEmployeeToMovement() {
      $scope.movement.data = $scope.employee.movement;
      if (angular.isDefined($scope.employee.movement.batch)) {
        if (angular.isUndefined($scope.movement.received)) { $scope.movement.received = {}; }
        $scope.movement.received.batch = $scope.employee.movement.batch;
      }
      if (angular.isDefined($scope.employee.movement.archiveDate)) {
        if (angular.isUndefined($scope.movement.archived)) { $scope.movement.archived = {}; }
        $scope.movement.archived.date = $scope.employee.movement.archiveDate;
      }
    }

    function setMovementToEmployee() {
      $scope.employee.cc = $scope.movement.cc;
      $scope.employee.payroll = $scope.movement.payroll;
      $scope.employee.rp = $scope.movement.rp;
      $scope.employee.data.salary.type = $scope.movement.data.salaryType;
      $scope.employee.data.salary.sdr = $scope.movement.data.sdr;
      $scope.employee.data.nss = $scope.movement.info.nss || null;
      $scope.employee.data.comments = $scope.movement.data.comments;
      $scope.employee.data.workerType = $scope.movement.data.workerType;
    }


    // Asegura estructura
    $scope.employee = $scope.employee || { data: { salary: {} } };
    $scope.F = $scope.F || { active: {} };
    $scope.M = $scope.M || { salaryTypes: [] };

    $scope.$watchGroup(
      ['M.salaryTypes.length', 'F.active.menuAction', 'employee.data.salary.type'],
      function () {
        if (!$scope.M.salaryTypes || !$scope.M.salaryTypes.length) return;
        var mixto = $scope.M.salaryTypes.find(function (s) { return s.name === '2-Mixto'; });
        if (!mixto) return;
        $log.log($scope.F.active.menuAction)
        if ($scope.F.active.menuAction === 'enrole' || $scope.F.active.menuAction === 'reEntry') {
          if ($scope.employee.data.salary.type !== mixto.humansiteCode) {
            $scope.employee.data.salary.type = mixto.humansiteCode;
          }
          return;
        }
        if (!$scope.employee.data.salary.type) {
          $scope.employee.data.salary.type = mixto.humansiteCode;
        }
      }
    );


    $scope.validateWorkerType = function () {
      $log.log($scope.F.active.menuAction);
      var invalidChange = angular.isDefined(originalWorKerType) && originalWorKerType === 1 && $scope.employee.data.workerType !== originalWorKerType && $scope.F.active.menuAction !== 'especialEdit' && $scope.F.active.menuAction !== 'reEntry';
      if (invalidChange && [6, 8].indexOf($scope.employee.movement.type) > -1) {
        invalidChange = false;
      }
      if (invalidChange) {
        $scope.employee.data.workerType = originalWorKerType;
        errAlertS('No se puede seleccionar un tipo de trabajador diferente al actual');
      } else {
        $filter('getContractTypes')($scope);
      }
    };
    $scope.validateContractType = function () {
      if (angular.isDefined(originalContractId)) {
        var originalContractType = $scope.allDocumentTypes.find(function (item) {
          return item._id === originalContractId;
        });
        var thisContractType = $scope.allDocumentTypes.find(function (item) {
          return item._id === $scope.employee.contractType;
        });
        $log.log(originalContractType, thisContractType);
      }
    };

    var allReady = false;
    var redirectTo;
    var init = function () {
      redirectTo = $stateParams.redirectTo;
      $rootScope.loadingProgress = true;
      initiated = true;
      getEmployee().then(function () {
        $rootScope.loadingProgress = true;
        checkActionStatus();
        checkParams();
        var needed = [];
        needed.push($scope.dataNeededPromise);
        needed.push($scope.statesObjsPromise);
        needed.push($filter('getBenefitsOfItem')($scope.employee));
        needed.push(getLastApprovedMovementOfEmployee());
        needed.push(setApplyVariables());
        needed.push(getZipCodeObj());
        return Promise.all(needed);
      }).then(function (resp) {
        if ((!$scope.F.addMode) && $scope.employee.center !== $scope.F.center) {
          throw 'el empleado no pertenece a esta empresa'
        }
        $scope.editArchived = $filter('userHasPermission')($scope.F.groupsOfUser, $scope.F.permissions, 'update', 'movements.movements');
        if ($scope.F.active.menuAction === 'especialEdit' && $scope.movement.status > 2) {
          setEmployeeToMovement();
        }
        if (["idseAutoRecords", "movements"].indexOf($scope.F.active.menuName) > -1) {
          setMovementToEmployee();
        }
        $rootScope.loadingProgress = true;
        if (angular.isUndefined($scope.movement)) {
          $scope.movement = {};
        }
        if (angular.isUndefined($scope.movement.data)) {
          $scope.movement.data = {};
        }
        originalCc = $scope.employee.cc;
        originalRp = $scope.employee.rp;
        originalEnroleDate = $scope.employee.data.enroleDate;
        originalWorKerType = $scope.employee.data.workerType;
        originalContractId = $scope.employee.contractType;
        if (['idseAutoRecords'].indexOf($scope.F.active.menuName) > -1) {
          $filter("loopEach")(originalMovData, function (item, index) {
            var thisValue = $filter('getFromObject')($scope.movement, item.path);
            originalMovData[index].original = thisValue;
          });
        }
        $scope.benefit = resp[2];
        if (angular.isUndefined($scope.benefit.christmasBonusTable)) {
          $scope.benefit.christmasBonusTable = [];
        }
        $log.log('about to set default values');
        setDefaultValues();
        $log.log('calling state changed');
        $scope.stateUpdated();
        $log.log('about to set payroll and cc');
        $rootScope.loadingProgress = true;
        $log.log('settingMaxMinValidations');
        setMinMaxValidations().then(function () {
          return $scope.payrollUpdated(true);
        }).then(function () {
          return $scope.ccUpdated(true);
        }).then(function () {
          validadorReingreso();
          if (['especialEdit'].indexOf($scope.F.active.menuAction) > -1 || ['idseAutoRecords'].indexOf($scope.F.active.menuName) > -1) {
            $scope.isManualEntry = true;
          }
          allReady = true;
          initWatchers();
          $rootScope.loadingProgress = false;
          $rootScope.$evalAsync();
          $timeout(function () { })
        });
      }).catch(function (error) {
        if (error === 'Registro inexistente') {
          $scope.goToList();
        } else {
          errAlertS('No se pudieron cargar los datos intente recargas la pagina');
        }
        $log.error('Error al obtener los datos del empleado o el movimiento', error);
        $rootScope.loadingProgress = false;
        $rootScope.$evalAsync();
        $timeout(function () { })
      });
    };
    var inicio = false;
    function validadorReingreso() {
      if (!inicio && $scope.F.active.menuAction === 'reEntry') {
        inicio = true;
        var ultimoMovimiento = $scope.lastApprovedMovement;
        var reingreso = ultimoMovimiento.data.rehirable;
        if ($state.params.forCurp) {
          $scope.employee.cc = undefined;
          $scope.employee.payroll = undefined;
        }
        if (reingreso === true) {
          $log.log('si es o no es recontratable');
        } else {
          var title = "Este es un empleado no recontratable por este motivo " + $scope.lastApprovedMovement.data.motive;
          $mdDialog.show($mdDialog
            .confirm(confirmConfig)
            .title(title)
            .htmlContent('¿Desea continuar?')
            .ariaLabel('Deleting')
            .ok('SI')
            .cancel('NO'))
            .then(function () {
              $log.log('Accedió a un usuario no recontratable')
            }, function () {
              $scope.goToList();
            });
        }
      }
    }
    $scope.setJobDescription = function () {
      $log.log($scope.employee.data.jobDescription, $scope.F.active.menuAction);
      if ($scope.F.active.menuAction === 'reEntry') {
        delete $scope.employee.data.jobDescription;
      }
    }
    $scope.showListPending = function (event, form) {
      checkValidFieldsModalFilter(event, form);
    }
    $scope.cpSelected = function (cpSelected) {
      if (angular.isObject(cpSelected)) {
        if (angular.isUndefined($scope.employee.data.info)) {
          $scope.employee.data.info = {};
        }
        if (angular.isUndefined($scope.employee.data.info.residence)) {
          $scope.employee.data.info.residence = {};
        }
        if (angular.isUndefined($scope.employee.data.info.residence.address)) {
          $scope.employee.data.info.residence.address = {};
        }
        $scope.employee.data.info.residence.state = cpSelected.stateId;
        $scope.employee.data.info.residence.town = cpSelected.townId;
        $scope.employee.data.info.residence.address.neighborhood = cpSelected.name;
        $scope.employee.data.info.residence.address.zipCode = cpSelected.cp;
        $scope.employee.data.info.residence.address.zipCodeId = cpSelected._id;
        $scope.stateUpdated();
      }
      $log.log(cpSelected);
    };
    function sendMovementIDSE(movement, movementId) {
      return new Promise(function (resolve) {
        var title;
        var msg;
        var showAskModal
        var promises = [];
        if (movement.received.batch) {
          title = 'Recibir movimiento de IDSE';
          msg = 'El movimiento ha sido editado con éxito, ¿Desea continuar con la recuperación del lote?';
          showAskModal = true;
        } else {
          title = 'Enviar movimiento a IDSE';
          msg = 'El movimiento ha sido editado con éxito ¿Desea reenviar el movimiento?';
          showAskModal = true;
        }
        if (showAskModal) {
          var promiseAsk = $mdDialog.show($mdDialog
            .confirm(confirmConfig)
            .title(title)
            .htmlContent(msg)
            .ariaLabel('success')
            .cancel('No, ya se ha validado la información')
            .ok('Sí'))
          promises.push(promiseAsk);
        }
        Promise.all(promises).then(function (resp) {
          promises = [];
          if (resp.length > 0) {
            var params = { ids: [movementId], batch: movement.received.batch, forceAnyStatus: true };
            if (movement.received.tempBatch) {
              params.tempBatch = movement.received.tempBatch;
            }
            promises.push($scope.D.models.action('movements', 'sendMovementsV2', params));
          }
          return Promise.all(promises)
        }).then(function () {
          resolve(false);
        }).catch(function (error) {
          if (error) { errAlertS(error) }
          resolve(false);
        })
      })
    }
    function redirectToApprove(movement, employeeId, movementId) {
      return new Promise(function (resolve) {
        $timeout(function () {
          var msg = '¿Desea continuar con la aprobación del movimiento?';
          var title = movement.data.type === 8 ? 'Se realizó el pre-reingreso del empleado con éxito.' : 'Se realizó la pre-alta del empleado con éxito.';
          var promiseAsk = $mdDialog.show($mdDialog
            .confirm(confirmConfig)
            .title(title)
            .htmlContent(msg)
            .ariaLabel('success')
            .cancel('No, mantener en revisión')
            .ok('Sí'));
          promiseAsk.then(function () {
            $log.log('datos que trar 2')
            $log.log({ employeeId: employeeId, movementId: movementId, redirectTo: $scope.R.states.fb.employees.list })
            var redirectParams = { employeeId: employeeId, movementId: movementId, redirectTo: $scope.R.states.fb.employees.list }
            $state.go($scope.R.states.fb.revisions.review, redirectParams);
            resolve(true);
          }).catch(function () {
            resolve(false)
          })
        }, 2500, false);
      })
    }
    function executeExtraTasks(afterTasks) {
      return new Promise(function (resolve) {
        var promises = [];
        if (angular.isArray(afterTasks)) {
          for (var t = 0; t < afterTasks.length; t++) {
            var thisC = afterTasks[t];
            promises.push(thisC.fn(thisC.param))
          }
        }
        Promise.all(promises).then(function () {
          resolve()
        }).catch(function (error) {
          errAlertS(error);
          resolve()
        });
      })
    }
    function sendNotification(dataNeededByTemplate, type, employee, movementId, saveOptions) {
      new Promise(function (resolve) {
        var action = $filter('typeName')(type, false, true);
        var thisPromises = [];
        if (['idseAutoRecords'].indexOf($scope.F.active.menuName) === -1) {
          thisPromises.push($scope.F.notifyUsers('movement', action, employee.status, movementId, employee, saveOptions.dontSendMail, dataNeededByTemplate))
        }
        Promise.all(thisPromises).then(function () {
          resolve(true);
        }).catch(function (error) {
          $log.error(error);
          resolve(false);
        });
      })
    }
    var saveAllAndNotify = function (employee, employeeId, movement, movementId, saveOptions, extraUpdates, afterTasks) {
      var successMsg = saveOptions.msg;
      $log.log(employee, movement);
      return new Promise(function (resolve, reject) {
        //importante agregar el id al objeto para consulta de otros métodos getEmployeeDData y getBenefit;
        employee.$id = employeeId;
        var promises = [
          $filter('getEmployeeDataObjects')(employee)
        ];
        if (['reEntry', 'enrole', 'especialEdit'].indexOf($scope.F.active.menuAction) > -1 || $scope.F.active.menuAction === 'update' && $scope.F.active.menuName === 'employees') {
          promises.push($scope.F.saveBenefitOfEmployee($filter('getBenefitsOfItem')(employee), $scope.benefit, employeeId, $scope.D.getTimeObject(), !$scope.fiscalMovement, true));
        }
        Promise.all(promises).then(function (resp) {
          $log.log('Se termino de guardar prestaciones y/o obtener datos para notificar')
          //importante eliminar el id del empleado tras consulta para evitar fallos al momento de insertar con el update;
          delete employee.$id;
          var dataNeededByTemplate = resp[0];
          var updates = {};
          if ((!saveOptions.dontUpdate) || saveOptions.dontUpdate !== 'movement') {
            updates['movements/collection/' + movementId] = movement;
          }
          if ((!saveOptions.dontUpdate) || saveOptions.dontUpdate !== 'employee') {
            updates['employees/collection/' + employeeId] = employee;
          }
          if (typeof (extraUpdates) == 'object') {
            for (var path in extraUpdates) {
              if (extraUpdates.hasOwnProperty(path)) {
                updates[path] = extraUpdates[path];
              }
            }
          }
          //en caso de haber solicitado el guardado de los beneficios se añade el guardado al update;
          if (angular.isObject(resp[1])) {
            for (var index in resp[1]) {
              if (resp[1].hasOwnProperty(index)) {
                updates[index] = resp[1][index];
              }
            }
          }
          $scope.F.root.child('catalogs').update(updates).then(function () {
            $log.log("Se termino de guardar datos de empleado y movimiento")
            var p = [sendNotification(dataNeededByTemplate, movement.data.type, employee, movementId, saveOptions)];
            if ((($scope.F.active.menuAction === "especialEdit" && $scope.F.active.menuName === "employees") || ($scope.F.active.menuAction === "update" && $scope.F.active.menuName === "enroles")) && originalEnroleDate !== employee.data.enroleDate && (employee.movement.type == 6 || employee.movement.type == 8) && employee.status < 3) {
              p.push(checkForAddingPendingDaysFilter(employee, employeeId, movementId));
            }
            Promise.all(p).then(function (resp) {
              $log.log("Se termino de notificar y de verificar días pendientes de pago")
              if (resp.length > 1) {
                var posiblesMsg = [
                  undefined,
                  "Se guardó el Empleado y Movimiento con éxito y se generaron las incidencias pendientes de pago automáticamente",
                  "Se guardó el Empleado y Movimiento con éxito pero no se generaron las incidencias pendientes de pago automáticamente, hacer manual esta operación",
                  "Se guardó el Empleado y Movimiento con éxito",
                  "Se guardó el Empleado y Movimiento con éxito pero no se encontraron calendarios para el empleado",
                  "Se guardó el Empleado y Movimiento con éxito pero no se encontraron operaciones abiertas para este empleado",
                  "Se guardó el Empleado y Movimiento con éxito pero no se modificaron las incidencias pendientes de pago, verificar esto manualmente",
                  "Se guardó el Empleado y Movimiento con éxito pero no se eliminaron las incidencias pendientes de pago, porque ya se encuentra en un periodo cerrado"
                ]
                successMsg = angular.isNumber(resp[1]) && angular.isDefined(posiblesMsg[resp[1]]) ? posiblesMsg[resp[1]] : resp[1];
              }
              successAlertS(successMsg);
              return executeExtraTasks(afterTasks);
            }).then(function () {
              $log.log("Se termino de ejecutar tareas extras")
              $rootScope.loadingProgress = false;
              $rootScope.$evalAsync(function () { });
              var promise = [];
              var rev = $filter('userHasPermission')($scope.F.groupsOfUser, $scope.F.permissions, 'review', 'movements.revisions');
              $log.log($scope.F.active.menuName, originalMovData.status.original, movement.status);
              if (saveOptions.askRedirection && rev) {
                $log.log('va a redireccionar a aprobar')
                $log.log(movement);
                $log.log(employee);
                promise = redirectToApprove(movement, employeeId, movementId);
              } else if (['idseAutoRecords'].indexOf($scope.F.active.menuName) > -1) {
                promise = sendMovementIDSE(movement, movementId)
              } else {
                promise = new Promise(function (resolve) { resolve(false) });//Fix para que no se quede cargando
              }
              return promise;
            }).then(function (noRedirectToList) {
              $log.log("Se termino de re-direccionar o de enviar/recibir mov de IDSE")
              if (!noRedirectToList) {
                $scope.goToList();
              }
              resolve(true);
            }).catch(function (err) {
              errAlertS(err);
            });
          }).catch(function (err) {
            errAlertS(err);
            $rootScope.loadingProgress = false;
            $rootScope.$evalAsync();
            reject(err);
          });
        }).catch(function (err) {
          errAlertS(err);
          $rootScope.loadingProgress = false;
          $rootScope.$evalAsync();
          reject(err);
        });
      });
    };
    function enroleEmployee(employee, employeeId, movement, movementId, movementType) {
      if (!employee.rp) {
        errAlertS('El Centro de Costo no tiene Registro Patronal, favor de asignarle uno antes de hacer ésta operación');
        $rootScope.loadingProgress = false;
        $rootScope.$evalAsync();
        return false;
      } else {
        $rootScope.$broadcast('stopDetailWatchers');
        // se escribe el humansiteCode en vez del id de mongo para tener compatibilidad en los 3 campos

        $log.log('datos de reingreso', employee);
        employee.data.salary.type = 2; // 0-fijo 1-variable 2-mixto
        // employee.data.workDay = 0;
        // employee.data.workerType = 0; // por default 0
        if (movementType === 8) {
          delete employee.data.dismissDate;
          delete employee.data.mdsDate;
        }
        movement.status = 1; // movement inits
        if (typeof (movement.data) === 'undefined') {
          movement.data = {};
        }
        movement.data.type = movementType;//movement type
        movement = $filter('prepareMovement')(movement, movementId, employee, employeeId, true);
        employee = $filter('prepareEmployee')(employee, employeeId, movement, movementId, movementType === 6, true);
        var tasks = [];
        tasks.push({ fn: $scope.F.setLastCertificateForNewEmployees, param: employeeId })
        tasks.push({ fn: $scope.F.setLastEmployeeNumber, param: employeeId })
        var saveOptions = {
          msg: 'Se creó empleado con éxito, se le notificará cuando un ejecutivo revise su solicitud de alta.',
          askRedirection: true
        }
        saveAllAndNotify(employee, employeeId, movement, movementId, saveOptions, undefined, tasks);
      }
    }
    /** Alta de empleado */
    $scope.enrole = function (employee) {
      $rootScope.loadingProgress = true;
      var employeeId = $scope.F.root.child('catalogs/employees/collection').push().key;
      employee = $filter('clearObject')(employee);
      var movementId = $scope.F.root.child('catalogs/movements/collection').push().key;
      var movement = $filter('clearObject')($scope.movement);
      enroleEmployee(employee, employeeId, movement, movementId, 6);
    };
    /** Reingreso de empleado */
    $scope.reEntry = function (employee) {
      $rootScope.loadingProgress = true;
      var employeeId = employee.$id;
      delete employee.vacationsEvents;
      employee = $filter('clearObject')(employee);
      var movementId = $scope.F.root.child('catalogs/movements/collection').push().key;
      var movement = $filter('clearObject')($scope.movement);
      enroleEmployee(employee, employeeId, movement, movementId, 8);
    }
    /** MDS de empleado */
    $scope.mds = function () {
      $rootScope.loadingProgress = true;
      $rootScope.$broadcast('stopDetailWatchers');
      var employeeId = $scope.employee.$id;
      var employee = $filter('clearObject')($scope.employee);
      var movementId = $scope.F.root.child('catalogs/movements/collection').push().key;
      var movement = $filter('clearObject')($scope.movement);
      $rootScope.$broadcast('stopDetailWatchers');
      movement.status = 2;
      if (typeof (movement.data) === 'undefined') {
        movement.data = {};
      }
      movement.data.type = 7;
      movement = $filter('prepareMovement')(movement, movementId, employee, employeeId, true);
      employee = $filter('prepareEmployee')(employee, employeeId, movement, movementId, false, true);
      var saveOptions = {
        msg: 'Se mandó la modificación de salario con éxito.',
        dontSendMail: (movement.data.hasOwnProperty('aniversary') || ($scope.aniversaryRecord && $scope.F.active.menuName === 'aniversaryRecords')) ? true : false
      }
      saveAllAndNotify(employee, employeeId, movement, movementId, saveOptions);
    };


    function disableContracts(employeeId) {
      $log.log('Esto es una prueba a ver si pasa por disableContracts');
      var contractIds = MongoF.documentTypes.filter(function (item) {
        return item.type === 'contract';
      }).map(function (item) {
        return item._id;
      })

      return $scope.D.api.get('documents', { employee: employeeId, documentType: angular.toJson({ $in: contractIds }) })
        .then(function (resp) {
          if (!resp.data || !resp.data.length) {
            throw new Error('No se encontraron documentos para el empleado');
          }
          var idContract = resp.data[0]._id;
          return $scope.D.api.update('documents', idContract, { active: false });
        })
        .then(function (resp) {
          $log.log(resp);
          return true;
        })
        .catch(function (error) {
          $log.log(error);
        });
    }

    /** Baja de empleado */
    $scope.dismiss = function () {
      $rootScope.loadingProgress = true;
      var employeeId = $scope.employee.$id;
      var employee = $filter('clearObject')($scope.employee);
      var movementId = $scope.F.root.child('catalogs/movements/collection').push().key;
      var movement = $filter('clearObject')($scope.movement);
      $rootScope.$broadcast('stopDetailWatchers');
      movement.status = 2;
      if (!$scope.fiscalMovement) {
        movement.status = 4;
      }
      var dismissConfig = $scope.M.dismissTypes.find(function (item) {
        return item._id === movement.data.dismissType;
      });
      if (dismissConfig.defaultStatus) {
        movement.status = dismissConfig.defaultStatus;
      }
      if (typeof (movement.data) === 'undefined') {
        movement.data = {};
      }
      movement.data.type = 2;
      if (employee.data) {
        if (employee.data.health) {
          if (employee.data.health.benefit) { employee.data.health.endDate = moment().valueOf(); }
        }
      }
      movement = $filter('prepareMovement')(movement, movementId, employee, employeeId, true);
      employee = $filter('prepareEmployee')(employee, employeeId, movement, movementId, false, true);
      var saveOptions = {
        msg: 'Se mandó la baja con éxito.',
        dontSendMail: (dismissConfig.disableNotification ? true : false)
      }
      cleanIsrAnual();
      saveAllAndNotify(employee, employeeId, movement, movementId, saveOptions, undefined, [{ fn: disableContracts, param: employeeId }]);
    };

    function cleanIsrAnual() {
      var update = {};
      var query = { key: "anualIsr", center: $scope.employee.center, project: angular.toJson({ fid: 1 }) };
      $log.log('query1', query)
      $rootScope.D.api.get('concepts', query).then(function (resp) {
        var data = resp.data || [];
        var fidConcetps = data.map(function (c) { return c.fid; });

        $log.log('fidConcetps ya lleno', fidConcetps);

        var query2 = {
          employee: $scope.employee.$id,
          status: angular.toJson({ $gte: 0, $lt: 3 }),
          incidenceType: angular.toJson({ $in: fidConcetps })
        };

        return $rootScope.D.api.get('incidences', query2);
      }).then(function (resp) {
        $log.log('incidencias', resp);

        var incidences = resp.data || [];
        if (incidences.length > 0) {
          for (var i = 0; i < incidences.length; i++) {
            var inc = incidences[i];
            update['incidences/' + inc.payroll + '/' + inc.calendar + '/' + inc.fid + '/status'] = -4;
            update['incidences/' + inc.payroll + '/' + inc.calendar + '/' + inc.fid + '/comments'] = 'incidencia rechazada desde la baja';
          }

          return $scope.F.root.update(update);
        } else {
          $log.log('No tiene para desactivar el isr anual', $scope.employee);
        }
      }).then(function (resp) {
        if (resp) $log.log('se actualizo correctamente', resp);
      }).catch(function (err) {
        $log.error('Error en cleanIsrAnual', err);
      });
    }




    /**Cuando se actualizan los datos del movimiento estando en módulos de IMSS */
    $scope.saveAndUpdateMovement = function (movement, employee) {
      $rootScope.loadingProgress = true;
      var employeeId = employee.$id;
      employee = $filter('clearObject')(employee);
      var movementId = movement.$id;
      movement = $filter('clearObject')(movement);
      $rootScope.$broadcast('stopDetailWatchers');
      movement = $filter('prepareMovement')(movement, movementId, employee, employeeId, false);
      employee = $filter('prepareEmployee')(employee, employeeId, movement, movementId, false, false);
      var saveOptions = {
        msg: 'Se actualizó el Movimiento y el Empleado con éxito.',
        dontSendMail: true
      }
      return saveAllAndNotify(employee, employeeId, movement, movementId, saveOptions);
    };
    /** Aplicar variable o aniversario */
    $scope.apply = function () {
      $rootScope.loadingProgress = true;
      $rootScope.$broadcast('stopDetailWatchers');
      var employeeId = $scope.employee.$id;
      var employee = $filter('clearObject')($scope.employee);
      var movementId = $scope.F.root.child('catalogs/movements/collection').push().key;
      var movement = $filter('clearObject')($scope.movement);
      movement.status = 2;
      movement.data.aniversary = true;
      movement.data.type = 7;
      movement.created = $scope.D.getTimeObject();
      movement = $filter('prepareMovement')(movement, movementId, employee, employeeId, true, true);
      employee = $filter('prepareEmployee')(employee, employeeId, movement, movementId, false, true);
      var saveOptions = {
        msg: 'Se mandó la modificación de salario con éxito',
        dontSendMail: true
      }
      saveAllAndNotify(employee, employeeId, movement, movementId, saveOptions);
    };

    function saveSpecial(action) {
      $rootScope.loadingProgress = true;
      $rootScope.$broadcast('stopDetailWatchers');
      var employeeId = $scope.employee.$id;
      var employee = $filter('clearObject')($scope.employee);
      var movementId = $scope.movement.$id;
      var movement = $filter('clearObject')($scope.movement);
      if (angular.isDefined(employee.movement.type)) {
        switch (employee.movement.type) {
          case 2:
            movement.data.date = angular.isDefined(employee.data.dismissDate) ? employee.data.dismissDate : null;
            break;
          case 6:
          case 8:
            movement.data.date = angular.isDefined(employee.data.enroleDate) ? employee.data.enroleDate : null;
            break;
          case 7:
            movement.data.date = angular.isDefined(employee.data.mdsDate) ? employee.data.mdsDate : null;
            break;
        }
      }
      var dontUpdateMovement = true;
      var dontUpdate = 'movement';
      var msg = 'Se guardo el Empleado con éxito';
      if (action === 'updateMovement') {
        dontUpdateMovement = false;
        dontUpdate = undefined;
        msg = 'Se guardó el Empleado y Movimiento con éxito';
        movement = $filter('prepareMovement')(movement, movementId, employee, employeeId, false);
      }
      employee = $filter('prepareEmployee')(employee, employeeId, movement, movementId, false, false, dontUpdateMovement);
      delete movement.data.batch;
      delete movement.data.archiveDate;
      delete movement.data.uid;
      var saveOptions = {
        msg: msg,
        dontSendMail: true,
        dontUpdate: dontUpdate
      }
      saveAllAndNotify(employee, employeeId, movement, movementId, saveOptions);
    }
    /** Edición especial */
    $scope.saveSpecial = function (ev) {
      if ($scope.movement.status > 2) {
        $mdDialog.show({
          locals: {
            editArchived: $scope.editArchived,
            confirmObj: {
              title: '¿Desea actualizar el movimiento?',
              content: 'Se editó el empleado con un movimiento ya enviado y/o archivado, desea actualizar la información del movimiento',
              options: {
                option1: {
                  text: 'Sí, actualizar el movimiento',
                  value: 'updateMovement'
                },
                option2: {
                  text: 'No, solo actualizar el empleado',
                  value: 'updateEmployee'
                }
              }
            }
          },
          controller: function (scope, $mdDialog, editArchived, confirmObj) {
            scope.confirmObj = confirmObj;
            scope.editArchived = editArchived;
            scope.close = function () {
              $mdDialog.cancel();
            };
            scope.confirm = function (response) {
              $mdDialog.hide(response);
            };
          },
          templateUrl: 'app/main/employees/dialogs/confirm-special-edit.html',
          parent: angular.element(document.body),
          targetEvent: ev
        }).then(function (answer) {
          saveSpecial(answer);
        }, function () {
          $log.debug('saveSpecial cancelled');
        });
      } else {
        saveSpecial('updateMovement');
      }
    };

    $scope.saveIdseAutoRecords = function () {
      var updateEmployee = ($scope.employee.movement.uid === $scope.movement.$id) ? 'updateEmployee' : undefined
      saveMiniMovements(updateEmployee);
    }

    function saveMiniMovements(action) {
      $rootScope.loadingProgress = true;
      $rootScope.$broadcast('stopDetailWatchers');
      var employeeNameObj = [$scope.employee.data.info.paternalSurname, $scope.employee.data.info.maternalSurname, $scope.employee.data.info.names];
      var employeeName = $filter('getCompoundData')(employeeNameObj);
      if (angular.isString(employeeName)) {
        $scope.employee.data.name = employeeName;
      }
      var employeeId = $scope.employee.$id;
      var employee = $filter('clearObject')($scope.employee);
      var movementId = $scope.movement.$id;
      var movement = $filter('clearObject')($scope.movement);
      movement = $filter('prepareMovement')(movement, movementId, employee, employeeId, false, false, true);
      var extraUpdates;
      var dontUpdate = 'employee';
      var msg = 'Se guardó el Movimiento con éxito';
      if (action === 'updateEmployee') {
        msg = 'Se guardó el Empleado y Movimiento con éxito';
        dontUpdate = undefined;
        employee = $filter('prepareEmployee')(employee, employeeId, movement, movementId, false, false);
      } else {
        extraUpdates = {};
        extraUpdates['employees/collection/' + employeeId + '/movements/' + movementId] = {
          p: movement.payroll,
          d: movement.data.date,
          s: movement.status,
          t: movement.data.type
        };
      }
      var saveOptions = {
        msg: msg,
        dontSendMail: true,
        dontUpdate: dontUpdate
      }
      saveAllAndNotify(employee, employeeId, movement, movementId, saveOptions, extraUpdates);
    }
    /** Edición especial*/
    $scope.saveMiniMovements = function (movement, ev) {
      $log.log($scope.employee);
      if ($scope.employee.movement.uid === movement.$id) {
        $mdDialog.show({
          locals: {
            editArchived: true,
            confirmObj: {
              title: '¿Desea actualizar al empleado?',
              content: 'Se edito el ultimo movimiento del empleado, desea que se actualice la información del empleado',
              options: {
                option1: {
                  text: 'Si, actualizar el empleado',
                  value: 'updateEmployee'
                },
                option2: {
                  text: 'No, solo actualizar el movimiento',
                  value: 'updateMovement'
                }
              }
            }
          },
          controller: function (scope, $mdDialog, editArchived, confirmObj) {
            scope.confirmObj = confirmObj;
            scope.editArchived = editArchived;
            scope.close = function () {
              $mdDialog.cancel();
            };
            scope.confirm = function (response) {
              $mdDialog.hide(response);
            };
          },
          templateUrl: 'app/main/employees/dialogs/confirm-special-edit.html',
          parent: angular.element(document.body),
          targetEvent: ev
        }).then(function (answer) {
          saveMiniMovements(answer);
        }, function () {
          $log.debug('saveMovement cancelled');
        });
      } else {
        saveMiniMovements();
      }
    };

    $scope.saveEmployee = function (employee) {
      $rootScope.loadingProgress = true;
      $rootScope.$broadcast('stopDetailWatchers');
      var employeeId = employee.$id;
      employee = $filter('clearObject')(employee);
      var movementId = $scope.movement.$id;
      var movement = $filter('clearObject')($scope.movement);
      employee.updated = $scope.D.getTimeObject();
      movement = $filter('prepareMovement')(movement, movementId, employee, employeeId, false);
      var saveOptions = {
        msg: 'Se actualizo empleado con éxito',
        dontSendMail: true
      }
      saveAllAndNotify(employee, employeeId, movement, movementId, saveOptions);
    };

    $scope.payrollUpdated = function (firstChange) {
      return new Promise(function (resolve, reject) {
        var payroll = $scope.employee.payroll;
        if (angular.isString(payroll)) {
          var payrollIsActive = getSomethingOfArrayFBFilter(payroll, $scope.L.allPayrolls, 'active');
          if (payrollIsActive || $scope.F.active.menuAction === 'especialEdit') {
            if (!firstChange) {
              delete $scope.employee.cc;
              //delete $scope.employee.rp;
              delete $scope.employee.data.position;
              delete $scope.employee.firm;
            }
            var promises = [];
            if (payroll) {
              promises.push($scope.L.loadList('ccs', 'lists/ccs/payroll', payroll, 'array', 'payrollCcs'));
              promises.push($scope.L.loadList('positions', 'lists/positions/payroll', payroll, 'array', 'payrollPositions'));
              promises.push($scope.L.loadList('payrolls', 'catalogs/payrolls/collection/' + payroll, undefined, 'object', 'payroll-' + payroll));
              promises.push($scope.L.loadList('departments', 'lists/departments/payroll', payroll, 'array', 'payrollDepartments'));
            }
            Promise.all(promises).then(function (resp) {
              $scope.payroll = resp[2];
              if ((!firstChange || typeof ($scope.employee.firm) === 'undefined')) {
                $scope.employee.firm = resp[2].firm;
              }
              var ccs = resp[0];
              var secondPromises = [];
              for (var c = 0; c < ccs.length; c++) {
                secondPromises.push($scope.L.loadList('rps', 'lists/rps/all', ccs[c]['rp_id'], 'object', 'rpCcs'));
              }
              if ($scope.payroll.specialServices) {
                secondPromises.push($scope.L.loadList('firms', 'catalogs/firms/collection/' + $scope.payroll.firm + '/companies', undefined, 'array', 'companiesOf-' + $scope.payroll.firm));
              }
              secondPromises.push($filter('getContractTypes')($scope));
              secondPromises.push($filter('getExtraFields')($scope.employee.firm));
              Promise.all(secondPromises).then(function (resp) {
                $scope.extraFields = resp.pop();
                if (!firstChange) {
                  checkBenefit();
                }
                var procesess = $filter("getFromObject")($scope.payroll, "processes", {});
                $scope.processes = [];
                $filter("loopEach")(procesess, function (process, processName) {
                  if (process.id) {
                    $scope.processes.push({ id: process.id, name: processName });
                  }
                });
                resolve(true);
              }).catch(reject);
            }).catch(reject);
          } else {
            if ($scope.F.addMode) {
              errAlertS('La nómina pre-seleccionada no está activa');
              delete $scope.employee.payroll;
              delete $scope.employee.cc;
              delete $scope.employee.rp;
              delete $scope.employee.data.position;
              delete $scope.employee.firm;
            }
            resolve(true);
          }
        } else {
          resolve(true);
        }
      });
    };
    $scope.ccUpdated = function (firstChange) {
      return new Promise(function (resolve, reject) {
        var cc = $scope.employee.cc;
        if (angular.isString(cc)) {
          var promises = [];
          if (cc) {
            promises.push($scope.L.loadList('ccs', 'catalogs/ccs/collection/' + cc + '/data', undefined, 'object', 'cc-' + cc));
          }
          Promise.all(promises).then(function (resp) {
            var doAction = true;
            $scope.cc = resp[0];
            if ($scope.F.active.menuAction === 'especialEdit') {
              if ($scope.employee.rp !== $scope.cc['rp_id']) {
                if ($scope.employee.movement.type !== 2 && $scope.employee.movement.type !== 6 && $scope.employee.movement.type !== 8) {
                  $log.log('no se puede porque no es ni alta ni reingreso ni baja');
                  $scope.employee.cc = originalCc;
                  $scope.employee.rp = originalRp;
                  errAlertS('Se detectó cambio de Registro Patronal, debe aplicar Baja y Alta');
                  doAction = false;
                } else if ($scope.employee.status >= 3 && $scope.employee.movement.type !== 2) {
                  $log.log('no se puede porque no el status es mayor a 3 es decir ya se envió y no es baja');
                  $scope.employee.cc = originalCc;
                  $scope.employee.rp = originalRp;
                  errAlertS('Se detectó cambio de Registro Patronal, debe aplicar Baja y Alta');
                  doAction = false;
                } else if ($scope.movement.data.type === 2 && $scope.employee.status < 4) {
                  $log.log('no se puede porque aunque esta de baja aun sigue en proceso de confirmación la baja');
                  $scope.employee.cc = originalCc;
                  $scope.employee.rp = originalRp;
                  errAlertS('Se detectó cambio de Registro Patronal, debe confirmar primero la baja');
                  doAction = false;
                }
              }
            }
            if (doAction) {
              if (typeof ($scope.employee.data) === 'undefined') { $scope.employee.data = {}; }
              if (typeof ($scope.employee.data.health) === 'undefined') { $scope.employee.data.health = {}; }
              $scope.employee.data.health.benefit = (angular.isObject($scope.cc) && $scope.cc.healthCare) ? true : false; // cc has health benefit
              var secondPromises = [];
              var rp = (angular.isObject($scope.cc) && typeof ($scope.cc['rp_id']) !== 'undefined') ? $scope.cc['rp_id'] : undefined;
              $scope.employee.rp = rp;
              if (typeof (rp) !== 'undefined') {
                secondPromises.push($scope.L.loadList('rps', 'lists/rps/all', rp, 'object', 'rpCcs'));
              }
              if ($scope.payroll.specialServices) {
                secondPromises.push($scope.L.loadList('rps', 'catalogs/rps/collection/' + $scope.employee.rp + '/companies', undefined, 'array', 'companiesOf-' + $scope.employee.rp));
              }
              Promise.all(secondPromises).then(function (secondResp) {
                $scope.rp = secondResp[0] ? secondResp[0] : {};
                var allRps = angular.isDefined($scope.L.payrollCcs) ? $scope.L.payrollCcs[$scope.employee.payroll] : [];
                if (!$scope.F.permissionToAccessAllPayrolls) {
                  1
                  allRps = $filter('filterUserCcs')(allRps, $scope.L.userCcs[$scope.F.profile.uid])
                }
                if ($scope.rp.rp === '00000000000') {
                  $scope.fiscalMovement = false;
                  delete $scope.employee.data.nss;
                  delete $scope.employee.data.health.umf;
                  delete $scope.movement.data.sd;
                  delete $scope.movement.data.sbc;

                } else {
                  $scope.fiscalMovement = true;
                }
                $scope.sameRps = allRps.filter(function (item) {
                  return $scope.L.rpCcs[item.rp_id].rp === $scope.rp.rp && item.valid;
                });
                if (!firstChange) {
                  checkBenefit();
                }
                if (angular.isObject($scope.cc)) {
                  $scope.geoZone = {};
                  var place = $scope.cc.place;
                  var placesOfWorkRecords = $scope.M.placesOfWorkRecords;
                  var geoZones = $scope.M.geoZones;
                  var geoZoneId = "";
                  if (angular.isDefined(place)) {
                    var filterPlacesOfWorkRecords = placesOfWorkRecords.filter(function (places) {
                      return places._id == place;
                    });
                    if (filterPlacesOfWorkRecords.length > 0 && angular.isDefined(filterPlacesOfWorkRecords[0].geoZone_id)) {
                      geoZoneId = filterPlacesOfWorkRecords[0].geoZone_id;
                      var filterGeoZones = geoZones.filter(function (geoZone) {
                        return geoZone._id == geoZoneId;
                      });
                      if (filterGeoZones.length > 0) {
                        $scope.geoZone = filterGeoZones[0];
                      } else {
                        errAlertS("No hay registros de zonas geográficas, favor de registrarlo");
                      }
                    } else {
                      errAlertS("En el lugar de trabajo no tiene asignado ninguna GeoZona, favor de asignarlos");
                    }
                  } else {
                    errAlertS("El centro de costo no tiene la plaza asignada");
                  }
                }
                var promises = [];
                $scope.minMaxValidations.geoZone = $scope.geoZone;
                if (angular.isDefined($scope.minMaxValidations) && allReady) {
                  promises.push($scope.minMaxValidations.setMinDates());
                  promises.push($scope.minMaxValidations.setMinSalaries($scope.movement.data.sd));
                }
                Promise.all(promises).then(function (resp) {
                  if (resp.length > 0) {
                    setMinDates();
                    setMinSalaries();
                  }
                  resolve(true);
                });
              }).catch(reject);
            }
          }).catch(reject);
        } else {
          delete $scope.employee.rp;
          resolve(true);
        }
      });
    };
    $scope.stateUpdated = function () {
      var value = $filter('pathInObj')($filter('clearObject')($scope.employee), 'data.info.residence.state');
      if (value) {
        $scope.M.getTownsByState($scope.employee.data.info.residence.state);
      }
    };
    $scope.setTableAction = function (table, action) {
      $scope[table + 'Action'] = action;
      $rootScope.$evalAsync();
    };
    $scope.addEmail = function () {
      if (angular.isDefined($scope.employee.data.info.emails) && $scope.employee.data.info.emails.length) {
        $scope.employee.data.info.emails.push({
          active: true
        });
      } else {
        $scope.employee.data.info.emails = [{
          active: true
        }];
      }
    };
    $scope.addBeneficiary = function () {
      if (!angular.isArray($scope.employee.data.info.beneficiaries)) {
        $scope.employee.data.info.beneficiaries = [];
      }
      if ($scope.employee.data.info.beneficiaries.length < 3) {
        $scope.employee.data.info.beneficiaries.push({});
      } else {
        errAlertS('Solo se permiten 3 registros');
      }
    };
    $scope.addSpecialServices = function () {
      if (angular.isArray($scope.employee.specialServices)) {
        $scope.employee.specialServices.push({});
      } else {
        $scope.employee.specialServices = [{}];
      }
    };
    $scope.addPhone = function () {
      if (angular.isDefined($scope.employee.data.info.phones) && $scope.employee.data.info.phones.length) {
        $scope.employee.data.info.phones.push({
          active: true
        });
      } else {
        $scope.employee.data.info.phones = [{
          active: true
        }];
      }
    };
    $scope.alreadyInCompanies = function (rfc, index) {
      var flag = false;
      if (angular.isArray($scope.employee.specialServices)) {
        var exist = $scope.employee.specialServices.findIndex(function (item) {
          return item.rfc === rfc;
        })
        if (exist > -1 && exist !== index) {
          flag = true;
        }
      }
      return flag;
    }
    $scope.addAccount = function () {
      if (angular.isDefined($scope.employee.data.cards) && $scope.employee.data.cards.length) {
        $scope.employee.data.cards.push({
          emit: false,
          emmitedYet: true
        });
      } else {
        $scope.employee.data.cards = [{
          emit: false,
          emmitedYet: true
        }];
      }
    }
    $scope.removeEmail = function (index) {
      $scope.employee.data.info.emails.splice(index, 1);
      $scope.form.$setDirty()
    };
    $scope.removeSpecialService = function (index) {
      $scope.employee.specialServices.splice(index, 1);
      $scope.form.$setDirty()

    };
    $scope.removePhone = function (index) {
      $scope.employee.data.info.phones.splice(index, 1);
      $scope.form.$setDirty()
    };
    $scope.loadEmployeeInfoByCurp = function (curp) {
      $log.log("loadEmployeeInfoByCurp called", curp)
      var executeValidation = ($scope.F.active.menuAction === 'enrole' && curp && curp !== 'XEXX010101ENEXXXA0');
      if (executeValidation) {
        $rootScope.loadingProgress = true;
        var title = '¿Desea reingresar el empleado?';
        var action;
        var dataEmployee = []
        var params = {
          'center': $scope.F.center,
          'data.curp': curp,
          'ignoreValidation.uniqueCurp': JSON.stringify({ $ne: true }),
          'project': angular.toJson({ 'fid': 1, 'movement.uid': 1, 'status': 1 })
        };
        $rootScope.D.api.get('employees', params).then(function (resp) {
          var employees = resp.data;
          dataEmployee.push(resp.data[0]);
          var promises = [];

          if (employees.length > 0) {
            $rootScope.loadingProgress = false;
            $rootScope.$evalAsync();
            action = 'redirectToEmployee';
            if (employees[0].status !== 5) {
              throw 'Esta curp ya esta dada de alta y el colaborador se encuentra activo';
            }
            promises.push({ action: action })
            promises.push(
              $mdDialog.show($mdDialog
                .confirm(confirmConfig)
                .title(title)
                .htmlContent('¿Reingresar empleado?')
                .ariaLabel('Deleting')
                .ok('SI')
                .cancel('NO'))
            )
          } else {
            action = 'consultarCurp';
            promises.push(ApiV3F.get('employees/curp', { curp: curp }));
          }
          return Promise.all(promises);
        }).then(function (resp) {
          if (action === 'consultarCurp') {
            $scope.employee.data.info.paternalSurname = '';
            $scope.employee.data.info.maternalSurname = '';
            $scope.employee.data.info.names = '';
            $scope.employee.data.info.birth.date = '';
            var curpData = $filter('getFromObject')(resp[0], 'data.result.data');
            $scope.isManualEntry = true;
            if (angular.isDefined(curpData)) {
              $scope.employee.data.info.paternalSurname = curpData.paternalSurname;
              $scope.employee.data.info.maternalSurname = curpData.maternalSurname;
              $scope.employee.data.info.names = curpData.name;
              var birthDateString = curpData.birthDate;
              var birthTimestamp = moment(birthDateString, 'DD-MM-YYYY');
              $scope.employee.data.info.birth.date = birthTimestamp.valueOf();
              successAlertS('Se obtuvo la información de RENAPO.')
            } else {
              var errorMessage = $filter('getFromObject')(resp[0], 'data.result.error') || 'No se encontró la información en RENAPO o los servicios no se encuentran disponibles.';
              if (errorMessage.toUpperCase().indexOf("los datos ingresados no son correctos") > -1 && $scope.fiscalMovement) {
                $scope.isManualEntry = false;
                errorMessage = 'No se encontró la información en RENAPO y se debe ingresar otra curp diferente.';
              }
              errAlertS(errorMessage);
            }
            $rootScope.loadingProgress = false;
            $scope.$evalAsync();
          } else if (action === 'redirectToEmployee') {
            var redirectParams = { employeeId: dataEmployee[0].fid, forCurp: true };
            $rootScope.loadingProgress = false;
            $state.go($scope.R.states.fb.employees.reEntry, redirectParams);
          }
        }).catch(function (error) {
          $log.log(error)
          $scope.isManualEntry = true;
          $rootScope.loadingProgress = false;
          if (error) {
            errAlertS(error);
          }
        });
      } else if (curp === 'XEXX010101ENEXXXA0') {
        $scope.isManualEntry = true;
      }
    }
    $scope.validateRfc = function (rfc) {
      try {
        // var executeArea = ['enrole', 'reEntry'].includes($scope.F.active.menuAction);
        var executeArea = ($scope.F.active.menuAction === 'enrole' || $scope.F.active.menuAction === 'reEntry');
        $log.log('Variable execute', executeArea)
        // var executeArea = ($scope.F.active.menuAction === 'enrole') || ($scope.F.active.menuAction === 'reEntry');
        if (executeArea && angular.isDefined(rfc) && allReady) {
          $rootScope.loadingProgress = true;
          var promise = [];
          promise.push(ApiV2F.get('employees/validateRfc/' + rfc, {}));
          Promise.all(promise).then(function (resp) {
            if (resp[0].data.valid === true) {
              var data = resp[0].data.data;
              $scope.employee.data.zpCodeSat = data.cp;
              $scope.employee.data.satName = data.name;
              $scope.employee.data.regimenSat = data.regime;
              $scope.employee.data.lastTimeUpdated = data.lastTimeUpdated;
              $rootScope.loadingProgress = false;
              successAlertS('Se obtuvieron los datos del empleado en el sat del rfc');
              $rootScope.loadingProgress = false;
              $rootScope.$evalAsync();
            }
            else {
              $rootScope.loadingProgress = false;
              $scope.employee.data.zpCodeSat = '';
              $scope.employee.data.satName = '';
              $scope.employee.data.regimenSat = '';
              $scope.employee.data.lastTimeUpdated = '';
              errAlertS('No se pudo obtener los datos del rfc, en el sat');
              $rootScope.$evalAsync();
            }
          }).catch(function (error) {
            $log.log('error en la promesa', error)
            errAlertS('Se requiere validación manual a través del portal sat')
            $rootScope.loadingProgress = false;
          });
        }
      }
      catch (error) {
        $log.log(error)
        $rootScope.loadingProgress = false;
        if (error) {
          $rootScope.loadingProgress = false;
          errAlertS(error);
        }
      }
    }
    $scope.validarRfc2 = function () {
      try {
        var cpSat = $scope.employee.data.zpCodeSat;
        var rfc = $scope.employee.data.rfc;
        var fullName = $scope.employee.data.info.names + ' '
        fullName += $scope.employee.data.info.paternalSurname ? $scope.employee.data.info.paternalSurname + ' ' : ''
        fullName += $scope.employee.data.info.maternalSurname ? $scope.employee.data.info.maternalSurname : ''
        var executeArea = ['enrole', 'reEntry'].includes($scope.F.active.menuAction);
        // var executeArea = ($scope.F.active.menuAction === 'enrole');
        var promise = []
        if (executeArea && angular.isDefined(cpSat) && allReady && cpSat !== '' && angular.isDefined(rfc) && rfc !== '' && angular.isDefined(fullName) && fullName !== '') {
          $rootScope.loadingProgress = true;
          var params = {
            name: fullName,
            zipCode: cpSat
          }
          promise.push(ApiV2F.post("employees/validateRfcData/" + rfc, params))
          Promise.all(promise).then(function (resp) {
            if (resp[0].data.valid === true) {
              $scope.employee.data.regimenSat = resp[0].data.data.regime;
              $scope.employee.data.satName = resp[0].data.data.name;
              successAlertS("Si es valido la información del RFC de la persona " + resp[0].data.data.name);
              $rootScope.loadingProgress = false;
              $rootScope.$evalAsync();
            } else {
              errAlertS(resp[0].data.msg);
              $scope.employee.data.regimenSat = '';
              $scope.employee.data.satName = '';
              $rootScope.loadingProgress = false;
              $rootScope.$evalAsync();
            }
          }).catch(function (error) {
            $log.log('error en la promesa', error)
            errAlertS('Se requiere validación manual a través del portal sat')
            $rootScope.loadingProgress = false;
          });
        } else {
          $rootScope.loadingProgress = false;
          $rootScope.$evalAsync();
        }
      } catch (error) {
        $log.log(error)
        $rootScope.loadingProgress = false;
        if (error) {
          errAlertS(error);
        }
      }
    }


    /** Observa cuando carga el empleado para setear defaults y validaciones  */
    if ($scope.objectLoaded) {
      if (!initiated) { init(); }
    } else {
      $log.debug('setting watcher to mainObjLoaded');
      $scope.thisDetailWatchers.mainObjLoaded = $rootScope.$on('mainObjectLoaded', function () {
        if (!initiated) {
          init();
        }
        $scope.thisDetailWatchers.mainObjLoaded();
        delete $scope.thisDetailWatchers.mainObjLoaded;
      });
    }
    $scope.thisDetailWatchers.employeeStopDetailWatchersEvent = $rootScope.$on('stopDetailWatchers', function () {
      for (var f in $scope.thisDetailWatchers) {
        if ($scope.thisDetailWatchers.hasOwnProperty(f)) {
          $log.debug('stopping $watcher', f);
          $scope.thisDetailWatchers[f]();
        }
      }
    });
    $scope.thisDetailWatchers.finalListeners = $scope.$on('$destroy', function () {
      for (var f in $scope.thisDetailWatchers) {
        if ($scope.thisDetailWatchers.hasOwnProperty(f)) {
          $log.debug('stopping $watcher', f);
          $scope.thisDetailWatchers[f]();
        }
      }
    });

    $scope.validPhone = function (phone) {
      if (phone && phone.length > 9) {
        $rootScope.loadingProgress = true;
        ApiV2F.get('employees/validatephone/' + phone, {}).then(function (resp) {
          if (resp.data.valid) {
            $rootScope.loadingProgress = false;
            $rootScope.$evalAsync();
            successAlertS('El numero telefónico es valido, ubicación' + ' ' + resp.data.location);
          } else {
            $rootScope.loadingProgress = false;
            $rootScope.$evalAsync();
            errAlertS('El numero telefónico no existe')
          }
        }).catch(function (error) {
          $log.log(error);
          $rootScope.loadingProgress = false;
          $rootScope.$evalAsync();
          errAlertS(error)
        })
      }
    }


    $scope.searchEmployeesFirm = function (search) {
      $log.log(AppF.autocompleteListM(search, 'employees', ['data.name', 'data.nss', 'fid'], { 'firm': $scope.employee.firm, 'center': AppF.center, 'status': { $ne: 5 } }, DataF))
      return AppF.autocompleteListM(search, 'employees', ['data.name', 'data.nss'], { 'firm': $scope.employee.firm, 'center': AppF.center, 'status': { $ne: 5 } }, DataF);
    }


    $scope.selectedBoss = null;

    $scope.onEmployeeSelect = function (item) {
      if (item && item.fid) {
        $scope.employee.tdsystemBossId = item.fid || null;
      }
    };

    function searchBoss(fid) {
      if (!fid) {
        $scope.selectedBoss = null;
        return;
      }
      $scope.D.api.get('employees', {
        fid: fid,
        project: JSON.stringify({ 'data.name': '$data.name', 'data.fid': '$data.fid', 'data.nss': '$data.nss' })
      }).then(function (resp) {
        if (resp.data && resp.data.length) {
          // Asegura el mismo shape que devuelven tus items
          var doc = resp.data[0];
          $scope.selectedBoss = doc; // <<=== OBJETO, no string
        } else {
          $scope.selectedBoss = null;
        }
      });
    }

    // INIT: hidrata y luego observa cambios
    function initBoss() {
      // hidrata inmediatamente si ya hay fid
      searchBoss($scope.employee && $scope.employee.tdsystemBossId);

      // watch sin el filtro fid !== prev (importante para el primer render)
      var unwatch = $scope.$watch('employee.tdsystemBossId', function (fid) {
        if (fid) searchBoss(fid);
        else $scope.selectedBoss = null;
      });

      $scope.$on('$destroy', function () { unwatch && unwatch(); });
    }

    // Si employee es FirebaseObject, espera a que cargue
    if ($scope.employee && angular.isFunction($scope.employee.$loaded)) {
      $scope.employee.$loaded().then(initBoss);
    } else {
      initBoss();
    }

    // startAfterInitFilter($scope, listWatchers, initiated, init)


  }

}());

(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('document', document);


    /** @ngInject */
    function document($log, errAlertS, $timeout, AppF, MongoF, DataF, CatalogsF, startAfterInitFilter, ListsF) {
        return {
            scope: {
                document: '=',
                mobjectLoaded: '<',
                form: '<',
                onSelectEmployee: '=',
                employee: '=',
                getExtras: '=',
                objName: '='
            },
            restrict: 'E',
            templateUrl: 'app/main/employees/views/documents/document.html',
            link: function (scope) {
                var watchersObj = {};
                var initFlag = false;
                var objTypesName = {
                    saludRecord: 'saludRecord',
                    contract: 'contract'
                };
                scope.objTypes = [];
                scope.readMode = AppF.readMode;
                scope.F = AppF;
                scope.searchEmployee = undefined;
                scope.lastDocument = {};
                function init() {
                    var needed = [scope.mobjectLoaded];
                    Promise.all(needed).then(function () {
                        return Promise.all([getEmployee(), getLastDocument()]);
                    }).then(function () {
                        payrollUpdated();
                        getObjTypes();
                        getExtras();
                        startListener();
                    }).catch(errAlertS);
                }
                function getObjTypes() {
                    scope.objTypes = MongoF.documentTypes.filter(function (item) {
                        return item.type === objTypesName[scope.objName];
                    });
                    if (AppF.addMode && scope.objTypes.length === 1) {
                        scope.document.documentType = scope.objTypes[0]._id;
                    }
                }
                function employeeSelected(employeeSelected, changePayroll) {
                    if (angular.isObject(employeeSelected)) {
                        scope.document.employee = employeeSelected.fid;
                        scope.document.employeeName = employeeSelected.data.name;
                        scope.document.employeeNss = employeeSelected.data.nss;

                        if (angular.isUndefined(scope.document.payroll) || changePayroll) {
                            scope.document.payroll = employeeSelected.payroll;
                            payrollUpdated();
                        }
                        scope.$evalAsync(function () {
                            $timeout(function () {
                                scope.onSelectEmployee();
                                getLastDocument();
                            }, 0, false);
                        });
                    }
                }
                function payrollUpdated() {
                    if (scope.document.payroll) {
                        scope.payroll = ListsF.allPayrolls.find(function (item) {
                            return item.$id === scope.document.payroll;
                        });
                        getObjTypes();
                    }
                }
                function getEmployee() {
                    return new Promise(function (resolve, reject) {
                        var employeeId = scope.document.employee;
                        if (angular.isDefined(employeeId)) {
                            DataF.api.get('p/employees', { fid: employeeId }).then(function (res) {
                                if (res.data.data.length > 0) {
                                    scope.employee = res.data.data[0];
                                    scope.document.employeeName = scope.employee.data.name;
                                    scope.document.employeeNss = scope.employee.data.nss;
                                    scope.$evalAsync(function () {
                                        $timeout(function () { }, 0, false);
                                    });
                                }
                                resolve(true);
                            }, function (error) {
                                reject(error);
                            });
                        } else {
                            resolve(true);
                        }
                    });
                }
                function getLastDocument() {
                    return new Promise(function (resolve, reject) {
                        var employeeId = scope.document.employee;
                        if (angular.isDefined(employeeId)) {
                            var query = { employee: employeeId, type: objTypesName[scope.objName], endDate: { $exists: true }, sort: angular.toJson({ 'startDate': -1 }) };
                            if (scope.document._id) {
                                query._id = angular.toJson({ $ne: { '$toObjectId': scope.document._id } });
                                if (scope.document.startDate) {
                                    query.startDate = angular.toJson({ $lt: scope.document.startDate });
                                }
                            }
                            DataF.api.get('one/documents', query).then(function (res) {
                                if (res.data.data.length > 0) {
                                    scope.lastDocument = res.data.data[0];
                                }
                                executeValidationForEach(true);
                                scope.$evalAsync(function () {
                                    $timeout(function () { }, 0, false);
                                });
                                resolve(true);
                            }, function (error) {
                                reject(error);
                            });
                        } else {
                            resolve(true);
                        }
                    });
                }
                function getExtras() {
                    scope.documentType = {};
                    if (scope.document.documentType && scope.objTypes.length > 0) {
                        scope.documentType = scope.objTypes.find(function (item) {
                            return item._id === scope.document.documentType;
                        });
                        if (angular.isDefined(scope.documentType) && scope.documentType.hasOwnProperty('fields')) {
                            scope.fields = scope.documentType.fields;
                        }
                    }
                }
                function searchEmployeeForDocument(query) {
                    return AppF.autocompleteListM(query, 'employees', ['data.name', 'data.nss'], { '$and': AppF.getAndValue(), 'center': AppF.center, 'status': { $ne: 5 } }, DataF);
                }
                function getValue(formule) {
                    var value;
                    try {
                        value = eval(formule);
                    } catch (error) {
                        $log.log('No se puede ejecutar', formule);
                        $log.log(error);
                        value = undefined;
                    }
                    return value;
                }
                var executing = false;
                function executeValidationForEach(first) {
                    $log.log('executeValidationForEach', first);
                    executing = true;
                    if (angular.isArray(scope.fields)) {
                        for (var f = 0; f < scope.fields.length; f++) {
                            var thisField = scope.fields[f];

                            if (thisField.type === 'date' && thisField.defaultValue && ((!scope.document[thisField.id]) || first || thisField.readonly === true)) {
                                scope.document[thisField.id] = getValue(thisField.defaultValue);
                            }
                            if (thisField.validation) {
                                var validationValue = getValue(thisField.validation);
                                scope.fields[f].validationResult = validationValue;
                                if (!validationValue) {
                                    delete scope.document[thisField.id];
                                }
                            }
                        }
                    }
                    executing = false;
                }
                function startListener() {
                    watchersObj.documentChange = scope.$watch('document', function (newVal) {
                        if (angular.isObject(newVal) && !executing) {
                            executeValidationForEach();
                        }
                    }, true);
                }
                scope.employeeSelected = employeeSelected;
                scope.searchEmployeeForDocument = searchEmployeeForDocument;
                scope.getExtras = getExtras;
                startAfterInitFilter(scope, watchersObj, initFlag, init);
            }
        };
    }
}());
(function () {
  "use strict";

  angular
    .module("app.employees")
    .controller("DocumentTypeController", DocumentTypeController);

  function DocumentTypeController($scope, startAfterInitFilter, $log, errAlertS) {
    var watchers = {};
    var initiated = false;

    function init() {
      variablesReq()
      var promises = [$scope.dataNeededPromise, $scope.statesObjsPromise, $scope.mainObjectLoaded];
      Promise.all(promises).then(function () {
        if (!angular.isArray($scope.documentType.notRequiredFields)) {
          $scope.documentType.notRequiredFields = []
        }
      }).catch(errAlertS);

    }

    function variablesReq() {
      $scope.D.models.action('documents', 'variablesReq', {}).then(function (resp) {
        $scope.specifics = resp.data;
      });
    }


    startAfterInitFilter($scope, watchers, initiated, init);
  }
})();

(function () {
    'use strict';

    angular
        .module('app.employees')
        .controller('CreditsController', CreditsController)

    /** @ngInject */
    function CreditsController(
        $rootScope,
        $scope,
        errAlertS,
        $log,
        $timeout,
        $mdDialog,
        confirmConfig,
        successAlertS,
        getEmpInfonavitDataFilter,
        AppF,
        $document
    ) {
        var deleteMiniCredit = function (credits) {
            var requests = {};
            for (var c in credits) {
                var credit = credits[c];
                requests['catalogs/employees/collection/' + credit.employee + '/credits/' + credit.$id] = null;
            }
            return $scope.F.root.update(requests);
        }
        $scope.disableCredits = function (selected, ev) {
            $log.log($scope.getThem())
            $mdDialog.show({
                templateUrl: 'app/main/employees/views/credits/dialogs/disabledCredits.html',
                controller: 'DisabledCreditsController',
                controllerAs: 'dsCtrl',
                parent: angular.element($document.body),
                targetEvent: ev,
                locals: { selected: selected, getThem: $scope.getThem }
            })

            // var itemMsg = selected.length > 1 ? selected.length + ' créditos' : ' 1 crédito'
            // var title = '¿Desea desactivar ' + itemMsg + '?';
            // $mdDialog.show($mdDialog
            //     .confirm(confirmConfig)
            //     .title(title)
            //     .htmlContent('Esta acción deshabilitara todos los créditos seleccionados')
            //     .ariaLabel('Deleting')
            //     .targetEvent(ev)
            //     .ok('SI')
            //     .cancel('NO'))
            //     .then(function () {
            //         $rootScope.loadingProgress = true;
            //         $scope.$evalAsync();
            //         var requests = {};
            //         for (var c = 0; c < selected.length; c++) {
            //             var credit = selected[c];
            //             requests['catalogs/credits/collection/' + credit.$id + '/valid'] = false;
            //         }
            //         $scope.F.root.update(requests).then(function () {
            //             successAlertS('Se deshabilitaron ' + itemMsg + ' correctamente')
            //             return $scope.F.sleep(3000);
            //         }).then(function () {
            //             return $scope.getThem()
            //         }).then(function () {
            //             $rootScope.loadingProgress = false;
            //             $scope.$evalAsync();
            //         }).catch(function (error) {
            //             errAlertS(error);
            //             $rootScope.loadingProgress = false;
            //             $scope.$evalAsync();
            //         });
            //     }, function () {
            //         $log.debug('Deleting Cancelled');
            //     });
        }

        $scope.activeCredits = function (selected, ev) {
            var itemMsg = selected.length > 1 ? selected.length + ' créditos' : ' 1 crédito'
            var title = '¿Desea activar ' + itemMsg + '?';
            $mdDialog.show($mdDialog
                .confirm(confirmConfig)
                .title(title)
                .htmlContent('Esta acción activara todos los créditos seleccionados')
                .ariaLabel('Deleting')
                .targetEvent(ev)
                .ok('SI')
                .cancel('NO'))
                .then(function () {
                    $rootScope.loadingProgress = true;
                    $scope.$evalAsync();
                    var requests = {};
                    for (var c = 0; c < selected.length; c++) {
                        var credit = selected[c];
                        requests['catalogs/credits/collection/' + credit.$id + '/valid'] = true;
                    }
                    $scope.F.root.update(requests).then(function () {
                        successAlertS('Se deshabilitaron ' + itemMsg + ' correctamente')
                        return $scope.F.sleep(3000);
                    }).then(function () {
                        return $scope.getThem()
                    }).then(function () {
                        $rootScope.loadingProgress = false;
                        $scope.$evalAsync();
                    }).catch(function (error) {
                        errAlertS(error);
                        $rootScope.loadingProgress = false;
                        $scope.$evalAsync();
                    });
                }, function () {
                    $log.debug('Deleting Cancelled');
                });
        }

        $scope.goToDetail = function (credit) {
            $scope.R.goToDetail('new', 'create', {
                creditId: 'new',
                payrollId: credit.payroll,
                employeeId: credit.employee,
                type: credit.data.type,
                factor: credit.data.factor,
                comments: credit.data.comments,
                noCredit: credit.data.account
            });
        }

        $scope.deleteWithMiniCredit = function (ev) {
            var selected = angular.fromJson(angular.toJson($scope.selected));
            $scope.deleteFb(ev, 1).then(function () {
                $rootScope.loadingProgress = true;
                deleteMiniCredit(selected).then(function () {
                    $scope.selected = [];
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync(function () {
                        $log.debug('deleteWithMiniCredit finished');
                    });
                    $timeout(function () {
                        $scope.getThem(true);
                    }, 2000, false)
                });
            }).catch(function (err) {
                errAlertS(err);
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
            });
        }
        $scope.checkCredit = function (ev, selected, action) {
            var thisValue;
            if (selected.length > 0) {
                $rootScope.loadingProgress = true;
                thisValue = action === 'validate' ? selected[0].data.nss : selected[0].employee;
            }
            getEmpInfonavitDataFilter(thisValue, action).then(function (creditData) {
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
                if (angular.isUndefined(creditData) || (creditData.credit)) {
                    $mdDialog.show({
                        templateUrl: 'app/main/employees/views/credits/dialogs/checkCredit.html',
                        controller: 'CheckCreditController',
                        controllerAs: 'chCredCtrl',
                        locals: {
                            action: action,
                            creditData: creditData
                        },
                        parent: angular.element(document.body),
                        targetEvent: ev
                    });
                } else if (angular.isDefined(creditData) && (!creditData.credit)) {
                    errAlertS(creditData.msg);
                }
            }).catch(function (error) {
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
                errAlertS(error);
            });
        }

        $scope.getReportInfonavit = function (employees) {
            for (var i = 0; i < employees.length; i++) {
                var employee = employees[i];
                AppF.downloadFile('POST', "interface/exportPdfInfonavit", { employee_id: employee.employee, name: employee.data.name, nss: employee.data.nss });
            }
        }

        $scope.importarCredits = function () {
            $mdDialog.show({
                templateUrl: 'app/main/employees/views/credits/dialogsImportCredits/importCredits.html',
                controller: 'ImportCreditsController',
                controllerAs: 'impCredCtrl',
                parent: angular.element($document.body), // <- requiere inyectar $document en tu controller donde declaras esta función
                clickOutsideToClose: false,
                escapeToClose: false,
                locals: {
                    payrollsMap: $scope.payrollsMap,    // { [payrollId]: true }
                    employeesMap: $scope.employeesMap,   // { [employeeId]: true }
                    prevCreditsMap: $scope.prevCreditsMap  // { [employeeId]: [{ startDate:'YYYY-MM-DD', active:true }] }
                }
            }).then(function (result) {
                $rootScope.$evalAsync(function () {
                    $log.debug('importCredits finished');
                });
                if (!result || !result.rows) return;

                // Aquí haces el POST / guardado real:
                // 1) Si row.__activate === true → desactiva créditos activos previos del empleado
                // 2) Inserta el nuevo crédito (activo/inactivo según __activate)
                // Ej:
                // ApiV3F.post('/credits/import', result.rows).then(...)

            }, function () {
                // Cancelado
            });
        };

    }

}());
(function () {
    'use strict';

    angular
        .module('app.employees')
        .controller('CreditController', CreditController)

    /** @ngInject */
    function CreditController(
        $scope,
        $log,
        $rootScope,
        successAlertS,
        $firebaseObject,
        $q,
        errAlertS,
        getCreditDataObjectsFilter,
        getFromObjectFilter,
        checkValidFieldsModalFilter,
        $timeout,
        orderObjectByFilter
    ) {
        $scope.listWatchers = {};
        $scope.minDate = undefined;
        $scope.maxDate = undefined;
        $scope.searchQuery = "";
        $scope.employeeSelected = {
            data: {}
        }
        var setMinimovementToEmployee = function (credit) {
            var miniCredit = {
                d: credit.data.date,
                v: credit.valid
            };
            return $scope.F.root.child('catalogs/employees/collection').child(credit.employee).child('credits').child(credit.$id).set(miniCredit);
        }
        var deactivateOtherCreditsOfEmployee = function () {
            var promise = $q.defer();
            if ($scope.employee.credits) {
                var updates = {};
                for (var c in $scope.employee.credits) {
                    if ($scope.employee.credits[c].v) {
                        updates['catalogs/credits/collection/' + c + '/valid'] = false;
                        updates['catalogs/employees/collection/' + $scope.employee.$id + '/credits/' + c + '/v'] = false;
                    }
                }
                $scope.F.root.update(updates).then(function () {
                    promise.resolve(true);
                }, function (err) {
                    promise.reject(err);
                })
            } else {
                promise.resolve(true);
            }
            return promise.promise;
        }
        $scope.createCreditAndNotify = function (credit) {
            $rootScope.loadingProgress = true;
            for (var c in $scope.employee.credits) {
                if ($scope.employee.credits[c].v) {
                    credit.data.lastCreditDate = $scope.employee.credits[c].d;
                }
            }
            $scope.add(credit, 1).then(function (snap) {
                var cid = snap.key;
                credit.$id = cid;
                $scope.F.addMode = false;
                $q.all([deactivateOtherCreditsOfEmployee(), setMinimovementToEmployee(credit), getCreditDataObjectsFilter(credit)]).then(function (all) {
                    var creditData = all[2];
                    $scope.F.notifyUsers('credit', 'credits', 'create', cid, credit, false, creditData)
                        .then(function () {
                            successAlertS('Se creó crédito con éxito');
                            $rootScope.loadingProgress = false;
                            $rootScope.$evalAsync();
                            $rootScope.$evalAsync(function () {
                                $log.debug('createCreditAndNotify finished');
                            });
                            if ($scope[$scope.formName]) $scope[$scope.formName].$setPristine();
                            if ($scope.F.settings.goToListOnCreate) $scope.R.goToList();
                        }).catch(function (err) {
                            errAlertS(err);
                            $rootScope.loadingProgress = false;
                            $rootScope.$evalAsync();
                        });
                }).catch(function (err) {
                    errAlertS(err);
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                })
            }).catch(function (err) {
                errAlertS(err);
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
            });
        }
        $scope.saveAndSetMiniCredit = function (credit) {
            $rootScope.loadingProgress = true;
            $q.all([setMinimovementToEmployee(credit), $scope.save(credit, 1, $scope.F.active.menuName, $scope)]).then(function () {
                successAlertS('Se editó crédito con éxito');
                $timeout(function () {
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync(function () {
                        if ($scope.F.settings.goToListOnCreate) { $scope.R.goToList(); }
                        $log.debug('saveAndSetMiniCredit finished');
                    });
                }, 5000, false);
            }).catch(function (err) {
                errAlertS(err);
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
            });
        };
        $scope.showListPending = function (event, form) {
            checkValidFieldsModalFilter(event, form);
        };
        $scope.listWatchers.applyNeeded = $scope.$watchGroup(['payrollId', 'employeeId', 'type', 'factor', 'comments', 'noCredit'], function (needed) {
            if (needed[0]) {
                $scope.credit.payroll = needed[0];
            }
            if (needed[1]) {
                $scope.credit.employee = needed[1];
            }
            if (needed[2]) {
                $scope.credit.data.type = needed[2];
            }
            if (needed[3]) {
                $scope.credit.data.factor = parseFloat(needed[3]);
            }
            if (needed[4]) {
                $scope.credit.data.comments = needed[4];
            }
            if (needed[5]) {
                $scope.credit.data.account = needed[5];
            }
        })
        $scope.listWatchers.employee = $scope.$watch('credit.employee', function (employeeId, oldEmployeeId) {
            $log.debug('credit employee', employeeId, oldEmployeeId);
            if (employeeId) {
                //$log.debug('Setting current SD & SBC in credit', employeeId);
                $scope.employee = $firebaseObject($scope.F.root.child('catalogs/employees/collection').child(employeeId));
                $scope.employee.$loaded().then(function (employee) {
                    $scope.searchQuery = employee.data.name;
                    $scope.employeeSelected = {
                        data: employee.data,
                        '$id': employeeId,
                        fid: employeeId
                    };
                    $scope.payroll = $firebaseObject($scope.F.root.child('catalogs/payrolls/collection').child(employee.payroll));
                    if (angular.isDefined(employee.data) && angular.isDefined(employee.data.salary)) {
                        $scope.credit.data.sd = (employee.data.salary.sd) ? employee.data.salary.sd : 0;
                        $scope.credit.data.sbc = (employee.data.salary.sbc) ? employee.data.salary.sbc : 0;
                        $scope.credit.data.sdr = (employee.data.salary.sdr) ? employee.data.salary.sdr : 0;
                    }
                    $scope.credit.cc = employee.cc;
                    $scope.credit.rp = employee.rp;
                    $scope.credit.data.name = employee.data.name;
                    $scope.credit.data.nss = employee.data.nss;
                    $scope.credit.payroll = employee.payroll;
                    $scope.$evalAsync(function () {
                    })
                    var lastCreditDate = 0;
                    var lastEnroleDate = 0;
                    if ($scope.employee.credits && Object.keys($scope.employee.credits).length) {
                        var credits = $scope.employee.credits;
                        var orderDate = Object.keys(credits).filter(function (key) {
                            return key !== $scope.credit.$id;
                        }).map(function (key) {
                            return { id: key, d: credits[key].d, v: credits[key].v };
                        }).sort(function (a, b) {
                            return a.d - b.d;
                        });
                        var lastDateCredit = orderDate.pop().d;
                        if (orderDate.length > 0) {
                            lastCreditDate = lastDateCredit + ($scope.F.oneDay * 1);
                        }
                    }
                    if ($scope.employee.movements && Object.keys($scope.employee.movements).length) {
                        for (var m in $scope.employee.movements) {
                            var thisMovement = $scope.employee.movements[m];
                            if (thisMovement.t === 6 || thisMovement.t === 8) {
                                if (lastEnroleDate < thisMovement.d) {
                                    lastEnroleDate = thisMovement.d;
                                }
                            }
                        }
                    }
                    if (angular.isDefined(getFromObjectFilter($scope.credit, 'data.factor'))) {
                        $scope.checkFactor($scope.credit);
                    }
                    var greaterDate;
                    if (lastCreditDate || lastEnroleDate) {
                        if (lastCreditDate > lastEnroleDate) {
                            greaterDate = lastCreditDate;
                        } else {
                            greaterDate = lastEnroleDate;
                        }
                    }
                    $scope.minDate = moment(greaterDate).toDate();
                    $rootScope.$evalAsync();
                    $log.debug('employeeSalary obtained for info and setted in credit', $scope.credit, employee.data.salary);
                });
            }
        });
        $scope.checkFactor = function (credit) {
            if (angular.isDefined(getFromObjectFilter(credit, 'employee'))) {
                $scope.F.root.child('catalogs/credits/collection/').orderByChild('employee').equalTo(credit.employee).once('value').then(function (snap) {
                    if (snap.exists()) {
                        var data = snap.val();
                        var factor = orderObjectByFilter(data, "-data.date");
                        if (factor.length > 0) {
                            var thisFactor = factor[0];
                            if (thisFactor.$id !== credit.$id && thisFactor.data.factor === getFromObjectFilter(credit, 'data.factor', 0)) {
                                delete $scope.credit.data.factor;
                                errAlertS("El factor actual no puede ser igual al factor anterior");
                            }
                        }
                    }
                })
            }
        }
        $scope.listWatchers.finalListener = $scope.$on("$destroy", function () {
            for (var f in $scope.listWatchers) {
                //$log.debug('stopping $watcher', f);
                $scope.listWatchers[f]();
            }
            //stopDetailWatchersEvent();
        });

    }

}());
(function () {
    'use strict';

    angular
        .module('app.employees')
        .controller('ContractsController', ContractsController);

    /** @ngInject */
    function ContractsController($scope, $log, errAlertS, $mdDialog, confirmConfig, getArrayOfIdsFilter, $http, $window, successAlertS) {
        function generatePdf(ids) {
            return new Promise(function (resolve, reject) {
                if (ids.length > 0) {
                    var promises = [];
                    for (var i = 0; i < ids.length && i < 10; i++) {
                        promises.push($http({
                            method: 'GET',
                            url: $window.__env.serviceWorkerUrl + 'views/documents?type=pdf&action=sign&documentId=' + ids[i],
                            responseType: 'arraybuffer'
                        }));
                    }
                    Promise.all(promises).then(function (resp) {
                        ids.splice(0, resp.length);
                        var linkElement = document.createElement('a');
                        for (var r = 0; r < resp.length; r++) {
                            var response = resp[r];
                            var headers = response.headers();
                            var filename = headers['x-filename'];
                            var contentType = headers['content-type'];
                            try {
                                var blob = new Blob([response.data], {
                                    type: contentType
                                });
                                var url = $window.URL.createObjectURL(blob);
                                linkElement.setAttribute('href', url);
                                linkElement.setAttribute('download', filename);
                                var clickEvent = new MouseEvent('click', {
                                    'view': window,
                                    'bubbles': true,
                                    'cancelable': false
                                });
                                linkElement.dispatchEvent(clickEvent);
                            } catch (e) {
                                reject(e);
                            }
                        }
                        resolve(generatePdf(ids));
                    }).catch(reject);
                } else {
                    resolve(true);
                }
            });
        }
        $scope.printPDF = function (e) {
            $mdDialog.show($mdDialog.confirm(confirmConfig)
                .title('Generar PDF')
                .content('Desea generar los pdf de los ' + $scope.selected.length + ' contrato(s)')
                .ariaLabel('Deleting')
                .targetEvent(e)
                .ok('Aceptar')
                .cancel('Cancelar'))
                .then(function () {
                    var contractsIds = getArrayOfIdsFilter($scope.selected, '_id');
                    generatePdf(contractsIds).then(function () {
                        successAlertS('Se generaron los pdf correctamente');
                    }).catch(errAlertS);
                }, function () {
                    $log.debug('Deleting Cancelled');
                });
        };
    }

}());
(function () {
    'use strict';

    angular
        .module('app.employees')
        .controller('ContractController', ContractController);

    /** @ngInject */
    function ContractController(
        $scope,
        $log,
        errAlertS,
        DataF,
        MongoF
    ) {
        $scope.employee = undefined;
        function getAllContracts() {
            return new Promise(function (resolve, reject) {
                var query = { employee: $scope.contract.employee, type: 'contract', endDate: { $exists: true }, payroll: $scope.contract.payroll };
                var queryAggregate = [
                    { $match: query },
                    { $addFields: { 'documentTypeId': { '$toObjectId': '$documentType' }, 's_id': { '$toString': '$_id' } } },
                    { $lookup: { localField: 'documentTypeId', foreignField: '_id', from: 'documentTypes', as: 'documentTypeData' } },
                    { $unwind: '$documentTypeData' },
                    { $addFields: { 'documentTypeKey': '$documentTypeData.key' } },
                    { $project: { 'documentTypeKey': 1, 'startDate': 1, 'endDate': 1, 'signed': 1, 'documentType': 1 } },
                    { $sort: { startDate: 1 } }
                ];
                if ($scope.contract._id) {
                    queryAggregate.splice(2, 0, { $match: { 's_id': { '$ne': $scope.contract._id } } });
                }
                var params = {
                    query: angular.toJson(queryAggregate)
                };
                DataF.api.post('aggregate/documents', params).then(function (res) {
                    resolve(res.data);
                }, function (error) {
                    reject(error);
                });
            });
        }
        $scope.validateEmployee = function () {
            if ($scope.employee.contractType) {
                getAllContracts().then(function (allContracts) {
                    var thisDocType = MongoF.documentTypes.find(function (item) {
                        return item._id === $scope.employee.contractType;
                    });
                    if (angular.isUndefined(thisDocType)) {
                        throw 'No se encontró el tipo de documento seleccionado';
                    }
                    if (allContracts.length > 0) {
                        var lastContract = allContracts[allContracts.length - 1];
                        if (lastContract.documentTypeKey === 'indefiniteContract') {
                            throw 'No se puede crear otro contrato si ya se tiene uno indeterminado';
                        }
                        if (lastContract.documentTypeKey === 'determinedContract' && ['testContract', 'trainingContract'].indexOf(thisDocType.key) > -1) {
                            throw 'No se puede generar un contrato de este tipo después de uno determinado';
                        }
                        if (lastContract.documentTypeKey === 'trainingContract' && thisDocType.key !== 'indefiniteContract') {
                            throw 'Después de un contrato de capacitación corresponde un contrato indeterminado';
                        }
                        var totalOfTest = allContracts.reduce(function (previous, current) {
                            if (current.documentTypeKey === 'testContract') {
                                previous = previous + 1;
                            }
                            return previous;
                        }, 0);
                        if (totalOfTest >= 3 && thisDocType.key !== 'indefiniteContract') {
                            throw 'No se puede tener mas de 3 contratos de prueba, el proximo contrato debería ser uno indeterminado';
                        }
                    }
                    $scope.contract.documentType = $scope.employee.contractType;
                    if (angular.isFunction($scope.getExtras)) {
                        $scope.getExtras();
                    }
                }).catch(function (error) {
                    errAlertS(error);
                    delete $scope.contract.documentType;
                });
            } else {
                $scope.employee = undefined;
                errAlertS('El empleado seleccionado no tiene un contrato asignado, primero asigne el contrato en edición de empleados para poder generarlo');
            }
        };
    }

}());
(function () {
    'use strict';

    angular
        .module('app.employees')
        .controller('AniversaryRecordsController', AniversaryRecordsController)

    /** @ngInject */
    function AniversaryRecordsController(
        $scope,
        amDifferenceFilter
    ) {
        var initiated = false;
        var init = function () {
            $scope.F.search.$payroll = 'all';
        }
        $scope.goToApply = function (aniversary) {
            // se cambian los valores para ser compatibles con la url
            var date = aniversary.hasSeniorityDate && aniversary.seniorityDate ? aniversary.seniorityDate : aniversary.enroleDate;
            var years = amDifferenceFilter(date, null, 'years') * (-1);
            var enroleDate = moment(date);
            enroleDate.add(years, 'years');
            var sd = aniversary.sd + '';
            sd = sd.replace('.', '-');
            var sbc = aniversary.newSbc + '';
            sbc = sbc.replace('.', '-');
            $scope.R.goToDetail(null, 'apply', {
                aniversaryRecordId: aniversary.$id,
                date: enroleDate.valueOf(),
                sd: sd,
                sbc: sbc,
                payrollId: aniversary.payroll
            });
        }

        var profileLoaded = $scope.$watchGroup(['F.profile.uid', 'F.loadedPermissions'], function (pp) {
            if (pp[0] && pp[1] && !initiated) {
                init();
                profileLoaded();
            }
        });
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.pages.error-404', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.pages_errors_error-404', {
            // url      : '/pages/errors/error-404',
            url      : '/pages/errors/404',
            views    : {
                'main@'                             : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_errors_error-404': {
                    templateUrl: 'app/main/pages/errors/404/error-404.html',
                    controller : 'Error404Controller as vm'
                }
            },
            bodyClass: 'error-404'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/errors/404');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.error-404')
        .controller('Error404Controller', Error404Controller);

    /** @ngInject */
    function Error404Controller()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.error-500', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.pages_errors_error-500', {
            url      : '/pages/errors/error-500',
            views    : {
                'main@'                             : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_errors_error-500': {
                    templateUrl: 'app/main/pages/errors/500/error-500.html',
                    controller : 'Error500Controller as vm'
                }
            },
            bodyClass: 'error-500'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/errors/500');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.error-500')
        .controller('Error500Controller', Error500Controller);

    /** @ngInject */
    function Error500Controller()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.error-403', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.pages_errors_error-403', {
            // url      : '/pages/errors/error-404',
            url      : '/pages/errors/403',
            views    : {
                'main@'                             : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_errors_error-403': {
                    templateUrl: 'app/main/pages/errors/403/error-403.html',
                    controller : 'Error403Controller as vm'
                }
            },
            bodyClass: 'error-403'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/errors/403');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.error-403')
        .controller('Error403Controller', Error403Controller);

    /** @ngInject */
    function Error403Controller(
        $scope,
        RoutesF
    )
    {
        // Data
        $scope.R = RoutesF;
    }
})();
(function() {
    'use strict';

    angular
        .module('app.config')
        .controller('UsersController', UsersController);

    function UsersController(
        $scope,
        $log,
        $q,
        $mdDialog,
        successAlertS,
        errAlertS,
        confirmConfig
    ) {

        var deActivate = function(user) {
            $log.debug('deactivating: ', user);
            return $scope.F.root.child('profiles/'+user.$id+'/active').set(false);
        }

        // var removeUserFromGroups = function(userId) {
        //     $log.debug('removing user from groups', userId);
        //     return $q(function(resolve, reject) {
        //         var groupsOfUser = angular.copy($scope.F.groupsOfUser);
        //         var updates = {};
        //         for (var g in groupsOfUser) {
        //             var group = groupsOfUser[g];
        //             updates['groups/' + group + '/users/' + userId] = null;
        //         }
        //         $scope.F.root.update(updates, function(error) {
        //             if (error) {
        //                 reject(error);
        //             } else {
        //                 resolve(true);
        //             }
        //         });
        //     });
        // }

        $scope.deActivateUser = function(e) {
            var msg = (!$scope.F.safeDelete.user) ?
                'Usuarios serán desactivados' :
                'Podrá recuperar sus datos en la papelera';
            var title = 'Quiere borrar ' + $scope.selected.length + ' Usuarios?';

            $mdDialog.show($mdDialog.confirm(confirmConfig)
                .title(title)
                .content(msg)
                .ariaLabel('Deleting')
                .targetEvent(e)
                .ok('Borrar')
                .cancel('Cancelar'))
            .then(function() {
                var count = 0;
                $log.debug('Deleting: ', $scope.selected);
                angular.forEach($scope.selected, function(user) {
                    if ($scope.F.safeDelete.user){

                    } else {
                        // removeUserFromGroups(user.$id).then(function() { // @todo:preguntar a conta que se hace aqui
                            deActivate(user).then(function() {
                                count++
                                if (count == $scope.selected.length) {
                                    successAlertS('Se borraron ' + count + ' Usuarios');
                                    $scope.selected = [];
                                }
                            }, errAlertS);
                        // }, function(err) {
                        //     errAlertS('No se pudo borrar el usuario de los grupos, favor de hacerlo manualmente');
                        // });
                    }
                });
            }, function() {
                $log.debug('Deleting Cancelled');
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.config')
        .controller('UserController', UserController);

    function UserController(
        $scope,
        $rootScope,
        $document,
        $firebaseAuth,
        $log,
        $filter,
        $mdDialog,
        successAlertS,
        errAlertS,
        $q,
        getArrayOfKeysFilter,
        AppF,
        ListsF,
        createCcsByPayrollsOfUserFilter,
        $http,
        startAfterInitFilter,
        groupByFieldFilter,
        $window,
        loopEachFilter,
        ApiV3F,
        userHasPermissionFilter
    ) {
        var watchers = {};
        var initiated = false;
        $scope.auth = $firebaseAuth();
        $scope.groupsOfUser = [];
        $scope.originalGroupsOfUser = [];
        $scope.payrollsCcsUser = [];
        $scope.originalPayrollsCssUser = [];
        $scope.userAccessToAllPayrolls = false;
        $scope.mfa = {
            authorized: false,
            loading: false,
            loaded: false,
            disabling: false,
            error: false,
            status: null
        };
        function init() {
            var needed = [
                $scope.dataNeededPromise,
                $scope.statesObjsPromise,
                $scope.mainObjectLoaded
            ];
            Promise.all(needed).then(function () {
                if ($scope.user.groupsOfUser) {
                    $scope.groupsOfUser = getArrayOfKeysFilter($scope.user.groupsOfUser);
                    $scope.originalGroupsOfUser = $scope.groupsOfUser.slice();
                }
                setAvailableGroups(true);
                return setUserPayrollsAndCcs();
            }).then(function () {
                $log.log('ready to set');
                $scope.mfa.authorized = userHasPermissionFilter(
                    $scope.F.groupsOfUser,
                    $scope.F.permissions,
                    'disableMfa',
                    'config.users'
                );
                if ($scope.mfa.authorized && !$scope.F.addMode) {
                    return loadMfaStatus();
                }
            }).catch(function (error) {
                errAlertS(error);
            });
        }
        function getUserUid() {
            return $scope.user && ($scope.user.uid || $scope.user.$id);
        }
        function normalizeMfaStatus(data) {
            data = data || {};
            return {
                enabled: data.enabled === true,
                factorCount: angular.isNumber(data.factorCount) ? data.factorCount : 0,
                factors: angular.isArray(data.factors) ? data.factors : []
            };
        }
        function loadMfaStatus() {
            var uid = getUserUid();
            if (!$scope.mfa.authorized || !uid) {
                return $q.when(false);
            }
            $scope.mfa.loading = true;
            $scope.mfa.error = false;
            return ApiV3F.get('users/' + encodeURIComponent(uid) + '/mfa').then(function (response) {
                $scope.mfa.status = normalizeMfaStatus(response.data);
                $scope.mfa.loaded = true;
                return $scope.mfa.status;
            }).catch(function (error) {
                $scope.mfa.error = true;
                $scope.mfa.loaded = false;
                errAlertS(error);
                return false;
            }).finally(function () {
                $scope.mfa.loading = false;
                $rootScope.$evalAsync();
            });
        }
        function disableMfa() {
            var uid = getUserUid();
            if (!$scope.mfa.authorized || !$scope.mfa.status || !$scope.mfa.status.enabled || !uid) {
                return $q.when(false);
            }
            $scope.mfa.disabling = true;
            return ApiV3F.delete('users/' + encodeURIComponent(uid) + '/mfa').then(function (response) {
                $scope.mfa.status = normalizeMfaStatus(response.data);
                $scope.mfa.loaded = true;
                $scope.mfa.error = false;
                successAlertS('Se deshabilitó el doble factor del usuario con éxito');
                return response;
            }).catch(function (error) {
                errAlertS(error);
                return $q.reject(error);
            }).finally(function () {
                $scope.mfa.disabling = false;
                $rootScope.$evalAsync();
            });
        }
        function showModalDisableMfa(ev) {
            var userName = ($scope.user.data && ($scope.user.data.name || $scope.user.data.email)) || getUserUid();
            var confirm = $mdDialog.confirm()
                .title('Deshabilitar MFA de ' + userName)
                .textContent('Se eliminarán todos los factores de autenticación del usuario y se revocarán sus sesiones. ¿Desea continuar?')
                .targetEvent(ev)
                .ok('Deshabilitar')
                .cancel('Cancelar');
            return $mdDialog.show(confirm).then(disableMfa).catch(function () { });
        }
        function setAccessAllPermission() {
            return new Promise(function (resolve, reject) {
                var promises = [];
                for (var g = 0; g < $scope.groupsOfUser.length; g++) {
                    promises.push(AppF.root.child('/permissions/' + $scope.groupsOfUser[g] + '/organization/payrolls/permissions/accessAll').once('value'));
                }
                Promise.all(promises).then(function (snaps) {
                    var accessAll = false;
                    snaps.map(function (item) { if (item.val()) { accessAll = true; } });
                    $scope.userAccessToAllPayrolls = accessAll;
                    if (accessAll) {
                        $scope.payrollsCcsUser = [];
                    } else {
                        $scope.payrollsCcsUser = angular.fromJson(angular.toJson($scope.originalPayrollsCssUser));
                    }
                    resolve(accessAll);
                }).catch(reject);
            });

        }
        function setUserPayrollsAndCcs() {
            return new Promise(function (resolve, reject) {
                setAccessAllPermission().then(function () {
                    var promises = {
                        //se obtiene las notificaciones globales para en caso de desactivar la cuenta se tengan los datos
                        globalNotifications: ListsF.loadList('globalNotifications', 'settings/globalNotifications', false, 'array', 'globalNotifications'),
                        //se obtienen los todos los centros de costo
                        allCcs: ListsF.loadList('ccs', 'lists/ccs/center/' + AppF.center, undefined, undefined, undefined, [{ q: 'orderByChild', v: 'archived' }, { q: 'endAt', v: false }])
                    };
                    if (!$scope.userAccessToAllPayrolls) {
                        //se obtienen las nominas en las que esta involucrado el usuario
                        promises.userPayrolls = ListsF.loadList('payrolls', 'lists/payrolls/user', $scope.user.$id, 'array', 'payrollsUser-' + $scope.user.$id);
                        //se obtienen los centros de costos en los que están involucrado el usuario
                        promises.userCcs = ListsF.loadList('ccs', 'lists/ccs/user', $scope.user.$id, 'array', 'ccsUser-' + $scope.user.$id);
                    }
                    return $q.all(promises);
                }).then(function (resp) {
                    $log.log(resp);
                    $scope.globalNotifications = resp.globalNotifications;
                    $scope.allPayrollsCcs = groupByFieldFilter(resp.allCcs, 'payroll', undefined, undefined, '$id');
                    if (!$scope.userAccessToAllPayrolls) {
                        $scope.payrollsCcsUser = createCcsByPayrollsOfUserFilter(resp.userPayrolls, groupByFieldFilter(resp.userCcs, 'payroll'), groupByFieldFilter(resp.allCcs, 'payroll'));
                        $scope.originalPayrollsCssUser = angular.fromJson(angular.toJson($scope.payrollsCcsUser));
                    }
                    resolve(true);
                }).catch(reject);
            });
        }
        function showDisabledMessage(active) {
            if (!active) {
                errAlertS('Se desactivaran las notificaciones globales al desactivar a este usuario');
            }
        }
        function transformChip(chip) {
            if (angular.isString(chip)) {
                return chip;
            } else {
                return chip.$id;
            }
        }
        function setAvailableGroups(avoidChange) {
            $scope.availableGroups = $filter('availableGroups')($scope.L.groups, $scope.user.firm);
            if (!avoidChange) {
                if ($scope.F.centers.indexOf($scope.user.firm) === -1) {
                    $scope.user.groupsOfUser = {
                        clientes: true
                    };
                } else {
                    $scope.user.groupsOfUser = {};
                }
                $scope.groupsOfUser = getArrayOfKeysFilter($scope.user.groupsOfUser);
                $scope.payrollsCcsUser = [];
            }
        }
        function addPayrollToUser(payroll) {
            payroll.ccs = [];
            $scope.payrollsCcsUser.push(payroll);
            $scope.newPayroll = null;
        }
        function getCcsOfPayrolls(search, payroll) {
            return new Promise(function (resolve) {
                //se convierte el objeto de los centros de costos en array para poder filtrarlos
                var thisCcs = $filter('objsToArray')($scope.allPayrollsCcs[payroll]);
                //se añade la opción todos para agregar todos los ccs en una sola tirada
                thisCcs.push({
                    '$id': 'all',
                    'name': 'TODOS'
                });
                //se filtran los datos según la búsqueda del usuario
                thisCcs = $filter('filter')(thisCcs, search);
                //se regresa el resultado de los datos
                resolve(thisCcs);
            });
        }
        function sendResetPass(user) {
            $rootScope.loadingProgress = true;
            var secondaryConnection;
            try {
                secondaryConnection = firebase.app('secondary');
            } catch (e) {
                secondaryConnection = firebase.initializeApp($window.__env.FB_CONFIG, 'secondary');
            }
            secondaryConnection.auth().sendPasswordResetEmail(user.data.email).then(function () {
                secondaryConnection.auth().signOut().then(function () {
                    successAlertS('Se mandó un correo para que el usuario asigne su password');
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync(function () {
                        $log.debug('sendPasswordResetEmail finished');
                    });
                }).catch(function (err) {
                    errAlertS(err);
                    secondaryConnection.auth().signOut();
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                });
            }).catch(function (err) {
                errAlertS(err);
                secondaryConnection.auth().signOut();
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
            });
        }
        function showModalSendResetPass(e) {
            var confirm = $mdDialog.confirm()
                .title('Restablecer contraseña')
                .htmlContent('<p>Envía un correo electrónico a ' + $scope.user.data.email + ' de restablecimiento de la contraseña.</p><p>La liga del correo caduca en 20 minutos</p>')
                .targetEvent(e)
                .ok('Mandar')
                .cancel('Cancelar');
            $mdDialog.show(confirm).then(function () {
                sendResetPass($scope.user);
            }).catch(function () { });
        }
        function changeEmail(userId, email) {
            if (angular.isDefined(email) && angular.isDefined(userId)) {
                $rootScope.loadingProgress = true;
                $http({
                    method: 'POST',
                    url: $window.__env.serviceWorkerUrl + 'fb/changeEmailUser/' + userId + '/' + email,
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                }).then(function () {
                    successAlertS('Se cambio la cuenta con éxito');
                }).catch(function (responseError) {
                    errAlertS(responseError);
                }).then(function () {
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                });
            }
        }
        function showModalChangeEmailDialog(e, email) {
            var confirm = $mdDialog.prompt()
                .title('Cambiar correo de la cuenta')
                .placeholder('Correo electrónico')
                .ariaLabel('Correo electrónico')
                .initialValue(email)
                .targetEvent(e)
                .ok('Cambiar')
                .cancel('Cancelar');
            $mdDialog.show(confirm).then(function (resp) {
                if (angular.isUndefined(resp) || resp === '' || !$filter('isEmail')(resp)) {
                    errAlertS('El correo no es valido, intente nuevamente');
                    $scope.changeEmail(e, email);
                } else {
                    changeEmail($scope.user.uid, resp);
                }
            }).catch(function () { });
        }
        function showModalChangePassword(userId, ev) {
            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: ev,
                locals: { userId: userId },
                templateUrl: 'app/main/config/views/users/dialogs/changePassword.html',
                controller: 'ChangePasswordController',
                controllerAs: 'changePassCtrl'
            });
        }
        function createProfile(user) {
            var object = $scope.D.prepareObject(user, 1, 0);
            object.center = AppF.centers.indexOf(object.firm) === -1 ? AppF.center : object.firm;
            return $scope.F.root.child('profiles').child(user.uid).set(object);
        }
        function disableGlobalNotifications(doIt) {
            return new Promise(function (resolve, reject) {
                try {
                    var updates = {};
                    for (var i = 0; i < $scope.globalNotifications.length && doIt; i++) {
                        if (['created', 'updated'].indexOf($scope.globalNotifications[i].$id) === -1) {
                            var id = $scope.globalNotifications[i].$id;
                            loopEachFilter($scope.globalNotifications[i], function (statusData, status) {
                                if (angular.isObject(statusData) && statusData.users) {
                                    loopEachFilter(statusData.users, function (value, thisUser) {
                                        if (thisUser === $scope.user.uid) {
                                            updates[id + '/' + status + '/users/' + thisUser] = null;
                                        }
                                    });
                                }
                            });
                        }
                    }
                    $log.log(updates);
                    AppF.root.child('settings/globalNotifications').update(updates).then(function () {
                        resolve(updates);
                    }).catch(function (error) {
                        reject(error);
                    });
                } catch (error) {
                    reject(error);
                }
            });
        }
        function processRealCcs(payroll, action, updates) {
            updates = angular.isDefined(updates) ? updates : {};
            if (angular.isDefined(payroll.$id) && $scope.allPayrollsCcs[payroll.$id]) {
                var thisCcs = $scope.allPayrollsCcs[payroll.$id];
                updates[payroll.$id] = updates[payroll.$id] ? updates[payroll.$id] : {};
                if (action === 'delete') {
                    payroll.ccs = [];
                    updates[payroll.$id]['all'] = null;
                }
                var allSetted = false;
                if (payroll.ccs.indexOf('all') > -1) {
                    updates[payroll.$id]['all'] = true;
                    allSetted = true;
                } else {
                    updates[payroll.$id]['all'] = null;
                }
                loopEachFilter(thisCcs, function (data, t) {
                    if (payroll.ccs.indexOf(t) > -1 && !allSetted) {
                        updates[payroll.$id][t] = true;
                    } else {
                        updates[payroll.$id][t] = null;
                    }
                });
            } else if (payroll.$id) {
                updates[payroll.$id] = updates[payroll.$id] ? updates[payroll.$id] : {};
                updates[payroll.$id]['all'] = null;
            }
            return updates;
        }
        function saveInvolvedRecords(userId) {
            return new Promise(function (resolve, reject) {
                try {
                    var updates = {};
                    var originalPayrollsCssUser = $filter('orderBy')($scope.originalPayrollsCssUser, '$id');
                    var payrollsCcsUser = $filter('orderBy')($scope.payrollsCcsUser, '$id');
                    for (var i = 0; i < payrollsCcsUser.length; i++) {
                        var thisPayroll = payrollsCcsUser[i];
                        var index = originalPayrollsCssUser.findIndex(function (item) {
                            return item.$id === thisPayroll.$id;
                        });
                        if (index > -1) {
                            updates = processRealCcs(thisPayroll, 'update', updates);
                            originalPayrollsCssUser.splice(index, 1);
                        } else if (thisPayroll.ccs.length > 0) {
                            updates = processRealCcs(thisPayroll, 'add', updates);
                        }
                    }
                    for (var j = 0; j < originalPayrollsCssUser.length; j++) {
                        var thisOriginalPayroll = originalPayrollsCssUser[j];
                        updates = processRealCcs(thisOriginalPayroll, 'delete', updates);
                    }
                    var queries = {};
                    loopEachFilter(updates, function (data, u) {
                        queries[u] = AppF.root.child('catalogs/involvedRecords/collection').orderByChild('payroll').equalTo(u).once('value');
                    });
                    var promise = Object.keys(queries).length > 0 ? $q.all(queries) : Promise.all([]);
                    promise.then(function (resp) {
                        resp = angular.isArray(resp) ? {} : resp;
                        var realUpdates = {};
                        loopEachFilter(resp, function (snapshot, payrollId) {
                            var involvedRecordId;
                            snapshot.forEach(function (childSnapshot) {
                                involvedRecordId = childSnapshot.key;
                            });
                            var isNewRecord = false;
                            if (angular.isUndefined(involvedRecordId)) {
                                isNewRecord = true;
                                involvedRecordId = AppF.root.child('catalogs/involvedRecords/collection').push().key;
                            }
                            var ccs = updates[payrollId];
                            var allNull = true;
                            loopEachFilter(ccs, function (value, ccId) {
                                if (value !== null) {
                                    allNull = false;
                                }
                                realUpdates[involvedRecordId + '/users/' + ccId + '/' + $scope.userId] = value;
                            });
                            realUpdates[involvedRecordId + '/payrollUsers/' + $scope.user.$id] = allNull ? null : true;
                            if (isNewRecord && !allNull) {
                                realUpdates[involvedRecordId + '/payroll'] = payrollId;
                                realUpdates[involvedRecordId + '/created'] = $scope.D.getTimeObject();
                            }
                        });
                        $log.log(realUpdates);
                        return AppF.root.child('catalogs/involvedRecords/collection').update(realUpdates);
                    }).then(function () {
                        resolve(userId);
                    }).catch(reject);
                } catch (error) {
                    reject(error);
                }
            });
        }
        function saveGroups(userId, groups, originalGroups) {
            return $q(function (resolve, reject) {
                var updates = {};
                for (var g = 0; g < groups.length; g++) {
                    var thisGroup = groups[g];
                    updates['/groups/' + thisGroup + '/users/' + userId] = true;
                    updates['/profiles/' + userId + '/groupsOfUser/' + thisGroup] = true;
                    var indexG = originalGroups.findIndex(function (item) {
                        return item === thisGroup;
                    });
                    if (indexG > -1) {
                        originalGroups.splice(indexG, 1);
                    }
                }
                for (var o = 0; o < originalGroups.length; o++) {
                    var thisG = originalGroups[o];
                    updates['/groups/' + thisG + '/users/' + userId] = null;
                    updates['/profiles/' + userId + '/groupsOfUser/' + thisG] = null;
                }
                $log.log(updates);
                $scope.F.root.update(updates, function (error) {
                    if (error) {
                        reject(error);
                    } else {
                        $scope.groupsOfUser = getArrayOfKeysFilter($scope.user.groupsOfUser);
                        resolve(true);
                    }
                });
            });
        }
        function addAndMaybeSetGroups(user) {
            $rootScope.loadingProgress = true;
            var secondaryConnection;
            try {
                secondaryConnection = firebase.app('secondary');
            } catch (e) {
                secondaryConnection = firebase.initializeApp($window.__env.FB_CONFIG, 'secondary');
            }
            var uid;
            var groups = [];
            secondaryConnection.auth().createUserWithEmailAndPassword(user.data.email, $scope.F.pass).then(function (u) {
                uid = u.uid;
                return secondaryConnection.auth().signOut();
            }).then(function () {
                user.uid = uid;
                if (!$scope.F.isDistributor()) {
                    user.firm = $scope.F.profile.firm;
                }
                user.emailVerified = false;
                if (user.groupsOfUser) {
                    groups = $scope.groupsOfUser;
                } else {
                    var gName = AppF.centers.indexOf(user.firm) > -1 ? 'ejecutivos' : 'clientes';
                    groups.push(gName);
                }
                return createProfile(user);
            }).then(function () {
                return saveGroups(uid, groups, []);
            }).then(function () {
                return saveInvolvedRecords(uid);
            }).then(function () {
                $scope.user.$id = user.uid;
                successAlertS('Se creó Usuario con éxito');
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync(function () {
                    $log.debug($scope.user, 'saved on FB');
                });
                $scope.R.goToList();
            }).catch(function (err) {
                errAlertS(err);
                secondaryConnection.auth().signOut();
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
            });
        }
        function saveAndMaybeSetGroups(user) {
            $scope.save(user, 1).then(function () {
                $rootScope.loadingProgress = true;
                return saveGroups(user.$id, $scope.groupsOfUser, $scope.originalGroupsOfUser);
            }).then(function () {
                return saveInvolvedRecords(user.$id);
            }).then(function () {
                return disableGlobalNotifications(!user.active);
            }).then(function () {
                successAlertS('Se guardó Usuario con éxito');
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync(function () {
                    $log.debug('saveAndMaybeSetGroups finished');
                });
                $scope.R.goToList();
            }).catch(function (err) {
                errAlertS(err);
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
                $scope.R.goToList();
            });
        }
        $scope.setAccessAllPermission = setAccessAllPermission;
        $scope.showDisabledMessage = showDisabledMessage;
        $scope.transformChip = transformChip;
        $scope.setAvailableGroups = setAvailableGroups;
        $scope.addPayrollToUser = addPayrollToUser;
        $scope.getCcsOfPayrolls = getCcsOfPayrolls;
        $scope.showModalChangeEmailDialog = showModalChangeEmailDialog;
        $scope.showModalSendResetPass = showModalSendResetPass;
        $scope.showModalChangePassword = showModalChangePassword;
        $scope.loadMfaStatus = loadMfaStatus;
        $scope.showModalDisableMfa = showModalDisableMfa;
        $scope.addAndMaybeSetGroups = addAndMaybeSetGroups;
        $scope.saveAndMaybeSetGroups = saveAndMaybeSetGroups;
        startAfterInitFilter($scope, watchers, initiated, init);
    }
})();

/* eslint-disable no-inner-declarations */
(function () {
    'use strict';

    angular
        .module('app.config')
        .controller('TicketController', TicketController);

    function TicketController($scope, ApiV3F, $mdDialog, confirmConfig, getSomethingOfArrayFBFilter, getSomethingOfArrayMFilter, errAlertS, $rootScope, $log, successAlertS, $timeout, clearObjectFilter, DataF, userHasPermissionFilter, AppF, startAfterInitFilter, $document, $q) {
        var initiated = false;
        var watchers = {};
        var taskSectionRequestId = 0;
        function init() {
            var promises = [$scope.dataNeededPromise, $scope.statesObjsPromise, $scope.mainObjectLoaded];
            Promise.all(promises).then(function () {
                $scope.editAllPermission = userHasPermissionFilter(AppF.groupsOfUser, AppF.permissions, 'editAll', 'config.tickets');
                $scope.setAssign = userHasPermissionFilter(AppF.groupsOfUser, AppF.permissions, 'setAssign', 'config.tickets');
                $scope.projectManagerPermissions = {
                    read: userHasPermissionFilter(AppF.groupsOfUser, AppF.permissions, 'read', 'apps.project-manager'),
                    access: userHasPermissionFilter(AppF.groupsOfUser, AppF.permissions, 'access', 'apps.project-manager'),
                    list: userHasPermissionFilter(AppF.groupsOfUser, AppF.permissions, 'list', 'apps.project-manager'),
                    createTask: userHasPermissionFilter(AppF.groupsOfUser, AppF.permissions, 'createTask', 'apps.project-manager'),
                    deleteTask: userHasPermissionFilter(AppF.groupsOfUser, AppF.permissions, 'deleteTask', 'apps.project-manager')
                };
                $log.log($scope.projectManagerPermissions, 'projectManagerPermissions')
                var data = []
                AppF.root.child('profiles').orderByChild('groupsOfUser/programadores').equalTo(true).once('value').then(function (snapshot) {
                    var usuarios = snapshot.val();
                    for (var key in usuarios) {
                        var user = usuarios[key];
                        data.push(user);
                        $log.log('usuario', user);
                    }
                })
                $scope.userAssign = data;
                initTaskManager();
            }).catch(errAlertS);
        }
        $scope.downloadFileRp = $scope.D.files.downloadFileRp
        $scope.actions = {};

        $scope.taskManager = {
            projects: [],
            sections: [],
            tasks: [],
            project: null,
            sectionId: null,
            priorities: [],
            priorityKey: null,
            title: '',
            description: '',
            loadingProjects: false,
            loadingSections: false,
            loadingTasks: false,
            saving: false,
            deleting: {},
            selectedTab: 1
        };

        function initTaskManager() {
            if (!$scope.ticket || !$scope.ticket._id) {
                return;
            }
            resetTaskDraft();
            if (!$scope.projectManagerPermissions.list) {
                $scope.taskManager.accessDenied = true;
                return;
            }
            loadTaskProjects().then(loadTicketTasks);
        }

        function resetTaskDraft() {
            var ticketId = $scope.ticket && $scope.ticket._id;
            var ticketTitle = ($scope.ticket && $scope.ticket.title) || '';

            taskSectionRequestId++;
            $scope.taskManager.project = null;
            $scope.taskManager.sectionId = null;
            $scope.taskManager.sections = [];
            $scope.taskManager.priorities = [];
            $scope.taskManager.priorityKey = null;
            $scope.taskManager.loadingSections = false;
            $scope.taskManager.title = 'Ticket ' + ticketId + (ticketTitle ? ': ' + ticketTitle : '');
            $scope.taskManager.description = ($scope.ticket && $scope.ticket.description) || '';
        }

        $scope.openTaskManagerForm = function (event) {
            if (!$scope.projectManagerPermissions.createTask || !$scope.taskManager.projects.length) {
                return;
            }
            resetTaskDraft();
            return $mdDialog.show({
                templateUrl: 'app/main/config/views/tickets/dialogs/task-manager-task.dialog.html',
                parent: angular.element($document[0].querySelector('#ticketS')),
                targetEvent: event,
                clickOutsideToClose: false,
                escapeToClose: false,
                preserveScope: true,
                scope: $scope
            }).catch(angular.noop);
        };

        $scope.cancelTaskManagerForm = function () {
            if ($scope.taskManager.saving) {
                return;
            }
            resetTaskDraft();
            $mdDialog.cancel();
        };

        function responseArray(response) {
            if (!response || !response.data) {
                return [];
            }
            if (angular.isArray(response.data)) {
                return response.data;
            }
            return angular.isArray(response.data.records) ? response.data.records : [];
        }

        function taskManagerRequest(requestFn, hasRetried) {
            return requestFn().catch(function (error) {
                var user = firebase.auth().currentUser;
                var unauthorized = error && (error.status === 401 || error.status === 403);

                if (!hasRetried && unauthorized && user) {
                    return $q.when(user.getIdToken(true)).then(function () {
                        return taskManagerRequest(requestFn, true);
                    });
                }
                return $q.reject(error);
            });
        }

        function getAllTaskManagerRecords(path, query, page, accumulated) {
            var currentPage = page || 1;
            var records = accumulated || [];
            var params = angular.extend({}, query, {
                page: currentPage,
                size: query.size || 100
            });

            return taskManagerRequest(function () {
                return ApiV3F.get(path, params);
            }).then(function (response) {
                var currentRecords = responseArray(response);
                var pagination = response && response.data && response.data.pagination;
                var allRecords = records.concat(currentRecords);

                if (pagination && allRecords.length < pagination.total && currentRecords.length) {
                    return getAllTaskManagerRecords(path, query, currentPage + 1, allRecords);
                }
                return allRecords;
            });
        }

        function taskManagerError(error, fallback) {
            var message = error && error.data && error.data.message;
            return { message: message || fallback };
        }

        function isTaskFromCurrentTicket(task) {
            var generateFrom = task && task.generateFrom;
            return generateFrom &&
                Object.prototype.hasOwnProperty.call(generateFrom, 'ticket') &&
                String(generateFrom.ticket) === String($scope.ticket._id);
        }

        function getTicketOrigin() {
            var ticketId = $scope.ticket && $scope.ticket._id;
            return {
                value: angular.isNumber(ticketId) ? ticketId : String(ticketId),
                type: angular.isNumber(ticketId) ? 'number' : 'string'
            };
        }

        function loadTaskProjects() {
            var user = firebase.auth().currentUser;
            if (!user) {
                errAlertS({ message: 'El usuario no tiene una sesión activa.' });
                return $q.when([]);
            }
            $scope.taskManager.loadingProjects = true;
            return getAllTaskManagerRecords('project-manager/projects', {
                active: true,
                archived: false,
                size: 100
            }).then(function (projects) {
                $scope.taskManager.projects = projects;
                return projects;
            }).catch(function (error) {
                $log.error('Task Manager projects error', error);
                errAlertS(taskManagerError(error, 'No fue posible consultar los proyectos de Task Manager.'));
                $scope.taskManager.projects = [];
                return [];
            }).finally(function () {
                $scope.taskManager.loadingProjects = false;
            });
        }

        function loadTicketTasks() {
            var projects = $scope.taskManager.projects || [];

            if (!$scope.ticket || !$scope.ticket._id || !projects.length) {
                $scope.taskManager.tasks = [];
                return $q.when([]);
            }

            $scope.taskManager.loadingTasks = true;
            return $q.all(projects.map(function (project) {
                var origin = getTicketOrigin();
                return getAllTaskManagerRecords('project-manager/projects/' + encodeURIComponent(project._id) + '/tasks', {
                    originKey: 'ticket',
                    originValue: origin.value,
                    originValueType: origin.type,
                    active: true,
                    size: 100
                }).then(function (tasks) {
                    return tasks.map(function (task) {
                        task.projectId = task.projectId || project._id;
                        return task;
                    });
                }).catch(function (error) {
                    $log.warn('Task Manager project tasks error', project._id, error);
                    return [];
                });
            }))
                .then(function (taskGroups) {
                    $scope.taskManager.tasks = [].concat.apply([], taskGroups).filter(isTaskFromCurrentTicket);
                })
                .catch(function (error) {
                    $log.error('Task Manager tasks error', error);
                    errAlertS(taskManagerError(error, 'No fue posible consultar las tareas asociadas al ticket.'));
                })
                .finally(function () {
                    $scope.taskManager.loadingTasks = false;
                });
        }

        function getActiveCatalogItems(items) {
            return (items || []).filter(function (item) {
                return item.active !== false;
            }).sort(function (a, b) {
                return (a.order || 0) - (b.order || 0);
            });
        }

        function getDefaultCatalogItem(items) {
            var activeItems = getActiveCatalogItems(items);
            var selected = activeItems.filter(function (item) {
                return item.isDefault === true;
            })[0] || activeItems[0];

            if (!selected) {
                throw new Error('El proyecto no tiene un catálogo de prioridades activo.');
            }

            return selected;
        }

        function getSelectedCatalogItem(items, key) {
            var selected = getActiveCatalogItems(items).filter(function (item) {
                return String(item.key) === String(key);
            })[0];

            if (!selected) {
                throw new Error('Selecciona una prioridad válida.');
            }
            return selected;
        }

        $scope.onTaskProjectChange = function () {
            var project = $scope.taskManager.project;
            var requestId = ++taskSectionRequestId;
            var defaultPriority;

            $scope.taskManager.sectionId = null;
            $scope.taskManager.sections = [];
            $scope.taskManager.priorities = [];
            $scope.taskManager.priorityKey = null;
            $scope.taskManager.loadingSections = false;
            if (!project || !project._id) {
                return;
            }

            try {
                $scope.taskManager.priorities = getActiveCatalogItems(project.priorityCatalog);
                defaultPriority = getDefaultCatalogItem(project.priorityCatalog);
                $scope.taskManager.priorityKey = defaultPriority.key;
            } catch (error) {
                errAlertS(error);
                return;
            }

            $scope.taskManager.loadingSections = true;
            getAllTaskManagerRecords('project-manager/projects/' + encodeURIComponent(project._id) + '/sections', {
                active: true,
                archived: false,
                size: 100
            })
                .then(function (sections) {
                    if (requestId === taskSectionRequestId) {
                        $scope.taskManager.sections = sections;
                    }
                })
                .catch(function (error) {
                    if (requestId !== taskSectionRequestId) {
                        return;
                    }
                    $log.error('Task Manager sections error', error);
                    errAlertS(taskManagerError(error, 'No fue posible consultar las secciones del proyecto.'));
                })
                .finally(function () {
                    if (requestId === taskSectionRequestId) {
                        $scope.taskManager.loadingSections = false;
                    }
                });
        };

        $scope.createTaskManagerTask = function () {
            var taskManager = $scope.taskManager;
            var user = firebase.auth().currentUser;
            var priority;
            var data;

            if (taskManager.saving || !$scope.projectManagerPermissions.createTask || !user || !taskManager.project || !taskManager.sectionId || !taskManager.priorityKey || !String(taskManager.title || '').trim()) {
                return;
            }

            try {
                priority = getSelectedCatalogItem(taskManager.project.priorityCatalog, taskManager.priorityKey);
            } catch (error) {
                errAlertS(error);
                return;
            }

            data = {
                projectId: taskManager.project._id,
                sectionId: taskManager.sectionId,
                title: String(taskManager.title).trim(),
                description: String(taskManager.description || '').trim() || null,
                priorityKey: priority.key,
                assignedTo: null,
                dueDate: null,
                generateFrom: {
                    ticket: getTicketOrigin().value
                }
            };

            taskManager.saving = true;
            taskManagerRequest(function () {
                return ApiV3F.post('project-manager/tasks', data);
            })
                .then(function () {
                    successAlertS('La tarea se agregó a Task Manager.');
                    resetTaskDraft();
                    $mdDialog.hide();
                    return loadTicketTasks();
                })
                .catch(function (error) {
                    $log.error('Task Manager create error', error);
                    errAlertS(taskManagerError(error, 'No fue posible crear la tarea. Puede volver a intentarlo.'));
                })
                .finally(function () {
                    taskManager.saving = false;
                });
        };

        $scope.deleteTaskManagerTask = function (task, event) {
            var taskId = task && (task._id || task.id);
            var projectId = task && task.projectId;

            if (!taskId || !projectId || !$scope.projectManagerPermissions.deleteTask || $scope.taskManager.deleting[taskId]) {
                return;
            }

            $mdDialog.show(
                $mdDialog.confirm(confirmConfig)
                    .title('Eliminar tarea')
                    .textContent('La tarea se eliminará de Task Manager. Esta acción no edita ni elimina el ticket.')
                    .ariaLabel('Eliminar tarea de Task Manager')
                    .targetEvent(event)
                    .ok('Eliminar')
                    .cancel('Cancelar')
            ).then(function () {
                $scope.taskManager.deleting[taskId] = true;
                return taskManagerRequest(function () {
                    return ApiV3F.delete(
                        'project-manager/projects/' + encodeURIComponent(projectId) +
                        '/tasks/' + encodeURIComponent(taskId)
                    );
                })
                    .then(function () {
                        successAlertS('La tarea se eliminó de Task Manager.');
                        return loadTicketTasks();
                    })
                    .catch(function (error) {
                        $log.error('Task Manager delete error', error);
                        errAlertS(taskManagerError(error, 'No fue posible eliminar la tarea.'));
                    })
                    .finally(function () {
                        delete $scope.taskManager.deleting[taskId];
                    });
            }).catch(angular.noop);
        };

        function getTaskProject(projectId) {
            return $scope.taskManager.projects.filter(function (item) {
                return String(item._id) === String(projectId);
            })[0];
        }

        function getTaskCatalogColor(task, catalogName, keyName, fallback) {
            var project = getTaskProject(task && task.projectId);
            var key = task && task[keyName];
            var item = project && (project[catalogName] || []).filter(function (catalogItem) {
                return String(catalogItem.key) === String(key);
            })[0];
            return item && item.color ? item.color : fallback;
        }

        $scope.taskProjectTitle = function (projectId) {
            var project = getTaskProject(projectId);
            return project ? project.title : projectId;
        };

        $scope.taskStatusColor = function (task) {
            return getTaskCatalogColor(task, 'statusCatalog', 'statusKey', '#64748B');
        };

        $scope.taskPriorityColor = function (task) {
            return getTaskCatalogColor(task, 'priorityCatalog', 'priorityKey', '#F59E0B');
        };


        $scope.addTracking = function (trackingMsg, pendingImages) {
            if (!angular.isArray($scope.ticket.trackings)) $scope.ticket.trackings = [];
            var msg = (trackingMsg || '').trim();
            var imgs = (pendingImages || []).filter(function (x) { return x && x.file; });
            if (!msg && !imgs.length) {
                return;
            }
            $scope.ticket.trackings.unshift({
                msg: msg,
                created: DataF.getTimeObject(),
                imagesLocal: imgs.map(function (x) {
                    return { file: x.file, preview: x.preview, name: x.file.name };
                }),
                images: []
            });

            $scope.actions.newTracking = '';
            $scope.actions.pendingImages = [];
            $scope.actions.showAddTracking = false;
        };
        $scope.canEditTracking = function (track) {
            return !!(track && $scope.ticket && $scope.ticket.trackings &&
                $scope.ticket.trackings[0] === track && track.created &&
                $scope.F.user && track.created.by === $scope.F.user.uid &&
                !$scope.F.readMode && $scope.editAllPermission && !$rootScope.loadingProgress);
        };

        $scope.editTracking = function (track, event) {
            if (!$scope.canEditTracking(track)) return;
            var original = track.msg || '';
            $mdDialog.show($mdDialog.prompt()
                .title('Editar último seguimiento')
                .textContent('El cambio se guardará con el ticket y se mostrará como editado.')
                .placeholder('Seguimiento')
                .initialValue(original)
                .targetEvent(event)
                .ok('Aplicar')
                .cancel('Cancelar'))
                .then(function (value) {
                    if (!$scope.canEditTracking(track) || (track.msg || '') !== original) return;
                    var msg = (value || '').trim();
                    if (msg === original) return;
                    if (!msg && !(track.images && track.images.length) &&
                        !(track.imagesLocal && track.imagesLocal.length)) {
                        errAlertS('El seguimiento debe contener texto o una imagen.');
                        return;
                    }
                    track.msg = msg;
                    track.edited = DataF.getTimeObject();
                    $scope.form.$setDirty();
                }, angular.noop);
        };

        function save() {
            try {
                $rootScope.loadingProgress = true;
                var hasFile = !!($scope.files && ($scope.files.length || $scope.files.lfFile));
                function getData() {
                    return clearObjectFilter ? clearObjectFilter($scope.ticket) : angular.copy($scope.ticket);
                }
                function setTimes(data, isNew) {
                    if (isNew) {
                        data.created = data.created || $scope.D.getTimeObject();
                    } else {
                        data.updated = $scope.D.getTimeObject();
                    }
                    return data;
                }
                if (!$scope.ticket._id) {
                    $scope.ticket.status = 1;

                    var createData = setTimes(getData(), true);
                    delete createData.files;

                    return ApiV3F.post('api/ticket/', createData)
                        .then(function (resp) {
                            var insertedId = resp && resp.data && resp.data.insertedId;
                            if (!insertedId) throw new Error('POST no regresó insertedId');

                            $scope.ticket._id = insertedId;

                            return uploadPendingTrackingImages(insertedId).then(function () {
                                if (!hasFile) return null;
                                return uploadFile($scope.files, insertedId, 'img1');
                            });
                        })
                        .then(function (uploadResp) {
                            if (uploadResp && uploadResp.url) $scope.ticket.files = uploadResp.url;

                            // ✅ el PUT final de creación (guardas trackings ya con urls)
                            var updateData = setTimes(getData(), false); // aquí puedes poner updated si quieres
                            updateData.status = 1;
                            updateData.trackings = $scope.ticket.trackings;

                            // importantísimo: no mandar basura local
                            if (updateData.trackings && updateData.trackings.length) {
                                updateData.trackings.forEach(function (t) { delete t.imagesLocal; });
                            }

                            return ApiV3F.put('api/ticket/' + $scope.ticket._id, updateData);
                        })
                        .then(function (resp) {
                            $scope.ticket.created = $scope.D.getTimeObject();
                            sendNotificationWsp($scope.ticket);
                            ApiV3F.post('api/archivedTicket/', $scope.ticket).then(function (resp) {
                                $log.log('Ticket archivado', resp);
                            })
                            finish(resp);
                        })
                        .catch(function (err) {
                            $log.log(err);
                            fail(err);
                        });
                }
                var uploadPromise = Promise.resolve(null);
                if (hasFile) uploadPromise = uploadFile($scope.files, $scope.ticket._id, 'img1');
                uploadPendingTrackingImages($scope.ticket._id)
                    .then(function () {
                        return uploadPromise;
                    })
                    .then(function (uploadResp) {
                        if (uploadResp && uploadResp.url) $scope.ticket.files = uploadResp.url;

                        var data = setTimes(getData(), false); // updated
                        data.status = 2;
                        data.trackings = $scope.ticket.trackings;

                        // limpiar local
                        if (data.trackings && data.trackings.length) {
                            data.trackings.forEach(function (t) { delete t.imagesLocal; });
                        }

                        return ApiV3F.put('api/ticket/' + $scope.ticket._id, data);
                    })
                    .then(function (resp) {
                        $scope.ticket.updated = $scope.D.getTimeObject();
                        $scope.ticket.status = 2;
                        sendEmailNotification($scope.ticket);
                        ApiV3F.put('api/archivedTicket/' + $scope.ticket._id, $scope.ticket).then(function (resp) {
                            $log.log('Ticket archivado', resp);
                        })
                        finish(resp);
                    })
                    .catch(fail);


                function finish(resp) {
                    $log.log(resp);
                    $log.log('data')
                    if (resp && resp.data) {
                        $scope.ticket = resp.data;
                    }
                    successAlertS('Se ha guardo el registro con éxito');
                    $rootScope.$emit('mongoCatalogCreated', { name: 'ticket', data: $scope.ticket });
                    $log.log($scope.ticket, 'saved on Mongo');
                    $scope.R.goToList();
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync(function () {
                        $log.debug($scope.ticket, 'saved on Mongo');
                    });
                }
                function fail(err) {
                    $log.error('save error', err);
                    errAlertS(err);
                    $rootScope.loadingProgress = false;
                }

            } catch (error) {
                errAlertS(error);
                $rootScope.loadingProgress = false;
            }
        }

        function sendNotificationWsp(updateData) {
            $log.log('Enviando notificación WhatsApp', updateData)
            var userName = getSomethingOfArrayFBFilter(updateData.created.by, $scope.L.profiles, 'name', false)
            var params = {
                module: updateData.module.toUpperCase(),
                priority: updateData.priority,
                date: moment(updateData.created.atTime).format('DD-MM-YYYY'),
                title: updateData.title.toUpperCase(),
                description: updateData.description.toUpperCase(),
                user: userName.toUpperCase()
            }
            ApiV3F.post('notifications/ticket', params).then(function (resp) {
                $log.log('Notificación enviada', resp)
            })
        }


        function sendEmailNotification(updateData) {
            $log.log('Enviando notificación Email', updateData)
            var createdBy = updateData && updateData.created ? updateData.created.by : null;
            var userEmail = createdBy ? getSomethingOfArrayFBFilter(createdBy, $scope.L.profiles, 'email', false) : '';
            var lastTracking = '';
            if (angular.isArray(updateData.trackings) && updateData.trackings.length) {
                var sorted = updateData.trackings.slice().sort(function (a, b) {
                    var atA = (a && a.created && angular.isNumber(a.created.atTime)) ? a.created.atTime : 0;
                    var atB = (b && b.created && angular.isNumber(b.created.atTime)) ? b.created.atTime : 0;
                    return atB - atA;
                });

                lastTracking = (sorted[0] && sorted[0].msg) ? sorted[0].msg : '';
            }

            // fecha segura
            var createdAt = (updateData && updateData.created && updateData.created.atTime)
                ? updateData.created.atTime
                : Date.now();

            var params = {
                module: (updateData.module || '').toString().toUpperCase(),
                priority: updateData.priority,
                date: moment(createdAt).format('DD-MM-YYYY'),
                title: (updateData.title || '').toString().toUpperCase(),
                description: (updateData.description || '').toString().toUpperCase(),
                user: userEmail,
                status: updateData.status,
                trackings: lastTracking
            };

            $log.log('correo', userEmail);

            return ApiV3F.post('form/sendEmailContactTicket', params)
                .then(function (resp) {
                    $log.log(resp);
                    return resp;
                })
                .catch(function (err) {
                    $log.error('sendEmailNotification error', err);
                    throw err;
                });
        }


        function uploadFile(files, id, fileName) {
            var item = angular.isArray(files) ? files[0] : files;
            var file = null;
            if (item instanceof File) {
                file = item;
            }
            else if (item && item.lfFile instanceof File) {
                file = item.lfFile;
            }
            else if (item && item.file instanceof File) {
                file = item.file;
            }
            if (!file) {
                return Promise.reject(new Error('No se recibió archivo válido (File/lfFile).'));
            }
            var ext = (file.name && file.name.includes('.')) ? file.name.split('.').pop() : '';
            var finalName = ext ? (fileName + '.' + ext) : fileName;
            var finalRef = "tickets/" + id + "/" + finalName;
            var fileRef = firebase.storage().ref(finalRef);
            return fileRef.put(file).then(function (snapshot) {
                return snapshot.ref.getDownloadURL().then(function (url) {
                    return { url: url, path: finalRef, name: finalName };
                });
            });
        }


        function uploadPendingTrackingImages(ticketId) {
            if (!angular.isArray($scope.ticket.trackings) || !$scope.ticket.trackings.length) {
                return Promise.resolve();
            }
            var tasks = [];
            $scope.ticket.trackings.forEach(function (t, tIndex) {
                if (!t || !angular.isArray(t.imagesLocal) || !t.imagesLocal.length) return;
                t.images = t.images || [];
                t.imagesLocal.forEach(function (img, imgIndex) {
                    if (!img || !img.file) return;
                    var name = 'tracking_' + (t.created && t.created.atTime ? t.created.atTime : Date.now()) + '_' + tIndex + '_' + imgIndex;
                    tasks.push(
                        uploadFile(img.file, ticketId, name).then(function (r) {
                            t.images.push({ url: r.url, path: r.path, name: r.name || name });
                        })
                    );
                });
            });

            return Promise.all(tasks).then(function () {
                // ya que se subieron, elimina lo local para que no se mande al backend
                $scope.ticket.trackings.forEach(function (t) {
                    delete t.imagesLocal;
                });
            });
        }

        $scope.closeTicket = function (selected, type, event) {
            var warning = 'Está a punto de cerrar <b>' + selected.length + '</b> ticket(s).<br><br>' + 'Una vez cerrados, no podrán modificarse ni recibir nuevos seguimientos.<br>' + '¿Desea continuar?';
            $mdDialog.show(
                $mdDialog.confirm(confirmConfig)
                    .title('Confirmar cierre de tickets')
                    .htmlContent(warning)
                    .ariaLabel('ticket close confirmation')
                    .targetEvent(event)
                    .ok('Cerrar tickets')
                    .cancel('Cancelar')
            ).then(function () {
                $rootScope.loadingProgress = true;
                var requests = selected.map(function (ticket) {
                    return ApiV3F.put('api/ticket/' + ticket._id, { status: 3 });
                });
                Promise.all(requests)
                    .then(function () {
                        successAlertS(selected.length + ' ticket(s) cerrados correctamente');
                        $rootScope.$emit('mongoCatalogCreated', {
                            name: 'ticket'
                        });
                        selected[0].status = 3; // Actualizar el estado del primer ticket para reflejar el cambio en la vista
                        sendEmailNotification(selected[0]);
                        selected[0].closeDetail = DataF.getTimeObject();
                        $log.log('Seleccionado', selected[0])
                        ApiV3F.put('api/archivedTicket/' + selected[0]._id, selected[0]).then(function (resp) {
                            $log.log('Ticket archivado', resp);
                        })
                    })
                    .catch(function (err) {
                        errAlertS('Algunos tickets no pudieron cerrarse');
                        $log.error(err);
                    })
                    .finally(function () {
                        $rootScope.loadingProgress = false;
                    });

            }).catch(function () {
                $log.log('Operación cancelada por el usuario');
            });
        };


        $scope.reopenTicket = function (selected, type, event) {
            var warning =
                'Está a punto de <b>reabrir</b> <b>' + selected.length + '</b> ticket(s).<br><br>' +
                'Una vez reabiertos, podrán modificarse y recibir nuevos seguimientos.<br>' +
                '¿Desea continuar?';

            $mdDialog.show(
                $mdDialog.confirm(confirmConfig)
                    .title('Confirmar reapertura de tickets')
                    .htmlContent(warning)
                    .ariaLabel('ticket reopen confirmation')
                    .targetEvent(event)
                    .ok('Reabrir tickets')
                    .cancel('Cancelar')
            ).then(function () {
                $rootScope.loadingProgress = true;
                $log.log(selected)
                var requests = selected.map(function (ticket) {
                    return ApiV3F.put('api/ticket/' + ticket._id, { status: 2 });
                });

                Promise.all(requests)
                    .then(function () {
                        successAlertS(selected.length + ' ticket(s) reabiertos correctamente');
                        $rootScope.$emit('mongoCatalogCreated', { name: 'ticket' });
                        selected.forEach(function (t) { t.status = 2; });
                    })
                    .catch(function (err) {
                        errAlertS('Algunos tickets no pudieron reabrirse');
                        $log.error(err);
                    })
                    .finally(function () {
                        $rootScope.loadingProgress = false;
                    });

            }).catch(function () {
                $log.log('Operación cancelada por el usuario');
            });
        };

        $scope.removeFieldFile = function (field) {
            $scope.ticket[field] = '';
            $scope.form.$setDirty();
        };

        $scope.actions = $scope.actions || {};
        $scope.actions.pendingImages = [];

        $scope.pickTrackingImages = function () {
            var el = $document[0].getElementById('trackingFileInput');
            if (el) {
                el.click();
            }
        };

        $scope.onTrackingFilesSelected = function (files) {
            $scope.$applyAsync(function () {
                for (var i = 0; i < files.length; i++) {
                    var f = files[i];
                    if (!f || !/^image\//.test(f.type)) continue;

                    var item = { file: f, preview: '' };

                    (function (it, file) {
                        var reader = new FileReader();
                        reader.onload = function (e) {
                            $scope.$applyAsync(function () {
                                it.preview = e.target.result;
                            });
                        };
                        reader.readAsDataURL(file);
                    })(item, f);

                    $scope.actions.pendingImages.push(item);
                }
            });
        };

        $scope.onTrackingPaste = function (event) {
            if ($scope.F.readMode || !$scope.editAllPermission) return;

            var clipboard = (event.originalEvent || event).clipboardData;
            if (!clipboard) return;

            var images = [];
            var items = clipboard.items || [];
            for (var i = 0; i < items.length; i++) {
                if (items[i].kind === 'file' && /^image\//.test(items[i].type)) {
                    var file = items[i].getAsFile();
                    if (file) images.push(file);
                }
            }

            if (!images.length) return;
            event.preventDefault();
            $scope.onTrackingFilesSelected(images);
        };

        $scope.removePendingImage = function (idx) {
            $scope.actions.pendingImages.splice(idx, 1);
        };

        $scope.onTrackingKeydown = function (e) {
            if (e.keyCode === 13 && !e.shiftKey) {
                e.preventDefault();
                $scope.addTracking($scope.actions.newTracking, $scope.actions.pendingImages);
            }
        };

        /* visor */
        $scope.openTrackingImage = function (url, ev) {
            ev && ev.preventDefault && ev.preventDefault();
            $mdDialog.show(
                $mdDialog.alert()
                    .clickOutsideToClose(true)
                    .title('Imagen')
                    .htmlContent('<div style="text-align:center;"><img src="' + url + '" style="max-width:100%; border-radius:12px;"/></div>')
                    .ok('Cerrar')
            );
        };

        $scope.save = save;
        $scope.add = save;
        startAfterInitFilter($scope, watchers, initiated, init);

    }
})();

(function () {
    'use strict';

    angular
        .module('app.config')
        .controller('SliderImagesController', SliderImagesController);

    function SliderImagesController($scope) {
        $scope.deleteImages = function (item, event) {
            $scope.selected.splice(0, $scope.selected.length);
            $scope.selected.push(item);
            return $scope.delete(event);
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.config')
        .controller('SliderImageController', SliderImageController);

    function SliderImageController($scope, errAlertS, $rootScope, successAlertS, $timeout) {

        $scope.saveSliderImage = function (sliderImage) {
            $rootScope.loadingProgress = true;
            $timeout(function () {
                if (angular.isUndefined(sliderImage.$id) || sliderImage.$id == null) {
                    sliderImage.$id = $scope.F.root.child('catalogs/sliderImages/collection').push().key;
                }
                if (angular.isUndefined(sliderImage.created)) {
                    sliderImage.created = $scope.D.getTimeObject(0, sliderImage.created);
                }
                var promises = [];
                if (angular.isDefined($scope.files) && angular.isDefined($scope.files.length) && $scope.files.length > 0) {
                    promises.push($scope.upload($scope.files, sliderImage, true));
                }
                Promise.all(promises).then(function () {
                    return $scope.save(sliderImage, 1);
                }).then(function () {
                    successAlertS('Se guardo registro con éxito');
                    $scope.R.goToList();
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                }).catch(function (err) {
                    errAlertS(err);
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                });
            }, 0, false);
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.config')
        .controller('ProfileController', ProfileController);

    function ProfileController(
        $scope,
        $rootScope,
        $state,
        startAfterInitFilter,
        $log,
        successAlertS,
        errAlertS,
        $filter,
        $q,
        ChatF,
        $mdDialog,
        $firebaseAuth,
        confirmConfig,
        ApiV3F,
        $window
    ) {
        $scope.auth = $firebaseAuth();
        $scope.F.UniqueAndFilter = false;
        // si necesitas cargar catálogos de mongo pon sus nombres aquí
        var dataNeeded = ['regimes']; // ex: ['countries', 'states', 'regimes']
        var initiated = false;
        var watchers = {};
        // var dataFrom = '';
        // var root = $scope.F.root;
        // var storageRef = firebase.storage().ref();
        $scope.formName = 'profileForm';
        $scope.images = [];
        $scope.selectedTab = '0';
        // filters here if there are selects on form
        // ex: $scope.countrySelectFilter = '';
        $scope.editMode = false;
        $scope.CF = ChatF;
        $scope.mfa = {
            loading: false,
            loaded: false,
            error: false,
            status: null
        };

        /**
         * @name init
         * @description función de inicio del controlador
         */
        function init() {
            $scope.profile = $scope.F.profile;
            $scope.groupsOfUser = angular.copy($scope.F.groupsOfUser);
            // if data from mongo is needed, load it first
            $scope.M.loadNeeded(dataNeeded);
            initiated = true;
            loadFirm($scope.F.profile.firm);
            loadMfaStatus();
        }

        function normalizeMfaStatus(data) {
            data = data || {};
            return {
                enabled: data.enabled === true,
                factorCount: angular.isNumber(data.factorCount) ? data.factorCount : 0,
                factors: angular.isArray(data.factors) ? data.factors : []
            };
        }

        function loadMfaStatus() {
            $scope.mfa.loading = true;
            $scope.mfa.error = false;
            return ApiV3F.get('auth/mfa').then(function (response) {
                $scope.mfa.status = normalizeMfaStatus(response.data);
                $scope.mfa.loaded = true;
                return $scope.mfa.status;
            }).catch(function (error) {
                $scope.mfa.loaded = false;
                $scope.mfa.error = true;
                errAlertS(error);
                return false;
            }).finally(function () {
                $scope.mfa.loading = false;
                $rootScope.$evalAsync();
            });
        }

        function buildDisableMfaUrl() {
            var loginAppUrl = $window.__env.loginAppUrl || 'http://localhost:4200';
            var separator = loginAppUrl.indexOf('?') === -1 ? '?' : '&';
            var center = ($window.center || 'tds').toLowerCase();
            return loginAppUrl + separator + 'subdomain=' + encodeURIComponent(center) + '&action=disable-mfa';
        }

        function showModalDisableMfa(ev) {
            var confirm = $mdDialog.confirm(confirmConfig)
                .title('Deshabilitar doble factor')
                .textContent('Volverá a iniciar sesión y confirmará su código de autenticación. Al terminar se cerrará esta sesión y se revocará la renovación de las demás. ¿Desea continuar?')
                .targetEvent(ev)
                .ok('Continuar')
                .cancel('Cancelar');

            return $mdDialog.show(confirm).then(function () {
                $rootScope.loadingProgress = true;
                return $scope.auth.$signOut().then(function () {
                    $window.location.replace(buildDisableMfaUrl());
                }).catch(function (error) {
                    $rootScope.loadingProgress = false;
                    errAlertS(error);
                });
            }).catch(function () { });
        }

        function loadFirm(firm) {
            if ($scope.F.centers.indexOf(firm) === -1) {
                $log.debug('loadFirm called');
                $scope.C.loadCatalog('firm', 'catalogs/firms/collection/' + firm, false, false, 'object').then(function () {
                    $log.debug('loadFirm finished', firm, $scope.C);
                }).catch(errAlertS);
            }
        }

        /**TODO: pasar función a API
         * @name saveProfile
         * @description Guarda perfil
         * @param {Profile} profile perfil a ser guardado
         * @param {Boolean} promise si la función es una promesa o no, por default NO
         */
        function saveProfile(profile, promise) {
            $log.debug('saving profile', profile);
            $rootScope.loadingProgress = true;
            var object = $scope.D.prepareObject(profile, 0, 1);

            if (promise) { return object.$save(); }
            object.$save().then(function () {
                successAlertS('Se guardó perfil con éxito');
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync(function () {
                    $log.debug('save profile finished');
                });
            }).catch(function (err) {
                errAlertS(err);
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
            });
        }

        /**
         * @name replaceAvatar
         * @description Remplaza avatar de usuario
         * @param {Files[]} files arreglo de archivos
         */
        function replaceAvatar(files) {
            var promise = $q.defer();
            $rootScope.loadingProgress = true;
            $scope.F.progress = false;
            $scope.C.uploadFile(files, $scope.profile).then(function (imgUrl) {
                $scope.profile.avatar = imgUrl;
                $scope.save($scope.profile, 1).then(function () {
                    successAlertS('Se subió la imagen de perfil correctamente');
                    $scope.images = [];
                    if ($scope.imageApi) { $scope.imageApi.removeAll(); }
                    $scope.F.progress = false;
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync(function () {
                        $log.debug('replaceAvatar finished');
                    });
                    promise.resolve(true);
                }).catch(function (err) {
                    errAlertS(err);
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                    promise.reject(err);
                });
            }).catch(function (err) {
                errAlertS(err);
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
                promise.reject(err);
            });
            return promise.promise;
        }

        /**
         * @name resetPasswordPrompt
         * @description Prompt para resetear contraseña de usuario
         * @param {Event} ev 
         */
        function resetPasswordPrompt(ev) {
            $log.debug('resetPassword Promp', ev);
            var confirm = $mdDialog.confirm()
                .title('Resetear contraseña')
                .htmlContent('<p>Desea resetear su contraseña? se enviará un correo electrónico a ' + $scope.F.profile.data.email + '  con las instrucciones.</p>')
                .targetEvent(ev)
                .ok('Mandar')
                .cancel('Cancelar');
            $mdDialog.show(confirm).then(function () {
                sendPasswordResetEmail($scope.F.profile);
            }, function () {
                $log.debug('Cancelado el restablecimiento');
            });
        }

        /**@type FB, auth, user
         * @description Cambia correo del usuario actual
         * @param {string} newEmail 
         */
        function changeEmail(newEmail) {
            $log.debug('changeEmail called', newEmail);
            $rootScope.loadingProgress = true;
            var oldMail = angular.copy($scope.F.user.email);
            $scope.F.user.updateEmail(newEmail).then(function () {
                var updates = {};
                updates['data/email'] = newEmail;
                updates['updated'] = $scope.D.getTimeObject();
                $scope.F.root.child('profiles').child($scope.F.user.uid).update(updates).then(function () {
                    successAlertS('El correo de su cuenta cambió exitosamente', 1);
                    $scope.newEmail = '';
                    $scope.showBox2 = false;
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync(function () {
                        $log.debug('changeEmail finished');
                    });
                }).catch(function (error) {
                    $scope.F.user.updateEmail(oldMail).then(function () {
                        errAlertS(error);
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync(function () {
                            $log.debug('changeEmail finished badly but returned to original');
                        });
                    }).catch(function (err) {
                        errAlertS(err);
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync(function () {
                            $log.debug('changeEmail finished badly and need manual change');
                        });
                    });
                });
            }).catch(function (err) {
                errAlertS(err);
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync(function () {
                    $log.debug('changeEmail finished badly but nothing happened');
                });
            });
        }

        /**@type DOM
         * @description Modal para confirmar cambio de correo
         * @param {Event} ev 
         */
        function changeEmailModal(ev) {
            $log.debug('changeEmailModal called');
            var confirm = $mdDialog.confirm(confirmConfig)
                .title('Cambiar mi correo a ' + $scope.newEmail)
                .htmlContent('Está seguro(a)?')
                .ariaLabel('Está Seguro(a)?')
                .targetEvent(ev)
                .ok('Cambiar')
                .cancel('Cancelar');

            $mdDialog.show(confirm).then(function (answer) {
                $log.debug(answer, 'answer');
                changeEmail($scope.newEmail);
            }, function () {
                $log.debug('sendToDismissesConfirm cancelled');
                return false;
            });
        }

        /**
         * @name sendPasswordResetEmail
         * @description Mandar correo para resetear password de usuario
         * @param {User} user 
         */
        function sendPasswordResetEmail(user) {
            $log.debug('Resetting password of user', user);
            $rootScope.loadingProgress = true;
            $scope.auth.$sendPasswordResetEmail(user.data.email).then(function () {
                successAlertS('Se mandó correo para que re-asigne su password, la liga caduca en 20 minutos.');
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync(function () {
                    $log.debug('sendPasswordResetEmail finished');
                });
            }).catch(function (err) {
                errAlertS(err);
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
            });
        }
        $scope.save = saveProfile;
        $scope.replaceAvatar = replaceAvatar;
        $scope.resetPasswordPrompt = resetPasswordPrompt;
        $scope.changeEmailModal = changeEmailModal;
        $scope.loadMfaStatus = loadMfaStatus;
        $scope.showModalDisableMfa = showModalDisableMfa;
        startAfterInitFilter($scope, watchers, initiated, init);

    }
})();

(function () {
    'use strict';

    angular
        .module('app.config')
        .controller('ProcessConfigController', ProcessConfigController);

    function ProcessConfigController($scope, ListsF, startAfterInitFilter, $log) {
        //inicializaciones
        var watchers = {};
        var initiated = false;
        $scope.L = ListsF;
        $scope.selectedTab = 0;
        $scope.addProcess = function () {
            $scope.processConfig.processes.push({ name: 'NUEVO' });
            $scope.selectedTab = $scope.processConfig.processes.length + 1;
        }
        $scope.removeProcess = function (index) {
            $scope.processConfig.processes.splice(index, 1);
        };
        function init() {
            var promises = [$scope.dataNeededPromise, $scope.statesObjsPromise];
            Promise.all(promises).then(function () {
                var thisConcepts = ListsF.concepts.slice();
                $scope.nitConcepts = [
                    { $id: 'sys_deductions', 'name': 'DEDUCCIONES' },
                    { $id: 'sys_perceptions', 'name': 'PERCEPCIONES' }
                ];
                $scope.incidencesTypes = [];
                for (var t = 0; t < thisConcepts.length; t++) {
                    var thisC = thisConcepts[t];
                    if (thisC.type === 'incidenceType') {
                        $scope.incidencesTypes.push(thisC);
                    } else {
                        $scope.nitConcepts.push(thisC);
                    }
                }
            }).catch(function (error) {
                $log.error(error);
            });
        }
        startAfterInitFilter($scope, watchers, initiated, init);

    }
})();
(function () {
    'use strict';

    angular
        .module('app.config')
        .controller('PermissionsController', PermissionsController);

    function PermissionsController(
        $rootScope,
        $scope,
        $log,
        successAlertS,
        errAlertS,
        startAfterInitFilter,
        ListsF,
        loopEachFilter,
        getFromObjectFilter,
        userHasPermissionFilter,
        translateFilter,
        menuNameFilter,
        $mdDialog,
        $http
    ) {
        var vm = this;
        var initiated = false;
        var watchers = {};
        var init = function () {
            $log.debug('initiated');
            initiated = true;
            ListsF.loadList('groups').then(function (groups) {
                var notForClient = false;
                var allGroups = false;
                var groupsToAdmin = {};
                for (var g = 0; g < $scope.F.groupsOfUser.length; g++) {
                    var group = $scope.F.groupsOfUser[g];
                    var thisGroup = groups.find(function (item) {
                        return item.$id === group;
                    });
                    if (angular.isDefined(thisGroup)) {
                        if (thisGroup.ag) {
                            allGroups = true;
                        } else if (angular.isObject(thisGroup.gtm)) {
                            groupsToAdmin = Object.assign(groupsToAdmin, thisGroup.gtm);
                        }
                        if (!thisGroup.groupForClient) {
                            notForClient = true;
                        }
                    }
                }
                vm.groups = groups.filter(function (item) {
                    return ((notForClient || (!notForClient && item.groupForClient)) && (allGroups || groupsToAdmin[item.$id])) ? true : false;
                });
                return $scope.F.root.child('permissions').once('value');
            }).then(function (snap) {
                vm.permissions = snap.val();
                $log.log(vm.permissions);
            }).catch(errAlertS);
        };

        vm.getPermissionReport = function (event) {
            try {
                var confirm = $mdDialog.confirm().
                    title('Dese exportar los permisos')
                    .textContent('Se generara un archivo con todos los permisos por grupos')
                    .ariaLabel('Está Seguro(a)?')
                    .targetEvent(event)
                    .ok('OK')
                    .cancel('Cancelar');
                $mdDialog.show(confirm).then(function () {
                    var extraParams = getAllPermissions();
                    return $http({
                        method: 'POST',
                        url: window.__env.serviceWorkerUrl + 'interface/exportPermissions',
                        responseType: 'arraybuffer',
                        data: extraParams
                    })
                }).then(function (response) {
                    var headers = response.headers();
                    var filename = headers['x-filename'];
                    var contentType = headers['content-type'];
                    var linkElement = document.createElement('a');
                    try {
                        var blob = new Blob([response.data], {
                            type: contentType
                        });
                        var url = window.URL.createObjectURL(blob);
                        linkElement.setAttribute('href', url);
                        linkElement.setAttribute("download", filename);
                        var clickEvent = new MouseEvent("click", {
                            'view': window,
                            'bubbles': true,
                            'cancelable': false
                        });
                        linkElement.dispatchEvent(clickEvent);
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync(function () {
                            $log.debug('generatePdf finished');
                        });
                    } catch (error) {
                        throw error;
                    }
                }).catch(function (error) {
                    if (angular.isDefined(error)) {
                        $log.error(error, 'error descargando el archivo');
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync();
                        errAlertS(error);
                    }
                });
            } catch (error) {
                errAlertS(error);
            }
        };

        function getAllPermissions() {
            var allPermissions = {};
            var permissionByGroup = {};

            for (var g = 0; g < vm.groups.length; g++) {
                var thisGroup = vm.groups[g];
                loopEachFilter(vm.permissions[thisGroup.$id], function (modules, categoryId) {
                    if (!allPermissions.hasOwnProperty(categoryId)) {
                        allPermissions[categoryId] = {
                            name: translateFilter('permission.' + categoryId),
                            modules: {}
                        };
                    }
                    loopEachFilter(modules, function (moduleObj, moduleId) {
                        if (!allPermissions[categoryId].modules.hasOwnProperty(moduleId)) {
                            allPermissions[categoryId].modules[moduleId] = {
                                name: menuNameFilter(moduleId),
                                permissions: {}
                            };
                        }
                        loopEachFilter(moduleObj.permissions, function (hasPermission, permissionId) {
                            if (!allPermissions[categoryId].modules[moduleId].permissions.hasOwnProperty(permissionId)) {
                                allPermissions[categoryId].modules[moduleId].permissions[permissionId] = {
                                    name: translateFilter('p.' + permissionId)
                                };
                            }
                            if (hasPermission) {
                                if (!permissionByGroup.hasOwnProperty(categoryId + '-' + moduleId + '-' + permissionId)) {
                                    permissionByGroup[categoryId + '-' + moduleId + '-' + permissionId] = [];
                                }
                                permissionByGroup[categoryId + '-' + moduleId + '-' + permissionId].push(thisGroup.$id);
                            }
                        });
                    });
                });
            }
            return { allPermissions: allPermissions, permissionByGroup: permissionByGroup, groups: vm.groups };
        }



        function setArrayData(objectName, fromObject, otherObjs) {
            vm[objectName] = [];
            var thisArray = [];
            loopEachFilter(fromObject, function (data, key) {
                thisArray.push(key);
            });
            if (angular.isArray(otherObjs)) {
                otherObjs.map(function (item) {
                    vm[item] = [];
                });
            }
            if (objectName === 'modulePerms' && !$scope.F.profile.groupsOfUser['super-administradores']) {
                thisArray = thisArray.filter(function (item) {
                    return userHasPermissionFilter($scope.F.groupsOfUser, $scope.F.permissions, item, vm.category + '.' + vm.module);
                });
            }
            vm[objectName] = thisArray;
        }
        vm.setPermissionsArray = function () {
            if (vm.group) {
                setArrayData('categories', vm.permissions[vm.group], ['categories', 'modules', 'modulePerms']);
            }
            if (vm.category) {
                setArrayData('modules', getFromObjectFilter(vm.permissions[vm.group], vm.category), ['modules', 'modulePerms']);
            }
            if (vm.module) {
                setArrayData('modulePerms', getFromObjectFilter(vm.permissions[vm.group], vm.category + '.' + vm.module + '.permissions'), ['modulePerms']);
            }
        };
        vm.savePermission = function (group, category, app, permission, val) {
            $rootScope.loadingProgress = true;
            $log.debug('savingPermission', group, category, app, permission, val);
            $scope.F.root.child('permissions').child(group).child(category).child(app).child('permissions').child(permission).set(val).then(function () {
                successAlertS('Permisos Actualizados');
                $rootScope.$emit('permissionsUpdated', true);
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync(function () {
                    $log.debug('savePermission finished');
                });
            }).catch(function (err) {
                errAlertS(err);
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
            });
        };
        startAfterInitFilter($scope, watchers, initiated, init);
    }
})();
(function () {
    'use strict';

    angular
        .module('app.config')
        .controller('PaymentSchemaController', PaymentSchemaController);

    function PaymentSchemaController(
        $scope,
        $log,
        clearObjectFilter,
        ListsF,
        $rootScope,
        getFromObjectFilter,
        nameOfLFilter,
        loopEachFilter,
        objsToArrayFilter,
        errAlertS,
        AppF
    ) {
        var detailWatchers = {};
        var initiated = false;
        $scope.nitConcepts = [];
        $scope.processesConfig = [];
        $scope.incidencesTypes = [];
        function init() {
            $scope.dataNeededPromise.then(function () {
                if (angular.isArray(ListsF.concepts)) {
                    var thisConcepts = [];
                    if (angular.isArray(ListsF.concepts)) {
                        thisConcepts = ListsF.concepts.slice();
                    }
                    for (var t = 0; t < thisConcepts.length; t++) {
                        var thisConcept = thisConcepts[t];
                        $log.log('Concept', thisConcept)
                        if (thisConcept.type === 'incidenceType') {
                            var id = thisConcept.$id;
                            var thisIncidenceType = clearObjectFilter(thisConcept);
                            thisIncidenceType.$id = id;
                            thisIncidenceType.name = thisIncidenceType.name + ' [' + (thisIncidenceType.payroll === 'global' ? 'GLOBAL' : nameOfLFilter(thisIncidenceType.payroll, ListsF.allPayrolls)) + ']';
                            $scope.incidencesTypes.push(thisIncidenceType);
                        } else {
                            $scope.nitConcepts.push(thisConcept);
                        }
                    }
                    // $scope.nitConcepts = thisConcepts.filter(function (item) {
                    //     return item.type !== 'incidenceType';
                    // });
                    $scope.nitConcepts.push({ $id: 'sys_deductions', 'name': 'DEDUCCIONES' });
                    $scope.nitConcepts.push({ $id: 'sys_perceptions', 'name': 'PERCEPCIONES' });
                }
            });
            $scope.loadProcessConfig();
        }
        $scope.L = ListsF;
        var preparePaymentSchema = function (paymentSchema) {
            if (paymentSchema.data.processes.fiscal.active) {
                if (paymentSchema.data.processes.fiscal.incidences) {
                    loopEachFilter(paymentSchema.data.processes.fiscal.incidences, function (incidence, incidenceId) {
                        delete paymentSchema.data.processes.fiscal.incidences[incidenceId]['$$hashKey'];
                    });
                }
            }
            if (angular.isArray(paymentSchema.data.processes.complements)) {
                for (var c = 0; c < paymentSchema.data.processes.complements.length; c++) {
                    delete paymentSchema.data.processes.complements[c]['$$hashKey'];
                }
            }
        };

        $scope.loadProcessConfig = function () {
            $scope.F.root.child('catalogs/processConfigs/collection').orderByChild('type').equalTo('settlement').once('value').then(function (snap) {

                if (snap.exists()) {
                    var data = snap.val();
                    var processes = objsToArrayFilter(data).filter(function (item) {
                        return item.center === AppF.center;
                    });
                    $scope.processesConfig = processes;
                } else {
                    errAlertS('No se encontró registro de los procesos de configuración');
                }
            }).catch(function (error) {
                $log.error('Ocurrió un error de' + error);
                errAlertS('Ocurrió un error al consultar los datos de los procesos de configuración');
            })
        }
        $scope.addPrepared = function (paymentSchema) {
            preparePaymentSchema(paymentSchema);
            $scope.add(paymentSchema);
        };

        $scope.savePrepared = function (paymentSchema, promise) {
            preparePaymentSchema(paymentSchema);
            var object = clearObjectFilter(paymentSchema);
            if (promise) { return $scope.save(object, 1); }
            $scope.save(paymentSchema);
        };

        $scope.incidenceIsInSchema = function (incidenceId) {
            if ($scope.paymentSchema.data) {
                if ($scope.paymentSchema.data.processes) {
                    if ($scope.paymentSchema.data.processes.fiscal) {
                        if ($scope.paymentSchema.data.processes.fiscal.incidences) {
                            return ($scope.paymentSchema.data.processes.fiscal.incidences.hasOwnProperty(incidenceId));
                        }
                    }
                }
            }
            return false;
        };

        $scope.addComplement = function () {
            if ($scope.paymentSchema.data.processes.complements) {
                $scope.paymentSchema.data.processes.complements.push({
                    active: true
                });
            } else {
                $scope.paymentSchema.data.processes.complements = [{
                    active: true
                }];
            }
        };
        function payrolls() {
            $scope.payrollsData = AppF.permissionToAccessAllPayrolls ? $rootScope.L.allPayrolls : $rootScope.L.payrolls;
        }
        payrolls()
        function setAllConcepts() {
            var allConcepts = [];
            if (angular.isDefined($scope.paymentSchema) && angular.isDefined($scope.paymentSchema.data) && angular.isDefined($scope.paymentSchema.data.processes)) {
                allConcepts.push(getFromObjectFilter($scope.paymentSchema.data.processes, 'real.concepts', {}));
                allConcepts.push(getFromObjectFilter($scope.paymentSchema.data.processes, 'fiscal.concepts', {}));
                allConcepts.push(getFromObjectFilter($scope.paymentSchema.data.processes, 'others.concepts', {}));
                var complements = getFromObjectFilter($scope.paymentSchema.data.processes, 'complements', []);
                for (var c = 0; c < complements.length; c++) {
                    allConcepts.push(getFromObjectFilter(complements[c], 'concepts', {}));
                }
            }
            var all = [];
            for (var a = 0; a < allConcepts.length; a++) {
                var thisConcepts = allConcepts[a];
                loopEachFilter(thisConcepts, function (data, itemId) {
                    var name = nameOfLFilter(itemId, ListsF.concepts, 'N/A');
                    if (name !== 'N/A') {
                        var obj = {};
                        obj.name = name;
                        obj.$id = itemId;
                        var index = all.findIndex(function (item) {
                            return item.$id === itemId;
                        });
                        if (index === -1) {
                            all.push(obj);
                        }
                    }
                });
            }
            $scope.allSchemaConcepts = all;
        }
        detailWatchers.realConcepts = $scope.$watch('paymentSchema.data.processes.real.concepts', function () {
            setAllConcepts();
        }, true);
        detailWatchers.fiscalConcepts = $scope.$watch('paymentSchema.data.processes.fiscal.concepts', function () {
            setAllConcepts();
        }, true);
        detailWatchers.othersConcepts = $scope.$watch('paymentSchema.data.processes.others.concepts', function () {
            setAllConcepts();
        }, true);
        detailWatchers.complementsConcepts = $scope.$watch('paymentSchema.data.processes.complements', function () {
            setAllConcepts();
        }, true);
        detailWatchers.onDestroy = $scope.$on('$destroy', function () {
            loopEachFilter(detailWatchers, function (watcher, watcherKey) {
                if (angular.isFunction(detailWatchers[watcherKey])) {
                    detailWatchers[watcherKey]();
                    delete detailWatchers[watcherKey];
                }
            });
        });

        $scope.removeComplement = function (index) {
            $scope.paymentSchema.data.processes.complements.splice(index, 1);
        };
        if ($scope.objectLoaded) {
            if (!initiated) { init(); }
        } else {
            detailWatchers.mainObjLoaded = $rootScope.$on('mainObjectLoaded', function () {
                if (!initiated) {
                    init();
                }
                detailWatchers.mainObjLoaded();
                delete detailWatchers.mainObjLoaded;
            });
        }

    }
})();
(function(){
    'use strict';

    angular
        .module('app.config')
        .filter('notDefaultIncidences', notDefaultIncidences)

    function notDefaultIncidences(AppF, getComplexIncidencesTypesFilter){

        return notDefaultIncidencesFn;

        function notDefaultIncidencesFn(incidences, object){
            var normalIncidences = (object) ? {} : [];
            if(!AppF.complexIncidencesMap) AppF.complexIncidencesMap = getComplexIncidencesTypesFilter();
            for(var i in incidences){
                var incidence = incidences[i];
                if(!object){
                    if(AppF.complexIncidencesMap.default.indexOf(i) == -1){
                        normalIncidences.push(incidence);
                    }
                } else {
                    //console.log(AppF.complexIncidencesMap.default.indexOf(i), i, AppF.complexIncidencesMap, "WTF")
                    if(AppF.complexIncidencesMap.default.indexOf(i) == -1){
                        normalIncidences[i] = incidence;
                    }
                }
            }
            return normalIncidences;
        }
    }

}());
(function(){
    'use strict';

    angular
        .module('app.core')
        .filter('normalIncidences', normalIncidences)

    function normalIncidences(){

        return normalIncidencesFn;

        function normalIncidencesFn(incidences){
            var normalI = {};
            for(var i in incidences){
                if(!incidences[i].default) normalI[i] = incidences[i];
            }
            return normalI;
        }
    }

}());
(function(){
    'use strict';

    angular
        .module('app.core')
        .filter('defaultIncidences', defaultIncidences)

    function defaultIncidences(){

        return defaultIncidencesFn;

        function defaultIncidencesFn(incidences){
            var defaultI = {};
            for(var i in incidences){
                if(incidences[i].default) defaultI[i] = incidences[i];
            }
            return defaultI;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.config')
        .controller('InvolvedRecordsController', InvolvedRecordsController);

    function InvolvedRecordsController(
        $rootScope,
        $scope,
        $state,
        $firebaseArray,
        $log,
        $q,
        $mdDialog,
        successAlertS,
        errAlertS,
        confirmConfig,
        startAfterInitFilter
    ) {
        var root = $scope.F.root;
        var initiated = false;
        var watchers = {};
        $scope.configState = 'app.config.involvedRecords.config';
        $scope.detailState = 'app.config.involvedRecords.detail';
        $scope.involvedRecords = [];
        $scope.selected = [];
        $scope.currentPage = $scope.F.currentPage('config', 'involvedRecords');
        $scope.uploadImage = false;

        function init() {
            $scope.involvedRecords = $firebaseArray(root.child('catalogs/involvedRecords/collection'));
            $scope.involvedRecords.$loaded(function (involvedRecords) {
                $scope.involvedRecords = involvedRecords;
            });
        }

        var remove = function (involvedRecord) {
            $log.debug('removing: ', involvedRecord);
            return $scope.involvedRecords.$remove(involvedRecord);
        };
        // Methods
        $scope.getValidations = function () {
            $scope.validations = [{
                valid: ($scope.involvedRecords.length && !$rootScope.loadingProgress),
                msg: 'Parece que no tiene involucrados aún'
            }];
            $log.debug($scope.validations, 'validations');
        };

        $scope.goToDetail = function (involvedRecord) {
            $scope.F.goToState($scope.detailState, { 'involvedRecordId': (involvedRecord === 'new') ? 'new' : involvedRecord.$id, 'involvedRecord': involvedRecord, 'involvedRecords': $scope.involvedRecords });
        };

        $scope.delete = function (e) {
            var msg = (!$scope.F.safeDelete.involvedRecord) ?
                'No podrá recuperar sus datos' :
                'Podrá recuperar sus datos en la papelera';
            var title = 'Quiere borrar ' + $scope.selected.length + ' Involucrados?';

            $mdDialog.show($mdDialog.confirm(confirmConfig)
                .title(title)
                .content(msg)
                .ariaLabel('Deleting')
                .targetEvent(e)
                .ok('Borrar')
                .cancel('Cancelar'))
                .then(function () {
                    var count = 0;
                    $log.debug('Deleting: ', $scope.selected);
                    angular.forEach($scope.selected, function (involvedRecord) {
                        remove(involvedRecord).then(function () {
                            count++;
                            if (count === $scope.selected.length) {
                                successAlertS('Se borraron ' + count + ' Involucrados');
                                $scope.selected = [];
                            }
                        }, errAlertS);
                    });
                }, function () {
                    $log.debug('Deleting Cancelled');
                });
        };
        watchers.involved = $scope.$watch('involvedRecords', function () {
            $scope.getValidations();
        }, true);
        watchers.currentPage = $scope.$watch('currentPage', function (cp) {
            if (cp) {
                $scope.F.setCurrentPage(cp, 'config', 'involvedRecords');
                $log.debug('setting currentPage', cp, $scope.currentPage);
            }
        });
        startAfterInitFilter($scope, watchers, initiated, init);

    }
})();
(function () {
    'use strict';

    angular
        .module('app.config')
        .controller('InvolvedRecordController', InvolvedRecordController);

    function InvolvedRecordController(
        $scope,
        $log,
        $q,
        getSomethingOfArrayFBFilter,
        getObjectsLikeTermOfArrayFilter,
        filterArrayForAutocompleteChipsFilter,
        startAfterInitFilter,
        AppF
    ) {
        var initiated = false;
        $scope.listWatchers = {};
        function init() {
            if (!$scope.involvedRecord.hasOwnProperty('users')) {
                $scope.involvedRecord.users = { all: {} };
            }
            $scope.involvedRecord.center = AppF.center;
            $scope.loadUsers();
        }
        $scope.autocompleteProfiles = function (nameOfProfile, ccId) {
            return $q(function (resolve, reject) {
                $scope.L.loadList('profiles', 'lists/profiles/center/' + AppF.center, false, 'array', 'users').then(function (users) {
                    var allR = getObjectsLikeTermOfArrayFilter(nameOfProfile, users, 'name');
                    var p = [];
                    for (var a in allR) {
                        if (allR.hasOwnProperty(a) && allR[a].active) {
                            if (ccId !== 'all' && $scope.involvedRecordUsers.all.indexOf(allR[a].$id) === -1) {
                                if (angular.isUndefined($scope.involvedRecordUsers[ccId])) { // si no esta definido ni en all
                                    p.push(allR[a]);
                                } else {
                                    if ($scope.involvedRecordUsers[ccId].indexOf(allR[a].$id) === -1) { // si no esta en all ni en el cc
                                        p.push(allR[a]);
                                    }
                                }
                            } else if ($scope.involvedRecordUsers.hasOwnProperty('all')) {
                                if ($scope.involvedRecordUsers.all.indexOf(allR[a].$id) === -1) { // si no esta en all
                                    var userIsInvolvedToCC = false;
                                    for (var c in $scope.L.payrollCcs[$scope.involvedRecord.payroll]) { // ni en otro cc
                                        if ($scope.L.payrollCcs[$scope.involvedRecord.payroll].hasOwnProperty(c)) {
                                            var cc = $scope.L.payrollCcs[$scope.involvedRecord.payroll][c].$id;
                                            if (angular.isDefined($scope.involvedRecordUsers[cc])) {
                                                if ($scope.involvedRecordUsers[cc].indexOf(allR[a].$id) !== -1) {
                                                    userIsInvolvedToCC = true;
                                                }
                                            }
                                        }
                                    }
                                    if (!userIsInvolvedToCC) { p.push(allR[a]); }
                                }
                            } else {
                                p.push(allR[a]);
                            }
                        }
                    }
                    resolve(p);
                }, function (error) {
                    reject(error);
                });
            });
        };
        $scope.transformChip = function (chip) {
            return chip.$id;
        };
        $scope.setInvolvedUser = function (userId, ccId, value) {
            if (!$scope.involvedRecord.hasOwnProperty('users')) { $scope.involvedRecord.users = { all: {} }; }
            if (!$scope.involvedRecord.users.hasOwnProperty(ccId)) { $scope.involvedRecord.users[ccId] = {}; }
            if (!$scope.involvedRecord.hasOwnProperty('payrollUsers')) { $scope.involvedRecord.payrollUsers = {}; }
            $scope.involvedRecord.users[ccId][userId] = value;
            $scope.involvedRecord.payrollUsers[userId] = value;
        };
        $scope.payrollsIsInvolved = function (payrollId) {
            var payrollExists;
            if (angular.isArray($scope.L.involvedRecords)) {
                payrollExists = $scope.L.involvedRecords.find(function (item) {
                    return item.payroll === payrollId;
                });
            }
            return typeof (payrollExists) !== 'undefined';
        };
        $scope.loadUsers = function () {
            $scope.L.loadList('profiles', 'lists/profiles/center/' + AppF.center, false, 'array', 'users');
        };
        $scope.listWatchers.payroll = $scope.$watch('involvedRecord.payroll', function (payrollId) {
            if (payrollId) {
                $log.debug('loading users from client associated with payrollId', payrollId);
                $scope.F.search.$firm = getSomethingOfArrayFBFilter(payrollId, $scope.L.allPayrolls, 'firm');
                $scope.L.loadList('rps', 'lists/rps/all', false, 'array', 'allRps')
                $scope.L.loadList('ccs', 'lists/ccs/payroll', payrollId, 'array', 'payrollCcs').then(function () {
                    if (!$scope.involvedRecordUsers) { $scope.involvedRecordUsers = {}; }
                    if ($scope.involvedRecord.users) {
                        $scope.involvedRecordUsers.all = filterArrayForAutocompleteChipsFilter($scope.involvedRecord.users.all, false, true);
                        for (var c in $scope.L.payrollCcs[payrollId]) {
                            if ($scope.L.payrollCcs[payrollId].hasOwnProperty(c)) {
                                var cc = $scope.L.payrollCcs[payrollId][c];
                                if (cc.hasOwnProperty('$id') && angular.isDefined(cc.$id)) {
                                    $scope.involvedRecordUsers[cc.$id] = filterArrayForAutocompleteChipsFilter($scope.involvedRecord.users[cc.$id], false, true);
                                }
                            }
                        }
                    }
                });
            }
        });
        startAfterInitFilter($scope, $scope.listWatchers, initiated, init);
    }
})();
(function () {
    'use strict';

    angular
        .module('app.config')
        .controller('OperationConstantsController', OperationConstantsController);

    function OperationConstantsController($scope, $mdDialog, $document, $log, userHasPermissionFilter, AppF, startAfterInitFilter, loopEachFilter) {
        var listWatchers = {};
        var initiated = false;
        $scope.anyHasPermission = false;
        function tabChanged(tab) {
            $scope.F.search.$type = tab;
            $scope.tabSelected = tab;
            filter();
        }
        function init() {
            $scope.permissions = {
                default: userHasPermissionFilter(AppF.groupsOfUser, AppF.permissions, 'tabOperationConstantsDefault', 'config.operationConstants'),
                payroll: userHasPermissionFilter(AppF.groupsOfUser, AppF.permissions, 'tabOperationConstantsPayroll', 'config.operationConstants'),
                cc: userHasPermissionFilter(AppF.groupsOfUser, AppF.permissions, 'tabOperationConstantsCc', 'config.operationConstants'),
                employee: userHasPermissionFilter(AppF.groupsOfUser, AppF.permissions, 'tabOperationConstantsEmployee', 'config.operationConstants')
            };
            for (var tab in $scope.permissions) {
                if ($scope.permissions.hasOwnProperty(tab)) {
                    if ($scope.permissions[tab]) {
                        $scope.anyHasPermission = true;
                    }
                }
            }
        }

        $scope.importOperationConstantsModal = function (ev) {
            $log.log('importOperationConstants called');
            $mdDialog.show({
                controller: 'ImportOperationConstantsController',
                templateUrl: 'app/main/config/views/operationConstants/dialogs/import-operation-constants.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                locals: {
                    permissions: $scope.permissions
                },
                controllerAs: 'impOpeConstCtrl',
                clickOutsideToClose: false
            }).then(function (answer) {
                $log.debug(answer, 'Import Operation Constants Modal answer');
            }, function () {
                $log.debug('Import Operation Constants Modal cancelled');
            });
        };
        $scope.resetThisFilters = function () {
            $scope.F.operationConstantsSearch = {};
            $scope.searchQuery = '';
            tabChanged($scope.tabSelected);
        };
        function filter() {
            var itemId = undefined;
            if (angular.isDefined($scope.F.search) && $scope.F.search.$type !== 'default' && angular.isObject($scope.F.operationConstantsSearch) && $scope.F.operationConstantsSearch[$scope.F.search.$type]) {
                itemId = $scope.F.operationConstantsSearch[$scope.F.search.$type];
            }
            if (angular.isDefined($scope.F.operationConstantsSearch) && angular.isDefined($scope.F.operationConstantsSearch.constantType) && angular.isDefined($scope.F.operationConstantsSearch.constantType.data)) {
                loopEachFilter($scope.F.operationConstantsSearch.constantType.data, function (value, key) {
                    $scope.F.search.$[key] = value;
                })
            } else {
                $scope.F.search.$.incidencesType = undefined;
                $scope.F.search.$['customField.key'] = undefined;
            }
            $scope.F.search.$.itemId = itemId;

        }
        function getEmployee() {
            if ($scope.F.operationConstantsSearch.employee) {
                $scope.L.loadList('employees', 'catalogs/employees/collection', $scope.F.operationConstantsSearch.employee, 'object', 'operationConstantEmployees').then(function (employee) {
                    $scope.searchQuery = employee.data.name;
                });
            }
        }
        listWatchers.operationConstantsTypeSearch = $scope.$watch('F.search.$type', function (val, oldVal) {
            if (angular.isUndefined(val)) {
                $scope.F.search.$type = typeof (oldVal) !== 'undefined' ? oldVal : 'default';
            }
        });
        listWatchers.operationConstantsSearch = $scope.$watch('F.operationConstantsSearch', function (val) {
            if (val && $scope.F.operationConstantsSearch.payroll) {
                $scope.L.loadList('ccs', 'lists/ccs/payroll', $scope.F.operationConstantsSearch.payroll, 'array', 'payrollCcs').then(function (ccs) {
                    $log.info(ccs, 'ccs of', $scope.F.operationConstantsSearch.payroll, 'loaded');
                });
            }
            if ($scope.F.search.$type === 'employee' && typeof (val) !== 'undefined' && typeof (val.employee) !== 'undefined') {
                getEmployee();
            }
            filter();
        }, true);
        $scope.tabChanged = tabChanged;
        $scope.searchQuery = '';

        startAfterInitFilter($scope, listWatchers, initiated, init);

    }
})();
(function () {
    'use strict';

    angular
        .module('app.config')
        .controller('OperationConstantController', OperationConstantController);

    function OperationConstantController($scope, $rootScope, $log, AppF, $filter, errAlertS) {
        var detailWatchers = {};
        var initiated = false;
        var formField = false;
        $scope.showField = false;
        $scope.incidencesTypesF = [];
        $scope.employeeSelected = "";
        var constantType;
        function filter() {
            if (typeof ($scope.F.search) !== 'undefined' && $scope.F.search.$type !== 'default' && angular.isObject($scope.F.operationConstantsSearch) && $scope.F.operationConstantsSearch[$scope.F.search.$type]) {
                $scope.operationConstant.itemId = $scope.F.operationConstantsSearch[$scope.F.search.$type];
                if ($scope.F.search.$type === 'employee') {
                    $scope.L.loadList('employees', 'catalogs/employees/collection', $scope.operationConstant.itemId, 'object', 'operationConstantEmployee-' + $scope.operationConstant.itemId).then(function (employee) {
                        $log.log("Aqui")
                        $scope.searchQuery = employee.data.name;
                        $scope.incidencesTypes(employee.payroll);
                        $scope.employeeSelected = employee;
                    });
                }
            } else if ($scope.operationConstant.type === 'default' && $scope.F.addMode) {
                $scope.operationConstant.itemId = 'default';
            }
            $scope.uniqueFilter = { itemId: $scope.operationConstant.itemId };
        }
        $scope.$watch('uniqueFilter', function (newVal) {
            if (angular.isDefined(newVal)) {
                if (['default', 'payroll', 'cc'].indexOf($scope.operationConstant.type) > -1) {
                    $scope.incidencesTypes(newVal);
                }
            }
        })
        $scope.resetContantsFilter = function () {
            $log.log("resetContantsFilter")
        }
        function init() {
            if (typeof ($scope.F.operationConstantsSearch) === 'undefined') {
                $scope.F.operationConstantsSearch = {};
            }
            if (!initiated) {
                var needed = [
                    $scope.dataNeededPromise,
                    $scope.statesObjsPromise
                ];
                Promise.all(needed).then(function () {
                    $scope.thisFields = $scope.C.customFields.filter(function (item) {
                        if (angular.isArray(item.groups) && item.groups.length > 0) {
                            return (item.groups.findIndex(function (item) {
                                return (AppF.groupsOfUser.indexOf(item) > -1);
                            }) > -1);
                        }
                        return true;
                    });
                    $log.log($scope.thisFields);
                }).catch(function (error) {
                    errAlertS(error);
                });

                if (!$scope.F.addMode) {
                    detailWatchers.itemId = $scope.$watch('operationConstant.itemId', function (itemId) {
                        $scope.uniqueFilter = { itemId: itemId };
                        switch ($scope.operationConstant.type) {
                            case 'payroll':
                                $scope.F.operationConstantsSearch.payroll = itemId;
                                break;
                            case 'cc':
                                $scope.F.operationConstantsSearch.cc = itemId;
                                $scope.L.loadList('ccs', 'lists/ccs/all', itemId, 'object', 'opertionConstantCC').then(function (cc) {
                                    $scope.F.operationConstantsSearch.payroll = cc.payroll;
                                });
                                break;
                            case 'employee':
                                $scope.F.operationConstantsSearch.employee = itemId;
                                $scope.L.loadList('employees', 'catalogs/employees/collection', itemId, 'object', 'operationConstantEmployee-' + itemId).then(function (employee) {
                                    $log.log("Aqui")
                                    $scope.F.operationConstantsSearch.payroll = employee.payroll;
                                    $scope.F.operationConstantsSearch.cc = employee.cc;
                                    $scope.searchQuery = employee.data.name;
                                    $scope.employeeSelected = employee;
                                });
                                break;
                        }
                    });
                }
                detailWatchers.operationConstantsSearch = $scope.$watch('F.operationConstantsSearch', function (val) {
                    if (typeof (val) !== 'undefined' && $scope.F.operationConstantsSearch.payroll && $scope.operationConstant.type === 'cc') {
                        $scope.L.loadList('ccs', 'lists/ccs/payroll', $scope.F.operationConstantsSearch.payroll, 'array', 'payrollCcs').then(function (ccs) {
                            $log.info(ccs, 'ccs of', $scope.F.operationConstantsSearch.payroll, 'loaded');
                        });
                    }
                    filter();
                    $scope.validateUniqueValue($scope.operationConstant, formField);
                }, true);
                if (angular.isDefined($scope.operationConstant.customField)) {
                    $scope.showField = true
                }
            }
        }
        $scope.searchQuery = '';

        $scope.incidencesTypes = function (payroll) {
            var type = $scope.operationConstant.type;
            var payrollId = (type === 'cc') ? $scope.F.operationConstantsSearch.payroll : ((type === 'employee') ? payroll : payroll.itemId);
            if ($scope.incidencesTypesF.length > 0) {
                $scope.incidencesTypesF = [];
            }
            if (payrollId == 'undefined') {
                $scope.incidencesTypesF = [];
                return false;
            }
            var incidencesType = $scope.L.incidencesTypes;
            for (var i = 0; i < incidencesType.length; i++) {
                if ([angular.lowercase(payrollId), 'global'].indexOf(angular.lowercase(incidencesType[i].payroll)) > -1) {
                    $scope.incidencesTypesF.push(incidencesType[i]);
                }
            }
        }
        $scope.showCalcField = function (value) {
            $scope.showField = (value === 'customField') ? true : false;
            if (value === 'customField') {
                delete $scope.operationConstant.incidencesType;
            }
            if (angular.isDefined(constantType) && constantType !== value && $scope.operationConstant.hasOwnProperty(constantType)) {
                delete $scope.operationConstant[constantType];
                constantType = value;
            } else {
                constantType = value;
            }
            $rootScope.$evalAsync();
        };
        $scope.validateUniqueValue = function (values, form) {
            formField = (form) ? form : formField;
            var value = $filter('getFromObject')(values, 'customField.key');
            if (angular.isUndefined(value) || !formField) {
                return false;
            }
            AppF.root.child('catalogs/operationConstants/collection').orderByChild('customField/key').equalTo(value).once('value').then(function (snap) {
                if (snap.exists()) {
                    var data = snap.val();
                    for (var c in data) {
                        if (data[c].type === $scope.operationConstant.type && data[c].customField.key === value && c !== $scope.operationConstant.$id) {
                            if (data[c].itemId === values.itemId) {
                                formField['key'].$setValidity('validateUniqueValue', false);
                                break;
                            } else {
                                formField['key'].$setValidity('validateUniqueValue', true);
                            }
                        }
                    }
                } else {
                    formField['key'].$setValidity('validateUniqueValue', true);
                }
                $rootScope.$evalAsync();
            })
        }

        if ($scope.objectLoaded) {
            init();
        } else {
            var mainObjectLoaded = $rootScope.$on('mainObjectLoaded', function () {
                mainObjectLoaded();
                init();
            });
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.config')
        .controller('IncidencesTypesController', IncidencesTypesController);

    function IncidencesTypesController(
        $scope,
        $rootScope,
        $mdDialog,
        $log,
        MongoF,
        errAlertS,
        AppF,
        $firebaseArray
    ) {
        var listenGLobal = true;
        // $scope.M = MongoF;
        $scope.showPayrollModal = function(ev, type) {
            $mdDialog.show({
                controller: DialogController,
                templateUrl: 'app/main/config/views/incidences-types/dialogs/' + type + 'Selector.html',
                parent: angular.element(document.body),
                locals: {
                    selected: $scope.selected
                },
                targetEvent: ev,
                clickOutsideToClose: true
            })
        };

        $scope.deleteIfDoesnHaveIncidences = function(ev, incidenceType) {
            $log.debug('checking if have incidences');
            $scope.F.root.child('catalogs/payrollCalendars').child(incidenceType.payroll).child('calendars').once('value', function(snap) {
                if (snap.val()) {
                    snap.forEach(function(pcSnap) {
                        var year = pcSnap.key;
                        $scope.F.root.child('incidences').child(incidenceType.payroll).child(year).orderByChild('incidenceType').equalTo(incidenceType.$id).once('value', function(snap) {
                            if (snap.val() !== null) {
                                errAlertS('No se puede borrar ya que tiene incidencias registradas');
                            } else {
                                $log.debug("delete!!", $scope.selected);
                                $scope.delete(ev);
                            }
                        })
                    });
                } else {
                    $log.debug("delete!!", $scope.selected);
                    $scope.delete(ev);
                }
            });
        }

        function DialogController($scope, $mdDialog, AppF, ListsF, $firebaseArray, $log, CatalogsF, clearObjectFilter, DataF, successAlertS, errAlertS, selected) {
            console.log(selected);
            $scope.F = AppF;
            $scope.L = ListsF;
            $scope.C = CatalogsF;
            $scope.D = DataF;
            $scope.M = MongoF;
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };

            $scope.copySelectedIncidences = function(payroll) {
                if (selected.length) {
                    copyNewIncidences(selected, payroll).then(function() {
                            successAlertS('Se copiaron ' + selected.length + ' incidencia(s) con exito');
                            selected = [];
                            $mdDialog.hide();
                        },
                        function(error) {
                            errAlertS(error);
                        });
                } else {
                    errAlertS("No se encontraron incidencias para copiar");
                }
            }

            var copyNewIncidences = function(incidences, destinationPayroll) {
                var updates = {};
                angular.forEach(incidences, function(incidence) {
                    var obj = clearObjectFilter(incidence);
                    var id = $scope.F.root.child('catalogs/incidencesTypes/collection').push().key;
                    delete obj.updated;
                    delete obj.created;
                    delete obj.payroll;
                    obj.payroll = destinationPayroll;
                    obj.created = $scope.D.getTimeObject();
                    updates[id] = obj;
                });
                return $scope.F.root.child('catalogs/incidencesTypes/collection').update(updates);
            }
            // @todo:backlog pasar a servidor
            $scope.copyIncidences = function(originPayroll, destinationPayroll) {
                if (originPayroll && destinationPayroll) {
                    var originIncendences = $scope.F.root.child('catalogs/incidencesTypes/collection').orderByChild('payroll').equalTo(originPayroll);
                    $scope.C.incidencesByPayroll = $firebaseArray(originIncendences);
                    $scope.C.incidencesByPayroll.$loaded().then(function(incidences) {
                        if (incidences.length) {
                            copyNewIncidences(incidences, destinationPayroll).then(function() {
                                    successAlertS('Se copiaron ' + incidences.length + ' incidencia(s) con exito');
                                    $mdDialog.hide();
                                },
                                function(error) {
                                    errAlertS(error);
                                });
                        } else {
                            errAlertS("No se encontraron incidencias para copiar");
                        }
                    });

                }
            }
        }

        $scope.$watch("F.search.$payroll", function(payroll) {
            if (payroll) {
                starWatchIncidencedTypes()
            }
        }, true);

        var starWatchIncidencedTypes = function() {
            $scope.$watch("incidencesTypes", function(incidencesTypes) {
                listenGLobal = false;
                if (AppF.search.$payroll) {
                    if(AppF.search.$payroll !== "global" && AppF.search.$payroll !== 'all'){
                        if (!$scope.globalIncidences) {
                            $scope.globalIncidences = $firebaseArray(AppF.root.child("catalogs/incidencesTypes/collection").orderByChild("payroll").equalTo("global"));
                        }
                        $scope.globalIncidences.$loaded().then(function(incidences) {
                            if (incidencesTypes) {
                                $scope.allIncidencesTypes = incidences.concat(incidencesTypes);
                            } else {
                                $scope.allIncidencesTypes = incidences;
                            }
                            listenGLobal = true;
                        });
                    } else {
                        $scope.allIncidencesTypes = incidencesTypes;
                    }
                } else {
                    if($scope.incidencesTypes){
                        $scope.allIncidencesTypes = $scope.incidencesTypes;
                    } else {
                        $scope.allIncidencesTypes = [];
                    }
                }
            }, true);

            $scope.$watch("globalIncidences", function() {
                if (listenGLobal) {
                    $scope.globalIncidences.$loaded().then(function(incidences) {
                        if ($scope.incidencesTypes) {
                            $scope.allIncidencesTypes = incidences.concat($scope.incidencesTypes);
                        } else {
                            $scope.allIncidencesTypes = incidences;
                        }
                    });
                }
            }, true);
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .controller('IncidencesTypeController', IncidencesTypeController)

    /** @ngInject */
    function IncidencesTypeController(
        $scope
    ) {
        $scope.$watch('incidencesType.automatic', function (automatic) {
            if (automatic) {
                $scope.incidencesType.allowManual = false;
                $scope.incidencesType.requireConfirmation = false;
                $scope.incidencesType.confirmationType = null;
            }
        })
        $scope.checkConfirmationType = function (confirmationType) {
            if (confirmationType !== 'file') {
                delete $scope.incidencesType.addFolio;
                delete $scope.incidencesType.uniqueFolio;
                delete $scope.incidencesType.requiredFolio;
                delete $scope.incidencesType.pattern;
            }
        }
        $scope.checkRequireConfirmation = function (requireConfirmation) {
            if (requireConfirmation) {
                $scope.incidencesType.allowManual = $scope.incidencesType.automatic = $scope.incidencesType.amortizationAvailable = false;
            } else {
                delete $scope.incidencesType.confirmationType;
                $scope.checkConfirmationType(null);
            }
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.config')
        .controller('ImportsController', ImportsController)

    /** @ngInject */
    function ImportsController(
        $rootScope,
        $scope,
        $q,
        successAlertS,
        errAlertS,
        $log
    ) {
        var deleteMiniCredits = function(row) {
            return new Promise(function(resolve, reject) {
                if (row.imports) {
                    var requests = {};
                    for (var cid in row.imports.credits) {
                        requests[cid] = $scope.F.root.child('catalogs/credits/collection').child(cid).child('employee').once('value');
                    }
                    $q.all(requests).then(function(allEmployees) {
                        var updates = {};
                        for (var cid in allEmployees) {
                            var eid = allEmployees[cid].val();
                            if (eid !== null) {
                                updates['employees/collection/' + eid + '/credits/' + cid] = null;
                            }
                        }
                        $scope.F.root.child('catalogs').update(updates)
                            .then(function() {
                                resolve();
                            }).catch(reject);
                    }).catch(reject);
                }
            });
        }

        $scope.deleteImport = function(ev, row) {
            $log.debug('deleting import', row);
            $rootScope.loadingProgress = true;
            var rowCopy = JSON.parse(JSON.stringify(row));
            $scope.delete(ev, 1).then(function() {
                if (rowCopy.type == 'credits') {
                    // borrar mini credits de empleados
                    deleteMiniCredits(rowCopy).then(function() {
                        successAlertS('Importación de créditos borrada');
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync(function() {
                            $log.debug('deleteImport finished');
                        });
                    }).catch(function(err) {
                        errAlertS(err);
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync();
                    });
                } else {
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync(function() {
                        $log.debug('deleteImport finished');
                    });
                }
            });

        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.config')
        .controller('ImportController', ImportController)

    /** @ngInject */
    function ImportController(
        $scope,
        $log,
        $q,
        $rootScope,
        $mdDialog,
        importNeededFieldsFilter,
        getArrayFromObjectFilter,
        getArrayOfIdsFilter,
        errAlertS,
        filterFilter,
        successAlertS,
        filterDataFromImportFilter,
        validateRowImportFilter,
        formatDataToImportFilter,
        importsReferenceObjectFilter,
        loopEachFilter
    ) {
        $scope.neededFields = [];
        $scope.searchInAutocomplete = {};
        $scope.dataToImport = {};
        $scope.dataToImportC = {};
        $scope.currentPage = 1;
        $scope.formIsValid = false;
        $scope.allowExceptions = false;
        $scope.generateDefaultMovement = function () {
            for (var d = 0; d < $scope.dataFromImport.length; d++) {
                var row = $scope.dataFromImport[d];
                if (!row.config.createMovementType && row["rp-rp"] !== "00000000000") {
                    $scope.dataFromImport[d].config.createMovementType = true;
                }
            }
        }
        $scope.loadNeededFields = function (type) {
            $scope.neededFields = importNeededFieldsFilter(type, true);
            $scope.requiredFields = importNeededFieldsFilter(type, true, false, true);
            $scope.neededActions = importNeededFieldsFilter(false, false);
            $scope.inputTypes = importNeededFieldsFilter(type, false, true);
            $log.debug('needed maps', {
                neededFields: $scope.neededFields,
                requiredFields: $scope.requiredFields,
                neededActions: $scope.neededActions,
                inputTypes: $scope.inputTypes,
                import: $scope.import
            })
        }

        $scope.removeRow = function (row) {
            for (var d = 0; d < $scope.dataFromImport.length; d++) {
                if ($scope.dataFromImport[d] === row) {
                    $scope.dataFromImport.splice(d, 1);
                    return;
                }
            }
            return;
        }

        function permiteException(row, value) {
            row.config.permiteException = value;
            // parche feo ya que al ser invalido no se toma en cuenta el ng-Model
            if (angular.isUndefined(row.id) && angular.isDefined(row['id-unique'])) {
                row.id = angular.copy(row['id-unique'].old);
            }
            // if(row.config.permiteException) row.config.valid = true;
            $scope.validateAllExceptions();
        }

        $scope.permiteExceptionAll = function () {
            for (var d = 0; d < $scope.dataFromImport.length; d++) {
                var row = $scope.dataFromImport[d];
                if (!row.config.permiteException && !row.config.valid) {
                    permiteException(row, true);
                }
            }
            // ng-repeat='row in (F.filteredItems = (dataFromImport)) | limitTo: F.paginate: (currentPage - 1) * F.paginate'
            // <md-button ng-if='!row.config.permiteException && !row.config.valid'
            //     ng-click='permiteException(row, true);cancel();'
            //     class='md-raised md-background md-warn md-hue-2'
            //     aria-label='Exception'>
            //     <span>Permitir Excepciones</span>
            // </md-button>
        }

        $scope.validationAction = function (ev, row, type) {
            $log.debug(row, type, "validateAction");
            $mdDialog.show({
                templateUrl: 'app/main/config/views/imports/dialogs/validation-row.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                locals: {
                    row: row,
                    type: type,
                    iType: $scope.import.type,
                    dataFromImport: $scope.dataFromImport,
                    removeRow: $scope.removeRow,
                    validateAllExceptions: $scope.validateAllExceptions,
                    permiteException: permiteException
                },
                // controller: 'DialogCtrl',

                controller: function (scope, row, type, iType, dataFromImport, removeRow, validateAllExceptions, permiteException) {
                    scope.row = row;
                    scope.type = type;
                    scope.iType = iType;
                    scope.cancel = function () {
                        $mdDialog.hide();
                    }
                    scope.permiteException = permiteException;
                    scope.createMovement = function (row, value) {
                        row.config.createMovement = value;
                    }
                    scope.createMovementType = function (row, value) {
                        row.config.createMovementType = value;
                    }
                    scope.removeRow = removeRow;
                },
                // scope: $scope.$new(),
                clickOutsideToClose: true
                //fullscreen: true
            });
        }

        var dataIsValid = function (data) {
            for (var d in data) {
                if (data[d].config) {
                    if (!data[d].config.permiteException) {
                        if (!data[d].config.valid) return false;
                    }
                }
            }
            return true;
        }

        $scope.validateField = function (value, field, row) {
            $log.debug(value, field, row, $scope.M.states, 'validateField');
            if (angular.isUndefined(row.config.validations)) row.config.validations = {};

            if ($scope.requiredFields.indexOf(field) !== -1) {
                if ($scope.inputTypes.fbAutocompletes.hasOwnProperty(field)) {
                    if (row[field + '-object'] !== null) {
                        if (row[field + '-object'].hasOwnProperty('$id')) {
                            row[field] = row[field + '-object'].$id;
                            row[field + '-name'] = row[field + '-object'].name;
                            delete row.config.validations[field];
                        } else {
                            row.config.validations[field] = 'campo requerido';
                        }
                    } else {
                        row[field] = null;
                        row.config.validations[field] = 'campo requerido';
                    }
                } else if ($scope.inputTypes.mongoAutocompletes.hasOwnProperty(field)) {
                    if (row[field + '-object'] !== null) {
                        var prop = $scope.inputTypes.mongoAutocompletes[field].selectUse;
                        if (row[field + '-object'].hasOwnProperty(prop)) {
                            row[field] = row[field + '-object'][prop];
                            row[field + '-name'] = row[field + '-object'].name;
                            delete row.config.validations[field];
                        } else {
                            row.config.validations[field] = 'campo requerido';
                        }
                    } else {
                        row[field] = null;
                        row.config.validations[field] = 'campo requerido';
                    }
                } else {
                    if (angular.isDefined(value) && value !== null) {
                        if (angular.isDefined(row.config.validations[field])) {
                            delete row.config.validations[field];
                        }
                    } else {
                        row.config.validations[field] = 'campo requerido';
                    }
                }
            }
            if (value) {
                console.log(value, $scope.inputTypes.unique[field])
                if ($scope.inputTypes.unique[field]) {
                    $scope.F.root.child('catalogs/' + $scope.import.type + '/collection').orderByChild('created/sqlId').equalTo(value).once('value', function (snaps) {
                        var val = snaps.val();
                        if (val == null) {
                            if (angular.isDefined(row.config.validations[field])) {
                                delete row.config.validations[field];
                                if (row.hasOwnProperty(field + '-unique')) delete row[field + '-unique'];
                            }
                            if (!Object.keys(row.config.validations).length) row.config.valid = true;
                            $scope.formIsValid = dataIsValid($scope.dataFromImport);
                        } else {
                            row.config.valid = false;
                            row.config.validations[field] = 'registro importado previamente';
                            snaps.forEach(function (sna) {
                                row[field + '-unique'] = sna.key;
                            });
                            $scope.formIsValid = dataIsValid($scope.dataFromImport);
                        }
                    });
                }
                if (['sd', 'sbc'].indexOf(field) !== -1) {
                    if (!row.nss || row.nss == null || row.nss == 'NULL') { // si empleado está asegurado
                        delete row.config.validations[field]; // entonces no es requerido
                    }
                }
                if (field == 'cc_id') {
                    if (value != null && angular.isDefined(value)) {
                        delete row.config.validations[field];
                    }
                    if (value != null) {
                        $scope.F.root.child('catalogs/ccs/collection').child(value).child('data/rp_id').once('value', function (snapd) {
                            var val = snapd.val();
                            if (val !== null) {
                                row['rp'] = val;
                                delete row.config.validations['rp'];
                                if (!Object.keys(row.config.validations).length) {
                                    row.config.valid = true;
                                }
                            } else {
                                row['rp'] = null
                                row.config.valid = false;
                                row.config.validations['rp'] = 'centro de costo no tiene rp';
                            }
                            $scope.formIsValid = dataIsValid($scope.dataFromImport);
                        });
                    } else {
                        row['rp'] = null
                        row.config.valid = false;
                        row.config.validations['rp'] = 'centro de costo no tiene rp';
                        $scope.formIsValid = dataIsValid($scope.dataFromImport);
                    }
                }
                if (field == 'nominas_id') {
                    if (value != null && angular.isDefined(value)) {
                        delete row.config.validations[field];
                    }
                    if (value != null) {
                        $scope.F.root.child('catalogs/payrolls/collection').child(row['nominas_id']).child('firm').once('value', function (snapd) {
                            var val = snapd.val();
                            if (val !== null) {
                                row['firm'] = val;
                                delete row.config.validations['firm'];
                                if (!Object.keys(row.config.validations).length) {
                                    row.config.valid = true;
                                }
                            } else {
                                row['firm'] = null
                                row.config.valid = false;
                                row.config.validations['firm'] = 'nómina no tiene cliente';
                            }
                            $scope.formIsValid = dataIsValid($scope.dataFromImport);
                        });
                    } else {
                        row['firm'] = null
                        row.config.valid = false;
                        row.config.validations['firm'] = 'nómina no tiene cliente';
                        $scope.formIsValid = dataIsValid($scope.dataFromImport);
                    }
                }

                $log.debug('after validations -> row', row)
            }
            //Funcion para crear el nombre y el nombre del beneficiario
            var compoundFields = {
                name: ['apellido_paterno', 'apellido_materno', 'nombre']
            };
            loopEachFilter(compoundFields, function (compoundField, key) {
                if (compoundField.indexOf(field) !== -1) {
                    var objArray = [];
                    for (var c = 0; c < compoundField.length; c++) {
                        if (angular.isString(row[compoundField[c]]) && row[compoundField[c]] !== '') {
                            objArray.push(row[compoundField[c]].trim());
                        }
                    }
                    if (objArray.length > 0) {
                        row[key] = objArray.join(' ');
                    }
                }
            });
            // if (['nombre', 'apellido_materno', 'apellido_paterno'].indexOf(field) !== -1) {
            //     var paternalSurname = (row['apellido_paterno']) ? row['apellido_paterno'] : '';
            //     var maternalSurname = (row['apellido_materno']) ? row['apellido_materno'] : '';
            //     var name = (row['nombre']) ? row['nombre'] : '';
            //     row['name'] = paternalSurname + " " + maternalSurname + " " + name;
            // }
            if (!Object.keys(row.config.validations).length) {
                row.config.valid = true;
            } else {
                row.config.valid = false;
            }

            $scope.formIsValid = dataIsValid($scope.dataFromImport);
        }

        $scope.mongoAutocomplete = function (term, field, item) {
            $rootScope.loadingProgress = true;
            return $q(function (resolve, reject) {
                var refConfig = $scope.inputTypes.mongoAutocompletes[field];

                $scope.D.api.autocomplete(refConfig.catalog, term).then(function (res) {
                    if (res.data.length) {
                        resolve(res.data);
                    } else {
                        resolve([]);
                    }
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync(function () {
                        $log.debug('mongoAutoComplete finished');
                    });
                }).catch(function (err) {
                    $log.error(err);
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                    reject(err);
                });
            });
        }

        $scope.fbAutocomplete = function (term, field, item) {
            $rootScope.loadingProgress = true;
            var refConfig = $scope.inputTypes.fbAutocompletes[field];

            return $q(function (resolve, reject) {
                var ref;
                if (!refConfig.child) {
                    // ref = $scope.F.root.child('lists').child(refConfig.parent);
                    ref = "lists/" + refConfig.parent;
                } else {
                    var rref = refConfig.listRef;
                    if (refConfig.listRef.search('<z>') !== -1) {
                        var relFieldChild = refConfig.child.match(/<z>(.*?)<\/z>/g) + '';
                        var relField = relFieldChild.replace('<z>', '');
                        relField = relField.replace('</z>', '');
                        rref = refConfig.listRef.replace(relFieldChild, item[relField]);
                    }
                    // ref = $scope.F.root.child(rref);
                    ref = rref;
                }
                console.log(ref);
                var searchQ = term.toUpperCase();
                // ref.orderByChild(refConfig.by).startAt(searchQ).endAt(searchQ + '\uf8ff').once('value', function (snap) {
                $rootScope.L.loadList("lists", ref, false, "array", "custom/" + ref).then(function (allData) {
                    var thisData = [].concat(allData);
                    var query = {};
                    query[refConfig.by] = searchQ;
                    var thisData = filterFilter(thisData, query);
                    resolve(thisData);
                    // var value = snap.val();
                    // if (value !== null) {
                    //     var array = getArrayFromObjectFilter(value, false, true);
                    //     resolve(array);
                    // } else {
                    //     resolve([]);
                    // }
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync(function () {
                        $log.debug('fbAutocomplete finished');
                    });
                }).catch(function (err) {
                    reject(err);
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                });
            });
        }

        $scope.editRow = function (row) {
            console.log(JSON.parse(JSON.stringify(row)));
            if (angular.isUndefined(row.config.editMode) || row.config.editMode == null) {
                row.config.editMode = true;
            } else {
                row.config.editMode = !row.config.editMode;
                row = validateRowImportFilter(row, $scope.requiredFields, $scope.inputTypes, $scope.import.type);
            }
            $log.debug(row, 'editRow')
        }

        $scope.review = function () {
            $log.debug('Initilizing review process..', $scope.dataFromImport);
            $rootScope.loadingProgress = true;
            formatDataToImportFilter($scope.dataFromImport, $scope.neededActions, $scope.import.type).then(function (dataToImport) {
                $scope.dataToImport = dataToImport;
                $log.debug(dataToImport, 'dataToImport');
                $scope.import.status = 1;
                $scope.selectedTab = 2;
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync(function () {
                    $log.debug('review finished');
                });
            }).catch(function (err) {
                errAlertS(err);
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
            });
        }

        $scope.removeInvalids = function () {
            var removeThis = [];
            for (var r in $scope.dataFromImport) {
                if (!$scope.dataFromImport[r].config.valid) {
                    removeThis.push(r);
                }
            }
            for (var i = removeThis.length - 1; i >= 0; i--)
                $scope.dataFromImport.splice(removeThis[i], 1);
            successAlertS('Regístros inválidos removidos de la lista');
        }

        $scope.allowAllExceptions = function () {
            $scope.allowExceptions = !$scope.allowExceptions;
            for (var r in $scope.dataFromImport) {
                if (!$scope.dataFromImport[r].config.valid) {
                    $scope.dataFromImport[r].config.permiteException = $scope.allowExceptions;
                }
            }
        }

        $scope.validateAllExceptions = function () {
            $scope.formIsValid = dataIsValid($scope.dataFromImport);
        }

        $scope.importData = function () {
            $log.debug('Importing data..', $scope.dataToImport);
            $rootScope.loadingProgress = true;
            $scope.import.imports = importsReferenceObjectFilter($scope.dataToImport, $scope.import.type);
            // first create import
            $scope.import.created = $scope.D.getTimeObject();
            var importId = $scope.F.root.child('imports/collection').push().key;
            // concatenate all requests
            var requests = {};
            $scope.import.file = null;
            requests['imports/collection/' + importId] = $scope.import;

            var salaryTypes = {};
            var workerTypes = {};
            var workDays = {};
            var latestMov = {};
            var latestCredit = {};
            var lastDismiss = {};
            var lastMds = {};
            var lastEnrole = {};
            var lastMovementData = {};
            // primero se recorren los movimientos construidos para empleados y movimientos
            if (['movements', 'employees'].indexOf($scope.import.type) !== -1) {
                for (var mid in $scope.dataToImport.movements) {
                    // al movimiento se le asigna el id de la importación que se va a crear
                    $scope.dataToImport.movements[mid].import = importId;

                    // Defaults
                    // si no existe un ultimo movimiento para el empleado se pone el primer registro de fecha (timestamp)
                    // se debe asignar unicamente si es un movimiento de la ultima empresa
                    if (angular.isUndefined(latestMov[$scope.dataToImport.movements[mid].employee])) {
                        if ($scope.dataToImport.movements[mid]['employee-rp'] === $scope.dataToImport.movements[mid].rp) {
                            latestMov[$scope.dataToImport.movements[mid].employee] = angular.copy($scope.dataToImport.movements[mid].data.date);
                            // console.log('damn', {
                            //     record: angular.copy($scope.dataToImport.movements[mid]),
                            //     validation: $scope.dataToImport.movements[mid]['employee-rp'] == $scope.dataToImport.movements[mid].rp, 
                            //     latestm: latestMov[$scope.dataToImport.movements[mid].employee]
                            // });
                        }
                    }

                    // se pone el primer registro de tipo_de_salario a su default
                    if (angular.isUndefined(salaryTypes[$scope.dataToImport.movements[mid].employee])) salaryTypes[$scope.dataToImport.movements[mid].employee] = {
                        st: 2 // default
                    };

                    // se pone el primer registro de tipo_de_trabajador
                    if (angular.isUndefined(workerTypes[$scope.dataToImport.movements[mid].employee])) workerTypes[$scope.dataToImport.movements[mid].employee] = {
                        mid: mid,
                        wt: angular.copy($scope.dataToImport.movements[mid].data.workerType)
                    };

                    // se pone el primer registro de jornada
                    if (angular.isUndefined(workDays[$scope.dataToImport.movements[mid].employee])) workDays[$scope.dataToImport.movements[mid].employee] = {
                        mid: mid,
                        wd: 0 // default
                    };

                    // si el ultimo movimiento registrado es menor o igual a el movimiento que va en la iteración
                    // entonces se garantiza el "Ultimo movimiento" al final de la iteración
                    // se llenan mapas para que cada empleado tenga su propio objeto
                    if (latestMov[$scope.dataToImport.movements[mid].employee] <= $scope.dataToImport.movements[mid].data.date &&
                        $scope.dataToImport.movements[mid]['employee-rp'] == $scope.dataToImport.movements[mid].rp) {

                        // setear fecha de ultimo movimiento
                        latestMov[$scope.dataToImport.movements[mid].employee] = angular.copy($scope.dataToImport.movements[mid].data.date);

                        // console.log('damn 2', {
                        //     record: angular.copy($scope.dataToImport.movements[mid]),
                        //     validation: $scope.dataToImport.movements[mid]['employee-rp'] == $scope.dataToImport.movements[mid].rp, 
                        //     latestm: latestMov[$scope.dataToImport.movements[mid].employee]
                        // });


                        if ($scope.dataToImport.movements[mid].data.type == 2) { // setear ultima baja
                            lastDismiss[$scope.dataToImport.movements[mid].employee] = angular.copy($scope.dataToImport.movements[mid]);
                        } else if ($scope.dataToImport.movements[mid].data.type == 7) {// setear ultimo mds
                            lastMds[$scope.dataToImport.movements[mid].employee] = angular.copy($scope.dataToImport.movements[mid]);
                        } else if ([6, 8].indexOf($scope.dataToImport.movements[mid].data.type) !== -1) { // alta o reingreso
                            lastEnrole[$scope.dataToImport.movements[mid].employee] = angular.copy($scope.dataToImport.movements[mid]);
                        }

                        // setear en employee.movement data del ultimo movimiento
                        var mData = angular.copy($scope.dataToImport.movements[mid].data);

                        mData.uid = angular.copy(mid);
                        if ($scope.import.type == 'movements') {
                            // cuando es movimientos se puede setear al final el movimiento del empleado
                            lastMovementData[$scope.dataToImport.movements[mid].employee] = angular.copy(mData);
                        } else if ($scope.import.type == 'employees') {
                            $scope.dataToImport.employees[$scope.dataToImport.movements[mid].employee].movement = mData;
                        }
                        // setear ultimas fechas

                        // setear el mapa de salarytypes por empleado para asi saber cual es del ultimo movimiento
                        salaryTypes[$scope.dataToImport.movements[mid].employee] = {
                            mid: mid, // in case we need to debug
                            st: angular.copy($scope.dataToImport.movements[mid].data.salaryType)
                        };

                        // setear el mapa de tipo de trabajador por empleado para asi saber cual es del ultimo movimiento
                        workerTypes[$scope.dataToImport.movements[mid].employee] = {
                            mid: mid, // in case we need to debug
                            wt: angular.copy($scope.dataToImport.movements[mid].data.workerType)
                        };

                        // setear el mapa de jornada por empleado para asi saber cual es del ultimo movimiento
                        workDays[$scope.dataToImport.movements[mid].employee] = {
                            mid: mid, // in case we need to debug
                            wd: angular.copy($scope.dataToImport.movements[mid].data.workDay)
                        };
                    }

                    // set miniMovement del movimiento
                    if ($scope.import.type == 'movements') {
                        requests['employees/collection/' + $scope.dataToImport.movements[mid].employee + '/movements/' + mid] = {
                            s: $scope.dataToImport.movements[mid].status,
                            d: $scope.dataToImport.movements[mid].data.date,
                            t: $scope.dataToImport.movements[mid].data.type,
                            p: $scope.dataToImport.movements[mid].payroll
                        };
                    } else if ($scope.import.type == 'employees') {
                        if (!$scope.dataToImport.employees[$scope.dataToImport.movements[mid].employee].hasOwnProperty('movements')) $scope.dataToImport.employees[$scope.dataToImport.movements[mid].employee].movements = {};
                        $scope.dataToImport.employees[$scope.dataToImport.movements[mid].employee].movements[mid] = {
                            s: $scope.dataToImport.movements[mid].status,
                            d: $scope.dataToImport.movements[mid].data.date,
                            t: $scope.dataToImport.movements[mid].data.type,
                            p: $scope.dataToImport.movements[mid].payroll
                        };
                    }
                    // se conservan campos para referencia de importación
                    // hardcode delete, ya que se agrego anteriormente solo para poder referenciarlo
                    // $scope.dataToImport.movements[mid].data.salaryType = null;
                    // $scope.dataToImport.movements[mid].data.workerType = null;
                    // $scope.dataToImport.movements[mid].data.workDay = null;

                    // se setea en requests el movimiento completo solo si tiene empleado

                    var maternalSurname = $scope.dataToImport.movements[mid].info.maternalSurname ? $scope.dataToImport.movements[mid].info.maternalSurname + " " : "";
                    var paternalSurname = $scope.dataToImport.movements[mid].info.paternalSurname ? $scope.dataToImport.movements[mid].info.paternalSurname + " " : "";
                    var names = $scope.dataToImport.movements[mid].info.names ? $scope.dataToImport.movements[mid].info.names : "";
                    $scope.dataToImport.movements[mid].info.name = paternalSurname + maternalSurname + names;
                    if ($scope.dataToImport.movements[mid].employee) {
                        // se borra el employee-rp
                        $scope.dataToImport.movements[mid]['employee-rp'] = null;
                        requests['movements/collection/' + mid] = $scope.dataToImport.movements[mid];
                    }

                }
            } else if ($scope.import.type == 'credits') {
                for (var cid in $scope.dataToImport.credits) {
                    // al crédito se le asigna el id de la importación que se va a crear
                    $scope.dataToImport.credits[cid].import = importId;

                    // Defaults
                    // si no existe un ultimo credito para el empleado se pone el primer registro de fecha (timestamp)
                    if (angular.isUndefined(latestCredit[$scope.dataToImport.credits[cid].employee])) latestCredit[$scope.dataToImport.credits[cid].employee] = {
                        cid: cid,
                        d: angular.copy($scope.dataToImport.credits[cid].data.date)
                    };

                    // si el ultimo credito registrado es menor o igual a el credito que va en la iteración
                    // entonces se garantiza el "Ultimo credito" al final de la iteración
                    // se llenan mapas para que cada empleado tenga su propio objeto
                    if (latestCredit[$scope.dataToImport.credits[cid].employee].d <= $scope.dataToImport.credits[cid].data.date) {
                        // setear fecha de ultimo credito
                        latestCredit[$scope.dataToImport.credits[cid].employee].d = angular.copy($scope.dataToImport.credits[cid].data.date);
                        latestCredit[$scope.dataToImport.credits[cid].employee].cid = angular.copy(cid);
                    }

                    requests['credits/collection/' + cid] = $scope.dataToImport.credits[cid];

                    // set miniCredit en el empleado
                    requests['employees/collection/' + $scope.dataToImport.credits[cid].employee + '/credits/' + cid] = {
                        d: $scope.dataToImport.credits[cid].data.date,
                        v: $scope.dataToImport.credits[cid].valid
                    };
                }
            }

            if ($scope.import.type == 'movements') {
                // set el ultimo tipo_de_salario en empleado
                for (var eid in salaryTypes) {
                    requests['employees/collection/' + eid + '/data/salary/type'] = salaryTypes[eid].st;
                }

                for (var eid2 in lastDismiss) {
                    // si la baja es el ultimo movimiento o la fecha de la ultima baja es mayor a la fecha de la ultima alta, se setea la ultima fecha de baja en el empleado
                    if ((latestMov[eid2] == lastDismiss[eid2].data.date) || (lastDismiss[eid2].data.date > lastEnrole[eid2].data.date)) {
                        requests['employees/collection/' + eid2 + '/data/dismissDate'] = lastDismiss[eid2].data.date;
                        var status = lastDismiss[eid2].status;
                        if (angular.isUndefined(status) || [1, 2, 3, 4].indexOf(status) === -1 || status === 4) {
                            status = 5;
                        }
                        requests['employees/collection/' + eid2 + '/status'] = status;
                    }
                }
                for (var eid3 in lastEnrole) {
                    requests['employees/collection/' + eid3 + '/data/enroleDate'] = lastEnrole[eid3].data.date;
                    var status = lastEnrole[eid3].status;
                    if (angular.isUndefined(status) || [1, 2, 3, 4].indexOf(status) === -1) {
                        status = 4;
                    }
                    requests['employees/collection/' + eid3 + '/status'] = status;
                }
                for (var eid4 in lastMds) {
                    // si el mds es el ultimo movimiento o la fecha del ultimo mds es mayor a la fecha de la ultima alta, se setea la ultima fecha de mds en el empleado
                    if ((latestMov[eid4] == lastMds[eid4].data.date) || (lastMds[eid4].data.date > lastEnrole[eid4].data.date)) {
                        requests['employees/collection/' + eid4 + '/data/mdsDate'] = lastMds[eid4].data.date;
                        requests['employees/collection/' + eid4 + '/data/salary/sd'] = lastMds[eid4].data.sd || null;
                        requests['employees/collection/' + eid4 + '/data/salary/sbc'] = lastMds[eid4].data.sbc || null;
                        requests['employees/collection/' + eid4 + '/data/salary/type'] = lastMds[eid4].data.salaryType || null;
                        var status = lastMds[eid4].status;
                        if (angular.isUndefined(status) || [1, 2, 3, 4].indexOf(status) === -1) {
                            status = 4;
                        }
                        requests['employees/collection/' + eid4 + '/status'] = status;
                    }
                }
                for (var eid5 in workerTypes) {
                    requests['employees/collection/' + eid5 + '/data/workerType'] = workerTypes[eid5].wt;
                }
                for (var eid6 in workDays) {
                    requests['employees/collection/' + eid6 + '/data/workDay'] = workDays[eid6].wd;
                }
                for (var eid7 in lastMovementData) {
                    requests['employees/collection/' + eid7 + '/movement'] = lastMovementData[eid7];
                }
            }
            // set id of import in each reference
            for (var uidn in $scope.dataToImport.employees) {
                $scope.dataToImport.employees[uidn].import = importId;
                requests['employees/collection/' + uidn] = $scope.dataToImport.employees[uidn];
            }

            $log.debug($scope.import, requests, 'request for import');
            $scope.F.root.child('catalogs').update(requests).then(function () {
                if ($scope.import.type == 'credits') {
                    var requests2 = {};
                    // set el ultimo credito válido en empleado
                    for (var eeid in latestCredit) {
                        requests2['employees/collection/' + eeid + '/credits/' + latestCredit[eeid].cid + '/v'] = true;
                        requests2['credits/collection/' + latestCredit[eeid].cid + '/valid'] = true;
                    }
                    $log.debug(requests2, 'requests after done for credit');
                    $scope.F.root.child('catalogs').update(requests2).then(function () {
                        successAlertS('Importación de registros completada');
                        setNssAndNamesForCredits($scope.dataToImport.credits);
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync(function () {
                            $log.debug('importData finished');
                        });
                        $scope.R.goToList();
                    });
                } else {
                    // se setea un nuevo sqlId si no lo llevan 
                    // (se setea solo la tarea, el servidor se encarga de garantizar que no se repitan los ids)
                    setEmployeeNumberIfDoesntHaveOne($scope.dataToImport.employees, requests)
                        .then(function () {
                            successAlertS('Importación de registros completada');
                            $rootScope.loadingProgress = false;
                            $rootScope.$evalAsync(function () {
                                $log.debug('importData 2 finished');
                            });
                            $scope.R.goToList();
                        }).catch(function (err) {
                            errAlertS(err);
                            $rootScope.loadingProgress = false;
                            $rootScope.$evalAsync();
                        });
                }
            }, function (err) {
                errAlertS(err);
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
            });
        }

        $scope.uploadToImport = function (files) {
            $rootScope.loadingProgress = true;
            $log.debug('Initializing upload to import process..');
            var formData = new FormData();
            $scope.F.loadingFile = true;
            formData.append('file', files[0].lfFile);
            $log.debug(formData, 'formData to be uploaded');
            $scope.D.files.csvToJson(formData).then(function (data) {
                $log.debug(data.data, 'data from csv');
                if (data.data.error_code) {
                    errAlertS(data.data.err_desc);
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                } else {
                    $scope.import.status = 0;
                    $scope.selectedTab = 1;
                    $scope.import.file = true;
                    filterDataFromImportFilter(data.data, $scope.import.type, $scope.inputTypes)
                        .then(function (dataFiltered) {
                            $scope.dataFromImport = dataFiltered;
                            $scope.import.payroll = $scope.dataFromImport[0].nominas_id;
                            for (var r in $scope.dataFromImport) {
                                $scope.dataFromImport[r] = validateRowImportFilter($scope.dataFromImport[r], $scope.requiredFields, $scope.inputTypes, $scope.import.type);
                                //listenValidations(r);
                            }
                            $scope.formIsValid = dataIsValid($scope.dataFromImport);
                            $scope.F.loadingFile = false;
                            $rootScope.loadingProgress = false;
                            $rootScope.$evalAsync(function () {
                                $log.debug($scope.dataFromImport, 'dataFromImport loaded');
                            });
                        }).catch(function (err) {
                            errAlertS(err);
                            $rootScope.loadingProgress = false;
                            $rootScope.$evalAsync();
                        });
                }
            }).catch(function (err) {
                errAlertS(err);
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
            });
        }
        $scope.dataIsValid = dataIsValid;
        var setEmployeeNumberIfDoesntHaveOne = function (employees, requests) {
            return new Promise(function (resolve, reject) {
                var promises = [];
                var employeesPayrolls = [];
                var payrollIds = {};
                for (var e in employees) {
                    if (employees.hasOwnProperty(e) && requests.hasOwnProperty('employees/collection/' + e) && requests['employees/collection/' + e].payroll) {
                        var payrollId = requests['employees/collection/' + e].payroll;
                        if (!payrollIds.hasOwnProperty(payrollId)) {
                            payrollIds[payrollId] = promises.length;
                            promises.push($scope.F.root.child('catalogs/payrolls/collection/' + payrollId + '/generateEmployeeNumber').once('value'));
                        }
                        employeesPayrolls.push([e, payrollId]);
                    }
                }
                Promise.all(promises).then(function (resp) {
                    var requests = [];
                    for (var payrollId in payrollIds) {
                        payrollIds[payrollId] = resp[payrollIds[payrollId]].exists() && resp[payrollIds[payrollId]].val();
                    }
                    for (var e = 0; e < employeesPayrolls.length; e++) {
                        var thisERow = employeesPayrolls[e];
                        if (payrollIds[thisERow[1]]) {
                            requests.push($rootScope.F.setLastEmployeeNumber(thisERow[0]));
                        }
                    }
                    return Promise.all(requests);
                }).then(function () {
                    resolve(true);
                }).catch(reject);
            })
        }
        var setNssAndNamesForCredits = function (credits) {
            for (var c in credits) {
                $scope.F.root.child('queue1/tasks').push({
                    type: 'setNssAndNameForCredits',
                    creditId: c,
                    employeeId: credits[c].employee
                })
            }
        }

        var stopWatchingThis = $scope.$watch('F.addMode', function (addMode) {
            if (!addMode) {
                $scope.selectedTab = 3;
                stopWatchingThis();
            }
        });

    }

}());
(function () {
    'use strict';

    angular
        .module('app.config')
        .controller('HolidaysController', HolidaysController);

    function HolidaysController($scope, $rootScope, $mdDialog, $log, clearObjectFilter, successAlertS, errAlertS) {
        function copyHolidays(event, selected) {
            var confirm = {
                controller: 'DialogCtrl',
                parent: angular.element(document.body),
                targetEvent: event,
                scope: $scope.$new(),
                locals: {
                    predefinedValue: undefined
                },
                clickOutsideToClose: true,
                templateUrl: 'app/main/config/views/holidays/select-year.html'
            }
            $mdDialog.show(confirm).then(function (answer) {
                $rootScope.loadingProgress = true;
                var ref = "catalogs/holidays/collection";
                var updates = {};
                for (var i = 0; i < selected.length; i++) {
                    var thisHoliday = JSON.parse(JSON.stringify(selected[i]));
                    thisHoliday.year = answer;
                    var thisHolidayDate = moment(thisHoliday.date).year(parseInt(thisHoliday.year));
                    thisHoliday.date = thisHolidayDate.valueOf();
                    var id = $scope.F.root.child(ref).push().key;
                    updates[id] = clearObjectFilter(thisHoliday);
                }
                $scope.F.root.child(ref).update(updates).then(function () {
                    successAlertS("Se copiaron las incidencias con exito");
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                    $scope.selected = [];
                }).catch(function (error) {
                    errAlertS("Hubo un error al copiar las incidencias intentelo nuevamente");
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                    console.log(error);
                })
            }, function () {
                $log.debug('copy holidays cancelled');
                return false;
            });

            // var year = 2018;
            // var updates = {};
            // for (var i = 0; i < all.length; i++) {
            //     var thisHoliday = all[i];
            //     thisHoliday.date = thisHoliday.date.valueOf();
            //     var id = $scope.F.root.child(ref).push().key;
            //     updates[id] = thisHoliday;
            // }
            // $scope.F.root.child(ref).update(updates);
        }
        $scope.copyHolidays = copyHolidays;
    }
})();
(function() {
    'use strict';

    angular
        .module('app.config')
        .controller('HolidayController', HolidayController);

    function HolidayController($scope) {
        function setDayAndMonth(date) {
            var thisDate = moment(date);
            $scope.holiday.day = thisDate.date();
            $scope.holiday.month = thisDate.month() + 1;
        }
        $scope.setDayAndMonth = setDayAndMonth;

    }
})();
(function () {
    'use strict';

    angular
        .module('app.config')
        .controller('GroupsController', GroupsController);

    /** @ngInject */
    function GroupsController($scope, errAlertS, $q, $log, $rootScope, $mdDialog, loopEachFilter, Slug, clearObjectFilter, DataF, successAlertS, $timeout, uppercaseFilter) {
        $scope.canSort = true;
        function deleteGroupsFromUsers() {
            return new Promise(function (resolve, reject) {
                var requests = {};
                for (var s = 0; s < $scope.selected.length; s++) {
                    var groupId = $scope.selected[s].$id;
                    requests[groupId] = $scope.F.root.child('profiles').orderByChild('groupsOfUser/' + groupId).equalTo(true).once('value');
                }
                $q.all(requests).then(function (groupsProfiles) {
                    var updates = {};
                    loopEachFilter(groupsProfiles, function (snap, group) {
                        snap.forEach(function (childSnap) {
                            updates[childSnap.key + '/groupsOfUser/' + group] = null;
                        });
                    });
                    return $scope.F.root.child('profiles').update(updates);
                }).then(function () {
                    resolve(true);
                }).catch(reject);
            });
        }
        var changePriority = function () {
            var updates = {};
            var count = 0;
            $scope.groups.map(function (item) {
                count++;
                $log.log(item.name);
                updates[item.$id + '/order'] = count;
                return item;
            });
            return $scope.F.root.child('groups').update(updates);
        };

        $scope.sortableOptions = {
            ghostClass: 'ghost',
            onEnd: changePriority
        };

        $scope.copyGroup = function (ev, group) {
            var newGroupName;
            var newGroupId;
            var confirm = $mdDialog.prompt()
                .title('Ingrese el nombre del nuevo grupo')
                .textContent('Se esta copiando un grupo, se copiaran todos los permisos del grupo, y sus configuraciones, con excepción de los usuarios')
                .placeholder('Nombre del grupo')
                .ariaLabel('Nombre del grupo')
                .targetEvent(ev)
                .ok('Copiar Grupo')
                .cancel('Cancelar');
            $mdDialog.show(confirm).then(function (result) {
                if (result === '') {
                    throw 'Debe insertar el nombre del nuevo grupo';
                }
                $rootScope.loadingProgress = true;
                $scope.$evalAsync();
                newGroupName = uppercaseFilter(result);
                newGroupId = Slug.slugify(result);
                return $scope.F.root.child('/lists/groups/all/' + newGroupId).once('value');
            }).then(function (snapGroup) {
                if (snapGroup.exists()) {
                    throw 'Este grupo ya existe no se puede copiar el grupo con este mismo nombre';
                }
                return Promise.all([
                    $scope.F.root.child('permissions/' + group.$id).once('value'),
                    $scope.F.root.child('lists/groups/all').orderByChild('order').limitToLast(1).once('value')
                ]);
            }).then(function (snap) {
                var order = 0;
                snap[1].forEach(function (childSnap) {
                    if (childSnap.val().order) {
                        order = childSnap.val().order;
                    }
                });
                order++;
                var newGroup = clearObjectFilter(group);
                delete newGroup.users;
                delete newGroup.updated;
                newGroup.created = DataF.getTimeObject();
                newGroup.name = newGroupName;
                newGroup.order = order;
                var newGroupPermissions = snap[0].val();
                $log.log(newGroupId, newGroupName, newGroup, newGroupPermissions);
                var promises = [
                    $scope.F.root.child('permissions/' + newGroupId).set(newGroupPermissions),
                    $scope.F.root.child('groups/' + newGroupId).set(newGroup)
                ];
                return Promise.all(promises);
            }).then(function () {
                successAlertS('Se copio el grupo con éxito');
            }).catch(function (error) {
                if (error) {
                    errAlertS(error);
                }
            }).then(function () {
                $rootScope.loadingProgress = false;
                $scope.$evalAsync(function () {
                    $timeout(function () { }, 0, false);
                });
            });
        };

        $scope.deleteGroupAndFromUsers = function (event) {
            $rootScope.loadingProgress = true;
            $scope.delete(event, 1).then(function () {
                deleteGroupsFromUsers().then(function () {
                    $scope.selected = [];
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync(function () {
                        $log.debug('deleteGroupAndFromUsers finished');
                    });
                }).catch(function (err) {
                    errAlertS(err);
                    $scope.selected = [];
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                });
            }).catch(function (err) {
                errAlertS(err);
                $scope.selected = [];
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
            });
        };
    }

}());
(function () {
    'use strict';

    angular
        .module('app.config')
        .controller('GroupController', GroupController);

    function GroupController(
        $scope,
        $rootScope,
        $document,
        $state,
        $firebaseObject,
        $firebaseArray,
        $log,
        successAlertS,
        errAlertS,
        $q,
        Slug,
        ListsF,
        getObjectsLikeTermOfArrayFilter,
        getDefaultPermissionsFilter,
        getUsersOfGroupFilter
    ) {

        var initiated = false;
        function init() {
            if (!initiated) {
                initiated = true;
                $scope.dataNeededPromise.then(function () {
                    console.log(ListsF.allGroups, ListsF.allProfiles)
                }).catch(errAlertS);
            }
        }

        $scope.autocomplete = function (search, lObject, clientParam, clientValue, operator) {
            //lObject allGroups || allProfiles
            var availablesLike = getObjectsLikeTermOfArrayFilter(search, ListsF[lObject] || [], 'name');
            if ($scope.group.groupForClient) {
                var availables = availablesLike.filter(function (item) {
                    var validation = (operator === 'equal') ? item[clientParam] === clientValue : item[clientParam] !== clientValue;
                    return validation;
                });
                return availables;
            } else {
                return availablesLike;
            }
        }

        function getLastOrderOfGroup() {
            return new Promise(function (resolve, reject) {
                $scope.F.root.child('lists/groups/all').orderByChild('order').limitToLast(1).once('value').then(function (snaps) {
                    var lastOrder = -1;
                    if (snaps.exists()) {
                        snaps.forEach(function (snap) {
                            var lastGroup = snap.val();
                            lastOrder = lastGroup.order;
                        });
                    }
                    resolve(lastOrder);
                }).catch(reject);
            });
        }

        $scope.addAndCreatePermissions = function (group) {
            try {
                $log.debug('adding group', group);
                group.created = $scope.D.getTimeObject();
                if ($scope.slug == 'new') {
                    errAlertS('No es posible guardar un grupo con ese nombre');
                    return false;
                }
                $rootScope.loadingProgress = true;
                // se hacen nuevos permisos @todo:backlog hacer que puedan copiar los permisos de un grupo en específico
                var newPermissions = getDefaultPermissionsFilter($scope.F.permissions[$scope.F.groupsOfUser[0]]);
                var updates = {};
                // obtener el ultimo orden para el grupo
                $log.log("getLastOrderOfGroup");
                getLastOrderOfGroup().then(function (lastOrder) {
                    $log.log("getLastOrderOfGroup finished");
                    group.order = lastOrder + 1;
                    updates['groups/' + $scope.slug] = group;
                    updates['permissions/' + $scope.slug] = newPermissions;
                    return $scope.F.root.update(updates);
                }).then(function () {
                    $log.log("updated finished");
                    successAlertS('Se creó Grupo con éxito');
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync(function () { });
                    $scope.R.goToList();
                }).catch(function (error) {
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync(function () { });
                    errAlertS(error);
                });
            } catch (error) {
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync(function () { });
                errAlertS(error);
            }

        }

        $scope.saveAndMoveIfNeeded = function (object, promise) {
            // $log.debug('saving group');
            object.updated = $scope.D.getTimeObject();
            $rootScope.loadingProgress = true;
            if ($scope.slug == 'new') {
                errAlertS('No es posible guardar un grupo con ese nombre');
                return false;
            }
            if (promise) return $scope.save(object);
            $scope.save(object, 1).then(function () {
                if ($scope.slug != $scope.group.$id) {
                    var moveGroupNode = $scope.D.moveTo("permissions/" + $scope.group.$id, "permissions/" + $scope.slug, "", true);
                    var movePermissionNode = $scope.D.moveTo("groups/" + $scope.group.$id, "groups/" + $scope.slug, "", true);
                    var promises = [moveGroupNode, movePermissionNode];
                    $q.all(promises).then(function () {
                        $scope.group = $firebaseObject($scope.F.root.child('groups').child($scope.slug));
                        $scope.group.$loaded(function (group) {
                            $scope.group = group;
                            $rootScope.loadingProgress = false;
                            $rootScope.$evalAsync(function () {
                                $log.debug('saveAndMoveIfNeeded finished');
                            });
                        });
                    }).catch(function (err) {
                        errAlertS(err);
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync();
                    });
                } else {
                    successAlertS('Se guardó Grupo con éxito');
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync(function () {
                        $log.debug('saveAndMoveIdNeeded 2 finished')
                    });
                    $scope.R.goToList();
                }
            }).catch(function (err) {
                errAlertS(err);
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
                $scope.R.goToList();
            });
        }

        $scope.transformChip = function (chip) {
            return chip.$id;
        }

        $scope.setProfilesAction = function (employee, value) {
            if (!$scope.group.users) {
                $scope.group.users = {};
            }
            $scope.group.users[employee] = value;
        }
        $scope.setGroupAction = function (name, value) {
            if (!$scope.group.gtm) {
                $scope.group.gtm = {};
            }
            $scope.group.gtm[name] = value;
        }

        var listWatchers = {};
        listWatchers.name = $scope.$watch('group.name', function (name) {
            if (name) {
                if (angular.isDefined(name) && name != '') {
                    $scope.slug = Slug.slugify(name);
                }
            }
        });
        listWatchers.users = $scope.$watch('group.users', function (users) {
            if (angular.isDefined(users) && users != '') {
                $scope.users = getUsersOfGroupFilter($scope.group.users);
            } else {
                $scope.users = [];
            }
        });
        listWatchers.gtm = $scope.$watch('group.gtm', function (gtm) {
            if (angular.isDefined(gtm) && gtm != '') {
                $scope.gtm = getUsersOfGroupFilter($scope.group.gtm);
            } else {
                $scope.gtm = [];
            }
        });

        /** Observa cuando carga el empleado para setear defaults y validaciones  */
        if ($scope.objectLoaded) {
            if (!initiated) { init(); }
        } else {
            $log.debug('setting watcher to mainObjLoaded');
            listWatchers.mainObjLoaded = $rootScope.$on('mainObjectLoaded', function () {
                if (!initiated) {
                    init();
                }
                listWatchers.mainObjLoaded();
                delete listWatchers.mainObjLoaded;
            });
        }
        $scope.$on("$destroy", function () {
            for (var f in listWatchers) {
                if (listWatchers.hasOwnProperty(f)) {
                    listWatchers[f]();
                    delete listWatchers[f];
                }
            }
        });

        //observa cuando cambia el estado para poblar los municipios
        // $scope.$watch('group', function(group) {
        //     if (group) {
        //         if (angular.isDefined(group.name) && group.name != '') {
        //             $scope.slug = Slug.slugify(group.name);
        //         }
        //         if (group.hasOwnProperty('users')) {
        //             // @todo:backlog quitar esto y cargarlo dinamicamente
        //             $scope.L.loadList('profiles', 'lists/profiles/all', false, 'array', 'users');
        //             $scope.users = getUsersOfGroupFilter($scope.group.users);
        //         } else {
        //             $scope.users = [];
        //         }

        //     }

        // }, true);
    }
})();
(function () {
    'use strict';

    angular
        .module('app.config')
        .controller('GlobalNotificationController', GlobalNotificationController);

    function GlobalNotificationController(
        $scope,
        $log,
        errAlertS,
        $filter,
        startAfterInitFilter
    ) {
        var initiated = false;
        $scope.listWatchers = {};
        function init() {

        }
        function filterNotifications(action) {
            if ($scope.globalNotification) {
                if (typeof ($scope.Z.globalNotification) === 'undefined') { $scope.Z.globalNotification = angular.copy($scope.blanc); }
                if (typeof ($scope.Z.globalNotification[action]) === 'undefined') { $scope.Z.globalNotification[action] = {}; }
                if ($scope.globalNotification.hasOwnProperty(action)) {
                    var thisGlobalNotification = $filter('clearObject')($scope.globalNotification[action]);
                    for (var status in thisGlobalNotification) {
                        if (thisGlobalNotification.hasOwnProperty(status)) {
                            var thisStatus = $scope.globalNotification[action][status];
                            if (typeof ($scope.Z.globalNotification[action][status]) === 'undefined') { $scope.Z.globalNotification[action][status] = []; }
                            if (!angular.isArray($scope.globalNotification[action][status].exceptions)) {
                                $scope.globalNotification[action][status].exceptions = [];
                            }
                            var items = [];
                            if (thisStatus.users) {
                                var users = $filter('getArrayFromObject')(thisStatus.users, 0, 1, true);
                                users = $filter('addFieldToElementsArray')(users, {
                                    type: 'user'
                                });
                                items = items.concat(users);
                            }
                            if (thisStatus.groups) {
                                var groups = $filter('getArrayFromObject')(thisStatus.groups, 0, 1, true);
                                groups = $filter('addFieldToElementsArray')(groups, {
                                    type: 'group'
                                });
                                items = items.concat(groups);
                            }
                            $scope.Z.globalNotification[action][status] = items;
                        }
                    }
                }
            }
        }
        function getProfiles(nameOfProfile) {
            return new Promise(function (resolve, reject) {
                $scope.L.loadList('profiles').then(function (profiles) {
                    var p = $filter('getObjectsLikeTermOfArray')(nameOfProfile, profiles, 'name');
                    for (var i = 0; i < p.length; i++) {
                        p[i].type = 'user';
                    }
                    resolve(p);
                }, function (err) {
                    errAlertS(err);
                    reject(err);
                });
            });
        }
        function getGroups(nameOfProfile) {
            return new Promise(function (resolve, reject) {
                $scope.L.loadList('groups').then(function (groups) {
                    var g = $filter('getObjectsLikeTermOfArray')(nameOfProfile, groups, 'name');
                    for (var i = 0; i < g.length; i++) {
                        g[i].type = 'group';
                    }
                    resolve(g);
                }, function (err) {
                    errAlertS(err);
                    reject(err);
                });

            });
        }
        $scope.setTabName = function (action) {
            $log.debug('setting tabName', action);
            $scope.tabName = action;
            filterNotifications(action);
        };
        $scope.transformChip = function (chip, action, status) {
            var founded = $filter('filter')($scope.Z.globalNotification[action][status], {
                $id: chip.$id,
                type: chip.type
            });
            if (founded.length) {
                return null;
            } else {
                return chip;
            }
        };
        $scope.transformChipNormal = function (chip) {
            return chip.$id;
        }
        $scope.setProfilesAction = function (action, status, user, value, userOrGroup) {
            var usersOrGroups;
            if (userOrGroup === 'user') { usersOrGroups = 'users'; }
            if (userOrGroup === 'group') { usersOrGroups = 'groups'; }
            if (!$scope.globalNotification.hasOwnProperty(action)) { $scope.globalNotification[action] = {}; }
            if (!$scope.globalNotification[action].hasOwnProperty(status)) { $scope.globalNotification[action][status] = {}; }
            if (!$scope.globalNotification[action][status].hasOwnProperty(usersOrGroups) || !$scope.globalNotification[action][status][usersOrGroups]) { $scope.globalNotification[action][status][usersOrGroups] = {}; }
            if (value) {
                $scope.globalNotification[action][status][usersOrGroups][user] = value;
            } else {
                delete $scope.globalNotification[action][status][usersOrGroups][user];
                if (!$filter('objectsLength')($scope.globalNotification[action][status][usersOrGroups])) {
                    $scope.globalNotification[action][status][usersOrGroups] = false;
                }
            }
        };
        $scope.autocompleteProfiles = function (nameOfProfile, only) {
            return new Promise(function (resolve, reject) {
                var items = [];
                var promises = [];
                if (only) {
                    promises.push(only === 'profiles' ? getProfiles(nameOfProfile) : getGroups(nameOfProfile));
                } else {
                    promises = [getGroups(nameOfProfile), getProfiles(nameOfProfile)];
                }
                Promise.all(promises).then(function (resp) {
                    items = resp.reduce(function (current, item) {
                        current = current.concat(item);
                        return current;
                    }, [])
                    // items = items.concat(resp[0]);
                    // items = items.concat(resp[1]);
                    resolve(items);
                }).catch(function (error) {
                    reject(error);
                });
            });
        };
        $scope.listWatchers.globalNotification = $scope.$watch('globalNotification', function (globalNotification) {
            if (globalNotification && globalNotification.hasOwnProperty('$id')) {
                $scope.globalNotification.$loaded().then(function () {
                    $scope.setTabName('enrole');
                });
            }
        });
        startAfterInitFilter($scope, $scope.listWatchers, initiated, init);
    }
})();
(function () {
    'use strict';

    angular
        .module('app.config')
        .controller('EmailImagesController', EmailImagesController);

    function EmailImagesController($scope) {
        $scope.deleteImages = function (item, event) {
            $scope.selected.splice(0, $scope.selected.length);
            $scope.selected.push(item);
            return $scope.delete(event);
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.config')
        .controller('EmailImageController', EmailImageController);

    function EmailImageController($scope, errAlertS, $rootScope, successAlertS, $timeout, clearObjectFilter, DataF, userHasPermissionFilter, AppF) {
        $scope.saveEmailImages = function (emailImage, finished) {
            $rootScope.loadingProgress = true;
            $timeout(function () {
                emailImage.center = AppF.center;
                if (angular.isUndefined(emailImage.$id) || emailImage.$id == null) {
                    emailImage.$id = $scope.F.root.child('catalogs/emailImages/collection').push().key;
                }
                if (angular.isUndefined(emailImage.created)) {
                    emailImage.created = $scope.D.getTimeObject(0, emailImage.created);
                }
                var promises = [];
                if (angular.isDefined($scope.files) && angular.isDefined($scope.files.length) && $scope.files.length > 0) {
                    promises.push($scope.upload($scope.files, emailImage, true));
                }
                Promise.all(promises).then(function () {
                    return $scope.save(emailImage, 1);
                }).then(function () {
                    successAlertS('Se guardo registro con éxito');
                    $scope.R.goToList();
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                }).catch(function (err) {
                    errAlertS(err);
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                });
            }, 0, false);
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('app.config')
        .controller('DashboardConfigController', DashboardConfigController);

    /** @ngInject */
    function DashboardConfigController(
        $scope, 
        Dashboard
    ) {
        var root = $scope.F.root;

        // Data
        $scope.dashboard = Dashboard;

        $scope.widget1 = $scope.dashboard.widget1;
        $scope.widget2 = $scope.dashboard.widget2;
        $scope.widget3 = $scope.dashboard.widget3;
        $scope.widget4 = $scope.dashboard.widget4;
        $scope.widget5 = {
            title: $scope.dashboard.widget5.title,
            mainChart: {
                config: {
                    refreshDataOnly: true,
                    deepWatchData: true
                },
                options: {
                    chart: {
                        type: 'multiBarChart',
                        color: ['#03a9f4', '#b3e5fc'],
                        height: 420,
                        margin: {
                            top: 8,
                            right: 16,
                            bottom: 32,
                            left: 32
                        },
                        clipEdge: true,
                        groupSpacing: 0.3,
                        reduceXTicks: false,
                        stacked: true,
                        duration: 250,
                        x: function(d) {
                            return d.x;
                        },
                        y: function(d) {
                            return d.y;
                        },
                        yAxis: {
                            tickFormat: function(d) {
                                return d;
                            }
                        },
                        legend: {
                            margin: {
                                top: 8,
                                bottom: 32
                            }
                        },
                        controls: {
                            margin: {
                                top: 8,
                                bottom: 32
                            }
                        },
                        tooltip: {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data: []
            },
            days: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
            ranges: $scope.dashboard.widget5.ranges,
            currentRange: '',
            changeRange: function(range) {
                $scope.widget5.currentRange = range;

                /**
                 * Update main chart data by iterating through the
                 * chart dataset and separately adding every single
                 * dataset by hand.
                 *
                 * You MUST NOT swap the entire data object by doing
                 * something similar to this:
                 * $scope.widget.mainChart.data = chartData
                 *
                 * It would be easier but it won't work with the
                 * live updating / animated charts due to how d3
                 * works.
                 *
                 * If you don't need animated / live updating charts,
                 * you can simplify these greatly.
                 */
                angular.forEach($scope.dashboard.widget5.mainChart, function(chartData, index) {
                    $scope.widget5.mainChart.data[index] = {
                        key: chartData.key,
                        values: chartData.values[range]
                    };
                });
            },
            init: function() {
                // Run this function once to initialize widget

                /**
                 * Update the range for the first time
                 */
                $scope.widget5.changeRange('TW');
            }
        };

        // Widget 6
        $scope.widget6 = {
            title: $scope.dashboard.widget6.title,
            mainChart: {
                config: {
                    refreshDataOnly: true,
                    deepWatchData: true
                },
                options: {
                    chart: {
                        type: 'pieChart',
                        color: ['#f44336', '#9c27b0', '#03a9f4', '#e91e63'],
                        height: 400,
                        margin: {
                            top: 0,
                            right: 0,
                            bottom: 0,
                            left: 0
                        },
                        donut: true,
                        clipEdge: true,
                        cornerRadius: 0,
                        labelType: 'percent',
                        padAngle: 0.02,
                        x: function(d) {
                            return d.label;
                        },
                        y: function(d) {
                            return d.value;
                        },
                        tooltip: {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data: []
            },
            footerLeft: $scope.dashboard.widget6.footerLeft,
            footerRight: $scope.dashboard.widget6.footerRight,
            ranges: $scope.dashboard.widget6.ranges,
            currentRange: '',
            changeRange: function(range) {
                $scope.widget6.currentRange = range;

                /**
                 * Update main chart data by iterating through the
                 * chart dataset and separately adding every single
                 * dataset by hand.
                 *
                 * You MUST NOT swap the entire data object by doing
                 * something similar to this:
                 * $scope.widget.mainChart.data = chartData
                 *
                 * It would be easier but it won't work with the
                 * live updating / animated charts due to how d3
                 * works.
                 *
                 * If you don't need animated / live updating charts,
                 * you can simplify these greatly.
                 */
                angular.forEach($scope.dashboard.widget6.mainChart, function(data, index) {
                    $scope.widget6.mainChart.data[index] = {
                        label: data.label,
                        value: data.values[range]
                    };
                });
            },
            init: function() {
                // Run this function once to initialize widget

                /**
                 * Update the range for the first time
                 */
                $scope.widget6.changeRange('TW');
            }
        };

        // Widget 7
        $scope.widget7 = {
            title: $scope.dashboard.widget7.title,
            ranges: $scope.dashboard.widget7.ranges,
            customers: $scope.dashboard.widget7.customers,
            currentRange: 'T'
        };

        // Methods

        //////////

        // Initialize Widget 5
        $scope.widget5.init();

        // Initialize Widget 6
        $scope.widget6.init();
    }
})();
(function () {
    'use strict';

    angular
        .module('app.config')
        .controller('CustomFieldController', CustomFieldController);

    /** @ngInject */
    function CustomFieldController($scope, $log, startAfterInitFilter, errAlertS) {
        var vm = this;
        var initiated = false;
        $scope.listWatchers = {};
        function init() {
            var needed = [
                $scope.dataNeededPromise,
                $scope.statesObjsPromise
            ];
            Promise.all(needed).then(function () {
                if (!angular.isArray($scope.customField.groups)) {
                    $scope.customField.groups = [];
                }
            }).catch(function (error) {
                errAlertS(error);
            });
        }
        vm.transformChip = function (chip) {
            return chip.$id;
        };
        startAfterInitFilter($scope, $scope.listWatchers, initiated, init);
    }

}());
(function () {
    'use strict';

    angular
        .module('app.config')
        .controller('ConstantsController', ConstantsController);

    function ConstantsController(
        $rootScope,
        $scope,
        $state,
        $firebaseArray,
        $sessionStorage,
        $log,
        $q,
        $mdDialog,
        successAlertS,
        errAlertS,
        confirmConfig,
        AppF,
        $filter,
        userHasPermissionFilter,
        startAfterInitFilter
    ) {
        var root = $scope.F.root;
        var initiated = false;
        var watchers = {};
        $scope.configState = 'app.config.constants.config';
        $scope.detailState = 'app.config.constants.update';
        $scope.selected = [];
        $scope.uploadImage = false;
        $scope.tabName;

        // needed
        $scope.clients = [];
        $scope.payrolls = [];
        $scope.ccs = [];
        $scope.employees = [];
        $scope.constants = {
            general: [],
            payroll: {},
            cc: {},
            employee: {}
        };
        $scope.constantsF = [];

        if ($sessionStorage.tab) {
            if ($sessionStorage.tab['constants']) {
                $scope.selectedTab = $sessionStorage.tab['constants'];
                switch ($scope.selectedTab) {
                    case 0: $scope.tabName = 'general'; break;
                    case 1: $scope.tabName = 'payroll'; break;
                    case 2: $scope.tabName = 'cc'; break;
                    case 3: $scope.tabName = 'employee'; break;
                }
                $log.debug({
                    selectedTab: $scope.selectedTab,
                    tabName: $scope.tabName
                }, 'selected tab from $sessionStorage');
            }
        } else {
            $scope.selectedTab = 0;
        }

        var init = function () {
            $scope.L.loadList('calcFields', 'catalogs/calcFields/collection', null, 'array');
            $scope.changeMainRef();
            if (!$scope.F.search || !$scope.F.search.hasOwnProperty('constants')) resetSearch();
            $scope.loadDataNeeded($scope.F.active.menuName);
            $scope.permissions = {
                tabGeneral: userHasPermissionFilter(AppF.groupsOfUser, AppF.permissions, "tabGeneral", "config.constants"),
                tabPayroll: userHasPermissionFilter(AppF.groupsOfUser, AppF.permissions, "tabPayroll", "config.constants"),
                tabCc: userHasPermissionFilter(AppF.groupsOfUser, AppF.permissions, "tabCc", "config.constants"),
                tabEmployee: userHasPermissionFilter(AppF.groupsOfUser, AppF.permissions, "tabEmployee", "config.constants")
            }
            if ($scope.selectedTab == 0) {
                $scope.loadConstants(null, 'generalTab init');
            }
            $scope.currentPage = $scope.F.currentPage('clients', 'constants-' + $scope.tabName);
            initiated = true;
            loadIncidencesTypes();
        }

        var loadIncidencesTypes = function () {
            $scope.allIncidences = $firebaseArray(AppF.root.child("lists/incidencesTypes/all"));
        }

        var remove = function (constant) {
            $scope.changeMainRef();
            $log.debug('removing: ', constant.$id);
            return $scope.F.root.child($scope.mainRef).child(constant.$id).set(null);
            //$scope.constants.$remove(constant);
        }

        var resetSearch = function () {
            $scope.F.search.constants = {
                payroll: false,
                cc: 'all',
                employee: 'all'
            }
        }

        // Methods
        $scope.getValidations = function () {
            if (!$scope.F.search || !$scope.F.search.hasOwnProperty('constants')) {
                resetSearch();
            }
            // validations for table loader
            if (initiated) {
                var validations = {
                    general: [{
                        valid: ($scope.constantsF.length && !$rootScope.loadingProgress),
                        msg: 'Parece que no tiene constantes aún'
                    }],
                    placeOfWork: [{
                        valid: ($scope.F.search.constants.placeOfWork && !$rootScope.loadingProgress),
                        msg: 'Seleccione un Lugar de Trabajo'
                    }, {
                        valid: (!$scope.F.search.constants.placeOfWork || ($scope.F.search.constants.placeOfWork && $scope.constantsF.length && !$rootScope.loadingProgress)),
                        msg: 'Parece que no tiene constantes por lugar de trabajo aún'
                    }],
                    payroll: [{
                        valid: ($scope.F.search.constants.payroll && !$rootScope.loadingProgress),
                        msg: 'Seleccione una Nómina'
                    }, {
                        valid: (!$scope.F.search.constants.payroll || ($scope.F.search.constants.payroll && $scope.constantsF.length && !$rootScope.loadingProgress)),
                        msg: 'Parece que no tiene constantes por nómina aún'
                    }],
                    cc: [{
                        valid: ($scope.F.search.constants.cc && !$rootScope.loadingProgress),
                        msg: 'Seleccione un Cliente, Nómina y CC'
                    }, {
                        valid: (!$scope.F.search.constants.cc || ($scope.F.search.constants.cc && $scope.constantsF.length && !$rootScope.loadingProgress)),
                        msg: 'Parece que no tiene constantes por cc aún'
                    }],
                    employee: [{
                        valid: ($scope.F.search.constants.employee && !$rootScope.loadingProgress),
                        msg: 'Seleccione una Nómina y Empleado'
                    }, {
                        valid: (!$scope.F.search.constants.employee || ($scope.F.search.constants.employee && $scope.constantsF.length && !$rootScope.loadingProgress)),
                        msg: 'Parece que no tiene constantes por empleado aún'
                    }]
                };
                $scope.validations = validations[$scope.tabName];
            } else {
                $scope.validations = [];
            }
            $log.debug($scope.validations, 'validations');
        }

        $scope.changeMainRef = function () {
            $scope.mainRef = '/constants';
            switch ($scope.tabName) {
                case 'general':
                    $scope.mainRef += '/general';
                    break;
                case 'payroll':
                case 'cc':
                case 'employee':
                    if ($scope.F.search.constants) {
                        var proll = $scope.F.search.constants.payroll || '';
                        $scope.mainRef += '/' + $scope.tabName + '/' + proll;
                    }
                    break;
            }
        }

        $scope.setTabName = function (tabName) {
            $scope.tabName = tabName;
            if ($sessionStorage.tab) {
                $sessionStorage.tab['constants'] = $scope.selectedTab;
            } else {
                $sessionStorage.tab = {
                    constants: $scope.selectedTab
                }
            }

            $log.debug($scope.tabName, $scope.selectedTab, 'tab setted in $sessionStorage');
        }

        $scope.goToDetail = function (constant, tab) {
            var proll = $scope.F.search.constants.payroll || '';
            var params = {
                'constantId': (angular.isDefined(constant.$id)) ? constant.$id : constant,
                'payrollId': proll
            };
            params.byId = ($scope.byId) ? $scope.byId : 'new';
            params.by = tab;
            $scope.F.goToState($scope.detailState, params);
        }

        $scope.loadConstants = function (filter, from) {
            var promise = $q.defer();
            $rootScope.loadingProgress = true;
            $scope.changeMainRef();
            $log.debug('Load constants by:', {
                tabName: $scope.tabName,
                mainRef: $scope.mainRef,
                from: from
            });
            var ref = root.child($scope.mainRef);
            switch ($scope.tabName) {
                case 'general':
                    if (!$scope.constants.general.length) {
                        $scope.constants.general = $firebaseArray(ref);
                        $scope.$watch('constants.general', function (constants, old) {
                            if (constants && (constants != old) && old != null) {
                                $scope.constantsF = [].concat(constants);
                            }
                        }, 1);
                        $scope.constants.general.$loaded().then(function (constants) {
                            $scope.constantsF = [].concat(constants);
                            $rootScope.loadingProgress = false;
                            $rootScope.$evalAsync(function () {
                                $log.debug('Loaded general constants from FB', {
                                    filtered: $scope.constantsF,
                                    fbCat: $scope.constants.general
                                });
                            });
                            promise.resolve($scope.constantsF);
                        }).catch(function (err) {
                            errAlertS(err);
                            $rootScope.loadingProgress = false;
                            $rootScope.$evalAsync();
                            promise.reject(err);
                        });
                    } else {
                        $scope.constantsF = [].concat($scope.constants.general);
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync(function () {
                            $log.debug('Loaded general constants from Memory', {
                                filtered: $scope.constantsF,
                                fbCat: $scope.constants.general
                            });
                        });
                    }
                    break;
                case 'payroll':
                    if (!$scope.constants.payroll[$scope.F.search.constants.payroll]) {
                        $scope.constants.payroll[$scope.F.search.constants.payroll] = $firebaseArray(ref);
                        $scope.$watch('constants.payroll', function (constants, old) {
                            if (constants[$scope.F.search.constants.payroll] && (constants[$scope.F.search.constants.payroll] != old[$scope.F.search.constants.payroll]) && old != null) {
                                $scope.constantsF = [].concat(constants[$scope.F.search.constants.payroll]); //angular.copy(constants[$scope.F.search.constants.payroll]);
                            }
                        }, 1);
                        $scope.constants.payroll[$scope.F.search.constants.payroll].$loaded().then(function (constants) {
                            $scope.constantsF = [].concat(constants);//angular.copy(constants);
                            $rootScope.loadingProgress = false;
                            $rootScope.$evalAsync(function () {
                                $log.debug('Loaded payroll constants from fb', {
                                    filtered: $scope.constantsF,
                                    fbCat: $scope.constants.payroll[$scope.F.search.constants.payroll],
                                    payroll: $scope.F.search.constants.payroll
                                });
                            });
                            promise.resolve($scope.constantsF);
                        }).catch(function (err) {
                            errAlertS(err);
                            $rootScope.loadingProgress = false;
                            $rootScope.$evalAsync();
                            promise.reject(err);
                        });
                    } else {
                        $scope.constantsF = [].concat($scope.constants.payroll[$scope.F.search.constants.payroll]);
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync(function () {
                            $log.debug('Loaded payroll constants from Memory', {
                                filtered: $scope.constantsF,
                                fbCat: $scope.constants.payroll[$scope.F.search.constants.payroll],
                                payroll: $scope.F.search.constants.payroll
                            });
                        });
                    }
                    break;
                case 'cc':
                    if (!$scope.constants.cc[$scope.F.search.constants.payroll]) {
                        $scope.constants.cc[$scope.F.search.constants.payroll] = $firebaseArray(ref);
                        $scope.$watch('constants.cc', function (constants, old) {
                            if (constants[$scope.F.search.constants.payroll] && (constants[$scope.F.search.constants.payroll] != old[$scope.F.search.constants.payroll]) && old != null) {
                                $scope.constantsF = [].concat(constants[$scope.F.search.constants.payroll]);
                            }
                        }, 1);
                        $scope.constants.cc[$scope.F.search.constants.payroll].$loaded().then(function (constants) {
                            $scope.constantsF = angular.copy(constants);
                            if ($scope.F.search.constants.cc !== 'all') {
                                $scope.constantsF = $filter('filter')(constants, { cc: $scope.F.search.constants.cc });
                            }

                            $rootScope.loadingProgress = false;
                            $rootScope.$evalAsync(function () {
                                $log.debug('Loaded cc constants from fb', {
                                    filtered: $scope.constantsF,
                                    fbCat: $scope.constants.cc[$scope.F.search.constants.payroll],
                                    cc: $scope.F.search.constants.cc
                                });
                            });
                            promise.resolve($scope.constantsF);
                        }, function (err) {
                            errAlertS(err);
                            $rootScope.loadingProgress = false;
                            $rootScope.$evalAsync();
                            promise.reject(err);
                        });
                    } else {
                        $scope.constantsF = [].concat($scope.constants.cc[$scope.F.search.constants.payroll]);
                        if ($scope.F.search.constants.cc !== 'all') {
                            $scope.constantsF = $filter('filter')($scope.constants.cc[$scope.F.search.constants.payroll], { cc: $scope.F.search.constants.cc });
                        }
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync(function () {
                            $log.debug('Loaded cc constants from Memory', {
                                filtered: $scope.constantsF,
                                fbCat: $scope.constants.cc[$scope.F.search.constants.payroll],
                                cc: $scope.F.search.constants.cc
                            });
                        });
                    }
                    break;
                case 'employee':
                    if (!$scope.constants.employee[$scope.F.search.constants.payroll]) {
                        $scope.constants.employee[$scope.F.search.constants.payroll] = $firebaseArray(ref);
                        $scope.$watch('constants.employee', function (constants, old) {
                            if (constants[$scope.F.search.constants.payroll] && (constants[$scope.F.search.constants.payroll] != old[$scope.F.search.constants.payroll]) && old != null) {
                                $scope.constantsF = [].concat(constants[$scope.F.search.constants.payroll]);
                                if ($scope.F.search.constants.employee !== 'all') {
                                    $scope.constantsF = $filter('filter')(constants, { employee: $scope.F.search.constants.employee });
                                }
                            }
                        }, 1);
                        $scope.constants.employee[$scope.F.search.constants.payroll].$loaded().then(function (constants) {
                            $scope.constantsF = [].concat(constants);
                            if ($scope.F.search.constants.employee !== 'all') {
                                $scope.constantsF = $filter('filter')(constants, { employee: $scope.F.search.constants.employee });
                            }

                            $rootScope.loadingProgress = false;
                            $rootScope.$evalAsync(function () {
                                $log.debug('Loaded employee constants from Memory', {
                                    filtered: $scope.constantsF,
                                    fbCat: $scope.constants.employee[$scope.F.search.constants.payroll],
                                    employee: $scope.F.search.constants.employee
                                });
                            });
                            promise.resolve($scope.constantsF);
                        }).catch(function (err) {
                            errAlertS(err);
                            $rootScope.loadingProgress = false;
                            $rootScope.$evalAsync();
                            promise.reject(err);
                        });
                    } else {
                        $scope.constantsF = [].concat($scope.constants.employee[$scope.F.search.constants.payroll]);
                        if ($scope.F.search.constants.employee !== 'all') {
                            $scope.constantsF = $filter('filter')($scope.constants.employee[$scope.F.search.constants.payroll], { employee: $scope.F.search.constants.employee });
                        }
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync(function () {
                            $log.debug('Loaded employee constants from Memory', {
                                filtered: $scope.constantsF,
                                fbCat: $scope.constants.employee[$scope.F.search.constants.payroll],
                                employee: $scope.F.search.constants.employee
                            });
                        });
                    }
                    break;
            }
            return promise.promise;
        }

        var loadCcs = function (payrollId) {
            $log.debug('Load ccs of payroll: ' + payrollId);
            $scope.ccs = $firebaseArray(root.child('lists/ccs/payroll').child(payrollId));
            $scope.ccs.$loaded(function (ccs) {
                $scope.ccs = ccs;
            });
        }

        var loadEmployees = function (payrollId) {
            $log.debug('Load employees of payroll: ' + payrollId);
            $scope.employees = $firebaseArray(root.child('lists/employees/payroll').child(payrollId));
            $scope.employees.$loaded(function (employees) {
                $scope.employees = $filter("filter")(employees, {
                    status: "!5"
                });
            });
        }

        $scope.delete = function (e) {
            var msg = (!$scope.F.safeDelete.constant) ?
                'No podrá recuperar sus datos' :
                'Podrá recuperar sus datos en la papelera';
            var title = 'Quiere borrar ' + $scope.selected.length + ' Constantes?';

            $mdDialog.show($mdDialog.confirm(confirmConfig)
                .title(title)
                .content(msg)
                .ariaLabel('Deleting')
                .targetEvent(e)
                .ok('Borrar')
                .cancel('Cancelar'))
                .then(function () {
                    var count = 0;
                    $log.debug('Deleting: ', $scope.selected);
                    angular.forEach($scope.selected, function (constant) {
                        if ($scope.F.safeDelete.constant) {

                        } else {
                            remove(constant).then(function () {
                                count++
                                if (count == $scope.selected.length) {
                                    successAlertS('Se borraron ' + count + ' Constantes');
                                    $scope.selected = [];
                                }
                            }, errAlertS);
                        }
                    });
                }, function () {
                    $log.debug('Deleting Cancelled');
                });
        }

        watchers.tabName = $scope.$watch('tabName', function (tab) {
            if (tab) {
                $scope.changeMainRef();
                $scope.constantsF = [];
                switch (tab) {
                    case 'general':
                        $scope.loadConstants(null, 'tabName general');
                        break;
                    case 'placeOfWork':
                        if (angular.isDefined($scope.F.search.constants)) {
                            if ($scope.F.search.constants.placeOfWork) {
                                $scope.loadConstants(null, 'tabName placeOfWork');
                            }
                        }
                        break;
                    case 'payroll':
                        if (angular.isDefined($scope.F.search.constants)) {
                            if ($scope.F.search.constants.payroll && $scope.F.search.constants.payroll != '') {
                                $scope.loadConstants(null, 'tabName payroll');
                            }
                        }
                        break;
                    case 'cc':
                        if (angular.isDefined($scope.F.search.constants)) {
                            if ($scope.F.search.constants.payroll) {
                                $scope.loadConstants(null, 'tabName cc');
                            }
                        }
                        break;
                    case 'employee':
                        if (angular.isDefined($scope.F.search.constants)) {
                            if ($scope.F.search.constants.payroll) {
                                $scope.loadConstants(null, 'tabName employee');
                            }
                        }
                        break;
                }
            }
        });

        watchers.constants = $scope.$watch('F.search.constants', function () {
            $scope.getValidations();
        });

        watchers.payroll = $scope.$watch('F.search.constants.payroll', function (payroll) {
            if (payroll && initiated && payroll != '') {
                $log.debug('loading ccs, incidencesTypes && employees for payroll', payroll);
                loadCcs(payroll);
                loadIncidencesTypes();
                loadEmployees(payroll);
                if ($scope.tabName == 'payroll') {
                    if ($scope.F.search.constants[$scope.tabName]) $scope.loadConstants(null, 'search payroll tab payroll');
                } else {
                    if ($scope.F.search.constants[$scope.tabName] == 'all') $scope.loadConstants(null, 'search payroll other tab');
                }
            }
        });

        watchers.cc = $scope.$watch('F.search.constants.cc', function (cc) {
            if (cc && initiated && $scope.tabName == 'cc') {
                if (cc == 'all') {
                    $scope.loadConstants(null, 'search cc all');
                } else {
                    $scope.loadConstants({ cc: cc }, 'search cc');
                }
            }
        });

        watchers.employee = $scope.$watch('F.search.constants.employee', function (employee) {
            if (employee && initiated && $scope.tabName == 'employee') {
                if (employee == 'all') {
                    $scope.loadConstants(null, 'search employee all');
                } else {
                    $scope.loadConstants({ employee: employee }, 'search employee');
                }
            }
        });
        watchers.currentPage = $scope.$watch('currentPage', function (cp) {
            if (cp) {
                $scope.F.setCurrentPage(cp, 'config', 'constants-' + $scope.tabName);
                $log.debug('setting currentPage', cp, $scope.currentPage);
            }
        });
        startAfterInitFilter($scope, watchers, initiated, init);
    }
})();
(function(){
    'use strict';

    angular
        .module('app.config')
        .filter('getIncidencesPropertiesMap', getIncidencesPropertiesMap)

    function getIncidencesPropertiesMap(){

        return getIncidencesPropertiesMapFn;

        function getIncidencesPropertiesMapFn(){
            var map = {
                // system
                workedDays: [], 
                daysOfPeriod: [],
                mensualization: [], 
                gravableBase: [], 
                socialPrevision: [],
                asimilated: [],
                isr: [], // de complemento
                administrativeServices: [],
                // sat complex
                '001': [], // sd, sdr (sueldos, salarios y jornales)
                '017': [], // subsidio para el empleo
                '027': [], // imss patron
                '002': [], // aguinaldo
                '003': [], // PTU
                '011': [], // prima de seguro de vida @todo preguntar como se hace esta
                '014': [], // subsidios por incapacidad
                '021': [], // prima vacacional
                '039': [], // jubilaciones, pensiones o haberes de retiro
                '040': [], // ingreso por entidades federativas?? @todo preguntar al conta
                '041': [], // ingreso por entidades federativas?? @todo preguntar al conta
                '042': [], // ingreso pagado? por entidades federativas?? @todo preguntar al conta
                '019': [], // horas extra
                '020': [], // prima dominical,
                '022': [], // prima por antigueda
                '005': ["imssFee","sbc","workedDays","gravableBase","netImss","employeeImss","patronalImss"], // fondo de ahorro @todo:carlos checar bien las propiedades ya que una parte es del patron y otra del empleado
                '043': [], // imss trabajador [001]
                '044': [], // isr [002]
                '052': [], // pagos por crédito de vivienda [010]
                '053': [], // pagos y abonos infonacot [011]
                '048': [], // descuento por incapacidad [006]
                '054': [], // anticipo de salarios [012] @todo hacer el módulo de prestamos con descuentos automáticos o usar constantes
                '062': [],  // ausentismo (faltas)
                // sat simple
                '004': [], // rembolso de gastos medicos dentales y hospitalarios
                '006': [], // caja de ahorro
                '009': [], // contribuciones a cargo del trabajador pagadas por el patrón
                '012': [], // seguro de gastos medicos mayores
                '013': [], // cuotas sindicales pagadas por el patrón
                '015': [], // becas para trabajadores y/o hijos 
                '016': [], // otros
                '023': [], // pagos por separación
                '024': [], // seguro de retiro
                '025': [], // indemnizaciones
                '026': [], // rembolso por funeral
                '028': [], // comisiones
                '029': [], // vales de despensa
                '030': [], // vales de restaurante
                '031': [], // vales de gasolina
                '032': [], // vales de ropa
                '033': [], // ayuda para renta
                '034': [], // ayuda para articulos escolares
                '035': [], // ayuda para anteojos
                '036': [], // ayuda para transporte
                '037': [], // ayuda para gastos de funeral
                '038': [],  // otros ingresos por salarios
                '045': [], // aportaciones al retiro, cesantia, vejez [003]
                '046': [], // otros [004]
                '047': [], // aportaciones a fondo de vivienda @todo checar con el conta [005]
                '049': [], // pensión alimenticia @todo checar con el conta [007]
                '050': [], // renta @todo checar con el conta [008],
                '051': [], // prestamos provinientes del fondo nacional de la vivienda [009] @todo preguntar al conta
                '056': [], // errores [014]
                '055': [], // pagos hechos con exceso al trabajador [013]
                '057': [], // perdidas [015]
                '058': [], // averias [016]
                '059': [], // adquisicion de articulos producidos por la empresa [017]
                '060': [], // cuotas para la constitución de sociedades cooperativas [018] @todo preguntar al conta
                '061': [], // cuotas sindicales [019] @todo preguntar al conta
                '063': []  // cuotas obrero-patronales [021] @todo preguntar al conta
            };
            return map;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.config')
        .directive('affectIncidenceValueForm', affectIncidenceValueForm)
        .directive('affectIncidenceTotalForm', affectIncidenceTotalForm)
        .directive('affectIncidencePropertyForm', affectIncidencePropertyForm)
        .directive('notApplyForm', notApplyForm)
        .directive('automaticApplyForm', automaticApplyForm);


    /** @ngInject */
    function affectIncidenceValueForm() {
        return {
            replace: true,
            templateUrl: 'app/main/config/views/constant/forms/affect-incidence-value.html'
        }
    }
    /** @ngInject */
    function affectIncidenceTotalForm() {
        return {
            replace: true,
            templateUrl: 'app/main/config/views/constant/forms/affect-incidence-total.html'
        }
    }

    /** @ngInject */
    function affectIncidencePropertyForm() {
        return {
            replace: true,
            templateUrl: 'app/main/config/views/constant/forms/affect-incidence-property.html'
        }
    }

    /** @ngInject */
    function automaticApplyForm() {
        return {
            replace: true,
            templateUrl: 'app/main/config/views/constant/forms/automatic-apply.html'
        }
    }

    /** @ngInject */
    function notApplyForm() {
        return {
            replace: true,
            templateUrl: 'app/main/config/views/constant/forms/not-apply.html'
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.config')
        .controller('ConstantController', ConstantController);

    function ConstantController(
        $scope,
        $rootScope,
        $document,
        $state,
        $firebaseObject,
        $firebaseArray,
        $log,
        successAlertS,
        errAlertS,
        $filter,
        clearObjectFilter,
        getSomethingOfArrayFBFilter,
        startAfterInitFilter
    ) {
        // si necesitas cargar catalogos de mongo pon sus nombres aqui
        var dataNeeded = ['placesOfWorkRecords']; // ex: ['countries', 'states', 'regimes']
        var initiated = false;
        var blancConstant = {};
        var watchers = {};
        $scope.minDate = moment().format("YYYY/MM/DD");
        $scope.backState = 'app.config.constants';
        $scope.uniqueFilter = false;
        $scope.fieldValue = 'value';
        $scope.by = $state.params.by;

        var init = function () {
            $scope.L.loadList('calcFields', 'catalogs/calcFields/collection', null, 'array');
            // si no viene el parametro detalle, o del objeto se regresa a atras
            if ((!$state.params.constantId && !$state.params.constant) || (!$state.params.payrollId && $state.params.by != "general")) {
                if (!$scope.F.addMode) $scope.R.goToList();
            }

            $scope.payrollId = $state.params.payrollId;
            if (!$scope.F.search) $scope.F.search = {};
            if (!$scope.F.search.constants) $scope.F.search.constants = {};
            $scope.F.search.constants.payroll = $scope.payrollId; // se setea de nuevo por si recarga
            $scope.constantId = $state.params.constantId;
            $scope.byId = $state.params.byId;

            // si no es un objeto nuevo se deben registrar los items del menu
            if ($state.params.constant == 'new' || $state.params.constantId == 'new') {
                $scope.F.addMode = true;
                $log.debug('F.addMode', $scope.F.addMode);
            }
            $scope.by = $state.params.by;
            // se cargan las constantes del estado o directo
            if (!$state.params.constant && $state.params.constantId && !$scope.F.addMode) {
                var fbRe = $scope.F.root.child('constants').child($state.params.by);
                var fbRf;
                switch ($state.params.by) {
                    case 'general':
                        fbRf = fbRe.child($scope.constantId);
                        break;
                    case 'payroll':
                    case 'cc':
                    case 'employee':
                        fbRf = fbRe.child($scope.payrollId).child($scope.constantId);
                        break;
                }
                $scope.constant = $firebaseObject(fbRf);
                $scope.constant.$loaded(function (constant) {
                    $scope.constant = constant;
                    $log.debug('Loaded constant from FB');
                });
            } else {
                // $scope.constants = ($state.params.constants) ? $state.params.constants : [];
                // si se manda objeto de constant vacio, se entiende que se quiere crear uno
                $scope.constant = ($scope.F.addMode) ? blancConstant : $state.params.constant;
                // dataFrom = ($scope.constants) ? 'array' : 'object';
                $log.debug('Loaded constant from previus state');
            }

            $scope.mainRef = '/constants/' + $state.params.by;
            $scope.changeMainRef();
            // dependiendo de que scope de constantes se cargan los catalogos necesarios
            switch ($scope.by) {
                case 'general':
                    $scope.loadIncidencesTypes();
                    break;
                case 'payroll':
                    if ($state.params.payrolls) {
                        $scope.payrolls = $state.params.payrolls;
                    }
                    $scope.loadIncidencesTypes();
                    break;
                case 'cc':
                    if ($state.params.payrolls) {
                        $scope.payrolls = $state.params.payrolls;
                    }
                    if ($state.params.ccs) {
                        $scope.ccs = $state.params.ccs;
                    } else if ($state.params.payrolls) {
                        $scope.loadCcs();
                    }
                    $scope.loadIncidencesTypes();
                    break;
                case 'employee':
                    if ($state.params.payrolls) {
                        $scope.payrolls = $state.params.payrolls;
                    }
                    if ($state.params.employees) {
                        $scope.employees = $state.params.employees;
                    } else if ($state.params.payrolls) {
                        $scope.loadEmployees();
                    }
                    if ($state.params.payrollId) {
                        $scope.F.search.$payroll = $state.params.payrollId;
                    }
                    $scope.loadIncidencesTypes();
                    break;
            }

            // if data from mongo is needed, load it first
            $scope.M.loadNeeded(dataNeeded);
            $scope.loadPropertiesIncidencesMap();
            initiated = true;
        }

        $scope.loadPropertiesIncidencesMap = function () {
            if (!$scope.F.incidencesPropertiesMap) $scope.F.incidencesPropertiesMap = $filter('getIncidencesPropertiesMap')();
        }

        $scope.changeMainRef = function () {
            if ($scope.F.search.constants.payroll) {
                $scope.mainRef = '/constants/' + $state.params.by;
                if ($state.params.by !== 'general') {
                    $scope.mainRef += '/' + $scope.F.search.constants.payroll;
                }
            }
        }

        $scope.loadCcs = function (payrollId) {
            $log.debug('Load ccs of payroll: ' + payrollId);
            $scope.ccs = $firebaseArray($scope.F.root.child('lists/ccs/payroll').child(payrollId));
            $scope.ccs.$loaded(function (ccs) {
                $scope.ccs = ccs;
            });
        }

        $scope.loadEmployees = function (payrollId) {
            $log.debug('Load employees of payroll: ' + payrollId);
            $scope.employees = $firebaseArray($scope.F.root.child('lists/employees/payroll').child(payrollId));
            $scope.employees.$loaded(function (employees) {
                $scope.employees = employees;
            });
        }

        $scope.loadIncidencesTypes = function () {
            console.log("loadIncidencesTypes called");
            // @todo: carliños esta funcion hay que hacerla de nuevo mas pequeña, checa como la hice en el listado, nomas debes de mandar llamar los listados no los catalogos
            $scope.globalIncidences = $firebaseArray($scope.F.root.child("catalogs/incidencesTypes/collection").orderByChild("payroll").equalTo("global"));
            switch ($scope.by) {
                case 'general':
                    $scope.allIncidences = $scope.globalIncidences;
                    break;
                case 'placeOfWork':
                    $scope.allIncidences = $scope.globalIncidences;
                    break;
                case 'payroll':
                case 'cc':
                case 'employee':
                    if (typeof ($scope.F.search) != "undefined" && typeof ($scope.F.search.constants) != "undefined" && typeof ($scope.F.search.constants.payroll) != "undefined") {

                        $scope.globalIncidences.$loaded().then(function (globalIncidences) {
                            $scope.L.loadList("incidencesTypes", "catalogs/incidencesTypes/collection", undefined, "array", "incidencestype-" + $scope.F.search.constants.payroll, [
                                { q: 'orderByChild', v: 'payroll' },
                                { q: 'equalTo', v: $scope.F.search.constants.payroll }
                            ]).then(function (payrollIncidences) {
                                $scope.allIncidences = globalIncidences.concat(payrollIncidences);
                            }).catch(errAlertS);
                        });
                    } else {
                        console.log("Calling only globals");
                        $scope.allIncidences = $scope.globalIncidences;
                    }
                    break;
                default:
                    $scope.allIncidences = [];
                    break;
            }
        }

        $scope.add = function (constant) {
            $rootScope.loadingProgress = true;
            $scope.changeMainRef();
            var constantToSave = clearObjectFilter(constant);
            constantToSave.created = $scope.D.getTimeObject();
            $log.debug('adding constant', constantToSave);
            $scope.F.root.child($scope.mainRef).push(constantToSave).then(function (ref) {
                var id = ref.key;
                $log.debug(id, $scope.constant, 'saved on FB');
                successAlertS('Se creó Constante con éxito');
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync(function () {
                    $log.debug('add constant finished');
                });
                $scope.R.goToList();
            }).catch(function (err) {
                errAlertS(err);
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
            });
        }

        $scope.save = function (constant, promise) {
            $rootScope.loadingProgress = true;
            $scope.changeMainRef();
            var constantToSave = clearObjectFilter(constant);
            $log.debug('saving constant', constantToSave);
            constantToSave.updated = $scope.D.getTimeObject();
            if (promise) return $scope.F.root.child($scope.mainRef).child(constant.$id).set(constantToSave);
            $scope.F.root.child($scope.mainRef).child(constant.$id).set(constantToSave).then(function () {
                successAlertS('Se guardó Constante con éxito');
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync(function () {
                    $log.debug('save constant finished');
                });
                $scope.R.goToList();
            }).catch(function (err) {
                errAlertS(err);
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
            });
        }



        watchers.paryoll = $scope.$watch('F.search.constants.payroll', function (payroll) {
            if (payroll && initiated) {
                var payrollIsActive = getSomethingOfArrayFBFilter(payroll, $scope.L.allPayrolls, 'active');
                $log.debug('payrollIsActive', {
                    payrollIsActive: payrollIsActive,
                    payroll: payroll,
                    list: $scope.L.allPayrolls
                });
                if (payrollIsActive) {
                    $scope.loadCcs(payroll);
                    $scope.loadEmployees(payroll);
                    $scope.loadIncidencesTypes();
                } else {
                    if ($scope.F.addMode) {
                        errAlertS('La nómina pre-seleccionada no está activa');
                        $scope.F.search.constants.payroll = null;
                    }
                }
            }
        });

        if ($scope.by == 'cc') {
            watchers.cc = $scope.$watch('constant.cc', function (cc) {
                if (cc && initiated) {
                    $scope.uniqueFilter = {
                        cc: cc
                    };
                }
            });
        }

        if ($scope.by == 'employee') {
            watchers.employee = $scope.$watch('constant.employee', function (employee) {
                if (employee && initiated) {
                    $scope.uniqueFilter = {
                        employee: employee
                    };
                }
            });
        }
        var cursorPositons = {};

        $scope.getCursorPos = function ($event, element) {
            $scope.fieldValue = element;
            var myEl = $event.target;
            var position = doGetCaretPosition(myEl);
            cursorPositons[element] = position;
            console.log(cursorPositons);
        };

        function doGetCaretPosition(oField) {
            var iCaretPos = 0;
            if (document.selection) {
                oField.focus();
                var oSel = document.selection.createRange();
                oSel.moveStart('character', -oField.value.length);
                iCaretPos = oSel.text.length;
            } else if (oField.selectionStart || oField.selectionStart == '0') {
                iCaretPos = oField.selectionStart;
            }
            return iCaretPos;
        };

        $scope.setCalFieldValue = function (calcField, valueName) {
            console.log(calcField, valueName);
            var oldText = $scope.constant.affect[valueName] || "";
            var insertText = "[" + calcField.name + "]";
            var position = cursorPositons[valueName] || 0;
            console.log("oldText", oldText);
            console.log("insertText", insertText);
            console.log("position", position);
            var output = [oldText.slice(0, position), insertText, oldText.slice(position)].join('');
            $scope.constant.affect[valueName] = output;
        }
        startAfterInitFilter($scope, watchers, initiated, init);
    }
})();
(function () {
    'use strict';

    angular
        .module('app.config')
        .controller('calcFieldController', calcFieldController);

    function calcFieldController(
        $scope
    ) {
        $scope.createRouteAutomatic = function(value){
            if(angular.isDefined(value.object) && value.object !== "" && angular.isDefined(value.field) && value.field !== ""){
                $scope.calcField.route = value.object + "." + value.field;
            }else{
                $scope.calcField.route = value.object || value.field;
            }
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.config')
        .controller('ArchivedTicketController', ArchivedTicketController);

    function ArchivedTicketController(
        $scope, errAlertS, startAfterInitFilter, $log, $rootScope,
        successAlertS, $timeout, clearObjectFilter, DataF
    ) {
        $scope.dash = {
            total: 0,
            closed: 0,
            progress: 0,
            open: 0,

            closedToday: 0,
            closed7d: 0,
            todayLabel: '',

            avgCloseHours: 0,
            medianCloseHours: 0,
            sumCloseHours: 0,

            pct: { closed: 0, progress: 0, open: 0 },

            byCloserTop: [],
            byCloserMax: 0,

            byModuleTop: [],
            byModuleMax: 0
        };

        function safeNum(n) { return (typeof n === 'number' && isFinite(n)) ? n : 0; }

        function formatTodayLabel(d) {
            // sin moment, para no depender
            var dd = String(d.getDate()).padStart(2, '0');
            var mm = String(d.getMonth() + 1).padStart(2, '0');
            var yy = d.getFullYear();
            return dd + '/' + mm + '/' + yy;
        }

        function computeMedian(arr) {
            if (!arr || !arr.length) return 0;
            var a = arr.slice().sort(function (x, y) { return x - y; });
            var mid = Math.floor(a.length / 2);
            return (a.length % 2) ? a[mid] : (a[mid - 1] + a[mid]) / 2;
        }

        function buildTop(mapObj, keyName) {
            var arr = Object.keys(mapObj).map(function (k) {
                var o = {};
                o[keyName] = k;
                o.count = mapObj[k];
                return o;
            }).sort(function (a, b) {
                return b.count - a.count;
            });

            var max = arr.length ? arr[0].count : 0;

            var top = arr.slice(0, 5).map(function (x) {
                x.pct = max ? (x.count / max) * 100 : 0;
                return x;
            });

            return { top: top, max: max };
        }

        function computeDash(list) {
            list = angular.isArray(list) ? list : [];

            var now = new Date();
            var startToday = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
            var endToday = startToday + (24 * 60 * 60 * 1000) - 1;
            var start7d = startToday - (6 * 24 * 60 * 60 * 1000);

            var total = list.length;

            var closed = 0, progress = 0, open = 0;
            var closedToday = 0, closed7d = 0;

            var sumCloseHours = 0;
            var closeCountForAvg = 0;
            var closeHoursArr = [];

            var byCloser = {}; // closeDetail.by -> count
            var byModule = {}; // module -> count

            for (var i = 0; i < list.length; i++) {
                var t = list[i] || {};
                var st = t.status;

                $log.log('status', st)

                if (st === 3) closed++;
                else if (st === 2) progress++;
                else if (st === 1) open++;

                // Solo cerrados (status=3)
                if (st === 3) {
                    // cierre por fecha
                    if (t.closeDetail && t.closeDetail.atTime) {
                        var ct = safeNum(t.closeDetail.atTime);

                        if (ct >= startToday && ct <= endToday) closedToday++;
                        if (ct >= start7d && ct <= endToday) closed7d++;
                    }

                    // top módulos
                    var mod = (t.module || 'sin_modulo');
                    byModule[mod] = (byModule[mod] || 0) + 1;

                    // top quien cerró
                    if (t.closeDetail && t.closeDetail.by) {
                        var uid = t.closeDetail.by;
                        byCloser[uid] = (byCloser[uid] || 0) + 1;
                    }

                    // tiempo cierre (created.atTime -> closeDetail.atTime)
                    if (t.created && t.created.atTime && t.closeDetail && t.closeDetail.atTime) {
                        var a = safeNum(t.created.atTime);
                        var b = safeNum(t.closeDetail.atTime);
                        if (a > 0 && b > 0 && b >= a) {
                            var h = (b - a) / 36e5;
                            sumCloseHours += h;
                            closeHoursArr.push(h);
                            closeCountForAvg++;
                        }
                    }
                }
            }

            var pctClosed = total ? (closed / total) * 100 : 0;
            var pctProgress = total ? (progress / total) * 100 : 0;
            var pctOpen = total ? (open / total) * 100 : 0;

            var avgCloseHours = closeCountForAvg ? (sumCloseHours / closeCountForAvg) : 0;
            var medianCloseHours = computeMedian(closeHoursArr);

            var topCloser = buildTop(byCloser, 'userId');
            var topModule = buildTop(byModule, 'module');

            // asignación final
            $scope.dash.total = total;
            $scope.dash.closed = closed;
            $scope.dash.progress = progress;
            $scope.dash.open = open;

            $scope.dash.closedToday = closedToday;
            $scope.dash.closed7d = closed7d;
            $scope.dash.todayLabel = formatTodayLabel(now);

            $scope.dash.sumCloseHours = sumCloseHours;
            $scope.dash.avgCloseHours = avgCloseHours;
            $scope.dash.medianCloseHours = medianCloseHours;

            $scope.dash.pct.closed = pctClosed;
            $scope.dash.pct.progress = pctProgress;
            $scope.dash.pct.open = pctOpen;

            $scope.dash.byCloserTop = topCloser.top;
            $scope.dash.byCloserMax = topCloser.max;

            $scope.dash.byModuleTop = topModule.top;
            $scope.dash.byModuleMax = topModule.max;
        }

        // -----------------------------
        // Watchers (compatibles con tu helper)
        // -----------------------------
        var watchers = {};

        // IMPORTANTE: no sobrescribas watchers con la función unwatch
        watchers.archivedTickets = $scope.$watchCollection('archivedTickets', function (newVal) {
            computeDash(newVal);
        });

        // Algunos helpers usan referencia (no boolean)
        var initiated = { value: false };

        function init() {
            // si ya hay data al entrar
            computeDash($scope.archivedTickets);
        }

        // Llama init una vez
        init();

        // respeta tu flujo
        startAfterInitFilter($scope, watchers, initiated, init);
    }
})();
/* eslint-disable angular/document-service */
(function () {
    'use strict';

    angular
        .module('app.core')
        .controller('ConceptsController', ConceptsController);

    /** @ngInject */
    function ConceptsController($scope, AppF, ListsF, DataF, $log, $mdDialog, errAlertS, successAlertS) {
        $scope.crute = 'catalogs/concepts/collection';
        $scope.checkTypeConcept = function (selected) {
            var find = selected.find(function (value) {
                return ['accumulator', 'calc'].indexOf(value.type) > -1;
            });
            return (angular.isDefined(find)) ? false : true;
        }
        $scope.showPayrollModal = function (ev, selected) {
            $mdDialog.show({
                templateUrl: 'app/main/config/views/concepts/dialogs/copy-concepts.html',
                parent: angular.element(document.body),
                locals: {
                    selected: selected
                },
                controller: function (scope, $mdDialog, $timeout, selected) {
                    scope.payrollId = [];
                    var payrollId = [];
                    scope.payrolls = [{ $id: "global", name: "GLOBAL" }];
                    var dataToCopy = selected;
                    var payrolls = angular.fromJson(angular.toJson(ListsF.payrolls));
                    var allPayrolls = angular.fromJson(angular.toJson(ListsF.allPayrolls));
                    var tempPayrollId = "";
                    scope.payrolls = scope.payrolls.concat((AppF.permissionToAccessAllPayrolls) ? allPayrolls : payrolls);
                    scope.destinationPayroll = [];
                    for (var i = 0; i < selected.length; i++) {
                        if (payrollId.indexOf(selected[i].payroll) === -1) {
                            payrollId.push(selected[i].payroll);
                        }
                    }
                    scope.payrollId = payrollId;
                    scope.addFields = function (id) {
                        scope.destinationPayroll.push({ payrollId: id });
                        scope.listPayroll = "";
                    }
                    scope.removeFields = function (index, payrollId) {
                        scope.destinationPayroll.splice(index, 1);
                        var newIndex = findIndex(scope.payrolls, payrollId);
                        scope.payrolls[newIndex].disabled = false;
                    }
                    scope.disabledId = function (ids) {
                        tempPayrollId = ids;
                        var index = findIndex(scope.payrolls, ids);
                        $timeout(function () {
                            scope.payrolls[index].disabled = true;
                        }, 0, false)
                    }
                    function findIndex(data, id) {
                        var index = data.findIndex(function (value) {
                            return value.$id === id;
                        });
                        return index
                    }
                    scope.copyConcepts = function (payrollsId, relation) {
                        var destinations = angular.fromJson(angular.toJson(payrollsId));
                        if (destinations.length > 0 && scope.listPayroll.length > 0) {
                            destinations.push({ payrollId: tempPayrollId });
                        }
                        if (destinations.length < 1) {
                            destinations = [{ payrollId: tempPayrollId }];
                        }
                        var queries = [];
                        for (var c = 0; c < dataToCopy.length; c++) {
                            queries.push(doItCopy(dataToCopy[c], destinations, scope.payrolls, relation));
                        }
                        Promise.all(queries).then(function (resp) {
                            var total = 0;
                            var error = [];
                            for (var r = 0; r < resp.length; r++) {
                                var data = resp[r];
                                for (var k in data) {
                                    if (data.hasOwnProperty(k)) {
                                        if (angular.isDefined(data[k].msg)) {
                                            error.push(data[k].msg);
                                        } else {
                                            total = total + data[k].total;
                                        }
                                    }
                                }
                            }
                            if (total > 0) {
                                successAlertS("Se copiaron " + total + ' concepts');
                            }
                            for (var e = 0; e < error.length; e++) {
                                errAlertS(error[e]);
                            }
                            scope.hide();
                        }).catch(function (error) {
                            errAlertS(error);
                        });
                    }
                    function doItCopy(dataToCopy, destinations, payrolls, relation) {
                        return new Promise(function (resolve, reject) {
                            var queries = [];
                            for (var d = 0; d < destinations.length; d++) {
                                queries.push(getConcepts(dataToCopy, destinations[d], payrolls));
                            }
                            Promise.all(queries).then(function (response) {
                                var updates = {};
                                var error = {};
                                var success = {};
                                var count = 0;
                                for (var r = 0; r < response.length; r++) {
                                    var obj = angular.fromJson(angular.toJson(dataToCopy));
                                    if (response[r].copy === true) {
                                        var keyFB = AppF.root.child('catalogs/concepts/collection').push().key;
                                        if (angular.isDefined(relation) && relation === "relation") {
                                            obj.from = obj.$id;
                                        }
                                        obj.payroll = response[r].payrollId;
                                        obj.created = DataF.getTimeObject();
                                        delete obj.$id;
                                        if (angular.isDefined(obj.updated)) {
                                            delete obj.updated
                                        }
                                        if (angular.isDefined(obj.$priority)) {
                                            delete obj.$priority
                                        }
                                        updates[keyFB] = obj;
                                        count++;
                                    } else {
                                        error[response[r].payrollId] = response[r];
                                    }
                                }
                                success['success'] = { total: count }
                                var resp = Object.assign(success, error);
                                AppF.root.child('catalogs/concepts/collection').update(updates).then(function () {
                                    resolve(resp);
                                }).catch(function (error) {
                                    $log.debug(error);
                                    throw "No se pudo agregar los datos, error de comunicación";
                                });
                            }).catch(function (error) {
                                reject(error);
                            })
                        })
                    }
                    function getConcepts(dataToCopy, destination, payrolls) {
                        return new Promise(function (resolve, reject) {
                            var listC = {};
                            var data = dataToCopy;
                            var concepts = [];
                            AppF.root.child('catalogs/concepts/collection').orderByChild('key').equalTo(data.key).once('value').then(function (snap) {
                                var payroll = payrolls.find(function (value) {
                                    return value.$id === destination.payrollId;
                                });
                                if (snap.exists()) {
                                    var concept = snap.val();
                                    for (var key in concept) {
                                        concept[key].$id = key;
                                        concepts.push(concept[key]);
                                    }
                                }
                                var f = concepts.find(function (value) {
                                    return value.payroll === destination.payrollId;
                                });
                                if (angular.isDefined(f)) {
                                    listC = {
                                        payrollId: destination.payrollId,
                                        name: payroll.name,
                                        concept: data.name,
                                        copy: false,
                                        msg: "El concepto " + data.name + " no se puede copiar porque ya existe esa llave en " + payroll.name
                                    };
                                } else {
                                    listC = {
                                        payrollId: destination.payrollId,
                                        name: payroll.name,
                                        copy: true,
                                        msg: "El concepto " + data.name + " puede copiar en " + payroll.name
                                    };
                                }
                                resolve(listC);
                            }).catch(function (error) {
                                reject(error);
                            })
                        })
                    }
                    scope.hide = function () {
                        $mdDialog.hide();
                    };
                    scope.cancel = function () {
                        $mdDialog.cancel();
                    };
                },
                targetEvent: ev,
                clickOutsideToClose: true
            })
        };
        $scope.showEditConceptsModal = function (ev) {
            $mdDialog.show({
                templateUrl: 'app/main/config/views/concepts/dialogs/edit-concepts/edit-concepts.html',
                parent: angular.element(document.body),
                controller: "EditConceptsController",
                controllerAs: "ecCtrl",
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true
            })
        };


        $scope.deleteConcepts = function (e, selected) {
            var promise = []
            for (var i = 0; i < selected.length; i++) {
                var incidenceType = selected[i].fid;
                var key = selected[i].key ? selected[i].key : null;
                var filter = {};
                filter[key] = { $exists: true };
                $log.log(filter);
                var params = {
                    incidenceType: incidenceType
                }
                promise.push($scope.D.api.get('incidences', params));
                promise.push($scope.D.api.get('calculations', filter));
            }
            Promise.all(promise).then(function (resp) {
                var deleteTheme = []
                for (var i = 0; i < resp.length; i++) {
                    if (resp[i].data.length > 0) {
                        errAlertS('No se puede borrar se esta usando en incidencias o en los calculos');
                        throw false
                    } else {
                        deleteTheme.push(selected);
                    }
                }
                $scope.deleteFb(deleteTheme);
            })
        }
    }
}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .controller('ConceptController', ConceptController);

    /** @ngInject */
    function ConceptController($scope, ListsF, $log, $rootScope, $q, getArrayOfIdsFilter, $mdDialog, confirmConfig, $filter, filterFilter, $timeout, $anchorScroll, $location, DataF, successAlertS, errAlertS) {
        var initiated = false;
        $scope.calcFields = [];
        $scope.groupings = [];
        $scope.calculation = {};
        $scope.objectParamsCount = {}
        $scope.indexCalculation;
        $scope.filters = [];
        $scope.employeeSelected = undefined;
        $scope.searchQuery = '';
        $scope.selectedIndex = 0;
        var originalCalculations;
        var dataFields = {
            id: 'value',
            name: 'TOTAL',
            outputType: 'currency',
            function: 'calc',
            formule: 'data.thisCalculation.totalIncidences.result',
            params: []
        };
        function init() {
            if (angular.isUndefined($scope.concept.calculations)) {
                $scope.concept.calculations = [];
                if (angular.isDefined($scope.concept.key)) {
                    $scope.concept.calculations.push({
                        conceptType: 'default',
                        fields: [],
                        'disabledEdit': true
                    });
                } else {
                    var indexValue = $scope.concept.calculations.indexOf(function (item) {
                        return item.id === 'value';
                    });
                    if (indexValue === -1) {
                        $scope.concept.calculations.push({
                            conceptType: 'default',
                            fields: [angular.fromJson(angular.toJson(dataFields))],
                            'disabledEdit': true
                        });
                    }
                }
            }
            for (var c = 0; c < $scope.concept.calculations.length; c++) {
                var thisCalculation = $scope.concept.calculations[c];
                if (angular.isArray(thisCalculation.fields)) {
                    for (var f = 0; f < thisCalculation.fields.length; f++) {
                        var thisField = thisCalculation.fields[f];
                        if (thisField.function === 'filter' && angular.isUndefined(thisField.params)) {
                            thisField.params = [];
                        }
                    }
                }
            }
            originalCalculations = JSON.stringify($scope.concept.calculations);
            if (angular.isUndefined($scope.concept.processType)) {
                $scope.concept.processType = {};
            }
            if (angular.isUndefined($scope.concept.fieldsToListen)) {
                $scope.concept.fieldsToListen = [];
            }
            if (angular.isUndefined($scope.concept.otherTotals)) {
                $scope.concept.otherTotals = [];
            }
            loadEmployees();
            ListsFilters();
            ListsConcepts();
            // loadProcessType();
            if (angular.isUndefined($scope.concept.key)) {
                typeUpdated($scope.concept.type, true);
            } else if ($scope.concept.payroll === 'global') {
                $scope.showPayroll = true;
            }
            if (angular.isUndefined($scope.concept.accFields)) {
                $scope.concept.accFields = [];
            }
            if (angular.isUndefined($scope.concept.accuFields)) {
                $scope.concept.accuFields = [];
            }
        }
        function typeUpdated(type, flag) {
            if (type === 'accumulator' || type === 'calc') {
                $scope.showPayroll = true;
                $scope.concept.payroll = "global";
            } else if (type === "incidenceType") {
                $scope.showPayroll = true;
                $scope.concept.payroll = "global";
            } else if (!type) {
                $scope.concept.payroll = "global";
                $scope.showPayroll = true
            }
            if (!flag) {
                $scope.concept.calculations = [];
                if (type === 'accumulator') {
                    $scope.concept.calculations.push({
                        conceptType: 'default',
                        directive: false,
                        fields: [],
                        'disabledEdit': true
                    });
                } else {
                    $scope.concept.calculations.push({
                        conceptType: 'default',
                        fields: [angular.fromJson(angular.toJson(dataFields))],
                        'disabledEdit': true
                    });
                }
                setCalculation($scope.concept.calculations[0], 0);
                if (['acumulator', 'calc'].indexOf(type) > -1) {
                    delete $scope.concept.nature;
                    delete $scope.concept.requireConfirmation;
                    delete $scope.concept.addFolio;
                    delete $scope.concept.uniqueFolio;
                    delete $scope.concept.requiredFolio;
                    delete $scope.concept.pattern;
                    delete $scope.concept.automatic;
                    delete $scope.concept.allowManual;
                    delete $scope.concept.constant;
                    delete $scope.concept.amortizationAvailable;
                }
            }
        }
        function setHiddenColumn(hiddenColumn) {
            if (hiddenColumn) {
                delete $scope.concept.showTotal;
                delete $scope.concept.requireConfirmation;
                delete $scope.concept.addFolio;
                delete $scope.concept.uniqueFolio;
                delete $scope.concept.requiredFolio;
                delete $scope.concept.pattern;
                delete $scope.concept.automatic;
                delete $scope.concept.allowManual;
                delete $scope.concept.constant;
                delete $scope.concept.amortizationAvailable;
            }
        }
        function setRequireConfirmation(requireConfirmation) {
            if (requireConfirmation) {
                delete $scope.concept.automatic;
                delete $scope.concept.allowManual;
                delete $scope.concept.constant;
                delete $scope.concept.amortizationAvailable;
            }
        }
        function setRequireFile(requireFile) {
            if (requireFile) {
                delete $scope.concept.addFolio;
                delete $scope.concept.uniqueFolio;
                delete $scope.concept.requiredFolio;
                delete $scope.concept.pattern;
            }
        }
        function addCalculation(indexCalculation) {
            if (angular.isUndefined($scope.concept.calculations)) {
                $scope.concept.calculations = [];
            }
            if (indexCalculation === 0) {
                $scope.concept.calculations.unshift({});
            } else {
                $scope.concept.calculations.splice(indexCalculation, 0, {});
                $timeout(function () {
                    $scope.calculation = $scope.concept.calculations[indexCalculation];
                    $rootScope.$evalAsync();
                }, 0.1, false)
            }
            $scope.calculation = $scope.concept.calculations[0];
        }
        function removeCalculation(event, index) {
            $mdDialog.show(
                $mdDialog.confirm(confirmConfig)
                    .title('Desea eliminar calculo?')
                    .ariaLabel('cancel movement')
                    .targetEvent(event)
                    .ok('Si')
                    .cancel('No'))
                .then(function () {
                    if (index > -1) {
                        $scope.concept.calculations.splice(index, 1);
                    }
                }, function () {
                    $log.debug('Cancelling Cancelled');
                }
                );
        }
        function listsEmployees(searchQuery, ccs) {
            return $q(function (resolve, reject) {
                var flag = ($scope.F.permissionToAccessAllPayrolls) ? true : false;
                var params = { "data.nss": { $exists: true } };
                if (!flag) {
                    params.cc = { $in: getArrayOfIdsFilter(ccs) }
                }
                $scope.autocompleteListM(searchQuery, "employees", ["data.name", "data.nss"], params).then(function (employees) {
                    resolve(employees);
                }, function (error) {
                    reject(error);
                })
            })
        }
        $scope.employees = [];
        function listsEmployeesOfTooltip(name, id) {
            var employees = $scope.employees;
            var exist = false;
            for (var i = 0; i < employees.length; i++) {
                if (employees[i].id === id) {
                    exist = true;
                    break;
                }
            }
            if (!exist) {
                $scope.employees.push({ id: id, name: name });
            }
        }
        function loadEmployees() {
            $scope.employees = [];
            var promises = [];
            var value = {}
            var calculationsAll = $scope.concept.calculations;
            var calculations = calculationsAll.filter(function (x) {
                if (value[x.employeeId]) return false;
                value[x.employeeId] = true;
                return true;
            });
            if (calculations.length > 0) {
                for (var i = 0; i < calculations.length; i++) {
                    var employeesId = calculations[i].employeeId;
                    if (employeesId) {
                        promises.push(ListsF.loadList('employees', 'lists/employees/all/' + employeesId, undefined, 'object', 'employees-' + employeesId));
                    }
                }

                $q.all(promises).then(function (resp) {
                    for (var i = 0; i < resp.length; i++) {
                        var snapshot = resp[i];
                        if (snapshot !== null) {
                            $scope.employees.push({ id: snapshot.$id, name: snapshot.name });
                        }
                    }
                    $scope.$evalAsync();
                }).catch(function (error) {
                    $log.debug(error);
                });
            }
        }
        function resetValuesOfConcept(index, value) {
            var concepts = $scope.F.conceptTypes;
            for (var i = 0; i < concepts.length; i++) {
                var type = concepts[i].id;
                if (type !== value) {
                    delete $scope.concept.calculations[index][type];
                }
            }
            if (value !== 'custom') {
                delete $scope.concept.calculations[index]['validations'];
            } else {
                if (angular.isUndefined($scope.concept.calculations[index].validations)) {
                    $scope.concept.calculations[index].validations = [
                        { condition: '', value: '', operator: 'equal' }
                    ];
                }
            }
        }
        function resetFields(value, index) {
            if (value !== false) {
                delete $scope.concept.calculations[index].fields;
            } else {
                var fields = $scope.concept.calculations[index].fields;
                if (angular.isUndefined(fields)) {
                    $scope.concept.calculations[index].fields = [
                        angular.fromJson(angular.toJson(dataFields))
                    ];
                }
            }
        }
        function addFields(index, type) {
            if (angular.isUndefined($scope.concept.calculations[index].fields)) {
                $scope.concept.calculations[index].fields = [];
            }
            var dataFields = $scope.concept.calculations[index].fields;
            var result = dataFields.length;
            var accumulator = false;
            if (type === 'accumulator' && angular.isDefined(dataFields) && dataFields.length === 0) {
                accumulator = true;
            }
            $scope.concept.calculations[index].fields.splice($scope.concept.calculations[index].fields.length - 1, 0, {
                id: (accumulator) ? 'value' : 'campo' + result,
                name: (accumulator) ? 'TOTAL' : 'VALOR',
                outputType: 'currency',
                function: 'calc',
                formule: 'data.thisCalculation.totalIncidences.result',
                params: []
            });
        }
        function removeFields(calculationIndex, fieldsIndex) {
            $scope.concept.calculations[calculationIndex].fields.splice(fieldsIndex, 1);
        }
        function resetValuesFormule(value, calculationIndex, fieldIndex) {
            if (value !== 'calc') {
                delete $scope.concept.calculations[calculationIndex].fields[fieldIndex].formule;
            } else {
                $scope.concept.calculations[calculationIndex].fields[fieldIndex].formule = 'data.thisCalculation.totalIncidences.result';
            }
        }
        function validateField(value, calculationIndex, fieldIndex, form) {
            var data = $scope.concept.calculations[calculationIndex].fields;
            var flag = true;
            if (angular.isDefined(value)) {
                for (var i = 0; i < data.length; i++) {
                    if (fieldIndex !== i) {
                        if (angular.lowercase(value) === angular.lowercase(data[i].id)) {
                            flag = false;
                            break;
                        }
                    }
                }
            }
            if (!flag) {
                form["id" + fieldIndex].$setValidity('validationError', false);
                if (value === 'value') {
                    delete $scope.concept.calculations[calculationIndex].fields[fieldIndex].id;
                }
            } else {
                form["id" + fieldIndex].$setValidity('validationError', true);
            }
        }
        function addFieldsCustom(indexCalculation) {
            $scope.concept.calculations[indexCalculation].validations.push({
                condition: '',
                value: ''
            });
        }
        function removeFieldsCustom(indexCalculation, indexFields) {
            $scope.concept.calculations[indexCalculation].validations.splice(indexFields, 1);
        }
        function loadFilters() {
            return new Promise(function (resolve, reject) {
                $rootScope.D.api.get("filters").then(function (resp) {
                    resolve(resp.data);
                }).catch(function (error) {
                    reject(error);
                });
            })
        }
        function loadCalcFields() {
            return $scope.L.loadList('calcFields', 'catalogs/calcFields/collection', null, 'array');
        }
        function loadGroupings() {
            return $scope.L.loadList('groupings', 'lists/groupings/all', null, 'array');
        }
        function ListsFilters() {
            $scope.listOfConceptsCalculation = [];
            var promises = [
                loadFilters(),
                loadCalcFields(),
                loadGroupings()
            ];
            Promise.all(promises).then(function (response) {
                if (response.length > 0) {
                    var filters = response[0];
                    var calcFields = response[1];
                    var groupings = response[2];
                    $scope.filters = filters;
                    $scope.calcFields = calcFields;
                    $scope.groupings = $filter("cleanArrayOfData")(groupings);
                    for (var f = 0; f < filters.length; f++) {
                        $scope.objectParamsCount[filters[f].id] = filters[f].params || [];
                    }
                }
            }).catch(function (error) {
                $log.error(error);
            })
        }
        function filterCalcFields(textToSearch) {
            var list = $filter('cleanArrayOfData')($scope.calcFields);
            var items = [];
            for (var i = 0; i < list.length; i++) {
                items.push(list[i]);
            }
            return filterFilter(items, textToSearch);
        }
        function transformChip(chip) {
            if (angular.isObject(chip)) {
                return chip.$id;
            }
            return chip;
        }
        function filterCalcFilters(textToSearch) {
            var list = $filter('cleanArrayOfData')($scope.filters);
            var items = [];
            for (var i = 0; i < list.length; i++) {
                items.push(list[i]);
            }
            return filterFilter(items, textToSearch);
        }
        function addParams(chip) {
            return chip;
        }
        function validParams(value, max, indexField, form) {
            if (max >= value.length && max <= value.length) {
                form["param" + indexField].$setValidity('minParams', true);
            } else {
                if (value.length < max) {
                    form["param" + indexField].$setValidity('minParams', false);
                }
            }
        }
        function ListsConcepts() {
            $scope.listsConcepts = [];
            var list = [];
            $scope.F.root.child('/lists/conceptsByCenter/' + $scope.F.center + '/all').once('value').then(function (resp) {
                var data = resp.val();
                for (var key in data) {
                    data[key].$id = key;
                    list.push(data[key]);
                }
                $scope.listsConcepts = list;
            }).catch(function (error) {
                $log.error(error);
            });
        }
        function showAvailableFields(event) {
            $mdDialog.show({
                parent: angular.element(document.body),
                targetEvent: event,
                templateUrl: 'app/main/config/views/concepts/dialogs/available-fields.html',
                locals: {
                    filters: $scope.filters,
                    calcFields: $scope.calcFields,
                    listsConcepts: $scope.listsConcepts
                },
                controller: function DialogController(scope, $mdDialog, filters, calcFields, listsConcepts) {
                    scope.filters = filters;
                    scope.calcFields = calcFields;
                    scope.listsConcepts = listsConcepts;

                    scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                    scope.toggleAvailableFields = function (value) {
                        var element = angular.element('.body-' + value).is(":visible");
                        document.querySelector('.head-' + value).classList.toggle("isOpen");
                        if (element === false) {
                            angular.element('.body-' + value).slideDown();
                        } else {
                            angular.element('.body-' + value).slideUp();
                        }
                    }
                }
            });
        }
        // $scope.items = [];
        // function toggle(item, list) {
        //     var idx = list.indexOf(item);
        //     if (idx > -1) {
        //         addValueProcessOfType("remove", item);
        //         list.splice(idx, 1);
        //     }
        //     else {
        //         addValueProcessOfType("add", item);
        //         list.push(item);
        //     }
        // }
        // function exists(item, list) {
        //     return list.indexOf(item) > -1;
        // }
        // function isIndeterminate() {
        //     return ($scope.selected.length !== 0 &&
        //         $scope.selected.length !== $scope.items.length);
        // }
        // function isChecked() {
        //     return $scope.selected.length === $scope.items.length;
        // }
        // function toggleAll() {
        //     if ($scope.selected.length === $scope.items.length) {
        //         addValueProcessOfType(false);
        //         $scope.selected = [];
        //     } else if ($scope.selected.length === 0 || $scope.selected.length > 0) {
        //         addValueProcessOfType(true);
        //         $scope.selected = $scope.items.slice(0);
        //     }
        // }
        // function addValueProcessOfType(flag, value) {
        //     var item = $scope.items;
        //     var status;
        //     if (flag == true) {
        //         status = true;
        //     } else if (flag == false) {
        //         status = false;
        //     } if (flag === "add") {
        //         $scope.concept.processType[value] = true;
        //     }
        //     else if (flag === "remove") {
        //         $scope.concept.processType[value] = false;
        //     }
        //     if (item.length > 0 && (status === true || status === false)) {
        //         for (var i = 0; i < item.length; i++) {
        //             $scope.concept.processType[item[i]] = status;
        //         }
        //     }
        // }
        // function loadProcessType() {
        //     var value = $scope.concept.processType;
        //     var data = [];
        //     for (var key in value) {
        //         if (value[key] == true) {
        //             data.push(key);
        //         }
        //     }
        //     if (data.length > 0) {
        //         $scope.items = Object.keys(value);
        //         $scope.selected = data;
        //     } else {
        //         $scope.items = ["payroll"];
        //         $scope.selected = ["payroll"];
        //         $scope.concept.processType.payroll = true;
        //     }
        // }
        function setCalculation(calculation, index) {
            $scope.calculation = {};
            $scope.indexCalculation = index;
            $timeout(function () {
                $scope.calculation = $scope.concept.calculations[index];
            }, 0.1, false);
            if (angular.isDefined(calculation.employeeId)) {
                ListsF.loadList('employees', 'catalogs/employees/collection/' + calculation.employeeId, undefined, 'object', 'employees-' + calculation.employeeId).then(function (employee) {
                    $scope.searchQuery = employee.data.name;
                    $scope.employeeSelected = employee;
                    $rootScope.$evalAsync();
                });
            } else {
                $scope.searchQuery = "";
                $scope.employeeSelected = "";
                $scope.$evalAsync();
            }
        }
        function copyCalculations(indexCalculation) {
            var data = $scope.concept.calculations[indexCalculation];
            if (indexCalculation === 0) {
                $scope.concept.calculations.unshift({
                    directive: angular.fromJson(angular.toJson(data.directive)),
                    fields: angular.fromJson(angular.toJson(data.fields))
                });
            } else {
                $scope.concept.calculations.splice(indexCalculation, 0, {
                    directive: angular.fromJson(angular.toJson(data.directive)),
                    fields: angular.fromJson(angular.toJson(data.fields))
                });
                $timeout(function () {
                    $scope.calculation = $scope.concept.calculations[indexCalculation];
                    $rootScope.$evalAsync();
                }, 0.1, false)
            }
            $scope.calculation = $scope.concept.calculations[0];
        }
        function moveFields(arr, old_index, new_index) {
            if (new_index >= arr.length) {
                return false;
            }
            arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
            return arr;
        }

        function movePosition(indexCalculation, indexFields, operation) {
            var fields = $scope.concept.calculations[indexCalculation].fields;
            if ((indexFields === 0 && operation === -1) || (indexFields === (fields.length - 1) && operation === +1)) {
                return false;
            } else {
                moveFields(fields, indexFields, (indexFields + operation));
                var newHash = 'fields' + (indexFields + operation);
                if ($location.hash() !== newHash && operation === -1) {
                    $timeout(function () {
                        $location.hash(newHash);
                        $anchorScroll();
                        $location.hash('');
                        $location.replace();
                    }, 0, false)
                }
            }
        }
        function movePositionTabs(indexCalculation, operation) {
            var calculations = $scope.concept.calculations;
            if ((indexCalculation === 0 && operation === -1) || (indexCalculation === (calculations.length - 1) && operation === +1)) {
                return false;
            } else {
                moveFields(calculations, indexCalculation, (indexCalculation + operation));
                $timeout(function () {
                    $scope.selectedIndex = indexCalculation + operation;
                }, 0, false);
            }
        }

        function setValue(setVal) {
            if (!setVal) {
                delete $scope.concept.defaultValue;
                delete $scope.concept.editValue;
            }
        }
        function addAccFields() {
            $scope.concept.accFields.push({ field: "", acc: "", accN: "" });
        }
        function deleteAccFields(index) {
            $scope.concept.accFields.splice(index, 1);
        }
        function addAccuFields() {
            $scope.concept.accuFields.push({ field: "", name: "" });
        }
        function deleteAccuFields(index) {
            $scope.concept.accuFields.splice(index, 1);
        }
        function addValidation() {
            if (!angular.isArray($scope.concept.validations)) {
                $scope.concept.validations = [];
            }
            $scope.concept.validations.push({});
        }
        function deleteValidation(index) {
            $scope.concept.validations.splice(index, 1);
        }
        function saveConcept(ev, concept, action) {

            var obj = {};
            if (action === 'create') {
                $rootScope.loadingProgress = true;
                var conceptId = $scope.F.root.child('catalogs/concepts/collection').push().key;
                concept.created = DataF.getTimeObject();
                concept.center = $scope.F.center;
                obj['catalogs/concepts/collection/' + conceptId] = concept;
                update(obj);
            }
            if (action === 'update') {
                var promises = [];
                if (originalCalculations !== JSON.stringify($scope.concept.calculations)) {
                    promises.push(new Promise(function (resolve) {
                        var confirm = $mdDialog.prompt()
                            .title('Se ha realizado un cambio en los cálculos, añadir comentario para registrar la modificación')
                            .placeholder('Comentario de edición')
                            .ariaLabel('Comentario de edición')
                            .targetEvent(ev)
                            .ok('Actualizar')
                            .cancel('Cancelar');
                        $mdDialog.show(confirm).then(function (data) {
                            resolve(data);
                        }).catch(function () {
                            resolve(false);
                        })
                    }))
                }
                Promise.all(promises).then(function (data) {
                    $rootScope.loadingProgress = true;
                    var id = concept.$id;
                    if (data.length > 0 && data[0]) {
                        var comment = data[0];
                        if (angular.isUndefined(concept.changeLog)) {
                            concept.changeLog = {};
                        }
                        concept.changeLog[moment().valueOf()] = comment;
                    }
                    concept.updated = DataF.getTimeObject();
                    delete concept.$id;
                    obj['catalogs/concepts/collection/' + id] = $filter('clearObject')(concept);
                    update(obj);
                }).catch(function (error) {
                    errAlertS(error);
                })
            }
        }
        function showModal(ev, data) {
            $rootScope.loadingProgress = false;
            var payrolls = ($scope.F.permissionToAccessAllPayrolls) ? angular.fromJson(angular.toJson($rootScope.L.allPayrolls)) : angular.fromJson(angular.toJson($rootScope.L.payrolls));
            payrolls.push({ $id: 'global', name: 'GLOBAL' });
            $mdDialog.show({
                templateUrl: 'app/main/config/views/concepts/dialogs/copy-concepts-relations.html',
                parent: angular.element(document.body),
                locals: {
                    data: data,
                    payrolls: payrolls
                },
                controller: function (scope, data, payrolls) {
                    scope.payrolls = payrolls;
                    var updated = data.updated;
                    scope.confirm = function (selected) {
                        $rootScope.loadingProgress = true;
                        var obj = {};
                        for (var i = 0; i < selected.length; i++) {
                            if (updated.hasOwnProperty(selected[i].$id)) {
                                obj['catalogs/concepts/collection/' + selected[i].$id] = updated[selected[i].$id];
                            }
                        }
                        update(obj, true);
                        scope.hide();
                    };
                    scope.items = data.concepts;
                    scope.selected = [];
                    scope.toggle = function (item, list) {
                        var idx = list.indexOf(item);
                        if (idx > -1) {
                            list.splice(idx, 1);
                        }
                        else {
                            list.push(item);
                        }
                    };
                    scope.exists = function (item, list) {
                        return list.indexOf(item) > -1;
                    };
                    scope.hide = function () {
                        $mdDialog.hide();
                        successAlertS('Se guardo concepto con éxito');
                        $scope.R.goToList();
                    };
                    scope.cancel = function () {
                        $mdDialog.cancel();
                        successAlertS('Se guardo concepto con éxito');
                        $scope.R.goToList();
                    };
                },
                targetEvent: ev,
                clickOutsideToClose: false
            });
        }
        function update(updates, flag) {
            if (flag) {
                $scope.F.root.update(updates).then(function () {
                    console.log('Se guardo concepto con éxito');
                }).catch(function (error) {
                    errAlertS('No se pudo actualizar los datos de concepto');
                    $log.error('Error al guardar el concepto', error);
                });
            } else {
                $scope.F.root.update(updates).then(function () {
                    successAlertS('Se guardo concepto con éxito');
                    $scope.R.goToList();
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                }).catch(function (error) {
                    errAlertS('No se pudo actualizar los datos de concepto');
                    $log.error('Error al guardar el concepto', error);
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                });
            }
        }
        $scope.transformChip = function (data) {
            return data.$id;
        }
        $scope.allPayrolls = $rootScope.F.permissionToAccessAllPayrolls ? $rootScope.L.allPayrolls : $rootScope.L.payrolls;
        $scope.querySearch = function (search) {
            $log.log($scope.allPayrolls);
            $scope.concept.payrollsRemoved = $scope.concept.payrollsRemoved || [];
            var lowerCaseSearch = (search || '').toLowerCase();

            var removedIds = $scope.concept.payrollsRemoved
                .map(function (p) {
                    return p && p.$id;
                })
                .filter(function (id) {
                    return angular.isString(id);
                });
            var filteredPayrolls = $scope.allPayrolls.filter(function (item) {
                var notRemoved = removedIds.indexOf(item.$id) === -1;
                var matchesSearch = item.name && item.name.toLowerCase().indexOf(lowerCaseSearch) > -1;
                return notRemoved && matchesSearch;
            });
            return filteredPayrolls;
        };




        $scope.typeUpdated = typeUpdated;
        $scope.setHiddenColumn = setHiddenColumn;
        $scope.setRequireConfirmation = setRequireConfirmation;
        $scope.setRequireFile = setRequireFile;
        $scope.addCalculation = addCalculation;
        $scope.removeCalculation = removeCalculation;
        $scope.listsEmployees = listsEmployees;
        $scope.resetValuesOfConcept = resetValuesOfConcept;
        $scope.resetFields = resetFields;
        $scope.addFields = addFields;
        $scope.addFieldsCustom = addFieldsCustom;
        $scope.removeFieldsCustom = removeFieldsCustom;
        $scope.removeFields = removeFields;
        $scope.resetValuesFormule = resetValuesFormule;
        $scope.validateField = validateField;
        $scope.listsEmployeesOfTooltip = listsEmployeesOfTooltip;
        $scope.loadEmployees = loadEmployees;
        $scope.ListsFilters = ListsFilters;
        $scope.filterCalcFields = filterCalcFields;
        $scope.filterCalcFilters = filterCalcFilters;
        $scope.addParams = addParams;
        $scope.validParams = validParams;
        $scope.transformChip = transformChip;
        $scope.showAvailableFields = showAvailableFields;
        // $scope.toggleAll = toggleAll;
        // $scope.isChecked = isChecked;
        // $scope.isIndeterminate = isIndeterminate;
        // $scope.exists = exists;
        // $scope.toggle = toggle;
        $scope.setCalculation = setCalculation;
        $scope.copyCalculations = copyCalculations;
        $scope.movePosition = movePosition;
        $scope.movePositionTabs = movePositionTabs;
        $scope.setValue = setValue;
        $scope.addAccFields = addAccFields;
        $scope.deleteAccFields = deleteAccFields;
        $scope.addAccuFields = addAccuFields;
        $scope.deleteAccuFields = deleteAccuFields;
        $scope.addValidation = addValidation;
        $scope.deleteValidation = deleteValidation;
        $scope.saveConcept = saveConcept;
        if ($scope.objectLoaded) {
            if (!initiated) { init(); }
        } else {
            $log.debug('setting watcher to mainObjLoaded');
            $scope.detailWatchers.mainObjLoaded = $rootScope.$on('mainObjectLoaded', function () {
                if (!initiated) {
                    init();
                }
                $scope.detailWatchers.mainObjLoaded();
                delete $scope.detailWatchers.mainObjLoaded;
            });
        }
    }
}());
(function () {
    'use strict';

    angular
        .module('app.config')
        .directive('formBenefit', formBenefit)


   /** @ngInject */
   function formBenefit() {
    return {
        replace: true,
        templateUrl: 'app/main/config/views/benefits/forms/form-benefit.html'
    }
}
}());
(function () {
    'use strict';

    angular
        .module('app.config')
        .controller('BenefitsController', BenefitsController);

    function BenefitsController($scope, $log, userHasPermissionFilter, AppF, startAfterInitFilter, getArrayOfIdsFilter) {
        var listWatchers = {};
        var initiated = false;
        $scope.anyHasPermission = false;
        function tabChanged(tab) {
            $scope.F.search.$type = tab;
            filter();
        }
        function init() {
            $scope.permissions = {
                default: userHasPermissionFilter(AppF.groupsOfUser, AppF.permissions, 'tabBenefitsDefault', 'config.benefits'),
                payroll: userHasPermissionFilter(AppF.groupsOfUser, AppF.permissions, 'tabBenefitsPayroll', 'config.benefits'),
                cc: userHasPermissionFilter(AppF.groupsOfUser, AppF.permissions, 'tabBenefitsCc', 'config.benefits'),
                employee: userHasPermissionFilter(AppF.groupsOfUser, AppF.permissions, 'tabBenefitsEmployee', 'config.benefits')
            };
            for (var tab in $scope.permissions) {
                if ($scope.permissions.hasOwnProperty(tab)) {
                    if ($scope.permissions[tab]) {
                        $scope.anyHasPermission = true;
                    }
                }
            }
        }
        function filter() {
            var itemId = undefined;
            if (angular.isDefined($scope.F.search) && $scope.F.search.$type !== 'default' && angular.isObject($scope.F.benefitsSearch) && $scope.F.benefitsSearch[$scope.F.search.$type]) {
                itemId = $scope.F.benefitsSearch[$scope.F.search.$type];
            }
            $scope.F.search.$.itemId = itemId;
        }
        function getEmployee() {
            if ($scope.F.benefitsSearch.employee) {
                $scope.L.loadList('employees', 'catalogs/employees/collection', $scope.F.benefitsSearch.employee, 'object', 'benefitEmployees').then(function (employee) {
                    $scope.searchQuery = employee.data.name;
                });
            }
        }
        listWatchers.benefitsTypeSearch = $scope.$watch('F.search.$type', function (val, oldVal) {
            $scope.thisCcs = [];
            if (angular.isUndefined(val)) {
                $scope.F.search.$type = typeof (oldVal) !== 'undefined' ? oldVal : 'default';
            }
        });
        listWatchers.benefitsSearch = $scope.$watch('F.benefitsSearch', function (val) {
            $scope.thisCcs = [];
            if (val && $scope.F.benefitsSearch.payroll) {
                $scope.L.loadList('ccs', 'lists/ccs/payroll', $scope.F.benefitsSearch.payroll, 'array', 'payrollCcs').then(function (ccs) {
                    if ($scope.F.search.$type === 'cc') {
                        $scope.thisCcs = getArrayOfIdsFilter(ccs);
                        $log.info(ccs, 'ccs of', $scope.F.benefitsSearch.payroll, 'loaded');
                    }
                });
            }
            if ($scope.F.search.$type === 'employee' && angular.isDefined(val) && angular.isDefined(val.employee)) {
                getEmployee();
            }
            filter();
        }, true);
        $scope.tabChanged = tabChanged;
        $scope.searchQuery = '';
        startAfterInitFilter($scope, listWatchers, initiated, init);
    }
})();
(function () {
    'use strict';

    angular
        .module('app.config')
        .controller('BenefitController', BenefitController);

    function BenefitController($scope, $rootScope, $log) {
        var detailWatchers = {};
        var initiated = false;
        function filter() {
            if (typeof ($scope.F.search) !== 'undefined' && $scope.F.search.$type !== 'default' && angular.isObject($scope.F.benefitsSearch) && $scope.F.benefitsSearch[$scope.F.search.$type]) {
                $scope.benefit.itemId = $scope.F.benefitsSearch[$scope.F.search.$type];
                if ($scope.F.search.$type === 'employee') {
                    $scope.L.loadList('employees', 'catalogs/employees/collection', $scope.benefit.itemId, 'object', 'benefitEmployee').then(function (employee) {
                        $scope.searchQuery = employee.data.name;
                    });
                }
            } else if ($scope.benefit.type === 'default' && $scope.F.addMode) {
                $scope.benefit.itemId = 'default';
            }
        }
        function stopWatcher() {
            for (var f in detailWatchers) {
                if (detailWatchers.hasOwnProperty(f)) {
                    detailWatchers[f]();
                }
            }
        }
        function addToOhter() {
            if (typeof ($scope.benefit.others) === 'undefined') {
                $scope.benefit.others = [];
            }
            $scope.benefit.others.push({});
        }
        function holidaysHasChange() {
            if ($scope.benefit.holidays === 'default') {
                $scope.benefit.holidaysTable = angular.fromJson(angular.toJson($scope.F.defaultBenefits.holidaysTable));
                $scope.editHolidayTable = false;
            }
        }
        function init() {
            if (typeof ($scope.F.benefitsSearch) === 'undefined') {
                $scope.F.benefitsSearch = {};
            }
            if (!initiated) {
                if (angular.isUndefined($scope.benefit.christmasBonusTable)) {
                    $scope.benefit.christmasBonusTable = [];
                }
                initiated = true;
                if (!$scope.F.addMode) {
                    detailWatchers.itemId = $scope.$watch('benefit.itemId', function (itemId) {
                        switch ($scope.benefit.type) {
                            case 'payroll':
                                $scope.F.benefitsSearch.payroll = itemId;
                                break;
                            case 'cc':
                                $scope.F.benefitsSearch.cc = itemId;
                                $scope.L.loadList('ccs', 'lists/ccs/all', itemId, 'object', 'benefitCC').then(function (cc) {
                                    $scope.F.benefitsSearch.payroll = cc.payroll;
                                });
                                break;
                            case 'employee':
                                $scope.F.benefitsSearch.employee = itemId;
                                $scope.L.loadList('employees', 'catalogs/employees/collection', itemId, 'object', 'benefitEmployee').then(function (employee) {
                                    $scope.F.benefitsSearch.payroll = employee.payroll;
                                    $scope.F.benefitsSearch.cc = employee.cc;
                                    $scope.searchQuery = employee.data.name;
                                });
                                break;
                        }
                    });
                }
                detailWatchers.benefitsSearch = $scope.$watch('F.benefitsSearch', function (val) {
                    if (typeof (val) !== 'undefined' && $scope.F.benefitsSearch.payroll && $scope.benefit.type === 'cc') {
                        $scope.L.loadList('ccs', 'lists/ccs/payroll', $scope.F.benefitsSearch.payroll, 'array', 'payrollCcs').then(function (ccs) {
                            $log.info(ccs, 'ccs of', $scope.F.benefitsSearch.payroll, 'loaded');
                        });
                    }
                    filter();
                }, true);

            }
        }
        detailWatchers.stopWatcher = $rootScope.$on('stopListWatchers', function () {
            stopWatcher();
        });
        detailWatchers.destroy = $scope.$on('$destroy', function () {
            stopWatcher();
        });
        $scope.addToOhter = addToOhter;
        $scope.searchQuery = '';
        $scope.holidaysHasChange = holidaysHasChange;

        if ($scope.objectLoaded) {
            init();
        } else {
            var mainObjectLoaded = $rootScope.$on('mainObjectLoaded', function () {
                mainObjectLoaded();
                init();
            });
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.config')
        .directive('activitiesRecords', activitiesRecords);
    
    function activitiesRecords() {
        var directive = {
            restrict: 'EA',
            controller:'ActivitiesRecordsController',
            replace: true,
            templateUrl: 'app/main/config/views/activitiesRecords/activitiesRecords.html'
        };
        return directive;
    }
})();
(function () {
    'use strict';

    angular
        .module('app.config')
        .controller('ActivitiesRecordsController', ActivitiesRecordsController);

    function ActivitiesRecordsController(
        $scope,
        $rootScope,
        $state,
        $log,
        $mdDialog,
        successAlertS,
        errAlertS,
        confirmConfig,
        startAfterInitFilter
    ) {
        var initiated = false;
        var watchers = {};
        $scope.configState = 'app.config.activitiesRecords.config';
        $scope.detailState = 'app.config.activitiesRecords.detail';
        $scope.addParam = 'new';
        $scope.activitiesRecords = [];
        $scope.selected = [];
        $scope.currentPage = 1;
        $scope.F.search.activitiesRecord = null;

        function init() {
            if (!$scope.F.search || !$scope.F.search.hasOwnProperty('activitiesRecords')) {
                $scope.F.resetSearch('activitiesRecords', $scope.selected);
            }
            initiated = true;
            $scope.getThem();
        }

        var remove = function (activitiesRecord) {
            $log.debug('removing: ', activitiesRecord);
            return $scope.D.api.delete('activitiesRecords/' + activitiesRecord._id);
        }

        $scope.getThem = function () {
            $rootScope.loadingProgress = true;
            var params = {
                page: $scope.currentPage,
                size: 10,
                sort: 'from.atTime',
                'from.by': $scope.F.user.uid
            };
            if ($scope.order) params.sort = $scope.order;
            if ($scope.F.search.activitiesRecord) params.name = $scope.F.search.activitiesRecord;
            $scope.D.api.get('p/logs', params).then(function (res) {
                $scope.activitiesRecords = res.data.data;
                $scope.pagination = res.data.pagination;
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync(function () {
                    $log.debug('getThem finished');
                });
            }).catch(function (err) {
                errAlertS(err);
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
            });
        };

        // Methods
        $scope.goToDetail = function (activitiesRecord) {
            $scope.F.goToState($scope.detailState, { 'activitiesRecordId': (activitiesRecord === 'new') ? 'new' : activitiesRecord._id, 'activitiesRecord': activitiesRecord });
        };

        $scope.delete = function (e) {
            var msg = (!$scope.F.safeDelete.activitiesRecord) ?
                'No podrá recuperar sus datos' :
                'Podrá recuperar sus datos en la papelera';
            var title = 'Quiere borrar ' + $scope.selected.length + ' nueva actividads?';

            $mdDialog.show($mdDialog.confirm(confirmConfig)
                .title(title)
                .content(msg)
                .ariaLabel('Deleting')
                .targetEvent(e)
                .ok('Borrar')
                .cancel('Cancelar'))
                .then(function () {
                    var count = 0;
                    $log.debug('Deleting: ', $scope.selected);
                    angular.forEach($scope.selected, function (activitiesRecord) {
                        if ($scope.F.safeDelete.activitiesRecord) {

                        } else {
                            remove(activitiesRecord).then(function () {
                                var i = $scope.activitiesRecords.indexOf(activitiesRecord);
                                $scope.activitiesRecords.splice(i, 1);
                                count++
                                if (count == $scope.selected.length) {
                                    successAlertS('Se borraron ' + count + ' nueva actividads');
                                }
                            }, errAlertS);
                        }
                    });
                }, function () {
                    $log.debug('Deleting Cancelled');
                });
        };
        startAfterInitFilter($scope, watchers, initiated, init);
    }
})();
(function () {
    'use strict';

    angular
        .module('app.config')
        .controller('copyAccountController', copyAccountController);

    function copyAccountController($log, account, DataF, ListsF, AppF, loopEachFilter, errAlertS, $rootScope, MongoF, $mdDialog, $scope, $q, successAlertS, scope) {
        var vm = this;

        function init() {
            vm.data = 'Hola mundo'
            vm.companiesRecords();
            vm.conceptsData();
            vm.payrolls = AppF.permissionToAccessAllPayrolls ? $rootScope.L.allPayrolls : $rootScope.L.payrolls;
        }
        scope.datas = 'Esto es una data'
        vm.companiesRecords = function () {
            return new Promise(function (resolve, reject) {
                var thisQuery = [{ q: 'orderByChild', v: 'center' }, { q: 'equalTo', v: function () { return AppF.center; } }];
                ListsF.loadList('companiesRecords', 'catalogs/companiesRecords/collection', false, 'array', 'report-companiesRecordId', thisQuery).then(function (data) {
                    var companiesRecords;
                    if (!AppF.permissionToAccessAllPayrolls) {
                        var allCompaniesRecords = [];
                        ListsF.payrolls.map(function (item) {
                            loopEachFilter(item.processes, function (data) {
                                if (data.companiesRecord && allCompaniesRecords.indexOf(data.companiesRecord) === -1) {
                                    allCompaniesRecords.push(data.companiesRecord);
                                }
                            });
                        });
                        companiesRecords = data.filter(function (item) {
                            return allCompaniesRecords.indexOf(item.$id) > -1;
                        });
                    } else {
                        companiesRecords = data;
                    }
                    vm.companiesRecordsList = companiesRecords;
                    resolve(companiesRecords);
                }).catch(reject);
            });
        }

        vm.conceptsData = function (idPayroll) {
            vm.cargos = [];
            vm.bonos = [];
            vm.payrollsData = idPayroll
            var query = { center: "tds", payroll: { $in: ["global", idPayroll] }, $or: angular.toJson([{ type: "incidenceType" }, { forAcc: { $exists: true } }]) }
            DataF.api.get('concepts', query).then(function (resp) {
                for (var i = 0; i < resp.data.length; i++) {
                    var concepts = resp.data[i];
                    var nature = concepts.nature ? concepts.nature : '';
                    var forToCc = concepts.forAcc ? concepts.forAcc : '';
                    if ((nature === 'perception' | nature === 'deduction' && concepts.allowNegative) || angular.isDefined(forToCc.charge)) {
                        vm.cargos.push(concepts);
                    }
                    if (nature === 'deduction' || angular.isDefined(forToCc.credit)) {
                        vm.bonos.push(concepts);
                    }
                }
            })
        }

        vm.valid = false
        vm.existData = function (idCompany, idPayroll) {
            if (angular.isDefined(idPayroll)) {
                vm.conceptsData(idPayroll)
            }
            if (angular.isDefined(idCompany)) {
                var query = { companiesRecord: idCompany };
                DataF.api.get("accountingAccounts", query).then(function (resp) {
                    if (resp.data.length > 0) {
                        $log.log('No se puede copiar')
                        errAlertS('No se puede por que ya existe una cuenta contable con estos datos.')
                        $rootScope.F.addMode = false;
                        vm.valid = false
                    } else {
                        vm.valid = true
                        $rootScope.F.addMode = true;
                    }
                })
            }
        }

        vm.close = function () {
            $mdDialog.hide();
        }

        vm.copyAccount = function () {
            try {
                $rootScope.loadingProgress = true;
                var obj = account[0];
                delete obj._id;
                $log.log('obj', obj);

                cleanObject(obj).then(function (resultadoLimpio) {
                    DataF.api.addWithUnique('accountingAccounts', resultadoLimpio).then(function () {
                        successAlertS('Se copió correctamente la cuenta contable');
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync();
                    })
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                    $mdDialog.hide()
                });

            } catch (error) {
                errAlertS(error)
            }
        }



        function cleanObject(obj) {
            function recursiveClean(o) {
                var deferred = $q.defer();

                var promises;
                if (angular.isArray(o)) {
                    promises = o.map(function (item) {
                        return recursiveClean(item);
                    });

                    $q.all(promises).then(function (results) {
                        deferred.resolve(results.filter(function (item) {
                            return angular.isDefined(item)
                        }));
                    });

                } else if (angular.isObject(o) && o !== null) {
                    var cleaned = {};
                    promises = [];

                    var shouldRemoveThisObject = false;
                    angular.forEach(o, function (value, key) {
                        if (key === 'ccId') {
                            cleaned[key] = '';
                            return;
                        }
                        if (key === 'concepts' && angular.isArray(value)) {
                            var matchingPayrolls = [];
                            angular.forEach($rootScope.L.allPayrolls, function (payroll) {
                                var processes = payroll.processes;
                                angular.forEach(processes, function (process) {
                                    $log.log('company', process.companiesRecord);
                                    if (process.companiesRecord === vm.accountingAccount.companiesRecord) {
                                        matchingPayrolls.push(payroll.$id);
                                    }
                                });
                            });
                            if (!matchingPayrolls.includes("global")) {
                                matchingPayrolls.push("global");
                            }
                            var validConcepts = [];
                            var conceptPromises = value.map(function (fid) {
                                var query = {
                                    center: AppF.center,
                                    payroll: { $in: matchingPayrolls },
                                    fid: fid
                                };
                                return DataF.api.get('concepts', query).then(function (resp) {
                                    $log.log('resp', resp)
                                    if (resp.data.length > 0) {
                                        validConcepts.push(fid);
                                    }
                                });
                            });

                            var conceptPromise = $q.all(conceptPromises).then(function () {
                                if (validConcepts.length > 0) {
                                    cleaned[key] = validConcepts;
                                } else {
                                    shouldRemoveThisObject = true;
                                    $log.log('Se eliminará "concepts" porque ningún concepto fue válido:', value);
                                }
                            });

                            promises.push(conceptPromise);
                        } else {
                            var childPromise = recursiveClean(value).then(function (cleanedValue) {
                                if (angular.isDefined(cleanedValue)) {
                                    cleaned[key] = cleanedValue;
                                }
                            });

                            promises.push(childPromise);
                        }
                    });

                    $q.all(promises).then(function () {
                        if (shouldRemoveThisObject) {
                            deferred.resolve(undefined);
                        } else if (Object.keys(cleaned).length === 0) {
                            deferred.resolve(undefined);
                        } else {
                            deferred.resolve(cleaned);
                        }
                    });

                } else {
                    deferred.resolve(o);
                }

                return deferred.promise;
            }

            obj.companiesRecord = vm.accountingAccount.companiesRecord;
            return recursiveClean(obj);
        }


        // function cleanObjectDelete(obj) {
        //     var payrolls = obj.payroll;
        //     function recursiveClean(o) {
        //         $rootScope.loadingProgress = true;
        //         var deferred = $q.defer();
        //         var promises;
        //         if (angular.isArray(o)) {
        //             promises = o.map(function (item) {
        //                 return recursiveClean(item);
        //             });

        //             $q.all(promises).then(function (results) {
        //                 deferred.resolve(results.filter(function (item) {
        //                     return angular.isDefined(item);
        //                 }));
        //             });
        //         } else if (angular.isObject(o) && o !== null) {
        //             var cleaned = {};
        //             promises = [];

        //             var removeThisObject = false;

        //             angular.forEach(o, function (value, key) {
        //                 if (key === 'ccId') {
        //                     cleaned[key] = '';
        //                 } else if (key === 'conceptId') {
        //                     var query = {
        //                         center: AppF.center,
        //                         payroll: { $in: ["global", payrolls] },
        //                         fid: value
        //                     };

        //                     var conceptPromise = DataF.api.get('concepts', query).then(function (resp) {
        //                         if (resp.data.length > 0) {
        //                             var keyConcept = resp.data[0].key;
        //                             var data = {
        //                                 center: AppF.center,
        //                                 payroll: { $in: ["global", obj.payroll] },
        //                                 key: keyConcept
        //                             };

        //                             return DataF.api.get('concepts', data).then(function (resp2) {
        //                                 if (resp2.data && resp2.data[0]) {
        //                                     $log.log('suceces', resp2)
        //                                     cleaned[key] = resp2.data[0].fid;
        //                                 } else {
        //                                     $log.log('Error', resp2)
        //                                     removeThisObject = true;
        //                                 }
        //                             });
        //                         } else {
        //                             removeThisObject = true;
        //                         }
        //                     });

        //                     promises.push(conceptPromise);
        //                 } else {
        //                     var childPromise = recursiveClean(value).then(function (cleanedValue) {
        //                         if (angular.isDefined(cleanedValue)) {
        //                             cleaned[key] = cleanedValue;
        //                         }
        //                     });
        //                     promises.push(childPromise);
        //                 }
        //             });

        //             $q.all(promises).then(function () {
        //                 if (removeThisObject || Object.keys(cleaned).length === 0) {
        //                     deferred.resolve(undefined);
        //                 } else {
        //                     deferred.resolve(cleaned);
        //                 }
        //             });
        //             $rootScope.loadingProgress = false;
        //             $rootScope.$evalAsync();
        //         } else {
        //             deferred.resolve(o);
        //             $rootScope.loadingProgress = false;
        //             $rootScope.$evalAsync();
        //         }
        //         return deferred.promise;
        //     }
        //     obj.payroll = vm.accountingAccount.payroll;
        //     obj.companiesRecord = vm.accountingAccount.companiesRecord;
        //     return recursiveClean(obj);
        // }


        init()
    }
})();
(function () {
    "use strict";
    angular
        .module("app.config")
        .controller("AccountingAccountsController", AccountingAccountsController);

    function AccountingAccountsController($scope, $log, $mdDialog, $document, $rootScope) {
        function init() {
            $log.log('selected', $scope.selected);
            $log.log('La lista')
        }

        $scope.copyAccount = function (ev) {
            $mdDialog.show({
                locals: {
                    account: $scope.selected,
                    scope: $scope
                },
                controllerAs: 'cpyctrl',
                controller: 'copyAccountController',
                templateUrl: 'app/main/config/views/accountingAccounts/copyAccount.html',
                parent: angular.element($document.body),
                targetEvent: ev
            }).then(function (answer) {
                $rootScope.$evalAsync();
                $log.debug(answer, 'importEmployeesModal answer');
            }).catch(function (err) {
                $log.debug('importEmployeesModal cancelled', err);
            });
        }

        init()
    }
})();
(function () {
    "use strict";

    angular
        .module("app.config")
        .controller("accountingAccountController", accountingAccountController);

    function accountingAccountController($scope, $log, $rootScope, $state, $filter, DataF, $timeout, $location, $anchorScroll, $q, errAlertS, AppF, ListsF, loopEachFilter, startAfterInitFilter) {
        var watchers = {};
        var initiated = false;
        $scope.ccList = [];
        $scope.ccListByPayroll = [];

        function init() {
            $scope.mode = AppF.readMode ? 'readMode' : 'editMode';
            var promises = [$scope.dataNeededPromise, $scope.statesObjsPromise, $scope.mainObjectLoaded];
            Promise.all(promises).then(function () {
                $scope.payrolls = AppF.permissionToAccessAllPayrolls ? $rootScope.L.allPayrolls : $rootScope.L.payrolls;
                promises = [];
                if ($scope.accountingAccount.companiesRecord) {
                    promises.push(loadCcsAndConcepts($scope.accountingAccount.companiesRecord));
                }
                return Promise.all(promises);
            }).then(function () {
                if ($scope.accountingAccount.process && $scope.accountingAccount.process[$scope.processSelected]) {
                    sortNodes($scope.accountingAccount.process[$scope.processSelected].debits);
                    sortNodes($scope.accountingAccount.process[$scope.processSelected].credits);
                }
            }).catch(errAlertS);

        }
        $scope.addLevel = function (type, obj) {
            if (angular.isUndefined($scope.accountingAccount.process)) {
                $scope.accountingAccount.process = {};
            }
            if (angular.isUndefined($scope.accountingAccount.process[$scope.processSelected])) {
                $scope.accountingAccount.process[$scope.processSelected] = {};
            }
            if (!angular.isArray($scope.accountingAccount.process[$scope.processSelected][obj])) {
                $scope.accountingAccount.process[$scope.processSelected][obj] = []
            }
            $scope.accountingAccount.process[$scope.processSelected][obj].unshift({ type: type });
        }

        function loadCcsAndConcepts(companiesRecord) {
            return new Promise(function (resolve, reject) {
                var allCcs = $rootScope.F.permissionToAccessAllPayrolls ? $rootScope.L.ccs : $rootScope.L.userCcs[AppF.profile.uid];
                var allPayrolls = $rootScope.F.permissionToAccessAllPayrolls ? $rootScope.L.allPayrolls : $rootScope.L.payrolls;
                var processCompany = [];
                var placesIds = [];
                var ccsByPayrollWithThisCompany = allPayrolls.reduce(function (current, payrollData) {
                    var flag = false;
                    var dataProcess = payrollData.processes;
                    for (var p in dataProcess) {
                        var data = dataProcess[p];
                        if (data.companiesRecord === companiesRecord) {
                            flag = true;
                            var addTo = processCompany.findIndex(function (item) { return item.$id === data.id }) === -1
                            if (addTo) {
                                processCompany.push({ name: p, $id: data.id });
                            }
                        }
                    }
                    if (flag) {
                        current.push({
                            payroll: payrollData,
                            ccs: allCcs.filter(function (ccData) {
                                var ccDataFlag = payrollData.$id === ccData.payroll;
                                if (ccDataFlag && placesIds.indexOf(ccData.place) === -1) {
                                    placesIds.push(ccData.place)
                                }
                                return ccDataFlag;
                            })
                        })
                    }
                    return current;
                }, [])

                var payrollIds = [];
                var query = { '_id:objectIds': { $in: placesIds } };
                var placeOfWorkRecords = {};
                var states = {};
                DataF.api.get('placesOfWorkRecords', query).then(function (resp) {
                    var statesIds = [];
                    if (angular.isArray(resp.data)) {
                        statesIds = resp.data.reduce(function (current, item) {
                            placeOfWorkRecords[item._id] = item;
                            if (current.indexOf(item.state_id) === -1) {
                                current.push(item.state_id);
                            }
                            return current;
                        }, [])
                    }
                    var query = { '_id:objectIds': { $in: statesIds } };
                    return DataF.api.get('states', query);
                }).then(function (resp) {
                    if (angular.isArray(resp.data)) {
                        states = resp.data.reduce(function (current, item) {
                            current[item._id] = item;
                            return current;
                        }, {})
                    }
                    var thisCcs = [];
                    var finalCcList = ccsByPayrollWithThisCompany.map(function (payrollData) {
                        payrollIds.push(payrollData.payroll.$id)
                        payrollData.ccs = payrollData.ccs.map(function (ccData) {
                            var stateKey = "S/E"
                            var placeOfWorkName = "S/P"
                            if (angular.isDefined(placeOfWorkRecords[ccData.place])) {
                                placeOfWorkName = placeOfWorkRecords[ccData.place].name;
                                if (angular.isDefined(states[placeOfWorkRecords[ccData.place].state_id])) {
                                    stateKey = states[placeOfWorkRecords[ccData.place].state_id].key;
                                }
                            }
                            ccData.placeOfWork = placeOfWorkName + ", " + stateKey;
                            ccData.payrollName = payrollData.payroll.name ? payrollData.payroll.name : 'S/N';
                            thisCcs.push(ccData);
                            return ccData;
                        }).filter(function (ccData) {
                            return ccData.valid === true;
                        })
                        return payrollData
                    }).filter(function (payrollData) {
                        return payrollData.ccs.length > 0;
                    });
                    $log.log(finalCcList, thisCcs)
                    $scope.ccList = thisCcs.reduce(function (current, item) {
                        current[item.$id] = item;
                        return current;
                    }, {});
                    $scope.selectCompaniesProcess = processCompany;
                    var fiscal = processCompany.filter(function (item) {
                        return item.$id === 'fiscal'
                    })
                    if (processCompany.length > 0) {
                        $scope.processSelected = fiscal.length > 0 ? fiscal[0].$id : processCompany[0].$id;
                        $log.log('Se selecciono el proceso: ' + $scope.processSelected);
                    }
                    $scope.ccListByPayroll = finalCcList.sort(function (a, b) {
                        var aValue = a.payroll.active ? 1 : 0;
                        var bValue = b.payroll.active ? 1 : 0;
                        return bValue - aValue;
                    });
                    $scope.cargos = [];
                    $scope.bonos = [];
                    payrollIds.push("global");//Se añade la opción global para que se carguen los conceptos globales
                    var query = { center: AppF.center, payroll: { $in: payrollIds }, $or: angular.toJson([{ allowNegative: { $exists: true } }, { notForAcc: { $exists: true } }, { forAcc: { $exists: true } }]), project: { allowNegative: 1, fid: 1, forAcc: 1, notForAcc: 1 } }
                    return DataF.api.get('concepts', query)
                }).then(function (resp) {
                    var bonos = [];
                    var cargos = [];

                    for (var i = 0; i < $scope.L.concepts.length; i++) {
                        var concept = $scope.L.concepts[i];
                        if (payrollIds.indexOf(concept.payroll) > -1) {
                            concept.fid = concept.$id;
                            var nature = concept.nature;
                            var conceptData = resp.data.find(function (item) {
                                return item.fid === concept.$id;
                            });
                            if (concept.payroll !== 'global') {
                                var payrollData = allPayrolls.find(function (item) {
                                    return item.$id === concept.payroll;
                                })
                                concept.payrollName = angular.isDefined(payrollData) ? payrollData.name : 'S/N';
                            }
                            if (angular.isDefined(conceptData)) {
                                concept.forAcc = conceptData.forAcc ? conceptData.forAcc : {};
                                concept.notForAcc = conceptData.notForAcc ? true : false;
                                concept.allowNegative = conceptData.allowNegative ? true : false;
                            } else {
                                concept.forAcc = {};
                                concept.notForAcc = false;
                            }
                            if ((nature === 'perception' && !concept.notForAcc) || concept.allowNegative || concept.forAcc.debit) {
                                cargos.push(concept);
                            }
                            if ((nature === 'deduction' && !concept.notForAcc) || concept.forAcc.credit) {
                                bonos.push(concept);
                            }
                        }
                    }

                    $scope.cargos = cargos.sort(function (a, b) {
                        return a.name.localeCompare(b.name)
                    });
                    $scope.bonos = bonos.sort(function (a, b) {
                        return a.name.localeCompare(b.name)
                    });
                    resolve(true);
                    $rootScope.$evalAsync();
                }).catch(function (error) {
                    errAlertS(error)
                    reject(error)
                })


            })
        }

        $scope.existData = function (idCompany) {
            if (angular.isDefined(idCompany)) {
                var query = { companiesRecord: idCompany };
                $scope.D.api.get("accountingAccounts", query).then(function (resp) {
                    if (resp.data.length > 0) {
                        $state.transitionTo($state.current, { accountingAccountId: resp.data[0]._id }, {
                            inherit: false,
                            notify: false
                        });
                        $scope.setMainObject(resp.data[0]);
                        $scope.F.addMode = false;
                    } else {
                        $state.transitionTo($state.current, { accountingAccountId: 'new' }, { inherit: false, notify: false });
                        $scope.setMainObject({ companiesRecord: idCompany });
                        $scope.F.addMode = true;
                    }
                    loadCcsAndConcepts(idCompany)
                }).catch(function (error) {
                    errAlertS(error)
                })
            }
        }

        function movePosition(indexCalculation, indexFields, operation) {
            var fields = indexCalculation;
            if ((indexFields === 0 && operation === -1) || (indexFields === (fields.length - 1) && operation === +1)) {
                return false;
            } else {
                moveFields(fields, indexFields, (indexFields + operation));
                var newHash = 'fields' + (indexFields + operation);
                if ($location.hash() !== newHash && operation === -1) {
                    $timeout(function () {
                        $location.hash(newHash);
                        $anchorScroll();
                        $location.hash('');
                        $location.replace();
                    }, 0, false)
                }
            }
            $scope.form.$setDirty();
        }
        function moveFields(arr, old_index, new_index) {
            if (new_index >= arr.length) {
                return false;
            }
            arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
            $scope.form.$setDirty();
            return arr;
        }

        $scope.movePosition = movePosition;


        $scope.addLayoutField = function () {
            $log.log('Se agrego un LayoutField')
            if (!angular.isArray($scope.accountingAccount.layoutFields)) {
                $scope.accountingAccount.layoutFields = [];
            }
            $scope.accountingAccount.layoutFields.push({ id: '', name: '', value: '' });
        }

        $scope.deleteField = function (index) {
            $scope.accountingAccount.layoutFields.splice(index, 1);
        }

        function getAccountString(account) {
            // return (account || '').toString().padStart(10, '0');
            return (account || '').toString();
        }

        function sortByAccount(a, b) {
            return getAccountString(a.account).localeCompare(getAccountString(b.account));
        }

        function sortNodes(nodes) {
            if (!angular.isArray(nodes)) {
                return
            }
            nodes.sort(sortByAccount);
            nodes.forEach(function (node) {
                if (angular.isArray(node.conditions)) {
                    node.conditions.sort(sortByAccount);
                }
                if (angular.isArray(node.children)) {
                    sortNodes(node.children);
                }
            });
        }



        startAfterInitFilter($scope, watchers, initiated, init);
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.reset-password', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_reset-password', {
            url      : '/pages/auth/reset-password',
            views    : {
                'main@'                                : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_reset-password': {
                    templateUrl: 'app/main/pages/auth/reset-password/reset-password.html',
                    controller : 'ResetPasswordController as vm'
                }
            },
            bodyClass: 'reset-password'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/reset-password');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.reset-password')
        .controller('ResetPasswordController', ResetPasswordController);

    /** @ngInject */
    function ResetPasswordController()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.login', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_login', {
            url: '/pages/auth/login',
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_login': {
                    templateUrl: 'app/main/pages/auth/login/login.html',
                    controller : 'LoginController as vm'
                }
            },
            bodyClass: 'login-v2'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/login');
    }

})();
(function () {
    'use strict';

    angular
        .module('app.pages.auth.login')
        .controller('LoginController', LoginController);

    /** @ngInject */
    function LoginController(
        $rootScope,
        $scope,
        $localStorage,
        $firebaseAuth,
        errAlertS,
        successAlertS,
        firebase
    ) {
        var self = this;
        $scope.auth = $firebaseAuth();
        $scope.credentials = {};
        $scope.rememberUser = ($localStorage.rememberUser) ? $localStorage.rememberUser : false;
        self.loading = false;
        var listWatchers = {};
        $scope.login = function () {
            self.loading = true;
            var persistenceType;
            if ($scope.rememberUser) {
                persistenceType = firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL);
            } else {
                persistenceType = firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION);
            }
            persistenceType.then(function () {
                $scope.auth.$signInWithEmailAndPassword($scope.credentials.email, $scope.credentials.password).then(function (user) {
                    $rootScope.$emit('loggedIn', { user: user });
                }).catch(function (err) {
                    errAlertS(err);
                    self.loading = false;
                });
            });
        };
        $scope.passwordReset = function () {
            firebase.auth().sendPasswordResetEmail($scope.credentials.email).then(function () {
                successAlertS('Correo mandado', 'Se envió un correo para restablecer contraseña a ' + $scope.credentials.email);
            }, errAlertS);
        };
        listWatchers.rememberUser = $scope.$watch('rememberUser', function (rememberUser) {
            $localStorage.rememberUser = (rememberUser) ? true : false;
        });
        listWatchers.finalListener = $scope.$on('$destroy', function () {
            for (var f in listWatchers) {
                if (listWatchers.hasOwnProperty(f)) {
                    listWatchers[f]();
                }
            }
        });
    }
})();
(function() {
    'use strict';

    angular
        .module('app.pages.auth.token-login', [])
        .config(config);

    /** @ngInject */
    function config(
        $stateProvider,
        $translatePartialLoaderProvider
    ) {
        // State
        $stateProvider.state('app.pages_auth_token-login', {
            url: '/pages/auth/token-login/:token/:rememberUser',
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'MainController as vm'
                },
                'content@app.pages_auth_token-login': {
                    templateUrl: 'app/main/pages/auth/token-login/token-login.html',
                    controller: 'TokenLoginController as vm'
                }
            },
            bodyClass: 'login-v2'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/token-login');
    }

})();
(function () {
    'use strict';

    angular
        .module('app.pages.auth.token-login')
        .controller('TokenLoginController', TokenLoginController);

    /** @ngInject */
    function TokenLoginController(
        $rootScope,
        $scope,
        $state,
        $localStorage,
        $firebaseAuth,
        $log,
        errAlertS,
        loginRedirectPath,
        firebase
    ) {
        var self = this;
        $scope.auth = $firebaseAuth();
        $scope.rememberUser = ($localStorage.rememberUser) ? $localStorage.rememberUser : false;
        self.loading = false;
        function login() {
            var token = $state.params.token;
            $localStorage.rememberUser = ($state.params.rememberUser && $state.params.rememberUser === 1) ? true : false;
            self.loading = true;
            var persistenceType;
            if ($localStorage.rememberUser) {
                persistenceType = firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL);
            } else {
                persistenceType = firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION);
            }
            persistenceType.then(function () {
                $scope.auth.$signInWithCustomToken(token).then(function (user) {
                    $log.log(user);
                    $rootScope.$emit('loggedIn', { user: user, token: token });
                }).catch(function (err) {
                    $log.log(err);
                    var error = 'No se pudo iniciar sesión por token';
                    if (err.code === 'auth/invalid-custom-token') {
                        error = 'Token invalido intente iniciar sesión nuevamente';
                    }
                    errAlertS(error);
                    self.loading = false;
                    $state.go(loginRedirectPath);
                });
            });
        }
        login();
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.register', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_register', {
            url      : '/pages/auth/register',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_register': {
                    templateUrl: 'app/main/pages/auth/register/register.html',
                    controller : 'RegisterController as vm'
                }
            },
            bodyClass: 'register'
        });

        // Translate
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/register');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.register')
        .controller('RegisterController', RegisterController);

    /** @ngInject */
    function RegisterController()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.lock', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_lock', {
            url      : '/pages/auth/lock',
            views    : {
                'main@'                      : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_lock': {
                    templateUrl: 'app/main/pages/auth/lock/lock.html',
                    controller : 'LockController as vm'
                }
            },
            bodyClass: 'lock'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/lock');


    }

})();
(function () {
    'use strict';

    angular
        .module('app.pages.auth.lock')
        .controller('LockController', LockController);

    /** @ngInject */
    function LockController(
        $sessionStorage,
        $rootScope,
        $scope,
        $state,
        $location,
        $localStorage,
        $firebaseAuth,
        $log,
        errAlertS,
        successAlertS,
        loginRedirectPath
    ) {
        $scope.auth = $firebaseAuth();
        // Data
        $scope.form = {
            username: ($scope.F.userBlocked) ? $scope.F.userBlocked.user : $scope.F.user.name
        };
        $scope.listWatchers = {};


        //console.log($scope.F.user);

        $scope.login = function (data) {
            $log.debug(data, 'login data');
            self.loading = true;
            $log.debug('login', $scope.credentials);
            $scope.auth.$signInWithEmailAndPassword($scope.F.userBlocked.user, $scope.form.password).then(function (user) {
                $rootScope.$emit('loggedIn', user);
            }).catch(function (err) {
                errAlertS(err);
                self.loading = false;
            });
        };

        $scope.listWatchers.rememberUser = $scope.$watch('rememberUser', function (rememberUser) {
            if (rememberUser !== null) {
                $localStorage.rememberUser = (rememberUser) ? true : false;
            }
        });

        var userL = $scope.$watch('F.userBlocked', function (user) {
            if (!user) {
                $log.debug('redirecting to login because no user', $scope.F.userBlocked);
                $state.go(loginRedirectPath);
                userL();
            }
        })


        $scope.listWatchers.finalListener = $scope.$on("$destroy", function () {
            for (var f in $scope.listWatchers) {
                //$log.debug('stopping $watcher', f);
                $scope.listWatchers[f]();
            }
            //stopDetailWatchersEvent();
        });


    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.forgot-password', [])
        .config(config);

    /** @ngInject */
    function config(
        $stateProvider, 
        $translatePartialLoaderProvider
    ){
        // State
        $stateProvider.state('app.pages_auth_forgot-password', {
            url: '/pages/auth/forgot-password',
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_forgot-password': {
                    templateUrl: 'app/main/pages/auth/forgot-password/forgot-password.html',
                    controller : 'ForgotPasswordController as vm'
                }
            },
            bodyClass: 'forgot-password'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/forgot-password');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.forgot-password')
        .controller('ForgotPasswordController', ForgotPasswordController);

    /** @ngInject */
    function ForgotPasswordController(
        $rootScope,
        $scope,
        $log,
        successAlertS,
        errAlertS
    ){
        /**@type DOM
         * @description Manda el link para resetear contraseña de Firebase
         * @param {string} email
         */
        function sendResetPassword(email){
            $log.debug('sendResetPassword called', email);
            $rootScope.loadingProgress = true;
            var secondaryConnection;
            try {
                secondaryConnection = firebase.app('secondary');
            } catch (e) {
                secondaryConnection = firebase.initializeApp(window.__env.FB_CONFIG, 'secondary');
            }
            secondaryConnection.auth().sendPasswordResetEmail(email).then(function() {
                successAlertS('Se mandó un correo a ' + email + ' con instrucciones para resetear su password');
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync(function(){
                    $log.debug('sendPasswordResetEmail finished');
                });
            }).catch(function(err) {
                errAlertS(err);
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
            });
        }

        $scope.sendResetPassword = sendResetPassword;
    }
})();
(function () {
    "use strict";

    angular
        .module("app.catalogs")
        .controller("zipCodeController", zipCodeController);

    function zipCodeController($scope, startAfterInitFilter, $log, $filter, $state, $http, errAlertS, $timeout) {
        var watchers = {};
        var initiated = false;

        function init() {
            if (!initiated) {
                $scope.mainObjectLoaded.then(function () {
                    $scope.getTowns($scope.zipCode.stateId);
                })
            }
        }

        $scope.getTowns = function (stateId) {
            if (stateId) {
                $scope.D.api.get('towns', { state_id: stateId, project: JSON.stringify({ name: "$name" }) }).then(function (response) {
                    $scope.towns = response.data;
                    $scope.$evalAsync()
                });
            } else {
                $scope.towns = []
            }
        }

        $scope.updateTown = function (selectedTownId) {
            var selected = $scope.towns.find(function (municipio) {
                return municipio._id === selectedTownId;
            });
            if (angular.isDefined(selected)) {
                $scope.zipCode.town = selected.name;
            } else {
                delete $scope.zipCode.town;
            }
        };

        $scope.updateKey = function (selectedStateId) {
            var selected = $scope.M.states.find(function (estado) {
                return estado._id === selectedStateId;
            });
            if (angular.isDefined(selected)) {
                $scope.zipCode.stateKey = selected.key;
            } else {
                delete $scope.zipCode.stateKey;
            }
        };
        $scope.setName = function () {
            var placeType = $scope.zipCode.placeType || '';
            console.log($scope.zipCode.placeType);
            var neighborhood = $scope.zipCode.neighborhood || '';
            var city = $scope.zipCode.city || '';
            var finalName = neighborhood;
            if (city) {
                finalName = placeType + ' ' + finalName + ', ' + city;
            } else {
                finalName = placeType + ' ' + finalName;
            }
            $scope.zipCode.name = finalName.trim();
        }

        startAfterInitFilter($scope, watchers, initiated, init);
    }
})();
(function () {
    'use strict';

    angular
        .module('app.catalogs')
        .controller('UmaController', UmaController);

    function UmaController($scope,$filter) {
        
        var listWatchers = {};
        listWatchers.year = $scope.$watch('umaRecord.year', function (year) {
            if (angular.isDefined(year) && year != '' && (year.toString()).length >= 4) {
                $scope.minEnroleDate = new Date('01-01-' + year);
                $scope.maxEnroleDate = new Date('12-31-' + year);
            }          
            if(angular.isDefined($scope.umaRecord) && angular.isDefined($scope.umaRecord.applicationDate)){
                if(angular.isDefined($scope.maxEnroleDate) && angular.isDefined($scope.minEnroleDate)){
                    if($scope.umaRecord.applicationDate > $scope.maxEnroleDate.valueOf() || $scope.umaRecord.applicationDate < $scope.minEnroleDate.valueOf()){
                        delete $scope.umaRecord.applicationDate;
                    }
                }   
            }           
        });
        $scope.$on("$destroy", function () {
            for (var f in listWatchers) {
                if(listWatchers.hasOwnProperty(f)){
                    listWatchers[f]();
                    delete listWatchers[f];
                }     
            }
        });
    }
}());
(function () {
    'use strict';

    angular
        .module('app.catalogs')
        .controller('StateController', StateController);

    function StateController($scope, startAfterInitFilter, errAlertS, $log, $rootScope) {
        $scope.selectedItem = "";
        $scope.searchText = "";
        $scope.listWatchers = {};
        $scope.perceptions = [];
        $scope.active = false;
        var initiated = false;
        $scope.querySearch = function (search) {
            if (!search) {
                return $scope.perceptions;
            }
            var lower = search.toLowerCase();
            return $scope.perceptions.filter(function (item) {
                return (item.key && item.key.toLowerCase().includes(lower)) || (item.name && item.name.toLowerCase().includes(lower));
            });
        };
        $scope.transformChip = function (data) {
            return data.$id;
        }
        function init() {
            var needed = [
                $scope.dataNeededPromise,
                $scope.statesObjsPromise,
                $scope.mainObjectLoaded
            ];
            Promise.all(needed).then(function () {
                if (!initiated) {
                    initiated = true;
                    if (angular.isUndefined($scope.state)) {
                        $scope.state = {};
                    } else {
                        transformArrayToObj($scope.state.discountsIsn);
                        transformArrayToObjPerson($scope.state.discountsIsnForPerson);
                        transformArrayToObjConcept($scope.state.discountsIsnForConcept);
                    }
                }
                if (!angular.isArray($scope.state.exemptIsnConcepts)) {
                    $scope.state.exemptIsnConcepts = [];
                }
                var payrollsName = {};
                $scope.perceptions = $rootScope.L.concepts.filter(function (item) {
                    return item.nature === 'perception';
                }).map(function (item) {
                    if (item.payroll !== 'global') {
                        if (angular.isUndefined(payrollsName[item.payroll])) {
                            var thisPayroll = $rootScope.L.allPayrolls.find(function (itemP) {
                                return itemP.$id === item.payroll;
                            })
                            payrollsName[item.payroll] = angular.isDefined(thisPayroll) ? thisPayroll.name : "N/E";
                        }
                        item.payrollName = payrollsName[item.payroll];
                    }
                    return item;
                });
            }).catch(function (error) {
                errAlertS(error);
            });
        }

        $scope.addFields = function () {
            if (angular.isUndefined($scope.fields)) {
                $scope.fields = [];
            }
            $scope.fields.push({ limit: "", percentage: "" });
        }

        $scope.addFieldsPerson = function () {
            if (angular.isUndefined($scope.fieldsPerson)) {
                $scope.fieldsPerson = [];
            }
            $scope.fieldsPerson.push({ persons: "", disccount: "" });
        }
        $scope.addFieldsConcept = function () {
            if (angular.isUndefined($scope.fieldsConcept)) {
                $scope.fieldsConcept = [];
            }
            $scope.fieldsConcept.push({ concept: "", value: "" });
        }

        $scope.deleteFields = function (fields, fieldIndex) {
            fields.splice(fieldIndex, 1);
            transformObjToArray(fields);
        }

        $scope.deleteFieldsPerson = function (fields, fieldIndex) {
            fields.splice(fieldIndex, 1);
            transformObjToArrayPerson(fields);
        }

        $scope.deleteFieldsConcept = function (fields, fieldIndex) {
            fields.splice(fieldIndex, 1);
            transformObjToArrayConcept(fields);
            $rootScope.$evalAsync();
        }


        $scope.createFields = function (field, fields, fieldIndex, form) {
            if (angular.isDefined(fieldIndex)) {
                var index = fields.findIndex(function (value) {
                    return angular.lowercase(value.limit) === angular.lowercase(field.limit);
                });
                if (index !== fieldIndex) {
                    form["limit" + fieldIndex].$setValidity('validationError', false);
                    $scope.active = true;
                } else {
                    form["limit" + fieldIndex].$setValidity('validationError', true);
                    $scope.active = false;
                }
            }
            if (!$scope.active && angular.isDefined(field.limit) && angular.isDefined(field.percentage)) {
                transformObjToArray(fields);
            }
        }

        $scope.createFieldsPerson = function (field, fields, fieldIndex, form) {
            if (angular.isDefined(fieldIndex)) {
                var index = fields.findIndex(function (value) {
                    return angular.lowercase(value.persons) === angular.lowercase(field.persons);
                });
                if (index !== fieldIndex) {
                    form["persons" + fieldIndex].$setValidity('validationError', false);
                    $scope.active = true;
                } else {
                    form["persons" + fieldIndex].$setValidity('validationError', true);
                    $scope.active = false;
                }
            }
            if (!$scope.active && angular.isDefined(field.persons) && angular.isDefined(field.disccount)) {
                transformObjToArrayPerson(fields);
            }
        }

        $scope.createFieldsConcept = function (field, fields, fieldIndex, form) {
            if (angular.isDefined(fieldIndex)) {
                var index = fields.findIndex(function (value) {
                    return angular.lowercase(value.concept) === angular.lowercase(field.concept);
                });
                if (index !== fieldIndex) {
                    form["concept" + fieldIndex].$setValidity('validationError', false);
                    $scope.active = true;
                } else {
                    form["concept" + fieldIndex].$setValidity('validationError', true);
                    $scope.active = false;
                }
            }
            if (!$scope.active && angular.isDefined(field.concept) && angular.isDefined(field.value)) {
                transformObjToArrayConcept(fields);
            }
        }

        function transformObjToArray(fields) {
            var obj = {};
            for (var f = 0; f < fields.length; f++) {
                obj[fields[f].limit] = fields[f].percentage;
            }
            $scope.state.discountsIsn = obj;
        }


        function transformObjToArrayPerson(fields) {
            var obj = {};
            for (var f = 0; f < fields.length; f++) {
                obj[fields[f].persons] = fields[f].disccount;
            }
            $scope.state.discountsIsnForPerson = obj;
        }
        function transformObjToArrayConcept(fields) {
            var obj = {};
            for (var f = 0; f < fields.length; f++) {
                obj[fields[f].concept] = fields[f].value;
            }
            $scope.state.discountsIsnForConcept = obj;
        }


        function transformArrayToObj(fieldsObj) {
            if (angular.isObject(fieldsObj)) {
                var fields = [];
                for (var f in fieldsObj) {
                    fields.push({ limit: f, percentage: fieldsObj[f] });
                }
                $scope.fields = fields;
            }
        }

        function transformArrayToObjPerson(fieldsObj) {
            if (angular.isObject(fieldsObj)) {
                var fields = [];
                for (var f in fieldsObj) {
                    fields.push({ persons: f, disccount: fieldsObj[f] });
                }
                $scope.fieldsPerson = fields;
            }
        }

        function transformArrayToObjConcept(fieldsObj) {
            if (angular.isObject(fieldsObj)) {
                var fields = [];
                for (var f in fieldsObj) {
                    fields.push({ concept: f, value: fieldsObj[f] });
                }
                $scope.fieldsConcept = fields;
            }
        }



        startAfterInitFilter($scope, $scope.listWatchers, initiated, init);
    }
}());
(function () {
    'use strict';

    angular
        .module('app.catalogs')
        .controller('placesOfWorkRecordController', placesOfWorkRecordController);

    function placesOfWorkRecordController($scope, $rootScope, lowercaseFilter, combineArraysOfObjectFilter) {
        var initiated = false;
        $scope.active = false;
        function init() {
            if (!initiated) {
                initiated = true;
                if(angular.isUndefined($scope.placesOfWorkRecord)){
                    $scope.placesOfWorkRecord = {};
                }else{
                    transformArrayToObj($scope.placesOfWorkRecord.accFields);
                }
            }
        }
        $scope.addFields = function() {
            if(angular.isUndefined($scope.fields)){
                $scope.fields = [];
            }
            $scope.fields.push({name: "", account: ""});
        }
        $scope.deleteFields = function(fields, fieldIndex) {
            fields.splice(fieldIndex, 1);
            transformObjToArray(fields);
        }
        $scope.createFields = function(field, fields, fieldIndex, form){
            if(angular.isDefined(fieldIndex)){
                var index = fields.findIndex(function(value){
                    return angular.lowercase(value.name) === angular.lowercase(field.name);
                });
                if(index !== fieldIndex){
                    form["name" + fieldIndex].$setValidity('validationError', false);
                    $scope.active = true;
                }else{
                    form["name" + fieldIndex].$setValidity('validationError', true);
                    $scope.active = false;
                }
            }
            if(!$scope.active && angular.isDefined(field.name) && angular.isDefined(field.account)){
                transformObjToArray(fields);
            }
        }
        function transformObjToArray(fields){
            var obj = {};
            for(var f = 0; f < fields.length; f++){
                obj[fields[f].name] = fields[f].account;
            }
            $scope.placesOfWorkRecord.accFields = obj;
        }
        function transformArrayToObj(fieldsObj) {
            if(angular.isObject(fieldsObj)){
                var fields = [];
                for(var f in fieldsObj){
                    fields.push({name: f, account: fieldsObj[f]});
                }
                $scope.fields = fields;
            }
        }
        if ($scope.mDetailFinished) {
            init();
        } else {
            var mainObjectLoaded = $rootScope.$on('mDetailFinished', function () {
                mainObjectLoaded();
                init();
            });
        }
    }
}());
(function () {
  "use strict";

  angular
    .module("app.catalogs")
    .controller("placeTypeController", placeTypeController);

  function placeTypeController($scope, startAfterInitFilter, $log, $filter, $state, $http, errAlertS, $timeout) {
    var watchers = {};
    var initiated = false;
    var firstEmployeeLoaded = false;
    $scope.employeeSelected = { data: { name: 'sin seleccionar' } };
    function init() {
    }
    $scope.cargarPlaceType = function () {
      $scope.D.api.get("placeTypes", {
        project: JSON.stringify({ name: 1 })
      }).then(function (response) {
        $scope.data = response.data
        console.log('datos del sitios', dataPlace)
      }).catch(function (error) {
        $log.log('error al cargar los movimientos', error)
      })
    }
    startAfterInitFilter($scope, watchers, initiated, init);
  }
})();
(function () {
    'use strict';

    angular
        .module('app.catalogs')
        .controller('paymentFormController', paymentFormController);

    function paymentFormController($scope, lowercaseFilter) {
        $scope.validate = function(value){
            var name = lowercaseFilter(value);
            $scope.paymentForm.key = name;
        }
    }
}());
(function () {
    'use strict';

    angular
        .module('app.catalogs')
        .controller('nfdController', nfdController);

    function nfdController($scope) {
        
        var listWatchers = {};
        listWatchers.year = $scope.$watch('nfdRecord.year', function (year) {
            if (angular.isDefined(year) && year != '' && (year.toString()).length >= 4) {
                $scope.minEnroleDate = new Date('01-01-' + year);
                $scope.maxEnroleDate = new Date('12-31-' + year);
            }  
            if(angular.isDefined($scope.nfdRecord) && angular.isDefined($scope.nfdRecord.applicationDate)){
                if(angular.isDefined($scope.maxEnroleDate) && angular.isDefined($scope.minEnroleDate)){
                    if($scope.nfdRecord.applicationDate > $scope.maxEnroleDate.valueOf() || $scope.nfdRecord.applicationDate < $scope.minEnroleDate.valueOf()){
                        delete $scope.nfdRecord.applicationDate;
                    }
                } 
            }           
        });
        $scope.$on("$destroy", function () {
            for (var f in listWatchers) {
                if(listWatchers.hasOwnProperty(f)){
                    listWatchers[f]();
                    delete listWatchers[f];
                }     
            }
        });
    }
}());
(function () {
    'use strict';
    angular
        .module('app.catalogs')
        .controller('MinimunWageRecordsController', MinimunWageRecordsController);

    function MinimunWageRecordsController($scope) {
        $scope.clearArray = function (record) {
            var newRecord = angular.fromJson(angular.toJson(record));
            delete newRecord.valuesArray;
            $scope.R.goToDetail(newRecord);
        };
    }

}());
(function () {
    'use strict';

    angular
        .module('app.catalogs')
        .controller('MinimumWageRecordController', MinimumWageRecordController);

    function MinimumWageRecordController($scope,$filter) {
        
        var listWatchers = {};
        listWatchers.year = $scope.$watch('minimumWageRecord.year', function (year) {
            if (angular.isDefined(year) && year != '' && (year.toString()).length >= 4) {
                $scope.minEnroleDate = new Date('01-01-' + year);
                $scope.maxEnroleDate = new Date('12-31-' + year);
            }       
            if(angular.isDefined($scope.minimumWageRecord) && angular.isDefined($scope.minimumWageRecord.applicationDate)){
                if($scope.minimumWageRecord.applicationDate > $scope.maxEnroleDate.valueOf() || $scope.minimumWageRecord.applicationDate < $scope.minEnroleDate.valueOf()){
                    delete $scope.minimumWageRecord.applicationDate;
                }
            }           
        });
        
        $scope.$on("$destroy", function () {
            for (var f in listWatchers) {
                if(listWatchers.hasOwnProperty(f)){
                    listWatchers[f]();
                    delete listWatchers[f];
                }     
            }
        });
    }
}());
(function () {
    'use strict';

    angular
        .module('app.catalogs')
        .controller('FilterController', FilterController);

    function FilterController($scope, $rootScope, $log, $timeout) {
        function init() {
            if(angular.isUndefined($scope.filter.params)){
                $scope.filter.params = [];
            }
        }
        function newParams(chip) {
            var params = chip.charAt(0).toUpperCase()  + chip.slice(1);
            return params;
        }
        function validate(value, form, fromId){
            if(value.length > 1){
                $rootScope.D.api.get("one/filters/", { "id" : { "$regex" : value , "$options" : "i"}}).then(function(resp){
                    var data = resp.data.data;
                    var alreadyExist = false;
                    $timeout(function(){
                        if(data.length > 0){
                            if(data[0]._id !== fromId){
                                alreadyExist = true;
                            }
                        }
                        if(alreadyExist){
                            form.id.$setValidity('validationError', false);
                        }else{
                            form.id.$setValidity('validationError', true);
                        }
                    },1000) 
                }).catch(function(error){
                    $log.error(error);
                }); 
            }        
        }
        if ($scope.mDetailFinished) {
            init();
        } else {
            var mainObjectLoaded = $rootScope.$on('mDetailFinished', function () {
                mainObjectLoaded();
                init();
            });
        }
        $scope.validate = validate;
        $scope.newParams = newParams;
    }
}());
(function () {
    'use strict';

    angular
        .module('app.catalogs')
        .controller('geoZoneController', geoZoneController);

    function geoZoneController($scope, Slug, uppercaseFilter) {
        
        var listWatchers = {};
        listWatchers.key = $scope.$watch('geoZone.name', function (name, nameOld) {
            if(geoZone){
                if(angular.isDefined(name) && name != ''){
                    $scope.geoZone.key = uppercaseFilter(Slug.slugify(name));
                }else{
                    if(name == undefined && nameOld != undefined){
                        delete $scope.geoZone.key;
                    }
                }
            }      
        });
        $scope.$on("$destroy", function () {
            for (var f in listWatchers) {
                if(listWatchers.hasOwnProperty(f)){
                    listWatchers[f]();
                    delete listWatchers[f];
                }     
            }
        });
    }
}());
(function() {
    'use strict';

    angular
        .module('app.core')
        .controller('DashboardClientsController', DashboardClientsController);

    /** @ngInject */
    function DashboardClientsController(
        $scope, 
        Dashboard
        ) {
        var root = $scope.F.root;

        // Data
        $scope.dashboard = Dashboard;

        $scope.widget1 = $scope.dashboard.widget1;
        $scope.widget2 = $scope.dashboard.widget2;
        $scope.widget3 = $scope.dashboard.widget3;
        $scope.widget4 = $scope.dashboard.widget4;
        $scope.widget5 = {
            title: $scope.dashboard.widget5.title,
            mainChart: {
                config: {
                    refreshDataOnly: true,
                    deepWatchData: true
                },
                options: {
                    chart: {
                        type: 'multiBarChart',
                        color: ['#03a9f4', '#b3e5fc'],
                        height: 420,
                        margin: {
                            top: 8,
                            right: 16,
                            bottom: 32,
                            left: 32
                        },
                        clipEdge: true,
                        groupSpacing: 0.3,
                        reduceXTicks: false,
                        stacked: true,
                        duration: 250,
                        x: function(d) {
                            return d.x;
                        },
                        y: function(d) {
                            return d.y;
                        },
                        yAxis: {
                            tickFormat: function(d) {
                                return d;
                            }
                        },
                        legend: {
                            margin: {
                                top: 8,
                                bottom: 32
                            }
                        },
                        controls: {
                            margin: {
                                top: 8,
                                bottom: 32
                            }
                        },
                        tooltip: {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data: []
            },
            days: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
            ranges: $scope.dashboard.widget5.ranges,
            currentRange: '',
            changeRange: function(range) {
                $scope.widget5.currentRange = range;

                /**
                 * Update main chart data by iterating through the
                 * chart dataset and separately adding every single
                 * dataset by hand.
                 *
                 * You MUST NOT swap the entire data object by doing
                 * something similar to this:
                 * $scope.widget.mainChart.data = chartData
                 *
                 * It would be easier but it won't work with the
                 * live updating / animated charts due to how d3
                 * works.
                 *
                 * If you don't need animated / live updating charts,
                 * you can simplify these greatly.
                 */
                angular.forEach($scope.dashboard.widget5.mainChart, function(chartData, index) {
                    $scope.widget5.mainChart.data[index] = {
                        key: chartData.key,
                        values: chartData.values[range]
                    };
                });
            },
            init: function() {
                // Run this function once to initialize widget

                /**
                 * Update the range for the first time
                 */
                $scope.widget5.changeRange('TW');
            }
        };

        // Widget 6
        $scope.widget6 = {
            title: $scope.dashboard.widget6.title,
            mainChart: {
                config: {
                    refreshDataOnly: true,
                    deepWatchData: true
                },
                options: {
                    chart: {
                        type: 'pieChart',
                        color: ['#f44336', '#9c27b0', '#03a9f4', '#e91e63'],
                        height: 400,
                        margin: {
                            top: 0,
                            right: 0,
                            bottom: 0,
                            left: 0
                        },
                        donut: true,
                        clipEdge: true,
                        cornerRadius: 0,
                        labelType: 'percent',
                        padAngle: 0.02,
                        x: function(d) {
                            return d.label;
                        },
                        y: function(d) {
                            return d.value;
                        },
                        tooltip: {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data: []
            },
            footerLeft: $scope.dashboard.widget6.footerLeft,
            footerRight: $scope.dashboard.widget6.footerRight,
            ranges: $scope.dashboard.widget6.ranges,
            currentRange: '',
            changeRange: function(range) {
                $scope.widget6.currentRange = range;

                /**
                 * Update main chart data by iterating through the
                 * chart dataset and separately adding every single
                 * dataset by hand.
                 *
                 * You MUST NOT swap the entire data object by doing
                 * something similar to this:
                 * $scope.widget.mainChart.data = chartData
                 *
                 * It would be easier but it won't work with the
                 * live updating / animated charts due to how d3
                 * works.
                 *
                 * If you don't need animated / live updating charts,
                 * you can simplify these greatly.
                 */
                angular.forEach($scope.dashboard.widget6.mainChart, function(data, index) {
                    $scope.widget6.mainChart.data[index] = {
                        label: data.label,
                        value: data.values[range]
                    };
                });
            },
            init: function() {
                // Run this function once to initialize widget

                /**
                 * Update the range for the first time
                 */
                $scope.widget6.changeRange('TW');
            }
        };

        // Widget 7
        $scope.widget7 = {
            title: $scope.dashboard.widget7.title,
            ranges: $scope.dashboard.widget7.ranges,
            customers: $scope.dashboard.widget7.customers,
            currentRange: 'T'
        };

        // Methods

        //////////

        // Initialize Widget 5
        $scope.widget5.init();

        // Initialize Widget 6
        $scope.widget6.init();
    }
})();
(function () {
    'use strict';

    angular
        .module('app.catalogs')
        .controller('BankAccountsController', BankAccountsController);

    function BankAccountsController($scope, $mdDialog, confirmConfig, $log, successAlertS, errAlertS, $filter, DataF, $rootScope) {
        function deleteBanks(e){
            var banks = $scope.selected;
            var $f = $filter;
            var catalogs = $scope.F.active.menuObjName;
            var listForDeleteBanks = [];
            var updates = {};
            $scope.F.root.child('catalogs/payrolls/collection').once('value').then(function(snap){
                if(snap.exists()){
                    var allPayrolls = snap.val();
                    for(var i = 0; i < banks.length; i++){
                        var banksIdPayroll = banks[i]._id;
                        $f('loopEach')(allPayrolls, function (payroll, payrollId) {
                            var processes = payroll.processes;
                            $f('loopEach')(processes, function(process, processId){
                                if(processes[processId] && processes[processId].bankAccounts){
                                    var banksId = process.bankAccounts;
                                    var indexBanks = banksId.indexOf(banksIdPayroll);
                                    if(indexBanks !== -1){
                                        updates[payrollId+"/processes/"+processId+"/bankAccounts/"+indexBanks] = null;
                                        listForDeleteBanks.push({bankId: banksIdPayroll, bankName: banks[i].name, payrollId: payrollId, payrollName: payroll.data.name, process: processId});
                                    } 
                                }                                
                            });
                        });
                    }
                }
                var message = "";
                var head = "";
                var notification = "";
                var title = 'Quiere borrar ' + $scope.selected.length + ' Mis Banco(s)?';
                if(!$scope.F.safeDelete.banksAccounts){
                    head = "No podrá recuperar sus datos";
                }else{
                    head = 'Podrá recuperar sus datos en la papelera';
                }
                if(listForDeleteBanks.length > 0){   
                    if($scope.selected.length > 1){
                        head = "<p>Eliminar estos " + $scope.selected.length + " bancos afectaría la(s) siguiente(s) nómina(s)</p>";
                    }else{
                        head = "<p>Eliminar este banco afectaría la(s) siguiente(s) nómina(s)</p>";
                    }
                    message += "<ul>";
                    for(var m = 0; m < listForDeleteBanks.length; m++){
                        var msj = listForDeleteBanks[m];
                        message += "<li>";
                        message += "El banco " + msj.bankName + " se encuentra en la nómina " + msj.payrollName + " del proceso " + msj.process;
                        message += "</li>";
                    }
                    message += "</ul>";
                }
                notification = head + message;
                $mdDialog.show($mdDialog.confirm(confirmConfig)
                    .title(title)
                    .htmlContent(notification)
                    .ariaLabel('Deleting')
                    .targetEvent(e)
                    .ok('Borrar')
                    .cancel('Cancelar'))
                    .then(function () {
                        $log.debug('Deleting: ', $scope.selected);
                        $rootScope.loadingProgress = true;
                        var count = 0;
                        for(var b = 0; b < banks.length; b++){
                            deleteBanksAccounts(banks[b]._id).then(function(){
                                count++;
                                var active = (count === banks.length)? true: false;
                                if(listForDeleteBanks.length > 0){
                                    $scope.F.root.child('catalogs/payrolls/collection').update(updates).then(function(){
                                        if(active){
                                            successAlertS('Se borro ' + banks.length + ' registro(s) de banco(s)');
                                            $rootScope.$emit('mongoCatalogsDeleted', {
                                                name: catalogs,
                                                data: banks
                                            });
                                        }   
                                    }).catch(function(error){
                                        $log.error(error);
                                        errAlertS("<p>Ocurrió un error al momento de eliminar los banco(s) de la(s) nómina(s), favor de hacerlo manualmente</p>"+ message);
                                    })
                                }else{
                                    if(active) successAlertS('Se borro ' + banks.length + ' registro(s) de banco(s)');     
                                }
                                $scope.getThem();
                                $scope.selected = [];
                            }).catch(function(error){
                                errAlertS(error);
                            }) 
                        }
                    }, function () {
                        $log.debug('Deleting Cancelled');
                    });
            }).catch(function(error){
                $log.error(error);
            })
        }
        function deleteBanksAccounts(id){
            return DataF.api.delete('bankAccounts/' + id);
        }
        $scope.deleteBanks = deleteBanks;
    }    
})();
(function () {
    'use strict';

    angular
        .module('app.catalogs')
        .controller('BankAccountController', BankAccountController);

    function BankAccountController($scope, $rootScope, $log, DataF) {
        var detailWatchers = {};
        var initiated = false;
        var watcherInit = false;

        $scope.fields = [];
        $scope.configLayouts = [];

        function init() {
            if (!initiated) {
                $scope.bankAccount.center = $scope.F.center;
                initiated = true;
                initWatcher();
            }
            if (angular.isDefined($scope.bankAccount.bank)) {
                $scope.onBankChange($scope.bankAccount.bank, $scope.bankAccount.isSpei);
            } else {
                $scope.thisBank = [];
                $scope.configLayouts = [];
                $scope.fields = [];
            }
        }
        function getForForm(fields) {
            var thisFields = [];
            var selectedLayout = $scope.bankAccount ? $scope.bankAccount.idlayoutBank : undefined;

            if (!angular.isArray(fields)) return thisFields;

            for (var i = 0; i < fields.length; i++) {
                var f = fields[i];
                if (!f.layoutSelection && !f.askfor) {
                    thisFields.push(f);
                    continue;
                }
                if (angular.isDefined(selectedLayout) && f.layoutSelection === selectedLayout) {
                    thisFields.push(f);
                }
            }

            return thisFields;
        }

        function initWatcher() {
            if (watcherInit) return;
            watcherInit = true;
            detailWatchers.bank = $scope.$watch('bankAccount.bank', function (newVal, oldVal) {
                if (!newVal || newVal === oldVal) return;
                $scope.onBankChange(newVal, $scope.bankAccount && $scope.bankAccount.isSpei);
            });
            detailWatchers.isSpei = $scope.$watch('bankAccount.isSpei', function (newVal, oldVal) {
                if (newVal === oldVal) return;

                var bankId = $scope.bankAccount && $scope.bankAccount.bank;
                if (angular.isDefined(bankId)) {
                    $scope.onBankChange(bankId, newVal);
                } else {
                    $scope.loadFields();
                }
            });
            detailWatchers.layout = $scope.$watch('bankAccount.idlayoutBank', function (newVal, oldVal) {
                if (newVal === oldVal) return;
                $scope.loadFields();
            });
        }

        function stopWatcher() {
            for (var f in detailWatchers) {
                if (detailWatchers.hasOwnProperty(f)) {
                    detailWatchers[f]();
                    delete detailWatchers[f];
                }
            }
        }

        detailWatchers.stopWatcher = $rootScope.$on('stopListWatchers', function () {
            stopWatcher();
        });

        detailWatchers.destroy = $scope.$on('$destroy', function () {
            stopWatcher();
        });

        function toSpeiFlag(isSpei) {
            return isSpei === true ? true : undefined;
        }

        function filterLayoutsBySpei(layouts, isSpei) {
            var spei = toSpeiFlag(isSpei);
            if (!angular.isArray(layouts)) return [];
            return layouts.filter(function (l) {
                return l.spei === spei;
            });
        }

        function ensureSelectedLayoutIsValid(layouts) {
            var current = $scope.bankAccount && $scope.bankAccount.idlayoutBank;
            if (!current) return;

            var exists = layouts.some(function (l) { return l.idLayout === current; });
            if (!exists) {
                $scope.bankAccount.idlayoutBank = undefined;
            }
        }

        $scope.onBankChange = function (idBank, isSpei) {
            var banks = $scope.M.banks || [];
            $scope.thisBank = banks.filter(function (item) {
                return item._id === idBank;
            });
            $scope.loadFields();
            var query = { '_id:objectIds': { $in: [idBank] } };
            return DataF.api.get('banks', query).then(function (resp) {
                var layouts = (resp.data && resp.data[0] && resp.data[0].configLayouts) ? resp.data[0].configLayouts : [];
                var filtered = filterLayoutsBySpei(layouts, isSpei);
                $scope.configLayouts = filtered;
                ensureSelectedLayoutIsValid(filtered);
                $scope.loadFields();
            });
        };

        $scope.loadFields = function () {
            if ($scope.thisBank && $scope.thisBank[0] && $scope.thisBank[0].fields) {
                $scope.fields = getForForm($scope.thisBank[0].fields);
                $scope.$evalAsync();
            } else {
                $scope.fields = [];
            }
        };

        if ($scope.mDetailFinished) {
            init();
        } else {
            var mainObjectLoaded = $rootScope.$on('mDetailFinished', function () {
                mainObjectLoaded();
                init();
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.catalogs')
        .controller('BankController', BankController);

    function BankController($scope, $rootScope) {
        var initiated = false;
        $scope.active = false;
        function init() {
            if (!initiated) {
                initiated = true;
                if (angular.isUndefined($scope.bank)) {
                    $scope.bank = {};
                } else {
                    transformArrayToObj($scope.bank.extraFields);
                }
            }
        }
        $scope.addFields = function () {
            if (angular.isUndefined($scope.fields)) {
                $scope.fields = [];
            }
            $scope.fields.push({ name: "", value: "" });
        }
        $scope.deleteFields = function (fields, fieldIndex) {
            fields.splice(fieldIndex, 1);
            transformObjToArray(fields);
        }
        $scope.createFields = function (field, fields, fieldIndex, form) {
            if (angular.isDefined(fieldIndex)) {
                var index = fields.findIndex(function (value) {
                    return angular.lowercase(value.name) === angular.lowercase(field.name);
                });
                if (index !== fieldIndex) {
                    form["name" + fieldIndex].$setValidity('validationError', false);
                    $scope.active = true;
                } else {
                    form["name" + fieldIndex].$setValidity('validationError', true);
                    $scope.active = false;
                }
            }
            if (!$scope.active && angular.isDefined(field.name) && angular.isDefined(field.value)) {
                transformObjToArray(fields);
            }
        }
        function transformObjToArray(fields) {
            var obj = {};
            for (var f = 0; f < fields.length; f++) {
                obj[fields[f].name] = fields[f].value;
            }
            $scope.bank.extraFields = obj;
        }
        function transformArrayToObj(fieldsObj) {
            if (angular.isObject(fieldsObj)) {
                var fields = [];
                for (var f in fieldsObj) {
                    fields.push({ name: f, value: fieldsObj[f] });
                }
                $scope.fields = fields;
            }
        }
        if ($scope.mDetailFinished) {
            init();
        } else {
            var mainObjectLoaded = $rootScope.$on('mDetailFinished', function () {
                mainObjectLoaded();
                init();
            });
        }
    }
}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .controller('XmlSatMetasController', XmlSatMetasController);

    function XmlSatMetasController($scope, nameOfLFilter, $q, $rootScope, ApiV3F, $document, successAlertS, AppF, errAlertS, $log, $mdDialog, ListsF) {
        $scope.requestDataModal = function (ev) {
            $mdDialog.show({
                controller: function (scope) {
                    scope.params = {
                        emitted: true,
                        cancel: true
                    }
                    scope.companiesRecords = ListsF.companiesRecords;
                    scope.closeDialog = function () {
                        $mdDialog.cancel();
                    }
                    scope.makeRequest = function (params) {
                        $rootScope.loadingProgress = true;
                        var promises = [];
                        var companiesRecordsData = [];
                        var companiesNames = {};
                        for (var p = 0; p < params.companiesRecordIds.length; p++) {
                            companiesNames[params.companiesRecordIds[p]] = nameOfLFilter(params.companiesRecordIds[p], ListsF.companiesRecords, 'Sin Nombre')
                            promises.push(AppF.root.child('lists/companiesRecords/active/true/' + params.companiesRecordIds[p]).once('value'))
                        }
                        Promise.all(promises).then(function (snaps) {
                            var errors = [];
                            for (var p = 0; p < params.companiesRecordIds.length; p++) {
                                var thisSnap = snaps[p];
                                if (!thisSnap.exists()) {
                                    errors.push('La empresa ' + companiesNames[params.companiesRecordIds[p]] + ' no se encuentra activa o no tiene los archivos fiel');
                                } else {
                                    companiesRecordsData.push({ id: params.companiesRecordIds[p], data: thisSnap.val() });
                                }
                            }
                            promises = [];
                            for (var c = 0; c < companiesRecordsData.length; c++) {
                                var companiesRecordData = companiesRecordsData[c];
                                if (!(companiesRecordData.data.cerFiel && companiesRecordData.data.keyFiel && companiesRecordData.data.passFiel)) {
                                    errors.push('La empresa ' + companiesNames[companiesRecordData.id] + ' no tiene todos los archivos fiel para consultar la información de');
                                    companiesRecordData.ignore = true;
                                } else {
                                    var thisParams = {}
                                    var endDate = moment(params.startDate).subtract(1, 'day');
                                    thisParams.companiesRecordId = companiesRecordData.id;
                                    thisParams.center = AppF.center;
                                    thisParams.status = 9;
                                    thisParams.endDate = endDate.valueOf();
                                    thisParams.endFormat = endDate.format('DD-MM-YYYY');
                                    thisParams.delOthFields = true;
                                    if (params.emitted) {
                                        var emittedObj = Object.assign({ xmlStatus: 'emitted', query: { companiesRecordId: companiesRecordData.id, xmlStatus: 'emitted' } }, angular.fromJson(angular.toJson(thisParams)));
                                        promises.push($scope.D.api.upsert('xmlSatMetas', emittedObj))
                                    }
                                    if (params.cancel) {
                                        var cancelObj = Object.assign({ xmlStatus: 'cancelled', query: { companiesRecordId: companiesRecordData.id, xmlStatus: 'cancelled' } }, angular.fromJson(angular.toJson(thisParams)));
                                        promises.push($scope.D.api.upsert('xmlSatMetas', cancelObj))
                                    }
                                }
                            }
                            if (errors.length > 0) {
                                errAlertS(errors);
                            }
                            return Promise.all(promises);
                        }).then(function () {
                            promises = [];
                            for (var c = 0; c < companiesRecordsData.length; c++) {
                                var companiesRecordData = companiesRecordsData[c];
                                if (!companiesRecordData.ignore) {
                                    var task = {
                                        type: "xml-sat-metas-queue",
                                        action: "retrySatXmlProcessing",
                                        data: {
                                            dateEnd: params.endDate,
                                            companiesRecordId: companiesRecordData.id
                                        }
                                    };
                                    if (params.emitted) {
                                        var emittedObj = Object.assign({}, angular.fromJson(angular.toJson(task)));
                                        emittedObj.data.xmlStatus = 'emitted';
                                        promises.push(ApiV3F.post('queue/add', emittedObj))
                                    }
                                    if (params.cancel) {
                                        var cancelObj = Object.assign({}, angular.fromJson(angular.toJson(task)));
                                        cancelObj.data.xmlStatus = 'cancelled';
                                        promises.push(ApiV3F.post('queue/add', cancelObj))
                                    }
                                }
                            }
                            return Promise.all(promises);
                        }).then(function () {
                            successAlertS('Se realizaron solicitudes correctamente, procesando....')
                            $mdDialog.hide();
                        }).catch(errAlertS).then(function () {
                            $rootScope.loadingProgress = false;
                            $rootScope.$evalAsync();
                        })
                    }

                },
                templateUrl: 'app/main/clients/views/xmlSatMetas/dialogs/request.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: false
            }).then(function (answer) {
                $log.debug(answer, 'requestData answer');
            }, function () {
                $log.debug('requestData cancelled');
            });
        };


        $scope.retrySatResponse = function (selected, event) {
            $mdDialog.show({
                templateUrl: 'app/main/clients/views/xmlSatMetas/dialogs/responseXmlDialog.html',
                controller: 'responseXmlController',
                controllerAs: 'rpsCtrl',
                locals: {
                    selected: $scope.selected
                },
                parent: angular.element($document.body),
                targetEvent: event
            });
        };

    }
})();
(function () {
    'use strict';

    angular
        .module('app.clients')
        .controller('SyncEmployeeRecordsController', SyncEmployeeRecordsController);


    function SyncEmployeeRecordsController($scope, errAlertS, successAlertS, $rootScope, ApiV3F) {

        $scope.resync = function () {
            try {
                var tasks = [];
                var selected = $scope.selected;
                var timestamp = new Date().valueOf()
                for (var s = 0; s < selected.length; s++) {
                    var task = {
                        action: 'syncApp',
                        type: 'integrations-queue',
                        data: {
                            catalog: 'employees',
                            firm: selected[s].firm,
                            id: selected[s].fid,
                            timestamp: timestamp,
                            app: $scope.F.filters[$scope.F.active.menuName]['sync.execute']
                        }
                    }
                    tasks.push(ApiV3F.post('/queue/add', task))
                }
                $rootScope.loadingProgress = true;
                Promise.all(tasks).then(function () {
                    successAlertS('Se intentaran sincronizar nuevamente')
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                }).catch(function (error) {
                    errAlertS(error);
                    $rootScope.loadingProgress = false
                    $rootScope.$evalAsync()
                })
            } catch (error) {
                errAlertS(error);
            }


        }

    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .controller('XmlBillsRequestsController', XmlBillsRequestsController);

    function XmlBillsRequestsController($scope, $q, $rootScope, $localStorage, errAlertS, $log) {
        $scope.mainXmlBillsRequest;
        $scope.getThemPagination = function () {
            getThem(false, 'from getThemPagination');
        };
        function compareBills(companiesRecord, year, month) {
            return new Promise(function (resolve) {
                $scope.D.models.action('bills', 'compareBills', { companiesRecord: companiesRecord, year: year, month: month }).then(function (done) {
                    resolve({});
                }).catch(function (error) {
                    resolve({ error: error })
                })
            });
        }
        function getThem(dontShowLoading, from) {
            return $q(function (resolve, reject) {
                $rootScope.loadingProgress = true;
                var filters = $scope.F.filters[$scope.F.active.menuName];
                var promises = [];
                $log.log(filters);
                if (filters.companiesRecord && filters['year:int'] && filters['month:int'] && filters.companiesRecord !== 'all' && filters['year:int'] !== 'all' && filters['month:int'] !== 'all') {
                    promises.push(compareBills(filters.companiesRecord, filters['year:int'], filters['month:int']))
                }
                Promise.all(promises).then(function (data) {
                    if (data.length > 0 && data[0].error) {
                        errAlertS(data[0].error)
                    }
                    $rootScope.loadingProgress = true;
                    return $scope.$parent.getThem(false, from);
                }).then(function () {
                    resolve(true);
                    $rootScope.loadingProgress = false;
                }).catch(function (err) {
                    $rootScope.loadingProgress = false;
                    errAlertS(err);
                    reject(err);
                });
            });
        }
        $scope.getThem = getThem;
    }
})();
(function () {
  "use strict";

  angular
    .module("app.employees")
    .controller("RpIdseRecordsController", RpIdseRecordsController);

  function RpIdseRecordsController($scope, $log, errAlertS, $window, startAfterInitFilter, userHasPermissionFilter, AppF) {
    var listWatchers = {};
    var initiated = false;
    $scope.showPassword = false;
    $scope.watchPassword = false
    function init() {
      $scope.watchPassword = userHasPermissionFilter(AppF.groupsOfUser, AppF.permissions, 'watchPassword', 'idse-panel.rpIdseRecords');
      $scope.downloadFiles = userHasPermissionFilter(AppF.groupsOfUser, AppF.permissions, 'downloadFiles', 'idse-panel.rpIdseRecords');
    }
    $scope.downloadFileRp = $scope.D.files.downloadFileRp;
    startAfterInitFilter($scope, listWatchers, initiated, init);
  }
})();

(function () {
  "use strict";

  angular
    .module("app.employees")
    .controller("RpIdseRecordController", RpIdseRecordController);

  function RpIdseRecordController($scope, userHasPermissionFilter, startAfterInitFilter, $log, $rootScope, errAlertS, $q, ApiV2F, successAlertS, AppF, ListsF, getFromObjectFilter, clearObjectFilter) {
    var watchers = {};
    var initiated = false;
    $scope.cerFile = [];
    $scope.keyFile = [];
    $scope.showPassword = false;
    $scope.watchPassword = false
    $scope.passwordDeleted = false;
    var originalFiles = {};
    function init() {
      var promises = [$scope.dataNeededPromise, $scope.statesObjsPromise, $scope.mainObjectLoaded];
      Promise.all(promises).then(function () {
        $scope.watchPassword = userHasPermissionFilter(AppF.groupsOfUser, AppF.permissions, 'watchPassword', 'idse-panel.rpIdseRecords');
        $scope.downloadFiles = userHasPermissionFilter(AppF.groupsOfUser, AppF.permissions, 'downloadFiles', 'idse-panel.rpIdseRecords');
        if ($scope.rpIdseRecord) {
          var cerFile = getFromObjectFilter($scope.rpIdseRecord, "cerFile");
          if (cerFile) {
            originalFiles.cerFile = cerFile;
          }
          var keyFile = getFromObjectFilter($scope.rpIdseRecord, "keyFile");
          if (keyFile)
            originalFiles.keyFile = keyFile;
        }
      }).catch(errAlertS);
    }
    function uploadFile(file, id, fileName) {
      return new Promise(function (resolve, reject) {
        var finalRef = "rpIdseRecords/" + id + "/" + fileName;
        var fileRef = firebase.storage().ref(finalRef);
        var uploadTask = fileRef.put(file);
        uploadTask.then(function (snapshot) {
          resolve({ url: snapshot.downloadURL, path: finalRef });
        }).catch(reject);
      })
    }
    function deleteFile(filePath) {
      $log.log(filePath);
      return firebase.storage().ref(filePath).delete();
    }
    function deleteFiles(thisFiles) {
      var promises = [];
      for (var keyFile in originalFiles) {
        if (originalFiles.hasOwnProperty(keyFile) && (angular.isUndefined(thisFiles[keyFile]) || thisFiles[keyFile].path !== originalFiles[keyFile])) {
          promises.push(deleteFile(originalFiles[keyFile]));
        }
      }
      return Promise.all(promises);
    }
    function uploadFiles(id) {
      return new Promise(function (resolve, reject) {
        try {
          var promises = {};
          if ($scope.cerFile.length > 0) {
            promises.cerFile = uploadFile($scope.cerFile[0].lfFile, id, $scope.rpIdseRecord.isCerFile ? 'cerFile.cer' : 'cerFile.pfx')
          } else if (!$scope.rpIdseRecord.cerFile) {
            throw new Error('No se encontró el certificado');
          }
          if ($scope.keyFile.length > 0) {
            promises.keyFile = uploadFile($scope.keyFile[0].lfFile, id, 'keyFile.key')
          } else if ($scope.rpIdseRecord.isCerFile && (!$scope.rpIdseRecord.keyFile)) {
            throw new Error('No se encontró la llave');
          }
          var thisPromise;
          if (Object.keys(promises).length > 0) {
            thisPromise = $q.all(promises)
          } else {
            thisPromise = Promise.all([]);
          }
          var thisResp;
          thisPromise.then(function (resp) {
            thisResp = angular.isArray(resp) ? {} : resp;
            return deleteFiles(resp)
          }).then(function () {
            resolve(thisResp)
          }).catch(reject);
        } catch (error) {
          reject(error);
        }
      })
    }
    function save() {
      try {
        $rootScope.loadingProgress = true;
        ApiV2F.get('api/rpIdseRecords', { rp: $scope.rpIdseRecord.rp }).then(function (resp) {
          var records = resp.data.filter(function (item) {
            var flag = true;
            if ($scope.rpIdseRecord._id) {
              flag = ($scope.rpIdseRecord._id !== item._id);
            }
            return flag;
          });
          if (records.length > 0) {
            throw new Error('Este registro patronal ya ha sido dado de alta');
          }
          return uploadFiles($scope.rpIdseRecord.rp);
        }).then(function (uploadData) {
          for (var key in uploadData) {
            $scope.rpIdseRecord[key] = uploadData[key].path;
          }
          if (!$scope.rpIdseRecord.isCerFile) {
            delete $scope.rpIdseRecord.keyFile;
          }
          var promise;
          if ($scope.rpIdseRecord._id) {
            var id = $scope.rpIdseRecord._id;
            var data = clearObjectFilter($scope.rpIdseRecord)
            if (data.created) {
              data.updated = $scope.D.getTimeObject();
            } else {
              data.created = $scope.D.getTimeObject();
            }
            promise = ApiV2F.put('api/rpIdseRecords/' + id, data);
          } else {
            promise = ApiV2F.post('api/rpIdseRecords', $scope.rpIdseRecord);
          }
          return promise
        }).then(function () {
          successAlertS('Se ha guardo el registro con éxito')
          $rootScope.$emit('mongoCatalogCreated', {
            name: 'rpIdseRecord',
            data: $scope.rpIdseRecord
          });
          $scope.R.goToList();
          $rootScope.loadingProgress = false;
          $rootScope.$evalAsync(function () {
            $log.debug($scope.rpIdseRecord, 'saved on Mongo');
          });
        }).catch(function (err) {
          errAlertS(err);
          $rootScope.loadingProgress = false;
        })
      } catch (error) {
        errAlertS(error);
        $rootScope.loadingProgress = false;
      }
    }

    function filesChange() {
      try {
        $rootScope.loadingProgress = true;
        $scope.rpIdseRecord.isCerFile = false;
        $scope.disabledNames = true;
        if ($scope.cerFile.length > 0) {
          var cerFile = $scope.cerFile[0];
          var nameArray = cerFile.lfFile.name.split('.');
          var extension = nameArray[nameArray.length - 1];
          $scope.rpIdseRecord.isCerFile = false;
          if (extension === 'cer') {
            $scope.rpIdseRecord.isCerFile = true;
          }
          var promises = [];
          if ($scope.rpIdseRecord.isCerFile || $scope.rpIdseRecord.password) {
            var params = { file: $scope.cerFile[0].lfFile };
            if (!$scope.rpIdseRecord.isCerFile) {
              params.password = $scope.rpIdseRecord.password;
            }
            promises.push(ApiV2F.post('files/getDataFromCertificate', params, true))
          }
          Promise.all(promises).then(function (resp) {
            if (resp.length > 0) {
              var thisResp = resp[0].data;
              if (thisResp.valid_to) {
                $scope.rpIdseRecord.cerExpiration = moment(new Date(thisResp.valid_to)).valueOf();
                if (!$scope.rpIdseRecord.isCerFile) {
                  if (thisResp.subject.businessCategory && (!$scope.rpIdseRecord.rp)) {
                    $scope.rpIdseRecord.rp = thisResp.subject.businessCategory;
                  }
                  if (thisResp.subject.O && (!$scope.rpIdseRecord.companiesRecordName) && thisResp.subject.O.toLowerCase().indexOf('instituto mexicano del seguro social')) {
                    $scope.rpIdseRecord.companiesRecordName = thisResp.subject.O;
                  }
                }
              }
            }
            $rootScope.loadingProgress = false;
            $rootScope.$evalAsync();
          }).catch(function (error) {
            errAlertS(error);
            $rootScope.loadingProgress = false;
            $rootScope.$evalAsync();
          })
        } else {
          $rootScope.loadingProgress = false;
        }
      } catch (error) {
        errAlertS(error);
        $rootScope.loadingProgress = false;
      }
    }
    function getCompanyName() {
      var thisRp = $scope.rpIdseRecord.rp
      if (angular.isString(thisRp) && thisRp.length === 11) {
        $rootScope.loadingProgress = true;
        var thisRps = ListsF.rps || [];
        var rpFounded = thisRps.find(function (item) {
          return item.rp === thisRp;
        })
        var promises = [];
        if (angular.isDefined(rpFounded) && rpFounded.companiesRecord) {
          promises.push(AppF.root.child('catalogs/companiesRecords/collection/' + rpFounded.companiesRecord + '/data/businessNameShort').once('value'))
        }
        Promise.all(promises).then(function (resp) {
          if (resp.length > 0) {
            var nameCompany = resp[0].val();
            if (angular.isDefined(nameCompany)) {
              $scope.rpIdseRecord.companiesRecordName = nameCompany;
            }
          }
          $rootScope.loadingProgress = false;
          $rootScope.$evalAsync();
        }).catch(function (error) {
          errAlertS(error);
          $rootScope.loadingProgress = false;
        })
      }
    }
    function setShowPassword(val) {
      $scope.showPassword = val;
    }
    function unsetPassword() {
      delete $scope.rpIdseRecord.password;
      $scope.passwordDeleted = true;
    }
    $scope.removeFieldFile = function (field) {
      delete $scope.rpIdseRecord[field];
      $scope.form.$setDirty()
    }
    $scope.unsetPassword = unsetPassword
    $scope.setShowPassword = setShowPassword;
    $scope.save = save;
    $scope.add = save;
    $scope.filesChange = filesChange;
    $scope.getCompanyName = getCompanyName;
    $scope.downloadFileRp = $scope.D.files.downloadFileRp;
    startAfterInitFilter($scope, watchers, initiated, init);
  }
})();

(function () {
    'use strict';

    angular
        .module('app.clients')
        .controller('RpController', RpController);

    function RpController(
        $scope,
        $rootScope,
        startAfterInitFilter,
        $log,
        successAlertS,
        errAlertS,
        checkIfEnableFilter,
        $timeout,
        userHasPermissionFilter,
        AppF,
        $state
    ) {
        var initiated = false;
        $scope.listWatchers = {};
        function disableAlert(enable, companiesRecords) {
            if (enable) {
                $rootScope.loadingProgress = true;
                var route = 'catalogs/companiesRecords/collection/' + companiesRecords + '/active';
                checkIfEnableFilter(route).then(function (response) {
                    if (!response) {
                        $scope.rp.active = false;
                        errAlertS("No se puede activar el registro patronal porque está desactivada la empresa en la que pertenece");
                    }
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                }).catch(function (error) {
                    errAlertS(error);
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                });
            } else {
                errAlertS('Al desactivar el registro patronal se desactivaran los centros de costos relacionados');
            }
        }
        function disableCcs(doIt) {
            return new Promise(function (resolve, reject) {
                if (doIt) {
                    try {
                        var ccsQuery = $scope.F.root.child('catalogs/ccs/collection').orderByChild('data/rp_id').equalTo($scope.rp.$id).once("value");
                        ccsQuery.then(function (snapshot) {
                            var updates = {};
                            snapshot.forEach(function (childSnapshot) {
                                var id = childSnapshot.key;
                                updates[id + '/valid'] = false;
                            })
                            //console.log(updates);
                            //resolve(updates);
                            $scope.F.root.child('catalogs/ccs/collection').update(updates).then(function () {
                                resolve(updates);
                            }).catch(function (error) {
                                reject(error);
                            })
                        }).catch(function (error) {
                            reject(error)
                        })
                    } catch (error) {
                        reject(error);
                    }
                } else {
                    resolve(true);
                }
            })
        }
        function saveRp(rp) {
            $rootScope.loadingProgress = true;
            $scope.save(rp, 1).then(function () {
                disableCcs(!rp.active).then(function () {
                    successAlertS('Se guardó Registro Patronal con éxito');
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync(function () {
                        $log.debug('save rp finished');
                        $scope.R.goToList();
                    });
                }).catch(function (error) {
                    errAlertS(error);
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                })
            })
        }
        $scope.selectedCompany = 0;
        $scope.hasCompanySelected = false;
        $scope.setCompanySelected = function (company) {
            $scope.hasCompanySelected = true;
            $scope.companySelected = company;
            $scope.$evalAsync();
            $timeout(function () { }, 0, false);
        }

        $scope.addItem = function (property, obj) {
            console.log('si esta pasando por esta funcion', $scope.rp)
            if (angular.isArray($scope.rp[property])) {
                $scope.rp[property].push(obj)
            } else {
                $scope.rp[property] = [obj];
            }
            $scope.selectedCompany = 1;
            $rootScope.$evalAsync();
            $timeout(function () { }, 0, false);
        }
        $scope.removeItem = function (index, property) {
            if (angular.isArray($scope.rp[property]) && $scope.rp[property].length > 0) {
                $scope.rp[property].splice(index, 1);
                $scope.$evalAsync(function () { });
                $timeout(function () { }, 0, false);
            }
        };
        $scope.setLastCompany = function () {
            if ($scope.rp.companies.length == 1) {
                $scope.setCompanySelected($scope.rp.companies[0]);
            }
        }
        $scope.listWatchers.stateid = $scope.$watch('companySelected.state_id', function (stateId) {
            if (angular.isDefined(stateId) && stateId !== '') {
                $scope.M.getTownsByState(stateId);
            }
        });

        $scope.showPass = false;
        $scope.passwordVisibilityPass = function () {
            $scope.showPass = !$scope.showPass;
        };

        function init() {
            $scope.rp.center = $scope.F.center;
            $scope.rp.client = $scope.F.profile.firm;
            $scope.verPasswordInfonavit = userHasPermissionFilter(AppF.groupsOfUser, AppF.permissions, 'verPasswordInfonavit', $scope.F.active.menuItem);
            var needed = [
                $scope.dataNeededPromise,
                $scope.statesObjsPromise
            ];
            Promise.all(needed).then(function () {
                $scope.rp.center = $scope.F.center;
                if (!angular.isArray($scope.rp.companies)) {
                    $scope.rp.companies = [];
                }
                if (angular.isArray($scope.rp.companies) && $scope.rp.companies.length > 0) {
                    $scope.setCompanySelected($scope.rp.companies[0]);
                }
                $rootScope.$evalAsync();
                $timeout(function () { }, 0, false);
            }).catch(function (error) {
                errAlertS(error);
            });
        }
        $scope.disableAlert = disableAlert;
        $scope.saveRp = saveRp;
        startAfterInitFilter($scope, $scope.listWatchers, initiated, init);
    }
})();
(function () {
    'use strict';
    angular
        .module('app.clients')
        .controller('ReportsController', ReportsController);
    function ReportsController($scope, errAlertS, ApiV3F, ApiV2F, $mdDialog, AppF, ListsF, CatalogsF, $document, $log, getFromObjectFilter, loopEachFilter, successAlertS, $q, orderByFilter, filterFilter) {
        $scope.editReports = {}
        var objData = {
            payrolls: function (data) {
                return new Promise(function (resolve, reject) {
                    var payrolls = (AppF.permissionToAccessAllPayrolls) ? ListsF.allPayrolls : ListsF.payrolls;
                    if (angular.isArray(payrolls)) {
                        resolve(payrolls);
                    } else {
                        reject('No se encontró el listado de los datos solicitados de ' + data.list);
                    }
                });
            },
            departments: function (data) {
                return new Promise(function (resolve, reject) {
                    var promises = [];
                    if (AppF.permissionToAccessAllPayrolls) {
                        var thisQuery = [{ q: 'orderByChild', v: 'center' }, { q: 'equalTo', v: function () { return AppF.center; } }];
                        promises.push(ListsF.loadList('departments', '/lists/departments/all', false, 'array', 'report-departments-all-' + AppF.center, thisQuery))
                    } else if (angular.isArray(ListsF.payrolls)) {
                        for (var p = 0; p < ListsF.payrolls.length; p++) {
                            var thisPayroll = ListsF.payrolls[p];
                            promises.push(ListsF.loadList('departments', '/lists/departments/payrolls/' + thisPayroll.$id, false, 'array', 'report-departments-byPayroll-' + thisPayroll.$id))
                        }
                    }
                    Promise.all(promises).then(function (resp) {
                        var allDepartments = [];
                        for (var r = 0; r < resp.length; r++) {
                            allDepartments = allDepartments.concat(resp[r])
                        }
                        resolve(allDepartments)
                    }).catch(reject)
                })
            },
            incidencesTypes: function (data) {
                return new Promise(function (resolve) {
                    var thisList = ListsF.incidencesTypes.slice();
                    var thisIncidencesTypes = [];
                    var payrolls = (AppF.permissionToAccessAllPayrolls) ? ListsF.allPayrolls : ListsF.payrolls;
                    for (var t = 0; t < thisList.length; t++) {
                        var incidenceType = thisList[t];
                        if (incidenceType.payroll === 'global') {
                            incidenceType.name = incidenceType.name + '(GLOBAL)';
                            thisIncidencesTypes.push(incidenceType);
                        } else {
                            var founded = payrolls.find(function (item) {
                                return item.$id === incidenceType.payroll;
                            });
                            if (angular.isDefined(founded)) {
                                var thisIncidenceType = angular.fromJson(angular.toJson(incidenceType));
                                thisIncidenceType.name = thisIncidenceType.name + '(' + founded.name + ')';
                                thisIncidencesTypes.push(thisIncidenceType);
                            }
                        }
                    }
                    resolve(thisIncidencesTypes);
                });
            },
            concepts: function (data) {
                return new Promise(function (resolve) {
                    resolve(ListsF.concepts.filter(function (item) {
                        return item.type !== 'incidenceType';
                    }));
                });
            },
            companiesRecords: function (data) {
                return new Promise(function (resolve, reject) {
                    var thisQuery = [{ q: 'orderByChild', v: 'center' }, { q: 'equalTo', v: function () { return AppF.center; } }];
                    ListsF.loadList('companiesRecords', 'catalogs/companiesRecords/collection', false, 'array', 'report-companiesRecordId', thisQuery).then(function (data) {
                        var companiesRecords;
                        if (!AppF.permissionToAccessAllPayrolls) {
                            var allCompaniesRecords = [];
                            ListsF.payrolls.map(function (item) {
                                loopEachFilter(item.processes, function (data) {
                                    if (data.companiesRecord && allCompaniesRecords.indexOf(data.companiesRecord) === -1) {
                                        allCompaniesRecords.push(data.companiesRecord);
                                    }
                                });
                            });
                            companiesRecords = data.filter(function (item) {
                                return allCompaniesRecords.indexOf(item.$id) > -1;
                            });
                        } else {
                            companiesRecords = data;
                        }
                        resolve(companiesRecords);
                    }).catch(reject);
                });
            },
            getMyPayrolls: function () {
                var payrolls;
                if (!AppF.permissionToAccessAllPayrolls) {
                    payrolls = ListsF.payrolls.map(function (item) {
                        return item.$id;
                    });
                }
                return payrolls;
            },
            getMyCcs: function () {
                var ccs;
                if (!AppF.permissionToAccessAllPayrolls) {
                    ccs = ListsF.ccs.map(function (item) {
                        return item.$id;
                    });
                }
                return ccs;
            }
        };
        $scope.downloadReport = function (ev, data) {
            if (angular.isDefined(data.params)) {
                getLists(data).then(function (lists) {
                    $mdDialog.show({
                        templateUrl: 'app/main/clients/views/reports/dialogs/reports.html',
                        locals: {
                            data: data,
                            fromList: lists
                        },
                        controller: function (scope, data, fromList, $q, $rootScope) {
                            $log.log('Este es el controller')
                            scope.searchText = '';
                            scope.data = data;
                            scope.autoCompleteOptions = {};
                            scope.fromList = fromList;
                            scope.reports = {};
                            //Seccion para fecha supongo
                            for (var i = 0; i < data.params.length; i++) {
                                if (data.params[i].listType === 'autocomplete') {
                                    if (data.params[i].query) {
                                        scope.autoCompleteOptions[data.params[i].field] = [];
                                    } else {
                                        scope.reports[data.params[i].field] = [];
                                    }
                                }
                            }
                            scope.filterList = function filterList(list, sort, search, paramsToWatch, reportData) {
                                return new Promise(function (resolve, reject) {
                                    try {
                                        var thisList = angular.isArray(list) ? list : [];
                                        var searchParams = [];
                                        if (search) {
                                            searchParams.push(search)
                                        }
                                        if (angular.isArray(paramsToWatch) && angular.isDefined(reportData)) {
                                            for (var p = 0; p < paramsToWatch.length; p++) {
                                                var thisValue = reportData[paramsToWatch[p]]
                                                if (angular.isDefined(thisValue)) {
                                                    if (angular.isArray(thisValue)) {
                                                        searchParams = searchParams.concat(thisValue)
                                                    } else {
                                                        searchParams.push(thisValue)
                                                    }
                                                }
                                            }
                                        }
                                        if (angular.isArray(searchParams)) {
                                            for (var a = 0; a < searchParams.length; a++) {
                                                if (searchParams[a]) {
                                                    thisList = filterFilter(thisList, searchParams[a])
                                                }
                                            }
                                        }
                                        console.log(searchParams)
                                        if (sort) {
                                            thisList = orderByFilter(thisList, sort)
                                        }
                                        resolve(thisList);
                                    } catch (error) {
                                        reject(error);
                                    }
                                })
                            }
                            scope.transformChip = function (chip, getObject) {
                                if (chip && angular.isObject(chip) && (chip.$id || chip.id) && !getObject) {
                                    return chip.$id;
                                }
                                return chip;
                            };
                            scope.setModelFromAutocomplete = function (fieldName, chipsObj, objField) {
                                scope.reports[fieldName] = [];
                                for (var c = 0; c < chipsObj.length; c++) {
                                    if (chipsObj[c].hasOwnProperty(objField)) {
                                        scope.reports[fieldName].push(chipsObj[c][objField]);
                                    }
                                }
                            };
                            scope.autocompleteListM = function (search, catalog, fields, extraQuerys, transformation, includeCenterQuery, includePayrollQuery) {
                                var thisExtraQuerys = extraQuerys;
                                if (extraQuerys.hasOwnProperty('project') && angular.isArray(extraQuerys.project)) {
                                    var thisProject = thisExtraQuerys.project;
                                    thisExtraQuerys.project = {};
                                    for (var e = 0; e < thisProject.length; e++) {
                                        thisExtraQuerys.project[thisProject[e].field] = thisProject[e].from;
                                    }
                                }
                                if (includeCenterQuery) {
                                    thisExtraQuerys.center = AppF.center;
                                }
                                if (includePayrollQuery && !AppF.permissionToAccessAllPayrolls) {
                                    thisExtraQuerys.payroll = objData.getMyPayrolls();
                                }
                                return $q(function (resolve, reject) {
                                    $scope.D.api.autocompleteMongo(search, catalog, fields, thisExtraQuerys).then(function (items) {
                                        for (var i = 0; i < items.length; i++) {
                                            loopEachFilter(transformation, function (data, index) {
                                                if (!items[i].hasOwnProperty(index)) {
                                                    items[i][index] = getFromObjectFilter(items[i], data, 'S/N');
                                                }
                                            });
                                        }
                                        resolve(items);
                                        $rootScope.loadingProgress = false;
                                        $rootScope.$evalAsync(function () {
                                            $log.debug('getThem finished');
                                        });
                                    }).catch(function (err) {
                                        errAlertS(err);
                                        reject(err);
                                        $rootScope.loadingProgress = false;
                                        $rootScope.$evalAsync();
                                    });
                                });
                            };
                            scope.cancel = function () {
                                $mdDialog.cancel();
                            };
                            scope.checkDate = function () {
                                var from = scope.reports.from ? moment(scope.reports.from).startOf('day') : null;
                                var to = scope.reports.to ? moment(scope.reports.to).startOf('day') : null;
                                scope.fromMinDate = null;
                                scope.fromMaxDate = null;
                                scope.toMinDate = null;
                                scope.toMaxDate = null;
                                if (from) {
                                    scope.toMinDate = from.toDate();
                                    scope.toMaxDate = from.clone().add(1, 'year').endOf('day').toDate();
                                }
                                if (to) {
                                    scope.fromMaxDate = to.clone().endOf('day').toDate();
                                    scope.fromMinDate = to.clone().subtract(1, 'year').startOf('day').toDate();
                                }
                                if (from && to) {
                                    var maxTo = from.clone().add(1, 'year').endOf('day');
                                    if (to.isAfter(maxTo)) scope.reports.to = maxTo.toDate();
                                    var minFrom = to.clone().subtract(1, 'year').startOf('day');
                                    if (from.isBefore(minFrom)) scope.reports.from = minFrom.toDate();
                                }
                            };
                            scope.downloadManyReports = function (params) {
                                params.filename = data.filename;
                                if ($scope.filenameFn.hasOwnProperty(params.filename)) {
                                    params.filename = $scope.filenameFn[params.filename](params)
                                }
                                $scope.downloadManyReports(data, params);
                            };

                            scope.months = [
                                { value: '01', label: "Enero" },
                                { value: '02', label: "Febrero" },
                                { value: '03', label: "Marzo" },
                                { value: '04', label: "Abril" },
                                { value: '05', label: "Mayo" },
                                { value: '06', label: "Junio" },
                                { value: '07', label: "Julio" },
                                { value: '08', label: "Agosto" },
                                { value: '09', label: "Septiembre" },
                                { value: '10', label: "Octubre" },
                                { value: '11', label: "Noviembre" },
                                { value: '12', label: "Diciembre" }
                            ];
                            scope.years = [];
                            var currentYear = new Date().getFullYear();
                            for (var d = currentYear; d >= 2000; d--) {
                                scope.years.push(d);
                            }
                            scope.yearsAnniversary = [];
                            var todayYear = new Date().getFullYear();
                            var startYear = todayYear - 2
                            var endYear = todayYear + 10;  // Diez años adelante: 2025 + 10 = 2035
                            // 4. Creamos el bucle para generar los años en orden ascendente.
                            // El bucle irá desde 2023 hasta 2035.
                            for (var year = startYear; year <= endYear; year++) {
                                scope.yearsAnniversary.push(year);
                            }
                            scope.$watchGroup(['reports.month', 'reports.year'], function (newValues) {
                                var monthsd = newValues;
                                var year = newValues;
                                if (angular.isDefined(monthsd) && year) {
                                    scope.reports.from = new Date(year, monthsd, 1);  // Genera una fecha válida
                                }
                            });
                            scope.$watch("reports", function (newVal) {
                                console.log(newVal)
                            }, true)
                        },
                        parent: angular.element($document.body),
                        targetEvent: ev,
                        escapeToClose: false
                    });
                }).catch(function (error) {
                    errAlertS(error);
                });
            } else {
                $scope.downloadManyReports(data);
            }
        };
        $scope.filenameFn = {
            getAccumulatedFileName: function (params) {
                var company = ListsF.companiesRecords.find(function (item) {
                    return item.$id === params.companiesRecordId;
                });
                var name = 'Acumulados por Compañia';
                if (angular.isDefined(company)) {
                    name = company.name + '_' + name;
                }
                return name;
            },
            getAbsencesFilenameRep: function (params) {
                var company = ListsF.companiesRecords.find(function (item) {
                    return item.$id === params.companiesRecordId;
                });
                var name = 'REP_AUSENTISMOS';
                if (angular.isDefined(company)) {
                    name = name + '_' + company.name;
                }
                var start = moment(params.from).format('DDMMYYYY');
                var end = moment(params.to).format('DDMMYYYY');
                name = name + '_' + start + '_' + end;
                return name;
            },
            getAnniversaryFilenameRep: function (params) {
                var company = ListsF.companiesRecords.find(function (item) {
                    return item.$id === params.companiesRecordId;
                });
                var name = 'REP_ANIVERSARIOS';
                if (angular.isDefined(company)) {
                    name = name + '_' + company.name;
                }
                var start = moment(params.from).format('DDMMYYYY');
                var end = moment(params.to).format('DDMMYYYY');
                name = name + '_' + start + '_' + end;
                return name;
            }
        };
        $scope.downloadManyReports = function (data, paramsP) {
            var params = angular.fromJson(angular.toJson(paramsP));
            var defaultParams = data.params.filter(function (item) {
                return item.default;
            });
            for (var d = 0; d < defaultParams.length; d++) {
                var thisP = defaultParams[d];
                var currtVal = params[thisP.field];
                if (angular.isUndefined(currtVal) || (angular.isArray(currtVal) && currtVal.length === 0) || (angular.isString(currtVal) && currtVal === '')) {
                    params[thisP.field] = objData[thisP.default]();
                }
            }
            params.center = AppF.center;
            var obj = {
                data: angular.toJson(params),
                filename: paramsP.filename ? params.filename : 'ACUMULADOS_DE_EMPLEADOS'
            };
            if (!data.apiVersion) {
                CatalogsF.exportToExcel(data.path, obj);
            } else if (data.apiVersion === 'v2') {
                ApiV2F.exportToExcel(data.path, obj)
            } else if (data.apiVersion === 'v3') {
                ApiV3F.exportToExcel(data.path, obj)
            }
        };
        function getLists(data) {
            return new Promise(function (resolve, reject) {
                var fromList = {};
                var listsF = data.params.filter(function (value) {
                    return value.type === 'fromList' && (value.listType !== 'autocomplete' || !value.query);
                });
                if (listsF.length > 0) {
                    var queries = {};
                    for (var i = 0; i < listsF.length; i++) {
                        if (objData.hasOwnProperty(listsF[i].list)) {
                            queries[listsF[i].list] = objData[listsF[i].list](listsF[i]);
                        } else {
                            var thisQuery;
                            if (listsF[i].includeCenterQuery) {
                                thisQuery = [{ q: 'orderByChild', v: 'center' }, { q: 'equalTo', v: function () { return AppF.center; } }];
                            }
                            queries[listsF[i].list] = ListsF.loadList(listsF[i].list, listsF[i].ref, false, 'array', 'report-' + listsF[i].field, thisQuery);
                        }
                    }
                    var thisPromise = Object.keys(queries).length > 0 ? $q.all(queries) : Promise.all([]);
                    thisPromise.then(function (resp) {
                        if (!angular.isArray(resp)) {
                            fromList = resp;
                        }
                        resolve(fromList);
                    }).catch(function (error) {
                        reject(error);
                    });
                } else {
                    resolve(fromList);
                }
            });
        }
        $scope.saveReportDescription = function (idReport, description) {
            $scope.$loadingProgress = true;
            $scope.$evalAsync();
            $scope.F.root.child("catalogs/reports/collection/" + idReport).update({ description: angular.isString(description) ? description : null }).then(function () {
                $scope.$loadingProgress = false;
                $scope.$evalAsync();
                delete $scope.editReports[idReport];
                successAlertS('Se guardo descripción con éxito')
            }).catch(function (error) {
                errAlertS(error);
                $scope.$loadingProgress = false;
                $scope.$evalAsync();
            })
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.clients')
        .controller('PositionController', PositionController);

    /** @ngInject */
    function PositionController(
        $scope,
        $log,
        errAlertS,
        getSomethingOfArrayFBFilter,
        startAfterInitFilter
    ) {
        var initiated = false;
        $scope.listWatchers = {};
        $scope.$watch('position.payroll', function (payrollId) {
            if (payrollId) {
                // catalog, ref, child, type, filterName, queryParams
                $scope.L.loadList('positions', 'lists/positions/payroll/' + payrollId, undefined, 'array', 'payrollPositions-' + payrollId, [{ q: 'orderByChild', v: 'isFiscal' }, { q: 'equalTo', v: true }]).then(function (positions) {
                    $log.log(positions);
                });
                var payrollIsActive = getSomethingOfArrayFBFilter(payrollId, $scope.L.allPayrolls, 'active');
                if (!payrollIsActive) {
                    if ($scope.F.addMode) {
                        errAlertS('La nómina pre-seleccionada no está activa');
                        $scope.position.payroll = null;
                    }

                }
            }
        });
        $scope.deleteFiscalPosition = function () {
            delete $scope.position.fiscalPosition;
        };
        function init() {
            $scope.position.center = $scope.F.center;
        }
        startAfterInitFilter($scope, $scope.listWatchers, initiated, init);

    }

}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .controller('PeriodsController', PeriodsController);

    function PeriodsController(
        $scope,
        $rootScope,
        $firebaseObject,
        $log,
        $mdDialog,
        successAlertS,
        errAlertS,
        clearObjectFilter,
        periodsHaveActiveOperationsFilter,
        getArrayOfIdsFilter,
        getFirstDateOfPeriodsFilter,
        confirmConfig
        ) {
        $scope.updateCal = { status: false };
        $scope.addingOne = false;

        /** TODO: documentación
         * @type
         * @description 
         * @returns Promesa<true|err>
         */
        function updateCalendarObject() {
            return new Promise(function(resolve, reject){
                if ($scope.updateCal.status) {
                    $scope.payrollCalendar.$save().then(function () {
                        successAlertS('Se actualizaron los periodos y el calendario correctamente');
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync(function(){
                            $log.debug('updateCalendarObject finished');
                        });
                        resolve(true);
                    }, function (err) {
                        errAlertS(err);
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync();
                        reject(err);
                    })
                } else {
                    successAlertS('Se actualizaron los periodos correctamente');
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                    resolve(true);
                }
            });
        }

        /**@type Helper
         * @description Carga el calendario
         * @param {string} payrollId 
         * @param {string} payrollCalendarId 
         */
        function loadPayrollCalendar(payrollId, payrollCalendarId){
            $scope.payrollCalendar = $firebaseObject($scope.F.root.child('catalogs/payrollCalendars').child(payrollId).child('calendars').child(payrollCalendarId));
        }

        /**@type Watcher
         * @description Carga el calendario cuando cambia la nómina y si está seteado F.search.$payrollCalendar
         * @param {string|null} pId
         */
        function loadPayrollCalendarOnPayrollChange(payrollId){
            if(payrollId && $scope.F.search.$payrollCalendar){
                $scope.payrollId = payrollId;
                loadPayrollCalendar(payrollId, $scope.F.search.$payrollCalendar);
            }
        }

        /**@type Watcher
         * @description Carga calendario si cambia el calendario y si está seteado F.search.$payroll
         * @param {string|null} payrollCalendarId 
         */
        function loadPayrollCalendarOnPayrollCalendarChange(payrollCalendarId){
            if(payrollCalendarId && $scope.F.search.$payroll){
                $scope.payrollCalendarId = payrollCalendarId;
                loadPayrollCalendar($scope.F.search.$payroll, payrollCalendarId);
            }
        }

        /** TODO: documentación
         * @type DOM
         * @description
         * @param {Event} event 
         * @param {*} periods 
         */
        function deActivatePeriods(event, periods){
            for(var s in periods){
                periods[s].active = false;
            }
        }

        /**@type DOM TODO: borrar ya que prueben nueva funcion
         * @description Checa antes de borrar si periodo es:
         * - el primero o el último
         * - si el periodo tiene operaciones activas
         * ------------ Despues de borrar:
         * - Actualiza fechas (min-max) de calendario
         * - Borra operaciones de ese periodo
         * @param {Event} event 
         */
        function checkAndRemove(event){
            $rootScope.loadingProgress = true;
            periodsHaveActiveOperationsFilter($scope.selected, $scope.F.search.$payroll, $scope.F.search.$payrollCalendar).then(function(have){
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
                if(!have.activeOperations){
                    var periods = getArrayOfIdsFilter($scope.selected);
                    // console.log(periods, have.operationIds, have, "COOL");
                    $scope.delete(event, 1).then(function(){
                        // actualizar fechas de calendario
                        $rootScope.loadingProgress = true;
                        var updates = {};
                        var firstAndLast = getFirstDateOfPeriodsFilter($scope.periods);
                        if(firstAndLast.first !== $scope.payrollCalendar.data.startDate){
                            updates['catalogs/payrollCalendars/' + $scope.F.search.$payroll + '/calendars/' + $scope.F.search.$payrollCalendar + '/data/startDate'] = firstAndLast.first;
                        }
                        if(firstAndLast.last !== $scope.payrollCalendar.data.endDate){
                            updates['catalogs/payrollCalendars/' + $scope.F.search.$payroll + '/calendars/' + $scope.F.search.$payrollCalendar + '/data/endDate'] = firstAndLast.last;
                        }
                        // borrar operaciones
                        for(var p in periods){
                            updates['catalogs/operations/ordinary/' + $scope.F.search.$payroll + '/' + $scope.F.search.$payrollCalendar + '/collection/' + have.operationIds[periods[p]]] = null;
                        }
                        $scope.F.root.update(updates).then(function(){
                            successAlertS('Periodos y Operaciones sin abrir borradas con éxito');
                            $rootScope.loadingProgress = false;
                            $rootScope.$evalAsync(function(){
                                $log.debug('checkAndRemove finished');
                            });
                        });
                    });
                } else {
                    errAlertS('No se puede eliminar periodo(s) seleccionado(s), ya que tiene una o más operaciónes activas');
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                }
            }, function(err){
                errAlertS(err);
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
            });
        }

        /**@type DOM, API
         * @description Con un confirm: borra primer o último periodo y su operación si no tiene operaciones activas, actualiza calendario y activa operación que sigue si aplica
         * @param {Event}
         */
        function checkAndRemove2(event){
            var msg = 'Periodo será borrado, se actualizarán las fechas en el calendario';
            msg += ($scope.selected[0].period == $scope.payrollCalendar.data.initialPeriod) ? ' y se activará el próximo periodo si aplica' : ' y si la operación del calendario no está activa la borrará también';
            msg += '. <br> <b>Solo podrá borrarlo si no tiene operaciones activas.</b>'
            $mdDialog.show(
                $mdDialog.confirm(confirmConfig)
                    .title('Quiere borrar el periodo ' + $scope.selected[0].period + '?')
                    .htmlContent(msg)
                    .ariaLabel('delete period')
                    .targetEvent(event)
                    .ok('Borrar')
                    .cancel('Cancelar'))
            .then(function() {
                $rootScope.loadingProgress = true;
                $scope.D.models.action('periods', 'removePeriod', {
                    period: $scope.selected[0].period,
                    payroll: $scope.F.search.$payroll,
                    calendar: $scope.payrollCalendarId
                }).then(function(response){
                    successAlertS(response.data.message, response.data.stay);
                    $scope.currentPage = (Math.ceil($scope.F.filteredItems.length/$scope.F.paginate)); // última pag
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync(function(){
                        $log.debug('checkAndRemove2 finished');
                    });
                }).catch(function(err){
                    errAlertS(err);
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                });
            }, function() {
                $log.debug('checkAndRemove Cancelled');
            });
        }

        /** TODO: borrar ya que prueben la nueva funcion */
        function addPeriod(){
            var newPeriod = angular.copy($scope.R.states.fb['periods'].blanc);
            newPeriod.period = $scope.periods.length+1;
            newPeriod.active = true;
            newPeriod.deleteAfterCreate = true;
            $scope.addingOne = true;
            $scope.periods.push(newPeriod);
            $scope.currentPage = (Math.ceil($scope.F.filteredItems.length/$scope.F.paginate));
        }

        /**@type DOM, API
         * @description con un prompt: agrega periodo antes del primer periodo o despues del último si no se pasa del año
         * @param {Event}
         */
        function addPeriod2(event){
            // TODO hacer custom dialog para tener 2 botones y 1 para cancelar
            var confirm = $mdDialog.confirm()
                .title('Desea agregar el nuevo periodo al inicio o al final?')
                .textContent('El minimo periodo al inicio es el 1')
                .ariaLabel('Escoger orden del periodo')
                .targetEvent(event)
                .ok('Despues')
                .cancel('Antes');
        
            $mdDialog.show(confirm).then(function() { // despues
                $rootScope.loadingProgress = true;
                $scope.D.models.action('periods', 'addPeriod', {
                    order: 1,
                    payroll: $scope.F.search.$payroll,
                    calendar: $scope.payrollCalendarId,
                    firm: $scope.payrollCalendar.firm
                }).then(function(response){
                    successAlertS(response.data.message, response.data.stay);
                    $scope.currentPage = (Math.ceil($scope.F.filteredItems.length/$scope.F.paginate)); // última pag
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync(function(){
                        $log.debug('addPeriod2 after finished');
                    });
                }).catch(function(err){
                    errAlertS(err);
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                });
            }, function() { // antes
                $rootScope.loadingProgress = true;
                $scope.D.models.action('periods', 'addPeriod', {
                    order: -1,
                    payroll: $scope.F.search.$payroll,
                    calendar: $scope.payrollCalendarId,
                    firm: $scope.payrollCalendar.firm
                }).then(function(response){
                    successAlertS(response.data.message, response.data.stay);
                    $scope.currentPage = 1;
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync(function(){
                        $log.debug('addPeriod2 before finished');
                    });
                }).catch(function(err){
                    errAlertS(err);
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                });
            });
        }

        /**TODO: pasar a API, documentación
         * @description
         * @param {*} periods 
         */
        function saveAndUpdateCalendar(periods) {
            $rootScope.loadingProgress = true;
            return new Promise(function(resolve, reject){
                // var count = 0;
                // var length = periods.length;
                var refToPeriods = $scope.R.constructDinamicRef('periods', $scope.R.states.fb['periods'].filter, $scope);
                var operationReference = 'catalogs/operations/ordinary/' + $scope.F.search.$payroll + '/' + $scope.payrollCalendarId + '/collection';
                var refToPeriod;
                var requests = {};
                // var newPeriods = [];
                
                angular.forEach(periods, function (object, key) {
                    if(!object.hasOwnProperty('$id')){ 
                        var newPeriod = angular.copy(object);
                        // newPeriod.$id = angular.copy(newPeriod.period);
                        newPeriod.created = $scope.D.getTimeObject();
                        delete newPeriod.deleteAfterCreate;
                        // newPeriods.push(newPeriod.$id);
                        var operationId = $scope.F.root.child(operationReference).push().key;
                        var operationN = {
                            status: -1,
                            period: newPeriod.period,
                            calendar: $scope.F.search.$payrollCalendar,
                            payroll: $scope.F.search.$payroll,
                            firm: $scope.payrollCalendar.firm,
                            created: $scope.D.getTimeObject(),
                            type: "automatic"
                        }
                        requests[operationReference + '/' +  operationId] = operationN;
                        var cleanObject = clearObjectFilter(newPeriod);
                        refToPeriod = refToPeriods + '/' + object.period;
                        requests[refToPeriod] = cleanObject;
                    }
                    // if (object.deleted) {
                    //     requests[refToPeriod] = null;
                    //     // removal of operations delegated to server ?
                    // } else {
                        
                    // }
                    // delete object.deleted;
                });
    
                // console.log(requests, "COOL");
                $scope.F.root.update(requests).then(function(){
                    updateCalendarObject().then(function(){
                        $scope.periodsForm.$setPristine();
                        // quitar el periodo que se agrego
                        for(var p in periods){
                            if(periods[p].deleteAfterCreate){
                                periods.splice(p,1);
                            }
                        }
                        $scope.addingOne = false;
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync(function(){
                            $log.debug('saveAndUpdateCalendar finished');
                        });
                        resolve();
                    }, function(err){
                        errAlertS(err);
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync();
                        reject(err);
                    });
                });
            });
        }

        // Funciones del DOM
        $scope.saveAndUpdateCalendar = saveAndUpdateCalendar;
        $scope.addPeriod = addPeriod; // local process TODO: borrar cuando prueben la otra
        $scope.addPeriod2 = addPeriod2; // api call
        $scope.checkAndRemove2 = checkAndRemove2; // api call
        $scope.checkAndRemove = checkAndRemove; // local process TODO: borrar cuando prueben la otra
        $scope.deActivatePeriods = deActivatePeriods;

        // Watchers
        $scope.$watch('F.search.$payrollCalendar', loadPayrollCalendarOnPayrollCalendarChange);
        $scope.$watch('F.search.$payroll', loadPayrollCalendarOnPayrollChange);
    }
})();
(function () {
    'use strict';

    angular
        .module('app.clients')
        .controller('PayrollController', PayrollController);

    function PayrollController(
        $scope,
        $rootScope,
        getFromObjectFilter,
        $log,
        filterFilter,
        successAlertS,
        errAlertS,
        $timeout,
        infoAlertS,
        userHasPermissionFilter,
        AppF
    ) {
        $scope.addProc = false;
        var initiated = false;
        $scope.payrollProcs = [];
        // $scope.vm = $scope;
        var assignPayroll = function (payroll) {
            var obj = {
                payroll: payroll,
                users: {
                    all: {}
                },
                payrollUsers: {}

            };
            obj.users.all[$scope.F.profile.uid] = true;
            obj.payrollUsers[$scope.F.profile.uid] = true;
            obj.created = $scope.D.getTimeObject();
            obj.center = $scope.F.center;
            $log.debug('assigning payroll to current user', $scope.F.profile.uid, obj);
            return $scope.F.root.child('catalogs/involvedRecords/collection').push(obj);
        };
        $scope.setAddProc = function () {
            $scope.addProc = !$scope.addProc;
        };
        $scope.validateSalaryAdjustment = function () {
            if ($scope.payroll.enableSalaryAdjusment) {
                var processes = getFromObjectFilter($scope.paymentSchema, 'data.processes');
                if (angular.isUndefined(processes) || (!processes.hasOwnProperty('fiscal')) || Object.keys(processes).length > 2) {
                    $scope.payroll.enableSalaryAdjusment = false;
                    errAlertS('Esta opción es solo para las nominas fiscales');
                }
            }
        };
        var init = function () {
            if (!initiated) {
                initiated = true;
            }

            $scope.paramsExtraPermission = userHasPermissionFilter(AppF.groupsOfUser, AppF.permissions, 'extraParameters', 'organization.payrolls')
            $scope.payroll.center = $scope.F.center;
            var needed = [
                $scope.dataNeededPromise,
                $scope.statesObjsPromise
            ];
            $scope.getConfigExtraFields();
            Promise.all(needed).then(function () {
                for (var thisProc in $scope.payroll.processes) {
                    if (thisProc === 'FISCAL') {
                        var active = getFromObjectFilter($scope.paymentSchema, 'data.processes.fiscal.active', false);
                        if (!active) {
                            $scope.payrollProcs.push({ name: thisProc, id: 'fiscal' });
                        }
                    } else if (thisProc !== 'processes' && thisProc !== 'complements') {
                        var founded;
                        var complements = getFromObjectFilter($scope.paymentSchema, 'data.processes.complements');
                        if (angular.isArray(complements)) {
                            founded = complements.find(function (item) {
                                return item.name === thisProc;
                            });
                        }
                        if (angular.isUndefined(founded)) {
                            $scope.payrollProcs.push({ name: thisProc, id: $scope.payroll.processes[thisProc].id });
                        }

                    }
                }
            }).catch(function (error) {
                errAlertS(error);
            });
        };

        function updatePayrollConstants(payrollId, payroll) {
            return new Promise(function (resolve, reject) {
                $scope.F.root.child('catalogs/operationConstants/collection').orderByChild('itemId').equalTo(payrollId).once('value').then(function (snap) {
                    var constantId;
                    var constant = {};
                    snap.forEach(function (childSnap) {
                        var thisConstant = childSnap.val();
                        if (thisConstant.type === 'payroll' && thisConstant.constantType === 'customField' && thisConstant.customField.key === 'isMaquila') {
                            constantId = childSnap.key;
                            constant = thisConstant;
                        }
                    });
                    var promises = [];
                    if ($scope.paymentSchema.data.name.indexOf('MAQUILA') > -1) {
                        if (angular.isString(constantId)) {
                            constant.customField = {
                                'key': 'isMaquila',
                                'name': 'ES MAQUILA',
                                'value': 1
                            };
                            constant.updated = $scope.D.getTimeObject();
                        } else {
                            constantId = $scope.F.root.child('catalogs/operationConstants/collection/').push().key;
                            constant = {
                                'constantType': 'customField',
                                'created': $scope.D.getTimeObject(),
                                'customField': {
                                    'key': 'isMaquila',
                                    'name': 'ES MAQUILA',
                                    'value': 1
                                },
                                'itemId': payrollId,
                                'name': payroll.data.name,
                                'type': 'payroll'
                            };
                        }
                        promises.push($scope.F.root.child('catalogs/operationConstants/collection/' + constantId).update(constant));
                    }
                    resolve(Promise.all(promises));
                }).catch(reject);
            });
        }
        $scope.savePayroll = function (payroll) {
            $rootScope.loadingProgress = true;
            var payrollCreated = false;
            $timeout(function () {
                $scope.save(payroll, true).then(function () {
                    payrollCreated = true;
                    return updatePayrollConstants(payroll.$id, payroll);
                }).then(function () {
                    successAlertS('Se actualizó Nómina con éxito');
                    $rootScope.loadingProgress = true;
                    $scope.R.goToList();
                }).catch(function (error) {
                    if (payrollCreated) {
                        $scope.R.goToList();
                        successAlertS('Se actualizó Nómina con éxito pero no se puedo crear el campo personalizado de maquila, favor de añadirla manualmente o reintentar');
                    } else {
                        errAlertS(error);
                    }
                    $rootScope.loadingProgress = false;
                });
            }, 0, false);
        };

        $scope.addAndAssign = function (payroll) {
            $log.debug('adding payroll', payroll);
            if (!$scope.F.isDistributor()) { payroll.firm = $scope.F.profile.firm; }
            $rootScope.loadingProgress = true;
            // var object = $scope.D.prepareObject(payroll, 1, 0);
            $scope.add(payroll, 1).then(function (ref) {
                var id = ref.key;
                assignPayroll(id).then(function () {
                    return updatePayrollConstants(id, payroll);
                }).then(function () {
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync(function () {
                        $log.debug(id, $scope.payroll, 'saved payroll and asigned current user to it');
                        successAlertS('Se creó Nómina con éxito');
                    });
                    if ($scope.F.settings.goToListOnCreate) { $scope.R.goToList(); }
                }).catch(function (err) {
                    $log.error(err);
                    successAlertS('Se actualizó Nómina con éxito pero no se puedo crear el campo personalizado de maquila, favor de añadirla manualmente o reintentar');
                    $scope.R.goToList();
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                });
            }).catch(function (err) {
                errAlertS(err);
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
            });
        };

        $scope.initProcesses = function (complement) {
            $scope.payroll = $scope.payroll || {};
            $scope.payroll.processes = $scope.payroll.processes || {};
            $scope.payroll.processes[complement.name] = {
                id: complement.type
            };
        };

        function setbankAccounts() {
            if (angular.isUndefined($scope.payroll.processes)) {
                $scope.payroll.processes = {};
            }
            var fiscalActive = getFromObjectFilter($scope.paymentSchema, 'data.processes.fiscal.active', false);
            if (fiscalActive) {
                if (angular.isUndefined($scope.payroll.processes.FISCAL)) {
                    $scope.payroll.processes.FISCAL = {};
                }
                if (angular.isUndefined($scope.payroll.processes.FISCAL.bankAccounts)) {
                    $scope.payroll.processes.FISCAL.bankAccounts = [];
                }
            } else if ($scope.payroll.processes.FISCAL && $scope.payroll.processes.FISCAL.bankAccounts) {
                delete $scope.payroll.processes.FISCAL.bankAccounts;
            }
            var complements = getFromObjectFilter($scope.paymentSchema, 'data.processes.complements', {});
            for (var c1 in complements) {
                if ($scope.paymentSchema.data.processes.complements.hasOwnProperty(c1)) {
                    var complement = complements[c1];
                    if (angular.isUndefined($scope.payroll.processes[complement.name]) || !angular.isObject($scope.payroll.processes[complement.name])) {
                        $scope.payroll.processes[complement.name] = {};
                    }
                    if (angular.isUndefined($scope.payroll.processes[complement.name].bankAccounts) || !angular.isArray($scope.payroll.processes[complement.name].bankAccounts)) {
                        $scope.payroll.processes[complement.name].bankAccounts = [];
                    }
                }
            }
            for (var processName in $scope.payroll.processes) {
                if ($scope.payroll.processes.hasOwnProperty(processName)) {
                    var process = $scope.payroll.processes[processName];
                    if (['processes', 'complements'].indexOf(processName) === -1 && !process.hasOwnProperty('bankAccounts')) {
                        $scope.payroll.processes[processName].bankAccounts = [];
                    }
                }
            }
        }

        $scope.deleteProcess = function ($index, processName) {
            $scope.payrollProcs.splice($index, 1);
            delete $scope.payroll.processes[processName];
        };

        $scope.$watch('payroll.paymentSchema', function (paymentSchemaId) {
            if (paymentSchemaId) {
                if ($scope.C.paymentSchemas.length) {
                    $scope.paymentSchema = $scope.C.paymentSchemas.$getRecord(paymentSchemaId);
                    $log.debug($scope.paymentSchema, 'paymentSchema selected');
                    setbankAccounts();
                } else {
                    var ref = $scope.R.constructDinamicRef('paymentSchemas', $scope.R.states.fb['paymentSchemas'].filter, $scope);
                    $scope.loadObjectOnScope('paymentSchemas', paymentSchemaId, 'paymentSchema', ref);
                    $log.debug($scope.paymentSchema, 'paymentSchema selected');
                    setbankAccounts();
                }
            }
        });

        $scope.filterBanks = function (textToSearch, id) {
            var banks = $scope.M.bankAccounts.slice();
            var filterBanks = banks.filter(function (value) {
                return value.status === true && value.companiesRecord === id;
            });
            return filterFilter(filterBanks, textToSearch);
        };

        $scope.transformChip = function (chip) {
            if (angular.isObject(chip)) {
                return chip._id;
            }
            return chip;
        };
        $scope.setFieldAccount = function (type) {
            $scope.payroll.processes[type].bankAccounts = [];
        };




        $scope.getConfigExtraFields = function () {
            $scope.getFieldsDataByName = {};
            $scope.F.root.child('/settings/payrollExtrafields/').once('value').then(function (resp) {
                $scope.getFieldsData = [];
                resp.forEach(function (childSnap) {
                    var data = childSnap.val();
                    var obj = { id: childSnap.key, name: data.name, description: data.description };
                    $scope.getFieldsData.push(obj)
                })
                $scope.getFieldsDataByName = resp.val();

                $log.log('Datos obtenidos:', $scope.getFieldsData);
            }).catch(function (error) {
                $log.error('Error al obtener los datos:', error);
            });
        };


        $scope.addFields = function (id) {
            if (angular.isUndefined($scope.payroll.extraFields)) {
                $scope.payroll.extraFields = {}
            }
            if (angular.isUndefined($scope.payroll.extraFields[id])) {
                $scope.payroll.extraFields[id] = ''
            } else {
                infoAlertS('Ya esta en uso este campo');
            }
            $scope.fieldSelected = ''
            $rootScope.$evalAsync();
        }

        $scope.deleteExtraFields = function (id) {
            $log.log($scope.payroll.extraFields);
            delete $scope.payroll.extraFields[id];
        };



        // $scope.visibleDescriptions = {};
        // $scope.toggleDescription = function (key) {
        //     $scope.visibleDescriptions[key] = !$scope.visibleDescriptions[key];
        // };




        if ($scope.objectLoaded) {
            init();
        } else {
            var mainObjectLoaded = $rootScope.$on('mainObjectLoaded', function () {
                mainObjectLoaded();
                init();
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.clients')
        .controller('StampedRecordsController', StampedRecordsController);

    function StampedRecordsController($scope, AppF, $state, $filter, $log, $rootScope, successAlertS, $window, $http, errAlertS, $q, $localStorage, ListsF, $timeout, $document, $mdDialog, confirmConfig, DataF, CatalogsF) {
        var watchers = {};
        var initiated = false;
        $scope.mainState = 'app.processes.stampedRecords';
        $scope.tabConfig = {};
        $scope.F = AppF;
        function init() {
            initiated = true;
        }
        function downloadFile(path, params) {
            $rootScope.loadingProgress = true;
            $http({
                method: 'POST',
                url: $window.__env.serviceWorkerUrl + path,
                responseType: 'arraybuffer',
                data: params
            }).then(function (response) {
                $log.log('finished');
                var headers = response.headers();
                var filename = headers['x-filename'];
                var contentType = headers['content-type'];
                var linkElement = document.createElement('a');
                try {
                    var blob = new Blob([response.data], {
                        type: contentType
                    });
                    var url = $window.URL.createObjectURL(blob);
                    linkElement.setAttribute('href', url);
                    linkElement.setAttribute('download', filename);
                    var clickEvent = new MouseEvent('click', {
                        'view': window,
                        'bubbles': true,
                        'cancelable': false
                    });
                    linkElement.dispatchEvent(clickEvent);
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync(function () {
                        $log.debug('generatePdf finished');
                    });
                } catch (ex) {
                    $log.error(ex, 'error descargando el archivo');
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                }
            }).catch(function (err) {
                $log.log(err);
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
                var message = new TextDecoder('utf-8').decode(err.data);
                var error = angular.fromJson(message);
                errAlertS(error.data || error.message);
            });
        }
        $scope.goToDetail = function (operation) {
            var opeType = operation.operationType;
            var detailState = 'app.processes.operations.edit';
            var params = {
                'operationId': operation.$id,
                'payrollId': operation.payroll,
                'operationType': opeType,
                'calendarYear': operation.calendar ? operation.calendar : null,
                'period': operation.period ? operation.period : null
            };
            if (opeType !== 'ordinary') {
                if (opeType === 'settlement') {
                    detailState = 'app.processes.operations.editSettlement';
                } else {
                    detailState = 'app.processes.operations.editSpecial';
                }
            }
            AppF.goToState(detailState, params);
        };
        $scope.startToBill = function (ev, operation) {
            $rootScope.loadingProgress = true;
            var promise;
            var operationType = operation.operationType;
            if (operationType === 'ordinary') {
                promise = AppF.root.child('catalogs/operations/ordinary/' + operation.payroll + '/' + operation.calendar + '/collection/' + operation.$id + '/status').once('value');
            } else {
                promise = AppF.root.child('catalogs/operations/' + operationType + '/all/' + operation.$id + '/status').once('value');
            }
            promise.then(function (statusSnap) {
                var status = statusSnap.val();
                if (!statusSnap.exists()) {
                    throw 'No se encontró la operación';
                } else if (status < 3) {
                    throw 'Aun no se puede timbrar esta operación, debe cerrarse primero';
                } else if (status > 5) {
                    throw 'Esta operación ya ha sido facturada';
                } else if (status === 4) {
                    throw 'La operación esta en proceso de timbrado';
                }
                var title = 'Esta seguro de proceder con el timbrado?';
                var msg = 'La factura se timbrara y no podrá cancelarlo en el proceso';
                $rootScope.loadingProgress = false;
                return $mdDialog.show($mdDialog
                    .confirm(confirmConfig)
                    .title(title)
                    .htmlContent(msg)
                    .ariaLabel('Deleting')
                    .targetEvent(ev)
                    .ok('SI')
                    .cancel('NO'));
            }).then(function () {
                $rootScope.loadingProgress = true;
                var updates = {};
                updates['billing'] = true;
                updates['status'] = 4;
                updates['billingDate'] = DataF.getCurrentServerTime();
                var ref;
                if (operationType === 'ordinary') {
                    ref = 'catalogs/operations/ordinary/' + operation.payroll + '/' + operation.calendar + '/collection';
                } else {
                    ref = 'catalogs/operations/' + operationType + '/all';
                }
                return $scope.F.root.child(ref + '/' + operation.$id).update(updates);
            }).then(function () {
                successAlertS('Se inicio el proceso de facturación');
            }).catch(function (error) {
                if (angular.isDefined(error)) {
                    errAlertS(error);
                }
            }).then(function () {
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
                $timeout(function () {
                    $scope.getThem();
                }, 3000, false);
            });
        };



        $scope.forceBill = function (ev, operation) {
            $mdDialog.show({
                locals: {
                    operation: operation,
                    scope: $scope
                },
                controllerAs: 'cpyctrl',
                controller: 'ForceBillsController',
                templateUrl: 'app/main/clients/views/operations/dialogs/forceBills.html',
                parent: angular.element($document.body),
                targetEvent: ev
            }).then(function (answer) {
                $rootScope.$evalAsync();
                $log.debug(answer, 'importEmployeesModal answer');
            }).catch(function (err) {
                $log.debug('importEmployeesModal cancelled', err);
            });
            $log.log('Operacion Data init', operation);
        }



        $scope.checkStatusOp = function (selected, statusN) {
            var status = selected.find(function (value) {
                return value.status < statusN;
            });
            return (angular.isUndefined(status)) ? true : false;
        };
        $scope.downloadZipBill = function (selected) {
            var operations = [];
            var promises = [];
            var employeesPromises = {};
            if (selected.length > 0) {
                for (var s = 0; s < selected.length; s++) {
                    var employeeId = false;
                    promises.push(AppF.root.child('catalogs/payrolls/collection/' + selected[s].payroll + '/data/class').once('value'));
                    if (Object.keys(selected[s].employees).length === 1) {
                        $filter('loopEach')(selected[s].employees, function (data, key) {
                            employeeId = key;
                            employeesPromises[key] = AppF.root.child('catalogs/employees/collection/' + key + '/data/employeeNumber').once('value');
                        });
                    }
                    operations.push({
                        employeeId: employeeId,
                        operation: selected[s].$id,
                        dispersion: selected[s].dispersion,
                        calendar: selected[s].calendar,
                        specialPeriod: selected[s].specialPeriod,
                        period: selected[s].period,
                        payroll: selected[s].payroll,
                        opeType: selected[s].operationType
                    });
                }
                if (Object.keys(employeesPromises).length > 0) {
                    promises.unshift($q.all(employeesPromises));
                } else {
                    promises.unshift(Promise.all([]));
                }
                $q.all(promises).then(function (resp) {
                    var employeesPromises = resp.shift();
                    employeesPromises = angular.isArray(employeesPromises) ? {} : employeesPromises;
                    if (resp.length > 0) {
                        for (var r = 0; r < resp.length; r++) {
                            if (resp[r].exists()) {
                                var payrollClass = resp[r].val();
                                var employeeNumber = undefined;
                                if (operations[r].employeeId) {
                                    employeeNumber = angular.isObject(employeesPromises[operations[r].employeeId]) && employeesPromises[operations[r].employeeId].val ? employeesPromises[operations[r].employeeId].val() : undefined;
                                }
                                var thisCalendar = operations[r].calendar ? '_' + operations[r].calendar : '';
                                var selectedPeriod = operations[r].specialPeriod ? operations[r].specialPeriod : operations[r].period;
                                var digits = operations[r].specialPeriod ? 3 : 2;
                                var thisPeriod = selectedPeriod ? '_' + $filter('zeroFill')(selectedPeriod, digits) : '';
                                var thisCenter = AppF.center.toUpperCase();
                                var params = {
                                    dispersionId: operations[r].dispersion,
                                    operationId: operations[r].operation,
                                    opType: operations[r].opeType,
                                    filename: thisCenter + thisCalendar + '_' + payrollClass + '_' + $scope.F.opeFilesName[operations[r].opeType].fiscal + thisPeriod + (employeeNumber ? '_' + employeeNumber : '')
                                };
                                downloadFile('models/bill/getBillZipAll', params);
                            } else {
                                throw 'No se encontró la clase de la nómina con ID ' + operations[r].payroll;
                            }
                        }
                    } else {
                        throw 'No se encontró la clase de la nómina';
                    }
                }).catch(function (error) {
                    errAlertS(error);
                });
            } else {
                errAlertS('Favor de seleccionar alguna operación');
            }
        };

        $scope.generateAccountingAccount = function (selected) {
            var operations = [];
            var promises = [];
            for (var s = 0; s < selected.length; s++) {
                operations.push({
                    specialPeriod: selected[s].specialPeriod,
                    operationType: selected[s].operationType,
                    operationId: selected[s].$id,
                    dispersionId: selected[s].dispersion,
                    payrollId: selected[s].payroll,
                    calendar: selected[s].calendar,
                    period: selected[s].period
                });
                promises.push(AppF.root.child('catalogs/dispersions/collection/' + selected[s].dispersion + '/data/process').once('value'));
            }
            Promise.all(promises).then(function (resp) {
                if (resp.length > 0) {
                    for (var r = 0; r < resp.length; r++) {
                        if (resp[r].exists()) {
                            var process = resp[r].val();
                            for (var p = 0; p < process.length; p++) {
                                if (['fiscal', 'socialPrevision'].indexOf(process[p].id) > -1) {
                                    var merge = Object.assign({ process: process[p].id }, operations[r]);
                                    var obj = {
                                        data: angular.toJson([merge]),
                                        nameF: 'exportAccount'
                                    };
                                    CatalogsF.exportToExcel('interface/exportAnyFiles', obj);
                                }
                            }
                        }
                    }
                } else {
                    throw 'No se encontraron los procesos de la operación';
                }
            }).catch(function (error) {
                errAlertS(error);
            });
        };

        $filter('startAfterInit')($scope, watchers, initiated, init);
    }
})();
(function () {
    'use strict';

    angular
        .module('app.clients')
        .controller('OperationsControllerOld', OperationsControllerOld);

    function OperationsControllerOld(
        $scope,
        $rootScope,
        $state,
        $firebaseArray,
        $firebaseObject,
        $log,
        $q,
        $mdDialog,
        $mdBottomSheet,
        $sessionStorage,
        AppF,
        DataF,
        successAlertS,
        errAlertS,
        confirmConfig,
        operationsOfPeriodFilter,
        clearObjectFilter,
        constructStatusNodeFilter,
        operationStatusNameFilter,
        isThereDeleteInCascadeFilter,
        getSomethingOfArrayFBFilter,
        cleanArrayOfDataFilter,
        startAfterInitFilter,
        ChatF,
        filterFilter,
        ListsF,
        loopEachFilter,
        userHasPermissionFilter,
        CatalogsF,
        orderByFilter,
        getFromObjectFilter,
        $timeout,
        $http,
        $window,
        $document,
        $filter
    ) {
        $scope.tabConfig = {};
        var addEditOpe = function (ev, specialObject, type) {
            console.log(type)
            $mdDialog.show({
                templateUrl: 'app/main/clients/views/newoperation/dialogs/special-payrolls.html',
                locals: {
                    specialObject: specialObject,
                    type: type,
                    opeConfig: $scope.tabConfig[$scope.tabName]
                },
                controller: 'specialPayrollsController',
                parent: angular.element(document.body),
                targetEvent: ev,
                scope: $scope.$new(),
                clickOutsideToClose: true
            });
            $scope.$evalAsync();
        }
        var addSettlements = function (ev, operation, action) {
            var employee;
            var movement;
            var operationId;
            var promises = [];
            $log.log(operation);
            if (angular.isDefined(operation) && angular.isDefined(operation.movement)) {
                operationId = operation.$id;
                movement = operation.movement;
                loopEachFilter(operation.employees, function (employeeData, idEmployee) {
                    promises.push(ListsF.loadList('employees', 'catalogs/employees/collection', idEmployee, 'object', 'employees-' + idEmployee))
                })
            }
            Promise.all(promises).then(function (resp) {
                if (resp.length > 0) {
                    employee = resp[0];
                    employee.processConfig = operation.processConfigId;
                    employee.incidences = operation.incidences;
                    employee.movementTypes = operation.movementTypes;
                }
                return getSettlement(operation, employee, action)
            }).then(function () {
                $mdDialog.show({
                    templateUrl: 'app/main/clients/views/newoperation/dialogs/settlements.html',
                    locals: {
                        employeeP: employee,
                        movement: movement,
                        operationId: operationId,
                        action: action
                    },
                    controller: 'settlementsController',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    scope: $scope.$new(),
                    clickOutsideToClose: true
                });
                $scope.$evalAsync();
            }).catch(errAlertS);

        }
        var defaultActions = ['access', 'add', 'edit', 'remove'];
        $scope.tabConfig = {
            settlements: {
                objectName: 'settlement',
                addEditAction: addSettlements,
                title: 'Finiquitos',
                editParam: 'edit'
            },
            specials: {
                objectName: 'special',
                addEditAction: addEditOpe,
                addParam: 'special',
                title: 'Operación Especial',
                editParam: 'special'
            },
            asimilated: {
                objectName: 'asimilated',
                addEditAction: addEditOpe,
                addParam: 'asimilated',
                title: 'Asimilados',
                editParam: 'asimilated'
            },
            advAndLoanOpes: {
                objectName: 'advAndLoanOpe',
                addEditAction: addEditOpe,
                addParam: 'advAndLoanOpe',
                title: 'Anticipos y prestamos',
                editParam: 'advAndLoanOpe'
            },
            travelExpensesOpes: {
                objectName: 'travelExpensesOpe',
                addEditAction: addEditOpe,
                addParam: 'travelExpensesOpe',
                title: 'Viáticos',
                editParam: 'travelExpensesOpe'
            }
        }
        var watchers = {};
        var root = AppF.root;
        var initiated = false;
        $scope.CF = ChatF;
        var dataNeeded = ['paymentFrequenciesRecords', 'dismissTypes'];
        $scope.mainState = 'app.processes.operations';
        $scope.configState = 'app.processes.operations.config';
        $scope.readState = 'app.processes.operations.read';
        $scope.detailState = 'app.processes.operations.edit';
        $scope.detailState2 = 'app.processes.operations.update';
        $scope.operations = {
            ordinary: [],
            extraordinary: []
        };
        $scope.selected = [];
        $scope.currentPageO = {
            ordinary: AppF.currentPage('clients', 'operationsO'),
            extraordinary: AppF.currentPage('clients', 'operationsE')
        }
        $scope.currentPageP = AppF.currentPage('clients', 'periods');
        $scope.uploadImage = false;
        $scope.addParams = 'new';
        $scope.tabName = 'ordinary';
        $scope.thisYear = moment().format("YYYY");
        $scope.selectedTab = 0;
        $scope.currentPage = 1;
        $scope.data = {
            ordinariesNotDoIt: {
                items: []
            },
            ordinariesDoIt: {
                items: []
            },
            settlementsNotDoIt: {
                items: []
            }
        };
        $scope.pagination = {
            ordinariesNotDoIt: {
                limit: 10,
                limitOption: [5, 10, 50, 100, 500],
                page: 1
            },
            ordinariesDoIt: {
                limit: 10,
                limitOption: [5, 10, 50, 100, 500],
                page: 1
            },
            settlementsNotDoIt: {
                limit: 10,
                limitOption: [5, 10, 50, 100, 500],
                page: 1
            }
        };
        $scope.initialLoadMoreText = 'Cargar mas resultados';
        if ($sessionStorage.tab) {
            if ($sessionStorage.tab['operations']) {
                $scope.selectedTab = $sessionStorage.tab['operations'];
                $log.debug($scope.selectedTab, 'selected tab from $sessionStorage');
            }
        }

        if ($state.params.payrollId) {
            AppF.search.$payroll = $state.params.payrollId;
        }

        if ($state.params.calendarYear) {
            AppF.search.operations.calendar = $state.params.calendarYear;
        }

        if ($state.params.period) {
            AppF.search.operations.period = $state.params.period
        }

        var init = function () {
            $scope.M.loadNeeded(dataNeeded);
            if (!AppF.search || !AppF.search.hasOwnProperty('operations')) {
                AppF.resetSearch('operations');
            }
            initiated = true;
            $scope.getValidations();
            for (var tab in $scope.tabConfig) {
                if ($scope.tabConfig.hasOwnProperty(tab)) {
                    var tabConfig = $scope.tabConfig[tab];
                    $scope.data[tab] = {
                        items: []
                    };
                    $scope.pagination[tab] = {
                        limit: 10,
                        limitOption: [5, 10, 50, 100, 500],
                        page: 1
                    };
                    for (var d = 0; d < defaultActions.length; d++) {
                        var action = defaultActions[d];
                        var permissionName = $filter('uppercase')(tabConfig.objectName.substring(0, 1)) + tabConfig.objectName.substring(1);
                        console.log(permissionName);
                        tabConfig[action] = userHasPermissionFilter(AppF.groupsOfUser, AppF.permissions, action + permissionName, 'processes.operations');
                    }
                }
            }
            $scope.userHasPermissionSettlementNotDoIt = userHasPermissionFilter(AppF.groupsOfUser, AppF.permissions, 'accessSettlementNotDoIt', 'processes.operations');
            $scope.userHasPermissionOrdinariesNotDoIt = userHasPermissionFilter(AppF.groupsOfUser, AppF.permissions, 'accessOrdinariesNotDoIt', 'processes.operations');
            $scope.userHasPermissionOrdinariesDoIt = userHasPermissionFilter(AppF.groupsOfUser, AppF.permissions, 'accessOrdinariesDoIt', 'processes.operations');
            if ($scope.userHasPermissionSettlementNotDoIt) {
                getSettlementNotDoIt();
            }
            console.log($scope.tabConfig);
        }

        var remove = function (operation) {
            $log.debug('removing: ', operation);
            return $scope.operations[$scope.tabName].$remove(operation);
        }

        var deleteDispersion = function (dispersionId) {
            return $scope.F.root.child('catalogs/dispersions/collection').child(dispersionId).set(null);
        }

        $scope.cleanCalculations = function (operation, ev) {
            var title = "Esta seguro de proceder la eliminacion de datos?"
            var msg = "Los datos se eliminarán y no podra recuperarlos";
            $mdDialog.show($mdDialog
                .confirm(confirmConfig)
                .title(title)
                .htmlContent(msg)
                .ariaLabel('Deleting')
                .targetEvent(ev)
                .ok('SI')
                .cancel('NO'))
                .then(function () {
                    $rootScope.loadingProgress = true;
                    $timeout(function () {
                        var updates = {};
                        var promises = [];
                        updates['operations/ordinary/' + operation.payroll + '/' + operation.calendar + '/collection/' + operation.$id] = null;
                        if (operation.dispersion) {
                            updates['dispersions/collection/' + operation.dispersion] = null;
                            var params = {
                                page: 0.5,
                                size: 0.5,
                                'idDispersion': operation.dispersion
                            }
                            promises.push($rootScope.D.api.get('p/calculations', params));
                        }
                        Promise.all(promises).then(function (resp) {
                            var promises = [];
                            if (resp.length > 0) {
                                var calculations = getFromObjectFilter(resp[0], 'data.data', []);
                                for (var c = 0; c < calculations.length; c++) {
                                    var thisCalculation = calculations[c];
                                    thisCalculation.mid = thisCalculation._id;
                                    delete thisCalculation._id;
                                    thisCalculation = clearObjectFilter(thisCalculation);
                                    updates["calculationsBackup/collection/" + thisCalculation.mid] = thisCalculation;
                                    promises.push($rootScope.D.api.delete('calculations/' + thisCalculation.mid))
                                }
                            }
                            promises.push($scope.F.root.child('catalogs').update(updates));
                            return Promise.all(promises)
                        }).then(function () {
                            successAlertS("Se termino de eliminar la informacion");
                            $scope.selected = [];
                        }).catch(function (error) {
                            errAlertS(error);
                        }).then(function () {
                            $rootScope.loadingProgress = false;
                            $timeout(function () { }, 0, false)
                        })
                    }, 0, false)

                }, function () {
                    $log.debug('Deleting Cancelled');
                });
        }
        $scope.getValidations = function () {
            if (!AppF.search || !AppF.search.hasOwnProperty('operations')) {
                AppF.resetSearch('operations');
                AppF.search.$payroll = false;
            }
            // validations for table loader
            if (initiated) {
                $scope.validations = {
                    periods: {
                        ordinary: [{
                            valid: (AppF.search.$payroll && AppF.search.operations.calendar && !$rootScope.loadingProgress),
                            msg: 'Seleccione una nómina y calendario'
                        },
                        {
                            valid: (AppF.search.$payroll && AppF.search.operations.calendar && $scope.operations.ordinary.length && !$rootScope.loadingProgress),
                            msg: 'Parece que no tiene operaciones de ésta nómina y calendario'
                        }
                        ]
                    },
                    operations: {
                        ordinary: [{
                            valid: (AppF.search.$payroll && AppF.search.operations.calendar && !$rootScope.loadingProgress),
                            msg: 'Seleccione una nómina y calendario'
                        },
                        {
                            valid: (AppF.search.$payroll && AppF.search.operations.calendar && $scope.operations.ordinary.length && !$rootScope.loadingProgress),
                            msg: 'Parece que no tiene operaciones de ésta nómina y calendario'
                        }
                        ],
                        extraordinary: [{
                            valid: (AppF.search.$payroll && AppF.search.operations.calendar && !$rootScope.loadingProgress),
                            msg: 'Seleccione una nómina y calendario'
                        },
                        {
                            valid: (AppF.search.$payroll && AppF.search.operations.calendar && $scope.operations.extraordinary.length && !$rootScope.loadingProgress),
                            msg: 'Parece que no tiene operaciones de ésta nómina y calendario'
                        }
                        ]
                    }
                };
                $scope.validations = [{
                    valid: (AppF.search.$payroll && AppF.search.operations.calendar && !$rootScope.loadingProgress),
                    msg: 'Seleccione una nómina y calendario'
                },
                {
                    valid: (AppF.search.$payroll && AppF.search.operations.calendar && $scope.operations.length && !$rootScope.loadingProgress),
                    msg: 'Parece que no tiene operaciones de ésta nómina y calendario'
                }
                ];
            } else {
                $scope.validations = {
                    periods: {
                        ordinary: []
                    },
                    operations: {
                        ordinary: [],
                        extraordinary: []
                    }
                };
            }
            $log.debug($scope.validations, 'validations');
        }

        $scope.goToDetail = function (operation, opeType) {
            var detailState;
            if (angular.isDefined(opeType)) {
                detailState = (['settlements', 'settlementsNotDoIt'].indexOf($scope.tabName) > -1) ? 'app.processes.operations.editSettlement' : 'app.processes.operations.editSpecial';
                AppF.goToState(detailState, {
                    'operationId': operation.operationId,
                    'payrollId': operation.payrollId,
                    'operationType': opeType
                });
            } else {
                detailState = 'app.processes.operations.edit';
                $log.log(operation);
                if (operation.status >= 3 && !operation.version) {
                    detailState = 'app.processes.operations.update';
                }
                AppF.goToState(detailState, {
                    'operationId': (operation == 'new') ? operation : operation.$id,
                    'operation': operation,
                    'operations': $scope.operations[$scope.tabName],
                    'payrollId': operation.payroll,
                    'calendarYear': operation.calendar,
                    //'periods': $scope.periods,
                    'period': (operation.period) ? operation.period : false,
                    'operationType': ['ordinary', 'ordinariesNotDoIt', 'ordinariesDoIt'].indexOf($scope.tabName) > -1 ? "ordinary" : undefined
                });
            }
        }
        $scope.setTabName = function (tabName) {
            $scope.tabName = tabName;
            if ($scope.selected.length > 0) {
                $scope.selected = [];
            }
            loadData(AppF.search.$payroll);
            if ($sessionStorage.tab) {
                $sessionStorage.tab['operations'] = $scope.selectedTab;
            } else {
                $sessionStorage.tab = {
                    operations: $scope.selectedTab
                }
            }
            $log.debug($scope.tabName, $scope.selectedTab, 'tab setted in $sessionStorage');
        }

        $scope.loadOperations = function (payrollId, calendarId) {
            $scope.operations.ordinary = $firebaseArray(root.child('catalogs/operations/ordinary').child(payrollId).child(calendarId).child('collection').orderByChild('period'));
            $scope.operations.ordinary.$loaded(function (operations) {
                $scope.operations.ordinary = operations;
                $log.debug('operations loaded', $scope.operations.ordinary, payrollId, calendarId);
            });
        }

        $scope.loadExtraordinaryOperations = function (payrollId, calendarId, status) {
            $scope.operations.extraordinary = $firebaseArray(root.child('catalogs/operations/extraordinary').child(payrollId).child(calendarId).child('collection'));
            $scope.operations.extraordinary.$loaded(function (operations) {
                $scope.operations.ordinary = operations;
                $log.debug('operations loaded', $scope.operations.extraordinary, payrollId, calendarId);
            });
        }

        $scope.loadPeriods = function (payrollId, calendarId) {
            $scope.periods = $firebaseArray(root.child('catalogs/payrollCalendars').child(payrollId).child('periods').child(calendarId));
            $scope.periods.$loaded(function (periods) {
                $scope.periods = periods;
            });
        }

        $scope.loadCalendars = function (payrollId) {
            $scope.calendars = $firebaseArray(root.child('catalogs/payrollCalendars').child(payrollId).child('calendars'));
            $scope.calendars.$loaded(function (calendars) {
                $scope.calendars = calendars;
            });
        }

        $scope.cancelOperationModal = function (ev, operation) {
            $log.debug('cancelOperationModal', operation);
            var title = 'Se cancelará la operación y si tiene una dispersión será borrada.';
            var msg = 'Quiere continuar?';
            $mdDialog.show($mdDialog.confirm(confirmConfig)
                .title(title)
                .content(msg)
                .ariaLabel('Cancelling Operation')
                .targetEvent(ev)
                .ok('Si')
                .cancel('Cancelar'))
                .then(function () {
                    // se borra dispersión si hay
                    if (operation.dispersion) {
                        deleteDispersion(operation.dispersion);
                    }
                    // se borra el mapa de empleados para que se vuelba a formar al abrirse
                    operation.employees = null;
                    // mover operación a status 0
                    $scope.moveOperation(operation, 0);
                    // @todo preguntar al contador si hay que cancelar temporalmente las incidencias rápidas o hacer algo más.
                }, function () {
                    $log.debug('Cancelling Cancelled');
                });
        }

        $scope.openOperationMenu = function ($mdOpenMenu, ev) {
            //originatorEv = ev;
            $mdOpenMenu(ev);
        };

        $scope.moveOperation = function (operation, status, promise) {
            $log.debug('moveOperation', operation, status);
            $rootScope.loadingProgress = true;
            operation = constructStatusNodeFilter(operation, status); // agrega nodo para status con tiempo, usuario, ip, etc
            operation.status = status;
            operation.updated = $scope.D.getTimeObject();
            if (promise) {
                return $scope.save(operation, 1);
            } else {
                $scope.save(operation, 1).then(function () {
                    successAlertS('Status de Operación actualizado a ' + operationStatusNameFilter(status));
                }, errAlertS).then(function () {
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                });
            }
        }

        $scope.addOperation = function (calendar, period, payrollId, tabName, msg) {
            var operation = {
                status: -1,
                period: period,
                calendar: calendar,
                payroll: payrollId,
                firm: getSomethingOfArrayFBFilter(payrollId, $scope.L.allPayrolls, 'firm'),
                created: DataF.getTimeObject(),
                type: tabName
            };
            if (msg) operation.comments = msg;
            $log.debug(operation, 'adding operation');
            return root.child('catalogs/operations').child(tabName).child(payrollId).child(calendar).child('collection').push(operation);
        }

        $scope.allowToAcces = function (operation, operations, status) {
            var flag = true;
            if ($scope.tabName === 'ordinary') {
                var periods = filterFilter(operations, {
                    period: parseInt(operation.period) - 1,
                    type: 'automatic'
                }, true);
                if (periods.length) {
                    for (var p in periods) {
                        var period = periods[p];
                        if (period.status != 0 && period.status < status) {
                            flag = false;
                        }
                    }
                }
                if (!flag) {
                    errAlertS("Debe cerrarse el periodo anterior");
                }
            }
            return flag;
        }

        $scope.save = function (operation, promise) {
            $log.debug('saving operation', operation);
            $rootScope.loadingProgress = true;
            operation.updated = $scope.D.getTimeObject();
            var operationsRef = 'catalogs/operations/' + $scope.tabName + '/' + operation.payroll + '/' + operation.calendar + '/collection';
            var object = clearObjectFilter(operation);
            if (promise) {
                return root.child(operationsRef).child(operation.$id).set(object);
            } else {
                root.child(operationsRef).child($scope.operation.$id).set(object).then(function () {
                    successAlertS('Se guardó operación con éxito');
                }, errAlertS).then(function () {
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                });
            }
        }
        $scope.deleteOp = function (e) {
            var msg = 'No podrá recuperar sus datos.'
            var title = 'Quiere borrar ' + $scope.selected.length + ' Operaciones?';
            $mdDialog.show($mdDialog.confirm(confirmConfig)
                .title(title)
                .htmlContent(msg)
                .ariaLabel('Deleting')
                .targetEvent(e)
                .ok('Borrar')
                .cancel('Cancelar'))
                .then(function () {
                    $rootScope.loadingProgress = true;
                    $log.debug('Deleting: ', $scope.selected);
                    var updates = {};
                    var newData = angular.fromJson(angular.toJson($scope.data[$scope.tabName].items));
                    var typeOperation = $scope.tabConfig[$scope.tabName].objectName;
                    angular.forEach($scope.selected, function (operation) {
                        updates['catalogs/operations/' + typeOperation + '/all/' + operation.$id] = null;
                        var index = $scope.data.settlements.items.findIndex(function (value) {
                            return value.$id === operation.$id;
                        });
                        newData.splice(index, 1);
                    });
                    $scope.F.root.update(updates).then(function () {
                        $scope.data[$scope.tabName].items = newData;
                        successAlertS('Borrando ' + $scope.selected.length + ' Operaciones');
                        $scope.selected = [];
                        $scope.$evalAsync();
                    })
                }, function () {
                    $log.debug('Deleting Cancelled');
                }).then(function () {
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                });
        }
        $scope.delete = function (e) {
            var deleteInCascade = isThereDeleteInCascadeFilter('catalogs', 'operations');
            var msg = (deleteInCascade) ?
                constructMsgFilter('Cuidado!! Esto ocacionará que se borren datos relacionados en cascada: ', deleteInCascade, false, 'menuName') :
                '';
            msg += (!AppF.safeDelete.payroll) ?
                'No podrá recuperar sus datos.' :
                'Podrá recuperar sus datos en la papelera.';
            var title = 'Quiere borrar ' + $scope.selected.length + ' Operaciones?';

            $mdDialog.show($mdDialog.confirm(confirmConfig)
                .title(title)
                .htmlContent(msg)
                .ariaLabel('Deleting')
                .targetEvent(e)
                .ok('Borrar')
                .cancel('Cancelar'))
                .then(function () {
                    var count = 0;
                    $log.debug('Deleting: ', $scope.selected);
                    angular.forEach($scope.selected, function (operation) {
                        if (AppF.safeDelete.operations) {

                        } else {
                            remove(operation).then(function () {
                                count++
                                if (count == $scope.selected.length) {
                                    successAlertS('Se borraron ' + count + ' Operaciones');
                                    $scope.selected = [];
                                }
                            }, errAlertS);
                        }
                    });
                }, function () {
                    $log.debug('Deleting Cancelled');
                });
        }

        var allLoadedInitiated = $rootScope.$on('allLoaded', function (allLoaded) {
            if (allLoaded && !initiated) {
                init();
                allLoadedInitiated();
            }
        });
        if (AppF.profile && !initiated) {
            if (AppF.profile.uid) {
                init();
            }
        }

        watchers.currentPage = $scope.$watchGroup(['currentPageO.ordinary', 'currentPageP'], function (cp, vp) {
            if (cp[0] !== vp[0]) {
                AppF.setCurrentPage(cp[0], 'clients', 'operations');
                $log.debug('setting currentPage of Operations', cp[0], $scope.currentPageO);
            }
            if (cp[1] !== vp[0]) {
                AppF.setCurrentPage(cp[1], 'clients', 'periods');
                $log.debug('setting currentPage of Periods', cp[1], $scope.currentPageP);
            }
        });

        watchers.payroll = $scope.$watch('F.search.$payroll', function (payroll) {
            if (payroll) {
                $scope.loadCalendars(payroll);
                $scope.F.search.operations.calendar = false;
                $scope.F.search.operations.period = false;
                $scope.selected = [];
                $state.go($scope.mainState, {
                    payrollId: payroll
                }, {
                    notify: false
                });
            } else {
                $scope.calendars = [];
                $state.go($scope.mainState, {
                    payrollId: undefined
                }, {
                    notify: false
                });
            }
            if ($scope.tabConfig.hasOwnProperty($scope.tabName)) {
                loadData(AppF.search.$payroll);
            }
        });

        watchers.calendar = $scope.$watch('F.search.operations.calendar', function (calendar) {
            if (calendar) {
                if (AppF.search.$payroll && $scope.tabName == 'ordinary') {
                    $scope.loadOperations(AppF.search.$payroll, calendar);
                    // $scope.loadPeriods(AppF.search.$payroll, calendar);
                    $scope.getValidations();
                    $state.go($scope.mainState, {
                        payrollId: AppF.search.$payroll,
                        calendarYear: calendar
                    }, {
                        notify: false
                    });
                }
            } else {
                // $scope.periods = [];
                $scope.operations.ordinary = [];
                $state.go($scope.mainState, {
                    payrollId: (AppF.search.$payroll) ? AppF.search.$payroll : undefined,
                    calendarYear: undefined,
                    period: undefined
                }, {
                    notify: false
                });
            }
        });

        watchers.calendars = $scope.$watch('calendars', function (calendars) {
            if (calendars && typeof (calendars) == "object") {
                angular.forEach(calendars, function (calendar, key) {
                    if (calendar.$id == $scope.thisYear) {
                        AppF.search.operations.calendar = $scope.thisYear;
                        return false;
                    }
                });
            }
        }, true);

        function loadData(payrollId) {
            console.log(catalog, $scope.tabName);
            if ($scope.tabName === 'settlementsNotDoIt') {
                getSettlementNotDoIt();
            } else if ($scope.tabName === 'ordinariesNotDoIt') {
                getOrdinariesNotDoIt();
            } else if ($scope.tabName === 'ordinariesDoIt') {
                getOrdinariesDoIt();
            } else if ($scope.tabConfig.hasOwnProperty($scope.tabName)) {
                var catalog = $scope.tabConfig[$scope.tabName].objectName;
                if (angular.isUndefined(AppF.allRecordOfProcess)) {
                    AppF.allRecordOfProcess = {};
                }

                if (angular.isUndefined(AppF.allRecordOfProcess[$scope.tabName]) && !AppF.search.$payroll) {

                    AppF.allRecordOfProcess[$scope.tabName] = $scope.F.paginator($scope.F.root.child('catalogs/operations/' + catalog + '/all'), 100, 'created/atTime', 'loadingData');
                    $scope.data[$scope.tabName] = AppF.allRecordOfProcess[$scope.tabName];
                } else {
                    if (!AppF.search.$payroll) {
                        $scope.data[$scope.tabName] = AppF.allRecordOfProcess[$scope.tabName];
                    } else {
                        $rootScope.loadingProgress = true;
                        var promises = [];
                        if (angular.isDefined(payrollId) && payrollId !== false) {
                            promises.push(ListsF.loadList('operations', 'catalogs/operations/' + catalog + '/payroll/' + payrollId, false, 'array', catalog + '-' + payrollId));
                        }
                        Promise.all(promises).then(function (data) {
                            $scope.data[$scope.tabName] = {
                                items: data[0],
                                forPayroll: true
                            }
                            $rootScope.loadingProgress = false;
                            $rootScope.$evalAsync();
                        });
                    }
                }
            }
        }
        function getSettlementNotDoIt() {
            ListsF.loadList('operations', 'catalogs/operations/settlement/all', false, 'array', 'settlementNotDoIt-all', [{ q: 'orderByChild', v: 'status' }, { q: 'startAt', v: 3 }, { q: 'endAt', v: 5.9 }]).then(function (data) {
                $scope.data['settlementsNotDoIt'] = {
                    items: data
                }
                $rootScope.$evalAsync();
            }).catch(function (error) {
                errAlertS(error);
            })
        }
        function getOrdinariesNotDoIt() {
            ListsF.loadList('operations', 'catalogs/operations/ordinary/all', false, 'array', 'ordinariesNotDoIt-all', [{ q: 'orderByChild', v: 'status' }, { q: 'startAt', v: 3 }, { q: 'endAt', v: 5.9 }]).then(function (data) {
                $scope.data['ordinariesNotDoIt'] = {
                    items: data
                }
                $rootScope.$evalAsync();
            }).catch(function (error) {
                errAlertS(error);
            })
        }

        function getOrdinariesDoIt() {
            ListsF.loadList('operations', 'catalogs/operations/ordinary/all', false, 'array', 'ordinariesDoIt-all', [{ q: 'orderByChild', v: 'status' }, { q: 'equalTo', v: 6 }]).then(function (data) {
                $scope.data['ordinariesDoIt'] = {
                    items: data
                }
                $rootScope.$evalAsync();
            }).catch(function (error) {
                errAlertS(error);
            })
        }

        $scope.getMoreResults = function () {
            console.log($scope.data[$scope.tabName].loadMoreButton);
            if ($scope.data[$scope.tabName].loadMoreButton) {
                $scope.initialLoadMoreText = 'Cargando...';
                $rootScope.$evalAsync(function () {
                    $log.log('getting more');
                });
                $scope.data[$scope.tabName].loadMore();
            }
        };
        $scope.$on('autoScrollBottom', function () {
            if (!AppF.search.$payroll) {
                $log.log('autoScrollBottom');
                $scope.getMoreResults();
            }
        });
        var loadingData = $rootScope.$on('loadingData', function () {
            $scope.initialLoadMoreText = 'Cargar mas resultados';
            $rootScope.$evalAsync();
        });
        $scope.$on('$destroy', function () {
            loadingData();
        });
        watchers.status = $scope.$watch('F.search.operations.status', function (status) {
            if (status) {
                if (AppF.search.$payroll && AppF.search.operations.calendar) {
                    $scope.loadExtraordinaryOperations(AppF.search.$payroll, AppF.search.operations.calendar, status);
                    $scope.getValidations();
                }
            } else {
                $scope.operations.extraordinary = [];
            }
        });
        $scope.startToBill = function (ev, operation, operationType) {
            console.log(operation);
            var title = "Esta seguro de proceder con el timbrado?"
            var msg = "La factura se timbrara y no podrá cancelarlo en el proceso";
            $mdDialog.show($mdDialog
                .confirm(confirmConfig)
                .title(title)
                .htmlContent(msg)
                .ariaLabel('Deleting')
                .targetEvent(ev)
                .ok('SI')
                .cancel('NO'))
                .then(function () {
                    if (operation.status >= 6) {
                        successAlertS('Esta operación ya se encuentra facturada en su totalidad');
                    } else if (operation.status < 3) {
                        errAlertS('Debe cerrar la nomina antes de realizar el timbrado de los datos')
                    } else {
                        var updates = {}
                        updates['billing'] = true;
                        updates['status'] = 4;
                        updates['billingDate'] = DataF.getCurrentServerTime();
                        var ref;
                        if (["ordinariesNotDoIt", "ordinary"].indexOf(operationType) > -1) {
                            ref = 'catalogs/operations/ordinary/' + operation.payroll + '/' + operation.calendar + '/collection';
                        } else if (["settlements", "settlementsNotDoIt"].indexOf(operationType) > -1) {
                            ref = 'catalogs/operations/settlement/all';
                        }
                        if (angular.isDefined(ref)) {
                            console.log(ref + '/' + operation.$id)
                            $scope.F.root.child(ref + '/' + operation.$id).update(updates).then(function (success) {
                                successAlertS('Se inicio el proceso de facturacion');
                            }).catch(errAlertS);
                        } else {
                            errAlertS("No se encontro la referencia del objeto");
                        }

                    }
                }, function () {
                    $log.debug('Deleting Cancelled');
                });
        }
        function getSettlement(currentOp, employees, action) {
            return new Promise(function (resolve, reject) {
                if (action === 'edit') {
                    AppF.root.child('catalogs/operations/settlement/all/').orderByChild('movement/date').equalTo(currentOp.movement.date).once('value').then(function (snap) {
                        var doIt = false;
                        if (snap.exists()) {
                            var operation = snap.val();
                            for (var opId in operation) {
                                var employeesObj = operation[opId].employees;
                                if (opId !== currentOp.$id) {
                                    if (employeesObj.hasOwnProperty(employees.$id) && employeesObj[employees.$id].status >= 3) {
                                        doIt = true;
                                        break;
                                    }
                                }
                            }
                        }
                        if (doIt) {
                            throw "No se puede editar los datos de la operación debido a que hay un finiquito cerrado con la misma fecha " + moment(currentOp.movement.date).format('DD/MM/YYYY');;
                        } else {
                            resolve(false);
                        }
                    }).catch(function (error) {
                        reject(error);
                    })
                } else {
                    resolve(false);
                }
            })
        }
        $scope.toggle = function (item, list) {
            var idx = list.findIndex(function (employee) {
                return employee.$id === item.$id;
            });
            if (idx > -1) {
                list.splice(idx, 1);
            } else {
                list.push(item);
            }
        };
        $scope.exists = function (item, list) {
            return list.findIndex(function (employee) {
                return employee.$id === item.$id;
            }) > -1;
        };
        $scope.checkStatus = function (selected) {
            var status = selected.find(function (value) {
                return value.status < 3;
            });
            return (angular.isUndefined(status)) ? true : false;
        }
        $scope.exportConcentrate = function (settlements) {
            var data = [];
            for (var i = 0; i < settlements.length; i++) {
                var employees = settlements[i].employees;
                for (var k in employees) {
                    data.push({ dispersionId: settlements[i].dispersion, employeeId: k, ccId: employees[k].cc });
                }
            }
            var obj = {
                data: angular.toJson(data),
                filename: 'CONCENTRADO_DE_' + settlements.length + '_EMPLEADOS'
            }
            CatalogsF.exportToExcel('interface/exportConcentrateToSettlements', obj);
        }
        $scope.exportAccumulate = function (selected) {
            var data = [];
            for (var i = 0; i < selected.length; i++) {
                data.push({ operationId: selected[i].$id, dispersionId: selected[i].dispersion, payrollId: selected[i].payroll });
            }
            var obj = {
                data: angular.toJson(data),
                filename: 'ACUMULADOS_DE_EMPLEADOS'
            }
            CatalogsF.exportToExcel('interface/exportAccumulate', obj);
        }
        $scope.generateAccountingAccount = function (selected) {
            var operations = [];
            var promises = [];
            for (var s = 0; s < selected.length; s++) {
                operations.push({ operationId: selected[s].$id, dispersionId: selected[s].dispersion, payrollId: selected[s].payroll, calendar: selected[s].calendar, period: selected[s].period });
                promises.push(AppF.root.child('catalogs/dispersions/collection/' + selected[s].dispersion + '/data/process').once('value'));
            }
            Promise.all(promises).then(function (resp) {
                if (resp.length > 0) {
                    for (var r = 0; r < resp.length; r++) {
                        if (resp[r].exists()) {
                            var process = resp[r].val();
                            for (var p = 0; p < process.length; p++) {
                                if (['fiscal', 'socialPrevision'].indexOf(process[p].id) > -1) {
                                    var merge = Object.assign({ process: process[p].id }, operations[r]);
                                    var obj = {
                                        data: angular.toJson([merge]),
                                        nameF: "exportAccount"
                                    }
                                    CatalogsF.exportToExcel('interface/exportAnyFiles', obj);
                                }
                            }
                        }
                    }
                } else {
                    throw "No se encontrarón los procesos de la operación";
                }
            }).catch(function (error) {
                errAlertS(error);
            })
        }
        $scope.checkStatusOp = function (selected) {
            var status = selected.find(function (value) {
                return value.status < 6;
            });
            return (angular.isUndefined(status)) ? true : false;
        }
        $scope.downloadZipBill = function (selected) {
            var operations = [];
            var promises = [];
            if (selected.length > 0) {
                for (var s = 0; s < selected.length; s++) {
                    operations.push({ operation: selected[s].$id, dispersion: selected[s].dispersion, calendar: selected[s].calendar, period: selected[s].period, payroll: selected[s].payroll });
                    promises.push(AppF.root.child('catalogs/payrolls/collection/' + selected[s].payroll + '/data/class').once('value'));
                }
                Promise.all(promises).then(function (resp) {
                    if (resp.length > 0) {
                        for (var r = 0; r < resp.length; r++) {
                            if (resp[r].exists()) {
                                var payrollClass = resp[r].val();
                                var thisCenter = AppF.center.toUpperCase();
                                var params = {
                                    dispersionId: operations[r].dispersion,
                                    operationId: operations[r].operation,
                                    opType: 'ordinary',
                                    filename: thisCenter + ((operations[r].calendar) ? '_' + operations[r].calendar + '_' : '') + payrollClass + '_ORDINARI' + ((operations[r].period) ? '_' + (operations[r].period > 9 ? operations[r].period : "0" + operations[r].period) : '')
                                }
                                downloadFile('models/bill/getBillZipAll', params);
                            } else {
                                throw "No se encontró la clase de la nómina con ID " + operations[r].payroll;
                            }
                        }
                    } else {
                        throw "No se encontró la clase de la nómina";
                    }
                }).catch(function (error) {
                    errAlertS(error);
                });
            } else {
                errAlertS("Favor de seleccionar alguna operación");
            }
        }
        function downloadFile(path, params) {
            $rootScope.loadingProgress = true;
            $http({
                method: 'POST',
                url: window.__env.serviceWorkerUrl + path,
                responseType: 'arraybuffer',
                data: params
            }).then(function (response) {
                var headers = response.headers();
                var filename = headers['x-filename'];
                var contentType = headers['content-type'];
                var linkElement = document.createElement('a');
                try {
                    var blob = new Blob([response.data], {
                        type: contentType
                    });
                    var url = window.URL.createObjectURL(blob);
                    linkElement.setAttribute('href', url);
                    linkElement.setAttribute("download", filename);
                    var clickEvent = new MouseEvent("click", {
                        "view": window,
                        "bubbles": true,
                        "cancelable": false
                    });
                    linkElement.dispatchEvent(clickEvent);
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync(function () {
                        $log.debug('generatePdf finished');
                    });
                } catch (ex) {
                    $log.error(ex, "error descargando el archivo");
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                }
            }).catch(function (err) {
                var message = new TextDecoder("utf-8").decode(err.data);
                var error = angular.fromJson(message);
                errAlertS(error.data || error.message);
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
            });
        }
        $scope.moveCalculations = function (operation, ev) {
            $mdDialog.show({
                templateUrl: 'app/main/clients/views/operations/dialogs/change-period.html',
                parent: angular.element($document.body),
                locals: {
                    operation: operation
                },
                controller: function (scope, operation, ListsF, userHasPermissionFilter) {
                    var moveToClosedPeriods = userHasPermissionFilter(AppF.groupsOfUser, AppF.permissions, 'moveToClosedPeriods', 'processes.operations');
                    var queries = [
                        ListsF.loadList('periods', 'catalogs/payrollCalendars/' + operation.payroll + '/periods/' + operation.calendar, undefined, 'array', 'periodsof-' + operation.payroll),
                        ListsF.loadList('periods', 'catalogs/closeOperations/collection', undefined, 'array', 'lastClosedOperation-', [{ q: 'orderByChild', v: 'date' }, { q: 'limitToLast', v: 1 }])
                    ];
                    Promise.all(queries).then(function (resp) {
                        if (!moveToClosedPeriods) {
                            var lastDateClosed = angular.isArray(resp[1]) && resp[1].length > 0 ? resp[1][0].date : 0;
                            scope.periods = resp[0].filter(function (item) {
                                return item.accuDate > lastDateClosed;
                            })
                        } else {
                            scope.periods = resp[0];
                        }
                    }).catch(errAlertS);
                    scope.operation = operation;
                    scope.hide = function () {
                        $mdDialog.hide();
                    };
                    scope.moveCalculations = function (periodSelected) {
                        $rootScope.loadingProgress = true;
                        $rootScope.$evalAsync();
                        $timeout(function () {
                            var params = {
                                page: 0.5,
                                size: 0.5,
                                'operationId': scope.operation.$id
                            }
                            $rootScope.D.api.get('p/calculations', params).then(function (resp) {
                                var calculations = getFromObjectFilter(resp, 'data.data', []);
                                var promises = [];
                                var updates = {};
                                updates['operations/settlement/all/' + operation.$id + '/period'] = periodSelected.period;
                                updates['operations/settlement/all/' + operation.$id + '/start'] = periodSelected.start;
                                updates['operations/settlement/all/' + operation.$id + '/end'] = periodSelected.end;
                                updates['dispersions/collection/' + operation.dispersion + '/data/period'] = periodSelected.period;
                                updates['dispersions/collection/' + operation.dispersion + '/data/accuDate'] = periodSelected.accuDate;
                                promises.push(AppF.root.child('catalogs').update(updates))
                                for (var c = 0; c < calculations.length; c++) {
                                    var data = clearObjectFilter(calculations[c]);
                                    data.accuDate = periodSelected.accuDate;
                                    data.period = periodSelected.period;
                                    promises.push($scope.D.api.update('calculations', calculations[c]._id, data))
                                }
                                return Promise.all(promises);
                            }).then(function () {
                                successAlertS('Se movió la operación con éxito');
                                scope.hide();
                            }).catch(errAlertS).then(function () {
                                $rootScope.loadingProgress = false;
                                $rootScope.$evalAsync();
                            });
                        }, 0, false);
                    }
                    scope.cancel = function () {
                        $mdDialog.cancel();
                    };
                },
                targetEvent: ev,
                clickOutsideToClose: false
            });


        }
        $scope.uploadFiles = function (selected) {
            $rootScope.loadingProgress = true;
            var obj = {
                operationId: selected[0].$id,
                dispersionId: selected[0].dispersion,
                payroll: selected[0].payroll,
                period: selected[0].period,
                calendar: selected[0].calendar
            }
            $http.post($window.__env.serviceWorkerUrl + 'models/bill/uploadFiles', obj).then(function (resp) {
                $rootScope.loadingProgress = false;
                successAlertS(resp.data);
            }).catch(function (error) {
                var message = error;
                if (getFromObjectFilter(error, 'data')) {
                    message = error.data;
                }
                $rootScope.loadingProgress = false;
                $log.error(error);
                errAlertS(message);
            })
        }
        startAfterInitFilter($scope, watchers, initiated, init);
    }
})();
(function () {
    'use strict';

    angular
        .module('app.clients')
        .controller('OperationsController', OperationsController);

    function OperationsController($scope, AppF, $mdDialog, $log, $filter, successAlertS, errAlertS, $document, $rootScope, confirmConfig, $timeout, $http, $window, $q, ListsF) {
        function getSettlement(currentOp, employees, action) {
            return new Promise(function (resolve, reject) {
                if (action === 'edit') {
                    $scope.F.root.child('catalogs/operations/settlement/all/').orderByChild('movement/date').equalTo(currentOp.movement.date).once('value').then(function (snap) {
                        var doIt = false;
                        snap.forEach(function (childSnap) {
                            var employeesObj = childSnap.val().employees;
                            var opId = childSnap.key;
                            if (opId !== currentOp.$id && employeesObj.hasOwnProperty(employees.$id) && employeesObj[employees.$id].status >= 3) {
                                doIt = true;
                                return;
                            }
                        });
                        if (doIt) {
                            throw 'No se puede editar los datos de la operación debido a que hay un finiquito cerrado con la misma fecha ' + moment(currentOp.movement.date).format('DD/MM/YYYY');
                        } else {
                            resolve(false);
                        }
                    }).catch(function (error) {
                        reject(error);
                    });
                } else {
                    resolve(false);
                }
            });
        }
        $scope.goToDetail = function (operation) {
            var opeType = operation.operationType;
            var detailState = 'app.processes.operations.edit';
            var params = {
                'operationId': operation.$id,
                'payrollId': opeType === 'ptuDistributionRecord' ? 'all' : operation.payroll,
                'operationType': opeType,
                'calendarYear': operation.calendar ? operation.calendar : null,
                'period': operation.period ? operation.period : null
            };
            if (opeType !== 'ordinary') {
                if (opeType === 'settlement') {
                    detailState = 'app.processes.operations.editSettlement';
                } else {
                    detailState = 'app.processes.operations.editSpecial';
                }
            }
            $scope.F.goToState(detailState, params);
        };

        function deleteValidation(e) {
            var msg = 'No podrá recuperar sus datos.';
            var title = 'Quiere borrar ' + $scope.selected.length + ' Operaciones?';
            var typeOperation = $scope.tabConfig.objectName;
            $mdDialog.show($mdDialog.confirm(confirmConfig)
                .title(title)
                .htmlContent(msg)
                .ariaLabel('Deleting')
                .targetEvent(e)
                .ok('Borrar')
                .cancel('Cancelar'))
                .then(function () {
                    $rootScope.loadingProgress = true;
                    var params = {
                        page: 0.5,
                        size: 0.5
                    };
                    var promises = [];
                    for (var s = 0; s < $scope.selected.length; s++) {
                        var operation = $scope.selected[s];
                        var thisP = angular.fromJson(angular.toJson(params));
                        thisP[typeOperation] = operation.$id;
                        promises.push($rootScope.D.api.get('p/incidences', thisP));
                    }
                    return Promise.all(promises);
                }).then(function (resp) {
                    var updates = {};
                    for (var s = 0; s < $scope.selected.length; s++) {
                        var operation = $scope.selected[s];
                        updates['catalogs/operations/' + typeOperation + '/all/' + operation.$id] = null;
                        var incidences = $filter('getFromObject')(resp[s], 'data.data', []);
                        for (var c = 0; c < incidences.length; c++) {
                            var thisIncidence = incidences[c];
                            if (thisIncidence.status < 3) {
                                updates['incidences/' + thisIncidence.payroll + '/' + thisIncidence.calendar + '/' + thisIncidence.fid] = null;
                            }
                        }
                    }
                    return $scope.F.root.update(updates);
                }).then(function () {
                    if (typeOperation === 'settlement') {
                        deleteIncidencesSettLements($scope.selected)
                    }
                    successAlertS('Borrando ' + $scope.selected.length + ' Operaciones');
                    $scope.selected = [];
                }).catch(function (error) {
                    if (angular.isDefined(error)) {
                        errAlertS(error);
                    }
                    $log.debug('Deleting Cancelled');
                }).then(function () {
                    $rootScope.loadingProgress = false;
                    $scope.$evalAsync();
                    $timeout(function () { }, 0, false);
                });
        }


        function deleteIncidencesSettLements(selected) {
            var ids = selected[0].fid
            $scope.D.api.get('incidences', { settlement: ids }).then(function (resp) {
                var updates = {};
                var data = resp.data;
                for (var i = 0; i < data.length; i++) {
                    var incidences = data[i];
                    var fidIncidences = incidences.fid;
                    updates['incidences/' + incidences.payroll + '/' + incidences.calendar + '/' + fidIncidences] = null;
                }
                return updateCatalog(updates);

            })
        }

        function updateCatalog(updates) {
            return $scope.F.root.child('catalogs/').update(updates);
        }

        $scope.deleteOp = function (e) {
            var selected = $scope.selected[0];
            var fidOperation = selected.$id;
            var idPayroll = selected.payroll;
            var calendar = selected.calendar;
            var operationType = selected.operationType;
            $log.log(selected)

            var promise;
            if (operationType === 'ordinary') {
                promise = $scope.F.root.child('catalogs/operations/ordinary/' + idPayroll + '/' + calendar + '/collection/' + fidOperation + '/status').once('value');
            } else {
                promise = $scope.F.root.child('catalogs/operations/' + operationType + '/all/' + fidOperation + '/status').once('value');
            }
            promise.then(function (response) {
                var datos = response.val()
                if (datos < 3) {
                    deleteValidation(e)
                } else {
                    errAlertS('No se puede eliminar por que esta cerrada');
                }
            });
        };
        function downloadFile(path, params) {
            $rootScope.loadingProgress = true;
            $http({
                method: 'POST',
                url: $window.__env.serviceWorkerUrl + path,
                responseType: 'arraybuffer',
                data: params
            }).then(function (response) {
                $log.log('finished');
                var headers = response.headers();
                var filename = headers['x-filename'];
                var contentType = headers['content-type'];
                var linkElement = document.createElement('a');
                try {
                    var blob = new Blob([response.data], {
                        type: contentType
                    });
                    var url = $window.URL.createObjectURL(blob);
                    linkElement.setAttribute('href', url);
                    linkElement.setAttribute('download', filename);
                    var clickEvent = new MouseEvent('click', {
                        'view': window,
                        'bubbles': true,
                        'cancelable': false
                    });
                    linkElement.dispatchEvent(clickEvent);
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync(function () {
                        $log.debug('generatePdf finished');
                    });
                } catch (ex) {
                    $log.error(ex, 'error descargando el archivo');
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                }
            }).catch(function (err) {
                $log.log(err);
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
                var message = new TextDecoder('utf-8').decode(err.data);
                var error = angular.fromJson(message);
                errAlertS(error.data || error.message);
            });
        }
        $scope.startToBill = function (ev, operation) {
            $rootScope.loadingProgress = true;
            var promise;
            var operationType = operation.operationType;
            if (operationType === 'ordinary') {
                promise = $scope.F.root.child('catalogs/operations/ordinary/' + operation.payroll + '/' + operation.calendar + '/collection/' + operation.$id + '/status').once('value');
            } else {
                promise = $scope.F.root.child('catalogs/operations/' + operationType + '/all/' + operation.$id + '/status').once('value');
            }
            promise.then(function (statusSnap) {
                var status = statusSnap.val();
                if (!statusSnap.exists()) {
                    throw 'No se encontró la operación';
                } else if (status < 3) {
                    throw 'Aun no se puede timbrar esta operación, debe cerrarse primero';
                } else if (status > 5) {
                    throw 'Esta operación ya ha sido facturada';
                } else if (status === 4) {
                    throw 'La operación esta en proceso de timbrado';
                }
                var title = 'Esta seguro de proceder con el timbrado?';
                var msg = 'La factura se timbrara y no podrá cancelarlo en el proceso';
                $rootScope.loadingProgress = false;
                return $mdDialog.show($mdDialog
                    .confirm(confirmConfig)
                    .title(title)
                    .htmlContent(msg)
                    .ariaLabel('Deleting')
                    .targetEvent(ev)
                    .ok('SI')
                    .cancel('NO'));
            }).then(function () {
                $rootScope.loadingProgress = true;
                var updates = {};
                updates['billing'] = true;
                updates['status'] = 4;
                updates['billingDate'] = $scope.D.getCurrentServerTime();
                var ref;
                if (operationType === 'ordinary') {
                    ref = 'catalogs/operations/ordinary/' + operation.payroll + '/' + operation.calendar + '/collection';
                } else {
                    ref = 'catalogs/operations/' + operationType + '/all';
                }
                return $scope.F.root.child(ref + '/' + operation.$id).update(updates);
            }).then(function () {
                successAlertS('Se inicio el proceso de facturación');
            }).catch(function (error) {
                if (angular.isDefined(error)) {
                    errAlertS(error);
                }
            }).then(function () {
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
            });
        };
        $scope.cleanCalculations = function (operation, ev) {
            var title = 'Esta seguro de proceder la eliminación de datos?';
            var msg = 'Los datos se eliminarán y no podra recuperarlos';
            $mdDialog.show($mdDialog
                .confirm(confirmConfig)
                .title(title)
                .htmlContent(msg)
                .ariaLabel('Deleting')
                .targetEvent(ev)
                .ok('SI')
                .cancel('NO'))
                .then(function () {
                    $rootScope.loadingProgress = true;
                    $timeout(function () {
                        var updates = {};
                        var promises = [];
                        updates['operations/ordinary/' + operation.payroll + '/' + operation.calendar + '/collection/' + operation.$id] = null;
                        if (operation.dispersion) {
                            updates['dispersions/collection/' + operation.dispersion] = null;
                            var params = {
                                page: 0.5,
                                size: 0.5,
                                'idDispersion': operation.dispersion
                            };
                            promises.push($rootScope.D.api.get('p/calculations', params));
                        }
                        Promise.all(promises).then(function (resp) {
                            var promises = [];
                            if (resp.length > 0) {
                                var calculations = $filter('getFromObject')(resp[0], 'data.data', []);
                                for (var c = 0; c < calculations.length; c++) {
                                    var thisCalculation = calculations[c];
                                    thisCalculation.mid = thisCalculation._id;
                                    delete thisCalculation._id;
                                    thisCalculation = $filter('clearObject')(thisCalculation);
                                    updates['calculationsBackup/collection/' + thisCalculation.mid] = thisCalculation;
                                    promises.push($rootScope.D.api.delete('calculations/' + thisCalculation.mid));
                                }
                            }
                            promises.push($scope.F.root.child('catalogs').update(updates));
                            return Promise.all(promises);
                        }).then(function () {
                            successAlertS('Se termino de eliminar la informacion');
                            $scope.selected = [];
                        }).catch(function (error) {
                            errAlertS(error);
                        }).then(function () {
                            $rootScope.loadingProgress = false;
                            $timeout(function () { }, 0, false);
                        });
                    }, 0, false);

                }, function () {
                    $log.debug('Deleting Cancelled');
                });
        };
        $scope.checkStatusOp = function (selected, statusN) {
            var status = selected.find(function (value) {
                return value.status < statusN;
            });
            return (angular.isUndefined(status)) ? true : false;
        };
        $scope.exportConcentrate = function (settlements) {
            var data = [];
            for (var i = 0; i < settlements.length; i++) {
                var employees = settlements[i].employees;
                for (var k in employees) {
                    if (employees.hasOwnProperty(k)) {
                        data.push({ dispersionId: settlements[i].dispersion, employeeId: k, ccId: employees[k].cc });
                    }
                }
            }
            var obj = {
                data: angular.toJson(data),
                filename: 'CONCENTRADO_DE_' + settlements.length + '_EMPLEADOS'
            };
            $scope.C.exportToExcel('interface/exportConcentrateToSettlements', obj);
        };
        $scope.importCalculationsModalV2 = function (ev) {
            $log.log('importCalculationsModal called');
            $mdDialog.show({
                controller: 'ImportCalculationsController',
                templateUrl: 'app/main/clients/views/operations/dialogs/import-calculationsv2.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                controllerAs: 'impCalcCtrl',
                clickOutsideToClose: false
            }).then(function (answer) {
                $log.debug(answer, 'Import Calculations Modal answer');
            }, function () {
                $log.debug('Import Calculations Modal cancelled');
            });
        };
        $scope.importCalculationsModal = function (ev) {
            $log.log('importCalculationsModal called');
            $mdDialog.show({
                controller: function (scope, DataF, AppF, ListsF, CatalogsF) {
                    var vm = this;
                    scope.L = ListsF;
                    scope.F = AppF;
                    vm.pagination = {
                        limit: 10,
                        limitOption: [5, 10, 50],
                        page: 1
                    };
                    vm.loading = false;
                    scope.close = function () {
                        $mdDialog.hide();
                    };
                    vm.applyCalculations = function () {
                        vm.loading = true;
                        scope.$evalAsync();
                        $filter('applyCalculations')(vm.data, vm.headers, vm.companiesRecord, vm.operationType, vm.allConceptsByKey).then(function () {
                            successAlertS('Se importaron los cálculos con éxito');
                            $mdDialog.hide();
                        }).catch(errAlertS).then(function () {
                            vm.loading = false;
                            scope.$evalAsync(function () {
                                $timeout(function () { }, 0, false);
                            });
                        });
                    };
                    function uploadCsv() {
                        var files = vm.filesArray;
                        $log.log(files);
                        if (angular.isArray(files) && files.length > 0) {
                            vm.loading = true;
                            var formData = new FormData();
                            formData.append('file', files[0].lfFile);
                            var thisConcepts = [];
                            CatalogsF.loadCatalog('concepts', 'lists/concepts/center/' + AppF.center).then(function (thisConceptsR) {
                                thisConcepts = thisConceptsR.slice();
                                return DataF.files.csvToJson(formData);
                            }).then(function (data) {
                                var conceptsByField = $filter('getCOnceptsByKeyAndField')(thisConcepts);
                                vm.allConcepts = conceptsByField.arr;
                                vm.allConceptsByKey = conceptsByField.obj;
                                var recordsData = $filter('formatCalculationsToImport')(data.data, conceptsByField);
                                vm.headers = recordsData.headers;
                                vm.data = recordsData.data;
                                return $filter('validateCalculations')(vm.data);
                            }).then(function (data) {
                                vm.data = data;
                                vm.loading = false;
                                scope.$evalAsync(function () {
                                    $timeout(function () { }, 0, false);
                                });
                            }).catch(function (error) {
                                errAlertS(error);
                                vm.loading = false;
                                scope.$evalAsync(function () {
                                    $timeout(function () { }, 0, false);
                                });
                            });
                        }
                    }
                    var currentStep = 1;
                    var stepperChange = $rootScope.$on('stepCalled', function (event, step) {
                        if (step === 2 && currentStep === 1) {
                            uploadCsv();
                        }
                        currentStep = step;
                    });
                    var onDestroy = $rootScope.$on('$destroy', function () {
                        stepperChange();
                        onDestroy();
                    });
                },
                templateUrl: 'app/main/clients/views/operation/dialogs/import-calculations.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                controllerAs: 'importCalculations',
                clickOutsideToClose: false
            }).then(function (answer) {
                $log.debug(answer, 'importCalculaitonsModal answer');
            }, function () {
                $log.debug('importCalculaitonsModal cancelled');
            });
        };

        $scope.moveCalculations = function (operation, ev) {
            $mdDialog.show({
                templateUrl: 'app/main/clients/views/operations/dialogs/change-period.html',
                parent: angular.element($document.body),
                locals: {
                    operation: operation
                },
                controller: function (scope, operation, ListsF, userHasPermissionFilter) {
                    var vm = this;
                    if (operation.forceBillingDate) {
                        vm.paymentDate = operation.forceBillingDate;
                    }
                    var maxPaymentDate = {
                        tds: function (periodSelected) {
                            vm.minPaymentDate = moment(periodSelected.start).toDate();
                            vm.maxPaymentDate = moment(periodSelected.end).add(3, 'days').toDate();
                        },
                        integratio: function (periodSelected) {
                            vm.minPaymentDate = moment(periodSelected.start).toDate();
                            vm.maxPaymentDate = moment(periodSelected.end).add(3, 'days').toDate();
                        },
                        manopco: function (periodSelected) {
                            vm.minPaymentDate = moment(periodSelected.start).toDate();
                            vm.maxPaymentDate = moment(periodSelected.end).add(3, 'days').toDate();
                        }
                    };
                    scope.setMinMaxPaymentDate = function (periodSelected, setBillingDate) {
                        var thisCenter = AppF.center;
                        if (!maxPaymentDate.hasOwnProperty(thisCenter)) {
                            thisCenter = 'tds';
                        }
                        maxPaymentDate[thisCenter](periodSelected, setBillingDate);
                        delete vm.paymentDate;
                        if (setBillingDate) {
                            var thisPaymentDay = moment(vm.maxPaymentDate.valueOf()).startOf('day').valueOf();
                            if (['ordinary', 'settlement'].indexOf(scope.operation.operationType) === -1 && scope.operation.specialDate >= scope.minPaymentDate.valueOf() && scope.operation.specialDate <= scope.maxPaymentDate.valueOf()) {
                                thisPaymentDay = vm.operation.specialDate;
                            }
                            vm.paymentDate = thisPaymentDay;
                        }
                    };
                    var moveToClosedPeriods = userHasPermissionFilter($scope.F.groupsOfUser, $scope.F.permissions, 'moveToClosedPeriods', 'processes.operations');
                    $log.log(operation.calendar, typeof (operation.calendar), 'catalogs/payrollCalendars/' + operation.payroll + '/periods/' + operation.calendar + 1);
                    var queries = [
                        ListsF.loadList('periods', 'catalogs/payrollCalendars/' + operation.payroll + '/periods/' + operation.calendar, undefined, 'array', 'periodsOf-' + operation.payroll + '-' + operation.calendar),
                        ListsF.loadList('periods', 'catalogs/closeOperations/collection', undefined, 'array', 'lastClosedOperation-', [{ q: 'orderByChild', v: 'date' }, { q: 'limitToLast', v: 1 }]),
                        ListsF.loadList('periods', 'catalogs/payrollCalendars/' + operation.payroll + '/periods/' + (operation.calendar + 1), undefined, 'array', 'periodsOf-' + operation.payroll + '-' + (operation.calendar + 1))
                    ];
                    Promise.all(queries).then(function (resp) {
                        var finalPeriods = [];
                        if (!moveToClosedPeriods) {
                            var lastDateClosed = angular.isArray(resp[1]) && resp[1].length > 0 ? resp[1][0].date : 0;
                            finalPeriods = resp[0].filter(function (item) {
                                return item.accuDate > lastDateClosed;
                            });
                        } else {
                            finalPeriods = resp[0];
                        }
                        finalPeriods = finalPeriods.map(function (item) {
                            item.calendar = operation.calendar;
                            return item;
                        })
                        $log.log(resp[2]);
                        if (angular.isArray(resp[2]) && resp[2].length > 0) {
                            finalPeriods = finalPeriods.concat(resp[2]);
                        }
                        scope.periods = finalPeriods.map(function (item) {
                            if (!item.calendar) {
                                item.calendar = operation.calendar + 1;
                            }
                            item.newId = item.calendar + '' + item.period;
                            return item;
                        })
                    }).catch(errAlertS);
                    scope.operation = operation;
                    scope.hide = function () {
                        $mdDialog.hide();
                    };
                    scope.moveCalculations = function (periodSelected, pdate) {
                        $rootScope.loadingProgress = true;
                        $rootScope.$evalAsync();
                        $timeout(function () {

                            var promises = [
                                $rootScope.D.api.get('calculations', { operationId: scope.operation.$id, project: JSON.stringify({ 'companiesRecords': 1 }) }),
                                $rootScope.D.api.get('bills', { operationId: scope.operation.$id, project: JSON.stringify({ 'employeeId': 1 }) }),
                            ];
                            Promise.all(promises).then(function (resps) {
                                var calculations = $filter('getFromObject')(resps[0], 'data', []);
                                var bills = $filter('getFromObject')(resps[1], 'data', []);
                                var promises = [];
                                var updates = {};
                                //@TODO: cuando es ordinaria cambiar la ruta correctamente
                                if (scope.operation.operationType === 'ordinary') {
                                    updates['operations/' + scope.operation.operationType + '/' + operation.payroll + '/' + operation.calendar + '/collection/' + operation.$id + '/forceBillingDate'] = pdate ? pdate : null;
                                    updates['operations/' + scope.operation.operationType + '/' + operation.payroll + '/' + operation.calendar + '/collection/' + operation.$id + '/accuPeriod'] = periodSelected.period;
                                    updates['operations/' + scope.operation.operationType + '/' + operation.payroll + '/' + operation.calendar + '/collection/' + operation.$id + '/accuPeriod'] = periodSelected.period;
                                    updates['operations/' + scope.operation.operationType + '/' + operation.payroll + '/' + operation.calendar + '/collection/' + operation.$id + '/accuCalendar'] = periodSelected.calendar;
                                    updates['operations/' + scope.operation.operationType + '/' + operation.payroll + '/' + operation.calendar + '/collection/' + operation.$id + '/accuDate'] = periodSelected.accuDate;
                                } else {
                                    updates['operations/' + scope.operation.operationType + '/all/' + operation.$id + '/forceBillingDate'] = pdate ? pdate : null;
                                    updates['operations/' + scope.operation.operationType + '/all/' + operation.$id + '/accuPeriod'] = periodSelected.period;
                                    updates['operations/' + scope.operation.operationType + '/all/' + operation.$id + '/start'] = periodSelected.start;
                                    updates['operations/' + scope.operation.operationType + '/all/' + operation.$id + '/end'] = periodSelected.end;
                                    updates['operations/' + scope.operation.operationType + '/all/' + operation.$id + '/accuCalendar'] = periodSelected.calendar;
                                    updates['operations/' + scope.operation.operationType + '/all/' + operation.$id + '/accuDate'] = periodSelected.accuDate;
                                }
                                updates['dispersions/collection/' + operation.dispersion + '/data/accuDate'] = periodSelected.accuDate;
                                updates['dispersions/collection/' + operation.dispersion + '/data/period'] = periodSelected.period;
                                updates['dispersions/collection/' + operation.dispersion + '/data/calendar'] = periodSelected.calendar;
                                promises.push($scope.F.root.child('catalogs').update(updates));
                                var listUpdates = {};
                                for (var c = 0; c < calculations.length; c++) {
                                    var calculation = $filter('clearObject')(calculations[c]);
                                    var dataToUpdate = { accuDate: periodSelected.accuDate, period: periodSelected.period, calendar: periodSelected.calendar }
                                    promises.push($scope.D.api.update('calculations', calculation._id, dataToUpdate));
                                    if (angular.isArray(calculation.companiesRecords)) {
                                        for (var d = 0; d < calculation.companiesRecords.length; d++) {
                                            if (calculation.companiesRecords[d].hasOwnProperty('companiesRecordId')) {
                                                listUpdates[calculation.companiesRecords[d].companiesRecordId + '/' + operation.dispersion + '/accuDate'] = periodSelected.accuDate;
                                            }
                                        }
                                    }
                                }
                                for (var b = 0; b < bills.length; b++) {
                                    var bill = bills[b];
                                    var dataToUpdate = { accuPeriod: periodSelected.period, accuDate: periodSelected.accuDate, accuPeriodEnd: periodSelected.end, accuPeriodStart: periodSelected.start, calendar: periodSelected.calendar };
                                    promises.push($scope.D.api.update('bills', bill._id, dataToUpdate));
                                }
                                promises.push($scope.F.root.child('lists/dispersions/companiesRecords').update(listUpdates));
                                return Promise.all(promises);
                            }).then(function () {
                                successAlertS('Se movió la operación con éxito');
                                scope.hide();
                            }).catch(errAlertS).then(function () {
                                $rootScope.loadingProgress = false;
                                $rootScope.$evalAsync();
                            });
                        }, 0, false);
                    };
                    scope.cancel = function () {
                        $mdDialog.cancel();
                    };
                },
                targetEvent: ev,
                controllerAs: 'changePeriod',
                clickOutsideToClose: false
            });
        };
        $scope.downloadZipBill = function (selected) {
            var operations = [];
            var promises = [];
            var employeesPromises = {};
            if (selected.length > 0) {
                for (var s = 0; s < selected.length; s++) {
                    var employeeId = false;
                    promises.push($scope.F.root.child('catalogs/payrolls/collection/' + selected[s].payroll + '/data/class').once('value'));
                    if (Object.keys(selected[s].employees).length === 1) {
                        $filter('loopEach')(selected[s].employees, function (data, key) {
                            employeeId = key;
                            employeesPromises[key] = $scope.F.root.child('catalogs/employees/collection/' + key + '/data/employeeNumber').once('value');
                        });
                    }
                    operations.push({
                        employeeId: employeeId,
                        operation: selected[s].$id,
                        dispersion: selected[s].dispersion,
                        calendar: selected[s].calendar,
                        specialPeriod: selected[s].specialPeriod,
                        period: selected[s].period,
                        payroll: selected[s].payroll,
                        opeType: selected[s].operationType
                    });
                }
                if (Object.keys(employeesPromises).length > 0) {
                    promises.unshift($q.all(employeesPromises));
                } else {
                    promises.unshift(Promise.all([]));
                }
                $q.all(promises).then(function (resp) {
                    var employeesPromises = resp.shift();
                    employeesPromises = angular.isArray(employeesPromises) ? {} : employeesPromises;
                    if (resp.length > 0) {
                        for (var r = 0; r < resp.length; r++) {
                            if (resp[r].exists()) {
                                var payrollClass = resp[r].val();
                                var employeeNumber = undefined;
                                if (operations[r].employeeId) {
                                    employeeNumber = angular.isObject(employeesPromises[operations[r].employeeId]) && employeesPromises[operations[r].employeeId].val ? employeesPromises[operations[r].employeeId].val() : undefined;
                                }
                                var thisCalendar = operations[r].calendar ? '_' + operations[r].calendar : '';
                                var selectedPeriod = operations[r].specialPeriod ? operations[r].specialPeriod : operations[r].period;
                                var digits = operations[r].specialPeriod ? 3 : 2;
                                var thisPeriod = selectedPeriod ? '_' + $filter('zeroFill')(selectedPeriod, digits) : '';
                                var thisCenter = AppF.center.toUpperCase();
                                var params = {
                                    dispersionId: operations[r].dispersion,
                                    operationId: operations[r].operation,
                                    opType: operations[r].opeType,
                                    filename: thisCenter + thisCalendar + '_' + payrollClass + '_' + $scope.F.opeFilesName[operations[r].opeType].fiscal + thisPeriod + (employeeNumber ? '_' + employeeNumber : '')
                                };
                                downloadFile('models/bill/getBillZipAll', params);
                            } else {
                                throw 'No se encontró la clase de la nómina con ID ' + operations[r].payroll;
                            }
                        }
                    } else {
                        throw 'No se encontró la clase de la nómina';
                    }
                }).catch(function (error) {
                    errAlertS(error);
                });
            } else {
                errAlertS('Favor de seleccionar alguna operación');
            }
        };

        $scope.forceCloseOperation = function (e, operations) {
            if (angular.isArray(operations) && operations.length > 0) {
                $mdDialog.show($mdDialog.confirm(confirmConfig)
                    .title('Desea cerrar esta operación sin cálculos')
                    .htmlContent('Se cerrara la operación sin cálculos y si hay disponible se aperturara la siguiente, desea continuar?')
                    .ariaLabel('Deleting')
                    .targetEvent(e)
                    .ok('Cerrar')
                    .cancel('Cancelar'))
                    .then(function () {
                        try {
                            var selectedOrdered = operations.sort(function (a, b) {
                                return a.period - b.period;
                            });
                            var count, calendar, payroll;
                            var ids = selectedOrdered.map(function (item) {
                                if (angular.isUndefined(count)) {
                                    count = item.period;
                                }
                                if (angular.isUndefined(calendar)) {
                                    calendar = item.calendar;
                                }
                                if (angular.isUndefined(payroll)) {
                                    payroll = item.payroll;
                                }
                                count++;
                                if (item.period + 1 !== count) {
                                    throw 'Solo pueden cerrarse varias operaciones de periodos consecutivos';
                                } else if (calendar !== item.calendar) {
                                    throw 'Solo pueden cerrarse varias operaciones del mismo calendario';
                                } else if (payroll !== item.payroll) {
                                    throw 'Solo pueden cerrarse varias operaciones de la misma nomina';
                                } else if (item.operationType !== 'ordinary') {
                                    throw 'Esta función solo es para nominas ordinarias';
                                }
                                return item.$id;
                            });
                            var query = {
                                page: 0.5,
                                size: 0.5,
                                '$or': [
                                    { fid: { $in: ids } },
                                    {
                                        payroll: payroll,
                                        calendar: calendar,
                                        period: count
                                    }
                                ]
                            };
                            $rootScope.loadingProgress = true;
                            $rootScope.D.api.get('p/operations', query).then(function (resp) {
                                var allOperations = resp.data.data;
                                var updates = {};
                                for (var i = 0; i < ids.length; i++) {
                                    var operationIndex = allOperations.findIndex(function (item) {
                                        return item.fid === ids[i];
                                    });
                                    if (operationIndex === -1) {
                                        throw 'No se encontró la operación seleccionada: ' + ids[i];
                                    }
                                    var thisOperation = allOperations.splice(operationIndex, 1)[0];
                                    if (thisOperation.status > 3) {
                                        throw 'Esta operación ya esta cerrada';
                                    }
                                    updates[thisOperation.fid + '/status'] = 7;
                                }
                                if (allOperations.length > 0) {
                                    var nextOperation = allOperations[0];
                                    if (angular.isDefined(nextOperation)) {
                                        updates[nextOperation.fid + '/status'] = 1;
                                    }
                                }
                                return $scope.F.root.child('catalogs/operations/ordinary/' + payroll + '/' + calendar + '/collection').update(updates);
                            }).then(function () {
                                successAlertS('Se actualizo la operación con éxito');
                            }).catch(errAlertS).then(function () {
                                $timeout(function () {
                                    $scope.getThem();
                                }, 5000, false);
                            });
                        } catch (error) {
                            errAlertS(error);
                        }
                    }).catch(function (error) {
                        errAlertS(error);
                    });
            } else {
                errAlertS('No existen operaciones para cerrar');
            }
        };

        $scope.exportDispersionLayout = function (ev, selected) {
            try {
                var allClosed = true;
                for (var e = 0; e < selected.length; e++) {
                    if (selected[e].status < 3) {
                        allClosed = false;
                    }
                }
                if (!allClosed) {
                    throw 'Para usar esta función las operaciones deben estar cerradas';
                }
                var payrolls = [];
                var process = {};
                for (var s = 0; s < selected.length; s++) {
                    var thisOpe = selected[s];
                    if (payrolls.indexOf(thisOpe.payroll) === -1) {
                        payrolls.push(thisOpe.payroll);
                        var payroll = ListsF.allPayrolls.find(function (item) {
                            return item.$id === thisOpe.payroll;
                        });
                        if (angular.isDefined(payroll)) {
                            for (var proc in payroll.processes) {
                                if (payroll.processes.hasOwnProperty(proc)) {
                                    var thisProc = payroll.processes[proc];
                                    if (angular.isObject(thisProc) && angular.isArray(thisProc.bankAccounts) && thisProc.bankAccounts.length > 0) {
                                        if (angular.isUndefined(process[proc])) {
                                            process[proc] = { id: thisProc.id, bankAccounts: {} };
                                        }
                                        var bankAccounts = thisProc.bankAccounts;
                                        for (var b = 0; b < bankAccounts.length; b++) {
                                            var bankAccountId = bankAccounts[b];
                                            if (angular.isUndefined(process[proc].bankAccounts[bankAccountId])) {
                                                process[proc].bankAccounts[bankAccountId] = 0;
                                            }
                                            process[proc].bankAccounts[bankAccountId]++;
                                        }

                                    }
                                }
                            }
                        }
                    }
                }
                var newProcess = [];
                $filter('loopEach')(process, function (proc, procName) {
                    proc.name = procName;
                    var bankAccounts = [];
                    $filter('loopEach')(proc.bankAccounts, function (number, bankAccountId) {
                        if (number === payrolls.length) {
                            bankAccounts.push(bankAccountId);
                        }
                    });
                    if (bankAccounts.length > 0) {
                        proc.bankAccounts = bankAccounts;
                        newProcess.push(proc);
                    }
                });
                $mdDialog.show({
                    templateUrl: 'app/main/clients/views/operations/dialogs/employees-dispersion.html',
                    controller: 'EmployeesDispersionController',
                    parent: angular.element($document.body),
                    locals: {
                        operations: selected,
                        processes: newProcess
                    },
                    targetEvent: ev,
                    controllerAs: 'employeesDispersion'
                });
            } catch (error) {
                errAlertS(error);
            }
        };

        $scope.generateAccountingAccount = function (selected, secondEndPoint, event) {
            $rootScope.loadingProgress = true;
            $rootScope.$evalAsync()
            var operations = [];
            var promises = [];
            for (var s = 0; s < selected.length; s++) {
                operations.push({
                    specialPeriod: selected[s].specialPeriod,
                    operationType: selected[s].operationType,
                    operationId: selected[s].$id,
                    dispersionId: selected[s].dispersion,
                    payrollId: selected[s].payroll,
                    calendar: selected[s].calendar,
                    period: selected[s].period,
                    payroll: selected[s].payroll
                });
                promises.push($scope.F.root.child('catalogs/dispersions/collection/' + selected[s].dispersion + '/data/process').once('value'));
            }
            Promise.all(promises).then(function (resp) {
                var dataToExport = [];
                for (var r = 0; r < resp.length; r++) {
                    if (resp[r].exists()) {
                        var process = resp[r].val();
                        for (var p = 0; p < process.length; p++) {
                            if (['fiscal', 'socialPrevision'].indexOf(process[p].id) > -1) {
                                dataToExport.push(Object.assign({ process: process[p].id, processName: process[p].name }, operations[r]));
                            }
                        }
                    }
                }
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync()
                if (dataToExport.length === 0) {
                    errAlertS('No se encontraron datos a exportar')
                } else {
                    $log.log('second', secondEndPoint)
                    showAccModal(dataToExport, secondEndPoint, event);
                }
            }).catch(function (error) {
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync()
                errAlertS(error);
            });
        };
        function showAccModal(dataToExport, secondEndPoint, event) {
            $mdDialog.show({
                templateUrl: 'app/main/clients/views/newoperation/dialogs/export-accs.html',
                locals: {
                    dataToExport: dataToExport,
                    secondEndPoint: secondEndPoint
                },
                controller: 'ExportAccsModalController',
                controllerAs: 'eacmCtrl',
                parent: angular.element($document.body),
                targetEvent: event,
                scope: $scope.$new(),
                clickOutsideToClose: false
            });
        }
        $scope.editAddActions = {
            validateOpeAccess: function (operation) {
                $filter('checkOpeOrdinaryAccess')(operation).then(function () {
                    $scope.goToDetail(operation);
                }).catch(errAlertS);
            },
            goToDetail: $scope.goToDetail,
            addEditDistribution: function (ev, operation) {
                $mdDialog.show({
                    templateUrl: 'app/main/clients/views/newoperation/dialogs/ptu-distribution.html',
                    locals: {
                        operation: operation
                    },
                    controller: 'PtuDistributionModalController',
                    controllerAs: 'pdmCtrl',
                    parent: angular.element($document.body),
                    targetEvent: ev,
                    scope: $scope.$new(),
                    clickOutsideToClose: false
                });
                $scope.$evalAsync();
            },
            addEditOpe: function (ev, specialObject, type) {
                $mdDialog.show({
                    templateUrl: 'app/main/clients/views/newoperation/dialogs/special-payrolls.html',
                    locals: {
                        specialObject: specialObject,
                        type: type,
                        opeConfig: $scope.tabConfig
                    },
                    controller: 'specialPayrollsController',
                    parent: angular.element($document.body),
                    targetEvent: ev,
                    scope: $scope.$new(),
                    clickOutsideToClose: false
                });
                $scope.$evalAsync();
            },
            addSettlements: function (ev, operation, action) {
                var employee;
                var movement;
                var operationId;
                var promises = [];
                if (angular.isDefined(operation) && angular.isDefined(operation.movement)) {
                    operationId = operation.$id;
                    movement = operation.movement;
                    $filter('loopEach')(operation.employees, function (employeeData, idEmployee) {
                        promises.push($scope.L.loadList('employees', 'catalogs/employees/collection', idEmployee, 'object', 'employees-' + idEmployee));
                    });
                }
                Promise.all(promises).then(function (resp) {
                    if (resp.length > 0) {
                        employee = resp[0];
                        employee.processConfig = operation.processConfigId;
                        employee.incidences = operation.incidences;
                        employee.absencesToCheck = operation.absencesToCheck;
                        employee.movementTypes = operation.movementTypes;
                        employee.disableMonthlyBase = operation.disableMonthlyBase;
                    }
                    return getSettlement(operation, employee, action);
                }).then(function () {
                    $mdDialog.show({
                        templateUrl: 'app/main/clients/views/newoperation/dialogs/settlements.html',
                        locals: {
                            employeeP: employee,
                            movement: movement,
                            operationId: operationId,
                            action: action
                        },
                        controller: 'settlementsController',
                        parent: angular.element($document.body),
                        targetEvent: ev,
                        scope: $scope.$new(),
                        clickOutsideToClose: true
                    });
                    $scope.$evalAsync();
                }).catch(errAlertS);
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.clients')
        .controller('ImportCalculationsController', ImportCalculationsController);

    function ImportCalculationsController($scope, ListsF, $log, $rootScope, AppF, $mdDialog, DataF, $filter, errAlertS, successAlertS, $timeout, sumObjectsFilter) {
        var vm = this;
        vm.L = ListsF;
        var concepts;
        var currentStep = 1;
        var payrollCalendars;
        vm.permissionToAccessAllPayrolls = AppF.permissionToAccessAllPayrolls;
        vm.operationTypes = AppF.operationTypes;
        vm.dateFormat = AppF.dateFormat;
        vm.headersError = false;
        $scope.close = function () {
            $mdDialog.hide();
        };
        function uploadCsv() {
            var files = vm.filesArray;
            if (angular.isArray(files) && files.length > 0) {
                vm.loading = true;
                var formData = new FormData();
                formData.append('file', files[0].lfFile);
                var thisConcepts = [];
                var promises = [
                    ListsF.loadList('concepts', 'lists/concepts/center/' + AppF.center, undefined, 'array', 'payrollConcepts-' + vm.payroll, [{ q: 'orderByChild', v: 'payroll' }, { q: 'equalTo', v: vm.payroll }]),
                    ListsF.loadList('concepts', 'lists/concepts/center/' + AppF.center, undefined, 'array', 'globalConcepts-' + AppF.center, [{ q: 'orderByChild', v: 'payroll' }, { q: 'equalTo', v: 'global' }]),
                    DataF.files.csvToJson(formData),
                    ListsF.loadList('payrollCalendars', 'catalogs/payrollCalendars/' + vm.payroll, undefined, 'object', 'allPayrollCalendarsOf-' + vm.payroll)
                ];
                Promise.all(promises).then(function (resp) {
                    payrollCalendars = resp[3];
                    thisConcepts = resp[0].concat(resp[1]);
                    concepts = $filter('getCOnceptsByKeyAndField')(thisConcepts);
                    var recordsData = $filter('formatCalculationsToImportV2')(resp[2].data, concepts.arr);
                    vm.headers = recordsData.headers;
                    vm.data = recordsData.data;
                    if (vm.headers.findIndex(function (item) {
                        return item.error ? true : false;
                    }) > -1) {
                        vm.headersError = true;
                    }
                    return $filter('validateCalculationsV2')(vm.data, payrollCalendars);
                }).then(function (data) {
                    vm.data = data;
                    vm.loading = false;
                    $scope.$evalAsync(function () {
                        $timeout(function () { }, 0, false);
                    });
                }).catch(function (error) {
                    errAlertS(error);
                    vm.loading = false;
                    $scope.$evalAsync(function () {
                        $timeout(function () { }, 0, false);
                    });
                });
            }
        }
        var filesNameWatch = $scope.$watch(function () {
            return angular.isArray(vm.filesArray) ? vm.filesArray.length : 0;
        }, function (newVal) {
            //Esta funcion vamos a extraer el nombre del archivo, una vez hecho eso lo dividiremos por espacios en arreglo
            //y cada palabra la buscaremos primero en el vm.L.companiesRecords si coincide el .name para ver si hay coincidencias y preseleccionar el vm.companiesRecord
            //luego cada palabra la buscaremos primero en el vm.L.allPayrolls si coincide el .name o el .class vm.permissionToAccessAllPayrolls si no en  vm.L.payrolls  para ver si hay coincidencias y preseleccionar el vm.payroll
            if (newVal > 0) {
                var fileName = vm.filesArray[0].lfFileName;
                var nameParts = fileName.split(' ');
                var foundedCompany = undefined
                var foundedPayroll = undefined
                var payrollsToSearch = vm.permissionToAccessAllPayrolls ? vm.L.allPayrolls : vm.L.payrolls;
                for (var i = 0; i < nameParts.length & (angular.isUndefined(foundedCompany) || angular.isUndefined(foundedPayroll)); i++) {
                    var part = nameParts[i].toLowerCase();
                    // Buscar en companiesRecords
                    if (angular.isArray(vm.L.companiesRecords) && angular.isUndefined(foundedCompany)) {
                        foundedCompany = vm.L.companiesRecords.find(function (companyRecord) {
                            if (companyRecord.name.toLowerCase().includes(part)) {
                                vm.companiesRecord = companyRecord.$id;
                                return true; // Salir del find
                            }
                        });
                    }
                    if (angular.isArray(payrollsToSearch) && angular.isUndefined(foundedPayroll)) {
                        foundedPayroll = payrollsToSearch.find(function (payroll) {
                            if (payroll.class.toLowerCase().includes(part) || payroll.name.toLowerCase().includes(part)) {
                                vm.payroll = payroll.$id;
                                return true; // Salir del find
                            }
                        });
                    }
                }
                if (angular.isDefined(foundedCompany)) {
                    vm.companiesRecord = foundedCompany.$id;
                }
                if (angular.isDefined(foundedPayroll)) {
                    vm.payroll = foundedPayroll.$id;
                    vm.checkOtherExports(vm.payroll);
                }
            }
        });
        vm.checkOtherExports = function (payroll) {
            vm.loading = true;
            if (payroll) {
                var query = ListsF.loadList('importAccuRecords', 'catalogs/importAccuRecords/collection', undefined, 'array', 'importAccuRecords-' + payroll, [{ q: 'orderByChild', v: 'payroll' }, { q: 'equalTo', v: payroll }]);
                query.then(function (importAccuRecords) {
                    vm.importAccuRecords = importAccuRecords.map(function (item) {
                        var companiesRecordData = ListsF.companiesRecords.find(function (thisItem) {
                            return thisItem.$id === item.companiesRecord;
                        });
                        if (angular.isDefined(companiesRecordData)) {
                            item.companiesRecordName = companiesRecordData.name;
                        }
                        item.total = sumObjectsFilter(item.count);
                        return item;
                    });
                    $log.log(importAccuRecords);
                    vm.loading = false;
                }).catch(function (error) {
                    errAlertS(error);
                    vm.loading = false;
                });
            }
        };
        vm.deleteImport = function deleteImport(importAccuRecord) {
            vm.loading = true;
            var params = {
                'importId': importAccuRecord.importId,
                'project': angular.toJson({ 'importId': 1 })
            };
            var promises = [
                DataF.api.get('calculations', params),
                AppF.root.child('lists/dispersions/companiesRecords/' + importAccuRecord.companiesRecord).orderByChild('importId').equalTo(importAccuRecord.importId).once('value')
            ];
            Promise.all(promises).then(function (resps) {
                var calculations = resps[0].data;
                var dispersions = resps[1];
                promises = [];
                for (var c = 0; c < calculations.length; c++) {
                    promises.push(DataF.api.delete('calculations/' + calculations[c]._id));
                }
                dispersions.forEach(function (childSnap) {
                    promises.push(AppF.root.child('lists/dispersions/companiesRecords/' + importAccuRecord.companiesRecord + '/' + childSnap.key).set(null));
                });
                return Promise.all(promises);
            }).then(function () {
                return AppF.root.child('catalogs/importAccuRecords/collection/' + importAccuRecord.$id).set(null);
            }).then(function () {
                successAlertS('Se eliminaron los registros con éxito');
                vm.loading = false;
                vm.checkOtherExports(vm.payroll);
            }).catch(function (error) {
                vm.loading = false;
                errAlertS(error);
            });
        };
        vm.applyCalculations = function () {
            vm.loading = true;
            var extra = {
                companiesRecord: vm.companiesRecord,
                operationType: vm.operationType,
                payroll: vm.payroll
            };
            $scope.$evalAsync();
            $filter('applyCalculationsV2')(vm.data, vm.headers, extra, concepts.obj).then(function () {
                successAlertS('Se importaron los cálculos con éxito');
                $mdDialog.hide();
            }).catch(errAlertS).then(function () {
                vm.loading = false;
                $scope.$evalAsync(function () {
                    $timeout(function () { }, 0, false);
                });
            });
        };
        var stepperChange = $rootScope.$on('stepCalled', function (event, step) {
            if (step === 2 && currentStep === 1) {
                uploadCsv();
            }
            currentStep = step;
        });
        var onDestroy = $rootScope.$on('$destroy', function () {
            stepperChange();
            onDestroy();
            filesNameWatch();
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.clients')
        .controller('EmployeesDispersionController', EmployeesDispersionController);

    function EmployeesDispersionController($scope, $mdDialog, AppF, $log, operations, processes, MongoF, errAlertS, DataF, $filter, $http, $rootScope) {
        var vm = this;
        vm.processes = processes;
        $scope.close = function () {
            $mdDialog.hide();
        };
        vm.getBanks = function () {
            var payrollBanks = [];
            if (vm.process && angular.isArray(vm.process.bankAccounts)) {
                vm.process.bankAccounts.map(function (item) {
                    var tba = MongoF.bankAccounts.find(function (bankAccount) {
                        return bankAccount._id === item;
                    });
                    if (angular.isDefined(tba)) {
                        tba.bankData = MongoF.banks.find(function (bank) {
                            return bank._id === tba.bank;
                        });
                        if (angular.isDefined(tba.bankData) && tba.bankData.hasLayoutDispersion) {
                            payrollBanks.push(tba);
                        }
                    }
                    return true;
                });
            }
            vm.payrollBanks = payrollBanks;
        };
        vm.addDateIfNeeded = function (bankAccount) {
            vm.loading = true;
            try {
                vm.dateNeeded = false;
                var fileRoute;
                if (bankAccount.isSpei) {
                    fileRoute = (angular.isDefined(bankAccount.bankData.fileRouteSpei) && bankAccount.bankData.fileRouteSpei !== '') ? bankAccount.bankData.fileRouteSpei : bankAccount.bankData.name + '_spei';
                } else {
                    fileRoute = (angular.isDefined(bankAccount.bankData.fileRoute) && bankAccount.bankData.fileRoute !== '') ? bankAccount.bankData.fileRoute : bankAccount.bankData.name;
                }
                if (['banorte', 'hsbc', 'kuspit_spei', 'santander', 'santander_spei'].indexOf(angular.lowercase(fileRoute)) > -1) {
                    vm.dateNeeded = true;
                }
                vm.minDate = angular.lowercase(bankAccount.bankData.name) === 'hsbc' ? moment(DataF.getCurrentServerTime()).toDate() : AppF.holydaysInMexico.getDateOfXLabourDaysSinceNow(15, DataF.getCurrentServerTime()).date;
                vm.onlyWeekendsPredicate = function (date) {
                    var day = date.getDay();
                    return day === 1 || day === 2 || day === 3 || day === 4 || day === 5;
                };
            } catch (error) {
                errAlertS(error);
            }
            vm.loading = false;
        };

        vm.generateDispersionLayout = function () {
            $rootScope.loadingProgress = true;
            var operationIds = [];
            var process = vm.process;
            var bankAccount = vm.bankAccount;
            var applicationDate = vm.applicationDate;
            var operationType;
            operations.map(function (item) {
                operationType = item.operationType;
                operationIds.push(item.fid);
                return true;
            });
            var fileRoute;
            if (bankAccount.isSpei) {
                fileRoute = (angular.isDefined(bankAccount.bankData.fileRouteSpei) && bankAccount.bankData.fileRouteSpei !== '') ? bankAccount.bankData.fileRouteSpei : bankAccount.bankData.name + '_spei';
            } else {
                fileRoute = (angular.isDefined(bankAccount.bankData.fileRoute) && bankAccount.bankData.fileRoute !== '') ? bankAccount.bankData.fileRoute : bankAccount.bankData.name;
            }
            var bankName = angular.lowercase(fileRoute);
            var params = {
                query: angular.toJson([
                    { $match: { operationId: { $in: operationIds } } },
                    { $lookup: { foreignField: 'fid', localField: 'employeeId', from: 'employees', as: 'employeeData' } },
                    { $unwind: '$employeeData' },
                    { $project: { 'fiscalTotal.value.result': '$fiscalTotal.value', 'socialPrevisionTotal.value.result': '$socialPrevisionTotal.value', 'employeeData': 1, 'period': 1, 'calendar': 1 } }
                ])
            };
            $rootScope.D.api.post('aggregate/calculations', params).then(function (resp) {
                var data = [];
                var employees = [];
                var allEmployeesO = {};
                var calculations = {};
                if (angular.isArray(resp.data)) {
                    data = resp.data;
                }
                data.map(function (item) {
                    var employeeData = item.employeeData;
                    employeeData.$id = employeeData.fid + item._id;
                    employees.push({
                        '$id': employeeData.fid + item._id,
                        'data': {
                            'name': employeeData.data.name,
                            'enroleDate': employeeData.data.enroleDate
                        }
                    });
                    allEmployeesO[employeeData.fid + item._id] = employeeData;
                    calculations[employeeData.fid + item._id] = item;
                    return true;
                });
                var filterName = $filter('convertToCamelCase')('get_data_for_layouts_' + fileRoute);
                var filter = $filter('getFilterIfExists')(filterName);
                if (!filter) {
                    errAlertS('No existe el archivo de layout del banco seleccionado');
                    return false;
                }
                var params = {
                    employees: employees,
                    allEmployeesO: allEmployeesO,
                    tabSelected: process.id,
                    processName: process.name,
                    calc: calculations,
                    paymentForms: MongoF.paymentForms,
                    operationType: operationType,
                    bankAccount: bankAccount,
                    date: applicationDate,
                    banks: MongoF.banks
                };
                return $filter(filterName)(params);
            }).then(function (resp) {
                if (angular.isDefined(resp.error) && angular.isArray(resp.error)) {
                    for (var i = 0; i < resp.error.length; i++) {
                        errAlertS(resp.error[i]);
                    }
                }
                if (angular.isDefined(resp.success)) {
                    if (angular.isArray(resp.success) && resp.success.length === 0) {
                        throw 'No existe ningún registro para layout de ' + bankAccount.bankData.name;
                    }
                    if (angular.isObject(resp.success) && angular.isDefined(resp.success.body) && resp.success.body.length === 0) {
                        throw 'No existe ningún registro para layout de ' + bankAccount.bankData.name;
                    }
                    var objData = {
                        data: angular.toJson(resp.success),
                        bankName: $filter('convertToCamelCase')(bankName)
                    };
                    if (angular.isDefined(resp.filename)) {
                        objData.filename = resp.filename;
                    }
                    $http({
                        method: 'POST',
                        url: window.__env.serviceWorkerUrl + 'interface/pag/layout/dispersion',
                        responseType: 'arraybuffer',
                        data: objData
                    }).then(function (response) {
                        var headers = response.headers();
                        var filename = headers['x-filename'];
                        var contentType = headers['content-type'];
                        var linkElement = document.createElement('a');
                        try {
                            var blob = new Blob([response.data], {
                                type: contentType
                            });
                            var url = window.URL.createObjectURL(blob);
                            linkElement.setAttribute('href', url);
                            linkElement.setAttribute('download', filename);
                            var clickEvent = new MouseEvent('click', {
                                'view': window,
                                'bubbles': true,
                                'cancelable': false
                            });
                            linkElement.dispatchEvent(clickEvent);
                            $rootScope.loadingProgress = false;
                            $rootScope.$evalAsync(function () {
                                $log.debug('generate file .pag finished');
                            });
                        } catch (ex) {
                            $log.error(ex, 'error descargando el archivo');
                            $rootScope.loadingProgress = false;
                            $rootScope.$evalAsync();
                        }
                    }).catch(function (err) {
                        var message = new TextDecoder('utf-8').decode(err.data);
                        var error = angular.fromJson(message);
                        errAlertS(error.data);
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync();
                    });
                } else {
                    errAlertS('No existe ningún registro para layout de ' + bankAccount.bankData.name);
                    $rootScope.loadingProgress = false;
                }
            }).catch(function (error) {
                $rootScope.loadingProgress = false;
                errAlertS(error);
            });
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.clients')
        .controller('AttendanceListsController', AttendanceListsController);

    function AttendanceListsController($scope, $filter, errAlertS, AppF) {
        var vm = this;
        var watchers = {};
        vm.operationStatus = AppF.operationStatatuss;
        var initiated = false;
        function init() {
            initiated = true;
        }
        function goToDetail(operation, action) {
            var detailState = 'app.processes.attendanceLists.' + action;
            var params = {
                'operationId': operation.$id,
                'payrollId': operation.payroll,
                'calendar': operation.calendar ? operation.calendar : null,
                'period': operation.period ? operation.period : null
            };
            $scope.F.goToState(detailState, params);
        }
        vm.access = function (operation, action) {
            // $filter('checkOpeOrdinaryAccess')(operation,allow).then(function () {
            goToDetail(operation, action);
            // }).catch(errAlertS);
        }
        $filter('startAfterInit')($scope, watchers, initiated, init);
    }
})();
(function () {
  'use strict';

  angular.
    module('app.clients').
    controller('AttendanceListController', AttendanceListController);

  function AttendanceListController($scope, $timeout, $filter, $mdDialog, $state, $q, $log, errAlertS, AppF, DataF, $rootScope, successAlertS, ListsF, MongoF, CatalogsF, $firebaseObject) {
    var vm = this;
    var watchers = {};
    var initiated = false;
    var payrollId, calendar, period;
    var data = {};
    var incidencesListeners;
    var allEmployees = [];
    var ccsIds = [];
    var allIncidences;
    vm.search = {};
    vm.mainObject;
    vm.order = ['enroleDate', 'name'];
    vm.allClosed = true;
    vm.someClosed = false;

    // var currentIncidences;
    function setData(objData, resp, valFns) {
      valFns = angular.isObject(valFns) ? valFns : {};
      $filter('loopEach')(resp, function (value, key) {
        var thisValue;
        if (valFns.hasOwnProperty(key)) {
          thisValue = valFns[key](value)
        } else {
          thisValue = value.val();
        }
        objData[key] = thisValue;
      })
    }
    function getEmployeeIncidences() {
      return new Promise(function (resolve, reject) {
        if (typeof (incidencesListeners) === 'undefined') {
          incidencesListeners = ListsF.loadList(
            'incidences',
            'incidences/' + payrollId + '/' + data.calendar,
            false,
            'array',
            'incidencesOf-' + payrollId + data.calendar + period,
            [{ q: 'orderByChild', v: 'period' }, { q: 'equalTo', v: parseInt(period) }]
          )
        }
        var incidencesTypes = data.incidenceTypes.reduce(function (current, item) {
          current.push(item.fid);
          return current;
        }, []);
        incidencesListeners.then(function (allIncidencesP) {
          allIncidences = allIncidencesP;
          vm.employeeIncidences = allIncidences.filter(function (item) {
            return incidencesTypes.indexOf(item.incidenceType) > -1
          }).reduce(function (current, item) {
            var thisDate = moment(item.date);
            var key = item.employee + thisDate.format('YYYYMMDD');
            var count = 1;
            if (angular.isDefined(current[key])) {
              count = current[key].count + 1;
            } else {
              count = 1;
            }
            current[key] = {
              fid: item.$id,
              employee: item.employee,
              date: thisDate.format('YYYYMMDD'),
              count: count,
              incidenceType: item.incidenceType,
              notEditable: data.incidenceTypesById[item.incidenceType].allowManual ? false : true,
              allowExist: data.incidenceTypesById[item.incidenceType].key === 'posibleVacations' ? false : true
            };
            return current;
          }, {})
          resolve(true);
        }).catch(reject)
      })
    }
    function filterEmployees() {
      $rootScope.loadingProgress = true;
      $rootScope.$evalAsync();
      $timeout(function () {
        var thisClosedEmployees = $filter('getFromObject')(vm.mainObject, 'employees', {})
        var thisEmployees = allEmployees.slice().map(function (item) {
          return Object.assign(item, thisClosedEmployees[item.fid] || {});
        });
        var indexOpen = thisEmployees.findIndex(function (item) {
          return !item.closed;
        })
        var indexClosed = thisEmployees.findIndex(function (item) {
          return item.closed;
        })
        vm.someClosed = (indexClosed > -1);
        vm.allClosed = (indexOpen === -1);
        if (!vm.allClosed && data.operation.status >= 3) {
          vm.allClosed = true;
        }
        if (vm.search.cc) {
          thisEmployees = thisEmployees.filter(function (item) {
            return item.cc === vm.search.cc;
          })
        }
        if (vm.search.employee) {
          thisEmployees = $filter('filter')(thisEmployees, vm.search.employee)
        }
        data.employees = thisEmployees;
        $rootScope.loadingProgress = false;
        $rootScope.$evalAsync();
        $timeout(function () { }, 0)
      }, 0)
    }
    function goToDetail(direction, action) {
      var detailState = 'app.processes.attendanceLists.' + action;
      var params = {
        // 'operationId': operation.$id,
        'payrollId': payrollId,
        'calendar': calendar,
        'period': parseInt(period) + direction
      };
      $scope.F.goToState(detailState, params);
    }

    function init() {
      console.log("incidencesListeners", incidencesListeners)
      $rootScope.loadingProgress = true;
      initiated = true;
      data.readOnlyMode = ($state.current.url.indexOf('read') !== -1);
      payrollId = $state.params.payrollId;
      calendar = $state.params.calendar;
      period = $state.params.period;
      var params = {
        center: AppF.center,
        payroll: angular.toJson({ $in: ['global', payrollId] }),
        validateDays: 'true:parseBool',
        type: 'incidenceType',
        attendanceCode: angular.toJson({ $exists: true })
      };
      var periodText = '' + parseInt(period);
      if (periodText.length < 2) {
        periodText = '0' + periodText;
      }
      vm.mainObject = $firebaseObject(AppF.root.child('/catalogs/attendanceLists/collection/' + payrollId + calendar + period));
      var thisPeriod = parseInt(period);
      var promises = {
        catalogsM: MongoF.loadNeeded(['placesOfWorkRecords']), //catálogos de mongo
        payroll: AppF.root.child('catalogs/payrolls/collection/' + payrollId).once('value'),
        period: AppF.root.child('/catalogs/payrollCalendars/' + payrollId + '/periods/' + calendar + '/' + period).once('value'),
        incidenceTypes: DataF.api.get('concepts', params),
        v: vm.mainObject.$loaded()
      }
      if ((thisPeriod - 1) > 0) {
        promises.lastPeriod = AppF.root.child('/catalogs/payrollCalendars/' + payrollId + '/periods/' + calendar + '/' + (thisPeriod - 1)).once('value');
      }
      promises.nextPeriod = AppF.root.child('/catalogs/payrollCalendars/' + payrollId + '/periods/' + calendar + '/' + (thisPeriod + 1)).once('value');
      data.calendar = calendar;
      $q.all(promises).then(function (resp) {
        delete resp.v;
        delete resp.catalogsM;
        setData(data, resp, { incidenceTypes: function (resp) { return resp.data } });
        data.incidenceTypesManual = $filter('orderBy')(data.incidenceTypes.filter(function (item) { return item.allowManual; }), ["nature", "name"])
        data.incidenceTypesById = data.incidenceTypes.reduce(function (current, item) {
          current[item.fid] = item;
          return current;
        }, {})
        data.ccs = ((AppF.permissionToAccessAllPayrolls) ? ListsF.ccs : ListsF.userCcs[AppF.profile.uid]).filter(function (item) { return item.payroll === payrollId });
        ccsIds = data.ccs.map(function (item) { return item.$id });
        data.days = [];
        var currentDay = moment(data.period.start);
        while (currentDay.valueOf() < data.period.end) {
          data.days.push({ obj: currentDay.clone(), dayNumber: currentDay.format('DD'), dayName: $filter('capitalize')(currentDay.format('ddd')), id: currentDay.format('YYYYMMDD') })
          currentDay.add(1, 'day');
        }
        promises = {
          employeesAndMovements: $filter('getMovementsD')(payrollId, data.period.start, data.period.end),
          operation: AppF.root.child('catalogs/operations/ordinary/' + payrollId + '/' + calendar + '/collection/' + data.period.operationId).once('value'),
          incidences: getEmployeeIncidences()
        }
        return $q.all(promises);
      }).then(function (resp) {
        delete resp.incidences;
        var employeesAndMovements = resp.employeesAndMovements;
        delete resp.employeesAndMovements;
        allEmployees = [];
        var positionsQuery = {};
        $filter('loopEach')(employeesAndMovements.employees, function (thisEmployee, employeeId) {
          if (AppF.permissionToAccessAllPayrolls || ccsIds.indexOf(thisEmployee.cc) > -1) {
            var thisMovements = employeesAndMovements.movements.filter(function (item) { return item.employee === employeeId });
            var employeeActiveDays = $filter('activeDaysFromMovements')(thisMovements, data.period);
            var activeDays = employeeActiveDays.reduce(function (current, item) {
              var currentDay = moment(item.start);
              while (currentDay.valueOf() <= item.end) {
                current[currentDay.format('YYYYMMDD')] = true;
                currentDay.add(1, 'day');
              }
              return current;
            }, {})
            if (!positionsQuery.hasOwnProperty(thisEmployee.data.position)) {
              positionsQuery[thisEmployee.data.position] = AppF.root.child('catalogs/positions/collection/' + thisEmployee.data.position + '/data/name').once('value');
            }
            allEmployees.push({
              name: thisEmployee.data.name,
              fid: thisEmployee.fid,
              position: thisEmployee.data.position,
              enroleDate: thisEmployee.data.enroleDate,
              activeDays: activeDays,
              cc: thisEmployee.cc,
              nss: thisEmployee.data.nss,
              noEmployee: thisEmployee.data.employeeNumber
            })
          }
        })
        setData(data, resp);
        return (Object.keys(positionsQuery).length > 0 ? $q.all(positionsQuery) : Promise.all([]))
      }).then(function (resp) {
        allEmployees.map(function (item) {
          item.positionName = resp[item.position] && resp[item.position].exists() ? resp[item.position].val() : 'S/P';
          return item;
        })
        $rootScope.loadingProgress = false;
        filterEmployees()
        initWatchers()
      }).catch(function (error) {
        errAlertS(error);
      })
    }
    function getSelectedText(element, type) {
      if (angular.isDefined(element)) {
        return type === "name" ? data.incidenceTypesById[element].name : data.incidenceTypesById[element].attendanceCode;
      } else {
        return type === "name" ? "ASISTENCIA" : "A";
      }
    }
    function setNextOrder(field, actualOrder) {
      var orderArray = [['enroleDate', 'name'], field, '-' + field];
      var index = orderArray.indexOf(actualOrder);
      if (index === -1) {
        index = 0;
      }
      var nextIndex = index + 1;
      if (nextIndex >= orderArray.length) {
        nextIndex = 0;
      }
      vm.order = orderArray[nextIndex];
    }
    function updateIncidence(newIncidence, thisIncidenceType, employee, dateMoment) {
      $rootScope.loadingProgress = true;
      var updates = {};
      var incidenceId;
      var deleteIncidence;
      if (((!angular.isObject(newIncidence)) || angular.isUndefined(newIncidence.fid)) && angular.isDefined(thisIncidenceType)) {
        incidenceId = AppF.root.child('incidences').push().key;
        updates['date'] = dateMoment.valueOf()
        updates['created'] = DataF.getTimeObject();
        updates['employee'] = employee;
        updates['calendar'] = parseInt(data.calendar);
        updates['center'] = AppF.center;
        updates['comments'] = 'Incidencia capturada mediante control de asistencia';
        updates['payroll'] = payrollId;
        updates['period'] = parseInt(period);
        updates['status'] = 0;
        updates['byAsstCtrl'] = true;
        updates['type'] = 'manual';
        updates['value'] = 1;
        updates['automaticAsignation'] = true;
        updates['incidenceType'] = thisIncidenceType;
      } else if (angular.isDefined(thisIncidenceType)) {
        updates['updated'] = DataF.getTimeObject();
        updates['incidenceType'] = thisIncidenceType;
        incidenceId = newIncidence.fid;
      } else if (angular.isObject(newIncidence) && newIncidence.hasOwnProperty('fid')) {
        deleteIncidence = true;
        incidenceId = newIncidence.fid;
      }
      var promise;
      if (deleteIncidence && incidenceId) {
        promise = AppF.root.child('incidences/' + payrollId + '/' + data.calendar + '/' + incidenceId).set(null);
      } else if (incidenceId) {
        promise = AppF.root.child('incidences/' + payrollId + '/' + data.calendar + '/' + incidenceId).update(updates)
      }
      promise.then(function () {
        return getEmployeeIncidences();
      }).then(function () {
        successAlertS('Se actualizo correctamente');
        $rootScope.loadingProgress = false;
      }).catch(function (error) {
        errAlertS(error);
        $rootScope.loadingProgress = false;
      });
    }
    function existVpIncidences() {
      var errors = [];
      for (var e = 0; e < allEmployees.length; e++) {
        var exist = (Object.keys(vm.employeeIncidences).findIndex(function (item) {
          var thisIncidence = vm.employeeIncidences[item];
          return thisIncidence.employee === allEmployees[e].fid && !thisIncidence.allowExist
        }) > -1);
        if (exist) {
          errors.push('El empleado ' + allEmployees[e].name + ' tiene incidencias que deben cambiarse antes de cerrar el periodo');
        }
      }
      return errors;
    }
    function closeAttendanceList(event) {
      var errors = existVpIncidences();
      if (errors.length == 0) {
        var confirm = $mdDialog.confirm().
          title('Cerrar la asistencia del periodo')
          .textContent('Al cerrar este periodo ya no podrá realizar mas cambios a los empleados, desea continuar?')
          .ariaLabel('Está Seguro(a)?')
          .targetEvent(event)
          .ok('OK')
          .cancel('Cancelar');
        $mdDialog.show(confirm).then(function () {
          $rootScope.loadingProgress = true;
          var updates = {};
          for (var a = 0; a < allEmployees.length; a++) {
            if (!updates[allEmployees[a].fid]) {
              updates[allEmployees[a].fid] = {};
            }
            updates[allEmployees[a].fid].closed = true;
          }
          AppF.root.child('/catalogs/attendanceLists/collection/' + payrollId + calendar + period + '/employees').update(updates).then(function () {
            return vm.mainObject.$loaded();
          }).then(function () {
            filterEmployees();
            $rootScope.loadingProgress = false;
            successAlertS('Se cerró el periodo con éxito');
          }).catch(function (error) {
            $rootScope.loadingProgress = false;
            errAlertS(error);
          })
        }).catch(function () {
          $log.log('close cancelled')
        })
      } else {
        errAlertS(errors);
      }
    }

    function reopenAttendanceList() {
      $mdDialog.show({
        templateUrl: 'app/main/clients/views/operations/attendanceListDialog.template.html',
        controller: 'AttendanceListDialogController',
        controllerAs: 'aldctrl',
        locals: {
          employeesClosed: allEmployees.filter(function (item) {
            return item.closed;
          }),
          payrollId: payrollId,
          calendar: calendar,
          period: period,
          mainObject: vm.mainObject

        }
      }).then(function () {
        filterEmployees();
        $rootScope.loadingProgress = false;
      }).catch(function () {
        $log.log('Reopening cancelled');
      });
    }

    function exportExcel() {
      var headers = [
        { field: 'noEmployee', name: "NO.", order: 0 },
        { field: 'nss', name: "NSS", order: 1 },
        { field: 'name', name: "NOMBRE", order: 2 },
        { field: 'ccName', name: 'CC', order: 3 }
      ];
      var thisData = [];
      var first = true;
      var incidencesTypes = {};
      for (var e = 0; e < data.employees.length; e++) {
        var thisEmployee = data.employees[e];
        var ccId = data.ccs.findIndex(function (item) {
          return item.$id === thisEmployee.cc;
        })
        var ccName = ccId > -1 ? data.ccs[ccId].name : 'S/C'
        var newEmployee = [
          thisEmployee.noEmployee,
          thisEmployee.nss,
          thisEmployee.name,
          ccName
        ]
        for (var d = 0; d < data.days.length; d++) {
          var thisDay = data.days[d];
          if (first) {
            headers.push({ field: '' + thisDay.id, name: thisDay.dayName + ' - ' + thisDay.dayNumber, order: headers.length, style: "bodyCenter" })
          }
          var incidenceObj = vm.employeeIncidences[thisEmployee.fid + '' + thisDay.id];
          var incidenceType;
          if (angular.isObject(incidenceObj)) {
            incidenceType = incidenceObj.incidenceType;
          } else {
            incidenceType = undefined;
          }
          if (angular.isDefined(incidenceType) && !incidencesTypes.hasOwnProperty(incidenceType)) {
            incidencesTypes[incidenceType] = [getSelectedText(incidenceType), getSelectedText(incidenceType, 'name')]
          }
          if (thisEmployee.activeDays[thisDay.id]) {
            newEmployee.push(getSelectedText(incidenceType))
          } else {
            newEmployee.push('');
          }
        }
        first = false;
        thisData.push(newEmployee);
      }
      var footer = [['#FOOTERHEADER#', 'CÓDIGO', 'INCIDENCIA']];
      footer.push(['#FOOTER#', 'A', 'ASISTENCIA'])
      footer = Object.keys(incidencesTypes).reduce(function (current, item) {
        var newItem = incidencesTypes[item]
        newItem.unshift('#FOOTER#');
        footer.push(newItem)
        return current;
      }, footer);

      var extra = [
        data.payroll.data.class + ' ' + data.payroll.data.name,
        'Incidencias del ' + data.period.startString + ' al ' + data.period.endString,
        'Periodo ' + data.period.period,
        ''
      ]
      var period = '' + data.period.period;
      if (period.length == 1) {
        period = '0' + period;
      }
      var params = {
        extra: angular.toJson(extra),
        headers: angular.toJson(headers),
        data: angular.toJson(thisData),
        footer: angular.toJson(footer),
        fileName: 'CONTROL_ASISTENCIA_' + data.payroll.data.name + '[' + data.payroll.data.class + ']' + '_' + period,
        sheetName: 'Periodo' + period
      }
      CatalogsF.exportToExcel('interface/exportAttendanceControl', params);
    }
    function initWatchers() {
      watchers.incidences = $scope.$watch(function () {
        return allIncidences;
      }, function () {
        executeFunction('getEmployeeIncidences')
      }, true)
    }
    var functionsToExecute = {
      getEmployeeIncidences: function () {
        return getEmployeeIncidences();
      }
    }
    var functionsQueue = [];
    var executingFunctions = false;
    function executeFunction(fnName) {
      if (angular.isDefined(fnName)) {
        functionsQueue.push(fnName);
      }
      if (!executingFunctions && functionsQueue.length > 0) {
        executingFunctions = true;
        var thisFnName = functionsQueue.shift()
        var result = functionsToExecute[thisFnName]();
        var promises = [];
        if (angular.isObject(result) && result != null && result.then) {
          promises.push(result)
        }
        Promise.all(promises).then(function (resp) {
          var thisResult = resp.length > 0 ? resp[1] : result;
          $log.log(thisFnName, thisResult);
          executingFunctions = false;
          executeFunction();
        }).catch(function () {
          executingFunctions = false;
        })
      }
    }
    vm.employees = [];
    vm.data = data;
    vm.getSelectedText = getSelectedText;
    vm.updateIncidence = updateIncidence;
    vm.filterEmployees = filterEmployees;
    vm.setNextOrder = setNextOrder;
    vm.exportExcel = exportExcel;
    vm.goToDetail = goToDetail;
    vm.closeAttendanceList = closeAttendanceList;
    vm.reopenAttendanceList = reopenAttendanceList;
    $filter('startAfterInit')($scope, watchers, initiated, init);
  }
})();


(function () {
  'use strict';
  angular.
    module('app.clients').
    controller('AttendanceListDialogController', AttendanceListDialogController);

  function AttendanceListDialogController($scope, $mdDialog, $log, errAlertS, AppF, $rootScope, successAlertS, employeesClosed, payrollId, calendar, period, mainObject) {
    var vm = this;
    var payrollId = payrollId;
    var calendar = calendar;
    var period = period;
    vm.employeesClosed = employeesClosed;
    vm.allSelected = true;
    vm.closeDialog = function () {
      $mdDialog.hide();
    };
    vm.changeAll = function (status) {
      for (var e = 0; e < vm.employeesClosed.length; e++) {
        vm.employeesClosed[e].checked = status;
      }
    }
    vm.checkAllSelected = function () {
      var allSelected = true;
      for (var e = 0; e < vm.employeesClosed.length; e++) {
        if (!vm.employeesClosed[e].checked) {
          allSelected = false;
          e = vm.employeesClosed.length;
        }
      }
      vm.allSelected = allSelected;
    }
    vm.reopen = function () {
      try {
        $rootScope.loadingProgress = true;
        var updates = {};
        for (var e = 0; e < vm.employeesClosed.length; e++) {
          if (vm.employeesClosed[e].checked) {
            updates[vm.employeesClosed[e].fid + '/closed'] = false;
          }
        }
        var path = '/catalogs/attendanceLists/collection/' + payrollId + calendar + period + '/employees';
        AppF.root.child(path).update(updates).then(function () {
          return mainObject.$loaded();
        }).then(function () {
          $rootScope.loadingProgress = false;
          vm.closeDialog();
          successAlertS('Se reabrieron los empleados con éxito');
        }).catch(function (error) {
          $rootScope.loadingProgress = false;
          errAlertS(error);
        });
      } catch (error) {
        errAlertS(error);
        $rootScope.loadingProgress = true;
      }
    };
    vm.checkAllSelected();
  }
})();


(function () {
    'use strict';

    angular
        .module('app.clients')
        .controller('PayrollCalendarsController', PayrollCalendarsController);

    function PayrollCalendarsController(
        $scope,
        $rootScope,
        $state,
        $log,
        $q,
        successAlertS,
        errAlertS,
        getFromObjectFilter,
        $mdDialog,
        $document
    ) {
        function checkIfAnyCalendarIsActive() {
            var selected = ($scope.selected && $scope.selected[0]) || null;
            if (!selected) {
                // No hay selección; decide si prefieres resolve(false) o reject(...)
                return Promise.resolve(false);
            }
            var payroll = selected.payroll;
            var selectedId = selected.$id;
            var calendarsRef = $scope.F.root.child('catalogs/payrollCalendars/' + payroll + '/calendars');
            // 1) Buscar si hay algún calendario activo (solo 1)
            return calendarsRef.orderByChild('data/active').equalTo(true).limitToFirst(1).once('value').then(function (activeSnap) {
                if (!activeSnap.exists()) return false;
                var activeVal = activeSnap.val();
                // Como limitToFirst(1), solo habrá una key
                var activeId = null;
                for (var k in activeVal) {
                    if (activeVal.hasOwnProperty(k)) {
                        activeId = k;
                        break;
                    }
                }
                if (!activeId) return false;
                // Si el activo es el mismo que quiero activar => error
                if (activeId === selectedId) {
                    return Promise.reject('Este calendario ya esta activo');
                }
                // 2) Validar si el calendario activo tiene operaciones en proceso/activas
                var opsRef = $scope.F.root.child('catalogs/operations/ordinary/' + payroll + '/' + activeId + '/collection');
                return opsRef.orderByChild('status').startAt(0.1).endAt(2.9).limitToFirst(1).once('value').then(function (opsSnap) {
                    if (opsSnap.exists()) {
                        return Promise.reject('No es posible activar el calendario ya que tiene operaciones activas o en proceso');
                    }
                    // 3) Desactivar el calendario previamente activo
                    return calendarsRef.child(activeId).child('data/active').set(false).then(function () {
                        return true;
                    });
                });
            });
        }
        //esta funcion es para checar en ref /catalogs/operations/ordinary/-KwuNbRnT0gu4HE_Yr5A/2021/collection si ya hay operaciones activas, esto se hace buscando del 0 al 2.9 en el campo status no se hace nada pero en caso de que no haya como
        //como este calendario quedaria activo entonces se activa la primera operacion del periodo, es decir se ordena por period y se toma la primera operacion para activarla para, 
        // hay que regresar el un promise cuta resolucion sera el  update a realizar para continuar en la funcion
        function activeOperationIfNeeded(calendar) {
            var promise = $q.defer();
            var opsRef = $scope.F.root.child('catalogs/operations/ordinary/' + calendar.payroll + '/' + calendar.$id + '/collection');
            opsRef.orderByChild('status').startAt(0.1).endAt(2.9).limitToFirst(1).once('value', function (opsSnap) {
                var opId;
                if (opsSnap.exists()) {
                    var opsVal = opsSnap.val();
                    for (var k in opsVal) {
                        if (opsVal.hasOwnProperty(k)) {
                            opId = k;
                            break;
                        }
                    }
                }
                if (!opId) {
                    $scope.F.root.child('catalogs/operations/ordinary/' + calendar.payroll + '/' + calendar.$id + '/collection').orderByChild('period').limitToFirst(1).once('value').then(function (firstOpSnap) {
                        if (firstOpSnap.exists()) {
                            var firstOpVal = firstOpSnap.val();
                            for (var k in firstOpVal) {
                                if (firstOpVal.hasOwnProperty(k)) {
                                    opId = k;
                                    break;
                                }
                            }
                            var updates = {};
                            updates['catalogs/operations/ordinary/' + calendar.payroll + '/' + calendar.$id + '/collection/' + opId + '/status'] = 1;
                            promise.resolve(updates);
                        } else {
                            promise.resolve(null);
                        }
                    }).catch(function (err) {
                        promise.reject(err);
                    })
                } else {
                    promise.resolve(null);
                }
            }).catch(function (err) {
                promise.reject(err);
            });
            return promise.promise;
        }

        $scope.activeCalendar = function () {
            $rootScope.loadingProgress = true;
            var updates = {};
            var promises = [];
            checkIfAnyCalendarIsActive($scope.selected[0]).then(function (doHave) {
                promises = [];
                if (doHave) {
                    errAlertS('No es posible activar el calendario ya hay otro calendario activo');
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                } else {
                    var calendar = $scope.selected[0];
                    updates['catalogs/payrollCalendars/' + calendar.payroll + '/calendars/' + calendar.$id + '/data/active'] = true;
                    promises.push(activeOperationIfNeeded(calendar));
                }
                return Promise.all(promises);
            }).then(function (resp) {
                promises = [];
                if (resp.length > 0) {
                    angular.forEach(resp, function (update) {
                        if (update !== null) {
                            angular.extend(updates, update);
                        }
                    });
                    promises.push($scope.F.root.update(updates))
                }
                return Promise.all(promises);
            }).then(function (resp) {
                if (resp.length > 0) {
                    successAlertS('El calendario se activó correctamente');
                }
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
            }).catch(function (err) {
                errAlertS(err);
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
            });

        }

        // @todo:backlog refactorizar tabla y ver la manera de pintar la vista de datos si es "necesaria"
        $scope.deleteCalendarAndPeriods = function (e) {
            $rootScope.loadingProgress = true;
            var promises = [
                checkIfPayrollCalendarHaveActiveOperations($scope.selected[0]),
                checkIfExistIncidencesPayrollCalendar($scope.selected[0]),
                checkIfExistSettlement($scope.selected[0])
            ];
            Promise.all(promises).then(function (doHave) {
                if (!doHave[0] && !doHave[1]) {
                    var calendars = angular.copy($scope.selected);
                    $scope.delete(e, 1).then(function () {
                        var count = 0;
                        var updates = {};
                        angular.forEach(calendars, function (payrollCalendar) {
                            count++;
                            updates['catalogs/payrollCalendars/' + payrollCalendar.payroll + '/periods/' + payrollCalendar.$id] = null;
                            updates['catalogs/payrollCalendars/' + payrollCalendar.payroll + '/calendars/' + payrollCalendar.$id] = null;
                            updates['catalogs/operations/ordinary/' + payrollCalendar.payroll + '/' + payrollCalendar.$id] = null;
                        });
                        //console.log(updates);
                        $scope.F.root.update(updates).then(function () {
                            successAlertS('Se borraron ' + count + ' Calendario(s) y sus Operaciones');
                            $rootScope.loadingProgress = false;
                            $rootScope.$evalAsync(function () {
                                $log.debug('deleteCalendarAndPeriods finished');
                            });
                        }).catch(function (err) {
                            errAlertS(err);
                            $rootScope.loadingProgress = false;
                            $rootScope.$evalAsync();
                        });
                    });
                } else {
                    if (doHave[0] && doHave[1] && doHave[2]) {
                        errAlertS('No es posible borrar el/los calendarios ya que tienen una o más operaciones e incidencias activas');
                    } else if (doHave[0] && doHave[1]) {
                        errAlertS('No es posible borrar el/los calendarios ya que tienen una o más operaciones e incidencias activas');
                    } else {
                        if (doHave[0]) {
                            errAlertS('No es posible borrar el/los calendarios ya que tienen una o más operaciones activas');
                        }
                        if (doHave[1]) {
                            errAlertS('No es posible borrar el/los calendarios ya que tienen una o más incidencias activas');
                        }
                        if (doHave[2]) {
                            errAlertS('No es posible borrar el/los calendarios ya que tienen una o más finiquitos activos');
                        }
                    }
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                }
            }, function (err) {
                errAlertS(err);
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
            });
        }

        var checkIfPayrollCalendarHaveActiveOperations = function (calendar) {
            var promise = $q.defer();
            $scope.F.root.child('catalogs/operations/ordinary').child(calendar.payroll).child(calendar.$id).child('collection').orderByChild('status').startAt(2).once('value', function (snap) {
                var val = snap.val();
                if (val !== null) {
                    promise.resolve(true); // si tiene operaciones activas
                } else {
                    promise.resolve(false);
                }
            }, function (err) {
                promise.reject(err);
            });

            return promise.promise;
        }

        var checkIfExistIncidencesPayrollCalendar = function (calendar) {
            var promise = $q.defer();
            $scope.F.root.child('incidences').child(calendar.payroll).child(calendar.$id).limitToFirst(1).once('value', function (snap) {
                var val = snap.val();
                if (val !== null) {
                    promise.resolve(true); // si tiene incidencias activas
                } else {
                    promise.resolve(false);
                }
            }, function (err) {
                promise.reject(err);
            });
            return promise.promise;
        }

        var checkIfExistSettlement = function (calendar) {
            var promise = $q.defer();
            $scope.F.root.child('catalogs/operations/settlement/all').orderByChild('payroll').equalTo(calendar.payroll).once('value', function (snap) {
                var val = snap.val();
                if (val !== null) {
                    var exist = false;
                    for (var k in val) {
                        if (angular.isDefined(getFromObjectFilter(val[k], 'dispersion'))) {
                            exist = true;
                            break;
                        }
                    }
                    promise.resolve(exist);
                } else {
                    promise.resolve(false);
                }
            }, function (err) {
                promise.reject(err);
            });
            return promise.promise;
        }

        $scope.importCalendar = function (ev) {
            $mdDialog.show({
                templateUrl: 'app/main/clients/views/payrollCalendars/dialogs/importCalendar.html',
                controller: 'importCalendarController',
                controllerAs: 'ctrl',
                parent: angular.element($document.body),
                targetEvent: ev,
                size: 'lg'
            });
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.clients')
        .controller('PayrollCalendarController', PayrollCalendarController);

    function PayrollCalendarController(
        $scope,
        $rootScope,
        startAfterInitFilter,
        $timeout,
        $firebaseArray,
        $log,
        successAlertS,
        errAlertS,
        $q,
        $filter,
        $mdDialog,
        confirmConfig,
        getSomethingOfArrayFBFilter,
        ListsF
    ) {
        var initiated = false;
        var listWatchers = {};
        var removeCalendars = {
            periods: []
        };
        function init() {
            var needed = [
                $scope.dataNeededPromise,
                $scope.statesObjsPromise,
                $scope.mainObjectLoaded
            ];
            Promise.all(needed).then(function () {
                $log.log('Needed initiated');
                return loadPeriods();
            }).then(function () {
                initWatchers();
            }).catch(errAlertS);
        }

        //funciones para actualizar un calendario
        $scope.saveCalendarAndPeriods = function (payrollCalendars, periods) {
            var data = periods;
            var object = payrollCalendars;
            angular.extend(object.data, data);
            delete (object.data.periods);
            $log.log('Guardando calendario y periodos', object, data, removeCalendars);
            var datesAvailable = calendarDatesAvailable(object.data.startDate, object.data.endDate, object.payroll, object.$id);
            datesAvailable.then(function (valid) {
                if (valid) {
                    var payrollCalendarReference = 'catalogs/payrollCalendars/' + object.payroll;
                    var calendarsReference = payrollCalendarReference + '/calendars';
                    var periodsReference = payrollCalendarReference + '/periods';
                    var operationReference = 'catalogs/operations/ordinary/' + object.payroll + '/' + object.data.year + '/collection';

                    var updates = {};
                    if (removeCalendars.periods.length > 0) {
                        for (var i = 0; i < removeCalendars.periods.length; i++) {
                            updates[periodsReference + '/' + object.data.year + '/' + removeCalendars.periods[i].$id] = null;
                            updates[operationReference + '/' + removeCalendars.periods[i].operationId] = null;
                        }
                    }
                    for (var key in removeCalendars.calendar) {
                        if (removeCalendars.calendar.hasOwnProperty(key)) {
                            updates[calendarsReference + '/' + object.data.year + '/data/' + key] = removeCalendars.calendar[key];
                        }
                    }
                    if (!updates.hasOwnProperty(calendarsReference + '/' + object.data.year + '/data/endDate')) {
                        updates[calendarsReference + '/' + object.data.year + '/data/endDate'] = $scope.payrollCalendar.data.endDate;
                    }
                    if (!updates.hasOwnProperty(calendarsReference + '/' + object.data.year + '/data/lastDate')) {
                        updates[calendarsReference + '/' + object.data.year + '/data/lastDate'] = $scope.payrollCalendar.data.lastDate || null;
                    }
                    if (!updates.hasOwnProperty(calendarsReference + '/' + object.data.year + '/data/lastPeriod')) {
                        updates[calendarsReference + '/' + object.data.year + '/data/lastPeriod'] = $scope.payrollCalendar.data.lastPeriod;
                    }
                    var first = true;
                    for (var c = 0; c < data.periods.length; c++) {
                        var thisPeriod = data.periods[c];
                        if (!thisPeriod.$id) {
                            var operationId = $scope.F.root.child(operationReference).push().key;
                            var operation = {
                                status: -1,
                                period: thisPeriod.period,
                                calendar: object.data.year,
                                payroll: object.payroll,
                                firm: object.firm,
                                created: $scope.D.getTimeObject(),
                                type: 'automatic',
                                isAdjustment: thisPeriod.isAdjustment,
                                factor: thisPeriod.factor,
                                accumulator: thisPeriod.accumulator,
                                center: $scope.F.center,
                                accuDate: thisPeriod.accuDate
                            };
                            updates[operationReference + '/' + operationId] = operation;
                            thisPeriod.operationId = operationId;
                            delete thisPeriod.days;
                            delete thisPeriod.isAdjustment;
                            var newPayrollCalendarId = object.data.year;
                            updates[periodsReference + '/' + newPayrollCalendarId + '/' + thisPeriod.period] = thisPeriod;
                        } else {
                            updates[operationReference + '/' + data.periods[c].operationId + '/isAdjustment'] = data.periods[c].isAdjustment || false;
                            updates[operationReference + '/' + data.periods[c].operationId + '/factor'] = data.periods[c].factor;
                            updates[operationReference + '/' + data.periods[c].operationId + '/accumulator'] = data.periods[c].accumulator;
                            updates[operationReference + '/' + data.periods[c].operationId + '/center'] = $scope.F.center;
                            var exists = removeCalendars.periods.find(function (value) {
                                return value.$id === data.periods[c].$id;
                            });
                            if (angular.isUndefined(exists)) {
                                if (first) {
                                    if (data.periods[c].status < 3 && data.periods[c].status < 1) {
                                        updates[operationReference + '/' + data.periods[c].operationId + '/status'] = 1;
                                    }
                                    first = false;
                                }
                                updates[periodsReference + '/' + object.data.year + '/' + data.periods[c].$id + '/accuDate'] = data.periods[c].accuDate;
                                updates[periodsReference + '/' + object.data.year + '/' + data.periods[c].$id + '/factor'] = data.periods[c].factor;
                                updates[periodsReference + '/' + object.data.year + '/' + data.periods[c].$id + '/isAdjustment'] = data.periods[c].isAdjustment;
                            }
                        }
                    }
                    $log.log('Que actualizo', updates);
                    $scope.F.root.update(updates).then(function () {
                        successAlertS('Se actualizó la información de los periodos y los datos del calendario con éxito');
                        $scope.R.goToList();
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync();
                    }).catch(function (error) {
                        errAlertS('No se pudo actualizar los periodos y los datos del calendario');
                        $log.error('Error al guardar el calendario', error);
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync();
                    });
                } else {
                    errAlertS('Ya existe un calendario con estas fechas');
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                }
            }).catch(function (error) {
                $log.error('Ocurrió un error al actualizar los periodos y datos del calendario', error);
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
            })
        }
        $scope.removePayrollAndPeriod = function (period, index) {
            var title = 'Quiere eliminar el periodo ' + period.period + ' del calendario?';
            var msg = 'No podrá recuperar sus datos';
            $mdDialog.show($mdDialog.confirm(confirmConfig)
                .title(title)
                .content(msg)
                .ariaLabel('Deleting')
                .ok('Aceptar')
                .cancel('Cancelar'))
                .then(function () {
                    $scope.dataToCreate.periods.splice(index, 1);
                    removeCalendars.periods.push(period);
                    removeCalendars.calendar = {
                        startDate: $scope.dataToCreate.periods[0].start,
                        endDate: $scope.dataToCreate.periods[$scope.dataToCreate.periods.length - 1].end,
                        lastDate: $scope.dataToCreate.periods[$scope.dataToCreate.periods.length - 1].end,
                        initialPeriod: $scope.dataToCreate.periods[0].period,
                        lastPeriod: $scope.dataToCreate.periods[$scope.dataToCreate.periods.length - 1].period
                    }
                    $scope.calcFactor();
                    $log.log(removeCalendars);
                }, function () {
                    $log.log('Se cancelo la operación');
                });
        }
        $scope.addPeriod = function () {
            try {
                var lastPeriod = $scope.dataToCreate.periods.length > 0 ? $scope.dataToCreate.periods[$scope.dataToCreate.periods.length - 1] : undefined;
                $log.log(lastPeriod)
                if (angular.isUndefined(lastPeriod)) { throw 'No se encontró el ultimo periodo'; }
                getPaymentFrequency($scope.payrollCalendar.payroll).then(function (paymentFrequency) {
                    var newPeriodData = constructPeriods(moment(lastPeriod.end).add(1, 'day').startOf('day'), lastPeriod.period + 1, paymentFrequency.days, undefined, $scope.payrollCalendar.extraWeek);
                    if (newPeriodData.periods.length) {
                        var thisPeriod = newPeriodData.periods[0];
                        var startDay = moment(thisPeriod.start);
                        var endDay = moment(thisPeriod.end);
                        var days = endDay.diff(startDay, 'days');
                        var monthActual = moment(thisPeriod.end).format('M');
                        var monthNext = moment(lastPeriod.end).format('M');
                        thisPeriod.days = days + 1;
                        thisPeriod.isAdjustment = monthActual !== monthNext ? true : false;
                        $scope.dataToCreate.periods.push(thisPeriod);
                        $scope.calcFactor();
                        removeCalendars.calendar = {
                            startDate: $scope.dataToCreate.periods[0].start,
                            initialPeriod: $scope.dataToCreate.periods[0].period,
                            endDate: $scope.dataToCreate.periods[$scope.dataToCreate.periods.length - 1].end,
                            lastPeriod: $scope.dataToCreate.periods[$scope.dataToCreate.periods.length - 1].period,
                            lastDate: $scope.dataToCreate.periods[$scope.dataToCreate.periods.length - 1].end
                        }
                    } else {
                        throw 'No se puede crear mas periodos';
                    }
                }).catch(errAlertS)
            } catch (error) {
                errAlertS(error)
            }
        }
        $scope.addCalendarAndPeriods = function (payrollCalendar, calendarData) {
            $log.debug('adding payrollCalendar', payrollCalendar);
            $rootScope.loadingProgress = true;
            var data = calendarData;
            var object = payrollCalendar;
            // esto se ejecuta cuando ya se guardara la información
            angular.extend(object.data, calendarData);
            delete (object.data.periods);
            var periods = $filter('keyObjectAsId')(data.periods, 'period');
            var datesAvailable = calendarDatesAvailable(object.data.startDate, object.data.endDate, object.payroll);
            datesAvailable.then(function (flag) {
                var payrollCalendarReference = 'catalogs/payrollCalendars/' + object.payroll;
                var calendarsReference = payrollCalendarReference + '/calendars';
                var periodsReference = payrollCalendarReference + '/periods';
                var operationReference = 'catalogs/operations/ordinary/' + object.payroll + '/' + object.data.year + '/collection';
                if (flag) {
                    getActiveCalendar(object.payroll).then(function (snap) {
                        var setActive = true;
                        if (snap.exists()) {
                            setActive = false;
                        }
                        var updates = {};
                        var firstPeriod = true;
                        angular.forEach(periods, function (value) {
                            var operationId = $scope.F.root.child(operationReference).push().key;
                            var operation = {
                                status: -1,
                                period: value.period,
                                calendar: object.data.year,
                                payroll: object.payroll,
                                firm: object.firm,
                                created: $scope.D.getTimeObject(),
                                type: 'automatic',
                                isAdjustment: value.isAdjustment,
                                factor: value.factor,
                                accumulator: value.accumulator,
                                accuDate: value.accuDate,
                                center: $scope.F.center
                            };
                            if (firstPeriod) {
                                if (setActive) {
                                    operation.status = 1;
                                }
                                firstPeriod = false;
                            }
                            updates[operationReference + '/' + operationId] = operation;
                            value.operationId = operationId;
                            delete value.days;
                            delete value.isAdjustment;
                        });
                        if (setActive) {
                            object.data.active = true;
                        }
                        var newPayrollCalendarId = object.data.year;
                        updates[calendarsReference + '/' + newPayrollCalendarId] = object;
                        updates[periodsReference + '/' + newPayrollCalendarId] = periods;
                        $scope.F.root.update(updates, function (error) {
                            if (error) {
                                errAlertS;
                                $log.debug(error);
                                $rootScope.loadingProgress = false;
                                $rootScope.$evalAsync();
                            } else {
                                successAlertS('Se creó calendario con éxito');
                                $rootScope.loadingProgress = false;
                                $rootScope.$evalAsync(function () {
                                    $log.debug('addCalendarAndPeriods finished');
                                });
                                $scope.R.goToList();
                            }
                        });
                    });
                } else {
                    errAlertS('Ya existe un calendario con estas fechas');
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                }
            }).catch(function (error) {
                $log.error(error);
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
            });
        };
        $scope.watchInitialDate = function (params) {
            if (angular.isObject(params) && params.type === 'year') {
                var form = params.form;
                var year = (params.year + '').length;
                $scope.yearError = '';
                if (angular.isDefined(year)) {
                    var error = false;
                    if (year > 4) {
                        $scope.messageYear = 'Solo se permite 4 dígitos';
                    } else if (params.year < 2000) {
                        $scope.messageYear = 'El año tiene que ser mayor o igual que 2000';
                    } else if (params.year > 3000) {
                        $scope.messageYear = 'El año tiene que ser menor o igual que 3000';
                    } else {
                        error = true;
                    }
                    form["year"].$setValidity('validationYear', error);
                }
            }
            if ($scope.payrollCalendar.payroll && $scope.payrollCalendar.data.year && $scope.initialDate && $scope.F.addMode) {
                $rootScope.loadingProgress = true;
                var calendarData = constructCalendar($scope.initialDate, $scope.payrollCalendar.data.initialPeriod, $scope.payrollCalendar.payroll, $scope.payrollCalendar.data.lastDate, $scope.payrollCalendar.extraWeek);
                calendarData.then(function (data) {
                    var isAdjustment = false;
                    for (var c = 0; c < data.periods.length; c++) {
                        var startDay = moment(data.periods[c].start);
                        var endDay = moment(data.periods[c].end);
                        var days = endDay.diff(startDay, 'days');
                        if (typeof data.periods[c + 1] !== "undefined") {
                            var monthActual = moment(data.periods[c].end).format('M');
                            var monthNext = moment(data.periods[c + 1].end).format('M');
                            if (monthActual !== monthNext) {
                                isAdjustment = true;
                            } else {
                                isAdjustment = false;
                            }
                        } else {
                            isAdjustment = true;
                        }
                        data.periods[c].isAdjustment = isAdjustment;
                        data.periods[c].days = days + 1;
                    }
                    $scope.dataToCreate = data;
                    $scope.calcFactor();
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                }).catch(function (err) {
                    errAlertS(err);
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                });
            }
        }
        $scope.calcFactor = function (data, event, indexAffected) {
            var promises = [];
            if (angular.isObject(data) && data.close) {
                var confirm = $mdDialog.confirm().
                    title('Modificar periodo cerrado')
                    .textContent('Se esta modificando la información de un periodo cerrado esto afectara la información de dichos periodos y podría causar una incongruencia en la información procesada, desea continuar?')
                    .ariaLabel('Desea continuar?')
                    .targetEvent(event)
                    .ok('OK')
                    .cancel('Cancelar');
                promises.push($mdDialog.show(confirm))
            }
            Promise.all(promises).then(function () {
                var periods = $scope.dataToCreate.periods;
                var accumulator = 0;
                for (var c = 0; c < periods.length; c++) {
                    if (c >= 1 && periods[c - 1].isAdjustment) {//Si no hay periodo interior o si el periodo interior se realiza ajuste el acumulador inicia en 0
                        accumulator = 0;
                    }
                    accumulator = accumulator + periods[c].days;
                    $scope.dataToCreate.periods[c].accumulator = accumulator;
                }
                var factor;
                for (var f = (periods.length - 1); f >= 0; f--) {
                    if (typeof (factor) === 'undefined' || periods[f].isAdjustment) {
                        factor = periods[f].accumulator;
                    }
                    $scope.dataToCreate.periods[f].factor = factor;
                    if (indexAffected === f || !$scope.dataToCreate.periods[f].accuDate) {
                        $scope.dataToCreate.periods[f].accuDate = periods[f].isAdjustment ? periods[f].start : moment.utc(moment(periods[f].end).format('DD-MM-YYYY') + ' 00:00 -0500', 'DD-MM-YYYY HH:mm Z').valueOf();
                    }
                }
                $timeout(function () { });
            }).catch(function (error) {
                $log.error(error);
                data.isAdjustment = data.isAdjustment ? false : true;
                $timeout(function () { });
            })
        }
        function loadPeriods() {
            return new Promise(function (resolve, reject) {
                var payrollCalendars = $filter('clearObject')($scope.payrollCalendar);
                if ($filter('objectsLength')(payrollCalendars.data) > 0) {
                    var promises = [
                        ListsF.loadList("calendarPeriods", 'catalogs/payrollCalendars/' + payrollCalendars.payroll + '/periods/' + payrollCalendars.data.year, undefined, "array", "calendarPeriod" + payrollCalendars.payroll + '/' + payrollCalendars.data.year),
                        $scope.F.root.child('catalogs/operations/ordinary/' + payrollCalendars.payroll + '/' + payrollCalendars.data.year + '/collection').once("value"),
                        $scope.F.root.child('catalogs/operations/settlement/all').orderByChild('payroll').equalTo(payrollCalendars.payroll).once("value")
                    ];
                    Promise.all(promises).then(function (data) {
                        var calendar = data[0];
                        var operation = data[1].val() || {};
                        var settlement = $filter('orderBy')($filter('getArrayFromObject')(data[2].val(), false, true), 'period');
                        if (angular.isArray(calendar)) {
                            for (var c = 0; c < calendar.length; c++) {
                                if (calendar[c].operationId && operation[calendar[c].operationId] && angular.isDefined(calendar[c]) && angular.isDefined(calendar[c].period)) {
                                    var startDay = moment(calendar[c].start);
                                    var endDay = moment(calendar[c].end);
                                    var days = endDay.diff(startDay, 'days');
                                    var exists = false;
                                    calendar[c].days = days + 1;
                                    calendar[c].isAdjustment = operation[calendar[c].operationId].isAdjustment;
                                    calendar[c].factor = operation[calendar[c].operationId].factor;
                                    calendar[c].accumulator = operation[calendar[c].operationId].accumulator;
                                    calendar[c].status = operation[calendar[c].operationId].status;
                                    if (operation[calendar[c].operationId].status >= 3) {
                                        calendar[c].close = true;
                                        exists = true;
                                    }
                                    if (!exists) {
                                        var findSettlement = settlement.filter(function (value) {
                                            return (value.accuPeriod || value.period) === calendar[c].period && value.calendar === parseInt(payrollCalendars.data.year);
                                        });
                                        if (findSettlement.length > 0) {
                                            calendar[c].close = true;
                                            calendar[c].status = -1;
                                        }
                                    }
                                }
                            }
                            var period = {
                                periods: angular.fromJson(angular.toJson(calendar))
                            };
                            $scope.initialDate = payrollCalendars.data.startDate;
                            $log.log('setting initial Date', $scope.initialDate, period);
                            $scope.dataToCreate = period;
                            $rootScope.$evalAsync(function () {
                                $timeout(function () {
                                    resolve(true);
                                }, 0)
                            });
                        } else {
                            errAlertS('No se encontró calendario del periodo');
                            resolve(true);
                        }
                    }).catch(function (error) {
                        errAlertS('Ocurrió un error al cargar el calendario del periodo');
                        $log.log(error);
                        reject(false);
                    });
                } else {
                    resolve(true);
                }
            })
        }
        function getActiveCalendar(payroll) {
            return $scope.F.root.child('catalogs/payrollCalendars/' + payroll + '/calendars').orderByChild('data/active').equalTo(true).once("value");
        }
        function getPaymentFrequency(payrollId) {
            return new Promise(function (resolve, reject) {
                $scope.F.root.child('catalogs/payrolls/collection/' + payrollId + '/paymentFrequency').once('value').then(function (snapshot) {
                    if (!snapshot.exists()) {
                        throw 'No se encontró la frecuencia de pago'
                    }
                    var frequencyId = snapshot.val();
                    return $scope.D.api.get('paymentFrequenciesRecords/' + frequencyId);
                }).then(function (res) {
                    var paymentFrequency = res.data;
                    if (Object.keys(res.data).length === 0) {
                        throw "No se encontró la información de la frecuencia de pago";
                    }
                    resolve(paymentFrequency);
                }).catch(reject)
            })
        }
        /*sección de creación de calendario y periodos*/
        function constructCalendar(startDate, actualPeriod, payrollId, lastDate, extraWeek) {
            return new Promise(function (resolve, reject) {
                getPaymentFrequency(payrollId).then(function (paymentFrequency) {
                    startDate = moment(startDate);
                    startDate.set('hour', 0);
                    startDate.set('minute', 0);
                    startDate.set('second', 0);
                    startDate.set('millisecond', 0);
                    var calendar_date = constructPeriods(startDate, actualPeriod, paymentFrequency.days, lastDate, extraWeek);
                    if (calendar_date.periods.length) {
                        calendar_date.name = paymentFrequency.name;
                        calendar_date.lastPeriod = angular.copy(calendar_date.periods[calendar_date.periods.length - 1].period);
                    }
                    resolve(calendar_date);
                }).catch(function (err) {
                    reject(err);
                });
            });
        }
        function constructPeriods(startDate, actualPeriod, frequencyPayment, lastDate, extraWeek) {
            $log.log('constructPeriods', {
                startDate: startDate,
                actualPeriod: actualPeriod,
                frequencyPayment: frequencyPayment,
                lastDate: lastDate,
                extraWeek: extraWeek
            });
            if (angular.isUndefined(actualPeriod) || actualPeriod <= 0 || actualPeriod === '') {
                actualPeriod = 1;
            }
            var data = {};
            switch (frequencyPayment) {
                case 7:
                    data = constructFixedPeriod(startDate, actualPeriod, 7, extraWeek ? 53 : 52, lastDate);
                    break;
                case 14:
                    data = constructFixedPeriod(startDate, actualPeriod, 14, extraWeek ? 27 : 26, lastDate);
                    break;
                case 15:
                case 15.21:
                    data = constructBiweekly(startDate, actualPeriod, 24, lastDate);
                    break;
                case 30:
                case 30.42:
                    data = constructMonthlyPeriod(startDate, actualPeriod, 12, lastDate);
                    break;
            }
            return data;
        }
        function constructFixedPeriod(startDate, actualPeriod, daysOfPeriod, totalPeriods, lastDate) {
            var data = {
                periods: [],
                endDate: '',
                startDate: startDate.valueOf()
            };
            var endDate = angular.copy(startDate);
            endDate.add(daysOfPeriod, 'd').subtract(1, 'ms');
            var startDateF = startDate.format('DD/MM/YYYY');
            if (lastDate) {
                var lastDateObject = moment(lastDate);
                var lastDateF = lastDateObject.format('DD/MM/YYYY');
                var days = lastDateObject.diff(startDate, 'days');
                totalPeriods = Math.ceil(parseInt(days) / parseInt(daysOfPeriod));
                if (actualPeriod > 1) totalPeriods += parseInt(actualPeriod) - 1;
            }
            $log.debug('constructFixedPeriod', {
                lastDateObject: lastDateObject,
                lastDate: lastDateF,
                startDate: startDateF,
                totalPeriods: totalPeriods,
                days: days,
                actualPeriod: actualPeriod,
                daysOfPeriod: daysOfPeriod
            })
            for (var i = actualPeriod; i <= totalPeriods; i++) {
                var period = constructPeriod(startDate, endDate, i);
                data.periods.push(period);
                startDate.add(daysOfPeriod, 'd');
                endDate.add(daysOfPeriod, 'd');
            }
            startDate.subtract(1, 'ms');
            data.endDate = startDate.valueOf();
            return data;
        }
        function constructBiweekly(startDate, actualPeriod, totalPeriods, lastDate) {
            var tempDate = angular.copy(startDate);
            tempDate.set('hour', 0);
            tempDate.set('minute', 0);
            tempDate.set('second', 0);
            tempDate.set('millisecond', 0);
            var data = {
                periods: [],
                endDate: '',
                startDate: ''
            };
            var firstDayOfMonth = '01-' + startDate.format('MM-YYYY');
            firstDayOfMonth = moment(firstDayOfMonth, 'DD-MM-YYYY ');
            firstDayOfMonth.set('hour', 0);
            firstDayOfMonth.set('minute', 0);
            firstDayOfMonth.set('second', 0);
            firstDayOfMonth.set('millisecond', 0);
            var sixteenthDayOfMonth = '16-' + startDate.format('MM-YYYY');
            sixteenthDayOfMonth = moment(sixteenthDayOfMonth, 'DD-MM-YYYY');
            sixteenthDayOfMonth.set('hour', 0);
            sixteenthDayOfMonth.set('minute', 0);
            sixteenthDayOfMonth.set('second', 0);
            sixteenthDayOfMonth.set('millisecond', 0);
            var lastDayOfMonth = angular.copy(firstDayOfMonth);
            $log.log(firstDayOfMonth.utcOffset(), sixteenthDayOfMonth.utcOffset(), lastDayOfMonth.utcOffset());
            lastDayOfMonth.add(1, 'M').subtract(1, 'ms');
            var firstBiweekly = true;
            var lastPeriodStart;
            if (parseInt(startDate.format('DD')) > 15) {
                firstBiweekly = false;
                lastPeriodStart = angular.copy(sixteenthDayOfMonth);
            } else {
                lastPeriodStart = angular.copy(firstDayOfMonth);
            }
            var i = actualPeriod;
            var lastDateObject = moment(lastDate);
            while ((!lastDate && i <= totalPeriods) || (lastDate && lastDateObject.valueOf() > lastPeriodStart.valueOf())) {
                var period;
                if (firstBiweekly) {
                    var temp_sixteenthDayOfMonth = angular.copy(sixteenthDayOfMonth);
                    temp_sixteenthDayOfMonth.subtract(1, 'ms');
                    period = constructPeriod(firstDayOfMonth, temp_sixteenthDayOfMonth, i);
                } else {
                    period = constructPeriod(sixteenthDayOfMonth, lastDayOfMonth, i);
                }
                lastPeriodStart = moment(period.end);
                data.periods.push(period);
                if (!firstBiweekly) {
                    firstDayOfMonth.add(1, 'M');
                    sixteenthDayOfMonth.add(1, 'M');
                    lastDayOfMonth = angular.copy(firstDayOfMonth);
                    lastDayOfMonth.add(1, 'M').subtract(1, 'ms');
                }
                firstBiweekly = !firstBiweekly;
                i++;
            }
            if (firstBiweekly) {
                firstDayOfMonth.subtract(1, 'ms');
                data.endDate = firstDayOfMonth.valueOf();
            } else {
                sixteenthDayOfMonth.subtract(1, 'ms');
                data.endDate = sixteenthDayOfMonth.valueOf();
            }
            if (data.periods.length) {
                data.periods[0].start = tempDate.valueOf();
                data.periods[0].startString = tempDate.format('DD-MM-YYYY');
                data.startDate = tempDate.valueOf();
            }
            return data;
        }
        function constructMonthlyPeriod(startDate, actualPeriod, totalPeriods, lastDate) {
            var tempDate = angular.copy(startDate);
            tempDate.set('hour', 0);
            tempDate.set('minute', 0);
            tempDate.set('second', 0);
            tempDate.set('millisecond', 0);
            var data = {
                periods: [],
                endDate: '',
                startDate: ''
            };
            var startDateString = '01-' + startDate.format('MM-YYYY');
            startDate = moment(startDateString, 'DD-MM-YYYY');
            startDate.set('hour', 0);
            startDate.set('minute', 0);
            startDate.set('second', 0);
            startDate.set('millisecond', 0);
            data.startDate = startDate.valueOf();
            var endDate = angular.copy(startDate);
            endDate.add(1, 'M').subtract(1, 'ms');
            var lastPeriodStart = angular.copy(startDate);
            var i = actualPeriod;
            var lastDateObject = moment(lastDate);
            while ((!lastDate && i <= totalPeriods) || (lastDate && lastDateObject.valueOf() > lastPeriodStart.valueOf())) {
                var period = constructPeriod(startDate, endDate, i);
                lastPeriodStart = moment(period.end);
                data.periods.push(period);
                startDate.add(1, 'M');
                endDate = angular.copy(startDate);
                endDate.add(1, 'M').subtract(1, 'ms');
                i++;
            }
            startDate.subtract(1, 'ms');
            data.endDate = startDate.valueOf();
            if (data.periods.length) {
                data.periods[0].start = tempDate.valueOf();
                data.periods[0].startString = tempDate.format('DD-MM-YYYY');
            }
            data.startDate = tempDate.valueOf();
            return data;
        }
        function constructPeriod(startDate, endDate, period) {
            var data = {
                start: startDate.valueOf(),
                end: endDate.valueOf(),
                startString: startDate.format('DD-MM-YYYY'),
                endString: endDate.format('DD-MM-YYYY'),
                period: parseInt(period + ''),
                active: true
            };
            return data;
        }
        // función para checar si las fechas de calendarios esta disponibles
        function calendarDatesAvailable(startDate, endDate, payrollId, calendarId) {
            return $q(function (resolve, reject) {
                var flag = true;
                //se realiza una consulta para encontrar los calendarios cuya fecha inicial se encuentre en las fechas de inicio y fin del calendario que se esta verificando
                var calendarsAfter = $firebaseArray($scope.F.root.child('catalogs/payrollCalendars/' + payrollId + '/calendars').orderByChild('data/startDate').startAt(startDate).endAt(endDate));
                //una vez cargados se procede a verificar la información
                calendarsAfter.$loaded(function (calendars) {
                    //si se encontraron calendarios se almacena la cantidad encontrados
                    var recordsFounded = calendars.length;
                    $log.debug(calendars, 'records Founded Start');
                    //si se manda el parámetro de Id del calendario quiere decir que se esta haciendo la verificación de un calendario ya guardado por lo tanto puede ser que se encuentre un record
                    if (angular.isDefined(calendarId)) {
                        //se prosigue a checar si el calendario del cual se esta verificando las fechas es el mismo que se encontró
                        var isTheSame = false;
                        angular.forEach(calendars, function (value) {
                            if (calendarId === value.$id) {
                                isTheSame = true;
                            }
                        });
                        //si el record encontrado corresponde al mismo record del cual se esta verificando las fechas entonces se disminuye la cantidad de registros encontrados
                        if (isTheSame) {
                            recordsFounded--;
                        }
                    }
                    //si el numero de record encontrados es 0 entonces se procede a checar la fecha final
                    if (recordsFounded < 1) {
                        //se realiza una consulta para encontrar los calendarios cuya fecha final se encuentre en las fechas de inicio y fin del calendario que se esta verificando
                        var calendarsBefore = $firebaseArray($scope.F.root.child('catalogs/payrollCalendars/' + payrollId + '/calendars').orderByChild('data/endDate').startAt(startDate).endAt(endDate));
                        //una vez cargados se procede a la verificación
                        calendarsBefore.$loaded(function (calendars) {
                            //se establece el numero de records encontrados
                            recordsFounded = calendars.length;
                            $log.debug(calendars, 'records Founded');
                            //si se manda el parametron de Id del calendario quiere decir que se esta haciendo la verificación de un calendario ya guardado por lo tanto puede ser que se encuentre un record 
                            if (angular.isDefined(calendarId)) {
                                var isTheSame = false;
                                angular.forEach(calendars, function (value) {
                                    if (calendarId === value.$id) {
                                        isTheSame = true;
                                    }
                                });
                                //si el record encontrado corresponde al mismo record del cual se esta verificando las fechas entonces se disminuye la cantidad de registros encontrados
                                if (isTheSame) {
                                    recordsFounded--;
                                }
                            }
                            //finalmente si los records encontrados son menores a uno quiere decir que no hay ningún calendario en las fechas que se quieren verificar
                            if (recordsFounded < 1) {
                                resolve(flag);
                            } else {
                                //si hay records encontrados entonces se le dice al usuario que ya hay calendarios en esas fechas
                                flag = false;
                                resolve(flag);
                            }
                        }, function (error) {
                            reject(error);
                        });
                    } else {
                        flag = false;
                        resolve(flag);
                    }
                }, function (error) {
                    reject(error);
                });
            });
        }
        function initWatchers() {
            $log.log('watchers init');
            // observa cuando se carga la fecha de inicio para llenar el md-datepicker
            listWatchers.startDate = $scope.$watch('payrollCalendar.data.startDate', function (newValue) {
                if (angular.isDefined(newValue) && newValue !== '') {
                    $scope.initialDate = newValue;
                }
            });
            listWatchers.data = $scope.$watch('payrollCalendar.data', function (payrollCalendarD) {
                if (payrollCalendarD) {
                    $scope.originalPayrollCalendar = angular.fromJson(angular.toJson($scope.payrollCalendar));
                }
            }, true);
            listWatchers.initialDate = $scope.$watch('initialDate', function (initialDate) {
                $log.log(initialDate);
                if (initialDate) {
                    $scope.minEndDate = moment(initialDate).endOf("day").toDate();
                } else {
                    $scope.minEndDate = null;
                }
            });
            listWatchers.lastDate = $scope.$watch('payrollCalendar.data.lastDate', function (lastDate) {
                if (lastDate) {
                    $scope.maxStartDate = moment(lastDate).startOf("day").toDate();
                } else {
                    $scope.maxStartDate = null;
                }
                $log.log($scope.maxStartDate);
            });
            // observa payroll para setear firm en calendario 
            listWatchers.payroll = $scope.$watch('payrollCalendar.payroll', function (payrollId, old) {
                if (angular.isDefined(payrollId)) {
                    var payrollIsActive = getSomethingOfArrayFBFilter(payrollId, $scope.L.allPayrolls, 'active');
                    if (payrollIsActive) {
                        $scope.F.search.$payroll = payrollId;
                        $scope.payrollCalendar.firm = $filter('getSomethingOfArrayFB')(payrollId, $scope.L.allPayrolls, 'firm');
                        $scope.mainRef = $scope.R.constructDinamicRef($scope.F.active.menuName, $scope.statesObj[$scope.F.active.menuName].filter, $scope);
                        if (payrollId !== old && angular.isDefined(old)) {
                            $scope.payrollCalendar.data.year = null;
                            $scope.payrollCalendar.data.initialPeriod = null;
                        }
                    } else {
                        if ($scope.F.addMode) {
                            errAlertS('La nómina pre-seleccionada no está activa');
                            $scope.payrollCalendar.payroll = null;
                        }
                    }
                }
            });
            //Observa el año seleccionado para llenar el md-datepicker con el año inicial y final con un mes de colchón
            listWatchers.year = $scope.$watch('payrollCalendar.data.year', function (year) {
                $log.log(year)
                if (angular.isDefined(year) && year !== null && year != '' && (year.toString()).length >= 4) {
                    $log.log('init validation')
                    $scope.minStartDate = new Date('12-01-' + (year - 1));
                    $scope.maxStartDate = new Date('01-31-' + (year + 1));
                    $scope.minEndDate = new Date('12-01-' + (year - 1));
                    $scope.maxEndDate = new Date('01-31-' + (year + 1));
                    if ($scope.initialDate && ($scope.minStartDate.valueOf() > $scope.initialDate || $scope.initialDate > $scope.maxStartDate.valueOf())) {
                        delete $scope.initialDate;
                        $log.log('initialDate deleted');
                    }
                    if ($scope.payrollCalendar.data.lastDate && ($scope.minEndDate.valueOf() > $scope.payrollCalendar.data.lastDate || $scope.payrollCalendar.data.lastDate > $scope.maxEndDate.valueOf())) {
                        delete $scope.payrollCalendar.data.lastDate;
                        $log.log('lastDate deleted');
                    }
                }
            });
        }
        startAfterInitFilter($scope, listWatchers, initiated, init)
    }
})();
(function () {
    'use strict';
    angular
        .module('app.clients')
        .controller('importCalendarController', importCalendarController);

    function importCalendarController($scope, DataF, errAlertS, $timeout, AppF, ListsF, CalendarF, $log, $rootScope, $mdDialog, successAlertS) {
        var vm = this;
        $scope.L = ListsF;
        $scope.F = AppF;
        $scope.C = CalendarF
        vm.loading = false;


        function uploadCsv() {
            var files = vm.filesArray;
            vm.loading = true;
            if (angular.isArray(files) && files.length > 0) {
                vm.loading = false;
                var formData = new FormData();
                formData.append('file', files[0].lfFile);
                $rootScope.$evalAsync()
                DataF.files.csvToJson(formData).then(function (resp) {
                    var requiredHeaders = ["periodo", "inicio", "fin", "fecha_acumulado", "ajuste", "calendario"];
                    var data = resp.data;
                    var isValid = Object.values(data).every(function (item) {
                        return requiredHeaders.every(function (header) {
                            return header in item;
                        });
                    });
                    if (!isValid) {
                        $rootScope.$evalAsync();
                        throw errAlertS("El archivo no tiene los encabezados requeridos.")
                    }
                    var result = Object.values(data).map(function (item) {
                        var initDate = moment(item.inicio, ['DD-MM-YYYY', 'DD/MM/YYYY']);
                        var lastDate = moment(item.fin, ['DD-MM-YYYY', 'DD/MM/YYYY']);
                        var daysOf = lastDate.diff(initDate, 'days') + 1;
                        var ajust = (item.ajuste === 'true' || item.ajuste.toLowerCase() === 'si') ? true : false;

                        var thisPeriod = parseInt(item.periodo);
                        var thisYear = parseInt(item.calendario);
                        if ((isNaN(thisPeriod)) || (isNaN(thisYear))) {
                            throw new Error('El formato del calendario o el periodo no es valido')
                        }
                        return {
                            periodo: thisPeriod,
                            inicio: item.inicio,
                            fin: item.fin,
                            fechaAcumulado: item.fecha_acumulado,
                            fechaCierre: item.fecha_cierre,
                            ajuste: ajust,
                            year: thisYear,
                            days: daysOf
                        };
                    });

                    var validatedResult = result.map(function (item) {
                        var inicioValido = moment(item.inicio, ['DD-MM-YYYY', 'DD/MM/YYYY'], true).isValid();
                        var finValido = moment(item.fin, ['DD-MM-YYYY', 'DD/MM/YYYY'], true).isValid();
                        var fechaAcumuladoValido = moment(item.fechaAcumulado, ['DD-MM-YYYY', 'DD/MM/YYYY'], true).isValid();
                        var isValid = inicioValido && finValido && fechaAcumuladoValido;
                        if (angular.isDefined(item.fechaCierre)) {
                            var fechaCierre = moment(item.fechaCierre, ['DD-MM-YYYY', 'DD/MM/YYYY'], true).isValid();
                            isValid = isValid && fechaCierre;
                        }
                        return Object.assign({}, item, { isValid: isValid });
                    });

                    // Log de los resultados validados
                    validatedResult.forEach(function (item) {
                        if (item.isValid) {
                            $log.log('Es valido la fecha')
                        } else {
                            throw errAlertS('No es valido el formato de fecha')
                        }
                    });
                    var periodos = sonConsecutivos(result);
                    if (periodos) {
                        var periods = result;
                        vm.accumulator = 0
                        for (var c = 0; c < periods.length; c++) {

                            if (c >= 1 && periods[c - 1].ajuste) {
                                vm.accumulator = 0;
                            }
                            vm.accumulator = vm.accumulator + periods[c].days;
                            periods[c].accumulator = vm.accumulator;
                        }


                        var factor;
                        for (var f = (periods.length - 1); f >= 0; f--) {
                            if (typeof factor === 'undefined' || periods[f].ajuste) {
                                factor = periods[f].accumulator;
                            }
                            periods[f].factor = factor
                        }
                        vm.headers = result
                        $rootScope.$evalAsync();
                    } else {
                        $rootScope.$evalAsync();
                        throw errAlertS('No se puede continuar, por que tienen que ser consecutivos los periodos')
                    }


                    vm.loading = false;
                    $rootScope.$evalAsync(function () {
                        $timeout(function () {
                        }, 0, false);
                    });
                }).catch(function (error) {
                    errAlertS(error);
                    vm.loading = false;
                    $scope.$evalAsync(function () {
                        $timeout(function () { }, 0, false);
                    });
                });
            }
        }


        function sonConsecutivos(arr) {
            for (var i = 1; i < arr.length; i++) {
                if (parseInt(arr[i].periodo) !== parseInt(arr[i - 1].periodo) + 1) {
                    return false;
                }
            }
            return true;
        }
        vm.getPeriods = function (payroll) {
            $scope.F.root.child("/catalogs/payrolls/collection/" + payroll).once('value').then(function (resp) {
                var dataPayroll = resp.val();
                vm.payroll = payroll;
                vm.namePayroll = dataPayroll.data.name;
                var paymentFrecuency = dataPayroll.paymentFrequency;
                vm.firm = dataPayroll.firm;
                DataF.api.get('paymentFrequenciesRecords/' + paymentFrecuency).then(function (resp) {
                    vm.fecuenciaPago = resp.data.name;
                })
            });
        }



        vm.applyCalendar = function () {
            try {
                $rootScope.loadingProgress = true;
                var dataHead = vm.headers;
                $log.log('dataHead', dataHead)
                //fechas timestamp
                var payroll = vm.payroll
                var initDate = dataHead[0].inicio;
                var lastDate = dataHead[dataHead.length - 1].fin;
                var lastDateTimeStamp = moment(lastDate, ['DD-MM-YYYY', 'DD/MM/YYYY']).endOf('day').valueOf();
                var initDateTimeStamp = moment(initDate, ['DD-MM-YYYY', 'DD/MM/YYYY']).startOf('day').valueOf();
                checkValidCalendarStart(payroll, initDateTimeStamp, lastDateTimeStamp).then(function (resp) {
                    if (!resp) {
                        throw new Error('No se puede crear por que ya existe un calendario con estas fechas')
                    }
                    return getActiveCalendar(payroll)
                }).then(function (resp) {
                    var active = resp.val();
                    var initPeriod = dataHead[0].periodo;
                    var lastPeriod = dataHead[dataHead.length - 1].periodo;
                    var year = dataHead[0].year;
                    var firm = vm.firm;
                    var name = vm.fecuenciaPago;
                    var obj = {
                        data: {
                            active: (!active) ? true : false,
                            endDate: lastDateTimeStamp,
                            initialPeriod: parseInt(initPeriod),
                            lastPeriod: parseInt(lastPeriod),
                            name: name,
                            startDate: initDateTimeStamp,
                            year: parseInt(year)
                        },
                        firm: firm,
                        payroll: payroll
                    };

                    var updates = {};
                    updates['/payrollCalendars/' + payroll + '/calendars/' + year] = obj;
                    var firstOperation = true;
                    for (var i = 0; i < dataHead.length; i++) {
                        var data = dataHead[i];
                        var initDateRow = moment(data.inicio, ['DD-MM-YYYY', 'DD/MM/YYYY']).startOf('day');
                        var lastDateRow = moment(data.fin, ['DD-MM-YYYY', 'DD/MM/YYYY']).endOf('day');
                        var initDateTimeStampRow = initDateRow.valueOf();
                        var lastDateTimeStampRow = lastDateRow.valueOf();
                        // Calcular la diferencia en días directamente
                        var diferenciaDias = lastDateRow.diff(initDateRow, 'days') + 1;
                        $log.log('Diferencia en días:', diferenciaDias);
                        var accuDateTimeStamp = moment(data.fechaAcumulado, ['DD-MM-YYYY', 'DD/MM/YYYY']).valueOf();
                        var objOperation = {
                            center: $scope.F.center,
                            accuDate: accuDateTimeStamp,
                            accumulator: data.accumulator,
                            factor: parseInt(data.factor),
                            period: data.periodo,
                            created: DataF.getTimeObject(),
                            isAdjustment: data.ajuste,
                            payroll: payroll,
                            firm: firm,
                            status: firstOperation && (!active) ? 1 : -1,
                            type: 'automatic',
                            calendar: year,
                            imported: true
                        };
                        firstOperation = false;
                        var operationsRef = 'operations/ordinary/' + payroll + '/' + year + '/collection';
                        var thisOperationId = $scope.F.root.child('catalogs/' + operationsRef).push().key;
                        updates[operationsRef + '/' + thisOperationId] = objOperation;
                        var objPeriod = {
                            accuDate: accuDateTimeStamp,
                            accumulator: data.accumulator,
                            active: true,
                            end: lastDateTimeStampRow,
                            endString: lastDateRow.format('DD-MM-YYYY'),
                            factor: data.factor,
                            period: data.periodo,
                            start: initDateTimeStampRow,
                            startString: initDateRow.format('DD-MM-YYYY'),
                            operationId: thisOperationId

                        };
                        updates['payrollCalendars/' + payroll + '/periods/' + year + '/' + data.periodo] = objPeriod;
                    }

                    return $scope.F.root.child('catalogs').update(updates)

                }).then(function () {
                    $scope.close();
                    successAlertS('Se guardo correctamente el calendario');
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                }).catch(function (error) {
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                    errAlertS(error)
                })
            } catch (error) {
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
                errAlertS(error)
            }
        };

        function checkValidCalendarStart(payroll, startDate, endDate) {
            var promises = [];
            promises.push(
                $scope.F.root
                    .child('catalogs/payrollCalendars/' + payroll + '/calendars')
                    .orderByChild('data/startDate')
                    .startAt(startDate)
                    .endAt(endDate)
                    .once('value'),
                $scope.F.root
                    .child('catalogs/payrollCalendars/' + payroll + '/calendars')
                    .orderByChild('data/endDate')
                    .startAt(startDate)
                    .endAt(endDate)
                    .once('value')
            );
            return Promise.all(promises).then(function (responses) {
                var one = responses[0].val();
                var two = responses[1].val();
                $log.log('Calendarios encontrados:', { startDate: one, endDate: two });
                if (one || two) {
                    return false;
                }
                return true;
            }).catch(function (error) {
                $log.error('Error al verificar calendarios:', error);
                return false; // Retornamos false si ocurre un error inesperado
            });
        }






        function getActiveCalendar(payroll) {
            return $scope.F.root.child('catalogs/payrollCalendars/' + payroll + '/calendars').orderByChild('data/active').equalTo(true).once("value");
        }

        $scope.close = function () {
            $mdDialog.hide();
        }

        var currentStep = 1;
        var stepperChange = $rootScope.$on('stepCalled', function (event, step) {
            if (step === 2 && currentStep === 1) {
                uploadCsv();
            } else if (step === 3 && currentStep === 2) {
                $log.log('tercer paso')
            }
            currentStep = step;
        });
        var onDestroy = $rootScope.$on('$destroy', function () {
            stepperChange();
            onDestroy();
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.clients')
        .controller('OperationNewController', OperationNewController);

    function OperationNewController(
        $scope,
        $rootScope,
        $state,
        $log,
        $q,
        $mdBottomSheet,
        $mdDialog,
        $sessionStorage,
        successAlertS,
        errAlertS,
        AppF,
        $filter,
        MongoF,
        $http,
        CatalogsF,
        DataF,
        confirmConfig,
        IncidencesF,
        $timeout
    ) {
        // si necesitas cargar catalogos de mongo pon sus nombres aqui
        var dataNeeded = ['subsidyRecords', 'isrRecords', 'imssRecords', 'paymentFrequenciesRecords', 'directives']; // ex: ['countries', 'states', 'regimes']
        var initiated = false;
        var $f = $filter;
        var operationId, periodId, calendarId, payrollId, operationType, refs;
        var backState = 'app.processes.operations';
        //FUNCIONES GENERALES
        var setTabName = function (tabName, slugIt) {
            $scope.selected = [];
            $scope.tabName = (slugIt) ? $f('slugify')(tabName) : tabName;
        }
        var goToList = function () {
            AppF.goToState(backState);
        }
        //INICIO DE LAS FUNCIONES
        var init = function () {
            initiated = true;
            $scope.setTabName('REAL');
            $rootScope.loadingProgress = true;
            // SI NO VIENE LOS PARAMETROS EN LA URL SE REGRESA HACIA ATRAS
            if (!$state.params.operationId && !$state.params.calendarYear && !$state.params.period && !$state.params.payrollId) $scope.R.goToList();
            //Se obtienen los parametros del url
            $scope.readOnlyMode = ($state.current.url.indexOf('read') !== -1);
            operationId = $state.params.operationId;
            periodId = parseInt($state.params.period);
            calendarId = parseInt($state.params.calendarYear);
            payrollId = $state.params.payrollId;
            operationType = $state.params.operationType;
            //SE OBTIENEN LOS PERMISOS DEL USUARIO PARA LAS OPERACIONES DE LA NOMINA
            $scope.operationPermissions = $f("getOperationPermissions")();
            //SE OBTIENEN LAS REFERENCIAS Y LOS DATOS PRINCIPALES DE LA OPERACION
            $f("getInitialDataOfOperation")(dataNeeded, operationId, periodId, calendarId, payrollId, operationType).then(function (resp) {
                refs = resp.refs;
                $scope.operationData = resp.data;
                loadOperationVariables();
            }).catch(function (error) {
                errAlertS('Error al obtener la informacion general de la informacion');
                $log.error(error);
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
            })
        };

        var loadOperationVariables = function () {
            $rootScope.loadingProgress = true;
            var operationVariables = [
                $f("getDispersion")($scope.operationData.operation, refs.dispersions),
                $f("getIncidences")(periodId, $scope.operationData.operation.status >= $scope.opStatusNotCalc, refs.incidences)
            ];
            //Si la sabana aun no esta cerrada se obtienen los movimientos de los empleados
            if ($scope.operationData.operation.status < $scope.opStatusNotCalc) {
                operationVariables.push($f("getMovements")(payrollId, $scope.operationData.period.start, $scope.operationData.period.end));
            }
            $q.all(operationVariables).then(function (resp) {
                $scope.operationData.dispersionObj = resp[0].dispersionObj;
                $scope.operationData.dispersion = resp[0].dispersion;
                $scope.operationData.unfilteredIncidences = resp[1].unfilteredIncidences;
                $scope.operationData.incidences = resp[1].incidences;
                $scope.operationData.movements = resp[2];
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
                var movementsGrouped = $f("groupByField")($scope.operationData.movements, 'employee', false, 'data.date');
                $f("getEmployeesAndDataForOperation")(movementsGrouped, $scope.operationData.dispersion, $scope.operationData.operation, $scope.operationData.period, $scope.operationData.operation.status < $scope.opStatusNotCalc, $scope.operationData.ccs).then(function (resp) {
                    for (var key in resp) {
                        $scope.operationData[key] = resp[key];
                    }
                    console.log($scope.operationData);
                }).catch(function (error) {
                    errAlertS('Error al obtener los empleados');
                    $log.error(error);
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                })
                //getEmployeesOfOperationAndLoadData(resp[2]);
            }).catch(function (error) {
                errAlertS('Error al obtener las incidencias y la dispersion, las incidences o los movimientos');
                $log.error(error);
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
            });
        }
        //PARAMETROS PARA AÑADIR EN EL SCOPE;
        $scope.selected = [];
        $scope.operationData = {};
        //FUNCIONES
        $scope.goToList = goToList;
        $scope.setTabName = setTabName;
        $scope.opStatusNotCalc = 3;
        //OBSERVADOR INICAL DE DATOS NECESARIO PARA NAVEGACION
        var allLoadedInitiated = $rootScope.$on('allLoaded', function (allLoaded) {
            if (allLoaded && !initiated) {
                init();
                allLoadedInitiated();
            }
        });
        //POR SI SE CARGA Y LOS DATOS YA ESTAN CARGADO
        if (AppF.profile && !initiated) {
            if (AppF.profile.uid) init();
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.clients')
        .controller('OperationController', OperationController);

    function OperationController(
        $scope,
        $rootScope,
        $document,
        $state,
        $firebaseObject,
        $firebaseArray,
        $log,
        $q,
        $mdBottomSheet,
        $mdDialog,
        $sessionStorage,
        successAlertS,
        errAlertS,
        AppF,
        $filter,
        MongoF,
        $http,
        CatalogsF,
        getOperationDataObjectsFilter,
        operationStatusNameFilter,
        DataF,
        confirmConfig,
        IncidencesF,
        $timeout
    ) {
        // si necesitas cargar catalogos de mongo pon sus nombres aqui
        var dataNeeded = ['subsidyRecords', 'isrRecords', 'imssRecords', 'paymentFrequenciesRecords', 'directives', 'placesOfWorkRecords', 'geoZones']; // ex: ['countries', 'states', 'regimes']
        var initiated = false;
        var dataFrom = '';
        var root = AppF.root;
        var storageRef = firebase.storage().ref();
        var blancOperation = {};
        var listeners = {};
        var movementsRef = AppF.root.child('catalogs/movements/collection');
        $scope.backState = 'app.processes.operations';
        $scope.search = {

        };
        $scope.dispersionsRef = 'catalogs/dispersions/collection/';
        $scope.oldOperationDataRef = 'catalogs/oldOperationData/collection';
        $scope.formName = 'operationForm';
        $scope.images = [];
        $scope.selected = [];
        $scope.currentPage = 1;
        $scope.hideNotSelected = false;
        $scope.selectedTab = '0';
        $scope.perceptions = {};
        $scope.deductions = {};
        $scope.order = ['data.enroleDate', 'data.name'];
        $scope.dispersion = false;
        $scope.readOnlyMode = false;
        $scope.directiveFunctions = {};
        $scope.files = [];
        $scope.F = AppF;
        $scope.M = MongoF;
        $scope.opStatusNotCalc = 3;
        $scope.calculating = false;
        $scope.checking = false;
        var mainFn = {};

        $scope.employeesStatusByOp = {
            '1': {
                nextStatus: [1, 2, 3],
                status: 0
            },
            '2': {
                nextStatus: [2, 3],
                status: 1
            },
            '2.5': {
                nextStatus: [3],
                status: 2
            }
        };
        delete AppF.allProcesses;
        delete AppF.incidencesTypes;
        delete AppF.incidenceTypeData;
        delete AppF.satIncidenceTypeData;
        delete AppF.complementIncidenceTypeData
        delete AppF.incidencesByEmployee;
        delete AppF.paymentSchema;
        delete AppF.fiscalIncidences;
        delete AppF.defaultFiscalIncidences;
        delete AppF.firstCalculationExecuted;
        delete AppF.firstCalculationFinished;
        delete AppF.balanceIncidenceMap;
        delete AppF.balancedIncidences;
        delete AppF.tempBalancedIncidences;
        AppF.directiveIds = {};
        AppF.activeDirectiveMap = {};
        AppF.listenerDirectiveTime = 300;
        AppF.finishCalculationTime = 300;
        AppF.fixIncidences = {};
        AppF.balancedIncidences = {};
        AppF.balanceIncidenceMap = {};
        AppF.tempBalancedIncidences = {};
        AppF.levels = ['second', 'third', 'fourth', 'fifth', 'sixth', 'seventh', 'eight'];
        $scope.niveles = AppF.levels;
        AppF.opstatusByEmployeeStatus = {
            '3': 3,
            '2': 2.5,
            '1': 2
        };
        AppF.operationDataNeeded = {
            REAL: {
                first: false
            },
            FISCAL: {

            }
        };
        AppF.notCalculate = false;
        // $scope.$watch("F.operationDataNeeded.FISCAL", function(newValue, oldValue) {
        //     console.log(JSON.stringify(newValue));
        // }, true)
        //SECCION PARA CARGAR LOS DATOS NECESARIOS PARA LA NOMINA
        var getOperation = function () {
            // $log.debug('getOperation Called');
            var deferred = $q.defer();
            if (!$state.params.operation && $state.params.operationId && !AppF.addMode) {
                $scope.operation = $firebaseObject(root.child($scope.operationsRef).child($scope.operationId));
                dataFrom = 'object';
                $scope.operation.$loaded().then(function () {
                    $scope.operationData = $firebaseObject(root.child('catalogs/payrollCalendars').child($scope.payrollId).child('periods').child($scope.operation.calendar).child($scope.operation.period));
                    $scope.operationData.$loaded(function (operationData) {
                        setHideNotSelect();
                        deferred.resolve(operationData);
                    });
                });
                // $log.debug('Loaded operation from FB');
                // return $scope.operation.$loaded();
            } else {
                $scope.operations = $state.params.operations;
                // si se manda objeto de operation vacio, se entiende que se quiere crear uno
                $scope.operation = (AppF.addMode) ? blancOperation : $state.params.operation;
                $scope.operationData = $firebaseObject(root.child('catalogs/payrollCalendars').child($scope.payrollId).child('periods').child($scope.operation.calendar).child($scope.operation.period));
                $scope.operationData.$loaded(function (operationData) {
                    setHideNotSelect();
                    deferred.resolve(operationData);
                    //$log.debug('Loaded operation from previus state');
                });
            }
            return deferred.promise;
        };
        var loadMyCcs = function () {
            //$log.debug('loadMyCcs called');
            return $scope.L.loadList('ccs', 'lists/ccs/user/', AppF.user.uid, 'array', 'userCcs');
        };
        var loadPeriod = function () {
            //$log.debug('loadPeriod called');
            $scope.period = $firebaseObject(root.child('catalogs/payrollCalendars').child($scope.payrollId).child('periods').child($scope.calendar).child($scope.periodNumber));
            return $scope.period.$loaded();
        };
        var loadEmployeesOfMovementsOrDispersion = function (movementsGroupedByEmployee, dispersionEmployees, period) {
            $log.debug('loadEmployeesOfMovementsOrDispersion called');
            return new Promise(function (resolve, reject) {
                var requests = [];
                var employeesToLoad = dispersionEmployees ? dispersionEmployees : movementsGroupedByEmployee;
                for (var m in employeesToLoad) {
                    requests.push($scope.L.loadList('employee', 'catalogs/employees/collection/', m, 'object', 'operationEmployees'));
                }
                Promise.all(requests).then(function (employees) {
                    //$log.debug($scope.L.operationEmployees);
                    var validEmployees = [];
                    for (var e = 0; e < employees.length; e++) {
                        var tempId = employees[e].$id;
                        var thisEmployee = $filter('clearObject')(employees[e]);
                        thisEmployee.$id = tempId;
                        if (thisEmployee.hasOwnProperty('movements')) {
                            if (typeof (dispersionEmployees) !== "undefined") {
                                thisEmployee.calculations = dispersionEmployees[thisEmployee.$id].calculations;
                            } else {
                                var thisMovements = thisEmployee.movements;
                                var lastMovementInEmployee = $filter("getLastMovemenBeforeDate")(thisMovements, period.start);
                                var lastMovementInMovements = $filter("getLastMovemenBeforeDate")(movementsGroupedByEmployee[thisEmployee.$id], period.start);
                                if (lastMovementInEmployee.length) {
                                    lastMovementInEmployee = lastMovementInEmployee[0];
                                } else {
                                    lastMovementInEmployee = undefined;
                                }
                                if (lastMovementInMovements.length) {
                                    lastMovementInMovements = lastMovementInMovements[0];
                                } else {
                                    lastMovementInMovements = undefined;
                                }

                                if (typeof (lastMovementInMovements) !== "undefined" && typeof (lastMovementInEmployee) !== "undefined" && lastMovementInEmployee.$id != lastMovementInMovements.$id) {
                                    if (lastMovementInEmployee.d > lastMovementInMovements.data.date && lastMovementInEmployee.p != lastMovementInMovements.payroll) {
                                        $log.debug(thisEmployee.data.name, "tiene un movimiento con id", lastMovementInEmployee.$id, "y fecha", $filter("date")(lastMovementInEmployee.d, "shortDate"), "mayor al movimiento con id", lastMovementInMovements.$id, "con fecha", $filter("date")(lastMovementInMovements.data.date, "shortDate"))
                                        var founded = $filter("filter")(movementsGroupedByEmployee[thisEmployee.$id], {
                                            $id: lastMovementInMovements.$id
                                        });
                                        if (founded.length) {
                                            var index = movementsGroupedByEmployee[thisEmployee.$id].indexOf(founded[0]);
                                            movementsGroupedByEmployee[thisEmployee.$id].splice(index, 1);

                                        } else {
                                            $log.error("No se encontro el movimiento de", thisEmployee.data.name, "en sus movementsGrouped");
                                        }
                                    } else if (lastMovementInEmployee.d > lastMovementInMovements.data.date && lastMovementInEmployee.p == lastMovementInMovements.payroll) {
                                        $log.error(thisEmployee.data.name, "tiene un movimiento registrado en employee.movements con id", lastMovementInEmployee.$id, " de esta nomina que no se añadio a la consulta de movimientos")
                                    } else if (lastMovementInEmployee.d < lastMovementInMovements.data.date) {
                                        $log.error(thisEmployee.data.name, "tiene un movimiento registrado en movements con id", lastMovementInMovements.$id, "que no se encuentra registrado en employee.movements");
                                    }
                                } else if (typeof (lastMovementInEmployee) !== "undefined" && lastMovementInEmployee.t !== 2 && lastMovementInEmployee.p == $scope.payrollId && lastMovementInEmployee.$id != lastMovementInMovements.$id) {
                                    $log.error(thisEmployee.data.name, "tiene un movimiento registrado en employee.movements de esta nomina que no se añadio a la consulta de movimientos", lastMovementInEmployee);
                                }
                            }
                            thisEmployee.movements = movementsGroupedByEmployee[thisEmployee.$id];
                            validEmployees.push(thisEmployee);
                        } else {
                            $log.error('Empleado con ID:' + thisEmployee.$id + ' no existe', movementsGroupedByEmployee[thisEmployee.$id]);
                        }
                    }
                    resolve(validEmployees);
                }).catch(function (error) {
                    reject(error);
                });
            });
        };
        var loadMovementsForOperation = function (payroll, startDate, endDate) {
            // $log.debug('loadMovementsForOperation called');
            return new Promise(function (resolve, reject) {
                var queryAggregate = [{
                    '$match': {
                        'payroll': payroll,
                        'data.date': {
                            '$lt': startDate
                        },
                        'status': {
                            '$gt': 1
                        }
                    }
                },
                {
                    '$sort': {
                        'employee': 1,
                        'data.date': -1
                    }
                },
                {
                    '$group': {
                        '_id': '$employee',
                        'mid': {
                            '$first': '$_id'
                        },
                        'approved': {
                            '$first': '$approved'
                        },
                        'archived': {
                            '$first': '$archived'
                        },
                        'cc': {
                            '$first': '$cc'
                        },
                        'created': {
                            '$first': '$created'
                        },
                        'data': {
                            '$first': '$data'
                        },
                        'fid': {
                            '$first': '$fid'
                        },
                        'info': {
                            '$first': '$info'
                        },
                        'payroll': {
                            '$first': '$payroll'
                        },
                        'received': {
                            '$first': '$received'
                        },
                        'rp': {
                            '$first': '$rp'
                        },
                        'status': {
                            '$first': '$status'
                        },
                        'updated': {
                            '$first': '$updated'
                        }
                    }
                },
                {
                    '$match': {
                        'data.type': {
                            '$ne': 2
                        },
                    }
                }
                ];
                var paramsLastMovement = {
                    query: JSON.stringify(queryAggregate)
                };
                var paramsBetweenMovements = {
                    page: 0.5,
                    size: 0.5,
                    payroll: payroll,
                    'data.date': {
                        '$gt': startDate - 1,
                        '$lt': endDate + 1
                    },
                    status: {
                        '$gt': 1
                    },
                    sort: 'employee'
                };
                var promises = [
                    $rootScope.D.api.post('aggregate/movements', paramsLastMovement),
                    $rootScope.D.api.get('p/movements', paramsBetweenMovements)
                ];
                Promise.all(promises).then(function (resp) {
                    var lastMovements = resp[0].data;
                    var betweeenMovements = resp[1].data.data;
                    for (var l = 0; l < lastMovements.length; l++) {
                        lastMovements[l].employee = lastMovements[l]._id;
                        lastMovements[l]._id = lastMovements[l].mid;
                        delete lastMovements[l].mid;
                        lastMovements[l].$id = lastMovements[l].fid;
                    }
                    for (var b = 0; b < betweeenMovements.length; b++) {
                        betweeenMovements[b].$id = betweeenMovements[b].fid;
                    }

                    $scope.allMovements = lastMovements.concat(betweeenMovements);
                    var movementsGrouped = $filter('groupByField')($scope.allMovements, 'employee', false, 'data.date');
                    resolve(movementsGrouped);
                }).catch(function (error) {
                    reject(error)
                })


            })
        };
        var loadPaymentSchemaAndPayroll = function () {
            //$log.debug('loadPaymentSchemaAndPayroll Called');
            $scope.payroll = $firebaseObject(root.child('catalogs/payrolls/collection').child($scope.payrollId));
            return $scope.payroll.$loaded().then(function (payroll) {
                $scope.payroll = payroll;
                var paymentSchemaId = payroll.paymentSchema;
                $scope.paymentSchema = $firebaseObject(root.child('catalogs/paymentSchemas/collection').child(paymentSchemaId));
                return $scope.paymentSchema.$loaded();
            });
        };
        var loadDispersion = function () {
            // $log.debug('loadDispersion called');
            return new Promise(function (resolve, reject) {
                if ($scope.operation.dispersion) {
                    $scope.dispersionObj = $firebaseObject(root.child($scope.dispersionsRef).child($scope.operation.dispersion));
                    $scope.dispersionObj.$loaded().then(function () {
                        $scope.dispersion = transformDispersionObj($scope.dispersionObj);
                        AppF.fixIncidences = $filter("getFixIncidences")($scope.dispersion);
                        $log.debug($scope.dispersion)
                        resolve($scope.dispersion);
                    }).catch(function (error) {
                        reject(error);
                    });
                } else {
                    resolve(true);
                }
            })
        };
        var loadCalcFields = function () {
            //$log.debug('loadCalcFields called');
            return $scope.L.loadList('calcFields', 'catalogs/calcFields/collection', null, 'array');
        };
        var loadIncidences = function () {
            // $log.debug('loadIncidences called');
            $scope.incidences = [];
            var deferred = $q.defer();
            if ($scope.operation.status >= $scope.opStatusNotCalc) {
                $scope.unfilteredIncidences = $firebaseArray(root.child($scope.incidencesRef).orderByChild('period').equalTo($scope.periodNumber));
                $scope.unfilteredIncidences.$loaded().then(function (incidences) {
                    $scope.incidences = $filter('getAppliedIncidences')(incidences);
                    deferred.resolve($scope.incidences);
                }, function (error) {
                    deferred.reject(error);
                });
            } else {
                $scope.unfilteredIncidences = $firebaseArray(root.child($scope.incidencesRef).orderByChild('status').startAt(0).endAt(2));
                $scope.unfilteredIncidences.$loaded().then(function (incidences) {
                    $scope.incidences = $filter('getIncidencesOfThisPeriod')(incidences, $scope.period.period);
                    deferred.resolve($scope.incidences);
                }, function (error) {
                    deferred.reject(error);
                });
            }
            return deferred.promise;
        };
        var loadIncidencesTypes = function () {
            //$log.debug('loadIncidencesTypes called');
            var deferred = $q.defer();
            $scope.payrollIncidencesTypes = $firebaseArray(root.child('catalogs/incidencesTypes/collection').orderByChild('payroll').equalTo($scope.payrollId));
            $scope.globalIncidencesTypes = $firebaseArray(root.child('catalogs/incidencesTypes/collection').orderByChild('payroll').equalTo('global'));
            $scope.payrollIncidencesTypes.$loaded(function (payrollIncidencesTypes) {
                $scope.globalIncidencesTypes.$loaded(function (globalIncidencesTypes) {
                    $scope.incidencesTypes = payrollIncidencesTypes.concat(globalIncidencesTypes)
                    deferred.resolve($scope.incidencesTypes)
                });
            });
            return deferred.promise;
        };
        var getLastActivePeriod = function () {
            return new Promise(function (resolve, reject) {
                $scope.lastActivePeriod = 0;
                AppF.root.child('catalogs/operations/ordinary/' + $scope.payrollId + '/' + $scope.calendar + '/collection').orderByChild('status').startAt(1).limitToFirst(1).once('value', function (operationsSnap) {
                    if (operationsSnap.exists()) {
                        var operation;
                        operationsSnap.forEach(function (operationSnap) {
                            operation = operationSnap.val();
                            operation.$id = operation.key;
                        });
                        $scope.lastActivePeriod = operation;
                    }
                    resolve($scope.lastActivePeriod);
                }, function (error) {
                    reject(error);
                });
            })
        };

        var getIncidencesPriority = function () {
            return new Promise(function (resolve, reject) {
                //$log.debug('getIncidencesPriority called');
                $scope.L.loadList('incidencesTypesPrioritys', 'catalogs/incidencesTypesPrioritys/collection/', false, 'array', 'incidencesTypesPrioritys').then(function (data) {
                    AppF.incidencesPrioritys = data;
                    resolve(AppF.incidencesPrioritys);
                }).catch(function (error) {
                    reject(error);
                });
            });
        }

        var getOperationPermissiones = function () {
            $scope.operationPermissions = {};
            $scope.operationPermissions.sendOperationToRevision = $filter('userHasPermission')(AppF.groupsOfUser, AppF.permissions, 'sendToReview', 'processes.operations');
            $scope.operationPermissions.sendOperationToFinalRevision = $filter('userHasPermission')(AppF.groupsOfUser, AppF.permissions, 'sendToFinalRevision', 'processes.operations');
            $scope.operationPermissions.closeOperation = $filter('userHasPermission')(AppF.groupsOfUser, AppF.permissions, 'sendPreBill', 'processes.operations');
        }
        //Iniciador de las operaciones
        var init = function () {
            $mdBottomSheet.hide()
            $scope.setTabName('REAL');
            $rootScope.loadingProgress = true;
            // if(!AppF.search || !AppF.search.hasOwnProperty('operations')) {
            //     AppF.resetSearch('operations');
            //     AppF.search.$payroll = false;
            // } 
            // si no viene el parametro detalle, o del objeto se regresa a atras
            if (!$state.params.operationId && !$state.params.calendarYear && !$state.params.period && !$state.params.payrollId) $scope.R.goToList();
            $scope.readOnlyMode = ($state.current.url.indexOf('read') !== -1);
            //$log.debug('readOnlyMode', $scope.readOnlyMode, $state.current.url);
            $scope.operationId = $state.params.operationId;
            $scope.periodNumber = parseInt($state.params.period);
            $scope.calendar = parseInt($state.params.calendarYear);
            $scope.payrollId = $state.params.payrollId;
            $scope.operationType = $state.params.operationType;
            $scope.incidencesRef = 'incidences/' + $scope.payrollId + '/' + $scope.calendar;
            $scope.operationsRef = 'catalogs/operations/' + $scope.operationType + '/' + $scope.payrollId + '/' + $scope.calendar + '/collection';
            // si no es un objeto nuevo se deben registrar los items del menu
            if ($state.params.operation == 'new' || $state.params.operationId == 'new') {
                AppF.addMode = true;
                //$log.debug('F.addMode', AppF.addMode);
            }
            // se obtinene los permisos que tiene definidos un usuario
            getOperationPermissiones();
            var data = [
                $scope.M.loadNeeded(dataNeeded),
                getOperation(),
                loadPaymentSchemaAndPayroll(),
                loadIncidencesTypes(),
                loadCalcFields(),
                loadMyCcs(),
                loadPeriod(),
                getLastActivePeriod(),
                getIncidencesPriority()
            ];
            $q.all(data).then(function (allR) {
                AppF.priorityMap = $filter("completeIncidencesPrioritys")(AppF.incidencesPrioritys, $scope.incidencesTypes, [], AppF.priorityMap);
                AppF.directivesMap = $filter("keyObjectAsId")($scope.M.directives, "_id", true);
                $log.debug('Información general de la operación cargada');
                $scope.processes = $filter('getProcessesNames')($scope.paymentSchema.data.processes, 1);
                $rootScope.loadingProgress = false;
                loadOperationVariables();
            }).catch(function (error) {
                errAlertS('Error al obtener la información general de la información');
                $log.error(error);
                $rootScope.loadingProgress = false;
            });
            initiated = true;
        };

        var loadOperationVariables = function () {
            $rootScope.loadingProgress = true;
            $q.all([loadDispersion(), loadIncidences(), loadMovementsForOperation($scope.payrollId, $scope.operationData.start, $scope.operationData.end), $filter('getMinimumWageOfDate')($scope.operationData.end)]).then(function (resp) {
                $log.log(resp[3]);
                if (angular.isObject(resp[3])) {
                    for (var key in resp[3]) {
                        if (resp[3].hasOwnProperty(key)) {
                            $scope[key] = resp[3][key];
                        }
                    }
                }
                $log.debug('Dispersion(si ya tiene), incidencias y movimientos(si necesita) cargados');
                $rootScope.loadingProgress = true;
                getEmployeesOfOperationAndLoadData(resp[2]);
            }).catch(function (error) {
                errAlertS('Error al obtener las incidencias y los movimientos');
                $log.error(error);
                $rootScope.loadingProgress = false;
            });
        }

        //SECCION PARA FUNCIONES
        var setOperationVariables = function () {

            $scope.operationStatusByEmployees = $scope.operation.status;
            if ($scope.operationPermissions.closeOperation) {
                $scope.previousEmployeeStatus = 1;
                $scope.previousIncidencesStatus = 1;
                $scope.previousOperationStatus = 2;
                $scope.nextEmployeeStatus = 3;
                $scope.nextIncidenceStatus = 3;
                $scope.nextOperationStatus = 3;
                $scope.showCloseOpButton = true;
            } else if ($scope.operationPermissions.sendOperationToFinalRevision) {
                $scope.previousEmployeeStatus = 0;
                $scope.previousIncidencesStatus = 0;
                $scope.previousOperationStatus = 1;
                $scope.nextEmployeeStatus = 2;
                $scope.nextIncidenceStatus = 2;
                $scope.nextOperationStatus = 2.5;
                $scope.showRevisionOpButton = true;
            } else if ($scope.operationPermissions.sendOperationToRevision) {
                $scope.previousEmployeeStatus = 0;
                $scope.previousIncidencesStatus = 0;
                $scope.previousOperationStatus = -1;
                $scope.nextEmployeeStatus = 1;
                $scope.nextIncidenceStatus = 1;
                $scope.nextOperationStatus = 2;
                $scope.showRevisionOpButton = true;
            }
            var r = ($scope.lastActivePeriod.period ? $scope.lastActivePeriod.period : 0) - $scope.operation.period;
            if (r === 1 && $scope.operation.status === 3 && $scope.lastActivePeriod.calendar === $scope.calendar) {
                $scope.showReopenButton = true;
            } else {
                delete $scope.showReopenButton;
            }
            //console.log($scope.showReopenButton);
            if ($scope.showRevisionOpButton) {
                //si tiee permiso para revisar la nomina pero la nomina ya no esta en un status para revisar entonces no mostrarmos le boton de revisar
                if ($scope.operation.status > 2) {
                    delete $scope.showRevisionOpButton;
                }
                //Si todos mis empleados estan en el siguiente estado que corresponde ya no mostramos el boton
                if ($scope.showRevisionOpButton) {
                    if ($scope.allMyEmployeesInStatus($scope.nextEmployeeStatus)) {
                        delete $scope.showRevisionOpButton;
                    }
                }
            }
            if ($scope.showCloseOpButton) {
                delete $scope.showRevisionOpButton;
                //si tiee permiso para revisar la nomina pero la nomina ya no esta en un status para revisar entonces no mostrarmos le boton de revisar
                if ($scope.operation.status > 2.5) {
                    delete $scope.showCloseOpButton;
                }
                //Si todos mis empleados estan en el siguiente estado que corresponde ya no mostramos el boton
                if ($scope.showCloseOpButton) {
                    if ($scope.allMyEmployeesInStatus($scope.nextEmployeeStatus)) {
                        delete $scope.showCloseOpButton;
                    }
                }
            }
            if ($scope.operation.status > 0 && $scope.operation.status < $scope.opStatusNotCalc) {
                var status = {};
                var nextStatus = $scope.employeesStatusByOp[$scope.operation.status].nextStatus;
                for (var a = 0; a < nextStatus.length; a++) {
                    status[nextStatus[a]] = $scope.allMyEmployeesInStatus(nextStatus[a]);
                }
                for (var s in status) {
                    if (status[s]) {
                        if (AppF.opstatusByEmployeeStatus[s] > $scope.operationStatusByEmployees) {
                            $scope.operationStatusByEmployees = AppF.opstatusByEmployeeStatus[s];
                        }
                    }
                }
            }

        };
        var transformDispersionObj = function (dispersionObj) {
            $log.debug($filter('clearObject')(dispersionObj));
            var dispersion = JSON.parse(JSON.stringify($filter('clearObject')(dispersionObj)));
            for (var cindex in dispersion.calculations) {
                var calculations = dispersion.calculations[cindex].calculations;
                for (var operationType in calculations) {
                    for (var concept in calculations[operationType]) {
                        for (var dataName in calculations[operationType][concept]['data']) {
                            if (typeof calculations[operationType][concept]['data'][dataName] == 'string') {
                                try {
                                    calculations[operationType][concept]['data'][dataName] = JSON.parse(calculations[operationType][concept]['data'][dataName]);
                                } catch (error) {
                                    $log.debug(error);
                                }
                            }
                        }
                        if (typeof (calculations[operationType][concept]['formulas']) != 'undefined') {
                            calculations[operationType][concept]['formulas'] = JSON.parse(calculations[operationType][concept]['formulas'])
                        }
                    }
                }
                dispersion.calculations[cindex].calculations = calculations;
            }
            return dispersion;
        };

        var getNextOperation = function (operation) {
            return new Promise(function (resolve, reject) {
                root.child($scope.operationsRef).orderByChild('period').equalTo(operation.period + 1).once('value').then(function (snap) {
                    if (snap.exists()) {
                        var nextOperation;
                        snap.forEach(function (childSnapshot) {
                            nextOperation = childSnapshot.val();
                            nextOperation.$id = childSnapshot.key;
                        });
                        if (typeof (nextOperation) !== "undefined") {
                            resolve({
                                operation: nextOperation
                            });
                        } else {
                            reject("No se encontró operación disponible");
                        }
                    } else {
                        var calendarRef = 'catalogs/payrollCalendars/' + operation.payroll + '/calendars';
                        var nextCalendar = parseInt($scope.calendar) + 1;
                        root.child(calendarRef + "/" + nextCalendar).once('value').then(function (calendarSnap) {
                            if (calendarSnap.exists()) {
                                var nextOperationsRef = 'catalogs/operations/' + $scope.operationType + '/' + $scope.payrollId + '/' + nextCalendar + '/collection';
                                root.child(nextOperationsRef).orderByChild('period').limitToFirst(1).once('value').then(function (thisSnap) {
                                    if (thisSnap.exists()) {
                                        var nextOperation;
                                        thisSnap.forEach(function (childSnapshot) {
                                            nextOperation = childSnapshot.val();
                                            nextOperation.$id = childSnapshot.key;
                                        });
                                        if (typeof (nextOperation) !== "undefined") {
                                            resolve({
                                                operation: nextOperation,
                                                nextCalendar: nextCalendar
                                            });
                                        } else {
                                            reject("No se encontró operación disponible en el siguiente calendario");
                                        }
                                    } else {
                                        reject("No se encontró operación disponible en el siguiente calendario")
                                    }
                                }).catch(function (error) {
                                    reject(error);
                                })
                            } else {
                                reject("No se encontro el siguiente calendario")
                            }
                        }).catch(function (error) {
                            $log.error(error);
                            resolve(true);
                        })
                    }
                }).catch(function (error) {
                    $log.error(error);
                    reject(error);
                })
            })
        }
        var updateNextOperation = function (operation) {
            var deferred = $q.defer();
            if (operation.status === 0 || operation.status === $scope.opStatusNotCalc) {
                getNextOperation(operation).then(function (nextOperationData) {
                    var thisOperationRef = $scope.operationsRef;
                    var updates = {};
                    if (typeof (nextOperationData.nextCalendar) !== "undefined") {
                        thisOperationRef = 'catalogs/operations/' + $scope.operationType + '/' + $scope.payrollId + '/' + nextOperationData.nextCalendar + '/collection';
                        var calendarRef = 'catalogs/payrollCalendars/' + operation.payroll + '/calendars';
                        updates[calendarRef + "/" + nextOperationData.nextCalendar + '/data/active'] = true;
                        updates[calendarRef + "/" + $scope.calendar + '/data/active'] = false;
                    }
                    updates[thisOperationRef + "/" + nextOperationData.operation.$id + "/status"] = 1;
                    root.update(updates).then(function () {
                        deferred.resolve("Se actualizo correctamente la siguiente operación");
                    }).catch(function () {
                        deferred.reject("No se puedo actualizar los datos de la siguiente operación")
                    })
                }).catch(function (error) {
                    if (typeof (error) == "string") {
                        errAlertS(error);
                    } else {
                        errAlertS("No se pudo obtener la información de la siguiente operación")
                    }
                    deferred.reject(error);
                })
            } else {
                deferred.resolve(true);
            }
            return deferred.promise;
        };
        var getUpdatesIncidences = function (employees, incidences, status, createIncidences, update, isMovingBack, dispersionId) {
            return new Promise(function (resolve, reject) {
                var updates = {};
                var referencesUpdates = {};
                angular.forEach(employees, function (employee) {
                    angular.forEach(incidences, function (incidence) {
                        if (incidence.employee == employee.$id) {
                            var setStatus = true;
                            if (createIncidences && createIncidences.indexOf(incidence.type) > -1) {
                                if (typeof (incidence.$id) === 'undefined') {
                                    setStatus = false;
                                    incidence.status = status;
                                    var incidenceId = root.child($scope.incidencesRef).push().key;
                                    updates[$scope.incidencesRef + "/" + incidenceId] = $filter('clearObject')(incidence);
                                }
                            }
                            if (setStatus && incidence.$id) {
                                updates[$scope.incidencesRef + "/" + incidence.$id + '/status'] = status;
                                var fromUpdate = $filter("getIncidencesUpdatesFrom")(incidence, {
                                    status: status
                                })
                                referencesUpdates = Object.assign(referencesUpdates, fromUpdate);
                            }
                            if (isMovingBack) {
                                if (incidence.type == "constant" && incidence.$id && status < $scope.opStatusNotCalc) {
                                    updates[$scope.incidencesRef + "/" + incidenceId] = null
                                }
                            }
                        }
                    })
                });
                var queryNextOperation = [];
                if ((typeof (createIncidences) == "object" && createIncidences.indexOf("rejected")) || (isMovingBack && status < $scope.opStatusNotCalc)) {
                    queryNextOperation.push(getNextOperation($scope.operation));
                }
                Promise.all(queryNextOperation).then(function (resp) {
                    if (resp.length > 0) {
                        var nextOperationData = resp[0];
                        for (var employeeId in AppF.fixIncidences.rejectedIncidences) {
                            var calendar = nextOperationData.nextCalendar ? nextOperationData.nextCalendar : $scope.calendar;
                            var incidencesRef = 'incidences/' + $scope.payrollId + '/' + calendar;
                            var thisIncidenceId;
                            for (var incidenceId in AppF.fixIncidences.rejectedIncidences[employeeId]) {
                                if (typeof (AppF.fixIncidences.rejectedIncidences[employeeId][incidenceId]) == "object") {
                                    if (isMovingBack) {
                                        thisIncidenceId = AppF.fixIncidences.rejectedIncidences[employeeId][incidenceId].$id;
                                        updates[incidencesRef + "/" + thisIncidenceId] = null;
                                    } else {
                                        thisIncidenceId = root.child(incidencesRef).push().key;
                                        var incidence = {
                                            "automaticAsignation": true,
                                            "calendar": calendar,
                                            "comments": "Incidencia Rechazada del periodo anterior",
                                            "employee": employeeId,
                                            "incidenceType": incidenceId,
                                            "payroll": $scope.payrollId,
                                            "period": nextOperationData.operation.period,
                                            "status": 1,
                                            "type": "system",
                                            "isRejected": true,
                                            "value": AppF.fixIncidences.rejectedIncidences[employeeId][incidenceId].value
                                        }
                                        updates[$scope.dispersionsRef + "/" + dispersionId + "/rejectedIncidences/" + thisIncidenceId] = {
                                            employee: employeeId,
                                            incidenceType: incidenceId,
                                            value: AppF.fixIncidences.rejectedIncidences[employeeId][incidenceId].value
                                        }
                                        updates[incidencesRef + "/" + thisIncidenceId] = incidence;
                                    }
                                }
                            }

                        }
                    }
                    console.log(updates);
                    if (update) {
                        resolve(Promise.all([root.update(updates), root.update(referencesUpdates)]));
                    } else {
                        resolve({
                            incidences: updates,
                            references: referencesUpdates
                        })
                    }
                }).catch(function (error) {
                    reject(error)
                });
            })


        };

        var setEmployeesStatus = function (employees, status, forceStatus, update, deleteNotInList) {
            $scope.operation = $filter('setOperationEmployeesStatus')($scope.operation, employees, status, forceStatus, deleteNotInList);
            if (update) {
                if (dataFrom == 'object') {
                    return $scope.operation.$save();
                } else {
                    return $scope.operations.$save($scope.operation);
                }
            } else {
                return true;
            }
        };

        var isvalidMovement = function (movement) {
            var isValid = false;
            if (movement.payroll == $scope.payrollId) {
                isValid = true;
            }
            if (isValid) {
                var movements = [movement];
                var lastMovements = $filter('getLastMovemenBeforeDate')(movements, $scope.period.start);
                var betweeenMovements = $filter('getMovementsBetweenDates')(movements, $scope.period.start, $scope.period.end);
                if (lastMovements.length || betweeenMovements.length) {
                    if (lastMovements.length) {
                        $log.debug('isValid because Last');
                    } else {
                        $log.debug('isValid because Between');
                    }
                    isValid = true;
                } else {
                    isValid = false;
                }
            }
            return isValid;
        };
        var validateMovement = function validateMovement(snapshot, key) {
            var movement = snapshot.val();
            movement.$id = key;
            var movementsGrouped;
            if (isvalidMovement(movement)) {
                var movementIndexFounded = -1;
                for (var i = 0; i < $scope.allMovements.length; i++) {
                    if ($scope.allMovements[i].$id == movement.$id) {
                        movementIndexFounded = i;
                        i = ($scope.allMovements.length + 1);
                    }
                }
                if (movementIndexFounded > -1) {
                    $log.debug('movement Edited');
                    $scope.allMovements[movementIndexFounded] = movement;
                } else {
                    $log.debug('movement Added');
                    $scope.allMovements.push(movement);
                }
                movementsGrouped = $filter('groupByField')($scope.allMovements, 'employee', false, 'data.date');
                getEmployeesOfOperationAndLoadData(movementsGrouped);
            } else {
                var indexFounded = $filter('getIndexFromArray')($scope.allMovements, '$id', movement.$id);
                if (indexFounded > -1) {
                    $scope.allMovements.splice(indexFounded, 1);
                    movementsGrouped = $filter('groupByField')($scope.allMovements, 'employee', false, 'data.date');
                    getEmployeesOfOperationAndLoadData(movementsGrouped);
                }
            }
        };
        var mergeEmployees = function (oldEmployees, newEmployees) {
            oldEmployees = typeof (oldEmployees) === 'undefined' ? [] : oldEmployees;
            for (var i = 0; i < newEmployees.length; i++) {
                var indexFounded = -1;
                for (var o = 0; o < oldEmployees.length; o++) {
                    if (newEmployees[i].$id == oldEmployees[o].$id) {
                        indexFounded = o;
                        o = oldEmployees.length;
                    }
                }
                if (indexFounded > -1) {
                    newEmployees[i] = Object.assign(oldEmployees[indexFounded], newEmployees[i]);
                }
            }
            return newEmployees;
        };
        var getEmployeesOfOperationAndLoadData = function (movementsGroupedByEmployee) {
            $rootScope.loadingProgress = true;
            $log.debug('getEmployeesOfOperationAndLoadData called');
            var dispersionEmployees = $scope.dispersion && $scope.dispersion.calculations ? $scope.dispersion.calculations : undefined;
            loadEmployeesOfMovementsOrDispersion(movementsGroupedByEmployee, dispersionEmployees, $scope.period).then(function (employees) {
                $log.debug('loadEmployeesOfMovementsOrDispersion finished');
                if ($scope.operation.status >= $scope.opStatusNotCalc) {
                    $log.debug('loadEmployees from dispersion');
                    $scope.allEmployees = employees;
                    var operationEmployees = (AppF.permissionToAccessAllPayrolls) ? $scope.allEmployees : $filter('getEmployeesCcs')($scope.allEmployees, $scope.L.userCcs[AppF.profile.uid]);

                    $scope.employeesF = mergeEmployees($scope.employeesF, operationEmployees);
                    setOperationVariables();
                    angular.forEach($scope.employeesF, function (employee) {
                        $filter('listenRps')(employee);
                        $filter('listenCcs')(employee);
                    });
                    var employeesDataNeeded = [
                        $q.all(AppF.rpsData),
                        $q.all(AppF.ccsData)
                    ];
                } else {
                    $log.debug('loadEmployees from movmeents');
                    $scope.allEmployees = $filter('getPeriodEmployees')(employees, $scope.period);
                    setEmployeesStatus($scope.allEmployees, 0, false, true, true);
                    var operationEmployees = (AppF.permissionToAccessAllPayrolls) ? $scope.allEmployees : $filter('getEmployeesCcs')($scope.allEmployees, $scope.L.userCcs[AppF.profile.uid]);
                    $scope.employeesF = mergeEmployees($scope.employeesF, operationEmployees);
                    setOperationVariables();
                    angular.forEach($scope.employeesF, function (employee) {
                        $filter('listenConstants')(employee);
                        $filter('listenRps')(employee);
                        $filter('listenCcs')(employee);
                        $filter('listenCredits')(employee, $scope.period);
                    });
                    $log.debug('listenEmployeeData called');
                    var employeesDataNeeded = [
                        $q.all(AppF.rpsData),
                        $q.all(AppF.ccsData),
                        $q.all(function () {
                            var array = [];
                            angular.forEach(AppF.constants, function (constant) {
                                array.push(constant.object.$loaded());
                            });
                            return array;
                        }),
                        $q.all(AppF.creditsData)
                    ];
                }
                $q.all(employeesDataNeeded).then(function (resp) {
                    $log.debug('listenEmployeeData finished');
                    $scope.rps = [];
                    angular.forEach(resp[0], function (snap, key) {
                        if (snap.exists()) {
                            var obj = snap.val();
                            obj.$id = key;
                            $scope.rps.push(obj);
                        }
                    });
                    $scope.ccs = [];
                    var filterById = function (item) {
                        return item[this.field] == this.key;
                    }
                    angular.forEach(resp[1], function (snap, key) {
                        if (snap.exists()) {
                            var obj = snap.val();
                            obj.$id = key;
                            // if (obj.data.place) {
                            //     var placeOfWorkRecords = MongoF.placesOfWorkRecords.filter(filterById, { key: obj.data.place, field: "_id" });
                            //     if (placeOfWorkRecords.length > 0) {
                            //         var geoZones = MongoF.geoZones.filter(filterById, { key: placeOfWorkRecords[0].geoZone_id, field: "_id" });
                            //         if (geoZones.length > 0) {
                            //             obj.placeData = placeOfWorkRecords[0];
                            //             obj.geoZoneData = geoZones[0]
                            //             if (typeof ($scope.minimumVariables) == "object" && typeof ($scope.minimumVariables[geoZones[0].name]) !== "undefined") {
                            //                 obj.minimunWage = $scope.minimumVariables[geoZones[0].name]
                            //             } else {
                            //                 errAlertS("No se encontro el salario minimo para la zona ", geoZones[0].name);
                            //             }
                            //         } else {
                            //             errAlertS("No se encontro la zona geografica seleccionada de la plaza" + placeOfWorkRecords[0].name);
                            //         }
                            //     } else {
                            //         errAlertS("No se encontro la plaza seleccionada del centro de costo" + obj.data.name);
                            //     }
                            // } else {
                            //     errAlertS("El centro de costo " + obj.data.name + " no tiene una plaza asignada, favor de asignarle una");
                            // }
                            $scope.ccs.push(obj);
                        }
                    });
                    if (typeof (resp[3]) !== "undefined") {
                        for (var e in $scope.employeesF) {
                            // var employeeCC = $scope.ccs.filter(filterById, { key: $scope.employeesF[e].cc, field: "$id" });
                            // if (employeeCC.length > 0) {
                            //     $scope.employeesF[e].ccData = employeeCC[0];
                            // } else {
                            //     errAlertS("No se encontro la informacion del centro de costo del empleado")
                            // }
                            $scope.employeesF[e].credit = resp[3][$scope.employeesF[e].$id];
                        }
                    }
                    $scope.operationCcs = (AppF.permissionToAccessAllPayrolls) ? $scope.ccs : $filter('getOperationCcs')($scope.ccs, $scope.L.userCcs[AppF.profile.uid]);
                    $scope.getValidations();
                    $log.debug("change in employees");
                    $scope.$emit('dataLoaded');
                });
            }).catch(function (error) {
                $log.error(error);
                errAlertS("Error al cargar los empleados");
                $rootScope.loadingProgress = false;
            });
        };
        var setHideNotSelect = function () {
            if ($scope.operation.status < $scope.opStatusNotCalc) {
                $scope.hideNotSelected = false;
            } else {
                $scope.hideNotSelected = true;
            }
            $log.debug('hideNotSelected setted', $scope.hideNotSelected);
        };
        var getIncidencesFromConstants = function (incidences) {
            if (AppF.constants) {
                $scope.constantIncidences = $filter('constantsByIncidences')($scope.employeesF, AppF.constants, $scope.period, $scope.payrollId, $scope.calendar, $scope.dispersion, $scope.L.calcFields, incidences, $scope.incidencesTypes);
                $scope.constantOfPayroll = $filter("constantsOfPayroll")($scope.payrollId, AppF.constants, $scope.L.calcFields);
                // console.log($scope.constantIncidences);
                var automaticIncidences = $filter('completeIncidenceInformation')(JSON.parse(JSON.stringify($scope.constantIncidences.automaticApply)), $scope.incidencesTypes, [], false);
                return $filter('combineAllIncidences')(incidences, automaticIncidences);
            } else {
                return incidences;
            }
        };
        var getIncidencesFromCredits = function (incidences) {
            incidences = $filter('createInfonavitIncidences')(incidences, $scope.incidencesTypes, $scope.employeesF, $scope.operation, $scope.calendar, $scope.payrollId, $scope.dispersion, $scope.period);
            return incidences;
        };
        $scope.toggle = function (item, list) {
            var idx = list.findIndex(function (employee) {
                return employee.$id == item.$id;
            });
            if (idx > -1) {
                list.splice(idx, 1);
            } else {
                list.push(item);
            }

        };
        $scope.exists = function (item, list) {
            return list.findIndex(function (employee) {
                return employee.$id == item.$id;
            }) > -1;
        };
        $scope.executeCalculations = {
            pending: []
        };
        $scope.$watch("executeCalculations.pending.length", function (pendingCalculations) {
            if (pendingCalculations > 0) {
                // $log.log(pendingCalculations, "to Execute");
                $scope.calculating = true;
                var promises = [];
                for (var i = 0; i < $scope.executeCalculations.pending.length; i++) {
                    var thisPendingCalculation = $scope.executeCalculations.pending[i];
                    promises.push($scope.directiveFunctions.calculate[thisPendingCalculation.directiveId + '-' + thisPendingCalculation.employeeId](thisPendingCalculation.pendingCalculations))
                }
                $q.all(promises).then(function () {
                    $scope.$$phase || $scope.$apply();
                    // $log.log("All pending calculations finished");
                    $scope.executeCalculations.pending = [];
                    $scope.calculating = false;
                    if ($scope.executeCalculations.callback) {
                        var params = $scope.executeCalculations.params
                        var thisCallback = $scope.executeCalculations.callback;
                        delete $scope.executeCalculations.callback;
                        delete $scope.executeCalculations.params;
                        // $scope.fixIncidencesFiscalP = $filter("perceptions")(AppF.fixIncidences.fiscal);
                        // $scope.fixIncidencesFiscalD = $filter("deductions")(AppF.fixIncidences.fiscal);
                        // if (typeof ($scope.complementProccess) == "undefined") {
                        //     $scope.complementProccess = {};
                        // }
                        // for (var proccess in AppF.fixIncidences) {
                        //     if (proccess !== "rejectedIncidences" && proccess !== "fiscal") {
                        //         // console.log(AppF.fixIncidences[proccess]);
                        //         $scope.complementProccess["fixIncidences" + proccess + "P"] = $filter("perceptions")(AppF.fixIncidences[proccess], "complement");
                        //         $scope.complementProccess["fixIncidences" + proccess + "D"] = $filter("deductions")(AppF.fixIncidences[proccess], "complement");
                        //         // console.log($scope.complementProccess["fixIncidences" + proccess + "P"], $scope.complementProccess["fixIncidences" + proccess + "D"]);
                        //     }
                        // }
                        try {
                            $log.debug("Abou to calling callback");
                            $timeout(function () {
                                if (typeof (params) === "object" && typeof (params.length) !== "undefined" && params.length > 0) {
                                    switch (params.length) {
                                        case 1:
                                            // $log.debug("callback called");
                                            mainFn[thisCallback](params[0]);
                                            break;
                                        case 2:
                                            // $log.debug("callback called");
                                            mainFn[thisCallback](params[0], params[1]);
                                            break;
                                    }
                                } else {
                                    // $log.debug("callback called");
                                    mainFn[thisCallback]();
                                }
                            })
                        } catch (error) {
                            errAlertS("Error en el callback")
                            // $log.error(error);
                        }
                    }
                }).catch(function (error) {
                    $log.error(error);
                    errAlertS("Error desconocido no se puede ejectuar el calculo");
                });
            }
        });

        mainFn.tryToFirstCalculations = function () {
            if (Object.keys($scope.directiveFunctions.firstCalculation).length) {
                $log.log(Object.keys($scope.directiveFunctions.firstCalculation).length, "first calculations to finish");
                var pendingCalculations = [];
                for (var c in $scope.directiveFunctions.firstCalculation) {
                    var thisC = $scope.directiveFunctions.firstCalculation[c];
                    if (thisC.readyToCalc()) {
                        var pending = {
                            directiveId: thisC.directiveId,
                            employeeId: thisC.employeeId
                        }
                        pendingCalculations.push(pending);
                    }
                }
                $scope.executeCalculations.callback = "tryToFirstCalculations";
                $scope.executeCalculations.pending = pendingCalculations;
            } else {
                AppF.firstCalculationFinished = true;
                $log.debug('Finished all firsts calculations');
                $rootScope.loadingProgress = false;
                mainFn.checkForChangesInDirectives(undefined, true);
            }
        }
        //Funcion para validar el boton de enviar a revisar cuando se hace la revision por centros de costo de una nomina
        $scope.allMyEmployeesInStatus = function (status, all) {
            var employees = $scope.employeesF;
            if (all) {
                employees = $scope.allEmployees;
            }
            var allInStatus = true;
            if (typeof (employees) != 'undefined' && typeof ($scope.operation) != 'undefined') {
                for (var i = 0; i < employees.length; i++) {
                    if ($scope.operation.employees && $scope.operation.employees[employees[i].$id] && $scope.operation.employees[employees[i].$id].status != status) {
                        allInStatus = false;
                        i = employees.length;
                    }
                }
            }
            return allInStatus;
        }
        $scope.add = function (operation) {
            //$log.debug('adding operation', operation);
            $rootScope.loadingProgress = true;
            var object = $scope.D.prepareObject(operation, 1, 0);
            $scope.operations.$add(object).then(function (ref) {
                var id = ref.key;
                var index = $scope.operations.$indexFor(id);
                $scope.operation = $scope.operations[index];
                //$log.debug(id, index, $scope.operation, 'saved on FB');
                successAlertS('Se creó operación con éxito');
            }, errAlertS).then(function () {
                $rootScope.loadingProgress = false;
                $scope.$evalAsync(function () {
                    //$log.debug('operation added');
                });
            });
        }
        $scope.save = function (operation, promise) {
            $log.debug('saving operation', operation);
            $rootScope.loadingProgress = true;
            var deferred;
            if (promise) deferred = $q.defer();
            operation.updated = $scope.D.getTimeObject();
            var object = $filter('clearObject')(operation);
            root.child($scope.operationsRef).child($scope.operationId).set(object).then(function (snap) {
                updateNextOperation(object, $scope.operationId).then(function () {
                    if (promise) {
                        deferred.resolve(snap);
                    } else {
                        successAlertS('Se guardó operación con éxito');
                        $rootScope.loadingProgress = false;
                        $scope.$evalAsync(function () {
                            //$log.debug('operation saved');
                        });
                    }
                });
            }, function (error) {
                if (promise) {
                    deferred.reject(error);
                } else {
                    errAlertS(error);
                    $rootScope.loadingProgress = false;
                    $scope.$evalAsync(function () {
                        //$log.debug('error saving operation');
                    });
                }
            });

            if (promise) return deferred.promise;
        }
        $scope.getValidations = function () {
            // validations for table loader
            $scope.validations = [{
                valid: ($scope.employeesF.length && !$rootScope.loadingProgress),
                msg: 'Parece que no tiene empleados activos para el periodo seleccionado'
            }];
            //$log.debug($scope.validations, 'validations');
        }
        $scope.goToList = function () {
            // data needed in back state
            var params = {
                calendars: $scope.payrolls
            };
            if (dataFrom == 'array') {
                params.operations = $scope.operations;
            }
            AppF.goToState($scope.backState, params);
        }
        $scope.toggleColumn = function (e, column) {
            e.stopPropagation();
            column.show = !column.show;
            $sessionStorage.columns = AppF.columns;
            //$log.debug('toggleColumn', column, AppF.columns);
        }
        $scope.countObj = function (obj) {
            if (typeof (obj) == 'object') {
                return $filter('countObject')(obj);
            }
            return 0;
        }
        $scope.getSatCode = function (incidenceId) {
            var i = $filter('getSomethingOfArrayFB')(incidenceId, AppF.incidencesTypes, 'satIncidencesType', '');
            return i;
        }
        $scope.openMenu = function ($mdOpenMenu, ev) {
            $mdOpenMenu(ev);
        }
        $scope.resetSelected = function () {
            $scope.selected = [];
        }
        $scope.confirmOperationAction = function (e, action, operation) {
            var title = '';
            var msg = '';
            var ariaLabel = '';
            var okText = '';
            if (action == 'moveOperation' || action == 'closeOperation') {
                title = 'Cerrar Operación';
                msg = 'Desea cerrar esta operación?';
                ariaLabel = 'CLose Operation';
                okText = 'Cerrar Operación';
            } else if (action == 'moveBackOperation') {
                title = 'Abrir Operación';
                msg = 'Desea abrir esta operación?';
                ariaLabel = 'Open Operation';
                okText = 'Abrir Operación';
            } else if (action == 'reOpenClosed') {
                title = 'Abrir operación cerrada';
                msg = 'Este periodo ya ha sido cerrada, por lo que si la reabre los cálculos hecho anteriormente podrían ser alterados, desea continuar?';
                ariaLabel = 'Open Operation';
                okText = 'Abrir Operación';
            } else if (action == 'cancelReOpen') {
                title = 'Cerrar nomina reabierta';
                msg = 'Desea descartar los cambios y cerrar la nomina con los datos que estaban anteriormente, si hace esto todos los demas datos capturados seran descartados';
                ariaLabel = 'Close Reopened Operation';
                okText = 'Cerrar Operación Reabierta';
            }
            $mdDialog.show($mdDialog.confirm(confirmConfig)
                .title(title)
                .content(msg)
                .ariaLabel(ariaLabel)
                .targetEvent(e)
                .ok(okText)
                .cancel('Cancelar'))
                .then(function () {
                    if (action == 'moveOperation') {
                        $scope.moveOperation(operation, 4);
                    } else if (action == 'closeOperation') {
                        closeOperation(operation);
                    } else if (action == 'moveBackOperation') {
                        $scope.moveOperation(operation, $scope.previousOperationStatus, "", $scope.employeesF, $scope.previousEmployeeStatus, $scope.incidences, $scope.previousIncidencesStatus, false, true);
                    } else if (action == 'reOpenClosed') {
                        reOpenClosed(operation, $scope.previousOperationStatus, "", $scope.employeesF, $scope.previousEmployeeStatus, $scope.incidences, $scope.previousIncidencesStatus, false, true);
                    } else if (action == 'cancelReOpen') {
                        cancelReopenOperation(operation, $scope.previousOperationStatus, "", $scope.employeesF, $scope.previousEmployeeStatus, $scope.incidences, $scope.previousIncidencesStatus, false, true);
                    }
                }, function () {
                    //$log.debug(action + ' Cancelled');
                });
        }
        $scope.setTabName = function (tabName, slugIt) {
            $scope.selected = [];
            $scope.tabName = (slugIt) ? $filter('slugify')(tabName) : tabName;
        }
        $scope.incidenceAffect = function (incidenceId, affect) {
            return $filter('incidenceAffect')(incidenceId, affect);
        }

        $scope.addFastIncidenceColumn = function (incidenceType, process) {
            //$log.debug('adding fastIncidence', incidenceType, process, $scope.fastIncidencesByType);
            if (!$scope.fastIncidencesByType.hasOwnProperty(incidenceType.$id)) {
                $scope.fastIncidencesByType[incidenceType.$id] = {};
            }
            for (var e = 0; e < $scope.realEmployees.length; e++) {
                var thisEmployee = $scope.realEmployees[e];
                if (thisEmployee.hasOwnProperty('$id')) {
                    if (angular.isUndefined($scope.fastIncidencesByType[incidenceType.$id][thisEmployee.$id])) {
                        $scope.fastIncidencesByType[incidenceType.$id][thisEmployee.$id] = {
                            value: 0
                        };
                    }
                }
            }
            $scope.fastIncidencesByTypeP = $filter("perceptions")($scope.fastIncidencesByType);
            $scope.fastIncidencesByTypeD = $filter("deductions")($scope.fastIncidencesByType);
            $scope.$$phase || $scope.$apply();
        }
        $scope.saveFastIncidence = function (incidence, employeeId, incidenceTypeId, activeDays, allIncindences) {
            if (AppF.firstCalculationFinished) {
                $log.debug("Saving fast incidence");
                incidence = JSON.parse(JSON.stringify(incidence));
                var promiseIncidence = function () {
                    return new Promise(function (resolve, reject) {
                        var addIncidence = true;
                        var needToAddColumn = false;
                        var deletedPromise = [];
                        var somethingChange = false;
                        if (incidence.value == '' || incidence.value == null) {
                            addIncidence = false;
                            if (incidence.hasOwnProperty('$ids')) {
                                needToAddColumn = true;
                                var deleteUpdates = {};
                                for (var i in incidence.$ids) {
                                    deleteUpdates[incidence.$ids[i]] = null;
                                }
                                somethingChange = true;
                                deletedPromise.push(root.child($scope.incidencesRef).update(deleteUpdates));
                            }
                        }
                        Promise.all(deletedPromise).then(function () {
                            var savePromise = [];
                            if (addIncidence) {
                                var defaultIncidence = {
                                    payroll: $scope.payrollId,
                                    period: $scope.periodNumber,
                                    calendar: $scope.calendar,
                                    automaticAsignation: true,
                                    status: 0,
                                    incidenceType: incidenceTypeId,
                                    employee: employeeId,
                                    type: 'fast',
                                    comments: 'Incidencia Rapida',
                                    created: DataF.getTimeObject()
                                }
                                if (incidence.created) {
                                    incidence.updated = DataF.getTimeObject()
                                }
                                incidence = angular.merge(incidence, defaultIncidence);
                                var updates = {};
                                if ($scope.incidenceAffect(incidenceTypeId, 'days')) {
                                    updates = $filter('createIncidencesByDay')(incidence, activeDays, allIncindences, AppF.incidencesTypes, root, $scope.incidencesRef);
                                } else {
                                    var incidenceId = false;
                                    if (typeof (incidence.$ids) != 'undefined') {
                                        incidenceId = incidence.$ids[0];
                                    } else {
                                        incidenceId = root.child($scope.incidencesRef).push().key;
                                    }
                                    if (incidence.hasOwnProperty['dates']) incidence.date = incidence.dates[0];
                                    else incidence.date = $scope.period.start;
                                    delete incidence.$ids;
                                    delete incidence.dates;
                                    updates[incidenceId] = $filter('clearObject')(incidence);
                                }
                                savePromise.push(root.child($scope.incidencesRef).update(updates));
                                somethingChange = true;
                            }
                            Promise.all(savePromise).then(function () {
                                var obj = {
                                    addColumn: needToAddColumn,
                                    somethingChange: somethingChange
                                };
                                resolve(obj);
                            }).catch(function (error) {
                                reject(error);
                            })
                        }).catch(function (error) {
                            reject(error);
                        })
                    })
                }
                if (typeof ($scope.ignoreChange) == "undefined") {
                    $scope.ignoreChange = [];
                }
                $scope.ignoreChange.push("si");
                promiseIncidence().then(function (actions) {
                    $scope.$$phase || $scope.$apply();
                    $scope.ignoreChange.pop();
                    $log.debug("Fast Incidence Saved");
                    if (!$scope.ignoreChange.length) {
                        delete $scope.ignoreChange;
                        if (actions.somethingChange) {
                            $log.debug("Emitted after promise updates");
                            $scope.$emit('dataLoaded');
                        }
                        if (actions.addColumn) {
                            $log.debug("Adding column")
                            var incidenceType = $filter('getObjectOfArrayById')(incidenceTypeId, AppF.incidencesTypes, '$id');
                            $scope.addFastIncidenceColumn(incidenceType)
                        }
                    }
                }).catch(function (error) {
                    $log.error(error);
                })
            }
        }
        $scope.exportToExcelWithHeaders = function () {
            var defaultTotalFiedls = ['salary', 'perceptions', 'deductions', 'netRealSalary'];
            var calculations = [];
            var headers = {};
            var totals = {};
            for (var e = 0; e < $scope.employeesF.length; e++) {
                var employee = $scope.employeesF[e];
                if (employee.calculations.REAL) {
                    for (var calculationId in employee.calculations.REAL) {
                        headers[calculationId] = {
                            "weight": employee.calculations.REAL[calculationId].value.weight,
                            "name": employee.calculations.REAL[calculationId].value.name,
                        }
                    }
                }
            }
            headers = $filter('objsToArray')(headers);
            headers = $filter('orderBy')(headers, ['weight', 'name']);
            var employeesOrdered = $filter("orderBy")($scope.employeesF, ['data.enroleDate', 'data.name'])
            for (var e = 0; e < employeesOrdered.length; e++) {
                var employee = employeesOrdered[e];
                if (employee.calculations.REAL) {
                    var obj = {};
                    obj.NO = employee.data.employeeNumber ? employee.data.employeeNumber : '';
                    obj.NSS = employee.data.nss;
                    obj.NOMBRE = employee.data.name;
                    obj.CC = $filter('getSomethingOfArrayFB')(employee.cc, $scope.ccs, 'data.name');
                    angular.forEach(headers, function (calc) {
                        var addTo = true;
                        if (!$scope.normalIncidencesByType.hasOwnProperty(calc.$id)) {
                            if ($scope.fastIncidencesByType.hasOwnProperty(calc.$id)) {
                                if ($filter('checkAllowDeleteFastIncidence')($scope.fastIncidencesByType[calc.$id])) {
                                    addTo = false;
                                }
                            }
                        }
                        if (addTo) {
                            var total = ($filter("pathInObj")(employee.calculations.REAL, calc.$id + ".value.total")) ? employee.calculations.REAL[calc.$id].value.total : 0;
                            obj[$filter('uppercase')(calc.name)] = total;
                            if ($filter('getSomethingOfArrayFB')(calc.$id, AppF.incidencesTypes, 'showTotal', false) || defaultTotalFiedls.indexOf(calc.$id) >= 0) {
                                if (angular.isUndefined(totals[$filter('uppercase')(calc.name)])) totals[$filter('uppercase')(calc.name)] = 0;
                                totals[$filter('uppercase')(calc.name)] += total;
                            }
                        }
                    })
                    calculations.push(obj);
                }
            }
            calculations.push(totals);
            var headers = [
                ['TDSystem Software'],
                [$scope.payroll.data.class + ' ' + $scope.payroll.data.name + ' [' + $filter('getSomethingOfArrayM')($scope.payroll.paymentFrequency, $scope.M.paymentFrequenciesRecords, 'name') + ']'],
                ['Incidencias del ' + $filter('date')($scope.operationData.start, AppF.dateFormat) + ' al ' + $filter('date')($scope.operationData.end, AppF.dateFormat)],
                ['']
                // ['Nomina:', $scope.payroll.data.name, '', 'Status de Operación:', $filter('operationStatusName')($scope.operation.status)],
                // [$filter('translate')('operation.SINGULAR'), 'Ordinaria ' + $scope.calendar + ' - ' + $scope.periodNumber,'', 'Fecha:', $filter('date')($scope.operationData.start, 'mediumDate') + ' - ' + $filter('date')($scope.operationData.end, 'mediumDate')],
                // ['']
            ];
            var data = {
                data: JSON.stringify(calculations),
                headers: JSON.stringify(headers)
            };
            CatalogsF.exportToExcel('interface/exportDataWithHeader', data);
        }
        $scope.deleteFastIncidences = function (incidenceId) {
            var deleteIncidences = {};
            angular.forEach($scope.fastIncidencesByType[incidenceId], function (incidence) {
                if (incidence.$id) {
                    deleteIncidences[$scope.operation.payroll + '/' + $scope.operation.calendar + '/' + incidence.$id] = null;
                }
            })
            AppF.root.child('incidences').update(deleteIncidences).then(function () {
                delete $scope.fastIncidencesByType[incidenceId]
            });
            $scope.fastIncidencesByTypeP = $filter("perceptions")($scope.fastIncidencesByType);
            $scope.fastIncidencesByTypeD = $filter("deductions")($scope.fastIncidencesByType);
            $scope.$$phase || $scope.$apply();
        }
        $scope.fastIncidenceUsed = function (incidenceTypeId) {
            for (var i in $scope.fastIncidencesByType) {
                if (i == incidenceTypeId) return true;
            }
            return false;
        }
        $scope.exportToExcel = function () {
            var dataToExport = JSON.stringify($filter('generateIncidencesToImport')($scope.allIncidences, $scope.payroll, $scope.period, $scope.employeesF, $scope.calendar));
            console.log($scope.allIncidences);
            var data = {
                data: dataToExport
            };
            CatalogsF.exportToExcel('interface/exportDataToCSV', data);
        }
        //SECCION PARA MOSTAR LOS MODALES BOTTOM
        $scope.addIncidence = function (incidence) {
            //$log.debug('addIncidenceAdvanced', incidence);
            return new Promise(function (resolve, reject) {
                $rootScope.loadingProgress = true;
                var incidenceAffect = $filter('getSomethingOfArrayFB')(incidence.incidenceType, $scope.incidencesTypes, 'affect');
                IncidencesF.checkIfIncidenceRequestIsNeededAndCreateIt(incidence, incidenceAffect)
                    .then(function (iR) {
                        var msg = (iR) ? 'Se creó una solicitud de incidencias masivas y varias incidencias para cada día' : 'Se creó Incidencia con éxito';
                        $rootScope.loadingProgress = false;
                        $scope.$evalAsync(function () {
                            //$log.debug('Incidencias creadas');
                        });
                        successAlertS(msg);
                        resolve(msg);
                    })
                    .catch(function (err) {
                        errAlertS(err);
                        $rootScope.loadingProgress = false;
                        $scope.$evalAsync(function () {
                            //$log.debug('error creando finished');
                        });
                        reject(err);
                    });
            });
        }
        $scope.saveIncidence = function (incidence) {
            return root.child('incidences/' + incidence.payroll + '/' + incidence.calendar + '/' + incidence.$id).update($filter('clearObject')(incidence));
        }
        $scope.deleteIncidence = function (incidences) {

            return $q(function (resolve, reject) {
                var updates = {};
                var checkRequest = {};
                angular.forEach(incidences, function (incidence, index) {
                    updates['incidences/' + incidence.payroll + '/' + incidence.calendar + '/' + incidence.$id] = null;
                    if (incidence.type == 'request') {
                        checkRequest[index] = root.child('catalogs/incidencesRequests/collection/' + incidence.request + '/incidences').once('value');
                    }
                });
                $q.all(checkRequest).then(function (data) {
                    angular.forEach(data, function (value, key) {
                        var incs = value.val();
                        var numOfRows = 0;
                        var match = false;
                        angular.forEach(incs, function (inc, k) {
                            numOfRows++;
                            if (k == incidences[key].$id) {
                                match = true;
                            }
                        });
                        if (match && numOfRows == 1) {
                            updates['catalogs/incidencesRequests/collection/' + incidences[key].request] = null;
                        } else {
                            updates['catalogs/incidencesRequests/collection/' + incidences[key].request + '/incidences/' + incidences[key].$id] = null;
                            updates['catalogs/incidencesRequests/collection/' + incidences[key].request + '/employees/' + incidences[key].employee] = null;
                        }
                    });
                    root.update(updates).then(function (snapshot) {
                        resolve(snapshot);
                    }, function (error) {
                        reject(error)
                    });
                });
            });
        }
        $scope.showCalculationsListBottomSheet = function (event, employee) {
            var flag = true;
            var employees;
            var process;
            if ($scope.tabName !== "FISCAL" && $scope.tabName !== "REAL") {
                var thisProcces = $filter("filter")($scope.paymentSchema.data.processes.complements, {
                    "name": $scope.tabName
                });
                if (thisProcces.length) {
                    process = thisProcces[0].type;
                } else {
                    errAlertS("No se obtuvo la informacion del proceso");
                    flag = false;
                }
            } else {
                process = $scope.tabName;
            }
            if ($scope.tabName == "FISCAL") {
                employees = $filter("orderBy")($scope.fiscalEmployees, $scope.order);
            } else {
                employees = $filter("orderBy")($scope.realEmployees, $scope.order);
            }
            var employeeIndex = employees.indexOf(employee);
            if (flag) {
                $mdBottomSheet.show({
                    templateUrl: 'app/main/clients/views/operation/dialogs/bottom-calculations.html',
                    locals: {
                        employee: employee,
                        employeeIndex: employeeIndex,
                        employees: employees,
                        incidences: $scope.allIncidences,
                        operation: $scope.operation,
                        tabName: $scope.tabName,
                        process: process
                    },
                    controller: function (scope, $rootScope, confirmConfig, $mdDialog, $firebaseObject, $filter, employee, employeeIndex, employees, incidences, operation, tabName, MongoF, AppF, process) {
                        scope.incidences = incidences;
                        scope.employee = employee;
                        scope.employees = employees;
                        scope.employeeIndex = employeeIndex;
                        scope.operation = operation;
                        scope.tabName = tabName;
                        scope.process = process;
                        scope.F = AppF;
                        scope.openCalc = function (ev, calculation) {
                            scope.calculation = calculation;
                            scope.isArray = function (dato) {
                                //$log.debug(typeof(dato), dato);
                                var isA = false;
                                if (typeof (dato) !== "undefined") {
                                    if (typeof dato == 'object') {
                                        isA = 1;
                                    }
                                    if (isA) {
                                        if (!isNaN(dato)) { //validacion especial ya uqe se extendio el objeto number y el typeof lo reconoce como objeto no como numero
                                            isA = false;
                                        } else if (typeof dato[0] == 'object') { // is array
                                            if (dato[0].hasOwnProperty('s') && dato[0].hasOwnProperty('d') && dato[0].hasOwnProperty('t')) {
                                                isA = 'movements';
                                            } else if (dato[0].hasOwnProperty('status') && dato[0].hasOwnProperty('data') && dato[0].data.hasOwnProperty('type') && dato[0].data.hasOwnProperty('date')) {
                                                isA = 'movements';
                                            } else if (dato[0].hasOwnProperty('start') && dato[0].hasOwnProperty('end')) {
                                                isA = 'days';
                                            } else if (dato[0].hasOwnProperty('sd') && dato[0].hasOwnProperty('sbc') && dato[0].hasOwnProperty('sdr')) {
                                                isA = 'salaries';
                                            }
                                        } else if (typeof (dato.amounts) == "object") {
                                            isA = 'gravable';
                                        } else if (!dato.length) {
                                            var record;
                                            for (var f in dato) {
                                                if (typeof (dato[f]) == "object") {
                                                    record = dato[f];
                                                }
                                            }
                                            if (typeof (record) != "undefined" && record.hasOwnProperty('value') && record.hasOwnProperty('from')) {
                                                isA = 'calculations';
                                            } else {
                                                isA = 'salaries';
                                            }
                                        }
                                    }
                                }
                                return isA;
                            }
                            scope.M = MongoF;
                            $mdDialog.show({
                                controller: 'DialogCtrl',
                                templateUrl: 'app/main/clients/views/operation/dialogs/calculations.html',
                                locals: {
                                    predefinedValue: undefined
                                },
                                parent: angular.element(document.body),
                                targetEvent: ev,
                                scope: scope.$new(),
                                clickOutsideToClose: true
                                //fullscreen: true
                            });
                            $rootScope.loadingProgress = false;
                            $scope.$evalAsync(function () {
                                //$log.debug('calculation show finished');
                            });
                        };
                    },
                    parent: '.md-tab-body',
                    clickOutsideToClose: true,
                    escapeToClose: true,
                    targetEvent: event
                }).then(function () {
                    //$log.debug(clickedItem);
                }).catch(function (error) {
                    $log.debug("Calculations modal closed", error);
                });
            }

        }
        $scope.setNextOrder = function (field, actualOrder) {
            var orderArray = [['data.enroleDate', 'data.name'], field, "-" + field];
            var index = orderArray.indexOf(actualOrder);
            if (index == -1) {
                index = 0;
            }
            console.log(index);
            var nextIndex = index + 1;
            console.log(nextIndex);
            if (nextIndex >= orderArray.length) {
                nextIndex = 0;
            }
            console.log(nextIndex);
            $scope.order = orderArray[nextIndex];
            $scope.$emit('dataLoaded', true);
        }
        $scope.showIncidencesListBottomSheet = function (event, employee) {
            $mdBottomSheet.show({
                templateUrl: 'app/main/clients/views/operation/dialogs/bottom-incidences.html',
                locals: {
                    employee: employee,
                    incidences: $scope.allIncidences,
                    addIncidence: $scope.addIncidence,
                    saveIncidence: $scope.saveIncidence,
                    deleteIncidence: $scope.deleteIncidence,
                    operation: $scope.operation,
                    incidencesTypes: $scope.incidencesTypes,
                    operationData: $scope.operationData,
                    payroll: $scope.payroll,
                    nextEmployeeStatus: $scope.nextEmployeeStatus,
                    opStatusNotCalc: $scope.opStatusNotCalc
                },
                controller: function (scope, $filter, $rootScope, AppF, confirmConfig, $mdDialog, $firebaseObject, employee, incidences, MongoF, addIncidence, saveIncidence, deleteIncidence, operation, incidencesTypes, operationData, payroll, nextEmployeeStatus, opStatusNotCalc) {
                    AppF.incidencesTypes = incidencesTypes;
                    AppF.minIncidenceRequestDate = moment(operationData.start).startOf('day').toDate();
                    AppF.maxIncidenceRequestDate = moment(operationData.end).startOf('day').toDate();
                    var movementsOrdered = $filter('orderBy')(employee.movements, 'd');
                    var activeDays = $filter('activeDaysFromMovements')(movementsOrdered, operationData, []);
                    scope.incidencesTypes = incidencesTypes;
                    scope.selected = [];
                    scope.M = MongoF;
                    scope.F = AppF;
                    scope.incidences = incidences;
                    scope.employee = employee;
                    scope.operation = operation;
                    scope.nextEmployeeStatus = nextEmployeeStatus;
                    scope.opStatusNotCalc = opStatusNotCalc;
                    var blancIncidence = {
                        automaticAsignation: true,
                        status: 0,
                        date: activeDays[0].start,
                        calendar: operation.calendar,
                        period: operation.period,
                        employee: employee.$id,
                        payroll: payroll.$id,
                        type: 'manual',
                        comments: ''
                    };
                    scope.getEmployeeIncidences = function () {
                        scope.employeeIncidences = AppF.incidencesByEmployee[scope.employee.$id] ? JSON.parse(JSON.stringify(AppF.incidencesByEmployee[scope.employee.$id])) : [];
                    }
                    var incidencesWatcher = scope.$watch(function () {
                        return AppF.incidencesByEmployee[scope.employee.$id];
                    }, function (newV) {
                        scope.getEmployeeIncidences();
                    })

                    scope.$on('$destroy', function () {
                        incidencesWatcher();
                    })
                    scope.addIncidence = function (incidence) {
                        if (!$scope.adding) {
                            $scope.adding = true;
                            addIncidence(incidence).then(function () {
                                $mdDialog.hide().then(function () {
                                    $scope.adding = false;
                                });
                            }).catch(function (error) {
                                $log.error(error);
                                $scope.adding = false;
                            });
                        }
                    }
                    scope.saveIncidence = function (incidence) {
                        saveIncidence(incidence).then(function () {
                            successAlertS('Se guardó incidencia con éxito');
                            $mdDialog.hide();
                        });
                    }
                    scope.deleteIncidence = function (e) {
                        var msg = (!AppF.safeDelete.operation) ?
                            'No podrá recuperar sus datos' :
                            'Podrá recuperar sus datos en la papelera';
                        var title = 'Quiere borrar ' + scope.selected.length + ' incidencias?';

                        $mdDialog.show($mdDialog.confirm(confirmConfig)
                            .title(title)
                            .content(msg)
                            .ariaLabel('Deleting')
                            .targetEvent(e)
                            .ok('Borrar')
                            .cancel('Cancelar'))
                            .then(function () {
                                var incidencesTotal = scope.selected.length;
                                $rootScope.loadingProgress = true;
                                deleteIncidence(scope.selected).then(function () {
                                    scope.selected = [];
                                    successAlertS('Se eliminaron ' + incidencesTotal + ' incidencia(s) con éxito');
                                    $mdDialog.hide();
                                }).catch(function (error) {
                                    errAlertS(error);
                                }).then(function () {
                                    $rootScope.loadingProgress = false;
                                })
                            }, function () {
                                $log.debug('Deleting Cancelled');
                            });
                    }
                    scope.checkIfValid = function (date, incidenceType, val, prom) {
                        //$log.debug('checkIfValid', date, incidenceType);
                        if (incidenceType && date) {
                            val = (val) ? val : 1;
                            return new Promise(function (resolve, reject) {
                                var incidenceAffect = $filter('getSomethingOfArrayFB')(incidenceType, scope.incidencesTypes, 'affect');
                                // se checa que la incidencia afecte solamene dias activos
                                var incidence = {
                                    date: date,
                                    value: val,
                                    employee: employee.$id
                                };
                                IncidencesF.checkIfValidActiveDates(incidence, incidenceType.affect)
                                    .then(function () {
                                        console.log(scope.employeeIncidences)
                                        if (incidenceAffect == 'days') {
                                            var msg = '';
                                            if (val > 1) {
                                                for (var x = 0; x < val; x++) {
                                                    var initDate = date + (AppF.oneDay * x); // * x dias empezando por 0
                                                    if (x == (val - 1)) {
                                                        // si es la ultima checar que la fecha no sobre pase el periodo
                                                        if (initDate > operationData.end) {
                                                            msg = 'Fecha ' + moment(initDate).format('DD/MM/YYYY') + ' es de otro periodo';
                                                            if (!prom) {
                                                                errAlertS(msg);
                                                                $log.error('incidence with problem: ', {
                                                                    incidence: incidences[i],
                                                                    dateOfInicidence: initDate,
                                                                    end: operationData.end
                                                                });
                                                                scope.incidence.value = x;
                                                            }
                                                            if (prom) reject(msg);
                                                            return false;
                                                        }
                                                    }
                                                    for (var i in scope.employeeIncidences) {
                                                        var iaffect = $filter('getSomethingOfArrayFB')(scope.employeeIncidences[i].incidenceType, scope.incidencesTypes, 'affect');
                                                        console.log(scope.employeeIncidences[i])
                                                        if (scope.employeeIncidences[i].date == initDate && iaffect == 'days' && scope.employeeIncidences[i].employee == incidence.employee) {
                                                            msg = 'Fecha ' + moment(initDate).format('DD/MM/YYYY') + ' ya tiene incidencia que afecta días';
                                                            if (!prom) {
                                                                errAlertS(msg);
                                                                $log.error('incidence with problem: ', scope.employeeIncidences[i]);
                                                                scope.incidence.date = null;
                                                            }
                                                            if (prom) reject(msg);
                                                            return false;
                                                        }
                                                    }
                                                }
                                                if (scope.incidence.date !== null) {
                                                    if (prom) resolve(true);
                                                }
                                            } else {
                                                for (var ii in scope.employeeIncidences) {
                                                    var iiaffect = $filter('getSomethingOfArrayFB')(scope.employeeIncidences[ii].incidenceType, scope.incidencesTypes, 'affect');
                                                    if (scope.employeeIncidences[ii].date == date && iiaffect == 'days' && scope.employeeIncidences[ii].employee == incidence.employee) {
                                                        msg = 'Fecha ' + moment(date).format('DD/MM/YYYY') + ' ya tiene incidencia que afecta días';
                                                        if (!prom) {
                                                            errAlertS(msg);
                                                            $log.error('incidence with problem: ', scope.employeeIncidences[ii]);
                                                            scope.incidence.date = null;
                                                        }
                                                        if (prom) reject(msg);
                                                        return false;
                                                    }
                                                }
                                                if (scope.incidence.date !== null) {
                                                    if (prom) resolve(true);
                                                }
                                            }
                                        } else {
                                            if (prom) resolve(true);
                                        }
                                    }).catch(function (err) {
                                        errAlertS(err);
                                        scope.incidence.date = null;
                                    });
                            });
                        }
                    }
                    scope.openObject = function (ev, incidence, action) {
                        var dataNeeded = [];
                        scope.action = action;
                        if (action == 'add') {
                            scope.F.addMode = true;
                            scope.incidence = JSON.parse(JSON.stringify(blancIncidence));
                        } else {
                            scope.F.addMode = false;
                            scope.incidence = incidence;
                        }
                        $rootScope.loadingProgress = true;
                        scope.disabled = true;
                        scope.M.loadNeeded(dataNeeded);
                        $mdDialog.show({
                            controller: 'DialogCtrl',
                            locals: {
                                predefinedValue: undefined
                            },
                            templateUrl: 'app/main/clients/views/operation/dialogs/incidence.html',
                            parent: angular.element(document.body),
                            targetEvent: ev,
                            scope: scope.$new(),
                            clickOutsideToClose: true
                            //fullscreen: true
                        });
                        $rootScope.loadingProgress = false;
                        $scope.$evalAsync(function () {
                            //$log.debug('open modal finished');
                        });
                    }
                },
                parent: '.md-tab-body',
                clickOutsideToClose: true,
                escapeToClose: true,
                targetEvent: event
            }).then(function () {
                //$log.debug(clickedItem)
            }).catch(function (error) {
                $log.debug("Incidences modal closed", error);
            })
        };
        //SECCION DE FUNCIONES PARA LAS IMAGENES
        $scope.upload = function (files, operation) {
            $rootScope.loadingProgress = true;
            //$log.debug('uploading file', files, operation);
            var file = files[0].lfFile; // @todo hacer que guarde varios pagos
            var filesRef = storageRef.child('operations/');
            var mimeType = file.type;
            var type = $filter('fileType')(mimeType);
            var fileName = 'payment-' + 1 + type;
            var spaceRef = filesRef.child(operation.$id).child(fileName);
            var uploadTask = spaceRef.put(file);
            $scope.progress = 0;
            if (!operation.payed) operation.payed = $scope.D.getTimeObject();
            uploadTask.on('state_changed', function (snapshot) {
                $scope.progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                //$log.debug('Upload is ' + $scope.progress + '% done');
                switch (snapshot.state) {
                    case firebase.storage.TaskState.PAUSED: // or 'paused'
                        //$log.debug('Upload is paused');
                        break;
                    case firebase.storage.TaskState.RUNNING: // or 'running'
                        //$log.debug('Upload is running');
                        break;
                }
            }, errAlertS, function () {
                // aqui debes poner tu archivo donde se supone que va en el objeto
                operation.payed.referenceFile = uploadTask.snapshot.downloadURL;
                $scope.save(operation, 1).then(function () {
                    successAlertS('Se subió el archivo correctamente');
                    $scope.files = [];
                    //$scope.filesApi.removeAll();
                }, errAlertS).then(function () {
                    $rootScope.loadingProgress = false;
                    $scope.$evalAsync(function () {
                        //$log.debug('file not updated error');
                    });
                })
            });
        }
        $scope.removeUpload = function (operation) {
            var fileUrl = operation.payed.referenceFile;
            var ext = $filter('fileType')(fileUrl, 1);
            var fileName = 'payment-' + 1 + ext; // @todo hacer que guarde varios pagos
            // Create a reference to the file to delete
            var desertRef = storageRef.child('operations/' + operation.$id + '/' + fileName);
            // Delete the file
            $rootScope.loadingProgress = true;
            desertRef.delete().then(function () {
                operation.payed.referenceFile = false;
                $scope.save(operation, 1).then(function () {
                    successAlertS('Se borró el archivo correctamente');
                });
            }, errAlertS).then(function () {
                $rootScope.loadingProgress = false;
                $scope.$evalAsync(function () {
                    //$log.debug('file deleted');
                });
            });
        }
        $scope.cancelUpload = function (uploadTask) {
            uploadTask.cancel();
        }
        //SECCION DE FUNCIONES PARA LA CONTINUACION DE LAS OPERACIONES
        //IMPLEMENTADOS
        //AUXILIARES
        function setDispersion(dispersion) {
            return new Promise(function (resolve, reject) {
                var uid;
                if (dispersion.hasOwnProperty('$id')) { // already exists
                    uid = dispersion.$id;
                } else {
                    uid = root.child($scope.dispersionsRef).push().key; // getting uid for first time
                }
                // rewrite or write dispersion
                var updates = {};
                updates[$scope.dispersionsRef + '/' + uid] = dispersion;
                updates[$scope.operationsRef + '/' + $scope.operationId + '/dispersion'] = uid;
                root.update(updates).then(function () {
                    resolve(uid)
                }).catch(function (error) {
                    reject(error);
                });
            })

        }

        function deleteOldOperationData(operation) {
            return new Promise(function (resolve) {
                if (operation.oldDataOperation) {
                    $log.debug("About to delete oldOperationData")
                    var oldOperationDataId = operation.oldDataOperation;
                    delete $scope.operation.oldDataOperation;
                    delete operation.oldDataOperation;
                    resolve(root.child($scope.oldOperationDataRef).child(oldOperationDataId).set(null));
                } else {
                    resolve(operation);
                }
            })
        }

        function moveOperation(operation, status, comments, employees, employeeStatus, incidences, incidenceStatus, createIncidences, moveBack, dispersionId) {
            return new Promise(function (resolve, reject) {
                try {
                    operation = $filter('constructStatusNode')(operation, status, moveBack, comments); // agrega nodo para status con tiempo, usuario, ip, etc
                    operation.updated = $scope.D.getTimeObject();
                    //Se obtienen los updates de las incidencias
                    var promises = [];
                    if (typeof (incidenceStatus) !== 'undefined' && incidenceStatus !== false) {
                        promises.push(getUpdatesIncidences(employees, incidences, incidenceStatus, createIncidences, false, moveBack, dispersionId));
                    }
                    Promise.all(promises).then(function (resp) {
                        var incidencesUpdates = {};
                        if (resp.length > 0) {
                            incidencesUpdates = resp[0];
                        }
                        //Se establece si es necesario el status de los empleados, cuando se establece el status siempre sera 
                        //necesario que todos los empleado esten en ese status para que la operación pueda estar en ese status
                        var validateEmployeesStatus = false;
                        if (typeof (employeeStatus) !== 'undefined' && employeeStatus !== false) {
                            validateEmployeesStatus = true;
                            //var setEmployeesStatus = function(employees, status, forceStatus, update, deleteNotInList)
                            setEmployeesStatus(employees, employeeStatus, true, false, false);
                        }
                        //Si se pasa el status del emplado se validara que todos esten en ese status para continuar, a menos que
                        //se esta regresando la nomina a un status anterior no se validaria que todos esten activos sino simplemente se asigna ese status
                        if (validateEmployeesStatus && !moveBack) {
                            if ($scope.allMyEmployeesInStatus(employeeStatus, true)) {
                                $scope.operation.status = status;
                            }
                        } else {
                            $scope.operation.status = status;
                        }
                        var updates = [
                            root.update(incidencesUpdates.incidences),
                            root.update(incidencesUpdates.references),
                            $scope.save(operation, 1)
                        ];
                        Promise.all(updates).then(function (resp) {
                            resolve(resp)
                        }).catch(function (error) {
                            reject(error);
                        })
                    }).catch(function (error) {
                        reject(error);
                    })
                } catch (error) {
                    reject(error);
                }
            })
        }

        function sendOperationNotification(operation, status, moveBack, operationTab, operationStatusName, employees, comments) {
            return getOperationDataObjectsFilter(operation, operationTab, moveBack, operationStatusName, employees, comments).then(function (operationData) {
                return AppF.notifyUsers('operation', 'operations', status, operation.$id, operation, false, operationData);
            });
        }
        $scope.sendToReview = function (operation, employees, comments) {
            $scope.moveOperation(operation, $scope.nextOperationStatus, comments, employees, $scope.nextEmployeeStatus, $scope.incidences, $scope.nextIncidenceStatus);
        }
        //FUNCIONES QUE AVANZAN EL STATUS DE LA NOMINA
        $scope.moveOperation = function (operation, status, comments, employees, employeeStatus, incidences, incidenceStatus, createIncidences, moveBack) {
            $rootScope.loadingProgress = true;
            $log.debug(moveBack ? 'moveBackOperation Called' : 'moveOperation Called');
            var moveOperationPromise = moveOperation(operation, status, comments, employees, employeeStatus, incidences, incidenceStatus, createIncidences, moveBack);
            moveOperationPromise.then(function (resp) {
                setOperationVariables();
                $log.debug(resp, "move Operation Result");
                successAlertS('Status de Operación actualizada a ' + operationStatusNameFilter(status));
                sendOperationNotification(operation, status, moveBack, 'ordinary', operationStatusNameFilter(status), $scope.allEmployees, comments).then(function () { });
                $rootScope.loadingProgress = false;
            }).catch(function (error) {
                if (typeof (error) == "string") {
                    errAlertS(error);
                }
                $log.error(error);
                $rootScope.loadingProgress = false;
            });
        }
        function getThisPeriodIncidences(item) {
            return item.period == this;
        }
        function checkPendingIncidences(operation) {
            // console.log("checkPendingIncidences called");
            return new Promise(function (resolve, reject) {
                // console.log([].concat($scope.unfilteredIncidences));
                var unconfirmed = $firebaseArray(root.child($scope.incidencesRef).orderByChild('status').equalTo(-1));
                unconfirmed.$loaded().then(function () {
                    // console.log(unconfirmed);
                    var pendingIncidences = unconfirmed.filter(getThisPeriodIncidences, $scope.periodNumber);
                    if (pendingIncidences.length > 0) {
                        reject("Existen " + pendingIncidences.length + " incidencia(s) pendientes por confirmar en este periodo por favor confirme o rechaze estas incidencias");
                    } else {
                        resolve(true);
                    }
                }).catch(reject);
            })
        }

        function closeOperation(operation) {
            $rootScope.loadingProgress = true;
            checkPendingIncidences(operation).then(function () {
                $rootScope.loadingProgress = false;
                stopWatchers();
                var dispersion = $filter('constructDispersionObject')(operation, $scope.allEmployees, $scope.fiscalEmployees, $scope.payroll, $scope.paymentSchema, $scope.incidences);
                console.log("about to set disperison")
                setDispersion(dispersion).then(function (dispersionId) {
                    console.log("dispersion setted");
                    delete operation.oldDataOperation;
                    //console.log(dispersionId)
                    console.log("about to move operation");
                    moveOperation(operation, $scope.nextOperationStatus, "", $scope.allEmployees, $scope.nextEmployeeStatus, $scope.allIncidences, $scope.nextOperationStatus, ["constant", "rejected"], undefined, dispersionId).then(function () {
                        console.log("operation moved");
                        successAlertS('Status de Operación actualizada a ' + operationStatusNameFilter(operation.status));
                        loadOperationVariables();
                        console.log($filter("clearObject")(operation))
                        operation.periodData = $scope.operationData;
                        sendOperationNotification(operation, $scope.nextOperationStatus, false, 'ordinary', operationStatusNameFilter($scope.nextOperationStatus), $scope.allEmployees, comments).then(function () { });
                        $rootScope.loadingProgress = false;
                    }).catch(function (error) {
                        $log.error(error);
                        errAlertS(error);
                        $rootScope.loadingProgress = false;
                    });
                }).catch(function (error) {
                    $log.error(error);
                    errAlertS(error);
                    $rootScope.loadingProgress = false;
                })
            }).catch(function (error) {
                $rootScope.loadingProgress = false;
                errAlertS(error);
            })

        }

        function reOpenClosed() {
            $log.debug("openClosedOperation called");
            stopWatchers();
            $rootScope.loadingProgress = true;
            var oldOperationDataId = $scope.operation.dispersion;
            var oldOperationData = {
                operation: $filter('clearObject')($scope.operation),
                dispersion: $filter('clearObject')($scope.dispersionObj)
            }
            root.child($scope.oldOperationDataRef).child(oldOperationDataId).update(oldOperationData).then(function () {
                root.child($scope.dispersionsRef).child($scope.operation.dispersion).set(null).then(function () {
                    $scope.operation.oldDataOperation = oldOperationDataId;
                    delete $scope.operation.dispersion;
                    delete $scope.dispersionObj;
                    $scope.dispersion = false;
                    moveOperation($scope.operation, 2.5, '', $scope.allEmployees, 2, $scope.incidences, 2, undefined, true).then(function () {
                        setHideNotSelect();
                        sendOperationNotification($scope.operation, 2.5, true, 'ordinary', operationStatusNameFilter(2.5)).then(function () { });
                        loadOperationVariables();
                        successAlertS("Se reabrió la operación con exito");
                        $rootScope.loadingProgress = false;
                    }).catch(function (error) {
                        $log.error(error);
                        errAlertS("Error al regresar la operación");
                        startWatchers()
                        $rootScope.loadingProgress = false;
                    })
                }).catch(function (error) {
                    $log.error(error);
                    errAlertS("Error al eliminar los datos de la dispersion");
                    startWatchers()
                    $rootScope.loadingProgress = false;
                });
            }).catch(function (error) {
                $log.error(error);
                errAlertS("Error al guardar los datos actuales");
                startWatchers()
                $rootScope.loadingProgress = false;
            })
        }

        function cancelReopenOperation() {
            $log.debug("cancelReopenOperation called");
            $rootScope.loadingProgress = true;
            stopWatchers();
            var oldOperationDataId = $scope.operation.oldDataOperation;
            //$log.debug(oldOperationDataId);
            root.child($scope.oldOperationDataRef).child(oldOperationDataId).once('value', function (snap) {
                if (snap.exists()) {
                    var data = snap.val();
                    var operation = data.operation;
                    var dispersion = data.dispersion;
                    //delete $scope.operation.oldDataOperation;
                    operation.dispersion = oldOperationDataId;
                    var updates = [];
                    updates.push(root.child($scope.operationsRef).child($scope.operation.$id).set(operation));
                    updates.push(root.child($scope.dispersionsRef).child(oldOperationDataId).set(dispersion));
                    updates.push(root.child($scope.oldOperationDataRef).child(oldOperationDataId).set(null));
                    updates.push(getUpdatesIncidences($scope.allEmployees, $scope.allIncidences, 3, undefined, true));
                    Promise.all(updates).then(function () {
                        setOperationVariables();
                        loadDispersion().then(function () {
                            setHideNotSelect();
                            $log.debug($scope.dispersion, $scope.dispersionObj);
                            $scope.$emit('dataLoaded');
                            successAlertS('Se revirtieron los cambios correctamente');
                            startWatchers();
                            $rootScope.loadingProgress = false;
                        });
                        sendOperationNotification($scope.operation, $scope.operation.status, false, 'ordinary', operationStatusNameFilter($scope.operation.status))
                    }).catch(function (error) {
                        $log.error(error);
                        errAlertS('Error al revertir los cambios');
                        startWatchers();
                        $rootScope.loadingProgress = false;
                    })
                } else {
                    $log.error('No existe la información con el id proporcionada');
                    errAlertS('Error al obtener los datos antiguos de la operación')
                    startWatchers();
                    $rootScope.loadingProgress = false;
                }
            }).catch(function (error) {
                $log.error(error);
                errAlertS('Error al intentar obtener los datos antiguos de la operación');
                startWatchers();
                $rootScope.loadingProgress = false;
            })
        }

        $scope.sendToReviewModal = function (ev, employees, operation) {
            $log.debug('sendToReviewModal', employees, operation);
            $scope.comments = '';
            // first show warning
            $mdDialog.show({
                controller: 'DialogCtrl',
                locals: {
                    predefinedValue: undefined
                },
                templateUrl: 'app/main/clients/views/operation/dialogs/send-to-review.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                fullscreen: true
            });
        }
        //POR IMPLEMENTAR
        $scope.uploadPaymentModal = function (ev) {
            //$log.debug('uploadPaymentModal', $scope.dispersion, $scope.operation);
            $scope.comments = '';

            $mdDialog.show({
                controller: 'DialogCtrl',
                locals: {
                    predefinedValue: undefined
                },
                templateUrl: 'app/main/clients/views/operation/dialogs/upload-payment.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                fullscreen: true
            });
        }
        $scope.viewPaymentModal = function (ev) {
            //$log.debug('viewPaymentModal', $scope.dispersion, $scope.operation);
            $scope.comments = '';
            $mdDialog.show({
                controller: 'DialogCtrl',
                locals: {
                    predefinedValue: undefined
                },
                templateUrl: 'app/main/clients/views/operation/dialogs/view-payment.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                fullscreen: true
            });
        }
        $scope.reviewModal = function (ev) {
            //$log.debug('reviewModal', $scope.dispersion, $scope.operation);
            $scope.comments = '';
            $mdDialog.show({
                controller: 'DialogCtrl',
                locals: {
                    predefinedValue: undefined
                },
                templateUrl: 'app/main/clients/views/operation/dialogs/review.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                fullscreen: true
            });
        }
        $scope.viewPreBillModal = function (ev) {
            //$log.debug('viewPreBillModal');
            $scope.comments = '';
            $mdDialog.show({
                controller: 'DialogCtrl',
                locals: {
                    predefinedValue: undefined
                },
                templateUrl: 'app/main/clients/views/operation/dialogs/view-prebill.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                fullscreen: true
            });
        }
        $scope.askPaymentConfirmationModal = function (ev) {
            //$log.debug('askPaymentConfirmationModal');
            $scope.comments = '';
            $mdDialog.show({
                controller: 'DialogCtrl',
                locals: {
                    predefinedValue: undefined
                },
                templateUrl: 'app/main/clients/views/operation/dialogs/ask-payment-confirmation.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                fullscreen: true
            });
        }
        $scope.authorizePreBill = function (operation, comments) {
            //$log.debug('authorizePreBill', operation, comments);
            $rootScope.loadingProgress = true;
            if (!operation.authorized) operation.authorized = $scope.D.getTimeObject();
            operation.authorized.comments = comments;
            $scope.moveOperationOLD(operation, 4, 1).then(function () {
                $scope.sendOperationNotification(operation, 4, 0, 'ordinary', operationStatusNameFilter(status)).then(function () {
                    successAlertS('Pre-factura Aprobada, favor de efectuar el pago y subir el comprobante');
                });
            }, errAlertS).then(function () {
                $rootScope.loadingProgress = false;
                $scope.$evalAsync(function () {
                    //$log.debug('error autorizando operación');
                });
            });
        }
        $scope.keepCalculating = function (flag) {
            if (!flag) {
                $scope.$emit('dataLoaded', true);
            }
        }

        function getEmployeeIndex(item) {
            return item.$id == this;
        }
        //Observes and watchers
        var startWatchers = function (ignoreFirst) {
            if ($scope.operation.status < $scope.opStatusNotCalc) {
                if (!$scope.observersLoaded) {
                    $log.debug("observers loaded");
                    $scope.observersLoaded = true;
                    var firstLoaded = {
                        incidences: ignoreFirst,
                        constants: ignoreFirst,
                        unfilteredIncidences: ignoreFirst,
                        employeesSdr: ignoreFirst
                    };
                    $log.debug($scope.observersLoaded, "about to load watcher");
                    //SECCION DE OBSERVADORES
                    listeners.unfilteredIncidences = $scope.$watch('unfilteredIncidences', function (unfilteredIncidences) {
                        if (unfilteredIncidences) {
                            if (firstLoaded.unfilteredIncidences) {
                                firstLoaded.unfilteredIncidences = false;
                            } else {
                                $scope.unfilteredIncidences.$loaded().then(function (incidences) {
                                    if ($scope.operation.status >= $scope.opStatusNotCalc) {
                                        $scope.incidences = $filter('getAppliedIncidences')(incidences);
                                    } else {
                                        $scope.incidences = $filter('getIncidencesOfThisPeriod')(incidences, $scope.period.period);
                                    }

                                });
                            }
                        }
                    }, true);

                    listeners.employeesSdr = $scope.$watch(function () {
                        var a = "";
                        //data,value,status
                        for (var i in $scope.L.operationEmployees) {
                            var salary = "0";
                            var thisEmployee = $scope.L.operationEmployees[i];
                            if (typeof (thisEmployee) == "object" && typeof (thisEmployee.data) == "object" && typeof (thisEmployee.data.salary) == "object" && typeof (thisEmployee.data.salary.sdr) !== "undefined") {
                                salary = "" + thisEmployee.data.salary.sdr;
                            }
                            a = a + salary;
                        }
                        return a;
                    }, function (salaries) {
                        console.log(salaries);
                        if (firstLoaded.employeesSdr) {
                            firstLoaded.employeesSdr = false;
                        } else {
                            var somethingChange = false;
                            for (var i in $scope.L.operationEmployees) {
                                var thisEmployee = $scope.L.operationEmployees[i];
                                var index = $scope.employeesF.findIndex(getEmployeeIndex, thisEmployee.$id);
                                console.log(index, thisEmployee.$id);
                                if (index > -1) {
                                    somethingChange = true;
                                    $scope.employeesF[index].data.salary.sdr = thisEmployee.data.salary.sdr;
                                }
                            }
                            if (somethingChange) {
                                $log.debug("Change in employees salaries");
                                $scope.$emit('dataLoaded');
                            }
                        }
                    });
                    listeners.incidencesCol = $scope.$watch(function () {
                        var a = "";
                        //data,value,status
                        for (var i = 0; i < $scope.incidences.length; i++) {
                            a = a + $scope.incidences[i].status;
                            a = a + $scope.incidences[i].value;
                            a = a + $scope.incidences[i].date;
                            //status,value,date
                        }
                        return a;
                    }, function (incidences, oldIncidences) {
                        if (firstLoaded.incidences) {
                            firstLoaded.incidences = false;
                        } else {
                            $log.debug("Change in incidences collection");
                            $scope.$emit('dataLoaded');
                        }

                    });
                    // listeners.incidencesArr = $scope.$watch('incidences', function(incidences, oldIncidences) {
                    //     if (incidences) {
                    //         if (firstLoaded.incidences) {
                    //             firstLoaded.incidences = false;
                    //         } else {
                    //             console.log(JSON.stringify(incidences));
                    //             console.log(JSON.stringify(oldIncidences));
                    //             $log.debug("Change in incidences array");
                    //             $scope.$emit('dataLoaded');
                    //         }
                    //     }
                    // });
                    listeners.constants = $scope.$watch('F.constants', function (constants) {
                        if (constants) {
                            if (firstLoaded.constants) {
                                firstLoaded.constants = false;
                            } else {
                                $log.debug("Change in constants");
                                $scope.$emit('dataLoaded');
                            }
                        }
                    }, true);
                    listeners.dispersionObj = $scope.$watch('dispersionObj', function (dispersionObj) {
                        if (dispersionObj) {
                            $scope.dispersion = transformDispersionObj(dispersionObj);
                        }
                    });
                    listeners.operationStatus = $scope.$watch('operation.status', function (status) {
                        if (status) {
                            setHideNotSelect();
                        }
                        setOperationVariables();
                        if (status >= $scope.opStatusNotCalc) {
                            stopWatchers();
                            loadOperationVariables();
                        }
                    });
                    listeners.credits = $scope.$watch('F.creditsData', function (newCredits, oldCredits) {
                        if (newCredits !== oldCredits) {
                            $log.debug("Change in credits");
                            for (var e in $scope.employeesF) {
                                $scope.employeesF[e].credit = AppF.creditsData[$scope.employeesF[e].$id];
                                $scope.$evalAsync(function () { });
                            }
                            $scope.$emit('dataLoaded');
                        }
                    }, true);

                    listeners.operationEmployees = $scope.$watch('operation.employees', function (status) {
                        setOperationVariables();
                    }, true);

                    listeners.final = $scope.$on('$destroy', function () {
                        stopWatchers();
                    })
                    startListenenLastMovements();
                }
            } else {
                if (!$scope.statusListener) {
                    $log.debug("status observer loaded")
                    $scope.statusListener = true;
                    listeners.operationStatus = $scope.$watch('operation.status', function (status) {
                        if (status < $scope.opStatusNotCalc) {
                            listeners.operationStatus();
                            delete listeners.operationStatus;
                            delete $scope.statusListener;
                            delete AppF.fixIncidences.rejectedIncidences
                            loadOperationVariables();
                        }
                    });
                }
            }
        }
        var stopWatchers = function () {
            for (var l in listeners) {
                listeners[l]();
                delete listeners[l];
                $log.debug('stoping watcher', l);
            }
            movementsRef.off();
            $scope.observersLoaded = false;
        }
        var startListenenLastMovements = function () {
            var firstIgnored = false;
            movementsRef.limitToLast(1).on('child_added', function (snapshot) {
                if (firstIgnored) {
                    validateMovement(snapshot, snapshot.key);
                } else {
                    firstIgnored = true;
                }
            })
            movementsRef.orderByChild("payroll").equalTo($scope.payrollId).on('child_changed', function (snapshot) {
                validateMovement(snapshot, snapshot.key);
            })
        }
        var initDirectiveFunctions = function (loading) {
            //$log.debug("initDirectiveFunctions called");
            if (!AppF.firstCalculationExecuted) {
                $rootScope.loadingProgress = true;
                AppF.firstCalculationExecuted = true;
                mainFn.tryToFirstCalculations();
            } else if (AppF.firstCalculationFinished) {
                mainFn.checkForChangesInDirectives(undefined, loading);
                startWatchers(true);
            }
        }

        var thisIsBeacuseBalance;
        var thisProcess;
        mainFn.checkForChangesInDirectives = function (employeeIdP, loading) {
            $log.debug("checkForChangesInDirectives called", employeeIdP, loading);
            var prioritysProcess = ["FISCAL", "REAL"];
            if (loading) {
                $rootScope.loadingProgress = true;
            }
            if (!$scope.calculating && !$scope.checking) {
                $scope.checking = true;
                var directiveStatus = [];
                if (employeeIdP) {
                    for (var directiveId in $scope.directiveFunctions.directiveWatcher[employeeIdP]) {
                        var need = $scope.directiveFunctions.directiveWatcher[employeeIdP][directiveId]();
                        var obj = {
                            directiveId: directiveId,
                            employeeId: employeeIdP,
                            place: need.place,
                            process: prioritysProcess.indexOf(need.directiveProcces),
                            isBecauseBalance: need.isBecauseBalance,
                            needRecalculate: need.flag,
                            need: need
                        }
                        if (obj.needRecalculate) {
                            directiveStatus.push(obj);
                        }
                    }
                } else {
                    for (var employeeId in $scope.directiveFunctions.directiveWatcher) {
                        for (var directiveId in $scope.directiveFunctions.directiveWatcher[employeeId]) {
                            var need = $scope.directiveFunctions.directiveWatcher[employeeId][directiveId]();
                            var obj = {
                                directiveId: directiveId,
                                employeeId: employeeId,
                                place: need.place,
                                process: prioritysProcess.indexOf(need.directiveProcces),
                                isBecauseBalance: need.isBecauseBalance,
                                needRecalculate: need.flag,
                                need: need
                            }
                            if (obj.needRecalculate) {
                                directiveStatus.push(obj);
                            }
                        }
                    }
                }
                directiveStatus = $filter("orderBy")(directiveStatus, ["isBecauseBalance", "-process"]);
                var tempDirectiveStatus = [];
                if (typeof (thisProcess) != "undefined") {
                    var realCalculations = $filter("filter")(directiveStatus, {
                        process: prioritysProcess.indexOf("REAL")
                    }, true);
                    //console.log("realCalculations", prioritysProcess.indexOf("REAL"), realCalculations.length);
                    if (realCalculations.length > 0) {
                        //console.log("Doing real calculations first")
                        thisIsBeacuseBalance = undefined;
                        thisProcess = undefined;
                    } else {
                        //console.log("Not real calculations found")
                        var founded = $filter("filter")(directiveStatus, {
                            process: thisProcess
                        });
                        //console.log("records of", thisProcess, "founded:", founded.length)
                        if (founded.length) {
                            thisProcess = founded[0].process;
                            thisIsBeacuseBalance = founded[0].isBecauseBalance;
                        } else {
                            thisIsBeacuseBalance = undefined;
                            thisProcess = undefined;
                        }
                    }
                }
                for (var a = 0; a < directiveStatus.length; a++) {
                    if (typeof (thisProcess) == "undefined") {
                        thisIsBeacuseBalance = directiveStatus[a].isBecauseBalance;
                        thisProcess = directiveStatus[a].process;
                    }
                    if (directiveStatus[a].isBecauseBalance == thisIsBeacuseBalance && thisProcess == directiveStatus[a].process) {
                        tempDirectiveStatus.push(directiveStatus[a])
                    }
                }
                // if (typeof(thisProcess) !== "undefined") {
                //     $log.debug("Calculating  proccess", prioritysProcess[thisProcess], "becauseBalance", thisIsBeacuseBalance);
                // }
                directiveStatus = tempDirectiveStatus;
                //$log.debug(directiveStatus);
                if (directiveStatus && directiveStatus.length) {
                    //console.log(directiveStatus);
                    AppF.balanceIncidenceMap = $filter("getBalanceIncidencesMap")(AppF.balancedIncidences, AppF.priorityMap, AppF.balanceIncidenceMap, AppF.tempBalancedIncidences);
                    //console.log(JSON.parse(JSON.stringify(AppF.balanceIncidenceMap)), JSON.parse(JSON.stringify(AppF.priorityMap)));
                    $log.debug("Changes detected directiveListeners");
                    var allBelongToTheSameEmployee = true;
                    var firstEmployeeId;
                    directiveStatus = $filter('orderBy')(directiveStatus, 'place');
                    var pendingCalculations = [];
                    for (var i = 0; i < directiveStatus.length; i++) {
                        var thisDirective = directiveStatus[i];
                        if (thisDirective.needRecalculate) {
                            var pending = {
                                directiveId: thisDirective.directiveId,
                                employeeId: thisDirective.employeeId,
                                isBecauseBalance: thisDirective.isBecauseBalance
                            }
                            pendingCalculations.push(pending);
                            if (typeof (firstEmployeeId) === "undefined") {
                                firstEmployeeId = thisDirective.employeeId;
                            }
                            if (firstEmployeeId !== thisDirective.employeeId) {
                                allBelongToTheSameEmployee = false;
                            }
                        }
                    }
                    var thisEmployeeId;
                    if (allBelongToTheSameEmployee) {
                        thisEmployeeId = firstEmployeeId;
                    }
                    $scope.executeCalculations.callback = "checkForChangesInDirectives";
                    $scope.executeCalculations.params = [thisEmployeeId, loading];
                    $scope.executeCalculations.pending = pendingCalculations;
                    $scope.checking = false;
                } else {
                    $scope.checking = false;
                    if (employeeIdP) {
                        mainFn.checkForChangesInDirectives(undefined, loading);
                    } else if (!$scope.readyToBalance) {
                        $log.debug("Setting ready to balance")
                        $scope.readyToBalance = true;
                        $timeout(function () {
                            mainFn.checkForChangesInDirectives(undefined, loading);
                        })
                    } else {
                        console.timeEnd("tiempo de carga de los primeros calculos");
                        startWatchers(true);
                        $rootScope.loadingProgress = false;
                    }
                }
            }
        };

        function getActiveDirectiveMap(normalIncidencesByType, fastIncidencesByType) {
            var tempActiveDirectiveMap = {};
            for (var incidenceId in fastIncidencesByType) {
                if (typeof (tempActiveDirectiveMap[incidenceId]) == "undefined") tempActiveDirectiveMap[incidenceId] = {};
                for (var employeeId in fastIncidencesByType[incidenceId]) {
                    if (typeof (tempActiveDirectiveMap[incidenceId][employeeId]) == "undefined") tempActiveDirectiveMap[incidenceId][employeeId] = {};
                    tempActiveDirectiveMap[incidenceId][employeeId].active = "none";
                    if (fastIncidencesByType[incidenceId][employeeId].value) tempActiveDirectiveMap[incidenceId][employeeId].active = "fast";
                }
            }
            for (var incidenceId in normalIncidencesByType) {
                if (typeof (tempActiveDirectiveMap[incidenceId]) == "undefined") tempActiveDirectiveMap[incidenceId] = {};
                for (var employeeId in normalIncidencesByType[incidenceId]) {
                    if (typeof (tempActiveDirectiveMap[incidenceId][employeeId]) == "undefined") tempActiveDirectiveMap[incidenceId][employeeId] = {};
                    tempActiveDirectiveMap[incidenceId][employeeId].active = tempActiveDirectiveMap[incidenceId][employeeId].active ? tempActiveDirectiveMap[incidenceId][employeeId].active : "none";
                    if (normalIncidencesByType[incidenceId][employeeId].length) tempActiveDirectiveMap[incidenceId][employeeId].active = "normal";
                }
            }
            return tempActiveDirectiveMap;
        }

        //OBSERVADORES PARA CARGAR LOS DATOS TRAS CARGAR LA INFORMACION NECESARIA DE LA SABANA
        $scope.$on('dataLoaded', function (e, loading) {
            console.log("dataloaded called");
            //console.log(loading);
            //$log.debug('dataLoaded emitted and init calculations', $scope.incidences, AppF.constants, $scope.employeesF, $scope.incidencesTypes);
            if ($scope.incidences && $scope.employeesF && $scope.incidencesTypes && !$scope.ignoreChange && !AppF.notCalculate) {
                //$log.debug("About to construct sabana");
                if ($scope.employeesF.length && $scope.paymentSchema.hasOwnProperty('data')) {
                    if (typeof (AppF.allProcesses) == "undefined") {
                        AppF.allProcesses = {};
                        if ($scope.paymentSchema.data.processes.fiscal.active) {
                            AppF.allProcesses.fiscal = true;
                        }
                        if (typeof ($scope.paymentSchema.data.processes.complements) !== "undefined" && typeof ($scope.paymentSchema.data.processes.complements.length) !== "undefined") {
                            for (var i = 0; i < $scope.paymentSchema.data.processes.complements.length; i++) {
                                AppF.allProcesses[$scope.paymentSchema.data.processes.complements[i].name] = $scope.paymentSchema.data.processes.complements[i];
                                if (typeof (AppF.operationDataNeeded[$scope.paymentSchema.data.processes.complements[i].type]) == "undefined") {
                                    AppF.operationDataNeeded[$scope.paymentSchema.data.processes.complements[i].type] = {};
                                }
                            }
                        }
                    }
                    //Se obtienen los empleados que estaran en las diferentes sabanas
                    $scope.realEmployees = $filter("orderBy")($scope.employeesF, $scope.order);
                    $scope.fiscalEmployees = $filter("orderBy")($filter('getFiscalEmployees')($scope.employeesF, $scope.rps, $scope.fiscalEmployees, $scope.operation.status >= $scope.opStatusNotCalc), $scope.order);
                    AppF.fiscalEmployeesIds = $filter("keyObjectAsKey")($scope.fiscalEmployees, "$id", true);
                    //Se obtienen todas las incidencias y se añade la informacion de las incidencias
                    var incidences = $scope.incidences ? JSON.parse(JSON.stringify($scope.incidences)) : [];
                    incidences = getIncidencesFromCredits(getIncidencesFromConstants(incidences));
                    $scope.allIncidences = $filter('completeIncidenceInformation')(incidences, $scope.incidencesTypes, [], false);
                    //Se setean todos los tipos de incidencias y se crea el mapa segun su ID para facil acceso
                    AppF.incidencesTypes = $filter("completeIncidencesTypeInformation")($scope.incidencesTypes, []);
                    AppF.incidenceTypeData = $filter("keyObjectAsKey")(AppF.incidencesTypes, "$id");
                    AppF.satIncidenceTypeData = $filter("keyObjectAsKey")([], "_id");
                    AppF.complementIncidenceTypeData = $filter("keyObjectAsKey")([], "_id");
                    //console.log(AppF.priorityMap);
                    //Se ordenan las incidencias segun lo necesitan las diferentes directivas de calculo de la parte real
                    $scope.perceptions = $filter('perceptionsByEmployee')($scope.allIncidences, $scope.employeesF);
                    $scope.deductions = $filter('deductionsByEmployee')($scope.allIncidences, $scope.employeesF);
                    //
                    $scope.incidencesByType = $filter('incidencesByField')($scope.allIncidences, $scope.employeesF, 'incidenceType', true, 2, 'type', 'fast');
                    //Incidencias Rapias
                    $scope.fastIncidencesByType = $filter('incidencesByField')($scope.allIncidences, $scope.employeesF, 'incidenceType', true, 1, 'type', 'fast', 'object', {
                        'phantomDate': 'dates'
                    });
                    $scope.fastIncidencesByTypeP = $filter("perceptions")($scope.fastIncidencesByType);
                    $scope.fastIncidencesByTypeD = $filter("deductions")($scope.fastIncidencesByType);
                    // console.log($scope.incidencesByType);
                    // console.log($scope.fastIncidencesByType);
                    //Incidencias por tipo
                    $scope.allIncidencesByType = $filter('incidencesByField')($scope.allIncidences, $scope.employeesF, 'incidenceType', true);
                    //Incidencias nomales
                    $scope.normalIncidencesByType = $filter('notDefaultIncidences')($scope.incidencesByType, true);
                    $scope.normalIncidencesByTypeP = $filter("perceptions")($scope.normalIncidencesByType);
                    $scope.normalIncidencesByTypeD = $filter("deductions")($scope.normalIncidencesByType);
                    //Incidencias por empleados
                    AppF.incidencesByEmployee = $filter('incidencesByEmployee')($scope.allIncidences, $scope.employeesF);
                    //Active Directive Map
                    AppF.activeDirectiveMap = getActiveDirectiveMap($scope.normalIncidencesByType, $scope.fastIncidencesByType);
                    //Se establecen las incidencias fiscales por default
                    AppF.paymentSchema = $scope.paymentSchema;
                    AppF.fiscalIncidences = [];
                    AppF.defaultFiscalIncidences = {};
                    var fiscalIncidencesOrdered = $filter("orderBy")($filter("objsToArray")($scope.paymentSchema.data.processes.fiscal.incidences), "order")
                    for (var i = 0; i < fiscalIncidencesOrdered.length; i++) {
                        var fiscalIncidence = fiscalIncidencesOrdered[i];
                        if (fiscalIncidence.active) {
                            if (fiscalIncidence.default) {
                                AppF.defaultFiscalIncidences[fiscalIncidence.$id] = fiscalIncidence;
                            }
                            AppF.fiscalIncidences.push(fiscalIncidence.$id);
                        }
                    }
                    if (typeof ($scope.dispersion) == "object" && typeof (AppF.fixIncidences.fiscal) == "object") {
                        //console.log("ABout to delete default from fixIncidencesFical")
                        for (var satIncidenceType in AppF.fixIncidences.fiscal) {
                            //console.log(satIncidenceType, typeof(AppF.defaultFiscalIncidences[satIncidenceType]), AppF.defaultFiscalIncidences);
                            if (typeof (AppF.defaultFiscalIncidences[satIncidenceType]) !== "undefined") {
                                delete AppF.fixIncidences.fiscal[satIncidenceType];
                            }
                        }
                    }
                    // console.log(AppF.defaultFiscalIncidences, AppF.fiscalIncidences);
                    AppF.defaultFiscalIncidencesP = $filter("perceptions")(AppF.defaultFiscalIncidences);
                    AppF.defaultFiscalIncidencesD = $filter("deductions")(AppF.defaultFiscalIncidences);
                    // console.log(AppF.defaultFiscalIncidencesP, AppF.defaultFiscalIncidencesD);
                    $scope.perceptionsFiscal = $filter('perceptionsByEmployee')($scope.allIncidences, $scope.fiscalEmployees, AppF.fiscalIncidences);
                    $scope.deductionsFiscal = $filter('deductionsByEmployee')($scope.allIncidences, $scope.fiscalEmployees, AppF.fiscalIncidences);
                    // console.log($scope.perceptionsFiscal, $scope.deductionsFiscal);
                    $scope.allFiscalIncidencesByType = $filter('incidencesByField')($scope.allIncidences, $scope.fiscalEmployees, 'incidenceType', true, 1, "incidenceType", AppF.fiscalIncidences);
                    // console.log($scope.allFiscalIncidencesByType);
                    //Se continua con el proceso de calculo de las directivas
                    // // console.log(incidencesNeeded);
                    // for (var key in incidencesNeeded) {
                    //     $scope[key] = incidencesNeeded[key];
                    // }
                    $rootScope.F.operationDataNeeded.REAL.first = true;
                    $scope.operationDataNeeded = true;
                    $rootScope.loadingProgress = false;
                    console.time("tiempo de carga de los primeros calculos");
                    $log.debug("operationDataNeeded setted true");
                    $scope.$$phase || $scope.$apply();
                    $timeout(function () {
                        for (var employee in $scope.realEmployees) {
                            var thisEmployee = $scope.realEmployees[employee];
                            if (typeof (thisEmployee.calculations) !== "undefined" && typeof (thisEmployee.calculations.REAL) !== "undefined") {
                                for (var c in thisEmployee.calculations.REAL) {
                                    var thisCalc = thisEmployee.calculations.REAL[c];
                                    if (typeof (thisCalc) == "undefined") {
                                        delete $scope.realEmployees[employee].calculations.REAL[c];
                                    }
                                }
                            }
                        }
                        $timeout(function () {
                            initDirectiveFunctions(loading);
                        })
                    });
                    $scope.closestLength = AppF.paginations.reduce(function (prev, curr) {
                        return (Math.abs(curr - $scope.employeesF.length) < Math.abs(prev - $scope.employeesF.length) ? curr : prev);
                    });
                }
            }
        });
        //OBSERVADOR INICAL DE DATOS NECESARIO PARA NAVEGACION
        var allLoadedInitiated = $rootScope.$on('allLoaded', function (allLoaded) {
            if (allLoaded && !initiated) {
                init();
                allLoadedInitiated();
            }
        });
        //POR SI SE CARGA Y LOS DATOS YA ESTAN CARGADO
        if (AppF.profile && !initiated) {
            if (AppF.profile.uid) init();
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.clients')
        .controller('IncidencesRequestsController', IncidencesRequestsController);

    function IncidencesRequestsController(
        $scope,
        $rootScope,
        $state,
        $firebaseArray,
        $log,
        $q,
        $mdDialog,
        successAlertS,
        errAlertS,
        confirmConfig
    ) {

        var removeIncidences = function (incidences) {
            return $q(function (resolve, reject) {
                try {
                    var count = 0;
                    var updates = {};
                    var promises = [];
                    angular.forEach(incidences, function (incidence, iKey) {
                        angular.forEach(incidence.incidences, function (employeeIncidence, eKey) {
                            var calendar = employeeIncidence.y || incidence.calendar;
                            var ref = "incidences/" + incidence.payroll + "/" + calendar + "/" + eKey;
                            promises.push($scope.F.root.child(ref).child("status").once("value"));
                            updates[ref] = null;
                        });
                        updates["catalogs/incidencesRequests/collection/" + incidence.$id] = null;
                        //console.log(updates);
                        count++;
                    })
                    Promise.all(promises).then(function (snapshots) {
                        var anyHasApplied = false;
                        for (var i = 0; i < snapshots.length; i++) {
                            var snapshot = snapshots[i];
                            if (snapshot.exists()) {
                                var incidenceStatus = snapshot.val();
                                if (incidenceStatus >= 3) {
                                    anyHasApplied = true;
                                    i = snapshots.length;
                                }
                            }
                        };
                        if (!anyHasApplied) {
                            $scope.F.root.update(updates, function (error) {
                                if (error) {
                                    reject(error);
                                } else {
                                    resolve(count);
                                }
                            })
                        } else {
                            reject("Uno o mas incidencias del request ya fueron aplicados");
                        }
                    }).catch(function (error) {
                        reject(error);
                    });
                } catch (error) {
                    //console.log(error);
                    reject(error);
                }
            });
        }

        $scope.deleteAndRemoveincidencesRequests = function (e) {
            var msg = (!$scope.F.safeDelete.incidence) ?
                'No podrá recuperar sus datos' :
                'Podrá recuperar sus datos en la papelera';
            var title = 'Quiere borrar ' + $scope.selected.length + ' Solicitudes de Incidencias?';

            $mdDialog.show($mdDialog.confirm(confirmConfig)
                .title(title)
                .content(msg)
                .ariaLabel('Deleting')
                .targetEvent(e)
                .ok('Borrar')
                .cancel('Cancelar'))
                .then(function () {
                    var count = 0;
                    $log.debug('Deleting: ', $scope.selected);
                    removeIncidences($scope.selected).then(function (recordsDeleted) {
                        successAlertS('Se borraron ' + recordsDeleted + ' Incidencias');
                        $scope.selected = [];
                    }, function (error) {
                        errAlertS(error);
                    });
                }, function () {
                    $log.debug('Deleting Cancelled');
                });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.clients')
        .controller('IncidencesRequestController', IncidencesRequestController);

    function IncidencesRequestController(
        $scope,
        $rootScope,
        $document,
        $state,
        $firebaseObject,
        $firebaseArray,
        $log,
        successAlertS,
        errAlertS,
        $q,
        clearObjectFilter,
        getCalendarOfDateFilter,
        getPeriodOfDateFilter,
        getActiveEmployeesFilter,
        filterFilter,
        getPeriodDataFilter,
        getEmployeesObjFilter,
        AppF,
        getObjectOfArrayByIdFilter,
        getSomethingOfArrayFBFilter,
        IncidencesF
    ) {
        $scope.employeesChips = [];
        $scope.employeesAction = {};
        $scope.calendars = [];
        $scope.periods = [];
        $scope.incidencesTypes = [];
        $scope.noCalendars = false;

        AppF.minIncidenceRequestDate = undefined;
        AppF.maxIncidenceRequestDate = undefined;

        $scope.getMinDate = function (payroll) {
            if (AppF.addMode) {
                $scope.F.root.child("catalogs/payrollCalendars/" + payroll + "/calendars").orderByChild("data/active").equalTo(true).once("value", function (snap) {
                    if (snap.exists()) {
                        $scope.noCalendars = false;
                        var calendar;
                        snap.forEach(function (childSnapshot) {
                            calendar = childSnapshot.val();
                            calendar.$id = childSnapshot.key;
                        });
                        $log.debug("getMinDate", "calendar Loaded", calendar);
                        console.log("catalogs/operations/ordinary/" + payroll + "/" + calendar.$id + "/collection");
                        $scope.F.root.child("catalogs/operations/ordinary/" + payroll + "/" + calendar.$id + "/collection").orderByChild("status").startAt(1).limitToFirst(1).once("value", function (operationsSnap) {
                            console.log(operationsSnap.val());
                            if (operationsSnap.exists()) {
                                var operation;
                                operationsSnap.forEach(function (operationSnap) {
                                    operation = operationSnap.val();
                                    operation.$id = operation.key;
                                });
                                $log.debug("getMinDate", "operation Loaded", operation);
                                $scope.F.root.child("catalogs/payrollCalendars/" + payroll + "/periods/" + calendar.$id + "/" + operation.period).once("value", function (periodSnap) {
                                    $log.debug("getMinDate", "operation Loaded", periodSnap.exists(), periodSnap.val());
                                    if (periodSnap.exists()) {
                                        var period = periodSnap.val();
                                        var status = AppF.getOperationStatusByEmployees(operation, $rootScope.L.userCcs[AppF.profile.uid]);
                                        var maxStatus = AppF.getMaxEditStatus();
                                        var mind;
                                        if (maxStatus >= status) {
                                            mind = period.start;
                                        } else {
                                            mind = period.end + 1;
                                        }
                                        AppF.minIncidenceRequestDate = moment(mind).startOf('day').toDate();
                                    }
                                });
                            }
                        });
                    } else {
                        errAlertS('No hay calendarios creados para ésta nómina, favor de primero crear uno');
                        $scope.noCalendars = true;
                    }
                });
            }
        }

        var addAllIncidencesForEachEmployee = function (validateFirst) {
            validateFirst = (angular.isUndefined(validateFirst)) ? true : false;
            return new Promise(function (resolve, reject) {
                var promises = [];
                var activeEmployees = angular.copy($scope.activeEmployees);
                angular.forEach(activeEmployees, function (employee) {
                    var miniIncidence = {
                        c: $scope.incidencesRequest.comments ? $scope.incidencesRequest.comments : '',
                        e: employee.$id,
                        it: $scope.incidencesRequest.incidenceType,
                        v: $scope.incidencesRequest.value,
                        add: true,
                        d: $scope.incidencesRequest.date,
                        s: 0
                    };
                    if (validateFirst) {
                        promises.push(checkIfNoRepeatedEmployeeAndType(miniIncidence, 1));
                    } else {
                        promises.push($scope.addIncidence(miniIncidence, 1));
                    }
                });
                $q.all(promises).then(function () {
                    if (validateFirst) {
                        addAllIncidencesForEachEmployee(false).then(resolve(true)).catch(reject);
                    } else {
                        resolve(true);
                    }
                }).catch(reject);
            });
        }

        var createEmployeesIncidences = function (incidenceRequest, incidenceRequestId) {
            return new Promise(function (resolve, reject) {
                try {
                    var ref = 'incidences';
                    var incidenceEmployeeRef = ref + '/' + incidenceRequest.payroll + '/' + incidenceRequest.calendar;
                    var updates = {};
                    angular.forEach(incidenceRequest.incidences, function (incidence, incidenceId) {
                        if (incidence.add) {
                            var object = {
                                request: incidenceRequestId,
                                type: 'request',
                                period: parseInt(incidence.p),
                                date: incidence.d,
                                incidenceType: incidence.it,
                                value: incidence.v,
                                status: (incidenceRequest.status ? incidenceRequest.status : 0),
                                comments: incidence.c ? incidence.c : '',
                                employee: incidence.e,
                                payroll: incidenceRequest.payroll,
                                calendar: parseInt(incidenceRequest.calendar)
                            }
                            if (incidence.update) {
                                object.updated = $scope.D.getTimeObject();
                            } else {
                                object.created = $scope.D.getTimeObject();
                            }
                            object.center = AppF.center;
                            // angular.forEach(object, function(value, key) {
                            //     updates[incidenceEmployeeRef + '/' + incidenceId + '/' + key] = value;
                            // });
                            updates[incidenceEmployeeRef + '/' + incidenceId] = object;
                        }
                        if (incidence.remove) {
                            updates[incidenceEmployeeRef + '/' + incidenceId] = null;
                        }
                    });

                    var thisIncidences = incidenceRequest.incidences;
                    angular.forEach(thisIncidences, function (incidence, index) {
                        if (incidence.remove) {
                            delete incidenceRequest.incidences[index];
                        } else {
                            delete incidence.update;
                            delete incidence.add;

                            incidenceRequest.incidences[index] = clearObjectFilter(incidence);
                        }
                    });
                    resolve(updates);
                } catch (err) {
                    reject(err);
                }
            });
        }

        $scope.addAndCreateEmployeesIncidences = function (incidencesRequest) {
            $log.debug('addAndCreateEmployeesIncidences', incidencesRequest);
            $rootScope.loadingProgress = true;
            incidencesRequest.created = $scope.D.getTimeObject();
            var requestIncidenceId = $scope.F.root.child('catalogs/incidencesRequests/collection').push().key;
            createEmployeesIncidences(incidencesRequest, requestIncidenceId)
                .then(function (updates) {
                    updates['catalogs/incidencesRequests/collection/' + requestIncidenceId] = clearObjectFilter(incidencesRequest);
                    $log.debug('requests about to be made to FB', updates);
                    $scope.F.root.update(updates, function (error) {
                        if (error) {
                            errAlertS(error)
                            $rootScope.loadingProgress = false;
                            $rootScope.$evalAsync();
                        } else {
                            successAlertS('Se creó Solicitud de Incidencias e incidencias con éxito');
                            $rootScope.loadingProgress = false;
                            $rootScope.$evalAsync(function () {
                                $log.debug('addAndCreateEmployeesIncidences finished');
                            });
                            $scope.R.goToList();
                        }
                    });
                }).catch(function (err) {
                    errAlertS(err);
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                });
        }

        $scope.saveAndSetEmployeesIncidences = function (incidencesRequest) {
            $log.debug('saveAndSetEmployeesIncidences', incidencesRequest);
            $rootScope.loadingProgress = true;
            incidencesRequest.employees = getEmployeesObjFilter($scope.employeesChips);
            var requestIncidenceId = incidencesRequest.$id;
            var employeesIncidences = createEmployeesIncidences(incidencesRequest, requestIncidenceId, incidencesRequest.incidences);
            var updates = employeesIncidences.updates;
            incidencesRequest.incidences = employeesIncidences.incidencesInformation;
            updates['catalogs/incidencesRequests/collection/' + requestIncidenceId] = clearObjectFilter(incidencesRequest);
            $scope.F.root.update(updates, function (error) {
                if (error) {
                    errAlertS;
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                } else {
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync(function () {
                        $log.debug('saveAndSetEmployeesIncidences finished');
                    });
                    successAlertS('Se guardo Incidencia con éxito');
                    $scope.R.goToList();
                }
            });
        }

        $scope.getPeriod = function (payrollId, date) {
            if (payrollId && date) {
                $scope.loadCalendars(payrollId, 1).then(function (calendars) {
                    $scope.calendars = calendars;
                    var calendar = getCalendarOfDateFilter(calendars, date);
                    $scope.incidencesRequest.calendar = null;
                    if (calendar.length == 1) {
                        $scope.incidencesRequest.calendar = calendar[0].data.year
                        $scope.loadPeriods(payrollId, $scope.incidencesRequest.calendar, true).then(function (periods) {
                            $scope.periods = periods;
                            var period = getPeriodOfDateFilter($scope.periods, date);
                            $scope.incidencesRequest.period = null;
                            if (period.length == 1) {
                                $scope.incidencesRequest.period = period[0].period;
                                $scope.loadActiveEmployees();
                            }
                        });
                    }
                }, function (err) {
                    errAlertS(err);
                })
            }
        };

        /** Checa que el tipo de incidencia no esté ya en la solicitud si es que afecta dias y devuelbe falso si es para un empleado que ya tiene incidencia en la solicitud */
        var checkIfNoRepeatedEmployeeAndType = function (incidence, prom) {
            $log.debug('checkIfNoRepeatedEmployeeAndType', incidence, $scope.incidencesRequest);
            return new Promise(function (resolve, reject) {
                try {
                    var problem = false;
                    var incidenceAffect = getSomethingOfArrayFBFilter(incidence.it, $scope.incidencesTypes, 'affect');

                    if (incidenceAffect) {
                        // se checa que la incidencia afecte solamene dias activos
                        IncidencesF.checkIfValidActiveDates(incidence, incidenceAffect)
                            .then(function () {
                                for (var i in $scope.incidencesRequest.incidences) {
                                    var mincidenceTypeAffect = getSomethingOfArrayFBFilter(incidence.it, $scope.incidencesTypes, 'affect');
                                    if ($scope.incidencesRequest.incidences[i].it == incidence.it
                                        && $scope.incidencesRequest.incidences[i].e == incidence.e
                                        && !$scope.incidencesRequest.incidences[i].remove
                                        && mincidenceTypeAffect == 'days') {
                                        if (prom) {
                                            reject('Por favor seleccione otro empleado u otro tipo de incidencia. empleado ya tiene una incidencia que afecta días en esta fecha');
                                        } else {
                                            resolve(false);
                                        }
                                        problem = true;
                                        return;
                                    }
                                }
                                // se checa si hay otra incidencia para ese empleado en ese día
                                if (incidenceAffect == 'days') {
                                    var incidenceValue = (incidence.v) ? incidence.v : 1;
                                    var incidenceDate = $scope.incidencesRequest.date + ($scope.F.oneDay * (incidenceValue - 1)); // + x dias
                                    var initOfDay = moment($scope.incidencesRequest.date).startOf('day').valueOf();
                                    var endOfDays = moment(incidenceDate).endOf('day').valueOf();
                                    // console.log(initOfDay, endOfDays, "COOL 2")
                                    $scope.F.root.child('incidences').child($scope.incidencesRequest.payroll).child($scope.incidencesRequest.calendar).orderByChild('date').startAt(initOfDay).endAt(endOfDays).once('value', function (snaps) {
                                        var incidencesOfDay = snaps.val();
                                        if (incidencesOfDay !== null) {
                                            var incidenceTypeAffects = {};
                                            snaps.forEach(function (snap) {
                                                var incidenceOfDay = snap.val();
                                                var iid = snap.key;
                                                incidenceTypeAffects[i] = getSomethingOfArrayFBFilter(incidenceOfDay.incidenceType, $scope.incidencesTypes, 'affect');
                                                // console.log(incidenceTypeAffects[i], incidenceOfDay, incidence, $scope.incidencesTypes, "NICE 2")
                                                if (incidenceOfDay.employee == incidence.e && incidenceTypeAffects[i] == 'days') {
                                                    var employeeName = getSomethingOfArrayFBFilter(incidenceOfDay.employee, $scope.employees, 'data.name');
                                                    // de ser así se borra la fecha y se manda alerta
                                                    $scope.incidencesRequest.date = null;
                                                    var msg = 'El empleado ' + employeeName + ' ya tiene una incidencia que afecta días en esa fecha: ' + moment(incidenceOfDay.date).format('DD/MM/YYYY');
                                                    if (prom) {
                                                        reject(msg);
                                                    } else {
                                                        resolve(msg);
                                                    }
                                                    problem = true;
                                                    return
                                                }
                                            });
                                            if (!problem) { resolve(true); }
                                        } else {
                                            resolve(true);
                                        }
                                    }, function (err) {
                                        if (!prom) errAlertS(err);
                                        reject(err);
                                    });
                                } else {
                                    resolve(true);
                                }
                            }).catch(function (err) {
                                reject(err);
                            });
                    } else {
                        reject('Problema con base de datos, favor de avisar al administrador del sistema');
                    }
                } catch (err) {
                    reject(err);
                }
            });
        }

        var getNewIncidenceId = function () {
            return $scope.F.root.child('incidences').child($scope.incidencesRequest.payroll).child($scope.incidencesRequest.calendar).push().key;
        }

        $scope.addIncidenceForAllPayroll = function () {
            $log.debug('addIncidenceForAllPayroll', {
                activeEmployees: angular.copy($scope.activeEmployees),
                incidencesRequest: angular.copy($scope.incidencesRequest)
            });
            addAllIncidencesForEachEmployee()
                .then(function () {
                    $log.debug('addIncidenceForAllPayroll success', $scope.incidencesRequest);
                }).catch(function (err) {
                    errAlertS(err);
                });
        }

        $scope.addIncidence = function (incidence, prom) {
            $log.debug('addIncidence', incidence, $scope.incidencesRequest);
            return new Promise(function (resolve, reject) {
                checkIfNoRepeatedEmployeeAndType(incidence, prom)
                    .then(function (isValid) {
                        if (isValid === true) {
                            if (!$scope.incidencesRequest.incidences) $scope.incidencesRequest.incidences = {};
                            var incidenceTypeAffect = getSomethingOfArrayFBFilter(incidence.it, $scope.incidencesTypes, 'affect');
                            if (incidenceTypeAffect == 'days' && incidence.v > 1) {
                                for (var x = 0; x < incidence.v; x++) {
                                    var mdateOfIncidence = $scope.incidencesRequest.date + (($scope.F.oneDay) * x); // + x dias
                                    var mperiodOfDate = getPeriodOfDateFilter($scope.periods, mdateOfIncidence);
                                    var mperiodOfIncidence = mperiodOfDate[0].period;
                                    var mcalendarOfIncidence = parseInt(moment(mdateOfIncidence).format('YYYY'));
                                    if (mcalendarOfIncidence == $scope.incidencesRequest.calendar) {
                                        if (mperiodOfDate.length == 1) {
                                            var individualIncidence = {
                                                c: incidence.c ? incidence.c : '',
                                                e: incidence.e,
                                                it: incidence.it,
                                                d: mdateOfIncidence,
                                                s: incidence.s,
                                                p: mperiodOfIncidence,
                                                v: 1,
                                                add: true
                                            };

                                            $scope.incidencesRequest.incidences[getNewIncidenceId()] = individualIncidence;
                                            $scope.$apply();
                                            $log.debug($scope.incidencesRequest.incidences, 'incidencesOf incidencesRequest');

                                            if (x == (incidence.v - 1)) {
                                                resolve(true);
                                            }
                                        } else {
                                            if (!prom) errAlertS('La fecha ' + moment(mdateOfIncidence).format('DD/MM/YYYY') + ' no tiene periodos asignables');
                                            return;
                                        }
                                    } else {
                                        // TODO: checar con el conta si esta logica esta bien o si las debemos poder hacer
                                        if (!prom) errAlertS('Las fechas a cubrir abarcan más de 1 año, favor de hacer una incidencia distinta para fechas de otro año: ' + mcalendarOfIncidence + ' -> ' + moment(mdateOfIncidence).format('DD/MM/YYYY'));
                                        return;
                                    }
                                }
                            } else {
                                incidence.c = incidence.c ? incidence.c : '';
                                incidence.p = $scope.incidencesRequest.period;
                                $scope.incidencesRequest.incidences[getNewIncidenceId()] = incidence;
                                $scope.$apply();
                                $log.debug($scope.incidencesRequest.incidences, 'incidencesOf incidencesRequest');
                                resolve(true);
                            }
                        } else {
                            var err = isValid === false ? 'Por favor seleccione otro empleado u otro tipo de incidencia.' : isValid;
                            if (!prom) errAlertS(err);
                            reject(err);
                        }
                    }).catch(function (err) {
                        if (!prom) errAlertS(err);
                        reject(err);
                    });
            });
        }

        $scope.removeIncidence = function (incidenceId) {
            if ($scope.incidencesRequest.incidences[incidenceId].add) $scope.incidencesRequest.incidences[incidenceId].add = false;
            $scope.incidencesRequest.incidences[incidenceId].remove = true;
        }

        $scope.loadActiveEmployees = function () {
            var period = getObjectOfArrayByIdFilter($scope.incidencesRequest.period, $scope.periods);
            if (period) {
                $scope.C.loadCatalog('employees', false, 'payroll', $scope.incidencesRequest.payroll, 'payrollEmployees').then(function (employees) {
                    $scope.activeEmployees = getActiveEmployeesFilter(employees, period.start, period.end);
                    $log.debug('activeEmployees', {
                        activeEmployees: $scope.activeEmployees,
                        employees: employees
                    })
                }, function (err) {
                    $log.error(err);
                })
            }
        }

        $scope.loadEmployees = function (payrollId) {
            $scope.C.loadCatalog('employees', false, 'payroll', payrollId, 'payrollEmployees').then(function (employees) {
                $scope.employees = employees;
            });
        }

        $scope.loadCalendars = function (payrollId, promise) {
            var rRef = 'catalogs/payrollCalendars/' + payrollId + '/calendars';
            if (promise) return $scope.C.loadCatalog('payrollCalendars', rRef, 0, 0, 0, 'payrollPayrollCalendars');
            $scope.C.loadCatalog('payrollCalendars', rRef, 0, 0, 0, 'payrollPayrollCalendars').then(function (calendars) {
                $scope.calendars = calendars;
            });
        }

        $scope.loadPeriods = function (payrollId, calendarId, promise) {
            var rRef = 'catalogs/payrollCalendars/' + payrollId + '/periods/' + calendarId;
            var promesa = $scope.C.loadCatalog('payrollCalendars', rRef, 0, 0, 0, 'payrollPayrollCalendarsPeriods');
            if (promise) return promesa;
            else {
                promesa.then(function (periods) {
                    $scope.periods = angular.copy(periods);
                });
            }
        }

        $scope.loadIncidencesTypes = function () {
            if (angular.isUndefined($scope.globalIncidences)) $scope.globalIncidences = $firebaseArray(AppF.root.child('catalogs/incidencesTypes/collection').orderByChild('payroll').equalTo('global'))
            $scope.globalIncidences.$loaded(function (globalIncidences) {
                $scope.C.loadCatalog('incidencesTypes', 0, 'payroll', $scope.incidencesRequest.payroll, 0, 'payrollIncidencesTypes').then(function (incidencesTypes) {
                    $scope.incidencesTypes = incidencesTypes.concat(globalIncidences.filter(function (item) {
                        return (item.center && item.center === AppF.center);
                    }));
                });
            })
        }

        /** Se observa la nomina: para setear de nuevo todo si se cambia, se piden los datos relacionados */
        $scope.$watch('incidencesRequest.payroll', function (payrollId) {
            $scope.calendars = null;
            $scope.periods = null;
            $scope.employees = null;
            $scope.incidencesTypes = [];
            if (payrollId) {
                var payrollIsActive = getSomethingOfArrayFBFilter(payrollId, $scope.L.allPayrolls, 'active');
                // $log.debug('payrollIsActive', {
                //     payrollIsActive: payrollIsActive, 
                //     payroll: payrollId, 
                //     list: $scope.L.allPayrolls
                // });
                if (payrollIsActive) {
                    if ($scope.F.addMode) {
                        $scope.incidencesRequest.incidences = {};
                        $scope.incidencesRequest.employees = {};
                        $scope.incidencesRequest.incidenceType = null;
                        $scope.incidencesRequest.date = null;
                        $scope.incidencesRequest.calendar = null;
                        $scope.incidencesRequest.period = null;
                        $scope.employeeSelected = null;
                        $scope.activeEmployees = [];
                    }

                    $scope.F.search.$payroll = payrollId;
                    if ($scope.incidencesRequest.calendar) $scope.loadPeriods(payrollId, $scope.incidencesRequest.calendar);
                    if ($scope.incidencesRequest.date) $scope.getPeriod(payrollId, $scope.incidencesRequest.date);
                    $scope.loadCalendars(payrollId);
                    // $scope.loadProcesses(payrollId);
                    $scope.loadEmployees(payrollId);
                    $scope.loadIncidencesTypes(payrollId);
                    $scope.getMinDate(payrollId);
                } else {
                    if ($scope.F.addMode) {
                        errAlertS('La nómina pre-seleccionada no está activa');
                        $scope.incidencesRequest.payroll = null;
                    }
                }
            }
        });

        $scope.$watch('incidencesRequest.date', function (date) {
            if (date && $scope.incidencesRequest.payroll) $scope.getPeriod($scope.incidencesRequest.payrollId, date);
        });

        $scope.$watch('incidencesRequest.calendar', function (calendar) {
            $scope.periods = null;
            if (calendar && $scope.incidencesRequest.payroll) {
                $scope.F.search.$payrollCalendar = calendar;
                $scope.loadPeriods($scope.incidencesRequest.payroll, calendar);
            }
        });

        // $scope.$watch('incidencesRequest.period', function(period) {
        //     if (period) $scope.loadActiveEmployees();
        // });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.clients')
        .controller('IncidencesController', IncidencesController);

    function IncidencesController(
        $rootScope,
        $scope,
        $firebaseArray,
        $log,
        $q,
        countObjectFilter,
        successAlertS,
        successMsgFilter,
        errAlertS,
        $mdDialog,
        $timeout,
        $filter,
        $document
    ) {
        $scope.listWatchers = {};

        $scope.listWatchers.payrollEmployees = $scope.$watch('F.search.$payroll', function (payrollId) {
            if (payrollId) {
                $scope.L.loadList('employees', 'lists/employees/payroll', payrollId, 'array', 'payrollEmployees');
            }
        });

        $scope.listWatchers.payrollCalendar = $scope.$watch('F.search.$payrollCalendar', function (pc) {
            if (pc && $scope.F.search.$payroll) {
                $scope.periods = $firebaseArray($scope.F.root.child('catalogs/payrollCalendars').child($scope.F.search.$payroll).child('periods').child(pc));
                $scope.periods.$loaded().then(function (periods) {
                    $scope.periods = periods;
                });
            }
        })



        $scope.deleteIncidences = function (e, isFb) {
            var incidences = $scope.selected.slice();
            var requests = [];
            var updates = {};
            var end = false;
            for (var s in incidences) {
                if (incidences[s].status >= 3) {
                    errAlertS('Una o más incidencias seleccionada(s) ya fueron aplicadas por lo que no se puede(n) borrar');
                    end = true;
                }
            }
            if (!end) {
                $rootScope.loadingProgress = true;
                var promise;
                if (isFb) {
                    promise = $scope.delete(e, 1);
                } else {
                    promise = $scope.deleteFb(e, 1);
                }
                promise.then(function () {
                    // por cada incidencia de tipo request se checa las incidencias 'solicitud' y se actualiza el mapa
                    // y se borran las incidencias de confirmación si es que hay
                    angular.forEach(incidences, function (incidence) {
                        if (incidence.type === 'request') {
                            if (requests.indexOf(incidence.request) === -1) {
                                requests.push(incidence.request);
                            }
                            updates['catalogs/incidencesRequests/collection/' + incidence.request + '/incidences/' + incidence.$id] = null;
                        }
                        if (incidence.file && incidence.status < 0) {
                            updates['/temp/confirmIncidences/' + incidence.$id] = null;
                        }
                        updates['incidences/' + incidence.payroll + '/' + incidence.calendar + '/' + incidence.$id] = null;
                    });
                    return $scope.F.root.update(updates);
                }).then(function () {
                    var queries = {};
                    angular.forEach(requests, function (request) {
                        queries[request] = $scope.F.root.child('catalogs/incidencesRequests/collection/' + request).once('value');
                    });
                    return $q.all(queries);
                }).then(function (resp) {
                    var updates = {};
                    angular.forEach(resp, function (incidencesRequest, id) {
                        if (incidencesRequest.exists() && !countObjectFilter(incidencesRequest.val().incidences)) {
                            updates[id] = null;
                        }
                    });
                    $scope.F.root.child('catalogs/incidencesRequests/collection').update(updates);
                }).then(function () {
                    return new Promise(function (resolve) {
                        $timeout(function () {
                            resolve($scope.getThem());
                        }, 4000, false);
                    });
                }).catch(function (error) {
                    errAlertS(error);
                }).then(function () {
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync(function () {
                        $timeout(function () {
                            $log.debug('deleteIncidences finished');
                        }, 0, false);
                    });
                });
            }
        };

        $scope.listWatchers.finalListener = $scope.$on("$destroy", function () {
            for (var f in $scope.listWatchers) {
                //$log.debug('stopping $watcher', f);
                $scope.listWatchers[f]();
            }
            //stopDetailWatchersEvent();
        });
        $scope.importIncidenceGeo = function (ev) {
            $mdDialog.show({
                templateUrl: 'app/main/clients/views/incidences/dialogs/import-incidences-geo.html',
                controller: 'IncidenceImportsGeoController',
                controllerAs: 'impIncGeoCtrl',
                parent: angular.element($document.body),
                targetEvent: ev,
                escapeToClose: false
            });
        }
        $scope.importIncidencesModal = function (ev) {
            $mdDialog.show({
                controller: function (scope, DataF, AppF, ListsF) {
                    scope.L = ListsF;
                    scope.F = AppF;
                    scope.pagination = {
                        limit: 10,
                        limitOption: [5, 10, 50],
                        page: 1
                    }
                    scope.loading = false;
                    scope.filesArray = [];
                    scope.close = function () {
                        $mdDialog.hide();
                    }
                    scope.applyIncidences = function () {
                        scope.loading = true;
                        scope.$evalAsync();
                        $timeout(function () {
                            var operationData;
                            if (scope.operationType === 'ptuDistributionRecord') {
                                operationData = scope.operations.find(function (item) {
                                    return item.fid === scope.operationId;
                                });
                            }
                            $filter('applyIncidences')(scope.data, scope.operationType, scope.operationId, operationData).then(function () {
                                successAlertS("Se aplicaron las incidencias con éxito");
                                $mdDialog.hide();
                            }).catch(errAlertS).then(function () {
                                scope.loading = false;
                                scope.$evalAsync();
                                $timeout(function () { }, 0, false);
                            });
                        }, 0, false);
                    }
                    scope.getOperations = function (operationType, payroll) {
                        scope.operations = [];
                        if (operationType) {
                            $rootScope.loadingProgress = true;
                            var params = {
                                page: 0.5,
                                size: 0.5,
                                operationType: operationType,
                                payroll: payroll,
                                status: { $lt: 3 }
                            };
                            $rootScope.D.api.get('p/operations', params).then(function (resp) {
                                scope.operations = $filter('getFromObject')(resp, 'data.data', []);
                            }).catch(errAlertS).then(function () {
                                $rootScope.loadingProgress = false;
                                $rootScope.$evalAsync();
                            });
                        }
                    }
                    function getAllValid(records) {
                        var count = 0;
                        angular.forEach(records, function (rec) {
                            if (rec.errors.length === 0) {
                                count++;
                            }
                        });
                        return count;
                    }
                    scope.uploadCsv = function (files, payroll, operationType, operationId) {
                        if (angular.isArray(files) && files.length > 0) {
                            scope.loading = true;
                            $timeout(function () {
                                var formData = new FormData();
                                $scope.F.loadingFile = true;
                                formData.append('file', files[0].lfFile);
                                $log.debug(formData, 'formData to be uploaded');
                                scope.operationType = operationType;
                                scope.operationId = operationId;
                                DataF.files.csvToJson(formData).then(function (data) {
                                    scope.MsStepper.gotoNextStep()
                                    scope.data = $filter('formatIncidencesToImport')(data.data, payroll, operationType);
                                    if(scope.data.length === 0){
                                        errAlertS('El archivo no contiene datos o el formato no es correcto');
                                        scope.loading = false;
                                        scope.$evalAsync();
                                        return;
                                    }
                                    $log.log('scope.data',scope.data)
                                    return $filter('validateIncidences')(scope.data, operationType, payroll)
                                }).then(function (data) {
                                    scope.data = data;
                                    scope.hasAnyValid = getAllValid(data) > 0;
                                    scope.loading = false;
                                    scope.$evalAsync();
                                    scope.secondStep = true;
                                    $timeout(function () {
                                    }, 0, false)
                                }).catch(function (error) {
                                    errAlertS(error);
                                    scope.loading = false;
                                });
                            }, 0, false);
                        }

                    };
                },
                templateUrl: 'app/main/clients/views/incidences/dialogs/import-incidences.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: false
            }).then(function (answer) {
                $log.debug(answer, 'importVariablesModal answer');
            }, function () {
                $log.debug('importVariablesModal cancelled');
            });
        };

    }
})();
(function () {
    'use strict';
    angular
        .module('app.employees')
        .controller('IncidenceImportsGeoController', IncidenceImportsGeoController);

    function IncidenceImportsGeoController($mdDialog, $scope, $q, $rootScope, errAlertS, DataF, AppF, ListsF, CalendarF, getEmployeesOfPeriodFilter, successAlertS, $log, $filter, IncidencesF, $timeout) {
        var vm = this;
        $scope.L = ListsF;
        $scope.F = AppF;
        $scope.C = CalendarF
        var yearCalendar;
        var concepts = [];
        var conceptsByKey = {};
        var employees = [];
        var geoIncidences = [];
        var valDaysConceptsIds = [];
        vm.periodData;
        vm.loading = false;
        vm.geoRecords = [];
        vm.sizeModal = 'nogrow';

        // ---------------------------- FUNCIÓN PARA OBTENER TODOS LOS DATOS PARA LA CONSULTA DE LA API GEO VICTORIA --------------------------------
        function getGeoRecords(payroll) {
            return new Promise(function (resolve, reject) {
                vm.geoRecords = [];
                var params = { 'payroll': payroll }
                $rootScope.D.api.get('geoRecords', params).then(function (resp) {
                    vm.geoRecords = resp.data.sort(function (a, b) {
                        return b.endDate - a.endDate;
                    });
                    var data = vm.geoRecords[0];
                    if (angular.isDefined(data)) {
                        vm.initConsulta = moment(data.endDate).add(1, 'days').valueOf();
                        vm.canChangeInitDate = false;
                    } else if (angular.isUndefined(data)) {
                        vm.initConsulta = moment(vm.initDate).valueOf();
                        vm.canChangeInitDate = true;
                    }
                    vm.updateEndConsulta(vm.initConsulta);
                    resolve(vm.geoRecords);
                }).catch(reject)
            })

        }
        function getPeriods(payroll) {
            return new Promise(function (resolve, reject) {
                $scope.F.root.child("/catalogs/payrollCalendars/" + payroll + "/calendars").orderByChild('data/active').equalTo(true).once('value').then(function (snap) {
                    if (!snap.exists()) {
                        throw new Error('Esta nómina no tiene calendario activo⚠️');
                    }
                    for (var dateCalendar in snap.val()) {
                        yearCalendar = dateCalendar;
                    }
                    if (angular.isUndefined(yearCalendar)) {
                        throw new Error('No tiene calendario activo esta nómina ⚠️')
                    }
                    return $scope.F.root.child("/catalogs/operations/ordinary/" + payroll + "/" + yearCalendar + "/collection/").orderByChild('status').startAt(1).endAt(2.9).once('value');
                }).then(function (snap) {
                    var operations = [];
                    snap.forEach(function (childSnap) {
                        operations.push(childSnap.val());
                    })
                    operations = operations.sort(function (a, b) {
                        return a.period - b.period;
                    })
                    vm.currentOperation = operations.shift();
                    return $scope.F.root.child("/catalogs/payrollCalendars/" + payroll + "/periods/" + yearCalendar + "/" + vm.currentOperation.period).once('value');
                }).then(function (snap) {
                    vm.periodData = snap.val();
                    // Fechas verdaderas de los calendarios.
                    vm.initDate = vm.periodData.start;
                    vm.endDate = vm.periodData.end;
                    vm.diffDate = moment(vm.endDate).diff(vm.initDate, 'days');
                    resolve(true);
                }).catch(reject);
            })
        }

        function getConcepts(payroll) {
            return new Promise(function (resolve, reject) {
                var query = {
                    $or: angular.toJson([
                        { idGeo: { $exists: true } },
                        { validateDays: true }
                    ]),
                    center: AppF.center,
                    payroll: angular.toJson({ $in: ['global', payroll] }),
                    project: { fid: 1, id_human: 1, inputType: 1, key: 1, name: 1, nature: 1, validateDays: 1, idGeo: 1, geoDateNotAssign: 1, isIncapacity: 1 }
                };
                $rootScope.D.api.get('concepts', query).then(function (resp) {
                    var thisConcepts = [];
                    var thisValDaysConceptsIds = [];
                    if (angular.isArray(resp.data)) {
                        for (var r = 0; r < resp.data.length; r++) {
                            var thisConcept = resp.data[r];
                            if (thisConcept.idGeo) {
                                thisConcepts.push(thisConcept)
                            }
                            if (thisConcept.validateDays) {
                                thisValDaysConceptsIds.push(thisConcept.fid);
                            }
                        }
                    }
                    concepts = thisConcepts;
                    valDaysConceptsIds = thisValDaysConceptsIds;
                    conceptsByKey = concepts.reduce(function (current, item) {
                        current[item.idGeo] = item;
                        return current;
                    }, {})
                    resolve(concepts);
                }).catch(reject)
            })
        }
        function getActiveEmployees(payroll, payrollCalendarStart, payrollCalendarEnd) {
            return new Promise(function (resolve, reject) {
                getEmployeesOfPeriodFilter('', payroll, payrollCalendarStart, payrollCalendarEnd, { 'employeeNumber': '$employeeData.data.employeeNumber', 'employeeId': '$employeeData.fid' }).then(function (employeesP) {
                    var employeeData = [];
                    for (var i = 0; i < employeesP.length; i++) {
                        employeeData.push({
                            employeeName: employeesP[i].name,
                            employeeNumber: '101' + employeesP[i].employeeNumber,
                            employeeId: employeesP[i].employeeId,
                            incidence: []
                        });
                    }
                    employees = employeeData;
                    resolve(employees)
                }).catch(reject);
            })
        }

        vm.getPayrollData = function (payroll) {
            vm.loading = true;
            getPeriods(payroll).then(function () {
                return Promise.all[getGeoRecords(payroll), getConcepts(payroll)];
            }).then(function () {
                return getActiveEmployees(payroll, vm.periodData.start, vm.periodData.end);
            }).then(function () {
                vm.loading = false;
                $rootScope.$evalAsync();
            }).catch(function (error) {
                errAlertS(error);
                vm.loading = false;
                $rootScope.$evalAsync();
            })
        }
        vm.updateEndConsulta = function (initConsulta) {
            if (initConsulta) {
                vm.minDate = moment(vm.initConsulta).toDate();
                $timeout(function () {
                    vm.endConsulta = moment(vm.initConsulta).add(vm.diffDate, 'days').valueOf();
                }, 500);
            }
        };
        // ----------------------- Función para verificar solo los empleados activos  ------------------------------
        vm.getIdIncidences = function () {
            AppF.downloadFile('POST', 'models/integrations/getGeoIncidence', {})
        }
        function isMoreThanOneMinute(delayStr) {
            var data = delayStr.split(":").map(Number);
            var hh = data[0];
            var mm = data[1];
            var totalMinutes = hh * 60 + mm;
            return totalMinutes > 1;
        }

        function getIncidencesFromGeoVictoriaByBatch(formatInitDate, formatEndDate, employees, employeesQueried) {
            return new Promise(function (resolve, reject) {
                employeesQueried = employeesQueried || [];
                if (!angular.isArray(employees) || employees.length === 0) {
                    return resolve(employeesQueried);
                }
                var batchSize = 5;
                var currentBatch = employees.splice(0, batchSize);
                var userIds = currentBatch.join(',');
                var dataApi = angular.toJson({
                    StartDate: formatInitDate,
                    EndDate: formatEndDate,
                    UserIds: userIds
                });
                $rootScope.D.models.action('integrations', 'geo', { url: 'api/v1/AttendanceBook', data: dataApi }).then(function (resp) {
                    if (!angular.isObject(resp.data)) {
                        return reject('Error en la consulta a Geo Victoria');
                    }
                    if (angular.isObject(resp.data.data) && angular.isArray(resp.data.data.Users)) {
                        employeesQueried = employeesQueried.concat(resp.data.data.Users);
                    }
                    resolve(getIncidencesFromGeoVictoriaByBatch(formatInitDate, formatEndDate, employees, employeesQueried));
                }).catch(function (error) {
                    reject(error);
                });
            });
        }
        // ----------------------- Función para llamar a la api de GEO VICTORIA ------------------------------
        function getIncidencesFromGeo() {
            return new Promise(function (resolve, reject) {
                var formatInitDate = moment(vm.initConsulta).format('YYYYMMDD') + '000000';
                var formatEndDate = moment(vm.endDate).format('YYYYMMDD') + '235959';
                getIncidencesFromGeoVictoriaByBatch(formatInitDate, formatEndDate, employees.map(function (item) { return item.employeeNumber; })).then(function (users) {
                    $log.log(users)
                    var incidences = [];
                    var momentDates = {};
                    var endConsulta = moment(vm.endConsulta).endOf('day').valueOf();
                    if (angular.isArray(users)) {
                        for (var i = 0; i < users.length; i++) {
                            var thisUser = users[i];
                            var plannedInterval = thisUser.PlannedInterval;
                            var employeeIndex = employees.findIndex(function (employee) {
                                return employee.employeeNumber === thisUser.Identifier;
                            })
                            if (employeeIndex > -1) {
                                var employeeData = employees[employeeIndex];
                                for (var p = 0; p < plannedInterval.length; p++) {
                                    var thisPlannedInterval = plannedInterval[p];
                                    var timeOffs = thisPlannedInterval.TimeOffs;
                                    var geoIncTypeId = undefined;
                                    var geoIncTypeName = undefined;
                                    if (angular.isUndefined(momentDates[thisPlannedInterval.Date])) {
                                        momentDates[thisPlannedInterval.Date] = moment(thisPlannedInterval.Date).valueOf()
                                    }
                                    var thisMDate = momentDates[thisPlannedInterval.Date];
                                    thisPlannedInterval.Holiday = thisPlannedInterval.Holiday === 'True' ? true : false;
                                    thisPlannedInterval.Worked = thisPlannedInterval.Worked === 'True' ? true : false;
                                    thisPlannedInterval.Absent = thisPlannedInterval.Absent === 'True' ? true : false;
                                    if (timeOffs.length > 0) {
                                        geoIncTypeId = timeOffs[0].TimeOffTypeId;
                                        geoIncTypeName = timeOffs[0].TimeOffTypeDescription;
                                    } else if (thisPlannedInterval.Absent && thisMDate <= endConsulta) {
                                        geoIncTypeId = 'absence';
                                        geoIncTypeName = 'Falta';
                                    } else if (thisPlannedInterval.Worked && thisPlannedInterval.Holiday) {
                                        geoIncTypeId = 'holidayWorked';
                                        geoIncTypeName = 'Festivo Laborado';
                                    } else if (angular.isDefined(thisPlannedInterval.Delay) && thisPlannedInterval.Delay !== "00:00") {
                                        if (isMoreThanOneMinute(thisPlannedInterval.Delay)) {
                                            geoIncTypeId = 'delay';
                                            geoIncTypeName = 'Retardo';
                                        }
                                    } else if ($filter('getFromObject')(thisPlannedInterval, 'Shifts.0.Type') === "NotWorking") {
                                        if (thisPlannedInterval.Worked) {
                                            geoIncTypeId = 'restDayWorked';
                                            geoIncTypeName = 'Descanso Laborado';
                                        } else {
                                            geoIncTypeId = 'restDay';
                                            geoIncTypeName = 'Dia de Descanso';
                                        }
                                    }
                                    var sundaySetted = false;
                                    //validar si la fecha es domingo
                                    if (thisPlannedInterval.Worked && moment(thisPlannedInterval.Date).day() === 0 && timeOffs.length === 0) {
                                        incidences.push({
                                            employeeName: employeeData.employeeName,
                                            employeeNumber: employeeData.employeeNumber,
                                            employeeId: employeeData.employeeId,
                                            date: thisPlannedInterval.Date,
                                            incTypeId: 'sundayWorked',
                                            incTypeName: 'Domingo Laborado',
                                            forNextOperation: (thisMDate > endConsulta)
                                        });
                                        sundaySetted = true;
                                    }
                                    if (angular.isDefined(geoIncTypeId)) {
                                        incidences.push({
                                            employeeName: employeeData.employeeName,
                                            employeeNumber: employeeData.employeeNumber,
                                            employeeId: employeeData.employeeId,
                                            date: thisPlannedInterval.Date,
                                            incTypeId: geoIncTypeId,
                                            incTypeName: geoIncTypeName,
                                            forNextOperation: (thisMDate > endConsulta)
                                        });
                                    }
                                    var posiblesExtras = []
                                    if (!sundaySetted) {
                                        posiblesExtras.push(thisPlannedInterval.AuthorizedOvertimeBefore);
                                        posiblesExtras.push(thisPlannedInterval.AuthorizedOvertimeAfter);
                                    }
                                    var extraTime = 0;
                                    for (var pe = 0; pe < posiblesExtras.length; pe++) {
                                        if (angular.isString(posiblesExtras[pe])) {
                                            var thisTime = posiblesExtras[pe].split(":");
                                            var hours = parseInt(thisTime[0]);
                                            if (!isNaN(hours) && hours > 0) {
                                                extraTime += hours;
                                            }
                                            var minutes = parseInt(thisTime[1]);
                                            if (!isNaN(minutes) && minutes > 0) {
                                                var thisValue = Math.round(minutes * 100 / 60) / 100;
                                                extraTime += thisValue;
                                            }
                                        }
                                    }
                                    if (extraTime > 0) {
                                        incidences.push({
                                            employeeName: employeeData.employeeName,
                                            employeeNumber: employeeData.employeeNumber,
                                            employeeId: employeeData.employeeId,
                                            date: thisPlannedInterval.Date,
                                            incTypeId: 'extraTimeHours',
                                            incTypeName: 'Tiempo extra',
                                            forNextOperation: (thisMDate > endConsulta),
                                            value: extraTime,
                                            dateNotImportant: true
                                        });
                                    }
                                }
                            } else {
                                errAlertS('No se encontró la información de este empleado')
                            }

                        }
                    }
                    geoIncidences = incidences;
                    resolve(geoIncidences);
                }).catch(function (error) {
                    reject(error)
                });
            })
        }
        function validateIncidencesDates(incidences, periodStart, periodEnd, result) {
            return new Promise(function (resolve, reject) {
                result = result ? result : { inProcess: [], assignable: [], accepted: [], notAssignable: [] };
                var promises = [];
                while (incidences.length > 0 && promises.length < 30) {
                    var thisIncidence = incidences.shift();
                    var thisConcept = conceptsByKey[thisIncidence.geoIncTypeId];
                    if (thisConcept.geoDateNotAssign || (thisIncidence.geoDate >= periodStart && thisIncidence.geoDate <= periodEnd && !thisIncidence.forNextOperation)) {
                        var tempIncidence = { employee: thisIncidence.employeeId, date: thisIncidence.geoDate, payroll: vm.payroll, value: 1 };
                        thisIncidence.geoDateNotAssign = thisConcept.geoDateNotAssign ? true : false;
                        promises.push(checkIncidencesAreAllowed(tempIncidence, thisIncidence.dateNotImportant));
                        result.inProcess.push(thisIncidence);
                    } else {
                        result.assignable.push(thisIncidence);
                    }
                }
                if (promises.length === 0) {
                    resolve(result);
                } else {
                    Promise.all(promises).then(function (response) {
                        for (var r = 0; r < response.length; r++) {
                            var allowed = response[r];
                            var thisIncidence = result.inProcess[r];
                            if (allowed) {
                                thisIncidence.systemDate = thisIncidence.geoDate;
                                result.accepted.push(thisIncidence);
                            } else if (thisIncidence.geoDateNotAssign && !thisIncidence.dateNotImportant) {
                                thisIncidence.error = "La fecha asignada no esta disponible";
                                result.notAssignable.push(thisIncidence);
                            } else {
                                result.assignable.push(thisIncidence);
                            }
                        }
                        result.inProcess = [];
                        resolve(validateIncidencesDates(incidences, periodStart, periodEnd, result))
                    }).catch(reject);
                }
            })
        }
        var checkEmployeeIsActive = function (incidenceData) {
            return new Promise(function (resolve) {
                IncidencesF.checkIfValidActiveDates(incidenceData, 'days').then(function () {
                    resolve(true);
                }).catch(function (error) {
                    $log.error(error);
                    resolve(false);
                })
            })
        }
        //---------------------------------------------- Verificar las incidencias permitidas  ------------------------------------------------------
        var checkIncidencesAreAllowed = function (incidenceData, notValidateDates) {
            return new Promise(function (resolve, reject) {
                try {
                    var allowed = true;
                    checkEmployeeIsActive(incidenceData).then(function (resp) {
                        var promises = [];
                        if (!resp) {
                            allowed = false;
                        } else if (!notValidateDates) {
                            var initOfDay = moment(incidenceData.date).startOf('day').valueOf();
                            var endOfDays = moment(incidenceData.date).endOf('day').valueOf();
                            var params = {
                                employee: incidenceData.employee,
                                date: { $lt: endOfDays, $gte: initOfDay },
                                incidenceType: { $in: valDaysConceptsIds }
                            };
                            promises.push($rootScope.D.api.get('incidences', params));
                        }
                        return Promise.all(promises);
                    }).then(function (resp) {
                        if (resp.length > 0 && resp[0].data.length > 0) {
                            allowed = false;
                        }
                        resolve(allowed);
                    }).catch(reject);
                } catch (error) {
                    reject(error)
                }
            })
        }
        //---------------------------------------------- Asignarle días a  las incidencias permitidas  ------------------------------------------------------
        var assignIncidencesDate = function (foundedByEmployee, currentIncidencesMap, nextDate, endDate, result) {
            return new Promise(function (resolve, reject) {
                result = result ? result : { accepted: [], notAccepted: [] };
                var promises = [];
                var posibleExistence = false;
                var nextDateM = moment(nextDate);
                for (var employeeId in foundedByEmployee) {
                    if (foundedByEmployee[employeeId].length > 0) {
                        if (nextDate < endDate) {
                            posibleExistence = true;
                            if (!currentIncidencesMap.hasOwnProperty(employeeId + nextDateM.format('DD-MM-YYYY'))) {
                                var dateImportant = foundedByEmployee[employeeId].some(function (item) {
                                    return !item.dateNotImportant;
                                });
                                var tempIncidence = { employee: employeeId, date: nextDate, payroll: vm.payroll, value: 1 };
                                promises.push(checkIncidencesAreAllowed(tempIncidence, dateImportant));
                            }
                        } else {
                            result.notAccepted = result.notAccepted.concat(foundedByEmployee[employeeId].map(function (item) {
                                item.error = "No hay fechas para asignar esta incidencia";
                                return item;
                            }))
                        }
                    }
                }
                if (nextDate >= endDate || !posibleExistence) {
                    resolve(result)
                } else {
                    Promise.all(promises).then(function (resp) {
                        var count = 0;
                        for (var employeeId in foundedByEmployee) {
                            if (foundedByEmployee[employeeId].length > 0 && (!currentIncidencesMap.hasOwnProperty(employeeId + nextDateM.format('DD-MM-YYYY')))) {
                                if (resp[count]) {
                                    var thisIncidence = foundedByEmployee[employeeId].splice(0, 1)[0];
                                    thisIncidence.systemDate = nextDate;
                                    result.accepted.push(thisIncidence);
                                    if (thisIncidence.dateNotImportant) {
                                        var indIncWithDateImp = foundedByEmployee[employeeId].findIndex(function (item) {
                                            return !item.dateNotImportant;
                                        })
                                        if (indIncWithDateImp > -1) {
                                            var incWithDateImp = foundedByEmployee[employeeId].splice(indIncWithDateImp, 1)[0];
                                            incWithDateImp.systemDate = nextDate;
                                            result.accepted.push(thisIncidence);
                                        }
                                    }
                                }
                                count++
                            }
                        }
                        var thisNextDate = moment(nextDate).add(1, 'day').valueOf();
                        resolve(assignIncidencesDate(foundedByEmployee, currentIncidencesMap, thisNextDate, endDate, result))
                    }).catch(reject)
                }
            });
        }
        function validateIncidences(geoIncidences) {
            return new Promise(function (resolve, reject) {
                var founded = [];
                var notFounded = [];
                var incapacities = [];
                var nextIncidences = [];

                var incidencesLastPeriod = $filter('getFromObject')(vm.geoRecords, '0.nextIncidencesMap', {});
                for (var p = 0; p < geoIncidences.length; p++) {
                    var geoIncidence = geoIncidences[p];
                    var thisConcept = conceptsByKey[geoIncidence.incTypeId];
                    var dateMoment = moment(geoIncidence.date)
                    var date = dateMoment.valueOf();
                    var mainObj = {
                        employeeName: geoIncidence.employeeName,
                        employeeId: geoIncidence.employeeId,
                        geoIncTypeId: geoIncidence.incTypeId,
                        geoIncTypeName: geoIncidence.incTypeName,
                        geoDate: date,
                        geoMDate: dateMoment,
                        forNextOperation: geoIncidence.forNextOperation
                    };
                    if (angular.isNumber(geoIncidence.value)) {
                        mainObj.value = geoIncidence.value;
                    }
                    if (geoIncidence.dateNotImportant) {
                        mainObj.dateNotImportant = true
                    }
                    if (angular.isDefined(thisConcept)) {
                        mainObj.systemIncTypeName = thisConcept.name;
                        mainObj.systemIncTypeId = thisConcept.fid;
                        if (thisConcept.isIncapacity) {
                            if (geoIncidence.forNextOperation) {
                                mainObj.type = 'incapacity';
                                nextIncidences.push(mainObj)
                            } else {
                                incapacities.push(mainObj);
                            }
                        } else if ((!thisConcept.validateDays) && !geoIncidence.dateNotImportant) {
                            mainObj.error = 'Esta incidencia no es asignable para días';
                            notFounded.push(mainObj);
                        } else if (angular.isDefined($filter('getFromObject')(incidencesLastPeriod, geoIncidence.employeeId + '.' + dateMoment.format('YYYY-MM-DD')))) {
                            mainObj.error = "Esta incidencia ya ha sido aplicada";
                            notFounded.push(mainObj);
                        } else {
                            founded.push(mainObj);
                        }
                    } else {
                        mainObj.error = 'No se ha asignado esta incidencia en el sistema'
                        notFounded.push(mainObj);
                    }
                }
                vm.incapacities = incapacities
                validateIncidencesDates(founded, vm.periodData.start, vm.periodData.end).then(function (result) {
                    notFounded = notFounded.concat(result.notAssignable);
                    founded = result.accepted;
                    var assignableSorted = result.assignable.sort(function (a, b) {
                        return a.geoDate - b.geoDate;
                    });
                    var foundedMap = founded.reduce(function (current, item) {
                        if (!item.dateNotImportant) {
                            current[item.employeeId + item.geoMDate.format('DD-MM-YYYY')] = true;
                        }
                        return current;
                    }, {})
                    return assignIncidencesDate($filter('groupByField')(assignableSorted, 'employeeId'), foundedMap, vm.periodData.start, vm.periodData.end);
                }).then(function (result) {
                    notFounded = notFounded.concat(result.notAccepted).reduce(function (current, item) {
                        if (item.forNextOperation) {
                            item.type = 'error';
                            nextIncidences.push(item)
                        } else {
                            current.push(item);
                        }
                        return current;
                    }, [])
                    founded = founded.concat(result.accepted).reduce(function (current, item) {
                        if (item.forNextOperation) {
                            item.type = 'accepted';
                            nextIncidences.push(item)
                        } else {
                            current.push(item);
                        }
                        return current;
                    }, []);
                    vm.notFounded = notFounded
                    vm.founded = founded
                    vm.nextIncidences = nextIncidences;
                    sortArrays();
                    resolve(true);
                }).catch(function (error) {
                    reject(error)
                });
            })
        }
        function analyzeData() {
            vm.loading = true;
            vm.notFounded = [];
            vm.founded = [];
            vm.incapacities = [];
            vm.nextIncidences = [];
            getIncidencesFromGeo().then(function () {
                return validateIncidences(geoIncidences)
            }).then(function () {
                vm.loading = false;
                $rootScope.$evalAsync();
            }).catch(function (error) {
                errAlertS(error);
                vm.loading = false;
                $rootScope.$evalAsync();
            })
        }
        function saveIncidences(updates, ref) {
            return new Promise(function (resolve, reject) {
                try {
                    var count = 0;
                    var thisUpdates = {};
                    for (var key in updates) {
                        thisUpdates[key] = updates[key];
                        delete updates[key];
                        count++;
                        if (count >= 30) {
                            break;
                        }
                    }
                    if (Object.keys(thisUpdates).length === 0) {
                        resolve(true);
                    } else {
                        $scope.F.root.child(ref).update(thisUpdates).then(function () {
                            resolve(saveIncidences(updates, ref))
                        }).catch(reject);
                    }
                } catch (error) {
                    reject(error)
                }
            })
        }
        function queryAllIncAreEditable(idsIncidences, ref, result) {
            return new Promise(function (resolve, reject) {
                try {
                    var toQuery = [];
                    if (angular.isArray(idsIncidences)) {
                        toQuery = idsIncidences.splice(0, idsIncidences.length > 20 ? 20 : idsIncidences.length).map(function (item) {
                            return $scope.F.root.child(ref + '/' + item + '/status').once('value');
                        });
                    }
                    if (toQuery.length === 0) {
                        resolve(true);
                    } else {
                        Promise.all(toQuery).then(function (resp) {
                            var anyIsNotEditable = resp.some(function (item) {
                                var status = item.exists() ? item.val() : 0;
                                return status >= 3;
                            })
                            if (anyIsNotEditable) {
                                reject('No se puede eliminar, ya que, se han aplicado las incidencias')
                            } else {
                                resolve(queryAllIncAreEditable(idsIncidences, ref, result))
                            }
                        }).catch(reject);
                    }
                } catch (error) {
                    reject(error)
                }
            })
        }
        function setSizeModal(step) {
            if (step == 2) {
                vm.sizeModal = 100;
            } else {
                vm.sizeModal = 'auto';
            }
        }
        function calculateTotalIncidences() {
            vm.totalIncidencesToApply = 0;
            vm.totalIncidencesToApply = vm.founded.filter(function (item) {
                return !item.notSync;
            }).length;
        }
        function sortArrays() {
            vm.founded = $filter("orderBy")(vm.founded, ['employeeName', 'dateNotImportant', 'systemDate']);
            vm.incapacities = $filter("orderBy")(vm.incapacities, ['employeeName', 'dateNotImportant', 'geoDate']);
            vm.notFounded = $filter("orderBy")(vm.notFounded, ['employeeName', 'dateNotImportant', 'geoDate']);
            vm.nextIncidences = $filter("orderBy")(vm.nextIncidences, ['employeeName', 'type', 'dateNotImportant', 'geoDate']);
        }
        vm.editComment = function (incidence, ev) {
            // Appending dialog to document.body to cover sidenav in docs app
            var confirm = $mdDialog.prompt()
                .title('Editar comentario Incidencia')
                .placeholder('Añade un comentario')
                .ariaLabel('Edit incidence comment')
                .initialValue(incidence.comment)
                .targetEvent(ev)
                .ok('Guardar!')
                .cancel('Cancelar');
            $mdDialog.show(confirm).then(function (result) {
                incidence.comment = result;
            }, function () {
                $log.log('Comment closed')
            });
        }
        vm.addRemoveToAccepted = function (index, action) {
            vm.loading = true;
            var items;
            if (action === 'add') {
                items = vm.nextIncidences.splice(index, 1);
                vm.founded.push(items[0]);
            } else if (action === 'remove') {
                items = vm.founded.splice(index, 1);
                vm.nextIncidences.push(items[0]);
            }
            sortArrays();
            vm.loading = false;
        }
        vm.deleteGeoRecord = function (geoRecord) {
            if (!vm.loading) {
                vm.loading = true;
                var ref = 'incidences/' + geoRecord.payroll + '/' + geoRecord.calendar;
                queryAllIncAreEditable(geoRecord.idsIncidences.slice(), ref).then(function () {
                    var updates = {};
                    for (var i = 0; i < geoRecord.idsIncidences.length; i++) {
                        var idIncidence = geoRecord.idsIncidences[i];
                        updates[idIncidence] = null;
                    }
                    return saveIncidences(updates, ref);
                }).then(function () {
                    return DataF.api.delete('geoRecords/' + geoRecord._id);
                }).then(function () {
                    return getGeoRecords(vm.payroll);
                }).then(function () {
                    vm.loading = false;
                    $rootScope.$evalAsync();
                    successAlertS('Se eliminó registro con éxito');
                }).catch(function (error) {
                    errAlertS(error);
                    vm.loading = false;
                    $rootScope.$evalAsync();
                })
            }
        }
        vm.applyIncidences = function () {
            if (!vm.loading) {
                try {
                    vm.loading = true;
                    var thisYearCalendar = parseInt(yearCalendar)
                    var ref = 'incidences/' + vm.payroll + '/' + thisYearCalendar;
                    var updates = {};
                    var nextIncidencesMap = {};
                    for (var i = 0; i < vm.founded.length; i++) {
                        var incidence = vm.founded[i];
                        if (!incidence.notSync) {
                            var thisIncidenceId = $scope.F.root.child(ref).push().key
                            updates[thisIncidenceId] = {
                                'created': DataF.getTimeObject(),
                                'automaticAsignation': true,
                                'calendar': thisYearCalendar,
                                'comments': incidence.comment ? incidence.comment + '(Incidencia generada por GeoVictoria)' : 'Incidencia generada por GeoVictoria',
                                'byGeo': true,
                                'date': incidence.systemDate,
                                'employee': incidence.employeeId,
                                'incidenceType': incidence.systemIncTypeId,
                                'payroll': vm.payroll,
                                'period': vm.currentOperation.period,
                                'status': 0,
                                'type': 'manual',
                                'value': incidence.value ? incidence.value : 1,
                                'center': AppF.center
                            };
                            if (incidence.type === 'accepted') {
                                if (angular.isUndefined(nextIncidencesMap[incidence.employeeId])) {
                                    nextIncidencesMap[incidence.employeeId] = {};
                                }
                                if (angular.isUndefined(nextIncidencesMap[incidence.employeeId][incidence.geoMDate.format('YYYY-MM-DD')])) {
                                    nextIncidencesMap[incidence.employeeId][incidence.geoMDate.format('YYYY-MM-DD')] = thisIncidenceId;
                                }
                            }
                        }
                    }
                    var incidencesIds = Object.keys(updates);
                    var params = {
                        initDate: Number(vm.initConsulta),
                        endDate: Number(vm.endConsulta),
                        numberIncidence: incidencesIds.length,
                        period: vm.currentOperation.period,
                        idsIncidences: incidencesIds,
                        payroll: vm.payroll,
                        calendar: thisYearCalendar,
                        nextIncidencesMap: nextIncidencesMap,
                        created: DataF.getTimeObject()
                    };
                    $rootScope.D.api.addWithUnique('geoRecords', params).then(function () {
                        return saveIncidences(updates, ref);
                    }).then(function () {
                        vm.loading = false
                        $scope.close();
                        $rootScope.$evalAsync();
                        successAlertS('Se aplico correctamente las incidencias');
                    }).catch(function (error) {
                        vm.loading = false
                        $rootScope.$evalAsync();
                        errAlertS(error);
                    });
                } catch (error) {
                    vm.loading = false
                    $rootScope.$evalAsync();
                    errAlertS(error);
                }
            }

        };

        $scope.close = function () {
            $mdDialog.hide();
        }
        var currentStep = 1;
        var stepperChange = $rootScope.$on('stepCalled', function (event, step) {
            if (step === 2 && currentStep === 1) {
                analyzeData();
            }
            if (step === 3 & currentStep === 2) {
                calculateTotalIncidences();
            }
            setSizeModal(step);
            currentStep = step;
        });
        var onDestroy = $scope.$on('destroy', function () {
            onDestroy();
            stepperChange();
        })
    }

})();

(function () {
    'use strict';

    angular
        .module('app.clients')
        .controller('IncidenceController', IncidenceController);

    function IncidenceController(
        $scope,
        $rootScope,
        $log,
        successAlertS,
        errAlertS,
        $q,
        $filter,
        AppF,
        $state,
        getIncidenceNotificationDataFilter,
        getSomethingOfArrayFBFilter,
        IncidencesF,
        startAfterInitFilter,
        ListsF,
        $timeout,
        getEmployeesOfPeriodFilter,
        DataF,
        userHasPermissionFilter,
        infoAlertS
    ) {
        $scope.employeesChips = [];
        $scope.employeesAction = {};
        $scope.incidencesTypes = [];
        if (AppF.addMode) {
            $scope.employeeSelected = undefined;
        } else {
            $scope.employeeSelected = { 'name': '' };
        }
        $scope.searchEmployee = '';
        $scope.requireConfirmation = false;
        $scope.requireFile = false;
        $scope.noCalendars = false;
        // $scope.minIncidenceDate = moment().startOf('day').toDate();
        $scope.F.minDate = $scope.minIncidenceDate;
        $scope.listWatchers = {};
        var initiated = false;
        var readyToSet = false;
        function setIncidenceType() {
            $scope.incidenceType = $scope.incidencesTypes.find(function (item) {
                return item.$id === $scope.incidence.incidenceType;
            });
        }
        function setRequireConfirmation() {
            if (angular.isDefined($scope.incidenceType)) {
                $scope.requireFile = $scope.incidenceType.requireFile ? true : false;
                $scope.requireConfirmation = $scope.incidenceType.requireConfirmation ? true : false;
                if ($scope.incidenceType.requireConfirmation || $scope.incidenceType.requireFile) {
                    $scope.incidence.created = $scope.D.getTimeObject();
                    $scope.incidence.$id = (!$scope.incidence.$id) ? $scope.R.getNewId($scope) : $scope.incidence.$id;
                } else {
                    $scope.requireConfirmation = false;
                    $scope.incidence.created = null;
                    $scope.incidence.$id = ($scope.F.addMode) ? null : $scope.incidence.$id;
                }
            }
        }
        function setDefaultValue() {
            if (angular.isDefined($scope.incidenceType) && $scope.incidenceType.setValue && !AppF.readMode) {
                $scope.incidence.value = $scope.incidenceType.defaultValue;
            }
        }
        function getCalendarAndPeriod(payroll, date) {
            return new Promise(function (resolve, reject) {
                if (!AppF.readMode) {
                    var calendar, period;
                    $scope.F.root.child('catalogs/payrollCalendars/' + payroll + '/calendars').orderByChild('data/endDate').startAt(date).limitToFirst(1).once('value').then(function (snap) {
                        if (snap.exists()) {
                            snap.forEach(function (childSnapshot) {
                                calendar = childSnapshot.val();
                                calendar.$id = childSnapshot.key;
                            });
                            return $scope.F.root.child('catalogs/payrollCalendars/' + payroll + '/periods/' + calendar.$id).orderByChild('end').startAt(date).limitToFirst(1).once('value');
                        } else {
                            reject('No hay calendarios creados para ésta nómina, favor de primero crear uno');
                        }
                    }).then(function (periodSnap) {
                        if (periodSnap.exists()) {
                            periodSnap.forEach(function (childSnapshot) {
                                period = childSnapshot.val();
                                period.$id = childSnapshot.key;
                            });
                            resolve({ period: period, calendar: calendar });
                        } else {
                            reject('No hay periodos creados para ésta nómina, favor de primero crear uno');
                        }
                    }).catch(reject);
                } else {
                    resolve({});
                }
            });
        }
        function setPeriod() {
            return new Promise(function (resolve, reject) {
                if ($scope.incidence.payroll && $scope.incidence.date) {
                    getCalendarAndPeriod($scope.incidence.payroll, $scope.incidence.date).then(function (resp) {
                        if (resp.hasOwnProperty('period')) {
                            $scope.F.search['$payrollCalendar'] = parseInt(resp.calendar.data.year);
                            $scope.incidence.payrollCalendar = parseInt(resp.calendar.data.year);
                            $scope.incidence.calendar = parseInt(resp.calendar.data.year);
                            $scope.incidence.period = parseInt(resp.period.period);
                            $scope.period = resp.period;
                        }
                        resolve(true);
                    }).catch(reject);
                } else {
                    resolve(true);
                }
            });
        }

        function checkEmployeeType() {
            return new Promise(function (resolve, reject) {
                try {
                    if (angular.isArray($scope.incidenceType.validations) && $scope.incidenceType.validations.length > 0 && $scope.incidence.employee) {
                        var params = {
                            fid: $scope.incidence.employee,
                            project: angular.toJson($scope.incidenceType.validations.reduce(function (current, item) {
                                current[item.path] = 1;
                                return current;
                            }, {}))
                        };
                        $rootScope.D.api.get('employees', params).then(function (resp) {
                            var thisEmployees = resp.data;
                            if (thisEmployees.length > 0) {
                                var thisEmployee = thisEmployees[0];
                                var error = false;
                                for (var v = 0; v < $scope.incidenceType.validations.length && !error; v++) {
                                    var thisValidation = $scope.incidenceType.validations[v];
                                    var value = $filter('getFromObject')(thisEmployee, thisValidation.path);
                                    var result = thisValidation.value;
                                    if (result === 'null') {
                                        result = null;
                                    } else if (result === 'undefined') {
                                        result = undefined;
                                    }
                                    else if (result.indexOf(':isNumber')) {
                                        result = parseFloat(result.replace(':isNumber', ''));
                                    }
                                    var haveError = false;
                                    if (thisValidation.operation === '=') {
                                        haveError = (value !== result);
                                    } if (thisValidation.operation === '!=') {
                                        haveError = (value === result);
                                    }
                                    if (haveError) {
                                        throw thisValidation.errorMsg;
                                    }
                                }
                                resolve(true);
                            } else {
                                throw 'No se encontró la información del empleado';
                            }
                        }).catch(function (error) {
                            delete $scope.incidence.incidenceType;
                            reject(error);
                        });
                    } else {
                        resolve(true);
                    }
                } catch (error) {
                    delete $scope.incidence.incidenceType;
                    reject(error);
                }

            });
        }

        function checkUniqueIfDate() {
            return new Promise(function (resolve, reject) {
                var incidence = $scope.incidence;
                if (incidence.employee && incidence.date && incidence.calendar && incidence.incidenceType && incidence.payroll && $scope.incidenceType) {
                    IncidencesF.checkIfValidActiveDates(incidence, $scope.incidenceType.affect).then(function () {
                        // incidencia aplica en días activos de empleado
                        // si el tipo de incidencia afecta a días
                        if ($scope.incidenceType.affect === 'days') {
                            // se checa si hay otra incidencia para ese empleado en ese día
                            var incidenceValue = (incidence.value) ? incidence.value : 1;
                            var incidenceDate = incidence.date + ($scope.F.oneDay * (incidenceValue - 1)); // + x dias
                            var initOfDay = moment(incidence.date).startOf('day').valueOf();
                            var endOfDays = moment(incidenceDate).endOf('day').valueOf();
                            var affectDays = $scope.incidencesTypes.filter(function (item) {
                                return item.validateDays;
                            });
                            var affectDaysIds = affectDays.map(function (item) {
                                return item.$id;
                            });
                            var params = {
                                employee: incidence.employee,
                                date: { $lt: endOfDays, $gte: initOfDay },
                                incidenceType: { $in: affectDaysIds }
                            };
                            return $rootScope.D.api.get('incidences', params);
                        } else {
                            resolve(true);
                        }
                    }).then(function (resp) {
                        var incidences = resp.data;
                        for (var i = 0; i < incidences.length; i++) {
                            var incidenceOfDay = incidences[i];
                            if (incidenceOfDay.fid !== $scope.incidence.$id) {
                                // de ser así se borra la fecha y se manda alerta
                                $scope.incidence.date = null;
                                throw 'El empleado ya tiene una incidencia que afecta días en esa fecha';
                            }
                        }
                        return ListsF.loadList('tempIncidences', 'temp/confirmIncidences', undefined, 'array', 'pendingIncidencesOf' + incidence.employee, [{ 'q': 'orderByChild', 'v': 'employee' }, { 'q': 'equalTo', 'v': incidence.employee }]);
                    }).then(function (confirmIncidences) {
                        for (var c = 0; c < confirmIncidences.length; c++) {
                            var cIncidence = confirmIncidences[c];
                            var cId = cIncidence.$id;
                            if (cId !== $scope.incidence.$id) {
                                if (cIncidence.value > 1) {
                                    for (var y = 0; y < cIncidence.value; y++) {
                                        var cIncidenceDate = cIncidence.date + ($scope.F.oneDay * y); // + x dias
                                        if (cIncidenceDate === incidence.date) {
                                            // de ser así se borra la fecha y se manda alerta
                                            $scope.incidence.date = null;
                                            throw 'El empleado ya tiene una incidencia por confirmar que afecta días en esa fecha';
                                        }
                                    }
                                } else {
                                    if (cIncidence.date === incidence.date) {
                                        // de ser así se borra la fecha y se manda alerta
                                        $scope.incidence.date = null;
                                        throw 'El empleado ya tiene una incidencia por confirmar que afecta días en esa fecha';
                                    }
                                }
                            }
                        }
                        resolve(true);
                    }).catch(reject);
                } else {
                    resolve(true);
                }
            });
        }
        function checkMaxAllowValidation() {
            return new Promise(function (resolve, reject) {
                delete $scope.maxAllowed;
                if ($scope.incidence.employee && $scope.incidenceType.max) {
                    $scope.F.root.child('catalogs/employees/collection/' + $scope.incidence.employee).once('value').then(function (snap) {
                        $scope.employeeSelected = snap.val();
                        $scope.F.root.child('catalogs/payrolls/collection/' + snap.val().payroll).once('value').then(function (snap) {
                            var paymentFrequency = snap.val().paymentFrequency;
                            var query = { '_id:objectIds': { $in: paymentFrequency } }
                            DataF.api.get('paymentFrequenciesRecords', query).then(function (resp) {
                                var frecuencia = resp.data[0].days;
                                if ($scope.incidenceType.getMax) {
                                    var data = { employee: $scope.employeeSelected, paymentFrequency: frecuencia };
                                    $log.log(data.employee.data.workDay);
                                    try {
                                        $scope.maxAllowed = eval($scope.incidenceType.max);
                                    } catch (error) {
                                        errAlertS(error);
                                        $scope.maxAllowed = 0;
                                    }
                                } else {
                                    $scope.maxAllowed = $scope.incidenceType.max;
                                }
                                resolve(true);
                            })
                        })

                    }).catch(reject);
                } else {
                    resolve(true);
                }
            });
        }
        function checkIncapacityType() {
            return new Promise(function (resolve, reject) {
                if ($scope.incidenceType.isIncapacity && $scope.incidenceType.valSubseq && $scope.incidence.date && $scope.incidence.employee && $scope.incidence.incapacityType === 'subsequent') {
                    var incapacityTypes = $scope.incidencesTypes.filter(function (item) {
                        return item.isIncapacity;
                    });
                    var idsInc = incapacityTypes.map(function (item) {
                        return item.$id;
                    });
                    var params = {
                        employee: $scope.incidence.employee,
                        date: { $lt: $scope.incidence.date },
                        incidenceType: { $in: idsInc }
                    };

                    var forceSubsequent = userHasPermissionFilter(AppF.groupsOfUser, AppF.permissions, 'forceSubsequentIncapacity', 'processes.incidences');
                    if (!forceSubsequent) {
                        params.date['$gte'] = moment($scope.incidence.date).subtract(1, 'day').valueOf()
                    }
                    params.page = 1;
                    params.size = 1
                    params.sort = '-date';
                    if ($scope.incidence.$id) {
                        params.fid = { $ne: $scope.incidence.$id };
                    }
                    $rootScope.D.api.get('p/incidences', params).then(function (resp) {
                        var thisIncidences = resp.data.data;
                        if ((!angular.isArray(thisIncidences)) || thisIncidences.length === 0) {
                            errAlertS('No se puede seleccionar este tipo de incapacidad ya que no hay registro previo de otra incapacidad');
                            delete $scope.incidence.incapacityType;
                            delete $scope.incidence.startDate;
                        } else {
                            delete $scope.incidence.startDate;
                            $scope.incidence.startDate = thisIncidences[0].startDate || thisIncidences[0].startDate;
                            infoAlertS('Se realizará continuidad de incidencia con fecha ' + moment($scope.incidence.startDate).format('DD-MM-YYYY'))
                        }
                        resolve(true);
                    }).catch(reject);
                } else {
                    resolve(true);
                }
            });
        }

        var onChangeActions = {
            incidenceType: function () {
                setIncidenceType();
                setRequireConfirmation();
                setDefaultValue();
                return checkEmployeeType().then(function () {
                    return checkUniqueIfDate();
                }).then(function () {
                    return checkIncapacityType();
                }).then(function () {
                    return checkMaxAllowValidation();
                });
            },
            date: function () {
                return setPeriod().then(function () {
                    return checkUniqueIfDate();
                }).then(function () {
                    return checkIncapacityType();
                });
            },
            employee: function () {
                return checkEmployeeType().then(function () {
                    return checkUniqueIfDate();
                }).then(function () {
                    return checkIncapacityType();
                }).then(function () {
                    return checkMaxAllowValidation();
                });
            },
            incapacityType: function () {
                return checkIncapacityType();
            },
            qty: function () {
                return checkUniqueIfDate().then(function () {
                    return checkMaxAllowValidation();
                });
            }
        };



        $scope.onChange = function (item) {
            if (readyToSet) {
                $rootScope.loadingProgress = true;
                $rootScope.$evalAsync();
                $timeout(function () {
                    var promise = onChangeActions[item]();
                    promise.then(function () {
                        $log.log('Se terminaron los cambios');
                    }).catch(function (error) {
                        errAlertS(error);
                    }).then(function () {
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync();
                        $timeout(function () { }, 0, false);
                    });
                }, 0, false);
            }
        };

        function setEmployee() {
            return new Promise(function (resolve, reject) {
                if ($scope.incidence.employee) {
                    $scope.F.root.child('catalogs/employees/collection/' + $scope.incidence.employee).once('value').then(function (snap) {
                        $scope.employeeSelected = snap.val();
                        $scope.employeeSelected._id = $scope.incidence.employee;
                        $scope.searchEmployee = $scope.employeeSelected.data.name;
                        $rootScope.$evalAsync();
                        $timeout(function () {
                            resolve(true);
                        }, 0, false);
                    }).catch(reject);
                } else {
                    resolve(true);
                }
            });
        }

        function getMinDate(payroll) {
            return new Promise(function (resolve, reject) {
                if (!AppF.readMode) {
                    var calendar, operation;
                    $scope.F.root.child('catalogs/payrollCalendars/' + payroll + '/calendars').orderByChild('data/active').equalTo(true).once('value').then(function (snap) {
                        if (snap.exists()) {
                            $scope.noCalendars = false;
                            snap.forEach(function (childSnapshot) {
                                calendar = childSnapshot.val();
                                calendar.$id = childSnapshot.key;
                            });
                            var params = {
                                payroll: payroll,
                                'calendar:int': calendar.$id,
                                operationType: 'ordinary',
                                status: angular.toJson({ $gte: 1, $lt: 3 }),
                                sort: 'period',
                                size: 1,
                                page: 1
                            };
                            return DataF.api.get('p/operations', params);
                            // return $scope.F.root.child('catalogs/operations/ordinary/' + payroll + '/' + calendar.$id + '/collection').orderByChild('status').startAt(1).limitToFirst(1).once('value');
                        } else {
                            errAlertS('No hay calendarios creados para ésta nómina, favor de primero crear uno');
                            $scope.noCalendars = true;
                            resolve(true);
                        }
                    }).then(function (operationsResp) {
                        if (operationsResp.data && operationsResp.data.data.length > 0) {
                            operation = operationsResp.data.data[0];
                            operation.$id = operation.fid;
                            $log.debug('operation Loaded', operation);
                            return $scope.F.root.child('catalogs/payrollCalendars/' + payroll + '/periods/' + calendar.$id + '/' + operation.period).once('value');
                        } else {
                            errAlertS('No hay operaciones creadas para ésta nómina, favor de crearlas');
                            $scope.noCalendars = true;
                            resolve(true);
                        }
                    }).then(function (periodSnap) {
                        $log.debug('operation Loaded', periodSnap.exists(), periodSnap.val());
                        if (periodSnap.exists()) {
                            var status = AppF.getOperationStatusByEmployees(operation, $rootScope.L.userCcs[AppF.profile.uid]);
                            var maxStatus = AppF.getMaxEditStatus();
                            var period = periodSnap.val();
                            var mind;
                            if (maxStatus >= status) {
                                mind = period.start;
                            } else {
                                mind = period.end + 1;
                            }
                            var formattedDate = moment(mind);
                            $scope.minIncidenceDate = new Date(formattedDate.utc().year(), formattedDate.utc().month(), formattedDate.utc().date());
                            resolve(true);
                        } else {
                            errAlertS('No hay periodos creadas para ésta nómina, favor de crearlas');
                            $scope.noCalendars = true;
                            resolve(true);
                        }
                    }).catch(reject);
                } else {
                    resolve(true);
                }
            });
        }
        function loadIncidencesTypes(payrollId) {
            return new Promise(function (resolve, reject) {
                $scope.incidencesTypes = [];
                ListsF.loadList('incidencesTypes', 'catalogs/incidencesTypes/collection', undefined, 'array', 'globalIncidencesTypes', [{ q: 'orderByChild', v: 'payroll' }, { q: 'equalTo', v: 'global' }]).then(function (globalIncidencesTypes) {
                    $scope.incidencesTypes = globalIncidencesTypes.filter(function (item) {
                        return (item.center && item.center === AppF.center);
                    });
                    $scope.incidencesTypes = $scope.incidencesTypes.filter(function (item) {
                        if (!item.payrollsRemoved) {
                            return true
                        }
                        return !item.payrollsRemoved.includes(payrollId);
                    });
                    return ListsF.loadList('incidencesTypes', 'catalogs/incidencesTypes/collection', undefined, 'array', 'payrollIncidencesTypes-' + payrollId, [{ q: 'orderByChild', v: 'payroll' }, { q: 'equalTo', v: payrollId }]);
                }).then(function (payrollIncidencesTypes) {
                    $scope.incidencesTypes = $scope.incidencesTypes.concat(payrollIncidencesTypes.slice());
                    resolve(true);
                }).catch(reject);
            });
        }

        $scope.payrollUpdated = function (force) {
            return new Promise(function (resolve, reject) {
                if (readyToSet || force) {
                    $scope.calendars = null;
                    $scope.periods = null;
                    $scope.employees = null;
                    $scope.incidencesTypes = [];
                    var payrollId = $scope.incidence.payroll;
                    if (payrollId && payrollId !== 'all' && payrollId !== 'global') {
                        if ($scope.R.states.fb[$scope.F.active.menuName] && $scope.R.states.fb[$scope.F.active.menuName].update) {
                            $state.go($scope.R.states.fb[$scope.F.active.menuName].update, { payrollId: payrollId }, {
                                notify: false
                            });
                        }
                        $scope.F.search['$payroll'] = payrollId;
                        var payrollIsActive = getSomethingOfArrayFBFilter(payrollId, $scope.L.allPayrolls, 'active');
                        if (payrollIsActive) {
                            if ($scope.F.addMode) {
                                $scope.activeEmployees = [];
                                $scope.incidence.incidenceType = null;
                                $scope.incidence.employee = null;
                                $scope.incidence.period = null;
                                $scope.incidence.calendar = null;
                                $scope.incidence.date = null;
                            }
                            var queries = [
                                loadIncidencesTypes(payrollId),
                                getMinDate(payrollId)
                            ];
                            Promise.all(queries).then(function () {
                                $rootScope.$evalAsync();
                                $timeout(function () {
                                    resolve(true);
                                }, 0, false);

                            }).catch(reject);
                        } else {
                            if ($scope.F.addMode) {
                                errAlertS('La nómina pre-seleccionada no está activa');
                                $scope.incidence.payroll = null;
                            }
                            resolve(true);
                        }
                    } else {
                        resolve(true);
                    }
                } else {
                    resolve(true);
                }
            });
        };
        $scope.getEmployees = function (searchQuery) {
            return new Promise(function (resolve, reject) {
                getEmployeesOfPeriodFilter(searchQuery, $scope.incidence.payroll, $scope.period.start, $scope.period.end).then(function (employees) {
                    resolve(employees);
                }).catch(reject);
            });
        };
        $scope.addAndMaybeSetIncidenceRequest = function (incidence) {
            $log.debug('addAndMaybeSetIncidenceRequest', incidence);
            $rootScope.loadingProgress = true;
            IncidencesF.checkIfIncidenceRequestIsNeededAndCreateIt(incidence, $scope.incidenceType.affect)
                .then(function (iR) {
                    var msg = (iR) ? 'Se creó una solicitud de incidencias masivas y varias incidencias para cada día' : 'Se creó Incidencia con éxito';
                    successAlertS(msg);
                    $scope.R.goToList();
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync(function () {
                        $log.debug('addAndMaybeSetIncidenceRequest finished');
                    });
                }).catch(function (err) {
                    errAlertS(err);
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                });
        };
        $scope.sendConfirmation = function (obj) {
            $rootScope.loadingProgress = true;
            obj.status = -1;
            var id = angular.copy(obj.$id);
            var type = 'incidence',
                action = 'incidences',
                status = obj.status,
                idM = id,
                record = obj,
                dontSendEmail = false;
            getIncidenceNotificationDataFilter(obj).then(function (dataNeededByTemplate) {
                $scope.F.notifyUsers(type, action, status, idM, record, dontSendEmail, dataNeededByTemplate).then(function () { // se notifica primero porque fb es menos probable que falle
                    $scope.save(obj, 1, 'incidences', $scope).then(function () {
                        successAlertS('Incidencia fue mandada a ejecutivo para su confirmación.');
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync(function () {
                            $log.debug('sendConfirmation finished');
                        });
                        if ($scope.F.settings.goToListOnCreate) { $scope.R.goToList(); }
                    });
                }).catch(function (err) {
                    errAlertS(err);
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                });
            }).catch(function (err) {
                errAlertS(err);
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
            });
        };
        $scope.confirmIncidence = function (obj) {
            $rootScope.loadingProgress = true;
            obj.status = 0;
            obj.confirmed = $scope.D.getTimeObject();
            var id = obj.$id;
            var obj2 = $filter('clearObject')(obj);
            obj2.$id = id;

            var type = 'incidence',
                action = 'incidences',
                status = obj2.status,
                idM = id,
                record = obj2,
                dontSendEmail = false;

            // $scope.save(obj, 1).then(function () {
            // una vez que se hizo esto hay que borrar la incidencia original y generar el request atomizado de incidencias
            IncidencesF.checkIfIncidenceRequestIsNeededAndCreateIt(obj, $scope.incidenceType.affect)
                .then(function (updates) {
                    // no es necesario borrar incidencia original, ya que ya fue re-escrita
                    var msg = 'La incidencia fue confirmada, se enviará notificación al cliente. ';
                    msg += Object.keys(updates).length > 1 ? 'Se creó una solicitud de incidencias masivas y varias incidencias para cada día' : 'Se creó Incidencia con éxito';
                    successAlertS(msg);
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync(function () {
                        $log.debug('confirmIncidence finished');
                    });
                    getIncidenceNotificationDataFilter(obj2).then(function (dataNeededByTemplate) {
                        $scope.F.notifyUsers(type, action, status, idM, record, dontSendEmail, dataNeededByTemplate).then(function () { // se notifica primero porque fb es menos probable que falle

                        }).catch(function (err) {
                            errAlertS(err);
                            $rootScope.loadingProgress = false;
                            $rootScope.$evalAsync();
                        });
                    }).catch(function (err) {
                        errAlertS(err);
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync();
                    });
                    if ($scope.F.settings.goToListOnCreate) { $scope.R.goToList(); }
                })
                .catch(function (err) {
                    errAlertS(err);
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                });
        };
        function updateIncidenceRequest(incidence) {
            return new Promise(function (resolve, reject) {
                if (angular.isString(incidence.request)) {
                    var ref = '/catalogs/incidencesRequests/collection/' + incidence.request + '/incidences/' + incidence.$id;
                    var miniIncidence = {
                        'c': incidence.comments,
                        'd': incidence.date,
                        'e': incidence.employee,
                        'it': incidence.incidenceType,
                        'p': incidence.period,
                        's': incidence.status,
                        'v': incidence.value
                    };
                    $scope.F.root.child(ref).update(miniIncidence).then(function () {
                        resolve(true);
                    }).catch(reject);
                } else {
                    resolve(true);
                }
            });
        }
        $scope.saveIncidence = function (obj) {
            updateIncidenceRequest(obj).then(function () {
                return $scope.save(obj);
            }).catch(function (error) {
                $log.error(error);
                errAlertS('Error al actualizar la incidencia del request');
            });
        };
        $scope.returnIncidence = function (obj) {
            $rootScope.loadingProgress = true;
            obj.status = -3;
            var id = angular.copy(obj.$id);
            var type = 'incidence',
                action = 'incidences',
                status = obj.status,
                idM = id,
                record = obj,
                dontSendEmail = false;
            getIncidenceNotificationDataFilter(obj).then(function (dataNeededByTemplate) {
                $scope.F.notifyUsers(type, action, status, idM, record, dontSendEmail, dataNeededByTemplate).then(function () { // se notifica primero porque fb es menos probable que falle
                    $scope.save(obj, 1).then(function () { // este guarda en 'temp/confirmIncidences'
                        // guardar en cat temporal un clon mientras tenga status menor a 0 vivirá ahi también
                        // el servidor automáticamente borra el elemento cuando llega a status mayor a cero y clona los cambios que se hagan en el clon al original (como el status)
                        successAlertS('Se enviará notificación al cliente de que hay problemas con su incidencia.');
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync(function () {
                            $log.debug('returnIncidence finished');
                        });
                        if ($scope.F.settings.goToListOnCreate) { $scope.R.goToList(); }
                    }).catch(function (err) {
                        errAlertS(err);
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync();
                    });
                }).catch(function (err) {
                    errAlertS(err);
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                });
            }).catch(function (err) {
                errAlertS(err);
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
            });
        };
        $scope.cancelIncidence = function (obj) {
            $rootScope.loadingProgress = true;
            obj.status = -4;
            var id = angular.copy(obj.$id);
            var type = 'incidence',
                action = 'incidences',
                status = obj.status,
                idM = id,
                record = obj,
                dontSendEmail = true;
            getIncidenceNotificationDataFilter(obj).then(function (dataNeededByTemplate) {
                $scope.F.notifyUsers(type, action, status, idM, record, dontSendEmail, dataNeededByTemplate).then(function () { // se notifica primero porque fb es menos probable que falle
                    $scope.save(obj, 1).then(function () { // este guarda en 'temp/confirmIncidences'
                        // guardar en cat temporal un clon mientras tenga status menor a 0 vivirá ahi también
                        // el servidor automáticamente borra el elemento cuando llega a status mayor a cero y clona los cambios que se hagan en el clon al original (como el status)
                        successAlertS('Se canceló la notificación, no será tomada en cuenta para la operación.');
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync(function () {
                            $log.debug('cancelIncidence finished');
                        });
                        if ($scope.F.settings.goToListOnCreate) { $scope.R.goToList(); }
                    }).catch(function (err) {
                        errAlertS(err);
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync();
                    });
                }).catch(function (err) {
                    errAlertS(err);
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                });
            }).catch(function (err) {
                errAlertS(err);
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
            });
        };
        function init() {
            var needed = [
                $scope.dataNeededPromise,
                $scope.statesObjsPromise,
                $scope.mainObjectLoaded
            ];
            Promise.all(needed).then(function () {
                return $scope.payrollUpdated(true);
            }).then(function () {
                return setEmployee();
            }).then(function () {
                setIncidenceType();
                setRequireConfirmation();
                setDefaultValue();
                return setPeriod();
            }).then(function () {
                return checkUniqueIfDate();
            }).then(function () {
                readyToSet = true;
                $scope.$evalAsync({});
            }).catch(function (error) {
                readyToSet = true;
                errAlertS(error);
                $scope.$evalAsync({});
            });
        }
        startAfterInitFilter($scope, $scope.listWatchers, initiated, init);
    }
})();
(function () {
  "use strict";

  angular
    .module("app.employees")
    .controller("HumandCatalogController", HumandCatalogController);

  function HumandCatalogController($scope, CatalogsF, $window, startAfterInitFilter, $log, $mdDialog, $state, ApiV3F, getFromObjectFilter, $timeout, $rootScope, AppF, ListsF, errAlertS) {
    var watchers = {};
    var initiated = false;
    $scope.thisFirms = [];
    $scope.thisPayrolls = [];
    $scope.thisCcs = [];
    $scope.humandCcs = [];
    $scope.ccSelected = ""
    $scope.ccHumanSelected = "";
    var ccHumandName = 'CENTRO DE COSTOS';
    function init() {
      var promises = [$scope.dataNeededPromise, $scope.statesObjsPromise, $scope.mainObjectLoaded];
      Promise.all(promises).then(function () {
        $scope.thisFirms = CatalogsF.firms.filter(function (item) {
          var apiKey = getFromObjectFilter(item, 'syncConfig.humand.apiKey');
          return angular.isDefined(apiKey) && apiKey !== null && apiKey !== '';
        })
        $log.log($scope.humandCatalog)
        promises = [];
        if ($scope.humandCatalog.firm) {
          $scope.loadPayrollsData($scope.humandCatalog.firm);
          // promises.push(ApiV3F.post('syncApps/request/humand', { firm: $scope.humandCatalog.firm, path: 'segmentations/groups/demo' }));
          promises.push($scope.loadSegmentation($scope.humandCatalog.firm));
        }
        return Promise.all(promises)
      }).then(function (data) {
        $log.log('Todo cargado', data);
      }).catch(errAlertS);
    }

    $scope.loadFirmData = function (firmId) {
      if (angular.isDefined(firmId)) {
        ApiV3F.get('api/humandCatalog/byQuery', { firm: firmId }).then(function (resp) {
          if (resp.data) {
            $state.transitionTo($state.current, { humandCatalogId: resp.data._id }, {
              inherit: false,
              notify: false
            });
            $scope.setMainObject(resp.data);
            $scope.F.addMode = false;
          } else {
            $state.transitionTo($state.current, { humandCatalogId: 'new' }, { inherit: false, notify: false });
            $scope.setMainObject({ firm: firmId });
            $scope.F.addMode = true;
          }
          $scope.loadPayrollsData(firmId);
          $scope.loadSegmentation(firmId);
        }).catch(function (error) {
          errAlertS(error)
        })
      }
    }
    function addCcToHumandCatalog(ccId, ev) {
      return new Promise(function (resolve, reject) {
        var ccHumanId;
        var ccName = $scope.thisCcs.find(function (cc) { return cc.$id === ccId }).name;
        var confirm = $mdDialog.prompt()
          .title('Agregar nuevo centro de costo en Humand')
          .placeholder('Centro de costo')
          .ariaLabel('Centro de costo')
          .initialValue(ccName)
          .targetEvent(ev)
          .ok('Agregar')
          .cancel('Cancelar');
        $mdDialog.show(confirm).then(function (resp) {
          return ApiV3F.post('syncApps/request/humand', { firm: $scope.humandCatalog.firm, path: 'segmentations/groups/' + ccHumandName + '/items', method: 'POST', data: { items: [resp] } })
        }).then(function (data) {
          if (data.data.length > 0) {
            ccHumanId = data.data[0].name
            return $scope.loadSegmentation($scope.humandCatalog.firm);
          } else {
            reject(new Error('No se pudo agregar el centro de costo'));
          }
          resolve(true);
        }).then(function () {
          resolve(ccHumanId)
        }).catch(reject)
      })
    }
    $scope.addCc = function (ccId, ccHumanId, ev) {
      $scope.humandCatalog.ccs = $scope.humandCatalog.ccs || {};
      var promises = [];
      if (ccHumanId === 'addItemHumand') {
        promises.push(addCcToHumandCatalog(ccId, ccHumanId, ev));
      }
      Promise.all(promises).then(function (resp) {
        if (resp.length > 0) {
          ccHumanId = resp[0];
        }
        if (angular.isDefined(ccId) && angular.isDefined(ccHumanId)) {
          if (!$scope.humandCatalog.ccs[ccId]) {
            $scope.humandCatalog.ccs[ccId] = ccHumanId;
            $log.log('Quitando selección');
            delete $scope.humandCatalog.ccSelected;
            delete $scope.humandCatalog.ccHumanSelected;
            $timeout(function () {
              $rootScope.$evalAsync();
            })
          } else {
            errAlertS('El centro de costo ya ha sido agregado');
          }
        }
      }).catch(function (error) {
        if (error) {
          errAlertS(error)
        } else {
          errAlertS('No se añadió el centro de costo');
        }
      });
    }
    $scope.loadSegmentation = function (firmId) {
      return new Promise(function (resolve, reject) {
        ApiV3F.post('syncApps/request/humand', { firm: firmId, path: 'segmentations' }).then(function (resp) {
          var allSegmentations = resp.data;
          if (angular.isArray(allSegmentations)) {
            var ccsSegmentation = allSegmentations.find(function (segmentation) {
              return segmentation.name === ccHumandName
            });
            if (ccsSegmentation && angular.isArray(ccsSegmentation.items)) {
              $scope.humandCcs = ccsSegmentation.items.map(function (item) {
                return {
                  id: item.id,
                  name: item.name
                };
              });
              $rootScope.$evalAsync();
            }
            resolve(true);
          }
        }).catch(reject)
      })
    }
    $scope.deleteCc = function (ccId) {
      delete $scope.humandCatalog.ccs[ccId];
      $scope.form.$setDirty();
    }
    $scope.loadPayrollsData = function (firm) {
      var payrolls = AppF.permissionToAccessAllPayrolls ? ListsF.allPayrolls : ListsF.payrolls;
      $scope.thisPayrolls = payrolls.filter(function (payroll) {
        return payroll.firm === firm;
      });
      $scope.thisPayrollsByKey = $scope.thisPayrolls.reduce(function (acc, payroll) {
        acc[payroll.$id] = payroll;
        return acc;
      }, {})
      var payrollsIds = $scope.thisPayrolls.map(function (payroll) { return payroll.$id });
      var ccs = AppF.permissionToAccessAllPayrolls ? ListsF.ccs : ListsF.userCcs[AppF.profile.uid];
      $scope.thisCcs = ccs.filter(function (cc) {
        return payrollsIds.indexOf(cc.payroll) > -1;
      })
      $scope.thisCcsByKey = $scope.thisCcs.reduce(function (acc, cc) {
        acc[cc.$id] = cc;
        return acc;
      }, {})
    }
    startAfterInitFilter($scope, watchers, initiated, init);
  }
})();

(function () {
    'use strict';

    angular
        .module('app.clients')
        .controller('FoliosController', FoliosController);

    function FoliosController(
        $scope,
        $rootScope,
        $mdDialog,
        $log,
        $filter,
        AppF,
        $document,
        getSomethingOfArrayMFilter,
        startAfterInitFilter
    ) {
        var initiated = false;
        var watchers = {};
        $scope.F = AppF;
        $scope.initialLoadMoreText = 'Cargar mas resultados';
        $scope.addFolio = function (ev) {
            $mdDialog.show({
                controller: function (scope, AppF, ListsF, MongoF, $rootScope, errAlertS, DataF, $firebaseObject) {
                    scope.M = MongoF;
                    scope.L = ListsF;
                    scope.F = AppF;
                    scope.D = DataF;
                    scope.close = function () {
                        $mdDialog.cancel();
                    };
                    scope.confirm = function () {
                        $mdDialog.hide();
                    };
                    scope.items = [];
                    scope.selected = [];
                    scope.issuersName = {};
                    scope.generate = function () {
                        scope.generating = true;
                        var idFolio = scope.F.root.child('catalogs/folios/collection').push().key;
                        var taskObj = {
                            'type': 'getIssuersNextFolio',
                            'payroll': scope.payrollData.$id,
                            'payrollName': scope.payrollData.data.name,
                            'recordId': idFolio,
                            'profileObj': scope.D.getTimeObject(),
                            'issuers': {}
                        };
                        for (var i = 0; i < scope.selected.length; i++) {
                            taskObj.issuers[scope.selected[i]] = scope.issuersName[scope.selected[i]].proccess;
                        }
                        $log.log(taskObj);
                        scope.F.root.child('queue1/tasks').push(taskObj).then(function () {
                            $log.log('se crea tarea para folio satisfactoriamente');
                            scope.folio = $firebaseObject(scope.F.root.child('catalogs/folios/collection/' + idFolio));
                        }).catch(function (error) {
                            $log.error(error, 'error al crear tarea para folios');
                            errAlertS('No se pudo crear el registro intentelo nuevamente');
                            $scope.generating = false;
                        });
                    };
                    scope.getIssuers = function (payroll) {
                        scope.items = [];
                        scope.selected = [];
                        if (payroll) {
                            $rootScope.loadingProgress = true;
                            ListsF.loadList('payrolls', 'catalogs/payrolls/collection', payroll, 'object', 'payrolls-' + payroll).then(function (payrollData) {
                                $log.log(payrollData);
                                scope.payrollData = payrollData;
                                $log.log(scope.M.bankAccounts);
                                for (var proc in payrollData.processes) {
                                    if (payrollData.processes.hasOwnProperty(proc) && angular.isDefined(payrollData.processes[proc].bankAccounts)) {
                                        for (var b = 0; b < payrollData.processes[proc].bankAccounts.length; b++) {
                                            var issuer = getSomethingOfArrayMFilter(payrollData.processes[proc].bankAccounts[b], scope.M.bankAccounts, 'issuer');
                                            if (issuer !== false) {
                                                scope.items.push(payrollData.processes[proc].bankAccounts[b]);
                                                scope.issuersName[payrollData.processes[proc].bankAccounts[b]] = { proccess: proc, name: getSomethingOfArrayMFilter(payrollData.processes[proc].bankAccounts[b], scope.M.bankAccounts, 'name', 'S/N') };
                                            }
                                        }
                                    }
                                }
                                $rootScope.loadingProgress = false;
                                $rootScope.$evalAsync();
                            }).catch(function (error) {
                                errAlertS('Error cargando emisoras');
                                $log.error(error);
                                $rootScope.loadingProgress = false;
                                $rootScope.$evalAsync();
                            });
                        }
                    };
                    scope.toggle = function (item, list) {
                        var idx = list.indexOf(item);
                        if (idx > -1) {
                            list.splice(idx, 1);
                        }
                        else {
                            list.push(item);
                        }
                    };
                    scope.exists = function (item, list) {
                        return list.indexOf(item) > -1;
                    };
                    scope.isIndeterminate = function () {
                        return (scope.selected.length !== 0 &&
                            scope.selected.length !== scope.items.length);
                    };
                    scope.isChecked = function () {
                        return scope.selected.length === scope.items.length;
                    };
                    scope.toggleAll = function () {
                        if (scope.selected.length === scope.items.length) {
                            scope.selected = [];
                        } else if (scope.selected.length === 0 || scope.selected.length > 0) {
                            scope.selected = scope.items.slice(0);
                        }
                    };
                },
                templateUrl: 'app/main/clients/views/folios/dialogs/form-folio.html',
                parent: angular.element($document.body),
                targetEvent: ev
            }).then(function (answer) {
                $log.log(answer);
            }, function () {
                $log.debug('sendManyToAction cancelled');
            });
        };
        $scope.getMoreResults = function () {
            if ($scope.folios.loadMoreButton) {
                $scope.initialLoadMoreText = 'Cargando...';
                $rootScope.$evalAsync(function () {
                    $log.log('getting more');
                    $scope.folios.loadMore();
                });
            }
        };
        function completeFoliosInfo() {
            if (angular.isDefined($scope.folios)) {
                for (var i = 0; i < $scope.folios.items.length; i++) {
                    var thisItem = $scope.folios.items[i];
                    if (angular.isUndefined(thisItem.userName)) {
                        $scope.folios.items[i].userName = $filter('nameOfL')(thisItem.created.by, $scope.L.profiles, thisItem.created.by);
                    }
                }
                $scope.initialLoadMoreText = 'Cargar mas resultados';
            }
        }
        function init() {
            $scope.L.loadList('profiles');
            $scope.M.loadCatalog('bankAccounts');
            $scope.folios = $scope.F.paginator($scope.F.root.child('catalogs/folios/collection'), 10, 'created/atTime', 'foliosCargados');
        }
        watchers.foliosCargados = $rootScope.$on('foliosCargados', function () {
            $rootScope.$evalAsync();
            completeFoliosInfo();
        });
        watchers.autoScrollBottom = $scope.$on('autoScrollBottom', function () {
            $log.log('autoScrollBottom');
            $scope.getMoreResults();
        });

        startAfterInitFilter($scope, watchers, initiated, init);

    }
})();
(function () {
    'use strict';

    angular
        .module('app.clients')
        .controller('FirmsController', FirmsController);

    function FirmsController(
        $scope,
        $log,
        startAfterInitFilter,
        infoAlertS,
        $mdDialog
    ) {
        var initiated = false;
        $scope.listWatchers = {};

        $scope.firmToRp = function (ev) {
            if (angular.isArray($scope.selected[0].companies) && $scope.selected[0].companies.length > 0) {
                $mdDialog.show({
                    templateUrl: 'app/main/clients/views/firms/firmsToRp.html',
                    controller: 'firmToRpController',
                    controllerAs: 'ftpCtrl',
                    locals: {
                        selected: $scope.selected[0].companies
                    },
                    parent: angular.element(document.body),
                    targetEvent: ev,
                });
            } else {
                infoAlertS('No existen empresas para copiar')
            }

        };

        function init() {
        }
        startAfterInitFilter($scope, $scope.listWatchers, initiated, init);
    }
})();

(function () {
    'use strict';

    angular
        .module('app.clients')
        .controller('firmToRpController', firmToRpController);

    function firmToRpController(
        $mdDialog,
        selected,
        ListsF,
        AppF,
        $rootScope,
        successAlertS
    ) {
        var vm = this;
        vm.L = ListsF;
        vm.close = function () {
            $mdDialog.cancel();
        };
        vm.answer = function () {
            if (angular.isObject(selected) && selected !== null) {
                $rootScope.loadingProgress = true;
                var companiesFirm = selected;
                AppF.root.child("catalogs/rps/collection/" + vm.rp + "/companies").update(companiesFirm).then(function () {
                    console.log('Datos actualizados correctamente');
                    successAlertS('Se copiaron las empresas con éxito');
                    $mdDialog.hide();
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                }).catch(function (error) {
                    console.error('Error al actualizar los datos:', error);
                    errAlertS(error);
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                });
            } else {
                console.error('vm.companiesFirm no es un objeto válido:', selected);
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.clients')
        .controller('FirmController', FirmController);

    function FirmController(
        $scope,
        $log,
        errAlertS,
        startAfterInitFilter,
        $rootScope,
        $timeout,
        userHasPermissionFilter,
        AppF
    ) {
        var initiated = false;
        $scope.selectedCompany = 0;
        $scope.listWatchers = {};
        $scope.hasCompanySelected = false;
        $scope.setCompanySelected = function (company) {
            $scope.hasCompanySelected = true;
            $scope.companySelected = company;
            $scope.$evalAsync();
            $timeout(function () { }, 0, false);
        }
        $scope.addItem = function (property, obj) {
            if (angular.isArray($scope.firm[property])) {
                $scope.firm[property].push(obj)
            } else {
                $scope.firm[property] = [obj];
            }
            $scope.selectedCompany = 1;
            $rootScope.$evalAsync();
            $timeout(function () { }, 0, false);
        }
        $scope.removeItem = function (index, property) {
            if (angular.isArray($scope.firm[property]) && $scope.firm[property].length > 0) {
                $scope.firm[property].splice(index, 1);
                $scope.$evalAsync(function () { });
                $timeout(function () { }, 0, false);
            }
        };
        $scope.setLastCompany = function () {
            if ($scope.firm.companies.length == 1) {
                $scope.setCompanySelected($scope.firm.companies[0]);
            }
        }
        $scope.listWatchers.stateid = $scope.$watch('companySelected.state_id', function (stateId) {
            if (angular.isDefined(stateId) && stateId !== '') {
                $scope.M.getTownsByState(stateId);
            }
        });
        function init() {
            var needed = [
                $scope.dataNeededPromise,
                $scope.statesObjsPromise
            ];
            Promise.all(needed).then(function () {
                var permissionIntegrationsHumand = userHasPermissionFilter(AppF.groupsOfUser, AppF.permissions, 'integrationHumand', 'organization.firms');
                var permissionGeoVictoria = userHasPermissionFilter(AppF.groupsOfUser, AppF.permissions, 'integrationGeoVictoria', 'organization.firms');
                var integrationBuk = userHasPermissionFilter(AppF.groupsOfUser, AppF.permissions, 'integrationBuk', 'organization.firms');

                if (permissionIntegrationsHumand || permissionGeoVictoria || integrationBuk) {
                    $scope.visibleIntegration = true;
                }
                if (integrationBuk) {
                    $scope.visibleIntegrationBuk = true;
                }
                if (permissionGeoVictoria) {
                    $scope.visibleIntegrationGeoVictoria = true;
                }
                if (permissionIntegrationsHumand) {
                    $scope.visibleIntegrationHumand = true;
                }
                $scope.firm.center = $scope.F.center;
                if (!angular.isArray($scope.firm.companies)) {
                    $scope.firm.companies = [];
                }
                if (angular.isArray($scope.firm.companies) && $scope.firm.companies.length > 0) {
                    $scope.setCompanySelected($scope.firm.companies[0]);
                }
                $rootScope.$evalAsync();
                $timeout(function () { }, 0, false);
            }).catch(function (error) {
                errAlertS(error);
            });
        }
        $scope.saveSyncConfig = function (firm, service, config) {
            $log.log(firm, service, config);
            if (angular.isUndefined(firm.syncConfig)) {
                firm.syncConfig = {};
            }
            if (angular.isUndefined(firm.syncConfig[service])) {
                firm.syncConfig[service] = {};
            }
            for (var key in config) {
                if (config.hasOwnProperty(key)) {
                    firm.syncConfig[service][key] = config[key];
                }
            }
            config = {};
        }
        startAfterInitFilter($scope, $scope.listWatchers, initiated, init);
    }
})();
(function () {
    'use strict';

    angular
        .module('app.clients')
        .controller('AuthTokensController', AuthTokensController)
        .controller('AuthTokenCreateController', AuthTokenCreateController);

    /** @ngInject */
    function AuthTokensController($scope, $q, $mdDialog, $document, AuthTokensF, errAlertS, successAlertS, translateFilter, menuNameFilter, AppF) {
        var contextType = $scope.authTokenContext && $scope.authTokenContext.type === 'centerOnly' ? 'centerOnly' : 'firmOnly';
        $scope.authTokensLoading = true;
        $scope.authTokens = [];
        $scope.authTokenPermissions = [];
        $scope.authTokenFirm = null;
        $scope.authTokenPermissionNames = {};
        $scope.canCreateTokenForFirm = false;
        $scope.authTokenTitle = contextType === 'centerOnly' ? 'Mis tokens de acceso' : 'Tokens de acceso';
        $scope.authTokenDescription = contextType === 'centerOnly' ?
            'Administre sus llaves delegadas para consumir la API.' :
            'Administre las llaves delegadas de';

        function getFirmId() {
            return $scope.firm && ($scope.firm.$id || $scope.firm.fid);
        }

        function getScopeId() {
            return contextType === 'centerOnly' ? AppF.center : getFirmId();
        }

        function load() {
            var scopeId = getScopeId();
            if (!scopeId || scopeId === 'new' || (contextType === 'centerOnly' && !AppF.isAdmin)) {
                $scope.authTokensLoading = false;
                return $q.when();
            }
            $scope.authTokensLoading = true;
            return $q.all([
                AuthTokensF.getCenters(),
                AuthTokensF.getFirms(),
                AuthTokensF.getPermissions(),
                AuthTokensF.list()
            ])
                .then(function (responses) {
                    var firmAccess = responses[1].data;
                    $scope.authTokenPermissions = responses[2].data.permissions || [];
                    $scope.authTokenPermissionNames = {};
                    $scope.authTokenPermissions.forEach(function (permission) {
                        var sectionName = translateFilter('permission.' + permission.section) || permission.section;
                        var moduleName = menuNameFilter(permission.module) || permission.module;
                        var actionName = translateFilter('p.' + permission.action) || permission.action;
                        $scope.authTokenPermissionNames[permission.key] = sectionName + ' / ' + moduleName + ' — ' + actionName;
                    });
                    $scope.authTokenFirm = null;
                    if (contextType === 'firmOnly') {
                        (firmAccess.firms || []).some(function (item) {
                            if (item.id === scopeId) {
                                $scope.authTokenFirm = item;
                                return true;
                            }
                            return false;
                        });
                        $scope.canCreateTokenForFirm = !!$scope.authTokenFirm;
                    } else {
                        var centers = responses[0].data.centers || [];
                        $scope.canCreateTokenForFirm = centers.some(function (center) {
                            return center.id === scopeId && center.isCurrent === true;
                        });
                    }
                    var currentUser = firebase.auth().currentUser;
                    $scope.authTokens = (responses[3].data || []).filter(function (token) {
                        if (contextType === 'centerOnly') {
                            return token.scopeType === 'centerOnly' && token.center === scopeId &&
                                token.owner && currentUser && token.owner.uid === currentUser.uid;
                        }
                        return token.scopeType === 'firmOnly' && token.firm === scopeId;
                    });
                }).catch(errAlertS).finally(function () {
                    $scope.authTokensLoading = false;
                });
        }

        $scope.openAuthTokenCreate = function (ev) {
            if (!$scope.canCreateTokenForFirm) return;
            $mdDialog.show({
                templateUrl: 'app/main/clients/views/firms/authTokenCreate.html',
                controller: 'AuthTokenCreateController',
                parent: angular.element($document[0].body),
                targetEvent: ev,
                clickOutsideToClose: false,
                escapeToClose: false,
                locals: {
                    tokenScope: {
                        id: getScopeId(),
                        type: contextType,
                        name: contextType === 'firmOnly' && $scope.firm.data ? $scope.firm.data.name : null
                    },
                    availablePermissions: $scope.authTokenPermissions
                }
            }).then(function (createdToken) {
                if (createdToken) $scope.authTokens.unshift(createdToken);
            }).catch(angular.noop);
        };

        $scope.getAuthTokenPermissionName = function (permissionKey) {
            return $scope.authTokenPermissionNames[permissionKey] || permissionKey;
        };

        $scope.getAuthTokenStatusName = function (status) {
            var names = {
                active: 'Activo',
                revoked: 'Revocado',
                expired: 'Expirado'
            };
            var statusKey = angular.isString(status) ? status.toLowerCase() : status;
            return names[statusKey] || status;
        };

        $scope.revokeAuthToken = function (token, ev) {
            if (!token.canRevoke) return;
            var confirm = $mdDialog.confirm()
                .title('Revocar token')
                .textContent('La integración que usa "' + token.name + '" dejará de funcionar inmediatamente.')
                .targetEvent(ev).ok('Revocar').cancel('Cancelar');
            $mdDialog.show(confirm).then(function () {
                token.revoking = true;
                return AuthTokensF.revoke(token.id);
            }).then(function () {
                token.status = 'revoked';
                token.canRevoke = false;
                successAlertS('Token revocado correctamente');
            }).catch(function (error) {
                if (error) errAlertS(error);
            }).finally(function () {
                token.revoking = false;
            });
        };

        $scope.reloadAuthTokens = load;
        load();
    }

    /** @ngInject */
    function AuthTokenCreateController($scope, $q, $mdDialog, $document, $window, AuthTokensF, errAlertS, successAlertS, translateFilter, menuNameFilter, tokenScope, availablePermissions) {
        var tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        tomorrow.setHours(0, 0, 0, 0);
        $scope.tokenScope = tokenScope;
        $scope.availablePermissions = availablePermissions;
        $scope.permissionSections = [];
        $scope.permissionUi = {
            selectedSection: null
        };
        $scope.minExpirationDate = tomorrow;
        $scope.saving = false;
        $scope.secretHandled = false;
        $scope.showAdvancedConfiguration = false;
        $scope.view = 'form';
        $scope.tokenData = {
            name: '', type: 'permanent', permissionMode: 'selected', permissions: [], expires: false, expiresAtDate: null,
            allowedIpsText: '', allowedOriginsText: '', restrictUrlsText: ''
        };

        function buildPermissionSections() {
            var sections = {};
            availablePermissions.forEach(function (permission) {
                var sectionKey = permission.section || 'other';
                var moduleKey = permission.module || 'other';
                if (!sections[sectionKey]) {
                    sections[sectionKey] = {
                        key: sectionKey,
                        name: translateFilter('permission.' + sectionKey) || permission.section || 'Otros',
                        modules: {},
                        moduleList: []
                    };
                }
                if (!sections[sectionKey].modules[moduleKey]) {
                    var moduleData = {
                        key: moduleKey,
                        name: menuNameFilter(moduleKey) || permission.module || 'Otros',
                        permissions: []
                    };
                    sections[sectionKey].modules[moduleKey] = moduleData;
                    sections[sectionKey].moduleList.push(moduleData);
                }
                permission.name = translateFilter('p.' + permission.action) || permission.action;
                sections[sectionKey].modules[moduleKey].permissions.push(permission);
            });
            angular.forEach(sections, function (section) {
                section.moduleList.sort(function (a, b) { return a.name.localeCompare(b.name); });
                $scope.permissionSections.push(section);
            });
            $scope.permissionSections.sort(function (a, b) { return a.name.localeCompare(b.name); });
            if ($scope.permissionSections.length) {
                $scope.permissionUi.selectedSection = $scope.permissionSections[0].key;
            }
        }

        $scope.getSelectedPermissionSection = function () {
            for (var i = 0; i < $scope.permissionSections.length; i++) {
                if ($scope.permissionSections[i].key === $scope.permissionUi.selectedSection) {
                    return $scope.permissionSections[i];
                }
            }
            return { moduleList: [] };
        };

        $scope.isPermissionSelected = function (permissionKey) {
            return $scope.tokenData.permissions.indexOf(permissionKey) !== -1;
        };

        $scope.togglePermission = function (permissionKey) {
            var index = $scope.tokenData.permissions.indexOf(permissionKey);
            if (index === -1) $scope.tokenData.permissions.push(permissionKey);
            else $scope.tokenData.permissions.splice(index, 1);
            $scope.tokenData.permissions = $scope.tokenData.permissions.slice();
        };

        $scope.getModuleSelectionState = function (moduleData) {
            var selected = 0;
            moduleData.permissions.forEach(function (permission) {
                if ($scope.isPermissionSelected(permission.key)) selected++;
            });
            return {
                checked: selected === moduleData.permissions.length && selected > 0,
                indeterminate: selected > 0 && selected < moduleData.permissions.length
            };
        };

        $scope.toggleModulePermissions = function (moduleData) {
            var selectAll = !$scope.getModuleSelectionState(moduleData).checked;
            moduleData.permissions.forEach(function (permission) {
                var index = $scope.tokenData.permissions.indexOf(permission.key);
                if (selectAll && index === -1) $scope.tokenData.permissions.push(permission.key);
                if (!selectAll && index !== -1) $scope.tokenData.permissions.splice(index, 1);
            });
            $scope.tokenData.permissions = $scope.tokenData.permissions.slice();
        };

        $scope.toggleAdvancedConfiguration = function () {
            $scope.showAdvancedConfiguration = !$scope.showAdvancedConfiguration;
        };

        buildPermissionSections();

        function splitValues(value) {
            if (!value) return [];
            return value.split(/[\n,]+/).map(function (item) { return item.trim(); })
                .filter(function (item) { return item.length > 0; });
        }

        $scope.createToken = function (form) {
            if ($scope.view !== 'form' || !$scope.tokenData) return;
            if (!form) {
                errAlertS('No fue posible validar el formulario. Cierre el diálogo e intente nuevamente.');
                return;
            }
            if ($scope.tokenData.permissionMode === 'selected' && !$scope.tokenData.permissions.length) {
                form.$setSubmitted();
                return;
            }
            if (form.$invalid || $scope.saving) {
                form.$setSubmitted();
                return;
            }
            var model = $scope.tokenData;
            var payload = {
                name: model.name.trim(), type: model.type, scopeType: tokenScope.type,
                permissionMode: model.permissionMode, allowedIps: splitValues(model.allowedIpsText),
                allowedOrigins: splitValues(model.allowedOriginsText), restrictUrls: splitValues(model.restrictUrlsText)
            };
            if (tokenScope.type === 'centerOnly') payload.center = tokenScope.id;
            else payload.firm = tokenScope.id;
            if (model.permissionMode === 'selected') payload.permissions = model.permissions.slice();
            if (model.expires && model.expiresAtDate) payload.expiresAt = model.expiresAtDate.getTime();
            $scope.saving = true;
            AuthTokensF.create(payload).then(function (response) {
                $scope.createdToken = response.data;
                $scope.tokenData = null;
                $scope.view = 'secret';
            }).catch(errAlertS).finally(function () {
                $scope.saving = false;
            });
        };

        function markSecretHandled() {
            $scope.secretHandled = true;
            successAlertS('Header de autorización guardado');
        }

        function copyWithFallback(value) {
            var textarea = $document[0].createElement('textarea');
            textarea.value = value;
            textarea.setAttribute('readonly', 'readonly');
            textarea.style.position = 'fixed';
            textarea.style.opacity = '0';
            $document[0].body.appendChild(textarea);
            textarea.select();
            try {
                if (!$document[0].execCommand('copy')) throw new Error('copy failed');
                markSecretHandled();
            } catch (error) {
                errAlertS('No fue posible copiar automáticamente. Seleccione y copie el header manualmente.');
            } finally {
                $document[0].body.removeChild(textarea);
            }
        }

        $scope.copySecret = function () {
            var value = $scope.createdToken.authorizationHeader;
            if ($window.navigator.clipboard && $window.navigator.clipboard.writeText) {
                $q.when($window.navigator.clipboard.writeText(value)).then(markSecretHandled)
                    .catch(function () { copyWithFallback(value); });
            } else copyWithFallback(value);
        };

        $scope.downloadSecret = function () {
            var blob = new Blob([$scope.createdToken.authorizationHeader + '\r\n'], { type: 'text/plain;charset=utf-8' });
            var url = $window.URL.createObjectURL(blob);
            var link = $document[0].createElement('a');
            link.href = url;
            link.download = 'tds-delegate-' + $scope.createdToken.id + '.txt';
            $document[0].body.appendChild(link);
            link.click();
            $document[0].body.removeChild(link);
            $window.URL.revokeObjectURL(url);
            markSecretHandled();
        };

        $scope.cancel = function () {
            if ($scope.view === 'secret' && !$scope.secretHandled) return;
            var result = $scope.createdToken;
            $scope.createdToken = null;
            if (result) {
                delete result.token;
                delete result.authorizationHeader;
            }
            $mdDialog.hide(result);
        };
    }
}());

(function() {
    'use strict';

    angular
        .module('app.clients')
        .controller('DashboardClientsController', DashboardClientsController);

    /** @ngInject */
    function DashboardClientsController($scope, Dashboard) {
        var root = $scope.F.root;

        // Data
        $scope.dashboard = Dashboard;

        $scope.widget1 = $scope.dashboard.widget1;
        $scope.widget2 = $scope.dashboard.widget2;
        $scope.widget3 = $scope.dashboard.widget3;
        $scope.widget4 = $scope.dashboard.widget4;
        $scope.widget5 = {
            title: $scope.dashboard.widget5.title,
            mainChart: {
                config: {
                    refreshDataOnly: true,
                    deepWatchData: true
                },
                options: {
                    chart: {
                        type: 'multiBarChart',
                        color: ['#03a9f4', '#b3e5fc'],
                        height: 420,
                        margin: {
                            top: 8,
                            right: 16,
                            bottom: 32,
                            left: 32
                        },
                        clipEdge: true,
                        groupSpacing: 0.3,
                        reduceXTicks: false,
                        stacked: true,
                        duration: 250,
                        x: function(d) {
                            return d.x;
                        },
                        y: function(d) {
                            return d.y;
                        },
                        yAxis: {
                            tickFormat: function(d) {
                                return d;
                            }
                        },
                        legend: {
                            margin: {
                                top: 8,
                                bottom: 32
                            }
                        },
                        controls: {
                            margin: {
                                top: 8,
                                bottom: 32
                            }
                        },
                        tooltip: {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data: []
            },
            days: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
            ranges: $scope.dashboard.widget5.ranges,
            currentRange: '',
            changeRange: function(range) {
                $scope.widget5.currentRange = range;

                /**
                 * Update main chart data by iterating through the
                 * chart dataset and separately adding every single
                 * dataset by hand.
                 *
                 * You MUST NOT swap the entire data object by doing
                 * something similar to this:
                 * $scope.widget.mainChart.data = chartData
                 *
                 * It would be easier but it won't work with the
                 * live updating / animated charts due to how d3
                 * works.
                 *
                 * If you don't need animated / live updating charts,
                 * you can simplify these greatly.
                 */
                angular.forEach($scope.dashboard.widget5.mainChart, function(chartData, index) {
                    $scope.widget5.mainChart.data[index] = {
                        key: chartData.key,
                        values: chartData.values[range]
                    };
                });
            },
            init: function() {
                // Run this function once to initialize widget

                /**
                 * Update the range for the first time
                 */
                $scope.widget5.changeRange('TW');
            }
        };

        // Widget 6
        $scope.widget6 = {
            title: $scope.dashboard.widget6.title,
            mainChart: {
                config: {
                    refreshDataOnly: true,
                    deepWatchData: true
                },
                options: {
                    chart: {
                        type: 'pieChart',
                        color: ['#f44336', '#9c27b0', '#03a9f4', '#e91e63'],
                        height: 400,
                        margin: {
                            top: 0,
                            right: 0,
                            bottom: 0,
                            left: 0
                        },
                        donut: true,
                        clipEdge: true,
                        cornerRadius: 0,
                        labelType: 'percent',
                        padAngle: 0.02,
                        x: function(d) {
                            return d.label;
                        },
                        y: function(d) {
                            return d.value;
                        },
                        tooltip: {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data: []
            },
            footerLeft: $scope.dashboard.widget6.footerLeft,
            footerRight: $scope.dashboard.widget6.footerRight,
            ranges: $scope.dashboard.widget6.ranges,
            currentRange: '',
            changeRange: function(range) {
                $scope.widget6.currentRange = range;

                /**
                 * Update main chart data by iterating through the
                 * chart dataset and separately adding every single
                 * dataset by hand.
                 *
                 * You MUST NOT swap the entire data object by doing
                 * something similar to this:
                 * $scope.widget.mainChart.data = chartData
                 *
                 * It would be easier but it won't work with the
                 * live updating / animated charts due to how d3
                 * works.
                 *
                 * If you don't need animated / live updating charts,
                 * you can simplify these greatly.
                 */
                angular.forEach($scope.dashboard.widget6.mainChart, function(data, index) {
                    $scope.widget6.mainChart.data[index] = {
                        label: data.label,
                        value: data.values[range]
                    };
                });
            },
            init: function() {
                // Run this function once to initialize widget

                /**
                 * Update the range for the first time
                 */
                $scope.widget6.changeRange('TW');
            }
        };

        // Widget 7
        $scope.widget7 = {
            title: $scope.dashboard.widget7.title,
            ranges: $scope.dashboard.widget7.ranges,
            customers: $scope.dashboard.widget7.customers,
            currentRange: 'T'
        };

        // Methods

        //////////

        // Initialize Widget 5
        $scope.widget5.init();

        // Initialize Widget 6
        $scope.widget6.init();
    }
})();
(function () {
    'use strict';

    angular
        .module('app.clients')
        .controller('CcsController', CcsController);

    function CcsController(
        $scope,
        $log,
        $filter,
        errAlertS,
        getSomethingOfArrayFBFilter,
        $rootScope,
        successAlertS,
        confirmConfig,
        $mdDialog,
        DataF
    ) {

        function disableCc(e) {

            var total = $scope.selected.length;
            $mdDialog.show($mdDialog.confirm(confirmConfig)
                .title("Desactivar " + total + " centro(s) de costo(s)")
                .content("Se desactivaran los centros de costo seleccionados, ¿Desea Continuar?")
                .ariaLabel('Deleting')
                .targetEvent(e)
                .ok('Desactivar')
                .cancel('Cancelar'))
                .then(function () {
                    $rootScope.loadingProgress = true;
                    var updates = {};
                    for (var i = 0; i < $scope.selected.length; i++) {
                        updates[$scope.selected[i].$id + "/valid"] = false;
                        updates[$scope.selected[i].$id + "/updated"] = DataF.getTimeObject();
                    }
                    $scope.F.root.child('catalogs/ccs/collection').update(updates, function (error) {
                        if (error) {
                            $log.error(error);
                            errAlertS('Error al desactivar los centros de costo');
                        } else {
                            successAlertS('Se desactivaron ' + total + ' con exito');
                        }
                    }).then(function () {
                        $scope.selected = [];
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync();
                    })
                }, function () {
                    $log.debug('Deleting Cancelled');
                });
        }
        $scope.disableCc = disableCc;
    }
})();
(function () {
    'use strict';

    angular
        .module('app.clients')
        .controller('CcController', CcController);

    function CcController(
        $scope,
        $log,
        $filter,
        errAlertS,
        getSomethingOfArrayFBFilter,
        $rootScope,
        successAlertS,
        checkIfEnableFilter,
        getFromObjectFilter
    ) {
        var initiated = false;
        $scope.employeesTochange = [];
        $scope.rps = [];
        var objRps = {};
        var extraParams = ["project_id", "name", "union_id", "healthCare", "rp_id", "place"];
        for (var e in extraParams) {
            var extraParam = extraParams[e];
            if ($scope[extraParam]) {
                $log.debug($scope[extraParam], extraParam)
                $scope.cc.data[extraParam] = $scope[extraParam];
            }
        }
        function init() {
            var needed = [
                $scope.dataNeededPromise,
                $scope.statesObjsPromise
            ];
            $scope.cc.center = $scope.F.center;
            Promise.all(needed).then(function () {
                if (angular.isDefined(getFromObjectFilter($scope.cc, 'payroll'))) {
                    var payrolls = ($scope.F.permissionToAccessAllPayrolls) ? $scope.L.allPayrolls : $scope.L.payrolls;
                    var payroll = payrolls.find(function (value) {
                        return value.$id === $scope.cc.payroll;
                    });
                    if (angular.isDefined(payroll)) {
                        $scope.filterRp(payroll, $scope.L.rps);
                    } else {
                        errAlertS("No se encontró los datos de la nómina");
                    }
                }
            }).catch(errAlertS);
        }
        $scope.disableAlert = function (enable, rps) {
            if (enable) {
                $rootScope.loadingProgress = true;
                var route = 'catalogs/rps/collection/' + rps + '/active';
                checkIfEnableFilter(route).then(function (response) {
                    if (!response) {
                        $scope.cc.valid = false;
                        errAlertS("No se puede activar el centro de costo porque está desactivado el registro patronal en el que pertenece");
                    }
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                }).catch(function (error) {
                    errAlertS(error);
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                });
            }
        }
        // observa cuando cambia la nómina y carga sus proyectos
        $scope.detailWatchers.ccPayroll = $scope.$watch('cc.payroll', function (payrollId) {
            if (angular.isDefined(payrollId) && payrollId != '' && payrollId !== 'all') {
                var payrollIsActive = getSomethingOfArrayFBFilter(payrollId, $scope.L.allPayrolls, 'active');
                if (payrollIsActive || !$scope.F.addMode) {
                    var firmId = $filter('getSomethingOfArrayFB')(payrollId, $scope.L.allPayrolls, 'firm');
                    $log.debug(payrollId, firmId, 'payroll changed, firmId');
                    $scope.F.search.$payroll = payrollId;
                } else {
                    if ($scope.F.addMode) {
                        errAlertS('La nómina pre-seleccionada no está activa');
                        $scope.cc.payroll = null;
                    }
                }
            }
        });

        if (!$scope.F.addMode) {
            $scope.detailWatchers.ccRp = $scope.$watch('cc.data.rp_id', function (rpId, oldRpId) {
                $scope.employeesTochange = [];
                if (rpId && oldRpId && rpId != oldRpId) {
                    $rootScope.loadingProgress = true;
                    var params = {
                        page: .5
                    };
                    params.status = {
                        "$in": [2, 1]
                    };
                    params.cc = $scope.cc.$id;
                    $scope.D.api.get('p/employees', params).then(function (res) {
                        var employees = res.data.data;
                        var diferrencesFounded = false;
                        if (employees.length) {
                            $scope.employeesTochange = employees;
                            var msg = "Se hara el cambio de rp de los siguientes empleados:<ul>";
                            for (var e in employees) {
                                if (employees[e].rp != rpId) {
                                    diferrencesFounded = true;
                                    msg += ("<li>" + employees[e].data.name + "</li>");
                                }
                            }
                            msg += "</ul>";
                        }
                        if (diferrencesFounded) {
                            successAlertS(msg);
                        }
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync();
                    }).catch(function (err) {
                        errAlertS(err);
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync();
                    });
                }
            })
        }

        $scope.saveCc = function (cc) {
            $scope.save(cc, 1).then(function () {
                if ($scope.employeesTochange.length) {
                    var updates = {};
                    for (var e in $scope.employeesTochange) {
                        var employee = $scope.employeesTochange[e];
                        updates[employee.fid + '/rp'] = cc.data.rp_id;
                    }
                    $scope.F.root.child('catalogs/employees/collection').update(updates).then(function () {
                        successAlertS('Se guardó el centro de costo y se actualizaron los empleados con éxito');
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync(function () {
                            $log.debug('save cc finished');
                        });
                        $scope.R.goToList();
                    })
                } else {
                    successAlertS('Se guardó el centro de costo con éxito');
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync(function () {
                        $log.debug('save cc finished');
                    });
                    $scope.R.goToList();
                }
            });
        }
        $scope.filterRp = function (payroll, rps) {
            if (!objRps.hasOwnProperty(payroll.$id)) {
                if (angular.isDefined(payroll) && angular.isDefined(payroll.processes)) {
                    var companiesRecord = [];
                    var rpsF = [];
                    for (var p in payroll.processes) {
                        if (payroll.processes[p].companiesRecord) {
                            companiesRecord.push(payroll.processes[p].companiesRecord);
                        }
                    }
                    for (var c = 0; c < companiesRecord.length; c++) {
                        var filter = rps.filter(function (value) {
                            return value.companiesRecord === companiesRecord[c];
                        });
                        for (var i = 0; i < filter.length; i++) {
                            var index = rpsF.findIndex(function (item) {
                                return item.$id === filter[i].$id;
                            });
                            if (index === -1) {
                                rpsF.push(filter[i]);
                            }
                        }
                    }
                    $scope.rps = rpsF;
                    objRps[payroll.$id] = rpsF;
                }
            } else {
                $scope.rps = objRps[payroll.$id];
            }
        }
        $scope.detailWatchers.finalListener = $scope.$on("$destroy", function () {
            for (var f in $scope.detailWatchers) {
                //$log.debug('stopping $watcher', f);
                $scope.detailWatchers[f]();
            }
        });
        if ($scope.objectLoaded) {
            if (!initiated) { init(); }
        } else {
            $log.debug('setting watcher to mainObjLoaded');
            $scope.detailWatchers.mainObjLoaded = $rootScope.$on('mainObjectLoaded', function () {
                if (!initiated) {
                    init();
                }
                $scope.detailWatchers.mainObjLoaded();
                delete $scope.detailWatchers.mainObjLoaded;
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.clients')
        .controller('CompaniesRecordController', CompaniesRecordController);

    function CompaniesRecordController(
        $rootScope,
        $scope,
        startAfterInitFilter,
        $log,
        $window,
        errAlertS,
        userHasPermissionFilter,
        AppF,
        ApiV3F,
        $timeout,
        successAlertS
    ) {
        var initiated = false;
        $scope.listWatchers = {};
        $scope.isLegalPerson = function (is) {
            if (is) {
                delete $scope.companiesRecord.data.societyType;
                $scope.setSocietyType($scope.companiesRecord.data.onlyName, $scope.companiesRecord.data.societyType)
            }
        }
        $scope.setSocietyType = function (name, type) {
            var finalName = name ? name : 'Empresa Nueva';
            finalName = finalName + (type ? ' ' + type : '');
            $log.log(finalName);
            $scope.companiesRecord.data.businessName = finalName;
        }
        $scope.downloadFile = function (filePath, extension) {
            $scope.D.files.getTempUrlFromStorage({ filePath: filePath }).then(function (data) {
                var url = data.data;
                var xhr = new XMLHttpRequest();
                xhr.responseType = 'blob';
                xhr.onload = function () {
                    var blob = xhr.response;
                    var url = $window.URL.createObjectURL(blob);
                    var linkElement = document.createElement('a');
                    linkElement.setAttribute('href', url);
                    linkElement.setAttribute('download', $scope.companiesRecord.data.name + '.' + extension);
                    var clickEvent = new MouseEvent('click', {
                        'view': window,
                        'bubbles': true,
                        'cancelable': false
                    });
                    linkElement.dispatchEvent(clickEvent);
                };
                xhr.open('GET', url);
                xhr.send();
            }).catch(errAlertS);
        };
        $scope.checkCertExpiration = function (companiesRecordId) {
            return new Promise(function (resolve, reject) {
                $scope.D.files.checkCerValidation(companiesRecordId).then(function (data) {
                    $log.log('datos del registro cerFile', data.data)
                    var thisData = data.data;
                    $log.log(thisData);
                    if (angular.isObject(thisData) && thisData.notAfter) {
                        $scope.companiesRecord.expirationDate = moment(thisData.notAfter).valueOf();
                    } else {
                        throw 'No se pudo obtener la fecha de expiración';
                    }
                    resolve(true);
                }).catch(reject);
            });
        };
        $scope.uploadCerFile = function (cerFile) {
            $scope.upload(cerFile, $scope.F.active.detailObject, false, 'cerFile', true).then(function () {
                return $scope.checkCertExpiration($scope.companiesRecord.$id);
            }).then(function () {
                $log.log('se termino');
            }).catch(function (error) {
                errAlertS(error);
            });
        };


        $scope.checkCertExpirationFiel = function (companiesRecordId) {
            return new Promise(function (resolve, reject) {
                $scope.D.files.checkCerValidationFiel(companiesRecordId).then(function (data) {
                    $log.log('datos del registro fiel', data.data)
                    var thisData = data.data;
                    $log.log(thisData);
                    if (angular.isObject(thisData) && thisData.notAfter) {
                        $scope.companiesRecord.expirationDateFiel = moment(thisData.notAfter).valueOf();
                    } else {
                        throw 'No se pudo obtener la fecha de expiración';
                    }
                    resolve(true);
                }).catch(reject);
            });
        };


        $scope.uploadCerFiel = function (cerFiel) {
            $scope.upload(cerFiel, $scope.F.active.detailObject, false, 'cerFiel', true).then(function () {
                return $scope.checkCertExpirationFiel($scope.companiesRecord.$id);
            }).then(function () {
                $log.log('se termino');
            }).catch(function (error) {
                errAlertS(error);
            });
        }

        $scope.disable = function (id, name) {
            $rootScope.loadingProgress = true;
            $scope.F.root.child('catalogs/rps/collection').orderByChild('companiesRecord').equalTo(id).once('value').then(function (snapshot) {
                var active = false;
                var message = '';
                var rps = '';
                if (snapshot.exists()) {
                    snapshot.forEach(function (value) {
                        var item = value.val();
                        if (item.active) {
                            active = true;
                            rps += '<li>' + item.data.shortName + '</li>';
                        }
                    });
                    if (active) {
                        $scope.companiesRecord.active = true;
                        message += 'No se puede desactivar esta empresa ' + angular.lowercase(name) + ' porque hay registros patronales activos';
                        errAlertS(message + '<ul>' + rps + '</ul>');
                    }
                }
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
            }).catch(function (error) {
                errAlertS(error);
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
            });
        };
        $scope.showPassword = false;
        $scope.passwordVisibility = function () {
            $scope.showPassword = !$scope.showPassword;
        };
        $scope.showPasswordFiel = false;
        $scope.passwordVisibilityFiel = function () {
            $scope.showPasswordFiel = !$scope.showPasswordFiel;
        };
        $scope.setNotificationExpirationDate = function (timePeriod, expirationDate) {
            var notificationDate = null;
            if (expirationDate && timePeriod) {
                var mExpirationDate = moment(expirationDate);
                mExpirationDate.subtract(1, timePeriod);
                notificationDate = mExpirationDate.valueOf();
                $log.log(mExpirationDate.format('YYYY-MM-DD'));
            }
            $scope.companiesRecord.expirationDateNotification = notificationDate;
        };

        $scope.setNotificationExpirationDateFiel = function (timePeriod, expirationDate) {
            var notificationDate = null;
            if (expirationDate && timePeriod) {
                var mExpirationDate = moment(expirationDate);
                mExpirationDate.subtract(1, timePeriod);
                notificationDate = mExpirationDate.valueOf();
                $log.log(mExpirationDate.format('YYYY-MM-DD'));
            }
            $scope.companiesRecord.expirationDateNotificationFiel = notificationDate;
        };







        $scope.analicesFile = function (type) {
            $rootScope.loadingProgress = true;
            var cer;
            var key;
            var pass;
            var obj;

            if (type === 'csd') {
                cer = $scope.cerFile.length > 0 ? $scope.cerFile[0].lfFile : $scope.companiesRecord.cerFile;
                key = $scope.keyFile.length > 0 ? $scope.keyFile[0].lfFile : $scope.companiesRecord.keyFile;
                pass = $scope.companiesRecord.password;
                obj = {
                    cer: $scope.cerFile.length > 0 ? $scope.cerFile[0].lfFile : undefined,
                    key: $scope.keyFile.length > 0 ? $scope.keyFile[0].lfFile : undefined,
                    cerUrl: $scope.cerFile.length === 0 ? $scope.companiesRecord.cerFile : undefined,
                    keyUrl: $scope.keyFile.length === 0 ? $scope.companiesRecord.keyFile : undefined,
                    pass: pass
                };
                if (cer && key && pass) {
                    if (!validateLfSize($scope.cerFile, 'El .cer', 500)) {
                        $scope.cerFile = [];
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync();
                        return;
                    }

                    $log.log('validando key', $scope.keyFile);
                    if (!validateLfSize($scope.keyFile, 'El .key', 500)) {
                        $scope.keyFile = [];
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync();
                        return;
                    }

                    ApiV3F.post("files/ValidateCerAndKey/", obj, true).then(function (resp) {
                        $log.log('resp', resp.data);
                        var data = resp.data.result;
                        if (data.errors) {
                            errAlertS(data.errors);
                            $scope.companiesRecord.saveFilesCsd = true;
                        } else {
                            successAlertS('Los archivos son válidos');
                            $scope.companiesRecord.saveFilesCsd = false;
                        }
                    }).catch(function (err) {
                        $log.error(err);
                    }).finally(function () {
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync();
                    });
                    return;
                }
            }

            if (type === 'fiel') {
                cer = $scope.cerFiel.length > 0 ? $scope.cerFiel[0].lfFile : $scope.companiesRecord.cerFiel;
                key = $scope.keyFiel.length > 0 ? $scope.keyFiel[0].lfFile : $scope.companiesRecord.keyFiel;
                pass = $scope.companiesRecord.passFiel;
                obj = {
                    cer: $scope.cerFiel.length > 0 ? $scope.cerFiel[0].lfFile : undefined,
                    key: $scope.keyFiel.length > 0 ? $scope.keyFiel[0].lfFile : undefined,
                    cerUrl: $scope.cerFiel.length === 0 ? $scope.companiesRecord.cerFiel : undefined,
                    keyUrl: $scope.keyFiel.length === 0 ? $scope.companiesRecord.keyFiel : undefined,
                    pass: pass
                };
                if (cer && key && pass) {
                    if (!validateLfSize($scope.keyFile, 'El .key', 500)) {
                        $scope.keyFile = [];
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync();
                        return;
                    }
                    if (!validateLfSize($scope.cerFile, 'El .cer', 500)) {
                        $scope.cerFile = [];
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync();
                        return;
                    }
                    ApiV3F.post("files/ValidateCerAndKey/", obj, true).then(function (resp) {
                        $log.log('resp', resp.data);
                        var data = resp.data.result;
                        if (data.errors) {
                            errAlertS(data.errors);
                            $scope.companiesRecord.saveFilesFiel = true;
                        } else {
                            successAlertS('Los archivos son válidos');
                            $scope.companiesRecord.saveFilesFiel = false;
                        }
                    }).catch(function (err) {
                        $log.error(err);
                    }).finally(function () {
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync();
                    });
                    return;
                }
            }
            $rootScope.loadingProgress = false;
            $rootScope.$evalAsync();
        };


        function validateLfSize(fileArr, label, minBytes) {
            minBytes = minBytes || 500;
            if (!fileArr || fileArr.length === 0) return true;

            var f = fileArr[0] && fileArr[0].lfFile;
            if (!f) return false;

            if (!f.size || f.size <= 0) {
                errAlertS(label + ' está vacío (0 KB). Selecciona un archivo válido.');
                return false;
            }
            if (f.size < minBytes) {
                errAlertS(label + ' es demasiado pequeño para ser válido.');
                return false;
            }

            return true;
        }



        // observa cuando cambia el estado para poblar los municipios
        $scope.listWatchers.companies = $scope.$watch('companiesRecord.data.location.state_id', function (stateId) {
            if (angular.isDefined(stateId) && stateId !== '') {
                $scope.M.getTownsByState(stateId);
            }
        });
        function init() {
            $scope.verFielSat = userHasPermissionFilter(AppF.groupsOfUser, AppF.permissions, 'verFiel', $scope.F.active.menuItem);
            $scope.verFielCsd = userHasPermissionFilter(AppF.groupsOfUser, AppF.permissions, 'verCsd', $scope.F.active.menuItem);
            $scope.companiesRecord.center = $scope.F.center;
            $scope.companiesRecord.client = $scope.F.profile.firm;
        }
        startAfterInitFilter($scope, $scope.listWatchers, initiated, init);
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('sendBillsEmail', sendBillsEmail)

    function sendBillsEmail($rootScope, $filter, $mdDialog, confirmConfig, errAlertS, $timeout, $http, $window, successAlertS) {

        function responseError(error, errors, resolve) {
            errors = angular.isArray(errors) ? errors : [];
            if (angular.isArray(error)) {
                if (error.length > 0) {
                    errors = errors.concat(error);
                }
            } else if (angular.isDefined(error)) {
                errors.push(error);
            }
            resolve(errors)
        }
        function getEmployeesSendStatus(employees, sentStatus, errors) {
            return new Promise(function (resolve) {
                try {
                    var original = employees.length;
                    var uids = [];
                    errors = angular.isArray(errors) ? errors : [];
                    sentStatus = angular.isDefined(sentStatus) ? sentStatus : { pending: [], sent: [] };
                    var e = 0;
                    while (e < employees.length && uids.length < 50) {
                        var employee = employees.shift();
                        if (employee.uuid) {
                            uids.push(employee.uuid);
                        }
                    }
                    var query = { uuid: JSON.stringify({ $in: uids }), sentStatus: JSON.stringify({ $exists: true }), project: angular.toJson({ sentStatus: 1, uuid: 1 }) };
                    $rootScope.D.api.get('bills', query).then(function (response) {
                        for (var r = 0; r < response.data.length; r++) {
                            var thisRecord = response.data[r];
                            var indexEmployee = uids.findIndex(function (item) {
                                return item === thisRecord.uuid;
                            });
                            if (thisRecord.sentStatus.indexOf('fail') === -1) {
                                uids.splice(indexEmployee, 1);
                                sentStatus.sent.push(thisRecord.uuid);
                            }
                        }
                        if (uids.length > 0) {
                            sentStatus.pending = sentStatus.pending.concat(uids);
                        }

                        resolve(employees.length > 0 ? getEmployeesSendStatus(employees, sentStatus, errors) : { errors: errors, sentStatus: sentStatus })
                    }).catch(function (error) {
                        errors.push(error);
                        resolve((employees.length > 0 && employees.length !== original) ? getEmployeesSendStatus(employees, sentStatus, errors) : { errors: errors, sentStatus: sentStatus })
                    });
                } catch (error) {
                    errors.push(error);
                    resolve((employees.length > 0 && employees.length !== original) ? getEmployeesSendStatus(employees, sentStatus, errors) : { errors: errors, sentStatus: sentStatus })
                }

            })
        }
        function sendFiscalEmail(selected, bySmtp, ev) {
            return new Promise(function (resolve) {
                var errors = [];
                try {
                    var employeesToSend = [];
                    $rootScope.loadingProgress = true;
                    getEmployeesSendStatus(JSON.parse(JSON.stringify(selected))).then(function (response) {
                        console.log(response.errors.length)
                        if (response.errors.length > 0) {
                            errors = errors.concat(response.errors);
                        }
                        if (response.sentStatus.pending.length === 0 && response.sentStatus.sent.length === 0) {
                            throw 'No hay nada para enviar';
                        }
                        employeesToSend = response.sentStatus.pending;
                        var sendingAgain = false;
                        if (response.sentStatus.pending.length === 0) {
                            employeesToSend = response.sentStatus.sent;
                            sendingAgain = true;
                        }
                        var msgOptions = {
                            'one-first': {
                                msg: 'A continuación se enviará el recibo, que no haya sido enviado previamente, ¿Desea continuar con el envió?',
                                title: '¿Enviar ' + employeesToSend.length + ' recibo?',
                            },
                            'one-again': {
                                msg: 'A continuación se reenviará el recibo seleccionado, tenga en cuenta que ya ha sido enviado previamente, ¿Desea continuar con el envió?',
                                title: '¿Reenviar ' + employeesToSend.length + ' recibo?',
                            },
                            'many-first': {
                                msg: 'A continuación se enviarán solo los recibos, que no hayan sido enviados previamente, ¿Desea continuar con el envió?',
                                title: '¿Enviar ' + employeesToSend.length + ' recibos?',
                            },
                            'many-again': {
                                msg: 'A continuación se reenviarán los recibos seleccionados, tenga en cuenta que ya han sido enviados previamente, ¿Desea continuar con el envió?',
                                title: '¿Reenviar ' + employeesToSend.length + ' recibos?',
                            }
                        }
                        $rootScope.loadingProgress = false;
                        var msgConfig = msgOptions[(employeesToSend.length == 1 ? 'one' : 'many') + '-' + (sendingAgain ? 'again' : 'first')];
                        return $mdDialog.show($mdDialog
                            .confirm(confirmConfig)
                            .title(msgConfig.title)
                            .htmlContent(msgConfig.msg)
                            .ariaLabel('Deleting')
                            .targetEvent(ev)
                            .cancel('CANCELAR')
                            .ok('ENVIAR'))
                    }).then(function () {
                        $rootScope.loadingProgress = true;
                        var data = {
                            uuids: employeesToSend,
                            nameF: 'getDataBillM',
                            center: center
                        };
                        if (bySmtp) {
                            data.bySmtp = true;
                        }
                        return $http.post($window.__env.serviceWorkerUrl + 'models/bill/sendEmailBillFilesG', data)
                    }).then(function (resp) {
                        var success = resp.data.success;
                        if (success.length > 0) {
                            successAlertS('Se añadieron ' + success.length + ' correos a la cola de forma exitosa');
                        }
                        $rootScope.loadingProgress = false;
                        responseError(resp.data.error, errors, resolve);
                    }).catch(function (error) {
                        responseError(error, errors, resolve);
                    });
                } catch (error) {
                    responseError(error, errors, resolve);
                }
            })
        }

        function sendComplementEmail(selected, cParams, ev) {
            return new Promise(function (resolve) {
                var errors = [];
                var dispersionId = cParams.dispersionId;
                var operationId = cParams.operationId;
                var operationType = cParams.operationType;
                var period = cParams.period;
                var calendar = cParams.calendar;
                try {
                    var title = (selected.type === 'all') ? "Esta seguro de enviar " + selected.data.length + " correos?" : "Esta seguro de enviar " + selected.data.length + " correos para los empleado seleccionados?";
                    var msg = "Se enviara los correos y no podrá cancelarlo en el proceso";
                    $mdDialog.show($mdDialog
                        .confirm(confirmConfig)
                        .title(title)
                        .htmlContent(msg)
                        .ariaLabel('Deleting')
                        .targetEvent(ev)
                        .cancel('CANCELAR')
                        .ok('ENVIAR'))
                        .then(function () {
                            var params = {
                                dispersionId: dispersionId,
                                operationId: operationId,
                                opType: operationType,
                                employees: [],
                                message: 'Estimado(a) {employeeName} se anexa el siguiente archivo correspondiente al Periodo: ' + period + ' del año: ' + calendar + ', Proceso: ALTER'
                            };
                            for (var i = 0; i < selected.data.length; i++) {
                                params.employees.push(selected.data[i].$id)
                            }
                            $rootScope.loadingProgress = true;
                            return $http.post($window.__env.serviceWorkerUrl + 'models/bill/sendEmailBillPrevision', params);
                        }).then(function (resp) {
                            $rootScope.loadingProgress = false;
                            var success = resp.data.success;
                            if (success.length > 0) {
                                successAlertS('Se añado' + success.length + ' correos a la cola de forma exitosa');
                            }
                            responseError(resp.data.error, errors, resolve);
                        }).catch(function (error) {
                            responseError(error, errors, resolve)
                        });
                } catch (error) {
                    responseError(error, errors, resolve)
                }
            })
        }

        return sendBillsEmailFn;

        function sendBillsEmailFn(selected, process, bySmtp, ev, complementParams, getThem) {
            var promise;
            var errors = [];
            if (process === 'fiscal') {
                promise = sendFiscalEmail(selected, bySmtp, ev);
            } else {
                promise = sendComplementEmail(selected, complementParams, ev)
            }
            promise.then(function (errors) {
                var time = 0;
                if (angular.isFunction(getThem)) {
                    time = 3000;
                }
                $timeout(function () {
                    if (angular.isFunction(getThem)) {
                        getThem();
                    }
                }, time)
                if (angular.isDefined(errors) && errors.length > 0) {
                    throw errors;
                }
            }).catch(function (error) {
                if (angular.isArray(error)) {
                    if (error.length > 0) {
                        errors = errors.concat(error);
                    }
                } else if (angular.isDefined(error)) {
                    errors.push(error);
                }
                if (errors.length > 0) {
                    errAlertS(errors);
                }
            })
        }
    }

}());
(function () {
  'use strict';

  angular
    .module('app.clients')
    .controller('BillsController', BillsController);

  function BillsController(
    $scope,
    $rootScope,
    $log,
    errAlertS,
    $filter,
    $http,
    firebase,
    $window,
    successAlertS,
    $timeout,
    $mdDialog,
    confirmConfig,
    ApiV3F
  ) {
    $scope.fieldsToExport = {
      uuid: 1,
      opType: 1,
      status: 1,
      employeeId: 1,
      companiesRecordId: 1,
      rpId: 1,
      payrollId: 1,
      calendar: 1,
      period: 1,
      sentStatus: 1,
      sentTime: 1,
      sentEmail: 1,
      errorMsg: 1,
      'Comprobante.Total': 1
    };
    $scope.allHave = function (selected) {
      var allHave = false;
      if (angular.isArray(selected) && selected.length > 0) {
        var exists = selected.filter(function (value) {
          return value.status === 'error';
        });
        allHave = (exists.length === 0) ? true : false;
      }
      return allHave;
    }
    $scope.downloadBill = function (selected) {
      var promises = [];
      var bills = [];
      var error = [];
      for (var i = 0; i < selected.length; i++) {
        if (angular.isDefined(selected[i]['Comprobante']['Total'])) {
          var total = $filter('convertNumberToString')(selected[i]['Comprobante']['Total']);
          bills.push({ billId: selected[i]._id, total: total });
        } else {
          error.push("Los datos de la factura no son valido de " + selected[i].employeeName);
        }
      }
      if (bills.length > 0) {
        for (var b = 0; b < bills.length; b++) {
          promises.push($http({ method: 'POST', url: window.__env.serviceWorkerUrl + "interface/pdf/operation/invoice", responseType: 'arraybuffer', data: bills[b] }));
        }
      }
      Promise.all(promises).then(function (response) {
        if (response.length > 0) {
          for (var r = 0; r < response.length; r++) {
            var headers = response[r].headers();
            var filename = headers['x-filename'];
            var contentType = headers['content-type'];
            var linkElement = document.createElement('a');
            try {
              var blob = new Blob([response[r].data], {
                type: contentType
              });
              var url = window.URL.createObjectURL(blob);
              linkElement.setAttribute('href', url);
              linkElement.setAttribute("download", filename);
              var clickEvent = new MouseEvent("click", {
                "view": window,
                "bubbles": true,
                "cancelable": false
              });
              linkElement.dispatchEvent(clickEvent);
              $rootScope.loadingProgress = false;
              $rootScope.$evalAsync(function () {
                $log.debug('generatePdf finished');
              });
            } catch (ex) {
              throw ex + " error descargando el archivo";
            }
          }
        } else {
          throw "No se pudo descargar archivo";
        }
      }).catch(function (err) {
        var error;
        if (angular.isString(err)) {
          error = err;
        } else {
          var message = new TextDecoder("utf-8").decode(err.data);
          error = angular.fromJson(message);
        }
        errAlertS(error);
        $rootScope.loadingProgress = false;
        $rootScope.$evalAsync();
      })
    }
    function getFileRequest(publicLink) {
      return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.responseType = 'blob';
        xhr.onload = function (event) {
          var blob = xhr.response;
          resolve(blob);
        };
        xhr.open('GET', publicLink);
        xhr.send();
        xhr.addEventListener('error', reject);
        xhr.addEventListener('abort', reject);
      })
    }
    $scope.downloadManyFiles = function (selected) {
      if (angular.isArray(selected) && selected.length > 0) {
        $rootScope.loadingProgress = true;
        var promises = [];
        var promisesIndex = [];
        for (var e = 0; e < selected.length; e++) {
          var bucketUrl = (angular.isDefined(selected[e].xmlUrl)) ? selected[e].xmlUrl : undefined;
          if (angular.isUndefined(bucketUrl)) {
            errAlertS('El empleado ' + selected[e].employeeName + ' no tiene la url definida');
          } else {
            promises.push(firebase.storage().ref().child(bucketUrl).getDownloadURL());
            promisesIndex.push(selected[e].employeeName)
          }
        }
        Promise.all(promises).then(function (resp) {
          promises = [];
          for (var r = 0; r < resp.length; r++) {
            promises.push(getFileRequest(resp[r]));
          }
          return Promise.all(promises);
        }).then(function (blobs) {
          for (var b = 0; b < blobs.length; b++) {
            var url = window.URL.createObjectURL(blobs[b]);
            var linkElement = document.createElement('a');
            linkElement.setAttribute('href', url);
            linkElement.setAttribute('download', promisesIndex[b]);
            var clickEvent = new MouseEvent("click", {
              "view": window,
              "bubbles": true,
              "cancelable": false
            });
            linkElement.dispatchEvent(clickEvent);
          }
          $rootScope.loadingProgress = false;
          $rootScope.$evalAsync();
        }).catch(function (error) {
          $log.log(error);
          errAlertS('Error al obtener los archivos');
          $rootScope.loadingProgress = false;
          $rootScope.$evalAsync();
        });
      } else {
        errAlertS("No se selecciono ningún empleado")
      }
    }
    $scope.checkOperation = function (selected) {
      var allHave = false;
      if (angular.isArray(selected) && selected.length > 0) {
        var exists = selected.filter(function (value) {
          return ['error', 'cancelled'].indexOf(value.status) > -1;
        });
        allHave = (exists.length === 0) ? true : false;
      }
      return allHave;
    }
    $scope.cancelBill = function (selected, ev) {
      var title = '¿Desea cancelar ' + selected.length + 'recibos?';
      $mdDialog.show($mdDialog
        .confirm(confirmConfig)
        .title(title)
        .htmlContent('Esta acción cancelara los recibos definitivamente, si necesita el recibo le recomendamos la opción de retimbrar')
        .ariaLabel('Deleting')
        .targetEvent(ev)
        .ok('SI')
        .cancel('NO'))
        .then(function () {
          $rootScope.loadingProgress = true;
          var promises = [];
          for (var t = 0; t < selected.length; t++) {
            promises.push(cancelThisBill(selected[t].uuid, true));
          }
          Promise.all(promises).then(function (resp) {
            $log.log(resp);
            successAlertS("Se termino el proceso de cancelación de las facturas");
          }).catch(function (error) {
            $log.error(error);
          }).then(function () {
            $rootScope.loadingProgress = false;
            $rootScope.$evalAsync();
            $timeout(function () { }, 0, false);
          });
        }, function () {
          $log.debug('Deleting Cancelled');
        });
    };
    function cancelThisBill(uuid, dontStopLoading) {
      return new Promise(function (resolve) {
        ApiV3F.post('employees/cancelBill', { "uuid": uuid }).then(function (resp) {
          if (!dontStopLoading) {
            $rootScope.loadingProgress = false;
          }
          successAlertS(resp.data);
          resolve(true);
        }).catch(function (error) {
          if (!dontStopLoading) {
            $rootScope.loadingProgress = false;
          }
          $log.error(error);
          errAlertS(error);
          resolve(false);
        });
      });
    }
    $scope.sendEmail = function (selected, ev, bySmtp) {
      $filter('sendBillsEmail')(selected, 'fiscal', bySmtp, ev, undefined, $scope.getThem);
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.clients')
        .controller('CalculationsController', CalculationsController);

    function CalculationsController(
        $scope,
        $state,
        $log,
        $q,
        successAlertS
        ) {
        // $scope.selected = [];
        // $scope.tabName = 'payrollCalendars';
        // Methods
        // $scope.goToDetail = function (payrollCalendar) {
        //     $scope.F.goToState($scope.detailState, { 
        //         'payrollCalendarId': (payrollCalendar=="new") ? "new" : payrollCalendar.$id, 
        //         'payrollCalendar': payrollCalendar, 
        //         'payrollCalendars': $scope.payrollCalendars, 
        //         "payrolls": $scope.payrolls, 
        //         "payrollSelected": $scope.F.search.payroll, 
        //         "payrollId": payrollCalendar.payroll 
        //     });
        // }

        // $scope.goToPeriods = function (payrollCalendar) {
        //     //console.log(payrollCalendar, "goperiods");
        //     $scope.F.goToState($scope.periodState, { 
                // 'payrollCalendarId': (payrollCalendar=="new") ? "new" : payrollCalendar.$id, 
                // 'payrollCalendar': payrollCalendar, 
                // "payrollId": payrollCalendar.payroll
        //     });
        // }

        // @todo:backlog refactorizar tabla y ver la manera de pintar la vista de datos si es "necesaria"
        // $scope.deleteCalendarAndPeriods = function (e) {
        //     $scope.delete(e, 1).then(function(){
        //         angular.forEach($scope.selected, function (payrollCalendar) {
        //             var periodFrom = 'catalogs/payrollCalendars/' + payrollCalendar.payroll + '/periods/' + payrollCalendar.$id;
        //             $scope.D.realDelete(periodFrom, "Se eliminaron los periodos de la nomina");
        //             remove(payrollCalendar).then(function () {
        //                 count++
        //                 if (count == $scope.selected.length) {
        //                     successAlertS('Se borraron ' + count + ' Calendarios');
        //                     $scope.selected = [];
        //                 }
        //             }, errAlertS);
        //         });
        //     });
        // }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.clients')
        .controller('CalculationController', CalculationController);

    function CalculationController(
        $scope,
        $rootScope,
        $document,
        $state,
        $firebaseObject,
        $firebaseArray,
        $log,
        successAlertS,
        errAlertS,
        $q,
        $filter,
        $mdDialog,
        confirmConfig
        ) {
        // $scope.vm = $scope;
        var updatePeriods = false;
        $scope.listWatchers={};

        //funciones para actualizar un calendario
        // @todo:backlog esto debería ir en el server de una manera automática
        $scope.saveCalendarAndPeriods = function(payrollCalendar) {
            $log.debug('saving payrollCalendar', payrollCalendar);
            $rootScope.loadingProgress = true;
            var object = payrollCalendar;
            var calendarData = constructCalendar($scope.initialDate, object.data.initialPeriod, object.payroll);
            calendarData.then(function(data) {
                //esto se ejectuta cuando ya se guardara la informacion
                angular.extend(object.data, data);
                delete(object.data.periods);
                var periods = $filter('keyObjectAsId')(data.periods, "period");
                var datesAvailable = calendarDatesAvailables(object.data.startDate, object.data.endDate, object.payroll, object.$id);
                datesAvailable.then(function(flag) {
                    if (flag) {
                        savePayrollCalendar(object, $scope.originalPayrollCalendar, periods).then(function() {
                            successAlertS('Se actualizó la informacion del calendario con éxito');
                            $scope.R.goToList();
                            $rootScope.loadingProgress = false;
                            $rootScope.$evalAsync(function(){
                                $log.debug('saveCalendarAndPeriods finished');
                            });
                        }, function(error) {
                            errAlertS("No se pudo guardar el calendario");
                            $log.debug("Error al guardar el calendario", error);
                        });
                    } else {
                        //alerta de error
                        errAlertS("Ya existe un calendario con estas fechas");
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync();
                    }
                }, function(error) {
                    $log.debug("error checando las fechas del calendario", error);
                });
            }, function(error) {
                $log.debug("error al crear los periodos y datos del calendario", error);
            });
        }

        function savePayrollCalendar(newCalendar, oldCalendar, periods) {
            return $q(function(resolve, reject) {
                saveCalendarData(newCalendar).then(function() {
                    updatePeriods = newCalendar.payroll != oldCalendar.payroll ? true : updatePeriods;
                    savePeriodData(newCalendar, periods, updatePeriods).then(function() {
                        var doIt = (newCalendar.payroll != oldCalendar.payroll);
                        changeNode(newCalendar, oldCalendar, doIt).then(function() {
                            newCalendar.payroll != oldCalendar.payroll;
                            if (doIt) {
                                $scope.payrollCalendar = $firebaseObject($scope.F.root.child('catalogs/payrollCalendars/' + newCalendar.payroll + '/calendars/' + newCalendar.$id));
                                $scope.payrollCalendar.$loaded().then(function(calendar) {
                                    $scope.originalPayrollCalendar = angular.copy(calendar);
                                    dataFrom = "object";
                                    resolve(true);
                                });
                            } else {
                                resolve(true);
                            }
                        }, function(error) {
                            $log.debug("Error actualizando los periodos del calendario", error);
                            reject(error);
                        });
                    }, function(error) {
                        $log.debug("Error actualizando los nodos del calendario", error);
                        reject(error);
                    });
                }, function(error) {
                    $log.debug("Error guardando los datos del calendario", error);
                    reject(error);
                });
            })
        }

        function saveCalendarData(calendar) {
            return $q(function(resolve, reject) {
                if (dataFrom == "array") {
                    $scope.payrollCalendars.$save(calendar).then(function(resp) {
                        $log.debug("Se guardo la informacion del calendario por la lista", resp);
                        resolve(true);
                    }, function(error) {
                        reject(error)
                    })
                } else if (dataFrom == "object") {
                    $scope.payrollCalendar.$save().then(function(resp) {
                        $log.debug("Se guardo la informacion del calendario por el objeto", resp);
                        resolve(true);
                    }, function(error) {
                        reject(error)
                    });
                } else {
                    reject("No se pudo guardar los datos del calendario");
                }
            })
        }

        function savePeriodData(calendar, periods, doIt) {
            return $q(function(resolve, reject) {
                doIt = angular.isDefined(doIt) ? doIt : true;
                if (doIt) {
                    var periodReference = 'catalogs/payrollCalendars/' + calendar.payroll + '/periods';
                    $scope.F.root.child(periodReference).child(calendar.$id).set(periods).then(function(resp) {
                        $log.debug("Se guardaron los periodos del calendario", resp);
                        resolve(true);
                    }, function(error) {
                        reject(error);
                        $log.debug("Error guardando los periodos", error);
                    });
                } else {
                    $log.debug("No se hicieron cambios del periodo");
                    resolve(true);
                }
            })
        }

        // @todo:backlog cambios de nodos automáticos desde server
        function changeNode(newCalendar, oldCalendar, doIt) {
            return $q(function(resolve, reject) {
                doIt = angular.isDefined(doIt) ? doIt : true;
                if (doIt) {
                    var calendarFrom = 'catalogs/payrollCalendars/' + oldCalendar.payroll + '/calendars/' + oldCalendar.$id;
                    var calendatTo = 'catalogs/payrollCalendars/' + newCalendar.payroll + '/calendars/' + oldCalendar.$id;
                    var periodFrom = 'catalogs/payrollCalendars/' + oldCalendar.payroll + '/periods/' + oldCalendar.$id;
                    var periodTo = 'catalogs/payrollCalendars/' + newCalendar.payroll + '/periods/' + oldCalendar.$id;
                    $scope.D.moveTo(calendarFrom, calendatTo, false, true).then(function(a) {
                        $log.debug("Se movio el nodo del calendario", a);
                        $scope.D.realDelete(periodFrom, false, false, true).then(function(b) {
                            $log.debug("Se movio el nodo del periodo", b);
                            resolve(true);
                        }, function(error) {
                            reject(error);
                        });
                    }, function(error) {
                        reject(error);
                    })
                } else {
                    $log.debug("No se movio el ningun nodo");
                    resolve(true);
                }
            })
        }

        //funcion para agregar un nuevo calendario
        $scope.addCalendarAndPeriods = function(payrollCalendar) {
            $log.debug('adding payrollCalendar', payrollCalendar);
            $rootScope.loadingProgress = true;
            var object = payrollCalendar;
            var calendarData = constructCalendar($scope.initialDate, object.data.initialPeriod, object.payroll);
            // @todo:backlog:edgardo constructores como este del lado del server
            calendarData.then(function(data) {
                //esto se ejectuta cuando ya se guardara la informacion
                angular.extend(object.data, data);
                delete(object.data.periods);
                var periods = $filter('keyObjectAsId')(data.periods, "period");
                var datesAvailable = calendarDatesAvailables(object.data.startDate, object.data.endDate, object.payroll);
                datesAvailable.then(function(flag) {
                    var payrollCalendarReference = 'catalogs/payrollCalendars/' + object.payroll;
                    var calendarsReference = payrollCalendarReference + '/calendars';
                    var periodsReference = payrollCalendarReference + '/periods';
                    var operationReference = 'catalogs/operations/ordinary/' + object.payroll + '/' + object.data.year + '/collection';
                    if (flag) {
                        var updates = {};
                        angular.forEach(periods, function(value, index) {
                            var operationId = $scope.F.root.child(operationReference).push().key;
                            var operation = {
                                status: -1,
                                period: value.period,
                                calendar: object.data.year,
                                payroll: object.payroll,
                                firm: object.firm,
                                created: $scope.D.getTimeObject(),
                                type: "automatic"
                            }
                            updates[operationReference + "/" + operationId] = operation;
                        });
                        var newPayrollCalendarId = object.data.year;
                        updates[calendarsReference + "/" + newPayrollCalendarId] = object;
                        updates[periodsReference + "/" + newPayrollCalendarId] = periods;
                        //console.log(updates);
                        $scope.F.root.update(updates, function(error) {
                            if (error) {
                                errAlertS;
                                $rootScope.loadingProgress = false;
                                $rootScope.$evalAsync(function(){
                                    $log.error("error al guardar la informaicon", error);
                                });
                            } else {
                                successAlertS('Se creó calendario con éxito');
                                $scope.R.goToList();
                            }
                        });
                    } else {
                        errAlertS("Ya existe un calendario con estas fechas");
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync();
                    }
                }, function(error) {
                    $log.error("error checando las fechas del calendario", error);
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                });
            }, function(error) {
                $log.debug("error al crear los periodos y datos del calendario", error);
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
            });
        }

        // @todo:backlog:edgardo mover constructores a una Factory
        /*seccion de creacion de calendario y periodos*/
        function constructCalendar(startDate, actualPeriod, payrollId) {
            return $q(function(resolve, reject) {
                startDate = moment(startDate);
                startDate.set("hour", 0);
                startDate.set("minute", 0);
                startDate.set("second", 0);
                startDate.set("millisecond", 0);
                // @todo:backlog:carlos crear una funcion en la factory para traer datos de la memoria o de fb
                $scope.F.root.child("catalogs/payrolls/collection/" + payrollId + "/paymentFrequency").once('value').then(function(snapshot) {
                    if (snapshot.exists()) {
                        var frequencyId = snapshot.val();
                        $scope.D.api.get('paymentFrequenciesRecords/' + frequencyId).then(function(res) {
                            var paymentFrequency = res.data;
                            var calendar_date = constructPeriods(startDate, actualPeriod, paymentFrequency.name);
                            resolve(calendar_date);
                        }, function(error) {
                            reject(error);
                        });
                    } else {
                        reject('No se encontro la frecuencia de pago');
                    }
                });
            });
        }

        // @todo:backlog:edgardo mover constructores a una Factory
        function constructPeriods(startDate, actualPeriod, frequencyPayment) {
            if (!angular.isDefined(actualPeriod) || actualPeriod <= 0 || actualPeriod == "") {
                actualPeriod = 1;
            }
            var data = {};
            switch (frequencyPayment) {
                case "Semanal":
                    data = constructFixedPeriod(startDate, actualPeriod, 7, 52);
                    break;
                case "Catorcenal":
                    data = constructFixedPeriod(startDate, actualPeriod, 14, 26);
                    break;
                case "Quincenal":
                    data = constructBiweekly(startDate, actualPeriod, 24);
                    break;
                case "Mensual":
                    data = constructMonthlyPeriod(startDate, actualPeriod, 12);
                    break;
            }
            return data;
        }

        // @todo:backlog:edgardo mover constructores a una Factory
        function constructFixedPeriod(startDate, actualPeriod, daysOfPeriod, totalPeriods) {
            var data = {
                periods: [],
                endDate: "",
                startDate: startDate.valueOf()
            };
            var endDate = angular.copy(startDate);
            endDate.add(daysOfPeriod, "d").subtract(1, "ms");
            for (var i = actualPeriod; i <= totalPeriods; i++) {
                var period = constructPeriod(startDate, endDate, i);
                data.periods.push(period);
                startDate.add(daysOfPeriod, "d");
                endDate.add(daysOfPeriod, "d");
            }
            startDate.subtract(1, "ms");
            data.endDate = startDate.valueOf();
            return data;
        }

        // @todo:backlog:edgardo mover constructores a una Factory
        function constructBiweekly(startDate, actualPeriod, totalPeriods) {
            var tempDate = angular.copy(startDate);
            tempDate.set("hour", 0);
            tempDate.set("minute", 0);
            tempDate.set("second", 0);
            tempDate.set("millisecond", 0);
            var data = {
                periods: [],
                endDate: "",
                startDate: ""
            };
            var firstDayOfMonth = "01-" + startDate.format("MM-YYYY");
            firstDayOfMonth = moment(firstDayOfMonth, "DD-MM-YYYY ");
            firstDayOfMonth.set("hour", 0);
            firstDayOfMonth.set("minute", 0);
            firstDayOfMonth.set("second", 0);
            firstDayOfMonth.set("millisecond", 0);
            var sixteenthDayOfMonth = "16-" + startDate.format("MM-YYYY");
            sixteenthDayOfMonth = moment(sixteenthDayOfMonth, "DD-MM-YYYY");
            sixteenthDayOfMonth.set("hour", 0);
            sixteenthDayOfMonth.set("minute", 0);
            sixteenthDayOfMonth.set("second", 0);
            sixteenthDayOfMonth.set("millisecond", 0);
            var lastDayOfMonth = angular.copy(firstDayOfMonth);
            lastDayOfMonth.add(1, "M").subtract(1, "ms");
            var firstBiweekly = true;

            if (parseInt(startDate.format("DD")) > 15) {
                firstBiweekly = false;
            }
            for (var i = actualPeriod; i <= totalPeriods; i++) {
                var period;
                if (firstBiweekly) {
                    var temp_sixteenthDayOfMonth = angular.copy(sixteenthDayOfMonth);
                    temp_sixteenthDayOfMonth.subtract(1, "ms");
                    period = constructPeriod(firstDayOfMonth, temp_sixteenthDayOfMonth, i);
                } else {
                    period = constructPeriod(sixteenthDayOfMonth, lastDayOfMonth, i);
                }
                data.periods.push(period);
                if (!firstBiweekly) {
                    firstDayOfMonth.add(1, "M");
                    sixteenthDayOfMonth.add(1, "M");
                    lastDayOfMonth = angular.copy(firstDayOfMonth);
                    lastDayOfMonth.add(1, "M").subtract(1, "ms");
                }
                firstBiweekly = !firstBiweekly;
            }

            if (firstBiweekly) {
                firstDayOfMonth.subtract(1, "ms");
                data.endDate = firstDayOfMonth.valueOf();
            } else {
                sixteenthDayOfMonth.subtract(1, "ms");
                data.endDate = sixteenthDayOfMonth.valueOf();
            }
            data.periods[0].start = tempDate.valueOf();
            data.periods[0].startString = tempDate.format("DD-MM-YYYY");
            data.startDate = tempDate.valueOf();
            return data;
        }

        // @todo:backlog:edgardo mover constructores a una Factory
        function constructMonthlyPeriod(startDate, actualPeriod, totalPeriods) {
            var tempDate = angular.copy(startDate);
            tempDate.set("hour", 0);
            tempDate.set("minute", 0);
            tempDate.set("second", 0);
            tempDate.set("millisecond", 0);
            var data = {
                periods: [],
                endDate: "",
                startDate: ""
            };
            var startDateString = "01-" + startDate.format("MM-YYYY");
            startDate = moment(startDateString, "DD-MM-YYYY");
            startDate.set("hour", 0);
            startDate.set("minute", 0);
            startDate.set("second", 0);
            startDate.set("millisecond", 0);
            data.startDate = startDate.valueOf();
            var endDate = angular.copy(startDate);
            endDate.add(1, "M").subtract(1, "ms");

            for (var i = actualPeriod; i <= totalPeriods; i++) {
                var period = constructPeriod(startDate, endDate, i);
                data.periods.push(period);
                startDate.add(1, "M");
                endDate = angular.copy(startDate);
                endDate.add(1, "M").subtract(1, "ms");
            }
            startDate.subtract(1, "ms");
            data.endDate = startDate.valueOf();
            data.periods[0].start = tempDate.valueOf();
            data.periods[0].startString = tempDate.format("DD-MM-YYYY");
            data.startDate = tempDate.valueOf();
            return data;
        }

        // @todo:backlog:edgardo mover constructores a una Factory
        function constructPeriod(startDate, endDate, period) {
            var data = {
                start: startDate.valueOf(),
                end: endDate.valueOf(),
                startString: startDate.format("DD-MM-YYYY"),
                endString: endDate.format("DD-MM-YYYY"),
                period: parseInt(period + ""),
                active: true
            }
            return data;
        }

        // todo:backlog:carlos cuando se refactoricen los calendarios y periodos modificar esta funcion
        // funcion para checar si las fechas de calendarios esta disponibles
        function calendarDatesAvailables(startDate, endDate, payrollId, calendarId) {
            return $q(function(resolve, reject) {
                var flag = true;
                //se realiza una consulata para encontrar los calendarios cuya fecha inicial se encuentre en las fechas de inicio y fin del calendario que se esta verificando
                var calendarsAfter = $firebaseArray($scope.F.root.child('catalogs/payrollCalendars/' + payrollId + '/calendars').orderByChild("data/startDate").startAt(startDate).endAt(endDate));
                //una vez cargados se procede a verificar la informacion
                calendarsAfter.$loaded(function(calendars) {
                    //si se ecnontraron calendarios se alamcena la cantidad encontrados
                    var recordsFounded = calendars.length;
                    $log.debug(calendars, "recordsFoundedstart");
                    //si se manda el parametro de Id del calendario quiere decir que se esta haciendo la verificacion de un calendario ya guardado por lo tanto puede ser que se enceuntre un record
                    if (angular.isDefined(calendarId)) {
                        //se prosigue a checar si el calendario del cual se esta checando las fechas es el mismo que se encontro
                        var isTheSame = false;
                        angular.forEach(calendars, function(value, key) {
                            if (calendarId == value.$id) {
                                isTheSame = true;
                            }
                        });
                        //si el record encontrado corresponde al mismo record del cual se estan checando las fechas entonces se dismimuye la cantidad de registros encontrados
                        if (isTheSame) {
                            recordsFounded--;
                        }
                    }
                    //si el numero de record encontrados es 0 entonces se procede a checar la fecha final
                    if (recordsFounded < 1) {
                        //se realiza una consulta para encontrar los calendarios cuya fecha final se encuentre en las fechas de inicio y fin del calendario que se esta verificando
                        var calendarsBefore = $firebaseArray($scope.F.root.child('catalogs/payrollCalendars/' + payrollId + '/calendars').orderByChild("data/endDate").startAt(startDate).endAt(endDate));
                        //una vez cargados se procede a la verificacion
                        calendarsBefore.$loaded(function(calendars) {
                            //se establece el numero de records encontrados
                            recordsFounded = calendars.length;
                            $log.debug(calendars, "recordsFoundedend");
                            //si se manda el parametro de Id del calendario quiere decir que se esta haciendo la verificacion de un calendario ya guardado por lo tanto puede ser que se enceuntre un record 
                            if (angular.isDefined(calendarId)) {
                                var isTheSame = false;
                                angular.forEach(calendars, function(value, key) {
                                    if (calendarId == value.$id) {
                                        isTheSame = true;
                                    }
                                });
                                //si el record encontrado corresponde al mismo record del cual se estan checando las fechas entonces se dismimuye la cantidad de registros encontrados
                                if (isTheSame) {
                                    recordsFounded--;
                                }
                            }
                            //finalmente si los records encontrados son menores a uno quiere decir que no hay ningun calendario en las fechas que se quieren verificar
                            if (recordsFounded < 1) {
                                resolve(flag);
                            } else {
                                //si hay records encotnrados entonces se le dice al usuario que ya hay calendarios en esas fechas
                                flag = false;
                                resolve(flag);
                            }
                        }, function(error) {
                            reject(error);
                        });
                    } else {
                        flag = false;
                        resolve(flag);
                    }
                }, function(error) {
                    reject(error)
                });
            });
        }


        /*Seccion de observadores*/
        $scope.watchPeriod = function(period) {
            //console.log("oerio", period)
            if (!$scope.F.addMode) {
                //console.log("oerio", $scope.originalPayrollCalendar)
                if (period != $scope.originalPayrollCalendar.data.initialPeriod) {
                    var title = 'Desea continuar';
                    var msg = "Al cambiar el periodo de inicio se borraran los periodos creados y se calcularan nuevamente";
                    $mdDialog.show($mdDialog.confirm(confirmConfig)
                        .title(title)
                        .content(msg)
                        .ariaLabel('Cambiar Fechas')
                        .ok('Aceptar')
                        .cancel('Cancelar'))
                    .then(function() {
                        updatePeriods = true;
                        //se queda igual
                    }, function() {
                        $scope.payrollCalendar.data.initialPeriod = $scope.originalPayrollCalendar.data.initialPeriod;
                    });
                }
            }
        }

        $scope.watchInitialDate = function(initialDate) {
            if (!$scope.F.addMode) {
                var d = moment(initialDate);
                if (d.valueOf() != $scope.originalPayrollCalendar.data.startDate) {
                    var title = 'Desea continuar';
                    var msg = "Al cambiar la fecha de inicio se borraran los periodos creados y se calcularan nuevamente";
                    $mdDialog.show($mdDialog.confirm(confirmConfig)
                        .title(title)
                        .content(msg)
                        .ariaLabel('Cambiar Fechas')
                        .ok('Aceptar')
                        .cancel('Cancelar'))
                    .then(function() {
                        updatePeriods = true; //se queda igual
                    }, function() {
                        $scope.initialDate = new Date($scope.originalPayrollCalendar.data.startDate);
                    });
                }
            }
        }

        // observa cuando se carga la fecha de inicio para llenar el md-datepicker
        $scope.listWatchers.statdate=$scope.$watch('payrollCalendar.data.startDate', function(newValue) {
            if (angular.isDefined(newValue) && newValue != "") {
                var date = new Date(newValue);
                $scope.initialDate = date;
            }
        });

        $scope.listWatchers.payrollaCalendar=$scope.$watch('payrollCalendar.data', function(payrollCalendarD){
            if(payrollCalendarD){
                    $scope.originalPayrollCalendar = angular.copy($scope.payrollCalendar);
                    // if ($state.params.payrollSelected) {
                    //     $scope.payrollCalendar.payroll = angular.isDefined($scope.payrollCalendar.payroll) 
                    //                             ? $scope.payrollCalendar.payroll
                    //                             : $state.params.payrollSelected;
                    // }
            }
        }, true);

        // obserba payroll para setear firm en calendario 
        $scope.listWatchers.payroll=$scope.$watch('payrollCalendar.payroll', function(payrollId) {
            if (angular.isDefined(payrollId)) {
                $scope.payrollCalendar.firm = $filter('getSomethingOfArrayFB')(payrollId, $scope.L.allPayrolls, 'firm');
                // $scope.F.root.child("catalogs/payrolls/collection").child(payroll).child("firm").once("value", function(snap) {
                //     $scope.payrollCalendar.firm = snap.val();
                // });
            }
        });

        $scope.listWatchers.finalListener = $scope.$on("$destroy", function() {
            for (var f in $scope.listWatchers) {
                //$log.debug('stopping $watcher', f);
                $scope.listWatchers[f]();
            }
            //stopDetailWatchersEvent();
        });
    }
})();
(function () {
    "use strict";

    angular
        .module("app.catalogs")
        .controller("BatchRecordsController", BatchRecordsController);

    function BatchRecordsController($scope, $mdDialog, $document, $log) {

        $scope.showDetails = function (batchRecord, action, ev) {
            $mdDialog.show({
                controllerAs: 'btCtrl',
                controller: 'BatchRecordModalController',
                templateUrl: 'app/main/clients/views/batchRecords/dialog/batch-record-modal.html',
                parent: angular.element($document.body),
                locals: {
                    batchRecord: batchRecord,
                    action: action
                },
                targetEvent: ev,
                clickOutsideToClose: false
            }).then(function () {
                $scope.getThem()
            }, function () {
                $log.debug('importEmployeesModal cancelled');
            });
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.notes')
        .factory('NotesService', NotesService);

    /** @ngInject */
    function NotesService(msApi, $q)
    {
        var service = {
            data      : [],
            addNote   : addNote,
            updateNote: updateNote,
            deleteNote: deleteNote,
            getData   : getData
        };

        /**
         * Add Note
         * @param note
         */
        function addNote(note)
        {
            service.data.push(note);
        }

        /**
         * Update Note
         * @param note
         */
        function updateNote(note)
        {
            for ( var i = 0; i < service.data.length; i++ )
            {
                if ( service.data[i].id === note.id )
                {
                    service.data[i] = note;
                }
            }
        }

        /**
         * Delete Note
         * @param note
         */
        function deleteNote(note)
        {
            for ( var i = 0; i < service.data.length; i++ )
            {
                if ( service.data[i].id === note.id )
                {
                    service.data.splice(i, 1);
                }
            }
        }

        /**
         * Get service data
         * @returns {Array}
         */
        function getData()
        {
            // Create a new deferred object
            var deferred = $q.defer();

            msApi.request('notes.notes@get', {},
                // SUCCESS
                function (response)
                {
                    // Attach the data
                    service.data = response.data;

                    // Resolve the promise
                    deferred.resolve(response);
                },

                // ERROR
                function (response)
                {
                    // Reject the promise
                    deferred.reject(response);
                }
            );

            return deferred.promise;
        }

        return service;

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.notes')
        .factory('LabelsService', LabelsService);

    /** @ngInject */
    function LabelsService(msUtils, NotesService, msApi, $q)
    {
        var service = {
            data       : [],
            addLabel   : addLabel,
            updateLabel: updateLabel,
            deleteLabel: deleteLabel,
            getData    : getData
        };

        /**
         * Add label
         * @param newLabel
         */
        function addLabel(newLabel)
        {
            if ( newLabel.name === '' )
            {
                return;
            }

            service.data.push({
                id   : msUtils.guidGenerator(),
                name : newLabel.name,
                color: newLabel.color || ''
            });
        }

        /**
         * Update Label
         * @param note
         */
        function updateLabel(note)
        {
            for ( var i = 0; i < service.data.length; i++ )
            {
                if ( service.data[i].id === note.id )
                {
                    service.data[i] = note;
                }
            }
        }

        /**
         * Delete Label
         * @param label
         */
        function deleteLabel(label)
        {
            var notes = NotesService.data;

            // Look for all notes if they have the labels
            for ( var j = 0; j < notes.length; j++ )
            {
                if ( notes[j].labels.indexOf(label.id) > -1 )
                {
                    notes[j].labels.splice(notes[j].labels.indexOf(label.id), 1);
                }
            }

            // Delete label from service data
            for ( var i = 0; i < service.data.length; i++ )
            {
                if ( service.data[i].id === label.id )
                {
                    service.data.splice(i, 1);
                }
            }

        }

        /**
         * Get service data
         * @returns {Array}
         */
        function getData()
        {
            // Create a new deferred object
            var deferred = $q.defer();

            msApi.request('notes.labels@get', {},
                // SUCCESS
                function (response)
                {
                    // Attach the data
                    service.data = response.data;

                    // Resolve the promise
                    deferred.resolve(response);
                },

                // ERROR
                function (response)
                {
                    // Reject the promise
                    deferred.reject(response);
                }
            );

            return deferred.promise;
        }

        return service;

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboards.server', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        // State
        $stateProvider.state('app.dashboards_server', {
            url      : '/dashboard-server',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/dashboards/server/dashboard-server.html',
                    controller : 'DashboardServerController as vm'
                }
            },
            // resolve  : {
                // DashboardData: function (msApi)
                // {
                //     return msApi.resolve('dashboard.server@get');
                // }
            // },
            bodyClass: 'dashboard-server'
        });

        // Api
        msApiProvider.register('dashboard.server', ['app/data/dashboard/server/data.json']);
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboards.server')
        .controller('DashboardServerController', DashboardServerController);

    /** @ngInject */
    function DashboardServerController($scope, $interval, DashboardData)
    {
        var vm = this;

        // Data
        vm.dashboardData = DashboardData;

        // Widget 1
        vm.widget1 = {
            title: vm.dashboardData.widget1.title,
            chart: {
                options: {
                    chart: {
                        type                   : 'lineChart',
                        color                  : ['#4caf50', '#3f51b5', '#ff5722'],
                        height                 : 320,
                        margin                 : {
                            top   : 32,
                            right : 32,
                            bottom: 32,
                            left  : 48
                        },
                        useInteractiveGuideline: true,
                        clipVoronoi            : false,
                        interpolate            : 'cardinal',
                        x                      : function (d)
                        {
                            return d.x;
                        },
                        y                      : function (d)
                        {
                            return d.y;
                        },
                        xAxis                  : {
                            tickFormat: function (d)
                            {
                                return d + ' min.';
                            },
                            showMaxMin: false
                        },
                        yAxis                  : {
                            tickFormat: function (d)
                            {
                                return d + ' MB';
                            }
                        },
                        interactiveLayer       : {
                            tooltip: {
                                gravity: 's',
                                classes: 'gravity-s'
                            }
                        },
                        legend                 : {
                            margin    : {
                                top   : 8,
                                right : 0,
                                bottom: 32,
                                left  : 0
                            },
                            rightAlign: false
                        }
                    }
                },
                data   : vm.dashboardData.widget1.chart
            }
        };

        // Widget 2
        vm.widget2 = vm.dashboardData.widget2;

        // Widget 3
        vm.widget3 = vm.dashboardData.widget3;

        // Widget 4
        vm.widget4 = {
            title   : vm.dashboardData.widget4.title,
            value   : vm.dashboardData.widget4.value,
            footnote: vm.dashboardData.widget4.footnote,
            detail  : vm.dashboardData.widget4.detail,
            chart   : {
                config : {
                    refreshDataOnly: true,
                    deepWatchData  : true
                },
                options: {
                    chart: {
                        type        : 'lineChart',
                        color       : ['rgba(0, 0, 0, 0.27)'],
                        height      : 50,
                        margin      : {
                            top   : 8,
                            right : 0,
                            bottom: 0,
                            left  : 0
                        },
                        duration    : 1,
                        clipEdge    : true,
                        interpolate : 'cardinal',
                        interactive : false,
                        isArea      : true,
                        showLegend  : false,
                        showControls: false,
                        showXAxis   : false,
                        showYAxis   : false,
                        x           : function (d)
                        {
                            return d.x;
                        },
                        y           : function (d)
                        {
                            return d.y;
                        },
                        yDomain     : [0, 4]
                    }
                },
                data   : vm.dashboardData.widget4.chart
            },
            init    : function ()
            {
                // Run this function once to initialize the widget

                // Grab the x value
                var lastIndex = vm.dashboardData.widget4.chart[0].values.length - 1,
                    x = vm.dashboardData.widget4.chart[0].values[lastIndex].x;

                /**
                 * Emulate constant data flow
                 *
                 * @param min
                 * @param max
                 */
                function latencyTicker(min, max)
                {
                    // Increase the x value
                    x++;

                    var randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;

                    var newValue = {
                        x: x,
                        y: randomNumber
                    };

                    vm.widget4.chart.data[0].values.shift();
                    vm.widget4.chart.data[0].values.push(newValue);

                    // Randomize the value
                    vm.widget4.value = 20 + randomNumber + 'ms';
                }

                // Set interval
                var latencyTickerInterval = $interval(function ()
                {
                    latencyTicker(1, 4);
                }, 1000);

                // Cleanup
                $scope.$on('$destroy', function ()
                {
                    $interval.cancel(latencyTickerInterval);
                });
            }
        };

        // Widget 5
        vm.widget5 = vm.dashboardData.widget5;

        // Widget 6
        vm.widget6 = {
            title: vm.dashboardData.widget6.title,
            chart: {
                config : {
                    refreshDataOnly: true,
                    deepWatchData  : true
                },
                options: {
                    chart: {
                        type                   : 'lineChart',
                        color                  : ['#03A9F4'],
                        height                 : 140,
                        margin                 : {
                            top   : 8,
                            right : 32,
                            bottom: 16,
                            left  : 48
                        },
                        duration               : 1,
                        clipEdge               : true,
                        clipVoronoi            : false,
                        interpolate            : 'cardinal',
                        isArea                 : true,
                        useInteractiveGuideline: true,
                        showLegend             : false,
                        showControls           : false,
                        x                      : function (d)
                        {
                            return d.x;
                        },
                        y                      : function (d)
                        {
                            return d.y;
                        },
                        yDomain                : [0, 100],
                        xAxis                  : {
                            tickFormat: function (d)
                            {
                                return d + ' sec.';
                            },
                            showMaxMin: false
                        },
                        yAxis                  : {
                            tickFormat: function (d)
                            {
                                return d + '%';
                            }
                        },
                        interactiveLayer       : {
                            tooltip: {
                                gravity: 's',
                                classes: 'gravity-s'
                            }
                        }
                    }
                },
                data   : vm.dashboardData.widget6.chart
            },
            init : function ()
            {
                // Run this function once to initialize the widget

                // Grab the x value
                var lastIndex = vm.dashboardData.widget6.chart[0].values.length - 1,
                    x = vm.dashboardData.widget6.chart[0].values[lastIndex].x;

                /**
                 * Emulate constant data flow
                 *
                 * @param min
                 * @param max
                 */
                function cpuTicker(min, max)
                {
                    // Increase the x value
                    x = x + 5;

                    var newValue = {
                        x: x,
                        y: Math.floor(Math.random() * (max - min + 1)) + min
                    };

                    vm.widget6.chart.data[0].values.shift();
                    vm.widget6.chart.data[0].values.push(newValue);
                }

                // Set interval
                var cpuTickerInterval = $interval(function ()
                {
                    cpuTicker(0, 100);
                }, 5000);

                // Cleanup
                $scope.$on('$destroy', function ()
                {
                    $interval.cancel(cpuTickerInterval);
                });
            }
        };

        // Widget 7
        vm.widget7 = {
            title    : vm.dashboardData.widget7.title,
            table    : vm.dashboardData.widget7.table,
            dtOptions: {
                dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                pagingType: 'simple',
                pageLength: 10,
                lengthMenu: [10, 20, 50, 100],
                autoWidth : false,
                responsive: true,
                columnDefs: [
                    {
                        width  : '20%',
                        targets: [0, 1, 2, 3, 4]
                    }
                ],
                columns   : [
                    {},
                    {},
                    {
                        render: function (data, type)
                        {
                            if ( type === 'display' )
                            {
                                return data + ' KB/s';
                            }
                            else
                            {
                                return data;
                            }
                        }
                    },
                    {
                        render: function (data, type)
                        {
                            if ( type === 'display' )
                            {
                                return data + '%';
                            }
                            else
                            {
                                return data;
                            }
                        }
                    },
                    {
                        render: function (data, type)
                        {
                            if ( type === 'display' )
                            {
                                var el = angular.element(data);
                                el.html(el.text() + ' MB');

                                return el[0].outerHTML;
                            }
                            else
                            {
                                return data;
                            }
                        }
                    }
                ]
            }
        };

        // Widget 8
        vm.widget8 = vm.dashboardData.widget8;

        // Methods

        //////////

        // Init Widget 4
        vm.widget4.init();

        // Init Widget 6
        vm.widget6.init();
    }
})();
(function () {
    'use strict';

    angular
        .module('app.dashboards.project', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.dashboards_project', {
            url: '/dashboard',
            params: {
                view: 'dashboard'
            },
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/dashboards/project/dashboard-project.html',
                    controller: 'DashboardProjectController'
                }
            },
            bodyClass: 'dashboard-project'
        }).state('app.project-manager', {
            url: '/project-manager',
            params: {
                view: 'project-manager'
            },
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/dashboards/project/dashboard-project.html',
                    controller: 'DashboardProjectController'
                }
            },
            bodyClass: 'app.dashboards_project'
        });
    }

})();
(function () {
    'use strict';

    angular
        .module('app.dashboards.project')
        .controller('DashboardProjectController', DashboardProjectController);

    /** @ngInject */
    function DashboardProjectController($scope, $sce, DataF, $log, errAlertS, tdsystemAppV2, $window, $stateParams) {
        DataF.auth.post('getCustomToken').then(function (data) {
            var token = data.data.token;
            var hostname = tdsystemAppV2[$window.__env.mode];
            var protocol = ["production", "staging"].indexOf($window.__env.mode) > -1 ? 'https' : 'http';
            var url = protocol + "://" + hostname +
                "/sign-in-token?disableMenuBar=true&disableProfileBar=true" +
                "&token=" + token +
                "&view=" + encodeURIComponent($stateParams.view);

            $log.log(url);
            $scope.dashboardUrl = $sce.trustAsResourceUrl(url);
        }).catch(errAlertS);
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboards.analytics', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        // State
        $stateProvider.state('app.dashboards_analytics', {
            url      : '/dashboard-analytics',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/dashboards/analytics/dashboard-analytics.html',
                    controller : 'DashboardAnalyticsController as vm'
                }
            },
            // resolve  : {
            //     DashboardData: function (msApi)
            //     {
            //         return msApi.resolve('dashboard.analytics@get');
            //     }
            // },
            bodyClass: 'dashboard-analytics'
        });

        // Api
        msApiProvider.register('dashboard.analytics', ['app/data/dashboard/analytics/data.json']);
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboards.analytics')
        .controller('DashboardAnalyticsController', DashboardAnalyticsController);

    /** @ngInject */
    function DashboardAnalyticsController(DashboardData, uiGmapGoogleMapApi)
    {
        var vm = this;

        // Data
        vm.dashboardData = DashboardData;
        vm.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg'];

        vm.widget1 = {
            title             : vm.dashboardData.widget1.title,
            onlineUsers       : vm.dashboardData.widget1.onlineUsers,
            bigChart          : {
                options: {
                    chart: {
                        type                   : 'lineWithFocusChart',
                        color                  : ['#2196F3'],
                        height                 : 400,
                        margin                 : {
                            top   : 32,
                            right : 32,
                            bottom: 64,
                            left  : 48
                        },
                        isArea                 : true,
                        useInteractiveGuideline: true,
                        duration               : 1,
                        clipEdge               : true,
                        clipVoronoi            : false,
                        interpolate            : 'cardinal',
                        showLegend             : false,
                        x                      : function (d)
                        {
                            return d.x;
                        },
                        y                      : function (d)
                        {
                            return d.y;
                        },
                        xAxis                  : {
                            showMaxMin: false,
                            tickFormat: function (d)
                            {
                                var date = new Date(new Date().setDate(new Date().getDate() + d));
                                return d3.time.format('%b %d')(date);
                            }
                        },
                        yAxis                  : {
                            showMaxMin: false
                        },
                        x2Axis                 : {
                            showMaxMin: false,
                            tickFormat: function (d)
                            {
                                var date = new Date(new Date().setDate(new Date().getDate() + d));
                                return d3.time.format('%b %d')(date);
                            }
                        },
                        y2Axis                 : {
                            showMaxMin: false
                        },
                        interactiveLayer       : {
                            tooltip: {
                                gravity: 's',
                                classes: 'gravity-s'
                            }
                        },
                        legend                 : {
                            margin    : {
                                top   : 8,
                                right : 0,
                                bottom: 32,
                                left  : 0
                            },
                            rightAlign: false
                        }
                    }
                },
                data   : vm.dashboardData.widget1.bigChart.chart
            },
            sessions          : {
                title   : vm.dashboardData.widget1.sessions.title,
                value   : vm.dashboardData.widget1.sessions.value,
                previous: vm.dashboardData.widget1.sessions.previous,
                options : {
                    chart: {
                        type                   : 'lineChart',
                        color                  : ['#03A9F4'],
                        height                 : 40,
                        margin                 : {
                            top   : 4,
                            right : 4,
                            bottom: 4,
                            left  : 4
                        },
                        isArea                 : true,
                        interpolate            : 'cardinal',
                        clipEdge               : true,
                        duration               : 500,
                        showXAxis              : false,
                        showYAxis              : false,
                        showLegend             : false,
                        useInteractiveGuideline: true,
                        x                      : function (d)
                        {
                            return d.x;
                        },
                        y                      : function (d)
                        {
                            return d.y;
                        },
                        xAxis                  : {
                            tickFormat: function (d)
                            {
                                var date = new Date(new Date().setDate(new Date().getDate() + d));
                                return d3.time.format('%A, %B %d, %Y')(date);
                            }
                        },
                        interactiveLayer       : {
                            tooltip: {
                                gravity: 's',
                                classes: 'gravity-s'
                            }
                        }
                    }
                },
                data    : vm.dashboardData.widget1.sessions.chart
            },
            pageviews         : {
                title   : vm.dashboardData.widget1.pageviews.title,
                value   : vm.dashboardData.widget1.pageviews.value,
                previous: vm.dashboardData.widget1.pageviews.previous,
                options : {
                    chart: {
                        type                   : 'lineChart',
                        color                  : ['#3F51B5'],
                        height                 : 40,
                        margin                 : {
                            top   : 4,
                            right : 4,
                            bottom: 4,
                            left  : 4
                        },
                        isArea                 : true,
                        interpolate            : 'cardinal',
                        clipEdge               : true,
                        duration               : 500,
                        showXAxis              : false,
                        showYAxis              : false,
                        showLegend             : false,
                        useInteractiveGuideline: true,
                        x                      : function (d)
                        {
                            return d.x;
                        },
                        y                      : function (d)
                        {
                            return d.y;
                        },
                        xAxis                  : {
                            tickFormat: function (d)
                            {
                                var date = new Date(new Date().setDate(new Date().getDate() + d));
                                return d3.time.format('%A, %B %d, %Y')(date);
                            }
                        },
                        interactiveLayer       : {
                            tooltip: {
                                gravity: 's',
                                classes: 'gravity-s'
                            }
                        }
                    }
                },
                data    : vm.dashboardData.widget1.pageviews.chart
            },
            pagesSessions     : {
                title   : vm.dashboardData.widget1.pagesSessions.title,
                value   : vm.dashboardData.widget1.pagesSessions.value,
                previous: vm.dashboardData.widget1.pagesSessions.previous,
                options : {
                    chart: {
                        type                   : 'lineChart',
                        color                  : ['#E91E63'],
                        height                 : 40,
                        margin                 : {
                            top   : 4,
                            right : 4,
                            bottom: 4,
                            left  : 4
                        },
                        isArea                 : true,
                        interpolate            : 'cardinal',
                        clipEdge               : true,
                        duration               : 500,
                        showXAxis              : false,
                        showYAxis              : false,
                        showLegend             : false,
                        useInteractiveGuideline: true,
                        x                      : function (d)
                        {
                            return d.x;
                        },
                        y                      : function (d)
                        {
                            return d.y;
                        },
                        xAxis                  : {
                            tickFormat: function (d)
                            {
                                var date = new Date(new Date().setDate(new Date().getDate() + d));
                                return d3.time.format('%A, %B %d, %Y')(date);
                            }
                        },
                        interactiveLayer       : {
                            tooltip: {
                                gravity: 's',
                                classes: 'gravity-s'
                            }
                        }
                    }
                },
                data    : vm.dashboardData.widget1.pagesSessions.chart
            },
            avgSessionDuration: {
                title   : vm.dashboardData.widget1.avgSessionDuration.title,
                value   : vm.dashboardData.widget1.avgSessionDuration.value,
                previous: vm.dashboardData.widget1.avgSessionDuration.previous,
                options : {
                    chart: {
                        type                   : 'lineChart',
                        color                  : ['#009688'],
                        height                 : 40,
                        margin                 : {
                            top   : 4,
                            right : 4,
                            bottom: 4,
                            left  : 4
                        },
                        isArea                 : true,
                        interpolate            : 'cardinal',
                        clipEdge               : true,
                        duration               : 500,
                        showXAxis              : false,
                        showYAxis              : false,
                        showLegend             : false,
                        useInteractiveGuideline: true,
                        x                      : function (d)
                        {
                            return d.x;
                        },
                        y                      : function (d)
                        {
                            return d.y;
                        },
                        xAxis                  : {
                            tickFormat: function (d)
                            {
                                var date = new Date(new Date().setDate(new Date().getDate() + d));
                                return d3.time.format('%A, %B %d, %Y')(date);
                            }
                        },
                        yAxis                  : {
                            tickFormat: function (d)
                            {
                                var formatTime = d3.time.format('%M:%S');
                                return formatTime(new Date('2012', '0', '1', '0', '0', d));
                            }
                        },
                        interactiveLayer       : {
                            tooltip: {
                                gravity: 's',
                                classes: 'gravity-s'
                            }
                        }
                    }
                },
                data    : vm.dashboardData.widget1.avgSessionDuration.chart
            }
        };

        // Widget 2
        vm.widget2 = {
            title: vm.dashboardData.widget2.title
        };

        // Widget 3
        vm.widget3 = {
            title       : vm.dashboardData.widget3.title,
            pages       : vm.dashboardData.widget3.pages,
            ranges      : vm.dashboardData.widget3.ranges,
            currentRange: vm.dashboardData.widget3.currentRange,
            changeRange : function (range)
            {
                vm.widget3.currentRange(range);
            }
        };

        // Widget 4
        vm.widget4 = vm.dashboardData.widget4;


        // Methods

        //////////

        // Widget 2
        uiGmapGoogleMapApi.then(function ()
        {
            vm.widget2.map = vm.dashboardData.widget2.map;
        });
    }

})();
(function() {
    'use strict';

    angular
        .module('app.calendar')
        .filter('updateEvents', updateEvents)

    function updateEvents() {

        return updateEventsFn;

        function updateEventsFn(source, newEvents) {
           
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.calendar')
        .filter('mergeOperations', mergeOperations);

    function mergeOperations(mergeOperationFilter, $log, $q) {

        return mergeOperationsFn;

        function mergeOperationsFn(operationsQuerys) {
            return $q(function (resolve) {
                var allOperations = [];
                var allPromises = [];
                angular.forEach(operationsQuerys, function (payroll) {
                    angular.forEach(payroll, function (operationsQueryObject) {
                        var operationPromises = {};
                        operationPromises.dates = operationsQueryObject.operationDates.$loaded();
                        operationPromises.info = operationsQueryObject.operationInfo.$loaded();
                        allPromises.push($q.all(operationPromises));
                    });
                });
                $q.all(allPromises).then(function (allDatas) {
                    angular.forEach(allDatas, function (data) {
                        var operationMerges = mergeOperationFilter(data.dates, data.info);
                        allOperations.push(operationMerges);
                    });
                    resolve(allOperations);
                });
            });
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.calendar')
        .filter('mergeOperation', mergeOperation);

    function mergeOperation(getObjectOfArrayByIdFilter, clearObjectFilter) {
        return mergeOperationFn;

        function mergeOperationFn(calendarOperations, operations) {
            var newOperations = angular.copy(operations);
            var newCalendarOperations = angular.copy(calendarOperations);
            var news = [];
            angular.forEach(newOperations, function (value) {
                var object = newCalendarOperations.find(function (item) {
                    return item.period === value.period;
                });
                object.periodFromPeriod = object.period;
                news.push(angular.merge(value, clearObjectFilter(object)));
            });
            return news;
        }
    }

}());
(function(){
    'use strict';

    angular
        .module('app.calendar')
        .filter('loadOperationsEvents', loadOperationsEvents)

    function loadOperationsEvents(
        CalendarF
    ){

        return loadOperationsEventsFn;

        function loadOperationsEventsFn(){
            
            return CalendarF.loadOperationsEvents();
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.calendar')
        .filter('isGratherThan', isGratherThan)

    function isGratherThan() {

        return isGratherThanFn;

        function isGratherThanFn(d, dtc) {
            d = moment(angular.copy(d));
            dtc = moment(angular.copy(dtc));
            d.set("hour", 59);
            d.set("minute", 59);
            d.set("second", 59);
            d.set("millisecond", 59);
            dtc.set("hour", 59);
            dtc.set("minute", 59);
            dtc.set("second", 59);
            dtc.set("millisecond", 59);
            if(d.valueOf()>dtc.valueOf()){
                return true;
            }else{
                return false;
            }
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.calendar')
        .filter('getOperationDates', getOperationDates);

    function getOperationDates($log) {

        return getOperationDatesFn;

        function getOperationDatesFn(date, dateType) {
            var days = 0;
            switch (dateType) {
                case 'dispersion':
                    days = 1;
                    break;
                case 'reception':
                    days = 4;
                    break;
            }
            date = moment(angular.copy(date));
            date = date.startOf('day');
            date.subtract(days, 'days');
            if (date.weekday() === 5 || date.weekday() === 6) {
                if (date.weekday() === 6) {
                    date.subtract(2, 'days');
                } else {
                    date.subtract(1, 'days');
                }
            }
            return date.valueOf();
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.calendar')
        .filter('getEventsBetweenDates', getEventsBetweenDates)

    function getEventsBetweenDates(getEventOperationNameFilter) {

        return getEventsBetweenDatesFn;

        function getEventsBetweenDatesFn(allEvents, startDate, endDate) {
            var events = [];
            angular.forEach(allEvents, function(event, key) {
                var thisDate = moment(angular.copy(event.start));
                if (thisDate.isBetween(startDate, endDate)) {
                    getEventOperationNameFilter(event)
                    events.push(event);
                }
            });
            return events;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.calendar')
        .filter('getEventOperationName', getEventOperationName)

    function getEventOperationName(getCountOperationStatusFilter) {

        return getEventOperationNameFn;

        function getEventOperationNameFn(event) {
            if (event.title == "recepcion") {
                var numEvents = getCountOperationStatusFilter(event.operations, 1);
                event.title = "Recepcion de nominas " + numEvents;
            } else if (event.title == "dispersion") {
                var numEvents = getCountOperationStatusFilter(event.operations, 8);
                event.title = "Dispersion de nominas " + numEvents;
            }


        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.calendar')
        .filter('getCountOperationStatus', getCountOperationStatus)

    function getCountOperationStatus() {

        return getCountOperationStatusFn;

        function getCountOperationStatusFn(operations, status) {
            var total = 0;
            var thisStatus = 0;
            angular.forEach(operations, function(value, key) {
                total++;
                if (value.status) {
                    if (value.status >= status) {
                        thisStatus++;
                    }
                }

            })
            return (thisStatus + "/" + total);
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.calendar')
        .filter('createEvents', createEvents)

    function createEvents(getObjectOfArrayByIdFilter, getOperationDatesFilter) {

        return createEventsFn;

        function createEventsFn(operations, startDate, endDate) {
            var newEvents = [];
            angular.forEach(operations, function (payroll) {
                angular.forEach(payroll, function (operation) {
                    var dispersionDate = '';
                    if (operation.dispersionDate) {
                        dispersionDate = moment(operation.dispersionDate);
                    } else {
                        dispersionDate = moment(getOperationDatesFilter(operation.end, 'dispersion'));
                    }
                    if (startDate.valueOf() < dispersionDate.valueOf() && dispersionDate.valueOf() < endDate.valueOf()) {
                        var objDispersion = getObjectOfArrayByIdFilter(dispersionDate.valueOf() + 'D', newEvents, 'identificator');
                        if (objDispersion) {
                            var indexD = newEvents.indexOf(objDispersion);
                            newEvents[indexD].operations.push(operation);
                        } else {
                            var msDispersion = dispersionDate.valueOf() + 'D';
                            var eventD = {
                                identificator: msDispersion,
                                allDay: true,
                                title: 'dispersion',
                                start: moment(dispersionDate.valueOf()).toDate(),
                                end: null,
                                operations: [operation],
                                type: 'operationEvents'
                            };
                            newEvents.push(eventD);
                        }
                    }
                    var recepcionDate = '';
                    if (operation.receptionDate) {
                        recepcionDate = moment(operation.receptionDate);
                    } else {
                        recepcionDate = moment(getOperationDatesFilter(operation.end, 'reception'));
                    }
                    if (startDate.valueOf() < recepcionDate.valueOf() && recepcionDate.valueOf() < endDate.valueOf()) {
                        var objRecepcion = getObjectOfArrayByIdFilter(recepcionDate.valueOf() + 'R', newEvents, 'identificator');
                        if (objRecepcion) {
                            var indexR = newEvents.indexOf(objRecepcion);
                            newEvents[indexR].operations.push(operation);
                        } else {
                            var msRecepcion = recepcionDate.valueOf() + 'R';
                            var eventR = {
                                identificator: msRecepcion,
                                allDay: true,
                                title: 'recepcion',
                                start: moment(recepcionDate.valueOf()).toDate(),
                                end: null,
                                operations: [operation],
                                type: 'operationEvents'
                            };
                            newEvents.push(eventR);
                        }
                    }
                });
            });
            return newEvents;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.calendar')
        .filter('changeEvents', changeEvents)

    function changeEvents(getEventsBetweenDatesFilter) {

        return changeEventsFn;

        function changeEventsFn(actualEventsArray, newEvents, startDate, endDate) {
            actualEventsArray.splice(0, actualEventsArray.length);
            var eventsToRender = getEventsBetweenDatesFilter(newEvents, startDate, endDate);
            angular.forEach(eventsToRender, function(value, key) {
                actualEventsArray.push(value);
            });
            //console.log(actualEventsArray);
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.chat', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider ) {
        // State
        $stateProvider.state('app.chat', {
            url: '/chat',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/chat/chat.html',
                    controller: 'ChatController'
                }
            }
        });
        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/chat');
    }

})();
(function() {
    'use strict';

    angular
        .module('app.chat')
        .factory('ChatsService', ChatsService);

    /** @ngInject */
    function ChatsService($rootScope, $timeout, $filter, AppF) {

        var AppF;
        var root;
        var watchingContacts = false;
        var watchingChats = false;
        var watchingProfile = false;
        var service = {
            chats: [],
            contacts: [],
            sendMsg: sendMsg
        };

      
        return service;
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('listFilters', listFilters)
        .directive('listFilterCompaniesRecord', listFilterCompaniesRecord)
        .directive('listFilterCompaniesRecordOne', listFilterCompaniesRecordOne)
        .directive('listFilterEmployeeAutocomplete', listFilterEmployeeAutocomplete)
        .directive('listFilterPayroll', listFilterPayroll)
        .directive('listFilterPayrollWg', listFilterPayrollWg)
        .directive('listFilterRp', listFilterRp)
        .directive('listFilterCalendar', listFilterCalendar)
        .directive('listFilterHasError', listFilterHasError)
        .directive('listFilterSentStatus', listFilterSentStatus)
        .directive('listFilterCc', listFilterCc)
        .directive('listFilterStatus', listFilterStatus)
        .directive('listFilterTicketStatus', listFilterTicketStatus)
        .directive('listFilterHasSeniorityDate', listFilterHasSeniorityDate)
        .directive('listFilterGroupings', listFilterGroupings)
        .directive('listFilterCreditStatus', listFilterCreditStatus)
        .directive('listFilterLoanStatus', listFilterLoanStatus)
        .directive('listFilterContractStatus', listFilterContractStatus)
        .directive('listFilterPeriod', listFilterPeriod)
        .directive('listFilterOperationType', listFilterOperationType)
        .directive('listFilterIncidencesStatus', listFilterIncidencesStatus)
        .directive('listFilterIncidencesTypes', listFilterIncidencesTypes)
        .directive('listFilterConceptType', listFilterConceptType)
        .directive('listFilterCalendarSelect', listFilterCalendarSelect)
        .directive('listFilterToDate', listFilterToDate)
        .directive('listFilterFromDate', listFilterFromDate)
        .directive('listFilterNature', listFilterNature)
        .directive('listFilterFormule', listFilterFormule)
        .directive('listFilterAction', listFilterAction)
        .directive('listFilterProfile', listFilterProfile)
        .directive('listFilterPeriodicity', listFilterPeriodicity)
        .directive('listFilterMonth', listFilterMonth)
        .directive('listFilterMonthBirth', listFilterMonthBirth)
        .directive('listFilterDocumentType', listFilterDocumentType)
        .directive('listFilterBatchTaskStatus', listFilterBatchTaskStatus)
        .directive('listFilterDiffFactor', listFilterDiffFactor)
        .directive('listFilterArchived', listFilterArchived)
        .directive('listFilterApps', listFilterApps)
        .directive('listFilterMovementType', listFilterMovementType)
        .directive('listFilterModulesItems', listFilterModulesItems);


    /** @ngInject */

    function listFilters(AppF, DataF, MongoF, CatalogsF, ListsF, RoutesF, errAlertS, $q, $localStorage, $log, $timeout, $filter) {
        return {
            scope: {
                ngModel: '=',
                modelName: '@',
                onChange: '=',
                columnsRepeat: '=',
                menuObjName: '@',
                initFilters: '<',
                tabName: '<',
                tabConfig: '<',
                filtersLoaded: '='
            },
            require: 'ngModel',
            link: function (scope, ele, attr, ngModel) {
                scope.filtersLoaded = false;
                scope.F = AppF;
                scope.L = ListsF;
                AppF.hideFilters = false;
                scope.dataFilters = [];
                scope.dataFilterN = {};
                scope.model = {};
                scope.F.selectedEmployee = '';
                scope.F.searchEmployee = '';
                scope.openMenu = function ($mdOpenMenu, ev) {
                    $mdOpenMenu(ev);
                };
                scope.createConfiguration = function (index, value, menuName) {
                    var cache = angular.fromJson(localStorage.getItem('configuration-' + menuName));
                    if (cache !== null) {
                        cache[value.name] = { catalogs: value.catalogs, name: value.name, show: (value.show) ? false : true };
                    } else {
                        cache = {};
                        cache[value.name] = { catalogs: value.catalogs, name: value.name, show: (value.show) ? false : true };
                    }
                    localStorage.setItem('configuration-' + menuName, angular.toJson(cache));
                };
                scope.toggleBar = function () {
                    AppF.hideFilters = !AppF.hideFilters;
                };
                scope.setModel = function (from, notFireFilter) {

                    if (scope.dataFilters.indexOf('apps') !== -1) {
                        setAppsPermission();
                    }
                    if (scope.dataFilters.indexOf('cc') !== -1) {
                        setCC();
                    }
                    ngModel.$setViewValue(scope.model);
                    $localStorage['filters-' + scope.modelName] = angular.toJson(scope.model);
                    if (angular.isFunction(scope.onChange) && !notFireFilter) {
                        scope.onChange(false, 'fromFilters');
                    }
                };
                scope.fireChange = function () {
                    if (angular.isFunction(scope.onChange)) {
                        scope.onChange();
                    }
                };
                function setAppsPermission() {
                    scope.couldSyncHumand = $filter('userHasPermission')(AppF.groupsOfUser, AppF.permissions, 'syncHumand', 'captures.employees');
                    scope.couldSyncBuk = $filter('userHasPermission')(AppF.groupsOfUser, AppF.permissions, 'syncBuk', 'captures.employees');
                    scope.couldSyncGeovictoria = $filter('userHasPermission')(AppF.groupsOfUser, AppF.permissions, 'syncGeovictoria', 'captures.employees');
                }
                function setCC() {
                    var mainCcs = scope.F.permissionToAccessAllPayrolls ? $filter('getFromObject')(scope.L, 'ccs') : $filter('getFromObject')(scope.L, 'userCcs.' + scope.F.profile.uid);
                    if (angular.isArray(mainCcs)) {
                        mainCcs = $filter('orderBy')([].concat(mainCcs), 'name');
                        var thisCcs = $filter('byArrayField')(mainCcs, [scope.model[scope.dataFilterN.payroll], scope.model[scope.dataFilterN.rp]], ['payroll', 'rp_id']);
                        for (var t = 0; t < thisCcs.length; t++) {
                            thisCcs[t].rpName = $filter('nameOfL')(thisCcs[t]['rp_id'], ListsF.rps);
                        }
                        scope.thisCcs = thisCcs;
                    }
                }
                scope.autocompleteListM = function (search, catalog, fields) {
                    return $q(function (resolve, reject) {
                        var extraQuerys = { 'center': AppF.center };
                        if (!scope.F.permissionToAccessAllPayrolls) {
                            extraQuerys = { cc: { $in: $filter('getArrayOfIds')($filter('getFromObject')(scope.L, 'userCcs.' + scope.F.profile.uid, [])) } };
                        }
                        DataF.api.autocompleteMongo(search, catalog, fields, extraQuerys).then(function (items) {
                            resolve(items);
                        }).catch(function (err) {
                            errAlertS(err);
                            reject(err);
                        });
                    });
                };
                scope.deleteFilters = function () {
                    scope.model = {};
                    scope.F.search[scope.menuObjName] = '';
                    scope.F.orderMongo = (RoutesF.listOrder[scope.F.active.menuName]) ? RoutesF.listOrder[scope.F.active.menuName] : '$id';
                    scope.F.selectedEmployee = '';
                    scope.F.searchEmployee = '';
                    scope.$evalAsync();
                    $timeout(function () {
                        scope.setModel();
                    }, 0, false);
                };
                function setFilter() {
                    $log.log('setFilterCalled');
                    if (angular.isArray(AppF.active.$filters)) {
                        scope.dataFilters = AppF.active.$filters.slice();
                        for (var d = 0; d < AppF.active.$filters.length; d++) {
                            scope.dataFilterN[AppF.active.$filters[d]] = AppF.active.$filters[d];
                        }
                    } else {
                        scope.dataFilters = [];
                        scope.dataFilterN = angular.fromJson(angular.toJson(AppF.active.$filters));
                        $filter('loopEach')(AppF.active.$filters, function (data, key) {
                            scope.dataFilters.push(key);
                        });
                    }
                    if (angular.isDefined(scope.tabConfig) && scope.tabConfig.hasOwnProperty('filters')) {
                        if (angular.isArray(scope.tabConfig.filters)) {
                            scope.dataFilters = scope.dataFilters.concat(scope.tabConfig.filters);
                            for (var s = 0; s < scope.tabConfig.filters.length; s++) {
                                scope.dataFilterN[scope.tabConfig.filters[s]] = scope.tabConfig.filters[s];
                            }
                        } else {
                            $filter('loopEach')(scope.tabConfig.filters, function (data, key) {
                                scope.dataFilters.push(key);
                                scope.dataFilterN[key] = data;
                            });
                        }
                    }
                    if (!AppF.isDistributor()) {
                        if (scope.dataFilters.indexOf('rp') > -1) {
                            scope.dataFilters.splice(scope.dataFilters.indexOf('rp'), 1);
                        }
                        if (scope.dataFilters.indexOf('companiesRecord') > -1) {
                            scope.dataFilters.splice(scope.dataFilters.indexOf('companiesRecord'), 1);
                        }
                    }
                    if (scope.dataFilters.indexOf('companiesRecord') > -1) {
                        if (AppF.permissionToAccessAllPayrolls) {
                            scope.companies = ListsF.companiesRecords;
                        } else {
                            var allCompaniesRecords = [];
                            ListsF.payrolls.map(function (item) {
                                $filter('loopEach')(item.processes, function (data) {
                                    if (data.companiesRecord && allCompaniesRecords.indexOf(data.companiesRecord) === -1) {
                                        allCompaniesRecords.push(data.companiesRecord);
                                    }
                                });
                            });
                            scope.companies = ListsF.companiesRecords.filter(function (item) {
                                return allCompaniesRecords.indexOf(item.$id) > -1;
                            });
                        }
                    }
                    if (angular.isDefined($localStorage['filters-' + scope.modelName])) {
                        var thisFilters;
                        try {
                            thisFilters = angular.fromJson($localStorage['filters-' + scope.modelName]);
                        } catch (error) {
                            $log.error(error);
                        }
                        if (angular.isObject(thisFilters)) {
                            scope.model = thisFilters;
                            scope.setModel('init', true);
                        }
                    }
                    var dataFiltersLength = scope.dataFilters.length;
                    scope.checkBoxSection = 0;
                    if (scope.dataFilters.indexOf("diffFactor") > -1) {
                        dataFiltersLength--;
                        scope.checkBoxSection++;
                    }
                    scope.flex = {
                        xs: $filter('number')(100 / (dataFiltersLength > 2 ? 2 : dataFiltersLength), 0),
                        sm: $filter('number')(100 / (dataFiltersLength > 4 ? 4 : dataFiltersLength), 0),
                        md: $filter('number')(dataFiltersLength > 5 ? (dataFiltersLength < 8 ? 15 : 20) : (100 / dataFiltersLength), 0)
                    };
                    scope.filtersLoaded = true;
                }
                function init() {
                    setFilter();
                    var promises = [];
                    if (scope.dataFilters.indexOf('employee') && scope.model[scope.dataFilterN.employee]) {
                        var modelName = scope.dataFilterN.employee;
                        var modelValue = scope.model[modelName];
                        promises.push(new Promise(function (resolve, reject) {
                            AppF.root.child('catalogs/employees/collection/' + modelValue + '/data/name').once('value').then(function (snap) {
                                scope.F.searchEmployee = snap.val();
                                scope.F.selectedEmployee = { $id: scope.model[modelName], data: { name: snap.val() } };
                                scope.$evalAsync();
                                resolve(true);
                            }).catch(reject);
                        }));
                    }
                    Promise.all(promises).then(function () {
                        scope.setModel();
                        scope.$watch('tabName', function () {
                            setFilter();
                        });

                    }).catch(errAlertS);
                }
                if (scope.initFilters) {
                    init();
                } else {
                    var onlyW = scope.$watch('initFilters', function (value) {
                        if (value) {
                            onlyW();
                            init();
                        }
                    }, true);
                }

            },
            templateUrl: 'app/main/acommon/directives/listFilters/filter-toolbar.html',
            restrict: 'AE',
            transclude: true
        };
    }
    function listFilterDiffFactor() {
        return {
            restrict: 'A',
            scope: false,
            templateUrl: 'app/main/acommon/directives/listFilters/diff-factor.html'
        };
    }
    function listFilterCompaniesRecord() {
        return {
            restrict: 'A',
            scope: false,
            templateUrl: 'app/main/acommon/directives/listFilters/companies-record.html'
        };
    }
    function listFilterCompaniesRecordOne() {
        return {
            restrict: 'A',
            scope: false,
            templateUrl: 'app/main/acommon/directives/listFilters/companies-record-one.html'
        };
    }
    function listFilterEmployeeAutocomplete() {
        return {
            restrict: 'A',
            scope: false,
            templateUrl: 'app/main/acommon/directives/listFilters/employee-autocomplete.html'
        };
    }

    function listFilterPayroll() {
        return {
            restrict: 'A',
            scope: false,
            templateUrl: 'app/main/acommon/directives/listFilters/payroll.html'
        };
    }
    function listFilterPayrollWg() {
        return {
            restrict: 'A',
            scope: false,
            templateUrl: 'app/main/acommon/directives/listFilters/payrollWg.html'
        };
    }
    function listFilterRp() {
        return {
            restrict: 'A',
            scope: false,
            templateUrl: 'app/main/acommon/directives/listFilters/rp.html'
        };
    }
    function listFilterCalendar() {
        return {
            restrict: 'A',
            scope: false,
            templateUrl: 'app/main/acommon/directives/listFilters/calendar.html'
        };
    }
    function listFilterPeriod() {
        return {
            restrict: 'A',
            scope: false,
            templateUrl: 'app/main/acommon/directives/listFilters/period.html'
        };
    }
    function listFilterHasError() {
        return {
            restrict: 'A',
            scope: false,
            templateUrl: 'app/main/acommon/directives/listFilters/has-error.html'
        };
    }
    function listFilterApps() {
        return {
            restrict: 'A',
            scope: false,
            templateUrl: 'app/main/acommon/directives/listFilters/apps.html'
        };
    }
    function listFilterSentStatus() {
        return {
            restrict: 'A',
            scope: false,
            templateUrl: 'app/main/acommon/directives/listFilters/sent-status.html'
        };
    }
    function listFilterCc() {
        return {
            restrict: 'A',
            scope: false,
            templateUrl: 'app/main/acommon/directives/listFilters/cc.html'
        };
    }
    function listFilterStatus() {
        return {
            restrict: 'A',
            scope: false,
            templateUrl: 'app/main/acommon/directives/listFilters/status.html'
        };
    }
    function listFilterHasSeniorityDate() {
        return {
            restrict: 'A',
            scope: false,
            templateUrl: 'app/main/acommon/directives/listFilters/hasSeniorityDate.html'
        };
    }
    function listFilterGroupings() {
        return {
            restrict: 'A',
            scope: false,
            templateUrl: 'app/main/acommon/directives/listFilters/groupings.html'
        };
    }
    function listFilterArchived() {
        return {
            restrict: 'A',
            scope: false,
            templateUrl: 'app/main/acommon/directives/listFilters/archived.html'
        };
    }
    function listFilterCreditStatus() {
        return {
            restrict: 'A',
            scope: false,
            templateUrl: 'app/main/acommon/directives/listFilters/credit-status.html'
        };
    }
    function listFilterLoanStatus() {
        return {
            restrict: 'A',
            scope: false,
            templateUrl: 'app/main/acommon/directives/listFilters/loan-status.html'
        };
    }
    function listFilterContractStatus() {
        return {
            restrict: 'A',
            scope: false,
            templateUrl: 'app/main/acommon/directives/listFilters/contract-status.html'
        };
    }
    function listFilterOperationType() {
        return {
            restrict: 'A',
            scope: false,
            templateUrl: 'app/main/acommon/directives/listFilters/operation-type.html'
        };
    }
    function listFilterIncidencesStatus() {
        return {
            restrict: 'A',
            scope: false,
            templateUrl: 'app/main/acommon/directives/listFilters/incidences-status.html'
        };
    }
    function listFilterIncidencesTypes() {
        return {
            restrict: 'A',
            scope: false,
            templateUrl: 'app/main/acommon/directives/listFilters/incidences-types.html'
        };
    }
    function listFilterConceptType() {
        return {
            restrict: 'A',
            scope: false,
            templateUrl: 'app/main/acommon/directives/listFilters/concept-type.html'
        };
    }
    function listFilterCalendarSelect() {
        return {
            restrict: 'A',
            scope: false,
            templateUrl: 'app/main/acommon/directives/listFilters/calendar-select.html'
        };
    }
    function listFilterToDate() {
        return {
            restrict: 'A',
            scope: false,
            templateUrl: 'app/main/acommon/directives/listFilters/to-date.html'
        };
    }
    function listFilterNature() {
        return {
            restrict: 'A',
            scope: false,
            templateUrl: 'app/main/acommon/directives/listFilters/nature.html'
        };
    }
    function listFilterFormule() {
        return {
            restrict: 'A',
            scope: false,
            templateUrl: 'app/main/acommon/directives/listFilters/formule.html'
        };
    }
    function listFilterFromDate() {
        return {
            restrict: 'A',
            scope: false,
            templateUrl: 'app/main/acommon/directives/listFilters/from-date.html'
        };
    }
    function listFilterAction() {
        return {
            restrict: 'A',
            scope: false,
            templateUrl: 'app/main/acommon/directives/listFilters/action.html'
        };
    }
    function listFilterProfile() {
        return {
            restrict: 'A',
            scope: false,
            templateUrl: 'app/main/acommon/directives/listFilters/profile.html'
        };
    }
    function listFilterPeriodicity() {
        return {
            restrict: 'A',
            scope: false,
            templateUrl: 'app/main/acommon/directives/listFilters/periodicity.html'
        };
    }
    function listFilterMonth() {
        return {
            restrict: 'A',
            scope: false,
            templateUrl: 'app/main/acommon/directives/listFilters/month.html'
        };
    }
    function listFilterMonthBirth() {
        return {
            restrict: 'A',
            scope: false,
            templateUrl: 'app/main/acommon/directives/listFilters/monthBirth.html'
        };
    }
    function listFilterDocumentType() {
        return {
            restrict: 'A',
            scope: false,
            templateUrl: 'app/main/acommon/directives/listFilters/document-type.html'
        };
    }
    function listFilterTicketStatus() {
        return {
            restrict: 'A',
            scope: false,
            templateUrl: 'app/main/acommon/directives/listFilters/ticket-status.html'
        };
    }

    function listFilterBatchTaskStatus() {
        return {
            restrict: 'A',
            scope: false,
            templateUrl: 'app/main/acommon/directives/listFilters/batch-task-status.html'
        };
    }
    function listFilterMovementType() {
        return {
            restrict: 'A',
            scope: false,
            templateUrl: 'app/main/acommon/directives/listFilters/movement-type.html'
        };
    }
    function listFilterModulesItems() {
        return {
            restrict: 'A',
            scope: false,
            templateUrl: 'app/main/acommon/directives/listFilters/modules-items.html'
        };
    }

}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('validateIncidence', validateIncidence);


    /** @ngInject */
    function validateIncidence(filterFilter, CalendarF, $q) {
        return {
            require: 'ngModel',
            restrict: 'A',
            link: function (scope, element, attrs, ngModel) {
                ngModel.$asyncValidators.availablePeriod = function (modelValue, viewValue) {
                    var options = {
                        date: modelValue
                    }
                    console.log("from validator");
                    return CalendarF.getActiveOperations(scope.payroll, 1, options).then(function (posibleOperation) {
                        try {
                            var flag = false;
                            if (posibleOperation.length > 0) {
                                flag = true;
                                scope.period = parseInt(posibleOperation[0].period);
                                scope.calendar = parseInt(posibleOperation[0].calendar);
                            }
                            if (flag) {
                                return true;
                            } else {
                                return $q.reject();
                            }
                        } catch (error) {
                            console.error(error);
                            return $q.reject();
                        }
                    })
                };
            }
        }
    }
}());
angular.module('app.clients').directive('validateFields', function ($log, $timeout) {
    return {
        restrict: 'A',
        require: 'ngModel',
        scope: {
            validateFields: "<"
        },
        link: function (scope, element, attrs, ngModel) {
            function isTextField() {
                return ['text', 'alphanumeric', 'textarea'].indexOf(scope.validateFields.type) > -1;
            }

            if (scope.validateFields.min) {
                ngModel.$validators.min = function (modelValue, viewValue) {
                    var value = angular.isDefined(viewValue) ? viewValue : modelValue;
                    if (ngModel.$isEmpty(value)) {
                        return true;
                    }

                    if (isTextField()) {
                        return String(value).length >= scope.validateFields.min;
                    }

                    if (scope.validateFields.type === 'number') {
                        return Number(value) >= scope.validateFields.min;
                    }

                    return true;
                };
            }
            if (scope.validateFields.max) {
                ngModel.$validators.max = function (modelValue, viewValue) {
                    var value = angular.isDefined(viewValue) ? viewValue : modelValue;
                    if (ngModel.$isEmpty(value)) {
                        return true;
                    }

                    if (isTextField()) {
                        return String(value).length <= scope.validateFields.max;
                    }

                    if (scope.validateFields.type === 'number') {
                        return Number(value) <= scope.validateFields.max;
                    }

                    return true;
                };
            }
            if (scope.validateFields.type === 'text' || scope.validateFields.type === 'textarea' && !scope.validateFields.allowLowerCase) {
                ngModel.$parsers.push(function (value) {
                    var upper = value.toUpperCase();
                    if (upper !== value) {
                        ngModel.$setViewValue(upper);
                        ngModel.$render();
                    }
                    return upper
                });
                // ngModel.$parsers.push(function (value) {
                //     var lower = value.toLowerCase();
                //     if (lower !== value) {
                //         ngModel.$setViewValue(lower);
                //         ngModel.$render();
                //     }
                //     $log.log('Entro por lower', lower);
                //     return lower;

                // });
            }

            // if (scope.validateFields.defaultValue) {
            $log.log(scope.validateFields)
            var defaultValue = eval(scope.validateFields.defaultValue);
            $timeout(function () {
                if (!ngModel.$modelValue && defaultValue) {
                    var trimmedValue = String(defaultValue).trim();
                    ngModel.$setViewValue(trimmedValue);
                    ngModel.$render();
                }
            });

            element.on('blur', function () {
                scope.$apply(function () {
                    var currentValue = ngModel.$viewValue;
                    if (currentValue) {
                        var trimmedValue = String(currentValue).trim();
                        if (trimmedValue !== currentValue) {
                            ngModel.$setViewValue(trimmedValue);
                            ngModel.$render();
                        }
                    } else if (defaultValue) {
                        var trimmedDefault = String(defaultValue).trim();
                        ngModel.$setViewValue(trimmedDefault);
                        ngModel.$render();
                    }
                });
            });
            // }
        }
    };
});

(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('validateIncidencesQty', validateIncidencesQty);


    /** @ngInject */
    function validateIncidencesQty($log) {
        return {
            require: 'ngModel',
            restrict: 'A',
            scope: {
                'maxIncidences': '<'
            },
            link: function (scope, elem, attrs, ngModel) {
                var validate = function (value) {
                    if (!ngModel.$isEmpty(value) && angular.isDefined(scope.maxIncidences) && value > scope.maxIncidences) {
                        value = scope.maxIncidences;
                        ngModel.$setViewValue(value);
                        ngModel.$render();
                    }
                    return value;
                };
                ngModel.$parsers.push(validate);
                validate(ngModel.$viewValue); // capitalize initial value
                scope.$watch('maxIncidences', function () {
                    validate(ngModel.$viewValue); // capitalize initial value
                });
            }
        }
    }
}());
(function () {
    'use strict';
    angular
        .module('app.core')
        .directive('validateFormButton', validateFormButton);
    /** @ngInject */
    function validateFormButton() {
        return {
            template: 
            '<md-button type="submit"'+
            '           ng-if="form.$invalid"'+
            '           ng-click="showListPending(event,form)"'+
            '           with-permission'+
            '           access="{{F.active.menuItem}}"'+
            '           class="md-fab md-red-600-bg"'+
            '           aria-label="Validation of Fields">'+
            '   <md-tooltip md-direction="left">Más Información</md-tooltip>'+
            '   <md-icon md-font-icon="icon-alert" aria-label="Information"></md-icon>'+
            '</md-button>'
        };
    }
}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('validConstantFormule', validConstantFormule);


    /** @ngInject */
    function validConstantFormule(getConstantFormulaFilter, getIndicesOfStringFilter) {

        return {
            require: 'ngModel',
            restrict: 'A',
            scope: {
                'calcFields': '='
            },
            link: function (scope, elem, attr, ngModel) {
                if (!ngModel) return; // do nothing if no ng-model

                var check = function (formula, fields) {
                    var valid = true;
                    var valorIndexs = getIndicesOfStringFilter("$valor", formula);
                    var initIndexes = getIndicesOfStringFilter("[", formula);
                    var lastIndexes = getIndicesOfStringFilter("]", formula);
                    if (initIndexes.length != lastIndexes.length) {
                        valid = false;
                    }
                    console.log(valid)
                    if (valid) {
                        angular.forEach(valorIndexs, function () {
                            formula = formula.replace("$valor", 1);
                        })
                        console.log(formula);
                        var validFormula = getConstantFormulaFilter(formula, fields, 2);
                        console.log(validFormula);
                        if (validFormula.valid) {
                            try {
                                eval(validFormula.formula);
                            } catch (e) {
                                valid = false;
                            }
                        }
                    }
                    return valid;
                }

                var doValidation = function (value) {
                    var valid = check(value, scope.calcFields);
                    ngModel.$setValidity('valid', valid);
                }

                ngModel.$parsers.unshift(function (value) {
                    if (value) {
                        doValidation(value);
                    }
                    return value;
                });

                ngModel.$formatters.unshift(function (value) {
                    if (value) {
                        doValidation(value);
                    }
                    return value;
                });
            }
        }
    }
}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('uniqueMongo', uniqueMongo);


    /** @ngInject */
    function uniqueMongo($q, DataF, $log) {
        return {
            require: 'ngModel',
            scope: {
                extraFields: '<'
            },
            restrict: 'A',
            link: function (scope, element, attrs, ngModel) {
                function validate(value) {
                    return new Promise(function (resolve, reject) {
                        if (angular.isDefined(attrs.field) && angular.isDefined(attrs.catalog) && !ngModel.$isEmpty(value)) {
                            try {
                                var queries = {};
                                queries[attrs.field] = value;
                                if (angular.isObject(scope.extraFields)) {
                                    $log.log(scope.extraFields, typeof (scope.extraFields));
                                    // var extraFields = JSON.parse(attrs.extraFields);
                                    // if (angular.isObject(extraFields)) {
                                    for (var f in scope.extraFields) {
                                        if (scope.extraFields.hasOwnProperty(f)) {
                                            queries[f] = scope.extraFields[f];
                                        }
                                    }
                                    // }
                                }
                                return DataF.api.get('one/' + attrs.catalog, queries).then(function (resp) {
                                    var alreadyExist = false;
                                    if (angular.isObject(resp.data) && angular.isObject(resp.data.data) && angular.isArray(resp.data.data) && resp.data.data.length > 0) {
                                        if(resp.data.data[0]._id !== attrs.fromId){
                                            alreadyExist = true;
                                        } 
                                    }
                                    if (alreadyExist) { reject('Existe'); }
                                    else { resolve(true); }
                                }).catch(function (error) {
                                    reject(error);
                                });
                            } catch (error) {
                                reject(error);
                            }
                        } else {
                            resolve(true);
                        }
                    });
                }

                ngModel.$asyncValidators.unique = function (modelValue) {
                    return validate(modelValue).then(function () {
                        return true;
                    }).catch(function (error) {
                        $log.error(error);
                        return $q.reject(error);
                    });
                };
            }
        }
    }
}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('sbcConsistency', sbcConsistency);


    /** @ngInject */
    function sbcConsistency($rootScope) {
        return {
            require: 'ngModel',
            restrict: 'A',
            scope: {
                'validator': '=',
                'sd': '<'
            },
            link: function (scope, elem, attr, ngModel) {
                ngModel.$parsers.unshift(function (value) {
                    if (value < scope.validator.minimumSbc) {
                        ngModel.$setViewValue(scope.validator.minimumSbc);
                        ngModel.$setModelValue = scope.validator.minimumSbc;
                        ngModel.$render();
                        $rootScope.$evalAsync();
                        return scope.validator.minimumSbc;
                    }
                    return value;
                });
            }
        }
    }
}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('rfc', rfc);


    /** @ngInject */
    function rfc($log) {
        return {
            require: 'ngModel',
            restrict: 'A',
            link: function (scope, elem, attr, ngModel) {
                var charValues = [
                    { char: "1", value: 1 },
                    { char: "2", value: 2 },
                    { char: "3", value: 3 },
                    { char: "4", value: 4 },
                    { char: "5", value: 5 },
                    { char: "6", value: 6 },
                    { char: "7", value: 7 },
                    { char: "8", value: 8 },
                    { char: "9", value: 9 },
                    { char: "A", value: 10 },
                    { char: "B", value: 11 },
                    { char: "C", value: 12 },
                    { char: "D", value: 13 },
                    { char: "E", value: 14 },
                    { char: "F", value: 15 },
                    { char: "G", value: 16 },
                    { char: "H", value: 17 },
                    { char: "I", value: 18 },
                    { char: "J", value: 19 },
                    { char: "K", value: 20 },
                    { char: "L", value: 21 },
                    { char: "M", value: 22 },
                    { char: "N", value: 23 },
                    { char: "&", value: 24 },
                    { char: "O", value: 25 },
                    { char: "P", value: 26 },
                    { char: "Q", value: 27 },
                    { char: "R", value: 28 },
                    { char: "S", value: 29 },
                    { char: "T", value: 30 },
                    { char: "U", value: 31 },
                    { char: "V", value: 32 },
                    { char: "W", value: 33 },
                    { char: "X", value: 34 },
                    { char: "Y", value: 35 },
                    { char: "Z", value: 36 },
                    { char: " ", value: 37 },
                    { char: "Ñ", value: 38 }
                ]
                function validateRfc(value) {
                    try {
                        value = (value + "").toUpperCase();
                        if ([13, 12].indexOf(value.length) === -1) {
                            throw 'Longitud no valida';
                        }
                        var thisPattern = /^([A-Z|a-z|&amp;]{3}\d{2}((0[1-9]|1[012])(0[1-9]|1\d|2[0-8])|(0[13456789]|1[012])(29|30)|(0[13578]|1[02])31)|([02468][048]|[13579][26])0229)(\w{2})([A|a|0-9]{1})$|^([A-Z|a-z]{4}\d{2}((0[1-9]|1[012])(0[1-9]|1\d|2[0-9])|(0[13456789]|1[012])(29|30)|(0[13578]|1[02])31)|([02468][048]|[13579][26])0229)((\w{3})){0,3}$/;
                        var pattern = new RegExp(thisPattern);
                        var valid = pattern.test(value);
                        if (!valid) {
                            throw 'Formato no valido'
                        }
                        var thisValue = value;
                        if (value.length === 12) {
                            thisValue = " " + value;
                        }
                        var total = 0;
                        for (var i = 0; i < (thisValue.length - 1); i++) {
                            var thisChar = thisValue.substring(i, i + 1);
                            var charFounded = charValues.find(function (item) {
                                return item.char === thisChar;
                            });
                            var charValue = 0;
                            if (angular.isDefined(charFounded)) {
                                charValue = charFounded.value;
                            }
                            var multiplicador = thisValue.length - i;
                            var result = charValue * multiplicador;
                            total += result;
                        }
                        var remainder = total % 11;
                        var finalResult = 11 - remainder;
                        var lastChar = thisValue.substring(thisValue.length - 1, thisValue.length);
                        $log.log(total, remainder, finalResult, lastChar);
                        finalResult = finalResult === 11 ? 0 : (finalResult === 10 ? 'A' : finalResult);
                        if (("" + finalResult) !== lastChar) {
                            throw "Dígito verificador no valido";
                        }

                        return value;
                    } catch (error) {
                        $log.error(error)
                        return false;
                    }
                }
                var exceptions = ["CCA050729SM8", "XAXX010101000"]
                ngModel.$validators.rfc = function (modelValue) {
                    if (ngModel.$isEmpty(modelValue)) {
                        return true;
                    }
                    if (attr.ignoreFormat === 'true') {
                        return true;
                    }
                    var valid;
                    var index = exceptions.indexOf(modelValue);
                    if (index > -1) {
                        valid = exceptions[index];
                    } else {
                        valid = validateRfc(modelValue);
                    }
                    if (valid) {
                        ngModel.$setViewValue(valid);
                    } else {
                        ngModel.$setDirty();
                        ngModel.$setTouched();
                    }
                    ngModel.$render();
                    return valid ? true : false;
                };
            }
        }
    }
}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('rfcConsistency', rfcConsistency);

    /** @ngInject */
    function rfcConsistency($timeout, $rootScope, getFromObjectFilter, $log) {
        return {
            require: 'ngModel',
            restrict: 'A',
            scope: { consistency: '=' },
            link: function (scope, elem, attr, ngModel) {
                if (!ngModel) return;
                var RFC_GENERIC = 'XAXX010101000';
                var DEBOUNCE_MS = 120;
                var revalidatePromise = null;
                function isDisabled() {
                    return attr.ignoreConsistency === '1' || attr.ignoreConsistency === 1 || attr.ignoreConsistency === 'true' || attr.ignoreConsistency === true;
                }
                function getFechaFromCredential(credential) {
                    return (credential || '').substr(4, 6); // YYMMDD
                }
                function getBirthYYMMDD(person) {
                    var birth = getFromObjectFilter(person, 'data.info.birth.date') || null;
                    if (!birth) return null;
                    var m = moment(birth);
                    if (!m.isValid()) return null;
                    return m.format('YYMMDD') || null;
                }

                function validate(value) {
                    // Si no hay valor, o no hay contexto, o está deshabilitado => no bloquees
                    if (!value || !scope.consistency || isDisabled()) return true;
                    var person = scope.consistency;
                    var data = person.data || {};
                    // RFC genérico: siempre pasa
                    if (value === RFC_GENERIC || data.rfc === RFC_GENERIC) return true;
                    // Solo validar cuando tenga longitud RFC real (12/13)
                    if (!(value.length === 12 || value.length === 13)) return true;
                    var rfcDate = getFechaFromCredential(value);
                    if (!rfcDate) return false;
                    var curp = (data.curp && data.curp !== '') ? data.curp : null;
                    var curpDate = curp ? getFechaFromCredential(curp) : null;
                    var birthDate = getBirthYYMMDD(person);
                    if (birthDate && curpDate) return birthDate === rfcDate && birthDate === curpDate;
                    if (birthDate) return birthDate === rfcDate;
                    if (curpDate) return rfcDate === curpDate;
                    // tu lógica original: si no hay birth ni curp, invalida
                    return false;
                }

                ngModel.$validators.consistency = function (modelValue, viewValue) {
                    $log.log('Validando consistencia RFC...', { modelValue: modelValue, viewValue: viewValue });
                    var value = modelValue || viewValue;
                    var result = validate(value);
                    $log.log('Resultado consistencia RFC:', result);
                    return result;
                };

                // Revalidar cuando cambie birth / curp (y si quieres, rfc del objeto)
                function debounceValidate() {
                    if (revalidatePromise) $timeout.cancel(revalidatePromise);
                    revalidatePromise = $timeout(function () {
                        ngModel.$validate();
                    }, DEBOUNCE_MS, false);
                }

                var unwatchBirth = scope.$watch(
                    function () {
                        return scope.consistency &&
                            scope.consistency.data &&
                            scope.consistency.data.info &&
                            scope.consistency.data.info.birth &&
                            scope.consistency.data.info.birth.date;
                    },
                    function (v) { if (v) debounceValidate(); }
                );

                var unwatchCurp = scope.$watch(
                    function () {
                        return scope.consistency && scope.consistency.data && scope.consistency.data.curp;
                    },
                    function (v) { if (v) debounceValidate(); }
                );

                var offStop = $rootScope.$on('stopDetailWatchers', function () {
                    if (unwatchBirth) unwatchBirth();
                    if (unwatchCurp) unwatchCurp();
                    if (offStop) offStop();
                });

                scope.$on('$destroy', function () {
                    if (revalidatePromise) $timeout.cancel(revalidatePromise);
                    if (unwatchBirth) unwatchBirth();
                    if (unwatchCurp) unwatchCurp();
                    if (offStop) offStop();
                });
            }
        };
    }
}());
(function() {
    'use strict';

    angular
        .module('app.core')
        .directive('removeSpace', removeSpace);

    function removeSpace() {
        return {
            require: 'ngModel',
            restrict: 'A',
            link: function(scope, element, attr, ngModel) {
                var toView = function (value) {
                    var reset = value.replace(/[\s]/g, '');
                    ngModel.$viewValue = reset;
                    ngModel.$render();
                    return reset; 
                }
                var toModel = function (value) {
                    ngModel.$modelValue = value;
                    ngModel.$setViewValue();
                    return value;
                }
                ngModel.$parsers.unshift(toView);
                ngModel.$formatters.unshift(toModel);
            }
        }
    }
}());
(function() {
    'use strict';

    angular
        .module('app.core')
        .directive('nss', nss);


    /** @ngInject */
    function nss($log) {

        return {
            require: 'ngModel',
            restrict: 'A',
            link: function(scope, elem, attr, ngModel) {
                var redondear_a_10 = function(num) {
                    num = parseInt(num);
                    if (num % 10 == 0) return num; // Si es un múltiplo de 10 exacto, no hacemos nada. 
                    return num + (10 - (num % 10)); // A $valor le sumamos lo que le falta para llegar al múltiplo de 10 siguiente 
                }
                var resta_9 = function(num) {
                    if (num >= 10) num = num - 9;
                    return num;
                }
                var check = function(value) {
                    var valid = true;
                    if (value) {
                        if (value == "00000000000") {
                            valid = true;
                        } else {
                            var numero = value;
                            var nss = numero.split("");
                            var digit = 1;
                            var suma = 0;
                            var num = 0;
                            for (var n in nss) {
                                if (n <= 9) {
                                    num = resta_9(nss[n] * digit);
                                    suma += num;
                                    digit = (digit == 1) ? 2 : 1;
                                }
                            }
                            var redondeo = redondear_a_10(suma);
                            var result = redondeo - suma;
                            $log.debug('checkNSS', {
                                redondeo: redondeo,
                                suma: suma,
                                resultado: result,
                                nss: nss,
                                ultimo: nss[10]
                            });
                            if (result != nss[10]) {
                                valid = false;
                            } else if (result == nss[10]) {
                                valid = true;
                            } else {
                                valid = false;
                            }
                        }
                    }
                    return valid;
                }

                var read = function() {
                    ngModel.$parsers.unshift(function(value) {
                        var valid = false;
                        if (!value) {
                            valid = true;
                        } else if (value.length == 11) {
                            valid = check(value);
                        }
                        ngModel.$setValidity('nss', valid);
                        if (!valid) {
                            ngModel.$setDirty();
                            ngModel.$setTouched();
                        }
                        return valid ? value : undefined;
                    });

                    ngModel.$formatters.unshift(function(value) {
                        var valid = false;
                        if (!value) {
                            valid = true;
                        } else if (value.length == 11) {
                            valid = check(value);
                        }
                        ngModel.$setValidity('nss', valid);
                        if (!valid) {
                            ngModel.$setDirty();
                            ngModel.$setTouched();
                        }
                        return value;
                    });
                }

                read();
            }
        }
    }
}());
angular.module('app.clients').directive('noWhiteSpaceInput', function () {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function (scope, element, attrs, ngModelCtrl) {
            ngModelCtrl.$parsers.push(function (value) {
                if (!value) return value;
                var cleaned = value.replace(/\s+/g, '');
                if (cleaned !== value) {
                    ngModelCtrl.$setViewValue(cleaned);
                    ngModelCtrl.$render();
                }
                return cleaned;
            });
        }
    };
});

(function () {
    'use strict';

    angular
        .module ('app.core')
        .directive ('fbInputSearch', fbInputSearch)
        .directive ('fbInputSearch2', fbInputSearch2)


    /** @ngInject */
    function fbInputSearch() {
        return {
            scope: true,
            restrict: 'A',
            transclude: true,
            replace: true,
            templateUrl: 'app/main/acommon/directives/inputs/fb-input-search.html'
        }
    }
    /** @ngInject */
    function fbInputSearch2() {
        return {
            scope: true,
            restrict: 'A',
            transclude: true,
            replace: true,
            templateUrl: 'app/main/acommon/directives/inputs/fb-input-search-2.html'
        }
    }

} ());
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('customDateFormat', customDateFormat);

    function customDateFormat($mdDateLocale) {
        return {
            require: 'ngModel',
            restrict: 'A',
            link: function (scope, element, attrs, ngModel) {
                var defaultFormatDate = $mdDateLocale.formatDate;

                $mdDateLocale.formatDate = function (date) {
                    if (attrs.customDateFormat === 'true' && date) {
                        return moment(date).locale('es').format('MMMM YYYY').toUpperCase();
                    }
                    return defaultFormatDate(date);
                };

                // Interceptar la selección para que solo guarde año y mes
                ngModel.$parsers.push(function (value) {
                    return value ? moment(value).startOf('month').toDate() : null;
                });

                scope.$on('$destroy', function () {
                    $mdDateLocale.formatDate = defaultFormatDate;
                });
            }
        };
    }
})();

(function () {
    'use strict';
    angular
        .module('app.core')
        .directive('emailBankValidator', emailBankValidator);
    /** @ngInject */
    function emailBankValidator($q, DataF, $log) {
        return {
            require: 'ngModel',
            scope: {
                payroll: '<',
                ignoreRegexValidation: '<'
            },
            restrict: 'A',
            link: function (scope, element, attrs, ngModel) {
                function validate(value) {
                    var email = value;
                    return new Promise(function (resolve, reject) {
                        var banks = [];
                        if (angular.isDefined(scope.payroll) && angular.isDefined(email) && !ngModel.$isEmpty(email)) {
                            if (angular.isDefined(scope.payroll.processes)) {
                                var process = scope.payroll.processes;
                                for (var key in process) {
                                    var value = process[key];
                                    if (value.bankAccounts) {
                                        for (var i = 0; i < value.bankAccounts.length; i++) {
                                            banks.push(value.bankAccounts[i]);
                                        }
                                    }
                                }
                                execute();
                            } else {
                                execute();
                            }
                        } else {
                            resolve(true);
                        }
                        function execute() {
                            var promises = [];
                            if (!scope.ignoreRegexValidation) {
                                promises.push(checkRegexEmailOfBank(banks));
                            }
                            Promise.all(promises).then(function (resp) {
                                var valid = true;
                                if (!scope.ignoreRegexValidation) {
                                    var regex = resp[0];
                                    var pattern = new RegExp(regex);
                                    valid = pattern.test(email);
                                }
                                if (valid) {
                                    resolve(true);
                                } else {
                                    reject(false);
                                }
                            });
                        }
                    });
                }
                function checkRegexEmailOfBank(banks) {
                    return new Promise(function (resolve, reject) {
                        var promises = [];
                        var array = [];
                        var patterDefault = /[a-zA-Z0-9_]+([.][a-zA-Z0-9_]+)*@[a-zA-Z0-9_-]+([.][a-zA-Z0-9_-]+)*[.][a-zA-Z]{2,}/;
                        if (angular.isDefined(banks)) {
                            for (var i = 0; i < banks.length; i++) {
                                promises.push(DataF.api.get('bankAccounts/' + banks[i]));
                            }
                            if (promises.length > 0) {
                                Promise.all(promises).then(function (response) {
                                    var queriesBanks = [];
                                    if (response.length > 0) {
                                        for (var r = 0; r < response.length; r++) {
                                            var result = response[r].data;
                                            if (result !== null && result.bank) {
                                                array.push(result.bank);
                                            }
                                        }
                                        var data = array.filter(function (el, index) {
                                            return array.indexOf(el) === index
                                        });
                                        for (var x = 0; x < data.length; x++) {
                                            queriesBanks.push(DataF.api.get('banks/' + data[x]));
                                        }
                                        return Promise.all(queriesBanks);
                                    } else {
                                        $log.debug("No hay ningun resgitro de cuentas de banco");
                                        resolve(patterDefault);
                                    }
                                }).then(function (response) {
                                    if (response.length > 0) {
                                        for (var i = 0; i < response.length; i++) {
                                            var bank = response[i].data;
                                            if (angular.isDefined(bank.emailRegex) && bank.emailRegex !== "") {
                                                resolve(bank.emailRegex);
                                            } else {
                                                resolve(patterDefault);
                                            }
                                        }
                                    } else {
                                        $log.debug("No hay ningun resgitro de bancos");
                                        resolve(patterDefault);
                                    }
                                }).catch(function (error) {
                                    reject(error);
                                });
                            } else {
                                resolve(patterDefault);
                            }
                        } else {
                            resolve(patterDefault);
                        }
                    })
                }
                ngModel.$asyncValidators.validFormat = function (modelValue) {
                    return validate(modelValue).then(function (response) {
                        return response;
                    }).catch(function (error) {
                        $log.error(error);
                        return $q.reject(error);
                    });
                };
                var emailWatcher = scope.$watch('payroll.processes', function () {
                    ngModel.$validate();
                }, true);
                var stopWatchers = scope.$on('stopDetailWatchers', function () {
                    emailWatcher();
                    stopWatchers();
                });
            }
        }
    }
}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('curp', curp);

    function curp() {
        return {
            require: 'ngModel',
            restrict: 'A',
            link: function (scope, elem, attr, ngModel) {
                /**
                 * @description Función para validar CURP de acuerdo a nuevo estandar de RENAPO 2017-2018
                 * @param {string} curp 
                 */
                function validateCurp(curp) {
                    var reg = '';
                    if (curp === 'XEXX010101ENEXXXA0') {
                        return true;
                    } else if (curp.length == 18) {
                        var digito = calculateDigit(curp);
                        reg = /[A-Z]{4}\d{6}[HMX][A-Z]{2}[B-DF-HJ-NP-TV-Z]{3}[A-Z0-9][0-9]/;
                        if (curp.search(reg)) {
                            return false;
                        }
                        if (!(parseInt(digito) == parseInt(curp.substring(17, 18)))) {
                            return digito;
                        }
                        return true;
                    } else {
                        switch (curp.length) {
                            case 10:
                                reg = /[A-Z]{4}\d{6}/;
                                break;
                            case 11:
                                reg = /[A-Z]{4}\d{6}[HMX]/;
                                break;
                            case 12:
                                reg = /[A-Z]{4}\d{6}[HMX][A-Z]/;
                                break;
                            case 13:
                                reg = /[A-Z]{4}\d{6}[HMX][A-Z]{2}/;
                                break;
                            case 14:
                                reg = /[A-Z]{4}\d{6}[HMX][A-Z]{2}[B-DF-HJ-NP-TV-Z]/;
                                break;
                            case 15:
                                reg = /[A-Z]{4}\d{6}[HMX][A-Z]{2}[B-DF-HJ-NP-TV-Z]{2}/;
                                break;
                            case 16:
                                reg = /[A-Z]{4}\d{6}[HMX][A-Z]{2}[B-DF-HJ-NP-TV-Z]{3}/;
                                break;
                            case 17:
                                reg = /[A-Z]{4}\d{6}[HMX][A-Z]{2}[B-DF-HJ-NP-TV-Z]{3}[A-Z0-9]/;
                                break;
                        }

                        if (curp.search(reg)) {
                            return false;
                        }
                        return true;
                    }
                }

                /**
                 * @description Función para calcular dígito para CURP (parte de validación de RENAPO)
                 * @param {string} curp 
                 */
                function calculateDigit(curp) {
                    var segRaiz = curp.substring(0, 17),
                        chrCaracter = '0123456789ABCDEFGHIJKLMNÑOPQRSTUVWXYZ',
                        intFactor = new Array(17),
                        lngSuma = 0.0,
                        lngDigito = 0.0;

                    for (var i = 0; i < 17; i++) {
                        for (var j = 0; j < 37; j++) {
                            if (segRaiz.substring(i, i + 1) == chrCaracter.substring(j, j + 1)) {
                                intFactor[i] = j;
                            }
                        }
                    }

                    for (var k = 0; k < 17; k++) {
                        lngSuma = lngSuma + ((intFactor[k]) * (18 - k));
                    }

                    lngDigito = (10 - (lngSuma % 10));

                    if (lngDigito == 10) {
                        lngDigito = 0;
                    }

                    return lngDigito;
                }

                ngModel.$parsers.unshift(function (value) {
                    if (value.length == 18) {
                        var valid = validateCurp(value);
                        if (!valid) {
                            ngModel.$setValidity('curp', false);
                            ngModel.$setDirty();
                            ngModel.$setTouched();
                        } else if (valid !== true && valid !== false) {
                            ngModel.$setValidity('curpDigit', false);
                            ngModel.$setDirty();
                            ngModel.$setTouched();
                        } else { // es válido
                            ngModel.$setValidity('curp', true);
                            ngModel.$setValidity('curpDigit', true);
                        }
                    }
                    var capitalized = value.toUpperCase();
                    ngModel.$setViewValue(capitalized);
                    ngModel.$render();

                    return valid === true ? capitalized : undefined;
                });

                ngModel.$formatters.unshift(function (value) {
                    if (value) {
                        var valid = validateCurp(value);
                        if (!valid) {
                            ngModel.$setValidity('curp', false);
                            ngModel.$setDirty();
                            ngModel.$setTouched();
                        } else if (valid !== true && valid !== false) {
                            ngModel.$setValidity('curpDigit', false);
                            ngModel.$setDirty();
                            ngModel.$setTouched();
                        } else { // es válido
                            ngModel.$setValidity('curp', true);
                            ngModel.$setValidity('curpDigit', true);
                        }
                    }
                    return value;
                });
            }
        }
    }
}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('curpConsistency', curpConsistency);

    /** @ngInject */
    function curpConsistency($timeout, $rootScope, $log, getFromObjectFilter) {
        return {
            require: 'ngModel',
            restrict: 'A',
            scope: {
                consistency: '='
            },
            link: function (scope, elem, attr, ngModel) {
                if (!ngModel) return;
                var CURP_GENERIC_EXTRANJERO = 'XEXX010101ENEXXXA0';
                var RFC_GENERIC = 'XAXX010101000';
                var DEBOUNCE_MS = 120;
                var revalidatePromise = null;
                function getFechaFromCredential(credential) {
                    return (credential || '').substr(4, 6); // YYMMDD
                }
                function getBirthYYMMDD(person) {
                    var birth = getFromObjectFilter(person, 'data.info.birth.date') || null;
                    if (!birth) return null;
                    var m = moment(birth);
                    if (!m.isValid()) return null;
                    var v = m.format('YYMMDD');
                    return v || null;
                }

                ngModel.$validators.consistency = function (modelValue, viewValue) {
                    var curp = modelValue || viewValue;
                    // Por compatibilidad con tu lógica: si está vacío o no hay persona/info suficiente => válido
                    if (!curp) return true;
                    // Curp genérica extranjero: siempre válido
                    if (curp === CURP_GENERIC_EXTRANJERO) return true;
                    var person = scope.consistency;
                    var data = person && person.data ? person.data : null;
                    if (!data) return true;
                    var birthYYMMDD = getBirthYYMMDD(person);
                    if (!birthYYMMDD) return true; // si no hay birth, no se puede validar consistencia
                    var birthFromCurp = getFechaFromCredential(curp);
                    if (!birthFromCurp) return false;
                    // RFC opcional (si existe y no es genérico, valida también)
                    var rfc = data.rfc;
                    var hasRealRfc = !!(rfc && rfc !== '' && rfc !== RFC_GENERIC);
                    var birthFromRfc = hasRealRfc ? getFechaFromCredential(rfc) : null;
                    if (birthFromCurp !== birthYYMMDD) return false;
                    if (hasRealRfc && birthFromRfc !== birthFromCurp) return false;
                    return true;
                };
                // Revalidar cuando cambie la fecha (sin deep watch)
                var unwatchBirth = scope.$watch(
                    function () {
                        return scope.consistency &&
                            scope.consistency.data &&
                            scope.consistency.data.info &&
                            scope.consistency.data.info.birth &&
                            scope.consistency.data.info.birth.date;
                    },
                    function (birthdate) {
                        if (!birthdate) return;
                        if (revalidatePromise) $timeout.cancel(revalidatePromise);
                        revalidatePromise = $timeout(function () {
                            ngModel.$validate();
                        }, DEBOUNCE_MS, false);
                    }
                );

                var offStop = $rootScope.$on('stopDetailWatchers', function () {
                    if (unwatchBirth) unwatchBirth();
                    if (offStop) offStop();
                });

                scope.$on('$destroy', function () {
                    if (revalidatePromise) $timeout.cancel(revalidatePromise);
                    if (unwatchBirth) unwatchBirth();
                    if (offStop) offStop();
                });
            }
        };
    }
}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('filterPayroll', filterPayroll)
        .directive('filterDashboardPayroll', filterDashboardPayroll)
        .directive('filterStatus', filterStatus)
        .directive('filterIncidenceStatus', filterIncidenceStatus)
        .directive('filterCc', filterCc)
        .directive('filterPayrollFilter', filterPayrollFilter)
        .directive('filterPayrollCc', filterPayrollCc)
        .directive('filterRp', filterRp)
        .directive('filterFirm', filterFirm)
        .directive('filterProfile', filterProfile)
        .directive('filterAction', filterAction)
        .directive('filterModule', filterModule)
        .directive('filterCompaniesRecord', filterCompaniesRecord)
        .directive('filterFromDate', filterFromDate)
        .directive('filterToDate', filterToDate)
        .directive('filterAutocompleteEmployee', filterAutocompleteEmployee)
        .directive('filterPayrollEmployee', filterPayrollEmployee)
        .directive('filterEmployee', filterEmployee)
        .directive('filterMovementType', filterMovementType)
        .directive('filterMovementsType', filterMovementsType)
        .directive('filterPayrollCalendar', filterPayrollCalendar)
        .directive('filterPeriod', filterPeriod)
        .directive('filterCreditStatus', filterCreditStatus)
        .directive('filterContractStatus', filterContractStatus)
        .directive('filterLoanStatus', filterLoanStatus)
        .directive('filterBy', filterBy)
        .directive('filterGroupings', filterGroupings)
        .directive('filterHasSeniorityDate', filterHasSeniorityDate);


    function filterPayrollCalendar() {
        return {
            restrict: 'A',
            // transclude: true,
            scope: true,
            // replace:true,
            templateUrl: 'app/main/acommon/directives/filters/payroll-calendar.html'
        }
    }

    function filterPeriod() {
        return {
            restrict: 'A',
            // transclude: true,
            scope: true,
            // replace:true,
            templateUrl: 'app/main/acommon/directives/filters/period.html'
        }
    }

    /** @ngInject */
    function filterPayroll() {
        return {
            restrict: 'A',
            scope: true,
            // replace:true,
            transclude: true,
            templateUrl: 'app/main/acommon/directives/filters/payroll.html'
        }
    }

    function filterProfile() {
        return {
            restrict: 'A',
            scope: true,
            // replace:true,
            transclude: true,
            templateUrl: 'app/main/acommon/directives/filters/profile.html'
        }
    }

    function filterAction() {
        return {
            restrict: 'A',
            scope: true,
            // replace:true,
            transclude: true,
            templateUrl: 'app/main/acommon/directives/filters/action.html'
        }
    }

    /** @ngInject */
    function filterDashboardPayroll() {
        return {
            restrict: 'A',
            scope: true,
            // replace:true,
            transclude: true,
            templateUrl: 'app/main/acommon/directives/filters/dashboard-payroll.html'
        }
    }

    /** @ngInject */
    function filterStatus() {
        return {
            restrict: 'A',
            scope: true,
            transclude: true,
            // replace:true,
            templateUrl: 'app/main/acommon/directives/filters/status.html'
        }
    }

    /** @ngInject */
    function filterIncidenceStatus() {
        return {
            restrict: 'A',
            scope: true,
            transclude: true,
            // replace:true,
            templateUrl: 'app/main/acommon/directives/filters/incidence-status.html'
        }
    }

    /** @ngInject */
    function filterCc() {
        return {
            restrict: 'A',
            scope: true,
            transclude: true,
            // replace:true,
            templateUrl: 'app/main/acommon/directives/filters/cc.html'
        }
    }

    /** @ngInject */
    function filterPayrollFilter() {
        return {
            restrict: 'A',
            scope: true,
            transclude: true,
            // replace:true,
            templateUrl: 'app/main/acommon/directives/filters/payroll-filter.html'
        }
    }

    /** @ngInject */
    function filterPayrollCc() {
        return {
            restrict: 'A',
            scope: true,
            transclude: true,
            // replace:true,
            templateUrl: 'app/main/acommon/directives/filters/payroll-cc.html'
        }
    }

    /** @ngInject */
    function filterRp() {
        return {
            restrict: 'A',
            scope: true,
            transclude: true,
            // replace:true,
            templateUrl: 'app/main/acommon/directives/filters/rp.html'
        }
    }

    /** @ngInject */
    function filterFirm() {
        return {
            restrict: 'A',
            scope: true,
            transclude: true,
            // replace:true,
            templateUrl: 'app/main/acommon/directives/filters/firm.html'
        }
    }

    /** @ngInject */
    function filterModule() {
        return {
            restrict: 'A',
            scope: true,
            transclude: true,
            // replace:true,
            templateUrl: 'app/main/acommon/directives/filters/module.html'
        }
    }

    /** @ngInject */
    function filterCompaniesRecord() {
        return {
            restrict: 'A',
            scope: true,
            transclude: true,
            // replace:true,
            templateUrl: 'app/main/acommon/directives/filters/companies-record.html'
        }
    }

    /** @ngInject */
    function filterFromDate() {
        return {
            restrict: 'A',
            scope: true,
            transclude: true,
            // replace:true,
            templateUrl: 'app/main/acommon/directives/filters/from-date.html'
        }
    }

    /** @ngInject */
    function filterToDate() {
        return {
            restrict: 'A',
            scope: true,
            transclude: true,
            // replace:true,
            templateUrl: 'app/main/acommon/directives/filters/to-date.html'
        }
    }

    /** @ngInject */
    function filterAutocompleteEmployee() {
        return {
            restrict: 'A',
            scope: true,
            transclude: true,
            templateUrl: 'app/main/acommon/directives/filters/autocomplete-employee.html'
        }
    }

    /** @ngInject */
    function filterPayrollEmployee() {
        return {
            restrict: 'A',
            scope: true,
            transclude: true,
            templateUrl: 'app/main/acommon/directives/filters/payroll-employee.html'
        }
    }

    /** @ngInject */
    function filterEmployee() {
        return {
            restrict: 'A',
            scope: true,
            transclude: true,
            templateUrl: 'app/main/acommon/directives/filters/employee.html'
        }
    }

    /** @ngInject */
    function filterMovementType() {
        return {
            restrict: 'A',
            scope: true,
            transclude: true,
            // replace:true,
            templateUrl: 'app/main/acommon/directives/filters/movement-type.html'
        }
    }

    function filterCreditStatus() {
        return {
            restrict: 'A',
            scope: true,
            transclude: true,
            // replace:true,
            templateUrl: 'app/main/acommon/directives/filters/credit-status.html'
        }
    }
    function filterLoanStatus() {
        return {
            restrict: 'A',
            scope: true,
            transclude: true,
            // replace:true,
            templateUrl: 'app/main/acommon/directives/filters/loan-status.html'
        }
    }
    function filterContractStatus() {
        return {
            restrict: 'A',
            scope: true,
            transclude: true,
            // replace:true,
            templateUrl: 'app/main/acommon/directives/filters/contract-status.html'
        }
    }


    function filterMovementsType() {
        return {
            restrict: 'A',
            scope: true,
            transclude: true,
            // replace:true,
            templateUrl: 'app/main/acommon/directives/filters/movements-type.html'
        }
    }

    /** @ngInject */
    function filterBy() {
        return {
            restrict: 'A',
            scope: true,
            transclude: true,
            // replace:true,
            templateUrl: 'app/main/acommon/directives/filters/by.html'
        }
    }

    /** @ngInject */
    function filterGroupings() {
        return {
            restrict: 'A',
            scope: true,
            transclude: true,
            // replace:true,
            templateUrl: 'app/main/acommon/directives/filters/groupings.html'
        }
    }

    /** @ngInject */
    function filterHasSeniorityDate() {
        return {
            restrict: 'A',
            scope: true,
            transclude: true,
            // replace:true,
            templateUrl: 'app/main/acommon/directives/filters/hasSeniorityDate.html'
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.employees')
        .controller('PaymentFormsController', PaymentFormsController);

    /** @ngInject */
    function PaymentFormsController($mdDialog, $log, errAlertS, successAlertS, employee, MongoF, ListsF, AppF, $rootScope, getFn, $timeout, $q) {
        $log.log(employee);
        var pfCtrl = this;
        pfCtrl.paymentForms = MongoF.paymentForms;
        var pfIndex = MongoF.paymentForms.findIndex(function (item) {
            return item.key === 'transfer';
        });
        var defaultPaymentForm;
        if (pfIndex > -1) {
            defaultPaymentForm = MongoF.paymentForms[pfIndex]._id;
        }
        pfCtrl.employee = employee;
        pfCtrl.processes = [];
        pfCtrl.cancel = function () {
            $mdDialog.cancel();
        };
        pfCtrl.save = function (paymentForms) {
            $rootScope.loadingProgress = true;
            var thisPaymentForms = paymentForms.map(function (item) {
                var obj = {
                    type: item.type
                };
                if (angular.isDefined(item.process)) {
                    obj.process = item.process;
                }
                return obj;
            })
            AppF.root.child('catalogs/employees/collection/' + employee.fid + '/paymentForms').set(thisPaymentForms).then(function () {
                var promises = [$q(function (resolve) {
                    $timeout(function () {
                        resolve(true)
                    }, 3000)
                })];
                return Promise.all(promises);
            }).then(function () {
                var promises = [];
                if (angular.isFunction(getFn)) {
                    promises = [getFn()];
                }
                return Promise.all(promises);
            }).then(function () {
                successAlertS('Se actualizo forma de pago con éxito');
                $mdDialog.hide();
            }).catch(errAlertS)
        };
        pfCtrl.employeePaymentForms = employee.paymentForms;
        if (!angular.isArray(pfCtrl.employeePaymentForms)) {
            pfCtrl.employeePaymentForms = [];
        }
        if (pfCtrl.employeePaymentForms.length === 0) {
            pfCtrl.employeePaymentForms.push({ type: defaultPaymentForm });
        }
        ListsF.loadList('payrolls', 'catalogs/payrolls/collection/' + employee.payroll + '/processes', undefined, 'array', 'processes-of-' + employee.payroll).then(function (data) {
            pfCtrl.processes = data.filter(function (item) {
                return item.id;
            }).map(function (item) {
                item.name = item.$id;
                return item;
            });
            pfCtrl.processes.push({ name: 'DEFAULT' })
            $log.log(data)
        }).catch(errAlertS);
    }
})();
(function () {
    'use strict';

    angular
        .module('app.clients')
        .controller('IaModelController', IaModelController);

    function IaModelController(
        $log,
        $mdDialog,
        errAlertS,
        $rootScope,
        ApiV2F,
        $sce
    ) {
        var vm = this;
        $log.log('entro por el controlador de ia')
        function init() {

        }


        vm.sendQuestion = function (data) {
            if (!data) {
                return
            }
            if (data) {
                var paramsData = {
                    question: data
                }
                $log.log(paramsData)
                vm.aiAnswer = '';
                // $rootScope.loadingProgress = true;
                vm.loadingAI = true;
                ApiV2F.post("gemini/ask/", paramsData).then(function (resp) {
                    var answer = resp.data.answer;
                    vm.aiAnswer = answer;
                    vm.trustedHtmlAnswer = $sce.trustAsHtml(answer);
                    $log.log('Respuesta de la IA:', vm.aiAnswer);
                    vm.loadingAI = false;
                    // $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                }).catch(function (error) {
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                    errAlertS(error);
                })
            } else {
                errAlertS('No se proporcionaron todos los datos necesarios')
            }
        };

        vm.cancel = function () {
            $mdDialog.hide();
        }
        init();
    }
}
)();


(function () {
    'use strict';

    angular
        .module('app.employees')
        .controller('FieldEditModalController', FieldEditModalController);

    /** @ngInject */
    function FieldEditModalController(object, columnConfig, $mdDialog, $log, getFromObjectFilter, MongoF) {
        var fieldCtrl = this;
        fieldCtrl.M = MongoF;
        fieldCtrl.field = '';
        if (columnConfig.path) {
            fieldCtrl.field = getFromObjectFilter(object, columnConfig.path, columnConfig.defaultRValue);
        }
        $log.log(columnConfig)
        fieldCtrl.columnConfig = columnConfig;
        fieldCtrl.object = object;
        fieldCtrl.cancel = function () {
            $mdDialog.cancel();
        };
        fieldCtrl.answer = function (answer) {
            $log.log(answer);
            $mdDialog.hide(answer);
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.employees')
        .controller('ManyEmployeeActionController', ManyEmployeeActionController);

    /** @ngInject */
    function ManyEmployeeActionController(scope, $mdDialog, selected, action, errAlertS, $filter, successAlertS, $rootScope, $log) {
        var minMovementDate
        scope.selected = selected;
        scope.M = $rootScope.M;
        scope.L = $rootScope.L;
        scope.F = $rootScope.F;
        scope.D = $rootScope.D;
        function getNotEmitted(item) {
            return (angular.isDefined(item.emmitedYet) && !item.emmitedYet) ? true : false;
        }

        scope.getCcs = function (payroll) {
            var thisCss = $rootScope.L.payrollCcs[payroll];
            if (!scope.F.permissionToAccessAllPayrolls) {
                thisCss = $filter('filterUserCcs')(thisCss, scope.L.userCcs[scope.F.profile.uid]);
            }
            thisCss = thisCss.filter(function (item) {
                return item.rp_id === selected[0].rp;
            });
            scope.ccs = thisCss;
        }
        scope.validateDismissDates = function () {
            var promises = [];
            $rootScope.loadingProgress = true;
            $rootScope.$evalAsync();
            for (var i = 0; i < scope.selected.length; i++) {
                var employee = scope.selected[i];
                var promesaEmployee = [];
                promesaEmployee.push($filter("validateEmployeeOperations")(employee.payroll, scope.data.dismissDate));
                promesaEmployee.push(scope.D.models.action('incidences', 'isThereIncidencesFromDate', {
                    date: scope.data.dismissDate,
                    validateOnly: 'd',
                    employeeId: employee.fid,
                    payrollId: employee.payroll
                }));
                promises.push(Promise.all(promesaEmployee))
            }
            Promise.all(promises).then(function (results) {
                $log.log(results);
                var errors = [];
                for (var i = 0; i < results.length; i++) {
                    var thisResult = results[i];
                    $log.log(thisResult)
                    var validacionesOperaciones = thisResult[0];
                    var validacionesIncidences = thisResult[1].data.message;
                    $log.log(scope.selected[i].data.name, validacionesIncidences, validacionesOperaciones);
                    if (!(validacionesOperaciones === true && validacionesIncidences === false)) {
                        var nameEmpleado = scope.selected[i].data.name;
                        errors.push("El empleado " + nameEmpleado + " " + (validacionesIncidences || 'Tiene cerrado el periodo'));
                    }
                }
                if (errors.length > 0) {
                    scope.data.dismissDate = null;
                    throw errors;
                }
                successAlertS('Estos empleados si se pueden dar de baja masivamente');
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
            }).catch(function (error) {
                errAlertS(error)
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
            });
        }
        function removeSame(valor, indiceActual, arreglo) {
            var indiceAlBuscar = arreglo.indexOf(valor);
            return indiceActual === indiceAlBuscar;
        }
        function validateUnique() {
            var modelValue = scope.selected;
            if (!angular.isArray(modelValue)) {
                return true;
            }
            var accounts = modelValue.map(function (item) { return item.data.cards[0].number; });
            accounts = accounts.filter(removeSame);
            return accounts.length === modelValue.length;
        }
        scope.validateForeignCurp = function (employee, emit) {
            var curp = employee.data.curp;
            if (angular.isString(curp)) {
                var country = curp.substr(11, 2);
                if (emit && country === 'NE') {
                    employee.hasPendingRequest = true;
                    employee.invalidCurp = 'Este empleado es nacido extranjero por lo que no se puede generar una cuenta, contactar a un ejecutivo de tesorería para mas información';
                } else {
                    employee.hasPendingRequest = false;
                    delete employee.invalidCurp;
                }
            } else {
                employee.hasPendingRequest = true;
                employee.invalidCurp = 'Este empleado no tiene curp o es invalida';
            }
        }
        function dismissReentry() {
            for (var i = 0; i < selected.length; i++) {
                if (angular.isDefined(selected[i].movement.date)) {
                    if (angular.isUndefined(minMovementDate)) {
                        minMovementDate = selected[i].movement.date;
                    }
                    if (selected[i].movement.date > minMovementDate) {
                        minMovementDate = selected[i].movement.date;
                    }
                }
            }
            var minDate;
            if (action === 'dismiss') {
                minDate = $rootScope.F.holydaysInMexico.getDateOfXLabourDaysSinceNow(scope.dumenType ? 30 : 5, $rootScope.F.serverTimeStamp).date;
                scope.maxMovementDate = $rootScope.F.holydaysInMexico.getDateOfXLabourDaysFromNow(2, $rootScope.F.serverTimeStamp).date;
            } else {
                minDate = $rootScope.F.holydaysInMexico.getDateOfXLabourDaysSinceNow(25, $rootScope.F.serverTimeStamp).date;
                scope.maxMovementDate = $rootScope.F.holydaysInMexico.getDateOfXLabourDaysFromNow(5, $rootScope.F.serverTimeStamp).date;
            }
            if (minDate.valueOf() > minMovementDate) {
                scope.minMovementDate = minDate;
            } else {
                var thisDate = moment(minMovementDate)
                if (action === "reentry") {
                    thisDate.add(1, 'day');
                }
                thisDate = thisDate.utc();
                scope.minMovementDate = new Date(thisDate.year(), thisDate.month(), thisDate.date());
            }
            if (action === 'reentry') {
                var payroll = selected[0].payroll;
                scope.L.loadList('ccs', 'lists/ccs/payroll', payroll, 'array', 'payrollCcs').then(function (ccs) {
                    angular.forEach(ccs, function (cc) {
                        scope.L.loadList('rps', 'lists/rps/all', cc['rp_id'], 'object', 'rpCcs');
                    });
                }).catch(errAlertS);
            }
        }
        function changePayroll() {
            var listenersModal = {};
            listenersModal.payroll = scope.$watch('data.payroll', function (payroll) {
                if (payroll) {
                    scope.L.loadList('positions', 'lists/positions/payroll', payroll, 'array', 'payrollPositions');
                    scope.L.loadList('ccs', 'lists/ccs/payroll', payroll, 'array', 'payrollCcs').then(function (ccs) {
                        var promises = [];
                        angular.forEach(ccs, function (cc) {
                            promises.push(scope.L.loadList('rps', 'lists/rps/all', cc['rp_id'], 'object', 'rpCcs'));
                        });
                        return Promise.all(promises);
                    }).then(function () {
                        scope.getCcs(payroll);
                    }).catch(function (error) {
                        errAlertS(error)
                    });
                }
            });
            listenersModal.minDate = scope.$watch('data.dismissDate', function (dismissDate) {
                if (dismissDate) {
                    var thisDate = moment(dismissDate + $rootScope.F.oneDay);
                    scope.minReentryDate = thisDate.toDate();
                    scope.data.reentryDate = thisDate.valueOf();
                }
            });
            listenersModal.maxDate = scope.$watch('data.reentryDate', function (reentryDate) {
                if (reentryDate) {
                    var thisDate = moment(reentryDate - $rootScope.F.oneDay);
                    scope.maxDismissDate = thisDate.toDate();
                }
            });
            listenersModal.final = scope.$on('$destroy', function () {
                $filter('loopEach')(listenersModal, function (data, l) {
                    $log.debug('finishing listener', l);
                    listenersModal[l]();
                });
            });
        }
        function registerEmitAccount() {
            scope.banks = {};
            var promises = [];
            var payrollIds = [];
            for (var s = 0; s < scope.selected.length; s++) {
                var thisEmployee = scope.selected[s];
                if (payrollIds.indexOf(thisEmployee.payroll) === -1) {
                    payrollIds.push(thisEmployee.payroll);
                    promises.push(scope.F.root.child('catalogs/payrolls/collection/' + thisEmployee.payroll + '/processes/').once('value'));
                }
                if (!angular.isArray(thisEmployee.data.cards)) {
                    thisEmployee.data.cards = [];
                }
                scope.validateForeignCurp(thisEmployee, thisEmployee.data.cards.length > 0 ? thisEmployee.data.cards[0].emit : false);
                var index = thisEmployee.data.cards.findIndex(getNotEmitted);
                var thisItem = { emmitedYet: false };
                if (index > -1) {
                    thisItem = thisEmployee.data.cards[index];
                    thisEmployee.data.cards.splice(index, 1);
                    //Función for find banks with requestNumber
                    if (angular.isDefined(thisItem.bank)) {
                        var banks = scope.M.banks;
                        var filterBanks = banks.find(function (bank) {
                            return bank._id === thisItem.bank;
                        });
                        if (angular.isDefined(filterBanks.requestNumber) && !filterBanks.requestNumber) {
                            thisEmployee.hasPendingRequest = true;
                        } else if (angular.isDefined(thisItem.number)) {
                            thisEmployee.hasPendingRequest = true;
                        }
                    }
                }
                thisItem.created = $rootScope.D.getTimeObject();
                thisEmployee.data.cards.unshift(thisItem);
            }
            Promise.all(promises).then(function (resp) {
                for (var r = 0; r < resp.length; r++) {
                    var payrollId = payrollIds[r];
                    if (resp[r].exists()) {
                        resp[r].forEach(function (childSnap) {
                            var processName = childSnap.key;
                            var process = childSnap.val();
                            if (['complements', 'processes'].indexOf(processName) === -1) {
                                if (angular.isUndefined(scope.banks[payrollId])) {
                                    scope.banks[payrollId] = {};
                                }
                                if (angular.isUndefined(scope.banks[payrollId]['processes'])) {
                                    scope.banks[payrollId]['processes'] = [];
                                }
                                if (angular.isUndefined(scope.banks[payrollId][process.id])) {
                                    scope.banks[payrollId][process.id] = [];
                                }
                                scope.banks[payrollId]['processes'].push({ id: process.id, name: processName });
                                if (angular.isArray(process.bankAccounts)) {
                                    for (var b = 0; b < process.bankAccounts.length; b++) {
                                        var bankAccountId = process.bankAccounts[b];
                                        var bankAccount = scope.M.bankAccounts.find(function (item) { return item._id === bankAccountId; });
                                        if (angular.isDefined(bankAccount)) {
                                            var bank = scope.M.banks.find(function (item) { return item._id === bankAccount.bank; });
                                            if (angular.isDefined(bank)) {
                                                var bankObject = angular.fromJson(angular.toJson(bank));
                                                bankObject.couldEmmit = bankAccount.couldEmmit;
                                                scope.banks[payrollId][process.id].push(bankObject);
                                            }
                                        }
                                    }
                                }
                            }
                        });
                    }
                }
            }).catch(errAlertS);
        }

        scope.AskInGeneration = function (id) {
            var bank = scope.M.banks.find(function (item) { return item._id === id });
            var fields = bank.fields;
            var AskInGenerations = [];
            for (var i = 0; i < fields.length; i++) {
                var field = fields[i];
                if (field.AskInGeneration) {
                    var fieldIObj = {
                        name: field.label,
                        id: field.id,
                        type: field.type,
                        max: field.max,
                        min: field.min
                    }
                    scope.labelGenerations = field.label;
                    scope.maxGenerations = field.max;
                    scope.minGenerations = field.min;
                    AskInGenerations.push(fieldIObj);
                }
            }
            scope.AskInGenerations = AskInGenerations;
        }






        scope.dumenType = $filter('recordsHaveValue')(selected, 'rp-rp', '00000000000') ? true : false;

        var actions = {
            dismiss: dismissReentry,
            reentry: dismissReentry,
            changePayroll: changePayroll,
            registerEmitAccount: registerEmitAccount
        }
        if (actions[action]) {
            actions[action](scope.dumenType);
        }
        scope.confirm = function () {
            if (action === 'registerEmitAccount') {
                var flag = validateUnique();
                if (flag) {
                    $mdDialog.hide(scope.selected);
                } else {
                    errAlertS('Existen cuentas repetidas');
                }
            } else {
                $mdDialog.hide(scope.data);
            }
        };
        scope.close = function () {
            $mdDialog.cancel();
        };

    }
})();
(function () {
    'use strict';

    angular
        .module('app.employees')
        .controller('EmployeesMovementsController', EmployeesMovementsController);

    /** @ngInject */
    function EmployeesMovementsController(
        $scope,
        errAlertS,
        $mdDialog,
        $rootScope,
        $q,
        $log,
        successAlertS,
        $filter,
        $http,
        confirmConfig,
        $firebaseObject,
        CatalogsF,
        ListsF,
        $timeout,
        $document,
        DataF,
        $firebaseArray,
        loopEachFilter,
        checkDisabilitiesEmployeeFilter,
        AppF
    ) {
        $scope.importEmployeesModal = function (ev) {
            $log.log('Empleados por importar a la b');
            $mdDialog.show({
                controllerAs: 'employeeDialog',
                controller: function (scope, DataF, AppF, ListsF, $rootScope) {
                    var vm = this;
                    vm.payrolls = AppF.permissionToAccessAllPayrolls ? ListsF.allPayrolls : ListsF.payrolls;
                    scope.loading = false;
                    vm.filesArray = [];

                    scope.close = function () {
                        $mdDialog.cancel();
                    };


                    function sanitizeForRtdb(value) {
                        if (value === null) return null;
                        if (typeof value === 'undefined') return null;
                        if (typeof value === 'function') return null;
                        if (typeof value === 'number' && !isFinite(value)) return null;

                        if (Array.isArray(value)) {
                            return value.map(sanitizeForRtdb).filter(v => v !== null);
                        }

                        if (value && typeof value === 'object') {
                            var out = {};
                            Object.keys(value).forEach(function (k) {
                                var v = sanitizeForRtdb(value[k]);
                                if (v === null) return;
                                out[k] = v;
                            });
                            return JSON.parse(JSON.stringify(out));
                        }

                        return value;
                    }

                    function buildNormalizerFromItems(items) {
                        items = items || [];
                        var defaults = {};
                        items.forEach(function (it) {
                            if (it && it.field && typeof it.defaultValue !== 'undefined') {
                                defaults[it.field] = it.defaultValue;
                            }
                        });

                        return function (obj) {
                            obj = (obj && typeof obj === 'object') ? obj : {};
                            Object.keys(defaults).forEach(function (k) {
                                if (typeof obj[k] === 'undefined') obj[k] = defaults[k];
                            });
                            return obj;
                        };
                    }

                    function currentToArray(current) {
                        if (Array.isArray(current)) return current.slice();
                        if (current && typeof current === 'object') {
                            return Object.keys(current).sort().map(k => current[k]);
                        }
                        return [];
                    }

                    function applyArrayStrategy(arr, incoming, strategy) {
                        strategy = strategy || {};
                        var mode = strategy.mode || 'append'; // append | dedupeIgnore | upsertReplace | upsertMerge
                        var keyField = strategy.keyField;
                        var keyFn = strategy.keyFn;
                        var normalize = strategy.normalize;

                        var getKey = function (it) {
                            if (!it) return '';
                            if (typeof keyFn === 'function') return String(keyFn(it) || '');
                            if (keyField) return String(it[keyField] || '');
                            return '';
                        };

                        var normIncoming = (incoming || [])
                            .map(it => normalize ? normalize(it) : it)
                            .map(sanitizeForRtdb)
                            .filter(Boolean);

                        if (mode === 'append' || (!keyField && !keyFn)) {
                            arr.push.apply(arr, normIncoming);
                            return arr;
                        }

                        var indexByKey = {};
                        for (var i = 0; i < arr.length; i++) {
                            var k = getKey(arr[i]);
                            if (k) indexByKey[k] = i;
                        }

                        normIncoming.forEach(function (it) {
                            var k = getKey(it);
                            if (!k) return;

                            var idx = indexByKey[k];

                            if (mode === 'dedupeIgnore') {
                                if (idx === undefined) {
                                    arr.push(it);
                                    indexByKey[k] = arr.length - 1;
                                }
                                return;
                            }

                            if (mode === 'upsertReplace') {
                                if (idx === undefined) {
                                    arr.push(it);
                                    indexByKey[k] = arr.length - 1;
                                } else {
                                    arr[idx] = it;
                                }
                                return;
                            }

                            // upsertMerge (default)
                            if (idx === undefined) {
                                arr.push(it);
                                indexByKey[k] = arr.length - 1;
                            } else {
                                arr[idx] = Object.assign({}, arr[idx], it);
                            }
                        });

                        return arr;
                    }

                    function arrayObjectTransaction(baseRef, fid, targetCfg, itemsToApply) {
                        if (!Array.isArray(itemsToApply) || itemsToApply.length === 0) return Promise.resolve(true);

                        var bdpath = targetCfg.bdpath; // ej: "data/info/phones"
                        var strategy = targetCfg.arrayStrategy || { mode: 'append' };

                        // defaults desde items (active:true, etc.)
                        if (!strategy.normalize && Array.isArray(targetCfg.items)) {
                            var normalizeDefaults = buildNormalizerFromItems(targetCfg.items);
                            strategy = Object.assign({}, strategy, {
                                normalize: function (it) { return normalizeDefaults(it); }
                            });
                        }

                        var ref = baseRef.child(fid + '/' + bdpath);

                        return ref.transaction(function (current) {
                            var arr = currentToArray(current);
                            return applyArrayStrategy(arr, itemsToApply, strategy);
                        });
                    }



                    function updateEmployees(records, headers) {
                        return new Promise(function (resolve, reject) {
                            var updates = {};
                            var arrayTasks = [];
                            var indexes = [];
                            var opCount = 0;
                            var baseRef = $scope.F.root.child('catalogs/employees/collection');

                            for (var r = 0; r < records.length && opCount < 200; r++) {
                                if (records[r].valid && !records[r].applied) {
                                    indexes.push(r);
                                    var fid = records[r].objToUpdate.fid;

                                    for (var h = 0; h < headers.length && opCount < 200; h++) {
                                        var head = headers[h];
                                        if (head.noImport) continue;
                                        if (!head.target) continue;

                                        var value = records[r][head.name + '_formatted'];

                                        if (head.target.type === 'arrayObject') {
                                            // DEBUG (como lo tenías)
                                            console.log('ARRAYOBJ RAW →', { field: head.name, fid, bdpath: head.target.bdpath, value });

                                            if (Array.isArray(value) && value.length > 0) {
                                                arrayTasks.push(arrayObjectTransaction(baseRef, fid, head.target, value));
                                                opCount++;
                                            }
                                        } else {
                                            updates[fid + '/' + head.target.bdpath] = value;
                                            opCount++;
                                        }
                                    }
                                } else {
                                    records[r].applied = true;
                                }
                            }

                            if (Object.keys(updates).length === 0 && arrayTasks.length === 0) {
                                return resolve(true);
                            }

                            var p = Promise.resolve();

                            if (Object.keys(updates).length > 0) {
                                p = p.then(function () { return baseRef.update(updates); });
                            }

                            if (arrayTasks.length > 0) {
                                p = p.then(function () { return Promise.all(arrayTasks); });
                            }

                            p.then(function () {
                                indexes.forEach(function (i) { records[i].applied = true; });
                                resolve(updateEmployees(records, headers));
                            }).catch(function (err) {
                                console.error('RTDB error:', err);
                                $log.error('RTDB error:', err);
                                reject(err);
                            });
                        });
                    }

                    vm.updateEmployees = function () {
                        scope.loading = true;
                        scope.$evalAsync(function () {
                            $timeout(function () {
                                updateEmployees(vm.data, vm.headers).then(function () {
                                    scope.$evalAsync(function () {
                                        $timeout(function () {
                                            $mdDialog.hide();
                                            successAlertS('Se actualizaron los empleados');
                                        }, 0, false);
                                    });
                                }).catch(function (error) {
                                    errAlertS(error);
                                    scope.loading = false;
                                });
                            }, 0, false);
                        });
                    };
                    vm.setValueFormatted = function (header) {
                        try {
                            var promise = $filter('transformField')(header.target.type, header.original, header.target)
                            promise.then(function (resp) {
                                header.sample = resp;
                                $scope.$evalAsync();
                            }).catch(errAlertS)

                        } catch (error) {
                            errAlertS(error);
                        }
                    };
                    function uploadCsv() {
                        var files = vm.filesArray;
                        var payroll = vm.payroll;
                        if (angular.isArray(files) && files.length > 0) {
                            scope.loading = true;
                            var formData = new FormData();
                            formData.append('file', files[0].lfFile);
                            var promises = [DataF.files.csvToJson(formData), $firebaseArray($scope.F.root.child('settings/imports/employees')).$loaded()];
                            Promise.all(promises).then(function (resp) {
                                var data = resp[0].data;
                                vm.posibleFields = resp[1];
                                vm.headers = [];
                                console.log()
                                for (var d = 0; d < data.length; d++) {
                                    var row = data[d];
                                    loopEachFilter(row, function (value, field) {
                                        if (d === 0) {
                                            vm.headers.push({ name: field, sample: value, original: value });
                                        }
                                    });
                                    row.payroll = payroll;
                                }
                                console.log('data', data)
                                // moment(resp.data[i].data.date).startOf('day').valueOf()
                                vm.data = data;
                                scope.loading = false;
                                scope.$evalAsync(function () {
                                    $timeout(function () {
                                    }, 0, false);
                                });
                            }).catch(function (error) {
                                errAlertS(error);
                                scope.loading = false;
                            });
                        } else {
                            $log.log('Nothing to upload');
                        }
                    }
                    var currentStep = 1;
                    var stepperChange = $rootScope.$on('stepCalled', function (event, step) {
                        if (step === 2 && currentStep === 1) {
                            uploadCsv();
                        } else if (step === 3 && currentStep === 2) {
                            var idsFields = vm.headers.filter(function (item) {
                                return item.byThis;
                            });
                            var query = '';
                            idsFields.map(function (item) {
                                query += item.target.path;
                            });
                            scope.$evalAsync(function () {
                                scope.loading = true;
                                $timeout(function () {
                                    $filter('processImportData')('employees', vm.data, idsFields, { payroll: vm.payroll }, vm.headers, query).then(function () {
                                        $log.log('finished processImportData');
                                        scope.loading = false;
                                        scope.$evalAsync(function () {
                                            $timeout(function () {
                                            }, 0, false);
                                        });
                                    }).catch(function (error) {
                                        errAlertS(error);
                                        scope.loading = false;
                                        scope.$evalAsync(function () {
                                            $timeout(function () {
                                            }, 0, false);
                                        });
                                    });
                                }, 0, false);
                            });
                        }
                        currentStep = step;
                    });
                    var onDestroy = $rootScope.$on('$destroy', function () {
                        stepperChange();
                        onDestroy();
                    });
                },
                templateUrl: 'app/main/employees/dialogs/import-employees.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: false
            }).then(function (answer) {
                $log.debug(answer, 'importEmployeesModal answer');
            }, function () {
                $log.debug('importEmployeesModal cancelled');
            });
        };

        $scope.returnToSending = function (event, status) {
            var movements = $scope.selected;
            var count = 0;
            var confirm = $mdDialog.confirm().
                title('Mover al status: Enviando')
                .textContent('a ' + movements.length + ' empleados')
                .ariaLabel('Está Seguro(a)?')
                .targetEvent(event)
                .ok('OK')
                .cancel('Cancelar');
            $mdDialog.show(confirm).then(function () {
                $rootScope.loadingProgress = true;
                var promises = [];
                for (var e = 0; e < movements.length; e++) {
                    var employee = movements[e].employee
                    promises.push($scope.F.root.child('catalogs/employees/collection/' + employee + '/movement/uid').once('value'))
                }
                return Promise.all(promises).then(function (resp) {
                    var updates = {};
                    for (var e = 0; e < movements.length; e++) {
                        var movement = movements[e];
                        var snap = resp[e];
                        if (snap.exists() && snap.val() === movement.$id) {
                            updates['catalogs/employees/collection/' + movement.employee + '/status'] = status;
                            updates['catalogs/employees/collection/' + movement.employee + '/movements/' + movement.$id + '/s'] = status;
                            updates['catalogs/movements/collection/' + movement.$id + '/status'] = status;
                            updates['catalogs/employees/collection/' + movement.employee + '/updated'] = $scope.D.getTimeObject();
                            updates['catalogs/movements/collection/' + movement.$id + '/updated'] = $scope.D.getTimeObject();
                            count++;
                        }
                    }
                    $log.log(updates);
                    return $scope.F.root.update(updates);
                }).then(function () {
                    successAlertS(count + ' Movimiento(s) realizado(s)');
                }).catch(function (error) {
                    errAlertS(error)
                }).then(function () {
                    $scope.selected = [];
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync(function () {
                        $log.debug('moveEmployeesAndMovements finished');
                    });
                    $timeout(function () {
                        $scope.selected = []
                    }, 0, false)
                });
            }, function () {
                $log.debug('movement(s) change cancelled');
                return false;
            });

        }
        /** TODO: documentación
         * @description
         * @param {Event} event 
         * @param {Int} status 
         * @returns
         */
        function moveEmployeesAndMovements(event, status, employees, predefinedValue) {
            var promise = $q.defer();
            var statusName = '';
            var sstatus;
            var confirmStatuss = [1, 2];
            var noLote = false;
            var archiveDate = false;
            var confirm;
            if (confirmStatuss.indexOf(status) !== -1) {
                confirm = $mdDialog.prompt()
                    .textContent('a ' + employees.length + ' empleados')
                    .ariaLabel('Está Seguro(a)?')
                    .targetEvent(event)
                    .ok('OK')
                    .cancel('Cancelar');
            } else {
                confirm = {
                    controller: 'DialogCtrl',
                    parent: angular.element($document.body),
                    targetEvent: event,
                    scope: $scope.$new(),
                    clickOutsideToClose: true,
                    locals: {
                        predefinedValue: predefinedValue
                    }
                };
            }

            switch (status) {
                case 1: // regreso a revisión [reviewed] -> simplemente regresar status
                    statusName = 'Revisión';
                    confirm.title('Mover al status: ' + statusName);
                    break;
                case 2: // regreso a alta, baja o mds [sent] -> simplemente regresar status
                    statusName = 'Revisado';
                    confirm.title('Mover al status: ' + statusName);
                    break;
                case 3: // idse [received] -> pedir numero de lote
                    statusName = 'Recibido';
                    confirm.templateUrl = 'app/main/employees/dialogs/receive-movement.html';
                    break;
                case 4: // archivado [archived] -> pedir fecha
                    statusName = 'Archivado';
                    confirm.templateUrl = 'app/main/employees/dialogs/archive-movement.html';
                    break;
                case 5: // de baja [archived] -> no hacer nada, puesto que la baja debe de hacerse en el employee.ctrl
                    return false;
            }

            $mdDialog.show(confirm).then(function (answer) {
                $log.debug(answer, status, 'answer');
                var mId;
                var type;
                if (answer) {
                    if (status === 3) { noLote = answer; }
                    if (status === 4) { archiveDate = answer; }
                    $rootScope.loadingProgress = true;
                    var updates = {};
                    for (var e = 0; e < employees.length; e++) {
                        var employee = employees[e];
                        var isNotFiscal = employee['rp-rp'] === '00000000000' || employee.movement.onlySd ? true : false;
                        if (employee.$id) {
                            mId = employee.movement.uid;
                            type = false;
                            switch ($scope.F.active.menuName) {
                                case 'enroles':
                                    type = [6, 8];
                                    break;
                                case 'dismissesRecords':
                                    type = 2;
                                    break;
                                case 'mdsRecords':
                                    type = 7;
                                    break;
                                case 'variables':
                                    type = 7;
                                    break;
                                case 'idseRecords':
                                    type = employee.movements[mId].t;
                                    break;
                            }

                            if (mId && type) {
                                // el contador pidió que se resetee la fecha desde solicitud
                                // if(employee.movement.type == 8 && status == 2){
                                //     employee.data.dismissDate = null; // cada reingreso debe de resetear la ultima fecha de baja
                                //     employee.data.mdsDate = null; // cada reingreso debe de resetear la ultima fecha de mds
                                // }

                                // aquí el contador nos pidió que desde status 3 se reconozca como dado de baja al empleado, pero solo será así en la Sabana
                                if (isNotFiscal) {
                                    status = 4;
                                }
                                if (employee.movement.type === 2 && status === 4) {
                                    sstatus = 5;
                                } else {
                                    sstatus = angular.fromJson(angular.toJson(status));
                                }
                                employee.movements[mId].s = sstatus;
                                employee.status = sstatus;
                                employee.updated = $scope.D.getTimeObject();

                                if (type === [6, 8] && (status === 3 || isNotFiscal)) {
                                    employee.enroleDate = angular.fromJson(angular.toJson(employee.movement.date));
                                }

                                if (noLote) { employee.movement.batch = noLote; }
                                else if (isNotFiscal) { employee.movement.batch = '000000000'; }
                                if (archiveDate) { employee.movement.archiveDate = archiveDate; }
                                else if (isNotFiscal) { employee.movement.archiveDate = (moment().valueOf()); }
                                // reparar del importador cuando viene el segundo teléfono y no el primero
                                var phones = $filter('pathInObj')(employee, 'data.info.phones');
                                if (angular.isObject(phones) && !phones[0] && angular.isDefined(phones[1])) {
                                    employee.data.info.phones[0] = angular.fromJson(angular.toJson(employee.data.info.phones[1]));
                                    delete employee.data.info.phones[1];
                                }
                                // salvar empleado y el movimiento
                                var employeeObj = $filter('clearObject')(employee);
                                if (sstatus === 3 && employee.movement.type === 7) {
                                    // cambiar sd y sbc si es un mds
                                    employeeObj.data.salary.sd = employee.movement.sd;
                                    employeeObj.data.salary.sbc = employee.movement.sbc;

                                }

                                updates['catalogs/employees/collection/' + employee.$id] = employeeObj;
                                if (sstatus === 3 || isNotFiscal) { // received para 3
                                    var received = $scope.D.getTimeObject();
                                    delete received.logged;
                                    received.batch = noLote ? noLote : '000000000';
                                    updates['catalogs/movements/collection/' + mId + '/received'] = received;
                                }
                                if (status === 4 || isNotFiscal) { // archived para 4
                                    var archived = $scope.D.getTimeObject();
                                    delete archived.logged;
                                    archived.date = archiveDate ? archiveDate : (moment().valueOf());
                                    updates['catalogs/movements/collection/' + mId + '/archived'] = archived;
                                }

                                updates['catalogs/movements/collection/' + mId + '/status'] = (sstatus === 5) ? 4 : sstatus;
                                updates['catalogs/movements/collection/' + mId + '/updated'] = $scope.D.getTimeObject();
                            }
                        }
                    }
                    $log.debug(updates, sstatus, type, mId, employees, 'request about to be made');
                    $scope.F.root.update(updates, function (error) {
                        if (error) {
                            errAlertS(error);
                            $rootScope.loadingProgress = false;
                            $rootScope.$evalAsync();
                        } else {
                            successAlertS('Movimiento(s) realizado(s)');
                            for (var e = 0; e <= employees.length; e++) {
                                if (e === employees.length - 1) { promise.resolve(true); }
                            }
                        }
                    }).then(function () {
                        $scope.selected = [];
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync(function () {
                            $log.debug('moveEmployeesAndMovements finished');
                        });
                        $mdDialog.hide();
                    });
                } else {
                    errAlertS('Necesita introducir los datos requeridos');
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                    promise.reject(false);
                    return false;
                }
            }, function () {
                promise.resolve(true);
                $log.debug('movement(s) change cancelled');
                return false;
            });
            return promise.promise;
        }

        function moveMovementsAndEmployeeIfNeeded(event, status, movements) {
            var promise = $q.defer();
            var sstatus;
            var archiveDate = false;
            var confirm = {
                controller: 'DialogCtrl',
                parent: angular.element(document.body),
                targetEvent: event,
                scope: $scope.$new(),
                locals: {
                    predefinedValue: undefined
                },
                clickOutsideToClose: true
            };
            switch (status) {
                case 4: // archivado [archived] -> pedir fecha
                    confirm.templateUrl = 'app/main/employees/dialogs/archive-movement.html';
                    break;
                default: // por el momento solo el movimiento en status 4 puede hacerse directamente
                    return false;
            }
            $mdDialog.show(confirm).then(function (answer) {
                $log.debug(answer, status, 'answer');
                if (answer) {
                    var employeesRequest = [];
                    for (var e in movements) {
                        if (movements[e].employee) {
                            employeesRequest.push(ListsF.loadList('employees', 'catalogs/employees/collection', movements[e].employee, 'object', 'employeesData'));
                        }
                    }
                    $rootScope.loadingProgress = true;
                    $q.all(employeesRequest).then(function (employeesResponse) {
                        if (status === 4) { archiveDate = answer; }
                        var updates = {};
                        for (var e = 0; e < movements.length; e++) {
                            var movement = movements[e];
                            var employee = employeesResponse[e];
                            var mId = movement.$id;
                            var type = movement.data.type;
                            var employeeRefence = 'catalogs/employees/collection/' + employee.$id;
                            if (mId && type) {
                                if (movement.data.type === 2 && status === 4) {
                                    sstatus = 5;
                                } else {
                                    sstatus = angular.fromJson(angular.toJson(status));
                                }
                                updates[employeeRefence + '/movements/' + mId + '/s'] = sstatus;
                                //si el movimiento que se esta efectuando el cambio corresponde al movimiento actual del empleado se modifican los valores del empleado también
                                if (employee.movement.uid === mId) {
                                    updates[employeeRefence + '/status'] = sstatus;
                                    updates[employeeRefence + '/updated'] = $scope.D.getTimeObject();
                                    if (archiveDate) {
                                        updates[employeeRefence + '/movement/archiveDate'] = archiveDate;
                                    }
                                }
                                if (status === 4) { // archived para 4
                                    var archived = $scope.D.getTimeObject();
                                    delete archived.logged;
                                    archived.date = archiveDate;
                                    updates['catalogs/movements/collection/' + mId + '/archived'] = archived;
                                }
                                updates['catalogs/movements/collection/' + mId + '/status'] = (sstatus === 5) ? 4 : sstatus;
                                updates['catalogs/movements/collection/' + mId + '/updated'] = $scope.D.getTimeObject();
                            }
                        }
                        $log.debug(updates, movements, 'request about to be made');
                        $scope.F.root.update(updates, function (error) {
                            if (error) {
                                errAlertS(error);
                                $rootScope.loadingProgress = false;
                                $rootScope.$evalAsync();
                            } else {
                                successAlertS('Movimiento(s) realizado(s)');
                                for (var e = 0; e <= movement.length; e++) {
                                    if (e === movements.length - 1) { promise.resolve(true); }
                                }
                            }
                        }).then(function () {
                            $scope.selected = [];
                            $rootScope.loadingProgress = false;
                            $rootScope.$evalAsync(function () {
                                $log.debug('moveEmployeesAndMovements finished');
                            });
                            $mdDialog.hide();
                        });
                    }).catch(function (error) {
                        $log.error(error);
                        errAlertS('Error consultando los empleados');
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync();
                        promise.reject(false);
                        return false;
                    });
                } else {
                    errAlertS('Necesita introducir los datos requeridos');
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                    promise.reject(false);
                    return false;
                }
            }, function () {
                promise.resolve(true);
                $log.debug('movement(s) change cancelled');
                return false;
            });
            return promise.promise;
        }

        /** TODO: documentación
         * @description
         * @param {Employee[]} employees 
         * @returns
         */
        function cancelMovementsAndSaveEmployees(employees) {
            $rootScope.loadingProgress = true;
            var updates = {};
            var lastMovementId = [];
            var lastMovement = [];
            for (var e = 0; e < employees.length; e++) {
                var employee = employees[e];
                var mid = angular.fromJson(angular.toJson(employee.movement.uid));
                lastMovementId[e] = $filter('getLastMovementId')(employee.movements, mid);
                lastMovement[e] = $firebaseObject($scope.F.root.child('catalogs/movements/collection').child(lastMovementId[e]));
                lastMovement[e].$loaded().then(function (lm) {
                    lastMovement[e] = lm;
                    var movEm = angular.fromJson(angular.toJson(lm.data));
                    movEm.uid = movEm.$id;
                    updates['catalogs/movements/collection/' + mid + '/cancelled'] = $scope.D.getTimeObject();
                    updates['catalogs/movements/collection/' + mid + '/status'] = 0;
                    updates['catalogs/employees/collection/' + employee.$id + '/movements/' + mid + '/s'] = 0;
                    updates['catalogs/employees/collection/' + employee.$id + '/movement'] = movEm;
                    updates['catalogs/employees/collection/' + employee.$id + '/status'] = lm.status;
                    updates['catalogs/employees/collection/' + employee.$id + '/updated'] = $scope.D.getTimeObject();
                    $scope.F.root.update(updates, function (error) {
                        if (!error) {
                            if ((e + 1) === employees.length) {
                                successAlertS('Movimientos cancelados');
                                $rootScope.loadingProgress = false;
                                $rootScope.$evalAsync(function () {
                                    $log.debug('cancelMovementsAndSaveEmployees finished');
                                });
                            }
                        } else {
                            errAlertS(error);
                            $rootScope.loadingProgress = false;
                            $rootScope.$evalAsync();
                        }
                    });
                }).catch(function (err) {
                    errAlertS(err);
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                    return false;
                });
            }
        }

        /** Verifica si los empleados tienen movimientos activos
         * @description
         * @param {Employee[]} employees 
         * @returns {[Movement.id...] | []} Arreglo de id de los movimientos activos
         */
        function employeeHasActiveMovements(employees) {
            var activeMovements = [];
            for (var e in employees) {
                if (employees[e].data.nss) {
                    if (employees[e].hasOwnProperty('movements')) {
                        for (var m in employees[e].movements) {
                            if (employees[e].movements[m].s > 2) {
                                activeMovements.push(m);
                            }
                        }
                    }
                }
            }
            return activeMovements;
        }

        /** Pregunta a FB si el empleado está en algúna dispersión
         * @description
         * @param {string} eid 
         * @returns {Dispersion | null}
         */
        function queryForEmployeeInDispersions(eid) {
            return $q(function (resolve, reject) {
                var params = {
                    page: 1,
                    size: 1,
                    employeeId: eid
                };
                DataF.api.get('p/calculations', angular.fromJson(angular.toJson(params))).then(function (data) {
                    var calculations = $filter('getFromObject')(data, 'data.data', []);
                    if (calculations.length > 0) {
                        resolve(calculations);
                    } else {
                        resolve(null);
                    }
                }, function (err) {
                    reject(err);
                });
            });
        }

        /** TODO: documentación
         * @description
         * @param {*} employees 
         * @returns
         */
        function checkActiveOperations(employees) {
            var promise = $q.defer();
            // promise.resolve(false); // no tiene operaciones activas
            var queries = [];
            for (var e = 0; e < employees.length; e++) {
                var employee = employees[e];
                if (employee.hasOwnProperty('$id')) {
                    var eid = employee.$id;
                    queries.push(queryForEmployeeInDispersions(eid));
                }
            }
            $q.all(queries).then(function (all) {
                var some = 0;
                for (var a in all) {
                    if (all[a] !== null) {
                        promise.resolve(true);
                        some = true;
                    }
                }
                if (!some) { promise.resolve(false); }
            }).catch(function (err) {
                $log.error(err);
                promise.reject(err);
            });

            return promise.promise;
        }

        /** Valida que los movimientos tipo baja no tengan más de 5 días hábiles */
        function validDismisses(employees) {
            var msg = '<ul>';
            var valid = true;
            for (var e in employees) {
                if (employees[e].movement.type === 2) { // es baja
                    // día máximo en que se puede dar de baja
                    var rp = $filter('getSomethingOfArrayFB')(employees[e].rp, ListsF.rps, 'rp', 'N/A');
                    var maxDissmissDate;
                    if (rp === '00000000000') {
                        maxDissmissDate = 0;
                    } else {

                        // AppF.holydaysInMexico.getDateOfXLabourDaysSinceNow(5, AppF.serverTimeStamp, undefined, true)
                        maxDissmissDate = $scope.F.holydaysInMexico.getDateOfXLabourDaysSinceNow(5, $scope.F.serverTimeStamp, undefined, true).date.valueOf();
                    }
                    var mDate = moment(employees[e].movement.date).startOf('day').valueOf();
                    if (mDate < maxDissmissDate) {
                        valid = false;
                        msg += '<li>' + moment(mDate).format('DD/MM/YYYY') + ' fue hace más de 5 días hábiles, favor de cambiar la fecha de baja para ' + employees[e].data.name + '</li>';
                    }
                }
            }
            msg += '</ul>';
            return (!valid) ? msg : true;
        }

        /**@type API
         * @description cancela último movimiento del empleado con un *prompt de confirmación
         * @param {Event} event 
         * 
         */
        function cancelLastMovement(event) {
            $log.debug('cancelLastMovement called');
            var warning = (Object.keys($scope.selected[0].movements).length === 1) ? 'se borrará el empleado ya que solo tiene un movimiento' : 'se regresará al empleado al estado previo';
            $mdDialog.show(
                $mdDialog.confirm(confirmConfig)
                    .title('Quiere cancelar el último movimiento del empleado ' + $scope.selected[0].data.name + '?')
                    .htmlContent(warning)
                    .ariaLabel('cancel movement')
                    .targetEvent(event)
                    .ok('Si')
                    .cancel('No'))
                .then(function () {
                    $rootScope.loadingProgress = true;
                    $scope.D.models.action('employees', 'cancelLastMovement', {
                        employee: $scope.selected[0].$id,
                        movement: $scope.selected[0].movement.uid
                    }).then(function (response) {
                        successAlertS(response.data.message, response.data.stay);
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync(function () {
                            $log.debug('cancelLastMovement finished');
                        });
                    }).catch(function (err) {
                        errAlertS(err);
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync();
                    });
                }, function () {
                    $log.debug('cancelLastMovement Cancelled');
                });
        }

        /**@type API
         * @description cancela último movimiento del empleado con un *prompt de confirmación
         * @param {Event} event 
         * 
         */
        function cancelVariables(event) {
            $log.debug('cancelVariables called');
            var warning = 'Se cancelaran las variables del empleado';
            $mdDialog.show(
                $mdDialog.confirm(confirmConfig)
                    .title('Quiere cancelar las variables de los empleados seleccionados ?')
                    .htmlContent(warning)
                    .ariaLabel('cancel variables')
                    .targetEvent(event)
                    .ok('Si')
                    .cancel('No'))
                .then(function () {
                    $rootScope.loadingProgress = true;
                    var cancelRequests = [];
                    for (var e = 0; e < $scope.selected.length; e++) {
                        cancelRequests.push($scope.D.models.action('employees', 'cancelLastMovement', {
                            employee: $scope.selected[e].$id,
                            movement: $scope.selected[e].movement.uid
                        }));
                    }
                    $q.all(cancelRequests).then(function () {
                        successAlertS('Variable(s) canceladas');
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync(function () {
                            $log.debug('cancelLastMovement finished');
                        });
                    }).catch(function (err) {
                        errAlertS(err);
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync();
                    });
                }, function () {
                    $log.debug('cancelLastMovement Cancelled');
                });
        }



        /** TODO: documentación
         * @type
         * @description
         * @param {Event} event 
         * @returns
         */
        function checkAndDeleteEmployeesAndMovements(event) {
            $rootScope.loadingProgress = true;
            var employeeActiveMovements = employeeHasActiveMovements($scope.selected);
            $log.debug(employeeActiveMovements, 'movements active of employees');
            if (!employeeActiveMovements.length) {
                checkActiveOperations($scope.selected).then(function (hasActiveOperations) {
                    if (!hasActiveOperations) {
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync();
                        $scope.deleteFb(event);
                    } else {
                        errAlertS('No se puede eliminar empleado(s) seleccionado(s), ya que está en una o más operaciones cerradas');
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync();
                    }
                });
            } else {
                errAlertS('No se puede eliminar empleado(s) seleccionado(s), ya que tiene una o más movimientos activos');
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
            }
        }

        /** TODO: documentación
         * @type
         * @description
         * @param {string} interfase 
         * @returns
         */
        function getInterface(interfase, extraParams) {
            $rootScope.loadingProgress = true;
            $log.debug('Sending movements to ' + interfase, $scope.selected);
            var employees = $scope.selected;
            var checkSBC = ((interfase === 'sua' || interfase === 'idse') && $scope.F.active.menuName === 'mdsRecords');
            var promises = [];
            promises.push($filter('checkSbc')(employees, checkSBC));
            promises.push($filter('checkMovementPrevious')(employees));
            $q.all(promises).then(function (resp) {
                var flagSameSbc = resp[0].flag;
                var flagEnsure = $filter('checkEnsure')(employees, $scope.L.rps);
                var flagRps = $filter('checkSameRP')(employees);
                var flagDateLow = $filter('checkDateLow')(employees, resp[1]);
                var flag = true;
                if (!flagEnsure) {
                    flag = false;
                    errAlertS('Algunos empleados no tienen numero de seguro social');
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                } else if (!flagRps) {
                    flag = false;
                    errAlertS('No todos los empleados pertenecen al mismo registro patronal');
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                } else if (flagSameSbc) {
                    flag = false;
                    errAlertS(resp[0].msg);
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                } else if (angular.isObject(flagDateLow)) {
                    flag = false;
                    var result = flagDateLow;
                    var message = '';
                    for (var i = 0; i < result.length; i++) {
                        if (result[i].response) {
                            message += '<li>' + result[i].message + '</li>';
                        }
                    }
                    errAlertS('<ul>' + message + '</ul>');
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                }
                var method = 'POST';
                if (flag) {
                    var type = $scope.F.active.menuName;
                    if (type === 'employees') { type = 'enroles'; }
                    var ids = $filter('getArrayOfIds')(employees);
                    if (typeof (extraParams) === 'undefined') {
                        extraParams = {};
                    }
                    extraParams.ids = ids.toString();
                    $http({
                        method: method,
                        url: window.__env.serviceWorkerUrl + 'interface/' + interfase + '/' + type,
                        responseType: 'arraybuffer',
                        data: extraParams
                    }).then(function (response) {
                        var headers = response.headers();
                        var filename = headers['x-filename'];
                        var contentType = headers['content-type'];

                        var linkElement = document.createElement('a');
                        try {
                            var blob;
                            blob = new Blob([response.data], {
                                type: contentType
                            });
                            var url = window.URL.createObjectURL(blob);
                            linkElement.setAttribute('href', url);
                            linkElement.setAttribute('download', filename);
                            var clickEvent = new MouseEvent('click', {
                                'view': window,
                                'bubbles': true,
                                'cancelable': false
                            });
                            linkElement.dispatchEvent(clickEvent);
                            $rootScope.loadingProgress = false;
                            $rootScope.$evalAsync(function () {
                                $log.debug('getInterface finished');
                            });
                        } catch (ex) {
                            $log.error(ex, 'error descargando el archivo');
                            $rootScope.loadingProgress = false;
                            $rootScope.$evalAsync();
                        }
                    }).catch(function (err) {
                        var msg = 'Error al solicitar el archivo';
                        if (angular.isDefined(err.data)) {
                            var data = angular.fromJson(String.fromCharCode.apply(null, new Uint8Array(err.data)));
                            if (angular.isDefined(data) && angular.isDefined(data.data.message) && angular.isDefined(data.data.message)) {
                                msg = data.data.message;
                            }
                        } else {
                            $log.error(err);
                        }
                        errAlertS(msg);
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync();
                    });
                }
            }).catch(function (error) {
                errAlertS('Error al consultar el sbc', error);
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
            });
        }

        /** TODO: documentación
         * @type
         * @description
         * @param {*} event 
         * @param {*} status 
         * @returns
         */
        function moveEmployees(event, status) {
            // primero checar que tengan el mismo RP los empleados seleccionados
            var employees = $scope.selected;
            var valid = (status === 3) ? $filter('checkSameRP')(employees) : true;
            var validDismiss = (status === 3) ? validDismisses(employees) : true;
            var validMovementSdType = $filter('recordsHaveValue')(employees, 'movement.onlySd', true, 'any');
            $log.debug('moveEmployees', {
                status: status,
                validRps: valid,
                validDismisses: validDismiss
            });
            if (valid) {
                if (validDismiss === true) {
                    if (!validMovementSdType) {
                        moveEmployeesAndMovements(event, status, employees);
                    } else {
                        var allOnlySdType = $filter('recordsHaveValue')(employees, 'movement.onlySd', true);
                        if (allOnlySdType) {
                            moveEmployeesAndMovements(event, status, employees, '000000000');
                        } else {
                            errAlertS('Uno o varios movimientos afectan solo para nominá');
                        }
                    }
                } else {
                    errAlertS(validDismiss);
                }
            } else {
                errAlertS('Los empleados tienen distintos Registros Patronales');
            }
        }

        /** TODO: documentación
         * @type
         * @description
         * @param {*} event 
         * @param {*} status 
         * @returns
         */
        function moveMovements(event, status) {
            // primero checar que tengan el mismo RP los empleados seleccionados
            var movements = $scope.selected;
            moveMovementsAndEmployeeIfNeeded(event, status, movements);
        }

        /**
         * @type DOM, formatter, filter
         * @description Regresa solo los empleados con movimiento actual tipo "alta"
         * @param {[Employee]} selected empleados seleccionados
         * @returns [Employee]
         */
        function onlyEnroles(selected) {
            for (var s in selected) {
                if (selected[s].movement.type !== 6) {
                    return false;
                }
            }
            return true;
        }

        /** TODO: documentación
         * @type
         * @description
         * @param {*} allData 
         * @param {*} exportId 
         * @returns
         */
        function exportDataToExcel(allData, exportId, currentPage, paginate, isMovements) {
            var ref = isMovements ? 'catalogs/movements/collection' : 'catalogs/employees/collection';
            CatalogsF.exportDataToExcel(allData, exportId, $scope.selected, ref, currentPage, paginate);
        }

        $scope.setEmployeeNumberAuto = function (employeeId) {
            var obj = {
                'type': 'setLastEmployeeId',
                'employeeId': employeeId
            };
            $scope.F.root.child('queue1/tasks').push(obj);
            $scope.getThem();
        };
        /**
         * @type API, dialog
         * @description Muestra dialog para confirmación de si se desea cancelar último movimiento y aplica acción
         * @param {Event} event 
         */
        function cancelMovements(event) {
            var confirm = $mdDialog.prompt()
                .title('Cancelar movimiento de ' + $filter('typeName')($scope.selected[0].movement.type))
                .textContent('a ' + $scope.selected.length + ' empleados')
                .ariaLabel('Está Seguro(a)?')
                .targetEvent(event)
                .ok('OK')
                .cancel('Cancelar');
            $mdDialog.show(confirm).then(function (answer) {
                $log.debug(answer, 'answer');
                cancelMovementsAndSaveEmployees($scope.selected);
            });
        }

        /** TODO: documentación
         * @type
         * @description
         * @param {[]} variables
         * @param {[Employee]} variableEmployees
         * @returns
         */
        function importVariables(variables, variableEmployees, count) {
            return $q(function (resolve) {
                if (angular.isUndefined(count)) {
                    count = 0;
                }
                count++;
                if (count < 5) {
                    $scope.F.loadingFile = true;
                    var activeVariables = $filter('checkValueObjectsOfArray')(variables);
                    $log.debug(variables, activeVariables, 'variables to be MDSs');
                    var updates = {};
                    var listsIdsExecute = [];
                    if (activeVariables.length > 0) {
                        for (var v = 0; v < activeVariables.length; v++) {
                            var variable = activeVariables[v];
                            var variableDate = (!isNaN(variable.date)) ? variable.date : moment(variable.date, 'DD/MM/YYYY').valueOf();
                            var salaryType = (typeof (variable.salaryType) !== 'undefined' && $filter('getSomethingOfArrayM')(parseInt(variable.salaryType), $scope.M.salaryTypes, 'name', false, 'humansiteCode')) ? parseInt(variable.salaryType) : 2;
                            var employee = variableEmployees[variable.id]
                            $log.log('empleado variables', employee);
                            var movement = {
                                status: 2.1,
                                employee: variable.id,
                                cc: (angular.isDefined(variableEmployees[variable.id].cc)) ? variableEmployees[variable.id].cc : '',
                                fromVariables: true,
                                data: {
                                    comments: 'MDS desde variable',
                                    date: Number(variableDate),
                                    sd: Number(variable.sd),
                                    sbc: Number(variable.sbc),
                                    type: 7,
                                    workDay: (angular.isDefined(variableEmployees[variable.id].data.workDay)) ? variableEmployees[variable.id].data.workDay : 0,
                                    workerType: (angular.isDefined(variableEmployees[variable.id].data.workerType)) ? variableEmployees[variable.id].data.workerType : 0,
                                    salaryType: salaryType,
                                    oldSbc: employee.data.salary.sbc,
                                    oldSd: employee.data.salary.sd
                                },
                                info: {
                                    maternalSurname: (angular.isDefined(variableEmployees[variable.id].data.info.maternalSurname)) ? variableEmployees[variable.id].data.info.maternalSurname : null,
                                    names: (angular.isDefined(variableEmployees[variable.id].data.info.names)) ? variableEmployees[variable.id].data.info.names : null,
                                    nss: variableEmployees[variable.id].data.nss,
                                    paternalSurname: (angular.isDefined(variableEmployees[variable.id].data.info.paternalSurname)) ? variableEmployees[variable.id].data.info.paternalSurname : null,
                                    umf: (angular.isDefined(variableEmployees[variable.id].data.health.umf)) ? variableEmployees[variable.id].data.health.umf : null,
                                    name: (angular.isDefined(variableEmployees[variable.id].data.name)) ? variableEmployees[variable.id].data.name : null
                                },
                                rp: variableEmployees[variable.id].rp,
                                payroll: variableEmployees[variable.id].payroll,
                                approved: $scope.D.getTimeObject(),
                                created: $scope.D.getTimeObject()
                            };
                            $log.debug(movement, 'movement to be imported');
                            var movementS = movement.data;
                            var movId = $scope.F.root.child('catalogs/movements/collection').push().key;
                            listsIdsExecute.push(variable.id);
                            updates['catalogs/movements/collection/' + movId] = movement;
                            updates['catalogs/employees/collection/' + variable.id + '/movements/' + movId] = {
                                d: movement.data.date,
                                t: 7,
                                s: 2.1,
                                p: movement.payroll
                            };
                            movementS.uid = movId;
                            updates['catalogs/employees/collection/' + variable.id + '/movement'] = movementS;
                            updates['catalogs/employees/collection/' + variable.id + '/status'] = 2.1;
                            updates['catalogs/employees/collection/' + variable.id + '/updated'] = $scope.D.getTimeObject();
                            updates['catalogs/employees/collection/' + variable.id + '/data/salary/sd'] = movement.data.sd;
                            updates['catalogs/employees/collection/' + variable.id + '/data/salary/sbc'] = movement.data.sbc;
                            updates['catalogs/employees/collection/' + variable.id + '/data/salary/type'] = salaryType;
                            updates['catalogs/employees/collection/' + variable.id + '/data/mdsDate'] = movement.data.date;
                            updates['catalogs/employees/collection/' + variable.id + '/data/comments'] = 'MDS desde variable';
                            if (Object.keys(updates).length >= 950) { //945
                                break;
                            }
                        }
                        $scope.F.root.update(updates).then(function () {
                            for (var key = 0; key < listsIdsExecute.length; key++) {
                                var index = variables.findIndex(function (variable) {
                                    return variable.id === listsIdsExecute[key] && (!variable.hasOwnProperty('execute') || !variable.execute);
                                });
                                variables[index].execute = true;
                            }
                            resolve(importVariables(variables, variableEmployees, count));
                        }).catch(function (error) {
                            $log.error(error);
                            resolve(false);
                        });
                    } else {
                        resolve(true);
                    }
                } else {
                    $log.error('Se excedió el máximo de ejecuciones');
                    $log.log(variables);
                    resolve(false);
                }
            });
        }

        /**@type API, formatter
         * @description Convierte variables seleccionadas en MDS pasándolos de status 2.1 a 2
         * @param {Employee[]} selected variables seleccionadas que desean convertirse en mds
         */
        function convertVariablesToMds(selected) {
            $log.debug('convertVariablesToMds', selected);
            var selectedEMap = [];
            for (var e = 0; e < selected.length; e++) {
                selectedEMap.push({
                    id: selected[e].$id,
                    mId: selected[e].movement.uid
                });
            }
            $rootScope.loadingProgress = true;
            $scope.D.models.action('employees', 'convertVariablesToMds', {
                employees: selectedEMap
            }).then(function (response) {
                successAlertS(response.data.message, response.data.stay);
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync(function () {
                    $log.debug('convertVariablesInMds finished');
                });
            }).catch(function (err) {
                errAlertS(err);
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
            });
        }

        /**@type API, formatter
         * @description Manda la(s) baja(s) al módulo de Bajas por confirmar
         * @param {Employee[]} selected 
         */
        function sendToDismissesUnconfirmed(selected) {
            $log.debug('sendToDismissesUnconfirmed', selected);
            var selectedEMap = [];
            for (var e = 0; e < selected.length; e++) {
                selectedEMap.push({
                    id: selected[e].$id,
                    mId: selected[e].movement.uid
                });
            }
            $rootScope.loadingProgress = true;
            $scope.D.models.action('employees', 'sendToDismissesUnconfirmed', {
                employees: selectedEMap
            }).then(function (response) {
                successAlertS(response.data.message, response.data.stay);
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync(function () {
                    $log.debug('sendToDismissesUnconfirmed finished');
                });
            }).catch(function (err) {
                errAlertS(err);
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
            });
        }

        /**@type API, formatter
         * @description Manda la(s) baja(s) por confirmar al módulo de Bajas
         * @param {Employee[]} selected 
         */
        function sendUnconfirmedDismissesToDismisses(selected) {
            $log.debug('sendUnconfirmedDismissesToDismisses', selected);
            var selectedEMap = [];
            for (var e = 0; e < selected.length; e++) {
                selectedEMap.push({
                    id: selected[e].$id,
                    mId: selected[e].movement.uid
                });
            }
            $rootScope.loadingProgress = true;
            $scope.D.models.action('employees', 'sendUnconfirmedDismissesToDismisses', {
                employees: selectedEMap
            }).then(function (response) {
                successAlertS(response.data.message, response.data.stay);
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync(function () {
                    $log.debug('sendUnconfirmedDismissesToDismisses finished');
                });
            }).catch(function (err) {
                errAlertS(err);
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
            });
        }

        /**@type DOM, prompt
         * @description Prompt de confirmación para convertir variable(s) en mds(s)
         * @param {Event} ev 
         */
        function convertVariablesToMdsModal(ev) {
            $log.debug('convertVariablesToMdsModal called');
            var selected = ($scope.selected.length === $scope.F.paginate) ? $scope.Z[$scope.F.active.menuName] : $scope.selected;
            var confirm = $mdDialog.confirm(confirmConfig)
                .title('Desea convertir ' + selected.length + ' variable(s) a mds(s)?')
                .htmlContent('Ésta acción es irreversible de manera automática por el momento')
                .ariaLabel('Está Seguro(a)?')
                .targetEvent(ev)
                .ok('Convertir')
                .cancel('Cancelar');

            $mdDialog.show(confirm).then(function (answer) {
                $log.debug(answer, 'answer');
                convertVariablesToMds(selected);
            }, function () {
                $log.debug('convertVariablesToMdsModal cancelled');
                return false;
            });
        }

        /**@type DOM, prompt 
         * @description Modal de confirmación para mandar baja(s) a módulo de bajas por confirmar
         * @param {Event} ev 
         */
        function sendToUnconfirmedConfirm(ev) {
            $log.debug('sendToUnconfirmedConfirm called');
            var selected = ($scope.selected.length === $scope.F.paginate) ? $scope.Z[$scope.F.active.menuName] : $scope.selected;
            var confirm = $mdDialog.confirm(confirmConfig)
                .title('Desea mandar ' + selected.length + ' baja(s) a bajas por confirmar(s)?')
                .ariaLabel('Está Seguro(a)?')
                .targetEvent(ev)
                .ok('Mandar')
                .cancel('Cancelar');

            $mdDialog.show(confirm).then(function (answer) {
                $log.debug(answer, 'answer');
                sendToDismissesUnconfirmed(selected);
            }, function () {
                $log.debug('sendToUnconfirmedConfirm cancelled');
                return false;
            });
        }

        /**@type DOM, prompt
         * @description Modal de confirmación para mandar baja(s) por confirmar a módulo de bajas
         * @param {Event} ev 
         */
        function sendToDismissesConfirm(ev) {
            $log.debug('sendToDismissesConfirm called');
            var selected = ($scope.selected.length === $scope.F.paginate) ? $scope.Z[$scope.F.active.menuName] : $scope.selected;
            var confirm = $mdDialog.confirm(confirmConfig)
                .title('Desea mandar ' + selected.length + ' baja(s) por confirmar a bajas(s)?')
                .ariaLabel('Está Seguro(a)?')
                .targetEvent(ev)
                .ok('Mandar')
                .cancel('Cancelar');

            $mdDialog.show(confirm).then(function (answer) {
                $log.debug(answer, 'answer');
                sendUnconfirmedDismissesToDismisses(selected);
            }, function () {
                $log.debug('sendToDismissesConfirm cancelled');
                return false;
            });
        }

        $scope.importVariablesModal = function (ev) {
            $log.debug('importVariablesModal');
            $mdDialog.show({
                controller: function (scope, infoAlertS) {
                    scope.filesArray = [];
                    scope.ddate = moment().valueOf();
                    scope.executeFail = false;
                    scope.variables = {
                        file: false,
                        movements: []
                    };
                    scope.L = $scope.L;
                    scope.M = $scope.M;
                    scope.close = function () {
                        $mdDialog.hide();
                        scope.removeUpload();
                    };
                    $scope.F.loadingFile = false;

                    scope.importVariables = function (variables) {
                        importVariables(variables, scope.variableEmployees).then(function (response) {
                            if (response) {
                                scope.close();
                            } else {
                                scope.executeFail = true;
                                infoAlertS('Error al aplicar algunas variables, favor de reintentar');
                            }
                            //successAlertS('Se crearon los movimientos y se actualizaron los empleados');
                        }).catch(errAlertS);
                    };

                    scope.upload = function (files) {
                        var formData = new FormData();
                        $scope.F.loadingFile = true;
                        formData.append('file', files[0].lfFile);
                        $log.debug(formData, 'formData to be uploaded');

                        var query = { isIncapacity: 'true:parseBool', center: AppF.center, project: angular.toJson({ fid: 1, name: 1 }) }
                        var promises = [
                            $scope.D.files.csvToJson(formData),
                            DataF.api.get('concepts', query)
                        ];
                        Promise.all(promises).then(function (resp) {
                            var data = resp[0];
                            var incapacitiesIncidencesTypes = resp[1].data.map(function (item) {
                                return item.fid;
                            })
                            $log.debug(data.data, 'data from csv');
                            scope.variables.file = true;
                            data.data = data.data.map(function (item) {
                                if (item.id) {
                                    item.id = item.id.trim();
                                }
                                return item;
                            });
                            var ids = $filter('getArrayOfIds')(data.data, 'id');
                            var dataEmployeemasive = [];
                            for (var d = 0; d < data.data.length; d++) {
                                var infoEmployee = data.data[d];
                                dataEmployeemasive.push(checkDisabilitiesEmployeeFilter(infoEmployee.id, moment(infoEmployee.date, ['DD-MM-YYYY', 'DD/MM/YYYY']).valueOf(), incapacitiesIncidencesTypes))
                                $log.log('id del empleado', moment(infoEmployee.date, ['DD-MM-YYYY', 'DD/MM/YYYY']).valueOf())
                            }
                            $q.all([$scope.F.getArrayOfFBObjects(ids, 'catalogs/employees/collection', 1), $filter('getMinimumWagesOfMovements')(data.data, 'date', 'id', 'umaRecords'), Promise.all(dataEmployeemasive)]).then(function (resp) {
                                scope.variableEmployees = resp[0];
                                scope.variables.movements = $filter('validateVariables')(resp[0], data.data, resp[1], resp[2]);
                                $scope.F.loadingFile = false;
                                $log.debug(scope.variableEmployees, 'variableEmployees loaded');
                                $rootScope.$evalAsync();
                                //data del filtro
                            });
                        }, function (err) {
                            errAlertS(err);
                            $scope.F.loadingFile = false;
                        });
                    };
                    // TODO: pasar a padre
                    scope.removeUpload = function () {
                        $log.debug('cancelling upload');
                        scope.filesArray = [];
                        scope.csvApi.removeAll();
                        scope.variables = {
                            file: false,
                            movements: []
                        };
                    };
                },
                templateUrl: 'app/main/employees/dialogs/import-variables.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            }).then(function (answer) {
                $log.debug(answer, 'importVariablesModal answer');
            }, function () {
                $log.debug('importVariablesModal cancelled');
            });
        };

        function getEmployeesData(ids, employeesData) {
            return new Promise(function (resolve, reject) {
                employeesData = angular.isUndefined(employeesData) ? [] : employeesData;
                try {
                    if (angular.isArray(ids) && ids.length > 0) {
                        var thisEmployeeId = ids.pop();
                        $scope.F.root.child('catalogs/employees/collection/' + thisEmployeeId).once('value').then(function (snap) {
                            if (snap.exists()) {
                                var thisEmployee = snap.val();
                                thisEmployee.$id = snap.key;
                                employeesData.push(thisEmployee);
                            }
                            resolve(getEmployeesData(ids, employeesData));
                        }).catch(reject);
                    } else {
                        resolve(employeesData);
                    }
                } catch (error) {
                    reject(error);
                }
            });

        }

        function checkEmployeesLoans(employeesIds) {
            return new Promise(function (resolve) {
                try {
                    getEmployeesData(employeesIds).then(function (employeesData) {
                        $log.log(employeesData);
                        resolve($filter('askForLoanUpdate')(employeesData));
                    }).catch(function (error) {
                        $log.log(error);
                        errAlertS('Error al actualizar los prestamos, verificar manualmente los créditos de los empleados');
                        resolve(false);
                    });
                } catch (error) {
                    $log.log(error);
                    errAlertS('Error al actualizar los prestamos, verificar manualmente los créditos');
                    resolve(false);
                }
            });
        }
        function executeManyAction(data, apiRoute, action) {
            $rootScope.loadingProgress = true;
            var employeesIds = $filter('getArrayOfIds')($scope.selected);
            data.employeesIds = employeesIds.toString();
            $log.debug(data, apiRoute, 'executeManyAction Called');
            $scope.D.models.action('employees', apiRoute, data).then(function (response) {
                successAlertS(response.data.message, response.data.stay);
                $rootScope.loadingProgress = false;
                var promises = [];
                $rootScope.$evalAsync(function () {
                    $log.debug(apiRoute, 'finished');
                });
                if (['reentry', 'changePayroll'].indexOf(action) > -1) {
                    promises.push(checkEmployeesLoans(employeesIds));
                }
                return Promise.all(promises);
            }).then(function () {
                $scope.getThem();
            }).catch(function (err) {
                errAlertS(err);
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
            });
        }

        function registerEmitAccount(selected) {
            var employeesToUpdate = {};
            var dataNeedByTemplate = {};
            var updates = {};
            for (var i = 0; i < selected.length; i++) {
                if (!selected[i].hasPendingRequest) {
                    updates[selected[i].fid + '/data/cards'] = $filter('clearObject')(selected[i].data.cards);
                    updates[selected[i].fid + '/updated'] = $scope.D.getTimeObject();
                    employeesToUpdate[selected[i].fid] = selected[i];
                    dataNeedByTemplate[selected[i].fid] = $filter('getEmployeeDataObjects')(selected[i]);
                }
            }
            if (Object.keys(employeesToUpdate).length > 0) {
                var templateData;
                $rootScope.loadingProgress = true;
                $q.all(dataNeedByTemplate).then(function (data) {
                    templateData = data;
                    // throw "Error";
                    return $scope.F.root.child('catalogs/employees/collection').update(updates);
                }).then(function () {
                    $filter('loopEach')(employeesToUpdate, function (data, employeeId) {
                        var index = $scope.selected.findIndex(function (item) {
                            return item.fid === employeeId;
                        });
                        if (index > -1) {
                            $scope.selected[index].data.cards = employeesToUpdate[employeeId].data.cards;
                        }
                        $scope.F.notifyUsers('enroleAccount', 'enroleAccount', 'requested', employeesToUpdate[employeeId].movement.uid, employeesToUpdate[employeeId], false, templateData[employeeId]);
                    });
                    successAlertS('Se envió la solicitud de cuentas con éxito');
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                }).catch(function (error) {
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                    errAlertS('Error al solicitar las cuentas inténtelo nuevamente');
                    $log.error(error);
                });
            } else {
                successAlertS('No se encontraron datos para solicitar');
            }
        }
        $scope.showSyncConfirmationModal = function (event) {
            var selected = $scope.selected;
            var title = "¿Sincronizar empleados?"
            var msg = selected.length + " empleado(s) serán sincronizados, desea continuar";
            var confirm = $mdDialog.confirm()
                .title(title)
                .textContent(msg)
                .ariaLabel('Sincronizar empleados')
                .targetEvent(event)
                .ok('Si, sincronizar')
                .cancel('No, Cancelar');
            $mdDialog.show(confirm).then(function () {
                var updates = {};
                var thisDate = moment();
                for (var s = 0; s < selected.length; s++) {
                    updates[selected[s].fid + "/syncToGeoVictoria"] = thisDate.valueOf();
                }
                $scope.loadingProgress = true;
                $scope.F.root.child('catalogs/employees/collection').update(updates).then(function () {
                    successAlertS('Se marcaron los empleados para sincronizar, para conocer el status vaya al pagina de sincronización');
                    $scope.loadingProgress = false;
                    $scope.$evalAsync();
                }).catch(function (error) {
                    errAlertS(error);
                    $scope.loadingProgress = false;
                    $scope.$evalAsync();
                });
            }, function () {
                $log.log('Synchronization cancelled');
            });
        }
        function validateEmployeeMovements(movementsIds, errors) {
            return new Promise(function (resolve, reject) {
                errors = errors || [];
                if (movementsIds.length > 0) {
                    var thisIds = movementsIds.splice(0, movementsIds.length > 50 ? 50 : movementsIds.length);
                    var query = { fid: { $in: thisIds }, project: angular.toJson({ status: 1, "info.name": 1 }) }
                    DataF.api.get('movements', query).then(function (resp) {
                        var movementsData = resp.data;
                        errors = movementsData.reduce(function (current, item) {
                            if (item.status < 3 || item.status === 3.5) {
                                current.push(item.info.name + " tiene un movimiento " + (item.status < 3 ? "pendiente" : "rechazado") + ", no se puede enviar mas movimientos");
                            }
                            return current;
                        }, errors);
                        resolve(validateEmployeeMovements(movementsIds, errors));
                    }).catch(reject)
                } else if (errors.length > 0) {
                    reject(errors);
                } else {
                    resolve(true);
                }
            });
        }
        function sendManyToAction(ev, action) {
            $log.debug('sendManyToAction');
            var template;
            var apiRoute;
            var extraInfo = {};
            var promises = [];
            var setDataActions = {
                dismiss: function () {
                    template = 'app/main/employees/dialogs/dismiss-many-employees.html';
                    apiRoute = 'dissmissEmployees';
                    extraInfo.dismissStatus = 2;
                    promises = [validateEmployeeMovements($scope.selected.map(function (item) { return item.movement.uid }))];
                },
                reentry: function () {
                    template = 'app/main/employees/dialogs/reentry-many-employees.html';
                    apiRoute = 'reentryEmployees';
                    extraInfo.reentryStatus = 2;
                    promises = [validateEmployeeMovements($scope.selected.map(function (item) { return item.movement.uid }))];
                },
                changePayroll: function () {
                    template = 'app/main/employees/dialogs/change-payroll-employees.html';
                    apiRoute = 'changePayrollEmployees';
                },
                registerEmitAccount: function () {
                    template = 'app/main/employees/dialogs/register-emit-account.html';
                    apiRoute = 'registerEmitAccount';
                }
            };
            if (setDataActions[action]) {
                setDataActions[action]()
            }
            return Promise.all(promises).then(function () {
                $log.log('action', action, template);
                return $mdDialog.show({
                    locals: {
                        selected: $scope.selected,
                        action: action
                    },
                    controller: "ManyEmployeeActionController",
                    templateUrl: template,
                    parent: angular.element($document.body),
                    targetEvent: ev
                })
            }).then(function (answer) {
                var data = Object.assign(answer, extraInfo);
                switch (action) {
                    case 'registerEmitAccount':
                        registerEmitAccount(answer);
                        break;
                    default:
                        if (action === 'dismiss') {
                            var dismissType = $scope.M.dismissTypes.find(function (item) {
                                return item._id === data.dismissType;
                            });
                            if (angular.isDefined(dismissType) && angular.isDefined(dismissType.defaultStatus)) {
                                data.dismissStatus = dismissType.defaultStatus;
                            }
                        }
                        executeManyAction(data, apiRoute, action);
                        break;
                }

            }).catch(function (error) {
                if (error) {
                    errAlertS(error);
                }
            });
        }

        function checkBenefitStatus() {
            $scope.D.models.action('employees', 'checkBenefitStatus', {}).then(function (response) {
                successAlertS(response.data.message);
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync(function () {
                    $log.debug('checkBenefitStatus finished');
                });
            }).catch(function (err) {
                errAlertS(err);
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
            });
        }

        $scope.ask = function () {
            $mdDialog.show({
                templateUrl: 'app/main/employees/views/iaModel.html',
                controller: 'IaModelController',
                controllerAs: 'aiCtrl',
                parent: angular.element($document.body),
                targetEvent: event,
                scope: $scope.$new(),
                clickOutsideToClose: false
            });
            $log.log('Entro para preguntar a la ia')
        }

        $scope.asyncIntegrations = function (selected, type, event) {
            var warning = 'Se sincronizaran ' + selected.length + ' empleados con ' + type + ', desea continuar?';
            $mdDialog.show(
                $mdDialog.confirm(confirmConfig)
                    .title('Integración con' + ' ' + type + ' ' + 'para control de asistencias de empleados')
                    .htmlContent(warning)
                    .ariaLabel('async employee')
                    .targetEvent(event)
                    .ok('Si')
                    .cancel('No')
            ).then(function () {
                for (var i = 0; i < selected.length; i++) {
                    var data = selected[i];
                    $log.log(data)
                    var todayDate = moment().valueOf();
                    if (type === 'geoVictoria') {
                        $scope.F.root.child('catalogs/employees/collection/' + data.$id + '/sync/execute/geovictoria').set(todayDate);
                        successAlertS('Se han enviado los empleados a GeoVictoria, para ver el estatus de la integración diríjase a la página de Sincronización');
                    }
                    if (type === 'buk') {
                        $scope.F.root.child('catalogs/employees/collection/' + data.$id + '/sync/execute/buk').set(todayDate);
                        successAlertS('Se han enviado los empleados a Buk, para ver el estatus de la integración diríjase a la página de Sincronización');
                    }
                    if (type === 'humand') {
                        $scope.F.root.child('catalogs/employees/collection/' + data.$id + '/sync/execute/humand').set(todayDate);
                        successAlertS('Se han enviado los empleados a Humand, para ver el estatus de la integración diríjase a la página de Sincronización');
                    }
                }
            }).catch(function () {
                $log.log('No se hizo la integración');
            })
        }

        $scope.disableValidationsForEmployees = function (selected, ev) {
            $mdDialog.show({
                templateUrl: 'app/main/employees/views/employees/dialogsEmployees/disableValidationsForEmployees.html',
                controller: 'disableValidationsForEmployeesController',
                controllerAs: 'dsCtrl',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    selected: selected
                }
            });
        }
        // function changeNomina() {
        //     console.log('Empleado seleccionado', $scope.selected);
        // }

        $scope.convertVariablesToMdsModal = convertVariablesToMdsModal;
        $scope.checkAndDeleteEmployeesAndMovements = checkAndDeleteEmployeesAndMovements;
        $scope.getInterface = getInterface;
        $scope.moveEmployees = moveEmployees;
        $scope.moveMovements = moveMovements;
        $scope.onlyEnroles = onlyEnroles;
        $scope.exportDataToExcel = exportDataToExcel;
        $scope.cancelMovements = cancelMovements;
        $scope.cancelLastMovement = cancelLastMovement;
        $scope.sendToUnconfirmedConfirm = sendToUnconfirmedConfirm;
        $scope.sendToDismissesConfirm = sendToDismissesConfirm;
        $scope.cancelVariables = cancelVariables;
        $scope.sendManyToAction = sendManyToAction;
        $scope.checkHealthBenefit = checkBenefitStatus;
    }
}());
(function () {
    'use strict';

    angular
        .module('app.clients')
        .directive('formCredit', formCredit)
        .directive('formLoan', formLoan)
        .directive('formDismiss', formDismiss)
        .directive('formExtras', formExtras)
        .directive('formSat', formSat)
        .directive('formInfo', formInfo)
        .directive('formInfoSimple', formInfoSimple)
        .directive('formSpecialServices', formSpecialServices)
        .directive('formLocation', formLocation)
        .directive('formMds', formMds)
        .directive('formAniversary', formAniversary)
        .directive('formConfig', formConfig)
        .directive('formRevisionEnrole', formRevisionEnrole)
        .directive('formSalaries', formSalaries)
        .directive('formHealth', formHealth)
        .directive('formWorker', formWorker)
        .directive('formSpecialMovement', formSpecialMovement)
        .directive('formDateMovement', formDateMovement)
        .directive('formFastEnrole', formFastEnrole)
        .directive('formBenefitsEmployee', formBenefitsEmployee)
        .directive('formExtraFields', formExtraFields)
        .directive('formEmployeeCards', formEmployeeCards)

    function formEmployeeCards() {
        // Return the directive configuration object.
        return ({
            require: "ngModel",
            restrict: "E",
            controllerAs: 'vm',
            scope: {
                readMode: "<",
                hideEmit: "<",
                hideArchived: "<",//
                hideHeader: "<",
                hideAddCard: "<",
                hideCardNumber: "<",//Deshabilitar mostrar tarjeta si es emitir
                hideBankToReg: "<",
                processes: "<",//Listado de procesos
                banks: "<",//Catalogo de bancos
                form: "<",//Formulario para mostrar validaciones
                verticalAlign: "<"
            },
            templateUrl: 'app/main/employees/forms/employee-cards.html',
            controller: function ($scope) {
                var vm = this;
                vm.minAccountLength = {};

                vm.setMinAndMaxLength = function (card, index) {
                    var thisBankIndex = vm.banks.findIndex(function (item) {
                        return card.bank === item._id
                    });
                    var accountLength = 10;
                    if (thisBankIndex > -1 && angular.isDefined(vm.banks[thisBankIndex].accountLength)) {
                        accountLength = vm.banks[thisBankIndex].accountLength
                    }
                    vm.minAccountLength[index] = accountLength;
                }
                $scope.$watchGroup(["readMode", "hideEmit", "hideArchived", "hideCardNumber", "processes", "banks", "form", "hideHeader", "hideAddCard", "hideBankToReg", "verticalAlign"], function () {
                    vm.readMode = $scope.readMode;
                    vm.hideEmit = $scope.hideEmit;
                    vm.hideArchived = $scope.hideArchived;
                    vm.hideCardNumber = $scope.hideCardNumber;
                    vm.hideHeader = $scope.hideHeader;
                    vm.hideAddCard = $scope.hideAddCard;
                    vm.processes = $scope.processes;
                    vm.banks = $scope.banks;
                    vm.form = $scope.form;
                    vm.verticalAlign = $scope.verticalAlign;
                    vm.hideBankToReg = $scope.hideBankToReg;
                });
            },
            link: function link(scope, element, attributes, ngModelController) {
                scope.$watchCollection('vm.cards', function (value) {
                    var thisValue = [];
                    if (angular.isArray(value)) {
                        thisValue = value.map(function (item) {
                            item.emit = item.emit ? true : false;
                            return item;
                        })
                    }
                    ngModelController.$setViewValue(thisValue);
                    ngModelController.$validate()
                });
                ngModelController.$render = function () {
                    if (!ngModelController.$viewValue) {
                        ngModelController.$viewValue = [];
                    }
                    scope.vm.cards = ngModelController.$viewValue;
                }
            }
        });
    }

    function formFastEnrole() {
        return {
            // replace: true,
            scope: true,
            templateUrl: 'app/main/employees/forms/fast-enrole.html'
        }
    }

    function formWorker() {
        return {
            // replace: true,
            scope: true,
            templateUrl: 'app/main/employees/forms/worker.html'
        }
    }

    function formDateMovement() {
        return {
            // replace: true,
            scope: true,
            templateUrl: 'app/main/employees/forms/date-movement.html'
        }
    }

    function formCredit() {
        return {
            // replace: true,
            scope: true,
            templateUrl: 'app/main/employees/forms/credit.html'
        }
    }

    function formLoan() {
        return {
            // replace: true,
            scope: true,
            templateUrl: 'app/main/employees/forms/loan.html'
        }
    }

    function formDismiss() {
        return {
            // replace: true,
            strict: 'A',
            scope: true,
            transclude: true,
            templateUrl: 'app/main/employees/forms/dismiss.html'
        }
    }

    function formExtras() {
        return {
            // replace: true,
            scope: true,
            templateUrl: 'app/main/employees/forms/extras.html'
        }
    }
    function formSat() {
        return {
            // replace: true,
            scope: true,
            templateUrl: 'app/main/employees/forms/sat.html'
        }
    }

    function formInfo() {
        return {
            // replace: true,
            scope: true,
            templateUrl: 'app/main/employees/forms/info.html'
        }
    }

    function formInfoSimple() {
        return {
            // replace: true,
            scope: true,
            templateUrl: 'app/main/employees/forms/info-simple.html'
        }
    }

    function formSpecialServices() {
        return {
            // replace: true,
            scope: true,
            templateUrl: 'app/main/employees/forms/special-services.html'
        }
    }

    function formLocation() {
        return {
            // replace: true,
            scope: true,
            templateUrl: 'app/main/employees/forms/location.html'
        }
    }

    function formMds() {
        return {
            // replace: true,
            scope: true,
            transclude: true,
            templateUrl: 'app/main/employees/forms/mds.html'
        }
    }

    function formAniversary() {
        return {
            // replace: true,
            scope: true,
            transclude: true,
            templateUrl: 'app/main/employees/forms/aniversary.html'
        }
    }

    function formConfig() {
        return {
            // replace: true,
            scope: true,
            templateUrl: 'app/main/employees/forms/config.html'
        }
    }

    function formRevisionEnrole() {
        return {
            // replace: true,
            scope: true,
            templateUrl: 'app/main/employees/forms/revision-enrole.html'
        }
    }

    function formSalaries() {
        return {
            // replace: true,
            scope: true,
            templateUrl: 'app/main/employees/forms/salaries.html'
        }
    }

    function formHealth() {
        return {
            // replace: true,
            scope: true,
            templateUrl: 'app/main/employees/forms/health.html'
        }
    }

    function formSpecialMovement() {
        return {
            // replace: true,
            scope: true,
            templateUrl: 'app/main/employees/forms/special-movement.html'
        }
    }

    function formBenefitsEmployee() {
        return {
            // replace: true,
            scope: true,
            templateUrl: 'app/main/employees/forms/benefits-employee.html'
        }
    }
    function formExtraFields() {
        return {
            // replace: true,
            scope: true,
            templateUrl: 'app/main/employees/forms/extra-fields.html'
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.employees')
        .filter('validateVariables', validateVariables)

    function validateVariables(
        AppF,
        ListsF
    ) {

        return validateVariablesFn;

        function validateVariablesFn(employees, variables, minimumWages, employeeHasIncidenses) {
            var variableMovements = [];
            //console.log(employees,variables);
            for (var v = 0; v < variables.length; v++) {
                var variable = variables[v];
                variable.valid = true;
                variable.importedSd = false;
                var oldSbc = 0;
                if (employees[variable.id] && employees[variable.id].data && employees[variable.id].data.salary && employees[variable.id].data.salary.sbc) {
                    oldSbc = Number(employees[variable.id].data.salary.sbc);
                    //console.log(oldSbc);
                }
                if (typeof (variable.sd) == "undefined") {
                    variable.sd = Number(employees[variable.id].data.salary.sd);
                } else {
                    variable.importedSd = true;
                }
                variable.sbc = Number(variable.sbc);
                variable.invalidReasons = [];
                if (!variable.id || variable.id == '') { // se eliminan lineas del csv vacias

                } else {
                    // existe el empleado?
                    if (!employees.hasOwnProperty(variable.id) || !employees[variable.id]) {
                        variable.valid = false;
                        variable.invalidReasons.push('Empleado con éste id no existe');
                    } else {
                        // el empleado no este con movimientos pendientes
                        // TODO: hacer que sistema pueda meter movimientos si status >= 3
                        if (employees[variable.id].status !== 4) {
                            variable.valid = false;
                            variable.invalidReasons.push('Empleado tiene movimientos pendientes');
                        }
                        // el empleado no esté dado de baja
                        if (employees[variable.id].status == 5) {
                            variable.valid = false;
                            variable.invalidReasons.push('Empleado está dado de baja');
                        }
                        // el empleado tenga NSS
                        if (!employees[variable.id].data.nss || employees[variable.id].data.nss.length != 11) {
                            variable.valid = false;
                            variable.invalidReasons.push('Empleado no tiene número de seguridad social');
                        }
                        if (employeeHasIncidenses[v]){
                            variable.valid = false;
                            variable.invalidReasons.push('El empleado tiene incapacidades pendientes')
                        }

                        var maxSbc = (angular.isDefined(minimumWages[variable.id]) && angular.isDefined(minimumWages[variable.id].value) ? minimumWages[variable.id].value : 0) * 25;
                        // sbc no puede ser menor o igual a sd
                        if (variable.sbc <= variable.sd && variable.sbc < maxSbc) {
                            variable.valid = false;
                            variable.invalidReasons.push('SBC debe ser mayor que SD');
                        }
                        //sbc no puede ser igual al que tiene actualmente
                        if (variable.sbc == oldSbc && variable.sbc < maxSbc) {
                            variable.valid = false;
                            variable.invalidReasons.push('SBC importado igual al SBC actual del empleado');
                        }
                        // fecha no sea misma o anterior que la del ultimo movimiento (mismo día)
                        var variableDate = (!isNaN(variable.date)) ? moment(parseInt(variable.date)) : moment(variable.date, 'DD/MM/YYYY');
                        // console.log(variableDate.format('DD/MM/YYYY'), 'variable Date', moment(employees[variable.id].movement.date).format('DD/MM/YYYY'));
                        var isSameOrAfterDate = moment(employees[variable.id].movement.date).isSameOrAfter(variableDate, 'day');
                        if (isSameOrAfterDate) {
                            variable.valid = false;
                            variable.invalidReasons.push('Misma fecha o anterior al último movimiento');
                        }
                        // nómina no está permitida para usuario
                        if (!AppF.permissionToAccessAllPayrolls) {
                            if (ListsF.payrolls.$indexFor(employees[variable.id].payroll) == -1) {
                                variable.valid = false;
                                variable.invalidReasons.push('No tiene permiso para gestionar ésta nómina');
                            }
                        }
                    }
                    variableMovements.push(variable);
                }
            }
            return variableMovements;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('validateMovement', validateMovement)

    function validateMovement($log, AppF, DataF) {

        function getMovementMsg(movement, text) {
            return ' El movimiento de ' + movement.info.name + ' con fecha ' + moment(movement.data.date).format('DD-MM-YYYY') + ' ' + text
        }

        return validateMovementFn;

        function validateMovementFn(movement, rp, movementTypeFrom) {
            return new Promise(function (resolve) {
                try {
                    console.log(movement.rp, rp)
                    if (movement.rp !== rp) {
                        throw getMovementMsg(movement, 'no pertenece al mismo rp');
                    }
                    var promises = [
                        AppF.root.child('catalogs/employees/collection/' + movement.employee).once('value'),
                        AppF.root.child('catalogs/movements/collection/' + movement.fid).once('value'),
                    ];
                    var query = { page: 1, size: 1, sort: '-data.date', 'status': 4, fid: { $ne: movement.fid }, employee: movement.employee, payroll: movement.payroll };
                    promises.push(DataF.api.get('p/movements', query));
                    var employeeData, movementData, lastMovement;
                    Promise.all(promises).then(function (response) {
                        if (!response[0].exists()) {
                            throw getMovementMsg(movement, 'no tiene la información del empleado');
                        } else {
                            employeeData = response[0].val();
                        }

                        if (!response[1].exists()) {
                            throw getMovementMsg(movement, 'no tiene información');
                        } else {
                            movementData = response[1].val();
                        }
                        if (movementData.data.type !== movementTypeFrom) {
                            throw getMovementMsg(movement, 'no es del mismo tipo de movimientos a enviar')
                        }

                        if ([3.5, 2, 2.1].indexOf(movementData.status) === -1) {
                            throw getMovementMsg(movement, 'no tiene un status valido de envió')
                        }
                        if (angular.isUndefined(movementData.info.nss) || movementData.info.nss === '' || movementData.info.nss === '000000000' || movementData.info.nss === 0) {
                            throw getMovementMsg(movement, 'no tiene un NSS valido');
                        }
                        if (angular.isArray(response[2].data.data) && response[2].data.data.length > 0) {
                            lastMovement = response[2].data.data[0];
                        }
                        if (angular.isDefined(lastMovement) && movementData.data.type === 7) {
                            var thisSbc = Math.round(movementData.data.sbc * 100) / 100;
                            var oldSbc = Math.round(lastMovement.data.sbc * 100) / 100
                            if (thisSbc === oldSbc) {
                                throw getMovementMsg(movement, 'tiene el mismo sbc que su ultimo movimiento aplicado')
                            }
                        }
                        var movementType = movementData.data.type;
                        var movementDate = movementData.data.date;
                        var limitDate;
                        if ([2, 6, 8].indexOf(movementType) > -1) {
                            if (movementDate > AppF.serverTimeStamp) {
                                if (movementType === 2) {
                                    throw getMovementMsg(movement, 'tiene una fecha de baja posterior a la fecha actual')
                                } else {
                                    limitDate = AppF.holydaysInMexico.getDateOfXLabourDaysFromNow(1, AppF.serverTimeStamp).date;
                                    if (movementDate > limitDate.valueOf()) {
                                        throw getMovementMsg(movement, 'tiene una fecha de alta posterior a la maxima permitida')
                                    }
                                }
                            } else if (movementDate < AppF.serverTimeStamp) {
                                limitDate = AppF.holydaysInMexico.getDateOfXLabourDaysSinceNow(movementType === 2 ? 5 : 25, AppF.serverTimeStamp, undefined, true).date;
                                if (movementDate < limitDate.valueOf()) {
                                    throw getMovementMsg(movement, 'tiene una fecha de ' + (movementType === 2 ? 'baja' : 'alta') + ' inferior a la minima permitida')
                                }
                            }
                        } else if (movementType === 7) {
                            var sd = lastMovement.data.sd;
                            if (angular.isUndefined(sd) || sd == null) {
                                throw getMovementMsg(movement, 'no tiene el SD anterior')
                            }
                            if (movementData.data.sd < sd) {
                                limitDate = AppF.holydaysInMexico.getDateOfXLabourDaysSinceNow(4, AppF.serverTimeStamp).date;
                                if (movementDate < limitDate.valueOf()) {
                                    throw getMovementMsg(movement, 'tiene una fecha de mds inferior a la minima permitida');
                                }
                            }
                        }
                        resolve(true);
                    }).catch(function (error) {
                        resolve({ error: error })
                    })
                } catch (error) {
                    resolve({ error: error, });
                }
            });
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('validateActionStatus', validateActionStatus)

    function validateActionStatus($log) {

        return validateActionStatusFn;

        function validateActionStatusFn(employee, action, mapActions) {
            var flag = true;
            if (employee.hasOwnProperty('status') && action) {
                if (mapActions[action]) {
                    if (mapActions[action].constructor == Array) {
                        if (mapActions[action].indexOf(employee.status) == -1) {
                            flag = 'El empleado no se puede editar en el status actual, si tiene dudas consulte con su ejecutivo.';
                            $log.debug('returning to list, because employee.status is no longer available for that view', employee, action);

                        }
                    } else {
                        if (mapActions[action] !== employee.status) {
                            $log.debug('returning to list, because employee.status is no longer available for that view', employee, action);
                            flag = 'El empleado no se puede editar en el status actual, si tiene dudas consulte con su ejecutivo.';
                        }
                    }

                }
            }
            return flag;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.employees')
        .filter('validateAccounts', validateAccounts)

    function validateAccounts(MongoF, nameOfMFilter, $log, getFromObjectFilter) {

        return validateAccountsFn;

        function validateAccountsFn(accounts, employeesQueries) {
            var accountsObj = [];
            for (var j = 0; j < accounts.length; j++) {
                var account = accounts[j];
                var employee = employeesQueries[parseInt(account['No_Empleado'])][0];
                $log.log(employee);
                var errors = [];
                try {
                    if (!angular.isObject(employee)) {
                        throw 'No se encontró el empleado de este registro';
                    }
                    var activeCard = getFromObjectFilter(employee.data, 'cards.0');
                    if (!angular.isObject(activeCard)) {
                        throw 'No se encontró el registro de tarjetas de este empleado'
                    }
                    var bank = activeCard.bank;
                    var cardNumber = activeCard.number;
                    var emit = activeCard.emit;
                    var accountCard = activeCard.account;
                    if (angular.isUndefined(bank)) {
                        errors.push('Esta cuenta no pertenece a algún banco conocido');
                    }
                    var bankName = nameOfMFilter(bank, MongoF.banks, false);
                    if (bankName !== 'BANORTE') {
                        errors.push('La cuenta configurada en el empleado no pertenece a BANORTE');
                    }
                    $log.log(cardNumber, account['Tarjeta'])
                    if (angular.isUndefined(cardNumber)) {
                        errors.push('No hay numero de tarjeta registrada en este registro');
                    } else if (cardNumber !== account['Tarjeta']) {
                        errors.push('El No. de tarjeta no coincide con la tarjeta configurada en el empleado')
                    }
                    if (!emit) {
                        errors.push('Este registro no esta configurado para generar');
                    }
                    if (accountCard) {
                        if (accountCard !== account['Cuenta']) {
                            errors.push('Este registro ya tiene un numero de cuenta asignada');
                        }
                    }
                    if (errors.length === 0) {
                        account.idEmployee = employee.$id;
                        if (accountCard === account['Cuenta'] && cardNumber === account['Tarjeta']) {
                            account.executed = true;
                        }
                    }
                } catch (error) {
                    errors.push(error);
                }
                account.employee = employee;
                if (errors.length > 0) {
                    account.invalid = true;
                    account.errors = errors;
                }
                accountsObj.push(account);
            }
            // for (var v in variables) {
            //     var variable = variables[v];
            //     variable.valid = true;
            //     variable.importedSd = false;
            //     var oldSbc = 0;
            //     if (employees[variable.id] && employees[variable.id].data && employees[variable.id].data.salary && employees[variable.id].data.salary.sbc) {
            //         oldSbc = Number(employees[variable.id].data.salary.sbc);
            //         //console.log(oldSbc);
            //     }
            //     if (typeof (variable.sd) == "undefined") {
            //         variable.sd = Number(employees[variable.id].data.salary.sd);
            //     } else {
            //         variable.importedSd = true;
            //     }
            //     variable.sbc = Number(variable.sbc);
            //     variable.invalidReasons = [];
            //     if (!variable.id || variable.id == '') { // se eliminan lineas del csv vacias

            //     } else {
            //         // existe el empleado?
            //         if (!employees.hasOwnProperty(variable.id) || !employees[variable.id]) {
            //             variable.valid = false;
            //             variable.invalidReasons.push('Empleado con éste id no existe');
            //         } else {
            //             // el empleado no este con movimientos pendientes
            //             // TODO: hacer que sistema pueda meter movimientos si status >= 3
            //             if (employees[variable.id].status !== 4) {
            //                 variable.valid = false;
            //                 variable.invalidReasons.push('Empleado tiene movimientos pendientes');
            //             }
            //             // el empleado no esté dado de baja
            //             if (employees[variable.id].status == 5) {
            //                 variable.valid = false;
            //                 variable.invalidReasons.push('Empleado está dado de baja');
            //             }
            //             // el empleado tenga NSS
            //             if (!employees[variable.id].data.nss || employees[variable.id].data.nss.length != 11) {
            //                 variable.valid = false;
            //                 variable.invalidReasons.push('Empleado no tiene número de seguridad social');
            //             }
            //             var maxSbc = (angular.isDefined(minimumWages[variable.id]) && angular.isDefined(minimumWages[variable.id].value) ? minimumWages[variable.id].value : 0) * 25;
            //             // sbc no puede ser menor o igual a sd
            //             if (variable.sbc <= variable.sd && variable.sbc < maxSbc) {
            //                 variable.valid = false;
            //                 variable.invalidReasons.push('SBC debe ser mayor que SD');
            //             }
            //             //sbc no puede ser igual al que tiene actualmente
            //             if (variable.sbc == oldSbc && variable.sbc < maxSbc) {
            //                 variable.valid = false;
            //                 variable.invalidReasons.push('SBC importado igual al SBC actual del empleado');
            //             }
            //             // fecha no sea misma o anterior que la del ultimo movimiento (mismo día)
            //             var variableDate = (!isNaN(variable.date)) ? moment(parseInt(variable.date)) : moment(variable.date, 'DD/MM/YYYY');
            //             // console.log(variableDate.format('DD/MM/YYYY'), 'variable Date', moment(employees[variable.id].movement.date).format('DD/MM/YYYY'));
            //             var isSameOrAfterDate = moment(employees[variable.id].movement.date).isSameOrAfter(variableDate, 'day');
            //             if (isSameOrAfterDate) {
            //                 variable.valid = false;
            //                 variable.invalidReasons.push('Misma fecha o anterior al último movimiento');
            //             }
            //             // nómina no está permitida para usuario
            //             if (!AppF.permissionToAccessAllPayrolls) {
            //                 if (ListsF.payrolls.$indexFor(employees[variable.id].payroll) == -1) {
            //                     variable.valid = false;
            //                     variable.invalidReasons.push('No tiene permiso para gestionar ésta nómina');
            //                 }
            //             }
            //         }
            //         variableMovements.push(variable);
            //     }
            // }
            return accountsObj;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.employees')
        .filter('typeName', typeName)

    function typeName() {

        return typeNameFn;

        function typeNameFn(type, nameOf, key) {
            var typeName = '';

            if (!nameOf) {
                nameOf = 'movement';
            }
            switch (nameOf) {
                case 'movement':
                    switch (type) {
                        case 6: typeName = (key) ? 'enrole' : 'alta'; break;
                        case 7: typeName = 'mds'; break;
                        case 2: typeName = (key) ? 'dismiss' : 'baja'; break;
                        case 8: typeName = (key) ? 'reEntry' : 'reingreso'; break;
                        case 10: typeName = 'aniversario'; break;
                    }
                    break;
                case 'credit':
                    typeName = type;
                    break;
            }

            return typeName;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.employees')
        .filter('toInt', toInt)

    function toInt() {

        return toIntFn;

        function toIntFn(value, defaultValue) {
            var fValue = defaultValue ? defaultValue : "NaN";
            if (typeof(value) == "string" || typeof(value) == "number") {
                var tempValue = parseInt(value);
                if (!isNaN(tempValue)) {
                    fValue = tempValue;
                }
            }
            return fValue;
        }
    }

}());
(function () {
  'use strict';

  angular
    .module('app.core')
    .filter('prepareMovement', prepareMovement);

  function prepareMovement($log, DataF) {

    return prepareMovementFn;

    function prepareMovementFn(movement, movementId, employee, employeeId, addMovementLog, notAddUpdateLog, notLastMovement, setSDasSdr) {
      movement.employee = employeeId;
      var thisTimeObject = DataF.getTimeObject();
      delete thisTimeObject.logged;
      if (addMovementLog) {
        if (movement.status >= 1 && angular.isUndefined(movement.created)) {
          movement.created = thisTimeObject;
        }
        if (movement.status >= 2 && angular.isUndefined(movement.approved)) {
          movement.approved = thisTimeObject;
        }
        if (movement.status >= 3 && angular.isUndefined(movement.received)) {
          movement.received = thisTimeObject;
        }
        if (movement.status >= 4 && angular.isUndefined(movement.archived)) {
          movement.archived = angular.fromJson(angular.toJson(thisTimeObject));
          movement.archived.date = DataF.getCurrentServerTime();
        }
      }
      if ([6, 8].indexOf(movement.data.type) > -1 && !notLastMovement) {
        movement.data.date = employee.data.enroleDate;
        movement.data.comments = angular.isDefined(employee.data.comments) ? employee.data.comments : null;
      }
      if ([2].indexOf(movement.data.type) > -1 && !notLastMovement) {
        movement.data.sd = angular.isDefined(employee.data.salary.sd) ? employee.data.salary.sd : null;
        movement.data.sbc = angular.isDefined(employee.data.salary.sbc) ? employee.data.salary.sbc : null;
        movement.data.position = angular.isDefined(employee.data.position) ? employee.data.position : null;
        movement.data.department = angular.isDefined(employee.data.department) ? employee.data.department : null;
      }
      if (typeof (movement.info) === 'undefined') {
        movement.info = {};
      }
      if (!notLastMovement) {
        movement.data.position = angular.isDefined(employee.data.position) ? employee.data.position : null;
        movement.data.department = angular.isDefined(employee.data.department) ? employee.data.department : null;
        movement.data.enroleDate = angular.isDefined(employee.data.enroleDate) ? employee.data.enroleDate : null;
        movement.data.seniorityDate = angular.isDefined(employee.data.seniorityDate) ? employee.data.seniorityDate : null;
        movement.data.b = angular.isDefined(employee.data.b) ? employee.data.b : null;
      }
      movement.info.name = employee.data.name;
      movement.info.names = employee.data.info.names;
      movement.info.paternalSurname = employee.data.info.paternalSurname ? employee.data.info.paternalSurname : null;
      movement.info.maternalSurname = employee.data.info.maternalSurname ? employee.data.info.maternalSurname : null;
      movement.payroll = employee.payroll;
      movement.rp = employee.rp;
      movement.cc = employee.cc;
      movement.info.umf = angular.isDefined(employee.data.health.umf) ? employee.data.health.umf : null;
      movement.info.nss = angular.isDefined(employee.data.nss) ? employee.data.nss : null;
      movement.data.workerType = angular.isDefined(employee.data.workerType) ? employee.data.workerType : null;
      movement.data.workDay = angular.isDefined(employee.data.workDay) ? employee.data.workDay : null;
      movement.data.salaryType = angular.isDefined(employee.data.salary.type) ? employee.data.salary.type : null;
      movement.data.sdr = setSDasSdr ? (angular.isDefined(employee.data.salary.sd) ? employee.data.salary.sd : null) : (angular.isDefined(employee.data.salary.sdr) ? employee.data.salary.sdr : null);
      movement.updated = DataF.getTimeObject();
      return movement;
    }
  }

}());

(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('prepareEmployee', prepareEmployee)

    function prepareEmployee(DataF) {

        return prepareEmployeeFn;

        function prepareEmployeeFn(employee, employeeId, movement, movementId, addCreatedLog, createIfNecessary, dontUpdateMovement, setSDasSdr) {
            var employeeStatus = (movement.data.type === 2 && movement.status === 4) ? 5 : movement.status;
            employee.status = employeeStatus;
            if (addCreatedLog && employee.status === 1) {
                employee.created = DataF.getTimeObject();
            }
            if (typeof (employee.movements) === 'undefined') {
                employee.movements = {};
            }
            if ((typeof (employee.movements[movementId]) !== 'undefined' || createIfNecessary) && !dontUpdateMovement) {
                employee.movements[movementId] = {
                    p: movement.payroll,
                    d: movement.data.date,
                    t: movement.data.type,
                    s: movement.status
                };
            }
            employee.data.comments = angular.isDefined(movement.data.comments) ? movement.data.comments : null;
            employee.data.salary.sd = angular.isDefined(movement.data.sd) ? movement.data.sd : null;
            employee.data.salary.sbc = angular.isDefined(movement.data.sbc) ? movement.data.sbc : null;
            if (setSDasSdr) {
                employee.data.salary.sdr = angular.isDefined(employee.data.salary.sd) ? employee.data.salary.sd : null;
            }
            employee.movement = angular.fromJson(angular.toJson(movement.data));
            employee.movement.uid = movementId;
            employee.movement.batch = angular.isDefined(movement.received) && angular.isDefined(movement.received.batch) ? movement.received.batch : null;
            employee.movement.archiveDate = angular.isDefined(movement.archived) && angular.isDefined(movement.archived.date) ? movement.archived.date : null;

            switch (movement.data.type) {
                case 2: // baja
                    employee.data.dismissDate = movement.data.date;
                    break;
                case 7: // mds
                    employee.data.mdsDate = movement.data.date;
                    break;
                case 6:
                case 8: // reEntry
                    // borrar fecha de baja de salud y actualizar nueva fecha si tiene salud activada
                    if (createIfNecessary) {
                        if (employee.data.health) {
                            employee.data.health.endDate = null;
                            employee.data.health.initDate = moment().valueOf();
                        } else {
                            employee.data.health.initDate = null;
                            employee.data.health.certificate = null;
                        }
                    }
                    employee.data.enroleDate = movement.data.date;
                    break;
            }

            employee.updated = DataF.getTimeObject();
            return employee;
        }
    }

}());
(function(){
    'use strict';

    angular
        .module('app.employees')
        .filter('movementsChip', movementsChip)

    function movementsChip(){

        return movementsChipFn;

        function movementsChipFn(movements, types){
            var count = 0;
            for(var m in movements){
                if(types.indexOf(movements[m].t) !== -1){
                    count++;
                }
            }
            return count;
        }
    }

}());
(function(){
    'use strict';

    angular
        .module('app.employees')
        .filter('movementStatusName', movementStatusName)

    function movementStatusName(AppF){

        return movementStatusNameFn;

        function movementStatusNameFn(status){
            for(var s in AppF.employeeStatatuss){
                if(status == AppF.employeeStatatuss[s].id) return AppF.employeeStatatuss[s].name;
            }
            return '';
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('MinMaxValiadationsForMovement', MinMaxValiadationsForMovement);

    function MinMaxValiadationsForMovement(getFactorFromBenefitsFilter, AppF, $rootScope, ListsF, $filter, $log, errAlertS) {
        var lastApprovedMovementCache = {};
        var lastApprovedMovementPromises = {};
        return MinMaxValiadationsForMovementFn;
        /**
         * @param {Object} employee
         * @param {Object} movement
         * @param {Object} benefitConfig
         * @param {boolean} couldBeTheSame
         * @param {boolean} noValidatePayroll
         * @param {{key:string,name:string}|undefined} geoZone
         * @param {ngForm|undefined} form
         */
        function MinMaxValiadationsForMovementFn(employee, movement, benefitConfig, couldBeTheSame, noValidatePayroll, geoZone, form) {
            // ===== Utils
            var thiss = this;
            var isObj = function (x) { return angular.isObject(x); };
            var isDef = function (x) { return typeof x !== 'undefined' && x !== null; };
            var setReady = function (ctrlName, ready) {
                if (angular.isDefined(form) && angular.isDefined(form[ctrlName])) {
                    form[ctrlName].$setValidity('ready', !!ready);
                }
            };
            var truncToLocalDate = function (msUtc) {
                var m = moment(msUtc).utc();
                return new Date(m.year(), m.month(), m.date());
            };
            var nextCent = function (num) {
                return (Math.round(num * 100) + 1) / 100;
            };
            // ===== Estado inicial opcional
            if (isDef(geoZone)) thiss.geoZone = geoZone;
            thiss.setBenefit = function (benefit) { benefitConfig = benefit; };
            // ===== Reglas de fechas por RP
            function computeDefaultDates(isFiscal) {
                return new Promise(function (resolve, reject) {
                    $log.log('Computing default dates for movement. Is fiscal?', isFiscal);
                    AppF.getActualTime().then(function (now) {
                        $log.log('Current server time is', new Date(now));
                        var HMX = AppF.holydaysInMexico;
                        if (!isFiscal) {
                            // No fiscal
                            thiss.minEnroleDate = HMX.getDateOfXLabourDaysSinceNow(25, now).date;
                            thiss.maxEnroleDate = HMX.getDateOfXLabourDaysFromNow(5, now).date;
                            thiss.minDismissDate = new Date(0);
                            thiss.maxDismissDate = new Date(now);
                            thiss.minMdsDate = HMX.getDateOfXLabourDaysSinceNow(15, now).date;
                            thiss.maxMdsDate = HMX.getDateOfXLabourDaysFromNow(5, now).date;
                            thiss.minMovementDate = HMX.getDateOfXLabourDaysSinceNow(15, now).date;
                        } else {
                            // Fiscal
                            thiss.maxEnroleDate = HMX.getDateOfXLabourDaysFromNow(5, now).date;
                            thiss.minEnroleDate = HMX.getDateOfXLabourDaysSinceNow(25, now).date;
                            thiss.minDismissDate = HMX.getDateOfXLabourDaysSinceNow(5, now).date;
                            thiss.maxDismissDate = HMX.getDateOfXLabourDaysFromNow(5, now).date;
                            thiss.minMdsDate = HMX.getDateOfXLabourDaysSinceNow(13, now).date;
                            thiss.maxMdsDate = HMX.getDateOfXLabourDaysFromNow(5, now).date;
                            thiss.minMovementDate = HMX.getDateOfXLabourDaysSinceNow(10, now).date;
                        }
                        resolve(true);
                    }).catch(reject)
                })
            }
            // ====== API: Fechas mínimas
            thiss.setMinDates = function () {
                return new Promise(function (resolve, reject) {
                    setReady('minDatesValidation', false);
                    $log.log('Setting min dates');
                    // Cargar en paralelo última mov. + cat RPs (si hace falta)
                    var pLast = getLastApprovedMovement();
                    var pRps = ListsF.loadList('rps');
                    var thisLastApprovedMovement;
                    var isFiscal;
                    Promise.all([pLast, pRps]).then(function (resp) {
                        thisLastApprovedMovement = resp[0];
                        var rps = resp[1];
                        var rp = $filter('getSomethingOfArrayFB')(employee.rp, rps, 'rp', 'N/A');
                        isFiscal = (rp !== '00000000000');
                        return computeDefaultDates(isFiscal);
                    }).then(function () {
                        if (isObj(thisLastApprovedMovement) && isObj(thisLastApprovedMovement.data)) {
                            var lastDate = thisLastApprovedMovement.data.date;
                            // si NO fue generado por sistema, forzamos mínimo +1 día
                            var minMovementDate = thisLastApprovedMovement.created.bySystem ? lastDate : (lastDate + AppF.oneDay);
                            var minObj = truncToLocalDate(minMovementDate);
                            if (minMovementDate > thiss.minDismissDate.valueOf()) thiss.minDismissDate = minObj;
                            if (minMovementDate > thiss.minEnroleDate.valueOf()) thiss.minEnroleDate = minObj;
                            if (minMovementDate > thiss.minMdsDate.valueOf()) thiss.minMdsDate = minObj;
                            if (minMovementDate > thiss.minMovementDate.valueOf()) thiss.minMovementDate = minObj;
                        }
                        setReady('minDatesValidation', true);
                        resolve(true);
                    }).catch(function (err) {
                        reject(err);
                    });
                })
            };
            // ====== API: Salarios mínimos
            thiss.setMinSalaries = function (currentSd) {
                setReady('minSalariesValidation', false);
                $log.log('Setting min salaries');
                return getLastApprovedMovement().then(function (resp) {
                    var thisLastApprovedMovement = resp;
                    var oldDate = employee.hasSeniorityDate ? employee.data.seniorityDate : employee.data.enroleDate;
                    if (!oldDate) oldDate = Date.now();
                    var mDate = (isObj(movement) && isObj(movement.data) && isDef(movement.data.date)) ? movement.data.date : Date.now();
                    return $filter('getMinimumWageOfDate')(mDate).then(function (minimumData) {
                        $log.log('ver si refresca el cache al cambiar de movimiento v2')
                        // $log.log({
                        //     date: moment(thisLastApprovedMovement?.data?.date).format('YYYY-MM-DD'),
                        //     sd: thisLastApprovedMovement?.data?.sd,
                        //     sbc: thisLastApprovedMovement?.data?.sbc
                        // }, 'Last approved movement data');
                        thiss.minimumVariables = minimumData.minimumVariables;
                        var data = getFactorFromBenefitsFilter(benefitConfig, oldDate, mDate, undefined, true, 'fromMinMax');
                        var factor = data.factor;
                        thiss.b = {
                            f: data.factor,
                            c: data.christmasBonus,
                            h: data.daysOfVacation,
                            p: data.prime,
                            o: data.othersTotal,
                            y: data.years,
                            ry: data.realYears
                        };
                        thiss.factor = factor;
                        var zoneKey = (thiss.geoZone && thiss.geoZone.key) || 'A';
                        var minByZone = minimumData.minimumVariables[zoneKey] || AppF.minimumVariables.A;
                        // Caso: solo SD
                        if (isObj(movement) && isObj(movement.data) && movement.data.onlySd) {
                            var baseSbc = (isObj(thisLastApprovedMovement) && isObj(thisLastApprovedMovement.data)) ? thisLastApprovedMovement.data.sbc : movement.data.sbc;
                            var uma = (minimumData.umaRecord || AppF.umaRecord);
                            thiss.minimumWageByZone = minByZone;
                            thiss.minimumSbc = baseSbc;
                            thiss.lastSbc = baseSbc;
                            thiss.maxSdOfLastSbc = (thiss.lastSbc >= (uma * 25)) ? null : Number((thiss.lastSbc / factor).toFixed(2));
                            thiss.minimumSd = employee.data.workDay === 0 ? minByZone : 0.1;
                        } else if (employee.data.workDay === 0) {
                            $log.log('Empleado con jornada completa, se validará contra salario mínimo general');
                            thiss.minimumSd = minByZone;
                            thiss.minimumWageByZone = minByZone;
                            if (!isDef(thiss.minimumSd)) {
                                errAlertS("No existe salario mínimo establecido para la zona " + (thiss.geoZone && thiss.geoZone.name) + " del año " + minimumData.minimumVariables.year);
                            }
                            if (isObj(thisLastApprovedMovement) && isObj(thisLastApprovedMovement.data) && thisLastApprovedMovement.payroll === employee.payroll && !noValidatePayroll) {
                                thiss.lastSd = thisLastApprovedMovement.data.sd;
                                thiss.lastSbc = thisLastApprovedMovement.data.sbc;
                            } else {
                                delete thiss.lastSd;
                                delete thiss.lastSbc;
                            }
                            var sdToCalc = thiss.minimumWageByZone;
                            if (isDef(currentSd) && currentSd > sdToCalc) {
                                sdToCalc = currentSd;
                            }
                            thiss.minimumSbc = $filter('getDinamicSbc')(sdToCalc, factor, employee.payroll, noValidatePayroll, minimumData.umaRecord, minByZone);
                            delete thiss.maxSdOfLastSbc;
                        } else {
                            $log.log('Empleado con jornada reducida, se validará solo contra salario mínimo por zona');
                            thiss.minimumSd = 0.1;
                            thiss.minimumWageByZone = minByZone;
                            if (isObj(thiss.lastApprovedMovement) && isObj(thiss.lastApprovedMovement.data) && thiss.lastApprovedMovement.payroll === employee.payroll && !noValidatePayroll) {
                                // thiss.minimumSd = couldBeTheSame ? thiss.lastApprovedMovement.data.sd : nextCent(thiss.lastApprovedMovement.data.sd);
                                thiss.lastSd = thisLastApprovedMovement.data.sd;
                                thiss.lastSbc = thisLastApprovedMovement.data.sbc;
                            } else {
                                delete thiss.lastSd;
                                delete thiss.lastSbc;
                            }
                            thiss.minimumSbc = minByZone;
                            delete thiss.maxSdOfLastSbc;
                        }
                        setReady('minSalariesValidation', true);
                        return true;
                    });
                });
            };
            // ====== Cache de último movimiento aprobado
            function getLastApprovedMovement() {
                $log.log('Getting last approved movement for employee ' + employee.$id);
                if (isObj(employee.movements) && employee.$id) {
                    var queries = {
                        page: 1,
                        size: 1,
                        sort: '-data.date',
                        employee: employee.$id,
                        rp: employee.rp,
                        status: { '$in': [3, 4] }
                    };
                    var promise = $rootScope.D.api.get('p/movements', queries);
                    return promise.then(function (resp) {
                        var data = resp && resp.data && resp.data.data;
                        var movement = (data && data.length > 0) ? data[0] : false;
                        return movement;
                    })
                } else {
                    return Promise.resolve(false);
                }

            }
        }
    }
}());

(function() {
    'use strict';

    angular
        .module('app.employees')
        .filter('getValueOfFilter', getValueOfFilter)

    function getValueOfFilter() {

        return getValueOfFilterFn;

        function getValueOfFilterFn(filter) {
            var temp = [];
            for (var a in filter) {
                temp.push({
                    name: a,
                    value: filter,
                    index: a
                });
            }
            return temp;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.employees')
        .filter('getValidEmployeesToPrintPdf', getValidEmployeesToPrintPdf)

    function getValidEmployeesToPrintPdf() {

        return getValidEmployeesToPrintPdfFn;

        function getValidEmployeesToPrintPdfFn(selectedMovements, number) {
            var valid = true;
            angular.forEach(selectedMovements, function (movement) {
                if (
                    angular.isUndefined(movement.received) ||
                    angular.isUndefined(movement.received.batch) ||
                    angular.isUndefined(movement.archived) ||
                    angular.isUndefined(movement.info.nss) ||
                    (angular.isDefined(movement.received.bySystem) && angular.isDefined(movement.archived.bySystem)) ||
                    (angular.isDefined(movement.data.onlySd) && movement.data.onlySd) ||
                    (angular.isDefined(movement.status) && movement.status < 4) ||
                    movement.received.batch === '000000000'
                ) {
                    valid = false;
                }
            })
            if (number && valid) {
                valid = 1;
            } else {
                valid = 0;
            }
            return valid;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('getSyncOptions', getSyncOptions);

    function getSyncOptions(DataF, ListsF, clearObjectFilter, $log, AppF) {

        function promiseOfIssuerName(firmId) {
            return new Promise(function (resolve, reject) {
                var objData = {};
                AppF.root.child("catalogs/firms/collection/" + firmId).once("value").then(function (resp) {
                    var data = resp.val();
                    if (angular.isObject(data) && angular.isObject(data.syncConfig)) {
                        if (data.syncConfig.buk) {
                            objData.buk = true;
                        }
                        if (data.syncConfig.geovictoria) {
                            objData.geoVictoria = true;
                        }
                        if (data.syncConfig.humand) {
                            objData.humand = true;
                        }
                    } else {
                        objData = { error: 'No se encontró la firma' };
                    }
                    resolve(objData);
                }).catch(function (error) {
                    reject(error);
                })
            });
        }

        function getSync(firmId) {
            return promiseOfIssuerName(firmId);
        }

        return getSync;
    }

}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('getPayrollIssuer', getPayrollIssuer);

    function getPayrollIssuer(DataF, ListsF, clearObjectFilter) {

        function promiseOfIssuerName(payrollId, thisProc, action) {
            return new Promise(function (resolve, reject) {
                var issuerName = 'N/A';
                thisProc = thisProc ? thisProc : 'fiscal';
                ListsF.loadList('payrollsProccess', 'catalogs/payrolls/collection/' + payrollId + '/processes', undefined, 'object', 'payrollProccess-' + payrollId).then(function (payrollProccessResp) {
                    if (payrollProccessResp !== null) {
                        var payrollProccess = clearObjectFilter(payrollProccessResp);
                        var promises = [];
                        var promisesIndex = [];
                        for (var proccess in payrollProccess) {
                            if (payrollProccess.hasOwnProperty(proccess)) {
                                if (payrollProccess[proccess].hasOwnProperty('bankAccounts') && payrollProccess[proccess].id === thisProc) {
                                    for (var i = 0; i < payrollProccess[proccess].bankAccounts.length; i++) {
                                        promises.push(DataF.api.get('bankAccounts/' + payrollProccess[proccess].bankAccounts[i]));
                                        promisesIndex.push(payrollProccess[proccess].bankAccounts[i]);
                                    }
                                }
                            }
                        }
                        Promise.all(promises).then(function (bankAccountResp) {
                            var bankAccounts = [];
                            var promisesCompanies = [];
                            var promisesIndexCompanies = [];
                            for (var b = 0; b < bankAccountResp.length; b++) {
                                var bankAccount = bankAccountResp[b].data;
                                if (angular.isObject(bankAccount) && bankAccount.companiesRecord && (angular.isUndefined(action) || action === 'register' || bankAccount.couldEmmit)) {
                                    bankAccounts.push(bankAccount);
                                    promisesCompanies.push(ListsF.loadList('companiesRecordsName', 'catalogs/companiesRecords/collection/' + bankAccount.companiesRecord + '/data/name', undefined, 'object', 'companiesRecordsName-' + bankAccount.companiesRecord));
                                    promisesIndexCompanies.push(bankAccount.companiesRecord);
                                }
                            }
                            Promise.all(promisesCompanies).then(function (companiesResp) {
                                issuerName = {};
                                for (var i = 0; i < bankAccounts.length; i++) {
                                    issuerName[bankAccounts[i].bank] = companiesResp[promisesIndexCompanies.indexOf(bankAccounts[i].companiesRecord)].$value + ' ' + bankAccounts[i].name;
                                }
                                resolve(issuerName);
                            }).catch(reject);
                        }).catch(reject);
                    } else {
                        resolve(issuerName);
                    }
                }).catch(reject);
            });
        }

        /**@type promise, getter, filter
         * @description trae el nombre y numero de emisora de la nómina
         * @param {string} payrollId 
         * @param {'FISCAL'|'complement'} process -> proceso
         * @param {number} complement -> número de complemento
         * @returns Promise<string>
         */
        function getPayrollIssuerFn(payrollId, processId, action) {
            return promiseOfIssuerName(payrollId, processId, action);
        }

        return getPayrollIssuerFn;
    }

}());
(function() {
    'use strict';

    angular
        .module('app.employees')
        .filter('getLastMovementId', getLastMovementId)

    function getLastMovementId($log) {

        return getLastMovementIdFn;

        function getLastMovementIdFn(movements, notThisId, payroll, isNew) {
            var latest = 0;
            var latestId = false;
            $log.debug(isNew,"is new for getLastMovementId so will ignore this movement id");
            for (var m in movements) {
                var mov = movements[m];
                var check = true;
                if (payroll && mov.p != payroll) {
                    check = false;
                }
                if (check) {
                    if (m !== notThisId || isNew) {
                        if (latest < mov.d) {
                            latest = mov.d;
                            latestId = m;
                        }
                    }
                }
            }
            return latestId;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('getGroupsProfileArray', getGroupsProfileArray);

    function getGroupsProfileArray($log, loopEachFilter, ListsF) {
        function getGroupsProfileArrayFn(row) {
            return new Promise(function (resolve, reject) {
                var groups = [];
                var queriesAll = [];
                var queriesGroups = [];
                loopEachFilter(row.groupsOfUser, function (value, group) {
                    queriesAll.push(ListsF.loadList('permissions', 'permissions/' + group + '/organization/payrolls/permissions/accessAll', undefined, 'object', 'accessAllPermissionOf-' + group));
                    queriesGroups.push(ListsF.loadList('groups', 'groups/' + group + '/name', undefined, 'object', 'groupNameOf-' + group));
                });
                Promise.all([Promise.all(queriesAll), Promise.all(queriesGroups)]).then(function (resp) {
                    var globalAccess = false;
                    for (var r = 0; r < resp[0].length; r++) {
                        var groupName = resp[1][r].$value;
                        if (groupName) {
                            var accessAll = resp[0][r].$value ? true : false;
                            var obj = {
                                name: groupName,
                                accessAll: accessAll
                            };
                            if (accessAll) {
                                globalAccess = true;
                            }
                            groups.push(obj);
                        }
                    }
                    row.firstGroupName = groups.length > 0 ? groups[0].name : undefined;
                    row.globalAccess = globalAccess;
                    resolve(groups);
                }).catch(reject);
            });
        }
        return getGroupsProfileArrayFn;
    }

}());
(function(){
    'use strict';

    angular
        .module('app.core')
        .filter('getEntityKeyFromCurp', getEntityKeyFromCurp)

    function getEntityKeyFromCurp(){

        return getEntityKeyFromCurpFn;

        function getEntityKeyFromCurpFn(curp){
            var key=curp.slice(11,13);
            return key;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('getEmployeeDataObjects', getEmployeeDataObjects);

    function getEmployeeDataObjects(
        $q,
        AppF,
        $log,
        DataF,
        getEntityKeyFromCurpFilter,
        $filter,
        ListsF,
        getFromObjectFilter
    ) {
        return function (employee) {
            var promise = $q.defer();
            var querys = {};
            var plainData = {};
            // acc setings
            plainData.styles = {
                td: 'border-bottom: 1px dotted #282c37; margin-right: 5px; margin-bottom: 5px; padding: 0px !important; font-size: 9px !important; font-family: Verdana, Arial, Helvetica, sans-serif !important;',
                strong: 'font-weight: 600; font-size: 9px; !important; font-family: Verdana, Arial, Helvetica, sans-serif !important;',
                span: 'font-size: 9px !important; font-family: Verdana, Arial, Helvetica, sans-serif !important;',
                br: 'line-height: 5px',
                hidden: 'display: none !important; visibility: hidden !important;'
            };
            if (angular.isArray(employee.data.cards) && employee.data.cards.length > 0) {
                plainData.cardNumber = employee.data.cards[0].number;
                if (employee.data.cards[0].emmitedYet) {
                    plainData.emitAccountClass = plainData.styles.hidden;
                }
                plainData.emitOption = 'SI';
                if (employee.data.cards[0].emit) {
                    plainData.accountMsg = 'SI';
                    plainData.accountMessage = 'GENERAR CUENTA';
                } else if (employee.data.cards[0].number) {
                    plainData.accountMsg = 'NO';
                    plainData.accountMessage = 'REGISTRAR CUENTA';
                } else if (!employee.data.cards[0].emitted && !employee.data.cards[0].number) {
                    plainData.accountClass = plainData.styles.hidden;
                }
            } else {
                plainData.accountClass = plainData.styles.hidden;
            }
            if (employee.movement) {
                if (employee.movement.type === 2) {
                    plainData.paySalaryInPayroll = (employee.movement.paySalaryInPayrol) ? 'SI' : 'NO';
                }
                plainData.movementType = $filter("uppercase")($filter('typeName')(employee.movement.type));
                plainData.movementDate = $filter('date')(employee.movement.date, 'dd-MM-yyyy');
                plainData.movementSd = $filter('currency')(employee.movement.sd);
                plainData.movementSbc = $filter('currency')(employee.movement.sbc);
            }
            if (employee.data.salary) {
                plainData.sdCurrency = $filter('currency')(employee.data.salary.sd);
                plainData.sbcCurrency = $filter('currency')(employee.data.salary.sbc);
                plainData.sdrCurrency = $filter('currency')(employee.data.salary.sdr);
                plainData.salaryBM = $filter('currency')($filter('bruteSalary')(employee.data.salary));
                plainData.salaryNM = $filter('currency')($filter('bruteSalary')(employee.data.salary, 1));
            }
            // arrays hidden
            if (employee.data.info.emails) {
                var activeEmails = $filter('filter')(employee.data.info.emails, {
                    active: true
                });
                if (activeEmails.length) {
                    plainData.email = activeEmails[0].email + ' - ' + activeEmails[0].type;
                }
                if (!employee.data.info.emails[0]) { plainData.emailsClass = plainData.styles.hidden; }
            } else {
                plainData.emailsClass = plainData.styles.hidden;
            }
            plainData.phonesClass = plainData.styles.hidden;
            if (employee && employee.data && employee.data.info && angular.isArray(employee.data.info.phones)) {
                var activePhones = $filter('filter')(employee.data.info.phones, { active: true }) || [];

                plainData.phone = activePhones
                    .map(function (p) {
                        return [p.phone, p.type].filter(Boolean).join(' - ');
                    }).join(' | ');

                plainData.phonesClass = activePhones.length ? '' : 'no-phones';
            }
            // salaries
            plainData.realSpan = 1;
            if (!employee.data.salary.sd || angular.isUndefined(employee.data.salary.sd)) {
                plainData.sdClass = plainData.styles.hidden;
                plainData.realSpan++;
            }
            if (!employee.data.salary.sbc || angular.isUndefined(employee.data.salary.sbc)) {
                plainData.sbcClass = plainData.styles.hidden;
                plainData.realSpan++;
            }
            plainData.employee = employee;
            querys.payroll = ListsF.loadList('payrolls', 'catalogs/payrolls/collection', employee.payroll, 'object', 'PayrollsData' + employee.payroll);
            querys.firmName = ListsF.loadList('firms', 'lists/firms/all', employee.firm, 'object', 'firmsData' + employee.firm);
            querys.ccName = ListsF.loadList('ccs', 'lists/ccs/all', employee.cc, 'object', 'ccsData' + employee.cc);
            querys.rpName = ListsF.loadList('rps', 'lists/rps/all', employee.rp, 'object', 'rpsData' + employee.rp);
            querys.capturedBy = ListsF.loadList('profiles', 'lists/profiles/all', AppF.profile.uid, 'object', 'profilesData' + AppF.profile.uid);
            if (angular.isObject(employee.created) && angular.isDefined(employee.created.by)) {
                querys.createdBy = ListsF.loadList('profiles', 'lists/profiles/all', employee.created.by, 'object', 'profilesData' + employee.created.by);
            }
            var createdByAccount = $filter('pathInObj')(employee, 'data.cards.0.created.by');
            if (createdByAccount !== false) {
                querys.createdByAccount = ListsF.loadList('profiles', 'lists/profiles/all', createdByAccount, 'object', 'profilesData' + createdByAccount);
            }
            if (employee.data.position) { querys.positionName = ListsF.loadList('positions', 'lists/positions/all', employee.data.position, 'object', 'positionsData'); }

            if (angular.isArray(employee.data.cards) && employee.data.cards.length > 0) {
                if (employee.data.cards[0].bank && employee.data.cards[0].bank.length > 20) {
                    querys.bank = DataF.api.get('banks/' + employee.data.cards[0].bank);
                }
            }
            if (employee.data.info) {
                if (employee.data.info.residence) {
                    if (employee.data.info.residence.address) {
                        if (employee.data.info.residence.address.streetType) { querys.streetType = DataF.api.get('streetTypes/' + employee.data.info.residence.address.streetType); }
                    }
                    if (employee.data.info.residence.state) { querys.state = DataF.api.get('states/' + employee.data.info.residence.state); }
                    if (employee.data.info.residence.town) { querys.town = DataF.api.get('towns/' + employee.data.info.residence.town); }
                }
            }

            var employeeEntityKey = getEntityKeyFromCurpFilter(employee.data.curp);
            querys.entity = DataF.api.get('states', {
                'key': employeeEntityKey
            });
            $q.all(querys).then(function (allData) {
                var allGood = true;
                plainData.center = AppF.center;
                plainData.payroll = allData.payroll;
                plainData.firmName = allData.firmName.name;
                plainData.ccName = allData.ccName.name;
                plainData.rpName = allData.rpName.name;
                plainData.capturedBy = allData.capturedBy.name;
                if (allData.createdBy) {
                    plainData.createdBy = allData.createdBy.name;
                } else {
                    plainData.createdBy = '';
                }
                if (angular.isDefined(allData.createdByAccount) && angular.isDefined(allData.createdByAccount.name)) {
                    plainData.createdByAccount = allData.createdByAccount.name;
                } else {
                    plainData.createdByAccount = '';
                }
                plainData.createdAtAccount = $filter('date')(new Date().valueOf(), 'dd-MM-yyyy HH:mm:ss');
                $log.log(plainData.createdAtAccount, plainData.createdByAccount);
                plainData.positionName = (allData.positionName) ? allData.positionName.name : 'N/A';
                if (allData.entity) {
                    if (allData.entity.data) {
                        if (allData.entity.data[0]) { plainData.entityName = allData.entity.data[0].name; }
                    } else {
                        plainData.entityName = 'N/A';
                    }
                } else {
                    plainData.entityName = 'N/A';
                }
                if (allData.bank) {
                    if (querys.bank && allData.bank.data) {
                        plainData.bankName = allData.bank.data.name;
                    }
                } else {
                    plainData.bankName = 'N/A';
                }

                if (allData.streetType) {
                    if (allData.streetType.data) { plainData.streetTypeName = allData.streetType.data.name; }
                } else {
                    plainData.streetTypeName = 'N/A';
                }
                if (allData.state) {
                    if (allData.state.data) { plainData.stateName = allData.state.data.name; }
                } else {
                    plainData.stateName = 'N/A';
                }
                if (allData.town) {
                    if (allData.town.data) { plainData.townName = allData.town.data.name; }
                } else {
                    plainData.townName = 'N/A';
                }
                var subQuerys = {};
                subQuerys.paymentFrequenciesRecordName = DataF.api.get('paymentFrequenciesRecords/' + plainData.payroll.paymentFrequency);
                plainData.realClass = plainData.styles.hidden;
                plainData.fiscalClass = '';
                plainData.complementsClass = '';
                if (plainData.payroll) {
                    if (allData.rpName.rp !== '00000000000') {
                        subQuerys.issuerFiscal = $filter('getPayrollIssuer')(employee.payroll, 'fiscal', getFromObjectFilter(employee, 'data.cards.0.emit') ? 'emit' : 'register');
                    }
                    subQuerys.issuerC = $filter('getPayrollIssuer')(employee.payroll, 'socialPrevision', getFromObjectFilter(employee, 'data.cards.0.emit') ? 'emit' : 'register');
                } else {
                    promise.reject(employee.data.name + ' le falta nómina');
                    allGood = false;
                }
                if (allGood) {
                    $q.all(subQuerys).then(function (allSubData) {
                        var issuerFiscal, issuerC = '';
                        if (angular.isDefined(allSubData.issuerFiscal)) {
                            var issuerFiscalArray = [];
                            $filter('loopEach')(allSubData.issuerFiscal, function (data) {
                                issuerFiscalArray.push(data);
                            });
                            issuerFiscal = issuerFiscalArray.toString();
                        }
                        if (angular.isDefined(allSubData.issuerC)) {
                            var issuerCArray = [];
                            $filter('loopEach')(allSubData.issuerC, function (data) {
                                issuerCArray.push(data);
                            });
                            issuerC = issuerCArray.toString();
                        }
                        plainData.issuerFiscal = issuerFiscal;
                        plainData.issuerComplements = issuerC;
                        promise.resolve(plainData);
                    }, function (err) {
                        promise.reject(err);
                    });
                }
            }, function (err) {
                promise.reject(err);
            });
            return promise.promise;
        };
    }

}());
(function() {
    'use strict';

    angular
        .module('app.employees')
        .filter('getDateMdsAniversary', getDateMdsAniversary)

    function getDateMdsAniversary(orderByFilter) {

        return getDateMdsAniversaryFn;

        function getDateMdsAniversaryFn(employee) {

            var today = moment();
            var dateToReturn = today.valueOf();
            var enroleDate = moment(employee.data.enroleDate);
            var years = today.diff(enroleDate, 'years');
            //console.log(years);
            enroleDate.add(years, "years");
            var lastMovementDate = 0;
            angular.forEach(employee.movements, function(movement) {
                if(lastMovementDate>movement.d){
                    lastMovementDate=movement.d;
                }
            })
            if (parseFloat(lastMovementDate) > enroleDate.valueOf()) {
                dateToReturn = parseFloat(lastMovementDate);
            } else {
                dateToReturn = enroleDate.valueOf();
            }
            return dateToReturn;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('getCreditDataObjects', getCreditDataObjects);

    function getCreditDataObjects($q, AppF, $filter, DataF) {

        return function (credit) {
            var promise = $q.defer();
            var queries = {};
            var plainData = {};
            // acc settings
            plainData.styles = {
                td: 'border-bottom: 1px dotted #282c37; margin-right: 5px; margin-bottom: 5px; padding: 0px !important; ',
                strong: 'font-weight: 600;',
                br: 'line-height: 5px',
                hidden: 'display: none !important; visibility: hidden !important;'
            };
            // salaries
            plainData.realSpan = 1;
            plainData.credit = angular.copy(credit);
            // console.log(credit);
            queries.payrollName = AppF.root.child('lists/payrolls/all').child(credit.payroll).child('name').once('value');
            queries.payrollPaymentFrequency = AppF.root.child('catalogs/payrolls/collection/' + credit.payroll + '/paymentFrequency').once('value');
            queries.createdBy = AppF.root.child('profiles').child(credit.created.by).child('data/name').once('value');
            queries.capturedBy = AppF.root.child('profiles').child(AppF.profile.uid).child('data/name').once('value');
            queries.ccName = AppF.root.child('lists/ccs/all').child(credit.cc).child('name').once('value');
            queries.rpName = AppF.root.child('lists/rps/all').child(credit.rp).child('name').once('value');
            queries.employeeHealthBenefit = AppF.root.child('catalogs/employees/collection').child(credit.employee).child('data/health/benefit').once('value');
            queries.employeeNss = AppF.root.child('catalogs/employees/collection').child(credit.employee).child('data/nss').once('value');
            queries.employeeName = AppF.root.child('catalogs/employees/collection').child(credit.employee).child('data/name').once('value');
            queries.employeeCurp = AppF.root.child('catalogs/employees/collection').child(credit.employee).child('data/curp').once('value');
            queries.employeeNumber = AppF.root.child('catalogs/employees/collection').child(credit.employee).child('data/employeeNumber').once('value');
            $q.all(queries).then(function (allData) {
                plainData.center = AppF.center;
                plainData.payrollName = allData.payrollName.val();
                plainData.createdBy = allData.createdBy.val();
                plainData.capturedBy = allData.capturedBy.val();
                plainData.employeeName = allData.employeeName.val();
                if (plainData.employeeName) {
                    plainData.employeeNss = allData.employeeNss.val();
                    plainData.employeeCurp = allData.employeeCurp.val();
                    plainData.employeeNumber = allData.employeeNumber.val();
                    plainData.employeeEnsured = plainData.employeeNss ? 'SI' : 'NO';
                    plainData.employeeHealthBenefit = allData.employeeHealthBenefit.val() ? 'SI' : 'NO';
                    plainData.ccName = allData.ccName.val();
                    plainData.rpName = allData.rpName.val();
                    plainData.creditSd = $filter('currency')(credit.data.sd);
                    plainData.creditSbc = $filter('currency')(credit.data.sbc);
                    plainData.creditSdr = $filter('currency')(credit.data.sdr);
                    plainData.creditDate = $filter('date')(credit.data.date, 'dd-MM-yyyy');
                    if (!plainData.credit.data.sd || angular.isUndefined(plainData.credit.data.sd)) {
                        plainData.sdClass = plainData.styles.hidden;
                        plainData.realSpan++;
                    }
                    if (!plainData.credit.data.sbc || (angular.isDefined(plainData.credit.salary) && angular.isUndefined(plainData.credit.salary.sbc))) {
                        plainData.sbcClass = plainData.styles.hidden;
                        plainData.realSpan++;
                    }
                }
                var promises = [];
                if (allData.payrollPaymentFrequency && allData.payrollPaymentFrequency.exists()) {
                    promises.push(DataF.api.get('paymentFrequenciesRecords/' + allData.payrollPaymentFrequency.val()))
                }
                return Promise.all(promises);
            }).then(function (resp) {
                console.log(resp[0].data);
                if (resp.length > 0 && resp[0].data.name) {
                    plainData.paymentFrequenciesRecordName = resp[0].data.name;
                }
                promise.resolve(plainData);
            }).catch(promise.reject);
            return promise.promise;
        };
    }

}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('getCompoundData', getCompoundData);

    function getCompoundData() {
        return getCompoundDataFn;

        function getCompoundDataFn(dataArray) {
            var finalName;
            if (angular.isArray(dataArray) && dataArray.length > 0) {
                var objArray = [];
                for (var d = 0; d < dataArray.length; d++) {
                    if (angular.isString(dataArray[d]) && dataArray[d].trim() !== '') {
                        objArray.push(dataArray[d].trim());
                    }
                }
                if (objArray.length > 0) {
                    finalName = objArray.join(' ');
                }
            }
            return finalName;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('filterUserCcs', filterUserCcs)

    function filterUserCcs(
        getArrayOfIdsFilter
    ) {

        return filterUserCcsFn;

        function filterUserCcsFn(ccs, userCcs) {
            var filteredCcs = [];
            var userCcsArray = getArrayOfIdsFilter(userCcs);
            if (angular.isArray(ccs)) {
                for (var c = 0; c < ccs.length; c++) {
                    if (userCcsArray.indexOf(ccs[c].$id) !== -1) {
                        filteredCcs.push(ccs[c]);
                    }
                }
            }
            return filteredCcs;
        }
    }

}());
(function(){
    'use strict';

    angular
        .module('app.employees')
        .filter('filterPayrollEmployees', filterPayrollEmployees)

    function filterPayrollEmployees(getArrayOfIdsFilter){

        return filterPayrollEmployeesFn;

        function filterPayrollEmployeesFn(employees, payrolls){
            var filtered = [];
            //console.log('filtering employees of payrolls', employees, payrolls);
            var payrollsIds = getArrayOfIdsFilter(payrolls);
            for(var e in employees){
                var employee = employees[e];
                if(employee.hasOwnProperty('$id') && payrollsIds.indexOf(employee.payroll) !== -1){
                    filtered.push(employee);
                }
            }

            return filtered;
        }
    }

}());
(function(){
    'use strict';

    angular
        .module('app.core')
        .filter('filterGroupUsers', filterGroupUsers)

    function filterGroupUsers(
        getArrayOfKeysFilter
    ){

        return filterGroupUsersFn;

        function filterGroupUsersFn(users, groupUsers, idP){
            var usersFiltered = {};
            var groupUsersArray = getArrayOfKeysFilter(users, idP);
            for(var userId in groupUsers){
                if(groupUsersArray.indexOf(userId) !== -1) usersFiltered[userId] = true;
            }

            return usersFiltered;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.employees')
        .filter('employeeStatusName', employeeStatusName)

    function employeeStatusName(
        typeNameFilter,
        capitalizeFilter,
        AppF
    ) {

        return employeeStatusNameFn;

        function employeeStatusNameFn(employee, to) {
            var statusName = '';
            var movement = employee.movement;
            if (movement) {
                var typeName = capitalizeFilter(typeNameFilter(movement.type));
                switch (employee.status) {
                    default: statusName = 'S/M';
                        break;
                    case 1:
                        if (to) {
                            if (AppF.centers.indexOf(to) > -1) {
                                statusName = 'solicita la revisión de ' + typeName + ' de';
                            } else if (to == 'client') {
                                statusName = 'ha enviado ' + typeName + ' a revisión de';
                            }
                        } else {
                            statusName = 'Revisando ' + typeName;
                        }
                        break;
                    case 2:
                        if (to) {
                            if (AppF.centers.indexOf(to) > -1) {
                                statusName = 'solicita el envio de ' + typeName + 'a IMSS de';
                            } else if (to == 'client') {
                                statusName = 'ha enviado ' + typeName + ' a IMSS de';
                            }
                        } else {
                            statusName = 'Enviando ' + typeName + ' a IMSS';
                        }
                        break;
                    case 2.1:
                        if (to) {
                            if (AppF.centers.indexOf(to) > -1) {
                                statusName = 'solicita el envio de variable a IMSS de';
                            } else if (to == 'client') {
                                statusName = 'ha enviado variable a IMSS de';
                            }
                        } else {
                            statusName = 'Enviando variable a IMSS';
                        }
                        break;
                    case 3:
                        if (to) {
                            if (AppF.centers.indexOf(to) > -1) {
                                statusName = 'solicita la recepción de ' + typeName + ' de IDSE de';
                            } else if (to == 'client') {
                                statusName = 'ha enviado ' + typeName + ' para recepción de IDSE de'
                            }
                        } else {
                            statusName = 'Recibiendo ' + typeName + ' de IDSE';
                        }

                        break;
                    case 3.5:
                        if (to) {
                            if (AppF.centers.indexOf(to) > -1) {
                                statusName = 'se rechazo de IDSE el ' + typeName + ' de'
                            } else if (to == 'client') {
                                statusName = 'se rechazo de IDSE el ' + typeName + ' de'
                            }
                        } else {
                            statusName = 'Movimiento de ' + typeName + ' rechazado de IDSE';
                        }

                        break;
                    case 4:
                        if (to) {
                            statusName = 'ha concluido el ' + typeName + ' de'
                        } else {
                            statusName = 'OK';
                        }

                        break; // Registro liberado
                    case 5:
                        if (to) {
                            statusName = 'ha concluido la ' + typeName + ' de'
                        } else {
                            statusName = 'Dado de Baja';
                        }
                        break;

                }
            } else {
                // $log.debug(employee, "no movements");
                statusName = 'sin mov'
            }

            return statusName;
        }
    }

}());
(function(){
    'use strict';

    angular
        .module('app.employees')
        .filter('clientOfPayroll', clientOfPayroll)

    function clientOfPayroll(){

        return clientOfPayrollFn;

        function clientOfPayrollFn(payrollId, payrolls){
            var client = false;
            for(var p in payrolls){
                if(payrolls[p].$id == payrollId){
                    client = payrolls[p].firm;
                    break;
                }
            }
            return client;
        }
    }

}());
/**
 * Validate empty fields and after show modal
 * @param {Object} form - Array object of the data of form 
 * @param {event} event - Action event click 
 */
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('checkValidFieldsModal', checkValidFieldsModal)

    function checkValidFieldsModal($rootScope, $mdDialog, $log, $filter) {

        return checkValidFieldsModalFn;

        function checkValidFieldsModalFn(event, form) {
            try {
                var data = [];
                var value = {}
                var input;
                var label;
                var valid = form.$error;
                for (var key in valid) {
                    var items = valid[key];
                    for (var i = 0; i < items.length; i++) {
                        if (!items[i].$valid) {
                            input = items[i].$name;
                            if (items[i].$$element["context"].previousElementSibling !== null) {
                                var thisElement = items[i].$$element["context"].previousElementSibling;
                                label = thisElement.innerText || thisElement.textContent || thisElement.innerHTML;
                                data.push({ "input": input, "label": label });
                            }
                        }
                    }
                }
                var result = data.filter(function (x) {
                    if (value[x.input]) return false;
                    value[x.input] = true;
                    return true;
                });

                if (result.length > 0) {
                    $rootScope.items = $filter('orderBy')(result, 'label');
                } else {
                    $rootScope.items = [{ info: "Hay campos pendientes, favor de verificar" }];
                }
                $mdDialog.show({
                    parent: angular.element(document.body),
                    targetEvent: event,
                    template:
                        '<md-dialog aria-label="List dialog">' +
                        '  <md-dialog-content style="padding-bottom:0px; padding-top: 15px;">' +
                        '    <div><b>Campos requeridos</b></div>' +
                        '    <ul style="margin-bottom: 0px;">' +
                        '      <li ng-repeat="item in items">' +
                        '           {{(item.label)?"El campo ["+item.label+"] es requerido":item.info}}' +
                        '      </li>' +
                        '    </ul>' +
                        '  </md-dialog-content>' +
                        '  <md-dialog-actions>' +
                        '    <md-button ng-click="closeDialog()" class="md-primary md-button md-tds-theme md-ink-ripple md-raised">' +
                        '      CERRAR' +
                        '    </md-button>' +
                        '  </md-dialog-actions>' +
                        '</md-dialog>',
                    locals: {
                        items: $rootScope.items
                    },
                    controller: function DialogController($scope, $mdDialog, items) {
                        $scope.items = items;
                        $scope.closeDialog = function () {
                            $mdDialog.hide();
                        }
                    }
                });
            } catch (error) {
                $log.error(error);
            }
        }
    }
}());
(function() {
    'use strict';

    angular
        .module('app.core')
        .filter('checkSbc', checkSbc)

    function checkSbc(DataF) {

        return checkSbcFn;

        function checkSbcFn(employees, doIt) {
            return new Promise(function(resolve, reject) {
                var obj = {
                    flag: false,
                    msg: ''
                }
                var requests = {};

                if (!doIt) {
                    resolve(obj)
                } else {
                    var request = [];
                    for (var e in employees) {
                        var employee = employees[e];
                        var query = {};
                        query.page = 1;
                        query.size = 1;
                        query.sort = "-data.date";
                        query.status = 4;
                        query.employee = employee.$id;
                        request.push(DataF.api.get('p/movements', query));
                    }
                    Promise.all(request).then(function(resp) {
                        var sameFounded = [];
                        for (var e in employees) {
                            var employee = employees[e];
                            var lastMovements = resp[e].data.data;
                            if (lastMovements.length) {
                                var lastMovement = lastMovements[0];
                                if (lastMovement.data.type != 2) {
                                    if (employee.data.salary.sbc == lastMovement.data.sbc) {
                                        obj.flag = true;
                                        sameFounded.push(employee);
                                    }
                                }
                            }
                        }
                        obj.msg = 'Estos empleados tienen el mismo sbc que su movimiento anterior:<ul>';
                        for (var s in sameFounded) {
                            employee = sameFounded[s];
                            obj.msg += ('<li>' + employee.data.name + '</li>');
                        }
                        obj.msg += '</ul>';
                        resolve(obj);
                    }).catch(function(error) {
                        reject(error)
                    })
                }
            })
        }
    }

}());
(function(){
    'use strict';

    angular
        .module('app.core')
        .filter('checkSameRP', checkSameRP)

    function checkSameRP(){

        return checkSameRPFn;

        function checkSameRPFn(records){
            var rp = false;
            var sameRP = true;
            for (var i = 0; i < records.length; i++) {
                if (rp === false) {
                    rp = records[i].rp;
                } else {
                    if (rp != records[i].rp) {
                        sameRP = false;
                    }
                }

            }
            return sameRP;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.core')
        .filter('checkSameField', checkSameField)

    function checkSameField(pathInObjFilter) {

        return checkSameFieldFn;

        function checkSameFieldFn(records, field) {
            var fieldValue;
            var sameField = true;
            for (var i = 0; i < records.length; i++) {
                var record = records[i];
                var thisValue = pathInObjFilter(record, field);
                if (typeof(fieldValue) === "undefined") {
                    fieldValue = thisValue;
                }
                if (fieldValue !== thisValue) {
                    sameField = false;
                }
            }
            return sameField;
        }
    }

}());
/**
 * Returns promises
 * @param {Object} data - List employees 
 * @param {Object} data.movement.type - validate the type of movement "Type 7" of the item employees
 * @returns {object}  Promises 
 */
(function() {
    'use strict';
    angular
        .module('app.core')
        .filter('checkMovementPrevious', checkMovementPrevious)

    function checkMovementPrevious(AppF,orderByFilter) {

        return checkMovementPreviousFn;

        function checkMovementPreviousFn(data) {
            return new Promise(function (resolve, reject) {
                var thisMovements = [];
                var promises = [];
                var employeesId = [];
                for (var i = 0; i < data.length; i++) {
                    if (data[i].movement.type === 7) {
                        thisMovements = [];
                        var mov = data[i].movements;
                        for (var key in mov) {
                            var movementValue = {};
                            movementValue.idMovement = key;
                            movementValue.values = mov[key];
                            movementValue.employee = data[i].$id;
                            thisMovements.push(movementValue);    
                        }
                        var order = orderByFilter(thisMovements, "values.d");
                        var idMovement = order[order.length - 2].idMovement;
                        promises.push(AppF.root.child("catalogs/movements/collection/" + idMovement + "/data/sd").once('value'));
                        employeesId.push(data[i].$id);                
                    }
                }
                Promise.all(promises).then(function (resp) {
                    var obj = {};
                    for (var i = 0; i < resp.length; i++){
                        if (resp[i].exists()) {
                            obj[employeesId[i]] = resp[i].val();
                        }
                    }
                    resolve(obj); 
                }).catch(function (error) {
                    reject(error);
                });
            });

          
        }
    }
}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('checkLayout', checkLayout);

    function checkLayout($log, MongoF, getSomethingOfArrayMFilter, loopEachFilter) {
        return checkLayoutFn;

        function checkAction(action, thisEmployee) {
            var thisAction = thisEmployee.data.cards[0].emit ? 'Emitir' : 'Registrar';
            action = angular.isDefined(action) ? action : thisAction;
            if (action !== thisAction) {
                thisAction = false;
            }
            return thisAction;
        }
        function checkBank(thisEmployee, bank) {
            var bankFounded = false;
            var index = thisEmployee.data.cards.findIndex(function (value) {
                return value.emmitedYet === false;
            });
            if (index === -1) {
                index = 0;
            }
            var thisCard = thisEmployee.data.cards[index];
            var process = thisCard.process || 'fiscal';
            var bankAccounts = [];
            loopEachFilter(thisEmployee['payroll2-processes'], function (data) {
                if (process === data.id && angular.isArray(data.bankAccounts)) {
                    bankAccounts = data.bankAccounts;
                }
            });
            bankFounded = loopAccount(bank, bankAccounts, thisCard.bank);
            return bankFounded;
        }
        function loopAccount(bank, bankAccounts, employeeBankId) {
            var bankFounded = false;
            for (var t = 0; t < bankAccounts.length && !bankFounded; t++) {
                var bankAccountId = bankAccounts[t];
                var bankId = getSomethingOfArrayMFilter(bankAccountId, MongoF.bankAccounts, 'bank');
                var couldEmmit = getSomethingOfArrayMFilter(bankAccountId, MongoF.bankAccounts, 'couldEmmit');
                if (bankId === bank._id && couldEmmit && employeeBankId === bankId) {
                    bankFounded = true;
                }
            }
            return bankFounded;
        }
        function checkLayoutFn(employees, bank, returnMsg) {
            var problems = false;
            var action;
            var msg;
            for (var i = 0; i < employees.length && !problems; i++) {
                var thisEmployee = employees[i];
                var hasProccess = angular.isDefined(thisEmployee['payroll2-processes']);//Se valida si tiene procesos con cuentas la nomina
                if (hasProccess) {
                    action = checkAction(action, thisEmployee);//Se valida que la accion de los empleados sea la misma
                    if (angular.isString(action) && action === 'Emitir') {
                        var hasBank = checkBank(thisEmployee, bank);//se valida que el empleado tenga configurado el banco que se eta validando asi como que se puede emitir desde este banco
                        if (!hasBank) {
                            problems = true;
                            msg = 'Los procesos configurados no pertenecen a ' + bank.name + ' o esta cuenta no puede emitir';
                        }
                    } else {
                        problems = true;
                        msg = 'Alguno de los empleados no son para emitirlos';
                    }
                } else {
                    problems = true;
                    msg = 'La nomina del algún empleado no tiene los procesos configurados';
                }
            }
            if (returnMsg && problems) {
                return msg;
            }
            return !problems;
        }
    }

}());
/**
 * Returns message and reponse
 * @param {Object} employee - List employees 
 * @param {String} employeeId - Id employee
 * @returns {Promise}  
 * 1 : Se revisó y aprobó movimiento con éxito y se generaron las incidencias pendientes de pago automáticamente
 * 2 : Se revisó y aprobó movimiento con éxito pero no se generaron las incidencias pendientes de pago automáticamente, hacer manual esta operación
 * 3 : Se revisó y aprobó movimiento con éxito
 * 4 : No se encontraron calendarios para el empleado
 * 5 : No se encontraron operaciones abiertas para este empleado
 * 6 : Se revisó y aprovó movimiento con éxito pero no se modificaron las incidencias pendientes de pago, checar esto manualmente
 * 7 : Se revisó y aprovó movimiento con éxito pero no se eliminaron las incidencias pendientes de pago porque ya se encuentra en un periodo cerrado
 */
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('checkForAddingPendingDays', checkForAddingPendingDays)

    function checkForAddingPendingDays(AppF, $rootScope, $log, $mdDialog, confirmConfig, DataF) {

        return checkForAddingPendingDaysFn;

        function checkForAddingPendingDaysFn(employee, employeeId, movementId) {
            return new Promise(function (resolve) {
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
                deleteListOfIncidences(employee, movementId).then(function (response) {
                    if (response === 1) {
                        resolve(7);
                    } else {
                        return checkOperations(employee, employee.movement.date);
                    }
                }).then(function (resp) {
                    if (angular.isDefined(resp) && resp.needGenerateDays) {
                        $mdDialog.show(
                            $mdDialog.confirm(confirmConfig)
                                .title('Desea generar incidencias pendientes de pago para este empleado ' + employee.data.name + '?')
                                .ariaLabel('cancel movement')
                                .targetEvent(event)
                                .ok('Si')
                                .cancel('No'))
                            .then(function () {
                                resolve(tryToaddIncidences(employee, employeeId, resp));
                            }, function () {
                                resolve(2);
                            });
                    } else {
                        if (resp === 4 || resp === 5) {
                            resolve(resp);
                        } else {
                            resolve(3);
                        }
                    }
                }).catch(function (error) {
                    $log.error(error);
                    resolve(6);
                });

            });
        }
        /**
         * Returns reponse
         * @param {Object} employee - Data employees 
         * @param {String} movementId - Id employee
         * @returns {Promise}  boolean, number, string
         */
        function deleteListOfIncidences(employee, movementId) {
            return new Promise(function (resolve, reject) {
                DataF.models.action('incidences', 'gufDeleteIncidencesFromMov', {
                    movementId: movementId,
                    typeEvent: 'PreviousDeleteIncidences',
                    status: employee.movement.type
                }).then(function (response) {
                    if (response.data.message === true || response.data.message === 1) {
                        resolve(response.data.message);
                    } else {
                        resolve("Se guardó el Empleado y Movimiento con éxito pero no se pudo eliminar las incidencias anteriores");
                    }
                }).catch(function (err) {
                    reject(err);
                });
            })
        }
        function checkOperations(employee, date) {
            return new Promise(function (resolve, reject) {
                //resolve true or false //reject errors
                var resp = {
                    //calendar
                    periods: [],
                    operations: [],
                    needGenerateDays: false
                };
                AppF.root.child('catalogs/payrollCalendars/' + employee.payroll + '/calendars').orderByChild('data/endDate').startAt(date).limitToFirst(1).once('value').then(function (response) {
                    var calendars = response.val();
                    var queryOperations;
                    for (var key in calendars) {
                        var data = calendars[key].data;
                        if (date >= data.startDate && date <= data.endDate) {
                            resp.calendar = data;
                            queryOperations = AppF.root.child('catalogs/operations/ordinary/' + employee.payroll + '/' + data.year + '/collection').orderByChild('status').startAt(1).limitToFirst(1).once("value");
                        }
                    }
                    if (typeof (queryOperations) !== "undefined") {
                        return queryOperations;
                    } else {
                        resolve(4);
                    }
                }).then(function (snapsOperatios) {
                    var operationsQueries = [];
                    snapsOperatios.forEach(function (child) {
                        var operation = child.val();
                        operation.$id = child.key;
                        if (operation.status > 0 && operation.status < 3) {
                            resp.operations.push(operation);
                            operationsQueries.push(AppF.root.child('catalogs/payrollCalendars/' + employee.payroll + '/periods/' + operation.calendar).orderByChild('period').equalTo(operation.period).once('value'));
                        }
                    });
                    if (operationsQueries.length > 0) {
                        return Promise.all(operationsQueries);
                    } else {
                        resolve(5);
                    }
                }).then(function (response) {
                    for (var r = 0; r < response.length; r++) {
                        var snap = response[r];
                        snap.forEach(function (data) {
                            var period = data.val();
                            resp.periods.push(period);
                            if (date < period.start) {
                                resp.needGenerateDays = true;
                            }
                        });
                    }
                    resolve(resp);
                }).catch(function (error) {
                    reject(error);
                });
            });
        }

        function addIncidences(employee, employeeId, cpoData) {
            return new Promise(function (resolve, reject) {
                var nextPeriod;
                var nextCalendar;
                var promises = [];
                if (typeof (cpoData.periods[0].period) !== "undefined") {
                    nextPeriod = cpoData.periods[0].period;
                    nextCalendar = cpoData.calendar.year;
                } else {
                    var nextDayOfPeriod = moment(cpoData.periods[0].end).add(1, "day").valueOf();
                    promises.push(checkOperations(employee, nextDayOfPeriod));
                }
                Promise.all(promises).then(function (resp) {
                    if (resp.length > 0) {
                        if (resp[0].periods.length > 0) {
                            nextPeriod = cpoData.periods[0].period;
                            nextCalendar = cpoData.calendar.year;
                        }
                    }
                    if (angular.isDefined(nextPeriod)) {
                        AppF.root.child('catalogs/incidencesTypes/collection').orderByChild('fdd').equalTo(true).once('value').then(function (snap) {
                            if (snap.exists()) {
                                var typeIncidence;
                                snap.forEach(function (childSnap) {
                                    if (childSnap.val().center === AppF.center) {
                                        typeIncidence = childSnap.key;
                                    }
                                });
                                var dateEndPeriod = cpoData.periods[0].start;
                                var differenceOfDays = moment(dateEndPeriod).diff(moment(employee.movement.date), 'days');
                                if (angular.isDefined(typeIncidence)) {
                                    var valueIncidencesRequests = {};
                                    var updatesIncidences = {};
                                    var msg = (employee.movement.type == 6) ? "Incidencias automática generada por Alta" : "Incidencias automática generada por Reingreso";
                                    var keyFB = AppF.root.child('catalogs/incidencesRequests/collection').push().key;
                                    for (var i = 0; i < differenceOfDays; i++) {
                                        var moreDays = i;
                                        var days = moment(employee.movement.date).add(moreDays, 'days');
                                        var Refid = AppF.root.child('catalogs/incidencesRequests/collection').push().key;
                                        valueIncidencesRequests[Refid] = {
                                            c: msg,
                                            d: days.valueOf(),
                                            e: employeeId,
                                            it: typeIncidence,
                                            p: nextPeriod,
                                            s: 0,
                                            v: 1,
                                            y: nextCalendar
                                        }
                                        updatesIncidences["incidences/" + employee.payroll + "/" + nextCalendar + "/" + Refid] = {
                                            automaticAsignation: true,
                                            calendar: nextCalendar,
                                            created: DataF.getTimeObject(),
                                            date: days.valueOf(),
                                            comments: msg,
                                            employee: employeeId,
                                            incidenceType: typeIncidence,
                                            payroll: employee.payroll,
                                            period: nextPeriod,
                                            request: keyFB,
                                            status: 0,
                                            type: "request",
                                            value: 1,
                                            bySystem: true
                                        }
                                        updatesIncidences["catalogs/movements/collection/" + employee.movement.uid + "/data/i/" + Refid] = true;
                                    }
                                    var incidencesRequests = {
                                        allPayroll: 0,
                                        applied: 0,
                                        automaticAsignation: true,
                                        calendar: nextCalendar,
                                        comments: msg,
                                        created: DataF.getTimeObject(),
                                        date: employee.movement.date,
                                        incidenceType: typeIncidence,
                                        incidences: valueIncidencesRequests,
                                        payroll: employee.payroll,
                                        period: nextPeriod,
                                        status: 0,
                                        value: differenceOfDays
                                    };

                                    updatesIncidences["catalogs/movements/collection/" + employee.movement.uid + "/data/ir/" + keyFB] = {
                                        py: employee.payroll,
                                        y: nextCalendar
                                    };
                                    updatesIncidences["catalogs/incidencesRequests/collection/" + keyFB] = incidencesRequests;
                                    AppF.root.update(updatesIncidences).then(function () {
                                        resolve(1);
                                    }).catch(function (error) {
                                        reject("No se pudo agregar los datos, error de comunicacion");
                                        $log.debug(error);
                                    });
                                } else {
                                    throw "No se encontro la incidencia para dias pendientes de pago";
                                }
                            } else {
                                reject("No se pudo obtener los catalogos de los tipos de incidencias, por favor intente más tarde");
                            }
                        }).catch(function (error) {
                            $log.error(error);
                            throw "Error al consultar la incidencia para dias pendientes de pago";
                        });
                    } else {
                        throw "No existen mas periodos disponibles para las incidencias";
                    }
                }).catch(function (error) {
                    if (angular.isString(error)) {
                        reject(error);
                    } else {
                        $log.error(error);
                        reject("No se pudo agregar las incidencias, hubo un error");
                    }
                });
            });
        }

        function tryToaddIncidences(employee, employeeId, cpoData, counter, event, showModal, msg) {
            return new Promise(function (resolve) {
                //resolve 
                counter = angular.isDefined(counter) ? counter + 1 : 1;
                if (counter > 10) {
                    resolve(2);
                }
                var promises = [];
                if (showModal) {
                    promises.push(
                        $mdDialog.show($mdDialog
                            .confirm(confirmConfig)
                            .title(msg)
                            .ariaLabel('Confirm Action')
                            .targetEvent(event)
                            .ok('Reintentar')
                            .cancel('Ok')
                        )
                    );
                }
                Promise.all(promises).then(function () {
                    addIncidences(employee, employeeId, cpoData).then(function () {
                        resolve(1);
                    }).catch(function (error) {
                        resolve(tryToaddIncidences(employee, employeeId, cpoData, counter, event, true, error));
                    });
                }).catch(function () {
                    resolve(2);
                });
            });
        }
    }
}());
(function(){
    'use strict';

    angular
        .module('app.core')
        .filter('checkEnsure', checkEnsure)

    function checkEnsure(
        getSomethingOfArrayFBFilter
    ){
        return checkEnsureFn;

        function checkEnsureFn(employees, rps){
            var hasEnsure = true;
            for (var i = 0; i < employees.length; i++) {
                if (typeof(employees[i].data.nss) == "undefined") {
                    hasEnsure=false;
                }
            }
            return hasEnsure;
        }
    }

}());
/**
 * Returns message and reponse
 * @param {Object} data - List employees 
 * @param {Object} data.movement.type - validate the type of movements of the item
 * @returns {object}  
 */
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('checkDateLow', checkDateLow)

    function checkDateLow(AppF) {

        return checkDateLowFn;

        function checkDateLowFn(data, movements) {
            var resp = false;
            var array = [];
            var result = {};
            var date;
            for (var i = 0; i < data.length; i++) {
                if (data[i].movement.type === 2) {
                    if (data[i].movement.date > AppF.serverTimeStamp) {
                        result.message = "El empleado " + data[i].data.name + " tiene una fecha de baja posterior a la fecha actual";
                        result.response = true;
                        array.push(result);
                    }
                    if (data[i].movement.date < AppF.serverTimeStamp) {
                        date = AppF.holydaysInMexico.getDateOfXLabourDaysSinceNow(5, AppF.serverTimeStamp, undefined, true).date;
                        console.log(data[i].movement.date, AppF.serverTimeStamp, date.valueOf());
                        if (data[i].movement.date < date.valueOf()) {
                            result.message = "El empleado " + data[i].data.name + " tiene una fecha de baja inferior a la minima permitida";
                            result.response = true;
                            array.push(result);
                        }
                    }
                } else if (data[i].movement.type === 6 || data[i].movement.type === 8) {
                    if (data[i].movement.date > AppF.serverTimeStamp) {
                        date = AppF.holydaysInMexico.getDateOfXLabourDaysFromNow(1, AppF.serverTimeStamp).date;
                        if (data[i].movement.date > date.valueOf()) {
                            result.message = "El empleado " + data[i].data.name + " tiene una fecha de alta posterior a la maxima permitida";
                            result.response = true;
                            array.push(result);
                        }
                    }
                    if (data[i].movement.date < AppF.serverTimeStamp) {
                        date = AppF.holydaysInMexico.getDateOfXLabourDaysSinceNow(25, AppF.serverTimeStamp, undefined, true).date;
                        if (data[i].movement.date < date.valueOf()) {
                            result.message = "El empleado " + data[i].data.name + " tiene una fecha de alta inferior a la minima permitida";
                            result.response = true;
                            array.push(result);
                        }
                    }

                } else if (data[i].movement.type === 7) {
                    var sd = movements[data[i].$id];
                    if (angular.isDefined(sd) && sd != null) {
                        if (angular.isDefined(movements)) {
                            if (data[i].data.salary.sd < sd) {
                                date = AppF.holydaysInMexico.getDateOfXLabourDaysSinceNow(4, AppF.serverTimeStamp).date;
                                if (data[i].movement.date < date.valueOf()) {
                                    result.message = "El empleado " + data[i].data.name + " tiene una fecha de mds inferior a la minima permitida";
                                    result.response = true;
                                    array.push(result);
                                }
                            }
                        }
                    } else {
                        result.message = "No se encontró el salario anterior del empleado " + data[i].data.name;
                        result.response = true;
                        array.push(result);
                    }
                }
            }
            if (array.length > 0) {
                resp = array;
            }
            return resp;
        }
    }
}());
(function(){
    'use strict';

    angular
        .module('app.core')
        .filter('checkCardsBelongBanorte', checkCardsBelongBanorte)

    function checkCardsBelongBanorte(){

        return checkCardsBelongBanorteFn;

        /**
         * @description Verifica que los empleados tengan todos tarjetas con iniciación 4915 (Banorte)
         * @param {Employee[]} employees 
         * @returns { problem: Boolean, problems: [employee.data.name...]}
         */
        function checkCardsBelongBanorteFn(employees){
            var problem = false;
            var problems = [];
            for(var e in employees){
                if(employees[e].data){
                    if(employees[e].data.cards){
                        if(employees[e].data.cards[0]){
                            var card = employees[e].data.cards[0].number + '';
                            if(card.substr(0,4) !== '4915'){
                                problem = true;
                                problems.push(employees[e].data.name);
                            }
                        } else problem = true;
                    } else problem = true;
                } else problem = true;
            }
            return {
                problem: problem,
                problems: problems
            }
        }
    }

}());

(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('MinMaxValidationsForMovementOld', MinMaxValidationsForMovementOld);

    function MinMaxValidationsForMovementOld(getFactorFromBenefitsFilter, AppF, $rootScope, ListsF, $filter, $log, errAlertS) {
        return MinMaxValidationsForMovementOldFn;
        //function MinMaxValidationsForMovementOld(employee, greaterSd, movement)
        function MinMaxValidationsForMovementOldFn(employee, movement, benefitConfig, lastApprovedMovement, couldBeTheSame, noValidatePayroll, geoZone, form) {
            var lastMovementPromise;
            var thiss = this;
            if (typeof (lastApprovedMovement) !== 'undefined') {
                thiss.lastApprovedMovement = lastApprovedMovement;
            }
            if (typeof (geoZone) !== 'undefined') {
                thiss.geoZone = geoZone;
            }
            // thiss.minMovementDate;
            // thiss.minEnroleDate;
            // thiss.minDismissDate;
            // thiss.minMdsDate;
            // thiss.maxEnroleDate;
            // thiss.maxDismissDate;
            // thiss.maxMdsDate;

            // thiss.minimumSd;
            // thiss.minimumSBC;
            // thiss.lastSbc;
            // thiss.maxSdOfLastSbc;
            // thiss.factor;

            thiss.setBenefit = function (benefit) {
                benefitConfig = benefit;
            };


            thiss.setDefaults = function (rp) {
                if (rp === '00000000000') {
                    $log.log('Este porque no es fiscal');
                    thiss.minEnroleDate = AppF.holydaysInMexico.getDateOfXLabourDaysSinceNow(25, AppF.serverTimeStamp).date;
                    thiss.maxEnroleDate = AppF.holydaysInMexico.getDateOfXLabourDaysFromNow(5, AppF.serverTimeStamp).date;
                    thiss.minDismissDate = new Date(0);
                    thiss.maxDismissDate = new Date(AppF.serverTimeStamp);
                    thiss.minMdsDate = AppF.holydaysInMexico.getDateOfXLabourDaysSinceNow(15, AppF.serverTimeStamp).date;
                    thiss.maxMdsDate = AppF.holydaysInMexico.getDateOfXLabourDaysFromNow(5, AppF.serverTimeStamp).date;
                    thiss.minMovementDate = AppF.holydaysInMexico.getDateOfXLabourDaysSinceNow(15, AppF.serverTimeStamp).date;
                } else {
                    $log.log('Este porque  es fiscal');
                    thiss.maxEnroleDate = AppF.holydaysInMexico.getDateOfXLabourDaysFromNow(5, AppF.serverTimeStamp).date;
                    thiss.minEnroleDate = AppF.holydaysInMexico.getDateOfXLabourDaysSinceNow(25, AppF.serverTimeStamp).date;
                    thiss.minDismissDate = AppF.holydaysInMexico.getDateOfXLabourDaysSinceNow(5, AppF.serverTimeStamp).date;
                    thiss.maxDismissDate = AppF.holydaysInMexico.getDateOfXLabourDaysFromNow(5, AppF.serverTimeStamp).date;
                    thiss.minMdsDate = AppF.holydaysInMexico.getDateOfXLabourDaysSinceNow(13, AppF.serverTimeStamp).date;
                    thiss.maxMdsDate = AppF.holydaysInMexico.getDateOfXLabourDaysFromNow(5, AppF.serverTimeStamp).date;
                    thiss.minMovementDate = AppF.holydaysInMexico.getDateOfXLabourDaysSinceNow(10, AppF.serverTimeStamp).date;
                }
            };
            thiss.setMinDates = function () {
                if (angular.isDefined(form) && angular.isDefined(form.minDatesValidation)) {
                    form.minDatesValidation.$setValidity('ready', false);
                }
                return new Promise(function (resolve, reject) {
                    $log.log('Setting min dates');
                    var promises = [getLastApprovedMovement(), ListsF.loadList('rps')];
                    Promise.all(promises).then(function (resp) {
                        var rp = $filter('getSomethingOfArrayFB')(employee.rp, resp[1], 'rp', 'N/A');
                        thiss.setDefaults(rp);
                        if (angular.isObject(thiss.lastApprovedMovement) && angular.isObject(thiss.lastApprovedMovement.data)) {
                            var lastMovementDate = thiss.lastApprovedMovement.data.date;
                            var minMovementDate = thiss.lastApprovedMovement.created.bySystem ? lastMovementDate : lastMovementDate + (AppF.oneDay * 1); // + 1 dias en caso de que no sea de sistema el movimieto
                            var minMovementDateMoment = moment(minMovementDate).utc();
                            var minMovementDateObject = new Date(minMovementDateMoment.year(), minMovementDateMoment.month(), minMovementDateMoment.date());
                            if (minMovementDate > thiss.minDismissDate.valueOf()) {
                                thiss.minDismissDate = minMovementDateObject;
                            }
                            if (minMovementDate > thiss.minEnroleDate.valueOf()) {
                                thiss.minEnroleDate = minMovementDateObject;
                            }
                            if (minMovementDate > thiss.minMdsDate.valueOf()) {
                                thiss.minMdsDate = minMovementDateObject;
                            }
                            if (minMovementDate > thiss.minMovementDate.valueOf()) {
                                thiss.minMovementDate = minMovementDateObject;
                            }
                        }
                        if (angular.isDefined(form) && angular.isDefined(form.minDatesValidation)) {
                            form.minDatesValidation.$setValidity('ready', true);
                        }
                        resolve(true);
                    }).catch(function (error) {
                        reject(error);
                    });
                });
            };

            thiss.setMinSalaries = function (currentSd) {
                if (angular.isDefined(form) && angular.isDefined(form.minSalariesValidation)) {
                    form.minSalariesValidation.$setValidity('ready', false);
                }
                return new Promise(function (resolve, reject) {
                    $log.log('Setting min salaries');
                    getLastApprovedMovement().then(function () {
                        var oldDate = employee.hasSeniorityDate ? employee.data.seniorityDate : employee.data.enroleDate;
                        if (!oldDate) {
                            oldDate = new Date().valueOf();
                        }
                        var mDate = new Date().valueOf();
                        if (typeof (movement.data) !== 'undefined' && typeof (movement.data.date) !== 'undefined') {
                            mDate = movement.data.date;
                        }
                        $filter('getMinimumWageOfDate')(mDate).then(function (minimumData) {
                            thiss.minimumVariables = minimumData.minimumVariables;
                            var data = getFactorFromBenefitsFilter(benefitConfig, oldDate, mDate, undefined, true, 'fromMinMax');
                            var factor = data.factor;
                            thiss.b = {
                                f: data.factor,
                                c: data.christmasBonus,//aguinaldo,
                                h: data.daysOfVacation,//vacaciones,
                                p: data.prime,//prima,
                                o: data.othersTotal,//otros,
                                y: data.years, //Años de antiguedad
                                ry: data.realYears //Años de antiguedad reales
                            };
                            $log.log(factor);
                            thiss.factor = factor;
                            if (typeof (movement.data) !== 'undefined' && movement.data.onlySd) {
                                $log.log('Setting sbc, lastSBC, maxSdOfLastSbc and minimunSd of last beacause onlSd');
                                if (angular.isObject(thiss.lastApprovedMovement) && angular.isObject(thiss.lastApprovedMovement.data)) {
                                    thiss.minimumSBC = thiss.lastApprovedMovement.data.sbc;
                                    thiss.lastSbc = thiss.lastApprovedMovement.data.sbc;
                                    if (thiss.lastSbc >= ((minimumData.umaRecord || AppF.umaRecord) * 25)) {
                                        thiss.maxSdOfLastSbc = null;
                                    } else {
                                        thiss.maxSdOfLastSbc = ((thiss.lastSbc / factor).toFixed(2) / 1);
                                    }
                                    // thiss.minimumSd = thiss.lastApprovedMovement.data.sd + 0.01;
                                    thiss.minimumSd = (Math.round(thiss.lastApprovedMovement.data.sd * 100) + 1) / 100;
                                } else {
                                    thiss.minimumSBC = movement.data.sbc;
                                    thiss.lastSbc = movement.data.sbc;
                                    thiss.maxSdOfLastSbc = ((movement.data.sbc / factor).toFixed(2) / 1);
                                    //thiss.minimumSd = movement.data.sd + 0.01;
                                    thiss.minimumSd = (Math.round(movement.data.sd * 100) + 1) / 100;

                                }
                            } else {
                                $log.log('Setting minimumSd to default of A Zone');
                                thiss.minimumSd = employee.data.workDay !== 0 ? 50 : minimumData.minimumVariables[thiss.geoZone.key || 'A'] || AppF.minimumVariables.A;
                                if (angular.isUndefined(thiss.minimumSd) || thiss.minimumSd === null) {
                                    errAlertS("No existe salario minimo establecido para la zona " + thiss.geoZone.name + " del año " + minimumData.minimumVariables.year);
                                }
                                if (angular.isObject(thiss.lastApprovedMovement) && angular.isObject(thiss.lastApprovedMovement.data) && thiss.lastApprovedMovement.payroll === employee.payroll && thiss.lastApprovedMovement.data.sd > thiss.minimumSd && !noValidatePayroll) {
                                    if (couldBeTheSame) {
                                        $log.log('Setting minimunSd to last movement Sd beacause same payroll and is aniversary');
                                        thiss.minimumSd = thiss.lastApprovedMovement.data.sd;
                                    } else {
                                        $log.log('Setting minimunSd to last movement Sd beacause same payroll');
                                        // thiss.minimumSd = thiss.lastApprovedMovement.data.sd + 0.01;
                                        thiss.minimumSd = (Math.round(thiss.lastApprovedMovement.data.sd * 100) + 1) / 100;
                                    }
                                }
                                var sdToCalc = thiss.minimumSd;
                                if (typeof (currentSd) !== 'undefined' && currentSd > sdToCalc) {
                                    sdToCalc = currentSd;
                                }
                                thiss.minimumSBC = $filter('getDinamicSbc')(sdToCalc, factor, lastApprovedMovement, employee.payroll, noValidatePayroll, minimumData.umaRecord, minimumData.minimumVariables[thiss.geoZone.key || 'A'] || AppF.minimumVariables.A);
                                $log.log(thiss.minimumSBC);
                            }
                            if (angular.isDefined(form) && angular.isDefined(form.minSalariesValidation)) {
                                form.minSalariesValidation.$setValidity('ready', true);
                            }
                            resolve(true);
                        }).catch(function (error) {
                            reject(error);
                        });
                    }).catch(function (error) {
                        reject(error);
                    });
                });
            };

            function getLastApprovedMovement() {
                return new Promise(function (resolve, reject) {
                    if (typeof (thiss.lastApprovedMovement) === 'undefined') {
                        var promises = [];
                        if (typeof (lastMovementPromise) === 'undefined' && angular.isObject(employee.movements) && employee.$id) {
                            var queries = {
                                'page': 1,
                                'size': 1,
                                'sort': '-data.date',
                                'employee': employee.$id,
                                'status': {
                                    '$in': [3, 4]
                                }
                            };
                            lastMovementPromise = $rootScope.D.api.get('p/movements', queries);
                        }
                        if (typeof (lastMovementPromise) !== 'undefined') {
                            promises.push(lastMovementPromise);
                        }
                        Promise.all(promises).then(function (resp) {
                            if (resp.length) {
                                var movementResp = resp[0];
                                if (movementResp.data.data.length > 0) {
                                    thiss.lastApprovedMovement = movementResp.data.data[0];
                                } else {
                                    thiss.lastApprovedMovement = false;
                                }
                            } else {
                                thiss.lastApprovedMovement = false;
                            }
                            resolve(thiss.lastApprovedMovement);
                        }).catch(function (error) {
                            reject(error);
                        });
                    } else {
                        resolve(thiss.lastApprovedMovement);
                    }
                });
            }

        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.pages.profile', [])
        .config(config);

    /** @ngInject */
    function config(
        $stateProvider,
        $translatePartialLoaderProvider
    ) {
        $stateProvider.state('app.pages_profile', {
            url: '/pages/profile',
            views: {
                'content@app': {
                    templateUrl: 'app/main/pages/profile/profile.html',
                    controller: 'ProfileController as vm'
                }
            },
            resolve: {
                Timeline: function(msApi) {
                    return msApi.resolve('profile.timeline@get');
                },
                About: function(msApi) {
                    return msApi.resolve('profile.about@get');
                },
                PhotosVideos: function(msApi) {
                    return msApi.resolve('profile.photosVideos@get');
                }
            },
            bodyClass: 'profile'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/profile');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.profile')
        .controller('ProfileController', ProfileController);

    /** @ngInject */
    function ProfileController(Timeline, About, PhotosVideos)
    {
        var vm = this;

        // Data
        vm.posts = Timeline.posts;
        vm.activities = Timeline.activities;
        vm.about = About.data;
        vm.photosVideos = PhotosVideos.data;

        // Methods

        //////////
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.invoice', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        // State
        $stateProvider
            .state('app.pages_invoice_modern', {
                url      : '/pages/invoice/modern',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/invoice/views/modern/modern.html',
                        controller : 'InvoiceController as vm'
                    }
                },
                resolve  : {
                    Invoice: function (msApi)
                    {
                        return msApi.resolve('invoice@get');
                    }
                },
                bodyClass: 'invoice printable'
            })
            .state('app.pages_invoice_compact', {
                url      : '/pages/invoice/compact',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/invoice/views/compact/compact.html',
                        controller : 'InvoiceController as vm'
                    }
                },
                resolve  : {
                    Invoice: function (msApi)
                    {
                        return msApi.resolve('invoice@get');
                    }
                },
                bodyClass: 'invoice printable'
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/invoice');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.invoice')
        .controller('InvoiceController', InvoiceController);

    /** @ngInject */
    function InvoiceController(Invoice)
    {
        var vm = this;

        // Data
        vm.invoice = Invoice.data;

        // Methods

        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.maintenance', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.pages_maintenance', {
            url      : '/pages/maintenance',
            views    : {
                'main@'                        : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_maintenance': {
                    templateUrl: 'app/main/pages/maintenance/maintenance.html',
                    controller : 'MaintenanceController as vm'
                }
            },
            bodyClass: 'maintenance'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/maintenance');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.maintenance')
        .controller('MaintenanceController', MaintenanceController);

    /** @ngInject */
    function MaintenanceController()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.full-slider', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.pages_full-slider', {
            url      : '/pages/full-slider',
            views    : {
                'main@'                        : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_full-slider': {
                    templateUrl: 'app/main/pages/full-slider/full-slider.html',
                    controller : 'FullSliderController as vm'
                }
            },
            bodyClass: 'full-slider'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/full-slider');
    }

})();
(function () {
    'use strict';

    angular
        .module('app.pages.full-slider')
        .controller('FullSliderController', FullSliderController);

    /** @ngInject */
    function FullSliderController($scope, ListsF, $log, errAlertS, $window) {
        var vm = this;
        var count = 0;
        ListsF.loadList('sliderImages', 'catalogs/sliderImages/collection', undefined, 'array').then(function (sliderImages) {
            vm.images=sliderImages;
            
        }).catch(function (error) {
            $log.error(error);
            errAlertS('Error cargando las imagens')
        });
        var watcher = $scope.$watch(function(){
            var x;
            if(angular.isArray(vm.images)){
                x = vm.images.length;
            }
            return x;
        }, function(newVal, oldVal){
            if(angular.isDefined(newVal) && angular.isDefined(oldVal) && newVal !== oldVal){
                $window.location.reload();
            }
        })
        $scope.$on('$destroy', function(){
            watcher();
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.coming-soon', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.pages_coming-soon', {
            url      : '/pages/coming-soon',
            views    : {
                'main@'                        : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_coming-soon': {
                    templateUrl: 'app/main/pages/coming-soon/coming-soon.html',
                    controller : 'ComingSoonController as vm'
                }
            },
            bodyClass: 'coming-soon'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/coming-soon');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.coming-soon')
        .controller('ComingSoonController', ComingSoonController);

    /** @ngInject */
    function ComingSoonController(
        $scope
    )
    {
        // var vm = this;

        // Data
        $scope.endTime = 1472975790000;

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.todo')
        .controller('TodoController', TodoController);

    /** @ngInject */
    function TodoController($document, $mdDialog, $mdSidenav, Tasks, Tags)
    {
        var vm = this;

        // Data
        vm.tasks = Tasks.data;
        vm.tags = Tags.data;
        vm.completed = [];
        vm.colors = ['blue', 'blue-grey', 'orange', 'pink', 'purple'];
        vm.projects = {
            'creapond'    : 'Project Creapond',
            'withinpixels': 'Project Withinpixels'
        };
        vm.selectedFilter = {
            filter : 'Start Date',
            dueDate: 'Next 3 days'
        };
        vm.selectedProject = 'creapond';

        // Tasks will be filtered against these models
        vm.taskFilters = {
            search   : '',
            tags     : [],
            completed: '',
            deleted  : false,
            important: '',
            starred  : '',
            startDate: '',
            dueDate  : ''
        };
        vm.taskFiltersDefaults = angular.copy(vm.taskFilters);
        vm.showAllTasks = true;

        vm.taskOrder = '';
        vm.taskOrderDescending = false;

        vm.sortableOptions = {
            handle        : '.handle',
            forceFallback : true,
            ghostClass    : 'todo-item-placeholder',
            fallbackClass : 'todo-item-ghost',
            fallbackOnBody: true,
            sort          : true
        };
        vm.msScrollOptions = {
            suppressScrollX: true
        };

        // Methods
        vm.preventDefault = preventDefault;
        vm.openTaskDialog = openTaskDialog;
        vm.toggleCompleted = toggleCompleted;
        vm.toggleSidenav = toggleSidenav;
        vm.toggleFilter = toggleFilter;
        vm.toggleFilterWithEmpty = toggleFilterWithEmpty;
        vm.filterByStartDate = filterByStartDate;
        vm.filterByDueDate = filterByDueDate;
        vm.resetFilters = resetFilters;
        vm.toggleTagFilter = toggleTagFilter;
        vm.isTagFilterExists = isTagFilterExists;

        init();

        //////////

        /**
         * Initialize the controller
         */
        function init()
        {
            angular.forEach(vm.tasks, function (task)
            {
                if ( task.startDate )
                {
                    task.startDate = new Date(task.startDate);
                    task.startDateTimestamp = task.startDate.getTime();
                }

                if ( task.dueDate )
                {
                    task.dueDate = new Date(task.dueDate);
                    task.dueDateTimestamp = task.dueDate.getTime();
                }
            });
        }

        /**
         * Prevent default
         *
         * @param e
         */
        function preventDefault(e)
        {
            e.preventDefault();
            e.stopPropagation();
        }

        /**
         * Open new task dialog
         *
         * @param ev
         * @param task
         */
        function openTaskDialog(ev, task)
        {
            $mdDialog.show({
                controller         : 'TaskDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/todo/dialogs/task/task-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    Task : task,
                    Tasks: vm.tasks,
                    event: ev
                }
            });
        }

        /**
         * Toggle completed status of the task
         *
         * @param task
         * @param event
         */
        function toggleCompleted(task, event)
        {
            event.stopPropagation();
            task.completed = !task.completed;
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Toggles filter with true or false
         *
         * @param filter
         */
        function toggleFilter(filter)
        {
            vm.taskFilters[filter] = !vm.taskFilters[filter];

            checkFilters();
        }

        /**
         * Toggles filter with true or empty string
         * @param filter
         */
        function toggleFilterWithEmpty(filter)
        {
            if ( vm.taskFilters[filter] === '' )
            {
                vm.taskFilters[filter] = true;
            }
            else
            {
                vm.taskFilters[filter] = '';
            }

            checkFilters();
        }

        /**
         * Reset filters
         */
        function resetFilters()
        {
            vm.showAllTasks = true;
            vm.taskFilters = angular.copy(vm.taskFiltersDefaults);
        }

        /**
         * Check filters and mark showAllTasks
         * as true if no filters selected
         */
        function checkFilters()
        {
            vm.showAllTasks = !!angular.equals(vm.taskFiltersDefaults, vm.taskFilters);
        }

        /**
         * Filter by startDate
         *
         * @param item
         * @returns {boolean}
         */
        function filterByStartDate(item)
        {
            if ( vm.taskFilters.startDate === true )
            {
                return item.startDate === new Date();
            }

            return true;
        }

        /**
         * Filter Due Date
         *
         * @param item
         * @returns {boolean}
         */
        function filterByDueDate(item)
        {
            if ( vm.taskFilters.dueDate === true )
            {
                return !(item.dueDate === null || item.dueDate.length === 0);
            }

            return true;
        }

        /**
         * Toggles tag filter
         *
         * @param tag
         */
        function toggleTagFilter(tag)
        {
            var i = vm.taskFilters.tags.indexOf(tag);

            if ( i > -1 )
            {
                vm.taskFilters.tags.splice(i, 1);
            }
            else
            {
                vm.taskFilters.tags.push(tag);
            }

            checkFilters();
        }

        /**
         * Returns if tag exists in the tagsFilter
         *
         * @param tag
         * @returns {boolean}
         */
        function isTagFilterExists(tag)
        {
            return vm.taskFilters.tags.indexOf(tag) > -1;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.tasks', [])
        .config(config);

    function config($stateProvider, $translatePartialLoaderProvider) {
        $stateProvider.state('app.tasks', {
            url: '/tasks'
        });

        $translatePartialLoaderProvider.addPart('app/main/apps/tasks');
    }
})();

(function () {
    'use strict';

    angular.module('app.tasks')
        .run(appQueueTasksRun);

    appQueueTasksRun.$inject = ['$rootScope', 'queueTasksDialog'];
    function appQueueTasksRun($rootScope, queueTasksDialog) {
        var off = $rootScope.$on('$stateChangeStart', function (e, toState, toParams, fromState) {
            if (toState.name === 'app.tasks' && toParams.as !== 'page') {
                e.preventDefault();

                var prevMenuName = ($rootScope.F.active && $rootScope.F.active.menuObjName) || '';
                if (prevMenuName === 'queueTasks' && fromState && fromState.data && fromState.data.menuObjName) {
                    prevMenuName = fromState.data.menuObjName;
                }

                $rootScope.$evalAsync(function () {
                    if ($rootScope.F.active) {
                        $rootScope.F.active.menuObjName = prevMenuName;
                    }
                });

                queueTasksDialog.open()
                    .finally(function () {
                        if ($rootScope.F.active) {
                            $rootScope.F.active.menuObjName = prevMenuName;
                        }
                    })
                    .catch(angular.noop);
            }
        });

        var offDestroy = $rootScope.$on('$destroy', function () {
            off();
            offDestroy();
        });
    }
})();

(function () {
    'use strict';

    angular.module('app.tasks')
        .factory('queueTasksDialog', queueTasksDialog);

    queueTasksDialog.$inject = ['$mdDialog', '$q', '$translatePartialLoader', '$translate'];
    function queueTasksDialog($mdDialog, $q, $translatePartialLoader, $translate) {
        var isOpen = false;

        function open() {
            if (isOpen) {
                return $q.when();
            }

            isOpen = true;
            $translatePartialLoader.addPart('app/main/apps/tasks');

            return $translate.refresh().then(function () {
                return $mdDialog.show({
                    controller: 'QueueTasksController',
                    controllerAs: 'vm',
                    bindToController: true,
                    templateUrl: 'app/main/apps/tasks/tasks.dialog.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: false,
                    escapeToClose: false,
                    multiple: true,
                    fullscreen: false
                });
            }).catch(angular.noop).finally(function () {
                isOpen = false;
            });
        }

        return {
            open: open
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('app.tasks')
        .controller('QueueTasksController', QueueTasksController);

    QueueTasksController.$inject = [
        '$scope',
        '$q',
        '$log',
        '$mdDialog',
        '$state',
        '$rootScope',
        'startAfterInitFilter',
        'errAlertS',
        'ApiV2F',
        'ApiV3F',
        'queueTasksSources'
    ];

    function QueueTasksController(
        $scope,
        $q,
        $log,
        $mdDialog,
        $state,
        $rootScope,
        startAfterInitFilter,
        errAlertS,
        ApiV2F,
        ApiV3F,
        queueTasksSources
    ) {
        var vm = this;

        vm.loading = false;
        vm.error = null;
        vm.allRows = [];
        vm.rows = [];
        vm.sources = angular.copy(queueTasksSources);
        vm.availableQueues = [];
        vm.availableActions = [];
        vm.loadedSources = [];
        vm.filteredRows = [];
        vm.pagedRows = [];
        vm.selectedMap = {};
        vm.confirmDelete = false;
        vm.expandedMap = {};
        vm.sourceFilter = null;
        vm.queueFilter = null;
        vm.statusFilter = null;
        vm.actionFilter = null;
        vm.sortOption = 'createdDesc';
        vm.page = 1;
        vm.pageSize = 10;
        vm.pageSizeOptions = [10, 25, 50];
        vm.totalPages = 1;
        vm.sortOptions = [
            { id: 'createdDesc', label: 'Creado: mas reciente' },
            { id: 'createdAsc', label: 'Creado: mas antiguo' },
            { id: 'scheduledDesc', label: 'Programado: mas reciente' },
            { id: 'scheduledAsc', label: 'Programado: mas antiguo' },
            { id: 'idAsc', label: 'ID: menor a mayor' },
            { id: 'idDesc', label: 'ID: mayor a menor' },
            { id: 'actionAsc', label: 'Accion: A-Z' },
            { id: 'actionDesc', label: 'Accion: Z-A' }
        ];

        vm.statusMeta = {
            active: { label: 'Activa' },
            waiting: { label: 'En espera' },
            delayed: { label: 'Programada' },
            failed: { label: 'Fallida' },
            completed: { label: 'Completada' },
            paused: { label: 'Pausada' },
            unknown: { label: 'Sin estatus' }
        };

        vm.statuses = ['active', 'waiting', 'delayed', 'failed', 'completed', 'paused'];

        vm.close = function () {
            vm.loading = false;
            $rootScope.$evalAsync();
            $state.reload();
            $mdDialog.hide();
        };

        vm.clearFilters = function () {
            vm.sourceFilter = null;
            vm.queueFilter = null;
            vm.statusFilter = null;
            vm.actionFilter = null;
            vm.sortOption = 'createdDesc';
            vm.selectedMap = {};
            vm.confirmDelete = false;
            vm.expandedMap = {};
            vm.page = 1;
            vm.loadData();
        };

        vm.refresh = function () {
            vm.loadData();
        };

        vm.filterRows = function () {
            vm.error = null;
            vm.filteredRows = applyFilters(vm.allRows);
            updatePagedRows();
            syncSelection();

            if (!vm.loading && !vm.filteredRows.length) {
                vm.error = 'No hay tareas para los filtros seleccionados.';
            }
        };

        vm.getStatusLabel = function (status) {
            var meta = vm.statusMeta[status] || vm.statusMeta.unknown;
            return meta.label;
        };

        vm.getStatusStyle = function (status) {
            if (status === 'failed') {
                return {
                    background: '#fde8e7',
                    color: '#d84343'
                };
            }

            if (status === 'completed') {
                return {
                    background: '#e6f1ff',
                    color: '#356ad8'
                };
            }

            if (status === 'active') {
                return {
                    background: '#e8f7ef',
                    color: '#1f8f57'
                };
            }

            if (status === 'delayed') {
                return {
                    background: '#fff4df',
                    color: '#c98218'
                };
            }

            return {
                background: '#eceff7',
                color: '#677086'
            };
        };

        vm.selectedCount = function () {
            var count = 0;
            var key;

            for (key in vm.selectedMap) {
                if (vm.selectedMap[key]) {
                    count++;
                }
            }

            return count;
        };

        vm.isAllSelected = function () {
            var i;

            if (!vm.rows.length) {
                return false;
            }

            for (i = 0; i < vm.rows.length; i++) {
                if (!vm.selectedMap[vm.rows[i].__key]) {
                    return false;
                }
            }

            return true;
        };

        vm.isIndeterminate = function () {
            var count = vm.selectedCount();
            return count > 0 && count < vm.rows.length;
        };

        vm.toggleAll = function ($event) {
            var i;
            var value;

            if ($event) {
                $event.stopPropagation();
            }

            value = !vm.isAllSelected();

            for (i = 0; i < vm.rows.length; i++) {
                vm.selectedMap[vm.rows[i].__key] = value;
            }

            vm.confirmDelete = false;
        };

        vm.toggleOne = function (item, $event) {
            if ($event) {
                $event.stopPropagation();
            }

            if (!item || !item.__key) {
                return;
            }

            vm.selectedMap[item.__key] = !vm.selectedMap[item.__key];
            vm.confirmDelete = false;
        };

        vm.cancelDelete = function () {
            vm.confirmDelete = false;
        };

        vm.toggleDetails = function (item, $event) {
            if ($event) {
                $event.stopPropagation();
            }

            if (!item || !item.__key) {
                return;
            }

            vm.expandedMap[item.__key] = !vm.expandedMap[item.__key];
        };

        vm.hasDetails = function (item) {
            return !!(item && item.rawJson);
        };

        vm.changePage = function (page) {
            if (page < 1 || page > vm.totalPages) {
                return;
            }

            vm.page = page;
            updatePagedRows();
        };

        vm.changePageSize = function () {
            vm.page = 1;
            updatePagedRows();
        };

        vm.visiblePages = function () {
            var pages = [];
            var start = Math.max(1, vm.page - 2);
            var end = Math.min(vm.totalPages, start + 4);
            var i;

            start = Math.max(1, end - 4);

            for (i = start; i <= end; i++) {
                pages.push(i);
            }

            return pages;
        };

        vm.deleteSelected = function () {
            var requests = [];
            var selectedRows = getSelectedRows();
            var i;
            var row;
            var source;
            var client;

            if (!selectedRows.length) {
                vm.confirmDelete = false;
                return;
            }

            vm.loading = true;
            vm.error = null;

            for (i = 0; i < selectedRows.length; i++) {
                row = selectedRows[i];
                source = getSourceById(row.sourceId);
                client = source ? getClientByName(source.client) : null;
                requests.push(deleteRow(source, client, row));
            }

            if (!requests.length) {
                vm.loading = false;
                vm.confirmDelete = false;
                vm.error = 'No hay tareas validas para eliminar.';
                return;
            }

            $q.all(requests)
                .then(function (results) {
                    var failed = results.filter(function (result) {
                        return !result.ok;
                    });

                    vm.selectedMap = {};
                    vm.confirmDelete = false;
                    if (failed.length) {
                        vm.error = 'Algunas tareas no se pudieron eliminar.';
                        errAlertS(vm.error);
                    }
                    return vm.loadData();
                })
                .finally(function () {
                    vm.loading = false;
                });
        };

        vm.loadData = function () {
            var selectedSources = getSelectedSources();
            var requests = [];
            var i;

            vm.loading = true;
            vm.error = null;

            for (i = 0; i < selectedSources.length; i++) {
                requests.push(fetchJobsFromSource(selectedSources[i]));
            }

            return $q.all(requests)
                .then(function (responses) {
                    var rows = [];
                    var queuesMap = {};
                    var actionsMap = {};
                    var availableSources = [];
                    var okCount = 0;

                    angular.forEach(responses, function (result) {
                        if (!result.ok) {
                            return;
                        }

                        okCount++;
                        availableSources.push(result.source.id);

                        angular.forEach(result.rows, function (item, index) {
                            var row = normalizeRow(item, result.source, index);
                            rows.push(row);
                            if (row.queue) {
                                queuesMap[row.queue] = true;
                            }
                            if (row.action) {
                                actionsMap[row.action] = true;
                            }
                        });
                    });

                    vm.loadedSources = availableSources;
                    vm.availableQueues = Object.keys(queuesMap).sort();
                    vm.availableActions = Object.keys(actionsMap).sort();
                    if (vm.queueFilter && vm.availableQueues.indexOf(vm.queueFilter) === -1) {
                        vm.queueFilter = null;
                    }
                    if (vm.actionFilter && vm.availableActions.indexOf(vm.actionFilter) === -1) {
                        vm.actionFilter = null;
                    }
                    vm.allRows = rows;
                    vm.selectedMap = {};
                    vm.confirmDelete = false;
                    vm.expandedMap = {};
                    vm.page = 1;
                    vm.filterRows();

                    if (!okCount) {
                        vm.error = 'No se pudo consultar ninguna fuente configurada.';
                        errAlertS(vm.error);
                        return;
                    }
                })
                .catch(function (error) {
                    $log.error('[tasks] loadData error:', error);
                    vm.allRows = [];
                    vm.rows = [];
                    vm.error = 'No se pudo consultar la cola de tareas.';
                    errAlertS(vm.error);
                    return [];
                })
                .finally(function () {
                    vm.loading = false;
                });
        };

        function init() {
            vm.loadData();
        }

        function getClientByName(clientName) {
            if (clientName === 'ApiV2F') {
                return ApiV2F;
            }

            if (clientName === 'ApiV3F') {
                return ApiV3F;
            }

            return null;
        }

        function getSourceById(sourceId) {
            var i;

            for (i = 0; i < vm.sources.length; i++) {
                if (vm.sources[i].id === sourceId) {
                    return vm.sources[i];
                }
            }

            return null;
        }

        function getSelectedSources() {
            if (!vm.sourceFilter) {
                return vm.sources.slice(0);
            }

            return vm.sources.filter(function (source) {
                return source.id === vm.sourceFilter;
            });
        }

        function fetchJobsFromSource(source) {
            var client = getClientByName(source.client);

            if (!client || !source.jobsPath) {
                return $q.when({
                    ok: false,
                    source: source,
                    rows: []
                });
            }

            return client.get(source.jobsPath).then(function (response) {
                return {
                    ok: true,
                    source: source,
                    rows: angular.isArray(response.data) ? response.data : []
                };
            }).catch(function (error) {
                $log.warn('[tasks] source failed:', source.id, error);
                return {
                    ok: false,
                    source: source,
                    rows: []
                };
            });
        }

        function normalizeStatus(value) {
            if (!value) {
                return 'unknown';
            }

            value = String(value).toLowerCase().trim();

            if (value === 'fallida' || value === 'failed' || value === 'fail' || value === 'error') {
                return 'failed';
            }

            if (value === 'completada' || value === 'completed' || value === 'success') {
                return 'completed';
            }

            if (value === 'activa' || value === 'active') {
                return 'active';
            }

            if (value === 'espera' || value === 'waiting' || value === 'pendiente') {
                return 'waiting';
            }

            if (value === 'retrasada' || value === 'delayed') {
                return 'delayed';
            }

            return value;
        }

        function readPath(obj, path) {
            var parts;
            var current;
            var i;

            if (!obj || !path) {
                return undefined;
            }

            parts = path.split('.');
            current = obj;

            for (i = 0; i < parts.length; i++) {
                if (current == null) {
                    return undefined;
                }
                current = current[parts[i]];
            }

            return current;
        }

        function pickFirst(obj, paths) {
            var i;
            var value;

            if (!angular.isArray(paths)) {
                return undefined;
            }

            for (i = 0; i < paths.length; i++) {
                value = readPath(obj, paths[i]);
                if (!angular.isUndefined(value) && value !== null && value !== '') {
                    return value;
                }
            }

            return undefined;
        }

        function normalizeRow(item, source, index) {
            var fields = source.fields || {};
            var id = pickFirst(item, fields.id);
            var queue = pickFirst(item, fields.queue);
            var status = normalizeStatus(pickFirst(item, fields.status));
            var timestamp = pickFirst(item, fields.timestamp);
            var scheduledFor = pickFirst(item, fields.scheduledFor);
            var normalizedId = angular.isDefined(id) ? id : index;

            return {
                id: normalizedId,
                queue: queue || 'Sin cola',
                status: status,
                action: pickFirst(item, fields.action) || 'Sin accion',
                attempts: pickFirst(item, fields.attempts) || 0,
                timestamp: timestamp || null,
                scheduledFor: normalizeDateValue(scheduledFor, timestamp),
                error: pickFirst(item, fields.error) || null,
                sourceId: source.id,
                sourceLabel: source.label,
                __key: source.id + '|' + String(normalizedId) + '|' + String(queue || 'Sin cola') + '|' + index,
                raw: item,
                rawJson: angular.toJson(item, 2)
            };
        }

        function normalizeDateValue(value, fallbackTimestamp) {
            if (!angular.isDefined(value) || value === null || value === '') {
                return null;
            }

            if (angular.isNumber(value)) {
                if (value > 9999999999) {
                    return value;
                }

                if (fallbackTimestamp && angular.isNumber(fallbackTimestamp)) {
                    return fallbackTimestamp + value;
                }
            }

            return value;
        }

        function buildDeletePath(source, jobId) {
            if (!source || !source.deletePath || !angular.isDefined(jobId)) {
                return null;
            }

            return source.deletePath.replace(':jobId', encodeURIComponent(jobId));
        }

        function deleteRow(source, client, row) {
            var deletePath = buildDeletePath(source, row.id);

            if (!client || !deletePath) {
                return $q.when({
                    ok: false,
                    row: row
                });
            }

            return client.delete(deletePath).then(function () {
                return {
                    ok: true,
                    row: row
                };
            }).catch(function (error) {
                $log.error('[tasks] delete row error:', row, error);
                return {
                    ok: false,
                    row: row
                };
            });
        }

        function getSelectedRows() {
            return vm.filteredRows.filter(function (row) {
                return !!vm.selectedMap[row.__key];
            });
        }

        function syncSelection() {
            var visibleMap = {};
            var nextSelected = {};
            var i;

            for (i = 0; i < vm.filteredRows.length; i++) {
                visibleMap[vm.filteredRows[i].__key] = true;
            }

            for (i in vm.selectedMap) {
                if (vm.selectedMap[i] && visibleMap[i]) {
                    nextSelected[i] = true;
                }
            }

            vm.selectedMap = nextSelected;
        }

        function applyFilters(rows) {
            return rows.filter(function (row) {
                if (vm.queueFilter && row.queue !== vm.queueFilter) {
                    return false;
                }

                if (vm.statusFilter && row.status !== vm.statusFilter) {
                    return false;
                }

                if (vm.actionFilter && row.action !== vm.actionFilter) {
                    return false;
                }

                return true;
            });
        }

        function compareValues(a, b, direction) {
            if (a === b) {
                return 0;
            }

            if (a === null || angular.isUndefined(a)) {
                return direction === 'asc' ? -1 : 1;
            }

            if (b === null || angular.isUndefined(b)) {
                return direction === 'asc' ? 1 : -1;
            }

            if (a < b) {
                return direction === 'asc' ? -1 : 1;
            }

            return direction === 'asc' ? 1 : -1;
        }

        function getSortValue(row, type) {
            if (type === 'id') {
                return angular.isNumber(row.id) ? row.id : String(row.id || '').toLowerCase();
            }

            if (type === 'scheduled') {
                return row.scheduledFor || 0;
            }

            if (type === 'action') {
                return String(row.action || '').toLowerCase();
            }

            return row.timestamp || 0;
        }

        function sortRows(rows) {
            var option = vm.sortOption || 'createdDesc';
            var direction = option.indexOf('Asc') > -1 ? 'asc' : 'desc';
            var type = 'created';

            if (option.indexOf('scheduled') === 0) {
                type = 'scheduled';
            } else if (option.indexOf('id') === 0) {
                type = 'id';
            } else if (option.indexOf('action') === 0) {
                type = 'action';
            }

            return rows.slice(0).sort(function (a, b) {
                var cmp = compareValues(getSortValue(a, type), getSortValue(b, type), direction);

                if (cmp !== 0) {
                    return cmp;
                }

                return compareValues(String(a.queue || '').toLowerCase(), String(b.queue || '').toLowerCase(), 'asc');
            });
        }

        function updatePagedRows() {
            var start;
            var sortedRows = sortRows(vm.filteredRows);

            vm.totalPages = Math.max(1, Math.ceil(sortedRows.length / vm.pageSize));
            if (vm.page > vm.totalPages) {
                vm.page = vm.totalPages;
            }

            start = (vm.page - 1) * vm.pageSize;
            vm.rows = sortedRows.slice(start, start + vm.pageSize);
        }

        var watchers = {};
        var initiated = false;
        startAfterInitFilter($scope, watchers, initiated, init);
    }
})();

(function () {
    'use strict';

    angular.module('app.tasks')
        .constant('queueTasksSources', [
            {
                id: 'apiV3',
                label: 'API v3',
                client: 'ApiV3F',
                jobsPath: 'queue/jobs',
                deletePath: 'queue/job/:jobId',
                fields: {
                    id: ['id', 'jobId', '_id'],
                    queue: ['queue', 'name', 'type'],
                    status: ['status', 'state', 'jobStatus'],
                    action: ['data.action', 'action', 'name'],
                    attempts: ['attemptsMade', 'attempts'],
                    timestamp: ['timestamp', 'createdAt', 'created'],
                    error: ['failedReason', 'error', 'message'],
                    scheduledFor: ['executeTime', 'delayMs', 'nextRunAt', 'processedOn', 'delayUntil', 'opts.delay']
                }
            },
            {
                id: 'apiV2',
                label: 'API v2',
                client: 'ApiV2F',
                jobsPath: 'tasks/jobs',
                deletePath: 'tasks/job/:jobId',
                fields: {
                    id: ['id', 'jobId', '_id'],
                    queue: ['queue', 'name', 'type'],
                    status: ['status', 'state', 'jobStatus'],
                    action: ['data.action', 'action', 'name'],
                    attempts: ['attemptsMade', 'attempts'],
                    timestamp: ['timestamp', 'createdAt', 'created'],
                    error: ['failedReason', 'error', 'message'],
                    scheduledFor: ['executeTime', 'delayMs', 'nextRunAt', 'processedOn', 'delayUntil', 'opts.delay']
                }
            }
        ]);
})();

(function ()
{
    'use strict';

    angular
        .module('app.notes')
        .controller('NotesController', NotesController);

    /** @ngInject */
    function NotesController($document, $timeout, $scope, $mdSidenav, NotesService, LabelsService, $mdDialog)
    {
        var vm = this;

        // Data
        vm.notes = NotesService.data;
        vm.labels = LabelsService.data;
        vm.search = '';
        vm.searchToolbar = false;
        vm.filters = {
            archive: false
        };
        vm.labelFilterIds = [];
        vm.noteListType = 'notes';

        // Methods
        vm.filterChange = filterChange;
        vm.openSearchToolbar = openSearchToolbar;
        vm.closeSearchToolbar = closeSearchToolbar;
        vm.editNote = editNote;
        vm.deleteLabel = deleteLabel;
        vm.toggleSidenav = toggleSidenav;
        vm.addNewLabel = LabelsService.addLabel;

        //////////

        /**
         * Change Notes Filter
         * @param type
         */
        function filterChange(type)
        {

            vm.noteListType = type;

            if ( type === 'notes' )
            {
                vm.labelFilterIds = [];
                vm.filters = {
                    archive: false
                };
            }
            else if ( type === 'archive' )
            {
                vm.labelFilterIds = [];
                vm.filters = {
                    archive: true
                };
            }
            else if ( type === 'reminders' )
            {
                vm.labelFilterIds = [];
                vm.filters = {
                    reminder: '',
                    archive : false
                };
            }
            else if ( angular.isObject(type) )
            {
                vm.labelFilterIds = [];
                vm.labelFilterIds.push(type.id);
            }

            $mdSidenav('main-sidenav').close();

        }

        /**
         * Edit Note
         * @param ev
         * @param noteId
         */
        function editNote(ev, noteId)
        {
            $mdDialog.show({
                template           : '<md-dialog ms-scroll><ms-note-form note-type="\'edit\'" note-id="\'' + noteId + '\'"></ms-note-form></md-dialog>',
                parent             : $document.find('#notes'),
                targetEvent        : ev,
                clickOutsideToClose: true,
                escapeToClose      : true
            });
        }

        /**
         * Delete Label
         * @param ev
         * @param label
         */
        function deleteLabel(ev, label)
        {
            var confirm = $mdDialog.confirm()
                .title('Are you sure want to delete the label?')
                .htmlContent('The "' + label.name + '" label will be deleted permanently.')
                .ariaLabel('delete label')
                .targetEvent(ev)
                .ok('OK')
                .cancel('CANCEL');

            $mdDialog.show(confirm).then(function ()
            {
                LabelsService.deleteLabel(label);
            });
        }

        /**
         * Open Search Toolbar
         */
        function openSearchToolbar()
        {
            vm.searchToolbar = true;

            $timeout(function ()
            {
                angular.element($document.find('#search-notes-input')).trigger('focus');

            });

            $document.on('keyup', escKeyEvent);
        }

        /**
         * Close Search Toolbar
         */
        function closeSearchToolbar()
        {
            $scope.$evalAsync(function ()
            {
                vm.searchToolbar = false;
                vm.search = '';
            });

            $document.off('keyup', escKeyEvent);
        }

        /**
         * Escape key event
         */
        function escKeyEvent(e)
        {
            if ( e.keyCode === 27 )
            {
                closeSearchToolbar();
            }
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Array prototype
         *
         * Get by id
         *
         * @param value
         * @returns {T}
         */
        Array.prototype.getById = function (value)
        {
            return this.filter(function (x)
            {
                return x.id === value;
            })[0];
        };

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.file-manager', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.file-manager', {
            url      : '/file-manager',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/file-manager/file-manager.html',
                    controller : 'FileManagerController as vm'
                }
            },
            resolve  : {
                Documents: function (msApi)
                {
                    return msApi.resolve('fileManager.documents@get');
                }
            },
            bodyClass: 'file-manager'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/file-manager');

        // Api
        msApiProvider.register('fileManager.documents', ['app/data/file-manager/documents.json']);

        // Navigation
        msNavigationServiceProvider.saveItem('apps.file-manager', {
            title : 'File Manager',
            icon  : 'icon-folder',
            state : 'app.file-manager',
            weight: 6
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.file-manager')
        .controller('FileManagerController', FileManagerController);

    /** @ngInject */
    function FileManagerController($mdSidenav, Documents)
    {
        var vm = this;

        // Data
        vm.accounts = {
            'creapond'    : 'johndoe@creapond.com',
            'withinpixels': 'johndoe@withinpixels.com'
        };
        vm.selectedAccount = 'creapond';
        vm.currentView = 'list';
        vm.showDetails = true;

        vm.path = Documents.data.path;
        vm.folders = Documents.data.folders;
        vm.files = Documents.data.files;
        vm.selected = vm.files[0];

        vm.ngFlowOptions = {
            // You can configure the ngFlow from here
            /*target                   : 'api/media/image',
             chunkSize                : 15 * 1024 * 1024,
             maxChunkRetries          : 1,
             simultaneousUploads      : 1,
             testChunks               : false,
             progressCallbacksInterval: 1000*/
        };
        vm.ngFlow = {
            // ng-flow will be injected into here through its directive
            flow: {}
        };

        // Methods
        vm.fileAdded = fileAdded;
        vm.upload = upload;
        vm.fileSuccess = fileSuccess;

        vm.select = select;
        vm.toggleDetails = toggleDetails;
        vm.toggleSidenav = toggleSidenav;
        vm.toggleView = toggleView;

        //////////

        /**
         * File added callback
         * Triggers when files added to the uploader
         *
         * @param file
         */
        function fileAdded(file)
        {
            // Prepare the temp file data for file list
            var uploadingFile = {
                id       : file.uniqueIdentifier,
                file     : file,
                type     : '',
                owner    : 'Emily Bennett',
                size     : '',
                modified : moment().format('MMMM D, YYYY'),
                opened   : '',
                created  : moment().format('MMMM D, YYYY'),
                extention: '',
                location : 'My Files > Documents',
                offline  : false,
                preview  : 'assets/images/etc/sample-file-preview.jpg'
            };

            // Append it to the file list
            vm.files.push(uploadingFile);
        }

        /**
         * Upload
         * Automatically triggers when files added to the uploader
         */
        function upload()
        {
            // Set headers
            vm.ngFlow.flow.opts.headers = {
                'X-Requested-With': 'XMLHttpRequest',
                //'X-XSRF-TOKEN'    : $cookies.get('XSRF-TOKEN')
            };

            vm.ngFlow.flow.upload();
        }

        /**
         * File upload success callback
         * Triggers when single upload completed
         *
         * @param file
         * @param message
         */
        function fileSuccess(file, message)
        {
            // Iterate through the file list, find the one we
            // are added as a temp and replace its data
            // Normally you would parse the message and extract
            // the uploaded file data from it
            angular.forEach(vm.files, function (item, index)
            {
                if ( item.id && item.id === file.uniqueIdentifier )
                {
                    // Normally you would update the file from
                    // database but we are cheating here!

                    // Update the file info
                    item.name = file.file.name;
                    item.type = 'document';

                    // Figure out & upddate the size
                    if ( file.file.size < 1024 )
                    {
                        item.size = parseFloat(file.file.size).toFixed(2) + ' B';
                    }
                    else if ( file.file.size >= 1024 && file.file.size < 1048576 )
                    {
                        item.size = parseFloat(file.file.size / 1024).toFixed(2) + ' Kb';
                    }
                    else if ( file.file.size >= 1048576 && file.file.size < 1073741824 )
                    {
                        item.size = parseFloat(file.file.size / (1024 * 1024)).toFixed(2) + ' Mb';
                    }
                    else
                    {
                        item.size = parseFloat(file.file.size / (1024 * 1024 * 1024)).toFixed(2) + ' Gb';
                    }
                }
            });
        }

        /**
         * Select an item
         *
         * @param item
         */
        function select(item)
        {
            vm.selected = item;
        }

        /**
         * Toggle details
         *
         * @param item
         */
        function toggleDetails(item)
        {
            vm.selected = item;
            toggleSidenav('details-sidenav');
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Toggle view
         */
        function toggleView()
        {
            vm.currentView = vm.currentView === 'list' ? 'grid' : 'list';
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.contacts')
        .controller('ContactsController', ContactsController);

    /** @ngInject */
    function ContactsController($scope, $mdSidenav, Contacts, User, msUtils, $mdDialog, $document)
    {

        var vm = this;

        // Data
        vm.contacts = Contacts.data;
        vm.user = User.data;
        vm.filterIds = null;
        vm.listType = 'all';
        vm.listOrder = 'name';
        vm.listOrderAsc = false;
        vm.selectedContacts = [];
        vm.newGroupName = '';

        // Methods
        vm.filterChange = filterChange;
        vm.openContactDialog = openContactDialog;
        vm.deleteContactConfirm = deleteContactConfirm;
        vm.deleteContact = deleteContact;
        vm.deleteSelectedContacts = deleteSelectedContacts;
        vm.toggleSelectContact = toggleSelectContact;
        vm.deselectContacts = deselectContacts;
        vm.selectAllContacts = selectAllContacts;
        vm.deleteContact = deleteContact;
        vm.addNewGroup = addNewGroup;
        vm.deleteGroup = deleteGroup;
        vm.toggleSidenav = toggleSidenav;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.exists = msUtils.exists;

        //////////

        /**
         * Change Contacts List Filter
         * @param type
         */
        function filterChange(type)
        {

            vm.listType = type;

            if ( type === 'all' )
            {
                vm.filterIds = null;
            }
            else if ( type === 'frequent' )
            {
                vm.filterIds = vm.user.frequentContacts;
            }
            else if ( type === 'starred' )
            {
                vm.filterIds = vm.user.starred;
            }
            else if ( angular.isObject(type) )
            {
                vm.filterIds = type.contactIds;
            }

            vm.selectedContacts = [];

        }

        /**
         * Open new contact dialog
         *
         * @param ev
         * @param contact
         */
        function openContactDialog(ev, contact)
        {
            $mdDialog.show({
                controller         : 'ContactDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/contacts/dialogs/contact/contact-dialog.html',
                parent             : angular.element($document.find('#content-container')),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    Contact : contact,
                    User    : vm.user,
                    Contacts: vm.contacts
                }
            });
        }

        /**
         * Delete Contact Confirm Dialog
         */
        function deleteContactConfirm(contact, ev)
        {
            var confirm = $mdDialog.confirm()
                .title('Are you sure want to delete the contact?')
                .htmlContent('<b>' + contact.name + ' ' + contact.lastName + '</b>' + ' will be deleted.')
                .ariaLabel('delete contact')
                .targetEvent(ev)
                .ok('OK')
                .cancel('CANCEL');

            $mdDialog.show(confirm).then(function ()
            {

                deleteContact(contact);
                vm.selectedContacts = [];

            }, function ()
            {

            });
        }

        /**
         * Delete Contact
         */
        function deleteContact(contact)
        {
            vm.contacts.splice(vm.contacts.indexOf(contact), 1);
        }

        /**
         * Delete Selected Contacts
         */
        function deleteSelectedContacts(ev)
        {
            var confirm = $mdDialog.confirm()
                .title('Are you sure want to delete the selected contacts?')
                .htmlContent('<b>' + vm.selectedContacts.length + ' selected</b>' + ' will be deleted.')
                .ariaLabel('delete contacts')
                .targetEvent(ev)
                .ok('OK')
                .cancel('CANCEL');

            $mdDialog.show(confirm).then(function ()
            {

                vm.selectedContacts.forEach(function (contact)
                {
                    deleteContact(contact);
                });

                vm.selectedContacts = [];

            });

        }

        /**
         * Toggle selected status of the contact
         *
         * @param contact
         * @param event
         */
        function toggleSelectContact(contact, event)
        {
            if ( event )
            {
                event.stopPropagation();
            }

            if ( vm.selectedContacts.indexOf(contact) > -1 )
            {
                vm.selectedContacts.splice(vm.selectedContacts.indexOf(contact), 1);
            }
            else
            {
                vm.selectedContacts.push(contact);
            }
        }

        /**
         * Deselect contacts
         */
        function deselectContacts()
        {
            vm.selectedContacts = [];
        }

        /**
         * Sselect all contacts
         */
        function selectAllContacts()
        {
            vm.selectedContacts = $scope.filteredContacts;
        }

        /**
         *
         */
        function addNewGroup()
        {
            if ( vm.newGroupName === '' )
            {
                return;
            }

            var newGroup = {
                'id'        : msUtils.guidGenerator(),
                'name'      : vm.newGroupName,
                'contactIds': []
            };

            vm.user.groups.push(newGroup);
            vm.newGroupName = '';
        }

        /**
         * Delete Group
         */
        function deleteGroup(ev)
        {
            var group = vm.listType;

            var confirm = $mdDialog.confirm()
                .title('Are you sure want to delete the group?')
                .htmlContent('<b>' + group.name + '</b>' + ' will be deleted.')
                .ariaLabel('delete group')
                .targetEvent(ev)
                .ok('OK')
                .cancel('CANCEL');

            $mdDialog.show(confirm).then(function ()
            {

                vm.user.groups.splice(vm.user.groups.indexOf(group), 1);

                filterChange('all');
            });

        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

    }

})();
(function () {
    'use strict';

    angular
        .module('app.calendar')
        .controller('CalendarController', CalendarController);

    /** @ngInject */
    function CalendarController(
        $scope,
        $rootScope,
        $log,
        startAfterInitFilter,
        getCountOperationStatusFilter,
        $mdBottomSheet,
        $filter,
        CalendarF
    ) {
        var watchers = {};
        var initiated = false;
        var payrollEvents = {
            events: []
        };
        var festiveEvents = {
            color: 'red',
            textColor: 'white',
            events: []
        };
        var eventsSources = [payrollEvents, festiveEvents];
        var calendarUiConfig = {
            calendar: {
                editable: true,
                eventLimit: true,
                header: '',
                handleWindowResize: false,
                aspectRatio: 1,
                dayNames: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
                dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab'],
                viewRender: function (view) {
                    $scope.calendarView = view;
                    $scope.calendar = $scope.calendarView.calendar;
                    $scope.currentMonthShort = $scope.calendar.getDate().format('MMM');
                    CalendarF.calendarModule.years[view.start.format('YYYY')] = true;
                    CalendarF.calendarModule.years[view.end.format('YYYY')] = true;
                    $scope.startDate = view.start;
                    $scope.endDate = view.end;
                    createMexicanFestiveEvents();
                    loadPayrollCalendar().then(function () {
                        return loadOperationsEvents();
                    }).then(function () {
                        createOperationsEvents();
                    }).catch(function (error) {
                        $log.error(error);
                    });
                },
                columnFormat: {
                    month: 'ddd',
                    week: 'ddd D',
                    day: 'ddd M'
                },
                eventClick: showEvent,
                selectable: true,
                selectHelper: true
            }
        };
        function init() {
            createMexicanFestiveEvents();
            loadPayrollCalendar().then(function () {
                return loadOperationsEvents();
            }).then(function () {
                createOperationsEvents();
            }).catch(function (error) {
                $log.error(error);
            });
        }
        function createMexicanFestiveEvents() {
            if (angular.isObject($scope.F.holydaysInMexico) && angular.isArray($scope.F.holydaysInMexico.matrix) && $scope.startDate && $scope.endDate) {
                festiveEvents.events.length = 0;
                for (var d = 0; d < $scope.F.holydaysInMexico.matrix.length; d++) {
                    var holyday = $scope.F.holydaysInMexico.matrix[d];
                    if ($scope.startDate.valueOf() < holyday.date.valueOf() && holyday.date.valueOf() < $scope.endDate.valueOf()) {
                        var id = holyday.date.valueOf() + 'R';
                        var e = {
                            identificator: id,
                            allDay: true,
                            title: holyday.occasion,
                            start: holyday.date,
                            end: null,
                            type: 'festiveEvents'
                        };
                        festiveEvents.events.push(e);
                    }
                }
            }
        }
        function loadPayrollCalendar() {
            return CalendarF.loadPayrollCalendar($scope.F.permissionToAccessAllPayrolls ? $rootScope.L.allPayrolls : $rootScope.L.payrolls, true);
        }
        function loadOperationsEvents() {
            return CalendarF.loadOperationsEvents();
        }
        function createOperationsEvents() {
            if (CalendarF.calendarModule.operations && $scope.startDate && $scope.endDate) {
                var operations = $filter('mergeOperations')(CalendarF.calendarModule.operations);
                operations.then(function (data) {
                    payrollEvents.events.length = 0;
                    var newEvents = $filter('createEvents')(data, $scope.startDate, $scope.endDate);
                    for (var n = 0; n < newEvents.length; n++) {
                        var thisEvent = newEvents[n];
                        if (thisEvent.title === 'recepcion') {
                            var numEventsR = getCountOperationStatusFilter(thisEvent.operations, 1);
                            thisEvent.title = 'Recepción de nominas ' + numEventsR;
                        } else if (thisEvent.title === 'dispersion') {
                            var numEventsD = getCountOperationStatusFilter(thisEvent.operations, 3);
                            thisEvent.title = 'Dispersion de nominas ' + numEventsD;
                        }
                        payrollEvents.events.push(thisEvent);
                    }
                });
            }
        }
        function showEvent(calendarEvent, e) {
            if (calendarEvent.type && calendarEvent.type === 'operationEvents') {
                $scope.F.calendarEvent = calendarEvent;
                $scope.showListBottomSheet(e);
            }
        }
        function showListBottomSheet(event) {
            $mdBottomSheet.show({
                templateUrl: 'app/main/apps/calendar/dialogs/bottom-list-grid.html',
                locals: {
                    event: event
                },
                controller: function (scope, $rootScope, $mdDialog, $firebaseObject, $filter, AppF) {
                    scope.F = AppF;
                    scope.today = moment().toDate();
                    // console.log(AppF.calendarEvent.operations);
                    // scope.goToOperation = function (operation) {
                    //     if (operation) {
                    //         $scope.F.goToState("app.processes.operations.detail", {
                    //             'period': operation.period,
                    //             'operationId': operation.$id,
                    //             'payrollId': operation.payroll,
                    //             'calendarYear': operation.calendar
                    //         });
                    //     }
                    // }
                },
                parent: '.md-tab-body',
                clickOutsideToClose: true,
                escapeToClose: true,
                targetEvent: event
            }).then(function (clickedItem) {
                $log.log(clickedItem);
            }).catch(function (error) {
                $log.error(error);
            });
        }
        function next() {
            $scope.calendarView.calendar.next();
        }
        function prev() {
            $scope.calendarView.calendar.prev();
        }
        $scope.showListBottomSheet = showListBottomSheet;
        $scope.next = next;
        $scope.prev = prev;
        $scope.CF = CalendarF;
        $scope.startDate = '';
        $scope.endDate = '';
        $scope.eventsSources = eventsSources;
        $scope.calendarUiConfig = calendarUiConfig;
        $scope.F.payrollEvents = $scope.F.payrollEvents ? $scope.F.payrollEvents : [];
        //Seccion de watchers
        // watchers.years = $scope.$watch('CF.calendarModule.years', function (years) {
        //     if (years) {

        //     }
        // }, true);
        // watchers.yearquery = $scope.$watch('CF.calendarModule.yearsQueryObjects', function (yearsQueryObjects) {
        //     if (yearsQueryObjects) {
        //         ();
        //     }
        // }, true);
        // watchers.operations = $scope.$watch('CF.calendarModule.operations', function (operations) {
        //     if (operations) {
        //         ;
        //     }
        // }, true);
        startAfterInitFilter($scope, watchers, initiated, init);

    }

})();
(function () {
    'use strict';

    angular
        .module('app.chat')
        .controller('ChatController', ChatController);

    /** @ngInject */
    function ChatController($mdSidenav, $timeout, $document, $mdMedia, ChatF, $log, $scope, AppF, $rootScope, startAfterInitFilter) {
        var initiated = false;
        var watchers = {};
        function init() {
            $scope.CF = ChatF;
            $log.debug(ChatF, "Factory de chats");
            $scope.user = AppF.profile;
            //$scope.chats = ChatsService.chats;
            $scope.leftSidenavView = false;
            AppF.chatActive = false;

            // Methods
            $scope.getChat = getChat;
            $scope.getChatByContactId = getChatByContactId;
            $scope.toggleSidenav = toggleSidenav;
            $scope.toggleLeftSidenavView = toggleLeftSidenavView;
            $scope.reply = reply;
            $scope.setUserStatus = ChatF.setUserStatus;
            $scope.getFriendStatus = ChatF.getFriendStatus;
        }

        //////////

        /**
         * Get Chat by Contact id
         * @param contactId
         */
        function getChat(chatId, iskey) {
            AppF.goBottom = true;
            var key = false;
            if (angular.isUndefined(iskey)) {
                angular.forEach(ChatF.chats, function (chat, kchat) {
                    if (chatId == chat.id) {
                        key = kchat;
                        return true;
                    }
                })
            } else {
                key = chatId;
            }

            if (key !== false) {
                ChatF.loadConversation(ChatF.chats[key])
                changeUnreadedMsg(ChatF.chats[key]);
                AppF.chatActive = key;
                if (!$mdMedia('gt-md')) {
                    $mdSidenav('left-sidenav').close();
                }
                // Reset Left Sidenav View
                $scope.toggleLeftSidenavView(false);
            }
        }

        function getChatByContactId(contactId) {
            var key = ChatF.addChatByProfileId(contactId);
            getChat(key, true);
        }

        function changeUnreadedMsg(chat) {
            ChatF.changeUnreadedMsg(chat);
        }

        function getScrollHeight() {
            var chatDialog = angular.element('#chat-content');
            return chatDialog[0].scrollHeight;
        }

        $rootScope.$on('nuevoMensajeCargado', function () {
            if (AppF.goBottom) {
                scrollToBottomOfChat(0);
            } else {
                $timeout(function () {
                    $scope.heightAfterLoad = getScrollHeight();
                    scrollTo($scope.heightAfterLoad - $scope.heightBeforeLoad)
                }, 0, false);
            }
        });

        $scope.$on('ngRepeatFinished', function () {
            if (AppF.goBottom) {
                scrollToBottomOfChat(0);
            }
        });

        $scope.$on('autoScrollBottom', function () {
            AppF.goBottom = true;
        });
        $scope.$on('scrollMiddle', function () {
            AppF.goBottom = false;
        });

        $scope.$on('loadMoreConversation', function () {
            $scope.heightBeforeLoad = getScrollHeight();
            if (ChatF.chats[AppF.chatActive].conversation.loadMoreButton) {
                ChatF.chats[AppF.chatActive].conversation.loadMore();
            }
        });

        /**
         * Reply
         */
        function reply() {
            ChatF.sendMsg($scope.CF.chats[AppF.chatActive], ChatF.replyMessage);
            ChatF.replyMessage = "";
        }

        /**
         * Scroll Chat Content to the bottom
         * @param speed
         */
        function scrollToBottomOfChat() {
            $timeout(function () {
                var chatContent = angular.element($document.find('#chat-content'));

                chatContent.animate({
                    scrollTop: chatContent[0].scrollHeight
                }, 400);
            }, 0, false);

        }

        function scrollTo(height) {
            //console.log(height);
            var chatDialog = angular.element('#chat-content');
            $timeout(function () {
                chatDialog.animate({
                    scrollTop: height
                }, 0);
            }, 0, false);
        }

        /**
         * Set User Status
         */


        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Toggle Left Sidenav View
         *
         * @param view id
         */
        function toggleLeftSidenavView(id) {
            $scope.leftSidenavView = id;
        }

        /**
         * Array prototype
         *
         * Get by id
         *
         * @param value
         * @returns {T}
         */



        startAfterInitFilter($scope, watchers, initiated, init);
    }
})();
(function () {
    'use strict';
    angular
        .module('app.core')
        .filter('setDataInObject', setDataInObject);
    /** @ngInject */
    function setDataInObject() {
        return function setData(valueId, allValues, mainObjectToSave, fieldToSave, fieldId) {
            fieldId = fieldId ? fieldId : 'id';
            var thisValue = allValues.find(function (item) {
                return item[fieldId] === valueId;
            });
            if (angular.isDefined(thisValue)) {
                mainObjectToSave[fieldToSave + 'Data'] = thisValue;
            }
        };
    }

})();
(function(){
    'use strict';

    angular
        .module('app.core')
        .filter('refToState', refToState)

    function refToState(){

        return refToStateFn;

        function refToStateFn(ref){
            var state;
            var refPath = ref.split('/');

            switch(refPath[0]){
                case 'catalogs': 
                    state = {
                        state: 'app.clients.' + refPath[1] + '.edit',
                        params: {}
                    };
                    var collection = refPath[1].slice(0, -1);
                    state.params[collection + 'Id'] = refPath[3];
                    // movimientos
                    if(refPath[1].indexOf('movements') !== -1){
                        state.state = 'app.captures.employees';
                    }
                break;
                // @ todo hacer los demas casos ya que quede normalizada la db
            }

            return state;
        }
    }

}());
(function () {
    'use strict';
    angular
        .module('app.core')
        .filter('recalculateEmployeeSbc', recalculateEmployeeSbc);
    /** @ngInject */
    function recalculateEmployeeSbc($q, getSbcFilter, AppF) {
        return function (value, employee, movement, mov) {
            try {
                var sbc = 0,
                    movementDate = 0,
                    sd = 0,
                    enroleDate = 0,
                    movementDate = moment().valueOf();
                if (mov) {
                    sd = movement.data.sd ? movement.data.sd : 0;
                } else {
                    sd = employee.data.salary.sd ? employee.data.salary.sd : 0;
                }
                enroleDate = employee.data.enroleDate ? employee.data.enroleDate : moment().valueOf();
                if (employee) {
                    sbc = getSbcFilter(sd, enroleDate, movementDate, AppF.umaRecord);
                } else {
                    sbc = getSbcFilter(sd, enroleDate, movementDate);
                }
                return (sbc ? sbc : value);
            } catch (error) {
                $log.error(error);
                errAlertS('Error calculando el sbc del empleado');
                return getSbcFilter(0, new Date(), new Date(), AppF.umaRecord);
            }
        }
    }

})();

(function() {
    'use strict';
    angular
        .module('app.core')
        .filter('momentToDate', momentToDate);
    /** @ngInject */
    function momentToDate() {
        return function(milliseconds) {
            return moment(milliseconds).toDate();
        }
    }

})();

(function () {
    'use strict';
    angular
        .module('app.core')
        .filter('loopEach', loopEach);
    /** @ngInject */
    function loopEach() {
        return function (obj, callback) {
            if (angular.isObject(obj) && obj !== null) {
                for (var key in obj) {
                    if (obj.hasOwnProperty(key)) {
                        callback(obj[key], key);
                    }
                }
            }
        };
    }

})();
(function () {
    'use strict';
    angular
        .module('app.core')
        .filter('isEmail', isEmail);
    /** @ngInject */
    function isEmail() {
        return function (email) {
            var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        }
    }

})();
(function(){
    'use strict';

    angular
        .module('app.core')
        .filter('interpretLogRef', interpretLogRef)

    function interpretLogRef(translateFilter){

        return interpretLogRefFn;

        function interpretLogRefFn(ref){
            var interpretation = '';

            var refPath = (typeof ref == 'string') ? ref.split('/') : false; // <- error

            switch(refPath[0]){
                case 'catalogs': interpretation = refPath[1]; break;
                case 'groups': interpretation = refPath[1]; break;
                case 'collection': interpretation = refPath[1]; break;

                case 'incidences': interpretation = refPath[0]; break;
                case 'incidencesRequests': interpretation = refPath[0]; break;
                case 'operations': interpretation = refPath[0]; break;
                case 'profiles': interpretation = refPath[0]; break;
                case 'permissions': interpretation = refPath[0]; break;
                case 'notifications': interpretation = refPath[0]; break;
            }
            interpretation = translateFilter('l.' + interpretation);

            return interpretation;
        }
    }

}());
(function() {
    'use strict';
    angular
        .module('app.core')
        .filter('getValidMovements', getValidMovements);
    /** @ngInject */
    function getValidMovements(orderByFilter) {
        return getValidMovementsFn;

        function getValidMovementsFn(movements, startDate) {
            var validMovements = [];
            movements = orderByFilter(movements, "d");
            var initialDate = moment(startDate);
            initialDate.set(0, "hours");
            initialDate.set(0, "minutes");
            initialDate.set(0, "seconds");
            initialDate.set(0, "milliseconds");
            var indexToConserve = 0;
            for (var i in movements) {
                var movement = movements[i];
                var movementDate = moment(movement.d);
                movementDate.set(0, "hours");
                movementDate.set(0, "minutes");
                movementDate.set(0, "seconds");
                movementDate.set(0, "milliseconds");
                if (movementDate.valueOf() === initialDate.valueOf() && (movement.t == 6 || movement.t == 8 || movement.t == 7)) {
                    indexToConserve = i;
                }
            }
            if (indexToConserve) {
                for (var i in movements) {
                    if (i >= indexToConserve) {
                        validMovements.push(movements[i]);
                    }
                }
            } else {
                validMovements = movements;
            }
            return validMovements;
        }
    }

})();
(function () {
    'use strict';
    angular
        .module('app.core')
        .filter('getTextBetweenDates', getTextBetweenDates);
    /** @ngInject */
    function getTextBetweenDates(uppercaseFilter) {
        return function (start, end) {
            var dayStart = moment(start).format('DD');
            var dayEnd = moment(end).format('DD');
            var monthsStart = moment(start).format('MMM');
            var monthsEnd = moment(end).format('MMM');
            var yearStart = moment(start).format('YYYY');
            var yearEnd = moment(end).format('YYYY');
            var date = dayStart + '-' + dayEnd + ' ' + uppercaseFilter(monthsStart) + ' ' + yearStart;
            if (monthsStart !== monthsEnd && yearStart !== yearEnd) {
                date = dayStart + ' ' + uppercaseFilter(monthsStart) + ' ' + yearStart + ' - ' + dayEnd + ' ' + uppercaseFilter(monthsEnd) + ' ' + yearEnd;
            } else if (monthsStart !== monthsEnd) {
                date = dayStart + ' ' + uppercaseFilter(monthsStart) + ' - ' + dayEnd + ' ' + uppercaseFilter(monthsEnd) + ' ' + yearStart;
            }
            return date;
        }
    }

})();
(function() {
    'use strict';
    angular
        .module('app.core')
        .filter('getSbcEmployee', getSbcEmployee);
    /** @ngInject */
    function getSbcEmployee(recalculateEmployeeSbcFilter, getLastSbcFilter, $log) {
        return function(sbc, employee, movement, mov, lastMovementOfPayroll, getLastMovementOfPayroll) {
            return new Promise(function(resolve, reject) {
                var thisSbc = recalculateEmployeeSbcFilter(sbc, employee, movement, mov);
                var promises = [];
                if (getLastMovementOfPayroll) {
                    promises.push(getLastSbcFilter(employee.$id, employee.payroll));
                }
                Promise.all(promises).then(function(promiseResp) {
                    var lastSbc = 0;
                    if (promiseResp.length) {
                        lastSbc = promiseResp[0];
                    } else if (typeof(lastMovementOfPayroll) == "object" && typeof(lastMovementOfPayroll.data) == "object" && typeof(lastMovementOfPayroll.data.sbc) != "undefined") {
                        lastSbc = lastMovementOfPayroll.data.sbc;
                    }
                    if (lastSbc > thisSbc && employee.movement.type != 8) {
                        resolve(lastSbc);
                    } else {
                        resolve(thisSbc);
                    }
                }).catch(function(err) {
                    $log.error(err, "error al obtener el ultimo sbc del empleado");
                    reject(err);
                })
            })
        }
    }

})();
(function() {
    'use strict';
    angular
        .module('app.core')
        .filter('getSbc', getSbc);
    /** @ngInject */
    function getSbc(getDinamicFactorFilter) {
        return function(sd, enroleDate, movementDate, minimumWage) {
            var factor = getDinamicFactorFilter(enroleDate, movementDate);
            var sbc = Math.round((sd * factor) * 100) / 100;
            if (angular.isDefined(minimumWage) && minimumWage) {
                var limit = minimumWage * 25;
                if (sbc > limit) {
                    sbc = Math.round(limit * 100) / 100;
                }
            }
            return sbc;
        }
    }

})();
(function() {
    'use strict';
    angular
        .module('app.core')
        .filter('getProcessesNames', getProcessesNames);
    /** @ngInject */
    function getProcessesNames() {
        return function(processes, includeReal) {
            var newProcesses = [];

            if (includeReal) {
                angular.forEach(processes, function(process, key) {
                    switch (key) {
                        case "real":
                            newProcesses.push(process.name);
                            break;
                        case "fiscal":
                            newProcesses.push(process.name)
                            break;
                        case "complements":
                            angular.forEach(process, function(complement, key) {
                                newProcesses.push(complement.name);
                            })
                            break;
                    }
                });
            } else {
                angular.forEach(processes, function(process, key) {
                    switch (process.$id) {
                        case "real":
                            break;
                        case "fiscal":
                            newProcesses.push(process.name)
                            break;
                        case "complements":
                            angular.forEach(process, function(complement, key) {
                                newProcesses.push(complement.name);
                            })
                            break;
                    }
                });
            }
            return newProcesses;
        };
    }

})();
(function() {
    'use strict';
    angular
        .module('app.core')
        .filter('getPeriodOfDate', getPeriodOfDate);
    /** @ngInject */
    function getPeriodOfDate() {
        return function(periods, date) {
            var periodFounded = [];
            angular.forEach(periods, function(period) {
                //console.log(period, date, "filtrogePeriodos");
                var periodStart = moment(period.start).startOf('day');
                var dateV = moment(date);
                var periodEnd = moment(period.end).endOf('day');
                // console.log(periodStart.format('DD/MM/YYYY HH:mm:ss'), periodEnd.format('DD/MM/YYYY HH:mm:ss'), dateV.format('DD/MM/YYYY HH:mm:ss'), "C");
                if ((periodStart.valueOf() <= dateV.valueOf()) && (periodEnd.valueOf() >= dateV.valueOf())) {
                    periodFounded.push(period);
                }
            });
            return periodFounded;
        };
    }

})();
(function() {
    'use strict';
    angular
        .module('app.core')
        .filter('getOperationStatusName', getOperationStatusName);
    /** @ngInject */
    function getOperationStatusName(AppF, getObjectOfArrayByIdFilter) {
        return function(status) {
            var name = "";
            var statusN = getObjectOfArrayByIdFilter(status, AppF.operationStatatuss, "id");
            if (statusN) {
                name = statusN.name
            }
            return name;
        };
    }

})();
(function() {
    'use strict';
    angular
        .module('app.core')
        .filter('getMovementsBetweenDates', getMovementsBetweenDates);
    /** @ngInject */
    function getMovementsBetweenDates() {
        return function(movements, startDate, endDate) {
            var movementsFounded = [];
            for (var i in movements) {
                if (typeof(movements[i].$id) == "undefined") {
                    movements[i].$id = i;
                }
                // si el status del movimiento es igual o mayor a 2
                // y la fecha del movimiento es mayor o igual a la fecha inicial
                // y la fecha del movimiento es menor o igual a la fecha final
                // entonces se empujan los movimientos
                var thisStatus = movements[i].s || movements[i].status;
                var thisDate = movements[i].d || movements[i].data.date;
                if (thisStatus >= 2 && thisDate >= startDate && thisDate <= endDate) {
                    movementsFounded.push(movements[i]);
                }
            }
            return movementsFounded;
        };
    }

})();
(function(){
    'use strict';

    angular
        .module('app.core')
        .filter('getMovementStatusName', getMovementStatusName)

    function getMovementStatusName(){

        return getMovementStatusNameFn;

        function getMovementStatusNameFn(status){
            var statusName = '';
            switch(status){
                case "1": statusName = 'Mandar a revisión'; break;
                case "2": statusName = 'Revisar'; break;
                case "3": statusName = 'Mandar a seguro social'; break;
                case "4": statusName = 'Recibir de seguro social'; break;
            }
            return statusName;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('getMinimumWagesOfMovements', getMinimumWagesOfMovements)

    function getMinimumWagesOfMovements($log, DataF, $q, pathInObjFilter) {
        return getMinimumWagesOfMovementsFn;

        // Obtiene el salario mínimo de Mongo si no existe en AppF
        function getMinimumWagesOfMovementsFn(arr, field, fieldToSet, catalogsType) {
            return new Promise(function (resolve, reject) {
                var promises = {};
                var query = {
                    sort: angular.toJson({ 'year': -1 })
                };
                for (var i = 0; i < arr.length; i++) {
                    var dateField = pathInObjFilter(arr[i], field);
                    var finalField = pathInObjFilter(arr[i], fieldToSet);
                    if (dateField && finalField && angular.isUndefined(promises[dateField])) {
                        var thisDate = moment(dateField,"DD/MM/YYYY");
                        thisDate = moment(thisDate.year() + '-' + (thisDate.month() + 1) + '-' + thisDate.date() + ' 00:00 -0500', 'YYYY-MM-DD HH:mm Z');
                        query.applicationDate = { '$lte': thisDate.valueOf() };
                        promises[dateField] = DataF.api.get('one/' + catalogsType, query);
                    }
                }
                console.log(promises);
                $q.all(promises).then(function (resp) {
                    var minimumWages = {};
                    console.log(resp);
                    for (var i = 0; i < arr.length; i++) {
                        var dateField = pathInObjFilter(arr[i], field);
                        var finalField = pathInObjFilter(arr[i], fieldToSet);
                        if (dateField && finalField) {
                            var minimumWage = pathInObjFilter(resp[dateField], 'data.data.0');
                            if (minimumWage) {
                                minimumWages[finalField] = minimumWage;
                            }
                        }
                    }
                    resolve(minimumWages);
                }).catch(reject);
                // var promises = [];
                // var query = {
                //     applicationDate: { '$lte': date },
                //     sort: angular.toJson({ 'year': -1 })
                // };
                // promises.push(DataF.api.get('one/minimumWageRecords', query));
                // promises.push(DataF.api.get('one/umaRecords', query));
                // promises.push(DataF.api.get('one/nfdRecords', query));
                // $q.all(promises).then(function (responses) {
                //     var minimumWageRecords = responses[0].data.data;
                //     var umaRecords = responses[1].data.data;
                //     var nfdRecords = responses[2].data.data;
                //     if (angular.isArray(umaRecords) && angular.isArray(minimumWageRecords) && angular.isArray(nfdRecords) && umaRecords.length > 0 && minimumWageRecords.length > 0 && nfdRecords.length > 0) {
                //         var obj = {
                //             umaRecord: umaRecords[0].value,
                //             minimumVariables: minimumWageRecords[0].values,
                //             nfdRecord: nfdRecords[0].value
                //         }
                //         obj.minimumVariables.year = minimumWageRecords[0].year;
                //         console.log(obj);
                //         resolve(obj);
                //     } else {
                //         reject('No se encontraron registros de salarios minimos');
                //     }
                // }).catch(function (error) {
                //     reject(error);
                // });
            });
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('getMinimumWageOfDate', getMinimumWageOfDate)

    function getMinimumWageOfDate(
        $log,
        DataF,
        $q
    ) {
        return getMinimumWageOfDateFn;

        // Obtiene el salario mínimo de Mongo si no existe en AppF
        function getMinimumWageOfDateFn(date) {
            return new Promise(function (resolve, reject) {
                var promises = [];
                var query = {
                    applicationDate: { '$lte': date },
                    sort: angular.toJson({ 'year': -1 })
                };
                promises.push(DataF.api.get('one/minimumWageRecords', query));
                promises.push(DataF.api.get('one/umaRecords', query));
                promises.push(DataF.api.get('one/nfdRecords', query));
                $q.all(promises).then(function (responses) {
                    var minimumWageRecords = responses[0].data.data;
                    var umaRecords = responses[1].data.data;
                    var nfdRecords = responses[2].data.data;
                    if (angular.isArray(umaRecords) && angular.isArray(minimumWageRecords) && angular.isArray(nfdRecords) && umaRecords.length > 0 && minimumWageRecords.length > 0 && nfdRecords.length > 0) {
                        var obj = {
                            umaRecord: umaRecords[0].value,
                            minimumVariables: minimumWageRecords[0].values,
                            nfdRecord: nfdRecords[0].value
                        }
                        obj.minimumVariables.year = minimumWageRecords[0].year;
                        resolve(obj);
                    } else {
                        $log.log('aqui el error 2')
                        reject('No se encontraron registros de salarios minimos from Date:' + date);
                    }
                }).catch(function (error) {
                    reject(error);
                });
            });
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('getMinimumWage', getMinimumWage)

    function getMinimumWage(
        $log,
        $sessionStorage,
        DataF,
        AppF,
        $q
    ) {
        return getMinimumWageFn;

        // Obtiene el salario mínimo de Mongo si no existe en AppF
        function getMinimumWageFn() {
            return new Promise(function (resolve, reject) {
                if (AppF.umaRecord) {
                    resolve(AppF.umaRecord);
                } else {
                    var promises = [];
                    var query = {
                        applicationDate: { '$lte': AppF.serverTimeStamp },
                        sort: angular.toJson({ 'year': -1 })
                    };
                    promises.push(DataF.api.get('one/minimumWageRecords', query));
                    promises.push(DataF.api.get('one/umaRecords', query));
                    $q.all(promises).then(function (responses) {
                        var minimumWageRecords = responses[0].data.data;
                        var umaRecords = responses[1].data.data;
                        if (angular.isArray(umaRecords) && angular.isArray(minimumWageRecords) && umaRecords.length > 0 && minimumWageRecords.length > 0) {
                            AppF.umaRecord = umaRecords[0].value;
                            AppF.minimumVariables = minimumWageRecords[0].values;
                            AppF.minimumVariables.year = minimumWageRecords[0].year;
                            resolve(AppF.umaRecord);
                        } else {
                            reject('No se encontraron registros de salarios minimos');
                        }
                    }).catch(function (error) {
                        reject(error);
                    });
                }
            });
        }
    }

}());
(function() {
    'use strict';
    angular
        .module('app.core')
        .filter('getLastSbc', getLastSbc);
    /** @ngInject */
    function getLastSbc($rootScope) {
        return function(employeeId,payrollId) {
            return new Promise(function(resolve, reject) {
                var params = {
                    page: 1,
                    size: 1,
                    employee: employeeId,
                    status: {'$in':[3,4]},
                    sort: '-data.date',
                    payroll: payrollId
                };
                $rootScope.D.api.get('p/movements', params).then(function(res) {
                    var lastSbc = 0;
                    var movements = res.data.data;
                    if (movements.length) {
                        lastSbc = movements[0].data.sbc;
                    }
                    resolve(lastSbc);
                }).catch(function(err) {
                    reject(err);
                });
            })
        }
    }

})();
(function () {
    'use strict';
    angular
        .module('app.core')
        .filter('getLastMovemenBeforeDate', getLastMovemenBeforeDate);
    /** @ngInject */
    function getLastMovemenBeforeDate() {
        return function (movements, date, payroll) {
            var movementFounded = [];
            //console.log(movements);
            angular.forEach(movements, function (movement, index) {
                if (angular.isUndefined(movements[index].$id)) {
                    movements[index].$id = index;
                }
                //console.log(movementFounded)
                // si el movimiento es menor a la fecha y el status es mayor o igual a 2 
                // entonces se empuja el movimiento
                var thisDate = movement.d || movement.data.date;
                var thisStatus = movement.s || movement.status;
                var thisPayroll = movement.p || movement.payroll;
                if (thisDate < date && thisStatus >= 2 && (angular.isUndefined(payroll) || angular.isDefined(payroll) && payroll === thisPayroll)) {
                    if (!movementFounded.length) {
                        movementFounded[0] = movement;
                    } else if (movementFounded[0].d < thisDate || (movementFounded[0].data && movementFounded[0].data.date < thisDate)) {
                        movementFounded[0] = movement;
                    }
                }
            });
            return movementFounded;
        };
    }

})();
(function(){
    'use strict';

    angular
        .module('app.core')
        .filter('getFiltersArray', getFiltersArray)

    function getFiltersArray(
        $log
    ){

        return getFiltersArrayFn;

        function getFiltersArrayFn(filters, sfilters){
            var filtersA = [];
            var requiredF = [];
            for(var f in filters){
                var filter = filters[f];
                filtersA.push(filter.by);
                if(filter.required) requiredF.push(filter.by);
            }
            // $log.debug(angular.copy(filtersA), "all in filters", filters, sfilters);
            for(var ff in sfilters){ // already in desired format
                var sfilter = sfilters[ff];
                if(typeof sfilter == 'string') filtersA.push(sfilter);
                else filtersA.push(sfilter.by);
                if(sfilter.required) requiredF.push(sfilter.by);
            }
            // $log.debug(filtersA, "all with $filters");
            return {filters: filtersA, required: requiredF};
        }
    }

}());

(function () {
    'use strict';
    angular
        .module('app.core')
        .filter('getExtraFields', getExtraFields);
    /** @ngInject */
    function getExtraFields($log, ListsF) {
        return function (firm) {
            return new Promise(function (resolve, reject) {
                var extra = [];
                var promises = [];
                if (angular.isDefined(firm)) {
                    promises.push(ListsF.loadList('extras', 'catalogs/firms/collection/' + firm + '/fields', undefined, 'array', 'extrasOfFirm-' + firm));
                }
                Promise.all(promises).then(function (resp) {
                    if (resp.length > 0) {
                        extra = resp[0];
                    }
                    resolve(extra);
                }).catch(reject);
            });
        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('getEmployeesGeozone', getEmployeesGeozone)

    function getEmployeesGeozone($log, AppF, $q, DataF) {
        return getEmployeesGeozoneFn;

        // Obtiene el salario mínimo de Mongo si no existe en AppF
        function getEmployeesGeozoneFn(arr) {
            return new Promise(function (resolve, reject) {
                console.log(arr);
                var ccs = {};
                var places = {};
                var ccsPromises = {};
                for (var i in arr) {
                    if (arr.hasOwnProperty(i) && angular.isDefined(arr[i].cc) && angular.isUndefined(ccsPromises[arr[i].cc])) {
                        ccsPromises[arr[i].cc] = AppF.root.child('catalogs/ccs/collection/' + arr[i].cc + "/data/place").once('value');
                    }
                }
                console.log(ccsPromises);
                $q.all(ccsPromises).then(function (resp) {
                    var placesPromises = {};
                    var count = 0;
                    for (var r in resp) {
                        if (resp.hasOwnProperty(r) && resp[r].exists()) {
                            ccs[r] = resp[r].val();
                            if (angular.isUndefined(placesPromises[resp[r].val()])) {
                                count++;
                                placesPromises[resp[r].val()] = DataF.api.get('placesOfWorkRecords/' + resp[r].val());
                            }
                        }
                    }
                    console.log(ccs);
                    console.log(placesPromises);
                    if (count > 0) {
                        return $q.all(placesPromises);
                    } else {
                        return Promise.all([]);
                    }
                }).then(function (resp) {
                    var geoZonePromises = {};
                    var count = 0;
                    for (var r in resp) {
                        if (resp.hasOwnProperty(r) && angular.isDefined(resp[r].data['geoZone_id'])) {
                            places[r] = resp[r].data['geoZone_id'];
                            if (angular.isUndefined(geoZonePromises[resp[r].data['geoZone_id']])) {
                                count++;
                                geoZonePromises[resp[r].data['geoZone_id']] = DataF.api.get('geoZones/' + resp[r].data['geoZone_id']);
                            }
                        }
                    }
                    console.log(places);
                    console.log(geoZonePromises);
                    if (count > 0) {
                        return $q.all(geoZonePromises);
                    } else {
                        return Promise.all([]);
                    }
                }).then(function (resp) {
                    console.log(resp)
                    var finalObj = {};
                    for (var i in arr) {
                        if (arr.hasOwnProperty(i) && angular.isDefined(arr[i].cc) && angular.isDefined(ccs[arr[i].cc])) {
                            var placeId = ccs[arr[i].cc];
                            if (angular.isDefined(places[placeId])) {
                                var geoZoneId = places[placeId];
                                if (angular.isDefined(resp[geoZoneId])) {
                                    if (angular.isDefined(resp[geoZoneId].data) && angular.isDefined(resp[geoZoneId].data.name)) {
                                        finalObj[arr[i].$id] = resp[geoZoneId].data.name;
                                    }
                                }
                            }
                        }
                    }
                    resolve(finalObj);
                }).catch(reject);
            });
        }
    }

}());
(function () {
    'use strict';
    angular
        .module('app.core')
        .filter('getDinamicSbc', getDinamicSbc);
    /** @ngInject */
    function getDinamicSbc(AppF) {
        return function (sd, factor, employeePayroll, noValidatePayroll, umaRecord, minimumSd) {
            var sbc = Math.round((sd * factor) * 100) / 100;

            if (angular.isUndefined(umaRecord)) {
                umaRecord = AppF.umaRecord;
            }
            var limit = umaRecord * 25;
            if (sbc > limit) {
                sbc = Math.round(limit * 100) / 100;
            }
            if (angular.isNumber(minimumSd) && sbc < minimumSd) {
                sbc = minimumSd;
            }
            return sbc;
        };
    }

})();
(function() {
    'use strict';
    angular
        .module('app.core')
        .filter('getDinamicFactor', getDinamicFactor);
    /** @ngInject */
    function getDinamicFactor(timeDiffFilter) {
        return function(ensuranceInitDate, movementDate) {
            var factor, diff = timeDiffFilter(movementDate, ensuranceInitDate, 'years');
             switch(diff){
                    case 1: factor = 1.0466; break;
                    case 2: factor = 1.0479; break;
                    case 3: factor = 1.0493; break;
                    case 4: factor = 1.0507; break;
                    case 5: factor = 1.0507; break;
                    case 6: factor = 1.0507; break;
                    case 7: factor = 1.0507; break;
                    case 8: factor = 1.0507; break;
                    case 9: factor = 1.0520; break;
                    case 10: factor = 1.0520; break;
                    case 11: factor = 1.0520; break;
                    case 12: factor = 1.0520; break;
                    case 13: factor = 1.0520; break;
                    case 14: factor = 1.0534; break;
                    case 15: factor = 1.0534; break;
                    case 16: factor = 1.0534; break;
                    case 17: factor = 1.0534; break;
                    case 18: factor = 1.0534; break;
                    case 19: factor = 1.0548; break;
                    case 20: factor = 1.0548; break;
                    case 21: factor = 1.0548; break;
                    case 22: factor = 1.0548; break;
                    case 23: factor = 1.0548; break;
                    case 24: factor = 1.0562; break;
                    default: factor = 1.0452; break;
                }
                //console.log(diff,factor, "in years");
                return factor;
        };
    }

})();

(function () {
    'use strict';
    angular
        .module('app.core')
        .filter('getContractTypes', getContractTypes);
    /** @ngInject */
    function getContractTypes($rootScope, AppF) {
        return function ($scope) {
            return new Promise(function (resolve, reject) {
                var query = { type: 'contract', center: AppF.center, project: angular.toJson({ content: 0, styles: 0, fields: 0, created: 0, updated: 0, uid: 0, satContractType: 0 }), firm: angular.toJson({ $in: ['global', $scope.employee.firm] }) };
                $rootScope.D.api.get('documentTypes', query).then(function (resp) {
                    $scope.allDocumentTypes = resp.data;
                    var contractTypes = $scope.allDocumentTypes.filter(function (item) {
                        return item.firm === $scope.employee.firm;
                    });
                    if (contractTypes.length === 0) {
                        contractTypes = $scope.allDocumentTypes.filter(function (item) {
                            return item.firm === 'global';
                        });
                    }
                    if ($scope.employee.data && $scope.employee.data.workerType) {
                        $scope.contractTypes = contractTypes.filter(function (item) {
                            return item.satContractTypeData && item.satContractTypeData.workerType === $scope.employee.data.workerType;
                        });
                    } else {
                        $scope.contractTypes = [];
                    }
                    resolve(contractTypes);
                }).catch(reject);
            });
        };
    }

})();
(function() {
    'use strict';
    angular
        .module('app.core')
        .filter('getCalendarOfDate', getCalendarOfDate);
    /** @ngInject */
    function getCalendarOfDate() {
        return function(calendars, date) {
            var calendarFinded = [];
            angular.forEach(calendars, function(calendar, index) {
                if (calendar.$id && (calendar.data.startDate <= date) && (calendar.data.endDate >= date)) {
                    calendarFinded.push(calendar);
                }
            });
            return calendarFinded;
        };
    }

})();
(function() {
    'use strict';
    angular
        .module('app.core')
        .filter('getAniversaryEmployees', getAniversaryEmployees);
        
    function getAniversaryEmployees(
        getSbcFilter,
        getDinamicFactorFilter
    ) {
        /**
         * @description Aniversarios: a partir del momento en que se consultan, los empleados con nss que tengan más de un año dados de alta y que estén en status 4 (ok) se les sugiere automáticamente un nuevo sbc y factor, para aplicarse en un MDS.
         * Entonces en base a la fecha de alta, se calculan los años que tiene el empleado a la fecha de hoy y en base a dichos años se debe tener un sbc y sd, si dicho empleado tiene un sd y sbc menor al que debe de tener se debe mostrar en aniversarios para su posible envio de MDS
         */
        return function(employees, date, minimumWage) {
            // console.log(employees, date, minimumWage);
            var activeEmployees = [];
            if (angular.isDefined(employees) && angular.isDefined(minimumWage)) {
                if (employees.length) {
                    date = date ? date : moment().valueOf();
                    var year1 = moment().subtract(1, "year").valueOf();
                    angular.forEach(employees, function(employee, index) {
                        if(employee.movements && employee.data.nss){
                            if (employee.data.enroleDate < year1 && employee.status == 4) {
                                if(employee.data.salary){
                                    var sbc = getSbcFilter(employee.data.salary.sd, employee.data.enroleDate, date, minimumWage);
                                    var factor = getDinamicFactorFilter(employee.data.enroleDate, date);
                                    if (employee.data.salary.sbc < sbc) {
                                        employee.data.newSbc = sbc;
                                        employee.data.factor = factor;
                                        activeEmployees.push(employee);
                                    }
                                }
                            }
                        }
                    });
                }
            }
            // console.log(activeEmployees);
            return activeEmployees;
        };
    }

})();
(function() {
    'use strict';
    angular
        .module('app.core')
        .filter('getActiveEmployees', getActiveEmployees);
    /** @ngInject */
    function getActiveEmployees(
        getMovementsBetweenDatesFilter,
        getLastMovemenBeforeDateFilter,
        getValidMovementsFilter
    ) {
        return getActiveEmployeesFn;

        function getActiveEmployeesFn(employees, startDate, endDate) {
            var activeEmployees = [];
            angular.forEach(employees, function(employee) {
                var movements = [];
                var movementBeforeDate = getLastMovemenBeforeDateFilter(employee.movements, startDate);
                if (movementBeforeDate.length && movementBeforeDate[0].t != 2) {
                    movements = movements.concat(movementBeforeDate);
                }
                var movementsBetweenDates = getMovementsBetweenDatesFilter(employee.movements, startDate, endDate);
                movements = movements.concat(movementsBetweenDates);
                movements = getValidMovementsFilter(movements,startDate);
                if (movements.length) {
                    employee.movements = movements;
                    activeEmployees.push(employee);
                }
            });
            return activeEmployees;
        }
    }

})();
(function () {
    'use strict';
    angular
        .module('app.core')
        .filter('geEmployeesByBatch', geEmployeesByBatch);
    /** @ngInject */
    function geEmployeesByBatch() {

        return geEmployeesByBatchFn;

        function geEmployeesByBatchFn(fn, fnName, fnQuery, employeesIds, data) {
            return new Promise(function (resolve, reject) {
                try {
                    data = data ? data : [];
                    if (employeesIds.length === 0) {
                        resolve(data)
                    } else {
                        var thisEmployeesIds = employeesIds.splice(0, (employeesIds.length > 50 ? 50 : employeesIds.length));
                        fn(fnName, fnQuery(thisEmployeesIds)).then(function (response) {
                            data = data.concat(response.data);
                            resolve(geEmployeesByBatchFn(fn, fnName, fnQuery, employeesIds, data))
                        }).catch(reject)
                    }
                } catch (error) {
                    reject(error);
                }
            });
        }
    }
})();
(function () {
    'use strict';
    angular
        .module('app.core')
        .filter('byArrayField', byArrayField);
    /** @ngInject */
    function byArrayField($log) {
        function anyIsArray(arrayTerms) {
            var flag = false;
            for (var i = 0; i < arrayTerms.length && !flag; i++) {
                if (angular.isArray(arrayTerms[i])) {
                    flag = true;
                }
            }
            return flag;
        }
        return function (array, arrayTermsP, fieldsP) {
            // $log.log(arguments);
            var arrayTerms, fields;
            if (!angular.isArray(arrayTermsP)) {
                arrayTerms = [arrayTermsP];
            } else {
                arrayTerms = arrayTermsP;
            }
            if (!angular.isArray(fieldsP)) {
                fields = [fieldsP];
            } else {
                fields = fieldsP;
            }
            var thisArray = [];
            if (angular.isArray(array)) {
                if (angular.isArray(arrayTerms) && arrayTerms.length > 0) {
                    thisArray = array.filter(function (item) {
                        var flag = true;
                        for (var a = 0; a < arrayTerms.length && flag; a++) {
                            var valueOfRecord = item[fields[a]];
                            var valuesAceptables = arrayTerms[a];
                            if (angular.isDefined(valuesAceptables)) {
                                if (angular.isArray(valuesAceptables)) {
                                    flag = valuesAceptables.indexOf(valueOfRecord) > -1;
                                } else {
                                    flag = valueOfRecord === valuesAceptables;
                                }
                            }
                        }
                        return flag;
                    });
                } else {
                    thisArray = array;
                }
            }
            return thisArray;
        };
    }

})();
(function() {
    'use strict';
    angular
        .module('app.core')
        .filter('addFieldToElementsArray', addFieldToElementsArray);
    /** @ngInject */
    function addFieldToElementsArray() {
        return function(arrayElements, fields) {
            for (var i = 0; i < arrayElements.length; i++) {
                for (var f in fields) {
                    arrayElements[i][f] = fields[f];
                }
            }
            return arrayElements;
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('fbSearchBar', fbSearchBar)
        .directive('fbDashboardBar', fbDashboardBar)
        .directive('fbSearchBar2', fbSearchBar2)
        .directive('filterToolbar', filterToolbar)
        .directive('filterToolbarEmployees', filterToolbarEmployees)
        .directive('mongoSearchBar', mongoSearchBar)
        .directive('mongoCrudDetailBar', mongoCrudDetailBar)
        .directive('fbCrudDetailBar', fbCrudDetailBar)
        .directive('countIcon', countIcon)
        .directive('ignoreMouseWheel', ignoreMouseWheel)
        .directive('ccChild', ccChild)


    /** @ngInject */

    function countIcon() {

        return {
            restrict: 'AE',
            scope: {
                array: '='
            },
            replace: true,
            transclude: true,
            templateUrl: 'app/main/acommon/directives/count-icon.html'
        }
    }

    function ccChild() {
        return {
            restrict: 'C',
            scope: {
                object: '=',
                form: '=',
                parent: '=',
                type: '<',
                mode: '<',
                ccList: '<',
                ccListByPayroll: '<',
                concepts: '<',
                parentIsConcept: '<',
                childIndex: '<',
                rootObj: '<'
            },
            templateUrl: 'app/main/acommon/directives/cc-child.html',
            controller: 'CcChildController',
            controllerAs: 'ccCtrl'
        }
    }

    function fbSearchBar(
    ) {

        return {
            restrict: 'A',
            scope: true,
            replace: true,
            templateUrl: 'app/main/acommon/directives/fb-search-bar.html'
        }
    }

    function fbSearchBar2(

    ) {

        return {
            restrict: 'A',
            scope: true,
            replace: true,
            templateUrl: 'app/main/acommon/directives/fb-search-bar-2.html'
        }
    }

    function fbDashboardBar(

    ) {

        return {
            restrict: 'A',
            scope: true,
            replace: true,
            templateUrl: 'app/main/acommon/directives/fb-dashboard-bar.html'
        }
    }

    function fbCrudDetailBar(

    ) {
        return {
            restrict: 'A',
            templateUrl: 'app/main/acommon/directives/fb-crud-detail-bar.html',
            link: function (scope, elem, attr) {
                scope.addMethod = 'add';
                scope.saveMethod = 'save';
                if (attr.addMethod) {
                    scope.addMethod = attr.addMethod;
                }
                if (attr.saveMethod) {
                    scope.saveMethod = attr.saveMethod;
                }
            }
        }
    }

    function mongoSearchBar(

    ) {
        return {
            restrict: 'A',
            scope: true,
            replace: true,
            templateUrl: 'app/main/acommon/directives/mongo-search-bar.html'
        }
    }

    function mongoCrudDetailBar(

    ) {
        return {
            restrict: 'A',
            scope: true,
            templateUrl: 'app/main/acommon/directives/mongo-crud-detail-bar.html'
        }
    }

    function filterToolbar(
        RoutesF,
        AppF,
        getFiltersArrayFilter
    ) {
        return {
            link: function (scope) {
                // scope.F = AppF;
                AppF.hideFilters = false;
                scope.toggleBar = function () {
                    AppF.hideFilters = !AppF.hideFilters;
                }
                // var typeOfCatalog = (RoutesF.fbCatalogs.indexOf(AppF.active.menuName) !== -1) ? 'fb' : 'mongo';
                var ff = getFiltersArrayFilter(AppF.active.filters, AppF.active.$filters);
                scope.ffilters = ff.filters;
                // console.log(scope.ffilters, scope.$filters, "WTF");
            },
            templateUrl: 'app/main/acommon/directives/filter-toolbar.html',
            restrict: 'AE',
            transclude: true
        }
    }

    function ignoreMouseWheel() {
        return {
            restrict: 'A',
            link: function (scope, element) {
                element.bind('mousewheel', function () {
                    element.blur();
                });
            }
        }
    }

    // @todo:backlog unificar este con el otro y hacer que filtren datos dinamicamente (ya cargados)
    function filterToolbarEmployees(
        RoutesF,
        AppF,
        ListsF
    ) {
        return {
            scope: {
                filters: '=',
                tabName: '@'
            },
            link: function (scope) {
                scope.F = AppF;

                AppF.hideFilters = true;
                scope.toggleBar = function () {
                    AppF.hideFilters = !AppF.hideFilters;
                }
                scope.L = ListsF;
            },
            templateUrl: 'app/main/acommon/directives/filter-toolbar.html',
            restrict: 'AE',
            transclude: true
            // replace: true
        }
    }

}());
/* eslint-disable angular/json-functions */
(function () {
    'use strict';
    angular
        .module('app.core')
        .controller('CcChildController', CcChildController);
    /** @ngInject */
    function CcChildController($scope, $log, AppF) {
        var vm = this;
        vm.object = $scope.object;
        vm.parentIsConcept = $scope.parentIsConcept;
        vm.mode = AppF.readMode ? 'readMode' : 'editMode';
        if (vm.object.type === 'concept' && (!angular.isArray(vm.object.concepts))) {
            vm.object.concepts = [];
        }
        function setCcListByPayroll() {
            vm.ccListByPayroll = JSON.parse(JSON.stringify($scope.ccListByPayroll));
        }
        function setConcepts() {
            if (angular.isArray(vm.object.concepts) && vm.object.concepts.length > 0) {
                var conceptsWithData = vm.object.concepts.map(function (item) {
                    var thisItem = $scope.concepts.find(function (concept) {
                        return concept.fid === item;
                    });
                    var obj = { fid: item };
                    if (angular.isDefined(thisItem)) {
                        obj.name = thisItem.name;
                        if (thisItem.payroll !== 'global') {
                            obj.payrollName = thisItem.payrollName;
                        }
                    }
                    return obj
                });
                vm.conceptsWithData = conceptsWithData;
            }
        }
        //? agregar campo si es text o selection
        vm.addCondition = function (ccId) {
            if (!angular.isArray(vm.object.conditions)) {
                vm.object.conditions = [];
            }
            vm.ccId = undefined;
            vm.object.conditions.push({ account: '', ccId: ccId });
        };
        //?Eliminar campos agregados
        vm.removeCondition = function (index) {
            vm.object.conditions.splice(index, 1);
            $scope.form.$setDirty();
        };
        //?Cambiar de modo con centro de costos
        vm.toggleConditioned = function () {
            if (vm.object.conditioned) {
                // vm.object.conditions = [{}];
                delete vm.object.account;
                delete vm.object.name;
            } else {
                delete vm.object.conditions;
            }
        };
        vm.addChildren = function (type) {
            if (!angular.isArray(vm.object.children)) {
                vm.object.children = []
            }
            vm.object.children.unshift({ type: type })
        }
        vm.deleteLevel = function (parent, index) {
            $log.log('deleting Level', index, parent);
            if (angular.isArray(parent)) {
                parent.splice(index, 1);
                $scope.form.$setDirty();
            }
        }
        function getAllConceptsUsed(obj) {
            var thisArray = [];
            if (angular.isArray(obj)) {
                thisArray = obj.reduce(function (current, item) {
                    if (item.type === 'concept' && angular.isArray(item.concepts) && item.concepts.length > 0) {
                        current = current.concat(item.concepts);
                    } else if (angular.isArray(item.children) && item.children.length > 0) {
                        current = current.concat(getAllConceptsUsed(item.children))
                    }
                    return current;
                }, thisArray)
            }
            return thisArray;
        }
        vm.querySearch = function (search) {
            var lowerCaseSearch = search.toLowerCase();
            var allConceptIdsUsed = getAllConceptsUsed($scope.rootObj)
            var thisConcepts = $scope.concepts.filter(function (item) {
                var flag = allConceptIdsUsed.indexOf(item.fid) === -1;
                if (flag) {
                    flag = item.name.toLowerCase().indexOf(lowerCaseSearch) > -1;
                }
                return flag;
            })
            return thisConcepts;
        }
        vm.transformChip = function (data) {
            return data.fid;
        }
        if ($scope.object.type === 'concept' && $scope.object.concepts.length > 0 && this.mode === 'readMode') {
            var conceptsWatch = $scope.$watch('concepts', function (newValue) {
                if (angular.isArray(newValue) && newValue.length > 0) {
                    conceptsWatch();
                    setConcepts();
                }
            }, true);
        } else if ($scope.object.type === 'level' && this.mode !== 'readMode') {
            var ccListByPayrollWatch = $scope.$watch('ccListByPayroll', function (newValue) {
                if (angular.isArray(newValue) && newValue.length > 0) {
                    ccListByPayrollWatch();
                    setCcListByPayroll();
                }
            }, true);
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.quick-panel', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider, msApiProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/quick-panel');

        // Api
        // msApiProvider.register('quickPanel.activities', ['app/data/quick-panel/activities.json']);
        // msApiProvider.register('quickPanel.contacts', ['app/data/quick-panel/contacts.json']);
        // msApiProvider.register('quickPanel.events', ['app/data/quick-panel/events.json']);
        // msApiProvider.register('quickPanel.notes', ['app/data/quick-panel/notes.json']);
    }
})();

(function () {
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('ChatTabController', ChatTabController);

    /** @ngInject */
    function ChatTabController($scope, $timeout, startAfterInitFilter, $mdDialog, $log, $rootScope, ChatF, successAlertS, AppF) {
        var initiated = false;
        var watchers = {};
        $scope.CF = ChatF;
        $scope.chatActive = false;
        $scope.replyMessage = 'nuevo';
        $scope.toggleChat = toggleChat;
        $scope.toggleChatByContactId = toggleChatByContactId;
        $scope.sendMsg = sendMsg;
        $scope.deleteChatActive = deleteChatActive;
        $scope.byfilter = { 'status': 'online' };
        $scope.setStatus = function (status) {
            if (angular.isDefined(status)) {
                $scope.byfilter = { 'status': status };
            } else {
                $scope.byfilter = {};
            }
        };
        function deleteChatActive() {
            $scope.chatActive = undefined;
        }

        var init = function () {
            ChatF.init();
        };

        function sendMsg() {
            ChatF.sendMsg(ChatF.chats[$scope.indexActive], ChatF.replyMessageQuick);
            ChatF.replyMessageQuick = '';
        }

        function toggleChatByContactId(contactId) {
            var key = ChatF.addChatByProfileId(contactId);
            toggleChat(key);
        }

        function archiveConversation(event, chat) {
            var confirm = $mdDialog.confirm().
                title('Archivar Conversación')
                .textContent('Desea mandar esta conversación a archivados?')
                .ariaLabel('Está Seguro(a)?')
                .targetEvent(event)
                .ok('OK')
                .cancel('Cancelar');
            $mdDialog.show(confirm).then(function () {
                var promises = [];
                if (chat.id) {
                    promises.push($scope.F.root.child('chats/' + chat.id + '/participants/' + AppF.profile.uid + '/archived').set(true));
                }
                return Promise.all(promises);
            }).then(function () {
                successAlertS('Se archivó el chat con éxito');
            }).catch(function (error) {
                if (error) {
                    $log.error(error);
                }
            });
        }
        $scope.archiveConversation = archiveConversation;

        function toggleChat(indexActive) {
            $scope.goBottom = true;
            $scope.indexActive = indexActive;
            $scope.chatActive = true;
            ChatF.loadConversation(ChatF.chats[$scope.indexActive]);
            changeUnreadedMsg(ChatF.chats[$scope.indexActive]);
        }

        function changeUnreadedMsg(chat) {
            ChatF.changeUnreadedMsg(chat);
        }

        function scrollToBottomOfChat(speed) {
            var chatDialog = angular.element('#chat-dialog');
            $timeout(function () {
                chatDialog.animate({
                    scrollTop: chatDialog[0].scrollHeight
                }, speed);
            }, 0, false);
        }

        function scrollTo(height) {
            //console.log(height);
            var chatDialog = angular.element('#chat-dialog');
            $timeout(function () {
                chatDialog.animate({
                    scrollTop: height
                }, 0);
            }, 0, false);
        }

        function getScrollHeight() {
            var chatDialog = angular.element('#chat-dialog');
            return chatDialog[0].scrollHeight;
        }

        watchers.newMessage = $rootScope.$on('nuevoMensajeCargado', function () {
            $scope.$evalAsync(function () {
                $timeout(function () {
                    if ($scope.goBottom) {
                        scrollToBottomOfChat(0);
                    } else {
                        $scope.heightAfterLoad = getScrollHeight();
                        scrollTo($scope.heightAfterLoad - $scope.heightBeforeLoad);
                    }
                }, 0, false);
            });
        });

        $scope.$on('ngRepeatFinished', function () {
            if ($scope.goBottom) {
                scrollToBottomOfChat(0);
            }
        });

        $scope.$on('autoScrollBottom', function () {
            $scope.goBottom = true;
        });
        $scope.$on('scrollMiddle', function () {
            $scope.goBottom = false;
        });

        $scope.$on('loadMoreConversation', function () {
            $scope.heightBeforeLoad = getScrollHeight();
            if (ChatF.chats[$scope.indexActive].conversation.loadMoreButton) {
                ChatF.chats[$scope.indexActive].conversation.loadMore();
            }
        });
        startAfterInitFilter($scope, watchers, initiated, init);

    }

})();
(function() {
    'use strict';

    angular
        .module('app.core')
        .directive('zerofilled', zerofilled);


    /** @ngInject */
    function zerofilled() {
        return {
            require: 'ngModel',
            restrict: 'C',
            link: function(ele, attrs, scope, modelCtrl) {
                //ele.attr('ng-change',ngModel.$viewValue.toUpperCase());
                var capitalize = function(inputValue) {
                    if (inputValue != undefined) {
                        var zerofilled = inputValue + "";
                        var chartsNumbers = scope.charts ? parseInt(scope.charts) : 1;
                        if (zerofilled.length < chartsNumbers) {
                            var count = 0;
                            while (zerofilled.length < chartsNumbers && count < chartsNumbers) {
                                count++;
                                zerofilled = "0" + zerofilled;
                            }
                        }
                        if (zerofilled !== inputValue) {
                            modelCtrl.$setViewValue(zerofilled);
                            modelCtrl.$render();
                        }
                        return zerofilled;
                    }else {
                        return;
                    }
                };
                modelCtrl.$parsers.push(capitalize);
                modelCtrl.$formatters.push(capitalize);
            }
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('uniqueFb3', uniqueFb3);


    /** @ngInject */
    function uniqueFb3(
        $q,
        $rootScope,
        $log,
        AppF
    ) {

        return {
            require: 'ngModel',
            restrict: 'A',
            scope: {
                equal: '=',
                notEqual: '='
            },
            link: function (scope, elem, attr, ngModel) {
                var listen = function () {
                    ngModel.$asyncValidators.unique = function (modelValue, viewValue) {
                        var deferred = $q.defer();
                        var value = modelValue || viewValue;
                        var doValidation = function () {
                            if (ngModel.$viewValue && value) {
                                if (angular.isUndefined(AppF.uniqueQueries[value])) AppF.uniqueQueries[value] = {};
                                AppF.uniqueQueries[value].ref = attr.ref;
                                AppF.uniqueQueries[value].query = attr.query;
                                AppF.uniqueQueries[value].fromid = attr.fromid;
                                $log.debug('querying fb ref, query, value', attr.ref, attr.query, value);
                                var ref = AppF.root.child(attr.ref).orderByChild(attr.query).equalTo(value);
                                ref.on('value', function (snap) {
                                    var val = snap.val();
                                    var exist = false;
                                    if (val == null) {
                                        AppF.uniqueQueries[value].result = true;
                                        ngModel.$setValidity('unique', true);
                                        deferred.resolve(true);
                                    } else {
                                        for (var key in val) {
                                            if ((angular.isUndefined(val[key].center) || val[key].center === AppF.center)) {
                                                if (attr.payrollid) {
                                                    if (attr.payrollid === val[key].payroll && key !== attr.fromid) {
                                                        exist = true;
                                                        break;
                                                    }
                                                } else {
                                                    if (key !== attr.fromid) {
                                                        exist = true;
                                                        break;
                                                    }
                                                }
                                            }
                                        }
                                        if (exist) {
                                            AppF.uniqueQueries[value].result = false;
                                            ngModel.$setValidity('unique', false);
                                            ngModel.$setDirty();
                                            ngModel.$setTouched();
                                            deferred.reject(false);
                                        } else {
                                            AppF.uniqueQueries[value].result = true;
                                            ngModel.$setValidity('unique', true);
                                            deferred.resolve(true);
                                        }
                                    }
                                }, function (err) {
                                    AppF.uniqueQueries[value].result = false;
                                    deferred.reject(err);
                                });
                                // } else {
                                //     $log.debug(AppF.uniqueQueries[value], 'uniqueQueries in Memory')
                                //     ngModel.$setValidity('unique', AppF.uniqueQueries[value].result);
                                //     if(!AppF.uniqueQueries[value].result){
                                //         ngModel.$setDirty();
                                //         ngModel.$setTouched();
                                //         deferred.reject(false);
                                //     } else {
                                //         deferred.resolve(AppF.uniqueQueries[value].result);
                                //     }

                                // }
                            } else {
                                ngModel.$setValidity('unique', true);
                                deferred.resolve(true);
                            }
                        }

                        if (angular.isDefined(scope.equal) && scope.equal != null) {
                            if (value == scope.equal) {
                                doValidation();
                            } else {
                                ngModel.$setValidity('unique', true);
                                deferred.resolve(true);
                            }
                        } else {
                            if (value !== scope.notEqual) {
                                doValidation();
                            } else {
                                ngModel.$setValidity('unique', true);
                                deferred.resolve(true);
                            }
                        }
                        return deferred.promise;
                    };
                }

                // scope.$watchGroup(['onlyIf','equal', 'notEqual'], function(allInScope){
                //     if(angular.isDefined(allInScope[0]) || angular.isDefined(allInScope[1]) || angular.isDefined(allInScope[2])){
                //         listen();
                //     }
                // });

                var watchers = {};
                watchers.listenAgainIfFieldChange = $rootScope.$watch(function () {
                    return attr.payrollid;
                }, function (payrollid) {
                    if (payrollid) {
                        ngModel.$validate();
                    }
                });
                watchers.finalListener = scope.$on("$destroy", function () {
                    for (var f in watchers) {
                        if (watchers.hasOwnProperty(f)) {
                            watchers[f]();
                        }
                    }
                });
                $rootScope.$on('allLoaded', function (allLoaded) {
                    if (allLoaded && ngModel.$viewValue) listen();
                })
                if ($rootScope.F.profile && ngModel.$viewValue) {
                    listen();
                }
                listen();
            }
        }
    }
}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('uniqueFb2', uniqueFb2);


    /** @ngInject */
    function uniqueFb2(
        $q,
        $rootScope,
        $log,
        AppF
    ) {

        return {
            require: 'ngModel',
            restrict: 'A',
            link: function (scope, elem, attr, ngModel) {
                attr.$observe('extra', function () {
                    ngModel.$validate();
                });
                attr.$observe('ref', function () {
                    ngModel.$validate();
                });
                attr.$observe('secondExtra', function () {
                    ngModel.$validate();
                });
                var listen = function () {
                    ngModel.$asyncValidators.unique = function (modelValue, viewValue) {
                        var deferred = $q.defer();
                        var value = modelValue || viewValue;
                        if (ngModel.$viewValue && value) {
                            if (angular.isUndefined(AppF.uniqueQueries[value])) AppF.uniqueQueries[value] = {};
                            $log.debug('querying fb 2 ref, query, value', attr.ref, attr.query, value, attr.extra, attr.extraField);
                            AppF.root.child(attr.ref).orderByChild(attr.query).equalTo(value).on('value', function (snap) {
                                var val = snap.val();
                                if (val == null) {
                                    AppF.uniqueQueries[value].result = true;
                                    ngModel.$setValidity('uniqueInBoth', true);
                                    deferred.resolve(true);
                                } else {
                                    var allCool = true;
                                    snap.forEach(function (row) {
                                        var valueOfSnap = row.val();
                                        var validation = (angular.isUndefined(valueOfSnap.center) || valueOfSnap.center === AppF.center);
                                        validation = validation && valueOfSnap[attr.extraField] === attr.extra;
                                        validation = validation && valueOfSnap[attr.secondExtraField] === attr.secondExtra;
                                        validation = validation && row.key !== attr.fromid;
                                        if (validation) {
                                            allCool = false;
                                        }
                                    });

                                    if (allCool) {
                                        ngModel.$setValidity('uniqueInBoth', true);
                                        deferred.resolve(true);
                                    } else {
                                        ngModel.$setValidity('uniqueInBoth', false);
                                        ngModel.$setDirty();
                                        ngModel.$setTouched();
                                        $rootScope.$evalAsync();
                                        deferred.reject(false);
                                    }
                                }
                            }, function (err) {
                                AppF.uniqueQueries[value].result = false;
                                deferred.reject(err);
                            });
                        } else {
                            deferred.resolve(true);
                        }

                        return deferred.promise;
                    };
                };
                $rootScope.$on('allLoaded', function (allLoaded) {
                    if (allLoaded && ngModel.$viewValue) listen();
                });
                if ($rootScope.F.profile && ngModel.$viewValue) {
                    listen();
                }
                listen();
            }
        }
    }
}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('uniqueFb', uniqueFb);


    /** @ngInject */
    function uniqueFb(
        $q,
        $rootScope,
        $log,
        AppF,
        $firebaseArray,
        ListsF,
        pathInObjFilter
    ) {

        return {
            require: 'ngModel',
            restrict: 'A',
            link: function (scope, elem, attr, ngModel) {
                var watchers = {};
                function validate(currentValue) {
                    return new Promise(function (resolve, reject) {
                        var ref = attr.ref;
                        var query = attr.query;
                        var fromid = attr.fromid;
                        var andFilter = attr.andfilter ? angular.fromJson(attr.andfilter) : undefined;
                        // $log.log(ref, query, fromid, andFilter, currentValue);
                        if (angular.isUndefined(ref) || angular.isUndefined(query) || ngModel.$isEmpty(currentValue) || ['00000000000', 'XEXX010101ENEXXXA0', 'XAXX010101000'].indexOf(currentValue) > -1) {
                            resolve(true);
                        } else if (attr.ignoreUnique === 'true') {
                            resolve(true);
                        } else {
                            var queries = [
                                { q: 'orderByChild', v: query },
                                { q: 'equalTo', v: currentValue }
                            ];
                            ListsF.loadList('ref', ref, undefined, undefined, ref + ' - ' + currentValue, queries).then(function (objects) {
                                var isUnique = true;
                                if (objects.length > 0) {
                                    for (var o = 0; o < objects.length && isUnique; o++) {
                                        var thisObject = objects[o];
                                        if ((angular.isUndefined(thisObject.center) || thisObject.center === AppF.center) && thisObject.$id !== fromid) {
                                            if (angular.isDefined(andFilter) && angular.isObject(andFilter)) {
                                                var allIsEqual = true;
                                                for (var path in andFilter) {
                                                    if (andFilter.hasOwnProperty(path) && allIsEqual) {
                                                        var thisObjectValue = pathInObjFilter(thisObject, path, undefined, 'undefined');
                                                        var value = andFilter[path];
                                                        if (angular.isString(value) && value.indexOf('function:') > -1) {
                                                            var fn = value.replace('function:', '');
                                                            var result = true;
                                                            switch (fn) {
                                                                case '!isEmpty':
                                                                    result = thisObjectValue !== 'undefined';
                                                                    break;
                                                            }
                                                            allIsEqual = result;
                                                        } else if (thisObjectValue !== value) {
                                                            allIsEqual = false;
                                                        }
                                                    }
                                                }
                                                isUnique = !allIsEqual;
                                            } else {
                                                isUnique = false;
                                            }
                                        }
                                    }
                                }
                                if (isUnique) {
                                    resolve(true);
                                } else {
                                    reject(false);
                                }
                                scope.$evalAsync();
                            }).catch(reject);
                        }
                    });
                }

                ngModel.$asyncValidators.unique = function (modelValue) {
                    return validate(modelValue).then(function () {
                        return true;
                    }).catch(function (error) {
                        $log.error(error);
                        ngModel.$setDirty();
                        ngModel.$setTouched();
                        return new Promise(function (resolve, reject) {
                            reject(error);
                        });
                    });
                };

                watchers.listenAgainIfFilterChange = $rootScope.$watch(function () {
                    return attr.andfilter;
                }, function (andfilter) {
                    if (andfilter) {
                        ngModel.$validate();
                    }
                });

                watchers.finalListener = scope.$on("$destroy", function () {
                    for (var f in watchers) {
                        if (watchers.hasOwnProperty(f)) {
                            watchers[f]();
                        }
                    }
                });
            }
        };
    }
}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('uniqueFbKey', uniqueFbKey);


    /** @ngInject */
    function uniqueFbKey($q, $rootScope) {

        return {
            require: 'ngModel',
            restrict: 'A',
            link: function (scope, elem, attr, ngModel) {
                var listen = function () {
                    ngModel.$asyncValidators.unique = function (modelValue, viewValue) {
                        var deferred = $q.defer();
                        if (ngModel.$viewValue) {
                            var value = modelValue || viewValue;
                            value = value + '';
                            if(attr.ref !== ''){
                                firebase.database().ref(attr.ref).orderByKey().equalTo(value).limitToFirst(1).on('value', function (snap) {
                                    if (snap.val() == null) {
                                        ngModel.$setValidity('unique', true);
                                        deferred.resolve(true);
                                    } else {
                                        snap.forEach(function (row) {
                                            if (row.key !== attr.fromid) {
                                                ngModel.$setValidity('unique', false);
                                                ngModel.$setDirty();
                                                ngModel.$setTouched();
                                                deferred.reject(false);
                                            } else {
                                                ngModel.$setValidity('unique', true);
                                                deferred.resolve(true);
                                            }
                                        });
                                    }
                                }, function (err) {
                                    deferred.reject(false);
                                });
                            }else{
                                deferred.resolve(true);
                            }
                        } else {
                            deferred.reject(false);
                        }
                        return deferred.promise;
                    };
                }

                $rootScope.$on('allLoaded', function (allLoaded) {
                    if (allLoaded && ngModel.$viewValue) listen();
                })
                if ($rootScope.F.profile && ngModel.$viewValue) {
                    listen();
                }
                listen();
            }
        }
    }
}());
(function () {
    'use strict';
    angular
        .module('app.core')
        .directive('uniqueMongoV2', uniqueMongoV2);

    /** @ngInject */
    function uniqueMongoV2(
        $q,
        $rootScope,
        $log,
        AppF,
        $firebaseArray,
        ListsF,
        pathInObjFilter,
        DataF
    ) {

        return {
            require: 'ngModel',
            restrict: 'A',
            link: function (scope, elem, attr, ngModel) {
                var watchers = {};
                function validate(currentValue) {
                    return new Promise(function (resolve, reject) {
                        var centerOfEmployee = attr.includecenter;
                        var ignoreValidationPath = attr.ignorevalidationpath;
                        var catalog = attr.catalog;
                        var field = attr.field;
                        var fromid = attr.fromid;
                        var andFilter = attr.andfilter ? angular.fromJson(attr.andfilter) : undefined;
                        if (
                            angular.isUndefined(catalog) ||
                            angular.isUndefined(field) ||
                            ngModel.$isEmpty(currentValue) ||
                            ['00000000000', 'XEXX010101ENEXXXA0', 'XAXX010101000'].indexOf(currentValue) > -1
                        ) {
                            return resolve(true);
                        }
                        if (attr.ignoreUnique === 'true') {
                            return resolve(true);
                        }
                        var queryData = {};
                        queryData[field] = currentValue;

                        if (centerOfEmployee) {
                            queryData.center = AppF.center;
                        }

                        if (andFilter && typeof andFilter === 'object') {
                            angular.extend(queryData, andFilter);
                        }
                        DataF.api.get(catalog, queryData).then(function (resp) {
                            var results = Array.isArray(resp.data) ? resp.data : [];
                            var hasConflict = results.some(function (record) {
                                if (fromid && record.fid === fromid) {
                                    return false;
                                }
                                var ignoreValidation = record.ignoreValidation || {};
                                var isIgnored = ignoreValidationPath &&
                                    ignoreValidation[ignoreValidationPath] === true;

                                // Si NO está ignorado, entonces es conflicto
                                return !isIgnored;
                            });

                            if (hasConflict) {
                                return reject(false);
                            } else {
                                return resolve(true);
                            }
                        }).catch(function (err) {
                            // En caso de error de la API, por seguridad podrías:
                            //   - resolver true (no bloquear al usuario)
                            //   - o rechazar (depende de tu política)
                            $log.error('uniqueFb => Error en la consulta de unicidad:', err);
                            // Aquí asumo que preferimos NO bloquear al usuario:
                            return resolve(true);
                        });
                    });
                }

                // Async validator de Angular
                ngModel.$asyncValidators.unique = function (modelValue) {
                    return validate(modelValue)
                        .then(function () {
                            return true; // válido
                        })
                        .catch(function (error) {
                            $log.error('uniqueFb => asyncValidator rechazado:', error);
                            ngModel.$setDirty();
                            ngModel.$setTouched();
                            // Rechazar para que Angular marque el campo como inválido
                            return $q.reject(error || false);
                        });
                };

                // Revalidar si cambia el field (por si cambias qué campo se valida)
                watchers.listenAgainIfFilterChange = $rootScope.$watch(function () {
                    return attr.field;
                }, function (newField) {
                    if (newField) {
                        ngModel.$validate();
                    }
                });

                watchers.finalListener = scope.$on('$destroy', function () {
                    for (var f in watchers) {
                        if (watchers.hasOwnProperty(f) && typeof watchers[f] === 'function') {
                            watchers[f]();
                        }
                    }
                });
            }
        };
    }
}());

(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('tableValues', tableValues);


    /** @ngInject */
    function tableValues() {
        return {
            transclude: true,
            scope: {
                tableOfValues: '=',
                defaultValue: '=',
                label: '@',
                formDisabled: '<',
                form: '=',
                helpText: '@',
                showLabelAllways: '<',
                editMode: '='
            },
            restrict: 'E',
            templateUrl: 'app/core/directives/table-values/table-values.html',
            link: function (scope) {
                var watchers = {};
                function validate() {
                    var somethingError = false;
                    for (var i = 0; i < scope.tableOfValues.length && !somethingError; i++) {
                        if (angular.isUndefined(scope.tableOfValues[i].limit) || angular.isUndefined(scope.tableOfValues[i].value)) {
                            somethingError = true;
                        }
                        if (angular.isDefined(scope.form[scope.label + '-limit-' + i]) && !somethingError) {
                            var l1 = Object.keys(scope.form[scope.label + '-limit-' + i].$error).length;
                            if (l1 > 0) {
                                somethingError = true;
                            }
                        }
                        if (angular.isDefined(scope.form[scope.label + '-value-' + i]) && !somethingError) {
                            var l2 = Object.keys(scope.form[scope.label + '-value-' + i].$error).length;
                            if (l2 > 0) {
                                somethingError = true;
                            }
                        }
                    }
                    scope.hasErrors = somethingError;
                }

                scope.setEditMode = function (value) {
                    scope.editMode = value;
                };

                scope.addRecord = function () {
                    if (!angular.isObject(scope.tableOfValues)) {
                        scope.tableOfValues = [];
                    }
                    scope.tableOfValues.push({});
                    scope.editMode = true;
                };
                scope.removeRecord = function ($index) {
                    scope.tableOfValues.splice($index, 1);
                    if (scope.tableOfValues.length === 1) {
                        scope.tableOfValues[0].limit = 1;
                    }
                };
                watchers.tableOfValues = scope.$watch('tableOfValues', function (tableOfValues) {
                    if (angular.isDefined(tableOfValues)) {
                        if (!angular.isObject(scope.tableOfValues)) {
                            scope.tableValues = [];
                        }
                        if (scope.tableOfValues.length === 0) {
                            scope.tableOfValues.push({ limit: 1, value: scope.defaultValue });
                        }
                        validate();
                    }
                }, true);

                watchers.firstValue = scope.$watch('tableOfValues[0].value', function (newVal) {
                    if (newVal) {
                        scope.defaultValue = scope.tableOfValues[0].value;
                    }
                });

                watchers.finalListener = scope.$on('$destroy', function () {
                    for (var f in watchers) {
                        if (watchers.hasOwnProperty(f)) {
                            watchers[f]();
                            delete watchers[f];
                        }
                    }
                });
            }
        };
    }
}());
(function () {
    'use strict';

    angular
        .module ('app.core')
        .directive ('tableLoader', tableLoader);


    /** @ngInject */
    function tableLoader(
        // $rootScope,
        // CatalogsZF
    ) {
        return {
            restrict: 'A',
            templateUrl: 'app/core/directives/table-loader/table-loader.html',
            replace: true,
            // transclude: true,
            scope: {
                array: '=',
                validations: '='
            }
            // link: function(scope, ele, attrs){
            //     scope.Z = CatalogsZF;
            //     scope.F = $rootScope.F;
            // }
        }
    }
} ());
(function(){
    'use strict';

    angular
        .module('app.core')
        .filter('tableLoaderValidations', tableLoaderValidations)

    function tableLoaderValidations(
        $rootScope,
        AppF
    ){

        return tableLoaderValidationsFn;

        function tableLoaderValidationsFn(array, module, tabName){
            if(angular.isDefined(AppF.search[module])){ // initiated
                var validations = {
                    constants: {
                        general: [
                            { valid: (array.length && !$rootScope.loadingProgress), msg: 'Parece que no tiene constantes aún'}
                        ],
                        placeOfWork: [
                            { valid: (AppF.search.constants.placeOfWork && !$rootScope.loadingProgress), msg: 'Seleccione un Lugar de Trabajo'},
                            { valid: (!AppF.search.constants.placeOfWork || (AppF.search.constants.placeOfWork && array.length && !$rootScope.loadingProgress)), msg: 'Parece que no tiene constantes por lugar de trabajo aún'}
                        ],
                        payroll: [
                            { valid: (AppF.search.constants.payroll && !$rootScope.loadingProgress), msg: 'Seleccione un Cliente y Nómina'},
                            { valid: (!AppF.search.constants.payroll || (AppF.search.constants.payroll && array.length && !$rootScope.loadingProgress)), msg: 'Parece que no tiene constantes por nómina aún'}
                        ],
                        cc: [
                            { valid: (AppF.search.constants.cc && !$rootScope.loadingProgress), msg: 'Seleccione un Cliente, Nómina y CC'},
                            { valid: (!AppF.search.constants.cc || (AppF.search.constants.cc && array.length && !$rootScope.loadingProgress)), msg: 'Parece que no tiene constantes por cc aún'}
                        ],
                        employee: [
                            { valid: (AppF.search.constants.employee && !$rootScope.loadingProgress), msg: 'Seleccione un Cliente, Nómina y Empleado'},
                            { valid: (!AppF.search.constants.employee || (AppF.search.constants.employee && array.length && !$rootScope.loadingProgress)), msg: 'Parece que no tiene constantes por empleado aún'}
                        ]
                    }
                        
                };
                return validations[module][tabName];
            } else {
                return [];
            }
        }
    }

}());
(function () {
    'use strict';

    angular
        .module ('app.core')
        .directive ('somethingOfList', somethingOfList);


    /** @ngInject */
    function somethingOfList(
        somethingOfLQFilter
    ) {
        return {
            restrict: 'E',
            replace: true,
            template: '<span>{{somethingOfSomething}}</span>',
            scope: {
                'uid': '=',
                'catalog': '@',
                'something': '@'
            },
            link: function(scope, attr, ele){
                scope.somethingOfSomething = '...';

                var getName = function(id, catalog, something){
                    somethingOfLQFilter(id, catalog, something).then(function(somethingOfSomething){
                        scope.somethingOfSomething = somethingOfSomething;
                    });
                }
                
                var watchIdAndCatalog = scope.$watchGroup(['uid', 'catalog', 'something'], function(all){
                    if(all[0] && all[1]){
                        if(all[2]) getName(all[0], all[1], all[2]);
                        else getName(all[0], all[1]);
                        watchIdAndCatalog();
                    }
                });
            }
        }
    }

} ());
(function() {
    'use strict';

    angular
        .module('app.core')
        .directive('withPermission', withPermission);


    /** @ngInject */
    function withPermission(
        AppF,
        $rootScope,
        $log,
        userHasPermissionFilter,
        $mdDialog,
        confirmConfig
    ) {

        return {
            require: '?ngModel',
            restrict: 'A',
            link: function(scope, ele, attrs, ngModel) {
                var watchers = {};
                var access = false;
                var action = false;
                var applyAction = function(event, element) {
                    $mdDialog
                        .show(
                            $mdDialog
                            .confirm(confirmConfig)
                            .title($rootScope.R.actions[action].alertFirst)
                            .ariaLabel('Confirm Action')
                            .targetEvent(event)
                            .ok('Si')
                            .cancel('Cancelar')
                        )
                        .then(function() {
                            $log.debug('activating action by keyPress with Alert', {
                                action: action,
                                access: access,
                                event: event,
                                element: element
                            });
                            // @todo:backlog mejorar esto
                            if (action == 'access') $rootScope.R.goToList();
                        }, function() {
                            $log.debug('Action Cancelled');
                        });
                }
                var init = function() {
                    if (attrs.access && attrs.action) {
                        var permission = userHasPermissionFilter(AppF.groupsOfUser, AppF.permissions, attrs.action, attrs.access);
                        if (permission) {
                            ele.show();
                        } else {
                            ele.hide();
                        }
                        if (!access) access = angular.copy(attrs.access);
                        if (!action) action = angular.copy(attrs.action);
                        if (ngModel) ngModel.$setViewValue(permission);
                    }
                    //$log.debug('Setting permission for button', permission, attrs.access, attrs.action, AppF.permissions, AppF.groupsOfUser);
                }

                attrs.$observe('access', function(access) {
                    if (access && attrs.action && AppF.permissions && AppF.groupsOfUser) init();
                })

                attrs.$observe('action', function(action) {
                    if (action && attrs.access && AppF.permissions && AppF.groupsOfUser) init();
                })

                watchers.permissionsUpdated = $rootScope.$on('permissionsUpdated', function(permissionsP) {
                    if (AppF.permissions && AppF.groupsOfUser && attrs.access && attrs.action) init();
                });

                watchers.permissions = $rootScope.$watch('F.permissions', function(permissions) {
                    if (permissions && AppF.groupsOfUser && attrs.access && attrs.action) init();
                }, true);

                watchers.groupsOfUser = $rootScope.$watch('F.groupsOfUser', function(groupsOfUser) {
                    if (groupsOfUser && AppF.permissions && attrs.access && attrs.action) init();
                }, true);

                watchers.allowShortcuts = $rootScope.$watch('F.settings.allowShortcuts', function(allow) {
                    if (allow && attrs.action && $rootScope.R.actions[attrs.action]) {
                        if ($rootScope.R.actions[attrs.action].name) ele.prop('title', '[' + $rootScope.R.actions[attrs.action].name + ']');
                        watchers.keyPress = $rootScope.$on('keyPress', function(e, data) {
                            if (access == AppF.active.menuItem && action == attrs.action) {
                                if (data.keyCode == $rootScope.R.actions[action].key) {
                                    if ($rootScope.R.actions[action].alertFirst) {
                                        applyAction(e, ele);
                                    } else {
                                        $log.debug('activating action by keyPress', {
                                            action: action,
                                            access: access,
                                            event: event,
                                            element: ele
                                        });
                                        ele.click();
                                    }
                                }
                            } else {
                                e.stopPropagation;
                                e.preventDefault();
                            }
                        });
                    }
                });

                watchers.finalListener = scope.$on("$destroy", function() {
                    for (var f in watchers) {
                        //$log.debug('stopping $watcher', f);
                        watchers[f]();
                    }
                });
            }
        }
    }

}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('ms2SpeedDial', ms2SpeedDialDirective);

        /** @ngInject */
        function ms2SpeedDialDirective(

        ) {
            return {
                link: function(scope){
                    scope.positionClass = {
                        'top': scope.position.top,
                        'bottom': scope.position.bottom,
                        'left': scope.position.left,
                        'right': scope.position.right
                    };
                },
                restrict: 'A',
                transclude: true,
                templateUrl: 'app/core/directives/ms2-speed-dial/ms2-speed-dial.html',
                scope: {
                    selected: '=',
                    position: '=',
                    actions: '=',
                    direction: '@',
                    configState: '='
                }
            }
        }

}());
(function () {
    'use strict';

    angular
        .module ('app.core')
        .directive ('ms2AutofocusIndex', ms2AutofocusIndex);


    /** @ngInject */
    function ms2AutofocusIndex(
        $document
    ) {
        return {
            link: function(scope, ele, attrs){
                function setIndexFocus() {
                    scope.$watch(function(){
                        return scope.$eval(attrs.ms2AutofocusIndex);
                    },function (newValue){
                        if(newValue == true){
                            ele[0].focus();
                        }
                    });
                }
                $document.ready(function(){
                    setIndexFocus();
                })
            },
            restrict: 'A'
        }
    }

} ());
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('ms2Autofocus', ms2Autofocus);


    /** @ngInject */
    function ms2Autofocus(
        $document,
        $timeout
    ) {
        return {
            link: function (scope, ele) {
                function setDefaultFocus() {
                    $timeout(function () {
                        ele.focus();
                    }, 1000);
                }
                $document.ready(function () {
                    setDefaultFocus();
                })
            },
            restrict: 'A'
        }
    }

}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msStepper', msStepperDirective)
        .directive('msStepperStep', msStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout, $rootScope) {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepHidden = isStepHidden;
        vm.filterHiddenStep = filterHiddenStep;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form) {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form) {
            var step = {
                element: element,
                scope: scope,
                form: form,
                stepNumber: scope.step || (vm.steps.length + 1),
                stepTitle: scope.stepTitle
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b) {
                return a.stepNumber - b.stepNumber;
            });
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps() {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm() {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function () {
                // Reset all the steps
                for (var x = 0; x < vm.steps.length; x++) {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                // gotoFirstStep();
            });
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber) {
            // If the stepNumber is not a valid step number, bail...
            if (!isStepNumberValid(stepNumber)) {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            // Hide all steps
            for (var i = 0; i < vm.steps.length; i++) {
                vm.steps[i].element.hide();
            }

            // Show the current step
            vm.steps[vm.currentStepNumber - 1].element.show();
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber) {
            // If the step we are about to go
            // is hidden, bail...
            if (isStepHidden(stepNumber)) {
                return;
            }

            vm.setCurrentStep(stepNumber);
            $rootScope.$emit('stepCalled', stepNumber);

        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep() {
            var stepNumber = vm.currentStepNumber - 1;

            // Test the previous steps and make sure
            // we will land to a one that is not hidden
            for (var s = stepNumber; s >= 1; s--) {
                if (!isStepHidden(s)) {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
            $rootScope.$emit('stepCalled', stepNumber);

        }

        /**
         * Go to the next step
         */
        function gotoNextStep() {
            var stepNumber = vm.currentStepNumber + 1;

            // Test the following steps and make sure
            // we will land to a one that is not hidden
            for (var s = stepNumber; s <= vm.steps.length; s++) {
                if (!isStepHidden(s)) {
                    stepNumber = s;
                    break;
                }
            }
            vm.setCurrentStep(stepNumber);
            $rootScope.$emit('stepCalled', stepNumber);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep() {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep() {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep() {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep() {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber) {
            // If the stepNumber is not a valid step number, bail...
            if (!isStepNumberValid(stepNumber)) {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber) {
            // If the stepNumber is not a valid step number, bail...
            if (!isStepNumberValid(stepNumber)) {
                return null;
            }

            var disabled = false;

            for (var i = 1; i < stepNumber; i++) {
                if (!isStepValid(i)) {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber) {
            // If the stepNumber is not a valid step number, bail...
            if (!isStepNumberValid(stepNumber)) {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is hidden
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepHidden(stepNumber) {
            // If the stepNumber is not a valid step number, bail...
            if (!isStepNumberValid(stepNumber)) {
                return null;
            }

            return !!vm.steps[stepNumber - 1].scope.hideStep;
        }

        /**
         * Check if the given step is hidden as a filter
         *
         * @param step
         * @returns {boolean}
         */
        function filterHiddenStep(step) {
            return !isStepHidden(step.stepNumber);
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber) {
            // If the stepNumber is not a valid step number, bail...
            if (!isStepNumberValid(stepNumber)) {
                return null;
            }

            // If the step is optional, always return true
            if (isStepOptional(stepNumber)) {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber) {
            return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid() {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msStepperDirective() {
        return {
            restrict: 'A',
            require: ['form', 'msStepper'],
            priority: 1001,
            controller: 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude: true,
            templateUrl: 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile: function (tElement) {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls) {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        };
    }

    /** @ngInject */
    function msStepperStepDirective() {
        return {
            restrict: 'E',
            require: ['form', '^msStepper'],
            priority: 1000,
            scope: {
                step: '=?',
                stepTitle: '=?',
                optionalStep: '=?',
                hideStep: '=?'
            },
            compile: function (tElement) {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls) {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                msTimeline: '=?',
                loadMore  : '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Default config
                    var config = {
                        scrollEl: '#content'
                    };

                    // Extend the configuration
                    config = angular.extend(config, scope.msTimeline, {});
                    
                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element(config.scrollEl);
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate) {
        return {
            restrict: 'E',
            link: function(scope, iElement) {
                // var splashScreenHideEvent = scope.$on('msSplashScreen::hide', function() {
                //     $animate.leave(iElement).then(function() {
                //         // De-register scope event
                //         splashScreenHideEvent();

                //         // Null-ify everything else
                //         // scope = iElement = null;
                //         iElement.hide();
                //     });
                // });

                // var splashScreenShowEvent =scope.$on('msSplashScreen::show', function() {
                //     $animate.enter(iElement).then(function() {
                //         // De-register scope event
                //         splashScreenShowEvent();

                //         // Null-ify everything else
                //         // scope = iElement = null;
                //         iElement.show();
                //     });
                // });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsShortcutsController', MsShortcutsController)
        .directive('msShortcuts', msShortcutsDirective);

    /** @ngInject */
    function MsShortcutsController($scope, $cookies, $document, $timeout, $q, msNavigationService)
    {
        var vm = this;

        // Data
        vm.query = '';
        vm.queryOptions = {
            debounce: 300
        };
        vm.resultsLoading = false;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;

        vm.results = null;
        vm.shortcuts = [];

        vm.sortableOptions = {
            ghostClass   : 'ghost',
            forceFallback: true,
            fallbackClass: 'dragging',
            onSort       : function ()
            {
                vm.saveShortcuts();
            }
        };

        // Methods
        vm.populateResults = populateResults;
        vm.loadShortcuts = loadShortcuts;
        vm.saveShortcuts = saveShortcuts;
        vm.addShortcut = addShortcut;
        vm.removeShortcut = removeShortcut;
        vm.handleResultClick = handleResultClick;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;

        //////////

        init();

        function init()
        {
            // Load the shortcuts
            vm.loadShortcuts().then(
                // Success
                function (response)
                {
                    vm.shortcuts = response;

                    // Add shortcuts as results by default
                    if ( vm.shortcuts.length > 0 )
                    {
                        vm.results = response;
                    }
                }
            );

            // Watch the model changes to trigger the search
            $scope.$watch('MsShortcuts.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                // Show the loader
                vm.resultsLoading = true;

                // Populate the results
                vm.populateResults().then(
                    // Success
                    function (response)
                    {
                        vm.results = response;
                    },
                    // Error
                    function ()
                    {
                        vm.results = [];
                    }
                ).finally(
                    function ()
                    {
                        // Hide the loader
                        vm.resultsLoading = false;
                    }
                );
            });
        }

        /**
         * Populate the results
         */
        function populateResults()
        {
            var results = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    results.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the results
            if ( vm.query )
            {
                results = results.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(vm.query)) > -1 )
                    {
                        return true;
                    }
                });

                // Iterate through one last time and
                // add required properties to items
                for ( var i = 0; i < results.length; i++ )
                {
                    // Add false to hasShortcut by default
                    results[i].hasShortcut = false;

                    // Test if the item is in the shortcuts list
                    for ( var y = 0; y < vm.shortcuts.length; y++ )
                    {
                        if ( vm.shortcuts[y]._id === results[i]._id )
                        {
                            results[i].hasShortcut = true;
                            break;
                        }
                    }
                }
            }
            else
            {
                // If the query is empty, that means
                // there is nothing to search for so
                // we will populate the results with
                // current shortcuts if there is any
                if ( vm.shortcuts.length > 0 )
                {
                    results = vm.shortcuts;
                }
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Fake the service delay
            $timeout(function ()
            {
                // Resolve the promise
                deferred.resolve(results);
            }, 250);

            // Return a promise
            return deferred.promise;
        }

        /**
         * Load shortcuts
         */
        function loadShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // load the shortcuts from the cookies.
            // But here you can make an API call
            // to load them from the DB.
            var shortcuts = angular.fromJson($cookies.get('FUSE.shortcuts'));

            // No cookie available. Generate one
            // for the demo purposes...
            if ( angular.isUndefined(shortcuts) )
            {
                shortcuts = [
                    {
                        'title'      : 'Chat',
                        'icon'       : 'icon-hangouts',
                        'state'      : 'app.chat',
                        'badge'      : {
                            'content': 13,
                            'color'  : '#09d261'
                        },
                        'weight'     : 5,
                        'children'   : [],
                        '_id'        : 'chat',
                        '_path'      : 'apps.chat',
                        'uisref'     : 'app.chat',
                        'hasShortcut': true
                    }, {
                        'title'      : 'Contacts',
                        'icon'       : 'icon-account-box',
                        'state'      : 'app.contacts',
                        'weight'     : 10,
                        'children'   : [],
                        '_id'        : 'contacts',
                        '_path'      : 'apps.contacts',
                        'uisref'     : 'app.contacts',
                        'hasShortcut': true
                    }, {
                        'title'      : 'Notes',
                        'icon'       : 'icon-lightbulb',
                        'state'      : 'app.notes',
                        'weight'     : 11,
                        'children'   : [],
                        '_id'        : 'notes',
                        '_path'      : 'apps.notes',
                        'uisref'     : 'app.notes',
                        'hasShortcut': true
                    }
                ];

                $cookies.put('FUSE.shortcuts', angular.toJson(shortcuts));
            }

            // Resolve the promise
            deferred.resolve(shortcuts);

            return deferred.promise;
        }

        /**
         * Save the shortcuts
         */
        function saveShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // keep the shortcuts in the cookies.
            // But here you can make an API call
            // to save them to the DB.
            $cookies.put('FUSE.shortcuts', angular.toJson(vm.shortcuts));

            // Fake the service delay
            $timeout(function ()
            {
                deferred.resolve({'success': true});
            }, 250);

            return deferred.promise;
        }

        /**
         * Add item as shortcut
         *
         * @param item
         */
        function addShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = true;

            // Add as a shortcut
            vm.shortcuts.push(item);

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Remove item from shortcuts
         *
         * @param item
         */
        function removeShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = false;

            // Remove the shortcut
            for ( var x = 0; x < vm.shortcuts.length; x++ )
            {
                if ( vm.shortcuts[x]._id === item._id )
                {
                    // Remove the x-th item from the array
                    vm.shortcuts.splice(x, 1);

                    // If we aren't searching for anything...
                    if ( !vm.query )
                    {
                        // If all the shortcuts have been removed,
                        // null-ify the results
                        if ( vm.shortcuts.length === 0 )
                        {
                            vm.results = null;
                        }
                        // Otherwise update the selected index
                        else
                        {
                            if ( x >= vm.shortcuts.length )
                            {
                                vm.selectedResultIndex = vm.shortcuts.length - 1;
                            }
                        }
                    }
                }
            }

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            // Add or remove the shortcut
            if ( item.hasShortcut )
            {
                vm.removeShortcut(item);
            }
            else
            {
                vm.addShortcut(item);
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $document.find('#ms-shortcut-add-menu').find('.results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }
    }

    /** @ngInject */
    function msShortcutsDirective()
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msShortcuts',
            controller      : 'MsShortcutsController as MsShortcuts',
            bindToController: {},
            templateUrl     : 'app/core/directives/ms-shortcuts/ms-shortcuts.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-shortcuts');

                // return function postLink(scope, iElement)
                // {
                //     // Data

                // };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsSearchBarController', MsSearchBarController)
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function MsSearchBarController($scope, $element, $timeout)
    {
        var vm = this;

        // Data
        vm.collapsed = true;
        vm.query = '';
        vm.queryOptions = {
            debounce: vm.debounce || 0
        };
        vm.resultsLoading = false;
        vm.results = null;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;

        // Methods
        vm.populateResults = populateResults;

        vm.expand = expand;
        vm.collapse = collapse;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.handleResultClick = handleResultClick;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;

        //////////

        init();

        function init()
        {
            // Watch the model changes to trigger the search
            $scope.$watch('MsSearchBar.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                if ( vm.collapsed )
                {
                    return;
                }

                // Evaluate the onSearch function to access the
                // function itself
                var onSearchEvaluated = $scope.$parent.$eval(vm.onSearch, {query: current}),
                    isArray = angular.isArray(onSearchEvaluated),
                    isPromise = (onSearchEvaluated && !!onSearchEvaluated.then);

                if ( isArray )
                {
                    // Populate the results
                    vm.populateResults(onSearchEvaluated);
                }

                if ( isPromise )
                {
                    // Show the loader
                    vm.resultsLoading = true;

                    onSearchEvaluated.then(
                        // Success
                        function (response)
                        {
                            // Populate the results
                            vm.populateResults(response);
                        },
                        // Error
                        function ()
                        {
                            // Assign an empty array to show
                            // the no-results screen
                            vm.populateResults([]);
                        }
                    ).finally(function ()
                        {
                            // Hide the loader
                            vm.resultsLoading = false;
                        }
                    );
                }
            });
        }

        /**
         * Populate the results
         *
         * @param results
         */
        function populateResults(results)
        {
            // Before doing anything,
            // make sure the search bar is expanded
            if ( vm.collapsed )
            {
                return;
            }

            var isArray = angular.isArray(results),
                isNull = results === null;

            // Only accept arrays and null values
            if ( !isArray && !isNull )
            {
                return;
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Populate the results
            vm.results = results;
        }

        /**
         * Expand
         */
        function expand()
        {
            // Set collapsed status
            vm.collapsed = false;

            // Call expand on scope
            $scope.expand();

            // Callback
            if ( vm.onExpand && angular.isFunction(vm.onExpand) )
            {
                vm.onExpand();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Empty the query
            vm.query = '';

            // Empty results to hide the results view
            vm.populateResults(null);

            // Set collapsed status
            vm.collapsed = true;

            // Call collapse on scope
            $scope.collapse();

            // Callback
            if ( vm.onCollapse && angular.isFunction(vm.onCollapse) )
            {
                vm.onCollapse();
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [27, 38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Escape
                case 27:

                    // Collapse the search bar
                    vm.collapse();

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    if ( !vm.results )
                    {
                        return;
                    }

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            if ( vm.onResultClick )
            {
                vm.onResultClick({item: item});
            }

            // Collapse the search bar
            vm.collapse();
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $element.find('.ms-search-bar-results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }
    }

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msSearchBar',
            controller      : 'MsSearchBarController as MsSearchBar',
            bindToController: {
                debounce     : '=?',
                onSearch     : '@',
                onResultClick: '&?',
                onExpand     : '&?',
                onCollapse   : '&?'
            },
            templateUrl     : 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    // Data
                    var inputEl,
                        bodyEl = $document.find('body');

                    // Methods
                    scope.collapse = collapse;
                    scope.expand = expand;

                    //////////

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Grab the input element
                        inputEl = iElement.find('#ms-search-bar-input');
                    }

                    /**
                     * Expand action
                     */
                    function expand()
                    {
                        // Add expanded class
                        iElement.addClass('expanded');

                        // Add helper class to the body
                        bodyEl.addClass('ms-search-bar-expanded');

                        // Focus on the input
                        inputEl.focus();
                    }

                    /**
                     * Collapse action
                     */
                    function collapse()
                    {
                        // Remove expanded class
                        iElement.removeClass('expanded');

                        // Remove helper class from the body
                        bodyEl.removeClass('ms-search-bar-expanded');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider() {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item) {
            if (!angular.isString(path)) {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = angular.isString(item.alias) ? item.alias : parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for (var i = 0; i < parent.length; i++) {
                if (parent[i]._id === id) {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if (updateItem) {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if (angular.isUndefined(item.weight) || !angular.isNumber(item.weight)) {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path) {
            if (!angular.isString(path)) {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for (var p = 0; p < parts.length; p++) {
                var id = parts[p];

                for (var i = 0; i < item.length; i++) {
                    if (item[i]._id === id) {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if (item[i]._path === path) {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent) {
            // If parent not provided, sort the root items
            if (!parent) {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for (var i = 0; i < parent.length; i++) {
                var children = parent[i].children;

                if (children.length > 1) {
                    children.sort(_byWeight);
                }

                if (children.length > 0) {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts) {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if (parts.length === 1) {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for (var i = 0; i < parts.length; i++) {
                var _id = parts[i],
                    createParent = true;

                for (var p = 0; p < parent.length; p++) {
                    if (parent[p]._id === _id) {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if (createParent) {
                    var item = {
                        _id: _id,
                        _path: parts.join('.'),
                        title: _id,
                        weight: 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y) {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item) {
            var uisref = '';

            if (angular.isDefined(item.state)) {
                uisref = item.state;

                if (angular.isDefined(item.stateParams) && angular.isObject(item.stateParams)) {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function () {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;
            // _flatNavigation = [];

            var service = {
                saveItem: saveItem,
                deleteItem: deleteItem,
                sort: sortByWeight,
                clearNavigation: clearNavigation,
                setActiveItem: setActiveItem,
                getActiveItem: getActiveItem,
                getNavigation: getNavigation,
                getFlatNavigation: getFlatNavigation,
                setNavigationScope: setNavigationScope,
                setFolded: setFolded,
                getFolded: getFolded,
                setFoldedOpen: setFoldedOpen,
                getFoldedOpen: getFoldedOpen,
                toggleFolded: toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation() {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if (navigationScope) {
                    navigationScope.vm.navigation = [];
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope) {
                activeItem = {
                    node: node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem() {
                return activeItem;
            }

            /**
             * Return navigation array
             *
             * @param root
             * @returns Array
             */
            function getNavigation(root) {
                if (root) {
                    for (var i = 0; i < navigation.length; i++) {
                        if (navigation[i]._id === root) {
                            return [navigation[i]];
                        }
                    }

                    return null;
                }

                return navigation;
            }

            /**
             * Return flat navigation array
             *
             * @param root
             * @returns Array
             */
            function getFlatNavigation(root) {
                // Get the correct navigation array
                var navigation = getNavigation(root);

                // Flatten the navigation object
                return _flattenNavigation(navigation);
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope) {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status) {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded() {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status) {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen() {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded() {
                navigationScope.toggleFolded();
            }

            /**
             * Flatten the given navigation
             *
             * @param navigation
             * @private
             */
            function _flattenNavigation(navigation) {
                var flatNav = [];

                for (var x = 0; x < navigation.length; x++) {
                    // Copy and clear the children of the
                    // navigation that we want to push
                    var navToPush = angular.copy(navigation[x]);
                    navToPush.children = [];

                    // Push the item
                    flatNav.push(navToPush);

                    // If there are child items in this navigation,
                    // do some nested function magic
                    if (navigation[x].children.length > 0) {
                        flatNav = flatNav.concat(_flattenNavigation(navigation[x].children));
                    }
                }

                return flatNav;
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService, ChatF) {
        var vm = this;
        $scope.CF = ChatF;
        // Data
        if ($scope.root) {
            vm.navigation = msNavigationService.getNavigation($scope.root);
        } else {
            vm.navigation = msNavigationService.getNavigation();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init() {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu() {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService) {
        return {
            restrict: 'E',
            scope: {
                folded: '=',
                root: '@'
            },
            controller: 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude: true,
            compile: function (tElement) {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement) {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init() {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if (msNavigationService.getFolded() === null) {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if (msNavigationService.getFolded()) {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function () {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function () {
                        return sidenav.isLockedOpen();
                    }, function (current, old) {
                        if (angular.isUndefined(current) || angular.equals(current, old)) {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if (folded) {
                            if (current) {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            } else {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if (activeItem) {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old) {
                        if (angular.isUndefined(current) || angular.equals(current, old)) {
                            if (current && angular.equals(current, old)) {
                                setFolded(current);
                            }
                            return;
                        } else {
                            setFolded(current);
                        }
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded) {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if (folded) {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                            // setFoldCollapser();
                        } else {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if (activeItem) {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander() {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function () {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser() {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser() {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event) {
                        if (event) {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if (activeItem) {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event) {
                        if (event) {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function () {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function () {
                        // Close the sidenav
                        sidenav.close();
                    });

                    // Cleanup
                    scope.$on('$destroy', function () {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, tdsystem2, $window, $animate, $state, ApiV2F, msNavigationService, $mdDialog, $document, $log, DataF, errAlertS) {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';
        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;
        vm.showRfcValidatorModal = showRfcValidatorModal;
        vm.showCifValidatorModal = showCifValidatorModal;
        vm.redirectHelpCenter = redirectHelpCenter;
        vm.redirectTimeAndAttendanceControl = redirectTimeAndAttendanceControl;
        vm.redirectVirtualXmlLogin = redirectVirtualXmlLogin;

        function redirectHelpCenter(ev) {
            DataF.auth.post('getCustomToken').then(function (response) {
                if (response.data.token) {
                    var token = response.data.token;
                    var redirectUrl = $window.location.protocol + '//' + tdsystem2[$window.__env.mode] + '/sign-in/token?key=' + token + '&redirectURL=/apps/centro-de-ayuda/articles&persistence=none';
                    $window.open(redirectUrl, '_blank');
                }
            }).catch(errAlertS)
        }
        function redirectTimeAndAttendanceControl(ev) {
            $window.open('https://clients.geovictoria.com/account/login', '_blank');
        }
        function redirectVirtualXmlLogin(ev) {
            $window.open('https://vxml.mx/vxmladmin/', '_blank');
        }
        function showRfcValidatorModal(ev) {
            $mdDialog.show({
                controller: 'RfcValidatorController',
                controllerAs: 'rfcValidCtrl',
                templateUrl: 'app/core/directives/ms-navigation/dialogs/rfc-validator/rfc-validator.html',
                parent: angular.element($document.body),
                targetEvent: ev
            }).then(function () {
                $log.debug('modal closed')
            }).catch(function (error) {
                if (error) {
                    $log.error(error);
                }
                $log.debug('modal cancelled');
            });
        }



        function showCifValidatorModal(ev) {
            $mdDialog.show({
                controller: 'CifValidatorController',
                controllerAs: 'cifValidCtrl',
                templateUrl: 'app/core/directives/ms-navigation/dialogs/cif-validator/cif-validator.html',
                parent: angular.element($document.body),
                targetEvent: ev
            }).then(function () {
                $log.debug('modal closed')
            }).catch(function (error) {
                if (error) {
                    $log.error(error);
                }
                $log.debug('modal cancelled');
            });
        }




        //////////

        init();

        /**
         * Initialize
         */
        function init() {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if (!vm.hasChildren || vm.group) {
                vm.collapsable = false;
            } else {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if (!vm.collapsable) {
                vm.collapsed = false;
            } else {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if (vm.node.state === $state.current.name || $state.includes(vm.node.state)) {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if (angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params)) {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function () {
                // Expand if the current scope is collapsable and is collapsed
                if (vm.collapsable && vm.collapsed) {
                    $scope.$evalAsync(function () {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path) {
                if (vm.collapsed || !vm.collapsable) {
                    return;
                }

                // If there is no path defined, collapse
                if (angular.isUndefined(path)) {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if (activeItem) {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if (givenPathParts.indexOf(vm.node._id) > -1) {
                        return;
                    }

                    // Test for active path
                    if (activePathParts.indexOf(vm.node._id) > -1) {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function () {
                if (vm.node.state === $state.current.name) {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if (angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params)) {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }

                // Expand the parents if we the current
                // state is a child of the node's state
                if ($state.includes(vm.node.state)) {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if (angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params)) {
                        return;
                    }

                    // Emit the stateMatched
                    $scope.$emit('msNavigation::stateMatched');
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed() {
            if (vm.collapsed) {
                vm.expand();
            } else {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse() {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function () {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl, {
                    'display': 'block',
                    'height': height + 'px'
                }, {
                    'height': '0px'
                },
                    vm.animateHeightClass
                ).then(
                    function () {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height': ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand() {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position': 'absolute',
                'visibility': 'hidden',
                'display': 'block',
                'height': 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position': '',
                'visibility': '',
                'display': '',
                'height': ''
            });

            $scope.$evalAsync(function () {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl, {
                    'display': 'block',
                    'height': '0px'
                }, {
                    'height': height + 'px'
                },
                    vm.animateHeightClass
                ).then(
                    function () {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass() {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden() {
            if (angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden)) {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective() {
        return {
            restrict: 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller: 'MsNavigationNodeController as vm',
            compile: function (tElement) {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl) {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if (MsNavigationNodeCtrl.group) {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective() {
        return {
            restrict: 'A',
            require: '^msNavigationNode',
            compile: function (tElement) {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl) {
                    // If the item is collapsable...
                    if (MsNavigationNodeCtrl.collapsable) {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function () {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService) {
        return {
            restrict: 'E',
            scope: {
                root: '@'
            },
            controller: 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude: true,
            compile: function (tElement) {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope) {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService) {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init() {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if (vm.node.state === $state.current.name || $state.includes(vm.node.state)) {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if (angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params)) {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function () {
                // Mark as active if has children
                if (vm.hasChildren) {
                    $scope.$evalAsync(function () {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function () {
                if (!vm.hasChildren) {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if (activeItem) {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if (activePathParts.indexOf(vm.node._id) > -1) {
                    $scope.$evalAsync(function () {
                        vm.isActive = true;
                    });
                } else {
                    $scope.$evalAsync(function () {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function () {
                if (vm.node.state === $state.current.name || $state.includes(vm.node.state)) {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if (angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params)) {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass() {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective() {
        return {
            restrict: 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller: 'MsNavigationHorizontalNodeController as vm',
            compile: function (tElement) {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl) {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if (MsNavigationHorizontalNodeCtrl.group) {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia) {
        return {
            restrict: 'A',
            require: '^msNavigationHorizontalNode',
            compile: function (tElement) {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl) {
                    iElement.on('click', onClick);

                    function onClick() {
                        if (!MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md')) {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function () {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    })
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMaterialColorPickerController', msMaterialColorPickerController)
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPickerController($scope, $mdColorPalette, $mdMenu, fuseGenerator)
    {
        var vm = this;
        vm.palettes = $mdColorPalette; // Material Color Palette
        vm.selectedPalette = false;
        vm.selectedHues = false;
        $scope.$selectedColor = {};

        // Methods
        vm.activateHueSelection = activateHueSelection;
        vm.selectColor = selectColor;
        vm.removeColor = removeColor;

        /**
         * Initialize / Watch model changes
         */
        $scope.$watch('ngModel', setSelectedColor);

        /**
         * Activate Hue Selection
         * @param palette
         * @param hues
         */
        function activateHueSelection(palette, hues)
        {
            vm.selectedPalette = palette;
            vm.selectedHues = hues;
        }

        /**
         * Select Color
         * @type {selectColor}
         */
        function selectColor(palette, hue)
        {
            // Update Selected Color
            updateSelectedColor(palette, hue);

            // Update Model Value
            updateModel();

            // Hide The picker
            $mdMenu.hide();
        }

        function removeColor()
        {

            vm.selectedColor = {
                palette: '',
                hue    : '',
                class  : ''
            };

            activateHueSelection(false, false);

            updateModel();
        }

        /**
         * Set SelectedColor by model type
         */
        function setSelectedColor()
        {

            if ( !vm.modelCtrl.$viewValue || vm.modelCtrl.$viewValue === '' )
            {
                removeColor();
                return;
            }

            var palette, hue;

            // If ModelType Class
            if ( vm.msModelType === 'class' )
            {
                var color = vm.modelCtrl.$viewValue.split('-');
                if ( color.length >= 5 )
                {
                    palette = color[1] + '-' + color[2];
                    hue = color[3];
                }
                else
                {
                    palette = color[1];
                    hue = color[2];
                }
            }

            // If ModelType Object
            else if ( vm.msModelType === 'obj' )
            {
                palette = vm.modelCtrl.$viewValue.palette;
                hue = vm.modelCtrl.$viewValue.hue || 500;
            }

            // Update Selected Color
            updateSelectedColor(palette, hue);
        }

        /**
         * Update Selected Color
         * @param palette
         * @param hue
         */
        function updateSelectedColor(palette, hue)
        {
            vm.selectedColor = {
                palette     : palette,
                hue         : hue,
                class       : 'md-' + palette + '-' + hue + '-bg',
                bgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].value),
                fgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].contrast)
            };

            // If Model object not Equals the selectedColor update it
            // it can be happen when the model only have pallete and hue values
            if ( vm.msModelType === 'obj' && !angular.equals(vm.selectedColor, vm.modelCtrl.$viewValue) )
            {
                // Update Model Value
                updateModel();
            }

            activateHueSelection(palette, vm.palettes[palette]);

            $scope.$selectedColor = vm.selectedColor;
        }

        /**
         * Update Model Value by model type
         */
        function updateModel()
        {

            if ( vm.msModelType === 'class' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor.class);
            }
            else if ( vm.msModelType === 'obj' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor);
            }
        }

    }

    /** @ngInject */
    function msMaterialColorPicker()
    {
        return {
            require    : ['msMaterialColorPicker', 'ngModel'],
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            controller : 'msMaterialColorPickerController as vm',
            transclude : true,
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function (scope, element, attrs, controllers, transclude)
            {
                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';

                transclude(scope, function (clone)
                {
                    clone = clone.filter(function (i, el)
                    {
                        return ( el.nodeType === 1 ) ? true : false;
                    });

                    if ( clone.length )
                    {
                        element.find('ms-color-picker-button').replaceWith(clone);
                    }
                });

            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMasonryController', msMasonryController)
        .directive('msMasonry', msMasonry)
        .directive('msMasonryItem', msMasonryItem);

    /** @ngInject */
    function msMasonryController($scope, $window, $mdMedia, $timeout)
    {
        var vm = this,
            defaultOpts = {
                columnCount     : 5,
                reLayoutDebounce: 400,
                responsive      : {
                    md: 3,
                    sm: 2,
                    xs: 1
                }
            },
            reLayoutTimeout = true;

        vm.options = null;
        vm.container = [];
        vm.containerPos = '';
        vm.columnWidth = '';
        vm.items = [];

        // Methods
        vm.reLayout = reLayout;
        vm.initialize = initialize;
        vm.waitImagesLoaded = waitImagesLoaded;

        function initialize()
        {
            vm.options = !vm.options ? defaultOpts : angular.extend(defaultOpts, vm.options);


            watchContainerResize();
        }

        $scope.$on('msMasonry:relayout', function ()
        {
            reLayout();
        });

        function waitImagesLoaded(element, callback)
        {
            if ( typeof imagesLoaded !== 'undefined' )
            {
                var imgLoad = $window.imagesLoaded(element);

                imgLoad.on('done', function ()
                {
                    callback();
                });
            }
            else
            {
                callback();
            }
        }

        function watchContainerResize()
        {
            $scope.$watch(
                function ()
                {
                    return vm.container.width();
                },
                function (newValue, oldValue)
                {
                    if ( newValue !== oldValue )
                    {
                        reLayout();
                    }
                }
            );
        }

        function reLayout()
        {
            // Debounce for relayout
            if ( reLayoutTimeout )
            {
                $timeout.cancel(reLayoutTimeout);
            }

            reLayoutTimeout = $timeout(function ()
            {
                start();

                $scope.$broadcast('msMasonry:relayoutFinished');

            }, vm.options.reLayoutDebounce);

            // Start relayout
            function start()
            {

                vm.containerPos = vm.container[0].getBoundingClientRect();

                updateColumnOptions();

                $scope.$broadcast('msMasonry:relayoutStarted');

                vm.items = vm.container.find('ms-masonry-item');

                //initialize lastRowBottomArr
                var referenceArr = Array.apply(null, new Array(vm.columnCount)).map(function ()
                {
                    return 0;
                });

                // set item positions
                for ( var i = 0; i < vm.items.length; i++ )
                {
                    var item = vm.items[i],
                        xPos, yPos;

                    item = angular.element(item);

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:startReLayout');
                    }

                    item.css({'width': vm.columnWidth});

                    var refTop = Math.min.apply(Math, referenceArr);

                    var column = referenceArr.indexOf(refTop);

                    referenceArr[column] = refTop + item[0].getBoundingClientRect().height;

                    xPos = Math.round(column * vm.columnWidth);
                    yPos = refTop;

                    item.css({'transform': 'translate3d(' + xPos + 'px,' + yPos + 'px,0px)'});

                    item.addClass('placed');

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:finishReLayout');
                    }

                }
            }
        }

        function updateColumnOptions()
        {
            vm.columnCount = vm.options.columnCount;

            if ( $mdMedia('gt-md') )
            {
                vm.columnCount = vm.options.columnCount;
            }
            else if ( $mdMedia('md') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.md ? vm.options.responsive.md : vm.columnCount);
            }
            else if ( $mdMedia('sm') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.sm ? vm.options.responsive.sm : vm.columnCount);
            }
            else
            {
                vm.columnCount = vm.options.responsive.xs;
            }

            vm.columnWidth = vm.containerPos.width / vm.columnCount;

        }
    }

    /** @ngInject */
    function msMasonry($timeout)
    {
        return {
            restrict  : 'AEC',
            controller: 'msMasonryController',
            compile   : compile
        };
        function compile(element, attributes)
        {
            return {
                pre : function preLink(scope, iElement, iAttrs, controller)
                {
                    controller.options = angular.fromJson(attributes.options || '{}');
                    controller.container = element;
                },
                post: function postLink(scope, iElement, iAttrs, controller)
                {
                    $timeout(function ()
                    {
                        controller.initialize();
                    });
                }
            };
        }
    }

    /** @ngInject */
    function msMasonryItem()
    {
        return {
            restrict: 'AEC',
            require : '^msMasonry',
            priority: 1,
            link    : link
        };

        function link(scope, element, attributes, controller)
        {
            controller.waitImagesLoaded(element, function ()
            {
                controller.reLayout();

            });

            scope.$on('msMasonryItem:finishReLayout', function ()
            {
                scope.$watch(function ()
                {
                    return element.height();
                }, function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        controller.reLayout();
                    }
                });
            });

            element.on('$destroy', function ()
            {
                controller.reLayout();
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msInfoBar', msInfoBarDirective);

    /** @ngInject */
    function msInfoBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : {},
            transclude : true,
            templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
            link       : function (scope, iElement)
            {
                var body = $document.find('body'),
                    bodyClass = 'ms-info-bar-active';

                // Add body class
                body.addClass(bodyClass);

                /**
                 * Remove the info bar
                 */
                function removeInfoBar()
                {
                    body.removeClass(bodyClass);
                    iElement.remove();
                    scope.$destroy();
                }

                // Expose functions
                scope.removeInfoBar = removeInfoBar;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        }

    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                }
            }
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {

        // Default configuration
        var defaultConfiguration = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }
                var offset = moment(val).utcOffset();
                var date = new Date(moment(val).add(offset, 'm'));
                return date;
            }
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            return defaultConfiguration;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require: 'ngModel',
            link   : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.unshift(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.unshift(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('app.core')
        .directive('inputdate', InputDateDirective);

    /** @ngInject */
    function InputDateDirective(
        $compile,
        $mdDialog,
        confirmConfig
    ) {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                date: "@",
                title: "=",
                calendar: "=",
                updatecalendar: "=",
                period: "="
            },
            template: '<md-input-container><label>{{title}}</label><md-datepicker md-hide-icons="triangle" name="tempdate" ng-model="tempdate" class="md-block" required></md-datepicker></md-input-container>',
            link: function(scope, element) {
                var watchers = {};
                var observe = function() {
                    watchers.tempdate = scope.$watch('tempdate', function(date, dateold) {
                        if (date) {
                            var d = moment(date);
                            var msg = "";
                            var datesProblems = false;
                            var dateToUpdate = "";
                            if (d.valueOf() < scope.calendar.data.startDate) {
                                dateToUpdate = "start";
                                datesProblems = true;
                                msg = "La fecha establecida es menor a la fecha del calendario, si continua se actualizaran las fechas del calendario " + d.getDay() + " -> " + date + " <- " + scope.calendar.data.startDate;
                            } else if (d.valueOf() > scope.calendar.data.endDate) {
                                dateToUpdate = "end";
                                datesProblems = true;
                                msg = "La fecha establecida es mayor a la fecha del calendario, si continua se actualizaran las fechas del calendario";
                            }
                            if (datesProblems) {
                                var title = 'Desea continuar';
                                $mdDialog.show($mdDialog.confirm(confirmConfig)
                                        .title(title)
                                        .content(msg)
                                        .ariaLabel('Cambiar Fechas')
                                        .ok('Aceptar')
                                        .cancel('Cancelar'))
                                    .then(function() {
                                        if (dateToUpdate == "start") {
                                            scope.calendar.data.startDate = d.valueOf();
                                        } else if (dateToUpdate == "end") {
                                            scope.calendar.data.endDate = d.valueOf();
                                        }
                                        scope.updatecalendar.status = true;
                                        //console.log(scope.updatecalendar.status);
                                        // scope.date = d.valueOf();
                                        scope.period[scope.date] = d.valueOf();
                                        scope.period[scope.date + 'String'] = d.format("DD-MM-YYYY");
                                    }, function() {
                                        scope.tempdate = dateold;
                                    });
                            } else {
                                scope.period[scope.date] = d.valueOf();
                                scope.period[scope.date + 'String'] = d.format("DD-MM-YYYY");
                            }
                        }
                    });
                }

                watchers.period = scope.$watch('period', function(period) {
                    if (period && scope.date && scope.period[scope.date]) {
                        var periodDate = moment(scope.period[scope.date]);
                        scope.tempdate = new Date(periodDate.year(), periodDate.month(), periodDate.date());
                    }
                });
                watchers.calendar = scope.$watch('calendar', function(calendar) {
                    if (calendar) {
                        if (calendar.data) {
                            observe();
                        }
                    }
                })

                watchers.finalListener = $scope.$on("$destroy", function() {
                    for (var f in watchers) {
                        //$log.debug('stopping $watcher', f);
                        watchers[f]();
                    }
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('inputDateMiliseconds', inputDateMilisecondsDirective);

    /** @ngInject */
    function inputDateMilisecondsDirective() {
        return {
            require: 'ngModel',
            restrict: 'A',
            link: function (scope, element, attrs, ngModel) {
                function toPlaces(dato) {
                    dato = dato + '';
                    if (dato.length !== 2) {
                        dato = '0' + dato;
                    }
                    return dato;
                }
                var toView = function (value) {
                    if (!ngModel.$isEmpty(value)) {
                        var thisDate;
                        if (angular.isObject(value)) {
                            var currDate = toPlaces(value.getDate());
                            var currMonth = toPlaces(value.getMonth() + 1); //Months are zero based
                            var currYear = value.getFullYear();
                            thisDate = moment(currYear + '-' + currMonth + '-' + currDate + ' 00:00 -0500', 'YYYY-MM-DD HH:mm Z');
                        } else if (angular.isNumber(value)) {
                            thisDate = moment(value);
                        } else {
                            if (value.indexOf('-') > -1 || value.indexOf('/') > -1) {
                                thisDate = moment(value + ' 00:00 -0500', 'DD-MM-YYYY HH:mm Z');
                            } else if (value.length === 8) {
                                thisDate = moment(value + ' 00:00 -0500', 'DDMMYYY HH:mm Z');
                            }
                        }
                        if (angular.isUndefined(thisDate)) {
                            return undefined;
                        } else {
                            ngModel.$viewValue = new Date(thisDate.utc().year(), thisDate.utc().month(), thisDate.utc().date());
                            ngModel.$render();
                            return thisDate.valueOf();
                        }
                    } else {
                        return value;
                    }
                };
                var toModel = function (value) {
                    if (!ngModel.$isEmpty(value) && !isNaN(parseFloat(value))) {
                        var formattedDate = moment(value);
                        ngModel.$modelValue = formattedDate.valueOf();
                        ngModel.$setViewValue(new Date(formattedDate.utc().year(), formattedDate.utc().month(), formattedDate.utc().date()));
                        return new Date(formattedDate.utc().year(), formattedDate.utc().month(), formattedDate.utc().date());
                    } else {
                        return undefined;
                    }
                };
                ngModel.$parsers.unshift(toView);
                ngModel.$formatters.unshift(toModel);
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('idsObject', idsObject);


    /** @ngInject */
    function idsObject($log, loopEachFilter) {
        return {
            scope: {
                model: '=',
                items: '<',
                readOnly: '<',
                payrolls: '<',
                allowOrder: '<',
                objectName: '@',
                form: '=',
                showHiddenColumn: '<',
                inputFieldName: '@',
                inputFieldId: '@',
                inputName: '@',
                inputId: '@',
                inputOperationName: '@',
                inputOperationId: '@',
                showOnReport: '<'
            },
            restrict: 'E',
            templateUrl: 'app/core/directives/ids-object/ids-object.html',
            link: function (scope) {
                var watchers = {};
                scope.modelArray = [];
                var changePriority = function () {
                    if (angular.isObject(scope.model) && scope.model !== null && scope.allowOrder) {
                        var tempModel = angular.fromJson(angular.toJson(scope.model));
                        for (var i = 0; i < scope.modelArray.length; i++) {
                            var thisItem = scope.modelArray[i];
                            tempModel[thisItem.$id].order = (i + 1);
                        }
                        scope.model = tempModel;
                    }
                    scope.form.$setDirty();
                };

                scope.querySearch = function (searchText) {
                    return Object.values(scope.payrolls || {}).filter(function (item) {
                        return item && item.name && item.name.toLowerCase().includes(searchText.toLowerCase());
                    });
                };

                scope.getNameFromId = function (id) {
                    var found = Object.values(scope.payrolls || {}).find(function (p) {
                        return p.$id === id;
                    });
                    return found ? found.name : 'N/E';
                };

                scope.ensurePayrollsArray = function (id) {
                    if (!scope.model[id]) {
                        scope.model[id] = {};
                    }

                    if (!angular.isArray(scope.model[id].payrolls)) {
                        scope.model[id].payrolls = [];
                    }
                    return scope.model[id].payrolls;
                };

                scope.transformChip = function (chip) {
                    return angular.isObject(chip) ? chip.$id : chip;
                };

                scope.itemInModel = function (itemId) {
                    if (angular.isObject(scope.model) && scope.model !== null) {
                        return scope.model.hasOwnProperty(itemId);
                    } else {
                        return false;
                    }
                };
                scope.addItem = function (item) {
                    var order = scope.modelArray.length + 1;
                    if (!angular.isObject(scope.model) || scope.model == null) {
                        scope.model = {};
                    }
                    if (!scope.model.hasOwnProperty(item.$id)) {
                        scope.model[item.$id] = {
                            active: true,
                            default: false,
                            order: order
                        };
                    }
                    delete scope.newItem;
                    scope.form.$setDirty();
                };
                scope.removeItem = function (id) {
                    delete scope.model[id];
                    scope.form.$setDirty();
                };

                scope.sortableOptionsPaymentSchema = {
                    ghostClass: 'ghost',
                    onEnd: changePriority
                };
                watchers.model = scope.$watch('model', function () {
                    if (angular.isObject(scope.model) && scope.model !== null) {
                        var tempArray = [];
                        loopEachFilter(scope.model, function (item, itemId) {
                            scope.ensurePayrollsArray(itemId)
                            item.$id = itemId;
                            tempArray.push(item);
                        });
                        scope.modelArray = tempArray.sort(function (a, b) {
                            return a.order - b.order;
                        });
                    } else {
                        scope.modelArray = [];
                    }
                }, true);
            }
        };
    }
}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('factorTable', factorTable);


    /** @ngInject */
    function factorTable(getFactorFromBenefitsFilter) {
        return {
            scope: {
                benefit: '<',
                factorSelected: '<',
                employee: '<'
            },
            restrict: 'E',
            templateUrl: 'app/core/directives/factor-table/factor-table.html',
            link: function (scope) {



                var watchers = {};
                function calculateDesireFactor() {
                    if (angular.isDefined(scope.employee)) {
                        var initDate = scope.employee.hasSeniorityDate && angular.isDefined(scope.employee.data.seniorityDate) ? scope.employee.data.seniorityDate : scope.employee.data.enroleDate;
                        scope.desireFactor = getFactorFromBenefitsFilter(scope.benefit, initDate, moment().valueOf(), undefined, false);
                        console.log(scope.desireFactor);
                    }
                }
                function removeSameAndUndefined(valor, indiceActual, arreglo) {
                    var indiceAlBuscar = arreglo.indexOf(valor);
                    if (indiceActual === indiceAlBuscar && typeof (valor) !== 'undefined') {
                        return true;
                    } else {
                        return false;
                    }
                }

                var calculateTable = function () {
                    var holidaysLimit = [];
                    var christmasBonusLimits = [];
                    if (angular.isDefined(scope.benefit)) {
                        if (angular.isArray(scope.benefit.holidaysTable)) {
                            holidaysLimit = scope.benefit.holidaysTable.map(function (item) { return item.limit; });
                        }
                        if (angular.isArray(scope.benefit.christmasBonusTable)) {
                            christmasBonusLimits = scope.benefit.christmasBonusTable.map(function (item) { return item.limit; });
                        }
                    }
                    var newLimits = [].concat(holidaysLimit).concat(christmasBonusLimits);
                    newLimits = newLimits.filter(removeSameAndUndefined);
                    newLimits.sort(function (a, b) { return a - b; });
                    var newArray = [];
                    for (var i = 0; i < newLimits.length; i++) {
                        var factorData = getFactorFromBenefitsFilter(scope.benefit, undefined, undefined, newLimits[i], true);
                        factorData.year = newLimits[i];
                        newArray.push(factorData);
                    }
                    scope.tableOfValues = newArray;
                };
                watchers.holidaysTable = scope.$watchGroup(['employee.hasSeniorityDate', 'employee.data.seniorityDate', 'employee.data.enroleDate'], function (newV) {
                    if (angular.isDefined(newV[1]) || angular.isDefined(newV[2])) {
                        calculateDesireFactor();
                    }
                }, true);
                watchers.holidaysTable = scope.$watch('benefit.holidaysTable', function () {
                    calculateTable();
                }, true);
                watchers.holidaysTable = scope.$watch('benefit.christmasBonusTable', function () {
                    calculateTable();
                }, true);
                watchers.holidaysTable = scope.$watch('benefit.others', function () {
                    calculateTable();
                }, true);

                watchers.holidaysTable = scope.$watchGroup(['benefit.holidaysDefault', 'benefit.christmasBonus', 'benefit.prime'], function () {
                    calculateTable();
                });


                watchers.finalListener = scope.$on('$destroy', function () {
                    for (var f in watchers) {
                        if (watchers.hasOwnProperty(f)) {
                            watchers[f]();
                            delete watchers[f];
                        }
                    }
                });
            }
        };
    }
}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('customFields', customFields);
    /** @ngInject */
    function customFields(AppF, $log, setDataInObjectFilter, DataF, getFromObjectFilter) {
        $log.log('si entro por aqui')
        return {
            transclude: true,
            scope: {
                mainObject: '=',
                fields: '<',
                form: '<'
            },
            restrict: 'E',
            templateUrl: 'app/core/directives/custom-fields/custom-fields.html',
            link: function (scope) {
                scope.debounceTime = AppF.debounceTime;
                scope.setData = setDataInObjectFilter;
                scope.querySearch = function (searchKey, catalog, where, project, itemName) {
                    $log.log(arguments);
                    $log.log('si entro por aqui')
                    return new Promise(function (resolve, reject) {
                        var thisWhere = JSON.parse(new String(where));
                        var thisProject = { project: JSON.parse(new String(project)) };
                        $log.log(thisWhere, thisProject);
                        $log.log('Searching for ', searchKey, ' in catalog ', catalog);
                        DataF.api.autocompleteMongo(searchKey, catalog, thisWhere, thisProject, true).then(function (items) {
                            resolve(items.map(function (item) {
                                item.nameSet = getFromObjectFilter(item, itemName, 'No name');
                                return item;
                            }));
                        }).catch(function (err) {
                            reject(err);
                        });
                    });
                }
            }
        };
    }
}());
/* eslint-disable angular/timeout-service */
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('cfValidations', cfValidations);


    /** @ngInject */
    function cfValidations($log) {
        return {
            require: 'ngModel',
            restrict: 'A',
            scope: {
                cfValidations: '='
            },
            link: function (scope, element, attrs, modelCtrl) {
                function customValidations($modelValue, $viewValue) {
                    return new Promise(function (resolve) {
                        $log.log($modelValue, $viewValue);
                        return new Promise(function (resolve2) {
                            setTimeout(function () {
                                resolve2(true)
                            }, 5000)
                        }).then(function () {
                            var vals = scope.cfValidations;
                            if ($modelValue) {
                                if (!vals.allowLowerCase) {
                                    $log.log()
                                }
                            }
                            return new Promise(function (resolve3) { resolve3(true) })
                        }).then(function () {
                            resolve(true)
                        }).catch(function (error) {
                            if (error) { $log.error(error) }
                            resolve(false)
                        });
                    });
                }
                modelCtrl.$asyncValidators.customValidations = customValidations
            }
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.core')
        .directive('activeIndicator', activeIndicator);
    
    function activeIndicator() {
        var directive = {
            restrict: 'E',
            scope: {
                active: '='
            },
            replace: true,
            templateUrl: 'app/core/directives/active-indicator/active-indicator.html'
        };
        return directive;
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;
        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigationFullwidthToolbar2';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // Set active theme
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions()
    {
        return {
            restrict   : 'E',
            scope      : {
                panelOpen: '=?'
            },
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        backdropEl = angular.element('<div class="ms-theme-options-backdrop"></div>');

                    // Panel open status
                    scope.panelOpen = scope.panelOpen || false;

                    /**
                     * Toggle options panel
                     */
                    function toggleOptionsPanel()
                    {
                        if ( scope.panelOpen )
                        {
                            closeOptionsPanel();
                        }
                        else
                        {
                            openOptionsPanel();
                        }
                    }

                    function openOptionsPanel()
                    {
                        // Set panelOpen status
                        scope.panelOpen = true;

                        // Add open class
                        iElement.addClass('open');

                        // Append the backdrop
                        bodyEl.append(backdropEl);

                        // Register the event
                        backdropEl.on('click touch', closeOptionsPanel);
                    }

                    /**
                     * Close options panel
                     */
                    function closeOptionsPanel()
                    {
                        // Set panelOpen status
                        scope.panelOpen = false;

                        // Remove open class
                        iElement.removeClass('open');

                        // De-register the event
                        backdropEl.off('click touch', closeOptionsPanel);

                        // Remove the backdrop
                        backdropEl.remove();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsPanel = toggleOptionsPanel;
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseTheming', fuseThemingProvider);

    /** @ngInject */
    function fuseThemingProvider()
    {
        // Inject Cookies Service
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        var registeredPalettes,
            registeredThemes;

        // Methods
        this.setRegisteredPalettes = setRegisteredPalettes;
        this.setRegisteredThemes = setRegisteredThemes;

        //////////

        /**
         * Set registered palettes
         *
         * @param _registeredPalettes
         */
        function setRegisteredPalettes(_registeredPalettes)
        {
            registeredPalettes = _registeredPalettes;
        }

        /**
         * Set registered themes
         *
         * @param _registeredThemes
         */
        function setRegisteredThemes(_registeredThemes)
        {
            registeredThemes = _registeredThemes;
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getRegisteredPalettes: getRegisteredPalettes,
                getRegisteredThemes  : getRegisteredThemes,
                setActiveTheme       : setActiveTheme,
                setThemesList        : setThemesList,
                themes               : {
                    list  : {},
                    active: {
                        'name' : '',
                        'theme': {}
                    }
                }
            };

            return service;

            //////////

            /**
             * Get registered palettes
             *
             * @returns {*}
             */
            function getRegisteredPalettes()
            {
                return registeredPalettes;
            }

            /**
             * Get registered themes
             *
             * @returns {*}
             */
            function getRegisteredThemes()
            {
                return registeredThemes;
            }

            /**
             * Set active theme
             *
             * @param themeName
             */
            function setActiveTheme(themeName)
            {
                // If theme does not exist, fallback to the default theme
                if ( angular.isUndefined(service.themes.list[themeName]) )
                {
                    // If there is no theme called "default"...
                    if ( angular.isUndefined(service.themes.list.default) )
                    {
                        $log.error('You must have at least one theme named "default"');
                        return;
                    }

                    $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                    // Otherwise set theme to default theme
                    service.themes.active.name = 'default';
                    service.themes.active.theme = service.themes.list.default;
                    $cookies.put('selectedTheme', service.themes.active.name);

                    return;
                }

                service.themes.active.name = themeName;
                service.themes.active.theme = service.themes.list[themeName];
                $cookies.put('selectedTheme', themeName);
            }

            /**
             * Set available themes list
             *
             * @param themeList
             */
            function setThemesList(themeList)
            {
                service.themes.list = themeList;
            }
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes, fuseThemingProvider)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        // var customTheme = $cookies.getObject('customTheme');
        // if ( customTheme )
        // {
        //     fuseThemes['custom'] = customTheme;
        // }

        $mdThemingProvider.alwaysWatchTheme(false);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });

        // Store generated PALETTES and THEMES objects from $mdThemingProvider
        // in our custom provider, so we can inject them into other areas
        fuseThemingProvider.setRegisteredPalettes($mdThemingProvider._PALETTES);
        fuseThemingProvider.setRegisteredThemes($mdThemingProvider._THEMES);
    }

})();
(function () {
    'use strict';

    var fuseThemes = {
        'default': {
            primary: {
                name: 'fuse-pale-blue',
                hues: {
                    'default': '700',
                    'hue-1': '500',
                    'hue-2': '600',
                    'hue-3': '400'
                }
            },
            accent: {
                name: 'light-blue',
                hues: {
                    'default': '600',
                    'hue-1': '400',
                    'hue-2': '700',
                    'hue-3': 'A100'
                }
            },
            warn: { name: 'red' },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1': '100',
                    'hue-2': '50',
                    'hue-3': '300'
                }
            }
        },
        'pink': {
            primary: {
                name: 'blue-grey',
                hues: {
                    'default': '800',
                    'hue-1': '600',
                    'hue-2': '400',
                    'hue-3': 'A100'
                }
            },
            accent: {
                name: 'pink',
                hues: {
                    'default': '400',
                    'hue-1': '300',
                    'hue-2': '600',
                    'hue-3': 'A100'
                }
            },
            warn: { name: 'blue' },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1': '100',
                    'hue-2': '50',
                    'hue-3': '300'
                }
            }
        },
        'teal': {
            primary: {
                name: 'fuse-blue',
                hues: {
                    'default': '900',
                    'hue-1': '600',
                    'hue-2': '500',
                    'hue-3': 'A100'
                }
            },
            accent: {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1': '400',
                    'hue-2': '600',
                    'hue-3': 'A100'
                }
            },
            warn: { name: 'deep-orange' },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1': '100',
                    'hue-2': '50',
                    'hue-3': '300'
                }
            }
        },
        'tds': {
            primary: {
                name: 'fuse-pale-blue',
                hues: {
                    'default': '700',
                    'hue-1': '500',
                    'hue-2': 'A200',
                    'hue-3': 'A400'
                }
            },
            accent: {
                name: 'fuse-blue',
                hues: {
                    'default': '900',
                    'hue-1': '600',
                    'hue-2': '500',
                    'hue-3': 'A100'
                }
            },
            warn: { name: 'deep-orange' },
            background: {
                name: 'grey',
                hues: {
                    'default': '200',
                    'hue-1': '100',
                    'hue-2': '50',
                    'hue-3': '300'
                }
            }
        }
    };

    angular
        .module('app.core')
        .constant('fuseThemes', fuseThemes);
})();
(function () {
    'use strict';

    var fusePalettes = [{
        name: 'fuse-blue',
        options: {
            '50': '#ebf1fa',
            '100': '#c2d4ef',
            '200': '#9ab8e5',
            '300': '#78a0dc',
            '400': '#5688d3',
            '500': '#3ba0fb',//este
            '600': '#0583f6',//este
            '700': '#275498',
            '800': '#21467e',
            '900': '#046fd0',//este
            'A100': '#c1e1fe',//este
            'A200': '#9ab8e5',
            'A400': '#5688d3',
            'A700': '#275498',
            'contrastDefaultColor': 'light',
            'contrastDarkColors': '50 100 200 A100',
            'contrastStrongLightColors': '300 400'
        }
    }, {
        name: 'fuse-pale-blue',
        options: {
            '50': '#ececee',
            '100': '#c5c6cb',
            '200': '#9ea1a9',
            '300': '#7d818c',
            '400': '#5c616f',
            '500': '#035aa9',//este
            '600': '#353a48',
            '700': '#034683',//este
            '800': '#262933',
            '900': '#1e2129',
            'A100': '#c5c6cb',
            'A200': '#509603',//este
            'A400': '#960350',//este
            'A700': '#034683',
            'contrastDefaultColor': 'light',
            'contrastDarkColors': '50 100 200 A100',
            'contrastStrongLightColors': '300 400'
        }
    }];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming, $window) {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba: rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate() {
            var registeredThemes = fuseTheming.getRegisteredThemes();
            var registeredPalettes = fuseTheming.getRegisteredPalettes();

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme) {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName) {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name': colorType.name,
                        'levels': {
                            'default': {
                                'color': rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1': {
                                'color': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2': {
                                'color': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3': {
                                'color': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName) {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName) {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName) {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName) {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes) {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme) {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName) {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = 'tds'; //$cookies.get('selectedTheme');
            if ($window.__env.mode === 'dev') {
                selectedTheme = 'tds';
            } else if ($window.__env.mode === 'staging') {
                selectedTheme = 'tds';
            }
            if (selectedTheme) {
                fuseTheming.setActiveTheme(selectedTheme);
            } else {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars) {
            var cssTemplate = '[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched) {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel) {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if (color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255) {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if (contrastLevel) {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if (color.length === 3) {
                return 'rgb(' + color.join(',') + ')';
            } else if (color.length === 4) {
                return 'rgba(' + color.join(',') + ')';
            } else {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel) {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if (color[0] === 255 && color[1] === 255 && color[2] === 255) {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if (color[0] === 0 && color[1] === 0 && color[2] === 0) {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('toastQueue', toastQueue);

    /** @ngInject */
    function toastQueue($mdToast, $log) {
        var queues = {};
        var currentPromises = {};
        function executeToast(queue) {
            if (angular.isUndefined(queue)) {
                queue = 'default';
            }
            if (angular.isUndefined(currentPromises[queue]) && queues[queue].length > 0) {
                try {
                    currentPromises[queue] = $mdToast.show(queues[queue][0]);
                    if (angular.isDefined(currentPromises[queue])) {
                        currentPromises[queue].then(function () {
                        }).catch(function () {
                        }).then(function () {
                            queues[queue].shift();
                            delete currentPromises[queue];
                            executeToast(queue);
                        });
                    }
                } catch (error) {
                    queues[queue].shift();
                    delete currentPromises[queue];
                    executeToast(queue);
                    $log.error(error);
                }

            }
        }
        return function (toast, queue) {
            if (angular.isUndefined(queue)) {
                queue = 'default';
            }
            if (angular.isUndefined(queues[queue])) {
                queues[queue] = [];
            }
            if (angular.isDefined(toast)) {
                queues[queue].push(toast);
            }
            executeToast(queue);
        }
    }
}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('successAlertS', successAlert);

    /** @ngInject */
    function successAlert(
        $mdToast,
        $log,
        toastQueue
    ) {
        return function (msg, stay) {
            $log.debug('successAlert called', msg, stay);

            var toast = {
                position: "bottom left",
                parent: document.querySelectorAll("#toaster"),
                template: '<md-toast class="success"><span flex>' + msg + '</span><md-button class="md-icon-button" ng-click="closeToast()"><md-icon style="color: white" aria-label="close" md-font-icon="icon-close"></md-icon></md-button></md-toast>',
                controller: "ToastController"
            };
            if (!stay) toast.hideDelay = 4000;
            else toast.hideDelay = 0;

            // show previously created toast
            //$mdToast.show(toast);
            toastQueue(toast);
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Edge',
                    versionSearch: 'Edge',
                    identity     : 'Edge'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity : 'Chrome'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity     : 'OmniWeb'
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : 'Apple',
                    versionSearch: 'Version',
                    identity     : 'Safari'
                },
                {
                    prop    : $window.opera,
                    identity: 'Opera'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'iCab',
                    identity : 'iCab'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'KDE',
                    identity : 'Konqueror'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity : 'Firefox'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'Camino',
                    identity : 'Camino'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity : 'Netscape'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'MSIE',
                    identity     : 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Trident/7',
                    identity     : 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Gecko',
                    identity     : 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Mozilla',
                    identity     : 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: 'Win',
                    identity : 'Windows'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Mac',
                    identity : 'Mac'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Linux',
                    identity : 'Linux'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPhone',
                    identity : 'iPhone'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPod',
                    identity : 'iPod'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPad',
                    identity : 'iPad'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Android',
                    identity : 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) !== -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index === -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) === -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider() {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject the $log service
        var $log = angular.injector(['ng']).get('$log');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url) {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl() {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject() {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource) {
            if (!angular.isString(key)) {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }
            if (!angular.isArray(resource)) {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }
            // Store the API object
            api[key] = {
                url: baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions: resource[2] || [],
                options: resource[3] || {}
            };
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($q, $log, $resource) {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register: register,
                resolve: resolve,
                request: request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters) {
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if (!resource || !method) {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if (!apiObject) {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // Success
                        function (response) {
                            deferred.resolve(response);
                        },

                        // Error
                        function (response) {
                            deferred.reject(response);
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error) {
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if (!resource || !method) {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if (!apiObject) {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // SUCCESS
                        function (response) {
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if (angular.isDefined(success) && angular.isFunction(success)) {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response) {
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if (angular.isDefined(error) && angular.isFunction(error)) {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('loadingS', loadingS);

    function loadingS($rootScope, $log) {
        function getCaller() {
            try {
                var stack = new Error().stack;
                var lines = stack.split('\n');
                // lines[0] = Error
                // lines[1] = current line (getCaller)
                // lines[2] = caller of start/stop
                return lines[3] || 'unknown';
            } catch (e) {
                return 'unknown';
            }
        }

        return {
            start: function () {
                $rootScope.loadingProgress = true;
                $rootScope.$evalAsync();
                $log.debug('[LoadingS.start] called from:', getCaller());
            },
            stop: function () {
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
                $log.debug('[LoadingS.stop] called from:', getCaller());
            }
        };
    }

}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('infoAlertS', infoAlertS);

    /** @ngInject */
    function infoAlertS($mdToast, $log, toastQueue) {
        return function (msg) {
            $log.debug(msg);

            var toast = {
                position: "bottom left",
                parent: document.querySelectorAll("#toaster"),
                hideDelay: 2000,
                template: '<md-toast class="info"><span flex>' + msg + '</span><md-button class="md-icon-button" ng-click="closeToast()"><md-icon style="color: white" aria-label="close" md-font-icon="icon-close"></md-icon></md-button></md-toast>',
                controller: "ToastController"
            };
            toastQueue(toast);
            // show previously created toast
            //$mdToast.show(toast);
        }
    }
}());
/* eslint-disable angular/json-functions */
(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('errAlertS', errAlert);

    /** @ngInject */
    function errAlert(
        $log,
        $rootScope,
        $http,
        toastQueue,
        $location,
        $state
    ) {

        // ---- Helpers ----------------------------------------------------------

        // 1) Detectar problemas reales de conexión/red
        function isApiConnectionIssue(err) {
            // AngularJS: xhrStatus => 'error' | 'timeout' | 'abort'
            var xs = err && err.xhrStatus;
            if (xs && (xs === 'error' || xs === 'timeout' || xs === 'abort')) return true;

            // status -1 (abort/timeout) o 0 (CORS/offline)
            if (err && (err.status === -1 || err.status === 0)) return true;

            return false;
        }

        // 2) Evitar spam de logs: 1 registro cada 30s por estado
        var lastConnLogByState = {};
        function shouldLogNow(stateName, windowMs) {
            var now = Date.now();
            var key = stateName || '';
            var last = lastConnLogByState[key];
            var win = windowMs || 30000;
            if (!last || (now - last) > win) {
                lastConnLogByState[key] = now;
                return true;
            }
            return false;
        }

        // 3) Clonar seguro (y opcionalmente truncar) objetos JSON
        function safeClone(obj, maxLen) {
            try {
                var json = JSON.stringify(obj);
                if (maxLen && json.length > maxLen) {
                    json = json.slice(0, maxLen) + '…';
                }
                return JSON.parse(json);
            } catch (_) { return null; }
        }

        // 4) Parsear función/archivo:línea:col del stack
        function parseOriginFromStack(stack) {
            if (!stack) return { function: null, file: null, line: null, col: null, rawStack: null };
            var lines = stack.split('\n').map(function (s) { return s.trim(); });
            var target = null;
            for (var i = 1; i < lines.length; i++) {
                if (lines[i].indexOf('logApiConnectionIssue') !== -1) continue;
                target = lines[i];
                break;
            }

            if (!target) return { function: null, file: null, line: null, col: null, rawStack: stack };

            var m1 = target.match(/^at\s+([^\s(]+)\s+\((.*):(\d+):(\d+)\)$/);
            if (m1) {
                return {
                    function: m1[1],
                    file: m1[2],
                    line: Number(m1[3]),
                    col: Number(m1[4]),
                    rawStack: stack
                };
            }
            var m2 = target.match(/^at\s+(.*):(\d+):(\d+)$/);
            if (m2) {
                return {
                    function: null,
                    file: m2[1],
                    line: Number(m2[2]),
                    col: Number(m2[3]),
                    rawStack: stack
                };
            }
            return { function: null, file: null, line: null, col: null, rawStack: stack };
        }

        // 5) Log a Firebase con ruta/estado y origen (función/línea)
        function logApiConnectionIssue(err) {
            // anti-spam por estado
            var stateName = $state.current ? $state.current.name : '';
            if (!shouldLogNow(stateName, 30000)) return;
            // Captura stack en el punto de log
            var e = err instanceof Error ? err : new Error('API_CONN_ISSUE');
            var stack = e && e.stack ? ('' + e.stack) : null;
            var origin = parseOriginFromStack(stack);

            // Truncar rawStack a ~8KB para no inflar RTDB
            if (origin && origin.rawStack && origin.rawStack.length > 8192) {
                origin.rawStack = origin.rawStack.slice(0, 8192) + '…';
            }

            var payload = {
                when: Date.now(),
                route: {
                    path: $location.path(),
                    url: $location.absUrl(),
                    state: stateName || null,
                    params: safeClone($state.params, 4000) // evita objetos enormes
                },
                origin: origin,
                // Opcional: guarda el UID si lo tienes disponible
                user: ($rootScope.F && $rootScope.F.user && $rootScope.F.user.uid) || null
            };

            try {
                $rootScope.F.root.child('settings/logErrors').push(payload);
            } catch (err) {
                $log.warn('No se pudo guardar logErrors', err, payload);
            }
        }

        // ---- Factory principal ------------------------------------------------
        function thisErr(err) {
            // $log.error(err);
            if (angular.isString(err)) {
                // deja el string tal cual
            } else if (angular.isArray(err) && err.length > 0) {
                var thisErrors = err.slice();
                var count = 0;
                var newMsgError = '';
                while (thisErrors.length > 0 && count < 5) {
                    var thisError = thisErrors.pop();
                    if (angular.isString(thisError)) {
                        count++;
                        newMsgError += '<li>' + thisError + '</li>';
                    } else {
                        thisErr(thisError);
                    }
                }
                if (newMsgError !== '') {
                    newMsgError = '<h3>Hay unos errores en la información</h3><ul>' + newMsgError + '</ul>';
                }
                if (thisErrors.length > 0) {
                    thisErr(thisErrors);
                }
                err = newMsgError;
            } else if (err && err.hasOwnProperty('data') && angular.isObject(err.data) && err.data.hasOwnProperty('message')) {
                err = err.data.message;
            } else if (err && err.hasOwnProperty('message') && angular.isUndefined(err.code)) {
                err = err.message;
                if (err && err.indexOf && err.includes('contains undefined in property')) {
                    err = "Algunos valores no están definidos en el objeto que se va guardar en la base de datos";
                }
            } else if (err && angular.isDefined(err.code)) {
                switch (err.code) {
                    case "EMAIL_TAKEN":
                        err = "El correo ya está en uso.";
                        break;
                    case "PERMISSION_DENIED":
                        err = "Permiso Denegado: El objeto está repetido o no cumple con las validaciones";
                        break;
                    case "INVALID_EMAIL":
                        err = "El correo no es válido";
                        break;
                    case "auth/user-not-found":
                        err = "Usuario no encontrado";
                        break;
                    case "auth/wrong-password":
                        err = "Password incorrecto";
                        break;
                    case "auth/email-already-in-use":
                        err = "Correo ya está en uso, favor de usar otro";
                        break;
                    case "auth/too-many-requests":
                        err = "Se ha intentado entrar demasiadas veces con un password incorrecto. Hemos bloqueado toda petición de éste dispositivo, favor de intentar más tarde";
                        break;
                    case "auth/quota-exceeded":
                        err = "Se excedió la cuota de Firebase Auth para esta operación. Favor de intentar más tarde o revisar la cuota/configuración del proyecto en Firebase.";
                        break;
                    case "auth/network-request-failed":
                        // también es un problema de red
                        try { logApiConnectionIssue(err); } catch (e1) { $log.warn("Error al guardar log de red (auth)", e1); }
                        err = "Error de conexión, favor de intentar más tarde";
                        break;
                }
            } else if (err && err.hasOwnProperty("status")) {
                if (isApiConnectionIssue(err)) {
                    try { logApiConnectionIssue(err); } catch (e2) { $log.warn("Error al guardar el log de conexión con el API", e2); }
                    err = "Problemas de conexión con el API, favor de intentar más tarde o si el problema persiste favor de avisar al administrador del sistema";
                } else if (err.status === 403) {
                    err = (err.data && err.data.message) || "Acceso no autorizado";
                } else if (err.status === 404) {
                    err = "Recurso no encontrado (404)";
                }
            } else if (err && err.hasOwnProperty("data")) {
                if (err.data == null) {
                    try { logApiConnectionIssue(err); } catch (e3) { $log.warn("Error al guardar el log de conexión con el API", e3); }
                    err = "Oops Problemas de conexión con el API, favor de intentar más tarde o si el problema persiste favor de avisar al administrador del sistema";
                } else {
                    if (err.data.hasOwnProperty("error")) {
                        if (err.data.error.name == "TokenExpiredError") {
                            $rootScope.F.user.getIdToken(true).then(function (token) {
                                $log.debug(token, "new token");
                                var x = ''; //'Basic ';
                                $http.defaults.headers.common.Authorization = x + token;
                                location.reload();
                            });
                            err = "Token expiró, recargando...";
                        } else {
                            err = err.data.error;
                        }
                    } else {
                        err = err.data && (err.data.message || err.data.error) || "Ocurrió un error";
                    }
                }
            }

            var toast = {
                position: "bottom left",
                hideDelay: 5000,
                template:
                    '<md-toast class="error">' +
                    '<span flex>' + err + '</span>' +
                    '<md-button class="md-icon-button" ng-click="closeToast()">' +
                    '<md-icon style="color: white" aria-label="close" md-font-icon="icon-close"></md-icon>' +
                    '</md-button>' +
                    '</md-toast>',
                controller: "ToastController"
            };

            toastQueue(toast);
        }
        return thisErr;
    }
}());

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function(){
    'use strict';

    angular
        .module('app.core')
        .filter('zeroFillReverse', zeroFillReverse)

    function zeroFillReverse(){

        return zeroFillReverseFn;

        function zeroFillReverseFn(string){
            var num;
            num = parseInt(string);
            return num;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.core')
        .filter('zeroFill', zeroFill);

    /** @ngInject */
    function zeroFill() {
        return function(number, width) {
            width -= number.toString().length;
            if (width > 0) {
                return new Array(width + (/\./.test(number) ? 2 : 1)).join('0') + number;
            }
            return number + ''; // always return a string
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('validateEmployeeOperations', validateEmployeeOperations)

    function validateEmployeeOperations(AppF, DataF) {

        return validateEmployeeOperations;

        function validateEmployeeOperations(idPayroll, fecha) {

            return new Promise(function (resolve, reject) {
                var promise = [];
                var calendar = []
                var calendarioActive;
                //Consulta de los calendarios de la nomina, solo los que tengan el campo == active=true :firebase
                promise.push(AppF.root.child("catalogs/payrollCalendars/" + idPayroll + "/calendars").orderByChild('data/active').equalTo(true).once('value'));
                Promise.all(promise).then(function (datos) {
                    var consultaCalendarActive = datos[0].val();
                    if (!datos[0].exists()) {
                        throw false;
                    }
                    for (var index in consultaCalendarActive) {
                        if (consultaCalendarActive.hasOwnProperty(index)) {
                            calendar.push(index)
                        }
                    }
                    calendarioActive = calendar[0];
                    var query = {
                        payroll: idPayroll,
                        calendar: calendarioActive,
                        operationType: 'ordinary',
                        status: { $gte: 3 },
                        sort: angular.toJson({ 'period': -1 })
                    };
                    //consulta de las operaciones con el calendario, :mongoDB
                    return DataF.api.get('one/operations', query);
                }).then(function (data) {
                    if (data.data.data.length === 0) {
                        throw false
                    }
                    var infoOperation = data.data.data[0];
                    var idPay = data.data.data[0].payroll;
                    //consulta de los calendarios de la nomina por los periodos :firebase
                    return AppF.root.child("catalogs/payrollCalendars/" + idPay + "/periods/" + calendarioActive + "/" + infoOperation.period).once('value')
                }).then(function (periods) {
                    var periodos = periods.val()
                    var finPeriodo = periodos.end;
                    var movementDate = moment(fecha).startOf('day').valueOf();
                    var periodDate = moment(finPeriodo).startOf('day').valueOf();
                    if (movementDate >= periodDate) {
                        resolve(true)
                    } else {
                        resolve(false)
                    }
                }).catch(function (error) {
                    if (error) {
                        reject(error);
                    } else {
                        resolve(true)
                    }
                })
            })
        }
    }
}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('userHasPermission', userHasPermission);

    function userHasPermission(
        pathInObjFilter
    ) {

        return userHasPermissionFn;

        function userHasPermissionFn(userGroups, permissionsGroup, permission, access, isState) {
            for (var g = 0; g < userGroups.length; g++) {
                var group = userGroups[g] + '';
                var ignore = (isState) ? 'app' : false;
                // @todo mejorar esto, ya que es una solución hardcoded para un problema que se da con el state de app.dashboards_project 
                var states = access.split('.');
                if (states.length === 2 && states[0] === 'app') {
                    access = 'app.apps.' + states[1];
                }
                if (states.length === 1) {
                    access = 'apps.' + states[0];
                }
                if (permissionsGroup.hasOwnProperty(group)) {
                    var pathInObj = pathInObjFilter(permissionsGroup[group], access, ignore);
                    if (pathInObj.hasOwnProperty('permissions')) {
                        if (pathInObj.permissions[permission] === true) {
                            return true;
                        }
                    }
                }
            }
            return false;
        }
    }

}());
(function(){
    'use strict';

    angular
        .module('app.core')
        .filter('uppercased', uppercased)

    function uppercased(){

        return uppercasedFn;

        function uppercasedFn(inputValue){
            if (inputValue == undefined) inputValue = '';
            var capitalized = inputValue.toUpperCase();
            return capitalized;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('translateFilter', translateFilter);

    function translateFilter($log, $filter) {
        return translateFilterObj;

        function getValue(value, name, nameTrad) {
            name = ('' + name).toLowerCase();
            nameTrad = ('' + nameTrad).toLowerCase();
            var thisValue = value;
            try {
                if (name.indexOf('date') > -1 || nameTrad.indexOf('fecha') > -1) {
                    var tempDate = moment(thisValue);
                    if (tempDate.isValid()) {
                        thisValue = tempDate.format('DD/MM/YYYY HH:mm:ss')
                    }
                }
            } catch (error) {
                $log.log(error);
                thisValue = value;
            }

            return thisValue;
        }

        function translateFilterObj(obj, path, pathTrans) {
            var translation;
            if (angular.isArray(obj)) {
                translation = []
                for (var i = 0; i < obj.length; i++) {
                    translation.push(translateFilterObj(obj[i], path))
                }
            } else if (angular.isObject(obj)) {
                translation = {};
                $filter('loopEach')(obj, function (value, pathObj) {
                    var pathTransObj = $filter('tdsTranslate')('log.' + pathObj);
                    translation[pathTransObj] = translateFilterObj(value, pathObj, pathTransObj);
                })
            } else {
                if (angular.isDefined(path)) {
                    if (angular.isArray(path)) {
                        path = path[path.length - 1]
                    }
                    if (angular.isUndefined(pathTrans)) {
                        pathTrans = $filter('tdsTranslate')('log.' + path);
                    }
                    obj = getValue(obj, path, pathTrans);
                }
                translation = obj
            }
            return translation;
        }
    }
}());

(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('transformField', transformField)

    function transformField(DataF, errAlertS) {
        var objTypes = {
            string: function (value) {
                return '' + value;
            },
            number: function (value) {
                var thisNumber = parseFloat(value);
                if (isNaN(thisNumber) || !isFinite(thisNumber)) {
                    thisNumber = 0;
                }
                return thisNumber;
            },
            date: function (value) {
                var thisDate = moment(value, ['DD-MM-YYYY', 'DD/MM/YYYY', 'X'], true);
                if (!thisDate.isValid()) {
                    throw 'Fecha no valida';
                }
                return thisDate.valueOf();
            },
            boolean: function (value) {
                if (typeof value === 'string') {
                    value = value.toLowerCase();
                }

                if (value === true || value === 'verdadero' || value === 'sí' || value === 'si' || value === 1) {
                    return true;
                }
                if (value === false || value === 'falso' || value === 'no' || value === 0) {
                    return false;
                }

                return false;
            },

            getFromMongo: function (value, config) {
                return new Promise(function (resolve, reject) {
                    try {
                        if (angular.isUndefined(config.idField)) {
                            throw new Error('No se encontró definido el id')
                        }
                        var query = {};
                        query[config.idField] = value;
                        DataF.api.get(config.catalog, query).then(function (data) {
                            var obj;
                            if (data.data && data.data.length > 0) {
                                obj = data.data[0];
                            }
                            if (angular.isUndefined(obj)) {
                                throw new Error('No se encontraron los datos en ' + config.catalog + ' con valor ' + value)
                            }
                            var propertyToGet = config.propertyToGet ? config.propertyToGet : '_id'
                            resolve(obj[propertyToGet]);
                        }).catch(function (error) {
                            reject(error);
                        });
                    } catch (error) {
                        reject(error)
                    }
                });
            },

            // getFromFirebase: function (value, config) {
            //     return new Promise(function (resolve, reject) {

            //         resolve('Consultar y obtener de firebase')
            //     });
            // },
            // Promise.all([Promise.all([PromiseOfPhone, PromiseOfType, PromiseOfActive]), Promise.all([PromiseOfPhone, PromiseOfType, PromiseOfActive])]);
            // resp=[
            //     ['valorFinalPhone', 'valorFinalType', 'valorFInalActive'],
            //     ['valorFinalPhone', 'valorFinalType', 'valorFInalActive']
            // ]
            // values = [9981659129,Personal]
            // config.items=[{type:'string',field:'phone'},{type:'string',field:'type'},{type:'boolean',field:'active',defaultValue:true}]
            arrayObject: function (value, config) {
                return new Promise(function (resolve, reject) {
                    try {
                        var rows = value.split('|');
                        var promises = [];
                        var headers = [];
                        for (var r = 0; r < rows.length; r++) {
                            var promisesRow = [];
                            var values = rows[r].split(':');
                            for (var f = 0; f < config.items.length; f++) {
                                var thisFieldConfig = config.items[f];
                                if (r === 0) {
                                    headers.push(thisFieldConfig.field)
                                }
                                promisesRow.push(transformFieldFn(thisFieldConfig.type, values[f], thisFieldConfig));
                            }
                            promises.push(Promise.all(promisesRow));
                        }
                        Promise.all(promises).then(function (resp) {
                            var thisArray = [];
                            for (var r = 0; r < resp.length; r++) {
                                var obj = {};
                                for (var h = 0; h < headers.length; h++) {
                                    var fieldName = headers[h];
                                    obj[fieldName] = resp[r][h];
                                }
                                thisArray.push(obj);
                            }
                            resolve(thisArray);
                        }).catch(reject);
                    } catch (error) {
                        reject(error);
                    }

                })

            }
        };
        return transformFieldFn;
        // Esta function recibe un valor que va a convertir a un tipo de objeto dato con cierta configuración, 
        // en caso de que no se proporcione el valor también se manejara un valor default en la configuración, 
        // siempre regresará una promesa cuyo cumplimiento resulto es el valor final
        // Ejem.
        // 1 -> string -> "1";
        // "63.94"->number->63.94
        // "verdadero"->boolean->true
        // "9981659129:Personal|9981049830:Casa"->arrayObject->[{phone:9981659129,type:'Personal},{phone:9981049830,type:'Casa}]
        function transformFieldFn(objType, value, config) {
            return new Promise(function (resolve, reject) {
                try {
                    if (angular.isUndefined(value) || value === null || value === '') {
                        if (angular.isObject(config) && angular.isDefined(config.defaultValue)) {
                            value = config.defaultValue;
                        } else {
                            value = undefined;
                        }
                    }
                    if (angular.isUndefined(value)) {
                        resolve(null);
                    } else {
                        var thisValue = objTypes[objType](value, config);
                        var promises = [];
                        if (typeof (thisValue) === 'object' && angular.isFunction(thisValue.then)) {
                            promises.push(thisValue);
                        }
                        Promise.all(promises).then(function (resp) {
                            if (resp.length > 0) {
                                thisValue = resp[0];
                            }
                            resolve(thisValue);
                        }).catch(reject)
                    }
                } catch (error) {
                    reject(error);
                }
            });
        }
    }
}());
(function(){
    'use strict';

    angular
        .module('app.core')
        .filter('timeDiff', timeDiff)

    function timeDiff(){

        return timeDiffFn;

        function timeDiffFn(date1, date2, format){
            if(!date2) date2 = moment();
            if(!format) format = 'years';
            var diff = moment(date1).diff(moment(date2), format);

            return Math.abs(diff);
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('tdsTranslate', tdsTranslate);

    function tdsTranslate($log, translateFilter, dateFilter) {
        return tdsTranslate;

        function tdsTranslate(text, parent) {
            var result = translateFilter(text);
            if (result === text) {
                var resultArray = text.split('.');
                var converted = false;
                try {
                    if (parent === 'changeLog') {
                        var thisDate = moment(resultArray[resultArray.length - 1], 'X');
                        if (thisDate.isValid()) {
                            result = thisDate.format('DD-MM-YY(HH:ss)')
                            converted = true;
                        }
                    }
                } catch (error) {
                    $log.error(error);
                    converted = false;
                }
                if (!converted) {
                    result = resultArray[resultArray.length - 1];
                }
            }
            return result;
        }
    }
}());

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function() {
    'use strict';

    angular
        .module('app.core')
        .filter('switchOtherMongoRecords', switchOtherMongoRecords)

    function switchOtherMongoRecords(MongoF, DataF, successAlertS, errAlertS, $q, $rootScope) {

        return switchOtherMongoRecordsFn;

        function switchOtherMongoRecordsFn(id, catalog, field, value, params) {
            return $q(function(resolve, reject) {
                params = params ? params : {};
                if (!value) value = 0;
                console.log(params);
                DataF.api.get(catalog, params).then(function(res) {
                    var mCatalog = res.data;
                    for (var c in mCatalog) {
                        var record = mCatalog[c];
                        if (record[field] == true && record._id !== id) {
                            record[field] = value;
                            var idd = angular.copy(record._id);
                            var recordd = angular.copy(record);
                            DataF.api.update(catalog, record._id, record).then(function() {
                                $rootScope.$emit('mongoCatalogUpdated', {
                                    name: catalog,
                                    data: recordd,
                                    id: idd
                                });
                                resolve(true);
                            }, function(err) {
                                errAlertS(err);
                                reject(err);
                            });
                        }
                    }
                    resolve(true);
                }, function(err) {
                    reject(err);
                });

            });
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('sumObjects', sumObjects);

    function sumObjects(loopEachFilter) {

        return sumObjectsFn;

        function sumObjectsFn(obj) {
            var count = 0;
            loopEachFilter(obj, function (data) {
                count += data;
            });
            return count;
        }
    }

}());
(function(){
    'use strict';

    angular
        .module('app.core')
        .filter('successMsg', successMsg)

    function successMsg(
        AppF,
        translateFilter
    ){

        return successMsgFn;

        function successMsgFn(action, length, whatSingular, whatPlural){
            if(!whatSingular) whatSingular = translateFilter(AppF.active.menuName + '.SINGULAR');
            if(!whatPlural) whatPlural = translateFilter(AppF.active.menuName + '.PLURAL');
            var msg = 'Se ';
            switch(action){
                case 'delete':
                    msg += (length > 1) ? 'borraron' : 'borró';
                break;
                case 'add':
                    msg += (length > 1) ? 'agregaron' : 'agregó';
                break;
                case 'edit':
                    msg += (length > 1) ? 'actualizaron' : 'actualizó';
                break;
            }
            if(msg == 'Se ') msg += action;
            msg += ' ' + length + ' ';
            msg += (length > 1) ? whatPlural : whatSingular;

            return msg;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('startAfterInit', startAfterInit);

    /** @ngInject */
    function startAfterInit(AppF, loopEachFilter, $rootScope, $log) {
        return function (scope, watchersObj, initFlag, initF, onDestroyFn) {
            function turnOffWatchers(all) {
                loopEachFilter(watchersObj, function (watcher, watcherKey) {
                    if (angular.isFunction(watchersObj[watcherKey]) && (all || (!all && watcherKey !== 'onDestroy'))) {
                        $log.log('Deleting ' + watcherKey);
                        watchersObj[watcherKey]();
                        delete watchersObj[watcherKey];
                    }
                });
            }
            watchersObj.onDestroy = scope.$on('$destroy', function () {
                turnOffWatchers(true);
                try {
                    angular.isArray(onDestroyFn) && onDestroyFn.forEach(function (f) { f(); });
                } catch (error) {
                    $log.error('Error on destroy startAfterInitFilter', error);
                }
            });

            //POR SI SE CARGA Y LOS DATOS YA ESTÁN CARGADO
            if (AppF.allLoaded && !initFlag) {
                initFlag = true;
                initF();
            } else if (!initFlag) {
                //OBSERVADOR INICIAL DE DATOS NECESARIO PARA NAVEGACIÓN
                watchersObj.allLoadedInitiated = $rootScope.$on('allLoaded', function () {
                    if (!initFlag) {
                        initFlag = true;
                        initF();
                        watchersObj.allLoadedInitiated();
                        delete watchersObj.allLoadedInitiated;
                    }
                });
            }

        };
    }

})();
(function(){
    'use strict';

    angular
        .module('app.core')
        .filter('sortObjectProperties', sortObjectProperties)

    function sortObjectProperties(){

        return sortObjectPropertiesFn;

        function sortObjectPropertiesFn(object){
            var objectSorted = {}, keys = Object.keys(object),
            i, len = keys.length;

            keys.sort(function(a,b){return a - b});

            for (i = 0; i < len; i++) {
                var k = keys[i];
                objectSorted[k] = object[k];
            }
            return objectSorted;
        }
    }

}());
(function(){
    'use strict';

    angular
        .module('app.core')
        .filter('somethingOfLQ', somethingOfLQ)

    function somethingOfLQ(
        AppF,
        errAlertS,
        $q
        ){

        return somethingOfLQFn;

        function somethingOfLQFn(id, catalog, something){
            if(!something) something = 'name';
            var promise = $q.defer();
            AppF.root.child('lists').child(catalog).child('all').child(id).child(something).once('value', function(snap){
                var som = snap.val();
                if(som){
                    promise.resolve(som);
                } else {
                    promise.resolve('...');
                }
            }, function(err){
                errAlertS(err);
                promise.reject(err);
            });

            return promise.promise;
        }
    }

}());
(function(){
    'use strict';

    angular
        .module('app.core')
        .filter('setTabIndexMap', setTabIndexMap)

    function setTabIndexMap(){

        return setTabIndexMapFn;

        function setTabIndexMapFn(tabs){
            var tabMap = {};
            var index = 0;
            for(var tabName in tabs){
                tabMap[tabName] = index;
                index++;
            }
            return tabMap;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('setInObjectPath', setInObjectPath)

    function setInObjectPath(clearObjectFilter) {

        return setInObjectPathFn;

        function setInObjectPathFn(path, object, value, forceThisValue, justSetIt) {
            var obj;
            if (!justSetIt) {
                obj = clearObjectFilter(object)
            } else {
                obj = object;
            }
            if (path.search('.') == -1) {
                obj[path] = value;
            } else {
                var paths = path.split('.');
                switch (paths.length) {
                    case 1:
                        if (typeof (obj[paths[0]] == "undefined") || forceThisValue) {
                            if (typeof (value) == "undefined") {
                                delete obj[paths[0]]
                            } else {
                                obj[paths[0]] = value;
                            }
                        }
                        break;
                    case 2:
                        if (typeof (obj[paths[0]]) == "undefined") obj[paths[0]] = {};
                        if (typeof (obj[paths[0]][paths[1]]) == "undefined" || forceThisValue) {
                            if (typeof (value) == "undefined") {
                                delete obj[paths[0]][paths[1]];
                            } else {
                                obj[paths[0]][paths[1]] = value;
                            }
                        }
                        break;
                    case 3:
                        if (typeof (obj[paths[0]]) == "undefined") obj[paths[0]] = {};
                        if (typeof (obj[paths[0]][paths[1]]) == "undefined") obj[paths[0]][paths[1]] = {};
                        if (typeof (obj[paths[0]][paths[1]][paths[2]]) == "undefined" || forceThisValue) {
                            if (typeof (value) == "undefined") {
                                delete obj[paths[0]][paths[1]][paths[2]];
                            } else {
                                obj[paths[0]][paths[1]][paths[2]] = value;
                            }
                        }
                        break;
                    case 4:
                        if (typeof (obj[paths[0]]) == "undefined") obj[paths[0]] = {};
                        if (typeof (obj[paths[0]][paths[1]]) == "undefined") obj[paths[0]][paths[1]] = {};
                        if (typeof (obj[paths[0]][paths[1]][paths[2]]) == "undefined") obj[paths[0]][paths[1]][paths[2]] = {};
                        if (typeof (obj[paths[0]][paths[1]][paths[2]][paths[3]]) == "undefined" || forceThisValue) {
                            if (typeof (value) == "undefined") {
                                delete obj[paths[0]][paths[1]][paths[2]][paths[3]];
                            } else {
                                obj[paths[0]][paths[1]][paths[2]][paths[3]] = value;
                            }
                        }
                        break;
                    case 5:
                        if (typeof (obj[paths[0]]) == "undefined") obj[paths[0]] = {};
                        if (typeof (obj[paths[0]][paths[1]]) == "undefined") obj[paths[0]][paths[1]] = {};
                        if (typeof (obj[paths[0]][paths[1]][paths[2]]) == "undefined") obj[paths[0]][paths[1]][paths[2]] = {};
                        if (typeof (obj[paths[0]][paths[1]][paths[2]][paths[3]]) == "undefined") obj[paths[0]][paths[1]][paths[2]][paths[3]] = {};
                        if (typeof (obj[paths[0]][paths[1]][paths[2]][paths[3]][paths[4]]) == "undefined" || forceThisValue) {
                            if (typeof (value) == "undefined") {
                                delete obj[paths[0]][paths[1]][paths[2]][paths[3]][paths[4]];
                            } else {
                                obj[paths[0]][paths[1]][paths[2]][paths[3]][paths[4]] = value;
                            }
                        }
                        break;
                }
            }
            return obj;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.core')
        .filter('setTimeOfDate', setTimeOfDate);

    /** @ngInject */
    function setTimeOfDate() {
        return function(date, m) {
            if (m == "end") {
                date.set(23, "hours");
                date.set(59, "minutes");
                date.set(59, "seconds");
                date.set(999, "milliseconds");
            } else if (m == "start") {
                date.set(0, "hours");
                date.set(0, "minutes");
                date.set(0, "seconds");
                date.set(0, "milliseconds");
            }

        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('searchSpecific', searchSpecific);

    function searchSpecific($log) {
        return function (items, searchText, fields) {
            // $log.log(items, searchText, fields)
            if (!searchText || !fields || !angular.isArray(fields) || fields.length === 0) {
                return items;
            }
            searchText = searchText.toLowerCase();
            return items.filter(function (item) {
                return fields.some(function (field) {
                    if (item.data.hasOwnProperty(field) && angular.isString(item.data[field])) {
                        return item.data[field].toLowerCase().includes(searchText);
                    }
                    return false;
                });
            });
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('recordsHaveValue', recordsHaveValue)

    function recordsHaveValue(getFromObjectFilter) {

        return recordsHaveValueFn;

        function recordsHaveValueFn(arrayObject, field, value, any) {
            var anyHasIt = false;
            var allHasIt = true;
            var thisValue = value ? value : "notDefinedYet";
            for (var a in arrayObject) {
                var thisObject = arrayObject[a];
                var objectValue = getFromObjectFilter(thisObject, field);
                if (thisValue === "notDefinedYet") {
                    thisValue = objectValue;
                }
                if (value === '#anyValue#' && typeof (objectValue) !== 'undefined') {
                    anyHasIt = true;
                } else if (value === '#anyValue#' && typeof (objectValue) === 'undefined') {
                    allHasIt = false;
                } else if (thisValue === objectValue) {
                    anyHasIt = true;
                } else {
                    allHasIt = false;
                }
            }
            if (any) {
                return anyHasIt;
            } else {
                return allHasIt;
            }

        }
    }

}());
(function(){
    'use strict';

    angular
        .module('app.core')
        .filter('randomPassword', randomPassword)

    function randomPassword(){

        return randomPasswordFn;

        function randomPasswordFn(){
            var possibleChars = ['abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!?_-'];
            var password = '';
            for(var i = 0; i < 16; i += 1) {
                password += possibleChars[Math.floor(Math.random() * possibleChars.length)];
            }
            return password;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('processImportData', processImportData)

    function processImportData(transformFieldFilter, DataF) {
        function getObjectToUpdate(catalog, records, idsFields, extraQuery, queryParams) {
            return new Promise(function (resolve, reject) {
                var queriesPromises = [];
                var indexesToUpdate = [];
                for (var e = 0; e < records.length && queriesPromises.length < 20; e++) {
                    var thisRecord = records[e];
                    if (thisRecord.query !== queryParams) {
                        thisRecord.query = queryParams;
                        var query = extraQuery || {};
                        for (var i = 0; i < idsFields.length; i++) {
                            query[idsFields[i].target.path] = thisRecord[idsFields[i].name];
                        }
                        indexesToUpdate.push(e);
                        queriesPromises.push(DataF.api.get(catalog, query));
                    }
                }
                if (queriesPromises.length === 0) {
                    resolve(records);
                } else {
                    Promise.all(queriesPromises).then(function (resp) {
                        for (var r = 0; r < resp.length; r++) {
                            var indexInRecords = indexesToUpdate[r];
                            records[indexInRecords].objToUpdate = resp[r].data.length === 1 ? resp[r].data[0] : undefined;
                        }
                        resolve(getObjectToUpdate(catalog, records, idsFields, extraQuery, queryParams))
                    }).catch(reject);
                }
            });
        }
        function formatRecords(records, headers, nextIndexToCheck) {
            return new Promise(function (resolve, reject) {
                nextIndexToCheck = angular.isUndefined(nextIndexToCheck) ? 0 : nextIndexToCheck;
                if (nextIndexToCheck >= records.length) {
                    resolve(records);
                } else {
                    var promises = [];
                    var indexes = [];
                    while (nextIndexToCheck < records.length && promises.length === 0) {
                        var recordToCheck = records[nextIndexToCheck];
                        if (angular.isDefined(recordToCheck.objToUpdate)) {
                            delete records[nextIndexToCheck].error;
                            records[nextIndexToCheck].valid = true;
                            for (var h = 0; h < headers.length; h++) {
                                var thisHeader = headers[h];
                                if (!thisHeader.noImport) {
                                    promises.push(transformFieldFilter(thisHeader.target.type, records[nextIndexToCheck][thisHeader.name], thisHeader.target));
                                    indexes.push(thisHeader.name + '_formatted');
                                }
                            }
                        } else {
                            records[nextIndexToCheck].valid = false;
                            records[nextIndexToCheck].error = 'Registro a actualizar no encontrado';
                        }
                        nextIndexToCheck++;
                    }
                    Promise.all(promises).then(function (resp) {
                        if (resp.length > 0) {
                            for (var r = 0; r < resp.length; r++) {
                                records[nextIndexToCheck - 1][indexes[r]] = resp[r];
                            }
                        }
                        resolve(formatRecords(records, headers, nextIndexToCheck))
                    }).catch(reject);
                }


            })
        }
        return processImportDataFn;
        function processImportDataFn(catalog, records, idsFields, extraQuery, headers, queryParams) {
            return new Promise(function (resolve, reject) {
                getObjectToUpdate(catalog, records, idsFields, extraQuery, queryParams).then(function (recordsR) {
                    return formatRecords(recordsR, headers);
                }).then(function (recordsR) {
                    resolve(recordsR);
                }).catch(reject)
            });
        }
    }
}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('permissionsForUser', permissionsForUser)

    function permissionsForUser($log) {

        return permissionsForUserFn;

        function permissionsForUserFn(userGroups, groupPermissions, permission, parent) {
            var modulesPermitted = [];
            for (var g in userGroups) {
                var group = userGroups[g];
                angular.forEach(groupPermissions[group][parent], function (module, moduleKey) {
                    if (angular.isObject(module) && angular.isObject(module.permissions)) {
                        if (module.permissions[permission]) {
                            if (modulesPermitted.indexOf(moduleKey) === -1) { //not in modulesPermitted already
                                modulesPermitted.push(moduleKey);
                            }
                        }
                    } else {
                        $log.error('No hay permisos en este modulo: ' + moduleKey, module);
                    }
                });
            }
            return modulesPermitted;
        }
    }

}());
(function(){
    'use strict';

    angular
        .module('app.core')
        .filter('permissionName', permissionName)

    function permissionName(){

        return permissionNameFn;

        function permissionNameFn(permission){
            var p = "";
            switch(permission){
                case "access":  p = "Acceso";   break;
                case "create":  p = "Crear";    break;
                case "read":    p = "Listar";   break;
                case "remove":  p = "Borrar";   break;
                case "update":  p = "Actualizar"; break;
            }
            return p;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('pathInObj', pathInObj)

    function pathInObj() {

        return pathInObjFn;

        function pathInObjFn(obj, access, ignore, defaultValue) {
            defaultValue = defaultValue ? defaultValue : false;
            var pathInObj;
            pathInObj = obj;
            if (obj && angular.isString(access)) {
                var paths = access.split('.');
                if (ignore) {
                    var ignoredI = paths.indexOf(ignore);
                    if (ignoredI !== -1) paths.splice(ignoredI, 1);
                }
                for (var a in paths) {
                    var path = paths[a];
                    pathInObj = (pathInObj.hasOwnProperty(path)) ? angular.fromJson(angular.toJson(pathInObj[path])) : defaultValue;
                }
            }

            return pathInObj;
        }
    }

}());
(function(){
    'use strict';

    angular
        .module('app.core')
        .filter('parseMessage', parseMessage)

    function parseMessage(){

        return parseMessageFn;

        /**@type filter, parser TODO: not in use
         * @description convierte llaves {{payroll.23452345}} en el nombre de un listado
         * @param {string} msg 
         * @returns string
         */
        function parseMessageFn(msg, Lists){
            function parseMsg(m){
                var message = angular.copy(m);
                if(Lists){
                    var firstIndexOfStart = message.indexOf('{{'),
                    firstIndexOfEnd = message.indexOf('}}');
                    console.log(firstIndexOfStart, firstIndexOfEnd, 1)
                    if(firstIndexOfStart !== -1){
                        var differenceLenght = firstIndexOfStart - firstIndexOfEnd;
                        console.log(differenceLenght, 2)
                        var variableName = message.substr(firstIndexOfStart, differenceLenght);
                        console.log(variableName, 3)
                        var variablesPaths = variableName.split('.');
                        console.log(variablesPaths, 4)
                        var nameOfList = variablesPaths[0];
                        console.log(nameOfList, 5)
                        var idOfVar = variablesPaths[1];
                        console.log(idOfVar, 6)
                        var nameOfVar = Lists[nameOfList][idOfVar].name;
                        console.log(nameOfVar, 7)
                        message = message.replace('{{' + variableName + '}}', nameOfVar);
                        if(message.indexOf('{{') !== -1){
                            return parseMsg(message);
                        } 
                    }
                }
                return message;
            }

            var msgParsed = parseMsg(msg);
            
            return msgParsed;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('orderObjectBy', orderObjectBy)

    function orderObjectBy(getFromObjectFilter) {

        return orderObjectByFn;

        function orderObjectByFn(items, field, reverse) {
            var filtered = [];
            angular.forEach(items, function (item, index) {
                if (typeof (item) == "object") {
                    item.$id = index;
                }
                filtered.push(item);
            });
            filtered.sort(function (a, b) {
                var aValue = getFromObjectFilter(a, field);
                var bValue = getFromObjectFilter(b, field);
                return (aValue > bValue ? 1 : -1);
            });
            if (reverse) filtered.reverse();
            return filtered;
        };

    }

}());
(function(){
    'use strict';

    angular
        .module('app.core')
        .filter('openGroups', openGroups)

    function openGroups(){

        return openGroupsFn;

        function openGroupsFn(permissions){
            var open = {
                groups: {},
                apps: {}
            };
            angular.forEach(permissions, function(groupName, groupApps){
                open.groups[groupName] = {};
                open.apps[groupName] = {};
                if(groupName !== true){
                    angular.forEach(groupApps, function(appGroup, apps){
                        open.groups[groupName][appGroup] = false;
                        open.apps[groupName][appGroup] = {};
                        if(apps !== true){
                            angular.forEach(apps, function(appName, app){
                                open.apps[groupName][appGroup][appName] = false;
                            })
                        }
                    });
                }   
            });
            return open;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('objectsLength', objectsLength)

    function objectsLength() {

        return objectsLengthFn;

        function objectsLengthFn(thisObj) {
            var count = 0;
            if (angular.isObject(thisObj)) {
                count = Object.keys(thisObj).length;
            }
            return count;
        }
    }

}());
(function(){
    'use strict';

    angular
        .module('app.core')
        .filter('objectInArray', objectInArray)

    function objectInArray(){

        return objectInArrayFn;

        function objectInArrayFn(array, object){
            for(var a in array){
                if(object === array[a]) return true;
            }
            
            return false;
        }
    }

}());
(function(){
    'use strict';

    angular
        .module('app.core')
        .filter('nameOfM', nameOfM)

    function nameOfM(){

        return nameOfMFn;

        function nameOfMFn(id, array, inData, defaultValue){
            var name = (defaultValue) ? defaultValue : "";
            if(id && array){
                for(var a in array){
                    if(array[a]._id == id){
                        if(inData) return array[a].data.name;
                        return array[a].name;
                    }
                }
            }
                
            return name;
            
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('nameOfL', nameOfL)

    function nameOfL($log) {

        return nameOfLFn;

        function nameOfLFn(id, list, defaultV) {
            // $log.log(list, defaultV);
            var name = "N/A";
            if (defaultV) name = defaultV;

            if (angular.isArray(list)) {
                for (var j = 0; j < list.length; j++) {
                    if (list[j].$id == id) {
                        return list[j].name;
                    }
                }
            } else {
                for (var l in list) {
                    if (list[l].$id == id) {
                        return list[l].name;
                    }
                }
            }
            return name;
        }
    }

}());
(function(){
    'use strict';

    angular
        .module('app.core')
        .filter('nameOfF', nameOfF)

    function nameOfF(){

        return nameOfFFn;

        function nameOfFFn(id, array){
            var name = "";
            if(id && array){
                for(var a in array){
                    if(array[a].$id == id){
                        return array[a].data.name;
                    }
                }
            }
                
            return name;
            
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.core')
        .filter('mergeObjectsOfArrayProperties', mergeObjectsOfArrayProperties)

    function mergeObjectsOfArrayProperties(filterFilter, pathInObjFilter) {

        return mergeObjectsOfArrayPropertiesFn;

        function mergeObjectsOfArrayPropertiesFn(firstGroup, secondGroup, firstGroupField, secondGroupField, fieldsToMerge, allFields, defaultValue) {
            secondGroupField = secondGroupField ? secondGroupField : firstGroupFiled;
            if (typeof(firstGroup) == "object" && typeof(secondGroup) == "object" && firstGroup.length && secondGroup.length && (typeof(fieldsToMerge) === "object" || typeof(fieldsToMerge) == "string" || typeof(allFields) !== "undefined")) {
                for (var i = 0; i < firstGroup.length; i++) {
                    var firstGroupItem = firstGroup[i];
                    var value = pathInObjFilter(firstGroupItem, firstGroupField);
                    if (value) {
                        var foundThis = {};
                        foundThis[secondGroupField] = value;
                        var founded = filterFilter(secondGroup, foundThis);
                        if (typeof(founded) == "object" && founded.length) {
                            var thisItemFounded = founded[0];
                            if (allFields) {
                                firstGroup[i] = Object.assign(thisItemFounded, firstGroup[i]);
                            } else {
                                if (typeof(fieldsToMerge) == "string") {
                                    var foundedValue = pathInObjFilter(thisItemFounded, fieldsToMerge);
                                    firstGroup[i][fieldsToMerge] = foundedValue;
                                } else {
                                    for (var f = 0; f < fieldsToMerge.length; f++) {
                                        var thisField = fieldsToMerge[f];
                                        var foundedValue = pathInObjFilter(thisItemFounded, thisField);
                                        firstGroup[i][thisField] = foundedValue;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            return firstGroup;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('menuName', menuName)

    function menuName(AppF) {

        return menuNameFn;

        function menuNameFn(name) {
            if (AppF.menuItems.other.hasOwnProperty(name)) return AppF.menuItems.other[name].title;
            if (AppF.menuItems.locations.hasOwnProperty(name)) return AppF.menuItems.locations[name].title;
            if (AppF.menuItems.records.hasOwnProperty(name)) return AppF.menuItems.records[name].title;

            if (AppF.menuItems.processes.hasOwnProperty(name)) return AppF.menuItems.processes[name].title;
            if (AppF.menuItems.organization.hasOwnProperty(name)) return AppF.menuItems.organization[name].title;
            if (AppF.menuItems.captures.hasOwnProperty(name)) return AppF.menuItems.captures[name].title;
            if (AppF.menuItems.movements.hasOwnProperty(name)) return AppF.menuItems.movements[name].title;
            if (AppF.menuItems.rh.hasOwnProperty(name)) return AppF.menuItems.rh[name].title;
            if (AppF.menuItems['help-center'].hasOwnProperty(name)) return AppF.menuItems['help-center'][name].title;
            if (AppF.menuItems['idse-panel'].hasOwnProperty(name)) return AppF.menuItems['idse-panel'][name].title;
            if (AppF.menuItems['apps-sync'].hasOwnProperty(name)) return AppF.menuItems['apps-sync'][name].title;

            if (AppF.menuItems.config.hasOwnProperty(name)) return AppF.menuItems.config[name].title;
            if (AppF.menuItems.apps.hasOwnProperty(name)) return AppF.menuItems.apps[name].title;
            if (AppF.menuItems.system.hasOwnProperty(name)) return AppF.menuItems.system[name].title;

            return false;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.core')
        .filter('loadObjectsAndLists', loadObjectsAndLists)

    function loadObjectsAndLists(
        AppF,
        ListsF,
        RoutesF,
        $q,
        $log,
        $localStorage,
        $firebaseObject,
        $firebaseArray,
        $sessionStorage,
        errAlertS,
        clearObjectFilter
    ) {

        return loadObjectsAndListsFn;

        function loadObjectsAndListsFn(map) {
            var session = false;
            var promises = {};
            var getPromiseFromRefMap = function(mapRef, r){
                var setObjectInF = function(refRef, refAlias){
                    AppF[refAlias] = $firebaseObject(AppF.root.child(refRef));
                    AppF[refAlias].$loaded(function(){
                        // $log.debug('Loaded simple object in AppF.' + refAlias, {
                        //     ref: refRef, 
                        //     from: refName,
                        //     loaded: AppF[refAlias],
                        //     isObject: isObject
                        // });
                        if(session){
                            if(!$sessionStorage.F) $sessionStorage.F = {};
                            $sessionStorage.F[refAlias] = clearObjectFilter(AppF[refAlias]);
                            // $localStorage.version.objects[refAlias] = version;
                        }
                        promises[r].resolve(true);
                    }, function(err){
                        errAlertS(err);
                        promises[r].reject(err);
                    });
                }
                // $log.debug('Trying to load mapRef', mapRef);
                promises[r] = $q.defer();
                var refName = mapRef;
                var isObject = (!angular.isString(refName));
                var refAlias = '';
                var refRef = angular.copy(RoutesF.dinamicRefs[refName]);
                var hasAlias = false;
                // if(!$localStorage.version) $localStorage.version = {};
                // if(!$localStorage.version.objects) $localStorage.version.objects = {};
                if (!isObject) {
                    refAlias = angular.copy(refName);
                    hasAlias = refAlias.indexOf('@');
                    if (hasAlias !== -1) {
                        var refArray = refAlias.split('@');
                        refAlias = refArray[0];
                        refRef = refArray[1]
                    }
                    // var version = AppF.version.objects[refAlias];
                    if($sessionStorage.F && session){
                        if($sessionStorage.F[refAlias] && $localStorage.version.objects[refAlias] == version){
                            $log.debug('setted F.' + refAlias + ' from $sessionStorage v: ' + version);
                            AppF[refAlias] = $sessionStorage.F[refAlias];
                            promises[r].resolve(true);
                        } else {
                            setObjectInF(refRef, refAlias);
                        }
                    } else {
                        setObjectInF(refRef, refAlias);
                    }
                } else {
                    if(refName.ref) refRef = refName.ref;
                    if (refName.list) {
                        var child = false;
                        if(refName.child) child = refName.child();
                        var sName = refName.filterName || refName.catalog;
                        var type = (refName.type) ? refName.type : 'array';
                        var fName = (refName.filterName) ? refName.filterName : false;
                        ListsF.loadList(refName.catalog, refRef, child, type, fName).then(function(loadedList){
                            $log.debug('Loaded complex ' + type + ' in Lists.' + sName, {
                                catalog: refName.catalog, 
                                ref: refRef, 
                                child: child, 
                                type: type, 
                                filterName: fName,
                                from: refName,
                                loaded: loadedList
                            });
                            promises[r].resolve(true);
                        }, function(err){
                            errAlertS(err);
                            promises[r].reject(err);
                        });
                    } else {
                        refAlias = refName.alias;
                        // var version = AppF.version.objects[refAlias];
                        if (refName.child) refRef += '/' + refName.child();
                        // setObjectInF(refRef, refAlias, version);
                        if(refName.sync && $sessionStorage.F && session){
                            if($sessionStorage.F[refAlias] && $localStorage.version.objects[refAlias] == version){
                                $log.debug('setted F.' + refAlias + ' from $sessionStorage v:' + version);
                                AppF[refAlias] = $sessionStorage.F[refAlias];
                                promises[r].resolve(true);
                            } else {
                                setObjectInF(refRef, refAlias);
                            }
                        } else {
                            setObjectInF(refRef, refAlias);
                        }
                    }
                }
                return promises[r].promise;
            }
            // $log.debug('loading objects and list', map);
            var requests = [];
            // carga las rutas necesarias
            for (var r in map) {
                if(!angular.isFunction(map[r])){
                    var mapPromise = getPromiseFromRefMap(map[r], r);
                    requests.push(mapPromise);
                }
            }
            // $log.debug('requests promise formed', requests);
            return $q.all(requests);
        }
    }

}());
(function(){
    'use strict';

    angular
        .module('app.core')
        .filter('keyobjToArray', keyobjToArray)

    function keyobjToArray(){

        return keyobjToArrayFn;

        function keyobjToArrayFn(obj, includeFirebaseStuff){
            var array = [];
            for(var g in obj){
                if(includeFirebaseStuff) {
                    if(angular.isString(g)){
                        array.push(g);
                    }
                } else {
                    if(g.indexOf("$") == -1 && angular.isString(g)){
                        array.push(g);
                    }
                }
            }
            return array;
        }
    }

}());
(function () {
    'use strict';
    angular
        .module('app.core')
        .filter('keyObjectAsKey', keyObjectAsKey)

    function keyObjectAsKey(pathInObjFilter) {
        return keyObjectAsKeyFn;

        function keyObjectAsKeyFn(array, key, indexAsValue, originalAsKey) {
            var newObject = {};
            angular.forEach(array, function (value, index) {
                var keyValue = pathInObjFilter(value, key, undefined, "sinvalor");
                if (keyValue != "sinvalor") {
                    if (indexAsValue) {
                        newObject[keyValue] = index;
                    } else {
                        if (angular.isString(originalAsKey) && angular.isObject(value)) {
                            value[originalAsKey] = index;
                        }
                        newObject[keyValue] = value;
                    }
                }
            });
            return newObject;
        }
    }
}());
(function() {
    'use strict';
    angular
        .module('app.core')
        .filter('keyObjectAsId', keyObjectAsId)

    function keyObjectAsId() {
        return keyObjectAsIdFn;

        function keyObjectAsIdFn(array, key, obj) {
            var newArray = [];
            if (obj) {
                var newArray = {};
            }
            angular.forEach(array, function(value, index) {
                newArray[value[key]] = value;
            });
            return newArray;
        }
    }
}());
(function(){
    'use strict';

    angular
        .module('app.core')
        .filter('isThereDeleteInCascade', isThereDeleteInCascade)

    function isThereDeleteInCascade(AppF){

        return isThereDeleteInCascadeFn;

        function isThereDeleteInCascadeFn(parent, beingDeleted){
            var deleteInCascade = false;
            if(parent){
                if(AppF.deleteInCascade.hasOwnProperty(parent)){ 
                    // si tiene configuración de borrado en cascada
                    if(AppF.deleteInCascade[parent].hasOwnProperty(beingDeleted)){ 
                        var goingToDelete = AppF.deleteInCascade[parent][beingDeleted];
                        deleteInCascade = [];
                        for(var what in goingToDelete){
                            deleteInCascade.push(what);
                        }
                    }
                }
            } else {
                if(AppF.deleteInCascade.hasOwnProperty(beingDeleted)){ 
                    var goingToDelete = AppF.deleteInCascade[beingDeleted];
                    deleteInCascade = [];
                    for(var what in goingToDelete){
                        deleteInCascade.push(what);
                    }
                }
            }
            return deleteInCascade;
        }
    }

}());
(function(){
    'use strict';

    angular
        .module('app.core')
        .filter('isThereChildDataM', isThereChildDataM)

    function isThereChildDataM(
        AppF,
        DataF,
        $q,
        $log,
        getArrayOfIdsFilter,
        objectsLengthFilter,
        errAlertS
    ){

        return isThereChildDataMFn;

        function isThereChildDataMFn(toDelete, items){
            var deferred = $q.defer();
            var ids = getArrayOfIdsFilter(items, '_id');
            var formatData = function(dataObject, map){
                var data = {};
                for(var key in dataObject){
                    var catalog = map[key].catalog;
                    var deleteN = map[key].delete;
                    if(!data.hasOwnProperty(catalog)) data[catalog] = {};
                    data[catalog] = (deleteN) ? false : true;
                }
                return data;
            }

            var doQuerys = function(catalogsDependant){
                var querys = {};
                var map = {};
                for(var what in catalogsDependant){
                    var catalogD = catalogsDependant[what];
                    for(var i in ids){
                        var idToQuery = ids[i];
                        if(catalogD.query && catalogD.col) {
                            // se mete una query de 1 item para ver si tiene elementos
                            catalog.query.limit = 1;
                            querys[what + '-' + idToQuery] = DataF.api.get(catalogD.col, catalog.query);
                            // se mapea key de query para formatear posteriormente
                            map[what + '-' + idToQuery] = {
                                catalog: what,
                                id: idToQuery,
                                delete: catalogD.delete
                            };
                        }
                    }
                }
                // se consulta catalogo por catalogo todos los ids para no mandar pedir todo de 1 vez
                var dataFounded = {};
                $q.all(querys).then(function(dataOfIdsInCatalog){
                    for(var idC in dataOfIdsInCatalog){
                        // si tiene datos meterlos en variable
                        var data = dataOfIdsInCatalog[idC].data;
                        if(data !== null) {
                            dataFounded[idC] = true;
                        } 
                    }
                    var hasData = objectsLengthFilter(dataFounded);
                    if(hasData){
                        $log.debug('hasData', hasData, dataFounded, querys);
                        var data = formatData(dataFounded, map);
                        deferred.resolve(data);
                    } else {
                        deferred.resolve(false);
                    }
                }, function(err){
                    errAlertS(err);
                    deferred.reject(err);
                });
            }
            
            if(!AppF.deleteInCascade.hasOwnProperty(toDelete)){
                deferred.resolve(false);
            } else {
                var catalogsDependant = AppF.deleteInCascade[toDelete];
                doQuerys(catalogsDependant);
            }
            // todo:backlog borrar el de arriba y descomentar el de abajo cuando se habilite esta funcion del server para borrar
            // if(!AppF.deleteInCascadeM.hasOwnProperty(toDelete)){
            //     deferred.resolve(false);
            // } else {
            //     var catalogsDependant = AppF.deleteInCascadeM[toDelete];
            //     doQuerys(catalogsDependant);
            // }
            return deferred.promise;
        }
    }

}());
(function(){
    'use strict';

    angular
        .module('app.core')
        .filter('isThereChildData', isThereChildData)

    function isThereChildData(
        AppF,
        $q,
        getArrayOfIdsFilter,
        objectsLengthFilter,
        errAlertS,
        $log
    ){

        return isThereChildDataFn;

        function isThereChildDataFn(parent, toDelete, items){
            var deferred = $q.defer();
            var ids = getArrayOfIdsFilter(items);
            var formatData = function(dataObject, map){
                var data = {};
                for(var key in dataObject){
                    var catalog = map[key].catalog;
                    var deleteN = map[key].delete;
                    if(!data.hasOwnProperty(catalog)) data[catalog] = {};
                    data[catalog] = (deleteN) ? false : true;
                }
                return data;
            }

            var doQuerys = function(parent, catalogsDependant){
                var querys = {};
                var map = {};
                for(var what in catalogsDependant){
                    var catalogD = catalogsDependant[what];
                    for(var i in ids){
                        var idToQuery = ids[i];
                        if(catalogD.query && catalogD.ref) {
                            // se mete una query de 1 item para ver si tiene elementos
                            querys[what + '-' + idToQuery] = AppF.root.child(catalogD.ref).orderByChild(catalogD.query).equalTo(idToQuery).limitToFirst(1).once('value');
                            // se mapea key de query para formatear posteriormente
                            map[what + '-' + idToQuery] = {
                                catalog: what,
                                id: idToQuery,
                                delete: catalogD.delete
                            };
                        }
                    }
                }
                // se consulta catalogo por catalogo todos los ids para no mandar pedir todo de 1 vez
                var dataFounded = {};
                $q.all(querys).then(function(dataOfIdsInCatalog){
                    for(var idC in dataOfIdsInCatalog){
                        // si tiene datos meterlos en variable
                        var data = dataOfIdsInCatalog[idC].val();
                        if(data !== null) {
                            dataFounded[idC] = true;
                        } 
                    }
                    var hasData = objectsLengthFilter(dataFounded);
                    if(hasData){
                        var data = formatData(dataFounded, map);
                        deferred.resolve(data);
                    } else {
                        deferred.resolve(false);
                    }
                }, function(err){
                    errAlertS(err);
                    deferred.reject(err);
                });
            }
            
            if(parent){
                if(!AppF.deleteInCascade.hasOwnProperty(parent)) {
                    $log.debug('no deleteInCascade Configured for ' + parent);
                    deferred.resolve(false);
                } else {
                    if(!AppF.deleteInCascade[parent].hasOwnProperty(toDelete)) {
                        $log.debug('no deleteInCascade Configured for child ' + toDelete);
                        deferred.resolve(false);
                    } else {
                        var catalogsDependant = AppF.deleteInCascade[parent][toDelete];
                        doQuerys(parent, catalogsDependant);
                        // console.log(parent, catalogsDependant, "WTF")
                    }
                }
            } else {
                if(!AppF.deleteInCascade.hasOwnProperty(toDelete)){
                    deferred.resolve(false);
                } else {
                    var catalogsDependant = AppF.deleteInCascade[toDelete];
                    doQuerys(parent, catalogsDependant);
                }
            }
            return deferred.promise;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.core')
        .filter('isSameDay', isSameDay)

    function isSameDay(setTimeOfDateFilter) {

        return isSameDay;

        function capitalizeFn(dateToCompare, date) {
            var dateStart = moment(date);
            setTimeOfDateFilter(dateStart, "start");
            var dateEnd = moment(date);
            setTimeOfDateFilter(dateEnd, "end");
            var dateToCompare = moment(dateToCompare);
            if (dateStart.valueOf() < dateToCompare.valueOf() && dateToCompare.valueOf() < dateEnd.valueOf())
                return true;
            else
                return false;
        }
    }

}());
(function(){
    'use strict';

    angular
        .module('app.core')
        .filter('isAdmin', isAdmin)

    function isAdmin(){

        return isAdminFn;

        function isAdminFn(groupsOfUser, groups){
            for(var g in groupsOfUser){
                var group = groupsOfUser[g];
                if(groups[group].admin) return true;
            }
            return false;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.core')
        .filter('indexObjectQueryOfArray', indexObjectQueryOfArray)

    function indexObjectQueryOfArray(pathInObjFilter) {

        return indexObjectQueryOfArrayFn;

        function indexObjectQueryOfArrayFn(array, query) {
            var index = -1;
            var filteredObj = array.find(function(item, i) {
                var allTrue = true;
                for (var path in query) {
                    var value = query[path];
                    var itemValue = pathInObjFilter(item, path);
                    if (itemValue !== value) {
                        allTrue = false;
                    }
                }
                if (allTrue) {
                    index = i;
                    return i;
                }
            });
            return index;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('imageType', imageType)

    function imageType($log) {

        return function (mime, url) {
            if (mime) {
                if (url) { // if is a FB url
                    // var mimes = ["jpg", "jpeg", "gif", "png", "pdf"];
                    var extP = mime.split(".").pop();
                    var ext = extP.split("?").shift();
                    return "." + ext;
                } else {
                    var type = "";
                    switch (mime) {
                        case "image/jpeg": type = ".jpg"; break;
                        case "image/jpg": type = ".jpg"; break;
                        case "image/gif": type = ".gif"; break;
                        case "image/png": type = ".png"; break;
                        case "application/pdf": type = ".pdf"; break;
                        case "application/x-x509-ca-cert": type = ".cer"; break;
                    }
                    return type;
                }
            } else {
                return false;
            }

        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('holydays', holydays);

    function holydays(
        $log,
        AppF,
        $firebaseArray
    ) {

        function HolydaysInMexico() {
            this.today = undefined;
            this.year = undefined;
            this.month = undefined;
            this.dayOfWeek = undefined;
            this.day = undefined;
            this.pascuaDay = undefined;
            this.pascuaMonth = undefined;
            this.matrix = [];
            var checkHolyday;

            var dateHolydays = function (holyday) {
                return (holyday.day === checkHolyday.day && holyday.month === checkHolyday.month);
            };

            this.getPascua = function () {
                //$log.debug('getting pascua')
                var $M, $N, $a, $b, $c, $d, $e, $f;
                if (this.year > 1583 && this.year < 1699) { $M = 22; $N = 2; }
                else if (this.year > 1700 && this.year < 1799) { $M = 23; $N = 3; }
                else if (this.year > 1800 && this.year < 1899) { $M = 23; $N = 4; }
                else if (this.year > 1900 && this.year < 2099) { $M = 24; $N = 5; }
                else if (this.year > 2100 && this.year < 2199) { $M = 24; $N = 6; }
                else if (this.year > 2200 && this.year < 2299) { $M = 25; $N = 0; }
                $a = this.year % 19;
                $b = this.year % 4;
                $c = this.year % 7;
                $d = ((19 * $a) + $M) % 30;
                $e = ((2 * $b) + (4 * $c) + (6 * $d) + $N) % 7;
                $f = $d + $e;
                if ($f < 10) {
                    this.pascuaDay = $f + 22;
                    this.pascuaMonth = 3;
                } else {
                    this.pascuaDay = $f - 9;
                    this.pascuaMonth = 4;
                }
                if (this.pascuaDay === 26 && this.pascuaMonth === 4) {
                    this.pascuaDay = 19;
                }
                else if (this.pascuaDay === 25 && this.pascuaMonth === 4 && $d === 28 && $e === 6 && $a > 10) {
                    this.pascuaDay = 18;
                }
            };

            this.getToday = function () {
                //$log.debug("getting today's date")
                if (!this.today) { this.today = moment().toDate(); }
                this.year = this.today.getFullYear();
                this.month = this.today.getMonth() + 1;
                this.dayOfWeek = this.today.getDay();
                this.day = this.today.getDate();
                return this.today;
            };

            this.getMatrix = function () {
                this.getPascua();
                this.matrix = $firebaseArray(AppF.root.child('catalogs/holidays/collection'));
            };

            this.getDateOfXLabourDaysFromNow = function (numberOfLabourDays, fromDate, notCheck) {
                var numberOfNaturalDays = angular.copy(numberOfLabourDays);
                var tomorrow;
                var day;
                var month;
                for (var dayCount = 1; dayCount <= numberOfNaturalDays; dayCount++) {
                    tomorrow = angular.isDefined(fromDate) ? moment(fromDate).toDate() : moment().toDate();
                    tomorrow.setDate(tomorrow.getDate() + dayCount);
                    day = tomorrow.getDate();
                    month = tomorrow.getMonth() + 1;
                    var dateToCheck = { day: day, month: month };
                    var dayOfWeek = tomorrow.getDay();
                    if (!notCheck) {
                        if ([0, 6].indexOf(dayOfWeek) !== -1) { // Domingo y Sabados
                            // console.log(dayOfWeek, dateToCheck, "Sabado o Domingo")
                            numberOfNaturalDays++;
                        } else {
                            var dayIsHoly = this.dateIsHolyday(dateToCheck);
                            if (dayIsHoly) {
                                // console.log(dayOfWeek, dateToCheck, dayIsHoly, "Día festivo")
                                numberOfNaturalDays++;
                            }
                        }
                    }

                }
                return {
                    date: tomorrow,
                    day: day,
                    month: month
                };
            };

            this.getDateOfXLabourDaysSinceNow = function (numberOfLabourDays, sinceDate, notCheck, setIso) {
                var numberOfNaturalDays = angular.copy(numberOfLabourDays);
                var yesterday;
                var day;
                var month;
                for (var dayCount = 1; dayCount <= numberOfNaturalDays; dayCount++) {
                    yesterday = angular.isDefined(sinceDate) ? moment(sinceDate).toDate() : moment().toDate();
                    yesterday.setDate(yesterday.getDate() - dayCount);
                    day = yesterday.getDate();
                    month = yesterday.getMonth() + 1;
                    var dateToCheck = { day: day, month: month };
                    var dayOfWeek = yesterday.getDay();
                    if (!notCheck) {
                        if ([0, 6].indexOf(dayOfWeek) !== -1) { // Domingo y Sabados
                            // console.log(dayOfWeek, dateToCheck, "Sabado o Domingo")
                            numberOfNaturalDays++;
                        } else {
                            var dayIsHoly = this.dateIsHolyday(dateToCheck);
                            if (dayIsHoly) {
                                // console.log(dayOfWeek, dateToCheck, dayIsHoly, "Día festivo")
                                numberOfNaturalDays++;
                            }
                        }
                    }

                }
                yesterday.setHours(0, 0, 0, 0);
                if (setIso) {
                    yesterday.setUTCHours(0, 0, 0, 0);
                }
                return {
                    date: yesterday,
                    day: day,
                    month: month
                };
            };

            this.dateIsHolyday = function (dayAndMonth) {
                if (angular.isUndefined(dayAndMonth)) { dayAndMonth = { day: this.day, month: this.month }; }
                checkHolyday = dayAndMonth;
                return this.matrix.some(dateHolydays);
            };

            this.getToday();
            this.getMatrix();
        }

        return holydaysFn;

        function holydaysFn() {
            return new HolydaysInMexico();
        }
    }

}());
(function(){
    'use strict';

    angular
        .module('app.core')
        .filter('groupsOfUser', groupsOfUser)

    function groupsOfUser(){

        return groupsOfUserFn;

        function groupsOfUserFn(uid, groupsPermissions,allData){
            var groups = [];
            angular.forEach(groupsPermissions, function(group, groupName){
                if(group.users){
                    if(group.users.hasOwnProperty(uid)){
                        if(allData)groups.push(group);
                        else groups.push(groupName);
                    }
                }
            });
            return groups;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('groupFiles', groupFiles);

    function groupFiles(loopEachFilter) {
        function atTimeSort(a, b) {
            return b.created.atTime - a.created.atTime;
        }

        return groupFilesFn;

        function groupFilesFn(files) {
            var thisObject = {};
            files.forEach(function (item) {
                if (!thisObject.hasOwnProperty(item.documentType)) {
                    thisObject[item.documentType] = [];
                }
                thisObject[item.documentType].push(item);
            });
            var thisArray = [];
            loopEachFilter(thisObject, function (data) {
                data.sort(atTimeSort);
                thisArray.push(data.shift());
                if (data.length > 0) {
                    thisArray[thisArray.length - 1].moreFiles = data;
                }
            });
            thisArray.sort(atTimeSort);
            return thisArray;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('groupByField', groupByField)

    function groupByField(orderByFilter) {

        return groupByFieldFn;

        function groupByFieldFn(array, field, includeEmptyFields, sortKey, groupByProperty) {
            var newObject = {};
            includeEmptyFields = includeEmptyFields ? includeEmptyFields : false;
            sortKey = sortKey ? sortKey : false;
            if (angular.isArray(array)) {
                for (var i = 0; i < array.length; i++) {
                    var thisItem = array[i];
                    if (thisItem.hasOwnProperty(field) && thisItem[field] !== '') {
                        if (!newObject.hasOwnProperty(thisItem[field])) {
                            newObject[thisItem[field]] = groupByProperty ? {} : [];
                        }
                        if (groupByProperty) {
                            newObject[thisItem[field]][thisItem[groupByProperty]] = thisItem;
                        } else {
                            newObject[thisItem[field]].push(thisItem);
                        }
                    } else if (includeEmptyFields) {
                        if (!newObject.hasOwnProperty('empty')) {
                            newObject.empty = groupByProperty ? {} : [];
                        }
                        if (groupByProperty) {
                            newObject.empty[thisItem[groupByProperty]] = thisItem;
                        } else {
                            newObject.empty.push(thisItem);
                        }

                    }
                }
            }

            if (sortKey && !groupByProperty) {
                for (var f in newObject) {
                    newObject[f] = orderByFilter(newObject[f], sortKey);
                }
            }
            return newObject;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('getWorkedDays', getWorkedDays)

    function getWorkedDays() {

        return getWorkedDaysFn;

        function getWorkedDaysFn(enroleDate, seniorityDate) {
            var days = 0;
            var thisDate = seniorityDate ? seniorityDate : enroleDate;
            days = moment().diff(moment(thisDate), 'days')
            return days;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('getValueOfRecord', getValueOfRecord)

    function getValueOfRecord($filter, AppF, MongoF) {

        return getValueOfRecordFn;

        function getValueOfRecordFn(record, columnConfig) {
            var value = angular.isDefined(columnConfig.defaultValue) ? columnConfig.defaultValue : 'N/A';
            var data;
            if (angular.isDefined(columnConfig.path)) {
                data = $filter('getFromObject')(record, columnConfig.path);
            } else {
                data = record;
            }
            if (angular.isDefined(data)) {
                switch (columnConfig.type) {
                    case 'boolean':
                        value = data ? 'Sí' : 'No';
                        break;
                    case 'date':
                        value = $filter('date')(data, AppF.dateFormat);
                        break;
                    case 'filter':
                        value = $filter(columnConfig.filter)(data);
                        break;
                    case 'fromMongo':
                        value = $filter('nameOfM')(data, MongoF[columnConfig.from]);
                        break;
                    case 'fromList':
                        value = 'S/V';
                        if (angular.isArray(columnConfig.list)) {
                            var row = columnConfig.list.find(function (item) {
                                return item.id === data;
                            })
                            if (angular.isDefined(row)) {
                                value = row.name;
                            }
                        }
                        break;
                    default:
                        value = data;
                        break;
                }
            }
            return value;
        }
    }
}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('getValueFromYear', getValueFromYear)

    function getValueFromYear() {

        return getValueFromYearFn;

        function getValueFromYearFn(tableOfValues, years, defaultValue) {
            var value;
            var search = true;
            if (angular.isDefined(tableOfValues)) {
                for (var i = 0; i < tableOfValues.length && search; i++) {
                    var thisRow = tableOfValues[i];
                    value = thisRow.value;
                    if (thisRow.limit >= years) {
                        search = false;
                    }
                }
            }
            if (angular.isUndefined(value)) {
                value = defaultValue;
            }
            return value;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.core')
        .filter('getUsersOfThisGroup', getUsersOfThisGroup)

    function getUsersOfThisGroup() {

        return getUsersOfThisGroupFn;

        function getUsersOfThisGroupFn(users, group, groups) {
            var us = [];
            if (angular.isDefined(users)) {
                angular.forEach(users, function(value, key) {
                    if (angular.isDefined(groups[group])) {
                        if (angular.isDefined(groups[group].users) && typeof(groups[group].users) == "object") {
                            if (groups[group].users.hasOwnProperty(value.uid)) {
                                us.push(value.uid);
                            }
                        }
                    }
                })
            }
            return us;
        }
    }

}());
(function(){
    'use strict';

    angular
        .module('app.core')
        .filter('getSomethingOfArrayM', getSomethingOfArrayM)

    function getSomethingOfArrayM(){

        return getSomethingOfArrayMFn;

        function getSomethingOfArrayMFn(id, array, path, defaultV, field){
            var defaultV = (defaultV) ? defaultV : false;
            field = (field) ? field : '_id';
            var paths = path.split('.');
            for(var a in array){
                if(array[a][field] == id){
                    var h = 0;
                    var something = array[a];
                    for(var p in paths){
                        h++;
                        var pp = paths[p];
                        something = (something[pp]) ? something[pp] : defaultV;
                        if(h == paths.length || !something){
                            return something;
                        }
                    }
                    
                }
            }
            return defaultV;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('getSomethingOfArrayFB', getSomethingOfArrayFB);

    function getSomethingOfArrayFB() {

        return getSomethingOfArrayFBFn;

        function getSomethingOfArrayFBFn(id, array, path, defaultV, field) {
            //$log.debug(id,array,path, defaultV, "getting something from FB array");
            defaultV = (defaultV) ? defaultV : false;
            var fieldProperty = (field) ? field : '$id';
            var paths = path.split('.');
            for (var a in array) {
                if (angular.isDefined(array[a]) && array[a]) {
                    if (array[a].hasOwnProperty(fieldProperty)) {
                        if (array[a][fieldProperty] === id) {
                            var h = 0;
                            var something = array[a];
                            for (var p in paths) {
                                if (paths.hasOwnProperty(p)) {
                                    h++;
                                    var pp = paths[p];
                                    something = (angular.isDefined(something[pp])) ? something[pp] : defaultV;
                                    if (h === paths.length || !something) {
                                        // if(path == 'affect') console.log(something, h, paths.length, "DAMN")
                                        return something;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            return defaultV;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.core')
        .filter('getSomethingBetweenDates', getSomethingBetweenDates)

    function getSomethingBetweenDates() {

        return getSomethingBetweenDatesFn;

        function getSomethingBetweenDatesFn(objects, startDate, endDate, datePath, deleteElement) {
            deleteElement = deleteElement ? deleteElement : false;
            var filterObjects = [];
            var startDate = parseInt(startDate);
            var endDate = parseInt(endDate);
            angular.forEach(objects, function(obj, key) {
                if (typeof(obj[datePath]) != "undefined") {
                    obj[datePath] = parseInt(obj[datePath]);
                    if (obj[datePath] >= startDate && obj[datePath] <= endDate) {
                        filterObjects.push(obj);
                        if (deleteElement) {
                            if (angular.isDefined(objects.length)) {
                                objects.splice(key, 1);
                            } else {
                                delete objects[key]
                            }

                        }
                    }
                }

            })
            return filterObjects;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('getRelationsOfCat', getRelationsOfCat);

    function getRelationsOfCat($log, RoutesF, $filter, $q, MongoF, ListsF, AppF) {

        return getRelationsOfCatFn;

        function getRelationsOfCatFn(cat, scopeN, relatedData) {
            return new Promise(function (resolve, reject) {
                try {
                    var allPromises = [];
                    var allPromisesAfter = {};
                    var allPromisesPath = [];
                    // si hay configuracion de sub-relaciones para este catalogo
                    if (RoutesF.relations[scopeN]) {
                        var relations = $filter('objsToArray')(RoutesF.relations[scopeN], 'field');
                        var relationsQuery = relations.filter(function (item) {
                            return !item.justSetField;
                        });
                        var relationsSet = relations.filter(function (item) {
                            return item.justSetField;
                        });
                        var catLength = cat.length;
                        for (var c = 0; c < catLength; c++) { // recorremos el catalogo
                            var row = cat[c];
                            var relLen = relationsQuery.length;
                            for (var r = 0; r < relLen; r++) {
                                var rel = relationsQuery[r];
                                var field = rel.field;
                                var dato = $filter('getFromObject')(row, rel.path ? rel.path : field);
                                // se inicializan los valores en la memoria
                                if (!relatedData.hasOwnProperty(field)) { relatedData[field] = {}; }
                                if (!relatedData[field].hasOwnProperty(dato)) { relatedData[field][dato] = false; }
                                if (typeof (dato) !== 'undefined') {
                                    // si viene de una lista se obtendrá directamente o de la memoria
                                    if (rel.fromListM || rel.fromList) {
                                        var itemId = rel.fromListM ? '_id' : '$id';
                                        var listsObject = rel.fromListM ? MongoF : ListsF;
                                        var listName = rel.fromListM ? rel.fromListM : rel.fromList;
                                        var filterNameOf = rel.fromListM ? 'nameOfM' : 'nameOfL';
                                        if (relatedData[field][dato] === false && rel.key !== 'name') {
                                            relatedData[field][dato] = $filter('getSomethingOfArrayFB')(dato, listsObject[listName], rel.key, 'N/A', itemId);
                                        } else if (relatedData[field][dato] === false && rel.key === 'name') {
                                            relatedData[field][dato] = $filter(filterNameOf)(dato, listsObject[listName], false, 'N/A');
                                        }
                                        row[field + '-' + rel.key] = relatedData[field][dato];
                                    } else if (rel.queryIn || rel.fromFilter) { // si se tiene que obtener de FB
                                        var pathToQuery = dato + '/' + rel.key;
                                        if (rel.child) {
                                            pathToQuery = row[rel.child] + '/' + pathToQuery;
                                        }
                                        if (rel.queryIn) {
                                            pathToQuery = rel.queryIn + '/' + pathToQuery;
                                        }
                                        if (!allPromisesAfter[pathToQuery]) { allPromisesAfter[pathToQuery] = []; }
                                        if (relatedData[field][dato] === false) { // si viene falso de la memoria, se debe obtener
                                            // $log.log('query', field, dato, rel.fromFilter ? rel.fromFilter : pathToQuery);
                                            allPromisesPath.push(pathToQuery);
                                            allPromises.push(rel.fromFilter ? eval(rel.fromFilter) : AppF.root.child(pathToQuery).once('value'));
                                            relatedData[field][dato] = true; // se marca para que no se repita la query
                                        }
                                        if (relatedData[field][dato] === true) { // entonces ya se habia hecho la query, solo se marca la referencia para obtener el valor en el futuro
                                            allPromisesAfter[pathToQuery].push({
                                                index: c,
                                                path: rel.fromFilter ? rel.path : field,
                                                key: rel.key,
                                                field: field,
                                                dato: dato
                                            });
                                        } else { // ya se obtuvo el valor
                                            row[(rel.fromFilter ? rel.path : field) + '-' + rel.key] = relatedData[field][dato];
                                        }
                                    }
                                }
                            }
                        }
                    }
                    Promise.all(allPromises).then(function (all) {
                        for (var q = 0; q < all.length; q++) {
                            var qPath = allPromisesPath[q];
                            var val = (typeof (all[q]) === 'object' && all[q].val) ? all[q].val() : all[q];
                            for (var m = 0; m < allPromisesAfter[qPath].length; m++) {
                                var modification = allPromisesAfter[qPath][m];
                                var ppath = modification.path + '-' + modification.key;
                                if (typeof (cat) !== 'undefined' && typeof (cat[modification.index]) !== 'undefined') {
                                    cat[modification.index][ppath] = val;
                                }
                                if (typeof (relatedData[modification.field]) === 'undefined') { relatedData[modification.field] = {}; }
                                relatedData[modification.field][modification.dato] = val;
                            }
                        }
                        if (angular.isArray(relationsSet)) {
                            var relSetLen = relationsSet.length;
                            for (var s = 0; s < relSetLen; s++) {
                                var thisRel = relationsSet[s];
                                var field = thisRel.field;
                                cat = cat.map(function (item) {
                                    item[field] = thisRel.justSetField(item);
                                    return item;
                                });
                            }
                        }
                        resolve(cat);
                    }).catch(reject);
                } catch (err) {
                    reject(err);
                }
            });
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('getPaidOfApplied', getPaidOfApplied)

    function getPaidOfApplied(roundNumberFilter) {

        return getPaidOfAppliedFn;

        function getPaidOfAppliedFn(incidences, includeForgiven) {
            var total = 0;
            for (var i in incidences) {
                if (angular.isObject(incidences[i]) && incidences[i].period) {
                    if (incidences[i].status >= 3 || (includeForgiven && incidences[i].status == -4)) {
                        total += incidences[i].value;
                    }
                }
            }
            return roundNumberFilter(total);
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.core')
        .filter('getOperationPîeData', getOperationPîeData)

    function getOperationPîeData() {

        return getOperationPîeDataFn;

        function getOperationPîeDataFn(operations, status) {
            var total = 0;
            var completed = 0;
            var incompleted = 0;
            angular.forEach(operations, function(operation) {
                total++;
                if(status>0){
                    if (operation.status >= status) {
                        completed++;
                    } else {
                        incompleted++;
                    }
                }else{
                    if (operation.status == status) {
                        completed++;
                    } else {
                        incompleted++;
                    }
                } 
            });
            var data = [{ label: "Completadas", value: completed }, { label: "Pendientes", value: incompleted }];
            return data;
        }
    }

}());
(function(){
    'use strict';

    angular
        .module('app.core')
        .filter('getObjectsOfIdsFromArrayOfIds', getObjectsOfIdsFromArrayOfIds)

    function getObjectsOfIdsFromArrayOfIds(){

        return getObjectsOfIdsFromArrayOfIdsFn;

        function getObjectsOfIdsFromArrayOfIdsFn(array){
            var object = {};
            for(var a in array){
                var id = array[a];
                object[id] = true;
            }
            return object;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('getActiveObjectsOfAccounts', getActiveObjectsOfAccounts)

    function getActiveObjectsOfAccounts() {

        return getActiveObjectsOfAccountsFn;

        function getActiveObjectsOfAccountsFn(array) {
            var actives = [];
            if (angular.isArray(array)) {
                for (var a = 0; a < array.length; a++) {
                    if (!array[a].invalid && !array[a].executed) {
                        actives.push(array[a]);
                    }
                }
            }
            return actives;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.core')
        .filter('getObjectsLikeTermOfArray', getObjectsLikeTermOfArray)

    function getObjectsLikeTermOfArray() {

        return getObjectsLikeTermOfArrayFn;

        function getObjectsLikeTermOfArrayFn(term, array, path) {
            var objects = [];
            path = path.split(".");
            angular.forEach(array, function(value, index) {
                var addToObjects = false;
                var whatToCompare = value;
                var undefinedValue = false;
                var count = 0;
                while ((count <= path.length) && !undefinedValue) {
                    if (count == path.length) {
                        if (typeof(whatToCompare) == "string") {
                            whatToCompare = whatToCompare.toLowerCase();
                            term = term.toLowerCase();
                            if (whatToCompare.indexOf(term) >= 0) {
                                addToObjects = true;
                            }
                        } else {
                            undefinedValue = true;
                        }
                    } else {
                        whatToCompare = whatToCompare[path[count]];
                        if (whatToCompare == undefined) {
                            undefinedValue = true;
                        }
                    }
                    count++;
                }
                if (addToObjects) {
                    objects.push(value);
                }
            });
            return objects;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.core')
        .filter('getObjectsBetweenDates', getObjectsBetweenDates)

    function getObjectsBetweenDates() {

        return getObjectsBetweenDatesFn;

        function getObjectsBetweenDatesFn(objects, startDate, endDate, fieldObject) {
            var filterObjects = [];
            angular.forEach(objects, function(object) {
                if (object[fieldObject] >= startDate && object[fieldObject] <= endDate) {
                    filterObjects.push(object);
                }
            })
            return filterObjects;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.core')
        .filter('getObjectOfArrayById', getObjectOfArrayById)

    function getObjectOfArrayById() {
        return getObjectOfArrayByIdFn;
        function getObjectOfArrayByIdFn(id, array, idKey) {
            idKey = idKey ? idKey : "$id";
            var ob=null;
            //console.log(id, array, idKey,"filtro para obtejer los datos");
            angular.forEach(array, function(obj, key) {
                if (obj[idKey] == id) {
                    ob=obj;
                    return true;
                }
            })
            return ob;
        }
    }

}());
(function(){
    'use strict';

    angular
        .module('app.core')
        .filter('getMonthsFromRange', getMonthsFromRange)

    function getMonthsFromRange(){

        return getMonthsFromRangeFn;

        function getMonthsFromRangeFn(from, to, format){
            if(!format) format = 'YYYY-MMM';
            var months = [];

            var dateStart = moment(from);
            var dateEnd = moment(to);
            
            while (dateEnd > dateStart) {
               months.push({
                   month: dateStart.format('MM'),
                   year: dateStart.format('YYYY'),
                   label: dateStart.format(format)
               });
               dateStart.add(1,'month');
            }
            
            return months;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('getMenuItemFromState', getMenuItemFromState)

    function getMenuItemFromState() {

        return getMenuItemFromStateFn;

        function getMenuItemFromStateFn(stateName, what, typeOfCatalog, addMode) {
            var value = false,
                menuItem = false;
            var stateNameArray = angular.copy(stateName).split(".");
            var details = ['detail', 'edit', 'especialEdit', 'review', 'credit', 'enrole', 'dismiss', 'mds', 'view', 'read', 'create', 'update', 'reEntry', 'apply', 'confirm', 'createHistoricMovement', 'editSettlement', 'editSpecial'];

            switch (what) {
                case 'name':
                    var action = stateNameArray.pop();
                    if (details.indexOf(action) !== -1) {
                        value = stateNameArray.pop();
                    } else {
                        value = action;
                    }
                    break;
                case 'action':
                    var action = stateNameArray.pop();
                    if (details.indexOf(action) !== -1) {
                        if (typeOfCatalog == 'mongo') {
                            if (action == 'edit') value = (addMode) ? 'create' : 'update';
                            else value = action;
                        } else {
                            value = action;
                        }
                    } else {
                        value = 'list';
                    }
                    break;
                case 'parent':
                    var app = stateNameArray.shift();
                    var parent = (stateNameArray.length > 1) ?
                        stateNameArray.shift() :
                        stateNameArray[0];
                    value = parent;
                    break;
                default:
                    stateNameArray.shift(); // se le quita el primero: app
                    for (var d in details) {
                        var det = details[d];
                        var detail = stateNameArray.indexOf(det);
                        if (detail !== -1) {
                            stateNameArray.splice(detail, 1); // remove detail if it is there
                        }
                    }
                    menuItem = stateNameArray.join(".");
                    value = menuItem;
                    break;
            }
            return value;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.core')
        .filter('getIndicesOfString', getIndicesOfString)

    function getIndicesOfString() {

        return getIndicesOfStringFn;

        function getIndicesOfStringFn(searchStr, str, caseSensitive) {
            var searchStrLen = searchStr.length;
            if (searchStrLen == 0) {
                return [];
            }
            var startIndex = 0,
                index, indices = [];
            if (!caseSensitive) {
                str = str.toLowerCase();
                searchStr = searchStr.toLowerCase();
            }
            while ((index = str.indexOf(searchStr, startIndex)) > -1) {
                indices.push(index);
                startIndex = index + searchStrLen;
            }
            return indices;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.core')
        .filter('getIndexFromArray', getIndexFromArray)

    function getIndexFromArray() {

        return getIndexFromArrayFn;

        function getIndexFromArrayFn(array, field, value) {
            var indexFounded = -1;
            for (var i = 0; i < array.length; i++) {
                var thisItem = array[i];
                if (thisItem[field] == value) {
                    indexFounded = i;
                    i = array.length;
                }
            }
            return indexFounded;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('getFromObject', getFromObject);

    function getFromObject() {

        return getFromObjectFn;

        function getFromObjectFn(obj, path, defaultValue, doNotCopy, defaultSplit) {
            var pathInObj;
            defaultSplit = defaultSplit ? defaultSplit : '.';
            if (angular.isObject(obj) && obj !== null && angular.isString(path)) {
                var paths = path.split(defaultSplit);
                pathInObj = obj;
                for (var a = 0; a < paths.length && angular.isDefined(pathInObj); a++) {
                    var thisPath = paths[a];
                    pathInObj = (pathInObj.hasOwnProperty(thisPath)) ? pathInObj[thisPath] : undefined;
                    if (a + 1 === paths.length) {
                        if (!doNotCopy) {
                            pathInObj = angular.fromJson(angular.toJson(pathInObj));
                        }
                    }
                }
                if (angular.isUndefined(pathInObj) && angular.isDefined(defaultValue)) {
                    pathInObj = defaultValue;
                }
                return pathInObj;
            } else {
                return defaultValue;
            }

        }
    }

}());
/**@type execution
 * @description Check if filter exists
 * @returns boolean or filter
 */
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('getFilterIfExists', getFilterIfExists)

    function getFilterIfExists($filter) {

        return getFilterIfExistsFn;

        function getFilterIfExistsFn(filterName) {
            try {
                return $filter(filterName);
            } catch (e){
                return false;
            }
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('getFactorFromBenefits', getFactorFromBenefits)

    function getFactorFromBenefits(getValueFromYearFilter, AppF) {

        return getFactorFromBenefitsFn;

        function getFactorFromBenefitsFn(benefit, enroleDateMilli, todayMilli, yearsP, getData) {
            // console.log(benefit, enroleDateMilli, todayMilli);
            var daysInYear = 365;
            var years;
            var realYears;
            var today
            if (yearsP) {
                years = yearsP;
            } else {
                var enrole = moment(enroleDateMilli);
                today = moment(todayMilli);
                // if (today.isLeapYear()) {
                //     daysInYear = 366;
                // }
                years = today.diff(enrole, "years");
                realYears = today.diff(enrole, "years", true);
                years++;
            }
            var daysOfVacation = getValueFromYearFilter(angular.isObject(today) && today.year() <= 2022 ? AppF.oldDefaultHolidaysTable : benefit.holidaysTable, years, benefit.holidaysDefault);
            if (angular.isUndefined(daysOfVacation)) { daysOfVacation = 6; }
            var christmasBonus = getValueFromYearFilter(benefit.christmasBonusTable, years > 0 ? years - 1 : years, benefit.christmasBonus);
            if (angular.isUndefined(christmasBonus)) { christmasBonus = 15; }
            var prime = angular.isUndefined(benefit.prime) ? 25 : benefit.prime;
            var primeDays = daysOfVacation * prime / 100;
            var totalDays = daysInYear + christmasBonus + primeDays;
            var factor = totalDays / daysInYear;
            var othersTotal = 0;
            if (angular.isObject(benefit.others)) {
                for (var o in benefit.others) {
                    if (benefit.others.hasOwnProperty(o)) {
                        var thisOther = benefit.others[o];
                        if (angular.isObject(thisOther) && angular.isDefined(thisOther.name) && angular.isDefined(thisOther.factor)) {
                            othersTotal += thisOther.factor * 10000;
                        }
                    }
                }
            }
            factor = Math.round(factor * 10000) / 10000;
            var finalFactor = factor * 10000;
            finalFactor += othersTotal;
            finalFactor = finalFactor / 10000;
            finalFactor = Math.round(finalFactor * 10000) / 10000;
            // console.log("finalFactor:" + finalFactor, "factor:" + factor, "totalDays:" + totalDays, "daysInYear:" + daysInYear, "daysOfVacation:" + daysOfVacation, "christmasBonus:" + christmasBonus, "primeDays:" + primeDays);
            if (getData) {
                var data = {
                    factor: finalFactor,
                    othersTotal: othersTotal / 10000,
                    prime: Math.round(prime * 10000) / 10000,
                    christmasBonus: Math.round(christmasBonus * 10000) / 10000,
                    daysOfVacation: Math.round(daysOfVacation * 10000) / 10000,
                    years: Math.round(years * 10000) / 10000,
                    realYears: Math.round(realYears * 10000) / 10000
                };
                if (!yearsP) {//Este bloque se pondrá por mientras para guardar un log con las datos con los que se estará calculando los factores
                    data.enroleDateMilli = enroleDateMilli;
                    data.todayMilli = enroleDateMilli;
                }
                return data;
            } else {
                return finalFactor;

            }
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.core')
        .filter('getDefaultPermissions', getDefaultPermissions)

    function getDefaultPermissions() {

        return getDefaultPermissionsFn;

        function getDefaultPermissionsFn(permissions) {
            var modules = angular.copy(permissions);
            angular.forEach(modules, function(apps, mkey) {
                angular.forEach(apps, function(app, akey) {
                    angular.forEach(app.permissions, function(permissions, pkey) {
                        modules[mkey][akey]["permissions"][pkey] = false;
                    });
                })
            });
            return modules;
        }
    }
}());
(function(){
    'use strict';

    angular
        .module('app.core')
        .filter('getDefaultMongoRecord', getDefaultMongoRecord)

    function getDefaultMongoRecord(){

        return getDefaultMongoRecordFn;

        function getDefaultMongoRecordFn(catalog, field){
            for(var c in catalog){
                var record = catalog[c];
                if(record.default) return record[field];
            }
            return false;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('getDefaultAvatarEmployee', getDefaultAvatarEmployee)

    function getDefaultAvatarEmployee() {

        function generadorAvatar(initials, size, bgColor, textColor) {
            var canvas = document.createElement("canvas");
            var context = canvas.getContext("2d");
            canvas.width = size;
            canvas.height = size;
            context.fillStyle = bgColor;
            context.fillRect(0, 0, size, size);
            context.fillStyle = textColor;
            context.font = Math.floor(size / 2) + "px Arial";
            context.textAlign = "center";
            context.textBaseline = "middle";
            context.fillText(initials, size / 2, size / 2);
            return canvas.toDataURL();
        }
        function obtenerIniciales(nombres, apellidoPaterno) {
            var nombresArray = nombres.split(" ");
            var primerNombre = nombresArray[0];
            var iniciales = [primerNombre, apellidoPaterno].map(function (nombre) {
                return nombre.charAt(0);
            }).join("");
            return iniciales;
        }
        return getDefaultAvatarEmployeeFn;

        function getDefaultAvatarEmployeeFn(employee) {
            var iniciales = obtenerIniciales(employee.data.info.names, employee.data.info.paternalSurname || employee.data.info.maternalSurname);
            return generadorAvatar(iniciales, 100, "#034683", "#ffffff");
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('getDateOf', getDateOf)

    function getDateOf(dateFilter) {

        return getDateOfFn;

        function getDateOfFn(date) {
            var thisDate = new Date().valueOf();
            if (angular.isNumber(date)) {
                thisDate = date;
            }
            return dateFilter(thisDate, 'medium');
        }
    }

}());
(function(){
    'use strict';

    angular
        .module('app.core')
        .filter('getCreationPropOfCatalog', getCreationPropOfCatalog)

    function getCreationPropOfCatalog(
        AppF
    ){

        function promiseOfCreationProp(uid, catRef, prop){
            return new Promise(function(resolve,reject){
                AppF.root.child(catRef).child(uid).child('created').child(prop).once('value').then(function(snap){
                    var dato = snap.val();
                    if(dato){
                        resolve(dato)
                    } else {
                        resolve('');
                    }
                }).catch(reject);
            });
        }

        return getCreationPropOfCatalogFn;

        function getCreationPropOfCatalogFn(uid, catRef, prop){
            return promiseOfCreationProp(uid, catRef, prop);
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('getConstantFormula', getConstantFormula)

    function getConstantFormula(getSomethingOfArrayFBFilter, getIndicesOfStringFilter) {


        return getConstantFormulaFn;

        function getConstantFormulaFn(formula, calcFields, type) {
            //typeOfReplace
            //1-Variables con las que se van a trabajar
            //2-Valores por default establecidos
            var typeOfReplace = type ? type : 1;
            var valid = true;
            var firstIndexs = getIndicesOfStringFilter("[", formula);
            var lastIndexs = getIndicesOfStringFilter("]", formula);
            if (firstIndexs.length != lastIndexs.length) {
                valid = false;
            }
            if (valid) {
                var fieldsToReplace = [];
                angular.forEach(firstIndexs, function (firstIndex, index) {
                    fieldsToReplace.push(formula.substring(firstIndexs[index] + 1, lastIndexs[index]));
                });
                angular.forEach(fieldsToReplace, function (fieldToReplace) {
                    var valueToReplace = "";
                    if (typeOfReplace == 1) {
                        var obj = getSomethingOfArrayFBFilter(fieldToReplace, calcFields, "object", false, "name");
                        var field = getSomethingOfArrayFBFilter(fieldToReplace, calcFields, "field", false, "name");
                        if (obj) {
                            valueToReplace = obj;
                            if (field) {
                                valueToReplace = valueToReplace + "." + field;
                            }
                        }
                    } else {
                        console.log(fieldToReplace, calcFields);
                        valueToReplace = getSomethingOfArrayFBFilter(fieldToReplace, calcFields, "defaultValue", "#NotFounded", "name");
                    }
                    formula = formula.replace("[" + fieldToReplace + "]", valueToReplace);
                });
            }
            return {
                valid: valid,
                formula: formula
            };
        }

    }

}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('getConfigurationColumns', getConfigurationColumns);

    function getConfigurationColumns($log) {

        return getConfigurationColumnsFn;

        function getConfigurationColumnsFn(data, localStorage, menu) {
            for (var i = 0; i < data.length; i++) {
                if (angular.isUndefined(localStorage)) {
                    data[i].catalogs = menu;
                    data[i].show = false;
                } else {
                    if (angular.isDefined(localStorage[data[i].name])) {
                        data[i].catalogs = menu;
                        data[i].name = localStorage[data[i].name].name;
                        data[i].show = localStorage[data[i].name].show;
                    } else {
                        data[i].catalogs = menu;
                        data[i].show = false;
                    }
                }
            }
            return data;
        }
    }

}());
(function(){
    'use strict';

    angular
        .module('app.core')
        .filter('getChangesIdsFromArray', getChangesIdsFromArray)

    function getChangesIdsFromArray(
        $log
    ){

        return getChangesIdsFromArray;

        function getChangesIdsFromArray(ids, array, idField){
            if(!idField) idField = '$id';
            var changes = {
                add: [],
                remove: []
            };

            // sobran
            for(var e in ids){
                var eId = ids[e];
                var exists = false;
                for(var i in array){
                    var row = array[i];
                    if(eId == row[idField]){
                        exists = true;
                    }
                }
                if(!exists){
                    changes.add.push(eId);
                    $log.debug('not exists must be added', eId);
                }
            }

            // sobran
            for(var i in array){
                var row = array[i];
                if(ids.indexOf(row[idField]) == -1) {
                    changes.remove.push(row[idField]);
                    $log.debug('must be removed', row[idField]);
                }
            }
            
            return changes;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('getBenefitsOfItem', getBenefitsOfItem)

    function getBenefitsOfItem($rootScope, orderByFilter, $log) {

        return getBenefitsOfItemFn;

        function getBenefitsOfItemFn(element, notEmployee) {
            // console.log(JSON.stringify(element));
            return new Promise(function (resolve, reject) {
                try {
                    var queries = [{ value: "default", level: 1, type: "default" }];
                    if (typeof (element) == "object") {
                        if (typeof (element.payroll) == "string") {
                            queries.push({ value: element.payroll, level: 2, type: "payroll" })
                        }
                        if (typeof (element.cc) == "string") {
                            queries.push({ value: element.cc, level: 3, type: "cc" })
                        }
                        if (!notEmployee && typeof (element.$id) == "string") {
                            queries.push({ value: element.$id, level: 4, type: "employee" })
                        } else if (typeof (element.employee) == "string") {
                            queries.push({ value: element.employee, level: 4, type: "employee" })
                        }
                    }
                    queries = orderByFilter(queries, "-level");
                    var promises = [];
                    for (var i = 0; i < queries.length; i++) {
                        var thisQuery = queries[i];
                        var query = [{
                            q: "orderByChild",
                            v: "itemId"
                        }, {
                            q: "equalTo",
                            v: thisQuery.value
                        }];
                        promises.push($rootScope.L.loadList("benefits", "catalogs/benefits/collection", false, "array", "benefits" + thisQuery.value, query));
                    }
                    Promise.all(promises).then(function (resps) {
                        var searching = true;
                        var benefit;
                        for (var a = 0; a < resps.length && searching; a++) {
                            var thisResp = [].concat(resps[a]);
                            if (thisResp.length > 0) {
                                var searchType = true;
                                for (var t = 0; t < thisResp.length && searchType; t++) {
                                    var thisBenefit = thisResp[t];
                                    if (thisBenefit.type == queries[a].type) {
                                        searchType = false;
                                        searching = false;
                                        benefit = angular.fromJson(angular.toJson(thisBenefit));
                                    }
                                }
                            }
                        }
                        if (typeof (benefit) == "undefined") {
                            $log.error(resps, "No se encontro configuracion de prestaciones");
                            reject("No se encontro configuracion de prestaciones")
                        } else {
                            resolve(benefit);
                        }
                    }).catch(function (error) {
                        $log.error(error, "Error consultado los beneficios, intente nuevamente");
                        reject("Error consultado los beneficios, intente nuevamente");
                    })
                } catch (error) {
                    $log.error(error, "Error al establecer los parametros de busqueda de los beneficios")
                    reject("Error al establecer los parametros de busqueda de los beneficios");
                }
            })
        }
    }

}());
(function(){
    'use strict';

    angular
        .module('app.core')
        .filter('getArrayOfKeys', getArrayOfKeys)

    function getArrayOfKeys(){

        return getArrayOfKeysFn;

        function getArrayOfKeysFn(object, idP){
            var arrayOfKeys = [];
            for(var a in object){
                if(!idP) {
                    arrayOfKeys.push(a);
                } else {
                    arrayOfKeys.push(object[a][idP]);
                }
            }
            return arrayOfKeys;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.core')
        .filter('getArrayOfIds', getArrayOfIds)

    function getArrayOfIds(
        pathInObjFilter
    ) {
        return getArrayOfIdsFn;

        function getArrayOfIdsFn(array, idField) {
            if (!idField) idField = "$id";
            var arrayOfIds = [];
            for (var a in array) {
                var value = pathInObjFilter(array[a], idField);
                if (value !== false) {
                    arrayOfIds.push(value);
                }

            }
            return arrayOfIds;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.core')
        .filter('getArrayFromObject', getArrayFromObject)

    function getArrayFromObject(
        clearObjectFilter
    ) {

        return getArrayFromObjectFn;

        function getArrayFromObjectFn(object, keyInsteadOfValue, withId, convertToObject) {
            if (!object) {
                return [];
            }
            var clearObject = clearObjectFilter(object);
            var array = [];
            for (var key in clearObject) {
                var valueToPush = (keyInsteadOfValue) ? key : clearObject[key];
                if (typeof(valueToPush) !== "object" && typeof(convertToObject) !== "undefined") {
                    valueToPush = {
                        value: valueToPush
                    };
                }
                if (withId) valueToPush.$id = key;
                array.push(valueToPush);
            }
            return array;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.core')
        .filter('getApplyToEmployeeCalculations', getApplyToEmployeeCalculations)

    function getApplyToEmployeeCalculations(filterObjFilter) {

        return getApplyToEmployeeCalculationsFn;

        function getApplyToEmployeeCalculationsFn(objs) {
            return filterObjFilter(objs, 'value.applyToEmployee', true);
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.core')
        .filter('filterQueryFB', filterQueryFB);

    function filterQueryFB() {

        return filterQueryFBFn;

        function filterQueryFBFn(array, orderBy, value, a) {
            var filtered = [];
            for (var a in array) {
                var row = array[a];
                if(orderBy == "data/type"){
                    if (typeof value == 'object' || typeof value == 'array') {
                        for (var v in value) {
                            var val = value[v];
                            var pass = false;
                            if(row.data){
                                if (row.data.type == val && !pass) {
                                    filtered.push(row);
                                    pass = true;
                                }
                            } else if(row.movement) {
                                if (row.movement.type == val && !pass) {
                                    filtered.push(row);
                                    pass = true;
                                }
                            }
                        }
                    } else {
                        if(row.data){
                            if (row.data.type == value) {
                                filtered.push(row);
                            }
                        } else if(row.movement){
                            if (row.movement.type == value) {
                                filtered.push(row);
                            }
                        }   
                    }
                } else if (orderBy == "movement/type") {
                    if (typeof value == 'object') {
                        for (var v in value) {
                            var val = value[v];
                            var pass = false;
                            if (row.movement.type == val && !pass) {
                                filtered.push(row);
                                pass = true;
                            }
                        }
                    } else {
                        if(row.movement){
                            if (row.movement.type == value) {
                                filtered.push(row);
                            }
                        } else if(row.data){
                            if(row.data.type == value){
                                filtered.push(row);
                            }
                        }   
                    }
                } else if (orderBy == "movements/type") {
                    //console.log(array, orderBy, value,a);
                    if (typeof value == 'object' || typeof value == 'array') {
                        var addTo = false;
                        //console.log(val, row.movements);
                        for (var v in value) {
                            var val = value[v];
                            if (!addTo) {
                                for (var m in row.movements) {
                                    if (row.movements[m].t == val && !addTo) {
                                        addTo = true;
                                    }
                                }
                            }
                        }
                        if (addTo) {
                            filtered.push(row);
                        }
                    } else {
                        var addTo = false;
                        var movements = {};
                        for (var m in row.movements) {
                            if (row.movements[m].t == value) {
                                movements[m] = row.movements[m];
                                addTo = true;
                            }
                        }
                        if (addTo) {
                            filtered.push(row);
                            var index = filtered.length - 1;
                            //filtered[index].movements = movements;
                        }
                    }
                } else if (orderBy == "movements/from") {
                    var addTo = false;
                    //console.log("filtring another");
                    for (var m in row.movements) {
                        //console.log(row.$id,row.movements[m].d ,value,(row.movements[m].d > value),"evaluacion",((row.movements[m].d > value) && !addTo));
                        if ((row.movements[m].d > value) && (!addTo)) {
                            addTo = true;
                        }
                    }
                    if (addTo) {
                        filtered.push(row);
                    }
                } else if (orderBy == "movements/to") {
                    var addTo = false;
                    for (var m in row.movements) {
                        if ((row.movements[m].t < value) && !addTo) {
                            addTo = true;
                        }
                    }
                    if (addTo) {
                        filtered.push(row);
                    }
                } else if (orderBy == "enroleDate/from") {
                    //console.log(value,row.data.enroleDate);
                    var addTo = false;
                    if (row.data.enroleDate <= value) {
                        addTo = true;
                    }
                    if (addTo) {
                        filtered.push(row);
                    }

                } else {
                    if (typeof value == 'object') {
                        for (var v in value) {
                            var val = value[v];
                            var pass = false;
                            if (row[orderBy] == val && !pass) {
                                filtered.push(row);
                                pass = true;
                            }
                        }
                    } else {
                        if (row[orderBy] == value) {
                            filtered.push(row);
                        }
                    }
                }

            }
            // console.log(array, filtered, orderBy, "AAAAAAA")

            return filtered;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('filterQueriesFB', filterQueriesFB)

    function filterQueriesFB(filterQueryFBFilter) {

        return filterQueriesFBFn;

        function filterQueriesFBFn(array, queryArray) {
            var filtered = array;
            angular.forEach(queryArray, function (value, order) {
                if (value && order != 'by') {
                    var orderBy
                    switch (order) {
                        case 'payroll': orderBy = 'payroll'; break;
                        case 'cc': orderBy = 'cc'; break;
                        case 'rp': orderBy = 'rp'; break;
                        case 'employee': orderBy = '$id'; break;
                        case 'status': orderBy = 'status'; break;
                        case 'movementType': orderBy = 'movement/type'; break;
                        case 'movementsType': orderBy = "movements/type"; break;
                        case 'movement': orderBy = "data/type"; break;
                        case 'from': orderBy = "movements/from"; break;
                        case 'to': orderBy = "movements/to";break;
                        case 'enroleFrom': orderBy="enroleDate/from";break;
                        default: orderBy = order;break;
                    }
                    filtered = filterQueryFBFilter(filtered, orderBy, value);
                    console.log(filtered, orderBy, value, "EEEEE")
                }
            });

            return filtered;
        }
    }

} ());
(function() {
    'use strict';

    angular
        .module('app.core')
        .filter('filterObj', filterObj)

    function filterObj(pathInObjFilter) {

        return filterObjFn;

        function filterObjFn(obj, path, value) {
            var newObj = {};
            if (typeof(obj) == "object") {
                for (var o in obj) {
                    var thisObj = obj[o];
                    var objValue = pathInObjFilter(thisObj, path);
                    if (typeof(objValue) !== "undefined" && objValue !== false && objValue == value) {
                        newObj[o] = thisObj;
                    }
                }
            }
            return newObj;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.core')
        .filter('filterMovements', filterMovements)

    function filterMovements() {

        return filterMovementsFn;

        function filterMovementsFn(movements, queryArray) {
            var filteredMovements = {};
            //console.log(queryArray);
            if (angular.isDefined(queryArray)) {
                if (queryArray["movementsType"] || queryArray["from"] || queryArray["to"]) {
                    angular.forEach(movements, function(movement, index) {
                        var addTo = true;
                        angular.forEach(queryArray, function(value, query) {
                            //console.log(movement, query, value);
                            if (value) {
                                switch (query) {
                                    case "movementsType":
                                        if (typeof(value) == "object") {

                                        } else {
                                            if (movement.t != value) addTo = false;
                                        }
                                        break;
                                    case "from":
                                        if (movement.d < value) addTo = false;
                                        break;
                                    case "to":
                                        if (movement.d > value) addTo = false;
                                        break;
                                }
                            }
                        });
                        if (addTo) {
                            filteredMovements[index] = movement;
                        }
                    });
                } else {
                    filteredMovements = movements;
                }
            }
            //console.log(queryArray);
            return filteredMovements;
        }
    }

}());
(function(){
    'use strict';

    angular
        .module('app.core')
        .filter('filterMArray', filterMArray)

    function filterMArray(){

        return filterMArrayFn;

        function filterMArrayFn(array, queryParams){
            var filteredArray = angular.copy(array);
            
            for(var property in queryParams){
                var value = queryParams[property];
                for(var a in filteredArray){
                    var record = filteredArray[a];
                    if(record[property] !== value){
                        filteredArray.splice(a, 1);
                    }
                }
            }

            return filteredArray;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('filterHide', filterHide)

    function filterHide() {

        return filterHideFn;

        function filterHideFn(objs, employeeNamePart, cc) {
            // console.log(employeeNamePart, cc)
            var hasFilter = false;
            if (typeof (employeeNamePart) !== "undefined" || typeof (cc) !== "undefined") {
                hasFilter = true;
            }
            // console.log(employeeNamePart, cc);
            if (typeof (objs) == "object" && hasFilter) {
                for (var i = 0; i < objs.length; i++) {
                    // var founded = filterFilter([objs[i]], search);
                    var showEmployee = true;
                    if (typeof (employeeNamePart) !== "undefined" && employeeNamePart !== "") {
                        var employeeName = objs[i].data.name;
                        if (typeof (employeeName) == "string") {
                            var employeeHasFilter = employeeName.search(new RegExp(employeeNamePart, "i"));
                            if (employeeHasFilter == -1) {
                                showEmployee = false;
                            }
                        } else {
                            showEmployee = false;
                        }
                    }
                    if (showEmployee && typeof (cc) !== "undefined" && cc !== "") {
                        var employeeCC = objs[i].cc;
                        if (employeeCC != cc) {
                            showEmployee = false;
                        }
                    }
                    objs[i].hide = !showEmployee;
                }
            }
            return objs;
        }
    }

}());
(function(){
    'use strict';

    angular
        .module('app.core')
        .filter('filterFData', filterFData)

    function filterFData(
        AppF,
        RoutesF,
        pathInObjFilter
    ){

        return filterFDataFn;

        function filterFDataFn(items, filter, scope){
            var filtered = angular.copy(items);
            var filterArray = function(array, filterBy, val){
                console.log(val, filterBy, 56757657675765757)
                for(var a in array){
                    if(val){
                        var itemPropValue = pathInObjFilter(array[a], filterBy);
                        if(itemPropValue !== val){
                            console.log('removing item from filter', {
                                itemVal: itemPropValue, 
                                item: array[a], 
                                by: filterBy, 
                                val: val, 
                                items: array
                            });
                            array[a].hidden = true;
                        } else {
                            array[a].hidden = false;
                        }
                    } else {
                        array[a].hidden = false;
                    }
                }
                return array;
            }

            if(typeof filter == 'string'){
                var val = RoutesF.searchValueInMemory(':' + filter, scope);
                filtered = filterArray(filtered, filter, val);
            }
            else
            if(typeof filter == 'function'){
                var ffilter = filter();
                var val = RoutesF.searchValueInMemory(ffilter, scope); // function
                filtered = filterArray(filtered, ffilter.by, val);
            }
            else
            if(typeof filter == 'object'){
                var val = RoutesF.searchValueInMemory(filter, scope);
                filtered = filterArray(filtered, filter.by, val);
            } 
            console.log(filtered, items, val, "YES");
            return filtered; 
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('filterCcs', filterCcs);

    function filterCcs() {
        return function (items, selectedCcs) {
            var thisItems = [];
            var selectedIds = [];
            if (angular.isArray(selectedCcs) && selectedCcs.length > 0) {
                selectedIds = selectedCcs.map(function (cc) {
                    return cc.ccId;
                });
            }
            if (angular.isArray(items)) {
                for (var i = 0; i < items.length; i++) {
                    var thisItem = items[i];
                    var thisCcs = thisItem.ccs.filter(function (cc) {
                        return selectedIds.indexOf(cc.$id) === -1;
                    })
                    if (thisCcs.length > 0) {
                        thisItem.availableCcs = thisCcs;
                        thisItems.push(thisItem);
                    }
                }
            }
            return thisItems;
        };
    }

})();

(function(){
    'use strict';

    angular
        .module('app.core')
        .filter('filterByPropName', filterByPropName)

    function filterByPropName(){

        return filterByPropNameFn;

        /** filtra un arreglo por propiedad, buscando el nombre en otro arreglo */
        function filterByPropNameFn(arrayOfObjects, searchValue, propPath, arrayOfNames, namePath, idPath){
            if(angular.isDefined(searchValue) && searchValue !== ''){
                if(!namePath) namePath = 'name';
                if(!idPath) idPath = '$id';
                var newArrayOfObjects = [];
                var arrayOfAllowedIds = [];
                for(var idN in arrayOfNames){
                    var row = arrayOfNames[idN];
                    if(row.hasOwnProperty(namePath) && row.hasOwnProperty(idPath)){
                        if(row[namePath].search(searchValue.toUpperCase()) !== -1){
                            arrayOfAllowedIds.push(row[idPath]);
                        }
                    }
                }
                if(arrayOfAllowedIds.length){
                    for(var a in arrayOfObjects){
                        var rrow = arrayOfObjects[a];
                        if(rrow.hasOwnProperty(propPath)){
                            if(arrayOfAllowedIds.indexOf(rrow[propPath]) !== -1){
                                newArrayOfObjects.push(rrow);
                            }
                        }
                    }
                }
                
                return newArrayOfObjects;
            }
            return arrayOfObjects;
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.core')
        .filter('filterByPropIds', filterByPropIds);

    /** @ngInject */
    function filterByPropIds() {
        return function(items, parameter, ids) {
            if (items.length === 0 || !ids || ids.length === 0) {
                return items;
            }

            var filtered = [];

            for (var i = 0; i < items.length; i++) {
                var item = items[i];
                var match = false;

                for (var j = 0; j < ids.length; j++) {
                    var id = ids[j];
                    if (item[parameter].indexOf(id) > -1) {
                        match = true;
                        break;
                    }
                }

                if (match) {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function(){
    'use strict';

    angular
        .module('app.core')
        .filter('filterByProp', filterByProp)

    function filterByProp(
        pathInObjFilter
    ){
        return filterByPropFn;

        /**@type DOM, filter
         * @description Busca en un arreglo de datos por 1 solo campo
         * @param {[{*}]} data array de datos a filtrar
         * @param {string} dato dato que se buscará
         * @param {string} field campo en que se buscara. ej: data.name
         * @returns [{*}]
         */
        function filterByPropFn(data, dato, field){
            if(dato && dato !== ''){
                return data.filter(function(obj){
                    var value = pathInObjFilter(obj, field),
                        datoCapitalized = dato.toUpperCase();
                    return (
                        (value.indexOf(dato) !== -1) ||
                        (value.indexOf(datoCapitalized) !== -1)
                    );
                });
            } else {
                return data;
            }
        }
    }

}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByIds', filterByIds);

    /** @ngInject */
    function filterByIds()
    {
        return function (items, ids)
        {

            if ( items.length === 0 || !ids )
            {
                return items;
            }

            if ( ids.length === 0 )
            {
                return [];
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item.id === id )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('filterAvailable', filterAvailable)

    function filterAvailable() {

        return filterAvailableFn;

        function filterAvailableFn(arr, keys) {
            return arr.filter(function (item) {
                if (keys && keys[item.$id]) {
                    return false; // Exclude items that are already in keys
                }
                return true; // Include items not in keys
            });
        }
    }

}());
(function(){
    'use strict';

    angular
        .module('app.core')
        .filter('filterArrayForAutocompleteChips', filterArrayForAutocompleteChips)

    function filterArrayForAutocompleteChips(){

        return filterArrayForAutocompleteChipsFn;

        function filterArrayForAutocompleteChipsFn(array, path, key){
            var newArray = [];
            if(key){
                for(var k in array){
                    newArray.push(k);
                }
            } else {
                if(!path) {
                    path = '$id'
                }
                for(var a in array){
                    if(array[a]){
                        if(array[a].hasOwnProperty(path)) newArray.push(array[a][path]);
                    }
                }
            }
            
            return newArray; 
        }
    }

}());
(function(){
    'use strict';

    angular
        .module('app.core')
        .filter('fileType', fileType)

    function fileType(){
        return function (mime, url){
            if(url){ // if is a FB url
                var mimes = ["jpg", "jpeg", "gif", "png", "pdf"];
                var extP = mime.split(".").pop();
                var ext = extP.split("?").shift();
                return "." + ext;
            } else {
                var type = "";
                switch(mime){
                    case "image/jpeg": type = ".jpg"; break;
                    case "image/jpg": type = ".jpg"; break;
                    case "image/gif": type = ".gif"; break;
                    case "image/png": type = ".png"; break;
                    case "application/pdf": type = ".pdf"; break;
                    case "application/x-pdf": type = ".pdf"; break;
                }
                return type;
            }
        }
    }

}());
(function(){
    'use strict';

    angular
        .module('app.core')
        .filter('dynamicSort', dynamicSort)

    function dynamicSort(){

        return dynamicSortFn;

        function dynamicSortFn(property){
            var sortOrder = 1;
            if(property[0] === "-") {
                sortOrder = -1;
                property = property.substr(1);
            }
            return function (a,b) {
                var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
                return result * sortOrder;
            }
        }
    }

}());
(function(){
    'use strict';

    angular
        .module('app.core')
        .filter('decodeArrayBufferObject', decodeArrayBufferObject)

    function decodeArrayBufferObject(){

        return decodeArrayBufferObjectFn;

        function decodeArrayBufferObjectFn(objBufferized){
            var decodedString = String.fromCharCode.apply(null, new Uint8Array(objBufferized));
            var obj = JSON.parse(decodedString);
            for(var o in obj){
                obj[o] = decodeURIComponent(escape(obj[o]));
            }
            return obj;
        }
    }

}());
(function(){
    'use strict';

    angular
        .module('app.core')
        .filter('createLinkWithResponse', createLinkWithResponse)

    function createLinkWithResponse(){

        return createLinkWithResponseFn;

        /**
         * @description Genera un link de un archivo y le da click
         * @param {Response} response respuesta de un servidor con un archivo
         * @param {Boolean} dontClickIt (opcional)
         * @returns {null | linkElement} si no viene la opción dontClickIt se crea el link y se le da click, si viene se regresa el elemento clickeable 
         */
        function createLinkWithResponseFn(response, dontClickIt){
            var headers = response.headers();
            var filename = headers['x-filename'];
            var contentType = headers['content-type'];
            var linkElement = document.createElement('a');
            var blob = new Blob([response.data], {
                type: contentType
            });
            var url = window.URL.createObjectURL(blob);
            linkElement.setAttribute('href', url);
            linkElement.setAttribute('download', filename);
            var clickEvent = new MouseEvent('click', {
                view: window,
                bubbles: true,
                cancelable: false
            });
            if(dontClickIt) return linkElement;
            else linkElement.dispatchEvent(clickEvent);
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('createCcsByPayrollsOfUser', createCcsByPayrollsOfUser);

    /** @ngInject */
    function createCcsByPayrollsOfUser(getArrayOfIdsFilter) {
        return function (payrollsOfUser, ccsOfUser, ccsByPayroll) {
            var ccsByPayrollsOfUser = [];
            if (angular.isArray(payrollsOfUser)) {
                for (var p = 0; p < payrollsOfUser.length; p++) {
                    var thisPayroll = angular.fromJson(angular.toJson(payrollsOfUser[p]));
                    thisPayroll.ccs = getArrayOfIdsFilter(ccsOfUser[thisPayroll.$id]);
                    var allCcs = getArrayOfIdsFilter(ccsByPayroll[thisPayroll.$id]);
                    if (angular.isArray(allCcs)) {
                        var all = true;
                        for (var c = 0; c < allCcs.length && all; c++) {
                            var thisCC = allCcs[c];
                            if (thisPayroll.ccs.indexOf(thisCC) === -1) {
                                all = false;
                            }
                        }
                        if (all) {
                            thisPayroll.ccs = ['all'];
                        }
                    }
                    ccsByPayrollsOfUser.push(thisPayroll);
                }
            }
            return ccsByPayrollsOfUser;
        };
    }

})();
(function() {
    'use strict';

    angular
        .module('app.core')
        .filter('countObject', countObject)

    function countObject() {

        return countObjectFn;

        function countObjectFn(obj) {
            var count = 0;
            if (angular.isDefined(obj)) {
                if (typeof(obj) == "object") {
                    count = Object.keys(obj).length;
                }
            }
            return count;
        }
    }

}());
/**@type execution
 * @description convert camel case of names
 * @example new_filters_for_calculate or new filters for calculate
 * @returns string
 */
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('convertToCamelCase', convertToCamelCase)

    function convertToCamelCase() {

        return convertToCamelCaseFn;

        function convertToCamelCaseFn(str) {
            var clear = str.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, ' ');
            var word = clear.toLowerCase();
            console.log(word);
            return word.replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
                return index === 0 ? word.toLowerCase() : word.toUpperCase();
            }).replace(/\s+/g, '');
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.core')
        .filter('constructMsg', constructMsg)

    function constructMsg($filter) {

        return constructMsgFn;

        function constructMsgFn(prefix, array, suffix, filterArray, isObject) {
            var msg = '';
            msg += (prefix) ? prefix : '';
            msg += '<ul>'; // Enter para describir el arreglo
            if (filterArray) {
                var aaray = [];
                for (var a in array) {
                    var name = (isObject) ? a : array[a];
                    var filtered = $filter(filterArray)(name);
                    if(filtered.length>1) msg += '<li>' + filtered + '</li>';
                }
                // for (var a in array) {
                //     var filtered = $filter(filterArray)(array[a]);
                //     if(filtered.length>1) aaray.push(filtered);
                // }
                //msg += '<li>' + aaray.join(", ") + '</li>';
            } else {
                for(var a in array){
                    var name = (isObject) ? a : array[a];
                    msg += '<li>' + name + '</li>';
                }
                //msg += '<li>' + array.join(", ") + '</li>';
            }
            msg += '</ul>';
            msg += (suffix) ? suffix + '<br />' : '';
            return msg;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('clearObject', clearObject)

    function clearObject() {

        return clearObjectFn;

        function clearObjectFn(object) {
            var newObject = {};
            var trash = ['$$hashKey', '$priority', '$id', '$$conf', '$$error', '$$notify'];
            angular.forEach(object, function (value, prop) {
                if (trash.indexOf(prop) === -1 && !angular.isFunction(value) && angular.isDefined(value)) {
                    if (angular.isObject(value) && value !== null) {
                        if (angular.isArray(value)) {
                            newObject[prop] = [];
                            for (var i = 0; i < value.length; i++) {
                                if (angular.isDefined(value[i])) {
                                    if (angular.isObject(value[i])) {
                                        newObject[prop].push(clearObjectFn(value[i]));
                                    } else {
                                        newObject[prop].push(angular.fromJson(angular.toJson(value[i])));
                                    }
                                }
                            }
                        } else {
                            newObject[prop] = clearObjectFn(value);
                        }
                    } else {
                        newObject[prop] = angular.fromJson(angular.toJson(value));
                    }
                }
            });
            return newObject;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('cleanString', cleanString)

    function cleanString() {

        return cleanStringFn;

        function cleanStringFn(string, replaceInvalids, deleteProhibited, justCapitals, notdeletespecialcharts, notdeletethese) {
            var cleaned = JSON.parse(JSON.stringify(string));
            var alwaysReplace = {
                capitals: {
                    A: ['Á', 'À', 'Â', 'Ã', 'Ä'],
                    E: ['É', 'È', 'Ê', 'Ë'],
                    I: ['Í', 'Ì', 'Î', 'Ï'],
                    O: ['Ó', 'Ò', 'Ô', 'Õ', 'Ö'],
                    U: ['Ú', 'Ù', 'Û', 'Ü']
                },
                notCapitals: {
                    a: ['á', 'à', 'â', 'ã', 'ª', 'ä'],
                    e: ['é', 'è', 'ê', 'ë'],
                    i: ['í', 'ì', 'î', 'ï'],
                    o: ['ó', 'ò', 'ô', 'õ', 'ö', 'º', '°'],
                    u: ['ú', 'ù', 'û', 'ü']
                }
            };
            var mapCapitals = {
                a: 'A',
                e: 'E',
                i: 'I',
                o: 'O',
                u: 'U'
            };
            var alwaysDelete = ['\\', '¨', 'º', '-', '~', '#', '@', '|', '!', '\"', '·', '$', '%', '&', '/', '(", ")', '?', "'", '¡', '¿', '[', '^', '`', ']', '+', '}', '{', '¨', '´', '>', '<', ';', ',', ':', '.', '´'];
            if (notdeletespecialcharts) {
                alwaysDelete = [];
            }
            if (angular.isArray(notdeletethese)) {
                for (var i = 0; i < notdeletethese.length; i++) {
                    var index = alwaysDelete.indexOf(notdeletethese[i]);
                    if (index > -1) {
                        alwaysDelete.splice(index, 1);
                    }
                }
            }
            if (replaceInvalids) {
                if (justCapitals) {
                    for (var capitalType in alwaysReplace) {
                        for (var replaceChar in alwaysReplace[capitalType]) {
                            for (var i in alwaysReplace[capitalType][replaceChar]) {
                                if (cleaned.indexOf(alwaysReplace[capitalType][replaceChar][i]) !== -1) {
                                    if (capitalType == 'notCapitals') {
                                        cleaned = cleaned.replace(alwaysReplace[capitalType][replaceChar][i], mapCapitals[replaceChar]);
                                        // console.log(cleaned, alwaysReplace[capitalType][replaceChar][i], mapCapitals[replaceChar], 'cool');
                                    } else {
                                        cleaned = cleaned.replace(alwaysReplace[capitalType][replaceChar][i], replaceChar);
                                        // console.log(cleaned, alwaysReplace[capitalType][replaceChar][i], replaceChar, 'cool 2');
                                    }
                                }
                            }
                        }
                    }
                } else {
                    for (var capitalType2 in alwaysReplace) {
                        for (var replaceChar2 in alwaysReplace[capitalType2]) {
                            for (var i2 in alwaysReplace[capitalType2][replaceChar2]) {
                                if (cleaned.indexOf(alwaysReplace[capitalType2][replaceChar2][i2]) !== -1) {
                                    cleaned = cleaned.replace(alwaysReplace[capitalType2][replaceChar2][i2], replaceChar2);
                                    // console.log(cleaned, alwaysReplace[capitalType2][replaceChar2][i2], replaceChar2, 'cool 3');
                                }
                            }
                        }
                    }
                }
            }

            if (deleteProhibited) {
                for (var ii in alwaysDelete) {
                    if (cleaned.indexOf(alwaysDelete[ii]) !== -1) {
                        cleaned = cleaned.replace(alwaysDelete[ii], '');
                        // console.log(cleaned, alwaysDelete[ii], 'cool 4');
                    }
                }
            }
            return cleaned;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('cleanArrayOfData', cleanArrayOfData)

    function cleanArrayOfData() {

        return cleanArrayOfDataFn;

        function cleanArrayOfDataFn(array) {
            var newArray = [];
            for (var a in array) {
                var obj = {};
                var addToArray = 0;
                for (var e in array[a]) {
                    var addToObject = true;
                    if (e == "$$hashKey") {
                        addToObject = false;
                    } else if (array[a][e] == "" || array[a][e] == null || array[a][e] == undefined) {
                        addToObject = false;
                    }
                    if (addToObject) {
                        addToArray++;
                        obj[e] = array[a][e];
                    }
                }
                if (addToArray) {
                    newArray.push(obj);
                }
            }
            return newArray;
        }
    }

}());
(function(){
    'use strict';

    angular
        .module('app.core')
        .filter('checkValueObjectsOfArray', checkValueObjectsOfArray)

    function checkValueObjectsOfArray(){

        return checkValueObjectsOfArrayFn;

        function checkValueObjectsOfArrayFn(array){
            var activeArray = [];
            for(var a in array){
                if(array[a].valid && !array[a].execute) activeArray.push(array[a]);
            }
            return activeArray;
        }
    }
}());
(function () {
  'use strict';

  angular
    .module('app.core')
    .filter('checkDisabilitiesEmployee', checkDisabilitiesEmployee)

  function checkDisabilitiesEmployee(AppF, DataF) {

    return checkDisabilitiesEmployee;

    function checkDisabilitiesEmployee(idEmpleado, fecha, tiposincidencias) {
      return new Promise(function (resolve, reject) {
        var promises = [];
        if (!angular.isArray(tiposincidencias)) {//En caso de pasar el arreglo de tipos de incidencia de incapacidades se consulta a la base de datos
          var query = { isIncapacity: 'true:parseBool', center: AppF.center, project: JSON.stringify({ fid: 1, name: 1 }) }
          promises.push(DataF.api.get('concepts', query))
        }
        Promise.all(promises).then(function (resp) {
          if (!angular.isArray(tiposincidencias)) {
            tiposincidencias = resp[0].data.map(function (item) {
              return item.fid;  
            });
          }
          query = { employee: idEmpleado, date: JSON.stringify({ $gte: fecha }), incidenceType: JSON.stringify({ $in: tiposincidencias }) };
          return DataF.api.get('incidences', query)
        }).then(function (item) {
          if (item.data.length > 0) {
            resolve(true)
          } else {
            resolve(false)
          }
        }).catch(reject)
      })
    }
  }
}());
(function(){
    'use strict';

    angular
        .module('app.core')
        .filter('capitalize', capitalize)

    function capitalize(){

        return capitalizeFn;

        function capitalizeFn(input){
            if(typeof input == 'string'){
                return (!!input) ? input.replace(/([^\W_]+[^\s-]*) */g, function (txt) {
                    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
                }) : '';
            }
                
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('bruteSalary', bruteSalary)

    function bruteSalary(AppF) {

        return bruteSalaryFn;

        function bruteSalaryFn(salary, net) {
            var realSalary = (salary.sd) ? salary.sd : AppF.minimumVariables.A;
            return (net) ? (realSalary * 30) - 1 : realSalary * 30;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter)
        .filter('getChatName', getChatName)
        .filter('getAvatar', getAvatar)
        .filter('toJSDate', toJSDate)
        .filter('replaceAll', replaceAll);

    function getOtherParticipantData(chat, contacts, profile, property, defaultText) {
        var text = defaultText;
        var participants = [];
        if (chat && chat.participants) {
            participants = angular.fromJson(angular.toJson(chat.participants));
            delete participants[profile.uid];
            participants = Object.keys(participants);
        }
        if (participants.length === 0) {
            text = 'Sin participantes';
        } else if (participants.length === 1 && angular.isArray(contacts)) {
            var participant = contacts.find(function (item) {
                return item.id === participants[0];
            });
            if (angular.isDefined(participant)) {
                text = participant[property];
            }
        } else {
            text = 'Grupo';
        }
        return text;
    }

    /** @ngInject */
    function getChatName() {
        return function (chat, contacts, profile) {
            return getOtherParticipantData(chat, contacts, profile, 'name', 'NoChatName');
        };
    }

    function getAvatar() {
        return function (chat, contacts, profile) {
            return getOtherParticipantData(chat, contacts, profile, 'avatar', 'assets/images/avatars/profile.jpg');
        };
    }

    /** @ngInject */
    function toTrustedFilter($sce) {
        return function (value) {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter() {
        return function (text) {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter() {
        return function (value) {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter() {
        return function (doc) {
            if (!doc) {
                return;
            }
            if (doc.type === 'directive') {
                return doc.name.replace(/([A-Z])/g, function ($1) {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

    function replaceAll() {
        return function (string, search, replace) {
            string = string + "";
            return string.replace(new RegExp(search, 'g'), replace);
        };
    }

    function toJSDate() {
        return function (value) {
            return moment(value).toDate();
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('altDate', altDate);

    /** @ngInject */
    function altDate()
    {
        return function (value)
        {
            var diff = moment().toDate() - moment(value).toDate();
            /**
             * If in a hour
             * e.g. "2 minutes ago"
             */
            if ( diff < (60 * 60 * 1000) )
            {
                return moment(value).fromNow();
            }
            /*
             * If in the day
             * e.g. "11:23"
             */
            else if ( diff < (60 * 60 * 24 * 1000) )
            {
                return moment(value).format('HH:mm');
            }
            /*
             * If in week
             * e.g "Tuesday"
             */
            else if ( diff < (60 * 60 * 24 * 7 * 1000) )
            {
                return moment(value).format('dddd');
            }
            /*
             * If more than a week
             * e.g. 03/29/2016
             */
            else
            {
                return moment(value).calendar();
            }

        };
    }

})();
(function() {
    'use strict';

    angular
        .module('app.core')
        .filter('allObjectsHasSameValue', allObjectsHasSameValue)

    function allObjectsHasSameValue() {

        return allObjectsHasSameValueFn;

        function allObjectsHasSameValueFn(arrayObject, field, value) {
            var flag = true;
            var thisValue = value ? value : "notDefinedYet";
            for (var a in arrayObject) {
                var thisObject = arrayObject[a];
                if (thisValue === "notDefinedYet") {
                    thisValue = thisObject[field];
                }
                if(thisValue!==thisObject[field]){
                    flag=false;
                }
            }
            return flag;
        }
    }

}());
(function(){
    'use strict';

    angular
        .module('app.core')
        .filter('activeObjectsOfArray', activeObjectsOfArray)

    function activeObjectsOfArray(){

        return activeObjectsOfArrayFn;

        function activeObjectsOfArrayFn(array, activeField){
            if(!activeField) activeField = 'active';
            var activeArray = [];
            for(var a in array){
                if(array[a].valid) activeArray.push(array[a]);
            }
            return activeArray;
        }
    }

}());
(function () {
    'use strict';

    /**
     * Main module of the Fuse
     */
    angular
        .module('fuse', [
            // Core
            'app.core',
            // Navigation
            'app.navigation',
            // Toolbar
            'app.toolbar',
            // Quick panel
            'app.quick-panel',
            // Apps
            'app.dashboards',
            'app.calendar',
            'app.tasks',
            // Cruds
            'app.clients',
            'app.config',
            // 'app.system',
            'app.employees',
            'app.catalogs',
            //'app.mail',
            'app.chat',
            //'app.file-manager',
            //'app.scrumboard',
            //'app.gantt-chart',
            'app.todo',
            // 'app.contacts',
            'app.notes',
            // 'app.tasks',

            // Pages
            'app.pages'

            // User Interface
            //'app.ui',

            // Components
            //'app.components'
        ]);
})();

(function () {
    'use strict';

    angular
        .module('fuse')
        .factory('RoutesF', RoutesF)

    // ment to contain all routes for controllers
    /** @ngInject */
    function RoutesF(
        $rootScope,
        $state,
        $stateParams,
        $location,
        $filter,
        getFromObjectFilter,
        $log,
        $q,
        $sessionStorage,
        AppF,
        infoAlertS,
        getArrayOfIdsFilter
    ) {
        var centerFn = function () {
            return AppF.center;
        };
        var defCenterTdsFn = {
            defaultValue: function () {
                if (AppF.center !== 'tds') {
                    return AppF.center;
                } else {
                    return undefined
                }
            }
        }
        var defCenterFn = {
            defaultValue: centerFn
        };
        var andFn = {
            defaultValue: function () {
                // $log.log(angular.toJson(AppF.ccsByPayrollsOfUser));
                if (AppF.permissionToAccessAllPayrolls) {
                    return undefined;
                } else {
                    var ccArray = [];
                    var payrollArray = [];
                    if (angular.isArray(AppF.ccsByPayrollsOfUser)) {
                        for (var j = 0; j < AppF.ccsByPayrollsOfUser.length; j++) {
                            var thisPayroll = AppF.ccsByPayrollsOfUser[j];
                            if (angular.isArray(thisPayroll.ccs)) {
                                if (thisPayroll.ccs.indexOf('all') > -1) {
                                    payrollArray.push(thisPayroll.$id);
                                } else {
                                    ccArray = ccArray.concat(thisPayroll.ccs);
                                }
                            }
                        }
                    }
                    var obj = angular.toJson([{ '$or': [{ cc: { $in: ccArray } }, { payroll: { $in: payrollArray } }] }]);
                    return obj;
                }
            }
        }
        var obj = {
            /**
             * @name convertDinamicRef
             * @description Autocompleta una referencia de Firebase con elementos del $state y de AppF.search.${termInUrl} y AppF.search.$.{termInUrl}
             * @param dinamicRef "" url dinamica con formato "url/:termInUrl/:otherTerm"
             * @param scope o null para buscar en scope[termInUrl]
             * @param catalog o null para hacer referencia
             * @param filter o null para hacer referencia
             */
            convertDinamicRef: function (dinamicRef, scope, catalog, filter, mainObject) {
                if (!catalog) {
                    catalog = AppF.active.menuName;
                }
                if (!filter) {
                    filter = AppF.active.$filter;
                }
                var ref = dinamicRef;
                var refArray = dinamicRef.split('/');
                for (var r = 0; r < refArray.length; r++) {
                    var cName = refArray[r];
                    if (cName.indexOf(':') !== -1) {
                        var val = obj.searchValueInMemory(cName, scope, mainObject);
                        if (!val) {
                            var msg = cName + ' no se encuentra en Memoria y es necesario';
                            $log.error(msg, {
                                catalog: catalog,
                                ref: ref,
                                dinamicRef: dinamicRef,
                                cName: cName,
                                val: val,
                                filter: filter
                            });
                            alert(msg);
                            return false;
                        }
                        ref = ref.replace(cName, val);
                    }
                }
                return ref;
            },
            /**
             *  @name constructDinamicRef
                @description Construye una url de referencia para Firebase, basada en la configuración de R.states[type][catalog].filter
                @param catalog "" el nombre del catalogo del cual se sacara la ref
                @param filter {} el filtro que se quiere filtrar
                @param scope $scope el scope o false para buscar tambien ahi valores para completar la ref
                @return "" ref para fb
            */
            constructDinamicRef: function (catalog, filter, scope, mainObject) {
                var dinamicRef = obj.dinamicRefs[catalog];
                var ref = '';
                if (!dinamicRef) alert('Falta configurar R.dinamicRefs.' + catalog);
                if (dinamicRef.indexOf(':') === -1) {
                    ref = dinamicRef;
                } else {
                    // var ref = '';
                    ref = obj.convertDinamicRef(dinamicRef, scope, catalog, filter, mainObject);
                }
                return ref;
            },
            // busca en filtro val o val() si hay o si no en F.search[cName], $scope[cNameId] y en $state.params[cNameId] en ese orden un valor y lo regresa
            searchValueInMemory: function (filterPropOrFilter, scope, mainObject) {
                var cNameD = '';
                var val = false;
                var filter = false;
                var typeOfCatalog;
                var getVal = function (cNameD, filterS) {
                    var cName = cNameD.substring(1); // take ':'
                    var cNameId = cName + 'Id';
                    var val = cNameD;
                    if (filterS) {
                        if (angular.isFunction(filterS.val)) {
                            val = filterS.val();
                        } else {
                            val = filterS.val;
                        }
                    }
                    if (val === false || !val || val === cNameD || val === null || val === '') {
                        if (angular.isObject(mainObject) && (mainObject[cNameId] || mainObject[cNameId])) {
                            val = mainObject[cNameId] || mainObject[cNameId];
                        } else if (scope && scope.F && scope.F.active && angular.isObject(scope.F.active.detailObject) && scope.F.active.detailObject[cName]) {
                            val = scope.F.active.detailObject[cName];
                        } else if (scope && scope.F && scope.F.active && angular.isObject(scope.F.active.detailObject) && scope.F.active.detailObject[cNameId]) {
                            val = scope.F.active.detailObject[cNameId];
                        } else if (AppF.search['$' + cName]) {
                            val = AppF.search['$' + cName];
                            // $log.debug('Found F.search.$', cName);
                        } else if (AppF.search.$[cName]) {
                            val = AppF.search.$[cName];
                        } else if (scope && scope[cNameId]) {
                            val = scope[cNameId];
                            // $log.debug('Found in $scope.', cNameId, val, scope[cNameId], scope);
                        } else if ($state.params[cNameId]) {
                            val = $state.params[cNameId];
                            // $log.debug('Found in $state.params.', cNameId);
                        }
                    }
                    return val;
                };
                if (typeof filterPropOrFilter == 'function') {
                    filter = filterPropOrFilter();
                    if (typeof filter == 'object') {
                        cNameD = ':' + filter.by;
                        val = getVal(cNameD, filter);
                    } else {
                        cNameD = ':' + filter;
                        typeOfCatalog = (obj.fbCatalogs.indexOf(filter + 's') !== -1) ? 'fb' : 'mongo';
                        val = getVal(cNameD, obj.states[typeOfCatalog][filter + 's'].filter);
                    }
                } else if (typeof filterPropOrFilter == 'object') {
                    typeOfCatalog = (obj.fbCatalogs.indexOf(filterPropOrFilter.by + 's') !== -1) ? 'fb' : 'mongo';
                    filter = obj.states[typeOfCatalog][filterPropOrFilter.by + 's'].filter;
                    cNameD = ':' + filterPropOrFilter.by;
                    val = getVal(cNameD, filter);
                } else { // is string or number
                    cNameD = filterPropOrFilter;
                    val = getVal(cNameD);
                }
                return val;
            },
            // regresa al state anterior lo saca de $sessionStorage
            back: function () {
                if (AppF.groupsOfUser) {
                    $log.debug('going back', {
                        activeObj: AppF.active
                    });
                    if (!$sessionStorage.lastState) {
                        AppF.goToInitialState();
                    } else {
                        $state.go($sessionStorage.lastState, $sessionStorage.lastParams);
                    }
                }
            },
            // trae un nuevo id de la ruta actual en fb
            getNewId: function (scope, catalog, filter) {
                if (!catalog) catalog = AppF.active.menuName;
                if (!filter) filter = AppF.active.filter;
                var ref = obj.constructDinamicRef(catalog, filter, scope);
                $log.debug('getNewId from ' + ref);
                return AppF.root.child(ref).push().key;
            },
            // va al listado si no se manda catalog y params va al configurado en R.states
            goToList: function (catalog, params) {
                if (!catalog) catalog = AppF.active.menuName;
                if (!params) params = {};
                $log.debug('going to List', {
                    catalog: catalog,
                    params: params
                });
                AppF.addMode = false;
                AppF.readMode = false;
                var typeOfCatalog = (obj.fbCatalogs.indexOf(catalog) !== -1) ? 'fb' : 'mongo';
                $state.go(obj.states[typeOfCatalog][catalog].list, params);
            },
            // va a un detail view (lo toma automaticamente si no se presentan los parámetros)
            goToDetail: function (object, action, params, catalogsName) {
                if (!catalogsName) catalogsName = AppF.active.menuName;
                var isFB = (obj.fbCatalogs.indexOf(catalogsName) !== -1);
                var typeOfCatalog = (isFB) ? 'fb' : 'mongo';
                if (!action) action = (!isFB) ? 'edit' : 'update';
                var idField = (!isFB) ? '_id' : '$id';
                var catalogName = catalogsName.slice(0, -1); // take last s
                if (object == 'new') AppF.addMode = true;
                if (!params) {
                    params = {};
                    if (object == 'new') {
                        params[catalogName + 'Id'] = 'new';
                    } else if (object.hasOwnProperty(idField)) {
                        params[catalogName + 'Id'] = object[idField];
                        if (typeOfCatalog == "mongo")
                            params[catalogName] = object;
                    } else {
                        $log.error(idField + ' dont exists in object... guessing', object, catalogsName);
                        if (typeof object == 'string') { // try idField
                            params[catalogName + 'Id'] = object;
                        } else {
                            params[catalogName] = object;
                        }
                    }
                }
                if (!obj.states[typeOfCatalog][catalogsName]) alert('Falta configurar R.states.fb.' + catalogsName), $log.error('Falta configurar R.states.fb.' + catalogsName, {
                    from: 'R.goToDetail()'
                });
                $log.debug('going to detail', {
                    action: action,
                    catalogsName: catalogsName,
                    params: params,
                    typeOfCatalog: typeOfCatalog,
                    objStatesAction: obj.states[typeOfCatalog][catalogsName][action]
                });
                $state.go(obj.states[typeOfCatalog][catalogsName][action], params);
            },
            /**
                @description Setea en $scope.F.search[paramName] para así invocar los listeners y filtrar
                @param filter
            */
            setStateFilter: function (filter, allIsAllowed) {
                var pName = filter.by + 'Id';
                var aName = '$' + filter.by;
                if ($state.params[pName] && angular.isDefined($state.params[pName])) {
                    if ($state.params[pName] !== AppF.search[aName] && $state.params[pName] !== 'all') {
                        $log.debug('setting in F.search.' + aName + ' from $state.params.' + pName);
                        AppF.search[aName] = $state.params[pName];
                    } else if ($state.params[pName] === 'all' && allIsAllowed) {
                        AppF.search[aName] = 'all';
                    }
                }
            },
            /**
                @description set in URL param from filter
                @param val
                @param filter
            */
            setStateParams: function (val, filter, allowAll, setUrl) {
                if (setUrl) {
                    var catalogs = (obj.fbCatalogs.indexOf(AppF.active.menuName) !== -1) ? 'fb' : 'mongo';
                    var list = obj.states[catalogs][AppF.active.menuName].list;
                    var f = obj.states[catalogs][AppF.active.menuName].filter;
                    var objP = {};
                    objP[f.by + "Id"] = "";
                    $state.go(list, objP, {
                        notify: false
                    });
                } else {
                    var menuName = AppF.active.menuName;
                    if (val == 'all' && !allowAll) val = null;
                    var typeOfCatalog = (obj.fbCatalogs.indexOf(menuName) !== -1) ? 'fb' : 'mongo';
                    if (!obj.states[typeOfCatalog][menuName]) alert('Falta configurar R.states.' + typeOfCatalog + '.' + menuName);
                    if (!filter) filter = obj.states[typeOfCatalog][menuName].filter;
                    if (filter) {
                        var pName = filter.by + 'Id';
                        var aName = '$' + pName;
                        var listState = obj.states[typeOfCatalog][menuName].list;
                        var newP;
                        // si es un listado con filtro, recarga la url con el filtro
                        if (!$state.params[pName] || angular.isUndefined($state.params[pName])) {
                            newP = $state.params ? JSON.parse(JSON.stringify($state.params)) : {};
                            newP[pName] = val;
                            $log.debug('setting from F.search.' + aName + ' in $state.params.' + pName, {
                                sParams: $state.params,
                                pName: pName,
                                newP: newP,
                                val: val,
                                state: listState,
                                from: 1
                            });
                            $state.go(listState, newP, {
                                notify: false
                            });
                        } else {
                            if ($state.params[pName] !== val) {
                                newP = $state.params ? JSON.parse(JSON.stringify($state.params)) : {};
                                // var newP = {};
                                newP[pName] = val;
                                $log.debug('setting from ' + aName + ' in $state.params.' + pName, {
                                    sParams: $state.params,
                                    pName: pName,
                                    newP: newP,
                                    val: val,
                                    state: listState,
                                    from: 2
                                });
                                $state.go(listState, newP, {
                                    notify: false
                                });
                            } else {
                                $log.debug('$state.params[' + pName + ']: ' + $state.params[pName] + ' is already equal val: ' + val);
                            }
                        }
                    }
                }
            },
            // mapa de referencias de FB
            // TODO:backlog pasar esto a fb y cargar previo a todo, las configuraciones de este tipo
            dinamicRefs: {
                version: 'interface/version',
                settings: 'settings/system',
                deleteInCascade: 'settings/triggers/deleteInCascade',
                safeDelete: 'settings/safeDelete',
                globalNotifications: 'settings/globalNotifications',
                connected: '.info/connected',
                menu: 'menu',
                dashboards_project: 'dashboard',
                users: 'profiles',
                permissions: 'permissions',
                groups: 'groups',
                groupings: 'catalogs/groupings/collection',
                concepts: 'catalogs/concepts/collection',
                processConfigs: 'catalogs/processConfigs/collection',
                accountAccVars: 'catalogs/accountAccVars/collection',
                payrollConfigs: 'catalogs/payrollConfigs/collection',
                customFields: 'catalogs/customFields/collection',
                sliderImages: 'catalogs/sliderImages/collection',
                emailImages: 'catalogs/emailImages/collection',
                constantsGeneral: 'constants/general', // @todo:wishlist hay que mover constants a catalogs
                constantsByfirm: 'constants/firm/:firm',
                constantsByPlaceOfWork: 'constants/placeOfWork/:placeOfWork',
                constantsByPayroll: 'constants/payroll/:payroll',
                constantsByCC: 'constants/cc/:cc',
                constantsByEmployee: 'constants/employee/:employee',
                folios: 'catalogs/folios/collection',
                benefits: 'catalogs/benefits/collection',
                operationConstants: 'catalogs/operationConstants/collection',
                chats: 'chats',
                imports: 'catalogs/imports/collection',
                conversations: 'conversations/:chat',
                notifications: 'notifications/:user/:readed',
                payrollCalendars: 'catalogs/payrollCalendars/:payroll/calendars',
                incidences: 'incidences/:payroll/:payrollCalendar',
                confirmIncidences: 'temp/confirmIncidences',
                periods: 'catalogs/payrollCalendars/:payroll/periods/:payrollCalendar',
                operations: 'catalogs/operations/:type/:payroll/:payrolCalendar/collection',
                stampedRecords: 'catalogs/operations/:type/:payroll/:payrolCalendar/collection',
                attendanceLists: 'catalogs/operations/:type/:payroll/:payrolCalendar/collection',
                firms: 'catalogs/firms/collection',
                calcFields: 'catalogs/calcFields/collection',
                holidays: 'catalogs/holidays/collection',
                ccs: 'catalogs/ccs/collection',
                rps: 'catalogs/rps/collection',
                projects: 'catalogs/projects/collection',
                paymentSchemas: 'catalogs/paymentSchemas/collection',
                incidencesTypes: 'catalogs/incidencesTypes/collection',
                payrolls: 'catalogs/payrolls/collection',
                involvedRecords: 'catalogs/involvedRecords/collection',
                incidencesRequests: 'catalogs/incidencesRequests/collection',
                positions: 'catalogs/positions/collection',
                departments: 'catalogs/departments/collection',
                companiesRecords: 'catalogs/companiesRecords/collection',
                employees: 'catalogs/employees/collection',
                aniversariesRecords: 'catalogs/employees/collection',
                aniversaryRecords: 'aniversaryRecords/collection',
                healthcareRecords: 'catalogs/employees/collection',
                employeesVacationsRecords: 'catalogs/employees/collection',
                employeeFiles: 'catalogs/employees/collection',
                personalInfoEmployees: 'catalogs/employees/collection',
                noEmployees: 'catalogs/employees/collection',
                employeeBirths: 'catalogs/employees/collection',
                anniversaryEmployees: 'catalogs/employees/collection',
                kardexEmployees: 'catalogs/employees/collection',
                realSalaryRecords: 'catalogs/employees/collection',
                credits: 'catalogs/credits/collection',
                loans: 'catalogs/loans/collection',
                enroles: 'catalogs/employees/collection',
                enroleAccounts: 'catalogs/employees/collection',
                dismissesRecords: 'catalogs/employees/collection',
                idseAutoRecords: 'catalogs/movements/collection',
                dismissesUnconfirmedRecords: 'catalogs/employees/collection',
                mdsRecords: 'catalogs/employees/collection',
                idseRecords: 'catalogs/movements/collection',
                reports: 'catalogs/reports/collection',
                closeOperations: 'catalogs/closeOperations/collection',
                revisions: 'catalogs/employees/collection',
                variables: 'catalogs/employees/collection',
                movements: 'catalogs/movements/collection',
                logs: 'catalogs/logs/collection'
                // movements: 'catalogs/movements/collection',
            },
            /** estos modulos cargaran al inicio simplemente refiriendote a la propiedad en R.dinamicRefs.{{propiedad}}
               puedes usar alias con alias@refName
               @todo:backlog poder cargar tmbien en M.loadCatalog y en C.loadCatalog
            */
            initialLoadS: [ // this block of object will be loaded after preLoad and will be recovered from $sessionStorage if version is not set
                'settings',
                'deleteInCascade',
                // 'groups',
                // 'menuItems@menu',
                // 'permissions',
                // 'connected',
                'safeDelete'
            ],
            /** carga avanzada inicial
             & se puede obtener un valor dinamico si se hace objeto
             puede invocar L.loadList con list: true y se pueden usar todos los parametros que loadList requiere:
             catalog, ref, child, type, filterName
            */
            initialLoadA: [],
            // mapa de atajos de teclado para acciones
            actions: {
                // access: { // list
                //     key: false,
                //     name: false
                //     // key: 27,
                //     // name: 'esc',
                //     // alertFirst: 'Está a punto de volver al listado'
                // },
                // update: {
                //     key: false,
                //     name: false
                // },
                // create: {
                //     key: 187,
                //     name: '+'
                // }
                // remove: {
                //     // key: 189,
                //     // name: '-'
                //     key: false,
                //     name: false
                // }
            },
            // mapa de catalogos que usan FB
            fbCatalogs: ['holidays', 'accountAccVars', 'calcFields', 'employeeBirths', 'anniversaryEmployees', 'users', 'firms', 'payrolls', 'paymentSchemas', 'ccs', 'companiesRecords', 'incidences', 'confirmIncidences', 'operations', 'attendanceLists', 'stampedRecords', 'payrollCalendars', 'periods', 'departments', 'positions', 'projects', 'rps', 'activitiesRecords', 'constants', 'benefits', 'operationConstants', 'groups', 'incidencesTypes', 'involvedRecords', 'notifications', 'permissions', 'incidencesRequests', 'globalNotifications', 'chats', 'conversations', 'employees', 'enroles', 'dismissesRecords', 'idseAutoRecords', 'dismissesUnconfirmedRecords', 'mdsRecords', 'variables', 'idseRecords', 'revisions', 'movements', 'logs', 'employeeFiles', 'personalInfoEmployees', 'employeesVacationsRecords', 'healthcareRecords', 'credits', 'loans', 'noEmployees', 'kardexEmployees', 'syncEmployeeRecords', 'realSalaryRecords', 'aniversariesRecords', 'aniversaryRecords', 'enroleAccounts', 'imports', 'dashboards_project', 'folios', 'processConfigs', 'payrollConfigs', "concepts", "groupings", "customFields", 'sliderImages', 'emailImages', 'closeOperations', 'reports'],
            // mapa de catalogos que usan Mongo
            mongoCatalogs: ['banks', 'employeeBirths', 'anniversaryEmployees', 'bankAccounts', 'filters', "tickets", "archivedTickets", 'paymentForms', 'directives', 'issuers', 'countriesRecords', 'dismissTypes', 'geoZones', 'imssRecords', 'cyvRecords', 'isrRecords', 'minimumWageRecords', 'incidencesStatusRecords', 'monthForAccumulatedRecords', 'paymentFrequenciesRecords', 'paymentGroups', 'placesOfWorkRecords', 'regimes', 'relationships', 'societyTypes', 'riskClassesRecords', 'salaryTypes', 'states', 'streetTypes', 'subsidyRecords', 'towns', 'unions', 'workDays', 'workerTypes', 'modules', 'bills', 'umaRecords', 'nfdRecords', 'documentTypes', 'saludRecords', 'contracts', 'xmlBillsRequests', 'xmlSatMetas', 'zipCodes', 'rpIdseRecords', 'batchRecords', 'placeTypes', 'accountingAccounts', 'humandCatalogs'],
            /**
                mapa de states y filtros que se aplican en las vistas
                filter {} se usa para no dar los datos al iniciar si no filtrar antes (este filtro aparece en el header)
                filters es un [{}] se usa para hacer filtros en orden antes de entregar datos, los datos que se entregan dependen del scopeName ya que si scopeName es igual al nombre del catálogo, se entiende que son los datos finales
            */
            // 'apps-sync': {
            //     humandCatalogs: {
            //         icon: "icon-format-list-bulleted",
            //         menuItem: "clients.apps-sync.humandCatalogs",
            //         state: "app.apps-sync.humandCatalogs",
            //         title: "Catálogos Humand",
            //         weight: 1
            //     }
            // },
            states: {
                // catalogs [records, locations, other]
                mongo: {
                    humandCatalogs: {
                        apiVersion: 3,
                        list: 'app.apps-sync.humandCatalogs',
                        edit: 'app.apps-sync.humandCatalogs.edit',
                        blanc: { center: centerFn },
                        $filters: {},
                        $filtersConfig: { 'center': defCenterFn },
                        // $generalFilter: ['rp', 'companiesRecordName', 'name']
                    },
                    rpIdseRecords: {
                        apiVersion: 2,
                        list: 'app.idse-panel.rpIdseRecords',
                        edit: 'app.idse-panel.rpIdseRecords.edit',
                        blanc: { center: centerFn },
                        $filters: {},
                        $filtersConfig: { 'center': defCenterFn },
                        $generalFilter: ['rp', 'companiesRecordName', 'name']
                    },
                    batchRecords: {
                        apiVersion: 2,
                        list: 'app.idse-panel.batchRecords',
                        edit: 'app.idse-panel.batchRecords.edit',
                        blanc: { center: centerFn },
                        $filters: { 'hasError': 'error', 'batchTaskStatus': 'status:number', 'archived': 'archived:boolean' },
                        $filtersConfig: {
                            'center': defCenterTdsFn,
                            'status:number': {
                                defaultValue: function () {
                                    return [0, 1, 3, 4]
                                }
                            },
                            'archived:boolean': {
                                defaultValue: function (value) {
                                    return angular.toJson({ $ne: true })
                                }
                            }
                        },
                        $generalFilter: ['rp', 'batch']
                    },
                    documentTypes: {
                        list: 'app.rh.documentTypes',
                        edit: 'app.rh.documentTypes.edit',
                        blanc: { center: centerFn },
                        $filters: { 'documentType': 'type' },
                        $filtersConfig: { 'center': defCenterFn }
                    },
                    contracts: {
                        $alias: 'document',
                        list: 'app.rh.contracts',
                        edit: 'app.rh.contracts.edit',
                        $filters: { 'payroll': 'payroll', 'contractStatus': 'active', 'monthBirth': 'endDate' },
                        blanc: {
                            type: 'contract',
                            center: centerFn,
                            active: true
                        },
                        $filtersConfig: {
                            'center': defCenterFn,
                            'payroll': {
                                defaultValue: function () {
                                    return AppF.permissionToAccessAllPayrolls ? undefined : getArrayOfIdsFilter($rootScope.L.payrolls);
                                }
                            },
                            'active': {
                                defaultValue: function () {
                                    var month = $filter('getFromObject')(AppF.filters, AppF.active.menuName + ".endDate")
                                    if (angular.isDefined(month)) {
                                        return true;
                                    }
                                    return undefined;
                                }
                            },
                            'endDate': {
                                specialFormat: 'monthSelected'
                            },
                            'type': {
                                defaultValue: 'contract'
                            }
                        },
                        $generalFilter: ['employeeName', 'employeeNss']
                    },
                    saludRecords: {
                        $alias: 'document',
                        list: 'app.rh.saludRecords',
                        edit: 'app.rh.saludRecords.edit',
                        blanc: {
                            type: 'saludRecord',
                            center: centerFn
                        },
                        $filtersConfig: {
                            'center': defCenterFn,
                            'type': {
                                defaultValue: 'saludRecord'
                            }
                        }
                    },
                    banks: {
                        list: 'app.other.banks',
                        edit: 'app.other.banks.edit',
                        unique: 'name',
                        blanc: {
                            allowRegister: true,
                            requestNumber: true
                        }
                    },
                    bankAccounts: {
                        list: 'app.other.bankAccounts',
                        edit: 'app.other.bankAccounts.edit',
                        unique: 'name',
                        $filtersConfig: {
                            'center': defCenterFn
                        },
                        blanc: {
                            status: true
                        }
                    },
                    directives: {
                        list: 'app.other.directives',
                        edit: 'app.other.directives.edit'
                    },
                    filters: {
                        list: 'app.other.filters',
                        edit: 'app.other.filters.edit'
                    },
                    paymentForms: {
                        list: 'app.other.paymentForms',
                        edit: 'app.other.paymentForms.edit'
                    },
                    issuers: {
                        list: 'app.other.issuers',
                        edit: 'app.other.issuers.edit',
                        unique: false
                    },
                    countriesRecords: {
                        list: 'app.locations.countriesRecords',
                        edit: 'app.locations.countriesRecords.edit',
                        unique: 'name'
                    },
                    dismissTypes: {
                        list: 'app.other.dismissTypes',
                        edit: 'app.other.dismissTypes.edit',
                        unique: 'name'
                    },
                    geoZones: {
                        list: 'app.locations.geoZones',
                        edit: 'app.locations.geoZones.edit',
                        unique: 'name',
                        blanc: {
                            status: true
                        }
                    },
                    placeTypes: {
                        list: 'app.locations.placeTypes',
                        edit: 'app.locations.placeTypes.edit',
                        unique: 'name'
                    },
                    zipCodes: {
                        list: 'app.locations.zipCodes',
                        edit: 'app.locations.zipCodes.edit',
                        unique: 'name'
                    },
                    imssRecords: {
                        list: 'app.records.imssRecords',
                        edit: 'app.records.imssRecords.edit',
                        unique: 'year',
                        $filters: { 'calendar': 'year:int' }
                    },
                    isrRecords: {
                        list: 'app.records.isrRecords',
                        edit: 'app.records.isrRecords.edit',
                        $filters: { 'calendar': 'year:int', 'periodicity': 'type' }
                    },
                    cyvRecords: {
                        list: 'app.records.cyvRecords',
                        edit: 'app.records.cyvRecords.edit'
                    },
                    minimumWageRecords: {
                        list: 'app.records.minimumWageRecords',
                        edit: 'app.records.minimumWageRecords.edit',
                        unique: 'year',
                        $filters: { 'calendar': 'year:int' }
                    },
                    incidencesStatusRecords: {
                        list: 'app.other.incidencesStatusRecords',
                        edit: 'app.other.incidencesStatusRecords.edit'
                    },
                    monthForAccumulatedRecords: {
                        list: 'app.other.monthForAccumulatedRecords',
                        edit: 'app.other.monthForAccumulatedRecords.edit'
                    },
                    paymentFrequenciesRecords: {
                        list: 'app.other.paymentFrequenciesRecords',
                        edit: 'app.other.paymentFrequenciesRecords.edit'
                    },
                    paymentGroups: {
                        list: 'app.other.paymentGroups',
                        edit: 'app.other.paymentGroups.edit'
                    },
                    placesOfWorkRecords: {
                        list: 'app.locations.placesOfWorkRecords',
                        edit: 'app.locations.placesOfWorkRecords.edit'
                    },
                    regimes: {
                        list: 'app.other.regimes',
                        edit: 'app.other.regimes.edit',
                        unique: 'name'
                    },
                    relationships: {
                        list: 'app.other.relationships',
                        edit: 'app.other.relationships.edit',
                        unique: 'name',
                        blanc: {
                            active: true
                        }
                    },
                    societyTypes: {
                        list: 'app.other.societyTypes',
                        edit: 'app.other.societyTypes.edit',
                        unique: 'name',
                        blanc: {}
                    },
                    riskClassesRecords: {
                        list: 'app.other.riskClassesRecords',
                        edit: 'app.other.riskClassesRecords.edit',
                        unique: 'name'
                    },
                    salaryTypes: {
                        list: 'app.other.salaryTypes',
                        edit: 'app.other.salaryTypes.edit',
                        unique: 'name'
                    },
                    accountingAccounts: {
                        list: 'app.config.accountingAccounts',
                        edit: 'app.config.accountingAccounts.edit',
                        read: 'app.config.accountingAccounts.read',
                        $filtersConfig: {
                            'center': defCenterFn
                        },
                        $filters: { 'companiesRecord': 'companiesRecord' },
                        disableSearchBar: true
                    },
                    tickets: {
                        list: 'app.config.tickets',
                        edit: 'app.config.tickets.edit',
                        read: 'app.config.tickets.read',
                        files: 1,
                        blanc: { center: centerFn },
                        $filters: { 'ticketStatus': 'status', 'modulesItems': 'module' },
                        $filtersConfig: {
                            'status': {
                                defaultValue: function () {
                                    return [1, 2]
                                }
                            }
                        }
                    },
                    archivedTickets: {
                        list: 'app.config.archivedTickets',
                        edit: 'app.config.archivedTickets.edit',
                        read: 'app.config.archivedTickets.read',
                        blanc: { center: centerFn }
                    },
                    states: {
                        list: 'app.locations.states',
                        edit: 'app.locations.states.edit',
                        unique: 'name'
                    },
                    streetTypes: {
                        list: 'app.other.streetTypes',
                        edit: 'app.other.streetTypes.edit',
                        unique: 'name'
                    },
                    subsidyRecords: {
                        list: 'app.records.subsidyRecords',
                        edit: 'app.records.subsidyRecords.edit',
                        $filters: { 'calendar': 'year:int', 'periodicity': 'type' }
                    },
                    towns: {
                        list: 'app.locations.towns',
                        edit: 'app.locations.towns.edit'
                    },
                    nfdRecords: {
                        list: 'app.records.nfdRecords',
                        edit: 'app.records.nfdRecords.edit',
                        $filters: { 'calendar': 'year:int' }
                    },
                    umaRecords: {
                        list: 'app.records.umaRecords',
                        edit: 'app.records.umaRecords.edit',
                        $filters: { 'calendar': 'year:int' }
                    },
                    xmlBillsRequests: {
                        list: 'app.processes.xmlBillsRequests',
                        blanc: {},
                        $filters: {
                            'companiesRecordOne': 'companiesRecord',
                            'calendarSelect': 'year:int',
                            'month': 'month:int'
                        },
                        $generalFilter: ['uuid', 'msg'],
                        $filtersConfig: {
                            'companiesRecord': {
                                defaultValue: function () {
                                    return "all";
                                }
                            },
                            'year:int': {
                                defaultValue: function () {
                                    return "all";
                                }
                            },
                            'month:int': {
                                defaultValue: function () {
                                    return "all";
                                }
                            }
                        }
                    },
                    bills: {
                        list: 'app.processes.bills',
                        $generalFilter: ['uuid', 'rfc', 'Comprobante.Emisor.Rfc'],
                        $filtersConfig: {
                            'center': defCenterFn,
                            'payrollId': {
                                defaultValue: function () {
                                    return AppF.permissionToAccessAllPayrolls ? undefined : getArrayOfIdsFilter($rootScope.L.payrolls);
                                }
                            },
                            'realPaymentDate.$gte': {
                                specialKey: 'lastKeyObject'
                            },
                            'realPaymentDate.$lte': {
                                specialKey: 'lastKeyObject'
                            }
                        },
                        $filters: {
                            'companiesRecord': 'companiesRecordId',
                            'operationType': 'opType',
                            'rp': 'rpId',
                            'payroll': 'payrollId',
                            'calendar': 'calendar:int',
                            'period': 'accuPeriod:int',
                            'employee': 'employeeId',
                            'hasError': 'errorMsg',
                            'sentStatus': 'sentStatus',
                            'fromDate': 'realPaymentDate.$gte',
                            'toDate': 'realPaymentDate.$lte'
                        }
                    },
                    xmlSatMetas: {
                        list: 'app.processes.xmlSatMetas',
                        $generalFilter: ['xmlStatus', 'nuevo'],
                        $filtersConfig: {
                            'center': defCenterFn
                        },
                        $filters: {
                            'companiesRecord': 'companiesRecordId'
                        }
                    },
                    unions: {
                        list: 'app.other.unions',
                        edit: 'app.other.unions.edit',
                        unique: 'name'
                    },
                    workDays: {
                        list: 'app.other.workDays',
                        edit: 'app.other.workDays.edit'
                    },
                    workerTypes: {
                        list: 'app.other.workerTypes',
                        edit: 'app.other.workerTypes.edit'
                    },
                    modules: {
                        list: 'app.system.modules',
                        edit: 'app.system.modules.detail'
                    },
                    actions: {
                        list: 'app.system.actions',
                        edit: 'app.system.actions.detail'
                    },
                    statusRecords: {
                        list: 'app.system.statusRecords',
                        edit: 'app.system.statusRecords.detail'
                    }
                },
                fb: {
                    //Accesos y permisos
                    groups: {
                        list: 'app.config.groups',
                        update: 'app.config.groups.update',
                        read: 'app.config.groups.read',
                        images: 2,
                        filter: false,
                        $filters: [],
                        blanc: {
                            users: {},
                            system: false
                        }
                    },
                    permissions: {
                        list: 'app.captures.employees', // @mejorar este redireccionamiento al listado
                        detail: 'app.config.permissions',
                        refObject: true,
                        filter: false,
                        $filters: [],
                        blanc: {}
                    },
                    users: {
                        list: 'app.config.users',
                        update: 'app.config.users.update',
                        read: 'app.config.users.read',
                        images: 2,
                        filter: {
                            by: 'center',
                            name: 'firmUsers',
                            scopeName: 'users',
                            query: true, // se usa para hacer orderBy, falso o null lo usan en la ref
                            val: function () {
                                return AppF.center === 'tds' ? undefined : AppF.center;
                            }
                        },
                        $filters: ['firm'],
                        blanc: {
                            active: true
                        }
                    },
                    involvedRecords: {
                        list: 'app.config.involvedRecords',
                        update: 'app.config.involvedRecords.update',
                        read: 'app.config.involvedRecords.read',
                        filter: {
                            scopeName: 'involvedRecords',
                            name: 'involvedRecordsCenter',
                            query: true,
                            by: 'center',
                            val: centerFn
                        },
                        $filters: [],
                        blanc: {
                            users: {
                                all: {}
                            }
                        }
                    },
                    globalNotifications: {
                        list: 'app.config.globalNotifications',
                        detail: 'app.config.globalNotifications',
                        refObject: true,
                        filter: false,
                        $filters: [],
                        blanc: {
                            enrole: {},
                            dismiss: {},
                            mds: {},
                            reEnrole: {},
                            operations: {},
                            credits: {},
                            incidences: {},
                            enroleAccount: {},
                            rhNotifications: {}
                        }
                    },
                    //Configuraciones de calculos
                    concepts: {
                        list: 'app.config.concepts',
                        update: 'app.config.concepts.update',
                        read: 'app.config.concepts.read',
                        $filtersConfig: {
                            'center': defCenterFn,
                            'calculations/fields/formule': {
                                specialFormat: 'regex',
                                specialKey: 'replaceDots'
                            }
                        },
                        $generalFilter: ['name', 'key', 'id_human', 'satCode'],
                        $filters: { 'payrollWg': 'payroll', 'conceptType': 'type', 'nature': 'nature', 'formule': 'calculations/fields/formule' },
                        blanc: {
                            showTotal: true,
                            requireConfirmation: 0,
                            payroll: 'global'
                        },
                        moreColumns: [{
                            path: 'satCode', name: 'Código SAT', type: 'string', rute: 'catalogs/concepts/collection', editable: function (object) {
                                return true;
                            }
                        }]
                    },
                    incidencesTypes: {
                        list: 'app.config.incidencesTypes',
                        update: 'app.config.incidencesTypes.update',
                        read: 'app.config.incidencesTypes.read',
                        filter: {
                            by: 'payroll',
                            name: 'payrollIncidencesTypes',
                            scopeName: 'incidencesTypes',
                            restrictAll: false,
                            query: true,
                            val: function () {
                                return AppF.search.$payroll;
                            }
                        },
                        $filters: [],
                        blanc: {
                            showTotal: true,
                            requireConfirmation: 0,
                            payroll: 'global'
                        }
                    },
                    customFields: {
                        list: 'app.config.customFields',
                        update: 'app.config.customFields.update',
                        read: 'app.config.customFields.read',
                        filter: false,
                        blanc: {}
                    },
                    operationConstants: {
                        list: 'app.config.operationConstants',
                        update: 'app.config.operationConstants.update',
                        read: 'app.config.operationConstants.read',
                        tabs: ['default', 'payroll', 'cc', 'employee'],
                        filter: {
                            by: 'type',
                            restrictAll: true,
                            alias: 'F.search.$type',
                            name: 'operationConstants',
                            scopeName: 'operationConstants',
                            query: true,
                            val: function () {
                                return AppF.search.$type || 'default';
                            }
                        },
                        $$filter: [{
                            by: 'cc',
                            val: function () {
                                var thisValue;
                                if (['employee'].indexOf(AppF.search.$type) > -1) {
                                    thisValue = getArrayOfIdsFilter(AppF.permissionToAccessAllPayrolls ? $rootScope.L.ccs : $rootScope.L.userCcs[AppF.profile.uid]);
                                }
                                return thisValue;
                            }
                        }, {
                            by: 'payroll',
                            val: function () {
                                var thisValue;
                                if (['cc', 'employee'].indexOf(AppF.search.$type) > -1) {
                                    thisValue = getArrayOfIdsFilter(AppF.permissionToAccessAllPayrolls ? $rootScope.L.allPayrolls : $rootScope.L.payrolls);
                                }
                                return thisValue;
                            }
                        }, {
                            by: 'itemId',
                            val: function () {
                                var thisValue;
                                if (AppF.search.$type === 'payroll') {
                                    thisValue = getArrayOfIdsFilter(AppF.permissionToAccessAllPayrolls ? $rootScope.L.allPayrolls : $rootScope.L.payrolls);
                                } else if (AppF.search.$type === 'cc') {
                                    thisValue = getArrayOfIdsFilter(AppF.permissionToAccessAllPayrolls ? $rootScope.L.ccs : $rootScope.L.userCcs[AppF.profile.uid]);
                                }
                                return thisValue;
                            }
                        }],
                        $filters: ['itemId', 'incidencesType', 'customField.key'],
                        blanc: AppF.defaultOperationConstants
                    },
                    paymentSchemas: {
                        list: 'app.config.paymentSchemas',
                        update: 'app.config.paymentSchemas.update',
                        read: 'app.config.paymentSchemas.read',
                        $filters: [],
                        filter: {
                            by: 'center',
                            name: 'paymentSchemas',
                            scopeName: 'paymentSchemas',
                            query: true,
                            val: centerFn
                        },
                        blanc: {
                            data: {
                                name: '',
                                processes: {
                                    real: {
                                        active: true,
                                        name: 'REAL'
                                    },
                                    fiscal: {
                                        active: true,
                                        name: 'FISCAL'
                                    },
                                    complements: []
                                }
                            }
                        }
                    },
                    processConfigs: {
                        list: 'app.config.processConfigs',
                        update: 'app.config.processConfigs.update',
                        read: 'app.config.processConfigs.read',
                        filter: {
                            by: 'center',
                            name: 'processConfigs',
                            scopeName: 'processConfigs',
                            query: true,
                            val: centerFn
                        },
                        $filters: [],
                        blanc: {
                            processes: [
                                { name: 'NUEVO' }
                            ]
                        }
                    },
                    accountAccVars: {
                        list: 'app.config.accountAccVars',
                        update: 'app.config.accountAccVars.update',
                        read: 'app.config.accountAccVars.read',
                        // $filtersConfig: {
                        //     'center': defCenterFn
                        // },
                        // $filters: { 'payroll': 'payroll', 'companiesRecord': 'companiesRecord' },
                        disableSearchBar: true
                    },

                    imports: {
                        list: 'app.config.imports',
                        update: 'app.config.imports.update',
                        read: 'app.config.imports.read',
                        filter: {
                            by: 'payroll',
                            alias: 'F.search.$payroll',
                            name: 'payrollImports',
                            scopeName: 'imports',
                            query: true,
                            restrictAll: true,
                            val: function () {
                                return AppF.search.$payroll
                            }
                        },
                        $filters: [],
                        blanc: {}
                    },
                    benefits: {
                        list: 'app.config.benefits',
                        update: 'app.config.benefits.update',
                        read: 'app.config.benefits.read',
                        tabs: ['default', 'payroll', 'cc', 'employee'],
                        filter: {
                            by: 'type',
                            restrictAll: true,
                            alias: 'F.search.$type',
                            name: 'benefits',
                            scopeName: 'benefits',
                            query: true,
                            val: function () {
                                return AppF.search.$type || 'default';
                            }
                        },
                        $$filter: [{
                            by: 'cc',
                            val: function () {
                                var thisValue;
                                if (['employee'].indexOf(AppF.search.$type) > -1) {
                                    thisValue = getArrayOfIdsFilter(AppF.permissionToAccessAllPayrolls ? $rootScope.L.ccs : $rootScope.L.userCcs[AppF.profile.uid]);
                                }
                                return thisValue;
                            }
                        }, {
                            by: 'payroll',
                            val: function () {
                                var thisValue;
                                if (['cc', 'employee'].indexOf(AppF.search.$type) > -1) {
                                    thisValue = getArrayOfIdsFilter(AppF.permissionToAccessAllPayrolls ? $rootScope.L.allPayrolls : $rootScope.L.payrolls);
                                }
                                return thisValue;
                            }
                        }, {
                            by: 'itemId',
                            val: function () {
                                var thisValue;
                                if (AppF.search.$type === 'payroll') {
                                    thisValue = getArrayOfIdsFilter(AppF.permissionToAccessAllPayrolls ? $rootScope.L.allPayrolls : $rootScope.L.payrolls);
                                } else if (AppF.search.$type === 'cc') {
                                    thisValue = getArrayOfIdsFilter(AppF.permissionToAccessAllPayrolls ? $rootScope.L.ccs : $rootScope.L.userCcs[AppF.profile.uid]);
                                }
                                return thisValue;
                            }
                        }],
                        $filters: ['itemId'],
                        blanc: AppF.defaultBenefits,
                    },
                    holidays: {
                        list: 'app.config.holidays',
                        update: 'app.config.holidays.update',
                        read: 'app.config.holidays.read',
                        filter: false,
                        $filters: []
                    },
                    //Utilidades
                    sliderImages: {
                        list: 'app.config.sliderImages',
                        update: 'app.config.sliderImages.update',
                        read: 'app.config.sliderImages.read',
                        files: 1,
                        filter: false,
                        $filters: [],
                        blanc: {
                        }
                    },
                    emailImages: {
                        list: 'app.config.emailImages',
                        update: 'app.config.emailImages.update',
                        read: 'app.config.emailImages.read',
                        files: 1,
                        filter: false,
                        $filters: [],
                        blanc: {
                            active: true
                        }
                    },

                    //Catalogos
                    firms: {
                        list: 'app.organization.firms',
                        update: 'app.organization.firms.update',
                        read: 'app.organization.firms.read',
                        images: 2, // tab and validator
                        filter: {
                            by: 'center',
                            name: 'firms',
                            scopeName: 'firms',
                            query: true,
                            val: function () {
                                return AppF.profile.firm
                            }
                        },
                        $filters: ['loanStatus'],
                        $filtersConfig: {
                            'loanStatus': {
                                'replace': 'active',
                                'allowFalse': true
                            }
                        },
                        blanc: {
                            active: true
                        },
                        fixedFieldsSearch: ['businessName', 'name', 'rfc']
                    },
                    companiesRecords: {
                        list: 'app.organization.companiesRecords',
                        read: 'app.organization.companiesRecords.read',
                        update: 'app.organization.companiesRecords.update',
                        images: 2,
                        filter: {
                            by: 'center',
                            name: 'companiesRecords',
                            scopeName: 'companiesRecords',
                            query: true,
                            val: function () {
                                return AppF.profile.firm
                            }
                        },
                        $$filter: [{
                            by: 'client',
                            val: function () {
                                return AppF.isDistributor() ? undefined : AppF.profile.firm;
                            }
                        }],
                        // $filters: ['payroll', 'loanStatus'],
                        $filters: ['loanStatus'],
                        $filtersConfig: {
                            'loanStatus': {
                                'replace': 'active',
                                'allowFalse': true
                            }
                        },
                        blanc: {
                            active: true
                        },
                        fixedFieldsSearch: ['rfc', 'businessName', 'businessNameShort', 'name']
                    },
                    rps: {
                        list: 'app.organization.rps',
                        update: 'app.organization.rps.update',
                        read: 'app.organization.rps.read',
                        filter: {
                            by: 'center',
                            name: 'rps',
                            scopeName: 'rps',
                            query: true,
                            val: function () {
                                return AppF.profile.firm
                            }
                        },
                        $$filter: [{
                            by: 'client',
                            val: function () {
                                return AppF.isDistributor() ? undefined : AppF.profile.firm;
                            }
                        }],
                        $filters: ['loanStatus', 'companiesRecord'],
                        $filtersConfig: {
                            'loanStatus': {
                                'replace': 'active',
                                'allowFalse': true
                            }
                        },
                        blanc: {
                            active: true
                        },
                        fixedFieldsSearch: ['shortName', 'name']

                    },
                    payrolls: {
                        list: 'app.organization.payrolls',
                        update: 'app.organization.payrolls.update',
                        read: 'app.organization.payrolls.read',
                        filter: {
                            by: 'center',
                            name: 'centerPayrolls',
                            scopeName: 'payrolls',
                            query: true,
                            val: centerFn
                        },
                        $$filter: [{
                            by: '$id',
                            val: function () {
                                var arrayOfIds = (AppF.permissionToAccessAllPayrolls) ?
                                    getArrayOfIdsFilter($rootScope.L.allPayrolls) :
                                    getArrayOfIdsFilter($rootScope.L.payrolls);
                                return arrayOfIds;
                            }
                        }],
                        $filters: ['loanStatus'],
                        $filtersConfig: {
                            'loanStatus': {
                                'replace': 'active',
                                'allowFalse': true
                            }
                        },
                        blanc: {
                            active: true,
                            generateEmployeeNumber: true
                        },
                        fixedFieldsSearch: ['class', 'name']
                    },
                    ccs: {
                        list: 'app.organization.ccs',
                        update: 'app.organization.ccs.update',
                        read: 'app.organization.ccs.read',
                        filter: {
                            by: 'center',
                            name: 'payrollCcs',
                            scopeName: 'ccs',
                            query: true,
                            val: centerFn
                        },
                        $$filter: [{
                            by: 'payroll',
                            val: function () {
                                return AppF.permissionToAccessAllPayrolls ? undefined : getArrayOfIdsFilter($rootScope.L.payrolls);
                            }
                        }
                        ],
                        $filters: ['payroll', 'loanStatus'],
                        $filtersConfig: {
                            'loanStatus': {
                                'replace': 'valid',
                                'allowFalse': true
                            }
                        },
                        blanc: {
                            data: {
                                healthCare: true
                            },
                            valid: true
                        },
                        fixedFieldsSearch: ['name']
                    },
                    positions: {
                        list: 'app.organization.positions',
                        update: 'app.organization.positions.update',
                        read: 'app.organization.positions.read',
                        filter: {
                            by: 'center',
                            name: 'positions',
                            scopeName: 'positions',
                            query: true,
                            val: centerFn
                        },
                        $$filter: [{
                            by: 'payroll',
                            val: function () {
                                var arrayOfIds = (AppF.permissionToAccessAllPayrolls) ?
                                    getArrayOfIdsFilter($rootScope.L.allPayrolls) :
                                    getArrayOfIdsFilter($rootScope.L.payrolls);
                                return arrayOfIds;
                            }
                        }],
                        $filters: ['payroll'],
                        blanc: {},
                        fixedFieldsSearch: ['name']
                    },
                    departments: {
                        list: 'app.organization.departments',
                        update: 'app.organization.departments.update',
                        read: 'app.organization.departments.read',
                        filter: {
                            by: 'center',
                            name: 'departments',
                            scopeName: 'departments',
                            query: true,
                            val: centerFn
                        },
                        $$filter: [{
                            by: 'payroll',
                            val: function () {
                                var arrayOfIds = (AppF.permissionToAccessAllPayrolls) ?
                                    getArrayOfIdsFilter($rootScope.L.allPayrolls) :
                                    getArrayOfIdsFilter($rootScope.L.payrolls);
                                return arrayOfIds;
                            }
                        }],
                        $filters: ['payroll'],
                        blanc: {},
                        fixedFieldsSearch: ['name']
                    },
                    //Calculos
                    payrollCalendars: {
                        list: 'app.processes.payrollCalendars',
                        update: 'app.processes.payrollCalendars.update',
                        read: 'app.processes.payrollCalendars.read',
                        filter: {
                            by: 'payroll',
                            restrictAll: true,
                            alias: 'F.search.$payroll',
                            name: 'payrollPayrollCalendars',
                            type: 'array',
                            scopeName: 'payrollCalendars',
                            val: function () {
                                return AppF.search.$payroll;
                            }
                        },
                        $filters: [],
                        blanc: {
                            data: {}
                        }
                    },
                    periods: {
                        list: 'app.processes.periods',
                        // detail: 'app.clients.periods.detail',
                        filter: {
                            by: 'payroll',
                            restrictAll: true,
                            alias: 'F.search.$payroll',
                            name: 'payrollPayrollCalendars',
                            scopeName: 'payrollCalendars',
                            type: 'array',
                            val: function () {
                                return AppF.search.$payroll;
                            }
                        },
                        filters: [{
                            by: 'payrollCalendar',
                            require: ['$payroll'],
                            alias: 'F.search.$payrollCalendar',
                            name: 'payrollPayrollCalendarsPeriods',
                            query: false,
                            type: 'array',
                            scopeName: 'periods',
                            val: function () {
                                return AppF.search.$payrollCalendar;
                            }
                        }],
                        blanc: {},
                        $filters: []
                    },
                    incidences: {
                        list: 'app.processes.incidences',
                        update: 'app.processes.incidences.update',
                        read: 'app.processes.incidences.read',
                        files: 1,
                        as: 'incidences',
                        $filtersConfig: {
                            'center': defCenterFn,
                            'payroll': {
                                defaultValue: function () {
                                    return AppF.permissionToAccessAllPayrolls ? undefined : getArrayOfIdsFilter($rootScope.L.payrolls);
                                }
                            }
                        },
                        $filters: { 'calendarSelect': 'calendar:int', 'employee': 'employee', 'payroll': 'payroll', 'period': 'period:int', 'incidencesStatus': 'status', 'incidencesTypes': 'incidenceType' }, //['period'],
                        blanc: {
                            status: 0,
                            type: 'manual'
                        }
                        // moreColumns: [
                        //     {
                        //         path: "incapacityType", name: "Tipo incapacidad", type: "fromList", list: AppF.incapacityTypes, editable: function (object) {
                        //             return angular.isDefined(object.incapacityType)
                        //         },
                        //         rute: function (element) {
                        //             return ('incidences/' + element.payroll + '/' + element.calendar)
                        //         }
                        //     },
                        //     {
                        //         path: "startDate", name: "Inicio Incapacidad", type: "date", editable: function (object) {
                        //             return angular.isDefined(object.startDate)
                        //         },
                        //         rute: function (element) {
                        //             return ('incidences/' + element.payroll + '/' + element.calendar)
                        //         }
                        //     }
                        // ],
                        // $generalFilter: ['folio', 'incidenceType']
                    },
                    confirmIncidences: {
                        list: 'app.processes.confirmIncidences',
                        confirm: 'app.processes.confirmIncidences.confirm',
                        read: 'app.processes.confirmIncidences.read',
                        images: 1,
                        as: 'incidence', // necesario para cuando se usa formularios compartidos y se quiere respetar el nombre del objeto principal
                        filter: {
                            by: 'payroll',
                            restrictAll: true,
                            alias: 'F.search.$payroll',
                            name: 'payrollIncidences',
                            query: true,
                            val: function () {
                                return AppF.search.$payroll
                            }
                        },
                        $filters: ['status'], //['period'],
                        blanc: {}
                    },
                    incidencesRequests: {
                        list: 'app.processes.incidencesRequests',
                        update: 'app.processes.incidencesRequests.update',
                        read: 'app.processes.incidencesRequests.read',
                        $filters: ['payroll'],
                        $$filter: [{
                            by: 'payroll',
                            val: function () {
                                var arrayOfIds = (AppF.permissionToAccessAllPayrolls) ?
                                    getArrayOfIdsFilter($rootScope.L.allPayrolls) :
                                    getArrayOfIdsFilter($rootScope.L.payrolls);
                                return arrayOfIds;
                            }
                        }],
                        filter: {
                            by: 'center',
                            name: 'incidencesRequests',
                            scopeName: 'incidencesRequests',
                            query: true,
                            val: centerFn
                        },
                        blanc: {
                            center: centerFn,
                            applied: 0,
                            automaticAsignation: true,
                            allPayroll: 0,
                            employees: {},
                            status: 0
                        }
                    },
                    attendanceLists: {
                        list: 'app.processes.attendanceLists',
                        $alias: 'operation',
                        detail: 'app.processes.attendanceLists.edit',
                        read: 'app.processes.attendanceLists.read',
                        $filters: { 'payroll': 'payroll', 'calendarSelect': 'calendar:int' },
                        $generalFilter: [],
                        disableSearchBar: true,
                        $filtersConfig: {
                            'center': defCenterFn,
                            'operationType': {
                                defaultValue: function () {
                                    return 'ordinary';
                                }
                            },
                            'payroll': {
                                required: function () {
                                    return true
                                },
                                defaultValue: function () {
                                    return undefined;
                                }
                            },
                            'calendar:int': {
                                required: function () {
                                    return true;
                                }
                            }
                        }
                    },
                    operations: {
                        list: 'app.processes.operations',
                        detail: 'app.processes.operations.edit',
                        read: 'app.processes.operations.read',
                        $filters: { 'payroll': 'payroll', 'employee': 'employees', 'calendarSelect': 'calendar:int' },
                        $generalFilter: [],
                        disableSearchBar: true,
                        tabs: {
                            ordinaryByPayroll: {
                                name: 'ordinaryByPayroll',
                                title: 'Ordinarias',
                                permission: ['edit'],
                                removeFilter: ['status'],
                                fixedOrder: 'period',
                                accessAction: 'validateOpeAccess'
                            }, settlement: {
                                name: 'settlement',
                                title: 'Finiquitos',
                                pObject: 'Settlement',
                                addEditAction: 'addSettlements',
                                addParam: 'settlement',
                                editParam: 'edit',
                                accessAction: 'goToDetail',
                                objectName: 'settlement',
                                permission: ['editSettlement']
                            }, special: {
                                name: 'special',
                                title: 'Especiales',
                                pObject: 'Special',
                                addEditAction: 'addEditOpe',
                                addParam: 'special',
                                objectName: 'special',
                                editParam: 'special',
                                accessAction: 'goToDetail',
                                permission: ['editSpecial']
                            }, extraordinary: {
                                name: 'extraordinary',
                                title: 'Extraordinarias',
                                pObject: 'Extraordinary',
                                addEditAction: 'addEditOpe',
                                addParam: 'extraordinary',
                                objectName: 'extraordinary',
                                editParam: 'extraordinary',
                                accessAction: 'goToDetail',
                                permission: ['editExtraordinary']
                            }, asimilated: {
                                name: 'asimilated',
                                title: 'Asimilados',
                                pObject: 'Asimilated',
                                addEditAction: 'addEditOpe',
                                addParam: 'asimilated',
                                objectName: 'asimilated',
                                editParam: 'asimilated',
                                accessAction: 'goToDetail',
                                permission: ['editAsimilated']
                            }, advAndLoanOpe: {
                                name: 'advAndLoanOpe',
                                title: 'Anticipos o prestamos',
                                pObject: 'AdvAndLoanOpe',
                                addParam: 'advAndLoanOpe',
                                objectName: 'advAndLoanOpe',
                                editParam: 'advAndLoanOpe',
                                addEditAction: 'addEditOpe',
                                accessAction: 'goToDetail',
                                permission: ['editAdvAndLoanOpe']
                            }, travelExpensesOpe: {
                                name: 'travelExpensesOpe',
                                title: 'Viáticos',
                                pObject: 'TravelExpensesOpe',
                                addParam: 'travelExpensesOpe',
                                objectName: 'travelExpensesOpe',
                                editParam: 'travelExpensesOpe',
                                addEditAction: 'addEditOpe',
                                accessAction: 'goToDetail',
                                permission: ['editTravelExpensesOpe']
                            }, chrisBonusRecord: {
                                name: 'chrisBonusRecord',
                                title: 'Aguinaldos',
                                pObject: 'ChrisBonusRecord',
                                addParam: 'chrisBonusRecord',
                                objectName: 'chrisBonusRecord',
                                editParam: 'chrisBonusRecord',
                                addEditAction: 'addEditOpe',
                                accessAction: 'goToDetail',
                                permission: ['editChrisBonusRecord']
                            }, ptuRecord: {
                                name: 'ptuRecord',
                                title: 'PTU',
                                pObject: 'PtuRecord',
                                addParam: 'ptuRecord',
                                objectName: 'ptuRecord',
                                editParam: 'ptuRecord',
                                addEditAction: 'addEditOpe',
                                accessAction: 'goToDetail',
                                permission: ['editPtuRecord']
                            }, ptuDistributionRecord: {
                                name: 'ptuDistributionRecord',
                                title: 'Distribución PTU',
                                pObject: 'PtuDistributionRecord',
                                addParam: 'ptuDistributionRecord',
                                objectName: 'ptuDistributionRecord',
                                editParam: 'ptuDistributionRecord',
                                addEditAction: 'addEditDistribution',
                                accessAction: 'goToDetail',
                                permission: ['editPtuDistributionRecord']
                            }
                        },
                        $filtersConfig: {
                            'center': defCenterFn,
                            'employees': {
                                specialFormat: 'existsField',
                                specialKey: 'existsKey'
                            },
                            'status': {
                                defaultValue: function (tabConfig) {
                                    if (angular.isDefined(tabConfig) && tabConfig.name === 'ordinary') {
                                        return { $gte: 3 };
                                    } else {
                                        return undefined;
                                    }
                                }
                            },
                            'operationType': {
                                defaultValue: function (tabConfig) {
                                    if (angular.isUndefined(tabConfig) || tabConfig.name === 'ordinaryByPayroll') {
                                        return 'ordinary';
                                    } else {
                                        return tabConfig.name;
                                    }
                                }
                            },
                            'payroll': {
                                required: function (tabConfig) {
                                    return angular.isDefined(tabConfig) && tabConfig.name === 'ordinaryByPayroll'
                                },
                                defaultValue: function () {
                                    return AppF.permissionToAccessAllPayrolls ? undefined : getArrayOfIdsFilter($rootScope.L.payrolls);
                                }
                            },
                            'calendar:int': {
                                required: function (tabConfig) {
                                    return angular.isDefined(tabConfig) && tabConfig.name === 'ordinaryByPayroll'
                                }
                            }
                        }
                    },
                    stampedRecords: {
                        list: 'app.processes.operations',
                        $alias: 'operation',
                        $filters: ['payroll'],
                        $generalFilter: [],
                        disableSearchBar: true,
                        tabs: {
                            ordinary: {
                                name: 'ordinary',
                                title: 'Nominas pend',
                                pObject: 'Ordinary',
                                editP: 'operationsedit',
                                removeFilter: ['operationType'],
                                permission: [{ action: 'edit', access: 'processes.operations' }]
                            }, settlement: {
                                name: 'settlement',
                                title: 'Finiquitos pend',
                                pObject: 'Settlement',
                                removeFilter: ['operationType'],
                                permission: [{ action: 'editSettlement', access: 'processes.operations' }]
                            }, asimilated: {
                                name: 'asimilated',
                                title: 'Asimilados pend',
                                pObject: 'Asimilated',
                                removeFilter: ['operationType'],
                                permission: [{ action: 'editAsimilated', access: 'processes.operations' }]
                            }, advAndLoanOpe: {
                                name: 'advAndLoanOpe',
                                title: 'Anticipos o prestamos pend',
                                pObject: 'AdvAndLoanOpe',
                                removeFilter: ['operationType'],
                                permission: [{ action: 'editAdvAndLoanOpe', access: 'processes.operations' }]
                            }, travelExpensesOpe: {
                                name: 'travelExpensesOpe',
                                title: 'Viáticos pend',
                                pObject: 'TravelExpensesOpe',
                                removeFilter: ['operationType'],
                                permission: [{ action: 'editTravelExpensesOpe', access: 'processes.operations' }]
                            }, chrisBonusRecord: {
                                name: 'chrisBonusRecord',
                                title: 'Aguinaldos pend',
                                pObject: 'ChrisBonusRecord',
                                removeFilter: ['operationType'],
                                permission: [{ action: 'editChrisBonusRecord', access: 'processes.operations' }]
                            }, extraordinary: {
                                name: 'extraordinary',
                                title: 'Extraordinarias pend',
                                pObject: 'Extraordinary',
                                removeFilter: ['operationType'],
                                permission: [{ action: 'editExtraordinary', access: 'processes.operations' }]
                            }, ptuRecord: {
                                name: 'ptuRecord',
                                title: 'PTU pend',
                                pObject: 'PtuRecord',
                                removeFilter: ['operationType'],
                                permission: [{ action: 'editPtuRecord', access: 'processes.operations' }]
                            }, allOpes: {
                                name: 'allOpes',
                                title: 'Operaciones Timbradas',
                                filters: ['operationType'],
                                permission: [{ action: 'edit', access: 'processes.operations' }]
                            }
                        },
                        $filtersConfig: {
                            'center': defCenterFn,
                            'status': {
                                defaultValue: function (tabConfig) {
                                    if (angular.isDefined(tabConfig) && tabConfig.name === 'allOpes') {
                                        return { $gte: 6 }
                                    } else {
                                        return { $gte: 3, $lt: 6 }
                                    }
                                }
                            },
                            'payroll': {
                                defaultValue: function () {
                                    return AppF.permissionToAccessAllPayrolls ? undefined : getArrayOfIdsFilter($rootScope.L.payrolls);
                                }
                            },
                            'operationType': {
                                defaultValue: function (tabConfig) {
                                    if (angular.isUndefined(tabConfig) || tabConfig.name === 'allOpes') {
                                        return undefined;
                                    } else {
                                        return tabConfig.name;
                                    }
                                }
                            }
                        }
                    },
                    closeOperations: {
                        list: 'app.processes.closeOperations',
                        update: 'app.processes.closeOperations.update',
                        read: 'app.processes.closeOperations.read',
                        filter: {
                            by: 'center',
                            name: 'closeOperations',
                            scopeName: 'closeOperations',
                            query: true,
                            val: function () {
                                return AppF.profile.firm
                            }
                        },
                        $filters: [],
                        blanc: {
                            center: centerFn
                        }
                    },
                    reports: {
                        list: 'app.processes.reports',
                        // update:'app.processes.reports.update',
                        // read: 'app.processes.reports.read',
                        filter: { restrictAll: false, allowClients: true },
                        $filters: [],
                        blanc: {}
                    },
                    folios: {
                        list: 'app.processes.folios',
                        // fill
                        filter: false,
                        $filters: [],
                        blanc: {
                            active: true
                        }
                    },
                    // EMPLEADOS
                    employees: {
                        list: 'app.captures.employees',
                        enrole: 'app.captures.employees.enrole',
                        reEntry: 'app.captures.employees.reEntry',
                        dismiss: 'app.captures.employees.dismiss',
                        mds: 'app.captures.employees.mds',
                        read: 'app.captures.employees.read',
                        update: 'app.captures.employees.update',
                        especialEdit: 'app.captures.employees.especialEdit',
                        moreColumns: [
                            { path: "data.employeeNumber", name: "# Empleado", type: "int" },
                            { path: "movement.batch", name: "Lote", type: "string" },
                            {
                                path: "paymentForms.0.type", name: "Formas de Pago", type: "fromMongo", from: "paymentForms", defaultValue: 'Transferencia', editFn: 'editPaymentForms', editable: function () {
                                    return true;
                                }
                            }
                        ],
                        $filters: {
                            'rp': 'rp', 'payroll': 'payroll', 'cc': 'cc', 'status': 'status', 'hasSeniorityDate': 'hasSeniorityDate', 'groupings': 'groupings:object'
                        },
                        $filtersConfig: {
                            '$and': {
                                defaultValue: function () {
                                    // $log.log(angular.toJson(AppF.ccsByPayrollsOfUser));
                                    if (AppF.permissionToAccessAllPayrolls) {
                                        return undefined;
                                    } else {
                                        var ccArray = [];
                                        var payrollArray = [];
                                        if (angular.isArray(AppF.ccsByPayrollsOfUser)) {
                                            for (var j = 0; j < AppF.ccsByPayrollsOfUser.length; j++) {
                                                var thisPayroll = AppF.ccsByPayrollsOfUser[j];
                                                if (angular.isArray(thisPayroll.ccs)) {
                                                    if (thisPayroll.ccs.indexOf('all') > -1) {
                                                        payrollArray.push(thisPayroll.$id);
                                                    } else {
                                                        ccArray = ccArray.concat(thisPayroll.ccs);
                                                    }
                                                }
                                            }
                                        }
                                        var obj = angular.toJson([{ '$or': [{ cc: { $in: ccArray } }, { payroll: { $in: payrollArray } }] }]);
                                        return obj;
                                    }
                                }
                            },
                            'center': defCenterFn,
                            'groupings:object': {
                                specialFormat: 'objectId'
                            }
                        },
                        blanc: {
                            data: {
                                info: {
                                    emails: [
                                        // {
                                        //     active: true,
                                        //     type: 'Personal'
                                        // }
                                    ],
                                    beneficiaries: [
                                        // {}
                                    ],
                                    phones: [
                                        // {
                                        //     active: true,
                                        //     type: 'Celular'
                                        // }
                                    ],
                                    birth: {}
                                },
                                health: {},
                                salary: {}
                            },
                            movements: {},
                            movement: {},
                            active: true
                        },
                        $generalFilter: ["data.name", "data.nss"]
                    },
                    enroles: {
                        list: 'app.movements.enroles',
                        read: 'app.movements.enroles.read',
                        update: 'app.movements.enroles.update',
                        $alias: 'employee',
                        filter: {
                            by: 'status',
                            name: 'status2Employees',
                            scopeName: 'employees',
                            query: true,
                            val: 2
                        },
                        $$filter: [{
                            by: 'center',
                            val: centerFn
                        }, {
                            by: 'movement.type',
                            val: [6, 8]
                        }, {
                            by: 'cc',
                            val: function () {
                                var arrayOfIds = (AppF.permissionToAccessAllPayrolls) ?
                                    getArrayOfIdsFilter($rootScope.L.ccs) :
                                    getArrayOfIdsFilter($rootScope.L.userCcs[AppF.profile.uid]);
                                return arrayOfIds;
                            }
                        }],
                        $filters: ['rp', 'payroll']
                    },
                    dismissesRecords: {
                        list: 'app.movements.dismissesRecords',
                        read: 'app.movements.dismissesRecords.read',
                        update: 'app.movements.dismissesRecords.update',
                        $alias: 'employee',
                        filter: {
                            by: 'status',
                            name: 'status2Employees',
                            scopeName: 'employees',
                            query: true,
                            val: 2
                        },
                        $$filter: [{
                            by: 'center',
                            val: centerFn
                        }, {
                            by: 'movement.type',
                            val: 2
                        }, {
                            by: 'cc',
                            val: function () {
                                var arrayOfIds = (AppF.permissionToAccessAllPayrolls) ?
                                    getArrayOfIdsFilter($rootScope.L.ccs) :
                                    getArrayOfIdsFilter($rootScope.L.userCcs[AppF.profile.uid]);
                                return arrayOfIds;
                            }
                        }],
                        $filters: ['rp', 'payroll'],
                        blanc: {
                            data: {
                                rehirable: true
                            }
                        }
                    },
                    idseAutoRecords: {
                        list: 'app.movements.idseAutoRecords',
                        update: 'app.movements.idseAutoRecords.update',
                        $alias: 'movement',
                        $filters: ['rp', 'payroll'],
                        $generalFilter: ['info.name', 'info.nss', 'received.batch', 'received.tempBatch'],
                        tabs: {
                            enroleRecord: {
                                name: 'enroleRecord',
                                title: 'Altas',
                                pObject: 'EnroleRecord',
                                // permission: [{ action: 'edit', access: 'processes.operations' }]
                            },
                            mdsRecord: {
                                name: 'mdsRecord',
                                title: 'MDS',
                                pObject: 'MdsRecord',
                                // permission: [{ action: 'editSettlement', access: 'processes.operations' }]
                            },
                            dismissRecord: {
                                name: 'dismissRecord',
                                title: 'Bajas',
                                pObject: 'DismissRecord',
                                // permission: [{ action: 'editAsimilated', access: 'processes.operations' }]
                            },
                            idseRecord: {
                                name: 'idseRecord',
                                title: 'Enviados',
                                pObject: 'IdseRecords',
                                // permission: [{ action: 'editAdvAndLoanOpe', access: 'processes.operations' }]
                            },
                            acceptedRecord: {
                                name: 'acceptedRecord',
                                title: 'Aceptados',
                                pObject: 'acceptedRecord',
                                // permission: [{ action: 'editTravelExpensesOpe', access: 'processes.operations' }]
                            },
                            deniedRecord: {
                                name: 'deniedRecord',
                                title: 'Rechazados',
                                pObject: 'deniedRecord',
                                permission: [{ action: 'editChrisBonusRecord', access: 'processes.operations' }]
                            }
                        },
                        $filtersConfig: {
                            'center': defCenterFn,
                            'info.nss': {
                                defaultValue: function () {
                                    return JSON.stringify({ $exists: true })
                                }
                            },
                            'status': {
                                defaultValue: function (tabConfig) {
                                    if (angular.isDefined(tabConfig)) {
                                        if (['enroleRecord', 'mdsRecord'].indexOf(tabConfig.name) > -1) {
                                            return { $gte: 2, $lt: 3 }
                                        } else if (['dismissRecord'].indexOf(tabConfig.name) > -1) {
                                            return 2
                                        } else if (tabConfig.name === 'idseRecord') {
                                            return 3;
                                        } else if (['deniedRecord'].indexOf(tabConfig.name) > -1) {
                                            return { $gt: 3, $lt: 4 }
                                        } else if (['acceptedRecord'].indexOf(tabConfig.name) > -1) {
                                            return 4;
                                        } else {
                                            return 0;
                                        }
                                    } else {
                                        return 0
                                    }
                                }
                            },
                            'data.type': {
                                defaultValue: function (tabConfig) {
                                    if (angular.isDefined(tabConfig)) {
                                        if (tabConfig.name === 'enroleRecord') {
                                            return [6, 8]
                                        } else if (tabConfig.name === 'mdsRecord') {
                                            return 7;
                                        } else if (tabConfig.name === 'dismissRecord') {
                                            return 2;
                                        } else if (['idseRecord', 'acceptedRecord', 'deniedRecord'].indexOf(tabConfig.name) > -1) {
                                            return undefined
                                        } else {
                                            return 0;
                                        }
                                    } else {
                                        return 0
                                    }
                                }
                            },
                            'archived.hasConfirmationData': {
                                defaultValue: function (tabConfig) {
                                    if (angular.isDefined(tabConfig) && tabConfig.name === 'acceptedRecord') {
                                        return true;
                                    }
                                    return undefined;
                                }
                            },
                            '$and': andFn
                        }

                    },
                    dismissesUnconfirmedRecords: {
                        list: 'app.movements.dismissesUnconfirmedRecords',
                        read: 'app.movements.dismissesUnconfirmedRecords.read',
                        update: 'app.movements.dismissesUnconfirmedRecords.update',
                        $alias: 'employee',
                        filter: {
                            by: 'status',
                            name: 'status22Employees',
                            scopeName: 'employees',
                            query: true,
                            val: 2.2
                        },
                        $$filter: [{
                            by: 'movement.type',
                            val: 2
                        }, {
                            by: 'cc',
                            val: function () {
                                var arrayOfIds = (AppF.permissionToAccessAllPayrolls) ?
                                    getArrayOfIdsFilter($rootScope.L.ccs) :
                                    getArrayOfIdsFilter($rootScope.L.userCcs[AppF.profile.uid]);
                                return arrayOfIds;
                            }
                        }],
                        $filters: ['rp', 'payroll'],
                        blanc: {
                            data: {
                                rehirable: true
                            }
                        }
                    },
                    mdsRecords: {
                        list: 'app.movements.mdsRecords',
                        read: 'app.movements.mdsRecords.read',
                        update: 'app.movements.mdsRecords.update',
                        $alias: 'employee',
                        filter: {
                            by: 'status',
                            name: 'status2Employees',
                            scopeName: 'employees',
                            query: true,
                            val: 2
                        },
                        $$filter: [{
                            by: 'center',
                            val: centerFn
                        }, {
                            by: 'movement.type',
                            val: 7
                        }, {
                            by: 'cc',
                            val: function () {
                                var arrayOfIds = (AppF.permissionToAccessAllPayrolls) ?
                                    getArrayOfIdsFilter($rootScope.L.ccs) :
                                    getArrayOfIdsFilter($rootScope.L.userCcs[AppF.profile.uid]);
                                return arrayOfIds;
                            }
                        }],
                        $filters: ['rp', 'payroll']
                    },
                    variables: {
                        list: 'app.movements.variables',
                        read: 'app.movements.variables.read',
                        $alias: 'employee',
                        filter: {
                            by: 'status',
                            name: 'status21Employees',
                            scopeName: 'employees',
                            query: true,
                            val: 2.1
                        },
                        $$filter: [{
                            by: 'center',
                            val: centerFn
                        }, {
                            by: 'movement.type',
                            val: 7
                        }, {
                            by: 'cc',
                            val: function () {
                                var arrayOfIds = (AppF.permissionToAccessAllPayrolls) ?
                                    getArrayOfIdsFilter($rootScope.L.ccs) :
                                    getArrayOfIdsFilter($rootScope.L.userCcs[AppF.profile.uid]);
                                return arrayOfIds;
                            }
                        }],
                        $filters: ['rp', 'payroll']
                    },
                    idseRecords: {
                        $alias: 'movement',
                        list: 'app.movements.idseRecords',
                        read: 'app.movements.idseRecords.read',
                        filter: {
                            by: 'status',
                            name: 'status3Employees',
                            scopeName: 'idseRecords',
                            query: true,
                            val: 3
                        },
                        $$filter: [{
                            by: 'center',
                            val: centerFn
                        }, {
                            by: 'cc',
                            val: function () {
                                var arrayOfIds = (AppF.permissionToAccessAllPayrolls) ?
                                    getArrayOfIdsFilter($rootScope.L.ccs) :
                                    getArrayOfIdsFilter($rootScope.L.userCcs[AppF.profile.uid]);
                                return arrayOfIds;
                            }
                        }],
                        $filters: ['rp', 'cc', 'data.type']
                    },
                    revisions: {
                        list: 'app.movements.revisions',
                        review: 'app.movements.revisions.review',
                        $alias: 'employee',
                        filter: {
                            by: 'status',
                            name: 'status1Employees',
                            scopeName: 'employees',
                            query: true,
                            val: 1
                        },
                        $$filter: [{
                            by: 'center',
                            val: centerFn
                        }, {
                            by: 'payroll',
                            val: function () {
                                var arrayOfIds = (AppF.permissionToAccessAllPayrolls) ?
                                    getArrayOfIdsFilter($rootScope.L.allPayrolls) :
                                    getArrayOfIdsFilter($rootScope.L.payrolls);
                                return arrayOfIds;
                            }
                        }, {
                            by: 'cc',
                            val: function () {
                                var arrayOfIds = (AppF.permissionToAccessAllPayrolls) ?
                                    getArrayOfIdsFilter($rootScope.L.ccs) :
                                    getArrayOfIdsFilter($rootScope.L.userCcs[AppF.profile.uid]);
                                return arrayOfIds;
                            }
                        }],
                        $filters: ['rp', 'cc', 'movement.type']
                    },
                    aniversaryRecords: {
                        list: 'app.movements.aniversaryRecords',
                        read: 'app.movements.aniversaryRecords.read',
                        apply: 'app.movements.aniversaryRecords.apply',
                        filter: {
                            by: 'center',
                            principal: true,
                            name: 'aniversaryRecords',
                            scopeName: 'aniversaryRecords',
                            query: true,
                            val: centerFn
                        },
                        $$filter: [{
                            by: 'cc',
                            val: function () {
                                var arrayOfIds = (AppF.permissionToAccessAllPayrolls) ?
                                    getArrayOfIdsFilter($rootScope.L.ccs) :
                                    getArrayOfIdsFilter($rootScope.L.userCcs[AppF.profile.uid]);
                                return arrayOfIds;
                            }
                        }],
                        $filters: ['payroll', 'rp', 'cc']
                    },
                    healthcareRecords: {
                        list: 'app.captures.healthcareRecords',
                        read: 'app.captures.healthcareRecords.read',
                        $alias: 'employee',
                        $filters: ['rp', 'payroll', 'cc', 'status'],
                        $filtersConfig: {
                            'center': defCenterFn,
                            'data.health.benefit': {
                                defaultValue: function () {
                                    return { $in: [1, true] }
                                }
                            },
                            '$and': {
                                defaultValue: function () {
                                    // $log.log(angular.toJson(AppF.ccsByPayrollsOfUser));
                                    if (AppF.permissionToAccessAllPayrolls) {
                                        return undefined;
                                    } else {
                                        var ccArray = [];
                                        var payrollArray = [];
                                        if (angular.isArray(AppF.ccsByPayrollsOfUser)) {
                                            for (var j = 0; j < AppF.ccsByPayrollsOfUser.length; j++) {
                                                var thisPayroll = AppF.ccsByPayrollsOfUser[j];
                                                if (angular.isArray(thisPayroll.ccs)) {
                                                    if (thisPayroll.ccs.indexOf('all') > -1) {
                                                        payrollArray.push(thisPayroll.$id);
                                                    } else {
                                                        ccArray = ccArray.concat(thisPayroll.ccs);
                                                    }
                                                }
                                            }
                                        }
                                        var obj = angular.toJson([{ '$or': [{ cc: { $in: ccArray } }, { payroll: { $in: payrollArray } }] }]);
                                        return obj;
                                    }
                                }
                            }
                        },
                        $generalFilter: ['data.name', 'data.nss', 'data.health.certificate:number']
                    },
                    employeesVacationsRecords: {
                        list: 'app.rh.employeesVacationsRecords',
                        update: 'app.rh.employeesVacationsRecords.update',
                        read: 'app.rh.employeesVacationsRecords.read',
                        $alias: 'employee',
                        $filters: ['rp', 'payroll', 'cc', 'status'],
                        $filtersConfig: {
                            'center': defCenterFn,
                            '$and': {
                                defaultValue: function () {
                                    if (AppF.permissionToAccessAllPayrolls) {
                                        return undefined;
                                    } else {
                                        var ccArray = [];
                                        var payrollArray = [];
                                        if (angular.isArray(AppF.ccsByPayrollsOfUser)) {
                                            for (var j = 0; j < AppF.ccsByPayrollsOfUser.length; j++) {
                                                var thisPayroll = AppF.ccsByPayrollsOfUser[j];
                                                if (angular.isArray(thisPayroll.ccs)) {
                                                    if (thisPayroll.ccs.indexOf('all') > -1) {
                                                        payrollArray.push(thisPayroll.$id);
                                                    } else {
                                                        ccArray = ccArray.concat(thisPayroll.ccs);
                                                    }
                                                }
                                            }
                                        }
                                        var obj = angular.toJson([{ '$or': [{ cc: { $in: ccArray } }, { payroll: { $in: payrollArray } }] }]);
                                        return obj;
                                    }
                                }
                            },
                            'data.nss': {
                                defaultValue: function () {
                                    return { $exists: true }
                                }
                            }
                        },
                        $generalFilter: ['data.name', 'data.nss']
                    },
                    employeeFiles: {
                        list: 'app.rh.employeeFiles',
                        update: 'app.rh.employeeFiles.update',
                        read: 'app.rh.employeeFiles.read',
                        $alias: 'employee',
                        $filters: ['rp', 'payroll', 'cc', 'status'],
                        $filtersConfig: {
                            'center': defCenterFn,
                            '$and': {
                                defaultValue: function () {
                                    if (AppF.permissionToAccessAllPayrolls) {
                                        return undefined;
                                    } else {
                                        var ccArray = [];
                                        var payrollArray = [];
                                        if (angular.isArray(AppF.ccsByPayrollsOfUser)) {
                                            for (var j = 0; j < AppF.ccsByPayrollsOfUser.length; j++) {
                                                var thisPayroll = AppF.ccsByPayrollsOfUser[j];
                                                if (angular.isArray(thisPayroll.ccs)) {
                                                    if (thisPayroll.ccs.indexOf('all') > -1) {
                                                        payrollArray.push(thisPayroll.$id);
                                                    } else {
                                                        ccArray = ccArray.concat(thisPayroll.ccs);
                                                    }
                                                }
                                            }
                                        }
                                        var obj = angular.toJson([{ '$or': [{ cc: { $in: ccArray } }, { payroll: { $in: payrollArray } }] }]);
                                        return obj;
                                    }
                                }
                            }
                        },
                        $generalFilter: ['data.name', 'data.nss']
                    },
                    personalInfoEmployees: {
                        list: 'app.rh.personalInfoEmployees',
                        update: 'app.rh.personalInfoEmployees.update',
                        read: 'app.rh.personalInfoEmployees.read',
                        $alias: 'employee',
                        $filters: ['rp', 'payroll', 'cc'],
                        $filtersConfig: {
                            'center': defCenterFn,
                            '$and': {
                                defaultValue: function () {
                                    if (AppF.permissionToAccessAllPayrolls) {
                                        return undefined;
                                    } else {
                                        var ccArray = [];
                                        var payrollArray = [];
                                        if (angular.isArray(AppF.ccsByPayrollsOfUser)) {
                                            for (var j = 0; j < AppF.ccsByPayrollsOfUser.length; j++) {
                                                var thisPayroll = AppF.ccsByPayrollsOfUser[j];
                                                if (angular.isArray(thisPayroll.ccs)) {
                                                    if (thisPayroll.ccs.indexOf('all') > -1) {
                                                        payrollArray.push(thisPayroll.$id);
                                                    } else {
                                                        ccArray = ccArray.concat(thisPayroll.ccs);
                                                    }
                                                }
                                            }
                                        }
                                        var obj = angular.toJson([{ '$or': [{ cc: { $in: ccArray } }, { payroll: { $in: payrollArray } }] }]);
                                        return obj;
                                    }
                                }
                            }
                        },
                        $generalFilter: ['data.name', 'data.nss']
                    },
                    noEmployees: {
                        list: 'app.captures.noEmployees',
                        read: 'app.captures.noEmployees.read',
                        $alias: 'employee',
                        $generalFilter: ['data.name', 'data.nss', 'data.employeeNumber:number'],
                        $filters: ['payroll', 'cc', 'status'],
                        $filtersConfig: {
                            'center': defCenterFn,
                            'status': {
                                defaultValue: function () {
                                    return [2, 2.1, 3, 3.5, 4, 5];
                                }
                            },
                            '$and': {
                                defaultValue: function () {
                                    // $log.log(angular.toJson(AppF.ccsByPayrollsOfUser));
                                    if (AppF.permissionToAccessAllPayrolls) {
                                        return undefined;
                                    } else {
                                        var ccArray = [];
                                        var payrollArray = [];
                                        if (angular.isArray(AppF.ccsByPayrollsOfUser)) {
                                            for (var j = 0; j < AppF.ccsByPayrollsOfUser.length; j++) {
                                                var thisPayroll = AppF.ccsByPayrollsOfUser[j];
                                                if (angular.isArray(thisPayroll.ccs)) {
                                                    if (thisPayroll.ccs.indexOf('all') > -1) {
                                                        payrollArray.push(thisPayroll.$id);
                                                    } else {
                                                        ccArray = ccArray.concat(thisPayroll.ccs);
                                                    }
                                                }
                                            }
                                        }
                                        var obj = angular.toJson([{ '$or': [{ cc: { $in: ccArray } }, { payroll: { $in: payrollArray } }] }]);
                                        return obj;
                                    }
                                }
                            }
                        }
                    },
                    employeeBirths: {
                        list: 'app.rh.employeeBirths',
                        read: 'app.rh.employeeBirths.read',
                        $alias: 'employee',
                        $generalFilter: ['data.name', 'data.nss', 'data.employeeNumber:number'],
                        $filters: {
                            'payroll': 'payroll',
                            'cc': 'cc',
                            'rp': 'rp',
                            'monthBirth': 'data.info.birth.month:int'
                        },
                        $filtersConfig: {
                            'center': defCenterFn,
                            'status': {
                                defaultValue: function () {
                                    return { $ne: 5 };
                                }
                            },
                            '$and': {
                                defaultValue: function () {
                                    // $log.log(angular.toJson(AppF.ccsByPayrollsOfUser));
                                    if (AppF.permissionToAccessAllPayrolls) {
                                        return undefined;
                                    } else {
                                        var ccArray = [];
                                        var payrollArray = [];
                                        if (angular.isArray(AppF.ccsByPayrollsOfUser)) {
                                            for (var j = 0; j < AppF.ccsByPayrollsOfUser.length; j++) {
                                                var thisPayroll = AppF.ccsByPayrollsOfUser[j];
                                                if (angular.isArray(thisPayroll.ccs)) {
                                                    if (thisPayroll.ccs.indexOf('all') > -1) {
                                                        payrollArray.push(thisPayroll.$id);
                                                    } else {
                                                        ccArray = ccArray.concat(thisPayroll.ccs);
                                                    }
                                                }
                                            }
                                        }
                                        var obj = angular.toJson([{ '$or': [{ cc: { $in: ccArray } }, { payroll: { $in: payrollArray } }] }]);
                                        return obj;
                                    }
                                }
                            },
                            'data.info.birth.month:int': {
                                defaultValue: function () {
                                    return null;
                                }
                            }
                        }
                    },
                    anniversaryEmployees: {
                        list: 'app.rh.anniversaryEmployees',
                        read: 'app.rh.anniversaryEmployees.read',
                        $alias: 'employee',
                        $generalFilter: ['data.name', 'data.nss', 'data.employeeNumber:number'],
                        $filters: {
                            'payroll': 'payroll',
                            'cc': 'cc',
                            'rp': 'rp',
                            // 'status': 'status',
                            'monthBirth': 'data.anniversary.month:int'
                        },
                        $filtersConfig: {
                            'center': defCenterFn,
                            'status': {
                                defaultValue: function () {
                                    return { $ne: 5 };
                                }
                            },
                            '$and': {
                                defaultValue: function () {
                                    // $log.log(angular.toJson(AppF.ccsByPayrollsOfUser));
                                    if (AppF.permissionToAccessAllPayrolls) {
                                        return undefined;
                                    } else {
                                        var ccArray = [];
                                        var payrollArray = [];
                                        if (angular.isArray(AppF.ccsByPayrollsOfUser)) {
                                            for (var j = 0; j < AppF.ccsByPayrollsOfUser.length; j++) {
                                                var thisPayroll = AppF.ccsByPayrollsOfUser[j];
                                                if (angular.isArray(thisPayroll.ccs)) {
                                                    if (thisPayroll.ccs.indexOf('all') > -1) {
                                                        payrollArray.push(thisPayroll.$id);
                                                    } else {
                                                        ccArray = ccArray.concat(thisPayroll.ccs);
                                                    }
                                                }
                                            }
                                        }
                                        var obj = angular.toJson([{ '$or': [{ cc: { $in: ccArray } }, { payroll: { $in: payrollArray } }] }]);
                                        return obj;
                                    }
                                }
                            },
                            'data.anniversary.month:int': {
                                defaultValue: function () {
                                    return null;
                                }
                            }
                        }
                    },
                    syncEmployeeRecords: {
                        list: 'app.apps-sync.syncEmployeeRecords',
                        $alias: 'employee',
                        $generalFilter: ['data.name', 'data.nss', 'data.employeeNumber:number'],
                        $filters: {
                            'apps': 'sync.execute',
                            'payroll': 'payroll',
                            'hasError': 'sync.error'
                        },
                        $filtersConfig: {
                            'sync.execute': {
                                required: function () {
                                    return true
                                },
                                specialFormat: 'existsField',
                                specialKey: 'existsKey'
                            },
                            'sync.error': {
                                specialKey: 'concatOtherValue:sync.execute'
                            },
                            'center': defCenterFn,
                            '$and': {
                                defaultValue: function () {
                                    // $log.log(angular.toJson(AppF.ccsByPayrollsOfUser));
                                    if (AppF.permissionToAccessAllPayrolls) {
                                        return undefined;
                                    } else {
                                        var ccArray = [];
                                        var payrollArray = [];
                                        if (angular.isArray(AppF.ccsByPayrollsOfUser)) {
                                            for (var j = 0; j < AppF.ccsByPayrollsOfUser.length; j++) {
                                                var thisPayroll = AppF.ccsByPayrollsOfUser[j];
                                                if (angular.isArray(thisPayroll.ccs)) {
                                                    if (thisPayroll.ccs.indexOf('all') > -1) {
                                                        payrollArray.push(thisPayroll.$id);
                                                    } else {
                                                        ccArray = ccArray.concat(thisPayroll.ccs);
                                                    }
                                                }
                                            }
                                        }
                                        var obj = angular.toJson([{ '$or': [{ cc: { $in: ccArray } }, { payroll: { $in: payrollArray } }] }]);
                                        return obj;
                                    }
                                }
                            }
                        }
                    },
                    kardexEmployees: {
                        list: 'app.rh.kardexEmployees',
                        read: 'app.rh.kardexEmployees.read',
                        $alias: 'employee',
                        $generalFilter: ['data.name', 'data.nss', 'data.employeeNumber:number'],
                        $filters: ['payroll', 'cc', 'status'],
                        $filtersConfig: {
                            'center': defCenterFn,
                            'status': {
                                defaultValue: function () {
                                    return JSON.stringify({ $ne: 5 })
                                }
                            },
                            '$and': {
                                defaultValue: function () {
                                    // $log.log(angular.toJson(AppF.ccsByPayrollsOfUser));
                                    if (AppF.permissionToAccessAllPayrolls) {
                                        return undefined;
                                    } else {
                                        var ccArray = [];
                                        var payrollArray = [];
                                        if (angular.isArray(AppF.ccsByPayrollsOfUser)) {
                                            for (var j = 0; j < AppF.ccsByPayrollsOfUser.length; j++) {
                                                var thisPayroll = AppF.ccsByPayrollsOfUser[j];
                                                if (angular.isArray(thisPayroll.ccs)) {
                                                    if (thisPayroll.ccs.indexOf('all') > -1) {
                                                        payrollArray.push(thisPayroll.$id);
                                                    } else {
                                                        ccArray = ccArray.concat(thisPayroll.ccs);
                                                    }
                                                }
                                            }
                                        }
                                        var obj = angular.toJson([{ '$or': [{ cc: { $in: ccArray } }, { payroll: { $in: payrollArray } }] }]);
                                        return obj;
                                    }
                                }
                            }
                        }
                    },

                    realSalaryRecords: {
                        list: 'app.captures.realSalaryRecords',
                        read: 'app.captures.realSalaryRecords.read',
                        $alias: 'employee',
                        $generalFilter: ["data.nss", "data.name", "data.employeeNumber:number"],
                        $filters: ['rp', 'payroll', 'cc', 'status'], // movement.type
                        $filtersConfig: {
                            'center': defCenterFn,
                            '$and': {
                                defaultValue: function () {
                                    if (AppF.permissionToAccessAllPayrolls) {
                                        return undefined;
                                    } else {
                                        var ccArray = [];
                                        var payrollArray = [];
                                        if (angular.isArray(AppF.ccsByPayrollsOfUser)) {
                                            for (var j = 0; j < AppF.ccsByPayrollsOfUser.length; j++) {
                                                var thisPayroll = AppF.ccsByPayrollsOfUser[j];
                                                if (angular.isArray(thisPayroll.ccs)) {
                                                    if (thisPayroll.ccs.indexOf('all') > -1) {
                                                        payrollArray.push(thisPayroll.$id);
                                                    } else {
                                                        ccArray = ccArray.concat(thisPayroll.ccs);
                                                    }
                                                }
                                            }
                                        }
                                        var obj = angular.toJson([{ '$or': [{ cc: { $in: ccArray } }, { payroll: { $in: payrollArray } }] }]);
                                        return obj;
                                    }
                                }
                            }
                        }
                    },
                    enroleAccounts: {
                        list: 'app.movements.enroleAccounts',
                        // read: 'app.movements.enroleAccounts.read',
                        // $alias: 'employee',
                        moreColumns: [{
                            path: "data.cards.0.comments", name: "Comentario", type: "string", rute: 'catalogs/employees/collection', editable: function (object) {
                                return true;
                            }, defaultValue: ''
                        }],
                        filter: {
                            by: 'data/cards/0/emmitedYet',
                            name: 'needEmmitionEmployees',
                            scopeName: 'enroleAccounts',
                            query: true,
                            val: false
                        },
                        $$filter: [{
                            by: 'center',
                            val: centerFn
                        }, {
                            by: 'status',
                            val: [1, 2, 3, 4]
                        }, {
                            by: 'cc',
                            val: function () {
                                return getArrayOfIdsFilter(AppF.permissionToAccessAllPayrolls ? $rootScope.L.ccs : $rootScope.L.userCcs[AppF.profile.uid]);
                            }
                        }],
                        $filters: ['rp']
                    },
                    logs: {
                        list: 'app.movements.logs',
                        filter: {
                            by: 'data.payroll',
                            restrictAll: false,
                            alias: 'F.search.$payroll',
                            name: 'payrollEmployees',
                            scopeName: 'logs',
                            query: true,
                            val: function () {
                                return 'all'
                            }
                        },
                        $generalFilter: ['activeSearchText'],
                        $filters: {
                            'action': 'action',
                            'profile': 'from.by',
                            'fromDate': 'from.atTime.$gte',
                            'toDate': 'from.atTime.$lte'
                        },
                        $filtersConfig: {
                            'from.atTime.$gte': {
                                specialKey: 'lastKeyObject'
                            },
                            'from.atTime.$lte': {
                                specialKey: 'lastKeyObject'
                            }
                        },
                        blanc: {}
                    },
                    movements: {
                        list: 'app.movements.movements',
                        read: 'app.movements.movements.read',
                        update: 'app.movements.movements.update',
                        createHistoricMovement: 'app.movements.movements.createHistoricMovement',
                        moreColumns: [
                            { path: "received.batch", name: "Lote", type: "string" }
                        ],
                        $generalFilter: ["info.name", "info.nss", "received.batch"],
                        filter: {
                            by: 'payroll',
                            restrictAll: true,
                            name: 'payrollEmployees',
                            scopeName: 'movements',
                            query: true,
                            val: function () {
                                return AppF.search.$payroll
                            }
                        },
                        $filters: {
                            'payroll': 'payroll',
                            'movementType': 'data.type',
                            'fromDate': 'data.date.$gte',
                            'toDate': 'data.date.$lte',
                            'status': 'status'
                        },
                        $filtersConfig: {
                            'center': defCenterFn,
                            'data.date.$gte': {
                                specialKey: 'lastKeyObject'
                            },
                            'data.date.$lte': {
                                specialKey: 'lastKeyObject'
                            },
                            'status': {
                                defaultValue: function (tabConfig) {
                                    return [4, 3]
                                }
                            },
                            '$and': {
                                defaultValue: function () {
                                    // $log.log(angular.toJson(AppF.ccsByPayrollsOfUser));
                                    if (AppF.permissionToAccessAllPayrolls) {
                                        return undefined;
                                    } else {
                                        var ccArray = [];
                                        var payrollArray = [];
                                        if (angular.isArray(AppF.ccsByPayrollsOfUser)) {
                                            for (var j = 0; j < AppF.ccsByPayrollsOfUser.length; j++) {
                                                var thisPayroll = AppF.ccsByPayrollsOfUser[j];
                                                if (angular.isArray(thisPayroll.ccs)) {
                                                    if (thisPayroll.ccs.indexOf('all') > -1) {
                                                        payrollArray.push(thisPayroll.$id);
                                                    } else {
                                                        ccArray = ccArray.concat(thisPayroll.ccs);
                                                    }
                                                }
                                            }
                                        }
                                        var obj = angular.toJson([{ '$or': [{ cc: { $in: ccArray } }, { payroll: { $in: payrollArray } }] }]);
                                        return obj;
                                    }
                                }
                            }
                        },
                        blanc: {}
                    },
                    credits: {
                        list: 'app.captures.credits',
                        create: 'app.captures.credits.create',
                        read: 'app.captures.credits.read',
                        update: 'app.captures.credits.update',
                        $generalFilter: ["data.name", "data.nss", "data.account"],
                        $filters: { 'payroll': 'payroll', 'cc': 'cc', 'creditStatus': 'valid', 'diffFactor': 'data/diffFactor' },
                        $filtersConfig: {
                            'data/diffFactor': {
                                specialKey: 'replaceDots'
                            },
                            'center': defCenterFn,
                            '$and': {
                                defaultValue: function () {
                                    if (AppF.permissionToAccessAllPayrolls) {
                                        return undefined;
                                    } else {
                                        var ccArray = [];
                                        var payrollArray = [];
                                        if (angular.isArray(AppF.ccsByPayrollsOfUser)) {
                                            for (var j = 0; j < AppF.ccsByPayrollsOfUser.length; j++) {
                                                var thisPayroll = AppF.ccsByPayrollsOfUser[j];
                                                if (angular.isArray(thisPayroll.ccs)) {
                                                    if (thisPayroll.ccs.indexOf('all') > -1) {
                                                        payrollArray.push(thisPayroll.$id);
                                                    } else {
                                                        ccArray = ccArray.concat(thisPayroll.ccs);
                                                    }
                                                }
                                            }
                                        }
                                        var obj = angular.toJson([{ '$or': [{ cc: { $in: ccArray } }, { payroll: { $in: payrollArray } }] }]);
                                        return obj;
                                    }
                                }
                            }
                        },
                        blanc: {
                            data: {},
                            valid: true
                        }
                    },
                    groupings: {
                        list: 'app.captures.groupings',
                        update: 'app.captures.groupings.update',
                        read: 'app.captures.groupings.read',
                        images: 2,
                        filter: {
                            by: 'center',
                            name: 'centerGrouping',
                            scopeName: 'groupings',
                            query: true,
                            val: centerFn
                        },
                        $filters: []
                    },
                    loans: {
                        list: 'app.captures.loans',
                        create: 'app.captures.loans.create',
                        read: 'app.captures.loans.read',
                        update: 'app.captures.loans.update',
                        filter: {
                            by: 'center',
                            name: 'centerLoan',
                            scopeName: 'loans',
                            query: true,
                            val: centerFn
                        },
                        $$filter: [{
                            by: 'payroll',
                            val: function () {
                                var arrayOfIds = (AppF.permissionToAccessAllPayrolls) ?
                                    getArrayOfIdsFilter($rootScope.L.allPayrolls) :
                                    getArrayOfIdsFilter($rootScope.L.payrolls);
                                return arrayOfIds;
                            }
                        }
                        ],
                        $filters: ['payroll', 'loanStatus'],
                        $filtersConfig: {
                            'loanStatus': {
                                'replace': 'valid',
                                'allowFalse': true
                            }
                        },
                        blanc: {
                            data: {},
                            valid: true
                        }
                    }
                }
            },
            // TODO:backlog hacer que se pinten dinamicamente los md-tables y los forms con una configuración aqui y pasar todos los inputs a directivas para poder invocarlos
            fields: {
                employees: {
                    nss: {
                        title: 'Número de Seguridad Social'
                    },
                    sd: {
                        title: 'Salario Diario'
                    },
                    sbc: {
                        title: 'Salario Base Cotización'
                    },
                    name: {
                        title: 'Nombre Completo de Empleado'
                    },
                    enroleDate: {
                        title: 'Última Fecha de Alta'
                    },
                    dismissDate: {
                        title: 'Última Fecha de Baja'
                    },
                    mdsDate: {
                        title: 'Última Fecha de Modificación de Salario'
                    },
                    status: {
                        title: 'Status del Movimiento Actual del Empleado'
                    }
                }
            },
            filtersBy: {
                // TODO: Búsqueda avanzada para créditos
                credits: [{
                    name: 'nombre',
                    label: 'nombre o nss',
                    default: true,
                    orderBy: 'data/name',
                    uppercased: true
                }, {
                    name: 'rp',
                    orderBy: 'rp'
                }],
                noEmployees: [{
                    name: 'nombre',
                    label: 'nombre o nss',
                    default: true,
                    orderBy: 'data/name',
                    uppercased: true
                }],
                employeeBirths: [{
                    name: 'nombre',
                    label: 'nombre o nss',
                    default: true,
                    orderBy: 'data/name',
                    uppercased: true
                }],
                anniversaryEmployees: [{
                    name: 'nombre',
                    label: 'nombre o nss',
                    default: true,
                    orderBy: 'data/name',
                    uppercased: true
                }],
                kardexEmployees: [{
                    name: 'nombre',
                    label: 'nombre o nss',
                    default: true,
                    orderBy: 'data/name',
                    uppercased: true
                }],
                syncEmployeeRecords: [{
                    name: 'nombre',
                    label: 'nombre o nss',
                    default: true,
                    orderBy: 'data/name',
                    uppercased: true
                }],
                healthcareRecords: [{
                    name: 'nombre',
                    label: 'nombre o nss',
                    default: true,
                    orderBy: 'data/name',
                    uppercased: true
                }, {
                    name: 'rp',
                    orderBy: 'rp'
                }, {
                    name: 'certificado',
                    orderBy: 'data/health/certificate',
                    number: true
                }],
                employeesVacationsRecords: [{
                    name: 'nombre',
                    label: 'nombre o nss',
                    default: true,
                    orderBy: 'data/name',
                    uppercased: true
                }, {
                    name: 'rp',
                    orderBy: 'rp'
                }],
                employeeFiles: [{
                    name: 'nombre',
                    label: 'nombre o nss',
                    default: true,
                    orderBy: 'data/name',
                    uppercased: true
                }, {
                    name: 'rp',
                    orderBy: 'rp'
                }],
                personalInfoEmployees: [{
                    name: 'nombre',
                    label: 'nombre o nss',
                    default: true,
                    orderBy: 'data/name',
                    uppercased: true
                }, {
                    name: 'rp',
                    orderBy: 'rp'
                }],
                movements: [{
                    name: 'nombre',
                    label: 'nombre, nss o lote',
                    default: true,
                    orderBy: 'info/name',
                    uppercased: true
                },],
                incidencesTypes: [{
                    name: 'nombre',
                    orderBy: 'name',
                    uppercased: true
                }],
                employees: [{
                    name: 'nombre',
                    label: 'nombre o nss',
                    default: true,
                    orderBy: 'data/name',
                    uppercased: true
                }, {
                    name: 'rp',
                    orderBy: 'rp'
                }, {
                    name: 'cc',
                    orderBy: 'cc'
                }, {
                    name: 'nomina',
                    orderBy: 'payroll'
                }]
            },
            listOrder: {
                credits: '-created.atTime',
                employees: '-created.atTime',
                ccs: '+data.name',
                companiesRecords: '+data.name',
                firms: '+data.name',
                incidences: '-date',
                incidencesRequests: ['+calendar', '+period'],
                payrollCalendars: '+data.startDate',
                payrolls: '+data.class',
                periods: '+period',
                positions: '+data.name',
                departments: '+data.name',
                projects: '+data.name',
                rps: '+data.shortName',
                closeOperations: '-date',
                groups: '+order',
                concepts: '+key',
                imports: '-date',
                incidencesTypes: '+name',
                attendanceLists: 'period',
                involvedRecords: '+"payroll-name"',
                paymentSchemas: '-data.name',
                users: ['-firm', '+data.name'],
                aniversariesRecords: '+data.name',
                dismissesRecords: ['+data.dismissDate', '+data.name'],
                idseAutoRecords: ['+received.batch', '+data.date', '+info.name'],
                dismissesUnconfirmedRecords: ['+data.dismissDate', '+data.name'],
                enroleAccounts: '+data.name',
                enroles: ['+data.enroleDate', '+data.name'],
                healthcareRecords: '-created.atTime',
                employeesVacationsRecords: '-created.atTime',
                employeeFiles: '-created.atTime',
                idseRecords: '+received.atTime',
                mdsRecords: '+data.mdsDate',
                movements: 'data.date',
                logs: '-from.atTime',
                noEmployees: '-created.atTime',
                employeeBirths: '-created.atTime',
                anniversaryEmployees: '-created.atTime',
                kardexEmployees: ['-data.enroleDate', '+data.name'],
                syncEmployeeRecords: '-created.atTime',
                realSalaryRecords: '-created.atTime',
                revisions: '+data.name',
                variables: ['+movement.date', '+data.name'],
                // mongo
                banks: '+name',
                bankAccounts: '+name',
                bills: '-created_at',
                xmlSatMetas: '-endDate',
                countriesRecords: '+name',
                directives: '+name',
                dismissTypes: '+name',
                geoZones: '+name',
                imssRecords: '-year',
                incidencesStatusRecords: '+name',
                isrRecords: ['-year', '-type', '+lowerLimit'],
                cyvRecords: ['-year', '+lowerLimit'],
                issuers: '+name',
                minimumWageRecords: '-year',
                monthForAccumulatedRecords: '+name',
                nfdRecords: '-year',
                paymentFrequenciesRecords: '+name',
                paymentGroups: '+name',
                placesOfWorkRecords: '+name',
                regimes: '+name',
                relationships: '+name',
                zipCodes: '+name',
                accountingAccounts: '+name',
                accountAccVars: '+name',
                placeTypes: '+name',
                societyTypes: '+name',
                riskClassesRecords: '+name',
                salaryTypes: '+name',
                states: '+name',
                streetTypes: '+name',
                subsidyRecords: ['-year', '-type', '+lowerLimit'],
                towns: ['+state_id', '+name'],
                umaRecords: '-year',
                unions: '+name',
                workDays: '+name',
                workerTypes: '+name'
            },
            // catalog lists will be populated with asociated names
            relations: {
                logs: {
                    fromBy: {
                        path: "from.by",
                        queryIn: 'profiles',
                        key: 'data/name'
                    },
                    dataArray: {
                        justSetField: function (item) {
                            var thisArray = [];
                            if (item.v != '2.0') {
                                thisArray = $filter('migrateLogs')(item.data)
                            } else if (['create', 'add', 'remove', 'delete'].indexOf(item.action) > -1 && angular.isArray(item.data)) {
                                for (var i = 0; i < item.data.length; i++) {
                                    if (item.data[i].rhs) {
                                        thisArray = thisArray.concat($filter('migrateLogs')(item.data[i].rhs))
                                    }
                                    if (item.data[i].lhs) {
                                        thisArray = thisArray.concat($filter('migrateLogs')(item.data[i].lhs))
                                    }
                                }
                            }
                            return thisArray;
                        }
                    }
                },
                xmlBillsRequests: {
                    companiesRecord: {
                        fromList: 'companiesRecords',
                        key: 'name'
                    }
                },
                minimumWageRecords: {
                    valuesArray: {
                        justSetField: function (item) {
                            var thisArray = [];
                            if (angular.isObject(item.values)) {
                                thisArray = $filter('objsToArray')(item.values)
                            }
                            return thisArray;

                        }
                    }
                },
                humandCatalogs: {
                    firm: {
                        fromList: 'firms',
                        key: 'name'
                    }
                },
                users: {
                    uid: {
                        path: 'uid',
                        fromFilter: '$filter("getGroupsProfileArray")(row)',
                        key: 'groups'
                    },
                    firm: {
                        fromList: 'firms',
                        key: 'name'
                    },
                    firm2: {
                        path: 'firm',
                        fromFilter: '$filter("getSomethingOfArrayFB")(dato, AppF.centersData, "name", "N/A", "id")',
                        key: 'name2'
                    }
                },
                bills: {
                    payrollId: {
                        fromList: 'allPayrolls',
                        key: 'name'
                    },
                    employeeId: {
                        queryIn: 'lists/employees/all',
                        key: 'name'
                    },
                    rpId: {
                        fromList: 'rps',
                        key: 'name'
                    },
                    companiesRecordId: {
                        fromList: 'companiesRecords',
                        key: 'name'
                    }
                },
                xmlSatMetas: {
                    companiesRecordId: {
                        fromList: 'companiesRecords',
                        key: 'name'
                    }
                },
                employees: {
                    rp: {
                        fromList: 'rps',
                        key: 'rp'
                    },
                    rp2: {
                        path: 'rp',
                        fromList: 'rps',
                        key: 'name'
                    },
                    payroll: {
                        fromList: 'allPayrolls',
                        key: 'name'
                    },
                    payroll2: {
                        path: 'payroll',
                        fromList: 'allPayrolls',
                        key: 'class'
                    },
                    bank: {
                        path: 'data.cards.0.bank',
                        fromListM: 'banks',
                        key: 'name'
                    },
                    hasSync: {
                        path: 'firm',
                        fromFilter: '$filter("getSyncOptions")(dato)',
                        key: 'syncOptions'
                    }
                },
                enroles: {
                    payroll: {
                        fromList: 'allPayrolls',
                        key: 'name'
                    },
                    pc: {
                        path: 'payroll',
                        fromList: 'allPayrolls',
                        key: 'class'
                    },
                    rp: {
                        fromList: 'rps',
                        key: 'rp'
                    }
                },
                dismissesRecords: {
                    payroll: {
                        fromList: 'allPayrolls',
                        key: 'name'
                    },
                    rp: {
                        fromList: 'rps',
                        key: 'rp'
                    }
                },
                idseAutoRecords: {
                    payroll: {
                        fromList: 'allPayrolls',
                        key: 'name'
                    },
                    rp: {
                        fromList: 'rps',
                        key: 'rp'
                    }
                },
                dismissesUnconfirmedRecords: {
                    payroll: {
                        fromList: 'allPayrolls',
                        key: 'name'
                    },
                    rp: {
                        fromList: 'rps',
                        key: 'rp'
                    }
                },
                mdsRecords: {
                    payroll: {
                        fromList: 'allPayrolls',
                        key: 'name'
                    },
                    pc: {
                        path: 'payroll',
                        fromList: 'allPayrolls',
                        key: 'class',
                    },
                    rp: {
                        fromList: 'rps',
                        key: 'rp'
                    }
                },
                variables: {
                    payroll: {
                        fromList: 'allPayrolls',
                        key: 'name'
                    },
                    rp: {
                        fromList: 'rps',
                        key: 'rp'
                    }
                },
                revisions: {
                    payroll: {
                        fromList: 'allPayrolls',
                        key: 'name'
                    },
                    rp: {
                        fromList: 'rps',
                        key: 'rp'
                    }
                },
                aniversariesRecords: {
                    payroll: {
                        fromList: 'allPayrolls',
                        key: 'name'
                    },
                    rp: {
                        fromList: 'rps',
                        key: 'rp'
                    }
                },
                healthcareRecords: {
                    rp: {
                        fromList: 'rps',
                        key: 'name'
                    },
                    payroll: {
                        fromList: 'allPayrolls',
                        key: 'name'
                    }
                },
                employeesVacationsRecords: {
                    rp: {
                        fromList: 'rps',
                        key: 'name'
                    },
                    payroll: {
                        fromList: 'allPayrolls',
                        key: 'name'
                    }
                },
                employeeFiles: {
                    rp: {
                        fromList: 'rps',
                        key: 'name'
                    },
                    payroll: {
                        fromList: 'allPayrolls',
                        key: 'name'
                    }
                },
                personalInfoEmployees: {
                    rp: {
                        fromList: 'rps',
                        key: 'name'
                    },
                    payroll: {
                        fromList: 'allPayrolls',
                        key: 'name'
                    }
                },
                noEmployees: {
                    rp: {
                        fromList: 'rps',
                        key: 'name'
                    },
                    payroll: {
                        fromList: 'allPayrolls',
                        key: 'name'
                    },
                    payroll2: {
                        path: 'payroll',
                        fromList: 'allPayrolls',
                        key: 'class'
                    }
                },
                employeeBirths: {
                    rp: {
                        fromList: 'rps',
                        key: 'name'
                    },
                    payroll: {
                        fromList: 'allPayrolls',
                        key: 'name'
                    },
                    payroll2: {
                        path: 'payroll',
                        fromList: 'allPayrolls',
                        key: 'class'
                    }
                },
                anniversaryEmployees: {
                    rp: {
                        fromList: 'rps',
                        key: 'name'
                    },
                    payroll: {
                        fromList: 'allPayrolls',
                        key: 'name'
                    },
                    payroll2: {
                        path: 'payroll',
                        fromList: 'allPayrolls',
                        key: 'class'
                    }
                },
                kardexEmployees: {
                    rp: {
                        fromList: 'rps',
                        key: 'name'
                    },
                    payroll: {
                        fromList: 'allPayrolls',
                        key: 'name'
                    },
                    payroll2: {
                        path: 'payroll',
                        fromList: 'allPayrolls',
                        key: 'processes'
                    },
                    position: {
                        path: 'data.position',
                        queryIn: 'lists/positions/all',
                        key: 'name'
                    },
                    imageDefault: {
                        justSetField: function (item) {
                            var image;
                            if (angular.isUndefined(item.data.photoEmployee)) {
                                image = $filter('getDefaultAvatarEmployee')(item);
                            }
                            return image;

                        }
                    }
                },
                syncEmployeeRecords: {
                    rp: {
                        fromList: 'rps',
                        key: 'name'
                    },
                    payroll: {
                        fromList: 'allPayrolls',
                        key: 'name'
                    }
                },
                realSalaryRecords: {
                    rp: {
                        fromList: 'rps',
                        key: 'name'
                    },
                    payroll: {
                        fromList: 'allPayrolls',
                        key: 'name'
                    }
                },
                loans: {
                    incidencesType: {
                        path: 'data.incidenceType',
                        fromList: 'incidencesTypes',
                        key: 'name'
                    },
                    employee: {
                        queryIn: 'lists/employees/all',
                        key: 'name'
                    }
                },
                enroleAccounts: {
                    payroll: {
                        fromList: 'allPayrolls',
                        key: 'name'
                    },
                    payroll2: {
                        path: 'payroll',
                        fromList: 'allPayrolls',
                        key: 'processes'
                    },
                    rp: {
                        fromList: 'rps',
                        key: 'rp'
                    },
                    fiscal: {
                        path: 'payroll',
                        fromFilter: '$filter("getPayrollIssuer")(dato)',
                        key: 'fiscal'
                    },
                    socialPrevision: {
                        path: 'payroll',
                        fromFilter: '$filter("getPayrollIssuer")(dato, "socialPrevision")',
                        key: 'socialPrevision'
                    },
                    asimilated: {
                        path: 'payroll',
                        fromFilter: '$filter("getPayrollIssuer")(dato, "asimilated")',
                        key: 'asimilated'
                    },
                    issuer_register: {
                        justSetField: function (item) {
                            var path = ('payroll-' + item.data.cards[0].process) + "." + (item.data.cards[0].emit ? item.data.cards[0].bank : item.data.cards[0].bankToReg);
                            var value = getFromObjectFilter(item, path, '');
                            return value;
                            // return (item['payroll-' + item.data.cards[0].process][item.data.cards[0].emit ? item.data.cards[0].bank : item.data.cards[0].bankToReg])
                        }
                    }
                },
                involvedRecords: {
                    payroll: {
                        fromList: 'allPayrolls',
                        key: 'name'
                    }
                },
                incidences: {
                    payroll: {
                        fromList: 'allPayrolls',
                        key: 'name'
                    },
                    employee: {
                        queryIn: 'lists/employees/all',
                        key: 'name'
                    },
                    incidenceType: {
                        fromList: 'concepts',
                        key: 'name'
                    }
                },
                confirmIncidences: {
                    payroll: {
                        fromList: 'allPayrolls',
                        key: 'name'
                    },
                    employee: {
                        queryIn: 'lists/employees/all',
                        key: 'name'
                    },
                    incidenceType: {
                        fromList: 'incidencesTypes',
                        key: 'name'
                    }

                },

                ccs: {
                    rp: {
                        path: 'data.rp_id',
                        fromList: 'rps',
                        key: 'name'
                    },
                    rp2: {
                        path: 'data.rp_id',
                        fromList: 'rps',
                        key: 'rp'
                    }
                },
                movements: {
                    payroll: {
                        fromList: 'allPayrolls',
                        key: 'name'
                    },
                    payroll2: {
                        path: 'payroll',
                        fromList: 'allPayrolls',
                        key: 'class'
                    },
                    rp: {
                        fromList: 'rps',
                        key: 'name'
                    },
                    'fid': {
                        path: 'fid',
                        fromFilter: '$filter("getValidEmployeesToPrintPdf")([row],true)',
                        key: 'pdfPrintable'
                    }
                },
                credits: {
                    payroll: {
                        fromList: 'allPayrolls',
                        key: 'name'
                    },
                    employee: {
                        queryIn: 'lists/employees/all',
                        key: 'rp'
                    }
                },
                benefits: {
                    payroll: {
                        path: 'itemId',
                        fromList: 'allPayrolls',
                        key: 'name'
                    },
                    cc: {
                        path: 'itemId',
                        fromList: 'ccs',
                        key: 'name'
                    },
                    employee: {
                        path: 'itemId',
                        queryIn: 'lists/employees/all',
                        key: 'name'
                    },
                    ccName: {
                        path: 'cc',
                        fromList: 'ccs',
                        key: 'name'
                    },
                    payrollName: {
                        path: 'payroll',
                        fromList: 'allPayrolls',
                        key: 'name'
                    }
                },
                operationConstants: {
                    ccName: {
                        path: 'cc',
                        fromList: 'ccs',
                        key: 'name'
                    },
                    payrollName: {
                        path: 'payroll',
                        fromList: 'allPayrolls',
                        key: 'name'
                    }
                },
                saludRecords: {
                    payroll: {
                        fromList: 'allPayrolls',
                        key: 'name'
                    },
                    employee: {
                        queryIn: 'lists/employees/all',
                        key: 'name'
                    }
                },
                contracts: {
                    payroll: {
                        fromList: 'allPayrolls',
                        key: 'name'
                    }
                }
            }
        };
        return obj;

    }

}());

(function () {
    'use strict';

    angular
        .module('fuse')
        .factory('MongoF', MongoF);

    function MongoF(
        $sessionStorage,
        DataF,
        AppF,
        $log,
        $q,
        $rootScope,
        $mdDialog,
        ApiV2F,
        ApiV3F,
        isThereChildDataMFilter,
        objectsLengthFilter,
        constructMsgFilter,
        confirmConfig,
        successAlertS,
        errAlertS
    ) {
        var thisCenter = function () {
            return AppF.center;
        }
        var obj = {
            loadData: {
                xmlBillsRequests: [],
                // mongo catalogs
                placesOfWorkRecords: ['states', 'geoZones'],
                towns: ['states'],
                concepts: ['directives'],
                minimumWageRecords: ['geoZones'],
                zipCodes: ['states', 'placeTypes'],
                placeTypes: ['states'],
                // fb catalogs
                ccs: ['unions', 'paymentGroups', 'placesOfWorkRecords'],
                rps: ['riskClassesRecords', 'placesOfWorkRecords', 'regimes', 'countriesRecords', 'states'],
                companiesRecords: ['countriesRecords', 'states', 'regimes', 'societyTypes'],
                firms: ['countriesRecords', 'states', 'regimes'],
                paymentSchemas: [],
                accountingAccounts: [],
                tickets: [],
                accountAccVars: [],
                incidences: ['incidencesTypes'],
                incidencesTypes: ['unions', 'paymentGroups', 'directives'],
                globalNotifications: ['modules', 'actions', 'statusRecords'],
                constants: ['placesOfWorkRecords'],
                benefits: [],
                batchRecords: ['dismissTypes', 'salaryTypes', 'workerTypes', 'workDays'],
                payrolls: ['paymentFrequenciesRecords', 'monthForAccumulatedRecords', 'issuers', 'bankAccounts'],
                actions: ['modules'],
                statusRecords: ['modules'],
                bankAccounts: ['banks', 'bankAccounts'],
                employees: {
                    read: ['relationships', 'states', 'streetTypes', 'banks', 'placesOfWorkRecords', 'geoZones'],
                    enrole: ['relationships', 'states', 'streetTypes', 'banks', 'placesOfWorkRecords', 'geoZones', 'workerTypes', 'workDays', 'salaryTypes'],
                    reEntry: ['relationships', 'states', 'streetTypes', 'banks', 'placesOfWorkRecords', 'geoZones', 'workerTypes', 'workDays', 'salaryTypes'],
                    update: ['relationships', 'states', 'streetTypes', 'banks', 'placesOfWorkRecords', 'geoZones', 'workerTypes', 'workDays', 'salaryTypes'],
                    especialEdit: ['relationships', 'states', 'streetTypes', 'banks', 'dismissTypes', 'salaryTypes', 'workerTypes', 'workDays', 'placesOfWorkRecords', 'geoZones'],
                    mds: ['placesOfWorkRecords', 'geoZones'],
                    dismiss: ['dismissTypes', 'placesOfWorkRecords', 'geoZones', { catalog: 'documentTypes', params: { center: thisCenter, type: 'contract' } }],
                    list: ['dismissTypes', 'banks', 'bankAccounts', 'placesOfWorkRecords', 'geoZones', 'paymentForms']
                },
                operations: ['paymentFrequenciesRecords', 'dismissTypes', 'banks', 'bankAccounts', 'paymentForms'],
                healthcareRecords: {
                    read: ['relationships', 'states', 'streetTypes', 'banks']
                },
                employeesVacationsRecords: {
                    read: ['relationships', 'states', 'streetTypes', 'banks']
                },
                employeeFiles: {
                    list: [{ catalog: 'documentTypes', params: { center: thisCenter, type: 'generalsRequired', firm: 'global' } }],
                    read: ['relationships', 'states', 'streetTypes', 'banks']
                },
                personalInfoEmployees: {
                    read: ['relationships', 'states', 'streetTypes', 'banks', 'placesOfWorkRecords', 'geoZones'],
                    list: ['relationships', 'states', 'streetTypes', 'banks', 'placesOfWorkRecords', 'geoZones'],
                    update: ['relationships', 'states', 'streetTypes', 'banks', 'placesOfWorkRecords', 'geoZones']
                },
                enroles: {
                    read: ['relationships', 'states', 'streetTypes', 'banks'],
                    update: ['salaryTypes', 'workerTypes', 'workDays', 'placesOfWorkRecords', 'geoZones']
                },
                idseRecords: {
                    read: ['relationships', 'states', 'streetTypes', 'banks', 'dismissTypes', 'placesOfWorkRecords']
                },
                noEmployees: {
                    read: ['relationships', 'states', 'streetTypes', 'banks']
                },
                kardexEmployees: [
                    'relationships', 'states', 'streetTypes', 'banks', 'placesOfWorkRecords', 'geoZones', 'workerTypes', 'workDays', 'salaryTypes', {
                        catalog: 'documentTypes', params: { center: thisCenter, type: 'contract' }
                    }],
                syncEmployeeRecords: [
                    'relationships', 'states', 'streetTypes', 'banks', 'placesOfWorkRecords', 'geoZones', 'workerTypes', 'workDays', 'salaryTypes', {
                        catalog: 'documentTypes', params: { center: thisCenter, type: 'contract' }
                    }],
                realSalaryRecords: {
                    read: ['relationships', 'states', 'streetTypes', 'banks']
                },
                mdsRecords: {
                    update: ['salaryTypes', 'workerTypes', 'workDays', 'placesOfWorkRecords', 'geoZones']
                },
                enroleAccounts: ['banks', 'bankAccounts'],
                variables: ['salaryTypes'],
                dismissesRecords: ['dismissTypes', 'placesOfWorkRecords', 'geoZones'],
                idseAutoRecords: ['relationships', 'states', 'streetTypes', 'banks', 'dismissTypes', 'salaryTypes', 'workerTypes', 'workDays', 'placesOfWorkRecords', 'geoZones'],
                aniversariesRecords: {
                    read: ['relationships', 'states', 'streetTypes', 'banks', 'placesOfWorkRecords', 'geoZones']
                },
                aniversaryRecords: ['relationships', 'states', 'streetTypes', 'banks', 'placesOfWorkRecords', 'geoZones'],
                credits: [],
                revisions: {
                    review: ['relationships', 'states', 'streetTypes', 'dismissTypes', 'banks', 'salaryTypes', 'workerTypes', 'workDays', 'placesOfWorkRecords', 'geoZones']
                },
                movements: {
                    read: ['relationships', 'states', 'streetTypes', 'dismissTypes', 'banks', 'placesOfWorkRecords', 'geoZones'],
                    update: ['relationships', 'states', 'streetTypes', 'banks', 'dismissTypes', 'salaryTypes', 'workerTypes', 'workDays', 'placesOfWorkRecords', 'geoZones'],
                    createHistoricMovement: ['dismissTypes', 'salaryTypes', 'workerTypes', 'workDays', 'placesOfWorkRecords', 'geoZones']
                },
                imports: {
                    detail: ['states']
                },
                saludRecords: [{ catalog: 'documentTypes', params: { center: thisCenter, type: 'saludRecord' } }],
                contracts: [{ catalog: 'documentTypes', params: { center: thisCenter, type: 'contract' } }],
                employeeBirths: {
                    read: ['relationships', 'states', 'streetTypes', 'banks']
                },
                anniversaryEmployees: {
                    read: ['relationships', 'states', 'streetTypes', 'banks']
                }
            },
            initialLoad: [],
            // catalogs
            countriesRecords: [],
            states: [],
            banks: [],
            directives: [],
            towns: [],
            notifications: [],
            regimes: [],
            geoZones: [],
            placeTypes: [],
            zipCodes: [],
            tickets: [],
            accountingAccounts: [],
            accountAccVars: [],
            unions: [],
            paymentGroups: [],
            streetTypes: [],
            relationships: [],
            xmlBillsRequests: [],
            riskClassesRecords: [],
            dismissTypes: [],
            concepts: [],
            placesOfWorkRecords: [],
            incidencesTypes: [],
            paymentFrequenciesRecords: [],
            monthForAccumulatedRecords: [],
            subsidyRecords: [],
            isrRecords: [],
            cyvRecords: [],
            imssRecords: [],
            salaryTypes: [],
            workDays: [],
            workerTypes: [],
            issuers: [],
            // system
            modules: [],
            actions: [],
            statusRecords: [],
            // functions
            whatIsLoaded: function (catalogs) {
                // var notLoaded = [];
                var notLoaded = catalogs;
                // for (var c in catalogs) {
                //     if(!obj[catalogs[c]]) alert('Falta configurar M.' + catalogs[c]);
                //     if (!obj[catalogs[c]].length) {
                //         // if(!$sessionStorage.M) $sessionStorage.M = {};
                //         // if (!$sessionStorage.M[catalogs[c]]) {
                //             notLoaded.push(catalogs[c]);
                //         // } else {
                //         //     if (!$sessionStorage.M[catalogs[c]].length) {
                //         //         notLoaded.push(catalogs[c]);
                //         //     }
                //         //     obj[catalogs[c]] = $sessionStorage.M[catalogs[c]];
                //         // }
                //     }
                // }
                return notLoaded;
            },
            loadCatalog: function (catalog, params, filterName) {
                var catalogName = (filterName) ? filterName : catalog;
                var defered = $q.defer();
                // var fbref;
                // if(!obj[catalog]) obj[catalog] = [];
                // if(!obj[catalogName].length){
                DataF.api.get(catalog, params).then(function (cat) {
                    //$log.debug('loading in M ', catalog, catalogName, params, cat)
                    obj[catalogName] = cat.data;
                    // $sessionStorage.M[catalogName] = cat.data;
                    defered.resolve(cat.data);
                }, function (err) {
                    errAlertS(err);
                    defered.reject(err);
                });
                // } else {
                //      defered.resolve(obj[catalogName]);
                // }
                return defered.promise;
            },
            getTownsByState: function (stateId) {
                DataF.api.get('towns', {
                    'state_id': stateId
                }).then(function (result) {
                    var data = result.data;
                    obj.towns = data;
                }, errAlertS);
            },
            getCatalog: function (catalog, query) {
                if (!query) { query = {}; }
                DataF.api.get(catalog, query).then(function (result) {
                    var data = result.data;
                    obj[catalog] = data;
                    $log.debug('Loaded ' + catalog, obj[catalog]);
                }, errAlertS);
            },
            deleteSafe: function (e, catalog, selected, name, alias, fn) {
                $log.debug(catalog, selected, 'deleting safely from FB');
                var promise = $q.defer();
                var catalogs = alias ? alias : catalog + 's';
                var remove = function (id) {
                    $log.debug('removing: ' + name, id, catalog, catalogs);
                    if (AppF.active.apiVersion === 2) {
                        var finalPath2 = 'api/' + catalogs + '/' + id;
                        return ApiV2F.delete(finalPath2);
                    } else if (AppF.active.apiVersion === 2) {
                        var finalPath3 = 'api/' + catalogs + '/' + id;
                        return ApiV3F.delete(finalPath3);
                    } else {
                        return DataF.api.delete(catalogs + '/' + id);
                    }
                    //return AppF.root.child(RoutesF.refs[catalogs]).child(id).set(null);
                };
                var deleteThem = function () {
                    var count = 0;
                    $log.debug('Deleting: ', selected);
                    angular.forEach(selected, function (cat) {
                        if (!AppF.safeDelete[catalog]) {
                            remove(cat._id).then(function () {
                                count++;
                                if (count === selected.length) {
                                    successAlertS('Se borraron ' + count + ' ' + name + '(s)');
                                    $rootScope.$emit('mongoCatalogsDeleted', {
                                        name: catalogs,
                                        data: selected
                                    });
                                    promise.resolve(true);
                                }
                            }, function (err) {
                                errAlertS(err);
                                promise.reject(err);
                            });
                        }
                    });
                };
                var askIfDelete = function (msg) {
                    var title = 'Quiere borrar ' + selected.length + ' ' + name + '(s)?';
                    $mdDialog
                        .show($mdDialog
                            .confirm(confirmConfig)
                            .title(title)
                            .htmlContent(msg)
                            .ariaLabel('Deleting')
                            .targetEvent(e)
                            .ok('Borrar')
                            .cancel('Cancelar'))
                        .then(function () {
                            if (angular.isDefined(fn)) {
                                fn(selected).then(function () {
                                    $log.log('Se eliminaron las incidencias en firebase 🗑️');
                                    deleteThem();
                                }).catch(function (error) {
                                    $log.log(error);
                                })
                            } else {
                                deleteThem();
                            }
                        }, function () {
                            $log.debug('Deleting Cancelled');
                        });
                };
                isThereChildDataMFilter(catalogs, selected).then(function (hasData) {
                    $log.debug('hasData', catalogs, hasData);
                    var msg = '';
                    if (!hasData) {
                        msg += (!AppF.safeDelete[catalog]) ?
                            'No podrá recuperar sus datos.' :
                            'Podrá recuperar sus datos en la papelera.';
                        askIfDelete(msg);
                    } else {
                        var deleteInCascade = [];
                        //var deleteInCascade = isThereDeleteInCascadeFilter('catalogs','payrolls');
                        for (var catalogg in hasData) {
                            if (hasData.hasOwnProperty(catalogg)) {
                                var deleteIt = !hasData[catalogg];
                                if (deleteIt) { deleteInCascade.push(catalogg); }
                            }
                        }
                        if (objectsLengthFilter(hasData) <= deleteInCascade.length) { // es seguro borrar los datos en cascada
                            msg = constructMsgFilter('Cuidado!! Esto ocacionará que se borren datos relacionados en cascada: ', deleteInCascade, false, 'menuName');
                            askIfDelete(msg);
                        } else { // no es seguro
                            msg = constructMsgFilter('No es posible borrar los datos debido a que tiene datos dependientes: ', hasData, false, 'menuName', true);
                            errAlertS(msg);
                            promise.reject(msg);
                        }
                    }
                }, function (err) {
                    errAlertS(err);
                    promise.reject(err);
                });
                return promise.promise;
            },
            initialMongoLoad: function (loadCatalogs) {
                var requests = [];
                if (!loadCatalogs) { loadCatalogs = obj.initialLoad; }
                for (var c in loadCatalogs) {
                    if (loadCatalogs.hasOwnProperty(c)) {
                        var catalog = loadCatalogs[c];
                        $log.debug('setting list in M.' + catalog);
                        var request = DataF.api.get(catalog);
                        requests.push(request);
                    }
                }
                return $q.all(requests);
            },
            loadNeeded: function (arrayOfLists) {
                var requests = [];
                if (!arrayOfLists) { arrayOfLists = obj.loadData[AppF.active.menuName]; }
                // $log.debug('loading needed', arrayOfLists);
                if (arrayOfLists) {
                    if (arrayOfLists.constructor !== Array && arrayOfLists) {
                        // $log.debug('loading needed mongo catalog for sub.state ' + AppF.active.menuAction);
                        arrayOfLists = arrayOfLists[AppF.active.menuAction];
                    }
                }
                if (arrayOfLists) {
                    var whatIsLoaded = obj.whatIsLoaded(arrayOfLists);
                    // $log.debug('loading needed mongo catalog', whatIsLoaded);
                    for (var list in whatIsLoaded) {
                        if (whatIsLoaded.hasOwnProperty(list)) {
                            var listO = whatIsLoaded[list];
                            if (angular.isString(listO)) {
                                requests.push(obj.loadCatalog(listO));
                            } else {
                                var params = {};
                                if (angular.isObject(listO.params)) {
                                    for (var param in listO.params) {
                                        if (listO.params.hasOwnProperty(param)) {
                                            var thisValue = listO.params[param];
                                            if (angular.isFunction(thisValue)) {
                                                thisValue = thisValue();
                                            }
                                            params[param] = thisValue;
                                        }
                                    }
                                }
                                requests.push(obj.loadCatalog(listO.catalog, params, listO.filter));
                            }
                        }
                    }
                }
                return Promise.all(requests);
            }
        };
        return obj;
    }

}());
(function () {
    'use strict';

    angular
        .module('fuse')
        .factory('ListsF', ListsF)

    // ment to replace lists in F
    function ListsF(
        $log,
        $firebaseArray,
        $firebaseObject,
        // $localStorage,
        $q,
        AppF,
        RoutesF,
        errAlertS,
        $rootScope
    ) {
        var companiesRecordQuery = { catalog: 'companiesRecords', query: [{ q: 'orderByChild', v: 'center' }, { q: 'equalTo', v: function () { return AppF.center; } }] };
        var payrolls = { catalog: 'payrolls', query: [{ q: 'orderByChild', v: 'center' }, { q: 'equalTo', v: function () { return AppF.center; } }] };
        var rps = { catalog: 'rps', query: [{ q: 'orderByChild', v: 'center' }, { q: 'equalTo', v: function () { return AppF.center; } }] };
        var ccs = { catalog: 'ccs', query: [{ q: 'orderByChild', v: 'center' }, { q: 'equalTo', v: function () { return AppF.center; } }] };
        var concepts = { ref: function () { return 'lists/conceptsByCenter/' + AppF.center + '/all'; }, catalog: 'concepts' };
        var incidencesTypes = { ref: function () { return '/lists/incidencesTypes/center/' + AppF.center; }, catalog: 'incidencesTypes' };
        var obj = {
            // objeto de configuración de las lists que cargan
            // [''] -> carga los listados en lists y details
            // { substate: [] } -> carga los listados solo en el sub.state que se indique
            loadData: {
                states: ['concepts'],
                humandCatalogs: [],
                xmlBillsRequests: [companiesRecordQuery],
                reports: [companiesRecordQuery, incidencesTypes, concepts],
                processConfigs: [incidencesTypes, concepts],
                accountAccVars: [],
                payrollConfigs: [payrolls],
                concepts: [payrolls, concepts],
                tickets: ['profiles'],
                archivedTickets: ['profiles'],
                bankAccounts: [companiesRecordQuery],
                issuers: [companiesRecordQuery],
                ccs: [rps, 'profiles'],
                rps: [companiesRecordQuery],
                accountingAccounts: [companiesRecordQuery, rps, concepts],
                loans: [incidencesTypes],
                contracts: [],
                rpIdseRecords: [rps],
                batchRecords: [rps],
                saludRecords: [],
                documentTypes: [],
                projects: [],
                companiesRecords: [],
                firms: [rps],
                positions: ['profiles'],
                departments: ['profiles'],
                payrolls: [companiesRecordQuery, 'profiles'],
                paymentSchemas: [incidencesTypes, concepts],
                involvedRecords: ['involvedRecords'],
                incidencesRequests: [incidencesTypes],
                globalNotifications: ['profiles', 'groups'],
                incidences: [concepts, incidencesTypes],
                confirmIncidences: [incidencesTypes],
                notifications: ['profiles'],
                users: [
                    'groups'
                ],
                groups: [{
                    catalog: 'groups',
                    ref: 'lists/groups/all',
                    type: 'array',
                    child: false,
                    filterName: 'allGroups'
                }, {
                    catalog: 'profiles',
                    ref: 'lists/profiles/all',
                    type: 'array',
                    child: false,
                    filterName: 'allProfiles'
                }],
                customFields: [{
                    catalog: 'groups',
                    ref: 'lists/groups/all',
                    type: 'array',
                    child: false,
                    filterName: 'allGroups'
                }],
                employees: {
                    list: [rps, ccs, 'groupings'],
                    update: [rps],
                    enrole: [rps],
                    specialEdit: [rps]
                },
                aniversariesRecords: {
                    list: [rps, ccs]
                },
                aniversaryRecords: {
                    list: [rps, ccs]
                },
                credits: {
                    list: [rps, ccs]
                },
                dismissesRecords: {
                    list: [rps, ccs]
                },
                idseAutoRecords: {
                    list: [rps, ccs]
                },
                operations: [companiesRecordQuery, concepts],
                benefits: [rps],
                operationConstants: [rps, incidencesTypes],
                dismissesUnconfirmedRecords: {
                    list: [rps, ccs]
                },
                enroles: {
                    list: [rps, ccs]
                },
                enroleAccounts: {
                    list: [rps, ccs]
                },
                healthcareRecords: {
                    list: [rps, ccs]
                },
                employeesVacationsRecords: {
                    list: [rps, ccs]
                },
                employeeFiles: {
                    list: [rps, ccs]
                },
                personalInfoEmployees: {
                    list: [rps, ccs]
                },
                idseRecords: {
                    list: [rps, ccs]
                },
                mdsRecords: {
                    list: [rps, ccs]
                },
                logs: {
                    list: ['profiles']
                },
                movements: {
                    list: [rps, ccs],
                    read: [],
                    createHistoricMovement: [],
                    update: []
                },
                noEmployees: {
                    list: [rps, ccs]
                },
                employeeBirths: {
                    list: [rps, ccs]
                },
                anniversaryEmployees: {
                    list: [rps, ccs]
                },
                kardexEmployees: [
                    rps, ccs, concepts
                ],
                syncEmployeeRecords: [
                    rps, ccs, concepts
                ],
                realSalaryRecords: {
                    list: [rps, ccs]
                },
                revisions: {
                    list: [rps, ccs],
                    review: [rps]
                },
                variables: {
                    list: [rps, ccs]
                },
                bills: [companiesRecordQuery, rps, 'payrolls'],
                xmlSatMetas: [companiesRecordQuery],
                imports: {
                    update: [
                        rps
                    ]
                },
                dashboards_project: [
                    'rps',
                    'ccs',
                    'profiles',
                    'groups',
                    {
                        catalog: 'employees',
                        ref: 'lists/employees/firm',
                        type: 'array',
                        child: function () {
                            console.log("Log para ver si este consulta lists/employees/firm");
                            return AppF.profile.firm;
                        },
                        filterName: 'firmEmployees'
                    }
                ]
            },
            // functions
            /*
                @param catalog if not provided will load actual menu catalog
                @param ref if not provided will load all
                @param child not required > it will load a extra child on ref
                @param type not required 'object' || 'array' (default)
                @param filterName if provided will save a filter
                @param queryParams [{q:orderBy,v:'payroll'},{q:equalTo,v:23}] in correct order 
                lists/ debe ir aqui
            */
            loadList: function (catalog, ref, child, type, filterName, queryParams) {
                if (!catalog) catalog = AppF.active.menuName;
                var listName = (filterName) ? filterName : catalog;
                if (!type) type == 'array';
                if (!ref) ref = 'lists/' + catalog + '/all';
                if (angular.isFunction(ref)) {
                    ref = ref();
                }
                var defered = $q.defer();
                var fbref;

                // query constructor ref
                if (queryParams) { // deben venir en el orden correcto en un array
                    if (child) {
                        if (angular.isFunction(child)) child = child();
                        ref = ref + '/' + child;
                    }
                    var fbref = AppF.root.child(ref);
                    for (var q in queryParams) {
                        var qParam = queryParams[q];
                        if (typeof (qParam.v) === 'function') {
                            fbref = fbref[qParam.q](qParam.v());
                        } else if (typeof (qParam.v) !== 'undefined') {
                            fbref = fbref[qParam.q](qParam.v);
                        } else {
                            fbref = fbref[qParam.q]();
                        }
                    }
                } else {
                    if (child) {
                        if (angular.isFunction(child)) child = child();
                        fbref = AppF.root.child(ref).child(child);
                    } else {
                        fbref = AppF.root.child(ref);
                    }
                }

                if (!filterName || !child) {
                    if (!obj[listName]) obj[listName] = [];
                    if (!obj[listName].length) {
                        // var version = AppF.version.lists[catalog].all;
                        // if(!$localStorage.L) $localStorage.L = {};
                        // if(!$localStorage.version) $localStorage.version = {};
                        // if(!$localStorage.version.lists) $localStorage.version.lists = {};
                        // if(!$localStorage.version.lists[catalog]) $localStorage.version.lists[catalog] = {};
                        // if(
                        // !$localStorage.L[listName]
                        // || version != $localStorage.version.lists[catalog].all
                        // ) {
                        obj[listName] = (type != 'object') ? $firebaseArray(fbref) : $firebaseObject(fbref);
                        obj[listName].$loaded().then(function (listCat) {
                            // $log.debug('loaded in L.' + listName, {
                            //     catalog: catalog,
                            //     listName: listName,
                            //     listCat: listCat,
                            //     ref: fbref
                            // });
                            $rootScope.$evalAsync(function () {
                                //console.log("first Updated Setted");
                            })
                            // $localStorage.L[listName] = clearObjectFilter(listCat);
                            // $localStorage.version.lists[catalog].all = version;
                            defered.resolve(listCat);
                        }, function (err) {
                            errAlertS(err);
                            defered.reject(err);
                        });
                        // } else {
                        //     $log.debug('loading from $localStorage in L.' + listName, {catalog:catalog, listName: listName, listCat: $localStorage.L[listName], ref: fbref});
                        //     obj[listName] = $localStorage.L[listName];
                        //     defered.resolve($localStorage.L[listName]);
                        // }
                    } else {
                        $log.debug('loaded from Memory in L.' + listName, {
                            catalog: catalog,
                            listName: listName,
                            listCat: obj[listName]
                        });
                        defered.resolve(obj[listName]);
                    }
                } else {
                    // var version = AppF.version.lists[catalog][child];
                    if (angular.isFunction(child)) child = child();
                    if (!obj[listName]) obj[listName] = {};
                    if (!obj[listName][child]) obj[listName][child] = [];
                    if (!obj[listName][child] || !obj[listName][child].length) {
                        // if(!$localStorage.L) $localStorage.L = {};
                        // if(!$localStorage.L[listName]) $localStorage.L[listName] = {};
                        // if(!$localStorage.version) $localStorage.version = { lists: {}};
                        // if(!$localStorage.version.lists[catalog]) $localStorage.version.lists[catalog] = {};
                        // if(
                        //     !$localStorage.L[listName][child]
                        //     || version != $localStorage.version.lists[catalog][child]
                        // ) {
                        obj[listName][child] = (type != 'object') ?
                            $firebaseArray(fbref) :
                            $firebaseObject(fbref);
                        obj[listName][child].$loaded().then(function (listCat) {
                            // $log.debug('loaded in L.' + listName + '.' + child, {
                            //     catalog: catalog,
                            //     listName: listName,
                            //     listCat: listCat,
                            //     ref: ref,
                            //     child: child
                            // });
                            $rootScope.$evalAsync(function () {
                                //console.log("first Updated Setted");
                            })
                            // $localStorage.L[listName][child] = clearObjectFilter(listCat);
                            // $localStorage.version.lists[catalog][child] = version;
                            defered.resolve(listCat);
                        }, function (err) {
                            errAlertS(err);
                            defered.reject(err);
                        });
                        // } else {
                        //     $log.debug('loaded from $localStorage in L.' + listName, {catalog: catalog, listName: listName, listCat: $localStorage.L[listName], ref: fbref});
                        //     obj[listName][child] = $localStorage.L[listName][child];
                        //     defered.resolve($localStorage.L[listName][child]);
                        // }
                    } else {
                        // $log.debug('loaded from Memory in L.' + listName + '.' + child, {
                        //     cName: listName,
                        //     cat: obj[listName][child],
                        //     child: child
                        // });
                        defered.resolve(obj[listName][child]);
                    }
                }
                return defered.promise;
            },
            // carga las Listas en L que sean requeridas para el state
            loadNeeded: function () {
                var requests = [];
                var arrayOfLists = obj.loadData[AppF.active.menuName];
                if (arrayOfLists) {
                    if (arrayOfLists.constructor !== Array && arrayOfLists) {
                        arrayOfLists = arrayOfLists[AppF.active.menuAction];
                    }
                }
                if (arrayOfLists) {
                    for (var list in arrayOfLists) {
                        if (typeof arrayOfLists[list] == 'string') {
                            requests.push(obj.loadList(arrayOfLists[list]));
                        } else {
                            requests.push(obj.loadList(arrayOfLists[list].catalog, arrayOfLists[list].ref, arrayOfLists[list].child, arrayOfLists[list].type, arrayOfLists[list].filterName, arrayOfLists[list].query));
                        }
                    }
                }
                return Promise.all(requests);
            }
        };
        return obj;
    }

}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('IncidencesF', IncidencesF);

    /** @ngInject */
    function IncidencesF(
        AppF,
        DataF,
        $log,
        clearObjectFilter,
        orderByFilter,
        activeDaysFromMovementsFilter,
        getSalaryByDayFilter,
        ListsF
    ) {

        var activeDays = {};
        var activeDaysFormatted = {};
        var employeesMovements = {};

        /** verifica que la fecha sea una fecha en que el empleado está activo */
        function checkIfValidActiveDates(incidence, incidenceAffect) {
            $log.log('checkActiveDate', incidence);
            var incidenceE = incidence.employee || incidence.e;
            var incidenceD = incidence.date || incidence.d;
            var incidenceV = incidence.value || incidence.v;
            var start = incidenceD,
                end = incidenceD;
            if (incidenceAffect === 'days' && incidenceV > 1) {
                end = incidenceD + (AppF.oneDay * (incidenceV - 1));
            }
            return new Promise(function (resolve, reject) {
                if (!employeesMovements.hasOwnProperty(incidenceE)) {
                    employeesMovements[incidenceE] = ListsF.loadList('movements', 'catalogs/movements/collection', undefined, 'array', 'employeeMovements-' + incidenceE, [{ 'q': 'orderByChild', 'v': 'employee' }, { 'q': 'equalTo', 'v': incidenceE }]);
                }
                employeesMovements[incidenceE].then(function (qMovements) {
                    var eMovements;
                    if (angular.isDefined(incidence.payroll)) {
                        eMovements = qMovements.filter(function (item) {
                            return item.payroll === incidence.payroll || item.p === incidence.payroll;
                        });
                    } else {
                        eMovements = qMovements;
                    }
                    $log.log(eMovements);
                    if (eMovements.length) {
                        doCheckIncidenceInActiveDays(
                            incidenceE,
                            start,
                            end,
                            incidence,
                            incidenceAffect,
                            eMovements
                        ).then(resolve)
                            .catch(function (err) {
                                incidence.date = null;
                                reject(err);
                            });
                    } else {
                        reject('No se encontraron movimientos de este empleado');
                    }
                }).catch(reject);
            });
        }

        /**
         * Revisa los movimientos del empleado entre las fechas y resuelve si el empleado está activo en ese periodo de fechas
         * @param {string} employeeId 
         * @param {number} start inicio de fecha en que se desea checar que esté activo
         * @param {number} end final de fecha en que se desea checar que se esté activo
         * @returns {Promise} resolve -> activo, reject -> inactivo
         */
        function doCheckIncidenceInActiveDays(employeeId, start, end, incidence, incidenceAffect, employeeMovements) {
            return new Promise(function (resolve, reject) {
                var employeeName;
                if (angular.isDefined(employeeMovements)) {
                    for (var i = 0; i < employeeMovements.length; i++) {
                        if (employeeMovements[i].info && employeeMovements[i].info.name) {
                            employeeName = ' ' + employeeMovements[i].info.name;
                        }
                    }
                }
                var incidenceV = incidence.value || incidence.v;
                var incidenceD = incidence.date || incidence.d;
                var movementsOrdered = orderByFilter(employeeMovements, 'data.date');
                var period = { start: start, end: end };
                activeDays[employeeId] = activeDaysFromMovementsFilter(movementsOrdered, period);
                activeDaysFormatted[employeeId] = getSalaryByDayFilter(activeDays[employeeId], period);
                $log.debug('activeDays', {
                    activeDays: activeDays[employeeId],
                    activeDaysFormatted: activeDaysFormatted[employeeId],
                    start: moment(start).format('DD/MM/YYYY'),
                    end: moment(end).format('DD/MM/YYYY'),
                    movementsOrdered: movementsOrdered
                });
                var problems = false;
                if (incidenceAffect === 'days' && incidenceV > 1) {
                    for (var x = 0; x < incidenceV; x++) {
                        var dateOfIncidenceAtomized = incidenceD + (AppF.oneDay * x);
                        var dateFormatted = moment(dateOfIncidenceAtomized).format('DD-MM-YYYY');
                        $log.log(dateFormatted, activeDaysFormatted[employeeId][dateFormatted], 'atomized');
                        if (activeDaysFormatted[employeeId].hasOwnProperty(dateFormatted)) {
                            if (!activeDaysFormatted[employeeId][dateFormatted].isActive) {
                                problems = true;
                                reject('En la fecha ' + dateFormatted + ' el empleado' + employeeName + ' no está activo');
                                return false;
                            }
                        } else {
                            problems = true;
                            reject('En la fecha ' + dateFormatted + ' el empleado' + employeeName + ' no está activo');
                            return false;
                        }
                    }
                } else {
                    var dateToCheck = moment(incidenceD).format('DD-MM-YYYY');
                    $log.log(dateToCheck, activeDaysFormatted[employeeId][dateToCheck], 'normal');
                    if (activeDaysFormatted[employeeId].hasOwnProperty(dateToCheck)) {
                        if (!activeDaysFormatted[employeeId][dateToCheck].isActive) {
                            problems = true;
                            reject('En la fecha ' + dateToCheck + ' el empleado' + employeeName + ' no está activo');
                            return false;
                        }
                    } else {
                        problems = true;
                        reject('En la fecha ' + dateToCheck + ' el empleado' + employeeName + ' no está activo');
                        return false;
                    }
                }
                if (!problems) {
                    resolve(true);
                }
            });
        }

        /**
         * regresa una miniIncidencia para usarse en una solicitud de incidencia 
         * @param {*} incidence 
         */
        function addMiniIncidences(incidence) {
            var miniIncidences = {};
            for (var i = 0; i < incidence.value; i++) {
                var incidenceId = AppF.root.child('incidences').child(incidence.payroll).child(incidence.calendar).push().key;
                if (i === 0 && incidence.$id) { incidenceId = incidence.$id; }
                miniIncidences[incidenceId] = {
                    c: (incidence.comments) ? incidence.comments : '',
                    e: incidence.employee,
                    it: incidence.incidenceType,
                    v: 1,
                    s: 0,
                    d: incidence.date
                };
            }
            return miniIncidences;
        }

        /**
         * Checa si la incidencia requiere crear una solicitud y en caso de que si, lo hace por cada día atomiza las incidencias
         * @param {*} incidence el objeto de la incidencia
         * @param {string} incidenceTypeAffect la propiedad de affect en incidenceType de la incidencia
         * @param {Period[]} periods arreglo de periodos cargados
         * @param {boolean} dontSave si viene en tru no guarda cuando incidenceTypeAffect == 'days' && incidence.$id
         */
        function checkIfIncidenceRequestIsNeededAndCreateIt(incidence, incidenceTypeAffect, dontSave) {
            function getCalendar(item) {
                var periodStart = moment(item.start).startOf('day');
                var dateV = moment(this);
                var periodEnd = moment(item.end).endOf('day');
                return (periodStart.valueOf() <= dateV.valueOf() && periodEnd.valueOf() >= dateV.valueOf());
            }
            return new Promise(function (resolve, reject) {
                if (incidenceTypeAffect === 'days' && incidence.value > 1) {
                    var promises = [];
                    promises.push(ListsF.loadList('periods', 'catalogs/payrollCalendars/' + incidence.payroll + '/periods', undefined, 'object', 'periodsFrom-' + incidence.calendar, [{ q: 'orderByKey' }, { q: 'startAt', v: incidence.calendar + '' }]));
                    Promise.all(promises).then(function (resp) {
                        var allPeriods = clearObjectFilter(resp[0]);
                        $log.log(allPeriods);
                        var periods = [];
                        for (var year in allPeriods) {
                            if (allPeriods.hasOwnProperty(year)) {
                                for (var period in allPeriods[year]) {
                                    if (allPeriods[year].hasOwnProperty(period)) {
                                        var thisPeriod = allPeriods[year][period];
                                        if (thisPeriod.period >= incidence.period || (thisPeriod.period < incidence.period && year > incidence.calendar)) {
                                            thisPeriod.calendar = parseInt(year);
                                            periods.push(thisPeriod);
                                        }
                                    }
                                }
                            }
                        }
                        var thisIncidences = [];
                        var incidenceRequestId = AppF.root.child('catalogs/incidencesRequests/collection').push().key;
                        if (periods.length > 0) {
                            for (var i = 0; i < incidence.value; i++) {
                                var incidenceDate = incidence.date + AppF.oneDay * i;
                                var periodOfDate = periods.filter(getCalendar, incidenceDate);
                                var periodOfIncidence, calendarOfIncidence;
                                // console.log("periodOfDate", periodOfDate, incidence.date, incidenceDate);
                                if (periodOfDate.length === 1) {
                                    periodOfIncidence = periodOfDate[0].period;
                                    calendarOfIncidence = periodOfDate[0].calendar;
                                } else {
                                    reject('La fecha ' + moment(incidenceDate).format('DD/MM/YYYY') + ' no tiene periodos asignables');
                                    return;
                                }
                                var incidenceToCreate = {
                                    created: DataF.getTimeObject(),
                                    automaticAsignation: true,
                                    calendar: parseInt(calendarOfIncidence),
                                    comments: (incidence.comments) ? incidence.comments : null,
                                    date: incidenceDate,
                                    employee: incidence.employee,
                                    incidenceType: incidence.incidenceType,
                                    payroll: incidence.payroll,
                                    period: periodOfIncidence,
                                    status: 0,
                                    type: 'request',
                                    value: 1,
                                    center: AppF.center,
                                    request: incidenceRequestId,
                                    file: incidence.file || null,
                                    folio: incidence.folio || null,
                                    confirmed: incidence.confirmed || null,
                                    startDate: incidence.startDate ? incidence.startDate : incidence.date,
                                    incapacityType: incidence.incapacityType || null
                                };
                                thisIncidences.push(incidenceToCreate);
                            }
                        } else {
                            reject('No se encontraron periodos asignables para esta incidencia');
                        }
                        var incidencesRequest = {
                            allPayroll: 0,
                            applied: 0,
                            automaticAsignation: true,
                            calendar: parseInt(incidence.calendar),
                            comments: 'Solicitud de incidencias automática para incidencia que afecta días',
                            created: DataF.getTimeObject(),
                            date: incidence.date,
                            incidenceType: incidence.incidenceType,
                            payroll: incidence.payroll,
                            period: incidence.period,
                            value: incidence.value,
                            status: 0,
                            incidences: {}
                        };
                        var updates = {};
                        var firstUsed = false;
                        for (var t = 0; t < thisIncidences.length; t++) {
                            var thisIncidence = thisIncidences[t];
                            var thisIncidenceId = undefined;
                            if (!firstUsed) {
                                firstUsed = true;
                                thisIncidenceId = incidence.$id;
                            }
                            if (typeof (thisIncidenceId) === 'undefined' || thisIncidenceId === null) {
                                thisIncidenceId = AppF.root.child('incidences').child(incidence.payroll).child(thisIncidence.calendar).push().key;
                            }
                            updates['incidences/' + incidence.payroll + '/' + thisIncidence.calendar + '/' + thisIncidenceId] = thisIncidence;
                            incidencesRequest.incidences[thisIncidenceId] = {
                                c: (incidence.comments) ? incidence.comments : '',
                                e: incidence.employee,
                                it: incidence.incidenceType,
                                v: 1,
                                s: 0,
                                d: thisIncidence.date,
                                y: thisIncidence.calendar,
                                p: thisIncidence.period
                            };
                        }
                        updates['catalogs/incidencesRequests/collection/' + incidenceRequestId] = incidencesRequest;
                        incidence.value = 1;
                        if (dontSave) {
                            resolve(updates);
                        } else {
                            AppF.root.update(updates).then(function () {
                                resolve(updates);
                            }).catch(reject);
                        }
                    }).catch(reject);
                } else {
                    var updates = {};
                    var incidencesRef = 'incidences/' + incidence.payroll + '/' + incidence.calendar;
                    var incidenceId;
                    var flagAddCreatedObject = false;
                    if (typeof (incidence.$id) === 'undefined' || incidence.$id === null) {
                        flagAddCreatedObject = true;
                        incidenceId = AppF.root.child(incidencesRef).push().key;
                    } else {
                        incidenceId = incidence.$id;
                    }
                    incidence = clearObjectFilter(incidence);
                    if (angular.isUndefined(incidence.center)) {
                        incidence.center = AppF.center;
                    }
                    if (flagAddCreatedObject) {
                        incidence.created = DataF.getTimeObject();
                    }
                    updates[incidencesRef + '/' + incidenceId] = incidence;
                    if (dontSave) {
                        resolve(updates);
                    } else {
                        AppF.root.update(updates).then(function () {
                            resolve(false);
                        }).catch(reject);
                    }
                }

            });
        }

        var obj = {
            activeDays: activeDays,
            employeesMovements: employeesMovements,
            activeDaysFormatted: activeDaysFormatted,
            addMiniIncidences: addMiniIncidences,
            checkIfIncidenceRequestIsNeededAndCreateIt: checkIfIncidenceRequestIsNeededAndCreateIt,
            doCheckIncidenceInActiveDays: doCheckIncidenceInActiveDays,
            checkIfValidActiveDates: checkIfValidActiveDates
        };
        return obj;
    }

}());
(function(){
    'use strict';

    angular
        .module('fuse')
        .factory('FunctionsF', FunctionsF)

    function FunctionsF() {
        var subsidyConstants = [{
            subsidy: 407.02,
            value: 0.01
        }, {
            subsidy: 406.83,
            value: 1768.97
        }, {
            subsidy: 406.62,
            value: 2653.39
        }, {
            subsidy: 392.77,
            value: 3472.85
        }, {
            subsidy: 382.46,
            value: 3537.88
        }, {
            subsidy: 354.23,
            value: 4446.16
        }, {
            subsidy: 324.87,
            value: 4717.19
        }, {
            subsidy: 294.63,
            value: 5335.43
        }, {
            subsidy: 253.54,
            value: 6224.68
        }, {
            subsidy: 217.61,
            value: 7113.91
        }, {
            subsidy: 0,
            value: 7382.34
        }];
        var liConstants = [{
            fixedQuota: 0,
            percent: 1.92,
            value: 0.01
        }, {
            fixedQuota: 9.52,
            percent: 6.4,
            value: 496.08
        }, {
            fixedQuota: 247.24,
            percent: 10.88,
            value: 4210.42
        }, {
            fixedQuota: 594.21,
            percent: 16,
            value: 7399.43
        }, {
            fixedQuota: 786.54,
            percent: 17.92,
            value: 8601.51
        }, {
            fixedQuota: 1090.61,
            percent: 21.36,
            value: 10298.36
        }, {
            fixedQuota: 3327.42,
            percent: 23.52,
            value: 20770.30
        }, {
            fixedQuota: 6141.95,
            percent: 30,
            value: 32736.84
        }, {
            fixedQuota: 15070.90,
            percent: 32,
            value: 62500.01
        }, {
            fixedQuota: 21737.57,
            percent: 34,
            value: 83333.34
        }, {
            fixedQuota: 78404.23,
            percent: 35,
            value: 250000.01
        }];
        var findLowerNearest = function(valuesArray, valueToFind, returnValue) {
            var i = 0;
            var valueFounded = false;
            var value = 0;
            while ((i < valuesArray.length) || !valueFounded) {
                if (valueToFind >= valuesArray[i].value) {
                    value = valuesArray[i][returnValue];
                } else {
                    valueFounded = true;
                }
                i++;
            }
            return value;
        };
        var obj = {
            // @todo checar los dias trabajado como se calculan
            getDaysWorked: function(employee, fields, period, calculate) {
                fields = !fields ? {} : fields;
                if (!fields.daysWorked || calculate) {
                    fields.daysWorked = 15;
                }
                return fields.getDaysWorked;
            },
            getImssSalary: function(employee, fields, period, calculate) {
                fields = !fields ? {} : fields;
                if (!fields.imssSalary || calculate) {
                    fields.imssSalary = employee.data.salary.sd ? employee.data.salary.sd : 0;
                }
                return fields.imssSalary;
            },
            getSalary: function(employee, fields, period, calculate) {
                fields = !fields ? {} : fields;
                if (!fields.salary || calculate) {
                    fields.salary = obj.getDaysWorked(employee, fields, period, calculate) * getImssSalary(employee, fields, period, calculate);
                }
                return fields.salary;
            },
            getMonthlySalary: function(employee, fields, period, calculate) {
                fields = !fields ? {} : fields;
                if (!fields.monthlySalary || calculate) {
                    fields.monthlySalary = obj.getImssSalary(employee, fields, period, calculate) * (period.monthlyWageFactor ? period.monthlyWageFactor : 0);
                }
                return fields.monthlySalary;
            },
            getSubsidy: function(employee, fields, period, calculate) {
                fields = !fields ? {} : fields;
                if (!fields.subsidy || calculate) {
                    if (obj.getPeriodSubsidy(employee, fields, period, calculate) > obj.getPeriodIsr(employee, fields, period, calculate)) {
                        fields.subsidy = obj.getPeriodSubsidy(employee, fields, period) - obj.getPeriodIsr(employee, fields, period);
                    } else {
                        fields.subsidy = 0;
                    }
                }
                return fields.subsidy;
            },
            getPeriodSubsidy: function(employee, fields, period, calculate) {
                fields = !fields ? {} : fields;
                if (!fields.periodSubsidy || calculate) {
                    fields.periodSubsidy = (obj.getTableSubsidy(employee, fields, period, calculate) / (period.monthlyWageFactor ? period.monthlyWageFactor : 0)) * obj.getDaysWorked(employee, fields, period, calculate);
                }
                return fields.periodSubsidy;
            },
            getTableSubsidy: function(employee, fields, period, calculate) {
                fields = !fields ? {} : fields;
                if (!fields.tableSubsidy || calculate) {
                    fields.tableSubsidy = findLowerNearest(subsidyConstants, obj.getMonthlySalary(employee, fields, period, calculate), "subsidy");
                }
                return fields.tableSubsidy;
            },
            getTaxableBase: function(employee, fields, period, calculate) {
                fields = !fields ? {} : fields;
                if (!fields.taxableBase || calculate) {
                    fields.taxableBase = (obj.getSalary(employee, fields, period, calculate) / obj.getDaysWorked(employee, fields, period, calculate)) * (payroll.monthlyWageFactor ? payroll.monthlyWageFactor : 0)
                }
                return fields.taxableBase;
            },
            getLi: function(employee, fields, period, calculate) {
                fields = !fields ? {} : fields;
                if (!fields.li || calculate) {
                    fields.li = findLowerNearest(liConstants, obj.getTaxableBase(employee, fields, period, calculate), "value")
                }
                return fields.li;
            }
        };
        return obj;
    }

}());
/* eslint-disable angular/json-functions */
/* eslint-disable angular/document-service */
/* eslint-disable angular/window-service */
(function () {
    'use strict';

    angular
        .module('fuse')
        .factory('DataF', DataF)

    /**
     * @ngdoc service
     * @name app.core.service:DataF
     * @requires $http
     * @requires $log
     * @requires successAlertS
     * @requires errAlertS
     * @requires $localStorage
     * @requires $firebaseObject
     * @requires $firebaseArray
     * @requires $sessionStorage
     * @requires $q
     * @requires $httpParamSerializer
     * @requires msNavigationService
     * @requires AppF
     * @requires $window
     */

    function DataF(
        $http,
        $log,
        successAlertS,
        errAlertS,
        $filter,
        $firebaseObject,
        $firebaseArray,
        $sessionStorage,
        $q,
        $httpParamSerializer,
        $rootScope,
        AppF
    ) {
        var swUrln = window.__env.serviceWorkerUrl; // + 'api/';
        var swUrl = swUrln + 'api/';
        var root = firebase.database().ref('/');
        function refreshToken() {
            if (AppF.refreshTokenPromise) {
                return AppF.refreshTokenPromise;
            }
            if (!firebase.auth().currentUser) {
                return Promise.reject({ code: 'auth/no-current-user', message: 'No hay un usuario autenticado.' });
            }
            AppF.refreshTokenPromise = firebase.auth().currentUser.getIdToken(false).then(function (token) {
                if (AppF.thisToken !== token) {
                    AppF.thisToken = token;
                    AppF.lastTimeRefresh = new Date().valueOf();
                }
                if (token !== $http.defaults.headers.common.Authorization) {
                    //$log.debug('token refresh');
                    $http.defaults.headers.common.Authorization = '' + token;
                    //$log.debug('http headers set', token);
                }
                return token;
            }).finally(function () {
                AppF.refreshTokenPromise = null;
            });
            return AppF.refreshTokenPromise;
        }

        function getCurrentServerTime() {
            var diff = new Date().valueOf() - AppF.currentTimeStamp;
            return AppF.serverTimeStamp + diff;
        }

        /**
         *  @ngdoc method
         * @name app.core.service:DataF#timeObject
         * @methodOf app.core.service:DataF
         * @description regresa un objecto
         * @param {object} notToLog descripcion
         * @param {object} ob descripcion
         */
        function timeObject(notToLog, ob) {
            var timeO = {
                by: AppF.user.uid,
                onBehalfOf: (AppF.profile.firm) ? AppF.profile.firm : 'TDS',
                atTime: getCurrentServerTime(),
                fromIP: AppF.ip ? AppF.ip : '0.0.0.0'
            };
            if (angular.isDefined(ob) && ob !== null) {
                if (ob.hasOwnProperty('sqlId')) {
                    timeO.sqlId = angular.copy(ob.sqlId);
                }
            }
            return timeO;
        }

        /**
         * @description Hace una llamada Post a las interfaces de la API, asume que se devolverá un archivo
         * @param {String} inter 
         * @param {Object} data 
         * @returns Promesa de llamado al API
         */
        function postInterface(inter, data) {
            return new Promise(function (resolve, reject) {
                refreshToken().then(function () {
                    $http({
                        method: 'POST',
                        url: swUrln + 'interface/' + inter,
                        data: data,
                        responseType: 'arraybuffer'
                    }).then(resolve).catch(reject)
                }).catch(reject);
            });
        }
        function authPost(path) {
            return new Promise(function (resolve, reject) {
                refreshToken().then(function () {
                    return $http({
                        method: 'POST',
                        url: swUrln + 'auth/' + path,
                        responseType: 'json'
                    })
                }).then(resolve).catch(reject);
            })
        }
        // Interfaces
        var interfacesM = {
            post: postInterface
        };
        var authM = {
            post: authPost
        }

        function actionInModel(model, action, data, type) {
            return new Promise(function (resolve, reject) {
                data.userIp = AppF.ip;
                refreshToken().then(function () {
                    $http({
                        method: type ? type : 'POST',
                        url: swUrln + 'models/' + model + '/' + action,
                        data: data,
                        responseType: 'json'
                    }).then(resolve).catch(reject)
                }).catch(reject);
            });
        }

        // FB models
        var modelsM = {
            action: actionInModel
        }

        // TODO: refactorizar toda la factory ya que vamos a usar en el futuro todo salvado en el API

        // Objects
        var filesM = {
            csvToJson: function (formData) {
                return new Promise(function (resolve, reject) {
                    refreshToken().then(function () {
                        $http.post(swUrln + 'files/csvToJson', formData, {
                            transformRequest: angular.identity,
                            headers: {
                                'Content-Type': undefined
                            }
                        }).then(resolve).catch(reject)
                    }).catch(reject);
                });
            },
            getTempUrlFromStorage: function (formData) {
                var newArray = [];
                if (angular.isObject(formData)) {
                    $filter('loopEach')(formData, function (value, key) {
                        newArray.push(key + '=' + value);
                    });
                }
                return refreshToken().then(function () {
                    return $http.get(swUrln + 'files/getTempUrlFromStorage?' + newArray.join('&'));
                });
            },
            checkCerValidation: function (id) {
                return refreshToken().then(function () {
                    return $http.get(swUrln + 'files/checkCerValidation?id=' + id);
                });
            },
            checkCerValidationFiel: function (id) {
                return refreshToken().then(function () {
                    return $http.get(swUrln + 'files/checkCerValidationFiel?id=' + id);
                });
            },
            downloadFileRp: function (fieldFile, fieldName, thisRpIdseRecord) {
                var filePath = thisRpIdseRecord[fieldFile]
                filesM.getTempUrlFromStorage({ filePath: filePath }).then(function (data) {
                    var nameArray = thisRpIdseRecord[fieldFile].split('.');
                    var extension = nameArray[nameArray.length - 1];
                    var url = data.data;
                    var xhr = new XMLHttpRequest();
                    xhr.responseType = 'blob';
                    xhr.onload = function () {
                        var blob = xhr.response;
                        var url = window.URL.createObjectURL(blob);
                        var linkElement = document.createElement('a');
                        linkElement.setAttribute('href', url);
                        linkElement.setAttribute('download', thisRpIdseRecord[fieldName] + '.' + extension);
                        var clickEvent = new MouseEvent('click', {
                            'view': window,
                            'bubbles': true,
                            'cancelable': false
                        });
                        linkElement.dispatchEvent(clickEvent);
                    };
                    xhr.open('GET', url);
                    xhr.send();
                }).catch(errAlertS);
            }
        };
        var api = {
            /**
                @description Borra definitivamente un objeto del API
                @param path (ruta de coleccion con id ej: 'notifications/$id')
                @returns Promesa
            */
            delete: function (path, params) {
                return new Promise(function (resolve, reject) {
                    refreshToken().then(function () {
                        $http.delete(swUrl + path, { params: params }).then(resolve).catch(reject);
                    }).catch(reject);
                });
            },
            /**
                @description Devuelbe una promesa con los datos guardados
                @param collection (ex: 'notifications'), params (ex: {name:'some name'}) 
            */
            add: function (collection, params) {
                return new Promise(function (resolve, reject) {
                    refreshToken().then(function () {
                        $http.post(swUrl + collection, params).then(resolve).catch(reject);
                    }).catch(reject);
                });
            },
            /**
                @description Devuelbe una promesa con los datos guardados
                @param collection (ex: 'notifications'), params (ex: {name:'some name'}) 
            */
            addWithUnique: function (collection, params, uniqueColumn) {
                return new Promise(function (resolve, reject) {
                    refreshToken().then(function () {
                        if (!uniqueColumn) {
                            $http.post(swUrl + collection, params).then(resolve).catch(reject);
                        } else {
                            uniqueColumn = "/" + uniqueColumn;
                            $http.post(swUrl + "u/" + collection + uniqueColumn, params).then(resolve).catch(reject);
                        }
                    }).catch(reject);
                });
            },
            /**
                @description Devuelbe una promesa con los datos guardados
                @param collection (ex: 'notifications'), id (del objeto que se quiere guardar), params (ex: {name:'some name'}) 
            */
            update: function (collection, id, params) {
                return new Promise(function (resolve, reject) {
                    delete params._id; // se limpia el objeto
                    refreshToken().then(function () {
                        $http.put(swUrl + collection + '/' + id, params).then(resolve).catch(reject);
                    }).catch(reject);
                });
            },
            upsert: function (collection, params) {
                return new Promise(function (resolve, reject) {
                    delete params._id; // se limpia el objeto
                    refreshToken().then(function () {
                        $http.put(swUrl + collection + '/upsert', params).then(resolve).catch(reject);
                    }).catch(reject);
                });
            },
            /**
                @name get
                @param path (ex: 'notifications'), query ({to:$id}) 
                @description Devuelbe una promesa con los datos consultados
            */

            get: function (path, query) {
                return new Promise(function (resolve, reject) {
                    var qs = (query) ? $httpParamSerializer(query) : '';
                    refreshToken().then(function () {
                        $http.get(swUrl + path + '?' + qs).then(resolve).catch(reject);
                    }).catch(reject);
                });
            },
            /**
                @name post
                @param path (ex: 'notifications'), query ({to:$id}) 
                @description Devuelbe una promesa con los datos consultados
            */
            post: function (path, query) {
                return new Promise(function (resolve, reject) {
                    var req = {
                        method: 'POST',
                        url: swUrl + path,
                        data: query,
                        transformRequest: function (obj) {
                            var str = [];
                            for (var p in obj) {
                                if (typeof (obj[p]) == "number" || typeof (obj[p]) == "string") {
                                    str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                                } else if (typeof (obj[p]) == "object" && obj[p].length) {
                                    for (var j in obj[p]) {
                                        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(JSON.stringify(obj[p][j])));
                                    }
                                } else {
                                    str.push(encodeURIComponent(p) + "=" + JSON.stringify(obj[p]));
                                }

                            }
                            return str.join("&");
                        },
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded'
                        }
                    }
                    refreshToken().then(function () {
                        $http(req).then(resolve).catch(reject);
                    }).catch(reject);
                });
            },
            /**
                @name get
                @description autocomplete para mongo
            */
            autocomplete: function (catalog, term) {
                return new Promise(function (resolve, reject) {
                    var query = {
                        name: term
                    };
                    var qs = (query) ? $httpParamSerializer(query) : '';
                    refreshToken().then(function () {
                        $http.get(swUrl + 'a/' + catalog + '?' + qs).then(resolve).catch(reject);
                    }).catch(reject);
                });
            },
            /**
                @name get
                @description autocomplete para mongo
            */
            autocompleteMongo: function (search, catalog, fields, extraQuerys, dontAddId) {
                return $q(function (resolve, reject) {
                    var params = {};
                    search = search.toUpperCase();
                    if (fields.length) {
                        if (fields.length > 1) {
                            if (['employees', 'incidences', 'credits', 'movements', 'concepts'].indexOf(catalog) > -1) {
                                params['center'] = $rootScope.F.center;
                            }
                            params['$or'] = [];
                            for (var f in fields) {
                                if (angular.isString(fields[f])) {
                                    var searchField = {};
                                    searchField[fields[f]] = {
                                        '$regex': search
                                    };
                                    params['$or'].push(searchField);
                                }
                            }
                        } else {
                            params[fields[0]] = {
                                '$regex': search
                            };
                        }
                    }
                    for (var e in extraQuerys) {
                        params[e] = extraQuerys[e];
                    }
                    api.get('p/' + catalog, params).then(function (res) {
                        var items = res.data.data;
                        if (!dontAddId) {
                            var tempItems = [];
                            for (var i in items) {
                                var item = items[i];
                                item.$id = item.fid;
                                tempItems.push(item);
                            }
                            items = tempItems;
                        }
                        resolve(items);

                    }).catch(function (err) {
                        reject(err);
                    });
                });

            }
        };

        var scopeFns = {
            getThem: function (N, scope, params, page, size) {
                if (N.apiMode) {
                    if (page) params.page = page;
                    if (size) params.size = size;
                    api.get(N.info.name[1], params).then(function (res) {
                        scope[N.info.name[1]] = res.data.data;
                        scope.pagination = res.data.pagination;
                        //scope.paginantion.totalPages = Math.ceil(scope.pagination.total / F.pagination);
                        scope.loading = false;
                    });
                } else {
                    var ref = (N.collectionOfUser) ? getRef(N.ref.ofUser(AppF.user.uid)) : DataF.getRef(N.ref.node);
                    scope[N.info.name[1]] = $firebaseArray(ref);
                    scope[N.info.name[1]].$loaded().then(function (data) {
                        scope[N.info.name[1]] = data;
                        scope.loading = false;
                    });
                }
            }
        };

        // functions

        var getRef = function (ref) {
            return root.child(ref);
        };
        var realDelete = function (ref, msg, deleted, promise) {
            return $q(function (resolve, reject) {
                deleted = (deleted) ? 'deleted/' : '';
                msg = (msg) ? msg : 'Borrado definitivamente';
                root
                    .child(deleted + ref)
                    .remove()
                    .then(function () {
                        if (!promise) {
                            successAlertS(msg);
                        }
                        resolve(true);

                    })
                    .catch(function (error) {
                        if (!promise) {
                            errAlertS
                        }
                        reject(error);
                    });
            });

        };
        var archiveIt = function (fromRef, toCol, msg) {
            /*
                @name archiveIt
                @params fromRef, toCollection, successMsg (optional)
                @description Archiva el objeto de un array de FB en el API histórico
            */
            // read FB ref once
            root
                .child(fromRef)
                .once('value', function (snap) {
                    var params = snap.val();
                    var key = snap.key;

                    params._id = key;
                    var archived_at = moment().valueOf()
                    //console.log(moment().toDate, moment().valueOf(), moment().toDate());
                    params.archived_at = archived_at;
                    // set it in API
                    $http.post(swUrl + toCol, params).then(function () {
                        // delete FB ref
                        realDelete(fromRef, msg);
                    }).catch(errAlertS);
                });
        };
        var retriveIt = function (fromCol, toRef, msg) {
            // get it from API
            $http.get(swUrl + fromCol).then(function (res) {
                var data = res.data;
                delete data.archived_at;
                delete data._id;
                // set it in FB
                root
                    .child(toRef)
                    .set(data, function (err) {
                        if (!err) {
                            // delete it from API
                            $http.delete(swUrl + fromCol).then(function () {
                                if (msg) successAlertS(msg);
                            }).catch(errAlertS);
                        } else {
                            errAlertS(err);
                        }
                    });
            }).catch(errAlertS);
        };
        var moveTo = function (fromRef, toRef, msg, promise) {
            if (promise) {
                return $q(function (resolve, reject) {
                    root.child(fromRef).once('value', function (snap) {
                        var updates = {};
                        updates[fromRef] = null;
                        updates[toRef] = snap.val();
                        root.update(updates).then(function () {
                            resolve(true);
                        }, function (error) {
                            reject(error);
                        });
                    }, function (error) {
                        reject(error);
                    });
                })
            } else {
                root.child(fromRef).once('value', function (snap) {
                    var updates = {};
                    updates[fromRef] = null;
                    updates[toRef] = snap.val();
                    root.update(updates).then(function () {
                        successAlertS(msg);
                    }, function (error) {
                        errAlertS(error);
                    });
                }, function (error) {
                    errAlertS(error);
                });
            }

        };
        var setIt = function (ref, object, msg, createdAt, updatedAt, promise) {
            var obj = {
                data: object
            };
            if (createdAt) obj.created = timeObject();
            if (updatedAt) obj.updated = timeObject();
            if (promise) {
                return root
                    .child(ref)
                    .set(obj);
            } else {
                root
                    .child(ref)
                    .set(obj, function (err) {
                        if (!err) {
                            if (msg) successAlertS(msg);
                        } else {
                            errAlertS(err);
                        }
                    });
            }

        };
        var addIt = function (ref, object, msg, promise) {
            object.created = timeObject();
            if (promise) {
                return root
                    .child(ref)
                    .push(object);
            } else {
                root
                    .child(ref)
                    .push(object, function (err) {
                        if (!err) {
                            if (msg) successAlertS(msg);
                        } else {
                            errAlertS(err);
                        }
                    });
            }

        };

        /**
         * @description Manda a la papelera un objeto con la misma referencia que tenia para poder restablecer, agrega deleted_at al objeto
         * @param ref Referencia a borrar
         * @param successMsg Mensaje de éxito
         * @param promise Si es promesa o no
         */
        function deleteIt(ref, msg, promise) {
            // read ref
            if (promise) {
                root.child(ref).once('value', function (snap) {
                    var data = snap.val();
                    data.deleted = timeObject();
                    // move ref to deleted
                    root.child('deleted/' + ref).set(data, function (err) {
                        if (!err) {
                            // delete original ref
                            return realDelete(ref, msg, false, true);
                        } else {
                            errAlertS(err)
                        }
                    });
                });
            } else {
                root.child(ref).once('value', function (snap) {
                    var data = snap.val();
                    data.deleted = timeObject();
                    // move ref to deleted
                    root.child('deleted/' + ref).set(data, function (err) {
                        if (!err) {
                            // delete original ref
                            realDelete(ref, msg);
                        } else {
                            errAlertS(err)
                        }
                    });
                });
            }
        }

        /**
            @description Saca de la papelera la referencia, la mete en la referencia deseada, borra el objeto de la papelera
            @param {String} ref (ex: 'notifications/$userId/$notificationId'), 
            @param {String} msg (ex: 'Se restableció con éxito el nodo'), 
            @param {Boolean} promise Si es promesa o no
        */
        function undeleteIt(ref, msg, promise) {
            if (promise) {
                root.child('deleted/' + ref).once('value', function (snap) {
                    var data = snap.val();
                    delete data.deleted;

                    root.child(ref).set(data, function (err) {
                        if (!err) {
                            return realDelete(ref, msg, true, true);
                        } else {
                            errAlertS(err)
                        }
                    });
                });
            } else {
                root.child('deleted/' + ref).once('value', function (snap) {
                    var data = snap.val();
                    delete data.deleted;

                    root.child(ref).set(data, function (err) {
                        if (!err) {
                            realDelete(ref, msg, true);
                        } else {
                            errAlertS(err)
                        }
                    });
                });
            }
        }

        /** TODO: documentación
         * @description
         */
        function logout() {
            $rootScope.$emit('loggedOut');
        }

        /** TODO: documentación y checar si es necesaria
         * @description
         * @param {*} object 
         * @param {*} createdAt 
         * @param {*} updatedAt 
         * @param {*} respect 
         * @returns 
         */
        function prepareObject(object, createdAt, updatedAt, respect) {
            var obje = {};
            if (respect) {
                obje = object;
            } else {
                obje = (!object.hasOwnProperty('data')) ? {
                    data: object
                } : object;
            }
            if (createdAt) obje.created = timeObject();
            if (updatedAt) obje.updated = timeObject();
            return obje;
        }

        var obj = {
            prepareObject: prepareObject,
            api: api,
            scope: scopeFns,
            archiveIt: archiveIt,
            retriveIt: retriveIt,
            moveTo: moveTo,
            getRef: getRef,
            set: setIt,
            add: addIt,
            delete: deleteIt,
            undelete: undeleteIt,
            realDelete: realDelete,
            getTimeObject: timeObject,
            logout: logout,
            auth: authM,
            files: filesM,
            interfaces: interfacesM,
            models: modelsM,
            getCurrentServerTime: getCurrentServerTime
        };

        return obj;
    }

}());

(function () {
    'use strict';

    angular
        .module('fuse')
        .factory('ChatF', ChatF);

    // Replace lists in F
    function ChatF($log, $filter, $firebaseArray, $firebaseObject, $q, AppF, getSomethingOfArrayFBFilter, ListsF, $rootScope) {
        var obj = {
            init: init,
            setUserStatus: setUserStatus,
            getFriendStatus: getFriendStatus,
            addChatByProfileId: addChatByProfileId,
            sendMsg: sendMsg,
            changeUnreadedMsg: changeUnreadedMsg,
            loadConversation: loadConversation,
            loaded: false
        };

        function init() {
            if (!obj.loaded) {
                obj.loaded = true;
                if (AppF.isDistributor()) {
                    AppF.root.child('profiles').orderByChild('center').equalTo(AppF.profile.firm).on('child_added', function (snapshot) {
                        addContact(snapshot.val());
                    });
                    AppF.root.child('profiles').orderByChild('center').equalTo(AppF.profile.firm).on('child_changed', function (snapshot) {
                        updateStatus(snapshot.val());
                    });
                } else {
                    AppF.root.child('profiles').orderByChild('firm').equalTo(AppF.center).on('child_added', function (snapshot) {
                        var profileId = snapshot.key;
                        var payrolls = $filter('getArrayOfIds')(ListsF.payrolls);
                        var promises = [];
                        for (var p = 0; p < payrolls.length; p++) {
                            var payroll = payrolls[p];
                            promises.push(ListsF.loadList('involverRecords', 'catalogs/involvedRecords/collection', undefined, 'array', 'involvedOfPayroll' + payroll, [{ q: 'orderByChild', v: 'payroll' }, { q: 'equalTo', v: payroll }]));
                        }
                        Promise.all(promises).then(function (involvedArray) {
                            var isInvolved = false;
                            for (var i = 0; i < involvedArray.length; i++) {
                                for (var a = 0; a < involvedArray[i].length; a++) {
                                    var involved = involvedArray[i][a];
                                    if (angular.isObject(involved) && angular.isObject(involved.payrollUsers) && angular.isDefined(involved.payrollUsers[profileId])) {
                                        isInvolved = true;
                                    }
                                }
                            }
                            if (isInvolved) {
                                addContact(snapshot.val());
                            }
                        });

                    });
                    AppF.root.child('profiles').orderByChild('firm').equalTo(AppF.center).on('child_changed', function (snapshot) {
                        updateStatus(snapshot.val());
                    });

                    AppF.root.child('profiles').orderByChild('firm').equalTo(AppF.profile.firm).on('child_added', function (snapshot) {
                        addContact(snapshot.val());
                    });
                    AppF.root.child('profiles').orderByChild('firm').equalTo(AppF.profile.firm).on('child_changed', function (snapshot) {
                        updateStatus(snapshot.val());
                    });
                }
                // @todo:carlos veo que estas llamando child_added acuérdate que eso trae todos los registros no solo los agregados, hay que optimizar esta consulta solo para los que tienen fecha y hora mayor a la actual (para mas referencias checa como lo hice en tasks.js por ejemplo en la linea 416)
                AppF.root.child('profiles/' + AppF.profile.uid + '/chats').on('child_added', function (snapshot) {
                    var chatHeader = snapshot.val();
                    AppF.root.child('chats/' + chatHeader.idchat).on('value', function (snapshot) {
                        var chat = snapshot.val();

                        if (chat !== null) {
                            chat.id = snapshot.key;
                            addChat(chat);
                        } // @todo:carlos poner aquí lo que debe ir en default, to asumo si no esta no se agrega el chat.
                    });
                });
                obj.loaded = true;
            }
        }



        function getFriendStatus(participants) {
            if (Object.keys(participants).length === 2) {
                var friendId = false;
                angular.forEach(participants, function (participant, id) {
                    if (id !== AppF.profile.$id) {
                        friendId = id;
                        return false;
                    }
                });
                if (friendId) {
                    var status = getSomethingOfArrayFBFilter(friendId, obj.contacts, 'status', '', 'id');
                    return status;
                }
            }
        }

        function setUserStatus(status) {
            AppF.root.child('profiles').child(AppF.profile.$id).update({
                status: status
            });
        }


        function addChatByProfileId(profileId) {
            var addNew = true;
            var key = null;
            angular.forEach(obj.chats, function (chat, keyChat) {
                angular.forEach(chat.participants, function (participant) {
                    if (profileId === participant.idprofile) {
                        key = keyChat;
                        addNew = false;
                        return false;
                    }
                });
            });
            if (addNew) {
                var newChat = {
                    participants: {}
                };
                newChat.participants[profileId] = {
                    idprofile: profileId,
                    'unreaded_msg': 0
                };
                newChat.participants[AppF.profile.uid] = {
                    idprofile: AppF.profile.uid,
                    'unreaded_msg': 0
                };
                key = addChat(newChat);
                return key;
            } else {
                return key;

            }
        }

        function sendMsg(activeChat, msg) {
            var isNew = activeChat.id ? false : true;
            var chatId;
            if (isNew) {//si el chat es nuevo se obtiene una nueva key para guardar los datos
                activeChat.id = AppF.root.child('chats').push().key;
            }
            chatId = activeChat.id;
            var updatesPr = {};
            var updatesCo = {};
            var updatesCh = {};
            //se recorre cada uno de los participantes para aumentar los mensaje no Leidos
            angular.forEach(activeChat.participants, function (value, key) {
                var notReaded = 0;
                if (activeChat.participants[key]['idprofile'] !== AppF.profile.uid) {//Si no soy yo aumento en 1 los mensajes no leídos
                    if (angular.isDefined(activeChat.participants[key]['unreaded_msg'])) {//Puede que existan mensajes no leídos por lo que recupero el contador en caso de haberlo
                        notReaded = activeChat.participants[key]['unreaded_msg'];
                    }
                    notReaded = notReaded + 1;
                }
                updatesCh['participants/' + key + '/unreaded_msg'] = notReaded;
                updatesCh['participants/' + key + '/archived'] = null;
                updatesPr[key + '/chats/' + chatId + '/unreaded_msg'] = notReaded;
                updatesPr[key + '/chats/' + chatId + '/idchat'] = chatId;
            });
            var thisTimeStamp = firebase.database.ServerValue.TIMESTAMP;
            if (isNew) { //si el chat es nuevo se le pone una fecha de creación
                updatesCh['date_created'] = thisTimeStamp;
            }
            //se crea o actualiza el nuevo chat
            updatesCh['id'] = chatId;
            updatesCh['last_msg'] = msg;
            updatesCh['date_updated'] = thisTimeStamp;
            //se inserta una nueva conversación
            var msgId = AppF.root.child('conversations').push().key;
            updatesCo['idprofile'] = AppF.profile.uid;
            updatesCo['msg'] = msg;
            updatesCo['time'] = thisTimeStamp;
            //se actualiza el nodo de chat con esta nueva información
            var promises = [
                AppF.root.child('chats/' + chatId).update(updatesCh),
                AppF.root.child('profiles').update(updatesPr),
                AppF.root.child('conversations/' + chatId + '/' + msgId).update(updatesCo)
            ];
            Promise.all(promises).then(function () {
                if (isNew) {
                    var index = obj.chats.findIndex(function (item) {
                        return item.id === chatId;
                    });
                    if (index > -1) {
                        obj.loadConversation(obj.chats[index]);
                    }
                }
            }).catch(function (error) {
                $log.error(error);
            });
        }

        function changeUnreadedMsg(chat) {
            if (chat.id) {
                AppF.root.child('chats/' + chat.id + '/participants/').child(AppF.profile.uid).update({
                    'unreaded_msg': 0
                });
                AppF.root.child('profiles/' + AppF.profile.uid + '/chats').child(chat.id).update({
                    'unreaded_msg': 0
                });
            }
        }

        function loadConversation(chat) {
            if (!chat.conversation.items) {
                chat.conversation = AppF.paginator(AppF.root.child('conversations/' + chat.id), 10, 'time', 'nuevoMensajeCargado');
            }
        }

        function updateStatus(contact) {
            var records = $filter('filter')(obj.contacts, {
                id: contact.uid
            });
            if (records && records.length) {
                var index = obj.contacts.indexOf(records[0]);
                if (index >= 0) {
                    obj.contacts[index].status = contact.status ? contact.status : 'offline';
                }
            }
            $rootScope.$evalAsync();
        }

        function addContact(contact) {
            if (contact.uid !== AppF.profile.uid && contact.data && contact.active) {
                contact = {
                    id: contact.uid,
                    name: contact.data.name,
                    email: contact.data.email,
                    active: contact.active,
                    status: contact.status ? contact.status : 'offline',
                    avatar: angular.isDefined(contact.avatar) ? contact.avatar : 'assets/images/avatars/profile.jpg'
                };
                if (angular.isUndefined(obj.contacts)) { obj.contacts = []; }
                obj.contacts.push(contact);
            }
            // $log.log( obj.contacts);
        }

        function addChat(chat) {
            if (angular.isUndefined(obj.chats)) { obj.chats = []; }
            var otherParticipant = -1;
            if (Object.keys(chat.participants).length === 2) {
                for (var participantId in chat.participants) {
                    if (chat.participants.hasOwnProperty(participantId)) {
                        if (participantId !== AppF.profile.uid) {
                            otherParticipant = participantId;
                        }
                    }
                }
            }
            var chatIndex = -1;
            if (chat.id) {
                chatIndex = obj.chats.findIndex(function (item) {
                    return item.id === chat.id;
                });
            }
            if (chatIndex === -1) {
                obj.chats.push({});
                chatIndex = obj.chats.length - 1;
            }
            if (chat.id) {
                obj.chats[chatIndex].id = chat.id;
            }
            obj.chats[chatIndex].participants = chat.participants;
            obj.chats[chatIndex].otherParticipant = otherParticipant;
            obj.chats[chatIndex]['last_msg'] = chat['last_msg'];
            obj.chats[chatIndex]['unreaded_msg'] = chat.participants[AppF.profile.uid]['unreaded_msg'];
            obj.chats[chatIndex].archived = chat.participants[AppF.profile.uid].archived;
            obj.chats[chatIndex].name = $filter('getChatName')(obj.chats[chatIndex], obj.contacts, AppF.profile);
            obj.chats[chatIndex].avatar = $filter('getAvatar')(obj.chats[chatIndex], obj.contacts, AppF.profile);
            if (angular.isUndefined(obj.chats[chatIndex].conversation)) {
                obj.chats[chatIndex].conversation = {};
            }

            return chatIndex;
        }
        return obj;
    }

}());
(function(){
    'use strict';

    angular
        .module('fuse')
        .factory('CatalogsZF', CatalogsZF)

    // ment to replace scopes filtered in crud lists
    function CatalogsZF(){
        var obj = {
        }
        return obj;
    }

}());
(function () {
    'use strict';

    angular
        .module('fuse')
        .factory('CatalogsF', CatalogsF)

    /**
     * @ngdoc service
     * @name app.core.service:CatalogsF
     * @requires $firebaseArray
     * @requires $firebaseObject
     * @requires $q
     * @requires $log
     * @requires $mdDialog
     * @requires AppF
     * @requires DataF
     * @requires RoutesF
     * @requires confirmConfig
     * @requires errAlertS
     * @requires successAlertS
     * @requires objectsLengthFilter
     * @requires isThereChildDataFilter
     * @requires constructMsgFilter
     * @requires imageTypeFilter
     * @requires clearObjectFilter
     * @requires translateFilter
     * @requires $rootScope
     * @requires $filter
     * @requires $http
     */

    // ment to replace scopes in crud lists
    function CatalogsF(
        $firebaseArray,
        $firebaseObject,
        $q,
        $log,
        $mdDialog,
        AppF,
        DataF,
        RoutesF,
        confirmConfig,
        errAlertS,
        successAlertS,
        objectsLengthFilter,
        isThereChildDataFilter,
        constructMsgFilter,
        imageTypeFilter,
        clearObjectFilter,
        translateFilter,
        $rootScope,
        $filter,
        $http
    ) {
        var concepts = { ref: function () { return 'lists/concepts/center/' + AppF.center; }, catalog: 'concepts' };
        var paymentSchemas = { catalog: 'paymentSchemas', query: 'center', val: function () { return AppF.center; } };
        var firms = { catalog: 'firms', query: 'center', val: function () { return AppF.center; } };
        var obj = {
            // catalogs
            loadData: {
                humandCatalogs: [firms],
                accountingAccounts: ['accountAccVars'],
                payrolls: [paymentSchemas],
                operationConstants: ['customFields'],
                operations: [concepts],
                contracts: [],
                employeeBirths: [],
                anniversaryEmployees: [],
                saludRecords: [],
                documentTypes: [],
                rpIdseRecords: [],
                batchRecords: []
            },
            // methods
            /**
                @param catalog: not required if filterName provided
                @param ref: not required if catalog provided
                @param query: not required
                @param val: not required in case of all needed
                @param type: not required 'object' || 'array' (default)
                @param filterName: not required just incase of filter needed
                @param startAt not required
                @param endAt not required
                @param limit not required
            */
            loadCatalog: function (catalog, ref, query, val, type, filterName, startAt, endAt, limit) {
                if (!catalog && !filterName) catalog = AppF.active.menuName;
                var catalogName = (filterName) ? filterName : catalog;
                if (!type || angular.isUndefined(type)) type = 'array';
                if (!ref || angular.isUndefined(ref) && catalog) ref = RoutesF.dinamicRefs[catalog]; //'catalogs/' + catalog + '/collection'
                if (angular.isFunction(ref)) {
                    ref = ref();
                }
                if (!obj[catalogName]) obj[catalogName] = [];
                var defered = $q.defer();
                // add childs as needed TODO:backlog agregar childs dinamicamente
                var loadFromFB = function (cName, fbRefObj, type, val) {
                    var askit = function (cName, fName) {
                        obj[cName] = (type != 'object') ?
                            $firebaseArray(fbRefObj) :
                            $firebaseObject(fbRefObj);
                        obj[cName].$loaded().then(function (cat) {
                            $log.debug('Loading catalog from FB in ' + fName, {
                                catFromFb: cat,
                                ref: ref,
                                query: query,
                                val: val,
                                cName: cName,
                                fName: fName,
                                limit: limit,
                                fbRefObj: fbRefObj,
                                from: 'C.loadCatalog()'
                            });
                            obj[cName] = cat;
                            defered.resolve(cat);
                        }, function (err) {
                            errAlertS(err);
                            defered.reject(err);
                        });
                    }
                    var fName = 'C.' + cName;
                    if (obj[cName]) delete obj[cName];
                    askit(cName, fName);
                }

                var doQuery = function (reff) {
                    if (reff.search(':') !== -1) reff = RoutesF.convertDinamicRef(reff);
                    var fbref;
                    if (angular.isDefined(val) && query && !startAt && !endAt) {
                        fbref = (val == 'all') ?
                            AppF.root.child(reff) :
                            AppF.root.child(reff).orderByChild(query).equalTo(val);
                    } else if (query && !val) {
                        fbref = AppF.root.child(reff).orderByChild(query);
                    } else {
                        fbref = AppF.root.child(reff);
                    }

                    if (startAt || endAt) {
                        if (query) {
                            fbref = AppF.root.child(reff).orderByChild(query);
                        } else {
                            fbref = AppF.root.child(reff);
                        }

                        if (startAt && endAt) {
                            fbref = fbref.startAt(startAt).endAt(endAt);
                        } else if (startAt && !endAt) {
                            fbref = fbref.startAt(startAt);
                        } else if (!startAt && endAt) {
                            fbref = fbref.endAt(endAt);
                        }
                    }

                    if (limit) {
                        if (limit.first) fbref = fbref.limitToFirst(limit.limit);
                        else fbref = fbref.limitToLast(limit.limit);
                    }


                    if (!filterName) {
                        loadFromFB(catalogName, fbref, type);
                    } else {
                        if (!RoutesF.states.fb[catalog]) {
                            $log.error('Falta configurar R.states.fb.' + catalog, {
                                from: 'C.loadCatalog()',
                                catalog: catalog,
                                catalogName: catalogName,
                                type: type,
                                ref: ref,
                                val: val,
                                filterName: filterName
                            });
                            defered.reject();
                        }
                        var filter = RoutesF.states.fb[catalog].filter;
                        if (filter && val) {
                            // en caso de tener childRef agregarlo a el objeto C.cat.fVal.val;
                            if (filter.childRef) {
                                var filterVal = filter.val();
                                if (filterVal) {
                                    if (filterVal == val) {
                                        loadFromFB(catalog, fbref, type, filterVal);
                                    } else {
                                        loadFromFB(catalog, fbref, type, filterVal, val);
                                    }
                                } else {
                                    $log.error('Falta configurar filter.val() para ' + catalog, {
                                        from: 'C.loadCatalog()',
                                        catalog: catalog,
                                        catalogName: catalogName,
                                        type: type,
                                        ref: ref,
                                        val: val,
                                        filterName: filterName
                                    });
                                    defered.reject();
                                }
                            } else {
                                loadFromFB(catalogName, fbref, type, val);
                            }
                        } else {
                            loadFromFB(catalogName, fbref, type, val);
                        }
                    }
                }

                doQuery(ref);

                return defered.promise;
            },
            uploadFile: function (files, object, imageName, returnFilePath, returnObj) {
                var promise = $q.defer();
                $log.debug('uploading image', files, object);
                var file = files[0].lfFile;
                var storageRef = firebase.storage().ref();
                var finalRef = AppF.active.menuName + '/';
                var imagesRef = storageRef.child(AppF.active.menuName + '/');
                var mimeType = file.type;
                var type;
                if (mimeType !== "") {
                    type = imageTypeFilter(mimeType);
                } else {
                    type = imageTypeFilter(file.name, 1);
                }
                var fileName = (angular.isDefined(imageName) ? imageName : AppF.active.imageName) + type;
                finalRef += (object.$id + "/" + fileName);
                var spaceRef = imagesRef.child(object.$id).child(fileName);
                // var path = spaceRef.fullPath;
                var uploadTask = spaceRef.put(file);
                uploadTask.on('state_changed', function (snapshot) {
                    AppF.progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                    $log.debug('Upload is ' + AppF.progress + '% done');
                    switch (snapshot.state) {
                        case firebase.storage.TaskState.PAUSED: // or 'paused'
                            $log.debug('Upload is paused');
                            break;
                        case firebase.storage.TaskState.RUNNING: // or 'running'
                            $log.debug('Upload is running');
                            break;
                    }
                }, function (err) {
                    errAlertS(err);
                    promise.reject(err);
                }, function () {
                    AppF.progress = 0;
                    if (returnObj) {
                        promise.resolve({ url: uploadTask.snapshot.downloadURL, path: finalRef });
                    } else if (returnFilePath) {
                        promise.resolve(finalRef);
                    } else {
                        promise.resolve(uploadTask.snapshot.downloadURL);
                    }

                });
                return promise.promise;
            },
            removeFile: function (path) {
                var storageRef = firebase.storage().ref();
                var desertRef = storageRef.child(path);
                return desertRef.delete()
            },
            removeUpload: function (object, orReject, filePath) {
                return new Promise(function (resolve, reject) {
                    var fileUrl = object[angular.isDefined(filePath) ? filePath : AppF.active.imageName];
                    var ext = imageTypeFilter(fileUrl, 1);
                    var fileName = (angular.isDefined(filePath) ? filePath : AppF.active.imageName) + ext;
                    // Create a reference to the file to delete
                    var storageRef = firebase.storage().ref();
                    var desertRef = storageRef.child(AppF.active.menuName + '/' + object.$id + '/' + fileName);
                    // Delete the file
                    desertRef.delete().then(function () {
                        resolve(true);
                    }).catch(function (err) {
                        if (!orReject) {
                            $log.error('No se encontró archivo para borrarse ' + desertRef);
                            resolve(false);
                        } else {
                            errAlertS(err);
                            reject(err);
                        }
                    });
                });
            },
            /**
             * @ngdoc method
             * @name app.core.service:CatalogsF#deleteSafe
             * @methodOf app.core.service:CatalogsF
             * @description Borra los objetos seleccionados de un catálogo preguntando y validando si es seguro o no borrar dado a sus datos hijos
             */
            deleteSafe: function (e, parent, catalog, selected, scope) {
                if (['calcField', 'cc', 'companiesRecord', 'credit', 'dispersion', 'employee', 'firm', 'incidencesRequest', 'incidencesType', 'involvedRecord', 'movement', 'operation', 'paymentSchema', 'payrollCalendar', 'payroll', 'project', 'rp'].indexOf(catalog) !== -1) {
                    parent = 'catalogs';
                } else if (['group', 'profile'].indexOf(catalog) !== -1) {
                    parent = false;
                }
                var name = translateFilter(catalog + '.SINGULAR');
                $log.debug(catalog, selected, 'deleting safely from FB');
                var catalogs = catalog + 's';
                var remove = function (object) {
                    return new Promise(function (resolve, reject) {
                        $log.debug('removing: ' + name, object.$id, catalog);
                        var typeOfCatalog = (RoutesF.fbCatalogs.indexOf(catalogs) !== -1) ? 'fb' : 'mongo';
                        var filter = RoutesF.states[typeOfCatalog][catalogs].filter;
                        if (RoutesF.states[typeOfCatalog][catalogs].filters) filter = RoutesF.states[typeOfCatalog][catalogs].filters[0];
                        // var ref = RoutesF.constructFilterRef(filter, 0, 1);
                        var ref = RoutesF.constructDinamicRef(catalogs, filter, 0, 1, scope, object);
                        $log.debug(ref, object, 'ref and obj to delete');
                        if (object.logo || object.avatar || object.file) {
                            Promise.all([
                                obj.removeUpload(object),
                                AppF.root.child(ref).child(object.$id).set(null)
                            ]).then(resolve).catch(reject);
                        } else {
                            AppF.root.child(ref).child(object.$id).set(null).then(resolve).catch(reject);
                        }
                    });
                }
                var deleteThem = function () {
                    var count = 0;
                    var promise = $q.defer();
                    $log.debug('Deleting: ', selected);
                    angular.forEach(selected, function (cat) {
                        if (!AppF.safeDelete[catalog]) {
                            remove(cat).then(function () {
                                count++
                                if (count == selected.length) {
                                    successAlertS('Se borraron ' + count + ' ' + name + '(s)');
                                    promise.resolve(true);
                                }
                            }, function (err) {
                                errAlertS(err);
                                promise.reject(err);
                            });
                        }
                    });
                    return promise.promise;
                }
                var askIfDelete = function (msg) {
                    var promise = $q.defer();
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                    var title = 'Quiere borrar ' + selected.length + ' ' + name + '(s) ?';
                    $mdDialog
                        .show($mdDialog
                            .confirm(confirmConfig)
                            .title(title)
                            .htmlContent(msg)
                            .ariaLabel('Deleting')
                            .targetEvent(e)
                            .ok('Borrar')
                            .cancel('Cancelar'))
                        .then(function () {
                            $rootScope.loadingProgress = true;
                            deleteThem().then(function () {
                                promise.resolve(true);
                            }, function (err) {
                                errAlertS(err);
                                promise.reject(err);
                            });
                        }, function () {
                            $log.debug('Deleting Cancelled');
                        });
                    return promise.promise;
                }
                return isThereChildDataFilter(parent, catalogs, selected).then(function (hasData) {
                    $log.debug('hasData', catalogs, hasData);
                    var msg = '';
                    if (!hasData) {
                        msg += (!AppF.safeDelete[catalog]) ?
                            'No podrá recuperar sus datos.' :
                            'Podrá recuperar sus datos en la papelera.';
                        return askIfDelete(msg);
                    } else {
                        var deleteInCascade = [];
                        //var deleteInCascade = isThereDeleteInCascadeFilter('catalogs','payrolls');
                        for (var catalogg in hasData) {
                            var deleteIt = !hasData[catalogg];
                            if (deleteIt) deleteInCascade.push(catalogg);
                        }
                        if (objectsLengthFilter(hasData) <= deleteInCascade.length) { // es seguro borrar los datos en cascada
                            msg = constructMsgFilter('Cuidado!! Esto ocasionará que se borren datos relacionados en cascada: ', deleteInCascade, false, 'menuName');
                            return askIfDelete(msg);
                        } else { // no es seguro
                            msg = constructMsgFilter('No es posible borrar los datos debido a que tiene datos dependientes: ', hasData, false, 'menuName', true);
                            return errAlertS(msg);
                        }
                    }
                }, errAlertS);
            },
            saveSimple: function (id, value, ppath, catalog, ref, dontAlert, promise, otherRefs) {
                if (angular.isDefined(value)) {
                    if (!promise) var defered = $q.defer();
                    if (!ref) ref = RoutesF.constructDinamicRef(catalog, AppF.active.filter, false);
                    var updated = DataF.getTimeObject();
                    // var updatesIn = AppF.root.child(RoutesF.dinamicRefs[catalog]).child(id);

                    var updates = {};
                    updates[id + '/updated'] = updated;
                    if (angular.isString(ppath)) {
                        updates[id + '/' + ppath] = value;
                    } else if (angular.isArray(ppath)) {
                        for (var i = 0; i < ppath.length; i++) {
                            updates[id + '/' + ppath[i]] = value;
                        }
                    }
                    var promises = [
                        AppF.root.child(ref).update(updates)
                    ];
                    if (angular.isString(otherRefs)) {
                        promises.push(AppF.root.child(otherRefs).set(value));
                    }
                    if (promise) {
                        return Promise.all(promises);
                    } else {
                        Promise.all(promises).then(function () {
                            if (!dontAlert) successAlertS('Guardado');
                            defered.resolve(true);
                        }, function (err) {
                            if (!dontAlert) errAlertS(err);
                            defered.reject(err);
                        });
                    }
                    if (!promise) return defered.promise;
                } else {
                    $log.error('Valor no existente, no se actualizó el dato');
                }
            },
            // @todo:backlog revisar si se va a usar y si no borrar
            saveCatalog: function (catalog, cName, ref) {
                $log.debug(catalog, 'saving on FB');
                var id = catalog.$id;
                catalog.updated = DataF.getTimeObject();
                var object = clearObjectFilter(catalog);
                return (ref) ? AppF.root.child(ref).child(id).set(object) :
                    AppF.root.child(RoutesF.refs[cName]).child(id).set(object);
            },
            // @todo:backlog revisar si se va a suar y si no borrar
            addCatalog: function (catalog, cName, ref) {
                $log.debug(catalog, 'adding on FB');
                catalog.created = DataF.getTimeObject();
                var object = clearObjectFilter(catalog);
                return (ref) ? AppF.root.child(ref).push(object) :
                    AppF.root.child(RoutesF.refs[cName]).push(object);
            },
            exportDataToExcel: function (allData, exportId, selected, refToExport, currentPage, paginate, url) {
                var elementsToExport;
                var title = "";
                var msg = "";
                url = url ? url : "interface/exportFBDataById";
                var currentData = $filter("limitTo")(allData, paginate, (currentPage - 1) * paginate);
                if (selected.length) {
                    if (selected.length == currentData.length) {
                        msg = "Todos los registro seran exportados";
                        elementsToExport = $rootScope.F.filteredItems;
                    } else {
                        msg = "Los registros seleccionados seran exportados";
                        elementsToExport = selected;
                    }
                } else {
                    msg = "Todos los registros de esta pagina seran exportados";
                    elementsToExport = currentData;
                }
                if (elementsToExport) {
                    if (elementsToExport.length) {
                        title = "Se exportaran " + elementsToExport.length + " registros";
                        $mdDialog.show(
                            $mdDialog.confirm(confirmConfig)
                                .title(title)
                                .content(msg)
                                .ariaLabel('Cambiar Fechas')
                                .ok('Aceptar')
                                .cancel('Cancelar')
                        ).then(function () {
                            var ids = $filter('getArrayOfIds')(elementsToExport);
                            var data = {
                                ref: refToExport,
                                ids: ids.toString()
                            };
                            if (exportId) data.exportId = exportId;
                            obj.exportToExcel(url, data);
                        });
                    } else {
                        errAlertS("No hay nada para exportar");
                    }
                } else {
                    errAlertS("No hay nada para exportar");
                }
            },
            exportData: function (allData, selected, refToExport, exportId, dbtype, queries, totalResults, glue, includeRowNumber, includeHeader, exportType) {
                var elementsToExport;
                var title = '';
                var msg = '';
                var exportByQuery = false;
                var url = 'interface/export';
                if (selected.length && selected.length === allData.length) {
                    msg = 'Todos los registro serán exportados';
                    exportByQuery = true;
                    title = 'Se exportaran ' + totalResults + ' registros';
                } else if (selected.length) {
                    msg = 'Los registros seleccionados serán exportados';
                    elementsToExport = selected;
                    title = 'Se exportaran ' + elementsToExport.length + ' registros';
                } else {
                    msg = 'Todos los registros de esta pagina serán exportados';
                    elementsToExport = allData;
                    title = 'Se exportaran ' + elementsToExport.length + ' registros';
                }
                if ((elementsToExport && elementsToExport.length) || exportByQuery) {
                    $mdDialog.show(
                        $mdDialog.confirm(confirmConfig)
                            .title(title)
                            .content(msg)
                            .ariaLabel('Exportar Datos')
                            .ok('Aceptar')
                            .cancel('Cancelar')
                    ).then(function () {
                        var query = queries;
                        if (!exportByQuery) {
                            query = {
                                sort: angular.isObject(queries) ? queries.sort : undefined
                            };
                            var fids = $filter('getArrayOfIds')(elementsToExport);
                            if (fids.length > 0) {
                                query.fid = { $in: fids };
                            } else {
                                var _ids = $filter('getArrayOfIds')(elementsToExport, '_id');
                                query._id = { $in: _ids };
                            }
                        }
                        var thisQuery = { query: angular.toJson(query) };
                        thisQuery.catalog = refToExport;
                        thisQuery.dbtype = dbtype;
                        thisQuery.includeRowNumber = includeRowNumber;
                        thisQuery.includeHeader = includeHeader;
                        thisQuery.glue = glue;
                        thisQuery.exportType = exportType;
                        if (exportId) { thisQuery.exportId = exportId; }
                        obj.exportToExcel(url, thisQuery);
                    });
                } else {
                    errAlertS('No hay nada para exportar');
                }
            },
            exportDataToExcelByQuery: function (allData, exportId, selected, refToExport, queries, totalResults, path) {
                var elementsToExport;
                var title = '';
                var msg = '';
                var exportByQuery = false;
                var refToExportA = refToExport.split('/');
                var url = path ? path : 'interface/' + refToExportA[1] + '/exportMongoDataByQuery';
                console.log(url)
                if (selected.length && selected.length === allData.length) {
                    msg = 'Todos los registro serán exportados';
                    exportByQuery = true;
                    title = 'Se exportaran ' + totalResults + ' registros';
                } else if (selected.length) {
                    msg = 'Los registros seleccionados serán exportados';
                    elementsToExport = selected;
                    title = 'Se exportaran ' + elementsToExport.length + ' registros';
                } else {
                    msg = 'Todos los registros de esta pagina serán exportados';
                    elementsToExport = allData;
                    title = 'Se exportaran ' + elementsToExport.length + ' registros';
                }
                if ((elementsToExport && elementsToExport.length) || exportByQuery) {
                    $mdDialog.show(
                        $mdDialog.confirm(confirmConfig)
                            .title(title)
                            .content(msg)
                            .ariaLabel('Exportar Datos')
                            .ok('Aceptar')
                            .cancel('Cancelar')
                    ).then(function () {
                        $log.log(queries);
                        var thisQuery = queries;
                        if (!exportByQuery) {
                            thisQuery = {
                                fid: angular.toJson({ $in: $filter('getArrayOfIds')(elementsToExport) }),
                                sort: angular.isObject(queries) ? queries.sort : undefined
                            };
                        }
                        thisQuery.ref = refToExport;
                        if (exportId) { thisQuery.exportId = exportId; }
                        obj.exportToExcel(url, thisQuery);
                    });
                } else {
                    errAlertS('No hay nada para exportar');
                }
            },
            exportAllDataToExcel: function () {
                var url = 'interface/exportAllFBData/' + AppF.active.menuName;
                $mdDialog.show(
                    $mdDialog.confirm(confirmConfig)
                        .title('Exportar todo')
                        .content('Todos los registros de ' + translateFilter(AppF.active.menuObjName + '.PLURAL') + ' serán exportados.')
                        .ariaLabel('Exportar todos los registros del módulo')
                        .ok('Aceptar')
                        .cancel('Cancelar')
                ).then(function () {
                    obj.exportAllToExcel(url);
                });
            },
            exportAllToExcel: function (url) {
                $rootScope.loadingProgress = true;
                $http({
                    method: 'POST',
                    url: window.__env.serviceWorkerUrl + url,
                    responseType: 'arraybuffer',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                }).then(function (response) {
                    var headers = response.headers();
                    var filename = headers['x-filename'];
                    var contentType = headers['content-type'];
                    var linkElement = document.createElement('a');
                    try {
                        var blob = new Blob([response.data], {
                            type: contentType
                        });
                        var url = window.URL.createObjectURL(blob);
                        linkElement.setAttribute('href', url);
                        linkElement.setAttribute("download", filename);
                        var clickEvent = new MouseEvent("click", {
                            "view": window,
                            "bubbles": true,
                            "cancelable": false
                        });
                        linkElement.dispatchEvent(clickEvent);
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync(function () {
                            $log.debug('exportAllToExcel finished');
                        });
                    } catch (ex) {
                        var msgE = "error descargando el archivo";
                        $log.error(ex, msgE);
                        errAlertS(msgE);
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync();
                    }
                }).catch(function (err) {
                    $log.error(err);
                    errAlertS(err.message);
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                });
            },
            exportToExcel: function (url, data, promise) {
                return new Promise(function (resolve, reject) {
                    if (!promise) {
                        $rootScope.loadingProgress = true;
                    }
                    $http({
                        method: 'POST',
                        url: window.__env.serviceWorkerUrl + url,
                        responseType: 'arraybuffer',
                        data: data,
                        transformRequest: function (obj) {
                            var str = [];
                            for (var p in obj) {
                                if (typeof (obj[p]) == "number" || typeof (obj[p]) == "string") {
                                    str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                                } else if (typeof (obj[p]) == "object" && obj[p].length) {
                                    for (var j in obj[p]) {
                                        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(JSON.stringify(obj[p][j])));
                                    }
                                } else {
                                    str.push(encodeURIComponent(p) + "=" + JSON.stringify(obj[p]));
                                }

                            }
                            return str.join("&");
                        },
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded'
                        }
                    }).then(function (response) {
                        var headers = response.headers();
                        var filename = headers['x-filename'];
                        var contentType = headers['content-type'];
                        var linkElement = document.createElement('a');
                        try {
                            var blobArray = [];
                            if (contentType.indexOf('text/csv') > -1 && contentType.indexOf('utf-8') > -1) {
                                blobArray.push('\ufeff')
                            }
                            blobArray.push(response.data);
                            var blob = new Blob(blobArray, {
                                type: contentType
                            });
                            var url = window.URL.createObjectURL(blob);
                            linkElement.setAttribute('href', url);
                            linkElement.setAttribute("download", filename);
                            var clickEvent = new MouseEvent("click", {
                                "view": window,
                                "bubbles": true,
                                "cancelable": false
                            });
                            linkElement.dispatchEvent(clickEvent);
                            if (!promise) {
                                $rootScope.loadingProgress = false;
                                $rootScope.$evalAsync(function () {
                                    $log.debug('exportToExcel finished');
                                });
                            }

                        } catch (ex) {
                            $log.debug(ex, "error descargando el archivo");
                            if (!promise) {
                                $rootScope.loadingProgress = false;
                                $rootScope.$evalAsync();
                            }

                        }
                        resolve(true)
                    }).catch(function (err) {
                        $log.error(err);
                        var message = new TextDecoder("utf-8").decode(err.data);
                        var error = angular.fromJson(message);
                        errAlertS(error);
                        if (!promise) {
                            $rootScope.loadingProgress = false;
                            $rootScope.$evalAsync();
                        }
                        reject(err);
                    });
                })

            },
            loadNeeded: function () {
                var requests = [];
                var arrayOfCatalogs = obj.loadData[AppF.active.menuName];
                // $log.debug('loading needed catalogs', arrayOfCatalogs);
                if (arrayOfCatalogs) {
                    for (var catalogN in arrayOfCatalogs) {
                        var ca = arrayOfCatalogs[catalogN];
                        if (typeof ca == 'string') {
                            requests.push(obj.loadCatalog(ca));
                        } else { // carga los parametros completos para obtener catalogo
                            if (angular.isFunction(ca.val)) {
                                ca.val = ca.val();
                            }
                            requests.push(obj.loadCatalog(ca.catalog, ca.ref, ca.query, ca.val, ca.type, ca.filterName));
                        }
                    }
                }
                return Promise.all(requests);
            }
        }
        return obj;
    }

}());
(function () {
    'use strict';

    angular
        .module('fuse')
        .factory('CalendarF', CalendarF);

    function CalendarF(
        $log,
        loopEachFilter,
        $firebaseArray,
        $q,
        AppF
    ) {
        var obj = {
            loadPayrollCalendar: loadPayrollCalendar,
            loadOperationsEvents: loadOperationsEvents,
            getActiveOperations: getActiveOperations,
            getAvailablePeriodStartDate: getAvailablePeriodStartDate,
            calendarModule: {
                years: {}
            }
        };

        function getAvailablePeriodStartDate(payroll) {
            return obj.getActiveOperations(payroll, 1).then(function (activeOperations) {
                return new Promise(function (resolve, reject) {
                    if (activeOperations.length) {
                        var thisOperation = activeOperations[0];
                        var operationDate = moment(thisOperation.start);
                        operationDate = new Date(operationDate.year(), operationDate.month(), operationDate.date());
                        resolve(operationDate);
                    } else {
                        reject('No se encontraron operaciones activas');
                    }
                });
            });
        }

        function loadPayrollCalendar(payrolls, promise) {
            var promises = [];
            angular.forEach(obj.calendarModule.years, function (value, year) {
                angular.forEach(payrolls, function (payroll) {
                    if (payroll.active) {
                        if (!obj.calendarModule.yearsQueryObjects) {
                            obj.calendarModule.yearsQueryObjects = {};
                        }
                        if (!obj.calendarModule.yearsQueryObjects[payroll.$id]) {
                            obj.calendarModule.yearsQueryObjects[payroll.$id] = {};
                        }
                        if (!obj.calendarModule.yearsQueryObjects[payroll.$id][year]) {
                            obj.calendarModule.yearsQueryObjects[payroll.$id][year] = $firebaseArray(AppF.root.child('catalogs/payrollCalendars/' + payroll.$id + '/calendars').orderByChild('data/year').equalTo(parseInt(year)));
                            promises.push(obj.calendarModule.yearsQueryObjects[payroll.$id][year].$loaded());
                        }
                    }
                });
            });
            if (promise) {
                return Promise.all(promises);
            }
        }

        function loadOperationsEvents(payrollId) {
            var promise = $q.defer();
            var promises = [];
            angular.forEach(obj.calendarModule.yearsQueryObjects, function (payroll, payrollId) {
                angular.forEach(payroll, function (yearQueryObject) {
                    angular.forEach(yearQueryObject, function (calendar) {
                        if (!obj.calendarModule.operations) {
                            obj.calendarModule.operations = {};
                        }
                        if (!obj.calendarModule.operations[payrollId]) {
                            obj.calendarModule.operations[payrollId] = {};
                        }
                        if (!obj.calendarModule.operations[payrollId][calendar.$id]) {
                            obj.calendarModule.operations[payrollId][calendar.$id] = {};
                            obj.calendarModule.operations[payrollId][calendar.$id].operationDates = $firebaseArray(AppF.root.child('catalogs/payrollCalendars/' + payrollId + '/periods/' + calendar.$id));
                            promises.push(obj.calendarModule.operations[payrollId][calendar.$id].operationDates.$loaded());
                            obj.calendarModule.operations[payrollId][calendar.$id].operationInfo = $firebaseArray(AppF.root.child('catalogs/operations/ordinary/' + payrollId + '/' + calendar.$id + '/collection'));
                            promises.push(obj.calendarModule.operations[payrollId][calendar.$id].operationInfo.$loaded());
                        }
                    });
                });
            });
            if (promises.length === 0 && payrollId) {
                if (obj.calendarModule.operations && obj.calendarModule.operations[payrollId]) {
                    loopEachFilter(obj.calendarModule.operations[payrollId], function (data, calendar) {
                        promises.push(obj.calendarModule.operations[payrollId][calendar].operationDates.$loaded());
                        promises.push(obj.calendarModule.operations[payrollId][calendar].operationInfo.$loaded());
                    });
                }

            }
            $q.all(promises).then(function () {
                promise.resolve(obj.calendarModule.operations);
            }, function (err) {
                promise.reject(err);
            });
            return promise.promise;
        }

        function getActiveOperations(payrollId, numOfOperations, options, operationsAvailable, loop, emptyCalendar) {
            return new Promise(function (resolve, reject) {
                loop = loop ? loop : 0;
                emptyCalendar = emptyCalendar ? emptyCalendar : 0;
                options = options ? options : {};
                loop++;
                if (emptyCalendar > 2) {
                    reject('No hay mas calendarios disponibles');
                } else if (loop > 5) {
                    reject('Se alcanzo el limite de loops');
                } else {
                    var whatCalendar;
                    var promiseCalendar = [];
                    var calendars;
                    if (options.calendar) {
                        whatCalendar = options.calendar;
                    } else if (obj.activeCalendar) {
                        whatCalendar = obj.activeCalendar;
                    } else {
                        if (options.date) {
                            calendars = $firebaseArray(AppF.root.child('catalogs/payrollCalendars/' + payrollId + '/calendars').orderByChild('data/endDate').startAt(options.date).limitToFirst(1));
                        } else {
                            calendars = $firebaseArray(AppF.root.child('catalogs/payrollCalendars/' + payrollId + '/calendars').orderByChild('data/active').equalTo(true));
                        }
                        promiseCalendar.push(calendars.$loaded());
                    }
                    Promise.all(promiseCalendar).then(function () {
                        return new Promise(function (resolve2, reject2) {
                            if (typeof (calendars) !== 'undefined' && calendars.length) {
                                var thisCalendar = calendars[0];
                                whatCalendar = thisCalendar.$id;
                                if (thisCalendar.active) {
                                    obj.activeCalendar = whatCalendar;
                                }
                            }
                            if (whatCalendar) {
                                resolve2(whatCalendar);
                            } else {
                                reject2('No existe Calendario disponible');
                            }
                        });
                    }).then(function (calendar) {
                        return getActiveOperationsOfYear(payrollId, calendar);
                    }).then(function (activeOperations) {
                        return new Promise(function (resolve3, reject3) {
                            if (options.date || numOfOperations) {
                                if (activeOperations.length > 0) {
                                    operationsAvailable = operationsAvailable ? operationsAvailable : [];
                                    numOfOperations = typeof (numOfOperations) !== 'undefined' ? numOfOperations : 1;
                                    for (var i = 0; i < activeOperations.length && operationsAvailable.length < numOfOperations; i++) {
                                        var thisOperation = activeOperations[i];
                                        if (options.date) {
                                            if (thisOperation.end > options.date) {
                                                operationsAvailable.push(thisOperation);
                                            }
                                        } else {
                                            operationsAvailable.push(thisOperation);
                                        }
                                    }
                                    if (operationsAvailable.length < numOfOperations) {
                                        var thisOptions = {
                                            calendar: parseInt(whatCalendar) + 1
                                        };
                                        resolve3(getActiveOperations(payrollId, numOfOperations, thisOptions, operationsAvailable, loop));
                                    } else {
                                        resolve3(operationsAvailable);
                                    }
                                } else if (numOfOperations > 0) {
                                    emptyCalendar++;
                                    var thisOptions2 = {
                                        calendar: parseInt(whatCalendar) + 1
                                    };
                                    resolve3(getActiveOperations(payrollId, numOfOperations, thisOptions2, operationsAvailable, loop, emptyCalendar));
                                } else if (numOfOperations === 0) {
                                    resolve3([]);
                                } else {
                                    reject3('No hay operaciones disponible');
                                }
                            } else {
                                resolve3(activeOperations);
                            }
                        });
                    }).then(function (activeOperations) {
                        resolve(activeOperations);
                    }).catch(function (error) {
                        reject(error);
                    });
                }
            });

        }

        function getActiveOperationsOfYear(payrollId, year) {
            obj.calendarModule.years[year] = true;
            var payrolls = [{
                $id: payrollId,
                active: true
            }];
            return loadPayrollCalendar(payrolls, true).then(function () {
                return loadOperationsEvents(payrollId);
            }).then(function () {
                return new Promise(function (resolve, reject) {
                    if (angular.isObject(obj.calendarModule.operations[payrollId][year]) && obj.calendarModule.operations[payrollId][year].operationInfo) {
                        var activeOperations = [];
                        for (var i = 0; i < obj.calendarModule.operations[payrollId][year].operationInfo.length; i++) {
                            var thisOperation = angular.fromJson(angular.toJson(obj.calendarModule.operations[payrollId][year].operationInfo[i]));
                            var thisOperationDates = angular.fromJson(angular.toJson(obj.calendarModule.operations[payrollId][year].operationDates.find(function (item) {
                                return item.period === thisOperation.period;
                            })));
                            if (thisOperation.status === -1 || thisOperation.status > 0 && thisOperation.status < 3) {
                                activeOperations.push(Object.assign(thisOperation, thisOperationDates));
                            }
                        }
                        resolve(activeOperations);
                    } else {
                        reject('No existen mas calendarios disponibles');
                    }
                });
            });
        }
        return obj;
    }

}());
(function () {
    'use strict';

    angular
        .module('fuse')
        .factory('AuthTokensF', AuthTokensF);

    /** @ngInject */
    function AuthTokensF($http, $q, $window, apiv3) {
        var baseUrl = $window.location.protocol + '//' + apiv3[$window.__env.mode] + '/auth/tokens';

        function request(method, suffix, data, query) {
            var user = firebase.auth().currentUser;
            if (!user) {
                return $q.reject({
                    code: 'auth/no-current-user',
                    message: 'No hay un usuario autenticado.'
                });
            }

            return $q.when(user.getIdToken(false)).then(function (idToken) {
                return $http({
                    method: method,
                    url: baseUrl + (suffix || ''),
                    data: data,
                    params: query,
                    headers: {
                        Authorization: 'Bearer ' + idToken
                    }
                });
            });
        }

        return {
            getCenters: function () {
                return request('GET', '/centers');
            },
            getFirms: function () {
                return request('GET', '/firms');
            },
            getPermissions: function () {
                return request('GET', '/permissions', undefined, {
                    filter: 'endpoints'
                });
            },
            list: function () {
                return request('GET');
            },
            create: function (data) {
                return request('POST', '', data);
            },
            revoke: function (tokenId) {
                return request('DELETE', '/' + encodeURIComponent(tokenId));
            }
        };
    }
}());

(function () {
    'use strict';

    angular
        .module('fuse')
        .factory('ApiV3F', ApiV3F)

    function ApiV3F(
        $window,
        apiv3,
        $httpParamSerializer,
        $http,
        $log,
        AppF,
        errAlertS,
        $rootScope
    ) {
        //?Para hacer pruebas de la apiV2 en local
        // var swUrl = 'http://' + apiv2[$window.__env.mode] + '/';
        var swUrl = $window.location.protocol + '//' + apiv3[$window.__env.mode] + '/';
        $log.log($window.__env.mode)
        function refreshToken() {
            if (AppF.refreshTokenPromise) {
                return AppF.refreshTokenPromise;
            }
            if (!firebase.auth().currentUser) {
                return Promise.reject({ code: 'auth/no-current-user', message: 'No hay un usuario autenticado.' });
            }
            AppF.refreshTokenPromise = firebase.auth().currentUser.getIdToken(false).then(function (token) {
                if (AppF.thisToken !== token) {
                    AppF.thisToken = token;
                    AppF.lastTimeRefresh = new Date().valueOf();
                }
                if (token !== $http.defaults.headers.common.Authorization) {
                    //$log.debug('token refresh');
                    $http.defaults.headers.common.Authorization = '' + token;
                    //$log.debug('http headers set', token);
                }
                return token;
            }).finally(function () {
                AppF.refreshTokenPromise = null;
            });
            return AppF.refreshTokenPromise;
        }
        function getRequestAndParams(params, isFile) {
            var req = {};
            if (isFile) {
                var formData = new FormData();
                angular.forEach(params, function (value, key) {
                    formData.append(key, value);
                });
                params = formData;
            }
            if (isFile) {
                req.headers = { 'Content-Type': undefined }
                req.transformRequest = angular.identity
            }
            return { request: req, params: params };
        }
        var obj = {
            get: function (path, query) {
                var qs = (query) ? $httpParamSerializer(query) : '';
                return refreshToken().then(function () {
                    return $http.get(swUrl + path + '?' + qs)
                })
            },
            post: function (path, params, isFile) {
                return new Promise(function (resolve, reject) {
                    var data = getRequestAndParams(params, isFile)
                    refreshToken().then(function () {
                        return $http.post(swUrl + path, data.params, data.request)
                    }).then(resolve).catch(reject);
                });
            },
            put: function (path, params, isFile) {
                return new Promise(function (resolve, reject) {
                    var data = getRequestAndParams(params, isFile)
                    refreshToken().then(function () {
                        return $http.put(swUrl + path, data.params, data.request)
                    }).then(resolve).catch(reject);
                });
            },
            delete: function (path) {
                return new Promise(function (resolve, reject) {
                    refreshToken().then(function () {
                        return $http.delete(swUrl + path)
                    }).then(resolve).catch(reject);
                });
            },
            exportToExcel: function (url, data, promise) {
                $log.log(swUrl)
                return new Promise(function (resolve, reject) {
                    if (!promise) {
                        $rootScope.loadingProgress = true;
                    }
                    $http({
                        method: 'POST',
                        url: swUrl + url,
                        responseType: 'arraybuffer',
                        data: data,
                        transformRequest: function (obj) {
                            var str = [];
                            for (var p in obj) {
                                if (typeof (obj[p]) == "number" || typeof (obj[p]) == "string") {
                                    str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                                } else if (typeof (obj[p]) == "object" && obj[p].length) {
                                    for (var j in obj[p]) {
                                        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(JSON.stringify(obj[p][j])));
                                    }
                                } else {
                                    str.push(encodeURIComponent(p) + "=" + JSON.stringify(obj[p]));
                                }

                            }
                            return str.join("&");
                        },
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded'
                        }
                    }).then(function (response) {
                        var headers = response.headers();
                        var filename = headers['x-filename'];
                        var contentType = headers['content-type'];
                        var linkElement = document.createElement('a');
                        try {
                            var blobArray = [];
                            if (contentType.indexOf('text/csv') > -1 && contentType.indexOf('utf-8') > -1) {
                                blobArray.push('\ufeff')
                            }
                            blobArray.push(response.data);
                            var blob = new Blob(blobArray, {
                                type: contentType
                            });
                            var url = window.URL.createObjectURL(blob);
                            linkElement.setAttribute('href', url);
                            linkElement.setAttribute("download", filename);
                            var clickEvent = new MouseEvent("click", {
                                "view": window,
                                "bubbles": true,
                                "cancelable": false
                            });
                            linkElement.dispatchEvent(clickEvent);
                            if (!promise) {
                                $rootScope.loadingProgress = false;
                                $rootScope.$evalAsync(function () {
                                    $log.debug('exportToExcel finished');
                                });
                            }

                        } catch (ex) {
                            $log.debug(ex, "error descargando el archivo");
                            if (!promise) {
                                $rootScope.loadingProgress = false;
                                $rootScope.$evalAsync();
                            }

                        }
                        resolve(true)
                    }).catch(function (err) {
                        $log.error(err);
                        var error;
                        try {
                            var message;
                            if (err.data instanceof ArrayBuffer) {
                                message = new TextDecoder("utf-8").decode(new Uint8Array(err.data));
                                error = angular.fromJson(message);
                            } else if (angular.isString(err.data)) {
                                error = angular.fromJson(err.data);
                            } else if (angular.isObject(err.data)) {
                                error = err.data;
                            } else {
                                error = {
                                    message: 'Ocurrió un error al exportar el archivo.'
                                };
                            }
                        } catch (e) {
                            $log.error('Error procesando respuesta de error:', e);
                            error = {
                                message: 'Ocurrió un error al exportar el archivo.'
                            };
                        }
                        errAlertS(error);
                        if (!promise) {
                            $rootScope.loadingProgress = false;
                            $rootScope.$evalAsync();
                        }
                        reject(err);
                    });
                })
            }
        };
        return obj;
    }

}());

(function () {
    'use strict';

    angular
        .module('fuse')
        .factory('ApiV2F', ApiV2F)

    function ApiV2F(
        $window,
        apiv2,
        $httpParamSerializer,
        $http,
        $log,
        AppF,
        errAlertS,
        $rootScope
    ) {
        //?Para hacer pruebas de la apiV2 en local
        // var swUrl = 'http://' + apiv2[$window.__env.mode] + '/';
        var swUrl = $window.location.protocol + '//' + apiv2[$window.__env.mode] + '/';
        $log.log($window.__env.mode)
        function refreshToken() {
            if (AppF.refreshTokenPromise) {
                return AppF.refreshTokenPromise;
            }
            if (!firebase.auth().currentUser) {
                return Promise.reject({ code: 'auth/no-current-user', message: 'No hay un usuario autenticado.' });
            }
            AppF.refreshTokenPromise = firebase.auth().currentUser.getIdToken(false).then(function (token) {
                if (AppF.thisToken !== token) {
                    AppF.thisToken = token;
                    AppF.lastTimeRefresh = new Date().valueOf();
                }
                if (token !== $http.defaults.headers.common.Authorization) {
                    //$log.debug('token refresh');
                    $http.defaults.headers.common.Authorization = '' + token;
                    //$log.debug('http headers set', token);
                }
                return token;
            }).finally(function () {
                AppF.refreshTokenPromise = null;
            });
            return AppF.refreshTokenPromise;
        }
        function getRequestAndParams(params, isFile) {
            var req = {};
            if (isFile) {
                var formData = new FormData();
                angular.forEach(params, function (value, key) {
                    formData.append(key, value);
                });
                params = formData;
            }
            if (isFile) {
                req.headers = { 'Content-Type': undefined }
                req.transformRequest = angular.identity
            }
            return { request: req, params: params };
        }
        var obj = {
            get: function (path, query) {
                var qs = (query) ? $httpParamSerializer(query) : '';
                return refreshToken().then(function () {
                    return $http.get(swUrl + path + '?' + qs)
                })
            },
            post: function (path, params, isFile) {
                return new Promise(function (resolve, reject) {
                    var data = getRequestAndParams(params, isFile)
                    refreshToken().then(function () {
                        return $http.post(swUrl + path, data.params, data.request)
                    }).then(resolve).catch(reject);
                });
            },
            put: function (path, params, isFile) {
                return new Promise(function (resolve, reject) {
                    var data = getRequestAndParams(params, isFile)
                    refreshToken().then(function () {
                        return $http.put(swUrl + path, data.params, data.request)
                    }).then(resolve).catch(reject);
                });
            },
            delete: function (path) {
                return new Promise(function (resolve, reject) {
                    refreshToken().then(function () {
                        return $http.delete(swUrl + path)
                    }).then(resolve).catch(reject);
                });
            },
            exportToExcel: function (url, data, promise) {
                return new Promise(function (resolve, reject) {
                    if (!promise) {
                        $rootScope.loadingProgress = true;
                    }
                    $http({
                        method: 'POST',
                        url: swUrl + url,
                        responseType: 'arraybuffer',
                        data: data,
                        transformRequest: function (obj) {
                            var str = [];
                            for (var p in obj) {
                                if (typeof (obj[p]) == "number" || typeof (obj[p]) == "string") {
                                    str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                                } else if (typeof (obj[p]) == "object" && obj[p].length) {
                                    for (var j in obj[p]) {
                                        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(JSON.stringify(obj[p][j])));
                                    }
                                } else {
                                    str.push(encodeURIComponent(p) + "=" + JSON.stringify(obj[p]));
                                }

                            }
                            return str.join("&");
                        },
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded'
                        }
                    }).then(function (response) {
                        var headers = response.headers();
                        var filename = headers['x-filename'];
                        var contentType = headers['content-type'];
                        var linkElement = document.createElement('a');
                        try {
                            var blobArray = [];
                            if (contentType.indexOf('text/csv') > -1 && contentType.indexOf('utf-8') > -1) {
                                blobArray.push('\ufeff')
                            }
                            blobArray.push(response.data);
                            var blob = new Blob(blobArray, {
                                type: contentType
                            });
                            var url = window.URL.createObjectURL(blob);
                            linkElement.setAttribute('href', url);
                            linkElement.setAttribute("download", filename);
                            var clickEvent = new MouseEvent("click", {
                                "view": window,
                                "bubbles": true,
                                "cancelable": false
                            });
                            linkElement.dispatchEvent(clickEvent);
                            if (!promise) {
                                $rootScope.loadingProgress = false;
                                $rootScope.$evalAsync(function () {
                                    $log.debug('exportToExcel finished');
                                });
                            }

                        } catch (ex) {
                            $log.debug(ex, "error descargando el archivo");
                            if (!promise) {
                                $rootScope.loadingProgress = false;
                                $rootScope.$evalAsync();
                            }

                        }
                        resolve(true)
                    }).catch(function (err) {
                        $log.error(err);
                        var message = new TextDecoder("utf-8").decode(err.data);
                        var error = angular.fromJson(message);
                        errAlertS(error);
                        if (!promise) {
                            $rootScope.loadingProgress = false;
                            $rootScope.$evalAsync();
                        }
                        reject(err);
                    });
                })
            }
        };
        return obj;
    }

}());

(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('uppercased', uppercased);


    /** @ngInject */
    function uppercased(
        cleanStringFilter,
        AppF,
        $log
    ) {
        return {
            require: 'ngModel',
            restrict: 'C',
            link: function (scope, element, attrs, modelCtrl) {
                //ele.attr('ng-change',ngModel.$viewValue.toUpperCase());
                var capitalize = function (inputValue) {
                    modelCtrl.$setValidity("uppercased", false);
                    var notdeletespecialcharts = (attrs.notdeletespecialcharts == "true");
                    var notdeletethese = [];
                    if (angular.isString(scope.notdeletethese)) {
                        try {
                            notdeletethese = angular.fromJson(scope.notdeletethese);
                        } catch (error) {
                            $log.log(error);
                            notdeletethese = [];
                        }
                    }
                    if (inputValue == undefined) inputValue = '';
                    var capitalized = inputValue.trim().toUpperCase();
                    if ((AppF.active.menuName == 'employees' && ['enrole'].indexOf(AppF.active.menuAction) !== -1) || ['revisions', 'enroles'].indexOf(AppF.active.menuName) !== -1) {
                        capitalized = cleanStringFilter(capitalized, 1, 1, 1, notdeletespecialcharts, notdeletethese);
                    }
                    if (capitalized !== inputValue) {
                        var selection = element[0].selectionStart;
                        modelCtrl.$setViewValue(capitalized);
                        modelCtrl.$render();
                        // set back the cursor after rendering
                        element[0].selectionStart = selection;
                        element[0].selectionEnd = selection;
                    }
                    modelCtrl.$setValidity("uppercased", true);
                    return capitalized;
                };
                modelCtrl.$parsers.push(capitalize);
                capitalize(scope[attrs.ngModel]); // capitalize initial value
            }
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('tdsAccountInput', tdsAccountInput);


    /** @ngInject */
    function tdsAccountInput(
        MongoF,
        getSomethingOfArrayMFilter
    ) {
        return {
            require: 'ngModel',
            restrict: 'A',
            scope: {
                bank: '=',
                emit: '='
            },
            link: function (scope, ele, attrs, ngModel) {
                ngModel.$validators.validPattern = function (modelValue) {
                    if (ngModel.$isEmpty(modelValue)) {
                        return true;
                    }
                    var patt = "^[0-9]*$"; // all numbers pattern
                    var pattern = new RegExp(patt);
                    return pattern.test(modelValue);
                };
                ngModel.$validators.validCard = function (modelValue) {
                    if (ngModel.$isEmpty(modelValue) || !scope.emit) {
                        return true;
                    }
                    return modelValue.length === 16;
                };
                ngModel.$validators.validAccount = function (modelValue) {
                    if (ngModel.$isEmpty(modelValue) || scope.emit) {
                        return true;
                    }
                    var lengths = [10, 18];
                    var customLength = getSomethingOfArrayMFilter(scope.bank, MongoF.banks, 'accountLength');
                    if (angular.isNumber(customLength)) {
                        lengths = [18, customLength];
                    }
                    return (lengths.indexOf(modelValue.length) > -1);
                };
                ngModel.$validators.validBank = function (modelValue) {
                    if (ngModel.$isEmpty(modelValue) || !scope.emit) {
                        return true;
                    }
                    var bankCode = getSomethingOfArrayMFilter(scope.bank, MongoF.banks, 'cardCode');
                    var bankValid;
                    if ((angular.isString(bankCode) && bankCode !== '') || angular.isNumber(bankCode)) { // si hay código de banco se entiende que se debe validar contra un banco
                        var bankCodes = [];
                        if (angular.isNumber(bankCode)) {
                            bankCodes.push(bankCode);
                        } else {
                            bankCodes = bankCode.split(',');
                        }
                        bankValid = false;
                        for (var b = 0; b < bankCodes.length && !bankValid; b++) {
                            bankValid = (modelValue.indexOf(bankCodes[b]) === 0);
                        }
                    } else {
                        bankValid = true;
                    }
                    return bankValid;
                };

                var watcher = scope.$watchGroup(['emit', 'bank'], function () {
                    ngModel.$validate();
                });

                var final = scope.$on('$destroy', function () {
                    watcher();
                    final();
                });
            }
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('app.core')
        .directive('stopTouchEvent', stopTouchEvent);


    /** @ngInject */
    function stopTouchEvent() {

        return {
            restrict: 'A',
            link: function(scope, element) {
                element.on('touchmove', function(evt) {
                    evt.stopPropagation();
                });
            }
        };
    }

}());
(function() {
    'use strict';

    angular
        .module('app.core')
        .directive('scrollable', scrollable);

    function scrollable() {
        return function(scope, element, attr) {
            var container = angular.element(element);
            container.bind("scroll", function(evt) {
                if (container[0].scrollTop <= 0) {
                    if (attr.onTopEvent) {
                        scope.$emit(attr.onTopEvent);
                    }
                }
                else if (container[0].offsetHeight + container[0].scrollTop >= container[0].scrollHeight) {
                    if (attr.onBottomEvent) {
                        scope.$emit(attr.onBottomEvent);
                    }

                }else{
                   if (attr.onMiddleEvent) {
                        scope.$emit(attr.onMiddleEvent);
                    }
                }
            });
        };
    }

}());
(function () {
  'use strict';

  angular
    .module('app.core')
    .directive('roundNumber', roundNumber);

  function roundNumber() {
    return {
      require: 'ngModel',
      restrict: 'A',
      link: function (scope, element, attrs, controller) {
        controller.$parsers.push(function (value) {
          var decimals = parseInt(attrs.roundNumber, 10);
          if (isNaN(decimals) || decimals < 0) {
            decimals = 2;
          }
          var valorNumero = parseFloat(value);
          if (!isNaN(valorNumero)) {
            valorNumero = parseFloat(valorNumero.toFixed(decimals));
          }
          return valorNumero; //por default convierte a 2 decimales
        });

        controller.$formatters.push(function (value) {
          return value;
        });

        element.bind('blur', function () {
          var decimals = parseInt(attrs.roundNumber, 10);
          if (isNaN(decimals) || decimals < 0) {
            decimals = 2;
          }
          var valorNumero = parseFloat(controller.$viewValue);
          if (!isNaN(valorNumero)) {
            valorNumero = parseFloat(valorNumero.toFixed(decimals));

            controller.$setViewValue(valorNumero);
            controller.$render();
          } //o pasar un parámetro, de cuantos decimales quiere que convierta a decimales
        });
      }
    };
  }
})();

angular.module('app.core').directive('onlyKey', function ($timeout, $log) {
    return {
        restrict: 'A',
        link: function (scope, element) {

            function apply() {
                var input = element[0].querySelector('input[type="file"]');
                if (!input) return false;

                input.setAttribute('accept', '.key');
                $log.log('onlyKey: accept aplicado =>', input.getAttribute('accept'));
                return true;
            }

            $timeout(function () {
                if (apply()) return;

                var obs = new MutationObserver(function () {
                    if (apply()) {
                        obs.disconnect();
                    }
                });

                obs.observe(element[0], { childList: true, subtree: true });

                scope.$on('$destroy', function () {
                    obs.disconnect();
                });
            }, 0);
        }
    };
});

angular.module('app.core').directive('onlyCer', function ($timeout, $log) {
    return {
        restrict: 'A',
        link: function (scope, element) {

            function apply() {
                var input = element[0].querySelector('input[type="file"]');
                if (!input) return false;

                // CER + PFX
                input.setAttribute(
                    'accept',
                    '.cer,.pfx,application/x-x509-ca-cert,application/x-pkcs12'
                );

                $log.log('onlyCer: accept aplicado =>', input.getAttribute('accept'));
                return true;
            }

            $timeout(function () {
                if (apply()) return;

                var obs = new MutationObserver(function () {
                    if (apply()) {
                        obs.disconnect();
                    }
                });

                obs.observe(element[0], { childList: true, subtree: true });

                scope.$on('$destroy', function () {
                    obs.disconnect();
                });
            }, 0);
        }
    };
});

(function() {
    'use strict';

    angular
        .module('app.core')
        .directive('onFinishRender', onFinishRender);

    function onFinishRender($timeout) {
        return {
            restrict: 'A',
            link: function(scope, element, attr) {
                if (scope.$last === true) {
                    $timeout(function() {
                        scope.$emit(attr.onFinishRender);
                    },0,false);
                }
            }
        }
    }

}());
(function () {
    'use strict';

    angular
        .module ('app.core')
        .directive ('maxHeightDataTable', maxHeight);
        
    function maxHeight() {
        return {
            restrict: 'C',
            link: function(scope, ele, attrs){
                var container = angular.element('.fullpage-datatable');
                var containerH=container.height();
                ele.css('max-height', containerH - 15);
            }
        }
    }

} ());
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('listenInactivity', listenInactivity);

    function listenInactivity(
        $timeout,
        $location,
        $log,
        $localStorage,
        $rootScope,
        AppF
    ) {
        return {
            restrict: 'A',
            link: function ($scope, element) {
                var container = angular.element(element);
                var clicked = false;
                $scope.tickInterval = 30000;
                $scope.expirationTime = AppF.expirationTime;
                $scope.inactivityTime = 0;
                container.on('scroll', function () {
                    $scope.inactivityTime = 0;
                });
                container.on('click', function () {
                    $scope.inactivityTime = 0;
                });
                container.on('keydown', function (evt) {
                    $scope.inactivityTime = 0;
                    AppF.actionTriggered = false;
                    $rootScope.$broadcast('keyPress', {
                        evt: evt,
                        keyCode: evt.keyCode,
                        for: AppF.active.menuName
                    });
                });
                var tick = function () {
                    $scope.inactivityTime = $scope.inactivityTime + 30;
                    if ($scope.inactivityTime > $scope.expirationTime && angular.isObject(AppF.user)) {
                        $log.debug(AppF.user, 'user about to be blocked');
                        AppF.userBlocked = {
                            user: AppF.user.email,
                            name: AppF.profile.data.name
                        };
                        var path = $location.path();
                        $localStorage.previousPage = path;
                        $log.debug('previousPage', $localStorage.previousPage);
                        $rootScope.$emit('loggedOut');
                    }
                    if (!$localStorage.rememberUser) {
                        $timeout(tick, $scope.tickInterval, false);
                    }
                    if (!clicked && container) {
                        container.click();
                        clicked = true;
                    }
                };
                tick();
            }
        };
    }

}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate)
    {
        return {
            restrict: 'E',
            compile : function (element, attr)
            {
                var code;
                //No attribute? code is the content
                if ( !attr.code )
                {
                    code = element.html();
                    element.empty();
                }

                return function (scope, element, attr)
                {

                    if ( attr.code )
                    {
                        // Attribute? code is the evaluation
                        code = scope.$eval(attr.code);
                    }
                    var shouldInterpolate = scope.$eval(attr.shouldInterpolate);

                    $q.when(code).then(function (code)
                    {
                        if ( code )
                        {
                            if ( shouldInterpolate )
                            {
                                code = $interpolate(code)(scope);
                            }
                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );
                            element.append(contentParent);
                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function ()
                            {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent)
                    {

                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line)
                        {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
                        lines = lines.map(function (line)
                        {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(attr.language || attr.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('beneficiariesPercent', beneficiariesPercent);


    /** @ngInject */
    function beneficiariesPercent() {
        return {
            require: 'ngModel',
            restrict: 'A',
            scope: {
                beneficiaries: '<',
                indexBen: '<'
            },
            link: function (scope, ele, attrs, ngModel) {
                ngModel.$validators.validpercent = function (modelValue) {
                    var flag = true;
                    if (angular.isArray(scope.beneficiaries)) {
                        var total = scope.beneficiaries.reduce(function (current, item, $index) {
                            var thisValue = 0;
                            if ($index === scope.indexBen) {
                                thisValue = modelValue;
                            } else if (!isNaN(item.percent)) {
                                thisValue = item.percent;
                            }
                            return current += thisValue;
                        }, 0);
                        if (!isNaN(total)) {
                            flag = (total <= 100);
                        }
                    }
                    return flag;
                };

            }
        };
    }

}());
(function() {
'use strict';

    angular
        .module('app.core')
        .controller('ToastController', ToastController);

    function ToastController(
        $scope, 
        $mdToast
    ){
        $scope.closeToast = function() {
            $mdToast.hide();
        };
    }
})();
(function () {
    'use strict';

    // to replace all Mongo Controllers for Lists
    angular
        .module('app.core')
        .controller('MongoListsController', MongoListsController);

    /** @ngInject */
    function MongoListsController(
        $scope,
        $rootScope,
        $log,
        $q,
        $filter,
        $localStorage,
        errAlertS,
        translateFilter,
        $mdDialog,
        $document,
        $timeout,
        CatalogsF,
        $window,
        startAfterInitFilter,
        AppF,
        ApiV2F,
        ApiV3F,
        loadingS
    ) {
        $scope.currentPage = 0;
        var initiated = false;
        var objName = $scope.F.active.menuObjName;
        var menuName = $scope.F.active.menuName;
        var initGetData = false;
        var detailWatchers = {};
        $scope.initFilters = false;
        $scope.relatedData = {};
        $scope.tabs = $scope.F.active.tabs;
        $scope.tabName = '';
        $scope.tabConfig = undefined;
        $scope.F.selectedTab = undefined;
        $scope.F.filtersLoaded = true;
        // $scope.filter = $scope.F.active.filter;
        var menuParent = $scope.F.active.menuParent;
        $scope.F.orderMongo = angular.isDefined($localStorage[menuName + 'orderMongo']) ? angular.fromJson($localStorage[menuName + 'orderMongo']) : (($scope.R.listOrder[menuName]) ? $scope.R.listOrder[menuName] : '$id');
        $scope.F.search[objName] = angular.isDefined($localStorage[menuName + 'mainSearch']) ? $localStorage[menuName + 'mainSearch'] : '';
        $scope.selected = [];
        var scopeName = (angular.isDefined($scope.F.active.filter) && $scope.F.active.filter.scopeName) ? $scope.F.active.filter.scopeName : menuName;
        delete $scope.catalogReady;
        // $scope.vm = $scope;
        function getConfigurationRow(menuName) {
            var data = angular.fromJson(localStorage.getItem('configuration-' + menuName));
            var fields = [];
            if (data === null) {
                fields.push({ catalogs: menuName, show: false });
            } else {
                fields = data;
            }
            return fields;
        }

        $scope.columnsRepeat = $filter('getConfigurationColumns')($scope.F.active.moreColumns, getConfigurationRow($scope.F.active.menuName), $scope.F.active.menuName);
        // function catalogUpdated(data) {
        //     var thisCatalog = menuName;
        //     if (angular.isDefined($scope.F.active.$alias)) {
        //         thisCatalog = $scope.F.active.$alias;
        //     }
        //     if (angular.isObject(data) && data !== null && data.hasOwnProperty('catalog') && thisCatalog === data.catalog) {
        //         $scope.getThem(true, 'from catalogUpdated');
        //     }
        // }
        $scope.getThemPagination = function () {
            $scope.getThem(false, 'from getThemPagination');
        };
        var init = function () {
            var defaultPermission = ['access', 'add', 'edit', 'remove'];
            $filter('loopEach')($scope.tabs, function (data, key) {
                var allP = defaultPermission.slice();
                for (var a = 0; a < allP.length; a++) {
                    allP[a] = allP[a] + (data.pObject ? data.pObject : '');
                }
                if (angular.isArray(data.permission)) {
                    allP = allP.concat(data.permission);
                }
                for (var c = 0; c < allP.length; c++) {
                    var action = allP[c];
                    var access = $scope.F.active.menuItem;
                    if (angular.isObject(action)) {
                        access = action.access;
                        action = action.action;
                    }
                    var accessC = access.split('.');
                    $scope.tabs[key][accessC[accessC.length - 1] + action] = $filter('userHasPermission')($scope.F.groupsOfUser, $scope.F.permissions, action, access);
                }
            });
            $log.debug('initiating ' + objName + ' controller as MongoListsCtrl');
            $scope[menuName] = [];
            $scope.Z[menuName] = $scope[menuName];
            $scope.currentPage = $scope.F.currentPage();
            var promises = [];
            $scope.getValidations();
            promises.push($scope.L.loadNeeded($scope.L.loadData[menuName]));
            promises.push($scope.M.loadNeeded($scope.M.loadData[menuName]));
            var getThemCalled = false;
            $q.all(promises).then(function () {
                return new Promise(function (resolve, reject) {
                    try {
                        if ($scope.tabs) {
                            var tabFromStor = $localStorage[menuName + 'lastTab'];
                            var lastTab = angular.isDefined(tabFromStor) && $scope.tabs.hasOwnProperty(tabFromStor) && $scope.tabs[tabFromStor][menuName + 'access' + ($scope.tabs[tabFromStor].pObject ? $scope.tabs[tabFromStor].pObject : '')] ? tabFromStor : undefined;
                            var count = -1;
                            var founded = false;
                            $filter('loopEach')($scope.tabs, function (thisTabConfig, tab) {
                                if (!founded && thisTabConfig[menuName + 'access' + (thisTabConfig.pObject ? thisTabConfig.pObject : '')]) {
                                    count++;
                                    if (angular.isDefined(lastTab) && lastTab === tab) {
                                        founded = true;
                                    } else if (angular.isUndefined(lastTab)) {
                                        lastTab = tab;
                                        founded = true;
                                    }
                                }
                            });
                            $timeout(function () {
                                if (angular.isDefined(lastTab)) {
                                    getThemCalled = true;
                                    $scope.F.selectedTab = count;
                                }
                                resolve(true);
                            }, 500, false);
                        } else {
                            resolve(true);
                        }
                    } catch (error) {
                        reject(error);
                    }
                });
            }).then(function () {
                $scope.initFilters = true;
                initGetData = true;
                return getThemCalled ? Promise.all([]) : $scope.getThem(false, 'from init');
            }).then(function () {
                $scope.catalogReady = true;
                $rootScope.$emit('catalogReady');
                // if (angular.isUndefined($scope.F.catalogChangeListener)) {
                //     $scope.F.catalogChangeListener = $scope.F.root.child('settings/changeListener');
                //     $scope.F.catalogChangeListener.on('value', function (snapshot) {
                //         catalogUpdated(snapshot.val());
                //     });
                // }
            }).catch(function (error) {
                $log.error(error);
            });
        };

        $scope.openModalEdit = function (ev, columnConfig, object) {
            if (columnConfig.editFn && editFn.hasOwnProperty(columnConfig.editFn)) {
                editFn[columnConfig.editFn](ev, columnConfig, object);
            } else {
                openModalEditFn(ev, columnConfig, object);
            }
        }
        var editFn = {
            editPaymentForms: function (ev, column, employee) {
                $log.log('called')
                $mdDialog.show({
                    controllerAs: 'pfCtrl',
                    locals: {
                        employee: employee,
                        column: column,
                        getFn: $scope.getThem
                    },
                    controller: 'PaymentFormsController',
                    templateUrl: 'app/main/employees/dialogs/paymentForms.html',
                    parent: angular.element($document.body),
                    targetEvent: ev,
                    clickOutsideToClose: false
                }).then(function (answer) {
                    $log.debug(answer, 'importEmployeesModal answer');
                }).catch(function (err) {
                    $log.debug('importEmployeesModal cancelled', err);
                });
            }
        }
        function openModalEditFn(ev, columnConfig, object) {
            $log.debug('importVariablesModal');
            $mdDialog.show({
                locals: {
                    columnConfig: columnConfig,
                    object: object
                },
                controller: 'FieldEditModalController as fieldCtrl',
                templateUrl: 'app/main/employees/dialogs/edit-field-modal.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            }).then(function (result) {
                var flag = true;
                if (columnConfig.regex) {
                    var reg = new RegExp(columnConfig.regex);
                    flag = reg.test(result);
                }
                if (flag) {
                    var thisPath = columnConfig.path.replace(/\./g, '/');
                    if (columnConfig.rute && object.$id) {
                        var thisRute = columnConfig.rute;
                        if (angular.isFunction(thisRute)) {
                            thisRute = thisRute(object);
                        }
                        var absolutePath = thisRute + '/' + object.$id + '/' + thisPath;
                        $scope.F.root.child(absolutePath).set(result).then(function () {
                        }).catch(errAlertS);
                    } else {
                        $log.log('No se hizo ninguna edición');
                    }
                } else {
                    errAlertS('El valor ingresado no es valido');
                }
            }, function () {
                $log.log('Se cancelo edición');
            });
        }

        function getValue(thisValue, format, sendEmpty, otherFilters) {
            var formats = {
                monthSelected: function (value) {
                    $log.log(value);
                    if (angular.isDefined(value)) {
                        var today = moment();
                        today.month(value - 1);
                        var result = { $lt: today.endOf('month').valueOf(), $gt: today.startOf('month').valueOf() };
                        $log.log(result);
                        return result;
                    }
                    return undefined;
                },
                existsField: function (value, otherValues) {
                    return { $exists: true };
                },
                existsKey: function (value) {
                    if (value) {
                        var obj = {};
                        obj[value] = { $exists: true };
                        return angular.toJson(obj);
                    }
                    return undefined;
                },
                objectId: function (value) {
                    if (value) {
                        var obj = {};
                        if (angular.isArray(value)) {
                            if (value.length === 0 && !sendEmpty) {
                                return undefined;
                            }
                            for (var j = 0; j < value.length; j++) {
                                obj[value[j]] = true;
                            }
                        } else {
                            obj[value] = true;
                        }
                        return angular.toJson(obj);
                    }
                    return undefined;
                },
                regex: function (value) {
                    return { $regex: value };
                },
                default: function (value) {
                    if (angular.isArray(value)) {
                        if (value.length === 0 && !sendEmpty) {
                            return undefined;
                        }
                        if (value.length === 1) {
                            return value[0];
                        } else {
                            return { $in: value };
                        }
                    } else {
                        return value;
                    }
                }
            };
            if (angular.isFunction(format)) {
                return format(thisValue, otherFilters);
            } else {
                format = angular.isDefined(format) && formats.hasOwnProperty(format) ? format : 'default';
                return formats[format](thisValue, otherFilters);
            }
        }
        $scope.getParamsObject = function (params) {
            params = params ? params : {};
            if ($scope.F.search[objName]) {
                $localStorage[menuName + 'mainSearch'] = $scope.F.search[objName];
                if (angular.isArray($scope.F.active.$generalFilter)) {
                    var generalFilter = $scope.F.active.$generalFilter.slice(0, $scope.F.active.$generalFilter.length);
                    var activeSearchTextIndex = generalFilter.indexOf('activeSearchText');
                    if (activeSearchTextIndex > -1) {
                        params['$text'] = JSON.stringify({ '$search': "*" + $scope.F.search[objName] + "*" });
                    } else {
                        params['$or'] = [];
                        for (var g = 0; g < generalFilter.length; g++) {
                            var thisField = {};
                            var thisFieldConfig = generalFilter[g].split(':');
                            switch (thisFieldConfig[1]) {
                                case 'number':
                                    var number = parseFloat($scope.F.search[objName]);
                                    if (!isNaN(number)) {
                                        thisField[thisFieldConfig[0]] = number;
                                        params['$or'].push(thisField);
                                    }
                                    break;
                                default:
                                    thisField[thisFieldConfig[0]] = {
                                        '$regex': $scope.F.search[objName],
                                        '$options': 'i'
                                    };
                                    params['$or'].push(thisField);
                                    break;
                            }
                        }
                    }

                } else {
                    params.name = $scope.F.search[objName];
                }
            } else {
                delete $localStorage[menuName + 'mainSearch'];
            }
            var customKeys = {};
            var thisFilterConfig = $scope.F.active.$filtersConfig || {};
            if (angular.isDefined($scope.F.filters) && angular.isObject($scope.F.filters[$scope.F.active.menuName])) {
                $filter('loopEach')($scope.F.filters[$scope.F.active.menuName], function (value, key) {
                    if (value) {
                        var thisKeyConfig = thisFilterConfig[key];
                        var specialFormat = $filter('getFromObject')(thisKeyConfig, 'specialFormat', undefined, true);
                        var thisValue = getValue(value, specialFormat, undefined, $scope.F.filters[$scope.F.active.menuName]);
                        if (angular.isDefined(thisValue) && thisValue !== 'all' && thisValue !== '') {
                            var specialKey;
                            var specialKeyParams = $filter('getFromObject')(thisKeyConfig, 'specialKey');
                            if (angular.isString(specialKeyParams)) {
                                specialKeyParams = specialKeyParams.split(":");
                                var firstResult = specialKeyParams.shift();
                                if (firstResult && firstResult !== '') {
                                    specialKey = firstResult;
                                }
                            }
                            if (angular.isDefined(specialKey) && angular.isDefined(value)) {
                                switch (specialKey) {
                                    case 'concatOtherValue':
                                        $log.log(specialKey, specialKeyParams, $scope.F.filters[$scope.F.active.menuName])
                                        var childKey
                                        if (specialKeyParams.length > 0 && $scope.F.filters[$scope.F.active.menuName] && $scope.F.filters[$scope.F.active.menuName][specialKeyParams[0]]) {
                                            childKey = $scope.F.filters[$scope.F.active.menuName][specialKeyParams[0]];
                                        }
                                        if (childKey) {
                                            var thisKey3 = key + '.' + childKey;
                                            customKeys[key] = thisKey3;
                                            params[thisKey3] = thisValue;
                                        } else {
                                            params[key] = thisValue;
                                        }
                                        break;
                                    case 'lastKeyObject':
                                        var originalKey = key;
                                        var arrKey = key.split('.');
                                        key = key.replace('.' + arrKey[arrKey.length - 1], '');
                                        if (!angular.isObject(params[key])) {
                                            params[key] = {};
                                        }
                                        customKeys[originalKey] = key;
                                        params[key][arrKey[arrKey.length - 1]] = thisValue;
                                        break;
                                    case 'existsKey':
                                        var thisKey1 = key + '.' + value;
                                        customKeys[key] = thisKey1;
                                        params[thisKey1] = thisValue;
                                        break;
                                    case 'replaceDots':
                                        var thisKey2 = key.replaceAll('/', '.')
                                        customKeys[key] = thisKey2;
                                        params[thisKey2] = thisValue;
                                        break;
                                    default:
                                        params[key] = thisValue;
                                        break;
                                }
                            } else {
                                params[key] = thisValue;
                            }
                        }
                    }
                });
            }
            $filter('loopEach')(thisFilterConfig, function (data, key) {
                if (angular.isDefined(data.defaultValue) && angular.isUndefined(params[key])) {
                    var defaultValue;
                    if (angular.isFunction(data.defaultValue)) {
                        defaultValue = getValue(data.defaultValue(angular.isDefined($scope.tabs) ? $scope.tabs[$scope.tabName] : undefined), undefined, true);
                    } else {
                        defaultValue = getValue(data.defaultValue, undefined, true);
                    }
                    if (angular.isDefined(defaultValue)) {
                        params[key] = defaultValue;
                    }
                }
                var thisIsRequired = angular.isFunction(data.required) ? data.required(angular.isDefined($scope.tabs) ? $scope.tabs[$scope.tabName] : undefined) : data.required;
                if (thisIsRequired && angular.isUndefined(params[key]) && angular.isUndefined(params[customKeys[key]])) {
                    params[key] = 'requiredParams';
                }
            });

            return params;
        };
        $scope.setTabName = function (tabName) {
            $localStorage[menuName + 'lastTab'] = tabName;
            $scope.tabName = tabName;
            $scope.tabConfig = $scope.tabs[$scope.tabName];
            if (angular.isDefined($scope.tabs) && angular.isDefined($scope.tabs[$scope.tabName]) && angular.isArray($scope.tabs[$scope.tabName].removeFilter)) {
                for (var f = 0; f < $scope.tabs[$scope.tabName].removeFilter.length; f++) {
                    var filterName = $scope.tabs[$scope.tabName].removeFilter[f];
                    if (angular.isDefined($scope.F.filters) && angular.isDefined($scope.F.filters[$scope.F.active.menuName]) && angular.isDefined($scope.F.filters[$scope.F.active.menuName][filterName])) {
                        delete $scope.F.filters[$scope.F.active.menuName][filterName];
                    }
                }
            }
            $scope.getThem(false, 'fromSetTabName');
        };
        $scope.exportData = function (allData, catalog, exportId, dbType, query, totalResults, glue, includeRowNumber, includeHeader, exportType) {
            if ($scope.F.orderMongo) {
                query.sort = $scope.F.orderMongo;
            }
            CatalogsF.exportData(allData, $scope.selected, catalog, exportId, dbType, query, totalResults, glue, includeRowNumber, includeHeader, exportType);
        };
        $scope.exportDataToExcelByQuery = function (allData, exportId, queries, totalResults, ref, customUrl) {
            if (ref) {
                $scope.refToExport = ref;
            } else if (angular.isUndefined($scope.refToExport)) {
                $scope.refToExport = $scope.R.constructDinamicRef(scopeName, false, $scope);
            }
            if (angular.isDefined($scope.tabs) && angular.isDefined($scope.tabs[$scope.tabName]) && angular.isDefined($scope.tabs[$scope.tabName].fixedOrder)) {
                $scope.F.orderMongo = $scope.tabs[$scope.tabName].fixedOrder;
            }
            $log.log($scope.F.orderMongo);
            if ($scope.F.orderMongo) {
                queries.sort = $scope.F.orderMongo;
            }
            CatalogsF.exportDataToExcelByQuery(allData, exportId, $scope.selected, $scope.refToExport, queries, totalResults, customUrl);
        };
        function getV2ApiParams(params) {
            var thisParams = {};
            if (params.size) {
                thisParams.$size = params.size;
                delete params.size;
            }
            if (params.page) {
                thisParams.$page = params.page;
                delete params.page;
            }
            if (params.sort) {
                thisParams.$sort = params.sort;
                delete params.sort;
            }
            for (var param in params) {
                if (param.indexOf("$or") > -1) {
                    thisParams[param] = angular.toJson(params[param]);
                } else {
                    thisParams[param] = params[param];
                }
            }
            return thisParams;
        }
        $scope.getThem = function (dontShowLoading, from) {
            return $q(function (resolve, reject) {
                if (initGetData && $scope.F.filtersLoaded) {
                    if (!dontShowLoading) {
                        loadingS.start();
                    }
                    var params = {
                        page: $scope.currentPage,
                        size: menuName === 'kardexEmployees' ? $scope.F.paginateV2 : $scope.F.paginate
                    };
                    if (angular.isDefined($scope.tabs) && angular.isDefined($scope.tabs[$scope.tabName]) && angular.isDefined($scope.tabs[$scope.tabName].fixedOrder)) {
                        $scope.F.orderMongo = $scope.tabs[$scope.tabName].fixedOrder;
                    }
                    if ($scope.F.orderMongo) {
                        $localStorage[menuName + 'orderMongo'] = angular.toJson($scope.F.orderMongo);
                        params.sort = $scope.F.orderMongo;
                    }
                    params = $scope.getParamsObject(params);
                    $log.log('getThem', from, params);
                    var catalog = menuName;
                    if (angular.isDefined($scope.F.active.$alias)) {
                        catalog = $scope.F.active.$alias + 's';
                    }
                    var promise;
                    if (AppF.active.apiVersion === 2) {
                        promise = ApiV2F.get('api/p/' + catalog, getV2ApiParams(params))
                    } else if (AppF.active.apiVersion === 3) {
                        promise = ApiV3F.get('api/p/' + catalog, getV2ApiParams(params))
                    } else {
                        promise = $scope.D.api.get('p/' + catalog, params);
                    }
                    promise.then(function (res) {
                        $scope.selected = [];
                        if ([2, 3].indexOf(AppF.active.apiVersion) > -1) {
                            $scope[menuName] = res.data.records;
                            $scope.pagination = res.data.pagination;
                        } else {
                            $scope[menuName] = res.data.data;
                            $scope.pagination = res.data.pagination;
                        }

                        for (var r = 0; r < $scope[menuName].length; r++) {
                            if ($scope[menuName][r].hasOwnProperty('fid')) {
                                $scope[menuName][r].$id = $scope[menuName][r].fid;
                            }
                        }
                        return $filter('getRelationsOfCat')($scope[menuName], menuName, $scope.relatedData, 'called from getThem');
                    }).then(function (catWithRelationNames) {
                        $scope[menuName] = catWithRelationNames;
                        loadingS.stop();
                        $rootScope.$evalAsync(function () {
                            $log.debug('getThem finished');
                            $timeout(function () {
                                resolve(true);
                            }, 0);
                        });
                    }).catch(function (err) {
                        errAlertS(err);
                        loadingS.stop();
                        $rootScope.$evalAsync(function () {
                            $log.debug('getThem finished with errors');
                            $timeout(function () {
                                reject(err);
                            }, 0, false);
                        });
                    });
                } else {
                    resolve(true);
                }
            });
        };
        function getTemporalToken() {
            return new Promise(function (resolve, reject) {
                var temporalToken = $scope.F.root.child('catalogs/authTokens').push().key;
                var obj = {};
                obj[temporalToken] = {
                    code: temporalToken,
                    uid: $scope.F.profile.uid,
                    type: 'temporal',
                    from: 'mongoListAuthToken',
                    restrictUrl: '/views/documents'
                };
                $scope.F.root.child('catalogs/authTokens').update(obj).then(function () {
                    resolve(temporalToken);
                }).catch(reject);

            });
        }
        $scope.showDocument = function (documentId, action) {
            var openedWindows;
            $scope.D.models.action('documents', 'validateDocuments', { documentId: documentId }).then(function () {
                var promises = [];
                if (action === 'sign') {
                    promises.push($scope.D.api.get('documents/' + documentId));
                }
                openedWindows = $window.open();
                Promise.all(promises)
            }).then(function (res) {
                if (action === 'sign') {
                    if (res.length <= 0) {
                        throw 'No se encuentra el documento';
                    }
                    var thisObj = res[0].data;
                    if (thisObj.signed) {
                        $scope.getThem();
                        throw 'Este documento ya esta firmado';
                    }
                }
                return getTemporalToken();
            }).then(function (temporalToken) {
                var finalUrl = $window.__env.serviceWorkerUrl + 'views/documents?temporalToken=' + temporalToken + '&documentId=' + documentId + '&action=' + action;
                openedWindows.location = finalUrl;
            }).catch(function (err) {
                if (angular.isDefined(openedWindows)) {
                    openedWindows.close();
                }
                errAlertS(err);
            });



        };
        // Methods
        $scope.getValidations = function () {
            $scope.validations = [{
                valid: ($scope[menuName].length && !$rootScope.loadingProgress),
                msg: 'Parece que no tiene ' + $filter('menuName')(menuName) + ' aún'
            }];
            $log.debug($scope.validations, 'validations');
        };
        $scope.deleteFb = function (e, promise) {
            return new Promise(function (resolve, reject) {
                if (!promise) { loadingS.start(); }
                var resp;
                $scope.C.deleteSafe(e, menuParent, objName, $scope.selected, $scope).then(function (res) {
                    resp = res;
                    var time = promise ? 0 : 5000;
                    return new Promise(function (resolve) {
                        $timeout(function () {
                            if (!promise) {
                                $scope.getThem(false, 'from deleteDb');
                            }
                            resolve(true);
                        }, time, false);
                    });
                }).then(function () {
                    $scope.selected = [];
                    if (!promise) {
                        // loadingS.stop();
                        $rootScope.$evalAsync(function () {
                            $log.debug('delete finished');
                        });
                    }
                    resolve(resp);
                }).catch(function (err) {
                    if (!promise) {
                        errAlertS(err);
                        // loadingS.stop();
                        $rootScope.$evalAsync();
                    }
                    reject(err);
                });
            });
        };
        $scope.delete = function (e, isPromise, fn) {
            var deferred;
            if (isPromise) {
                deferred = $q.defer();
            }
            $scope.M.deleteSafe(e, objName, $scope.selected, translateFilter($scope.F.active.menuObjName + '.PLURAL'), $scope.F.active.$alias ? $scope.F.active.$alias + 's' : undefined, fn).then(function () {
                return $scope.getThem(false, 'from delete');
            }).then(function () {
                $scope.selected = [];
                if (isPromise) {
                    deferred.resolve(true);
                }
            }).catch(function (error) {
                $log.log(error);
                if (isPromise) {
                    deferred.reject(error);
                }
            });
            if (isPromise) {
                return deferred.promise;
            }
        };
        detailWatchers.currentPageListener = $scope.$watch('currentPage', function (cp) {
            if (cp) {
                $scope.F.setCurrentPage(cp);
                $log.debug('setting currentPage', cp, $scope.currentPage);
            }
        });
        startAfterInitFilter($scope, detailWatchers, initiated, init);
    }

}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .controller('MongoDetailController', MongoDetailController);

    /** @ngInject */
    function MongoDetailController(
        $scope,
        $rootScope,
        $state,
        $log,
        MongoF,
        $q,
        successAlertS,
        errAlertS,
        AppF,
        startAfterInitFilter,
        setDataInObjectFilter,
        switchOtherMongoRecordsFilter,
        ApiV2F,
        ApiV3F,
        loadingS
    ) {
        // $scope.vm = $scope;
        var initiated = false;
        var objName = $scope.F.active.menuObjName;
        var menuName = $scope.F.active.menuName;
        var statesObj = $scope.R.states;
        var menuState = statesObj.mongo[menuName];
        var mainObjectLoaded = $q.defer();
        var detailWatchers = {};
        $scope.mainObjectLoaded = mainObjectLoaded.promise;
        $scope.objectLoaded = false;
        // $scope.formName = objName + 'Form';
        $scope.selectedTab = '0';
        $scope.blanc = {};

        $scope.addElement = function (mainObj, arrayObj, obj) {
            if (angular.isDefined(mainObj)) {
                if (angular.isUndefined(mainObj[arrayObj])) {
                    mainObj[arrayObj] = [];
                }
                mainObj[arrayObj].push(obj);
            }
        };

        function init() {
            if (angular.isObject(menuState.blanc)) {
                for (var field in menuState.blanc) {
                    if (menuState.blanc.hasOwnProperty(field)) {
                        var thisField = menuState.blanc[field];
                        if (angular.isFunction(thisField)) {
                            $scope.blanc[field] = thisField();
                        } else {
                            $scope.blanc[field] = thisField;
                        }
                    }
                }
            }
            $scope.dataNeededPromise = $scope.loadDataNeeded($scope.F.active.menuName);
            $log.debug('initiating ' + menuName + ' controller as CatalogsDetailsCtrl');
            // si no viene el parámetro detalle, o del objeto se regresa a atrás
            if (!$state.params[objName + 'Id'] && !$state.params[objName]) { $scope.R.goToList(); }
            $scope[objName + 'Id'] = $state.params[objName + 'Id'];
            var defered = $q.defer();
            var promises = [
                defered.promise,
                $scope.dataNeededPromise
            ];
            if (!$state.params[objName] && $state.params[objName + 'Id'] && !$scope.F.addMode) {
                var catalog = menuName;
                if (angular.isDefined($scope.F.active.$alias)) {
                    catalog = $scope.F.active.$alias + 's';
                }
                var promise;
                if (AppF.active.apiVersion === 2) {
                    promise = ApiV2F.get('api/' + catalog + '/' + $scope[objName + 'Id'])
                } else if (AppF.active.apiVersion === 3) {
                    promise = ApiV3F.get('api/' + catalog + '/' + $scope[objName + 'Id'])
                } else {
                    promise = $scope.D.api.get(catalog + '/' + $scope[objName + 'Id']);
                }
                promise.then(function (res) {
                    $scope.objectLoaded = true;
                    $scope[objName] = res.data;
                    $scope.F.active.detailObject = $scope[objName];
                    $log.debug('Loaded from Mongo', objName, $scope[objName]);
                    defered.resolve(objName);
                }, function (error) {
                    defered.reject(error);
                });
            } else {

                // si se manda objeto de bank vació, se entiende que se quiere crear uno
                $scope[objName] = ($scope.F.addMode) ? angular.copy($scope.blanc) : $state.params[objName];
                $scope.F.active.detailObject = $scope[objName];
                $scope.objectLoaded = true;
                $log.debug('Loaded from previous state or new', objName, $scope[objName]);
                defered.resolve(objName);
            }
            Promise.all(promises).then(function () {
                $rootScope.$emit('mDetailFinished');
                $scope.mDetailFinished = true;
                mainObjectLoaded.resolve();
            }).catch(function (err) {
                errAlertS(err);
                mainObjectLoaded.reject(err);
                if ($scope.F.settings.goToListOnFail) { $scope.R.goToList(); }
            });
        }
        $scope.setData = setDataInObjectFilter;


        function disableContracts(employeeId, id) {
            var contractIds = MongoF.documentTypes.filter(function (item) {
                return item.type === 'contract';
            }).map(function (item) {
                return item._id;
            })
            return $scope.D.api.get('documents', { employee: employeeId, documentType: angular.toJson({ $in: contractIds }) }).then(function (resp) {
                if (!resp.data || !resp.data.length) {
                    $log.log('No hay documentos de tipo contrato que desactivar');
                }
                var response = resp.data;
                for (var i = 0; i < response.length; i++) {
                    if (id !== response[i]._id) {
                        $scope.D.api.update('documents', response[i]._id, { active: false }).then(function (res) {
                            $log.log('Document updated successfully:', res);
                        });
                    }
                }
            }).catch(function (error) {
                $log.log(error);
            });
        }


        $scope.add = function (obj) {
            loadingS.start();
            $log.debug('Adding to mongo collection:' + menuName, obj);
            if (angular.isObject(obj) && angular.isUndefined(obj.created)) {
                obj.created = $scope.D.getTimeObject(true, undefined, true);
            }
            function addIt(object) {
                var catalog = menuName;
                if (angular.isDefined($scope.F.active.$alias)) {
                    catalog = $scope.F.active.$alias + 's';
                }
                $scope.D.api.addWithUnique(catalog, object, menuState.unique).then(function (res) {
                    var id = res.data.insertedIds[0];
                    obj._id = id;
                    $scope[objName] = object;
                    var data = res.data.ops[0];
                    if (catalog === 'documents' && angular.isString(catalog)) {
                        $log.log('data', data)
                        var promises = [disableContracts(data.employee, data._id)]
                        Promise.all(promises).then(function (resp) {
                            $log.log(resp);
                        }).catch(function (err) {
                            $log.log(err)
                        });
                    }
                    successAlertS('Se creó registro con éxito');
                    $rootScope.$emit('mongoCatalogCreated', {
                        name: menuName,
                        data: object
                    });
                    $scope.R.goToList();
                    loadingS.stop();
                    $rootScope.$evalAsync(function () {
                        $log.debug($scope[objName], 'saved on Mongo');
                    });
                }).catch(function (err) {
                    errAlertS(err);
                    loadingS.stop();
                    $rootScope.$evalAsync();
                });
            }
            // default es para tener un registro default (solo se puede tener 1) 
            if (obj.default) {
                var params;
                if (angular.isFunction(menuState.default)) {
                    params = menuState.default(obj);
                } else if (angular.isObject(menuState.default)) {
                    params = menuState.default;
                }
                switchOtherMongoRecordsFilter(false, menuName, 'default', 0, params).then(function () {
                    successAlertS('Se guardó registro como predeterminado');
                }, errAlertS).then(function () {
                    addIt(obj);
                });
            } else {
                addIt(obj);
            }
        };
        $scope.setMainObject = function (obj) {
            var thisObject = {};
            if ($scope.blanc) {
                thisObject = angular.copy($scope.blanc);
            }
            $scope[objName] = Object.assign(thisObject, obj);

            $log.log('Blanc: ', $scope.blanc)
            $log.log('Datos de del scope', $scope[objName]);
            $scope.F.active.detailObject = $scope[objName];
        }

        $scope.save = function (obj) {
            loadingS.start();
            $log.debug('saving ' + objName, obj);
            var p = angular.copy(obj);
            if (angular.isObject(obj)) {
                obj.updated = $scope.D.getTimeObject(true, undefined, true);
            }
            function saveIt(object) {
                var catalog = menuName;
                if (angular.isDefined($scope.F.active.$alias)) {
                    catalog = $scope.F.active.$alias + 's';
                }
                $scope.D.api.update(catalog, object._id, object).then(function () {
                    successAlertS('Se guardó registro con éxito');
                    $rootScope.$emit('mongoCatalogUpdated', {
                        name: menuName,
                        data: object,
                        id: p._id
                    });
                    $scope.R.goToList();
                    loadingS.stop();
                    $rootScope.$evalAsync(function () {
                        $log.debug('save mongo finished');
                    });
                }).catch(function (err) {
                    errAlertS(err);
                    loadingS.stop();
                    $rootScope.$evalAsync();
                });
            }
            if (obj.default) {
                var params;
                if (angular.isFunction(menuState.default)) {
                    params = menuState.default(obj);
                } else if (angular.isObject(menuState.default)) {
                    params = menuState.default;
                }
                switchOtherMongoRecordsFilter(obj._id, menuName, 'default', 0, params).then(function () {
                    successAlertS('Se guardó registro como predeterminado');
                }, errAlertS).then(function () {
                    saveIt(obj);
                });
            } else {
                saveIt(obj);
            }
        };
        var onDestroyFns = [
            function () {
                delete $scope.F.active.detailObject;
            }
        ]
        startAfterInitFilter($scope, detailWatchers, initiated, init, onDestroyFns);
    }

}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .controller('FBListsController2', FBListsController)

    /**
    @ngdoc controller
    @name app.core.controller:FBListsController
    @requires $scope
    @requires $rootScope
    @requires $state
    @requires $firebaseObject
    @requires $firebaseArray
    @requires $log
    @requires $q
    @requires successAlertS
    @requires errAlertS
    @requires infoAlertS
    @requires $filter
    @requires clearObjectFilter
    @requires translateFilter
    */
    /** @ngInject */
    function FBListsController(
        $rootScope,
        $scope,
        $log,
        $q,
        menuNameFilter,
        translateFilter,
        pathInObjFilter,
        $timeout,
        errAlertS,
        $filter, // no quitar se requiere para eval fn
        getArrayFromObjectFilter,
        $mdDialog,
        $document,
        CatalogsF,
        objectInArrayFilter,
        startAfterInitFilter
    ) {
        var initiated = false;
        var menuName = $scope.F.active.menuName;
        var menuParent = $scope.F.active.menuParent;
        var objName = $scope.F.active.menuObjName;
        $scope.statesObj = $scope.R.states;
        $scope.menuState = $scope.statesObj.fb[menuName];
        var filtersDone = false;
        $scope.C[menuName] = [];
        $scope[menuName] = [];
        $scope.selected = [];
        $scope.currentPage = $scope.F.currentPage();
        $scope.F.currentPageMongo = $scope.F.currentPage();
        $scope.filter = $scope.F.active.filter;
        $scope.$filter = $scope.F.active.$filter;
        $scope.$$filter = $scope.F.active.$$filter;
        $scope.filters = $scope.F.active.filters;
        $scope.$filters = $scope.F.active.$filters;
        $scope.$filtersUse = $scope.F.active.$filtersUse;
        $scope.$generalFilter = $scope.F.active.$generalFilter;
        $scope.$filtersConfig = $scope.F.active.$filtersConfig;
        $scope.moreColumns = $scope.F.active.moreColumns;
        $scope.columnsRepeat = $filter('getConfigurationColumns')($scope.moreColumns, getConfigurationRow(menuName), menuName);
        $scope.listWatchers = {};
        $scope.relatedData = {};
        $scope.order = ($scope.R.listOrder[menuName]) ? $scope.R.listOrder[menuName] : '$id';
        $scope.F.orderMongo = ($scope.R.listOrder[menuName]) ? $scope.R.listOrder[menuName] : '$id';
        var scopeName = ($scope.filter.scopeName) ? $scope.filter.scopeName : menuName;
        var allIsAllowed = false;
        if ($scope.filters) {
            $scope.lastFilter = $scope.filters[$scope.filters.length - 1];
            if ($scope.lastFilter.scopeName !== scopeName) $scope.scopeName = $scope.lastFilter.scopeName;
        } else {
            $scope.scopeName = scopeName;
        }
        if (!$scope.Z[$scope.scopeName]) $scope.Z[$scope.scopeName] = [];
        /**
         * @ngdoc method
         * @name app.core.controller:FBListsController#getConfigurationRow
         * @methodOf app.core.controller:FBListsController
         * @description Obtiene la configuracion de las columnas que se encuentra en localstorage
         * @param menuName es un identificador para tomar el nombre del arreglo en localstorage
         */
        function getConfigurationRow(menuName) {
            var data = angular.fromJson(localStorage.getItem("configuration-" + menuName));
            var fields = [];
            if (data === null) {
                fields.push({ catalogs: menuName, show: false });
            } else {
                fields = data;
            }
            return fields;
        }
        /**
         * @ngdoc method
         * @name app.core.controller:FBListsController#$scope.createConfiguration
         * @methodOf app.core.controller:FBListsController
         * @description Crear la configuracion de las columnas en localstorage
         * @param index es el indice del arreglo a modificar
         * @param value es el valor que se va agregar el arreglo de la configuracion
         * @param menuName es un identificador para crear el nombre del arreglo en localstorage
         */
        $scope.createConfiguration = function (index, value, menuName) {
            var cache = angular.fromJson(localStorage.getItem("configuration-" + menuName));
            if (cache !== null) {
                cache[value.name] = { catalogs: value.catalogs, name: value.name, show: (value.show) ? false : true }
            } else {
                cache = {};
                cache[value.name] = { catalogs: value.catalogs, name: value.name, show: (value.show) ? false : true };
            }
            $log.log(cache);
            localStorage.setItem("configuration-" + menuName, angular.toJson(cache));
        }
        //Evento para mostrar menu de la configuracion de las columnas
        $scope.openMenu = function ($mdOpenMenu, ev) {
            $mdOpenMenu(ev);
        }
        /**
         * @ngdoc method
         * @name app.core.controller:FBListsController#getPrincipalFilter
         * @methodOf app.core.controller:FBListsController
         * @description Obtiene filtro principal de la configuración en Routes
         */
        function getPrincipalFilter() {
            if ($scope.filters) {
                for (var f in $scope.filters) {
                    if ($scope.filters[f].principal) {
                        return $scope.filters[f];
                    }
                }
                return $scope.filter;
            } else {
                if ($scope.filter) {
                    return $scope.filter;
                }
                return {}; // no filter
            }
        }

        /**
         * @ngdoc method
         * @name app.core.controller:FBListsController#setFilterBy
         * @methodOf app.core.controller:FBListsController
         * @description Setea el campo default de los filtros *por en búsqueda avanzada
         */
        function setFilterBy() {
            var filterByDefault = null;
            for (var f in $scope.R.filtersBy[$scope.F.active.menuName]) {
                if ($scope.R.filtersBy[$scope.F.active.menuName][f].default) {
                    filterByDefault = $scope.R.filtersBy[$scope.F.active.menuName][f];
                }
            }
            $scope.F.search.filterBy = filterByDefault || $scope.F.search.filterBy;
        }

        var principalFilter = getPrincipalFilter();


        /** */
        function init() {
            initiated = true;
            if ($scope.filter) {
                if (!$scope.filter.restrictAll && $scope.F.isDistributor()) { allIsAllowed = true; };
            }
            $scope.F.advancedSearchMode = ($scope.F.isDistributor()) ? true : false;
            $scope.loadDataNeeded($scope.F.active.menuName); // in indexCtrl loads Mongo Cats and Lists or Objects
            // setear F.search.$param si viene en los params y no esta seteado ya si hay un filtro
            if ($scope.filter) {
                $scope.R.setStateFilter($scope.filter, allIsAllowed);
            }

            // se setea el filterBy con el default que le corresponde
            setFilterBy();
            resetMemory();
            resetSearch(1);


            // setear F.search.$param por cada uno de los filtros
            if ($scope.filters) {
                for (var f in $scope.filters) {
                    $scope.R.setStateFilter($scope.filters[f], allIsAllowed);
                }
            }
            // checkAndLoadFiltersAndWatchers();
            if (menuName == 'employees') {
                $scope.F.root.child('catalogs').child(menuName).child('counter').on('value', function (s) {
                    if (s.val()) {
                        $scope.totalCounter = s.val();
                    } else {
                        $scope.totalCounter = 0;
                    }
                });
            }

            if (!$scope.filter) {
                $scope.loadThem(1).then(function () {
                    checkAndLoadFiltersAndWatchers();
                    $scope.getValidations();
                });
            } else {
                if ($scope.filter.alias) { // es un filtro que esta esperando un valor de un select
                    checkAndLoadFiltersAndWatchers();
                    $scope.getValidations();
                } else { // es un filtro que debe aplicarse al
                    // $scope.getValidations();
                    $scope.loadThem(0, $scope.filter).then(function () {
                        checkAndLoadFiltersAndWatchers();
                        if ($scope.$$filter) { // hidden filter to be applied
                            // $scope.Z[scopeName] = $scope.filterData($scope[$scope.filter.scopeName], $scope.$$filter);
                            // $scope.getValidations();
                        } else {
                            $scope.Z[scopeName] = $scope[scopeName];
                            $scope.getValidations();
                        }
                    });
                }
            }
        }

        /**
         * @ngdoc method
         * @name app.core.controller:FBListsController#resetSearch
         * @methodOf app.core.controller:FBListsController
         * @description Resetea todos los campos de búsqueda simple o avanzada
         * @param {boolean} advancedToo Variable para determinar si es resteo simple o avanzado
         */
        function resetSearch(advancedToo) {
            $scope.F.searchText = null;
            if (advancedToo) {
                $scope.F.search.query = null;
                $scope.F.search.$query = null;
            }
        }

        /**
         * @ngdoc method
         * @name app.core.controller:FBListsController#resetMemory
         * @methodOf app.core.controller:FBListsController
         * @description Pone las factorys Z y C en blanco (solo variables)
         */
        function resetMemory() {
            $scope.Z = {};
            for (var c in $scope.C) {
                if (typeof $scope.C[c] != 'function' && c !== 'loadData') {
                    delete $scope.C[c];
                }
            }
        }

        /** */
        var resetSubFilters = function () {
            if ($scope.filters) {
                for (var f in $scope.filters) {
                    $scope.F.search['$' + $scope.filters[f].by] = false;
                }
            }
        }

        /** */
        var listenWatcherForAliasAndApplyFilter = function (filterP) {
            $scope.listWatchers['filters-' + filterP.by] = $scope.$watch(filterP.alias, function (val) {
                $log.log("listenWatcherForAliasAndApplyFilter", filterP)
                $scope[filterP.scopeName] = [];
                if (val) {
                    $scope.R.setStateParams(val, filterP, allIsAllowed); // se setea en $state.params
                    if (val == 'all') {
                        if (filterP.childRef) {
                            $scope[menuName] = []; // no se puede por ahora buscar todos en listados con filtros en hijos
                        } else {
                            if ($scope.filter.allowAll) {
                                if (filterP.scopeName == $scope.filter.allowAll.scopeName) {
                                    if (filterP.justFilter) {
                                        $scope.selected = [];
                                        $scope.filterData($scope[filterP.from], $scope.filter.allowAll);
                                        $scope.getValidations();
                                    } else {
                                        $scope.loadThem(0, $scope.filter.allowAll);
                                    }
                                }
                            } else {
                                if (filterP.justFilter) {
                                    $scope.selected = [];
                                    $scope.filterData($scope[filterP.from], filterP);
                                    $scope.getValidations();
                                } else {
                                    $scope.loadThem(0, filterP);
                                }
                            }
                        }
                    } else {
                        if (filterP.justFilter) {
                            $scope.selected = [];
                            $scope.filterData($scope[filterP.from], filterP);
                            $scope.getValidations();
                        } else {
                            $scope.loadThem(0, filterP);
                        }
                    }
                }
            });
        };

        /** */
        var checkAndLoadFiltersAndWatchers = function () {
            if (!$scope.R.dinamicRefs[menuName]) alert('Falta configurar R.dinamicRefs.' + menuName + ' !!!');
            if (!$scope.menuState) alert('Falta configurar R.states.fb."' + menuName + ' !!!');
            if ($scope.filter) {
                if ($scope.filter.alias) {
                    $scope.listWatchers.filter = $scope.$watch($scope.filter.alias, function (val) {
                        $log.log("checkAndLoadFiltersAndWatchers", $scope.filter.alias)
                        if (!$scope.menuState.dontResetFiltersOnLIst) $scope[menuName] = [];
                        if (!$scope.menuState.dontResetFiltersOnLIst) resetSubFilters();
                        if (val) {
                            $scope.R.setStateParams(val, null, allIsAllowed);
                            if (val == 'all' && allIsAllowed) {
                                if ($scope.filter.childRef) {
                                    if (!$scope.menuState.dontResetFiltersOnLIst) $scope[menuName] = []; // no se puede por ahora buscar todos en listados con filtros en hijos
                                } else { // si no hay filtro configurado carga todos
                                    $scope.loadThem(1);
                                }
                            } else {

                                if ($scope.filters) {
                                    $scope.loadThem(0, $scope.filter).then(function () {
                                        if (filtersDone) {
                                            if (!$scope.menuState.dontResetFiltersOnLIst) resetSubFilters();
                                        }
                                    });
                                } else {
                                    $scope.loadThem(0).then(function () {
                                        if (filtersDone) {
                                            if (!$scope.menuState.dontResetFiltersOnLIst) resetSubFilters();
                                        }
                                    });
                                }
                            }
                        } else {
                            var setUrl = true;
                            $scope.R.setStateParams(val, null, allIsAllowed, setUrl);
                            if ($scope.filters) {
                                if (!$scope.menuState.dontResetFiltersOnLIst) $scope.Z[menuName] = [];
                                $scope.getValidations();
                            }
                        }
                    });
                }
            }

            // $scope.filters son los filtros query y/o datos para mostrar el listado principal
            // el último es el que muestra los datos
            if ($scope.filters) {
                for (var f in $scope.filters) {
                    var filterP = $scope.filters[f];
                    if (filterP.alias) {
                        listenWatcherForAliasAndApplyFilter(filterP);
                    }
                }
            }
        }

        /**
         * @ngdoc method
         * @name app.core.controller:FBListsController#getValidations
         * @methodOf app.core.controller:FBListsController
         * @description obtiene las validaciones necesarias y muestra mensaje dinamicamente
         */
        $scope.getValidations = function () {
            var sFnString;
            var searchVal;
            if ($scope.F.active.filters) {
                sFnString = '$scope.' + $scope.filter.alias;
                searchVal = eval(sFnString);
                $scope.validations = [{
                    valid: (angular.isUndefined(searchVal) || $scope[menuName].length),
                    msg: 'No hay registros de ' + translateFilter(objName + '.SINGULAR') + ' aún.'
                }];
                for (var f in $scope.F.active.filters) {
                    var sFnStringX = '$scope.' + $scope.F.active.filters[f].alias;
                    var searchValX = eval(sFnStringX);
                    var cName = objName;
                    if (f == $scope.F.active.filters.length - 1) {
                        var ff = ($scope.F.active.filters.length == 1) ? 0 : f - 1;
                        if (!ff) {
                            cName = angular.fromJson(angular.toJson($scope.filter.scopeName));
                            cName = cName.substring(cName.length, -1);
                        } else {
                            if ($scope.F.active.filters[ff]) {
                                cName = angular.copy($scope.F.active.filters[ff].scopeName);
                                cName = cName.substring(cName.length, -1);
                            }
                        }
                    }
                    $scope.validations.push({
                        valid: (angular.isDefined(searchValX) && !$scope[menuName].length),
                        msg: 'Seleccione ' +
                            translateFilter($scope.F.active.filters[f].by + '.SINGULAR') +
                            ' para filtrar ' +
                            translateFilter(objName + '.SINGULAR') + '.'
                    });
                }
            } else {
                if ($scope.filter && $scope.filter.alias) {
                    sFnString = '$scope.' + $scope.filter.alias;
                    searchVal = eval(sFnString);
                    // valid -> que tiene que salir para que NO SALGA EL msg
                    // msg -> msg bajo excepción que que valid sea false
                    $scope.validations = [{
                        valid: (angular.isUndefined(searchVal) || $scope[menuName].length),
                        msg: 'No hay registros de ' +
                            translateFilter(objName + '.SINGULAR') +
                            ' aún.'
                    }, {
                        valid: (angular.isDefined(searchVal) && !$scope[menuName].length),
                        msg: 'Seleccione ' +
                            translateFilter($scope.filter.by + '.SINGULAR') +
                            ' para filtrar ' +
                            translateFilter(objName + '.SINGULAR') + '.'
                    }];
                } else {
                    if ($scope[menuName]) {
                        $scope.validations = [{
                            valid: ($scope[menuName].length),
                            msg: 'No hay ' + menuNameFilter(menuName) + ' aún'
                        }];
                    }
                }
            }
        }

        /** */
        $scope.filterMultipleData = function (data, filters, scopeName) {
            var filteredData = angular.copy(data);
            if (!scopeName) scopeName = menuName;
            for (var fi = 0; fi < filters.length; fi++) {
                filteredData = $scope.filterData(filteredData, filters[fi], 1);
                if (fi == filters.length - 1) {
                    $scope.$evalAsync(function () {
                        $scope.Z[scopeName] = filteredData;
                    });
                }
            }
            if (angular.isArray($scope.selected) && $scope.selected.length > 0) {
                var newSelected = [];
                for (var s = 0; s < $scope.selected.length; s++) {
                    if (angular.isArray(filteredData)) {
                        var obj = filteredData.find(function (item) {
                            return item.$id === $scope.selected[s].$id;
                        })
                        if (angular.isDefined(obj)) {
                            newSelected.push($scope.selected[s]);
                        }
                    }
                }
                $scope.selected = newSelected;
            }
            return filteredData;
        }

        /**
         * @ngdoc method
         * @name app.core.controller:FBListsController#autocompleteThis
         * @methodOf app.core.controller:FBListsController
         * @description función que filtra datos para búsqueda avanzada
         */
        $scope.autocompleteThis = function () {
            var filter = {};
            if ($scope.F.search.query && $scope.F.search.filterBy) {
                if ($scope.F.search.filterBy.uppercased) {
                    filter.startAt = $scope.F.search.query.toUpperCase();
                    filter.endAt = $scope.F.search.query.toUpperCase();
                    filter.endAt += '\uf8ff';
                } else {
                    if ($scope.F.search.filterBy.number) {
                        filter.val = Number($scope.F.search.query);
                    } else {
                        filter.val = $scope.F.search.query;
                    }

                }
                filter.alias = 'F.search.$query';
                filter.query = true;
                filter.name = $scope.F.active.menuName + '_by_' + $scope.F.search.filterBy.name;
                filter.by = angular.copy($scope.F.search.filterBy.orderBy);
                filter.scopeName = angular.copy($scope.F.active.menuName);
                $scope.loadThem(0, filter);
                watchFilter(filter);
            }
        };

        function addToParams(field, value, params, uppercase, orFields, dataType) {
            params = params ? params : {};
            var objectType = typeof (value);
            switch (objectType) {
                case 'object':
                    params[field] = {};
                    params[field].$in = value;
                    //en caso de que el field que se agrega al campo sea cc se pregunta si se tiene acceso a todas las nominas, en caso de ser cierto se elimina el campo cc para evitar enviar todas las cc
                    if (field === 'cc') {
                        if ($scope.F.permissionToAccessAllPayrolls) {
                            delete params[field];
                        }
                    }
                    break;
                case 'string':
                    if (uppercase) {
                        value = value.toUpperCase();
                    }
                    if (value == 'null') {
                        params[field] = { $exists: false }
                    } else if (value !== 'all') {
                        if (field === '$or') {
                            if (orFields) {
                                params[field] = [];
                                for (var o = 0; o < orFields.length; o++) {
                                    var q = {};
                                    q[orFields[o]] = {
                                        '$regex': value,
                                        '$options': 'i'
                                    };
                                    params[field].push(q);
                                }
                            }
                        } else if (dataType === 'idObject') {
                            params = {};
                            params[field + '.' + value] = true;
                        } else if (dataType === 'mObject' && angular.isDefined(value)) {
                            params[field] = value;
                        } else {
                            params[field] = {};
                            params[field].$regex = value;
                            params[field].$options = 'i';
                        }
                    }
                    break;
                case 'number':
                    if (field === '$or') {
                        if (orFields) {
                            params[field] = [];
                            for (var o = 0; o < orFields.length; o++) {
                                var q = {};
                                q[orFields[o]] = value;
                                params[field].push(q);
                            }
                        }
                    } else if (field.indexOf(':') >= 0) {
                        var fields = field.split(':');
                        switch (fields[1]) {
                            case '>=':
                                params[fields[0]] = params[fields[0]] ? params[fields[0]] : {};
                                params[fields[0]].$gt = value - 1;
                                break;
                            case '<=':
                                params[fields[0]] = params[fields[0]] ? params[fields[0]] : {};
                                params[fields[0]].$lt = value;
                                break;
                        }
                    } else {
                        params[field] = value;
                    }
                    break;
                case "boolean":
                    params[field] = value;
                    break;
            }
            return params;
        }

        $scope.getQuerys = function (params) {
            params = params ? params : {};
            if ($scope.F.orderMongo) { params.sort = $scope.F.orderMongo; }
            if ($scope.$$filter) {
                if ($scope.$$filter.length) {
                    for (var i = 0; i < $scope.$$filter.length; i++) {
                        var val = angular.isFunction($scope.$$filter[i].val) ? $scope.$$filter[i].val() : $scope.$$filter[i].val;
                        params = addToParams($scope.$$filter[i].by, val, params, undefined, undefined, $scope.$$filter[i].type);
                    }
                } else {
                    if ($scope.$$filter.by) {
                        val = angular.isFunction($scope.$$filter.val) ? $scope.$$filter.val() : $scope.$$filter.val;
                        if (val) {
                            params = addToParams($scope.$$filter.by, val, params, undefined, undefined, $scope.$$filter.type);
                        }
                    }
                }
            }
            if ($scope.$filters && $scope.$filters.length) {
                for (var a = 0; a < $scope.$filters.length; a++) {
                    if ($scope.F.search.$[$scope.$filters[a]] || ($scope.$filtersConfig && $scope.$filtersConfig[$scope.$filters[a]] && $scope.$filtersConfig[$scope.$filters[a]].allowFalse)) {
                        var f = $scope.$filters[a]
                        if ($scope.$filtersConfig && $scope.$filtersConfig[$scope.$filters[a]] && $scope.$filtersConfig[$scope.$filters[a]].replace) {
                            f = $scope.$filtersConfig[$scope.$filters[a]].replace;
                        }
                        var dataType;
                        if ($scope.$filtersConfig && $scope.$filtersConfig[$scope.$filters[a]] && $scope.$filtersConfig[$scope.$filters[a]].dataType) {
                            dataType = $scope.$filtersConfig[$scope.$filters[a]].dataType;
                        }
                        params = addToParams(f, $scope.F.search.$[$scope.$filters[a]], params, undefined, undefined, dataType);
                    }
                }
            }
            if ($scope.$generalFilter && $scope.$generalFilter.length && $scope.F.searchText && $scope.F.searchText[$scope.F.active.menuObjName]) {
                params = addToParams("$or", $scope.F.searchText[$scope.F.active.menuObjName], params, false, $scope.$generalFilter);
            }
            if ($scope.F.search.query) {
                if (typeof ($scope.F.search.filterBy) != "undefined" && $scope.F.search.filterBy && typeof ($scope.F.search.filterBy.orderBy) != "undefined" && typeof ($scope.F.search.query) != "undefined" && $scope.F.search.query) {
                    var field = $scope.F.search.filterBy.orderBy;
                    field = field.replace(/\//g, ".");
                    var value = $scope.F.search.query
                    if ($scope.F.search.filterBy.number) {
                        value = parseFloat(value);
                    }
                    if ($scope.$generalFilter && $scope.$generalFilter.indexOf(field) >= 0) {
                        params = addToParams("$or", value, params, $scope.F.search.filterBy.uppercased, $scope.$generalFilter);
                    } else {
                        params = addToParams(field, value, params, $scope.F.search.filterBy.uppercased)
                    }
                }
            } else if ($scope.filter.by && $scope.filter.val()) {
                params = addToParams($scope.filter.by, $scope.filter.val(), params, false)
            }
            return params;
        }
        $scope.restartSelected = function (page, limit) {
            $scope.selected = [];
        }
        $scope.openModalEdit = function (ev, columnConfig, object) {
            $log.debug('importVariablesModal');
            $mdDialog.show({
                locals: {
                    columnConfig: columnConfig,
                    object: object
                },
                controller: 'FieldEditModalController as fieldCtrl',
                templateUrl: 'app/main/employees/dialogs/edit-field-modal.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            }).then(function (result) {
                $log.log(result);
                var flag = true;
                if (columnConfig.regex) {
                    var reg = new RegExp(columnConfig.regex);
                    flag = reg.test(result);
                }
                if (flag) {
                    var thisPath = columnConfig.path.replace(/\./g, '/');
                    $log.log(thisPath);
                    if (columnConfig.rute && object.$id) {
                        var absolutePath = columnConfig.rute + '/' + object.$id + '/' + thisPath;
                        $scope.F.root.child(absolutePath).set(result).then(function () {
                            $timeout(function () {
                                if (["employees", "noEmployees", "employeeBirths","anniversaryEmployees", "realSalaryRecords", "employeesVacationsRecords", "employeeFiles", "personalInfoEmployees", "healthcareRecords", "movements", "credits", "logs"].indexOf(scopeName) >= 0) {
                                    $scope.getThem(true);
                                }
                            }, 2000, false);
                        }).catch(errAlertS);
                    } else {
                        $log.log('No se hizo ninguna edicion');
                    }
                } else {
                    errAlertS('El valor ingresado no es valido');
                }
            }, function () {
                $log.log('Se cancelo edición')
            });
        }

        $scope.getThem = function (applyCatFilter) {
            return new Promise(function (resolve, reject) {
                $log.log('getThem Call')
                $rootScope.loadingProgress = true;
                $rootScope.$evalAsync();
                $timeout(function () {
                    $log.log("init")
                    var catalog = ($scope.filter.allowAll && $scope.filter.allowAll.scopeName) ? $scope.filter.allowAll.scopeName : $scope.filter.scopeName
                    var params = {
                        page: $scope.F.currentPageMongo ? $scope.F.currentPageMongo : 1,
                        size: $scope.F.paginate
                    };
                    params = $scope.getQuerys(params);
                    $log.log(params);
                    $scope.selected = [];
                    $scope.D.api.get('p/' + catalog, params).then(function (res) {
                        $log.log('data get from api finished');
                        var newData = [];
                        for (var r = 0; r < res.data.data.length; r++) {
                            if (res.data.data[r].fid) {
                                var dat = res.data.data[r];
                                dat.$id = dat.fid;
                                newData.push(dat);
                            } else {
                                newData.push(res.data.data[r]);
                            }
                        }
                        $scope[catalog] = newData;
                        $scope.pagination = res.data.pagination;
                        var promises = [];
                        if (applyCatFilter) {
                            $filter('getRelationsOfCat')(newData, catalog, $scope.relatedData, "called from getThem");
                        }
                        return Promise.all(promises);
                    }).then(function (resp) {
                        $log.log('getRelationFInished');
                        if (resp.length > 0) {
                            $scope[scopeName] = resp[0];
                        }
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync(function () { });
                        $timeout(function () {
                            $log.debug('getThem finished');
                            resolve($scope[scopeName]);
                        }, 0, false)
                    }).catch(function (err) {
                        errAlertS(err);
                        reject(err);
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync();
                    });
                }, 0, false);
            });
        }

        /**
         * @ngdoc method
         * @name app.core.controller:FBListsController#reOrder
         * @methodOf app.core.controller:FBListsController
         * @description cambia filtro y hace query si hay valor
         */
        $scope.reOrder = function () {
            // si tiene - se le quita y se asigna a variable
            var order = ($scope.order.indexOf('-') !== -1) ? $scope.order.replace('-', '') : $scope.order;
            // $scope.queryFilter = order;
            if (!$scope.filter) {
                $scope.filter = {
                    scopeName: menuName,
                    alias: 'F.search.query',
                    val: function () {
                        return $scope.F.search.query;
                    }
                };
            }
            $scope.filter.by = order;
            $scope.autocompleteThis();
        }
        /**
         * @ngdoc method
         * @name app.core.controller:FBListsController#filterData
         * @methodOf app.core.controller:FBListsController
         * @description función que filtra el listado cargado recursivamente
         */
        $scope.filterData = function (data, filter, reduce) {
            var filteredData;
            if (angular.isArray(filter)) {
                // filteredData = angular.copy(data);
                filteredData = data.slice();
                for (var f in filter) {
                    filteredData = $scope.filterData(filteredData, filter[f], reduce);
                }
            } else {
                // filteredData = (reduce) ? angular.copy(data) : [];
                filteredData = (reduce) ? data.slice() : [];
                var filterVal = false;
                var filterOperator = false;
                var sscopeName = ($scope.filter.scopeName) ? $scope.filter.scopeName : menuName;
                if (typeof filter == 'string') {
                    var mainFilter;
                    if (filter.indexOf(':') == -1) {
                        mainFilter = filter;
                        filterVal = $scope.F.search.$[filter];
                    } else { // filter have operator
                        var filterA = filter.split(':');
                        var filterO = angular.copy(filter);
                        filter = filterA[0];
                        filterOperator = filterA[1];
                        mainFilter = filterO;
                        filterVal = $scope.F.search.$[filterO];
                    }
                    if ((angular.isUndefined(filterVal) || filterVal === false) && angular.isArray($scope.$$filter)) {
                        var thisFilter = $scope.$$filter.find(function (item) {
                            return item.by === mainFilter;
                        });
                        if (angular.isObject(thisFilter) && thisFilter.val) {
                            filterVal = (typeof thisFilter.val == 'function') ? thisFilter.val() : thisFilter.val;
                        }
                    }
                } else {
                    //AQUI ME QUEDE CUANDO ES UN OBJETO PERO CHECAR QUE NO EXISTA SELECCIONADO UN VALOR
                    if (angular.isUndefined(filter.val)) return data;
                    sscopeName = (filter.scopeName) ? filter.scopeName : menuName;
                    filterVal = $scope.F.search.$[filter.by];
                    if (angular.isUndefined(filterVal) || filterVal === false) {
                        filterVal = (typeof filter.val == 'function') ? filter.val() : filter.val;
                    }
                }
                if (typeof filter == 'object') {
                    if (filter.query) return data;
                    if (filter.applyFilter) {
                        filteredData = eval(filter.applyFilter);
                        $scope.Z[sscopeName] = angular.copy(filteredData);
                        $scope.$evalAsync(function () { });
                        return filteredData;
                    }
                }
                if (filterVal && filterVal !== 'all') {
                    var i = data.length;
                    while (i--) {
                        if (data[i].$id) {
                            var path = (!angular.isObject(filter)) ? (filter) : filter.by;
                            if (typeof ($scope.F.active.$filtersConfig) !== "undefined" && typeof ($scope.F.active.$filtersConfig[filter]) !== "undefined" && typeof ($scope.F.active.$filtersConfig[filter].field) !== "undefined") {
                                path = $scope.F.active.$filtersConfig[filter].field;
                            }
                            var dValue = pathInObjFilter(data[i], path);
                            if (!reduce) { // incrementar el arreglo
                                if (filterVal.constructor == Array) {
                                    if (filterVal.indexOf(dValue) != -1 || filterVal.indexOf("all") != -1) {
                                        filteredData.push(data[i]);
                                    }
                                } else {
                                    if (filterOperator) {
                                        var filterOperatorEval = eval('dValue ' + filterOperator + ' filterVal');
                                        if (filterOperatorEval) {
                                            filteredData.push(data[i]);
                                        }
                                    } else {
                                        if (dValue == filterVal) {
                                            filteredData.push(data[i]);
                                        }
                                    }
                                }
                            } else { // reducir el arreglo
                                if (filterVal.constructor == Array) { // tiene varios valores: [1,2]
                                    if (filterVal.indexOf(dValue) == -1) {
                                        filteredData.splice(i, 1);
                                    }
                                } else { // es un valor simple
                                    if (filterOperator) { // tiene operador el filtro
                                        var filterOperatorEvalR = eval('dValue ' + filterOperator + ' filterVal');
                                        if (filterOperatorEvalR) {

                                        } else { // we only need negative of eval here
                                            filteredData.splice(i, 1);
                                        }
                                    } else { // es un filtro simple
                                        if (dValue !== filterVal) {
                                            filteredData.splice(i, 1);
                                        }
                                    }
                                }
                            }
                        }
                    }
                }

                if (!reduce) {
                    if (sscopeName == menuName) {
                        $scope[sscopeName] = angular.copy(filteredData);
                        $scope.C[sscopeName] = angular.copy(filteredData);
                    }
                    $scope.Z[sscopeName] = filteredData;
                    $scope.$evalAsync(function () { });
                }
            }

            return filteredData;
        }

        /**
         * @ngdoc method
         * @name app.core.controller:FBListsController#filterData
         * @methodOf app.core.controller:FBListsController
         * @description autocomplete de lists
         * @param {string} search search value
         * @param {string} parent parent of list
         * @param {string} child child of list
         */
        $scope.autocompleteList = function (search, parent, child, by) {
            return $q(function (resolve, reject) {
                // si se busca en la lista de payroll se hace del lado del cliente ya que ya estan cargadas todas las payrolls disponibles del cliente
                if (parent == "payrolls") {
                    var p = ($scope.F.permissionToAccessAllPayrolls) ? $rootScope.L.allPayrolls : $rootScope.L.payrolls;
                    resolve($filter("filter")(p, search));
                } else {
                    if (!by) by = 'name';
                    var ref;
                    if (!child) {
                        ref = $scope.F.root.child('lists').child(parent);
                    } else {
                        ref = $scope.F.root.child('lists').child(parent).child(child);
                    }
                    var searchQ = search.toUpperCase();
                    ref.orderByChild(by).startAt(searchQ).endAt(searchQ + '\uf8ff').limitToFirst(10).once('value', function (snap) {
                        var value = snap.val();
                        if (value !== null) {
                            var array = getArrayFromObjectFilter(value, false, true);
                            resolve(array);
                        } else {
                            resolve([]);
                        }
                    }, function (err) {
                        reject(err);
                    });
                }
            });
        }

        $scope.autoSelect = function (searchF, what) {
            $scope.F.search[searchF] = (what) ? what.$id : false;
        }

        var resetPrincipalFilter = function () {
            $scope.Z[principalFilter.scopeName] = []; // se inicia un array vacio
        }

        /**
         * carga un listado
            @param all > para cargar todos, si este es falso o undefined carga el filtro principal
            @param filterThis > para cargar especificamente un filtro
        */
        $scope.loadThem = function (all, filterThis) {
            var promise = $q.defer();
            var from = false;
            var loadCatalogOrListAndSetIt = function (params, scopeName, list) {
                $rootScope.loadingProgress = true;
                var mName = params.catalog;
                var ref = params.ref;
                var query = params.query;
                var val = params.val;
                var type = params.type;
                var filterName = params.filterName;
                if (["employees", "noEmployees", "realSalaryRecords", "employeeBirths", "anniversaryEmployees", "employeesVacationsRecords", "employeeFiles", "personalInfoEmployees", "healthcareRecords", "movements", "credits", "logs"].indexOf(scopeName) >= 0 && ["employees", "anniversaryEmployees", "employeeBirths", "noEmployees", "healthcareRecords", "movements", "credits", "logs"].indexOf(params.catalog) >= 0) {
                    $scope.getThem().then(function (cat) {
                        $filter('getRelationsOfCat')(cat, scopeName, $scope.relatedData, "called from loadThem").then(function (catWithRelationNames) {
                            $scope[scopeName] = catWithRelationNames; // se setea en scope ya que se está filtrando el catalogo principal
                            //$scope.getValidations();
                            $scope.$apply();
                            promise.resolve(catWithRelationNames);
                            $rootScope.loadingProgress = false;
                            $rootScope.$evalAsync(function () { });
                        });
                    })
                } else if (list) {
                    $scope.L.loadList(
                        mName,
                        ref,
                        val,
                        type,
                        filterName
                    ).then(function (catList) {
                        // $scope.Z[scopeName] = angular.copy(catList); // se setea en factory de filtros
                        $scope[scopeName] = catList; // se setea en scope ya que se está filtrando el catalogo principal
                        resetPrincipalFilter();
                        // $scope.getValidations();
                        promise.resolve(catList);
                        filtersDone = true;
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync(function () {

                        });
                    }, function (err) {
                        errAlertS(err);
                        promise.reject(err);
                    });
                } else {
                    var limit = false;
                    var startAt = false;
                    var endAt = false;
                    if (params.limit) {
                        limit = {
                            limit: $scope.F.paginate * $scope.currentPage
                        }
                        if ($scope.order) {
                            if ($scope.order.indexOf('-') == -1) {
                                limit.first = true;
                            }
                        }
                    }
                    if (params.startAt) startAt = params.startAt;
                    if (params.endAt) endAt = params.endAt;
                    if (val == 'all' && !allIsAllowed) {
                        promise.resolve($scope.Z[$scope.F.active.menuName] | $scope[scopeName]);
                        filtersDone = true;
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync(function () {

                        });
                    } else {
                        $scope.C.loadCatalog(
                            mName,
                            ref,
                            query,
                            val,
                            type,
                            filterName,
                            startAt,
                            endAt,
                            limit // limit
                        ).then(function (cat) {
                            $filter('getRelationsOfCat')(cat, scopeName, $scope.relatedData, "called from loadThem 2").then(function (catWithRelationNames) {
                                $scope[scopeName] = catWithRelationNames; // se setea en scope ya que se está filtrando el catalogo principal
                                if ($scope.$$filter) {
                                    $scope.Z[scopeName] = $scope.filterData(catWithRelationNames, $scope.$$filter, 1);
                                }
                                if (!$scope.$$filter && principalFilter.scopeName == scopeName) {
                                    $scope.Z[scopeName] = catWithRelationNames;
                                }
                                if (principalFilter.scopeName !== scopeName) { // si no es el catalogo principal, se resetean los resultados
                                    $scope.Z[principalFilter.scopeName] = [];
                                }
                                $scope.getValidations();
                                promise.resolve(catWithRelationNames);
                                $rootScope.loadingProgress = false;
                                $rootScope.$evalAsync(function () {

                                });
                            });
                        }, function (err) {
                            errAlertS(err);
                            promise.reject(err);
                        });
                    }
                }
            }
            var filter = false;
            var ref = false;
            var cParams = {};
            var scopeName = false;
            var fVal = false;
            var query = false;
            var type = 'array';
            if (all || !$scope.filter) { // all query or !filter
                filter = $scope.filter;
                // var filters = $scope.filters;
                ref = $scope.R.constructDinamicRef(menuName, filter, $scope);
                cParams = {
                    catalog: menuName,
                    ref: ref,
                    // query: 'created/atTime',
                    // val: false,
                    type: 'array',
                    filterName: false,
                    limit: false
                };
                from = 5;
                loadCatalogOrListAndSetIt(cParams, menuName);
            } else if (!filterThis) { // filter query
                filter = $scope.filter;
                if (filter.hasOwnProperty('by') && filter.hasOwnProperty('name')) {
                    scopeName = ($scope.filters) ? filter.scopeName : menuName;
                    var mName = (filter.scopeName) ? filter.scopeName : menuName;
                    ref = false
                    query = false;
                    type = (filter.type) ? filter.type : 'array';
                    fVal = (typeof filter.val == 'function') ? filter.val() : filter.val;

                    if (filter.list) {
                        ref = 'lists/' + mName + '/' + filter.by;
                        cParams = {
                            catalog: mName,
                            ref: ref,
                            val: fVal,
                            type: type,
                            filterName: filter.name
                        };
                        from = 4;
                        loadCatalogOrListAndSetIt(cParams, scopeName, 1);
                    } else {
                        ref = $scope.R.constructDinamicRef(scopeName, filter, $scope);
                        if (filter.by) query = filter.by;
                        cParams = {
                            catalog: mName,
                            ref: ref,
                            query: query,
                            val: fVal,
                            type: type,
                            filterName: filter.name,
                            limit: false
                        };
                        if (filter.startAt) cParams.startAt = filter.startAt;
                        if (filter.endAt) cParams.endAt = filter.endAt;
                        from = 3;
                        loadCatalogOrListAndSetIt(cParams, scopeName);
                    }
                }
            } else {
                // filterThis
                filter = filterThis;
                if (filterThis.hasOwnProperty('by') && filterThis.hasOwnProperty('name')) {
                    scopeName = filter.scopeName;
                    ref = false;
                    query = false;
                    type = (filter.type) ? filter.type : 'array';
                    fVal = (typeof filter.val == 'function') ? filter.val() : filter.val;
                    if (filter.by && filter.query) query = filter.by;
                    if (filter.ref) query = filter.by;
                    if (filter.list) {
                        ref = 'lists/' + filter.scopeName + '/' + filter.by;
                        cParams = {
                            catalog: menuName,
                            ref: ref,
                            val: fVal,
                            type: type,
                            filterName: filter.name
                        };
                        from = 2;
                        loadCatalogOrListAndSetIt(cParams, scopeName, 1);
                    } else {
                        ref = $scope.R.constructDinamicRef(scopeName, filterThis, $scope);
                        cParams = {
                            catalog: menuName,
                            ref: ref,
                            query: query,
                            val: fVal,
                            type: type,
                            filterName: filter.name,
                            limit: false
                        };
                        if (filter.startAt) cParams.startAt = filter.startAt;
                        if (filter.endAt) cParams.endAt = filter.endAt;
                        from = 1;
                        loadCatalogOrListAndSetIt(cParams, scopeName);
                    }
                }
            }
            $scope.refToExport = ref;
            return promise.promise;
        }

        /**
         * @ngdoc method
         * @name app.core.controller:FBListsController#delete
         * @methodOf app.core.controller:FBListsController
         * @description invoca safeDelete con el modal de validación y confirmación
         */
        $scope.delete = function (e, promise) {
            if (promise) return $scope.C.deleteSafe(e, menuParent, objName, $scope.selected, $scope);
            $rootScope.loadingProgress = true;
            $scope.C.deleteSafe(e, menuParent, objName, $scope.selected, $scope).then(function () {
                $scope.selected = [];
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync(function () {
                    $log.debug('delete finished');
                });
                if (["employees", "noEmployees", "employeeBirths", "anniversaryEmployees", "realSalaryRecords", "healthcareRecords", "employeesVacationsRecords", "movements", "credits", "logs"].indexOf(scopeName) >= 0) {
                    $scope.getThem(true);
                }
            }).catch(function (err) {
                errAlertS(err);
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
            });
        }
        $scope.clearSelected = function () {
            $scope.selected = [];
        }

        $scope.exportDataToExcel = function (allData, exportId, currentPage, paginate) {
            CatalogsF.exportDataToExcel(allData, exportId, $scope.selected, $scope.refToExport, currentPage, paginate);
        }
        $scope.exportDataToExcelByQuery = function (allData, exportId, querys, totalResults) {
            if (typeof ($scope.refToExport) == "undefined") {
                $scope.refToExport = $scope.R.constructDinamicRef(scopeName, false, $scope);
            }
            CatalogsF.exportDataToExcelByQuery(allData, exportId, $scope.selected, $scope.refToExport, querys, totalResults);
        }
        /**
         * @ngdoc method
         * @name app.core.controller:FBListsController#getExportAll
         * @methodOf app.core.controller:FBListsController
         * @description función que exporta todo el módulo (no necesita estár cargado)
         */
        $scope.getExportAll = function () {
            CatalogsF.exportAllDataToExcel();
        }

        $scope.listWatchers.currentPage = $scope.$watch('currentPage', function (cp) {
            if (cp) {
                $scope.F.setCurrentPage(cp);
            }
        });

        var watchFilter = function (filter) {
            $scope.listWatchers[filter.name] = $scope.$watch('C.' + filter.name, function (catalog) {
                if (initiated) {
                    if (angular.isDefined(catalog)) {
                        //$scope.selected = [];
                        $filter('getRelationsOfCat')(catalog, menuName, $scope.relatedData, "called from watchFilter").then(function (cat) {
                            // TODO: cambiar esto por un filtro que filtre todo tanto el filtro principal como los filtros secundarios, mejorar la búsqueda, no es clara
                            // TODO: parche horrible, cambiar por algo funcional
                            if (['mdsRecords', 'dismissesRecords', 'dismissesUnconfirmedRecords', 'idseRecords', 'enroles', 'variables', 'enroleAccounts', 'revisions', "personalInfoEmployees", "employeeFiles", "employeesVacationsRecords", 'healthcareRecords', 'realSalaryRecords', 'noEmployees','anniversaryEmployees', 'employeeBirths'].indexOf(menuName) !== -1) {
                                // $scope.filterMultipleData(catalog, $scope.$filters, $scope.scopeName);
                                if ($scope.$$filter) {
                                    $scope.filterData(cat, $scope.$$filter);
                                } else {
                                    $scope.filterData(cat, filter);
                                }
                            } else {
                                $scope.filterData(cat, filter);
                            }
                            if ($scope.$filters) {
                                var nowLength = catalog.length;
                                var beforeLength = catalog.length;
                                $scope.filtersChange(nowLength > beforeLength);
                            }
                            // if($scope.$filters && !$scope.R.filtersBy[menuName]){
                            //     $scope.filterMultipleData(catalog, $scope.$filters, $scope.scopeName);
                            //     $scope.filterData(catalog, $scope.$$filter);
                            // } else {
                            //     if($scope.F.advancedSearchMode){
                            //         $scope.filterData(catalog, $scope.$$filter);
                            //     } else {
                            //         $scope.filterMultipleData(catalog, $scope.$filters, $scope.scopeName);
                            //     }
                            // }
                            $scope.getValidations();
                        });
                    }
                }
            }, true);
        }

        if ($scope.$$filter) {
            if ($scope.filters) { // se observa el último filtro
                watchFilter($scope.lastFilter);
            } else { // se observa el unico filtro
                watchFilter($scope.filter);
            }
        } else {
            if ($scope.filters) {
                // se observa el filtro principal
                watchFilter(principalFilter);
            } else { // se observa el unico filtro
                watchFilter($scope.filter);
            }
        }

        $scope.filtersChange = function (keepSelected) {
            var scopeName = menuName;
            if ($scope.filter.scopeName) {
                scopeName = $scope.filter.scopeName;
                if ($scope.filter.allowAll) {
                    var evalFilter = eval('$scope.F.search.$' + $scope.filter.allowAll.inFilter);
                    if (evalFilter == 'all') {
                        scopeName = $scope.filter.allowAll.scopeName
                    }
                }
            }
            if ($scope.filter.scopeName !== menuName && $scope.$$filter) {
                scopeName = menuName;
            }

            if (angular.isDefined($scope.filters[0]) && !$scope.$$filter) {
                if ($scope.filters[0].scopeName == menuName) {
                    scopeName = $scope.filters[0].scopeName
                }
            }

            if (angular.isDefined($scope.filters[1]) && !$scope.$$filter) {
                if ($scope.filters[1].scopeName == menuName && !$scope.filters[1].justFilter) {
                    scopeName = $scope.filters[1].scopeName;
                }
            }

            if ($scope[scopeName]) { // filtra lo que ya se tenia filtrado de FB
                // if (!keepSelected) $scope.selected = [];
                // if($scope.$$filter) $scope.filterData($scope[scopeName], $scope.$$filter);
                var initL = ($scope.$filters) ? angular.copy($scope.$filters.length) : 0;
                for (var fff in $scope.filters) {
                    if ($scope.filters[fff].justFilter) {
                        if (!objectInArrayFilter($scope.filters, $scope.filters[fff])) $scope.$filters[parseInt(fff) + initL - 1] = $scope.filters[fff];
                    }
                }

                var filterThis = angular.copy($scope[scopeName]);
                var withName = angular.copy(scopeName);
                if (angular.isDefined($scope.$filtersUse)) {
                    withName = angular.copy($scope.$filtersUse);
                }

                $scope.filterMultipleData(filterThis, $scope.$filters, withName);
                $scope.getValidations();
                // }
            }

        }

        if ($scope.$filters) { // si hay filtros se observa el objeto F.search.$ y cada vez que cambia filtra todo
            console.log('watcher initiated');
            $scope.listWatchers.$filters = $scope.$watch('F.search.$', function (data) {
                console.log(data);
                if (initiated) {
                    console.log(data);
                    $scope.filtersChange()
                }
            }, true);
        }
        $scope.autocompleteMongo = function (search, catalog, fields, extraQuerys) {
            return $q(function (resolve, reject) {
                $scope.D.api.autocompleteMongo(search, catalog, fields, extraQuerys).then(function (items) {
                    resolve(items);
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync(function () {
                        $log.debug('getThem finished');
                    });
                }).catch(function (err) {
                    errAlertS(err);
                    reject(err);
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                });
            });
        }
        $scope.listWatchers.advancedSearchMode = $scope.$watch('F.advancedSearchMode', function (advancedMode) {
            if (angular.isDefined(advancedMode) && angular.isDefined($scope.F.searchText) && angular.isDefined($scope.F.search)) {
                if (advancedMode) resetSearch();
                else {
                    resetSearch(1)
                }
            }
        })
        startAfterInitFilter($scope, $scope.listWatchers, initiated, init);
    }

}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .controller('FB2ListsController', FB2ListsController)

    /** @ngInject */
    function FB2ListsController(
        $rootScope,
        $scope,
        $log,
        $q,
        menuNameFilter,
        translateFilter,
        pathInObjFilter,
        successAlertS,
        errAlertS,
        $filter, // no quitar se requiere para eval fn
        getArrayFromObjectFilter
    ) {
        var initiated = false;
        var menuName = $scope.F.active.menuName;
        var menuParent = $scope.F.active.menuParent;
        var objName = $scope.F.active.menuObjName;
        var statesObj = $scope.R.states;
        var menuState = statesObj.fb[menuName];
        var filtersDone = false;

        // $scope.vm = $scope;
        // $scope.formName = objName + 'Form';
        $scope.C[menuName] = [];
        $scope[menuName] = [];
        $scope.selected = [];
        $scope.currentPage = $scope.F.currentPage();
        $scope.filter = $scope.F.active.filter;
        $scope.$filter = $scope.F.active.$filter;
        $scope.$$filter = $scope.F.active.$$filter;
        $scope.filters = $scope.F.active.filters;
        $scope.$filters = $scope.F.active.$filters;
        $scope.$filtersUse = $scope.F.active.$filtersUse;
        $scope.listWatchers = {};

        var init = function () {
            initiated = true;
            $scope.loadDataNeeded($scope.F.active.menuName); // in indexCtrl

            // setear F.search.$param si viene en los params y no esta seteado ya si hay un filtro
            if ($scope.filter) {
                $scope.R.setStateFilter($scope.filter);
            }

            // setear F.search.$param por cada uno de los filtros
            if ($scope.filters) {
                for (var f in $scope.filters) {
                    $scope.R.setStateFilter($scope.filters[f]);
                }
            }
            // checkAndLoadFiltersAndWatchers();
            if (menuName == 'employees') {
                $scope.F.root.child('catalogs').child(menuName).child('counter').on('value', function (s) {
                    if (s.val()) {
                        $scope.totalCounter = s.val();
                    } else {
                        $scope.totalCounter = 0;
                    }
                });
            }


            if (!$scope.filter) {
                $scope.loadThem(1).then(function () {
                    checkAndLoadFiltersAndWatchers();
                    $scope.getValidations();
                });
            } else {
                if ($scope.filter.alias) { // es un filtro que esta esperando un valor de un select
                    checkAndLoadFiltersAndWatchers();
                    $scope.getValidations();
                } else { // es un filtro que debe aplicarse al 
                    // $scope.getValidations();
                    $scope.loadThem(0, $scope.filter).then(function () {
                        checkAndLoadFiltersAndWatchers();
                        var scopeName = ($scope.filter.scopeName) ? $scope.filter.scopeName : menuName;
                        if ($scope.$$filter) { // hidden filter to be applied
                            // $scope.Z[scopeName] = $scope.filterData($scope[$scope.filter.scopeName], $scope.$$filter);
                            // $scope.getValidations();
                        } else {
                            $scope.Z[scopeName] = $scope[scopeName];
                            $log.debug('loading in Z', $scope[scopeName]);
                            $scope.getValidations();
                        }
                    });
                }
            }
        }

        var resetSubFilters = function () {
            if ($scope.filters) {
                for (var f in $scope.filters) {
                    $scope.F.search['$' + $scope.filters[f].by] = false;
                }
            }
        }

        var checkAndLoadFiltersAndWatchers = function () {
            if (!$scope.R.dinamicRefs[menuName]) alert('Falta configurar R.dinamicRefs.' + menuName + ' !!!');
            if (!menuState) alert('Falta configurar R.states.fb."' + menuName + ' !!!');
            if ($scope.filter) {
                if ($scope.filter.alias) {
                    $log.debug('$watcher from filter loaded on ' + $scope.filter.alias);
                    $scope.listWatchers.filter = $scope.$watch($scope.filter.alias, function (val) {
                        $scope[menuName] = [];
                        resetSubFilters(); // @todo:backlog poner esto con validacion
                        if (val) {
                            $scope.R.setStateParams(val);
                            if (val == 'all') {
                                if ($scope.filter.childRef) {
                                    $scope[menuName] = []; // no se puede por ahora buscar todos en listados con filtros en hijos
                                } else { // si no hay filtro configurado carga todos
                                    $scope.loadThem(1);
                                }
                            } else {
                                if ($scope.filters) {
                                    $scope.loadThem(0, $scope.filter).then(function () {
                                        if (filtersDone) {
                                            resetSubFilters();
                                        }
                                    });
                                } else {
                                    $scope.loadThem(0).then(function () {
                                        if (filtersDone) {
                                            resetSubFilters();
                                        }
                                    });
                                }
                            }
                        } else {
                            if ($scope.filters) {
                                $scope.Z[menuName] = [];
                                $scope.getValidations();
                            }
                        }
                    });
                }
            }

            if ($scope.filters) {
                for (var f in $scope.filters) {
                    var filterP = $scope.filters[f];
                    if (filterP.alias) {
                        $log.debug('$watcher from filters loaded on ' + filterP.alias);
                        $scope.listWatchers['filters-' + filterP.by] = $scope.$watch(filterP.alias, function (val) {
                            $scope[filterP.scopeName] = [];
                            if (val) {
                                $scope.R.setStateParams(val, filterP);
                                if (val == 'all') {
                                    if (filterP.childRef) {
                                        $scope[menuName] = []; // no se puede por ahora buscar todos en listados con filtros en hijos
                                    } else {
                                        if ($scope.filter.allowAll) {
                                            if (filterP.scopeName == $scope.filter.allowAll.scopeName) $scope.loadThem(0, $scope.filter.allowAll);
                                        } else {
                                            $scope.loadThem(0, filterP);
                                        }
                                    }
                                } else {
                                    $scope.loadThem(0, filterP);
                                }
                            }
                        });
                    }
                }
            }
        }

        $scope.getValidations = function () {
            var sFnString;
            var searchVal;
            if ($scope.F.active.filters) {
                sFnString = '$scope.' + $scope.filter.alias;
                searchVal = eval(sFnString);
                $scope.validations = [{
                    valid: (angular.isUndefined(searchVal) || $scope[menuName].length),
                    msg: 'No hay registros de ' + translateFilter(objName + '.SINGULAR') + ' aún.'
                }];
                for (var f in $scope.F.active.filters) {
                    var sFnStringX = '$scope.' + $scope.F.active.filters[f].alias;
                    var searchValX = eval(sFnStringX);
                    var cName = objName;
                    if (f == $scope.F.active.filters.length - 1) {
                        var ff = ($scope.F.active.filters.length == 1) ? 0 : f - 1;
                        if (!ff) {
                            cName = angular.copy($scope.filter.scopeName);
                            cName = cName.substring(cName.length, -1);
                        } else {
                            if ($scope.F.active.filters[ff]) {
                                cName = angular.copy($scope.F.active.filters[ff].scopeName);
                                cName = cName.substring(cName.length, -1);
                            }
                        }
                    }
                    $scope.validations.push({
                        valid: (angular.isDefined(searchValX) && !$scope[menuName].length),
                        msg: 'Seleccione ' +
                            translateFilter($scope.F.active.filters[f].by + '.SINGULAR') +
                            ' para filtrar ' +
                            translateFilter(objName + '.SINGULAR') + '.'
                    });
                }
            } else {
                if ($scope.filter && $scope.filter.alias) {
                    sFnString = '$scope.' + $scope.filter.alias;
                    searchVal = eval(sFnString);
                    // valid -> que tiene que salir para que NO SALGA EL msg
                    // msg -> msg bajo excepción que que valid sea false
                    $scope.validations = [{
                        valid: (angular.isUndefined(searchVal) || $scope[menuName].length),
                        msg: 'No hay registros de ' +
                            translateFilter(objName + '.SINGULAR') +
                            ' aún.'
                    }, {
                        valid: (angular.isDefined(searchVal) && !$scope[menuName].length),
                        msg: 'Seleccione ' +
                            translateFilter($scope.filter.by + '.SINGULAR') +
                            ' para filtrar ' +
                            translateFilter(objName + '.SINGULAR') + '.'
                    }];
                } else {
                    if ($scope[menuName]) {
                        $scope.validations = [{
                            valid: ($scope[menuName].length),
                            msg: 'No hay ' + menuNameFilter(menuName) + ' aún'
                        }];
                    }
                }
            }

            $log.debug($scope.validations, 'validations');
        }

        $scope.filterMultipleData = function (data, filters, scopeName) {
            var filteredData = angular.copy(data);
            if (!scopeName) scopeName = menuName;
            for (var fi = 0; fi < filters.length; fi++) {
                filteredData = $scope.filterData(filteredData, filters[fi], 1);
                if (fi == filters.length - 1) {
                    $scope.$evalAsync(function () {
                        $scope.Z[scopeName] = filteredData;
                        $log.debug('filtering multiple data', {
                            filters: filters,
                            data: data,
                            scopeName: scopeName,
                            filteredData: filteredData
                        });
                    });
                }
            }
            return filteredData;
        }

        $scope.autocompleteThis = function () {
            var filter = {};
            if ($scope.F.search.query && $scope.F.search.filterBy) {
                if ($scope.filters) {
                    for (var fi in $scope.filters) {
                        var filterF = $scope.filters[fi];
                        if (filterF.principal) {
                            filter = angular.copy(filterF);
                        }
                    }
                } else {
                    filter = angular.copy($scope.filter);
                }
                filter.startAt = ($scope.F.search.filterBy.uppercased) ? $scope.F.search.query.toUpperCase() : $scope.F.search.query;
                filter.startAt = ($scope.F.search.filterBy.uppercased) ? $scope.F.search.query.toUpperCase() : $scope.F.search.query;
                filter.endAt = ($scope.F.search.filterBy.uppercased) ? $scope.F.search.query.toUpperCase() : $scope.F.search.query;
                filter.endAt += '\uf8ff';
                filter.by = $scope.F.search.filterBy.orderBy;
                $scope.loadThem(0, filter);
            }
        }

        /*
            @description cambia filtro y hace query si hay valor
        */
        $scope.reOrder = function () {
            // si tiene - se le quita y se asigna a variable
            var order = ($scope.order.indexOf('-') !== -1) ? $scope.order.replace('-', '') : $scope.order;
            // $scope.queryFilter = order;
            if (!$scope.filter) {
                $scope.filter = {
                    scopeName: menuName,
                    alias: 'F.search.query',
                    val: function () {
                        return $scope.F.search.query;
                    }
                };
            }
            $scope.filter.by = order;
            $scope.autocompleteThis();
        }

        $scope.loadMore = function () {

        }

        $scope.filterData = function (data, filter, reduce) {
            if (angular.isArray(filter)) {
                var filteredData = angular.copy(data);
                for (var f in filter) {
                    filteredData = $scope.filterData(filteredData, filter[f], reduce);
                }
            } else {
                var filteredData = (reduce) ? angular.copy(data) : [];
                var filterVal = false;
                var filterOperator = false;
                var scopeName = ($scope.filter.scopeName) ? $scope.filter.scopeName : menuName;

                if (typeof filter == 'string') {
                    if (filter.indexOf(':') == -1) {
                        filterVal = $scope.F.search.$[filter];
                    } else { // filter have operator
                        var filterA = filter.split(':');
                        var filterO = angular.copy(filter);
                        filter = filterA[0];
                        filterOperator = filterA[1];
                        filterVal = $scope.F.search.$[filterO];
                    }
                } else {
                    scopeName = (filter.scopeName) ? filter.scopeName : menuName;
                    filterVal = (typeof filter.val == 'function') ? filter.val() : filter.val;
                }

                if (typeof filter == 'object') {
                    if (filter.applyFilter) {
                        filteredData = eval(filter.applyFilter);
                        $scope.Z[scopeName] = angular.copy(filteredData);
                        $scope.$evalAsync(function () {
                            $log.debug('filtering data APPLYING', {
                                filter: filter,
                                data: data,
                                filterVal: filterVal,
                                scopeName: scopeName,
                                filteredData: $scope.Z[scopeName],
                                apply: filter.applyFilter
                            });
                        });
                        return filteredData;
                    }
                }
                if (filterVal && filterVal !== 'all') {
                    var i = data.length;
                    while (i--) {
                        if (data[i].$id) {
                            var dValue = (typeof filter == 'string') ?
                                pathInObjFilter(data[i], filter) :
                                pathInObjFilter(data[i], filter.by);
                            if (!reduce) { // incrementar el arreglo
                                if (filterVal.constructor == Array) {
                                    if (filterVal.indexOf(dValue) != -1) {
                                        filteredData.push(data[i]);
                                    }
                                } else {
                                    if (filterOperator) {
                                        var filterOperatorEval = eval('dValue ' + filterOperator + ' filterVal');
                                        if (filterOperatorEval) {
                                            filteredData.push(data[i]);
                                        }
                                    } else {
                                        if (dValue == filterVal) {
                                            filteredData.push(data[i]);
                                        }
                                    }
                                }
                            } else { // reducir el arreglo
                                if (filterVal.constructor == Array) { // tiene varios valores: [1,2]
                                    if (filterVal.indexOf(dValue) == -1) {
                                        filteredData.splice(i, 1);
                                    }
                                } else { // es un valor simple
                                    if (filterOperator) { // tiene operador el filtro
                                        var filterOperatorEvalR = eval('dValue ' + filterOperator + ' filterVal');
                                        if (filterOperatorEvalR) { } else { // we only need negative of eval here
                                            filteredData.splice(i, 1);
                                        }
                                    } else { // es un filtro simple
                                        if (dValue !== filterVal) {
                                            filteredData.splice(i, 1);
                                        }
                                    }
                                }
                            }
                        }
                    }
                }

                if (!reduce) {
                    if (scopeName == menuName) {
                        $scope[scopeName] = angular.copy(filteredData);
                        $scope.C[scopeName] = angular.copy(filteredData);
                    }
                    $scope.Z[scopeName] = filteredData;
                    $scope.$evalAsync(function () {
                        $log.debug('filtering data', {
                            filter: filter,
                            data: data,
                            filterVal: filterVal,
                            scopeName: scopeName,
                            filteredData: filteredData
                        });
                    });
                }
            }

            return filteredData;
        }

        /*
            @description autocomplete de lists
            @param search > search value 
            @param parent > parent of list
            @param child > child of list
        */
        $scope.autocompleteList = function (search, parent, child, by) {
            return $q(function (resolve, reject) {
                if (!by) by = 'name';
                var ref;
                if (!child) {
                    ref = $scope.F.root.child('lists').child(parent);
                } else {
                    ref = $scope.F.root.child('lists').child(parent).child(child);
                }
                var searchQ = search.toUpperCase();
                ref.orderByChild(by).startAt(searchQ).endAt(searchQ + '\uf8ff').limitToFirst(5).once('value', function (snap) {
                    var value = snap.val();
                    if (value !== null) {
                        var array = getArrayFromObjectFilter(value, false, true);
                        resolve(array);
                    } else {
                        resolve([]);
                    }
                }, function (err) {
                    reject(err);
                });
            });
        }

        $scope.autoSelect = function (searchF, what) {
            $scope.F.search[searchF] = (what) ? what.$id : false;
        }

        /*
            @param all > para cargar todos, si este es falso o undefined carga el filtro principal
            @param filterThis > para cargar especificamente un filtro
        */
        $scope.loadThem = function (all, filterThis) {
            $rootScope.loadingProgress = true;
            var promise = $q.defer();
            var from = false;

            var loadCatalogOrListAndSetIt = function (params, scopeName, list) {
                var mName = params.catalog;
                var ref = params.ref;
                var query = params.query;
                var val = params.val;
                var type = params.type;
                var filterName = params.filterName;
                if (list) {
                    $scope.L.loadList(
                        mName,
                        ref,
                        val,
                        type,
                        filterName
                    ).then(function (catList) {
                        $log.debug('setting list in $scope.' + scopeName, {
                            params: params,
                            from: from,
                            list: catList
                        });
                        // $scope.Z[scopeName] = angular.copy(catList); // se setea en factory de filtros
                        $scope[scopeName] = catList; // se setea en scope ya que se está filtrando el catalogo principal
                        // $scope.getValidations();
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync();
                        filtersDone = true;
                        promise.resolve(catList);
                    }, function (err) {
                        errAlertS(err);
                        promise.reject(err);
                    });
                } else {
                    var limit = false;
                    var startAt = false;
                    var endAt = false;
                    if (params.limit) {
                        limit = {
                            limit: $scope.F.paginate * $scope.currentPage
                        }
                        if ($scope.order) {
                            if ($scope.order.indexOf('-') == -1) {
                                limit.first = true;
                            }
                        }
                    }
                    if (params.startAt) startAt = params.startAt;
                    if (params.endAt) endAt = params.endAt;
                    $scope.C.loadCatalog(
                        mName,
                        ref,
                        query,
                        val,
                        type,
                        filterName,
                        startAt,
                        endAt,
                        limit // limit
                    ).then(function (cat) {
                        // $scope.Z[scopeName] = angular.copy(cat); // se setea en factory de filtros
                        $scope[scopeName] = cat; // se setea en scope ya que se está filtrando el catalogo principal
                        // if ($scope.$$filter) $scope.filterData(cat, $scope.$$filter);
                        if (!$scope.$$filter) {
                            $scope.Z[scopeName] = cat;
                        }
                        $scope.getValidations();
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync();
                        $log.debug(
                            'Setted catalog in $scope.' + scopeName, {
                            params: params,
                            from: from,
                            sCat: cat,
                            zCat: $scope.Z[scopeName],
                            scopeName: scopeName,
                            ref: ref,
                            startAt: startAt,
                            endAt: endAt,
                            limit: limit
                        }
                        );
                        promise.resolve(cat);
                    }, function (err) {
                        errAlertS(err);
                        promise.reject(err);
                    });
                }
            }
            var filter = false;
            var ref = false;
            var cParams = {};
            var scopeName = false;
            var fVal = false;
            var query = false;
            var type = 'array';
            if (all || !$scope.filter) { // all query or !filter
                $log.debug('loading dinamic catalogs all');
                filter = $scope.filter;
                // var filters = $scope.filters;
                ref = $scope.R.constructDinamicRef(menuName, filter, $scope);
                cParams = {
                    catalog: menuName,
                    ref: ref,
                    query: 'created/atTime',
                    val: false,
                    type: 'array',
                    filterName: false,
                    limit: false
                };
                from = 5
                loadCatalogOrListAndSetIt(cParams, menuName);
            } else if (!filterThis) { // filter query
                filter = $scope.filter;
                if (filter.hasOwnProperty('by') && filter.hasOwnProperty('name')) {
                    scopeName = ($scope.filters) ? filter.scopeName : menuName;
                    var mName = (filter.scopeName) ? filter.scopeName : menuName;
                    ref = false
                    query = false;
                    type = (filter.type) ? filter.type : 'array';
                    fVal = (typeof filter.val == 'function') ? filter.val() : filter.val;

                    if (filter.list) {
                        ref = 'lists/' + mName + '/' + filter.by;
                        $log.debug('loading dinamic list', filter);
                        cParams = {
                            catalog: mName,
                            ref: ref,
                            val: fVal,
                            type: type,
                            filterName: filter.name
                        };
                        from = 4;
                        loadCatalogOrListAndSetIt(cParams, scopeName, 1);
                    } else {
                        ref = $scope.R.constructDinamicRef(scopeName, filter, $scope);
                        $log.debug('loading dinamic catalog', filter);
                        if (filter.by) query = filter.by;
                        cParams = {
                            catalog: mName,
                            ref: ref,
                            query: query,
                            val: fVal,
                            type: type,
                            filterName: filter.name,
                            limit: false
                        };
                        if (filter.startAt) cParams.startAt = filter.startAt;
                        if (filter.endAt) cParams.endAt = filter.endAt;
                        from = 3;
                        loadCatalogOrListAndSetIt(cParams, scopeName);
                    }
                }
            } else {
                // filterThis
                filter = filterThis;
                if (filterThis.hasOwnProperty('by') && filterThis.hasOwnProperty('name')) {
                    scopeName = filter.scopeName;
                    ref = false;
                    query = false;
                    type = (filter.type) ? filter.type : 'array';
                    fVal = (typeof filter.val == 'function') ? filter.val() : filter.val;
                    if (filter.by && filter.query) query = filter.by;
                    if (filter.ref) query = filter.by;

                    if (filter.list) {
                        ref = 'lists/' + filter.scopeName + '/' + filter.by;
                        $log.debug('loading dinamic list from filterThis ', filter);
                        cParams = {
                            catalog: menuName,
                            ref: ref,
                            val: fVal,
                            type: type,
                            filterName: filter.name
                        };
                        from = 2;
                        loadCatalogOrListAndSetIt(cParams, scopeName, 1);
                    } else {
                        ref = $scope.R.constructDinamicRef(scopeName, filterThis, $scope);
                        $log.debug('loading dinamic catalog from filterThis ', filter);
                        cParams = {
                            catalog: menuName,
                            ref: ref,
                            query: query,
                            val: fVal,
                            type: type,
                            filterName: filter.name,
                            limit: false
                        };
                        if (filter.startAt) cParams.startAt = filter.startAt;
                        if (filter.endAt) cParams.endAt = filter.endAt;
                        from = 1;
                        loadCatalogOrListAndSetIt(cParams, scopeName);
                    }
                }
            }
            return promise.promise;
        }

        /*
            @description invoca safeDelete con el modal de validación y confirmación
        */
        $scope.delete = function (e, promise) {
            $log.debug(e, menuParent, objName, $scope.selected, $scope);
            if (promise) return $scope.C.deleteSafe(e, menuParent, objName, $scope.selected, $scope);
            $scope.C.deleteSafe(e, menuParent, objName, $scope.selected, $scope).then(function () {
                $scope.selected = [];
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
            }, function (err) {
                errAlertS(err);
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync();
            });
        }

        $scope.listWatchers.currentPage = $scope.$watch('currentPage', function (cp) {
            if (cp) {
                $scope.F.setCurrentPage(cp);
                $log.debug('setting currentPage', cp, $scope.currentPage);
            }
        });

        if ($scope.$$filter) {
            if ($scope.filters) { // se observa el último filtro
                $scope.listWatchers.$$filter = $scope.$watch('C.' + $scope.filters[$scope.filters.length - 1].name, function (catalog) {
                    if (initiated) {
                        $log.debug(catalog, "C." + $scope.filters[$scope.filters.length - 1].name + ' changed');
                        if (catalog) {
                            $scope.selected = [];
                            $scope.filterData(catalog, $scope.$$filter);
                            $scope.getValidations();
                        }
                    }
                }, true);
            } else { // se observa el unico filtro
                $scope.listWatchers.$$filter = $scope.$watch('C.' + $scope.filter.name, function (catalog) {
                    if (initiated) {
                        $log.debug(catalog, "C." + $scope.filter.name + ' changed');
                        if (catalog) {
                            $scope.selected = [];
                            $scope.filterData(catalog, $scope.$$filter);
                            $scope.getValidations();
                        }
                    }
                }, true);
            }
        } else {
            if ($scope.filters) { // se observa el último filtro
                $scope.listWatchers.main = $scope.$watch('C.' + $scope.filters[$scope.filters.length - 1].name, function (catalog) {
                    if (initiated) {
                        $log.debug(catalog, "C." + $scope.filters[$scope.filters.length - 1].name + ' changed 2');
                        if (catalog) {
                            $scope.selected = [];
                            $scope.Z[$scope.filters[$scope.filters.length - 1].scopeName] = catalog;
                            $scope.getValidations();
                        }
                    }
                }, true);
            } else { // se observa el unico filtro
                $scope.listWatchers.main = $scope.$watch('C.' + $scope.filter.name, function (catalog) {
                    if (initiated) {
                        $log.debug(catalog, "C." + $scope.filter.name + ' changed 2');
                        if (catalog) {
                            $scope.selected = [];
                            $scope.Z[$scope.filter.scopeName] = catalog;
                            $scope.getValidations();
                        }
                    }
                }, true);
            }
        }

        if ($scope.$filters) {
            $scope.listWatchers.$filters = $scope.$watch('F.search.$', function () {
                if (initiated) {
                    var scopeName = menuName;
                    if ($scope.filter.scopeName) {
                        scopeName = $scope.filter.scopeName;
                        if ($scope.filter.allowAll) {
                            var evalFilter = eval('$scope.F.search.$' + $scope.filter.allowAll.inFilter);
                            if (evalFilter == 'all') {
                                scopeName = $scope.filter.allowAll.scopeName
                            }
                        }
                    }
                    if ($scope.filter.scopeName !== menuName && $scope.$$filter) {
                        scopeName = menuName;
                    }
                    if ($scope[scopeName]) { // filtra lo que ya se tenia filtrado de FB
                        if ($scope[scopeName].length) {
                            $scope.selected = [];
                            // if($scope.$$filter) $scope.filterData($scope[scopeName], $scope.$$filter);
                            $scope.filterMultipleData($scope[scopeName], $scope.$filters, scopeName);
                            $scope.getValidations();
                        }
                    }
                }
            }, true);
        }

        $rootScope.$on('allLoaded', function (allLoaded) {
            if (allLoaded && !initiated) {
                init();
            }
        });

        if ($scope.F.profile && !initiated) {
            init();
        }

        $scope.listWatchers.stopListener = $rootScope.$on('stopListWatchers', function () {
            for (var f in $scope.listWatchers) {
                //$log.debug('stopping $watcher', f);
                $scope.listWatchers[f]();
            }
        });

        $scope.listWatchers.finalListener = $scope.$on("$destroy", function () {
            for (var f in $scope.listWatchers) {
                //$log.debug('stopping $watcher', f);
                $scope.listWatchers[f]();
            }
        });
    }

}());
/* eslint-disable angular/no-private-call */
(function () {
    'use strict';

    angular
        .module('app.core')
        .controller('FBListsController', FBListsController);

    /**
    @ngdoc controller
    @name app.core.controller:FBListsController
    @requires $scope
    @requires $rootScope
    @requires $state
    @requires $firebaseObject
    @requires $firebaseArray
    @requires $log
    @requires $q
    @requires successAlertS
    @requires errAlertS
    @requires infoAlertS
    @requires $filter
    @requires clearObjectFilter
    @requires translateFilter
    */
    /** @ngInject */
    function FBListsController(
        loopEachFilter,
        $rootScope,
        $scope,
        $log,
        $q,
        errAlertS,
        $filter, // no quitar se requiere para eval fn
        getArrayFromObjectFilter,
        $mdDialog,
        $document,
        CatalogsF,
        $timeout,
        loadingS
    ) {
        var initiated = false;
        var menuName = $scope.F.active.menuName;
        var menuParent = $scope.F.active.menuParent;
        var objName = $scope.F.active.menuObjName;
        var listWatchers = {};
        var allIsAllowed = false;
        $scope.statesObj = $scope.R.states;
        $scope.menuState = $scope.statesObj.fb[menuName];
        $scope.C[menuName] = [];
        $scope.fixedFieldsSearch = $scope.F.active.fixedFieldsSearch



        $scope[menuName] = [];
        $scope.selected = [];
        $scope.currentPage = $scope.F.currentPage();
        $scope.F.currentPageMongo = $scope.F.currentPage();
        $scope.filter = $scope.F.active.filter;//main filter
        $scope.$$filter = $scope.F.active.$$filter;//hidden filters
        $scope.filters = $scope.F.active.filters;//filtros que se aplican para poder hacer el filtrado principal
        $scope.$filters = $scope.F.active.$filters;//filtros de la barra de tareas 
        $scope.moreColumns = $scope.F.active.moreColumns;
        $scope.columnsRepeat = $filter('getConfigurationColumns')($scope.moreColumns, getConfigurationRow(menuName), menuName);
        $scope.relatedData = {};
        $scope.order = ($scope.R.listOrder[menuName]) ? $scope.R.listOrder[menuName] : '$id';
        $scope.F.orderMongo = ($scope.R.listOrder[menuName]) ? $scope.R.listOrder[menuName] : '$id';
        var scopeName = ($scope.filter.scopeName) ? $scope.filter.scopeName : menuName;
        if (angular.isArray($scope.filters)) {
            $scope.lastFilter = $scope.filters[$scope.filters.length - 1];
            if ($scope.lastFilter.scopeName !== scopeName) { $scope.scopeName = $scope.lastFilter.scopeName; }
        } else {
            $scope.scopeName = scopeName;
        }
        if (!$scope.Z[$scope.scopeName]) { $scope.Z[$scope.scopeName] = []; }
        $scope.mainCatalog = undefined;

        function getConfigurationRow(menuName) {
            var data = angular.fromJson(localStorage.getItem('configuration-' + menuName));
            return (data === null ? [{ catalogs: menuName, show: false }] : data);
        }
        function setFilterBy() {
            var filterByDefault;
            if (angular.isArray($scope.R.filtersBy[$scope.F.active.menuName])) {
                filterByDefault = $scope.R.filtersBy[$scope.F.active.menuName].find(function (item) {
                    return item.default;
                });
            }
            $scope.F.search.filterBy = filterByDefault || $scope.F.search.filterBy;
        }
        function resetSearch(advancedToo) {
            $scope.F.searchText = null;
            if (advancedToo) {
                $scope.F.search.query = null;
                $scope.F.search.$query = null;
            }
        }
        function resetMemory() {
            $scope.Z = {};
            loopEachFilter($scope.C, function (data, index) {
                if (!(angular.isFunction(data) || index === 'loadData')) {
                    delete $scope.C[index];
                }
            });
        }
        $scope.createConfiguration = function (index, value, menuName) {
            var cache = angular.fromJson(localStorage.getItem('configuration-' + menuName));
            cache = cache === null ? {} : cache;
            cache[value.name] = { catalogs: value.catalogs, name: value.name, show: (value.show) ? false : true };
            localStorage.setItem('configuration-' + menuName, angular.toJson(cache));
        };
        $scope.openMenu = function ($mdOpenMenu, ev) {
            $mdOpenMenu(ev);
        };
        $scope.openModalEdit = function (ev, columnConfig, object) {
            if (columnConfig.editFn && editFn.hasOwnProperty(columnConfig.editFn)) {
                editFn[columnConfig.editFn](ev, columnConfig, object);
            } else {
                openModalEditFn(ev, columnConfig, object);
            }
        }
        var editFn = {
            editPaymentForms: function (ev, column, employee) {
                $log.log('called')
                $mdDialog.show({
                    controllerAs: 'pfCtrl',
                    locals: {
                        employee: employee,
                        column: column
                    },
                    controller: 'PaymentFormsController',
                    templateUrl: 'app/main/employees/dialogs/paymentForms.html',
                    parent: angular.element($document.body),
                    targetEvent: ev,
                    clickOutsideToClose: false
                }).then(function (answer) {
                    $log.debug(answer, 'importEmployeesModal answer');
                }).catch(function (err) {
                    $log.debug('importEmployeesModal cancelled', err);
                });
            }
        }
        function openModalEditFn(ev, columnConfig, object) {
            $log.debug('importVariablesModal');
            $mdDialog.show({
                locals: {
                    columnConfig: columnConfig,
                    object: object
                },
                controller: 'FieldEditModalController as fieldCtrl',
                templateUrl: 'app/main/employees/dialogs/edit-field-modal.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            }).then(function (result) {
                var flag = true;
                if (columnConfig.regex) {
                    var reg = new RegExp(columnConfig.regex);
                    flag = reg.test(result);
                }
                if (flag) {
                    var thisPath = columnConfig.path.replace(/\./g, '/');
                    if (columnConfig.rute && object.$id) {
                        var thisRute = columnConfig.rute;
                        if (angular.isFunction(thisRute)) {
                            thisRute = thisRute(object);
                        }
                        var absolutePath = thisRute + '/' + object.$id + '/' + thisPath;
                        $scope.F.root.child(absolutePath).set(result).then(function () {
                        }).catch(errAlertS);
                    } else {
                        $log.log('No se hizo ninguna edición');
                    }
                } else {
                    errAlertS('El valor ingresado no es valido');
                }
            }, function () {
                $log.log('Se cancelo edición');
            });
        }



        $scope.getValidations = function () {
            $scope.validations = [];
            if (($scope.filter && $scope.filter.alias) || angular.isArray($scope.filters)) {
                $scope.validations.push({
                    valid: (angular.isUndefined($filter('getFromObject')($scope, $scope.filter.alias)) || $scope[menuName].length),
                    msg: 'No hay registros de ' + $filter('translate')(objName + '.SINGULAR') + ' aún.'
                });
                if (angular.isArray($scope.filters)) {
                    var fLength = $scope.filters.length;
                    for (var f = 0; f < fLength; f++) {
                        $scope.validations.push({
                            valid: (angular.isDefined($filter('getFromObject')($scope, $scope.filters[f].alias)) && !$scope[menuName].length),
                            msg: 'Seleccione ' + $filter('translate')($scope.filters[f].by + '.SINGULAR') + ' para filtrar ' + $filter('translate')(objName + '.SINGULAR') + '.'
                        });
                    }
                } else {
                    $scope.validations.push({
                        valid: (angular.isDefined($filter('getFromObject')($scope, $scope.filter.alias)) && !$scope[menuName].length),
                        msg: 'Seleccione ' + $filter('translate')($scope.filter.by + '.SINGULAR') + ' para filtrar ' + $filter('translate')(objName + '.SINGULAR') + '.'
                    });
                }
            } else if ($scope[menuName]) {
                $scope.validations.push({
                    valid: ($scope[menuName].length),
                    msg: 'No hay ' + $filter('menuName')(menuName) + ' aún'
                });
            }
        };
        $scope.restartSelected = function () {
            $scope.selected = [];
        };

        $scope.autocompleteList = function (search, parent, child, by) {
            return $q(function (resolve, reject) {
                // si se busca en la lista de payroll se hace del lado del cliente ya que ya están cargadas todas las payrolls disponibles del cliente
                if (parent === 'payrolls') {
                    var p = ($scope.F.permissionToAccessAllPayrolls) ? $rootScope.L.allPayrolls : $rootScope.L.payrolls;
                    resolve($filter('filter')(p, search));
                } else {
                    by = by ? by : 'name';
                    var ref = $scope.F.root.child('lists').child(parent);
                    if (child) {
                        ref = ref.child(child);
                    }
                    var searchQ = search.toUpperCase();
                    ref.orderByChild(by).startAt(searchQ).endAt(searchQ + '\uf8ff').limitToFirst(10).once('value', function (snap) {
                        var value = snap.val();
                        var array = value !== null ? $filter('getArrayFromObject')(value, false, true) : [];
                        resolve(array);
                    }, function (err) {
                        reject(err);
                    });
                }
            });
        };
        $scope.reOrder = function () {
            // si tiene - se le quita y se asigna a variable
            var order = ($scope.order.indexOf('-') !== -1) ? $scope.order.replace('-', '') : $scope.order;
            // $scope.queryFilter = order;
            if (!$scope.filter) {
                $scope.filter = {
                    scopeName: menuName,
                    alias: 'F.search.query',
                    val: function () {
                        return $scope.F.search.query;
                    }
                };
            }
            $scope.filter.by = order;
            $scope.autocompleteThis();
        };
        $scope.autoSelect = function (searchF, what) {
            $scope.F.search[searchF] = (what) ? what.$id : false;
        };
        $scope.delete = function (e, promise) {
            if (promise) { return $scope.C.deleteSafe(e, menuParent, objName, $scope.selected, $scope); }
            loadingS.start();
            $scope.C.deleteSafe(e, menuParent, objName, $scope.selected, $scope).then(function () {
                $scope.selected = [];
                loadingS.stop();
                $rootScope.$evalAsync(function () {
                    $log.debug('delete finished');
                });
            }).catch(function (err) {
                errAlertS(err);
                loadingS.stop();
                $rootScope.$evalAsync();
            });
        };
        $scope.clearSelected = function () {
            $scope.selected = [];
        };
        $scope.exportDataToExcel = function (allData, exportId, currentPage, paginate) {
            CatalogsF.exportDataToExcel(allData, exportId, $scope.selected, $scope.refToExport, currentPage, paginate);
        };
        $scope.exportDataToExcelByQuery = function (allData, exportId, queries, totalResults) {
            if (typeof ($scope.refToExport) === 'undefined') {
                $scope.refToExport = $scope.R.constructDinamicRef(scopeName, false, $scope);
            }
            CatalogsF.exportDataToExcelByQuery(allData, exportId, $scope.selected, $scope.refToExport, queries, totalResults);
        };
        $scope.getExportAll = function () {
            CatalogsF.exportAllDataToExcel();
        };
        $scope.autocompleteMongo = function (search, catalog, fields, extraQuerys) {
            return $q(function (resolve, reject) {
                $scope.D.api.autocompleteMongo(search, catalog, fields, extraQuerys).then(function (items) {
                    resolve(items);
                    loadingS.stop();
                    $rootScope.$evalAsync(function () {
                        $log.debug('getThem finished');
                    });
                }).catch(function (err) {
                    errAlertS(err);
                    reject(err);
                    loadingS.stop();
                    $rootScope.$evalAsync();
                });
            });
        };

        function init() {
            initiated = true;
            if (!$scope.R.dinamicRefs[menuName]) { alert('Falta configurar R.dinamicRefs.' + menuName + ' !!!'); }
            if (!$scope.menuState) { alert('Falta configurar R.states.fb."' + menuName + ' !!!'); }
            var restrictAll = ($scope.filter && $scope.filter.restrictAll) ? $scope.filter.restrictAll : false;
            var allowClients = ($scope.filter && $scope.filter.allowClients) ? $scope.filter.allowClients : false;
            restrictAll = angular.isFunction(restrictAll) ? restrictAll() : restrictAll;
            allIsAllowed = (!restrictAll) && ($scope.F.isDistributor() || allowClients) ? true : false;
            $scope.F.advancedSearchMode = $scope.F.isDistributor() ? true : false;
            $scope.loadDataNeeded($scope.F.active.menuName); // in indexCtrl loads Mongo Cats and Lists or Objects
            // se setea el filterBy con el default que le corresponde
            setFilterBy();
            resetMemory();
            resetSearch(1);
            // setear F.search.$param si viene en los params y no esta seteado ya si hay un filtro
            if ($scope.filter) {
                $scope.R.setStateFilter($scope.filter, allIsAllowed);
            }
            var allFilters = angular.isArray($scope.filters) ? $scope.filters : [];
            if ($scope.filter) {
                allFilters.push($scope.filter);
            }
            var aLength = allFilters.length;
            for (var a = 0; a < aLength; a++) {
                $scope.R.setStateFilter(allFilters[a], allIsAllowed);
            }
            getData();
        }
        $scope.searchText = '';


        $scope.filterMultipleData = function (data, filters, scopeName) {
            var filteredData = angular.copy(data);
            if (!scopeName) { scopeName = menuName; }
            for (var fi = 0; fi < filters.length; fi++) {
                filteredData = $scope.filterData(filteredData, filters[fi], 1);
                if (fi === filters.length - 1) {
                    $scope.$evalAsync(function () {
                        $scope.Z[scopeName] = filteredData;
                    });
                }
            }
            if (angular.isArray($scope.selected) && $scope.selected.length > 0) {
                var newSelected = [];
                for (var s = 0; s < $scope.selected.length; s++) {
                    if (angular.isArray(filteredData)) {
                        var obj = filteredData.find(function (item) {
                            return item.$id === $scope.selected[s].$id;
                        });
                        if (angular.isDefined(obj)) {
                            newSelected.push($scope.selected[s]);
                        }
                    }
                }
                $scope.selected = newSelected;
            }
            return filteredData;
        };
        function filterData(thisRecords, filter) {
            if (thisRecords.length > 0) {
                if (angular.isArray(filter)) {
                    var fLength = filter.length;
                    for (var f = 0; f < fLength; f++) {
                        thisRecords = filterData(thisRecords, filter[f]);
                    }
                } else {
                    thisRecords = thisRecords.filter(function (item) {
                        var flag = true;
                        var thisValue = $filter('getFromObject')(item, filter.field);
                        if (angular.isArray(filter.value)) {
                            flag = filter.value.indexOf(thisValue) > -1;
                        } else if (angular.isDefined(filter.ope)) {
                            flag = eval(thisValue + 'operator' + filter.value);
                        } else {
                            flag = thisValue === filter.value;
                        }
                        return flag;
                    });
                }
            }
            return thisRecords;
        }
        function getData(notShowLoading) {
            if (!notShowLoading) {
                loadingS.start();
                $rootScope.$evalAsync();
            }
            $timeout(function () {
                $scope.loadThem().then(function (records) {
                    var selectedFilters = angular.isArray($scope.$filters) ? $scope.$filters.slice() : [];
                    var defaultFilters = angular.isArray($scope.$$filter) ? $scope.$$filter.slice() : [];
                    var allFilters = selectedFilters.reduce(function (current, filter) {
                        var mainFilter;
                        var filterVal;
                        var filterOpe;
                        if (filter.indexOf(':') === -1) {
                            mainFilter = filter;
                        } else { // filter have operator
                            var filterA = filter.split(':');
                            mainFilter = filterA[0];
                            filterOpe = filterA[1];
                        }
                        filterVal = $scope.F.search.$[filter];
                        var thisFilterIndex = defaultFilters.findIndex(function (item) {
                            return item.by === filter;
                        });
                        if (thisFilterIndex > -1) {
                            var thisFilter = defaultFilters[thisFilterIndex];
                            if (angular.isUndefined(filterVal)) {
                                filterVal = angular.isFunction(thisFilter.val) ? thisFilter.val() : thisFilter.val;
                                defaultFilters.splice(thisFilterIndex, 1);
                            }
                        }
                        var falseAllowed = $filter('getFromObject')($scope.F.active.$filtersConfig, filter + '.allowFalse');

                        if (angular.isDefined(filterVal) && filterVal !== 'all' && (filterVal !== false || falseAllowed)) {
                            current.push({ field: mainFilter, value: filterVal, ope: filterOpe });
                        }
                        return current;
                    }, []);
                    allFilters = defaultFilters.reduce(function (current, filter) {
                        var mainFilter = filter.by;
                        var filterVal = angular.isFunction(filter.val) ? filter.val() : filter.val;
                        if (angular.isDefined(filterVal) && filterVal !== 'all') {
                            current.push({ field: mainFilter, value: filterVal });
                        }
                        return current;
                    }, allFilters);
                    allFilters = allFilters.map(function (item) {
                        var thisPath = $filter('getFromObject')($scope.F.active.$filtersConfig, item.mainFilter + '.field');
                        $log.log('item', item)
                        if (angular.isDefined(thisPath)) {
                            item.mainFilter = thisPath;
                        }
                        var replaceField = $filter('getFromObject')($scope.F.active.$filtersConfig, item.field + '.replace');
                        if (angular.isDefined(replaceField)) {
                            item.field = replaceField
                        }
                        return item;
                    });
                    $log.log('allFilters', allFilters);
                    records = filterData(records, allFilters || []);
                    return $filter('getRelationsOfCat')(records, scopeName, $scope.relatedData);
                }).then(function (records) {
                    $scope.selected = $scope.selected.filter(function (item) {
                        return records.indexOf(function (record) {
                            return record.$id === item.$id || record._id === item._id;
                        }) > -1;
                    });
                    $scope.$evalAsync(function () {
                        $scope.Z[menuName] = records;
                        $scope[scopeName] = records;
                        $scope.getValidations();
                        initWatchers();
                        if (!notShowLoading) {
                            loadingS.stop();
                        }
                        $timeout(function () { }, 0, false);
                    });
                }).catch(function (error) {
                    errAlertS(error);
                });
            }, 0, false);
        }

        $scope.loadThem = function () {
            return $q(function (resolve, reject) {
                try {
                    var filter = $scope.filter ? $scope.filter : {};
                    var val = angular.isDefined(filter.val) ? (angular.isFunction(filter.val) ? filter.val() : filter.val) : undefined;
                    var promises = [];
                    var mainCatalog;
                    // var a = angular.isUndefined(val) && !$scope.filter && allIsAllowed; //sin valor de filtro es decir no tiene porque no se esta filtrando nada
                    // var b = angular.isDefined(val) && val === 'all' && allIsAllowed; //sin valor de filtro es decir se quieren todos los resultados
                    // var c = angular.isDefined(val) && val !== 'all' && filter.hasOwnProperty('by') && filter.hasOwnProperty('name'); //se filtran los datos de acuerdo a una selección
                    var flag = (angular.isUndefined(val) || val === 'all') && allIsAllowed;
                    flag = flag || (angular.isDefined(val) && val !== 'all' && filter.hasOwnProperty('by') && filter.hasOwnProperty('name'));
                    if (flag) {
                        var scopeName = filter.scopeName ? filter.scopeName : menuName;
                        var type = filter.type ? filter.type : 'array';
                        var query = filter.by ? filter.by : undefined;
                        var ref = $scope.R.constructDinamicRef(scopeName, filter, $scope);
                        mainCatalog = $filter('convertToCamelCase')(scopeName + '_' + query + '_' + val);
                        if ($scope.C.hasOwnProperty(mainCatalog)) {
                            promises.push(new Promise(function (resolve) {
                                resolve($scope.C[mainCatalog]);
                            }));
                        } else {
                            promises.push($scope.C.loadCatalog(scopeName, ref, query, val, type, mainCatalog));
                        }
                        $scope.refToExport = ref;
                    }
                    Promise.all(promises).then(function (resp) {
                        var records = resp.length > 0 ? resp[0].slice() : [];
                        if (angular.isDefined(mainCatalog)) {
                            $scope.mainCatalog = mainCatalog;
                        }
                        resolve(angular.fromJson(angular.toJson(records)));
                    }).catch(reject);
                } catch (error) {
                    reject(error);
                }
            });
        };
        var watchersSetted = false;
        var firstIgnored = {};
        function callGetData(from, notShowLoading) {
            if (from) {
                if (angular.isUndefined(firstIgnored[from])) {
                    firstIgnored[from] = 0;
                }
                firstIgnored[from]++;
            }
            if (!from || firstIgnored[from] > 1) {
                getData(notShowLoading);
            }
        }
        function initWatchers() {
            if (!watchersSetted) {
                watchersSetted = true;
                // var thisFilter = $scope.$$filter && $scope.filters ? $scope.lastFilter : (!$scope.$$filter && $scope.filters ? principalFilter : $scope.filter);
                listWatchers.advancedSearchMode = $scope.$watch('F.advancedSearchMode', function (advancedMode) {
                    if (angular.isDefined(advancedMode) && angular.isDefined($scope.F.searchText) && angular.isDefined($scope.F.search)) {
                        resetSearch(advancedMode ? undefined : 1);
                    }
                });
                listWatchers.currentPage = $scope.$watch('currentPage', function (cp) {
                    if (cp) {
                        $scope.F.setCurrentPage(cp);
                    }
                });
                if ($scope.$filters) { // si hay filtros se observa el objeto F.search.$ y cada vez que cambia filtra todo
                    listWatchers.$filters = $scope.$watch('F.search.$', function () {
                        callGetData('$filters');
                    }, true);
                }
                listWatchers.mainCatalog = $scope.$watch('mainCatalog', function (newVal, oldVal) {
                    if (angular.isDefined(oldVal) && listWatchers.hasOwnProperty(oldVal) && oldVal !== newVal) {
                        $log.log('destroying principal watcher of cat:C.' + oldVal);
                        listWatchers[oldVal]();
                        delete listWatchers[oldVal];
                        delete firstIgnored[oldVal];
                    }
                    if (angular.isDefined(newVal) && (!listWatchers.hasOwnProperty(newVal))) {
                        $log.log('creating principal watcher of cat:C.' + newVal);
                        listWatchers[newVal] = $scope.$watch('C.' + newVal, function () {
                            callGetData(newVal, true);
                        }, true);
                    }
                });
                if ($scope.filter && $scope.filter.alias) {
                    listWatchers.filter = $scope.$watch($scope.filter.alias, function (val) {
                        $scope.R.setStateParams(val, null, allIsAllowed, val ? undefined : true);
                        callGetData('filter');
                    });
                }
            }
        }

        $filter('startAfterInit')($scope, listWatchers, initiated, init);
    }

}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .controller('FBDetailController', FBDetailController)
    /**
    @ngdoc controller
    @name app.core.controller:FBDetailController
    @requires $scope
    @requires $rootScope
    @requires $state
    @requires $firebaseObject
    @requires $firebaseArray
    @requires $log
    @requires $q
    @requires successAlertS
    @requires errAlertS
    @requires infoAlertS
    @requires $filter
    @requires clearObjectFilter
    @requires translateFilter
    */
    /** @ngInject */
    function FBDetailController(
        $scope,
        $rootScope,
        $state,
        $firebaseObject,
        $timeout,
        $log,
        $q,
        successAlertS,
        errAlertS,
        infoAlertS,
        $filter,
        clearObjectFilter,
        translateFilter,
        $mdDialog,
        startAfterInitFilter,
        loadingS
    ) {
        loadingS.start();
        // si necesitas cargar catalogos de mongo pon sus nombres aqui
        var initiated = false;
        // var storageRef = firebase.storage().ref();
        var menuName = $scope.F.active.menuName;
        var menuParent = $scope.F.active.menuParent;
        $scope.statesObj = $scope.R.states.fb;
        $scope.menuState = $scope.statesObj[menuName];
        var mainObjectLoaded = $q.defer();
        $scope.mainObjectLoaded = mainObjectLoaded.promise;
        var imageName = $scope.F.active.imageName;
        var action = $scope.F.active.action;
        var objName = ($scope.menuState.$alias) ? $scope.menuState.$alias : $scope.F.active.menuObjName;

        $scope.objectLoaded = false;
        $scope.F.UniqueAndFilter = false;

        $scope.images = [];
        $scope.files = [];
        $scope.selected = [];
        $scope.selectedTab = '0';
        $scope.blanc = {};
        $scope.filter = $scope.F.active.filter;
        $scope.$filter = $scope.F.active.$filter;
        $scope.$$filter = $scope.F.active.$$filter;
        $scope.filters = $scope.F.active.filters;
        $scope.$filters = $scope.F.active.$filters;
        $scope.detailWatchers = {};
        function init() {
            if (angular.isObject($scope.menuState.blanc)) {
                for (var field in $scope.menuState.blanc) {
                    if ($scope.menuState.blanc.hasOwnProperty(field)) {
                        var thisField = $scope.menuState.blanc[field];
                        if (angular.isFunction(thisField)) {
                            $scope.blanc[field] = thisField();
                        } else {
                            $scope.blanc[field] = angular.fromJson(angular.toJson(thisField));
                        }
                    }
                }
            }
            $scope.dataNeededPromise = $scope.loadDataNeeded($scope.F.active.menuName);
            for (var p in $state.params) {
                var param = $state.params[p];
                if (param) $scope[p] = param;
            }
            // setear F.search.$param si viene en los params y no esta seteado ya si hay un filtro
            if ($scope.filter && !$scope.F.disableSearchBar) {
                $scope.R.setStateFilter($scope.filter);
            }
            // setear F.search.$param por cada uno de los filtros
            if ($scope.filters && !$scope.F.disableSearchBar) {
                for (var f in $scope.filters) {
                    var filte = $scope.filters[f];
                    $scope.R.setStateFilter(filte);
                }
            }
            if (!$scope.menuState.refObject) {
                if (!$state.params[objName + 'Id'] && !$state.params[objName]) {
                    infoAlertS('URL incompleta para ' + action + ' en ' + menuName + ' falta parametro :' + objName + 'Id o :' + objName);
                    $log.error('missing url params', {
                        state: $scope.F.active,
                        params: $state.params
                    });
                    if ($scope.F.settings.goToListOnFail) $scope.R.goToList();
                }
            }
            if ((!$state.params[objName] && $state.params[objName + 'Id'] && !$scope.F.addMode) || $scope.menuState.refObject) {
                var ref = $scope.R.constructDinamicRef(menuName, $scope.filter, $scope);
                if (($state.params[objName + 'Id'] !== 'global' && $state.params[objName + 'Id']) || $scope.menuState.refObject) {
                    var as = ($scope.menuState.as) ? $scope.menuState.as : objName;
                    $scope.loadObjectOnScope(menuName, $state.params[objName + 'Id'], objName, ref, as).then(function () {
                        $scope.F.active.detailObject = $scope[objName];
                        $scope.objectLoaded = true;
                        $scope.statesObjsPromise = loadFiltersFromStates();
                        loadingS.stop();
                        $rootScope.$evalAsync(function () {
                            $log.debug('Loaded from id ' + objName);
                            $rootScope.$broadcast('mainObjectLoaded');
                            mainObjectLoaded.resolve();
                        });
                    }).catch(function (err) {
                        if (err == null) {
                            infoAlertS('Registro inexistente ' + objName);
                            $log.error('Registro Inexistente en $scope.' + objName, {
                                menuName: menuName,
                                val: $state.params[objName + 'Id'],
                                objName: objName
                            });
                        } else {
                            errAlertS(err);
                        }
                        mainObjectLoaded.reject(err);
                        if ($scope.F.settings.goToListOnFail) $scope.R.goToList();
                    });
                } else {
                    $log.debug('no need to load object');
                }
            } else {
                // si se manda objeto de vacio, se entiende que se quiere crear uno
                $scope[objName] = ($scope.F.addMode) ? $scope.blanc : $state.params[objName];
                $scope.objectLoaded = true;
                $scope.statesObjsPromise = loadFiltersFromStates();
                $scope.F.active.detailObject = $scope[objName];
                loadingS.stop();
                $rootScope.$evalAsync(function () {
                    $rootScope.$broadcast('mainObjectLoaded');
                    mainObjectLoaded.resolve();
                    $log.debug('Loaded from previus state or new ' + objName, $scope[objName]);
                });
            }
        }

        /**
         * @ngdoc method
         * @name app.core.controller:FBDetailController#loadFiltersFromStates
         * @methodOf app.core.controller:FBDetailController
         * @description Carga objetos en $scope de acuerdo a los Ids de los params seteados en $state.params
         */
        var loadFiltersFromStates = function () {
            return new Promise(function (resolve, reject) {
                var promises = [];
                for (var p in $state.params) {
                    if ($state.params.hasOwnProperty(p)) {
                        var param = $state.params[p];
                        if (param) { $scope[p] = param; }
                        if (p.search('Id') !== -1 && param !== 'all') {
                            var ppName = p.substring(p.length - 2, -1); // requiere que solo haya paramId en los params 
                            if (ppName !== objName && ppName && ppName !== '' && angular.isObject($scope.statesObj[ppName + 's']) && angular.isObject($scope.statesObj[ppName + 's'].filter)) { // solo carga objetos distintos al principal
                                var ppRef = $scope.R.constructDinamicRef(ppName + 's', $scope.statesObj[ppName + 's'].filter, $scope);
                                if ($scope.F.centers.indexOf($state.params[ppName + 'Id']) === -1 && ppName !== 'firm') {
                                    if ($state.params[ppName + 'Id'] !== 'new' && $state.params[ppName + 'Id'] !== 'global' && $state.params[ppName + 'Id'] !== '') {
                                        promises.push($scope.loadObjectOnScope(ppName + 's', $state.params[ppName + 'Id'], ppName, ppRef));
                                        $log.debug('loaded object from param', {
                                            ppName: ppName,
                                            ppRef: ppRef,
                                            scopeValue: $scope[ppName]
                                        });
                                    } else {
                                        $scope[ppName] = JSON.parse(JSON.stringify($scope.statesObj[ppName + 's'].blanc ? $scope.statesObj[ppName + 's'].blanc : {}));
                                        $log.debug('loaded blanc object from param', {
                                            ppName: ppName,
                                            ppRef: ppRef,
                                            scopeValue: $scope[ppName],
                                            fromBlanc: $scope.statesObj[ppName + 's'].blanc
                                        });
                                    }
                                } else {
                                    $scope[ppName] = {};
                                }
                            }
                        }
                    }
                }
                Promise.all(promises).then(function (resp) {
                    $rootScope.$evalAsync(function () {
                        $timeout(function () {
                            resolve(resp);
                        }, 0, false);
                    });
                }).catch(function (err) {
                    if (err == null) {
                        err = 'Registro inexistente';
                    }
                    errAlertS(err);
                    reject(err);
                });
            });
        }


        /**
         * @ngdoc method
         * @name app.core.controller:FBDetailController#loadObjectOnScope
         * @methodOf app.core.controller:FBDetailController
         * @description Carga un objeto en scope 
         * @param {string} catalog el nombre del catalogo ej: "payrolls"
         * @param {string} id el id del objeto a cargar (se usa si no se manda ref) @todo:backlog simplificar esto
         * @param {string} scopeName será el nombre en el cual se registrara en el scope
         * @param {string} ref si no viene la referencia se saca automáticamente del catálogo en $scope.statesObj[catalog]
         */
        $scope.loadObjectOnScope = function (catalog, id, scopeName, ref, as) {
            loadingS.start();
            var promise = $q.defer();
            var refPath = ref;
            if (!$scope.statesObj[catalog].refObject) {
                if (!refPath && catalog) {
                    // refPath = $scope.R.constructFilterRef($scope.statesObj[catalog].filter, $scope, 1, 1);
                    refPath = $scope.R.constructDinamicRef(catalog, $scope.statesObj[catalog].filter, $scope, 1);
                    // $log.debug('query with filter to be made in $scope.' + scopeName + ' -> ' + refPath, $scope.statesObj[catalog].filter);
                } else {
                    refPath += '/' + id + '/';
                    // $log.debug('query to be made in $scope.' + scopeName + ' -> ' + refPath);
                }
            }

            $scope[scopeName] = $firebaseObject($scope.F.root.child(refPath));
            if (as) { $scope[as] = $scope[scopeName]; }

            $scope[scopeName].$loaded(function (obj) {
                $log.log('setting in scope', scopeName);
                if (obj.$value !== null) {
                    loadingS.stop();
                    $rootScope.$evalAsync(function () {
                        promise.resolve(obj);
                    });
                } else {
                    $log.debug('objeto cargado en scope ' + scopeName + ' no tiene valor');
                    if ($scope.statesObj[catalog].refObject) {
                        $scope[scopeName] = $scope.blanc;
                        $scope.F.addMode = true;
                        loadingS.stop();
                        $rootScope.$evalAsync(function () {
                            promise.resolve($scope.blanc);
                        });
                    } else {
                        promise.reject(null);
                    }
                }
                // $log.debug('result from FB in ref: ' + refPath + ' for object: ' + scopeName, obj);
            }, function (err) {
                errAlertS(err);
                promise.reject(err);
            });

            return promise.promise;
        }

        $scope.unarchived = function (active, mainObject) {
            if (active) {
                mainObject.archived = false;
            }
        };

        $scope.autocompleteListM = function (search, catalog, fields, extraQuerys) {
            return $scope.F.autocompleteListM(search, catalog, fields, extraQuerys, $scope.D);
        };

        /**
         * @ngdoc method
         * @name app.core.controller:FBDetailController#add
         * @methodOf app.core.controller:FBDetailController
         * @description Agrega un objeto
         * @param {object} obj el objeto a crear
         * @param {boolean=} promise en caso de que sea true devuelve una promesa
         * @param {string} catalog si viene se guardará en ese objeto según la configuración en R.states
         * @param {object=} sscope scope del cual viene el objeto 
         * @return {promise} en caso de que el parametro true sea cierto regresa una promesa
         */
        $scope.add = function (obj, promise, catalog, sscope) {
            return new Promise(function (resolve, reject) {
                $scope.$emit('stopDetailWatchers');
                if (!catalog) { catalog = menuName; }
                if (!sscope) { sscope = $scope; }
                obj.created = $scope.D.getTimeObject(0, obj.created);
                if (angular.isUndefined(obj.center)) {
                    obj.center = $scope.F.center;
                }
                var object = clearObjectFilter(obj);
                // var ref = $scope.R.constructFilterRef($scope.statesObj[catalog].filter, $scope, 1, 1);
                var ref = $scope.R.constructDinamicRef(catalog, $scope.statesObj[catalog].filter, sscope);
                $log.debug('Adding to FB Catalog ' + objName, {
                    isRefObject: $scope.menuState.refObject,
                    returnPromise: promise,
                    objName: objName,
                    obj: obj,
                    object: object,
                    ref: ref,
                    catalog: catalog
                });
                var thisPromise;
                if (!$scope.statesObj[catalog].refObject) {
                    thisPromise = $scope.F.root.child(ref).push(object);
                } else {
                    thisPromise = $scope.F.root.child(ref).set(object);
                }
                loadingS.start();
                thisPromise.then(function (res) {
                    $timeout(function () {
                        if (!promise) {
                            $log.debug(res.key, obj, 'saved on FB');
                            $scope.F.addMode = false;
                            successAlertS('Se creó ' + translateFilter(objName + '.SINGULAR') + ' con éxito');
                            if ($scope.F.settings.goToListOnCreate) $scope.R.goToList();
                            loadingS.stop();
                            $rootScope.$evalAsync(function () {
                                $log.debug('add finished');
                            });
                        }
                        resolve(res);
                    }, 2500, false);
                }).catch(function (err) {
                    if (!promise) {
                        errAlertS(err);
                        loadingS.stop();
                        $rootScope.$evalAsync();
                    }
                    reject(err);
                });
            });
        }

        /**
         * @ngdoc method
         * @name app.core.controller:FBDetailController#save
         * @methodOf app.core.controller:FBDetailController
         * @description Salva un objeto
         * @param {object} obj el objeto a salvar
         * @param {boolean=} promise devolver promsea
         * @param {string} catalog si viene se guardará en ese objeto según la configuración en R.states
         * @param {object=} sscope scope del cual viene el objeto
         * @return {promise} en caso de que el parametro true sea cierto regresa una promesa
         */
        $scope.save = function (obj, promise, catalog, sscope) {
            return new Promise(function (resolve, reject) {
                $scope.$emit('stopDetailWatchers');
                if (!catalog) { catalog = menuName; }
                if (!sscope) { sscope = $scope; }
                obj.updated = $scope.D.getTimeObject();
                if (angular.isUndefined(obj.center)) {
                    obj.center = $scope.F.center;
                }
                var object = clearObjectFilter(obj);
                var ref = $scope.R.constructDinamicRef(catalog, $scope.statesObj[catalog].filter, sscope);
                $log.debug('saving ' + objName, {
                    obj: obj,
                    catalog: catalog,
                    ref: ref,
                    objectToSave: object
                });
                var thisPromise;
                if (!$scope.statesObj[catalog].refObject) {
                    thisPromise = $scope.F.root.child(ref).child(obj.$id).set(object);
                } else {
                    thisPromise = $scope.F.root.child(ref).set(object);
                }
                loadingS.start();
                thisPromise.then(function (result) {
                    $timeout(function () {
                        if (!promise) {
                            successAlertS('Se guardo ' + translateFilter(objName + '.SINGULAR') + ' con éxito');
                            if ($scope.F.settings.goToListOnUpdate) $scope.R.goToList();
                            loadingS.stop();
                            $rootScope.$evalAsync(function () {
                                $log.debug('save finished');
                            });
                        }
                        resolve(result);
                    }, 2500, false);
                }).catch(function (error) {
                    if (!promise) {
                        errAlertS(error);
                        loadingS.stop();
                        $rootScope.$evalAsync();
                    }
                    reject(error);
                });
            })
        }

        /**
         * @ngdoc method
         * @name app.core.controller:FBDetailController#upload
         * @methodOf app.core.controller:FBDetailController
         * @description Sube una o varias imagenes
         * @param {filesArray} files un arreglo de objetos de archivo
         * @param {object} obj el objeto al cual están ligados los archivos
         * @param {boolean} justUpload si solo se quiere subir sin guardar
         * @return {promise} promesa de cuando se sube el archivo
         */
        $scope.upload = function (files, obj, justUpload, imageName, returnFilePath) {
            var promise = $q.defer();
            loadingS.start();
            $scope.F.progress = false;
            if (obj.hasOwnProperty('$id')) {
                $scope.C.uploadFile(files, obj, imageName, returnFilePath).then(function (imgUrl) {
                    obj[angular.isDefined(imageName) ? imageName : $scope.F.active.imageName] = imgUrl;
                    if (justUpload) {
                        if ($scope.imageApi) $scope.imageApi.removeAll();
                        $scope.images = [];
                        $scope.files = [];
                        if (angular.isDefined(imageName)) { $scope[imageName] = []; }
                        $scope.F.progress = false;
                        loadingS.stop();
                        $rootScope.$evalAsync(function () {
                            $log.debug('upload finished');
                        });
                        promise.resolve(true);
                    } else {
                        $scope.save(obj, 1).then(function () {
                            successAlertS('Se subió el archivo correctamente');
                            $scope.images = [];
                            $scope.files = [];
                            if ($scope.imageApi) $scope.imageApi.removeAll();
                            $scope.F.progress = false;
                            loadingS.stop();
                            $rootScope.$evalAsync(function () {
                                $log.debug('upload and save finished');
                            });
                            promise.resolve(true);
                        }).catch(function (err) {
                            errAlertS(err);
                            promise.reject(err);
                        });
                    }
                }).catch(function (err) {
                    errAlertS(err);
                    promise.reject(err);
                });
            } else {
                var errM = 'Primero debe crear el registro';
                errAlertS(errM);
                promise.reject(errM);
            }
            return promise.promise;
        }

        $scope.removeUpload = function (obj, filePath) {
            var promise = $q.defer();
            loadingS.start();
            $scope.C.removeUpload(obj, undefined, filePath).then(function () {
                obj[angular.isDefined(filePath) ? filePath : $scope.F.active.imageName] = false;
                $scope.save(obj, 1).then(function () {
                    successAlertS('Se borró el archivo correctamente');
                    $scope.images = [];
                    if (angular.isDefined(imageName)) { $scope[imageName] = []; }
                    if ($scope.imageApi) $scope.imageApi.removeAll();
                    loadingS.stop();
                    $rootScope.$evalAsync(function () {
                        $log.debug('removeUpload finished');
                    });
                    promise.resolve(true);
                }, function (err) {
                    errAlertS(err);
                    promise.reject(err);
                });
            }, errAlertS);
            return promise.promise;
        }

        $scope.cancelUpload = function (uploadTask) {
            uploadTask.cancel();
        }

        $scope.addElement = function (mainObj, arrayObj, obj) {
            if (angular.isDefined(mainObj)) {
                if (angular.isUndefined(mainObj[arrayObj])) {
                    mainObj[arrayObj] = [];
                }
                mainObj[arrayObj].push(obj);
            }
        };

        $scope.addObject = function (ev, catalog, obj, field, catalogName, fieldName, objInSave, fieldToSave, validateUnique, validateFields) {
            // Appending dialog to document.body to cover sidenav in docs app
            var confirm = $mdDialog.prompt()
                .title('Agregar nuevo ' + catalogName)
                .placeholder(fieldName)
                .ariaLabel(fieldName)
                .targetEvent(ev)
                .ok('Agregar')
                .cancel('Cancelar');

            $mdDialog.show(confirm).then(function (result) {
                if (result && result != '') {
                    var promise = [];
                    var catalogRef = 'catalogs/' + catalog + '/collection';
                    if (validateUnique) {
                        var findThisValue = result;
                        if (typeof (result) == "string") {
                            findThisValue = result.toUpperCase();
                        }
                        promise.push($scope.F.root.child(catalogRef).orderByChild(field).equalTo(findThisValue).once("value"));
                    }
                    Promise.all(promise).then(function (snapshots) {
                        var recordFounded = false;
                        if (snapshots.length) {
                            var snapshot = snapshots[0];
                            snapshot.forEach(function (thisSnap) {
                                if (thisSnap.val()) {
                                    var data = thisSnap.val();
                                    if (typeof (validateFields) !== "undefined") {
                                        for (var thisField in validateFields) {
                                            if (typeof (data[validateFields[thisField]]) !== "undefined" && typeof (obj[validateFields[thisField]]) !== "undefined") {
                                                if (data[validateFields[thisField]] === obj[validateFields[thisField]]) {
                                                    recordFounded = true;
                                                }
                                            }
                                        }
                                    }
                                }
                            })
                        }
                        if (!recordFounded) {
                            var finalField = field.split(".");
                            var count = 0;
                            obj.created = $scope.D.getTimeObject(0, obj.created);
                            var object = clearObjectFilter(obj);
                            $scope.F.root.child(catalogRef).push(object).then(function (snapshot) {
                                var key = snapshot.key;
                                var update = {};
                                update[key + '/' + field] = result.toUpperCase();
                                $scope.F.root.child(catalogRef).update(update).then(function () {
                                    objInSave[fieldToSave] = snapshot.key;
                                });
                            });
                        } else {
                            errAlertS("Este registro ya existe");
                        }
                    }).catch(function (error) {
                        $log.error(error);
                    })
                }
            }, function () {
                $log.debug("Cancelado");
            });
        };

        // si hay un filtro observa el filtro
        if ($scope.filter) {
            if ($scope.filter.alias) {
                //$log.debug('setting $watcher in ' + $scope.filter.alias);
                $scope.detailWatchers.filter = $scope.$watch($scope.filter.alias, function (val) {
                    if (val) {
                        $log.debug('setting from watcher on $scope.' + $scope.filter.by + 'Id -> ' + val)
                        //$scope.R.setStateParams(val, $scope.filter);
                        $scope[$scope.filter.by + 'Id'] = val; // se setea en scope
                        if ($scope[objName]) {
                            if ($scope.F.addMode) $scope[objName][$scope.filter.by] = val; // scope.payroll.firm <-
                        }
                    }
                });
            }
        }
        var onDestroyFns = [
            function () {
                delete $scope.F.active.detailObject;
            }
        ]
        startAfterInitFilter($scope, $scope.detailWatchers, initiated, init, onDestroyFns);
    }

}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .controller('DialogCtrl', DialogCtrl)

    /** @ngInject */
    function DialogCtrl($scope, $mdDialog,predefinedValue) {
        $scope.enable=true;
        if(typeof(predefinedValue)!=="undefined"){
            $scope.enable=false;
            $scope.noLote=predefinedValue;
        }
        $scope.today = new Date();
        $scope.hide = function () {
            $mdDialog.hide();
        };

        $scope.cancel = function () {
            $mdDialog.cancel();
        };

        $scope.answer = function (answer) {
            $mdDialog.hide(answer);
        };
    }

}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/toolbar');
    }
})();

(function () {
    'use strict';

    angular
        .module('app.toolbar')
        .controller('ToolbarController', ToolbarController);

    /** @ngInject */
    function ToolbarController($scope, $window, $mdDialog, $document, $rootScope, $q, $state, successAlertS, $timeout, $mdSidenav, $translate, $mdToast, $log, msNavigationService, errAlertS, $sessionStorage, AppF, $localStorage, DataF, ChatF) {
        $scope.CF = ChatF;
        // Data
        $rootScope.global = {
            search: ''
        };

        $scope.changeCenter = function (center) {
            var updates = {};
            updates['center'] = center;
            updates['firm'] = center;
            AppF.root.child('profiles/' + AppF.profile.$id).update(updates).then(function (done) {
                successAlertS('Empresa Actualizada');
                window.location.reload(true);
            }).catch(function (error) {
                errAlertS(error);
            });
        };

        $scope.bodyEl = angular.element('body');
        $scope.userStatusOptions = [{
            'id': 'online',
            'title': 'Online',
            'icon': 'icon-checkbox-marked-circle',
            'color': '#4CAF50',
            'translate': 'CHAT.STATUS_ONLINE'
        }, {
            'id': 'away',
            'title': 'Away',
            'icon': 'icon-clock',
            'color': '#FFC107',
            'translate': 'CHAT.STATUS_AWAY'
        }, {
            'id': 'do-not-disturb',
            'title': 'Do not Disturb',
            'icon': 'icon-minus-circle',
            'color': '#F44336',
            'translate': 'CHAT.STATUS_DO_NOT_DISTURB'
        }, {
            'id': 'invisible',
            'title': 'Invisible',
            'icon': 'icon-checkbox-blank-circle-outline',
            'color': '#BDBDBD',
            'translate': 'CHAT.STATUS_INVISIBLE'
        }, {
            'id': 'offline',
            'title': 'Offline',
            'icon': 'icon-checkbox-blank-circle-outline',
            'color': '#616161',
            'translate': 'CHAT.STATUS_OFFLINE'
        }];
        $scope.languages = {
            en: {
                'title': 'English',
                'translation': 'TOOLBAR.ENGLISH',
                'code': 'en',
                'flag': 'us'
            },
            es: {
                'title': 'Spanish',
                'translation': 'TOOLBAR.SPANISH',
                'code': 'es',
                'flag': 'es'
            },
            tr: {
                'title': 'Turkish',
                'translation': 'TOOLBAR.TURKISH',
                'code': 'tr',
                'flag': 'tr'
            }
        };

        // Methods
        $scope.toggleSidenav = toggleSidenav;
        $scope.logout = DataF.logout;
        $scope.changeLanguage = changeLanguage;
        $scope.setUserStatus = setUserStatus;
        $scope.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
        $scope.toggleMsNavigationFolded = toggleMsNavigationFolded;
        $scope.search = search;
        $scope.searchResultClick = searchResultClick;
        $scope.redirectPrivacy = redirectPrivacys;

        //////////

        init();

        /**
         * Initialize
         */
        function init() {

            // Select the first status as a default
            $scope.userStatus = $scope.userStatusOptions[0];

            // Get the selected language directly from angular-translate module setting
            $scope.selectedLanguage = $scope.languages[$translate.preferredLanguage()];
        }


        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId, tab) {
            $mdSidenav(sidenavId).toggle();
        }

        function redirectPrivacys() {
            $scope.url = $window.open("https://tdsystem.software/Aviso-de-Privacidad.html", '_blank');
        }

        /**
         * Sets User Status
         * @param status
         */
        function setUserStatus(status) {
            $scope.userStatus = status;
        }

        /**
         * Logout Function
         */


        /**
         * Change Language
         */
        function changeLanguage(lang) {
            $scope.selectedLanguage = lang;

            /**
             * Show temporary message if user selects a language other than English
             *
             * angular-translate module will try to load language specific json files
             * as soon as you change the language. And because we don't have them, there
             * will be a lot of errors in the page potentially breaking couple functions
             * of the template.
             *
             * To prevent that from happening, we added a simple "return;" statement at the
             * end of this if block. If you have all the translation files, remove this if
             * block and the translations should work without any problems.
             */
            if (lang.code !== 'en') {
                var message = 'Fuse supports translations through angular-translate module, but currently we do not have any translations other than English language. If you want to help us, send us a message through ThemeForest profile page.';

                $mdToast.show({
                    template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                    hideDelay: 7000,
                    position: 'top right',
                    parent: '#content'
                });

                return;
            }

            // Change the language
            $translate.use(lang.code);
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu() {
            $scope.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }

        /**
         * Toggle msNavigation folded
         */
        function toggleMsNavigationFolded() {
            msNavigationService.toggleFolded();
            $localStorage.config.menuFolded = (AppF.folded) ? false : true;
            //console.log($localStorage.config.menuFolded, "storage");
        }

        /**
         * Search action
         *
         * @param query
         * @returns {Promise}
         */
        function search(query) {
            var navigation = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for (var x = 0; x < flatNavigation.length; x++) {
                if (flatNavigation[x].uisref) {
                    navigation.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the navigation;
            // otherwise we will return the entire navigation
            // list. Not exactly a good thing to do but it's
            // for demo purposes.
            if (query) {
                navigation = navigation.filter(function (item) {
                    if (angular.lowercase(item.title).search(angular.lowercase(query)) > -1) {
                        return true;
                    }
                });
            }

            // Fake service delay
            $timeout(function () {
                deferred.resolve(navigation);
            }, 1000);

            return deferred.promise;
        }

        /**
         * Search result click action
         *
         * @param item
         */
        function searchResultClick(item) {
            // If item has a link
            if (item.uisref) {
                // If there are state params,
                // use them...
                if (item.stateParams) {
                    $state.go(item.state, item.stateParams);
                } else {
                    $state.go(item.state);
                }
            }
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('fuse')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController() {
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }

})();
(function() {
    'use strict';

    angular
        .module('app.navigation')
        .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController($scope, $localStorage, $log, AppF) {
        // Data
        $scope.bodyEl = angular.element('body');
        AppF.folded = $localStorage.config.menuFolded;
        $scope.msScrollOptions = {
            suppressScrollX: true
        };

        // Methods
        $scope.toggleMsNavigationFolded = function() {
            AppF.folded = !AppF.folded;
            $localStorage.config.menuFolded = AppF.folded;
            $log.debug($localStorage.config.menuFolded, "storage")
        }

        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function() {
            $scope.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
        });
    }

})();
(function() {
    'use strict';

    angular
        .module('app.quick-panel')
        .directive('chatTab', chatTab);
    
    function chatTab() {
        var directive = {
            restrict: 'EA',
            controller:'ChatTabController',
            replace: false,
            templateUrl: 'app/quick-panel/tabs/chat/chat-tab.html'
        };
        return directive;
    }
})();
(function () {
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('QuickPanelController', QuickPanelController);

    /** @ngInject */
    function QuickPanelController(
        $rootScope,
        $scope,
        $log,
        $state,
        AppF,
        DataF,
        errAlertS,
        startAfterInitFilter,
        refToStateFilter
    ) {
        $scope.listWatchers = {};
        var initiated = false;
        $scope.currentPage = 1;
        $scope.date = moment().toDate();
        $scope.F = AppF;
        $scope.M = DataF;
        function init() {
            initiated = true;
            $scope.loadLogs();
        }

        $scope.loadLogs = function () {
            $rootScope.loadingProgress = true;

            AppF.root.child('/catalogs/changeLogs/collection').once('value')
                .then(function (snap) {
                    var logs = [];
                    if (snap && snap.exists && snap.exists()) {
                        snap.forEach(function (child) {
                            var val = child.val() || {};
                            var messages = angular.isArray(val.message)
                                ? val.message
                                : (val.message ? [val.message] : [])

                            logs.push({
                                $id: child.key,
                                atTime: val.atTime || null,
                                version: val.version || '',
                                messages: messages// <- arreglo normalizado
                            })
                        });
                    }

                    // ordenar por fecha descendente
                    logs.sort(function (a, b) { return (b.atTime || 0) - (a.atTime || 0); });
                    $log.log('console', logs)
                    AppF.logs = logs;
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                })
                .catch(function (err) {
                    errAlertS(err);
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync();
                });
        };



        $scope.goToLogRef = function (ref) {
            var state = refToStateFilter(ref);
            $log.debug('Going to ref state', ref, state);
            if (state.hasOwnProperty('params')) {
                $state.go(state.state, state.params);
            } else {
                $state.go(state);
            }
        };
        startAfterInitFilter($scope, $scope.listWatchers, initiated, init);
    }

})();
(function() {
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig) {

        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if (fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile()) {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if (msUtils.isMobile()) {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if (browserInfo) {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .config(config);

    angular.module('app.core').constant('angularMomentConfig', {
        locale: "es",
        timezone: 'America/Bogota'
    });


    /** @ngInject */
    function config(
        $ariaProvider,
        $logProvider,
        msScrollConfigProvider,
        $translateProvider,
        $provide,
        fuseConfigProvider
    ) {
        // Enable debug logging

        // oldTimeZOne America/Bogota|BMT -05 -04|4U.g 50 40|0121|-2eb73.I 38yo3.I 2en0|90e5
        $logProvider.debugEnabled(window.__env.enableDebug);
        moment.tz.setDefault('America/Bogota');
        // uiGmapgoogle-maps configuration
        // uiGmapGoogleMapApiProvider.configure({
        //     //    key: 'your api key',
        //     v        : '3.exp',
        //     libraries: 'weather,geometry,visualization'
        // });

        // angular-translate configuration

        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/i18n/{lang}.json'
        });
        $translateProvider.preferredLanguage('es');
        $translateProvider.useSanitizeValueStrategy('sanitize');

        $provide.decorator('dateFilter', ['$delegate', function ($delegate) {
            var DEFAULT_TIMEZONE = '-05';
            var oldDelegate = $delegate;
            var standardDateFilterInterceptor = function (date, format, timezone) {
                if (angular.isUndefined(timezone)) {
                    timezone = DEFAULT_TIMEZONE;
                }
                return oldDelegate.apply(this, [date, format, timezone]);
            };
            return standardDateFilterInterceptor;
        }]);

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });
        // Text Angular options
        $provide.decorator('taOptions', [
            '$delegate', function (taOptions) {
                taOptions.toolbar = [
                    ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'pre', 'quote', 'justifyLeft', 'justifyCenter', 'justifyRight', 'indent', 'outdent'],
                    ['bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol', 'redo', 'undo', 'clear','html'],
                ];

                taOptions.classes = {
                    focussed: 'focussed',
                    toolbar: 'ta-toolbar',
                    toolbarGroup: 'ta-group',
                    toolbarButton: 'md-button',
                    toolbarButtonActive: 'active',
                    disabled: '',
                    textEditor: 'form-control',
                    htmlEditor: 'form-control'
                };

                return taOptions;
            }
        ]);

        // Text Angular tools
        $provide.decorator('taTools', [
            '$delegate', function (taTools) {
                taTools.quote.iconclass = 'icon-format-quote';
                taTools.bold.iconclass = 'icon-format-bold';
                taTools.italics.iconclass = 'icon-format-italic';
                taTools.underline.iconclass = 'icon-format-underline';
                taTools.strikeThrough.iconclass = 'icon-format-strikethrough';
                taTools.ul.iconclass = 'icon-format-list-bulleted';
                taTools.ol.iconclass = 'icon-format-list-numbers';
                taTools.redo.iconclass = 'icon-redo';
                taTools.undo.iconclass = 'icon-undo';
                taTools.clear.iconclass = 'icon-close-circle-outline';
                taTools.justifyLeft.iconclass = 'icon-format-align-left';
                taTools.justifyCenter.iconclass = 'icon-format-align-center';
                taTools.justifyRight.iconclass = 'icon-format-align-right';
                taTools.justifyFull.iconclass = 'icon-format-align-justify';
                taTools.indent.iconclass = 'icon-format-indent-increase';
                taTools.outdent.iconclass = 'icon-format-indent-decrease';
                taTools.html.iconclass = 'icon-code-tags';
                taTools.insertImage.iconclass = 'icon-file-image-box';
                taTools.insertLink.iconclass = 'icon-link';
                taTools.insertVideo.iconclass = 'icon-filmstrip';

                return taTools;
            }
        ]);


        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars': false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile': true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        /*eslint-enable */
    }
    angular.module("ngLocale", [], ["$provide", function ($provide) {
        var PLURAL_CATEGORY = {
            ZERO: "zero",
            ONE: "one",
            TWO: "two",
            FEW: "few",
            MANY: "many",
            OTHER: "other"
        };
        $provide.value("$locale", {
            "DATETIME_FORMATS": {
                "AMPMS": [
                    "a. m.",
                    "p. m."
                ],
                "DAY": [
                    "domingo",
                    "lunes",
                    "martes",
                    "mi\u00e9rcoles",
                    "jueves",
                    "viernes",
                    "s\u00e1bado"
                ],
                "ERANAMES": [
                    "antes de Cristo",
                    "despu\u00e9s de Cristo"
                ],
                "ERAS": [
                    "a. C.",
                    "d. C."
                ],
                "FIRSTDAYOFWEEK": 6,
                "MONTH": [
                    "enero",
                    "febrero",
                    "marzo",
                    "abril",
                    "mayo",
                    "junio",
                    "julio",
                    "agosto",
                    "septiembre",
                    "octubre",
                    "noviembre",
                    "diciembre"
                ],
                "SHORTDAY": [
                    "dom.",
                    "lun.",
                    "mar.",
                    "mi\u00e9.",
                    "jue.",
                    "vie.",
                    "s\u00e1b."
                ],
                "SHORTMONTH": [
                    "ene",
                    "feb",
                    "mar",
                    "abr",
                    "may",
                    "jun",
                    "jul",
                    "ago",
                    "sep",
                    "oct",
                    "nov",
                    "dic"
                ],
                "STANDALONEMONTH": [
                    "enero",
                    "febrero",
                    "marzo",
                    "abril",
                    "mayo",
                    "junio",
                    "julio",
                    "agosto",
                    "septiembre",
                    "octubre",
                    "noviembre",
                    "diciembre"
                ],
                "WEEKENDRANGE": [
                    5,
                    6
                ],
                "fullDate": "EEEE, d 'de' MMMM 'de' y",
                "longDate": "d 'de' MMMM 'de' y",
                "medium": "dd/MM/y HH:mm:ss",
                "mediumDate": "dd/MM/y",
                "mediumTime": "HH:mm:ss",
                "short": "dd/MM/yy HH:mm",
                "shortDate": "dd/MM/yy",
                "shortTime": "HH:mm"
            },
            "NUMBER_FORMATS": {
                "CURRENCY_SYM": "$",
                "DECIMAL_SEP": ".",
                "GROUP_SEP": ",",
                "PATTERNS": [{
                    "gSize": 3,
                    "lgSize": 3,
                    "maxFrac": 3,
                    "minFrac": 0,
                    "minInt": 1,
                    "negPre": "-",
                    "negSuf": "",
                    "posPre": "",
                    "posSuf": ""
                },
                {
                    "gSize": 3,
                    "lgSize": 3,
                    "maxFrac": 2,
                    "minFrac": 2,
                    "minInt": 1,
                    "negPre": "-\u00a4",
                    "negSuf": "",
                    "posPre": "\u00a4",
                    "posSuf": ""
                }
                ]
            },
            "id": "es-mx",
            "localeID": "es_MX",
            "pluralCat": function (n, opt_precision) {
                if (n == 1) {
                    return PLURAL_CATEGORY.ONE;
                }
                return PLURAL_CATEGORY.OTHER;
            }
        });
    }])
})();
(function () {
    'use strict';

    angular
        .module('fuse')
        .run(runBlock);

    /** @ngInject */
    function runBlock(
        $rootScope,
        $timeout,
        $state,
        loginRedirectPath,
        AppF,
        RoutesF,
        $log,
        allowedOfflineStates,
        $sessionStorage,
        $http,
        userHasPermissionFilter,
        getMenuItemFromStateFilter,
        $window,
        getFromObjectFilter,
        errAlertS
    ) {
        $sessionStorage.loggedIn = $sessionStorage.loggedIn ? $sessionStorage.loggedIn : false;
        var changeByTokenRefresh = false;
        $sessionStorage.tokenSetted = false;
        AppF.essentialLoaded = false;
        // initialize firebase app
        firebase.initializeApp($window.__env.FB_CONFIG);
        AppF.root = firebase.database().ref('/');
        function refreshToken(time, getNew) {
            var refresh = function () {
                if (!AppF.user) {
                    return;
                }
                AppF.user.getIdToken(false).then(function (token) {
                    var x = '';
                    $http.defaults.headers.common.Authorization = x + token;
                    $sessionStorage.tokenSetted = true;
                    if (getNew) {
                        $log.debug('se refresco el token');
                        changeByTokenRefresh = true;
                    }
                    var userJson = angular.fromJson(angular.toJson(AppF.user));
                    var expirationTime = angular.isDefined(userJson.stsTokenManager.expirationTime) ? userJson.stsTokenManager.expirationTime : 1800000;
                    expirationTime = moment(expirationTime);
                    var now = moment();
                    var time = expirationTime.diff(now);
                    time -= 300000;
                    refreshToken(time, true, false);
                }, function (err) {
                    $log.error(err);
                });
            };
            $timeout(refresh, time, false);
        }
        function isPermitted(route) {
            return (allowedOfflineStates.indexOf(route) !== -1);
        }
        function buildModernLoginUrl() {
            var loginAppUrl = $window.__env.loginAppUrl || 'http://localhost:4200';
            var requestedCenter = ($window.center || 'tds').toLowerCase();
            return loginAppUrl + '?subdomain=' + encodeURIComponent(requestedCenter);
        }
        function redirectToModernLogin(e) {
            e.preventDefault()
            $window.location.replace(buildModernLoginUrl());
        }
        function validateUser() {
            var loginStatus;
            var user = AppF.user;
            if (AppF.userBlocked && !angular.isObject(user)) {
                loginStatus = 'blocked';
            } else if (changeByTokenRefresh) {
                changeByTokenRefresh = false;
                loginStatus = 'valid';
            } else if (angular.isObject(user)) {
                loginStatus = 'valid';
                if (!$sessionStorage.tokenSetted) {
                    refreshToken(0, false, true);
                }
            } else {
                loginStatus = 'none';
            }
            return loginStatus;
        }
        function logState(toStateN, toParams) {
            AppF.active.menuItem = getMenuItemFromStateFilter(toStateN);
            AppF.active.menuState = toStateN;
            AppF.active.menuParams = (toParams) ? toParams : {};
            AppF.active.menuName = getMenuItemFromStateFilter(toStateN, 'name'); // employees
            AppF.active.menuObjName = AppF.active.menuName.slice(0, -1);
            AppF.active.typeOfCatalog = (RoutesF.fbCatalogs.indexOf(AppF.active.menuName) !== -1) ? 'fb' : 'mongo';
            AppF.active.menuRef = false;
            AppF.active.filter = false;
            AppF.active['$$filter'] = false;
            AppF.active.$filter = false;
            AppF.active.filters = false;
            AppF.active.$filters = false;
            AppF.active.moreColumns = {};
            AppF.active.$filtersConfig = {};
            delete AppF.active.tabs;
            delete AppF.active.$filtersUse;
            delete AppF.active.$generalFilter;
            delete AppF.active.disableSearchBar;
            if (angular.isDefined(RoutesF.states[AppF.active.typeOfCatalog]) && angular.isDefined(RoutesF.states[AppF.active.typeOfCatalog][AppF.active.menuName])) {
                AppF.active.filter = getFromObjectFilter(RoutesF.states[AppF.active.typeOfCatalog][AppF.active.menuName], 'filter', false, true);
                if (RoutesF.dinamicRefs[AppF.active.menuName]) {
                    AppF.active.menuRef = RoutesF.constructDinamicRef(AppF.active.menuName, AppF.active.filter, {});
                }
                AppF.active['$$filter'] = getFromObjectFilter(RoutesF.states[AppF.active.typeOfCatalog][AppF.active.menuName], '$$filter', false, true);
                AppF.active.$filter = getFromObjectFilter(RoutesF.states[AppF.active.typeOfCatalog][AppF.active.menuName], '$filter', false, true);
                AppF.active.filters = getFromObjectFilter(RoutesF.states[AppF.active.typeOfCatalog][AppF.active.menuName], 'filters', false, true);
                AppF.active.$filters = getFromObjectFilter(RoutesF.states[AppF.active.typeOfCatalog][AppF.active.menuName], '$filters', false, true);
                AppF.active.moreColumns = getFromObjectFilter(RoutesF.states[AppF.active.typeOfCatalog][AppF.active.menuName], 'moreColumns', {}, true);
                AppF.active.$filtersConfig = getFromObjectFilter(RoutesF.states[AppF.active.typeOfCatalog][AppF.active.menuName], '$filtersConfig', {}, true);
                AppF.active.tabs = getFromObjectFilter(RoutesF.states[AppF.active.typeOfCatalog][AppF.active.menuName], 'tabs', undefined, true);
                AppF.active.$filtersUse = getFromObjectFilter(RoutesF.states[AppF.active.typeOfCatalog][AppF.active.menuName], '$filtersUse', undefined, true);
                AppF.active.$generalFilter = getFromObjectFilter(RoutesF.states[AppF.active.typeOfCatalog][AppF.active.menuName], '$generalFilter', undefined, true);
                AppF.active.$alias = getFromObjectFilter(RoutesF.states[AppF.active.typeOfCatalog][AppF.active.menuName], '$alias', undefined, true);
                AppF.active.disableSearchBar = getFromObjectFilter(RoutesF.states[AppF.active.typeOfCatalog][AppF.active.menuName], 'disableSearchBar', undefined, true);
                AppF.active.apiVersion = getFromObjectFilter(RoutesF.states[AppF.active.typeOfCatalog][AppF.active.menuName], 'apiVersion', undefined, true);
                AppF.active.fixedFieldsSearch = getFromObjectFilter(RoutesF.states[AppF.active.typeOfCatalog][AppF.active.menuName], 'fixedFieldsSearch', undefined, true);
            }
            AppF.active.formName = 'form';
            AppF.active.menuParent = getMenuItemFromStateFilter(toStateN, 'parent');
            AppF.addMode = (AppF.active.menuParams[AppF.active.menuObjName + 'Id'] === 'new' || AppF.active.menuParams[AppF.active.$alias + 'Id'] === 'new');
            AppF.active.menuAction = getMenuItemFromStateFilter(toStateN, 'action', AppF.active.typeOfCatalog, AppF.addMode);
            AppF.readMode = (AppF.active.menuAction === 'read');
            AppF.active.imageName = false;
            for (var imageNameP in AppF.imageName) {
                if (AppF.imageName[imageNameP].indexOf(AppF.active.menuName) > -1) {
                    AppF.active.imageName = imageNameP;
                }
            }
        }
        function blockedOrNoneFn(toState, toParams, e) {
            $log.debug(toState.name);
            redirectToModernLogin(e);
        }
        function hasPermission(route, params, e) {
            var has = false;
            var menuAction = $rootScope.F.active.menuAction === 'list' ? 'access' : angular.fromJson(angular.toJson($rootScope.F.active.menuAction));
            var permission = userHasPermissionFilter(AppF.groupsOfUser, AppF.permissions, menuAction, $rootScope.F.active.menuItem, 0);
            if (permission === false || permission === 0) {
                $log.debug(route, permission, AppF.groupsOfUser, AppF.permissions, menuAction, 'Redirecting to 403');
                e.preventDefault();
                $state.go('app.pages_errors_error-403');
            } else {
                has = true;
                $sessionStorage.lastState = route;
                $sessionStorage.lastParams = params;
                $log.debug('Set in $sessionStorage, Everything is OK redirecting to:', route, AppF.active.menuItem);
            }
            return has;
        }
        var loginActions = {
            blocked: blockedOrNoneFn,
            none: blockedOrNoneFn,
            valid: function (toState, toParams, e) {
                if (toState.name === 'app.pages_auth_login') {
                    e.preventDefault();
                    AppF.goToInitialState();
                } else {
                    logState(toState.name, toParams, e);
                    hasPermission(toState.name, toParams, e);
                    $log.debug('Going to', toState.name)
                    $log.debug('emitting initIndex');
                    $rootScope.$emit('initIndex');
                }
            }
        };
        function goNext(e, toState, toParams) {
            $log.debug(toState.name, $window.center, $window.__env.mode, AppF.centerData)
            var isPermiteddFlag = isPermitted(toState.name);
            var centersAllowed = AppF.profile && angular.isObject(AppF.profile.centers) ? AppF.profile.centers : [];
            var profileCenter = AppF.profile && angular.isString(AppF.profile.center) ? AppF.profile.center : '';
            if (toState.name === 'app.pages_auth_login') {
                redirectToModernLogin(e);
            } else if (angular.isUndefined(AppF.centerData) || AppF.centerData == null || !AppF.centerData.enabled) {
                redirectToModernLogin(e);
            } else if (AppF.profile && profileCenter !== $window.center && centersAllowed.indexOf($window.center) === -1) {
                e.preventDefault();
                AppF.logout();
                errAlertS('No puede acceder a este Centro de Trabajo');
            } else if (!isPermiteddFlag) {
                var userType = validateUser();
                $log.debug('userType:', userType, toState.name);
                loginActions[userType](toState, toParams, e);
            }
        }
        var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function (e, toState, toParams, fromState) {
            $log.debug(toState.name, AppF.essentialLoaded, fromState.name);
            // El login legado debe cancelarse de inmediato. Si esperamos a
            // firstLoading, UI-Router alcanza a renderizar su plantilla antes
            // de enviar al usuario al portal de autenticación moderno.
            if (toState.name === 'app.pages_auth_login') {
                redirectToModernLogin(e);
                return;
            }
            if (AppF.essentialLoaded) {
                goNext(e, toState, toParams)
            } else {
                var firstLoading = $rootScope.$on('firstLoading', function () {
                    $log.debug('firstLoading called')
                    firstLoading();
                    goNext(e, toState, toParams)
                })
            }
        });
        function login(ev, params) {
            AppF.userChecked = true;
            AppF.user = params.user;
            AppF.getRootData(params.token).then(function () {
                AppF.goToInitialState();
            }).catch();
        }
        var loggedIn = $rootScope.$on('loggedIn', login);
        var loggedOut = $rootScope.$on('loggedOut', AppF.logout);
        $rootScope.state = $state;
        $rootScope.$on('$destroy', function () {
            stateChangeStartEvent();
            loggedIn();
            loggedOut();
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('fuse')
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider) {
        $locationProvider.html5Mode(true);

        $urlRouterProvider.when('/', '/pages/auth/login');
        $urlRouterProvider.otherwise('/captures/employees/');

        /**
         * Layout Style Switcher
         *
         * This code is here for demonstration purposes.
         * If you don't need to switch between the layout
         * styles like in the demo, you can set one manually by
         * typing the template urls into the `State definitions`
         * area and remove this code
         */
        // Inject $cookies
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies) {
                $cookies = _$cookies;
            }
        ]);

        // Get active layout
        var layoutStyle = 'verticalNavigationFullwidthToolbar2';//$cookies.get('layoutStyle') || 'verticalNavigation';

        var layouts = {
            verticalNavigation: {
                main: 'app/core/layouts/vertical-navigation.html',
                toolbar: 'app/toolbar/layouts/vertical-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationFullwidthToolbar: {
                main: 'app/core/layouts/vertical-navigation-fullwidth-toolbar.html',
                toolbar: 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationFullwidthToolbar2: {
                main: 'app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html',
                toolbar: 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html'
            },
            horizontalNavigation: {
                main: 'app/core/layouts/horizontal-navigation.html',
                toolbar: 'app/toolbar/layouts/horizontal-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/horizontal-navigation/navigation.html'
            },
            contentOnly: {
                main: 'app/core/layouts/content-only.html',
                toolbar: '',
                navigation: ''
            },
            contentWithToolbar: {
                main: 'app/core/layouts/content-with-toolbar.html',
                toolbar: 'app/toolbar/layouts/content-with-toolbar/toolbar.html',
                navigation: ''
            }
        };
        // END - Layout Style Switcher

        // State definitions
        $stateProvider
            .state('app', {
                abstract: true,
                resolve: {
                    main: function (AppF) {
                        return AppF.getRootData();
                    }
                },
                views: {
                    'main@': {
                        templateUrl: layouts[layoutStyle].main,
                        controller: 'MainController as vm'
                    },
                    'toolbar@app': {
                        templateUrl: layouts[layoutStyle].toolbar,
                        controller: 'ToolbarController as vm'
                    },
                    'navigation@app': {
                        templateUrl: layouts[layoutStyle].navigation,
                        controller: 'NavigationController as vm'
                    },
                    'quickPanel@app': {
                        templateUrl: 'app/quick-panel/quick-panel.html',
                        controller: 'QuickPanelController as vm'
                    }
                }
            });
    }

})();
(function () {
    'use strict';

    angular
        .module('fuse')
        .factory('AppF', AppF);

    function AppF(
        $state,
        $http,
        $filter,
        $timeout,
        $sessionStorage,
        $localStorage,
        $rootScope,
        $templateRequest,
        $sce,
        $q,
        successAlertS,
        errAlertS,
        $log,
        $firebaseObject,
        $interpolate,
        infoAlertS,
        initialState,
        $window,
        getArrayOfIdsFilter,
        $firebaseAuth,
        msNavigationService,
        loginRedirectPath
    ) {
        function buildModernLoginUrl() {
            var loginAppUrl = $window.__env.loginAppUrl || 'http://localhost:4200';
            console.log("loginAppUrl", loginAppUrl)
            var requestedCenter = ($window.center || 'tds').toLowerCase();
            console.log("requestedCenter", requestedCenter)
            return loginAppUrl + '?subdomain=' + encodeURIComponent(requestedCenter);
        }
        var cats = {
            operationTypesRelaxed: ['asimilated', 'special', 'travelExpensesOpe', 'advAndLoanOpe'],
            contractVariables: [
                'nombre', 'fecha_de_inicio', 'fecha_de_nacimiento', 'rp', 'Centro de costos', 'curp', 'edad', 'telefono', 'sexo', 'rfc', 'cveNacionalidad', 'diaNacimiento',
                'mesNacimiento', 'añoNacimiento', 'sd', 'sueldo_en_numero', 'sueldo_en_letra', 'frecuencia', 'aguinaldo', 'dia_de_antiguedad', 'mes_de_antiguedad', 'año_de_antiguedad',
                'estado_civil', 'puesto', 'puestoDescripcion', 'tipo_de_via', 'nombre_de_la_calle', 'numero', 'colonia', 'estado', 'municipio', 'codigo_postal', 'beneficiario', 'beneficiarios',
                'razon_social', 'representante', 'representante2', 'duracion', 'domicilio_empresa', 'rfc_empresa', 'ciudad_empresa', 'estado_empresa', 'firma_representante', 'estado_lugar_de_trabajo',
                'lugar_de_trabajo', 'dia_de_termino', 'mes_de_termino', 'año_de_termino', 'nss', 'email', 'objeto', 'motivo', 'persona_sustituida', 'dia_de_firma', 'mes_de_firma', 'año_de_firma', 'cp_sat'
            ],
            incapacityTypes: [
                { id: 'initial', name: 'Inicial' },
                { id: 'unique', name: 'Única' },
                { id: 'subsequent', name: 'Subsecuente' }
            ],
            documentTypes: [
                { id: 'contract', name: 'Contrato' },
                { id: 'saludRecord', name: 'Hoja de Salud' },
                { id: 'generalsRequired', name: 'Generales Requeridos' },
                { id: 'generals', name: 'Generales' }
            ],
            cyvMeasures: [
                { obj: 'uma', name: 'UMA' },
                { obj: 'minimumWage', name: 'Salario Mínimo' }
            ],
            eventTypes: [
                { id: 1, name: 'Aniversario', realName: 'Aniversario', property: 'earned' },
                { id: 2, name: 'Prescrito', realName: 'Prescrito', property: 'prescribed' },
                { id: 3, name: 'Ajuste(Ganadas)', realName: 'Ajuste', property: 'earned' },
                { id: 4, name: 'Ajuste(Disfrutadas)', realName: 'Ajuste', property: 'enjoyed' }
            ],
            contractSatTypes: [
                { id: '01', name: 'Contrato de trabajo por tiempo indeterminado', workerType: 1 },
                { id: '02', name: 'Contrato de trabajo para obra determinada', workerType: 3 },
                { id: '03', name: 'Contrato de trabajo por tiempo determinado', workerType: 2 },
                { id: '04', name: 'Contrato de trabajo por temporada', workerType: 2 },
                { id: '05', name: 'Contrato de trabajo sujeto a prueba', workerType: 2 },
                { id: '06', name: 'Contrato de trabajo con capacitación inicial', workerType: 1 },
                { id: '07', name: 'Modalidad de contratación por pago de hora laborada', workerType: 2 },
                { id: '08', name: 'Modalidad de trabajo por comisión laboral', workerType: 2 }
            ],
            sentStatuses: [
                { id: "sent", name: "Enviado" },
                { id: "delivered", name: "Entregado" },
                { id: "complained", name: "Reportado" },
                { id: "permanent_fail", name: "Permanentemente rechazado" },
                { id: "temporary_fail", name: "Temporalmente rechazado" },
                { id: "sentBySmtp", name: "Enviado por SMTP" },
                { id: "failed", name: "Rechazado" },
                { id: "queueForSend", name: "En cola para envio" },
                { id: "queuefail", name: "Error al añadir a la cola" },
                { id: "emailBlackListed", name: "Se encuentra en lista negra el correo" }

            ],
            opeFilesName: {
                'ordinary': { fiscal: 'ORDINARI', socialPrevision: 'ALTER' },
                'asimilated': { fiscal: 'ASIM', socialPrevision: 'ASIM_ALT' },
                'advAndLoanOpe': { fiscal: 'ANT_PRES', socialPrevision: '' },
                'travelExpensesOpe': { fiscal: 'VIAT', socialPrevision: '' },
                'settlement': { fiscal: 'BAJA', socialPrevision: 'ALT_BAJA' },
                'chrisBonusRecord': { fiscal: 'AGUINALD', socialPrevision: 'AGUINALT' },
                'special': { fiscal: 'ESPECIAL', socialPrevision: 'SPECIALT' },
                'extraordinary': { fiscal: 'EXTRAORDINARIA', socialPrevision: 'ALTER_EXTRA' },
                'ptuRecord': { fiscal: 'PTU', socialPrevision: 'ALTER_PTU' },
                'ptuDistributionRecord:': { fiscal: 'PTU_DISTRIBUCIÓN' }
            },
            otherProcs: [{ id: "socialPrevision", name: "PREVISION" }, { id: "asimilated", name: "ASIMILADOS" }, { id: "fiscal", name: "FISCAL" }, { id: "ptuRecord", name: "PTU" }, { id: "ptuDistributionRecord", name: "Distribución PTU" }],
            hasSeniorityDateOptions: [{ id: true, value: 'Si' }, { id: false, value: 'No' }, { id: '{"$exists":false}', value: 'No asignado' }],
            inputTypes: { autocompleteM: { id: 'autocompleteM', value: 'AutoCompletar' }, date: { id: 'date', value: 'Fecha' }, textarea: { id: 'textarea', value: 'Texto Largo' }, number: { id: 'number', value: 'Numero' }, text: { id: 'text', value: 'Texto' }, alphanumeric: { id: 'alphanumeric', value: 'Alfanumérico' }, select: { id: 'select', value: 'Selector', values: true } },
            complementTypes: ['asimilated', 'socialPrevision'],
            processTypes: [{ id: 'asimilated', name: 'ASIMILADOS' }, { id: 'socialPrevision', name: 'COMPLEMENTO' }, { id: 'fiscal', name: 'FISCAL' }],
            contactTypes: ['Celular', 'Trabajo', 'Casa', 'Otro'],
            emailTypes: ['Personal', 'Trabajo'],
            creditTypes: ["porcentaje", "cuota fija", "vsm"],
            operationTypes: [
                { id: 'settlement', name: 'Finiquitos' },
                { id: 'special', name: 'Especiales' },
                { id: 'extraordinary', name: 'Extraordinaria' },
                { id: 'asimilated', name: 'Asimilados' },
                { id: 'advAndLoanOpe', name: 'Anticipos y prestamos' },
                { id: 'travelExpensesOpe', name: 'Viáticos' },
                { id: 'chrisBonusRecord', name: 'Aguinaldo' },
                { id: 'ptuRecord', name: 'PTU' },
                { id: 'ptuDistributionRecord', name: 'Distribución PTU' }
            ],
            xmlBillsRequestStatus: ["Con errores", "Terminado", "En proceso", "Analizando"],
            xmlBillsRequestResults: [null, "Ok", "No Sistema", "Con Diferencias", "No SAT"],
            processes: [{
                id: "fiscal",
                name: "Fiscal"
            },
            {
                id: "real",
                name: "Real"
            }, {
                id: "all",
                name: "Todos"
            },
            {
                id: "complement",
                name: "Complemento"
            }
            ],


            maritalStatuses: ['SOLTERO(A)', 'CASADO(A)', 'UNION LIBRE', 'VIUDO(A)', 'DIVORCIADO(A)', 'CONCUBINATO'],
            conceptTypes: [{ id: "payrollId", value: "Nómina" }, { id: "ccId", value: "Centros de Costo" }, { id: "groupId", value: "Agrupación" }, { id: "employeeId", value: "Empleado" }, { id: "custom", value: "Custom" }],
            operationDirectives: [{
                code: "001",
                name: "Directiva para calcular subsidio",
                selectable: false
            }, {
                code: "002",
                name: "Directiva para calcular el IMSS",
                selectable: false
            }, {
                code: "003",
                name: "Directiva para calcular finiquito",
                selectable: false
            }, {
                code: "004",
                name: "Directiva para calcular horas extras",
                selectable: false
            }, {
                code: "005",
                name: "Directiva para calcular ",
                selectable: false
            }],
            incidenceStatatuss: [
                { id: -5, name: "Pausada" },
                { id: -4, name: "Cancelada" },
                { id: -3, name: "con Problemas" },
                { id: -2, name: "sin Comprobante" },
                { id: -1, name: "En espera de Aprobación" },
                { id: 0, name: "Por aplicar" },
                { id: 1, name: "En revision" },
                { id: 2, name: "En revision por ejecutivo" },
                { id: 3, name: "Aplicada" }
            ],
            employeeStatuss: [{
                id: 1,
                name: 'Revisando'
            },
            {
                id: 2,
                name: 'Enviando'
            },
            {
                id: 2.1,
                name: 'Enviando Variable'
            },
            {
                id: 3,
                name: 'Recibiendo'
            },
            {
                id: 3.5,
                name: 'Rechazado'
            }, {
                id: 4,
                name: 'OK'
            }, {
                id: 5,
                name: 'de Baja'
            }
            ],
            opstatusByEmployeeStatus: {
                '3': 3,
                '2': 2.5,
                '1': 2
            },
            actions: [{
                id: 'add',
                name: 'Agregar'
            }, {
                id: 'update',
                name: 'Editar'
            }, {
                id: 'remove',
                name: 'Eliminar'
            }, {
                id: 'sendNotificationEmail',
                name: 'Envió de corros'
            }],
            constantTypes: {
                automaticApply: {
                    name: 'Aplicación Automática',
                    description: 'Se aplican las incidencias con una periodicidad, opcionalmente se puede seleccionar una fecha inicial y una final',
                    forOpeConstants: true
                },
                affectIncidenceValue: {
                    name: 'Afectar el Valor de incidencia',
                    description: 'Cuando existan incidencias manuales, rápidas o programadas, el sistema revisará si hay constantes de éste tipo y afectará su valor final con un operador matemático'
                },
                affectIncidenceProperty: { // @todo:carlos poner TODAS las propiedades en el mapa
                    name: 'Afectar Propiedad de Cálculo',
                    description: 'Cuando existan incidencias manuales, rápidas o programadas, el sistema revisará si hay constantes de éste tipo y afectará alguno de sus valores para el calculo con un operador matemático'
                },
                notApply: {
                    name: 'No aplicar Incidencia',
                    description: 'A los parámetros dictados en la constante, no se le aplicará la incidencia (cuando haya)',
                    forOpeConstants: true
                },
                customField: {
                    name: 'Campo personalizado',
                    forOpeConstants: true
                },
                applyVariable: {
                    name: 'Aplicar Variable',
                    description: 'Aplicar este concepto para las variables',
                    forOpeConstants: true,
                    onlyOn: ['payroll']
                },
                notApplyVariable: {
                    name: 'No Aplicar Variable',
                    description: 'No aplicar este concepto para las variables',
                    forOpeConstants: true,
                    onlyOn: ['payroll']
                }
            },
            oldDefaultHolidaysTable: [{
                limit: 1,
                value: 6
            },
            {
                limit: 2,
                value: 8
            },
            {
                limit: 3,
                value: 10
            },
            {
                limit: 4,
                value: 12
            },
            {
                limit: 9,
                value: 14
            },
            {
                limit: 14,
                value: 16
            },
            {
                limit: 19,
                value: 18
            },
            {
                limit: 24,
                value: 20
            },
            {
                limit: 29,
                value: 22
            },
            {
                limit: 34,
                value: 24
            },
            {
                limit: 39,
                value: 26
            },
            {
                limit: 44,
                value: 28
            },
            {
                limit: 49,
                value: 30
            },
            {
                limit: 54,
                value: 32
            },
            {
                limit: 55,
                value: 34
            }],
            //defaultHolidaysTable: [6, 8, 10, 12, 14, 14, 14, 14, 14, 16, 16, 16, 16, 16, 18, 18, 18, 18, 18, 20, 20, 20, 20, 20, 22, 22, 22, 22, 22, 24, 24, 24, 24, 24, 26, 26, 26, 26, 26, 28, 28, 28, 28, 28, 30, 30, 30, 30, 30, 32, 32, 32, 32, 32, 34, 34, 34, 34, 34],
            defaultHolidaysTable: [{
                limit: 1,
                value: 12
            },
            {
                limit: 2,
                value: 14
            },
            {
                limit: 3,
                value: 16
            },
            {
                limit: 4,
                value: 18
            },
            {
                limit: 5,
                value: 20
            },
            {
                limit: 10,
                value: 22
            },
            {
                limit: 15,
                value: 24
            },
            {
                limit: 20,
                value: 26
            },
            {
                limit: 25,
                value: 28
            },
            {
                limit: 30,
                value: 30
            },
            {
                limit: 35,
                value: 32
            },
            {
                limit: 40,
                value: 34
            },
            {
                limit: 45,
                value: 36
            }],
            calcFieldsObjects: ['employee', 'payroll', 'operation', 'umaRecord', 'nfdRecord', 'minimumVariables', 'constants', 'amountObj'],
            periodicity: [{ id: 'anually', name: 'Anual' }, { id: 'monthly', name: 'Mensual' }, { id: 'biweekly', name: 'Quincenal', showOnPayroll: true }],
            creditStatuses: [{
                id: true,
                name: 'Vigente'
            }, {
                id: false,
                name: 'No vigente'
            }],
            contractStatuses: [{
                id: true,
                name: 'Activo'
            }, {
                id: false,
                name: 'No activo'
            }],
            loanStatuses: [{
                id: true,
                name: 'Vigente'
            }, {
                id: false,
                name: 'No vigente'
            }],
            movementTypes: [{
                id: 2,
                name: 'Baja',
                clave: '02-Baja'
            }, {
                id: 6,
                name: 'Alta',
                clave: '06-Alta Empresa'
            }, {
                id: 7,
                name: 'Mds',
                clave: '07-Modificación'
            }, {
                id: 8,
                name: 'Reingreso',
                clave: '08-Reingreso'
            }, {
                id: 10,
                name: 'Aniversario',
                clave: '10-Aniversarios'
            }],
            operationStatuss: [{
                id: -1, // created
                name: 'Sin Abrir',
                description: 'Operación automática, jamás abierta',
                icon: 'icon-lock'
            }, {
                id: 0, // cancelled
                name: 'Cancelada',
                description: 'Operación Cancelada',
                icon: 'icon-calendar-remove',
                class: 'cancelled'
            }, {
                id: 1, // opened
                name: 'Abierta',
                description: 'En espera de captura de incidencias del cliente, una vez capturadas el cliente mandará a revisión la operación',
                msg: 'Se abrirá la operación para poder capturar las incidencias',
                icon: 'icon-numeric-1-box',
                class: 'working'
            }, {
                id: 2, // requestedClient
                name: 'En revisión por cliente',
                description: 'Operación en revisión por un ejecutivo de cliente, cuando el ejecutivo del cliente termine mandará a revision',
                msg: 'Se mandara la operación a revisión por el cliente para validación de las incidencias',
                icon: 'icon-numeric-2-box',
                class: 'working'
            }, {
                id: 2.5, // requestedCenter
                name: 'En revisión por ejecutivo',
                description: 'Operación en revisión por un ejecutivo, cuando el ejecutivo termine mandará la pre-factura al cliente',
                msg: 'Se mandara la operación a revisión por el ejecutivo para validación de las incidencias',
                icon: 'icon-numeric-2-box',
                class: 'working'
            }, {
                id: 3, // reviewed
                name: 'Cerrada',
                description: 'Se ha mandado la prefactura al cliente, una vez autorizada se deberá hacer el pago correspondiente',
                msg: 'Se cerrara la operación y se guardara los cálculos de empleado',
                icon: 'icon-numeric-3-box',
                class: 'finished'
            }, {
                id: 4, // reviewed
                name: 'Timbrando...',
                description: 'Se están procesando los recibos fiscales de los empelados',
                msg: 'Se generaran los cfdis de cada empleado',
                icon: 'icon-numeric-4-box',
                class: 'finished'
            }, {
                id: 5, // reviewed
                name: 'Timbrado Parcialmente',
                description: 'Se termino la generación de los timbrados de los empleados pero con errores',
                msg: 'Se terminó la generación de los recibos de nomina pero con algunos errores',
                icon: 'icon-numeric-5-box',
                class: 'finished'
            }, {
                id: 6, // reviewed
                name: 'Timbrado Correctamente',
                description: 'Se termino la generación de los timbrados de los empleados satisfactoriamente',
                msg: 'Se terminó la generación de los recibos de nomina correctamente',
                icon: 'icon-numeric-6-box',
                class: 'finished'
            }, {
                id: 7, // reviewed
                name: 'Cerrada',
                description: 'Se cerro la operación, no es necesario generar recibos',
                msg: 'Se cerro la operación',
                icon: 'icon-numeric-7-box',
                class: 'finished'
            }
                // Real reviewed Status
                // , {
                //     id: 3, // reviewed
                //     name: 'Revizado, esperando Autorización de pre-factura',
                //     description: 'Se ha mandado la prefactura al cliente, una vez autorizada se deberá hacer el pago correspondiente',
                //     icon: 'icon-numeric-3-box',
                //     class: "finished"
                // }
                // , {
                //     id: 4, // authorized
                //     name: 'Pre-factura Autorizada, esperando Pago',
                //     description: 'El cliente ha autorizado la pre-factura, ahora deberá subir un documento de referencia del pago hecho',
                //     icon: 'icon-numeric-4-box'
                // }, {
                //     id: 5, // payed
                //     name: 'Esperando Confirmación del Pago',
                //     description: 'El cliente mandó el pago y un ejecutivo lo confirmará o no',
                //     icon: 'icon-numeric-5-box'
                // }, {
                //     id: 6, // confirmed
                //     name: 'Pago Confirmado',
                //     description: 'El pago fue confirmado, ahora la operación puede ser mandada a revisión',
                //     icon: 'icon-numeric-6-box'
                // }, {
                //     id: 7, // dispersed
                //     name: 'Mandado a Dispersión',
                //     description: 'La operación fue mandada a dispersión, se deberá notificar al cliente una vez realizada',
                //     icon: 'icon-numeric-7-box'
                // }, {
                //     id: 8, // notified
                //     name: 'Dispersada',
                //     description: 'La operación ha sido dispersada y el cliente notificado',
                //     icon: 'icon-numeric-8-box'
                // }, {
                //     id: 9, // archived
                //     name: 'Finalizada',
                //     description: 'La operación está ahora archivada',
                //     icon: 'icon-numeric-9-box'
                // }
            ]
        };

        var menuItems = {
            apps: {
                virtualXmlLogin: {
                    action: 'redirectVirtualXmlLogin',
                    icon: "icon-ticket",
                    menuItem: "apps.virtualXmlLogin",
                    state: "app.virtualXmlLogin",
                    title: "Asignación de Timbres",
                    alias: 'virtualXmlLogin',
                    weight: 3
                },
                timeAndAttendanceControlLogin: {
                    action: 'redirectTimeAndAttendanceControl',
                    icon: "icon-bell-ring",
                    menuItem: "apps.timeAndAttendanceControl",
                    state: "app.timeAndAttendanceControl",
                    title: "Control de Tiempo y Asistencia",
                    alias: 'timeAndAttendanceControlLogin',
                    weight: 1
                },
                guides: {
                    icon: "icon-clipboard-check",
                    action: 'redirectHelpCenter',
                    menuItem: "apps.guides",
                    state: "app.guides",
                    title: "Centro de Ayuda",
                    weight: 2
                },
                calendar: {
                    icon: "icon-calendar-today",
                    menuItem: "apps.calendar",
                    state: "app.calendar",
                    title: "Calendario",
                    weight: 3
                },
                tasks: {
                    icon: "icon-code-not-equal-variant",
                    menuItem: "apps.tasks",
                    state: "app.tasks",
                    title: "Tareas y Eventos",
                    weight: 3
                },
                dashboards_project: {
                    icon: "icon-hexagon",
                    menuItem: "apps.dashboards_project",
                    state: "app.dashboards_project",
                    title: "Dashboard Inicio",
                    weight: 4
                },
                "project-manager": {
                    icon: "icon-hexagon",
                    menuItem: "apps.project-manager",
                    state: "app.project-manager",
                    title: "Gestión de proyectos",
                    weight: 4
                },
                chat: {
                    badge: true,
                    icon: "icon-hangouts",
                    menuItem: "apps.chat",
                    state: "app.chat",
                    title: "Chat",
                    weight: 5,
                    hidden: true,
                    active: false
                },
                notes: {
                    icon: "icon-lightbulb",
                    menuItem: "apps.notes",
                    state: "app.notes",
                    title: "Notas",
                    hidden: true,
                    active: false,
                    weight: 6
                },
                "to-do": {
                    badge: true,
                    icon: "icon-checkbox-marked",
                    menuItem: "apps.to-do",
                    state: "app.to-do",
                    title: "To-Do",
                    hidden: true,
                    active: false,
                    weight: 7
                }
            },
            records: {
                imssRecords: {
                    icon: false,
                    menuItem: "catalogs.records.imssRecords",
                    state: "app.records.imssRecords",
                    title: "IMSS"
                },
                isrRecords: {
                    icon: false,
                    menuItem: "catalogs.records.isrRecords",
                    state: "app.records.isrRecords",
                    title: "ISR"
                },
                cyvRecords: {
                    icon: false,
                    menuItem: "catalogs.records.cyvRecords",
                    state: "app.records.cyvRecords",
                    title: "CYV"
                },
                minimumWageRecords: {
                    icon: false,
                    menuItem: "catalogs.records.minimumWageRecords",
                    state: "app.records.minimumWageRecords",
                    title: "Salarios Mínimos"
                },
                nfdRecords: {
                    icon: false,
                    menuItem: "catalogs.records.nfdRecords",
                    state: "app.records.nfdRecords",
                    title: "NFD"
                },
                subsidyRecords: {
                    icon: false,
                    menuItem: "catalogs.records.subsidyRecords",
                    state: "app.records.subsidyRecords",
                    title: "Subsidios"
                },
                umaRecords: {
                    icon: false,
                    menuItem: "catalogs.records.umaRecords",
                    state: "app.records.umaRecords",
                    title: "UMA"
                }
            },
            other: {
                banks: {
                    icon: false,
                    menuItem: "catalogs.other.banks",
                    state: "app.other.banks",
                    title: "Bancos",
                    weight: 1
                },
                bankAccounts: {
                    icon: false,
                    menuItem: "catalogs.other.bankAccounts",
                    state: "app.other.bankAccounts",
                    title: "Mis Bancos",
                    weight: 1
                },
                directives: {
                    icon: false,
                    menuItem: "catalogs.other.directives",
                    state: "app.other.directives",
                    title: "Directivas",
                    weight: 3
                },
                filters: {
                    icon: false,
                    menuItem: "catalogs.other.filters",
                    state: "app.other.filters",
                    title: "Filtros",
                    weight: 3
                },
                paymentForms: {
                    icon: false,
                    menuItem: "catalogs.other.paymentForms",
                    state: "app.other.paymentForms",
                    title: "Formas de Pago",
                    weight: 6
                },
                dismissTypes: {
                    icon: false,
                    menuItem: "catalogs.other.dismissTypes",
                    state: "app.other.dismissTypes",
                    title: "Tipos de Baja",
                    weight: 13
                },
                issuers: {
                    icon: false,
                    menuItem: "catalogs.other.issuers",
                    state: "app.other.issuers",
                    title: "Emisoras",
                    weight: 4
                },
                monthForAccumulatedRecords: {
                    icon: false,
                    menuItem: "catalogs.other.monthForAccumulatedRecords",
                    state: "app.other.monthForAccumulatedRecords",
                    title: "Meses para Acumulados",
                    weight: 8
                },
                paymentFrequenciesRecords: {
                    icon: false,
                    menuItem: "catalogs.other.paymentFrequenciesRecords",
                    state: "app.other.paymentFrequenciesRecords",
                    title: "Frecuencias de Pago",
                    weight: 6
                },
                paymentGroups: {
                    icon: false,
                    menuItem: "catalogs.other.paymentGroups",
                    state: "app.other.paymentGroups",
                    title: "Grupos de Pago",
                    weight: 7
                },
                regimes: {
                    icon: false,
                    menuItem: "catalogs.other.regimes",
                    state: "app.other.regimes",
                    title: "Regímenes",
                    weight: 10
                },
                relationships: {
                    icon: false,
                    menuItem: "catalogs.other.relationships",
                    state: "app.other.relationships",
                    title: "Parentescos",
                    weight: 9
                },
                societyTypes: {
                    icon: false,
                    menuItem: "catalogs.other.societyTypes",
                    state: "app.other.societyTypes",
                    title: "Tipos de Sociedad",
                    weight: 10
                },
                riskClassesRecords: {
                    icon: false,
                    menuItem: "catalogs.other.riskClassesRecords",
                    state: "app.other.riskClassesRecords",
                    title: "Clases de Riesgo",
                    weight: 2
                },
                streetTypes: {
                    icon: false,
                    menuItem: "catalogs.other.streetTypes",
                    state: "app.other.streetTypes",
                    title: "Tipos de Calle",
                    weight: 12
                },
                unions: {
                    icon: false,
                    menuItem: "catalogs.other.unions",
                    state: "app.other.unions",
                    title: "Sindicatos",
                    weight: 11
                },
                workDays: {
                    icon: false,
                    menuItem: "catalogs.other.workDays",
                    state: "app.other.workDays",
                    title: "Jornadas",
                    weight: 5
                },
                workerTypes: {
                    icon: false,
                    menuItem: "catalogs.other.workerTypes",
                    state: "app.other.workerTypes",
                    title: "Tipos de Empleado",
                    weight: 14
                }
            },
            locations: {
                countriesRecords: {
                    icon: false,
                    menuItem: "catalogs.locations.countriesRecords",
                    state: "app.locations.countriesRecords",
                    title: "Países",
                    weight: 4
                },
                geoZones: {
                    icon: false,
                    menuItem: "catalogs.locations.geoZones",
                    state: "app.locations.geoZones",
                    title: "Zonas Geográficas",
                    weight: 5
                },
                placesOfWorkRecords: {
                    icon: false,
                    menuItem: "catalogs.locations.placesOfWorkRecords",
                    state: "app.locations.placesOfWorkRecords",
                    title: "Lugares de Trabajo",
                    weight: 2
                },
                states: {
                    icon: false,
                    menuItem: "catalogs.locations.states",
                    state: "app.locations.states",
                    title: "Estados",
                    weight: 1
                },
                towns: {
                    icon: false,
                    menuItem: "catalogs.locations.towns",
                    state: "app.locations.towns",
                    title: "Municipios",
                    weight: 3
                },
                zipCodes: {
                    icon: false,
                    menuItem: "catalogs.locations.zipCodes",
                    state: "app.locations.zipCodes",
                    title: "Códigos Postales",
                    weight: 3
                },
                placeTypes: {
                    icon: false,
                    menuItem: "catalogs.locations.placeTypes",
                    state: "app.locations.placeTypes",
                    title: "Tipos de asentamiento",
                    weight: 5
                }
            },
            organization: {
                firms: {
                    icon: "icon-city",
                    menuItem: "clients.organization.firms",
                    state: "app.organization.firms",
                    title: "Clientes",
                    weight: 3
                },
                payrolls: {
                    icon: "icon-account-multiple-outline",
                    menuItem: "clients.organization.payrolls",
                    state: "app.organization.payrolls",
                    title: "Nóminas",
                    weight: 4
                },
                positions: {
                    icon: "icon-hexagon",
                    menuItem: "clients.organization.positions",
                    state: "app.organization.positions",
                    title: "Puestos",
                    weight: 7
                },
                departments: {
                    icon: "icon-hexagon",
                    menuItem: "clients.organization.departments",
                    state: "app.organization.departments",
                    title: "Departamentos",
                    weight: 6
                },
                rps: {
                    icon: "icon-account-switch",
                    menuItem: "clients.organization.rps",
                    state: "app.organization.rps",
                    title: "Registros Patronales",
                    weight: 2
                },
                ccs: {
                    icon: "icon-account-network",
                    menuItem: "clients.organization.ccs",
                    state: "app.organization.ccs",
                    title: "Centros de Costos",
                    weight: 6
                },
                companiesRecords: {
                    icon: "icon-alphabetical",
                    menuItem: "clients.organization.companies",
                    state: "app.organization.companiesRecords",
                    title: "Empresas",
                    weight: 1
                }

            },
            movements: {
                aniversaryRecords: {
                    icon: "icon-account-box",
                    menuItem: "clients.movements.aniversaryRecords",
                    state: "app.movements.aniversaryRecords",
                    title: "Aniversarios",
                    weight: 1
                },
                dismissesRecords: {
                    icon: "icon-account-box",
                    menuItem: "clients.movements.dismissesRecords",
                    state: "app.movements.dismissesRecords",
                    title: "Bajas",
                    weight: 4
                },
                idseAutoRecords: {
                    icon: "icon-account-box",
                    menuItem: "clients.movements.idseAutoRecords",
                    state: "app.movements.idseAutoRecords",
                    title: "IDSE Automático",
                    weight: 4
                },
                dismissesUnconfirmedRecords: {
                    icon: "icon-pin",
                    menuItem: "clients.movements.dismissesUnconfirmedRecords",
                    state: "app.movements.dismissesUnconfirmedRecords",
                    title: "Bajas por Confirmar",
                    weight: 5
                },
                enroles: {
                    icon: "icon-account-box",
                    menuItem: "clients.movements.enroles",
                    state: "app.movements.enroles",
                    title: "Altas",
                    weight: 3
                },
                idseRecords: {
                    icon: "icon-account-box",
                    menuItem: "clients.movements.idseRecords",
                    state: "app.movements.idseRecords",
                    title: "IDSE",
                    weight: 7
                },
                mdsRecords: {
                    icon: "icon-account-box",
                    menuItem: "clients.movements.mdsRecords",
                    state: "app.movements.mdsRecords",
                    title: "MDS",
                    weight: 8
                },
                movements: {
                    icon: "icon-account-box",
                    menuItem: "clients.movements.movements",
                    state: "app.movements.movements",
                    title: "Movimientos",
                    weight: 9
                },
                logs: {
                    icon: "icon-account-box",
                    menuItem: "clients.movements.logs",
                    state: "app.movements.logs",
                    title: "Auditoria",
                    weight: 10
                },
                revisions: {
                    icon: "icon-account-box",
                    menuItem: "clients.movements.revisions",
                    state: "app.movements.revisions",
                    title: "Revisiones",
                    weight: 12
                },
                variables: {
                    icon: "icon-account-box",
                    menuItem: "clients.movements.variables",
                    state: "app.movements.variables",
                    title: "Variables",
                    weight: 13
                },
                enroleAccounts: {
                    icon: "icon-account-box",
                    menuItem: "clients.movements.enroleAccounts",
                    state: "app.movements.enroleAccounts",
                    title: "Alta de Tarjetas",
                    weight: 2
                }
            },
            captures: {
                credits: {
                    icon: "icon-account-box",
                    menuItem: "clients.captures.credits",
                    state: "app.captures.credits",
                    title: "Acreditados",
                    weight: 1
                },
                loans: { // TODO: ver que el contador cheque este formulario
                    icon: "icon-account-box",
                    menuItem: "clients.captures.loans",
                    state: "app.captures.loans",
                    title: "Prestamos",
                    weight: 4
                },
                employees: {
                    icon: "icon-account-box",
                    menuItem: "clients.captures.employees",
                    state: "app.captures.employees",
                    title: "Empleados",
                    weight: 2
                },
                groupings: {
                    icon: "icon-account-box",
                    menuItem: "clients.captures.groupings",
                    state: "app.captures.groupings",
                    title: "Agrupaciones",
                    weight: 2
                },
                healthcareRecords: {
                    icon: "icon-account-box",
                    menuItem: "clients.captures.healthcareRecords",
                    state: "app.captures.healthcareRecords",
                    title: "Salud",
                    weight: 6
                },
                noEmployees: {
                    icon: "icon-account-box",
                    menuItem: "clients.captures.noEmployees",
                    state: "app.captures.noEmployees",
                    title: "No. de Empleados",
                    weight: 3
                },
                realSalaryRecords: {
                    icon: "icon-account-box",
                    menuItem: "clients.captures.realSalaryRecords",
                    state: "app.captures.realSalaryRecords",
                    title: "Salario Real",
                    weight: 5
                },
                rfcValidator: {
                    icon: "icon-spellcheck",
                    action: 'showRfcValidatorModal',
                    menuItem: "clients.captures.rfcValidator",
                    state: "app.captures.rfcValidator",
                    title: "Validador RFC",
                    weight: 9
                },
                documentRfcValidator: {
                    icon: "icon-clipboard-check",
                    action: 'showCifValidatorModal',
                    menuItem: "clients.captures.documentRfcValidator",
                    state: "app.captures.documentRfcValidator",
                    title: "Validador cédula RFC",
                    weight: 9
                }
            },
            'idse-panel': {
                rpIdseRecords: {
                    icon: "icon-folder-outline-lock",
                    menuItem: "clients.idse-panel.rpIdseRecords",
                    state: "app.idse-panel.rpIdseRecords",
                    title: "Credenciales IMSS",
                    weight: 1
                },
                batchRecords: {
                    icon: "icon-folder-outline-lock",
                    menuItem: "clients.idse-panel.batchRecords",
                    state: "app.idse-panel.batchRecords",
                    title: "Envio de Lotes",
                    weight: 2
                }
            },
            'apps-sync': {
                syncEmployeeRecords: {
                    icon: "icon-format-list-bulleted",
                    menuItem: "clients.apps-sync.syncEmployeeRecords",
                    state: "app.apps-sync.syncEmployeeRecords",
                    title: "Empleados Sincronizados",
                    weight: 1
                },
                humandCatalogs: {
                    icon: "icon-format-list-bulleted",
                    menuItem: "clients.apps-sync.humandCatalogs",
                    state: "app.apps-sync.humandCatalogs",
                    title: "Catálogos Humand",
                    weight: 2
                }
            },
            rh: {
                documentTypes: {
                    icon: "icon-format-list-bulleted",
                    menuItem: "clients.rh.documentTypes",
                    state: "app.rh.documentTypes",
                    title: "Tipos de documentos",
                    weight: 1
                },
                contracts: {
                    icon: "icon-book-open",
                    menuItem: "clients.rh.contracts",
                    state: "app.rh.contracts",
                    title: "Contratos",
                    weight: 2
                },
                saludRecords: {
                    icon: "icon-account-box",
                    menuItem: "clients.rh.saludRecords",
                    state: "app.rh.saludRecords",
                    title: "Salud",
                    weight: 3
                },
                employeesVacationsRecords: {
                    icon: "icon-beach",
                    menuItem: "clients.rh.employeesVacationsRecords",
                    state: "app.rh.employeesVacationsRecords",
                    title: "Control de Vacaciones",
                    weight: 4
                },
                employeeFiles: {
                    icon: "icon-folder-multiple",
                    menuItem: "clients.rh.employeeFiles",
                    state: "app.rh.employeeFiles",
                    title: "Expedientes Empleado",
                    weight: 5
                },
                personalInfoEmployees: {
                    icon: "icon-folder-multiple",
                    menuItem: "clients.rh.personalInfoEmployees",
                    state: "app.rh.personalInfoEmployees",
                    title: "Información personal empleados",
                    weight: 6
                },
                kardexEmployees: {
                    icon: "icon-account-box",
                    menuItem: "clients.rh.kardexEmployees",
                    state: "app.rh.kardexEmployees",
                    title: "Kardex Empleados",
                    weight: 7
                },
                employeeBirths: {
                    icon: "icon-cake-variant",
                    menuItem: "clients.rh.employeeBirths",
                    state: "app.rh.employeeBirths",
                    title: "Cumpleaños Empleados",
                    weight: 2
                },
                anniversaryEmployees: {
                    icon: "icon-human",
                    menuItem: "clients.rh.anniversaryEmployees",
                    state: "app.rh.anniversaryEmployees",
                    title: "Aniversarios de empleados",
                    weight: 2
                }
            },
            'help-center': {
                categoryRecords: {
                    icon: false,
                    menuItem: "clients.help-center.categoryRecords",
                    state: "app.help-center.categoryRecords",
                    title: "Categorías",
                    weight: 1
                },
                faqs: {
                    icon: false,
                    menuItem: "clients.help-center.faqs",
                    state: "app.help-center.faqs",
                    title: "Preguntas Frecuentes",
                    weight: 2
                },
                guides: {
                    icon: false,
                    menuItem: "clients.help-center.guides",
                    state: "app.help-center.guides",
                    title: "Guias",
                    weight: 3
                },
                articles: {
                    icon: false,
                    menuItem: "clients.help-center.articles",
                    state: "app.help-center.articles",
                    title: "Artículos",
                    weight: 4
                }
            },
            processes: {
                folios: {
                    icon: "icon-document",
                    menuItem: "clients.processes.folios",
                    state: "app.processes.folios",
                    title: "Folios",
                    weight: 2
                },
                dispersions: {
                    hidden: true,
                    icon: "icon-hexagon",
                    menuItem: "clients.processes.dispersions",
                    state: "app.processes.dispersions",
                    title: "Dispersiones",
                    weight: 7
                },
                xmlBillsRequests: {
                    icon: "icon-document",
                    menuItem: "clients.processes.xmlBillsRequests",
                    state: "app.processes.xmlBillsRequests",
                    title: "Confrontas",
                    weight: 10
                },
                incidences: {
                    icon: "icon-clipboard-account",
                    menuItem: "clients.processes.incidences",
                    state: "app.processes.incidences",
                    title: "Incidencias",
                    weight: 2
                },
                confirmIncidences: {
                    icon: "icon-clipboard-check",
                    menuItem: "clients.processes.confirmIncidences",
                    state: "app.processes.confirmIncidences",
                    title: "Incidencias a Confirmar",
                    weight: 3
                },
                incidencesRequests: {
                    icon: "icon-clipboard-account",
                    menuItem: "clients.processes.incidencesRequests",
                    state: "app.processes.incidencesRequests",
                    title: "Incidencias Masivas",
                    weight: 4
                },
                operations: {
                    icon: "icon-calculator",
                    menuItem: "clients.processes.operations",
                    state: "app.processes.operations",
                    title: "Operaciones",
                    weight: 5
                },
                payrollCalendars: {
                    icon: "icon-calendar",
                    menuItem: "clients.processes.payrollCalendars",
                    state: "app.processes.payrollCalendars",
                    title: "Calendarios",
                    weight: 1
                },
                stampedRecords: {
                    icon: "icon-bell",
                    menuItem: "clients.processes.stampedRecords",
                    state: "app.processes.stampedRecords",
                    title: "Timbrados",
                    weight: 6
                },
                attendanceLists: {
                    icon: "icon-clipboard-outline",
                    menuItem: "clients.processes.attendanceLists",
                    state: "app.processes.attendanceLists",
                    title: "Control de asistencia",
                    weight: 6
                },
                periods: {
                    icon: "icon-calendar",
                    menuItem: "clients.processes.periods",
                    state: "app.processes.periods",
                    title: "Periodos",
                    weight: 6
                },
                bills: {
                    icon: "icon-document",
                    menuItem: "clients.processes.bills",
                    state: "app.processes.bills",
                    title: "Recibos",
                    weight: 9
                },
                xmlSatMetas: {
                    icon: "icon-document",
                    menuItem: "clients.processes.xmlSatMetas",
                    state: "app.processes.xmlSatMetas",
                    title: "Solicitudes XML Sat",
                    weight: 10
                },
                reports: {
                    icon: "icon-document",
                    menuItem: "clients.processes.reports",
                    state: "app.processes.reports",
                    title: "Reportes",
                    weight: 9
                },
                closeOperations: {
                    icon: "icon-calendar-check",
                    menuItem: "clients.processes.closeOperations",
                    state: "app.processes.closeOperations",
                    title: "Cierre Mensual de Operaciones",
                    weight: 8
                }
            },
            config: {
                profile: {
                    icon: "icon-account",
                    menuItem: "config.profile",
                    state: "app.config.profile",
                    title: "Perfil",
                    hidden: true,
                    active: false
                },
                groups: {
                    icon: "icon-account-switch",
                    menuItem: "config.groups",
                    state: "app.config.groups",
                    title: "Grupos"
                },
                permissions: {
                    icon: "icon-security",
                    menuItem: "config.permissions",
                    state: "app.config.permissions",
                    title: "Permisos"
                },
                users: {
                    icon: "icon-account-multiple",
                    menuItem: "config.users",
                    state: "app.config.users",
                    title: "Usuarios"
                },
                involvedRecords: {
                    icon: "icon-account-key",
                    menuItem: "config.involvedRecords",
                    state: "app.config.involvedRecords",
                    title: "Involucrados"
                },
                globalNotifications: {
                    icon: "icon-comment-alert",
                    menuItem: "config.globalNotifications",
                    state: "app.config.globalNotifications",
                    title: "Notificaciones Globales"
                },
                concepts: {
                    icon: "icon-format-list-numbers",
                    menuItem: "config.concepts",
                    state: "app.config.concepts",
                    title: "Conceptos"
                },
                incidencesTypes: {
                    icon: "icon-clipboard-text",
                    menuItem: "config.incidencesTypes",
                    state: "app.config.incidencesTypes",
                    title: "Tipos de Incidencias"
                },
                customFields: {
                    icon: "icon-package-variant",
                    menuItem: "config.customFields",
                    state: "app.config.customFields",
                    title: "Campos Personalizados"
                },
                operationConstants: {
                    icon: "icon-key-change",
                    menuItem: "config.operationConstants",
                    state: "app.config.operationConstants",
                    title: "Constantes de Operaciones"
                },
                paymentSchemas: {
                    icon: "icon-briefcase",
                    menuItem: "config.paymentSchemas",
                    state: "app.config.paymentSchemas",
                    title: "Esquemas de Pago"
                },
                processConfigs: {
                    icon: "icon-engine",
                    menuItem: "config.processConfigs",
                    state: "app.config.processConfigs",
                    title: "Configuraciones de procesos"
                },
                imports: {
                    icon: "icon-import",
                    menuItem: "config.imports",
                    state: "app.config.imports",
                    title: "Importaciones"
                },
                benefits: {
                    icon: "icon-cash",
                    menuItem: "config.benefits",
                    state: "app.config.benefits",
                    title: "Prestaciones"
                },
                holidays: {
                    icon: "icon-cake",
                    menuItem: "config.holidays",
                    state: "app.config.holidays",
                    title: "Dias festivos"
                },
                tickets: {
                    icon: "icon-ticket",
                    menuItem: "config.tickets",
                    state: "app.config.tickets",
                    title: "Tickets"
                },
                archivedTickets: {
                    icon: "icon-ticket",
                    menuItem: "config.archivedTickets",
                    state: "app.config.archivedTickets",
                    title: "Tickets Archivados"
                },
                sliderImages: {
                    icon: "icon-folder-multiple-image",
                    menuItem: "config.sliderImages",
                    state: "app.config.sliderImages",
                    title: "Imágenes del Slider"
                },
                emailImages: {
                    icon: "icon-email-open",
                    menuItem: "config.emailImages",
                    state: "app.config.emailImages",
                    title: "Imágenes Recibo"
                },
                accountingAccounts: {
                    icon: "icon-cash-100",
                    menuItem: "config.accountingAccounts",
                    state: "app.config.accountingAccounts",
                    title: "Cuentas contables"
                },
                accountAccVars: {
                    icon: "icon-alphabetical",
                    menuItem: "config.accountAccVars",
                    state: "app.config.accountAccVars",
                    title: "Variables Cuentas Contable"
                }

            },
            system: {
                actions: {
                    icon: "icon-hexagon",
                    menuItem: "system.actions",
                    state: "app.system.actions",
                    title: "Acciones de Módulos"
                },
                modules: {
                    icon: "icon-hexagon",
                    menuItem: "system.modules",
                    state: "app.system.modules",
                    title: "Módulos"
                },
                statusRecords: {
                    icon: "icon-hexagon",
                    menuItem: "system.statusRecords",
                    state: "app.system.statusRecords",
                    title: "Status de Módulos"
                }
            }
        };
        var centersData = [
            { id: 'tds', name: 'TDS' },
            { id: 'integratio', name: 'INTEGRATIO' },
            { id: 'manopco', name: 'GRUPO MANOPCO' },
            { id: 'maritur', name: 'MARITUR DMC' },
            { id: 'maravilla', name: 'DEMO' },
            { id: 'grupocorerepe', name: 'GRUPO COREREPE' },
            { id: 'solad', name: 'SOLAD' },
            { id: 'halford', name: 'HALFORD' },
            { id: 'mormex', name: 'MORMEX' }
        ]
        var currentTime = {
            offset: 0,
            lastSync: 0,
            ttl: 60 * 1000 // 1 minuto
        };
        var obj = {
            getErrorMessage: getErrorMessage,
            allAreSelected: allAreSelected,
            toggleAll: toggleAll,
            getActualTime: function (force) {
                var now = Date.now();
                if (!force && currentTime.lastSync && (now - currentTime.lastSync) < currentTime.ttl) {
                    return Promise.resolve(now + currentTime.offset);
                }
                return firebase.database().ref('/.info/serverTimeOffset').once('value').then(function (snap) {
                    var offset = snap.val() || 0;
                    currentTime.offset = offset;
                    currentTime.lastSync = Date.now();
                    return Date.now() + currentTime.offset
                });
            },
            getRootData: function (token) {
                return new Promise(function (resolve, reject) {
                    $log.log('getRootData called')
                    obj.getDataCenter().then(function (centerData) {
                        obj.centerData = centerData;
                        return checkUser()
                    }).then(function () {
                        initPersistance();
                        return loadProfile(token);
                    }).then(function () {
                        return loadPermissions();
                    }).then(function () {
                        if (!obj.essentialLoaded) {
                            obj.essentialLoaded = true;
                            $rootScope.$emit('firstLoading');
                        }
                        obj.essentialLoaded = true;
                        $timeout(function () {
                            resolve(true);
                        }, 1000);
                    }).catch(reject);
                });
            },
            logout: function logout(route) {
                $log.debug('Logging out.. Bye');
                $firebaseAuth().$signOut().then(function () {
                    delete obj.user;
                    delete obj.profile;
                    delete obj.groupsOfUser;
                    delete obj.IndexCtrlInitiated;
                    delete obj.permissionToAccessAllPayrolls;
                    delete obj.loadedPermissions;
                    delete obj.requestedState;
                    delete obj.requestedParams;
                    delete obj.isAdmin;
                    // se borra el cache de menus
                    msNavigationService.deleteItem('config');
                    msNavigationService.deleteItem('apps');
                    msNavigationService.deleteItem('clients');
                    msNavigationService.deleteItem('catalogs');
                    msNavigationService.deleteItem('system');
                    $sessionStorage.M = null;
                    $sessionStorage.loggedIn = false;
                    $sessionStorage.F = null;
                    $window.location.replace(buildModernLoginUrl());
                }, errAlertS);
            },
            operationTypesRelaxed: cats.operationTypesRelaxed,
            expirationTime: 1800, // media hora
            root: null,
            oneDay: 1000 * 60 * 60 * 24,
            iconSize: {
                s: 12,
                n: 24,
                m: 36,
                x: 48,
                xx: 96
            },
            tableHeadingMargin: {
                '5': 0,
                '10': 0,
                '20': 10,
                '30': 20,
                '50': 40,
                '100': 50
            },
            debounceTime: 1000,
            isOpen: true,
            timezone: moment().format('ZZ'),
            cardMaxLength: '16',
            cardMinLength: '16',
            brandName: 'TDS',
            paginate: ($sessionStorage.paginate) ? $sessionStorage.paginate : 10,
            pageSize: 9,
            paginations: [5, 10, 20, 30, 50, 100, 500],
            dateView: 'month',
            dateViewY: 'year', // month, day
            progress: 0,
            addMode: false,
            readMode: false,
            ticketStatus: [{ id: 1, name: 'Abierto' }, { id: 2, name: 'En proceso' }, { id: 3, name: 'Cerrado' }],
            constanPeriods: [{ id: 'period', name: 'Periodo' }, { name: 'Fin del mes', id: 'endOfMonth' }, { name: 'Inicio del mes', id: 'startOfMonth' }, { name: 'Cumpleaños de empleado', id: 'employeeBirthday' }, { id: 'employeeAniversary', name: 'Aniversario de empleado' }],
            ticketPriority: [{ id: 1, name: 'Baja' }, { id: 2, name: 'Media' }, { id: 3, name: 'Alta' }],
            imageName: {
                logo: ['firms', 'companiesRecords'],
                avatar: ['users', 'employees', 'groups'],
                file: ['incidencesTypes', 'tickets', 'archivedTickets', 'incidences', 'confirmedIncidenes', 'sliderImages', 'emailImages']
            },
            default: {
                icon: "icon-hexagon"
            },
            active: {
                menuItem: false,
                menuName: false,
                menuParams: false,
                page: false
            },
            onlyWeekendsPredicate: function (date) {
                var day = date.getDay();
                return day === 0 || day === 6;
            },
            onlyWorkdaysPredicate: function (date) {
                var day = date.getDay();
                var month = date.getMonth() + 1;
                var dayAndMonth = {
                    day: day,
                    month: month
                };
                var isHollyDay = obj.holydaysInMexico.dateIsHolyday(dayAndMonth);
                return (!isHollyDay);
            },
            autocompleteListM: function (search, catalog, fields, extraQuerys, DataF) {
                return $q(function (resolve, reject) {
                    if (catalog === 'employees' && !obj.permissionToAccessAllPayrolls) {
                        if (!angular.isObject(extraQuerys)) {
                            extraQuerys = {};
                        }
                        if (!extraQuerys.payroll) {
                            extraQuerys.payroll = JSON.stringify({ "$in": getArrayOfIdsFilter($rootScope.L.payrolls) })
                        }
                    }
                    DataF.api.autocompleteMongo(search, catalog, fields, extraQuerys).then(function (items) {
                        resolve(items);
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync(function () {
                            $log.debug('getThem finished');
                        });
                    }).catch(function (err) {
                        errAlertS(err);
                        reject(err);
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync();
                    });
                });
            },
            onlyLabourDaysPredicate: function (date) {
                var day = date.getDay();
                var month = date.getMonth() + 1;
                var dayAndMonth = {
                    day: day,
                    month: month
                };
                var isHollyDay = obj.holydaysInMexico.dateIsHolyday(dayAndMonth);
                return (!isHollyDay && day !== 0 && day !== 6);
            },
            uniqueQueries: {},
            currentPage: function () {
                obj.active.page = $localStorage.currentPage;
                if (!obj.active.page) obj.active.page = {};
                if (!obj.active.page.hasOwnProperty(obj.active.menuParent)) obj.active.page[obj.active.menuParent] = {};
                if (!obj.active.page[obj.active.menuParent].hasOwnProperty(obj.active.menuName)) obj.active.page[obj.active.menuParent][obj.active.menuName] = 1;
                return obj.active.page[obj.active.menuParent][obj.active.menuName];
            },
            setCurrentPage: function (page) {
                if (!obj.active.page.hasOwnProperty(obj.active.menuParent)) obj.active.page[obj.active.menuParent] = {};
                obj.active.page[obj.active.menuParent][obj.active.menuName] = page;
                if (!$localStorage.currentPage) $localStorage.currentPage = {};
                if (!$localStorage.currentPage[obj.active.menuParent]) $localStorage.currentPage[obj.active.menuParent] = {};
                $localStorage.currentPage[obj.active.menuParent][obj.active.menuName] = page;
            },
            goToInitialState: function () {
                var F = this;
                if (angular.isDefined(F.requestedState)) {
                    var requestedState = F.requestedState;
                    var requestedParams = F.requestedParams;
                    $state.go(requestedState, requestedParams);
                } else {
                    F.root.child('groups/' + obj.groupsOfUser[0] + '/initialState').once('value').then(function (resp) {
                        var route = resp.val();
                        if (route && route !== null) {
                            try {
                                $state.go(route);
                            } catch (error) {
                                $state.go(initialState);
                            }
                        } else {
                            $state.go(initialState);
                        }
                    }).catch(function (error) {
                        $log.error(error);
                    });
                }
            },
            statusBatchRecords: ["Pendiente de envió", "Enviado", "Recibido satisfactorio", "No enviado", "Recibido con errores"],
            statusQueueBatchRecords: ["Por Enviar", "En Proceso", "Terminado"],
            eventTypes: cats.eventTypes,
            contractSatTypes: cats.contractSatTypes,
            cyvMeasures: cats.cyvMeasures,
            incapacityTypes: cats.incapacityTypes,
            contractVariables: cats.contractVariables,
            documentTypes: cats.documentTypes,
            operationDirectives: cats.operationDirectives,
            maritalStatuses: cats.maritalStatuses,
            sentStatuses: cats.sentStatuses,
            conceptTypes: cats.conceptTypes,
            creditTypes: cats.creditTypes,
            operationTypes: cats.operationTypes,
            processes: cats.processes,
            inputTypes: cats.inputTypes,
            hasSeniorityDateOptions: cats.hasSeniorityDateOptions,
            otherProcs: cats.otherProcs,
            opeFilesName: cats.opeFilesName,
            readAllMyNotifications: function () {
                if (angular.isDefined(obj.notifications.notReaded)) {
                    $rootScope.loadingProgress = true;
                    var allPromises = [];
                    var notReaded = JSON.parse(JSON.stringify(obj.notifications.notReaded));
                    for (var n in notReaded) {
                        allPromises.push(obj.readNotification(notReaded[n].$id, 1));
                    }
                    $q.all(allPromises).then(function (all) {
                        successAlertS('Las notificaciones fueron leidas');
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync(function () {
                            $log.debug('readAllMyNotifications finished');
                        });
                    }).catch(function (err) {
                        errAlertS(err);
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync();
                    });

                }
            },
            getAndValue: function () {
                if (this.permissionToAccessAllPayrolls) {
                    return undefined;
                } else {
                    var ccArray = [];
                    var payrollArray = [];
                    if (angular.isArray(this.ccsByPayrollsOfUser)) {
                        for (var j = 0; j < this.ccsByPayrollsOfUser.length; j++) {
                            var thisPayroll = this.ccsByPayrollsOfUser[j];
                            if (angular.isArray(thisPayroll.ccs)) {
                                if (thisPayroll.ccs.indexOf('all') > -1) {
                                    payrollArray.push(thisPayroll.$id);
                                } else {
                                    ccArray = ccArray.concat(thisPayroll.ccs);
                                }
                            }
                        }
                    }
                    var obj = angular.toJson([{ '$or': [{ cc: { $in: ccArray } }, { payroll: { $in: payrollArray } }] }]);
                    return obj;
                }
            },
            readNotification: function (notificationId, prom) {
                var promise = $q.defer();
                var F = this;
                if (!prom) $rootScope.loadingProgress = true;
                var updates = {};
                updates['notifications/' + F.profile.uid + '/not_readed/' + notificationId + '/readed'] = 1;
                updates['notifications/' + F.profile.uid + '/not_readed/' + notificationId + '/readed_at'] = moment().valueOf();
                F.root.update(updates, function (err) {
                    if (!err) {
                        var fromRef = 'notifications/' + F.profile.uid + '/not_readed/' + notificationId;
                        var toRef = 'notifications/' + F.profile.uid + '/readed/' + notificationId;
                        F.root.child(fromRef).once('value', function (snap) {
                            var updates = {};
                            updates[fromRef] = null;
                            updates[toRef] = snap.val();
                            F.root.update(updates).then(function () {
                                if (!prom) successAlertS('Notificación Leida');
                                if (!prom) {
                                    $rootScope.loadingProgress = false;
                                    $rootScope.$evalAsync(function () {
                                        $log.debug('readNotification finished');
                                    });
                                }
                                promise.resolve();
                            }).catch(function (err) {
                                promise.reject(err);
                                if (!prom) errAlertS(err);
                                if (!prom) {
                                    $rootScope.loadingProgress = false;
                                    $rootScope.$evalAsync();
                                }
                            });
                        }, function (err) {
                            promise.reject(err);
                            if (!prom) errAlertS(err);
                            if (!prom) {
                                $rootScope.loadingProgress = false;
                                $rootScope.$evalAsync();
                            }
                        });
                    } else {
                        promise.reject(err);
                        if (!prom) errAlertS(err);
                        if (!prom) {
                            $rootScope.loadingProgress = false;
                            $rootScope.$evalAsync();
                        }
                    }
                    return promise.promise;
                });
            },
            paginator: function (query, limit, timeStampField, eventEmitted) {
                var blancPaginator = function (query, limit, timeStampField, eventEmitted) {
                    limit = limit ? limit : 10;
                    var lastRecord = null;
                    var listenersLoaded = false;
                    var data = {
                        items: [],
                        loadMoreButton: true,
                        loading: false
                    }
                    function addRemoveItem(id, item, forInsert) {
                        var index = data.items.findIndex(function (item) {
                            return item.$id === id
                        });
                        if (index > -1) {
                            if (item) {
                                data.items[index] = item;
                            } else {
                                data.items.splice(index, 1);
                            }
                        } else if (item && forInsert) {
                            data.items.push(item);
                        }
                    }
                    data.loadMore = function () {
                        if (data.loadMoreButton) {
                            $log.log('getting more', lastRecord)
                            data.loading = true;
                            data.loadMoreButton = false;
                            var promise;
                            if (lastRecord) {
                                promise = query.orderByChild(timeStampField).endAt(lastRecord).limitToLast(limit + 1).once('value');
                            } else {
                                promise = query.orderByChild(timeStampField).limitToLast(limit).once('value');
                            }
                            promise.then(function (snap) {
                                var count = 0;
                                snap.forEach(function (childSnap) {
                                    count++;
                                    var item = childSnap.val();
                                    item.$id = childSnap.key;
                                    if (count == 1) {
                                        lastRecord = $filter("pathInObj")(item, $filter("replaceAll")(timeStampField, "/", "."));
                                    }
                                    addRemoveItem(childSnap.key, item, true)
                                });
                                if (count >= limit) {
                                    data.loadMoreButton = true;
                                }
                            }).catch(function (error) {
                                errAlertS(error);
                                data.loadMoreButton = true;
                            }).then(function () {
                                data.loading = false;
                                loadListeners();
                                $rootScope.$emit(eventEmitted, true);
                            });
                        }
                    }
                    function loadListeners() {
                        if (!listenersLoaded) {
                            listenersLoaded = true;
                            query.on("child_removed", function (snap) {
                                addRemoveItem(snap.key);
                                $rootScope.$emit(eventEmitted, true);
                            });
                            query.on("child_changed", function (snap) {
                                var item = snap.val();
                                item.$id = snap.key;
                                addRemoveItem(snap.key, item);
                                $rootScope.$emit(eventEmitted, true);
                            })
                            query.orderByChild(timeStampField).limitToLast(1).on("child_added", function (snap) {
                                var item = snap.val();
                                item.$id = snap.key;
                                addRemoveItem(snap.key, item, true);
                                $rootScope.$emit(eventEmitted, true);
                            });
                        }
                    }
                    data.loadMore();
                    return data;
                }
                return blancPaginator(query, limit, timeStampField, eventEmitted);
            },
            searchBlanc: {
                $: {
                    employee: false,
                    rp: false,
                    cc: false
                },
                $payroll: false,
                $employee: false,
                $firm: false,
                $companiesRecord: false,
                // // constants
                constants: {
                    client: false,
                    placeOfWork: false,
                    payroll: false,
                    cc: false,
                    employee: ''
                },
                benefits: {
                    client: false,
                    payroll: false,
                    cc: false,
                    employee: ''
                },
                // operations
                operations: {
                    calendar: false,
                    period: false,
                    status: false
                }
            },
            notifyUsers: function (type, action, status, idM, record, dontSendEmail, dataNeededByTemplate) {
                dataNeededByTemplate.date = moment().format("DD-MM-YYYY HH:mm");
                if (!dataNeededByTemplate.hasOwnProperty('center')) {
                    dataNeededByTemplate.center = obj.center;
                }
                var params = {
                    type: type,
                    action: action,
                    status: status,
                    idM: idM,
                    record: record,
                    dontSendEmail: dontSendEmail,
                    dataNeededByTemplate: dataNeededByTemplate
                }
                return $http.post(window.__env.serviceWorkerUrl + "notifications/send", params);
            },
            sendNotification: function (body, title, to, action, state, name, dontSendEmail, data, template) {
                var emailPromise = $q.defer();
                var notificationPromise = $q.defer();
                var object = {
                    created_at: firebase.database.ServerValue.TIMESTAMP,
                    from: {
                        avatar: this.profile.photoURL ? this.profile.photoURL : 'assets/images/avatars/profile.jpg',
                        name: this.profile.data.name,
                        uid: this.profile.uid
                    },
                    readed: 0,
                    title: title,
                    to: to
                }
                if (body && body != "" && body != null) object.body = body;
                if (action && action != "" && action != null) object.link = {
                    action: action,
                    name: name,
                    state: state
                };
                if (obj.settings.notificate) {
                    this.root.child('notifications/' + to + '/not_readed').push(object).then(function () {
                        notificationPromise.resolve(true);
                    }, function (err) {
                        errAlertS(err);
                        notificationPromise.reject(err);
                    });
                } else {
                    notificationPromise.resolve(true);
                }
                if (!dontSendEmail && obj.settings.sendEmail) { // always send email except when flag is setted
                    if (!angular.isDefined(this.profiles)) this.profiles = {};
                    if (!angular.isDefined(this.profiles[to])) this.profiles[to] = $firebaseObject(this.root.child("profiles").child(to));
                    var f = this;
                    this.profiles[to].$loaded().then(function (profile) {
                        if (angular.isDefined(profile.data)) {
                            if (angular.isDefined(profile.data.email)) {
                                var date = moment().valueOf();
                                // var dateString = dateFilter(date.valueOf(), "medium");
                                var eparams = {
                                    // action: f.profile.data.name + ' ' + action + ' ' + name,
                                    action: title,
                                    notification: title,
                                    date: date,
                                    template: template,
                                    data: data
                                };
                                $log.debug('sendingEmail to ' + profile.data.email + ' : ' + profile.data.name, eparams);
                                f.sendEmail(profile.data.email, profile.data.name, eparams, template).then(function () {
                                    emailPromise.resolve(true);
                                }, function (err) {
                                    errAlertS(err);
                                    emailPromise.reject(err);
                                });
                            }
                        } else {
                            var msg = 'Perfil ya no existe ' + profile.$id;
                            emailPromise.resolve(true);
                            infoAlertS(msg);
                        }
                    });
                } else {
                    emailPromise.resolve(true);
                }
                return $q.all([notificationPromise.promise, emailPromise.promise]);
            },
            sendEmailS: function (params) {
                return $http.post(window.__env.serviceWorkerUrl + "email/send", params);
            },
            getTemplateHtml: function (templateName, data) {
                var promise = $q.defer();

                var headerUrl = $sce.getTrustedResourceUrl('app/main/acommon/templates/_head.html');
                var footerUrl = $sce.getTrustedResourceUrl('app/main/acommon/templates/_foot.html');
                var templateUrl = $sce.getTrustedResourceUrl('app/main/acommon/templates/' + templateName + '.html');
                var headerRequest = $q.defer();
                var footerRequest = $q.defer();
                var bodyRequest = $q.defer();
                obj.tdata = JSON.parse(JSON.stringify(data));
                if (obj.tdata.employee) {
                    obj.tdata.employee.created.atTime = moment(obj.tdata.employee.created.atTime).isValid() ? obj.tdata.employee.created.atTime : moment().valueOf();
                }
                if (obj.tdata.credit) {
                    obj.tdata.credit.created.atTime = moment(obj.tdata.credit.created.atTime).isValid() ? obj.tdata.credit.created.atTime : moment().valueOf();
                }
                if (obj.tdata.operation) {
                    obj.tdata.operation.created.atTime = moment(obj.tdata.operation.created.atTime).isValid() ? obj.tdata.operation.created.atTime : moment().valueOf();
                }
                if (obj.tdata.incidence) {
                    obj.tdata.incidence.created.atTime = moment(obj.tdata.incidence.created.atTime).isValid() ? obj.tdata.incidence.created.atTime : moment().valueOf();
                }

                obj.tdata.L = $rootScope.L;
                obj.tdata.M = $rootScope.M;
                obj.tdata.Z = $rootScope.Z;
                obj.tdata.C = $rootScope.C;
                $rootScope.templateData = obj.data;
                $templateRequest(headerUrl).then(function (templateHeader) {
                    var htmlH = $interpolate(templateHeader)(obj.tdata);
                    headerRequest.resolve(htmlH);
                }, function (err) {
                    headerRequest.reject({
                        err: err,
                        msg: 'problema al obtener template header'
                    });
                });

                $templateRequest(templateUrl).then(function (templateBody) {
                    var htmlB = $interpolate(templateBody)(obj.tdata);
                    bodyRequest.resolve(htmlB);
                }, function (err) {
                    bodyRequest.reject({
                        err: err,
                        msg: 'problema al obtener template body'
                    });
                });

                $templateRequest(footerUrl).then(function (templateFooter) {
                    var htmlF = $interpolate(templateFooter)(obj.tdata);
                    footerRequest.resolve(htmlF);
                }, function (err) {
                    footerRequest.reject({
                        err: err,
                        msg: 'problema al obtener template footer'
                    });
                });

                $q.all({
                    header: headerRequest.promise,
                    body: bodyRequest.promise,
                    footer: footerRequest.promise
                }).then(function (allT) {
                    var html = allT.header + allT.body + allT.footer;
                    // $('body').html(html); return false; // test
                    obj.tdata = false;
                    promise.resolve(html);
                }, function (err) {
                    errAlertS(err);
                    promise.reject(err);
                })

                return promise.promise;
            },
            sendEmail: function (toEmail, toName, data, template) {
                var promise = $q.defer();
                var f = this;
                obj.getTemplateHtml(template, data).then(function (html) {
                    var mail = {
                        from: "Sistema <no-reply@tdsystem.software>",
                        to: toName + " <" + toEmail + ">",
                        body: html,
                        subject: data.action
                    }
                    // console.log(mail, data, "MAIL");
                    // angular.element('body').html(html); promise.resolve(true); // for tests
                    f.sendEmailS(mail).then(function (response) {
                        $log.debug(response, "mail response");
                        promise.resolve(true);
                    });
                }, function (err) {
                    errAlertS(err);
                    promise.reject(err);
                });
                return promise.promise;
            },
            setLastIdForNewEmployees: function (employeeId) {
                var promise = $q.defer();
                obj.root.child('queue1/tasks').push({
                    type: 'setLastEmployeeId',
                    employeeId: employeeId
                })
                    .then(function (newId) {
                        promise.resolve(newId);
                    }, function (err) {
                        promise.reject(err);
                    });
                return promise.promise;
            },
            setLastCertificateForNewEmployees: function (employeeId) {
                obj.root.child('queue1/tasks').push({
                    type: 'setLastCertificate',
                    employeeId: employeeId
                });
            },
            setLastEmployeeNumber: function (employeeId) {
                obj.root.child('queue1/tasks').push({
                    type: 'setLastEmployeeNumber',
                    employeeId: employeeId
                });
            },
            checkPayrollForDisable: function (payrollId) {
                obj.root.child('queue1/tasks').push({
                    type: 'tryDisablePayroll',
                    payrollId: payrollId
                });
            },
            checkCreditStatus: function (employeeId) {
                obj.root.child('queue1/tasks').push({
                    type: 'checkCreditStatus',
                    employeeId: employeeId
                });
            },
            addObjectToArray: function (parent, arrayName, obj) {
                if (typeof (parent[arrayName]) == "undefined") parent[arrayName] = [];
                parent[arrayName].push(obj ? obj : {});
            },
            constantTypes: cats.constantTypes,
            actions: cats.actions,
            //[0 = capturado, 1 = En revisión, 2 = autorizacion de cliente, 3 = esperando pago, 4 = esperando confirmacion, 5 = pago confirmado, 6 = mandado a dispersión, 7 = dispersado, 8 = finalizado, 9 = cancelado]
            operationStatatuss: cats.operationStatuss,
            complementTypes: cats.complementTypes,
            processTypes: cats.processTypes,
            employeeStatatuss: cats.employeeStatuss,
            incidenceStatuss: cats.incidenceStatatuss,
            opstatusByEmployeeStatus: cats.opstatusByEmployeeStatus,
            // TODO: porque hay 2 objetos parecidos?
            xmlBillsRequestStatus: cats.xmlBillsRequestStatus,
            xmlBillsRequestResults: cats.xmlBillsRequestResults,
            movementTypes: cats.movementTypes,
            movementsTypes: cats.movementTypes,
            creditStatuses: cats.creditStatuses,
            loanStatuses: cats.loanStatuses,
            contractStatuses: cats.contractStatuses,
            calcFieldsObjects: cats.calcFieldsObjects,
            periodicity: cats.periodicity,
            oldDefaultHolidaysTable: cats.oldDefaultHolidaysTable,
            defaultBenefits: {
                holidaysTable: cats.defaultHolidaysTable,
                christmasBonus: 15,
                prime: 25,
                holidays: "default",
                type: "default"
            },
            defaultOperationConstants: {
                type: "default"
            },
            search: {
                operations: {},
                employees: {},
                movements: {},
                filters: {},
                $: {
                    employee: false,
                    rp: false,
                    cc: false,
                    payroll: false,
                    status: false
                },
                $payroll: false,
                $employee: false,
                $firm: false,
                $companiesRecord: false
            },
            resetSearch: function (tabName, selected) {
                if (tabName) {
                    obj.search[tabName] = JSON.parse(JSON.stringify(obj.searchBlanc[tabName] ? obj.searchBlanc[tabName] : {}));
                } else {
                    obj.search = JSON.parse(JSON.stringify(obj.searchBlanc));
                }
                if (selected) {
                    selected = [];
                }
                if (angular.isDefined(obj.searchText) && obj.searchText !== null) obj.searchText[obj.active.menuObjName] = "";
            },
            resetAdvancedSearch: function () {
                obj.search.filterBy = null;
                obj.search.$query = null;
                obj.search.query = null;
                obj.advancedSearchMode = false;
                $log.debug('resetAdvancedSearch');
            },
            inArray: function (id, array, path) {
                if (!path) path = '$id';
                for (var a in array) {
                    if (array[a].hasOwnProperty(path)) {
                        if (array[a][path] == id) return true;
                    }
                }
                return false;
            },
            turnOffOthers: function (obj, objs, field) {
                if (obj) {
                    for (var o in objs) {
                        var oobj = objs[o];
                        if (oobj !== obj) {
                            oobj[field] = false;
                        }
                    }
                }
            },
            saveBenefitOfEmployee: function (benefitPromise, thisBenefit, employeeId, timeObj, isNotFiscal, getUpdate) {
                return new Promise(function (resolve, reject) {
                    if (isNotFiscal) {
                        console.log("Not saving because is not fiscal");
                        if (getUpdate) {
                            resolve({})
                        } else {
                            resolve(true);
                        }
                    } else {
                        console.log("Saving because fiscal");
                        benefitPromise.then(function (benefit) {
                            var thisBenefitId = thisBenefit.$id;
                            thisBenefit = $filter("clearObject")(thisBenefit);
                            var benefitId = benefit.$id;
                            benefit = $filter("clearObject")(benefit);
                            function compareJson(thisBenefit, benefit) {
                                delete thisBenefit.created;
                                delete thisBenefit.updated;
                                delete benefit.created;
                                delete benefit.updated;
                                var data = [
                                    angular.fromJson(angular.toJson(thisBenefit)),
                                    angular.fromJson(angular.toJson(benefit))
                                ];
                                for (var i = 0; i < data.length; i++) {
                                    var factor = data[i].holidaysTable;
                                    for (var x = 0; x < factor.length; x++) {
                                        delete factor[x].factor;
                                    }
                                }
                                var result = !(angular.toJson(data[0]) == angular.toJson(data[1]));
                                return result;
                            }
                            var isDifferent = compareJson(thisBenefit, benefit);
                            console.log("Benefist is different", isDifferent);
                            if (isDifferent) {
                                var idToUpdate;
                                if (thisBenefit.itemId == employeeId) {
                                    idToUpdate = thisBenefitId;
                                    if (timeObj) {
                                        thisBenefit.updated = timeObj;
                                    }
                                } else {
                                    idToUpdate = obj.root.child('catalogs/benefits/collection').push().key;
                                    if (timeObj) {
                                        thisBenefit.created = timeObj;
                                    }
                                }
                                thisBenefit.itemId = employeeId;
                                thisBenefit.type = "employee";

                                if (getUpdate) {
                                    var prom = {};
                                    prom['benefits/collection/' + idToUpdate] = thisBenefit;
                                    resolve(prom);
                                } else {
                                    obj.root.child('catalogs/benefits/collection/' + idToUpdate).set(thisBenefit).then(function () {
                                        resolve(true);
                                    }).catch(function (error) {
                                        reject(error)
                                    })
                                }
                            } else {
                                if (getUpdate) {
                                    resolve({})
                                } else {
                                    resolve("No need to update anything");

                                }
                            }
                        }).catch(function (error) {
                            reject(error);
                        })
                    }

                })
            },
            paginationLabel: {
                page: 'Página:',
                rowsPerPage: 'Registros:',
                of: 'de'
            },
            animationsEnabled: true,
            speedSelectedDialPosition: {
                bottom: true,
                right: true
            },
            speedSelectedDialDirection: 'up',
            loading: true,
            user: false,
            profile: false,
            version: "2.2.1",
            groups: false,
            filtres: false,
            imagePlaceholder: 'assets/images/placeholders/image.png',
            datepickerFormat: 'dd-MM-yyyy',
            dateFormat: 'dd/MM/yyyy',
            tableFormat: 'LLLL',
            datepickerAcceptedFormats: ['dd/MM/yyyy'],
            states: false,
            notifications: {
                readed: [],
                notReaded: []
            },
            panel: {
                left: {},
                right: {
                    selectedTab: 0
                }
            },
            goToState: function (state, params) {
                if (!params) params = {};
                $state.go(state, params)
            },
            addFiltresToParams: function (params, filtresOfCollection) {
                angular.forEach(this.filtres, function (value, key) {
                    params[filtresOfCollection[key]] = value;
                });
                return params;
            },
            // Asegúrate de inyectar $q y $log donde declares este servicio
            getIp: function () {
                var deferred = $q.defer();
                var resolved = false;
                var pendientes = 0;
                var fuentes = [{
                    name: "TDS Backend Service",
                    request: $http.get(window.__env.serviceWorkerUrl + 'myIp'),
                    child: "clientIp"
                }, {
                    name: "GeoSites",
                    request: $http.get('//api.ipstack.com/check?access_key=99359c767b453a003da1ae87e30699a2&output=json'),
                    child: "ip"
                }];
                pendientes = fuentes.length;
                angular.forEach(fuentes, function (f) {
                    f.request.then(function (resp) {
                        var ip = resp && resp.data && resp.data[f.child];
                        if (typeof ip !== 'undefined') {
                            if (!resolved) {
                                resolved = true; // nos quedamos con el primer éxito
                                $log.debug("IP:", ip, "obtenida por", f.name);
                                deferred.resolve(ip);
                            }
                        } else {
                            fallo(new Error('Respuesta inválida de ' + f.name));
                        }
                    }).catch(function (err) {
                        fallo(err);
                    });
                });
                function fallo(err) {
                    pendientes--;
                    if (pendientes === 0 && !resolved) {
                        // Todos fallaron
                        deferred.reject(err || new Error('No se pudo obtener la IP'));
                    }
                }
                return deferred.promise;
            },
            closeFilters: function (sscope) {
                obj.search = {};
                sscope.showFilters = false;
            },
            centersData: centersData,
            centers: centersData.map(function (item) { return item.id; }),
            isDistributor: function (firm) {
                return obj.centers.indexOf(firm ? firm : obj.profile.firm) > -1;
            },
            getMaxEditStatus: function () {
                var maxStatus = 1;
                var rev = $filter('userHasPermission')(obj.groupsOfUser, obj.permissions, 'sendToFinalRevision', 'processes.operations');
                var closeOperation = $filter('userHasPermission')(obj.groupsOfUser, obj.permissions, 'sendPreBill', 'processes.operations');
                if (closeOperation) {
                    maxStatus = 2.5;
                } else if (rev) {
                    maxStatus = 2;
                }
                return maxStatus;
            },
            getOperationStatusByEmployees: function (operation, ccs) {
                var myccs = $filter('getArrayOfIds')(ccs);
                var myEmployees = {};
                var statusEmployees;
                var sameStatus = true;
                for (var employeeId in operation.employees) {
                    if (obj.permissionToAccessAllPayrolls || myccs.indexOf(operation.employees[employeeId].cc) > -1) {
                        myEmployees[employeeId] = operation.employees[employeeId];
                        if (typeof (statusEmployees) === 'undefined') {
                            statusEmployees = operation.employees[employeeId].status;
                        }
                        if (statusEmployees !== operation.employees[employeeId].status) {
                            sameStatus = false;
                        }
                    }
                }
                var status = operation.status;
                if (sameStatus && cats.opstatusByEmployeeStatus[statusEmployees] > status) {
                    status = cats.opstatusByEmployeeStatus[statusEmployees]
                }
                // console.log(myEmployees, sameStatus, myccs);
                // console.log(status);
                return status;
            },
            getArrayOfFBObjects: function (ids, ref, returnObject) {
                var deferred = $q.defer();
                var querys = {};
                for (var i in ids) {
                    var id = ids[i];
                    if (id) querys[id] = obj.root.child(ref).child(id).once('value');
                }
                $log.debug(ids, querys, 'querys about to be made');
                $q.all(querys).then(function (data) {
                    var i = 0;
                    var arrayOfObjects = (returnObject) ? {} : [];
                    for (var d in data) {
                        if (returnObject) {
                            arrayOfObjects[d] = data[d].val();
                            if (arrayOfObjects[d]) arrayOfObjects[d]['$id'] = d;
                        } else {
                            arrayOfObjects[i] = data[d].val();
                            if (arrayOfObjects[i]) arrayOfObjects[i]['$id'] = d;
                        }
                        i++;
                    }
                    deferred.resolve(arrayOfObjects);
                    $log.debug(arrayOfObjects, "arrayOfObjects");
                    return arrayOfObjects;
                }, function (err) {
                    errAlertS(err);
                    deferred.reject(err);
                });
                return deferred.promise;
            },
            menuItems: menuItems,
            contactTypes: cats.contactTypes,
            emailTypes: cats.emailTypes,
            getDataCenter: function () {
                return new Promise(function (resolve, reject) {
                    firebase.database().ref('/').child('centers/collection/' + $window.center).once('value').then(function (snap) {
                        resolve(snap.val());
                    }).catch(function (error) {
                        $log.error(error);
                        reject(error);
                    });
                });
            },
            sleep: function (time) {
                return new Promise(function (resolve) {
                    $timeout(function () {
                        resolve(true);
                    }, time);
                })
            },
            downloadFile: downloadFile
        }
        function getErrorMessage(error) {
            $log.error(error);
            var errorMsg;
            if (angular.isString(error)) {
                errorMsg = error;
            } else if (error instanceof Error) {
                errorMsg = error.message;
            } else {
                var timeStamp = new Date().valueOf();
                $log.error(timeStamp, error);
                errorMsg = 'Error desconocido: ' + timeStamp;
            }
            return errorMsg;
        }
        function allAreSelected(allData, selected) {
            var flag = false;
            if (angular.isArray(allData) && angular.isArray(selected)) {
                flag = allData.length === selected.length;
            }
            return flag;
        }
        function toggleAll(allData, selected, field) {
            var hasSameSize = false;
            if (angular.isArray(allData) && angular.isArray(selected)) {
                hasSameSize = allData.length === selected.length;
            }
            if (hasSameSize) {
                selected.splice(0, selected.length);
            } else {
                for (var a = 0; a < allData.length; a++) {
                    var thisRow = allData[a];
                    var thisIndex = selected.findIndex(function (item) {
                        return item[field] === thisRow[field];
                    });
                    if (thisIndex === -1) {
                        selected.push(thisRow);
                    }
                }
            }
        }
        function checkUser() {
            return new Promise(function (resolve) {
                if (obj.userChecked) {
                    resolve(obj.user);
                } else {
                    var userChecked = $firebaseAuth().$onAuthStateChanged(function (firebaseUser) {
                        obj.userChecked = true;
                        userChecked();
                        if (firebaseUser) {
                            obj.user = firebaseUser;
                        }
                        resolve(obj.user);
                    });
                }
            });
        }
        var persistance = {};
        function initPersistance() {
            if (obj.user && obj.user.uid && !persistance.hasOwnProperty(obj.user.uid)) {
                persistance[obj.user.uid] = {};
                persistance[obj.user.uid].conn = obj.root.child('.info/connected');
                persistance[obj.user.uid].userStatusRef = obj.root.child('profiles/' + obj.user.uid + '/status');
                persistance[obj.user.uid].fn = persistance[obj.user.uid].conn.on('value', function (snapshot) {
                    if (snapshot.val()) {
                        persistance[obj.user.uid].userStatusRef.onDisconnect().set('offline').then(function () {
                            persistance[obj.user.uid].userStatusRef.set('online');
                        });
                    }
                });
            }
        }
        function loadProfile(token) {
            return new Promise(function (resolve, reject) {
                if (obj.user && obj.user.uid) {
                    if (!obj.profile) {
                        obj.profile = $firebaseObject(obj.root.child('profiles/' + obj.user.uid));
                    }
                    obj.profile.$loaded().then(function () {
                        if (!obj.profile.active) {
                            errAlertS('Cuenta desactivada, favor de contactar a soporte para reactivarla');
                            obj.logout();
                        } else if (token && (!obj.profile.token || obj.profile.token !== token)) {
                            errAlertS('Inicio de sesión caducado, identifíquese nuevamente');
                            obj.logout(loginRedirectPath);
                        }
                        obj.root.child('profiles/' + obj.user.uid + '/token').set(null);
                        resolve(obj.profile);
                    }).catch(reject);
                } else {
                    resolve({});
                }
            });
        }
        function loadPermissions() {
            return new Promise(function (resolve) {
                if (obj.profile && obj.profile.groupsOfUser) {
                    obj.groupsOfUser = $filter('getArrayOfKeys')(obj.profile.groupsOfUser);
                    resolve(getPermissionsOfUser());
                } else {
                    resolve(true);
                }
            });
        }
        function getPermissionsOfUser() {
            obj.permissions = {};
            obj.center = undefined;
            var getPermission = function (groupName) {
                var promise = $q.defer();
                obj.root.child('permissions').child(groupName).once('value', function (snap) {
                    var permission = snap.val();
                    obj.permissions[snap.key] = (permission) ? permission : {};
                    promise.resolve(true);
                }, function (err) {
                    promise.reject(err);
                });
                return promise.promise;
            };
            function getCenter() {
                var promise = $q.defer();
                if (obj.isDistributor()) {
                    obj.center = obj.profile.firm;
                    promise.resolve(true);
                } else {
                    obj.root.child('catalogs/firms/collection/' + obj.profile.firm + '/center').once('value', function (snap) {
                        obj.center = snap.val();
                        promise.resolve(true);
                    }, function (err) {
                        promise.reject(err);
                    });
                }
                return promise.promise;
            }
            var requests = [getCenter()];
            for (var g = 0; g < obj.groupsOfUser.length; g++) {
                requests.push(getPermission(obj.groupsOfUser[g]));
            }
            return $q.all(requests);
        }
        function downloadFile(method, url, data) {
            try {
                $log.debug('downloadFile init');
                $rootScope.loadingProgress = true;
                $http({
                    method: method,
                    url: window.__env.serviceWorkerUrl + url,
                    data: data,
                    responseType: 'arraybuffer'
                }).then(function (response) {
                    try {
                        var headers = response.headers();
                        var filename = headers['x-filename'];
                        var contentType = headers['content-type'];
                        var linkElement = document.createElement('a');
                        var blobArray = [];
                        if (contentType.indexOf('text/csv') > -1 && contentType.indexOf('utf-8') > -1) {
                            blobArray.push('\ufeff')
                        }
                        blobArray.push(response.data);
                        var blob = new Blob(blobArray, {
                            type: contentType
                        });
                        // var blob = new Blob([response.data], {
                        //     type: contentType
                        // });
                        var url = window.URL.createObjectURL(blob);
                        linkElement.setAttribute('href', url);
                        linkElement.setAttribute("download", filename);
                        var clickEvent = new MouseEvent("click", {
                            'view': window,
                            'bubbles': true,
                            'cancelable': false
                        });
                        linkElement.dispatchEvent(clickEvent);
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync(function () {
                            $log.debug('downloadFile finished');
                        });
                    } catch (error) {
                        errAlertS(error)
                        $rootScope.loadingProgress = false;
                        $rootScope.$evalAsync(function () {
                            $log.debug('downloadFile error');
                        });
                    }
                }).catch(function (error) {
                    var msg = 'Error al solicitar el archivo';
                    if (angular.isDefined(error.data)) {
                        var data = angular.fromJson(String.fromCharCode.apply(null, new Uint8Array(error.data)));
                        if (angular.isObject(data) && angular.isObject(data.data) && angular.isString(data.data.message)) {
                            msg = data.data.message;
                        } else if (angular.isObject(data) && angular.isString(data.message)) {
                            msg = data.message;
                        }
                    } else {
                        $log.error(err);
                    }
                    errAlertS(msg);
                    $rootScope.loadingProgress = false;
                    $rootScope.$evalAsync(function () {
                        $log.debug('downloadFile error');
                    });
                })
            } catch (error) {
                errAlertS(error)
                $rootScope.loadingProgress = false;
                $rootScope.$evalAsync(function () {
                    $log.debug('downloadFile error');
                });
            }
        }

        return obj;
    }

})();

(function () {
    'use strict';

    angular
        .module('fuse')
        .controller('IndexController', IndexController);

    /** @ngInject */
    function IndexController(
        $scope,
        $rootScope,
        $q,
        $firebaseObject,
        $log,
        $sessionStorage,
        $localStorage,
        fuseTheming,
        AppF,
        RoutesF,
        CatalogsF,
        CatalogsZF,
        ListsF,
        DataF,
        MongoF,
        errAlertS,
        msNavigationService,
        $window,
        permissionsForUserFilter,
        userHasPermissionFilter,
        getArrayFromObjectFilter,
        dynamicSortFilter,
        loadObjectsAndListsFilter,
        getMinimumWageFilter,
        $timeout,
        holydaysFilter,
        $mdToast,
        groupByFieldFilter,
        createCcsByPayrollsOfUserFilter
    ) {
        var generalListeners = {};
        AppF.IndexCtrlInitiated = false;
        $rootScope.F = AppF;
        $rootScope.C = CatalogsF;
        $rootScope.Z = CatalogsZF;
        $rootScope.D = DataF;
        $rootScope.M = MongoF;
        $rootScope.L = ListsF;
        $rootScope.R = RoutesF;
        $scope.themes = fuseTheming.themes;
        $scope.listeners = {};
        AppF.allLoaded = false;
        if (!$localStorage.config) { $localStorage.config = {}; }
        if (!$sessionStorage.stateParams) { $sessionStorage.stateParams = {}; }
        function getMainData() {
            return loadObjectsAndListsFilter(RoutesF.initialLoadA);
        }
        $scope.loadDataNeeded = function (menuName) {
            var listsNeededDef = $q.defer();
            ListsF.loadNeeded(ListsF.loadData[menuName]).then(function () {
                listsNeededDef.resolve();
            }).catch(function (error) {
                $log.error(error);
                listsNeededDef.reject(error);
            });
            var mongoNeededDef = $q.defer();
            MongoF.loadNeeded(MongoF.loadData[menuName]).then(function () {
                mongoNeededDef.resolve();
            }).catch(function (error) {
                $log.error(error);
                mongoNeededDef.reject(error);
            });
            var catalogsNeededDef = $q.defer();
            CatalogsF.loadNeeded(CatalogsF.loadData[menuName]).then(function () {
                catalogsNeededDef.resolve();
            }).catch(function (error) {
                $log.error(error);
                catalogsNeededDef.reject(error);
            });
            var requests = [
                listsNeededDef.promise,
                mongoNeededDef.promise,
                catalogsNeededDef.promise
            ];
            return $q.all(requests);
        };
        function listenNotifications() {
            AppF.notifications.readed = AppF.paginator(AppF.root.child('notifications').child(AppF.profile.uid).child('readed'), 10, 'created_at');
            AppF.notifications.notReaded = [];
            return new Promise(function (resolve) {
                resolve([]);
            });
        }
        // Dinamic Menu Items
        function setMenuItems() {
            var promise = $q.defer();
            try {
                // módulos de clientes
                var organizationModules = permissionsForUserFilter(AppF.groupsOfUser, AppF.permissions, 'access', 'organization');
                var capturesModules = permissionsForUserFilter(AppF.groupsOfUser, AppF.permissions, 'access', 'captures');
                var rhModules = permissionsForUserFilter(AppF.groupsOfUser, AppF.permissions, 'access', 'rh');
                var idsePanelModules = permissionsForUserFilter(AppF.groupsOfUser, AppF.permissions, 'access', 'idse-panel');
                var movementsModules = permissionsForUserFilter(AppF.groupsOfUser, AppF.permissions, 'access', 'movements');
                var processesModules = permissionsForUserFilter(AppF.groupsOfUser, AppF.permissions, 'access', 'processes');
                var appsSyncModules = permissionsForUserFilter(AppF.groupsOfUser, AppF.permissions, 'access', 'apps-sync');
                if (
                    organizationModules.length ||
                    capturesModules.length ||
                    rhModules.length ||
                    idsePanelModules.length ||
                    movementsModules.length ||
                    processesModules.length ||
                    appsSyncModules.length
                ) {
                    msNavigationService.saveItem('clients', {
                        title: 'Clientes',
                        group: true,
                        weight: 2
                    });
                    msNavigationService.saveItem('clients.organization', {
                        title: 'Organización', // RH
                        icon: 'icon-hexagon',
                        weight: 1
                    });
                    msNavigationService.saveItem('clients.captures', {
                        title: 'Capturas', // Empleados
                        icon: 'icon-hexagon',
                        weight: 2
                    });
                    msNavigationService.saveItem('clients.rh', {
                        title: 'Recursos Humanos', // Empleados
                        icon: 'icon-hexagon',
                        weight: 3
                    });
                    msNavigationService.saveItem('clients.idse-panel', {
                        title: 'Panel IDSE', // Empleados
                        icon: 'icon-hexagon',
                        weight: 4
                    });
                    msNavigationService.saveItem('clients.movements', {
                        title: 'Movimientos', // Empleados 2
                        icon: 'icon-hexagon',
                        weight: 5
                    });
                    msNavigationService.saveItem('clients.processes', {
                        title: 'Procesos', // Nóminas
                        icon: 'icon-hexagon',
                        weight: 6
                    });
                    msNavigationService.saveItem('clients.apps-sync', {
                        title: 'APPS Sinc.', // Empleados
                        icon: 'icon-hexagon',
                        weight: 7
                    });
                    if (organizationModules.length) { setAllMenuItemsFor(AppF.menuItems.organization, organizationModules); }
                    if (capturesModules.length) { setAllMenuItemsFor(AppF.menuItems.captures, capturesModules); }
                    if (rhModules.length) { setAllMenuItemsFor(AppF.menuItems.rh, rhModules); }
                    if (idsePanelModules.length) { setAllMenuItemsFor(AppF.menuItems['idse-panel'], idsePanelModules); }
                    if (movementsModules.length) { setAllMenuItemsFor(AppF.menuItems.movements, movementsModules); }
                    if (processesModules.length) { setAllMenuItemsFor(AppF.menuItems.processes, processesModules); }
                    if (appsSyncModules.length) { setAllMenuItemsFor(AppF.menuItems['apps-sync'], appsSyncModules); }
                }
                var otherModules = permissionsForUserFilter(AppF.groupsOfUser, AppF.permissions, 'access', 'other');
                var recordsModules = permissionsForUserFilter(AppF.groupsOfUser, AppF.permissions, 'access', 'records');
                var locationsModules = permissionsForUserFilter(AppF.groupsOfUser, AppF.permissions, 'access', 'locations');
                if ((otherModules.length || recordsModules.length || locationsModules.length) && AppF.isDistributor()) {
                    msNavigationService.saveItem('catalogs', {
                        title: 'Catálogos',
                        group: true,
                        weight: 5
                    });
                    msNavigationService.saveItem('catalogs.records', {
                        title: 'Registros',
                        icon: 'icon-hexagon'
                    });
                    msNavigationService.saveItem('catalogs.other', {
                        title: 'Otros',
                        icon: 'icon-hexagon'
                    });
                    msNavigationService.saveItem('catalogs.locations', {
                        title: 'Locaciones',
                        icon: 'icon-hexagon'
                    });
                    setAllMenuItemsFor(AppF.menuItems.records, recordsModules);
                    setAllMenuItemsFor(AppF.menuItems.other, otherModules);
                    setAllMenuItemsFor(AppF.menuItems.locations, locationsModules);
                }
                var appModules = permissionsForUserFilter(AppF.groupsOfUser, AppF.permissions, 'access', 'apps');
                var helpCenterModules = permissionsForUserFilter(AppF.groupsOfUser, AppF.permissions, 'access', 'help-center');
                if (appModules.length) {
                    msNavigationService.saveItem('apps', {
                        title: 'APPS',
                        group: true,
                        weight: 5
                    });
                    setAllMenuItemsFor(AppF.menuItems.apps, appModules.concat(helpCenterModules));
                }
                var configModules = permissionsForUserFilter(AppF.groupsOfUser, AppF.permissions, 'access', 'config');
                if (configModules.length) {
                    msNavigationService.saveItem('config', {
                        title: 'Config',
                        group: true,
                        weight: 6,
                        hidden: function () {
                            return true;
                        }
                    });
                    setAllMenuItemsFor(AppF.menuItems.config, configModules);
                }
                var allItems = msNavigationService.getNavigation();
                for (var ai = 0; ai < allItems.length; ai++) {
                    var parentItem = allItems[ai];
                    for (var ei = 0; ei < parentItem.children.length; ei++) {
                        var subParentItem = parentItem.children[ei];
                        if (!subParentItem.children.length && parentItem.title !== 'APPS') {
                            msNavigationService.deleteItem(parentItem._id + '.' + subParentItem._id);
                        }
                    }
                }
                promise.resolve(true);
            } catch (err) {
                errAlertS(err);
                promise.reject(err);
            }
            return promise.promise;
        }
        function setAllMenuItemsFor(menuItems, modules) {
            var sM = getArrayFromObjectFilter(menuItems);
            var sModulesOfUser = [];
            for (var s = 0; s < sM.length; s++) {
                var thisItem = sM[s];
                var stateA = thisItem.state.split('.');
                var mName = stateA[stateA.length - 1];
                if (modules.indexOf(mName) !== -1) { sModulesOfUser.push(thisItem); }
            }
            var sortedModules = sModulesOfUser.sort(dynamicSortFilter('weight'));
            for (var c = 0; c < sortedModules.length; c++) {
                var moduleC = sortedModules[c];
                if (moduleC.active !== false) { setMenuItem(moduleC); }

            }
        }
        function setMenuItem(menu) {
            if (menu) {
                var menuItem = {
                    title: menu.title
                };
                if (menu.state) { menuItem.state = menu.state; }
                if (menu.alias) { menuItem.alias = menu.alias; }
                if (menu.icon) { menuItem.icon = menu.icon; }
                if (menu.weight) { menuItem.weight = menu.weight; }
                if (menu.action) { menuItem.action = menu.action; }
                if (menu.badge) {
                    menuItem.badge = {
                        content: 13,
                        color: '#09d261'
                    };
                }
                msNavigationService.saveItem(menu.menuItem, menuItem);
            }
        }
        var init = function () {
            AppF.getIp().then(function (ip) {
                AppF.ip = ip;
            }).catch(function (err) {
                $log.debug(err)
            });
            AppF.root.child('version').once('value', function (version) { // solo cuando inicia el sistema
                var val = version.val();
                AppF.systemVersion = (val) ? +val : 'LOCAL';
                if (!$localStorage.systemVersion && AppF.systemVersion !== 'LOCAL') { $localStorage.systemVersion = AppF.systemVersion; }// first set
                if (AppF.systemVersion !== $localStorage.systemVersion) {
                    $mdToast.show({
                        hideDelay: 0,
                        position: 'bottom left',
                        controller: function (scope) {
                            scope.closeToast = function () {
                                $localStorage.systemVersion = AppF.systemVersion;
                                $window.location.reload(true);
                                $mdToast.hide();
                            };
                        },
                        template: '<md-toast>' +
                            '<span class="md-toast-text" flex>Nueva versión del sistema!</span>' +
                            '<md-button class="md-highlight" ng-click="closeToast()">' +
                            '   Actualizar' +
                            '</md-button>' +
                            '</md-toast>'
                    });
                }
            });
            AppF.connected = $firebaseObject(AppF.root.child(RoutesF.dinamicRefs.connected));
            AppF.IndexCtrlInitiated = true;
            AppF.holydaysInMexico = holydaysFilter();
            Promise.all([getMainData(), AppF.getActualTime()]).then(function (resp) {
                AppF.serverTimeStamp = resp[1];
                AppF.currentTimeStamp = new Date().valueOf();
                $log.log("serverTimeStamp:", AppF.serverTimeStamp);
                $log.log("currentTimeStamp:", AppF.currentTimeStamp);
                return $q.all([getMinimumWageFilter()]);
            }).then(function () {
                AppF.permissionToAccessAllPayrolls = userHasPermissionFilter(AppF.groupsOfUser, AppF.permissions, 'accessAll', 'organization.payrolls');
                AppF.permissionToImport = userHasPermissionFilter(AppF.groupsOfUser, AppF.permissions, 'import', 'config.imports');
                var promises = [];
                promises.push(ListsF.loadList('payrolls', 'lists/payrolls/center/' + AppF.center, false, 'array', 'allPayrolls'));
                promises.push(ListsF.loadList('payrolls', 'lists/payrolls/user/' + AppF.user.uid, false, 'array', 'payrolls'));
                promises.push(ListsF.loadList('ccs', 'lists/ccs/user/', AppF.user.uid, 'array', 'userCcs'));
                promises.push(ListsF.loadList('ccs', 'lists/ccs/center/' + AppF.center, undefined, undefined, undefined, [{ q: 'orderByChild', v: 'archived' }, { q: 'endAt', v: false }]));
                promises.push(AppF.holydaysInMexico.matrix.$loaded());
                return $q.all(promises);
            }).then(function (resp) {
                var payrollsOfUser = resp[1];
                var ccsOfUserByPayroll = groupByFieldFilter(resp[2], 'payroll');
                var allCcsByPayroll = groupByFieldFilter(resp[3], 'payroll');
                if (!AppF.permissionToAccessAllPayrolls) {
                    AppF.ccsByPayrollsOfUser = createCcsByPayrollsOfUserFilter(payrollsOfUser, ccsOfUserByPayroll, allCcsByPayroll);
                }

                AppF.isAdmin = (AppF.groupsOfUser.indexOf('super-administradores') !== -1 || AppF.groupsOfUser.indexOf('administradores') !== -1 || AppF.groupsOfUser.indexOf('administradores-jr') !== -1);
                ListsF.loadList('firms', undefined, undefined, undefined, undefined, [{ q: 'orderByChild', v: 'center' }, { q: 'equalTo', v: AppF.center }]);
                loadObjectsAndListsFilter(RoutesF.initialLoadS);
                listenNotifications().then(function () { }, errAlertS);
                $timeout(function () {
                    AppF.allLoaded = true;
                    $rootScope.$emit('allLoaded', true); // lo mas importante ya cargó
                    $rootScope.$evalAsync();
                }, 0, false);
                return setMenuItems();
            }).then(function () {
                var flatNavigation = msNavigationService.getFlatNavigation();
                AppF.navigationItems = [];
                for (var x = 0; x < flatNavigation.length; x++) {
                    if (flatNavigation[x].uisref) {
                        AppF.navigationItems.push(flatNavigation[x]);
                    }
                }
            }).catch(errAlertS);
        };
        generalListeners.initIndex = $rootScope.$on('initIndex', function () {
            if (!AppF.IndexCtrlInitiated) {
                console.log('initIndex')
                init();
            }
        });
        generalListeners.paginate = $scope.$watch('F.paginate', function (paginate) {
            if (paginate) {
                $sessionStorage.paginate = paginate;
            }
        });
        generalListeners.finalListener = $scope.$on('$destroy', function () {
            for (var f in generalListeners) {
                if (generalListeners.hasOwnProperty(f)) {
                    generalListeners[f]();
                }
            }
        });
    }
})();
(function () {
    'use strict';
    angular
        .module('fuse')
        .constant('confirmConfig', {
            onComplete: function afterShowAnimatsion() {
                var $dialog = angular.element(document.querySelector('md-dialog'));
                var $actionsSection = $dialog.find('md-dialog-actions');
                var $cancelButton = $actionsSection.children()[0];
                var $confirmButton = $actionsSection.children()[1];
                angular.element($confirmButton).addClass('md-raised md-warn');
                angular.element($cancelButton).addClass('md-raised');
            }
        })
        .constant('angularMomentConfig', {
            timezone: 'America/Bogota'
        })
        .constant('initialState', 'app.captures.employees')
        .constant('loginRedirectPath', 'app.pages_auth_login')
        .constant('blockedRedirectPath', 'app.pages_auth_lock')
        .constant('tdsLoginStagingPage', 'http://grupotds.com/index2_copy.html')
        .constant('tdsLoginProductionPage', 'https://tdsystem.software/')
        .constant('headers', {
            "Content-type": "application/x-www-form-urlencoded; charset=utf-8"
        })
        .constant('apiv2', {
            dev: 'localhost:3004',
            staging: 'devapiv2.tdsystem.software',
            production: 'apiv2.tdsystem.software'
        })
        .constant('apiv3', {
            dev: 'localhost:3006',
            staging: 'devapiv3.tdsystem.software',
            production: 'apiv3.tdsystem.software'
        })
        .constant('tdsystem2', {
            dev: 'localhost:4600',
            staging: 'docs.dev.tdsystem.software',
            production: 'docs.tdsystem.software'
        })
        .constant('tdsystemAppV2', {
            dev: 'localhost:4400',
            staging: 'devappv2.tdsystem.software',
            production: 'appv2.tdsystem.software'
        })
        // for key-bind directive
        .constant('keyCodes', {
            esc: 27,
            space: 32,
            enter: 13,
            tab: 9,
            backspace: 8,
            shift: 16,
            ctrl: 17,
            alt: 18,
            capslock: 20,
            numlock: 144
        })
        .constant('allowedOfflineStates', [
            'app.pages_auth_token-login',
            'app.pages_auth_login',
            'app.pages_auth_register',
            'app.pages_auth_forgot-password',
            'app.pages_auth_lock',
            'verify-account',
            'app.pages_errors_error-403',
            'app.pages_errors_error-404',
            'app.pages_full-slider'
        ])
})();
(function () {
    'use strict';

    angular
        .module('fuse')
        .config(config);

    /** @ngInject */
    function config($mdDateLocaleProvider) {
        $mdDateLocaleProvider.months = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
        $mdDateLocaleProvider.shortMonths = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sept', 'Oct', 'Nov', 'Dic'];
        $mdDateLocaleProvider.days = ['domingo', 'lunes', 'martes', 'miercoles', 'juevez', 'viernes', 'sabado'];
        $mdDateLocaleProvider.shortDays = ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa'];

        // $mdDateLocaleProvider.monthHeaderFormatter = function(date) {
        //     return myShortMonths[date.getMonth()] + ' ' + date.getFullYear();
        // };

        // Configuracion de formatos de fechas
        // primer día de la semana
        $mdDateLocaleProvider.firstDayOfWeek = 1;

        function toPlaces(dato) {
            dato = dato + "";
            if (dato.length != 2) {
                dato = "0" + dato;
            }
            return dato;
        }
        String.prototype.setString = function (idx, rem, str) {
            return this.slice(0, idx) + str + this.slice(idx + Math.abs(rem));
        };
        $mdDateLocaleProvider.parseDate = function (dateString) {
            if (angular.isString(dateString) && dateString.length === 8) {
                dateString = dateString.setString(4, 0, '-');
                dateString = dateString.setString(2, 0, '-');
            }
            var m = moment(dateString, ['DD-MM-YYYY', 'DD/MM/YYYY'], true);
            if (m.isValid()) {
                var thisDate = new Date(m.year(), m.month(), m.date());
                return thisDate;
            } else {
                return new Date(NaN);
            }
        };
        $mdDateLocaleProvider.isDateComplete = function (dateString) {
            dateString = dateString.trim();
            var flag;
            if (angular.isString(dateString)) {
                if (dateString.length > 7) {
                    flag = true;
                } else {
                    flag = false;
                }
            } else {
                flag = true;
            }
            return flag;
        };
        // se usa cuando se selecciona la fecha desde el selector de fecha y se muestra en el string
        $mdDateLocaleProvider.formatDate = function (date) {
            if (angular.isDefined(date) && date) {
                var currDate = toPlaces(date.getDate());
                var currMonth = toPlaces(date.getMonth() + 1); //Months are zero based
                var currYear = date.getFullYear();
                var m = moment(currYear + '-' + currMonth + '-' + currDate + ' 00:00 -0500', 'YYYY-MM-DD HH:mm Z');
                return m.isValid() ? m.utc().format('DD-MM-YYYY') : '';
            } else {
                return '';
            }
        };

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboards', [
            'app.dashboards.project'
            // ,'app.dashboards.server'
            // ,'app.dashboards.analytics'
        ])
        .config(config);

    /** @ngInject */
    function config(
        $translatePartialLoaderProvider
    )
    {
        $translatePartialLoaderProvider.addPart('app/main/apps/dashboards');
    }

})();
(function() {
    'use strict';

    angular
        .module('app.system', [])
        .config(system);

    /** @ngInject */
    function system(
        $stateProvider, 
        $translatePartialLoaderProvider
        ) {
        // State
        $stateProvider
            .state('app.system', {
                abstract: true,
                url: '/system'
            })
            .state('app.system.modules', {
                url: '/modules',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/system/views/modules/modules.html',
                        controller: 'MongoListsController'
                    }
                },
                bodyClass: 'system'
            })
            .state('app.system.modules.detail', {
                url: '/:moduleId',
                params: {
                    module: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/system/views/modules/module.html',
                        controller: 'MongoDetailController'
                    }
                },
                bodyClass: 'system'
            })
            .state('app.system.actions', {
                url: '/actions/:moduleId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/system/views/actions/actions.html',
                        controller: 'MongoListsController'
                    }
                },
                bodyClass: 'system'
            })
            .state('app.system.actions.detail', {
                url: '/:actionId',
                params: {
                    action: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/system/views/actions/action.html',
                        controller: 'MongoDetailController'
                    }
                },
                bodyClass: 'system'
            })
            .state('app.system.statusRecords', {
                url: '/statusRecords/:moduleId/:actionId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/system/views/statusRecords/statusRecords.html',
                        controller: 'MongoListsController'
                    }
                },
                bodyClass: 'system'
            })
            .state('app.system.statusRecords.detail', {
                url: '/:statusRecordId',
                params: {
                    statusRecord: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/system/views/statusRecords/statusRecord.html',
                        controller: 'MongoDetailController'
                    }
                },
                bodyClass: 'system'
            })
            ;

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/system');
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages', [
            'app.pages.auth.login',
            //'app.pages.auth.register',
            'app.pages.auth.forgot-password',
            'app.pages.auth.reset-password',
            'app.pages.auth.token-login',
            'app.pages.auth.lock',
            // 'app.pages.coming-soon',
            'app.pages.full-slider',
            'app.pages.error-404',
            'app.pages.error-403',
            // 'app.pages.error-500',
            'app.pages.invoice',
            'app.pages.maintenance'
            //'app.pages.profile',
            // 'app.pages.search'
            //'app.pages.timeline'
        ])
        .config(config);

    /** @ngInject */
    function config()
    {
        
        // msNavigationServiceProvider.saveItem('pages', {
        //     title : 'PAGES',
        //     group : true,
        //     hidden: function(){
        //         return true;
        //     },
        //     weight: 8
        // });
    }
})();
angular.module("fuse").run(["$templateCache", function($templateCache) {$templateCache.put("app/quick-panel/quick-panel.html","<md-content><md-tabs md-swipe-content class=\"smallTabs\"><md-tab label=\"Historial de cambios\"><md-tab-body><md-content \nclass=\"activity-tab scrollable\" ms-scroll ng-include=\"\'app/quick-panel/tabs/logs/logs-tab.html\'\"></md-content>\n</md-tab-body></md-tab></md-tabs></md-content>");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up md-background md-hue-1\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-background md-hue-1\" ui-view=\"content\" flex></md-content><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar\" ui-view=\"toolbar\"></md-toolbar><div id=\"horizontal-navigation\" class=\"md-whiteframe-1dp\" \nui-view=\"navigation\"></div><div id=\"content-container\" flex layout=\"column\"><md-content id=\"content\" \nclass=\"animate-slide-up md-background md-hue-1\" ms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav \nid=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll \nui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar-2\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex \nlayout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-background md-hue-1\" ms-scroll ui-view=\"content\" \nflex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><div id=\"main-container\" \nlayout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" \nmd-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex \nlayout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-background md-hue-1\" ms-scroll ui-view=\"content\" \nflex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nclass=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll \nui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-background md-hue-1\" ms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav \nid=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll \nui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/theme-options/theme-options.html","<div class=\"ms-theme-options-panel\" layout=\"row\" layout-align=\"start start\"><div \nclass=\"ms-theme-options-panel-button md-primary-bg\" ng-click=\"toggleOptionsPanel()\"><md-icon md-font-icon=\"icon-cog\" \nclass=\"white-text\"></md-icon></div><div class=\"ms-theme-options-list\" layout=\"column\"><div class=\"theme-option\"><div \nclass=\"option-title\">Layout Style:</div><md-radio-group layout=\"column\" ng-model=\"vm.layoutStyle\" \nng-change=\"vm.updateLayoutStyle()\"><md-radio-button value=\"verticalNavigation\">Vertical Navigation</md-radio-button>\n<md-radio-button value=\"verticalNavigationFullwidthToolbar\">Vertical Navigation with Fullwidth Toolbar\n</md-radio-button><md-radio-button value=\"verticalNavigationFullwidthToolbar2\">\nVertical Navigation with Fullwidth Toolbar 2</md-radio-button><md-radio-button value=\"horizontalNavigation\">\nHorizontal Navigation</md-radio-button><md-radio-button value=\"contentOnly\">Content Only</md-radio-button>\n<md-radio-button value=\"contentWithToolbar\">Content with Toolbar</md-radio-button></md-radio-group></div><md-divider>\n</md-divider><div class=\"theme-option\"><div class=\"option-title\">Layout Mode:</div><md-radio-group layout=\"row\" \nlayout-align=\"start center\" ng-model=\"vm.layoutMode\" ng-change=\"vm.updateLayoutMode()\"><md-radio-button value=\"boxed\">\nBoxed</md-radio-button><md-radio-button value=\"wide\">Wide</md-radio-button></md-radio-group></div><md-divider>\n</md-divider><div class=\"theme-option\"><div class=\"option-title\">Color Palette:</div><md-menu-item \nng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"theme\"><md-button class=\"md-raised theme-button\" \naria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" \nng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" \nng-class=\"themeName\"><span><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" md-font-icon=\"icon-palette\">\n</md-icon><span>{{themeName}}</span></span></md-button></md-menu-item></div></div></div>");
$templateCache.put("app/main/catalogs/catalogs.html","<div id=\"clients\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"search-wrapper md-whiteframe-4dp\" layout=\"row\" layout-align=\"start center\" flex></div></div><div \nclass=\"content-card\" layout=\"column\" flex>Dashboard de Catalogos</div></div></div>");
$templateCache.put("app/main/clients/clients.html","<div id=\"clients\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"search-wrapper md-whiteframe-4dp\" layout=\"row\" layout-align=\"start center\" flex></div></div><div \nclass=\"content-card\" layout=\"column\" flex>Dashboard de Clientes</div></div></div>");
$templateCache.put("app/main/config/config.html","<div id=\"config\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"search-wrapper md-whiteframe-4dp\" layout=\"row\" layout-align=\"start center\" flex></div></div><div \nclass=\"content-card\" layout=\"column\" flex>Dashboard de Configuración</div></div></div>");
$templateCache.put("app/main/system/system.html","");
$templateCache.put("app/core/directives/active-indicator/active-indicator.html","<div class=\"quantity-indicator\" ng-class=\"{\'md-red-500-bg\': !active, \'md-green-600-bg\': active }\"></div>");
$templateCache.put("app/core/directives/custom-fields/custom-fields.html","<div id=\"customFields\" layout-wrap layout=\"row\"><div ng-if=\"((!field.validation) || field.validationResult)\" \nflex=\"{{field.width}}\" ng-repeat=\"($index,field) in fields\" layout=\"row\" layout-align=\"start start\"><div flex>\n<md-autocomplete ng-if=\"field.type===\'autocompleteM\' && !field.requiredModal\" flex=\"{{field.width}}\" \nng-required=\"field.required\" md-no-cache=\"true\" md-input-name=\"{{field.id}}\" \nmd-selected-item=\"mainObject[field.id+\'Data\']\" md-search-text=\"mainObject[field.id]\" \nmd-items=\"item in querySearch(mainObject[field.id],field.catalog,field.query,field.project,field.itemName)\" \nmd-item-text=\"item.nameSet\" md-require-match md-select-on-match md-floating-label=\"{{field.label}}\"><md-item-template>\n<span md-highlight-text=\"mainObject[field.id]\">{{item.nameSet}}</span></md-item-template><md-not-found>Sin resultados\n</md-not-found><div ng-messages=\"form[field.id].$error\"><div ng-message=\"required\">Este campo es requerido</div><div \nng-message=\"md-require-match\">Seleccione un elemento de la lista</div></div></md-autocomplete><md-input-container \nclass=\"md-block no-errors-spacer\" ng-if=\" [\'autocompleteM\'].indexOf(field.type)===-1 && !field.requiredModal\"><label>\n{{field.id !== \'branch\' ? field.label : undefined }}</label><input \nng-if=\"[\'text\',\'alphanumeric\'].indexOf(field.type) > -1\" validate-fields=\"field\" type=\"text\" name=\"{{field.id}}\" \nng-model=\"mainObject[field.id]\" md-minlength=\"field.min\" minlength=\"{{field.min}}\" md-maxlength=\"field.max\" \nmaxlength=\"{{field.max}}\" ng-disabled=\"field.readonly\" ng-required=\"field.required\"> <input \nng-if=\"field.id !== \'branch\'? field.type==\'number\' : undefined && !field.requiredModal\" validate-fields=\"field\" \ntype=\"number\" name=\"{{field.id}}\" min=\"{{field.min}}\" max=\"{{field.max}}\" ng-disabled=\"field.readonly\" \nng-model=\"mainObject[field.id]\" ng-required=\"field.required\"><textarea \nng-if=\"field.type==\'textarea\' && !field.requiredModal\" validate-fields=\"field\" name=\"{{field.id}}\" \nng-model-options=\"{ debounce:debounceTime }\" md-minlength=\"field.min\" minlength=\"{{field.min}}\" \nmd-maxlength=\"field.max\" maxlength=\"{{field.max}}\" ng-disabled=\"field.readonly\" ng-model=\"mainObject[field.id]\" \nng-required=\"field.required\"></textarea><md-datepicker md-hide-icons=\"calendar\" \nng-if=\"field.type==\'date\' && !field.requiredModal\" name=\"{{field.id}}-value-{{$index}}\" \nng-model=\"mainObject[field.id]\" input-date-miliseconds class=\"md-block\" ng-disabled=\"field.readonly\" \nng-required=\"field.required\"></md-datepicker><md-select ng-if=\"field.type==\'select\' && !field.requiredModal\" \nname=\"{{field.id}}\" ng-model=\"mainObject[field.id]\" ng-disabled=\"field.readonly\" \nng-change=\"setData(mainObject[field.id],field.values,mainObject,field.id)\" ng-required=\"field.required\"><md-option \nng-value=\"thisValue.id\" ng-repeat=\"thisValue in field.values track by thisValue.id\">{{thisValue.name}}</md-option>\n</md-select><div ng-messages=\"form[field.id].$error\" role=\"alert\"><div ng-message=\"required\">\nEl campo {{field.label}} es requerido</div><div ng-message=\"min\">EL valor no puede ser menor a {{field.min}}</div><div \nng-message=\"max\">EL valor no puede ser mayor a {{field.max}}</div><div ng-message=\"minlength\">\nLa longitud minima debe ser {{field.min}}</div><div ng-message=\"maxlength\">La longitud maxima debe ser {{field.max}}\n</div></div></md-input-container></div><div flex=\"nogrow\" class=\"infoInput\" ng-if=\"field.info\"><md-button \nclass=\"md-icon-button md-primary\" aria-label=\"message\"><md-tooltip md-direction=\"top\">{{field.info}}</md-tooltip>\n<md-icon md-font-icon=\"icon-alert-octagon\"></md-icon></md-button></div></div></div>");
$templateCache.put("app/core/directives/factor-table/factor-table.html","<div class=\"factorTable\"><div class=\"isFieldset md-whiteframe-2dp\"><label class=\"legend\">Factor de Integracion</label>\n<table class=\"simple miniTable\"><thead><tr><th>Años</th><th>V<md-tooltip md-direction=\"top\">Vacaciones</md-tooltip>\n</th><th>P<md-tooltip md-direction=\"top\">Prima Vacacional</md-tooltip></th><th>A<md-tooltip md-direction=\"top\">\nAguinaldo</md-tooltip></th><th>O<md-tooltip md-direction=\"top\">Otros</md-tooltip></th><th>Factor</th></tr></thead>\n<tbody><tr ng-repeat=\"($index,row) in tableOfValues\" ng-class=\"{\'emphasisItem\':factorSelected==row.factor}\"><td><label \nng-if=\"row.factor==desireFactor\">*<md-tooltip md-visible=\"demo.showTooltip\">Factor correspondiente a la fecha actual\n</md-tooltip></label>\n{{ $index-1 >= 0? (tableOfValues[$index-1].year+1 == row.year ? \'\' : tableOfValues[$index-1].year + 1 +\' - \') : (row.limit>1?\'1 - \':\'\') }} {{row.year}}\n</td><td>{{row.daysOfVacation}}</td><td>{{row.prime}}</td><td>{{row.christmasBonus}}</td><td>{{row.othersTotal}}</td>\n<td>{{row.factor}}</td></tr></tbody></table></div></div>");
$templateCache.put("app/core/directives/ids-object/ids-object.html","<div class=\"idsObject\"><div layout=\"row\"><md-select ng-disabled=\"readMode\" name=\"{{objectName}}\" flex \nng-model=\"newItem\" aria-label=\"select item\"><md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" \nng-keydown=\"$event.stopPropagation()\" ng-model=\"itemSelectFilter\" placeholder=\"Busque una {{objectName}}\">\n</md-select-header><md-option ng-disabled=\"itemInModel(item.$id)\" ng-value=\"item\" \nng-repeat=\"item in items | orderBy:\'name\' | filter:itemSelectFilter\">{{item.name}}</md-option></md-select><div \nflex=\"nogrow\"><md-button ng-disabled=\"!newItem||readMode\" ng-click=\"addItem(newItem)\" class=\"md-primary md-raised\" \naria-label=\"Add item\"><md-tooltip md-direction=\"left\">Agregar</md-tooltip><md-icon md-font-icon=\"icon-plus\" \naria-label=\"Add\"></md-icon></md-button></div></div><div flex layout=\"column\" \nng-sortable=\"sortableOptionsPaymentSchema\" ng-model=\"modelArray\"><div flex class=\"item\" \nng-repeat=\"item in modelArray track by item.$id\" layout=\"row\" layout-align=\"end center\"><md-input-container \nclass=\"md-block no-margin\" md-no-float flex><span class=\"title\">{{item.$id | getSomethingOfArrayFB:items:\"name\":\"S/N\"}}\n</span></md-input-container><md-input-container class=\"md-block no-margin\" md-no-float flex \nng-if=\"inputFieldName && inputFieldId\"><input ng-disabled=\"F.readMode\" type=\"text\" name=\"inputField{{item.$id}}\" \nplaceholder=\"{{inputFieldName}}\" ng-model=\"model[item.$id][inputFieldId]\" \nng-model-options=\"{ debounce: F.debounceTime }\" required><div ng-messages=\'form[\"inputField\"+item.$id].$error\' \nrole=\"alert\"><div ng-message=\"required\">{{inputFieldName}} es requerido</div></div></md-input-container>\n<md-input-container class=\"md-block no-margin\" md-no-float flex ng-if=\"inputName && inputId\"><input \nng-disabled=\"F.readMode\" type=\"text\" name=\"input{{item.$id}}\" placeholder=\"{{inputName}}\" \nng-model=\"model[item.$id][inputId]\" ng-model-options=\"{ debounce: F.debounceTime }\" required><div \nng-messages=\'form[\"input\"+item.$id].$error\' role=\"alert\"><div ng-message=\"required\">{{inputName}} es requerido</div>\n</div></md-input-container><md-input-container class=\"md-block no-margin\" md-no-float flex \nng-if=\"inputOperationName && inputOperationId\"><input ng-disabled=\"F.readMode\" type=\"text\" \nname=\"inputOperation{{item.$id}}\" placeholder=\"{{inputOperationName}}\" ng-model=\"model[item.$id][inputOperationId]\" \nng-model-options=\"{ debounce: F.debounceTime }\"><div ng-messages=\'form[\"inputOperation\"+item.$id].$error\' role=\"alert\">\n<div ng-message=\"required\">{{inputOperationName}} es requerido</div></div></md-input-container><md-input-container \nclass=\"md-block no-margin\" md-no-float flex ng-if=\"model[item.$id].forPayrolls\"><md-chips \nng-model=\"model[item.$id].payrolls\" md-transform-chip=\"transformChip($chip)\" md-require-match=\"true\"><md-autocomplete \nmd-selected-item=\"selectedItem\" md-search-text=\"searchText\" md-items=\"item in querySearch(searchText)\" \nmd-item-text=\"item.name\" placeholder=\"Agregar una nómina\"><md-item-template><span>{{item.name}}</span>\n</md-item-template><md-not-found>No se encontraron resultados.</md-not-found></md-autocomplete><md-chip-template><span>\n{{ getNameFromId($chip) }}</span></md-chip-template></md-chips></md-input-container><div flex=\"nogrow\" \nng-if=\"showOnReport && model[item.$id].hiddenColumn\" class=\"pr-10\"><md-checkbox \nng-model=\"model[item.$id].showOnReport\" aria-label=\"showOnReport\">Mostrar en Reporte</md-checkbox></div><div \nflex=\"nogrow\" ng-if=\"showHiddenColumn\"><md-checkbox ng-model=\"model[item.$id].hiddenColumn\" aria-label=\"hiddenColumn\">\nNo Mostrar</md-checkbox></div><div flex=\"nogrow\" ng-if=\"payrolls\" class=\"ml-5\"><md-checkbox \nng-model=\"model[item.$id].forPayrolls\" aria-label=\"hiddenColumn\">Nóminas a aplicar</md-checkbox></div><div \nflex=\"nogrow\"><md-button ng-disabled=\"readMode\" ng-click=\"removeItem(item.$id)\" \nclass=\"md-warn md-fab md-mini md-raised\" aria-label=\"Remove item\"><md-tooltip md-direction=\"left\">Borrar</md-tooltip>\n<md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button></div></div></div></div>");
$templateCache.put("app/core/directives/ms-info-bar/ms-info-bar.html","<div id=\"ms-info-bar\" layout=\"row\" layout-align=\"start center\" flex><div id=\"ms-info-bar-message\" ng-transclude flex>\n</div><md-button id=\"ms-info-bar-close\" class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"removeInfoBar()\"><md-icon \nmd-font-icon=\"icon-close s24\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><div ng-click=\"$mdOpenMenu($event)\"><ms-color-picker-button><md-button \naria-label=\"Row Color\" md-menu-origin ng-click=\"$mdOpenMenu($event)\" ng-class=\"vm.selectedColor.class\"><span \nng-show=\"vm.selectedColor.palette\">{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span \nng-show=\"!vm.selectedColor.palette\">Select Color</span></md-button></ms-color-picker-button></div><md-menu-content \nclass=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"vm.selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"vm.activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!vm.selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"vm.selectedColor.palette\">\n{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span ng-if=\"!vm.selectedColor.palette\">Select Color\n</span><md-button class=\"remove-color-button md-icon-button\" ng-click=\"vm.removeColor()\" aria-label=\"Remove Color\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-show=\"!vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in vm.palettes\" ng-click=\"vm.activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-show=\"vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" \nng-class=\"\'md-\'+vm.selectedPalette+\'-\'+hue+\'-bg\'\" ng-repeat=\"(hue, values) in vm.selectedHues\" \nng-click=\"vm.selectColor(vm.selectedPalette,hue)\" layout=\"row\" layout-align=\"start end\" md-ink-ripple><span \nclass=\"label\">{{hue}} </span><i ng-if=\"vm.selectedPalette == vm.selectedColor.palette && hue == vm.selectedColor.hue\" \nclass=\"s16 icon-check\"></i></div></div></div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-button \nclass=\"ms-search-bar-expander md-icon-button\" aria-label=\"Expand Search Bar\" ng-click=\"MsSearchBar.expand()\" \nng-if=\"!MsSearchBar.resultsLoading || MsSearchBar.collapsed\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\">\n</md-icon></md-button><div class=\"ms-search-bar-loader\" layout=\"row\" layout-align=\"center center\" \nng-if=\"MsSearchBar.resultsLoading && !MsSearchBar.collapsed\"><md-progress-circular class=\"md-accent\" md-diameter=\"48\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></label><input id=\"ms-search-bar-input\" type=\"text\" \nplaceholder=\"Search\" flex ng-model=\"MsSearchBar.query\" ng-model-options=\"MsSearchBar.queryOptions\" \nng-blur=\"MsSearchBar.collapse()\" ng-keydown=\"MsSearchBar.handleKeydown($event)\"><md-button \nclass=\"ms-search-bar-collapser md-icon-button\" ng-click=\"MsSearchBar.collapse()\" aria-label=\"Collapse Search Bar\">\n<md-icon md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></md-button><div class=\"ms-search-bar-results\" \nng-if=\"MsSearchBar.results\" ms-scroll><div class=\"no-results\" ng-if=\"MsSearchBar.results.length === 0\">No Results!\n</div><div class=\"result\" ng-repeat=\"result in MsSearchBar.results\" ng-click=\"MsSearchBar.handleResultClick(result)\" \nng-mouseenter=\"MsSearchBar.handleMouseenter($index)\" ng-mousedown=\"MsSearchBar.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsSearchBar.selectedResultIndex}\" md-ink-ripple><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"icon-container\" layout=\"row\" layout-align=\"center center\"><i \nng-if=\"result.icon\" class=\"{{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div><div>\n<div class=\"title\">{{result.title}}</div><div class=\"description\" ng-if=\"result.description\">{{result.description}}\n</div></div></div></div></div></div>");
$templateCache.put("app/core/directives/ms-shortcuts/ms-shortcuts.html","<div class=\"shortcuts-container\" layout=\"row\" layout-align=\"start center\" flex><div class=\"shortcuts\" layout=\"row\" \nlayout-align=\"start center\" ms-scroll ng-if=\"MsShortcuts.shortcuts.length > 0\" \nng-sortable=\"MsShortcuts.sortableOptions\"><div ng-repeat=\"shortcut in MsShortcuts.shortcuts\" layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button shortcut\" aria-label=\"{{shortcut.title}}\" \nui-sref=\"{{shortcut.uisref}}\"><md-icon ng-if=\"shortcut.icon\" md-font-icon=\"{{shortcut.icon}}\" class=\"icon s24\">\n</md-icon><div ng-if=\"!shortcut.icon\" class=\"first-letter\">{{shortcut.title.charAt(0)}}</div><md-tooltip \nmd-direction=\"bottom\">{{shortcut.title}}</md-tooltip></md-button></div></div><md-menu md-offset=\"8 56\"><md-button \nclass=\"md-icon-button add-shortcut-button\" aria-label=\"Add shortcut\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-star\" class=\"icon amber-600-fg s20\"></md-icon><md-tooltip md-direction=\"bottom\">\nClick to add/remove shortcut</md-tooltip></md-button><md-menu-content><div id=\"ms-shortcut-add-menu\"><div \nclass=\"shortcut-search\" layout=\"row\" layout-align=\"start center\"><div class=\"search-icon\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!MsShortcuts.resultsLoading\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon></div><div class=\"shortcut-loader\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"MsShortcuts.resultsLoading\"><md-progress-circular class=\"md-accent\" \nmd-diameter=\"40\" md-mode=\"indeterminate\"></md-progress-circular></div><input type=\"text\" placeholder=\"Search\" flex \nng-model=\"MsShortcuts.query\" ng-model-options=\"MsShortcuts.queryOptions\" \nng-keydown=\"MsShortcuts.handleKeydown($event)\"></div><div class=\"results\" ng-if=\"MsShortcuts.results\" ms-scroll><div \nclass=\"no-results\" ng-if=\"MsShortcuts.results.length === 0\">No Results!</div><div class=\"result\" \nng-repeat=\"result in MsShortcuts.results\" ng-click=\"MsShortcuts.handleResultClick(result)\" \nng-mouseenter=\"MsShortcuts.handleMouseenter($index)\" ng-mousedown=\"MsShortcuts.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsShortcuts.selectedResultIndex}\" md-prevent-menu-close=\"md-prevent-menu-close\" \nmd-ink-ripple><div layout=\"row\" layout-align=\"start space-between\"><div layout=\"row\" layout-align=\"start center\" flex>\n<div class=\"icon-container\" layout=\"row\" layout-align=\"center center\"><i ng-if=\"result.icon\" class=\"{{result.icon}}\">\n</i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div><div><div class=\"title\">{{result.title}}</div>\n</div></div><md-icon md-font-icon=\"icon-pin\" class=\"icon s18\" ng-class=\"{\'fade-text\': !result.hasShortcut}\"></md-icon>\n</div></div></div></div></md-menu-content></md-menu></div>");
$templateCache.put("app/core/directives/ms2-speed-dial/ms2-speed-dial.html","<md-fab-speed-dial md-open=\"isOpen\" md-direction=\"{{direction}}\" class=\"md-fling ms2-speed-dial\" \nng-click=\"isOpen = !isOpen\" ng-class=\"positionClass\"><md-fab-trigger><md-button aria-label=\"crud menu\" \nclass=\"md-fab md-accent\" md-class=\"{\'md-hue-1\': selected.length}\"><md-icon md-font-icon=\"icon-cube\"></md-icon>\n</md-button></md-fab-trigger><md-fab-actions><md-button ng-if=\"actions.delete && selected.length\" ng-click=\"delete()\" \naria-label=\"Delete\" class=\"md-fab md-raised md-warn md-mini\"><md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\">\n</md-icon></md-button><md-button ng-if=\"actions.archive && selected.length\" ng-click=\"archive()\" \naria-label=\"Archive Selected\" class=\"md-fab md-raised md-mini\"><md-icon md-font-icon=\"icon-archive\" \naria-label=\"Archive\"></md-icon></md-button><md-button ng-if=\"actions.add && !selected.length\" \nng-click=\"F.goToState(addState, addParams)\" aria-label=\"add\" class=\"md-fab md-raised md-mini\"><md-icon \nmd-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon></md-button><md-button ng-if=\"actions.config && !selected.length\" \nng-click=\"F.goToState(configState)\" aria-label=\"config\" class=\"md-fab md-raised md-mini\"><md-icon \nmd-font-icon=\"icon-cog\" aria-label=\"config\"></md-icon></md-button></md-fab-actions></md-fab-speed-dial>");
$templateCache.put("app/core/directives/table-loader/table-loader.html","<div layout-align=\"center center\" ng-show=\"!array.length\" class=\"md-accent noData\"><h1 \nng-repeat=\"validation in validations\" ng-if=\"!validation.valid\" class=\"md-subhead\">{{validation.msg}}</h1><div \nclass=\"container\" ng-show=\"loadingProgress\"><md-progress-linear md-mode=\"query\" ng-disabled=\"!loadingProgress\">\n</md-progress-linear><div class=\"bottom-block\"><span>Filtrando resultados...</span></div></div></div>");
$templateCache.put("app/core/directives/table-values/table-values.html","<div class=\"tableValues\" ng-class=\"{\'isFieldset\':tableOfValues.length>1 || showLabelAllways}\"><h3 class=\"noMargin\" \nng-class=\"{\'isLegend\':tableOfValues.length>1}\" ng-if=\"tableOfValues.length > 1 || showLabelAllways\">{{label}}</h3>\n<ng-transclude></ng-transclude><md-input-container class=\"md-block noMarginBottom\" flex=\"100\" \nng-if=\"tableOfValues.length <= 1\"><label>{{label}}</label><input type=\"number\" ignore-mouse-wheel name=\"{{label}}\" \nng-model=\"tableOfValues[0].value\" ng-disabled=\"formDisabled\" step=\"1\" min=\"0\" max=\"366\" required><div \nng-messages=\"form[label].$error\" role=\"alert\"><div ng-message=\"min\">Debe ingresar un valor que represente dias</div>\n<div ng-message=\"max\">No se puede ingresar mas dias de un año</div><div ng-message=\"required\">Este dato es requerido\n</div></div></md-input-container><div layout=\"row\" layout-align=\"end start\" \nng-if=\"!formDisabled && tableOfValues.length <= 1\"><div flex=\"nogrow\"><md-button class=\"md-icon-button\" \naria-label=\"add record\" ng-click=\"addRecord()\"><md-tooltip md-direction=\"top\">\nAñadir mas registros segun fecha de antiguedad</md-tooltip><md-icon md-font-icon=\"icon-table-row-plus-after\" \naria-label=\"add record\"></md-icon></md-button></div></div><div ng-if=\"tableOfValues.length>1\"><code \nng-if=\"editMode && helpText\" class=\"help\">{{helpText}}</code><table class=\"simple miniTable\"><thead><tr><th>Años</th>\n<th>Dias</th><th ng-if=\"!formDisabled\" class=\"iconbutton\"><md-button class=\"md-icon-button\" aria-label=\"save table\" \nng-if=\"!editMode\" ng-click=\"setEditMode(true)\"><md-tooltip md-direction=\"top\">Editar tabla</md-tooltip><md-icon \nmd-font-icon=\"icon-pencil\" aria-label=\"Edit table\"></md-icon></md-button><md-button class=\"md-icon-button\" \nng-disabled=\"hasErrors\" aria-label=\"save table\" ng-if=\"editMode\" ng-click=\"setEditMode(false)\"><md-tooltip \nmd-direction=\"top\">Guardar tabla</md-tooltip><md-icon md-font-icon=\"icon-content-save\" aria-label=\"save table\">\n</md-icon></md-button></th></tr></thead><tbody><tr ng-repeat=\"($index,row) in tableOfValues\"><td \nng-if=\"editMode && !formDisabled\" class=\"valigntop noPadding\"><md-input-container class=\"md-block noMargin\" \nmd-no-float><input type=\"number\" name=\"{{label}}-limit-{{$index}}\" ng-model=\"row.limit\" placeholder=\"Años\" \nignore-mouse-wheel step=\"1\" ng-min=\"$index==0?1:tableOfValues[$index-1].limit+1\" max=\"59\" required><div \nng-messages=\'form[label+\"-limit-\"+$index].$error\' role=\"alert\"><div ng-message=\"min\">\nDebe ser un numero mayor al limite del registro anterior {{tableOfValues[$index-1].limit}}</div><div ng-message=\"max\">\nSolo se aceptan hasta 59</div><div ng-message=\"required\">Este dato es requerido</div></div></md-input-container></td>\n<td ng-if=\"(!editMode || formDisabled)\">\n{{ $index-1 >= 0? (tableOfValues[$index-1].limit+1 == row.limit ? \'\' : tableOfValues[$index-1].limit + 1 +\' - \') : (row.limit>1?\'1 - \':\'\') }} {{row.limit}}\n</td><td ng-if=\"editMode && !formDisabled\" class=\"valigntop noPadding\"><md-input-container class=\"md-block noMargin\" \nmd-no-float><input type=\"number\" name=\"{{label}}-value-{{$index}}\" ng-model=\"row.value\" placeholder=\"Dias\" \nignore-mouse-wheel step=\"1\" min=\"0\" max=\"366\" required><div ng-messages=\'form[label+\"-value-\"+$index].$error\' \nrole=\"alert\"><div ng-message=\"min\">Debe ingresar un valor que represente dias</div><div ng-message=\"max\">\nNo se puede ingresar mas dias de un año</div><div ng-message=\"required\">Este dato es requerido</div></div>\n</md-input-container></td><td ng-if=\"!editMode\">{{row.value}}</td><td ng-if=\"!formDisabled\" \nclass=\"iconbutton noPadding\" ng-class=\"{\'valigntop\':editMode}\"><md-button class=\"md-icon-button\" \nng-click=\"removeRecord($index)\" ng-disabled=\"!editMode\"><md-tooltip md-direction=\"left\">Eliminar</md-tooltip><md-icon \nmd-font-icon=\"icon-trash\" aria-label=\"Add\"></md-icon></md-button></td></tr><tr ng-if=\"editMode\"><td \ncolspan=\"{{formDisabled?1:2}}\">&nbsp;</td><td class=\"iconbutton\"><md-button class=\"md-icon-button\" \naria-label=\"add record\" ng-click=\"addRecord()\"><md-tooltip md-direction=\"top\">\nAñadir mas registros segun fecha de antiguedad</md-tooltip><md-icon md-font-icon=\"icon-table-row-plus-after\" \naria-label=\"add record\"></md-icon></md-button></td></tr></tbody></table></div></div>");
$templateCache.put("app/main/acommon/directives/cc-child.html","<div id=\"cc-child\"><div layout=\"row\"><div id=\"body\" flex layout=\"row\"><div flex ng-if=\"ccCtrl.mode === \'readMode\'\"><div\n ng-if=\"ccCtrl.object.type === \'concept\'\" flex layout=\"column\" class=\"p-0 m-0\"><div flex><b>CUENTA:</b>\n {{ccCtrl.object.account.toUpperCase()}}</div><div flex><b>CONCEPTOS:</b> <span \nng-repeat=\"concept in ccCtrl.conceptsWithData\" class=\"text-boxed\" style=\"white-space:normal\">\n{{concept.name}}{{concept.payrollName ? \' [\' + concept.payrollName + \']\' : \'\'}}</span></div></div><div \nng-if=\"ccCtrl.object.type === \'level\' && (!ccCtrl.object.conditioned)\" layout=\"row\" layout-align=\"start center\"><div \nflex=\"nogrow\"><b>CUENTA:</b> {{ccCtrl.object.account.toUpperCase()}}</div><div flex=\"nogrow\" class=\"ml-10\"><b>NOMBRE:\n</b> {{ccCtrl.object.name.toUpperCase()}}</div></div><div \nng-if=\"ccCtrl.object.type === \'level\' && ccCtrl.object.conditioned\" layout=\"row\" class=\"p-0 m-0\" \nlayout-align=\"start space-between\"><div flex=\"nogrow\"><div ng-repeat=\"row in ccCtrl.object.conditions\" class=\"p-0 m-0\" \nlayout=\"row\" layout-align=\"start start\"><div flex=\"nogrow\"><b>CUENTA:</b> {{row.account.toUpperCase()}}</div><div flex \nclass=\"ml-10\" ng-class=\"{\'red-500-fg\': !ccList[row.ccId].valid }\"><em class=\"blue-900-fg font-weight-900\">\n{{ccList[row.ccId].payrollName}}: </em>{{ccList[row.ccId].name}} [{{ccList[row.ccId].placeOfWork}}]</div></div></div>\n</div></div><div flex ng-if=\"ccCtrl.mode === \'editMode\'\" layout-wrap layout=\"row\"><md-input-container flex=\"nogrow\" \nng-if=\"ccCtrl.object.type === \'level\'\" \nng-class=\"{\'mb-0\':(!ccCtrl.object.conditioned),\'m-0\':ccCtrl.object.conditioned}\" class=\"md-block no-errors-spacer\">\n<md-checkbox ng-model=\"ccCtrl.object.conditioned\" ng-change=\"ccCtrl.toggleConditioned()\" \naria-label=\"toggleConditioned\"><md-tooltip>Configurar cuentas por centro de costo</md-tooltip>CC</md-checkbox>\n</md-input-container><div flex ng-if=\"ccCtrl.object.conditioned\"></div><md-input-container flex \nng-if=\"!ccCtrl.object.conditioned\" class=\"md-block no-errors-spacer mb-0\"><label>Cuenta</label><input \nmd-maxlength=\"50\" class=\"m-0 p-0 uppercased\" required placeholder=\"Ingrese una cuenta\" name=\"cuenta\" \nng-model=\"ccCtrl.object.account\"></md-input-container><md-input-container flex \nng-if=\"ccCtrl.object.type === \'level\' && !ccCtrl.object.conditioned\" class=\"md-block no-errors-spacer mb-0\"><label>\nNombre</label><input md-maxlength=\"50\" class=\"uppercased\" required placeholder=\"Nombre\" name=\"name\" \nng-model=\"ccCtrl.object.name\"></md-input-container><div flex=\"nogrow\" layout=\"row\" layout-align=\"end start\"><div>\n<md-icon class=\"green-600-fg pointer\" \nng-if=\"(!ccCtrl.parentIsConcept) && (ccCtrl.object.type !== \'concept\') && type===\'debit\'\" \nng-click=\"ccCtrl.addChildren(\'concept\')\" md-svg-src=\"/assets/icons/concept-give.svg\"><md-tooltip md-direction=\"bottom\">\nAgregar Concepto</md-tooltip></md-icon><md-icon class=\"green-600-fg pointer\" \nng-if=\"(!ccCtrl.parentIsConcept) && (ccCtrl.object.type !== \'concept\') && type===\'credit\'\" \nng-click=\"ccCtrl.addChildren(\'concept\')\" md-svg-src=\"/assets/icons/concept-receive.svg\"><md-tooltip \nmd-direction=\"bottom\">Agregar Concepto</md-tooltip></md-icon></div><div><md-icon \nmd-svg-src=\"/assets/icons/bx-layer-plus.svg\" ng-click=\"ccCtrl.addChildren(\'level\')\" class=\"blue-600-fg pointer\">\n<md-tooltip md-direction=\"bottom\">Agregar Nivel</md-tooltip></md-icon></div><div><md-icon \nmd-svg-src=\"/assets/icons/bx-trash.svg\" ng-if=\"(parent && childIndex > -1)\" \nng-click=\"ccCtrl.deleteLevel(parent, childIndex)\" class=\"icon red-600-fg pointer\" aria-label=\"Eliminar\"><md-tooltip \nmd-direction=\"right\">Eliminar nivel</md-tooltip></md-icon></div></div><div flex=\"100\" \nng-if=\"ccCtrl.object.conditioned\" layout=\"row\"><div flex layout=\"column\"><div flex=\"100\" \nng-repeat=\"row in ccCtrl.object.conditions\" layout=\"row\" layout-align=\"start center\"><div flex \nclass=\"ml-10 md-caption\" ng-class=\"{\'red-500-fg\': !(ccList[row.ccId].valid) }\"><em class=\"blue-900-fg font-weight-900\">\n{{ccList[row.ccId].payrollName}}: </em>{{ccList[row.ccId].name}} [{{ccList[row.ccId].placeOfWork}}]</div>\n<md-input-container flex=\"25\" class=\"md-block no-errors-spacer m-0\" md-no-float required><input required type=\"text\" \nclass=\"uppercased\" placeholder=\"Cuenta\" name=\"account\" ng-model=\"row.account\"></md-input-container><div flex=\"nogrow\">\n<md-icon md-svg-src=\"/assets/icons/store-remove.svg\" class=\"icon red-600-fg p-0 pointer mr-5\" \nng-click=\"ccCtrl.removeCondition($index)\" aria-label=\"Eliminar\"></md-icon></div></div><div flex=\"100\" layout=\"row\" \nlayout-align=\"start center\"><md-input-container flex class=\"md-block no-errors-spacer m-0\" md-no-float><md-select \nng-model=\"ccCtrl.ccId\" name=\"cc\" placeholder=\"Centro de costos\"><md-select-header><input autocomplete=\"off\" \ntype=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"ccRecordSelectFilter\" \nplaceholder=\"Busque un centro de costos\"></md-select-header><md-optgroup label=\"{{payrollData.payroll.name}}\" \nng-repeat=\"payrollData in (ccCtrl.ccListByPayroll | filterCcs : ccCtrl.object.conditions) track by payrollData.payroll.$id\">\n<md-option ng-value=\"cc.$id\" \nng-repeat=\"cc in (payrollData.availableCcs | orderBy:\'data.name\' | filter:ccRecordSelectFilter) track by cc.$id\">\n{{ cc.name }} [{{cc.placeOfWork }}]</md-option></md-optgroup></md-select></md-input-container><div flex=\"nogrow\" \nclass=\"mt-5\"><md-icon md-svg-src=\"/assets/icons/store-add.svg\" \nng-click=\"ccCtrl.ccId?ccCtrl.addCondition(ccCtrl.ccId):\'\'\" \nng-class=\"{\'grey-500-fg\':!ccCtrl.ccId, \'blue-600-fg\': ccCtrl.ccId}\" class=\"icon p-0 pointer\" aria-label=\"Agregar\">\n<md-tooltip>Agregar centro de costo</md-tooltip></md-icon></div></div></div></div><div flex=\"100\" \nng-if=\"ccCtrl.object.type===\'concept\'\" class=\"mb-10\"><md-chips ng-model=\"ccCtrl.object.concepts\" \nmd-transform-chip=\"ccCtrl.transformChip($chip)\" md-require-match=\"true\"><md-autocomplete \nmd-selected-item=\"ccCtrl.selectedItem\" class=\"custom-template\" md-search-text=\"ccCtrl.searchText\" md-no-cache=\"true\" \nmd-items=\"item in ccCtrl.querySearch(ccCtrl.searchText)\" md-item-text=\"item.name\" placeholder=\"Agregar un concepto\">\n<md-item-template><span class=\"optionToSelect\">{{item.name}}<label ng-if=\"item.payroll!==\'global\'\">\n[{{item.payrollName}}]</label></span></md-item-template><md-not-found>No se encontraron resultados.</md-not-found>\n</md-autocomplete><md-chip-template class=\"md-caption\"><span><strong>\n{{$chip | getSomethingOfArrayFB : concepts : \'name\' : \'N/E\' : \'fid\'}}</strong> <em \nng-if=\"($chip | getSomethingOfArrayFB : concepts : \'payroll\' : \'global\' : \'fid\') !== \'global\'\">\n{{$chip | getSomethingOfArrayFB : concepts : \'payrollName\' : \'N/E\' : \'fid\'}}</em></span></md-chip-template></md-chips>\n</div></div></div></div><ul><li class=\"cc-child\" ng-repeat=\"($thisChildIndex, child) in ccCtrl.object.children\" \nobject=\"child\" mode=\"ccCtrl.mode\" concepts=\"concepts\" cc-list=\"ccList\" cc-list-by-payroll=\"ccListByPayroll\" \nroot-obj=\"rootObj\" type=\"type\" form=\"form\" parent=\"ccCtrl.object.children\" \nparent-is-concept=\"ccCtrl.object.type === \'concept\'\" child-index=\"$thisChildIndex\"></li></ul></div>");
$templateCache.put("app/main/acommon/directives/count-icon.html","<md-icon md-font-icon=\'icon-numeric-{{(array.length > 9) ? \"9-plus\" : array.length }}-box\' class=\"crud-icon\"></md-icon>");
$templateCache.put("app/main/acommon/directives/fb-crud-detail-bar.html","<md-toolbar class=\"md-tall header md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" \nlayout=\"row\" layout-align=\"start center\" flex><md-button with-permission action=\"access\" \naccess=\"{{F.active.menuItem}}\" class=\"goto-button md-icon-button\" aria-label=\"Go to list\" ng-click=\"R.goToList()\" \ntranslate translate-attr-aria-label=\"EC.GO_TO\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div \nlayout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"{{F.menuItems[F.active.menuParent][F.active.menuName].icon || F.default.icon}}\" class=\"crud-icon\">\n</md-icon><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\">\n{{F.active.detailObject.name||F.active.detailObject.data.name}}</div><div class=\"subtitle secondary-text\"><span \nng-if=\"!F.addMode\">{{\'EC.DETAIL_OF\' | translate}} {{F.active.menuObjName + \'.SINGULAR\' | translate}}</span> <span \nng-if=\"F.addMode\">{{\'EC.CREATE\' | translate}} {{F.active.menuObjName + \'.SINGULAR\' | translate}}</span></div></div>\n</div></div><div><md-button ng-if=\"selectedTab == R.states.fb[F.active.menuName].images\" with-permission \naction=\"update\" access=\"{{F.active.menuItem}}\" ng-click=\"upload(images, F.active.detailObject)\" \nng-show=\"images.length && !F.active.detailObject[F.active.imageName]\" \nclass=\"md-raised md-background md-fab md-accent md-hue-1\" aria-label=\"Upload image\" ng-disabled=\"loadingProgress\">\n<md-tooltip md-direction=\"left\">{{\'EC.UPLOAD_IMAGE\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-upload\">\n</md-icon></md-button><md-button ng-if=\"selectedTab == R.states.fb[F.active.menuName].images\" with-permission \naction=\"update\" access=\"{{F.active.menuItem}}\" ng-click=\"removeUpload(F.active.detailObject)\" \nng-show=\"F.active.detailObject[F.active.imageName]\" class=\"md-warn md-raised md-background md-fab\" \naria-label=\"Delete image\" ng-disabled=\"loadingProgress\"><md-tooltip md-direction=\"left\">\n{{\'EC.DELETE_IMAGE\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button><md-button \ntype=\"submit\" ng-if=\"!F.addMode && objectLoaded && !F.readMode\" with-permission action=\"update\" \naccess=\"{{F.active.menuItem}}\" ng-click=\"this[saveMethod](F.active.detailObject)\" \nng-hide=\"form.$pristine && !objectLoaded\" ng-disabled=\"form.pending || form.$invalid || loadingProgress\" \nclass=\"md-raised md-background md-fab md-accent md-hue-1\" aria-label=\"Save\"><md-tooltip md-direction=\"left\">\n{{\'EC.SAVE\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-content-save\" aria-label=\"Save\"></md-icon>\n</md-button><md-button type=\"submit\" ng-if=\"F.addMode && objectLoaded\" with-permission action=\"create\" \naccess=\"{{F.active.menuItem}}\" ng-click=\"this[addMethod](F.active.detailObject)\" \nng-hide=\"form.$pristine && !objectLoaded\" ng-disabled=\"form.$pending || form.$invalid || loadingProgress\" \nclass=\"md-raised md-background md-fab md-accent md-hue-1\" aria-label=\"Add\"><md-tooltip md-direction=\"left\">\n{{\'EC.ADD\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-content-save\" aria-label=\"Add\"></md-icon></md-button>\n</div></md-toolbar>");
$templateCache.put("app/main/acommon/directives/fb-dashboard-bar.html","<div class=\"header\" layout-gt-xs=\"row\" layout-align=\"space-between\"><div layout=\"row\" layout-align=\"space-between\" \nflex><div flex><h3 class=\"font-weight-300\">Dashboard</h3></div><div filter-dashboard-payroll flex \nng-if=\"[0,1,2,3].indexOf(selectedTab) == -1\"></div><md-input-container class=\"withButton\"><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"toggleSidenav(\'sidenav\')\" hide-gt-md aria-label=\"Toggle sidenav\">\n<md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button></md-input-container></div></div>");
$templateCache.put("app/main/acommon/directives/fb-search-bar-2.html","<div class=\"header\" layout-gt-xs=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" \nlayout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\" \nng-hide=\"F.search[F.active.menuObjName]\"><md-icon \nmd-font-icon=\"{{F.menuItems[F.active.menuParent][F.active.menuName].icon || F.default.icon}}\" class=\"crud-icon\">\n</md-icon><span>{{F.active.menuObjName + \'.PLURAL\' | translate}}</span></div><div class=\"count secondary-text\" hide-xs>\n<strong>Registros cargados: </strong><span>\n{{[\'employees\', \'noEmployees\',\'realSalaryRecords\',\'movements\',\'healthcareRecords\',\'personalInfoEmployees\',\'employeeFiles\',\'employeesVacationsRecords\',\'credits\',\'logs\'].indexOf(F.active.menuName)>=0?pagination.total:Z[F.active.menuName].length}}\n</span></div></div><div fb-input-search-2></div></div>");
$templateCache.put("app/main/acommon/directives/fb-search-bar.html","<div class=\"header\" layout-gt-xs=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" \nlayout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\" \nng-hide=\"F.search[F.active.menuObjName]\"><md-icon \nmd-font-icon=\"{{F.menuItems[F.active.menuParent][F.active.menuName].icon || F.default.icon}}\" class=\"crud-icon\">\n</md-icon><span>{{F.active.menuObjName + \'.PLURAL\' | translate}}</span></div><div class=\"count secondary-text\"><span>\nResultados: </span><span>\n{{[\'employees\', \'noEmployees\',\'realSalaryRecords\',\'movements\',\'healthcareRecords\',\'personalInfoEmployees\',\'employeeFiles\',\'employeesVacationsRecords\',\'credits\',\'logs\'].indexOf(F.active.menuName)>=0?pagination.total:F.filteredItems.length}}\n</span></div></div><div fb-input-search></div></div>");
$templateCache.put("app/main/acommon/directives/filter-toolbar.html","<div flex class=\"filterToolbar md-padding\" layout-gt-xs=\"row\" layout-align=\"end center\" \nng-if=\"ffilters.length || $filters.length || moreColumns.length\"><div flex filter-status \nng-if=\'$filters.indexOf(\"status\") !== -1 && (F.active.menuName !== \"incidences\" && F.active.menuName !== \"confirmIncidences\")\' \nflex-order=\'{{$filters.indexOf(\"status\")}}\'></div><div flex filter-rp ng-if=\'$filters.indexOf(\"rp\") !== -1\' \nflex-order=\'{{$filters.indexOf(\"rp\")}}\'></div><div flex filter-cc ng-if=\'$filters.indexOf(\"cc\") !== -1\' \nflex-order=\'{{$filters.indexOf(\"cc\")}}\'></div><div flex filter-has-seniority-date \nng-if=\'$filters.indexOf(\"hasSeniorityDate\") !== -1\' flex-order=\'{{$filters.indexOf(\"hasSeniorityDate\")}}\'></div><div \nflex filter-credit-status ng-if=\'$filters.indexOf(\"creditStatus\") !== -1\' \nflex-order=\'{{$filters.indexOf(\"creditStatus\")}}\'></div><div flex filter-loan-status \nng-if=\'$filters.indexOf(\"loanStatus\") !== -1\' flex-order=\'{{$filters.indexOf(\"loanStatus\")}}\'></div><div flex \nfilter-contract-status ng-if=\'$filters.indexOf(\"contractStatus\") !== -1\' \nflex-order=\'{{$filters.indexOf(\"contractStatus\")}}\'></div><div flex filter-payroll-filter \nng-if=\'$filters.indexOf(\"payroll\") !== -1\' flex-order=\'{{$filters.indexOf(\"payroll\")}}\'></div><div flex \nfilter-payroll-cc ng-if=\'$filters.indexOf(\"payroll-cc\") !== -1\' flex-order=\'{{$filters.indexOf(\"payroll-cc\")}}\'></div>\n<div flex filter-movement-type ng-if=\'$filters.indexOf(\"movement.type\") !== -1\' \nflex-order=\'{{$filters.indexOf(\"movement.type\")}}\'></div><div flex filter-movements-type \nng-if=\'$filters.indexOf(\"data.type\") !== -1\' flex-order=\'{{$filters.indexOf(\"data.type\")}}\'></div><div flex \nfilter-profile ng-if=\'$filters.indexOf(\"profile\") !== -1\' flex-order=\'{{$filters.indexOf(\"profile\")}}\'></div><div flex \nfilter-action ng-if=\'$filters.indexOf(\"action\") !== -1\' flex-order=\'{{$filters.indexOf(\"action\")}}\'></div><div flex \nfilter-from-date ng-if=\'$filters.indexOf(\"data.date:>=\") !== -1\' flex-order=\'{{$filters.indexOf(\"data.date:>=\")}}\'>\n</div><div flex filter-to-date ng-if=\'$filters.indexOf(\"data.date:<=\") !== -1\' \nflex-order=\'{{$filters.indexOf(\"data.date:<=\")}}\'></div><div flex filter-period \nng-if=\'$filters.indexOf(\"period\") !== -1\' flex-order=\'{{$filters.indexOf(\"period\")}}\'></div><div flex filter-period \nng-if=\'ffilters.indexOf(\"period\") !== -1\' flex-order=\'{{$filters.length+ffilters.indexOf(\"period\")}}\'></div><div flex \nfilter-groupings ng-if=\'$filters.indexOf(\"groupings\") !== -1\' flex-order=\'{{$filters.indexOf(\"groupings\")}}\'></div><div\n flex filter-payroll-calendar ng-if=\'ffilters.indexOf(\"payrollCalendar\") !== -1\' \nflex-order=\'{{$filters.length+ffilters.indexOf(\"payrollCalendar\")}}\'></div><div flex filter-companies-record \nng-if=\'ffilters.indexOf(\"companiesRecord\") !== -1\' \nflex-order=\'{{$filters.length+ffilters.indexOf(\"companiesRecord\")}}\'></div><div flex filter-employee-autocomplete \nng-if=\'ffilters.indexOf(\"employeeAutoComplete\") !== -1\' \nflex-order=\'{{$filters.length+ffilters.indexOf(\"employeeAutoComplete\")}}\'></div><div flex filter-payroll-employee \nng-if=\'$filters.indexOf(\"employee\") !== -1 && [\"credits\",\"bills\"].indexOf(F.active.menuName) !== -1\' \nflex-order=\'{{$filters.indexOf(\"employee\")}}\'></div><div flex filter-employee \nng-if=\'$filters.indexOf(\"employee\") !== -1 && [\"credits\",\"bills\"].indexOf(F.active.menuName) === -1\' \nflex-order=\'{{$filters.indexOf(\"employee\")}}\'></div><div flex filter-module ng-if=\'ffilters.indexOf(\"module\") !== -1\' \nflex-order=\'{{$filters.length+ffilters.indexOf(\"module\")}}\'></div><div flex filter-firm \nng-if=\'ffilters.indexOf(\"firm\") !== -1\' flex-order=\'{{$filters.length+ffilters.indexOf(\"firm\")}}\'></div><div flex \nfilter-incidence-status \nng-if=\'$filters.indexOf(\"status\") !== -1 && (F.active.menuName == \"incidences\" || F.active.menuName == \"confirmIncidences\")\' \nflex-order=\'{{$filters.indexOf(\"status\")}}\'></div><div ng-if=\"moreColumns.length\" flex=\"nogrow\" \nflex-order=\"{{$filters.length}}\"><md-menu><md-button class=\"md-icon-button\" aria-label=\"add columns in the table\" \nng-click=\"openMenu($mdOpenMenu, $event)\"><md-tooltip md-direction=\"left\">Ver más Columnas</md-tooltip><md-icon \nmd-font-icon=\"icon-eye\" aria-label=\"read icon\"></md-icon></md-button><md-menu-content width=\"4\"><md-menu-item \nclass=\"h-auto\"><div class=\"overflow\"><fieldset class=\"standard\" layout=\"column\"><legend><b>Campos Disponibles</b>\n</legend><md-checkbox ng-repeat=\"($index, column) in columnsRepeat\" ng-model=\"column.show\" flex=\"\" \nng-true-value=\"true\" ng-false-value=\"false\" ng-click=\"createConfiguration($index, column, F.active.menuName)\">\n{{column.name}}</md-checkbox></fieldset></div></md-menu-item></md-menu-content></md-menu></div></div>");
$templateCache.put("app/main/acommon/directives/mongo-crud-detail-bar.html","<md-toolbar class=\"md-tall header md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" \nlayout=\"row\" layout-align=\"start center\" flex><md-button class=\"goto-button md-icon-button\" aria-label=\"Go to list\" \nwith-permission action=\"access\" access=\"{{F.active.menuItem}}\" ng-click=\"R.goToList()\" translate \ntranslate-attr-aria-label=\"EC.GO_TO\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\'{{F.menuItems.catalogs[F.active.menuName].icon || \"icon-hexagon\"}}\' \nclass=\"crud-icon\"></md-icon><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\">\n{{F.active.detailObject.name}}</div><div class=\"subtitle secondary-text\"><span ng-if=\"!F.addMode\">\n{{\'EC.DETAIL_OF\' | translate}} {{F.active.menuObjName + \'.SINGULAR\' | translate}}</span> <span ng-if=\"F.addMode\">\n{{\'EC.CREATE\' | translate}} {{F.active.menuObjName + \'.SINGULAR\' | translate}}</span></div></div></div></div><div>\n<md-button type=\"submit\" ng-if=\"!F.addMode\" with-permission action=\"update\" access=\"{{F.active.menuItem}}\" \nng-click=\"save(F.active.detailObject)\" ng-hide=\"form.$pristine\" ng-disabled=\"form.$invalid || loadingProgress\" \nclass=\"md-raised md-background md-fab md-accent md-hue-1\" aria-label=\"Save\"><md-tooltip md-direction=\"left\">\n{{\'EC.SAVE\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-content-save\" aria-label=\"Save\"></md-icon>\n</md-button><md-button type=\"submit\" ng-if=\"F.addMode\" with-permission action=\"create\" access=\"{{F.active.menuItem}}\" \nng-click=\"add(F.active.detailObject)\" ng-hide=\"form.$pristine\" ng-disabled=\"form.$invalid || loadingProgress\" \nclass=\"md-raised md-background md-fab md-accent md-hue-1\" aria-label=\"Add\"><md-tooltip md-direction=\"left\">\n{{\'EC.ADD\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-content-save\" aria-label=\"Add\"></md-icon></md-button>\n</div></md-toolbar>");
$templateCache.put("app/main/acommon/directives/mongo-search-bar.html","<div class=\"header\" layout-gt-xs=\"row\" layout-align=\"space-between center\" \nstyle=\"min-height: auto;height:auto!important\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\"><div \nflex=\"nogrow\" class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"{{F.menuItems[F.active.menuParent][F.active.menuName].icon || F.default.icon}}\" class=\"crud-icon\">\n</md-icon><span>{{F.active.menuObjName + \'.PLURAL\' | translate}}</span></div><div flex=\"nogrow\" \nclass=\"secondary-text p-5\"><span># Registros:</span> <span>{{pagination.total || 0}}</span></div><div flex></div></div>\n<div class=\"search\" layout=\"row\" layout-align=\"start center\" flex md-padding ng-if=\"!F.active.disableSearchBar\"><div \nflex=\"nogrow\"><md-button ng-disabled=\"!F.search[F.active.menuObjName]\" class=\"md-fab md-mini md-primary\" \naria-label=\"search button\" type=\"submit\" ng-click=\'getThem(false,\"from searchbar\")\'><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon></md-button></div><input id=\"{{F.active.menuObjName}}s-search\" \nclass=\"search-input uppercased\" flex type=\"text\" placeholder=\"Buscar\" translate ms2-autofocus \ntranslate-attr-placeholder=\"EC.SEARCH\" ng-change=\"getThem(false,\'from input searchbar\')\" \nng-model-options=\"{ debounce: F.debounceTime }\" ng-model=\"F.search[F.active.menuObjName]\"></div></div>");
$templateCache.put("app/main/acommon/templates/_foot.html","");
$templateCache.put("app/main/acommon/templates/_head.html","<html><head><style>\nhtml, body {\r\n            margin: 0 !important;\r\n            padding: 0 !important;\r\n        }\r\n        * {\r\n            font-size: 10px !important;\r\n            font-family: Verdana, Arial, Helvetica, sans-serif !important;\r\n        }\r\n        body,\r\n        p,\r\n        table,\r\n        th,\r\n        td,\r\n        div,\r\n        strong {\r\n            text-align: left;\r\n        }\r\n\r\n        #myTable {\r\n            margin-left: 0.5;\r\n            margin-right: auto;\r\n            width: 500px;\r\n            text-align: left;\r\n        }\r\n\r\n        td.colone {\r\n            vertical-align: center;\r\n            border-left: medium none;\r\n            border-right: medium none;\r\n            border-top: medium none;\r\n            border-bottom: .5pt dotted #008000\r\n        }\r\n\r\n        td.colone2 {\r\n            vertical-align: center;\r\n            border-left: medium none;\r\n            border-right: medium none;\r\n            border-top: medium none;\r\n            border-bottom: .5pt dotted #FFFFFF\r\n        }\r\n\r\n        td.colthree {\r\n            width: 0.1%;\r\n        }\r\n\r\n        td.colthree2 {\r\n            width: 0.1%;\r\n            border-left: medium none;\r\n            border-right: medium none;\r\n            border-top: medium none;\r\n            border-bottom: .5pt dotted #008000\r\n        }\r\n\r\n        table.border {\r\n            border: 1px solid #FFFFFF;\r\n            border-collapse: collapse;\r\n        }\n</style></head><body><table id=\"myTable\" width=\"100%\" border=\"0\" cellspacing=\"0\" cellpadding=\"0\" \nstyle=\"font-size:10px !important; font-family: Verdana, Arial, Helvetica, sans-serif !important\"><tr><td \nalign=\"center\" valign=\"top\" bgcolor=\"#ffffff\" \nstyle=\"background-color:#ffffff; font-size: 10px !important;\r\n            font-family: Verdana, Arial, Helvetica, sans-serif !important; color:#000000\">\n</td></tr></table></body></html>");
$templateCache.put("app/main/acommon/templates/credit.html","<table class=\"border\" width=\"700\" cellpadding=\"3\" cellspacing=\"0\"><tr><td class=\"colone\" style=\"{{data.styles.td}}\">\n<strong style=\"{{data.styles.strong}}\">ASEGURADO:</strong> <span style=\"{{data.styles.span}}\">{{data.employeeEnsured}}\n</span></td><td class=\"colone\" style=\"{{data.styles.td}}\"><strong style=\"{{data.styles.strong}}\">SALUD.COM:</strong> \n<span style=\"{{data.styles.span}}\">{{data.employeeHealthBenefit}}</span></td><td class=\"colone\" \nstyle=\"{{data.styles.td}}\"><strong style=\"{{data.styles.strong}}\">TIPO DE DESCUENTO:</strong> <span \nstyle=\"{{data.styles.span}}\">{{data.credit.data.type}}</span></td></tr><tr><td class=\"colone\" \nstyle=\"{{data.styles.td}}\"><strong style=\"{{data.styles.strong}}\">IMSS:</strong> <span style=\"{{data.styles.span}}\">\n{{data.employeeNss}}</span></td><td class=\"colone\" style=\"{{data.styles.td}}\"><strong style=\"{{data.styles.strong}}\">\nNOMBRE:</strong> <span style=\"{{data.styles.span}}\">{{data.employeeName}}</span></td><td class=\"colone\" \nstyle=\"{{data.styles.td}}\"><strong style=\"{{data.styles.strong}}\">CURP:</strong> <span style=\"{{data.styles.span}}\">\n{{data.employeeCurp}}</span></td></tr><tr><td class=\"colone\" style=\"{{data.styles.td}} {{data.sdClass}}\"><strong \nstyle=\"{{data.styles.strong}}\">SD:</strong> <span style=\"{{data.styles.span}}\">{{data.credit.data.sd|currency}}</span>\n</td><td class=\"colone\" style=\"{{data.styles.td}} {{data.sbcClass}}\"><strong style=\"{{data.styles.strong}}\">SBC:\n</strong> <span style=\"{{data.styles.span}}\">{{data.credit.data.sbc|currency}}</span></td><td class=\"colone\" \nstyle=\"{{data.styles.td}}\" colspan=\"{{data.realSpan}}\"><strong style=\"{{data.styles.strong}}\">S REAL:</strong> <span \nstyle=\"{{data.styles.span}}\">{{data.credit.data.sdr|currency}}</span></td></tr><tr><td class=\"colone\" \nstyle=\"{{data.styles.td}}\"><strong style=\"{{data.styles.strong}}\">FECHA DE INICIO:</strong> <span \nstyle=\"{{data.styles.span}}\">{{data.credit.data.date|date:\'dd-MM-yyyy\'}}</span></td><td class=\"colone\" \nstyle=\"{{data.styles.td}}\"><strong style=\"{{data.styles.strong}}\">FACTOR:</strong> <span style=\"{{data.styles.td}}\">\n{{data.credit.data.factor}}</span></td><td class=\"colone\" style=\"{{data.styles.td}}\"><strong \nstyle=\"{{data.styles.strong}}\">NÚMERO DE CRÉDITO:</strong> <span style=\"{{data.styles.span}}\">\n{{data.credit.data.account}}</span></td></tr><tr><td class=\"colone\" style=\"{{data.styles.td}}\"><strong \nstyle=\"{{data.styles.strong}}\">EMPRESA:</strong> <span style=\"{{data.styles.span}}\">{{data.rpName}}</span></td><td \nclass=\"colone\" style=\"{{data.styles.td}}\"><strong style=\"{{data.styles.strong}}\">NÓMINA:</strong> <span \nstyle=\"{{data.styles.span}}\">{{data.payrollName}}</span></td><td class=\"colone\" style=\"{{data.styles.td}}\"><strong \nstyle=\"{{data.styles.strong}}\">CC:</strong> <span style=\"{{data.styles.span}}\">{{data.ccName}}</span></td></tr><tr><td \nclass=\"colone\" style=\"{{data.styles.td}}\"><strong style=\"{{data.styles.strong}}\">CAPTURADO POR:</strong> <span \nstyle=\"{{data.styles.span}}\">{{data.capturedBy}}</span></td><td class=\"colone\" style=\"{{data.styles.td}}\"><strong \nstyle=\"{{data.styles.strong}}\">EL DÍA:</strong> <span style=\"{{data.styles.span}}\">{{date|date:\'dd-MM-yyyy hh:mm:ss\'}}\n</span></td><td class=\"colone\" style=\"{{data.styles.td}}\"><strong style=\"{{data.styles.strong}}\">DESDE IP:</strong> \n<span style=\"{{data.styles.span}}\">{{data.credit.created.fromIP}}</span></td></tr><tr><td class=\"colone\" \nstyle=\"{{data.styles.td}}\" colspan=\"3\"><strong style=\"{{data.styles.strong}}\">COMENTARIOS:</strong> <span \nstyle=\"{{data.styles.span}}\">{{data.credit.data.comments}}</span></td></tr></table>");
$templateCache.put("app/main/acommon/templates/dismiss.html","<table class=\"border\" width=\"700\" cellpadding=\"3\" cellspacing=\"0\"><tr><td class=\"colone\" style=\"{{data.styles.td}}\">\n<strong style=\"{{data.styles.strong}}\">IMSS:</strong> <span style=\"{{data.styles.span}}\">{{data.employee.data.nss}}\n</span></td><td class=\"colone\" style=\"{{data.styles.td}}\"><strong style=\"{{data.styles.strong}}\">NOMBRE:</strong> <span\n style=\"{{data.styles.span}}\">{{data.employee.data.name}}</span></td></tr><tr><td class=\"colone\" \nstyle=\"{{data.styles.td}}\"><strong style=\"{{data.styles.strong}}\">MOVIMIENTO:</strong> <span \nstyle=\"{{data.styles.span}}\">{{data.employee.movement.type|typeName}}</span></td><td class=\"colone\" \nstyle=\"{{data.styles.td}}\" colspan=\"2\"><strong style=\"{{data.styles.strong}}\">CON FECHA:</strong> <span \nstyle=\"{{data.styles.td}}\">{{data.employee.movement.date|date:\'dd-MM-yyyy\'}}</span></td></tr><tr><td class=\"colone\" \nstyle=\"{{data.styles.td}}\"><strong style=\"{{data.styles.strong}}\">EMPRESA:</strong> <span style=\"{{data.styles.span}}\">\n{{data.rpName}}</span></td><td class=\"colone\" style=\"{{data.styles.td}}\"><strong style=\"{{data.styles.strong}}\">NÓMINA:\n</strong> <span style=\"{{data.styles.span}}\">{{data.payroll.data.name}}</span></td><td class=\"colone\" \nstyle=\"{{data.styles.td}}\"><strong style=\"{{data.styles.strong}}\">PAGA SUELDO EN NÓMINA:</strong> <span \nstyle=\"{{data.styles.span}}\">{{data.paySalaryInPayroll}}</span></td></tr><tr><td class=\"colone\" \nstyle=\"{{data.styles.td}}\"><strong style=\"{{data.styles.strong}}\">CAPTURADO POR:</strong> <span \nstyle=\"{{data.styles.span}}\">{{data.capturedBy}}</span></td><td class=\"colone\" style=\"{{data.styles.td}}\"><strong \nstyle=\"{{data.styles.strong}}\">EL DÍA:</strong> <span style=\"{{data.styles.span}}\">{{date|date:\'dd-MM-yyyy hh:mm:ss\'}}\n</span></td><td class=\"colone\" style=\"{{data.styles.td}}\"><strong style=\"{{data.styles.strong}}\">DESDE IP:</strong> \n<span style=\"{{data.styles.span}}\">{{data.employee.created.fromIP}}</span></td></tr><tr><td class=\"colone\" \nstyle=\"{{data.styles.td}}\" colspan=\"3\"><strong style=\"{{data.styles.strong}}\">COMENTARIOS:</strong> <span \nstyle=\"{{data.styles.span}}\">{{data.employee.movement.comments}}</span></td></tr></table>");
$templateCache.put("app/main/acommon/templates/enrole.html","<table class=\"border\" width=\"700\" cellpadding=\"3\" cellspacing=\"0\"><tr><td class=\"colone\" style=\"{{data.styles.td}}\">\n<strong style=\"{{data.styles.strong}}\">IMSS:</strong> <span style=\"{{data.styles.span}}\">{{data.employee.data.nss}}\n</span></td><td class=\"colone\" style=\"{{data.styles.td}}\"><strong style=\"{{data.styles.strong}}\">NOMBRE:</strong> <span\n style=\"{{data.styles.span}}\">{{data.employee.data.name}}</span></td><td class=\"colone\" style=\"{{data.styles.td}}\">\n<strong style=\"{{data.styles.strong}}\">CURP:</strong> <span style=\"{{data.styles.span}}\">{{data.employee.data.curp}}\n</span></td></tr><tr><td class=\"colone\" style=\"{{data.styles.td}} {{data.sdClass}}\"><strong \nstyle=\"{{data.styles.strong}}\">SD:</strong> <span style=\"{{data.styles.span}}\">\n{{data.employee.data.salary.sd|currency}}</span></td><td class=\"colone\" style=\"{{data.styles.td}} {{data.sbcClass}}\">\n<strong style=\"{{data.styles.strong}}\">SBC:</strong> <span style=\"{{data.styles.span}}\">\n{{data.employee.data.salary.sbc|currency}}</span></td><td class=\"colone\" style=\"{{data.styles.td}}\" \ncolspan=\"{{data.realSpan}}\"><strong style=\"{{data.styles.strong}}\">S REAL:</strong> <span style=\"{{data.styles.span}}\">\n{{data.employee.data.salary.sdr|currency}}</span></td></tr><tr><td class=\"colone\" style=\"{{data.styles.td}}\"><strong \nstyle=\"{{data.styles.strong}}\">MOVIMIENTO:</strong> <span style=\"{{data.styles.span}}\">\n{{data.employee.movement.type|typeName}}</span></td><td class=\"colone\" style=\"{{data.styles.td}}\"><strong \nstyle=\"{{data.styles.strong}}\">CON FECHA:</strong> <span style=\"{{data.styles.td}}\">\n{{data.employee.movement.date|date:\'dd-MM-yyyy\'}}</span></td><td class=\"colone\" style=\"{{data.styles.td}}\"><strong \nstyle=\"{{data.styles.strong}}\">RFC:</strong> <span style=\"{{data.styles.span}}\">{{data.employee.data.rfc}}</span></td>\n</tr><tr><td class=\"colone\" style=\"{{data.styles.td}}\"><strong style=\"{{data.styles.strong}}\">EMPRESA:</strong> <span \nstyle=\"{{data.styles.span}}\">{{data.rpName}}</span></td><td class=\"colone\" style=\"{{data.styles.td}}\"><strong \nstyle=\"{{data.styles.strong}}\">NÓMINA:</strong> <span style=\"{{data.styles.span}}\">{{data.payroll.data.name}}</span>\n</td><td class=\"colone\" style=\"{{data.styles.td}}\"><strong style=\"{{data.styles.strong}}\">CC:</strong> <span \nstyle=\"{{data.styles.span}}\">{{data.ccName}}</span></td></tr><tr><td class=\"colone\" style=\"{{data.styles.td}}\"><strong \nstyle=\"{{data.styles.strong}}\">CAPTURADO POR:</strong> <span style=\"{{data.styles.span}}\">{{data.capturedBy}}</span>\n</td><td class=\"colone\" style=\"{{data.styles.td}}\"><strong style=\"{{data.styles.strong}}\">EL DÍA:</strong> <span \nstyle=\"{{data.styles.span}}\">{{date|date:\'dd-MM-yyyy hh:mm:ss\'}}</span></td><td class=\"colone\" \nstyle=\"{{data.styles.td}}\"><strong style=\"{{data.styles.strong}}\">DESDE IP:</strong> <span \nstyle=\"{{data.styles.span}}\">{{data.employee.created.fromIP}}</span></td></tr><tr><td class=\"colone\" \nstyle=\"{{data.styles.td}}\" colspan=\"3\"><strong style=\"{{data.styles.strong}}\">COMENTARIOS:</strong> <span \nstyle=\"{{data.styles.span}}\">{{data.employee.data.comments}}</span> <span style=\"{{data.styles.span}}\">\n{{data.employee.movement.comments}}</span></td></tr><tr style=\"{{data.accountClass}}\"><td class=\"colone\" \nstyle=\"{{data.styles.td}}\"><strong style=\"{{data.styles.strong}}\">VINCULAR CUENTA:</strong> <span \nstyle=\"{{data.styles.span}}\">{{data.accountMsg}}</span></td><td class=\"colone\" style=\"{{data.styles.td}}\"><strong \nstyle=\"{{data.styles.strong}}\">BANCO:</strong> <span style=\"{{data.styles.span}}\">{{ data.bankName }}</span></td><td \nclass=\"colone\" style=\"{{data.styles.td}}\"><strong style=\"{{data.styles.strong}}\">TARJETA O CUENTA:</strong> <span \nstyle=\"{{data.styles.span}}\">{{ data.cardNumber }}</span></td></tr><tr><td class=\"colone\" style=\"{{data.styles.td}}\">\n<strong style=\"{{data.styles.strong}}\">BENEFICIARIOS:</strong> <span style=\"{{data.styles.span}}\">\n{{ data.employee.data.info.beneficiaries[0].name }}</span></td><td class=\"colone\" style=\"{{data.styles.td}}\"><strong \nstyle=\"{{data.styles.strong}}\">PARENTESCO:</strong> <span style=\"{{data.styles.span}}\">\n{{ data.employee.data.info.beneficiaries[0].relationship }}</span></td><td class=\"colone\" style=\"{{data.styles.td}}\">\n<strong style=\"{{data.styles.strong}}\">PORCENTAJE:</strong> <span style=\"{{data.styles.span}}\">100%</span></td></tr>\n<tr><td class=\"colone\" style=\"{{data.styles.td}}\" colspan=\"3\"><strong style=\"{{data.styles.strong}}\">EMISORAS:</strong>\n<span style=\"{{data.fiscalClass}}\"><b>FISCAL:</b> {{data.issuerFiscal}} </span><span style=\"{{data.complementsClass}}\">\n<b>{{data.issuerC1N}}:</b> {{data.issuerC1}}</span></td></tr><tr><td class=\"colone\" style=\"{{data.styles.td}}\" \ncolspan=\"3\"><b>TIPO DE VÍA:</b> <span style=\"{{data.styles.span}}\">{{ data.streetTypeName }}</span> <b>CALLE:</b> <span\n style=\"{{data.styles.span}}\">{{ data.employee.data.info.residence.address.street }}</span> <b>NÚMERO:</b> <span \nstyle=\"{{data.styles.span}}\">{{ data.employee.data.info.residence.address.externalNumber }}</span> <b>NÚMERO INT:</b> \n<span style=\"{{data.styles.span}}\">{{ data.employee.data.info.residence.address.internalNumber }}</span> <b>COLONIA:\n</b> <span style=\"{{data.styles.span}}\">{{ data.employee.data.info.residence.address.neighborhood }}</span> <b>ESTADO:\n</b> <span style=\"{{data.styles.span}}\">{{ data.stateName }}</span> <b>MUNICIPIO:</b> <span \nstyle=\"{{data.styles.span}}\">{{ data.townName }}</span> <b>CP:</b> <span style=\"{{data.styles.span}}\">\n{{ data.employee.data.info.residence.address.zipCode }}</span> <span style=\"{{data.phonesClass}}\"><b>TELÉFONO:</b> \n<span style=\"{{data.styles.span}}\">\n{{ data.employee.data.info.phones[0].phone + \' - \' }} {{data.employee.data.info.phones[0].type}} </span></span><span \nstyle=\"{{data.emailsClass}}\"><b>CORREO:</b> <span style=\"{{data.styles.span}}\">\n{{ data.employee.data.info.emails[0].email + \' - \' }} {{data.employee.data.info.emails[0].type}}</span></span></td>\n</tr><tr><td class=\"colone\" style=\"{{data.styles.td}}\"><strong style=\"{{data.styles.strong}}\">PUESTO:</strong> <span \nstyle=\"{{data.styles.span}}\">{{data.positionName}}</span></td><td class=\"colone\" style=\"{{data.styles.td}}\"><strong \nstyle=\"{{data.styles.strong}}\">SUELDO BRUTO MENSUAL:</strong> <span style=\"{{data.styles.span}}\">\n{{data.employee.data.salary|bruteSalary|currency}}</span></td><td class=\"colone\" style=\"{{data.styles.td}}\"><strong \nstyle=\"{{data.styles.strong}}\">SUELDO NETO MENSUAL:</strong> <span style=\"{{data.styles.span}}\">\n{{data.employee.data.salary|bruteSalary:1|currency}}</span></td></tr><tr><td class=\"colone\" style=\"{{data.styles.td}}\" \ncolspan=\"1\"><strong style=\"{{data.styles.strong}}\">FRECUENCIA DE PAGO:</strong> <span style=\"{{data.styles.span}}\">\n{{data.paymentFrequenciesRecordName}}</span></td><td class=\"colone\" colspan=\"2\"><strong>ENTIDAD DE NACIMIENTO:</strong>\n <span style=\"{{data.styles.span}}\">{{data.entityName}}</span></td></tr></table>");
$templateCache.put("app/main/acommon/templates/incidence.html","<table class=\"border\" width=\"700\" cellpadding=\"3\" cellspacing=\"0\"><tr><td colspan=\"3\" class=\"colone\" \nstyle=\"{{data.styles.td}}\"><strong style=\"{{data.styles.strong}}\">NÓMINA:</strong> <span style=\"{{data.styles.span}}\">\n{{data.payrollName}}</span></td></tr><tr><td class=\"colone\" style=\"{{data.styles.td}}\"><strong \nstyle=\"{{data.styles.strong}}\">IMSS:</strong> <span style=\"{{data.styles.span}}\">{{data.employeeNss}}</span></td><td \ncolspan=\"2\" class=\"colone\" style=\"{{data.styles.td}}\"><strong style=\"{{data.styles.strong}}\">EMPLEADO:</strong> <span \nstyle=\"{{data.styles.span}}\">{{data.employeeName}}</span></td></tr><tr><td class=\"colone\" style=\"{{data.styles.td}}\">\n<strong style=\"{{data.styles.strong}}\">AÑO:</strong> <span style=\"{{data.styles.span}}\">{{data.incidence.calendar}}\n</span></td><td class=\"colone\" style=\"{{data.styles.td}}\"><strong style=\"{{data.styles.strong}}\">PERIODO:</strong> \n<span style=\"{{data.styles.td}}\">{{data.incidence.period}}</span></td><td class=\"colone\" style=\"{{data.styles.td}}\">\n<strong style=\"{{data.styles.strong}}\">FECHA:</strong> <span style=\"{{data.styles.span}}\">\n{{data.incidence.date|date:\'dd-MM-yyyy\'}}</span></td></tr><tr><td class=\"colone\" style=\"{{data.styles.td}}\"><strong \nstyle=\"{{data.styles.strong}}\">TIPO DE INCIDENCIA:</strong> <span style=\"{{data.styles.span}}\">\n{{data.incidenceTypeName}}</span></td><td class=\"colone\" style=\"{{data.styles.td}}\"><strong \nstyle=\"{{data.styles.strong}}\">VALOR:</strong> <span style=\"{{data.styles.td}}\">{{data.incidence.value}}</span></td><td\n class=\"colone\" style=\"{{data.styles.td}}\"><strong style=\"{{data.styles.strong}}\">STATUS:</strong> <span \nstyle=\"{{data.styles.span}}\">{{data.incidence.status|incidenceStatusName}}</span></td></tr><tr><td class=\"colone\" \nstyle=\"{{data.styles.td}}\"><strong style=\"{{data.styles.strong}}\">CAPTURADO POR:</strong> <span \nstyle=\"{{data.styles.span}}\">{{data.capturedBy}}</span></td><td class=\"colone\" style=\"{{data.styles.td}}\"><strong \nstyle=\"{{data.styles.strong}}\">EL DÍA:</strong> <span style=\"{{data.styles.span}}\">{{date|date:\'dd-MM-yyyy hh:mm:ss\'}}\n</span></td><td class=\"colone\" style=\"{{data.styles.td}}\"><strong style=\"{{data.styles.strong}}\">DESDE IP:</strong> \n<span style=\"{{data.styles.span}}\">{{data.incidence.created.fromIP}}</span></td></tr><tr><td class=\"colone\" \nstyle=\"{{data.styles.td}}\" colspan=\"3\"><strong style=\"{{data.styles.strong}}\">COMENTARIOS:</strong> <span \nstyle=\"{{data.styles.span}}\">{{data.incidence.comments}}</span></td></tr></table>");
$templateCache.put("app/main/acommon/templates/mds.html","<table class=\"border\" width=\"700\" cellpadding=\"3\" cellspacing=\"0\"><tr><td class=\"colone\" style=\"{{data.styles.td}}\">\n<strong style=\"{{data.styles.strong}}\">IMSS:</strong> <span style=\"{{data.styles.span}}\">{{data.employee.data.nss}}\n</span></td><td class=\"colone\" colspan=\"2\" style=\"{{data.styles.td}}\"><strong style=\"{{data.styles.strong}}\">NOMBRE:\n</strong> <span style=\"{{data.styles.span}}\">{{data.employee.data.name}}</span></td><td class=\"colone\" \nstyle=\"{{data.styles.td}}\"><strong style=\"{{data.styles.strong}}\">CURP:</strong> <span style=\"{{data.styles.span}}\">\n{{data.employee.data.curp}}</span></td></tr><tr><td class=\"colone\" style=\"{{data.styles.td}} {{data.sdClass}}\"><strong \nstyle=\"{{data.styles.strong}}\">SD:</strong> <span style=\"{{data.styles.span}}\">{{data.employee.movement.sd|currency}}\n</span></td><td class=\"colone\" style=\"{{data.styles.td}} {{data.sbcClass}}\"><strong style=\"{{data.styles.strong}}\">SBC:\n</strong> <span style=\"{{data.styles.span}}\">{{data.employee.movement.sbc|currency}}</span></td><td class=\"colone\" \nstyle=\"{{data.styles.td}}\" colspan=\"{{data.realSpan}}\"><strong style=\"{{data.styles.strong}}\">S REAL:</strong> <span \nstyle=\"{{data.styles.span}}\">{{data.employee.data.salary.sdr|currency}}</span></td></tr><tr><td class=\"colone\" \nstyle=\"{{data.styles.td}}\"><strong style=\"{{data.styles.strong}}\">MOVIMIENTO:</strong> <span \nstyle=\"{{data.styles.span}}\">{{data.employee.movement.type|typeName}}</span></td><td class=\"colone\" \nstyle=\"{{data.styles.td}}\" colspan=\"2\"><strong style=\"{{data.styles.strong}}\">CON FECHA:</strong> <span \nstyle=\"{{data.styles.td}}\">{{data.employee.movement.date|date:\'dd-MM-yyyy\'}}</span></td><td class=\"colone\" \nstyle=\"{{data.styles.td}}\"><strong style=\"{{data.styles.strong}}\">RFC:</strong> <span style=\"{{data.styles.span}}\">\n{{data.employee.data.rfc}}</span></td></tr><tr><td class=\"colone\" style=\"{{data.styles.td}}\"><strong \nstyle=\"{{data.styles.strong}}\">EMPRESA:</strong> <span style=\"{{data.styles.span}}\">{{data.rpName}}</span></td><td \nclass=\"colone\" style=\"{{data.styles.td}}\"><strong style=\"{{data.styles.strong}}\">NÓMINA:</strong> <span \nstyle=\"{{data.styles.span}}\">{{data.payroll.data.name}}</span></td><td class=\"colone\" style=\"{{data.styles.td}}\">\n<strong style=\"{{data.styles.strong}}\">CC:</strong> <span style=\"{{data.styles.span}}\">{{data.ccName}}</span></td></tr>\n<tr><td class=\"colone\" style=\"{{data.styles.td}}\"><strong style=\"{{data.styles.strong}}\">CAPTURADO POR:</strong> <span \nstyle=\"{{data.styles.span}}\">{{data.capturedBy}}</span></td><td class=\"colone\" style=\"{{data.styles.td}}\"><strong \nstyle=\"{{data.styles.strong}}\">EL DÍA:</strong> <span style=\"{{data.styles.span}}\">{{date|date:\'dd-MM-yyyy hh:mm:ss\'}}\n</span></td><td class=\"colone\" style=\"{{data.styles.td}}\"><strong style=\"{{data.styles.strong}}\">DESDE IP:</strong> \n<span style=\"{{data.styles.span}}\">{{data.employee.created.fromIP}}</span></td></tr><tr><td class=\"colone\" \nstyle=\"{{data.styles.td}}\" colspan=\"3\"><strong style=\"{{data.styles.strong}}\">COMENTARIOS:</strong> <span \nstyle=\"{{data.styles.span}}\">{{data.employee.data.comments}}</span> <span style=\"{{data.styles.span}}\">\n{{data.employee.movement.comments}}</span></td></tr></table>");
$templateCache.put("app/main/acommon/templates/movement.html","<table class=\"border\" width=\"700\" cellpadding=\"3\" cellspacing=\"0\"><tr><td class=\"colone\" style=\"{{data.styles.td}}\">\n<strong style=\"{{data.styles.strong}}\">IMSS:</strong> <span style=\"{{data.styles.span}}\">{{data.employee.data.nss}}\n</span></td><td class=\"colone\" style=\"{{data.styles.td}}\" colspan=\"2\"><strong style=\"{{data.styles.strong}}\">NOMBRE:\n</strong> <span style=\"{{data.styles.span}}\">{{data.employee.data.name}}</span></td></tr><tr><td class=\"colone\" \nstyle=\"{{data.styles.td}}\"><strong style=\"{{data.styles.strong}}\">RFC:</strong> <span style=\"{{data.styles.span}}\">\n{{data.employee.data.rfc}}</span></td><td class=\"colone\" style=\"{{data.styles.td}}\"><strong \nstyle=\"{{data.styles.strong}}\">CURP:</strong> <span style=\"{{data.styles.span}}\">{{data.employee.data.curp}}</span>\n</td><td class=\"colone\" style=\"{{data.styles.td}}\" colspan=\"{{data.realSpan}}\"><strong style=\"{{data.styles.strong}}\">\nS REAL:</strong> <span style=\"{{data.styles.span}}\">{{data.employee.data.salary.sdr|currency}}</span></td></tr><tr><td \nclass=\"colone\" style=\"{{data.styles.td}}\"><strong style=\"{{data.styles.strong}}\">MOVIMIENTO:</strong> <span \nstyle=\"{{data.styles.span}}\">{{data.employee.movement.type|typeName}}</span></td><td class=\"colone\" \nstyle=\"{{data.styles.td}}\" colspan=\"2\"><strong style=\"{{data.styles.strong}}\">CON FECHA:</strong> <span \nstyle=\"{{data.styles.td}}\">{{data.employee.movement.date|date:\'dd-MM-yyyy\'}}</span></td></tr><tr><td class=\"colone\" \nstyle=\"{{data.styles.td}}\"><strong style=\"{{data.styles.strong}}\">EMPRESA:</strong> <span style=\"{{data.styles.span}}\">\n{{data.rpName}}</span></td><td class=\"colone\" style=\"{{data.styles.td}}\"><strong style=\"{{data.styles.strong}}\">NÓMINA:\n</strong> <span style=\"{{data.styles.span}}\">{{data.payroll.data.name}}</span></td><td class=\"colone\" \nstyle=\"{{data.styles.td}}\"><strong style=\"{{data.styles.strong}}\">CC:</strong> <span style=\"{{data.styles.span}}\">\n{{data.ccName}}</span></td></tr><tr><td class=\"colone\" style=\"{{data.styles.td}}\"><strong \nstyle=\"{{data.styles.strong}}\">CAPTURADO POR:</strong> <span style=\"{{data.styles.span}}\">{{data.capturedBy}}</span>\n</td><td class=\"colone\" style=\"{{data.styles.td}}\"><strong style=\"{{data.styles.strong}}\">EL DÍA:</strong> <span \nstyle=\"{{data.styles.span}}\">{{date|date:\'dd-MM-yyyy hh:mm:ss\'}}</span></td><td class=\"colone\" \nstyle=\"{{data.styles.td}}\"><strong style=\"{{data.styles.strong}}\">DESDE IP:</strong> <span \nstyle=\"{{data.styles.span}}\">{{data.employee.created.fromIP}}</span></td></tr><tr><td class=\"colone\" \nstyle=\"{{data.styles.td}}\" colspan=\"3\"><strong style=\"{{data.styles.strong}}\">COMENTARIOS:</strong> <span \nstyle=\"{{data.styles.span}}\">{{data.employee.data.comments}}</span> <span style=\"{{data.styles.span}}\">\n{{data.employee.movement.comments}}</span></td></tr></table>");
$templateCache.put("app/main/acommon/templates/operation.html","<p class=\"colone\">Le informamos que la siguiente n&oacute;mina ha sido cerrada de forma exitosa:<br>\n---------------------------------------------------------<br>* <strong>Clase:</strong> {{data.payrollClass}}<br>* \n<strong>Nomina:</strong> {{data.payrollName}}<br>* <strong>Frecuencia de pago:</strong>\n {{data.paymentFrequenciesRecordName}}<br>* <strong>Periodo:</strong>\n {{data.operation.calendar}}-{{data.operation.period}}<br>---------------------------------------------------------<br>\n<strong>Capturado por:</strong> {{data.capturedBy}} El dia: <span>{{date|date:\'dd-MM-yyyy hh:mm:ss\'}}</span><br>\n<strong>Desde:</strong> {{data.operation.created.fromIP}}</p>");
$templateCache.put("app/main/acommon/templates/reEntry.html","<table class=\"border\" width=\"700\" cellpadding=\"3\" cellspacing=\"0\"><tr><td class=\"colone\" style=\"{{data.styles.td}}\">\n<strong style=\"{{data.styles.strong}}\">IMSS:</strong> <span style=\"{{data.styles.span}}\">{{data.employee.data.nss}}\n</span></td><td class=\"colone\" style=\"{{data.styles.td}}\"><strong style=\"{{data.styles.strong}}\">NOMBRE:</strong> <span\n style=\"{{data.styles.span}}\">{{data.employee.data.name}}</span></td><td class=\"colone\" style=\"{{data.styles.td}}\">\n<strong style=\"{{data.styles.strong}}\">CURP:</strong> <span style=\"{{data.styles.span}}\">{{data.employee.data.curp}}\n</span></td></tr><tr><td class=\"colone\" style=\"{{data.styles.td}} {{data.sdClass}}\"><strong \nstyle=\"{{data.styles.strong}}\">SD:</strong> <span style=\"{{data.styles.span}}\">\n{{data.employee.data.salary.sd|currency}}</span></td><td class=\"colone\" style=\"{{data.styles.td}} {{data.sbcClass}}\">\n<strong style=\"{{data.styles.strong}}\">SBC:</strong> <span style=\"{{data.styles.span}}\">\n{{data.employee.data.salary.sbc|currency}}</span></td><td class=\"colone\" style=\"{{data.styles.td}}\" \ncolspan=\"{{data.realSpan}}\"><strong style=\"{{data.styles.strong}}\">S REAL:</strong> <span style=\"{{data.styles.span}}\">\n{{data.employee.data.salary.sdr|currency}}</span></td></tr><tr><td class=\"colone\" style=\"{{data.styles.td}}\"><strong \nstyle=\"{{data.styles.strong}}\">MOVIMIENTO:</strong> <span style=\"{{data.styles.span}}\">\n{{data.employee.movement.type|typeName}}</span></td><td class=\"colone\" style=\"{{data.styles.td}}\"><strong \nstyle=\"{{data.styles.strong}}\">CON FECHA:</strong> <span style=\"{{data.styles.td}}\">\n{{data.employee.movement.date|date:\'dd-MM-yyyy\'}}</span></td><td class=\"colone\" style=\"{{data.styles.td}}\"><strong \nstyle=\"{{data.styles.strong}}\">RFC:</strong> <span style=\"{{data.styles.span}}\">{{data.employee.data.rfc}}</span></td>\n</tr><tr><td class=\"colone\" style=\"{{data.styles.td}}\"><strong style=\"{{data.styles.strong}}\">EMPRESA:</strong> <span \nstyle=\"{{data.styles.span}}\">{{data.rpName}}</span></td><td class=\"colone\" style=\"{{data.styles.td}}\"><strong \nstyle=\"{{data.styles.strong}}\">NÓMINA:</strong> <span style=\"{{data.styles.span}}\">{{data.payroll.data.name}}</span>\n</td><td class=\"colone\" style=\"{{data.styles.td}}\"><strong style=\"{{data.styles.strong}}\">CC:</strong> <span \nstyle=\"{{data.styles.span}}\">{{data.ccName}}</span></td></tr><tr><td class=\"colone\" style=\"{{data.styles.td}}\"><strong \nstyle=\"{{data.styles.strong}}\">CAPTURADO POR:</strong> <span style=\"{{data.styles.span}}\">{{data.capturedBy}}</span>\n</td><td class=\"colone\" style=\"{{data.styles.td}}\"><strong style=\"{{data.styles.strong}}\">EL DÍA:</strong> <span \nstyle=\"{{data.styles.span}}\">{{date|date:\'dd-MM-yyyy hh:mm:ss\'}}</span></td><td class=\"colone\" \nstyle=\"{{data.styles.td}}\"><strong style=\"{{data.styles.strong}}\">DESDE IP:</strong> <span \nstyle=\"{{data.styles.span}}\">{{data.employee.created.fromIP}}</span></td></tr><tr><td class=\"colone\" \nstyle=\"{{data.styles.td}}\" colspan=\"3\"><strong style=\"{{data.styles.strong}}\">COMENTARIOS:</strong> <span \nstyle=\"{{data.styles.span}}\">{{data.employee.data.comments}}</span> <span style=\"{{data.styles.span}}\">\n{{data.employee.movement.comments}}</span></td></tr><tr style=\"{{data.accountClass}} {{data.emitAccountClass}}\"><td \nclass=\"colone\" style=\"{{data.styles.td}}\"><strong style=\"{{data.styles.strong}}\">VINCULAR CUENTA:</strong> <span \nstyle=\"{{data.styles.span}}\">{{data.accountMsg}}</span></td><td class=\"colone\" style=\"{{data.styles.td}}\"><strong \nstyle=\"{{data.styles.strong}}\">BANCO:</strong> <span style=\"{{data.styles.span}}\">{{ data.bankName }}</span></td><td \nclass=\"colone\" style=\"{{data.styles.td}}\"><strong style=\"{{data.styles.strong}}\">TARJETA O CUENTA:</strong> <span \nstyle=\"{{data.styles.span}}\">{{ data.cardNumber }}</span></td></tr><tr style=\"{{data.emitAccountClass}}\"><td \nclass=\"colone\" style=\"{{data.styles.td}}\"><strong style=\"{{data.styles.strong}}\">BENEFICIARIOS:</strong> <span \nstyle=\"{{data.styles.span}}\">{{ data.employee.data.info.beneficiaries[0].name }}</span></td><td class=\"colone\" \nstyle=\"{{data.styles.td}}\"><strong style=\"{{data.styles.strong}}\">PARENTESCO:</strong> <span \nstyle=\"{{data.styles.span}}\">{{ data.employee.data.info.beneficiaries[0].relationship }}</span></td><td class=\"colone\" \nstyle=\"{{data.styles.td}}\"><strong style=\"{{data.styles.strong}}\">PORCENTAJE:</strong> <span \nstyle=\"{{data.styles.span}}\">100%</span></td></tr><tr style=\"{{data.emitAccountClass}}\"><td class=\"colone\" \nstyle=\"{{data.styles.td}}\" colspan=\"3\"><strong style=\"{{data.styles.strong}}\">EMISORAS:</strong><span \nstyle=\"{{data.fiscalClass}}\"><b>FISCAL:</b> {{data.issuerFiscal}} </span><span style=\"{{data.complementsClass}}\"><b>\n{{data.issuerC1N}}:</b> {{data.issuerC1}}</span></td></tr><tr style=\"{{data.emitAccountClass}}\"><td class=\"colone\" \nstyle=\"{{data.styles.td}}\" colspan=\"3\"><b>TIPO DE VÍA:</b> <span style=\"{{data.styles.span}}\">{{ data.streetTypeName }}\n</span> <b>CALLE:</b> <span style=\"{{data.styles.span}}\">{{ data.employee.data.info.residence.address.street }}</span> \n<b>NÚMERO:</b> <span style=\"{{data.styles.span}}\">{{ data.employee.data.info.residence.address.externalNumber }}</span>\n <b>NÚMERO INT:</b> <span style=\"{{data.styles.span}}\">{{ data.employee.data.info.residence.address.internalNumber }}\n</span> <b>COLONIA:</b> <span style=\"{{data.styles.span}}\">{{ data.employee.data.info.residence.address.neighborhood }}\n</span> <b>ESTADO:</b> <span style=\"{{data.styles.span}}\">{{ data.stateName }}</span> <b>MUNICIPIO:</b> <span \nstyle=\"{{data.styles.span}}\">{{ data.townName }}</span> <b>CP:</b> <span style=\"{{data.styles.span}}\">\n{{ data.employee.data.info.residence.address.zipCode }}</span> <span style=\"{{data.phonesClass}}\"><b>TELÉFONO:</b> \n<span style=\"{{data.styles.span}}\">\n{{ data.employee.data.info.phones[0].phone + \' - \' }} {{data.employee.data.info.phones[0].type}} </span></span><span \nstyle=\"{{data.emailsClass}}\"><b>CORREO:</b> <span style=\"{{data.styles.span}}\">\n{{ data.employee.data.info.emails[0].email + \' - \' }} {{data.employee.data.info.emails[0].type}}</span></span></td>\n</tr><tr style=\"{{data.emitAccountClass}}\"><td class=\"colone\" style=\"{{data.styles.td}}\"><strong \nstyle=\"{{data.styles.strong}}\">PUESTO:</strong> <span style=\"{{data.styles.span}}\">{{data.positionName}}</span></td><td\n class=\"colone\" style=\"{{data.styles.td}}\"><strong style=\"{{data.styles.strong}}\">SUELDO BRUTO MENSUAL:</strong> <span \nstyle=\"{{data.styles.span}}\">{{data.employee.data.salary|bruteSalary|currency}}</span></td><td class=\"colone\" \nstyle=\"{{data.styles.td}}\"><strong style=\"{{data.styles.strong}}\">SUELDO NETO MENSUAL:</strong> <span \nstyle=\"{{data.styles.span}}\">{{data.employee.data.salary|bruteSalary:1|currency}}</span></td></tr><tr \nstyle=\"{{data.emitAccountClass}}\"><td class=\"colone\" style=\"{{data.styles.td}}\" colspan=\"1\"><strong \nstyle=\"{{data.styles.strong}}\">FRECUENCIA DE PAGO:</strong> <span style=\"{{data.styles.span}}\">\n{{data.paymentFrequenciesRecordName}}</span></td><td class=\"colone\" colspan=\"2\"><strong>ENTIDAD DE NACIMIENTO:</strong>\n <span style=\"{{data.styles.span}}\">{{data.entityName}}</span></td></tr></table>");
$templateCache.put("app/main/acommon/templates/variable.html","<table class=\"border\" width=\"700\" cellpadding=\"3\" cellspacing=\"0\"><tr><td class=\"colone\" style=\"{{data.styles.td}}\">\n<strong style=\"{{data.styles.strong}}\">IMSS:</strong> <span style=\"{{data.styles.span}}\">{{data.employee.data.nss}}\n</span></td><td class=\"colone\" colspan=\"2\" style=\"{{data.styles.td}}\"><strong style=\"{{data.styles.strong}}\">NOMBRE:\n</strong> <span style=\"{{data.styles.span}}\">{{data.employee.data.name}}</span></td></tr><tr><td class=\"colone\" \nstyle=\"{{data.styles.td}} {{data.sdClass}}\"><strong style=\"{{data.styles.strong}}\">SD:</strong> <span \nstyle=\"{{data.styles.span}}\">{{data.employee.movement.sd|currency}}</span></td><td class=\"colone\" \nstyle=\"{{data.styles.td}} {{data.sbcClass}}\"><strong style=\"{{data.styles.strong}}\">SBC:</strong> <span \nstyle=\"{{data.styles.span}}\">{{data.employee.movement.sbc|currency}}</span></td><td class=\"colone\" \nstyle=\"{{data.styles.td}}\" colspan=\"{{data.realSpan}}\"><strong style=\"{{data.styles.strong}}\">S REAL:</strong> <span \nstyle=\"{{data.styles.span}}\">{{data.employee.data.salary.sdr|currency}}</span></td></tr><tr><td class=\"colone\" \nstyle=\"{{data.styles.td}}\"><strong style=\"{{data.styles.strong}}\">MOVIMIENTO:</strong> <span \nstyle=\"{{data.styles.span}}\">{{data.employee.movement.type|typeName}}</span></td><td class=\"colone\" \nstyle=\"{{data.styles.td}}\" colspan=\"2\"><strong style=\"{{data.styles.strong}}\">CON FECHA:</strong> <span \nstyle=\"{{data.styles.td}}\">{{data.employee.movement.date|date:\'dd-MM-yyyy\'}}</span></td></tr><tr><td class=\"colone\" \nstyle=\"{{data.styles.td}}\"><strong style=\"{{data.styles.strong}}\">EMPRESA:</strong> <span style=\"{{data.styles.span}}\">\n{{data.rpName}}</span></td><td class=\"colone\" style=\"{{data.styles.td}}\"><strong style=\"{{data.styles.strong}}\">NÓMINA:\n</strong> <span style=\"{{data.styles.span}}\">{{data.payroll.data.name}}</span></td><td class=\"colone\" \nstyle=\"{{data.styles.td}}\"><strong style=\"{{data.styles.strong}}\">CC:</strong> <span style=\"{{data.styles.span}}\">\n{{data.ccName}}</span></td></tr><tr><td class=\"colone\" style=\"{{data.styles.td}}\"><strong \nstyle=\"{{data.styles.strong}}\">CAPTURADO POR:</strong> <span style=\"{{data.styles.span}}\">{{data.capturedBy}}</span>\n</td><td class=\"colone\" style=\"{{data.styles.td}}\"><strong style=\"{{data.styles.strong}}\">EL DÍA:</strong> <span \nstyle=\"{{data.styles.span}}\">{{date|date:\'dd-MM-yyyy hh:mm:ss\'}}</span></td><td class=\"colone\" \nstyle=\"{{data.styles.td}}\"><strong style=\"{{data.styles.strong}}\">DESDE IP:</strong> <span \nstyle=\"{{data.styles.span}}\">{{data.employee.created.fromIP}}</span></td></tr><tr><td class=\"colone\" \nstyle=\"{{data.styles.td}}\" colspan=\"3\"><strong style=\"{{data.styles.strong}}\">COMENTARIOS:</strong> <span \nstyle=\"{{data.styles.span}}\">{{data.employee.data.comments}}</span> <span style=\"{{data.styles.span}}\">\n{{data.employee.movement.comments}}</span></td></tr><tr style=\"{{data.accountClass}}\"><td class=\"colone\" \nstyle=\"{{data.styles.td}}\"><strong style=\"{{data.styles.strong}}\">VINCULAR CUENTA:</strong> <span \nstyle=\"{{data.styles.span}}\">{{data.accountMsg}}</span></td><td class=\"colone\" style=\"{{data.styles.td}}\"><strong \nstyle=\"{{data.styles.strong}}\">BANCO:</strong> <span style=\"{{data.styles.span}}\">{{ data.bankName }}</span></td><td \nclass=\"colone\" style=\"{{data.styles.td}}\"><strong style=\"{{data.styles.strong}}\">NÚMERO DE TARJETA:</strong> <span \nstyle=\"{{data.styles.span}}\">{{ data.cardNumber }}</span></td></tr><tr><td class=\"colone\" style=\"{{data.styles.td}}\">\n<strong style=\"{{data.styles.strong}}\">BENEFICIARIOS:</strong> <span style=\"{{data.styles.span}}\">\n{{ data.employee.data.info.beneficiaries[0].name }}</span></td><td class=\"colone\" style=\"{{data.styles.td}}\"><strong \nstyle=\"{{data.styles.strong}}\">PARENTESCO:</strong> <span style=\"{{data.styles.span}}\">\n{{ data.employee.data.info.beneficiaries[0].relationship }}</span></td><td class=\"colone\" style=\"{{data.styles.td}}\">\n<strong style=\"{{data.styles.strong}}\">PROCENTAJE:</strong> <span style=\"{{data.styles.span}}\">100%</span></td></tr>\n<tr><td class=\"colone\" style=\"{{data.styles.td}}\" colspan=\"3\"><strong style=\"{{data.styles.strong}}\">EMISORAS:</strong>\n<span style=\"{{data.fiscalClass}}\"><b>FISCAL:</b> {{data.issuerFiscal}} </span><span style=\"{{data.complementsClass}}\">\n<b>{{data.issuerC1N}}:</b> {{data.issuerC1}}</span></td></tr><tr><td class=\"colone\" style=\"{{data.styles.td}}\" \ncolspan=\"3\"><b>TIPO DE VÍA:</b> <span style=\"{{data.styles.span}}\">{{ data.streetTypeName }}</span> <b>CALLE:</b> <span\n style=\"{{data.styles.span}}\">{{ data.employee.data.info.residence.address.street }}</span> <b>NÚMERO:</b> <span \nstyle=\"{{data.styles.span}}\">{{ data.employee.data.info.residence.address.externalNumber }}</span> <b>NÚMERO INT:</b> \n<span style=\"{{data.styles.span}}\">{{ data.employee.data.info.residence.address.internalNumber }}</span> <b>COLONIA:\n</b> <span style=\"{{data.styles.span}}\">{{ data.employee.data.info.residence.address.neighborhood }}</span> <b>ESTADO:\n</b> <span style=\"{{data.styles.span}}\">{{ data.stateName }}</span> <b>MUNICIPIO:</b> <span \nstyle=\"{{data.styles.span}}\">{{ data.townName }}</span> <b>CP:</b> <span style=\"{{data.styles.span}}\">\n{{ data.employee.data.info.residence.address.zipCode }}</span> <span style=\"{{data.phonesClass}}\"><b>TELÉFONO:</b> \n<span style=\"{{data.styles.span}}\">\n{{ data.employee.data.info.phones[0].phone + \' - \' }} {{data.employee.data.info.phones[0].type}} </span></span><span \nstyle=\"{{data.emailsClass}}\"><b>CORREO:</b> <span style=\"{{data.styles.span}}\">\n{{ data.employee.data.info.emails[0].email + \' - \' }} {{data.employee.data.info.emails[0].type}}</span></span></td>\n</tr><tr><td class=\"colone\" style=\"{{data.styles.td}}\"><strong style=\"{{data.styles.strong}}\">PUESTO:</strong> <span \nstyle=\"{{data.styles.span}}\">{{data.positionName}}</span></td><td class=\"colone\" style=\"{{data.styles.td}}\"><strong \nstyle=\"{{data.styles.strong}}\">SUELDO BRUTO MENSUAL:</strong> <span style=\"{{data.styles.span}}\">\n{{data.employee.data.salary|bruteSalary|currency}}</span></td><td class=\"colone\" style=\"{{data.styles.td}}\"><strong \nstyle=\"{{data.styles.strong}}\">SUELDO NETO MENSUAL:</strong> <span style=\"{{data.styles.span}}\">\n{{data.employee.data.salary|bruteSalary:1|currency}}</span></td></tr><tr><td class=\"colone\" style=\"{{data.styles.td}}\" \ncolspan=\"1\"><strong style=\"{{data.styles.strong}}\">FRECUENCIA DE PAGO:</strong> <span style=\"{{data.styles.span}}\">\n{{data.paymentFrequenciesRecordName}}</span></td><td class=\"colone\" colspan=\"2\"><strong>ENTIDAD DE NACIMIENTO:</strong>\n <span style=\"{{data.styles.span}}\">{{data.entityName}}</span></td></tr></table>");
$templateCache.put("app/main/apps/chat/chat.html","<div id=\"chat-app\" class=\"page-layout carded fullwidth\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\"><div\n class=\"content-card\" layout=\"row\" flex><md-sidenav class=\"sidenav left-sidenav md-sidenav-left\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"left-sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/apps/chat/sidenavs/left/left-sidenav.html\'\" layout=\"column\"></md-sidenav><div \nclass=\"start-point\" ng-if=\"F.chatActive===false\" flex layout=\"column\" flex layout-align=\"center center\"><div \nclass=\"big-circle md-whiteframe-4dp\"><md-icon class=\"s128 md-accent\" md-font-icon=\"icon-hangouts\"></md-icon></div><span\n class=\"app-title\" translate=\"CHAT.APP_TITLE\">Chat App</span> <span class=\"hide show-gt-md secondary-text\" \ntranslate=\"CHAT.START_MESSAGE\">Select contact to start the chat!..</span><md-button class=\"md-raised hide-gt-md\" \nng-click=\"toggleSidenav(\'left-sidenav\')\" translate=\"CHAT.START_MESSAGE\">Select contact to start the chat!..</md-button>\n</div><div ng-if=\"F.chatActive!==false\" class=\"chat\" layout=\"column\" flex><md-toolbar class=\"chat-toolbar\"><div \nclass=\"md-toolbar-tools\"><md-button class=\"hide-gt-md responsive-chats-button md-icon-button\" \nng-click=\"toggleLeftSidenavView(false);toggleSidenav(\'left-sidenav\')\" aria-label=\"chats button\"><md-icon \nmd-font-icon=\"icon-hangouts s36\"></md-icon></md-button><div class=\"chat-contact\" layout=\"row\" \nlayout-align=\"start center\" ng-click=\"toggleSidenav(\'right-sidenav\')\"><div class=\"avatar-wrapper\"><img class=\"avatar\" \nng-src=\"{{CF.chats[F.chatActive].avatar||\'assets/images/avatars/profile.jpg\'}}\" alt=\"{{CF.chats[F.chatActive].name}}\"> \n<i class=\"icon icon- s16 status\" ng-class=\"chat.status\"></i></div><div class=\"chat-contact-name\">\n{{CF.chats[F.chatActive].name}}</div></div></div></md-toolbar><md-content id=\"chat-content\" flex ms-scroll scrollable \non-middle-event=\"scrollMiddle\" on-bottom-event=\"autoScrollBottom\" on-top-event=\"loadMoreConversation\"><div \nclass=\"chat-messages\" ng-if=\"F.chatActive!==false\"><div layout=\"row\" \nng-repeat=\"dialog in CF.chats[F.chatActive].conversation.items\" on-finish-render=\"ngRepeatFinished\" \nclass=\"md-padding message-row\" ng-class=\"dialog.idprofile==F.profile.uid?\'user\':\'contact\'\"><img \nng-if=\"dialog.idprofile===F.profile.uid\" class=\"avatar\" \nng-src=\"{{CF.profile.data.avatar||\'assets/images/avatars/profile.jpg\'}}\" alt=\"{{F.profile.data.name}}\"> <img \nng-if=\"dialog.idprofile!==F.profile.uid\" class=\"avatar\" \nng-src=\"{{CF.chats[indexActive].avatar||\'assets/images/avatars/profile.jpg\'}}\" alt=\"{{CF.chats[indexActive].name}}\">\n<div class=\"bubble\"><div class=\"message\">{{dialog.msg}}</div><div class=\"time secondary-text\">{{dialog.time | altDate}}\n</div></div></div></div></md-content><div class=\"chat-footer flex-noshrink\" layout=\"row\" layout-align=\"center center\">\n<form ng-submit=\"reply()\" flex class=\"reply-form\" layout=\"row\" layout-align=\"start center\"><md-input-container flex \nmd-no-float><textarea ng-keyup=\"$event.keyCode == 13 ? reply($event) : null\" md-no-autogrow ng-model=\"CF.replyMessage\" \nng-class=\"{\'grow\': textareaGrow}\" placeholder=\"Type and hit enter to send message\" translate \ntranslate-attr-placeholder=\"CHAT.REPLY_PLACEHOLDER\">\r\n                            </textarea></md-input-container>\n<md-button class=\"md-fab\" type=\"submit\" aria-label=\"Send message\" translate \ntranslate-attr-aria-label=\"CHAT.SEND_MESSAGE\"><md-icon md-font-icon=\"icon-send\"></md-icon></md-button></form></div>\n</div><md-sidenav class=\"sidenav right-sidenav md-sidenav-right\" layout=\"column\" md-component-id=\"right-sidenav\" \nms-sidenav-helper ng-include=\"\'app/main/apps/chat/sidenavs/right/right-sidenav.html\'\"></md-sidenav></div></div></div>");
$templateCache.put("app/main/apps/calendar/calendar.html","<div id=\"calendar\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"header\" \nng-class=\"currentMonthShort\"><div class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div \nclass=\"header-top\" layout=\"row\" layout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon></span><span \nclass=\"logo-text\" translate=\"CALENDAR.CALENDAR\">Calendar</span></div><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" aria-label=\"Search\" translate \ntranslate-attr-aria-label=\"CALENDAR.SEARCH\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><md-tooltip><span \ntranslate=\"CALENDAR.SEARCH\">Buscar</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"calendar.today()\" aria-label=\"Today\" translate translate-attr-aria-label=\"CALENDAR.TODAY\"><md-icon \nmd-font-icon=\"icon-calendar-today\"></md-icon><md-tooltip><span translate=\"CALENDAR.TODAY\">Hoy</span></md-tooltip>\n</md-button><md-button class=\"md-icon-button\" ng-click=\"calendar.changeView(\'agendaDay\')\" aria-label=\"Day\" translate \ntranslate-attr-aria-label=\"CALENDAR.DAY\"><md-icon md-font-icon=\"icon-view-day\"></md-icon><md-tooltip><span \ntranslate=\"CALENDAR.DAY\">Día</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"calendar.changeView(\'agendaWeek\')\" aria-label=\"Week\" translate translate-attr-aria-label=\"CALENDAR.WEEK\">\n<md-icon md-font-icon=\"icon-view-week\"></md-icon><md-tooltip><span translate=\"CALENDAR.WEEK\">Semana</span></md-tooltip>\n</md-button><md-button class=\"md-icon-button\" ng-click=\"calendar.changeView(\'month\')\" aria-label=\"Month\" translate \ntranslate-attr-aria-label=\"CALENDAR.MONTH\"><md-icon md-font-icon=\"icon-view-module\"></md-icon><md-tooltip><span \ntranslate=\"CALENDAR.MONTH\">Mes</span></md-tooltip></md-button></div></div><div class=\"header-bottom\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-icon-button arrow\" ng-click=\"calendar.prev()\" aria-label=\"Previous\" \ntranslate translate-attr-aria-label=\"CALENDAR.PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon>\n</md-button><div class=\"title\">{{calendarView.title}}</div><md-button class=\"md-icon-button arrow\" \nng-click=\"calendar.next()\" aria-label=\"Next\" translate translate-attr-aria-label=\"CALENDAR.NEXT\"><md-icon \nmd-font-icon=\"icon-chevron-right\"></md-icon></md-button></div></div></div><div class=\"content\"><div id=\"calendarView\" \nui-calendar=\"calendarUiConfig.calendar\" ng-model=\"eventsSources\" calendar=\"main\"></div></div></div>");
$templateCache.put("app/main/apps/contacts/contacts.html","<div id=\"contacts\" class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button sidenav-toggle\" hide-gt-md ng-click=\"vm.toggleSidenav(\'sidenav\')\" aria-label=\"Toggle sidenav\" \ntranslate translate-attr-aria-label=\"CONTACTS.TOGGLE_SIDENAV\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon \nmd-font-icon=\"icon-account-box\" class=\"s24\"></md-icon></span><span class=\"logo-text\" translate=\"CONTACTS.CONTACTS\">\nContacts</span></div></div><div class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><label \nfor=\"search\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></label><md-input-container md-no-float class=\"m-0\"><input \nid=\"search\" placeholder=\"Search for anyone\" type=\"text\" ng-model=\"vm.search\" translate \ntranslate-attr-placeholder=\"CONTACTS.SEARCH_FOR_ANYONE\"></md-input-container></div></div><div \nng-show=\"vm.selectedContacts.length > 0\" class=\"selected-bar header animate-slide-down md-accent-bg\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"close-button-wrapper\" ng-click=\"vm.selectedContacts =[]\"><md-button \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-arrow-left\" class=\"mr-8\"></md-icon><span \ntranslate=\"CONTACTS.BACK\">Back</span></md-button></div><div flex layout=\"row\" layout-align=\"space-between center\"><div>\n<span class=\"selected-contacts-count\"><span>{{vm.selectedContacts.length}}</span> <span translate=\"CONTACTS.SELECTED\">\nselected</span></span><md-menu class=\"select-menu\" ng-if=\"!vm.currentThread\"><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\" aria-label=\"multi select toggle\" translate \ntranslate-attr-aria-label=\"CONTACTS.MULTI_SELECT_TOGGLE\"><md-icon md-font-icon=\"icon-menu-down\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.selectAllContacts()\" translate=\"CONTACTS.SELECT_ALL\">\nSelect all</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.deselectContacts()\" \ntranslate=\"CONTACTS.SELECT_NONE\">Select none</md-button></md-menu-item></md-menu-content></md-menu></div><div \nclass=\"multi-select-actions\"><md-button class=\"md-icon-button\" ng-click=\"vm.deleteSelectedContacts($event)\" \naria-label=\"delete selected\" translate translate-attr-label=\"CONTACTS.DELETE_SELECTED\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon></md-button></div></div></div><div class=\"content\" md-background-bg layout=\"row\" \nlayout-align=\"start start\"><md-sidenav class=\"sidenav main-sidenav md-white-bg\" ms-scroll \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/apps/contacts/sidenavs/main/main-sidenav.html\'\"></md-sidenav><div class=\"main\" ms-scroll><md-list\n class=\"contacts-list\"><md-subheader class=\"md-no-sticky md-white-bg\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"list-title\" layout=\"row\" layout-align=\"start center\" \nng-hide=\"editGroupForm.$visible\"><span ng-if=\"vm.listType === \'all\'\" translate=\"CONTACTS.ALL_CONTACTS\">All contacts\n</span> <span ng-if=\"vm.listType === \'frequent\'\" translate=\"CONTACTS.FREQUENTLY_CONTACTED\">Frequnetly contacted</span> \n<span ng-if=\"vm.listType === \'starred\'\" translate=\"CONTACTS.STARRED_CONTACTS\">Starred contacts</span> <span \nng-if=\"vm.listType.name\">{{vm.listType.name}}</span> <span ng-if=\"filteredContacts.length\" \nclass=\"secondary-text contacts-count\">({{filteredContacts.length}})</span></div><div class=\"edit-group-form\" \nng-show=\"vm.listType.name\" layout=\"row\" layout-align=\"start center\"><span ng-show=\"editGroupForm.$visible\" \neditable-text=\"vm.listType.name\" e-form=\"editGroupForm\" onaftersave=\"vm.editGroup()\"></span><md-button \nclass=\"md-icon-button edit-group-button\" ng-click=\"editGroupForm.$show()\" ng-hide=\"editGroupForm.$visible\" \naria-label=\"edit group name\" translate translate-attr-label=\"CONTACTS.EDIT_GROUP_NAME\"><md-icon \nmd-font-icon=\"icon-pencil s18\"></md-icon></md-button><md-button class=\"md-icon-button edit-group-button\" \nng-click=\"vm.deleteGroup($event)\" ng-hide=\"editGroupForm.$visible\" aria-label=\"delete group\" translate \ntranslate-attr-label=\"CONTACTS.DELETE_GROUP\"><md-icon md-font-icon=\"icon-delete s18\"></md-icon></md-button></div><div \nflex></div><md-menu><md-button class=\"md-icon-button\" aria-label=\"Sort\" translate \ntranslate-attr-aria-label=\"CONTACTS.SORT\"><md-icon md-font-icon=\"icon-sort-alphabetical\" \nng-click=\"$mdOpenMenu($event)\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"vm.listOrder = \'name\';vm.listOrderAsc = false\" \nng-style=\"vm.listOrder === \'name\' && vm.listOrderAsc=== false && {\'font-weight\':\'500\'}\"><span \ntranslate=\"CONTACTS.FIRST_NAME\">First Name</span> <small translate=\"CONTACTS.A_TO_Z\">(A to Z)</small></md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.listOrder = \'name\'; vm.listOrderAsc = true\" \nng-style=\"vm.listOrder === \'name\' && vm.listOrderAsc=== true && {\'font-weight\':\'500\'}\"><span \ntranslate=\"CONTACTS.FIRST_NAME\">First Name</span> <small translate=\"CONTACTS.Z_TO_A\">(Z to A)</small></md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.listOrder = \'lastName\';vm.listOrderAsc = false\" \nng-style=\"vm.listOrder === \'lastName\' && vm.listOrderAsc=== false && {\'font-weight\':\'500\'}\"><span \ntranslate=\"CONTACTS.LAST_NAME\">Last Name</span> <small translate=\"CONTACTS.A_TO_Z\">(A to Z)</small></md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.listOrder = \'lastName\'; vm.listOrderAsc = true\" \nng-style=\"vm.listOrder === \'lastName\' && vm.listOrderAsc=== true && {\'font-weight\':\'500\'}\"><span \ntranslate=\"CONTACTS.LAST_NAME\">Last Name</span> <small translate=\"CONTACTS.Z_TO_A\">(Z to A)</small></md-button>\n</md-menu-item></md-menu-content></md-menu></div></md-subheader><md-list-item class=\"contact-item md-white-bg\" \nmd-ink-ripple \nng-repeat=\"contact in vm.contacts | filter: vm.search | filter: global.search | filterByIds:vm.filterIds |  orderBy: vm.listOrder :vm.listOrderAsc | filter:query as filteredContacts track by contact.id \" \nng-click=\"vm.openContactDialog($event, contact)\" \nng-style=\"{\'transform\': \'translate3d(0px, \'+$index * 100+\'%, 0px)\', \'z-index\': filteredContacts.length - $index}\" \nng-class=\"{\'selected\': vm.isSelected(contact)}\"><md-checkbox ng-checked=\"vm.exists(contact, vm.selectedContacts)\" \nng-click=\"vm.toggleSelectContact(contact, $event)\" \naria-label=\"{{vm.exists(contact, vm.selectedContacts) ? \'Deselect\' : \'Select\'}}\"></md-checkbox><img class=\"md-avatar\" \nng-if=\"contact.avatar\" alt=\"{{contact.name}}\" ng-src=\"{{contact.avatar}}\"><p class=\"text-truncate font-weight-600\">\n{{contact.name}} {{contact.lastName}}</p><p class=\"email text-truncate hide show-gt-sm\">{{contact.email}}</p><p \nclass=\"phone text-truncate hide show-gt-md\">{{contact.phone}}</p><p class=\"job-title text-truncate hide show-gt-lg\">\n{{contact.jobTitle}}</p><p class=\"company text-truncate hide show-gt-lg\">{{contact.company}}</p><div class=\"actions\" \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button hide show-gt-xs\" \nng-click=\"$event.stopPropagation();vm.toggleInArray(contact.id, vm.user.starred)\" aria-label=\"Toggle starred\" \ntranslate translate-attr-aria-label=\"CONTACTS.TOGGLE_STARRED\"><md-icon ng-if=\"vm.exists(contact.id,vm.user.starred)\" \nmd-font-icon=\"icon-star\" class=\"amber-fg\"></md-icon><md-icon ng-if=\"!vm.exists(contact.id,vm.user.starred)\" \nmd-font-icon=\"icon-star-outline\"></md-icon></md-button><md-menu><md-button class=\"md-icon-button\" aria-label=\"More\" \ntranslate translate-attr-aria-label=\"CONTACTS.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\" \nng-click=\"$mdOpenMenu($event)\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"vm.deleteContactConfirm(contact, ev)\" translate=\"CONTACTS.DELETE_CONTACT\">Delete Contact</md-button>\n</md-menu-item><md-divider ng-if=\"vm.user.groups\"></md-divider><md-subheader class=\"md-no-sticky\" \nng-if=\"vm.user.groups\">Groups</md-subheader><md-list-item ng-if=\"vm.user.groups\" ng-repeat=\"group in vm.user.groups\" \nng-click=\"vm.toggleInArray(contact.id,group.contactIds)\"><p class=\"pl-8\" \nng-style=\"vm.exists(contact.id,group.contactIds) && {\'font-weight\':\'500\'}\">{{group.name}}</p></md-list-item>\n</md-menu-content></md-menu></div></md-list-item></md-list><md-list-item class=\"no-results md-white-bg\" \nng-show=\"filteredContacts.length === 0\"><p translate=\"CONTACTS.NO_RESULTS\">No results..</p></md-list-item></div></div>\n<md-button class=\"md-fab md-accent md-icon-button\" id=\"add-contact-button\" ng-click=\"vm.openContactDialog($event)\" \naria-label=\"add contact\" translate translate-attr-aria-label=\"CONTACTS.ADD_CONTACT\"><md-icon \nmd-font-icon=\"icon-account-plus\"></md-icon></md-button></div>");
$templateCache.put("app/main/apps/file-manager/file-manager.html","<div id=\"file-manager\" class=\"page-layout simple right-sidenav\" layout=\"row\"><md-sidenav class=\"main-sidenav\" \nmd-component-id=\"main-sidenav\" ng-include=\"\'app/main/apps/file-manager/sidenavs/main/main-sidenav.html\'\" ms-scroll \nms-sidenav-helper></md-sidenav><div class=\"center\" layout=\"column\" flex><div class=\"header md-accent-bg\"><div \nclass=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"space-between\"><md-button class=\"md-icon-button main-sidenav-toggle\" \nng-click=\"vm.toggleSidenav(\'main-sidenav\')\" aria-label=\"Toggle Main Sidenav\" translate \ntranslate-attr-aria-label=\"FILE.TOOGLE_MAIN_SIDENAV\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"right-side\" layout=\"row\"><md-button class=\"md-icon-button\" aria-label=\"Search\" translate \ntranslate-attr-aria-label=\"FM.SEARCH\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><md-tooltip><span \ntranslate=\"FM.SEARCH\">Search</span></md-tooltip></md-button><md-button ng-if=\"vm.currentView === \'list\'\" \nclass=\"md-icon-button\" ng-click=\"vm.toggleView()\" aria-label=\"view type\" translate \ntranslate-attr-aria-label=\"FM.GRID_VIEW\"><md-icon md-font-icon=\"icon-view-module\"></md-icon><md-tooltip><span \ntranslate=\"FM.GRID_VIEW\">Grid View</span></md-tooltip></md-button><md-button ng-if=\"vm.currentView === \'grid\'\" \nclass=\"md-icon-button\" aria-label=\"view type\" ng-click=\"vm.toggleView()\" translate \ntranslate-attr-aria-label=\"FM.LIST_VIEW\"><md-icon md-font-icon=\"icon-view-headline\"></md-icon><md-tooltip><span \ntranslate=\"FM.LIST_VIEW\">List View</span></md-tooltip></md-button></div></div><div class=\"breadcrumb text-truncate\" \nlayout=\"row\" layout-align=\"start center\"><span data-ng-repeat=\"path in vm.path\">{{path}}<md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"icon separator\"></md-icon></span></div></div><div id=\"file-uploader\" \nflow-init=\"vm.ngFlowOptions\" flow-name=\"vm.ngFlow.flow\" flow-files-submitted=\"vm.upload()\" \nflow-file-added=\"vm.fileAdded($file)\" flow-file-success=\"vm.fileSuccess($file, $message)\" \nflow-complete=\"vm.uploadComplete()\"><md-button flow-btn class=\"add-file-button md-fab md-warn\" \nng-click=\"vm.addFile($event)\" aria-label=\"Add file\" translate translate-attr-aria-label=\"FM.ADD_FILE\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button></div></div><md-content class=\"content\" flex ms-scroll><div \nng-if=\"vm.currentView === \'grid\'\" ng-include=\"\'app/main/apps/file-manager/views/grid/grid-view.html\'\"></div><div \nng-if=\"vm.currentView === \'list\'\" ng-include=\"\'app/main/apps/file-manager/views/list/list-view.html\'\"></div>\n</md-content></div><md-sidenav class=\"sidenav details-sidenav md-sidenav-right\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" \nmd-component-id=\"details-sidenav\" ng-include=\"\'app/main/apps/file-manager/sidenavs/details/details-sidenav.html\'\" \nms-scroll ms-sidenav-helper></md-sidenav></div>");
$templateCache.put("app/main/apps/notes/notes.html","<div id=\"notes\" class=\"\" layout=\"column\"><md-sidenav class=\"sidenav main-sidenav md-white-bg\" ms-scroll \nmd-component-id=\"main-sidenav\" ms-sidenav-helper ng-include=\"\'app/main/apps/notes/sidenavs/main/main-sidenav.html\'\">\n</md-sidenav><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\"><md-button class=\"md-icon-button sidenav-toggle\" \nng-click=\"vm.toggleSidenav(\'main-sidenav\')\" aria-label=\"Toggle sidenav\" translate \ntranslate-attr-aria-label=\"NOTES.TOGGLE_SIDENAV\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button>\n<div class=\"main-title\" layout=\"row\" layout-align=\"start center\"><md-icon class=\"logo-icon mr-8\" \nmd-font-icon=\"icon-lightbulb\"></md-icon><span class=\"title\" ng-if=\"vm.noteListType === \'notes\'\" \ntranslate=\"NOTES.NOTES\">Notes</span> <span class=\"title\" ng-if=\"vm.noteListType === \'reminders\'\" \ntranslate=\"NOTES.REMINDERS\">Reminders</span> <span class=\"title\" ng-if=\"vm.noteListType === \'archive\'\" \ntranslate=\"NOTES.ARCHIVE\">Archive</span> <span class=\"title\" ng-if=\"vm.noteListType.name\">{{vm.noteListType.name}}\n</span> <span ng-if=\"filteredNotes.length\" class=\"pl-8 white-text secondary-text notes-count\">\n({{filteredNotes.length}})</span></div></div><div flex></div><md-button class=\"md-icon-button sidenav-toggle\" \nng-click=\"vm.openSearchToolbar()\" aria-label=\"open search toolbar\" translate \ntranslate-attr-aria-label=\"NOTES.OPEN_SEARCH_TOOLBAR\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon\"></md-icon>\n</md-button></div><div ng-show=\"vm.searchToolbar\" \nclass=\"md-toolbar-tools search-toolbar animate-slide-down md-accent-bg\" layout=\"row\" layout-align=\"start center\">\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeSearchToolbar()\" translate translate-attr-aria-label=\"NOTES.CLOSE\" \naria-label=\"close\"><md-icon md-font-icon=\"icon-close\" class=\"mr-8\"></md-icon></md-button><input \nid=\"search-notes-input\" placeholder=\"Search notes\" type=\"text\" ng-model=\"vm.search\" translate \ntranslate-attr-placeholder=\"NOTES.SEARCH_NOTES\" ng-model-options=\"{\'debounce\': 200}\" flex></div></md-toolbar>\n<md-content ms-scroll flex><ms-new-note ng-hide=\"vm.noteListType === \'archive\'\" class=\"md-whiteframe-2dp\">\n</ms-new-note><ms-masonry class=\"notes\" options=\'{\"columnCount\":5}\'><ms-masonry-item class=\"note\" \nng-repeat=\"note in vm.notes | filter:vm.search | filter:vm.filters | filterByPropIds:\'labels\':vm.labelFilterIds |  orderBy: \'time\':true | filter:query as filteredNotes track by note.id \" \nms-note-item=\"note\" ng-click=\"vm.editNote($event, note.id)\"></ms-masonry-item></ms-masonry><div \nclass=\"no-results text-center\" ng-if=\"filteredNotes.length === 0 &&  vm.search === \'\'\"><div class=\"message\" \nng-if=\"vm.noteListType === \'notes\'\"><md-icon class=\"message-icon s96\" md-font-icon=\"icon-lightbulb\"></md-icon><div \nclass=\"message-text\" translate=\"NOTES.NO_NOTES_YET\">No notes yet...</div></div><div class=\"message\" \nng-if=\"vm.noteListType === \'reminders\'\"><md-icon class=\"message-icon s96\" md-font-icon=\"icon-bell\"></md-icon><div \nclass=\"message-text\" translate=\"NOTES.NO_NOTES_WITH_REMINDERS\">No notes with reminders</div></div><div class=\"message\" \nng-if=\"vm.noteListType === \'archive\'\"><md-icon class=\"message-icon s96\" md-font-icon=\"icon-archive\"></md-icon><div \nclass=\"message-text\" translate=\"NOTES.NO_ARCHIVED_NOTES\">No archived Notes</div></div><div class=\"message\" \nng-if=\"vm.noteListType.name\"><md-icon class=\"message-icon s96\" md-font-icon=\"icon-label\"></md-icon><div \nclass=\"message-text\" translate=\"NOTES.NO_NOTES_WITH_THIS_LABEL\">No notes with this label</div></div></div><div \nclass=\"no-results text-center\" ng-if=\"filteredNotes.length === 0 &&  vm.search !== \'\'\"><div class=\"message\"><md-icon \nclass=\"message-icon s96\" md-font-icon=\"icon-lightbulb\"></md-icon><div class=\"message-text\" \ntranslate=\"NOTES.NO_RESULTS\">No results...</div></div></div></md-content></div>");
$templateCache.put("app/main/apps/tasks/tasks.dialog.html","<md-dialog aria-label=\"Queue Tasks\" layout=\"column\" \nstyle=\"width: 92vw; max-width: 1280px; min-height: 70vh; border-radius: 14px; overflow: hidden; background: #f7f7fb\">\n<md-toolbar class=\"md-primary\" \nstyle=\"background: linear-gradient(180deg, #fcfcff 0%, #f3f3fb 100%); color: #20243a; border-bottom: 1px solid #e5e7f2\">\n<div class=\"md-toolbar-tools\"><h2><md-icon md-font-icon=\"icon-format-list-bulleted\" style=\"color: #315efb\"></md-icon>\n&nbsp; Cola de tareas</h2><div style=\"margin-left: 12px; font-size: 12px; color: #7d839d\">\nGestion centralizada de procesos y ejecucion de hilos.</div><span flex></span><md-button class=\"md-icon-button\" \naria-label=\"Actualizar\" ng-click=\"vm.refresh()\"><md-icon md-font-icon=\"icon-refresh\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Cerrar\" ng-click=\"vm.close()\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"md-padding\" layout=\"column\" flex \nstyle=\"background: #f7f7fb; overflow: hidden\"><div layout=\"row\" layout-wrap layout-align=\"start center\" \nstyle=\"background: #ffffff; border: 1px solid #e6e8f2; border-radius: 10px; padding: 12px 14px\"><md-input-container \nflex style=\"margin-bottom: 0\"><label>Fuente</label><md-select ng-model=\"vm.sourceFilter\" ng-change=\"vm.loadData()\">\n<md-option ng-value=\"null\">Todas</md-option><md-option ng-repeat=\"source in vm.sources\" ng-value=\"source.id\">\n{{ source.label }}</md-option></md-select></md-input-container><md-input-container flex style=\"margin-bottom: 0\">\n<label>Cola</label><md-select ng-model=\"vm.queueFilter\" ng-change=\"vm.filterRows()\"><md-option ng-value=\"null\">Todas\n</md-option><md-option ng-repeat=\"queue in vm.availableQueues\" ng-value=\"queue\">{{ queue }}</md-option></md-select>\n</md-input-container><md-input-container flex style=\"margin-bottom: 0\"><label>Estatus</label><md-select \nng-model=\"vm.statusFilter\" ng-change=\"vm.filterRows()\"><md-option ng-value=\"null\">Todos</md-option><md-option \nng-repeat=\"status in vm.statuses\" ng-value=\"status\">{{ vm.getStatusLabel(status) }}</md-option></md-select>\n</md-input-container><md-input-container flex style=\"margin-bottom: 0\"><label>Accion</label><md-select \nng-model=\"vm.actionFilter\" ng-change=\"vm.filterRows()\"><md-option ng-value=\"null\">Todas</md-option><md-option \nng-repeat=\"action in vm.availableActions\" ng-value=\"action\">{{ action }}</md-option></md-select></md-input-container>\n<md-input-container flex style=\"margin-bottom: 0\"><label>Ordenar por</label><md-select ng-model=\"vm.sortOption\" \nng-change=\"vm.changePage(1)\"><md-option ng-repeat=\"option in vm.sortOptions\" ng-value=\"option.id\">{{ option.label }}\n</md-option></md-select></md-input-container><div flex=\"nogrow\" layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-icon-button\" style=\"margin: 0 8px 0 0\" ng-click=\"vm.refresh()\" ng-disabled=\"vm.loading\" \naria-label=\"Recargar\"><md-icon md-font-icon=\"icon-refresh\"></md-icon><md-tooltip md-direction=\"top\" md-delay=\"0\">\nRecargar</md-tooltip></md-button><md-button class=\"md-icon-button md-warn\" style=\"margin: 0\" \nng-click=\"vm.clearFilters()\" aria-label=\"Limpiar filtros\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip \nmd-direction=\"top\" md-delay=\"0\">Limpiar filtros</md-tooltip></md-button></div></div><md-progress-linear \nng-if=\"vm.loading\" md-mode=\"indeterminate\"></md-progress-linear><div ng-if=\"vm.error && !vm.loading\" \nstyle=\"padding: 24px; text-align: center\"><md-icon md-font-icon=\"icon-alert\"></md-icon><div style=\"margin-top: 8px\">\n{{ vm.error }}</div></div><div class=\"md-table-container\" ng-if=\"vm.rows.length && !vm.loading\" \nstyle=\"margin-top: 12px; background: #ffffff; border: 1px solid #e6e8f2; border-radius: 10px; overflow: hidden; display: flex; flex-direction: column; flex: 1; min-height: 0\">\n<div style=\"overflow: auto; flex: 1; min-height: 0\"><table md-table \nstyle=\"background: #ffffff; table-layout: auto; width: 100%\"><thead md-head><tr md-row style=\"background: #f1f3ff\"><th \nmd-column style=\"width: 48px; padding: 8px 10px; position: sticky; top: 0; background: #f1f3ff; z-index: 2\">\n<md-checkbox ng-checked=\"vm.isAllSelected()\" md-indeterminate=\"vm.isIndeterminate()\" ng-click=\"vm.toggleAll($event)\" \naria-label=\"Seleccionar todas\"></md-checkbox></th><th md-column \nstyle=\"padding: 8px 10px; white-space: nowrap; position: sticky; top: 0; background: #f1f3ff; z-index: 2\">ID</th><th \nmd-column style=\"padding: 8px 10px; position: sticky; top: 0; background: #f1f3ff; z-index: 2\">Detalles</th><th \nmd-column style=\"padding: 8px 10px; white-space: nowrap; position: sticky; top: 0; background: #f1f3ff; z-index: 2\">\nEstatus</th><th md-column \nstyle=\"padding: 8px 10px; white-space: nowrap; position: sticky; top: 0; background: #f1f3ff; z-index: 2\">Fechas</th>\n<th md-column style=\"padding: 8px 10px; position: sticky; top: 0; background: #f1f3ff; z-index: 2\">Error</th></tr>\n</thead><tbody md-body><tr ng-repeat-start=\"item in vm.rows track by item.__key\" md-row \nstyle=\"border-bottom: 1px solid #eef0f7\"><td md-cell style=\"padding: 8px 10px\"><md-checkbox \nng-checked=\"!!vm.selectedMap[item.__key]\" ng-click=\"vm.toggleOne(item, $event)\" aria-label=\"Seleccionar tarea\">\n</md-checkbox></td><td md-cell style=\"padding: 8px 10px; white-space: nowrap\">{{ item.id }}</td><td md-cell \nstyle=\"padding: 8px 10px\"><div layout=\"row\" layout-align=\"start center\" style=\"gap: 8px\"><div \nstyle=\"font-weight: 600; color: #2c3350; white-space: normal; word-break: break-word\">{{ item.action }}</div><md-button\n class=\"md-icon-button md-primary\" style=\"margin: 0; width: 28px; min-width: 28px; height: 28px; line-height: 28px\" \naria-label=\"Ver detalle\" ng-click=\"vm.toggleDetails(item, $event)\" ng-disabled=\"!vm.hasDetails(item)\"><md-icon \nmd-font-icon=\"{{ vm.expandedMap[item.__key] ? \'icon-close\' : \'icon-eye\' }}\" style=\"font-size: 16px\"></md-icon>\n</md-button></div><div style=\"margin-top: 4px; color: #6f7896; white-space: normal; word-break: break-word\">\n{{ item.queue }} ({{ item.sourceLabel }})</div></td><td md-cell style=\"padding: 8px 10px; white-space: nowrap\"><span \nstyle=\"display: inline-block; padding: 4px 10px; border-radius: 999px; font-size: 12px; font-weight: 600\" \nng-style=\"vm.getStatusStyle(item.status)\">{{ vm.getStatusLabel(item.status) }}</span><div style=\"margin-top: 6px\"><span\n \nstyle=\"display: inline-block; padding: 2px 8px; border-radius: 999px; background: #eef1f8; color: #5f6985; font-size: 11px; font-weight: 600\">\n{{ item.attempts }} intento(s)</span></div></td><td md-cell style=\"padding: 8px 10px; white-space: nowrap\"><div \nstyle=\"font-weight: 600; color: #2c3350\">Creado: {{ item.timestamp | date:\'short\' }}</div><div \nng-if=\"!item.scheduledFor\" style=\"margin-top: 6px; color: #9aa1b8\">Programado: -</div><div ng-if=\"item.scheduledFor\" \nstyle=\"margin-top: 6px; color: #6f7896\">Programado: {{ item.scheduledFor | date:\'short\' }}</div></td><td md-cell \nstyle=\"padding: 8px 10px; max-width: 260px; color: #c62828; white-space: nowrap; overflow: hidden; text-overflow: ellipsis\">\n<span>{{ item.error || \'-\' }}</span><md-tooltip ng-if=\"item.error\" md-direction=\"top\" md-delay=\"0\">{{ item.error }}\n</md-tooltip></td></tr><tr ng-repeat-end ng-if=\"vm.expandedMap[item.__key]\" style=\"background: #f8f9ff\"><td \ncolspan=\"11\" style=\"padding: 0 10px 10px\"><div ng-if=\"item.error\" \nstyle=\"padding: 10px 0 6px; color: #d84343; font-weight: 600; font-size: 12px\">Detalle del error tecnico:</div><div \nstyle=\"max-height: 240px; overflow: auto; background: #e9ebf7; border-radius: 8px\"><pre \nstyle=\"margin: 0; padding: 14px; color: #34384d; font-size: 12px; white-space: pre-wrap; word-break: break-word\">\n{{ item.rawJson }}</pre></div></td></tr></tbody></table></div></div><div \nng-if=\"!vm.loading && !vm.error && !vm.rows.length\" style=\"padding: 24px; text-align: center\"><md-icon \nmd-font-icon=\"icon-clipboard-text-outline\"></md-icon><p>No hay tareas para los filtros seleccionados.</p></div><div \nng-if=\"vm.filteredRows.length && !vm.loading\" layout=\"row\" layout-align=\"space-between center\" \nstyle=\"padding: 12px 4px 0; color: #6b7280; font-size: 12px\"><div>\nMostrando {{ ((vm.page - 1) * vm.pageSize) + 1 }}-{{ (((vm.page - 1) * vm.pageSize) + vm.rows.length) }} de {{ vm.filteredRows.length }} tareas\n</div><div layout=\"row\" layout-align=\"end center\"><md-input-container style=\"margin: 0 12px 0 0; min-width: 90px\">\n<md-select ng-model=\"vm.pageSize\" ng-change=\"vm.changePageSize()\" aria-label=\"Tamano de pagina\"><md-option \nng-repeat=\"size in vm.pageSizeOptions\" ng-value=\"size\">{{ size }}</md-option></md-select></md-input-container>\n<md-button class=\"md-icon-button\" ng-click=\"vm.changePage(vm.page - 1)\" ng-disabled=\"vm.page === 1\" \naria-label=\"Pagina anterior\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon></md-button><md-button \nng-repeat=\"pageNumber in vm.visiblePages() track by pageNumber\" class=\"md-icon-button\" \nng-class=\"{\'md-primary md-raised\': vm.page === pageNumber}\" ng-click=\"vm.changePage(pageNumber)\" \naria-label=\"Ir a pagina {{ pageNumber }}\">{{ pageNumber }}</md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.changePage(vm.page + 1)\" ng-disabled=\"vm.page === vm.totalPages\" aria-label=\"Pagina siguiente\"><md-icon \nmd-font-icon=\"icon-chevron-right\"></md-icon></md-button></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><span \nng-if=\"vm.confirmDelete\" style=\"margin-right: 8px\">Eliminar {{ vm.selectedCount() }} tarea(s)?</span></div><div \nlayout=\"row\" layout-align=\"end center\"><md-button ng-if=\"vm.confirmDelete\" ng-click=\"vm.cancelDelete()\">Cancelar\n</md-button><md-button ng-if=\"vm.confirmDelete\" class=\"md-warn md-raised\" ng-click=\"vm.deleteSelected()\" \nng-disabled=\"!vm.selectedCount() || vm.loading\">Confirmar</md-button><md-button ng-if=\"!vm.confirmDelete\" \nclass=\"md-warn\" ng-click=\"vm.confirmDelete = true\" ng-disabled=\"!vm.selectedCount() || vm.loading\">\nEliminar seleccionadas</md-button><md-button class=\"md-primary md-raised\" ng-click=\"vm.close()\">Cerrar</md-button>\n</div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/todo/todo.html","<div id=\"todo\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><md-sidenav \nclass=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"main-sidenav\" \nng-include=\"\'app/main/apps/todo/sidenavs/main/main-sidenav.html\'\" ms-scroll ms-sidenav-helper></md-sidenav><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"search-wrapper md-whiteframe-4dp\" flex layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'main-sidenav\')\" hide-gt-md \naria-label=\"Toggle sidenav\" translate translate-attr-aria-label=\"TODO.TOGGLE_SIDENAV\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"search\" flex layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input flex \nng-model=\"vm.taskFilters.search\" type=\"text\" placeholder=\"Search for a task or tag\" translate \ntranslate-attr-placeholder=\"TODO.SEARCH\"></div></div></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><md-select class=\"simplified\" \nng-model=\"vm.selectedFilter.dueDate\" placeholder=\"Due Date\"><md-option value=\"Next 3 days\" \ntranslate=\"TODO.NEXT_3_DAYS\">Next 3 days</md-option><md-option value=\"Next 7 days\" translate=\"TODO.NEXT_7_DAYS\">\nNext 7 days</md-option><md-option value=\"Next 2 weeks\" translate=\"TODO.NEXT_2_WEEKS\">Next 2 weeks</md-option><md-option\n value=\"Next month\" translate=\"TODO.NEXT_MONTH\">Next month</md-option></md-select><div layout=\"row\" \nlayout-align=\"start center\"><md-select class=\"simplified\" ng-model=\"vm.taskOrder\" placeholder=\"Order\" \nng-change=\"vm.taskOrderDescending = vm.taskOrder === \'\' ? false : vm.taskOrderDescending\"><md-option \nvalue=\"startDateTimestamp\" translate=\"TODO.START_DATE\">Start Date</md-option><md-option value=\"dueDateTimestamp\" \ntranslate=\"TODO.DUE_DATE\">Due Date</md-option><md-option value=\"\" translate=\"TODO.MANUAL\">Manual</md-option><md-option \nvalue=\"title\" translate=\"TODO.TITLE\">Title</md-option></md-select><md-button class=\"md-icon-button\" \nng-disabled=\"vm.taskOrder === \'\'\" ng-click=\"vm.taskOrderDescending = !vm.taskOrderDescending\" \naria-label=\"Sort Direction\" translate translate-attr-aria-label=\"TODO.SORT_DIRECTION\"><md-icon \nmd-font-icon=\"icon-sort-ascending\" ng-if=\"vm.taskOrderDescending === false\"></md-icon><md-icon \nmd-font-icon=\"icon-sort-descending\" ng-if=\"vm.taskOrderDescending === true\"></md-icon></md-button></div></div><div \nclass=\"content\" layout=\"row\" flex><md-content class=\"todo-list-pane\" flex \nng-include=\"\'app/main/apps/todo/views/list/list-view.html\'\" ms-scroll=\"vm.msScrollOptions\"></md-content></div></div>\n</div></div>");
$templateCache.put("app/main/employees/dialogs/archive-movement.html","<md-dialog><md-toolbar><div class=\"md-toolbar-tools\"><h2>Archivar {{selected.length}} Movimiento(s)</h2><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close Dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><form name=\"movementForm\" ng-submit=\"answer(archiveDate)\" \nng-disabled=\"movementForm.$invalid\" novalidate><div class=\"md-dialog-content\"><div layout-gt-xs=\"row\" flex>\n<md-input-container class=\"md-block date-picker\" flex ng-init=\"archiveDate = today.valueOf()\"><label>\nFecha para Archivar</label><md-datepicker md-hide-icons=\"triangle\" md-current-view=\"{{F.dateView}}\" \ninput-date-miliseconds ng-model=\"archiveDate\" required name=\"archiveDate\" md-min-date=\"minDate\" class=\"md-block\">\n</md-datepicker><div ng-messages=\"movementForm.archiveDate.$error\" ng-show=\"movementForm.archiveDate.$dirty\" \nrole=\"alert\"><div ng-message=\"required\">Fecha de Archivo es requerido</div></div></md-input-container></div></div>\n</form></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button ng-click=\"answer(archiveDate)\" \nclass=\"md-primary md-hue-2\" ng-disabled=\"movementForm.$invalid\">OK</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/employees/dialogs/bottom-list-grid.html","<md-bottom-sheet class=\"md-list md-has-header bottomList\"><md-subheader ng-cloak>{{nameOf | capitalize}}s de Empleado\n</md-subheader><md-content layout-fill stop-touch-event><md-list ng-cloak layout=\"column\"><md-list-item \nng-repeat=\"(id, obj) in array\" layout-align=\"space-between center\" layout=\"row\" flex><span \nclass=\"md-inline-list-icon-label\">{{obj.t | typeName| capitalize}}</span> <span class=\"md-inline-list-icon-label\">\n{{obj.d| date:F.dateFormat}}</span><md-button with-permission action=\"read{{nameOfObj | capitalize}}\" \naccess=\"{{F.active.menuItem}}\" ng-click=\'openObject($event, id,\"read\")\' class=\"md-raised md-primary md-hue-1\" \naria-label=\"See {{nameOf}} Detail\"><md-tooltip md-direction=\"left\">Ver</md-tooltip><md-icon md-font-icon=\"icon-eye\" \naria-label=\"see more\"></md-icon></md-button><md-button with-permission action=\"update{{nameOfObj | capitalize}}\" \naccess=\"{{F.active.menuItem}}\" ng-click=\'openObject($event, id,\"edit\")\' class=\"md-raised md-primary md-hue-1\" \naria-label=\"Edit {{nameOf}}\"><md-tooltip md-direction=\"left\">Editar</md-tooltip><md-icon \nmd-font-icon=\"icon-tooltip-edit\" aria-label=\"edit\"></md-icon></md-button><md-button with-permission \naction=\"remove{{nameOfObj | capitalize}}\" access=\"{{F.active.menuItem}}\" ng-click=\"delete($event,id,nameOfObj,array)\" \nclass=\"md-raised md-primary md-hue-1\" aria-label=\"Delete {{nameOf}}\"><md-tooltip md-direction=\"left\">Eliminar\n</md-tooltip><md-icon md-font-icon=\"icon-delete\" aria-label=\"delete\"></md-icon></md-button><md-button with-permission \naction=\"generatePdf{{nameOfObj | capitalize}}\" access=\"{{F.active.menuItem}}\" ng-if=\"nameOfObj==\'movement\'\" \nng-click=\"generetePdf(id,nameOfObj)\" class=\"md-raised md-primary md-hue-1\" aria-label=\"Generate PDF\"><md-tooltip \nmd-direction=\"left\">Generar PDF</md-tooltip><md-icon md-font-icon=\"icon-file-pdf\" aria-label=\"print pdf\"></md-icon>\n</md-button></md-list-item></md-list></md-content></md-bottom-sheet>");
$templateCache.put("app/main/employees/dialogs/change-payroll-employees.html","<md-dialog aria-label=\"Change Payroll Employees\"><form name=\"changePayrollData\" novalidate ng-cloak><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Cambiar de Nomina {{selected.length}} empleado(s)</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"close()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><h3 class=\"no-margin\">Nomina Origen</h3><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container class=\"md-block evenPadding\" flex flex-gt-xs=\"50\"><label>Tipo de Baja</label>\n<md-select name=\"dismissType\" ng-model=\"data.dismissType\" required><md-select-header><input autocomplete=\"off\" \ntype=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"dismissTypeSelectFilter\" \nplaceholder=\"Busque un tipo de baja\"></md-select-header><md-option ng-value=\"dismissType._id\" \nng-repeat=\'dismissType in M.dismissTypes | orderBy:\"name\" | filter:dismissTypeSelectFilter\'>{{dismissType.name}}\n</md-option></md-select><div ng-messages=\"form.dismissType.$error\" \nng-show=\"form.dismissType.$touched || form.dismissType.$dirty\" role=\"alert\"><div ng-message=\"required\">\nTipo de Baja es requerido</div></div></md-input-container><md-input-container class=\"md-block date-picker\" flex \nflex-gt-xs=\"50\"><label>Fecha de Baja</label><md-datepicker md-hide-icons=\"triangle\" md-max-date=\"maxDismissDate\" \nmd-current-view=\"{{F.dateView}}\" input-date-miliseconds ng-model=\"data.dismissDate\" name=\"date\" class=\"md-block\" \nrequired></md-datepicker></md-input-container></div><h3 class=\"no-margin\">Nomina Destino</h3><div layout=\"column\" \nlayout-gt-sm=\"row\"><div flex=\"50\" layout=\"column\" layout-gt-xs=\"row\"><md-input-container class=\"md-block evenPadding\" \nflex flex-gt-xs=\"50\"><label>Nómina</label><md-select ng-model=\"data.payroll\" name=\"payroll\" required><md-select-header>\n<input autocomplete=\"off\" type=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" \nng-model=\"payrollSelectFilter\" placeholder=\"Busque una nómina\"></md-select-header><md-option \nng-if=\"!F.permissionToAccessAllPayrolls && payroll.active\" ng-value=\"payroll.$id\" \nng-repeat=\"payroll in L.payrolls | orderBy:\'name\' | filter:payrollSelectFilter\">{{payroll.name}}</md-option><md-option \nng-if=\"F.permissionToAccessAllPayrolls && payroll.active\" ng-value=\"payroll.$id\" \nng-repeat=\"payroll in L.allPayrolls | orderBy:\'name\' | filter:payrollSelectFilter\">{{payroll.name}}</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block evenPadding\" flex flex-gt-xs=\"50\"><label>\nCentro de Costo</label><md-select ng-model=\"data.cc\" name=\"cc\" required><md-select-header><input autocomplete=\"off\" \ntype=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"ccSelectFilter\" \nplaceholder=\"Busque un centro de costo\"></md-select-header><md-option ng-value=\"cc.$id\" \nng-repeat=\"cc in ccs| orderBy:\'name\' | filter:ccSelectFilter\">{{cc.name}} <small>[{{L.rpCcs[cc.rp_id].name}}]</small>\n</md-option></md-select><div ng-messages=\"form.cc.$error\" ng-show=\"form.cc.$touched || form.cc.$dirty\" role=\"alert\">\n<div ng-message=\"required\">Centro de Costo es requerido</div></div></md-input-container></div><div flex=\"50\" \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container class=\"md-block evenPadding\" flex><label>Puesto</label>\n<md-select ng-model=\"data.position\" name=\"position\" required ng-disabled=\"F.readMode\"><md-select-header><input \nautocomplete=\"off\" type=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"positionSelectFilter\" \nplaceholder=\"Busque un puesto\"></md-select-header><md-option ng-value=\"position.$id\" \nng-repeat=\"position in L.payrollPositions[data.payroll] | orderBy:\'name\' | filter:positionSelectFilter\">\n{{position.name}}</md-option></md-select><div ng-messages=\"form.position.$error\" \nng-show=\"form.position.$touched || form.position.$dirty\" role=\"alert\"><div ng-message=\"required\">Puesto es requerido\n</div></div></md-input-container><md-input-container class=\"md-block date-picker\" flex flex-gt-xs=\"50\"><label>\nFecha de Reingreso</label><md-datepicker md-hide-icons=\"triangle\" md-min-date=\"minReentryDate\" \nmd-current-view=\"{{F.dateView}}\" input-date-miliseconds ng-model=\"data.reentryDate\" name=\"date\" class=\"md-block\" \nrequired></md-datepicker></md-input-container></div></div><p>\nLos empleados seleccionados generaran automaticamente los movimientos necesarios para ser movidos a una nomina diferente\n</p></md-dialog-content><md-dialog-actions layout=\"row\"><md-button class=\"md-accent md-raised md-primary\" \nng-disabled=\"changePayrollData.$invalid\" ng-click=\"confirm(selected)\">Mandar {{selected.length}} empleados(s)<md-icon \nmd-font-icon=\"icon-send\" aria-label=\"send\"></md-icon></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/employees/dialogs/confirm-special-edit.html","<md-dialog aria-label=\"Confirm Employee Special\"><form name=\"changePayrollData\" novalidate ng-cloak><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>{{confirmObj.title}}</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"close()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><h3 class=\"no-margin\">{{confirmObj.content}}</h3></md-dialog-content><md-dialog-actions\n layout=\"row\"><md-button class=\"md-accent md-raised md-primary\" ng-click=\"confirm(confirmObj.options.option1.value)\" \nng-disabled=\"!editArchived\">{{confirmObj.options.option1.text}}<md-icon md-font-icon=\"icon-send\" aria-label=\"send\">\n</md-icon></md-button><md-button class=\"md-raised md-primary\" ng-click=\"confirm(confirmObj.options.option2.value)\">\n{{confirmObj.options.option2.text}}<md-icon md-font-icon=\"icon-send\" aria-label=\"send\"></md-icon></md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/employees/dialogs/credit.html","<md-dialog><form name=\"form\" novalidate><md-toolbar><div class=\"md-toolbar-tools\"><h2 flex>Crédito <small>\n{{credit.data.date|date:\"mediumDate\"}}</small></h2><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close Dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div \nclass=\"md-dialog-content\"><div form-credit></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-if=\'action == \"edit\"\' ng-click=\"saveCredit(credit)\" ng-hide=\"form.$pristine\" \nng-disabled=\"form.$invalid || loadingProgress\" class=\"md-raised md-background md-accent md-hue-1\" \naria-label=\"Save incidencesType\"><md-tooltip md-direction=\"left\">{{\'EC.SAVE\' | translate}}</md-tooltip><md-icon \nmd-font-icon=\"icon-content-save\" aria-label=\"Save\"></md-icon></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/employees/dialogs/dismiss-many-employees.html","<md-dialog aria-label=\"Dissmiss Employees\"><form name=\"dismissData\" novalidate ng-cloak><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Desea dar de baja {{selected.length}} empleados(s)</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"close()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container \nclass=\"md-block evenPadding\" flex><label>Tipo de Baja</label><md-select name=\"dismissType\" ng-model=\"data.dismissType\" \nrequired><md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" \nng-keydown=\"$event.stopPropagation()\" ng-model=\"dismissTypeSelectFilter\" placeholder=\"Busque un tipo de baja\">\n</md-select-header><md-option ng-value=\"dismissType._id\" \nng-repeat=\'dismissType in M.dismissTypes | orderBy:\"name\" | filter:dismissTypeSelectFilter\'>{{dismissType.name}}\n</md-option></md-select><div ng-messages=\"form.dismissType.$error\" \nng-show=\"form.dismissType.$touched || form.dismissType.$dirty\" role=\"alert\"><div ng-message=\"required\">\nTipo de Baja es requerido</div></div></md-input-container><md-input-container class=\"md-block date-picker\" flex><label>\nFecha de Baja</label><md-datepicker md-hide-icons=\"triangle\" md-current-view=\"{{F.dateView}}\" \nmd-min-date=\"minMovementDate\" md-max-date=\"maxMovementDate\" ng-change=\"validateDismissDates()\" input-date-miliseconds \nrequired ng-model=\"data.dismissDate\" name=\"date\" class=\"md-block\"></md-datepicker></md-input-container></div>\n<md-input-container class=\"md-block mt-0\"><md-switch name=\"payPayrollInSalary\" ng-model=\"data.payPayrollInSalary\">\nPagar Sueldo en Nomina</md-switch></md-input-container><p>\nLos empleados seleccionados serán dados de baja con la fecha seleccionado</p></md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button class=\"md-accent md-raised md-warn\" ng-disabled=\"dismissData.$invalid\" \nng-click=\"confirm(selected)\">Mandar {{selected.length}} empleados(s)<md-icon md-font-icon=\"icon-send\" \naria-label=\"send\"></md-icon></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/employees/dialogs/edit-field-modal.html","<md-dialog><md-toolbar><div class=\"md-toolbar-tools\"><h2>Editar {{fieldCtrl.object.name||fieldCtrl.object.data.name}}\n</h2><div flex></div><md-button class=\"md-icon-button\" ng-click=\"fieldCtrl.cancel()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close Dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div \nclass=\"md-dialog-content noPadding\"><form name=\"form\" ng-submit=\"fieldCtrl.answer(fieldCtrl.field)\" novalidate><div \nlayout-gt-xs=\"row\" flex><md-switch ng-if=\"fieldCtrl.columnConfig.type===\'boolean\'\" ng-model=\"fieldCtrl.field\" \naria-label=\"{fieldCtrl.columnConfig.name}}\">{{fieldCtrl.columnConfig.name}}</md-switch><md-input-container \nclass=\"md-block\" ng-class=\'{\"date-picker\":fieldCtrl.columnConfig.type===\"date\"}\' flex \nng-if=\"fieldCtrl.columnConfig.type!==\'boolean\'\"><label>{{fieldCtrl.columnConfig.name}}</label><md-select \nng-if=\'fieldCtrl.columnConfig.type===\"fromList\"\' ng-model=\"fieldCtrl.field\" name=\"field\" required><md-option \nng-value=\"item.id\" ng-repeat=\"item in fieldCtrl.columnConfig.list\">{{item.name}}</md-option></md-select><md-datepicker \nmd-hide-icons=\"triangle\" ng-if=\'fieldCtrl.columnConfig.type===\"date\"\' md-current-view=\"{{F.dateView}}\" \ninput-date-miliseconds ng-model=\"fieldCtrl.field\" name=\"field\" class=\"md-block\" required></md-datepicker><input \ntype=\"text\" ng-if=\"fieldCtrl.columnConfig.regex && [\'string\',\'number\'].indexOf(fieldCtrl.columnConfig.type)>-1\" \nname=\"field\" ng-model=\"fieldCtrl.field\" md-minlength=\"fieldCtrl.columnConfig.min\" \nminlength=\"{{fieldCtrl.columnConfig.min}}\" md-maxlength=\"fieldCtrl.columnConfig.max\" \nmaxlength=\"{{fieldCtrl.columnConfig.max}}\" pattern=\"{{fieldCtrl.columnConfig.regex}}\" required> <input type=\"text\" \nng-if=\"!fieldCtrl.columnConfig.regex  && [\'string\',\'number\'].indexOf(fieldCtrl.columnConfig.type)>-1\" name=\"field\" \nng-model=\"fieldCtrl.field\" md-minlength=\"fieldCtrl.columnConfig.min\" minlength=\"{{fieldCtrl.columnConfig.min}}\" \nmd-maxlength=\"fieldCtrl.columnConfig.max\" maxlength=\"{{fieldCtrl.columnConfig.max}}\" required><md-select \nng-model=\"fieldCtrl.field\" required ng-if=\"fieldCtrl.columnConfig.type==\'fromMongo\'\"><md-select-header><input \nautocomplete=\"off\" type=\"search\" id=\"searchObject\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" \nng-model=\"fieldCtrl.objectSelectFilter\" placeholder=\"Buscar {{fieldCtrl.columnConfig.name}}\"></md-select-header>\n<md-option ng-value=\"obj._id\" \nng-repeat=\"obj in fieldCtrl.M[fieldCtrl.columnConfig.from] | orderBy:\'name\' | filter:fieldCtrl.objectSelectFilter\">\n{{obj.name}}</md-option></md-select><div ng-messages=\"form.field.$error\" role=\"alert\"><div ng-message=\"required\">\n{{fieldCtrl.columnConfig.name}} es requerido</div><div ng-message=\"minlength\">\n{{fieldCtrl.columnConfig.name}} debe tener al menos {{fieldCtrl.columnConfig.min}} dígitos</div><div \nng-message=\"maxlength\">{{fieldCtrl.columnConfig.name}} debe tener un máximo de {{fieldCtrl.columnConfig.max}} digitos\n</div><div ng-message=\"pattern\">Formato no válido</div></div></md-input-container></div></form></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button aria-label=\"answer field\" \nng-click=\"fieldCtrl.answer(fieldCtrl.field)\" class=\"md-primary md-hue-2\" ng-disabled=\"form.$invalid\">Actualizar\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/employees/dialogs/fast-movement-update.html","<md-dialog><md-toolbar><div class=\"md-toolbar-tools\"><h2>Edición rápida de {{employee.movement.type|typeName}}</h2>\n<md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close Dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content><form name=\"form\" ng-submit=\"answer(employee)\" \nng-disabled=\"form.$invalid\" novalidate><div class=\"md-dialog-content\" \nng-if=\"[2].indexOf(employee.movement.type) !== -1\"><div form-fast-dismiss></div></div><div class=\"md-dialog-content\" \nng-if=\"[6,8].indexOf(employee.movement.type) !== -1\"><div form-fast-enrole></div></div><div class=\"md-dialog-content\" \nng-if=\"[7].indexOf(employee.movement.type) !== -1\"><div form-fast-mds></div></div></form></md-dialog-content>\n<md-dialog-actions layout=\"row\"><span flex></span><md-button ng-click=\"answer(employee)\" class=\"md-primary md-hue-2\" \nng-disabled=\"form.$invalid\">Guardar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/employees/dialogs/import-accounts.html","<md-dialog aria-label=\"Import accounts\"><form name=\"importAccountsForm\" novalidate ng-cloak><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Importar Cuentas ({{accounts.accounts.length}})</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"close()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\" layout=\"column\"><div flex \nng-show=\"!accounts.file\"><lf-ng-md-file-input lf-files=\"filesArray\" lf-placeholder=\"CVS\" \nlf-drag-and-drop-label=\"csv - Max: 10MB\" lf-browse-label=\"{{\'EC.search\' | translate}}\" \nlf-remove-label=\"{{\'EC.remove\' | translate}}\" lf-filesize=\"10MB\" lf-required name=\"accountsFile\" lf-api=\"csvApi\">\n</lf-ng-md-file-input><div ng-messages=\"importAccountsForm.accountsFile.$error\" style=\"color:red\"><div \nng-message=\"required\">Archivo requerido</div><div ng-message=\"maxcount\">Demaciados archivos</div><div \nng-message=\"filesize\">Archivo demaciado grande</div><div ng-message=\"totalsize\">Espacio total demaciado grande</div>\n<div ng-message=\"mimetype\">Formato inválido</div></div><div flex=\"no-grow\" layout=\"row\"><span flex></span> <a \nclass=\"downloadLink\" target=\"_blanc\" href=\"assets/csv/import-accounts-blanc.csv\">descargar template<md-icon \nmd-font-icon=\"icon-file-excel\" aria-label=\"download accounts template\"></md-icon></a></div></div><code flex \nng-if=\"!accounts.file\">Campos necesarios: No_Empleado, Tarjeta, Cuenta<br></code><md-progress-circular \nng-show=\"F.loadingFile\" class=\"md-primary\" md-mode=\"indeterminate\" md-diameter=\"128\"></md-progress-circular><div flex \nng-show=\"accounts.file\"><md-table-container ng-hide=\"F.loadingFile\"><table md-table class=\"row-border\"><thead md-head>\n<tr md-row><th md-column><span>Nomina</span></th><th md-column><span>Empleado</span></th><th md-column><span>Tarjeta\n</span></th><th md-column><span>Cuenta</span></th><th md-column></th></tr></thead><tbody md-body><tr \nng-class=\'{\"validRow\": !employeeM.invalid, \"invalidRow\": employeeM.invalid}\' md-row \nng-repeat=\"employeeM in accounts.accounts\"><td md-cell>{{employeeM.employee.payroll | nameOfL:L.allPayrolls:\'N/A\'}}\n</td><td md-cell>{{employeeM.employee.data.name}}</td><td md-cell>{{employeeM[\'Tarjeta\']}}</td><td md-cell>\n{{employeeM[\'Cuenta\']}}</td><td md-cell><md-button ng-disabled=\"!employeeM.invalid && !employeeM.executed\" \nclass=\"md-fab md-mini\" \nng-class=\'{\"md-primary\": !employeeM.invalid && !employeeM.executed, \"md-warn\": employeeM.invalid , \"green-500-bg\": employeeM.executed}\'>\n<md-icon ng-show=\"employeeM.invalid\" md-font-icon=\"icon-cancel\" aria-label=\"invalid\"></md-icon><md-icon \nng-show=\"!employeeM.invalid\" md-font-icon=\"icon-check\" aria-label=\"valid\"></md-icon><md-tooltip \nng-if=\"employeeM.executed\" md-direction=\"left\">Se Aplico</md-tooltip><md-tooltip ng-if=\"employeeM.errors.length>0\" \nmd-direction=\"left\"><label ng-repeat=\"error in employeeM.errors\">{{error}}{{!$last?\',\':\'\'}}</label></md-tooltip>\n</md-button></td></tr></tbody></table></md-table-container></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\"><span flex></span><md-button \nng-if=\"accounts.file && (accounts.accounts | getActiveObjectsOfAccounts).length && !executedFail\" \nng-disabled=\"executing\" class=\"md-accent md-raised\" ng-click=\"importAccounts(accounts.accounts)\">\nImportar ({{(accounts.accounts | getActiveObjectsOfAccounts).length}}) Cuentas<md-icon md-font-icon=\"icon-import\" \naria-label=\"upload\"></md-icon></md-button><md-button ng-if=\"executedFail\" class=\"md-accent md-raised\" \nng-disabled=\"executing\" ng-click=\"importAccounts(accounts.accounts)\">Reintentar<md-icon md-font-icon=\"icon-import\" \naria-label=\"upload\"></md-icon></md-button><md-button ng-if=\"!accounts.file\" ng-disabled=\"importAccountsForm.$invalid\" \nclass=\"md-primary md-raised\" ng-click=\"upload(filesArray)\">Subir<md-icon md-font-icon=\"icon-file-excel\" \naria-label=\"upload\"></md-icon></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/employees/dialogs/import-employees.html","<md-dialog aria-label=\"Import Variables\" class=\"importDialog\"><form name=\"stepper\" class=\"importEmployees\" ms-stepper \nng-submit=\"employeeDialog.updateEmployees()\" ng-model=\"stepper\" novalidate><ms-stepper-step ng-form=\"step1\" step=\"1\" \nstep-title=\"\'Sube el archivo\'\"><div ng-include=\"\'app/main/employees/dialogs/step-1.html\'\"></div></ms-stepper-step>\n<ms-stepper-step ng-form=\"step2\" step=\"2\" step-title=\"\'Tipos de datos\'\"><div \nng-include=\"\'app/main/employees/dialogs/step-2.html\'\"></div></ms-stepper-step><ms-stepper-step class=\"noAutoH\" \nng-form=\"step3\" step=\"3\" step-title=\"\'Verifica y aplica la información\'\"><div \nng-include=\"\'app/main/employees/dialogs/step-3.html\'\"></div></ms-stepper-step></form></md-dialog>");
$templateCache.put("app/main/employees/dialogs/import-variables.html","<md-dialog aria-label=\"Import Variables\"><form name=\"importVariablesForm\" novalidate ng-cloak><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Importar Variables ({{variables.movements.length}})</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"close()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\" layout=\"column\"><div flex \nng-show=\"!variables.file\"><lf-ng-md-file-input lf-files=\"filesArray\" lf-placeholder=\"CSV\" \nlf-drag-and-drop-label=\"csv - Max: 10MB\" lf-browse-label=\"{{\'EC.search\' | translate}}\" \nlf-remove-label=\"{{\'EC.remove\' | translate}}\" lf-filesize=\"10MB\" lf-required name=\"variablesFile\" lf-api=\"csvApi\">\n</lf-ng-md-file-input><div ng-messages=\"importVariablesForm.variablesFile.$error\" style=\"color:red\"><div \nng-message=\"required\">Archivo requerido</div><div ng-message=\"maxcount\">Demaciados archivos</div><div \nng-message=\"filesize\">Archivo demaciado grande</div><div ng-message=\"totalsize\">Espacio total demaciado grande</div>\n<div ng-message=\"mimetype\">Formato inválido</div></div><div flex=\"no-grow\" layout=\"row\"><span flex></span> <a \nclass=\"downloadLink\" target=\"_blanc\" href=\"assets/csv/import-variables-blanc.csv\">descargar template<md-icon \nmd-font-icon=\"icon-file-excel\" aria-label=\"download variables template\"></md-icon></a></div></div><code flex \nng-if=\"!variables.file\">Campos necesarios: id, sd, sbc, date<br><small>[id = id de firebase]</small></code>\n<md-progress-circular ng-show=\"F.loadingFile\" class=\"md-primary\" md-mode=\"indeterminate\" md-diameter=\"128\">\n</md-progress-circular><div flex ng-show=\"variables.file\"><md-table-container ng-hide=\"F.loadingFile\"><table md-table \nclass=\"row-border\"><thead md-head><tr md-row><th md-column><span>Nómina</span></th><th md-column><span>Empleado</span>\n</th><th md-column><span>Fecha</span></th><th md-column><span>\nSD {{variables.movements[0].importedSd?\'[importado]\':\'[actual]\'}}</span></th><th md-column><span>SBC</span></th><th \nmd-column><span>Tipo de Salario</span></th><th md-column><span>Válido</span></th></tr></thead><tbody md-body \nng-init=\"explain = false\"><tr ng-class=\'{\"validRow\": employeeM.valid, \"invalidRow\": !employeeM.valid}\' md-row \nng-repeat=\"employeeM in variables.movements\"><td md-cell ng-show=\"!explain\">\n{{ ::employeeM.id | getSomethingOfArrayFB: variableEmployees:\'payroll\' | nameOfL:L.allPayrolls:\'N/A\'}}</td><td md-cell \nng-show=\"!explain\">{{ ::employeeM.id | getSomethingOfArrayFB: variableEmployees:\'data.name\':\'N/A\' }}</td><td md-cell \nng-show=\"!explain\">{{ ::employeeM.date | date }}</td><td md-cell ng-show=\"!explain\">{{ ::employeeM.sd | currency }}\n</td><td md-cell ng-show=\"!explain\">{{::employeeM.sbc | currency}}</td><td md-cell ng-show=\"!explain\">\n{{(employeeM.salaryType|toInt)|getSomethingOfArrayM:M.salaryTypes:\'name\':\' \':\'humansiteCode\'}}</td><td md-cell \ncolspan=\"6\" ng-show=\"explain\"><ul ng-show=\"employeeM.invalidReasons\"><li \nng-repeat=\"reason in employeeM.invalidReasons track by $index\">{{::reason}}</li></ul><span \nng-show=\"employeeM.invalidReasons\">{{::employeeM.id}} - Importado sin errores</span></td><td md-cell><md-button \nng-disabled=\"employeeM.valid && !employeeM.execute\" class=\"md-fab md-mini\" \nng-class=\'{\"md-primary\": employeeM.valid, \"md-warn\": !employeeM.valid, \"green-500-bg\":employeeM.execute}\' \nng-click=\"explain = !explain\"><md-icon ng-show=\"!employeeM.valid\" \nmd-font-icon=\'icon-{{(explain) ? \"eye-off\" : \"eye\"}}\' aria-label=\"invalid\"></md-icon><md-icon \nng-show=\"employeeM.valid\" md-font-icon=\"icon-check\" aria-label=\"valid\"></md-icon><md-tooltip ng-if=\"employeeM.execute\" \nmd-direction=\"left\">Se Aplico</md-tooltip></md-button></td></tr></tbody></table></md-table-container></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-show=\"variables.file\" class=\"md-warn md-raised\" \nng-click=\"removeUpload()\">Cancelar</md-button><span flex></span><md-button \nng-if=\'variables.file && (variables.movements | activeObjectsOfArray:\"valid\").length && !executeFail\' \nclass=\"md-accent md-raised\" ng-click=\"importVariables(variables.movements)\">\nImportar ({{(variables.movements | activeObjectsOfArray:\'valid\').length}}) movimientos<md-icon \nmd-font-icon=\"icon-import\" aria-label=\"upload\"></md-icon></md-button><md-button ng-if=\"executeFail\" \nclass=\"md-accent md-raised\" ng-click=\"importVariables(variables.movements)\">Reintentar<md-icon \nmd-font-icon=\"icon-import\" aria-label=\"upload\"></md-icon></md-button><md-button ng-if=\"!variables.file\" \nng-disabled=\"importVariablesForm.$invalid\" class=\"md-primary md-raised\" ng-click=\"upload(filesArray)\">Subir<md-icon \nmd-font-icon=\"icon-file-excel\" aria-label=\"upload\"></md-icon></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/employees/dialogs/interface-bank.html","<md-dialog aria-label=\"Interface Data\"><form name=\"interfaceForm\" novalidate ng-cloak><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Interface de alta de cuentas {{bank.name}}</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"column\" layout-gt-xs=\"row\"><custom-fields flex \nfields=\"fields\" main-object=\"interfaceData\" form=\"interfaceForm\"></custom-fields></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button class=\"md-accent md-raised md-primary\" ng-disabled=\"interfaceForm.$invalid\" \nng-click=\"answer(interfaceData)\">OK<md-icon md-font-icon=\"icon-send\" aria-label=\"send\"></md-icon></md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/employees/dialogs/interface-banorte-consecutive.html","<md-dialog><md-toolbar><div class=\"md-toolbar-tools\"><h2>Interface de alta de cuentas Banorte</h2><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close Dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><form name=\"consecutiveForm\" ng-submit=\"answer(consecutive)\" \nng-disabled=\"consecutiveForm.$invalid\" novalidate><div class=\"md-dialog-content\"><div layout-gt-xs=\"row\" flex>\n<md-input-container class=\"md-block\" flex><label>Confirmación de Lote</label><input type=\"text\" name=\"consecutive\" \nng-model=\"consecutive\" md-minlength=\"2\" md-maxlength=\"2\" maxlength=\"2\" pattern=\"^(0?[1-9]|[1-9][0-9])$\" required><div \nng-messages=\"consecutiveForm.consecutive.$error\" ng-show=\"consecutiveForm.consecutive.$dirty\" role=\"alert\"><div \nng-message=\"required\">Consecutivo es requerido</div><div ng-message=\"pattern\">Consecutivo debe ser 01-99</div></div>\n</md-input-container></div></div></form></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span>\n<md-button aria-label=\"answer consecutive\" ng-click=\"answer(consecutive)\" class=\"md-primary md-hue-2\" \nng-disabled=\"consecutiveForm.$invalid\">OK</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/employees/dialogs/movement.html","<md-dialog><md-toolbar><div class=\"md-toolbar-tools\"><h2>Movimiento <small>{{movement.type}}</small></h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close Dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\">\n<div ng-if=\"movement.data.type==6 || movement.data.type==8\" form-info></div><div ng-if=\"movement.data.type==2\" \nform-dismiss></div><div ng-if=\"movement.data.type==7\" form-mds></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/employees/dialogs/paymentForms.html","<md-dialog aria-label=\"Reentry Employees\" flex=\"30\" flex-xs=\"100\" flex-sm=\"50\" flex-md=\"40\" flex-lg=\"35\"><form \nname=\"form\" novalidate ng-cloak><md-toolbar><div class=\"md-toolbar-tools\"><h2>Actualizar formas de pago</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"pfCtrl.cancel()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><div \nflex=\"nogrow\" ng-repeat=\"paymentForm in pfCtrl.employeePaymentForms\" layout=\"row\" layout-align=\"start center\">\n<md-input-container class=\"md-block no-errors-spacer\" flex><label>Forma de pago</label><md-select \nng-model=\"paymentForm.type\" name=\"paymentFormType\" required><md-option ng-value=\"paymentForm._id\" \nng-repeat=\"paymentForm in pfCtrl.paymentForms | orderBy:\'name\' \">{{paymentForm.name}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block no-errors-spacer\" flex \nng-if=\"pfCtrl.employeePaymentForms.length>1\"><label>Proceso</label><md-select ng-model=\"paymentForm.process\" \nname=\"paymentFormProcess\" required><md-option ng-value=\"proc.id\" \nng-repeat=\"proc in pfCtrl.processes | orderBy:\'name\' \">{{proc.name}}</md-option></md-select></md-input-container><div \nflex=\"nogrow\" ng-if=\"pfCtrl.employeePaymentForms.length>1\"><md-button class=\"md-icon-button md-warn md-hue-2\" \naria-label=\"delete paymentForm\" ng-click=\"pfCtrl.employeePaymentForms.splice($index,1)\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon></md-button></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div flex=\"nogrow\"><md-button class=\"md-raised\" \nng-click=\"pfCtrl.employeePaymentForms.push({})\">Añadir forma de pago<md-icon md-font-icon=\"icon-cash-multiple\" \naria-label=\"add payment form\"></md-icon></md-button></div><div flex=\"nogrow\"><md-button \nclass=\"md-accent md-raised md-primary\" ng-disabled=\"form.$invalid\" ng-click=\"pfCtrl.save(pfCtrl.employeePaymentForms)\">\nActualizar<md-icon md-font-icon=\"icon-send\" aria-label=\"send\"></md-icon></md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/employees/dialogs/receive-movement.html","<md-dialog><md-toolbar><div class=\"md-toolbar-tools\"><h2>Recibir {{selected.length}} Movimiento(s)</h2><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close Dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><form name=\"movementForm\" ng-submit=\"answer(noLote)\" \nng-disabled=\"movementForm.$invalid\" novalidate><div class=\"md-dialog-content\"><div layout-gt-xs=\"row\" flex>\n<md-input-container class=\"md-block\" flex><label>Confirmación de Lote</label><input type=\"text\" name=\"noLote\" \nng-model=\"noLote\" md-minlength=\"9\" md-maxlength=\"9\" maxlength=\"9\" ng-readonly=\"!enable\" pattern=\"([0-9]{9})\" required>\n<div ng-messages=\"movementForm.noLote.$error\" ng-show=\"movementForm.noLote.$dirty\" role=\"alert\"><div \nng-message=\"required\">Número de Lote es requerido</div><div ng-message=\"pattern\">\nNúmero de Lote debe tener [9] números del (0-9)</div></div></md-input-container></div></div></form></md-dialog-content>\n<md-dialog-actions layout=\"row\"><span flex></span><md-button ng-click=\"answer(noLote)\" class=\"md-primary md-hue-2\" \nng-disabled=\"movementForm.$invalid\">OK</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/employees/dialogs/reentry-many-employees.html","<md-dialog aria-label=\"Reentry Employees\"><form name=\"reentryData\" novalidate ng-cloak><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Desea reingresar {{selected.length}} empleados(s)</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"close()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container \nclass=\"md-block evenPadding\" flex flex-gt-xs=\"50\"><label>Centro de Costo</label><md-select ng-model=\"data.cc\" \nname=\"cc\" required><md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" \nng-keydown=\"$event.stopPropagation()\" ng-model=\"ccSelectFilter\" placeholder=\"Busque un centro de costo\">\n</md-select-header><md-option ng-if=\"!F.permissionToAccessAllPayrolls&&cc.valid\" ng-value=\"cc.$id\" \nng-repeat=\"cc in L.payrollCcs[selected[0].payroll] | filterUserCcs:L.userCcs[F.profile.uid] | orderBy:\'name\' | filter:ccSelectFilter\">\n{{cc.name}} <small>[{{L.rpCcs[cc.rp_id].name}}]</small></md-option><md-option \nng-if=\"F.permissionToAccessAllPayrolls&&cc.valid\" ng-value=\"cc.$id\" \nng-repeat=\"cc in L.payrollCcs[selected[0].payroll] | orderBy:\'name\' | filter:ccSelectFilter\">{{cc.name}} <small>\n[{{L.rpCcs[cc.rp_id].name}}]</small></md-option></md-select><div ng-messages=\"form.cc.$error\" \nng-show=\"form.cc.$touched || form.cc.$dirty\" role=\"alert\"><div ng-message=\"required\">Centro de Costo es requerido</div>\n</div></md-input-container><md-input-container class=\"md-block date-picker\" flex flex-gt-xs=\"50\"><label>\nFecha de Reingreso</label><md-datepicker md-hide-icons=\"triangle\" md-current-view=\"{{F.dateView}}\" \nmd-min-date=\"minMovementDate\" md-max-date=\"maxMovementDate\" input-date-miliseconds ng-model=\"data.reentryDate\" \nname=\"date\" class=\"md-block\" required></md-datepicker></md-input-container></div><p>\nLos empleados seleccionados seran reingresados con la fecha seleccionada</p></md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button class=\"md-accent md-raised md-primary\" ng-disabled=\"reentryData.$invalid\" \nng-click=\"confirm(selected)\">Mandar {{selected.length}} empleados(s)<md-icon md-font-icon=\"icon-send\" \naria-label=\"send\"></md-icon></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/employees/dialogs/register-emit-account.html","<md-dialog aria-label=\"Register Emit Employees\"><form name=\"registerEmitEmployees\" novalidate ng-cloak><md-toolbar><div\n class=\"md-toolbar-tools\"><h2>Registrar/generar cuenta, clabe o tarjeta</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"close()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div ng-repeat=\"employee in selected|orderBy:\'-data.name\'\"><h3 \nclass=\"noMargin strongItem\">{{employee.data.name}} <small ng-if=\"employee.hasPendingRequest && !employee.invalidCurp\" \nclass=\"inactiveOption\">[Solicitud Pendiente]</small> <small ng-if=\"employee.hasPendingRequest && employee.invalidCurp\" \nclass=\"inactiveOption\" ng-bind=\"employee.invalidCurp\"></small></h3><h4 class=\"noMargin\" \nng-if=\"employee.data.cards.length>1\">\n{{employee.data.cards.length-1}} cuenta{{employee.data.cards.length-1>1?\"s\":\"\"}} registrada{{employee.data.cards.length-1>1?\"s\":\"\"}}/emitida{{employee.data.cards.length-1>1?\"s\":\"\"}} \n<small><md-button ng-if=\"!employee.showCards\" class=\"md-icon-button\" ng-click=\"employee.showCards=true\" \naria-label=\"show cardss\"><md-icon md-font-icon=\"icon-chevron-double-down\"></md-icon></md-button><md-button \nng-if=\"employee.showCards\" class=\"md-icon-button\" ng-click=\"employee.showCards=false\" arial-label=\"Hide Cards\"><md-icon\n md-font-icon=\"icon-chevron-double-up\"></md-icon></md-button></small></h4><div ng-show=\"employee.showCards\"><p \nclass=\"md-caption noMarginTop\" ng-if=\"$index!==0\" ng-repeat=\"($index,card) in employee.data.cards\">\n{{card.bank|nameOfM:M.banks}} - {{card.number}}</p></div><md-radio-group ng-model=\"employee.data.cards[0].emit\" \nng-change=\"employee.data.cards[0].bank = null; employee.data.cards[0].process = null;  validateForeignCurp(employee, employee.data.cards[0].emit); checkBanks(employee.data.cards[0].emit, employee.payroll);\" \nng-disabled=\"employee.hasPendingRequest && !employee.invalidCurp\"><div layout-gt-xs=\"row\"><div flex=\"nogrow\">\n<md-radio-button class=\"noMargin paddingRight\" ng-value=\"true\">Generar</md-radio-button></div><div flex=\"nogrow\">\n<md-radio-button class=\"noMargin\" ng-value=\"false\">Registrar</md-radio-button></div></div></md-radio-group><div \nlayout-gt-xs=\"row\"><md-input-container class=\"md-block noMargin\" flex-gt-xs flex=\"nogrow\" md-no-float><md-select \nng-model=\"employee.data.cards[0].process\" placeholder=\"Proceso\" ng-disabled=\"employee.hasPendingRequest\"><md-option \nng-repeat=\"proc in banks[employee.payroll].processes\" ng-value=\"proc.id\">{{proc.name}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block noMargin\" flex-gt-xs flex=\"nogrow\" md-no-float><md-select \nng-model=\"employee.data.cards[0].bank\" required ng-change=\"AskInGeneration(employee.data.cards[0].bank)\" \nng-disabled=\"employee.hasPendingRequest\" placeholder=\"Banco\" name=\"cardBank-{{employee.$id}}\"><md-select-header><input \nautocomplete=\"off\" type=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"bankSelectFilter\" \nplaceholder=\"Busque un banco\"></md-select-header><md-option \nng-repeat=\"bank in (employee.data.cards[0].emit?banks[employee.payroll][employee.data.cards[0].process]:M.banks) |filter: (employee.data.cards[0].emit?{couldEmmit: true}:{allowRegister: true}) | orderBy:\'name\' | filter:bankSelectFilter\" \nng-value=\"bank._id\">{{bank.name}}</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block noMargin\" ng-if=\'(employee.data.cards[0].bank | getSomethingOfArrayM: M.banks: \"requestNumber\")==true\' \nflex-gt-xs flex=\"nogrow\" md-no-float><input ng-disabled=\"employee.hasPendingRequest\" tds-account-input \nbank=\"employee.data.cards[0].bank\" emit=\"employee.data.cards[0].emit\" unique-fb ref=\"{{F.active.menuRef}}\" \nquery=\"data/cards/0/number\" fromid=\'{{employee.hasPendingRequest?\"\":employee.fid}}\' type=\"text\" \nplaceholder=\"{{(!employee.data.cards[0].emit) ? \'Cuenta o clabe\' : \'Tarjeta\'}}\" \nng-model=\"employee.data.cards[0].number\" name=\"cardAccount-{{employee.fid}}\" \nmd-minlength=\"employee.data.cards[0].emit?16:10\" minlength=\"{{employee.data.cards[0].emit?16:10}}\" \nmd-maxlength=\"employee.data.cards[0].emit?16:18\" maxlength=\"{{employee.data.cards[0].emit?16:18}}\" \nng-model-options=\"{ debounce: F.debounceTime }\" required><div \nng-messages=\'registerEmitEmployees[\"cardAccount-\"+employee.fid].$error\' role=\"alert\"><div ng-message=\"required\">\n{{employee.data.cards[0].emit?\'Tarjeta\':\'Cuenta o Clabe\'}} es requerida</div><div ng-message=\"validPattern\">\nsolo se admiten dígitos (0-9)</div><div ng-message=\"validCard\">Tarjeta requiere tener 16 dígitos (0-9)</div><div \nng-message=\"validAccount\">La cuenta debe ser de 10 o 18 dígitos (0-9)</div><div ng-message=\"minlength\">\nCuenta debe tener al menos {{employee.data.cards[0].emit?16:10}} dígitos (0-9)</div><div ng-message=\"maxlength\">\nCuenta debe tener un máximo de {{employee.data.cards[0].emit?16:18}} dígitos (0-9)</div><div ng-message=\"validBank\">\nTarjeta no pertenece a {{employee.data.cards[0].bank|nameOfM:M.banks}}</div><div ng-message=\"unique\">\nCuenta o Tarjeta ya está registrada</div></div></md-input-container><md-input-container \nng-if=\"!employee.data.cards[0].emit\" class=\"md-block noMargin\" flex-gt-xs flex=\"nogrow\" md-no-float><md-select \nng-model=\"employee.data.cards[0].bankToReg\" required ng-disabled=\"employee.hasPendingRequest\" \nplaceholder=\"Banco de registro\" name=\"cardBankToReg{{employee.$id}}\"><md-select-header><input autocomplete=\"off\" \ntype=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"bankSelectToRegFilter\" \nplaceholder=\"Busque un banco\"></md-select-header><md-option \nng-repeat=\"bank in banks[employee.payroll][employee.data.cards[0].process] | orderBy:\'name\' | filter:bankSelectToRegFilter\" \nng-value=\"bank._id\">{{bank.name}}</md-option></md-select></md-input-container><md-input-container \nng-if=\"AskInGenerations\" class=\"md-block noMargin\" ng-repeat=\"(index, item) in AskInGenerations\" flex-gt-xs \nflex=\"nogrow\" md-no-float><input ng-model=\"employee.data.cards[0].extras[item.id]\" \nng-model-options=\"{ debounce: F.debounceTime }\" type=\"{{item.type}}\" placeholder=\"{{item.name}}\" required>\n</md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nclass=\"md-accent md-raised md-primary\" \nng-disabled=\"registerEmitEmployees.$pending || registerEmitEmployees.$invalid || (selected.length-(selected|filter:{hasPendingRequest:true}).length) < 1\" \nng-click=\"confirm(selected)\">Enviar {{selected.length-(selected|filter:{hasPendingRequest:true}).length}} empleados(s)\n<md-icon md-font-icon=\"icon-send\" aria-label=\"send\"></md-icon></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/employees/dialogs/step-1.html","<div><div flex><md-input-container class=\"md-block evenPadding\" flex><label>Nómina</label><md-select \nng-model=\"employeeDialog.payroll\" name=\"payroll\" required><md-select-header><input autocomplete=\"off\" type=\"search\" \nclass=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"payrollSelectFilter\" placeholder=\"Busque una nómina\">\n</md-select-header><md-option ng-value=\"payroll.$id\" ng-if=\"payroll.active\" \nng-repeat=\"payroll in employeeDialog.payrolls | orderBy:\'class\' | filter:payrollSelectFilter\">\n{{payroll.class}} {{payroll.name}}</md-option></md-select><div ng-messages=\"step1.payroll.$error\" role=\"alert\"><div \nng-message=\"required\">Nómina es requerido</div></div></md-input-container><div layout=\"row\" \nlayout-align=\"center start\"><div flex><lf-ng-md-file-input lf-files=\"employeeDialog.filesArray\" \nlf-placeholder=\"Selecciona el archivo csv\" lf-drag-and-drop-label=\"csv - Max: 10MB\" \nlf-browse-label=\"{{\'EC.search\' | translate}}\" lf-remove-label=\"{{\'EC.remove\' | translate}}\" lf-filesize=\"10MB\" \nlf-required lf-mimetype=\"text/csv\" accept=\"text/csv\" name=\"variablesFile\" lf-api=\"csvApi\"></lf-ng-md-file-input><div \nng-messages=\"step1.variablesFile.$error\" style=\"color:red\"><div ng-message=\"required\">Archivo requerido</div><div \nng-message=\"maxcount\">Demasiados archivos</div><div ng-message=\"filesize\">Archivo demasiado grande</div><div \nng-message=\"totalsize\">Espacio total demasiado grande</div><div ng-message=\"mimetype\">Formato de archivo no valido\n</div></div></div></div></div></div>");
$templateCache.put("app/main/employees/dialogs/step-2.html","<div><div ng-if=\"loading\"><md-progress-linear md-mode=\"indeterminate\"></md-progress-linear><span class=\"md-subhead\">\nCargando..</span></div><div style=\"max-height: 550px;overflow: auto\"><table class=\"simple\"><thead class=\"stickyHeader\">\n<tr><th><h3>Campo</h3></th><th><h3>Campo Destino</h3></th><th><h3>Ejemplo</h3></th><th><h3>Buscar por</h3></th><th><h3>\nNo importar</h3></th></tr></thead><tbody><tr ng-repeat=\"($index,header) in employeeDialog.headers\"><td \nng-bind=\"header.name\"></td><td><md-input-container class=\"md-block\" md-no-float><md-select ng-model=\"header.target\" \nng-change=\"employeeDialog.setValueFormatted(header)\" ng-required=\"!header.noImport\" ng-disabled=\"header.noImport\" \naria-label=\"target\" name=\"type{{$index}}\"><md-option ng-value=\"thisField\" \nng-repeat=\"thisField in employeeDialog.posibleFields track by thisField.$id\" ng-bind=\"thisField.name\"></md-option>\n</md-select><div ng-messages=\'form[\"type\"+$index].$error\' role=\"alert\"><div ng-message=\"required\">Campo es requerido\n</div></div></md-input-container></td><td ng-bind=\"header.sample\"></td><td><md-checkbox ng-model=\"header.byThis\" \nclass=\"mb-0\" aria-label=\"byThis\" aria-label=\"By this\" ng-disabled=\"header.noImport\"></md-checkbox></td><td><md-checkbox\n ng-model=\"header.noImport\" class=\"mb-0\" aria-label=\"noImport\" aria-label=\"No import\"></md-checkbox></td></tr></tbody>\n</table></div></div>");
$templateCache.put("app/main/employees/dialogs/step-3.html","<div><div ng-if=\"loading\"><md-progress-linear md-mode=\"indeterminate\"></md-progress-linear><span class=\"md-subhead\">\nCargando..</span></div><div style=\"max-height: 500px;overflow: auto\"><table class=\"simple\"><thead class=\"stickyHeader\">\n<tr><th style=\"text-align: left\"><div layout=\"row\"><div flex=\"nogrow\"><md-button class=\"md-fab md-mini md-primary\" \naria-label=\"search button\" disabled=\"true\" type=\"submit\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button>\n</div><input flex type=\"text\" placeholder=\"Buscar Empleado\" ng-model-options=\"{ debounce: F.debounceTime }\" \nng-model=\"importSearch\"></div></th><th ng-if=\"!header.noImport\" ng-repeat=\"($index,header) in employeeDialog.headers\">\n{{header.name}}<br><small>{{header.path}}</small></th></tr></thead><tbody><tr \nng-repeat=\"row in employeeDialog.data  | filter : importSearch | orderBy : \'valid\'\"><td style=\"text-align: left\">\n<md-button ng-if=\"!row.valid\" aria-label=\"Upload File\" class=\"md-icon-button md-warn md-hue-2 no-margin\"><md-icon \nmd-font-icon=\"icon-sim-alert\" aria-label=\"Upload\"></md-icon><md-tooltip md-direction=\"right\"><label>{{row.error}}\n</label></md-tooltip></md-button><md-button ng-if=\"row.valid && !record.applied\" aria-label=\"Upload File\" \nclass=\"md-icon-button md-primary no-margin\"><md-icon md-font-icon=\"icon-checkbox-marked\" aria-label=\"Upload\"></md-icon>\n<md-tooltip md-direction=\"right\">Sin problemas</md-tooltip></md-button>{{row.objToUpdate.data.name||\'No encontrado\'}}\n</td><td ng-if=\"!header.noImport\" ng-repeat=\"($index,header) in employeeDialog.headers\">\n{{row[header.name+\'_formatted\']||\'S/V\'}}</td></tr></tbody></table></div></div>");
$templateCache.put("app/main/employees/forms/aniversary.html","<div flex><div layout-gt-xs=\"row\" flex><md-input-container class=\"md-block evenPadding\" flex><label>Nómina</label>\n<md-select ng-model=\"aniversaryRecord.payroll\" name=\"payroll\" disabled=\"disabled\"><md-select-header><input \nautocomplete=\"off\" type=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"payrollSelectFilter\" \nplaceholder=\"Busque una nómina\"></md-select-header><md-option ng-if=\"!F.permissionToAccessAllPayrolls\" \nng-value=\"payroll.$id\" ng-repeat=\"payroll in L.payrolls | orderBy:\'name\' | filter:payrollSelectFilter\">{{payroll.name}}\n</md-option><md-option ng-if=\"F.permissionToAccessAllPayrolls\" ng-value=\"payroll.$id\" \nng-repeat=\"payroll in L.allPayrolls | orderBy:\'name\' | filter:payrollSelectFilter\">{{payroll.name}}</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block\" flex><label>Nombre</label><input type=\"text\" \nng-model=\"aniversaryRecord.name\" disabled=\"disabled\"></md-input-container><md-input-container \nclass=\"md-block date-picker\" flex><label>Fecha de Alta en IMSS</label><md-datepicker md-hide-icons=\"triangle\" \nng-model=\"aniversaryRecord.enroleDate\" input-date-miliseconds class=\"md-block\" disabled=\"disabled\"></md-datepicker>\n</md-input-container></div><div layout-gt-xs=\"row\" flex><md-input-container class=\"md-block date-picker\" flex><label>\nFecha de MDS</label><md-datepicker md-hide-icons=\"triangle\" md-current-view=\"{{F.dateView}}\" \nmd-min-date=\"minMovementDate\" md-max-date=\"maxMdsDate\" input-date-miliseconds required ng-model=\"movement.data.date\" \nng-disabled=\"F.readMode\" name=\"date\" class=\"md-block\"></md-datepicker><div ng-messages=\"form.date.$error\" \nng-show=\"form.date.$touched || form.date.$dirty\" role=\"alert\"><div ng-message=\"required\">Fecha de MDS es requerido\n</div><div ng-message=\"min\">Fecha de MDS debe ser a partir de {{minMovementDate | date}}</div><div \nng-message=\"mindate\">Fecha de MDS debe ser a partir de {{minMovementDate | date}}</div><div ng-message=\"max\">\nFecha de MDS debe ser antes de {{maxMdsDate | date}}</div><div ng-message=\"maxdate\">\nFecha de MDS debe ser antes de {{maxMdsDate | date}}</div></div></md-input-container><md-input-container \nclass=\"md-block\" flex><label>SD - SMAG [{{minimumWage}}]{{lastSd ? (\', último SD: \') + lastSd : \'\'}}</label><input \ntype=\"number\" step=\"any\" ng-min=\"minimumSd\" name=\"sd\" ng-model=\"movement.data.sd\" \nng-model-options=\"{ debounce: F.debounceTime }\" ng-disabled=\"F.readMode\" required><div ng-messages=\"form.sd.$error\" \nng-show=\"form.sd.$touched || form.sd.$dirty\" role=\"alert\"><div ng-message=\"required\">Sueldo Diario es requerido</div>\n<div ng-message=\"min\">Sueldo no puede ser menor al salario mínimo: {{minimumWage}}</div></div></md-input-container>\n<md-input-container class=\"md-block\" flex ng-if=\"!F.readMode\"><label>\nSBC - SDI [{{minimumSbc}}]{{lastSbc ? (\', último SBC: \') + lastSbc : \'\'}}</label><input sbc-consistency \nemployee=\"employee\" movement=\"movement\" benefit=\"benefit\" last-movement=\"lastApprovedMovement\" sd=\"movement.data.sd\" \nis-movement=\"true\" ng-min=\"minimumSbc\" type=\"number\" step=\"any\" ng-change=\"validateSbc()\" name=\"sbc\" \nis-movement=\"true\" round-number=\"2\" ng-model=\"movement.data.sbc\" required \nng-model-options=\"{ debounce: F.debounceTime }\"><div ng-messages=\"form.sbc.$error\" \nng-show=\"form.sbc.$touched || form.sbc.$dirty\" role=\"alert\"><div ng-message=\"required\">\nSueldo Base Cotización es requerido</div><div ng-message=\"min\">Sueldo Base Cotización debe ser al menos {{minimumWage}}\n</div></div></md-input-container><md-input-container class=\"md-block\" flex ng-if=\"F.readMode\"><label>\nSBC [{{minimumWage}}] MIW o mayor que sbc actual: {{minimumSbc}}</label><input employee=\"employee\" type=\"number\" \nstep=\"any\" name=\"sbc\" ng-model=\"movement.data.sbc\" disabled=\"disabled\" readonly=\"readonly\"></md-input-container></div>\n<md-input-container class=\"md-block\" flex><label>Comentarios</label><textarea class=\"uppercased\" name=\"comments\" \nng-model=\"movement.data.comments\" md-maxlength=\"350\" maxlength=\"350\" ng-disabled=\"F.readMode\" \nng-model-options=\"{ debounce: F.debounceTime }\"></textarea><div ng-messages=\"form.comments.$error\" \nng-show=\"form.comments.$touched || form.comments.$dirty\" role=\"alert\"><div ng-message=\"maxlength\">\nComentarios no debe tener más de 350 caracteres</div></div></md-input-container></div>");
$templateCache.put("app/main/employees/forms/benefits-employee.html","<div id=\"benefit\"><md-input-container class=\"md-block\" flex \nng-if=\"fiscalMovement && employee.data.nss!==\'00000000000\'\"><label>Vacaciones Disfrutadas</label><input type=\"number\" \nstep=\"1\" name=\"enjoyedVacations\" min=\"0\" ng-model=\"employee.data.enjoyedVacations\"><div \nng-messages=\"form.enjoyedVacations.$error\" ng-show=\"form.enjoyedVacations.$touched || form.enjoyedVacations.$dirty\" \nrole=\"alert\"><div ng-message=\"min\">Debe insertar un valor mayor a 0</div></div></md-input-container><div layout=\"row\" \nlayout-xs=\"column\"><div flex=\"{{payroll.hasRealSeniorityDate?\'50\':\'100\'}}\" flex-xs=\"nogrow\"><p class=\"noMarginTop\">\nAntigüedad</p><md-radio-group ng-model=\"employee.hasSeniorityDate\" layout-gt-xs=\"row\" \nng-required=\'F.active.menuAction !== \"especialEdit\"\' ng-disabled=\"F.readMode\"><md-radio-button ng-value=\"false\" \naria-label=\"dontHasSeniorityDate\">Sin Antigüedad</md-radio-button><md-radio-button ng-value=\"true\" \naria-label=\"hasSeniorityDate\">Respetar Antigüedad</md-radio-button></md-radio-group><div \nng-if=\"employee.hasSeniorityDate\"><md-input-container class=\"date-picker noMarginBottom md-block\" md-no-float>\n<md-datepicker ng-disabled=\"F.readMode\" md-hide-icons=\"triangle\" md-current-view=\"{{F.dateView}}\" \ninput-date-miliseconds md-max-date=\"enroleDateJS\" ng-model=\"employee.data.seniorityDate\" name=\"seniorityDate\" \nmd-placeholder=\"Antigüedad\" required></md-datepicker><div ng-messages=\"form.seniorityDate.$error\" \nng-show=\"form.seniorityDate.$touched || form.seniorityDate.$dirty\" role=\"alert\"><div ng-message=\"required\">\nFecha de Antigüedad es requerido</div><div ng-message=\"min\">\nFecha de Antigüedad debe ser a partir de {{enroleDateJS | date}}</div><div ng-message=\"maxdate\">\nFecha de Antigüedad debe ser antes de {{enroleDateJS | date}}</div></div></md-input-container></div></div><div \nng-if=\"payroll.hasRealSeniorityDate\" flex=\"50\" flex-xs=\"nogrow\"><p class=\"noMarginTop\">Antigüedad Real</p>\n<md-radio-group ng-model=\"employee.hasRealSeniorityDate\" layout-gt-xs=\"row\" \nng-change=\"employee.hasRealSeniorityDate ? false : employee.data.realSeniorityDate=null\" \nng-required=\'F.active.menuAction !== \"especialEdit\"\' ng-disabled=\"F.readMode\"><md-radio-button ng-value=\"false\" \naria-label=\"dontHasRealSeniorityDate\">Sin Antigüedad Real</md-radio-button><md-radio-button ng-value=\"true\" \naria-label=\"hasRealSeniorityDate\">Respetar Antigüedad</md-radio-button></md-radio-group><div \nng-if=\"employee.hasRealSeniorityDate\"><md-input-container class=\"date-picker noMarginBottom md-block\" md-no-float>\n<md-datepicker ng-disabled=\"F.readMode\" md-hide-icons=\"triangle\" md-current-view=\"{{F.dateView}}\" \ninput-date-miliseconds md-max-date=\"enroleDateJS\" ng-model=\"employee.data.realSeniorityDate\" name=\"realSeniorityDate\" \nmd-placeholder=\"Antigüedad Real\" required></md-datepicker><div ng-messages=\"form.realSeniorityDate.$error\" \nng-show=\"form.realSeniorityDate.$touched || form.realSeniorityDate.$dirty\" role=\"alert\"><div ng-message=\"required\">\nFecha de Antigüedad es requerido</div><div ng-message=\"min\">\nFecha de Antigüedad debe ser a partir de {{enroleDateJS | date}}</div><div ng-message=\"maxdate\">\nFecha de Antigüedad debe ser antes de {{enroleDateJS | date}}</div></div></md-input-container></div></div></div><p \nng-if=\"fiscalMovement && employee.data.nss!==\'00000000000\'\">Configuración de prestaciones:</p><md-radio-group \nng-model=\"employee.customBenefits\" layout-gt-xs=\"row\" required \nng-if=\"fiscalMovement && employee.data.nss!==\'00000000000\'\" ng-disabled=\"F.readMode\"><md-radio-button ng-value=\"false\" \naria-label=\"dontHasCustomBenefits\" ng-if=\"benefit.type!=\'employee\'\"><label ng-if=\"benefit.itemId==\'default\'\">\nPrestaciones mínimas de ley</label><label ng-if=\"benefit.itemId!=\'default\'\">\nPrestaciones superiores a la ley configuradas en {{benefit.type + \'.SINGULAR\' | translate}}</label></md-radio-button>\n<md-radio-button ng-value=\"true\" aria-label=\"hasCustomBenefits\">Configurar prestaciones superiores a la ley\n</md-radio-button></md-radio-group><form-benefit ng-if=\"fiscalMovement && employee.data.nss!==\'00000000000\'\">\n</form-benefit></div>");
$templateCache.put("app/main/employees/forms/config.html","<md-list><md-list-item><md-icon md-font-icon=\"icon-clipboard-check\"></md-icon><p>Activo</p><md-switch \nclass=\"md-secondary\" name=\"active\" ng-model=\"employee.active\" ng-false-value=\"0\"></md-switch></md-list-item></md-list>");
$templateCache.put("app/main/employees/forms/credit.html","<div><div layout-gt-xs=\"row\" flex><md-autocomplete class=\"md-block\" flex md-min-length=\"2\" \nmd-selected-item=\"employeeSelected\" md-search-text=\"searchQuery\" md-selected-item-change=\"credit.employee=item.$id\" \nmd-item-text=\"item.data.name\" md-delay=\"500\" \nmd-items=\'item in autocompleteListM(searchQuery, \"employees\",[\"data.name\",\"data.nss\"],{\"data.nss\":{$exists:true}})\' \nmd-require-match=\"true\" md-select-on-match=\"true\" md-match-case-insensitive=\"true\" placeholder=\"Empleado\" \nmd-no-cache=\"true\" md-floating-label=\"Empleado\" required><md-item-template><span md-highlight-text=\"searchQuery\" \nng-class=\"{\'inactiveOption\': (item.status==5)}\">{{item.data.nss?item.data.nss+\' - \':\'\'}}{{item.data.name}}</span>\n</md-item-template><md-not-found>No hay registros</md-not-found></md-autocomplete><md-input-container class=\"md-block\" \nflex><label>Nómina</label><input type=\"text\" name=\"payroll\" ng-model=\"payroll.data.name\" disabled=\"true\" required><div \nng-messages=\"form.payroll.$error\" ng-show=\"form.payroll.$touched || form.payroll.$dirty\" role=\"alert\"><div \nng-message=\"required\">Nomina es requerido</div></div></md-input-container></div><div layout-gt-xs=\"row\" flex>\n<md-input-container class=\"md-block evenPadding\" flex><label>Tipo de Crédito</label><md-select \nng-model=\"credit.data.type\" name=\"type\" required ng-disabled=\"F.readMode\"><md-select-header><input autocomplete=\"off\" \ntype=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"typeSelectFilter\" \nplaceholder=\"Busque una tipo de crédito\"></md-select-header><md-option ng-value=\"type\" \nng-repeat=\"type in F.creditTypes | filter:typeSelectFilter\">{{type | uppercase}}</md-option></md-select><div \nng-messages=\"form.type.$error\" ng-show=\"form.type.$touched || form.type.$dirty\" role=\"alert\"><div \nng-message=\"required\">Tipo de Crédito es requerido</div></div></md-input-container><md-input-container \nclass=\"md-block date-picker\" flex><label>Fecha de Inicio</label><md-datepicker md-hide-icons=\"triangle\" \nmd-current-view=\"{{F.dateView}}\" input-date-miliseconds ng-model=\"credit.data.date\" required name=\"date\" \nmd-min-date=\"minDate\" class=\"md-block\"></md-datepicker><div ng-messages=\"form.date.$error\" \nng-show=\"form.date.$touched || form.date.$dirty\" role=\"alert\"><div ng-message=\"required\">Fecha de Inicio es requerido\n</div></div></md-input-container></div><div layout-gt-xs=\"row\" flex><md-input-container class=\"md-block\" flex><label>\nFactor de Crédito</label><input type=\"number\" step=\"any\" name=\"factor\" ng-model-options=\"{ debounce: F.debounceTime }\" \nng-model=\"credit.data.factor\" ng-change=\"checkFactor(credit)\" required><div ng-messages=\"form.factor.$error\" \nng-show=\"form.factor.$touched || form.factor.$dirty\" role=\"alert\"><div ng-message=\"required\">\nFactor de Crédito es requerido</div></div></md-input-container><md-input-container class=\"md-block\" flex><label>\nNo. de Crédito</label><input type=\"text\" name=\"account\" ng-model=\"credit.data.account\" md-maxlength=\"10\" \nmaxlength=\"10\" pattern=\"([0-9]{10})\" required><div ng-messages=\"form.account.$error\" \nng-show=\"form.account.$touched || form.account.$dirty\" role=\"alert\"><div ng-message=\"required\">\nNo. de Credito es requerido</div><div ng-message=\"pattern\">No. de Credito no debe tener más de 10 números</div></div>\n</md-input-container></div><div layout-gt-xs=\"row\" flex><md-input-container class=\"md-block\" flex><label>Comentarios\n</label><textarea class=\"uppercased\" rows=\"2\" name=\"comments\" ng-disabled=\"F.readMode\" ng-model=\"credit.data.comments\" \nmd-maxlength=\"150\" maxlength=\"150\" ng-model-options=\"{ debounce: F.debounceTime }\"></textarea><div \nng-messages=\"form.comments.$error\" ng-show=\"form.comments.$touched || form.comments.$dirty\" role=\"alert\"><div \nng-message=\"maxlength\">Comentarios no debe tener más de 150 caracteres</div></div></md-input-container>\n<md-input-container ng-if=\"!F.addMode\" flex=\"nogrow\" class=\"md-input-has-placeholder md-block\"><label>Vigente</label>\n<md-switch class=\"md-secondary md-padding\" name=\"valid\" ng-false-value=\"0\" ng-disabled=\"F.readMode\" \narial-label=\"valid switch\" ng-model=\"credit.valid\"></md-switch></md-input-container></div></div>");
$templateCache.put("app/main/employees/forms/date-movement.html","<div layout-gt-xs=\"row\" flex><md-input-container class=\"md-block date-picker\" flex><label>Última Fecha de Alta</label>\n<md-datepicker md-hide-icons=\"triangle\" md-current-view=\"{{F.dateView}}\" input-date-miliseconds \nng-model=\"employee.data.enroleDate\" name=\"enroleDate\" class=\"md-block\" required></md-datepicker><div \nng-messages=\"form.enroleDate.$error\" ng-show=\"form.enroleDate.$touched || form.enroleDate.$dirty\" role=\"alert\"><div \nng-message=\"required\">Fecha de Alta es requerido</div></div></md-input-container><md-input-container \nclass=\"md-block date-picker\" flex><label>Última Fecha de MDS</label><md-datepicker md-hide-icons=\"triangle\" \nmd-current-view=\"{{F.dateView}}\" input-date-miliseconds ng-model=\"employee.data.mdsDate\" name=\"mdsDate\" \nclass=\"md-block\"></md-datepicker></md-input-container><md-input-container class=\"md-block date-picker\" flex><label>\nÚltima Fecha de Baja</label><md-datepicker md-hide-icons=\"triangle\" md-current-view=\"{{F.dateView}}\" \ninput-date-miliseconds ng-model=\"employee.data.dismissDate\" name=\"dismissDate\" class=\"md-block\"></md-datepicker>\n</md-input-container></div>");
$templateCache.put("app/main/employees/forms/dismiss.html","<div><div layout-gt-xs=\"row\" flex ng-if=\'F.active.menuAction!=\"especialEdit\" && F.active.menuName!==\"movements\"\'>\n<md-input-container class=\"md-block evenPadding\" ng-if=\"F.active.menuName !== \'operations\'\" flex><label>Nomina</label>\n<md-select ng-model=\"employee.payroll\" name=\"payroll\" disabled=\"disabled\"><md-select-header><input autocomplete=\"off\" \ntype=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"payrollSelectFilter\" \nplaceholder=\"Busque una nomina\"></md-select-header><md-option ng-if=\"!F.permissionToAccessAllPayrolls\" \nng-value=\"payroll.$id\" ng-repeat=\"payroll in L.payrolls | orderBy:\'name\' | filter:payrollSelectFilter\">{{payroll.name}}\n</md-option><md-option ng-if=\"F.permissionToAccessAllPayrolls\" ng-value=\"payroll.$id\" \nng-repeat=\"payroll in L.allPayrolls | orderBy:\'name\' | filter:payrollSelectFilter\">{{payroll.name}}</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block\" ng-if=\"F.active.menuName !== \'operations\'\" flex>\n<label>Nombre</label><input type=\"text\" ng-model=\"employee.data.name\" disabled=\"disabled\"></md-input-container>\n<md-autocomplete class=\"md-block\" ng-if=\"F.active.menuName === \'operations\'\" flex=\"noshrink\" md-min-length=\"2\" \nmd-selected-item=\"employeeSelected\" md-search-text=\"searchQuery\" \nmd-selected-item-change=\"employee.employeeId=item.$id\" md-item-text=\"item.data.name\" md-delay=\"500\" \nmd-items=\"item in listsEmployees(searchQuery,L.userCcs[F.profile.uid])\" md-require-match=\"true\" placeholder=\"Empleado\" \nmd-no-cache=\"true\" md-input-name=\"employee\" ng-required=\"!addMode.read\" md-floating-label=\"Empleado\" \nng-disabled=\"disabledEmployee\"><md-item-template><span md-highlight-text=\"searchQuery\" style=\"display: block\" \nng-click=\"loadMovements(item)\" ng-class=\"{\'inactiveOption\': (item.status==5)}\">{{item.data.name}}</span>\n</md-item-template><md-not-found>No hay registros</md-not-found><div ng-messages=\"form.employee.$error\"><div \nng-message=\"required\">El empleado es requerido</div></div></md-autocomplete><md-input-container \nclass=\"md-block movements\" ng-if=\"F.active.menuName === \'operations\'\" flex=\"nogrow\"><label>Movimientos</label>\n<md-select ng-model=\"employee.movementTypes\" name=\"movementTypes\" \nng-change=\"loadPayroll(employee.movementTypes, dismissMovement)\" ng-disabled=\"disabledEmployee\" required><md-option \nng-value=\"movement.$id\" \nng-repeat=\"movement in dismissMovement.movementTypes | orderBy:\'d\' | filter:movementSelectFilter track by movement.$id\">\n{{movement.d | date}} {{(movement.d)?\'- [\' +movement.name+ \']\' : movement.name}}</md-option></md-select><div \nclass=\"md-errors-spacer\"></div><div ng-messages=\"form.movementTypes.$error\" role=\"alert\"><div ng-message=\"required\">\nEl movimiento es requerido</div></div></md-input-container><md-input-container class=\"md-block date-picker\" \nng-if=\"F.active.menuName !== \'operations\'\" flex><label>Fecha de Alta en IMSS</label><md-datepicker \nmd-hide-icons=\"triangle\" ng-model=\"employee.data.enroleDate\" input-date-miliseconds class=\"md-block\" \ndisabled=\"disabled\"></md-datepicker></md-input-container></div><div layout-gt-xs=\"row\" \nng-if=\"F.active.menuName === \'operations\'\"><md-input-container class=\"md-block payroll\" flex><label>Nómina</label>\n<input type=\"text\" name=\"payroll\" ng-model=\"employee.payroll\" required disabled=\"disabled\"><div \nng-messages=\"form.payroll.$error\" role=\"alert\"><div ng-message=\"required\">La condición requerido</div></div>\n</md-input-container><md-input-container class=\"md-block date-picker\" flex><label>Fecha de Alta en IMSS</label>\n<md-datepicker md-hide-icons=\"triangle\" ng-model=\"employee.data.enroleDate\" required input-date-miliseconds \nclass=\"md-block\" disabled=\"disabled\"></md-datepicker></md-input-container></div><div layout-gt-xs=\"row\" flex>\n<md-input-container class=\"md-block evenPadding\" flex><label>Tipo de Baja</label><md-select name=\"dismissType\" \nng-model=\"movement.data.dismissType\" required ng-disabled=\"F.readMode\"><md-select-header><input autocomplete=\"off\" \ntype=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"dismissTypeSelectFilter\" \nplaceholder=\"Busque un tipo de baja\"></md-select-header><md-option ng-value=\"dismissType._id\" \nng-repeat=\'dismissType in M.dismissTypes | orderBy:\"name\" | filter:dismissTypeSelectFilter\'>{{dismissType.name}}\n</md-option></md-select><div class=\"md-errors-spacer\"></div><div ng-messages=\"form.dismissType.$error\" \nng-show=\"form.dismissType.$touched || form.dismissType.$dirty\" role=\"alert\"><div ng-message=\"required\">\nTipo de Baja es requerido</div></div></md-input-container><md-input-container class=\"md-block date-picker\" flex \nng-if=\'F.active.menuAction == \"createHistoricMovement\"\'><label>Fecha de Baja</label><md-datepicker \nmd-hide-icons=\"triangle\" md-current-view=\"{{F.dateView}}\" input-date-miliseconds required md-max-date=\"maxDate\" \nng-model=\"movement.data.date\" name=\"date\" ng-disabled=\"F.readMode\" class=\"md-block\"></md-datepicker><div \nng-messages=\"form.date.$error\" ng-show=\"form.date.$touched || form.date.$dirty\" role=\"alert\"><div \nng-message=\"required\">Fecha de Baja es requerido</div><div ng-message=\"maxdate\">\nFecha de Baja debe ser antes de {{maxDate | date}}</div></div></md-input-container><md-input-container \nclass=\"md-block date-picker\" flex \nng-if=\'F.active.menuAction !== \"especialEdit\" && F.active.menuAction !== \"createHistoricMovement\"\'><label>Fecha de Baja\n</label><md-datepicker md-hide-icons=\"triangle\" md-current-view=\"{{F.dateView}}\" md-min-date=\"minMovementDate\" \nmd-max-date=\"maxDismissDate\" input-date-miliseconds required ng-disabled=\"F.readMode\" ng-model=\"movement.data.date\" \nname=\"date\" class=\"md-block\"></md-datepicker><div ng-messages=\"form.date.$error\" \nng-show=\"form.date.$touched || form.date.$dirty\" role=\"alert\"><div ng-message=\"required\">Fecha de Baja es requerido\n</div><div ng-message=\"min\">Fecha de Baja debe ser a partir de {{minMovementDate | date}}</div><div ng-message=\"max\">\nFecha de Baja debe ser antes de {{maxDismissDate | date}}</div><div ng-message=\"mindate\">\nFecha de Baja debe ser a partir de {{minMovementDate | date}}</div><div ng-message=\"maxdate\">\nFecha de Baja debe ser antes de {{maxDismissDate | date}}</div></div></md-input-container></div><div \nlayout-gt-xs=\"row\" flex><md-input-container class=\"md-input-has-placeholder\" flex><md-checkbox \nname=\"paySalaryInPayroll\" \nng-disabled=\'F.readMode || (F.active.menuAction == \"update\" && F.active.menuName == \"dismissesRecords\")\' \nng-model=\"movement.data.paySalaryInPayrol\" aria-label=\"Pago Sueldo en Nomina\" ng-true-value=\"true\" ng-false-value=\"0\">\nPago sueldo en Nómina</md-checkbox></md-input-container><md-input-container class=\"md-input-has-placeholder\" flex>\n<md-checkbox name=\"rehirable\" \nng-disabled=\'F.readMode || (F.active.menuAction == \"update\" && F.active.menuName == \"dismissesRecords\")\' \nng-model=\"movement.data.rehirable\" aria-label=\"Recontratable\" ng-true-value=\"true\" ng-false-value=\"0\">Recontratable\n</md-checkbox></md-input-container></div><div ng-if=\"!movement.data.rehirable\" flex><md-input-container \nclass=\"md-block\"><label>Motivo</label><textarea \nng-disabled=\'F.readMode || (F.active.menuAction == \"update\" && F.active.menuName == \"dismissesRecords\")\' \nclass=\"uppercased\" name=\"motive\" ng-model=\"movement.data.motive\" md-maxlength=\"250\" maxlength=\"250\" \nng-model-options=\"{ debounce: F.debounceTime }\" ng-required=\"!movement.data.rehirable\"></textarea><div \nng-messages=\"form.motive.$error\" ng-show=\"form.motive.$touched || form.motive.$dirty\" role=\"alert\"><div \nng-message=\"required\">Motivo es requerido</div></div></md-input-container></div><md-input-container class=\"md-block\" \nflex><label>Comentarios</label><textarea \nng-disabled=\'F.readMode || (F.active.menuAction == \"update\" && F.active.menuName == \"dismissesRecords\")\' \nclass=\"uppercased\" name=\"comments\" ng-model=\"movement.data.comments\" md-maxlength=\"350\" maxlength=\"350\" \nng-model-options=\"{ debounce: F.debounceTime }\"></textarea><div ng-messages=\"form.comments.$error\" \nng-show=\"form.comments.$touched || form.comments.$dirty\" role=\"alert\"><div ng-message=\"maxlength\">\nComentarios no debe tener más de 350 caracteres</div></div></md-input-container></div>");
$templateCache.put("app/main/employees/forms/employee-cards.html","<div layout=\"row\" ng-if=\"!vm.hideHeader\" layout-align=\"start center\"><span flex>Cuenta(s) Registradas/Emitidas</span>\n<div flex=\"nogrow\" ng-if=\"(!vm.hideAddCard) && (!vm.readMode)\"><md-button ng-click=\"vm.cards.push({})\" \nclass=\"md-primary md-raised md-fab md-mini\" aria-label=\"Add Account\" ng-disabled=\"F.readMode\"><md-tooltip \nmd-direction=\"left\">Añadir Cuenta</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"Add\"></md-icon></md-button>\n</div></div><div layout-gt-xs=\"column\" ng-repeat=\"($index,card) in vm.cards\"><div flex=\"nogrow\" \nng-if=\"(!vm.hideEmit) && vm.verticalAlign\"><md-radio-group ng-model=\"card.emit\" \nng-change=\"vm.setMinAndMaxLength(card,$index)\"><div layout=\"column\" layout-gt-xs=\"row\"><div flex=\"nogrow\">\n<md-radio-button ng-value=\"true\" class=\"mr-5\">Generar</md-radio-button></div><div flex=\"nogrow\"><md-radio-button \nng-value=\"false\">Registrar</md-radio-button></div></div></md-radio-group></div><div flex=\"nogrow\" layout=\"row\"><div \nng-if=\"(!vm.hideEmit) && (!vm.verticalAlign)\" flex=\"nogrow\" class=\"pr-10\"><md-radio-group ng-model=\"card.emit\" \nng-change=\"vm.setMinAndMaxLength(card,$index)\"><md-radio-button class=\"mb-5\" ng-value=\"true\">Generar</md-radio-button>\n<md-radio-button ng-value=\"false\">Registrar</md-radio-button></md-radio-group></div><md-input-container \nclass=\"md-block no-errors-spacer\" flex><label>Banco</label><md-select ng-model=\"card.bank\" \nng-change=\"vm.setMinAndMaxLength(card,$index)\" name=\"cardBank\" required><md-select-header><input autocomplete=\"off\" \ntype=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"bankSelectFilter\" \nplaceholder=\"Busque un Banco\"></md-select-header><md-option ng-value=\"bank._id\" \nng-repeat=\"bank in vm.banks | orderBy:\'name\' | filter:bankSelectFilter\">{{bank.name}}</md-option></md-select><div \nng-messages=\'form[\"cardBank\"+$index].$error\' role=\"alert\"><div ng-message=\"required\">Es necesario el banco</div></div>\n</md-input-container><md-input-container flex class=\"md-block no-errors-spacer\" ng-if=\"card.emit\"><label \nng-if=\"vm.hideCardNumber\">Cuenta <small>Tarjeta#:{{card.number}}</small></label><label ng-if=\"!vm.hideCardNumber\">\nCuenta</label><input type=\"text\" name=\"cardAccountEmit{{$index}}\" md-minlength=\"vm.minAccountLength[$index]\" \nminlength=\"{{vm.minAccountLength[$index]}}\" md-maxlength=\"vm.minAccountLength[$index]\" \nmaxlength=\"{{vm.minAccountLength[$index]}}\" required ng-model-options=\"{ debounce: F.debounceTime }\" \nng-model=\"card.account\"><div ng-messages=\'form[\"cardAccountEmit\"+$index].$error\' role=\"alert\"><div \nng-message=\"required\">Cuenta es requerida</div><div ng-message=\"minlength\">\nCuenta debe tener al menos {{vm.minAccountLength[$index]}} dígitos (0-9)</div><div ng-message=\"maxlength\">\nCuenta debe tener un máximo de {{vm.minAccountLength[$index]}} dígitos (0-9)</div><div ng-message=\"unique\">\nCuenta o Tarjeta ya está registrada</div></div></md-input-container><md-input-container \nclass=\"md-block no-errors-spacer\" flex ng-if=\"card.emit && !vm.hideCardNumber\"><label>Tarjeta</label><input \ntype=\"text\" name=\"cardNumber{{$index}}\" tds-account-input bank=\"card.bank\" emit=\"card.emit\" md-minlength=\"16\" \nminlength=\"16\" md-maxlength=\"16\" maxlength=\"16\" ng-model-options=\"{ debounce: F.debounceTime }\" \nng-disabled=\"card.emit\" required ng-model=\"card.number\"><div ng-messages=\'cardNumber[\"cardAccount\"+$index].$error\' \nrole=\"alert\"><div ng-message=\"required\">El numero de tarjeta es requerido</div><div ng-message=\"validPattern\">\nSolo se admiten dígitos (0-9)</div><div ng-message=\"validCard\">Tarjeta requiere tener 16 dígitos (0-9)</div><div \nng-message=\"minlength\">Cuenta debe tener al menos 16 dígitos (0-9)</div><div ng-message=\"maxlength\">\nCuenta debe tener un máximo de 16 dígitos (0-9)</div><div ng-message=\"validBank\">\nTarjeta no pertenece a {{card.bank | nameOfM : vm.banks}}</div><div ng-message=\"unique\">\nCuenta o Tarjeta ya está registrada</div></div></md-input-container><md-input-container \nclass=\"md-block no-errors-spacer\" flex ng-if=\"!card.emit\"><label>Cuenta o Clabe</label><input type=\"text\" \nname=\"cardAccount{{$index}}\" tds-account-input bank=\"card.bank\" emit=\"card.emit\" \nmd-minlength=\"vm.minAccountLength[$index]\" minlength=\"{{vm.minAccountLength[$index]}}\" md-maxlength=\"18\" \nmaxlength=\"18\" ng-model-options=\"{ debounce: F.debounceTime }\" ng-disabled=\"card.emit\" required ng-model=\"card.number\">\n<div ng-messages=\'form[\"cardAccount\"+$index].$error\' role=\"alert\"><div ng-message=\"required\">\nCuenta o CLABE es requerida</div><div ng-message=\"validPattern\">Solo se admiten dígitos (0-9)</div><div \nng-message=\"validAccount\">La cuenta debe ser de {{vm.minAccountLength[$index]}} o 18 dígitos (0-9)</div><div \nng-message=\"minlength\">Cuenta debe tener al menos {{vm.minAccountLength[$index]}} dígitos (0-9)</div><div \nng-message=\"maxlength\">Cuenta debe tener un máximo de 18 dígitos (0-9)</div><div ng-message=\"unique\">\nCuenta o Tarjeta ya está registrada</div></div></md-input-container><md-input-container class=\"md-block\" flex><label>\nProceso</label><md-select ng-model=\"card.process\" name=\"cardBank\"><md-option ng-value=\"undefined\">DEFAULT</md-option>\n<md-option ng-value=\"process.id\" ng-repeat=\"process in vm.processes | orderBy:\'name\'\">{{process.name}}</md-option>\n</md-select></md-input-container><md-input-container ng-if=\"(!card.emit) && !vm.hideBankToReg\" \nclass=\"md-block no-errors-spacer\" flex><label>Banco a registrar</label><md-select ng-model=\"card.bankToReg\" \nname=\"cardBankToReg\"><md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" \nng-keydown=\"$event.stopPropagation()\" ng-model=\"bankToRegSelectFilter\" placeholder=\"Busque un Banco\">\n</md-select-header><md-option ng-value=\"bank._id\" \nng-repeat=\"bank in vm.banks | orderBy:\'name\' | filter:bankToRegSelectFilter\">{{bank.name}}</md-option></md-select>\n</md-input-container><div ng-if=\"!hideArchived\" flex=\"nogrow\"><md-switch name=\"emitedCard\" \naria-label=\"emmited account\" class=\"md-secondary\" md-invert=\"true\" ng-model=\"card.emmitedYet\" ng-false-value=\"false\">\nArchivada</md-switch></div><div flex=\"nogrow\" ng-if=\"!vm.readMode\"><md-button ng-click=\"vm.cards.splice($index,1)\" \nclass=\"md-warn md-raised md-fab md-mini\" aria-label=\"Remove Card\"><md-tooltip md-direction=\"left\">Borrar Tarjeta\n</md-tooltip><md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button></div></div></div>");
$templateCache.put("app/main/employees/forms/extra-fields.html","<div id=\"extraFields\"><md-autocomplete md-items=\"item in searchEmployeesFirm(searchEmployee)\" \nmd-search-text=\"searchEmployee\" md-selected-item=\"selectedBoss\" \nmd-selected-item-change=\"onEmployeeSelect(selectedBoss)\" md-item-text=\"item.data.name\" md-require-match=\"true\" \nmd-min-length=\"4\" md-no-cache=\"true\" md-input-name=\"autocompleteField\" md-floating-label=\"Jefe directo\">\n<md-item-template><span md-highlight-text=\"searchEmployee\">\n{{ item.data.nss ? (item.data.nss + \' - \') : \'\' }}{{ item.data.name }}</span></md-item-template></md-autocomplete><div \nlayout=\"column\" layout-gt-xs=\"row\"><custom-fields flex fields=\"extraFields\" main-object=\"employee\" form=\"form\">\n</custom-fields></div></div>");
$templateCache.put("app/main/employees/forms/extras.html","<div><md-input-container class=\"md-block\" flex><label>Estado Civil</label><md-select \nng-model=\"employee.data.maritalStatus\" name=\"maritalStatus\" ng-required=\'F.active.menuAction === \"enrole\"\' \nng-disabled=\"F.readMode\"><md-option ng-value=\"maritalStatus\" ng-repeat=\"maritalStatus in F.maritalStatuses\">\n{{maritalStatus}}</md-option></md-select><div ng-messages=\"form.maritalStatus.$error\" role=\"alert\"><div \nng-message=\"required\">Estado civil es requerido</div></div></md-input-container><div><div layout=\"row\" \nlayout-align=\"center center\"><span flex>Beneficiarios</span><md-button ng-click=\"addBeneficiary();form.$setDirty();\" \nclass=\"md-primary md-raised md-fab md-mini\" aria-label=\"Add addBeneficiary\" ng-if=\"!F.readMode\"><md-tooltip \nmd-direction=\"addBeneficiary\">Agregar Beneficiario</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"Add\">\n</md-icon></md-button></div><div layout-gt-xs=\"row\" flex layout-align=\"start start\" \nng-repeat=\"($index,beneficiary) in employee.data.info.beneficiaries\"><md-input-container \nclass=\"md-block no-errors-spacer\" flex flex-gt-xs=\"55\"><label>Beneficiario</label><input ng-disabled=\"F.readMode\" \nplaceholder=\"Nombre Completo\" class=\"uppercased\" type=\"text\" name=\"{{index}}beneficiary\" ng-model=\"beneficiary.name\" \nrequired md-maxlength=\"100\" ng-model-options=\"{ debounce: F.debounceTime }\" maxlength=\"100\"><div \nng-messages=\'form[$index+\"beneficiary\"].$error\' role=\"alert\"><div ng-message=\"required\">Beneficiario(a) es requerido\n</div><div ng-message=\"maxlength\">Beneficiario(a) no debe tener más de 100 caracteres</div></div></md-input-container>\n<md-input-container class=\"md-block no-errors-spacer\" flex flex-gt-xs=\"25\"><label>Parentesco</label><md-select \nng-model=\"beneficiary.relationship\" name=\"{{$index}}relationship\" ng-required=\'F.active.menuAction !== \"especialEdit\"\' \nng-disabled=\"F.readMode\"><md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" \nng-keydown=\"$event.stopPropagation()\" ng-model=\"relationshipSelectFilter\" placeholder=\"Busque un Parentesco\">\n</md-select-header><md-option ng-value=\"relationship.name\" \nng-repeat=\"relationship in (M.relationships | filter:{active:true}) | orderBy:\'name\' | filter:relationshipSelectFilter\">\n{{relationship.name}}</md-option></md-select><div ng-messages=\'form[$index+\"relationship\"].$error\' role=\"alert\"><div \nng-message=\"required\">Parentesco del Beneficiario(a) es requerido</div></div></md-input-container><md-input-container \nclass=\"md-block no-errors-spacer\" flex flex-gt-xs=\"20\"><label>Porcentaje</label><input type=\"number\" min=\"1\" max=\"100\" \nbeneficiaries=\"employee.data.info.beneficiaries\" index-ben=\"$index\" beneficiaries-percent \nng-required=\'F.active.menuAction !== \"especialEdit\"\' ng-disabled=\"F.readMode\" name=\"{{$index}}percent\" \nng-model=\"beneficiary.percent\"><div ng-messages=\'form[$index+\"percent\"].$error\' role=\"alert\"><div \nng-message=\"required\">Porcentaje es requerido</div><div ng-message=\"min\">Porcentaje debe ser mayor a 0</div><div \nng-message=\"max\">Porcentaje no debe pasar 100</div><div ng-message=\"validpercent\">\nLa suma de los beneficiarios no debe pasar 100</div></div></md-input-container><div flex=\"nogrow\" layout=\"row\" \nlayout-align=\"end center\" ng-if=\"!F.readMode\"><md-button \nng-click=\"employee.data.info.beneficiaries.splice($index,1);form.$setDirty();\" \nclass=\"md-warn md-raised md-fab md-mini\" aria-label=\"Remove beneficiary\"><md-tooltip md-direction=\"left\">\nBorrar Beneficiario</md-tooltip><md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button></div>\n</div></div><hr><div \nng-if=\'(F.active.menuAction==\"read\" || F.active.menuAction == \"review\" || F.active.menuAction == \"especialEdit\")\'>\n<form-employee-cards ng-model=\"employee.data.cards\" read-mode=\"F.readMode\" hide-add-card=\"true\" processes=\"processes\" \nform=\"form\" banks=\"M.banks\"></form-employee-cards></div><hr \nng-if=\'(F.active.menuAction==\"read\" || F.active.menuAction == \"review\" || F.active.menuAction == \"especialEdit\")\'><div>\n<div layout=\"row\" layout-align=\"center center\"><span flex>Emails</span><md-button \nng-click=\"addEmail();form.$setDirty();\" class=\"md-primary md-raised md-fab md-mini\" aria-label=\"Add email\" \nng-disabled=\"F.readMode\"><md-tooltip md-direction=\"left\">Agregar Email</md-tooltip><md-icon md-font-icon=\"icon-plus\" \naria-label=\"Add\"></md-icon></md-button></div><div layout-gt-xs=\"row\" layout-align=\"center center\" \nng-repeat=\"($index, email) in employee.data.info.emails\"><md-input-container class=\"md-block no-errors-spacer\" flex>\n<label>Email</label><input ng-disabled=\"F.readMode\" name=\"email{{$index}}\" type=\"email\" email-bank-validator \nignore-regex-validation=\"employee.ignoreValidation.emailRegex\" payroll=\"payroll\" \nng-model-options=\"{ debounce: F.debounceTime }\" ng-model=\"email.email\" md-maxlength=\"100\" maxlength=\"100\" \nng-required=\'F.active.menuAction != \"especialEdit\" && fiscalMovement && employee.data.nss!==\"00000000000\"\'><div \nng-messages=\'form[\"email\"+$index].$error\' role=\"alert\"><div ng-message=\"maxlength\">\nEmail no debe tener más de 100 caracteres</div><div ng-message=\"required\">Email es requerido</div><div \nng-message=\"validFormat\">El correo no tiene un formato válido</div><div ng-message=\"email\">Email no es válido</div>\n</div></md-input-container><md-input-container class=\"md-block no-errors-spacer\" flex \nng-init=\'email.type?false:email.type = \"Personal\"\'><label>Tipo</label><md-select name=\"emailType\" \nng-model=\"email.type\" ng-disabled=\"F.readMode\"><md-option ng-value=\"emailType\" ng-repeat=\"emailType in F.emailTypes\">\n{{emailType}}</md-option></md-select></md-input-container><div flex layout=\"row\"><div flex layout=\"row\" \nlayout-align=\"end center\"><md-button ng-click=\"removeEmail($index);form.$setDirty();\" \nclass=\"md-warn md-raised md-fab md-mini\" aria-label=\"Remove email\" ng-disabled=\"F.readMode\" ng-if=\"!F.readMode\">\n<md-tooltip md-direction=\"left\">Borrar Email</md-tooltip><md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\">\n</md-icon></md-button></div></div></div></div><hr><div><div layout=\"row\" layout-align=\"center center\"><span flex>\nTeléfonos</span><md-button ng-click=\"addPhone()\" class=\"md-primary md-raised md-fab md-mini\" aria-label=\"Add phone\" \nng-if=\"!F.readMode\"><md-tooltip md-direction=\"left\">Agregar Teléfono</md-tooltip><md-icon md-font-icon=\"icon-plus\" \naria-label=\"Add\"></md-icon></md-button></div><div layout-gt-xs=\"row\" \nng-repeat=\"phone in employee.data.info.phones track by $index\"><md-input-container class=\"md-block no-errors-spacer\" \nflex><label>Teléfono</label><input ng-disabled=\"F.readMode\" name=\"phone{{$index}}\" type=\"text\" ng-model=\"phone.phone\" \nng-pattern=\"/^[1-9]{1}[0-9]{9}$/\" md-maxlength=\"10\" maxlength=\"10\" required><div \nng-messages=\'form[\"phone\"+$index].$error\' role=\"alert\"><div ng-message=\"required\">Teléfono es requerido</div><div \nng-message=\"pattern\">No es un teléfono válido, debe contener 10 digitos (0-9)</div></div></md-input-container>\n<md-input-container class=\"md-block no-errors-spacer\" flex><label>Tipo</label><md-select name=\"phoneType\" \nng-model=\"phone.type\" required ng-disabled=\"F.readMode\" ng-init=\'phone.type?false:(phone.type = \"Celular\")\'><md-option \nng-value=\"phoneType\" ng-repeat=\"phoneType in F.contactTypes\">{{phoneType}}</md-option></md-select></md-input-container>\n<div flex layout=\"row\"><div flex layout=\"row\" layout-align=\"end center\"><md-button ng-click=\"removePhone($index)\" \nclass=\"md-warn md-raised md-fab md-mini\" aria-label=\"Remove phone\" ng-if=\"!F.readMode\"><md-tooltip md-direction=\"left\">\nBorrar Teléfono</md-tooltip><md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button></div></div>\n</div></div><hr><md-input-container class=\"md-block no-errors-spacer\" flex><label>\nDescripción corta de las actividades o funciones</label><textarea ng-disabled=\"F.readMode\" class=\"uppercased\" rows=\"3\" \nname=\"jobDescription\" ng-model=\"employee.data.jobDescription\" md-maxlength=\"1000\" maxlength=\"1000\" \nnotdeletespecialcharts=\"true\" ng-model-options=\"{ debounce: F.debounceTime }\"></textarea><div \nng-messages=\"form.jobDescription.$error\" ng-show=\"form.jobDescription.$touched || form.jobDescription.$dirty\" \nrole=\"alert\"><div ng-message=\"maxlength\">Texto no debe tener más de 350 caracteres</div><div ng-message=\"required\">\nTexto es requerida</div></div></md-input-container></div>");
$templateCache.put("app/main/employees/forms/fast-dismiss.html","<div layout=\"column\" flex><md-input-container class=\"md-block date-picker\" flex><label>Fecha de Baja</label>\n<md-datepicker md-hide-icons=\"triangle\" md-current-view=\"{{F.dateView}}\" md-min-date=\"minMovementDate\" \nmd-max-date=\"maxDismissDate\" md-date-filter=\"F.onlyWorkdaysPredicate\" input-date-miliseconds required \nng-model=\"employee.movement.date\" name=\"date\" class=\"md-block\"></md-datepicker><div ng-messages=\"form.date.$error\" \nng-show=\"form.date.$touched || form.date.$dirty\" role=\"alert\"><div ng-message=\"required\">Fecha de Baja es requerido\n</div><div ng-message=\"min\">Fecha de Baja debe ser a partir de {{minMovementDate | date}}</div><div ng-message=\"max\">\nFecha de Baja debe ser antes de {{maxDismissDate | date}}</div><div ng-message=\"mindate\">\nFecha de Baja debe ser a partir de {{minMovementDate | date}}</div><div ng-message=\"maxdate\">\nFecha de Baja debe ser antes de {{maxDismissDate | date}}</div></div></md-input-container><md-input-container \nclass=\"md-block evenPadding\" flex><label>Tipo de Baja</label><md-select name=\"dismissType\" \nng-model=\"employee.movement.dismissType\" required><md-select-header><input autocomplete=\"off\" type=\"search\" \nclass=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"dismissTypeSelectFilter\" \nplaceholder=\"Busque un tipo de baja\"></md-select-header><md-option ng-value=\"dismissType._id\" \nng-repeat=\'dismissType in M.dismissTypes | orderBy:\"name\" | filter:dismissTypeSelectFilter\'>{{dismissType.name}}\n</md-option></md-select><div ng-messages=\"form.dismissType.$error\" \nng-show=\"form.dismissType.$touched || form.dismissType.$dirty\" role=\"alert\"><div ng-message=\"required\">\nTipo de Baja es requerido</div></div></md-input-container></div>");
$templateCache.put("app/main/employees/forms/fast-enrole.html","<div layout=\"row\" flex><md-input-container class=\"md-block evenPadding\" flex><label>Nómina</label><md-select \nng-model=\"employee.payroll\" name=\"payroll\" ng-disabled=\"true\"><md-select-header><input autocomplete=\"off\" \ntype=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"payrollSelectFilter\" \nplaceholder=\"Busque una nómina\"></md-select-header><md-option ng-if=\"!F.permissionToAccessAllPayrolls\" \nng-value=\"payroll.$id\" ng-repeat=\"payroll in L.payrolls | orderBy:\'name\' | filter:payrollSelectFilter\">{{payroll.name}}\n</md-option><md-option ng-if=\"F.permissionToAccessAllPayrolls\" ng-value=\"payroll.$id\" \nng-repeat=\"payroll in L.allPayrolls | orderBy:\'name\' | filter:payrollSelectFilter\">{{payroll.name}}</md-option>\n</md-select><div ng-messages=\"form.payroll.$error\" ng-show=\"form.payroll.$touched || form.payroll.$dirty\" role=\"alert\">\n<div ng-message=\"required\">Nómina es requerido</div></div></md-input-container><md-input-container \nclass=\"md-block evenPadding\" flex><label>Centro de Costo</label><md-select ng-model=\"employee.cc\" name=\"cc\" \nng-disabled=\"true\"><md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" \nng-keydown=\"$event.stopPropagation()\" ng-model=\"ccSelectFilter\" placeholder=\"Busque un centro de costo\">\n</md-select-header><md-option ng-show=\"cc.valid\" ng-value=\"cc.$id\" \nng-repeat=\"cc in L.payrollCcs[employee.payroll] | orderBy:\'name\' | filter:ccSelectFilter\">{{cc.name}} <small>\n[{{L.rpCcs[cc.rp_id].name}}]</small></md-option></md-select><div ng-messages=\"form.cc.$error\" \nng-show=\"form.cc.$touched || form.cc.$dirty\" role=\"alert\"><div ng-message=\"required\">Centro de Costo es requerido</div>\n</div></md-input-container><md-input-container class=\"md-block date-picker\" flex><label>Fecha de Alta</label>\n<md-datepicker md-hide-icons=\"triangle\" md-current-view=\"{{F.dateView}}\" md-min-date=\"minEnroleDate\" \nmd-max-date=\"maxEnroleDate\" input-date-miliseconds ng-model=\"movement.data.date\" name=\"enroleDate\" class=\"md-block\" \nrequired></md-datepicker><div ng-messages=\"form.enroleDate.$error\" \nng-show=\"form.enroleDate.$touched || form.enroleDate.$dirty\" role=\"alert\"><div ng-message=\"required\">\nFecha de Alta es requerido</div><div ng-message=\"min\">Fecha de Alta debe ser a partir de {{minEnroleDate | date}}</div>\n<div ng-message=\"max\">Fecha de Alta debe ser antes de {{maxEnroleDate | date}}</div><div ng-message=\"mindate\">\nFecha de Alta debe ser a partir de {{minEnroleDate | date}}</div><div ng-message=\"maxdate\">\nFecha de Alta debe ser antes de {{maxEnroleDate | date}}</div></div></md-input-container></div><div layout=\"row\" flex>\n<md-input-container class=\"md-block\" flex><label>Apellido Paterno</label><input class=\"uppercased\" type=\"text\" \nname=\"paternalSurname\" ng-model=\"employee.data.info.paternalSurname\" md-maxlength=\"30\" maxlength=\"30\" \nnotdeletethese=\'[\".\",\"-\",\"&#39;\"]\' ng-model-options=\"{ debounce: F.debounceTime }\" required><div \nng-messages=\"form.paternalSurname.$error\" ng-show=\"form.paternalSurname.$touched || form.paternalSurname.$dirty\" \nrole=\"alert\"><div ng-message=\"required\">Apellido Paterno es requerido</div><div ng-message=\"maxlength\">\nApellido Paterno no debe tener más de 30 caracteres</div></div></md-input-container><md-input-container \nclass=\"md-block\" flex><label>Apellido Materno</label><input class=\"uppercased\" type=\"text\" name=\"maternalSurname\" \nng-model=\"employee.data.info.maternalSurname\" md-maxlength=\"30\" maxlength=\"30\" notdeletethese=\'[\".\",\"-\",\"&#39;\"]\' \nng-model-options=\"{ debounce: F.debounceTime }\"><div ng-messages=\"form.maternalSurname.$error\" \nng-show=\"form.maternalSurname.$touched || form.maternalSurname.$dirty\" role=\"alert\"><div ng-message=\"maxlength\">\nApellido Materno no debe tener más de 30 caracteres</div></div></md-input-container><md-input-container \nclass=\"md-block\" flex><label>Nombre(s)</label><input class=\"uppercased\" type=\"text\" name=\"names\" \nng-model=\"employee.data.info.names\" required md-maxlength=\"40\" maxlength=\"40\" notdeletethese=\'[\".\",\"-\",\"&#39;\"]\' \nng-model-options=\"{ debounce: F.debounceTime }\"><div ng-messages=\"form.names.$error\" \nng-show=\"form.names.$touched || form.names.$dirty\" role=\"alert\"><div ng-message=\"required\">Nombre(s) es requerido</div>\n<div ng-message=\"maxlength\">Nombre(s) no debe tener más de 40 caracteres</div></div></md-input-container></div><div \nlayout=\"row\" flex><md-input-container class=\"md-block\" flex ng-if=\"fiscalMovement\"><label>RFC</label><input \nclass=\"uppercased\" rfc ignore-format=\"{{employee.ignoreValidation.rfcFormat}}\" consistency=\"employee\" \nignore-consistency=\"{{employee.ignoreValidation.rfcConsistency}}\" unique-mongo-v2 catalog=\"employees\" \nincludecenter=\"true\" ignorevalidationpath=\"uniqueRfc\" field=\"data.nss\" ref=\"catalogs/employees/collection\" \nfromid=\"{{employee.$id}}\" andfilter=\'{\"data.nss\":\"function:!isEmpty\"}\' type=\"text\" name=\"rfc\" \nng-model=\"employee.data.rfc\" maxlength=\"13\" md-maxlength=\"13\" required><div ng-messages=\"form.rfc.$error\" \nng-show=\"(form.rfc.$error && !form.rfc.$pristine) || (form.rfc.$error && employee.data.rfc)\" role=\"alert\"><div \nng-message=\"rfc\">RFC no tiene un formato válido</div><div ng-message=\"consistency\">\nRFC no coincide con Fecha de Nacimiento o con CURP</div><div ng-message=\"required\">RFC es requerido</div><div \nng-message=\"unique\">RFC ya está registrado</div></div></md-input-container><md-input-container class=\"md-block\" flex \nng-if=\"!fiscalMovement\"><label>RFC</label><input class=\"uppercased\" rfc \nignore-format=\"{{employee.ignoreValidation.rfcFormat}}\" consistency=\"employee\" \nignore-consistency=\"{{employee.ignoreValidation.rfcConsistency}}\" type=\"text\" name=\"rfc\" ng-model=\"employee.data.rfc\" \nmaxlength=\"13\" md-maxlength=\"13\" required><div ng-messages=\"form.rfc.$error\" \nng-show=\"(form.rfc.$error && !form.rfc.$pristine) || (form.rfc.$error && employee.data.rfc)\" role=\"alert\"><div \nng-message=\"rfc\">RFC no tiene un formato válido</div><div ng-message=\"consistency\">\nRFC no coincide con Fecha de Nacimiento o con CURP</div><div ng-message=\"required\">RFC es requerido</div><div \nng-message=\"unique\">RFC ya está registrado</div></div></md-input-container><md-input-container class=\"md-block\" flex \nng-if=\"fiscalMovement\"><label>CURP</label><input class=\"uppercased\" curp curp-consistency consistency=\"employee\" \nunique-fb ref=\"catalogs/employees/collection\" query=\"data/curp\" fromid=\"{{employee.$id}}\" \nandfilter=\'{\"data.nss\":\"function:!isEmpty\"}\' type=\"text\" name=\"curp\" ng-model=\"employee.data.curp\" maxlength=\"18\" \nmd-maxlength=\"18\" required><div ng-messages=\"form.curp.$error\" \nng-show=\"(form.curp.$error && !form.curp.$pristine) || (form.curp.$error && employee.data.curp)\" role=\"alert\"><div \nng-message=\"curp\">CURP no tiene un formato válido</div><div ng-message=\"consistency\">\nCURP no coincide con Fecha de Nacimiento o con RFC</div><div ng-message=\"required\">CURP es requerido</div><div \nng-message=\"unique\">CURP ya está registrado</div></div></md-input-container><md-input-container class=\"md-block\" flex \nng-if=\"!fiscalMovement\"><label>CURP</label><input class=\"uppercased\" curp curp-consistency consistency=\"employee\" \ntype=\"text\" name=\"curp\" ng-model=\"employee.data.curp\" maxlength=\"18\" md-maxlength=\"18\" required><div \nng-messages=\"form.curp.$error\" \nng-show=\"(form.curp.$error && !form.curp.$pristine) || (form.curp.$error && employee.data.curp)\" role=\"alert\"><div \nng-message=\"curp\">CURP no tiene un formato válido</div><div ng-message=\"consistency\">\nCURP no coincide con Fecha de Nacimiento o con RFC</div><div ng-message=\"required\">CURP es requerido</div><div \nng-message=\"unique\">CURP ya está registrado</div></div></md-input-container><md-input-container \nclass=\"md-block date-picker\" flex><label>Nacimiento</label><md-datepicker ng-disabled=\"F.readMode\" \nmd-hide-icons=\"triangle\" input-date-miliseconds ng-model=\"employee.data.info.birth.date\" name=\"birthdate\" required \nclass=\"md-block\"></md-datepicker><div ng-messages=\"form.birthdate.$error\" \nng-show=\"(form.birthdate.$error && !form.birthdate.$pristine) || (form.birthdate.$error && employee.data.info.birth.date)\" \nrole=\"alert\"><div ng-message=\"required\">Fecha de Nacimiento es requerida</div></div></md-input-container></div><div \nlayout=\"row\" flex><md-input-container class=\"md-block\" flex><label>\nSD - SMAG [{{minimumWage}}]{{lastSd ? (\', último SD: \') + lastSd : \'\'}}</label><input type=\"number\" step=\"any\" \nname=\"sd\" ng-model=\"movement.data.sd\" ng-min=\"minimumSd\" ng-disabled=\"!fiscalMovement\" \nng-required=\"employee.data.nss && employee.data.nss!==\'00000000000\'\" ng-model-options=\"{ debounce: F.debounceTime }\">\n<div ng-messages=\"form.sd.$error\" ng-show=\"form.sd.$touched || form.sd.$dirty\" role=\"alert\"><div ng-message=\"required\">\nSueldo Diario es requerido</div><div ng-message=\"min\">Sueldo no puede ser menor al salario mínimo: {{minimumWage}}\n</div></div></md-input-container><md-input-container class=\"md-block\" flex ng-if=\"fiscalMovement && !F.readMode\">\n<label>SBC - SDI [{{minimumSbc}}]{{lastSbc ? (\', último SBC: \') + lastSbc : \'\'}}</label><input sbc-consistency \nsd=\"movement.data.sd\" validator=\"minMaxValidations\" type=\"number\" step=\"any\" name=\"sbc\" round-number=\"2\" \nng-change=\"validateSbc()\" ng-model=\"movement.data.sbc\" ng-min=\"minimumSbc\" \nng-required=\"employee.data.nss && employee.data.nss!==\'00000000000\'\" ng-model-options=\"{ debounce: F.debounceTime }\">\n<div ng-messages=\"form.sbc.$error\" ng-show=\"form.sbc.$touched || form.sbc.$dirty\" role=\"alert\"><div \nng-message=\"required\">Sueldo Base Cotización es requerido</div><div ng-message=\"min\">\nSueldo Base Cotización no puede ser menor a: {{minimumSbc}}</div></div></md-input-container><md-input-container \nclass=\"md-block\" flex ng-if=\"!fiscalMovement || F.readMode\"><label>\nSBC [{{minimumWage}}] MIW o mayor que sbc actual: {{minimumSbc}}</label><input type=\"number\" step=\"any\" name=\"sbc\" \nround-number=\"2\" ng-model=\"movement.data.sbc\" ng-min=\"minimumSbc\" disabled=\"disabled\" readonly=\"readonly\" \nng-model-options=\"{ debounce: F.debounceTime }\"></md-input-container></div>");
$templateCache.put("app/main/employees/forms/fast-mds.html","<div layout=\"column\" flex><md-input-container class=\"md-block date-picker\" flex \nng-if=\'F.active.menuAction !== \"especialEdit\"\'><label>Fecha de MDS</label><md-datepicker md-hide-icons=\"triangle\" \nmd-current-view=\"{{F.dateView}}\" md-min-date=\"minMovementDate\" md-max-date=\"maxMdsDate\" input-date-miliseconds \nrequired ng-model=\"employee.movement.date\" name=\"date\" class=\"md-block\"></md-datepicker><div \nng-messages=\"form.date.$error\" ng-show=\"form.date.$touched || form.date.$dirty\" role=\"alert\"><div \nng-message=\"required\">Fecha de MDS es requerido</div><div ng-message=\"min\">\nFecha de MDS debe ser a partir de {{minMovementDate | date}}</div><div ng-message=\"mindate\">\nFecha de MDS debe ser a partir de {{minMovementDate | date}}</div><div ng-message=\"max\">\nFecha de MDS debe ser antes de {{maxMdsDate | date}}</div><div ng-message=\"maxdate\">\nFecha de MDS debe ser antes de {{maxMdsDate | date}}</div></div></md-input-container><md-input-container \nclass=\"md-block\" flex ng-if=\'F.active.menuAction !== \"especialEdit\" && L.rpCcs[employee.rp].rp!=0 && !F.readMode\'>\n<label>SD [{{minimumWage}}] MIW o al último sd: {{minimumSd}}</label><input type=\"number\" step=\"any\" \nng-min=\"minimumSd\" name=\"sd\" ng-model=\"employee.data.salary.sd\" ng-disabled=\"F.readMode\" \nng-model-options=\"{ debounce: F.debounceTime }\" required><div ng-messages=\"form.sd.$error\" \nng-show=\"form.sd.$touched || form.sd.$dirty\" role=\"alert\"><div ng-message=\"required\">Sueldo Diario es requerido</div>\n<div ng-message=\"min\">Sueldo no puede ser menor al salario minimo: {{minimumWage}} o al último sd: {{minimumSd}}</div>\n</div></md-input-container><md-input-container class=\"md-block\" flex \nng-if=\'F.active.menuAction !== \"especialEdit\"&& (L.rpCcs[employee.rp].rp==0 || F.readMode)\'><label>\nSBC [{{minimumWage}}] MIW o mayor que sbc actual: {{minimumSbc}}</label><input sbc-consistency movement=\"movement\" \nemployee=\"employee\" benefit=\"benefit\" last-movement=\"lastApprovedMovement\" sd=\"employee.data.salary.sd\" \nis-movement=\"true\" type=\"number\" step=\"any\" name=\"sbc\" round-number=\"2\" ng-model=\"employee.data.salary.sbc\" \nng-min=\"minimumSbc\" ng-required=\"employee.data.nss\" ng-model-options=\"{ debounce: F.debounceTime }\"><div \nng-messages=\"form.sbc.$error\" ng-show=\"form.sbc.$touched || form.sbc.$dirty\" role=\"alert\"><div ng-message=\"required\">\nSueldo Base Cotización es requerido</div><div ng-message=\"min\">\nSueldo Base Cotización no puede ser menor a: {{minimumSbc}}</div></div></md-input-container><md-input-container \nclass=\"md-block\" flex ng-if=\'F.active.menuAction !== \"especialEdit\" && L.rpCcs[employee.rp].rp==0\'><label>\nSBC [{{minimumWage}}] MIW o mayor que sbc actual: {{minimumSbc}}</label><input type=\"number\" step=\"any\" name=\"sbc\" \nround-number=\"2\" ng-model=\"employee.data.salary.sbc\" ng-min=\"minimumSbc\" disabled=\"disabled\" readonly=\"readonly\" \nng-model-options=\"{ debounce: F.debounceTime }\"></md-input-container></div>");
$templateCache.put("app/main/employees/forms/health.html","<div><div layout-gt-xs=\"row\" flex><md-input-container class=\"md-block\" flex \nng-if=\'F.active.menuAction !== \"especialEdit\"\'><label>UMF</label><input type=\"text\" name=\"umf\" class=\"zerofilled\" \nng-model=\"employee.data.health.umf\" ng-model-options=\"{ debounce: F.debounceTime }\" charts=\"3\" pattern=\"([0-9]{3})\" \nmd-maxlength=\"3\" maxlength=\"3\" md-minlength=\"3\" minlength=\"3\" ng-disabled=\"L.rpCcs[employee.rp].rp==0 || F.readMode\" \nng-required=\"L.rpCcs[employee.rp].rp!=0\"><div ng-messages=\"form.umf.$error\" \nng-show=\"form.umf.$touched || form.umf.$dirty\" role=\"alert\"><div ng-message=\"required\">UMF es requerido</div><div \nng-message=\"pattern\">UMF debe tener [3] números del (0-9)</div></div></md-input-container><md-input-container \nclass=\"md-block\" flex ng-if=\'F.active.menuAction == \"especialEdit\"\'><label>UMF</label><input type=\"text\" name=\"umf\" \nclass=\"zerofilled\" ng-model=\"employee.data.health.umf\" ng-model-options=\"{ debounce: F.debounceTime }\" charts=\"3\" \nng-disabled=\"!fiscalMovement || F.readMode || employee.data.nss===\'00000000000\'\"></md-input-container>\n<md-input-container class=\"md-input-has-placeholder\" flex><label>Beneficio Salud</label><md-switch \nname=\"healthBenefit\" aria-label=\"active health\" class=\"md-secondary\" ng-model=\"employee.data.health.benefit\" \nng-false-value=\"0\"></md-switch></md-input-container></div><div layout-gt-xs=\"row\" flex><md-input-container \nclass=\"md-block date-picker\" flex ng-if=\'F.active.menuAction == \"especialEdit\"\'><label>Alta Salud</label><md-datepicker\n md-hide-icons=\"triangle\" md-current-view=\"{{F.dateView}}\" input-date-miliseconds \nng-model=\"employee.data.health.initDate\" name=\"healthInitDate\" class=\"md-block\"></md-datepicker></md-input-container>\n<md-input-container class=\"md-block date-picker\" flex ng-if=\'F.active.menuAction !== \"especialEdit\"\'><label>Alta Salud\n</label><md-datepicker md-hide-icons=\"triangle\" md-current-view=\"{{F.dateView}}\" md-min-date=\"minDate\" \ninput-date-miliseconds ng-required=\"employee.data.health.benefit\" ng-model=\"employee.data.health.initDate\" \nname=\"healthInitDate\" class=\"md-block\"></md-datepicker><div ng-messages=\"form.healthInitDate.$error\" \nng-show=\"form.healthInitDate.$error && !form.healthInitDate.$pristine || form.healthInitDate.$error && employee.data.health.initDate\" \nrole=\"alert\"><div ng-message=\"required\">Fecha de Alta Salud es requerido</div><div ng-message=\"min\">\nFecha de Alta Salud debe ser a partir de {{minDate | date}}</div><div ng-message=\"mindate\">\nFecha de Alta Salud debe ser a partir de {{minDate | date}}</div></div></md-input-container><md-input-container \nclass=\"md-block date-picker\" flex ng-if=\'F.active.menuAction == \"especialEdit\"\'><label>Baja Salud</label><md-datepicker\n md-hide-icons=\"triangle\" md-current-view=\"{{F.dateView}}\" input-date-miliseconds \nng-model=\"employee.data.health.endDate\" name=\"healthEndDate\" class=\"md-block\"></md-datepicker></md-input-container>\n<md-input-container class=\"md-block date-picker\" flex ng-if=\'F.active.menuAction !== \"especialEdit\"\'><label>Baja Salud\n</label><md-datepicker md-hide-icons=\"triangle\" md-current-view=\"{{F.dateView}}\" input-date-miliseconds \nng-model=\"employee.data.health.endDate\" name=\"healthEndDate\" md-min-date=\"employee.data.health.initDate\" \nclass=\"md-block\"></md-datepicker><div ng-messages=\"form.healthEndDate.$error\" \nng-show=\"form.healthEndDate.$touched || form.healthEndDate.$dirty\" role=\"alert\"><div ng-message=\"min\">\nFecha de Baja Salud debe ser a partir de {{employee.data.health.initDate | date}}</div><div ng-message=\"mindate\">\nFecha de Baja Salud debe ser a partir de {{employee.data.health.initDate | date}}</div></div></md-input-container>\n<md-input-container class=\"md-block\" flex><label>Certificado</label><input unique-fb name=\"healthCertificate\" \nref=\"{{F.active.menuRef}}\" query=\"data/health/certificate\" fromid=\"{{employee.$id}}\" type=\"number\" min=\"0\" \nng-model=\"employee.data.health.certificate\" ng-model-options=\"{ debounce: F.debounceTime }\"><div \nng-messages=\"form.healthCertificate.$error\" ng-show=\"form.healthCertificate.$touched || form.healthCertificate.$dirty\" \nrole=\"alert\"><div ng-message=\"min\">Certificado debe ser un número válido</div><div ng-message=\"unique\">\nCertificado ya registrado</div></div></md-input-container></div></div>");
$templateCache.put("app/main/employees/forms/info-simple.html","<div><div layout-gt-xs=\"row\" flex><md-input-container class=\"md-block evenPadding\" flex><label>Centro de Costo</label>\n<md-select ng-model=\"employee.cc\" name=\"cc\" required ng-change=\"ccUpdated()\" ng-disabled=\"F.readMode\">\n<md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" \nng-model=\"ccSelectFilter\" placeholder=\"Busque un centro de costo\"></md-select-header><md-option ng-value=\"cc.$id\" \nng-repeat=\"cc in sameRps | orderBy:\'name\' | filter:ccSelectFilter\">{{cc.name}} <small>\n{{cc.place|nameOfM:M.placesOfWorkRecords}}</small> <small>[{{L.rpCcs[cc.rp_id].name}}]</small></md-option></md-select>\n<div ng-messages=\"form.cc.$error\" role=\"alert\"><div ng-message=\"required\">Centro de Costo es requerido</div></div>\n</md-input-container><md-input-container class=\"md-block evenPadding\" flex><label>Puesto</label><md-select \nng-model=\"employee.data.position\" ng-change=\"setJobDescription()\" name=\"position\" required ng-disabled=\"F.readMode\">\n<md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" \nng-model=\"positionSelectFilter\" placeholder=\"Busque un puesto\"></md-select-header><md-option ng-value=\"position.$id\" \nng-repeat=\"position in L.payrollPositions[employee.payroll] | orderBy:\'name\' | filter:positionSelectFilter\">\n{{position.name}}</md-option></md-select><div ng-messages=\"form.position.$error\" role=\"alert\"><div \nng-message=\"required\">Puesto es requerido</div></div></md-input-container><md-input-container \nclass=\"md-block evenPadding\" flex \nng-if=\"L.payrollDepartments[employee.payroll] && L.payrollDepartments[employee.payroll].length > 0\"><label>Departamento\n</label><md-select ng-model=\"employee.data.department\" name=\"department\" required ng-disabled=\"F.readMode\">\n<md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" \nng-model=\"departmentSelectFilter\" placeholder=\"Busque un departamento\"></md-select-header><md-option \nng-value=\"department.$id\" \nng-repeat=\"department in L.payrollDepartments[employee.payroll] | orderBy:\'name\' | filter:departmentSelectFilter\">\n{{department.name}}</md-option></md-select><div ng-messages=\"form.department.$error\" role=\"alert\"><div \nng-message=\"required\">Departamento es requerido</div></div></md-input-container><md-input-container \nclass=\"md-block evenPadding\" flex=\"20\"><label>Estado Civil</label><md-select ng-model=\"employee.data.maritalStatus\" \nname=\"maritalStatus\" ng-disabled=\"F.readMode\"><md-option ng-value=\"maritalStatus\" \nng-repeat=\"maritalStatus in F.maritalStatuses\">{{maritalStatus}}</md-option></md-select><div \nng-messages=\"form.maritalStatus.$error\" role=\"alert\"><div ng-message=\"required\">Estado civil es requerido</div></div>\n</md-input-container></div><div layout=\"row\"><span flex>Beneficiarios</span><md-button ng-click=\"addBeneficiary()\" \nclass=\"md-primary md-raised md-fab md-mini\" aria-label=\"Add addBeneficiary\" ng-disabled=\"F.readMode\"><md-tooltip \nmd-direction=\"addBeneficiary\">Agregar Beneficiario</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"Add\">\n</md-icon></md-button></div><div layout-gt-xs=\"row\" flex layout-align=\"start start\" \nng-repeat=\"($index,beneficiary) in employee.data.info.beneficiaries\"><md-input-container class=\"md-block mb-0\" flex \nflex-gt-xs=\"55\"><label>Beneficiario</label><input ng-disabled=\"F.readMode\" placeholder=\"Nombre Completo\" \nclass=\"uppercased\" type=\"text\" name=\"{{index}}beneficiary\" ng-model=\"beneficiary.name\" required md-maxlength=\"100\" \nng-model-options=\"{ debounce: F.debounceTime }\" maxlength=\"100\"><div ng-messages=\'form[$index+\"beneficiary\"].$error\' \nrole=\"alert\"><div ng-message=\"required\">Beneficiario(a) es requerido</div><div ng-message=\"maxlength\">\nBeneficiario(a) no debe tener más de 100 caracteres</div></div></md-input-container><md-input-container \nclass=\"md-block mb-0\" flex flex-gt-xs=\"25\"><label>Parentesco</label><md-select ng-model=\"beneficiary.relationship\" \nname=\"{{$index}}relationship\" required ng-disabled=\"F.readMode\"><md-select-header><input autocomplete=\"off\" \ntype=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"relationshipSelectFilter\" \nplaceholder=\"Busque un Parentesco\"></md-select-header><md-option ng-value=\"relationship.name\" \nng-repeat=\"relationship in (M.relationships | filter:{active:true}) | orderBy:\'name\' | filter:relationshipSelectFilter\">\n{{relationship.name}}</md-option></md-select><div ng-messages=\'form[$index+\"relationship\"].$error\' role=\"alert\"><div \nng-message=\"required\">Parentesco del Beneficiario(a) es requerido</div></div></md-input-container><md-input-container \nclass=\"md-block mb-0\" flex flex-gt-xs=\"20\"><label>Porcentaje</label><input type=\"number\" min=\"1\" max=\"100\" \nbeneficiaries=\"employee.data.info.beneficiaries\" index-ben=\"$index\" beneficiaries-percent required \nng-disabled=\"F.readMode\" name=\"{{$index}}percent\" ng-model=\"beneficiary.percent\"><div \nng-messages=\'form[$index+\"percent\"].$error\' role=\"alert\"><div ng-message=\"required\">Porcentaje es requerido</div><div \nng-message=\"min\">Porcentaje debe ser mayor a 0</div><div ng-message=\"max\">Porcentaje no debe pasar 100</div></div>\n</md-input-container><div flex=\"nogrow\" layout=\"row\" layout-align=\"end center\"><md-button \nng-click=\"employee.data.info.beneficiaries.splice($index,1);form.$setDirty()\" class=\"md-warn md-raised md-fab md-mini\" \naria-label=\"Remove beneficiary\"><md-tooltip md-direction=\"left\">Borrar Beneficiario</md-tooltip><md-icon \nmd-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button></div></div><hr><form-employee-cards \nng-model=\"employee.data.cards\" read-mode=\"F.readMode\" processes=\"processes\" form=\"form\" banks=\"M.banks\" \nhide-emit=\"true\" hide-archived=\"true\" hide-card-number=\"true\" hide-bank-to-reg=\"true\"></form-employee-cards><hr><div \nlayout=\"row\"><span flex>Emails</span><md-button ng-click=\"addEmail()\" class=\"md-primary md-raised md-fab md-mini\" \naria-label=\"Add email\" ng-disabled=\"F.readMode\"><md-tooltip md-direction=\"left\">Agregar Email</md-tooltip><md-icon \nmd-font-icon=\"icon-plus\" aria-label=\"Add\"></md-icon></md-button></div><div layout-gt-xs=\"row\" \nng-repeat=\"($index, email) in employee.data.info.emails\"><md-input-container class=\"md-block\" flex><label>Email</label>\n<input ng-disabled=\"F.readMode\" name=\"email{{$index}}\" type=\"email\" email-bank-validator \nignore-regex-validation=\"employee.ignoreValidation.emailRegex\" payroll=\"payroll\" \nng-model-options=\"{ debounce: F.debounceTime }\" ng-model=\"email.email\" md-maxlength=\"100\" maxlength=\"100\" \nng-required=\'F.active.menuAction != \"especialEdit\" && fiscalMovement\'><div ng-messages=\'form[\"email\"+$index].$error\' \nrole=\"alert\"><div ng-message=\"maxlength\">Email no debe tener más de 100 caracteres</div><div ng-message=\"required\">\nEmail es requerido</div><div ng-message=\"validFormat\">El correo no tiene un formato válido</div><div \nng-message=\"email\">Email no es válido</div></div></md-input-container><md-input-container class=\"md-block evenPadding\" \nflex><label>Tipo</label><md-select name=\"emailType\" ng-model=\"email.type\" ng-disabled=\"F.readMode\"><md-option \nng-value=\"emailType\" ng-repeat=\"emailType in F.emailTypes\">{{emailType}}</md-option></md-select></md-input-container>\n<div layout=\"nogrow\" layout-align=\"end center\"><md-button ng-click=\"removeEmail($index)\" \nclass=\"md-warn md-raised md-fab md-mini\" aria-label=\"Remove email\" ng-disabled=\"F.readMode\"><md-tooltip \nmd-direction=\"left\">Borrar Email</md-tooltip><md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon>\n</md-button></div></div><hr><div layout=\"row\"><span flex>Teléfonos</span><md-button ng-click=\"addPhone()\" \nclass=\"md-primary md-raised md-fab md-mini\" aria-label=\"Add phone\" ng-disabled=\"F.readMode\"><md-tooltip \nmd-direction=\"left\">Agregar Teléfono</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"Add\"></md-icon>\n</md-button></div><div layout-gt-xs=\"row\" ng-repeat=\"phone in employee.data.info.phones track by $index\">\n<md-input-container class=\"md-block\" flex><label>Teléfono</label><input ng-disabled=\"F.readMode\" \nname=\"phone{{$index}}\" type=\"text\" ng-model=\"phone.phone\" ng-pattern=\"/^[1-9]{3}[0-9]{7}$/\" md-maxlength=\"10\" \nmaxlength=\"10\" minlength=\"10\" required ng-change=\"validPhone(phone.phone)\"><div \nng-messages=\'form[\"phone\"+$index].$error\' role=\"alert\"><div ng-message=\"required\">Teléfono es requerido</div><div \nng-message=\"pattern\">No es un teléfono válido, debe contener 10 digitos (0-9)</div></div></md-input-container>\n<md-input-container class=\"md-block evenPadding\" flex><label>Tipo</label><md-select name=\"phoneType\" \nng-model=\"phone.type\" required ng-disabled=\"F.readMode\"><md-option ng-value=\"phoneType\" \nng-repeat=\"phoneType in F.contactTypes\">{{phoneType}}</md-option></md-select></md-input-container><div layout=\"nogrow\" \nlayout-align=\"end center\"><md-button ng-click=\"removePhone($index)\" class=\"md-warn md-raised md-fab md-mini\" \naria-label=\"Remove phone\" ng-disabled=\"F.readMode\"><md-tooltip md-direction=\"left\">Borrar Teléfono</md-tooltip><md-icon\n md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button></div></div><hr><md-input-container \nclass=\"md-block\" flex><label>Descripción corta de las actividades o funciones</label><textarea \nng-disabled=\"F.readMode\" class=\"uppercased\" rows=\"3\" name=\"jobDescription\" ng-model=\"employee.data.jobDescription\" \nmd-maxlength=\"1000\" maxlength=\"1000\" notdeletespecialcharts=\"true\" ng-model-options=\"{ debounce: F.debounceTime }\">\n</textarea><div ng-messages=\"form.jobDescription.$error\" \nng-show=\"form.jobDescription.$touched || form.jobDescription.$dirty\" role=\"alert\"><div ng-message=\"maxlength\">\nTexto no debe tener más de 350 caracteres</div><div ng-message=\"required\">Texto es requerida</div></div>\n</md-input-container></div>");
$templateCache.put("app/main/employees/forms/info.html","<div><div ng-show=\"false\" ng-if=\"F.active.menuAction!==\'especialEdit\'\"><input name=\"geoZone\" ng-model=\"geoZone.name\" \nrequired></div><div layout-gt-xs=\"row\" flex ng-if=\"F.active.menuName !== \'idseAutoRecords\'\"><md-input-container \nclass=\"md-block evenPadding\" flex><label>Nómina</label><md-select ng-model=\"employee.payroll\" name=\"payroll\" required \nng-change=\"payrollUpdated()\" ng-disabled=\"F.readMode\"><md-select-header><input autocomplete=\"off\" type=\"search\" \nclass=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"payrollSelectFilter\" placeholder=\"Busque una nómina\">\n</md-select-header><md-option ng-if=\"payroll.active||!F.addMode\" ng-value=\"payroll.$id\" \nng-class=\'{\"inactiveOption\":!payroll.active}\' \nng-repeat=\"payroll in (F.permissionToAccessAllPayrolls?L.allPayrolls:L.payrolls) | orderBy:\'class\' | filter:payrollSelectFilter\">\n{{payroll.class}} {{payroll.name}}</md-option></md-select><div ng-messages=\"form.payroll.$error\" role=\"alert\"><div \nng-message=\"required\">Nómina es requerido</div></div></md-input-container><md-input-container \nclass=\"md-block evenPadding\" flex><label>Centro de Costo</label><md-select ng-model=\"employee.cc\" name=\"cc\" required \nng-change=\"ccUpdated()\" ng-disabled=\"F.readMode\"><md-select-header><input autocomplete=\"off\" type=\"search\" \nclass=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"ccSelectFilter\" \nplaceholder=\"Busque un centro de costo\"></md-select-header><md-option ng-class=\'{\"inactiveOption\":!cc.valid}\' \nng-if=\'!F.permissionToAccessAllPayrolls && (cc.valid || (!F.addMode && F.active.menuAction!=\"reEntry\" && F.active.menuAction!=\"review\"))\' \nng-value=\"cc.$id\" \nng-repeat=\"cc in L.payrollCcs[employee.payroll] | filterUserCcs:L.userCcs[F.profile.uid] | orderBy:\'name\' | filter:ccSelectFilter\">\n{{cc.name}} <small>{{cc.place|nameOfM:M.placesOfWorkRecords}}</small> <small>[{{L.rpCcs[cc.rp_id].name}}]</small>\n</md-option><md-option ng-class=\'{\"inactiveOption\":!cc.valid}\' \nng-if=\'F.permissionToAccessAllPayrolls && (cc.valid || (!F.addMode && F.active.menuAction!=\"reEntry\" && F.active.menuAction!=\"review\"))\' \nng-value=\"cc.$id\" ng-repeat=\"cc in L.payrollCcs[employee.payroll] | orderBy:\'name\' | filter:ccSelectFilter\">\n{{cc.name}} <small>{{cc.place|nameOfM:M.placesOfWorkRecords}}</small> <small>[{{L.rpCcs[cc.rp_id].name}}]</small>\n</md-option></md-select><div ng-messages=\"form.cc.$error\" role=\"alert\"><div ng-message=\"required\">\nCentro de Costo es requerido</div></div></md-input-container><md-input-container class=\"md-block evenPadding\" flex>\n<label>Puesto</label><md-select ng-model=\"employee.data.position\" ng-change=\"setJobDescription()\" name=\"position\" \nrequired ng-disabled=\"F.readMode\"><md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" \nng-keydown=\"$event.stopPropagation()\" ng-model=\"positionSelectFilter\" placeholder=\"Busque un puesto\">\n</md-select-header><md-option ng-value=\"position.$id\" \nng-repeat=\"position in L.payrollPositions[employee.payroll] | orderBy:\'name\' | filter:positionSelectFilter\">\n{{position.name}}</md-option></md-select><div ng-messages=\"form.position.$error\" role=\"alert\"><div \nng-message=\"required\">Puesto es requerido</div></div></md-input-container><md-input-container \nclass=\"md-block evenPadding\" flex \nng-if=\"L.payrollDepartments[employee.payroll] && L.payrollDepartments[employee.payroll].length > 0\"><label>Departamento\n</label><md-select ng-model=\"employee.data.department\" name=\"department\" required ng-disabled=\"F.readMode\">\n<md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" \nng-model=\"departmentSelectFilter\" placeholder=\"Busque un departamento\"></md-select-header><md-option \nng-value=\"department.$id\" \nng-repeat=\"department in L.payrollDepartments[employee.payroll] | orderBy:\'name\' | filter:departmentSelectFilter\">\n{{department.name}}</md-option></md-select><div ng-messages=\"form.department.$error\" role=\"alert\"><div \nng-message=\"required\">Departamento es requerido</div></div></md-input-container></div><div layout-gt-xs=\"row\" flex>\n<md-input-container class=\"md-block\" flex ng-if=\'F.active.menuAction !== \"especialEdit\" && fiscalMovement\'><label>CURP\n</label><input ng-disabled=\"F.readMode || (!employee.cc)\" class=\"uppercased\" curp curp-consistency unique-mongo-v2 \nincludecenter=\"true\" ignorevalidationpath=\"uniqueCurp\" field=\"data.curp\" catalog=\"employees\" consistency=\"employee\" \nref=\"catalogs/employees/collection\" query=\"data/curp\" fromid=\"{{employee.$id}}\" \nng-change=\"loadEmployeeInfoByCurp(employee.data.curp)\" andfilter=\'{\"data.nss\":\"function:!isEmpty\"}\' type=\"text\" \nname=\"curp\" ng-model=\"employee.data.curp\" maxlength=\"18\" md-maxlength=\"18\" required><div \nng-messages=\"form.curp.$error\" role=\"alert\"><div ng-message=\"curp\">CURP no tiene un formato válido</div><div \nng-message=\"curpDigit\">CURP no tiene un formato válido, revisé el dígito verificador</div><div \nng-message=\"consistency\">CURP no coincide con Fecha de Nacimiento o con RFC</div><div ng-message=\"required\">\nCURP es requerido</div><div ng-message=\"unique\">CURP ya está registrado</div></div></md-input-container>\n<md-input-container class=\"md-block\" flex ng-if=\'F.active.menuAction == \"especialEdit\" && fiscalMovement\'><label>CURP\n</label><input ng-disabled=\"F.readMode\" class=\"uppercased\" unique-mongo-v2 includecenter=\"true\" \nignorevalidationpath=\"uniqueCurp\" field=\"data.curp\" catalog=\"employees\" curp ref=\"catalogs/employees/collection\" \nquery=\"data/curp\" fromid=\"{{employee.$id}}\" type=\"text\" name=\"curp\" ng-model=\"employee.data.curp\" maxlength=\"18\" \nmd-maxlength=\"18\"><div ng-messages=\"form.curp.$error\" role=\"alert\"><div ng-message=\"curp\">\nCURP no tiene un formato válido</div><div ng-message=\"consistency\">CURP no coincide con Fecha de Nacimiento o con RFC\n</div><div ng-message=\"required\">CURP es requerido</div><div ng-message=\"unique\">CURP ya está registrado</div></div>\n</md-input-container><md-input-container class=\"md-block\" flex \nng-if=\'F.active.menuAction !== \"especialEdit\" && !fiscalMovement\'><label>CURP</label><input unique-mongo-v2 \nincludecenter=\"true\" ignorevalidationpath=\"uniqueCurp\" fromid=\"{{employee.$id}}\" field=\"data.curp\" catalog=\"employees\" \nng-disabled=\"F.readMode || (!employee.cc)\" class=\"uppercased\" ng-change=\"loadEmployeeInfoByCurp(employee.data.curp)\" \ncurp curp-consistency consistency=\"employee\" type=\"text\" name=\"curp\" ng-model=\"employee.data.curp\" maxlength=\"18\" \nmd-maxlength=\"18\" required><div ng-messages=\"form.curp.$error\" role=\"alert\"><div ng-message=\"curp\">\nCURP no tiene un formato válido</div><div ng-message=\"curpDigit\">\nCURP no tiene un formato válido, revisé el dígito verificador</div><div ng-message=\"consistency\">\nCURP no coincide con Fecha de Nacimiento o con RFC</div><div ng-message=\"required\">CURP es requerido</div><div \nng-message=\"unique\">CURP ya está registrado</div></div></md-input-container><md-input-container class=\"md-block\" flex \nng-if=\'F.active.menuAction == \"especialEdit\" && !fiscalMovement\'><label>CURP</label><input ng-disabled=\"F.readMode\" \nclass=\"uppercased\" curp type=\"text\" name=\"curp\" ng-model=\"employee.data.curp\" maxlength=\"18\" md-maxlength=\"18\"><div \nng-messages=\"form.curp.$error\" role=\"alert\"><div ng-message=\"curp\">CURP no tiene un formato válido</div><div \nng-message=\"consistency\">CURP no coincide con Fecha de Nacimiento o con RFC</div><div ng-message=\"required\">\nCURP es requerido</div><div ng-message=\"unique\">CURP ya está registrado</div></div></md-input-container>\n<md-input-container class=\"md-block\" flex><label>Apellido Paterno</label><input \nng-disabled=\'F.readMode || (!isManualEntry && F.active.menuAction != \"especialEdit\")\' class=\"uppercased\" type=\"text\" \nname=\"paternalSurname\" ng-model=\"employee.data.info.paternalSurname\" md-maxlength=\"30\" maxlength=\"30\" \nnotdeletethese=\'[\".\",\"-\",\"&#39;\"]\' ng-model-options=\"{ debounce: F.debounceTime }\" required><div \nng-messages=\"form.paternalSurname.$error\" role=\"alert\"><div ng-message=\"required\">Apellido Paterno es requerido</div>\n<div ng-message=\"maxlength\">Apellido Paterno no debe tener más de 30 caracteres</div></div></md-input-container>\n<md-input-container class=\"md-block\" flex><label>Apellido Materno</label><input \nng-disabled=\'F.readMode || (!isManualEntry && F.active.menuAction != \"especialEdit\")\' class=\"uppercased\" type=\"text\" \nname=\"maternalSurname\" ng-model=\"employee.data.info.maternalSurname\" md-maxlength=\"30\" maxlength=\"30\" \nnotdeletethese=\'[\".\",\"-\",\"&#39;\"]\' ng-model-options=\"{ debounce: F.debounceTime }\"><div \nng-messages=\"form.maternalSurname.$error\" role=\"alert\"><div ng-message=\"maxlength\">\nApellido Materno no debe tener más de 30 caracteres</div></div></md-input-container></div><div layout-gt-xs=\"row\" flex>\n<md-input-container class=\"md-block\" flex><label>Nombre(s)</label><input \nng-disabled=\'F.readMode || (!isManualEntry && F.active.menuAction != \"especialEdit\")\' class=\"uppercased\" type=\"text\" \nname=\"names\" ng-model=\"employee.data.info.names\" required md-maxlength=\"40\" maxlength=\"40\" \nnotdeletethese=\'[\".\",\"-\",\"&#39;\"]\' ng-model-options=\"{ debounce: F.debounceTime }\"><div \nng-messages=\"form.names.$error\" role=\"alert\"><div ng-message=\"required\">Nombre(s) es requerido</div><div \nng-message=\"maxlength\">Nombre(s) no debe tener más de 40 caracteres</div></div></md-input-container><md-input-container\n class=\"md-block date-picker\" flex><label>Nacimiento</label><md-datepicker \nng-disabled=\'F.readMode || (!isManualEntry && F.active.menuAction != \"especialEdit\")\' md-hide-icons=\"triangle\" \ninput-date-miliseconds ng-model=\"employee.data.info.birth.date\" name=\"birthdate\" required class=\"md-block\">\n</md-datepicker><div ng-messages=\"form.birthdate.$error\" role=\"alert\"><div ng-message=\"required\">\nFecha de Nacimiento es requerida</div></div></md-input-container><md-input-container class=\"md-block\" flex \nng-if=\"F.active.menuName === \'idseAutoRecords\'\"><label>NSS</label><input nss class=\"uppercased\" unique-mongo-v2 \ncatalog=\"employees\" includecenter=\"true\" ignorevalidationpath=\"uniqueNss\" field=\"data.nss\" \nref=\"catalogs/employees/collection\" query=\"data/nss\" fromid=\"{{employee.$id}}\" type=\"text\" name=\"nss\" \nng-model=\"employee.data.nss\" md-maxlength=\"11\" maxlength=\"11\" pattern=\"([0-9]{11})\" required \nng-model-options=\"{ debounce: F.debounceTime }\"><div ng-messages=\"form.nss.$error\" role=\"alert\"><div ng-message=\"nss\">\nNSS no tiene un formato válido</div><div ng-message=\"required\">NSS es requerido</div><div ng-message=\"unique\">\nNSS ya está registrado</div></div></md-input-container></div><div layout-gt-xs=\"row\" flex \nng-if=\"F.active.menuName !== \'idseAutoRecords\'\"><md-input-container class=\"md-block\" flex \nng-if=\"fiscalMovement && !F.readMode\"><label>NSS</label><input nss class=\"uppercased\" unique-mongo-v2 \ncatalog=\"employees\" includecenter=\"true\" ignorevalidationpath=\"uniqueNss\" field=\"data.nss\" \nref=\"catalogs/employees/collection\" query=\"data/nss\" fromid=\"{{employee.$id}}\" type=\"text\" name=\"nss\" \nng-model=\"employee.data.nss\" md-maxlength=\"11\" maxlength=\"11\" pattern=\"([0-9]{11})\" required \nng-model-options=\"{ debounce: F.debounceTime }\"><div ng-messages=\"form.nss.$error\" role=\"alert\"><div ng-message=\"nss\">\nNSS no tiene un formato válido</div><div ng-message=\"required\">NSS es requerido</div><div ng-message=\"unique\">\nNSS ya está registrado</div></div></md-input-container><md-input-container class=\"md-block\" flex \nng-if=\"!fiscalMovement || F.readMode\"><label>NSS</label><input class=\"uppercased\" type=\"text\" name=\"nss\" \nng-model=\"employee.data.nss\" disabled=\"disabled\" readonly=\"readonly\" ng-model-options=\"{ debounce: F.debounceTime }\">\n</md-input-container><md-input-container class=\"md-block date-picker\" flex \nng-if=\'F.active.menuAction !== \"especialEdit\" && F.active.menuName != \"movements\"\'><label>Fecha de Alta</label>\n<md-datepicker ng-disabled=\"F.readMode\" md-hide-icons=\"triangle\" md-current-view=\"{{F.dateView}}\" \nmd-min-date=\"minEnroleDate\" md-max-date=\"maxEnroleDate\" input-date-miliseconds ng-model=\"employee.data.enroleDate\" \nname=\"enroleDate\" class=\"md-block\" required></md-datepicker><div ng-messages=\"form.enroleDate.$error\" role=\"alert\"><div\n ng-message=\"required\">Fecha de Alta es requerido</div><div ng-message=\"min\">\nFecha de Alta debe ser a partir de {{minEnroleDate | date}}</div><div ng-message=\"max\">\nFecha de Alta debe ser antes de {{maxEnroleDate | date}}</div><div ng-message=\"mindate\">\nFecha de Alta debe ser a partir de {{minEnroleDate | date}}</div><div ng-message=\"maxdate\">\nFecha de Alta debe ser antes de {{maxEnroleDate | date}}</div></div></md-input-container><md-input-container \nclass=\"md-block date-picker\" flex ng-if=\'F.active.menuAction !== \"especialEdit\"  && F.active.menuName == \"movements\"\'>\n<label>Fecha de Alta</label><md-datepicker ng-disabled=\"F.readMode\" md-hide-icons=\"triangle\" \nmd-current-view=\"{{F.dateView}}\" input-date-miliseconds ng-model=\"movement.data.date\" name=\"enroleDate\" \nclass=\"md-block\" required></md-datepicker><div ng-messages=\"form.enroleDate.$error\" role=\"alert\"><div \nng-message=\"required\">Fecha de Alta es requerido</div></div></md-input-container><md-input-container class=\"md-block\" \nflex flex-gt-xs=\"20\"><label>Sueldo Diario Real</label><input ng-disabled=\"F.readMode\" type=\"number\" step=\"any\" \nname=\"sdr\" min=\".00001\" ng-model=\"employee.data.salary.sdr\" ng-disabled=\"isOnlyFiscal\"><div \nng-messages=\"form.sdr.$error\" role=\"alert\"><div ng-message=\"required\">Sueldo Diario Real es requerido</div></div>\n</md-input-container></div><md-input-container class=\"md-block\" flex><label>Comentarios</label><textarea \nng-disabled=\"F.readMode\" class=\"uppercased\" rows=\"3\" name=\"comments\" ng-model=\"employee.data.comments\" \nmd-maxlength=\"350\" maxlength=\"350\" notdeletespecialcharts=\"true\" ng-model-options=\"{ debounce: F.debounceTime }\">\n</textarea><div ng-messages=\"form.comments.$error\" role=\"alert\"><div ng-message=\"maxlength\">\nComentarios no debe tener más de 350 caracteres</div></div></md-input-container></div>");
$templateCache.put("app/main/employees/forms/loan.html","<div><fieldset ng-disabled=\"!F.addMode\" class=\"noBorder\"><div layout-gt-xs=\"row\" flex><md-autocomplete flex \nclass=\"md-block\" md-min-length=\"2\" md-selected-item=\"employeeSelected\" md-search-text=\"searchQuery\" \nmd-selected-item-change=\"loan.employee=item.$id\" md-item-text=\"item.data.name\" md-delay=\"500\" \nmd-items=\'item in autocompleteListM(searchQuery, \"employees\",[\"data.name\",\"data.nss\"],{\"status\":{\"$ne\":5}})\' \nmd-require-match=\"F.addMode\" md-select-on-match=\"true\" md-match-case-insensitive=\"true\" placeholder=\"Empleado\" \nmd-no-cache=\"true\" md-floating-label=\"Empleado\"><md-item-template><span md-highlight-text=\"searchQuery\">\n{{item.data.nss?item.data.nss+\' - \':\'\'}}{{item.data.name}}</span></md-item-template><md-not-found>No hay registros\n</md-not-found></md-autocomplete><md-input-container class=\"md-block\" flex><label>Nómina</label><input type=\"text\" \nname=\"payroll\" ng-model=\"payroll.data.name\" required readonly=\"true\"><div ng-messages=\"form.payroll.$error\" \nng-show=\"form.payroll.$touched || form.payroll.$dirty\" role=\"alert\"><div ng-message=\"required\">Nomina es requerido\n</div></div></md-input-container></div><div layout-gt-xs=\"row\" flex><md-input-container class=\"md-block date-picker\" \nflex><label>Fecha del préstamo</label><md-datepicker name=\"loanDate\" ng-disabled=\"!allowEditDate\" \nmd-hide-icons=\"triangle\" md-current-view=\"{{F.dateView}}\" input-date-miliseconds ng-model=\"loan.data.date\" name=\"date\" \nmd-min-date=\"minDate\" class=\"md-block\" required></md-datepicker><div ng-messages=\"form.date.$error\" \nng-show=\"form.date.$touched || form.date.$dirty\" role=\"alert\"><div ng-message=\"required\">\nFecha del préstamo es requerido</div><div ng-message=\"min\">Fecha del préstamo debe ser a partir de {{minDate | date}}\n</div><div ng-message=\"mindate\">Fecha del préstamo debe ser a partir de {{minDate | date}}</div></div>\n</md-input-container><md-input-container class=\"md-block evenPadding\" flex><label>Incidencia</label><md-select \nng-model=\"loan.data.incidenceType\" name=\"incidenceType\" required ng-disabled=\"!F.addMode\"><md-select-header><input \nautocomplete=\"off\" type=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"typeSelectFilter\" \nplaceholder=\"Busque una tipo de incidencia\"></md-select-header><md-option ng-value=\"incidencesType.$id\" \nng-repeat=\"incidencesType in allIncidencesTypes |  filter:typeSelectFilter\">{{incidencesType.name | uppercase}}\n</md-option></md-select><div ng-messages=\"form.incidenceType.$error\" \nng-show=\"form.incidenceType.$touched || form.type.$dirty\" role=\"alert\"><div ng-message=\"required\">\nIncidencia del descuento es requerido</div></div></md-input-container><md-input-container class=\"md-block\" flex><label>\nFolio</label><input type=\"text\" name=\"folio\" ng-model=\"loan.data.folio\"></md-input-container></div><div \nlayout-gt-xs=\"row\" flex><md-input-container class=\"md-block\" flex><label>Monto Total</label><input type=\"number\" \nstep=\"any\" name=\"amount\" ng-model=\"loan.data.amount\" ng-model-options=\"{ debounce: F.debounceTime }\" required><div \nng-messages=\"form.factor.$error\" ng-show=\"form.factor.$touched || form.factor.$dirty\" role=\"alert\"><div \nng-message=\"required\">Monto es requerido</div></div></md-input-container><md-input-container class=\"md-block\" flex>\n<label>Monto por periodo</label><input type=\"number\" step=\"any\" name=\"periodAmount\" ng-model=\"loan.data.periodAmount\" \nng-model-options=\"{ debounce: F.debounceTime }\" required><div ng-messages=\"form.periodAmount.$error\" \nng-show=\"form.periodAmount.$touched || form.periodAmount.$dirty\" role=\"alert\"><div ng-message=\"required\">\nMonto por periodo es requerido</div></div></md-input-container><md-input-container ng-if=\"!F.addMode\" flex=\"nogrow\" \nclass=\"md-input-has-placeholder md-block\"><label>Vigente</label><md-switch class=\"md-secondary md-padding\" \nname=\"valid\" ng-change=\"validChange(loan.valid)\" ng-false-value=\"0\" arial-label=\"loan switch\" ng-model=\"loan.valid\">\n</md-switch></md-input-container></div><md-input-container class=\"md-block\" flex><label>Comentarios</label><textarea \nclass=\"uppercased\" rows=\"1\" name=\"comments\" ng-model=\"loan.data.comments\" md-maxlength=\"150\" maxlength=\"150\" \nng-model-options=\"{ debounce: F.debounceTime }\">\r\n        </textarea><div ng-messages=\"form.comments.$error\" \nng-show=\"form.comments.$touched || form.comments.$dirty\" role=\"alert\"><div ng-message=\"maxlength\">\nComentarios no debe tener más de 150 caracteres</div></div></md-input-container></fieldset><div layout=\"column\" flex>\n<md-table-container layout=\"column\" flex><table md-table flex><thead md-head md-order=\"order\"><tr md-row><th md-column>\nA&ntilde;o</th><th md-column>Periodo</th><th md-column>Fecha</th><th md-column>Monto</th><th md-column>Status</th><th \nmd-column>Comentario</th></tr></thead><tbody md-body><tr md-row md-select=\"incidence\" md-select-id=\"incidence.$id\" \nmd-auto-select ng-repeat=\"incidence in thisIncidences|orderBy:[\'calendar\',\'period\']\"><td md-cell>{{incidence.calendar}}\n</td><td md-cell>{{incidence.period}}</td><td md-cell \nng-click=\"(incidence.status<3&&incidence.status>-1)?editDate($event, incidence, thisIncidences):\'\'\">\n{{incidence.date|date:F.dateFormat}}</td><td md-cell>{{incidence.value}}</td><td md-cell>\n{{incidence.status | incidenceStatusName}}<md-button ng-if=\"incidence.status<3&&incidence.status>-1\" \nng-click=\"cancelIncidence(incidence)\" class=\"md-icon-button md-primary\" aria-label=\"Cancel Incidence\"><md-icon \nmd-font-icon=\"icon-cancel\" aria-label=\"cancel icon\"></md-icon></md-button></td><td md-cell \nng-click=\"(incidence.status<3&&incidence.status>-1)?editComment($event, incidence, thisIncidences):\'\'\" \nng-class=\"{\'md-placeholder\': !incidence.comments}\"><p ng-if=\"incidence.comments\">{{incidence.comments}}</p><p \nng-if=\"!incidence.comments&&incidence.status>-1&& incidence.status<3\">Agrega un comentario</p></td></tr></tbody>\n</table></md-table-container></div></div>");
$templateCache.put("app/main/employees/forms/location.html","<div><div layout-gt-xs=\"row\" layout-wrap><md-autocomplete flex-xs=\"100\" flex=\"25\" \nmd-items=\"item in autocompleteListM(F.searchCp,\'zipCodes\',[\'cp\',\'neighborhood\'])\" md-search-text=\"F.searchCp\" \nmd-selected-item=\"F.selectedCp\" md-selected-item-change=\"cpSelected(F.selectedCp)\" md-item-text=\"item.cp\" \nmd-no-cache=\"true\" md-min-length=\"4\" md-menu-class=\"autocomplete-zp-template\" md-input-name=\"autocompleteField\" \nmd-floating-label=\"Codigo Postal\" md-input-maxlength=\"5\" md-input-minlength=\"5\" md-escape-options=\"clear\">\n<md-item-template><span class=\"item-title\"><span><strong>{{item.cp}}</strong> <em>{{item.name}}</em></span> </span>\n<span class=\"item-metadata\"><small>{{item.town}} - {{item.stateKey}}</small></span></md-item-template><div \nng-messages=\"form.autocompleteField.$error\" ng-if=\"form.autocompleteField.$touched\"><div ng-message=\"md-require-match\">\nSeleccione un código postal de la lista.</div></div></md-autocomplete><md-input-container flex-xs=\"100\" flex=\"25\" \nclass=\"md-block evenPadding\"><label>Estado</label><md-select ng-model=\"employee.data.info.residence.state\" \nname=\"state\" ng-model-options=\"{ debounce: F.debounceTime }\" ng-disabled=\"true\"><md-select-header><input \nautocomplete=\"off\" type=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"stateSelectFilter\" \nplaceholder=\"Busque un estado\"></md-select-header><md-option ng-value=\"state._id\" \nng-repeat=\"state in M.states | orderBy:\'name\' | filter:stateSelectFilter\">{{state.name}}</md-option></md-select><div \nng-messages=\"form.state.$error\" ng-show=\"form.state.$touched || form.state.$dirty\" role=\"alert\"></div>\n</md-input-container><md-input-container flex-xs=\"100\" flex=\"25\" class=\"md-block evenPadding\"><label>Municipio</label>\n<md-select ng-model=\"employee.data.info.residence.town\" name=\"town\" ng-disabled=\"true\"><md-select-header><input \nautocomplete=\"off\" type=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"townSelectFilter\" \nplaceholder=\"Busque un municipio\"></md-select-header><md-option ng-value=\"town._id\" \nng-repeat=\"town in M.towns | orderBy:\'name\' | filter:townSelectFilter\">{{town.name}}</md-option></md-select><div \nng-messages=\"form.town.$error\" ng-show=\"form.town.$touched || form.town.$dirty\" role=\"alert\"></div>\n</md-input-container><md-input-container flex-xs=\"100\" flex=\"25\" class=\"md-block\"><label>Localidad</label><input \nng-disabled=\"true\" class=\"uppercased\" type=\"text\" name=\"neighborhood\" \nng-model=\"employee.data.info.residence.address.neighborhood\"><div ng-messages=\"form.neighborhood.$error\" \nng-show=\"form.neighborhood.$touched || form.neighborhood.$dirty\" role=\"alert\"></div></md-input-container>\n<md-input-container flex-xs=\"100\" flex=\"25\" class=\"md-block evenPadding\"><label>Tipo de vía</label><md-select \nname=\"streetType\" ng-model=\"employee.data.info.residence.address.streetType\" ng-disabled=\"F.readMode\">\n<md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" \nng-model=\"streetTypeSelectFilter\" placeholder=\"Busque un tipo de calle\"></md-select-header><md-option \nng-value=\"streetType._id\" ng-repeat=\"streetType in M.streetTypes | orderBy:\'name\' | filter:streetTypeSelectFilter\">\n{{streetType.name}}</md-option></md-select><div ng-messages=\"form.streetType.$error\" \nng-show=\"form.streetType.$touched || form.streetType.$dirty\" role=\"alert\"></div></md-input-container>\n<md-input-container flex-xs=\"100\" flex=\"25\" class=\"md-block\"><label>Calle</label><input ng-disabled=\"F.readMode\" \nclass=\"uppercased\" type=\"text\" name=\"street\" ng-model=\"employee.data.info.residence.address.street\" md-maxlength=\"30\" \nmaxlength=\"30\" ng-model-options=\"{ debounce: F.debounceTime }\"><div ng-messages=\"form.street.$error\" \nng-show=\"form.street.$touched || form.street.$dirty\" role=\"alert\"><div ng-message=\"maxlength\">\nCalle no debe tener más de 24 caracteres</div></div></md-input-container><md-input-container flex-xs=\"100\" flex=\"25\" \nclass=\"md-block\"><label>Fraccionamiento</label><input ng-disabled=\"F.readMode\" class=\"uppercased\" type=\"text\" \nname=\"houseDevelop\" ng-model=\"employee.data.info.residence.houseDevelop\" md-maxlength=\"24\" maxlength=\"24\" \nng-model-options=\"{ debounce: F.debounceTime }\"><div ng-messages=\"form.houseDevelop.$error\" \nng-show=\"form.houseDevelop.$touched || form.houseDevelop.$dirty\" role=\"alert\"><div ng-message=\"maxlength\">\nFraccionamiento no debe tener más de 24 caracteres</div></div></md-input-container><md-input-container flex-xs=\"100\" \nflex=\"25\" class=\"md-block\"><label>No. Exterior</label><input ng-disabled=\"F.readMode\" class=\"uppercased\" type=\"text\" \nname=\"externalNumber\" ng-model=\"employee.data.info.residence.address.externalNumber\" md-maxlength=\"12\" maxlength=\"12\" \nng-model-options=\"{ debounce: F.debounceTime }\"><div ng-messages=\"form.externalNumber.$error\" \nng-show=\"form.externalNumber.$touched || form.externalNumber.$dirty\" role=\"alert\"><div ng-message=\"maxlength\">\nNo. Exterior no debe tener más de 7 caracteres</div></div></md-input-container><md-input-container flex-xs=\"100\" \nflex=\"25\" class=\"md-block\"><label>No. Interior</label><input ng-disabled=\"F.readMode\" class=\"uppercased\" type=\"text\" \nname=\"internalNumber\" md-maxlength=\"12\" maxlength=\"12\" ng-model=\"employee.data.info.residence.address.internalNumber\" \nng-model-options=\"{ debounce: F.debounceTime }\"><div ng-messages=\"form.internalNumber.$error\" \nng-show=\"form.internalNumber.$touched || form.internalNumber.$dirty\" role=\"alert\"><div ng-message=\"maxlength\">\nNo. Interior no debe tener más de 7 caracteres</div></div></md-input-container><md-input-container flex-xs=\"100\" \nflex=\"75\" class=\"md-block\"><label>Referencia</label><input ng-disabled=\"F.readMode\" class=\"uppercased\" type=\"text\" \nname=\"reference\" md-maxlength=\"50\" maxlength=\"50\" ng-model=\"employee.data.info.residence.address.reference\" \nng-model-options=\"{ debounce: F.debounceTime }\"><div ng-messages=\"form.reference.$error\" \nng-show=\"form.reference.$touched || form.reference.$dirty\" role=\"alert\"><div ng-message=\"maxlength\">\nReferencia no debe tener más de 50 caracteres</div></div></md-input-container></div></div>");
$templateCache.put("app/main/employees/forms/mds.html","<div flex><div ng-show=\"false\" \nng-if=\"F.active.menuAction!==\'especialEdit\' && F.active.menuName!==\'mdsRecords\' && F.active.menuAction!==\'update\' && F.active.menuAction!==\'createHistoricMovement\'\">\n<input name=\"geoZone\" ng-model=\"geoZone.name\" required></div><div layout-gt-xs=\"row\" flex \nng-if=\'F.active.menuAction !== \"especialEdit\" && F.active.menuName!==\"movements\"\'><md-input-container \nclass=\"md-block evenPadding\" flex><label>Nómina</label><md-select ng-model=\"employee.payroll\" name=\"payroll\" \ndisabled=\"disabled\"><md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" \nng-keydown=\"$event.stopPropagation()\" ng-model=\"payrollSelectFilter\" placeholder=\"Busque una nómina\">\n</md-select-header><md-option ng-if=\"!F.permissionToAccessAllPayrolls\" ng-value=\"payroll.$id\" \nng-repeat=\"payroll in L.payrolls | orderBy:\'name\' | filter:payrollSelectFilter\">{{payroll.name}}</md-option><md-option \nng-if=\"F.permissionToAccessAllPayrolls\" ng-value=\"payroll.$id\" \nng-repeat=\"payroll in L.allPayrolls | orderBy:\'name\' | filter:payrollSelectFilter\">{{payroll.name}}</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block\" flex><label>Nombre</label><input type=\"text\" \nng-model=\"employee.data.name\" disabled=\"disabled\"></md-input-container><md-input-container \nclass=\"md-block date-picker\" flex><label>Fecha de Alta en IMSS</label><md-datepicker md-hide-icons=\"triangle\" \nng-model=\"employee.data.enroleDate\" input-date-miliseconds class=\"md-block\" disabled=\"disabled\"></md-datepicker>\n</md-input-container></div><div layout-gt-xs=\"row\" flex ng-if=\'F.active.menuAction !== \"especialEdit\"\'>\n<md-input-container class=\"md-block date-picker\" flex ng-if=\'F.active.menuAction == \"createHistoricMovement\"\'><label>\nFecha de MDS</label><md-datepicker md-hide-icons=\"triangle\" md-current-view=\"{{F.dateView}}\" input-date-miliseconds \nrequired md-max-date=\"maxDate\" ng-model=\"movement.data.date\" name=\"date\" ng-disabled=\"F.readMode\" class=\"md-block\">\n</md-datepicker><div ng-messages=\"form.date.$error\" ng-show=\"form.date.$touched || form.date.$dirty\" role=\"alert\"><div \nng-message=\"required\">Fecha de MDS es requerido</div><div ng-message=\"maxdate\">\nFecha de MDS debe ser antes de {{maxDate | date}}</div></div></md-input-container><md-input-container \nclass=\"md-block date-picker\" flex \nng-if=\'F.active.menuAction !== \"especialEdit\" && F.active.menuAction !== \"createHistoricMovement\"\'><label>Fecha de MDS\n</label><md-datepicker md-hide-icons=\"triangle\" md-current-view=\"{{F.dateView}}\" md-min-date=\"minMovementDate\" \nmd-max-date=\"maxMdsDate\" input-date-miliseconds required ng-model=\"movement.data.date\" ng-disabled=\"F.readMode\" \nname=\"date\" class=\"md-block\"></md-datepicker><div ng-messages=\"form.date.$error\" \nng-show=\"form.date.$touched || form.date.$dirty\" role=\"alert\"><div ng-message=\"required\">Fecha de MDS es requerido\n</div><div ng-message=\"min\">Fecha de MDS debe ser a partir de {{minMovementDate | date}}</div><div \nng-message=\"mindate\">Fecha de MDS debe ser a partir de {{minMovementDate | date}}</div><div ng-message=\"max\">\nFecha de MDS debe ser antes de {{maxMdsDate | date}}</div><div ng-message=\"maxdate\">\nFecha de MDS debe ser antes de {{maxMdsDate | date}}</div></div></md-input-container><md-input-container \nclass=\"md-block\" flex ng-if=\'[\"especialEdit\",\"createHistoricMovement\"].indexOf(F.active.menuAction) == -1\'><label \nng-if=\"movement.data.onlySd\">\nSD - SMAG [{{minimumWage}}]{{lastSd ? (\', último SD: \') + lastSd : \'\'}}, tope:{{maxSdOfLastSbc}}</label><label \nng-if=\"!movement.data.onlySd\">SD - SMAG [{{minimumWage}}]{{lastSd ? (\', último SD: \') + lastSd : \'\'}}</label><input \ntype=\"number\" step=\"any\" ng-min=\"minimumSd\" ng-max=\"movement.data.onlySd?maxSdOfLastSbc:undefined\" name=\"sd\" \nng-model=\"movement.data.sd\" ng-disabled=\"F.readMode\" required ng-model-options=\"{ debounce: F.debounceTime }\"><div \nng-messages=\"form.sd.$error\" ng-show=\"form.sd.$touched || form.sd.$dirty\" role=\"alert\"><div ng-message=\"required\">\nSueldo Diario es requerido</div><div ng-message=\"min\">Sueldo no puede ser menor al mínimo: {{minimumSd}}</div><div \nng-message=\"max\">SBC no puede ser menor a la integración mínima de ley</div></div></md-input-container>\n<md-input-container class=\"md-block\" flex ng-if=\'[\"createHistoricMovement\"].indexOf(F.active.menuAction) > -1\'><label>\nSD</label><input type=\"number\" step=\"any\" name=\"sd\" ng-model=\"movement.data.sd\" ng-disabled=\"F.readMode\" required><div \nng-messages=\"form.sd.$error\" ng-show=\"form.sd.$touched || form.sd.$dirty\" role=\"alert\"><div ng-message=\"required\">\nSueldo Diario es requerido</div></div></md-input-container><md-input-container class=\"md-block\" flex \nng-if=\'F.active.menuAction !== \"especialEdit\" && !movement.data.onlySd && F.active.menuAction != \"createHistoricMovement\" && !F.readMode\'>\n<label>SBC - SDI [{{minimumSbc}}]{{lastSbc ? (\', último SBC: \') + lastSbc : \'\'}}</label><input sbc-consistency \nng-min=\"minimumSbc\" sd=\"movement.data.sd\" validator=\"minMaxValidations\" type=\"number\" step=\"any\" name=\"sbc\" \nround-number=\"2\" ng-change=\"validateSbc()\" ng-model=\"movement.data.sbc\" \nng-model-options=\"{ debounce: F.debounceTime }\" required><div ng-messages=\"form.sbc.$error\" \nng-show=\"form.sbc.$touched || form.sbc.$dirty\" role=\"alert\"><div ng-message=\"required\">\nSueldo Base Cotización es requerido</div><div ng-message=\"min\">Sueldo Base Cotización debe ser al menos {{minimumSbc}}\n</div></div></md-input-container><md-input-container class=\"md-block\" flex \nng-if=\'F.active.menuAction !== \"especialEdit\" && (movement.data.onlySd || F.active.menuAction == \"createHistoricMovement\" || F.readMode)\'>\n<label>SBC</label><input ng-min=\"minimumSbc\" type=\"number\" step=\"any\" name=\"sbc\" round-number=\"2\" \nng-model=\"movement.data.sbc\" ng-disabled=\"F.readMode || movement.data.onlySd\" \nng-required=\'F.active.menuAction == \"createHistoricMovement\"\' ng-readonly=\"F.readMode || movement.data.onlySd\">\n</md-input-container></div><md-input-container class=\"md-block\" flex ng-if=\"!movement.data.aniversary\"><md-checkbox \nname=\"tos\" ng-model=\"movement.data.onlySd\" \nng-change=\"movement.data.onlySd?movement.data.sbc=minMaxValidations.lastSbc:null\" ng-disabled=\"F.readMode\" \nng-false-value=\"false\">Solo actualizar SD<md-tooltip>\nAplica cuando el incremento solo es en el salario diario, no incrementa el salario base cotizacion, no se envia el movimiento a IDSE\n</md-tooltip></md-checkbox></md-input-container><md-input-container class=\"md-block\" flex><label>Comentarios</label>\n<textarea class=\"uppercased\" name=\"comments\" ng-model=\"movement.data.comments\" md-maxlength=\"350\" maxlength=\"350\" \nng-disabled=\"F.readMode\" ng-model-options=\"{ debounce: F.debounceTime }\"></textarea><div \nng-messages=\"form.comments.$error\" ng-show=\"form.comments.$touched || form.comments.$dirty\" role=\"alert\"><div \nng-message=\"maxlength\">Comentarios no debe tener más de 350 caracteres</div></div></md-input-container></div>");
$templateCache.put("app/main/employees/forms/revision-enrole.html","<div layout-gt-xs=\"row\" flex><md-input-container class=\"md-block\" flex><label>UMF</label><input type=\"text\" name=\"umf\" \nclass=\"zerofilled\" charts=\"3\" ng-model=\"employee.data.health.umf\" ng-model-options=\"{ debounce: F.debounceTime }\" \npattern=\"([0-9]{3})\" md-maxlength=\"3\" maxlength=\"3\" md-minlength=\"3\" minlength=\"3\" \nng-disabled=\"L.rpCcs[employee.rp].rp==0 || employee.data.nss===\'00000000000\'\" \nng-required=\"L.rpCcs[employee.rp].rp!=0 &&  employee.data.nss!==\'00000000000\'\"><div ng-messages=\"form.umf.$error\" \nng-show=\"form.umf.$touched || form.umf.$dirty\" role=\"alert\"><div ng-message=\"required\">UMF es requerido</div><div \nng-message=\"pattern\">UMF debe tener [3] números del (0-9)</div></div></md-input-container><md-input-container \nclass=\"md-block date-picker\" flex><label>Fecha de Alta</label><md-datepicker md-hide-icons=\"triangle\" \nmd-current-view=\"{{F.dateView}}\" md-min-date=\"minEnroleDate\" md-max-date=\"maxEnroleDate\" input-date-miliseconds \nng-model=\"employee.data.enroleDate\" name=\"enroleDate\" class=\"md-block\" required></md-datepicker><div \nng-messages=\"form.enroleDate.$error\" ng-show=\"form.enroleDate.$touched || form.enroleDate.$dirty\" role=\"alert\"><div \nng-message=\"required\">Fecha de Alta es requerido</div><div ng-message=\"min\">\nFecha de Alta debe ser a partir de {{minEnroleDate | date}}</div><div ng-message=\"max\">\nFecha de Alta debe ser antes de {{maxEnroleDate | date}}</div><div ng-message=\"mindate\">\nFecha de Alta debe ser a partir de {{minEnroleDate | date}}</div><div ng-message=\"maxdate\">\nFecha de Alta debe ser antes de {{maxEnroleDate | date}}</div></div></md-input-container></div>");
$templateCache.put("app/main/employees/forms/salaries.html","<div layout-gt-xs=\"row\" flex><input type=\"hidden\" name=\"minDatesValidation\" ng-model=\"employee.cc\"> <input \ntype=\"hidden\" name=\"minSalariesValidation\" ng-model=\"employee.rp\"><md-input-container class=\"md-block\" flex><label>\nSueldo Diario Real</label><input type=\"number\" step=\"any\" name=\"sdr\" min=\".00001\" ng-model=\"employee.data.salary.sdr\" \nng-disabled=\"isOnlyFiscal\"><div ng-messages=\"form.sdr.$error\" ng-show=\"form.sdr.$touched || form.sdr.$dirty\" \nrole=\"alert\"><div ng-message=\"required\">Sueldo Diario Real es requerido</div></div></md-input-container>\n<md-input-container class=\"md-block\" flex \nng-if=\'F.active.menuAction !== \"especialEdit\" && !(F.readMode) && F.active.menuItem != \"movements.movements\"\'><label>\nSD - SMAG [{{minimumWage}}]{{lastSd ? (\', último SD: \') + lastSd : \'\'}}</label><input type=\"number\" step=\"any\" \nname=\"sd\" ng-model=\"movement.data.sd\" ng-min=\"minimumSd\" \nng-disabled=\"!fiscalMovement || isUndefined(employee.hasSeniorityDate) || isUndefined(employee.customBenefits)\" \nng-required=\'fiscalMovement && employee.data.nss!==\"00000000000\"\' ng-model-options=\"{ debounce: F.debounceTime }\"><div \nng-messages=\"form.sd.$error\" ng-show=\"form.sd.$touched || form.sd.$dirty\" role=\"alert\"><div ng-message=\"required\">\nSueldo Diario es requerido</div><div ng-message=\"min\">Sueldo no puede ser menor al salario mínimo: {{minimumWage}}\n</div></div></md-input-container><md-input-container class=\"md-block\" flex \nng-if=\'F.active.menuAction == \"especialEdit\" || F.readMode || F.active.menuItem == \"movements.movements\"\'><label>\nSD - SMAG [{{minimumWage}}]{{lastSd ? (\', último SD: \') + lastSd : \'\'}}</label><input type=\"number\" step=\"any\" \nname=\"sd\" ng-model=\"movement.data.sd\" \nng-disabled=\"!fiscalMovement || isUndefined(employee.hasSeniorityDate) || isUndefined(employee.customBenefits)\" \nng-required=\'fiscalMovement && F.active.menuAction != \"especialEdit\" && employee.data.nss!==\"00000000000\"\' \nng-model-options=\"{ debounce: F.debounceTime }\"><div ng-messages=\"form.sd.$error\" \nng-show=\"form.sd.$touched || form.sd.$dirty\" role=\"alert\"><div ng-message=\"required\">Sueldo Diario es requerido</div>\n</div></md-input-container><md-input-container class=\"md-block\" flex \nng-if=\'F.active.menuAction !== \"especialEdit\" && !(F.readMode) && F.active.menuItem != \"movements.movements\"\'><label>\nSBC - SDI [{{minimumSbc}}]{{lastSbc ? (\', último SBC: \') + lastSbc : \'\'}}</label><input sbc-consistency \nsd=\"movement.data.sd\" validator=\"minMaxValidations\" type=\"number\" step=\"any\" round-number=\"2\" name=\"sbc\" \nng-model=\"movement.data.sbc\" ng-min=\"fiscalMovement?minimumSbc:null\" ng-disabled=\"!fiscalMovement\" \nng-required=\'fiscalMovement && employee.data.nss!==\"00000000000\"\' ng-model-options=\"{ debounce: F.debounceTime }\"><div \nng-messages=\"form.sbc.$error\" ng-show=\"form.sbc.$touched || form.sbc.$dirty\" role=\"alert\"><div ng-message=\"required\">\nSueldo Base Cotización es requerido</div><div ng-message=\"min\">\nSueldo Base Cotización no puede ser menor a: {{minimumSbc}}</div></div></md-input-container><md-input-container \nclass=\"md-block\" flex \nng-if=\'F.active.menuAction == \"especialEdit\" || F.readMode || F.active.menuItem == \"movements.movements\"\'><label>\nSBC - SDI [{{minimumSbc}}]{{lastSbc ? (\', último SBC: \') + lastSbc : \'\'}}</label><input type=\"number\" step=\"any\" \nname=\"sbc\" round-number=\"2\" ng-model=\"movement.data.sbc\" ng-disabled=\"!fiscalMovement\" \nng-required=\'fiscalMovement && F.active.menuAction != \"especialEdit\" && employee.data.nss!==\"00000000000\"\' \nng-model-options=\"{ debounce: F.debounceTime }\"><div ng-messages=\"form.sbc.$error\" \nng-show=\"form.sbc.$touched || form.sbc.$dirty\" role=\"alert\"><div ng-message=\"required\">\nSueldo Base Cotización es requerido</div></div></md-input-container></div>");
$templateCache.put("app/main/employees/forms/sat.html","<div><md-input-container class=\"md-block\" flex ng-if=\'F.active.menuAction !== \"especialEdit\" && !fiscalMovement\'>\n<label>RFC</label><input ng-disabled=\"F.readMode\" class=\"uppercased\" rfc \nignore-format=\"{{employee.ignoreValidation.rfcFormat}}\" consistency=\"employee\" unique-mongo-v2 catalog=\"employees\" \nincludecenter=\"true\" ignorevalidationpath=\"uniqueRfc\" field=\"data.rfc\" fromid=\"{{employee.$id}}\" rfc-consistency \nignore-consistency=\"{{employee.ignoreValidation.rfcConsistency}}\" type=\"text\" name=\"rfc\" ng-model=\"employee.data.rfc\" \nmaxlength=\"13\" md-maxlength=\"13\" required><div ng-messages=\"form.rfc.$error\" role=\"alert\"><div ng-message=\"rfc\">\nRFC no tiene un formato válido</div><div ng-message=\"consistency\">RFC no coincide con Fecha de Nacimiento o con CURP\n</div><div ng-message=\"required\">RFC es requerido</div><div ng-message=\"unique\">RFC ya está registrado</div></div>\n</md-input-container><md-input-container class=\"md-block\" flex \nng-if=\'F.active.menuAction !== \"especialEdit\" && fiscalMovement\'><label>RFC</label><input ng-disabled=\"F.readMode\" \nclass=\"uppercased\" rfc ignore-format=\"{{employee.ignoreValidation.rfcFormat}}\" consistency=\"employee\" rfc-consistency \nignore-consistency=\"{{employee.ignoreValidation.rfcConsistency}}\" unique-mongo-v2 catalog=\"employees\" \nincludecenter=\"true\" ignorevalidationpath=\"uniqueRfc\" field=\"data.rfc\" \nignore-unique=\"{{employee.ignoreValidation.uniqueRfc}}\" ref=\"catalogs/employees/collection\" \nng-change=\"validateRfc(employee.data.rfc)\" fromid=\"{{employee.$id}}\" type=\"text\" name=\"rfc\" \nandfilter=\'{\"data.nss\":\"function:!isEmpty\"}\' ng-model=\"employee.data.rfc\" maxlength=\"13\" md-maxlength=\"13\" required>\n<div ng-messages=\"form.rfc.$error\" role=\"alert\"><div ng-message=\"rfc\">RFC no tiene un formato válido</div><div \nng-message=\"consistency\">RFC no coincide con Fecha de Nacimiento o con CURP</div><div ng-message=\"required\">\nRFC es requerido</div><div ng-message=\"unique\">RFC ya está registrado</div></div></md-input-container>\n<md-input-container class=\"md-block\" flex ng-if=\'F.active.menuAction == \"especialEdit\" && fiscalMovement\'><label>RFC\n</label><input ng-disabled=\"F.readMode\" class=\"uppercased\" ng-change=\"validateRfc(employee.data.rfc)\" rfc \nunique-mongo-v2 catalog=\"employees\" includecenter=\"true\" ignorevalidationpath=\"uniqueRfc\" field=\"data.rfc\" unique-fb \nignore-unique=\"{{employee.ignoreValidation.uniqueRfc}}\" ignore-format=\"{{employee.ignoreValidation.rfcFormat}}\" \nref=\"catalogs/employees/collection\" fromid=\"{{employee.$id}}\" type=\"text\" name=\"rfc\" \nandfilter=\'{\"data.nss\":\"function:!isEmpty\"}\' ng-model=\"employee.data.rfc\" maxlength=\"13\" md-maxlength=\"13\" required>\n<div ng-messages=\"form.rfc.$error\" role=\"alert\"><div ng-message=\"rfc\">RFC no tiene un formato válido</div><div \nng-message=\"consistency\">RFC no coincide con Fecha de Nacimiento o con CURP</div><div ng-message=\"required\">\nRFC es requerido</div><div ng-message=\"unique\">RFC ya está registrado</div></div></md-input-container>\n<md-input-container class=\"md-block\" flex ng-if=\'F.active.menuAction == \"especialEdit\" && !fiscalMovement\'><label>RFC\n</label><input ng-disabled=\"F.readMode\" class=\"uppercased\" rfc type=\"text\" name=\"rfc\" \nignore-format=\"{{employee.ignoreValidation.rfcFormat}}\" ng-model=\"employee.data.rfc\" \nng-change=\"validateRfc(employee.data.rfc)\" maxlength=\"13\" md-maxlength=\"13\" required><div \nng-messages=\"form.rfc.$error\" role=\"alert\"><div ng-message=\"rfc\">RFC no tiene un formato válido</div><div \nng-message=\"consistency\">RFC no coincide con Fecha de Nacimiento o con CURP</div><div ng-message=\"required\">\nRFC es requerido</div><div ng-message=\"unique\">RFC ya está registrado</div></div></md-input-container>\n<md-input-container class=\"md-block\" flex ng-if=\'F.active.menuAction !== \"especialEdit\" && !fiscalMovement\'><label>\nCP Sat</label><input type=\"text\" name=\"zipCodeSat\" ng-model=\"employee.data.zpCodeSat\" pattern=\"([0-9]{5})\" \nmd-maxlength=\"5\" maxlength=\"5\" ng-required=\"fiscalMovement\"><div ng-messages=\"form.zipCodeSat.$error\" \nng-show=\"form.zipCodeSat.$touched || form.zipCodeSat.$dirty\" role=\"alert\"><div ng-message=\"required\">CP es requerido\n</div><div ng-message=\"pattern\">CP debe tener [5] números del (0-9)</div></div></md-input-container><md-input-container\n class=\"md-block\" flex ng-if=\'F.active.menuAction !== \"especialEdit\" && fiscalMovement\'><label>CP Sat</label><input \nng-disabled=\"F.readMode || (!employee.data.rfc || !employee.data.info.names || (!employee.data.info.paternalSurname && !employee.data.info.maternalSurname))\" \ntype=\"text\" name=\"zipCodeSat\" ng-model=\"employee.data.zpCodeSat\" ng-change=\"validarRfc2()\" pattern=\"([0-9]{5})\" \nmd-maxlength=\"5\" maxlength=\"5\" ng-required=\"fiscalMovement\"><div ng-messages=\"form.zipCodeSat.$error\" \nng-show=\"form.zipCodeSat.$touched || form.zipCodeSat.$dirty\" role=\"alert\"><div ng-message=\"required\">CP es requerido\n</div><div ng-message=\"pattern\">CP debe tener [5] números del (0-9)</div></div></md-input-container><md-input-container\n class=\"md-block\" flex><label>Nombre del empleado en sat</label><input ng-disabled=\"F.readMode\" type=\"text\" \nname=\"satName\" ng-model=\"employee.data.satName\"></md-input-container><md-input-container class=\"md-block\" flex><label>\nRegimen</label><input ng-disabled=\"F.readMode\" type=\"text\" name=\"regimenSat\" ng-model=\"employee.data.regimenSat\">\n</md-input-container><md-input-container class=\"md-block\" flex><label>Ultima fecha de actualización</label><input \nng-disabled=\"F.readMode\" type=\"text\" name=\"updated\" ng-model=\"employee.data.lastTimeUpdated\"></md-input-container>\n</div>");
$templateCache.put("app/main/employees/forms/special-movement.html","<div><div layout-gt-xs=\"row\" flex><md-input-container class=\"md-block evenPadding\" flex-gt-xs=\"50\" \nng-if=\'F.active.menuName != \"idseAutoRecords\"\'><label>Status</label><md-select class=\"filter\" \nng-model=\"movement.status\" name=\"status\" placeholder=\"Status\" \nng-disabled=\"(movement.status==4 && !editArchived) || movement.$id!==employee.movement.uid\" required><md-option \nng-if=\"status.id<5\" ng-value=\"status.id\" \nng-repeat=\"status in F.employeeStatatuss | orderBy:\'id\' | filter:statusSelectFilter\">{{status.id}} : {{status.name}}\n</md-option></md-select><div ng-messages=\"form.status.$error\" ng-show=\"form.status.$touched || form.status.$dirty\" \nrole=\"alert\"><div ng-message=\"required\">Status es requerido</div></div></md-input-container><md-input-container \nclass=\"md-block evenPadding\" flex-gt-xs=\"50\"><label>Tipo de Movimiento</label><md-select name=\"movementType\" \nclass=\"filter\" ng-model=\"movement.data.type\" placeholder=\"Tipo de movimiento\" disabled=\"true\" required><md-option \nng-value=\"movementType.id\" \nng-repeat=\"movementType in F.movementTypes | orderBy:\'name\' | filter:movementTypeSelectFilter\">{{movementType.name}}\n</md-option></md-select></md-input-container><md-input-container class=\"md-block date-picker\" flex-gt-xs=\"50\" \nng-if=\'F.active.menuName==\"movements\" && [6,8].indexOf(movement.data.type)>-1\'><label>Fecha de Movimiento</label>\n<md-datepicker ng-disabled=\"F.readMode\" md-hide-icons=\"triangle\" md-current-view=\"{{F.dateView}}\" \ninput-date-miliseconds required ng-model=\"movement.data.date\" name=\"movementDate\"></md-datepicker><div \nng-messages=\"form.movementDate.$error\" ng-show=\"form.movementDate.$touched || form.movementDate.$dirty\" role=\"alert\">\n</div></md-input-container></div><div layout-gt-xs=\"row\" flex><md-input-container class=\"md-block evenPadding\" \nflex-gt-xs=\"50\" ng-if=\"movement.status >= 3\"><label>Lote</label><input type=\"text\" \nng-disabled=\'(F.active.menuName!==\"idseAutoRecords\" && F.active.menuAction !== \"especialEdit\") || (movement.status == 4 && !editArchived)\' \nname=\"batch\" ng-model=\"movement.received.batch\"></md-input-container><md-input-container class=\"md-block date-picker\" \nflex-gt-xs=\"50\" ng-if=\"movement.status>= 3\"><label>Fecha de Archivado</label><md-datepicker ng-disabled=\"F.readMode\" \nmd-hide-icons=\"triangle\" md-current-view=\"{{F.dateView}}\" input-date-miliseconds ng-model=\"movement.archived.date\" \nname=\"archivedDate\"></md-datepicker><div ng-messages=\"form.archivedDate.$error\" \nng-show=\"form.archivedDate.$touched || form.archivedDate.$dirty\" role=\"alert\"></div></md-input-container></div><div \nng-if=\"movement.data.type == 2\" form-dismiss></div><div ng-if=\"movement.data.type == 7\" form-mds></div></div>");
$templateCache.put("app/main/employees/forms/special-services.html","<div>{{ L[\"companiesOf-companiesOf-\"+employee.rp]}}<div layout=\"row\" layout-align=\"start center\"><span flex=\"nogrow\">\nPorcentaje de servicios especializados</span><md-button ng-click=\"addSpecialServices()\" \nclass=\"md-primary md-raised md-fab md-mini\" aria-label=\"Add Special Services\" ng-disabled=\"F.readMode\"><md-tooltip \nmd-direction=\"left\">Agregar Porcentaje</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"Add\"></md-icon>\n</md-button></div><div layout=\"column\" layout-gt-xs=\"row\" \nng-repeat=\"($indexs, specialService) in employee.specialServices\"><md-input-container class=\"md-block mb-0 mt-0\" \nmd-no-float flex=\"30\"><md-select name=\"rfc{{$indexs}}\" ng-model=\"specialService.rfc\" ng-disabled=\"F.readMode\" \nplaceholder=\"RFC\" required><md-option ng-disabled=\"alreadyInCompanies(company.rfc,$indexs)\" ng-value=\"company.rfc\" \nng-repeat=\'company in L[\"companiesOf-\"+employee.rp]\'>{{company.rfc}} - {{company.businessName}}</md-option></md-select>\n<div ng-messages=\'form[\"rfc\"+$indexs].$error\' role=\"alert\"><div ng-message=\"required\">RFC es requerido</div></div>\n</md-input-container><div flex layout=\"row\"><md-input-container class=\"md-block mb-0 mt-0\" md-no-float flex-xs=\"20\" \nflex=\"25\"><input name=\"percent{{$indexs}}\" placeholder=\"Porcentaje\" ng-model=\"specialService.percent\" \nng-disabled=\"F.readMode\" type=\"number\" min=\"0\" max=\"100\" step=\"1\" required><div \nng-messages=\'form[\"percent\"+$indexs].$error\' role=\"alert\"><div ng-message=\"required\">Requerido</div><div \nng-message=\"max\">Valor Maximo 100</div><div ng-message=\"min\">Valor Minimo 0</div></div></md-input-container><div flex>\n<md-slider-container><md-slider ng-model=\"specialService.percent\" min=\"0\" max=\"100\" aria-label=\"percent\" \nclass=\"md-accent\"></md-slider></md-slider-container></div></div><div layout=\"nogrow\" layout-align=\"end center\">\n<md-button ng-click=\"removeSpecialService($indexs)\" class=\"md-warn md-raised md-fab md-mini\" \naria-label=\"Remove Special Service\" ng-disabled=\"F.readMode\"><md-tooltip md-direction=\"left\">Eliminar</md-tooltip>\n<md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button></div></div></div>");
$templateCache.put("app/main/employees/forms/worker.html","<div><div layout-gt-xs=\"row\" flex><md-input-container class=\"md-block evenPadding\" flex><label>Tipo de trabajador\n</label><md-select ng-model=\"employee.data.workerType\" name=\"workerType\" ng-change=\"validateWorkerType()\" required \nng-disabled=\"F.readMode\"><md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" \nng-keydown=\"$event.stopPropagation()\" ng-model=\"workerTypeSelectFilter\" placeholder=\"Busque un tipo de trabajador\">\n</md-select-header><md-option ng-value=\"workerType.humansiteCode\" \nng-repeat=\"workerType in M.workerTypes | orderBy:\'name\' | filter:workerTypeSelectFilter\">{{workerType.name}}\n</md-option></md-select><div ng-messages=\"form.workerType.$error\" \nng-show=\"form.workerType.$touched || form.workerType.$dirty\" role=\"alert\"><div ng-message=\"required\">\nTípo de trabajador es requerido</div></div></md-input-container><md-input-container \nng-if=\"F.active.menuName !== \'movements\'\" class=\"md-block evenPadding\" flex><label>Tipo de contrato</label><md-select \nng-model=\"employee.contractType\" ng-change=\"validateContractType()\" name=\"contractType\" ng-disabled=\"F.readMode\">\n<md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" \nng-model=\"contractTypeSelectFilter\" placeholder=\"Busque un contrato\"></md-select-header><md-option value>Ninguno\n</md-option><md-option ng-value=\"contractType._id\" \nng-repeat=\"contractType in contractTypes | orderBy:\'name\' | filter:contractTypeSelectFilter\">{{contractType.name}}\n</md-option></md-select><div ng-messages=\"form.contractType.$error\" \nng-show=\"form.contractType.$touched || form.contractType.$dirty\" role=\"alert\"><div ng-message=\"required\">\nTipo de trabajador es requerido</div></div></md-input-container></div><div layout-gt-xs=\"row\" flex><md-input-container \nclass=\"md-block evenPadding\" flex><label>Jornada</label><md-select ng-model=\"employee.data.workDay\" name=\"workDay\" \nrequired ng-disabled=\"F.readMode\"><md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" \nng-keydown=\"$event.stopPropagation()\" ng-model=\"workDaySelectFilter\" placeholder=\"Busque una jornada\">\n</md-select-header><md-option ng-value=\"workDay.humansiteCode\" \nng-repeat=\"workDay in M.workDays | orderBy:\'name\' | filter:workDaySelectFilter\">{{workDay.name}}</md-option>\n</md-select><div ng-messages=\"form.workDay.$error\" ng-show=\"form.workDay.$touched || form.workDay.$dirty\" role=\"alert\">\n<div ng-message=\"required\">Jornada es requerido</div></div></md-input-container><md-input-container \nclass=\"md-block evenPadding\" flex><label>Tipo de salario</label><md-select ng-model=\"employee.data.salary.type\" \nname=\"salaryType\" required \nng-disabled=\"F.readMode || F.active.menuAction === \'enrole\' || F.active.menuAction === \'reEntry\' || F.active.menuAction === \'review\' \">\n<md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" \nng-model=\"salaryTypeSelectFilter\" placeholder=\"Busque un tipo de salario\"></md-select-header><md-option \nng-value=\"salaryType.humansiteCode\" \nng-repeat=\"salaryType in M.salaryTypes | orderBy:\'name\' | filter:salaryTypeSelectFilter\">{{salaryType.name}}\n</md-option></md-select><div ng-messages=\"form.salaryType.$error\" \nng-show=\"form.salaryType.$touched || form.salaryType.$dirty\" role=\"alert\"><div ng-message=\"required\">\nTípo de salario es requerido</div></div></md-input-container></div></div>");
$templateCache.put("app/main/employees/views/iaModel.html","\\<md-dialog id=\"iaModel\" class=\"rounded-xl shadow-lg\" flex=\"30\" flex-xs=\"100\" flex-sm=\"60\" flex-md=\"45\" flex-lg=\"35\" \nstyle=\"border-radius: 12px; overflow: hidden\"><form name=\"form\" novalidate ng-cloak><md-toolbar class=\"md-primary\" \nstyle=\"background-color: #3f51b5\"><h2 class=\"text-left pl-10\" style=\"color: white; font-weight: 500; font-size: 20px\">\n💬 Inicia una conversación con la IA</h2></md-toolbar><md-dialog-content layout=\"column\"><input type=\"text\" \nautocomplete=\"off\" name=\"text\" class=\"input\" placeholder=\"¿Qué quieres preguntarle?\" ng-model=\"userQuestion\"><div \nng-if=\"aiCtrl.loadingAI\" class=\"mt-10 p-4 text-center\" style=\"margin-top: 5px; font-style: italic; color: #777\">\n🤔 Pensando...</div><div ng-if=\"aiCtrl.aiAnswer\" class=\"rounded bg-gray-100 border mt-10\" \nstyle=\"padding: 5px; border-radius: 8px; background-color: #f5f5f5; border: 1px solid #ddd\"><strong>Respuesta de la IA:\n</strong><div style=\"margin-top: 5px\" ng-bind-html=\"aiCtrl.trustedHtmlAnswer\"></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"end center\" class=\"px-20 pb-10\" style=\"padding: 0 24px 16px 24px\">\n<md-button class=\"md-primary md-raised\" ng-click=\"aiCtrl.sendQuestion(userQuestion)\" \nstyle=\"background-color: #4CAF50; color: white\">Enviar pregunta</md-button><md-button ng-click=\"aiCtrl.cancel()\" \nclass=\"md-warn\">Cancelar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/coming-soon/coming-soon.html","<div id=\"coming-soon\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"coming-soon-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"coming-soon-form\" class=\"md-whiteframe-8dp\"><div class=\"top\"><div\n class=\"logo md-accent-bg\"><span>F</span></div><div class=\"title\" translate=\"COMINGSOON.TITLE\">\nHey! Thank you for checking out our app.</div><div class=\"subtitle\" translate=\"COMINGSOON.SUBTITLE\">\nIt’s not quite ready yet, but we are working hard and it will be ready in approximately:</div><timer \nend-time=\"endTime\" layout=\"row\" layout-wrap><div flex-xs=\"50\"><div class=\"value\">{{days}}</div><div class=\"type\" \ntranslate=\"COMINGSOON.DAYS\">days</div></div><div flex-xs=\"50\"><div class=\"value\">{{hours}}</div><div class=\"type\" \ntranslate=\"COMINGSOON.HOURS\">hours</div></div><div flex-xs=\"50\"><div class=\"value\">{{minutes}}</div><div class=\"type\" \ntranslate=\"COMINGSOON.MINUTES\">minutes</div></div><div flex-xs=\"50\"><div class=\"value\">{{seconds}}</div><div \nclass=\"type\" translate=\"COMINGSOON.SECONDS\">seconds</div></div></timer></div><form><div class=\"message\" \ntranslate=\"COMINGSOON.MESSAGE\">\nIf you would like to be notified when the app is ready, you can subscribe to our e-mail list.</div><md-input-container \nflex md-no-float><input type=\"email\" placeholder=\"Email address\" translate \ntranslate-attr-placeholder=\"COMINGSOON.EMAIL_ADRESS\"></md-input-container><md-button class=\"md-raised md-accent\" \naria-label=\"SUBSCRIBE\" translate=\"COMINGSOON.SUBSCRIBE\" translate-attr-aria-label=\"COMINGSOON.SUBSCRIBE\">SUBSCRIBE\n</md-button></form></div></div></div>");
$templateCache.put("app/main/pages/full-slider/full-slider.html","<div id=\"full-slider\" layout-fill layout=\"column\"><swiper loop=\"true\" autoplay=\"30000\" speed=\"2000\" autoheight=\"true\">\n<slides><slide ng-repeat=\"image in vm.images\"><img ng-src=\"{{image.file}}\" \nstyle=\"min-height: 100vh; object-fit:contain; object-position: center\"></slide></slides></swiper></div>");
$templateCache.put("app/main/pages/maintenance/maintenance.html","<div id=\"maintenance\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"maintenance-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"maintenance-form\" class=\"md-whiteframe-8dp\"><div \nclass=\"logo md-accent-bg\"><span>F</span></div><div class=\"title\" translate=\"MAINTENANCE.TITLE\">\nClosed for scheduled maintenance!</div><div class=\"subtitle\" translate=\"MAINTENANCE.SUBTITLE\">\nWe\'re sorry for the inconvenience.<br>Please check back later.</div></div></div></div>");
$templateCache.put("app/main/pages/profile/profile.html","<div id=\"profile\" class=\"page-layout simple tabbed\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between end\"><div class=\"user-info\" \nlayout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"start center\"><img \nclass=\"profile-image avatar huge\" src=\"assets/images/avatars/katherine.jpg\"><div class=\"name\">Katherine Wilson</div>\n</div><div class=\"actions\" layout=\"row\" layout-align=\"end center\"><md-button class=\"md-raised md-accent\" \naria-label=\"Follow\" translate=\"PROFILE.FOLLOW\" translate-attr-aria-label=\"PROFILE.FOLLOW\">Follow</md-button><md-button \nclass=\"md-raised md-primary\" translate=\"PROFILE.SEND_MESSAGE\" translate-attr-aria-label=\"PROFILE.SEND_MESSAGE\">\nSend Message</md-button></div></div><div class=\"content\" flex><md-tabs md-dynamic-height><md-tab><md-tab-label><span \ntranslate=\"PROFILE.TIMELINE\">Timeline</span></md-tab-label><md-tab-body><md-content class=\"timeline-tab\" \nng-include=\"\'app/main/pages/profile/tabs/timeline/timeline.html\'\"></md-content></md-tab-body></md-tab><md-tab>\n<md-tab-label><span translate=\"PROFILE.ABOUT\">About</span></md-tab-label><md-tab-body><md-content class=\"about-tab\" \nng-include=\"\'app/main/pages/profile/tabs/about/about.html\'\"></md-content></md-tab-body></md-tab><md-tab><md-tab-label>\n<span translate=\"PROFILE.PHOTOS_VIDEOS\">Photos & Videos</span></md-tab-label><md-tab-body><md-content \nclass=\"photos-videos-tab\" ng-include=\"\'app/main/pages/profile/tabs/photos-videos/photos-videos.html\'\"></md-content>\n</md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/quick-panel/tabs/chat/chat-tab.html","<div class=\"main\" ng-hide=\"chatActive\"><md-list class=\"recent md-dense\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.RECENT\">Recent</span></md-subheader><md-list-item ng-show=\"!contact.archived\" \nclass=\"animate-slide-left contact md-2-line\" ng-repeat=\"($index,contact) in CF.chats\" ng-click=\"toggleChat($index)\">\n<img ng-src=\"{{contact.avatar}}\" class=\"md-avatar\" alt=\"{{contact.name}}\"><div ng-if=\"contact.otherParticipant!==-1\" \nclass=\"status {{contact.otherParticipant|getSomethingOfArrayFB:CF.contacts:\'status\':\'offline\':\'id\'}}\"></div><div \nng-if=\"contact.unreaded_msg && contact.unreaded_msg!=0\" class=\"md-accent-bg unread-message-count\">\n{{contact.unreaded_msg}}</div><div class=\"md-list-item-text\"><h3 class=\"text-truncate\">{{contact.name|uppercase}}</h3>\n<p class=\"last-message\">{{contact.last_msg}}</p></div><md-icon md-font-icon=\"icon-archive\" \nng-click=\"archiveConversation($event,contact)\" aria-label=\"archive\" class=\"md-secondary md-hue-3\"></md-icon>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"all md-dense\"><md-list-item><p \ntranslate=\"QUICKPANEL.START_NEW_CHAT\">Start New Chat</p><md-menu class=\"md-secondary\"><md-button \nclass=\"md-icon-button\"><md-icon md-font-icon=\"icon-filter\"></md-icon></md-button><md-menu-content width=\"3\">\n<md-menu-item><md-button ng-click=\"setStatus()\">Todos</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"setStatus(\'online\')\">Online</md-button></md-menu-item></md-menu-content></md-menu></md-list-item>\n<md-list-item class=\"contact md-2-line\" ng-if=\"contact.active\" ng-repeat=\"contact in CF.contacts | filter:byfilter\" \nng-click=\"toggleChatByContactId(contact.id)\"><img ng-src=\"{{contact.avatar}}\" class=\"md-avatar\" \nalt=\"{{contact.name|uppercase}}\"><div class=\"status {{contact.status}}\"></div><div class=\"md-list-item-text\"><h3 \nclass=\"text-truncate\">{{contact.name|uppercase}}</h3></div></md-list-item></md-list><md-divider></md-divider></div><div\n class=\"chat animate-slide-right\" ng-show=\"chatActive\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" ng-click=\"deleteChatActive()\" aria-label=\"Back\" \ntranslate translate-attr-aria-label=\"QUICKPANEL.BACK\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon>\n</md-button><h4><span>{{CF.chats[indexActive].name}}</span></h4></div></div></md-toolbar><md-content flex \nlayout-padding ms-scroll scrollable id=\"chat-dialog\" on-middle-event=\"scrollMiddle\" on-bottom-event=\"autoScrollBottom\" \non-top-event=\"loadMoreConversation\"><div layout=\"row\" ng-show=\"CF.chats[indexActive].conversation.loading\">\nloading......</div><div layout=\"row\" \nng-repeat=\"dialog in CF.chats[indexActive].conversation.items | orderBy:\'time\'  track by dialog.time \" \non-finish-render=\"ngRepeatFinished\" class=\"md-padding message-row\" \nng-class=\"dialog.idprofile==F.profile.uid?\'user\':\'contact\'\"><img ng-if=\"dialog.idprofile===F.profile.uid\" \nclass=\"avatar\" ng-src=\"{{CF.profile.data.avatar||\'assets/images/avatars/profile.jpg\'}}\" alt=\"{{F.profile.data.name}}\"> \n<img ng-if=\"dialog.idprofile!==F.profile.uid\" class=\"avatar\" \nng-src=\"{{CF.chats[indexActive].avatar||\'assets/images/avatars/profile.jpg\'}}\" alt=\"{{CF.chats[indexActive].name}}\">\n<div class=\"bubble\" flex><div class=\"message\">{{dialog.msg}}</div><div class=\"time secondary-text\">\n{{dialog.time|altDate}}</div></div></div></md-content><form ng-submit=\"sendMsg()\" layout=\"row\" class=\"reply\" \nlayout-align=\"start center\"><textarea flex ng-model=\"CF.replyMessageQuick\" \nng-keyup=\"$event.keyCode == 13 ? sendMsg() : null\" placeholder=\"Type and hit enter to send message\" translate \ntranslate-attr-placeholder=\"QUICKPANEL.REPLY_PLACEHOLDER\"></textarea><md-button class=\"md-fab\" type=\"submit\" \naria-label=\"Send message\" translate translate-attr-aria-label=\"QUICKPANEL.SEND_MESSAGE\"><md-icon \nmd-font-icon=\"icon-send\"></md-icon></md-button></form></div>");
$templateCache.put("app/quick-panel/tabs/logs/logs-tab.html","<md-list class=\"log-list-timeline\" id=\"logs\" flex><md-list-item class=\"log-item\" ng-class=\"{\'alt\': $even}\" \nng-repeat=\"log in F.logs\"><md-icon class=\"md-avatar log-icon\" md-svg-src=\"/assets/icons/tdsicon.svg\"></md-icon><div \nclass=\"log-content\"><ul class=\"log-messages\"><li ng-repeat=\"msg in log.messages track by $index\" class=\"log-message\">\n{{ msg }}</li></ul><div class=\"log-meta\"><span class=\"log-time\">{{ log.atTime | date:\'dd/MM/yy HH:mm\' }}</span> <span \nclass=\"log-version\">v{{ log.version }}</span></div></div></md-list-item></md-list>");
$templateCache.put("app/quick-panel/tabs/notifications/notifications-tab.html","<md-list class=\"md-dense\" flex><md-list-item class=\"secondary-button-padding\"><p>\n{{(F.notifications.notReaded.length) ? \'Marcar todas como leidas\' : \'No hay notificaciones sin leer\'}}</p><md-button \naria-label=\"read all notifications\" class=\"md-secondary\" ng-hide=\"!F.notifications.notReaded.length\" \nng-click=\"F.readAllMyNotifications()\"><md-icon md-font-icon=\"icon-broom\" class=\"icon\"></md-icon></md-button>\n</md-list-item><md-list-item class=\"md-3-line\" ng-click=\"F.readNotification(notification.$id)\" \nng-repeat=\'notification in F.notifications.notReaded|orderBy:\"-created_at\"\'><img ng-src=\"{{notification.from.avatar}}\" \nclass=\"md-avatar\" alt=\"{{notification.from.name}}\"><div class=\"md-list-item-text\" layout=\"column\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle\" class=\"icon floatingBullet\"><md-tooltip md-direction=\"left\"><small>\nMarcar como leida</small></md-tooltip></md-icon><h3>{{notification.title}}</h3><p \nng-if=\"notification.link.action && notification.link.action!=\'\'\">{{ notification.from.name }} <small>\n{{notification.link.action}}</small> <a ui-sref=\"{{notification.link.state}}\">{{notification.link.name}}</a></p><p \nng-if=\"!notification.body || notification.body==\'\'\"><small><span am-time-ago=\"notification.created_at\"></span></small>\n</p><p ng-if=\"notification.body && notification.body!=\'\'\"><small>{{ notification.body }}<br><span \nam-time-ago=\"notification.created_at\"></span></small></p></div></md-list-item></md-list>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal></ms-navigation-horizontal></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE\n</span></div><md-icon class=\"fold-toggle s18\" md-font-icon=\"icon-backburger\" hide show-gt-sm \nng-click=\"toggleMsNavigationFolded()\"></md-icon></md-toolbar><ms-navigation class=\"scrollable\" folded=\"folded\" \nms-scroll=\"msScrollOptions\"></ms-navigation>");
$templateCache.put("app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html","<ms-navigation class=\"scrollable\" folded=\"F.folded\" ms-scroll=\"msScrollOptions\"></ms-navigation>");
$templateCache.put("app/toolbar/layouts/content-with-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">T</span> <span class=\"logo-text\">TDSystem Software\n</span></div><div class=\"toolbar-separator\"></div><ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div>\n</div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" \nng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><div \nclass=\"toolbar-separator\"></div><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"userStatus.icon\" ng-style=\"{\'color\': userStatus.color }\" class=\"icon status s16\"></md-icon>\n</div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm>\n</md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\">\n<md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item>\n<md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon>\n<md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon \nng-class=\"userStatus.icon\" ng-style=\"{\'color\': userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" aria-label=\"user status\" class=\"status\" \nng-class=\"userStatus.class\">{{userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item \nclass=\"status md-indent\" ng-class=\"{\'selected\': status === userStatus}\" ng-repeat=\"status in userStatusOptions\">\n<md-icon md-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu></md-menu-item>\n<md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\">\n</md-icon><md-button ng-click=\"logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar>\n<div class=\"toolbar-separator\"></div><ms-search-bar on-search=\"search(query)\" \non-result-click=\"searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div><md-menu \nid=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" \nlayout-align=\"center center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{selectedLanguage.flag}}.png\"> <span \nclass=\"iso\">{{selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in languages\"><md-button ng-click=\"changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><ms-shortcuts></ms-shortcuts><div \nclass=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular \nid=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\">\n</md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"userStatus.icon\" ng-style=\"{\'color\': userStatus.color }\" class=\"icon status s16\"></md-icon>\n</div><span class=\"username\" hide show-gt-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" \nhide-xs></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"userStatus.icon\" ng-style=\"{\'color\': userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" aria-label=\"user status\" \nng-class=\"userStatus.class\">{{userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item \nclass=\"status md-indent\" ng-class=\"{\'selected\': status === userStatus}\" ng-repeat=\"status in userStatusOptions\">\n<md-icon md-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu></md-menu-item>\n<md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\">\n</md-icon><md-button ng-click=\"logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar>\n<div class=\"toolbar-separator\"></div><ms-search-bar on-search=\"search(query)\" \non-result-click=\"searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div><md-menu \nid=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" \nlayout-align=\"center center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{selectedLanguage.flag}}.png\"> <span \nclass=\"iso\">{{selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in languages\"><md-button ng-click=\"changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/horizontal-navigation/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">T</span> <span class=\"logo-text\">TDSystem Software\n</span></div><div class=\"toolbar-separator\"></div><ms-shortcuts></ms-shortcuts></div><div layout=\"row\" \nlayout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu \nmd-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" \ntranslate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"userStatus.icon\" ng-style=\"{\'color\': userStatus.color }\" class=\"icon status s16\"></md-icon>\n</div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm>\n</md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\">\n<md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item>\n<md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon>\n<md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon \nng-class=\"userStatus.icon\" ng-style=\"{\'color\': userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" aria-label=\"user status\" \nng-class=\"userStatus.class\">{{userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item \nclass=\"status md-indent\" ng-class=\"{\'selected\': status === userStatus}\" ng-repeat=\"status in userStatusOptions\">\n<md-icon md-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu></md-menu-item>\n<md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\">\n</md-icon><md-button ng-click=\"logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar>\n<ms-search-bar on-search=\"search(query)\" on-result-click=\"searchResultClick(item)\" debounce=\"300\"></ms-search-bar>\n<md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" \nlayout-align=\"center center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{selectedLanguage.flag}}.png\"> <span \nclass=\"iso\">{{selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in languages\"><md-button ng-click=\"changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"toggleSidenav(\'quick-panel\')\" \naria-label=\"Toggle quick panel\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"icon\"></md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" flex layout-align=\"start center\"><div flex=\"nogrow\">\n<img ng-src=\"{{F.centerData.logo || \'logo_tds.png\'}}\" class=\"p-5\" \nalt=\"{{F.centerData.loadingText || \'TDSystem Software\'}}\" style=\"max-height: 46px\"><md-tooltip md-direction=\"right\">\n{{(F.systemVersion == \"LOCAL\") ? \"LOCAL\" : \"v.\" + F.systemVersion}}</md-tooltip></div><div flex=\"nogrow\" \nclass=\"toolbar-separator\"></div><div flex=\"nogrow\"><md-button id=\"navigation-toggle\" class=\"md-icon-button\" \nng-click=\"toggleSidenav(\'navigation\')\" aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button></div><div flex=\"nogrow\" class=\"toolbar-separator\"></div><div flex></div></div><div layout=\"row\" flex \nlayout-align=\"end center\"><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><a md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nng-src=\"{{(F.profile.avatar) ? F.profile.avatar : \'assets/images/avatars/profile.jpg\'}}\"><md-icon md-font-icon \nng-class=\"userStatus.icon\" ng-style=\"{\'color\': (F.connected.$value) ? \'green\' : \'red\'}\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-xs>{{F.profile.username}}</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\"></md-icon></div></a><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.config.profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>Mi Perfil\n</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-security\" class=\"icon\">\n</md-icon><md-button ng-click=\"redirectPrivacy()\">Aviso de privacidad</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ng-if=\"F.profile.centers\"><md-icon md-font-icon=\"icon-store\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" aria-label=\"change center\" class=\"status\"><label \nng-bind=\"F.center | getSomethingOfArrayFB:F.centersData:\'name\':\'S/N\':\'id\'\"></label></md-button><md-menu-content \nwidth=\"2\"><md-menu-item ng-class=\"{\'selected\': center === F.center}\" ng-repeat=\"center in F.profile.centers\"><md-button\n ng-click=\"changeCenter(center)\" aria-label=\"change center\"><label \nng-bind=\"center | getSomethingOfArrayFB:F.centersData:\'name\':\'S/N\':\'id\'\"></label></md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-item><md-menu-item class=\"md-indent\" with-permission access=\"apps.chat\" \naction=\"changeStatus\" ng-model=\"permissionToChangeStatus\"><md-icon md-font-icon \nng-class=\"(F.profile.status|getSomethingOfArrayFB:userStatusOptions:\'icon\':\'icon-checkbox-blank-circle-outline\':\'id\')\" \nng-style=\"{\'color\': (F.profile.status|getSomethingOfArrayFB:userStatusOptions:\'color\':\'#616161\':\'id\') }\" class=\"icon\">\n</md-icon><md-menu id=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"userStatus\">\n{{(F.profile.status|getSomethingOfArrayFB:userStatusOptions:\'translate\':\'CHAT.STATUS_ONLINE\':\'id\')|translate}}\n</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === userStatus}\" ng-repeat=\"status in userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"CF.setUserStatus(status.id)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider ng-if=\"F.isDistributor()\"></md-menu-divider><md-menu-item ng-if=\"F.isDistributor()\" \nclass=\"md-indent\"><md-icon md-font-icon=\"icon-cog\" class=\"icon\"></md-icon><md-menu id=\"config-menu\"><md-button \naria-label=\"Config Settings\" ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"md-primary\">Config</md-button>\n<md-menu-content width=\"2\"><md-menu-item ng-if=\"menu.active != false\" ng-repeat=\"menu in F.menuItems.config\" \nwith-permission action=\"access\" access=\"{{menu.menuItem}}\" class=\"status md-indent\"><md-icon \nmd-font-icon=\"{{menu.icon}}\" class=\"icon\"></md-icon><md-button ui-sref=\"{{menu.state}}\">{{menu.title}}</md-button>\n</md-menu-item></md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item \nclass=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"logout()\">Logout\n</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div>\n<ms-search-bar on-search=\"search(query)\" on-result-click=\"searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div \nclass=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button notifications\" \nng-click=\"toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><span ng-show=\'(CF.chats|getTotalOfArrayField:\"unreaded_msg\")\' \nclass=\"badge md-whiteframe-1dp notificationIconLeft\">{{CF.chats|getTotalOfArrayField:\'unreaded_msg\'}}<md-tooltip \nmd-direction=\"left\">{{CF.chats|getTotalOfArrayField:\'unreaded_msg\'}} mensajes nuevos</md-tooltip></span><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"icon\"></md-icon><span ng-show=\"F.notifications.notReaded.length\" \nclass=\"badge md-whiteframe-1dp notificationIcon\">{{F.notifications.notReaded.length}}<md-tooltip md-direction=\"left\">\n{{F.notifications.notReaded.length}} notificaciones nuevas</md-tooltip></span></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><ms-search-bar on-search=\"search(query)\" \non-result-click=\"searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"64\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nng-src=\"{{(F.profile.avatar) ? F.profile.avatar : \'assets/images/avatars/profile.jpg\'}}\"><md-icon md-font-icon \nng-class=\"userStatus.icon\" ng-style=\"{\'color\': userStatus.color }\" class=\"icon status s16\"></md-icon></div><span \nclass=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm></md-icon>\n</div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon \nmd-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\"><md-icon md-font-icon ng-class=\"userStatus.icon\" ng-style=\"{\'color\': userStatus.color }\" \nclass=\"icon\"></md-icon><md-menu id=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" \naria-label=\"user status\" ng-class=\"userStatus.class\">{{userStatus.title}}</md-button><md-menu-content width=\"2\">\n<md-menu-item class=\"status md-indent\" ng-class=\"{\'selected\': status === userStatus}\" \nng-repeat=\"status in userStatusOptions\"><md-icon md-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" \nclass=\"icon\"></md-icon><md-button ng-click=\"setUserStatus(status)\">{{status.title}}</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><div class=\"toolbar-separator\"></div>\n</div></div>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\r\n\r\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\r\n             ng-class=\"{\'active md-accent-bg\': vm.isActive}\">\r\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\r\n        </div>\r\n\r\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\r\n           ng-class=\"{\'active md-accent-bg\': vm.isActive}\"\r\n           ng-if=\"node.uisref && node.title\">\r\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\r\n        </a>\r\n\r\n    </div>\r\n\r\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\r\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\r\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\r\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\r\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li style=\"font-size: xx-small; text-align:center\">`</li><li ng-repeat=\"node in vm.navigation\" \nms-navigation-node=\"node\" ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" \nng-include=\"\'navigation-nested.html\'\"></li></ul><script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\r\n\r\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title && vm.hasChildren\">\r\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\r\n        </div>\r\n\r\n        <a class=\"ms-navigation-button\"ui-sref=\"{{node.uisref}}\"  ui-sref-active=\"active md-accent-bg\" ng-if=\"(node.uisref && !node.action) && node.title\">\r\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span ng-if=\"node.uisref!=\'app.chat\'&&node.badge\" class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\">{{node.badge.content}}</span>\r\n            <span ng-if=\"node.uisref==\'app.chat\'&&(CF.chats|getTotalOfArrayField:\'unreaded_msg\')>0\" class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\">{{CF.chats|getTotalOfArrayField:\'unreaded_msg\'}}</span>\r\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\r\n        </a>\r\n        <a class=\"ms-navigation-button\" ng-click=\"vm[node.action]()\" ui-sref-active=\"active md-accent-bg\" ng-if=\"node.action && node.title\">\r\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span ng-if=\"node.uisref!=\'app.chat\'&&node.badge\" class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\">{{node.badge.content}}</span>\r\n            <span ng-if=\"node.uisref==\'app.chat\'&&(CF.chats|getTotalOfArrayField:\'unreaded_msg\')>0\" class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\">{{CF.chats|getTotalOfArrayField:\'unreaded_msg\'}}</span>\r\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\r\n        </a>\r\n\r\n    </div>\r\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\r\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\" ng-class=\"{\'collapsed\': vm.collapsed && !vm.folded, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li>\r\n    </ul>\n</script>");
$templateCache.put("app/main/acommon/directives/filters/action.html","<md-input-container class=\"md-block md-icon-float\" flex-gt-xs md-no-float><md-icon count-icon array=\"F.actions\">\n</md-icon><md-select class=\"filter\" ng-model=\'F.search.$[\"action\"]\' placeholder=\"Accion\" \nng-change=\"[\'employees\', \'noEmployees\',\'realSalaryRecords\',\'movements\',\'healthcareRecords\',\'personalInfoEmployees\',\'employeeFiles\',\'employeesVacationsRecords\',\'credits\',\'logs\'].indexOf(F.active.menuName)>=0?getThem(true):false\">\n<md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" \nng-model=\"actionSelectFilter\" placeholder=\"Busque una accion\"></md-select-header><md-option ng-value=\"false\">Todos\n</md-option><md-option ng-value=\"action.id\" \nng-repeat=\"action in F.actions | orderBy:\'name\' | filter:actionSelectFilter\">{{action.name}}</md-option></md-select>\n</md-input-container>");
$templateCache.put("app/main/acommon/directives/filters/autocomplete-all-payroll.html","");
$templateCache.put("app/main/acommon/directives/filters/autocomplete-employee.html","<md-autocomplete class=\"search-input\" md-min-length=\"2\" md-selected-item=\"F.search.$employee\" \nmd-search-text=\"searchEmployee\" md-items=\"employee in autocompleteEmployees(searchEmployee)\" \nmd-item-text=\"employee.name\" md-require-match=\"true\" md-select-on-match=\"true\" md-match-case-insensitive=\"true\">\n<md-item-template><span md-highlight-text=\"searchEmployee\">{{employee.name}}</span></md-item-template><md-not-found>\nNo hay empleados con ese nombre</md-not-found></md-autocomplete>");
$templateCache.put("app/main/acommon/directives/filters/by.html","<md-input-container class=\"md-block\" flex-gt-xs md-no-float><md-select class=\"search-input\" \nng-model=\"F.search.filterBy\" placeholder=\"Por\" name=\"by\" required><md-select-header><input autocomplete=\"off\" \ntype=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"bySelectFilter\" \nplaceholder=\"Filtre resultados por..\"></md-select-header><md-option ng-value=\"filter\" \nng-repeat=\"filter in R.filtersBy[F.active.menuName] | orderBy:\'name\'\">por {{filter.label?filter.label:filter.name}}\n</md-option></md-select></md-input-container>");
$templateCache.put("app/main/acommon/directives/filters/cc.html","<md-input-container class=\"md-block md-icon-float\" flex-gt-xs md-no-float><md-icon count-icon array=\"L.ccs\"></md-icon>\n<label>Centro de Costo</label><md-select class=\"filter\" ng-model=\"F.search.$.cc\" placeholder=\"CC\" \nng-change=\"[\'employees\', \'noEmployees\',\'realSalaryRecords\',\'movements\',\'healthcareRecords\',\'personalInfoEmployees\',\'employeeFiles\',\'employeesVacationsRecords\',\'credits\',\'logs\'].indexOf(F.active.menuName)>=0?getThem(true):false\">\n<md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" \nng-model=\"ccSelectFilter\" placeholder=\"Busque un Centro de Costo\"></md-select-header><md-option ng-value=\"false\">Todos\n</md-option><md-option ng-if=\"!F.permissionToAccessAllPayrolls && F.search.$payroll == cc.payroll\" ng-value=\"cc.$id \" \nng-repeat=\"cc in L.userCcs[F.profile.uid] |  orderBy : [\'-valid\',\'name\'] | filter:ccSelectFilter\" \nng-class=\"{\'inactiveOption\':!cc.valid}\">{{cc.name}} <small ng-if=\"cc.rp_id\">[{{cc.rp_id | nameOfL:L.rps}}]</small>\n</md-option><md-option ng-if=\"F.permissionToAccessAllPayrolls\" ng-value=\"cc.$id \" \nng-repeat=\"cc in L.ccs |  orderBy : [\'-valid\',\'name\'] | filter:ccSelectFilter\" ng-class=\"{\'inactiveOption\':!cc.valid}\">\n{{cc.name}} <small ng-if=\"cc.rp_id\">[{{cc.rp_id | nameOfL:L.rps}}]</small></md-option></md-select></md-input-container>");
$templateCache.put("app/main/acommon/directives/filters/companies-record.html","<md-input-container class=\"md-block md-icon-float\" flex-gt-xs md-no-float><md-icon count-icon \narray=\"L.companiesRecords\"></md-icon><md-select class=\"filter\" ng-model=\"F.search.$.companiesRecord\" \nplaceholder=\"Empresa\"><md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" \nng-keydown=\"$event.stopPropagation()\" ng-model=\"companiesRecordSelectFilter\" placeholder=\"Busque una Empresa\">\n</md-select-header><md-option ng-if=\"F.isAdmin\" ng-value=\'\"all\"\'>Todas</md-option><md-option \nng-value=\"companiesRecord.$id\" \nng-repeat=\"companiesRecord in L.companiesRecords | orderBy:[\'-active\',\'name\'] | filter:companiesRecordSelectFilter\">\n{{companiesRecord.name}}</md-option></md-select></md-input-container>");
$templateCache.put("app/main/acommon/directives/filters/contract-status.html","<md-input-container class=\"md-block md-icon-float\" flex-gt-xs=\"nogrow\" md-no-float \nng-init=\'F.search.$.contractStatus = \"all\"\'><md-icon count-icon array=\"F.contractStatuses\"></md-icon><label>Status\n</label><md-select class=\"filter\" ng-model=\"F.search.$.contractStatus\" placeholder=\"Status\" \nng-change=\"[\'employees\', \'noEmployees\',\'realSalaryRecords\',\'movements\',\'healthcareRecords\',\'personalInfoEmployees\',\'employeeFiles\',\'employeesVacationsRecords\',\'contracts\',\'logs\'].indexOf(F.active.menuName)>=0?getThem(true):false\">\n<md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" \nng-model=\"statusContractSelectFilter\" placeholder=\"Busque un Status\"></md-select-header><md-option ng-value=\"all\">Todos\n</md-option><md-option ng-value=\"contractS.id\" \nng-repeat=\"contractS in F.contractStatus | orderBy:\'name\' | filter:statusSelectFilter\">{{contract.name}}</md-option>\n</md-select></md-input-container>");
$templateCache.put("app/main/acommon/directives/filters/credit-status.html","<md-input-container class=\"md-block md-icon-float\" flex-gt-xs=\"nogrow\" md-no-float \nng-init=\'F.search.$.creditStatus = \"all\"\'><md-icon count-icon array=\"F.creditStatuses\"></md-icon><label>Status</label>\n<md-select class=\"filter\" ng-model=\"F.search.$.creditStatus\" placeholder=\"Status\" \nng-change=\"[\'employees\', \'noEmployees\',\'realSalaryRecords\',\'movements\',\'healthcareRecords\',\'personalInfoEmployees\',\'employeeFiles\',\'employeesVacationsRecords\',\'credits\',\'logs\'].indexOf(F.active.menuName)>=0?getThem(true):false\">\n<md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" \nng-model=\"statusCreditSelectFilter\" placeholder=\"Busque un Status\"></md-select-header><md-option ng-value=\"all\">Todos\n</md-option><md-option ng-value=\"creditS.id\" \nng-repeat=\"creditS in F.creditStatuses | orderBy:\'name\' | filter:statusSelectFilter\">{{creditS.name}}</md-option>\n</md-select></md-input-container>");
$templateCache.put("app/main/acommon/directives/filters/dashboard-payroll.html","<md-input-container class=\"md-block md-icon-float\" flex md-no-float><md-icon ng-if=\"F.permissionToAccessAllPayrolls\" \ncount-icon array=\"L.allPayrolls\"></md-icon><md-icon ng-if=\"!F.permissionToAccessAllPayrolls\" count-icon \narray=\"L.payrolls\"></md-icon><md-select class=\"search-input\" ng-model=\"F.search.$payroll\" placeholder=\"Nómina\" \nrequired><md-select-header><input autocomplete=\"off\" type=\"search\" id=\"searchPayroll\" class=\"md-text\" \nng-keydown=\"$event.stopPropagation()\" ng-model=\"payrollSelectFilter\" placeholder=\"Busque una nómina\">\n</md-select-header><md-option ng-if=\"F.isAdmin && !F.active.filter.restrictAll\" ng-value=\'\"all\"\'>Todas</md-option>\n<md-option ng-value=\"false\">Ninguna</md-option><md-option ng-value=\'\"global\"\' \nng-if=\'F.active.menuName == \"incidencesTypes\"\'>Globales</md-option><md-option ng-if=\"!F.permisToAccessAllPayrolls\" \nng-value=\"payroll.$id\" ng-repeat=\"payroll in L.payrolls | orderBy:\'name\' | filter:payrollSelectFilter\">{{payroll.name}}\n</md-option><md-option ng-if=\"F.permissionToAccessAllPayrolls\" ng-value=\"payroll.$id\" \nng-repeat=\"payroll in L.allPayrolls | orderBy:\'name\' | filter:payrollSelectFilter\">{{payroll.name}}</md-option>\n</md-select></md-input-container>");
$templateCache.put("app/main/acommon/directives/filters/employee.html","<md-input-container class=\"md-block md-icon-float\" flex-gt-xs md-no-float \nng-init=\'F.search.$employee = (F.active.filter.subFilterStartWithAll) ?  \"all\" :  false\'><md-icon count-icon \narray=\"L.payrollEmployees[F.search.$payroll]\"></md-icon><label>Empleado</label><md-select class=\"filter\" \nng-model=\"F.search.$employee\" placeholder=\"Empleado\" required><md-select-header><input autocomplete=\"off\" \ntype=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"employeeSelectFilter\" \nplaceholder=\"Busque un Empleado\"></md-select-header><md-option \nng-if=\'(F.active.filter.allowAll && F.active.filter.allowAll.inFilter == \"employee\") || F.active.filter.subFilterStartWithAll\' \nng-value=\'\"all\"\'>Todos</md-option><md-option ng-value=\"employee.$id \" \nng-repeat=\"employee in L.payrollEmployees[F.search.$payroll] | orderBy:\'name\' | filter:employeeSelectFilter\">\n{{employee.name}}</md-option></md-select></md-input-container>");
$templateCache.put("app/main/acommon/directives/filters/firm.html","<md-input-container class=\"md-block md-icon-float\" flex md-no-float><md-icon count-icon array=\"L.firms\"></md-icon>\n<md-select ng-model=\"F.search.$.firm\" class=\"search-input\" placeholder=\"Cliente\"><md-select-header><input \nautocomplete=\"off\" type=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"firmSelectFilter\" \nplaceholder=\"Busque un cliente\"></md-select-header><md-option ng-if=\"!F.active.filter.restrictAll\" ng-value=\'\"all\"\'>\nTodos</md-option><md-option ng-if=\'F.active.menuName == \"users\" && [\"tds\",center.id].indexOf(F.profile.firm)>-1\' \nng-value=\"center.id\" style=\"color: blue\" ng-repeat=\"center in F.centersData\" ng-bind=\"center.name\"></md-option>\n<md-option ng-if=\"F.profile.firm === F.center\" ng-value=\"firm.$id\" \nng-repeat=\"firm in L.firms | orderBy:\'name\' | filter:firmSelectFilter\">{{firm.name}}</md-option><md-option \nng-if=\"F.profile.firm !== F.center && firm.$id === F.profile.firm\" ng-value=\"firm.$id\" \nng-repeat=\"firm in L.firms | orderBy:\'name\' | filter:firmSelectFilter\">{{firm.name}}</md-option></md-select>\n</md-input-container>");
$templateCache.put("app/main/acommon/directives/filters/from-date.html","<md-input-container class=\"md-block date-picker\" flex-gt-xs=\"nogrow\" md-no-float><label>Desde</label><md-datepicker \nclass=\"filter\" md-hide-icons=\"triangle\" ng-model=\'F.search.$[\"data.date:>=\"]\' input-date-miliseconds end-start=\"start\" \nname=\"from\" \nng-change=\"[\'employees\', \'noEmployees\',\'realSalaryRecords\',\'movements\',\'healthcareRecords\',\'personalInfoEmployees\',\'employeeFiles\',\'employeesVacationsRecords\',\'credits\',\'logs\'].indexOf(F.active.menuName)>=0?getThem(true):false\">\n</md-datepicker></md-input-container>");
$templateCache.put("app/main/acommon/directives/filters/groupings.html","<md-input-container class=\"md-block md-icon-float\" flex-gt-xs md-no-float><md-icon count-icon array=\"L.groupings\">\n</md-icon><label>Agrupaciones</label><md-select class=\"filter\" ng-model=\"F.search.$.groupings\" \nng-change=\"[\'employees\', \'noEmployees\',\'realSalaryRecords\',\'movements\',\'healthcareRecords\',\'personalInfoEmployees\',\'employeeFiles\',\'employeesVacationsRecords\',\'credits\',\'logs\'].indexOf(F.active.menuName)>=0?getThem(true):false\" \nplaceholder=\"Agrupaciones\"><md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" \nng-keydown=\"$event.stopPropagation()\" ng-model=\"groupingSelectFilter\" placeholder=\"Busque una Agrupación\">\n</md-select-header><md-option ng-value=\"false\">Todos</md-option><md-option ng-value=\"grouping.$id\" \nng-repeat=\"grouping in L.groupings | orderBy:\'name\' | filter:groupingSelectFilter\">{{grouping.name | uppercase}}\n</md-option></md-select></md-input-container>");
$templateCache.put("app/main/acommon/directives/filters/hasSeniorityDate.html","<md-input-container class=\"md-block md-icon-float\" flex-gt-xs md-no-float><md-icon count-icon \narray=\"F.hasSeniorityDateOptions\"></md-icon><label>Tiene antigüedad</label><md-select class=\"filter\" \nng-model=\"F.search.$.hasSeniorityDate\" placeholder=\"Tiene antigüedad\" \nng-change=\"[\'employees\', \'noEmployees\',\'realSalaryRecords\',\'movements\',\'healthcareRecords\',\'personalInfoEmployees\',\'employeeFiles\',\'employeesVacationsRecords\',\'credits\',\'logs\'].indexOf(F.active.menuName)>=0?getThem(true):false\">\n<md-option ng-value=\"undefined\">Todos</md-option><md-option ng-repeat=\"item in F.hasSeniorityDateOptions\" \nng-value=\"item.id\">{{item.value}}</md-option></md-select></md-input-container>");
$templateCache.put("app/main/acommon/directives/filters/incidence-status.html","<md-input-container class=\"md-block md-icon-float\" flex-gt-xs=\"nogrow\" md-no-float ng-init=\"F.search.$.status = false\">\n<md-icon count-icon array=\"F.incidenceStatuss\"></md-icon><label>\nStatus {{(F.search.$.status) ? F.search.$.status : \'Todos\'}}</label><md-select class=\"filter\" \nng-model=\"F.search.$.status\" placeholder=\"Status\"><md-select-header><input autocomplete=\"off\" type=\"search\" \nclass=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"statusSelectFilter\" placeholder=\"Busque un Status\">\n</md-select-header><md-option ng-value=\"false\">Todos</md-option><md-option ng-value=\"status.id\" \nng-repeat=\"status in F.incidenceStatuss | orderBy:\'name\' | filter:statusSelectFilter\">{{status.name}}</md-option>\n</md-select></md-input-container>");
$templateCache.put("app/main/acommon/directives/filters/loan-status.html","<md-input-container class=\"md-block md-icon-float\" flex-gt-xs=\"nogrow\" md-no-float><md-icon count-icon \narray=\"F.loanStatuses\"></md-icon><label>Status</label><md-select class=\"filter\" ng-model=\"F.search.$.loanStatus\" \nplaceholder=\"Status\" \nng-change=\"[\'employees\', \'noEmployees\',\'realSalaryRecords\',\'movements\',\'healthcareRecords\',\'personalInfoEmployees\',\'employeeFiles\',\'employeesVacationsRecords\',\'loans\',\'logs\'].indexOf(F.active.menuName)>=0?getThem(true):false\">\n<md-option ng-value=\"all\">Todos</md-option><md-option ng-value=\"loanS.id\" \nng-repeat=\"loanS in F.loanStatuses | orderBy:\'name\' | filter:statusSelectFilter\">{{loanS.name}}</md-option></md-select>\n</md-input-container>");
$templateCache.put("app/main/acommon/directives/filters/module.html","<md-input-container class=\"md-block md-icon-float\" flex md-no-float><md-icon count-icon array=\"M.modules\"></md-icon>\n<md-select class=\"search-input\" ng-model=\"F.search.$module\" placeholder=\"Módulo\" required><md-select-header><input \nautocomplete=\"off\" type=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"moduleSelectFilter\" \nplaceholder=\"Busque un módulo\"></md-select-header><md-option ng-if=\"F.isAdmin\" ng-value=\'\"all\"\'>Todos</md-option>\n<md-option ng-value=\"module._id\" ng-repeat=\"module in M.modules | orderBy:\'name\' | filter:moduleSelectFilter\">\n{{module.name}}</md-option></md-select></md-input-container>");
$templateCache.put("app/main/acommon/directives/filters/movement-type.html","<md-input-container class=\"md-block md-icon-float\" flex-gt-xs md-no-float><md-icon count-icon array=\"F.movementTypes\">\n</md-icon><md-select class=\"filter\" ng-model=\'F.search.$[\"movement.type\"]\' placeholder=\"Tipo de Movimiento\" \nng-change=\"[\'employees\', \'noEmployees\',\'realSalaryRecords\',\'movements\',\'healthcareRecords\',\'personalInfoEmployees\',\'employeeFiles\',\'employeesVacationsRecords\',\'credits\',\'logs\'].indexOf(F.active.menuName)>=0?getThem(true):false\">\n<md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" \nng-model=\"movementTypeSelectFilter\" placeholder=\"Busque un tipo de movimiento\"></md-select-header><md-option \nng-value=\"false\">Todos</md-option><md-option ng-value=\"movementType.id\" \nng-repeat=\"movementType in F.movementTypes | orderBy:\'name\' | filter:movementTypeSelectFilter\">{{movementType.name}}\n</md-option></md-select></md-input-container>");
$templateCache.put("app/main/acommon/directives/filters/movements-type.html","<md-input-container class=\"md-block md-icon-float\" flex-gt-xs md-no-float><md-icon count-icon array=\"F.movementsTypes\">\n</md-icon><md-select class=\"filter\" ng-model=\'F.search.$[\"data.type\"]\' placeholder=\"Tipo de Movimiento\" \nng-change=\"[\'employees\', \'noEmployees\',\'realSalaryRecords\',\'movements\',\'healthcareRecords\',\'personalInfoEmployees\',\'employeeFiles\',\'employeesVacationsRecords\',\'credits\',\'logs\'].indexOf(F.active.menuName)>=0?getThem(true):false\">\n<md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" \nng-model=\"movementsTypeSelectFilter\" placeholder=\"Busque un tipo de movimiento\"></md-select-header><md-option \nng-value=\"false\">Todos</md-option><md-option ng-value=\"movementsType.id\" \nng-repeat=\"movementsType in F.movementsTypes | orderBy:\'name\' | filter:movementsTypeSelectFilter\">\n{{movementsType.name}}</md-option></md-select></md-input-container>");
$templateCache.put("app/main/acommon/directives/filters/payroll-calendar.html","<md-input-container class=\"md-block md-icon-float\" flex md-no-float><md-icon count-icon \narray=\"Z.payrollPayrollCalendars[F.search.$payrollCalendar]\"></md-icon><label>Año</label><md-select \nng-model=\"F.search.$payrollCalendar\" class=\"filter\" required><md-select-header><input autocomplete=\"off\" type=\"search\" \nclass=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"payrollCalendarSelectFilter\" \nplaceholder=\"Busque un año\"></md-select-header><md-option ng-value=\"calendar.$id\" \nng-repeat=\"calendar in Z.payrollPayrollCalendars[F.search.$payrollCalendar] =  payrollCalendars | orderBy:\'data.year\' | filter:payrollCalendarSelectFilter\">\n{{calendar.$id}}</md-option></md-select></md-input-container>");
$templateCache.put("app/main/acommon/directives/filters/payroll-cc.html","<md-input-container class=\"md-block md-icon-float\" flex-gt-xs md-no-float><md-icon count-icon \narray=\"L.payrollCcs[F.search.$payroll]\"></md-icon><label>Centro de Costo</label><md-select class=\"filter\" \nng-model=\"F.search.$.cc\" placeholder=\"CC\"><md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" \nng-keydown=\"$event.stopPropagation()\" ng-model=\"ccSelectFilter\" placeholder=\"Busque un Centro de Costo\">\n</md-select-header><md-option ng-value=\"cc.$id \" \nng-repeat=\"cc in L.payrollCcs[F.search.$payroll] | orderBy:\'name\' | filter:ccSelectFilter\">{{cc.name}}</md-option>\n</md-select></md-input-container>");
$templateCache.put("app/main/acommon/directives/filters/payroll-employee.html","<md-input-container class=\"md-block md-icon-float\" flex-gt-xs md-no-float \nng-init=\'F.search.$.employee = (F.active.filter.subFilterStartWithAll) ?  \"all\" :  false\'><md-icon count-icon \narray=\"L.payrollEmployees[F.search.$payroll]\"></md-icon><label>Empleado</label><md-select class=\"filter\" \nng-model=\"F.search.$.employee\" placeholder=\"Empleado\" required><md-select-header><input autocomplete=\"off\" \ntype=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"employeeSelectFilter\" \nplaceholder=\"Busque un Empleado\"></md-select-header><md-option \nng-if=\'(F.active.filter.allowAll && F.active.filter.allowAll.inFilter == \"employee\") || F.active.filter.subFilterStartWithAll\' \nng-value=\'\"all\"\'>Todos</md-option><md-option ng-value=\"employee.$id \" \nng-repeat=\"employee in L.payrollEmployees[F.search.$payroll] | orderBy:\'name\' | filter:employeeSelectFilter\">\n{{employee.name}}</md-option></md-select></md-input-container>");
$templateCache.put("app/main/acommon/directives/filters/payroll-filter.html","<md-input-container class=\"md-block md-icon-float\" flex-gt-xs=\"nogrow\" md-no-float><md-icon \nng-show=\"F.permissionToAccessAllPayrolls\" count-icon array=\"L.allPayrolls\"></md-icon><md-icon \nng-show=\"!F.permissionToAccessAllPayrolls\" count-icon array=\"L.payrolls\"></md-icon><label>Nómina</label><md-select \nclass=\"filter\" ng-model=\"F.search.$.payroll\" placeholder=\"Nómina\"><md-select-header><input autocomplete=\"off\" \ntype=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"payrollSelectFilter\" \nplaceholder=\"Busque una nomina\"></md-select-header><md-option ng-if=\"F.permissionToAccessAllPayrolls\" ng-value=\'\"all\"\'>\nTodas</md-option><md-option ng-if=\"!F.permissionToAccessAllPayrolls\" ng-value=\"payroll.$id\" \nng-repeat=\"payroll in L.payrolls | orderBy : [\'-active\',\'name\'] | filter:payrollSelectFilter\">\n{{payroll.class}} {{payroll.name}}</md-option><md-option ng-if=\"F.permissionToAccessAllPayrolls\" \nng-value=\"payroll.$id\" ng-class=\"{\'inactiveOption\': !payroll.active}\" \nng-repeat=\"payroll in L.allPayrolls | orderBy : [\'-active\',\'name\'] | filter:payrollSelectFilter\">\n{{payroll.class}} {{payroll.name}}</md-option></md-select></md-input-container>");
$templateCache.put("app/main/acommon/directives/filters/payroll.html","<md-input-container class=\"md-block md-icon-float\" flex md-no-float><md-icon ng-if=\"F.permissionToAccessAllPayrolls\" \ncount-icon array=\"L.allPayrolls\"></md-icon><md-icon ng-if=\"!F.permissionToAccessAllPayrolls\" count-icon \narray=\"L.payrolls\"></md-icon><md-select class=\"search-input\" ng-model=\"F.search.$payroll\" placeholder=\"Nómina\" \nrequired \nng-change=\"[\'employees\', \'noEmployees\',\'realSalaryRecords\',\'movements\',\'healthcareRecords\',\'personalInfoEmployees\',\'employeeFiles\',\'employeesVacationsRecords\',\'credits\',\'logs\'].indexOf(F.active.menuName)>=0?getThem(true):false\">\n<md-select-header><input autocomplete=\"off\" type=\"search\" id=\"searchPayroll\" class=\"md-text\" \nng-keydown=\"$event.stopPropagation()\" ng-model=\"payrollSelectFilter\" placeholder=\"Busque una nómina\">\n</md-select-header><md-option \nng-if=\'(F.permissionToAccessAllPayrolls && !F.active.filter.restrictAll) && F.active.menuName !== \"operations\"\' \nng-value=\'\"all\"\'>Todas</md-option><md-option ng-value=\"false\">Ninguna</md-option><md-option ng-value=\'\"global\"\' \nng-if=\'F.active.menuName == \"incidencesTypes\"\'>Globales</md-option><md-option ng-if=\"!F.permissionToAccessAllPayrolls\" \nng-class=\"{\'inactiveOption\': !payroll.active}\" ng-value=\"payroll.$id\" \nng-repeat=\"payroll in L.payrolls | orderBy : [\'-active\',\'name\'] | filter:payrollSelectFilter\">\n{{payroll.class}} {{payroll.name}}</md-option><md-option ng-if=\"F.permissionToAccessAllPayrolls\" \nng-class=\"{\'inactiveOption\': !payroll.active}\" ng-value=\"payroll.$id\" \nng-repeat=\"payroll in L.allPayrolls | orderBy : [\'-active\',\'name\'] | filter:payrollSelectFilter\">\n{{payroll.class}} {{payroll.name}}</md-option></md-select></md-input-container>");
$templateCache.put("app/main/acommon/directives/filters/period.html","<md-input-container class=\"md-block\" flex md-no-float><label>Periodo</label><md-select ng-model=\"F.search.$period\" \nclass=\"filter\" required><md-option ng-value=\"false\">Seleccione periodo</md-option><md-option \nng-class=\'{\"md-warn\":!period.active}\' ng-value=\"period.period\" ng-repeat=\"period in periods\">\n{{period.period}}: {{period.start| date:F.dateFormat}}-{{period.end| date:F.dateFormat}}</md-option></md-select>\n</md-input-container>");
$templateCache.put("app/main/acommon/directives/filters/profile.html","<md-input-container class=\"md-block md-icon-float\" flex-gt-xs md-no-float><md-icon count-icon array=\"L.profiles\">\n</md-icon><md-select class=\"filter\" ng-model=\'F.search.$[\"profile\"]\' placeholder=\"Usuario\" \nng-change=\"[\'employees\', \'noEmployees\',\'realSalaryRecords\',\'movements\',\'healthcareRecords\',\'personalInfoEmployees\',\'employeeFiles\',\'employeesVacationsRecords\',\'credits\',\'logs\'].indexOf(F.active.menuName)>=0?getThem(true):false\">\n<md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" \nng-model=\"profileSelectFilter\" placeholder=\"Busque un usuario\"></md-select-header><md-option ng-value=\"false\">Todos\n</md-option><md-option ng-value=\"profile.$id\" \nng-repeat=\"profile in L.profiles | orderBy:\'name\' | filter:profileSelectFilter\">{{profile.name}}</md-option>\n</md-select></md-input-container>");
$templateCache.put("app/main/acommon/directives/filters/rp.html","<md-input-container class=\"md-block md-icon-float\" flex-gt-xs md-no-float><md-icon count-icon array=\"L.rps\"></md-icon>\n<label>Registro Patronal</label><md-select class=\"filter\" ng-model=\"F.search.$.rp\" \nng-change=\"[\'employees\', \'noEmployees\',\'realSalaryRecords\',\'movements\',\'healthcareRecords\',\'employeeFiles\',\'personalInfoEmployees\',\'employeesVacationsRecords\',\'credits\',\'logs\'].indexOf(F.active.menuName)>=0?getThem(true):false\" \nplaceholder=\"RP\"><md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" \nng-keydown=\"$event.stopPropagation()\" ng-model=\"rpSelectFilter\" placeholder=\"Busque un Registro Patronal\">\n</md-select-header><md-option ng-value=\'\"all\"\'>Todos</md-option><md-option ng-value=\"rp.$id\" \nng-repeat=\"rp in L.rps | orderBy:\'name\' | filter:rpSelectFilter\" ng-class=\"{\'inactiveOption\':!rp.active}\">{{rp.name}}\n</md-option></md-select></md-input-container>");
$templateCache.put("app/main/acommon/directives/filters/status.html","<md-input-container class=\"md-block md-icon-float\" flex-gt-xs=\"nogrow\" md-no-float ng-init=\"F.search.$.status = false\">\n<md-icon ng-show=\'F.active.menuName !== \"realSalaryRecords\"\' count-icon array=\"F.employeeStatatuss\"></md-icon><md-icon \nng-show=\'F.active.menuName == \"realSalaryRecords\"\' count-icon array=\"[false,4,5]\"></md-icon><label>\nStatus {{(F.search.$.status) ? F.search.$.status : \'Todos\'}}</label><md-select class=\"filter\" \nng-model=\"F.search.$.status\" placeholder=\"Status\" \nng-change=\"[\'employees\', \'noEmployees\',\'realSalaryRecords\',\'movements\',\'healthcareRecords\',\'personalInfoEmployees\',\'employeeFiles\',\'employeesVacationsRecords\',\'credits\',\'logs\'].indexOf(F.active.menuName)>=0?getThem(true):false\">\n<md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" \nng-model=\"statusSelectFilter\" placeholder=\"Busque un Status\"></md-select-header><md-option ng-value=\"false\">Todos\n</md-option><md-option ng-if=\'F.active.menuName !== \"realSalaryRecords\"\' ng-value=\"status.id\" \nng-repeat=\"status in F.employeeStatatuss | orderBy:\'name\' | filter:statusSelectFilter\">{{status.name}}</md-option>\n<md-option ng-if=\'F.active.menuName == \"realSalaryRecords\"\' ng-value=\"4\">Activos</md-option><md-option \nng-if=\'F.active.menuName == \"realSalaryRecords\"\' ng-value=\"5\">Bajas</md-option></md-select></md-input-container>");
$templateCache.put("app/main/acommon/directives/filters/to-date.html","<md-input-container class=\"md-block date-picker filter\" flex-gt-xs md-no-float><label>Hasta</label><md-datepicker \nng-change=\"[\'employees\', \'noEmployees\',\'realSalaryRecords\',\'movements\',\'healthcareRecords\',\'personalInfoEmployees\',\'employeeFiles\',\'employeesVacationsRecords\',\'credits\',\'logs\'].indexOf(F.active.menuName)>=0?getThem(true):false\" \nmd-hide-icons=\"triangle\" ng-model=\'F.search.$[\"data.date:<=\"]\' input-date-miliseconds end-start=\"end\" name=\"to\">\n</md-datepicker></md-input-container>");
$templateCache.put("app/main/acommon/directives/inputs/fb-input-search-2.html","<div class=\"search filterInputs\" layout-gt-xs=\"row\" layout-align=\"start center\" flex><div layout=\"row\" flex \nng-if=\"!F.advancedSearchMode\"><md-button ng-if=\"F.profile.firm == F.center\" class=\"md-icon-button\" \naria-label=\"switch to advanced search\" ng-click=\"F.advancedSearchMode = !F.advancedSearchMode\"><md-tooltip \nmd-direction=\"left\">Búsqueda Avanzada</md-tooltip><md-icon ng-init=\'icn = \"icon-magnify\"\' \nng-mouseenter=\'icn = \"icon-filter\"\' ng-mouseleave=\'icn = \"icon-magnify\"\' md-font-icon=\"{{icn}}\" \nclass=\"white-text icon search-icon\"></md-icon></md-button><md-icon ng-if=\"F.profile.firm !== F.center\" \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input \nid=\"{{F.active.menuParent}}-{{F.active.menuName}}-search\" class=\"search-input\" type=\"text\" ms2-autofocus \nplaceholder=\'Buscar en {{F.active.menuObjName + \".PLURAL\" | translate}}\' \nng-change=\"[\'employees\', \'noEmployees\',\'realSalaryRecords\',\'movements\',\'healthcareRecords\',\'personalInfoEmployees\',\'employeeFiles\',\'employeesVacationsRecords\',\'credits\',\'logs\'].indexOf(F.active.menuName)>=0?getThem(true):clearSelected()\" \nflex ng-model=\"F.searchText[F.active.menuObjName]\" ng-model-options=\"{ debounce: F.debounceTime }\" \nng-if=\"!F.advancedSearchMode\"></div><div layout=\"row\" flex ng-if=\"!F.advancedSearchMode\"><div class=\"search\" \nng-if=\'filter.by == \"payroll\" || filter.by == \"data.payroll\"\' flex filter-payroll></div><div class=\"search\" \nng-if=\'filter.by == \"module\"\' flex filter-module></div><div class=\"search\" ng-if=\'filter.by == \"firm\"\' flex \nfilter-firm></div><div class=\"search\" ng-if=\'filter.by == \"companiesRecord\"\' flex filter-companies-record></div>\n<md-input-container flex=\"nogrow\"><md-button class=\"md-icon-button\" aria-label=\"reset simple search\" \nng-click=\"F.resetSearch(null, selected)\"><md-icon md-font-icon=\"icon-reload\" class=\"white-text\" \naria-label=\"reload-simple-filters\"></md-icon></md-button></md-input-container></div><div layout=\"row\" flex \nng-if=\"F.advancedSearchMode && F.profile.firm == F.center\"><md-input-container flex=\"nogrow\"><md-button \nng-if=\"F.profile.firm == F.center\" class=\"md-icon-button\" aria-label=\"switch to simple search\" \nng-click=\"F.advancedSearchMode = !F.advancedSearchMode\"><md-tooltip md-direction=\"left\">Búsqueda Simple</md-tooltip>\n<md-icon ng-init=\'icn = \"icon-filter\"\' ng-mouseenter=\'icn = \"icon-filter\"\' ng-mouseleave=\'icn = \"icon-magnify\"\' \nmd-font-icon=\"{{icn}}\" class=\"white-text icon search-icon\"></md-icon></md-button></md-input-container><div \nclass=\"search\" flex filter-by></div></div><div layout=\"row\" flex \nng-if=\"F.advancedSearchMode && F.profile.firm == F.center\"><div flex class=\"search\" \nng-if=\'[\"nss\",\"nombre\",\"certificado\"].indexOf(F.search.filterBy.name) !== -1 && F.search.filterBy.name && !F.search.filterBy.relatedBy\'>\n<md-input-container class=\"md-block\" flex-gt-xs md-no-float><input \nid=\"{{F.active.menuParent}}-{{F.active.menuName}}-search\" class=\"search-input\" type=\"text\" aria-label=\"advanced query\" \nms2-autofocus ng-model=\"F.search.query\" ng-model-options=\"{ debounce: F.debounceTime }\" ng-change=\"autocompleteThis()\">\n</md-input-container></div><div flex class=\"search\" \nng-if=\'[\"nss\",\"nombre\",\"certificado\"].indexOf(F.search.filterBy.name) == -1 && F.search.filterBy.name || F.search.filterBy.relatedBy\'>\n<md-autocomplete class=\"search-input\" md-min-length=\"2\" md-selected-item=\"F.search.$query\" \nmd-search-text=\"searchQuery\" md-selected-item-change=\"F.search.query=item.$id;autocompleteThis()\" \nmd-items=\'item in autocompleteList(searchQuery, F.search.filterBy.orderBy + \"s\", \"all\", F.search.filterBy.relatedBy)\' \nmd-item-text=\"item.name\" md-require-match=\"true\" md-select-on-match=\"true\" md-match-case-insensitive=\"true\">\n<md-item-template><span md-highlight-text=\"searchQuery\">{{item.name}}</span></md-item-template><md-not-found>\nNo hay registros</md-not-found></md-autocomplete></div><md-input-container flex=\"nogrow\"><md-button \nclass=\"md-icon-button\" aria-label=\"reset advanced search\" ng-click=\"F.resetAdvancedSearch()\"><md-icon \nmd-font-icon=\"icon-reload\" class=\"white-text\" aria-label=\"reload-advanced-filters\"></md-icon></md-button>\n</md-input-container></div></div>");
$templateCache.put("app/main/acommon/directives/inputs/fb-input-search.html","<div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"{{F.active.menuParent}}-{{F.active.menuName}}-search\" \nclass=\"search-input\" type=\"text\" ms2-autofocus \nplaceholder=\'Buscar en {{F.active.menuObjName + \".PLURAL\" | translate}}\' flex \nng-change=\"[\'employees\', \'noEmployees\',\'realSalaryRecords\',\'movements\',\'healthcareRecords\',\'personalInfoEmployees\',\'employeeFiles\',\'employeesVacationsRecords\',\'credits\',\'logs\'].indexOf(F.active.menuName)>=0?getThem(true):clearSelected()\" \nng-model=\"F.searchText[F.active.menuObjName]\" ng-model-options=\"{ debounce: F.debounceTime }\"><div class=\"search\" \nng-if=\'filter.by == \"payroll\"||filter.by == \"data.payroll\"\' flex filter-payroll></div><div class=\"search\" \nng-if=\'filter.by == \"module\"\' flex filter-module></div><div class=\"search\" ng-if=\'filter.by == \"firm\"\' flex \nfilter-firm></div><div class=\"search\" ng-if=\'filter.by == \"companiesRecord\"\' flex filter-companies-record></div><div \nng-if=\"filter\" ng-show=\'F.isAdmin && filterAll.by == \"employee\"  && filterAll.type == \"autocomplete\"\' flex \nfilter-autocomplete-employee md-padding></div><md-button class=\"md-icon-button\" aria-label=\"filter data\" \nng-click=\"F.resetSearch(null, selected);resetThisFilters();\"><md-icon md-font-icon=\"icon-reload\" class=\"white-text\" \naria-label=\"reload-filters\"></md-icon></md-button></div>");
$templateCache.put("app/main/acommon/directives/listFilters/action.html","<md-input-container class=\"md-block\" md-no-float><label>Acción</label><md-select ng-change=\'setModel(\"fromAction\")\' \nng-model=\"model[dataFilterN.action]\" placeholder=\"Seleccione una acción\"><md-select-header><input autocomplete=\"off\" \ntype=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"actionSelectFilter\" \nplaceholder=\"Busque una acción\"></md-select-header><md-option ng-value=\'\"all\"\'>Todos</md-option><md-option \nng-value=\"action.id\" ng-repeat=\"action in F.actions | orderBy:\'name\' | filter:actionSelectFilter\">{{action.name}}\n</md-option></md-select></md-input-container>");
$templateCache.put("app/main/acommon/directives/listFilters/apps.html","<md-input-container class=\"md-block\" md-no-float><label>APPS</label><md-select ng-model=\"model[dataFilterN.apps]\" \nng-change=\'setModel(\"fromApps\")\' placeholder=\"Aplicaciones\"><md-option value=\"geovictoria\" \nng-if=\"couldSyncGeovictoria\">GeoVictoria</md-option><md-option value=\"buk\" ng-if=\"couldSyncBuk\">Buk</md-option>\n<md-option value=\"humand\" ng-if=\"couldSyncHumand\">Humand</md-option></md-select></md-input-container>");
$templateCache.put("app/main/acommon/directives/listFilters/archived.html","<md-input-container class=\"md-block\" md-no-float><label>Archivado</label><md-select \nng-model=\"model[dataFilterN.archived]\" ng-change=\'setModel(\"fromArchived\")\' placeholder=\"Archivado\"><md-option \nvalue=\'{\"$ne\":\"all\"}\'>Todos</md-option><md-option value=\"true\">Si</md-option><md-option value=\'{\"$ne\":true}\'>No\n</md-option></md-select></md-input-container>");
$templateCache.put("app/main/acommon/directives/listFilters/batch-task-status.html","<md-input-container class=\"md-block\" md-no-float><label>Estatus envío</label><md-select \nng-model=\"model[dataFilterN.batchTaskStatus]\" ng-change=\'setModel(\"fromBatchTaskStatus\")\' multiple=\"multiple\">\n<md-option ng-repeat=\"($index,thisStatus) in F.statusBatchRecords\" ng-value=\"$index\">{{thisStatus}}</md-option>\n</md-select></md-input-container>");
$templateCache.put("app/main/acommon/directives/listFilters/calendar-select.html","<md-input-container class=\"md-block\" md-no-float><label>Calendario</label><md-select \nng-model=\"model[dataFilterN.calendarSelect]\" ng-change=\'setModel(\"fromCalendarSelect\")\'><md-option ng-value>Todos\n</md-option><md-option value=\"2021\">2021</md-option><md-option value=\"2022\">2022</md-option><md-option value=\"2023\">\n2023</md-option><md-option value=\"2024\">2024</md-option><md-option value=\"2025\">2025</md-option><md-option \nvalue=\"2026\">2026</md-option><md-option value=\"2027\">2027</md-option><md-option value=\"2028\">2028</md-option>\n</md-select></md-input-container>");
$templateCache.put("app/main/acommon/directives/listFilters/calendar.html","<md-input-container class=\"md-block\" md-no-float><label>Calendario</label><input type=\"text\" class=\"filter\" \nng-model=\"model[dataFilterN.calendar]\" ng-change=\'setModel(\"fromCalendar\")\' \nng-model-options=\"{ debounce: F.debounceTime }\"></md-input-container>");
$templateCache.put("app/main/acommon/directives/listFilters/cc.html","<md-input-container class=\"md-block\" md-no-float><label>Centro de Costo</label><md-select \nng-change=\'setModel(\"fromCc\")\' ng-model=\"model[dataFilterN.cc]\" placeholder=\"CC\"><md-select-header><input \nautocomplete=\"off\" type=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"ccSelectFilter\" \nplaceholder=\"Busque un Centro de Costosss\"></md-select-header><md-option ng-value=\"undefined\">Todos</md-option>\n<md-option ng-value=\"cc.$id\" \nng-repeat=\"cc in thisCcs | filter:ccSelectFilter | orderBy : [\'-valid\',\'name\'] track by cc.$id\" \nng-class=\"{\'inactiveOption\':!cc.valid}\">{{cc.name}} <small ng-bind=\"\'[\'+cc.rpName+\']\'\"></small></md-option></md-select>\n</md-input-container>");
$templateCache.put("app/main/acommon/directives/listFilters/companies-record-one.html","<md-input-container class=\"md-block\" md-no-float><label>Empresa</label><md-select \nng-model=\"model[dataFilterN.companiesRecordOne]\" ng-change=\'setModel(\"fromCompaniesRecordOne\")\' placeholder=\"Empresa\">\n<md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" \nng-model=\"companiesRecordOneSelectFilter\" placeholder=\"Busque una Empresa\"></md-select-header><md-option \nng-value=\"companiesRecord.$id \" \nng-repeat=\"companiesRecord in L.companiesRecords | orderBy:\'name\' | filter:companiesRecordOneSelectFilter\">\n{{companiesRecord.name}}</md-option></md-select></md-input-container>");
$templateCache.put("app/main/acommon/directives/listFilters/companies-record.html","<md-input-container class=\"md-block\" md-no-float><label>Empresa</label><md-select \nng-model=\"model[dataFilterN.companiesRecord]\" ng-change=\'setModel(\"fromCompaniesRecord\")\' placeholder=\"Empresa\" \nmultiple=\"multiple\"><md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" \nng-keydown=\"$event.stopPropagation()\" ng-model=\"companiesRecordSelectFilter\" placeholder=\"Busque una Empresa\">\n</md-select-header><md-option ng-value=\"companiesRecord.$id \" \nng-repeat=\"companiesRecord in companies | orderBy:\'name\' | filter:companiesRecordSelectFilter\">{{companiesRecord.name}}\n</md-option></md-select></md-input-container>");
$templateCache.put("app/main/acommon/directives/listFilters/concept-type.html","<md-input-container class=\"md-block\" md-no-float><label>Tipo de concepto</label><md-select \nng-model=\"model[dataFilterN.conceptType]\" ng-change=\'setModel(\"fromConceptType\")\'><md-option ng-value=\"undefined\">Todos\n</md-option><md-option ng-value=\'\"incidenceType\"\'>{{\'concept.INCIDENCETYPE\' | translate}}</md-option><md-option \nng-value=\'\"calc\"\'>{{\'concept.CALC\' | translate}}</md-option><md-option ng-value=\'\"accumulator\"\'>\n{{\'concept.ACCUMULATOR\' | translate}}</md-option></md-select></md-input-container>");
$templateCache.put("app/main/acommon/directives/listFilters/contract-status.html","<md-input-container class=\"md-block\" md-no-float><label>Status</label><md-select \nng-model=\"model[dataFilterN.contractStatus]\" ng-change=\'setModel(\"fromContractStatus\")\' placeholder=\"Estatus\">\n<md-option ng-value=\"all\">Todos</md-option><md-option ng-value=\"contractS.id\" \nng-repeat=\"contractS in F.contractStatuses | orderBy:\'name\' | filter:statusSelectFilter\">{{contractS.name}}</md-option>\n</md-select></md-input-container>");
$templateCache.put("app/main/acommon/directives/listFilters/credit-status.html","<md-input-container class=\"md-block\" md-no-float><label>Status</label><md-select \nng-model=\"model[dataFilterN.creditStatus]\" ng-change=\'setModel(\"fromCreditStatus\")\' placeholder=\"Status\"><md-option \nng-value=\"all\">Todos</md-option><md-option ng-value=\"creditS.id\" \nng-repeat=\"creditS in F.creditStatuses | orderBy:\'name\' | filter:statusSelectFilter\">{{creditS.name}}</md-option>\n</md-select></md-input-container>");
$templateCache.put("app/main/acommon/directives/listFilters/diff-factor.html","<md-checkbox ng-model=\"model[dataFilterN.diffFactor]\" ng-change=\'setModel(\"fromDiffFactor\")\' \nng-false-value=\"undefined\" aria-label=\"Different Factor\">Con factor diferente</md-checkbox>");
$templateCache.put("app/main/acommon/directives/listFilters/document-type.html","<md-input-container class=\"md-block\" md-no-float><label>Tipo de documento</label><md-select class=\"filter\" \nng-change=\'setModel(\"fromDocumentType\")\' ng-model=\"model[dataFilterN.documentType]\" placeholder=\"Tipo de documento\" \nmultiple=\"multiple\"><md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" \nng-keydown=\"$event.stopPropagation()\" ng-model=\"documentTypeSelectFilter\" placeholder=\"Busque un tipo de documento\">\n</md-select-header><md-option ng-value=\"document.id\" \nng-repeat=\"document in F.documentTypes | orderBy:\'name\' | filter:documentTypeSelectFilter\">{{document.name}}\n</md-option></md-select></md-input-container>");
$templateCache.put("app/main/acommon/directives/listFilters/employee-autocomplete.html","<md-autocomplete md-min-length=\"5\" md-input-name=\"autocompleteField\" md-no-cache=\"true\" \nmd-selected-item=\"F.selectedEmployee\" \nmd-selected-item-change=\"model[dataFilterN.employee]=F.selectedEmployee.$id;setModel(\'fromEmployee\')\" \nmd-search-text=\"F.searchEmployee\" \nmd-items=\'employee in autocompleteListM(F.searchEmployee, \"employees\",[\"data.name\",\"data.nss\"])\' \nmd-item-text=\"employee.data.name\" md-escape-options=\"clear\" md-clear-button=\"true\" \nmd-floating-label=\"Busca un empleado\" input-aria-describedby=\"Search an employee\"><md-item-template><span \nmd-highlight-text=\"F.searchEmployee\">{{employee.data.name}}</span></md-item-template><md-not-found>\nNo hay empleados con ese nombre</md-not-found><div ng-messages=\"searchForm.autocompleteField.$error\" \nng-if=\"searchForm.autocompleteField.$touched\"><div ng-message=\"md-require-match\">Seleccione un empleado de la lista\n</div></div></md-autocomplete>");
$templateCache.put("app/main/acommon/directives/listFilters/filter-toolbar.html","<div flex class=\"filterToolbar\" layout=\"row\" layout-align=\"start start\" ng-if=\"dataFilters.length\"><div flex \nlayout=\"column\" layout-gt-xs=\"row\"><div flex layout=\"row\" layout-align-gt-md=\"start center\" \nlayout-align=\"start center\" layout-wrap><div flex=\"100\" flex-gt-xs=\"{{flex.xs}}\" flex-gt-sm=\"{{flex.sm}}\" \nflex-gt-md=\"{{flex.md}}\" list-filter-apps ng-if=\'dataFilters.indexOf(\"apps\") !== -1\'></div><div flex=\"100\" \nflex-gt-xs=\"{{flex.xs}}\" flex-gt-sm=\"{{flex.sm}}\" flex-gt-md=\"{{flex.md}}\" list-filter-companies-record \nng-if=\'dataFilters.indexOf(\"companiesRecord\") !== -1\'></div><div flex=\"100\" flex-gt-xs=\"{{flex.xs}}\" \nflex-gt-sm=\"{{flex.sm}}\" flex-gt-md=\"{{flex.md}}\" list-filter-companies-record-one \nng-if=\'dataFilters.indexOf(\"companiesRecordOne\") !== -1\'></div><div flex=\"100\" flex-gt-xs=\"{{flex.xs}}\" \nflex-gt-sm=\"{{flex.sm}}\" flex-gt-md=\"{{flex.md}}\" list-filter-rp ng-if=\'dataFilters.indexOf(\"rp\") !== -1\'></div><div \nflex=\"100\" flex-gt-xs=\"{{flex.xs}}\" flex-gt-sm=\"{{flex.sm}}\" flex-gt-md=\"{{flex.md}}\" list-filter-payroll \nng-if=\'dataFilters.indexOf(\"payroll\") !== -1\'></div><div flex=\"100\" flex-gt-xs=\"{{flex.xs}}\" flex-gt-sm=\"{{flex.sm}}\" \nflex-gt-md=\"{{flex.md}}\" list-filter-payroll-wg ng-if=\'dataFilters.indexOf(\"payrollWg\") !== -1\'></div><div flex=\"100\" \nflex-gt-xs=\"{{flex.xs}}\" flex-gt-sm=\"{{flex.sm}}\" flex-gt-md=\"{{flex.md}}\" list-filter-cc \nng-if=\'dataFilters.indexOf(\"cc\") !== -1\'></div><div flex=\"100\" flex-gt-xs=\"{{flex.xs}}\" flex-gt-sm=\"{{flex.sm}}\" \nflex-gt-md=\"{{flex.md}}\" list-filter-employee-autocomplete ng-if=\'dataFilters.indexOf(\"employee\") !== -1\'></div><div \nflex=\"100\" flex-gt-xs=\"{{flex.xs}}\" flex-gt-sm=\"{{flex.sm}}\" flex-gt-md=\"{{flex.md}}\" list-filter-has-seniority-date \nng-if=\'dataFilters.indexOf(\"hasSeniorityDate\") !== -1\'></div><div flex=\"100\" flex-gt-xs=\"{{flex.xs}}\" \nflex-gt-sm=\"{{flex.sm}}\" flex-gt-md=\"{{flex.md}}\" list-filter-status ng-if=\'dataFilters.indexOf(\"status\") !== -1\'>\n</div><div flex=\"100\" flex-gt-xs=\"{{flex.xs}}\" flex-gt-sm=\"{{flex.sm}}\" flex-gt-md=\"{{flex.md}}\" list-filter-groupings \nng-if=\'dataFilters.indexOf(\"groupings\") !== -1\'></div><div flex=\"100\" flex-gt-xs=\"{{flex.xs}}\" \nflex-gt-sm=\"{{flex.sm}}\" flex-gt-md=\"{{flex.md}}\" list-filter-calendar ng-if=\'dataFilters.indexOf(\"calendar\") !== -1\'>\n</div><div flex=\"100\" flex-gt-xs=\"{{flex.xs}}\" flex-gt-sm=\"{{flex.sm}}\" flex-gt-md=\"{{flex.md}}\" \nlist-filter-calendar-select ng-if=\'dataFilters.indexOf(\"calendarSelect\") !== -1\'></div><div flex=\"100\" \nflex-gt-xs=\"{{flex.xs}}\" flex-gt-sm=\"{{flex.sm}}\" flex-gt-md=\"{{flex.md}}\" list-filter-month \nng-if=\'dataFilters.indexOf(\"month\") !== -1\'></div><div flex=\"100\" flex-gt-xs=\"{{flex.xs}}\" flex-gt-sm=\"{{flex.sm}}\" \nflex-gt-md=\"{{flex.md}}\" list-filter-month-birth ng-if=\'dataFilters.indexOf(\"monthBirth\") !== -1\'></div><div \nflex=\"100\" flex-gt-xs=\"{{flex.xs}}\" flex-gt-sm=\"{{flex.sm}}\" flex-gt-md=\"{{flex.md}}\" list-filter-period \nng-if=\'dataFilters.indexOf(\"period\") !== -1\'></div><div flex=\"100\" flex-gt-xs=\"{{flex.xs}}\" flex-gt-sm=\"{{flex.sm}}\" \nflex-gt-md=\"{{flex.md}}\" list-filter-has-error ng-if=\'dataFilters.indexOf(\"hasError\") !== -1\'></div><div flex=\"100\" \nflex-gt-xs=\"{{flex.xs}}\" flex-gt-sm=\"{{flex.sm}}\" flex-gt-md=\"{{flex.md}}\" list-filter-sent-status \nng-if=\'dataFilters.indexOf(\"sentStatus\") !== -1\'></div><div flex=\"100\" flex-gt-xs=\"{{flex.xs}}\" \nflex-gt-sm=\"{{flex.sm}}\" flex-gt-md=\"{{flex.md}}\" list-filter-credit-status \nng-if=\'dataFilters.indexOf(\"creditStatus\") !== -1\'></div><div flex=\"100\" flex-gt-xs=\"{{flex.xs}}\" \nflex-gt-sm=\"{{flex.sm}}\" flex-gt-md=\"{{flex.md}}\" list-filter-contract-status \nng-if=\'dataFilters.indexOf(\"contractStatus\") !== -1\'></div><div flex=\"100\" flex-gt-xs=\"{{flex.xs}}\" \nflex-gt-sm=\"{{flex.sm}}\" flex-gt-md=\"{{flex.md}}\" list-filter-modules-items \nng-if=\'dataFilters.indexOf(\"modulesItems\") !== -1\'></div><div flex=\"100\" flex-gt-xs=\"{{flex.xs}}\" \nflex-gt-sm=\"{{flex.sm}}\" flex-gt-md=\"{{flex.md}}\" list-filter-loan-status \nng-if=\'dataFilters.indexOf(\"loanStatus\") !== -1\'></div><div flex=\"100\" flex-gt-xs=\"{{flex.xs}}\" \nflex-gt-sm=\"{{flex.sm}}\" flex-gt-md=\"{{flex.md}}\" list-filter-movement-type \nng-if=\'dataFilters.indexOf(\"movementType\") !== -1\'></div><div flex=\"100\" flex-gt-xs=\"{{flex.xs}}\" \nflex-gt-sm=\"{{flex.sm}}\" flex-gt-md=\"{{flex.md}}\" list-filter-from-date ng-if=\'dataFilters.indexOf(\"fromDate\") !== -1\'>\n</div><div flex=\"100\" flex-gt-xs=\"{{flex.xs}}\" flex-gt-sm=\"{{flex.sm}}\" flex-gt-md=\"{{flex.md}}\" list-filter-to-date \nng-if=\'dataFilters.indexOf(\"toDate\") !== -1\'></div><div flex=\"100\" flex-gt-xs=\"{{flex.xs}}\" flex-gt-sm=\"{{flex.sm}}\" \nflex-gt-md=\"{{flex.md}}\" list-filter-operation-type ng-if=\'dataFilters.indexOf(\"operationType\") !== -1\'></div><div \nflex=\"100\" flex-gt-xs=\"{{flex.xs}}\" flex-gt-sm=\"{{flex.sm}}\" flex-gt-md=\"{{flex.md}}\" list-filter-concept-type \nng-if=\'dataFilters.indexOf(\"conceptType\") !== -1\'></div><div flex=\"100\" flex-gt-xs=\"{{flex.xs}}\" \nflex-gt-sm=\"{{flex.sm}}\" flex-gt-md=\"{{flex.md}}\" list-filter-nature ng-if=\'dataFilters.indexOf(\"nature\") !== -1\'>\n</div><div flex=\"100\" flex-gt-xs=\"{{flex.xs}}\" flex-gt-sm=\"{{flex.sm}}\" flex-gt-md=\"{{flex.md}}\" list-filter-formule \nng-if=\'dataFilters.indexOf(\"formule\") !== -1\'></div><div flex=\"100\" flex-gt-xs=\"{{flex.xs}}\" flex-gt-sm=\"{{flex.sm}}\" \nflex-gt-md=\"{{flex.md}}\" list-filter-profile ng-if=\'dataFilters.indexOf(\"profile\") !== -1\'></div><div flex=\"100\" \nflex-gt-xs=\"{{flex.xs}}\" flex-gt-sm=\"{{flex.sm}}\" flex-gt-md=\"{{flex.md}}\" list-filter-action \nng-if=\'dataFilters.indexOf(\"action\") !== -1\'></div><div flex=\"100\" flex-gt-xs=\"{{flex.xs}}\" flex-gt-sm=\"{{flex.sm}}\" \nflex-gt-md=\"{{flex.md}}\" list-filter-periodicity ng-if=\'dataFilters.indexOf(\"periodicity\") !== -1\'></div><div \nflex=\"100\" flex-gt-xs=\"{{flex.xs}}\" flex-gt-sm=\"{{flex.sm}}\" flex-gt-md=\"{{flex.md}}\" list-filter-document-type \nng-if=\'dataFilters.indexOf(\"documentType\") !== -1\'></div><div flex=\"100\" flex-gt-xs=\"{{flex.xs}}\" \nflex-gt-sm=\"{{flex.sm}}\" flex-gt-md=\"{{flex.md}}\" list-filter-ticket-status \nng-if=\'dataFilters.indexOf(\"ticketStatus\") !== -1\'></div><div flex=\"100\" flex-gt-xs=\"{{flex.xs}}\" \nflex-gt-sm=\"{{flex.sm}}\" flex-gt-md=\"{{flex.md}}\" list-filter-incidences-status \nng-if=\'dataFilters.indexOf(\"incidencesStatus\") !== -1\'></div><div flex=\"100\" flex-gt-xs=\"{{flex.xs}}\" \nflex-gt-sm=\"{{flex.sm}}\" flex-gt-md=\"{{flex.md}}\" list-filter-incidences-types \nng-if=\'dataFilters.indexOf(\"incidencesTypes\") !== -1\'></div><div flex=\"100\" flex-gt-xs=\"{{flex.xs}}\" \nflex-gt-sm=\"{{flex.sm}}\" flex-gt-md=\"{{flex.md}}\" list-filter-batch-task-status \nng-if=\'dataFilters.indexOf(\"batchTaskStatus\") !== -1\'></div><div flex=\"100\" flex-gt-xs=\"{{flex.xs}}\" \nflex-gt-sm=\"{{flex.sm}}\" flex-gt-md=\"{{flex.md}}\" list-filter-archived ng-if=\'dataFilters.indexOf(\"archived\") !== -1\'>\n</div></div><div ng-if=\"checkBoxSection > 0\" flex=\"nogrow\" layout-align-gt-md=\"start center\" \nlayout-align=\"start center\"><div flex=\"nogrow\" list-filter-diff-factor \nng-if=\'dataFilters.indexOf(\"diffFactor\") !== -1\'></div></div></div><div flex=\"nogrow\" layout=\"row\"><div flex=\"nogrow\">\n<md-button class=\"p-0 md-icon-button\" aria-label=\"delete filters\" ng-click=\"deleteFilters()\"><md-tooltip \nmd-direction=\"left\">Borrar Filtros</md-tooltip><md-icon md-font-icon=\"icon-filter-remove\" aria-label=\"delete filters\">\n</md-icon></md-button></div><div flex=\"nogrow\"><md-button class=\"p-0 md-icon-button\" aria-label=\"refresh\" \nng-click=\"fireChange()\"><md-tooltip md-direction=\"left\">Actualizar</md-tooltip><md-icon \nmd-font-icon=\"icon-backup-restore\" aria-label=\"refresh\"></md-icon></md-button></div><div flex=\"nogrow\" \nng-if=\"F.active.moreColumns.length\"><md-menu><md-button class=\"md-icon-button\" aria-label=\"add columns in the table\" \nng-click=\"openMenu($mdOpenMenu, $event)\"><md-tooltip md-direction=\"left\">Ver más Columnas</md-tooltip><md-icon \nmd-font-icon=\"icon-eye\" aria-label=\"read icon\"></md-icon></md-button><md-menu-content width=\"4\"><md-menu-item \nclass=\"h-auto\"><div class=\"overflow\"><fieldset class=\"standard\" layout=\"column\"><legend><b>Campos Disponibles</b>\n</legend><md-checkbox ng-repeat=\"($index, column) in columnsRepeat\" ng-model=\"column.show\" flex=\"\" \nng-true-value=\"true\" ng-false-value=\"false\" ng-click=\"createConfiguration($index, column, F.active.menuName)\">\n{{column.name}}</md-checkbox></fieldset></div></md-menu-item></md-menu-content></md-menu></div></div></div>");
$templateCache.put("app/main/acommon/directives/listFilters/formule.html","<md-input-container class=\"md-block\" md-no-float><label>Formula</label><input type=\"text\" \nng-model=\"model[dataFilterN.formule]\" ng-change=\'setModel(\"fromFormule\")\' \nng-model-options=\"{ debounce: F.debounceTime }\"></md-input-container>");
$templateCache.put("app/main/acommon/directives/listFilters/from-date.html","<md-input-container class=\"md-block date-picker filter\" md-no-float><label>Desde</label><md-datepicker \nmd-hide-icons=\"triangle\" ng-model=\"model[dataFilterN.fromDate]\" ng-change=\'setModel(\"fromFromDate\")\' \ninput-date-miliseconds name=\"from\"></md-datepicker></md-input-container>");
$templateCache.put("app/main/acommon/directives/listFilters/groupings.html","<md-input-container class=\"md-block\" md-no-float><label>Agrupaciones</label><md-select \nng-change=\'setModel(\"fromGroupings\")\' ng-model=\"model[dataFilterN.groupings]\" placeholder=\"Agrupaciones\" \nmultiple=\"multiple\"><md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" \nng-keydown=\"$event.stopPropagation()\" ng-model=\"groupingSelectFilter\" placeholder=\"Busque una Agrupación\">\n</md-select-header><md-option ng-value=\"grouping.$id\" \nng-repeat=\"grouping in L.groupings | orderBy:\'name\' | filter:groupingSelectFilter\">{{grouping.name | uppercase}}\n</md-option></md-select></md-input-container>");
$templateCache.put("app/main/acommon/directives/listFilters/has-error.html","<md-input-container class=\"md-block\" md-no-float><label>Errores</label><md-select \nng-model=\"model[dataFilterN.hasError]\" ng-change=\'setModel(\"fromHasError\")\' placeholder=\"Errores\"><md-option \nvalue=\"all\">Todos</md-option><md-option value=\'{\"$exists\":true}\'>Con errores</md-option><md-option \nvalue=\'{\"$exists\":false}\'>Sin Errores</md-option></md-select></md-input-container>");
$templateCache.put("app/main/acommon/directives/listFilters/hasSeniorityDate.html","<md-input-container class=\"md-block\" md-no-float><label>Tiene antigüedad</label><md-select \nng-change=\'setModel(\"fromHasSeniorityDate\")\' ng-model=\"model[dataFilterN.hasSeniorityDate]\" \nplaceholder=\"Tiene antigüedad\"><md-option ng-value=\"undefined\">Todos</md-option><md-option \nng-repeat=\"item in F.hasSeniorityDateOptions\" ng-value=\"item.id\">{{item.value}}</md-option></md-select>\n</md-input-container>");
$templateCache.put("app/main/acommon/directives/listFilters/incidences-status.html","<md-input-container class=\"md-block\" md-no-float><label>Estatus</label><md-select class=\"filter\" \nng-change=\'setModel(\"fromIncidencesStatus\")\' ng-model=\"model[dataFilterN.incidencesStatus]\" placeholder=\"Estatus\" \nmultiple=\"multiple\"><md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" \nng-keydown=\"$event.stopPropagation()\" ng-model=\"statusSelectFilter\" placeholder=\"Busque un Estatus\"></md-select-header>\n<md-option ng-value=\"status.id\" ng-repeat=\"status in F.incidenceStatuss | orderBy:\'-id\' | filter:statusSelectFilter\">\n{{status.name}}</md-option></md-select></md-input-container>");
$templateCache.put("app/main/acommon/directives/listFilters/incidences-types.html","<md-input-container class=\"md-block\" md-no-float><label>Tipo de incidencia</label><md-select class=\"filter\" \nng-change=\'setModel(\"fromIncidencesTypes\")\' ng-model=\"model[dataFilterN.incidencesTypes]\" \nplaceholder=\"Tipo de incidencia\"><md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" \nng-keydown=\"$event.stopPropagation()\" ng-model=\"incidencesSelectFilter\" placeholder=\"Busque un tipo de incidencia\">\n</md-select-header><md-option ng-value=\"incidences.$id\" \nng-repeat=\"incidences in L.incidencesTypes | orderBy:\'-id\' | filter:incidencesSelectFilter\">{{incidences.name}}\n</md-option></md-select></md-input-container>");
$templateCache.put("app/main/acommon/directives/listFilters/modules-items.html","<md-input-container class=\"md-block\" md-no-float><label>Modulos del sistema</label><md-select class=\"filter\" \nng-change=\'setModel(\"fromModulesItems\")\' ng-model=\"model[dataFilterN.modulesItems]\" placeholder=\"Modulo\" \nmultiple=\"multiple\"><md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" \nng-keydown=\"$event.stopPropagation()\" ng-model=\"modulesItemsSelectFilter\" placeholder=\"Busque un modulo\">\n</md-select-header><md-option ng-value=\"nav._id\" \nng-repeat=\"nav in F.navigationItems | orderBy:\'name\' | filter:modulesItemsSelectFilter\"><md-icon ng-if=\"nav.icon\" \nmd-font-icon=\"{{nav.icon}}\"></md-icon>{{nav.title}}</md-option></md-select></md-input-container>");
$templateCache.put("app/main/acommon/directives/listFilters/month.html","<md-input-container class=\"md-block\" md-no-float><label>Mes</label><md-select ng-change=\'setModel(\"fromMonth\")\' \nng-model=\"model[dataFilterN.month]\" placeholder=\"Seleccione un mes\"><md-option ng-value>Todos</md-option><md-option \nng-value=\"1\">Enero</md-option><md-option ng-value=\"2\">Febrero</md-option><md-option ng-value=\"3\">Marzo</md-option>\n<md-option ng-value=\"4\">Abril</md-option><md-option ng-value=\"5\">Mayo</md-option><md-option ng-value=\"6\">Junio\n</md-option><md-option ng-value=\"7\">Julio</md-option><md-option ng-value=\"8\">Agosto</md-option><md-option ng-value=\"9\">\nSeptiembre</md-option><md-option ng-value=\"10\">Octubre</md-option><md-option ng-value=\"11\">Noviembre</md-option>\n<md-option ng-value=\"12\">Diciembre</md-option></md-select></md-input-container>");
$templateCache.put("app/main/acommon/directives/listFilters/monthBirth.html","<md-input-container class=\"md-block\" md-no-float><label ng-if=\"F.active.menuName === \'anniversaryEmployees\'\">\nMes de aniversario</label><label ng-if=\"F.active.menuName !== \'anniversaryEmployees\'\">\n{{F.active.menuName === \'employeeBirths\'? \'Mes de cumpleaños\': \'Mes de vencimiento de contratos\'}}</label><md-select \nng-change=\'setModel(\"fromMonthBirth\")\' ng-model=\"model[dataFilterN.monthBirth]\" placeholder=\"Seleccione el mes\">\n<md-option ng-value=\"all\">Todos</md-option><md-option ng-value=\"1\">Enero</md-option><md-option ng-value=\"2\">Febrero\n</md-option><md-option ng-value=\"3\">Marzo</md-option><md-option ng-value=\"4\">Abril</md-option><md-option ng-value=\"5\">\nMayo</md-option><md-option ng-value=\"6\">Junio</md-option><md-option ng-value=\"7\">Julio</md-option><md-option \nng-value=\"8\">Agosto</md-option><md-option ng-value=\"9\">Septiembre</md-option><md-option ng-value=\"10\">Octubre\n</md-option><md-option ng-value=\"11\">Noviembre</md-option><md-option ng-value=\"12\">Diciembre</md-option></md-select>\n</md-input-container>");
$templateCache.put("app/main/acommon/directives/listFilters/movement-type.html","<md-input-container class=\"md-block\" md-no-float><label>TIpo de movimiento</label><md-select \nng-model=\"model[dataFilterN.movementType]\" ng-change=\'setModel(\"fromMovementType\")\' multiple=\"multiple\"><md-option \nng-value=\"movementType.id\" \nng-repeat=\"movementType in F.movementTypes | orderBy:\'name\' | filter:movementTypeSelectFilter\">{{movementType.name}}\n</md-option></md-select></md-input-container>");
$templateCache.put("app/main/acommon/directives/listFilters/nature.html","<md-input-container class=\"md-block\" md-no-float><label>Naturaleza</label><md-select \nng-model=\"model[dataFilterN.nature]\" ng-change=\'setModel(\"fromNature\")\'><md-option ng-value=\"undefined\">Todos\n</md-option><md-option ng-value=\'\"deduction\"\'>{{\'concept.DEDUCTION\' | translate}}</md-option><md-option \nng-value=\'\"perception\"\'>{{\'concept.PERCEPTION\' | translate}}</md-option><md-option ng-value=\'{\"$exists\":false}\'>\nSin Especificar</md-option></md-select></md-input-container>");
$templateCache.put("app/main/acommon/directives/listFilters/operation-type.html","<md-input-container class=\"md-block\" md-no-float><label>TIpo de operación</label><md-select \nng-model=\"model[dataFilterN.operationType]\" ng-change=\'setModel(\"fromOperationType\")\'><md-option value=\"all\">Todos\n</md-option><md-option value=\"ordinary\">Ordinaria</md-option><md-option value=\"settlement\">Finiquito</md-option>\n<md-option value=\"special\">Especial</md-option><md-option value=\"extraordinary\">Extraordinaria</md-option><md-option \nvalue=\"asimilated\">Asimilados</md-option><md-option value=\"advAndLoanOpe\">Anticipos y prestamos</md-option><md-option \nvalue=\"travelExpensesOpe\">Viáticos</md-option><md-option value=\"chrisBonusRecord\">Aguinaldos</md-option><md-option \nvalue=\"ptuRecord\">PTU</md-option><md-option value=\"ptuDistributionRecord\">PTU Distribución</md-option></md-select>\n</md-input-container>");
$templateCache.put("app/main/acommon/directives/listFilters/payroll.html","<md-input-container class=\"md-block\" md-no-float><label>Nomina</label><md-select ng-change=\'setModel(\"fromPayroll\")\' \nng-model=\"model[dataFilterN.payroll]\" placeholder=\"Nómina\"><md-select-header><input autocomplete=\"off\" type=\"search\" \nid=\"searchPayroll\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"payrollSelectFilter\" \nplaceholder=\"Busque una nómina\"></md-select-header><md-option ng-value=\"undefined\">Todos</md-option><md-option \nng-if=\"!F.permissionToAccessAllPayrolls\" ng-class=\"{\'inactiveOption\': !payroll.active}\" ng-value=\"payroll.$id\" \nng-repeat=\"payroll in L.payrolls | filter:payrollSelectFilter | orderBy : [\'-active\',\'name\']\" \nng-bind=\"payroll.class+\' \'+payroll.name\"></md-option><md-option ng-if=\"F.permissionToAccessAllPayrolls\" \nng-class=\"{\'inactiveOption\': !payroll.active}\" ng-value=\"payroll.$id\" \nng-repeat=\"payroll in L.allPayrolls | filter:payrollSelectFilter | orderBy: [\'-active\',\'name\']\" \nng-bind=\"payroll.class+\' \'+payroll.name\"></md-option></md-select></md-input-container>");
$templateCache.put("app/main/acommon/directives/listFilters/payrollWg.html","<md-input-container class=\"md-block\" md-no-float><label>Nomina</label><md-select ng-change=\'setModel(\"fromPayroll\")\' \nng-model=\"model[dataFilterN.payrollWg]\" placeholder=\"Nómina\"><md-select-header><input autocomplete=\"off\" type=\"search\" \nid=\"searchPayroll\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"payrollSelectFilter\" \nplaceholder=\"Busque una nómina\"></md-select-header><md-option ng-value=\"undefined\">Todos</md-option><md-option \nng-value=\"\'global\'\">Global</md-option><md-option ng-if=\"!F.permissionToAccessAllPayrolls\" \nng-class=\"{\'inactiveOption\': !payroll.active}\" ng-value=\"payroll.$id\" \nng-repeat=\"payroll in L.payrolls | orderBy:\'name\' | filter:payrollSelectFilter\" \nng-bind=\"payroll.class+\' \'+payroll.name\"></md-option><md-option ng-if=\"F.permissionToAccessAllPayrolls\" \nng-class=\"{\'inactiveOption\': !payroll.active}\" ng-value=\"payroll.$id\" \nng-repeat=\"payroll in L.allPayrolls | orderBy:\'name\' | filter:payrollSelectFilter\" \nng-bind=\"payroll.class+\' \'+payroll.name\"></md-option></md-select></md-input-container>");
$templateCache.put("app/main/acommon/directives/listFilters/period.html","<md-input-container class=\"md-block\" md-no-float><label>Periodo</label><input type=\"text\" \nng-model=\"model[dataFilterN.period]\" ng-change=\'setModel(\"fromPeriod\")\' \nng-model-options=\"{ debounce: F.debounceTime }\"></md-input-container>");
$templateCache.put("app/main/acommon/directives/listFilters/periodicity.html","<md-input-container class=\"md-block\" md-no-float><label>Periodicidad</label><md-select \nng-model=\"model[dataFilterN.periodicity]\" ng-change=\'setModel(\"fromPeriodicity\")\'><md-option ng-value>Todos</md-option>\n<md-option ng-value=\"period.id\" ng-repeat=\"period in F.periodicity\">{{period.name}}</md-option></md-select>\n</md-input-container>");
$templateCache.put("app/main/acommon/directives/listFilters/profile.html","<md-input-container class=\"md-block\" md-no-float><label>Usuario</label><md-select ng-change=\'setModel(\"fromProfile\")\' \nng-model=\"model[dataFilterN.profile]\" placeholder=\"Seleccione una usuario\"><md-select-header><input autocomplete=\"off\" \ntype=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"profileSelectFilter\" \nplaceholder=\"Busque un usuario\"></md-select-header><md-option ng-value=\'\"all\"\'>Todos</md-option><md-option \nng-value=\"profile.$id\" ng-repeat=\"profile in L.profiles | orderBy:\'name\' | filter:profileSelectFilter\">{{profile.name}}\n</md-option></md-select></md-input-container>");
$templateCache.put("app/main/acommon/directives/listFilters/rp.html","<md-input-container class=\"md-block\" md-no-float><label>Registro Patronal</label><md-select \nng-model=\"model[dataFilterN.rp]\" ng-change=\'setModel(\"fromRp\")\' placeholder=\"RP\"><md-select-header><input \nautocomplete=\"off\" type=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"rpSelectFilter\" \nplaceholder=\"Busque un Registro Patronal\"></md-select-header><md-option ng-value=\"undefined\">Todos</md-option>\n<md-option ng-value=\"rp.$id\" ng-repeat=\"rp in L.rps | filter:rpSelectFilter | orderBy:[\'-active\', \'name\']\" \nng-class=\"{\'inactiveOption\': !rp.active}\" ng-bind=\"rp.name\"></md-option></md-select></md-input-container>");
$templateCache.put("app/main/acommon/directives/listFilters/sent-status.html","<md-input-container class=\"md-block\" md-no-float><label>Estatus del envío</label><md-select \nng-model=\"model[dataFilterN.sentStatus]\" ng-change=\'setModel(\"fromSentStatus\")\' placeholder=\"Estatus del envío\">\n<md-option value=\"all\">Todos</md-option><md-option ng-value=\"status.id\" \nng-repeat=\"status in F.sentStatuses | orderBy:\'name\'\">{{status.name}}</md-option><md-option ng-value=\"{$exists:false}\">\nNo enviado</md-option></md-select></md-input-container>");
$templateCache.put("app/main/acommon/directives/listFilters/status.html","<md-input-container class=\"md-block\" md-no-float><label>Status</label><md-select class=\"filter\" \nng-change=\'setModel(\"fromStatus\")\' ng-model=\"model[dataFilterN.status]\" placeholder=\"Status\" multiple=\"multiple\">\n<md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" \nng-model=\"statusSelectFilter\" placeholder=\"Busque un Status\"></md-select-header><md-option ng-value=\"status.id\" \nng-repeat=\"status in F.employeeStatatuss | orderBy:\'name\' | filter:statusSelectFilter\">{{status.name}}</md-option>\n</md-select></md-input-container>");
$templateCache.put("app/main/acommon/directives/listFilters/ticket-status.html","<md-input-container class=\"md-block\" md-no-float><label>Estatus del ticket</label><md-select class=\"filter\" \nng-change=\'setModel(\"fromTicketStatus\")\' ng-model=\"model[dataFilterN.ticketStatus]\" placeholder=\"Estatus del ticket\" \nmultiple=\"multiple\"><md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" \nng-keydown=\"$event.stopPropagation()\" ng-model=\"ticketStatusSelectFilter\" placeholder=\"Busque un estatus del ticket\">\n</md-select-header><md-option ng-value=\"statusTicket.id\" \nng-repeat=\"statusTicket in F.ticketStatus | orderBy:\'name\' | filter:ticketStatusSelectFilter\">{{statusTicket.name}}\n</md-option></md-select></md-input-container>");
$templateCache.put("app/main/acommon/directives/listFilters/to-date.html","<md-input-container class=\"md-block date-picker filter\" md-no-float><label>Hasta</label><md-datepicker \nmd-hide-icons=\"triangle\" ng-model=\"model[dataFilterN.toDate]\" ng-change=\'setModel(\"fromToDate\")\' \ninput-date-miliseconds name=\"to\"></md-datepicker></md-input-container>");
$templateCache.put("app/main/apps/calendar/dialogs/bottom-list-grid.html","<md-bottom-sheet class=\"md-list md-has-header bottomList\"><md-subheader ng-cloak>\n{{F.calendarEvent.title}} - {{(F.calendarEvent.start)}}</md-subheader><md-content layout-fill stop-touch-event>\n<md-table-container><table md-table id=\"payrollEventsInCalendar\" class=\"row-border\"><thead md-head><tr md-row><th \nmd-column><span>Nomina</span></th><th md-column ng-repeat=\"status in F.operationStatatuss\" ng-if=\"status.id!=0\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button\" aria-label=\"{{status.name |uppercase}}\">\n<md-tooltip md-direction=\"top\">{{status.name |uppercase}}</md-tooltip><md-icon md-font-icon=\"{{status.icon}}\">\n</md-icon></md-button></div></th></tr></thead><tbody md-body><tr md-row \nng-repeat=\"(id, obj) in F.calendarEvent.operations\"><td md-cell><a ng-if=\"F.permissionToAccessAllPayrolls\" \nng-click=\"goToOperation(obj)\">{{obj.payroll|nameOfL:L.allPayrolls | uppercase}} <strong ng-bind=\'\"P\"+obj.period\'>\n</strong></a> <a ng-if=\"!F.permissionToAccessAllPayrolls\" ng-click=\"goToOperation(obj)\">\n{{obj.payroll|nameOfL:L.payrolls | uppercase}} <strong ng-bind=\'\"P\"+obj.period\'></strong></a></td><td md-cell \nng-repeat=\"status in F.operationStatatuss\" ng-if=\"status.id!=0\"><div layout=\"row\" layout-align=\"start center\">\n<md-button ng-if=\"obj.status>=status.id\" class=\"md-icon-button md-primary md-hue-2\" aria-label=\"ok\"><md-tooltip \nmd-direction=\"top\">Se completo este status</md-tooltip><md-icon md-font-icon=\"icon-check-circle\"></md-icon></md-button>\n<md-button ng-if=\"obj.status<status.id && (F.calendarEvent.start|isGratherThan:today)\" class=\"md-icon-button\" \naria-label=\"waiting\"><md-tooltip md-direction=\"top\">Esperando</md-tooltip><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle-outline\"></md-icon></md-button><md-button \nng-if=\"obj.status<status.id && !(F.calendarEvent.start|isGratherThan:today)\" class=\"md-icon-button md-warn md-hue-2\" \naria-label=\"atention needed\"><md-tooltip md-direction=\"top\">Requiere atencion de usuario</md-tooltip><md-icon \nmd-font-icon=\"icon-alert\"></md-icon></md-button></div></td></tr></tbody></table></md-table-container></md-content>\n</md-bottom-sheet>");
$templateCache.put("app/main/apps/dashboards/server/dashboard-server.html","<div id=\"dashboard-server\"><div id=\"widgets\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nflippable=\"false\" layout=\"row\" flex=\"100\"><ms-widget-front class=\"p-16 white-bg\"><div class=\"pb-16\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">{{vm.widget1.title}}</div><md-menu><md-button aria-label=\"more\" \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh\n</md-button></md-menu-item></md-menu-content></md-menu></div><div><nvd3 class=\"h-320\" class=\"remove-x-lines\" \noptions=\"vm.widget1.chart.options\" data=\"vm.widget1.chart.data\"></nvd3></div></ms-widget-front></ms-widget></div><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"p-16 pink-400-bg white-fg\"><div class=\"pb-24\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-icon class=\"m-0 mr-8\" \nmd-font-icon=\"icon-harddisk\"></md-icon><div class=\"h3\">{{vm.widget2.title}}</div></div><md-menu><md-button \naria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\">\n</md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" \naria-label=\"Flip widget\">Details</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" \naria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pb-24\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"h2\">{{vm.widget2.value.used}}</div><div \nclass=\"h2 secondary-text pl-8\">/ {{vm.widget2.value.total}}</div></div><md-progress-linear md-mode=\"determinate\" \nvalue=\"{{vm.widget2.value.percentage}}\"></md-progress-linear></ms-widget-front><ms-widget-back \nclass=\"p-16 pr-32 pink-400-bg white-fg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" \nng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button>\n</div><div>{{vm.widget2.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" \nflex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"p-16 blue-bg white-fg\"><div class=\"pb-24\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nclass=\"m-0 mr-8\" md-font-icon=\"icon-server-network\"></md-icon><div class=\"h3\">{{vm.widget3.title}}</div></div><md-menu>\n<md-button aria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu>\n</div><div class=\"pb-24\" layout=\"row\" layout-align=\"start end\"><div class=\"h2\">{{vm.widget3.value.used}}</div><div \nclass=\"h2 pl-8 secondary-text\">/ {{vm.widget3.value.total}}</div></div><md-progress-linear md-mode=\"determinate\" \nvalue=\"{{vm.widget3.value.percentage}}\"></md-progress-linear></ms-widget-front><ms-widget-back \nclass=\"p-16 pr-32 blue-bg white-fg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" \nng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button>\n</div><div>{{vm.widget3.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" \nflex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"p-16 teal-400-bg white-fg\"><div class=\"pb-24\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nclass=\"m-0 mr-8\" md-font-icon=\"icon-clock-fast\"></md-icon><div class=\"h3\">{{vm.widget4.title}}</div></div><md-menu>\n<md-button aria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu>\n</div><div class=\"pb-8 h1\">{{vm.widget4.value}}</div><div class=\"chart-fill-16\"><nvd3 \nclass=\"h-50 remove-opacity remove-line-stroke\" config=\"vm.widget4.chart.config\" options=\"vm.widget4.chart.options\" \ndata=\"vm.widget4.chart.data\"></nvd3></div></ms-widget-front><ms-widget-back class=\"p-16 pr-32 teal-400-bg white-fg\">\n<div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon \nmd-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>{{vm.widget4.detail}}</div></ms-widget-back>\n</ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front \nclass=\"p-16 indigo-400-bg white-fg\"><div class=\"pb-24\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-icon class=\"m-0 mr-8\" md-font-icon=\"icon-scale\"></md-icon><div class=\"h3\">\n{{vm.widget5.title}}</div></div><md-menu><md-button aria-label=\"more\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content \nwidth=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details</md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item>\n</md-menu-content></md-menu></div><div layout=\"column\" layout-align=\"space-between\" flex><div class=\"h1 pb-8\" \nlayout=\"row\" layout-align=\"start center\"><span>{{vm.widget5.value}}</span><md-icon md-font-icon=\"icon-trending-down\" \nclass=\"ml-16\"></md-icon></div><div class=\"secondary-text\">{{vm.widget5.footnote}}</div></div></ms-widget-front>\n<ms-widget-back class=\"p-16 pr-32 indigo-400-bg white-fg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" \nng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button>\n</div><div>{{vm.widget5.detail}}</div></ms-widget-back></ms-widget></div><div class=\"widget-group\" layout=\"row\" \nflex=\"100\" layout-wrap><ms-widget flippable=\"false\" layout=\"row\" flex=\"100\"><ms-widget-front class=\"p-16 white-bg\"><div\n class=\"pb-24\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{vm.widget6.title}}</div><md-menu>\n<md-button aria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu>\n</div><div><nvd3 class=\"h-140 remove-x-lines remove-opacity\" config=\"vm.widget6.chart.config\" \noptions=\"vm.widget6.chart.options\" data=\"vm.widget6.chart.data\"></nvd3></div></ms-widget-front></ms-widget></div><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"false\" layout=\"row\" flex=\"100\" \nflex-gt-md=\"60\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 pv-24 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><span class=\"h3\">{{vm.widget7.title}}\n</span> <span class=\"ml-16 text-boxed pink-bg white-fg\">{{vm.widget7.table.rows.length}} processes</span></div>\n<md-menu><md-button aria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu>\n</div><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.widget7.dtOptions\"><thead><tr><th \nclass=\"secondary-text\" ng-repeat=\"column in ::vm.widget7.table.columns\"><div class=\"table-header\"><span \nclass=\"column-title\">{{column.title}}</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in ::vm.widget7.table.rows\"><td ng-repeat=\"cell in row\"><span class=\"{{cell.classes}}\">{{cell.value}}\n</span></td></tr></tbody></table></ms-widget-front></ms-widget><ms-widget flippable=\"false\" layout=\"row\" flex=\"100\" \nflex-gt-md=\"40\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 pv-24 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><span class=\"h3\">{{vm.widget8.title}}\n</span> <span class=\"ml-16 text-boxed blue-bg white-fg\">Showing last {{vm.widget8.activities.length}} activity</span>\n</div><md-menu><md-button aria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu>\n</div><div class=\"ph-16 pv-15 border-bottom\" layout=\"row\" layout-align=\"start center\" \nng-repeat=\"activity in vm.widget8.activities\"><div><i class=\"icon pr-16 mr-16 border-right\" \nng-class=\"{\'icon-arrow-down red-fg\':activity.type === \'Input\', \'icon-arrow-up green-fg\':activity.type === \'Output\'}\">\n</i></div><div class=\"h4 text-bold\" flex>{{activity.process}}</div><div class=\"h4 font-weight-500 secondary-text\">\n{{activity.value}}</div></div></ms-widget-front></ms-widget></div></div></div>");
$templateCache.put("app/main/apps/dashboards/analytics/dashboard-analytics.html","<div id=\"dashboard-analytics\"><div id=\"widgets\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap>\n<ms-widget flippable=\"false\" layout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div class=\"p-24 border-bottom\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{vm.widget1.title}}</div><div \nclass=\"text-boxed green-600-bg white-fg\">{{vm.widget1.onlineUsers}} online users</div></div><div \nclass=\"pb-32 border-bottom\"><nvd3 class=\"h-400 remove-x-lines remove-opacity\" options=\"vm.widget1.bigChart.options\" \ndata=\"vm.widget1.bigChart.data\"></nvd3></div><div layout=\"row\" layout-align=\"start center\" layout-wrap><div \nclass=\"p-24 grey-50-bg\" layout=\"row\" layout-align=\"start center\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><div \nlayout=\"column\" flex><div class=\"h3 secondary-text pb-8\">{{vm.widget1.sessions.title}}</div><div \nclass=\"font-size-32 line-height-32 pb-16\">{{vm.widget1.sessions.value}}</div><div><nvd3 class=\"h-40\" \noptions=\"vm.widget1.sessions.options\" data=\"vm.widget1.sessions.data\"></nvd3></div></div></div><div \nclass=\"p-24 grey-50-bg\" layout=\"row\" layout-align=\"start center\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><div \nlayout=\"column\" flex><div class=\"h3 secondary-text pb-8\">{{vm.widget1.pageviews.title}}</div><div \nclass=\"font-size-32 line-height-32 pb-16\">{{vm.widget1.pageviews.value}}</div><div><nvd3 class=\"h-40\" \noptions=\"vm.widget1.pageviews.options\" data=\"vm.widget1.pageviews.data\"></nvd3></div></div></div><div \nclass=\"p-24 grey-50-bg\" layout=\"row\" layout-align=\"start center\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><div \nlayout=\"column\" flex><div class=\"h3 secondary-text pb-8\">{{vm.widget1.pagesSessions.title}}</div><div \nclass=\"font-size-32 line-height-32 pb-16\">{{vm.widget1.pagesSessions.value}}</div><div><nvd3 class=\"h-40\" \noptions=\"vm.widget1.pagesSessions.options\" data=\"vm.widget1.pagesSessions.data\"></nvd3></div></div></div><div \nclass=\"p-24 grey-50-bg\" layout=\"row\" layout-align=\"start center\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><div \nlayout=\"column\" flex><div class=\"h3 secondary-text pb-8\">{{vm.widget1.avgSessionDuration.title}}</div><div \nclass=\"font-size-32 line-height-32 pb-16\">{{vm.widget1.avgSessionDuration.value}}</div><div><nvd3 class=\"h-40\" \noptions=\"vm.widget1.avgSessionDuration.options\" data=\"vm.widget1.avgSessionDuration.data\"></nvd3></div></div></div>\n</div></ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nflippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-md=\"65\"><ms-widget-front class=\"white-bg\"><div class=\"p-16\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{vm.widget2.title}}</div><md-menu><md-button \naria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\">\n</md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"refreshWidget()\" \naria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div><div>\n<ui-gmap-google-map center=\"vm.widget2.map.center\" zoom=\"vm.widget2.map.zoom\" options=\"vm.widget2.map.options\">\n<ui-gmap-markers models=\"vm.widget2.map.markers\" coords=\"\'coords\'\"><ui-gmap-windows show=\"show\"><div ng-non-bindable>\n{{sessions}}</div></ui-gmap-windows></ui-gmap-markers></ui-gmap-google-map></div></ms-widget-front></ms-widget>\n<ms-widget flippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-md=\"35\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{vm.widget3.title}}</div>\n<div class=\"pv-16\"><md-select class=\"simplified\" ng-model=\"vm.widget3.currentRange\" aria-label=\"Change range\">\n<md-option ng-repeat=\"(key, range) in vm.widget3.ranges\" value=\"{{key}}\">{{range}}</md-option></md-select></div></div>\n<div class=\"ph-16 pv-20 border-bottom\" ng-repeat=\"page in vm.widget3.pages[vm.widget3.currentRange]\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"column\" flex><span class=\"h4 pb-10\">{{page.path}}</span>\n<md-progress-linear class=\"md-accent\" md-mode=\"determinate\" value=\"{{page.value}}\"></md-progress-linear></div><div \nclass=\"pl-32 h3 font-weight-500 secondary-text\">{{page.value}}%</div></div></ms-widget-front></ms-widget></div><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"false\" layout=\"row\" flex=\"100\">\n<ms-widget-front class=\"white-bg\"><div class=\"ph-16 pt-16 pb-8 md-accent-bg\"><div class=\"h3\">{{vm.widget4.title}}</div>\n</div><md-tabs class=\"md-accent no-radius\" md-dynamic-height><md-tab label=\"{{tab.label}}\" \nng-repeat=\"tab in vm.widget4.tabs\"><div layout=\"row\" layout-align=\"start center\" layout-wrap><div flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\" ng-repeat=\"group in tab.groups\"><div class=\"h2 m-16 pb-16 border-bottom\">\n{{group.title}}</div><div class=\"p-16 pb-32\" ng-repeat=\"data in group.data\"><div class=\"pb-8\" layout=\"row\" \nlayout-align=\"space-between start\"><span class=\"h3\">{{data.title}}</span> <span \nclass=\"h3 secondary-text font-weight-500\">{{data.value}}%</span></div><md-progress-linear \nclass=\"{{data.progressColor}}\" md-mode=\"determinate\" value=\"{{data.value}}\"></md-progress-linear></div></div></div>\n</md-tab></md-tabs></ms-widget-front></ms-widget></div></div></div>");
$templateCache.put("app/main/apps/dashboards/project/dashboard-project.html","<div id=\"dashboard-project\" class=\"flex\"><iframe ng-src=\"{{dashboardUrl}}\" width=\"100%\" height=\"100%\"><p>\nYour browser does not support iframes.</p></iframe></div>");
$templateCache.put("app/main/catalogs/views/bankAccounts/bankAccount.html","<div id=\"bankAccount\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill \nng-controller=\"BankAccountController\"><form name=\"form\" novalidate flex layout=\"column\" ng-disabled=\"F.readMode\"><div \nmongo-crud-detail-bar flex=\"nogrow\"></div><md-content layout=\"column\" class=\"content main-content-bg\" flex><div \nclass=\"detail-form-container md-background-bg md-whiteframe-2dp\"><header class=\"section-header\" \nlayout-align=\"start start\" layout=\"row\"><div flex=\"nogrow\" class=\"mr-5\"><md-icon \nmd-svg-src=\"/assets/icons/banklogo.svg\"></md-icon></div><div flex=\"95\"><h2>Información General</h2></div></header><div \nclass=\"ba-row\" layout=\"row\" layout-xs=\"column\" layout-md=\"row\" layout-gt-xs=\"row\"><md-input-container \nclass=\"md-block ba-field nomargin\" flex=\"25\" flex-md=\"20\" flex-sm=\"15\" flex-xs=\"100\"><label>Empresa</label><md-select \nng-model=\"bankAccount.companiesRecord\" placeholder=\"Seleccione Empresa\" required><md-select-header \nclass=\"ba-select-header\"><input autocomplete=\"off\" type=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" \nng-model=\"companiesRecordSelectFilter\" placeholder=\"Busque una Empresa\"></md-select-header><md-option \nng-value=\"companiesRecord.$id\" \nng-repeat=\"companiesRecord in L.companiesRecords | orderBy:\'name\' | filter:companiesRecordSelectFilter\">\n{{companiesRecord.name}}</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block ba-field nomargin\" flex=\"25\" flex-sm=\"15\" flex-md=\"20\" flex-xs=\"100\"><label>Nombre de la Cuenta</label>\n<input ng-model=\"bankAccount.name\" class=\"uppercased\" ng-model-options=\"{ debounce: F.debounceTime }\" type=\"text\" \nname=\"name\" required></md-input-container><div flex=\"50\" flex-md=\"60\" flex-sm=\"70\" flex-xs=\"100\" layout=\"row\" \nlayout-xs=\"column\"><div class=\"custom-switch-card\" ng-class=\"{\'active\': bankAccount.isSpei}\" flex=\"33\" flex-xs=\"100\">\n<md-switch ng-change=\"bankAccount.isSpei ? bankAccount.couldEmmit = false : \'\'\" ng-model=\"bankAccount.isSpei\" \nng-disabled=\"F.readMode\" aria-label=\"Es SPEI\"><div class=\"switch-label-group\"><span class=\"main-label\">Es SPEI</span> \n<span class=\"sub-label\">Transferencia inmediata</span></div></md-switch></div><div class=\"custom-switch-card\" \nng-if=\"!bankAccount.isSpei\" flex=\"33\" ng-class=\"{\'active\': bankAccount.couldEmmit}\" flex-xs=\"100\"><md-switch \nng-model=\"bankAccount.couldEmmit\" ng-disabled=\"F.readMode\" aria-label=\"Puede Emitir\"><div class=\"switch-label-group\">\n<span class=\"main-label\">Emisión</span> <span class=\"sub-label\">Generar tarjetas</span></div></md-switch></div><div \nclass=\"custom-switch-card status-switch\" ng-if=\"!F.addMode\" flex=\"33\" ng-class=\"{\'inactive\': !bankAccount.status}\" \nflex-xs=\"100\"><md-switch ng-model=\"bankAccount.status\" ng-disabled=\"F.readMode\" aria-label=\"Estado\"><div \nclass=\"switch-label-group\"><span class=\"main-label\">{{(bankAccount.status) ? \"Cuenta Activa\" : \"Cuenta Inactiva\"}}\n</span> <span class=\"sub-label\">Estado operativo</span></div></md-switch></div></div></div><div class=\"ba-row\" \nlayout=\"column\" layout-gt-xs=\"row\" style=\"margin-top: 20px\"><md-input-container class=\"md-block ba-field\" flex><label>\nBanco</label><md-select ng-model=\"bankAccount.bank\" ng-change=\"onBankChange(bankAccount.bank, bankAccount.isSpei)\" \nrequired name=\"bank\"><md-select-header class=\"ba-select-header\"><input autocomplete=\"off\" type=\"search\" \nclass=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"bankSelectFilter\" placeholder=\"Busque un banco\">\n</md-select-header><md-option ng-value=\"bank._id\" \nng-repeat=\"bank in M.banks | orderBy:\'name\' | filter:bankSelectFilter\">{{bank.name}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block ba-field\" flex><label>Layout del Banco</label><md-select \nng-model=\"bankAccount.idlayoutBank\" ng-change=\"loadFields()\" ng-disabled=\"!bankAccount.bank\" name=\"layoutBank\">\n<md-select-header class=\"ba-select-header\"><input autocomplete=\"off\" type=\"search\" class=\"md-text\" \nng-keydown=\"$event.stopPropagation()\" ng-model=\"bankLayoutSelectFilter\" placeholder=\"Busque un layout\">\n</md-select-header><md-option ng-value=\"undefined\">Ninguno</md-option><md-option ng-value=\"bank.idLayout\" \nng-repeat=\"bank in configLayouts | orderBy:\'idLayout\' | filter:bankLayoutSelectFilter\">{{bank.idLayout}}</md-option>\n</md-select></md-input-container></div><div class=\"ba-divider\"></div><div class=\"custom-fields-container\">\n<custom-fields fields=\"fields\" form=\"form\" main-object=\"bankAccount\"></custom-fields></div></div></md-content></form>\n</div>");
$templateCache.put("app/main/catalogs/views/bankAccounts/bankAccounts.html","<div id=\"bankAccounts\" class=\"page-layout carded fullwidth crud-index\" ng-controller=\"BankAccountsController\" \nlayout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div mongo-search-bar>\n</div><div class=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><div \ntable-loader array=\"bankAccounts\" validations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"bankAccounts.length\"><thead md-head \nmd-order=\"F.orderMongo\" fix-head md-on-reorder=\"getThem\"><tr md-row><th md-column md-order-by=\"name\"><span>Nombre\n</span></th><th md-column md-order-by=\"bank\"><span>Banco</span></th><th md-column md-order-by=\"isSpei\"><span>Es SPEI\n</span></th><th md-column md-order-by=\"companiesRecord\"><span>Empresa</span></th></tr></thead><tbody md-body><tr \nmd-row md-auto-select md-select=\"bankAccount\" md-select-id=\"_id\" ng-repeat=\"bankAccount in bankAccounts\"><td md-cell>\n{{bankAccount.name}}</td><td md-cell>{{bankAccount.bank|nameOfM:M.banks}}</td><td md-cell>\n{{bankAccount.isSpei?\'Si\':\'No\'}}</td><td md-cell>{{bankAccount.companiesRecord|nameOfL:L.companiesRecords}}</td></tr>\n</tbody></table></md-table-container><md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" \nlayout-xs=\"column\" ng-show=\"bankAccounts.length\" md-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" \nmd-limit-options=\"F.paginations\" md-page=\"$parent.currentPage\" md-total=\"{{pagination.total}}\" \nmd-on-paginate=\"getThemPagination\" md-page-select></md-table-pagination></div></div><md-fab-speed-dial \nmd-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\"><md-fab-trigger>\n<md-button aria-label=\"crud menu\" class=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon>\n</md-button></md-fab-trigger><md-fab-actions><md-button with-permission action=\"update\" access=\"{{F.active.menuItem}}\" \nng-if=\"selected.length == 1\" ng-click=\"R.goToDetail(selected[0])\" aria-label=\"edit\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Editar</md-tooltip><md-icon \nmd-font-icon=\"icon-pencil\" aria-label=\"edit\"></md-icon></md-button><md-button with-permission action=\"remove\" \naccess=\"{{F.active.menuItem}}\" ng-if=\"selected.length\" ng-click=\"deleteBanks($event)\" aria-label=\"Delete\" \nclass=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">{{\'EC.REMOVE\' | translate}}</md-tooltip>\n<md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button><md-button with-permission \naction=\"create\" access=\"{{F.active.menuItem}}\" ng-if=\"!selected.length\" ng-click=\'R.goToDetail(\"new\")\' \naria-label=\"add\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">\n{{\'EC.ADD\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon></md-button>\n</md-fab-actions></md-fab-speed-dial></div></div>");
$templateCache.put("app/main/catalogs/views/banks/bank.html","<div id=\"bank\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill \nng-controller=\"BankController\"><form name=\"form\" novalidate flex layout=\"column\" ng-disabled=\"F.readMode\"><div \nmongo-crud-detail-bar flex=\"nogrow\"></div><md-content layout=\"column\" class=\"content\" flex><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\" flex=\"grow\"><div layout-gt-xs=\"row\">\n<md-input-container class=\"md-block no-errors-spacer\" flex=\"100\"><label>Nombre</label><input ms2-autofocus \nclass=\"uppercased\" ng-model-options=\"{ debounce: F.debounceTime }\" type=\"text\" name=\"name\" ng-model=\"bank.name\" \nmd-maxlength=\"20\" maxlength=\"20\" required><div ng-messages=\"form.name.$error\" role=\"alert\"><div ng-message=\"required\">\nNombre es requerido</div></div></md-input-container><md-input-container class=\"md-block no-errors-spacer\" flex=\"100\">\n<label>Código del SAT</label><input class=\"uppercased\" ng-model-options=\"{ debounce: F.debounceTime }\" type=\"text\" \nname=\"satCode\" ng-model=\"bank.satCode\" required><div ng-messages=\"form.satCode.$error\" \nng-show=\"form.satCode.$touched || form.satCode.$dirty\"><div ng-message=\"required\">El código del sat es requerido</div>\n</div></md-input-container></div><div layout-gt-xs=\"row\" style=\"padding-top: 5px\" layout-align=\"end start\">\n<md-input-container class=\"md-block no-errors-spacers m-0\" flex=\"100\"><label>Longitud Cuenta</label><input \ntype=\"number\" name=\"accountLength\" ng-model=\"bank.accountLength\"></md-input-container><md-input-container \nclass=\"md-block no-errors-spacer m-0\" flex=\"100\"><label>Email Regex</label><input type=\"text\" name=\"emailRegex\" \nng-model=\"bank.emailRegex\" md-maxlength=\"100\" maxlength=\"100\"></md-input-container><div flex=\"nogrow\"><md-switch \naria-label=\"bank default\" class=\"md-secondary mt-0\" ng-model=\"bank.default\">Predeterminado</md-switch></div></div><div \nlayout=\"row\" layout-wrap><div flex=\"25\" flex-xs=\"100\"><md-switch aria-label=\"bank AllowRegister\" \nclass=\"md-secondary mt-0\" ng-model=\"bank.allowRegister\">Permitir Registrar</md-switch></div><div flex=\"25\" \nflex-xs=\"100\"><md-switch aria-label=\"bank requestNumber\" class=\"md-secondary mt-0\" ng-model=\"bank.requestNumber\">\nSolicitar cuenta o tarjeta</md-switch></div><div flex=\"25\" flex-xs=\"100\"><md-switch aria-label=\"bank hasLayout\" \nclass=\"md-secondary mt-0\" ng-model=\"bank.hasLayout\">Tiene Layout de registro</md-switch></div><md-input-container \nflex=\"25\" flex-xs=\"100\" class=\"md-block no-error-spacer mb-0 mt-0\"><label>Icono</label><input type=\"text\" name=\"name\" \nng-model=\"bank.icon\"></md-input-container></div><div flex=\"100\"><md-switch aria-label=\"bank requestNumber\" \nclass=\"md-secondary mt-0\" ng-model=\"bank.hasLayoutDispersion\">Tiene Layout Para Dispersar</md-switch></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><fieldset ng-if=\"bank.hasLayoutDispersion\"><legend>agregar layout<md-button \nclass=\"md-icon-button\" style=\"margin: 0\" aria-label=\"Add\" ng-click=\"addElement(bank,\'configLayouts\',{})\" \nng-disabled=\"active\"><md-icon md-font-icon=\"icon-plus-circle-outline\"></md-icon><md-tooltip md-direction=\"top\">\nAñade un campo personalizada para que aparezca en la información al generar un registro en MIS BANCOS</md-tooltip>\n</md-button></legend><table class=\"miniTable simple centered fixed\" ng-if=\"bank.configLayouts.length > 0\"><thead><tr>\n<th>ID</th><th>Ruta de archivo dispersion</th><th>Es spei</th><th>Eliminar</th></tr></thead><tbody><tr \nclass=\"valigntop noPadding\" ng-repeat=\"($index,configLayout) in bank.configLayouts\"><td class=\"noBorder\">\n<md-input-container class=\"md-block noMargin\" md-no-float><input type=\"text\" ng-model=\"configLayout.idLayout\" \nname=\"idLayout-{{$index}}\" placeholder=\"ID del layout\" required><div ng-messages=\'form[\"idLayout-\"+$index].$error\' \nrole=\"alert\"><div ng-message=\"required\">Este dato es requerido</div></div></md-input-container></td><td \nclass=\"noBorder\"><md-input-container class=\"md-block noMargin\" md-no-float><input type=\"text\" \nng-model=\"configLayout.pathFileDispersion\" name=\"pathFileDispersion-{{$index}}\" \nplaceholder=\"Configuar layout dispersion\" required><div ng-messages=\'form[\"pathFileDispersion-\"+$index].$error\' \nrole=\"alert\"><div ng-message=\"required\">Este dato es requerido</div></div></md-input-container></td><td \nclass=\"noBorder\"><md-input-container class=\"md-block noMargin\" md-no-float><md-checkbox ng-model=\"configLayout.spei\" \naria-label=\"showOnReport\"></md-checkbox></md-input-container></td><td class=\"iconbutton noBorder\"><md-button \nng-click=\"bank.configLayouts.splice($index,1);form.$setDirty();\" aria-label=\"Remove\" class=\"md-icon-button\"><md-icon \nmd-font-icon=\"icon-close-circle-outline\"></md-icon></md-button></td></tr></tbody></table></fieldset></div><fieldset>\n<legend>Campos Personalizados<md-button class=\"md-icon-button\" style=\"margin: 0\" aria-label=\"Add\" \nng-click=\"addElement(bank,\'fields\',{})\" ng-disabled=\"active\"><md-icon md-font-icon=\"icon-plus-circle-outline\">\n</md-icon><md-tooltip md-direction=\"top\">\nAñade un campo personalizada para que aparezca en la información al generar un registro en MIS BANCOS</md-tooltip>\n</md-button></legend><h3 ng-if=\"!bank.fields.length > 0\" class=\"text-italic grey-700-fg\">\nNo se han agregado campos personalizados</h3><table class=\"miniTable simple centered fixed\" \nng-if=\"bank.fields.length > 0\"><thead><tr><th>ID</th><th>Nombre</th><th>Ancho</th><th>Tipo</th><th>Requerido</th><th>\nMin</th><th>Max</th><th>pattern</th><th>Mensaje Informativo</th><th>Pedir</th><th>Pedir en generación</th><th>\nSeleccionar layout</th><th>Solicitar en el modal</th><th>Eliminar</th></tr></thead><tbody><tr \nclass=\"valigntop noPadding\" ng-repeat=\"($index,field) in bank.fields\"><td class=\"noBorder\"><md-input-container \nclass=\"md-block noMargin\" md-no-float><input type=\"text\" name=\"id-{{$index}}\" ng-model=\"field.id\" \nplaceholder=\"ID del campo\" required><div ng-messages=\'form[\"id-\"+$index].$error\' role=\"alert\"><div \nng-message=\"required\">Este dato es requerido</div></div></md-input-container></td><td class=\"noBorder\">\n<md-input-container class=\"md-block noMargin\" md-no-float><input type=\"text\" name=\"label-{{$index}}\" \nng-model=\"field.label\" placeholder=\"Nombre del campo\" required><div ng-messages=\'form[\"label-\"+$index].$error\' \nrole=\"alert\"><div ng-message=\"required\">Este dato es requerido</div></div></md-input-container></td><td \nclass=\"noBorder\"><md-input-container class=\"md-block noMargin\" md-no-float><input type=\"number\" \nname=\"width-{{$index}}\" ng-model=\"field.width\" placeholder=\"Ancho del campo\" min=\"1\" max=\"100\" required><div \nng-messages=\'form[\"width-\"+$index].$error\' role=\"alert\"><div ng-message=\"required\">Este dato es requerido</div><div \nng-message=\"min\">Debe tener un ancho</div><div ng-message=\"max\">No puedo sobrepasar el 100</div></div>\n</md-input-container></td><td class=\"noBorder\"><md-input-container class=\"md-block noMargin\" md-no-float><md-select \nng-model=\"field.type\" name=\"type-{{$index}}\" placeholder=\"Tipo de campo\" required><md-option ng-value=\"inputType.id\" \nng-repeat=\"inputType in F.inputTypes\">{{inputType.value}}</md-option></md-select><div \nng-messages=\'form[\"type-\"+$index].$error\' role=\"alert\"><div ng-message=\"required\">Este dato es requerido</div></div>\n</md-input-container></td><td class=\"noBorder\"><div layout=\"row\" layout-align=\"center start\"><md-switch flex=\"nogrow\" \nclass=\"noMargin\" ng-model=\"field.required\" aria-label=\"Requerido\"></md-switch></div></td><td class=\"noBorder\">\n<md-input-container class=\"md-block noMargin\" md-no-float><input type=\"number\" name=\"min-{{$index}}\" \nng-model=\"field.min\" placeholder=\"Minimo\"></md-input-container></td><td class=\"noBorder\"><md-input-container \nclass=\"md-block noMargin\" md-no-float><input type=\"number\" name=\"max-{{$index}}\" ng-model=\"field.max\" \nplaceholder=\"Maximo\"></md-input-container></td><td class=\"noBorder\"><md-input-container class=\"md-block noMargin\" \nmd-no-float><input type=\"text\" name=\"max-{{$index}}\" ng-model=\"field.pattern\" placeholder=\"pattern\">\n</md-input-container></td><td class=\"noBorder\"><md-input-container class=\"md-block noMargin\" md-no-float><input \ntype=\"text\" name=\"info-{{$index}}\" ng-model=\"field.info\" placeholder=\"Info\"><div \nng-messages=\'form[\"info-\"+$index].$error\' role=\"alert\"><div ng-message=\"required\">Este dato es requerido</div></div>\n</md-input-container></td><td class=\"noBorder\"><div layout=\"row\" layout-align=\"center start\"><md-switch flex=\"nogrow\" \nclass=\"noMargin\" ng-model=\"field.askfor\" aria-label=\"Pedir Campo\"></md-switch></div></td><td class=\"noBorder\"><div \nlayout=\"row\" layout-align=\"center start\"><md-switch flex=\"nogrow\" class=\"noMargin\" ng-model=\"field.AskInGeneration\" \naria-label=\"Pedir al generar\"></md-switch></div></td><td><md-input-container class=\"md-block noMargin\" md-no-float>\n<md-select ng-model=\"field.layoutSelection\" name=\"layoutSelection-{{$index}}\" placeholder=\"Seleccionar layout\">\n<md-option ng-value=\"\">Ninguno</md-option><md-option \nng-repeat=\"layout in bank.configLayouts | orderBy:\'name\' | filter:statusSelectFilter\" ng-value=\"layout.idLayout\" \nng-if=\"layout.idLayout\">{{layout.idLayout}}</md-option></md-select></md-input-container></td><td class=\"noBorder\">\n<md-input-container class=\"md-block noMargin\" md-no-float><md-checkbox ng-model=\"field.requiredModal\" \naria-label=\"requiredModal\"></md-checkbox></md-input-container></td><td class=\"iconbutton noBorder\"><md-button \nng-click=\"bank.fields.splice($index,1);form.$setDirty();\" aria-label=\"Remove\" class=\"md-icon-button\"><md-icon \nmd-font-icon=\"icon-close-circle-outline\"></md-icon></md-button></td></tr></tbody></table></fieldset><fieldset><legend>\nCampos extras<md-button class=\"md-icon-button\" style=\"margin: 0\" aria-label=\"Add\" \nng-click=\"addFields(indexCalculation)\" ng-disabled=\"active\"><md-icon md-font-icon=\"icon-plus-circle\"></md-icon>\n<md-tooltip md-direction=\"top\">Agregar campo</md-tooltip></md-button></legend><h3 ng-if=\"!fields.length > 0\" \nclass=\"text-italic grey-700-fg\">No se han agregado campos extras</h3><div layout=\"row\" layout-align=\"end\" \nng-repeat=\"(index, field) in fields track by index\"><md-input-container class=\"md-block no-error-spacer m-0\" flex>\n<label>Nombre</label><input ng-model-options=\"{ debounce: F.debounceTime }\" type=\"text\" name=\"name{{$index}}\" \nng-model=\"field.name\" ng-change=\"createFields(field, fields, index, form)\" required><div \nng-messages=\"form[\'name\'+$index].$error\" role=\"alert\"><div ng-message=\"required\">El nombre es requerido</div><div \nng-message=\"validationError\">Este valor ya existe</div></div></md-input-container><md-input-container \nclass=\"md-block no-error-spacer m-0\" flex><label>Valor</label><input ng-model-options=\"{ debounce: F.debounceTime }\" \ntype=\"text\" name=\"value{{$index}}\" ng-model=\"field.value\" ng-change=\"createFields(field, fields)\" required><div \nng-messages=\"form[\'value\'+$index].$error\" role=\"alert\"><div ng-message=\"required\">El valor es requerido</div></div>\n</md-input-container><div flex=\"nogrow\"><md-button class=\"md-icon-button\" aria-label=\"Delete\" \nng-click=\"deleteFields(fields, index)\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip md-direction=\"top\">\nEliminar</md-tooltip></md-button></div></div></fieldset></div></md-content></form></div>");
$templateCache.put("app/main/catalogs/views/banks/banks.html","<div id=\"banks\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div mongo-search-bar></div><div class=\"content-card\" layout=\"column\" flex>\n<div class=\"content fullpage-datatable\" layout=\"column\" flex><div table-loader array=\"banks\" validations=\"validations\">\n</div><md-table-container class=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table \nmd-table md-row-select multiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"banks.length\"><thead md-head \nmd-order=\"F.orderMongo\" fix-head md-on-reorder=\"getThem\"><tr md-row><th md-column md-order-by=\"name\"><span>Nombre\n</span></th><th md-column md-order-by=\"default\"><span>Default</span></th><th md-column md-order-by=\"satCode\"><span>\nCódigo de SAT</span></th></tr></thead><tbody md-body><tr md-row md-auto-select md-select=\"bank\" md-select-id=\"_id\" \nng-repeat=\"bank in banks\"><td md-cell>{{bank.name}}</td><td md-cell><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"quantity-indicator\" ng-class=\"{\'md-red-500-bg\': !bank.default, \'md-green-600-bg\': bank.default }\"></div></div>\n</td><td md-cell>{{bank.satCode}}</td></tr></tbody></table></md-table-container><md-table-pagination \nlayout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" ng-show=\"banks.length\" \nmd-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" md-limit-options=\"F.paginations\" md-page=\"currentPage\" \nmd-total=\"{{pagination.total}}\" md-on-paginate=\"getThemPagination\" md-page-select></md-table-pagination></div></div>\n<md-fab-speed-dial md-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" \nclass=\"ms2-speed-dial bottom right\"><md-fab-trigger><md-button aria-label=\"crud menu\" \nclass=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon></md-button></md-fab-trigger>\n<md-fab-actions><md-button with-permission action=\"update\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" \nng-click=\"R.goToDetail(selected[0])\" aria-label=\"edit\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip \nmd-direction=\"left\">Editar</md-tooltip><md-icon md-font-icon=\"icon-pencil\" aria-label=\"edit\"></md-icon></md-button>\n<md-button with-permission action=\"remove\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length\" \nng-click=\"delete($event)\" aria-label=\"Delete\" class=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">\n{{\'EC.REMOVE\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button>\n<md-button with-permission action=\"create\" access=\"{{F.active.menuItem}}\" ng-if=\"!selected.length\" \nng-click=\'R.goToDetail(\"new\")\' aria-label=\"add\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip \nmd-direction=\"left\">{{\'EC.ADD\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon>\n</md-button></md-fab-actions></md-fab-speed-dial></div></div>");
$templateCache.put("app/main/catalogs/views/countries-records/countries-record.html","<div id=\"countriesRecord\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill><form name=\"form\" \nnovalidate flex layout=\"column\" ng-disabled=\"F.readMode\"><div mongo-crud-detail-bar></div><md-content layout=\"column\" \nclass=\"content\" flex><md-tab-body><div class=\"detail-form-container md-background-bg md-whiteframe-1dp\">\n<md-input-container class=\"md-block\"><label>País</label><input ms2-autofocus class=\"uppercased\" \nng-model-options=\"{ debounce: F.debounceTime }\" type=\"text\" name=\"name\" ng-model=\"countriesRecord.name\" \nmd-maxlength=\"20\" maxlength=\"20\" required></md-input-container><md-input-container class=\"md-block\"><label>Clave\n</label><input class=\"uppercased\" ng-model-options=\"{ debounce: F.debounceTime }\" type=\"text\" name=\"key\" \nng-model=\"countriesRecord.key\" md-maxlength=\"3\" maxlength=\"3\" required></md-input-container></div></md-tab-body>\n</md-content></form></div>");
$templateCache.put("app/main/catalogs/views/countries-records/countries-records.html","<div id=\"countriesRecords\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div mongo-search-bar></div><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><div \ntable-loader array=\"countriesRecords\" validations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"countriesRecords.length\"><thead md-head \nmd-order=\"F.orderMongo\" fix-head md-on-reorder=\"getThem\"><tr md-row><th md-column md-order-by=\"name\"><span>País</span>\n</th></tr></thead><tbody md-body><tr md-row md-auto-select md-select=\"countriesRecord\" md-select-id=\"_id\" \nng-repeat=\"countriesRecord in countriesRecords\"><td md-cell>{{countriesRecord.name}}</td></tr></tbody></table>\n</md-table-container><md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" \nng-show=\"countriesRecords.length\" md-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" \nmd-limit-options=\"F.paginations\" md-page=\"currentPage\" md-total=\"{{pagination.total}}\" \nmd-on-paginate=\"getThemPagination\" md-page-select></md-table-pagination></div></div><md-fab-speed-dial \nmd-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\"><md-fab-trigger>\n<md-button aria-label=\"crud menu\" class=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon>\n</md-button></md-fab-trigger><md-fab-actions><md-button with-permission action=\"update\" access=\"{{F.active.menuItem}}\" \nng-if=\"selected.length == 1\" ng-click=\"R.goToDetail(selected[0])\" aria-label=\"Edit\" \nclass=\"md-fab md-raised md-accent md-hue-2 md-mini\"><md-tooltip md-direction=\"left\">{{\'EC.EDIT\' | translate}}\n</md-tooltip><md-icon md-font-icon=\"icon-pencil\" aria-label=\"Edit\"></md-icon></md-button><md-button with-permission \naction=\"remove\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length\" ng-click=\"delete($event)\" aria-label=\"Delete\" \nclass=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">{{\'EC.REMOVE\' | translate}}</md-tooltip>\n<md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button><md-button with-permission \naction=\"create\" access=\"{{F.active.menuItem}}\" ng-if=\"!selected.length\" ng-click=\'R.goToDetail(\"new\")\' \naria-label=\"add\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">\n{{\'EC.ADD\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon></md-button>\n</md-fab-actions></md-fab-speed-dial></div></div>");
$templateCache.put("app/main/catalogs/views/dashboard/dashboard.html","<div id=\"dashboard-clients\" class=\"page-layout blank\" layout=\"row\"><div class=\"center\" flex ms-scroll><div \nclass=\"content\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"true\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><md-select class=\"simplified font-size-16\" \nng-model=\"widget1.currentRange\" aria-label=\"Change range\"><md-option ng-repeat=\"(key, range) in widget1.ranges\" \nvalue=\"{{key}}\">{{range}}</md-option></md-select><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\">\n<md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details</md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item>\n</md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"light-blue-fg font-size-72 line-height-72\">{{widget1.data.count[widget1.currentRange]}}%</div><div \nclass=\"h3 secondary-text font-weight-500\">{{widget1.data.label}}</div></div><div class=\"p-16 grey-50-bg border-top\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">{{widget1.data.extra.label}}:\n</span> <span class=\"h4 ml-8\">{{widget1.data.extra.count[widget1.currentRange]}}</span></div></ms-widget-front>\n<ms-widget-back class=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" \nng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button>\n</div><div>{{widget1.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">{{widget2.title}}</div><md-menu><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh\n</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"red-fg font-size-72 line-height-72\">${{widget2.data.count}}</div><div \nclass=\"h3 secondary-text font-weight-500\">{{widget2.data.label}}</div></div><div class=\"p-16 grey-50-bg border-top\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">{{widget2.data.extra.label}}:\n</span> <span class=\"h4 ml-8\">${{widget2.data.extra.count}}</span></div></ms-widget-front><ms-widget-back \nclass=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" \naria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>\n{{widget2.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">{{widget3.title}}</div><md-menu><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh\n</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"orange-fg font-size-72 line-height-72\">{{widget3.data.count}}</div><div \nclass=\"h3 secondary-text font-weight-500\">{{widget3.data.label}}</div></div><div class=\"p-16 grey-50-bg border-top\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">{{widget3.data.extra.label}}:\n</span> <span class=\"h4 ml-8\">{{widget3.data.extra.count}}</span></div></ms-widget-front><ms-widget-back \nclass=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" \naria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>\n{{widget3.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">{{widget4.title}}</div><md-menu><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh\n</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"blue-grey-fg font-size-72 line-height-72\">${{widget4.data.count}}</div><div \nclass=\"h3 secondary-text font-weight-500\">{{widget4.data.label}}</div></div><div class=\"p-16 grey-50-bg border-top\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">{{widget4.data.extra.label}}:\n</span> <span class=\"h4 ml-8\">${{widget4.data.extra.count}}</span></div></ms-widget-front><ms-widget-back \nclass=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" \naria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>\n{{widget4.detail}}</div></ms-widget-back></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" \nlayout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 pv-8 border-bottom\" \nlayout=\"row\" layout-align=\"space-between center\" layout-wrap><div class=\"pv-8 h3\">{{widget5.title}}</div><div \nclass=\"pv-8\" layout=\"row\" layout-align=\"start center\" layout-align-sm=\"end\" flex-sm=\"100\"><md-button class=\"ph-16\" \nng-repeat=\"(key, range) in widget5.ranges\" ng-click=\"widget5.changeRange(key)\" \nng-disabled=\"widget5.currentRange == key\">{{range}}</md-button></div></div><div class=\"p-16\"><nvd3 \nclass=\"h-420 remove-x-lines\" config=\"widget5.mainChart.config\" options=\"widget5.mainChart.options\" \ndata=\"widget5.mainChart.data\"></nvd3></div></ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" \nflex=\"100\" layout-wrap><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{widget6.title}}</div>\n<div class=\"pv-16\"><md-select class=\"simplified\" ng-model=\"widget6.currentRange\" \nng-change=\"widget6.changeRange(widget6.currentRange)\" aria-label=\"Change range\"><md-option \nng-repeat=\"(key, range) in widget6.ranges\" value=\"{{key}}\">{{range}}</md-option></md-select></div></div><div \nclass=\"p-16\"><nvd3 class=\"h-400\" config=\"widget6.mainChart.config\" options=\"widget6.mainChart.options\" \ndata=\"widget6.mainChart.data\"></nvd3></div><div class=\"pv-8 mh-16 border-top\" layout=\"row\" layout-align=\"start center\" \nlayout-wrap><div class=\"pv-8 border-right\" layout=\"column\" layout-align=\"center center\" flex=\"100\" flex-gt-xs=\"50\">\n<span class=\"font-size-32\">{{widget6.footerLeft.count[widget6.currentRange]}}</span> <span class=\"h4\">\n{{widget6.footerLeft.title}}</span></div><div class=\"pv-8\" layout=\"column\" layout-align=\"center center\" flex=\"100\" \nflex-gt-xs=\"50\"><span class=\"font-size-32\">{{widget6.footerRight.count[widget6.currentRange]}}</span> <span class=\"h4\">\n{{widget6.footerRight.title}}</span></div></div></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">{{widget7.title}}</div><div class=\"pv-16\"><md-select \nclass=\"simplified\" ng-model=\"widget7.currentRange\" aria-label=\"Change range\"><md-option \nng-repeat=\"(key, range) in widget7.ranges\" value=\"{{key}}\">{{range}}</md-option></md-select></div></div><div \nclass=\"p-16\" layout=\"row\" layout-align=\"space-between center\" \nng-repeat=\"customer in widget7.customers[widget7.currentRange]\"><div><div class=\"h3\">{{customer.name}}</div><span \nng-if=\"customer.location\">{{customer.location}}</span></div><md-button class=\"md-icon-button\" \naria-label=\"More information\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></div></ms-widget-front>\n</ms-widget></div></div></div></div>");
$templateCache.put("app/main/catalogs/views/cyv-records/cyv-record.html","<div id=\"cyvRecord\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill><form name=\"form\" \nnovalidate flex layout=\"column\" ng-disabled=\"F.readMode\"><div mongo-crud-detail-bar></div><md-content layout=\"column\" \nclass=\"content\" flex><div class=\"detail-form-container md-background-bg md-whiteframe-1dp\"><div flex \nlayout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex><label>Año</label><input ms2-autofocus type=\"number\" \nname=\"year\" ng-model=\"cyvRecord.year\" required></md-input-container><md-input-container class=\"md-block\" flex><label>\nPorcentaje</label><input type=\"number\" name=\"percentFee\" ng-model=\"cyvRecord.percentFee\" required></md-input-container>\n</div><div flex layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex><label>Limite Superior</label><input \ntype=\"number\" name=\"upperLimit\" ng-model=\"cyvRecord.upperLimit\" required></md-input-container><md-input-container \nclass=\"md-block\" flex><label>Medida</label><md-select ng-model=\"cyvRecord.measure\"><md-option ng-value=\"measure.obj\" \nng-repeat=\"measure in F.cyvMeasures\">{{measure.name}}</md-option></md-select></md-input-container></div></div>\n</md-content></form></div>");
$templateCache.put("app/main/catalogs/views/cyv-records/cyv-records.html","<div id=\"cyvRecords\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div mongo-search-bar></div><div class=\"content-card\" layout=\"column\" \nflex><div class=\"content fullpage-datatable\" layout=\"column\" flex><div table-loader array=\"cyvRecords\" \nvalidations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"cyvRecords.length\"><thead md-head md-order=\"order\" \nfix-head md-on-reorder=\"getThem\"><tr md-row><th md-column md-order-by=\"year\"><span>Año</span></th><th md-column \nmd-order-by=\"lowerLimit\"><span>Límite Superior</span></th><th md-column md-order-by=\"percentFee\"><span>Cuota Porcentual\n</span></th></tr></thead><tbody md-body><tr md-row md-auto-select md-select=\"cyvRecord\" md-select-id=\"_id\" \nng-repeat=\"cyvRecord in cyvRecords\"><td md-cell>{{cyvRecord.year}}</td><td md-cell>\n{{cyvRecord.upperLimit}} {{cyvRecord.measure | getSomethingOfArrayFB : F.cyvMeasures : \'name\' : \'S/M\' : \'obj\'}}</td><td\n md-cell>{{cyvRecord.percentFee}}</td></tr></tbody></table></md-table-container><md-table-pagination \nlayout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" ng-show=\"cyvRecords.length\" \nmd-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" md-limit-options=\"F.paginations\" md-page=\"currentPage\" \nmd-total=\"{{pagination.total}}\" md-on-paginate=\"getThemPagination\" md-page-select></md-table-pagination></div></div>\n<md-fab-speed-dial md-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" \nclass=\"ms2-speed-dial bottom right\"><md-fab-trigger><md-button aria-label=\"crud menu\" \nclass=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon></md-button></md-fab-trigger>\n<md-fab-actions><md-button with-permission action=\"update\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" \nng-click=\"R.goToDetail(selected[0])\" aria-label=\"edit\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip \nmd-direction=\"left\">Editar</md-tooltip><md-icon md-font-icon=\"icon-pencil\" aria-label=\"edit\"></md-icon></md-button>\n<md-button with-permission action=\"remove\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length\" \nng-click=\"delete($event)\" aria-label=\"Delete\" class=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">\n{{\'EC.REMOVE\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button>\n<md-button with-permission action=\"create\" access=\"{{F.active.menuItem}}\" ng-if=\"!selected.length\" \nng-click=\'R.goToDetail(\"new\")\' aria-label=\"add\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip \nmd-direction=\"left\">{{\'EC.ADD\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon>\n</md-button></md-fab-actions></md-fab-speed-dial></div></div>");
$templateCache.put("app/main/catalogs/views/directives/directive.html","<div id=\"directive\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill><form name=\"form\" \nnovalidate flex layout=\"column\" ng-disabled=\"F.readMode\"><div mongo-crud-detail-bar></div><md-content layout=\"column\" \nclass=\"content\" flex><div class=\"detail-form-container md-background-bg md-whiteframe-1dp\" layout=\"column\"><div flex \nlayout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex><label>ID</label><input ms2-autofocus class=\"uppercased\" \nng-model-options=\"{ debounce: F.debounceTime }\" type=\"text\" name=\"name\" ng-model=\"directive._id\" md-maxlength=\"20\" \nmaxlength=\"20\" required></md-input-container><md-input-container class=\"md-block\" flex><label>Nombre</label><input \nclass=\"uppercased\" ng-model-options=\"{ debounce: F.debounceTime }\" type=\"text\" name=\"name\" ng-model=\"directive.name\" \nrequired></md-input-container></div><div flex><fieldset><legend>Procesos que lo ejecutan</legend><md-input-container \nclass=\"md-block\"><md-checkbox name=\"processesReal\" ng-model=\"directive.processes.REAL\">Real</md-checkbox>\n</md-input-container><md-input-container class=\"md-block\"><md-checkbox name=\"processesFiscal\" \nng-model=\"directive.processes.FISCAL\">Fiscal</md-checkbox></md-input-container></fieldset></div></div></md-content>\n</form></div>");
$templateCache.put("app/main/catalogs/views/directives/directives.html","<div id=\"directives\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div mongo-search-bar></div><div class=\"content-card\" layout=\"column\" \nflex><div class=\"content fullpage-datatable\" layout=\"column\" flex><div table-loader array=\"directives\" \nvalidations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"directives.length\"><thead md-head \nmd-order=\"F.orderMongo\" fix-head md-on-reorder=\"getThem\"><tr md-row><th md-column md-order-by=\"_id\"><span>ID</span>\n</th><th md-column md-order-by=\"name\"><span>Nombre</span></th><th md-column md-order-by=\"process\"><span>Proceso</span>\n</th></tr></thead><tbody md-body><tr md-row md-auto-select md-select=\"directive\" md-select-id=\"_id\" \nng-repeat=\"directive in directives\"><td md-cell>{{directive._id}}</td><td md-cell>{{directive.name}}</td><td md-cell>\n{{directive.process}}</td></tr></tbody></table></md-table-container><md-table-pagination layout-align=\"start center\" \nlayout-gt-xs=\"row\" layout-xs=\"column\" ng-show=\"directives.length\" md-label=\"{{F.paginationLabel}}\" \nmd-limit=\"F.paginate\" md-limit-options=\"F.paginations\" md-page=\"currentPage\" md-total=\"{{pagination.total}}\" \nmd-on-paginate=\"getThemPagination\" md-page-select></md-table-pagination></div></div><md-fab-speed-dial \nmd-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\"><md-fab-trigger>\n<md-button aria-label=\"crud menu\" class=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon>\n</md-button></md-fab-trigger><md-fab-actions><md-button with-permission action=\"update\" access=\"{{F.active.menuItem}}\" \nng-if=\"selected.length == 1\" ng-click=\"R.goToDetail(selected[0])\" aria-label=\"edit\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Editar</md-tooltip><md-icon \nmd-font-icon=\"icon-pencil\" aria-label=\"edit\"></md-icon></md-button><md-button with-permission action=\"remove\" \naccess=\"{{F.active.menuItem}}\" ng-if=\"selected.length\" ng-click=\"delete($event)\" aria-label=\"Delete\" \nclass=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">{{\'EC.REMOVE\' | translate}}</md-tooltip>\n<md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button><md-button with-permission \naction=\"create\" access=\"{{F.active.menuItem}}\" ng-if=\"!selected.length\" ng-click=\'R.goToDetail(\"new\")\' \naria-label=\"add\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">\n{{\'EC.ADD\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon></md-button>\n</md-fab-actions></md-fab-speed-dial></div></div>");
$templateCache.put("app/main/catalogs/views/dismiss-types/dismiss-type.html","<div id=\"dismissType\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill><form name=\"form\" \nnovalidate flex layout=\"column\" ng-disabled=\"F.readMode\"><div mongo-crud-detail-bar></div><md-content layout=\"column\" \nclass=\"content\" flex><div class=\"detail-form-container md-background-bg md-whiteframe-1dp\"><md-input-container \nclass=\"md-block\"><label>Tipo de Baja</label><input ms2-autofocus class=\"uppercased\" \nng-model-options=\"{ debounce: F.debounceTime }\" type=\"text\" name=\"name\" ng-model=\"dismissType.name\" md-maxlength=\"50\" \nmaxlength=\"50\" required></md-input-container><md-input-container flex class=\"md-block\"><label>Default Status</label>\n<md-select ng-model=\"dismissType.defaultStatus\"><md-option ng-value>Ninguno</md-option><md-option ng-value=\"status.id\" \nng-repeat=\'status in F.employeeStatatuss | orderBy:\"name\" | filter:statusSelectFilter\'>{{status.name}}</md-option>\n</md-select></md-input-container><md-input-container flex class=\"md-block\"><md-switch \nng-model=\"dismissType.disableNotification\" aria-label=\"Disable Notification\">Deshabilitar Notificación</md-switch>\n</md-input-container><md-input-container class=\"md-block\"><label>Codigo</label><input ms2-autofocus class=\"uppercased\" \nng-model-options=\"{ debounce: F.debounceTime }\" type=\"text\" name=\"humansiteCode\" ng-model=\"dismissType.humansiteCode\" \nmd-maxlength=\"50\" maxlength=\"50\" required></md-input-container></div></md-content></form></div>");
$templateCache.put("app/main/catalogs/views/dismiss-types/dismiss-types.html","<div id=\"dismissTypes\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div mongo-search-bar></div><div class=\"content-card\" layout=\"column\" \nflex><div class=\"content fullpage-datatable\" layout=\"column\" flex><div table-loader array=\"dismissTypes\" \nvalidations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"dismissTypes.length\"><thead md-head \nmd-order=\"F.orderMongo\" fix-head md-on-reorder=\"getThem\"><tr md-row><th md-column md-order-by=\"name\"><span>Tipo de Baja\n</span></th></tr></thead><tbody md-body><tr md-row md-auto-select md-select=\"dismissType\" md-select-id=\"_id\" \nng-repeat=\"dismissType in dismissTypes\"><td md-cell>{{dismissType.name}}</td></tr></tbody></table></md-table-container>\n<md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" ng-show=\"dismissTypes.length\" \nmd-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" md-limit-options=\"F.paginations\" md-page=\"currentPage\" \nmd-total=\"{{pagination.total}}\" md-on-paginate=\"getThemPagination\" md-page-select></md-table-pagination></div></div>\n<md-fab-speed-dial md-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" \nclass=\"ms2-speed-dial bottom right\"><md-fab-trigger><md-button aria-label=\"crud menu\" \nclass=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon></md-button></md-fab-trigger>\n<md-fab-actions><md-button with-permission action=\"update\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" \nng-click=\"R.goToDetail(selected[0])\" aria-label=\"edit\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip \nmd-direction=\"left\">Editar</md-tooltip><md-icon md-font-icon=\"icon-pencil\" aria-label=\"edit\"></md-icon></md-button>\n<md-button with-permission action=\"remove\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length\" \nng-click=\"delete($event)\" aria-label=\"Delete\" class=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">\n{{\'EC.REMOVE\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button>\n<md-button with-permission action=\"create\" access=\"{{F.active.menuItem}}\" ng-if=\"!selected.length\" \nng-click=\'R.goToDetail(\"new\")\' aria-label=\"add\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip \nmd-direction=\"left\">{{\'EC.ADD\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon>\n</md-button></md-fab-actions></md-fab-speed-dial></div></div>");
$templateCache.put("app/main/catalogs/views/filters/filter.html","<div id=\"filter\" ng-controller=\"FilterController\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" \nlayout-fill><form name=\"form\" novalidate flex layout=\"column\" ng-disabled=\"F.readMode\"><div mongo-crud-detail-bar \nflex=\"nogrow\"></div><md-content layout=\"column\" class=\"content\" flex><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\" flex=\"grow\"><div layout-gt-xs=\"row\">\n<md-input-container class=\"md-block\" flex><label>Id</label><input ms2-autofocus type=\"text\" name=\"id\" \nng-model-options=\"{ debounce: F.debounceTime }\" ng-model=\"filter.id\" ng-change=\"validate(filter.id, form, filter._id)\" \nrequired><div ng-messages=\"form.id.$error\" role=\"alert\"><div ng-message=\"required\">El id es requerido</div><div \nng-message=\"validationError\">Este valor ya existe</div></div></md-input-container><md-input-container class=\"md-block\" \nflex><label>Nombre</label><input class=\"uppercased\" ng-model-options=\"{ debounce: F.debounceTime }\" type=\"text\" \nname=\"name\" ng-model=\"filter.name\" md-maxlength=\"20\" maxlength=\"20\" required><div ng-messages=\"form.name.$error\" \nrole=\"alert\"><div ng-message=\"maxlength\">La longitud maxima debe ser de 20 caracteres</div><div ng-message=\"required\">\nEl Nombre es requerido</div></div></md-input-container></div><md-content class=\"md-padding\" layout=\"column\"><md-chips \nng-model=\"filter.params\" readonly=\"ctrl.readonly\" md-transform-chip=\"newParams($chip)\" placeholder=\"Parametros\">\n<md-chip-template><span><strong>{{$chip | capitalize}}</strong></span></md-chip-template></md-chips></md-content></div>\n</md-content></form></div>");
$templateCache.put("app/main/catalogs/views/filters/filters.html","<div id=\"filters\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div mongo-search-bar></div><div class=\"content-card\" layout=\"column\" flex>\n<div class=\"content fullpage-datatable\" layout=\"column\" flex><div table-loader array=\"filters\" \nvalidations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"filters.length\"><thead md-head md-order=\"F.orderMongo\" \nfix-head md-on-reorder=\"getThem\"><tr md-row><th md-column md-order-by=\"id\"><span>Id</span></th><th md-column \nmd-order-by=\"name\"><span>Nombre</span></th><th md-column md-order-by=\"params\"><span>Parametros</span></th></tr></thead>\n<tbody md-body><tr md-row md-auto-select md-select=\"filter\" md-select-id=\"_id\" ng-repeat=\"filter in filters\"><td \nmd-cell>{{filter.id}}</td><td md-cell>{{filter.name}}</td><td md-cell>{{filter.params}}</td></tr></tbody></table>\n</md-table-container><md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" \nng-show=\"filters.length\" md-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" md-limit-options=\"F.paginations\" \nmd-page=\"currentPage\" md-total=\"{{pagination.total}}\" md-on-paginate=\"getThemPagination\" md-page-select>\n</md-table-pagination></div></div><md-fab-speed-dial md-open=\"F.isOpen\" \nmd-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\"><md-fab-trigger><md-button \naria-label=\"crud menu\" class=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon></md-button>\n</md-fab-trigger><md-fab-actions><md-button with-permission action=\"update\" access=\"{{F.active.menuItem}}\" \nng-if=\"selected.length == 1\" ng-click=\"R.goToDetail(selected[0])\" aria-label=\"edit\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Editar</md-tooltip><md-icon \nmd-font-icon=\"icon-pencil\" aria-label=\"edit\"></md-icon></md-button><md-button with-permission action=\"remove\" \naccess=\"{{F.active.menuItem}}\" ng-if=\"selected.length\" ng-click=\"delete($event)\" aria-label=\"Delete\" \nclass=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">{{\'EC.REMOVE\' | translate}}</md-tooltip>\n<md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button><md-button with-permission \naction=\"create\" access=\"{{F.active.menuItem}}\" ng-if=\"!selected.length\" ng-click=\'R.goToDetail(\"new\")\' \naria-label=\"add\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">\n{{\'EC.ADD\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon></md-button>\n</md-fab-actions></md-fab-speed-dial></div></div>");
$templateCache.put("app/main/catalogs/views/geo-zones/geo-zone.html","<div id=\"geoZone\" ng-controller=\"geoZoneController\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" \nlayout-fill><form name=\"form\" novalidate flex layout=\"column\" ng-disabled=\"F.readMode\"><div mongo-crud-detail-bar>\n</div><md-content layout=\"column\" class=\"content\" flex><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\"><md-input-container class=\"md-block\"><label>\nZona geografica</label><input ms2-autofocus class=\"uppercased\" unique-mongo catalog=\"geoZones\" field=\"name\" \nng-model-options=\"{ debounce: F.debounceTime }\" type=\"text\" name=\"name\" ng-model=\"geoZone.name\" md-maxlength=\"15\" \nmaxlength=\"15\" required from-id=\"{{geoZone._id}}\"><div ng-messages=\"form.name.$error\" role=\"alert\"><div \nng-message=\"unique\">Nombre no es unico</div></div></md-input-container><div layout-gt-xs=\"row\"><md-input-container \nclass=\"md-block\" flex><label>Clave</label><input ng-if=\"!F.addMode\" type=\"text\" name=\"key\" ng-model=\"geoZone.key\" \ndisabled=\"disabled\"> <input ng-if=\"F.addMode\" ref=\"{{F.active.menuRef}}\" fromid=\"{{geoZoneId}}\" type=\"text\" name=\"key\" \nng-model=\"geoZone.key\" disabled=\"disabled\"></md-input-container><md-switch ng-disabled=\"F.readMode\" ng-if=\"!F.addMode\" \nflex=\"nogrow\" class=\"md-secondary md-padding\" name=\"enableDisable\" aria-label=\"Enable or Disable switch\" \nng-model=\"geoZone.status\">{{(geoZone.status)?\"Deshabilitar\":\"Habilitar\"}}</md-switch></div></div></md-content></form>\n</div>");
$templateCache.put("app/main/catalogs/views/geo-zones/geo-zones.html","<div id=\"geoZones\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div mongo-search-bar></div><div class=\"content-card\" layout=\"column\" flex>\n<div class=\"content fullpage-datatable\" layout=\"column\" flex><div table-loader array=\"geoZones\" \nvalidations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"geoZones.length\"><thead md-head \nmd-order=\"F.orderMongo\" fix-head md-on-reorder=\"getThem\"><tr md-row><th md-column md-order-by=\"name\"><span>Geo Zona\n</span></th></tr></thead><tbody md-body><tr md-row md-auto-select md-select=\"geoZone\" md-select-id=\"_id\" \nng-repeat=\"geoZone in geoZones\"><td md-cell>{{geoZone.name}}</td></tr></tbody></table></md-table-container>\n<md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" ng-show=\"geoZones.length\" \nmd-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" md-limit-options=\"F.paginations\" md-page=\"currentPage\" \nmd-total=\"{{pagination.total}}\" md-on-paginate=\"getThemPagination\" md-page-select></md-table-pagination></div></div>\n<md-fab-speed-dial md-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" \nclass=\"ms2-speed-dial bottom right\"><md-fab-trigger><md-button aria-label=\"crud menu\" \nclass=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon></md-button></md-fab-trigger>\n<md-fab-actions><md-button with-permission action=\"update\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" \nng-click=\"R.goToDetail(selected[0])\" aria-label=\"edit\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip \nmd-direction=\"left\">Editar</md-tooltip><md-icon md-font-icon=\"icon-pencil\" aria-label=\"edit\"></md-icon></md-button>\n<md-button with-permission action=\"remove\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length\" \nng-click=\"delete($event)\" aria-label=\"Delete\" class=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">\n{{\'EC.REMOVE\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button>\n<md-button with-permission action=\"create\" access=\"{{F.active.menuItem}}\" ng-if=\"!selected.length\" \nng-click=\'R.goToDetail(\"new\")\' aria-label=\"add\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip \nmd-direction=\"left\">{{\'EC.ADD\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon>\n</md-button></md-fab-actions></md-fab-speed-dial></div></div>");
$templateCache.put("app/main/catalogs/views/incidences-status-records/incidences-status-record.html","<div id=\"incidencesStatusRecord\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill><form \nname=\"form\" novalidate flex layout=\"column\" ng-disabled=\"F.readMode\"><div mongo-crud-detail-bar></div><md-content \nlayout=\"column\" class=\"content\" flex><div class=\"detail-form-container md-background-bg md-whiteframe-1dp\">\n<md-input-container class=\"md-block\"><label>Estado</label><input ms2-autofocus class=\"uppercased\" \nng-model-options=\"{ debounce: F.debounceTime }\" type=\"text\" name=\"name\" ng-model=\"incidencesStatusRecord.name\" \nmd-maxlength=\"20\" maxlength=\"20\" required></md-input-container></div></md-content></form></div>");
$templateCache.put("app/main/catalogs/views/incidences-status-records/incidences-status-records.html","<div id=\"incidencesStatusRecords\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div mongo-search-bar></div><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><div \ntable-loader array=\"incidencesStatusRecords\" validations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"incidencesStatusRecords.length\"><thead md-head \nmd-order=\"order\" fix-head md-on-reorder=\"getThem\"><tr md-row><th md-column md-order-by=\"name\"><span>\nEstado de Incidencia</span></th><th md-column><span>{{\'EC.ACTIONS\' | translate}}</span></th></tr></thead><tbody \nmd-body><tr md-row md-auto-select md-select=\"incidencesStatusRecord\" md-select-id=\"_id\" \nng-repeat=\"incidencesStatusRecord in incidencesStatusRecords\"><td md-cell>{{incidencesStatusRecord.name}}</td><td \nmd-cell><md-button class=\"edit-button md-icon-button\" ng-click=\"goToDetail(incidencesStatusRecord)\" \naria-label=\"go to details\"><md-icon md-font-icon=\"icon-pencil\" class=\"s16\" aria-label=\"edit\"></md-icon></md-button>\n</td></tr></tbody></table></md-table-container><md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" \nlayout-xs=\"column\" md-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" md-limit-options=\"F.paginations\" \nmd-page=\"currentPage\" md-total=\"{{pagination.total}}\" md-on-paginate=\"getThemPagination\" md-page-select>\n</md-table-pagination></div></div><md-fab-speed-dial md-open=\"F.isOpen\" \nmd-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\"><md-fab-trigger><md-button \naria-label=\"crud menu\" class=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon></md-button>\n</md-fab-trigger><md-fab-actions><md-button ng-if=\"selected.length\" ng-click=\"delete($event)\" aria-label=\"Delete\" \nclass=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">{{\'EC.REMOVE\' | translate}}</md-tooltip>\n<md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button><md-button ng-if=\"!selected.length\" \nng-click=\'R.goToDetail(\"new\")\' aria-label=\"add\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip \nmd-direction=\"left\">{{\'EC.ADD\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon>\n</md-button></md-fab-actions></md-fab-speed-dial></div></div>");
$templateCache.put("app/main/catalogs/views/imss-records/imss-record.html","<div id=\"imssRecord\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill><form name=\"form\" \nnovalidate flex layout=\"column\" ng-disabled=\"F.readMode\"><div mongo-crud-detail-bar></div><md-content layout=\"column\" \nclass=\"content\" flex><div class=\"detail-form-container md-background-bg md-whiteframe-1dp\"><md-input-container \nclass=\"md-block\"><label>Año</label><input ms2-autofocus type=\"number\" name=\"year\" ng-model=\"imssRecord.year\" required>\n</md-input-container><md-input-container class=\"md-block\"><label>Cuota Fija %</label><input type=\"number\" \nname=\"fixedFee\" ng-model=\"imssRecord.fixedFee\" required></md-input-container><md-input-container class=\"md-block\">\n<label>Execedente Asegurado</label><input type=\"number\" name=\"ensuredExcess\" ng-model=\"imssRecord.ensuredExcess\" \nrequired></md-input-container><md-input-container class=\"md-block\"><label>Excedente Patrón</label><input type=\"number\" \nname=\"bossExcess\" ng-model=\"imssRecord.bossExcess\" required></md-input-container><md-input-container class=\"md-block\">\n<label>Prestaciones dinero Patrón</label><input type=\"number\" name=\"bossBenefits\" ng-model=\"imssRecord.bossBenefits\" \nrequired></md-input-container><md-input-container class=\"md-block\"><label>Prestaciones dinero Asegurado</label><input \ntype=\"number\" name=\"ensuredBenefits\" ng-model=\"imssRecord.ensuredBenefits\" required></md-input-container>\n<md-input-container class=\"md-block\"><label>GMP Patrón</label><input type=\"number\" name=\"gmpBoss\" \nng-model=\"imssRecord.gmpBoss\" required></md-input-container><md-input-container class=\"md-block\"><label>GMP Asegurado\n</label><input type=\"number\" name=\"gmpEnsured\" ng-model=\"imssRecord.gmpEnsured\" required></md-input-container>\n<md-input-container class=\"md-block\"><label>IVA Patrón</label><input type=\"number\" name=\"ivaBoss\" \nng-model=\"imssRecord.ivaBoss\" required></md-input-container><md-input-container class=\"md-block\"><label>IVA Asegurado\n</label><input type=\"number\" name=\"ivaEnsured\" ng-model=\"imssRecord.ivaEnsured\" required></md-input-container>\n<md-input-container class=\"md-block\"><label>Guarderías</label><input type=\"number\" name=\"daycare\" \nng-model=\"imssRecord.daycare\" required></md-input-container><md-input-container class=\"md-block\"><label>Retiro</label>\n<input type=\"number\" name=\"retirement\" ng-model=\"imssRecord.retirement\" required></md-input-container>\n<md-input-container class=\"md-block\"><label>CYV Patrón</label><input type=\"number\" name=\"cyvBoss\" \nng-model=\"imssRecord.cyvBoss\" required></md-input-container><md-input-container class=\"md-block\"><label>CYV Asegurado\n</label><input type=\"number\" name=\"cyvEnsured\" ng-model=\"imssRecord.cyvEnsured\" required></md-input-container>\n<md-input-container class=\"md-block\"><label>Infonavit</label><input type=\"number\" name=\"infonavit\" \nng-model=\"imssRecord.infonavit\" required></md-input-container></div></md-content></form></div>");
$templateCache.put("app/main/catalogs/views/imss-records/imss-records.html","<div id=\"imssRecords\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div mongo-search-bar></div><div class=\"content-card\" layout=\"column\" \nflex><div class=\"content fullpage-datatable\" layout=\"column\" flex><div list-filters filters-loaded=\"F.filtersLoaded\" \nng-model=\"F.filters[F.active.menuName]\" on-change=\"getThem\" columns-repeat=\"columnsRepeat\" \nmenu-obj-name=\"{{F.active.menuObjName}}\" model-name=\"{{F.active.menuName}}\" init-filters=\"initFilters\"></div><div \ntable-loader array=\"imssRecords\" validations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"imssRecords.length\"><thead md-head md-order=\"order\" \nfix-head md-on-reorder=\"getThem\"><tr md-row><th md-column md-order-by=\"year\"><span>Año</span></th><th md-column \nmd-order-by=\"fixedFee\"><span>Cuota Fija</span></th></tr></thead><tbody md-body><tr md-row md-auto-select \nmd-select=\"imssRecord\" md-select-id=\"_id\" ng-repeat=\"imssRecord in imssRecords\"><td md-cell>{{imssRecord.year}}</td><td\n md-cell>{{imssRecord.fixedFee}}</td></tr></tbody></table></md-table-container><md-table-pagination \nlayout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" ng-show=\"imssRecords.length\" \nmd-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" md-limit-options=\"F.paginations\" md-page=\"currentPage\" \nmd-total=\"{{pagination.total}}\" md-on-paginate=\"getThemPagination\" md-page-select></md-table-pagination></div></div>\n<md-fab-speed-dial md-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" \nclass=\"ms2-speed-dial bottom right\"><md-fab-trigger><md-button aria-label=\"crud menu\" \nclass=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon></md-button></md-fab-trigger>\n<md-fab-actions><md-button with-permission action=\"update\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" \nng-click=\"R.goToDetail(selected[0])\" aria-label=\"edit\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip \nmd-direction=\"left\">Editar</md-tooltip><md-icon md-font-icon=\"icon-pencil\" aria-label=\"edit\"></md-icon></md-button>\n<md-button with-permission action=\"remove\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length\" \nng-click=\"delete($event)\" aria-label=\"Delete\" class=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">\n{{\'EC.REMOVE\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button>\n<md-button with-permission action=\"create\" access=\"{{F.active.menuItem}}\" ng-if=\"!selected.length\" \nng-click=\'R.goToDetail(\"new\")\' aria-label=\"add\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip \nmd-direction=\"left\">{{\'EC.ADD\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon>\n</md-button></md-fab-actions></md-fab-speed-dial></div></div>");
$templateCache.put("app/main/catalogs/views/issuers/issuer.html","<div id=\"issuer\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill><form name=\"form\" \nnovalidate flex layout=\"column\" ng-disabled=\"F.readMode\"><div mongo-crud-detail-bar></div><md-content layout=\"column\" \nclass=\"content\" flex><div class=\"detail-form-container md-background-bg md-whiteframe-1dp\"><md-input-container \nclass=\"md-block\"><label>Empresa</label><md-select ms2-autofocus class=\"filter\" ng-model=\"issuer.companiesRecord\" \nplaceholder=\"Seleccione Empresa\" required><md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" \nng-keydown=\"$event.stopPropagation()\" ng-model=\"companiesRecordSelectFilter\" placeholder=\"Busque una Empresa\">\n</md-select-header><md-option ng-value=\"companiesRecord.$id \" \nng-repeat=\"companiesRecord in L.companiesRecords | orderBy:\'name\' | filter:companiesRecordSelectFilter\">\n{{companiesRecord.name}}</md-option></md-select></md-input-container><md-input-container flex class=\"md-block\"><label>\nEmisora</label><input class=\"uppercased\" ng-model-options=\"{ debounce: F.debounceTime }\" type=\"text\" name=\"name\" \nng-model=\"issuer.name\" md-maxlength=\"40\" maxlength=\"40\" required></md-input-container><div layout-gt-xs=\"row\">\n<md-input-container flex class=\"md-block\"><label>Folio Inicio</label><input type=\"number\" name=\"startAt\" \nng-max=\"issuer.endAt?issuer.endAt-1:null\" ng-model=\"issuer.startAt\" min=\"1\"><div ng-messages=\"form.startAt.$error\" \nng-show=\"form.startAt.$touched || form.startAt.$dirty\" role=\"alert\"><div ng-message=\"min\">No puede ser inferior a 1\n</div><div ng-message=\"max\">No puede ser superior a {{issuer.endAt-1}}</div></div></md-input-container>\n<md-input-container flex class=\"md-block\"><label>Folio Fin</label><input type=\"number\" name=\"endAt\" \nng-min=\"issuer.startAt?issuer.startAt+1:null\" ng-model=\"issuer.endAt\"><div ng-messages=\"form.endAt.$error\" \nng-show=\"form.endAt.$touched || form.endAt.$dirty\" role=\"alert\"><div ng-message=\"min\">\nNo puede ser inferior a {{issuer.startAt+1}}</div></div></md-input-container><md-input-container flex class=\"md-block\">\n<label>Folio Actual</label><input type=\"number\" ng-min=\"issuer.startAt?issuer.startAt:1\" \nng-max=\"issuer.endAt?issuer.endAt:null\" name=\"folio\" ng-model=\"issuer.folio\" required><div \nng-messages=\"form.folio.$error\" ng-show=\"form.folio.$touched || form.folio.$dirty\" role=\"alert\"><div ng-message=\"min\">\nNo puede ser inferior a {{issuer.startAt?issuer.startAt:1}}</div><div ng-message=\"max\">\nNo puede ser superior a {{issuer.endAt}}</div><div ng-message=\"required\">Este campo es requerido</div></div>\n</md-input-container></div><md-input-container class=\"md-block\"><label>Excluidos</label><input type=\"text\" \nname=\"reserved\" ng-model=\"issuer.reserved\"></md-input-container></div></md-content></form></div>");
$templateCache.put("app/main/catalogs/views/issuers/issuers.html","<div id=\"issuers\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div mongo-search-bar></div><div class=\"content-card\" layout=\"column\" flex>\n<div class=\"content fullpage-datatable\" layout=\"column\" flex><div table-loader array=\"issuers\" \nvalidations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"issuers.length\"><thead md-head md-order=\"F.orderMongo\" \nfix-head md-on-reorder=\"getThem\"><tr md-row><th md-column md-order-by=\"companiesRecord\"><span>Empresa</span></th><th \nmd-column md-order-by=\"name\"><span>Emisora</span></th></tr></thead><tbody md-body><tr md-row md-auto-select \nmd-select=\"issuer\" md-select-id=\"_id\" ng-repeat=\"issuer in issuers\"><td md-cell>\n{{issuer.companiesRecord | getSomethingOfArrayFB:L.companiesRecords:\'name\':\'N/A\'}}</td><td md-cell>{{issuer.name}}</td>\n</tr></tbody></table></md-table-container><md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" \nlayout-xs=\"column\" ng-show=\"issuers.length\" md-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" \nmd-limit-options=\"F.paginations\" md-page=\"currentPage\" md-total=\"{{pagination.total}}\" \nmd-on-paginate=\"getThemPagination\" md-page-select></md-table-pagination></div></div><md-fab-speed-dial \nmd-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\"><md-fab-trigger>\n<md-button aria-label=\"crud menu\" class=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon>\n</md-button></md-fab-trigger><md-fab-actions><md-button with-permission action=\"update\" access=\"{{F.active.menuItem}}\" \nng-if=\"selected.length == 1\" ng-click=\"R.goToDetail(selected[0])\" aria-label=\"edit\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Editar</md-tooltip><md-icon \nmd-font-icon=\"icon-pencil\" aria-label=\"edit\"></md-icon></md-button><md-button with-permission action=\"remove\" \naccess=\"{{F.active.menuItem}}\" ng-if=\"selected.length\" ng-click=\"delete($event)\" aria-label=\"Delete\" \nclass=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">{{\'EC.REMOVE\' | translate}}</md-tooltip>\n<md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button><md-button with-permission \naction=\"create\" access=\"{{F.active.menuItem}}\" ng-if=\"!selected.length\" ng-click=\'R.goToDetail(\"new\")\' \naria-label=\"add\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">\n{{\'EC.ADD\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon></md-button>\n</md-fab-actions></md-fab-speed-dial></div></div>");
$templateCache.put("app/main/catalogs/views/isr-records/isr-record.html","<div id=\"isrRecord\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill><form name=\"form\" \nnovalidate flex layout=\"column\" ng-disabled=\"F.readMode\"><div mongo-crud-detail-bar></div><md-content layout=\"column\" \nclass=\"content\" flex><div class=\"detail-form-container md-background-bg md-whiteframe-1dp\"><div flex \nlayout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex><label>Año</label><input ms2-autofocus type=\"number\" \nname=\"year\" ng-model=\"isrRecord.year\" required></md-input-container><md-input-container class=\"md-block\" flex><label>\nPeriodo</label><md-select ng-model=\"isrRecord.type\" placeholder=\"Seleccione Periodicidad\" required><md-option \nng-value=\"period.id\" ng-repeat=\"period in F.periodicity\">{{period.name}}</md-option></md-select></md-input-container>\n</div><div flex layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex><label>Limite Inferior</label><input \ntype=\"number\" name=\"lowerLimit\" ng-model=\"isrRecord.lowerLimit\" required></md-input-container><md-input-container \nclass=\"md-block\" flex><label>Cuota Fija</label><input type=\"number\" name=\"fixedFee\" ng-model=\"isrRecord.fixedFee\" \nrequired></md-input-container><md-input-container class=\"md-block\" flex><label>Porcentaje</label><input type=\"number\" \nname=\"percentFee\" ng-model=\"isrRecord.percentFee\" required></md-input-container></div></div></md-content></form></div>");
$templateCache.put("app/main/catalogs/views/isr-records/isr-records.html","<div id=\"isrRecords\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div mongo-search-bar></div><div class=\"content-card\" layout=\"column\" \nflex><div class=\"content fullpage-datatable\" layout=\"column\" flex><div list-filters filters-loaded=\"F.filtersLoaded\" \nng-model=\"F.filters[F.active.menuName]\" on-change=\"getThem\" columns-repeat=\"columnsRepeat\" \nmenu-obj-name=\"{{F.active.menuObjName}}\" model-name=\"{{F.active.menuName}}\" init-filters=\"initFilters\"></div><div \ntable-loader array=\"isrRecords\" validations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"isrRecords.length\"><thead md-head md-order=\"order\" \nfix-head md-on-reorder=\"getThem\"><tr md-row><th md-column md-order-by=\"year\"><span>Año</span></th><th md-column \nmd-order-by=\"lowerLimit\"><span>Límite Inferior</span></th><th md-column md-order-by=\"fixedFee\"><span>Cuota Fija</span>\n</th><th md-column md-order-by=\"percentFee\"><span>Cuota Porcentual</span></th><th md-column md-order-by=\"type\"><span>\nPeriodicidad</span></th></tr></thead><tbody md-body><tr md-row md-auto-select md-select=\"isrRecord\" md-select-id=\"_id\" \nng-repeat=\"isrRecord in isrRecords\"><td md-cell>{{isrRecord.year}}</td><td md-cell>{{isrRecord.lowerLimit}}</td><td \nmd-cell>{{isrRecord.fixedFee}}</td><td md-cell>{{isrRecord.percentFee}}</td><td md-cell>\n{{isrRecord.type | getSomethingOfArrayFB : F.periodicity : \'name\' : \'S/P\' : \'id\'}}</td></tr></tbody></table>\n</md-table-container><md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" \nng-show=\"isrRecords.length\" md-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" md-limit-options=\"F.paginations\" \nmd-page=\"currentPage\" md-total=\"{{pagination.total}}\" md-on-paginate=\"getThemPagination\" md-page-select>\n</md-table-pagination></div></div><md-fab-speed-dial md-open=\"F.isOpen\" \nmd-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\"><md-fab-trigger><md-button \naria-label=\"crud menu\" class=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon></md-button>\n</md-fab-trigger><md-fab-actions><md-button with-permission action=\"update\" access=\"{{F.active.menuItem}}\" \nng-if=\"selected.length == 1\" ng-click=\"R.goToDetail(selected[0])\" aria-label=\"edit\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Editar</md-tooltip><md-icon \nmd-font-icon=\"icon-pencil\" aria-label=\"edit\"></md-icon></md-button><md-button with-permission action=\"remove\" \naccess=\"{{F.active.menuItem}}\" ng-if=\"selected.length\" ng-click=\"delete($event)\" aria-label=\"Delete\" \nclass=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">{{\'EC.REMOVE\' | translate}}</md-tooltip>\n<md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button><md-button with-permission \naction=\"create\" access=\"{{F.active.menuItem}}\" ng-if=\"!selected.length\" ng-click=\'R.goToDetail(\"new\")\' \naria-label=\"add\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">\n{{\'EC.ADD\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon></md-button>\n</md-fab-actions></md-fab-speed-dial></div></div>");
$templateCache.put("app/main/catalogs/views/minimum-wage-records/minimum-wage-record.html","<div id=\"minimumWageRecord\" ng-controller=\"MinimumWageRecordController\" class=\"page-layout simple tabbed crud-detail\" \nlayout=\"column\" layout-fill><form name=\"form\" novalidate flex layout=\"column\" ng-disabled=\"F.readMode\"><div \nmongo-crud-detail-bar></div><md-content layout=\"column\" class=\"content\" flex><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\"><div layout-gt-xs=\"row\"><md-input-container \nclass=\"md-block\" flex><label>Año</label><input ms2-autofocus type=\"number\" name=\"year\" \nng-model=\"minimumWageRecord.year\" required></md-input-container><md-input-container class=\"md-block date-picker\" flex>\n<label>Fecha de Aplicacion</label><md-datepicker ng-disabled=\"F.readMode\" md-hide-icons=\"triangle\" \nmd-current-view=\"{{F.dateView}}\" md-min-date=\"minEnroleDate\" md-max-date=\"maxEnroleDate\" input-date-miliseconds \nng-model=\"minimumWageRecord.applicationDate\" name=\"applicationDate\" class=\"md-block\" required></md-datepicker><div \nng-messages=\"form.applicationDate.$error\" role=\"alert\"><div ng-message=\"required\">Fecha de Alta es requerido</div><div \nng-message=\"min\">Fecha de Alta debe ser a partir de {{minEnroleDate | date}}</div><div ng-message=\"max\">\nFecha de Alta debe ser antes de {{maxEnroleDate | date}}</div><div ng-message=\"mindate\">\nFecha de Alta debe ser a partir de {{minEnroleDate | date}}</div><div ng-message=\"maxdate\">\nFecha de Alta debe ser antes de {{maxEnroleDate | date}}</div></div></md-input-container></div><div \nng-repeat=\"item in M.geoZones\" layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex><label>{{item.name}}\n</label><input type=\"number\" name=\"{{item.key}}\" ng-required=\"item.status\" \nng-model=\"minimumWageRecord.values[item.key]\"></md-input-container></div></div></md-content></form></div>");
$templateCache.put("app/main/catalogs/views/minimum-wage-records/minimum-wage-records.html","<div id=\"minimumWageRecords\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\" \nng-controller=\"MinimunWageRecordsController\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" \nlayout=\"column\" flex><div mongo-search-bar></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><div list-filters filters-loaded=\"F.filtersLoaded\" \nng-model=\"F.filters[F.active.menuName]\" on-change=\"getThem\" columns-repeat=\"columnsRepeat\" \nmenu-obj-name=\"{{F.active.menuObjName}}\" model-name=\"{{F.active.menuName}}\" init-filters=\"initFilters\"></div><div \ntable-loader array=\"minimumWageRecords\" validations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"minimumWageRecords.length\"><thead md-head \nmd-order=\"order\" fix-head md-on-reorder=\"getThem\"><tr md-row><th md-column md-order-by=\"year\"><span>Año</span></th><th \nmd-column md-order-by=\"applicationDate\"><span>Fecha de Aplicación</span></th><th md-colum><span>Valores</span></th>\n</tr></thead><tbody md-body><tr md-row md-auto-select md-select=\"minimumWageRecord\" md-select-id=\"_id\" \nng-repeat=\"minimumWageRecord in minimumWageRecords\"><td md-cell>{{minimumWageRecord.year}}</td><td md-cell>\n{{minimumWageRecord.applicationDate | date:F.dateFormat}}</td><td md-cell><span \nng-repeat=\"value in minimumWageRecord.valuesArray | orderBy: \'$id\'\" ng-if=\"value.value\"><b>{{value.$id}}</b>\n:{{value.value}} {{(minimumWageRecord.valuesArray.length-1 == $index)?\"\":\" - \"}}</span></td></tr></tbody></table>\n</md-table-container><md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" \nng-show=\"minimumWageRecords.length\" md-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" \nmd-limit-options=\"F.paginations\" md-page=\"$parent.currentPage\" md-total=\"{{pagination.total}}\" \nmd-on-paginate=\"getThemPagination\" md-page-select></md-table-pagination></div></div><md-fab-speed-dial \nmd-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\"><md-fab-trigger>\n<md-button aria-label=\"crud menu\" class=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon>\n</md-button></md-fab-trigger><md-fab-actions><md-button with-permission action=\"update\" access=\"{{F.active.menuItem}}\" \nng-if=\"selected.length == 1\" ng-click=\"clearArray(selected[0])\" aria-label=\"edit\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Editar</md-tooltip><md-icon \nmd-font-icon=\"icon-pencil\" aria-label=\"edit\"></md-icon></md-button><md-button with-permission action=\"remove\" \naccess=\"{{F.active.menuItem}}\" ng-if=\"selected.length\" ng-click=\"delete($event)\" aria-label=\"Delete\" \nclass=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">{{\'EC.REMOVE\' | translate}}</md-tooltip>\n<md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button><md-button with-permission \naction=\"create\" access=\"{{F.active.menuItem}}\" ng-if=\"!selected.length\" ng-click=\'R.goToDetail(\"new\")\' \naria-label=\"add\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">\n{{\'EC.ADD\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon></md-button>\n</md-fab-actions></md-fab-speed-dial></div></div>");
$templateCache.put("app/main/catalogs/views/month-for-accumulated-records/month-for-accumulated-record.html","<div id=\"monthForAccumulatedRecord\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill><form \nname=\"form\" novalidate flex layout=\"column\" ng-disabled=\"F.readMode\"><div mongo-crud-detail-bar></div><md-content \nlayout=\"column\" class=\"content\" flex><div class=\"detail-form-container md-background-bg md-whiteframe-1dp\">\n<md-input-container class=\"md-block\"><label>Mes</label><input ms2-autofocus class=\"uppercased\" \nng-model-options=\"{ debounce: F.debounceTime }\" type=\"text\" name=\"name\" ng-model=\"monthForAccumulatedRecord.name\" \nmd-maxlength=\"40\" maxlength=\"40\" required></md-input-container></div></md-content></form></div>");
$templateCache.put("app/main/catalogs/views/month-for-accumulated-records/month-for-accumulated-records.html","<div id=\"monthForAccumulatedRecords\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div mongo-search-bar></div><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><div \ntable-loader array=\"monthForAccumulatedRecords\" validations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"monthForAccumulatedRecords.length\"><thead md-head \nmd-order=\"F.orderMongo\" fix-head md-on-reorder=\"getThem\"><tr md-row><th md-column md-order-by=\"name\"><span>Mes</span>\n</th></tr></thead><tbody md-body><tr md-row md-auto-select md-select=\"monthForAccumulatedRecord\" md-select-id=\"_id\" \nng-repeat=\"monthForAccumulatedRecord in monthForAccumulatedRecords\"><td md-cell>{{monthForAccumulatedRecord.name}}</td>\n</tr></tbody></table></md-table-container><md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" \nlayout-xs=\"column\" ng-show=\"monthForAccumulatedRecords.length\" md-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" \nmd-limit-options=\"F.paginations\" md-page=\"currentPage\" md-total=\"{{pagination.total}}\" \nmd-on-paginate=\"getThemPagination\" md-page-select></md-table-pagination></div></div><md-fab-speed-dial \nmd-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\"><md-fab-trigger>\n<md-button aria-label=\"crud menu\" class=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon>\n</md-button></md-fab-trigger><md-fab-actions><md-button with-permission action=\"update\" access=\"{{F.active.menuItem}}\" \nng-if=\"selected.length == 1\" ng-click=\"R.goToDetail(selected[0])\" aria-label=\"edit\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Editar</md-tooltip><md-icon \nmd-font-icon=\"icon-pencil\" aria-label=\"edit\"></md-icon></md-button><md-button with-permission action=\"remove\" \naccess=\"{{F.active.menuItem}}\" ng-if=\"selected.length\" ng-click=\"delete($event)\" aria-label=\"Delete\" \nclass=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">{{\'EC.REMOVE\' | translate}}</md-tooltip>\n<md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button><md-button with-permission \naction=\"create\" access=\"{{F.active.menuItem}}\" ng-if=\"!selected.length\" ng-click=\'R.goToDetail(\"new\")\' \naria-label=\"add\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">\n{{\'EC.ADD\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon></md-button>\n</md-fab-actions></md-fab-speed-dial></div></div>");
$templateCache.put("app/main/catalogs/views/nfd-records/nfd-record.html","<div id=\"nfdRecord\" ng-controller=\"nfdController\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" \nlayout-fill><form name=\"form\" novalidate flex layout=\"column\" ng-disabled=\"F.readMode\"><div mongo-crud-detail-bar>\n</div><md-content layout=\"column\" class=\"content\" flex><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\"><md-input-container class=\"md-block\"><label>Año\n</label><input ms2-autofocus type=\"number\" name=\"year\" ng-model=\"nfdRecord.year\" required></md-input-container>\n<md-input-container class=\"md-block\"><label>NFD</label><input type=\"number\" name=\"value\" ng-model=\"nfdRecord.value\" \nrequired></md-input-container><md-input-container class=\"md-block date-picker\" flex><label>Fecha de Aplicacion</label>\n<md-datepicker ng-disabled=\"F.readMode\" md-hide-icons=\"triangle\" md-current-view=\"{{F.dateView}}\" \nmd-min-date=\"minEnroleDate\" md-max-date=\"maxEnroleDate\" input-date-miliseconds ng-model=\"nfdRecord.applicationDate\" \nname=\"applicationDate\" class=\"md-block\" required></md-datepicker><div ng-messages=\"form.applicationDate.$error\" \nrole=\"alert\"><div ng-message=\"required\">Fecha de Alta es requerido</div><div ng-message=\"min\">\nFecha de Alta debe ser a partir de {{minEnroleDate | date}}</div><div ng-message=\"max\">\nFecha de Alta debe ser antes de {{maxEnroleDate | date}}</div><div ng-message=\"mindate\">\nFecha de Alta debe ser a partir de {{minEnroleDate | date}}</div><div ng-message=\"maxdate\">\nFecha de Alta debe ser antes de {{maxEnroleDate | date}}</div></div></md-input-container></div></md-content></form>\n</div>");
$templateCache.put("app/main/catalogs/views/nfd-records/nfd-records.html","<div id=\"nfdRecords\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div mongo-search-bar></div><div class=\"content-card\" layout=\"column\" \nflex><div class=\"content fullpage-datatable\" layout=\"column\" flex><div list-filters filters-loaded=\"F.filtersLoaded\" \nng-model=\"F.filters[F.active.menuName]\" on-change=\"getThem\" columns-repeat=\"columnsRepeat\" \nmenu-obj-name=\"{{F.active.menuObjName}}\" model-name=\"{{F.active.menuName}}\" init-filters=\"initFilters\"></div><div \ntable-loader array=\"nfdRecords\" validations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"nfdRecords.length\"><thead md-head md-order=\"order\" \nfix-head md-on-reorder=\"getThem\"><tr md-row><th md-column md-order-by=\"year\"><span>Año</span></th><th md-column \nmd-order-by=\"value\"><span>NFD</span></th><th md-column md-order-by=\"applicationDate\"><span>Fecha de Aplicación</span>\n</th></tr></thead><tbody md-body><tr md-row md-auto-select md-select=\"nfdRecord\" md-select-id=\"_id\" \nng-repeat=\"nfdRecord in nfdRecords\"><td md-cell>{{nfdRecord.year}}</td><td md-cell>{{nfdRecord.value}}</td><td md-cell>\n{{nfdRecord.applicationDate | date:F.dateFormat}}</td></tr></tbody></table></md-table-container><md-table-pagination \nlayout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" ng-show=\"nfdRecords.length\" \nmd-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" md-limit-options=\"F.paginations\" md-page=\"currentPage\" \nmd-total=\"{{pagination.total}}\" md-on-paginate=\"getThemPagination\" md-page-select></md-table-pagination></div></div>\n<md-fab-speed-dial md-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" \nclass=\"ms2-speed-dial bottom right\"><md-fab-trigger><md-button aria-label=\"crud menu\" \nclass=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon></md-button></md-fab-trigger>\n<md-fab-actions><md-button with-permission action=\"update\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" \nng-click=\"R.goToDetail(selected[0])\" aria-label=\"edit\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip \nmd-direction=\"left\">Editar</md-tooltip><md-icon md-font-icon=\"icon-pencil\" aria-label=\"edit\"></md-icon></md-button>\n<md-button with-permission action=\"remove\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length\" \nng-click=\"delete($event)\" aria-label=\"Delete\" class=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">\n{{\'EC.REMOVE\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button>\n<md-button with-permission action=\"create\" access=\"{{F.active.menuItem}}\" ng-if=\"!selected.length\" \nng-click=\'R.goToDetail(\"new\")\' aria-label=\"add\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip \nmd-direction=\"left\">{{\'EC.ADD\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon>\n</md-button></md-fab-actions></md-fab-speed-dial></div></div>");
$templateCache.put("app/main/catalogs/views/payment-forms/payment-form.html","<div id=\"paymentForm\" class=\"page-layout simple tabbed crud-detail\" ng-controller=\"paymentFormController\" \nlayout=\"column\" layout-fill><form name=\"form\" novalidate flex layout=\"column\" ng-disabled=\"F.readMode\"><div \nmongo-crud-detail-bar flex=\"nogrow\"></div><md-content layout=\"column\" class=\"content\" flex><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\" flex=\"grow\"><div layout-gt-xs=\"row\">\n<md-input-container class=\"md-block\" flex><label>Key</label><input ms2-autofocus type=\"text\" name=\"key\" \nng-model-options=\"{ debounce: F.debounceTime }\" ng-model=\"paymentForm.key\" ng-change=\"validate(paymentForm.key)\" \nunique-mongo catalog=\"paymentForms\" field=\"key\" from-id=\"{{paymentForm._id}}\" required><div \nng-messages=\"form.key.$error\" role=\"alert\"><div ng-message=\"required\">El id es requerido</div><div ng-message=\"unique\">\nEste valor ya existe</div></div></md-input-container><md-input-container class=\"md-block\" flex><label>Nombre</label>\n<input class=\"uppercased\" ng-model-options=\"{ debounce: F.debounceTime }\" type=\"text\" name=\"name\" \nng-model=\"paymentForm.name\" required><div ng-messages=\"form.name.$error\" role=\"alert\"><div ng-message=\"required\">\nEl Nombre es requerido</div></div></md-input-container></div></div></md-content></form></div>");
$templateCache.put("app/main/catalogs/views/payment-forms/payment-forms.html","<div id=\"filters\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div mongo-search-bar></div><div class=\"content-card\" layout=\"column\" flex>\n<div class=\"content fullpage-datatable\" layout=\"column\" flex><div table-loader array=\"paymentForms\" \nvalidations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"paymentForms.length\"><thead md-head \nmd-order=\"F.orderMongo\" fix-head md-on-reorder=\"getThem\"><tr md-row><th md-column md-order-by=\"key\"><span>Key</span>\n</th><th md-column md-order-by=\"name\"><span>Nombre</span></th></tr></thead><tbody md-body><tr md-row md-auto-select \nmd-select=\"paymentForm\" md-select-id=\"_id\" ng-repeat=\"paymentForm in paymentForms\"><td md-cell>{{paymentForm.key}}</td>\n<td md-cell>{{paymentForm.name}}</td></tr></tbody></table></md-table-container><md-table-pagination \nlayout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" ng-show=\"paymentForm.length\" \nmd-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" md-limit-options=\"F.paginations\" md-page=\"currentPage\" \nmd-total=\"{{pagination.total}}\" md-on-paginate=\"getThemPagination\" md-page-select></md-table-pagination></div></div>\n<md-fab-speed-dial md-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" \nclass=\"ms2-speed-dial bottom right\"><md-fab-trigger><md-button aria-label=\"crud menu\" \nclass=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon></md-button></md-fab-trigger>\n<md-fab-actions><md-button with-permission action=\"update\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" \nng-click=\"R.goToDetail(selected[0])\" aria-label=\"edit\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip \nmd-direction=\"left\">Editar</md-tooltip><md-icon md-font-icon=\"icon-pencil\" aria-label=\"edit\"></md-icon></md-button>\n<md-button with-permission action=\"remove\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length\" \nng-click=\"delete($event)\" aria-label=\"Delete\" class=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">\n{{\'EC.REMOVE\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button>\n<md-button with-permission action=\"create\" access=\"{{F.active.menuItem}}\" ng-if=\"!selected.length\" \nng-click=\'R.goToDetail(\"new\")\' aria-label=\"add\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip \nmd-direction=\"left\">{{\'EC.ADD\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon>\n</md-button></md-fab-actions></md-fab-speed-dial></div></div>");
$templateCache.put("app/main/catalogs/views/payment-frequencies-records/payment-frequencies-record.html","<div id=\"paymentFrequenciesRecord\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill><form \nname=\"form\" novalidate flex layout=\"column\" ng-disabled=\"F.readMode\"><div mongo-crud-detail-bar></div><md-content \nlayout=\"column\" class=\"content\" flex><div class=\"detail-form-container md-background-bg md-whiteframe-1dp\">\n<md-input-container class=\"md-block\"><label>Frecuencia</label><input ms2-autofocus class=\"uppercased\" \nng-model-options=\"{ debounce: F.debounceTime }\" type=\"text\" name=\"name\" ng-model=\"paymentFrequenciesRecord.name\" \nmd-maxlength=\"20\" maxlength=\"20\" required><div ng-messages=\"form.name.$error\" \nng-show=\"form.name.$touched || form.name.$dirty\"><div ng-message=\"required\">La frecuencia es requerido</div></div>\n</md-input-container><md-input-container class=\"md-block\"><label>Días</label><input type=\"number\" name=\"days\" \nng-model=\"paymentFrequenciesRecord.days\" required><div ng-messages=\"form.days.$error\" \nng-show=\"form.days.$touched || form.days.$dirty\"><div ng-message=\"required\">Los días es requerido</div></div>\n</md-input-container><md-input-container class=\"md-block\"><label>Factor Fijo</label><input type=\"number\" name=\"factor\" \nng-model=\"paymentFrequenciesRecord.mensualizationFactor\" required><div ng-messages=\"form.factor.$error\" \nng-show=\"form.factor.$touched || form.factor.$dirty\"><div ng-message=\"required\">El factor fijo es requerido</div></div>\n</md-input-container><md-input-container class=\"md-block\"><label>Otros relativos</label><input type=\"number\" \nname=\"otherCharges\" ng-model=\"paymentFrequenciesRecord.otherCharges\"><div ng-messages=\"form.otherCharges.$error\" \nng-show=\"form.otherCharges.$touched || form.otherCharges.$dirty\"><div ng-message=\"required\">\nOtros relativos es requerido</div></div></md-input-container><md-input-container class=\"md-block\"><label>Código del SAT\n</label><input class=\"uppercased\" ng-model-options=\"{ debounce: F.debounceTime }\" type=\"text\" name=\"satCode\" \nng-model=\"paymentFrequenciesRecord.satCode\" required><div ng-messages=\"form.satCode.$error\" \nng-show=\"form.satCode.$touched || form.satCode.$dirty\"><div ng-message=\"required\">El código del sat es requerido</div>\n</div></md-input-container></div></md-content></form></div>");
$templateCache.put("app/main/catalogs/views/payment-frequencies-records/payment-frequencies-records.html","<div id=\"paymentFrequenciesRecords\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div mongo-search-bar></div><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><div \ntable-loader array=\"paymentFrequenciesRecords\" validations=\"validations\"></div><md-table-container \nng-init=\'order = \"days\"\'><table md-table md-row-select multiple=\"true\" ng-model=\"selected\" class=\"row-border\" \nng-show=\"paymentFrequenciesRecords.length\"><thead md-head md-order=\"order\" fix-head md-on-reorder=\"getThem\"><tr md-row>\n<th md-column md-order-by=\"name\"><span>Frecuencia</span></th><th md-column md-order-by=\"days\"><span>Dias</span></th><th\n md-column md-order-by=\"mensualizationFactor\"><span>Factor de Mensualizacion</span></th><th md-column \nmd-order-by=\"satCode\"><span>Código de SAT</span></th></tr></thead><tbody md-body><tr md-row md-auto-select \nmd-select=\"paymentFrequenciesRecord\" md-select-id=\"_id\" \nng-repeat=\"paymentFrequenciesRecord in paymentFrequenciesRecords | orderBy:order \"><td md-cell>\n{{paymentFrequenciesRecord.name}}</td><td md-cell>{{paymentFrequenciesRecord.days}}</td><td md-cell>\n{{paymentFrequenciesRecord.mensualizationFactor}}</td><td md-cell>{{paymentFrequenciesRecord.satCode}}</td></tr>\n</tbody></table></md-table-container><md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" \nlayout-xs=\"column\" ng-show=\"paymentFrequenciesRecords.length\" md-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" \nmd-limit-options=\"F.paginations\" md-page=\"currentPage\" md-total=\"{{pagination.total}}\" \nmd-on-paginate=\"getThemPagination\" md-page-select></md-table-pagination></div></div><md-fab-speed-dial \nmd-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\"><md-fab-trigger>\n<md-button aria-label=\"crud menu\" class=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon>\n</md-button></md-fab-trigger><md-fab-actions><md-button with-permission action=\"update\" access=\"{{F.active.menuItem}}\" \nng-if=\"selected.length == 1\" ng-click=\"R.goToDetail(selected[0])\" aria-label=\"edit\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Editar</md-tooltip><md-icon \nmd-font-icon=\"icon-pencil\" aria-label=\"edit\"></md-icon></md-button><md-button with-permission action=\"remove\" \naccess=\"{{F.active.menuItem}}\" ng-if=\"selected.length\" ng-click=\"delete($event)\" aria-label=\"Delete\" \nclass=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">{{\'EC.REMOVE\' | translate}}</md-tooltip>\n<md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button><md-button with-permission \naction=\"create\" access=\"{{F.active.menuItem}}\" ng-if=\"!selected.length\" ng-click=\'R.goToDetail(\"new\")\' \naria-label=\"add\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">\n{{\'EC.ADD\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon></md-button>\n</md-fab-actions></md-fab-speed-dial></div></div>");
$templateCache.put("app/main/catalogs/views/payment-groups/payment-group.html","<div id=\"paymentGroup\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill><form name=\"form\" \nnovalidate flex layout=\"column\" ng-disabled=\"F.readMode\"><div mongo-crud-detail-bar></div><md-content layout=\"column\" \nclass=\"content\" flex><div class=\"detail-form-container md-background-bg md-whiteframe-1dp\"><md-input-container \nclass=\"md-block\"><label>Grupo de Pago *</label><input class=\"uppercased\" \nng-model-options=\"{ debounce: F.debounceTime }\" type=\"text\" name=\"name\" ng-model=\"paymentGroup.name\" md-maxlength=\"20\" \nmaxlength=\"20\" required></md-input-container></div></md-content></form></div>");
$templateCache.put("app/main/catalogs/views/payment-groups/payment-groups.html","<div id=\"paymentGroups\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div mongo-search-bar></div><div class=\"content-card\" layout=\"column\" \nflex><div class=\"content fullpage-datatable\" layout=\"column\" flex><div table-loader array=\"paymentGroups\" \nvalidations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"paymentGroups.length\"><thead md-head md-order=\"order\" \nfix-head md-on-reorder=\"getThem\"><tr md-row><th md-column md-order-by=\"name\"><span>Grupo de Pago</span></th></tr>\n</thead><tbody md-body><tr md-row md-auto-select md-select=\"paymentGroup\" md-select-id=\"_id\" \nng-repeat=\"paymentGroup in paymentGroups\"><td md-cell>{{paymentGroup.name}}</td></tr></tbody></table>\n</md-table-container><md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" \nng-show=\"paymentGroups.length\" md-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" md-limit-options=\"F.paginations\" \nmd-page=\"currentPage\" md-total=\"{{pagination.total}}\" md-on-paginate=\"getThemPagination\" md-page-select>\n</md-table-pagination></div></div><md-fab-speed-dial md-open=\"F.isOpen\" \nmd-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\"><md-fab-trigger><md-button \naria-label=\"crud menu\" class=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon></md-button>\n</md-fab-trigger><md-fab-actions><md-button with-permission action=\"update\" access=\"{{F.active.menuItem}}\" \nng-if=\"selected.length == 1\" ng-click=\"R.goToDetail(selected[0])\" aria-label=\"edit\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Editar</md-tooltip><md-icon \nmd-font-icon=\"icon-pencil\" aria-label=\"edit\"></md-icon></md-button><md-button with-permission action=\"remove\" \naccess=\"{{F.active.menuItem}}\" ng-if=\"selected.length\" ng-click=\"delete($event)\" aria-label=\"Delete\" \nclass=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">{{\'EC.REMOVE\' | translate}}</md-tooltip>\n<md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button><md-button with-permission \naction=\"create\" access=\"{{F.active.menuItem}}\" ng-if=\"!selected.length\" ng-click=\'R.goToDetail(\"new\")\' \naria-label=\"add\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">\n{{\'EC.ADD\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon></md-button>\n</md-fab-actions></md-fab-speed-dial></div></div>");
$templateCache.put("app/main/catalogs/views/placeTypes/placeType.html","<div id=\"placeType\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill><form name=\"form\" \nnovalidate flex layout=\"column\" ng-disabled=\"F.readMode\"><div mongo-crud-detail-bar></div><md-content layout=\"column\" \nclass=\"content\" flex><div class=\"detail-form-container md-background-bg md-whiteframe-1dp\"><md-input-container \nclass=\"md-block\"><label>Nombre</label><input ms2-autofocus class=\"uppercased\" \nng-model-options=\"{ debounce: F.debounceTime }\" type=\"text\" name=\"name\" ng-model=\"placeType.name\" md-maxlength=\"20\" \nmaxlength=\"20\" required></md-input-container></div></md-content></form></div>");
$templateCache.put("app/main/catalogs/views/placeTypes/placeTypes.html","<div id=\"placeTypes\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div mongo-search-bar></div><div class=\"content-card\" layout=\"column\" \nflex><div class=\"content fullpage-datatable\" layout=\"column\" flex><div table-loader array=\"placeTypes\" \nvalidations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"placeTypes.length\"><thead md-head \nmd-order=\"F.orderMongo\" fix-head md-on-reorder=\"getThem\"><tr md-row><th md-column md-order-by=\"name\"><span>Nombre\n</span></th></tr></thead><tbody md-body><tr md-row md-auto-select md-select=\"placeType\" md-select-id=\"_id\" \nng-repeat=\"placeType in placeTypes\"><td md-cell>{{placeType.name}}</td></tr></tbody></table></md-table-container>\n<md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" ng-show=\"placeTypes.length\" \nmd-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" md-limit-options=\"F.paginations\" md-page=\"currentPage\" \nmd-total=\"{{pagination.total}}\" md-on-paginate=\"getThemPagination\" md-page-select></md-table-pagination></div></div>\n<md-fab-speed-dial md-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" \nclass=\"ms2-speed-dial bottom right\"><md-fab-trigger><md-button aria-label=\"crud menu\" \nclass=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon></md-button></md-fab-trigger>\n<md-fab-actions><md-button with-permission action=\"update\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" \nng-click=\"R.goToDetail(selected[0])\" aria-label=\"edit\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip \nmd-direction=\"left\">Editar</md-tooltip><md-icon md-font-icon=\"icon-pencil\" aria-label=\"edit\"></md-icon></md-button>\n<md-button with-permission action=\"remove\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length\" \nng-click=\"delete($event)\" aria-label=\"Delete\" class=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">\n{{\'EC.REMOVE\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button>\n<md-button with-permission action=\"create\" access=\"{{F.active.menuItem}}\" ng-if=\"!selected.length\" \nng-click=\'R.goToDetail(\"new\")\' aria-label=\"add\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip \nmd-direction=\"left\">{{\'EC.ADD\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon>\n</md-button></md-fab-actions></md-fab-speed-dial></div></div>");
$templateCache.put("app/main/catalogs/views/places-of-work-records/places-of-work-record.html","<div id=\"placesOfWorkRecord\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" \nng-controller=\"placesOfWorkRecordController\" layout-fill><form name=\"form\" novalidate flex layout=\"column\" \nng-disabled=\"F.readMode\"><div mongo-crud-detail-bar></div><md-content layout=\"column\" class=\"content\" flex><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\"><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex class=\"md-block\"><label>Ciudad</label><input ms2-autofocus class=\"uppercased\" \nng-model-options=\"{ debounce: F.debounceTime }\" type=\"text\" name=\"name\" ng-model=\"placesOfWorkRecord.name\" \nmd-maxlength=\"40\" maxlength=\"40\" required><div ng-messages=\"form.name.$error\" role=\"alert\"><div ng-message=\"required\">\nEste campo es requerido</div></div></md-input-container><md-input-container flex class=\"md-block\"><label>Estado</label>\n<md-select ng-model=\"placesOfWorkRecord.state_id\" required name=\"state\"><md-select-header><input autocomplete=\"off\" \ntype=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"stateSelectFilter\" \nplaceholder=\"Busque un estado\"></md-select-header><md-option ng-value=\"state._id\" \nng-repeat=\"state in M.states | orderBy:\'name\' | filter:stateSelectFilter\">{{state.name}}</md-option></md-select><div \nng-messages=\"form.state.$error\" role=\"alert\"><div ng-message=\"required\">Este campo es requerido</div></div>\n</md-input-container></div><div layout=\"row\" layout-xs=\"column\"><md-input-container flex class=\"md-block\"><label>\nGeo-Zona</label><md-select ng-model=\"placesOfWorkRecord.geoZone_id\" required name=\"geoZone\"><md-select-header><input \nautocomplete=\"off\" type=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"geoZoneSelectFilter\" \nplaceholder=\"Busque un geo-zona\"></md-select-header><md-option ng-value=\"geoZone._id\" \nng-repeat=\"geoZone in M.geoZones | orderBy:\'name\' | filter:geoZoneSelectFilter\">{{geoZone.name}}</md-option>\n</md-select><div ng-messages=\"form.geoZone.$error\" role=\"alert\"><div ng-message=\"required\">Este campo es requerido\n</div></div></md-input-container><md-input-container flex class=\"md-block\"><label>ISN (Porcentaje)</label><input \nng-model-options=\"{ debounce: F.debounceTime }\" type=\"number\" md-min=\"0\" min=\"0\" md-max=\"99\" max=\"99\" step=\".01\" \nname=\"isn\" ng-model=\"placesOfWorkRecord.isn\" required><div ng-messages=\"form.isn.$error\" role=\"alert\"><div \nng-message=\"required\">Este campo es requerido</div><div ng-message=\"min\">Este campo no puede ser menor a 1</div><div \nng-message=\"max\">Este campo no puede ser mayor a 99</div></div></md-input-container><md-input-container flex=\"nogrow\">\n<md-switch name=\"discountIsn\" aria-label=\"Discount ISN\" class=\"md-secondary noMarginTop\" \nng-model=\"placesOfWorkRecord.discountIsn\">Retención ISN</md-switch></md-input-container></div><md-input-container \nclass=\"md-block\"><label>Porcentaje de Fomento al Empleo</label><input ng-model-options=\"{ debounce: F.debounceTime }\" \ntype=\"number\" md-min=\"0\" min=\"0\" md-max=\"99\" max=\"99\" step=\".01\" name=\"employeePromotionPercent\" \nng-model=\"placesOfWorkRecord.employeePromotionPercent\"><div ng-messages=\"form.employeePromotionPercent.$error\" \nrole=\"alert\"><div ng-message=\"min\">Este campo no puede ser menor a 1</div><div ng-message=\"max\">\nEste campo no puede ser mayor a 99</div></div></md-input-container><div><fieldset class=\"pt-5 pb-5 pl-15 pr-0 m-0\">\n<md-button class=\"md-icon-button\" style=\"margin: 0\" aria-label=\"Add\" ng-click=\"addFields(indexCalculation)\" \nng-disabled=\"active\"><md-icon md-font-icon=\"icon-plus-circle\"></md-icon><md-tooltip md-direction=\"top\">\nAgregar Cuenta Contable</md-tooltip></md-button><span>Cuenta Contable</span><div layout=\"row\" layout-align=\" end\" \nng-repeat=\"(index, field) in fields track by index\"><md-input-container class=\"md-block\" flex><label>Nombre</label>\n<input ng-model-options=\"{ debounce: F.debounceTime }\" type=\"text\" name=\"name{{$index}}\" ng-model=\"field.name\" \nng-change=\"createFields(field, fields, index, form)\" required><div ng-messages=\"form[\'name\'+$index].$error\" \nrole=\"alert\"><div ng-message=\"required\">El nombre es requerido</div><div ng-message=\"validationError\">\nEste valor ya existe</div></div></md-input-container><md-input-container class=\"md-block\" flex><label>Cuenta</label>\n<input ng-model-options=\"{ debounce: F.debounceTime }\" type=\"text\" name=\"account{{$index}}\" ng-model=\"field.account\" \nng-change=\"createFields(field, fields)\" required><div ng-messages=\"form[\'account\'+$index].$error\" role=\"alert\"><div \nng-message=\"required\">La cuenta es requerido</div></div></md-input-container><md-input-container \nclass=\"md-block mb-25\" flex=\"nogrow\"><md-button class=\"md-icon-button m-0 pd-0\" aria-label=\"Delete\" \nng-click=\"deleteFields(fields, index)\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip md-direction=\"top\">\nEliminar</md-tooltip></md-button></md-input-container></div></fieldset></div></div></md-content></form></div>");
$templateCache.put("app/main/catalogs/views/places-of-work-records/places-of-work-records.html","<div id=\"placesOfWorkRecords\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div mongo-search-bar></div><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><div \ntable-loader array=\"placesOfWorkRecords\" validations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"placesOfWorkRecords.length\"><thead md-head \nmd-order=\"F.orderMongo\" fix-head md-on-reorder=\"getThem\"><tr md-row><th md-column md-order-by=\"name\"><span>Ciudad\n</span></th><th md-column md-order-by=\"state_id\"><span>Estado</span></th><th md-column md-order-by=\"geoZone_id\"><span>\nGeo-Zona</span></th><th md-column md-order-by=\"isn\"><span>ISN</span></th></tr></thead><tbody md-body><tr md-row \nmd-auto-select md-select=\"placesOfWorkRecord\" md-select-id=\"_id\" ng-repeat=\"placesOfWorkRecord in placesOfWorkRecords\">\n<td md-cell>{{placesOfWorkRecord.name}}</td><td md-cell>{{placesOfWorkRecord.state_id | nameOfM: M.states}}</td><td \nmd-cell>{{placesOfWorkRecord.geoZone_id | nameOfM: M.geoZones}}</td><td md-cell>\n{{placesOfWorkRecord.isn?placesOfWorkRecord.isn+\'%\':\'\'}}</td></tr></tbody></table></md-table-container>\n<md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" \nng-show=\"placesOfWorkRecords.length\" md-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" \nmd-limit-options=\"F.paginations\" md-page=\"currentPage\" md-total=\"{{pagination.total}}\" \nmd-on-paginate=\"getThemPagination\" md-page-select></md-table-pagination></div></div><md-fab-speed-dial \nmd-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\"><md-fab-trigger>\n<md-button aria-label=\"crud menu\" class=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon>\n</md-button></md-fab-trigger><md-fab-actions><md-button with-permission action=\"update\" access=\"{{F.active.menuItem}}\" \nng-if=\"selected.length == 1\" ng-click=\"R.goToDetail(selected[0])\" aria-label=\"edit\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Editar</md-tooltip><md-icon \nmd-font-icon=\"icon-pencil\" aria-label=\"edit\"></md-icon></md-button><md-button with-permission action=\"remove\" \naccess=\"{{F.active.menuItem}}\" ng-if=\"selected.length\" ng-click=\"delete($event)\" aria-label=\"Delete\" \nclass=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">{{\'EC.REMOVE\' | translate}}</md-tooltip>\n<md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button><md-button with-permission \naction=\"create\" access=\"{{F.active.menuItem}}\" ng-if=\"!selected.length\" ng-click=\'R.goToDetail(\"new\")\' \naria-label=\"add\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">\n{{\'EC.ADD\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon></md-button>\n</md-fab-actions></md-fab-speed-dial></div></div>");
$templateCache.put("app/main/catalogs/views/regimes/regime.html","<div id=\"regime\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill><form name=\"form\" \nnovalidate flex layout=\"column\" ng-disabled=\"F.readMode\"><div mongo-crud-detail-bar></div><md-content layout=\"column\" \nclass=\"content\" flex><div class=\"detail-form-container md-background-bg md-whiteframe-1dp\"><md-input-container \nclass=\"md-block\"><label>Régimen</label><input ms2-autofocus class=\"uppercased\" \nng-model-options=\"{ debounce: F.debounceTime }\" type=\"text\" name=\"name\" ng-model=\"regime.name\" md-maxlength=\"90\" \nmaxlength=\"90\" required></md-input-container><md-input-container class=\"md-block\"><label>Codigo</label><input \ntype=\"number\" name=\"code\" ng-model=\"regime.code\" required></md-input-container></div></md-content></form></div>");
$templateCache.put("app/main/catalogs/views/regimes/regimes.html","<div id=\"regimes\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div mongo-search-bar></div><div class=\"content-card\" layout=\"column\" flex>\n<div class=\"content fullpage-datatable\" layout=\"column\" flex><div table-loader array=\"regimes\" \nvalidations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"regimes.length\"><thead md-head md-order=\"F.orderMongo\" \nfix-head md-on-reorder=\"getThem\"><tr md-row><th md-column md-order-by=\"name\"><span>Régimen</span></th><th md-column \nmd-order-by=\"code\"><span>Régimen</span></th></tr></thead><tbody md-body><tr md-row md-auto-select md-select=\"regime\" \nmd-select-id=\"_id\" ng-repeat=\"regime in regimes\"><td md-cell>{{regime.name}}</td><td md-cell>{{regime.code}}</td></tr>\n</tbody></table></md-table-container><md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" \nlayout-xs=\"column\" ng-show=\"regimes.length\" md-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" \nmd-limit-options=\"F.paginations\" md-page=\"currentPage\" md-total=\"{{pagination.total}}\" \nmd-on-paginate=\"getThemPagination\" md-page-select></md-table-pagination></div></div><md-fab-speed-dial \nmd-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\"><md-fab-trigger>\n<md-button aria-label=\"crud menu\" class=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon>\n</md-button></md-fab-trigger><md-fab-actions><md-button with-permission action=\"update\" access=\"{{F.active.menuItem}}\" \nng-if=\"selected.length == 1\" ng-click=\"R.goToDetail(selected[0])\" aria-label=\"edit\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Editar</md-tooltip><md-icon \nmd-font-icon=\"icon-pencil\" aria-label=\"edit\"></md-icon></md-button><md-button with-permission action=\"remove\" \naccess=\"{{F.active.menuItem}}\" ng-if=\"selected.length\" ng-click=\"delete($event)\" aria-label=\"Delete\" \nclass=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">{{\'EC.REMOVE\' | translate}}</md-tooltip>\n<md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button><md-button with-permission \naction=\"create\" access=\"{{F.active.menuItem}}\" ng-if=\"!selected.length\" ng-click=\'R.goToDetail(\"new\")\' \naria-label=\"add\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">\n{{\'EC.ADD\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon></md-button>\n</md-fab-actions></md-fab-speed-dial></div></div>");
$templateCache.put("app/main/catalogs/views/risk-classes-records/risk-classes-record.html","<div id=\"riskClassesRecord\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill><form \nname=\"form\" novalidate flex layout=\"column\" ng-disabled=\"F.readMode\"><div mongo-crud-detail-bar></div><md-content \nlayout=\"column\" class=\"content\" flex><div class=\"detail-form-container md-background-bg md-whiteframe-1dp\">\n<md-input-container class=\"md-block\"><label>Clase</label><input ms2-autofocus class=\"uppercased\" \nng-model-options=\"{ debounce: F.debounceTime }\" type=\"text\" name=\"name\" ng-model=\"riskClassesRecord.name\" \nmd-maxlength=\"20\" maxlength=\"20\" required><div ng-messages=\"form.name.$error\"><div ng-message=\"required\">\nLa clase es requerido</div></div></md-input-container><md-input-container class=\"md-block\"><label>Código del SAT\n</label><input class=\"uppercased\" ng-model-options=\"{ debounce: F.debounceTime }\" type=\"text\" name=\"satCode\" \nng-model=\"riskClassesRecord.satCode\" required><div ng-messages=\"form.satCode.$error\" \nng-show=\"form.satCode.$touched || form.satCode.$dirty\"><div ng-message=\"required\">El código del sat es requerido</div>\n</div></md-input-container></div></md-content></form></div>");
$templateCache.put("app/main/catalogs/views/risk-classes-records/risk-classes-records.html","<div id=\"riskClassesRecords\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div mongo-search-bar></div><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><div \ntable-loader array=\"riskClassesRecords\" validations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"riskClassesRecords.length\"><thead md-head \nmd-order=\"F.orderMongo\" fix-head md-on-reorder=\"getThem\"><tr md-row><th md-column md-order-by=\"name\"><span>Clase</span>\n</th><th md-column md-order-by=\"satCode\"><span>Código del SAT</span></th></tr></thead><tbody md-body><tr md-row \nmd-auto-select md-select=\"riskClassesRecord\" md-select-id=\"_id\" ng-repeat=\"riskClassesRecord in riskClassesRecords\"><td\n md-cell>{{riskClassesRecord.name}}</td><td md-cell>{{riskClassesRecord.satCode}}</td></tr></tbody></table>\n</md-table-container><md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" \nng-show=\"riskClassesRecords.length\" md-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" \nmd-limit-options=\"F.paginations\" md-page=\"currentPage\" md-total=\"{{pagination.total}}\" \nmd-on-paginate=\"getThemPagination\" md-page-select></md-table-pagination></div></div><md-fab-speed-dial \nmd-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\"><md-fab-trigger>\n<md-button aria-label=\"crud menu\" class=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon>\n</md-button></md-fab-trigger><md-fab-actions><md-button with-permission action=\"update\" access=\"{{F.active.menuItem}}\" \nng-if=\"selected.length == 1\" ng-click=\"R.goToDetail(selected[0])\" aria-label=\"edit\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Editar</md-tooltip><md-icon \nmd-font-icon=\"icon-pencil\" aria-label=\"edit\"></md-icon></md-button><md-button with-permission action=\"remove\" \naccess=\"{{F.active.menuItem}}\" ng-if=\"selected.length\" ng-click=\"delete($event)\" aria-label=\"Delete\" \nclass=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">{{\'EC.REMOVE\' | translate}}</md-tooltip>\n<md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button><md-button with-permission \naction=\"create\" access=\"{{F.active.menuItem}}\" ng-if=\"!selected.length\" ng-click=\'R.goToDetail(\"new\")\' \naria-label=\"add\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">\n{{\'EC.ADD\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon></md-button>\n</md-fab-actions></md-fab-speed-dial></div></div>");
$templateCache.put("app/main/catalogs/views/relationships/relationship.html","<div id=\"relationship\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill><form name=\"form\" \nnovalidate flex layout=\"column\" ng-disabled=\"F.readMode\"><div mongo-crud-detail-bar></div><md-content layout=\"column\" \nclass=\"content\" flex><div class=\"detail-form-container md-background-bg md-whiteframe-1dp\"><md-input-container \nclass=\"md-block\"><label>Nombre</label><input ms2-autofocus class=\"uppercased\" \nng-model-options=\"{ debounce: F.debounceTime }\" type=\"text\" name=\"name\" ng-model=\"relationship.name\" md-maxlength=\"20\" \nmaxlength=\"20\" required></md-input-container><md-switch ng-model=\"relationship.active\" aria-label=\"active\" \nclass=\"md-info\">Activado</md-switch></div></md-content></form></div>");
$templateCache.put("app/main/catalogs/views/relationships/relationships.html","<div id=\"relationships\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div mongo-search-bar></div><div class=\"content-card\" layout=\"column\" \nflex><div class=\"content fullpage-datatable\" layout=\"column\" flex><div table-loader array=\"relationships\" \nvalidations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"relationships.length\"><thead md-head \nmd-order=\"F.orderMongo\" fix-head md-on-reorder=\"getThem\"><tr md-row><th md-column md-order-by=\"name\"><span>Nombre\n</span></th></tr></thead><tbody md-body><tr md-row md-auto-select md-select=\"relationship\" md-select-id=\"_id\" \nng-repeat=\"relationship in relationships\"><td md-cell>{{relationship.name}}</td></tr></tbody></table>\n</md-table-container><md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" \nng-show=\"relationships.length\" md-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" md-limit-options=\"F.paginations\" \nmd-page=\"currentPage\" md-total=\"{{pagination.total}}\" md-on-paginate=\"getThemPagination\" md-page-select>\n</md-table-pagination></div></div><md-fab-speed-dial md-open=\"F.isOpen\" \nmd-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\"><md-fab-trigger><md-button \naria-label=\"crud menu\" class=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon></md-button>\n</md-fab-trigger><md-fab-actions><md-button with-permission action=\"update\" access=\"{{F.active.menuItem}}\" \nng-if=\"selected.length == 1\" ng-click=\"R.goToDetail(selected[0])\" aria-label=\"edit\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Editar</md-tooltip><md-icon \nmd-font-icon=\"icon-pencil\" aria-label=\"edit\"></md-icon></md-button><md-button with-permission action=\"remove\" \naccess=\"{{F.active.menuItem}}\" ng-if=\"selected.length\" ng-click=\"delete($event)\" aria-label=\"Delete\" \nclass=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">{{\'EC.REMOVE\' | translate}}</md-tooltip>\n<md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button><md-button with-permission \naction=\"create\" access=\"{{F.active.menuItem}}\" ng-if=\"!selected.length\" ng-click=\'R.goToDetail(\"new\")\' \naria-label=\"add\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">\n{{\'EC.ADD\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon></md-button>\n</md-fab-actions></md-fab-speed-dial></div></div>");
$templateCache.put("app/main/catalogs/views/salary-types/salary-type.html","<div id=\"salaryType\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill><form name=\"form\" \nnovalidate flex layout=\"column\" ng-disabled=\"F.readMode\"><div mongo-crud-detail-bar></div><md-content layout=\"column\" \nclass=\"content\" flex><div class=\"detail-form-container md-background-bg md-whiteframe-1dp\"><md-input-container \nclass=\"md-block\"><label>Tipo de Salario</label><input ms2-autofocus class=\"uppercased\" \nng-model-options=\"{ debounce: F.debounceTime }\" type=\"text\" name=\"name\" ng-model=\"salaryType.name\" md-maxlength=\"20\" \nmaxlength=\"20\" required></md-input-container></div></md-content></form></div>");
$templateCache.put("app/main/catalogs/views/salary-types/salary-types.html","<div id=\"salaryTypes\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div mongo-search-bar></div><div class=\"content-card\" layout=\"column\" \nflex><div class=\"content fullpage-datatable\" layout=\"column\" flex><div table-loader array=\"salaryTypes\" \nvalidations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"salaryTypes.length\"><thead md-head md-order=\"order\" \nfix-head md-on-reorder=\"getThem\"><tr md-row><th md-column md-order-by=\"name\"><span>Tipo de Salario</span></th></tr>\n</thead><tbody md-body><tr md-row md-auto-select md-select=\"salaryType\" md-select-id=\"_id\" \nng-repeat=\"salaryType in salaryTypes\"><td md-cell>{{salaryType.name}}</td></tr></tbody></table></md-table-container>\n<md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" ng-show=\"salaryTypes.length\" \nmd-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" md-limit-options=\"F.paginations\" md-page=\"currentPage\" \nmd-total=\"{{pagination.total}}\" md-on-paginate=\"getThemPagination\" md-page-select></md-table-pagination></div></div>\n<md-fab-speed-dial md-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" \nclass=\"ms2-speed-dial bottom right\"><md-fab-trigger><md-button aria-label=\"crud menu\" \nclass=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon></md-button></md-fab-trigger>\n<md-fab-actions><md-button with-permission action=\"update\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" \nng-click=\"R.goToDetail(selected[0])\" aria-label=\"edit\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip \nmd-direction=\"left\">Editar</md-tooltip><md-icon md-font-icon=\"icon-pencil\" aria-label=\"edit\"></md-icon></md-button>\n<md-button with-permission action=\"remove\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length\" \nng-click=\"delete($event)\" aria-label=\"Delete\" class=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">\n{{\'EC.REMOVE\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button>\n<md-button with-permission action=\"create\" access=\"{{F.active.menuItem}}\" ng-if=\"!selected.length\" \nng-click=\'R.goToDetail(\"new\")\' aria-label=\"add\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip \nmd-direction=\"left\">{{\'EC.ADD\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon>\n</md-button></md-fab-actions></md-fab-speed-dial></div></div>");
$templateCache.put("app/main/catalogs/views/societyTypes/societyType.html","<div id=\"societyType\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill><form name=\"form\" \nnovalidate flex layout=\"column\" ng-disabled=\"F.readMode\"><div mongo-crud-detail-bar></div><md-content layout=\"column\" \nclass=\"content\" flex><div class=\"detail-form-container md-background-bg md-whiteframe-1dp\"><md-input-container \nclass=\"md-block\"><label>Nombre</label><input ms2-autofocus class=\"uppercased\" \nng-model-options=\"{ debounce: F.debounceTime }\" type=\"text\" name=\"name\" ng-model=\"societyType.name\" md-maxlength=\"20\" \nmaxlength=\"20\" required></md-input-container></div></md-content></form></div>");
$templateCache.put("app/main/catalogs/views/societyTypes/societyTypes.html","<div id=\"societyTypes\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div mongo-search-bar></div><div class=\"content-card\" layout=\"column\" \nflex><div class=\"content fullpage-datatable\" layout=\"column\" flex><div table-loader array=\"societyTypes\" \nvalidations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"societyTypes.length\"><thead md-head \nmd-order=\"F.orderMongo\" fix-head md-on-reorder=\"getThem\"><tr md-row><th md-column md-order-by=\"name\"><span>Nombre\n</span></th></tr></thead><tbody md-body><tr md-row md-auto-select md-select=\"societyType\" md-select-id=\"_id\" \nng-repeat=\"societyType in societyTypes\"><td md-cell>{{societyType.name}}</td></tr></tbody></table></md-table-container>\n<md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" ng-show=\"societyTypes.length\" \nmd-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" md-limit-options=\"F.paginations\" md-page=\"currentPage\" \nmd-total=\"{{pagination.total}}\" md-on-paginate=\"getThemPagination\" md-page-select></md-table-pagination></div></div>\n<md-fab-speed-dial md-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" \nclass=\"ms2-speed-dial bottom right\"><md-fab-trigger><md-button aria-label=\"crud menu\" \nclass=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon></md-button></md-fab-trigger>\n<md-fab-actions><md-button with-permission action=\"update\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" \nng-click=\"R.goToDetail(selected[0])\" aria-label=\"edit\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip \nmd-direction=\"left\">Editar</md-tooltip><md-icon md-font-icon=\"icon-pencil\" aria-label=\"edit\"></md-icon></md-button>\n<md-button with-permission action=\"remove\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length\" \nng-click=\"delete($event)\" aria-label=\"Delete\" class=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">\n{{\'EC.REMOVE\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button>\n<md-button with-permission action=\"create\" access=\"{{F.active.menuItem}}\" ng-if=\"!selected.length\" \nng-click=\'R.goToDetail(\"new\")\' aria-label=\"add\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip \nmd-direction=\"left\">{{\'EC.ADD\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon>\n</md-button></md-fab-actions></md-fab-speed-dial></div></div>");
$templateCache.put("app/main/catalogs/views/street-types/street-type.html","<div id=\"streetType\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill><form name=\"form\" \nnovalidate flex layout=\"column\" ng-disabled=\"F.readMode\"><div mongo-crud-detail-bar></div><md-content layout=\"column\" \nclass=\"content\" flex><div class=\"detail-form-container md-background-bg md-whiteframe-1dp\"><div layout=\"row\" \nlayout-wrap><md-input-container class=\"md-block\" flex=\"100\"><label>Tipo de Calle</label><input ms2-autofocus \nclass=\"uppercased\" ng-model-options=\"{ debounce: F.debounceTime }\" type=\"text\" name=\"name\" ng-model=\"streetType.name\" \nmd-maxlength=\"30\" maxlength=\"30\" required></md-input-container><md-input-container class=\"md-block\" flex=\"50\" \nflex-xs=\"100\"><label>Clave</label><input class=\"uppercased\" ng-model-options=\"{ debounce: F.debounceTime }\" \ntype=\"text\" name=\"key\" ng-model=\"streetType.key\" md-maxlength=\"3\" maxlength=\"3\" required></md-input-container>\n<md-input-container class=\"md-block\" flex=\"50\" flex-xs=\"100\"><label>HumanCode</label><input type=\"number\" min=\"0\" \nname=\"humansiteCode\" ng-model=\"streetType.humansiteCode\"></md-input-container></div></div></md-content></form></div>");
$templateCache.put("app/main/catalogs/views/street-types/street-types.html","<div id=\"streetTypes\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div mongo-search-bar></div><div class=\"content-card\" layout=\"column\" \nflex><div class=\"content fullpage-datatable\" layout=\"column\" flex><div table-loader array=\"streetTypes\" \nvalidations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"streetTypes.length\"><thead md-head \nmd-order=\"F.orderMongo\" fix-head md-on-reorder=\"getThem\"><tr md-row><th md-column md-order-by=\"name\"><span>\nTipo de Calle</span></th><th md-column md-order-by=\"key\"><span>Clave</span></th><th md-column \nmd-order-by=\"humansiteCode\"><span>HumanCode</span></th></tr></thead><tbody md-body><tr md-row md-auto-select \nmd-select=\"streetType\" md-select-id=\"_id\" ng-repeat=\"streetType in streetTypes\"><td md-cell>{{streetType.name}}</td><td\n md-cell>{{streetType.key}}</td><td md-cell>{{streetType.humansiteCode}}</td></tr></tbody></table></md-table-container>\n<md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" ng-show=\"streetTypes.length\" \nmd-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" md-limit-options=\"F.paginations\" md-page=\"currentPage\" \nmd-total=\"{{pagination.total}}\" md-on-paginate=\"getThemPagination\" md-page-select></md-table-pagination></div></div>\n<md-fab-speed-dial md-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" \nclass=\"ms2-speed-dial bottom right\"><md-fab-trigger><md-button aria-label=\"crud menu\" \nclass=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon></md-button></md-fab-trigger>\n<md-fab-actions><md-button with-permission action=\"update\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" \nng-click=\"R.goToDetail(selected[0])\" aria-label=\"edit\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip \nmd-direction=\"left\">Editar</md-tooltip><md-icon md-font-icon=\"icon-pencil\" aria-label=\"edit\"></md-icon></md-button>\n<md-button with-permission action=\"remove\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length\" \nng-click=\"delete($event)\" aria-label=\"Delete\" class=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">\n{{\'EC.REMOVE\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button>\n<md-button with-permission action=\"create\" access=\"{{F.active.menuItem}}\" ng-if=\"!selected.length\" \nng-click=\'R.goToDetail(\"new\")\' aria-label=\"add\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip \nmd-direction=\"left\">{{\'EC.ADD\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon>\n</md-button></md-fab-actions></md-fab-speed-dial></div></div>");
$templateCache.put("app/main/catalogs/views/states/state.html","<div id=\"state\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" ng-controller=\"StateController\" \nlayout-fill><form name=\"form\" novalidate flex layout=\"column\" ng-disabled=\"F.readMode\"><div mongo-crud-detail-bar>\n</div><md-content class=\"content\" flex><div class=\"crud-card highlight\"><h3 class=\"section-title\">\nInformación del Estado</h3><div layout=\"column\" layout-gt-sm=\"row\" layout-gap=\"16px\"><div flex=\"100\" flex-gt-sm=\"60\" \nlayout=\"row\" layout-wrap><md-input-container class=\"md-block\" flex=\"100\" flex-gt-xs=\"70\"><label>Estado</label><input \nms2-autofocus class=\"uppercased\" ng-model-options=\"{ debounce: F.debounceTime }\" type=\"text\" name=\"name\" \nng-model=\"state.name\" md-maxlength=\"30\" maxlength=\"30\" required><div ng-messages=\"form.name.$error\" \nng-show=\"form.name.$touched || form.name.$dirty\"><div ng-message=\"required\">El estado es requerido</div></div>\n</md-input-container><md-input-container class=\"md-block\" flex=\"100\" flex-gt-xs=\"30\"><label>Clave</label><input \nclass=\"uppercased\" ng-model-options=\"{ debounce: F.debounceTime }\" type=\"text\" name=\"key\" ng-model=\"state.key\" \nmd-maxlength=\"2\" maxlength=\"2\" required><div ng-messages=\"form.key.$error\" \nng-show=\"form.key.$touched || form.key.$dirty\"><div ng-message=\"required\">Requerido</div></div></md-input-container>\n<md-input-container class=\"md-block\" flex=\"100\" flex-gt-xs=\"50\"><label>Código del SAT</label><input class=\"uppercased\" \nng-model-options=\"{ debounce: F.debounceTime }\" type=\"text\" name=\"satCode\" ng-model=\"state.satCode\" required><div \nng-messages=\"form.satCode.$error\" ng-show=\"form.satCode.$touched || form.satCode.$dirty\"><div ng-message=\"required\">\nRequerido</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"100\" flex-gt-xs=\"50\"><label>\nHumanCode</label><input type=\"text\" name=\"humansiteCode\" ng-model=\"state.humansiteCode\"></md-input-container></div><div\n flex=\"100\" flex-gt-sm=\"40\" class=\"chips-container\"><md-chips ng-model=\"state.exemptIsnConcepts\" \nmd-transform-chip=\"transformChip($chip)\" md-require-match=\"true\" placeholder=\"Agregar concepto...\"><md-autocomplete \nmd-selected-item=\"selectedItem\" md-search-text=\"searchText\" md-no-cache=\"true\" \nmd-items=\"item in querySearch(searchText)\" md-item-text=\"item.name\" placeholder=\"Buscar Conceptos exentos de ISN\">\n<md-item-template><span class=\"optionToSelect\">{{item.name}}<label ng-if=\"item.payroll!==\'global\'\">\n[{{item.payrollName}}]</label></span></md-item-template><md-not-found>No se encontraron resultados.</md-not-found>\n</md-autocomplete><md-chip-template class=\"md-caption\"><span><strong>\n{{$chip | getSomethingOfArrayFB : perceptions : \'name\' : \'N/E\' : \'$id\'}}</strong> <em \nng-if=\"($chip | getSomethingOfArrayFB : perceptions : \'payroll\' : \'global\' : \'$id\') !== \'global\'\">\n{{$chip | getSomethingOfArrayFB : perceptions : \'payrollName\' : \'N/E\' : \'$id\'}}</em></span></md-chip-template>\n</md-chips></div></div></div><div class=\"crud-card\"><md-checkbox ng-model=\"state.expoChihuahua\" \naria-label=\"Checkbox 1\"><h4>Contribucion extraordinaria para el fideicomiso Expo-chihuahua</h4></md-checkbox></div><div\n class=\"crud-card\"><div flex layout=\"row\" layout-align=\"start center\"><div class=\"section-title\" flex=\"90\" \nflex-lg=\"70\" flex-md=\"70\" flex-sm=\"70\" flex-xs=\"70\">Configuración de Descuentos</div><div flex=\"10\" flex-lg=\"20\" \nflex-md=\"20\" flex-sm=\"40\" flex-xs=\"40\"><span class=\"status-label\" ng-if=\"state.discountIsnOption === \'persons\'\" \nng-class=\"{\'on\': state.discountIsnOption === \'persons\'}\">Descuento por personas</span> <span class=\"status-label\" \nng-if=\"state.discountIsnOption === \'limited\'\" ng-class=\"{\'off\': state.discountIsnOption === \'limited\'}\">\nDescuento por limites</span></div><div flex=\"nogrow\"><md-switch ng-model=\"state.discountIsnOption\" \naria-label=\"Toggle Discount Option\" ng-true-value=\"\'limited\'\" ng-false-value=\"\'persons\'\" class=\"md-primary\">\n</md-switch></div></div><div ng-if=\"state.discountIsnOption === \'limited\'\" class=\"animate-fade-in\"><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"mb-10\"><span class=\"md-subhead\">Tabla de descuento por límites</span>\n<md-button class=\"md-icon-button md-primary btn-add-mini\" ng-click=\"addFields(indexCalculation)\" ng-disabled=\"active\">\n<md-icon md-font-icon=\"icon-plus-circle\"></md-icon><md-tooltip>Agregar fila</md-tooltip></md-button></div><div \nlayout=\"row\" class=\"dynamic-row\" ng-repeat=\"(index, field) in fields track by index\"><md-input-container flex \nclass=\"md-block no-margin\"><label>Límite</label><input type=\"text\" name=\"limit{{$index}}\" ng-model=\"field.limit\" \nng-model-options=\"{ debounce: F.debounceTime }\" ng-change=\"createFields(field, fields, index, form)\" required><div \nng-messages=\"form[\'limit\'+$index].$error\"><div ng-message=\"required\">Requerido</div><div ng-message=\"validationError\">\nDuplicado</div></div></md-input-container><md-input-container flex class=\"md-block no-margin\"><label>Porcentaje</label>\n<input type=\"text\" name=\"percentage{{$index}}\" ng-model=\"field.percentage\" \nng-model-options=\"{ debounce: F.debounceTime }\" ng-change=\"createFields(field, fields)\" required><div \nng-messages=\"form[\'percentage\'+$index].$error\"><div ng-message=\"required\">Requerido</div></div></md-input-container>\n<div class=\"action-col\" style=\"width: 50px\"><md-button class=\"md-icon-button md-warn\" \nng-click=\"deleteFields(fields, index);form.$setDirty();\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button>\n</div></div></div><div ng-if=\"state.discountIsnOption === \'persons\'\" class=\"animate-fade-in\"><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"mb-10\"><span class=\"md-subhead\">Tabla de descuento por personas</span>\n<md-button class=\"md-icon-button md-primary btn-add-mini\" ng-click=\"addFieldsPerson(indexCalculation)\" \nng-disabled=\"active\"><md-icon md-font-icon=\"icon-plus-circle\"></md-icon><md-tooltip>Agregar fila</md-tooltip>\n</md-button></div><div layout=\"row\" class=\"dynamic-row\" ng-repeat=\"(index, field) in fieldsPerson track by index\">\n<md-input-container flex class=\"md-block no-margin\"><label>Personas</label><input type=\"text\" name=\"persons{{$index}}\" \nng-model=\"field.persons\" ng-model-options=\"{ debounce: F.debounceTime }\" \nng-change=\"createFieldsPerson(field, fieldsPerson, index, form)\" required><div \nng-messages=\"form[\'persons\'+$index].$error\"><div ng-message=\"required\">Requerido</div><div \nng-message=\"validationError\">Duplicado</div></div></md-input-container><md-input-container flex \nclass=\"md-block no-margin\"><label>Porcentaje</label><input type=\"text\" name=\"disccount{{$index}}\" \nng-model=\"field.disccount\" ng-model-options=\"{ debounce: F.debounceTime }\" \nng-change=\"createFieldsPerson(field, fieldsPerson);form.$setDirty();\" required><div \nng-messages=\"form[\'disccount\'+$index].$error\"><div ng-message=\"required\">Requerido</div></div></md-input-container><div\n class=\"action-col\" style=\"width: 50px\"><md-button class=\"md-icon-button md-warn\" \nng-click=\"deleteFieldsPerson(fieldsPerson, index)\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div>\n</div></div></div><div class=\"crud-card\"><div class=\"section-title\">Cargos por ISN<md-button \nclass=\"md-icon-button md-primary btn-add-mini\" ng-click=\"addFieldsConcept(indexCalculation)\" ng-disabled=\"active\">\n<md-icon md-font-icon=\"icon-plus-circle\"></md-icon><md-tooltip>Agregar Concepto</md-tooltip></md-button></div><div \nlayout=\"row\" class=\"dynamic-row\" ng-repeat=\"(index, field) in fieldsConcept track by index\"><md-input-container flex \nclass=\"md-block no-margin\"><label>Nombre del concepto</label><input type=\"text\" name=\"concept{{$index}}\" \nng-model=\"field.concept\" ng-model-options=\"{ debounce: F.debounceTime }\" \nng-change=\"createFieldsConcept(field, fieldsConcept, index, form)\" required><div \nng-messages=\"form[\'concept\'+$index].$error\"><div ng-message=\"required\">Requerido</div><div \nng-message=\"validationError\">Duplicado</div></div></md-input-container><md-input-container flex \nclass=\"md-block no-margin\"><label>Porcentaje</label><input type=\"text\" name=\"value{{$index}}\" ng-model=\"field.value\" \nng-model-options=\"{ debounce: F.debounceTime }\" ng-change=\"createFieldsConcept(field, fieldsConcept)\" required><div \nng-messages=\"form[\'value\'+$index].$error\"><div ng-message=\"required\">Requerido</div></div></md-input-container><div \nclass=\"action-col\" style=\"width: 50px\"><md-button class=\"md-icon-button md-warn\" \nng-click=\"deleteFieldsConcept(fieldsConcept, index);form.$setDirty();\"><md-icon md-font-icon=\"icon-delete\"></md-icon>\n</md-button></div></div><div ng-if=\"fieldsConcept.length === 0\" layout=\"row\" layout-align=\"center center\" \nstyle=\"padding: 20px; color: #999\"><span>No hay cargos adicionales configurados.</span></div></div></md-content></form>\n</div>");
$templateCache.put("app/main/catalogs/views/states/states.html","<div id=\"states\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div mongo-search-bar></div><div class=\"content-card\" layout=\"column\" flex>\n<div class=\"content fullpage-datatable\" layout=\"column\" flex><div table-loader array=\"states\" \nvalidations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"states.length\"><thead md-head md-order=\"F.orderMongo\" \nfix-head md-on-reorder=\"getThem\"><tr md-row><th md-column md-order-by=\"_id\"><span>ID_System</span></th><th md-column \nmd-order-by=\"name\"><span>Estado</span></th><th md-column md-order-by=\"key\"><span>Clave</span></th><th md-column \nmd-order-by=\"satCode\"><span>Código de SAT</span></th></tr></thead><tbody md-body><tr md-row md-auto-select \nmd-select=\"state\" md-select-id=\"_id\" ng-repeat=\"state in states\"><td md-cell>{{state._id}}</td><td md-cell>\n{{state.name}}</td><td md-cell>{{state.key}}</td><td md-cell>{{state.satCode}}</td></tr></tbody></table>\n</md-table-container><md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" \nng-show=\"states.length\" md-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" md-limit-options=\"F.paginations\" \nmd-page=\"currentPage\" md-total=\"{{pagination.total}}\" md-on-paginate=\"getThemPagination\" md-page-select>\n</md-table-pagination></div></div><md-fab-speed-dial md-open=\"F.isOpen\" \nmd-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\"><md-fab-trigger><md-button \naria-label=\"crud menu\" class=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon></md-button>\n</md-fab-trigger><md-fab-actions><md-button with-permission action=\"update\" access=\"{{F.active.menuItem}}\" \nng-if=\"selected.length == 1\" ng-click=\"R.goToDetail(selected[0])\" aria-label=\"edit\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Editar</md-tooltip><md-icon \nmd-font-icon=\"icon-pencil\" aria-label=\"edit\"></md-icon></md-button><md-button with-permission action=\"remove\" \naccess=\"{{F.active.menuItem}}\" ng-if=\"selected.length\" ng-click=\"delete($event)\" aria-label=\"Delete\" \nclass=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">{{\'EC.REMOVE\' | translate}}</md-tooltip>\n<md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button><md-button with-permission \naction=\"create\" access=\"{{F.active.menuItem}}\" ng-if=\"!selected.length\" ng-click=\'R.goToDetail(\"new\")\' \naria-label=\"add\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">\n{{\'EC.ADD\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon></md-button>\n</md-fab-actions></md-fab-speed-dial></div></div>");
$templateCache.put("app/main/catalogs/views/subsidy-records/subsidy-record.html","<div id=\"subsidyRecord\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill><form name=\"form\" \nnovalidate flex layout=\"column\" ng-disabled=\"F.readMode\"><div mongo-crud-detail-bar></div><md-content layout=\"column\" \nclass=\"content\" flex><div class=\"detail-form-container md-background-bg md-whiteframe-1dp\"><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex><label>Año</label><input ms2-autofocus type=\"number\" \nname=\"year\" ng-model=\"subsidyRecord.year\" required></md-input-container><md-input-container class=\"md-block\" flex>\n<label>Periodo</label><md-select ms2-autofocus ng-model=\"subsidyRecord.type\" placeholder=\"Seleccione Periodicidad\" \nrequired><md-option ng-value=\"period.id\" ng-repeat=\"period in F.periodicity\">{{period.name}}</md-option></md-select>\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex><label>\nLímite Inferior</label><input type=\"number\" name=\"upperLimit\" ng-model=\"subsidyRecord.lowerLimit\" required>\n</md-input-container><md-input-container class=\"md-block\" flex><label>Subsidio</label><input type=\"number\" \nname=\"subsidy\" ng-model=\"subsidyRecord.subsidy\" required></md-input-container></div></div></md-content></form></div>");
$templateCache.put("app/main/catalogs/views/subsidy-records/subsidy-records.html","<div id=\"subsidyRecords\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div mongo-search-bar></div><div class=\"content-card\" layout=\"column\" \nflex><div class=\"content fullpage-datatable\" layout=\"column\" flex><div list-filters filters-loaded=\"F.filtersLoaded\" \nng-model=\"F.filters[F.active.menuName]\" on-change=\"getThem\" columns-repeat=\"columnsRepeat\" \nmenu-obj-name=\"{{F.active.menuObjName}}\" model-name=\"{{F.active.menuName}}\" init-filters=\"initFilters\"></div><div \ntable-loader array=\"subsidyRecords\" validations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"subsidyRecords.length\"><thead md-head md-order=\"order\" \nfix-head md-on-reorder=\"getThem\"><tr md-row><th md-column md-order-by=\"year\"><span>Año</span></th><th md-column \nmd-order-by=\"lowerLimit\" hide show-gt-sm><span>Límite Inferior</span></th><th md-column md-order-by=\"subsidy\"><span>\nSubsidio</span></th><th md-column md-order-by=\"type\"><span>Periodicidad</span></th></tr></thead><tbody md-body><tr \nmd-row md-auto-select md-select=\"subsidyRecord\" md-select-id=\"_id\" ng-repeat=\"subsidyRecord in subsidyRecords\"><td \nmd-cell>{{subsidyRecord.year}}</td><td md-cell hide show-gt-sm>{{subsidyRecord.lowerLimit}}</td><td md-cell>\n{{subsidyRecord.subsidy}}</td><td md-cell>\n{{subsidyRecord.type | getSomethingOfArrayFB : F.periodicity : \'name\' : \'S/P\' : \'id\'}}</td></tr></tbody></table>\n</md-table-container><md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" \nng-show=\"subsidyRecords.length\" md-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" \nmd-limit-options=\"F.paginations\" md-page=\"currentPage\" md-total=\"{{pagination.total}}\" \nmd-on-paginate=\"getThemPagination\" md-page-select></md-table-pagination></div></div><md-fab-speed-dial \nmd-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\"><md-fab-trigger>\n<md-button aria-label=\"crud menu\" class=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon>\n</md-button></md-fab-trigger><md-fab-actions><md-button with-permission action=\"update\" access=\"{{F.active.menuItem}}\" \nng-if=\"selected.length == 1\" ng-click=\"R.goToDetail(selected[0])\" aria-label=\"edit\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Editar</md-tooltip><md-icon \nmd-font-icon=\"icon-pencil\" aria-label=\"edit\"></md-icon></md-button><md-button with-permission action=\"remove\" \naccess=\"{{F.active.menuItem}}\" ng-if=\"selected.length\" ng-click=\"delete($event)\" aria-label=\"Delete\" \nclass=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">{{\'EC.REMOVE\' | translate}}</md-tooltip>\n<md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button><md-button with-permission \naction=\"create\" access=\"{{F.active.menuItem}}\" ng-if=\"!selected.length\" ng-click=\'R.goToDetail(\"new\")\' \naria-label=\"add\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">\n{{\'EC.ADD\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon></md-button>\n</md-fab-actions></md-fab-speed-dial></div></div>");
$templateCache.put("app/main/catalogs/views/uma-records/uma-record.html","<div id=\"umaRecord\" ng-controller=\"UmaController\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" \nlayout-fill><form name=\"form\" novalidate flex layout=\"column\" ng-disabled=\"F.readMode\"><div mongo-crud-detail-bar>\n</div><md-content layout=\"column\" class=\"content\" flex><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\"><md-input-container class=\"md-block\"><label>Año\n</label><input ms2-autofocus type=\"number\" name=\"year\" ng-model=\"umaRecord.year\" required></md-input-container>\n<md-input-container class=\"md-block\"><label>UMA</label><input type=\"number\" name=\"value\" ng-model=\"umaRecord.value\" \nrequired></md-input-container><md-input-container class=\"md-block date-picker\" flex><label>Fecha de Aplicacion</label>\n<md-datepicker ng-disabled=\"F.readMode\" md-hide-icons=\"triangle\" md-current-view=\"{{F.dateView}}\" \nmd-min-date=\"minEnroleDate\" md-max-date=\"maxEnroleDate\" input-date-miliseconds ng-model=\"umaRecord.applicationDate\" \nname=\"applicationDate\" class=\"md-block\" required></md-datepicker><div ng-messages=\"form.applicationDate.$error\" \nrole=\"alert\"><div ng-message=\"required\">Fecha de Alta es requerido</div><div ng-message=\"min\">\nFecha de Alta debe ser a partir de {{minEnroleDate | date}}</div><div ng-message=\"max\">\nFecha de Alta debe ser antes de {{maxEnroleDate | date}}</div><div ng-message=\"mindate\">\nFecha de Alta debe ser a partir de {{minEnroleDate | date}}</div><div ng-message=\"maxdate\">\nFecha de Alta debe ser antes de {{maxEnroleDate | date}}</div></div></md-input-container></div></md-content></form>\n</div>");
$templateCache.put("app/main/catalogs/views/uma-records/uma-records.html","<div id=\"umaRecords\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div mongo-search-bar></div><div class=\"content-card\" layout=\"column\" \nflex><div class=\"content fullpage-datatable\" layout=\"column\" flex><div list-filters filters-loaded=\"F.filtersLoaded\" \nng-model=\"F.filters[F.active.menuName]\" on-change=\"getThem\" columns-repeat=\"columnsRepeat\" \nmenu-obj-name=\"{{F.active.menuObjName}}\" model-name=\"{{F.active.menuName}}\" init-filters=\"initFilters\"></div><div \ntable-loader array=\"umaRecords\" validations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"umaRecords.length\"><thead md-head md-order=\"order\" \nfix-head md-on-reorder=\"getThem\"><tr md-row><th md-column md-order-by=\"year\"><span>Año</span></th><th md-column \nmd-order-by=\"value\"><span>UMA</span></th><th md-column md-order-by=\"applicationDate\"><span>Fecha de Aplicación</span>\n</th></tr></thead><tbody md-body><tr md-row md-auto-select md-select=\"umaRecord\" md-select-id=\"_id\" \nng-repeat=\"umaRecord in umaRecords\"><td md-cell>{{umaRecord.year}}</td><td md-cell>{{umaRecord.value}}</td><td md-cell>\n{{umaRecord.applicationDate | date:F.dateFormat}}</td></tr></tbody></table></md-table-container><md-table-pagination \nlayout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" ng-show=\"umaRecords.length\" \nmd-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" md-limit-options=\"F.paginations\" md-page=\"currentPage\" \nmd-total=\"{{pagination.total}}\" md-on-paginate=\"getThemPagination\" md-page-select></md-table-pagination></div></div>\n<md-fab-speed-dial md-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" \nclass=\"ms2-speed-dial bottom right\"><md-fab-trigger><md-button aria-label=\"crud menu\" \nclass=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon></md-button></md-fab-trigger>\n<md-fab-actions><md-button with-permission action=\"update\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" \nng-click=\"R.goToDetail(selected[0])\" aria-label=\"edit\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip \nmd-direction=\"left\">Editar</md-tooltip><md-icon md-font-icon=\"icon-pencil\" aria-label=\"edit\"></md-icon></md-button>\n<md-button with-permission action=\"remove\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length\" \nng-click=\"delete($event)\" aria-label=\"Delete\" class=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">\n{{\'EC.REMOVE\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button>\n<md-button with-permission action=\"create\" access=\"{{F.active.menuItem}}\" ng-if=\"!selected.length\" \nng-click=\'R.goToDetail(\"new\")\' aria-label=\"add\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip \nmd-direction=\"left\">{{\'EC.ADD\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon>\n</md-button></md-fab-actions></md-fab-speed-dial></div></div>");
$templateCache.put("app/main/catalogs/views/work-days/work-day.html","<div id=\"workDay\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill><form name=\"form\" \nnovalidate flex layout=\"column\" ng-disabled=\"F.readMode\"><div mongo-crud-detail-bar></div><md-content layout=\"column\" \nclass=\"content\" flex><div class=\"detail-form-container md-background-bg md-whiteframe-1dp\"><md-input-container \nclass=\"md-block\"><label>Jornada</label><input ms2-autofocus class=\"uppercased\" \nng-model-options=\"{ debounce: F.debounceTime }\" type=\"text\" name=\"name\" ng-model=\"workDay.name\" md-maxlength=\"20\" \nmaxlength=\"20\" required></md-input-container></div></md-content></form></div>");
$templateCache.put("app/main/catalogs/views/work-days/work-days.html","<div id=\"workDays\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div mongo-search-bar></div><div class=\"content-card\" layout=\"column\" flex>\n<div class=\"content fullpage-datatable\" layout=\"column\" flex><div table-loader array=\"workDays\" \nvalidations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"workDays.length\"><thead md-head \nmd-order=\"F.orderMongo\" fix-head md-on-reorder=\"getThem\"><tr md-row><th md-column md-order-by=\"name\"><span>Jornada\n</span></th></tr></thead><tbody md-body><tr md-row md-auto-select md-select=\"workDay\" md-select-id=\"_id\" \nng-repeat=\"workDay in workDays\"><td md-cell>{{workDay.name}}</td></tr></tbody></table></md-table-container>\n<md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" ng-show=\"workDays.length\" \nmd-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" md-limit-options=\"F.paginations\" md-page=\"currentPage\" \nmd-total=\"{{pagination.total}}\" md-on-paginate=\"getThemPagination\" md-page-select></md-table-pagination></div></div>\n<md-fab-speed-dial md-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" \nclass=\"ms2-speed-dial bottom right\"><md-fab-trigger><md-button aria-label=\"crud menu\" \nclass=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon></md-button></md-fab-trigger>\n<md-fab-actions><md-button with-permission action=\"update\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" \nng-click=\"R.goToDetail(selected[0])\" aria-label=\"edit\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip \nmd-direction=\"left\">Editar</md-tooltip><md-icon md-font-icon=\"icon-pencil\" aria-label=\"edit\"></md-icon></md-button>\n<md-button with-permission action=\"remove\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length\" \nng-click=\"delete($event)\" aria-label=\"Delete\" class=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">\n{{\'EC.REMOVE\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button>\n<md-button with-permission action=\"create\" access=\"{{F.active.menuItem}}\" ng-if=\"!selected.length\" \nng-click=\'R.goToDetail(\"new\")\' aria-label=\"add\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip \nmd-direction=\"left\">{{\'EC.ADD\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon>\n</md-button></md-fab-actions></md-fab-speed-dial></div></div>");
$templateCache.put("app/main/catalogs/views/towns/town.html","<div id=\"town\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill><form name=\"form\" novalidate \nflex layout=\"column\" ng-disabled=\"F.readMode\"><div mongo-crud-detail-bar></div><md-content layout=\"column\" \nclass=\"content\" flex><div class=\"detail-form-container md-background-bg md-whiteframe-1dp\"><div layout=\"row\" \nlayout-wrap><md-input-container class=\"md-block\" flex=\"100\"><label>Municipio</label><input ms2-autofocus \nclass=\"uppercased\" ng-model-options=\"{ debounce: F.debounceTime }\" type=\"text\" name=\"name\" ng-model=\"town.name\" \nmd-maxlength=\"20\" maxlength=\"20\" required></md-input-container><md-input-container class=\"md-block\" flex=\"33\" \nflex-xs=\"100\"><label>ID Municipio</label><input class=\"uppercased\" ng-model-options=\"{ debounce: F.debounceTime }\" \ntype=\"text\" name=\"town_id\" ng-model=\"town.town_id\" md-maxlength=\"4\" maxlength=\"4\" required></md-input-container>\n<md-input-container class=\"md-block\" flex=\"33\" flex-xs=\"100\"><label>Estado</label><md-select ng-model=\"town.state_id\">\n<md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" \nng-model=\"stateSelectFilter\" placeholder=\"Busque un estado\"></md-select-header><md-option ng-value=\"state._id\" \nng-repeat=\"state in M.states | orderBy:\'name\' | filter:stateSelectFilter\">{{state.name}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" flex=\"33\" flex-xs=\"100\"><label>HumanCode</label><input \ntype=\"number\" min=\"0\" name=\"humansiteCode\" ng-model=\"town.humansiteCode\"></md-input-container></div></div></md-content>\n</form></div>");
$templateCache.put("app/main/catalogs/views/towns/towns.html","<div id=\"towns\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div mongo-search-bar></div><div class=\"content-card\" layout=\"column\" flex>\n<div class=\"content fullpage-datatable\" layout=\"column\" flex><div table-loader array=\"towns\" validations=\"validations\">\n</div><md-table-container class=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table \nmd-table md-row-select multiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"towns.length\"><thead md-head \nmd-order=\"F.orderMongo\" fix-head md-on-reorder=\"getThem\"><tr md-row><th md-column md-order-by=\"_id\"><span>ID_System\n</span></th><th md-column md-order-by=\"name\"><span>Municipio</span></th><th md-column md-order-by=\"state_id\"><span>\nEstado</span></th></tr></thead><tbody md-body><tr md-row md-auto-select md-select=\"town\" md-select-id=\"_id\" \nng-repeat=\"town in towns\"><td md-cell>{{town._id}}</td><td md-cell>{{town.name}}</td><td md-cell>\n{{town.state_id|nameOfM:M.states}}</td></tr></tbody></table></md-table-container><md-table-pagination \nlayout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" ng-show=\"towns.length\" \nmd-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" md-limit-options=\"F.paginations\" md-page=\"currentPage\" \nmd-total=\"{{pagination.total}}\" md-on-paginate=\"getThemPagination\" md-page-select></md-table-pagination></div></div>\n<md-fab-speed-dial md-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" \nclass=\"ms2-speed-dial bottom right\"><md-fab-trigger><md-button aria-label=\"crud menu\" \nclass=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon></md-button></md-fab-trigger>\n<md-fab-actions><md-button with-permission action=\"update\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" \nng-click=\"R.goToDetail(selected[0])\" aria-label=\"edit\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip \nmd-direction=\"left\">Editar</md-tooltip><md-icon md-font-icon=\"icon-pencil\" aria-label=\"edit\"></md-icon></md-button>\n<md-button with-permission action=\"remove\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length\" \nng-click=\"delete($event)\" aria-label=\"Delete\" class=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">\n{{\'EC.REMOVE\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button>\n<md-button with-permission action=\"create\" access=\"{{F.active.menuItem}}\" ng-if=\"!selected.length\" \nng-click=\'R.goToDetail(\"new\")\' aria-label=\"add\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip \nmd-direction=\"left\">{{\'EC.ADD\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon>\n</md-button></md-fab-actions></md-fab-speed-dial></div></div>");
$templateCache.put("app/main/catalogs/views/unions/union.html","<div id=\"union\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill><form name=\"form\" novalidate \nflex layout=\"column\" ng-disabled=\"F.readMode\"><div mongo-crud-detail-bar></div><md-content layout=\"column\" \nclass=\"content\" flex><div class=\"detail-form-container md-background-bg md-whiteframe-1dp\"><md-input-container \nclass=\"md-block\"><label>Sindicato</label><input ms2-autofocus class=\"uppercased\" \nng-model-options=\"{ debounce: F.debounceTime }\" type=\"text\" name=\"name\" ng-model=\"union.name\" md-maxlength=\"20\" \nrequired></md-input-container></div></md-content></form></div>");
$templateCache.put("app/main/catalogs/views/unions/unions.html","<div id=\"unions\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div mongo-search-bar></div><div class=\"content-card\" layout=\"column\" flex>\n<div class=\"content fullpage-datatable\" layout=\"column\" flex><div table-loader array=\"unions\" \nvalidations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"unions.length\"><thead md-head md-order=\"F.orderMongo\" \nfix-head md-on-reorder=\"getThem\"><tr md-row><th md-column md-order-by=\"name\"><span>Nombre</span></th></tr></thead>\n<tbody md-body><tr md-row md-auto-select md-select=\"union\" md-select-id=\"_id\" ng-repeat=\"union in unions\"><td md-cell>\n{{union.name}}</td></tr></tbody></table></md-table-container><md-table-pagination layout-align=\"start center\" \nlayout-gt-xs=\"row\" layout-xs=\"column\" ng-show=\"unions.length\" md-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" \nmd-limit-options=\"F.paginations\" md-page=\"currentPage\" md-total=\"{{pagination.total}}\" \nmd-on-paginate=\"getThemPagination\" md-page-select></md-table-pagination></div></div><md-fab-speed-dial \nmd-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\"><md-fab-trigger>\n<md-button aria-label=\"crud menu\" class=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon>\n</md-button></md-fab-trigger><md-fab-actions><md-button with-permission action=\"update\" access=\"{{F.active.menuItem}}\" \nng-if=\"selected.length == 1\" ng-click=\"R.goToDetail(selected[0])\" aria-label=\"edit\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Editar</md-tooltip><md-icon \nmd-font-icon=\"icon-pencil\" aria-label=\"edit\"></md-icon></md-button><md-button with-permission action=\"remove\" \naccess=\"{{F.active.menuItem}}\" ng-if=\"selected.length\" ng-click=\"delete($event)\" aria-label=\"Delete\" \nclass=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">{{\'EC.REMOVE\' | translate}}</md-tooltip>\n<md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button><md-button with-permission \naction=\"create\" access=\"{{F.active.menuItem}}\" ng-if=\"!selected.length\" ng-click=\'R.goToDetail(\"new\")\' \naria-label=\"add\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">\n{{\'EC.ADD\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon></md-button>\n</md-fab-actions></md-fab-speed-dial></div></div>");
$templateCache.put("app/main/catalogs/views/worker-types/worker-type.html","<div id=\"workerType\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill><form name=\"form\" \nnovalidate flex layout=\"column\" ng-disabled=\"F.readMode\"><div mongo-crud-detail-bar></div><md-content layout=\"column\" \nclass=\"content\" flex><div class=\"detail-form-container md-background-bg md-whiteframe-1dp\"><md-input-container \nclass=\"md-block\"><label>Tipo de Trabajador</label><input ms2-autofocus class=\"uppercased\" \nng-model-options=\"{ debounce: F.debounceTime }\" type=\"text\" name=\"name\" ng-model=\"workerType.name\" md-maxlength=\"20\" \nmaxlength=\"20\" required></md-input-container></div></md-content></form></div>");
$templateCache.put("app/main/catalogs/views/worker-types/worker-types.html","<div id=\"workerTypes\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div mongo-search-bar></div><div class=\"content-card\" layout=\"column\" \nflex><div class=\"content fullpage-datatable\" layout=\"column\" flex><div table-loader array=\"workerTypes\" \nvalidations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"workerTypes.length\"><thead md-head \nmd-order=\"F.orderMongo\" fix-head md-on-reorder=\"getThem\"><tr md-row><th md-column md-order-by=\"name\"><span>\nTipo de Trabajador</span></th></tr></thead><tbody md-body><tr md-row md-auto-select md-select=\"workerType\" \nmd-select-id=\"_id\" ng-repeat=\"workerType in workerTypes\"><td md-cell>{{workerType.name}}</td></tr></tbody></table>\n</md-table-container><md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" \nng-show=\"workerTypes.length\" md-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" md-limit-options=\"F.paginations\" \nmd-page=\"currentPage\" md-total=\"{{pagination.total}}\" md-on-paginate=\"getThemPagination\" md-page-select>\n</md-table-pagination></div></div><md-fab-speed-dial md-open=\"F.isOpen\" \nmd-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\"><md-fab-trigger><md-button \naria-label=\"crud menu\" class=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon></md-button>\n</md-fab-trigger><md-fab-actions><md-button with-permission action=\"update\" access=\"{{F.active.menuItem}}\" \nng-if=\"selected.length == 1\" ng-click=\"R.goToDetail(selected[0])\" aria-label=\"edit\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Editar</md-tooltip><md-icon \nmd-font-icon=\"icon-pencil\" aria-label=\"edit\"></md-icon></md-button><md-button with-permission action=\"remove\" \naccess=\"{{F.active.menuItem}}\" ng-if=\"selected.length\" ng-click=\"delete($event)\" aria-label=\"Delete\" \nclass=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">{{\'EC.REMOVE\' | translate}}</md-tooltip>\n<md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button><md-button with-permission \naction=\"create\" access=\"{{F.active.menuItem}}\" ng-if=\"!selected.length\" ng-click=\'R.goToDetail(\"new\")\' \naria-label=\"add\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">\n{{\'EC.ADD\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon></md-button>\n</md-fab-actions></md-fab-speed-dial></div></div>");
$templateCache.put("app/main/catalogs/views/zipCodes/zipCode.html","<div id=\"zipCode\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill \nng-controller=\"zipCodeController\"><form name=\"form\" novalidate flex layout=\"column\" ng-disabled=\"F.readMode\"><div \nmongo-crud-detail-bar></div><md-content layout=\"column\" class=\"content\" flex><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\"><md-input-container class=\"md-block no-errors-spacer\">\n<label>Codigo Postal</label><input ms2-autofocus class=\"uppercased\" ng-model-options=\"{ debounce: F.debounceTime }\" \ntype=\"text\" name=\"cp\" ng-model=\"zipCode.cp\" md-maxlength=\"5\" maxlength=\"5\" required></md-input-container>\n<md-input-container class=\"md-block\"><label>Tipos de asentamiento</label><md-select ng-disabled=\"F.readMode\" \nng-model=\"zipCode.placeType\" name=\"placeType\" required ng-change=\"setName()\"><md-select-header><input \nautocomplete=\"off\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"placeTypeSelectFilter\" type=\"search\" \nclass=\"md-text\" placeholder=\"Busque un tipo de asentamiento\"></md-select-header><md-option ng-value=\"placeType.name\" \nng-repeat=\"placeType in M.placeTypes | orderBy:\'name\' | filter:placeTypeSelectFilter\">{{placeType.name}}</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block\"><label>Estado</label><md-select \nng-disabled=\"F.readMode\" ng-model=\"zipCode.stateId\" name=\"stateId\" required \nng-change=\"updateKey(zipCode.stateId);getTowns(zipCode.stateId)\"><md-select-header><input autocomplete=\"off\" \nng-keydown=\"$event.stopPropagation()\" ng-model=\"stateSelectFilter\" type=\"search\" class=\"md-text\" \nplaceholder=\"Busque un estado\"></md-select-header><md-option ng-model=\"selectedState\" ng-value=\"estado._id\" \nng-repeat=\"estado in M.states | orderBy:\'name\' | filter:stateSelectFilter\">{{estado.name}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\"><label>Municipio</label><md-select ng-disabled=\"F.readMode\" \nng-model=\"zipCode.townId\" name=\"townId\" required ng-change=\"updateTown(zipCode.townId)\"><md-select-header><input \nautocomplete=\"off\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"townSelectFilter\" type=\"search\" class=\"md-text\" \nplaceholder=\"Busque un municipio\"></md-select-header><md-option ng-model=\"selectedState\" ng-value=\"municipio._id\" \nng-repeat=\"municipio in towns | orderBy:\'name\' | filter:townSelectFilter\">{{municipio.name}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block no-errors-spacer\"><label>Localidad</label><input \nclass=\"uppercased\" ng-model-options=\"{ debounce: F.debounceTime }\" ng-change=\"setName()\" type=\"text\" \nname=\"neighborhood\" ng-model=\"zipCode.neighborhood\" md-maxlength=\"40\" maxlength=\"40\" required></md-input-container>\n<md-input-container class=\"md-block no-errors-spacer\"><label>Ciudad</label><input class=\"uppercased\" \nng-model-options=\"{ debounce: F.debounceTime }\" type=\"text\" ng-change=\"setName()\" name=\"city\" ng-model=\"zipCode.city\" \nmd-maxlength=\"20\" maxlength=\"20\"></md-input-container></div></md-content></form></div>");
$templateCache.put("app/main/catalogs/views/zipCodes/zipCodes.html","<div id=\"zipCodes\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div mongo-search-bar></div><div class=\"content-card\" layout=\"column\" flex>\n<div class=\"content fullpage-datatable\" layout=\"column\" flex><div table-loader array=\"zipCodes\" \nvalidations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"zipCodes.length\"><thead md-head \nmd-order=\"F.orderMongo\" fix-head md-on-reorder=\"getThem\"><tr md-row><th md-column md-order-by=\"name\"><span>CP</span>\n</th><th md-column md-order-by=\"name\"><span>Vecindario</span></th><th md-column md-order-by=\"name\"><span>Nombre</span>\n</th><th md-column md-order-by=\"name\"><span>Tipo de lugar</span></th><th md-column md-order-by=\"name\"><span>Ciudad\n</span></th></tr></thead><tbody md-body><tr md-row md-auto-select md-select=\"zipCode\" md-select-id=\"_id\" \nng-repeat=\"zipCode in zipCodes\"><td md-cell>{{zipCode.cp}}</td><td md-cell>{{zipCode.neighborhood}}</td><td md-cell>\n{{zipCode.name}}</td><td md-cell>{{zipCode.placeType}}</td><td md-cell>{{zipCode.city}}</td></tr></tbody></table>\n</md-table-container><md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" \nng-show=\"zipCodes.length\" md-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" md-limit-options=\"F.paginations\" \nmd-page=\"currentPage\" md-total=\"{{pagination.total}}\" md-on-paginate=\"getThemPagination\" md-page-select>\n</md-table-pagination></div></div><md-fab-speed-dial md-open=\"F.isOpen\" \nmd-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\"><md-fab-trigger><md-button \naria-label=\"crud menu\" class=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon></md-button>\n</md-fab-trigger><md-fab-actions><md-button with-permission action=\"update\" access=\"{{F.active.menuItem}}\" \nng-if=\"selected.length == 1\" ng-click=\"R.goToDetail(selected[0])\" aria-label=\"edit\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Editar</md-tooltip><md-icon \nmd-font-icon=\"icon-pencil\" aria-label=\"edit\"></md-icon></md-button><md-button with-permission action=\"remove\" \naccess=\"{{F.active.menuItem}}\" ng-if=\"selected.length\" ng-click=\"delete($event)\" aria-label=\"Delete\" \nclass=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">{{\'EC.REMOVE\' | translate}}</md-tooltip>\n<md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button><md-button with-permission \naction=\"create\" access=\"{{F.active.menuItem}}\" ng-if=\"!selected.length\" ng-click=\'R.goToDetail(\"new\")\' \naria-label=\"add\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">\n{{\'EC.ADD\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon></md-button>\n</md-fab-actions></md-fab-speed-dial></div></div>");
$templateCache.put("app/main/clients/views/batchRecords/batchRecords.html","<div id=\"batchRecords\" ng-controller=\"BatchRecordsController\" class=\"page-layout carded fullwidth crud-index\" \nlayout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div mongo-search-bar>\n</div><div class=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><div \nlist-filters filters-loaded=\"F.filtersLoaded\" ng-model=\"F.filters[F.active.menuName]\" on-change=\"getThem\" \ncolumns-repeat=\"columnsRepeat\" menu-obj-name=\"{{F.active.menuObjName}}\" model-name=\"{{F.active.menuName}}\" \ninit-filters=\"initFilters\"></div><div table-loader array=\"batchRecords\" validations=\"validations\"></div>\n<md-table-container class=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table \nmd-row-select multiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"batchRecords.length\"><thead md-head \nmd-order=\"F.orderMongo\" fix-head md-on-reorder=\"getThem\"><tr md-row><th md-column md-order-by=\"fid\"><span>ID</span>\n</th><th md-column md-order-by=\"rp\"><span>RP</span></th><th md-column md-order-by=\"created.atTime\"><span>Fecha</span>\n</th><th md-column md-order-by=\"updated\"><span>Fecha Ult. Actu</span></th><th md-column md-order-by=\"batch\"><span>Lote\n</span></th><th md-column md-order-by=\"receivedDate\"><span>Fecha recibido</span></th><th md-column \nmd-order-by=\"archivedDate\"><span>Fecha respuesta</span></th><th md-column md-order-by=\"status\"><span>Estatus</span>\n</th><th md-column md-order-by=\"queueStatus\"><span>Estatus cola</span></th><th md-column md-order-by=\"count\"><span>\nIntentos</span></th><th md-column md-order-by=\"error\"><span>Error</span></th></tr></thead><tbody md-body><tr md-row \nmd-auto-select md-select=\"batchRecord\" md-select-id=\"_id\" ng-repeat=\"batchRecord in batchRecords\"><td md-cell>\n{{batchRecord.fid}}</td><td md-cell>{{batchRecord.rp}}<span ng-if=\"F.center===\'tds\'\">\n[{{batchRecord.center | getSomethingOfArrayFB : F.centersData : \'name\' : batchRecord.center : \'id\'}}]</span></td><td \nmd-cell>{{batchRecord.created.atTime | date : \'dd/MM/yyyy hh:mm a\'}}</td><td md-cell>\n{{batchRecord.updated | date : \'dd/MM/yyyy hh:mm a\'}}</td><td md-cell>{{batchRecord.batch}}</td><td md-cell>\n{{batchRecord.receivedDate | date : \'dd/MM/yyyy hh:mm a\'}}</td><td md-cell>\n{{batchRecord.archivedDate | date : \'dd/MM/yyyy hh:mm a\'}}</td><td md-cell>{{F.statusBatchRecords[batchRecord.status]}}\n</td><td md-cell>{{F.statusQueueBatchRecords[batchRecord.queueStatus]}}</td><td md-cell>{{batchRecord.count}}</td><td \nmd-cell>{{batchRecord.error}}</td></tr></tbody></table></md-table-container><md-table-pagination \nlayout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" ng-show=\"batchRecords.length\" \nmd-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" md-limit-options=\"F.paginations\" md-page=\"$parent.currentPage\" \nmd-total=\"{{pagination.total}}\" md-on-paginate=\"getThemPagination\" md-page-select></md-table-pagination></div></div>\n<md-fab-speed-dial md-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" \nclass=\"ms2-speed-dial bottom right\"><md-fab-trigger><md-button aria-label=\"crud menu\" \nclass=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon></md-button></md-fab-trigger>\n<md-fab-actions><md-button with-permission action=\"update\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" \nng-click=\"R.goToDetail(selected[0])\" aria-label=\"edit\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip \nmd-direction=\"left\">Editar</md-tooltip><md-icon md-font-icon=\"icon-pencil\" aria-label=\"edit\"></md-icon></md-button>\n<md-button with-permission action=\"remove\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length\" \nng-click=\"delete($event)\" aria-label=\"Delete\" class=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">\n{{\'EC.REMOVE\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button>\n<md-button with-permission action=\"create\" access=\"{{F.active.menuItem}}\" ng-if=\"!selected.length\" \nng-click=\'R.goToDetail(\"new\")\' aria-label=\"add\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip \nmd-direction=\"left\">{{\'EC.ADD\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon>\n</md-button><md-button action=\"edit\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length === 1\" \nng-click=\'showDetails(selected[0], \"edit\", $event)\' aria-label=\"edit\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">{{\'EC.EDIT\' | translate}}\n</md-tooltip><md-icon md-font-icon=\"icon-pencil\" aria-label=\"edit\"></md-icon></md-button></md-fab-actions>\n</md-fab-speed-dial></div></div>");
$templateCache.put("app/main/clients/views/bills/bill.html","<div id=\"bank\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill><form name=\"form\" novalidate \nflex layout=\"column\" ng-disabled=\"F.readMode\"><div mongo-crud-detail-bar></div><md-content layout=\"column\" \nclass=\"content\" flex><div class=\"detail-form-container md-background-bg md-whiteframe-1dp\"><div layout-gt-xs=\"row\">\n<md-input-container flex class=\"md-block\"><label>Facturadora</label><md-select name=\"companiesRecord\" \nng-model=\"bill.companiesRecord\" required><md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" \nng-keydown=\"$event.stopPropagation()\" ng-model=\"companySelectFilter\" placeholder=\"Busque una empresa\">\n</md-select-header><md-option ng-value=\"companiesRecord.$id\" \nng-repeat=\"companiesRecord in L.companiesRecords | orderBy:\'name\' | filter:companySelectFilter\">\n{{companiesRecord.name}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex><label>\nRFC</label><input rfc class=\"uppercased\" ng-model-options=\"{ debounce: F.debounceTime }\" maxlength=\"13\" \nmd-maxlength=\"13\" type=\"text\" name=\"toRFC\" ng-model=\"bill.toRFC\" required></md-input-container></div><div \nlayout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex><label>XML</label><input class=\"uppercased\" \nng-model-options=\"{ debounce: F.debounceTime }\" type=\"url\" name=\"xmlFile\" ng-model=\"bill.xmlFile\" required>\n</md-input-container><md-input-container class=\"md-block\" flex><label>Timbrado del SAT</label><input \nclass=\"uppercased\" ng-model-options=\"{ debounce: F.debounceTime }\" type=\"text\" name=\"satStamp\" \nng-model=\"bill.satStamp\" required></md-input-container></div><div layout-gt-xs=\"row\"><md-input-container \nclass=\"md-block date-picker\" flex><label>Fecha</label><md-datepicker md-hide-icons=\"triangle\" input-date-miliseconds \nng-model=\"bill.date\" name=\"date\" required></md-datepicker></md-input-container><md-input-container \nclass=\"md-input-has-placeholder md-block\" flex><label>Tipo</label><md-radio-group ng-model=\"bill.type\" required>\n<md-radio-button value=\"fromClient\">{{\'bill.FROMCLIENT\' | translate}}</md-radio-button><md-radio-button \nvalue=\"toClient\">{{\'bill.TOCLIENT\' | translate}}</md-radio-button></md-radio-group></md-input-container></div><div \nlayout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex><label>Monto</label><input type=\"number\" step=\"any\" \nname=\"amount\" ng-model=\"bill.amount\" ng-min=\"0\"></md-input-container><md-input-container class=\"md-block\" flex><label>\nI.V.A.</label><input type=\"number\" step=\"any\" name=\"iva\" ng-model=\"bill.iva\" ng-min=\"0\"></md-input-container>\n<md-input-container class=\"md-block\" flex><label>Total</label><input type=\"number\" step=\"any\" name=\"total\" \nng-model=\"bill.total\" ng-min=\"0\"></md-input-container></div></div></md-content></form></div>");
$templateCache.put("app/main/clients/views/bills/bills.html","<div id=\"bills\" class=\"page-layout carded fullwidth crud-index\" ng-controller=\"BillsController\" layout=\"row\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div mongo-search-bar></div><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><div \nlist-filters filters-loaded=\"F.filtersLoaded\" ng-model=\"F.filters[F.active.menuName]\" on-change=\"getThem\" \ncolumns-repeat=\"columnsRepeat\" menu-obj-name=\"{{F.active.menuObjName}}\" model-name=\"{{F.active.menuName}}\" \ninit-filters=\"initFilters\"></div><div table-loader array=\"bills\" validations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"bills.length\"><thead md-head md-order=\"F.orderMongo\" \nfix-head md-on-reorder=\"getThem\"><tr md-row><th md-column md-order-by=\"opType\"><span>Tipo</span></th><th md-column \nmd-order-by=\"status\"><span>Estatus</span></th><th md-column md-order-by=\"employeeName\"><span>Empleado</span></th><th \nmd-column md-order-by=\"rfc\"><span>RFC</span></th><th md-column md-order-by=\"companiesRecordId\"><span>Empresa</span>\n</th><th md-column md-order-by=\"rpId\"><span>RP</span></th><th md-column md-order-by=\"payrollId\"><span>Nomina</span>\n</th><th md-column md-order-by=\"calendar\"><span>Calendario</span></th><th md-column md-order-by=\"period\"><span>Periodo\n</span></th><th md-column md-order-by=\"sentTime\"><span>Status de envío</span></th><th md-column md-order-by=\"sentTime\">\n<span>Fecha de envío</span></th><th md-column md-order-by=\"sentEmail\"><span>Correo de envío</span></th></tr></thead>\n<tbody md-body><tr md-row \nng-class=\"{\'inactiveEmployee\': bill.status === \'error\', \'statusCancel\': bill.status === \'cancelled\'}\" md-auto-select \nmd-select=\"bill\" md-select-id=\"_id\" ng-repeat=\"bill in bills\"><td md-cell>{{\'b.\'+bill.opType | translate}}</td><td \nmd-cell>{{\'b.\'+bill.status | translate}}<md-button class=\"md-icon-button md-warn\" aria-label=\"cancel by\" \nng-if=\"bill.cancelledByName\"><md-tooltip md-direction=\"left\">por {{bill.cancelledByName}}</md-tooltip><md-icon \nmd-font-icon=\"icon-bookmark-remove\"></md-icon></md-button></td><td md-cell ng-bind=\"bill.employeeName\"></td><td \nmd-cell><div layout=\"row\" layout-align=\"start center\"><div flex=\"nogrow\" ng-bind=\"bill.rfc\"></div><div flex=\"nogrow\">\n<md-button class=\"md-icon-button md-warn\" ng-if=\"bill.errorMsg\" aria-label=\"error msg\"><md-tooltip \nmd-direction=\"right\">{{bill.errorMsg}}</md-tooltip><md-icon md-font-icon=\"icon-alert\"></md-icon></md-button></div>\n</div></td><td md-cell>{{bill[\'companiesRecordId-name\']}}</td><td md-cell>{{bill[\'rpId-name\']}}</td><td md-cell>\n{{bill[\'payrollId-name\']}}</td><td md-cell>{{bill.calendar}}</td><td md-cell>{{bill.period}}</td><td md-cell><div \nlayout=\"row\" layout-align=\"start center\"><div flex=\"nogrow\" \nng-bind=\"bill.sentStatus?(\'b.\'+bill.sentStatus | translate):(bill.sentTime?\'Enviado\':\'No enviado\')\"></div><div \nflex=\"nogrow\"><md-button class=\"md-icon-button md-warn\" ng-if=\"bill.sentStatus.indexOf(\'fail\')>-1\" \naria-label=\"error msg\"><md-tooltip md-direction=\"right\">{{bill.sentMsg}}</md-tooltip><md-icon \nmd-font-icon=\"icon-alert\"></md-icon></md-button></div></div></td><td md-cell>{{bill.sentTime|date:\'short\'}}</td><td \nmd-cell>{{bill.sentEmail}}</td></tr></tbody></table></md-table-container><md-table-pagination \nlayout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" ng-show=\"bills.length\" \nmd-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" md-limit-options=\"F.paginations\" md-page=\"$parent.currentPage\" \nmd-total=\"{{pagination.total}}\" md-on-paginate=\"getThemPagination\" md-page-select></md-table-pagination></div></div>\n<md-fab-speed-dial md-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" \nclass=\"ms2-speed-dial bottom right\"><md-fab-trigger><md-button aria-label=\"crud menu\" \nclass=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon></md-button></md-fab-trigger>\n<md-fab-actions><md-button with-permission action=\"update\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" \nng-click=\"R.goToDetail(selected[0])\" aria-label=\"edit\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip \nmd-direction=\"left\">Editar</md-tooltip><md-icon md-font-icon=\"icon-pencil\" aria-label=\"edit\"></md-icon></md-button>\n<md-button with-permission action=\"remove\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length\" \nng-click=\"delete($event)\" aria-label=\"Delete\" class=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">\n{{\'EC.REMOVE\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button>\n<md-button with-permission action=\"create\" access=\"{{F.active.menuItem}}\" ng-if=\"!selected.length\" \nng-click=\'R.goToDetail(\"new\")\' aria-label=\"add\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip \nmd-direction=\"left\">{{\'EC.ADD\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon>\n</md-button><md-button with-permission action=\"downloadPdf\" access=\"{{processes.operation}}\" \nng-if=\"selected.length>0 && allHave(selected)\" class=\"md-fab md-mini md-primary md-hue-3\" aria-label=\"Download PDF\" \nng-click=\"downloadBill(selected)\"><md-icon md-font-icon=\"icon-file-pdf\"></md-icon><md-tooltip md-direction=\"left\">\nDescargar PDF</md-tooltip></md-button><md-button with-permission action=\"downloadXml\" access=\"{{processes.operation}}\" \nng-if=\"selected.length>0 && allHave(selected)\" class=\"md-fab md-mini md-primary md-hue-3\" aria-label=\"Download XML\" \nng-click=\"downloadManyFiles(selected)\"><md-icon md-font-icon=\"icon-file-xml\"></md-icon><md-tooltip md-direction=\"left\">\nDescargar XML</md-tooltip></md-button><md-button with-permission action=\"sendEmail\" access=\"processes.operations\" \nng-if=\"checkOperation(selected)\" class=\"md-fab md-mini md-hue-3\" aria-label=\"Send Email\" \nng-click=\"sendEmail(selected, $event)\"><md-icon md-font-icon=\"icon-email\"></md-icon><md-tooltip md-direction=\"left\">\nEnviar recibo</md-tooltip></md-button><md-button with-permission action=\"sendEmailSpecial\" \naccess=\"processes.operations\" ng-if=\"checkOperation(selected)\" class=\"md-fab md-mini md-hue-3\" aria-label=\"Send Email\" \nng-click=\"sendEmail(selected, $event, \'smtp\')\"><md-icon md-font-icon=\"icon-email-secure\"></md-icon><md-tooltip \nmd-direction=\"left\">Enviar recibo ruta especial</md-tooltip></md-button><md-button action=\"exportv2\" \naccess=\"{{F.active.menuItem}}\" \nng-click=\'exportData(bills,\"bills\",\"bills\",\"mongo\",getParamsObject(),pagination.total,\",\",1,1,\"csv\")\' \naria-label=\"export\" class=\"md-fab md-raised md-mini md-primary md-hue-2\"><md-tooltip md-direction=\"left\">Exportar datos\n</md-tooltip><md-icon md-font-icon=\" icon-file-excel\" aria-label=\"export\"></md-icon></md-button><md-button \naction=\"cancelBilling\" access=\"{{F.active.menuItem}}\" ng-if=\" (selected|recordsHaveValue:\'status\':\'ok\')\" \naria-label=\"cancelled billing\" ng-click=\"cancelBill(selected,$event)\" class=\"md-fab md-mini md-raised md-warn\"><md-icon\n md-font-icon=\"icon-undo-variant\" aria-label=\"cancel bill\"></md-icon><md-tooltip md-direction=\"left\">Cancelar Recibo\n</md-tooltip></md-button></md-fab-actions></md-fab-speed-dial></div></div>");
$templateCache.put("app/main/clients/views/closeOperations/closeOperation.html","<div id=\"closeOperation\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill><form name=\"form\" \nnovalidate flex layout=\"column\" ng-disabled=\"F.readMode\"><div fb-crud-detail-bar></div><md-content layout=\"column\" \nclass=\"content\" flex><div class=\"detail-form-container md-background-bg md-whiteframe-1dp\"><md-input-container \nclass=\"md-block date-picker\" flex><label>Fecha de cierre</label><md-datepicker ng-disabled=\"F.readMode\" \nmd-hide-icons=\"triangle\" input-date-miliseconds ng-model=\"closeOperation.date\" name=\"closeOperationDate\" required \nclass=\"md-block\"></md-datepicker><div ng-messages=\"form.closeOperationDate.$error\" role=\"alert\"><div \nng-message=\"required\">Fecha de Cierre es requerida</div></div></md-input-container></div></md-content></form></div>");
$templateCache.put("app/main/clients/views/closeOperations/closeOperations.html","<div id=\"closeOperations\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div fb-search-bar></div><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><div \nfilter-toolbar></div><div table-loader array=\"closeOperations\" validations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"closeOperations.length\"><thead md-head \nmd-order=\"order\" fix-head><tr md-row><th md-column md-order-by=\"date\"><span>Fecha</span></th></tr></thead><tbody \nmd-body><tr md-row md-auto-select md-select=\"closeOperation\" md-select-id=\"$id\" \nng-repeat=\"closeOperation in (F.filteredItems = (closeOperations | filter:F.searchText.closeOperation | orderBy:order)) | limitTo: F.paginate: (currentPage - 1) * F.paginate\">\n<td md-cell>{{closeOperation.date | date:F.dateFormat}}</td></tr></tbody></table></md-table-container>\n<md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" \nng-show=\"closeOperations.length\" md-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" \nmd-limit-options=\"F.paginations\" md-page=\"currentPage\" md-on-paginate=\"restartSelected\" \nmd-total=\"{{F.filteredItems.length}}\" md-page-select></md-table-pagination></div></div><md-fab-speed-dial \nmd-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\"><md-fab-trigger>\n<md-button aria-label=\"crud menu\" class=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon>\n</md-button></md-fab-trigger><md-fab-actions><md-button with-permission action=\"read\" access=\"{{F.active.menuItem}}\" \nng-if=\"selected.length == 1\" \nng-click=\'R.goToDetail(null, \"read\", {closeOperationId: selected[0].$id, firmId: selected[0].firm})\' aria-label=\"view\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Ver</md-tooltip><md-icon \nmd-font-icon=\"icon-eye\" aria-label=\"view\"></md-icon></md-button><md-button with-permission action=\"export\" \naccess=\"{{F.active.menuItem}}\" ng-click=\"exportDataToExcel(F.filteredItems,null,currentPage,F.paginate)\" \naria-label=\"export\" class=\"md-fab md-raised md-mini md-primary md-hue-2\"><md-tooltip md-direction=\"left\">\nExportar a excel</md-tooltip><md-icon md-font-icon=\" icon-file-excel\" aria-label=\"export\"></md-icon></md-button>\n<md-button with-permission action=\"update\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" \nng-click=\'R.goToDetail(null, \"update\", {closeOperationId: selected[0].$id, firmId: selected[0].firm})\' \naria-label=\"edit\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Editar\n</md-tooltip><md-icon md-font-icon=\"icon-pencil\" aria-label=\"edit\"></md-icon></md-button><md-button with-permission \naction=\"remove\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length\" ng-click=\"delete($event)\" aria-label=\"Delete\" \nclass=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">{{\'EC.REMOVE\' | translate}}</md-tooltip>\n<md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button><md-button with-permission \naction=\"create\" access=\"{{F.active.menuItem}}\" ng-if=\"!selected.length\" \nng-click=\'R.goToDetail(null, \"update\", {closeOperationId: \"new\"})\' aria-label=\"add\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">{{\'EC.ADD\' | translate}}\n</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon></md-button></md-fab-actions>\n</md-fab-speed-dial></div></div>");
$templateCache.put("app/main/clients/views/ccs/cc.html","<div id=\"cc\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill ng-controller=\"CcController\">\n<form name=\"form\" novalidate flex layout=\"column\" ng-disabled=\"F.readMode\"><md-toolbar \nclass=\"md-tall header md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" \nlayout-align=\"start center\" flex><md-button with-permission action=\"access\" access=\"{{F.active.menuItem}}\" \nclass=\"goto-button md-icon-button\" aria-label=\"Go to list\" ng-click=\"R.goToList()\" translate \ntranslate-attr-aria-label=\"EC.GO_TO\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" \nlayout-align=\"start center\"><md-icon \nmd-font-icon=\"{{F.menuItems[F.active.menuParent][F.active.menuName].icon || F.default.icon}}\" class=\"crud-icon\">\n</md-icon><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\">{{F.active.detailObject.data.name}}</div><div\n class=\"subtitle secondary-text\"><span ng-if=\"!F.addMode\">\n{{\'EC.DETAIL_OF\' | translate}} {{F.active.menuObjName + \'.SINGULAR\' | translate}}</span> <span ng-if=\"F.addMode\">\n{{\'EC.CREATE\' | translate}} {{F.active.menuObjName + \'.SINGULAR\' | translate}}</span></div></div></div></div><div>\n<md-button type=\"submit\" ng-if=\"!F.addMode && objectLoaded && !F.readMode\" with-permission action=\"update\" \naccess=\"{{F.active.menuItem}}\" ng-click=\"saveCc(F.active.detailObject)\" ng-hide=\"form.$pristine && !objectLoaded\" \nng-disabled=\"form.$invalid || loadingProgress\" class=\"md-raised md-background md-fab md-accent md-hue-1\" \naria-label=\"Save\"><md-tooltip md-direction=\"left\">{{\'EC.SAVE\' | translate}}</md-tooltip><md-icon \nmd-font-icon=\"icon-content-save\" aria-label=\"Save\"></md-icon></md-button><md-button type=\"submit\" \nng-if=\"F.addMode && objectLoaded\" with-permission action=\"create\" access=\"{{F.active.menuItem}}\" \nng-click=\"add(F.active.detailObject)\" ng-hide=\"form.$pristine && !objectLoaded\" \nng-disabled=\"form.$invalid || loadingProgress || form.$pending\" \nclass=\"md-raised md-background md-fab md-accent md-hue-1\" aria-label=\"Add\"><md-tooltip md-direction=\"left\">\n{{\'EC.ADD\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-content-save\" aria-label=\"Add\"></md-icon></md-button>\n</div></md-toolbar><md-content layout=\"column\" class=\"content\" flex><md-tabs md-selected=\"selectedTab\" flex \nlayout-fill><md-tab label=\"Información\"><md-tab-body><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\"><div layout-gt-xs=\"row\"><md-input-container \nclass=\"md-block\" flex><label>Nómina</label><md-select ng-disabled=\"F.readMode\" ms2-autofocus name=\"payroll\" \nng-change=\'cc.data.name = \"\"\' ng-model=\"cc.payroll\" required><md-select-header><input autocomplete=\"off\" type=\"search\" \nclass=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"payrollSelectFilter\" placeholder=\"Busque una nómina\">\n</md-select-header><md-option ng-if=\"!F.permissionToAccessAllPayrolls\" ng-value=\"payroll.$id\" \nng-disabled=\"!payroll.active\" ng-click=\"filterRp(payroll, L.rps)\" \nng-repeat=\"payroll in L.payrolls | orderBy:\'name\' | filter:payrollSelectFilter\">{{payroll.class}} {{payroll.name}}\n</md-option><md-option ng-if=\"F.permissionToAccessAllPayrolls\" ng-value=\"payroll.$id\" ng-disabled=\"!payroll.active\" \nng-click=\"filterRp(payroll, L.rps)\" ng-repeat=\"payroll in L.allPayrolls | orderBy:\'name\' | filter:payrollSelectFilter\">\n{{payroll.class}} {{payroll.name}}</md-option></md-select><div ng-messages=\"form.payroll.$error\" \nng-show=\"form.payroll.$touched || form.payroll.$dirty\" role=\"alert\"><div ng-message=\"required\">Nómina es requerido\n</div></div></md-input-container><md-input-container class=\"md-block\" flex><label>Registro Patronal</label><md-select \nng-disabled=\"F.readMode\" name=\"rp\" ng-model=\"cc.data.rp_id\" required><md-select-header><input autocomplete=\"off\" \ntype=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"rpSelectFilter\" \nplaceholder=\"Busque un registro patronal\"></md-select-header><md-option ng-if=\"rp.active || !F.addMode\" \nng-disabled=\"!rp.active\" ng-value=\"rp.$id\" ng-repeat=\"rp in rps | orderBy:\'name\' | filter:rpSelectFilter\">{{rp.name}}\n</md-option></md-select><div ng-messages=\"form.rp.$error\" ng-show=\"form.rp.$touched || form.rp.$dirty\" role=\"alert\">\n<div ng-message=\"required\">Registro Patronal es requerido</div></div></md-input-container></div><div \nlayout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex><label>Nombre</label><input \nng-readonly=\"!cc.data.rp_id || !cc.payroll || F.readMode\" unique-fb-2 ref=\"lists/ccs/payroll/{{cc.payroll}}\" \nquery=\"name\" fromid=\"{{cc.$id}}\" extra-field=\"rp_id\" extra=\"{{cc.data.rp_id}}\" second-extra-field=\"place\" \nsecond-extra=\"{{cc.data.place}}\" class=\"uppercased\" ng-model-options=\"{ debounce: F.debounceTime }\" type=\"text\" \nname=\"name\" ng-model=\"cc.data.name\" md-maxlength=\"50\" maxlength=\"50\" required><div ng-messages=\"form.name.$error\" \nng-show=\"form.name.$touched || form.name.$dirty\" role=\"alert\"><div ng-message=\"required\">Nombre es requerido</div><div \nng-message=\"maxlength\">Nombre no debe tener más de 40 caracteres</div><div ng-message=\"uniqueInBoth\">\nNombre ya está registrado en RP y Nómina</div></div></md-input-container></div><div layout-gt-xs=\"row\">\n<md-input-container class=\"md-block\" flex><label>Sindicato</label><md-select ng-disabled=\"F.readMode\" \nng-model=\"cc.data.union_id\" name=\"union\" required><md-select-header><input autocomplete=\"off\" type=\"search\" \nclass=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"unionSelectFilter\" placeholder=\"Busque un sindicato\">\n</md-select-header><md-option ng-value=\"union._id\" \nng-repeat=\"union in M.unions | orderBy:\'name\' | filter:unionSelectFilter\">{{union.name}}</md-option></md-select><div \nng-messages=\"form.union.$error\" ng-show=\"form.union.$touched || form.union.$dirty\" role=\"alert\"><div \nng-message=\"required\">Sindicato es requerido</div></div></md-input-container><md-input-container class=\"md-block\" flex>\n<label>Ubicacion</label><md-select ng-disabled=\"F.readMode\" ng-model=\"cc.data.place\" name=\"`place\" required>\n<md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" \nng-model=\"placeSelectFilter\" placeholder=\"Busque una plaza\"></md-select-header><md-option \nng-value=\"placesOfWorkRecord._id\" \nng-repeat=\"placesOfWorkRecord in M.placesOfWorkRecords | orderBy:\'name\' | filter:placeSelectFilter\">\n{{placesOfWorkRecord.name}}</md-option></md-select><div ng-messages=\"form.place.$error\" \nng-show=\"form.place.$touched || form.place.$dirty\" role=\"alert\"><div ng-message=\"required\">Plaza es requerido</div>\n</div></md-input-container></div></div></md-tab-body></md-tab><md-tab label=\"Configuración\"><md-tab-body><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\"><md-switch ng-disabled=\"F.readMode\" \nclass=\"md-secondary md-padding\" name=\"healthCare\" aria-label=\"healthCare switch\" ng-model=\"cc.data.healthCare\">Salud\n</md-switch><md-switch ng-disabled=\"F.readMode\" class=\"md-secondary md-padding\" name=\"valid\" \narial-label=\"valid switch\" ng-change=\"disableAlert(cc.valid, cc.data.rp_id);unarchived(cc.valid,cc)\" \nng-model=\"cc.valid\">Vigente</md-switch><md-switch ng-disabled=\"F.readMode\" class=\"md-secondary md-padding\" \nname=\"valid\" arial-label=\"valid switch\" ng-model=\"cc.applyEmployeePromotionTax\">Aplicar Impuesto de Fomento al Empleo\n</md-switch><md-switch ng-disabled=\"F.readMode\" class=\"md-warn md-padding\" name=\"archived\" \narial-label=\"archived switch\" ng-model=\"cc.archived\">Archivado</md-switch></div></md-tab-body></md-tab></md-tabs>\n</md-content></form></div>");
$templateCache.put("app/main/clients/views/ccs/ccs.html","<div id=\"ccs\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\" ng-controller=\"CcsController\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div fb-search-bar></div><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><div \nfilter-toolbar></div><div table-loader array=\"ccs\" validations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"ccs.length\"><thead md-head md-order=\"order\" fix-head>\n<tr md-row><th md-column md-order-by=\"payroll\">Nómina</th><th md-column md-order-by=\"data.name\"><span>Nombre</span>\n</th><th md-column md-order-by=\'\"rp-name\"\'>Registro Patronal</th><th md-column md-order-by=\"data.union_id\"><span>\nSindicato</span></th><th md-column md-order-by=\"data.place\"><span>Plaza</span></th><th md-column md-order-by=\"valid\">\n<span>Vigente</span></th><th md-column md-order-by=\"data.healthCare\"><span>Salud</span></th></tr></thead><tbody \nmd-body><tr ng-class=\"{\'inactiveEmployee\': !cc.valid}\" md-row md-auto-select md-select=\"cc\" md-select-id=\"$id\" \nng-repeat=\"cc in (F.filteredItems = (Z.ccs | searchSpecific:F.searchText.cc:fixedFieldsSearch | orderBy:order)) | limitTo: F.paginate: (currentPage - 1) * F.paginate\">\n<td md-cell>{{cc.payroll | nameOfL: L.allPayrolls:\'N/A\'}}</td><td md-cell>{{cc.data.name}}</td><td md-cell>\n{{cc[\"rp-name\"]}}</td><td md-cell>{{cc.data.union_id | nameOfM: M.unions:0:\'N/A\'}}</td><td md-cell>\n{{cc.data.place | nameOfM: M.placesOfWorkRecords:0:\'N/A\'}}</td><td md-cell><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"quantity-indicator\" \nng-class=\"{\'md-red-500-bg\': !cc.valid, \'md-green-600-bg\': cc.valid }\"></div></div></td><td md-cell>\n{{cc.data.healthCare?\'Si\':\'No\'}}</td></tr></tbody></table></md-table-container><md-table-pagination \nng-show=\"ccs.length\" layout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" \nmd-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" md-limit-options=\"F.paginations\" \nmd-on-paginate=\"restartSelected\" md-total=\"{{F.filteredItems.length}}\" md-page=\"currentPage\" md-page-select>\n</md-table-pagination></div></div><md-fab-speed-dial md-open=\"F.isOpen\" \nmd-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\"><md-fab-trigger><md-button \naria-label=\"crud menu\" class=\"md-fab md-accent\" md-class=\"{\'md-hue-1\': selected.length}\"><md-icon \nmd-font-icon=\"icon-cube\"></md-icon></md-button></md-fab-trigger><md-fab-actions><md-button with-permission \naction=\"read\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" \nng-click=\'R.goToDetail(null, \"read\", {ccId: selected[0].$id, payrollId: selected[0].payroll})\' aria-label=\"view\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Ver</md-tooltip><md-icon \nmd-font-icon=\"icon-eye\" aria-label=\"view\"></md-icon></md-button><md-button with-permission action=\"export\" \naccess=\"{{F.active.menuItem}}\" ng-click=\"exportDataToExcel(F.filteredItems,null,currentPage,F.paginate)\" \naria-label=\"export\" class=\"md-fab md-raised md-mini md-primary md-hue-2\"><md-tooltip md-direction=\"left\">\nExportar a excel</md-tooltip><md-icon md-font-icon=\" icon-file-excel\" aria-label=\"export\"></md-icon></md-button>\n<md-button with-permission action=\"update\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" \nng-click=\'R.goToDetail(null, \"update\", {ccId: selected[0].$id, payrollId: selected[0].payroll})\' aria-label=\"edit\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Editar</md-tooltip><md-icon \nmd-font-icon=\"icon-pencil\" aria-label=\"edit\"></md-icon></md-button><md-button with-permission action=\"remove\" \naccess=\"{{F.active.menuItem}}\" ng-if=\"selected.length\" ng-click=\"delete($event)\" aria-label=\"Delete\" \nclass=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">{{\'EC.REMOVE\' | translate}}</md-tooltip>\n<md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button><md-button with-permission \naction=\"create\" access=\"{{F.active.menuItem}}\" ng-if=\"!selected.length\" \nng-click=\'R.goToDetail(null, \"update\", {ccId: \"new\"})\' aria-label=\"add\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">{{\'EC.ADD\' | translate}}\n</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon></md-button><md-button with-permission \naction=\"disabledMany\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length\" aria-label=\"disabled\" \nclass=\"md-fab md-raised md-mini md-warn md-hue-2\" ng-click=\"disableCc($event)\"><md-tooltip md-direction=\"left\">\n{{\'EC.DISABLED\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-cancel\" aria-label=\"disabled\"></md-icon>\n</md-button><md-button with-permission action=\"clone\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length==1\" \nng-click=\'R.goToDetail(null, \"update\", {ccId: \"new\",rp_id:selected[0].data.rp_id,project_id:selected[0].data.project_id, name:selected[0].data.name,union_id:selected[0].data.union_id,healthCare:selected[0].data.healthCare,payrollId: selected[0].payroll,place:selected[0].data.place})\' \naria-label=\"add\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">\n{{\'EC.CLONE\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-content-copy\" aria-label=\"clone\"></md-icon>\n</md-button></md-fab-actions></md-fab-speed-dial></div></div>");
$templateCache.put("app/main/clients/views/calculations/calculation.html","<div id=\"payrollCalendar\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill \nng-controller=\"PayrollCalendarController\"><form name=\"form\" novalidate flex layout=\"column\" ng-disabled=\"!F.addMode\">\n<md-toolbar class=\"md-tall header md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" \nlayout=\"row\" layout-align=\"start center\" flex><md-button class=\"goto-button md-icon-button\" \naria-label=\"Go to payrollCalendars\" ng-click=\"R.goToList(F.active.menuName, F.active.menuParams)\" translate \ntranslate-attr-aria-label=\"EC.GO_TO\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"{{F.menuItems.clients.payrollCalendars.icon || F.default.icon}}\" \nclass=\"crud-icon\"></md-icon><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\">\n{{payrollCalendar.payroll | nameOfL: L.allPayrolls}} - {{payrollCalendar.data.year}}</div><div \nclass=\"subtitle secondary-text\"><span ng-if=\"!F.addMode\">\n{{\'EC.DETAIL_OF\' | translate}} {{\'payrollCalendar.SINGULAR\' | translate}}</span> <span ng-if=\"F.addMode\">\n{{\'EC.CREATE\' | translate}} {{\'payrollCalendar.SINGULAR\' | translate}}</span></div></div></div></div><div><md-button \ntype=\"submit\" ng-if=\"!F.addMode\" with-permission action=\"update\" access=\"{{F.active.menuItem}}\" \nng-click=\"saveCalendarAndPeriods(payrollCalendar)\" ng-hide=\"form.$pristine\" \nng-disabled=\"form.$invalid || loadingProgress\" class=\"md-raised md-background md-fab md-accent md-hue-1\" \naria-label=\"Save payrollCalendar\"><md-tooltip md-direction=\"left\">{{\'EC.SAVE\' | translate}}</md-tooltip><md-icon \nmd-font-icon=\"icon-content-save\" aria-label=\"Save\"></md-icon></md-button><md-button type=\"submit\" ng-if=\"F.addMode\" \nwith-permission action=\"create\" access=\"{{F.active.menuItem}}\" ng-click=\"addCalendarAndPeriods(payrollCalendar)\" \nng-hide=\"form.$pristine\" ng-disabled=\"form.$invalid || loadingProgress\" \nclass=\"md-raised md-background md-fab md-accent md-hue-1\" aria-label=\"Add payrollCalendar\"><md-tooltip \nmd-direction=\"left\">{{\'EC.ADD\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-content-save\" aria-label=\"Add\">\n</md-icon></md-button></div></md-toolbar><md-content layout=\"column\" class=\"content\" flex><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\"><div layout-gt-xs=\"row \"><md-input-container \nclass=\"md-block\" flex-gt-xs><label>Nomina</label><md-select ms2-autofocus ng-model=\"payrollCalendar.payroll\" required>\n<md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" \nng-model=\"payrollSelectFilter\" placeholder=\"Busque una nomina \"></md-select-header><md-option ng-value=\"payroll.$id\" \nng-repeat=\"payroll in L.allPayrolls | orderBy:\'name\' | filter:payrollSelectFilter\">{{payroll.name}}</md-option>\n</md-select></md-input-container></div><div layout-gt-xs=\"row \"><md-input-container class=\"md-block\" flex-gt-xs><label>\nPeriodo Inicial</label><input type=\"text\" maxlength=\"3\" ng-pattern=\"/^[0-9]{1,3}$/\" name=\"initialPeriod\" \nng-model=\"payrollCalendar.data.initialPeriod\" ng-model-options=\"{ debounce: F.debounceTime }\" \nng-change=\"watchPeriod(payrollCalendar.data.initialPeriod)\"><div \nng-messages=\"payrollCalendarForm.initialPeriod.$error\"><div ng-message=\"pattern\">Ingrese un numero entero valido</div>\n</div></md-input-container><md-input-container class=\"md-block\" flex-gt-xs><label>Año</label><input \nng-disabled=\"!F.addMode\" type=\"text\" maxlength=\"4\" ng-pattern=\"/^[0-9]{4}$/\" name=\"year\" \nng-model=\"payrollCalendar.data.year\" unique-fb ref=\"{{mainRef}}/{{payrollCalendar.payroll}}/calendars\" \nquery=\"data/year\" fromid=\"{{payrollCalendar.$id}}\" required><div ng-messages=\"payrollCalendarForm.year.$error\"><div \nng-message=\"pattern\">Ingrese el año al que corresponde el calendario</div><div ng-message=\"unique\">\nEl año que ingreso ya tiene periodos</div></div></md-input-container><md-input-container class=\"md-block\" \nflex-gt-xs=\"nogrow\"><label>Fecha Inicio</label><md-datepicker md-hide-icons=\"triangle\" name=\"initialDate\" \nng-model=\"initialDate\" class=\"md-block\" required ng-change=\"watchInitialDate(initialDate)\"></md-datepicker>\n</md-input-container></div></div></md-content></form></div>");
$templateCache.put("app/main/clients/views/calculations/calculations.html","<div id=\"payrollCalendars\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\" \nng-controller=\"PayrollCalendarsController\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" \nflex><div fb-search-bar></div><div class=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" \nlayout=\"column\"><div table-loader array=\"payrollCalendars\" validations=\"validations\"></div><md-table-container \nng-show=\"payrollCalendars.length\"><table md-table md-row-select multiple=\"true\" ng-model=\"selected\" class=\"row-border\">\n<thead md-head md-order=\"order\" fix-head><tr md-row><th md-column md-order-by=\"data.year\"><span>Año</span></th><th \nmd-column md-order-by=\"data.payroll\"><span>Nómina</span></th><th md-column md-order-by=\"data.startDate\"><span>\nFecha Inicio</span></th><th md-column md-order-by=\"data.endDate\"><span>Fecha Fin</span></th></tr></thead><tbody \nmd-body><tr md-row md-auto-select md-select=\"payrollCalendar\" md-select-id=\"$id\" \nng-repeat=\"payrollCalendar in (F.filteredItems = (payrollCalendars | filter:F.searchText.payrollCalendar | orderBy:order)) | limitTo: F.paginate: (currentPage - 1) * F.paginate\">\n<td md-cell>{{payrollCalendar.data.year}}</td><td md-cell>{{payrollCalendar.payroll | nameOfL: L.allPayrolls:\'N/A\'}}\n</td><td md-cell>{{payrollCalendar.data.startDate | date:\'mediumDate\'}}</td><td md-cell>\n{{payrollCalendar.data.endDate | date:\'mediumDate\'}}</td></tr></tbody></table></md-table-container><md-table-pagination\n layout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" ng-show=\"payrollCalendars.length\" \nmd-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" md-limit-options=\"F.paginations\" md-page=\"currentPage\" \nmd-on-paginate=\"restartSelected\" md-total=\"{{F.filteredItems.length}}\" md-page-select></md-table-pagination></div>\n</div><md-fab-speed-dial md-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" \nclass=\"ms2-speed-dial bottom right\"><md-fab-trigger><md-button aria-label=\"crud menu\" \nclass=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon></md-button></md-fab-trigger>\n<md-fab-actions><md-button with-permission action=\"read\" access=\"clients.periods\" ng-if=\"selected.length == 1\" \nng-click=\'R.goToDetail(selected[0], \"list\", {payrollCalendar:selected[0], payrollCalendarId: selected[0].$id, payrollId: F.search.$payroll}, \"periods\")\' \naria-label=\"see periods\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">\nVer Periodos</md-tooltip><md-icon md-font-icon=\"icon-calendar-check-multiple\" aria-label=\"view\"></md-icon></md-button>\n<md-button with-permission action=\"update\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" \nng-click=\"R.goToDetail(selected[0])\" aria-label=\"edit\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip \nmd-direction=\"left\">Editar</md-tooltip><md-icon md-font-icon=\"icon-pencil\" aria-label=\"edit\"></md-icon></md-button>\n<md-button with-permission action=\"remove\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length\" \nng-click=\"deleteCalendarAndPeriods($event)\" aria-label=\"Delete\" class=\"md-fab md-raised md-warn md-mini\"><md-tooltip \nmd-direction=\"left\">{{\'EC.REMOVE\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\">\n</md-icon></md-button><md-button with-permission action=\"create\" access=\"{{F.active.menuItem}}\" \nng-if=\"!selected.length\" ng-click=\'R.goToDetail(\"new\")\' aria-label=\"add\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">{{\'EC.ADD\' | translate}}\n</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon></md-button></md-fab-actions>\n</md-fab-speed-dial></div></div>");
$templateCache.put("app/main/clients/views/companies-records/companies-record.html","<div id=\"companiesRecord\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill \nng-controller=\"CompaniesRecordController\"><form name=\"form\" novalidate flex layout=\"column\" ng-disabled=\"F.readMode\">\n<div fb-crud-detail-bar></div><md-content layout=\"column\" class=\"content\" flex><md-tabs md-selected=\"selectedTab\" flex \nlayout-fill><md-tab label=\"info\"><md-tab-body><div class=\"detail-form-container md-background-bg md-whiteframe-1dp\">\n<div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex><label>Nombre Corto</label><input \nng-disabled=\"F.readMode\" unique-fb ref=\"{{F.active.menuRef}}\" query=\"data/name\" fromid=\"{{companiesRecord.$id}}\" \nms2-autofocus class=\"uppercased\" ng-model-options=\"{ debounce: F.debounceTime }\" type=\"text\" name=\"name\" \nng-model=\"companiesRecord.data.name\" md-maxlength=\"20\" maxlength=\"20\" required><div ng-messages=\"form.name.$error\" \nng-show=\"form.name.$touched || form.name.$dirty\" role=\"alert\"><div ng-message=\"required\">Nombre Corto es requerido\n</div><div ng-message=\"maxlength\">Nombre Corto no debe tener más de 20 caracteres</div><div ng-message=\"unique\">\nNombre Corto ya está registrado</div></div></md-input-container></div><div layout-gt-xs=\"row\"><md-input-container \nclass=\"md-block\" flex-gt-xs=\"70\"><label>Razón Social</label><input ng-disabled=\"F.readMode\" class=\"uppercased\" \nng-model-options=\"{ debounce: F.debounceTime }\" \nng-change=\"setSocietyType(companiesRecord.data.onlyName, companiesRecord.data.societyType)\" type=\"text\" \nname=\"onlyName\" md-maxlength=\"150\" maxlength=\"150\" ng-model=\"companiesRecord.data.onlyName\" required><div \nng-messages=\"form.onlyName.$error\" ng-show=\"form.onlyName.$touched || form.onlyName.$dirty\" role=\"alert\"><div \nng-message=\"required\">Razón Social es requerido</div><div ng-message=\"maxlength\">\nRazón Social no debe tener más de 150 caracteres</div></div></md-input-container><md-input-container class=\"md-block\" \nflex-gt-xs=\"30\" ng-if=\"(!companiesRecord.data.legalPerson)\"><label>Tipo de Sociedad</label><md-select \nng-disabled=\"F.readMode\" name=\"societyType\" \nng-change=\"setSocietyType(companiesRecord.data.onlyName, companiesRecord.data.societyType)\" \nng-model=\"companiesRecord.data.societyType\" required><md-select-header><input autocomplete=\"off\" type=\"search\" \nclass=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"societyTypesSelectFilter\" \nplaceholder=\"Busque un tipo de sociedad\"></md-select-header><md-option ng-value=\"societyType.name\" \nng-repeat=\"societyType in M.societyTypes | orderBy:\'name\' | filter:societyTypesSelectFilter\">{{societyType.name}}\n</md-option></md-select><div ng-messages=\"form.societyType.$error\" \nng-show=\"form.societyType.$touched || form.societyType.$dirty\" role=\"alert\"><div ng-message=\"required\">\nTipo de sociedad es requerido</div></div></md-input-container></div><div layout=\"row\" layout-xs=\"column\">\n<md-input-container class=\"md-block mb-0\" flex><label>RFC</label><input ng-disabled=\"F.readMode\" rfc unique-fb \nref=\"{{F.active.menuRef}}\" query=\"data/rfc\" fromid=\"{{companiesRecord.$id}}\" type=\"text\" md-maxlength=\"13\" \nmaxlength=\"13\" name=\"rfc\" ng-model=\"companiesRecord.data.rfc\" required><div ng-messages=\"form.rfc.$error\" \nng-show=\"form.rfc.$touched || form.rfc.$dirty\" role=\"alert\"><div ng-message=\"rfc\">RFC no tiene un formato válido</div>\n<div ng-message=\"required\">RFC es requerido</div><div ng-message=\"unique\">RFC ya está registrado</div></div>\n</md-input-container><md-input-container ng-if=\"companiesRecord.data.legalPerson\" class=\"md-block mb-0\" flex><label>\nCURP</label><input ng-disabled=\"F.readMode\" class=\"uppercased\" curp unique-fb \nref=\"catalogs/companiesRecords/collection\" query=\"data/curp\" fromid=\"{{companiesRecord.$id}}\" type=\"text\" name=\"curp\" \nng-model=\"companiesRecord.data.curp\" maxlength=\"18\" md-maxlength=\"18\" required><div ng-messages=\"form.curp.$error\" \nrole=\"alert\"><div ng-message=\"curp\">CURP no tiene un formato válido</div><div ng-message=\"curpDigit\">\nCURP no tiene un formato válido, revisé el dígito verificador</div><div ng-message=\"required\">CURP es requerido</div>\n<div ng-message=\"unique\">CURP ya está registrado</div></div></md-input-container></div><md-input-container \nclass=\"md-block mt-0\"><md-switch class=\"md-primary mt-0\" name=\"legalPerson\" \nng-change=\"isLegalPerson(companiesRecord.data.legalPerson)\" ng-model=\"companiesRecord.data.legalPerson\">Persona Física\n</md-switch></md-input-container><md-input-container class=\"md-block\"><label>Representante</label><input \nng-disabled=\"F.readMode\" class=\"uppercased\" ng-model-options=\"{ debounce: F.debounceTime }\" type=\"text\" \nname=\"representative\" md-maxlength=\"150\" maxlength=\"150\" ng-model=\"companiesRecord.data.representative\" required><div \nng-messages=\"form.representative.$error\" ng-show=\"form.representative.$touched || form.businessName.$dirty\" \nrole=\"alert\"><div ng-message=\"required\">Representante es requerido</div><div ng-message=\"maxlength\">\nRepresentante no debe tener más de 150 caracteres</div></div></md-input-container><md-input-container class=\"md-block\">\n<label>Representante2</label><input ng-disabled=\"F.readMode\" class=\"uppercased\" \nng-model-options=\"{ debounce: F.debounceTime }\" type=\"text\" name=\"representative2\" md-maxlength=\"150\" maxlength=\"150\" \nng-model=\"companiesRecord.data.representative2\"><div ng-messages=\"form.representative2.$error\" \nng-show=\"form.representative2.$touched || form.businessName.$dirty\" role=\"alert\"><div ng-message=\"maxlength\">\nRepresentante no debe tener más de 150 caracteres</div></div></md-input-container><md-input-container class=\"md-block\">\n<label>Régimen</label><md-select ng-disabled=\"F.readMode\" name=\"regime\" ng-model=\"companiesRecord.data.regime_id\">\n<md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" \nng-model=\"regimeSelectFilter\" placeholder=\"Busque un regimen\"></md-select-header><md-option ng-value=\"regime._id\" \nng-repeat=\"regime in M.regimes | orderBy:\'name\' | filter:regimeSelectFilter\">{{regime.name}}</md-option></md-select>\n</md-input-container></div></md-tab-body></md-tab><md-tab label=\"domicilio\"><md-tab-body><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\"><div layout-gt-xs=\"row\"><md-input-container \nclass=\"md-block\" flex><label>Calle</label><input ng-disabled=\"F.readMode\" class=\"uppercased\" \nng-model-options=\"{ debounce: F.debounceTime }\" type=\"text\" md-maxlength=\"50\" maxlength=\"50\" name=\"street\" \nng-model=\"companiesRecord.data.location.street\" required><div ng-messages=\"form.street.$error\" \nng-show=\"form.street.$touched || form.street.$dirty\" role=\"alert\"><div ng-message=\"required\">Calle es requerido</div>\n<div ng-message=\"maxlength\">Calle no debe tener más de 50 caracteres</div></div></md-input-container>\n<md-input-container class=\"md-block\" flex=\"nogrow\"><label>No. Exterior</label><input ng-disabled=\"F.readMode\" \nclass=\"uppercased\" ng-model-options=\"{ debounce: F.debounceTime }\" type=\"text\" md-maxlength=\"20\" maxlength=\"20\" \nname=\"externalNumber\" ng-model=\"companiesRecord.data.location.externalNumber\" required><div \nng-messages=\"form.externalNumber.$error\" ng-show=\"form.externalNumber.$touched || form.externalNumber.$dirty\" \nrole=\"alert\"><div ng-message=\"required\">No. Exterior es requerido</div><div ng-message=\"maxlength\">\nNo. Exterior no debe tener más de 20 caracteres</div></div></md-input-container><md-input-container class=\"md-block\" \nflex=\"nogrow\"><label>No. Interior</label><input ng-disabled=\"F.readMode\" class=\"uppercased\" \nng-model-options=\"{ debounce: F.debounceTime }\" type=\"text\" md-maxlength=\"20\" maxlength=\"20\" name=\"internalNumber\" \nng-model=\"companiesRecord.data.location.internalNumber\"><div ng-messages=\"form.internalNumber.$error\" \nng-show=\"form.externalNumber.$touched || form.externalNumber.$dirty\" role=\"alert\"><div ng-message=\"maxlength\">\nNo. Interior no debe tener más de 20 caracteres</div></div></md-input-container></div><div layout-gt-xs=\"row\">\n<md-input-container class=\"md-block\" flex><label>Colonia</label><input ng-disabled=\"F.readMode\" class=\"uppercased\" \nng-model-options=\"{ debounce: F.debounceTime }\" type=\"text\" name=\"neighborhood\" md-maxlength=\"50\" maxlength=\"50\" \nng-model=\"companiesRecord.data.location.neighborhood\" required><div ng-messages=\"form.neighborhood.$error\" \nng-show=\"form.neighborhood.$touched || form.neighborhood.$dirty\" role=\"alert\"><div ng-message=\"required\">\nColonia es requerido</div><div ng-message=\"maxlength\">Colonia no debe tener más de 50 caracteres</div></div>\n</md-input-container><md-input-container class=\"md-block\" flex><label>Referencia</label><input \nng-disabled=\"F.readMode\" class=\"uppercased\" ng-model-options=\"{ debounce: F.debounceTime }\" type=\"text\" \nmd-maxlength=\"50\" maxlength=\"50\" name=\"reference\" ng-model=\"companiesRecord.data.location.reference\"><div \nng-messages=\"form.reference.$error\" ng-show=\"form.reference.$touched || form.reference.$dirty\" role=\"alert\"><div \nng-message=\"maxlength\">Referencia no debe tener más de 50 caracteres</div></div></md-input-container>\n<md-input-container class=\"md-block\" flex=\"nogrow\"><label>CP</label><input ng-disabled=\"F.readMode\" type=\"text\" \nmd-maxlength=\"5\" maxlength=\"5\" name=\"zipCode\" ng-model=\"companiesRecord.data.location.zipCode\" ng-pattern=\"/[0-9]{5}/\" \nrequired><div ng-messages=\"form.zipCode.$error\" \nng-show=\"(form.zipCode.$error && !form.zipCode.$pristine) || (form.zipCode.$error && companiesRecord.data.location.zipCode)\" \nrole=\"alert\"><div ng-message=\"required\">CP es requerido</div><div ng-message=\"pattern\">\nCP debe tener [5] números del (0-9)</div></div></md-input-container></div><div layout-gt-xs=\"row\"><md-input-container \nclass=\"md-block\" flex><label>País</label><md-select name=\"country_id\" ng-disabled=\"F.readMode\" \nng-model=\"companiesRecord.data.location.country_id\"><md-select-header><input name=\"country_id\" type=\"search\" \nclass=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"countrySelectFilter\" placeholder=\"Busque un país\">\n</md-select-header><md-option ng-value=\"country._id\" \nng-repeat=\"country in M.countriesRecords | orderBy:\'name\' | filter:countrySelectFilter\">{{country.name}}</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block\" flex><label>Estado</label><md-select \nng-disabled=\"F.readMode\" name=\"state_id\" ng-model=\"companiesRecord.data.location.state_id\" \nng-model-options=\"{ debounce: F.debounceTime }\"><md-select-header><input autocomplete=\"off\" type=\"search\" \nclass=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"stateSelectFilter\" placeholder=\"Busque un estado\">\n</md-select-header><md-option ng-value=\"state._id\" \nng-repeat=\"state in M.states | orderBy:\'name\' | filter:stateSelectFilter\">{{state.name}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" flex><label>Municipio</label><md-select \nng-disabled=\"F.readMode\" name=\"town_id\" ng-model=\"companiesRecord.data.location.town_id\"><md-select-header><input \nautocomplete=\"off\" type=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"townSelectFilter\" \nplaceholder=\"Busque un municipio\"></md-select-header><md-option ng-value=\"town._id\" \nng-repeat=\"town in M.towns | orderBy:\'name\' | filter:townSelectFilter\">{{town.name}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\"><label>Ciudad</label><input ng-disabled=\"F.readMode\" \nclass=\"uppercased\" ng-model-options=\"{ debounce: F.debounceTime }\" type=\"text\" md-maxlength=\"30\" maxlength=\"30\" \nname=\"city\" ng-model=\"companiesRecord.data.location.city\" required><div ng-messages=\"form.city.$error\" \nng-show=\"form.reference.$touched || form.reference.$dirty\" role=\"alert\"><div ng-message=\"required\">Ciudad es requerido\n</div><div ng-message=\"maxlength\">Ciudad no debe tener más de 30 caracteres</div></div></md-input-container></div>\n</div></md-tab-body></md-tab><md-tab ng-disabled=\"F.addMode\"><md-tab-label><span translate=\"companiesRecord.LOGO\">Logo\n</span></md-tab-label><md-tab-body><div class=\"detail-form-container md-background-bg md-whiteframe-1dp\"><div \nclass=\"upload-button\" layout=\"column\" layout-align=\"center center\"><h3 ng-hide=\"companiesRecord.logo\" \nclass=\"secondary-text\" translate=\"EC.UPLOAD_RULES\">Only PNG & JPG - Max. 2MB</h3><img ng-show=\"companiesRecord.logo\" \nng-src=\"{{companiesRecord.logo}}\" alt=\"Logo\"><lf-ng-md-file-input ng-show=\"!companiesRecord.logo\" lf-files=\"images\" \nng-disabled=\"F.readMode\" lf-placeholder=\"Imagen\" lf-drag-and-drop-label=\"{{\'EC.DROP_TO_UPLOAD\' | translate}}\" \nlf-browse-label=\"{{\'EC.SEARCH\' | translate}}\" lf-remove-label=\"{{\'EC.REMOVE\' | translate}}\" lf-filesize=\"2MB\" \nname=\"logo\" lf-api=\"imageApi\" progress preview drag></lf-ng-md-file-input><div ng-messages=\"form.logo.$error\" \nstyle=\"color:red\"><div ng-message=\"required\">This is required.</div><div ng-message=\"maxcount\">Too many files.</div>\n<div ng-message=\"filesize\">File size too large.</div><div ng-message=\"totalsize\">Total size too large.</div><div \nng-message=\"mimetype\">Mimetype error.</div></div></div></div></md-tab-body></md-tab><md-tab ng-disabled=\"F.addMode\">\n<md-tab-label><span>Certificados de Sello Digital (CSD)</span></md-tab-label><md-tab-body><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\"><div layout=\"row\" layout-wrap><h3 class=\"mb-0\" \nflex=\"nogrow\">Certificado (.cer)</h3><div flex ng-if=\"companiesRecord.cerFile\"><md-button \nng-click=\"downloadFile(companiesRecord.cerFile,\'cer\')\" aria-label=\" Download Cer\" \nclass=\"md-fab md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"top\">Descargar</md-tooltip><md-icon \nmd-font-icon=\"icon-download\" aria-label=\"Download\"></md-icon></md-button><md-button \nng-click=\"removeUpload(F.active.detailObject,\'cerFile\',true)\" aria-label=\"Eliminar Cer\" class=\"md-fab md-mini md-warn\">\n<md-tooltip md-direction=\"top\">Eliminar Archivo</md-tooltip><md-icon md-font-icon=\"icon-delete\" aria-label=\"Delete\">\n</md-icon></md-button><md-button ng-click=\"checkCertExpiration(companiesRecord.$id)\" \naria-label=\"Obtener Cer Validation Date\" class=\"md-fab md-mini md-primary md-hue-2\"><md-tooltip md-direction=\"top\">\nObtener fecha de expiración</md-tooltip><md-icon md-font-icon=\"icon-calendar\" aria-label=\"Calendar\"></md-icon>\n</md-button></div><div flex=\"100\" ng-show=\"!companiesRecord.cerFile\" layout=\"row\"><div flex><lf-ng-md-file-input \nname=\"cerFile\" lf-files=\"cerFile\" ng-change=\"analicesFile(\'csd\')\" \nlf-mimetype=\"application/x-x509-ca-cert|application/x-pkcs12 \" lf-placeholder=\"Seleccione su archivo .cer o .pfx\" \nlf-api=\"imageApi\" lf-browse-label=\"Seleccionar\" lf-filesize=\"5MB\" only-cer lf-remove-label=\"Quitar\">\n</lf-ng-md-file-input><div ng-messages=\"form.cerFile.$error\" style=\"color:red\"><div ng-message=\"filesize\">\nEl tamaño del archivo es muy grande.</div><div ng-message=\"mimetype\">El formato de archivo no coincide.</div></div>\n</div><div flex=\"nogrow\"><md-button ng-disabled=\"form.cerFile.$invalid || companiesRecord.saveFilesCsd\" \nng-click=\"uploadCerFile(cerFile)\" aria-label=\"Upload Cer\" class=\"md-fab md-mini md-accent md-hue-2\"><md-tooltip \nmd-direction=\"top\">Subir Archivo</md-tooltip><md-icon md-font-icon=\"icon-upload\" aria-label=\"Upload\"></md-icon>\n</md-button></div></div></div><div layout=\"row\" layout-wrap><h3 class=\"mb-0\" flex=\"nogrow\">Llave privada (.key)</h3>\n<div flex ng-if=\"companiesRecord.keyFile\"><md-button ng-click=\"downloadFile(companiesRecord.keyFile,\'key\')\" \naria-label=\" Download Key\" class=\"md-fab md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"top\">Descargar\n</md-tooltip><md-icon md-font-icon=\"icon-download\" aria-label=\"Download\"></md-icon></md-button><md-button \nng-click=\"removeUpload(F.active.detailObject,\'keyFile\',true)\" aria-label=\"Delete Cer\" class=\"md-fab md-mini md-warn\">\n<md-tooltip md-direction=\"top\">Eliminar Archivo</md-tooltip><md-icon md-font-icon=\"icon-delete\" aria-label=\"Delete\">\n</md-icon></md-button></div><div flex=\"100\" ng-show=\"!companiesRecord.keyFile\" layout=\"row\"><div flex>\n<lf-ng-md-file-input name=\"keyFile\" lf-files=\"keyFile\" ng-change=\"analicesFile(\'csd\')\" lf-api=\"imageApi\" \nlf-placeholder=\"Seleccione su archivo .key\" lf-filesize=\"5MB\" lf-remove-label=\"Quitar\" lf-browse-label=\"Seleccionar\" \nonly-key></lf-ng-md-file-input><div ng-messages=\"form.keyFile.$error\" style=\"color:red\"><div ng-message=\"filesize\">\nEl tamaño del archivo es muy grande.</div><div ng-message=\"mimetype\">El formato de archivo no coincide.</div></div>\n</div><div flex=\"nogrow\"><md-button ng-disabled=\"form.keyFile.$invalid || companiesRecord.saveFilesCsd\" \nng-click=\"upload(keyFile, F.active.detailObject, false, \'keyFile\', true)\" aria-label=\"Upload Cer\" \nclass=\"md-fab md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"top\">Subir Archivo</md-tooltip><md-icon \nmd-font-icon=\"icon-upload\" aria-label=\"Upload\"></md-icon></md-button></div></div></div><div layout=\"row\" layout-wrap>\n<h3 class=\"mb-0\" flex=\"nogrow\">Contraseña:</h3><div flex ng-if=\"companiesRecord.password\"><span \nclass=\"p-10 text-green\" style=\"color: green\" flex=\"nogrow\" ng-if=\"showPassword\">{{ companiesRecord.password }}</span>\n<md-button ng-if=\"verFielCsd\" ng-click=\"passwordVisibility()\" aria-label=\"ver pass\" class=\"md-fab md-mini md-success\">\n<md-tooltip md-direction=\"top\">{{ showApiKey ? \'Ocultar\' : \'Ver\' }} Contraseña</md-tooltip><md-icon \nmd-font-icon=\'{{ showApiKey ? \"icon-eye-off\" : \"icon-eye\" }}\' \naria-label=\'{{ showApiKey ? \"ocultar pass\" : \"ver pass\" }}\'></md-icon></md-button><md-button \nng-click=\"companiesRecord.password=undefined \" aria-label=\"Delete password\" class=\"md-fab md-mini md-warn\"><md-tooltip \nmd-direction=\"top\">Eliminar Archivo</md-tooltip><md-icon md-font-icon=\"icon-delete\" aria-label=\"Delete\"></md-icon>\n</md-button></div><div flex=\"100\" ng-show=\"!companiesRecord.password\" layout=\"row\"><div flex><md-input-container \nclass=\"md-block mt-0 no-errors-spacer\" md-no-float><input type=\"password\" name=\"companiesRecordPassword\" \nng-model=\"companiesRecordPassword\" placeholder=\"Ingresa la contraseña del archivo cer\" autocomplete=\"off\" \nng-required=\"companiesRecordPassword.cer\"><div ng-messages=\"form.companiesRecordPassword.$error\" role=\"alert\"><div \nng-message=\"required\">Contraseña es requerido</div></div></md-input-container></div><div flex=\"nogrow\"><md-button \nng-disabled=\"form.companiesRecordPassword.$invalid\" \nng-click=\"companiesRecord.password=companiesRecordPassword;companiesRecordPassword=undefined;analicesFile(\'csd\')\" \naria-label=\"Upload Cer\" class=\"md-fab md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"top\">Guardar</md-tooltip>\n<md-icon md-font-icon=\"icon-content-save\" aria-label=\"save\"></md-icon></md-button></div></div></div><div layout=\"row\">\n<div flex=\"100\" flex-gt-xs=\"50\"><h3 class=\"mb-0 mt-0\">Fecha de expiración</h3><md-input-container \nclass=\"md-block date-picker mt-0 mb-0 no-errors-spacer\" md-no-float><md-datepicker ng-disabled=\"F.readMode\" \nmd-hide-icons=\"triangle\" input-date-miliseconds \nng-change=\"setNotificationExpirationDate(companiesRecord.timePeriod,companiesRecord.expirationDate)\" \nmd-placeholder=\"Ingrese la fecha de expiración de los archivos\" ng-model=\"companiesRecord.expirationDate\" \nname=\"expirationDate\" ng-required=\"companiesRecordPassword.cer\"></md-datepicker><div \nng-messages=\"form.expirationDate.$error\" role=\"alert\"><div ng-message=\"required\">Fecha de Expiración es requerida</div>\n</div></md-input-container></div><div flex=\"100\" flex-gt-xs=\"50\"><h3 class=\"mb-0 mt-0\">\nConfigurar alerta de notificación</h3><md-input-container class=\"md-block mt-0 no-errors-spacer\" md-no-float><md-select\n placeholder=\"Seleccione una opción\" \nng-change=\"setNotificationExpirationDate(companiesRecord.timePeriod,companiesRecord.expirationDate)\" \nng-model=\"companiesRecord.timePeriod\" ng-disabled=\"!companiesRecord.expirationDate\"><md-option><em>No notificar</em>\n</md-option><md-option value=\"day\">1 dia antes</md-option><md-option value=\"week\">1 semana antes</md-option><md-option \nvalue=\"month\">1 mes antes</md-option></md-select></md-input-container></div></div><div \nng-if=\"companiesRecord.timePeriod\"><md-input-container class=\"md-block\"><label>Correos a Notificar</label><textarea \nng-model=\"companiesRecord.emailsToNotify\" \nplaceholder=\"Ingrese el correo al cual se enviara la notificación de la alerta, en caso de ser ingresar varios correos, separarlos por coma\" \nmd-maxlength=\"450\" rows=\"5\"></textarea></md-input-container></div></div></md-tab-body></md-tab><md-tab \nng-disabled=\"F.addMode\"><md-tab-label><span>Fiel</span></md-tab-label><md-tab-body><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\"><div layout=\"row\" layout-wrap><h3 class=\"mb-0\" \nflex=\"nogrow\">Certificado (.cer)</h3><div flex ng-if=\"companiesRecord.cerFiel\"><md-button \nng-click=\"downloadFile(companiesRecord.cerFiel,\'cer\')\" aria-label=\" Download Cer\" \nclass=\"md-fab md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"top\">Descargar</md-tooltip><md-icon \nmd-font-icon=\"icon-download\" aria-label=\"Download\"></md-icon></md-button><md-button \nng-click=\"removeUpload(F.active.detailObject,\'cerFiel\',true)\" aria-label=\"Eliminar Cer\" class=\"md-fab md-mini md-warn\">\n<md-tooltip md-direction=\"top\">Eliminar Archivo</md-tooltip><md-icon md-font-icon=\"icon-delete\" aria-label=\"Delete\">\n</md-icon></md-button></div><div flex=\"100\" ng-show=\"!companiesRecord.cerFiel\" layout=\"row\"><div flex>\n<lf-ng-md-file-input name=\"cerFiel\" only-cer lf-files=\"cerFiel\" ng-change=\"analicesFile(\'fiel\')\" \nlf-mimetype=\"application/x-x509-ca-cert\" lf-placeholder=\"Seleccione su archivo .cer\" lf-api=\"imageApi\" \nlf-browse-label=\"Seleccionar\" lf-filesize=\"5MB\" lf-remove-label=\"Quitar\"></lf-ng-md-file-input><div \nng-messages=\"form.cerFiel.$error\" style=\"color:red\"><div class=\"error\" ng-if=\"fiel.errors.cer\">{{fiel.errors.cer}}\n</div><div ng-message=\"filesize\">El tamaño del archivo es muy grande.</div><div ng-message=\"mimetype\">\nEl formato de archivo no coincide.</div></div></div><div flex=\"nogrow\"><md-button \nng-disabled=\"form.cerFiel.$invalid || companiesRecord.saveFilesFiel\" ng-click=\"uploadCerFiel(cerFiel)\" \naria-label=\"Upload Cer\" class=\"md-fab md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"top\">Subir Archivo\n</md-tooltip><md-icon md-font-icon=\"icon-upload\" aria-label=\"Upload\"></md-icon></md-button></div></div></div><div \nlayout=\"row\" layout-wrap><h3 class=\"mb-0\" flex=\"nogrow\">Llave privada (.key)</h3><div flex \nng-if=\"companiesRecord.keyFiel\"><md-button ng-click=\"downloadFile(companiesRecord.keyFiel,\'key\')\" \naria-label=\"Download Key\" class=\"md-fab md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"top\">Descargar\n</md-tooltip><md-icon md-font-icon=\"icon-download\" aria-label=\"Download\"></md-icon></md-button><md-button \nng-click=\"removeUpload(F.active.detailObject,\'keyFiel\',true)\" aria-label=\"Delete Cer\" class=\"md-fab md-mini md-warn\">\n<md-tooltip md-direction=\"top\">Eliminar Archivo</md-tooltip><md-icon md-font-icon=\"icon-delete\" aria-label=\"Delete\">\n</md-icon></md-button></div><div flex=\"100\" ng-show=\"!companiesRecord.keyFiel\" layout=\"row\"><div flex>\n<lf-ng-md-file-input name=\"keyFiel\" lf-files=\"keyFiel\" lf-api=\"imageApi\" accept=\".key\" \nng-change=\"analicesFile(\'fiel\')\" only-key lf-placeholder=\"Seleccione su archivo .key\" lf-filesize=\"5MB\" \nlf-remove-label=\"Quitar\" lf-browse-label=\"Seleccionar\"></lf-ng-md-file-input><div ng-messages=\"form.keyFiel.$error\" \nstyle=\"color:red\"><div class=\"error\" ng-if=\"fiel.errors.key\">{{fiel.errors.key}}</div><div ng-message=\"filesize\">\nEl tamaño del archivo es muy grande.</div><div ng-message=\"mimetype\">El formato de archivo no coincide.</div></div>\n</div><div flex=\"nogrow\"><md-button ng-disabled=\"form.keyFiel.$invalid || companiesRecord.saveFilesFiel\" \nng-click=\"upload(keyFiel, F.active.detailObject, false, \'keyFiel\', true)\" aria-label=\"Upload Cer\" \nclass=\"md-fab md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"top\">Subir Archivo</md-tooltip><md-icon \nmd-font-icon=\"icon-upload\" aria-label=\"Upload\"></md-icon></md-button></div></div></div><div layout=\"row\" layout-wrap>\n<h3 class=\"mb-0\" flex=\"nogrow\">Contraseña</h3><div flex ng-if=\"companiesRecord.passFiel\"><span class=\"p-10 text-green\" \nstyle=\"color: green\" flex=\"nogrow\" ng-if=\"showPasswordFiel\">{{ companiesRecord.passFiel }}</span><md-button \nwith-permission ng-if=\"verFielSat\" ng-click=\"passwordVisibilityFiel()\" aria-label=\"ver pass\" \nclass=\"md-fab md-mini md-success\"><md-tooltip md-direction=\"top\">{{ showPasswordFiel ? \'Ocultar\' : \'Ver\' }} Contraseña\n</md-tooltip><md-icon md-font-icon=\'{{ showPasswordFiel ? \"icon-eye-off\" : \"icon-eye\" }}\' \naria-label=\'{{ showPasswordFiel ? \"ocultar pass\" : \"ver pass\" }}\'></md-icon></md-button><md-button \nng-click=\"companiesRecord.passFiel=undefined\" aria-label=\"Delete password\" class=\"md-fab md-mini md-warn\"><md-tooltip \nmd-direction=\"top\">Eliminar Archivo</md-tooltip><md-icon md-font-icon=\"icon-delete\" aria-label=\"Delete\"></md-icon>\n</md-button></div><div flex=\"100\" ng-show=\"!companiesRecord.passFiel\" layout=\"row\"><div flex><md-input-container \nclass=\"md-block mt-0 no-errors-spacer\" md-no-float><input type=\"password\" name=\"companiesRecordPassField\" \nng-model=\"companiesRecordPassField\" placeholder=\"Ingresa la contraseña del archivo cer\" autocomplete=\"off\" \nng-required=\"companiesRecordPassField.cer\"><div ng-messages=\"form.companiesRecordPassField.$error\" role=\"alert\"><div \nng-message=\"required\">Contraseña es requerido</div></div></md-input-container></div><div flex=\"nogrow\"><md-button \nng-disabled=\"form.companiesRecordPassField.$invalid\" \nng-click=\"companiesRecord.passFiel=companiesRecordPassField;companiesRecordPassField=undefined;analicesFile(\'fiel\')\" \naria-label=\"Upload Cer\" class=\"md-fab md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"top\">Guardar</md-tooltip>\n<md-icon md-font-icon=\"icon-content-save\" aria-label=\"save\"></md-icon></md-button></div></div></div><div layout=\"row\">\n<div flex=\"100\" flex-gt-xs=\"50\"><h3 class=\"mb-0 mt-0\">Fecha de expiración</h3><md-input-container \nclass=\"md-block date-picker mt-0 mb-0 no-errors-spacer\" md-no-float><md-datepicker ng-disabled=\"F.readMode\" \nmd-hide-icons=\"triangle\" input-date-miliseconds \nng-change=\"setNotificationExpirationDateFiel(companiesRecord.timePeriodFiel,companiesRecord.expirationDateFiel)\" \nmd-placeholder=\"Ingrese la fecha de expiración de los archivos\" ng-model=\"companiesRecord.expirationDateFiel\" \nname=\"expirationDateFiel\" ng-required=\"companiesRecordPassword.cer\"></md-datepicker><div \nng-messages=\"form.expirationDateFiel.$error\" role=\"alert\"><div ng-message=\"required\">Fecha de Expiración es requerida\n</div></div></md-input-container></div><div flex=\"100\" flex-gt-xs=\"50\"><h3 class=\"mb-0 mt-0\">\nConfigurar alerta de notificación</h3><md-input-container class=\"md-block mt-0 no-errors-spacer\" md-no-float><md-select\n placeholder=\"Seleccione una opción\" \nng-change=\"setNotificationExpirationDateFiel(companiesRecord.timePeriodFiel,companiesRecord.expirationDateFiel)\" \nng-model=\"companiesRecord.timePeriodFiel\" ng-disabled=\"!companiesRecord.expirationDateFiel\"><md-option><em>No notificar\n</em></md-option><md-option value=\"day\">1 dia antes</md-option><md-option value=\"week\">1 semana antes</md-option>\n<md-option value=\"month\">1 mes antes</md-option></md-select></md-input-container></div></div><div \nng-if=\"companiesRecord.timePeriodFiel\"><md-input-container class=\"md-block\"><label>Correos a Notificar</label><textarea\n ng-model=\"companiesRecord.emailsToNotifyFiel\" \nplaceholder=\"Ingrese el correo al cual se enviara la notificación de la alerta, en caso de ser ingresar varios correos, separarlos por coma\" \nmd-maxlength=\"450\" rows=\"5\"></textarea></md-input-container></div></div></md-tab-body></md-tab><div \nng-if=\"fiel._validating\">Validando…</div><div class=\"error\" ng-if=\"fiel.errors.submit\">{{fiel.errors.submit}}</div>\n<md-tab label=\"configuración\" ng-disabled=\"F.addMode\"><md-tab-body><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\"><div layout=\"row\" with-permission \naction=\"uploadSignature\" access=\"{{F.active.menuItem}}\" layout-align=\"start center\"><h3 flex=\"nogrow\">\nFirma digitalizada (.png)</h3><div flex ng-if=\"companiesRecord.signFile\"><md-button \nng-click=\"downloadFile(companiesRecord.signFile,\'png\')\" aria-label=\" Download Key\" \nclass=\"md-fab md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"top\">Descargar</md-tooltip><md-icon \nmd-font-icon=\"icon-download\" aria-label=\"Download\"></md-icon></md-button><md-button \nng-click=\"removeUpload(F.active.detailObject,\'signFile\',true)\" aria-label=\"Delete Cer\" class=\"md-fab md-mini md-warn\">\n<md-tooltip md-direction=\"top\">Eliminar Archivo</md-tooltip><md-icon md-font-icon=\"icon-delete\" aria-label=\"Delete\">\n</md-icon></md-button></div></div><div ng-show=\"!companiesRecord.signFile\" with-permission action=\"uploadSignature\" \naccess=\"{{F.active.menuItem}}\" layout=\"row\"><div flex><lf-ng-md-file-input name=\"signFile\" lf-files=\"signFile\" \nlf-mimetype=\"image/png\" lf-api=\"imageApi\" lf-placeholder=\"Seleccione su archivo .png\" lf-filesize=\"5MB\" \nlf-remove-label=\"Quitar\" lf-browse-label=\"Seleccionar\"></lf-ng-md-file-input><div ng-messages=\"form.signFile.$error\" \nstyle=\"color:red\"><div ng-message=\"filesize\">El tamaño del archivo es muy grande.</div><div ng-message=\"mimetype\">\nEl formato de archivo no coincide.</div></div></div><div flex=\"nogrow\"><md-button ng-disabled=\"form.signFile.$invalid\" \nng-click=\"upload(signFile, F.active.detailObject, false, \'signFile\',true)\" aria-label=\"Upload Cer\" \nclass=\"md-fab md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"top\">Subir Archivo</md-tooltip><md-icon \nmd-font-icon=\"icon-upload\" aria-label=\"Upload\"></md-icon></md-button></div></div><md-list><md-list-item><md-icon \nmd-font-icon=\"icon-clipboard-check\"></md-icon><p>Activo</p><md-switch ng-disabled=\"F.readMode\" class=\"md-secondary\" \nname=\"active\" ng-change=\"disable(companiesRecord.$id, companiesRecord.data.name)\" ng-model=\"companiesRecord.active\">\n</md-switch></md-list-item></md-list></div></md-tab-body></md-tab><md-tab label=\"Campos extras\" \nng-disabled=\"F.addMode\"><md-tab-body><div class=\"detail-form-container md-background-bg md-whiteframe-1dp\">\n<md-input-container class=\"md-block\" flex><label>Clave de contribuyente declarante</label><input \nng-disabled=\"F.readMode\" ref=\"{{F.active.menuRef}}\" query=\"data/codeDeclarant\" ms2-autofocus class=\"uppercased\" \nng-model-options=\"{ debounce: F.debounceTime }\" type=\"text\" name=\"codeDeclarant\" \nng-model=\"companiesRecord.data.codeDeclarant\" md-maxlength=\"10\" maxlength=\"10\"></md-input-container></div>\n</md-tab-body></md-tab></md-tabs></md-content></form></div>");
$templateCache.put("app/main/clients/views/companies-records/companies-records.html","<div id=\"companiesRecords\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div fb-search-bar></div><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><div \nfilter-toolbar></div><div table-loader array=\"companiesRecords\" validations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"companiesRecords.length\"><thead md-head \nmd-order=\"order\" fix-head><tr md-row><th md-column><span>Logo</span></th><th md-column md-order-by=\"data.name\"><span>\nNombre Corto</span></th><th md-column md-order-by=\"data.rfc\"><span>RFC</span></th><th md-column \nmd-order-by=\"data.location.city\">Ciudad</th><th md-column md-order-by=\"active\"><span>Activo</span></th></tr></thead>\n<tbody md-body><tr md-row md-auto-select md-select=\"companiesRecord\" md-select-id=\"$id\" \nng-repeat=\"companiesRecord in (F.filteredItems = (Z.companiesRecords | searchSpecific:F.searchText.companiesRecord:fixedFieldsSearch)) | limitTo: F.paginate : (currentPage - 1) * F.paginate\">\n<td md-cell><img ng-if=\"companiesRecord.logo\" class=\"thumb-image\" ng-src=\"{{companiesRecord.logo}}\"> <img \nng-if=\"!companiesRecord.logo\" class=\"thumb-image\" ng-src=\"{{F.imagePlaceholder}}\"></td><td md-cell>\n{{companiesRecord.data.name}}</td><td md-cell>{{companiesRecord.data.rfc}}</td><td md-cell>\n{{companiesRecord.data.location.city}}</td><td md-cell><div layout=\"row\" layout-align=\"start center\"><active-indicator \nactive=\"companiesRecord.active\"></active-indicator></div></td></tr></tbody></table></md-table-container>\n<md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" \nng-show=\"companiesRecords.length\" md-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" \nmd-limit-options=\"F.paginations\" md-page=\"currentPage\" md-on-paginate=\"restartSelected\" \nmd-total=\"{{F.filteredItems.length}}\" md-page-select></md-table-pagination></div></div><md-fab-speed-dial \nmd-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\"><md-fab-trigger>\n<md-button aria-label=\"crud menu\" class=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon>\n</md-button></md-fab-trigger><md-fab-actions><md-button with-permission action=\"read\" access=\"{{F.active.menuItem}}\" \nng-if=\"selected.length == 1\" ng-click=\'R.goToDetail(null, \"read\", {companiesRecordId: selected[0].$id})\' \naria-label=\"view\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Ver</md-tooltip>\n<md-icon md-font-icon=\"icon-eye\" aria-label=\"view\"></md-icon></md-button><md-button with-permission action=\"export\" \naccess=\"{{F.active.menuItem}}\" ng-click=\"exportDataToExcel(F.filteredItems,null,currentPage,F.paginate)\" \naria-label=\"export\" class=\"md-fab md-raised md-mini md-primary md-hue-2\"><md-tooltip md-direction=\"left\">\nExportar a excel</md-tooltip><md-icon md-font-icon=\" icon-file-excel\" aria-label=\"export\"></md-icon></md-button>\n<md-button with-permission action=\"update\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" \nng-click=\'R.goToDetail(null, \"update\", {companiesRecordId: selected[0].$id})\' aria-label=\"edit\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Editar</md-tooltip><md-icon \nmd-font-icon=\"icon-pencil\" aria-label=\"edit\"></md-icon></md-button><md-button with-permission action=\"remove\" \naccess=\"{{F.active.menuItem}}\" ng-if=\"selected.length\" ng-click=\"delete($event)\" aria-label=\"Delete\" \nclass=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">{{\'EC.REMOVE\' | translate}}</md-tooltip>\n<md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button><md-button with-permission \naction=\"create\" access=\"{{F.active.menuItem}}\" ng-if=\"!selected.length\" \nng-click=\'R.goToDetail(null, \"update\", {companiesRecordId: \"new\"})\' aria-label=\"add\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">{{\'EC.ADD\' | translate}}\n</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon></md-button></md-fab-actions>\n</md-fab-speed-dial></div></div>");
$templateCache.put("app/main/clients/views/dashboard/dashboard.html","<div id=\"dashboard-clients\" class=\"page-layout blank\" layout=\"row\"><div class=\"center\" flex ms-scroll><div \nclass=\"content\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"true\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><md-select class=\"simplified font-size-16\" \nng-model=\"widget1.currentRange\" aria-label=\"Change range\"><md-option ng-repeat=\"(key, range) in widget1.ranges\" \nvalue=\"{{key}}\">{{range}}</md-option></md-select><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\">\n<md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details</md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item>\n</md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"light-blue-fg font-size-72 line-height-72\">{{widget1.data.count[widget1.currentRange]}}%</div><div \nclass=\"h3 secondary-text font-weight-500\">{{widget1.data.label}}</div></div><div class=\"p-16 grey-50-bg border-top\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">{{widget1.data.extra.label}}:\n</span> <span class=\"h4 ml-8\">{{widget1.data.extra.count[widget1.currentRange]}}</span></div></ms-widget-front>\n<ms-widget-back class=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" \nng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button>\n</div><div>{{widget1.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">{{widget2.title}}</div><md-menu><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh\n</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"red-fg font-size-72 line-height-72\">${{widget2.data.count}}</div><div \nclass=\"h3 secondary-text font-weight-500\">{{widget2.data.label}}</div></div><div class=\"p-16 grey-50-bg border-top\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">{{widget2.data.extra.label}}:\n</span> <span class=\"h4 ml-8\">${{widget2.data.extra.count}}</span></div></ms-widget-front><ms-widget-back \nclass=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" \naria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>\n{{widget2.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">{{widget3.title}}</div><md-menu><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh\n</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"orange-fg font-size-72 line-height-72\">{{widget3.data.count}}</div><div \nclass=\"h3 secondary-text font-weight-500\">{{widget3.data.label}}</div></div><div class=\"p-16 grey-50-bg border-top\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">{{widget3.data.extra.label}}:\n</span> <span class=\"h4 ml-8\">{{widget3.data.extra.count}}</span></div></ms-widget-front><ms-widget-back \nclass=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" \naria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>\n{{widget3.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">{{widget4.title}}</div><md-menu><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh\n</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"blue-grey-fg font-size-72 line-height-72\">${{widget4.data.count}}</div><div \nclass=\"h3 secondary-text font-weight-500\">{{widget4.data.label}}</div></div><div class=\"p-16 grey-50-bg border-top\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">{{widget4.data.extra.label}}:\n</span> <span class=\"h4 ml-8\">${{widget4.data.extra.count}}</span></div></ms-widget-front><ms-widget-back \nclass=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" \naria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>\n{{widget4.detail}}</div></ms-widget-back></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" \nlayout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 pv-8 border-bottom\" \nlayout=\"row\" layout-align=\"space-between center\" layout-wrap><div class=\"pv-8 h3\">{{widget5.title}}</div><div \nclass=\"pv-8\" layout=\"row\" layout-align=\"start center\" layout-align-sm=\"end\" flex-sm=\"100\"><md-button class=\"ph-16\" \nng-repeat=\"(key, range) in widget5.ranges\" ng-click=\"widget5.changeRange(key)\" \nng-disabled=\"widget5.currentRange == key\">{{range}}</md-button></div></div><div class=\"p-16\"><nvd3 \nclass=\"h-420 remove-x-lines\" config=\"widget5.mainChart.config\" options=\"widget5.mainChart.options\" \ndata=\"widget5.mainChart.data\"></nvd3></div></ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" \nflex=\"100\" layout-wrap><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{widget6.title}}</div>\n<div class=\"pv-16\"><md-select class=\"simplified\" ng-model=\"widget6.currentRange\" \nng-change=\"widget6.changeRange(widget6.currentRange)\" aria-label=\"Change range\"><md-option \nng-repeat=\"(key, range) in widget6.ranges\" value=\"{{key}}\">{{range}}</md-option></md-select></div></div><div \nclass=\"p-16\"><nvd3 class=\"h-400\" config=\"widget6.mainChart.config\" options=\"widget6.mainChart.options\" \ndata=\"widget6.mainChart.data\"></nvd3></div><div class=\"pv-8 mh-16 border-top\" layout=\"row\" layout-align=\"start center\" \nlayout-wrap><div class=\"pv-8 border-right\" layout=\"column\" layout-align=\"center center\" flex=\"100\" flex-gt-xs=\"50\">\n<span class=\"font-size-32\">{{widget6.footerLeft.count[widget6.currentRange]}}</span> <span class=\"h4\">\n{{widget6.footerLeft.title}}</span></div><div class=\"pv-8\" layout=\"column\" layout-align=\"center center\" flex=\"100\" \nflex-gt-xs=\"50\"><span class=\"font-size-32\">{{widget6.footerRight.count[widget6.currentRange]}}</span> <span class=\"h4\">\n{{widget6.footerRight.title}}</span></div></div></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">{{widget7.title}}</div><div class=\"pv-16\"><md-select \nclass=\"simplified\" ng-model=\"widget7.currentRange\" aria-label=\"Change range\"><md-option \nng-repeat=\"(key, range) in widget7.ranges\" value=\"{{key}}\">{{range}}</md-option></md-select></div></div><div \nclass=\"p-16\" layout=\"row\" layout-align=\"space-between center\" \nng-repeat=\"customer in widget7.customers[widget7.currentRange]\"><div><div class=\"h3\">{{customer.name}}</div><span \nng-if=\"customer.location\">{{customer.location}}</span></div><md-button class=\"md-icon-button\" \naria-label=\"More information\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></div></ms-widget-front>\n</ms-widget></div></div></div></div>");
$templateCache.put("app/main/clients/views/departments/department.html","<div id=\"department\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill><form name=\"form\" \nnovalidate flex layout=\"column\" ng-disabled=\"F.readMode\"><div fb-crud-detail-bar></div><md-content layout=\"column\" \nclass=\"content\" flex><div class=\"detail-form-container md-background-bg md-whiteframe-1dp\"><div layout-gt-xs=\"row\">\n<md-input-container class=\"md-block\" flex><label>Nómina</label><md-select ng-disabled=\"F.readMode\" \nng-model=\"department.payroll\" name=\"payroll\" required><md-select-header><input type=\"text\" \nng-keydown=\"$event.stopPropagation()\" ng-model=\"payrollSelectFilter\" placeholder=\"Busque una nomina\">\n</md-select-header><md-option ng-if=\"!F.permissionToAccessAllPayrolls\" ng-value=\"payroll.$id\" \nng-disabled=\"!payroll.active\" ng-repeat=\"payroll in L.payrolls | orderBy:\'name\' | filter:payrollSelectFilter\">\n{{payroll.class}} {{payroll.name}}</md-option><md-option ng-if=\"F.permissionToAccessAllPayrolls\" \nng-value=\"payroll.$id\" ng-disabled=\"!payroll.active\" \nng-repeat=\"payroll in L.allPayrolls | orderBy:\'name\' | filter:payrollSelectFilter\">{{payroll.class}} {{payroll.name}}\n</md-option></md-select><div ng-messages=\"form.payroll.$error\" ng-show=\"form.payroll.$touched || form.payroll.$dirty\" \nrole=\"alert\"><div ng-message=\"required\">Nómina es requerido</div></div></md-input-container></div><div \nlayout-gt-xs=\"row\"><md-input-container flex class=\"md-block\"><label>Departamento</label><input \nng-disabled=\"F.readMode\" unique-fb ref=\'{{\"lists/departments/payroll/\" + department.payroll}}\' query=\"name\" \nfromid=\"{{department.$id}}\" class=\"uppercased\" ng-model-options=\"{ debounce: F.debounceTime }\" type=\"text\" name=\"name\" \nng-model=\"department.data.name\" md-maxlength=\"60\" maxlength=\"60\" required><div ng-messages=\"form.name.$error\" \nng-show=\"form.name.$touched || form.name.$dirty\" role=\"alert\"><div ng-message=\"required\">Departamento es requerido\n</div><div ng-message=\"maxlength\">Departamento no debe tener más de 60 caracteres</div><div ng-message=\"unique\">\nDepartamento ya está registrado en Nómina</div></div></md-input-container></div></div></md-content></form></div>");
$templateCache.put("app/main/clients/views/departments/departments.html","<div id=\"departments\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div fb-search-bar></div><div class=\"content-card\" layout=\"column\" flex>\n<div class=\"content fullpage-datatable\" layout=\"column\" flex><div filter-toolbar></div><div with-permission \nng-model=\"haveP\" action=\"update\" access=\"{{F.active.menuItem}}\"></div><div table-loader array=\"departments\" \nvalidations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"departments.length\"><thead md-head md-order=\"order\" \nfix-head><tr md-row><th md-column md-order-by=\"payroll\"><span>Nómina</span></th><th md-column md-order-by=\"data.name\">\n<span>Puesto</span></th></tr></thead><tbody md-body><tr md-row md-auto-select md-select=\"department\" \nmd-select-id=\"$id\" \nng-repeat=\"department in (F.filteredItems = (Z.departments | searchSpecific:F.searchText.department:fixedFieldsSearch | orderBy:order)) | limitTo: F.paginate: (currentPage - 1) * F.paginate\">\n<td md-cell>{{department.payroll | nameOfL:L.allPayrolls:\'N/A\'}}</td><td md-cell>{{department.data.name}}</td></tr>\n</tbody></table></md-table-container><md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" \nlayout-xs=\"column\" ng-show=\"departments.length\" md-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" \nmd-limit-options=\"F.paginations\" md-page=\"currentPage\" md-on-paginate=\"restartSelected\" \nmd-total=\"{{F.filteredItems.length}}\" md-page-select></md-table-pagination></div></div><md-fab-speed-dial \nmd-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\"><md-fab-trigger>\n<md-button aria-label=\"crud menu\" class=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon>\n</md-button></md-fab-trigger><md-fab-actions><md-button with-permission action=\"export\" access=\"{{F.active.menuItem}}\" \nng-click=\"exportDataToExcel(F.filteredItems,F.active.menuName,currentPage,F.paginate)\" aria-label=\"export\" \nclass=\"md-fab md-raised md-mini md-primary md-hue-2\"><md-tooltip md-direction=\"left\">Exportar a excel</md-tooltip>\n<md-icon md-font-icon=\" icon-file-excel\" aria-label=\"export\"></md-icon></md-button><md-button with-permission \naction=\"read\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" \nng-click=\'R.goToDetail(null, \"read\", {departmentId: selected[0].$id, payrollId: selected[0].payroll})\' \naria-label=\"view\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Ver</md-tooltip>\n<md-icon md-font-icon=\"icon-eye\" aria-label=\"view\"></md-icon></md-button><md-button with-permission action=\"update\" \naccess=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" \nng-click=\'R.goToDetail(null, \"update\", {departmentId: selected[0].$id, payrollId: selected[0].payroll})\' \naria-label=\"edit\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Editar\n</md-tooltip><md-icon md-font-icon=\"icon-pencil\" aria-label=\"edit\"></md-icon></md-button><md-button with-permission \naction=\"remove\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length\" ng-click=\"delete($event)\" aria-label=\"Delete\" \nclass=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">{{\'EC.REMOVE\' | translate}}</md-tooltip>\n<md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button><md-button with-permission \naction=\"create\" access=\"{{F.active.menuItem}}\" ng-if=\"!selected.length\" \nng-click=\'R.goToDetail(null, \"update\", {departmentId: \"new\"})\' aria-label=\"add\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">{{\'EC.ADD\' | translate}}\n</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon></md-button></md-fab-actions>\n</md-fab-speed-dial></div></div>");
$templateCache.put("app/main/clients/views/firms/authTokenCreate.html","<md-dialog id=\"auth-token-create-dialog\" aria-label=\"Crear token de acceso\"><md-toolbar><div class=\"md-toolbar-tools\">\n<span class=\"title\" ng-if=\"view === \'form\' && tokenScope.name\">Crear token para {{tokenScope.name}}</span> <span \nclass=\"title\" ng-if=\"view === \'form\' && !tokenScope.name\">Crear token de acceso</span> <span class=\"title\" \nng-if=\"view === \'secret\'\">Guarde su token</span><div flex></div><md-button class=\"md-icon-button\" \nng-if=\"view === \'form\' || secretHandled\" ng-click=\"cancel()\" aria-label=\"Cerrar\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><form name=\"tokenForm\" novalidate ng-submit=\"createToken(tokenForm)\">\n<md-dialog-content class=\"auth-tokens-content\"><div ng-if=\"view === \'form\'\"><md-input-container \nclass=\"md-block no-errors-spacer\"><label>Nombre</label><input name=\"name\" ng-model=\"tokenData.name\" required \nminlength=\"3\" maxlength=\"80\"><div ng-messages=\"tokenForm.name.$error\" role=\"alert\"><div ng-message=\"required\">\nEl nombre es requerido.</div><div ng-message=\"minlength\">Use al menos 3 caracteres.</div><div ng-message=\"maxlength\">\nUse máximo 80 caracteres.</div></div></md-input-container><md-input-container class=\"md-block\"><label>Tipo</label>\n<md-select ng-model=\"tokenData.type\" required><md-option value=\"permanent\">Permanente</md-option><md-option \nvalue=\"temporal\">Temporal</md-option></md-select></md-input-container><md-input-container class=\"md-block\"><label>\nModo de permisos</label><md-select name=\"permissionMode\" ng-model=\"tokenData.permissionMode\" required><md-option \nvalue=\"all\">Todos los permisos actuales</md-option><md-option value=\"selected\">Seleccionar permisos</md-option>\n</md-select></md-input-container><div class=\"permission-selector\" ng-if=\"tokenData.permissionMode === \'selected\'\"><div \nlayout=\"row\" layout-align=\"space-between center\"><md-input-container class=\"md-block permission-section-select\" flex>\n<label>Sección</label><md-select ng-model=\"permissionUi.selectedSection\" ng-disabled=\"!permissionSections.length\">\n<md-option ng-repeat=\"section in permissionSections track by section.key\" ng-value=\"section.key\">{{section.name}}\n</md-option></md-select></md-input-container><span flex=\"nogrow\" class=\"secondary-text permission-count\">\n{{tokenData.permissions.length}} permisos seleccionados</span></div><div class=\"permission-modules\"><md-card \nclass=\"permission-module-card\" ng-repeat=\"module in getSelectedPermissionSection().moduleList track by module.key\">\n<md-card-title><md-card-title-text><span class=\"md-title\">{{module.name}}</span></md-card-title-text><md-checkbox \naria-label=\"Seleccionar todos los permisos de {{module.name}}\" ng-checked=\"getModuleSelectionState(module).checked\" \nmd-indeterminate=\"getModuleSelectionState(module).indeterminate\" ng-click=\"toggleModulePermissions(module)\">\n</md-checkbox></md-card-title><md-divider></md-divider><md-card-content><md-checkbox class=\"permission-action\" \nng-repeat=\"permission in module.permissions track by permission.key\" ng-checked=\"isPermissionSelected(permission.key)\" \nng-click=\"togglePermission(permission.key)\"><span>{{permission.name}}</span> <small>{{permission.key}}</small>\n</md-checkbox></md-card-content></md-card></div><div class=\"permission-validation\" \nng-if=\"tokenForm.$submitted && !tokenData.permissions.length\" role=\"alert\">Seleccione al menos un permiso.</div><p \nclass=\"secondary-text\" ng-if=\"!availablePermissions.length\">\nNo tiene permisos seleccionables. Use “Todos los permisos actuales” o solicite acceso.</p></div><div \nclass=\"advanced-configuration\"><md-button type=\"button\" class=\"advanced-configuration-toggle\" \nng-click=\"toggleAdvancedConfiguration()\" aria-expanded=\"{{showAdvancedConfiguration}}\"><md-icon \nmd-font-icon=\"{{showAdvancedConfiguration ? \'icon-chevron-up\' : \'icon-chevron-down\'}}\"></md-icon>Configuración avanzada\n</md-button><md-divider></md-divider><div class=\"advanced-configuration-content\" ng-show=\"showAdvancedConfiguration\">\n<md-switch ng-model=\"tokenData.expires\">Definir fecha de expiración</md-switch><md-input-container \nclass=\"md-block date-picker no-errors-spacer\" ng-if=\"tokenData.expires\"><label>Expira el</label><md-datepicker \nname=\"expiresAt\" ng-model=\"tokenData.expiresAtDate\" md-min-date=\"minExpirationDate\" required></md-datepicker><div \nng-messages=\"tokenForm.expiresAt.$error\" role=\"alert\"><div ng-message=\"required\">Seleccione una fecha futura.</div><div\n ng-message=\"mindate\">La fecha debe ser futura.</div></div></md-input-container><md-input-container \nclass=\"md-block no-errors-spacer\"><label>IPs permitidas (una por línea)</label><textarea \nng-model=\"tokenData.allowedIpsText\" placeholder=\"192.168.1.5\" rows=\"2\"></textarea></md-input-container>\n<md-input-container class=\"md-block no-errors-spacer\"><label>Orígenes permitidos (uno por línea)</label><textarea \nng-model=\"tokenData.allowedOriginsText\" placeholder=\"tdsystem.software\" rows=\"2\"></textarea></md-input-container>\n<md-input-container class=\"md-block no-errors-spacer\"><label>Rutas restringidas (una por línea)</label><textarea \nng-model=\"tokenData.restrictUrlsText\" rows=\"2\" placeholder=\"/api/tasks&#10;/api/tasks/*\"></textarea>\n</md-input-container></div></div></div><div ng-if=\"view === \'secret\'\" class=\"auth-token-secret\"><md-icon \nmd-font-icon=\"icon-alert-circle\" class=\"auth-token-secret-icon\"></md-icon><h2>Este token se mostrará una sola vez</h2>\n<p>Copie o descargue el header antes de continuar. No podrá recuperarlo después.</p><md-input-container \nclass=\"md-block\"><label>Header Authorization</label><textarea readonly=\"readonly\" rows=\"3\" \nng-model=\"createdToken.authorizationHeader\"></textarea></md-input-container><div layout=\"row\" \nlayout-align=\"center center\" layout-wrap><md-button class=\"md-raised md-accent\" type=\"button\" ng-click=\"copySecret()\">\n<md-icon md-font-icon=\"icon-content-copy\"></md-icon>Copiar</md-button><md-button class=\"md-raised\" type=\"button\" \nng-click=\"downloadSecret()\"><md-icon md-font-icon=\"icon-download\"></md-icon>Descargar</md-button></div><p \nclass=\"auth-token-saved\" ng-if=\"secretHandled\">Ya puede cerrar esta pantalla de forma segura.</p></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\"><md-button ng-if=\"view === \'form\'\" \ntype=\"button\" ng-click=\"cancel()\" ng-disabled=\"saving\">Cancelar</md-button><md-button ng-if=\"view === \'form\'\" \ntype=\"submit\" class=\"md-raised md-accent\" \nng-disabled=\"tokenForm.$invalid || saving || (tokenData.permissionMode === \'selected\' && !tokenData.permissions.length)\">\n{{saving ? \'Creando…\' : \'Crear token\'}}</md-button><md-button ng-if=\"view === \'secret\'\" type=\"button\" \nclass=\"md-raised md-accent\" ng-click=\"cancel()\" ng-disabled=\"!secretHandled\">Continuar</md-button></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/clients/views/firms/authTokens.html","<div id=\"auth-tokens-tab\" ng-controller=\"AuthTokensController\"><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\"><div class=\"auth-token-header\" layout=\"row\" \nlayout-align=\"space-between center\" layout-wrap><div class=\"auth-token-header-copy\"><h2>{{authTokenTitle}}</h2><p \nclass=\"secondary-text\">{{authTokenDescription}} <strong ng-if=\"authTokenContext.type !== \'centerOnly\'\">\n{{firm.data.name}}.</strong> Los secretos existentes nunca se vuelven a mostrar.</p></div><div \nclass=\"auth-token-header-actions\" layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-icon-button auth-token-refresh\" ng-click=\"reloadAuthTokens()\" ng-disabled=\"authTokensLoading\" \naria-label=\"Recargar tokens\"><md-icon md-font-icon=\"icon-refresh\"></md-icon><md-tooltip>Recargar</md-tooltip>\n</md-button><md-button class=\"md-raised md-accent\" ng-click=\"openAuthTokenCreate($event)\" \nng-disabled=\"authTokensLoading || !canCreateTokenForFirm\">Crear token</md-button></div></div><div layout=\"row\" \nlayout-align=\"center center\" class=\"auth-token-loading\" ng-if=\"authTokensLoading\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><div class=\"auth-token-empty\" \nng-if=\"!authTokensLoading && !canCreateTokenForFirm\">No puede crear tokens para este alcance.</div><div \nclass=\"auth-token-empty\" ng-if=\"!authTokensLoading && canCreateTokenForFirm && !authTokens.length\">\nAún no hay tokens de acceso visibles.</div><md-table-container class=\"auth-token-table-container\" \nng-if=\"!authTokensLoading && authTokens.length\"><table md-table class=\"row-border auth-token-table\"><thead md-head><tr \nmd-row><th md-column>Propietario / token</th><th md-column>Permisos</th><th md-column>Restricciones</th><th md-column>\nExpiración</th><th md-column>Estado</th><th md-column></th></tr></thead><tbody md-body><tr md-row \nng-repeat=\"token in authTokens track by token.id\"><td md-cell><strong>{{token.name}}</strong><div>\n{{token.owner.name || token.owner.uid}}</div><small>{{token.tokenPreview}} · {{token.type}} · {{token.scopeType}}\n</small></td><td md-cell><div ng-if=\"token.permissionMode === \'all\'\">Todos los permisos actuales del propietario</div>\n<div ng-if=\"token.permissionMode === \'selected\' && token.permissions && token.permissions.length\"><span \nclass=\"auth-token-permission-chip\" ng-repeat=\"permissionKey in token.permissions track by permissionKey\">\n{{getAuthTokenPermissionName(permissionKey)}}</span></div><div \nng-if=\"token.permissionMode === \'selected\' && (!token.permissions || !token.permissions.length)\">\nSin permisos seleccionados</div></td><td md-cell><small ng-if=\"token.allowedIps && token.allowedIps.length\">\nIPs: {{token.allowedIps.join(\', \')}}</small> <small ng-if=\"token.allowedOrigins && token.allowedOrigins.length\">\nOrígenes: {{token.allowedOrigins.join(\', \')}}</small> <small ng-if=\"token.restrictUrls && token.restrictUrls.length\">\nRutas: {{token.restrictUrls.join(\', \')}}</small> <small \nng-if=\"(!token.allowedIps || !token.allowedIps.length) && (!token.allowedOrigins || !token.allowedOrigins.length) && (!token.restrictUrls || !token.restrictUrls.length)\">\nSin restricciones adicionales</small></td><td md-cell>\n{{token.expiresAt ? (token.expiresAt | date:\'dd/MM/yyyy\') : \'Sin expiración\'}}</td><td md-cell><span \nclass=\"auth-token-status\" ng-class=\"\'status-\' + (token.status | lowercase)\">{{getAuthTokenStatusName(token.status)}}\n</span></td><td md-cell><md-button class=\"md-icon-button md-warn\" ng-if=\"token.canRevoke\" \nng-click=\"revokeAuthToken(token, $event)\" ng-disabled=\"token.revoking\" aria-label=\"Revocar token\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon><md-tooltip>Revocar</md-tooltip></md-button></td></tr></tbody></table>\n</md-table-container></div></div>");
$templateCache.put("app/main/clients/views/firms/firm.html","<div id=\"firm\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill \nng-controller=\"FirmController\"><form name=\"form\" novalidate flex layout=\"column\" ng-disabled=\"F.readMode\"><div \nfb-crud-detail-bar></div><md-content layout=\"column\" class=\"content\" flex><md-tabs md-selected=\"selectedTab\" flex \nlayout-fill><md-tab label=\"info\"><md-tab-body><div class=\"detail-form-container md-background-bg md-whiteframe-1dp\">\n<md-input-container class=\"md-block mb-0\"><label>Nombre Corto</label><input ng-disabled=\"F.readMode\" unique-fb \nref=\"{{F.active.menuRef}}\" query=\"data/name\" fromid=\"{{firm.$id}}\" ms2-autofocus class=\"uppercased\" \nng-model-options=\"{ debounce: F.debounceTime }\" type=\"text\" name=\"name\" ng-model=\"firm.data.name\" md-maxlength=\"20\" \nmaxlength=\"20\" required><div ng-messages=\"form.name.$error\" ng-show=\"form.name.$touched || form.name.$dirty\" \nrole=\"alert\"><div ng-message=\"required\">Nombre de Cliente es requerido</div><div ng-message=\"maxlength\">\nNombre de Cliente no debe tener más de 20 caracteres</div><div ng-message=\"unique\">Nombre de Cliente ya está registrado\n</div></div></md-input-container><h3 class=\"mt-0 mb-0 text-bold\">TELÉFONOS<md-button class=\"md-icon-button\" \nng-click=\'addItem(\"phones\",{active:true})\' aria-label=\"Add phone\" ng-disabled=\"F.readMode\"><md-icon \nmd-font-icon=\"icon-plus\" aria-label=\"Add\"></md-icon></md-button></h3><div layout-gt-xs=\"row\" \nng-repeat=\"phone in firm.phones track by $index\"><ng-form name=\"phoneForm\" layout-gt-xs=\"row\" flex><md-input-container \nclass=\"md-block mb-0\" flex><label>Teléfono</label><input ng-disabled=\"F.readMode\" name=\"phone\" type=\"text\" \nng-model=\"phone.phone\" ng-pattern=\"/^[0-9]{10}$/\" md-maxlength=\"10\" maxlength=\"10\" required><div \nng-messages=\"phoneForm.phone.$error\" \nng-show=\"(phoneForm.phone.$error && !phoneForm.phone.$pristine) || (phoneForm.phone.$error && phone.phone)\" \nrole=\"alert\"><div ng-message=\"required\">Teléfono es requerido</div><div ng-message=\"pattern\">\nNo es un teléfono válido, debe contener 10 digitos (0-9)</div></div></md-input-container><md-input-container \nclass=\"md-block mb-0\" flex><label>Tipo</label><md-select name=\"phoneType\" ng-model=\"phone.type\" required \nng-disabled=\"F.readMode\"><md-option ng-value=\"phoneType\" ng-repeat=\"phoneType in F.contactTypes\">{{phoneType}}\n</md-option></md-select></md-input-container><div flex=\"nogrow\" layout=\"row\"><md-button \nng-click=\'removeItem($index,\"phones\")\' class=\"md-warn md-raised md-fab md-mini\" aria-label=\"Remove phone\" \nng-disabled=\"F.readMode || firm.phones.length==1\"><md-tooltip md-direction=\"left\">Borrar Teléfono</md-tooltip><md-icon \nmd-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button></div></ng-form></div><h3 \nclass=\"mt-0 mb-0 text-bold\">EMPRESAS<md-button class=\"md-icon-button\" \nng-click=\'addItem(\"companies\",{});setCompanySelected(firm.companies[firm.companies.length-1])\' \naria-label=\"Add company\" ng-disabled=\"F.readMode\"><md-icon md-font-icon=\"icon-plus\" aria-label=\"Add\"></md-icon>\n</md-button></h3><div class=\"animated\" ng-show=\"firm.companies && firm.companies.length>1\"><md-tabs class=\"md-primary\">\n<md-tab md-selected=\"selectedCompany\" md-autoselect=\"true\" md-on-select=\"setCompanySelected(company)\" \nng-repeat=\"($index,company) in firm.companies\"><md-tab-label>{{company.rfc||\'Nueva Empresa\'}} <button \nng-click=\"removeItem( $index,\'companies\');setLastCompany()\" class=\"md-icon-button\" aria-label=\"Delete\"><md-icon \nmd-font-icon=\"icon-trash\"></md-icon></button></md-tab-label></md-tab></md-tabs></div><div layout=\"row\" layout-wrap \nng-if=\"hasCompanySelected\"><md-input-container class=\"md-block\" flex=\"50\"><label>RFC</label><input \nng-disabled=\"F.readMode\" rfc type=\"text\" md-maxlength=\"13\" maxlength=\"13\" name=\"rfc\" ng-model=\"companySelected.rfc\" \nrequired><div ng-messages=\"form.rfc.$error\" ng-show=\"form.rfc.$touched || form.rfc.$dirty\" role=\"alert\"><div \nng-message=\"rfc\">RFC no tiene un formato válido</div><div ng-message=\"required\">RFC es requerido</div><div \nng-message=\"unique\">RFC ya está registrado</div></div></md-input-container><md-input-container class=\"md-block\" \nflex=\"50\"><label>Régimen</label><md-select ng-disabled=\"F.readMode\" name=\"regime\" ng-model=\"companySelected.regime_id\">\n<md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" \nng-model=\"regimeSelectFilter\" placeholder=\"Busque un regimen\"></md-select-header><md-option ng-value=\"regime._id\" \nng-repeat=\"regime in M.regimes | orderBy:\'name\' | filter:regimeSelectFilter\">{{regime.name}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" flex=\"100\"><label>Razón Social</label><input \nng-disabled=\"F.readMode\" class=\"uppercased\" ng-model-options=\"{ debounce: F.debounceTime }\" type=\"text\" \nname=\"businessName\" md-maxlength=\"150\" maxlength=\"150\" ng-model=\"companySelected.businessName\" required><div \nng-messages=\"form.businessName.$error\" ng-show=\"form.businessName.$touched || form.businessName.$dirty\" role=\"alert\">\n<div ng-message=\"required\">Razón social es requerido</div><div ng-message=\"maxlength\">\nRazón social no debe tener más de 150 caracteres</div></div></md-input-container><md-input-container class=\"md-block\" \nflex=\"100\"><label>Dirección</label><textarea ng-disabled=\"F.readMode\" class=\"uppercased\" rows=\"2\" \nng-model-options=\"{ debounce: F.debounceTime }\" name=\"address\" ng-model=\"companySelected.address\" required></textarea>\n<div ng-messages=\"form.address.$error\" ng-show=\"form.address.$touched || form.address.$dirty\" role=\"alert\"><div \nng-message=\"required\">Dirección es requerido</div></div></md-input-container><md-input-container class=\"md-block\" \nflex=\"50\"><label>País</label><md-select ng-disabled=\"F.readMode\" name=\"countriesRecord_id\" \nng-model=\"companySelected.countriesRecord_id\"><md-select-header><input autocomplete=\"off\" type=\"search\" \nclass=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"countrySelectFilter\" placeholder=\"Busque un país\">\n</md-select-header><md-option ng-value=\"country._id\" \nng-repeat=\"country in M.countriesRecords | orderBy:\'name\' | filter:countrySelectFilter\">{{country.name}}</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>Estado</label><md-select \nng-disabled=\"F.readMode\" name=\"state_id\" ng-model=\"companySelected.state_id\" \nng-model-options=\"{ debounce: F.debounceTime }\"><md-select-header><input autocomplete=\"off\" type=\"search\" \nclass=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"stateSelectFilter\" placeholder=\"Busque un estado\">\n</md-select-header><md-option ng-value=\"state._id\" \nng-repeat=\"state in M.states | orderBy:\'name\' | filter:stateSelectFilter\">{{state.name}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>Municipio</label><md-select \nng-disabled=\"F.readMode\" name=\"town_id\" ng-model=\"companySelected.town_id\"><md-select-header><input autocomplete=\"off\" \ntype=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"townSelectFilter\" \nplaceholder=\"Busque un municipio\"></md-select-header><md-option ng-value=\"town._id\" \nng-repeat=\"town in M.towns | orderBy:\'name\' | filter:townSelectFilter\">{{town.name}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>Ciudad</label><input \nng-disabled=\"F.readMode\" class=\"uppercased\" ng-model-options=\"{ debounce: F.debounceTime }\" type=\"text\" \nmd-maxlength=\"60\" maxlength=\"60\" name=\"city\" ng-model=\"companySelected.city\" required><div \nng-messages=\"form.city.$error\" ng-show=\"form.city.$touched || form.city.$dirty\" role=\"alert\"><div \nng-message=\"required\">Ciudad es requerido</div><div ng-message=\"maxlength\">Ciudad no debe tener más de 30 caracteres\n</div></div></md-input-container></div></div></md-tab-body></md-tab><md-tab ng-disabled=\"F.addMode\" label=\"logo\">\n<md-tab-body><div class=\"detail-form-container md-background-bg md-whiteframe-1dp\"><div class=\"upload-button\" \nlayout=\"column\" layout-align=\"center center\"><h3 ng-hide=\"firm.logo\" class=\"secondary-text\" \ntranslate=\"EC.UPLOAD_RULES\">Only PNG & JPG - Max. 2MB</h3><img ng-show=\"firm.logo\" ng-src=\"{{firm.logo}}\" alt=\"Logo\">\n<lf-ng-md-file-input ng-show=\"!firm.logo\" ng-disabled=\"F.readMode\" lf-files=\"images\" lf-mimetype=\"image/*\" \nlf-placeholder=\"Imagen\" lf-drag-and-drop-label=\"{{\'EC.DROP_TO_UPLOAD\' | translate}}\" \nlf-browse-label=\"{{\'EC.SEARCH\' | translate}}\" lf-remove-label=\"{{\'EC.REMOVE\' | translate}}\" lf-filesize=\"2MB\" \nname=\"logo\" lf-api=\"imageApi\" progress preview drag></lf-ng-md-file-input><div ng-messages=\"form.logo.$error\" \nng-show=\"(form.logo.$error && !form.logo.$pristine) || (form.logo.$error && firm.logo)\" role=\"alert\"><div \nng-message=\"required\">This is required.</div><div ng-message=\"maxcount\">Too many files.</div><div \nng-message=\"filesize\">File size too large.</div><div ng-message=\"totalsize\">Total size too large.</div><div \nng-message=\"mimetype\">Mimetype error.</div></div></div></div></md-tab-body></md-tab><md-tab ng-disabled=\"F.addMode\" \nlabel=\"configuración\"><md-tab-body><div class=\"detail-form-container md-background-bg md-whiteframe-1dp\"><md-list>\n<md-list-item><md-icon md-font-icon=\"icon-clipboard-check\"></md-icon><p>Activo</p><md-switch ng-disabled=\"F.readMode\" \nclass=\"md-secondary\" name=\"active\" ng-model=\"firm.active\" ng-false-value=\"0\"></md-switch></md-list-item><md-list-item>\n<md-icon md-font-icon=\"icon-key\"></md-icon><p>Activar doble factor de autenticación</p><md-switch \nng-disabled=\"F.readMode\" class=\"md-secondary\" name=\"active\" ng-model=\"firm.data.enableMfa\" ng-false-value=\"null\">\n</md-switch></md-list-item><md-list-item><md-icon md-font-icon=\"icon-key-change\"></md-icon><p>Cambiar contraseña</p>\n<md-input-container class=\"md-block mb-0\" md-no-float flex><md-select name=\"passExpiration\" \nng-model=\"firm.passExpiration\" ng-change=\"firm.passExpiration?firm.forceChangePass=null:\'\'\" ng-disabled=\"F.readMode\">\n<md-option ng-value=\"undefined\">No cambiar</md-option><md-option ng-value=\"30\">Cada 30 dias</md-option><md-option \nng-value=\"90\">Cada 90 dias</md-option><md-option ng-value=\"180\">Cada 6 meses</md-option><md-option ng-value=\"365\">\nAnualmente</md-option></md-select></md-input-container></md-list-item><md-list-item \nng-if=\"\r\n                                                   firm.passExpiration\"><md-icon md-font-icon=\"icon-lock\">\n</md-icon><p>Forzar cambio de contraseña</p><md-switch ng-disabled=\"F.readMode\" class=\"md-secondary\" name=\"active\" \nng-model=\"firm.forceChangePass\" ng-false-value=\"null\"></md-switch></md-list-item></md-list></div></md-tab-body>\n</md-tab><md-tab label=\"Campos\"><md-tab-body><div class=\"detail-form-container md-background-bg md-whiteframe-1dp\">\n<fieldset><legend>Campos Personalizados<md-button ng-click=\"addElement(firm,\'fields\',{})\" aria-label=\"Add\" \nclass=\"md-icon-button\"><md-icon md-font-icon=\"icon-plus-circle-outline\"></md-icon></md-button></legend><div \nng-repeat=\"($index,field) in firm.fields\" flex class=\"noErrorSpaces\"><div layout=\"row\" layout-align=\"end start\"><div \nflex=\"nogrow\"><md-button aria-label=\"Delete\" class=\"md-icon-button\" \nng-click=\"firm.fields.splice($index,1);form.$setDirty();\"><md-icon md-font-icon=\"icon-trash\"></md-icon></md-button>\n<md-button ng-disabled=\"$first\" aria-label=\"Move Up\" class=\"md-icon-button\" \nng-click=\"firm.fields.splice($index-1,0,firm.fields.splice($index,1)[0]);form.$setDirty();\"><md-icon \nmd-font-icon=\"icon-arrow-up-bold-hexagon-outline\"></md-icon></md-button><md-button ng-disabled=\"$last\" \naria-label=\"Move Down\" class=\"md-icon-button\" \nng-click=\"firm.fields.splice($index+1,0,firm.fields.splice($index,1)[0]);form.$setDirty();\"><md-icon \nmd-font-icon=\"icon-arrow-down-bold-hexagon-outline\"></md-icon></md-button></div></div><div layout=\"row\" layout-wrap>\n<md-input-container flex flex-xs=\"100\" class=\"md-block mb-0\"><label>ID</label><input type=\"text\" name=\"id-{{$index}}\" \nng-model=\"field.id\" required><div ng-messages=\'form[\"id-\"+$index].$error\' role=\"alert\"><div ng-message=\"required\">\nEste dato es requerido</div></div></md-input-container><md-input-container flex flex-xs=\"100\" class=\"md-block mb-0\">\n<label>Nombre</label><input type=\"text\" name=\"label-{{$index}}\" ng-model=\"field.label\" required><div \nng-messages=\'form[\"label-\"+$index].$error\' role=\"alert\"><div ng-message=\"required\">Este dato es requerido</div></div>\n</md-input-container><md-input-container flex flex-xs=\"100\" class=\"md-block mb-0\"><label>Orden</label><input \ntype=\"number\" name=\"order-{{$index}}\" ng-model=\"field.order\"></md-input-container><md-input-container flex \nflex-xs=\"100\" class=\"md-block mb-0\"><label>Tamaño</label><input type=\"text\" name=\"width-{{$index}}\" \nng-model=\"field.width\"></md-input-container><md-input-container flex flex-xs=\"100\" class=\"md-block mb-0\"><label>\nTipo de campo</label><md-select ng-model=\"field.type\" name=\"type-{{$index}}\" required><md-option \nng-value=\"inputType.id\" ng-repeat=\"inputType in F.inputTypes\">{{inputType.value}}</md-option></md-select><div \nng-messages=\'form[\"type-\"+$index].$error\' role=\"alert\"><div ng-message=\"required\">Este dato es requerido</div></div>\n</md-input-container><div flex=\"100\" layout=\"column\" ng-if=\"field.type===\'select\'\"><fieldset><legend>Valores<md-button \nng-click=\"addElement(field,\'values\',{})\" aria-label=\"Add\" class=\"md-icon-button\"><md-icon \nmd-font-icon=\"icon-plus-circle-outline\"></md-icon></md-button></legend><div \nng-repeat=\"($index2,value) in field.values\" layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" \nflex=\"33\" class=\"md-block mb-0\"><label>ID Valor</label><input type=\"text\" required name=\"id-{{$index}}-{{$index2}}\" \nng-model=\"value.id\"><div ng-messages=\'form[\"id-\"+$index+\"-\"+$index2].$error\' role=\"alert\"><div ng-message=\"required\">\nEste dato es requerido</div></div></md-input-container><md-input-container flex=\"100\" flex=\"33\" class=\"md-block mb-0\">\n<label>Nombre</label><input type=\"text\" required name=\"name-{{$index}}-{{$index2}}\" ng-model=\"value.name\"><div \nng-messages=\'form[\"name-\"+$index+\"-\"+$index2].$error\' role=\"alert\"><div ng-message=\"required\">Este dato es requerido\n</div></div></md-input-container><md-input-container flex=\"100\" flex=\"33\" class=\"md-block mb-0\"><label>Descripción\n</label><input type=\"text\" name=\"description-{{$index}}-{{$index2}}\" ng-model=\"value.description\"><div \nng-messages=\'form[\"description-\"+$index+\"-\"+$index2].$error\' role=\"alert\"><div ng-message=\"required\">\nEste dato es requerido</div></div></md-input-container></div></fieldset></div><div flex=\"100\"></div><md-input-container\n flex=\"25\" flex-xs=\"50\" class=\"md-block mb-0\" ng-if=\"field.type===\'autocompleteM\'\"><label>Catalogo</label><input \ntype=\"text\" name=\"catalog-{{$index}}\" ng-model=\"field.catalog\" required><div \nng-messages=\'form[\"catalog-\"+$index].$error\' role=\"alert\"><div ng-message=\"required\">Este dato es requerido</div></div>\n</md-input-container><md-input-container flex=\"25\" flex-xs=\"50\" class=\"md-block mb-0\" \nng-if=\"field.type===\'autocompleteM\'\"><label>Campos a consultar</label><input type=\"text\" name=\"query-{{$index}}\" \nng-model=\"field.query\" required><div ng-messages=\'form[\"query-\"+$index].$error\' role=\"alert\"><div \nng-message=\"required\">Este dato es requerido</div></div></md-input-container><md-input-container flex=\"25\" \nflex-xs=\"50\" class=\"md-block mb-0\" ng-if=\"field.type===\'autocompleteM\'\"><label>Campos a regresar</label><input \ntype=\"text\" name=\"project-{{$index}}\" ng-model=\"field.project\" required><div \nng-messages=\'form[\"project-\"+$index].$error\' role=\"alert\"><div ng-message=\"required\">Este dato es requerido</div></div>\n</md-input-container><md-input-container flex=\"25\" flex-xs=\"50\" class=\"md-block mb-0\" \nng-if=\"field.type===\'autocompleteM\'\"><label>Campo a mostrar</label><input type=\"text\" name=\"itemName-{{$index}}\" \nng-model=\"field.itemName\" required><div ng-messages=\'form[\"itemName-\"+$index].$error\' role=\"alert\"><div \nng-message=\"required\">Este dato es requerido</div></div></md-input-container><md-input-container flex=\"50\" \nflex-xs=\"100\" class=\"md-block mb-0\" ng-if=\"[\'select\',\'autocompleteM\'].indexOf(field.type)==-1\"><label>Valor default\n</label><input type=\"text\" name=\"defaultValue-{{$index}}\" ng-model=\"field.defaultValue\"><div \nng-messages=\'form[\"defaultValue-\"+$index].$error\' role=\"alert\"><div ng-message=\"required\">Este dato es requerido</div>\n</div></md-input-container><md-input-container flex=\"50\" flex-xs=\"100\" class=\"md-block mb-0\"><label>Validación</label>\n<input type=\"text\" name=\"validation-{{$index}}\" ng-model=\"field.validation\"><div \nng-messages=\'form[\"validation-\"+$index].$error\' role=\"alert\"><div ng-message=\"required\">Este dato es requerido</div>\n</div></md-input-container><md-input-container ng-if=\"field.type!==\'autocompleteM\'\" flex flex-xs=\"100\" \nclass=\"md-block mb-0\"><label>Mínimo</label><input type=\"number\" name=\"min-{{$index}}\" ng-model=\"field.min\">\n</md-input-container><md-input-container ng-if=\"field.type!==\'autocompleteM\'\" flex flex-xs=\"100\" class=\"md-block mb-0\">\n<label>Maximo</label><input type=\"number\" name=\"max-{{$index}}\" ng-model=\"field.max\"></md-input-container><div \nflex=\"nogrow\" flex-xs=\"100\" class=\"pl-5 pr-5\"><md-switch ng-model=\"field.required\" aria-label=\"Requerido\">Requerido\n</md-switch></div><div flex=\"nogrow\" flex-xs=\"100\" class=\"pl-5 pr-5\"><md-switch ng-model=\"field.readonly\" \naria-label=\"Solo lectura\">Solo lectura</md-switch></div></div><hr ng-if=\"!$last\"></div></fieldset></div></md-tab-body>\n</md-tab><md-tab label=\"Integraciones\" ng-if=\"visibleIntegration\"><md-tab-body><md-content \nclass=\"p-24 md-background-bg\"><div layout=\"row\" layout-wrap layout-align=\"start start\"><md-card \nclass=\"integration-card fixed-card\" ng-if=\"visibleIntegrationHumand\" layout=\"column\"><md-card-title \nclass=\"card-header\"><img ng-src=\"assets/images/humands.svg\" class=\"integration-logo\" alt=\"Buk logo\">\n<md-card-title-text><span class=\"md-headline\">Humand</span> <span class=\"md-subhead\">Control de asistencias</span>\n</md-card-title-text></md-card-title><md-card-content class=\"card-content\" flex><div class=\"lock-hero\" layout=\"column\" \nlayout-align=\"center center\"><md-button class=\"md-icon-button lock-btn\" \nng-click=\"firm.syncConfig.humand.apiKey?showHumandConfig = !showHumandConfig:\'\'\" \nng-class=\"{\'is-open\': showHumandConfig}\" aria-label=\"{{ showHumandConfig ? \'Ocultar API Key\' : \'Mostrar API Key\' }}\" \nmd-no-ink=\"false\"><svg class=\"lock-svg\" viewBox=\"0 0 64 64\" aria-hidden=\"true\"><rect class=\"lock-body\" x=\"12\" y=\"28\" \nrx=\"6\" ry=\"6\" width=\"40\" height=\"28\"></rect><circle class=\"keyhole\" cx=\"32\" cy=\"44\" r=\"3\"></circle><path \nclass=\"shackle\" d=\"M20,28 v-6 a12,12 0 0 1 24,0 v6\" fill=\"none\" stroke-width=\"6\" stroke-linecap=\"round\" \nstroke-linejoin=\"round\"/></svg></md-button><div class=\"status-pill\" \nng-class=\"!firm.syncConfig.humand.apiKey ? \'is-empty\' : (showHumandConfig ? \'is-open\' : \'is-closed\')\"><span \nclass=\"dot\"></span> {{ !firm.syncConfig.humand.apiKey ? \'Sin datos\' : (showHumandConfig ? \'Visible\' : \'Protegida\') }}\n</div></div><md-divider class=\"section-divider\"></md-divider><div \nng-if=\"showHumandConfig && firm.syncConfig.humand.apiKey\" class=\"api-key-wrapper\" aria-live=\"polite\"><div \nclass=\"api-key-label\">API Key</div><div class=\"api-key-box\"><span class=\"api-key-value\">\n{{ firm.syncConfig.humand.apiKey }}</span></div></div><div ng-show=\"!firm.syncConfig.humand.apiKey\" class=\"empty-key\">\n<div class=\"empty-title\">Sin Configuración</div><div class=\"empty-desc\">\nIngresa tu API KEY para habilitar la integración.</div><md-input-container class=\"md-block\" md-no-float><input \ntype=\"text\" name=\"humandApiKey\" ng-model=\"humanConfig.apiKey\" ng-trim=\"true\" autocomplete=\"off\"></md-input-container>\n</div></md-card-content><md-card-actions class=\"card-actions\" layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-icon-button danger-ghost\" ng-if=\"firm.syncConfig.humand.apiKey\" ng-click=\"firm.syncConfig.humand={}\" \naria-label=\"Eliminar API Key\"><md-tooltip md-direction=\"top\">Eliminar</md-tooltip><md-icon md-font-icon=\"icon-trash\">\n</md-icon></md-button><md-button ng-if=\"!firm.syncConfig.humand.apiKey\" \nng-disabled=\"form.humandApiKey.$invalid || !humanConfig.apiKey\" ng-click=\"saveSyncConfig(firm,\'humand\',humanConfig)\" \naria-label=\"Guardar API Key\" class=\"md-fab md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"top\">Guardar\n</md-tooltip><md-icon md-font-icon=\"icon-content-save\" aria-label=\"save\"></md-icon></md-button></md-card-actions>\n</md-card><md-card class=\"integration-card fixed-card\" ng-if=\"visibleIntegrationBuk\" layout=\"column\"><md-card-title \nclass=\"card-header\"><img ng-src=\"assets/images/buksv.svg\" class=\"integration-logo\" alt=\"Buk logo\"><md-card-title-text>\n<span class=\"md-headline\">Buk</span> <span class=\"md-subhead\">Control de asistencias</span></md-card-title-text>\n</md-card-title><md-card-content class=\"card-content\" flex><div class=\"lock-hero\" layout=\"column\" \nlayout-align=\"center center\"><md-button class=\"md-icon-button lock-btn\" \nng-click=\"firm.syncConfig.buk.token&&firm.syncConfig.buk.url?showBukConfig = !showBukConfig:\'\'\" \nng-class=\"{\'is-open\': showBukConfig}\" aria-label=\"{{ showBukConfig ? \'Ocultar datos\' : \'Mostrar datos\' }}\"><svg \nclass=\"lock-svg\" viewBox=\"0 0 64 64\" aria-hidden=\"true\"><rect class=\"lock-body\" x=\"12\" y=\"28\" rx=\"6\" ry=\"6\" width=\"40\" \nheight=\"28\"></rect><circle class=\"keyhole\" cx=\"32\" cy=\"44\" r=\"3\"></circle><path class=\"shackle\" \nd=\"M20,28 v-6 a12,12 0 0 1 24,0 v6\" fill=\"none\" stroke-width=\"6\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></svg>\n</md-button><div class=\"status-pill\" \nng-class=\"firm.syncConfig.buk.token&&firm.syncConfig.buk.url ? (showBukConfig ? \'is-open\' : \'is-closed\') : \'is-open\'\">\n<span class=\"dot\"></span>\n {{ firm.syncConfig.buk.token&&firm.syncConfig.buk.url ? (showBukConfig ? \'Visible\' : \'Protegida\') : \'Sin datos\' }}\n</div></div><md-divider class=\"section-divider\"></md-divider><div \nng-if=\"showBukConfig && firm.syncConfig.buk.token && firm.syncConfig.buk.url\" class=\"api-key-wrapper\" \naria-live=\"polite\"><div class=\"api-key-label\">TOKEN</div><div class=\"api-key-box\"><span class=\"api-key-value\">\n{{ firm.syncConfig.buk.token }}</span></div><div class=\"api-key-label\" style=\"margin-top:12px\">URL</div><div \nclass=\"api-key-box\"><span class=\"api-key-value\">{{ firm.syncConfig.buk.url }}</span></div></div><div \nng-show=\"!firm.syncConfig.buk.token || !firm.syncConfig.buk.url\" class=\"empty-key\"><div class=\"empty-title\">\nSin Configuración</div><div class=\"empty-desc\">Ingresa tu token y la URL de tu instancia de Buk.</div>\n<md-input-container class=\"md-block\"><label>Token</label><input type=\"text\" name=\"bukToken\" ng-model=\"bukConfig.token\" \nautocomplete=\"off\"></md-input-container><md-input-container class=\"md-block\"><label>URL</label><input type=\"url\" \nplaceholder=\"https://tuservidor.buk.cl\" name=\"bukUrl\" ng-model=\"bukConfig.url\"></md-input-container></div>\n</md-card-content><md-card-actions class=\"card-actions\" layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-icon-button danger-ghost\" ng-if=\"firm.syncConfig.buk.token && firm.syncConfig.buk.url\" \nng-click=\" firm.syncConfig.buk={}\" aria-label=\"Eliminar datos\"><md-tooltip md-direction=\"top\">Eliminar</md-tooltip>\n<md-icon md-font-icon=\"icon-trash\"></md-icon></md-button><md-button \nng-if=\"!firm.syncConfig.buk.token||!firm.syncConfig.buk.url\" \nng-disabled=\"form.bukToken.$invalid || form.bukUrl.$invalid || !bukConfig.token || !bukConfig.url\" \nng-click=\"saveSyncConfig(firm,\'buk\',bukConfig)\" aria-label=\"Guardar\" class=\"md-fab md-mini md-accent md-hue-2\">\n<md-tooltip md-direction=\"top\">Guardar</md-tooltip><md-icon md-font-icon=\"icon-content-save\" aria-label=\"save\">\n</md-icon></md-button></md-card-actions></md-card><md-card class=\"integration-card fixed-card\" \nng-if=\"visibleIntegrationGeoVictoria\" layout=\"column\"><md-card-title class=\"card-header\"><img \nng-src=\"assets/images/Icono_GeoVictoria.png\" class=\"integration-logo\" alt=\"Buk logo\"><md-card-title-text><span \nclass=\"md-headline\">GeoVictoria</span> <span class=\"md-subhead\">Control de asistencias</span></md-card-title-text>\n</md-card-title><md-card-content class=\"card-content\" flex><div class=\"lock-hero\" layout=\"column\" \nlayout-align=\"center center\"><md-button class=\"md-icon-button lock-btn\" \nng-click=\"firm.syncConfig.geovictoria.key && firm.syncConfig.geovictoria.secret ? showGeovictoriaConfig = !showGeovictoriaConfig : \'\'\" \nng-class=\"{\'is-open\': showGeovictoriaConfig}\" \naria-label=\"{{ showGeovictoriaConfig ? \'Ocultar datos\' : \'Mostrar datos\' }}\"><svg class=\"lock-svg\" viewBox=\"0 0 64 64\" \naria-hidden=\"true\"><rect class=\"lock-body\" x=\"12\" y=\"28\" rx=\"6\" ry=\"6\" width=\"40\" height=\"28\"></rect><circle \nclass=\"keyhole\" cx=\"32\" cy=\"44\" r=\"3\"></circle><path class=\"shackle\" d=\"M20,28 v-6 a12,12 0 0 1 24,0 v6\" fill=\"none\" \nstroke-width=\"6\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></svg></md-button><div class=\"status-pill\" \nng-class=\"firm.syncConfig.geovictoria.key && firm.syncConfig.geovictoria.secret ? (showGeovictoriaConfig ? \'is-open\' : \'is-closed\') : \'is-open\'\">\n<span class=\"dot\"></span>\n {{ firm.syncConfig.geovictoria.key && firm.syncConfig.geovictoria.secret ? (showGeovictoriaConfig ? \'Visible\' : \'Protegida\') : \'Sin datos\' }}\n</div></div><md-divider class=\"section-divider\"></md-divider><div \nng-if=\"showGeovictoriaConfig && firm.syncConfig.geovictoria.key && firm.syncConfig.geovictoria.secret\" \nclass=\"api-key-wrapper\" aria-live=\"polite\"><div class=\"api-key-label\">KEY</div><div class=\"api-key-box\"><span \nclass=\"api-key-value\">{{ firm.syncConfig.geovictoria.key }}</span></div><div class=\"api-key-label\" \nstyle=\"margin-top:12px\">SECRET</div><div class=\"api-key-box\"><span class=\"api-key-value\">\n{{ firm.syncConfig.geovictoria.secret }}</span></div></div><div \nng-show=\"!firm.syncConfig.geovictoria.key || !firm.syncConfig.geovictoria.secret\" class=\"empty-key\"><div \nclass=\"empty-title\">Sin configuración</div><div class=\"empty-desc\">\nIngresa tu Key y Secret para habilitar la integración.</div><md-input-container class=\"md-block\"><label>Key</label>\n<input type=\"text\" name=\"geoKey\" ng-model=\"geoConfig.key\" autocomplete=\"off\"></md-input-container><md-input-container \nclass=\"md-block\"><label>Secret</label><input type=\"password\" name=\"geoSecret\" ng-model=\"geoConfig.secret\" \nautocomplete=\"off\"></md-input-container></div></md-card-content><md-card-actions class=\"card-actions\" layout=\"row\" \nlayout-align=\"end center\"><md-button class=\"md-icon-button danger-ghost\" \nng-if=\"firm.syncConfig.geovictoria.key || firm.syncConfig.geovictoria.secret\" \nng-click=\" firm.syncConfig.geovictoria={}\" aria-label=\"Eliminar datos\"><md-tooltip md-direction=\"top\">Eliminar\n</md-tooltip><md-icon md-font-icon=\"icon-delete\" aria-label=\"Delete\"></md-icon></md-button><md-button \nng-if=\"!firm.syncConfig.geovictoria.key || !firm.syncConfig.geovictoria.secret\" \nng-disabled=\"form.geoKey.$invalid || form.geoSecret.$invalid || !geoConfig.key || !geoConfig.secret\" \nng-click=\"saveSyncConfig(firm,\'geovictoria\',geoConfig)\" aria-label=\"Guardar\" class=\"md-fab md-mini md-accent md-hue-2\">\n<md-tooltip md-direction=\"top\">Guardar</md-tooltip><md-icon md-font-icon=\"icon-content-save\" aria-label=\"save\">\n</md-icon></md-button></md-card-actions></md-card></div></md-content></md-tab-body></md-tab><md-tab \nlabel=\"Tokens de acceso\" ng-if=\"!F.readMode\" ng-disabled=\"F.addMode\"><md-tab-body><div class=\"auth-tokens-tab-wrapper\" \nng-init=\"authTokenContext = {type: \'firmOnly\'}\" ng-include=\"\'app/main/clients/views/firms/authTokens.html\'\"></div>\n</md-tab-body></md-tab></md-tabs></md-content></form></div>");
$templateCache.put("app/main/clients/views/firms/firms.html","<div id=\"firms\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\" ng-controller=\"FirmsController\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div fb-search-bar></div><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><div \nfilter-toolbar></div><div table-loader array=\"firms\" validations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"firms.length\"><thead md-head md-order=\"order\" fix-head>\n<tr md-row><th md-column><span>Logo</span></th><th md-column md-order-by=\"data.name\"><span>Nombre Corto</span></th><th \nmd-column md-order-by=\"active\"><span>Activo</span></th></tr></thead><tbody md-body><tr md-row md-auto-select \nmd-select=\"firm\" md-select-id=\"$id\" \nng-repeat=\"firm in (F.filteredItems = (firms | searchSpecific:F.searchText.firm:fixedFieldsSearch | orderBy:order)) | limitTo: F.paginate: (currentPage - 1) * F.paginate\">\n<td md-cell><img ng-if=\"firm.logo\" class=\"thumb-image\" ng-src=\"{{firm.logo}}\"> <img ng-if=\"!firm.logo\" \nclass=\"thumb-image\" ng-src=\"{{F.imagePlaceholder}}\"></td><td md-cell>{{firm.data.name}}</td><td md-cell><div \nlayout=\"row\" layout-align=\"start center\"><div class=\"quantity-indicator\" \nng-class=\"{\'md-red-500-bg\': !firm.active, \'md-green-600-bg\': firm.active }\"></div></div></td></tr></tbody></table>\n</md-table-container><md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" \nng-show=\"firms.length\" md-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" md-limit-options=\"F.paginations\" \nmd-page=\"currentPage\" md-on-paginate=\"restartSelected\" md-total=\"{{F.filteredItems.length}}\" md-page-select>\n</md-table-pagination></div></div><md-fab-speed-dial md-open=\"F.isOpen\" \nmd-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\"><md-fab-trigger><md-button \naria-label=\"crud menu\" class=\"md-fab md-accent\" md-class=\"{\'md-hue-1\': selected.length}\"><md-icon \nmd-font-icon=\"icon-cube\"></md-icon></md-button></md-fab-trigger><md-fab-actions><md-button with-permission \naction=\"read\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" \nng-click=\'R.goToDetail(null, \"read\", {firmId: selected[0].$id})\' aria-label=\"view\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Ver</md-tooltip><md-icon \nmd-font-icon=\"icon-eye\" aria-label=\"view\"></md-icon></md-button><md-button with-permission action=\"export\" \naccess=\"{{F.active.menuItem}}\" ng-click=\"exportDataToExcel(F.filteredItems,null,currentPage,F.paginate)\" \naria-label=\"export\" class=\"md-fab md-raised md-mini md-primary md-hue-2\"><md-tooltip md-direction=\"left\">\nExportar a excel</md-tooltip><md-icon md-font-icon=\" icon-file-excel\" aria-label=\"export\"></md-icon></md-button>\n<md-button with-permission action=\"update\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" \nng-click=\'R.goToDetail(null, \"update\", {firmId: selected[0].$id})\' aria-label=\"edit\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Editar</md-tooltip><md-icon \nmd-font-icon=\"icon-pencil\" aria-label=\"edit\"></md-icon></md-button><md-button with-permission action=\"copyFirmToRp\" \naccess=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" ng-click=\"firmToRp($event)\" aria-label=\"edit\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Copiar empresas</md-tooltip>\n<md-icon md-font-icon=\"icon-content-copy\" aria-label=\"edit\"></md-icon></md-button><md-button with-permission \naction=\"remove\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length\" ng-click=\"delete($event)\" aria-label=\"Delete\" \nclass=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">{{\'EC.REMOVE\' | translate}}</md-tooltip>\n<md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button><md-button with-permission \naction=\"create\" access=\"{{F.active.menuItem}}\" ng-if=\"!selected.length\" \nng-click=\'R.goToDetail(null, \"update\", {firmId: \"new\"})\' aria-label=\"add\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">{{\'EC.ADD\' | translate}}\n</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon></md-button></md-fab-actions>\n</md-fab-speed-dial></div></div>");
$templateCache.put("app/main/clients/views/firms/firmsToRp.html","<md-dialog><form ng-cloak name=\"form\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>\n¿Desea copiar las empresas a un registro patronal?</h2></div></md-toolbar><md-dialog-content><md-input-container \nclass=\"md-block\"><label>Registro patronales</label><md-select ng-model=\"ftpCtrl.rp\" name=\"rp\" required>\n<md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" \nng-model=\"rpsSelectFilter\" placeholder=\"Busque un registro patronal\"></md-select-header><md-option ng-value=\"rp.$id\" \nng-repeat=\"rp in ftpCtrl.L.rps | filter:rpsSelectFilter\">{{rp.name}}</md-option></md-select><div \nng-messages=\"form.rp.$error\" role=\"alert\"><div ng-message=\"required\">El registro patronal es requerido</div></div>\n</md-input-container></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"ftpCtrl.close()\">Cancelar\n</md-button><md-button ng-disabled=\"form.$invalid\" ng-click=\"ftpCtrl.answer()\">Aceptar</md-button></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/clients/views/humandCatalogs/humandCatalog.html","<div id=\"humandCatalogStyle\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill \nng-controller=\"HumandCatalogController\"><form name=\"form\" novalidate flex layout=\"column\" ng-disabled=\"F.readMode\"><div\n mongo-crud-detail-bar flex=\"nogrow\"></div><md-content layout=\"column\" class=\"content\" flex><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\" layout=\"column\"><md-input-container \nclass=\"md-block evenPadding mb-0\" flex><label>Cliente</label><md-select ng-model=\"humandCatalog.firm\" name=\"firm\" \nng-change=\"loadFirmData(humandCatalog.firm)\" required ng-disabled=\"F.readMode\"><md-select-header><input \nautocomplete=\"off\" type=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"firmSelectFilter\" \nplaceholder=\"Busque un cliente\"></md-select-header><md-option ng-value=\"firm.$id\" \nng-repeat=\"firm in thisFirms | filter:firmSelectFilter\">{{firm.data.name}}</md-option></md-select><div \nng-messages=\"form.payroll.$error\" role=\"alert\"><div ng-message=\"required\">Cliente es requerido</div></div>\n</md-input-container><div><md-card id=\"cc-relations-card\" class=\"elevated\"><md-card-title class=\"card-header gradient\">\n<md-card-title-text><h3 class=\"title\">Centros de costo · Relación Humand</h3><div class=\"subtitle\">\nConecta tus CC internos con sus equivalentes en Humand</div></md-card-title-text><md-card-title-media><md-icon \nmd-svg-src=\"/assets/icons/relationw.svg\" class=\"header-icon\"></md-icon></md-card-title-media></md-card-title>\n<md-divider></md-divider><md-card-content class=\"card-body\" layout=\"column\" layout-gap=\"16\"><md-subheader \nclass=\"md-no-sticky section-subheader\">Relaciones existentes</md-subheader><md-list class=\"relations-list\">\n<md-list-item class=\"relation-item\" ng-repeat=\"($key, cc) in humandCatalog.ccs\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"cc-interno\" flex layout=\"column\"><div class=\"cc-name\">\n{{ thisCcsByKey[$key].name }}</div><div class=\"cc-meta\">{{ thisPayrollsByKey[thisCcsByKey[$key].payroll].name }}</div>\n</div><md-icon md-font-icon=\"icon-chevron-right s-20\" class=\"chevron\" aria-label=\"Relación\"></md-icon><div \nclass=\"cc-humand\" flex>{{ cc }}</div><md-button class=\"md-icon-button md-warn\" aria-label=\"Eliminar relación\" \nng-click=\"deleteCc($key)\"><md-icon md-svg-src=\"/assets/icons/bx-trash.svg\"></md-icon><md-tooltip md-direction=\"bottom\">\nEliminar CC</md-tooltip></md-button></md-list-item><md-list-item ng-if=\"!humandCatalog.ccs\"><p class=\"empty-hint\">\nAún no hay relaciones. Crea la primera abajo.</p></md-list-item></md-list><md-divider></md-divider><div \nng-if=\"!F.readMode\" layout=\"column\" layout-gt-sm=\"row\" layout-gap=\"16\" class=\"form-row\"><md-input-container \nclass=\"md-block evenPadding mb-0\" flex=\"100\" flex-gt-sm=\"50\"><label>Centro de costo (interno)</label><md-select \nng-model=\"humandCatalog.ccSelected\" name=\"ccSelectedF\" md-container-class=\"select-panel\"><md-select-header \nclass=\"select-search\"><input autocomplete=\"off\" type=\"search\" class=\"md-text\" ng-model=\"ccSelectedFilter\" \nng-keydown=\"$event.stopPropagation()\" placeholder=\"Buscar centro de costo…\"></md-select-header><md-option \nng-value=\"cc.$id\" ng-repeat=\"cc in thisCcs | filter: ccSelectedFilter track by cc.$id\">\n{{ cc.name }} — {{ thisPayrollsByKey[thisCcsByKey[cc.$id].payroll].name }}</md-option></md-select><div \nng-messages=\"form.ccSelectedF.$error\" role=\"alert\"><div ng-message=\"required\">Centro de costo es requerido</div></div>\n</md-input-container><md-input-container class=\"md-block evenPadding mb-0\" flex=\"100\" flex-gt-sm=\"50\"><label>\nCentro de costo Humand</label><md-select ng-model=\"humandCatalog.ccHumanSelected\" name=\"ccHumanSelectedF\" \nmd-on-close=\"ccHumanSelectedFilter = \'\'\" md-container-class=\"select-panel\" \nng-change=\"humandCatalog.ccHumanSelected === \'addItemHumand\' && openAddHumandCcDialog()\"><md-select-header \nclass=\"select-search\"><input autocomplete=\"off\" type=\"search\" class=\"md-text\" ng-model=\"ccHumanSelectedFilter\" \nng-keydown=\"$event.stopPropagation()\" placeholder=\"Buscar centro de costo Humand…\"></md-select-header><md-option \nng-value=\"\'addItemHumand\'\"><p \nstyle=\"font-family:\'Lucida Sans\', \'Lucida Sans Regular\', \'Lucida Grande\', \'Lucida Sans Unicode\', Geneva, Verdana, sans-serif; margin: 0%; padding: 0%\">\n<md-icon md-svg-src=\"/assets/icons/plusblue.svg\" class=\"m-0 p-0\"></md-icon>Agregar nuevo elemento</p></md-option>\n<md-option ng-value=\"cc.name\" ng-repeat=\"cc in humandCcs | filter: ccHumanSelectedFilter track by cc.name\">\n{{ cc.name }}</md-option></md-select><div ng-messages=\"form.ccHumanSelectedF.$error\" role=\"alert\"><div \nng-message=\"required\">Centro de costo Humand es requerido</div></div></md-input-container><div layout=\"row\" \nlayout-align=\"start center\" flex=\"100\"><md-button class=\"w-fit\" style=\"background-color: white\" \nng-disabled=\"!humandCatalog.ccSelected || !humandCatalog.ccHumanSelected || F.readMode\" \nng-click=\"addCc(humandCatalog.ccSelected, humandCatalog.ccHumanSelected)\"><md-icon \nmd-svg-src=\"/assets/icons/relation.svg\" class=\"mr-4\" style=\"color: aliceblue\"></md-icon>Relacionar<md-tooltip \nmd-direction=\"bottom\">Relacionar</md-tooltip></md-button></div></div></md-card-content></md-card></div><md-card \nclass=\"account-card\"><md-card-title class=\"pb-0 pt-0\"><div layout=\"row\" layout-align=\"start center\"><div><h3>\nCARPETA HUMAND</h3></div></div></md-card-title><md-card-content><div layout=\"column\"><div layout=\"row\" \nlayout-xs=\"column\" layout-align=\"start center\" layout-align-xs=\"start stretch\"><span flex=\"nogrow\" flex-xs=\"100\">\nRECIBOS:</span><md-input-container class=\"md-block no-errors-spacer m-0\" md-no-float flex-xs=\"100\" flex><input \nname=\"receiptId\" type=\"number\" ng-model=\"humandCatalog.receiptId\" placeholder=\"Id carpeta recibo\" autocomplete=\"off\" \naria-label=\"ID del recibo\"></md-input-container><div flex=\"nogrow\" flex-xs=\"100\"><md-switch \nng-model=\"humandCatalog.requestReceiptFirm\" aria-label=\"Requiere firma\" class=\"m-0\">Requiere firma</md-switch></div>\n</div><div ng-if=\"humandCatalog.requestReceiptFirm\" layout=\"row\" layout-xs=\"column\"><md-input-container \nclass=\"md-block no-errors-spacer m-0\" md-no-float flex-xs=\"100\" flex><input name=\"page\" type=\"number\" \nng-model=\"humandCatalog.receiptCoord.page\" placeholder=\"Pagina Firma\" autocomplete=\"off\" aria-label=\"Page signature\">\n</md-input-container><md-input-container class=\"md-block no-errors-spacer m-0\" md-no-float flex-xs=\"100\" flex><input \nname=\"page_x\" type=\"number\" ng-model=\"humandCatalog.receiptCoord.x\" placeholder=\"Firma Pos X\" autocomplete=\"off\" \naria-label=\"Page signature x\"></md-input-container><md-input-container class=\"md-block no-errors-spacer m-0\" \nmd-no-float flex-xs=\"100\" flex><input name=\"page_y\" type=\"number\" ng-model=\"humandCatalog.receiptCoord.y\" \nplaceholder=\"Firma Pos Y\" autocomplete=\"off\" aria-label=\"Page signature y\"></md-input-container><md-input-container \nclass=\"md-block no-errors-spacer m-0\" md-no-float flex-xs=\"100\" flex><input name=\"page_height\" type=\"number\" \nng-model=\"humandCatalog.receiptCoord.height\" placeholder=\"Firma Altura\" autocomplete=\"off\" \naria-label=\"Page signature height\"></md-input-container><md-input-container class=\"md-block no-errors-spacer m-0\" \nmd-no-float flex-xs=\"100\" flex><input name=\"page_width\" type=\"number\" ng-model=\"humandCatalog.receiptCoord.width\" \nplaceholder=\"Firma Anchura\" autocomplete=\"off\" aria-label=\"Page signature width\"></md-input-container></div></div>\n</md-card-content></md-card></div></md-content></form></div>");
$templateCache.put("app/main/clients/views/humandCatalogs/humandCatalogs.html","<div id=\"humandCatalogs\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div mongo-search-bar></div><div class=\"content-card\" layout=\"column\" \nflex><div class=\"content fullpage-datatable\" layout=\"column\" flex><div list-filters filters-loaded=\"F.filtersLoaded\" \nng-model=\"F.filters[F.active.menuName]\" on-change=\"getThem\" columns-repeat=\"columnsRepeat\" \nmenu-obj-name=\"{{F.active.menuObjName}}\" model-name=\"{{F.active.menuName}}\" init-filters=\"initFilters\"></div><div \ntable-loader array=\"humandCatalogs\" validations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"humandCatalogs.length\"><thead md-head \nmd-order=\"F.orderMongo\" fix-head md-on-reorder=\"getThem\"><tr md-row><th md-column md-order-by=\"firm\"><span>Cliente\n</span></th><th md-column md-order-by=\"firm\"><span>Id del recibo</span></th><th md-column md-order-by=\"firm\"><span>\nFecha</span></th></tr></thead><tbody md-body><tr md-row md-auto-select md-select=\"humandCatalog\" md-select-id=\"_id\" \nng-repeat=\"humandCatalog in humandCatalogs\"><td md-cell>{{humandCatalog[\"firm-name\"]}}</td><td md-cell \nstyle=\"font-weight: bold\">{{humandCatalog.receiptId}}</td><td md-cell>{{humandCatalog.created.atTime|date:\'short\'}}\n</td></tr></tbody></table></md-table-container><md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" \nlayout-xs=\"column\" ng-show=\"humandCatalogs.length\" md-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" \nmd-limit-options=\"F.paginations\" md-page=\"currentPage\" md-total=\"{{pagination.total}}\" \nmd-on-paginate=\"getThemPagination\" md-page-select></md-table-pagination></div></div><md-fab-speed-dial \nmd-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\"><md-fab-trigger>\n<md-button aria-label=\"crud menu\" class=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon>\n</md-button></md-fab-trigger><md-fab-actions><md-button with-permission action=\"update\" access=\"{{F.active.menuItem}}\" \nng-if=\"selected.length == 1\" ng-click=\"R.goToDetail(selected[0])\" aria-label=\"edit\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Editar</md-tooltip><md-icon \nmd-font-icon=\"icon-pencil\" aria-label=\"edit\"></md-icon></md-button><md-button with-permission action=\"remove\" \naccess=\"{{F.active.menuItem}}\" ng-if=\"selected.length\" ng-click=\"delete($event)\" aria-label=\"Delete\" \nclass=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">{{\'EC.REMOVE\' | translate}}</md-tooltip>\n<md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button><md-button with-permission \naction=\"create\" access=\"{{F.active.menuItem}}\" ng-if=\"!selected.length\" ng-click=\'R.goToDetail(\"new\")\' \naria-label=\"add\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">\n{{\'EC.ADD\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon></md-button>\n</md-fab-actions></md-fab-speed-dial></div></div>");
$templateCache.put("app/main/clients/views/folios/folios.html","<div id=\"folios\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div fb-search-bar></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content\" layout-margin layout=\"row\" flex><div flex class=\"scrollable\" scrollable \non-bottom-event=\"autoScrollBottom\"><table class=\"simple row-border miniTable\"><thead><tr><th>Nomina</th><th>Folios</th>\n<th>Usuario</th><th>Fecha</th></tr></thead><tbody><tr \nng-repeat=\"folio in (folios.items|filter:F.searchText[F.active.menuObjName])|orderBy:\'-created.atTime\'\"><td>\n{{ folio.payrollName }}</td><td><p ng-repeat=\"issuer in folio.folios|objsToArray|orderBy:\'process\'\" class=\"noMargin\">\n{{issuer.process}}: <strong>{{issuer.issuer}}</strong> Folio: <strong>{{issuer.folio}}</strong></p></td><td>\n{{folio.userName}}</td><td>{{folio.created.atTime | date:\'medium\'}}</td></tr></tbody><tfoot><tr><td colspan=\"4\" \nstyle=\"text-align: center\"><md-button ng-disabled=\"!folios.loadMoreButton\" ng-click=\"getMoreResults()\">\n{{initialLoadMoreText}}</md-button></td></tr></tfoot></table></div></div></div><md-fab-speed-dial md-open=\"F.isOpen\" \nmd-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\"><md-fab-trigger><md-button \naria-label=\"crud menu\" class=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon></md-button>\n</md-fab-trigger><md-fab-actions><md-button with-permission action=\"create\" access=\"{{F.active.menuItem}}\" \nng-if=\"!selected.length\" ng-click=\"addFolio()\" aria-label=\"add\" class=\"md-fab md-raised md-mini md-accent md-hue-2\">\n<md-tooltip md-direction=\"left\">{{\'EC.ADD\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-plus\" \naria-label=\"add\"></md-icon></md-button></md-fab-actions></md-fab-speed-dial></div></div>");
$templateCache.put("app/main/clients/views/incidencesRequests/incidencesRequest.html","<div id=\"incidence\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill \nng-controller=\"IncidencesRequestController\"><form name=\"form\" novalidate flex layout=\"column\" ng-disabled=\"!F.addMode\">\n<md-toolbar class=\"md-tall header md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" \nlayout=\"row\" layout-align=\"start center\" flex><md-button with-permission action=\"access\" \naccess=\"{{F.active.menuItem}}\" class=\"goto-button md-icon-button\" aria-label=\"Go to incidences\" \nng-click=\"R.goToList()\" translate translate-attr-aria-label=\"EC.GO_TO\"><md-icon md-font-icon=\"icon-arrow-left\">\n</md-icon></md-button><div layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"{{F.menuItems.clients.incidences.icon || F.default.icon}}\" class=\"crud-icon\"></md-icon><div \nlayout=\"column\" layout-align=\"start start\"><div class=\"h2\">{{incidencesRequest.data.name}}</div><div \nclass=\"subtitle secondary-text\"><span ng-if=\"!F.addMode\">\n{{\'EC.DETAIL_OF\' | translate}} {{\'incidencesRequest.SINGULAR\' | translate}}</span> <span ng-if=\"F.addMode\">\n{{\'EC.CREATE\' | translate}} {{\'incidencesRequest.SINGULAR\' | translate}}</span></div></div></div></div><div><md-button \ntype=\"submit\" ng-if=\"F.addMode\" with-permission action=\"create\" access=\"{{F.active.menuItem}}\" \nng-click=\"addAndCreateEmployeesIncidences(incidencesRequest)\" ng-hide=\"form.$pristine\" \nng-disabled=\"form.$invalid || loadingProgress|| !(incidencesRequest.incidences|getTotalValideIncidences)\" \nclass=\"md-raised md-background md-fab md-accent md-hue-1\" aria-label=\"Add incidence\"><md-tooltip md-direction=\"left\">\n{{\'EC.ADD\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-content-save\" aria-label=\"Add\"></md-icon></md-button>\n</div></md-toolbar><md-content layout=\"column\" class=\"content\" flex><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\"><div form-incidences-request></div></div></md-content>\n</form></div>");
$templateCache.put("app/main/clients/views/incidencesRequests/incidencesRequests.html","<div id=\"incidencesRequests\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\" \nng-controller=\"IncidencesRequestsController\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" \nlayout=\"column\" flex><div fb-search-bar></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><div filter-toolbar></div><div table-loader \narray=\"incidencesRequests\" validations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"incidencesRequests.length\"><thead md-head \nmd-order=\"order\" fix-head><tr md-row><th md-column md-order-by=\"payroll\"><span>Nómina</span></th><th md-column \nmd-order-by=\"incidences.length\"># Incidencias</th><th md-column><span>Incidencias</span></th><th md-column md-numeric \nmd-order-by=\"calendar\">Año</th><th md-column md-numeric md-order-by=\"period\">Periodo</th></tr></thead><tbody md-body>\n<tr md-row md-auto-select md-select=\"incidenceRequest\" md-select-id=\"$id\" \nng-repeat=\"incidenceRequest in (F.filteredItems = (incidencesRequests | filter:F.searchText.incidencesRequest | orderBy:order)) | limitTo: F.paginate: (currentPage - 1) * F.paginate\">\n<td md-cell>{{incidenceRequest.payroll | nameOfL:L.allPayrolls:\'N/A\'}}</td><td md-cell>\n{{incidenceRequest.incidences | objectsLength}}</td><td md-cell><div class=\"incidencesWrapper\"><span \nng-repeat=\"incidence in incidenceRequest.incidences\" \nng-class=\"{\'green-900-fg\':((incidence.it|getSomethingOfArrayFB:L.incidencesTypes:\'nature\') == \'perception\'),\'red-900-fg\':((incidence.it|getSomethingOfArrayFB:L.incidencesTypes:\'nature\') == \'deduction\')}\">\n{{incidence.it|nameOfL:L.incidencesTypes}}:{{incidence.v}}</span></div></td><td md-cell>{{incidenceRequest.calendar}}\n</td><td md-cell>{{incidenceRequest.period}}</td></tr></tbody></table></md-table-container><md-table-pagination \nlayout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" ng-show=\"incidencesRequests.length\" \nmd-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" md-limit-options=\"F.paginations\" md-page=\"currentPage\" \nmd-on-paginate=\"restartSelected\" md-total=\"{{F.filteredItems.length}}\" md-page-select></md-table-pagination></div>\n</div><md-fab-speed-dial md-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" \nclass=\"ms2-speed-dial bottom right\"><md-fab-trigger><md-button aria-label=\"crud menu\" \nclass=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon></md-button></md-fab-trigger>\n<md-fab-actions><md-button with-permission action=\"export\" access=\"{{F.active.menuItem}}\" \nng-click=\"exportDataToExcel(F.filteredItems,F.active.menuName,currentPage,F.paginate)\" aria-label=\"export\" \nclass=\"md-fab md-raised md-mini md-primary md-hue-2\"><md-tooltip md-direction=\"left\">Exportar a excel</md-tooltip>\n<md-icon md-font-icon=\" icon-file-excel\" aria-label=\"export\"></md-icon></md-button><md-button with-permission \naction=\"read\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" \nng-click=\'R.goToDetail(null, \"read\", {incidencesRequestId: selected[0].$id, payrollId: selected[0].payroll})\' \naria-label=\"view\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Ver</md-tooltip>\n<md-icon md-font-icon=\"icon-eye\" aria-label=\"view\"></md-icon></md-button><md-button with-permission action=\"read\" \naccess=\"clients.incidences\" ng-if=\"selected.length == 1\" \nng-click=\'R.goToDetail(selected[0], \"list\", {payrollCalendarId: selected[0].calendar, payrollId: selected[0].payroll}, \"incidences\")\' \naria-label=\"see incidences\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">\nVer Incidencias</md-tooltip><md-icon md-font-icon=\"icon-book-multiple\" aria-label=\"view\"></md-icon></md-button>\n<md-button with-permission action=\"remove\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length\" \nng-click=\"deleteAndRemoveincidencesRequests($event)\" aria-label=\"Delete\" class=\"md-fab md-raised md-warn md-mini\">\n<md-tooltip md-direction=\"left\">{{\'EC.REMOVE\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-delete\" \naria-label=\"Remove\"></md-icon></md-button><md-button with-permission action=\"create\" access=\"{{F.active.menuItem}}\" \nng-if=\"!selected.length\" ng-click=\'R.goToDetail(null, \"update\", {incidencesRequestId: \"new\"})\' aria-label=\"add\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">{{\'EC.ADD\' | translate}}\n</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon></md-button></md-fab-actions>\n</md-fab-speed-dial></div></div>");
$templateCache.put("app/main/clients/views/incidences/confirm-incidences.html","<div id=\"confirm-incidences\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\" \nng-controller=\"IncidencesController\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex>\n<div fb-search-bar></div><div class=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" \nlayout=\"column\" flex><div filter-toolbar></div><div table-loader array=\"Z.confirmIncidences\" validations=\"validations\">\n</div><md-table-container class=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table \nmd-table md-row-select multiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"Z.confirmIncidences.length\">\n<thead md-head md-order=\"order\" fix-head><tr md-row><th md-column md-order-by=\"payroll\"><span>Nómina</span></th><th \nmd-column md-order-by=\"employee\"><span>Empleado</span></th><th md-column md-order-by=\"data.nameOfIncidence\"><span>\nIncidencia</span></th><th md-column md-order-by=\"data.value\">Cantidad</th><th md-column md-order-by=\"data.date\">Fecha\n</th><th md-column md-order-by=\"data.calendar\">Año</th><th md-column md-order-by=\"data.period\">Periodo</th><th \nmd-column md-order-by=\"data.status\">Status</th></tr></thead><tbody md-body><tr md-row md-auto-select \nmd-select=\"incidence\" md-select-id=\"$id\" \nng-repeat=\"incidence in (F.filteredItems = (Z.confirmIncidences | filter:F.searchText.incidence | orderBy:order)) | limitTo: F.paginate: (currentPage - 1) * F.paginate\">\n<td md-cell>{{incidence.payroll | nameOfL:L.allPayrolls:\'N/A\'}}</td><td md-cell><something-of-list \nuid=\"incidence.employee\" catalog=\"employees\"></something-of-list></td><td md-cell>\n{{incidence.incidenceType | nameOfL: L.incidencesTypes:\'N/A\'}}</td><td md-cell>{{incidence.value}}</td><td md-cell>\n{{incidence.date | date}}</td><td md-cell>{{incidence.calendar}}</td><td md-cell>{{incidence.period}}</td><td md-cell>\n{{incidence.status | incidenceStatusName}}</td></tr></tbody></table></md-table-container><md-table-pagination \nlayout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" ng-show=\"F.filteredItems.length\" \nmd-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" md-limit-options=\"F.paginations\" md-page=\"currentPage\" \nmd-on-paginate=\"restartSelected\" md-total=\"{{F.filteredItems.length}}\" md-page-select></md-table-pagination></div>\n</div><md-fab-speed-dial md-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" \nclass=\"ms2-speed-dial bottom right\"><md-fab-trigger><md-button aria-label=\"crud menu\" \nclass=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon></md-button></md-fab-trigger>\n<md-fab-actions><md-button with-permission action=\"read\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" \nng-click=\'R.goToDetail(null, \"read\", {confirmIncidenceId: selected[0].$id})\' aria-label=\"view\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Ver</md-tooltip><md-icon \nmd-font-icon=\"icon-eye\" aria-label=\"view\"></md-icon></md-button><md-button with-permission action=\"remove\" \naccess=\"processes.incidences\" ng-if=\"selected.length\" ng-click=\"deleteIncidences($event,true)\" aria-label=\"Delete\" \nclass=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">{{\'EC.REMOVE\' | translate}}</md-tooltip>\n<md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button><md-button with-permission \naction=\"export\" access=\"{{F.active.menuItem}}\" \nng-click=\'exportDataToExcel(F.filteredItems,\"incidences\",currentPage,F.paginate)\' aria-label=\"export\" \nclass=\"md-fab md-raised md-mini md-primary md-hue-2\"><md-tooltip md-direction=\"left\">Exportar a excel</md-tooltip>\n<md-icon md-font-icon=\" icon-file-excel\" aria-label=\"export\"></md-icon></md-button><md-button with-permission \naction=\"confirm\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" \nng-click=\'R.goToDetail(null, \"confirm\", {confirmIncidenceId: selected[0].$id})\' aria-label=\"Confirm Incidence\" \nclass=\"md-fab md-raised md-accent md-hue-2 md-mini\"><md-tooltip md-direction=\"left\">{{\'EC.CONFIRM\' | translate}}\n</md-tooltip><md-icon md-font-icon=\"icon-check\" aria-label=\"Confirm\"></md-icon></md-button><md-button target=\"_blanc\" \nwith-permission action=\"read\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" \nng-href=\"{{selected[0].file}}\" aria-label=\"Confirm Incidence\" class=\"md-fab md-raised md-accent md-hue-2 md-mini\">\n<md-tooltip md-direction=\"left\">Ver adjunto</md-tooltip><md-icon md-font-icon=\"icon-attachment\" \naria-label=\"Ver adjunto\"></md-icon></md-button></md-fab-actions></md-fab-speed-dial></div></div>");
$templateCache.put("app/main/clients/views/incidences/incidence.html","<div id=\"incidence\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill \nng-controller=\"IncidenceController\"><form name=\"form\" novalidate flex layout=\"column\" ng-disabled=\"F.readMode\">\n<md-toolbar class=\"md-tall header md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" \nlayout=\"row\" layout-align=\"start center\" flex><md-button with-permission action=\"access\" \naccess=\"{{F.active.menuItem}}\" class=\"goto-button md-icon-button\" aria-label=\"Go to list\" ng-click=\"R.goToList()\" \ntranslate translate-attr-aria-label=\"EC.GO_TO\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div \nlayout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"{{F.menuItems[F.active.menuParent][F.active.menuName].icon || F.default.icon}}\" class=\"crud-icon\">\n</md-icon><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\">{{F.active.detailObject.data.name}}</div><div\n class=\"subtitle secondary-text\"><span ng-if=\"!F.addMode\">\n{{\'EC.DETAIL_OF\' | translate}} {{F.active.menuObjName + \'.SINGULAR\' | translate}}</span> <span ng-if=\"F.addMode\">\n{{\'EC.CREATE\' | translate}} {{F.active.menuObjName + \'.SINGULAR\' | translate}}</span></div></div></div></div><div>\n<md-button type=\"submit\" ng-if=\"!F.addMode && objectLoaded && !F.readMode && !requireConfirmation\" with-permission \naction=\"update\" access=\"{{F.active.menuItem}}\" ng-click=\"saveIncidence(F.active.detailObject)\" \nng-hide=\"form.$pristine && !objectLoaded\" \nng-disabled=\"form.$invalid || form.$pristine || loadingProgress || noCalendars\" \nclass=\"md-raised md-background md-fab md-accent md-hue-1\" aria-label=\"Save\"><md-tooltip md-direction=\"left\">\n{{\'EC.SAVE\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-content-save\" aria-label=\"Save\"></md-icon>\n</md-button><md-button type=\"submit\" ng-if=\"F.addMode && objectLoaded && !requireConfirmation\" with-permission \naction=\"create\" access=\"{{F.active.menuItem}}\" ng-click=\"addAndMaybeSetIncidenceRequest(F.active.detailObject)\" \nng-hide=\"form.$pristine && !objectLoaded\" ng-disabled=\"form.$invalid || loadingProgress || noCalendars\" \nclass=\"md-raised md-background md-fab md-accent md-hue-1\" aria-label=\"Add\"><md-tooltip md-direction=\"left\">\n{{\'EC.ADD\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-content-save\" aria-label=\"Add\"></md-icon></md-button>\n<md-button ng-if=\"selectedTab == R.states.fb[F.active.menuName].files && requireFile\" with-permission action=\"update\" \naccess=\"{{F.active.menuItem}}\" ng-click=\"upload(files, F.active.detailObject, true)\" \nng-show=\"files.length && !F.active.detailObject[F.active.imageName]\" \nclass=\"md-raised md-background md-fab md-accent md-hue-1\" aria-label=\"Upload image\" \nng-disabled=\"loadingProgress || noCalendars || form.confirmationFile.$invalid\"><md-tooltip md-direction=\"left\">\nSubir adjunto</md-tooltip><md-icon md-font-icon=\"icon-upload\"></md-icon></md-button><md-button \nng-if=\"selectedTab == R.states.fb[F.active.menuName].files && incidence.file && requireFile\" with-permission \naction=\"update\" access=\"{{F.active.menuItem}}\" ng-click=\"removeUpload(F.active.detailObject)\" \nng-show=\"F.active.detailObject[F.active.imageName]\" class=\"md-warn md-raised md-background md-fab\" \naria-label=\"Delete file\" ng-disabled=\"loadingProgress || noCalendars\"><md-tooltip md-direction=\"left\">Borrar adjunto\n</md-tooltip><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button><md-button type=\"submit\" \nng-if=\"objectLoaded && !F.readMode && requireConfirmation\" with-permission action=\"update\" \naccess=\"{{F.active.menuItem}}\" ng-click=\"sendConfirmation(F.active.detailObject)\" \nng-hide=\"form.$pristine && !objectLoaded\" ng-disabled=\"form.$invalid || loadingProgress || noCalendars\" \nclass=\"md-raised md-background md-fab md-accent md-hue-1\" aria-label=\"Send to confirm\"><md-tooltip md-direction=\"left\">\nMandar a Confirmar</md-tooltip><md-icon md-font-icon=\"icon-send\" aria-label=\"Send\"></md-icon></md-button><md-button \ntype=\"submit\" \nng-if=\'!F.addMode && objectLoaded && !F.readMode && requireConfirmation && incidence.status == -1 && F.active.menuAction == \"confirm\"\' \nwith-permission action=\"problem\" access=\"{{F.active.menuItem}}\" ng-click=\"returnIncidence(F.active.detailObject)\" \nng-hide=\"form.$pristine && !objectLoaded\" \nng-disabled=\"form.$invalid || loadingProgress  || !incidence.comments || noCalendars\" \nclass=\"md-raised md-background md-fab md-warn\" aria-label=\"Send Back\"><md-tooltip md-direction=\"left\">\nRegresar Incidencia al Cliente</md-tooltip><md-icon md-font-icon=\"icon-arrow-left-bold\" aria-label=\"Regresar\">\n</md-icon></md-button><md-button type=\"submit\" \nng-if=\'!F.addMode && objectLoaded && !F.readMode && requireConfirmation && incidence.status == -1 && F.active.menuAction == \"confirm\"\' \nwith-permission action=\"confirm\" access=\"{{F.active.menuItem}}\" ng-click=\"confirmIncidence(F.active.detailObject)\" \nng-hide=\"form.$pristine && !objectLoaded\" ng-disabled=\"form.$invalid || loadingProgress  || noCalendars\" \nclass=\"md-raised md-background md-fab md-accent md-hue-1\" aria-label=\"Confirm\"><md-tooltip md-direction=\"left\">\nConfirmar</md-tooltip><md-icon md-font-icon=\"icon-check\" aria-label=\"Confirmar\"></md-icon></md-button></div>\n</md-toolbar><md-content layout=\"column\" class=\"content\" flex><md-tabs md-selected=\"selectedTab\" flex layout-fill>\n<md-tab label=\"incidencia\"><md-tab-body><div class=\"detail-form-container md-background-bg md-whiteframe-1dp\"><div \nflex layout=\"column\"><md-input-container class=\"md-block\" flex><label>Nómina</label><md-select \nng-disabled=\"!F.addMode || F.readMode\" ms2-autofocus aria-label=\"payrollOfIncidence\" ng-model=\"incidence.payroll\" \nng-change=\"payrollUpdated()\" name=\"payroll\" required><md-select-header><input type=\"text\" \nng-keydown=\"$event.stopPropagation()\" ng-model=\"payrollSelectFilter\" placeholder=\"Busque una nomina\">\n</md-select-header><md-option ng-disabled=\"!payroll.active\" ng-if=\"!F.permissionToAccessAllPayrolls\" \nng-value=\"payroll.$id\" ng-repeat=\"payroll in L.payrolls | orderBy:\'name\' | filter:payrollSelectFilter\">{{payroll.name}}\n</md-option><md-option ng-disabled=\"!payroll.active\" ng-if=\"F.permissionToAccessAllPayrolls\" ng-value=\"payroll.$id\" \nng-repeat=\"payroll in L.allPayrolls | orderBy:\'name\' | filter:payrollSelectFilter\">{{payroll.name}}</md-option>\n</md-select><div ng-messages=\"form.payroll.$error\" ng-show=\"form.payroll.$touched || form.payroll.$dirty\" role=\"alert\">\n<div ng-message=\"required\">Nómina es requerido</div></div></md-input-container><md-input-container class=\"md-block\" \nflex ng-if=\"!noCalendars\"><label>Tipo de Incidencia</label><md-select aria-label=\"incidenceType\" \nng-model=\"incidence.incidenceType\" name=\"incidenceType\" required \nng-disabled=\'!incidence.payroll||incidence.payroll==\"global\"||F.readMode\' ng-change=\'onChange(\"incidenceType\")\'>\n<md-select-header><input type=\"text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"incidenceTypeSelectFilter\" \nplaceholder=\"Busque un tipo de incidencia\"></md-select-header><md-option \nng-if=\"F.readMode || (!F.readMode && !incidenceType.automatic) && incidenceType.processes.payroll\" \nng-value=\"incidenceType.$id\" \nng-repeat=\"incidenceType in incidencesTypes | orderBy:\'name\' | filter:incidenceTypeSelectFilter\">{{incidenceType.name}}\n</md-option></md-select><div ng-messages=\"form.incidenceType.$error\" \nng-show=\"form.incidenceType.$touched || form.incidenceType.$dirty\" role=\"alert\"><div ng-message=\"required\">\nTipo de Incidencia es requerido</div></div></md-input-container><div layout-gt-xs=\"row\" ng-if=\"!noCalendars\">\n<md-input-container class=\"md-block date-picker\" flex><label>Fecha</label><md-datepicker ng-disabled=\"F.readMode\" \nmd-hide-icons=\"triangle\" md-min-date=\"minIncidenceDate\" md-max-date=\"maxIncidenDate\" ng-change=\"onChange(\'date\')\" \ninput-date-miliseconds ng-model=\"incidence.date\" name=\"date\" md-current-view=\"{{F.dateView}}\" required></md-datepicker>\n<div ng-messages=\"form.date.$error\" \nng-show=\"(form.date.$error && !form.date.$pristine) || (form.date.$error && incidence.date)\" role=\"alert\"><div \nng-message=\"required\">Fecha de la incidencia es requerida</div><div ng-message=\"mindate\">\nFecha de la incidencia es inválida debe ser a partir de {{minIncidenceDate|date:F.dateFormat}}</div><div \nng-message=\"maxdate\">\nFecha de la incidencia es inválida debe ser hasta {{maxIncidenDate|date:F.dateFormat}} {{incidence.date|date}}</div>\n</div></md-input-container><md-input-container class=\"md-block\" flex=\"nogrow\"><label>Año</label><input type=\"number\" \nname=\"calendar\" ng-model=\"incidence.calendar\" disabled=\"disabled\" ng-required></md-input-container><md-input-container \nclass=\"md-block\" flex=\"nogrow\"><label>Periodo</label><input type=\"number\" name=\"period\" ng-model=\"incidence.period\" \nng-required disabled=\"disabled\"></md-input-container></div><div layout-gt-xs=\"row\" ng-if=\"!noCalendars\">\n<md-autocomplete class=\"md-block\" flex=\"noshrink\" md-min-length=\"2\" md-selected-item=\"employeeSelected\" \nmd-search-text=\"searchEmployee\" md-selected-item-change=\'incidence.employee=item._id;onChange(\"employee\")\' \nmd-item-text=\"item.name\" md-delay=\"500\" md-items=\"item in getEmployees(searchEmployee)\" md-require-match=\"true\" \nplaceholder=\"Empleado\" md-no-cache=\"true\" md-input-name=\"employee\" ng-required=\"true\" md-floating-label=\"Empleado\" \nng-init=\"searchEmployee=employeeSelected.name\" ng-readonly=\"F.readMode || !incidence.payroll || !period\">\n<md-item-template><span md-highlight-text=\"searchEmployee\">{{item.nss}} {{item.name}}</span></md-item-template>\n<md-not-found>No hay registros</md-not-found><div ng-messages=\"form.employee.$error\"><div ng-message=\"required\">\nEl empleado es requerido</div></div></md-autocomplete></div><div layout-gt-xs=\"row\" ng-if=\"!noCalendars\">\n<md-input-container class=\"md-block\" flex-gt-xs=\"30\" \nng-if=\"!incidenceType.noEditValue && incidenceType.affect===\'days\' && incidenceType.allowNegative\"><label>Cantidad\n</label><input ng-disabled=\"F.readMode\" type=\"number\" name=\"value\" step=\"1\" max=\"{{maxAllowed}}\" \nng-model=\"incidence.value\" ng-model-options=\"{ debounce: F.debounceTime }\" ng-change=\'onChange(\"qty\")\' required><div \nng-messages=\"form.value.$error\" ng-show=\"form.value.$touched || form.value.$dirty\" role=\"alert\"><div \nng-message=\"required\">Cantidad es requerido</div><div ng-message=\"max\">\nDebe insertar un numero menor o igual a {{maxAllowed}}</div><div ng-message=\"step\">No se admiten decimales</div></div>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-xs=\"30\" \nng-if=\"!incidenceType.noEditValue && incidenceType.affect!==\'days\' && incidenceType.allowNegative\"><label>Cantidad\n</label><input ng-disabled=\"F.readMode\" type=\"number\" name=\"value\" step=\".01\" max=\"{{maxAllowed}}\" \nng-model=\"incidence.value\" ng-model-options=\"{ debounce: F.debounceTime }\" ng-change=\'onChange(\"qty\")\' required><div \nng-messages=\"form.value.$error\" ng-show=\"form.value.$touched || form.value.$dirty\" role=\"alert\"><div \nng-message=\"required\">Cantidad es requerido</div><div ng-message=\"max\">\nDebe insertar un numero menor o igual a {{maxAllowed}}</div></div></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-xs=\"30\" \nng-if=\"!incidenceType.noEditValue && incidenceType.affect===\'days\' && !incidenceType.allowNegative\"><label>Cantidad\n</label><input ng-disabled=\"F.readMode\" type=\"number\" name=\"value\" step=\"1\" max=\"{{maxAllowed}}\" \nng-model=\"incidence.value\" ng-model-options=\"{ debounce: F.debounceTime }\" min=\"0\" ng-change=\'onChange(\"qty\")\' \nrequired><div ng-messages=\"form.value.$error\" ng-show=\"form.value.$touched || form.value.$dirty\" role=\"alert\"><div \nng-message=\"required\">Cantidad es requerido</div><div ng-message=\"max\">\nDebe insertar un numero menor o igual a {{maxAllowed}}</div><div ng-message=\"min\">Solo se permiten números positivos\n</div><div ng-message=\"step\">No se admiten decimales</div></div></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-xs=\"30\" \nng-if=\"!incidenceType.noEditValue && incidenceType.affect!==\'days\' && !incidenceType.allowNegative\"><label>Cantidad\n</label><input ng-disabled=\"F.readMode\" type=\"number\" name=\"value\" step=\".01\" min=\"0\" max=\"{{maxAllowed}}\" \nng-model=\"incidence.value\" ng-model-options=\"{ debounce: F.debounceTime }\" ng-change=\'onChange(\"qty\")\' required><div \nng-messages=\"form.value.$error\" ng-show=\"form.value.$touched || form.value.$dirty\" role=\"alert\"><div \nng-message=\"required\">Cantidad es requerido</div><div ng-message=\"min\">Solo se permiten números positivos</div><div \nng-message=\"max\">Debe insertar un numero menor o igual a {{maxAllowed}}</div></div></md-input-container>\n<md-input-container class=\"md-block\" flex><label>Comentario</label><textarea ng-disabled=\"F.readMode\" \nclass=\"uppercased\" ng-model-options=\"{ debounce: F.debounceTime }\" name=\"comments\" ng-model=\"incidence.comments\" \nmd-maxlength=\"250\" maxlength=\"250\"></textarea><small ng-if=\"!incidence.comments\" style=\"color: orange\" with-permission \naction=\"problem\" access=\"{{F.active.menuItem}}\">Para regresar Incidencia al cliente, un comentario es requerido</small>\n</md-input-container></div></div></div></md-tab-body></md-tab><md-tab label=\"Extra\" \nng-disabled=\"(!requireFile && !incidenceType.isIncapacity) || noCalendars\"><md-tab-body><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\"><div layout=\"row\" layout-xs=\"column\" \nlayout=\"start stretch\"><div flex-gt-xs=\"66\" flex=\"nogrow\"><md-input-container \nng-if=\"incidenceType.addFolio && !incidenceType.uniqueFolio\" class=\"md-block\" layout-gt-xs=\"row\"><label>Folio</label>\n<input ng-disabled=\"F.readMode\" type=\"text\" name=\"folio\" class=\"uppercased\" pattern=\"{{incidenceType.pattern}}\" \nng-model=\"incidence.folio\" ng-model-options=\"{ debounce: F.debounceTime }\" ng-required=\"incidenceType.requiredFolio\">\n<div ng-messages=\"form.folio.$error\" ng-show=\"form.folio.$touched || form.folio.$dirty\" role=\"alert\"><div \nng-message=\"required\">Folio es requerdio</div><div ng-message=\"pattern\">Este folio no tiene el formato correcto</div>\n</div></md-input-container><md-input-container ng-if=\"incidenceType.addFolio && incidenceType.uniqueFolio\" \nclass=\"md-block\" layout-gt-xs=\"row\"><label>Folio</label><input ng-disabled=\"F.readMode\" unique-fb query=\"folio\" \nclass=\"uppercased\" ref=\"incidences/{{incidence.payroll}}/{{incidence.calendar}}\" fromid=\"{{incidence.$id}}\" \ntype=\"text\" name=\"folio\" pattern=\"{{incidenceType.pattern}}\" ng-model=\"incidence.folio\" \nng-model-options=\"{ debounce: F.debounceTime }\" ng-required=\"incidenceType.requiredFolio\"><div \nng-messages=\"form.folio.$error\" ng-show=\"form.folio.$touched || form.folio.$dirty\" role=\"alert\"><div \nng-message=\"required\">Folio es requerido</div><div ng-message=\"unique\">Este folio ya esta registrado</div><div \nng-message=\"pattern\">Este folio no tiene el formato correcto</div></div></md-input-container><md-input-container \nclass=\"md-block\" flex ng-if=\"incidenceType.isIncapacity\"><label>Tipo de incapacidad</label><md-select \nng-disabled=\"F.readMode\" ng-change=\"onChange(\'incapacityType\')\" aria-label=\"incapacity type\" \nng-model=\"incidence.incapacityType\" name=\"incapacityType\" required><md-option ng-value=\"item.id\" \nng-repeat=\"item in F.incapacityTypes track by item.id\">{{item.name}}</md-option></md-select><div \nng-messages=\"form.incapacityType.$error\" ng-show=\"form.incapacityType.$touched || form.incapacityType.$dirty\" \nrole=\"alert\"><div ng-message=\"required\">Tipo de incapacidad es requerido</div></div></md-input-container></div><div \nflex-gt-xs=\"33\" flex=\"nogrow\" ng-hide=\"!requireFile\" class=\"ml-10 mr-10 text-center\"><input type=\"hidden\" \nng-model=\"incidence.file\" ng-required=\"requireFile\"><div class=\"upload-button\"><h3 ng-hide=\"incidence.file\" \nclass=\"secondary-text text-center\">Solo PNG, JPG, GIF o PDF - Max. 2MB</h3><lf-ng-md-file-input \nng-show=\"!incidence.file\" lf-files=\"files\" ng-disabled=\"F.readMode\" \nlf-mimetype=\"image/png|image/gif|image/jpg|image/jpeg|application/pdf\" lf-placeholder=\"Archivo\" \nlf-drag-and-drop-label=\"Arrastre aquí\" lf-browse-label=\"Buscar\" lf-remove-label=\"Remover\" lf-filesize=\"2MB\" \naccept=\"image/png,image/gif,image/jpg,image/jpeg,application/pdf\" name=\"confirmationFile\" lf-api=\"imageApi\" progress \npreview drag></lf-ng-md-file-input><div ng-messages=\"form.confirmationFile.$error\" style=\"color:red\"><div \nng-message=\"required\">Archivo de confirmación requerido</div><div ng-message=\"maxcount\">Demasiados archivos</div><div \nng-message=\"filesize\">Archivo demasiado grande</div><div ng-message=\"totalsize\">El peso total es demasiado</div><div \nng-message=\"mimetype\">Tipo de archivo inválido</div></div></div><div flex><img \nng-show=\'incidence.file && incidence.file.indexOf(\".pdf\") == -1\' ng-src=\"{{incidence.file}}\" \nalt=\"Archivo de Confirmación\"><md-button ng-show=\'incidence.file && incidence.file.indexOf(\".pdf\") == -1\' \ntarget=\"_blanc\" ng-href=\"{{incidence.file}}\"><md-icon md-font-icon=\"icon-clip\" aria-label=\"adjunto\"></md-icon>\nVer en otra ventana</md-button><md-button ng-show=\'incidence.file && incidence.file.indexOf(\".pdf\") !== -1\' \ntarget=\"_blanc\" ng-href=\"{{incidence.file}}\"><md-icon md-font-icon=\"icon-file-pdf\" aria-label=\"PDF\"></md-icon>\nArchivo Adjunto</md-button></div></div></div></div></md-tab-body></md-tab></md-tabs></md-content></form></div>");
$templateCache.put("app/main/clients/views/incidences/incidences.html","<div id=\"incidences\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\" ng-controller=\"IncidencesController\">\n<div class=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div mongo-search-bar></div><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><div \nlist-filters filters-loaded=\"F.filtersLoaded\" ng-model=\"F.filters[F.active.menuName]\" on-change=\"getThem\" \ncolumns-repeat=\"columnsRepeat\" menu-obj-name=\"{{F.active.menuObjName}}\" model-name=\"{{F.active.menuName}}\" \ninit-filters=\"initFilters\"></div><div table-loader array=\"incidences\" validations=\"validations\"></div>\n<md-table-container class=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table \nmd-row-select multiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"incidences.length\"><thead md-head \nmd-order=\"F.orderMongo\" fix-head md-on-reorder=\"getThem\"><tr md-row><th md-column md-order-by=\"payroll\"><span>Nómina\n</span></th><th md-column md-order-by=\"employee\"><span>Empleado</span></th><th md-column md-order-by=\"incidenceType\">\n<span>Incidencia</span></th><th md-column md-order-by=\"folio\"><span>Folio</span></th><th md-column md-order-by=\"value\">\n<span>Cantidad</span></th><th md-column md-order-by=\"date\"><span>Fecha</span></th><th md-column md-order-by=\"calendar\">\n<span>Año</span></th><th md-column md-order-by=\"period\"><span>Periodo</span></th><th md-column md-order-by=\"status\">\n<span>Status</span></th><th md-column md-order-by=\"comments\"><span>Tipo de operación</span></th><th md-column \nmd-order-by=\"comments\"><span>Comentarios</span></th><th md-column md-order-by=\"{{column.path}}\" \nng-repeat=\"column in columnsRepeat\" ng-show=\"column.show\">{{column.name}}</th></tr></thead><tbody md-body><tr md-row \nng-class=\"{\'inactiveEmployee\': (incidence.incidenceType|getSomethingOfArrayFB:L.concepts:\'nature\':false)==\'deduction\'}\" \nmd-auto-select md-select=\"incidence\" md-select-id=\"$id\" ng-repeat=\"incidence in incidences\"><td md-cell>\n{{incidence[\'payroll-name\']}}</td><td md-cell>{{incidence[\'employee-name\']}}<md-button ng-if=\"incidence.file\" \nclass=\"md-icon-button\" target=\"_blanc\" ng-href=\"{{incidence.file}}\" aria-label=\"More\"><md-icon \nmd-font-icon=\"icon-file-outline\"></md-icon></md-button></td><td md-cell>{{incidence[\'incidenceType-name\']}}</td><td \nmd-cell>{{incidence.folio}}</td><td md-cell>{{incidence.value}}</td><td md-cell>{{incidence.date | date:F.dateFormat}}\n</td><td md-cell>{{incidence.calendar}}</td><td md-cell>{{incidence.period}}</td><td md-cell>\n{{incidence.status | incidenceStatusName}}</td><td md-cell>\n{{incidence.operationTypeName ? incidence.operationTypeName : \'Ordinaria\'}}</td><td md-cell>{{incidence.comments}}</td>\n<td md-cell ng-repeat=\"column in columnsRepeat\" ng-show=\"column.show\"><div layout=\"row\" layout-align=\"start center\">\n<div flex>{{incidence | getValueOfRecord: column}}</div><div flex=\"nogrow\"><md-button with-permission action=\"update\" \naccess=\"{{F.active.menuItem}}\" ng-if=\"column.editable(incidence)\" class=\"md-icon-button\" \nng-click=\"openModalEdit($event,column,incidence)\" aria-label=\"More\"><md-icon md-font-icon=\"icon-pencil\"></md-icon>\n</md-button></div></div></td></tr></tbody></table></md-table-container><md-table-pagination \nlayout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" ng-show=\"incidences.length\" \nmd-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" md-limit-options=\"F.paginations\" md-page=\"$parent.currentPage\" \nmd-total=\"{{pagination.total}}\" md-on-paginate=\"getThemPagination\" md-page-select></md-table-pagination></div></div>\n<md-fab-speed-dial md-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" \nclass=\"ms2-speed-dial bottom right\" ng-mouseenter=\"isOpen=true\" ng-mouseleave=\"isOpen=false\"><md-fab-trigger><md-button\n aria-label=\"crud menu\" class=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon></md-button>\n</md-fab-trigger><md-fab-actions><md-button with-permission action=\"read\" access=\"{{F.active.menuItem}}\" \nng-if=\"selected.length == 1\" \nng-click=\'R.goToDetail(null, \"read\", {incidenceId: selected[0].fid, payrollId: selected[0].payroll, payrollCalendarId: selected[0].calendar})\' \naria-label=\"view\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Ver</md-tooltip>\n<md-icon md-font-icon=\"icon-eye\" aria-label=\"view\"></md-icon></md-button><md-button with-permission action=\"export\" \naccess=\"{{F.active.menuItem}}\" \nng-click=\'exportDataToExcelByQuery(incidences,\"incidences\",getParamsObject(),pagination.total,\"catalogs/incidences/collection\")\' \naria-label=\"export\" class=\"md-fab md-raised md-mini md-primary md-hue-2\"><md-tooltip md-direction=\"left\">\nExportar a excel</md-tooltip><md-icon md-font-icon=\" icon-file-excel\" aria-label=\"export\"></md-icon></md-button>\n<md-button with-permission action=\"update\" access=\"{{F.active.menuItem}}\" \nng-if=\'selected.length == 1 && [-3, -2, -1, 0, 1, 2, 2.5].indexOf(selected[0].status) !== -1 && selected[0].type!=\"system\" && !selected[0].bySystem\' \nng-click=\'R.goToDetail(null, \"update\", {incidenceId: selected[0].fid, payrollId: selected[0].payroll, payrollCalendarId: selected[0].calendar})\' \naria-label=\"Edit\" class=\"md-fab md-raised md-accent md-hue-2 md-mini\"><md-tooltip md-direction=\"left\">\n{{\'EC.EDIT\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-pencil\" aria-label=\"Edit\"></md-icon></md-button>\n<md-button with-permission action=\"remove\" access=\"{{F.active.menuItem}}\" \nng-if=\'selected.length && !(selected|recordsHaveValue:\"type\":\"system\":\"any\")\' ng-click=\"deleteIncidences($event)\" \naria-label=\"Delete\" class=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">\n{{\'EC.REMOVE\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button>\n<md-button action=\"removeSystemIncidences\" access=\"{{F.active.menuItem}}\" \nng-if=\'selected.length && (selected|recordsHaveValue:\"type\":\"system\")\' ng-click=\"deleteIncidences($event)\" \naria-label=\"Delete\" class=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">\n{{\'EC.REMOVE\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button>\n<md-button with-permission action=\"create\" access=\"{{F.active.menuItem}}\" ng-if=\"!selected.length\" \nng-click=\'R.goToDetail(null, \"update\", {incidenceId: \"new\"})\' aria-label=\"add\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">{{\'EC.ADD\' | translate}}\n</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon></md-button><md-button with-permission \naction=\"importIncidences\" access=\"{{F.active.menuItem}}\" ng-show=\"!selected.length\" \nng-click=\"importIncidencesModal($event)\" aria-label=\"importIncidences\" \nclass=\"md-fab md-raised md-mini md-primary md-hue-3\"><md-tooltip md-direction=\"left\">Importar Incidencias</md-tooltip>\n<md-icon md-font-icon=\"icon-import\" aria-label=\"import incidences\"></md-icon></md-button><md-button with-permission \naction=\"importIncidencesGeo\" access=\"{{F.active.menuItem}}\" ng-show=\"!selected.length\" \nng-click=\"importIncidenceGeo($event)\" aria-label=\"importIncidencesGeo\" \nclass=\"md-fab md-raised md-mini md-hue-3 md-primary blue-900-bg\"><md-tooltip md-direction=\"left\">\nImportar incidencias reloj</md-tooltip><md-icon md-font-icon=\"icon-calendar-clock\" aria-label=\"import incidences\">\n</md-icon></md-button></md-fab-actions></md-fab-speed-dial></div></div>");
$templateCache.put("app/main/clients/views/newoperation/operation.html","<div id=\"newOperation\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\"><div class=\"top-bg md-accent-bg\" \nflex></div><div class=\"center\" flex layout=\"column\"><div class=\"header white-fg\" layout=\"column\" layout-gt-xs=\"row\">\n<div flex=\"nogrow\" layout=\"column\"><div flex=\"nogrow\" layout=\"row\" layout-align=\"start center\"><div flex=\"nogrow\">\n<md-button class=\"goto-button md-icon-button\" aria-label=\"Go to incidences\" ng-click=\"goToList()\" translate \ntranslate-attr-aria-label=\"EC.GO_TO\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button></div><div \nflex=\"nogrow\"><md-icon md-font-icon=\"{{F.menuItems.processes.operations.icon}}\" class=\"crud-icon\"></md-icon></div>\n</div><div flex=\"nogrow\" flex-gt-xs=\"auto\"></div></div><div flex layout=\"column\"><div flex=\"nogrow\" layout=\"column\" \nlayout-gt-xs=\"row\"><div class=\"h3\" flex layout=\"column\"><span flex>{{payroll.data.class}} {{payroll.data.name}}</span> \n<span flex>\n{{(F.addMode) ? \'Crear\' : \'\'}} {{\'operation.SINGULAR\' | translate}} Ordinaria {{operation.calendar}} - {{period.period}}\n</span></div><div flex class=\"secondary-text\" layout=\"column\"><span flex>Estatus de Operación: <b>\n{{operationStatusByEmployees | operationStatusName}}</b></span> <span flex>Fecha Inicio: <b>\n{{period.start | date:\'mediumDate\'}}</b> Fecha Fin: <b>{{period.end | date:\'mediumDate\'}}</b></span></div></div><div \nflex=\"nogrow\" class=\"text-italic\" ng-if=\"operation.comments\"><p class=\"no-margin\"><strong>Comentarios:</strong> <span \nng-bind=\"operation.comments\"></span></p></div></div></div><div class=\"content-card margin-bottom\" flex=\"100\" \nlayout=\"column\" style=\"position:relative\"><div class=\"filterToolbar no-paddingTB\" flex=\"nogrow\"><div layout=\"row\" \nlayout-align=\"space-between center\"><md-input-container class=\"md-block\" flex md-no-float><input \nng-model-options=\"{ debounce: F.debounceTime }\" placeholder=\"Filtrar Empleados\" class=\"search-input whitePlaceholder\" \ntype=\"text\" flex ng-model=\"search.employee\" ng-change=\"filterEmployees()\"></md-input-container><md-input-container \nng-if=\"employeesCcs.length>1\" class=\"md-block\" flex=\"nogrow\" md-no-float><md-select ng-model=\"search.cc\" \nplaceholder=\"Centro de costo\" ng-change=\"filterEmployees()\"><md-select-header><input autocomplete=\"off\" type=\"search\" \nclass=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"ccSelectFilter\" \nplaceholder=\"Busque un centro de costo\"></md-select-header><md-option value=\"\"><em>Todos</em></md-option><md-option \nng-class=\"{\'inactiveOption\':!cc.valid}\" ng-repeat=\"cc in employeesCcs | filter:ccSelectFilter track by cc.$id\" \nng-value=\"cc.$id\">{{cc.name}}</md-option></md-select></md-input-container><md-menu \nng-if=\"!readOnlyMode && operation.status < opStatusNotCalc && operationStatusByEmployees < nextOperationStatus\" \nflex=\"nogrow\"><md-button class=\"md-icon-button\" aria-label=\"add fast incidence\" \nng-click=\"openMenu($mdOpenMenu, $event)\"><md-tooltip md-direction=\"left\">Agregar Incidencia Rápida</md-tooltip><md-icon\n md-font-icon=\"icon-plus\" aria-label=\"fast incidence\"></md-icon></md-button><md-menu-content width=\"4\"><md-menu-item \nlayout-padding><md-input-container class=\"md-block\"><label>Filtrar Incidencias</label><input type=\"text\" \nng-model=\"fastIncidencesFilter\"></md-input-container></md-menu-item><md-menu-item \nng-repeat=\'incidenceT in incidencesTypes | filter:fastIncidencesFilter | orderBy:\"name\" | orderBy:\"-nature\" track by incidenceT.$id\'>\n<md-button ng-class=\'{\"md-warn\":incidenceT.nature==\"deduction\",\"md-primary\":incidenceT.nature==\"perception\"}\' \nng-disabled=\"fastIncidenceUsed(incidenceT.$id)\" ng-click=\"addFastIncidenceColumn(incidenceT.$id, tabName)\">\n{{incidenceT.name}}</md-button></md-menu-item></md-menu-content></md-menu><md-input-container \nng-if=\"!readOnlyMode && operation.status < opStatusNotCalc && operationStatusByEmployees<nextOperationStatus\" \nflex=\"nogrow\"><md-checkbox name=\"notCalculate\" ng-model=\"notCalculate\" ng-change=\"fireValidation(notCalculate)\">\nNo calcular</md-checkbox></md-input-container></div></div><div class=\"p-5 animate-slide-up\" ng-if=\"showProgress\"><p \nclass=\"md-subhead\" ng-bind=\"actionMessages\"></p><md-progress-linear \nstyle=\"background-image: url(\'assets/images/loading.gif\'); background-repeat: repeat-x\" md-mode=\"buffer\" \nvalue=\"{{operationProgress}}\" md-buffer-value=\"{{operationProgress}}\" ng-disabled=\"false\"></md-progress-linear></div>\n<div flex=\"nogrow\" class=\"animate-fade-in-out\"><md-tabs ng-show=\"process.length\"><md-tab \nng-repeat=\"pro in process track by pro.id\" md-on-select=\"setTabName(pro.id)\" label=\"{{pro.name}}\" \nng-if=\"pro.id!==\'rejectedIncidences\' || (pro.id===\'rejectedIncidences\' && rejectedIncidences.length>0)\"></md-tab>\n</md-tabs></div><div flex layout=\"column\" ng-if=\"tabSelected==pro.id\" ng-repeat=\"pro in process track by pro.id\" \nng-include=\"\'app/main/clients/views/newoperation/tabs/\'+pro.id+\'.html\'\"></div></div></div><md-fab-speed-dial \nmd-open=\"true\" md-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\"><md-fab-trigger>\n<md-button aria-label=\"menu\" class=\"md-fab md-accent md-hue-1 md-action\"><md-icon md-font-icon=\"icon-cube\"></md-icon>\n</md-button></md-fab-trigger><md-fab-actions><md-button with-permission action=\"readIncidences\" \naccess=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1 && !F.notCalculate\" \nng-click=\"showIncidencesListBottomSheet($event, selected[0])\" aria-label=\"incidences of employee\" \nclass=\"md-fab md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Incidencias de Empleado</md-tooltip><md-icon \nmd-font-icon=\"{{F.menuItems.config.incidencesTypes.icon}}\" aria-label=\"incidences\"></md-icon></md-button><md-button \nwith-permission action=\"readCalculations\" access=\"{{F.active.menuItem}}\" \nng-if=\"selected.length == 1 && !F.notCalculate\" ng-click=\"showCalculationsListBottomSheet($event, selected[0].$id)\" \naria-label=\"calculations of employee\" class=\"md-fab md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">\nCálculos de Empleado</md-tooltip><md-icon md-font-icon=\"icon-calculator\" aria-label=\"calculations\"></md-icon>\n</md-button><md-button ng-if=\"showRevisionOpButton && !calculating && !checking && !F.notCalculate\" \nng-click=\"confirmOperationAction($event, \'closeOperation\', operation)\" aria-label=\"send employees to revision\" \nclass=\"md-fab md-mini md-primary md-hue-3\"><md-tooltip md-direction=\"left\">Mandar a Revisión</md-tooltip><md-icon \nmd-font-icon=\"icon-calendar-check-multiple\" aria-label=\"send to revision\"></md-icon></md-button><md-button \nng-if=\"showCloseOpButton && !calculating && !checking && !F.notCalculate\" \naria-label=\"send employees to pre-bill revision\" ng-click=\"confirmOperationAction(event,\'closeOperation\',operation);\" \nclass=\"md-fab md-mini md-accent md-hue-1\"><md-icon md-font-icon=\"icon-send\" aria-label=\"send to revision\"></md-icon>\n<md-tooltip md-direction=\"left\">Cerrar Operación</md-tooltip></md-button><md-button with-permission \naction=\"reOpenInRevision\" access=\"{{F.active.menuItem}}\" \nng-if=\"((showCloseOpButton&&operationStatusByEmployees==2.5)||(showRevisionOpButton&&operationStatusByEmployees==2)) && !failCloseOperation\" \nng-click=\"confirmOperationAction(event,\'moveBackOperation\',operation);\" aria-label=\"send employeesrevision\" \nclass=\"md-fab md-mini md-warn md-hue-2\"><md-icon md-font-icon=\"icon-arrow-left\" aria-label=\"not aprove\"></md-icon>\n<md-tooltip md-direction=\"left\">Abrir Operación</md-tooltip></md-button><md-button with-permission \naction=\"receiptsSentHumand\" access=\"{{F.active.menuItem}}\" \nng-if=\'tabSelected !== \"real\" && operation.status>=3 && selected.length > 0 && allowHumand\' \nng-click=\"sendPayrollReceipt($event, selected)\" aria-label=\"calculations of employee\" class=\"md-fab md-mini md-hue-2\" \nstyle=\"background-color: #003382\"><md-tooltip md-direction=\"left\">Enviar recibo a Humand</md-tooltip><md-icon \nmd-svg-src=\"/assets/images/hum.svg\" aria-label=\"sync humand\"></md-icon></md-button><md-button with-permission \naction=\"reOpenClosed\" access=\"{{F.active.menuItem}}\" ng-if=\"showReopenButton\" \nng-click=\"confirmOperationAction(event,\'reOpenClosed\',operation);\" aria-label=\"send employeesrevision\" \nclass=\"md-fab md-mini md-warn md-hue-2\"><md-icon md-font-icon=\"icon-arrow-left\" aria-label=\"not aprove\"></md-icon>\n<md-tooltip md-direction=\"left\">Re-Abrir Operación</md-tooltip></md-button><md-button with-permission \naction=\"reOpenClosed\" access=\"{{F.active.menuItem}}\" ng-if=\"operation.oldDataOperation\" \nng-click=\"confirmOperationAction(event,\'cancelReOpen\',operation);\" aria-label=\"send employeesrevision\" \nclass=\"md-fab md-mini md-warn md-hue-2\"><md-icon md-font-icon=\"icon-reload\" aria-label=\"cancel reOpen\"></md-icon>\n<md-tooltip md-direction=\"left\">Cancelar Apertura de Nomina</md-tooltip></md-button><md-button \nng-if=\"tabSelected !== \'others\' && tabSelected !== \'rejectedIncidences\'\" \nng-click=\"exportToExcelWithHeaders(tabSelected)\" aria-label=\"export incidences\" \nclass=\"md-fab md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Exportar Sabana</md-tooltip><md-icon \nmd-font-icon=\"icon-spreadsheet\" aria-label=\"export incidences\"></md-icon></md-button></md-fab-actions>\n</md-fab-speed-dial></div>");
$templateCache.put("app/main/clients/views/newoperation/ordinary.html","<div id=\"newOperation\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\"><div class=\"top-bg md-accent-bg\" \nflex></div><div class=\"center\" flex layout=\"column\"><div class=\"header white-fg\" layout=\"column\" layout-gt-xs=\"row\">\n<div flex=\"nogrow\" layout=\"column\"><div flex=\"nogrow\" layout=\"row\" layout-align=\"start center\"><div flex=\"nogrow\">\n<md-button class=\"goto-button md-icon-button\" aria-label=\"Go to incidences\" ng-click=\"goToList()\" translate \ntranslate-attr-aria-label=\"EC.GO_TO\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button></div><div \nflex=\"nogrow\"><md-icon md-font-icon=\"{{F.menuItems.processes.operations.icon}}\" class=\"crud-icon\"></md-icon></div>\n</div><div flex=\"nogrow\" flex-gt-xs=\"auto\"></div></div><div flex layout=\"column\"><div flex=\"nogrow\" layout=\"column\" \nlayout-gt-xs=\"row\"><div class=\"h3\" flex layout=\"column\"><div flex layout=\"row\" layout-align=\"start center\"><span \nflex=\"nogrow\">{{payroll.data.class}} {{payroll.data.name}}</span> <span flex=\"nogrow\" \nng-if=\"operation.excludedEmployees\" ng-click=\"showExcludedModal($event)\" style=\"cursor: pointer\" \nclass=\"text-boxed md-orange-A400-bg orange-50-fg\">{{operation.excludedEmployees|objectsLength}} Empleado(s) excluido(s)\n</span></div><span flex>\n{{(F.addMode) ? \'Crear\' : \'\'}} {{\'operation.SINGULAR\' | translate}} Ordinaria {{operation.calendar}} - {{period.period}} \n<button aria-label=\"show previous operation\" with-permission action=\"edit\" access=\"{{F.active.menuItem}}\" \nng-click=\"goToOperation(-1)\"><md-icon md-font-icon=\"icon-arrow-left-bold-hexagon-outline\"></md-icon></button> <button \naria-label=\"show next operation\" with-permission action=\"edit\" access=\"{{F.active.menuItem}}\" \nng-click=\"goToOperation(1)\"><md-icon md-font-icon=\"icon-arrow-right-bold-hexagon-outline\"></md-icon></button></span>\n</div><div flex class=\"secondary-text\" layout=\"column\"><span flex>Estatus de Operación: <b>\n{{operationStatusByEmployees | operationStatusName}}</b></span> <span flex>Fecha Inicio: <b>\n{{period.start | date:\'mediumDate\'}}</b> Fecha Fin: <b>{{period.end | date:\'mediumDate\'}}</b></span><div flex><span \nng-if=\"operation.accuPeriod && operation.accuPeriod!==operation.period\">Periodo Acumulado: <b>{{operation.accuPeriod}}\n</b></span> <span ng-if=\"operation.forceBillingDate\">Fecha de pago: <b>\n{{operation.forceBillingDate | date:\'mediumDate\'}}</b></span></div></div></div><div flex=\"nogrow\" class=\"text-italic\" \nng-if=\"operation.comments\"><p class=\"no-margin\"><strong>Comentarios:</strong> <span ng-bind=\"operation.comments\">\n</span></p></div></div></div><div class=\"content-card margin-bottom\" flex=\"100\" layout=\"column\" \nstyle=\"position:relative\"><div class=\"filterToolbar no-paddingTB\" flex=\"nogrow\"><div layout=\"row\" \nlayout-align=\"space-between center\"><md-input-container class=\"md-block\" flex md-no-float><input \nng-model-options=\"{ debounce: F.debounceTime }\" placeholder=\"Filtrar Empleados\" class=\"search-input whitePlaceholder\" \ntype=\"text\" flex ng-model=\"search.employee\" ng-change=\"filterEmployees()\"></md-input-container><md-input-container \nng-if=\"employeesCcs.length>1\" class=\"md-block\" flex=\"nogrow\" md-no-float><md-select ng-model=\"search.cc\" \nplaceholder=\"Centro de costo\" ng-change=\"filterEmployees()\"><md-select-header><input autocomplete=\"off\" type=\"search\" \nclass=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"ccSelectFilter\" \nplaceholder=\"Busque un centro de costo\"></md-select-header><md-option value=\"\"><em>Todos</em></md-option><md-option \nng-class=\"{\'inactiveOption\':!cc.valid}\" ng-repeat=\"cc in employeesCcs | filter:ccSelectFilter track by cc.$id\" \nng-value=\"cc.$id\">{{cc.name}}({{cc.rpName}}) [{{cc.place | nameOfM: M.placesOfWorkRecords }}]</md-option></md-select>\n</md-input-container><md-menu \nng-if=\"!readOnlyMode && operation.status < opStatusNotCalc && operationStatusByEmployees < nextOperationStatus\" \nflex=\"nogrow\"><md-button class=\"md-icon-button\" aria-label=\"add fast incidence\" \nng-click=\"openMenu($mdOpenMenu, $event)\"><md-tooltip md-direction=\"left\">Agregar Incidencia Rápida</md-tooltip><md-icon\n md-font-icon=\"icon-plus\" aria-label=\"fast incidence\"></md-icon></md-button><md-menu-content width=\"4\"><md-menu-item \nlayout-padding><md-input-container class=\"md-block\"><label>Filtrar Incidencias</label><input type=\"text\" \nng-model=\"fastIncidencesFilter\"></md-input-container></md-menu-item><md-menu-item ng-if=\"incidenceT.allowFast\" \nng-repeat=\'incidenceT in incidencesTypes | filter:fastIncidencesFilter | orderBy:\"name\" | orderBy:\"-nature\" track by incidenceT.$id\'>\n<md-button ng-class=\'{\"md-warn\":incidenceT.nature==\"deduction\",\"md-primary\":incidenceT.nature==\"perception\"}\' \nng-disabled=\"fastIncidenceUsed(incidenceT.$id)\" ng-click=\"addFastIncidenceColumn(incidenceT.$id, tabName)\">\n{{incidenceT.name}}</md-button></md-menu-item></md-menu-content></md-menu><md-input-container \nng-if=\"!readOnlyMode && operation.status < opStatusNotCalc && operationStatusByEmployees<nextOperationStatus\" \nflex=\"nogrow\"><md-checkbox name=\"notCalculate\" ng-model=\"notCalculate\" ng-change=\"fireValidation(notCalculate)\">\nNo calcular</md-checkbox></md-input-container></div></div><div class=\"p-5 animate-slide-up\" ng-if=\"showProgress\"><p \nclass=\"md-subhead\" ng-bind=\"actionMessages\"></p><md-progress-linear \nstyle=\"background-image: url(\'assets/images/loading.gif\'); background-repeat: repeat-x\" md-mode=\"buffer\" \nvalue=\"{{operationProgress}}\" md-buffer-value=\"{{operationProgress}}\" ng-disabled=\"false\"></md-progress-linear></div>\n<div flex=\"nogrow\" class=\"animate-fade-in-out\"><md-tabs ng-show=\"process.length\"><md-tab \nng-repeat=\"pro in process track by pro.id\" md-on-select=\"setTabName(pro.id)\" \nlabel=\"{{pro.alias? pro.alias: pro.name}}\" \nng-if=\"pro.id!==\'rejectedIncidences\' || (pro.id===\'rejectedIncidences\' && rejectedIncidences.length>0)\"></md-tab>\n</md-tabs></div><div flex layout=\"column\" ng-if=\"tabSelected==pro.id\" ng-repeat=\"pro in process track by pro.id\" \nng-include=\"\'app/main/clients/views/newoperation/tabs/\'+pro.id+\'.html\'\"></div></div></div><md-fab-speed-dial \nmd-open=\"true\" ng-if=\"process.length>1\" md-direction=\"{{F.speedSelectedDialDirection}}\" \nclass=\"ms2-speed-dial bottom right\"><md-fab-trigger><md-button aria-label=\"menu\" \nclass=\"md-fab md-accent md-hue-1 md-action\"><md-icon md-font-icon=\"icon-cube\"></md-icon></md-button></md-fab-trigger>\n<md-fab-actions ng-if=\"!F.notCalculate && !executing && !hasErrors\"><md-button ng-if=\"showRevisionOpButton\" \nng-click=\"confirmOperationAction($event, \'closeOperation\')\" aria-label=\"send employees to revision\" \nclass=\"md-fab md-mini md-primary md-hue-3\"><md-tooltip md-direction=\"left\">Mandar a Revisión</md-tooltip><md-icon \nmd-font-icon=\"icon-calendar-check-multiple\" aria-label=\"send to revision\"></md-icon></md-button><md-button \nng-if=\"showCloseOpButton\" aria-label=\"send employees to pre-bill revision\" \nng-click=\"checkAccount($event,\'closeOperation\',operation);\" class=\"md-fab md-mini md-accent md-hue-1\"><md-icon \nmd-font-icon=\"icon-send\" aria-label=\"send to revision\"></md-icon><md-tooltip md-direction=\"left\">Cerrar Operación\n</md-tooltip></md-button><md-button with-permission action=\"reOpenInRevision\" access=\"{{F.active.menuItem}}\" \nng-if=\"((showCloseOpButton && operationStatusByEmployees==2.5)||(showRevisionOpButton && operationStatusByEmployees==2)) && !failCloseOperation\" \nng-click=\"confirmOperationAction(event,\'moveBackOperation\');\" aria-label=\"send employeesrevision\" \nclass=\"md-fab md-mini md-warn md-hue-2\"><md-icon md-font-icon=\"icon-arrow-left\" aria-label=\"not aprove\"></md-icon>\n<md-tooltip md-direction=\"left\">Abrir Operación</md-tooltip></md-button><md-button with-permission \naction=\"reOpenClosed\" access=\"{{F.active.menuItem}}\" ng-click=\"confirmOperationAction(event,\'reOpenClosed\');\" \naria-label=\"send employeesrevision\" class=\"md-fab md-mini md-warn md-hue-2\"><md-icon md-font-icon=\"icon-arrow-left\" \naria-label=\"not aprove\"></md-icon><md-tooltip md-direction=\"left\">Re-Abrir Operación</md-tooltip></md-button><md-button\n with-permission action=\"reOpenClosed\" access=\"{{F.active.menuItem}}\" ng-if=\"operation.oldDataOperation\" \nng-click=\"confirmOperationAction(event,\'cancelReOpen\');\" aria-label=\"send employeesrevision\" \nclass=\"md-fab md-mini md-warn md-hue-2\"><md-icon md-font-icon=\"icon-reload\" aria-label=\"cancel reOpen\"></md-icon>\n<md-tooltip md-direction=\"left\">Cancelar Apertura de Nomina</md-tooltip></md-button><md-button with-permission \naction=\"startBilling\" access=\"{{F.active.menuItem}}\" \nng-if=\"operation.status >= 3 && operation.status !== 4 && !operation.billing && tabSelected === \'fiscal\' && fiscalEmployees.length > 0\" \naria-label=\"send employees to pre-bill revision\" ng-click=\"startToBill($event)\" \nclass=\"md-fab md-mini md-primary md-hue-2\"><md-icon md-font-icon=\"icon-receipt\" aria-label=\"send to revision\">\n</md-icon><md-tooltip md-direction=\"left\">Iniciar timbrado</md-tooltip></md-button><md-button with-permission \naction=\"cancelBilling\" access=\"{{F.active.menuItem}}\" \nng-if=\"tabSelected===\'fiscal\' && operation.status>=5 && !operation.billing\" aria-label=\"cancelled billing\" \nng-click=\"cancelToBill(selected,$event)\" class=\"md-fab md-mini md-raised md-warn\"><md-icon \nmd-font-icon=\"icon-undo-variant\" aria-label=\"cancel bill\"></md-icon><md-tooltip md-direction=\"left\">Cancelar Recibo\n</md-tooltip></md-button><md-button with-permission action=\"readIncidences\" access=\"{{F.active.menuItem}}\" \nng-if=\"selected.length == 1\" ng-click=\"showIncidencesListBottomSheet($event, selected[0])\" \naria-label=\"incidences of employee\" class=\"md-fab md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">\nIncidencias de Empleado</md-tooltip><md-icon md-font-icon=\"{{F.menuItems.config.incidencesTypes.icon}}\" \naria-label=\"incidences\"></md-icon></md-button><md-button with-permission action=\"readCalculations\" \naccess=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" \nng-click=\"showCalculationsListBottomSheet($event, selected[0].$id)\" aria-label=\"calculations of employee\" \nclass=\"md-fab md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Cálculos de Empleado</md-tooltip><md-icon \nmd-font-icon=\"icon-calculator\" aria-label=\"calculations\"></md-icon></md-button><md-button with-permission \naction=\"receiptsSentHumand\" access=\"{{F.active.menuItem}}\" \nng-if=\'tabSelected !== \"real\" && operation.status>=3 && selected.length > 0 && allowHumand\' \nng-click=\"sendPayrollReceipt($event, selected)\" aria-label=\"calculations of employee\" class=\"md-fab md-mini md-hue-2\" \nstyle=\"background-color: #003382\"><md-tooltip md-direction=\"left\">Enviar recibo a Humand</md-tooltip><md-icon \nmd-svg-src=\"/assets/images/hum.svg\" aria-label=\"sync humand\"></md-icon></md-button><md-button with-permission \naction=\"exportAccounting\" access=\"{{F.active.menuItem}}\" \nng-if=\'tabSelected !== \"real\" && operation.status>=3 && selected.length==0\' \nng-click=\"generateAccountingAccountBy2(tabSelected)\" aria-label=\"print Payment Methods\" \nclass=\"md-fab md-mini green-800-bg md-hue-2\"><md-icon md-font-icon=\"icon-cash-usd\" \naria-label=\"generate accounting account\"></md-icon><md-tooltip md-direction=\"left\">Póliza Contable</md-tooltip>\n</md-button><md-button with-permission action=\"layoutCompaq\" access=\"{{F.active.menuItem}}\" \nng-if=\'tabSelected !== \"real\" && tabSelected !== \"fiscal\" && operation.status >= 3 && selected.length == 0\' \nng-click=\"generateAccountingAccountCompaq(tabSelected)\" aria-label=\"print Payment Methods\" \nclass=\"md-fab blue-50-bg md-mini md-hue-2\"><md-icon md-svg-src=\"/assets/icons/account.svg\"></md-icon><md-tooltip \nmd-direction=\"top\">Descargar layout contpaqi</md-tooltip></md-button><md-button with-permission action=\"layoutCompaq\" \naccess=\"{{F.active.menuItem}}\" ng-if=\'tabSelected === \"fiscal\" && operation.status === 6 && selected.length==0\' \nng-click=\"generateAccountingAccountCompaq(tabSelected)\" aria-label=\"print Payment Methods\" \nclass=\"md-fab blue-50-bg md-mini md-hue-2\"><md-icon md-svg-src=\"/assets/icons/account.svg\"></md-icon><md-tooltip \nmd-direction=\"top\">Descargar layout contpaqi</md-tooltip></md-button><md-button with-permission \naction=\"exportAnualIsrReport\" access=\"{{F.active.menuItem}}\" \nng-if=\'tabSelected === \"fiscal\" && hasAnualIsrCalculation\' ng-click=\"generateAnualAdjustmentReport()\" \naria-label=\"Generate Adjustments Methods\" class=\"md-fab md-mini md-primary md-hue-2\"><md-icon \nmd-font-icon=\"icon-calendar-check-multiple\" aria-label=\"generate anual isr report\"></md-icon><md-tooltip \nmd-direction=\"left\">Reporte de Cálculo Anual</md-tooltip></md-button><md-button with-permission \naction=\"exportOperation\" access=\"{{F.active.menuItem}}\" ng-click=\"exportReportPayroll()\" \naria-label=\"export incidences\" class=\"md-fab md-mini md-primary md-hue-2\"><md-tooltip md-direction=\"left\">\nReporte de nómina general</md-tooltip><md-icon md-font-icon=\"icon-spreadsheet\" aria-label=\"export incidences\">\n</md-icon></md-button><md-button with-permission action=\"downloadPdf\" access=\"{{F.active.menuItem}}\" \nng-if=\"tabSelected==\'fiscal\' && selected.length>0 && allHave(selected,\'billId\')\" \nclass=\"md-fab md-mini md-primary md-hue-3\" aria-label=\"Download PDF\" ng-click=\"downloadBill(selected)\"><md-icon \nmd-font-icon=\"icon-file-pdf\"></md-icon><md-tooltip md-direction=\"left\">Descargar PDF</md-tooltip></md-button><md-button\n with-permission action=\"downloadPdf\" access=\"{{F.active.menuItem}}\" \nng-if=\"tabSelected==\'fiscal\' && selected.length>0 && !allHave(selected,\'billId\') && operation.status>=3\" \nclass=\"md-fab md-mini md-primary md-hue-3\" aria-label=\"Download PDF\" \nng-click=\"downloadBills($event, selected, \'billNoBilled\')\"><md-icon md-font-icon=\"icon-file-pdf\"></md-icon><md-tooltip \nmd-direction=\"left\">Descargar PDF Provisional</md-tooltip></md-button><md-button with-permission action=\"downloadPdf\" \naccess=\"{{F.active.menuItem}}\" ng-if=\"tabSelected === \'socialPrevision\' && operation.status>=3\" \nclass=\"md-fab md-mini md-primary md-hue-3\" aria-label=\"Download PDF\" \nng-click=\"downloadBills($event, selected, \'prevision\')\"><md-icon md-font-icon=\"icon-file-pdf\"></md-icon><md-tooltip \nmd-direction=\"left\">Descargar PDF</md-tooltip></md-button><md-button with-permission action=\"downloadXml\" \naccess=\"{{F.active.menuItem}}\" ng-if=\"tabSelected==\'fiscal\' && selected.length>0 && allHave(selected,\'xmlUrl\')\" \nclass=\"md-fab md-mini md-primary md-hue-3\" aria-label=\"Download XML\" ng-click=\"downloadManyFiles(selected,\'xmlUrl\')\">\n<md-icon md-font-icon=\"icon-file-xml\"></md-icon><md-tooltip md-direction=\"left\">Descargar XML</md-tooltip></md-button>\n<md-button with-permission action=\"downloadZip\" access=\"{{F.active.menuItem}}\" ng-if=\"tabSelected==\'fiscal\'\" \nclass=\"md-fab md-mini md-hue-3\" aria-label=\"Download ZIP\" ng-click=\"downloadZipBill(selected)\"><md-icon \nmd-font-icon=\"icon-zip-box\"></md-icon><md-tooltip md-direction=\"left\">Descargar ZIP</md-tooltip></md-button><md-button \nwith-permission action=\"sendEmail\" access=\"{{F.active.menuItem}}\" \nng-if=\"tabSelected==\'fiscal\' && (selected.length>0?allHave(selected,\'billId\'):true)\" class=\"md-fab md-mini md-hue-3\" \naria-label=\"Send Email\" \nng-click=\"confirmSendEmail($event, ((selected.length>0)?{data:selected, type:\'byEmployee\'}:{data:fiscalEmployees, type:\'all\'}), \'fiscal\')\">\n<md-icon md-font-icon=\"icon-email\"></md-icon><md-tooltip md-direction=\"left\">Enviar recibo</md-tooltip></md-button>\n<md-button with-permission action=\"sendEmail\" access=\"{{F.active.menuItem}}\" \nng-if=\"tabSelected=== \'socialPrevision\' && operation.status>=3\" class=\"md-fab md-mini md-hue-3\" \naria-label=\"Send Email\" \nng-click=\"confirmSendEmail($event, ((selected.length>0)?{data:selected, type:\'byEmployee\'}:{data:operationEmployees, type:\'all\'}), \'prevision\')\">\n<md-icon md-font-icon=\"icon-email\"></md-icon><md-tooltip md-direction=\"left\">Enviar recibo</md-tooltip></md-button>\n<md-button with-permission action=\"excludeEmployees\" access=\"{{F.active.menuItem}}\" \nng-show=\"tabSelected=== \'real\' && selected.length>0\" class=\"md-fab md-mini md-warn md-raised\" aria-label=\"Send Email\" \nng-click=\"excludeEmployees($event, selected)\"><md-icon md-svg-src=\"/assets/icons/account-multiple-minus.svg\"></md-icon>\n<md-tooltip md-direction=\"left\">Excluir empleados del calculo</md-tooltip></md-button><md-button \nng-if=\'tabSelected !== \"real\" && selected.length==0\' ng-click=\"exportPaymentForms()\" \naria-label=\"print Payment Methods\" class=\"md-fab md-mini md-primary md-hue-3\"><md-icon md-font-icon=\"icon-file-pdf\" \naria-label=\"not aprove\"></md-icon><md-tooltip md-direction=\"left\">Reporte de formas de pago</md-tooltip></md-button>\n<md-button with-permission action=\"dispersionReportByBank\" access=\"{{F.active.menuItem}}\" \nng-click=\"exportDispersionPaymentForms()\" aria-label=\"print Payment Methods\" \nclass=\"md-fab md-mini md-hue-3 green-A100-bg\"><md-icon md-svg-src=\"/assets/icons/moneyBag.svg\" aria-label=\"not aprove\">\n</md-icon><md-tooltip md-direction=\"left\">Reporte de dispersión por banco</md-tooltip></md-button><div \nng-repeat=\"bankAccount in thisBankAccounts[tabSelected]\"><md-button ng-if=\"bankAccount.bankData.hasLayoutDispersion\" \nng-click=\"layoutBanks($event, bankAccount, selected)\" aria-label=\"print Layout For Bank\" \nclass=\"md-fab md-raised md-mini\"><md-tooltip md-direction=\"left\">\nLayout para {{bankAccount.name || bankAccount.bankData.name}}{{bankAccount.isSpei?\' SPEI\':\'\'}}</md-tooltip><md-icon \nng-if=\"bankAccount.bankData.icon\" md-svg-src=\"{{bankAccount.bankData.icon}}\"></md-icon><md-icon \nng-if=\"!bankAccount.bankData.icon\" md-font-icon=\"icon-credit-card-multiple\"></md-icon></md-button></div><md-button \nwith-permission \nng-if=\'tabSelected === \"fiscal\" && payroll.extraFields.tokaClientId && payroll.extraFields.tokaProduct\' \naction=\"layoutToka\" access=\"{{F.active.menuItem}}\" ng-click=\'getLayoutVales(\"toka\",selected)\' \naria-label=\"generate layout vouchers\" class=\"md-fab md-mini md-hue-3 md-blue-900-bg\"><md-icon \nmd-svg-icon=\"assets/images/logos/tokat.svg\" aria-label=\"not aprove\"></md-icon><md-tooltip md-direction=\"left\">\nLayout Vales</md-tooltip></md-button></md-fab-actions></md-fab-speed-dial></div>");
$templateCache.put("app/main/clients/views/newoperation/settlement.html","<div id=\"newOperation\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\"><div class=\"top-bg md-accent-bg\" \nflex></div><div class=\"center\" flex layout=\"column\"><div class=\"header white-fg\" layout=\"column\" layout-gt-xs=\"row\">\n<div flex=\"nogrow\" layout=\"column\"><div flex=\"nogrow\" layout=\"row\" layout-align=\"start center\"><div flex=\"nogrow\">\n<md-button class=\"goto-button md-icon-button\" aria-label=\"Go to incidences\" ng-click=\"goToList()\" translate \ntranslate-attr-aria-label=\"EC.GO_TO\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button></div><div \nflex=\"nogrow\"><md-icon md-font-icon=\"{{F.menuItems.processes.operations.icon}}\" class=\"crud-icon\"></md-icon></div>\n</div><div flex=\"nogrow\" flex-gt-xs=\"auto\"></div></div><div flex layout=\"column\"><div flex=\"nogrow\" layout=\"column\" \nlayout-gt-xs=\"row\"><div class=\"h3\" flex layout=\"column\"><span flex>{{payroll.data.class}} {{payroll.data.name}}</span> \n<span flex>Finiquito</span></div><div flex class=\"secondary-text\" layout=\"column\"><span flex>Estatus de Operación: <b>\n{{operationStatusByEmployees | operationStatusName}}</b></span> <span flex>Fecha de Alta: <b>\n{{(tabSelected==\'fiscal\'?calculations[operationEmployees[0].$id].initEmployeeDate.fiscal.result:calculations[operationEmployees[0].$id].initEmployeeDate.value.result)|date:\'mediumDate\'}}\n</b> Fecha de Baja:<b>{{operation.movement.date | date:\'mediumDate\'}}</b></span> <span \nng-if=\"operation.forceBillingDate\" flex>Fecha de pago: <b>{{operation.forceBillingDate | date:\'mediumDate\'}}</b></span>\n</div></div><div flex=\"nogrow\" class=\"text-italic\" ng-if=\"operation.comments\"><p class=\"no-margin\"><strong>Comentarios:\n</strong> <span ng-bind=\"operation.comments\"></span></p></div></div></div><div class=\"content-card margin-bottom\" \nflex=\"100\" layout=\"column\" style=\"position:relative\"><div class=\"filterToolbar no-paddingTB\" flex=\"nogrow\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div flex></div></div></div><div class=\"p-5 animate-slide-up\" \nng-if=\"showProgress\"><p class=\"md-subhead\" ng-bind=\"actionMessages\"></p><md-progress-linear \nstyle=\"background-image: url(\'assets/images/loading.gif\'); background-repeat: repeat-x\" md-mode=\"buffer\" \nvalue=\"{{operationProgress}}\" md-buffer-value=\"{{operationProgress}}\" ng-disabled=\"false\"></md-progress-linear></div>\n<div flex=\"nogrow\" class=\"animate-fade-in-out\"><md-tabs ng-show=\"process.length\"><md-tab \nng-repeat=\"pro in process track by pro.id\" md-on-select=\"setTabName(pro.id)\" \nlabel=\"{{pro.alias? pro.alias: pro.name}}\" \nng-if=\"pro.id!==\'rejectedIncidences\' || (pro.id===\'rejectedIncidences\' && rejectedIncidences.length>0)\"></md-tab>\n</md-tabs></div><div flex layout=\"column\" ng-if=\"tabSelected==pro.id\" ng-repeat=\"pro in process track by pro.id\" \nng-include=\"\'app/main/clients/views/newoperation/tabs/\'+pro.id+\'.html\'\"></div></div></div><md-fab-speed-dial \nmd-open=\"true\" ng-if=\"process.length>1\" md-direction=\"{{F.speedSelectedDialDirection}}\" \nclass=\"ms2-speed-dial bottom right\"><md-fab-trigger><md-button aria-label=\"menu\" \nclass=\"md-fab md-accent md-hue-1 md-action\"><md-icon md-font-icon=\"icon-cube\"></md-icon></md-button></md-fab-trigger>\n<md-fab-actions ng-if=\"!F.notCalculate && !executing && !hasErrors\"><md-button ng-if=\"showRevisionOpButton\" \nng-click=\"confirmOperationAction($event, \'closeOperation\')\" aria-label=\"send employees to revision\" \nclass=\"md-fab md-mini md-primary md-hue-3\"><md-tooltip md-direction=\"left\">Mandar a Revisión</md-tooltip><md-icon \nmd-font-icon=\"icon-calendar-check-multiple\" aria-label=\"send to revision\"></md-icon></md-button><md-button \nng-if=\"showCloseOpButton\" aria-label=\"send employees to pre-bill revision\" \nng-click=\"checkAccount($event,\'closeOperation\',operation);\" class=\"md-fab md-mini md-accent md-hue-1\"><md-icon \nmd-font-icon=\"icon-send\" aria-label=\"send to revision\"></md-icon><md-tooltip md-direction=\"left\">Cerrar Operación\n</md-tooltip></md-button><md-button with-permission action=\"reOpenClosed\" access=\"{{F.active.menuItem}}\" \nng-if=\"showReopenButton\" ng-click=\"confirmOperationAction(event,\'reOpenClosed\');\" aria-label=\"send employeesrevision\" \nclass=\"md-fab md-mini md-warn md-hue-2\"><md-icon md-font-icon=\"icon-arrow-left\" aria-label=\"not aprove\"></md-icon>\n<md-tooltip md-direction=\"left\">Re-Abrir Operación</md-tooltip></md-button><md-button with-permission \naction=\"reOpenClosed\" access=\"{{F.active.menuItem}}\" ng-if=\"operation.oldDataOperation\" \nng-click=\"confirmOperationAction(event,\'cancelReOpen\');\" aria-label=\"send employeesrevision\" \nclass=\"md-fab md-mini md-warn md-hue-2\"><md-icon md-font-icon=\"icon-reload\" aria-label=\"cancel reOpen\"></md-icon>\n<md-tooltip md-direction=\"left\">Cancelar Apertura de Nomina</md-tooltip></md-button><md-button with-permission \naction=\"startBilling\" access=\"{{F.active.menuItem}}\" \nng-if=\"operation.status >= 3 && operation.status !== 4 && !operation.billing && tabSelected===\'fiscal\' && fiscalEmployees.length > 0\" \naria-label=\"send employees to pre-bill revision\" ng-click=\"startToBill($event)\" \nclass=\"md-fab md-mini md-primary md-hue-2\"><md-icon md-font-icon=\"icon-receipt\" aria-label=\"send to revision\">\n</md-icon><md-tooltip md-direction=\"left\">Iniciar timbrado</md-tooltip></md-button><md-button with-permission \naction=\"cancelBilling\" access=\"{{F.active.menuItem}}\" \nng-if=\"tabSelected===\'fiscal\' && operation.status>=5 && !operation.billing\" aria-label=\"cancelled billing\" \nng-click=\"cancelToBill(selected,$event)\" class=\"md-fab md-mini md-raised md-warn\"><md-icon \nmd-font-icon=\"icon-undo-variant\" aria-label=\"cancel bill\"></md-icon><md-tooltip md-direction=\"left\">Cancelar Recibo\n</md-tooltip></md-button><md-button with-permission action=\"readIncidences\" access=\"{{F.active.menuItem}}\" \nng-click=\"showIncidencesListBottomSheet($event, operationEmployees[0])\" aria-label=\"incidences of employee\" \nclass=\"md-fab md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Incidencias de Empleado</md-tooltip><md-icon \nmd-font-icon=\"{{F.menuItems.config.incidencesTypes.icon}}\" aria-label=\"incidences\"></md-icon></md-button><md-button \nwith-permission action=\"readCalculations\" access=\"{{F.active.menuItem}}\" \nng-click=\"showCalculationsListBottomSheet($event, operationEmployees[0].$id)\" aria-label=\"calculations of employee\" \nclass=\"md-fab md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Cálculos de Empleado</md-tooltip><md-icon \nmd-font-icon=\"icon-calculator\" aria-label=\"calculations\"></md-icon></md-button><md-button with-permission \naction=\"exportAccounting\" access=\"{{F.active.menuItem}}\" \nng-if=\'tabSelected !== \"real\" && operation.status>=3 && selected.length==0\' \nng-click=\"generateAccountingAccountBy2(tabSelected)\" aria-label=\"print Payment Methods\" \nclass=\"md-fab md-mini green-800-bg md-hue-2\"><md-icon md-font-icon=\"icon-cash-usd\" \naria-label=\"generate accounting account\"></md-icon><md-tooltip md-direction=\"left\">Póliza Contable</md-tooltip>\n</md-button><md-button with-permission action=\"layoutCompaq\" access=\"{{F.active.menuItem}}\" \nng-if=\'tabSelected !== \"real\" && tabSelected !== \"fiscal\" && operation.status >= 3 && selected.length == 0\' \nng-click=\"generateAccountingAccountCompaq(tabSelected)\" aria-label=\"print Payment Methods\" \nclass=\"md-fab blue-50-bg md-mini md-hue-2\"><md-icon md-svg-src=\"/assets/icons/account.svg\"></md-icon><md-tooltip \nmd-direction=\"top\">Descargar layout contpaqi</md-tooltip></md-button><md-button with-permission action=\"layoutCompaq\" \naccess=\"{{F.active.menuItem}}\" ng-if=\'tabSelected === \"fiscal\" && operation.status === 6 && selected.length==0\' \nng-click=\"generateAccountingAccountCompaq(tabSelected)\" aria-label=\"print Payment Methods\" \nclass=\"md-fab blue-50-bg md-mini md-hue-2\"><md-icon md-svg-src=\"/assets/icons/account.svg\"></md-icon><md-tooltip \nmd-direction=\"top\">Descargar layout contpaqi</md-tooltip></md-button><md-button \nng-if=\"[\'others\',\'rejectedIncidences\', \'fiscal\', \'socialPrevision\'].indexOf(tabSelected)===-1\" \nng-click=\"exportToExcelWithHeaders(tabSelected)\" aria-label=\"export incidences\" \nclass=\"md-fab md-mini md-primary md-hue-2\"><md-tooltip md-direction=\"left\">Exportar Finiquitos</md-tooltip><md-icon \nmd-font-icon=\"icon-spreadsheet\" aria-label=\"export incidences\"></md-icon></md-button><md-button \nng-if=\"[\'fiscal\',\'socialPrevision\'].indexOf(tabSelected)>-1\" ng-click=\"exportSettlementReport(tabSelected)\" \naria-label=\"export incidences\" class=\"md-fab md-mini md-primary md-hue-3\"><md-tooltip md-direction=\"left\">\nExportar Carta</md-tooltip><md-icon md-font-icon=\"icon-file-pdf\" aria-label=\"export incidences\"></md-icon></md-button>\n<md-button with-permission action=\"exportOperation\" access=\"{{F.active.menuItem}}\" \nng-if=\"tabSelected === \'real\' && selected.length==0\" ng-click=\"exportReportPayroll()\" aria-label=\"export incidences\" \nclass=\"md-fab md-mini md-primary md-hue-2\"><md-tooltip md-direction=\"left\">Reporte de nómina general</md-tooltip>\n<md-icon md-font-icon=\"icon-spreadsheet\" aria-label=\"export incidences\"></md-icon></md-button><md-button \nwith-permission action=\"downloadPdf\" access=\"{{F.active.menuItem}}\" \nng-if=\"tabSelected==\'fiscal\' && selected.length>0 && allHave(selected,\'billId\')\" \nclass=\"md-fab md-mini md-primary md-hue-3\" aria-label=\"Download PDF\" ng-click=\"downloadBill(selected)\"><md-icon \nmd-font-icon=\"icon-file-pdf\"></md-icon><md-tooltip md-direction=\"left\">Descargar PDF</md-tooltip></md-button><md-button\n with-permission action=\"downloadXml\" access=\"{{F.active.menuItem}}\" \nng-if=\"tabSelected==\'fiscal\' && selected.length>0 && allHave(selected,\'xmlUrl\')\" \nclass=\"md-fab md-mini md-primary md-hue-3\" aria-label=\"Download XML\" ng-click=\"downloadManyFiles(selected,\'xmlUrl\')\">\n<md-icon md-font-icon=\"icon-file-xml\"></md-icon><md-tooltip md-direction=\"left\">Descargar XML</md-tooltip></md-button>\n<md-button with-permission action=\"downloadZip\" access=\"{{F.active.menuItem}}\" \nng-if=\"tabSelected==\'fiscal\' && selected.length>0 && allHave(selected,\'billId\')\" class=\"md-fab md-mini md-hue-3\" \naria-label=\"Download ZIP\" ng-click=\"downloadZipBill(selected)\"><md-icon md-font-icon=\"icon-zip-box\"></md-icon>\n<md-tooltip md-direction=\"left\">Descargar ZIP</md-tooltip></md-button><md-button with-permission action=\"sendEmail\" \naccess=\"{{F.active.menuItem}}\" \nng-if=\"tabSelected==\'fiscal\' && (selected.length>0?allHave(selected,\'billId\'):allHave(fiscalEmployees,\'billId\'))\" \nclass=\"md-fab md-mini md-hue-3\" aria-label=\"Send Email\" \nng-click=\"confirmSendEmail($event, ((selected.length>0)?{data:selected, type:\'byEmployee\'}:{data:fiscalEmployees, type:\'all\'}), \'fiscal\')\">\n<md-icon md-font-icon=\"icon-email\"></md-icon><md-tooltip md-direction=\"left\">Enviar recibo</md-tooltip></md-button><div\n ng-repeat=\"bankAccount in thisBankAccounts[tabSelected]\"><md-button ng-if=\"bankAccount.bankData.hasLayoutDispersion\" \nng-click=\"layoutBanks($event, bankAccount, selected)\" aria-label=\"print Layout For Bank\" \nclass=\"md-fab md-raised md-mini\"><md-tooltip md-direction=\"left\">\nLayout para {{bankAccount.name || bankAccount.bankData.name}}{{bankAccount.isSpei?\'SPEI\':\'\'}}</md-tooltip><md-icon \nng-if=\"bankAccount.bankData.icon\" md-svg-src=\"{{bankAccount.bankData.icon}}\"></md-icon><md-icon \nng-if=\"!bankAccount.bankData.icon\" md-font-icon=\"icon-credit-card-multiple\"></md-icon></md-button></div>\n</md-fab-actions></md-fab-speed-dial></div>");
$templateCache.put("app/main/clients/views/newoperation/special.html","<div id=\"newOperation\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\"><div class=\"top-bg md-accent-bg\" \nflex></div><div class=\"center\" flex layout=\"column\"><div class=\"header white-fg\" layout=\"column\" layout-gt-xs=\"row\">\n<div flex=\"nogrow\" layout=\"column\"><div flex=\"nogrow\" layout=\"row\" layout-align=\"start center\"><div flex=\"nogrow\">\n<md-button class=\"goto-button md-icon-button\" aria-label=\"Go to incidences\" ng-click=\"goToList()\" translate \ntranslate-attr-aria-label=\"EC.GO_TO\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button></div><div \nflex=\"nogrow\"><md-icon md-font-icon=\"{{F.menuItems.processes.operations.icon}}\" class=\"crud-icon\"></md-icon></div>\n</div><div flex=\"nogrow\" flex-gt-xs=\"auto\"></div></div><div flex layout=\"column\"><div flex=\"nogrow\" layout=\"column\" \nlayout-gt-xs=\"row\"><div class=\"h3\" flex layout=\"column\"><span flex ng-if=\"operation.companiesRecordId\">\n{{operation.companiesRecordId | getSomethingOfArrayFB : L.companiesRecords: \'name\'}}</span> <span flex ng-if=\"payroll\">\n{{payroll.data.class}} {{payroll.data.name}}</span> <span flex>\n{{\'operation.SINGULAR\' | translate}} {{operationType | getSomethingOfArrayFB : F.operationTypes :\'name\' : \'N/A\' : \'id\'}} {{operation.calendar}} - {{operation.specialPeriod}}\n</span></div><div flex class=\"secondary-text\" layout=\"column\"><span flex>Estatus de Operación: <b>\n{{operationStatusByEmployees | operationStatusName}}</b></span> <span flex>Fecha: <b>\n{{operation.specialDate | date:\'mediumDate\'}}</b></span> <span ng-if=\"operation.forceBillingDate\" flex>Fecha de pago: \n<b>{{operation.forceBillingDate | date:\'mediumDate\'}}</b></span></div></div><div flex=\"nogrow\" class=\"text-italic\" \nng-if=\"operation.comments\"><p class=\"no-margin\"><strong>Comentarios:</strong> <span ng-bind=\"operation.comments\">\n</span></p></div></div></div><div class=\"content-card margin-bottom\" flex=\"100\" layout=\"column\" \nstyle=\"position:relative\"><div class=\"filterToolbar no-paddingTB\" flex=\"nogrow\"><div layout=\"row\" \nlayout-align=\"space-between center\"><md-input-container class=\"md-block\" flex md-no-float><input \nng-model-options=\"{ debounce: F.debounceTime }\" placeholder=\"Filtrar Empleados\" class=\"search-input whitePlaceholder\" \ntype=\"text\" flex ng-model=\"search.employee\" ng-change=\"filterEmployees()\"></md-input-container><md-input-container \nng-if=\"employeesCcs.length>1\" class=\"md-block\" flex=\"nogrow\" md-no-float><md-select ng-model=\"search.cc\" \nplaceholder=\"Centro de costo\" ng-change=\"filterEmployees()\"><md-select-header><input autocomplete=\"off\" type=\"search\" \nclass=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"ccSelectFilter\" \nplaceholder=\"Busque un centro de costo\"></md-select-header><md-option value=\"\"><em>Todos</em></md-option><md-option \nng-class=\"{\'inactiveOption\':!cc.valid}\" ng-repeat=\"cc in employeesCcs | filter:ccSelectFilter track by cc.$id\" \nng-value=\"cc.$id\">{{cc.name}}</md-option></md-select></md-input-container><md-menu \nng-if=\"!readOnlyMode && operation.status < opStatusNotCalc && operationStatusByEmployees < nextOperationStatus\" \nflex=\"nogrow\"><md-button class=\"md-icon-button\" aria-label=\"add fast incidence\" \nng-click=\"openMenu($mdOpenMenu, $event)\"><md-tooltip md-direction=\"left\">Agregar Incidencia Rápida</md-tooltip><md-icon\n md-font-icon=\"icon-plus\" aria-label=\"fast incidence\"></md-icon></md-button><md-menu-content width=\"4\"><md-menu-item \nlayout-padding><md-input-container class=\"md-block\"><label>Filtrar Incidencias</label><input type=\"text\" \nng-model=\"fastIncidencesFilter\"></md-input-container></md-menu-item><md-menu-item ng-if=\"incidenceT.allowFast\" \nng-repeat=\'incidenceT in incidencesTypes | filter:fastIncidencesFilter | orderBy:\"name\" | orderBy:\"-nature\" track by incidenceT.$id\'>\n<md-button ng-class=\'{\"md-warn\":incidenceT.nature==\"deduction\",\"md-primary\":incidenceT.nature==\"perception\"}\' \nng-disabled=\"fastIncidenceUsed(incidenceT.$id)\" ng-click=\"addFastIncidenceColumn(incidenceT.$id, tabName)\">\n{{incidenceT.name}}</md-button></md-menu-item></md-menu-content></md-menu><md-input-container \nng-if=\"!readOnlyMode && operation.status < opStatusNotCalc && operationStatusByEmployees<nextOperationStatus\" \nflex=\"nogrow\"><md-checkbox name=\"notCalculate\" ng-model=\"notCalculate\" ng-change=\"fireValidation(notCalculate)\">\nNo calcular</md-checkbox></md-input-container></div></div><div class=\"p-5 animate-slide-up\" ng-if=\"showProgress\"><p \nclass=\"md-subhead\" ng-bind=\"actionMessages\"></p><md-progress-linear \nstyle=\"background-image: url(\'assets/images/loading.gif\'); background-repeat: repeat-x\" md-mode=\"buffer\" \nvalue=\"{{operationProgress}}\" md-buffer-value=\"{{operationProgress}}\" ng-disabled=\"false\"></md-progress-linear></div>\n<div flex=\"nogrow\" class=\"animate-fade-in-out\"><md-tabs ng-show=\"process.length\"><md-tab \nng-repeat=\"pro in process track by pro.id\" md-on-select=\"setTabName(pro.id)\" \nlabel=\"{{pro.alias? pro.alias: pro.name}}\" \nng-if=\"pro.id!==\'rejectedIncidences\' || (pro.id===\'rejectedIncidences\' && rejectedIncidences.length>0)\"></md-tab>\n</md-tabs></div><div flex layout=\"column\" ng-if=\"tabSelected==pro.id\" ng-repeat=\"pro in process track by pro.id\" \nng-include=\"\'app/main/clients/views/newoperation/tabs/\'+pro.id+\'.html\'\"></div></div></div><md-fab-speed-dial \nmd-open=\"true\" md-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\"><md-fab-trigger>\n<md-button aria-label=\"menu\" class=\"md-fab md-accent md-hue-1 md-action\"><md-icon md-font-icon=\"icon-cube\"></md-icon>\n</md-button></md-fab-trigger><md-fab-actions ng-if=\"!F.notCalculate && !executing && !hasErrors\"><md-button \nng-if=\"showRevisionOpButton\" ng-click=\"confirmOperationAction($event, \'closeOperation\')\" \naria-label=\"send employees to revision\" class=\"md-fab md-mini md-primary md-hue-3\"><md-tooltip md-direction=\"left\">\nMandar a Revisión</md-tooltip><md-icon md-font-icon=\"icon-calendar-check-multiple\" aria-label=\"send to revision\">\n</md-icon></md-button><md-button ng-if=\'showCloseOpButton && operationType!==\"ptuDistributionRecord\"\' \naria-label=\"send employees to pre-bill revision\" ng-click=\"checkAccount($event,\'closeOperation\',operation);\" \nclass=\"md-fab md-mini md-accent md-hue-1\"><md-icon md-font-icon=\"icon-send\" aria-label=\"send to revision\"></md-icon>\n<md-tooltip md-direction=\"left\">Cerrar Operación</md-tooltip></md-button><md-button with-permission \naction=\"reOpenInRevision\" access=\"{{F.active.menuItem}}\" \nng-if=\"((showCloseOpButton && operationStatusByEmployees==2.5)||(showRevisionOpButton && operationStatusByEmployees==2)) && !failCloseOperation\" \nng-click=\"confirmOperationAction(event,\'moveBackOperation\');\" aria-label=\"send employeesrevision\" \nclass=\"md-fab md-mini md-warn md-hue-2\"><md-icon md-font-icon=\"icon-arrow-left\" aria-label=\"not aprove\"></md-icon>\n<md-tooltip md-direction=\"left\">Abrir Operación</md-tooltip></md-button><md-button with-permission \naction=\"reOpenClosed\" access=\"{{F.active.menuItem}}\" ng-if=\"showReopenButton\" \nng-click=\"confirmOperationAction(event,\'reOpenClosed\');\" aria-label=\"send employeesrevision\" \nclass=\"md-fab md-mini md-warn md-hue-2\"><md-icon md-font-icon=\"icon-arrow-left\" aria-label=\"not aprove\"></md-icon>\n<md-tooltip md-direction=\"left\">Re-Abrir Operación</md-tooltip></md-button><md-button with-permission \naction=\"reOpenClosed\" access=\"{{F.active.menuItem}}\" ng-if=\"operation.oldDataOperation\" \nng-click=\"confirmOperationAction(event,\'cancelReOpen\');\" aria-label=\"send employeesrevision\" \nclass=\"md-fab md-mini md-warn md-hue-2\"><md-icon md-font-icon=\"icon-reload\" aria-label=\"cancel reOpen\"></md-icon>\n<md-tooltip md-direction=\"left\">Cancelar Apertura de Nomina</md-tooltip></md-button><md-button with-permission \naction=\"startBilling\" access=\"{{F.active.menuItem}}\" \nng-if=\"operation.status >= 3 && operation.status !== 4 && !operation.billing && tabSelected===\'fiscal\' && fiscalEmployees.length > 0\" \naria-label=\"send employees to pre-bill revision\" ng-click=\"startToBill($event)\" \nclass=\"md-fab md-mini md-primary md-hue-2\"><md-icon md-font-icon=\"icon-receipt\" aria-label=\"send to revision\">\n</md-icon><md-tooltip md-direction=\"left\">Iniciar timbrado</md-tooltip></md-button><md-button with-permission \naction=\"cancelBilling\" access=\"{{F.active.menuItem}}\" \nng-if=\"tabSelected===\'fiscal\' && operation.status>=5 && !operation.billing\" aria-label=\"cancelled billing\" \nng-click=\"cancelToBill(selected,$event)\" class=\"md-fab md-mini md-raised md-warn\"><md-icon \nmd-font-icon=\"icon-undo-variant\" aria-label=\"cancel bill\"></md-icon><md-tooltip md-direction=\"left\">Cancelar Recibo\n</md-tooltip></md-button><md-button with-permission action=\"readIncidences\" access=\"{{F.active.menuItem}}\" \nng-if=\"selected.length == 1\" ng-click=\"showIncidencesListBottomSheet($event, selected[0])\" \naria-label=\"incidences of employee\" class=\"md-fab md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">\nIncidencias de Empleado</md-tooltip><md-icon md-font-icon=\"{{F.menuItems.config.incidencesTypes.icon}}\" \naria-label=\"incidences\"></md-icon></md-button><md-button with-permission action=\"readCalculations\" \naccess=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" \nng-click=\"showCalculationsListBottomSheet($event, selected[0].$id)\" aria-label=\"calculations of employee\" \nclass=\"md-fab md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Cálculos de Empleado</md-tooltip><md-icon \nmd-font-icon=\"icon-calculator\" aria-label=\"calculations\"></md-icon></md-button><md-button with-permission \naction=\"exportAccounting\" access=\"{{F.active.menuItem}}\" \nng-if=\'tabSelected !== \"real\" && operation.status>=3 && selected.length==0\' \nng-click=\"generateAccountingAccountBy2(tabSelected)\" aria-label=\"print Payment Methods\" \nclass=\"md-fab md-mini green-800-bg md-hue-2\"><md-icon md-font-icon=\"icon-cash-usd\" \naria-label=\"generate accounting account\"></md-icon><md-tooltip md-direction=\"left\">Póliza Contable</md-tooltip>\n</md-button><md-button ng-if=\'tabSelected !== \"real\" && tabSelected !== \"fiscal\" && selected.length==0\' \nwith-permission action=\"dispersionReportByBank\" access=\"{{F.active.menuItem}}\" \nng-click=\"exportDispersionPaymentForms()\" aria-label=\"print Payment Methods\" \nclass=\"md-fab md-mini md-hue-3 green-A100-bg\"><md-icon md-svg-src=\"/assets/icons/moneyBag.svg\" aria-label=\"not aprove\">\n</md-icon><md-tooltip md-direction=\"left\">Reporte de dispersión por banco</md-tooltip></md-button><md-button \nwith-permission action=\"layoutCompaq\" access=\"{{F.active.menuItem}}\" \nng-if=\'tabSelected !== \"real\" && tabSelected !== \"fiscal\" && operation.status >= 3 && selected.length == 0\' \nng-click=\"generateAccountingAccountCompaq(tabSelected)\" aria-label=\"print Payment Methods\" \nclass=\"md-fab blue-50-bg md-mini md-hue-2\"><md-icon md-svg-src=\"/assets/icons/account.svg\"></md-icon><md-tooltip \nmd-direction=\"top\">Descargar layout contpaqi</md-tooltip></md-button><md-button with-permission action=\"layoutCompaq\" \naccess=\"{{F.active.menuItem}}\" ng-if=\'tabSelected === \"fiscal\" && operation.status === 6 && selected.length==0\' \nng-click=\"generateAccountingAccountCompaq(tabSelected)\" aria-label=\"print Payment Methods\" \nclass=\"md-fab blue-50-bg md-mini md-hue-2\"><md-icon md-svg-src=\"/assets/icons/account.svg\"></md-icon><md-tooltip \nmd-direction=\"top\">Descargar layout contpaqi</md-tooltip></md-button><md-button \nng-if=\"tabSelected !== \'others\' && tabSelected !== \'rejectedIncidences\'\" \nng-click=\"exportToExcelWithHeaders(tabSelected)\" aria-label=\"export incidences\" \nclass=\"md-fab md-mini md-primary md-hue-2\"><md-tooltip md-direction=\"left\">Reporte de nómina individual</md-tooltip>\n<md-icon md-font-icon=\"icon-spreadsheet\" aria-label=\"export incidences\"></md-icon></md-button><md-button \nwith-permission action=\"exportOperation\" access=\"{{F.active.menuItem}}\" \nng-if=\"tabSelected === \'real\' && operationType!== \'ptuDistributionRecord\'\" ng-click=\"exportReportPayroll()\" \naria-label=\"export incidences\" class=\"md-fab md-mini md-primary md-hue-2\"><md-tooltip md-direction=\"left\">\nReporte de nómina general</md-tooltip><md-icon md-font-icon=\"icon-spreadsheet\" aria-label=\"export incidences\">\n</md-icon></md-button><md-button with-permission action=\"downloadPdf\" access=\"{{F.active.menuItem}}\" \nng-if=\"tabSelected==\'fiscal\' && selected.length>0 && allHave(selected,\'billId\')\" \nclass=\"md-fab md-mini md-primary md-hue-3\" aria-label=\"Download PDF\" ng-click=\"downloadBill(selected)\"><md-icon \nmd-font-icon=\"icon-file-pdf\"></md-icon><md-tooltip md-direction=\"left\">Descargar PDF</md-tooltip></md-button><md-button\n with-permission action=\"downloadPdf\" access=\"{{F.active.menuItem}}\" \nng-if=\"tabSelected==\'fiscal\' && selected.length>0 && !allHave(selected,\'billId\') && operation.status>=3\" \nclass=\"md-fab md-mini md-primary md-hue-3\" aria-label=\"Download PDF\" \nng-click=\"downloadBills($event, selected, \'billNoBilled\')\"><md-icon md-font-icon=\"icon-file-pdf\"></md-icon><md-tooltip \nmd-direction=\"left\">Descargar PDF Provisional</md-tooltip></md-button><md-button with-permission action=\"downloadPdf\" \naccess=\"{{F.active.menuItem}}\" ng-if=\"tabSelected === \'socialPrevision\' && operation.status>=3\" \nclass=\"md-fab md-mini md-primary md-hue-3\" aria-label=\"Download PDF\" \nng-click=\"downloadBills($event, selected, \'prevision\')\"><md-icon md-font-icon=\"icon-file-pdf\"></md-icon><md-tooltip \nmd-direction=\"left\">Descargar PDF</md-tooltip></md-button><md-button with-permission action=\"downloadXml\" \naccess=\"{{F.active.menuItem}}\" ng-if=\"tabSelected==\'fiscal\' && selected.length>0 && allHave(selected,\'xmlUrl\')\" \nclass=\"md-fab md-mini md-primary md-hue-3\" aria-label=\"Download XML\" ng-click=\"downloadManyFiles(selected,\'xmlUrl\')\">\n<md-icon md-font-icon=\"icon-file-xml\"></md-icon><md-tooltip md-direction=\"left\">Descargar XML</md-tooltip></md-button>\n<md-button with-permission action=\"downloadZip\" access=\"{{F.active.menuItem}}\" ng-if=\"tabSelected==\'fiscal\'\" \nclass=\"md-fab md-mini md-hue-3\" aria-label=\"Download ZIP\" ng-click=\"downloadZipBill(selected)\"><md-icon \nmd-font-icon=\"icon-zip-box\"></md-icon><md-tooltip md-direction=\"left\">Descargar ZIP</md-tooltip></md-button><md-button \nwith-permission action=\"receiptsSentHumand\" access=\"{{F.active.menuItem}}\" \nng-if=\'tabSelected !== \"real\" && operation.status>=3 && selected.length > 0 && allowHumand\' \nng-click=\"sendPayrollReceipt($event, selected)\" aria-label=\"calculations of employee\" class=\"md-fab md-mini md-hue-2\" \nstyle=\"background-color: #003382\"><md-tooltip md-direction=\"left\">Enviar recibo a Humand</md-tooltip><md-icon \nmd-svg-src=\"/assets/images/hum.svg\" aria-label=\"sync humand\"></md-icon></md-button><md-button with-permission \naction=\"sendEmail\" access=\"{{F.active.menuItem}}\" \nng-if=\"tabSelected==\'fiscal\' && (selected.length>0?allHave(selected,\'billId\'):allHave(fiscalEmployees,\'billId\'))\" \nclass=\"md-fab md-mini md-hue-3\" aria-label=\"Send Email\" \nng-click=\"confirmSendEmail($event, ((selected.length>0)?{data:selected, type:\'byEmployee\'}:{data:fiscalEmployees, type:\'all\'}), \'fiscal\')\">\n<md-icon md-font-icon=\"icon-email\"></md-icon><md-tooltip md-direction=\"left\">Enviar recibo</md-tooltip></md-button>\n<md-button with-permission action=\"sendEmail\" access=\"{{F.active.menuItem}}\" \nng-if=\"tabSelected=== \'socialPrevision\' && operation.status>=3\" class=\"md-fab md-mini md-hue-3\" \naria-label=\"Send Email\" \nng-click=\"confirmSendEmail($event, ((selected.length>0)?{data:selected, type:\'byEmployee\'}:{data:operationEmployees, type:\'all\'}), \'prevision\')\">\n<md-icon md-font-icon=\"icon-email\"></md-icon><md-tooltip md-direction=\"left\">Enviar recibo</md-tooltip></md-button>\n<md-button ng-if=\'tabSelected !== \"real\"\' ng-click=\"exportPaymentForms()\" aria-label=\"print Payment Methods\" \nclass=\"md-fab md-mini md-primary md-hue-3\"><md-icon md-font-icon=\"icon-file-pdf\" aria-label=\"not aprove\"></md-icon>\n<md-tooltip md-direction=\"left\">Reporte de formas de pago</md-tooltip></md-button><div \nng-repeat=\"bankAccount in thisBankAccounts[tabSelected]\"><md-button ng-if=\"bankAccount.bankData.hasLayoutDispersion\" \nng-click=\"layoutBanks($event, bankAccount, selected)\" aria-label=\"print Layout For Bank\" \nclass=\"md-fab md-raised md-mini\"><md-tooltip md-direction=\"left\">\nLayout para {{bankAccount.name || bankAccount.bankData.name}}{{bankAccount.isSpei?\' SPEI\':\'\'}}</md-tooltip><md-icon \nng-if=\"bankAccount.bankData.icon\" md-svg-src=\"{{bankAccount.bankData.icon}}\"></md-icon><md-icon \nng-if=\"!bankAccount.bankData.icon\" md-font-icon=\"icon-credit-card-multiple\"></md-icon></md-button></div>\n</md-fab-actions></md-fab-speed-dial></div>");
$templateCache.put("app/main/clients/views/operation/operation-extraordinary.html","<div id=\"operation\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header white-fg\" layout-gt-xs=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" flex><md-button class=\"goto-button md-icon-button\" \naria-label=\"Go to incidences\" ng-click=\"R.goToList(F.active.menuName, F.active.menuParams)\" translate \ntranslate-attr-aria-label=\"EC.GO_TO\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><md-icon \nmd-font-icon=\"{{F.menuItems.clients.operations.icon}}\" class=\"crud-icon\"></md-icon><div class=\"h3\" flex \nlayout=\"column\"><span flex>\n{{(F.addMode) ? \'Crear\' : \'\'}} {{\'operation.SINGULAR\' | translate}} Extraordinaria {{calendar}} - {{periodNumber}} \n</span><span flex>{{payroll.data.name}}</span></div></div><div class=\"count secondary-text\" layout=\"column\" flex><span \nflex>Esquema de Pago: {{paymentSchema.data.name}}</span></div><div class=\"count secondary-text\" layout=\"column\" flex>\n<span sheet-mensualization-factor payroll=\"payroll\" period=\"period\" ng-model=\"operation.mensualizationFactor\">\nFactor de Mensualización: {{operation.mensualizationFactor}}</span></div></div><div class=\"content-card\" \nlayout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><h5 class=\"subTitle\">\nStatus de Operación: <b>{{operation.status | operationStatusName}}</b></h5><md-tabs md-selected=\"selectedTab\" \nmd-dynamic-height flex class=\"scrollable\"><md-tab label=\"real\" md-on-select=\'setTabName(\"REAL\")\'><ng-include \nsrc=\"\'app/main/clients/views/operation/tabs/real-extraordinary.html\'\"></ng-include></md-tab><md-tab label=\"fiscal\" \nmd-on-select=\'setTabName(\"FISCAL\")\' ng-if=\"paymentSchema.data.processes.fiscal.active\"><ng-include \nsrc=\"\'app/main/clients/views/operation/tabs/fiscal-extraordinary.html\'\"></ng-include></md-tab><md-tab \nng-repeat=\"process in paymentSchema.data.processes.complements\" label=\"{{process.name}}\" \nmd-on-select=\"setTabName(process.name)\" ng-if=\"process.active\"><ng-include \nsrc=\"\'app/main/clients/views/operation/tabs/complement-extraordinary.html\'\" ng-init=\"complementName = process.name\">\n</ng-include></md-tab></md-tabs></div></div><md-fab-speed-dial md-open=\"F.isOpen\" \nmd-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\" ng-click=\"isOpen = !isOpen\">\n<md-fab-trigger><md-button aria-label=\"crud menu\" class=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\">\n</md-icon></md-button></md-fab-trigger><md-fab-actions><md-button with-permission action=\"readIncidences\" \naccess=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" \nng-click=\"showIncidencesListBottomSheet($event, selected[0])\" aria-label=\"incidences of employee\" \nclass=\"md-fab md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Incidencias de Empleado</md-tooltip><md-icon \nmd-font-icon=\"{{F.menuItems.config.incidencesTypes.icon}}\" aria-label=\"incidences\"></md-icon></md-button><md-button \nwith-permission action=\"readCalculations\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" \nng-click=\"showCalculationsListBottomSheet($event, selected[0])\" aria-label=\"calculations of employee\" \nclass=\"md-fab md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Cálculos de Empleado</md-tooltip><md-icon \nmd-font-icon=\"icon-calculator\" aria-label=\"calculations\"></md-icon></md-button><md-button with-permission \naction=\"sendToReview\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length && operation.status == 1 && !readOnlyMode\" \nng-click=\"sendToReviewModal($event, selected, operation)\" aria-label=\"send employees to revision\" \nclass=\"md-fab md-mini md-primary md-hue-3\"><md-tooltip md-direction=\"left\">Mandar a Revisión</md-tooltip><md-icon \nmd-font-icon=\"icon-calendar-check-multiple\" aria-label=\"send to revision\"></md-icon></md-button><md-button \nwith-permission action=\"review\" access=\"{{F.active.menuItem}}\" ng-if=\"operation.status == 2 && !readOnlyMode\" \nng-click=\"reviewModal($event)\" aria-label=\"review operation\" class=\"md-fab md-mini md-accent md-hue-2\"><md-tooltip \nmd-direction=\"left\">Revisar</md-tooltip><md-icon md-font-icon=\"icon-calendar-check\" aria-label=\"review\"></md-icon>\n</md-button><md-button with-permission action=\"viewPreBill\" access=\"{{F.active.menuItem}}\" \nng-if=\"operation.status == 3\" ng-click=\"viewPreBillModal($event, operation)\" aria-label=\"view pre-bill\" \nclass=\"md-fab md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Revizar Pre-Factura</md-tooltip><md-icon \nmd-font-icon=\"icon-check\" aria-label=\"review and send pre-bill to payment\"></md-icon></md-button><md-button \nwith-permission action=\"uploadPayment\" access=\"{{F.active.menuItem}}\" \nng-if=\"operation.status == 4 && !operation.payed.referenceFile && !readOnlyMode\" ng-click=\"uploadPaymentModal($event)\" \naria-label=\"upload payment\" class=\"md-fab md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">\nSubir Comprobante de Pago</md-tooltip><md-icon md-font-icon=\"icon-auto-upload\" aria-label=\"upload\"></md-icon>\n</md-button><a md-button target=\"_blanc\" ng-href=\"{{operation.payed.referenceFile}}\" with-permission \naction=\"viewPayment\" access=\"{{F.active.menuItem}}\" ng-if=\"operation.payed.referenceFile\" aria-label=\"view payment\" \nclass=\"md-fab md-mini md-primary md-hue-3\"><md-tooltip md-direction=\"left\">Ver Comprobante de Pago</md-tooltip><md-icon\n md-font-icon=\"icon-eye\" aria-label=\"view payment\"></md-icon></a><md-button with-permission \naction=\"askPaymentConfirmation\" access=\"{{F.active.menuItem}}\" ng-if=\"operation.status == 4 && !readOnlyMode\" \nng-click=\"askPaymentConfirmationModal($event)\" aria-label=\"send to executive confirmation\" \nclass=\"md-fab md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Pedir Confirmación del Pago</md-tooltip>\n<md-icon md-font-icon=\"icon-briefcase-checked\" aria-label=\"payment confirmation\"></md-icon></md-button><md-button \nwith-permission action=\"viewPayment\" access=\"{{F.active.menuItem}}\" ng-if=\"operation.status == 5 && operation.payed\" \nng-click=\"viewPaymentModal($event, operation.payment)\" aria-label=\"review payment\" \nclass=\"md-fab md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Ver Pago</md-tooltip><md-icon \nmd-font-icon=\"icon-eye\" aria-label=\"payment confirmation\"></md-icon></md-button><md-button with-permission \naction=\"disperse\" access=\"{{F.active.menuItem}}\" ng-if=\"operation.status == 6 && !readOnlyMode\" \nng-click=\"moveOperation(operation, 7)\" aria-label=\"send to dispersion\" class=\"md-fab md-mini md-accent md-hue-2\">\n<md-tooltip md-direction=\"left\">Mandar a Dispersión</md-tooltip><md-icon md-font-icon=\"icon-clipboard-account\" \naria-label=\"send dispersion\"></md-icon></md-button><md-button with-permission action=\"confirmDispersion\" \naccess=\"{{F.active.menuItem}}\" ng-if=\"operation.status == 7 && !readOnlyMode\" ng-click=\"moveOperation(operation, 8)\" \naria-label=\"confirm the dispersion\" class=\"md-fab md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">\nConfirmar Dispersión</md-tooltip><md-icon md-font-icon=\"icon-clipboard-check\" aria-label=\"confirm dispersion\">\n</md-icon></md-button><md-button with-permission action=\"archiveOperation\" access=\"{{F.active.menuItem}}\" \nng-if=\"operation.status == 8 && !readOnlyMode\" ng-click=\"moveOperation(operation, 9)\" aria-label=\"archive dispersion\" \nclass=\"md-fab md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Archivar</md-tooltip><md-icon \nmd-font-icon=\"icon-archive\" aria-label=\"archive\"></md-icon></md-button></md-fab-actions></md-fab-speed-dial></div>\n</div>");
$templateCache.put("app/main/clients/views/operation/operation-ordinary.html","<div id=\"operation\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\"><div class=\"top-bg md-accent-bg\" flex>\n</div><div class=\"center\" flex layout=\"column\"><div class=\"header white-fg\" flex=\"nogrow\" layout=\"column\" \nlayout-gt-xs=\"row\" layout-align=\"start start\"><div layout=\"column\" layout-gt-xs=\"row\" flex \nlayout-align-gt-xs=\"start center\"><div flex=\"nogrow\" layout=\"row\" layout-align=\"start center\"><div flex=\"nogrow\">\n<md-button class=\"goto-button md-icon-button\" aria-label=\"Go to incidences\" ng-click=\"goToList()\" translate \ntranslate-attr-aria-label=\"EC.GO_TO\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button></div><md-icon \nflex=\"nogrow\" md-font-icon=\"{{F.menuItems.clients.operations.icon}}\" class=\"crud-icon\"></md-icon><span flex></span>\n</div><div class=\"h3\" flex layout=\"column\"><span flex>{{payroll.data.name}}</span> <span flex>\n{{(F.addMode) ? \'Crear\' : \'\'}} {{\'operation.SINGULAR\' | translate}} Ordinaria {{calendar}} - {{periodNumber}}</span>\n</div></div><div class=\"secondary-text\" layout=\"column\" flex><span sheet-mensualization-factor payroll=\"payroll\" \nperiod=\"period\" constants=\"constantOfPayroll.constants\" ng-model=\"operation.mensualizationFactor\" \ndataloaded=\"F.operationDataNeeded.REAL.first\" flex>Factor de Mensualización: {{operation.mensualizationFactor}}</span> \n<span flex>Status de Operación: <b>{{operationStatusByEmployees | operationStatusName}}</b></span> <span flex>\nFecha Inicio: <b>{{operationData.start | date:\'mediumDate\'}}</b> Fecha Fin: <b>\n{{operationData.end | date:\'mediumDate\'}}</b></span></div></div><div class=\"content-card margin-bottom\" flex \nlayout=\"column\"><md-tabs md-selected=\"selectedTab\" md-dynamic-height><md-tab label=\"real\" \nmd-on-select=\'setTabName(\"REAL\")\'></md-tab></md-tabs><div class=\"content fullpage-datatable\" flex layout=\"column\"><div \nflex layout=\"column\" ng-show=\"tabName==\'REAL\'\" ng-include=\"\'app/main/clients/views/operation/tabs/real-ordinary.html\'\">\n</div></div></div></div><md-fab-speed-dial md-open=\"true\" md-direction=\"{{F.speedSelectedDialDirection}}\" \nclass=\"ms2-speed-dial bottom right\"><md-fab-trigger><md-button aria-label=\"menu\" class=\"md-fab md-accent md-hue-1\">\n<md-icon md-font-icon=\"icon-cube\"></md-icon></md-button></md-fab-trigger><md-fab-actions><md-button with-permission \naction=\"readIncidences\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1 && !F.notCalculate\" \nng-click=\"showIncidencesListBottomSheet($event, selected[0])\" aria-label=\"incidences of employee\" \nclass=\"md-fab md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Incidencias de Empleado</md-tooltip><md-icon \nmd-font-icon=\"{{F.menuItems.config.incidencesTypes.icon}}\" aria-label=\"incidences\"></md-icon></md-button><md-button \nwith-permission action=\"readCalculations\" access=\"{{F.active.menuItem}}\" \nng-if=\"selected.length == 1 && !F.notCalculate\" ng-click=\"showCalculationsListBottomSheet($event, selected[0])\" \naria-label=\"calculations of employee\" class=\"md-fab md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">\nCálculos de Empleado</md-tooltip><md-icon md-font-icon=\"icon-calculator\" aria-label=\"calculations\"></md-icon>\n</md-button><md-button ng-if=\"showRevisionOpButton && !calculating && !checking && !F.notCalculate\" \nng-click=\"sendToReviewModal($event, employeesF, operation)\" aria-label=\"send employees to revision\" \nclass=\"md-fab md-mini md-primary md-hue-3\"><md-tooltip md-direction=\"left\">Mandar a Revisión</md-tooltip><md-icon \nmd-font-icon=\"icon-calendar-check-multiple\" aria-label=\"send to revision\"></md-icon></md-button><md-button \nng-if=\"showCloseOpButton && !calculating && !checking && !F.notCalculate\" \naria-label=\"send employees to pre-bill revision\" ng-click=\"confirmOperationAction(event,\'closeOperation\',operation);\" \nclass=\"md-fab md-mini md-accent md-hue-1\"><md-icon md-font-icon=\"icon-send\" aria-label=\"send to revision\"></md-icon>\n<md-tooltip md-direction=\"left\">Cerrar Operación</md-tooltip></md-button><md-button with-permission \naction=\"reOpenInRevision\" access=\"{{F.active.menuItem}}\" ng-if=\"operationStatusByEmployees==2.5\" \nng-click=\"confirmOperationAction(event,\'moveBackOperation\',operation);\" aria-label=\"send employeesrevision\" \nclass=\"md-fab md-mini md-warn md-hue-2\"><md-icon md-font-icon=\"icon-arrow-left\" aria-label=\"not aprove\"></md-icon>\n<md-tooltip md-direction=\"left\">Abrir Operación</md-tooltip></md-button><md-button with-permission \naction=\"reOpenClosed\" access=\"{{F.active.menuItem}}\" ng-if=\"showReopenButton\" \nng-click=\"confirmOperationAction(event,\'reOpenClosed\',operation);\" aria-label=\"send employeesrevision\" \nclass=\"md-fab md-mini md-warn md-hue-2\"><md-icon md-font-icon=\"icon-arrow-left\" aria-label=\"not aprove\"></md-icon>\n<md-tooltip md-direction=\"left\">Re-Abrir Operación</md-tooltip></md-button><md-button with-permission \naction=\"reOpenClosed\" access=\"{{F.active.menuItem}}\" ng-if=\"operation.oldDataOperation\" \nng-click=\"confirmOperationAction(event,\'cancelReOpen\',operation);\" aria-label=\"send employeesrevision\" \nclass=\"md-fab md-mini md-warn md-hue-2\"><md-icon md-font-icon=\"icon-reload\" aria-label=\"cancel reOpen\"></md-icon>\n<md-tooltip md-direction=\"left\">Cancelar Apertura de Nomina</md-tooltip></md-button><md-button \nng-click=\"exportToExcelWithHeaders(operation.payroll,operation.calendar,operation.period)\" \naria-label=\"export incidences\" class=\"md-fab md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">\nExportar Sabana</md-tooltip><md-icon md-font-icon=\"icon-spreadsheet\" aria-label=\"export incidences\"></md-icon>\n</md-button></md-fab-actions></md-fab-speed-dial></div>");
$templateCache.put("app/main/clients/views/operations/attendanceList.html","<div id=\"attendanceList\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\"><div class=\"top-bg md-accent-bg\" \nflex></div><div class=\"center\" flex layout=\"column\"><div class=\"header white-fg\" layout=\"column\" layout-gt-xs=\"row\">\n<div flex=\"nogrow\" layout=\"row\" layout-align=\"start start\"><div layout=\"row\" flex=\"nogrow\" \nlayout-align=\"center center\"><div flex=\"nogrow\"><md-button class=\"goto-button md-icon-button\" \naria-label=\"Go to incidences\" ng-click=\"R.goToList()\" translate translate-attr-aria-label=\"EC.GO_TO\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button></div><div flex=\"nogrow\"><md-icon \nmd-font-icon=\"{{F.menuItems.processes.attendanceLists.icon}}\" class=\"crud-icon\"></md-icon></div></div></div><div flex \nlayout=\"column\" layout-gt-xs=\"row\"><div flex flex-gt-xs=\"50\" class=\"h3\" layout=\"column\"><span flex flex-gt-xs=\"nogrow\">\nControl de asistencia <button with-permission ng-if=\"alCtrl.data.lastPeriod.period\" \naria-label=\"show previous operation\" action=\'{{alCtrl.data.readOnlyMode?\"read\":\"update\"}}\' \naccess=\"{{F.active.menuItem}}\" ng-click=\'alCtrl.goToDetail(-1,alCtrl.data.readOnlyMode?\"read\":\"update\")\'><md-icon \nmd-font-icon=\"icon-arrow-left-bold-hexagon-outline\"></md-icon></button> <button with-permission \nng-if=\"alCtrl.data.nextPeriod.period\" aria-label=\"show next operation\" \naction=\'{{alCtrl.data.readOnlyMode?\"read\":\"update\"}}\' access=\"{{F.active.menuItem}}\" \nng-click=\'alCtrl.goToDetail(1,alCtrl.data.readOnlyMode?\"read\":\"update\")\'><md-icon \nmd-font-icon=\"icon-arrow-right-bold-hexagon-outline\"></md-icon></button> </span><span flex flex-gt-xs=\"nogrow\">\n{{alCtrl.data.payroll.data.class}} {{alCtrl.data.payroll.data.name}} {{alCtrl.data.calendar}} - {{alCtrl.data.period.period}}\n</span></div><div flex flex-gt-xs=\"50\" class=\"secondary-text\" layout=\"column\"><span flex flex-gt-xs=\"nogrow\">\nEstatus de Operación: <b>{{alCtrl.allClosed?\'Cerrada\':\'Abierta\'}}</b></span> <span flex flex-gt-xs=\"nogrow\">\nFecha Inicio: <b>{{alCtrl.data.period.start | date:\'mediumDate\'}}</b> Fecha Fin: <b>\n{{alCtrl.data.period.end | date:\'mediumDate\'}}</b></span></div></div></div><div class=\"content-card margin-bottom\" \nflex=\"100\" layout=\"column\" style=\"position:relative\"><div class=\"filterToolbar no-paddingTB\" flex=\"nogrow\"><div \nlayout=\"row\" layout-align=\"space-between center\"><md-input-container class=\"md-block\" flex md-no-float><input \nng-model-options=\"{ debounce: F.debounceTime }\" placeholder=\"Filtrar Empleados\" class=\"search-input whitePlaceholder\" \ntype=\"text\" flex ng-model=\"alCtrl.search.employee\" ng-change=\"alCtrl.filterEmployees()\"></md-input-container>\n<md-input-container ng-if=\"alCtrl.data.ccs.length>1\" class=\"md-block\" flex=\"nogrow\" md-no-float><md-select \nng-model=\"alCtrl.search.cc\" placeholder=\"Centro de costo\" ng-change=\"alCtrl.filterEmployees()\"><md-select-header><input\n autocomplete=\"off\" type=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"ccSelectFilter\" \nplaceholder=\"Busque un centro de costo\"></md-select-header><md-option value=\"\"><em>Todos</em></md-option><md-option \nng-class=\"{\'inactiveOption\':!cc.valid}\" ng-repeat=\"cc in alCtrl.data.ccs | filter:ccSelectFilter track by cc.$id\" \nng-value=\"cc.$id\">{{cc.name}} [{{cc.place | nameOfM: M.placesOfWorkRecords }}]</md-option></md-select>\n</md-input-container><div flex=\"nogrow\"><md-input-container><label>Campos Extras</label><md-select \nng-model=\"extraFields\" multiple=\"multiple\"><md-option ng-value=\"field\" \nng-repeat=\"field in [{name:\'Puesto\',field:\'positionName\'}]\">{{field.name}}</md-option></md-select></md-input-container>\n</div></div></div><div flex style=\"overflow: auto\"><table class=\"miniTable simple table_sabana\"><thead><tr><th><div \nlayout=\"row\" layout-align=\"start center\"><span class=\"padding-left-10\" flex=\"nogrow\">Nombre</span><div flex \nclass=\"text-right\"><md-button class=\"md-icon-button md-primary\" aria-label=\"Settings\" \nng-click=\"alCtrl.setNextOrder(\'name\',alCtrl.order)\"><md-icon md-font-icon=\"icon-filter-variant\" \naria-label=\"Order by Date\" ng-if=\"alCtrl.order!==\'name\' && alCtrl.order!=\'-name\'\"></md-icon><md-icon \nmd-font-icon=\"icon-arrow-down\" aria-label=\"Order Descendent\" ng-if=\"alCtrl.order==\'name\'\"></md-icon><md-icon \nmd-font-icon=\"icon-arrow-up\" aria-label=\"Order Ascendent\" ng-if=\"alCtrl.order==\'-name\'\"></md-icon></md-button></div>\n</div></th><th ng-repeat=\"thisField in extraFields\"><label>{{thisField.name}}</label></th><th class=\"text-center\" \nng-repeat=\"thisDay in alCtrl.data.days\"><span ng-bind=\"thisDay.dayName+\' - \'+thisDay.dayNumber\"></span></th></tr>\n</thead><tr ng-repeat=\"employee in alCtrl.data.employees | orderBy: alCtrl.order\"><td><label class=\"pl-10\" \nng-bind=\"employee.name\">Empleado</label></td><td ng-repeat=\"thisField in extraFields\"><label \nng-bind=\"employee[thisField.field]\">Puesto</label></td><td class=\"text-center\" ng-repeat=\"thisDay in alCtrl.data.days\">\n<div ng-if=\"employee.activeDays[thisDay.id]\"><div \nng-if=\"(!employee.closed) && (!alCtrl.data.readOnlyMode) && alCtrl.data.operation.status < 3 && (!alCtrl.employeeIncidences[employee.fid+\'\'+thisDay.id].notEditable)\">\n<md-menu><md-button aria-label=\"Open incidence type\" class=\"md-raised\" \nng-class=\"{\'red-500-fg\':alCtrl.data.incidenceTypesById[alCtrl.employeeIncidences[employee.fid+\'\'+thisDay.id].incidenceType].nature===\'deduction\',\'green-500-fg\':alCtrl.data.incidenceTypesById[alCtrl.employeeIncidences[employee.fid+\'\'+thisDay.id].incidenceType].nature===\'perception\'}\" \nng-click=\"$mdOpenMenu($event)\">\n{{alCtrl.getSelectedText(alCtrl.employeeIncidences[employee.fid+\'\'+thisDay.id].incidenceType)}}<md-icon \nclass=\"red-800-fg\" ng-if=\"alCtrl.employeeIncidences[employee.fid+\'\'+thisDay.id].count > 1\" md-font-icon=\"icon-alert\">\n</md-icon><md-tooltip>\n{{alCtrl.getSelectedText(alCtrl.employeeIncidences[employee.fid+\'\'+thisDay.id].incidenceType,\'name\')}}</md-tooltip>\n</md-button><md-menu-content width=\"6\"><md-menu-item><md-button \nng-click=\"alCtrl.updateIncidence(alCtrl.employeeIncidences[employee.fid+\'\'+thisDay.id], undefined, employee.fid, thisDay.obj)\">\n<span md-menu-align-target>A - ASISTENCIA</span></md-button></md-menu-item><md-menu-item \nng-repeat=\"incidenceType in alCtrl.data.incidenceTypesManual\"><md-button \nng-class=\"{\'red-500-fg\':incidenceType.nature===\'deduction\',\'green-500-fg\':incidenceType.nature===\'perception\'}\" \nng-click=\"alCtrl.updateIncidence(alCtrl.employeeIncidences[employee.fid+\'\'+thisDay.id], incidenceType.fid, employee.fid, thisDay.obj)\">\n<span md-menu-align-target>{{incidenceType.attendanceCode}} - {{incidenceType.name}}</span></md-button></md-menu-item>\n</md-menu-content></md-menu></div><md-button \nng-if=\"employee.closed || alCtrl.data.readOnlyMode || alCtrl.data.operation.status >= 3 || alCtrl.employeeIncidences[employee.fid+\'\'+thisDay.id].notEditable\" \naria-label=\"show incidence type\" class=\"md-raised\" \nng-class=\"{\'red-500-fg\':alCtrl.data.incidenceTypesById[alCtrl.employeeIncidences[employee.fid+\'\'+thisDay.id].incidenceType].nature===\'deduction\',\'green-500-fg\':alCtrl.data.incidenceTypesById[alCtrl.employeeIncidences[employee.fid+\'\'+thisDay.id].incidenceType].nature===\'perception\'}\">\n{{alCtrl.getSelectedText(alCtrl.employeeIncidences[employee.fid+\'\'+thisDay.id].incidenceType)}}<md-icon \nmd-font-icon=\"icon-lock-outline\"></md-icon><md-tooltip>\n{{alCtrl.getSelectedText(alCtrl.employeeIncidences[employee.fid+\'\'+thisDay.id].incidenceType,\'name\')}}</md-tooltip>\n</md-button></div><span ng-if=\"!employee.activeDays[thisDay.id]\">No activo</span></td></tr></table></div></div></div>\n<md-fab-speed-dial md-open=\"true\" md-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\">\n<md-fab-trigger><md-button aria-label=\"menu\" class=\"md-fab md-accent md-hue-1 md-action\"><md-icon \nmd-font-icon=\"icon-cube\"></md-icon></md-button></md-fab-trigger><md-fab-actions><md-button with-permission \naction=\"export\" access=\"{{F.active.menuItem}}\" ng-click=\"alCtrl.exportExcel()\" aria-label=\"export incidences\" \nclass=\"md-fab md-mini md-primary md-hue-2\"><md-tooltip md-direction=\"left\">Exportar</md-tooltip><md-icon \nmd-font-icon=\"icon-spreadsheet\" aria-label=\"export incidences\"></md-icon></md-button><md-button with-permission \naction=\"close\" access=\"{{F.active.menuItem}}\" ng-if=\"!alCtrl.allClosed\" ng-click=\"alCtrl.closeAttendanceList()\" \naria-label=\"export incidences\" class=\"md-fab md-mini md-primary\"><md-tooltip md-direction=\"left\">Cerrar</md-tooltip>\n<md-icon md-font-icon=\"icon-alarm-check\" aria-label=\"export incidences\"></md-icon></md-button><md-button \nwith-permission action=\"reopen\" access=\"{{F.active.menuItem}}\" \nng-if=\"alCtrl.someClosed && alCtrl.data.operation.status < 3\" ng-click=\"alCtrl.reopenAttendanceList()\" \naria-label=\"export incidences\" class=\"md-fab md-mini md-primary\"><md-tooltip md-direction=\"left\">Reabrir</md-tooltip>\n<md-icon md-font-icon=\"icon-calendar-clock\" aria-label=\"export incidences\"></md-icon></md-button></md-fab-actions>\n</md-fab-speed-dial></div>");
$templateCache.put("app/main/clients/views/operations/attendanceListDialog.template.html","<md-dialog aria-label=\"Reabrir el control de asistencias\" flex-xs=\"50\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 \nflex>¿Desea reabrir los empleados del control de asistencia?</h2></div></md-toolbar><md-dialog-content><div>\n<md-checkbox ng-model=\"aldctrl.allSelected\" ng-click=\"aldctrl.changeAll(!aldctrl.allSelected)\" \naria-label=\"Seleccionar todos\">Seleccionar todos</md-checkbox></div><div \nng-repeat=\"employee in aldctrl.employeesClosed\"><md-checkbox ng-model=\"employee.checked\" \nng-change=\"aldctrl.checkAllSelected()\" aria-label=\"Seleccionar empleado\">{{ employee.name }}</md-checkbox></div>\n</md-dialog-content><md-dialog-actions><md-button ng-click=\"aldctrl.closeDialog()\" class=\"md-primary\">Cancelar\n</md-button><md-button ng-click=\"aldctrl.reopen()\" class=\"md-primary\">Reabrir</md-button></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/clients/views/operations/attendanceLists.html","<div id=\"attendanceLists\" class=\"page-layout carded fullwidth crud-index\" \nng-controller=\"AttendanceListsController as alsCtrl\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div mongo-search-bar></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><div list-filters filters-loaded=\"F.filtersLoaded\" \nng-model=\"F.filters[F.active.menuName]\" on-change=\"getThem\" columns-repeat=\"columnsRepeat\" \nmenu-obj-name=\"{{F.active.menuObjName}}\" model-name=\"{{F.active.menuName}}\" init-filters=\"initFilters\"></div><div \ntable-loader array=\"attendanceLists\" validations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"attendanceLists.length\"><thead md-head \nmd-order=\"F.orderMongo\" fix-head md-on-reorder=\"getThem\"><tr md-row><th md-column>Nómina</th><th md-column>Empleado(s)\n</th><th md-column>Periodo</th><th md-column>Status</th></tr></thead><tbody md-body><tr md-row \nng-class=\"attendanceList.status | getSomethingOfArrayFB : alsCtrl.operationStatus : \'class\' : \'\' : \'id\'\" \nmd-auto-select md-select=\"attendanceList\" md-select-id=\"_id\" ng-repeat=\"attendanceList in attendanceLists\"><td md-cell>\n{{attendanceList.payroll | getSomethingOfArrayFB : L.allPayrolls : \'class\'}} {{attendanceList.payroll | nameOfL:L.allPayrolls}}\n</td><td md-cell \nng-bind=\"attendanceList.employees | getFromObjectField:\'name\':(attendanceList.employees | objectsLength : 0)\"></td><td \nmd-cell ng-bind=\"attendanceList.period + \' - \' + attendanceList.calendar\"></td><td md-cell><md-icon \nmd-font-icon=\'{{attendanceList.status | nameOfStatusOperation:\"icon\"}}\'></md-icon><span>\n{{attendanceList.status | nameOfStatusOperation}}</span></td></tr></tbody></table></md-table-container>\n<md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" \nng-show=\"attendanceLists.length\" md-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" \nmd-limit-options=\"F.paginations\" md-page=\"$parent.currentPage\" md-total=\"{{pagination.total}}\" \nmd-on-paginate=\"getThemPagination\" md-page-select></md-table-pagination></div></div><md-fab-speed-dial \nmd-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\"><md-fab-trigger>\n<md-button aria-label=\"crud menu\" class=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon>\n</md-button></md-fab-trigger><md-fab-actions><md-button with-permission action=\"update\" access=\"{{F.active.menuItem}}\" \nng-if=\"selected.length===1 && selected[0].status < 3\" ng-click=\"alsCtrl.access(selected[0],\'update\')\" \naria-label=\"Modal Employees\" class=\"md-fab md-mini md-accent md-hue-2\"><md-icon md-font-icon=\"icon-open-in-app\" \naria-label=\"Edit\"></md-icon><md-tooltip md-direction=\"left\">Editar</md-tooltip></md-button><md-button with-permission \naction=\"read\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length===1\" ng-click=\"alsCtrl.access(selected[0],\'read\')\" \naria-label=\"Modal Employees\" class=\"md-fab md-mini md-accent md-hue-2\"><md-icon md-font-icon=\"icon-eye\" \naria-label=\"Edit\"></md-icon><md-tooltip md-direction=\"left\">Ver</md-tooltip></md-button></md-fab-actions>\n</md-fab-speed-dial></div></div>");
$templateCache.put("app/main/clients/views/operations/operations.html","<div id=\"operations\" class=\"page-layout carded fullwidth crud-index\" ng-controller=\"OperationsController\" layout=\"row\">\n<div class=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div mongo-search-bar></div><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><md-tabs \nng-if=\"tabs\" md-selected=\"F.selectedTab\"><md-tab ng-repeat=\"tab in tabs\" \nng-if=\"tabs[tab.name][\'operationsaccess\'+(tab.pObject?tab.pObject:\'\')]\" label=\"{{tab.title}}\" \nmd-on-select=\"$parent.setTabName(tab.name)\"></md-tab></md-tabs><div list-filters filters-loaded=\"F.filtersLoaded\" \nng-model=\"F.filters[F.active.menuName]\" on-change=\"getThem\" tab-name=\"tabName\" tab-config=\"tabs[tabName]\" \ncolumns-repeat=\"columnsRepeat\" menu-obj-name=\"{{F.active.menuObjName}}\" model-name=\"{{F.active.menuName}}\" \ninit-filters=\"initFilters\"></div><div table-loader array=\"operations\" validations=\"validations\"></div>\n<md-table-container class=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table \nmd-row-select multiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"operations.length\"><thead md-head \nmd-order=\"F.orderMongo\" fix-head md-on-reorder=\"getThem\"><tr md-row><th md-column \nng-if=\"tabConfig.name === \'ordinaryByPayroll\'\">Nómina</th><th md-column \nng-if=\"[\'ordinaryByPayroll\',\'ptuDistributionRecord\'].indexOf(tabConfig.name) === -1\" md-order-by=\"payroll\">Nómina</th>\n<th md-column ng-if=\"tabConfig.name === \'ptuDistributionRecord\'\">Empresa</th><th md-column>Empleado(s)</th><th \nmd-column md-order-by=\"period\" ng-if=\"[\'ordinary\',\'ordinaryByPayroll\'].indexOf(tabs[tabName].name) > -1\">Periodo/Fecha\n</th><th md-column md-order-by=\"movement.date\" ng-if=\"[\'settlement\'].indexOf(tabs[tabName].name) > -1\">Periodo/Fecha\n</th><th md-column md-order-by=\"specialPeriod\" \nng-if=\"[\'ordinary\',\'settlement\',\'ordinaryByPayroll\',\'ptuDistributionRecord\'].indexOf(tabs[tabName].name) === -1\">\nPeriodo/Fecha</th><th md-column md-order-by=\"calendar\" \nng-if=\"[\'ptuDistributionRecord\'].indexOf(tabs[tabName].name) > -1\">Año</th><th md-column md-order-by=\"accuPeriod\" \nng-if=\"[\'ordinaryByPayroll\',\'ptuDistributionRecord\'].indexOf(tabs[tabName].name) === -1\">Periodo Cierre</th><th \nmd-column ng-if=\"tabConfig.name === \'ordinaryByPayroll\'\">Status</th><th md-column \nng-if=\"tabConfig.name !== \'ordinaryByPayroll\'\" md-order-by=\"status\">Status</th></tr></thead><tbody md-body><tr md-row \nng-class=\"tabConfig.name==\'ordinaryByPayroll\'?(operation.status|getSomethingOfArrayFB:F.operationStatatuss:\'class\':\' \':\'id\'):\'\'\" \nmd-auto-select md-select=\"operation\" md-select-id=\"_id\" ng-repeat=\"operation in operations\"><td md-cell \nng-if=\"tabConfig.name !== \'ptuDistributionRecord\'\">\n{{operation.payroll | getSomethingOfArrayFB : L.allPayrolls : \'class\'}} {{operation.payroll | nameOfL:L.allPayrolls}}\n</td><td md-cell ng-if=\"tabConfig.name === \'ptuDistributionRecord\'\">\n{{operation.companiesRecordId | nameOfL : L.companiesRecords}}</td><td md-cell \nng-if=\"[\'settlement\'].indexOf(tabs[tabName].name) === -1\" ng-bind=\"(operation.employees | objectsLength : 0)\"></td><td \nmd-cell ng-if=\"[\'settlement\'].indexOf(tabs[tabName].name) > -1\" \nng-bind=\"operation.employees | getFromObjectField : \'name\' : \'S/N\'\"></td><td \nng-if=\"[\'ordinary\',\'ordinaryByPayroll\'].indexOf(tabs[tabName].name) >-1\" md-cell \nng-bind=\"operation.period + \' - \' + operation.calendar\"></td><td \nng-if=\"[\'settlement\'].indexOf(tabs[tabName].name) >-1\" md-cell ng-bind=\"operation.movement.date | date:F.dateFormat\">\n</td><td \nng-if=\"[\'ordinary\',\'settlement\',\'ordinaryByPayroll\',\'ptuDistributionRecord\'].indexOf(tabs[tabName].name) === -1\" \nmd-cell ng-bind=\"operation.specialPeriod+\'-\'+operation.calendar\"></td><td \nng-if=\"[\'ptuDistributionRecord\'].indexOf(tabs[tabName].name) >-1\" md-cell ng-bind=\"operation.calendar\"></td><td \nmd-cell ng-if=\"[\'ordinaryByPayroll\',\'ptuDistributionRecord\'].indexOf(tabs[tabName].name) === -1\" \nng-bind=\"operation.accuPeriod?(operation.accuPeriod + \'-\' + (operation.accuCalendar || operation.calendar)):\'\'\"></td>\n<td md-cell><md-icon md-font-icon=\'{{operation.status | nameOfStatusOperation:\"icon\"}}\'></md-icon><span>\n{{operation.status | nameOfStatusOperation}}</span></td></tr></tbody></table></md-table-container><md-table-pagination \nlayout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" ng-show=\"operations.length\" \nmd-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" md-limit-options=\"F.paginations\" md-page=\"$parent.currentPage\" \nmd-total=\"{{pagination.total}}\" md-on-paginate=\"getThemPagination\" md-page-select></md-table-pagination></div></div>\n<md-fab-speed-dial md-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" \nclass=\"ms2-speed-dial bottom right\"><md-fab-trigger><md-button aria-label=\"crud menu\" \nclass=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon></md-button></md-fab-trigger>\n<md-fab-actions><md-button \nng-if=\"tabConfig.addEditAction && editAddActions[tabConfig.addEditAction] && !selected.length && tabConfig[\'operationsadd\'+(tabConfig.pObject?tabConfig.pObject:\'\')]\" \nng-click=\"editAddActions[tabConfig.addEditAction](event, undefined, tabConfig.addParam)\" \naria-label=\"Modal Add Operation\" class=\"md-fab md-mini md-accent md-hue-2\"><md-icon md-font-icon=\"icon-plus\" \naria-label=\"Add\"></md-icon><md-tooltip md-direction=\"left\">Agregar</md-tooltip></md-button><md-button \nng-if=\"tabConfig.addEditAction && editAddActions[tabConfig.addEditAction] && selected.length === 1 && selected[0].status < 3 && tabConfig[\'operationsedit\'+(tabConfig.pObject?tabConfig.pObject:\'\')]\" \nng-click=\"editAddActions[tabConfig.addEditAction](event, selected[0],  tabConfig.editParam)\" \naria-label=\"Modal Edit Payroll\" class=\"md-fab md-mini md-accent md-hue-2\"><md-icon md-font-icon=\"icon-pencil\" \naria-label=\"Edit\"></md-icon><md-tooltip md-direction=\"left\">Editar Datos Operación</md-tooltip></md-button><md-button \nng-if=\"tabConfig.accessAction && editAddActions[tabConfig.accessAction] && selected.length === 1 && tabConfig[\'operationsedit\'+(tabConfig.pObject?tabConfig.pObject:\'\')]\" \nng-click=\"editAddActions[tabConfig.accessAction](selected[0])\" aria-label=\"Modal Employees\" \nclass=\"md-fab md-mini md-accent md-hue-2\"><md-icon md-font-icon=\"icon-open-in-app\" aria-label=\"Edit\"></md-icon>\n<md-tooltip md-direction=\"left\">Acceder/Calcular</md-tooltip></md-button><md-button \nng-if=\"[\'ordinaryByPayroll\',\'ordinary\'].indexOf(tabConfig.name)===-1 && selected.length === 1 && selected[0].status < 3 && tabConfig[\'operationsremove\'+(tabConfig.pObject?tabConfig.pObject:\'\')]\" \nng-click=\"deleteOp($event)\" aria-label=\"Settlements\" class=\"md-fab md-mini md-warn md-hue-2\"><md-icon \nmd-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon><md-tooltip md-direction=\"left\">Eliminar</md-tooltip>\n</md-button><md-button \nng-if=\'selected.length == 1 && selected[0].status >= 3 && [\"ordinary\",\"ordinaryByPayroll\"].indexOf(tabConfig.name)>-1\' \nwith-permission action=\"cleanCalculations\" access=\"{{F.active.menuItem}}\" \nng-click=\"cleanCalculations(selected[0],$event)\" aria-label=\"access\" class=\"md-fab md-mini md-warn md-hue-2\"><md-icon \nmd-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon><md-tooltip md-direction=\"left\">\nRemover operación, cálculos y acumulados(Eliminación Permanente Cuidado)</md-tooltip></md-button><md-button \nwith-permission \nng-if=\'selected.length == 1 && selected[0].status >= 3 && [\"ordinaryByPayroll\",\"chrisBonusRecord\",\"settlement\",\"special\",\"ptuRecord\",\"asimilated\",\"advAndLoanOpe\",\"travelExpensesOpe\",\"extraordinary\"].indexOf(tabConfig.name)>-1\' \naction=\"moveOperations\" access=\"{{F.active.menuItem}}\" ng-click=\"moveCalculations(selected[0],$event)\" \naria-label=\"access\" class=\"md-fab md-mini md-accent md-hue-2\"><md-icon md-font-icon=\"icon-format-line-spacing\" \naria-label=\"Move Calculation\"></md-icon><md-tooltip md-direction=\"left\">Cambiar periodo de acumulación</md-tooltip>\n</md-button><md-button with-permission action=\"startBilling\" access=\"processes.operations\" \nng-if=\'tabConfig.name!==\"special\" && selected.length === 1 && (selected[0].status===3 || (selected[0].status===5 && !selected[0].billing))\' \naria-label=\"send employees to pre-bill revision\" ng-click=\"startToBill($event,selected[0])\" \nclass=\"md-fab md-mini md-primary md-hue-2\"><md-icon md-font-icon=\"icon-receipt\" aria-label=\"send to revision\">\n</md-icon><md-tooltip md-direction=\"left\">Iniciar timbrado</md-tooltip></md-button><md-button with-permission \naction=\"exportAccounting2\" access=\"processes.operations\" ng-if=\"selected.length > 0 && checkStatusOp(selected,3)\" \nng-click=\"generateAccountingAccount(selected)\" aria-label=\"print Payment Methods\" \nclass=\"md-fab md-mini md-primary md-hue-2\"><md-icon md-font-icon=\"icon-cash-usd\" \naria-label=\"generate accounting account\"></md-icon><md-tooltip md-direction=\"left\">Póliza Contable 2</md-tooltip>\n</md-button><md-button with-permission action=\"exportAccounting\" access=\"processes.operations\" \nng-if=\"selected.length > 0 && checkStatusOp(selected,3)\" ng-click=\"generateAccountingAccount(selected,true)\" \naria-label=\"print Payment Methods\" class=\"md-fab md-mini md-primary md-hue-2\"><md-icon md-font-icon=\"icon-cash-usd\" \naria-label=\"generate accounting account\"></md-icon><md-tooltip md-direction=\"left\">Póliza Contable</md-tooltip>\n</md-button><md-button with-permission action=\"exportConcentrate\" access=\"{{F.active.menuItem}}\" \nng-if=\'[\"settlement\"].indexOf(tabConfig.name)>-1 && selected.length > 0 && checkStatusOp(selected,3)\' \naria-label=\"export\" ng-click=\"exportConcentrate(selected)\" class=\"md-fab md-raised md-mini md-primary md-hue-2\">\n<md-tooltip md-direction=\"left\">Concentrado</md-tooltip><md-icon md-font-icon=\"icon-file-excel\" aria-label=\"export\">\n</md-icon></md-button><md-button with-permission action=\"downloadZip\" access=\"processes.operations\" \nng-if=\"tabConfig.name!==\'special\' && selected.length > 0 && checkStatusOp(selected,6)\" class=\"md-fab md-mini md-hue-3\" \naria-label=\"Download ZIP\" ng-click=\"downloadZipBill(selected)\"><md-icon md-font-icon=\"icon-zip-box\"></md-icon>\n<md-tooltip md-direction=\"left\">Descargar ZIP</md-tooltip></md-button><md-button with-permission \naction=\"importCalculations\" access=\"{{F.active.menuItem}}\" ng-show=\"!selected.length\" \nng-click=\"importCalculationsModal($event)\" aria-label=\"importIncidences\" \nclass=\"md-fab md-raised md-mini md-primary md-hue-3\"><md-tooltip md-direction=\"left\">Importar Cálculos</md-tooltip>\n<md-icon md-font-icon=\"icon-import\" aria-label=\"import variables\"></md-icon></md-button><md-button with-permission \naction=\"importCalculationsV2\" access=\"{{F.active.menuItem}}\" ng-show=\"!selected.length\" \nng-click=\"importCalculationsModalV2($event)\" aria-label=\"importIncidences\" \nclass=\"md-fab md-raised md-mini md-primary md-hue-3\"><md-tooltip md-direction=\"left\">Importar Cálculos V2</md-tooltip>\n<md-icon md-font-icon=\"icon-import\" aria-label=\"import variables\"></md-icon></md-button><md-button with-permission \naction=\"forceCloseUnclosedOperation\" access=\"{{F.active.menuItem}}\" ng-click=\"forceCloseOperation($event,selected)\" \naria-label=\"close operation\" class=\"md-fab md-raised md-mini md-primary md-hue-3\"><md-tooltip md-direction=\"left\">\nCerrar operación sin cálculo</md-tooltip><md-icon md-font-icon=\"icon-close-network\" aria-label=\"close operation\">\n</md-icon></md-button><md-button ng-if=\'selected.length>0 && [\"settlement\"].indexOf(tabConfig.name)>-1\' \nng-click=\"exportDispersionLayout($event,selected)\" aria-label=\"generate dispersion layout\" \nclass=\"md-fab md-mini md-primary md-hue-3\"><md-icon md-font-icon=\"icon-cash\" aria-label=\"icon cash\"></md-icon>\n<md-tooltip md-direction=\"left\">Generar Layout Dispersion</md-tooltip></md-button></md-fab-actions></md-fab-speed-dial>\n</div></div>");
$templateCache.put("app/main/clients/views/operations/operations_old.html","<div id=\"operations\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout-gt-xs=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-calculator\"></md-icon><span>\n{{\'operation.PLURAL\' | translate}}</span></div><div class=\"count secondary-text\"><span>\n{{\'EC.TOTAL_OF\' | translate}} {{\'operation.PLURAL\' | translate}}:</span> <span>{{operations[tabName].length}}</span>\n</div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"operations-search\" class=\"search-input\" type=\"text\" \nplaceholder=\"Search\" translate translate-attr-placeholder=\"EC.SEARCH\" flex ng-model=\"F.search.operation\"><div \nclass=\"search\" flex filter-payroll></div></div></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><md-tabs md-selected=\"selectedTab\" md-dynamic-height flex \nclass=\"scrollable\" scrollable on-bottom-event=\"autoScrollBottom\"><md-tab label=\"Ordinarias\" \nmd-on-select=\'setTabName(\"ordinary\")\'><ng-include src=\"\'app/main/clients/views/operations/tabs/ordinary.html\'\">\n</ng-include></md-tab><md-tab \nlabel=\"Nominas No Timbradas [{{(data.ordinariesNotDoIt.items.length>0)?data.ordinariesNotDoIt.items.length:0}}]\" \nng-if=\"userHasPermissionOrdinariesNotDoIt\" md-on-select=\'setTabName(\"ordinariesNotDoIt\")\'><ng-include \nsrc=\"\'app/main/clients/views/operations/tabs/ordinariesNotDoIt.html\'\"></ng-include></md-tab><md-tab \nlabel=\"Nominas Timbradas [{{(data.ordinariesDoIt.items.length>0)?data.ordinariesDoIt.items.length:0}}]\" \nng-if=\"userHasPermissionOrdinariesDoIt\" md-on-select=\'setTabName(\"ordinariesDoIt\")\'><ng-include \nsrc=\"\'app/main/clients/views/operations/tabs/ordinariesDoIt.html\'\"></ng-include></md-tab><md-tab label=\"Finiquitos\" \nng-if=\"tabConfig.settlements.access\" md-on-select=\'setTabName(\"settlements\")\'><ng-include \nsrc=\"\'app/main/clients/views/operations/tabs/settlements.html\'\"></ng-include></md-tab><md-tab \nlabel=\"Finiquitos No Timbrados [{{(data.settlementsNotDoIt.items.length>0)?data.settlementsNotDoIt.items.length:0}}]\" \nng-if=\"userHasPermissionSettlementNotDoIt\" md-on-select=\'setTabName(\"settlementsNotDoIt\")\'><ng-include \nsrc=\"\'app/main/clients/views/operations/tabs/settlementsNotDoIt.html\'\"></ng-include></md-tab><md-tab \nlabel=\"Especiales\" ng-if=\"tabConfig.specials.access\" md-on-select=\'setTabName(\"specials\")\'><ng-include \nsrc=\"\'app/main/clients/views/operations/tabs/specials.html\'\"></ng-include></md-tab><md-tab label=\"Asimilados\" \nng-if=\"tabConfig.asimilated.access\" md-on-select=\'setTabName(\"asimilated\")\'><ng-include \nsrc=\"\'app/main/clients/views/operations/tabs/asimilated.html\'\"></ng-include></md-tab><md-tab \nlabel=\"Prestamos y Anticipos\" ng-if=\"tabConfig.advAndLoanOpes.access\" md-on-select=\'setTabName(\"advAndLoanOpes\")\'>\n<ng-include src=\"\'app/main/clients/views/operations/tabs/advAndLoanOpes.html\'\"></ng-include></md-tab><md-tab \nlabel=\"Viáticos\" ng-if=\"tabConfig.travelExpensesOpes.access\" md-on-select=\'setTabName(\"travelExpensesOpes\")\'>\n<ng-include src=\"\'app/main/clients/views/operations/tabs/travelExpensesOpes.html\'\"></ng-include></md-tab><md-tab \nlabel=\"PTU\" ng-if=\"tabConfig.ptuRecords.access\" md-on-select=\'setTabName(\"ptuRecords\")\'><ng-include \nsrc=\"\'app/main/clients/views/operations/tabs/ptuRecords.html\'\"></ng-include></md-tab></md-tabs></div></div>\n<md-fab-speed-dial md-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" \nclass=\"ms2-speed-dial bottom right\" ng-click=\"isOpen = !isOpen\"><md-fab-trigger><md-button aria-label=\"crud menu\" \nclass=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon></md-button></md-fab-trigger>\n<md-fab-actions><md-button with-permission action=\"uploadFile\" access=\"{{F.active.menuItem}}\" \nng-if=\"tabName === \'ordinary\' && selected.length === 1 && checkStatusOp(selected)\" ng-click=\"uploadFiles(selected)\" \naria-label=\"print Payment Methods\" class=\"md-fab md-mini md-primary md-hue-2\"><md-icon \nmd-font-icon=\"icon-cloud-upload\" aria-label=\"generate accounting account\"></md-icon><md-tooltip md-direction=\"left\">\nSubir Archivos</md-tooltip></md-button></md-fab-actions></md-fab-speed-dial></div></div>");
$templateCache.put("app/main/clients/views/operations/stampedRecords.html","<div id=\"stampedRecords\" class=\"page-layout carded fullwidth crud-index\" ng-controller=\"StampedRecordsController\" \nlayout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div mongo-search-bar>\n</div><div class=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex>\n<md-tabs ng-if=\"tabs\" md-selected=\"F.selectedTab\"><md-tab ng-repeat=\"tab in tabs\" \nng-if=\"tabs[tab.name][\'stampedRecordsaccess\'+(tab.pObject?tab.pObject:\'\')]\" label=\"{{tab.title}}\" \nmd-on-select=\"$parent.setTabName(tab.name)\"></md-tab></md-tabs><div list-filters filters-loaded=\"F.filtersLoaded\" \nng-model=\"F.filters[F.active.menuName]\" on-change=\"getThem\" tab-name=\"tabName\" tab-config=\"tabs[tabName]\" \ncolumns-repeat=\"columnsRepeat\" menu-obj-name=\"{{F.active.menuObjName}}\" model-name=\"{{F.active.menuName}}\" \ninit-filters=\"initFilters\"></div><div table-loader array=\"stampedRecords\" validations=\"validations\"></div>\n<md-table-container class=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table \nmd-row-select multiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"stampedRecords.length\"><thead md-head \nmd-order=\"F.orderMongo\" fix-head md-on-reorder=\"getThem\"><tr md-row><th md-column md-order-by=\"payroll\">Nómina</th><th \nmd-column>Empleado(s)</th><th md-column md-order-by=\"period\" ng-if=\"tabs[tabName].name === \'ordinary\'\">Periodo/Fecha\n</th><th md-column md-order-by=\"movement.date\" ng-if=\"tabs[tabName].name === \'settlement\'\">Periodo/Fecha</th><th \nmd-column ng-if=\"tabs[tabName].name === \'allOpes\'\">Periodo</th><th md-column md-order-by=\"billingDate\" \nng-if=\"tabs[tabName].name === \'allOpes\'\">Fecha de timbrado</th><th md-column md-order-by=\"specialPeriod\" \nng-if=\"[\'ordinary\',\'settlement\',\'allOpes\'].indexOf(tabs[tabName].name) === -1\">Periodo/Fecha</th><th \nmd-order-by=\"accuPeriod\" md-column>Periodo Cierre</th><th md-column>Status</th><th md-column>Tipo de operación</th>\n</tr></thead><tbody md-body><tr md-row \nng-class=\"{\'inactiveEmployee\': stampedRecord.status === \'error\', \'statusCancel\': stampedRecord.status === \'cancelled\'}\" \nmd-auto-select md-select=\"operation\" md-select-id=\"_id\" ng-repeat=\"operation in stampedRecords\"><td md-cell>\n{{operation.payroll | getSomethingOfArrayFB : L.allPayrolls : \'class\'}} {{operation.payroll | nameOfL:L.allPayrolls}}\n</td><td md-cell ng-bind=\"operation.employees | getFromObjectField:\'name\':(operation.employees | objectsLength)\"></td>\n<td ng-if=\"tabs[tabName].name === \'ordinary\'\" md-cell ng-bind=\"operation.period + \' - \' + operation.calendar\"></td><td \nng-if=\"tabs[tabName].name === \'settlement\'\" md-cell ng-bind=\"operation.movement.date | date:F.dateFormat\"></td><td \nng-if=\"tabs[tabName].name === \'allOpes\'\" md-cell ng-bind=\"operation.specialPeriod || operation.period\"></td><td \nng-if=\"tabs[tabName].name === \'allOpes\'\" md-cell ng-bind=\"operation.billingDate | date:F.dateFormat\"></td><td \nng-if=\"[\'ordinary\',\'settlement\',\'allOpes\'].indexOf(tabs[tabName].name) === -1\" md-cell \nng-bind=\"operation.specialPeriod\"></td><td md-cell ng-bind=\"operation.accuPeriod + \'-\' + operation.calendar\"></td><td \nmd-cell><md-icon md-font-icon=\'{{operation.status | nameOfStatusOperation:\"icon\"}}\'></md-icon><span>\n{{operation.status | nameOfStatusOperation}}</span></td><td md-cell ng-bind=\"\'b.\'+operation.operationType | translate\">\n</td></tr></tbody></table></md-table-container><md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" \nlayout-xs=\"column\" ng-show=\"stampedRecords.length\" md-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" \nmd-limit-options=\"F.paginations\" md-page=\"$parent.currentPage\" md-total=\"{{pagination.total}}\" \nmd-on-paginate=\"getThemPagination\" md-page-select></md-table-pagination></div></div><md-fab-speed-dial \nmd-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\"><md-fab-trigger>\n<md-button aria-label=\"crud menu\" class=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon>\n</md-button></md-fab-trigger><md-fab-actions><md-button \nng-if=\"tabs[tabName][(tabs[tabName].editP?tabs[tabName].editP:(\'operationsedit\'+(tabs[tabName].pObject?tabs[tabName].pObject:\'\')))] && selected.length === 1\" \nng-click=\"goToDetail(selected[0])\" aria-label=\"Modal Employees\" class=\"md-fab md-mini md-accent md-hue-2\"><md-icon \nmd-font-icon=\"icon-open-in-app\" aria-label=\"Edit\"></md-icon><md-tooltip md-direction=\"left\">Acceder</md-tooltip>\n</md-button><md-button with-permission action=\"forcedInvoices\" access=\"processes.operations\" \nng-if=\"selected.length === 1 && (selected[0].status===3 || (selected[0].status===5 && !selected[0].billing))\" \naria-label=\"send employees to pre-bill revision\" ng-click=\"forceBill($event,selected[0])\" \nclass=\"md-fab md-mini md-cyan-900-bg md-hue-2\"><md-icon md-svg-src=\"/assets/icons/check.svg\" \naria-label=\"send to revision\"></md-icon><md-tooltip md-direction=\"left\">Marcar operación como timbrada</md-tooltip>\n</md-button><md-button with-permission action=\"startBilling\" access=\"processes.operations\" \nng-if=\"selected.length === 1 && (selected[0].status===3 || (selected[0].status===5 && !selected[0].billing))\" \naria-label=\"send employees to pre-bill revision\" ng-click=\"startToBill($event,selected[0])\" \nclass=\"md-fab md-mini md-primary md-hue-2\"><md-icon md-font-icon=\"icon-receipt\" aria-label=\"send to revision\">\n</md-icon><md-tooltip md-direction=\"left\">Iniciar timbrado</md-tooltip></md-button><md-button with-permission \naction=\"downloadZip\" access=\"processes.operations\" ng-if=\"selected.length > 0 && checkStatusOp(selected,6)\" \nclass=\"md-fab md-mini md-hue-3\" aria-label=\"Download ZIP\" ng-click=\"downloadZipBill(selected)\"><md-icon \nmd-font-icon=\"icon-zip-box\"></md-icon><md-tooltip md-direction=\"left\">Descargar ZIP</md-tooltip></md-button><md-button \nwith-permission action=\"exportAccounting\" access=\"processes.operations\" \nng-if=\"selected.length > 0 && checkStatusOp(selected,3)\" ng-click=\"generateAccountingAccount(selected)\" \naria-label=\"print Payment Methods\" class=\"md-fab md-mini md-primary md-hue-2\"><md-icon md-font-icon=\"icon-cash-usd\" \naria-label=\"generate accounting account\"></md-icon><md-tooltip md-direction=\"left\">Póliza Contable</md-tooltip>\n</md-button></md-fab-actions></md-fab-speed-dial></div></div>");
$templateCache.put("app/main/clients/views/payrollCalendars/payrollCalendar.html","<div id=\"payrollCalendar\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill \nng-controller=\"PayrollCalendarController\"><form name=\"form\" novalidate flex layout=\"column\"><md-toolbar \nclass=\"md-tall header md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" \nlayout-align=\"start center\" flex><md-button class=\"goto-button md-icon-button\" aria-label=\"Go to payrollCalendars\" \nng-click=\"R.goToList(F.active.menuName, F.active.menuParams)\" translate translate-attr-aria-label=\"EC.GO_TO\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"{{F.menuItems.clients.payrollCalendars.icon || F.default.icon}}\" class=\"crud-icon\"></md-icon><div \nlayout=\"column\" layout-align=\"start start\"><div class=\"h2\">\n{{payrollCalendar.payroll | nameOfL: L.allPayrolls}} - {{payrollCalendar.data.year}}</div><div \nclass=\"subtitle secondary-text\"><span ng-if=\"!F.addMode\">\n{{\'EC.DETAIL_OF\' | translate}} {{\'payrollCalendar.SINGULAR\' | translate}}</span> <span ng-if=\"F.addMode\">\n{{\'EC.CREATE\' | translate}} {{\'payrollCalendar.SINGULAR\' | translate}}</span></div></div></div></div><div><md-button \ntype=\"submit\" ng-if=\"!F.addMode && !F.readMode\" with-permission action=\"update\" access=\"{{F.active.menuItem}}\" \nng-click=\"saveCalendarAndPeriods(payrollCalendar, dataToCreate)\" ng-hide=\"form.$pristine\" \nng-disabled=\"form.$invalid || loadingProgress\" class=\"md-raised md-background md-fab md-accent md-hue-1\" \naria-label=\"Save payrollCalendar\"><md-tooltip md-direction=\"left\">{{\'EC.SAVE\' | translate}}</md-tooltip><md-icon \nmd-font-icon=\"icon-content-save\" aria-label=\"Save\"></md-icon></md-button><md-button type=\"submit\" ng-if=\"F.addMode\" \nwith-permission action=\"create\" access=\"{{F.active.menuItem}}\" \nng-click=\"addCalendarAndPeriods(payrollCalendar, dataToCreate)\" ng-hide=\"form.$pristine\" \nng-disabled=\"form.$invalid || loadingProgress\" class=\"md-raised md-background md-fab md-accent md-hue-1\" \naria-label=\"Add payrollCalendar\"><md-tooltip md-direction=\"left\">{{\'EC.ADD\' | translate}}</md-tooltip><md-icon \nmd-font-icon=\"icon-content-save\" aria-label=\"Add\"></md-icon></md-button></div></md-toolbar><md-content layout=\"column\" \nclass=\"content\" flex><div class=\"detail-form-container md-background-bg md-whiteframe-1dp\"><div layout-gt-xs=\"row \">\n<md-input-container class=\"md-block\" flex-gt-xs><label>Nómina</label><md-select ms2-autofocus \nng-model=\"payrollCalendar.payroll\" required ng-change=\"watchInitialDate()\" ng-disabled=\"!F.addMode\"><md-select-header>\n<input autocomplete=\"off\" type=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" \nng-model=\"payrollSelectFilter\" placeholder=\"Busque una nomina \"></md-select-header><md-option \nng-if=\"!F.permissionToAccessAllPayrolls\" ng-value=\"payroll.$id\" ng-disabled=\"!payroll.active\" \nng-repeat=\"payroll in L.payrolls | orderBy:\'name\' | filter:payrollSelectFilter\">{{payroll.name}}</md-option><md-option \nng-if=\"F.permissionToAccessAllPayrolls\" ng-value=\"payroll.$id\" ng-disabled=\"!payroll.active\" \nng-repeat=\"payroll in L.allPayrolls | orderBy:\'name\' | filter:payrollSelectFilter\">{{payroll.name}}</md-option>\n</md-select></md-input-container></div><div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex-gt-xs><label>\nPeriodo Inicial</label><input ng-disabled=\"!F.addMode||F.readMode||!payrollCalendar.payroll\" type=\"number\" \nng-pattern=\"/^[0-9]{1,3}$/\" name=\"initialPeriod\" ng-model=\"payrollCalendar.data.initialPeriod\" \nng-model-options=\"{ debounce: F.debounceTime }\" ng-change=\"watchInitialDate(payrollCalendar.data.initialPeriod)\"><div \nng-messages=\"form.initialPeriod.$error\"><div ng-message=\"pattern\">Ingrese un número entero valido</div></div>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-xs><label>Año</label><input \nng-disabled=\"!F.addMode||F.readMode||!payrollCalendar.payroll\" type=\"number\" name=\"year\" \nng-model=\"payrollCalendar.data.year\" ng-model-options=\"{ debounce: F.debounceTime }\" unique-fb-key ref=\"{{mainRef}}\" \nfromid=\"{{payrollCalendar.$id}}\" \nng-change=\'watchInitialDate({year:payrollCalendar.data.year, type:\"year\", form: form})\' required><div \nng-messages=\"form.year.$error\" \nng-show=\"(form.year.$error && !form.year.$pristine) || (form.year.$error && payrollCalendar.data.year)\"><div \nng-message=\"unique\">El año que ingreso ya tiene periodos</div><div ng-message=\"validationYear\">{{messageYear}}</div>\n<div ng-message=\"unique\">El año es requerido</div></div></md-input-container><md-input-container class=\"md-block\" \nflex-gt-xs=\"nogrow\"><label>Fecha Inicio</label><md-datepicker class=\"md-block\" md-hide-icons=\"triangle\" \nng-disabled=\"!F.addMode||F.readMode||!payrollCalendar.payroll\" md-min-date=\"minStartDate\" md-max-date=\"maxStartDate\" \ninput-date-miliseconds name=\"initialDate\" ng-model=\"initialDate\" required ng-change=\"watchInitialDate(initialDate)\">\n</md-datepicker><div ng-messages=\"form.initialDate.$error\" \nng-show=\"(form.initialDate.$error && !form.initialDate.$pristine) || (form.initialDate.$error && initialDate)\"><div \nng-message=\"required\">Fecha Inicio es requerido</div><div ng-message=\"max\">\nFecha Inicio debe ser antes de {{maxStartDate | date}}</div><div ng-message=\"maxdate\">\nFecha Inicio debe ser antes de {{maxStartDate | date}}</div></div></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-xs=\"nogrow\"><label>Fecha Fin</label><md-datepicker class=\"md-block\" md-hide-icons=\"triangle\" \nng-disabled=\"!F.addMode||F.readMode||!payrollCalendar.payroll\" md-min-date=\"minEndDate\" md-max-date=\"maxEndDate\" \ninput-date-miliseconds name=\"lastDate\" ng-model=\"payrollCalendar.data.lastDate\" ng-change=\"watchInitialDate()\">\n</md-datepicker><div ng-messages=\"form.lastDate.$error\" \nng-show=\"(form.lastDate.$error && !form.lastDate.$pristine) || (form.lastDate.$error && payrollCalendar.data.lastDate)\">\n<div ng-message=\"min\">Fecha Fin debe ser a partir de {{minEndDate | date}}</div><div ng-message=\"mindate\">\nFecha Fin debe ser a partir de {{minEndDate | date}}</div></div></md-input-container></div><md-switch \naria-label=\"extra week\" ng-disabled=\"F.readMode\" class=\"m-0\" name=\"sumRelativeToBase\" \nng-model=\"payrollCalendar.extraWeek\" ng-change=\"watchInitialDate(initialDate)\">Año con semana extra</md-switch><div \nlayout-gt-xs=\"column\" ng-if=\"dataToCreate\"><div class=\"table-responsive md-scrollbar\"><table for=\"Calendar\" \nclass=\"calendar\"><thead><tr><th>Periodo</th><th>Fecha Inicial</th><th>Fecha Fin</th><th>Fecha de acumulado</th><th>\nAjuste</th><th>Factor</th></tr></thead><tbody><tr ng-repeat=\"($index, period) in dataToCreate.periods track by $index\">\n<td class=\"red-400-fg\">{{ period.period }}<md-icon ng-if=\"period.close\" md-font-icon=\"icon-lock\"></md-icon></td><td>\n{{period.start | date:\"mediumDate\"}}</td><td>{{period.end | date:\"mediumDate\"}}</td><td ng-if=\"!F.readMode\">\n<md-datepicker ng-model=\"period.accuDate\" name=\"accuDate\" input-date-miliseconds></md-datepicker></td><td \nng-if=\"F.readMode\">{{period.accuDate | date:\"mediumDate\"}}</td><td ng-if=\"!F.readMode\"><md-checkbox \nng-model=\"period.isAdjustment\" name=\"isAdjustment{{$index}}\" ng-change=\"calcFactor(period,$event,$index)\" \nclass=\"adjustment\" ng-disabled=\"F.readMode\">Es de ajuste</md-checkbox></td><td ng-if=\"F.readMode\"><span \nng-if=\"period.isAdjustment\" class=\"greenC doneMark\">✓</span></td><td class=\"factor\" ng-if=\"!F.readMode\">\n<md-input-container class=\"period-factor\"><input ng-disabled=\"F.readMode\" \nng-model-options=\"{debounce: F.debounceTime}\" name=\"factor{{$index}}\" ng-model=\"period.factor\" aria-label=\"factor\" \ntype=\"number\" required><div ng-messages=\'form[\"factor\"+$index].$error\'><div ng-message=\"required\">\nEl factor es requerido</div></div></md-input-container><div class=\"remove-calendar\"><button \nng-if=\"($first || $last) && !period.close && !F.readMode\" ng-click=\"removePayrollAndPeriod(period, $index)\" \nclass=\"md-icon-button\" aria-label=\"Delete\"><md-icon md-font-icon=\"icon-trash\"></md-icon></button> <button \nng-if=\"$last && !F.readMode\" ng-click=\"addPeriod(period, $index)\" class=\"md-icon-button\" aria-label=\"Add Period\">\n<md-icon md-font-icon=\"icon-plus\"></md-icon></button></div></td><td ng-if=\"F.readMode\">{{period.factor}}</td></tr>\n</tbody></table></div></div></div></md-content></form></div>");
$templateCache.put("app/main/clients/views/payrollCalendars/payrollCalendars.html","<div id=\"payrollCalendars\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\" \nng-controller=\"PayrollCalendarsController\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" \nflex><div fb-search-bar></div><div class=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" \nlayout=\"column\"><div table-loader array=\"payrollCalendars\" validations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"payrollCalendars.length\"><thead md-head \nmd-order=\"order\" fix-head><tr md-row><th md-column md-order-by=\"data.year\"><span>Año</span></th><th md-column \nmd-order-by=\"data.payroll\"><span>Nómina</span></th><th md-column md-order-by=\"data.startDate\"><span>Fecha Inicio</span>\n</th><th md-column md-order-by=\"data.endDate\"><span>Fecha Fin</span></th><th md-column md-order-by=\"data.active\"><span>\nActivo</span></th></tr></thead><tbody md-body><tr md-row md-auto-select md-select=\"payrollCalendar\" md-select-id=\"$id\" \nng-repeat=\"payrollCalendar in (F.filteredItems = (payrollCalendars | filter:F.searchText.payrollCalendar | orderBy:order)) | limitTo: F.paginate: (currentPage - 1) * F.paginate\">\n<td md-cell>{{payrollCalendar.data.year}}</td><td md-cell>{{payrollCalendar.payroll | nameOfL: L.allPayrolls:\'N/A\'}}\n</td><td md-cell>{{payrollCalendar.data.startDate | date:\'mediumDate\'}}</td><td md-cell>\n{{payrollCalendar.data.endDate | date:\'mediumDate\'}}</td><td md-cell><div layout=\"row\" layout-align=\"start center\">\n<active-indicator active=\"payrollCalendar.data.active\"></active-indicator></div></td></tr></tbody></table>\n</md-table-container><md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" \nng-show=\"payrollCalendars.length\" md-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" \nmd-limit-options=\"F.paginations\" md-page=\"currentPage\" md-on-paginate=\"restartSelected\" \nmd-total=\"{{F.filteredItems.length}}\" md-page-select></md-table-pagination></div></div><md-fab-speed-dial \nmd-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\"><md-fab-trigger>\n<md-button aria-label=\"crud menu\" class=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon>\n</md-button></md-fab-trigger><md-fab-actions><md-button with-permission action=\"read\" access=\"{{F.active.menuItem}}\" \nng-if=\"selected.length == 1\" \nng-click=\'R.goToDetail(null, \"read\", {payrollCalendarId: selected[0].$id, payrollId: selected[0].payroll})\' \naria-label=\"view\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Ver</md-tooltip>\n<md-icon md-font-icon=\"icon-eye\" aria-label=\"view\"></md-icon></md-button><md-button with-permission action=\"export\" \naccess=\"{{F.active.menuItem}}\" ng-click=\'exportDataToExcel(F.filteredItems,\"payrollCalendars\",currentPage,F.paginate)\' \naria-label=\"export\" class=\"md-fab md-raised md-mini md-primary md-hue-2\"><md-tooltip md-direction=\"left\">\nExportar a excel</md-tooltip><md-icon md-font-icon=\" icon-file-excel\" aria-label=\"export\"></md-icon></md-button>\n<md-button with-permission action=\"read\" access=\"clients.periods\" ng-if=\"selected.length == 1\" \nng-click=\'R.goToDetail(selected[0], \"list\", {payrollCalendar:selected[0], payrollCalendarId: selected[0].$id, payrollId: F.search.$payroll}, \"periods\")\' \naria-label=\"see periods\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">\nVer Periodos</md-tooltip><md-icon md-font-icon=\"icon-calendar-check-multiple\" aria-label=\"view\"></md-icon></md-button>\n<md-button with-permission action=\"update\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" \nng-click=\'R.goToDetail(null, \"update\", {payrollCalendarId: selected[0].$id, payrollId: selected[0].payroll})\' \naria-label=\"edit\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Editar\n</md-tooltip><md-icon md-font-icon=\"icon-pencil\" aria-label=\"edit\"></md-icon></md-button><md-button with-permission \naction=\"remove\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" \nng-click=\"deleteCalendarAndPeriods($event)\" aria-label=\"Delete\" class=\"md-fab md-raised md-warn md-mini\"><md-tooltip \nmd-direction=\"left\">{{\'EC.REMOVE\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\">\n</md-icon></md-button><md-button with-permission action=\"create\" access=\"{{F.active.menuItem}}\" \nng-if=\"!selected.length\" ng-click=\'R.goToDetail(null, \"update\", {payrollCalendarId: \"new\"})\' aria-label=\"add\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">{{\'EC.ADD\' | translate}}\n</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon></md-button><md-button with-permission \naction=\"importCalendar\" access=\"{{F.active.menuItem}}\" ng-click=\"importCalendar($event)\" aria-label=\"add\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Importar calendario</md-tooltip>\n<md-icon md-font-icon=\"icon-import\" aria-label=\"add\"></md-icon></md-button><md-button with-permission \naction=\"activeCalendar\" access=\"{{F.active.menuItem}}\" ng-click=\"activeCalendar($event)\" aria-label=\"add\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Activar calendario</md-tooltip>\n<md-icon md-font-icon=\"icon-select-inverse\" aria-label=\"add\"></md-icon></md-button></md-fab-actions>\n</md-fab-speed-dial></div></div>");
$templateCache.put("app/main/clients/views/payrolls/payroll.html","<div id=\"payroll\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill \nng-controller=\"PayrollController\"><form name=\"form\" novalidate flex layout=\"column\" ng-disabled=\"F.readMode\">\n<md-toolbar class=\"md-tall header md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" \nlayout=\"row\" layout-align=\"start center\" flex><md-button with-permission action=\"access\" \naccess=\"{{F.active.menuItem}}\" class=\"goto-button md-icon-button\" aria-label=\"Go to payrolls\" ng-click=\"R.goToList()\" \ntranslate translate-attr-aria-label=\"EC.GO_TO\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div \nlayout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"{{F.menuItems.clients.payrolls.icon || F.default.icon}}\" class=\"crud-icon\"></md-icon><div \nlayout=\"column\" layout-align=\"start start\"><div class=\"h2\">{{payroll.data.name}}</div><div \nclass=\"subtitle secondary-text\"><span ng-if=\"!F.addMode\">\n{{\'EC.DETAIL_OF\' | translate}} {{\'payroll.SINGULAR\' | translate}}</span> <span ng-if=\"F.addMode\">\n{{\'EC.CREATE\' | translate}} {{\'payroll.SINGULAR\' | translate}}</span></div></div></div></div><div><md-button \ntype=\"submit\" ng-if=\"!F.addMode && !F.readMode\" with-permission action=\"update\" access=\"{{F.active.menuItem}}\" \nng-click=\"savePayroll(payroll)\" ng-hide=\"form.$pristine\" ng-disabled=\"form.$invalid || loadingProgress\" \nclass=\"md-raised md-background md-fab md-accent md-hue-1\" aria-label=\"Save payroll\"><md-tooltip md-direction=\"left\">\n{{\'EC.SAVE\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-content-save\" aria-label=\"Save\"></md-icon>\n</md-button><md-button type=\"submit\" ng-if=\"F.addMode\" with-permission action=\"create\" access=\"{{F.active.menuItem}}\" \nng-click=\"addAndAssign(payroll)\" ng-hide=\"form.$pristine\" ng-disabled=\"form.$invalid || loadingProgress\" \nclass=\"md-raised md-background md-fab md-accent md-hue-1\" aria-label=\"Add payroll\"><md-tooltip md-direction=\"left\">\n{{\'EC.ADD\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-content-save\" aria-label=\"Add\"></md-icon></md-button>\n</div></md-toolbar><md-content layout=\"column\" class=\"content\" flex><md-tabs md-selected=\"selectedTab\" flex \nlayout-fill><md-tab label=\"Información\"><md-tab-body><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\" layout=\"column\"><div layout-gt-xs=\"row\">\n<md-input-container flex class=\"md-block\"><label>Cliente</label><md-select ms2-autofocus ng-disabled=\"F.readMode\" \nname=\"firm\" ng-model=\"payroll.firm\" required><md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" \nng-keydown=\"$event.stopPropagation()\" ng-model=\"firmSelectFilter\" placeholder=\"Busque un cliente\"></md-select-header>\n<md-option ng-value=\"firm.$id\" ng-repeat=\"firm in L.firms | orderBy:\'name\' | filter:firmSelectFilter\">{{firm.name}}\n</md-option></md-select><div class=\"md-errors-spacer\"></div><div ng-messages=\"form.firm.$error\" \nng-show=\"form.firm.$touched || form.firm.$dirty\" role=\"alert\"><div ng-message=\"required\">Cliente es requerido</div>\n</div></md-input-container><md-input-container flex class=\"md-block mb-0\"><label>Nómina</label><input unique-fb \nref=\"{{F.active.menuRef}}\" query=\"data/name\" fromid=\"{{payroll.$id}}\" class=\"uppercased\" \nng-model-options=\"{ debounce: F.debounceTime }\" type=\"text\" name=\"name\" ng-model=\"payroll.data.name\" md-maxlength=\"30\" \nmaxlength=\"30\" ng-disabled=\"F.readMode\" required><div class=\"messages-validate-only-input\" \nng-messages=\"form.name.$error\" ng-show=\"form.name.$touched || form.name.$dirty\" role=\"alert\"><div \nng-message=\"required\">Nombre es requerido</div><div ng-message=\"maxlength\">Nombre no debe tener más de 30 caracteres\n</div><div ng-message=\"unique\">Nombre ya está registrado</div></div></md-input-container></div><div layout-gt-xs=\"row\">\n<md-input-container flex class=\"md-block\"><label>Clase</label><input ng-disabled=\"F.readMode\" class=\"uppercased\" \nng-model-options=\"{ debounce: F.debounceTime }\" type=\"text\" name=\"class\" ng-model=\"payroll.data.class\" \nmd-maxlength=\"4\" maxlength=\"4\" required><div class=\"messages-validate-only-input\" ng-messages=\"form.class.$error\" \nng-show=\"form.class.$touched || form.class.$dirty\" role=\"alert\"><div ng-message=\"required\">Clase es requerido</div><div\n ng-message=\"maxlength\">Clase no debe tener más de 4 caracteres</div></div></md-input-container><div flex=\"nogrow\" \nclass=\"md-input-has-placeholder md-block\"><md-switch aria-label=\"sum relative to base\" ng-disabled=\"F.readMode\" \nclass=\"md-secondary md-padding\" name=\"sumRelativeToBase\" ng-model=\"payroll.data.sumRelativeToBase\">\nSuma relativos a Base</md-switch></div></div><div layout-gt-xs=\"row\"><md-input-container flex class=\"md-block\"><label>\nFrecuencia de Pago</label><md-select ng-disabled=\"F.readMode\" name=\"paymentFrequency\" \nng-model=\"payroll.paymentFrequency\" required><md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" \nng-keydown=\"$event.stopPropagation()\" ng-model=\"paymentFrequencySelectFilter\" \nplaceholder=\"Busque una frecuencia de pago\"></md-select-header><md-option ng-value=\"paymentFrequency._id\" \nng-repeat=\"paymentFrequency in M.paymentFrequenciesRecords | orderBy:\'name\' | filter:paymentFrequencySelectFilter\">\n{{paymentFrequency.name}}</md-option></md-select><div class=\"md-errors-spacer\"></div><div \nng-messages=\"form.paymentFrequency.$error\" ng-show=\"form.paymentFrequency.$touched || form.paymentFrequency.$dirty\" \nrole=\"alert\"><div ng-message=\"required\">Frecuencia de pago es requerido</div></div></md-input-container>\n<md-input-container flex=\"nogrow\" class=\"md-input-has-placeholder typeOfDayForPayment\"><label>Tipo de días para Pago\n</label><md-radio-group ng-disabled=\"F.readMode\" name=\"typeOfDayForPayment\" \nng-model=\"payroll.data.typeOfDayForPayment\" layout=\"row\" required><md-radio-button class=\"md-padding\" flex \nvalue=\"natural\">Naturales</md-radio-button><md-radio-button class=\"md-padding\" flex value=\"fixed\">Fijos\n</md-radio-button></md-radio-group><div ng-messages=\"form.typeOfDayForPayment.$error\" \nng-show=\"form.typeOfDayForPayment.$touched || form.typeOfDayForPayment.$dirty\" role=\"alert\"><div ng-message=\"required\">\nTipo de días para pago es requerido</div></div></md-input-container></div><div layout-gt-xs=\"row\"><md-input-container \nflex class=\"md-block\"><label>IVA</label><input ng-disabled=\"F.readMode\" type=\"number\" step=\"any\" name=\"iva\" \nng-model=\"payroll.data.iva\" required><div class=\"messages-validate-only-input\" ng-messages=\"form.iva.$error\" \nng-show=\"form.iva.$touched || form.iva.$dirty\" role=\"alert\"><div ng-message=\"required\">IVA es requerido</div></div>\n</md-input-container><md-input-container flex class=\"md-block mb-line\"><label>Honorarios</label><input \nng-disabled=\"F.readMode\" type=\"number\" step=\"any\" name=\"fee\" ng-model=\"payroll.data.fee\" required><div \nclass=\"messages-validate-only-input\" ng-messages=\"form.fee.$error\" ng-show=\"form.fee.$touched || form.fee.$dirty\" \nrole=\"alert\"><div ng-message=\"required\">Honorarios es requerido</div></div></md-input-container><md-input-container \nflex=\"nogrow\" class=\"mt-line\"><md-checkbox ng-model=\"payroll.addOtherCharges\" class=\"mb-0\" \nng-change=\"payroll.otherCharges=\'\'\" aria-label=\"Cobrar relativos extras\">Cobrar relativos extras</md-checkbox>\n</md-input-container></div><div layout-gt-xs=\"row\"><md-input-container flex class=\"md-block\" \nng-if=\"payroll.addOtherCharges\"><label>Otros relativos</label><input ng-disabled=\"F.readMode\" type=\"number\" \nname=\"otherCharges\" ng-model=\"payroll.otherCharges\"><div class=\"messages-validate-only-input\" \nng-messages=\"form.otherCharges.$error\" ng-show=\"form.otherCharges.$touched || form.otherCharges.$dirty\" role=\"alert\">\n<div ng-message=\"required\">Otros relativos es requerido</div></div></md-input-container></div><div layout-gt-xs=\"row\">\n<md-input-container flex class=\"md-block\"><label>Esquema de pago</label><md-select ng-disabled=\"F.readMode\" \nname=\"paymentSchema\" ng-model=\"payroll.paymentSchema\" ng-change=\"payroll.enableSalaryAdjusment=false\" required>\n<md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" \nng-model=\"paymentSchemaSelectFilter\" placeholder=\" Busque un esquema de pago\"></md-select-header><md-option \nng-value=\"paymentSchema.$id\" \nng-repeat=\"paymentSchema in C.paymentSchemas | orderBy:\'data.name\' | filter:paymentSchemaSelectFilter\">\n{{paymentSchema.data.name}}</md-option></md-select><div class=\"md-errors-spacer\"></div><div \nng-messages=\"form.paymentSchema.$error\" ng-show=\"form.paymentSchema.$touched || form.paymentSchema.$dirty\" \nrole=\"alert\"><div ng-message=\"required\">Esquema de pago es requerido</div></div></md-input-container></div><div \nng-show=\"payroll.paymentSchema\"><h3 class=\"mt-0 text-bold\">PROCESOS</h3><div \nng-if=\"paymentSchema.data.processes.fiscal.active\"><h5 class=\"mb-0 text-italic\" \nng-init=\"payroll.processes.FISCAL.id=\'fiscal\'\">{{paymentSchema.data.processes.fiscal.name}}</h5><div class=\"fiscal\" \nlayout=\"row\" layout-xs=\"column\" layout-wrap><md-input-container flex-xs=\"100\" flex-sm=\"40\" flex-md=\"30\" flex=\"30\" \nclass=\"mb-0\"><label>Empresa</label><md-select ng-disabled=\"F.readMode || payroll.processes.FISCAL.companiesRecord\" \nname=\"companiesRecordF\" ng-model=\"payroll.processes.FISCAL.companiesRecord\" ng-change=\'setFieldAccount(\"FISCAL\")\' \nrequired><md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" \nng-keydown=\"$event.stopPropagation()\" ng-model=\"companiesRecordSelectFilter\" placeholder=\"Busque un cliente\">\n</md-select-header><md-option ng-value=\"company.$id\" \nng-repeat=\"company in L.companiesRecords | orderBy:\'name\' | filter:companiesRecordSelectFilter\">{{company.name}}\n</md-option></md-select><div class=\"md-errors-spacer\"></div><div ng-messages=\"form.companiesRecordF.$error\" \nng-show=\"form.companiesRecordF.$touched || form.companiesRecordF.$dirty\" role=\"alert\"><div ng-message=\"required\">\nLa empresa es requerido</div></div></md-input-container><div flex-xs=\"100\" flex-sm=\"60\" flex-md=\"70\" flex=\"70\" \nclass=\"fiscal\"><md-chips ng-model=\"payroll.processes.FISCAL.bankAccounts\" md-autocomplete-snap \nmd-transform-chip=\"transformChip($chip)\" md-require-match=\"true\" input-aria-label=\"Cuentas de bancos\"><md-autocomplete \nmd-selected-item=\"selectedItem\" md-search-text=\"searchText\" md-min-length=\"0\" \nmd-items=\"item in filterBanks(searchText, payroll.processes.FISCAL.companiesRecord)\" md-no-cache \nmd-item-text=\"item.name\" placeholder=\"Seleccione una cuenta\" md-dropdown-position=\"bottom\" \ninput-aria-describedby=\"autocompleteTitle\"><span md-highlight-text=\"ctrl.searchText\">{{item.name}}</span>\n</md-autocomplete><md-chip-template><span><strong>{{$chip|nameOfM:M.bankAccounts}} <small>\n{{($chip|getSomethingOfArrayM:M.bankAccounts:\"status\")?\"\":\"-Desactivado\"}}</small></strong></span></md-chip-template>\n</md-chips></div></div></div><div ng-repeat=\"(cI, complement) in paymentSchema.data.processes.complements\" \nng-init=\"payroll.processes[complement.name] = payroll.processes[complement.name] || {}; payroll.processes[complement.name].id = payroll.processes[complement.name].id || complement.type\">\n<h5 flex class=\"text-italic mt-0 mb-0\">{{complement.alias || complement.name}}</h5><div class=\"socialPrevision\" \nlayout=\"row\" layout-xs=\"column\" layout-wrap><md-input-container flex-xs=\"100\" flex-sm=\"40\" flex-md=\"30\" flex=\"30\" \nclass=\"mb-0\"><label>Empresa</label><md-select \nng-disabled=\"F.readMode || payroll.processes[complement.name].companiesRecord\" name=\"companiesRecordP\" \nng-model=\"payroll.processes[complement.name].companiesRecord\" ng-change=\"setFieldAccount(complement.name)\" required>\n<md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" \nng-model=\"companiesRecordSelectFilter\" placeholder=\"Busque un cliente\"></md-select-header><md-option \nng-value=\"company.$id\" ng-repeat=\"company in L.companiesRecords | orderBy:\'name\' | filter:companiesRecordSelectFilter\">\n{{company.name}}</md-option></md-select><div class=\"md-errors-spacer\"></div><div \nng-messages=\"form.companiesRecordP.$error\" ng-show=\"form.companiesRecordP.$touched || form.companiesRecordP.$dirty\" \nrole=\"alert\"><div ng-message=\"required\">La empresa es requerido</div></div></md-input-container><div flex-xs=\"100\" \nflex-sm=\"60\" flex-md=\"70\" flex=\"70\" class=\"fiscal\"><md-chips \nng-model=\"payroll.processes[complement.name].bankAccounts\" md-autocomplete-snap \nmd-transform-chip=\"transformChip($chip)\" md-require-match=\"true\" input-aria-label=\"Cuentas de Banco\"><md-autocomplete \nmd-selected-item=\"selectedItem\" md-search-text=\"searchText\" md-min-length=\"0\" \nmd-items=\"item in filterBanks(searchText, payroll.processes[complement.name].companiesRecord)\" md-no-cache \nmd-item-text=\"item.name\" md-dropdown-position=\"bottom\" input-aria-describedby=\"autocompleteTitle\" \nplaceholder=\"Selecciona una cuenta\"><span md-highlight-text=\"ctrl.searchText\">{{item.name}}</span></md-autocomplete>\n<md-chip-template><span><strong>{{$chip|nameOfM:M.bankAccounts}} <small>\n{{($chip|getSomethingOfArrayM:M.bankAccounts:\"status\")?\"\":\"-Desactivado\"}}</small></strong></span></md-chip-template>\n</md-chips></div></div></div><div layout=\"row\" layout-align=\"start center\"><div flex=\"nogrow\"><h3 \nclass=\"mt-0 mb-0 text-bold\">OTROS PROCESOS<md-button ng-show=\"!addProc\" class=\"md-icon-button\" ng-click=\"setAddProc()\" \naria-label=\"More\"><md-icon md-font-icon=\"icon-library-plus\"></md-icon></md-button></h3></div><div flex><div \nlayout=\"row\" layout-align=\"start center\" class=\"animated\" ng-if=\"addProc\"><md-input-container flex=\"nogrow\"><label>\nProceso</label><md-select ng-disabled=\"F.readMode\" name=\"procSelector\" ng-model=\"procSelector\" required><md-option \nng-value=\"p\" ng-repeat=\"p in F.otherProcs\">{{p.name}}</md-option></md-select></md-input-container><div flex=\"nogrow\">\n<md-button ng-click=\"payrollProcs.push(procSelector);setAddProc()\" ng-disabled=\"!procSelector\">Añadir proceso\n</md-button></div><div flex=\"nogrow\"><md-button class=\"md-warn\" ng-click=\"setAddProc()\">Cancelar</md-button></div><div \nflex></div></div></div></div><div ng-repeat=\"($index,proc) in payrollProcs\"><h5 flex class=\"text-italic mt-0 mb-0\" \nng-init=\"payroll.processes[proc.name].id=proc.id\">{{proc.name}}</h5><div class=\"socialPrevision\" layout=\"row\" \nlayout-xs=\"column\" layout-wrap><md-input-container flex-xs=\"100\" flex-sm=\"40\" flex-md=\"30\" flex=\"30\" class=\"mb-0\">\n<label>Empresa</label><md-select ng-disabled=\"F.readMode || payroll.processes[proc.name].companiesRecord\" \nname=\"companiesRecordP{{proc.id}}\" ng-model=\"payroll.processes[proc.name].companiesRecord\" \nng-change=\"setFieldAccount(proc.name)\" required><md-select-header><input autocomplete=\"off\" type=\"search\" \nclass=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"companiesRecordSelectFilter\" \nplaceholder=\"Busque un cliente\"></md-select-header><md-option ng-value=\"company.$id\" \nng-repeat=\"company in L.companiesRecords | orderBy:\'name\' | filter:companiesRecordSelectFilter\">{{company.name}}\n</md-option></md-select><div class=\"md-errors-spacer\"></div><div ng-messages=\'form[\"companiesRecordP\"+proc.id].$error\' \nng-show=\'form[\"companiesRecordP\"+proc.id].$touched || form[\"companiesRecordP\"+proc.id].$dirty\' role=\"alert\"><div \nng-message=\"required\">La empresa es requerido</div></div></md-input-container><div flex class=\"fiscal\"><md-chips \nng-model=\"payroll.processes[proc.name].bankAccounts\" md-autocomplete-snap md-transform-chip=\"transformChip($chip)\" \nmd-require-match=\"true\" input-aria-label=\"Cuentas de Banco\"><md-autocomplete md-selected-item=\"selectedItem\" \nmd-search-text=\"searchText\" md-min-length=\"0\" \nmd-items=\"item in filterBanks(searchText, payroll.processes[proc.name].companiesRecord)\" md-no-cache \nmd-item-text=\"item.name\" md-dropdown-position=\"bottom\" input-aria-describedby=\"autocompleteTitle\" \nplaceholder=\"Selecciona una cuenta\"><span md-highlight-text=\"ctrl.searchText\">{{item.name}}</span></md-autocomplete>\n<md-chip-template><span><strong>{{$chip|nameOfM:M.bankAccounts}} <small>\n{{($chip|getSomethingOfArrayM:M.bankAccounts:\"status\")?\"\":\"-Desactivado\"}}</small></strong></span></md-chip-template>\n</md-chips></div><div flex=\"nogrow\" layout=\"row\" layout-align=\"end center\"><md-button \nng-click=\"deleteProcess($index,proc.name);form.$setDirty();\" class=\"md-warn md-raised md-fab md-mini\" \naria-label=\"Remove\"><md-tooltip md-direction=\"left\">Borrar</md-tooltip><md-icon md-font-icon=\"icon-delete\" \naria-label=\"Remove\"></md-icon></md-button></div></div></div></div><md-input-container class=\"md-block\"><label>\nComentarios</label><textarea ng-disabled=\"F.readMode\" ng-model=\"payroll.data.comments\" name=\"comments\" \nclass=\"uppercased\" ng-model-options=\"{ debounce: F.debounceTime }\" columns=\"1\" md-maxlength=\"150\" maxlength=\"150\">\n</textarea><div ng-messages=\"form.comments.$error\" ng-show=\"form.comments.$touched || form.comments.$dirty\" \nrole=\"alert\"><div ng-message=\"maxlength\">Comentarios no debe tener más de 150 caracteres</div></div>\n</md-input-container></div></md-tab-body></md-tab><md-tab label=\"configuración\"><md-tab-body><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\"><div layout=\"row\" layout-xs=\"column\" \nlayout-align=\"space-between start\" layout-align-xs=\"start stretch\"><div flex=\"50\" flex-xs=\"100\"><md-list><md-list-item \nng-if=\"!F.addMode\"><md-icon md-font-icon=\"icon-clipboard-check\"></md-icon><p>Activo</p><md-switch \nng-disabled=\"F.readMode\" class=\"md-secondary\" name=\"active\" ng-model=\"payroll.active\" \nng-change=\"unarchived(payroll.active,payroll)\"></md-switch></md-list-item><md-list-item><md-icon \nmd-font-icon=\"icon-clipboard-check\"></md-icon><p>Descontar faltas en proporción al séptimo dia</p><md-switch \nng-disabled=\"F.readMode\" class=\"md-secondary\" name=\"dapsd\" ng-model=\"payroll.dapsd\"></md-switch></md-list-item>\n<md-list-item><md-icon md-font-icon=\"icon-worker\"></md-icon><p>Mostrar campo de servicios especializados</p><md-switch \nng-disabled=\"F.readMode\" class=\"md-secondary\" name=\"specialServices\" ng-model=\"payroll.specialServices\"></md-switch>\n</md-list-item><md-list-item><md-icon md-font-icon=\"icon-division\"></md-icon><p>Desactivar ajuste anual</p><md-switch \nng-disabled=\"F.readMode\" class=\"md-secondary\" name=\"dontDoAnualAdjustment\" ng-model=\"payroll.dontDoAnualAdjustment\">\n</md-switch></md-list-item></md-list></div><div flex=\"50\" flex-xs=\"100\"><md-list><md-list-item><md-icon \nmd-font-icon=\"icon-coin\"></md-icon><p>Activar Ajuste de Salario</p><md-switch ng-disabled=\"F.readMode\" \nclass=\"md-secondary\" name=\"enableSalaryAdjusment\" ng-model=\"payroll.enableSalaryAdjusment\" \nng-change=\"validateSalaryAdjustment()\"></md-switch></md-list-item><md-list-item><md-icon \nmd-font-icon=\"icon-cash-multiple\"></md-icon><p flex=\"nogrow\">Régimen:</p><md-input-container flex \nclass=\"md-block mb-0 mt-0 no-errors-spacer\" md-mo-float><input class=\"uppercased\" \nng-model-options=\"{ debounce: F.debounceTime }\" type=\"text\" name=\"regime\" ng-model=\"payroll.data.regime\" required><div \nng-messages=\"form.regime.$error\" ng-show=\"form.regime.$touched || form.regime.$dirty\"><div ng-message=\"required\">\nEl régimen es requerido</div></div></md-input-container></md-list-item><md-list-item><md-icon \nmd-font-icon=\"icon-table-row-height\"></md-icon><p flex=\"nogrow\">Usar Tablas:</p><md-input-container flex \nclass=\"md-block mb-0 mt-0 no-errors-spacer\" md-mo-float><md-select ng-model=\"payroll.periodicity\"><md-option ng-value>\nDefault(Mensual)</md-option><md-option ng-value=\"period.id\" \nng-repeat=\"period in F.periodicity|filter:{showOnPayroll:true}\">{{period.name}}</md-option></md-select>\n</md-input-container></md-list-item></md-list></div></div></div></md-tab-body></md-tab><md-tab label=\"Campos extras\">\n<md-tab-body><div class=\"detail-form-container md-background-bg md-whiteframe-1dp\"><div layout=\"row\" \nlayout-align=\"start center\" layout-wrap><md-input-container flex=\"70\"><label>Seleccionar Campo Extra</label><md-select \nng-model=\"fieldSelected\"><md-option ng-repeat=\"item in getFieldsData\" ng-value=\"item\">{{ item.name }}</md-option>\n</md-select></md-input-container><div><md-button class=\"md-raised md-fab md-mini md-primary\" \nng-click=\"addFields(fieldSelected.id)\"><md-icon md-font-icon=\"icon-plus-circle-outline\"></md-icon></md-button>\n<md-tooltip md-direction=\"bottom\">Guardar campo extra</md-tooltip></div></div><div \nng-repeat=\"(key,value) in payroll.extraFields\" flex><div flex=\"nogrow\" layout=\"row\" layout-align=\"start center\">\n<md-input-container class=\"md-block\" ng-if=\"getFieldsDataByName[key].type === \'text\'\" flex=\"100\"><label>\n{{getFieldsDataByName[key].name}}</label><input required type=\"text\" name=\"{{key}}\" \nng-model=\"payroll.extraFields[key]\" maxlength=\"100\"><div ng-messages=\"form[key].$error\"><div ng-message=\"required\">\nEl campo es requerido</div></div><md-tooltip md-direction=\"top\">{{getFieldsDataByName[key].description}}</md-tooltip>\n</md-input-container><md-button ng-click=\"deleteExtraFields(key);form.$setDirty();\" \nclass=\"md-warn md-raised md-fab md-mini\" aria-label=\"Remove\"><md-tooltip md-direction=\"left\">Borrar</md-tooltip>\n<md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button><md-input-container class=\"md-block\" \nflex=\"50\" ng-if=\"getFieldsDataByName[key].type === \'number\'\"><label>{{getFieldsDataByName[key].name}}</label><input \nrequired type=\"number\" name=\"{{key}}\" ng-model=\"payroll.extraFields[key]\" maxlength=\"100\"><div \nng-messages=\"form[key].$error\"><div ng-message=\"required\">El campo es requerido</div></div></md-input-container></div>\n</div></div></md-tab-body></md-tab><md-tab label=\"Parámetros extras\" ng-if=\"paramsExtraPermission\"><md-tab-body><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\"><div layout=\"row\" layout-xs=\"column\" \nlayout-align=\"space-between start\" layout-align-xs=\"start stretch\"><div flex=\"50\" flex-xs=\"100\"><md-list-item \nng-if=\"!F.addMode\"><md-icon md-font-icon=\"icon-clipboard-check\"></md-icon><p>\nMostrar subtotales por centro de costo en reporte</p><md-switch ng-disabled=\"F.readMode\" class=\"md-secondary\" \nname=\"active\" ng-model=\"payroll.subtotal\"></md-switch></md-list-item><md-list-item><md-icon \nmd-font-icon=\"icon-flash-auto\"></md-icon><p>Generar automaticamente No. de Empleado</p><md-switch \nng-disabled=\"F.readMode\" class=\"md-secondary\" name=\"active\" ng-model=\"payroll.generateEmployeeNumber\"></md-switch>\n</md-list-item><md-list-item><md-icon md-font-icon=\"icon-division\"></md-icon><p>Realizar ajuste mensual</p><md-switch \nng-disabled=\"F.readMode\" class=\"md-secondary\" name=\"doMonthlyAdjustment\" ng-model=\"payroll.doMonthlyAdjustment\">\n</md-switch></md-list-item></div><div flex=\"50\" flex-xs=\"100\"><md-list-item><md-icon md-font-icon=\"icon-archive\">\n</md-icon><p>Archivado</p><md-switch ng-disabled=\"F.readMode\" class=\"md-warn\" name=\"archived\" \nng-model=\"payroll.archived\"></md-switch></md-list-item><md-list-item><md-icon md-font-icon=\"icon-cake-variant\">\n</md-icon><p>Activar fecha real de antigüedad</p><md-switch ng-disabled=\"F.readMode\" class=\"md-secondary\" \nname=\"hasRealSeniorityDate\" ng-model=\"payroll.hasRealSeniorityDate\"></md-switch></md-list-item><md-list-item><md-icon \nmd-font-icon=\"icon-clipboard-check\"></md-icon><p>Sincronizar empleados con GeoVictoria</p><md-switch \nng-disabled=\"F.readMode\" class=\"md-secondary\" name=\"syncGeoVictoria\" ng-model=\"payroll.sync.execute.geovictoria\">\n</md-switch></md-list-item></div></div></div></md-tab-body></md-tab></md-tabs></md-content></form></div>");
$templateCache.put("app/main/clients/views/payrolls/payrolls.html","<div id=\"payrolls\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div fb-search-bar></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><div filter-toolbar></div><div table-loader array=\"payrolls\" \nvalidations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"payrolls.length\"><thead md-head md-order=\"order\" \nfix-head><tr md-row><th md-column md-order-by=\"firm\" ng-if=\"F.isDistributor()\"><span>Cliente</span></th><th md-column \nmd-order-by=\"data.class\"><span>Clase</span></th><th md-column md-order-by=\"data.name\"><span>Nómina</span></th><th \nmd-column md-order-by=\"paymentSchema\"><span>Esquema de Pago</span></th><th md-column md-order-by=\"data.fee\"><span>\nHonorarios</span></th><th md-column md-order-by=\"paymentFrequency\"><span>Frecuencia de Pago</span></th><th md-column \nmd-order-by=\"data.typeOfDayForPayment\">Tipo de Días para pago</th><th md-column md-order-by=\"active\"><span>Activo\n</span></th></tr></thead><tbody md-body><tr md-row md-auto-select md-select=\"payroll\" md-select-id=\"$id\" \nng-repeat=\"payroll in (F.filteredItems = (Z[F.active.menuName] | searchSpecific:F.searchText.payroll:fixedFieldsSearch | orderBy:order)) | limitTo: F.paginate: (currentPage - 1) * F.paginate\">\n<td md-cell ng-if=\"F.isDistributor()\">{{payroll.firm | nameOfL:L.firms}}</td><td md-cell>{{payroll.data.class}}</td><td\n md-cell>{{payroll.data.name}}</td><td md-cell>\n{{payroll.paymentSchema | getSomethingOfArrayFB : C.paymentSchemas : \'data.name\' : \'Sin asignar\'}}</td><td md-cell>\n{{payroll.data.fee}}</td><td md-cell>{{payroll.paymentFrequency | nameOfM:M.paymentFrequenciesRecords}}</td><td \nmd-cell>{{\'c.\' + payroll.data.typeOfDayForPayment | translate}}</td><td md-cell><div layout=\"row\" \nlayout-align=\"start center\"><active-indicator active=\"payroll.active\"></active-indicator></div></td></tr></tbody>\n</table></md-table-container><md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" \nng-show=\"payrolls.length\" md-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" md-limit-options=\"F.paginations\" \nmd-page=\"currentPage\" md-on-paginate=\"restartSelected\" md-total=\"{{F.filteredItems.length}}\" md-page-select>\n</md-table-pagination></div></div><md-fab-speed-dial md-open=\"F.isOpen\" \nmd-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\"><md-fab-trigger><md-button \naria-label=\"crud menu\" class=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon></md-button>\n</md-fab-trigger><md-fab-actions><md-button with-permission action=\"read\" access=\"{{F.active.menuItem}}\" \nng-if=\"selected.length == 1\" \nng-click=\'R.goToDetail(null, \"read\", {payrollId: selected[0].$id, firmId: selected[0].firm})\' aria-label=\"view\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Ver</md-tooltip><md-icon \nmd-font-icon=\"icon-eye\" aria-label=\"view\"></md-icon></md-button><md-button with-permission action=\"export\" \naccess=\"{{F.active.menuItem}}\" ng-click=\"exportDataToExcel(F.filteredItems,null,currentPage,F.paginate)\" \naria-label=\"export\" class=\"md-fab md-raised md-mini md-primary md-hue-2\"><md-tooltip md-direction=\"left\">\nExportar a excel</md-tooltip><md-icon md-font-icon=\" icon-file-excel\" aria-label=\"export\"></md-icon></md-button>\n<md-button with-permission action=\"update\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" \nng-click=\'R.goToDetail(null, \"update\", {payrollId: selected[0].$id, firmId: selected[0].firm})\' aria-label=\"edit\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Editar</md-tooltip><md-icon \nmd-font-icon=\"icon-pencil\" aria-label=\"edit\"></md-icon></md-button><md-button with-permission action=\"remove\" \naccess=\"{{F.active.menuItem}}\" ng-if=\"selected.length\" ng-click=\"delete($event)\" aria-label=\"Delete\" \nclass=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">{{\'EC.REMOVE\' | translate}}</md-tooltip>\n<md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button><md-button with-permission \naction=\"create\" access=\"{{F.active.menuItem}}\" ng-if=\"!selected.length\" \nng-click=\'R.goToDetail(null, \"update\", {payrollId: \"new\"})\' aria-label=\"add\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">{{\'EC.ADD\' | translate}}\n</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon></md-button></md-fab-actions>\n</md-fab-speed-dial></div></div>");
$templateCache.put("app/main/clients/views/periods/period.html","<div id=\"payroll\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill \nng-controller=\"PayrollController\"><form name=\"form\" novalidate flex layout=\"column\" ng-disabled=\"F.readMode\"><div \nfb-crud-detail-bar></div><md-content layout=\"column\" class=\"content\" flex><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\" layout=\"column\"><div layout-gt-xs=\"row\">\n<md-input-container flex class=\"md-block\" ng-if=\"F.isDistributor()\"><label>Periodo</label><input type=\"number\" \nng-model=\"period.period\" name=\"period\"></md-input-container><md-input-container flex class=\"md-block\"><label>\nFecha de Inicio</label><md-datepicker md-hide-icons=\"triangle\" input-date-miliseconds ng-model=\"period.end\" \nname=\"birthdate\" required class=\"md-block\"></md-datepicker></md-input-container><md-input-container flex \nclass=\"md-block date-picker\"><label>Fecha de Fin</label><md-datepicker md-hide-icons=\"triangle\" input-date-miliseconds \nng-model=\"period.end\" name=\"birthdate\" required class=\"md-block\"></md-datepicker></md-input-container>\n<md-input-container flex class=\"md-block\"><label>Activo</label><md-switch aria-label=\"active\" \nclass=\"md-secondary md-padding\" name=\"active\" ng-false-value=\"0\" ng-model=\"period.active\"></md-switch>\n</md-input-container></div></div></md-content></form></div>");
$templateCache.put("app/main/clients/views/periods/periods.html","<div id=\"periods\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\" ng-controller=\"PeriodsController\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><form name=\"periodsForm\" novalidate flex \nlayout=\"column\"><div fb-search-bar></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\"><div filter-toolbar></div><div table-loader array=\"periods\" \nvalidations=\"validations\"></div><md-table-container><table md-table md-row-select multiple=\"true\" ng-model=\"selected\" \nclass=\"row-border\" ng-show=\"periods.length\"><thead md-head md-order=\"order\" fix-head><tr md-row><th md-column \nmd-order-by=\"period\"><span>Periodo</span></th><th md-column md-order-by=\"start\"><span>Fecha Inicio</span></th><th \nmd-column md-order-by=\"end\"><span>Fecha Fin</span></th><th md-column md-order-by=\"active\"><span>Activo</span></th></tr>\n</thead><tbody md-body><tr md-row md-select=\"period\" md-auto-select md-select-id=\"$id\" \nng-repeat=\"period in (F.filteredItems = (periods | filter:F.searchText.period | orderBy:order)) | limitTo: F.paginate: (currentPage - 1) * F.paginate\">\n<td md-cell><md-input-container ng-if=\"havePToUpdate || havePToCreate\" md-no-float><input type=\"number\" name=\"period\" \nng-model=\"period.period\" \nng-disabled=\"(!havePToUpdate && !havePToCreate) || (havePToCreate && period.$id && !havePToUpdate)\" \nms2-autofocus=\"{{$index == F.filteredItems.length-1}}\"></md-input-container><span \nng-if=\"!havePToUpdate && !havePToCreate\">{{period.period}}</span></td><td md-cell><md-input-container \nng-if=\"havePToUpdate || havePToCreate\" md-no-float \nng-disabled=\"(!havePToUpdate && !havePToCreate) || (havePToCreate && period.$id && !havePToUpdate)\"><inputdate \ntitle=\"\'Fecha Inicio\'\" date=\"start\" period=\"period\" calendar=\"payrollCalendar\" updatecalendar=\"updateCal\"></inputdate>\n</md-input-container><span ng-if=\"!havePToUpdate && !havePToCreate\">{{period.start|date:F.formatDate}}</span></td><td \nmd-cell><md-input-container ng-if=\"havePToUpdate || havePToCreate\" md-no-float \nng-disabled=\"(!havePToUpdate && !havePToCreate) || (havePToCreate && period.$id && !havePToUpdate)\"><inputdate \ntitle=\"\'Fecha Fin\'\" date=\"end\" period=\"period\" calendar=\"payrollCalendar\" updatecalendar=\"updateCal\"></inputdate>\n</md-input-container><span ng-if=\"!havePToUpdate && !havePToCreate\">{{period.end|date:F.formatDate}}</span></td><td \nmd-cell><md-input-container ng-if=\"havePToUpdate || havePToCreate\" md-no-float><md-switch aria-label=\"active\" \nclass=\"md-secondary md-padding\" name=\"active\" ng-false-value=\"0\" ng-model=\"period.active\" \nng-disabled=\"(!havePToUpdate && !havePToCreate) || (havePToCreate && period.$id && !havePToUpdate)\"></md-switch>\n</md-input-container><span ng-if=\"!havePToUpdate && !havePToCreate\">{{(period.active) ? \'Activo\': \'Inactivo\'}}</span>\n</td></tr></tbody></table></md-table-container><md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" \nlayout-xs=\"column\" ng-show=\"periods.length\" md-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" \nmd-limit-options=\"F.paginations\" md-page=\"currentPage\" md-on-paginate=\"restartSelected\" \nmd-total=\"{{F.filteredItems.length}}\" md-page-select></md-table-pagination></div></div><md-fab-speed-dial \nmd-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\"><md-fab-trigger>\n<md-button aria-label=\"crud menu\" class=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon>\n</md-button></md-fab-trigger><md-fab-actions><md-button with-permission action=\"export\" access=\"{{F.active.menuItem}}\" \nng-click=\'exportDataToExcel(F.filteredItems,\"periods\",currentPage,F.paginate)\' aria-label=\"export\" \nclass=\"md-fab md-raised md-mini md-primary md-hue-2\"><md-tooltip md-direction=\"left\">Exportar a excel</md-tooltip>\n<md-icon md-font-icon=\" icon-file-excel\" aria-label=\"export\"></md-icon></md-button><md-button ng-if=\"addingOne\" \nwith-permission action=\"update\" access=\"{{F.active.menuItem}}\" ng-click=\"saveAndUpdateCalendar(periods)\" \nng-hide=\"periodsForm.$pristine\" ng-disabled=\"periodsForm.$invalid || loadingProgress\" aria-label=\"edit\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">{{\'EC.SAVE\' | translate}}\n</md-tooltip><md-icon md-font-icon=\"icon-content-save\" aria-label=\"edit\"></md-icon></md-button><md-button \nwith-permission action=\"remove\" access=\"{{F.active.menuItem}}\" \nng-if=\"selected.length == 1 && ([payrollCalendar.data.initialPeriod,payrollCalendar.data.lastPeriod].indexOf(selected[0].period) !== -1)\" \nng-click=\"checkAndRemove2($event);\" aria-label=\"Delete\" class=\"md-fab md-raised md-warn md-mini\"><md-tooltip \nmd-direction=\"left\">Borrar Periodo</md-tooltip><md-icon md-font-icon=\"icon-delete\" aria-label=\"delete periods\">\n</md-icon></md-button><md-button with-permission action=\"create\" access=\"{{F.active.menuItem}}\" \nng-if=\"F.search.$payrollCalendar && !selected.length && !addingOne\" ng-click=\"addPeriod2()\" aria-label=\"add\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">{{\'EC.ADD\' | translate}}\n</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon></md-button></md-fab-actions>\n</md-fab-speed-dial></form></div></div>");
$templateCache.put("app/main/clients/views/positions/position.html","<div id=\"position\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill \nng-controller=\"PositionController\"><form name=\"form\" novalidate flex layout=\"column\" ng-disabled=\"F.readMode\"><div \nfb-crud-detail-bar></div><md-content layout=\"column\" class=\"content\" flex><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\"><div layout-gt-xs=\"row\"><md-input-container \nclass=\"md-block\" flex><label>Nómina</label><md-select ng-disabled=\"F.readMode\" ng-model=\"position.payroll\" \nname=\"payroll\" required><md-select-header><input type=\"text\" ng-keydown=\"$event.stopPropagation()\" \nng-model=\"payrollSelectFilter\" placeholder=\"Busque una nomina\"></md-select-header><md-option \nng-if=\"!F.permissionToAccessAllPayrolls\" ng-value=\"payroll.$id\" ng-disabled=\"!payroll.active\" \nng-repeat=\"payroll in L.payrolls | orderBy:\'name\' | filter:payrollSelectFilter\">{{payroll.class}} {{payroll.name}}\n</md-option><md-option ng-if=\"F.permissionToAccessAllPayrolls\" ng-value=\"payroll.$id\" ng-disabled=\"!payroll.active\" \nng-repeat=\"payroll in L.allPayrolls | orderBy:\'name\' | filter:payrollSelectFilter\">{{payroll.class}} {{payroll.name}}\n</md-option></md-select><div ng-messages=\"form.payroll.$error\" ng-show=\"form.payroll.$touched || form.payroll.$dirty\" \nrole=\"alert\"><div ng-message=\"required\">Nómina es requerido</div></div></md-input-container></div><div \nlayout-gt-xs=\"row\"><md-input-container flex class=\"md-block\"><label>Puesto</label><input ng-disabled=\"F.readMode\" \nunique-fb ref=\'{{\"lists/positions/payroll/\" + position.payroll}}\' query=\"name\" fromid=\"{{position.$id}}\" \nclass=\"uppercased\" ng-model-options=\"{ debounce: F.debounceTime }\" type=\"text\" name=\"name\" \nng-model=\"position.data.name\" md-maxlength=\"60\" maxlength=\"60\" required><div ng-messages=\"form.name.$error\" \nng-show=\"form.name.$touched || form.name.$dirty\" role=\"alert\"><div ng-message=\"required\">Puesto es requerido</div><div \nng-message=\"maxlength\">Puesto no debe tener más de 60 caracteres</div><div ng-message=\"unique\">\nPuesto ya está registrado en Nómina</div></div></md-input-container><md-switch flex=\"nogrow\" class=\"md-primary\" \nmd-no-ink ng-change=\"!position.isFiscal?deleteFiscalPosition():\'\'\" aria-label=\"Switch No Ink\" \nng-model=\"position.isFiscal\">Es un Puesto Fiscal</md-switch></div><md-input-container class=\"md-block\" \nng-if=\"!position.isFiscal\"><label>Puesto Fiscal</label><md-select ng-disabled=\"F.readMode\" ms2-autofocus \nng-model=\"position.fiscalPosition\" name=\"fiscalPosition\" required><md-select-header><input type=\"text\" \nng-keydown=\"$event.stopPropagation()\" ng-model=\"positionsSelectFilter\" placeholder=\"Busque un puesto\">\n</md-select-header><md-option ng-value=\"position.$id\" \nng-repeat=\"position in L[\'payrollPositions-\'+position.payroll] | orderBy:\'name\' | filter:positionsSelectFilter\">\n{{position.name}}</md-option></md-select><div ng-messages=\"form.fiscalPosition.$error\" \nng-show=\"form.fiscalPosition.$touched || form.fiscalPosition.$dirty\" role=\"alert\"><div ng-message=\"required\">\nPuesto fiscal es requerido</div></div></md-input-container></div></md-content></form></div>");
$templateCache.put("app/main/clients/views/positions/positions.html","<div id=\"positions\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div fb-search-bar></div><div class=\"content-card\" layout=\"column\" flex>\n<div class=\"content fullpage-datatable\" layout=\"column\" flex><div filter-toolbar></div><div with-permission \nng-model=\"haveP\" action=\"update\" access=\"{{F.active.menuItem}}\"></div><div table-loader array=\"positions\" \nvalidations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"positions.length\"><thead md-head md-order=\"order\" \nfix-head><tr md-row><th md-column md-order-by=\"payroll\"><span>Nómina</span></th><th md-column md-order-by=\"data.name\">\n<span>Puesto</span></th><th md-column md-order-by=\"data.name\"><span>Puesto Fiscal</span></th></tr></thead><tbody \nmd-body><tr md-row md-auto-select md-select=\"position\" md-select-id=\"$id\" \nng-repeat=\"position in (F.filteredItems = (Z.positions | searchSpecific:F.searchText.position:fixedFieldsSearch | orderBy:order)) | limitTo: F.paginate: (currentPage - 1) * F.paginate\">\n<td md-cell>{{position.payroll | nameOfL:L.allPayrolls:\'N/A\'}}</td><td md-cell>{{position.data.name}}</td><td md-cell>\n{{position.isFiscal?\'ES UN PUESTO FISCAL\':(position.fiscalPosition?(position.fiscalPosition|getSomethingOfArrayFB:positions:\'data.name\'):\'No asignado\')}}\n</td></tr></tbody></table></md-table-container><md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" \nlayout-xs=\"column\" ng-show=\"positions.length\" md-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" \nmd-limit-options=\"F.paginations\" md-page=\"currentPage\" md-on-paginate=\"restartSelected\" \nmd-total=\"{{F.filteredItems.length}}\" md-page-select></md-table-pagination></div></div><md-fab-speed-dial \nmd-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\"><md-fab-trigger>\n<md-button aria-label=\"crud menu\" class=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon>\n</md-button></md-fab-trigger><md-fab-actions><md-button with-permission action=\"export\" access=\"{{F.active.menuItem}}\" \nng-click=\"exportDataToExcel(F.filteredItems,F.active.menuName,currentPage,F.paginate)\" aria-label=\"export\" \nclass=\"md-fab md-raised md-mini md-primary md-hue-2\"><md-tooltip md-direction=\"left\">Exportar a excel</md-tooltip>\n<md-icon md-font-icon=\" icon-file-excel\" aria-label=\"export\"></md-icon></md-button><md-button with-permission \naction=\"read\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" \nng-click=\'R.goToDetail(null, \"read\", {positionId: selected[0].$id, payrollId: selected[0].payroll})\' aria-label=\"view\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Ver</md-tooltip><md-icon \nmd-font-icon=\"icon-eye\" aria-label=\"view\"></md-icon></md-button><md-button with-permission action=\"update\" \naccess=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" \nng-click=\'R.goToDetail(null, \"update\", {positionId: selected[0].$id, payrollId: selected[0].payroll})\' \naria-label=\"edit\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Editar\n</md-tooltip><md-icon md-font-icon=\"icon-pencil\" aria-label=\"edit\"></md-icon></md-button><md-button with-permission \naction=\"remove\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length\" ng-click=\"delete($event)\" aria-label=\"Delete\" \nclass=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">{{\'EC.REMOVE\' | translate}}</md-tooltip>\n<md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button><md-button with-permission \naction=\"create\" access=\"{{F.active.menuItem}}\" ng-if=\"!selected.length\" \nng-click=\'R.goToDetail(null, \"update\", {positionId: \"new\"})\' aria-label=\"add\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">{{\'EC.ADD\' | translate}}\n</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon></md-button></md-fab-actions>\n</md-fab-speed-dial></div></div>");
$templateCache.put("app/main/clients/views/projects/project.html","<div id=\"project\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill><form name=\"form\" \nnovalidate flex layout=\"column\" ng-disabled=\"F.readMode\"><div fb-crud-detail-bar></div><md-content layout=\"column\" \nclass=\"content\" flex><div class=\"detail-form-container md-background-bg md-whiteframe-1dp\"><div layout-gt-xs=\"row\">\n<md-input-container class=\"md-block\" flex><label>Cliente</label><md-select ng-disabled=\"F.readMode\" ms2-autofocus \nng-model=\"project.firm\" name=\"firm\" required><md-select-header><input autocomplete=\"off\" name=\"firm\" \nng-keydown=\"$event.stopPropagation()\" type=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" \nng-model=\"firmSelectFilter\" placeholder=\"Busque un cliente\"></md-select-header><md-option ng-value=\"\'tds\'\" \nstyle=\"color: blue\">TDS</md-option><md-option ng-value=\"firm.$id\" \nng-repeat=\"firm in L.firms | orderBy:\'name\' | filter:firmSelectFilter\">{{firm.name}}</md-option></md-select><div \nng-messages=\"form.firm.$error\" ng-show=\"form.firm.$touched || form.firm.$dirty\" role=\"alert\"><div \nng-message=\"required\">Cliente es requerido</div></div></md-input-container></div><md-input-container class=\"md-block\">\n<label>Nombre</label><input ng-disabled=\"F.readMode\" unique-fb ref=\'{{\"lists/projects/firm/\" + project.firm}}\' \nquery=\"name\" fromid=\"{{project.$id}}\" class=\"uppercased\" ng-model-options=\"{ debounce: F.debounceTime }\" type=\"text\" \nname=\"name\" ng-model=\"project.data.name\" md-minlenght=\"3\" minlenght=\"3\" md-maxlength=\"40\" maxlength=\"40\" required><div \nng-messages=\"form.name.$error\" \nng-show=\"(form.name.$error && !form.name.$pristine) || (form.name.$error && project.data.name)\" role=\"alert\"><div \nng-message=\"required\">Nombre es requerido</div><div ng-message=\"maxlength\">Nombre no debe tener más de 40 caracteres\n</div><div ng-message=\"minlength\">Nombre debe tener al menos 3 caracteres</div><div ng-message=\"unique\">\nNombre ya está registrado en Cliente</div></div></md-input-container></div></md-content></form></div>");
$templateCache.put("app/main/clients/views/projects/projects.html","<div id=\"projects\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div fb-search-bar></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><div table-loader array=\"projects\" validations=\"validations\">\n</div><md-table-container class=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table \nmd-table md-row-select multiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"projects.length\"><thead md-head \nmd-order=\"order\" fix-head><tr md-row><th md-column md-order-by=\"firm\"><span>Cliente</span></th><th md-column \nmd-order-by=\"data.name\"><span>Nombre Corto</span></th></tr></thead><tbody md-body><tr md-row md-auto-select \nmd-select=\"project\" md-select-id=\"$id\" \nng-repeat=\"project in (F.filteredItems = (projects | filter:F.searchText.project | orderBy:order)) | limitTo: F.paginate: (currentPage - 1) * F.paginate\">\n<td md-cell><span ng-if=\'project.firm != \"tds\"\'>{{project.firm | nameOfL:L.firms}}</span> <span \nng-if=\'project.firm == \"tds\"\'>TDS</span></td><td md-cell>{{project.data.name}}</td></tr></tbody></table>\n</md-table-container><md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" \nng-show=\"projects.length\" md-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" md-limit-options=\"F.paginations\" \nmd-page=\"currentPage\" md-on-paginate=\"restartSelected\" md-total=\"{{F.filteredItems.length}}\" md-page-select>\n</md-table-pagination></div></div><md-fab-speed-dial md-open=\"F.isOpen\" \nmd-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\"><md-fab-trigger><md-button \naria-label=\"crud menu\" class=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon></md-button>\n</md-fab-trigger><md-fab-actions><md-button with-permission action=\"read\" access=\"{{F.active.menuItem}}\" \nng-if=\"selected.length == 1\" \nng-click=\'R.goToDetail(null, \"read\", {projectId: selected[0].$id, firmId: selected[0].firm})\' aria-label=\"view\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Ver</md-tooltip><md-icon \nmd-font-icon=\"icon-eye\" aria-label=\"view\"></md-icon></md-button><md-button with-permission action=\"export\" \naccess=\"{{F.active.menuItem}}\" ng-click=\"exportDataToExcel(F.filteredItems,null,currentPage,F.paginate)\" \naria-label=\"export\" class=\"md-fab md-raised md-mini md-primary md-hue-2\"><md-tooltip md-direction=\"left\">\nExportar a excel</md-tooltip><md-icon md-font-icon=\" icon-file-excel\" aria-label=\"export\"></md-icon></md-button>\n<md-button with-permission action=\"update\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" \nng-click=\'R.goToDetail(null, \"update\", {projectId: selected[0].$id, firmId: selected[0].firm})\' aria-label=\"edit\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Editar</md-tooltip><md-icon \nmd-font-icon=\"icon-pencil\" aria-label=\"edit\"></md-icon></md-button><md-button with-permission action=\"remove\" \naccess=\"{{F.active.menuItem}}\" ng-if=\"selected.length\" ng-click=\"delete($event)\" aria-label=\"Delete\" \nclass=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">{{\'EC.REMOVE\' | translate}}</md-tooltip>\n<md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button><md-button with-permission \naction=\"create\" access=\"{{F.active.menuItem}}\" ng-if=\"!selected.length\" \nng-click=\'R.goToDetail(null, \"update\", {projectId: \"new\"})\' aria-label=\"add\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">{{\'EC.ADD\' | translate}}\n</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon></md-button></md-fab-actions>\n</md-fab-speed-dial></div></div>");
$templateCache.put("app/main/clients/views/rpIdseRecords/rpIdseRecord.html","<div id=\"rpIdseRecord\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill \nng-controller=\"RpIdseRecordController\"><form name=\"form\" novalidate flex layout=\"column\" ng-disabled=\"F.readMode\"><div \nmongo-crud-detail-bar flex=\"nogrow\"></div><md-content layout=\"column\" class=\"content\" flex><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\" layout=\"column\"><div flex layout=\"row\"><div \nflex=\"100\" layout=\"column\"><div flex layout=\"row\" layout-align=\"start center\"><md-icon flex=\"nogrow\" class=\"m-0 mr-8\" \nmd-svg-src=\"/assets/icons/cer-file.svg\" aria-hidden=\"true\"></md-icon><div flex class=\"h3\">Certificado</div><md-button \nng-if=\"rpIdseRecord.cerFile && downloadFiles\" ng-click=\"downloadFileRp(\'cerFile\', \'username\', rpIdseRecord)\" \nflex=\"nogrow\" class=\"md-icon-button\" aria-label=\"More\"><md-icon md-font-icon=\"icon-arrow-down\"></md-icon></md-button>\n<md-button ng-if=\"rpIdseRecord.cerFile\" flex=\"nogrow\" class=\"md-icon-button\" aria-label=\"More\" \nng-click=\"removeFieldFile(\'cerFile\')\"><md-icon md-font-icon=\"icon-trash\"></md-icon></md-button></div><div flex \nng-show=\"!rpIdseRecord.cerFile\" class=\"pr-5\"><lf-ng-md-file-input name=\"cerFile\" ng-change=\"filesChange()\" \nlf-files=\"cerFile\" lf-mimetype=\"application/x-x509-ca-cert|application/x-pkcs12\" lf-api=\"imageApi\" \naccept=\"application/x-x509-ca-cert,.pfx\" lf-placeholder=\"Seleccione su archivo .cer o .pfx\" lf-filesize=\"5MB\" \nlf-remove-label=\"Quitar\" lf-browse-label=\"Seleccionar\"></lf-ng-md-file-input><div ng-messages=\"form.cerFile.$error\" \nstyle=\"color:red\"><div ng-message=\"mimetype\">El formato de archivo no es valido.</div></div></div></div><div \nflex=\"100\" layout=\"column\" ng-show=\"rpIdseRecord.isCerFile\"><div flex layout=\"row\" layout-align=\"start center\"><md-icon\n flex=\"nogrow\" class=\"m-0 mr-8\" md-svg-src=\"/assets/icons/key-file.svg\" aria-hidden=\"true\"></md-icon><div flex \nclass=\"h3\">Llave</div><md-button ng-if=\"rpIdseRecord.keyFile && downloadFiles\" flex=\"nogrow\" \nng-click=\"downloadFileRp(\'keyFile\', \'password\', rpIdseRecord)\" class=\"md-icon-button\" aria-label=\"More\"><md-icon \nmd-font-icon=\"icon-arrow-down\"></md-icon></md-button><md-button ng-if=\"rpIdseRecord.keyFile\" flex=\"nogrow\" \nclass=\"md-icon-button\" aria-label=\"More\" ng-click=\"removeFieldFile(\'keyFile\')\"><md-icon md-font-icon=\"icon-trash\">\n</md-icon></md-button></div><div flex ng-show=\"!rpIdseRecord.keyFile\" class=\"pl-5\"><lf-ng-md-file-input name=\"keyFile\" \nlf-files=\"keyFile\" lf-api=\"imageApi\" accept=\".key\" lf-placeholder=\"Seleccione su archivo .key\" lf-filesize=\"5MB\" \nlf-remove-label=\"Quitar\" lf-browse-label=\"Seleccionar\"></lf-ng-md-file-input><div ng-messages=\"form.keyFile.$error\" \nstyle=\"color:red\"><div ng-message=\"mimetype\">El formato de archivo es valido.</div></div></div></div></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container class=\"md-block mb-0\" flex><label>Usuario</label><input \nng-disabled=\"F.readMode\" type=\"text\" name=\"imssUsername\" ng-model=\"rpIdseRecord.username\" required><div \nng-messages=\"form.imssUsername.$error\" role=\"alert\"><div ng-message=\"required\">Usuario es requerido</div></div>\n</md-input-container><div flex ng-if=\"(!F.addMode) && (!passwordDeleted)\" layout=\"row\" layout-align=\"end center\"><span \nflex=\"nogrow\" class=\"pr-5\">Contraseña: </span><span flex ng-if=\"!showPassword\">******************</span> <span flex \nng-if=\"showPassword\" ng-bind=\"rpIdseRecord.password\"></span><md-button flex=\"nogrow\" ng-if=\"watchPassword\" \nclass=\"md-icon-button\" ng-show=\"showPassword\" ng-click=\"setShowPassword(false)\" aria-label=\"More\"><md-icon \nmd-font-icon=\"icon-eye-off\"></md-icon></md-button><md-button flex=\"nogrow\" ng-if=\"watchPassword\" \nclass=\"md-icon-button\" ng-show=\"(!showPassword)\" ng-click=\"setShowPassword(true)\" aria-label=\"More\"><md-icon \nmd-font-icon=\"icon-eye\"></md-icon></md-button><md-button flex=\"nogrow\" class=\"md-icon-button\" \nng-click=\"unsetPassword()\" aria-label=\"More\"><md-icon md-font-icon=\"icon-trash\"></md-icon></md-button></div>\n<md-input-container class=\"md-block mb-0\" ng-if=\"F.addMode || passwordDeleted\" flex><label>Contraseña</label><input \nng-disabled=\"F.readMode\" type=\"password\" name=\"imssPassword\" ng-change=\"(!rpIdseRecord.isCerFile)?filesChange():\'\'\" \nautocomplete=\"new-password\" ng-model=\"rpIdseRecord.password\" required><div ng-messages=\"form.imssPassword.$error\" \nrole=\"alert\"><div ng-message=\"required\">Contraseña es requerido</div></div></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container class=\"md-block mb-0\" flex><label>Registro Patronal</label>\n<input ng-disabled=\"!F.addMode\" class=\"uppercased\" type=\"text\" name=\"rp\" maxlength=\"11\" ng-change=\"getCompanyName()\" \nmd-maxlength=\"11\" minlength=\"11\" md-minlength=\"11\" ng-model=\"rpIdseRecord.rp\" required><div \nng-messages=\"form.rp.$error\" role=\"alert\"><div ng-message=\"required\">Registro Patronal es requerido</div><div \nng-message=\"min\">La longitud del RP es incorrecta</div><div ng-message=\"max\">La longitud del RP es incorrecta</div>\n</div></md-input-container><md-input-container class=\"md-block mb-0\" flex><label>Nombre Corto</label><input \nng-disabled=\"F.readMode\" class=\"uppercased\" type=\"text\" name=\"name\" ng-model=\"rpIdseRecord.name\" required><div \nng-messages=\"form.name.$error\" role=\"alert\"><div ng-message=\"required\">Empresa es requerido</div></div>\n</md-input-container></div><md-input-container class=\"md-block mb-0\" flex><label>Razón Social</label><input \nng-disabled=\"F.readMode\" class=\"uppercased\" type=\"text\" name=\"companiesRecordName\" \nng-model=\"rpIdseRecord.companiesRecordName\" required><div ng-messages=\"form.companiesRecordName.$error\" role=\"alert\">\n<div ng-message=\"required\">Empresa es requerido</div></div></md-input-container></div></md-content></form></div>");
$templateCache.put("app/main/clients/views/rpIdseRecords/rpIdseRecords.html","<div id=\"rpIdseRecords\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\" \nng-controller=\"RpIdseRecordsController\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" \nflex><div mongo-search-bar></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><div list-filters filters-loaded=\"F.filtersLoaded\" \nng-model=\"F.filters[F.active.menuName]\" on-change=\"getThem\" columns-repeat=\"columnsRepeat\" \nmenu-obj-name=\"{{F.active.menuObjName}}\" model-name=\"{{F.active.menuName}}\" init-filters=\"initFilters\"></div><div \ntable-loader array=\"rpIdseRecords\" validations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"rpIdseRecords.length\"><thead md-head \nmd-order=\"F.orderMongo\" fix-head md-on-reorder=\"getThem\"><tr md-row><th md-column md-order-by=\"companiesRecordName\">\n<span>Empresa</span></th><th md-column md-order-by=\"name\"><span>Nombre</span></th><th md-column md-order-by=\"rp\"><span>\nRP</span></th><th md-column md-order-by=\"username\"><span>Usuario</span></th><th md-column md-order-by=\"cerFile\"><span>\nCertificado</span></th><th md-column md-order-by=\"keyFile\"><span>Llave</span></th></tr></thead><tbody md-body><tr \nmd-row md-auto-select md-select=\"rpIdseRecord\" md-select-id=\"_id\" ng-repeat=\"rpIdseRecord in rpIdseRecords\"><td \nmd-cell>{{rpIdseRecord.companiesRecordName}}</td><td md-cell>{{rpIdseRecord.name}}</td><td md-cell>{{rpIdseRecord.rp}}\n</td><td md-cell><div layout=\"row\" layout-align=\"start center\"><div flex=\"nogrow\">{{rpIdseRecord.username}}</div><div \nflex=\"nogrow\" ng-if=\"rpIdseRecord.showPassword\">({{rpIdseRecord.password}})</div><div flex=\"nogrow\" \nng-if=\"watchPassword\"><md-button ng-if=\"!rpIdseRecord.showPassword\" class=\"md-icon-button\" aria-label=\"More\" \nng-click=\"rpIdseRecord.showPassword=true\" ng-click=\"downloadFileRp(\'cerFile\', \'username\', rpIdseRecord)\"><md-tooltip \nmd-direction=\"top\">Mostrar Contraseña</md-tooltip><md-icon class=\"green-900-fg\" md-font-icon=\"icon-eye\"></md-icon>\n</md-button><md-button ng-if=\"rpIdseRecord.showPassword\" class=\"md-icon-button\" aria-label=\"More\" \nng-click=\"rpIdseRecord.showPassword=false\" ng-click=\"downloadFileRp(\'cerFile\', \'username\', rpIdseRecord)\"><md-tooltip \nmd-direction=\"top\">Ocultar contraseña</md-tooltip><md-icon class=\"green-900-fg\" md-font-icon=\"icon-eye-off\"></md-icon>\n</md-button></div></div></td><td md-cell><div ng-if=\"rpIdseRecord.cerFile && downloadFiles\"><md-button \nclass=\"md-icon-button\" aria-label=\"More\" ng-click=\"downloadFileRp(\'cerFile\', \'username\', rpIdseRecord)\"><md-tooltip \nmd-direction=\"top\">Descargar</md-tooltip><md-icon class=\"green-900-fg\" md-font-icon=\"icon-check\"></md-icon></md-button>\n</div><div ng-if=\"rpIdseRecord.cerFile && (!downloadFiles)\"><md-button class=\"md-icon-button\" aria-label=\"More\">\n<md-icon class=\"green-900-fg\" md-font-icon=\"icon-check\"></md-icon></md-button></div></td><td md-cell><div \nng-if=\"rpIdseRecord.keyFile && downloadFiles\"><md-button class=\"md-icon-button\" aria-label=\"More\" \nng-click=\"downloadFileRp(\'keyFile\', \'password\', rpIdseRecord)\"><md-tooltip md-direction=\"top\">Descargar</md-tooltip>\n<md-icon class=\"green-900-fg\" md-font-icon=\"icon-check\"></md-icon></md-button></div><div \nng-if=\"rpIdseRecord.keyFile && (!downloadFiles)\"><md-button class=\"md-icon-button\" aria-label=\"More\"><md-icon \nclass=\"green-900-fg\" md-font-icon=\"icon-check\"></md-icon></md-button></div></td></tr></tbody></table>\n</md-table-container><md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" \nng-show=\"rpIdseRecords.length\" md-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" md-limit-options=\"F.paginations\" \nmd-page=\"$parent.currentPage\" md-total=\"{{pagination.total}}\" md-on-paginate=\"getThemPagination\" md-page-select>\n</md-table-pagination></div></div><md-fab-speed-dial md-open=\"F.isOpen\" \nmd-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\"><md-fab-trigger><md-button \naria-label=\"crud menu\" class=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon></md-button>\n</md-fab-trigger><md-fab-actions><md-button with-permission action=\"update\" access=\"{{F.active.menuItem}}\" \nng-if=\"selected.length == 1\" ng-click=\"R.goToDetail(selected[0])\" aria-label=\"edit\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Editar</md-tooltip><md-icon \nmd-font-icon=\"icon-pencil\" aria-label=\"edit\"></md-icon></md-button><md-button with-permission action=\"remove\" \naccess=\"{{F.active.menuItem}}\" ng-if=\"selected.length\" ng-click=\"delete($event)\" aria-label=\"Delete\" \nclass=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">{{\'EC.REMOVE\' | translate}}</md-tooltip>\n<md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button><md-button with-permission \naction=\"create\" access=\"{{F.active.menuItem}}\" ng-if=\"!selected.length\" ng-click=\'R.goToDetail(\"new\")\' \naria-label=\"add\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">\n{{\'EC.ADD\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon></md-button>\n</md-fab-actions></md-fab-speed-dial></div></div>");
$templateCache.put("app/main/clients/views/reports/report.html","<div id=\"report\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill><form name=\"form\" \nnovalidate flex layout=\"column\" ng-disabled=\"F.readMode\"><div mongo-crud-detail-bar></div><md-content layout=\"column\" \nclass=\"content\" flex><div class=\"detail-form-container md-background-bg md-whiteframe-1dp\"></div></md-content></form>\n</div>");
$templateCache.put("app/main/clients/views/reports/reports.html","<div id=\"reports\" flex=\"100\" class=\"page-layout carded fullwidth crud-index\" layout=\"column\" \nng-controller=\"ReportsController\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div \nfb-search-bar></div><div class=\"content-card mb-10\" layout=\"column\" flex><div flex \nclass=\"content fullpage-datatable overflow-auto\" layout=\"column\"><div table-loader array=\"reports\" \nvalidations=\"validations\"></div><div flex layout=\"row\" layout-align=\"start start\" layout-wrap><div \nclass=\"card-container\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"33\" flex-gt-md=\"25\" flex-gt-lg=\"20\" with-permission \naction=\"download{{report.id}}\" access=\"{{F.active.menuItem}}\" \nng-repeat=\"report in (F.filteredItems = (reports | filter:F.searchText.report | orderBy:order))  track by report.$id\">\n<div class=\"editForm\" with-permission flex=\"nogrow\" action=\"update\" access=\"{{F.active.menuItem}}\" layout=\"row\"><div \nflex></div><md-icon md-font-icon=\"icon-pencil\" ng-click=\"editReports[report.$id]=true\" \nng-show=\"!editReports[report.$id]\" aria-label=\"delete import\"></md-icon><md-icon ng-if=\"editReports[report.$id]\" \nflex=\"nogrow\" md-font-icon=\"icon-content-save\" ng-click=\"saveReportDescription(report.$id,report.description);\" \naria-label=\"delete import\"></md-icon></div><md-card class=\"h-150\" \nng-click=\"editReports[report.$id]?\'\':downloadReport($event, report)\"><md-card-title><md-card-title-text><span \nclass=\"h2 mb-0 mt-0\"><strong>{{report.name}}</strong></span><p ng-if=\"!editReports[report.$id]\" \nclass=\"md-background-bg secondary-text\"><em>{{report.description}}</em></p><div ng-if=\"editReports[report.$id]\" flex>\n<md-input-container class=\"md-block no-error-spacer mb-0 mt-0\" md-no-float><textarea type=\"text\" cols=\"3\" \nplaceholder=\"Descripcion del reporte\" name=\"description\" ng-model=\"report.description\">\n\r\n                                                    </textarea></md-input-container></div></md-card-title-text>\n</md-card-title></md-card></div></div></div></div></div></div>");
$templateCache.put("app/main/clients/views/rps/rp.html","<div id=\"rp\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill ng-controller=\"RpController\">\n<form name=\"form\" novalidate flex layout=\"column\" ng-disabled=\"F.readMode\"><div fb-crud-detail-bar \nsave-method=\"saveRp\"></div><md-content layout=\"column\" class=\"content\" flex><md-tabs md-selected=\"selectedTab\" flex \nlayout-fill><md-tab label=\"Información\"><md-tab-body><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\"><div layout-gt-xs=\"row\"><md-input-container \nclass=\"md-block\" flex><label>Empresa</label><md-select ng-disabled=\"F.readMode\" name=\"companiesRecords\" \nng-model=\"rp.companiesRecord\" required><md-select-header><input ms2-autofocus name=\"companiesRecord\" \nautocomplete=\"off\" type=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" \nng-model=\"companiesRecordSelectFilter\" placeholder=\"Busque una empresa\"></md-select-header><md-option \nng-value=\"companiesRecord.$id\" ng-disabled=\"!companiesRecord.active\" \nng-repeat=\"companiesRecord in L.companiesRecords | orderBy:\'name\' | filter:companiesRecordSelectFilter\">\n{{companiesRecord.name}}</md-option></md-select><div class=\"md-errors-spacer\"></div><div \nng-messages=\"form.companiesRecords.$error\" ng-show=\"form.companiesRecords.$touched || form.companiesRecords.$dirty\" \nrole=\"alert\"><div ng-message=\"required\">Empresa es requerido</div></div></md-input-container></div><div \nlayout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex><label>Registro Patronal</label><md-tooltip \nmd-direction=\"top\">{{\'rp.TOOLTIP_RP\' | translate}}</md-tooltip><input unique-fb-3 ref=\"{{F.active.menuRef}}\" \nquery=\"data/name\" fromid=\"{{rp.$id}}\" not-equal=\'\"00000000000\"\' ng-disabled=\"F.readMode\" class=\"uppercased\" \nng-model-options=\"{ debounce: F.debounceTime }\" type=\"text\" name=\"name\" ng-model=\"rp.data.name\" md-minlength=\"11\" \nminlength=\"11\" md-maxlength=\"11\" maxlength=\"11\" required><div ng-messages=\"form.name.$error\" \nng-show=\"form.name.$touched || form.name.$dirty\" role=\"alert\"><div ng-message=\"required\">Registro Patronal es requerido\n</div><div ng-message=\"minlength\">Registro Patronal debe tener 11 carácteres de largo</div><div ng-message=\"maxlength\">\nRegistro Patronal debe tener 11 carácteres de largo</div><div ng-message=\"unique\">\nRegistro Patronal ya está registrado con ese nombre</div></div></md-input-container><md-input-container \nclass=\"md-block\" flex><label>Nombre corto</label><input unique-fb ref=\"{{F.active.menuRef}}\" query=\"data/shortName\" \nfromid=\"{{rp.$id}}\" class=\"uppercased\" ng-disabled=\"F.readMode\" ng-model-options=\"{ debounce: F.debounceTime }\" \ntype=\"text\" name=\"shortName\" ng-model=\"rp.data.shortName\" md-maxlength=\"20\" maxlength=\"20\" required><div \nng-messages=\"form.shortName.$error\" ng-show=\"form.shortName.$touched || form.shortName.$dirty\" role=\"alert\"><div \nng-message=\"required\">Nombre Corto es requerido</div><div ng-message=\"maxlength\">\nNombre Corto no debe tener más de 20 caracteres</div><div ng-message=\"unique\">Nombre Corto ya está registrado</div>\n</div></md-input-container></div><div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex><label>\nPrima de riesgo</label><input ng-disabled=\"F.readMode\" type=\"number\" step=\"any\" name=\"riskPrime\" \nng-model=\"rp.data.riskPrime\" required><div ng-messages=\"form.riskPrime.$error\" \nng-show=\"form.riskPrime.$touched || form.riskPrime.$dirty\" role=\"alert\"><div ng-message=\"required\">\nPrima de riesgo es requerido</div></div></md-input-container><md-input-container class=\"md-block\" flex><label>\nClase de riesgo</label><md-select ng-disabled=\"F.readMode\" name=\"riskClassesRecords\" \nng-model=\"rp.data.riskClassesRecord\" required><md-select-header><input name=\"riskClassesRecord\" autocomplete=\"off\" \ntype=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"riskClassesRecordSelectFilter\" \nplaceholder=\"Busque una Clase de Riesgo\"></md-select-header><md-option ng-value=\"riskClassesRecord._id\" \nng-repeat=\"riskClassesRecord in M.riskClassesRecords | orderBy:\'name\' | filter:riskClassesRecordSelectFilter\">\n{{riskClassesRecord.name}}</md-option></md-select><div class=\"md-errors-spacer\"></div><div \nng-messages=\"form.riskClassesRecords.$error\" \nng-show=\"form.riskClassesRecords.$touched || form.riskClassesRecords.$dirty\" role=\"alert\"><div ng-message=\"required\">\nClase de riesgo es requerido</div></div></md-input-container><md-input-container class=\"md-block\" flex><label>\nLugar de trabajo</label><md-select ng-disabled=\"F.readMode\" name=\"placesOfWorkRecords\" \nng-model=\"rp.data.placesOfWorkRecord\" required><md-select-header><input name=\"placesOfWorkRecord\" autocomplete=\"off\" \ntype=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"placesOfWorkRecordSelectFilter\" \nplaceholder=\"Busque una lugar de trabajo\"></md-select-header><md-option ng-value=\"placesOfWorkRecord._id\" \nng-repeat=\"placesOfWorkRecord in M.placesOfWorkRecords | orderBy:\'name\' | filter:placesOfWorkRecordSelectFilter\">\n{{placesOfWorkRecord.name}}</md-option></md-select><div class=\"md-errors-spacer\"></div><div \nng-messages=\"form.placesOfWorkRecords.$error\" \nng-show=\"form.placesOfWorkRecords.$touched || form.placesOfWorkRecords.$dirty\" role=\"alert\"><div ng-message=\"required\">\nLugar de trabajo es requerido</div></div></md-input-container></div><div layout-gt-xs=\"row\"><md-input-container \nclass=\"md-block\" flex><label>Domicilio</label><textarea ng-disabled=\"F.readMode\" class=\"uppercased\" \nng-model-options=\"{ debounce: F.debounceTime }\" name=\"address\" ng-model=\"rp.data.address\" md-maxlength=\"150\" \nmaxlength=\"150\" required></textarea><div ng-messages=\"form.address.$error\" \nng-show=\"form.address.$touched || form.address.$dirty\" role=\"alert\"><div ng-message=\"required\">Dirección es requerido\n</div><div ng-message=\"maxlength\">Dirección no debe tener más de 150 caracteres</div></div></md-input-container></div>\n</div></md-tab-body></md-tab><md-tab label=\"configuración\" ng-disabled=\"F.addMode\"><md-tab-body><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\"><md-list><md-list-item><md-icon \nmd-font-icon=\"icon-clipboard-check\"></md-icon><p>Activo</p><md-switch ng-disabled=\"F.readMode\" class=\"md-secondary\" \nname=\"active\" ng-model=\"rp.active\" ng-change=\"disableAlert(rp.active, rp.companiesRecord);unarchived(rp.active,rp)\">\n</md-switch></md-list-item><md-list-item><md-icon md-font-icon=\"icon-archive\"></md-icon><p>Archivado</p><md-switch \nng-disabled=\"F.readMode\" class=\"md-warn\" name=\"archived\" ng-model=\"rp.archived\"></md-switch></md-list-item></md-list>\n</div></md-tab-body></md-tab><md-tab label=\"Agregar empresas\"><div class=\"p-10\"><h3 class=\"mt-0 mb-0 text-bold\">\nEMPRESAS<md-button class=\"md-icon-button\" \nng-click=\'addItem(\"companies\",{});setCompanySelected(rp.companies[rp.companies.length-1])\' aria-label=\"Add company\" \nng-disabled=\"F.readMode\"><md-icon md-font-icon=\"icon-plus\" aria-label=\"Add\"></md-icon></md-button></h3><div \nclass=\"animated mb-10\" ng-show=\"rp.companies && rp.companies.length>0\"><md-tabs class=\"md-primary\"><md-tab \nmd-selected=\"selectedCompany\" md-autoselect=\"true\" md-on-select=\"setCompanySelected(company)\" \nng-repeat=\"($index,company) in rp.companies\"><md-tab-label>{{company.rfc||\'Nueva Empresa\'}} <button \nng-click=\"removeItem( $index,\'companies\');setLastCompany()\" class=\"md-icon-button\" aria-label=\"Delete\"><md-icon \nmd-font-icon=\"icon-trash\"></md-icon></button></md-tab-label></md-tab></md-tabs></div><div layout=\"row\" layout-wrap \nng-if=\"hasCompanySelected\"><md-input-container class=\"md-block\" flex=\"50\"><label>RFC</label><input \nng-disabled=\"F.readMode\" rfc type=\"text\" md-maxlength=\"13\" maxlength=\"13\" name=\"rfc\" ng-model=\"companySelected.rfc\" \nrequired><div ng-messages=\"form.rfc.$error\" ng-show=\"form.rfc.$touched || form.rfc.$dirty\" role=\"alert\"><div \nng-message=\"rfc\">RFC no tiene un formato válido</div><div ng-message=\"required\">RFC es requerido</div><div \nng-message=\"unique\">RFC ya está registrado</div></div></md-input-container><md-input-container class=\"md-block\" \nflex=\"50\"><label>Régimen</label><md-select ng-disabled=\"F.readMode\" name=\"regime\" ng-model=\"companySelected.regime_id\">\n<md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" \nng-model=\"regimeSelectFilter\" placeholder=\"Busque un regimen\"></md-select-header><md-option ng-value=\"regime._id\" \nng-repeat=\"regime in M.regimes | orderBy:\'name\' | filter:regimeSelectFilter\">{{regime.name}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block mt-0\" flex=\"100\"><label>Razón Social</label><input \nng-disabled=\"F.readMode\" class=\"uppercased\" ng-model-options=\"{ debounce: F.debounceTime }\" type=\"text\" \nname=\"businessName\" md-maxlength=\"150\" maxlength=\"150\" ng-model=\"companySelected.businessName\" required><div \nng-messages=\"form.businessName.$error\" ng-show=\"form.businessName.$touched || form.businessName.$dirty\" role=\"alert\">\n<div ng-message=\"required\">Razón social es requerido</div><div ng-message=\"maxlength\">\nRazón social no debe tener más de 150 caracteres</div></div></md-input-container><md-input-container \nclass=\"md-block mt-0\" flex=\"100\"><label>Dirección</label><textarea ng-disabled=\"F.readMode\" class=\"uppercased\" \nng-model-options=\"{ debounce: F.debounceTime }\" name=\"address\" ng-model=\"companySelected.address\" required></textarea>\n<div ng-messages=\"form.address.$error\" ng-show=\"form.address.$touched || form.address.$dirty\" role=\"alert\"><div \nng-message=\"required\">Dirección es requerido</div></div></md-input-container><md-input-container class=\"md-block mt-0\" \nflex=\"50\"><label>País</label><md-select ng-disabled=\"F.readMode\" name=\"countriesRecord_id\" \nng-model=\"companySelected.countriesRecord_id\"><md-select-header><input autocomplete=\"off\" type=\"search\" \nclass=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"countrySelectFilter\" placeholder=\"Busque un país\">\n</md-select-header><md-option ng-value=\"country._id\" \nng-repeat=\"country in M.countriesRecords | orderBy:\'name\' | filter:countrySelectFilter\">{{country.name}}</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>Estado</label><md-select \nng-disabled=\"F.readMode\" name=\"state_id\" ng-model=\"companySelected.state_id\" \nng-model-options=\"{ debounce: F.debounceTime }\"><md-select-header><input autocomplete=\"off\" type=\"search\" \nclass=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"stateSelectFilter\" placeholder=\"Busque un estado\">\n</md-select-header><md-option ng-value=\"state._id\" \nng-repeat=\"state in M.states | orderBy:\'name\' | filter:stateSelectFilter\">{{state.name}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>Municipio</label><md-select \nng-disabled=\"F.readMode\" name=\"town_id\" ng-model=\"companySelected.town_id\"><md-select-header><input autocomplete=\"off\" \ntype=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"townSelectFilter\" \nplaceholder=\"Busque un municipio\"></md-select-header><md-option ng-value=\"town._id\" \nng-repeat=\"town in M.towns | orderBy:\'name\' | filter:townSelectFilter\">{{town.name}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>Ciudad</label><input \nng-disabled=\"F.readMode\" class=\"uppercased\" ng-model-options=\"{ debounce: F.debounceTime }\" type=\"text\" \nmd-maxlength=\"60\" maxlength=\"60\" name=\"city\" ng-model=\"companySelected.city\" required><div \nng-messages=\"form.city.$error\" ng-show=\"form.city.$touched || form.city.$dirty\" role=\"alert\"><div \nng-message=\"required\">Ciudad es requerido</div><div ng-message=\"maxlength\">Ciudad no debe tener más de 30 caracteres\n</div></div></md-input-container></div></div></md-tab><md-tab ng-disabled=\"F.addMode\"><md-tab-label><span>Infonavit\n</span></md-tab-label><md-tab-body><div class=\"detail-form-container md-background-bg md-whiteframe-1dp\">\n<md-input-container class=\"md-block no-errors-spacer\"><label>Correo electrónico</label><input \nng-model-options=\"{ debounce: F.debounceTime }\" type=\"email\" name=\"email\" ng-model=\"rp.data.email\" md-maxlength=\"50\" \nmaxlength=\"50\" aria-autocomplete=\"none\"><div ng-messages=\"form.email.$error\" \nng-show=\"form.email.$touched || form.email.$dirty\" role=\"alert\"><div ng-message=\"maxlength\">\nEmail no debe tener más de 50 caracteres</div><div ng-message=\"unique\">Email ya está registrado</div><div \nng-message=\"email\">Email no es válido</div></div></md-input-container><div layout=\"row\" layout-wrap><h3 class=\"mb-0\" \nflex=\"nogrow\">Contraseña</h3><div flex ng-if=\"rp.data.password\"><span class=\"p-10 text-green\" style=\"color: green\" \nflex=\"nogrow\" ng-if=\"showPass\">{{ rp.data.password }}</span><md-button ng-if=\"verPasswordInfonavit\" \nng-click=\"passwordVisibilityPass()\" aria-label=\"ver pass\" aria-autocomplete=\"none\" class=\"md-fab md-mini md-success\">\n<md-tooltip md-direction=\"top\">{{ showPass ? \'Ocultar\' : \'Ver\' }} Contraseña</md-tooltip><md-icon \nmd-font-icon=\'{{ showPass ? \"icon-eye-off\" : \"icon-eye\" }}\' aria-label=\'{{ showPass ? \"ocultar pass\" : \"ver pass\" }}\'>\n</md-icon></md-button><md-button ng-click=\"rp.data.password=undefined\" aria-label=\"Delete password\" \nclass=\"md-fab md-mini md-warn\"><md-tooltip md-direction=\"top\">Eliminar Archivo</md-tooltip><md-icon \nmd-font-icon=\"icon-delete\" aria-label=\"Delete\"></md-icon></md-button></div><div flex=\"100\" ng-show=\"!rp.data.password\" \nlayout=\"row\"><div flex><md-input-container class=\"md-block mt-0 no-errors-spacer\" md-no-float><input type=\"password\" \nname=\"passInfo\" ng-model=\"passInfo\" placeholder=\"Ingresa la contraseña del Infonavit\" autocomplete=\"off\"><div \nng-messages=\"form.passInfo.$error\" role=\"alert\"><div ng-message=\"required\">Contraseña es requerido</div></div>\n</md-input-container></div><div flex=\"nogrow\"><md-button ng-disabled=\"form.passInfo.$invalid\" \nng-click=\"rp.data.password =passInfo;passInfo=undefined\" aria-label=\"Upload Cer\" \nclass=\"md-fab md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"top\">Guardar</md-tooltip><md-icon \nmd-font-icon=\"icon-content-save\" aria-label=\"save\"></md-icon></md-button></div></div></div></div></md-tab-body>\n</md-tab></md-tabs></md-content></form></div>");
$templateCache.put("app/main/clients/views/rps/rps.html","<div id=\"rps\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div fb-search-bar></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><div filter-toolbar></div><div table-loader array=\"rps\" \nvalidations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"rps.length\"><thead md-head md-order=\"order\" fix-head>\n<tr md-row><th md-column md-order-by=\"companiesRecord\"><span>Empresa</span></th><th md-column \nmd-order-by=\"data.shortName\"><span>Nombre Corto</span></th><th md-column md-order-by=\"data.name\">Registro Patronal</th>\n<th md-column md-order-by=\"data.riskPrime\" md-numeric><span>Prima de Riesgo</span></th><th md-column \nmd-order-by=\"data.riskClassesRecord\"><span>Clase de Riesgo</span></th><th md-column md-order-by=\"data.isn\" md-numeric>\n<span>ISN</span></th><th md-column md-order-by=\"data.placesOfWorkRecord\"><span>Lugar de Trabajo</span></th><th \nmd-column md-order-by=\"companies\"><span>Compañías</span></th><th md-column md-order-by=\"active\"><span>Activo</span>\n</th></tr></thead><tbody md-body><tr ng-class=\"{\'inactiveEmployee\': !rp.active}\" md-row md-auto-select md-select=\"rp\" \nmd-select-id=\"$id\" \nng-repeat=\"rp in (F.filteredItems = (Z.rps | searchSpecific:F.searchText.rp:fixedFieldsSearch | orderBy:order)) | limitTo: F.paginate: (currentPage - 1) * F.paginate\">\n<td md-cell>{{rp.companiesRecord | nameOfL:L.companiesRecords:\'N/A\'}}</td><td md-cell>{{rp.data.shortName}}</td><td \nmd-cell>{{rp.data.name}}</td><td md-cell>{{rp.data.riskPrime}}</td><td md-cell>\n{{rp.data.riskClassesRecord | nameOfM:M.riskClassesRecords:0:\'N/A\'}}</td><td md-cell>{{rp.data.isn}}</td><td md-cell>\n{{rp.data.placesOfWorkRecord | nameOfM:M.placesOfWorkRecords:0:\'N/A\'}}</td><td md-cell>\n{{rp.companies.length>0 ? rp.companies.length + \" registro(s)\" : \'S/R\'}}</td><td md-cell><div layout=\"row\" \nlayout-align=\"start center\"><active-indicator active=\"rp.active\"></active-indicator></div></td></tr></tbody></table>\n</md-table-container><md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" \nng-show=\"rps.length\" md-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" md-limit-options=\"F.paginations\" \nmd-page=\"currentPage\" md-on-paginate=\"restartSelected\" md-total=\"{{F.filteredItems.length}}\" md-page-select>\n</md-table-pagination></div></div><md-fab-speed-dial md-open=\"F.isOpen\" \nmd-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\"><md-fab-trigger><md-button \naria-label=\"crud menu\" class=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon></md-button>\n</md-fab-trigger><md-fab-actions><md-button with-permission action=\"read\" access=\"{{F.active.menuItem}}\" \nng-if=\"selected.length == 1\" \nng-click=\'R.goToDetail(null, \"read\", {companiesRecordId: selected[0].companiesRecord, rpId: selected[0].$id, rp: selected[0]})\' \naria-label=\"view\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Ver</md-tooltip>\n<md-icon md-font-icon=\"icon-eye\" aria-label=\"view\"></md-icon></md-button><md-button with-permission action=\"export\" \naccess=\"{{F.active.menuItem}}\" ng-click=\"exportDataToExcel(F.filteredItems,null,currentPage,F.paginate)\" \naria-label=\"export\" class=\"md-fab md-raised md-mini md-primary md-hue-2\"><md-tooltip md-direction=\"left\">\nExportar a excel</md-tooltip><md-icon md-font-icon=\" icon-file-excel\" aria-label=\"export\"></md-icon></md-button>\n<md-button with-permission action=\"update\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" \nng-click=\'R.goToDetail(null, \"update\", {companiesRecordId: selected[0].companiesRecord, rpId: selected[0].$id, rp: selected[0]})\' \naria-label=\"edit\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Editar\n</md-tooltip><md-icon md-font-icon=\"icon-pencil\" aria-label=\"edit\"></md-icon></md-button><md-button with-permission \naction=\"remove\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length\" ng-click=\"delete($event)\" aria-label=\"Delete\" \nclass=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">{{\'EC.REMOVE\' | translate}}</md-tooltip>\n<md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button><md-button with-permission \naction=\"create\" access=\"{{F.active.menuItem}}\" ng-if=\"!selected.length\" \nng-click=\'R.goToDetail(null, \"update\", {rpId: \"new\"})\' aria-label=\"add\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">{{\'EC.ADD\' | translate}}\n</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon></md-button></md-fab-actions>\n</md-fab-speed-dial></div></div>");
$templateCache.put("app/main/clients/views/syncEmployeeRecords/syncEmployeeRecords.html","<div id=\"{{F.active.menuName}}\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\" \nng-controller=\"SyncEmployeeRecordsController\"><div class=\"top-bg md-accent-bg\"><div with-permission ng-model=\"haveP\" \naction=\"saveSimple\" access=\"{{F.active.menuItem}}\"></div></div><div class=\"center\" layout=\"column\" flex><div \nmongo-search-bar></div><div class=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" \nlayout=\"column\" flex><div list-filters filters-loaded=\"F.filtersLoaded\" ng-model=\"F.filters[F.active.menuName]\" \non-change=\"getThem\" columns-repeat=\"columnsRepeat\" menu-obj-name=\"{{F.active.menuObjName}}\" \nmodel-name=\"{{F.active.menuName}}\" init-filters=\"initFilters\"></div><div table-loader array=\"syncEmployeeRecords\" \nvalidations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"syncEmployeeRecords.length\"><thead md-head \nmd-order=\"F.orderMongo\" fix-head md-on-reorder=\"getThem\"><tr md-row><th md-column md-order-by=\"data.employeeNumber\">\n<span>No. Empleado</span></th><th md-column md-order-by=\"data.name\"><span>Nombre</span></th><th md-column \nmd-order-by=\"{{\'sync.syncAt.\'+F.filters[F.active.menuName][\'sync.execute\']}}\"><span>Fecha Sincronización</span></th><th\n md-column md-order-by=\"{{\'sync.error.\'+F.filters[F.active.menuName][\'sync.execute\']}}\"><span>Error sincronización\n</span></th></tr></thead><tbody md-body><tr md-row \nng-class=\"{\'inactiveEmployee\': employee.movement.type == 2 || employee.status == 5}\" md-select-id=\"$id\" md-auto-select \nmd-select=\"employee\" ng-repeat=\"employee in syncEmployeeRecords\"><td md-cell>{{employee.data.employeeNumber}}</td><td \nmd-cell>{{employee.data.name}}</td><td md-cell>\n{{employee.sync.syncAt[F.filters[F.active.menuName][\'sync.execute\']] | date : \'medium\'}}</td><td md-cell>\n{{employee.sync.error[F.filters[F.active.menuName][\'sync.execute\']]}}</td></tr></tbody></table></md-table-container>\n<md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" \nng-show=\"syncEmployeeRecords.length\" md-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" \nmd-limit-options=\"F.paginations\" md-page=\"$parent.currentPage\" md-total=\"{{pagination.total}}\" \nmd-on-paginate=\"getThemPagination\" md-page-select></md-table-pagination></div></div><md-fab-speed-dial \nmd-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\"><md-fab-trigger>\n<md-button aria-label=\"crud menu\" class=\"md-fab md-accent\" md-class=\"{\'md-hue-1\': selected.length}\"><md-icon \nmd-font-icon=\"icon-cube\"></md-icon></md-button></md-fab-trigger><md-fab-actions><md-button with-permission \naction=\"syncGeovictoria\" access=\"captures.employees\" \nng-if=\"selected.length > 0 && F.filters[F.active.menuName][\'sync.execute\']==\'geovictoria\'\" ng-click=\"resync($event)\" \naria-label=\"Sync with GeoVictoria\" class=\"md-fab md-raised md-mini md-primary\"><md-tooltip md-direction=\"left\">\nReintentar sincronización</md-tooltip><md-icon md-font-icon=\" icon-sync\" aria-label=\" icon-sync\"></md-icon></md-button>\n<md-button with-permission action=\"syncBuk\" access=\"captures.employees\" \nng-if=\"selected.length > 0 && F.filters[F.active.menuName][\'sync.execute\']===\'buk\'\" ng-click=\"resync($event)\" \naria-label=\"Sync with GeoVictoria\" class=\"md-fab md-raised md-mini md-primary\"><md-tooltip md-direction=\"left\">\nReintentar sincronización</md-tooltip><md-icon md-font-icon=\" icon-sync\" aria-label=\" icon-sync\"></md-icon></md-button>\n<md-button with-permission action=\"syncHumand\" access=\"captures.employees\" \nng-if=\"selected.length > 0 && F.filters[F.active.menuName][\'sync.execute\']===\'humand\'\" ng-click=\"resync($event)\" \naria-label=\"Sync with GeoVictoria\" class=\"md-fab md-raised md-mini md-primary\"><md-tooltip md-direction=\"left\">\nReintentar sincronización</md-tooltip><md-icon md-font-icon=\" icon-sync\" aria-label=\" icon-sync\"></md-icon></md-button>\n</md-fab-actions></md-fab-speed-dial></div></div>");
$templateCache.put("app/main/clients/views/xmlSatMetas/xmlSatMetas.html","<div id=\"xmlSatMetas\" ng-controller=\"XmlSatMetasController\" class=\"page-layout carded fullwidth crud-index\" \nlayout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div mongo-search-bar>\n</div><div class=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><div \nlist-filters filters-loaded=\"F.filtersLoaded\" ng-model=\"F.filters[F.active.menuName]\" on-change=\"getThem\" \ncolumns-repeat=\"columnsRepeat\" menu-obj-name=\"{{F.active.menuObjName}}\" model-name=\"{{F.active.menuName}}\" \ninit-filters=\"initFilters\"></div><div table-loader array=\"xmlSatMetas\" validations=\"validations\"></div>\n<md-table-container class=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table \nmd-row-select multiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"xmlSatMetas.length\"><thead md-head \nmd-order=\"F.orderMongo\" fix-head md-on-reorder=\"getThem\"><tr md-row><th md-column><span>Compañia</span></th><th \nmd-column md-order-by=\"status\"><span>Estatus</span></th><th md-column md-order-by=\"xmlStatus\"><span>\nXML Estatus Solicitado</span></th><th md-column md-order-by=\"requestId\"><span>RequestId</span></th><th md-column \nmd-order-by=\"responseIds\"><span>ResponseIds</span></th><th md-column md-order-by=\"startDate\"><span>Fecha Inicio</span>\n</th><th md-column md-order-by=\"endDate\"><span>Fecha Fin</span></th><th md-column md-order-by=\"updated\"><span>\nUltima Fecha Actualización</span></th><th md-column md-order-by=\"error\"><span>Error</span></th></tr></thead><tbody \nmd-body><tr md-row md-auto-select md-select=\"xmlSatMeta\" md-select-id=\"_id\" ng-repeat=\"xmlSatMeta in xmlSatMetas\"><td \nmd-cell ng-bind=\"xmlSatMeta[\'companiesRecordId-name\']\"></td><td md-cell ng-bind=\"xmlSatMeta.status\"></td><td md-cell \nng-bind=\"xmlSatMeta.xmlStatus\"></td><td md-cell ng-bind=\"xmlSatMeta.requestId\"></td><td md-cell \nng-bind=\"xmlSatMeta.responseIds\"></td><td md-cell ng-bind=\"xmlSatMeta.startDate|date:\'short\'\"></td><td md-cell \nng-bind=\"xmlSatMeta.endDate|date:\'short\'\"></td><td md-cell ng-bind=\"xmlSatMeta.updated.atTime|date:\'short\'\"></td><td \nmd-cell ng-bind=\"xmlSatMeta.error\"></td></tr></tbody></table></md-table-container><md-table-pagination \nlayout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" ng-show=\"xmlSatMetas.length\" \nmd-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" md-limit-options=\"F.paginations\" md-page=\"$parent.currentPage\" \nmd-total=\"{{pagination.total}}\" md-on-paginate=\"getThemPagination\" md-page-select></md-table-pagination></div></div>\n<md-fab-speed-dial md-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" \nclass=\"ms2-speed-dial bottom right\"><md-fab-trigger><md-button aria-label=\"crud menu\" \nclass=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon></md-button></md-fab-trigger>\n<md-fab-actions><md-button with-permission action=\"requestData\" access=\"{{F.active.menuItem}}\" \nng-show=\"!selected.length\" ng-click=\"requestDataModal($event)\" aria-label=\"requestData\" \nclass=\"md-fab md-raised md-mini md-primary md-hue-3\"><md-tooltip md-direction=\"left\">Solicitar Datos</md-tooltip>\n<md-icon md-font-icon=\"icon-server-plus\" aria-label=\"request data\"></md-icon></md-button><md-button \nng-show=\"selected.length > 0\" with-permission action=\"retrySatResponse\" access=\"{{F.active.menuItem}}\" \nng-click=\"retrySatResponse(selected,$event)\" aria-label=\"requestData\" class=\"md-fab md-raised md-mini md-hue-3\">\n<md-tooltip md-direction=\"left\">Reintentar recuperación sat</md-tooltip><md-icon md-svg-src=\"/assets/icons/again.svg\" \naria-label=\"request data\"></md-icon></md-button><md-button with-permission action=\"remove\" \naccess=\"{{F.active.menuItem}}\" ng-if=\"selected.length\" ng-click=\"delete($event)\" aria-label=\"Delete\" \nclass=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">{{\'EC.REMOVE\' | translate}}</md-tooltip>\n<md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button></md-fab-actions></md-fab-speed-dial>\n</div></div>");
$templateCache.put("app/main/clients/views/xmlBillsRequests/xmlBillsRequests.html","<div id=\"xmlBillsRequests\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\" \nng-controller=\"XmlBillsRequestsController\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" \nflex><div mongo-search-bar></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><div list-filters filters-loaded=\"F.filtersLoaded\" \nng-model=\"F.filters[F.active.menuName]\" on-change=\"getThem\" columns-repeat=\"columnsRepeat\" \nmenu-obj-name=\"{{F.active.menuObjName}}\" model-name=\"{{F.active.menuName}}\" init-filters=\"initFilters\"></div><div \ntable-loader array=\"xmlBillsRequests\" validations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"xmlBillsRequests.length\"><thead md-head \nmd-order=\"F.orderMongo\" fix-head md-on-reorder=\"getThem\"><tr md-row><th md-column md-order-by=\"uuid\" class=\"w-auto\">\n<span>UUID</span></th><th md-column md-order-by=\"sat\" class=\"text-center\"><span>En SAT</span></th><th md-column \nmd-order-by=\"satStatus\" class=\"text-center\"><span>Status SAT</span></th><th md-column md-order-by=\"isr\" \nclass=\"text-center\"><span>ISR</span></th><th md-column md-order-by=\"satTotal\" class=\"text-center\"><span>Total SAT\n</span></th><th md-column md-order-by=\"satFechaEmision\" class=\"text-center\"><span>Fecha Emisión SAT</span></th><th \nmd-column md-order-by=\"satFechaPago\" class=\"text-center\"><span>Fecha Pago SAT</span></th><th md-column \nmd-order-by=\"system\" class=\"text-center\"><span>En TDSYSTEM</span></th><th md-column md-order-by=\"tdsStatus\" \nclass=\"text-center\"><span>Status TDSYSTEM</span></th><th md-column md-order-by=\"tdsTotal\" class=\"text-center\"><span>\nTotal TDSYSTEM</span></th><th md-column md-order-by=\"tdsAccuDate\" class=\"text-center\"><span>Fecha Acu. TDSYSTEM</span>\n</th><th md-column md-order-by=\"tdsPeriod\" class=\"text-center\"><span>Periodo TDSYSTEM</span></th><th md-column \nmd-order-by=\"result\" class=\"text-center\"><span>Resultado</span></th><th md-column md-order-by=\"msg\"><span>Mensaje\n</span></th></tr></thead><tbody md-body><tr md-row \nng-class=\"{\'inactiveEmployee\': xmlBillsRequest.status === \'error\', \'statusCancel\': xmlBillsRequest.status === \'cancelled\'}\" \nmd-auto-select md-select=\"xmlBillsRequest\" md-select-id=\"_id\" ng-repeat=\"xmlBillsRequest in xmlBillsRequests\"><td \nmd-cell ng-bind=\"xmlBillsRequest.uuid\" class=\"w-auto\"></td><td md-cell class=\"text-center\"><md-button \nng-if=\"xmlBillsRequest.sat\" aria-label=\"in sat\" class=\"md-primary md-hue-2\"><md-icon md-font-icon=\"icon-check\">\n</md-icon></md-button><md-button ng-if=\"!xmlBillsRequest.sat\" aria-label=\"not in sat\" class=\"md-warn\"><md-icon \nmd-font-icon=\"icon-cancel\"></md-icon></md-button></td><td md-cell ng-bind=\"xmlBillsRequest.satStatus\" \nclass=\"text-center\"></td><td md-cell ng-bind=\"xmlBillsRequest.isr\" class=\"text-center\"></td><td md-cell \nng-bind=\"xmlBillsRequest.satTotal\" class=\"text-center\"></td><td md-cell ng-bind=\"xmlBillsRequest.satFechaEmision\" \nclass=\"text-center\"></td><td md-cell ng-bind=\"xmlBillsRequest.satFechaPago\" class=\"text-center\"></td><td md-cell \nclass=\"text-center\"><md-button ng-if=\"xmlBillsRequest.system\" aria-label=\"in system\" class=\"md-primary md-hue-2\">\n<md-icon md-font-icon=\"icon-check\"></md-icon></md-button><md-button ng-if=\"!xmlBillsRequest.system\" \naria-label=\"not in system\" class=\"md-warn\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></td><td md-cell \nng-bind=\"xmlBillsRequest.tdsStatus\" class=\"text-center\"></td><td md-cell ng-bind=\"xmlBillsRequest.tdsTotal\" \nclass=\"text-center\"></td><td md-cell ng-bind=\"xmlBillsRequest.tdsAccuDate| date : F.dateFormat\" class=\"text-center\">\n</td><td md-cell ng-bind=\"xmlBillsRequest.tdsPeriod\" class=\"text-center\"></td><td md-cell \nng-bind=\"F.xmlBillsRequestResults[xmlBillsRequest.result]\" class=\"text-center\"></td><td md-cell \nng-bind=\"xmlBillsRequest.msg\"></td></tr></tbody></table></md-table-container><md-table-pagination \nlayout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" ng-show=\"xmlBillsRequests.length\" \nmd-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" md-limit-options=\"F.paginations\" md-page=\"$parent.currentPage\" \nmd-total=\"{{pagination.total}}\" md-on-paginate=\"getThemPagination\" md-page-select></md-table-pagination></div></div>\n<md-fab-speed-dial md-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" \nclass=\"ms2-speed-dial bottom right\"><md-fab-trigger><md-button aria-label=\"crud menu\" \nclass=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon></md-button></md-fab-trigger>\n<md-fab-actions><md-button action=\"exportv2\" access=\"{{F.active.menuItem}}\" \nng-click=\'exportData(xmlBillsRequests,\"xmlBillsRequests\",\"xmlBillsRequests\",\"mongo\",getParamsObject(),pagination.total,\",\",1,1,\"csv\")\' \naria-label=\"export\" class=\"md-fab md-raised md-mini md-primary md-hue-2\"><md-tooltip md-direction=\"left\">Exportar datos\n</md-tooltip><md-icon md-font-icon=\" icon-file-excel\" aria-label=\"export\"></md-icon></md-button></md-fab-actions>\n</md-fab-speed-dial></div></div>");
$templateCache.put("app/main/config/views/accountAccVars/accountAccVar.html","<div id=\"involvedRecord\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill><form name=\"form\" \nnovalidate flex layout=\"column\" ng-disabled=\"F.readMode\"><div fb-crud-detail-bar></div><md-content layout=\"column\" \nclass=\"content\" flex><div class=\"detail-form-container md-background-bg md-whiteframe-1dp\"><md-card \nclass=\"md-whiteframe-3dp\" style=\"width:auto\"><md-card-content class=\"p-5\"><div layout=\"row\"><md-input-container \nclass=\"md-block\" flex=\"30\"><input type=\"text\" class=\"m-0 p-0\" ng-disabled=\"F.readMode\" ng-model=\"accountAccVar.id\" \nplaceholder=\"Id\" no-white-space-input></md-input-container><md-input-container class=\"md-block\" flex=\"30\"><input \ntype=\"text\" class=\"m-0 p-0\" ng-disabled=\"F.readMode\" ng-model=\"accountAccVar.name\" placeholder=\"Nombre\">\n</md-input-container><md-input-container class=\"md-block\" flex=\"30\"><input type=\"text\" class=\"m-0 p-0\" \nng-disabled=\"F.readMode\" ng-model=\"accountAccVar.pathOrFn\" placeholder=\"Ruta\"></md-input-container><md-input-container \nflex=\"10\" class=\"mt-line\"><md-checkbox ng-model=\"accountAccVar.isFunction\" ng-disabled=\"F.readMode\" class=\"mb-0\" \naria-label=\"Cobrar relativos extras\">Función</md-checkbox></md-input-container></div></md-card-content></md-card></div>\n</md-content></form></div>");
$templateCache.put("app/main/config/views/accountAccVars/accountAccVars.html","<div id=\"accountAccVars\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div fb-search-bar></div><div class=\"content-card\" layout=\"column\" flex>\n<div class=\"content fullpage-datatable\" layout=\"column\" flex><div filter-toolbar></div><div table-loader \narray=\"accountAccVars\" validations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"accountAccVars.length\"><thead md-head md-order=\"order\" \nfix-head><tr md-row><th md-column md-order-by=\"id\"><span>Id</span></th><th md-column md-order-by=\"name\"><span>Nombre\n</span></th><th md-column md-order-by=\"path\"><span>Ruta</span></th><th md-column md-order-by=\"path\"><span>Función\n</span></th></tr></thead><tbody md-body><tr md-row md-auto-select md-select=\"accountAccVar\" md-select-id=\"$id\" \nng-repeat=\"accountAccVar in (F.filteredItems = (accountAccVars | filter:F.searchText.accountAccVar | orderBy:order)) | limitTo: F.paginate: (currentPage - 1) * F.paginate\">\n<td md-cell>{{accountAccVar.id}}</td><td md-cell>{{accountAccVar.name}}</td><td md-cell>{{accountAccVar.pathOrFn}}</td>\n<td md-cell><div layout=\"row\" layout-align=\"start center\"><active-indicator active=\"accountAccVar.isFunction\">\n</active-indicator></div></td></tr></tbody></table></md-table-container><md-table-pagination \nlayout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" ng-show=\"accountAccVars.length\" \nmd-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" md-limit-options=\"F.paginations\" md-page=\"currentPage\" \nmd-on-paginate=\"restartSelected\" md-total=\"{{F.filteredItems.length}}\" md-page-select></md-table-pagination></div>\n</div><md-fab-speed-dial md-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" \nclass=\"ms2-speed-dial bottom right\"><md-fab-trigger><md-button aria-label=\"crud menu\" \nclass=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon></md-button></md-fab-trigger>\n<md-fab-actions><md-button with-permission action=\"read\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" \nng-click=\'R.goToDetail(null, \"read\", {accountAccVarId: selected[0].$id})\' aria-label=\"view\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Ver</md-tooltip><md-icon \nmd-font-icon=\"icon-eye\" aria-label=\"view\"></md-icon></md-button><md-button with-permission action=\"update\" \naccess=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" \nng-click=\'R.goToDetail(null, \"update\", {accountAccVarId: selected[0].$id})\' aria-label=\"edit\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Editar</md-tooltip><md-icon \nmd-font-icon=\"icon-pencil\" aria-label=\"edit\"></md-icon></md-button><md-button with-permission action=\"remove\" \naccess=\"{{F.active.menuItem}}\" ng-click=\"delete($event)\" aria-label=\"Delete\" class=\"md-fab md-raised md-warn md-mini\">\n<md-tooltip md-direction=\"left\">{{\'EC.REMOVE\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-delete\" \naria-label=\"Remove\"></md-icon></md-button><md-button with-permission action=\"create\" access=\"{{F.active.menuItem}}\" \nng-if=\"!selected.length\" ng-click=\'R.goToDetail(null, \"update\", {accountAccVarId: \"new\"})\' aria-label=\"add\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">{{\'EC.ADD\' | translate}}\n</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon></md-button></md-fab-actions>\n</md-fab-speed-dial></div></div>");
$templateCache.put("app/main/config/views/accountingAccounts/accountingAccount.html","<div id=\"accountingAccount\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill \nng-controller=\"accountingAccountController\"><form name=\"form\" novalidate flex layout=\"column\" ng-disabled=\"F.readMode\">\n<div mongo-crud-detail-bar></div><md-content layout=\"column\" class=\"content\" flex><div \nclass=\"detail-form-container md-background-bg modern-container\"><md-card class=\"md-whiteframe-3dp\" style=\"width:auto\">\n<md-card-title class=\"pb-1\"><md-card-title-text><span class=\"md-headline font-weight-900 pl-15\">CUENTAS CONTABLES\n</span></md-card-title-text></md-card-title><md-card-content><md-card class=\"input-card\" flex=\"100\" layout=\"row\" \nlayout-align=\"start center\"><md-input-container class=\"md-block mb-10\" flex=\"50\"><label>Empresa</label><md-select \nng-model=\"accountingAccount.companiesRecord\" ng-disabled=\"F.readMode\" \nng-change=\"existData(accountingAccount.companiesRecord)\"><md-select-header><input type=\"search\" \nng-keydown=\"$event.stopPropagation()\" ng-model=\"companySelectFilter\" placeholder=\"Buscar empresa\" class=\"search-input\">\n</md-select-header><md-option ng-class=\"{\'grey-500-fg\':!company.active}\" ng-value=\"company.$id\" \nng-repeat=\"company in L.companiesRecords | orderBy:[\'-active\',\'name\'] | filter:companySelectFilter\">{{ company.name}}\n</md-option></md-select></md-input-container><md-input-container class=\"md-block mb-10\" flex=\"50\"><label>\nTipo de proceso</label><md-select ng-model=\"processSelected\" ng-disabled=\"F.readMode\"><md-option \nng-value=\"processData.$id\" ng-repeat=\"processData in selectCompaniesProcess\">{{ processData.name }}</md-option>\n</md-select></md-input-container></md-card><div flex layout-wrap layout-gt-sm=\"row\" layout-align-gt-sm=\"center start\">\n<div flex=\"100\" ng-if=\"processSelected\" flex-gt-md=\"50\" flex-gt-lg=\"33\"><md-card class=\"account-card\"><md-card-title \nclass=\"pb-0 pt-0\"><div layout=\"row\" layout-align=\"start center\"><div><h3>CARGOS</h3></div><div><md-icon \nng-click=\"addLevel(\'concept\', \'debits\')\" class=\"green-600-fg ml-5 pointers\" ng-if=\"!F.readMode\" \nmd-svg-src=\"/assets/icons/concept-give.svg\"></md-icon><md-tooltip md-direction=\"bottom\">Agregar Concepto</md-tooltip>\n</div><div><md-icon ng-click=\"addLevel(\'level\', \'debits\')\" ng-if=\"!F.readMode\" \nmd-svg-src=\"/assets/icons/bx-layer-plus.svg\" class=\"blue-600-fg ml-5 pointers\"></md-icon><md-tooltip \nmd-direction=\"bottom\">Agregar Nivel</md-tooltip></div></div></md-card-title><md-card-content class=\"p-0\"><ul \nclass=\"tree\"><li class=\"cc-child pr-0\" ng-repeat=\"debit in accountingAccount.process[processSelected].debits\" \nobject=\"debit\" mode=\"mode\" root-obj=\"accountingAccount.process[processSelected].debits\" \nparent=\"accountingAccount.process[processSelected].debits\" form=\"form\" child-index=\"$index\" cc-list=\"ccList\" \ncc-list-by-payroll=\"ccListByPayroll\" type=\"\'debit\'\" concepts=\"cargos\"></li></ul></md-card-content></md-card></div><div \nng-if=\"processSelected\" flex=\"100\" flex-gt-md=\"50\" flex-gt-lg=\"33\"><md-card class=\"account-card\"><md-card-title \nclass=\"pb-0 pt-0\"><div layout=\"row\" layout-align=\"start center\"><div><h3>ABONOS</h3></div><div><md-icon \nng-click=\"addLevel(\'concept\', \'credits\')\" ng-if=\"!F.readMode\" class=\"green-600-fg ml-5 pointers\" \nmd-svg-src=\"/assets/icons/concept-receive.svg\"></md-icon><md-tooltip md-direction=\"bottom\">Agregar Concepto\n</md-tooltip></div><div><md-icon ng-click=\"addLevel(\'level\', \'credits\')\" ng-if=\"!F.readMode\" \nmd-svg-src=\"/assets/icons/bx-layer-plus.svg\" class=\"blue-600-fg ml-5 pointers\"></md-icon><md-tooltip \nmd-direction=\"bottom\">Agregar Nivel</md-tooltip></div></div></md-card-title><md-card-content class=\"p-0\"><ul \nclass=\"tree\"><li class=\"cc-child pr-0\" ng-repeat=\"credit in accountingAccount.process[processSelected].credits\" \nobject=\"credit\" mode=\"mode\" root-obj=\"accountingAccount.process[processSelected].credits\" \nparent=\"accountingAccount.process[processSelected].credits\" form=\"form\" child-index=\"$index\" cc-list=\"ccList\" \ncc-list-by-payroll=\"ccListByPayroll\" type=\"\'credit\'\" concepts=\"bonos\"></li></ul></md-card-content></md-card></div><div \nflex=\"100\" flex-gt-lg=\"33\" layout=\"row\" layout-wrap layout-align=\"center start\" class=\"mt-5\"><div flex class=\"pt-0\">\n<md-card class=\"layout-card\"><md-card-title class=\"pb-0 pt-0\"><div layout=\"row\" layout-align=\"start center\"><div><h3>\nCONFIGURACIÓN DE LAYOUT</h3></div><div><md-icon ng-click=\"addLayoutField()\" class=\"green-600-fg ml-5 pointers\" \nng-if=\"!F.readMode\" md-font-icon=\"icon-plus-circle-outline\"></md-icon><md-tooltip md-direction=\"bottom\">\nAgregar campo del layout</md-tooltip></div></div></md-card-title><md-card-content ng-if=\"!F.readMode\" \nclass=\"mb-0 pb-0 pr-0\" flex=\"nogrow\"><div class=\"chip\" flex=\"nogrow\" ng-repeat=\"fields in C.accountAccVars\"><div \nclass=\"chip-content\">{{fields.name? \'{\' + fields.name + \'}\' : \'\'}}</div></div></md-card-content><div \nclass=\"pr-15 pl-15\"><md-input-container class=\"md-block no-errors-spacer\" flex><label>Nombre del archivo</label><input \ntype=\"text\" placeholder=\"Nombre del Archivo\" ng-disabled=\"F.readMode\" ng-model=\"accountingAccount.fileName\">\n</md-input-container><md-checkbox ng-model=\"accountingAccount.withSeparator\" class=\"mb-0\" ng-disabled=\"F.readMode\" \naria-label=\"withSeparator\">Añadir separador a la cuenta</md-checkbox></div><md-card-content class=\"mb-0 pb-0 mt-5\"><div\n layout=\"row\" layout-wrap layout-align=\"end end\" layout-align-gt-sm=\"center start\" \nng-repeat=\"($index, field) in accountingAccount.layoutFields\"><div flex=\"nogrow\" flex-order=\"2\" flex-order-gt-sm=\"1\">\n<md-icon md-font-icon=\"icon-arrow-up-bold\" class=\"pointer\" ng-if=\"!F.readMode\" \nng-click=\"movePosition(accountingAccount.layoutFields, $index, -1)\" \nng-show=\"accountingAccount.layoutFields.length > 1\" ng-disabled=\"$first\"><md-tooltip md-direction=\"right\">Mover Arriba\n</md-tooltip></md-icon><md-icon md-font-icon=\"icon-arrow-down-bold\" class=\"pointer\" ng-if=\"!F.readMode\" \nng-show=\"accountingAccount.layoutFields.length > 1\" \nng-click=\"movePosition(accountingAccount.layoutFields, $index, +1)\" ng-disabled=\"$last\"><md-tooltip \nmd-direction=\"right\">Mover Abajo</md-tooltip></md-icon></div><div flex flex-sm=\"100\" flex-xs=\"100\" flex-order=\"1\" \nflex-order-gt-sm=\"2\" layout=\"column\" layout-gt-sm=\"row\"><md-input-container class=\"md-block no-errors-spacer mt-0\" \nmd-no-float flex><input type=\"text\" no-white-space-input ng-disabled=\"F.readMode\" required placeholder=\"ID\" \nng-model=\"field.id\"></md-input-container><md-input-container class=\"md-block no-errors-spacer mt-0\" md-no-float flex>\n<input type=\"text\" ng-disabled=\"F.readMode\" placeholder=\"Nombre\" required ng-model=\"field.name\"></md-input-container>\n<md-input-container class=\"md-block no-errors-spacer mt-0\" md-no-float flex><md-select ng-model=\"field.type\" \nng-disabled=\"F.readMode\" name=\"processType\" placeholder=\"Tipo de de dato\"><md-option ng-value=\"undefined\">Texto\n</md-option><md-option ng-value=\"\'boolean\'\">Bolean</md-option><md-option ng-value=\"\'number\'\">Numero</md-option>\n<md-option ng-value=\"\'date\'\">Fecha</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block no-errors-spacer mt-0\" md-no-float flex><input type=\"text\" placeholder=\"Valor\" required \nng-disabled=\"F.readMode\" ng-model=\"field.value\"></md-input-container></div><div flex=\"nogrow\" flex-order=\"3\" \nflex-order-gt-sm=\"3\"><md-icon ng-click=\"deleteField($index)\" ng-if=\"!F.readMode\" class=\"red-600-fg ml-5 mt-0 pointers\" \nmd-font-icon=\"icon-delete-variant\"><md-tooltip md-direction=\"right\">Eliminar</md-tooltip></md-icon></div><hr \nflex=\"100\" flex-gt-sm=\"0\"></div><md-checkbox ng-model=\"accountingAccount.LayoutContpaqi\" class=\"mb-0\" \nng-disabled=\"F.readMode\" aria-label=\"withSeparator\">Mostrar layout contpaqi</md-checkbox></md-card-content></md-card>\n</div></div></div></md-card-content></md-card></div></md-content></form></div>");
$templateCache.put("app/main/config/views/accountingAccounts/accountingAccounts.html","<div id=\"accountingAccounts\" ng-controller=\"AccountingAccountsController\" \nclass=\"page-layout carded fullwidth crud-index\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div mongo-search-bar></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><md-tabs ng-if=\"tabs\" md-selected=\"F.selectedTab\"><md-tab \nng-repeat=\"tab in tabs\" ng-if=\"tabs[tab.name][\'accountingAccountsaccess\'+(tab.pObject?tab.pObject:\'\')]\" \nlabel=\"{{tab.title}}\" md-on-select=\"$parent.setTabName(tab.name)\"></md-tab></md-tabs><div list-filters \nfilters-loaded=\"F.filtersLoaded\" ng-model=\"F.filters[F.active.menuName]\" on-change=\"getThem\" tab-name=\"tabName\" \ntab-config=\"tabs[tabName]\" columns-repeat=\"columnsRepeat\" menu-obj-name=\"{{F.active.menuObjName}}\" \nmodel-name=\"{{F.active.menuName}}\" init-filters=\"initFilters\"></div><div table-loader array=\"accountingAccounts\" \nvalidations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"accountingAccounts.length\"><thead md-head \nmd-order=\"F.orderMongo\" fix-head md-on-reorder=\"getThem\"><tr md-row><th>Empresa</th></tr></thead><tbody md-body><tr \nmd-row md-auto-select md-select=\"accountingAccount\" md-select-id=\"_id\" \nng-repeat=\"accountingAccount in accountingAccounts\"><td>\n{{accountingAccount.companiesRecord | nameOfL:L.companiesRecords:\'N/A\'}}</td></tr></tbody></table></md-table-container>\n<md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" \nng-show=\"accountingAccounts.length\" md-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" \nmd-limit-options=\"F.paginations\" md-page=\"$parent.currentPage\" md-total=\"{{pagination.total}}\" \nmd-on-paginate=\"getThemPagination\" md-page-select></md-table-pagination></div></div><md-fab-speed-dial \nmd-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\"><md-fab-trigger>\n<md-button aria-label=\"crud menu\" class=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon>\n</md-button></md-fab-trigger><md-fab-actions><md-button with-permission action=\"read\" access=\"{{F.active.menuItem}}\" \nng-if=\"selected.length == 1\" ng-click=\'R.goToDetail(null, \"read\", {accountingAccountId: selected[0]._id,})\' \naria-label=\"view\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Ver</md-tooltip>\n<md-icon md-font-icon=\"icon-eye\" aria-label=\"view\"></md-icon></md-button><md-button with-permission action=\"update\" \naccess=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" ng-click=\"R.goToDetail(selected[0])\" aria-label=\"edit\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2 blue-900-bg\"><md-tooltip md-direction=\"left\">Editar</md-tooltip>\n<md-icon md-font-icon=\"icon-pencil\" aria-label=\"edit\"></md-icon></md-button><md-button ng-if=\"selected.length\" \nng-click=\'copyAccount(\"$event\")\' aria-label=\"add\" class=\"md-fab md-raised md-mini teal-900-bg md-hue-2\"><md-tooltip \nmd-direction=\"left\">Copiar cuenta contable</md-tooltip><md-icon md-svg-src=\"/assets/icons/bx-copy-alt.svg\" \nclass=\"deep-orange-50-fg\" aria-label=\"add\"></md-icon></md-button><md-button with-permission action=\"remove\" \naccess=\"{{F.active.menuItem}}\" ng-if=\"selected.length\" ng-click=\"delete($event)\" aria-label=\"Delete\" \nclass=\"md-fab md-raised md-warn md-mini red-A700-bg\"><md-tooltip md-direction=\"left\">{{\'EC.REMOVE\' | translate}}\n</md-tooltip><md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button><md-button with-permission \naction=\"create\" access=\"{{F.active.menuItem}}\" ng-if=\"!selected.length\" \nng-click=\'R.goToDetail(null,\"edit\",{type:tabConfig.name,accountingAccountId:\"new\"})\' aria-label=\"add\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">{{\'EC.ADD\' | translate}}\n</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon></md-button></md-fab-actions>\n</md-fab-speed-dial></div></div>");
$templateCache.put("app/main/config/views/accountingAccounts/copyAccount.html","<md-dialog aria-label=\"Reentry Employees\" id=\"copyAccount\" flex=\"30\" flex-xs=\"100\" flex-sm=\"50\" flex-md=\"40\" \nflex-lg=\"35\"><form name=\"form\" novalidate ng-cloak><md-toolbar><div class=\"md-toolbar-tools\"><h2>Copiar cuenta contable\n</h2></div></md-toolbar><md-dialog-content><div layout=\"row\" layout-align=\"start center\"><div flex=\"100\">\n<md-input-container class=\"md-block mb-10\"><label>Empresa</label><md-select \nng-model=\"cpyctrl.accountingAccount.companiesRecord\" \nng-change=\"cpyctrl.existData(cpyctrl.accountingAccount.companiesRecord, cpyctrl.accountingAccount.payroll)\">\n<md-select-header><input type=\"search\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"companySelectFilter\" \nplaceholder=\"Buscar empresa\" class=\"search-input\"></md-select-header><md-option ng-value=\"company.$id\" \nng-repeat=\"company in cpyctrl.companiesRecordsList | orderBy:\'data.name\' | filter:companySelectFilter\">\n{{ company.data.name }}</md-option></md-select></md-input-container></div></div><div ng-if=\"errorMessage\" \nid=\"errorMessage\">{{ errorMessage }}</div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"end center\"><div flex=\"nogrow\" class=\"mr-5\"><button class=\"btnSave\" ng-disabled=\"!cpyctrl.valid\" \nng-click=\"cpyctrl.copyAccount()\">Guardar</button></div><div flex=\"nogrow\"><button class=\"btnClose\" \nng-click=\"cpyctrl.close()\">Cancelar</button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/config/views/benefits/benefit.html","<div id=\"benefit\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill \nng-controller=\"BenefitController\"><form name=\"form\" novalidate flex layout=\"column\" ng-disabled=\"F.readMode\">\n<md-toolbar class=\"md-tall header md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" \nlayout=\"row\" layout-align=\"start center\" flex><md-button class=\"goto-button md-icon-button\" with-permission \naccess=\"{{F.active.menuItem}}\" action=\"access\" aria-label=\"Go to list\" ng-click=\"R.goToList()\" translate \ntranslate-attr-aria-label=\"EC.GO_TO\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"{{F.menuItems.config.benefits.icon}}\" class=\"crud-icon\"></md-icon>\n<div layout=\"column\" layout-align=\"start start\"><div class=\"h2\">{{benefit.incidencesType | nameOfM:M.incidencesTypes}}\n</div><div class=\"subtitle secondary-text\"><span ng-if=\"!F.addMode\">\n{{\'EC.DETAIL_OF\' | translate}} {{\'benefit.SINGULAR\' | translate}}</span> <span ng-if=\"F.addMode\">\n{{\'EC.CREATE\' | translate}} {{\'benefit.SINGULAR\' | translate}}</span></div></div></div></div><div><md-button \ntype=\"submit\" ng-if=\"!F.addMode\" with-permission action=\"update\" access=\"{{F.active.menuItem}}\" \nng-click=\"save(benefit)\" ng-hide=\"form.$pristine\" ng-disabled=\"form.$invalid || loadingProgress\" \nclass=\"md-raised md-background md-fab md-accent md-hue-1\" aria-label=\"Save benefit\"><md-tooltip md-direction=\"left\">\n{{\'EC.SAVE\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-content-save\" aria-label=\"Save\"></md-icon>\n</md-button><md-button type=\"submit\" ng-if=\"F.addMode\" with-permission action=\"create\" access=\"{{F.active.menuItem}}\" \nng-click=\"add(benefit)\" ng-hide=\"form.$pristine\" ng-disabled=\"form.$invalid || loadingProgress\" \nclass=\"md-raised md-background md-fab md-accent md-hue-1\" aria-label=\"Add benefit\"><md-tooltip md-direction=\"left\">\n{{\'EC.ADD\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-content-save\" aria-label=\"Add\"></md-icon></md-button>\n</div></md-toolbar><md-content layout=\"column\" class=\"content\" flex><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\"><md-input-container md-no-float \nstyle=\"margin: 0px!important;padding: 0px!important\"><input type=\"text\" style=\"display:none\" name=\"itemId\" unique-fb \nref=\"{{F.active.menuRef}}\" query=\"itemId\" fromid=\"{{benefit.$id}}\" aria-label=\"none\" ng-model=\"benefit.itemId\"><div \nng-messages=\"form.itemId.$error\" role=\"alert\"><div ng-message=\"unique\">Este registro ya existe en la base de datos\n</div></div></md-input-container><div layout-gt-xs=\"row\"><div ng-if=\'[\"payroll\",\"cc\"].indexOf(benefit.type)>-1\' flex \nlayout=\"column\"><md-input-container class=\"md-block md-icon-float\" flex-gt-xs=\"nogrow\" md-no-float><label>Nómina\n</label><md-select class=\"filter\" ng-disabled=\"F.readMode\" ng-model=\"F.benefitsSearch.payroll\" required>\n<md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" \nng-model=\"payrollSelectFilter\" placeholder=\"Busque una nomina\"></md-select-header><md-option \nng-if=\"!F.permissionToAccessAllPayrolls && (F.readMode || (!F.readMode && payroll.active))\" ng-value=\"payroll.$id\" \nng-repeat=\"payroll in L.payrolls | orderBy:\'name\' | filter:payrollSelectFilter\">{{payroll.name}}</md-option><md-option \nng-if=\"F.permissionToAccessAllPayrolls && (F.readMode || (!F.readMode && payroll.active))\" ng-value=\"payroll.$id\" \nng-repeat=\"payroll in L.allPayrolls | orderBy:\'name\' | filter:payrollSelectFilter\">{{payroll.name}}</md-option>\n</md-select></md-input-container></div><div ng-if=\'[\"cc\"].indexOf(benefit.type)>-1\' flex><md-input-container \nclass=\"md-block md-icon-float\" flex-gt-xs md-no-float><label>Centro de Costo</label><md-select class=\"filter\" \nng-model=\"F.benefitsSearch.cc\" required><md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" \nng-keydown=\"$event.stopPropagation()\" ng-model=\"ccSelectFilter\" placeholder=\"Busque un Centro de Costo\">\n</md-select-header><md-option ng-disabled=\"!cc.valid\" ng-value=\"cc.$id \" \nng-repeat=\"cc in L.payrollCcs[F.benefitsSearch.payroll] | orderBy:\'name\' | filter:ccSelectFilter\">\n{{cc.name}} [{{cc.rp_id|nameOfL:L.rps}}]</md-option></md-select></md-input-container></div><div \nng-if=\'[\"employee\"].indexOf(benefit.type)>-1\' flex><md-autocomplete class=\"md-block\" md-min-length=\"2\" \nmd-selected-item=\"employeeSelected\" md-search-text=\"searchQuery\" \nmd-selected-item-change=\"F.benefitsSearch.employee=item.$id\" md-item-text=\"item.data.name\" md-delay=\"500\" \nmd-items=\'item in autocompleteListM(searchQuery, \"employees\",[\"data.name\",\"data.nss\"],{\"data.nss\":{$exists:true}})\' \nmd-require-match=\"true\" md-select-on-match=\"true\" md-match-case-insensitive=\"true\" placeholder=\"Empleado\" \nmd-no-cache=\"true\" md-floating-label=\"Empleado\"><md-item-template><span md-highlight-text=\"searchQuery\">\n{{item.data.nss?item.data.nss+\' - \':\'\'}}{{item.data.name}}</span></md-item-template><md-not-found>No hay registros\n</md-not-found></md-autocomplete></div></div><form-benefit></form-benefit></div></md-content></form></div>");
$templateCache.put("app/main/config/views/benefits/benefits.html","<div id=\"benefits\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\" ng-controller=\"BenefitsController\"><div\n class=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div fb-search-bar></div><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><md-tabs \nng-show=\"anyHasPermission\"><md-tab ng-repeat=\"tab in F.active.tabs\" md-active=\"F.search.$type==tab\" \nng-disabled=\"!permissions[tab]\" label=\"{{(F.active.menuObjName + \'.\' + tab) | translate}}\" \nmd-on-select=\"tabChanged(tab)\"></md-tab></md-tabs><div ng-show=\"anyHasPermission\"><div flex \nclass=\"filterToolbar md-padding\" layout-gt-xs=\"row\" layout-align=\"end center\" ng-if=\'F.search.$type!=\"default\"\'><div \nng-if=\'[\"payroll\",\"cc\"].indexOf(F.search.$type)>-1\' flex><md-input-container class=\"md-block md-icon-float\" \nflex-gt-xs=\"nogrow\" md-no-float><label>Nómina</label><md-select class=\"filter\" ng-model=\"F.benefitsSearch.payroll\">\n<md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" \nng-model=\"payrollSelectFilter\" placeholder=\"Busque una nomina\"></md-select-header><md-option \nng-if=\"F.permissionToAccessAllPayrolls\" ng-value=\'\"all\"\'>Todas</md-option><md-option \nng-if=\"!F.permissionToAccessAllPayrolls\" ng-class=\"{\'inactiveOption\': !payroll.active}\" ng-value=\"payroll.$id\" \nng-repeat=\"payroll in L.payrolls | orderBy:\'name\' | filter:payrollSelectFilter\">{{payroll.name}}</md-option><md-option \nng-if=\"F.permissionToAccessAllPayrolls\" ng-value=\"payroll.$id\" ng-class=\"{\'inactiveOption\': !payroll.active}\" \nng-repeat=\"payroll in L.allPayrolls | orderBy:\'name\' | filter:payrollSelectFilter\">{{payroll.name}}</md-option>\n</md-select></md-input-container></div><div ng-if=\'[\"cc\"].indexOf(F.search.$type)>-1\' flex><md-input-container \nclass=\"md-block md-icon-float\" flex-gt-xs md-no-float><label>Centro de Costo</label><md-select class=\"filter\" \nng-model=\"F.benefitsSearch.cc\"><md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" \nng-keydown=\"$event.stopPropagation()\" ng-model=\"ccSelectFilter\" placeholder=\"Busque un Centro de Costo\">\n</md-select-header><md-option ng-value=\"\'all\'\">Todas</md-option><md-option ng-value=\"cc.$id \" \nng-class=\"{\'inactiveOption\': !cc.valid}\" \nng-repeat=\"cc in L.payrollCcs[F.benefitsSearch.payroll] | orderBy:\'name\' | filter:ccSelectFilter\">{{cc.name}}\n</md-option></md-select></md-input-container></div><div ng-if=\'[\"employee\"].indexOf(F.search.$type)>-1\' flex>\n<md-autocomplete class=\"md-block\" md-min-length=\"2\" md-selected-item=\"employeeSelected\" md-search-text=\"searchQuery\" \nmd-selected-item-change=\"F.benefitsSearch.employee=item.$id\" md-item-text=\"item.data.name\" md-delay=\"500\" \nmd-items=\'item in autocompleteMongo(searchQuery, \"employees\",[\"data.name\",\"data.nss\"],{\"data.nss\":{$exists:true}})\' \nmd-require-match=\"true\" md-select-on-match=\"true\" md-match-case-insensitive=\"true\" placeholder=\"Empleado\" \nmd-no-cache=\"true\" md-floating-label=\"Empleado\"><md-item-template><span md-highlight-text=\"searchQuery\">\n{{item.data.nss?item.data.nss+\'-\':\'\'}}{{item.data.name}}</span></md-item-template><md-not-found>No hay registros\n</md-not-found></md-autocomplete></div></div></div><div table-loader array=\"benefits\" validations=\"validations\"></div>\n<md-table-container ng-show=\"anyHasPermission\" \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"F.filteredItems.length\"><thead md-head \nmd-order=\"order\" fix-head><tr md-row><th ng-if=\'F.search.$type==\"payroll\"\' md-column md-order-by=\'\"payroll-name\"\'>\nNombre</th><th ng-if=\'F.search.$type==\"cc\"\' md-column md-order-by=\'\"cc-name\"\'>Nombre</th><th \nng-if=\'F.search.$type==\"employee\"\' md-column md-order-by=\'\"employee-name\"\'>Nombre</th><th \nng-if=\'F.search.$type==\"employee\" || F.search.$type==\"cc\"\' md-column md-order-by=\'\"payrollName-name\"\'>Nomina</th><th \nng-if=\'F.search.$type==\"employee\"\' md-column md-order-by=\'\"ccName-name\"\'>CC</th><th md-column \nmd-order-by=\"christmasBonus\">Dias Aguinaldo</th><th md-column md-order-by=\"prime\"><span>Prima Vacacional</span></th><th\n md-column md-order-by=\"holidays\">Vacaciones</th><th md-column md-order-by=\"hasOthers\">Otras prestaciones</th></tr>\n</thead><tbody md-body><tr md-row md-auto-select md-select=\"benefit\" md-select-id=\"$id\" \nng-repeat=\'benefit in (F.filteredItems = (Z.benefits | byArrayField : thisCcs : \"itemId\" | filter:F.searchText[F.active.menuObjName] | orderBy:order)) | limitTo: F.paginate: (currentPage - 1) * F.paginate\'>\n<td md-cell ng-if=\'F.search.$type==\"payroll\"\'>{{benefit[\'payroll-name\']}}</td><td md-cell ng-if=\'F.search.$type==\"cc\"\'>\n{{benefit[\'cc-name\']}}</td><td md-cell ng-if=\'F.search.$type==\"employee\"\'>{{benefit[\'employee-name\']}}</td><td md-cell \nng-if=\'F.search.$type==\"employee\" || F.search.$type==\"cc\"\'>{{benefit[\'payrollName-name\']}}</td><td md-cell \nng-if=\'F.search.$type==\"employee\"\'>{{benefit[\'ccName-name\']}}</td><td md-cell>{{benefit.christmasBonus}}</td><td \nmd-cell>{{benefit.prime}}</td><td md-cell>{{benefit.holidays}}</td><td md-cell>{{benefit.hasOthers?\"Si\":\"No\"}}</td>\n</tr></tbody></table></md-table-container><md-table-pagination ng-show=\"anyHasPermission\" layout-align=\"start center\" \nlayout-gt-xs=\"row\" layout-xs=\"column\" ng-show=\"F.filteredItems.length\" md-label=\"{{F.paginationLabel}}\" \nmd-limit=\"F.paginate\" md-limit-options=\"F.paginations\" md-page=\"currentPage\" md-on-paginate=\"restartSelected\" \nmd-total=\"{{F.filteredItems.length}}\" md-page-select></md-table-pagination><div ng-hide=\"anyHasPermission\" \nlayout-align=\"center center\" class=\"md-accent noData\"><h1 class=\"md-subhead\">\nNo tiene permiso para acceder a este modulo</h1></div></div></div><md-fab-speed-dial ng-show=\"anyHasPermission\" \nmd-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\" \nng-mouseenter=\"isOpen=true\" ng-mouseleave=\"isOpen=false\"><md-fab-trigger><md-button aria-label=\"crud menu\" \nclass=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon></md-button></md-fab-trigger>\n<md-fab-actions><md-button with-permission action=\"read\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" \nng-click=\'R.goToDetail(null, \"read\", {benefitId: selected[0].$id})\' aria-label=\"view\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Ver</md-tooltip><md-icon \nmd-font-icon=\"icon-eye\" aria-label=\"view\"></md-icon></md-button><md-button action=\"export\" \naccess=\"{{F.active.menuItem}}\" ng-click=\"exportDataToExcel(F.filteredItems,null,currentPage,F.paginate)\" \naria-label=\"export\" class=\"md-fab md-raised md-mini md-primary md-hue-2\"><md-tooltip md-direction=\"left\">\nExportar a excel</md-tooltip><md-icon md-font-icon=\" icon-file-excel\" aria-label=\"export\"></md-icon></md-button>\n<md-button with-permission action=\"update\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" \nng-click=\'R.goToDetail(null, \"update\", {benefitId: selected[0].$id})\' aria-label=\"Edit\" \nclass=\"md-fab md-raised md-accent md-hue-2 md-mini\"><md-tooltip md-direction=\"left\">{{\'EC.EDIT\' | translate}}\n</md-tooltip><md-icon md-font-icon=\"icon-pencil\" aria-label=\"Edit\"></md-icon></md-button><md-button with-permission \naction=\"remove\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length\" ng-click=\"delete($event)\" aria-label=\"Delete\" \nclass=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">{{\'EC.REMOVE\' | translate}}</md-tooltip>\n<md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button><md-button with-permission \naction=\"create\" access=\"{{F.active.menuItem}}\" ng-if=\"!selected.length\" \nng-click=\'R.goToDetail(null, \"update\", {benefitId: \"new\"})\' aria-label=\"add\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">{{\'EC.ADD\' | translate}}\n</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon></md-button></md-fab-actions>\n</md-fab-speed-dial></div></div>");
$templateCache.put("app/main/config/views/activitiesRecords/activitiesRecords.html","<div><div id=\"activitiesRecords\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\"><div class=\"center\" \nlayout=\"column\" flex><div class=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" \nlayout=\"column\" flex><div table-loader array=\"activitiesRecords\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table ng-model=\"selected\" \nclass=\"row-border\" ng-show=\"activitiesRecords.length\"><thead md-head md-order=\"order\" fix-head md-on-reorder=\"getThem\">\n<tr md-row><th md-column md-order-by=\"name\"><span>Actividad</span></th><th md-column md-order-by=\"name\"><span>Fecha\n</span></th></tr></thead><tbody md-body><tr md-row md-auto-select md-select=\"activitiesRecord\" md-select-id=\"_id\" \nng-repeat=\"activitiesRecord in activitiesRecords\"><td md-cell><b>\nSe {{\'l.\' + activitiesRecord.action | translate}} {{activitiesRecord.ref | interpretLogRef }}</b> <a \nng-if=\"activitiesRecord.data.data.name\" ng-click=\"goToLogRef(activitiesRecord.ref)\">{{activitiesRecord.data.data.name}}\n</a><a ng-if=\'activitiesRecord.ref.indexOf(\"movements\") !== -1\' ng-click=\"goToLogRef(activitiesRecord.ref)\">\n{{activitiesRecord.data.data.type | typeName}}</a> <span ng-if=\'activitiesRecord.ref.indexOf(\"movements\") !== -1\'>\na status \"{{activitiesRecord.data.status | movementStatusName}}\"</span></td><td md-cell><small>\n{{activitiesRecord.from.atTime | date:\'medium\'}}</small></td></tr></tbody></table></md-table-container>\n<md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" \nng-show=\"activitiesRecords.length\" md-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" \nmd-limit-options=\"F.paginations\" md-page=\"currentPage\" md-total=\"{{pagination.total}}\" md-on-paginate=\"getThem\" \nmd-page-select></md-table-pagination></div></div></div></div></div>");
$templateCache.put("app/main/config/views/archivedTickets/archivedTicket.html","<div id=\"archivedTicket\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill \nng-controller=\"ArchivedTicketController\"><form name=\"form\" novalidate flex layout=\"column\" ng-disabled=\"F.readMode\">\n<md-toolbar class=\"md-tall header md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" \nlayout=\"row\" layout-align=\"start center\" flex><md-button with-permission action=\"access\" \naccess=\"{{F.active.menuItem}}\" class=\"goto-button md-icon-button\" aria-label=\"Go to list\" ng-click=\"R.goToList()\" \ntranslate translate-attr-aria-label=\"EC.GO_TO\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div \nlayout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"{{F.menuItems[F.active.menuParent][F.active.menuName].icon || F.default.icon}}\" class=\"crud-icon\">\n</md-icon><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\">{{F.active.detailObject.data.name}}</div><div\n class=\"subtitle secondary-text\"><span ng-if=\"!F.addMode\">\n{{\'EC.DETAIL_OF\' | translate}} {{F.active.menuObjName + \'.SINGULAR\' | translate}}</span> <span ng-if=\"F.addMode\">\n{{\'EC.CREATE\' | translate}} {{F.active.menuObjName + \'.SINGULAR\' | translate}}</span></div></div></div></div><div>\n<md-button type=\"submit\" ng-if=\"!F.addMode && objectLoaded && !F.readMode\" with-permission action=\"reopen\" \naccess=\"{{F.active.menuItem}}\" ng-click=\"saveTicket(F.active.detailObject,true)\" \nng-disabled=\"form.$invalid || form.$pending || loadingProgress\" \nclass=\"md-raised md-background md-fab md-accent md-hue-1\" aria-label=\"reopen ticket\"><md-tooltip md-direction=\"left\">\nRe abrir Ticket</md-tooltip><md-icon md-font-icon=\"icon-undo\" aria-label=\"reopen\"></md-icon></md-button><md-button \ntype=\"submit\" ng-if=\"!F.addMode && objectLoaded && !F.readMode\" with-permission action=\"update\" \naccess=\"{{F.active.menuItem}}\" ng-click=\"saveTicket(F.active.detailObject)\" ng-hide=\"form.$pristine && !objectLoaded\" \nng-disabled=\"form.$invalid || form.$pristine || loadingProgress\" \nclass=\"md-raised md-background md-fab md-accent md-hue-1\" aria-label=\"Save\"><md-tooltip md-direction=\"left\">\n{{\'EC.SAVE\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-content-save\" aria-label=\"Save\"></md-icon>\n</md-button></div></md-toolbar><md-content layout=\"column\" class=\"content\" flex><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\"><form-ticket ticket=\"archivedTicket\" form=\"form\" \nfiles=\"files\" remove-upload=\"removeUpload\"></form-ticket></div></md-content></form></div>");
$templateCache.put("app/main/config/views/archivedTickets/archivedTickets.html","<div id=\"archivedTickets\" class=\"page-layout carded fullwidth crud-index\" ng-controller=\"ArchivedTicketController\" \nlayout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div mongo-search-bar>\n</div><div class=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><div \nlist-filters filters-loaded=\"F.filtersLoaded\" ng-model=\"F.filters[F.active.menuName]\" on-change=\"getThem\" \ncolumns-repeat=\"columnsRepeat\" menu-obj-name=\"{{F.active.menuObjName}}\" model-name=\"{{F.active.menuName}}\" \ninit-filters=\"initFilters\"></div><div table-loader array=\"archivedTickets\" validations=\"validations\"></div><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><div \nlist-filters filters-loaded=\"F.filtersLoaded\" ng-model=\"F.filters[F.active.menuName]\" on-change=\"getThem\" \ncolumns-repeat=\"columnsRepeat\" menu-obj-name=\"{{F.active.menuObjName}}\" model-name=\"{{F.active.menuName}}\" \ninit-filters=\"initFilters\"></div><div table-loader array=\"archivedTickets\" validations=\"validations\"></div><div \nclass=\"ticketsDash\" ng-if=\"archivedTickets && archivedTickets.length\"><div class=\"ticketsDash__inner\" layout=\"column\">\n<div class=\"ticketsDash__head\" layout=\"row\" layout-wrap layout-align=\"space-between center\"><div \nclass=\"ticketsDash__titleWrap\" layout=\"row\" layout-align=\"start center\"><div class=\"ticketsDash__badge\"><md-icon \nmd-svg-src=\"/assets/icons/Productivity.svg\"></md-icon></div><div><div class=\"ticketsDash__title\">Productividad</div>\n<div class=\"ticketsDash__sub\">Resumen basado en tickets mostrados</div></div></div><div class=\"ticketsDash__chips\" \nlayout=\"row\" layout-wrap layout-align=\"end center\"><div class=\"chip chip--soft\">Total: <b style=\"margin-left:6px\">\n{{dash.total}}</b></div><div class=\"chip chip--ok\">Cerrados: <b style=\"margin-left:6px\">{{dash.closed}}</b></div><div \nclass=\"chip chip--warn\">Proceso: <b style=\"margin-left:6px\">{{dash.progress}}</b></div><div class=\"chip chip--info\">\nAbiertos: <b style=\"margin-left:6px\">{{dash.open}}</b></div></div></div><div class=\"ticketsDash__scroll\"><div \nclass=\"ticketsDash__kpis\" layout=\"row\" layout-gt-md=\"row\" layout-align=\"start stretch\" layout-wrap=\"true\" \nlayout-wrap-gt-md=\"false\"><div flex-gt-md=\"10\" flex-md=\"50\" flex-sm=\"50\" flex-xs=\"100\" class=\"kpiCard kpiCard--big\">\n<div class=\"kpiCard__label\">Cerrados hoy</div><div class=\"kpiCard__value\">{{dash.closedToday}}</div><div \nclass=\"kpiCard__hint\">{{dash.todayLabel}}</div></div><div flex-gt-md=\"20\" flex-md=\"50\" flex-sm=\"50\" flex-xs=\"100\" \nclass=\"kpiCard kpiCard--big\"><div class=\"kpiCard__label\">Cerrados 7 días</div><div class=\"kpiCard__value\">\n{{dash.closed7d}}</div><div class=\"kpiCard__hint\">Últimos 7 días</div></div><div flex-gt-md=\"20\" flex-md=\"50\" \nflex-sm=\"50\" flex-xs=\"100\" class=\"kpiCard\"><div class=\"kpiCard__label\">Promedio cierre</div><div \nclass=\"kpiCard__value\">{{dash.avgCloseHours | number:1}}h</div><div class=\"kpiCard__hint\">\ncreated.atTime → closeDetail.atTime</div></div><div flex-gt-md=\"20\" flex-md=\"50\" flex-sm=\"50\" flex-xs=\"100\" \nclass=\"kpiCard\"><div class=\"kpiCard__label\">Mediana cierre</div><div class=\"kpiCard__value\">\n{{dash.medianCloseHours | number:1}}h</div><div class=\"kpiCard__hint\">Mejor métrica que promedio</div></div><div \nflex-gt-md=\"25\" flex-md=\"50\" flex-sm=\"100\" flex-xs=\"100\" class=\"kpiCard\"><div class=\"kpiCard__label\">\nTiempo total (cerrados)</div><div class=\"kpiCard__value\">{{dash.sumCloseHours | number:0}}h</div><div \nclass=\"kpiCard__hint\">Acumulado del periodo</div></div></div><div class=\"ticketsDash__charts\" layout=\"row\" layout-wrap \nlayout-align=\"start stretch\"><div flex-gt-md=\"50\" flex-md=\"100\" flex-xs=\"100\" class=\"chartCard\"><div \nclass=\"chartCard__head\" layout=\"row\" layout-align=\"space-between center\"><div><div class=\"chartCard__title\">\nDistribución por estatus</div><div class=\"chartCard__sub\">Proporción del total</div></div><div class=\"chip chip--soft\">\n<span class=\"dot dot--closed\"></span> Cerrado <span class=\"dot dot--progress\" style=\"margin-left:10px\"></span> Proceso \n<span class=\"dot dot--open\" style=\"margin-left:10px\"></span> Abierto</div></div><div class=\"stackBar\" \naria-label=\"Distribución por estatus\"><div class=\"stackBar__seg stackBar__seg--closed\" \nstyle=\"width: {{dash.pct.closed}}%\"></div><div class=\"stackBar__seg stackBar__seg--progress\" \nstyle=\"width: {{dash.pct.progress}}%\"></div><div class=\"stackBar__seg stackBar__seg--open\" \nstyle=\"width: {{dash.pct.open}}%\"></div></div><div class=\"stackBar__labels\" layout=\"row\" \nlayout-align=\"space-between center\"><span>Cerrados: <b>{{dash.closed}}</b> ({{dash.pct.closed | number:0}}%)</span> \n<span>Proceso: <b>{{dash.progress}}</b> ({{dash.pct.progress | number:0}}%)</span> <span>Abiertos: <b>{{dash.open}}</b>\n ({{dash.pct.open | number:0}}%)</span></div></div><div flex-gt-md=\"45\" flex-md=\"100\" flex-xs=\"100\" class=\"chartCard\">\n<div class=\"chartCard__head\" layout=\"row\" layout-align=\"space-between center\"><div><div class=\"chartCard__title\">\nMódulos con más cierres (Top 5)</div><div class=\"chartCard__sub\">Basado en tickets status=3</div></div><div \nclass=\"chip chip--soft\">Max: <b style=\"margin-left:6px\">{{dash.byModuleMax}}</b></div></div><div class=\"hBars\"><div \nclass=\"hBars__row\" ng-repeat=\"m in dash.byModuleTop\"><div class=\"hBars__name\">\n{{m.module| getSomethingOfArrayM:F.navigationItems:\'title\':ticket.module:\'_id\'}}</div><div class=\"hBars__bar\"><div \nclass=\"hBars__fill\" style=\"width: {{m.pct}}%\"></div></div><div class=\"hBars__val\">{{m.count}}</div></div></div></div>\n<div flex=\"100\" class=\"chartCard\"><div class=\"chartCard__head\" layout=\"row\" layout-align=\"space-between center\"><div>\n<div class=\"chartCard__title\">Cerrados por usuario (Top 5)</div><div class=\"chartCard__sub\">\nBasado en closeDetail.by (quien lo cerró)</div></div><div class=\"chip chip--soft\">Max: <b style=\"margin-left:6px\">\n{{dash.byCloserMax}}</b></div></div><div class=\"hBars\"><div class=\"hBars__row\" ng-repeat=\"u in dash.byCloserTop\"><div \nclass=\"hBars__name\">{{ u.userId | getSomethingOfArrayFB: L.profiles:\'name\':u.userId }} <span class=\"hBars__id\" \nng-if=\"!(u.userId | getSomethingOfArrayFB: L.profiles:\'name\':u.userId)\">{{u.userId}}</span></div><div \nclass=\"hBars__bar\"><div class=\"hBars__fill\" style=\"width: {{u.pct}}%\"></div></div><div class=\"hBars__val\">{{u.count}}\n</div></div></div></div></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/main/config/views/concepts/concept.html","<div id=\"concept\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill \nng-controller=\"ConceptController\"><form name=\"form\" novalidate flex layout=\"column\" ng-disabled=\"F.readMode\">\n<md-toolbar class=\"md-tall header md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" \nlayout=\"row\" layout-align=\"start center\" flex><md-button class=\"goto-button md-icon-button\" \naria-label=\"Go to payrollCalendars\" ng-click=\"R.goToList(F.active.menuName, F.active.menuParams)\" translate \ntranslate-attr-aria-label=\"EC.GO_TO\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"{{F.menuItems.clients.payrollCalendars.icon || F.default.icon}}\" \nclass=\"crud-icon\"></md-icon><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\">{{concept.name}}</div><div \nclass=\"subtitle secondary-text\"><span ng-if=\"!F.addMode\">\n{{\'EC.DETAIL_OF\' | translate}} {{\'concept.SINGULAR\' | translate}}</span> <span ng-if=\"F.addMode\">\n{{\'EC.CREATE\' | translate}} {{\'concept.SINGULAR\' | translate}}</span></div></div></div></div><div><md-button \ntype=\"submit\" ng-if=\"!F.addMode && !F.readMode\" with-permission action=\"update\" access=\"{{F.active.menuItem}}\" \nng-click=\'saveConcept(form, concept, \"update\")\' ng-hide=\"form.$pristine\" \nng-disabled=\"form.$invalid || loadingProgress\" class=\"md-raised md-background md-fab md-accent md-hue-1\" \naria-label=\"Save Concept\"><md-tooltip md-direction=\"left\">{{\'EC.SAVE\' | translate}}</md-tooltip><md-icon \nmd-font-icon=\"icon-content-save\" aria-label=\"Save\"></md-icon></md-button><md-button type=\"submit\" ng-if=\"F.addMode\" \nwith-permission action=\"create\" access=\"{{F.active.menuItem}}\" ng-click=\'saveConcept(form, concept, \"create\")\' \nng-hide=\"form.$pristine\" ng-disabled=\"form.$invalid || loadingProgress\" \nclass=\"md-raised md-background md-fab md-accent md-hue-1\" aria-label=\"Add Concept\"><md-tooltip md-direction=\"left\">\n{{\'EC.ADD\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-content-save\" aria-label=\"Add\"></md-icon></md-button>\n</div></md-toolbar><md-content layout=\"column\" class=\"content\"><md-tabs md-dynamic-height><md-tab label=\"Descripcion\">\n<md-tab-body><div class=\"detail-form-container md-background-bg md-whiteframe-1dp\" flex><div><fieldset \nclass=\"demo-fieldset\"><legend class=\"demo-legend\" \nng-class=\"{\'inactiveOption\': !concept.type, \'success\': concept.type}\">{{\'concept.TYPE\' | translate}} *</legend>\n<md-radio-group layout=\"row\" layout-wrap ng-model=\"concept.type\" ng-change=\"typeUpdated(concept.type)\" \nclass=\"m-radio-group\" required><md-radio-button flex-xs=\"100\" value=\"incidenceType\">\n{{\'concept.INCIDENCETYPE\' | translate}}</md-radio-button><md-radio-button flex-xs=\"100\" value=\"calc\">\n{{\'concept.CALC\' | translate}}</md-radio-button><md-radio-button flex-xs=\"100\" value=\"accumulator\">\n{{\'concept.ACCUMULATOR\' | translate}}</md-radio-button></md-radio-group></fieldset></div><div class=\"mb-10\"><fieldset \nclass=\"demo-fieldset\"><legend class=\"demo-legend\">Tipos de proceso</legend><md-checkbox \nng-model=\"concept.processes.payroll\" class=\"mb-0\" aria-label=\"For Payroll\">Nomina</md-checkbox><md-checkbox \nng-model=\"concept.processes.settlement\" class=\"mb-0\" aria-label=\"For Settlement\">Finiquito</md-checkbox><md-checkbox \nng-model=\"concept.processes.special\" class=\"mb-0\" aria-label=\"For Special\">Especial</md-checkbox><md-checkbox \nng-model=\"concept.processes.extraordinary\" class=\"mb-0\" aria-label=\"For Extraordinary\">Extraordinaria</md-checkbox>\n<md-checkbox ng-model=\"concept.processes.ptuRecord\" class=\"mb-0\" aria-label=\"For PtuRecord\">PTU</md-checkbox>\n<md-checkbox ng-model=\"concept.processes.asimilated\" class=\"mb-0\" aria-label=\"For asimilated\">Asimilados</md-checkbox>\n<md-checkbox ng-model=\"concept.processes.advAndLoanOpe\" class=\"mb-0\" aria-label=\"For advAndLoanOpe\">\nAnticipos y prestamos</md-checkbox><md-checkbox ng-model=\"concept.processes.travelExpensesOpe\" class=\"mb-0\" \naria-label=\"For travelExpensesOpe\">Viáticos</md-checkbox><md-checkbox ng-model=\"concept.processes.chrisBonusRecord\" \nclass=\"mb-0\" aria-label=\"For chrisBonusRecord\">Aguinaldo</md-checkbox><md-checkbox \nng-model=\"concept.processes.ptuDistributionRecord\" class=\"mb-0\" aria-label=\"For ptuDistributionRecord\">Distribución PTU\n</md-checkbox></fieldset></div><div layout=\"row\" layout-xs=\"column\" layout-wrap><md-input-container class=\"md-block\" \nflex=\"50\" ng-if=\'concept.type === \"incidenceType\"\'><label>{{\'payroll.SINGULAR\' | translate}}</label><md-select \nms2-autofocus ng-model=\"concept.payroll\" name=\"payroll\" required><md-select-header><input autocomplete=\"off\" \ntype=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"payrollSelectFilter\" \nplaceholder=\'{{\"payroll.SEARCHPAYROLL\"|translate}}\'></md-select-header><md-option value=\"global\" \nng-selected=\"showPayroll\">{{\'payroll.GLOBAL\' | translate | uppercased}} <small>\n{{\'payroll.FORALL\' | translate | uppercased}}</small></md-option><md-option \nng-class=\"{\'inactiveOption\':!payroll.active}\" \nng-if=\"!F.permissionToAccessAllPayrolls && concept.type === \'incidenceType\'\" ng-value=\"payroll.$id\" \nng-repeat=\"payroll in L.payrolls | orderBy:\'name\' | filter:payrollSelectFilter\">{{payroll.class}} {{payroll.name}}\n</md-option><md-option ng-class=\"{\'inactiveOption\':!payroll.active}\" \nng-if=\'F.permissionToAccessAllPayrolls && concept.type === \"incidenceType\"\' ng-value=\"payroll.$id\" \nng-repeat=\"payroll in L.allPayrolls | orderBy:\'name\' | filter:payrollSelectFilter\">{{payroll.class}} {{payroll.name}}\n</md-option></md-select><div ng-messages=\"form.payroll.$error\" ng-show=\"form.payroll.$touched || form.payroll.$dirty\" \nrole=\"alert\"><div ng-message=\"required\">La nómina es requerido</div></div></md-input-container><md-input-container \nlass=\"md-block\" flex=\"50\" ng-if=\'concept.type === \"incidenceType\"\'><md-chips ng-model=\"concept.payrollsRemoved\" \nmd-transform-chip=\"transformChip($chip)\" md-require-match=\"true\"><md-autocomplete md-selected-item=\"selectedItem\" \nclass=\"custom-template\" md-search-text=\"searchText\" md-no-cache=\"true\" md-items=\"item in querySearch(searchText)\" \nmd-item-text=\"item.name\" placeholder=\"Quitar nomina\"><md-item-template><span class=\"optionToSelect\">{{item.name}}<label\n ng-if=\"item.payroll!==\'global\'\">[{{item.class}}]</label></span></md-item-template><md-not-found>\nNo se encontraron resultados.</md-not-found></md-autocomplete><md-chip-template class=\"md-caption\"><span><strong>\n{{$chip | getSomethingOfArrayFB : allPayrolls : \'name\' : \'N/E\' : \'$id\'}}</strong></span></md-chip-template></md-chips>\n</md-input-container><md-input-container class=\"md-block\" flex=\"70\" flex-xs=\"100\"><label>{{\'concept.NAME\' | translate}}\n</label><input unique-fb ref=\'{{\"lists/concepts/payroll/\" + concept.payroll}}\' query=\"name\" fromid=\"{{concept.$id}}\" \nclass=\"uppercased\" type=\"text\" name=\"name\" ng-model=\"concept.name\" md-maxlength=\"200\" maxlength=\"200\" \nng-model-options=\"{ debounce: F.debounceTime }\" required><div ng-messages=\"form.name.$error\" \nng-show=\"form.name.$touched || form.name.$dirty\" role=\"alert\"><div ng-message=\"required\">\n{{\'concept.NAMEREQUIRED\' | translate}}</div><div ng-message=\"maxlength\">{{\'concept.NAMEMAX\' | translate}}</div><div \nng-message=\"unique\">{{\'concept.NAMEUNIQUE\' | translate}}</div></div></md-input-container><div flex=\"30\" flex-xs=\"100\" \nlayout=\"row\" layout-align=\"start center\"><md-input-container flex class=\"md-block\" ng-if=\"!concept.getMax\"><label>\nValor Maximo</label><input type=\"number\" name=\"max\" ng-model=\"concept.max\"></md-input-container><md-input-container \nflex class=\"md-block\" ng-if=\"concept.getMax\"><label>Valor Maximo</label><input type=\"text\" name=\"max\" \nng-model=\"concept.max\"></md-input-container><md-switch flex=\"nogrow\" name=\"getMax\" aria-label=\"get Max\" \nclass=\"md-secondary mb-0 mt-0\" ng-model=\"concept.getMax\">Formula</md-switch></div><md-input-container class=\"md-block\" \nflex=\'{{concept.type===\"incidenceType\"?25:33}}\' flex-xs=\"100\"><label>{{\'concept.KEY\' | translate}}</label><input \ntype=\"text\" name=\"key\" remove-space ng-model-options=\"{ debounce: F.debounceTime }\" ng-model=\"concept.key\" required>\n<div ng-messages=\"form.key.$error\" ng-show=\"form.key.$touched || form.key.$dirty\" role=\"alert\"><div \nng-message=\"required\">La clave es requerido</div><div ng-message=\"unique\">La clave ya está registrado en los conceptos\n</div></div></md-input-container><md-input-container class=\"md-block\" flex=\'{{concept.type===\"incidenceType\"?25:33}}\' \nflex-xs=\"100\"><label>{{\'concept.IDHUMAN\' | translate}}</label><input type=\"text\" name=\"id_human\" remove-space \nng-model-options=\"{ debounce: F.debounceTime }\" ng-model=\"concept.id_human\" required><div \nng-messages=\"form.id_human.$error\" ng-show=\"form.id_human.$touched || form.id_human.$dirty\" role=\"alert\"><div \nng-message=\"required\">El Código es requerido</div></div></md-input-container><md-input-container class=\"md-block\" \nflex=\'{{concept.type===\"incidenceType\"?25:33}}\' flex-xs=\"100\"><label>Codigo SAT</label><input type=\"text\" \nname=\"satCode\" remove-space ng-model-options=\"{ debounce: F.debounceTime }\" ng-model=\"concept.satCode\"><div \nng-messages=\"form.satCode.$error\" ng-show=\"form.satCode.$touched || form.satCode.$dirty\" role=\"alert\"></div>\n</md-input-container><md-input-container class=\"md-block\" ng-if=\'concept.type===\"incidenceType\"\' \nflex=\'{{concept.type===\"incidenceType\"?25:33}}\' flex-xs=\"100\"><label>Código Asistencia</label><input type=\"text\" \nname=\"attendanceCode\" remove-space ng-model-options=\"{ debounce: F.debounceTime }\" \nng-model=\"concept.attendanceCode                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              \">\n<div ng-messages=\"form.attendanceCode.$error\" ng-show=\"form.attendanceCode.$touched || form.attendanceCode.$dirty\" \nrole=\"alert\"></div></md-input-container><div flex=\"100\" flex-gt-xs=\"33\" class=\"p-5\"><span class=\"md-caption\">\n{{\'concept.INPUTDATATYPE\' | translate}}</span><md-radio-group ng-model=\"concept.inputType\" \nng-change=\"concept.validateDays=false\" required><md-radio-button value=\"currency\">{{\'concept.CURRENCY\' | translate}}\n</md-radio-button><md-radio-button value=\"integer\">{{\'concept.INTEGER\' | translate}}</md-radio-button><md-radio-button \nvalue=\"float\">{{\'concept.FLOAT\' | translate}}</md-radio-button></md-radio-group><md-checkbox \nng-model=\"concept.validateDays\" aria-label=\"Afecta dias\" \nng-if=\"concept.inputType === \'integer\' && concept.type==\'incidenceType\'\">Afecta días</md-checkbox><br><span \nclass=\"md-caption\">{{\'concept.NATURE\'|translate}}</span><md-radio-group name=\"nature\" ng-model=\"concept.nature\" \nng-required=\'concept.type===\"incidenceType\"\' ng-change=\"concept.forVariables=false\"><md-radio-button value=\"deduction\">\n{{\'concept.DEDUCTION\' | translate}}</md-radio-button><md-radio-button value=\"perception\">\n{{\'concept.PERCEPTION\' | translate}}</md-radio-button><md-radio-button ng-if=\'concept.type!==\"incidenceType\"\'>\nSin Especificar</md-radio-button></md-radio-group><md-checkbox \nng-if=\"concept.type===\'incidenceType\' && concept.nature===\'perception\'\" ng-model=\" concept.forVariables\" \naria-label=\"For Variables\">Para variables</md-checkbox><div flex></div><span class=\"md-caption\">Valor automático</span>\n<md-switch ng-disabled=\"F.readMode || concept.hiddenCalc\" ng-if=\"concept.type==\'incidenceType\'\" name=\"setValue\" \naria-label=\"set value\" class=\"md-secondary mb-0 mt-0\" ng-model=\"concept.setValue\" \nng-change=\"setValue(concept.setValue)\">Establecer valor automáticamente</md-switch><md-input-container \nclass=\"md-block mb-0 no-errors-spacer\" ng-if=\"concept.setValue\"><label>Valor Default</label><input type=\"number\" \nname=\"defaultValue\" ng-model-options=\"{ debounce: F.debounceTime }\" ng-model=\"concept.defaultValue\" required><div \nng-messages=\"form.defaultValue.$error\" ng-show=\"form.defaultValue.$touched || form.defaultValue.$dirty\" role=\"alert\">\n<div ng-message=\"required\">Valor default es requerido</div></div></md-input-container><md-switch \nng-disabled=\"F.readMode || concept.hiddenCalc\" ng-if=\"concept.type==\'incidenceType\' && concept.setValue\" \nname=\"noEditValue\" aria-label=\"no edit value\" class=\"md-secondary mt-0\" ng-model=\"concept.noEditValue\">\nNo permitir editar valor</md-switch></div><div flex=\"100\" flex-gt-xs=\"33\" class=\"p-5\"><span class=\"md-caption\">Totales\n<br></span><md-switch ng-disabled=\"F.readMode || concept.hiddenCalc\" name=\"showTotal\" aria-label=\"show total\" \nclass=\"md-secondary mt-0 mb-0\" ng-model=\"concept.showTotal\">{{\'concept.SHOWTOTAL\' | translate}}</md-switch><md-chips \nng-model=\"concept.otherTotals\" name=\"otherTotals\" readonly=\"ctrl.readonly\" md-transform-chip=\"transformChip($chip)\" \ninput-aria-label=\"Totales\" placeholder=\"Otros Totales\" secondary-placeholder=\"Agrega otro total\"><md-chip-template>\n<span><strong>{{$chip}}</strong></span></md-chip-template></md-chips><br><fieldset><legend>Cuentas contables</legend>\n<div ng-if=\"concept.type !== \'incidenceType\'\"><md-checkbox ng-model=\"concept.forAcc.debit\" aria-label=\"charge\">\nPara cargos</md-checkbox><md-checkbox ng-model=\"concept.forAcc.credit\" aria-label=\"payment\">Para abonos</md-checkbox>\n</div><div ng-if=\"concept.type === \'incidenceType\'\"><md-checkbox ng-model=\"concept.notForAcc\" \naria-label=\"Not for accounting\">No mostrar en póliza</md-checkbox></div></fieldset><br><md-switch \nng-disabled=\"F.readMode || concept.hiddenCalc\" ng-if=\"concept.type==\'incidenceType\'\" name=\"requireConfirmation\" \naria-label=\"require confirmation\" class=\"md-secondary mt-0 mb-0\" ng-model=\"concept.requireConfirmation\" \nng-change=\"setRequireConfirmation(concept.requireConfirmation)\">Solicitar Confirmacion</md-switch><md-switch \nng-disabled=\"F.readMode || concept.hiddenCalc\" ng-if=\"concept.type==\'incidenceType\'\" name=\"requireFile\" \naria-label=\"require file\" class=\"md-secondary mt-0 mb-0\" ng-model=\"concept.requireFile\" \nng-change=\"setRequireFile(concept.requireFile)\">Solicitar Archivo</md-switch><div ng-if=\"concept.requireFile\"><span \nclass=\"md-caption\">{{\'concept.FOLIO\' | translate}}</span><div layout=\"row\" layout-wrap><div flex=\"100\"><md-checkbox \nng-disabled=\"F.readMode\" ng-model=\"concept.addFolio\" aria-label=\"Folio Field\">{{\'concept.ADDFOLIO\' | translate}}\n</md-checkbox></div><div flex=\"50\"><md-checkbox ng-disabled=\"F.readMode || !concept.addFolio\" \nng-model=\"concept.uniqueFolio\" aria-label=\"Need to Calculate\">{{\'concept.UNIQUEFOLIO\' | translate}}</md-checkbox></div>\n<div flex=\"50\"><md-checkbox ng-disabled=\"F.readMode || !concept.addFolio\" ng-model=\"concept.requiredFolio\" \naria-label=\"Need to Calculate\">{{\'concept.REQUIREDFOLIO\' | translate}}</md-checkbox></div><md-input-container \nflex=\"100\" class=\"no-errors-spacer\"><label>{{\'concept.PATTERN\' | translate}}</label><input type=\"text\" name=\"pattern\" \nng-model=\"concept.pattern\" placeholder=\"{{\'concept.PATTERN\' | translate}}\" \nng-disabled=\"F.readMode || !concept.addFolio\"></md-input-container></div></div><fieldset><legend>\nIncidencias Automaticas<md-button \nng-click=\"concept.generateAuto.push?concept.generateAuto.push({}):concept.generateAuto=[{}]\" \naria-label=\"Add Auto Incidence\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-plus-circle-outline\"></md-icon>\n</md-button></legend><div ng-repeat=\"($index,inc) in concept.generateAuto\"><md-input-container class=\"md-block\"><label>\nIncidencia</label><md-select ng-model=\"concept.generateAuto[$index].incidenceType\" \nname=\"generateAutoIncidenceType{{$index}}\" ng-disabled=\"F.readMode\" required><md-select-header><input \nautocomplete=\"off\" type=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"conceptSelectFilter\" \nplaceholder=\"Busque un tipo de incidencia\"></md-select-header><md-option ng-value=\"thisConcept.$id\" \nng-if=\"thisConcept.type==\'incidenceType\' && (thisConcept.payroll===\'global\' || thisConcept.payroll===concept.payroll || concept.payroll===\'global\') && thisConcept.$id!==concept.$id\" \nng-repeat=\"thisConcept in listsConcepts | orderBy:\'name\' | filter:conceptSelectFilter\">{{thisConcept.name}}</md-option>\n</md-select><div ng-messages=\'form[\"generateAutoIncidenceType\"+$index].$error\' role=\"alert\"><div ng-message=\"required\">\nIncidencia es requerido</div></div></md-input-container><div layout=\"row\" layout-align=\"start start\">\n<md-input-container flex class=\"md-block no-errors-spacer mt-0\"><label>Validación de generación automática</label>\n<input type=\"text\" name=\"generateAutoValidation{{$index}}\" ng-model=\"concept.generateAuto[$index].validation\">\n</md-input-container><div flex=\"nogrow\"><md-button ng-click=\"concept.generateAuto.splice($index,1);form.$setDirty();\" \naria-label=\"Remove autoIncidence\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-trash\"></md-icon></md-button>\n</div></div><hr ng-if=\"!$last\"></div></fieldset></div><div flex=\"100\" flex-gt-xs=\"33\" class=\"p-5\"><span \nclass=\"md-caption\" flex=\"100\">{{\'concept.OTHEROPTIONS\' | translate}}</span><md-switch name=\"hiddenCalc\" \naria-label=\"hide Column\" class=\"md-secondary noMarginTop\" ng-model=\"concept.hiddenCalc\" \nng-change=\"setHiddenColumn(concept.hiddenCalc)\">{{\'concept.HIDDENCOLUMN\' | translate}}</md-switch><md-switch \nng-disabled=\"F.readMode\" name=\"byProvision\" aria-label=\"second Complement\" class=\"md-secondary\" \nng-model=\"concept.byProvision\">Por provision</md-switch><md-switch ng-disabled=\"F.readMode\" name=\"secondComplement\" \naria-label=\"second Complement\" class=\"md-secondary\" ng-model=\"concept.secondComplement\">Timbrar en segundo complemento\n</md-switch><md-switch ng-disabled=\"F.readMode || concept.requireConfirmation|| concept.hiddenCalc\" \nng-if=\"concept.type==\'incidenceType\'\" name=\"automatic\" aria-label=\"automatic incidence\" class=\"md-secondary mt-0\" \nng-model=\"concept.automatic\">{{\'concept.AUTOMATIC\' | translate}}</md-switch><md-switch \nng-disabled=\"F.readMode || concept.requireConfirmation || concept.hiddenCalc\" ng-if=\"concept.type==\'incidenceType\'\" \nng-change=\"concept.allowManual?concept.allowFast=false:\'\'\" name=\"showColumn\" aria-label=\"allow manual incidence\" \nclass=\"md-secondary\" ng-model=\"concept.allowManual\">{{\'concept.ALLOWMANUAL\' | translate}}</md-switch><md-switch \nng-disabled=\"F.readMode || concept.requireConfirmation || concept.hiddenCalc\" \nng-if=\"concept.type==\'incidenceType\' && concept.allowManual\" name=\"allowFast\" \nng-change=\"concept.allowFast?concept.allowNegative=false:\'\'\" aria-label=\"allow fast incidence\" class=\"md-secondary\" \nng-model=\"concept.allowFast\">Permitir Rapida</md-switch><md-switch \nng-disabled=\"F.readMode || concept.requireConfirmation || concept.hiddenCalc\" ng-if=\"concept.type==\'incidenceType\'\" \nname=\"\" aria-label=\"allow negative incidence\" class=\"md-secondary\" ng-model=\"concept.allowNegative\">Permitir Negativos\n</md-switch><md-switch ng-disabled=\"F.readMode || concept.requireConfirmation || concept.hiddenCalc\" \nng-if=\"concept.type==\'incidenceType\'\" name=\"constant\" aria-label=\"automatic incidence\" class=\"md-secondary\" \nng-model=\"concept.constant\">{{\'concept.CONSTANT\' | translate}}</md-switch><md-switch \nng-disabled=\"F.readMode || concept.requireConfirmation || concept.hiddenCalc\" ng-if=\"concept.type==\'incidenceType\'\" \nname=\"amortizationAvailable\" aria-label=\"Available for amortization\" class=\"md-secondary\" \nng-model=\"concept.amortizationAvailable\">{{\'concept.AMORTIZATIONAVAILABLE\' | translate}}</md-switch><md-switch \nng-disabled=\"F.readMode || concept.requireConfirmation || concept.hiddenCalc\" ng-if=\"concept.type==\'incidenceType\'\" \nname=\"forCredit\" aria-label=\"For Credit\" class=\"md-secondary\" ng-model=\"concept.forCredit\">\n{{\'concept.FORCREDIT\' | translate}}</md-switch><md-switch \nng-disabled=\"F.readMode || concept.requireConfirmation || concept.hiddenCalc\" ng-if=\"concept.type==\'incidenceType\'\" \nname=\"forCredit\" aria-label=\"Do not show input field\" class=\"md-secondary\" ng-model=\"concept.hiddenField\">\n{{\'concept.DONTSHOWINPUTFIELD\' | translate}}</md-switch><md-switch \nng-disabled=\"F.readMode || concept.requireConfirmation || concept.hiddenCalc\" ng-if=\"concept.type==\'incidenceType\'\" \nname=\"fdd\" aria-label=\"Days pending payment\" class=\"md-secondary\" ng-model=\"concept.fdd\">{{\'concept.FDD\' | translate}}\n</md-switch><md-switch ng-disabled=\"F.readMode || concept.hiddenCalc\" ng-if=\"concept.type==\'incidenceType\'\" \nname=\"isIncapacity\" aria-label=\"isIncapacity\" class=\"md-secondary\" ng-change=\"concept.valSubseq=false\" \nng-model=\"concept.isIncapacity\">Es incapacidad</md-switch><md-switch ng-disabled=\"F.readMode || concept.hiddenCalc\" \nng-if=\"concept.type==\'incidenceType\' && concept.isIncapacity\" name=\"valSubseq\" aria-label=\"valSubseq\" \nclass=\"md-secondary\" ng-model=\"concept.valSubseq\">Validar Subsecuente</md-switch></div></div></div></md-tab-body>\n</md-tab><md-tab label=\"Calculo\" ng-if=\"concept.type.length > 0\"><md-tab-body><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\" flex><div><labe>Campos a Escuchar</labe><md-chips \nng-model=\"concept.fieldsToListen\" name=\"fieldsToListen\" readonly=\"ctrl.readonly\" \nmd-transform-chip=\"transformChip($chip)\" input-aria-label=\"Filtros\" placeholder=\"Campo de Calculo\" \nsecondary-placeholder=\"Campo de Calculo\"><md-chip-template><span><strong>{{$chip}}</strong></span></md-chip-template>\n</md-chips></div><md-button aria-label=\"Add\" ng-click=\"addCalculation(indexCalculation)\" ng-disabled=\"form.$invalid\">\nAgregar Nuevo Calculo<md-icon md-font-icon=\"icon-playlist-plus\"></md-icon></md-button><div class=\"md-whiteframe-1dp\">\n<md-tabs class=\"md-accent\" md-border-bottom md-dynamic-height md-selected=\"selectedIndex\"><md-tab \nng-repeat=\"($index,calculation) in concept.calculations track by $index\" \nmd-on-select=\"setCalculation(calculation, $index, form)\" ng-disabled=\"form.$invalid && $index !== indexCalculation\" \nid=\"calculation-{{$index}}\"><md-tab-label style=\"display: inline-block\"><span>\n{{($last)?\'Calculo\':(!calculation.conceptType)? \'Calculo\':(calculation.conceptType === \'payrollId\')? \'Calculo Nómina\': (calculation.conceptType === \'ccId\')? \'Calculo CC\' : (calculation.conceptType === \'groupId\')? \'Calculo Agrupación\' : (calculation.conceptType === \'employeeId\')? \'Calculo Empleado\' : \'Calculo Default\'}} {{(!$last)?$index+1:\'Default\'}}\n</span><md-tooltip ng-if=\"calculation.conceptType === \'payrollId\'\" md-direction=\"top\">\n{{calculation.payrollId | nameOfL:(F.permissionToAccessAllPayrolls?L.allPayrolls:L.payrolls)}} {{(calculation.isFiscal)?\"FISCAL\" : \"\"}}\n</md-tooltip><md-tooltip ng-if=\"calculation.conceptType === \'ccId\'\" md-direction=\"top\">\n{{calculation.ccId | nameOfL:(F.permissionToAccessAllPayrolls?L.ccs:L.userCcs[F.profile.uid])}} {{(calculation.isFiscal)?\"FISCAL\" : \"\"}}\n</md-tooltip><md-tooltip ng-if=\"calculation.conceptType === \'groupId\'\" md-direction=\"top\">\n{{calculation.groupId | getSomethingOfArrayFB:groupings:\"name\":\"N/A\":\"$id\"}} {{(calculation.isFiscal)?\"FISCAL\" : \"\"}}\n</md-tooltip><md-tooltip ng-if=\"calculation.conceptType === \'employeeId\'\" md-direction=\"top\">\n{{calculation.employeeId | getSomethingOfArrayFB:employees:\"name\":\"N/A\":\"id\"}} {{(calculation.isFiscal)?\"FISCAL\" : \"\"}}\n</md-tooltip><md-tooltip ng-if=\"calculation.conceptType === \'default\' && calculation.isFiscal\" md-direction=\"top\">\nCALCULO FISCAL</md-tooltip><button ng-if=\"!calculation.disabledEdit\" ng-click=\"removeCalculation($event, $index)\" \nclass=\"md-icon-button\" aria-label=\"Delete\"><md-icon md-font-icon=\"icon-trash\" class=\"white-icon-trash\"></md-icon>\n</button> <button ng-disabled=\"form.$invalid || $index !== indexCalculation\" ng-click=\"copyCalculations($index)\" \nclass=\"md-icon-button\" aria-label=\"Copy content\"><md-icon md-font-icon=\"icon-content-copy\" class=\"white-icon-trash\">\n</md-icon></button> <button ng-if=\"!calculation.disabledEdit\" ng-show=\"concept.calculations.length > 2\" \nng-disabled=\"form.$invalid || $index === 0 || $index !== indexCalculation\" \nng-click=\"movePositionTabs(indexCalculation, -1, calculation)\" class=\"md-icon-button\" aria-label=\"Left\"><md-icon \nmd-font-icon=\"icon-chevron-left white-icon-chevron\"></md-icon></button> <button ng-if=\"!calculation.disabledEdit\" \nng-show=\"concept.calculations.length > 2\" \nng-disabled=\"form.$invalid || concept.calculations.length-2 === $index || $index !== indexCalculation\" \nng-click=\"movePositionTabs(indexCalculation, +1, calculation)\" class=\"md-icon-button\" aria-label=\"Right\"><md-icon \nmd-font-icon=\"icon-chevron-right white-icon-chevron\"></md-icon></button></md-tab-label></md-tab></md-tabs><div \nclass=\"padding-content\"><md-input-container class=\"md-block mb-0\" ng-if=\"!calculation.disabledEdit\" flex><label>\nConcepto por</label><md-select ng-model=\"calculation.conceptType\" name=\"conceptType\" required \nng-change=\"resetValuesOfConcept(indexCalculation, calculation.conceptType)\" ng-disabled=\"F.readMode\"><md-option \nng-value=\"conceptType.id\" ng-repeat=\"conceptType in F.conceptTypes track by conceptType.id\" \nng-disabled=\"conceptType.isFiscal\" \nng-if=\"(concept.payroll !== \'global\' && conceptType.id !== \'payrollId\') || concept.payroll === \'global\'\">\n{{conceptType.value}}</md-option></md-select><div ng-messages=\"form.conceptType.$error\" role=\"alert\"><div \nng-message=\"required\">El concepto es requerido</div></div></md-input-container><md-input-container \nng-if=\"(!calculation.conceptType || (calculation.conceptType === \'payrollId\' && concept.payroll === \'global\')) && !calculation.disabledEdit\" \nclass=\"md-block no-errors-spacer mb-0\" flex><label>Nómina</label><md-select ng-model=\"calculation.payrollId\" \nname=\"payrollId\" required ng-disabled=\"F.readMode\"><md-select-header><input autocomplete=\"off\" type=\"search\" \nclass=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"payrollSelectFilter\" placeholder=\"Busque una nómina\">\n</md-select-header><md-option ng-if=\"payroll.active||!F.addMode\" ng-value=\"payroll.$id\" \nng-class=\'{\"inactiveOption\":!payroll.active}\' \nng-repeat=\"payroll in (F.permissionToAccessAllPayrolls?L.allPayrolls:L.payrolls) | orderBy:\'name\' | filter:payrollSelectFilter\">\n{{payroll.class}} {{payroll.name}}</md-option></md-select><div ng-messages=\"form.payrollId.$error\" role=\"alert\"><div \nng-message=\"required\">Nómina es requerido</div></div></md-input-container><md-input-container \nng-if=\'calculation.conceptType === \"ccId\"\' class=\"md-block no-errors-spacer mb-0\" flex><label>Centros de Costo</label>\n<md-select ng-model=\"calculation.ccId\" name=\"ccId\" required ng-disabled=\"F.readMode\"><md-select-header><input \nautocomplete=\"off\" type=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"ccSelectFilter\" \nplaceholder=\"Busque un centro de costo\"></md-select-header><md-option ng-if=\"cc.valid||!F.addMode\" ng-value=\"cc.$id\" \nng-class=\'{\"inactiveOption\":!cc.valid}\' \nng-repeat=\"cc in (F.permissionToAccessAllPayrolls?L.ccs:L.userCcs[F.profile.uid]) | orderBy:\'name\' | filter:ccSelectFilter\">\n{{cc.name}}</md-option></md-select><div ng-messages=\"form.ccId.$error\" role=\"alert\"><div ng-message=\"required\">\nCentro de costo es requerido</div></div></md-input-container><md-input-container \nng-if=\'calculation.conceptType === \"groupId\"\' class=\"md-block no-errors-spacer mb-0\" flex><label>Agrupación</label>\n<md-select ng-model=\"calculation.groupId\" name=\"groupId\" required ng-disabled=\"F.readMode\"><md-select-header><input \nautocomplete=\"off\" type=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"groupSelectFilter\" \nplaceholder=\"Busque una agrupación\"></md-select-header><md-option ng-value=\"group.$id\" \nng-repeat=\"group in groupings | orderBy:\'name\' | filter:groupSelectFilter\">{{group.name}}</md-option></md-select><div \nng-messages=\"form.groupId.$error\" role=\"alert\"><div ng-message=\"required\">Agrupación es requerido</div></div>\n</md-input-container><md-autocomplete ng-if=\'calculation.conceptType === \"employeeId\"\' \nclass=\"md-block no-errors-spacer mb-0\" flex md-min-length=\"2\" md-selected-item=\"employeeSelected\" \nmd-search-text=\"searchQuery\" md-selected-item-change=\"calculation.employeeId=item.$id\" md-item-text=\"item.data.name\" \nmd-delay=\"500\" md-items=\"item in listsEmployees(searchQuery,L.userCcs[F.profile.uid])\" md-require-match=\"true\" \nmd-select-on-match=\"true\" md-match-case-insensitive=\"true\" placeholder=\"Empleado\" md-no-cache=\"true\" \nmd-input-name=\"employee\" ng-required=\"!addMode.read\" md-floating-label=\"Empleado\"><md-item-template><span \nmd-highlight-text=\"searchQuery\" style=\"display: block\" \nng-click=\"listsEmployeesOfTooltip(item.data.name, item.$id, item._id)\" ng-class=\"{\'inactiveOption\': (item.status==5)}\">\n{{item.data.nss?item.data.nss+\' - \':\'\'}}{{item.data.name}}</span></md-item-template><md-not-found>No hay registros\n</md-not-found><div ng-messages=\"form.employee.$error\"><div ng-message=\"required\">El empleado es requerido</div></div>\n</md-autocomplete><div ng-if=\'calculation.conceptType === \"custom\"\' class=\"custom-fields\"><button \nclass=\"md-icon-button btn-add-fields\" ng-click=\"addFieldsCustom(indexCalculation)\" aria-label=\"Add\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></button><div layout=\"row\" layout-xs=\"column\" \nng-repeat=\"($index, validation) in calculation.validations track by $index\"><md-input-container \nclass=\"md-block no-errors-spacer mb-0\" flex><label>Condición</label><input type=\"text\" name=\"condition{{$index}}\" \nng-model=\"validation.condition\" required><div ng-messages=\"form[\'condition\'+$index].$error\" role=\"alert\"><div \nng-message=\"required\">La condición requerido</div></div></md-input-container><md-input-container \nclass=\"md-block no-errors-spacer mb-0\" flex><label>Operador</label><md-select ng-model=\"validation.operator\" \nplaceholder=\"Seleccione un operador\" name=\"operator{{$index}}\" required><md-option value=\"equal\">Igual</md-option>\n<md-option value=\"notEqual\">Diferente</md-option></md-select><div ng-messages=\"form[\'operator\'+$index].$error\" \nrole=\"alert\"><div ng-message=\"required\">El operador es requerido</div></div></md-input-container><md-input-container \nclass=\"md-block no-errors-spacer mb-0\" flex><label>Valor</label><input type=\"text\" name=\"value{{$index}}\" \nng-model=\"validation.value\" required><div ng-messages=\"form[\'value\'+$index].$error\" role=\"alert\"><div \nng-message=\"required\">El valor es requerido</div></div></md-input-container><md-input-container \nclass=\"md-block no-errors-spacer mb-0\" flex=\"nogrow\"><button ng-if=\"!$first\" \nng-click=\"removeFieldsCustom(indexCalculation, $index)\" class=\"md-icon-button br-none\" aria-label=\"Delete\"><md-icon \nmd-font-icon=\"icon-trash\"></md-icon></button></md-input-container></div></div><md-input-container \nclass=\"md-block md-icon-float\" ng-style=\"calculation.conceptType === \'employeeId\' && {\'margin-top\':\'0\'}\" flex=\"100\">\n<label>Directiva</label><md-select ng-disabled=\"F.readMode\" ng-model=\"calculation.directive\" name=\"directive\" \nng-change=\"resetFields(calculation.directive, indexCalculation)\" required><md-select-header><input autocomplete=\"off\" \ntype=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"directiveSelectFilter\" \nplaceholder=\"Busque una directiva\"></md-select-header><md-option ng-value=\"false\">Ninguna</md-option><md-option \nng-value=\"directive._id\" ng-repeat=\"directive in M.directives | orderBy:\'name\' | filter: directiveSelectFilter\">\n{{directive._id}} - {{directive.name}}</md-option></md-select><div ng-messages=\"form.directive.$error\" role=\"alert\">\n<div ng-message=\"required\">La directiva es requerido</div></div></md-input-container><fieldset class=\"fieldsFieldset\" \nng-if=\"(calculation.disabledEdit && (calculation.directive === false || !calculation.directive)) || (!calculation.disabledEdit && calculation.directive === false)\">\n<legend><strong>CAMPOS DE CALCULO</strong> <button class=\"md-icon-button\" \nng-click=\"addFields(indexCalculation, concept.type)\" aria-label=\"Add\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n</button></legend><div flex layout=\"column\"><div layout=\"row\" class=\"background-field\" id=\"fields{{$index}}\" \nlayout-wrap ng-repeat=\"($index, field) in calculation.fields track by field.id\"><div flex=\"100\" layout=\"row\" \nlayout-align=\"end start\"><div flex=\"nogrow\"><button class=\"md-icon-button\" \nng-if=\"(field.id !== \'value\' && calculation.disabledEdit) || (field.id !== \'value\' && !calculation.disabledEdit) || concept.type === \'accumulator\'\" \nng-click=\"removeFields(indexCalculation, $index)\" aria-label=\"Delete\"><md-icon md-font-icon=\"icon-trash\"></md-icon>\n</button> <button class=\"md-icon-button\" ng-click=\"showAvailableFields()\" ng-if=\"field.function==\'calc\'\"><md-tooltip \nmd-direction=\"left\">Campos disponibles</md-tooltip><md-icon md-font-icon=\"icon-format-list-bulleted\"></md-icon>\n</button> <button class=\"md-icon-button\" ng-click=\"movePosition(indexCalculation, $index, -1)\" \nng-show=\"calculation.fields.length > 1\" ng-disabled=\"$first\" aria-label=\"Up\"><md-icon \nmd-font-icon=\"icon-arrow-up-bold\"></md-icon></button> <button class=\"md-icon-button\" \nng-click=\"movePosition(indexCalculation, $index, +1)\" ng-show=\"calculation.fields.length > 1\" ng-disabled=\"$last\" \naria-label=\"Up\"><md-icon md-font-icon=\"icon-arrow-down-bold\"></md-icon></button></div></div><md-input-container \nclass=\"mb-0 no-errors-spacer md-block\" flex-xs=\"100\" flex-sm=\"50\" \nflex-md=\"{{(field.outputType === \'float\' || field.outputType === \'array\' || field.outputType === \'object\' || field.outputType === \'objectArray\')?\'20\':\'25\'}}\" \nflex=\"{{(field.outputType === \'float\' || field.outputType === \'array\' || field.outputType === \'object\' || field.outputType === \'objectArray\')?\'20\':\'25\'}}\" \nng-if=\"field.id !== \'value\' || (field.id === \'value\' && concept.type === \'accumulator\')\"><label>ID</label><input \nng-model=\"field.id\" type=\"text\" ng-model-options=\"{ debounce: F.debounceTime }\" name=\"id{{$index}}\" \nng-change=\"validateField(field.id, indexCalculation, $index, form, id{{$index}})\" required><div \nng-messages=\"form[\'id\'+$index].$error\"><div ng-message=\"required\">Es requerido!</div><div ng-message=\"validationError\">\nEste valor ya existe</div></div></md-input-container><md-input-container class=\"mb-0 no-errors-spacer md-block\" \nflex-xs=\"100\" flex-sm=\"50\" \nflex-md=\"{{(field.outputType === \'float\' || field.outputType === \'array\' || field.outputType === \'object\' || field.outputType === \'objectArray\')?\'20\':\'25\'}}\" \nflex=\"{{(field.outputType === \'float\' || field.outputType === \'array\' || field.outputType === \'object\' || field.outputType === \'objectArray\')?\'20\':\'25\'}}\" \nng-if=\"field.id !== \'value\' || (field.id === \'value\' && concept.type === \'accumulator\')\"><label>Nombre</label><input \nng-model=\"field.name\" type=\"text\" ng-model-options=\"{ debounce: F.debounceTime }\" name=\"name{{$index}}\" \nclass=\"uppercased\" required><div ng-messages=\"form[\'name\'+$index].$error\"><div ng-message=\"required\">Es requerido!\n</div></div></md-input-container><md-input-container class=\"mb-0 no-errors-spacer md-block\" flex-xs=\"100\" \nflex-sm=\"{{(field.id === \'value\' && field.name === \'TOTAL\')?(field.outputType === \'float\' || field.outputType === \'array\' || field.outputType === \'object\' || field.outputType === \'objectArray\')?\'33\':\'50\':50}}\" \nflex-md=\"{{(field.id === \'value\' && field.name === \'TOTAL\')?(field.outputType === \'float\' || field.outputType === \'array\' || field.outputType === \'object\' || field.outputType === \'objectArray\')?\'33\':(concept.type===\'accumulator\')?\'25\':\'50\':(field.outputType === \'float\' || field.outputType === \'array\' || field.outputType === \'object\' || field.outputType === \'objectArray\')?\'20\':\'25\'}}\" \nflex=\"{{(field.id === \'value\' && field.name === \'TOTAL\')?(field.outputType === \'float\' || field.outputType === \'array\' || field.outputType === \'object\' || field.outputType === \'objectArray\')?\'33\':(concept.type===\'accumulator\')?\'25\':\'50\':(field.outputType === \'float\' || field.outputType === \'array\' || field.outputType === \'object\' || field.outputType === \'objectArray\')?\'20\':\'25\'}}\">\n<label>Tipo de dato (salida)</label><md-select ng-model=\"field.outputType\" placeholder=\"Seleccione un tipo de dato\" \nname=\"outputType{{$index}}\" required><md-option value=\"currency\">Moneda</md-option><md-option value=\"integer\">Entero\n</md-option><md-option value=\"float\">Decimales</md-option><md-option value=\"percent\">Porcentaje</md-option><md-option \nvalue=\"date\">Fecha</md-option><md-option value=\"string\">Texto</md-option><md-option value=\"array\">Arreglo</md-option>\n<md-option value=\"boolean\">Booleano</md-option><md-option value=\"object\">Objeto</md-option><md-option \nvalue=\"objectArray\">Objeto de Arreglos</md-option></md-select><div class=\"md-errors-spacer\"></div></md-input-container>\n<md-input-container class=\"mb-0 no-errors-spacer md-block\" \nng-if=\"field.outputType === \'array\' || field.outputType === \'object\' || field.outputType === \'objectArray\'\" \nflex-xs=\"100\" \nflex-sm=\"{{(field.id === \'value\' && field.name === \'TOTAL\')?\'33\':(field.outputType === \'float\' || field.outputType === \'array\' || field.outputType === \'object\' || field.outputType === \'objectArray\')? \'50\':\'25\'}}\" \nflex-md=\"{{(field.id === \'value\' && field.name === \'TOTAL\')?\'33\':(field.outputType === \'float\' || field.outputType === \'array\' || field.outputType === \'object\' || field.outputType === \'objectArray\')? \'20\':\'25\'}}\" \nflex=\"{{(field.id === \'value\' && field.name === \'TOTAL\')?\'33\':(field.outputType === \'float\' || field.outputType === \'array\' || field.outputType === \'object\' || field.outputType === \'objectArray\')? \'20\':\'25\'}}\">\n<label>Campos</label><input ng-model=\"field.fields\" type=\"text\" name=\"fields{{$index}}\"></md-input-container>\n<md-input-container class=\"mb-0 no-errors-spacer md-block\" ng-if=\"field.outputType === \'float\'\" flex-xs=\"100\" \nflex-sm=\"{{(field.id === \'value\' && field.name === \'TOTAL\')?\'33\':(field.outputType === \'float\' || field.outputType === \'array\' || field.outputType === \'object\' || field.outputType === \'objectArray\')? \'50\':\'25\'}}\" \nflex-md=\"{{(field.id === \'value\' && field.name === \'TOTAL\')?\'33\':(field.outputType === \'float\' || field.outputType === \'array\' || field.outputType === \'object\' || field.outputType === \'objectArray\')? \'20\':\'25\'}}\" \nflex=\"{{(field.id === \'value\' && field.name === \'TOTAL\')?\'33\':(field.outputType === \'float\' || field.outputType === \'array\' || field.outputType === \'object\' || field.outputType === \'objectArray\')? \'20\':\'25\'}}\">\n<label>Posiciones</label><input ng-model=\"field.positions\" type=\"text\" name=\"fields{{$index}}\"></md-input-container>\n<md-input-container class=\"mb-0 no-errors-spacer md-block\" flex-xs=\"100\" \nflex-sm=\"{{(field.id === \'value\' && field.name === \'TOTAL\')?(field.outputType === \'float\' || field.outputType === \'array\' || field.outputType === \'object\' || field.outputType === \'objectArray\')?\'33\':\'50\':(field.outputType === \'float\' || field.outputType === \'array\' || field.outputType === \'object\' || field.outputType === \'objectArray\')?\'100\':\'50\'}}\" \nflex-md=\"{{(field.id === \'value\' && field.name === \'TOTAL\')?(field.outputType === \'float\' || field.outputType === \'array\' || field.outputType === \'object\' || field.outputType === \'objectArray\')?\'33\':(concept.type===\'accumulator\')?\'25\':\'50\':(field.outputType === \'float\' || field.outputType === \'array\' || field.outputType === \'object\' || field.outputType === \'objectArray\')?\'20\':\'25\'}}\" \nflex=\"{{(field.id === \'value\' && field.name === \'TOTAL\')?(field.outputType === \'float\' || field.outputType === \'array\' || field.outputType === \'object\' || field.outputType === \'objectArray\')?\'33\':(concept.type===\'accumulator\')?\'25\':\'50\':(field.outputType === \'float\' || field.outputType === \'array\' || field.outputType === \'object\' || field.outputType === \'objectArray\')?\'20\':\'25\'}}\">\n<label>Función</label><md-select ng-model=\"field.function\" name=\"function{{$index}}\" \nplaceholder=\"Seleccione un calculo\" ng-change=\"resetValuesFormule(field.function, indexCalculation, $index)\" \nng-required=\"concept.type !== \'accumulator\'\"><md-option ng-if=\"concept.type === \'accumulator\'\" value=\"false\">NINGUNO\n</md-option><md-option value=\"calc\">EJECUTAR CALCULO</md-option><md-option value=\"field\">CAMPOS DE CALCULO</md-option>\n<md-option value=\"filter\">FILTROS</md-option></md-select></md-input-container><md-input-container \nclass=\"mb-0 no-errors-spacer md-block\" flex ng-if=\"field.function==\'calc\'\"><label>Formula</label><textarea \nng-model=\"field.formule\" name=\"formule{{$index}}\" rows=\"1\"></textarea></md-input-container><md-input-container \nclass=\"mb-0 no-errors-spacer md-block\" flex ng-if=\"field.function==\'field\'\"><label for=\"Campos de calculo\">\nCampos de Calculo</label><md-select name=\"field{{$index}}\" ng-model=\"field.formule\" required><md-select-header><input \nautocomplete=\"off\" type=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"formuleSelectFilter\" \nplaceholder=\"Busque un campo de calculo\"></md-select-header><md-option ng-value=\"field.route\" \nng-repeat=\"field in calcFields | orderBy:\'name\' | filter:formuleSelectFilter\">{{field.name}}</md-option></md-select>\n<div ng-messages=\'form[\"field\"+$index].$error\' ng-show=\"form[\'field\'+$index].$touched || form[\'field\'+$index].$dirty\" \nrole=\"alert\"><div ng-message=\"required\">El campo de calculo es requerido</div></div></md-input-container>\n<md-input-container class=\"mb-0 no-errors-spacer md-block\" flex-xs=\"100\" flex-sm=\"30\" flex-md=\"30\" flex=\"30\" \nng-if=\"field.function==\'filter\'\"><label for=\"Campos de calculo\">Filtros</label><md-select name=\"filter{{$index}}\" \nng-model=\"field.formule\" ng-change=\"field.params=[]\" required><md-select-header><input autocomplete=\"off\" \ntype=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"formuleSelectFilter\" \nplaceholder=\"Busque un campo de calculo\"></md-select-header><md-option ng-value=\"field.id\" \nng-repeat=\"field in filters | orderBy:\'name\' | filter:formuleSelectFilter\">{{field.name}}</md-option></md-select><div \nng-messages=\'form[\"filter\"+$index].$error\' role=\"alert\"><div ng-message=\"required\">El campo de calculo es requerido\n</div></div></md-input-container><div flex-xs=\"100\" flex-sm=\"70\" flex-md=\"70\" flex=\"70\" class=\"params\" \nng-if=\"field.function==\'filter\'\"><md-chips ng-model=\"field.params\" ng-required=\"true\" name=\"param{{$index}}\" \nreadonly=\"ctrl.readonly\" md-transform-chip=\"addParams($chip)\" \nmd-max-chips=\"{{objectParamsCount[field.formule].length + 1}}\" \nmd-on-add=\"validParams(field.params, objectParamsCount[field.formule].length, $parent.$index, form)\" \nmd-on-remove=\"validParams(field.params, objectParamsCount[field.formule].length, $parent.$index, form)\" \ninput-aria-label=\"Filtros\" placeholder=\"{{objectParamsCount[field.formule][field.params.length] || \'Parametros\'}}\" \nsecondary-placeholder=\"{{objectParamsCount[field.formule][field.params.length]}}\"><md-chip-template><span><strong>\n{{$chip}}</strong></span></md-chip-template></md-chips><div class=\"errorHint\" \nng-messages=\"form[\'param\'+$index].$error\" ng-show=\"form[\'param\'+$index].$touched || form[\'param\'+$index].$dirty\"><div \nng-message=\"required\">Los parámetros son requeridos</div><div ng-message=\"md-max-chips\">\nNúmero máximo de {{objectParamsCount[field.formule].length}} parámetros</div><div ng-message=\"minParams{{index}}\">\nNúmero mínimo de {{objectParamsCount[field.formule].length}} parámetros</div></div></div><div flex=\"100\"><div \nlayout=\"row\" layout-align=\"center end\" layout-xs=\"column\"><md-input-container flex \nclass=\"mb-0 no-errors-spacer md-block\"><label>Acumular en</label><md-select name=\"accumulator{{$index}}\" \nng-model=\"field.accumulator\"><md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" \nng-keydown=\"$event.stopPropagation()\" ng-model=\"accumulatorSelectFilter\" placeholder=\"Busque un acumulador\">\n</md-select-header><md-option ng-value=\"false\">NINGUNO</md-option><md-option ng-value=\"accumulator.$id\" \nng-if=\"accumulator.type==\'accumulator\'\" \nng-repeat=\"accumulator in listsConcepts | orderBy:\'name\' | filter:accumulatorSelectFilter\">{{accumulator.name}}\n</md-option></md-select><div ng-messages=\"form[\'accumulator\'+$index].$error\" \nng-show=\"form[\'accumulator\'+$index].$touched || form[\'accumulator\'+$index].$dirty\" role=\"alert\"><div \nng-message=\"required\">Acumulador es requerido</div></div></md-input-container><md-input-container flex \nclass=\"mb-0 no-errors-spacer md-block\" ng-if=\"concept.type === \'incidenceType\'\"><label>Procesos</label><md-select \nng-model=\"field.process\" name=\"process{{$index}}\"><md-option ng-value=\"false\">NINGUNO</md-option><md-option \nng-value=\"processType.id\" ng-repeat=\"processType in F.processTypes\">{{processType.name}}</md-option></md-select>\n</md-input-container><md-input-container flex class=\"mb-0 no-errors-spacer md-block\" ng-if=\"field.customValidation\">\n<label>Validacion</label><input ng-model=\"field.validation\" type=\"text\" \nng-model-options=\"{ debounce: F.debounceTime }\" name=\"validation{{$index}}\"></md-input-container></div></div><div \nflex=\"100\" class=\"mt-15\"><md-checkbox ng-model=\"field.hidden\" aria-label=\"Oculto\">Oculto</md-checkbox><md-checkbox \nng-model=\"field.ilb\" aria-label=\"Insert line break\">Insertar Salto de Linea</md-checkbox><md-checkbox \nng-model=\"field.customValidation\" aria-label=\"CustomValidation\">Validar campo</md-checkbox></div></div></div>\n</fieldset></div></div></div></md-tab-body></md-tab><md-tab label=\"Cuentas Contables\"><md-tab-body><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp accFields\"><md-button aria-label=\"Add\" \nng-click=\"addAccFields(index)\">Agregar Cuenta Contable<md-icon md-font-icon=\"icon-playlist-plus\"></md-icon></md-button>\n<div class=\"contField\" ng-repeat=\"(index, item) in concept.accFields track by index\"><div layout=\"row\" \nclass=\"fieldset\" layout-wrap><md-input-container flex-xs=\"100\" flex-sm=\"50\" flex-md=\"20\" flex=\"20\" class=\"md-block\">\n<label>Campo</label><input ng-model=\"item.field\" type=\"text\" name=\"field{{$index}}\" required><div \nng-messages=\"form[\'field\'+$index].$error\" ng-show=\"form[\'field\'+$index].$touched || form[\'field\'+$index].$dirty\" \nrole=\"alert\"><div ng-message=\"required\">El campo es requerido</div></div></md-input-container><md-input-container \nflex-xs=\"100\" flex-sm=\"50\" flex-md=\"30\" flex=\"30\" class=\"md-block\"><label>Cuenta Contable</label><input \nng-model=\"item.acc\" type=\"text\" name=\"acc{{$index}}\" required><div ng-messages=\"form[\'acc\'+$index].$error\" \nng-show=\"form[\'acc\'+$index].$touched || form[\'acc\'+$index].$dirty\" role=\"alert\"><div ng-message=\"required\">\nLa cuenta contable es requerido</div></div></md-input-container><md-input-container flex-xs=\"100\" flex-sm=\"50\" \nflex-md=\"15\" flex=\"15\" class=\"md-block\"><label>Tipo Cuenta Contable</label><md-select name=\"accN{{$index}}\" \nng-model=\"item.accN\" required><md-option value=\"C\">Crédito</md-option><md-option value=\"D\">Débito</md-option>\n</md-select><div class=\"md-errors-spacer\"></div><div ng-messages=\"form[\'accN\'+$index].$error\" \nng-show=\"form[\'accN\'+$index].$touched || form[\'accN\'+$index].$dirty\" role=\"alert\"><div ng-message=\"required\">\nTipo de cuenta contable es requerido</div></div></md-input-container><md-input-container flex-xs=\"100\" flex-sm=\"50\" \nflex-md=\"15\" flex=\"15\" class=\"md-block\"><label>Tipo de Proceso</label><md-select name=\"pType{{$index}}\" \nng-model=\"item.pType\" required><md-option value=\"fiscal\">Fiscal</md-option><md-option value=\"socialPrevision\">\nComplemento</md-option></md-select><div class=\"md-errors-spacer\"></div><div ng-messages=\"form[\'pType\'+$index].$error\" \nng-show=\"form[\'pType\'+$index].$touched || form[\'pType\'+$index].$dirty\" role=\"alert\"><div ng-message=\"required\">\nTipo de cuenta contable es requerido</div></div></md-input-container><md-input-container flex-xs=\"100\" flex-sm=\"50\" \nflex-md=\"15\" flex=\"15\" class=\"md-block\"><label>Tipo de Operación</label><md-select name=\"opType{{$index}}\" \nng-model=\"item.opType\"><md-option value=\"\">Ninguno</md-option><md-option value=\"payroll\">Nómina</md-option><md-option \nvalue=\"settlement\">Finiquito</md-option><md-option value=\"special\">Especial</md-option></md-select><div \nclass=\"md-errors-spacer\"></div><div ng-messages=\"form[\'pType\'+$index].$error\" \nng-show=\"form[\'pType\'+$index].$touched || form[\'pType\'+$index].$dirty\" role=\"alert\"><div ng-message=\"required\">\nTipo de cuenta contable es requerido</div></div></md-input-container><md-input-container class=\"md-block mb-25 delete\" \nflex-xs=\"100\" flex-sm=\"100\" flex-md=\"5\" flex=\"5\"><md-button class=\"md-icon-button m-0 pd-0\" aria-label=\"Delete\" \nng-click=\"deleteAccFields(index, concept.accFields)\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip \nmd-direction=\"top\">Eliminar</md-tooltip></md-button></md-input-container></div></div></div></md-tab-body></md-tab>\n<md-tab label=\"Acumulados\"><md-tab-body><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp accFields\"><md-button aria-label=\"Add\" \nng-click=\"addAccuFields(index)\">Agregar Acumulador<md-icon md-font-icon=\"icon-playlist-plus\"></md-icon></md-button><div\n class=\"contField\" ng-repeat=\"(index, item) in concept.accuFields track by index\"><div layout-gt-xs=\"row\" \nlayout=\"column\" class=\"fieldset\"><md-input-container flex class=\"md-block\"><label>Campo</label><input \nng-model=\"item.field\" type=\"text\" name=\"field{{$index}}\"><div ng-messages=\"form[\'field\'+$index].$error\" \nng-show=\"form[\'field\'+$index].$touched || form[\'field\'+$index].$dirty\" role=\"alert\"><div ng-message=\"required\">\nEl campo es requerido</div></div></md-input-container><md-input-container flex class=\"md-block\"><label>Nombre</label>\n<input ng-model=\"item.name\" type=\"text\" name=\"name{{$index}}\" required><div ng-messages=\"form[\'name\'+$index].$error\" \nng-show=\"form[\'name\'+$index].$touched || form[\'name\'+$index].$dirty\" role=\"alert\"><div ng-message=\"required\">\nLa nombre es requerido</div></div></md-input-container><md-input-container flex class=\"md-block\"><label>Operación\n</label><md-select name=\"operation{{$index}}\" ng-model=\"item.operation\" required><md-option value=\"sum\">Suma\n</md-option><md-option value=\"last\">Ultimo</md-option></md-select><div class=\"md-errors-spacer\"></div><div \nng-messages=\"form[\'operation\'+$index].$error\" \nng-show=\"form[\'operation\'+$index].$touched || form[\'operation\'+$index].$dirty\" role=\"alert\"><div ng-message=\"required\">\nTipo de operación es requerido</div></div></md-input-container><md-input-container flex class=\"md-block\"><label>Orden\n</label><input ng-model=\"item.order\" type=\"number\" step=\"1\" name=\"accuFieldOrder{{$index}}\"></md-input-container>\n<md-input-container flex class=\"md-block\"><label>Tipo de Proceso</label><md-select name=\"pType{{$index}}\" \nng-model=\"item.process\"><md-option ng-value>Ninguno</md-option><md-option value=\"fiscal\">Fiscal</md-option><md-option \nvalue=\"socialPrevision\">Complemento</md-option></md-select><div class=\"md-errors-spacer\"></div><div \nng-messages=\"form[\'pType\'+$index].$error\" ng-show=\"form[\'pType\'+$index].$touched || form[\'pType\'+$index].$dirty\" \nrole=\"alert\"><div ng-message=\"required\">Tipo de cuenta contable es requerido</div></div></md-input-container>\n<md-input-container flex class=\"md-block\"><label>Columna</label><md-select name=\"column{{$index}}\" \nng-model=\"item.column\"><md-option value=\"notShow\">No mostrar</md-option><md-option value=\"perception\">Percepcion\n</md-option><md-option value=\"deduction\">Deduccion</md-option><md-option value=\"provision\">Provision</md-option>\n<md-option value=\"other\">Otros</md-option></md-select><div class=\"md-errors-spacer\"></div><div \nng-messages=\"form[\'column\'+$index].$error\" ng-show=\"form[\'column\'+$index].$touched || form[\'column\'+$index].$dirty\" \nrole=\"alert\"><div ng-message=\"required\">Columna requerido</div></div></md-input-container><md-input-container \nclass=\"md-block mb-25 delete\" flex=\"nogrow\"><md-button class=\"md-icon-button m-0 pd-0\" aria-label=\"Delete\" \nng-click=\"deleteAccuFields(index, concept.accFields)\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip \nmd-direction=\"top\">Eliminar</md-tooltip></md-button></md-input-container></div></div></div></md-tab-body></md-tab>\n<md-tab label=\"Validaciones\" ng-if=\"concept.type === \'incidenceType\'\"><md-tab-body><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp accFields\"><md-button aria-label=\"Add\" \nng-click=\"addValidation(index)\">Agregar Validacion<md-icon md-font-icon=\"icon-playlist-plus\"></md-icon></md-button><div\n class=\"contField\" ng-repeat=\"(index, validation) in concept.validations track by index\"><div layout-gt-xs=\"row\" \nlayout=\"column\" class=\"fieldset\"><md-input-container flex class=\"md-block\"><label>Ruta</label><input \nng-model=\"validation.path\" type=\"text\" name=\"path{{$index}}\"><div ng-messages=\"form[\'path\'+$index].$error\" \nng-show=\"form[\'path\'+$index].$touched || form[\'path\'+$index].$dirty\" role=\"alert\"><div ng-message=\"required\">\nEl campo es requerido</div></div></md-input-container><md-input-container flex class=\"md-block\"><label>Operación\n</label><md-select name=\"operation{{$index}}\" ng-model=\"validation.operation\" required><md-option value=\"=\">Igual a\n</md-option><md-option value=\"!=\">Diferente a</md-option></md-select><div class=\"md-errors-spacer\"></div><div \nng-messages=\"form[\'operation\'+$index].$error\" \nng-show=\"form[\'operation\'+$index].$touched || form[\'operation\'+$index].$dirty\" role=\"alert\"><div ng-message=\"required\">\nTipo de operación es requerido</div></div></md-input-container><md-input-container flex class=\"md-block\"><label>Valor\n</label><input ng-model=\"validation.value\" type=\"text\" name=\"value{{$index}}\" required><div \nng-messages=\"form[\'value\'+$index].$error\" ng-show=\"form[\'value\'+$index].$touched || form[\'value\'+$index].$dirty\" \nrole=\"alert\"><div ng-message=\"required\">Valor es requerido</div></div></md-input-container><md-input-container flex \nclass=\"md-block\"><label>Error</label><input ng-model=\"validation.errorMsg\" type=\"text\" name=\"error{{$index}}\" required>\n<div ng-messages=\"form[\'error\'+$index].$error\" ng-show=\"form[\'error\'+$index].$touched || form[\'error\'+$index].$dirty\" \nrole=\"alert\"><div ng-message=\"required\">Error es requerido</div></div></md-input-container><md-input-container \nclass=\"md-block mb-25 delete\" flex=\"nogrow\"><md-button class=\"md-icon-button m-0 pd-0\" aria-label=\"Delete\" \nng-click=\"deleteValidation(index, concept.validations)\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip \nmd-direction=\"top\">Eliminar</md-tooltip></md-button></md-input-container></div></div></div></md-tab-body></md-tab>\n<md-tab label=\"GeoVictoria\"><md-tab-body><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp accFields\"><div layot=\"row\"><md-input-container \nclass=\"md-block\" flex=\"50\"><label>Identificador Geo victoria</label><input ng-model=\"concept.idGeo\" type=\"text\" \nname=\"idGeo\"></md-input-container><div flex=\"50\"><md-switch name=\"geoDateNotAssign\" aria-label=\"geoDateNotAssign\" \nclass=\"md-secondary mb-0 mt-0\" ng-model=\"concept.geoDateNotAssign\">No reasignar fecha GeoVictoria</md-switch></div>\n</div></div></md-tab-body></md-tab></md-tabs></md-content></form></div>");
$templateCache.put("app/main/config/views/concepts/concepts.html","<div id=\"concepts\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\" ng-controller=\"ConceptsController\"><div\n class=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div mongo-search-bar></div><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><div \nlist-filters filters-loaded=\"F.filtersLoaded\" ng-model=\"F.filters[F.active.menuName]\" on-change=\"getThem\" \ncolumns-repeat=\"columnsRepeat\" menu-obj-name=\"{{F.active.menuObjName}}\" model-name=\"{{F.active.menuName}}\" \ninit-filters=\"initFilters\"></div><div table-loader array=\"concepts\" validations=\"validations\"></div><md-table-container\n class=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"concepts.length\"><thead md-head \nmd-order=\"F.orderMongo\" fix-head md-on-reorder=\"getThem\"><tr md-row><th md-column md-order-by=\"payroll\"><span>Nómina\n</span></th><th md-column md-order-by=\"name\"><span>Nombre</span></th><th md-column md-order-by=\"key\"><span>Llave</span>\n</th><th md-column md-order-by=\"id_human\"><span>Código</span></th><th md-column md-order-by=\"type\"><span>\nTipo de Concepto</span></th><th md-column md-order-by=\"nature\"><span>Naturaleza</span></th><th md-column \nmd-order-by=\"accFields\"><span>Cuentas</span></th><th md-column><span>Global</span></th><th md-column \nmd-order-by=\"{{column.path}}\" ng-repeat=\"column in columnsRepeat\" ng-show=\"column.show\">{{column.name}}</th></tr>\n</thead><tbody md-body><tr md-row md-select=\"concept\" md-auto-select md-select-id=\"$id\" \nng-repeat-start=\"concept in concepts\"><td md-cell>\n{{(concept.payroll === \'global\' ) ? \'GLOBAL\' : (concept.payroll | nameOfL:L.allPayrolls:\'N/A\')}}</td><td md-cell>\n{{concept.name}} <button ng-if=\"!concept.showCalculation\" ng-click=\"concept.showCalculation=true\" \naria-label=\"show calculation\"><md-icon md-font-icon=\"icon-eye\"></md-icon></button> <button \nng-if=\"concept.showCalculation\" ng-click=\"concept.showCalculation=false\" aria-label=\"not show calculation\"><md-icon \nmd-font-icon=\"icon-eye-off\"></md-icon></button></td><td md-cell><div layout=\"row\" layout-align=\"start center\"><div \nflex=\"nogrow\">{{concept.key}}</div><div flex=\"nogrow\"><md-button with-permission action=\"update\" \naccess=\"{{F.active.menuItem}}\" class=\"md-icon-button\" \nng-click=\"openModalEdit($event,{path:\'key\',name:\'Llave\',type:\'string\', rute:crute},concept)\" aria-label=\"More\"><md-icon\n md-font-icon=\"icon-pencil\"></md-icon></md-button></div></div></td><td md-cell><div layout=\"row\" \nlayout-align=\"start center\"><div flex=\"nogrow\">{{concept.id_human}}</div><div flex=\"nogrow\"><md-button with-permission \naction=\"update\" access=\"{{F.active.menuItem}}\" class=\"md-icon-button\" \nng-click=\"openModalEdit($event,{path:\'id_human\',name:\'Código\',type:\'string\', rute:crute},concept)\" aria-label=\"More\">\n<md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></div></div></td><td md-cell>\n{{(concept.type)?((\'concept.\'+(concept.type|uppercase)) | translate | uppercase) :\'N/A\'}}</td><td md-cell>\n{{concept.nature ? (\'c.\' + concept.nature | translate) : \'\'}}</td><td md-cell><md-button with-permission \naction=\"update\" access=\"{{F.active.menuItem}}\" class=\"md-icon-button md-primary md-hue-2\" aria-label=\"show accounts\" \nng-if=\"concept.accFields\"><md-tooltip md-direction=\"left\" style=\"overflow: visible\"><span \nng-repeat=\"accField in concept.accFields\">{{accField.acc}}<strong> {{$last?\'\':\' - \'}}</strong></span></md-tooltip>\n<md-icon md-font-icon=\"icon-library-books\"></md-icon></md-button></td><td md-cell>\n{{concept.payroll==\"global\"?\"SI\":\"NO\"}}</td><td md-cell ng-repeat=\"column in columnsRepeat\" ng-show=\"column.show\"><div \nlayout=\"row\" layout-align=\"start center\"><div flex=\"nogrow\">{{concept | getValueOfRecord: column}}</div><div \nflex=\"nogrow\"><md-button ng-if=\"column.editable(concept)\" class=\"md-icon-button\" \nng-click=\"openModalEdit($event,column,concept)\" aria-label=\"More\"><md-icon md-font-icon=\"icon-pencil\"></md-icon>\n</md-button></div></div></td></tr><tr md-row class=\"animate-fade-in-out\" ng-if=\"concept.showCalculation\" \nng-init=\"concept.cIndex=0\" ng-repeat-end><td md-cell colspan=\"8\"><div><div layout=\"row\" layout-align=\"center end\"><div \nflex=\"nogrow\" ng-if=\"concept.calculations.length>1\"><md-select ng-model=\"concept.cIndex\" placeholder=\"Calculo\" \nclass=\"md-no-underline\"><md-option ng-value=\"$cIndex\" ng-repeat=\"($cIndex,calculation) in concept.calculations\" \nng-bind=\"\'Calculo \'+($cIndex+1)\"></md-option></md-select></div><div flex layout=\"row\" class=\"tags\"><span flex=\"nogrow\" \nng-if=\"concept.processes.payroll\" class=\"text-boxed\">Nomina</span> <span flex=\"nogrow\" \nng-if=\"concept.processes[ope.id]\" class=\"text-boxed\" ng-repeat=\"ope in F.operationTypes\" ng-bind=\"ope.name\"></span>\n</div></div><dl><dt class=\"mb-0\" ng-repeat-start=\"field in concept.calculations[concept.cIndex].fields\">\n{{field.name}}: <small>{{field.accumulator?(\'[\'+(field.accumulator | nameOfL : L.concepts : \'Falta Accu\') + \']\'):\'\'}}\n</small></dt><dd class=\"mb-5 mt-0\" ng-repeat-end ng-bind=\"field.formule\"></dd></dl></div></td><td md-cell \nng-repeat=\"column in columnsRepeat\" ng-show=\"column.show\">&nbsp;</td></tr></tbody></table></md-table-container>\n<md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" ng-show=\"concepts.length\" \nmd-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" md-limit-options=\"F.paginations\" md-page=\"$parent.currentPage\" \nmd-total=\"{{pagination.total}}\" md-on-paginate=\"getThemPagination\" md-page-select></md-table-pagination></div></div>\n<md-fab-speed-dial md-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" \nclass=\"ms2-speed-dial bottom right\"><md-fab-trigger><md-button aria-label=\"crud menu\" \nclass=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon></md-button></md-fab-trigger>\n<md-fab-actions><md-button with-permission action=\"read\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" \nng-click=\'R.goToDetail(null, \"read\", {conceptId: selected[0].$id, payrollId: selected[0].payroll})\' aria-label=\"view\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Ver</md-tooltip><md-icon \nmd-font-icon=\"icon-eye\" aria-label=\"view\"></md-icon></md-button><md-button with-permission action=\"update\" \naccess=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" \nng-click=\'R.goToDetail(null, \"update\", {conceptId: selected[0].$id, payrollId: selected[0].payroll})\' \naria-label=\"edit\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Editar\n</md-tooltip><md-icon md-font-icon=\"icon-pencil\" aria-label=\"edit\"></md-icon></md-button><md-button with-permission \naction=\"remove\" access=\"{{F.active.menuItem}}\" ng-click=\"deleteConcepts($event, selected)\" aria-label=\"Delete\" \nclass=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">{{\'EC.REMOVE\' | translate}}</md-tooltip>\n<md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button><md-button with-permission \naction=\"create\" access=\"{{F.active.menuItem}}\" ng-if=\"!selected.length\" \nng-click=\'R.goToDetail(null, \"update\", {conceptId: \"new\"})\' aria-label=\"add\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">{{\'EC.ADD\' | translate}}\n</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon></md-button><md-button with-permission \naction=\"export\" access=\"{{F.active.menuItem}}\" \nng-click=\'exportDataToExcelByQuery(concepts,\"concepts\",getParamsObject(),pagination.total,\"catalogs/concepts/collection\")\' \naria-label=\"export\" class=\"md-fab md-raised md-mini md-primary md-hue-2\"><md-tooltip md-direction=\"left\">\nExportar a excel</md-tooltip><md-icon md-font-icon=\" icon-file-excel\" aria-label=\"export\"></md-icon></md-button>\n<md-button with-permission action=\"copyConcepts\" access=\"{{F.active.menuItem}}\" \nng-if=\"selected.length>0 && checkTypeConcept(selected)\" aria-label=\"copy\" \nng-click=\"showPayrollModal($event, selected)\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip \nmd-direction=\"left\">{{\'concept.COPYCONCEPT\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-transfer\" \naria-label=\"copy\"></md-icon></md-button><md-button with-permission action=\"editConcepts\" \naccess=\"{{F.active.menuItem}}\" aria-label=\"edit concepts\" ng-click=\"showEditConceptsModal($event, selected)\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Editar conceptos</md-tooltip>\n<md-icon md-font-icon=\"icon-table-edit\" aria-label=\"copy\"></md-icon></md-button></md-fab-actions></md-fab-speed-dial>\n</div></div>");
$templateCache.put("app/main/config/views/calc-fields/calc-field.html","<div id=\"calcField\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill \nng-controller=\"calcFieldController\"><form name=\"form\" novalidate flex layout=\"column\" ng-disabled=\"F.readMode\">\n<md-toolbar class=\"md-tall header md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" \nlayout=\"row\" layout-align=\"start center\" flex><md-button class=\"goto-button md-icon-button\" \naria-label=\"Go to calcFields\" with-permission action=\"access\" access=\"{{F.active.menuItem}}\" ng-click=\"R.goToList()\" \ntranslate translate-attr-aria-label=\"EC.GO_TO\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div \nlayout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"{{F.menuItems.catalogs.calcFields.icon || F.default.icon}}\" class=\"crud-icon\"></md-icon><div \nlayout=\"column\" layout-align=\"start start\"><div class=\"h2\">{{calcField.name}}</div><div \nclass=\"subtitle secondary-text\"><span ng-if=\"!F.addMode\">\n{{\'EC.DETAIL_OF\' | translate}} {{\'calcField.SINGULAR\' | translate}}</span> <span ng-if=\"F.addMode\">\n{{\'EC.CREATE\' | translate}} {{\'calcField.SINGULAR\' | translate}}</span></div></div></div></div><div><md-button \ntype=\"submit\" ng-if=\"!F.addMode\" with-permission action=\"update\" access=\"{{F.active.menuItem}}\" \nng-click=\"createRouteAutomatic(calcField);save(calcField)\" ng-hide=\"form.$pristine\" \nng-disabled=\"form.$invalid || loadingProgress\" class=\"md-raised md-background md-fab md-accent md-hue-1\" \naria-label=\"Save calcField\"><md-tooltip md-direction=\"left\">{{\'EC.SAVE\' | translate}}</md-tooltip><md-icon \nmd-font-icon=\"icon-content-save\" aria-label=\"Save\"></md-icon></md-button><md-button type=\"submit\" ng-if=\"F.addMode\" \nwith-permission action=\"create\" access=\"{{F.active.menuItem}}\" \nng-click=\"createRouteAutomatic(calcField);add(calcField)\" ng-hide=\"form.$pristine\" \nng-disabled=\"form.$invalid || loadingProgress\" class=\"md-raised md-background md-fab md-accent md-hue-1\" \naria-label=\"Add calcField\"><md-tooltip md-direction=\"left\">{{\'EC.ADD\' | translate}}</md-tooltip><md-icon \nmd-font-icon=\"icon-content-save\" aria-label=\"Add\"></md-icon></md-button></div></md-toolbar><md-content layout=\"column\" \nclass=\"content\" flex><div class=\"detail-form-container md-background-bg md-whiteframe-1dp\"><md-input-container \nclass=\"md-block\" layout-gt-xs=\"row\"><label>Nombre</label><input type=\"text\" name=\"name\" ng-model=\"calcField.name\" \nrequired unique-fb ref=\"{{F.active.menuRef}}\" query=\"name\" fromid=\"{{calcField.$id}}\" class=\"uppercased\" \nmd-maxlength=\"30\" maxlength=\"30\" ng-model-options=\"{ debounce: F.debounceTime }\"><div ng-messages=\"form.name.$error\" \nng-show=\"form.name.$touched || form.name.$dirty\" role=\"alert\"><div ng-message=\"required\">Nombre es requerido</div><div \nng-message=\"unique\">Nombre ya está registrado</div></div></md-input-container><div layout-gt-xs=\"row\">\n<md-input-container class=\"md-block\" flex><label>Objeto</label><md-select ng-model=\"calcField.object\" name=\"object\" \nrequired><md-option ng-value=\"object\" ng-repeat=\"object in F.calcFieldsObjects\">{{object}}</md-option></md-select><div \nng-messages=\"calcField.object.$error\" ng-show=\"calcField.object.$dirty\" role=\"alert\"><div ng-message=\"required\">\nCampo de calculo es requerido</div></div></md-input-container><input type=\"hidden\" name=\"route\" \nng-model=\"calcField.route\"><md-input-container class=\"md-block\" flex><label>Campo</label><input type=\"text\" \nname=\"field\" ng-model=\"calcField.field\"></md-input-container><md-input-container class=\"md-block\" flex><label>\nValor por Default</label><input type=\"number\" name=\"defaultValue\" ng-model=\"calcField.defaultValue\" required>\n</md-input-container><div flex=\"nogrow\"><md-switch class=\"md-secondary md-padding\" name=\"allowAssign\" \nng-false-value=\"0\" aria-label=\"allowAssign switch\" ng-model=\"calcField.allowAssign\">Permitir Modificar Valor\n</md-switch></div></div></div></md-content></form></div>");
$templateCache.put("app/main/config/views/calc-fields/calc-fields.html","<div id=\"calcFields\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div mongo-search-bar></div><div class=\"content-card\" layout=\"column\" \nflex><div class=\"content fullpage-datatable\" layout=\"column\" flex><div table-loader array=\"calcFields\" \nvalidations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"calcFields.length\"><thead md-head md-order=\"order\" \nfix-head md-on-reorder=\"getThem \"><tr md-row><th md-column md-order-by=\"name\"><span>Nombre</span></th><th md-column \nmd-order-by=\"object\"><span>Objeto</span></th><th md-column md-order-by=\"field\" hide show-gt-xs>Campo</th><th md-column \nmd-order-by=\"defaultValue\">Valor por default</th><th md-column md-order-by=\"allowAssign\">Permitir Asignar Valor</th>\n</tr></thead><tbody md-body><tr md-row md-auto-select md-select=\"calcField\" md-select-id=\"_id\" \nng-repeat=\"calcField in calcFields\"><td md-cell>{{calcField.name}}</td><td md-cell>{{calcField.object}}</td><td \nmd-cell>{{calcField.field}}</td><td md-cell>{{calcField.defaultValue}}</td><td md-cell><div layout=\"row\" \nlayout-align=\"start center\"><active-indicator active=\"calcField.allowAssign\"></active-indicator></div></td></tr>\n</tbody></table></md-table-container><md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" \nlayout-xs=\"column\" ng-show=\"calcFields.length\" md-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" \nmd-limit-options=\"F.paginations\" md-page=\"currentPage\" md-total=\"{{pagination.total}}\" \nmd-on-paginate=\"getThemPagination\" md-page-select></md-table-pagination></div></div><md-fab-speed-dial \nmd-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\" \nng-mouseenter=\"isOpen=true\" ng-mouseleave=\"isOpen=false\"><md-fab-trigger><md-button aria-label=\"crud menu\" \nclass=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon></md-button></md-fab-trigger>\n<md-fab-actions><md-button with-permission action=\"read\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" \nng-click=\'R.goToDetail(null, \"read\", {calcFieldId: selected[0].$id})\' aria-label=\"view\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Ver</md-tooltip><md-icon \nmd-font-icon=\"icon-eye\" aria-label=\"view\"></md-icon></md-button><md-button with-permission action=\"update\" \naccess=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" \nng-click=\'R.goToDetail(null, \"update\", {calcFieldId: selected[0].$id})\' aria-label=\"edit\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Editar</md-tooltip><md-icon \nmd-font-icon=\"icon-pencil\" aria-label=\"edit\"></md-icon></md-button><md-button with-permission action=\"remove\" \naccess=\"{{F.active.menuItem}}\" ng-if=\"selected.length\" ng-click=\"delete($event)\" aria-label=\"Delete\" \nclass=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">{{\'EC.REMOVE\' | translate}}</md-tooltip>\n<md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button><md-button with-permission \naction=\"create\" access=\"{{F.active.menuItem}}\" ng-if=\"!selected.length\" \nng-click=\'R.goToDetail(null, \"update\", {calcFieldId: \"new\"})\' aria-label=\"add\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">{{\'EC.ADD\' | translate}}\n</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon></md-button></md-fab-actions>\n</md-fab-speed-dial></div></div>");
$templateCache.put("app/main/config/views/constant/constant.html","<div id=\"constant\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill><form name=\"form\" \nnovalidate flex layout=\"column\" ng-disabled=\"F.readMode\"><md-toolbar class=\"md-tall header md-accent-bg\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button \nclass=\"goto-button md-icon-button\" with-permission access=\"{{F.active.menuItem}}\" action=\"access\" \naria-label=\"Go to list\" ng-click=\"R.goToList()\" translate translate-attr-aria-label=\"EC.GO_TO\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"{{F.menuItems.config.constants.icon}}\" class=\"crud-icon\"></md-icon><div layout=\"column\" \nlayout-align=\"start start\"><div class=\"h2\">{{constant.incidencesType | nameOfM:M.incidencesTypes}}</div><div \nclass=\"subtitle secondary-text\"><span ng-if=\"!F.addMode\">\n{{\'EC.DETAIL_OF\' | translate}} {{\'constant.SINGULAR\' | translate}}</span> <span ng-if=\"F.addMode\">\n{{\'EC.CREATE\' | translate}} {{\'constant.SINGULAR\' | translate}}</span></div></div></div></div><div><md-button \ntype=\"submit\" ng-if=\"!F.addMode\" with-permission action=\"update\" access=\"{{F.active.menuItem}}\" \nng-click=\"save(constant)\" ng-hide=\"form.$pristine\" ng-disabled=\"form.$invalid || loadingProgress\" \nclass=\"md-raised md-background md-fab md-accent md-hue-1\" aria-label=\"Save constant\"><md-tooltip md-direction=\"left\">\n{{\'EC.SAVE\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-content-save\" aria-label=\"Save\"></md-icon>\n</md-button><md-button type=\"submit\" ng-if=\"F.addMode\" with-permission action=\"create\" access=\"{{F.active.menuItem}}\" \nng-click=\"add(constant)\" ng-hide=\"form.$pristine\" ng-disabled=\"form.$invalid || loadingProgress\" \nclass=\"md-raised md-background md-fab md-accent md-hue-1\" aria-label=\"Add constant\"><md-tooltip md-direction=\"left\">\n{{\'EC.ADD\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-content-save\" aria-label=\"Add\"></md-icon></md-button>\n</div></md-toolbar><md-content layout=\"column\" class=\"content\" flex><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\"><div layout-gt-xs=\"row\" \nng-if=\'[\"payroll\", \"cc\", \"employee\"].indexOf(by) !== -1\'><div filter-constants-payrolls></div></div><div \nlayout-gt-xs=\"row\" ng-if=\'by == \"cc\"\'><md-input-container class=\"md-block\" flex md-no-float><label>CC</label><md-select\n name=\"cc\" ng-model=\"constant.cc\" class=\"filter\" required><md-select-header><input autocomplete=\"off\" type=\"search\" \nclass=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"ccSelectFilter\" \nplaceholder=\"Busque un centro de costo\"></md-select-header><md-option ng-value=\"cc.$id\" \nng-repeat=\"cc in ccs | orderBy:\'name\' | filter:ccSelectFilter\">{{cc.name}}</md-option></md-select></md-input-container>\n</div><div layout-gt-xs=\"row\" ng-if=\'by == \"employee\"\'><md-input-container class=\"md-block\" flex md-no-float><label>\nEmpleado</label><md-select ng-model=\"constant.employee\" class=\"filter\" required><md-select-header><input \nautocomplete=\"off\" type=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"employeeSelectFilter\" \nplaceholder=\"Busque un empleado\"></md-select-header><md-option ng-value=\"employee.$id\" \nng-repeat=\"employee in employees | orderBy:\'name\' | filter:employeeSelectFilter\">{{employee.name}}</md-option>\n</md-select></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex md-no-float>\n<md-select ng-model=\"constant.type\" arial-label=\"constant type\" placeholder=\"Tipo de Constante\" required><md-option \nng-disabled=\"type.disabled\" ng-value=\"id\" ng-repeat=\"(id, type) in F.constantTypes\">{{type.name}}</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block\" flex \nng-if=\"constant.type&&constant.type!=\'affectIncidenceProperty\'\"><label>Incidencia</label><md-select \nng-model=\"constant.incidencesType\" aria-label=\"constant incidenceType\" name=\"incidencesType\" \nandfilter=\"{{uniqueFilter}}\" unique-fb ref=\"{{mainRef}}\" query=\"incidencesType\" required fromid=\"{{constant.$id}}\">\n<md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" \nng-model=\"incidencesTypeSelectFilter\" placeholder=\"Busque un tipo de incidencia\"></md-select-header><md-option \nng-if=\"constant.type==\'affectIncidenceValue\'?(!incidencesType.directive&&incidencesType.customCalc?true:false):(constant.type==\'automaticApply\'?incidencesType.constant:true)\" \nng-value=\"incidencesType.$id\" \nng-repeat=\"incidencesType in allIncidences | orderBy:\'name\' | filter:incidencesTypeSelectFilter\">\n{{incidencesType.name}}</md-option></md-select><div ng-messages=\"form.incidencesType.$error\" \nng-show=\"(form.incidencesType.$error && !form.incidencesType.$pristine) || (form.incidencesType.$error && constant.incidencesType)\" \nrole=\"alert\"><div ng-message=\"required\">Tipo de incidencia es requerido</div><div ng-message=\"unique\">\nTipo de incidencia ya está registrado bajo éste nivel</div></div></md-input-container></div><code class=\"help\" \nng-show=\"constant.type\"><p>{{F.constantTypes[constant.type].description}}</p></code><div flex><div \nautomatic-apply-form ng-if=\'constant.type == \"automaticApply\"\'></div><div affect-incidence-value-form \nng-if=\'constant.type == \"affectIncidenceValue\"\'></div><div not-apply-form ng-if=\'constant.type == \"notApply\"\'></div>\n<div affect-incidence-property-form ng-if=\'constant.type == \"affectIncidenceProperty\"\'></div></div></div></md-content>\n</form></div>");
$templateCache.put("app/main/config/views/constants/constants.html","<div id=\"constants\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout-gt-xs=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" flex layout=\"column\" layout-align=\"start start\"><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"{{F.menuItems.config.constants.icon || F.default.icon}}\" class=\"crud-icon\"></md-icon><span>\n{{\'constant.PLURAL\' | translate}} {{tabName | constantsBy}}</span></div><div class=\"count secondary-text\"><span>\n{{\'EC.TOTAL_OF\' | translate}} {{\'constant.PLURAL\' | translate}}:</span> <span>{{constants.length}}</span></div></div>\n<div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"constants-search\" class=\"search-input\" type=\"text\" \nplaceholder=\"Buscar por tipo de incidencia\" flex ng-model-options=\"{ debounce: F.debounceTime }\" \nng-model=\"F.search.constant\"></div></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><md-tabs md-selected=\"selectedTab\" flex layout-fill><md-tab \nng-if=\"permissions.tabGeneral\" label=\"general\" md-on-select=\'setTabName(\"general\")\'><ng-include \nsrc=\"\'app/main/config/views/constants/tabs/general.html\'\"></ng-include></md-tab><md-tab ng-if=\"permissions.tabPayroll\" \nlabel=\"nómina\" md-on-select=\'setTabName(\"payroll\")\'><ng-include \nsrc=\"\'app/main/config/views/constants/tabs/payroll.html\'\"></ng-include></md-tab><md-tab ng-if=\"permissions.tabCc\" \nlabel=\"cc\" md-on-select=\'setTabName(\"cc\")\'><ng-include src=\"\'app/main/config/views/constants/tabs/cc.html\'\">\n</ng-include></md-tab><md-tab ng-if=\"permissions.tabEmployee\" label=\"empleado\" md-on-select=\'setTabName(\"employee\")\'>\n<ng-include src=\"\'app/main/config/views/constants/tabs/employee.html\'\"></ng-include></md-tab></md-tabs></div></div>\n<md-fab-speed-dial md-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" \nclass=\"ms2-speed-dial bottom right\"><md-fab-trigger><md-button aria-label=\"crud menu\" \nclass=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon></md-button></md-fab-trigger>\n<md-fab-actions><md-button with-permission action=\"update\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" \nng-click=\"goToDetail(selected[0], tabName)\" aria-label=\"edit\" class=\"md-fab md-raised md-mini md-accent md-hue-2\">\n<md-tooltip md-direction=\"left\">Editar</md-tooltip><md-icon md-font-icon=\"icon-pencil\" aria-label=\"edit\"></md-icon>\n</md-button><md-button with-permission action=\"remove\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length\" \nng-click=\"delete($event)\" aria-label=\"Delete\" class=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">\n{{\'EC.REMOVE\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button>\n<md-button with-permission action=\"create\" access=\"{{F.active.menuItem}}\" ng-if=\"!selected.length\" \nng-click=\'goToDetail(\"new\", tabName)\' aria-label=\"add\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip \nmd-direction=\"left\">{{\'EC.ADD\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon>\n</md-button></md-fab-actions></md-fab-speed-dial></div></div>");
$templateCache.put("app/main/config/views/dashboard/dashboard.html","<div id=\"dashboard-config\" class=\"page-layout blank\" layout=\"row\"><div class=\"center\" flex ms-scroll><div \nclass=\"content\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"true\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><md-select class=\"simplified font-size-16\" \nng-model=\"widget1.currentRange\" aria-label=\"Change range\"><md-option ng-repeat=\"(key, range) in widget1.ranges\" \nvalue=\"{{key}}\">{{range}}</md-option></md-select><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\">\n<md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details</md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item>\n</md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"light-blue-fg font-size-72 line-height-72\">{{widget1.data.count[widget1.currentRange]}}%</div><div \nclass=\"h3 secondary-text font-weight-500\">{{widget1.data.label}}</div></div><div class=\"p-16 grey-50-bg border-top\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">{{widget1.data.extra.label}}:\n</span> <span class=\"h4 ml-8\">{{widget1.data.extra.count[widget1.currentRange]}}</span></div></ms-widget-front>\n<ms-widget-back class=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" \nng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button>\n</div><div>{{widget1.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">{{widget2.title}}</div><md-menu><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh\n</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"red-fg font-size-72 line-height-72\">${{widget2.data.count}}</div><div \nclass=\"h3 secondary-text font-weight-500\">{{widget2.data.label}}</div></div><div class=\"p-16 grey-50-bg border-top\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">{{widget2.data.extra.label}}:\n</span> <span class=\"h4 ml-8\">${{widget2.data.extra.count}}</span></div></ms-widget-front><ms-widget-back \nclass=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" \naria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>\n{{widget2.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">{{widget3.title}}</div><md-menu><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh\n</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"orange-fg font-size-72 line-height-72\">{{widget3.data.count}}</div><div \nclass=\"h3 secondary-text font-weight-500\">{{widget3.data.label}}</div></div><div class=\"p-16 grey-50-bg border-top\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">{{widget3.data.extra.label}}:\n</span> <span class=\"h4 ml-8\">{{widget3.data.extra.count}}</span></div></ms-widget-front><ms-widget-back \nclass=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" \naria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>\n{{widget3.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">{{widget4.title}}</div><md-menu><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh\n</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"blue-grey-fg font-size-72 line-height-72\">${{widget4.data.count}}</div><div \nclass=\"h3 secondary-text font-weight-500\">{{widget4.data.label}}</div></div><div class=\"p-16 grey-50-bg border-top\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">{{widget4.data.extra.label}}:\n</span> <span class=\"h4 ml-8\">${{widget4.data.extra.count}}</span></div></ms-widget-front><ms-widget-back \nclass=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" \naria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>\n{{widget4.detail}}</div></ms-widget-back></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" \nlayout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 pv-8 border-bottom\" \nlayout=\"row\" layout-align=\"space-between center\" layout-wrap><div class=\"pv-8 h3\">{{widget5.title}}</div><div \nclass=\"pv-8\" layout=\"row\" layout-align=\"start center\" layout-align-sm=\"end\" flex-sm=\"100\"><md-button class=\"ph-16\" \nng-repeat=\"(key, range) in widget5.ranges\" ng-click=\"widget5.changeRange(key)\" \nng-disabled=\"widget5.currentRange == key\">{{range}}</md-button></div></div><div class=\"p-16\"><nvd3 \nclass=\"h-420 remove-x-lines\" config=\"widget5.mainChart.config\" options=\"widget5.mainChart.options\" \ndata=\"widget5.mainChart.data\"></nvd3></div></ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" \nflex=\"100\" layout-wrap><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{widget6.title}}</div>\n<div class=\"pv-16\"><md-select class=\"simplified\" ng-model=\"widget6.currentRange\" \nng-change=\"widget6.changeRange(widget6.currentRange)\" aria-label=\"Change range\"><md-option \nng-repeat=\"(key, range) in widget6.ranges\" value=\"{{key}}\">{{range}}</md-option></md-select></div></div><div \nclass=\"p-16\"><nvd3 class=\"h-400\" config=\"widget6.mainChart.config\" options=\"widget6.mainChart.options\" \ndata=\"widget6.mainChart.data\"></nvd3></div><div class=\"pv-8 mh-16 border-top\" layout=\"row\" layout-align=\"start center\" \nlayout-wrap><div class=\"pv-8 border-right\" layout=\"column\" layout-align=\"center center\" flex=\"100\" flex-gt-xs=\"50\">\n<span class=\"font-size-32\">{{widget6.footerLeft.count[widget6.currentRange]}}</span> <span class=\"h4\">\n{{widget6.footerLeft.title}}</span></div><div class=\"pv-8\" layout=\"column\" layout-align=\"center center\" flex=\"100\" \nflex-gt-xs=\"50\"><span class=\"font-size-32\">{{widget6.footerRight.count[widget6.currentRange]}}</span> <span class=\"h4\">\n{{widget6.footerRight.title}}</span></div></div></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">{{widget7.title}}</div><div class=\"pv-16\"><md-select \nclass=\"simplified\" ng-model=\"widget7.currentRange\" aria-label=\"Change range\"><md-option \nng-repeat=\"(key, range) in widget7.ranges\" value=\"{{key}}\">{{range}}</md-option></md-select></div></div><div \nclass=\"p-16\" layout=\"row\" layout-align=\"space-between center\" \nng-repeat=\"customer in widget7.customers[widget7.currentRange]\"><div><div class=\"h3\">{{customer.name}}</div><span \nng-if=\"customer.location\">{{customer.location}}</span></div><md-button class=\"md-icon-button\" \naria-label=\"More information\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></div></ms-widget-front>\n</ms-widget></div></div></div></div>");
$templateCache.put("app/main/config/views/customFields/customField.html","<div id=\"customField\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill \nng-controller=\"CustomFieldController as cfctrl\"><form name=\"form\" novalidate flex layout=\"column\" \nng-disabled=\"F.readMode\"><div fb-crud-detail-bar></div><md-content layout=\"column\" class=\"content\" flex><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\"><div layout-gt-xs=\"row\"><md-input-container \nclass=\"md-block\" flex><label>Llave</label><input ng-disabled=\"F.readMode\" unique-fb \nref=\"catalogs/customFields/collection\" query=\"key\" type=\"text\" name=\"key\" ng-model=\"customField.key\" \nng-model-options=\"{ debounce: F.debounceTime }\" fromid=\"{{customField.$id}}\" required></md-input-container>\n<md-input-container class=\"md-block\" flex><label>Nombre</label><input unique-fb class=\"uppercased\" type=\"text\" \nng-disabled=\"F.readMode\" name=\"name\" ng-model=\"customField.name\" md-maxlength=\"200\" maxlength=\"200\" \nng-model-options=\"{ debounce: F.debounceTime }\" required><div ng-messages=\"form.name.$error\" \nng-show=\"form.name.$touched || form.name.$dirty\" role=\"alert\"><div ng-message=\"required\">\nNombre de tipo de Incidencia es requerido</div><div ng-message=\"maxlength\">\nNombre de tipo de Incidencia debe tener 200 carácteres de largo como máximo</div><div ng-message=\"unique\">\nNombre de tipo de Incidencia ya está registrado en Nómina</div></div></md-input-container></div><md-input-container \nclass=\"md-block\" flex><label>Descripción</label><textarea ng-model=\"customField.description\" rows=\"5\"></textarea>\n</md-input-container><div><md-checkbox ng-model=\"customField.validateGroups\" aria-label=\"validateGroups\" \nng-change=\"customField.groups=[]\">Validar Grupos</md-checkbox></div><div ng-if=\"customField.validateGroups\">\n<md-input-container class=\"md-block mt-0\" md-no-float><md-chips ng-model=\"customField.groups\" md-autocomplete-snap \nmd-transform-chip=\"cfctrl.transformChip($chip)\" md-require-match=\"true\" input-aria-label=\"groups\"><md-autocomplete \nmd-selected-item=\"group.$id\" md-search-text=\"searchText\" md-min-length=\"0\" \nmd-items=\"group in L.allGroups|filter:searchText\" md-item-text=\"group.name\" placeholder=\"Seleccione un Grupo\" \nmd-dropdown-position=\"bottom\" md-no-cache=\"true\" input-aria-describedby=\"autocompleteTitle\"><span \nmd-highlight-text=\"ctrl.searchText\">{{group.name}}</span></md-autocomplete><md-chip-template><span><strong>\n{{$chip | nameOfL : L.allGroups}}</strong></span></md-chip-template></md-chips></md-input-container></div></div>\n</md-content></form></div>");
$templateCache.put("app/main/config/views/customFields/customFields.html","<div id=\"customFields\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div fb-search-bar></div><div class=\"content-card\" layout=\"column\" flex>\n<div class=\"content fullpage-datatable\" layout=\"column\" flex><div filter-toolbar></div><div table-loader \narray=\"customFields\" validations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"customFields.length\"><thead md-head md-order=\"order\" \nfix-head><tr md-row><th md-column md-order-by=\"key\"><span>Llave</span></th><th md-column md-order-by=\"name\"><span>\nNombre</span></th><th md-column><span>Descripción</span></th></tr></thead><tbody md-body><tr md-row md-auto-select \nmd-select=\"customField\" md-select-id=\"$id\" \nng-repeat=\"customField in (F.filteredItems = (customFields | filter:F.searchText.customField | orderBy:order)) | limitTo: F.paginate: (currentPage - 1) * F.paginate\">\n<td md-cell ng-bind=\"customField.key\"></td><td md-cell ng-bind=\"customField.name\"></td><td md-cell \nng-bind=\"customField.description\"></td></tr></tbody></table></md-table-container><md-table-pagination \nlayout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" ng-show=\"customFields.length\" \nmd-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" md-limit-options=\"F.paginations\" md-page=\"currentPage\" \nmd-on-paginate=\"restartSelected\" md-total=\"{{F.filteredItems.length}}\" md-page-select></md-table-pagination></div>\n</div><md-fab-speed-dial md-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" \nclass=\"ms2-speed-dial bottom right\"><md-fab-trigger><md-button aria-label=\"crud menu\" \nclass=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon></md-button></md-fab-trigger>\n<md-fab-actions><md-button with-permission action=\"read\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" \nng-click=\'R.goToDetail(null, \"read\", {customFieldId: selected[0].$id, payrollId: selected[0].payroll})\' \naria-label=\"view\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Ver</md-tooltip>\n<md-icon md-font-icon=\"icon-eye\" aria-label=\"view\"></md-icon></md-button><md-button with-permission action=\"update\" \naccess=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" \nng-click=\'R.goToDetail(null, \"update\", {customFieldId: selected[0].$id, payrollId: selected[0].payroll})\' \naria-label=\"edit\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Editar\n</md-tooltip><md-icon md-font-icon=\"icon-pencil\" aria-label=\"edit\"></md-icon></md-button><md-button with-permission \naction=\"remove\" access=\"{{F.active.menuItem}}\" ng-click=\"delete($event)\" aria-label=\"Delete\" \nclass=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">{{\'EC.REMOVE\' | translate}}</md-tooltip>\n<md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button><md-button with-permission \naction=\"create\" access=\"{{F.active.menuItem}}\" ng-if=\"!selected.length\" \nng-click=\'R.goToDetail(null, \"update\", {customFieldId: \"new\"})\' aria-label=\"add\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">{{\'EC.ADD\' | translate}}\n</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon></md-button><md-button with-permission \naction=\"export\" access=\"{{F.active.menuItem}}\" \nng-click=\"exportDataToExcel(F.filteredItems,F.active.menuName,currentPage,F.paginate)\" aria-label=\"export\" \nclass=\"md-fab md-raised md-mini md-primary md-hue-2\"><md-tooltip md-direction=\"left\">Exportar a excel</md-tooltip>\n<md-icon md-font-icon=\"icon-file-excel\" aria-label=\"export\"></md-icon></md-button><md-button with-permission \naction=\"copy\" access=\"{{F.active.menuItem}}\" aria-label=\"copy\" ng-click=\"showPayrollModal($event,\'payrolls\')\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">{{\'EC.COPY\' | translate}}\n</md-tooltip><md-icon md-font-icon=\"icon-transfer\" aria-label=\"copy\"></md-icon></md-button><md-button with-permission \naction=\"copy\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length\" aria-label=\"copy\" \nng-click=\"showPayrollModal($event,\'payroll\')\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip \nmd-direction=\"left\">{{\'EC.COPYINCIDENCES\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-transfer\" \naria-label=\"copy\"></md-icon></md-button></md-fab-actions></md-fab-speed-dial></div></div>");
$templateCache.put("app/main/config/views/emailImages/emailImage.html","<div id=\"emailImage\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill \nng-controller=\"EmailImageController\"><form name=\"form\" novalidate flex layout=\"column\" ng-disabled=\"F.readMode\">\n<md-toolbar class=\"md-tall header md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" \nlayout=\"row\" layout-align=\"start center\" flex><md-button with-permission action=\"access\" \naccess=\"{{F.active.menuItem}}\" class=\"goto-button md-icon-button\" aria-label=\"Go to list\" ng-click=\"R.goToList()\" \ntranslate translate-attr-aria-label=\"EC.GO_TO\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div \nlayout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"{{F.menuItems[F.active.menuParent][F.active.menuName].icon || F.default.icon}}\" class=\"crud-icon\">\n</md-icon><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\">{{F.active.detailObject.data.name}}</div><div\n class=\"subtitle secondary-text\"><span ng-if=\"!F.addMode\">\n{{\'EC.DETAIL_OF\' | translate}} {{F.active.menuObjName + \'.SINGULAR\' | translate}}</span> <span ng-if=\"F.addMode\">\n{{\'EC.CREATE\' | translate}} {{F.active.menuObjName + \'.SINGULAR\' | translate}}</span></div></div></div></div><div>\n<md-button type=\"submit\" ng-if=\"!F.addMode && objectLoaded && !F.readMode\" with-permission action=\"update\" \naccess=\"{{F.active.menuItem}}\" ng-click=\"saveEmailImages(F.active.detailObject)\" \nng-hide=\"form.$pristine && !objectLoaded\" ng-disabled=\"form.$invalid || form.$pristine || loadingProgress\" \nclass=\"md-raised md-background md-fab md-accent md-hue-1\" aria-label=\"Save\"><md-tooltip md-direction=\"left\">\n{{\'EC.SAVE\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-content-save\" aria-label=\"Save\"></md-icon>\n</md-button><md-button type=\"submit\" ng-if=\"F.addMode && objectLoaded\" with-permission action=\"create\" \naccess=\"{{F.active.menuItem}}\" ng-click=\"saveEmailImages(F.active.detailObject)\" \nng-hide=\"form.$pristine && !objectLoaded\" ng-disabled=\"form.$invalid || loadingProgress || noCalendars\" \nclass=\"md-raised md-background md-fab md-accent md-hue-1\" aria-label=\"Add\"><md-tooltip md-direction=\"left\">\n{{\'EC.ADD\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-content-save\" aria-label=\"Add\"></md-icon></md-button>\n</div></md-toolbar><md-content layout=\"column\" class=\"content\" flex><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\"><div flex layout=\"row\"><md-input-container \nclass=\"md-block\" flex><label>Titulo</label><input ms2-autofocus class=\"uppercased\" type=\"text\" name=\"name\" \nng-model=\"emailImage.name\" ng-model-options=\"{ debounce: F.debounceTime }\" required ng-disabled=\"F.readMode\"><div \nng-messages=\"form.name.$error\" role=\"alert\"><div ng-message=\"required\">Titulo es requerido</div></div>\n</md-input-container></div><div flex><div class=\"upload-button\" layout=\"column\"><span class=\"md-title text-center\">\nImagen</span><lf-ng-md-file-input ng-show=\"!emailImage.file\" lf-files=\"files\" ng-disabled=\"F.readMode\" \nlf-mimetype=\"image/*\" lf-placeholder=\"Solo PNG, JPG, GIF o PDF - Max. 2MB\" lf-drag-and-drop-label=\"Arrastre aquí\" \nlf-browse-label=\"Buscar\" lf-remove-label=\"Remover\" lf-on-file-remove=\"form.$setDirty();\" lf-filesize=\"5MB\" \nname=\"confirmationFile\" lf-api=\"imageApi\" progress preview drag></lf-ng-md-file-input><div \nng-messages=\"form.confirmationFile.$error\" style=\"color:red\"><div ng-message=\"required\">\nArchivo de confirmación requerido</div><div ng-message=\"maxcount\">Demaciados archivos</div><div ng-message=\"filesize\">\nArchivo demaciado grande</div><div ng-message=\"totalsize\">El peso total es demaciado</div><div ng-message=\"mimetype\">\nTipo de archivo inválido</div></div></div><div layout=\"column\" layout-align=\"center center\" style=\"max-height: 300px\">\n<img flex style=\"object-fit: contain\" ng-show=\'emailImage.file && emailImage.file.indexOf(\".pdf\") == -1\' \nng-src=\"{{emailImage.file}}\" alt=\"Archivo de Confirmación\"></div><div layout=\"row\" layout-align=\"center center\"><div \nflex=\"nogrow\"><md-button class=\"md-primary\" ng-show=\"emailImage.file\" target=\"_blanc\" ng-href=\"{{emailImage.file}}\">\n<md-icon md-font-icon=\"icon-file-pdf\" aria-label=\"PDF\"></md-icon>\n{{emailImage.file.indexOf(\".pdf\") !== -1?\'Archivo Adjunto\':\'Mostrar en otra ventana\'}}</md-button></div><div \nflex=\"nogrow\"><md-button ng-if=\"emailImage.file || editAllPermission\" with-permission action=\"update\" \naccess=\"{{F.active.menuItem}}\" ng-click=\"removeUpload(F.active.detailObject)\" \nng-show=\"F.active.detailObject[F.active.imageName]\" class=\"md-warn md-raised md-background md-icon-button\" \naria-label=\"Delete file\" ng-disabled=\"loadingProgress \"><md-tooltip md-direction=\"left\">Borrar adjunto</md-tooltip>\n<md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div></div></div></div></md-content></form></div>");
$templateCache.put("app/main/config/views/emailImages/emailImages.html","<div id=\"emailImages\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\" \nng-controller=\"EmailImagesController\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex>\n<div fb-search-bar flex=\"nogrow\"></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><div filter-toolbar flex=\"nogrow\"></div><div table-loader flex \narray=\"emailImages\" validations=\"validations\"></div><div flex=\"nogrow\" class=\"scrollable\"><div layout=\"row\" \nlayout-wrap=\"\"><div \nng-repeat=\"emailImage in (F.filteredItems = (emailImages | filter:F.searchText.emailImage | orderBy:order)) | limitTo: F.paginate: (currentPage - 1) * F.paginate\" \nflex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"33\" flex-gt-lg=\"25\"><md-card><img ng-src=\"{{emailImage.file}}\" \nclass=\"md-card-image\" alt=\"Washed Out\"><md-card-actions layout=\"row\" layout-align=\"end center\"><md-button \nwith-permission action=\"read\" access=\"{{F.active.menuItem}}\" \nng-click=\'R.goToDetail(null, \"read\", {emailImageId: emailImage.$id})\' aria-label=\"view\" \nclass=\"md-icon-button md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Ver</md-tooltip>\n<md-icon md-font-icon=\"icon-eye\" aria-label=\"view\"></md-icon></md-button><md-button with-permission action=\"update\" \naccess=\"{{F.active.menuItem}}\" ng-click=\'R.goToDetail(null, \"update\", {emailImageId: emailImage.$id})\' \naria-label=\"edit\" class=\"md-icon-button md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">\nEditar</md-tooltip><md-icon md-font-icon=\"icon-pencil\" aria-label=\"edit\"></md-icon></md-button><md-button \nwith-permission action=\"remove\" access=\"{{F.active.menuItem}}\" ng-click=\"deleteImages(emailImage,$event)\" \naria-label=\"Delete\" class=\"md-icon-button md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">\n{{\'EC.REMOVE\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button>\n</md-card-actions></md-card></div></div></div><md-table-pagination flex=\"nogrow\" layout-align=\"start center\" \nlayout-gt-xs=\"row\" layout-xs=\"column\" ng-show=\"emailImages.length\" md-label=\"{{F.paginationLabel}}\" \nmd-limit=\"F.paginate\" md-limit-options=\"F.paginations\" md-page=\"currentPage\" md-on-paginate=\"restartSelected\" \nmd-total=\"{{F.filteredItems.length}}\" md-page-select></md-table-pagination></div></div><md-fab-speed-dial \nmd-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\"><md-fab-trigger>\n<md-button aria-label=\"crud menu\" class=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon>\n</md-button></md-fab-trigger><md-fab-actions><md-button with-permission action=\"create\" access=\"{{F.active.menuItem}}\" \nng-click=\'R.goToDetail(null, \"update\", {emailImageId: \"new\"})\' aria-label=\"add\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">{{\'EC.ADD\' | translate}}\n</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon></md-button></md-fab-actions>\n</md-fab-speed-dial></div></div>");
$templateCache.put("app/main/config/views/globalNotifications/globalNotification.html","<div id=\"globalNotifications\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill \nng-controller=\"GlobalNotificationController\"><form name=\"form\" novalidate flex layout=\"column\"><div fb-crud-detail-bar>\n</div><md-content layout=\"column\" class=\"content\" flex><md-tabs md-selected=\"selectedTab\" flex layout-fill><md-tab \nmd-on-select=\"setTabName(action)\" label=\'{{\"n.\" + action | translate}}\' \nng-repeat=\"(action, actionObj) in Z.globalNotification\"><md-tab-body><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\"><md-content layout=\"column\"><md-list><md-list-item \nlayout=\"row\" layout-align=\"start start\" ng-repeat=\"(status, statusObj) in actionObj | sortObjectProperties\">\n<md-input-container flex class=\"md-block\"><label ng-if=\'[\"enrole\", \"dismiss\",\"mds\",\"reEnrole\"].indexOf(action) !== -1\'>\nStatus {{status}}: {{status | getMovementStatusName}}</label><label ng-if=\'action == \"incidences\"\'>\nStatus {{status}}: {{status | incidenceStatusName}}</label><label \nng-if=\'[\"create\",\"update\",\"remove\",\"cancel\",\"closed\",\"inFinalRevision\",\"inRevision\",\"opened\",\"requested\", \"anniversary\", \"birthDay\"].indexOf(status) !== -1\'>\n{{\'EC.\' + status.toUpperCase() | translate}}</label><md-chips ng-model=\"Z.globalNotification[action][status]\" \nmd-on-add=\"setProfilesAction(action,status,$chip.$id,true,$chip.type)\" \nmd-on-remove=\"setProfilesAction(action,status,$chip.$id,false,$chip.type)\" md-autocomplete-snap md-removable \nmd-transform-chip=\"transformChip($chip,action,status)\" md-require-match=\"true\"><md-autocomplete \nmd-selected-item=\"profile.$id\" md-search-text=\"searchProfile\" \nmd-items=\"profile in autocompleteProfiles(searchProfile)\" md-item-text=\"profile.name\" \nplaceholder=\"Busque un usuario o grupo\"><span ng-if=\"profile.type==\'user\'\" md-highlight-text=\"searchProfile\">\n{{profile.name}} ({{profile.firm | nameOfL : L.firms : profile.firm}})</span> <span ng-if=\"profile.type==\'group\'\" \nmd-highlight-text=\"searchProfile\">{{profile.name}}</span></md-autocomplete><md-chip-template><span \nng-if=\"$chip.type==\'user\'\"><md-icon md-font-icon=\"icon-account\"></md-icon><strong>{{$chip.$id | nameOfL: L.profiles}}\n</strong> <span class=\"blueC\">\n{{($chip.$id | getSomethingOfArrayFB : L.profiles:\'firm\':\'\') | nameOfL : L.firms : ($chip.$id | getSomethingOfArrayFB : L.profiles:\'firm\':\'\')}}\n</span> </span><span ng-if=\"$chip.type==\'group\'\"><md-icon md-font-icon=\"icon-account-multiple\"></md-icon><strong>\n{{$chip.$id | nameOfL: L.groups}}</strong></span></md-chip-template></md-chips></md-input-container><md-input-container\n flex class=\"md-block\"><label ng-if=\'[\"enrole\", \"dismiss\",\"mds\",\"reEnrole\"].indexOf(action) !== -1\'>\nStatus {{status}}: {{status | getMovementStatusName}} [Excepciones]</label><label ng-if=\'action == \"incidences\"\'>\nStatus {{status}}: {{status | incidenceStatusName}} [Excepciones]</label><label \nng-if=\'[\"create\",\"update\",\"remove\",\"cancel\",\"closed\",\"inFinalRevision\",\"inRevision\",\"opened\",\"requested\"].indexOf(status) !== -1\'>\n{{\'EC.\' + status.toUpperCase() | translate}} [Excepciones]</label><md-chips \nng-model=\"globalNotification[action][status].exceptions\" md-autocomplete-snap md-removable \nmd-transform-chip=\"transformChipNormal($chip)\" md-require-match=\"true\"><md-autocomplete md-selected-item=\"profile.$id\" \nmd-search-text=\"searchProfile\" md-items=\'profile in autocompleteProfiles(searchProfile,\"profiles\")\' \nmd-item-text=\"profile.name\" placeholder=\"Usuario que no sea notificado\"><span md-highlight-text=\"searchProfile\">\n{{profile.name}} ({{profile.firm | nameOfL : L.firms : profile.firm}})</span></md-autocomplete><md-chip-template><span>\n<md-icon md-font-icon=\"icon-account\"></md-icon><strong>{{$chip | nameOfL: L.profiles}}</strong> <span class=\"blueC\">\n{{($chip | getSomethingOfArrayFB : L.profiles:\'firm\':\'\') | nameOfL : L.firms : ($chip | getSomethingOfArrayFB : L.profiles:\'firm\':\'\')}}\n</span></span></md-chip-template></md-chips></md-input-container></md-list-item></md-list></md-content></div>\n</md-tab-body></md-tab></md-tabs></md-content></form></div>");
$templateCache.put("app/main/config/views/globalNotifications/globalNotifications.html","<div id=\"globalNotifications\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div fb-search-bar></div><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><div \ntable-loader array=\"globalNotifications\" validations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"globalNotifications.length\"><thead md-head \nmd-order=\"order\" fix-head><tr md-row><th md-column md-order-by=\"module\"><span>Módulo</span></th></tr></thead><tbody \nmd-body><tr md-row md-auto-select md-select=\"globalNotification\" md-select-id=\"$id\" \nng-repeat=\"globalNotification in (F.filteredItems = (globalNotifications | filter:F.searchText.globalNotification | orderBy:order)) | limitTo: F.paginate: (currentPage - 1) * F.paginate\">\n<td md-cell>{{globalNotification.module | nameOfM: M.modules:\'N/A\'}}</td></tr></tbody></table></md-table-container>\n<md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" \nng-show=\"globalNotifications.length\" md-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" \nmd-limit-options=\"F.paginations\" md-page=\"currentPage\" md-on-paginate=\"restartSelected\" \nmd-total=\"{{F.filteredItems.length}}\" md-page-select></md-table-pagination></div></div><md-fab-speed-dial \nmd-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\"><md-fab-trigger>\n<md-button aria-label=\"crud menu\" class=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon>\n</md-button></md-fab-trigger><md-fab-actions><md-button with-permission action=\"update\" access=\"{{F.active.menuItem}}\" \nng-if=\"selected.length == 1\" ng-click=\"R.goToDetail(selected[0])\" aria-label=\"edit\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Editar</md-tooltip><md-icon \nmd-font-icon=\"icon-pencil\" aria-label=\"edit\"></md-icon></md-button><md-button with-permission action=\"remove\" \naccess=\"{{F.active.menuItem}}\" ng-if=\"selected.length\" ng-click=\"delete($event)\" aria-label=\"Delete\" \nclass=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">{{\'EC.REMOVE\' | translate}}</md-tooltip>\n<md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button><md-button with-permission \naction=\"create\" access=\"{{F.active.menuItem}}\" ng-if=\"!selected.length\" ng-click=\'R.goToDetail(\"new\")\' \naria-label=\"add\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">\n{{\'EC.ADD\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon></md-button>\n</md-fab-actions></md-fab-speed-dial></div></div>");
$templateCache.put("app/main/config/views/groups/group.html","<div id=\"group\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill \nng-controller=\"GroupController\"><form name=\"form\" novalidate flex layout=\"column\" ng-disabled=\"F.readMode\"><md-toolbar \nclass=\"md-tall header md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" \nlayout-align=\"start center\" flex><md-button class=\"goto-button md-icon-button\" aria-label=\"Go to groups\" \nng-click=\"R.goToList()\" translate translate-attr-aria-label=\"EC.GO_TO\"><md-icon md-font-icon=\"icon-arrow-left\">\n</md-icon></md-button><div layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"{{F.menuItems.config.groups.icon || F.default.icon}}\" class=\"crud-icon\"></md-icon><div layout=\"column\" \nlayout-align=\"start start\"><div class=\"h2\">{{group.data.name}}</div><div class=\"subtitle secondary-text\"><span \nng-if=\"!F.addMode\">{{\'EC.DETAIL_OF\' | translate}} {{\'group.SINGULAR\' | translate}}</span> <span ng-if=\"F.addMode\">\n{{\'EC.CREATE\' | translate}} {{\'group.SINGULAR\' | translate}}</span></div></div></div></div><div><md-button \ntype=\"submit\" ng-if=\"!F.addMode && !F.readMode\" with-permission action=\"update\" access=\"{{F.active.menuItem}}\" \nng-click=\"saveAndMoveIfNeeded(group)\" ng-hide=\"form.$pristine\" ng-disabled=\"form.$invalid || loadingProgress\" \nclass=\"md-raised md-background md-fab md-accent md-hue-1\" aria-label=\"Save group\"><md-tooltip md-direction=\"left\">\n{{\'EC.SAVE\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-content-save\" aria-label=\"Save\"></md-icon>\n</md-button><md-button type=\"submit\" ng-if=\"F.addMode\" with-permission action=\"create\" access=\"{{F.active.menuItem}}\" \nng-click=\"addAndCreatePermissions(group)\" ng-hide=\"form.$pristine\" ng-disabled=\"form.$invalid || loadingProgress\" \nclass=\"md-raised md-background md-fab md-accent md-hue-1\" aria-label=\"Add group\"><md-tooltip md-direction=\"left\">\n{{\'EC.ADD\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-content-save\" aria-label=\"Add\"></md-icon></md-button>\n</div></md-toolbar><md-content layout=\"column\" class=\"content\" flex><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\"><div layout-gt-xs=\"row\"><md-input-container \nclass=\"md-block\" flex><label>Nombre</label><input ms2-autofocus class=\"uppercased\" type=\"text\" name=\"name\" \nng-model=\"group.name\" ng-model-options=\"{ debounce: F.debounceTime }\" md-maxlength=\"50\" maxlength=\"50\" required \nng-disabled=\"group.system||F.readMode\"><div ng-messages=\"form.slug.$error\" \nng-show=\"(form.name.$dirty || form.name.$touched) && F.addMode\" role=\"alert\"><div ng-message=\"required\">\nNombre de Grupo es requerido</div><div ng-message=\"unique\">Nombre de Grupo ya está registrado</div></div>\n</md-input-container><md-input-container class=\"md-block\" flex><label>Referencia del sistema</label><input \nng-if=\"!F.addMode\" type=\"text\" name=\"slug\" ng-model=\"slug\" disabled=\"disabled\"> <input ng-if=\"F.addMode\" unique-fb-key \nref=\"{{F.active.menuRef}}\" fromid=\"{{groupId}}\" type=\"text\" name=\"slug\" ng-model=\"slug\" disabled=\"disabled\">\n</md-input-container></div><div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex><label>Ruta</label><input \ntype=\"text\" name=\"initialState\" ng-model=\"group.initialState\" ng-disabled=\"F.readMode\"></md-input-container><div \nflex=\"nogrow\"><md-switch layout-margin name=\"groupForClient\" aria-label=\"is for cliente\" class=\"md-secondary\" \nng-model=\"group.groupForClient\">Grupo para cliente</md-switch></div><div flex=\"nogrow\"><md-switch layout-margin \nng-change=\"group.gtm=[]\" name=\"ag\" aria-label=\"is for cliente\" class=\"md-secondary\" ng-model=\"group.ag\">Todos\n</md-switch></div></div><div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex ng-if=\"!group.ag\"><label>\nGrupos para Administrar</label><md-chips ng-model=\"gtm\" md-on-add=\"setGroupAction($chip,true)\" \nmd-on-remove=\"setGroupAction($chip,null)\" md-autocomplete-snap md-transform-chip=\"transformChip($chip)\" \nmd-require-match=\"true\" input-aria-label=\"Grupos para Administrar\"><md-autocomplete md-selected-item=\"groups.$id\" \nmd-search-text=\"searchText\" md-min-length=\"0\" \nmd-items=\"group in autocomplete(searchText, \'allGroups\', \'groupForClient\', true,\'equal\')\" md-item-text=\"group.gtm\" \nplaceholder=\"Seleccione un Grupo\" md-dropdown-position=\"bottom\" md-no-cache=\"true\" \ninput-aria-describedby=\"autocompleteTitle\"><span md-highlight-text=\"ctrl.searchText\">{{group.name}}</span>\n</md-autocomplete><md-chip-template><span><strong>{{$chip | getSomethingOfArrayFB: L.allGroups:\'name\':\'No encontrado\'}}\n</strong></span></md-chip-template></md-chips></md-input-container></div><div layout-gt-xs=\"row\"><md-input-container \nclass=\"md-block\" flex><label>Usuarios</label><md-chips ng-model=\"users\" md-on-add=\"setProfilesAction($chip,true)\" \nmd-on-remove=\"setProfilesAction($chip,null)\" md-autocomplete-snap md-removable \nmd-transform-chip=\"transformChip($chip)\" ng-disabled=\"F.readMode\" md-require-match=\"true\"><md-autocomplete \nmd-selected-item=\"profile.$id\" md-search-text=\"searchProfile\" \nmd-items=\'profile in autocomplete(searchProfile, \"allProfiles\", \"firm\", F.center,\"notEqual\")\' \nmd-item-text=\"profile.name\" md-no-cache=\"true\" placeholder=\"Busque un usuario\"><span md-highlight-text=\"searchProfile\">\n{{profile.name}} ({{profile.firm | nameOfL: L.firms : profile.firm}})</span></md-autocomplete><md-chip-template><span>\n<strong>{{$chip | nameOfL: L.allProfiles: \'N/A\'}}</strong> <span class=\"blueC\">\n{{($chip | getSomethingOfArrayFB: L.allProfiles:\'firm\':\'N/A\') | nameOfL: L.firms : ($chip | getSomethingOfArrayFB: L.allProfiles:\'firm\':\'N/A\')}}\n</span></span></md-chip-template></md-chips></md-input-container></div></div></md-content></form></div>");
$templateCache.put("app/main/config/views/groups/groups.html","<div id=\"groups\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\" ng-controller=\"GroupsController\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div fb-search-bar></div><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><div \ntable-loader array=\"groups\" validations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"groups.length\"><thead md-head fix-head><tr md-row><th \nmd-column><span>Nombre Corto</span></th><th md-column md-numeric><span>Usuarios</span></th></tr></thead><tbody md-body \nng-sortable=\"sortableOptions\"><tr md-row id=\"{{group.$id}}\" md-auto-select md-select=\"group\" md-select-id=\"$id\" \nng-repeat=\'group in groups | orderBy  : \"order\" | filter : F.searchText.group track by group.$id\'><td md-cell>\n{{group.name}}</td><td md-cell>{{group.users | objectsLength}}</td></tr></tbody></table></md-table-container></div>\n</div><md-fab-speed-dial md-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" \nclass=\"ms2-speed-dial bottom right\" ng-mouseenter=\"isOpen=true\" ng-mouseleave=\"isOpen=false\"><md-fab-trigger><md-button\n aria-label=\"crud menu\" class=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon></md-button>\n</md-fab-trigger><md-fab-actions><md-button with-permission action=\"read\" access=\"{{F.active.menuItem}}\" \nng-if=\"selected.length == 1\" ng-click=\'R.goToDetail(null, \"read\", {groupId: selected[0].$id})\' aria-label=\"view\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Ver</md-tooltip><md-icon \nmd-font-icon=\"icon-eye\" aria-label=\"view\"></md-icon></md-button><md-button with-permission action=\"update\" \naccess=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" \nng-click=\'R.goToDetail(null, \"update\", {groupId: selected[0].$id})\' aria-label=\"Edit\" \nclass=\"md-fab md-raised md-accent md-hue-2 md-mini\"><md-tooltip md-direction=\"left\">{{\'EC.EDIT\' | translate}}\n</md-tooltip><md-icon md-font-icon=\"icon-pencil\" aria-label=\"Edit\"></md-icon></md-button><md-button with-permission \naction=\"remove\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length\" ng-click=\"deleteGroupAndFromUsers($event)\" \naria-label=\"Delete\" class=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">\n{{\'EC.REMOVE\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button>\n<md-button with-permission action=\"create\" access=\"{{F.active.menuItem}}\" ng-if=\"!selected.length\" \nng-click=\'R.goToDetail(null, \"update\", {groupId: \"new\"})\' aria-label=\"add\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">{{\'EC.ADD\' | translate}}\n</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon></md-button><md-button with-permission \naction=\"copyGroups\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length===1\" aria-label=\"copy\" \nng-click=\"copyGroup($event, selected[0])\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip \nmd-direction=\"left\">Copiar grupos</md-tooltip><md-icon md-font-icon=\"icon-transfer\" aria-label=\"copy\"></md-icon>\n</md-button></md-fab-actions></md-fab-speed-dial></div></div>");
$templateCache.put("app/main/config/views/holidays/holiday.html","<div id=\"holiday\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill \nng-controller=\"HolidayController\"><form name=\"form\" novalidate flex layout=\"column\" ng-disabled=\"F.readMode\">\n<md-toolbar class=\"md-tall header md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" \nlayout=\"row\" layout-align=\"start center\" flex><md-button class=\"goto-button md-icon-button\" \naria-label=\"Go to holidays\" with-permission action=\"access\" access=\"{{F.active.menuItem}}\" ng-click=\"R.goToList()\" \ntranslate translate-attr-aria-label=\"EC.GO_TO\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div \nlayout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"{{F.menuItems.catalogs.holidays.icon || F.default.icon}}\" class=\"crud-icon\"></md-icon><div \nlayout=\"column\" layout-align=\"start start\"><div class=\"h2\">{{holiday.occasion}}</div><div \nclass=\"subtitle secondary-text\"><span ng-if=\"!F.addMode\">\n{{\'EC.DETAIL_OF\' | translate}} {{\'holiday.SINGULAR\' | translate}}</span> <span ng-if=\"F.addMode\">\n{{\'EC.CREATE\' | translate}} {{\'holiday.SINGULAR\' | translate}}</span></div></div></div></div><div><md-button \ntype=\"submit\" ng-if=\"!F.addMode\" with-permission action=\"update\" access=\"{{F.active.menuItem}}\" \nng-click=\"save(holiday)\" ng-hide=\"form.$pristine\" ng-disabled=\"form.$invalid || loadingProgress\" \nclass=\"md-raised md-background md-fab md-accent md-hue-1\" aria-label=\"Save holiday\"><md-tooltip md-direction=\"left\">\n{{\'EC.SAVE\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-content-save\" aria-label=\"Save\"></md-icon>\n</md-button><md-button type=\"submit\" ng-if=\"F.addMode\" with-permission action=\"create\" access=\"{{F.active.menuItem}}\" \nng-click=\"add(holiday)\" ng-hide=\"form.$pristine\" ng-disabled=\"form.$invalid || loadingProgress\" \nclass=\"md-raised md-background md-fab md-accent md-hue-1\" aria-label=\"Add holiday\"><md-tooltip md-direction=\"left\">\n{{\'EC.ADD\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-content-save\" aria-label=\"Add\"></md-icon></md-button>\n</div></md-toolbar><md-content layout=\"column\" class=\"content\" flex><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\"><md-input-container class=\"md-block\" \nlayout-gt-xs=\"row\"><label>Nombre</label><input type=\"text\" name=\"occasion\" ng-model=\"holiday.occasion\" required \nng-model-options=\"{ debounce: F.debounceTime }\"><div ng-messages=\"form.occasion.$error\" \nng-show=\"form.occasion.$touched || form.occasion.$dirty\" role=\"alert\"><div ng-message=\"required\">Nombre es requerido\n</div></div></md-input-container><div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex><label>Año</label>\n<input type=\"number\" name=\"year\" ng-model=\"holiday.year\" required ng-model-options=\"{ debounce: F.debounceTime }\"><div \nng-messages=\"form.year.$error\" ng-show=\"form.year.$touched || form.year.$dirty\" role=\"alert\"><div \nng-message=\"required\">Nombre es requerido</div></div></md-input-container><md-input-container \nclass=\"md-block date-picker\" flex><label>Fecha</label><md-datepicker ng-disabled=\"F.readMode\" md-hide-icons=\"triangle\" \ninput-date-miliseconds ng-model=\"holiday.date\" name=\"date\" ng-change=\"setDayAndMonth(holiday.date)\" required \nclass=\"md-block\"></md-datepicker><div ng-messages=\"form.date.$error\" \nng-show=\"(form.date.$error && !form.date.$pristine) || (form.date.$error && holiday.date)\" role=\"alert\"><div \nng-message=\"required\">Fecha es requerida</div></div></md-input-container></div></div></md-content></form></div>");
$templateCache.put("app/main/config/views/holidays/holidays.html","<div id=\"holidays\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\" ng-controller=\"HolidaysController\"><div\n class=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div fb-search-bar></div><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><div \ntable-loader array=\"holidays\" validations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"holidays.length\"><thead md-head fix-head><tr md-row><th\n md-column><span>Año</span></th><th md-column><span>Ocasion</span></th><th md-column><span>Fecha</span></th></tr>\n</thead><tbody md-body><tr md-row id=\"{{holiday.$id}}\" md-auto-select md-select=\"holiday\" md-select-id=\"$id\" \nng-repeat=\"holiday in (F.filteredItems = (holidays | filter:F.searchText.holiday | orderBy:order)) | limitTo: F.paginate: (currentPage - 1) * F.paginate\">\n<td md-cell>{{holiday.year}}</td><td md-cell>{{holiday.occasion}}</td><td md-cell>{{holiday.date|date:\'fullDate\'}}</td>\n</tr></tbody></table></md-table-container><md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" \nlayout-xs=\"column\" ng-show=\"holidays.length\" md-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" \nmd-limit-options=\"F.paginations\" md-page=\"currentPage\" md-on-paginate=\"restartSelected\" \nmd-total=\"{{F.filteredItems.length}}\" md-page-select></md-table-pagination></div></div><md-fab-speed-dial \nmd-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\" \nng-mouseenter=\"isOpen=true\" ng-mouseleave=\"isOpen=false\"><md-fab-trigger><md-button aria-label=\"crud menu\" \nclass=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon></md-button></md-fab-trigger>\n<md-fab-actions><md-button with-permission action=\"read\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" \nng-click=\'R.goToDetail(null, \"read\", {holidayId: selected[0].$id})\' aria-label=\"view\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Ver</md-tooltip><md-icon \nmd-font-icon=\"icon-eye\" aria-label=\"view\"></md-icon></md-button><md-button with-permission action=\"update\" \naccess=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" \nng-click=\'R.goToDetail(null, \"update\", {holidayId: selected[0].$id})\' aria-label=\"Edit\" \nclass=\"md-fab md-raised md-accent md-hue-2 md-mini\"><md-tooltip md-direction=\"left\">{{\'EC.EDIT\' | translate}}\n</md-tooltip><md-icon md-font-icon=\"icon-pencil\" aria-label=\"Edit\"></md-icon></md-button><md-button with-permission \naction=\"remove\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length\" ng-click=\"delete($event)\" aria-label=\"Delete\" \nclass=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">{{\'EC.REMOVE\' | translate}}</md-tooltip>\n<md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button><md-button with-permission \naction=\"copyHolidays\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length\" ng-click=\"copyHolidays($event,selected)\" \naria-label=\"copy\" class=\"md-fab md-raised md-accent md-mini\"><md-tooltip md-direction=\"left\">\n{{\'EC.COPYHOLIDAYS\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-reply-all\" aria-label=\"Remove\"></md-icon>\n</md-button><md-button with-permission action=\"create\" access=\"{{F.active.menuItem}}\" ng-if=\"!selected.length\" \nng-click=\'R.goToDetail(null, \"update\", {holidayId: \"new\"})\' aria-label=\"add\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">{{\'EC.ADD\' | translate}}\n</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon></md-button></md-fab-actions>\n</md-fab-speed-dial></div></div>");
$templateCache.put("app/main/config/views/holidays/select-year.html","<md-dialog aria-label=\"Year Holiday\"><form name=\"holidayYearForm\" ng-submit=\"answer(year)\" \nng-disabled=\"holidayYearForm.$invalid\" novalidate><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nCopiar {{selected.length}} Dia(s) Festivo(s)</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close Dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><div layout-gt-xs=\"row\" flex><md-input-container \nclass=\"md-block\" flex><label>Año para los dias festivos</label><input type=\"number\" name=\"year\" ng-model=\"year\" \nrequired><div ng-messages=\"holidayYearForm.year.$error\" ng-show=\"holidayYearForm.year.$dirty\" role=\"alert\"><div \nng-message=\"required\">Año es requerido</div></div></md-input-container></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><span flex></span><md-button ng-click=\"answer(year)\" class=\"md-primary md-hue-2\" \nng-disabled=\"holidayYearForm.$invalid\">OK</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/config/views/imports/import.html","<div id=\"import\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill \nng-controller=\"ImportController\"><form name=\"mainForm\" novalidate flex layout=\"column\" ng-disabled=\"F.readMode\">\n<md-toolbar class=\"md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" \nlayout-align=\"start center\" flex><md-button class=\"goto-button md-icon-button\" aria-label=\"Go to list\" with-permission \naction=\"access\" access=\"{{F.active.menuItem}}\" ng-click=\"R.goToList()\" translate translate-attr-aria-label=\"EC.GO_TO\">\n<md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\'{{F.menuItems.catalogs[F.active.menuName].icon || \"icon-hexagon\"}}\' class=\"crud-icon\"></md-icon><div \nlayout=\"column\" layout-align=\"start start\"><div class=\"h2\">{{F.active.detailObject.name}}</div><div \nclass=\"subtitle secondary-text\"><span ng-if=\"!F.addMode\">\n{{\'EC.DETAIL_OF\' | translate}} {{F.active.menuObjName + \'.SINGULAR\' | translate}}</span> <span ng-if=\"F.addMode\">\n{{\'EC.CREATE\' | translate}} {{F.active.menuObjName + \'.SINGULAR\' | translate}}</span></div></div></div></div><div>\n<md-button ng-if=\'F.addMode && import.type == \"employees\" && selectedTab == 0\' with-permission action=\"upload\" \naccess=\"{{F.active.menuItem}}\" ng-click=\"uploadToImport(employeesFilesArray)\" ng-hide=\"mainForm.$pristine\" \nng-disabled=\"mainForm.$invalid || loadingProgress || !employeesFilesArray.length\" \nclass=\"md-raised md-background md-fab md-accent md-hue-1\" aria-label=\"Upload employees import file\"><md-tooltip \nmd-direction=\"left\">Subir CSV</md-tooltip><md-icon md-font-icon=\"icon-upload\" aria-label=\"upload employees\"></md-icon>\n</md-button><md-button ng-if=\'F.addMode && import.type == \"movements\" && selectedTab == 0\' with-permission \naction=\"upload\" access=\"{{F.active.menuItem}}\" ng-click=\"uploadToImport(movementsFilesArray)\" \nng-hide=\"mainForm.$pristine\" ng-disabled=\"mainForm.$invalid || loadingProgress || !movementsFilesArray.length\" \nclass=\"md-raised md-background md-fab md-accent md-hue-1\" aria-label=\"Upload movements import file\"><md-tooltip \nmd-direction=\"left\">Subir CSV</md-tooltip><md-icon md-font-icon=\"icon-upload\" aria-label=\"upload movements\"></md-icon>\n</md-button><md-button ng-if=\'F.addMode && import.type == \"credits\" && selectedTab == 0\' with-permission \naction=\"upload\" access=\"{{F.active.menuItem}}\" ng-click=\"uploadToImport(creditsFilesArray)\" \nng-hide=\"mainForm.$pristine\" ng-disabled=\"mainForm.$invalid || loadingProgress || !creditsFilesArray.length\" \nclass=\"md-raised md-background md-fab md-accent md-hue-1\" aria-label=\"Upload credits import file\"><md-tooltip \nmd-direction=\"left\">Subir CSV</md-tooltip><md-icon md-font-icon=\"icon-upload\" aria-label=\"upload credits\"></md-icon>\n</md-button><md-button \nng-if=\'F.addMode && selectedTab == 1 && import.type==\"employees\" && dataIsValid(dataFromImport)\' with-permission \naction=\"review\" access=\"{{F.active.menuItem}}\" ng-click=\"generateDefaultMovement()\" \nclass=\"md-raised md-background md-fab md-primary md-hue-2\" aria-label=\"Aprove employees\"><md-tooltip \nmd-direction=\"left\">Generar Movimiento inicial</md-tooltip><md-icon md-font-icon=\"icon-check-bookmark\" \naria-label=\"aprove employees\"></md-icon></md-button><md-button \nng-if=\"F.addMode && selectedTab == 1 && !dataIsValid(dataFromImport)\" ng-click=\"permiteExceptionAll()\" \nclass=\"md-fab md-mini md-warn\"><md-tooltip md-direction=\"left\">Forzar Registro</md-tooltip><md-icon \nmd-font-icon=\"icon-clipboard-check\" aria-label=\"valid forced\"></md-icon></md-button><md-button \nng-if=\"F.addMode && selectedTab == 1\" with-permission action=\"review\" access=\"{{F.active.menuItem}}\" \nng-click=\"review()\" \nng-disabled=\"(mainForm.$invalid || !dataIsValid(dataFromImport) || loadingProgress) && !allowExceptions\" \nclass=\"md-raised md-background md-fab md-accent md-hue-1\" aria-label=\"Aprove employees\"><md-tooltip \nmd-direction=\"left\">Revisar y Aprobar</md-tooltip><md-icon md-font-icon=\"icon-check-all\" aria-label=\"aprove employees\">\n</md-icon></md-button><md-button ng-if=\"F.addMode && selectedTab == 2\" with-permission action=\"import\" \naccess=\"{{F.active.menuItem}}\" ng-click=\"importData()\" \nng-disabled=\"(mainForm.$invalid || !dataIsValid(dataFromImport)  || loadingProgress) && !allowExceptions\" \nclass=\"md-raised md-background md-fab md-accent\" aria-label=\"Import employees\"><md-tooltip md-direction=\"left\">Importar\n</md-tooltip><md-icon md-font-icon=\"icon-import\" aria-label=\"import\"></md-icon></md-button></div></md-toolbar>\n<md-content layout=\"column\" class=\"content\" flex><md-tabs md-selected=\"selectedTab\" flex layout-fill><md-tab \nlabel=\"Importación\" ng-disabled=\"!F.addMode\"><md-tab-body><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\"><div flex layout=\"row\"><md-input-container flex \nclass=\"md-input-has-value\"><label>Tipo de Importación</label><md-radio-group ng-model=\"import.type\" required \nng-change=\"loadNeededFields(import.type)\"><md-radio-button value=\"employees\" class=\"md-primary\">Empleados\n</md-radio-button><md-radio-button value=\"movements\">Movimientos</md-radio-button><md-radio-button value=\"credits\">\nCréditos</md-radio-button></md-radio-group></md-input-container></div><hr><div flex layout=\"row\" ng-show=\"import.type\">\n<div flex ng-show=\'import.type == \"employees\"\' layout=\"column\"><div flex><lf-ng-md-file-input \nlf-files=\"employeesFilesArray\" lf-placeholder=\"CSV de Empleados\" lf-drag-and-drop-label=\"csv - Max: 10MB\" \nlf-browse-label=\"Buscar\" lf-remove-label=\"Borrar\" lf-filesize=\"10MB\" name=\"employeesFile\" lf-api=\"csvApi\">\n</lf-ng-md-file-input></div><div flex=\"no-grow\" layout=\"row\"><span flex></span> <a class=\"downloadLink\" \ntarget=\"_blanc\" href=\"assets/csv/import-employees-blanc.csv\">descargar template<md-icon md-font-icon=\"icon-file-excel\" \naria-label=\"download employees template\"></md-icon></a></div><div ng-messages=\"mainForm.employeesFile.$error\" \nstyle=\"color:red\"><div ng-message=\"required\">Archivo requerido</div><div ng-message=\"maxcount\">Demaciados archivos\n</div><div ng-message=\"filesize\">Archivo demaciado grande</div><div ng-message=\"totalsize\">\nEspacio total demaciado grande</div><div ng-message=\"mimetype\">Formato inválido</div></div><div flex><h4>\nCampos requeridos *:</h4><ul class=\"requiredFields\"><li ng-repeat=\"(keyR, nameR) in requiredFields\"><span>{{nameR}}\n</span><span ng-show=\"keyR == requiredFields.length-1\">.</span><span ng-show=\"keyR != requiredFields.length-1\">,&nbsp;\n</span></li></ul></div></div><div flex ng-show=\'import.type == \"movements\"\' layout=\"column\"><div flex>\n<lf-ng-md-file-input lf-files=\"movementsFilesArray\" lf-placeholder=\"CSV de Movimientos\" \nlf-drag-and-drop-label=\"csv - Max: 10MB\" lf-browse-label=\"Buscar\" lf-remove-label=\"Borrar\" lf-filesize=\"10MB\" \nname=\"movementsFile\" lf-api=\"csvApi\"></lf-ng-md-file-input></div><div flex=\"no-grow\" layout=\"row\"><span flex></span> <a\n class=\"downloadLink\" target=\"_blanc\" href=\"assets/csv/import-movements-blanc.csv\">descargar template<md-icon \nmd-font-icon=\"icon-file-excel\" aria-label=\"download movements template\"></md-icon></a></div><div \nng-messages=\"mainForm.movementsFile.$error\" style=\"color:red\"><div ng-message=\"required\">Archivo requerido</div><div \nng-message=\"maxcount\">Demaciados archivos</div><div ng-message=\"filesize\">Archivo demaciado grande</div><div \nng-message=\"totalsize\">Espacio total demaciado grande</div><div ng-message=\"mimetype\">Formato inválido</div></div><div \nflex><h4>Campos requeridos *:</h4><ul class=\"requiredFields\"><li ng-repeat=\"(keyR, nameR) in requiredFields\"><span>\n{{nameR}}</span><span ng-show=\"keyR == requiredFields.length-1\">.</span><span \nng-show=\"keyR != requiredFields.length-1\">,&nbsp;</span></li></ul></div></div><div flex \nng-show=\'import.type == \"credits\"\' layout=\"column\"><div flex><lf-ng-md-file-input lf-files=\"creditsFilesArray\" \nlf-placeholder=\"CSV de Créditos\" lf-drag-and-drop-label=\"csv - Max: 10MB\" lf-browse-label=\"Buscar\" \nlf-remove-label=\"Borrar\" lf-filesize=\"10MB\" name=\"creditsFile\" lf-api=\"csvApi\"></lf-ng-md-file-input></div><div \nflex=\"no-grow\" layout=\"row\"><span flex></span> <a class=\"downloadLink\" target=\"_blanc\" \nhref=\"assets/csv/import-credits-blanc.csv\">descargar template<md-icon md-font-icon=\"icon-file-excel\" \naria-label=\"download credits template\"></md-icon></a></div><div ng-messages=\"mainForm.creditsFile.$error\" \nstyle=\"color:red\"><div ng-message=\"required\">Archivo requerido</div><div ng-message=\"maxcount\">Demaciados archivos\n</div><div ng-message=\"filesize\">Archivo demaciado grande</div><div ng-message=\"totalsize\">\nEspacio total demaciado grande</div><div ng-message=\"mimetype\">Formato inválido</div></div><div flex><h4>\nCampos requeridos *:</h4><ul class=\"requiredFields\"><li ng-repeat=\"(keyR, nameR) in requiredFields\"><span>{{nameR}}\n</span><span ng-show=\"keyR == requiredFields.length-1\">.</span><span ng-show=\"keyR != requiredFields.length-1\">,&nbsp;\n</span></li></ul></div></div></div><hr><div flex layout=\"row\"><code flex>\nLa importación quedará registrada bajo la nómina del primer registro en el csv.</code></div><md-progress-circular \nng-show=\"F.loadingFile\" class=\"md-primary\" md-mode=\"indeterminate\" md-diameter=\"128\"></md-progress-circular></div>\n</md-tab-body></md-tab><md-tab label=\"Revisión y Actualización\" ng-disabled=\"!import.file || !F.addMode\"><md-tab-body>\n<div class=\"md-background-bg md-whiteframe-1dp\"><h4>Datos para Importar {{import.type|importTypeName}}</h4>\n<md-table-container ng-hide=\"F.loadingFile\"><table md-table class=\"row-border\"><thead md-head><tr md-row><th mg-column>\n<small>EDITAR</small></th><th md-column ng-repeat=\"field in neededFields\"><span \nng-class=\'{\"requiredField\": requiredFields.indexOf(field) != -1}\'>{{field}}</span></th><th md-column><md-menu \nmd-position-mode=\"target-left target\" ng-if=\"!dataIsValid(dataFromImport) \"><md-button ng-click=\"$mdOpenMenu($event)\" \nclass=\"md-warn\">Validez</md-button><md-menu-content><md-menu-item><md-button class=\"md-warn md-hue-2 md-icon\" \nng-click=\"removeInvalids()\" aria-label=\"remove invalids\"><md-icon md-font-icon=\"icon-delete-variant\" \naria-label=\"valid\"></md-icon>Remover registros inválidos</md-button></md-menu-item><md-menu-item><md-button \nclass=\"md-warn md-hue-2 md-icon\" ng-click=\"allowAllExceptions()\" aria-label=\"allow exceptions\"><md-icon \nmd-font-icon=\"icon-multiple-check\" aria-label=\"validss\"></md-icon><span ng-show=\"!allowExceptions\">\nPermitir todas las excepciones</span> <span ng-show=\"allowExceptions\">Cancelar Permitir todas las excepciones</span>\n</md-button></md-menu-item></md-menu-content></md-menu><md-button ng-if=\"dataIsValid(dataFromImport) \" \nclass=\"md-primary md-icon\">Validez</md-button></th></tr></thead><tbody md-body><tr \nng-class=\'{\"validRow\": row.config.valid, \"invalidRow\": !row.config.valid}\' md-row \nng-repeat=\"row in (F.filteredItems = (dataFromImport)) | limitTo: F.paginate: (currentPage - 1) * F.paginate\" \nng-init=\"subForm = \'subForm\' + $index\"><td md-cell><md-button class=\"md-primary md-icon-button\" \nng-click=\"editRow(row)\"><md-tooltip md-direction=\"right\">{{(row.config.editMode) ? \'Dejar de Editar\' : \'Editar\'}}\n</md-tooltip><md-icon ng-show=\"!row.config.editMode\" md-font-icon=\"icon-pencil\" aria-label=\"edit icon\"></md-icon>\n<md-icon ng-show=\"row.config.editMode\" md-font-icon=\"icon-check\" aria-label=\"edit icon\"></md-icon></md-button></td><td \nmd-cell ng-repeat=\"field in neededFields\"><div ng-if=\"!row.config.editMode\"><span ng-if=\"inputTypes.inputs[field]\">\n{{row[field]}}</span><span ng-if=\"inputTypes.switchs[field]\">{{(row[field]) ? \'Si\': \'No\'}}</span><span \nng-if=\"inputTypes.datepickers[field]\">{{row[field]|date:F.dateFormat}}</span><span ng-if=\"inputTypes.selects[field]\">\n{{row[field]}} </span><span ng-if=\"inputTypes.fbAutocompletes[field]\">{{row[field + \'-name\']}} </span><span \nng-if=\"inputTypes.mongoAutocompletes[field]\">{{row[field + \'-name\']}}</span></div><ng-form name=\"{{subForm}}\"><div \nng-if=\"row.config.editMode\"><md-input-container ng-if=\'inputTypes.inputs[field] && field !== \"id\"\' md-no-float><input \nng-if=\'inputTypes.inputs[field] == \"text\"\' \nng-required=\"requiredFields.indexOf(field) !== -1 && !row.config.permiteException\" \nng-disabled=\"inputTypes.disabled.indexOf(field) !== -1 && row[field]\" type=\"{{inputTypes.inputs[field]}}\" \nname=\"{{field}}\" ng-class=\"field\" tabindex=\"{{$index+1}}000\" ng-model-options=\"{ debounce: F.debounceTime }\" \naria-label=\"{{field}}-importer\" ng-model=\"row[field]\"> <input \nng-if=\'inputTypes.inputs[field] == \"number\" && [\"sd\",\"sbc\"].indexOf(field) == -1\' \nng-required=\"requiredFields.indexOf(field) !== -1 && !row.config.permiteException\" \nng-disabled=\"inputTypes.disabled.indexOf(field) !== -1 && row[field]\" step=\"any\" type=\"number\" name=\"{{field}}\" \nng-class=\"field\" tabindex=\"{{$index+1}}000\" ng-model-options=\"{ debounce: F.debounceTime }\" \naria-label=\"{{field}}-importer\" ng-model=\"row[field]\"> <input \nng-if=\'inputTypes.inputs[field] == \"number\" && [\"sd\",\"sbc\"].indexOf(field) !== -1\' \nng-required=\'row[\"rp-rp\"]!=\"00000000000\"  && !row.config.permiteException\' \nng-disabled=\"inputTypes.disabled.indexOf(field) !== -1 && row[field]\" step=\"any\" type=\"number\" name=\"{{field}}\" \ntitle=\"{{row.nss}}\" ng-class=\"field\" tabindex=\"{{$index+1}}000\" ng-model-options=\"{ debounce: F.debounceTime }\" \naria-label=\"{{field}}-importer\" ng-model=\"row[field]\"></md-input-container><md-input-container \nng-if=\"inputTypes.unique[field] && !row.config.permiteException\" md-no-float><input unique-fb \nref=\"{{inputTypes.unique[field].ref}}\" query=\"{{inputTypes.unique[field].query}}\" fromid=\"{{row.id}}\" \nng-required=\"requiredFields.indexOf(field) !== -1\" \nng-disabled=\"inputTypes.disabled.indexOf(field) !== -1 && row[field]\" type=\"{{inputTypes.inputs[field]}}\" \ntabindex=\"{{$index+1}}000\" name=\"{{field}}\" ng-class=\"field\" ng-model-options=\"{ debounce: F.debounceTime }\" \naria-label=\"{{field}}-importer\" ng-model=\"row[field]\"></md-input-container><md-input-container \nng-if=\"inputTypes.unique[field] && row.config.permiteException\" md-no-float><input \nng-disabled=\"inputTypes.disabled.indexOf(field) !== -1 && row[field]\" type=\"{{inputTypes.inputs[field]}}\" \nname=\"{{field}}\" ng-class=\"field\" ng-model-options=\"{ debounce: F.debounceTime }\" aria-label=\"{{field}}-importer\" \ntabindex=\"{{$index+1}}000\" ng-model=\"row[field]\"></md-input-container><md-input-container \nng-if=\"inputTypes.switchs[field]\" class=\"md-input-has-placeholder\"><md-switch aria-label=\"{{row.id}} {{field}}\" \nclass=\"md-secondary\" name=\"{{field}}\" ng-model=\"row[field]\" \nng-required=\"requiredFields.indexOf(field) !== -1 && !row.config.permiteException\" \nng-disabled=\"inputTypes.disabled.indexOf(field) !== -1 && row[field]\" ng-model-options=\"{ debounce: F.debounceTime }\" \naria-label=\"{{field}}-importer\" ng-false-value=\"0\"></md-switch></md-input-container><md-input-container \nclass=\"md-block date-picker date-picker-inTd\" ng-if=\"inputTypes.datepickers[field]\"><md-datepicker \nmd-current-view=\"{{F.dateView}}\" md-hide-icons=\"triangle\" input-date-miliseconds ng-model=\"row[field]\" \nname=\"{{field}}\" ng-required=\"requiredFields.indexOf(field) !== -1 && !row.config.permiteException\" \nng-model-options=\"{ debounce: F.debounceTime }\" aria-label=\"{{field}}-importer\" \nng-disabled=\"inputTypes.disabled.indexOf(field) !== -1 && row[field]\"></md-datepicker></md-input-container>\n<md-input-container ng-if=\"inputTypes.selects[field]\" class=\"md-block evenPadding\" md-no-float><md-select \nng-model=\"row[field]\" ng-model-options=\"{ debounce: F.debounceTime }\" aria-label=\"{{field}}-importer\" \nng-required=\"requiredFields.indexOf(field) !== -1 && !row.config.permiteException\" \nng-disabled=\"inputTypes.disabled.indexOf(field) !== -1 && row[field]\"><md-option ng-value=\"id\" \nng-repeat=\"(id, name) in inputTypes.selects[field]\">{{name}}</md-option></md-select></md-input-container>\n<md-input-container ng-if=\"inputTypes.fbAutocompletes[field]\" md-no-float><md-autocomplete \nng-required=\"requiredFields.indexOf(field) !== -1 && !row.config.permiteException\" \nng-disabled=\"inputTypes.disabled.indexOf(field) !== -1 && row[field]\" md-input-name=\"{{field}}\" md-min-length=\"3\" \nmd-selected-item-change=\"row[field]=item.$id\" md-selected-item=\'row[field + \"-object\"]\' \nmd-search-text=\'row[field + \"-name\"]\' md-items=\'item in fbAutocomplete(row[field + \"-name\"], field, row)\' \nmd-item-text=\"item.name\" md-require-match=\"true\" md-select-on-match=\"true\" md-match-case-insensitive=\"true\" \nng-class=\"field\" ng-model-options=\"{ debounce: F.debounceTime }\" aria-label=\"{{field}}-importer\" md-no-cache=\"true\" \nmd-min-length=\"3\" md-autocomplete-snap=\"width\" md-match-case-insensitive=\"true\"><md-item-template><span \nmd-highlight-text=\'row[field + \"-name\"]\'>{{item.name}}</span> <small ng-if=\'field == \"cc_id\"\'>\n[{{item.rp_id | nameOfL:L.rps}}]</small></md-item-template><md-not-found>Sin coincidencias</md-not-found>\n</md-autocomplete></md-input-container><md-input-container ng-if=\"inputTypes.mongoAutocompletes[field]\" md-no-float>\n<md-autocomplete ng-required=\"requiredFields.indexOf(field) !== -1 && !row.config.permiteException\" \nng-disabled=\"inputTypes.disabled.indexOf(field) !== -1 && row[field]\" md-input-name=\"{{field}}\" md-min-length=\"3\" \nmd-selected-item-change=\"row[field]=item._id\" md-selected-item=\'row[field + \"-object\"]\' \nmd-search-text=\'row[field + \"-name\"]\' md-items=\'item in mongoAutocomplete(row[field + \"-name\"], field, row)\' \nmd-item-text=\"item.name\" md-require-match=\"true\" md-select-on-match=\"true\" ng-class=\"field\" \nng-model-options=\"{ debounce: F.debounceTime }\" aria-label=\"{{field}}-importer\" md-match-case-insensitive=\"true\">\n<md-item-template><span md-highlight-text=\'row[field + \"-name\"]\'>{{item.name}}</span> <span \nng-if=\'field == \"municipios_id\"\'>- {{item.state_id | nameOfM:M.states}}</span></md-item-template><md-not-found>\nSin coincidencias</md-not-found></md-autocomplete></md-input-container></div></ng-form></td><td md-cell><md-button \nng-click=\'validationAction($event, row, \"invalid\")\' ng-show=\"!row.config.valid && !row.config.permiteException\" \nclass=\"md-fab md-mini md-warn md-hue-2\"><md-tooltip md-direction=\"left\">Registro inválido: <span>\n{{ row.config.validations | objectToRawValidation}}</span></md-tooltip><md-icon md-font-icon=\"icon-close\" \naria-label=\"invalid\"></md-icon></md-button><md-button ng-click=\'validationAction($event, row, \"invalid\")\' \nng-show=\"!row.config.valid && row.config.permiteException\" class=\"md-fab md-mini md-warn\"><md-tooltip \nmd-direction=\"left\">Registro válido (forzado): <span>{{ row.config.validations | objectToRawValidation}}</span>\n</md-tooltip><md-icon md-font-icon=\"icon-clipboard-check\" aria-label=\"valid forced\"></md-icon></md-button><md-menu \nng-if=\'import.type !== \"employees\" && row.id && row.estatus != 1\' md-position-mode=\"target-left target\" \nng-show=\"row.config.valid\"><md-button ng-click=\"$mdOpenMenu($event)\" class=\"md-fab md-mini md-accent\" \naria-label=\"registro invalido menu\"><md-tooltip md-direction=\"left\">Registro válido</md-tooltip><md-icon \nmd-font-icon=\"icon-check\" aria-label=\"valid\"></md-icon></md-button><md-menu-content><md-menu-item><md-button \nclass=\"md-warn md-hue-2\" ng-click=\"removeRow(row.id)\" aria-label=\"remove employee\">Remover registro</md-button>\n</md-menu-item></md-menu-content></md-menu><md-menu ng-if=\'import.type == \"employees\" && row.id && row.estatus != 1\' \nmd-position-mode=\"target-left target\" ng-show=\'row.config.valid && row[\"rp-rp\"]!=\"00000000000\"\'><md-button \nng-click=\"$mdOpenMenu($event)\" class=\"md-fab md-mini md-accent\" aria-label=\"registro valido menu\"><md-tooltip \nmd-direction=\"left\">Registro válido</md-tooltip><md-icon md-font-icon=\"icon-check\" aria-label=\"valid\"></md-icon>\n</md-button><md-menu-content><md-menu-item><md-button class=\"md-warn md-hue-2\" ng-click=\"removeRow(row.id)\" \naria-label=\"remove employee\">Remover registro</md-button></md-menu-item></md-menu-content></md-menu><md-button \nng-if=\'import.type == \"employees\" && !row.id && row.estatus == 1\' ng-click=\'validationAction($event, row, \"info\")\' \nng-show=\'row.config.valid && row[\"rp-rp\"]!=\"00000000000\" && row.config.createMovementType\' \nclass=\"md-fab md-mini md-accent\" aria-label=\"registro valido sin id new movement\"><md-tooltip md-direction=\"left\">\nEmpleado válido sin id (se creará movimiento de alta)</md-tooltip><md-icon md-font-icon=\"icon-account-check\" \naria-label=\"valid especial\"></md-icon></md-button><md-button \nng-if=\'import.type == \"employees\" && !row.id && row.estatus == 1\' ng-click=\'validationAction($event, row, \"info\")\' \nng-show=\'row.config.valid && row[\"rp-rp\"]!=\"00000000000\" && !row.config.createMovementType\' \nclass=\"md-fab md-mini md-warn\" aria-label=\"registro valido sin id no new movement\"><md-tooltip md-direction=\"left\">\nEmpleado válido sin id (no se creará movimiento de alta)</md-tooltip><md-icon md-font-icon=\"icon-account-alert\" \naria-label=\"invalid especial\"></md-icon></md-button><md-button ng-if=\'import.type == \"employees\"\' \nng-click=\'validationAction($event, row, \"info\")\' \nng-show=\'row.config.valid && row[\"rp-rp\"]==\"00000000000\" && row.config.createMovement\' \nclass=\"md-fab md-mini md-accent\" aria-label=\"registro valido sin nss create movement\"><md-tooltip md-direction=\"left\">\nEmpleado válido sin NSS (se creará movimiento de alta default)</md-tooltip><md-icon md-font-icon=\"icon-account-check\" \naria-label=\"valid especial\"></md-icon></md-button><md-button ng-if=\'import.type == \"employees\"\' \nng-click=\'validationAction($event, row, \"info\")\' \nng-show=\'row.config.valid && row[\"rp-rp\"]==\"00000000000\" && !row.config.createMovement\' class=\"md-fab md-mini md-warn\" \naria-label=\"registro valido sin nss no new movement\"><md-tooltip md-direction=\"left\">\nEmpleado válido sin NSS (no se creará movimiento de alta default)</md-tooltip><md-icon \nmd-font-icon=\"icon-account-alert\" aria-label=\"invalid especial\"></md-icon></md-button></td></tr></tbody></table>\n</md-table-container><md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" \nng-show=\"F.filteredItems.length\" md-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" \nmd-limit-options=\"F.paginations\" md-page=\"currentPage\" md-on-paginate=\"restartSelected\" \nmd-total=\"{{F.filteredItems.length}}\" md-page-select></md-table-pagination></div></md-tab-body></md-tab><md-tab \nlabel=\"Aprobación e Importación\" ng-disabled=\"!import.status == 1 || !F.addMode\"><md-tab-body><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\" ng-if=\'import.type == \"employees\"\' layout=\"column\">\n<h4>Datos para Importar Empleados</h4><h5>{{dataToImport.employees | objectsLength}} Empleados</h5><div flex \nlayout=\"column\"><div ng-repeat=\"(id, dato) in dataToImport.employees\" ng-init=\"dataToImportC[id]\" flex><a \nng-click=\"dataToImportC[id] = !dataToImportC[id]\"><span ng-show=\"!dataToImportC[id]\">+</span><span \nng-show=\"dataToImportC[id]\">-</span> {{id}}</a><pre class=\"blockcubed\" ng-show=\"dataToImportC[id]\">\n\r\n                                        {{dato | json}}\r\n                                    </pre></div></div><h5>\n{{dataToImport.movements | objectsLength}} Movimientos</h5><div flex layout=\"column\"><div \nng-repeat=\"(id, dato) in dataToImport.movements\" ng-init=\"dataToImportC[id]\" flex><a \nng-click=\"dataToImportC[id] = !dataToImportC[id]\"><span ng-show=\"!dataToImportC[id]\">+</span><span \nng-show=\"dataToImportC[id]\">-</span> {{id}}</a><pre class=\"blockcubed\" ng-show=\"dataToImportC[id]\">\n\r\n                                        {{dato | json}}\r\n                                    </pre></div></div></div>\n<div class=\"detail-form-container md-background-bg md-whiteframe-1dp\" ng-if=\'import.type == \"movements\"\' \nlayout=\"column\"><h4>Datos para Importar Movimientos</h4><h5>{{dataToImport.movements | objectsLength}} Movimientos</h5>\n<div flex layout=\"column\"><div ng-repeat=\"(id, dato) in dataToImport.movements\" ng-init=\"dataToImportC[id]\" flex><a \nng-click=\"dataToImportC[id] = !dataToImportC[id]\"><span ng-show=\"!dataToImportC[id]\">+</span><span \nng-show=\"dataToImportC[id]\">-</span> {{id}} - {{dato.data.date | date:\'dd/MM/yyyy\'}}</a><pre class=\"blockcubed\" \nng-show=\"dataToImportC[id]\">\n\r\n                                        {{dato | json}}\r\n                                    </pre></div></div></div>\n<div class=\"detail-form-container md-background-bg md-whiteframe-1dp\" ng-if=\'import.type == \"credits\"\' layout=\"column\">\n<h4>Datos para Importar Créditos</h4><h5>{{dataToImport.credits | objectsLength}} Créditos</h5><div flex \nlayout=\"column\"><div ng-repeat=\"(id, dato) in dataToImport.credits\" ng-init=\"dataToImportC[id]\" flex><a \nng-click=\"dataToImportC[id] = !dataToImportC[id]\"><span ng-show=\"!dataToImportC[id]\">+</span><span \nng-show=\"dataToImportC[id]\">-</span> {{id}} - {{dato.data.date | date:\'dd/MM/yyyy\'}}</a><pre class=\"blockcubed\" \nng-show=\"dataToImportC[id]\">\n\r\n                                        {{dato | json}}\r\n                                    </pre></div></div></div>\n</md-tab-body></md-tab><md-tab label=\"Registros Importados\" ng-disabled=\"F.addMode\"><md-tab-body><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\" ng-if=\"!F.addMode\"><strong>Fecha:</strong>\n {{import.created.atTime | date}}<br><strong>Tipo:</strong>\n {{(import.type == \"employees\") ? \"Empleados\" : \"Movimientos\" }}<br><strong>Importaciones:</strong><br><ul \nng-if=\"import.imports.employees\"><li>Empleados</li><li ng-repeat=\"(ie, n) in import.imports.employees\"><span>{{ie}}\n</span></li></ul><ul ng-if=\"import.imports.movements\"><li>Movimientos</li><li \nng-repeat=\"(im, n) in import.imports.movements\"><span>{{im}}</span></li></ul><ul ng-if=\"import.imports.credits\"><li>\nCréditos</li><li ng-repeat=\"(ic, n) in import.imports.credits\"><span>{{ic}}</span></li></ul></div></md-tab-body>\n</md-tab></md-tabs></md-content></form></div>");
$templateCache.put("app/main/config/views/imports/imports.html","<div id=\"imports\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\" ng-controller=\"ImportsController\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div fb-search-bar></div><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><div \nfilter-toolbar></div><div table-loader array=\"imports\" validations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"imports.length\"><thead md-head md-order=\"order\" \nfix-head><tr md-row><th md-column md-order-by=\"date\"><span>Fecha</span></th><th md-column md-order-by=\"type\"><span>Tipo\n</span></th><th md-column md-order-by=\"payroll\"><span>Nómina</span></th><th md-column><span>Registros</span></th></tr>\n</thead><tbody md-body><tr md-row md-auto-select md-select=\"import\" md-select-id=\"_id\" \nng-repeat=\"import in (F.filteredItems = (imports | filter:F.searchText.import | orderBy:order)) | limitTo: F.paginate: (currentPage - 1) * F.paginate\">\n<td md-cell>{{import.created.atTime|date}}</td><td md-cell>{{(import.type|importTypeName)}}</td><td md-cell>\n{{import.payroll|nameOfL:L.allPayrolls}}</td><td md-cell>{{import.imports[import.type]|objectsLength}}</td></tr>\n</tbody></table></md-table-container><md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" \nlayout-xs=\"column\" ng-show=\"imports.length\" md-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" \nmd-limit-options=\"F.paginations\" md-page=\"currentPage\" md-on-paginate=\"restartSelected\" \nmd-total=\"{{F.filteredItems.length}}\" md-page-select></md-table-pagination></div></div><md-fab-speed-dial \nmd-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\"><md-fab-trigger>\n<md-button aria-label=\"crud menu\" class=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon>\n</md-button></md-fab-trigger><md-fab-actions><md-button with-permission action=\"read\" access=\"{{F.active.menuItem}}\" \nng-if=\"selected.length == 1\" ng-click=\'R.goToDetail(selected[0], \"read\", {importId: selected[0].$id})\' \naria-label=\"Edit\" class=\"md-fab md-raised md-accent md-hue-2 md-mini\"><md-tooltip md-direction=\"left\">Ver</md-tooltip>\n<md-icon md-font-icon=\"icon-eye\" aria-label=\"see\"></md-icon></md-button><md-button with-permission action=\"remove\" \naccess=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" ng-click=\"deleteImport($event, selected[0])\" \naria-label=\"Undo and Delete\" class=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">Deshacer y Borrar\n</md-tooltip><md-icon md-font-icon=\"icon-undo\" aria-label=\"undo\"></md-icon></md-button><md-button with-permission \naction=\"create\" access=\"{{F.active.menuItem}}\" ng-if=\"!selected.length\" \nng-click=\'R.goToDetail(null, \"update\", {importId: \"new\"})\' aria-label=\"add\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">{{\'EC.ADD\' | translate}}\n</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon></md-button></md-fab-actions>\n</md-fab-speed-dial></div></div>");
$templateCache.put("app/main/config/views/involvedRecords/involvedRecord.html","<div id=\"involvedRecord\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill \nng-controller=\"InvolvedRecordController\"><form name=\"form\" novalidate flex layout=\"column\" ng-disabled=\"F.readMode\">\n<div fb-crud-detail-bar></div><md-content layout=\"column\" class=\"content\" flex><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\"><div layout=\"row\"><md-input-container \nclass=\"md-block\" flex><label>Nómina</label><md-select unique-fb ref=\"{{F.active.menuRef}}\" query=\"payroll\" \nfromid=\"{{involvedRecord.$id}}\" ms2-autofocus ng-model=\"involvedRecord.payroll\" name=\"payroll\" \nng-disabled=\"F.readMode\"><md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" \nng-keydown=\"$event.stopPropagation()\" ng-model=\"payrollSelectFilter\" placeholder=\"Busque una nómina\">\n</md-select-header><md-option ng-disabled=\"payrollsIsInvolved(payroll.$id)\" ng-value=\"payroll.$id\" \nng-repeat=\"payroll in L.allPayrolls | orderBy:\'name\' | filter:payrollSelectFilter\">{{payroll.name}}</md-option>\n</md-select><div ng-messages=\"form.payroll.$error\" ng-show=\"form.payroll.$touched\" role=\"alert\"><div \nng-message=\"unique\">Nómina ya está registrado</div></div></md-input-container></div><md-table-container><table \nmd-table class=\"row-border\" ng-style=\"{\'pointer-events\': (F.readMode)?\'none\':\'auto\'}\"><thead md-head md-order=\"order\" \nfix-head><tr md-row><th md-column md-order-by=\"name\"><span>Centro de Costo</span></th><th md-column><span>Usuarios\n</span></th></tr></thead><tbody md-body><tr md-row><td md-cell>Todos</td><td md-cell><md-chips \nng-model=\"involvedRecordUsers.all\" md-on-add=\"setInvolvedUser($chip,\'all\',true)\" \nmd-on-remove=\"setInvolvedUser($chip,\'all\',null)\" md-autocomplete-snap md-removable \nmd-transform-chip=\"transformChip($chip)\" ng-disabled=\"F.readMode\" md-require-match=\"true\"><md-autocomplete \nmd-selected-item=\"profile.$id\" md-menu-class=\"aucompleteInvolved\" md-search-text=\"searchProfile\" \nmd-items=\'profile in autocompleteProfiles(searchProfile, \"all\")\' md-item-text=\"profile.name\" \nplaceholder=\"Busque un usuario\"><span md-highlight-text=\"searchProfile\">\n{{profile.name}} ({{profile.firm | nameOfL: L.firms: F.center}})</span></md-autocomplete><md-chip-template><span>\n<strong>{{$chip | nameOfL: L.users}}</strong> <span class=\"blueC\">\n{{($chip | getSomethingOfArrayFB: L.users:\'firm\':\'N/A\') | nameOfL: L.firms: F.center}}</span></span></md-chip-template>\n</md-chips></td></tr><tr ng-class=\"{\'inactiveEmployee\': !cc.valid}\" md-row \nng-repeat=\"cc in L.payrollCcs[involvedRecord.payroll] | orderBy:order\"><td md-cell>\n{{cc.name}} [{{cc.rp_id|nameOfL:L.allRps}}]</td><td md-cell><md-chips ng-model=\"involvedRecordUsers[cc.$id]\" \nmd-on-add=\"setInvolvedUser($chip, cc.$id, true)\" md-on-remove=\"setInvolvedUser($chip, cc.$id, null)\" \nmd-autocomplete-snap md-removable ng-disabled=\"F.readMode\" md-transform-chip=\"transformChip($chip)\" \nmd-require-match=\"true\"><md-autocomplete md-selected-item=\"profile.$id\" md-search-text=\"searchProfile[cc.$id]\" \nmd-items=\"profile in autocompleteProfiles(searchProfile[cc.$id], cc.$id)\" md-item-text=\"profile.name\" md-no-cache \nplaceholder=\"Busque un usuario\"><span md-highlight-text=\"searchProfile\">\n{{profile.name}} ({{profile.firm | nameOfL: L.firms : profile.firm}})</span></md-autocomplete><md-chip-template><span>\n<strong>{{$chip | nameOfL: L.users}}</strong> <span class=\"blueC\">\n{{($chip | getSomethingOfArrayFB: L.users : \'firm\' : \'N/A\') | nameOfL : L.firms : ($chip | getSomethingOfArrayFB: L.users:\'firm\':\'N/A\')}}\n</span></span></md-chip-template></md-chips></td></tr></tbody></table></md-table-container></div></md-content></form>\n</div>");
$templateCache.put("app/main/config/views/involvedRecords/involvedRecords.html","<div id=\"involvedRecords\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div fb-search-bar></div><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><div \nfilter-toolbar></div><div table-loader array=\"involvedRecords\" validations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"involvedRecords.length\"><thead md-head \nmd-order=\"order\" fix-head><tr md-row><th md-column md-order-by=\"payroll\"><span>Nomina</span></th><th md-column><span>\nUsuarios</span></th></tr></thead><tbody md-body><tr md-row md-auto-select md-select=\"involvedRecord\" \nmd-select-id=\"$id\" \nng-repeat=\"involvedRecord in (F.filteredItems = (involvedRecords | filter:F.searchText.involvedRecord | orderBy:order)) | limitTo: F.paginate: (currentPage - 1) * F.paginate\">\n<td md-cell>{{involvedRecord[\'payroll-name\']}}</td><td md-cell>{{involvedRecord.payrollUsers | objectsLength}}</td>\n</tr></tbody></table></md-table-container><md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" \nlayout-xs=\"column\" ng-show=\"involvedRecords.length\" md-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" \nmd-limit-options=\"F.paginations\" md-page=\"currentPage\" md-on-paginate=\"restartSelected\" \nmd-total=\"{{F.filteredItems.length}}\" md-page-select></md-table-pagination></div></div><md-fab-speed-dial \nmd-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\"><md-fab-trigger>\n<md-button aria-label=\"crud menu\" class=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon>\n</md-button></md-fab-trigger><md-fab-actions><md-button with-permission action=\"read\" access=\"{{F.active.menuItem}}\" \nng-if=\"selected.length == 1\" ng-click=\'R.goToDetail(null, \"read\", {involvedRecordId: selected[0].$id})\' \naria-label=\"view\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Ver</md-tooltip>\n<md-icon md-font-icon=\"icon-eye\" aria-label=\"view\"></md-icon></md-button><md-button with-permission action=\"update\" \naccess=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" \nng-click=\'R.goToDetail(null, \"update\", {involvedRecordId: selected[0].$id})\' aria-label=\"edit\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Editar</md-tooltip><md-icon \nmd-font-icon=\"icon-pencil\" aria-label=\"edit\"></md-icon></md-button><md-button with-permission action=\"remove\" \naccess=\"{{F.active.menuItem}}\" ng-if=\"selected.length\" ng-click=\"delete($event)\" aria-label=\"Delete\" \nclass=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">{{\'EC.REMOVE\' | translate}}</md-tooltip>\n<md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button><md-button with-permission \naction=\"create\" access=\"{{F.active.menuItem}}\" ng-if=\"!selected.length\" \nng-click=\'R.goToDetail(null, \"update\", {involvedRecordId: \"new\"})\' aria-label=\"add\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">{{\'EC.ADD\' | translate}}\n</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon></md-button></md-fab-actions>\n</md-fab-speed-dial></div></div>");
$templateCache.put("app/main/config/views/incidences-types/incidences-type.html","<div id=\"incidencesType\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill \nng-controller=\"IncidencesTypeController\"><form name=\"form\" novalidate flex layout=\"column\" ng-disabled=\"F.readMode\">\n<div fb-crud-detail-bar></div><md-content layout=\"column\" class=\"content\" flex><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\"><div layout-gt-xs=\"row\"><md-input-container \nclass=\"md-block\" flex-gt-xs=\"30\"><label>Nómina</label><md-select ms2-autofocus ng-model=\"incidencesType.payroll\" \nrequired ng-disabled=\"!F.addMode\"><md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" \nng-keydown=\"$event.stopPropagation()\" ng-model=\"payrollSelectFilter\" placeholder=\"Busque una nómina\">\n</md-select-header><md-option value=\"global\">GLOBAL <small>PARA TODAS LAS NOMINAS</small></md-option><md-option \nng-if=\"!F.permissionToAccessAllPayrolls\" ng-value=\"payroll.$id\" \nng-repeat=\"payroll in L.payrolls | orderBy:\'name\' | filter:payrollSelectFilter\">{{payroll.name}}</md-option><md-option \nng-if=\"F.permissionToAccessAllPayrolls\" ng-value=\"payroll.$id\" \nng-repeat=\"payroll in L.allPayrolls | orderBy:\'name\' | filter:payrollSelectFilter\">{{payroll.name}}</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block\" flex><label>Nombre</label><input unique-fb \nref=\'{{\"lists/incidencesTypes/payroll/\" + incidencesType.payroll}}\' query=\"name\" fromid=\"{{incidencesType.$id}}\" \nclass=\"uppercased\" type=\"text\" ng-disabled=\"F.readMode\" name=\"name\" ng-model=\"incidencesType.name\" md-maxlength=\"200\" \nmaxlength=\"200\" ng-model-options=\"{ debounce: F.debounceTime }\" required><div ng-messages=\"form.name.$error\" \nng-show=\"form.name.$touched || form.name.$dirty\" role=\"alert\"><div ng-message=\"required\">\nNombre de tipo de Incidencia es requerido</div><div ng-message=\"maxlength\">\nNombre de tipo de Incidencia debe tener 200 carácteres de largo como máximo</div><div ng-message=\"unique\">\nNombre de tipo de Incidencia ya está registrado en Nómina</div></div></md-input-container></div><div \nlayout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex><label>ID</label><input ng-disabled=\"F.readMode\" \nclass=\"uppercased\" type=\"text\" name=\"internal_code\" ng-model=\"incidencesType.internal_code\" \nng-model-options=\"{ debounce: F.debounceTime }\" required></md-input-container><md-input-container \nclass=\"md-block md-icon-float\" flex><md-icon count-icon array=\"M.directives\"></md-icon><label>ID de la directiva\n</label><md-select ng-disabled=\"F.readMode\" ng-model=\"incidencesType.directive\" name=\"directive\"><md-select-header>\n<input autocomplete=\"off\" type=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" \nng-model=\"directiveSelectFilter\" placeholder=\"Busque un tipo de incidencia\"></md-select-header><md-option ng-value>\nNinguna</md-option><md-option ng-value=\"directive._id\" \nng-repeat=\"directive in M.directives | orderBy:\'name\' | filter: directiveSelectFilter\">\n{{directive._id}} - {{directive.name}}</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block md-icon-float\" flex><md-icon count-icon array=\"M.satIncidencesTypes\"></md-icon><label>\nIncidencia del SAT</label><md-select ng-disabled=\"F.readMode\" ng-model=\"incidencesType.satIncidencesType\" \nname=\"satIncidencesType\"><md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" \nng-keydown=\"$event.stopPropagation()\" ng-model=\"satIncidencesTypesSelectFilter\" \nplaceholder=\"Busque un tipo de incidencia\"></md-select-header><md-option ng-value>Ninguna</md-option><md-option \nng-if=\"!satIncidencesType.isConcept\" ng-value=\"satIncidencesType._id\" \nng-repeat=\"satIncidencesType in M.satIncidencesTypes | orderBy:\'name\' | filter: satIncidencesTypesSelectFilter\">\n{{satIncidencesType.sat_code}} - {{satIncidencesType.name}}</md-option></md-select></md-input-container></div><div \nlayout-gt-xs=\"row\" layout-wrap><md-input-container \nflex-gt-xs=\'{{(incidencesType.addFolio||incidencesType.confirmationType==\"file\"||!incidencesType.requireConfirmation)?33:25}}\' \nclass=\"md-input-has-placeholder md-block\" flex><label>Naturaleza</label><md-radio-group ng-disabled=\"F.readMode\" \nname=\"nature\" ng-model=\"incidencesType.nature\" ng-required=\"!incidencesType.satIncidenceType\"><md-radio-button \nvalue=\"deduction\">{{\'incidencesType.DEDUCTION\' | translate}}</md-radio-button><md-radio-button value=\"perception\">\n{{\'incidencesType.PERCEPTION\' | translate}}</md-radio-button></md-radio-group></md-input-container><md-input-container \nflex-gt-xs=\'{{(incidencesType.addFolio||incidencesType.confirmationType==\"file\"||!incidencesType.requireConfirmation)?33:25}}\' \nclass=\"md-input-has-placeholder md-block\" flex><label>Afecta</label><md-radio-group ng-disabled=\"F.readMode\" \nname=\"affect\" ng-model=\"incidencesType.affect\" ng-required=\"!incidencesType.satIncidenceType\" \nng-change=\"incidencesType.affect==\'days\'?incidencesType.customCalc=false:\'\'\"><md-radio-button value=\"days\">\n{{\'incidencesType.DAYS\' | translate}}</md-radio-button><md-radio-button value=\"salary\">\n{{\'incidencesType.SALARY\' | translate}}</md-radio-button></md-radio-group><md-checkbox \nng-if=\"incidencesType.affect==\'salary\'&&(!incidencesType.directive)\" ng-model=\"incidencesType.customCalc\" \naria-label=\"Need to Calculate\">Se calcula el valor</md-checkbox></md-input-container><md-input-container \nflex-gt-xs=\'{{(incidencesType.addFolio||incidencesType.confirmationType==\"file\"||!incidencesType.requireConfirmation)?33:25}}\' \nclass=\"md-input-has-placeholder md-block\" flex><label>Requiere confirmación</label><md-switch \nname=\"requireConfirmation\" aria-label=\"require confirmation\" class=\"md-secondary\" \nng-model=\"incidencesType.requireConfirmation\" ng-false-value=\"0\" \nng-change=\"checkRequireConfirmation(incidencesType.requireConfirmation)\" \nng-disabled=\"incidencesType.automatic||F.readMode\"></md-switch></md-input-container><md-input-container \nflex-gt-xs=\'{{incidencesType.confirmationType!=\"file\"?25:33}}\' ng-if=\"incidencesType.requireConfirmation\" \nclass=\"md-input-has-placeholder md-block\" flex><label>Tipo de confirmación</label><md-radio-group \nname=\"confirmationType\" ng-model=\"incidencesType.confirmationType\" ng-required=\"incidencesType.requireConfirmation\" \nng-change=\"checkConfirmationType(incidencesType.confirmationType)\" ng-disabled=\"incidencesType.automatic||F.readMode\">\n<md-radio-button value=\"justConfirm\">solo confirmación</md-radio-button><md-radio-button value=\"file\">archivo\n</md-radio-button></md-radio-group></md-input-container><md-input-container flex-gt-xs=\"33\" \nng-if=\"incidencesType.confirmationType==\'file\'\" class=\"md-input-has-placeholder md-block\" flex><label>Folio</label>\n<md-checkbox ng-model=\"incidencesType.addFolio\" aria-label=\"Folio Field\">Añadir Folio</md-checkbox><br><md-checkbox \nng-if=\"incidencesType.addFolio\" ng-model=\"incidencesType.uniqueFolio\" aria-label=\"Need to Calculate\">Folio Unico\n</md-checkbox><md-checkbox ng-if=\"incidencesType.addFolio\" ng-model=\"incidencesType.requiredFolio\" \naria-label=\"Need to Calculate\">Folio Requerido</md-checkbox></md-input-container><md-input-container flex-gt-xs=\"33\" \nng-if=\"incidencesType.addFolio\" class=\"md-block\" flex><label>Pattern Folio</label><input type=\"text\" \nng-disabled=\"F.readMode\" name=\"pattern\" ng-model=\"incidencesType.pattern\" \nng-model-options=\"{ debounce: F.debounceTime }\"></md-input-container></div><div layout-gt-xs=\"row\" layout-wrap>\n<md-input-container flex-gt-xs=\'{{incidencesType.nature==\"deduction\" ? 33 : 25}}\' \nclass=\"md-input-has-placeholder md-block\" flex><label>Automática</label><md-switch \nng-disabled=\"F.readMode||incidencesType.requireConfirmation\" aria-label=\"automatic incidence\" class=\"md-secondary\" \nng-model=\"incidencesType.automatic\" ng-false-value=\"0\"></md-switch></md-input-container><md-input-container \nflex-gt-xs=\'{{incidencesType.nature==\"deduction\" ? 33 : 25}}\' class=\"md-input-has-placeholder md-block\" flex><label>\nDisponible constante automatica</label><md-switch ng-disabled=\"F.readMode||incidencesType.requireConfirmation\" \naria-label=\"automatic incidence\" class=\"md-secondary\" ng-model=\"incidencesType.constant\" ng-false-value=\"0\">\n</md-switch></md-input-container><md-input-container flex-gt-xs=\'{{incidencesType.nature==\"deduction\" ? 33 : 25}}\' \nclass=\"md-input-has-placeholder md-block\" flex><label>Permitir añadir manualmente</label><md-switch \naria-label=\"allow manual incidence\" class=\"md-secondary\" ng-model=\"incidencesType.allowManual\" ng-false-value=\"0\" \nng-disabled=\"incidencesType.automatic||F.readMode||incidencesType.requireConfirmation\"></md-switch>\n</md-input-container><md-input-container flex-gt-xs=\'{{incidencesType.nature==\"deduction\" ? 50 : 25}}\' \nclass=\"md-input-has-placeholder md-block\" flex><label>Mostrar Total <small>[en sabana]</small></label><md-switch \nng-disabled=\"\r\n                                        F.readMode\" name=\"showTotal\" aria-label=\"show total\" \nclass=\"md-secondary\" ng-model=\"incidencesType.showTotal\" ng-false-value=\"0\"></md-switch></md-input-container>\n<md-input-container flex-gt-xs=\"50\" ng-show=\'incidencesType.nature==\"deduction\"\' \nclass=\"md-input-has-placeholder md-block\" flex><label>Disponible en amortizaciones</label><md-switch \nng-disabled=\"F.readMode||incidencesType.requireConfirmation\" name=\"amortizationAvailable\" \naria-label=\"Available for amortization\" class=\"md-secondary\" ng-model=\"incidencesType.amortizationAvailable\" \nng-false-value=\"0\"></md-switch></md-input-container></div></div></md-content></form></div>");
$templateCache.put("app/main/config/views/incidences-types/incidences-types.html","<div id=\"incidencesTypes\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\" \nng-controller=\"IncidencesTypesController\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" \nflex><div fb-search-bar></div><div class=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" \nlayout=\"column\" flex><div filter-toolbar></div><div table-loader array=\"allIncidencesTypes\" validations=\"validations\">\n</div><md-table-container class=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table \nmd-table md-row-select multiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"allIncidencesTypes.length\">\n<thead md-head md-order=\"order\" fix-head><tr md-row><th md-column md-order-by=\"payroll\"><span>Nómina</span></th><th \nmd-column md-order-by=\"name\"><span>Nombre</span></th><th md-column md-order-by=\"internal_code\"><span>ID</span></th><th \nmd-column md-order-by=\"nature\"><span>Naturaleza</span></th><th md-column><span>Global</span></th><th md-column hide \nshow-gt-xs md-order-by=\"satIncidencesType\"><span>Incidencia del SAT</span></th><th md-column hide show-gt-xs \nmd-order-by=\"directive\"><span>Directiva</span></th></tr></thead><tbody md-body><tr md-row md-auto-select \nmd-select=\"incidencesType\" md-select-id=\"$id\" \nng-repeat=\"incidencesType in (F.filteredItems = (allIncidencesTypes | filter:F.searchText.incidencesType | orderBy:order)) | limitTo: F.paginate: (currentPage - 1) * F.paginate\">\n<td md-cell>\n{{(incidencesType.payroll == \'global\') ? \'Global\' : (incidencesType.payroll | nameOfL:L.allPayrolls:\'N/A\')}}</td><td \nmd-cell>{{incidencesType.name}}</td><td md-cell>{{incidencesType.internal_code}}</td><td md-cell>\n{{(\'incidencesType.\'+(incidencesType.nature|uppercase)) | translate}}</td><td md-cell>\n{{incidencesType.payroll==\"global\"?\"SI\":\"NO\"}}</td><td md-cell hide show-gt-xs>{{incidencesType.satIncidencesType}}\n</td><td md-cell hide show-gt-xs>{{incidencesType.directive}}</td></tr></tbody></table></md-table-container>\n<md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" \nng-show=\"allIncidencesTypes.length\" md-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" \nmd-limit-options=\"F.paginations\" md-page=\"currentPage\" md-on-paginate=\"restartSelected\" \nmd-total=\"{{F.filteredItems.length}}\" md-page-select></md-table-pagination></div></div><md-fab-speed-dial \nmd-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\"><md-fab-trigger>\n<md-button aria-label=\"crud menu\" class=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon>\n</md-button></md-fab-trigger><md-fab-actions><md-button with-permission action=\"read\" access=\"{{F.active.menuItem}}\" \nng-if=\"selected.length == 1\" \nng-click=\'R.goToDetail(null, \"read\", {incidencesTypeId: selected[0].$id, payrollId: selected[0].payroll})\' \naria-label=\"view\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Ver</md-tooltip>\n<md-icon md-font-icon=\"icon-eye\" aria-label=\"view\"></md-icon></md-button><md-button with-permission action=\"update\" \naccess=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" \nng-click=\'R.goToDetail(null, \"update\", {incidencesTypeId: selected[0].$id, payrollId: selected[0].payroll})\' \naria-label=\"edit\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Editar\n</md-tooltip><md-icon md-font-icon=\"icon-pencil\" aria-label=\"edit\"></md-icon></md-button><md-button with-permission \naction=\"remove\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" \nng-click=\"deleteIfDoesnHaveIncidences($event, selected[0])\" aria-label=\"Delete\" \nclass=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">{{\'EC.REMOVE\' | translate}}</md-tooltip>\n<md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button><md-button with-permission \naction=\"create\" access=\"{{F.active.menuItem}}\" ng-if=\"!selected.length\" \nng-click=\'R.goToDetail(null, \"update\", {incidencesTypeId: \"new\"})\' aria-label=\"add\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">{{\'EC.ADD\' | translate}}\n</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon></md-button><md-button with-permission \naction=\"copy\" access=\"{{F.active.menuItem}}\" aria-label=\"copy\" ng-click=\"showPayrollModal($event,\'payrolls\')\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">{{\'EC.COPY\' | translate}}\n</md-tooltip><md-icon md-font-icon=\"icon-transfer\" aria-label=\"copy\"></md-icon></md-button><md-button with-permission \naction=\"copy\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length\" aria-label=\"copy\" \nng-click=\"showPayrollModal($event,\'payroll\')\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip \nmd-direction=\"left\">{{\'EC.COPYINCIDENCES\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-transfer\" \naria-label=\"copy\"></md-icon></md-button></md-fab-actions></md-fab-speed-dial></div></div>");
$templateCache.put("app/main/config/views/operationConstants/operationConstant.html","<div id=\"operationConstant\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill \nng-controller=\"OperationConstantController\"><form name=\"form\" novalidate flex layout=\"column\" ng-disabled=\"F.readMode\">\n<md-toolbar class=\"md-tall header md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" \nlayout=\"row\" layout-align=\"start center\" flex><md-button class=\"goto-button md-icon-button\" with-permission \naccess=\"{{F.active.menuItem}}\" action=\"access\" aria-label=\"Go to list\" ng-click=\"R.goToList()\" translate \ntranslate-attr-aria-label=\"EC.GO_TO\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"{{F.menuItems.config.operationConstants.icon}}\" class=\"crud-icon\">\n</md-icon><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\">\n{{operationConstant.incidencesType | nameOfM:M.incidencesTypes}}</div><div class=\"subtitle secondary-text\"><span \nng-if=\"!F.addMode\">{{\'EC.DETAIL_OF\' | translate}} {{\'operationConstant.SINGULAR\' | translate}}</span> <span \nng-if=\"F.addMode\">{{\'EC.CREATE\' | translate}} {{\'operationConstant.SINGULAR\' | translate}}</span></div></div></div>\n</div><div><md-button type=\"submit\" ng-if=\"!F.addMode\" with-permission action=\"update\" access=\"{{F.active.menuItem}}\" \nng-click=\"save(operationConstant)\" ng-hide=\"form.$pristine\" ng-disabled=\"form.$invalid || loadingProgress\" \nclass=\"md-raised md-background md-fab md-accent md-hue-1\" aria-label=\"Save operationConstant\"><md-tooltip \nmd-direction=\"left\">{{\'EC.SAVE\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-content-save\" aria-label=\"Save\">\n</md-icon></md-button><md-button type=\"submit\" ng-if=\"F.addMode\" with-permission action=\"create\" \naccess=\"{{F.active.menuItem}}\" ng-click=\"add(operationConstant)\" ng-hide=\"form.$pristine\" \nng-disabled=\"form.$invalid || loadingProgress\" class=\"md-raised md-background md-fab md-accent md-hue-1\" \naria-label=\"Add operationConstant\"><md-tooltip md-direction=\"left\">{{\'EC.ADD\' | translate}}</md-tooltip><md-icon \nmd-font-icon=\"icon-content-save\" aria-label=\"Add\"></md-icon></md-button></div></md-toolbar><md-content layout=\"column\" \nclass=\"content\" flex><div class=\"detail-form-container md-background-bg md-whiteframe-1dp\"><div layout-gt-xs=\"row\"><div\n ng-if=\'[\"payroll\",\"cc\"].indexOf(operationConstant.type)>-1\' flex layout=\"column\"><md-input-container \nclass=\"md-block md-icon-float\" flex-gt-xs=\"nogrow\" md-no-float><label>Nómina</label><md-select class=\"filter\" \nng-disabled=\"F.readMode\" ng-model=\"F.operationConstantsSearch.payroll\" \nng-change=\'F.operationConstantsSearch.cc=\"\"; incidencesTypes(F.operationConstantsSearch)\' required><md-select-header>\n<input autocomplete=\"off\" type=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" \nng-model=\"payrollSelectFilter\" placeholder=\"Busque una nomina\"></md-select-header><md-option \nng-if=\"!F.permissionToAccessAllPayrolls && (F.readMode || (!F.readMode && payroll.active))\" ng-value=\"payroll.$id\" \nng-repeat=\"payroll in L.payrolls | orderBy:\'name\' | filter:payrollSelectFilter\">{{payroll.name}}</md-option><md-option \nng-if=\"F.permissionToAccessAllPayrolls && (F.readMode || (!F.readMode && payroll.active))\" ng-value=\"payroll.$id\" \nng-repeat=\"payroll in L.allPayrolls | orderBy:\'name\' | filter:payrollSelectFilter\">{{payroll.name}}</md-option>\n</md-select></md-input-container></div><div ng-if=\'[\"cc\"].indexOf(operationConstant.type)>-1\' flex><md-input-container \nclass=\"md-block md-icon-float\" flex-gt-xs md-no-float><label>Centro de Costo</label><md-select class=\"filter\" \nng-model=\"F.operationConstantsSearch.cc\" name=\"cc\" required><md-select-header><input autocomplete=\"off\" type=\"search\" \nclass=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"ccSelectFilter\" \nplaceholder=\"Busque un Centro de Costo\"></md-select-header><md-option ng-disabled=\"!cc.valid\" ng-value=\"cc.$id \" \nng-repeat=\"cc in L.payrollCcs[F.operationConstantsSearch.payroll] | orderBy:\'name\' | filter:ccSelectFilter\">\n{{cc.name}} [{{cc.rp_id|nameOfL:L.rps}}]</md-option></md-select><div class=\"md-errors-spacer\"></div><div \nng-messages=\"form.cc.$error\" role=\"alert\"><div ng-message=\"required\">El centro de costo es requerido</div></div>\n</md-input-container></div><div ng-if=\'[\"employee\"].indexOf(operationConstant.type)>-1\' flex><md-autocomplete \nclass=\"md-block employee\" md-min-length=\"2\" md-selected-item=\"employeeSelected\" md-search-text=\"searchQuery\" \nmd-selected-item-change=\"F.operationConstantsSearch.employee=item.$id\" md-item-text=\"item.data.name\" md-delay=\"500\" \nmd-items=\'item in autocompleteListM(searchQuery, \"employees\",[\"data.name\",\"data.nss\"])\' md-require-match=\"true\" \nmd-select-on-match=\"true\" md-match-case-insensitive=\"true\" md-input-name=\"employee\" placeholder=\"Empleado\" \nmd-no-cache=\"true\" md-floating-label=\"Empleado\"><md-item-template><span md-highlight-text=\"searchQuery\">\n{{item.data.nss?item.data.nss+\' - \':\'\'}}{{item.data.name}}</span></md-item-template><md-not-found>No hay registros\n</md-not-found><div ng-messages=\"form.employee.$error\"><div ng-message=\"required\">El empleado es requerido</div></div>\n</md-autocomplete></div></div><div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex md-no-float><label>\nTipo de constante</label><md-select ng-model=\"operationConstant.constantType\" name=\"constantType\" \narial-label=\"constant type\" placeholder=\"Tipo de Constante\" ng-change=\"showCalcField(operationConstant.constantType)\" \nrequired><md-option with-permission access=\"{{F.active.menuItem}}\" action=\"{{id}}\" \nng-if=\"type.forOpeConstants && ((!type.onlyOn) || type.onlyOn.indexOf(operationConstant.type)>-1)\" \nng-disabled=\"type.disabled\" ng-value=\"id\" ng-repeat=\"(id, type) in F.constantTypes\">{{type.name}}</md-option>\n</md-select><div class=\"md-errors-spacer\"></div><div ng-messages=\"form.constantType.$error\" role=\"alert\"><div \nng-message=\"required\">El tipo de constante es requerido</div></div></md-input-container><md-input-container \nclass=\"md-block\" ng-if=\"!showField\" flex><label>Incidencia</label><md-select \nng-model=\"operationConstant.incidencesType\" aria-label=\"operationConstant incidenceType\" name=\"incidencesType\" \nandfilter=\"{{uniqueFilter}}\" unique-fb ref=\"catalogs/operationConstants/collection\" query=\"incidencesType\" required \nfromid=\"{{operationConstant.$id}}\"><md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" \nng-keydown=\"$event.stopPropagation()\" ng-model=\"incidencesTypeSelectFilter\" placeholder=\"Busque un tipo de incidencia\">\n</md-select-header><md-option \nng-if=\"[\'applyVariable\',\'notApplyVariable\'].indexOf(operationConstant.constantType) > -1\" \nng-value=\"incidencesType.$id\" ng-class=\"{\'inactiveOption\': incidencesType.nature === \'deduction\'}\" \nng-repeat=\"incidencesType in incidencesTypesF | filter : {nature:\'perception\'} | orderBy: [\'nature\',\'name\'] | filter:incidencesTypeSelectFilter\">\n{{incidencesType.name}}</md-option><md-option \nng-if=\"[\'applyVariable\',\'notApplyVariable\'].indexOf(operationConstant.constantType) == -1\" \nng-value=\"incidencesType.$id\" ng-class=\"{\'inactiveOption\': incidencesType.nature === \'deduction\'}\" \nng-repeat=\"incidencesType in incidencesTypesF | filter : {constant:true} | orderBy: [\'nature\',\'name\'] | filter:incidencesTypeSelectFilter\">\n{{incidencesType.name}}</md-option></md-select><div ng-messages=\"form.incidencesType.$error\" role=\"alert\"><div \nng-message=\"required\">Tipo de incidencia es requerido</div><div ng-message=\"unique\">\nTipo de incidencia ya está registrado bajo éste nivel</div></div></md-input-container></div><code class=\"help\" \nng-show=\'operationConstant.constantType && operationConstant.constantType!==\"customField\"\'><p>\n{{F.constantTypes[operationConstant.constantType].description}}</p></code><div layout-gt-xs=\"row\" layout-wrap \nng-if=\"showField\"><md-input-container class=\"md-block\" flex=\"50\"><label>Campo</label><md-select \nng-model=\"operationConstant.customField.key\" aria-label=\"operationConstant customField key\" name=\"key\" \nandfilter=\"{{uniqueFilter}}\" unique-fb ref=\"catalogs/operationConstants/collection\" query=\"incidencesType\" required \nfromid=\"{{operationConstant.$id}}\"><md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" \nng-keydown=\"$event.stopPropagation()\" ng-model=\"customFieldSelectFilter\" placeholder=\"Busque un campo\">\n</md-select-header><md-option ng-value=\"customField.key\" \nng-repeat=\"customField in thisFields | filter:customFieldSelectFilter\">{{customField.name}} ({{customField.key}})\n</md-option></md-select><div ng-messages=\"form.incidencesType.$error\" role=\"alert\"><div ng-message=\"required\">\nTipo de incidencia es requerido</div><div ng-message=\"unique\">Tipo de incidencia ya está registrado bajo éste nivel\n</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><input type=\"number\" name=\"value\" \nng-model=\"operationConstant.customField.value\" placeholder=\"Valor\" ng-disabled=\"F.readMode\" required><div \nng-messages=\"form.value.$error\" role=\"alert\"><div ng-message=\"required\">El valor es requerido</div></div>\n</md-input-container><code class=\"help\" flex=\"100\"><p>\n{{operationConstant.customField.key | getSomethingOfArrayFB : C.customFields : \'description\' : \'Sin descripción\' : \'key\'}}.\n</p></code></div><div flex><div layout=\"column\" ng-if=\'operationConstant.constantType == \"automaticApply\"\' flex><div \nflex layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex md-no-float><label>Cada</label><md-select \nms2-autofocus ng-model=\"operationConstant.automaticApply.each\" name=\"each\" placeholder=\"Cada\" required><md-option \nng-value=\'\"period\"\'>Periodo</md-option><md-option ng-value=\'\"startOfMonth\"\'>Inicio del Mes</md-option><md-option \nng-value=\'\"endOfMonth\"\'>Fin del Mes</md-option><md-option ng-value=\'\"employeeBirthday\"\'>Cumpleaños de empleado\n</md-option><md-option ng-value=\'\"employeeAniversary\"\'>Aniversario de empleado</md-option></md-select><div \nclass=\"md-errors-spacer\"></div><div ng-messages=\"form.each.$error\" role=\"alert\"><div ng-message=\"required\">\nCada es requerido</div></div></md-input-container><md-input-container \nng-if=\'operationConstant.automaticApply.each == \"days\"\' class=\"md-block\" flex><label>Días</label><input type=\"number\" \nng-model=\"operationConstant.automaticApply.days\" required></md-input-container><md-input-container class=\"md-block\" \nflex><label>Valor</label><input type=\"text\" ng-model=\"operationConstant.automaticApply.value\" name=\"value\" required>\n<div ng-messages=\"form.value.$error\" role=\"alert\"><div ng-message=\"required\">Valor es requerido</div></div>\n</md-input-container></div><div flex layout-gt-xs=\"row\"><md-input-container flex class=\"md-block date-picker from\">\n<label>Desde</label><md-datepicker md-hide-icons=\"triangle\" input-date-miliseconds md-min-date=\"minDate\" \nng-model=\"operationConstant.automaticApply.from\" name=\"from\" class=\"md-block\"></md-datepicker></md-input-container>\n<md-input-container flex class=\"md-block date-picker\"><label>Hasta</label><md-datepicker md-hide-icons=\"triangle\" \ninput-date-miliseconds md-min-date=\"minDate\" ng-model=\"operationConstant.automaticApply.to\" name=\"to\" class=\"md-block\">\n</md-datepicker></md-input-container></div><code class=\"help\" \nng-if=\"!operationConstant.automaticApply.from || !operationConstant.automaticApply.to\"><p \nng-show=\"!operationConstant.automaticApply.from\">\nSi no se selecciona una fecha de inicio, se aplicará automaticamente a partir del próximo periodo aplicable.</p><p \nng-show=\"!operationConstant.automaticApply.to\">\nSi no se selecciona una fecha de fin, se aplicará automaticamente infinitamente cada periodo aplicable.</p></code>\n</div><div layout-gt-sm=\"row\" ng-if=\'operationConstant.constantType == \"notApply\"\' flex><md-input-container \nclass=\"md-input-has-placeholder md-block\" flex><label>No aplicar</label><br><md-checkbox \nng-model=\"operationConstant.notApply.automatic\" aria-label=\"Incidencias Automáticas\" ng-true-value=\"true\" \nclass=\"md-warn md-align-bottom-left\">Incidencias Automáticas</md-checkbox><md-checkbox \nng-model=\"operationConstant.notApply.manual\" aria-label=\"Incidencias Manuales\" ng-true-value=\"true\" \nclass=\"md-warn md-align-bottom-left\">Incidencias Manuales y por Request</md-checkbox><md-checkbox \nng-model=\"operationConstant.notApply.fast\" aria-label=\"Incidencias Rápidas\" ng-true-value=\"true\" \nclass=\"md-warn md-align-bottom-left\">Incidencias Rápidas (solo en sábana)</md-checkbox></md-input-container></div>\n</div></div></md-content></form></div>");
$templateCache.put("app/main/config/views/operationConstants/operationConstants.html","<div id=\"operationConstants\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\" \nng-controller=\"OperationConstantsController\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" \nlayout=\"column\" flex><div fb-search-bar></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><md-tabs ng-show=\"anyHasPermission\"><md-tab \nng-repeat=\"tab in F.active.tabs\" md-active=\"F.search.$type==tab\" ng-disabled=\"!permissions[tab]\" \nlabel=\"{{(F.active.menuObjName + \'.\' + tab) | translate}}\" md-on-select=\"tabChanged(tab)\"></md-tab></md-tabs><div \nng-show=\"anyHasPermission\"><div flex class=\"filterToolbar md-padding\" layout-gt-xs=\"row\" layout-align=\"end center\"><div\n flex><md-input-container class=\"md-block md-icon-float\" flex-gt-xs=\"nogrow\" md-no-float><label>Tipo de constante\n</label><md-select class=\"filter\" ng-model=\"F.operationConstantsSearch.constantType\"><md-select-header><input \nautocomplete=\"off\" type=\"search\" id=\"searchConstantType\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" \nng-model=\"constantTypeSelectFilter\" placeholder=\"Busque un tipo de constante\"></md-select-header><md-option \nng-value=\"undefined\">Todos</md-option><md-option ng-value=\"{data:{incidencesType:incidencesType.$id}}\" \nng-repeat=\"incidencesType in L.incidencesTypes | orderBy:\'name\' | filter:constantTypeSelectFilter\">\n{{incidencesType.name}} <small>(Tipo de incidencia)</small></md-option><md-option \nng-value=\"{data:{\'customField.key\':customField.key}}\" \nng-repeat=\"customField in C.customFields | orderBy:\'name\' | filter:constantTypeSelectFilter\">{{customField.name}} \n<small>(Campo personalizado)</small></md-option></md-select></md-input-container></div><div \nng-if=\'[\"payroll\",\"cc\",\"employee\"].indexOf(F.search.$type)>-1\' flex><md-input-container class=\"md-block md-icon-float\" \nflex-gt-xs=\"nogrow\" md-no-float><label>Nómina</label><md-select class=\"filter\" \nng-model=\"F.operationConstantsSearch.payroll\"><md-select-header><input autocomplete=\"off\" type=\"search\" \nclass=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"payrollSelectFilter\" placeholder=\"Busque una nomina\">\n</md-select-header><md-option ng-if=\"F.permissionToAccessAllPayrolls\" ng-value=\"false\">Todas</md-option><md-option \nng-if=\"!F.permissionToAccessAllPayrolls\" ng-class=\"{\'inactiveOption\': !payroll.active}\" ng-value=\"payroll.$id\" \nng-repeat=\"payroll in L.payrolls | orderBy:\'name\' | filter:payrollSelectFilter\">{{payroll.name}}</md-option><md-option \nng-if=\"F.permissionToAccessAllPayrolls\" ng-value=\"payroll.$id\" ng-class=\"{\'inactiveOption\': !payroll.active}\" \nng-repeat=\"payroll in L.allPayrolls | orderBy:\'name\' | filter:payrollSelectFilter\">{{payroll.name}}</md-option>\n</md-select></md-input-container></div><div ng-if=\'[\"cc\"].indexOf(F.search.$type)>-1\' flex><md-input-container \nclass=\"md-block md-icon-float\" flex-gt-xs md-no-float><label>Centro de Costo</label><md-select class=\"filter\" \nng-model=\"F.operationConstantsSearch.cc\"><md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" \nng-keydown=\"$event.stopPropagation()\" ng-model=\"ccSelectFilter\" placeholder=\"Busque un Centro de Costo\">\n</md-select-header><md-option ng-value=\"false\">Todas</md-option><md-option ng-value=\"cc.$id \" \nng-class=\"{\'inactiveOption\': !cc.valid}\" \nng-repeat=\"cc in L.payrollCcs[F.operationConstantsSearch.payroll] | orderBy:\'name\' | filter:ccSelectFilter\">{{cc.name}}\n</md-option></md-select></md-input-container></div><div ng-if=\'[\"employee\"].indexOf(F.search.$type)>-1\' flex>\n<md-autocomplete class=\"md-block\" md-min-length=\"2\" md-selected-item=\"employeeSelected\" md-search-text=\"searchQuery\" \nmd-selected-item-change=\"F.operationConstantsSearch.employee=item.$id\" md-item-text=\"item.data.name\" md-delay=\"500\" \nmd-items=\'item in autocompleteMongo(searchQuery, \"employees\",[\"data.name\",\"data.nss\"])\' md-require-match=\"true\" \nmd-select-on-match=\"true\" md-match-case-insensitive=\"true\" placeholder=\"Empleado\" md-no-cache=\"true\" \nmd-floating-label=\"Empleado\"><md-item-template><span md-highlight-text=\"searchQuery\">\n{{item.data.nss?item.data.nss+\' - \':\'\'}}{{item.data.name}}</span> <b>{{\'(\'+ item.center +\')\'}}</b></md-item-template>\n<md-not-found>No hay registros</md-not-found></md-autocomplete></div></div></div><div table-loader \narray=\"operationConstants\" validations=\"validations\"></div><md-table-container ng-show=\"anyHasPermission\" \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"F.filteredItems.length\"><thead md-head \nmd-order=\"order\" fix-head><tr md-row><th ng-if=\'[\"payroll\",\"cc\",\"employee\"].indexOf(F.search.$type)>-1\' md-column \nmd-order-by=\"name\">Nombre</th><th ng-if=\'F.search.$type==\"employee\" || F.search.$type==\"cc\"\' md-column \nmd-order-by=\'\"payrollName-name\"\'>Nomina</th><th ng-if=\'F.search.$type==\"employee\"\' md-column \nmd-order-by=\'\"ccName-name\"\'>CC</th><th md-column md-order-by=\"constantType\"><span>Tipo de constante</span></th><th \nmd-column>Tipo de incidencia</th><th md-column>Valor</th></tr></thead><tbody md-body><tr md-row md-auto-select \nmd-select=\"operationConstant\" md-select-id=\"$id\" \nng-repeat=\'operationConstant in (F.filteredItems = (Z.operationConstants | filter:F.searchText[F.active.menuObjName]|filter:([\"cc\",\"employee\"].indexOf(F.search.$type)>-1 && F.operationConstantsSearch.payroll?{payroll:F.operationConstantsSearch.payroll}:{}) | orderBy:order)) | limitTo: F.paginate: (currentPage - 1) * F.paginate\'>\n<td md-cell ng-if=\'[\"payroll\",\"cc\",\"employee\"].indexOf(F.search.$type)>-1\'>{{operationConstant.name}}</td><td md-cell \nng-if=\'F.search.$type==\"employee\" || F.search.$type==\"cc\"\'>{{operationConstant[\'payrollName-name\']}}</td><td md-cell \nng-if=\'F.search.$type==\"employee\"\'>{{operationConstant[\'ccName-name\']}}</td><td md-cell>\n{{F.constantTypes[operationConstant.constantType].name}}</td><td md-cell><span \nng-if=\"operationConstant.constantType===\'customField\'\">\n{{operationConstant.customField.key | getSomethingOfArrayFB : C.customFields : \'name\' : \'N/A\' : \'key\'}}</span> <span \nng-if=\"operationConstant.constantType!==\'customField\'\">{{operationConstant.incidencesType | nameOfL:L.incidencesTypes}}\n</span></td><td md-cell><span ng-if=\"operationConstant.constantType===\'customField\'\">\n{{operationConstant.customField.value}}</span> <span ng-if=\"operationConstant.constantType!==\'customField\'\">\n{{operationConstant.automaticApply.value}}</span></td></tr></tbody></table></md-table-container><md-table-pagination \nng-show=\"anyHasPermission\" layout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" \nng-show=\"F.filteredItems.length\" md-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" \nmd-limit-options=\"F.paginations\" md-page=\"currentPage\" md-on-paginate=\"restartSelected\" \nmd-total=\"{{F.filteredItems.length}}\" md-page-select></md-table-pagination><div ng-hide=\"anyHasPermission\" \nlayout-align=\"center center\" class=\"md-accent noData\"><h1 class=\"md-subhead\">\nNo tiene permiso para acceder a este modulo</h1></div></div></div><md-fab-speed-dial ng-show=\"anyHasPermission\" \nmd-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\" \nng-mouseenter=\"isOpen=true\" ng-mouseleave=\"isOpen=false\"><md-fab-trigger><md-button aria-label=\"crud menu\" \nclass=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon></md-button></md-fab-trigger>\n<md-fab-actions><md-button with-permission action=\"read\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" \nng-click=\'R.goToDetail(null, \"read\", {operationConstantId: selected[0].$id})\' aria-label=\"view\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Ver</md-tooltip><md-icon \nmd-font-icon=\"icon-eye\" aria-label=\"view\"></md-icon></md-button><md-button action=\"export\" \naccess=\"{{F.active.menuItem}}\" ng-click=\"exportDataToExcel(F.filteredItems,null,currentPage,F.paginate)\" \naria-label=\"export\" class=\"md-fab md-raised md-mini md-primary md-hue-2\"><md-tooltip md-direction=\"left\">\nExportar a excel</md-tooltip><md-icon md-font-icon=\" icon-file-excel\" aria-label=\"export\"></md-icon></md-button>\n<md-button with-permission action=\"update\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" \nng-click=\'R.goToDetail(null, \"update\", {operationConstantId: selected[0].$id})\' aria-label=\"Edit\" \nclass=\"md-fab md-raised md-accent md-hue-2 md-mini\"><md-tooltip md-direction=\"left\">{{\'EC.EDIT\' | translate}}\n</md-tooltip><md-icon md-font-icon=\"icon-pencil\" aria-label=\"Edit\"></md-icon></md-button><md-button with-permission \naction=\"remove\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length\" ng-click=\"delete($event)\" aria-label=\"Delete\" \nclass=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">{{\'EC.REMOVE\' | translate}}</md-tooltip>\n<md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button><md-button with-permission \naction=\"create\" access=\"{{F.active.menuItem}}\" ng-if=\"!selected.length\" \nng-click=\'R.goToDetail(null, \"update\", {operationConstantId: \"new\"})\' aria-label=\"add\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">{{\'EC.ADD\' | translate}}\n</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon></md-button><md-button with-permission \naction=\"import\" access=\"{{F.active.menuItem}}\" ng-show=\"!selected.length\" \nng-click=\"importOperationConstantsModal($event)\" aria-label=\"importIncidences\" \nclass=\"md-fab blue-900-bg md-mini md-primary md-hue-3\"><md-tooltip md-direction=\"left\">Importar Constantes de Operación\n</md-tooltip><md-icon md-svg-src=\"/assets/icons/import2.svg\" aria-label=\"import variables\"></md-icon></md-button>\n</md-fab-actions></md-fab-speed-dial></div></div>");
$templateCache.put("app/main/config/views/paymentSchemas/paymentSchema.html","<div id=\"paymentSchema\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill \nng-controller=\"PaymentSchemaController\"><form name=\"form\" novalidate flex layout=\"column\" ng-disabled=\"F.readMode\">\n<md-toolbar class=\"md-tall header md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" \nlayout=\"row\" layout-align=\"start center\" flex><md-button with-permission access=\"{{F.active.menuItem}}\" \naction=\"access\" class=\"goto-button md-icon-button\" aria-label=\"Go to paymentSchemas\" \nng-click=\"R.goToList(F.active.menuName, F.active.menuParams)\" translate translate-attr-aria-label=\"EC.GO_TO\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" layout-align=\"start center\"><md-icon \nclass=\"crud-icon\" md-font-icon=\"{{F.menuItems.config.paymentSchemas.icon}}\"></md-icon><div layout=\"column\" \nlayout-align=\"start start\"><div class=\"h2\">{{paymentSchema.data.name}}</div><div class=\"subtitle secondary-text\"><span \nng-if=\"!F.addMode\">{{\'EC.DETAIL_OF\' | translate}} {{\'paymentSchema.SINGULAR\' | translate}}</span> <span \nng-if=\"F.addMode\">{{\'EC.CREATE\' | translate}} {{\'paymentSchema.SINGULAR\' | translate}}</span></div></div></div></div>\n<div><md-button type=\"submit\" ng-if=\"!F.addMode && !F.readMode\" with-permission action=\"update\" \naccess=\"{{F.active.menuItem}}\" ng-click=\"savePrepared(paymentSchema)\" ng-hide=\"form.$pristine\" \nng-disabled=\"form.$invalid || loadingProgress\" class=\"md-raised md-background md-fab md-accent md-hue-1\" \naria-label=\"Save paymentSchema\"><md-tooltip md-direction=\"left\">{{\'EC.SAVE\' | translate}}</md-tooltip><md-icon \nmd-font-icon=\"icon-content-save\" aria-label=\"Save\"></md-icon></md-button><md-button type=\"submit\" ng-if=\"F.addMode\" \nwith-permission action=\"create\" access=\"{{F.active.menuItem}}\" ng-click=\"addPrepared(paymentSchema)\" \nng-hide=\"form.$pristine\" ng-disabled=\"form.$invalid || loadingProgress\" \nclass=\"md-raised md-background md-fab md-accent md-hue-1\" aria-label=\"Add paymentSchema\"><md-tooltip \nmd-direction=\"left\">{{\'EC.ADD\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-content-save\" aria-label=\"Add\">\n</md-icon></md-button></div></md-toolbar><md-content layout=\"column\" class=\"content\" flex><md-tabs \nmd-selected=\"selectedTab\" flex class=\"scrollable\"><md-tab label=\"real\"><md-tab-body><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\" layout=\"column\"><md-input-container \nclass=\"md-block mb-0\" flex><label>Nombre del Esquema de Pago</label><input unique-fb query=\"data/name\" \nng-disabled=\"F.readMode\" ref=\"{{F.active.menuRef}}\" fromid=\"{{paymentSchema.$id}}\" ms2-autofocus class=\"uppercased\" \ntype=\"text\" name=\"name\" ng-model=\"paymentSchema.data.name\" ng-model-options=\"{ debounce: F.debounceTime }\" \nmd-maxlength=\"40\" maxlength=\"40\" required><div ng-messages=\"form.name.$error\" \nng-show=\"form.name.$touched || form.name.$dirty\" role=\"alert\"><div ng-message=\"required\">Nombre es requerido</div><div \nng-message=\"unique\">Nombre ya está registrado</div><div ng-message=\"maxlength\">Nombre no debe ser mayor a 40 caracteres\n</div></div></md-input-container><md-input-container class=\"md-block\" flex><label>Proceso de configuración</label>\n<md-select ng-model=\"paymentSchema.processesConfigId\" name=\"processesConfigId\" ng-disabled=\"F.readMode\" required>\n<md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" \nng-model=\"processesSelectFilter\" placeholder=\"Busque un proceso\"></md-select-header><md-option \nng-value=\"processConfig.$id\" \nng-repeat=\"processConfig in processesConfig | orderBy:\'name\' | filter:processesSelectFilter\">{{processConfig.name}}\n</md-option></md-select><div ng-messages=\"form.processesConfigId.$error\" role=\"alert\"><div ng-message=\"required\">\nEl proceso de configuración es requerido</div></div></md-input-container><md-input-container class=\"md-block\" flex>\n<label>Descripción</label><textarea ng-disabled=\"F.readMode\" class=\"uppercased\" rows=\"3\" name=\"description\" \nng-model=\"paymentSchema.description\" md-maxlength=\"500\" maxlength=\"500\" \nng-model-options=\"{ debounce: F.debounceTime }\"></textarea><div ng-messages=\"form.description.$error\" role=\"alert\"><div\n ng-message=\"maxlength\">La descripción no debe tener más de 150 caracteres</div></div></md-input-container><div \nlayout=\"row\" flex><div flex><h3>Proceso Real</h3></div></div><h4 class=\"placeholder\">Conceptos</h4><div \nclass=\"idsConcept\"><ids-object model=\"paymentSchema.data.processes.real.concepts\" items=\"nitConcepts\" \nread-only=\"F.readMode\" allow-order=\"true\" object-name=\"concepts\" form=\"form\" payrolls=\"payrollsData\" \nshow-on-report=\"true\" show-hidden-column=\"true\"></ids-object></div><h4 class=\"placeholder\">Totales</h4><div \nclass=\"idsConcept\"><ids-object model=\"paymentSchema.data.processes.real.totals\" items=\"allSchemaConcepts\" \nread-only=\"F.readMode\" allow-order=\"true\" object-name=\"totals\" form=\"form\" input-field-name=\"Campo\" \ninput-field-id=\"field\" input-name=\"Nombre\" input-id=\"name\" input-operation-name=\"Operación\" \ninput-operation-id=\"operation\" show-hidden-column=\"false\"></ids-object></div><h4 class=\"placeholder\">Campos extras</h4>\n<div class=\"idsConcept\"><ids-object model=\"paymentSchema.data.processes.real.extras\" items=\"nitConcepts\" \nread-only=\"F.readMode\" allow-order=\"true\" object-name=\"extras\" form=\"form\" input-name=\"Nombre\" input-id=\"name\" \nshow-hidden-column=\"false\"></ids-object></div></div></md-tab-body></md-tab><md-tab label=\"fiscal\"><md-tab-body><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\" layout=\"column\"><div layout=\"row\" \nlayout-align=\"start center\" flex><div flex><h3>Proceso Fiscal</h3></div><div flex=\"nogrow\"><md-switch \nng-disabled=\"F.readMode\" class=\"md-secondary pr-5\" name=\"processes_fiscal\" \nng-model=\"paymentSchema.data.processes.fiscal.active\" aria-label=\"proceso fiscal\">Activado</md-switch></div><div \nflex=\"nogrow\"><md-switch ng-disabled=\"F.readMode\" class=\"md-secondary\" name=\"processes_fiscal\" \nng-model=\"paymentSchema.data.processes.fiscal.disableCalc\" aria-label=\"proceso fiscal\">Deshabilitar Calculo</md-switch>\n</div><div flex=\"nogrow\"><md-switch ng-disabled=\"F.readMode\" class=\"md-secondary\" name=\"processes_fiscal_incidences\" \nng-model=\"paymentSchema.data.processes.fiscal.defaultIncidences\" aria-label=\"proceso fiscal\">Incidencias Default\n</md-switch></div></div><hr><div layout=\"column\" flex ng-show=\"paymentSchema.data.processes.fiscal.active\">\n<md-input-container class=\"md-block\" flex><label>Tope del Proceso Fiscal</label><input ng-disabled=\"F.readMode\" \nplaceholder=\"0 = sin limites\" min=\"0\" md-minlength=\"0\" minlength=\"0\" type=\"number\" name=\"fiscal_limit\" \nng-model=\"paymentSchema.data.processes.fiscal.limit\"></md-input-container><h4 class=\"placeholder\">Conceptos</h4><div \nclass=\"idsConcept\"><ids-object model=\"paymentSchema.data.processes.fiscal.concepts\" items=\"nitConcepts\" \nread-only=\"F.readMode\" allow-order=\"true\" object-name=\"concepts\" form=\"form\" payrolls=\"payrollsData\" \nshow-on-report=\"true\" show-hidden-column=\"true\"></ids-object></div><h4 class=\"placeholder\">Incidencias</h4><div \nclass=\"concept-incidences\"><div class=\"idsConcept\"><ids-object model=\"paymentSchema.data.processes.fiscal.incidences\" \nitems=\"incidencesTypes\" read-only=\"F.readMode\" allow-order=\"true\" object-name=\"concepts\" form=\"form\" \nshow-hidden-column=\"false\"></ids-object></div></div><h4 class=\"placeholder\">Totales</h4><div class=\"idsConcept\">\n<ids-object model=\"paymentSchema.data.processes.fiscal.totals\" items=\"allSchemaConcepts\" read-only=\"F.readMode\" \nallow-order=\"true\" object-name=\"totals\" form=\"form\" input-field-name=\"Campo\" input-field-id=\"field\" \ninput-name=\"Nombre\" input-id=\"name\" input-operation-name=\"Operación\" input-operation-id=\"operation\" \nshow-hidden-column=\"false\"></ids-object></div></div></div></md-tab-body></md-tab><md-tab label=\"complementos\">\n<md-tab-body><div class=\"detail-form-container md-background-bg md-whiteframe-1dp\" layout=\"column\"><div layout=\"row\" \nflex><div flex><h3>Procesos Complementarios</h3></div><div flex=\"nogrow\"><md-button ng-disabled=\"F.readMode\" \nng-click=\"addComplement()\" class=\"md-primary md-raised\" aria-label=\"Add complement\"><md-tooltip md-direction=\"left\">\nAgregar Complemento</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"Add\"></md-icon></md-button></div></div>\n<div ng-repeat=\"complement in paymentSchema.data.processes.complements\" class=\"complement\"><div layout-gt-xs=\"row\">\n<md-input-container class=\"md-block\" flex><label>Nombre</label><input ng-disabled=\"F.readMode\" class=\"uppercased\" \nplaceholder=\"nombre del complemento...\" type=\"text\" ng-model-options=\"{ debounce: F.debounceTime }\" \nname=\"complement_name[$index]\" ng-model=\"complement.name\" required></md-input-container><md-input-container \nclass=\"md-block\" flex><label>Alias</label><input ng-disabled=\"F.readMode\" class=\"uppercased\" \nplaceholder=\"Alias del complemento...\" type=\"text\" ng-model-options=\"{ debounce: F.debounceTime }\" \nname=\"alias[$index]\" ng-model=\"complement.alias\"><div ng-messages=\'form[\"alias\"+$index].$error\' \nng-show=\'form[\"alias\"+$index].$touched || form[\"alias\"+$index].$dirty\' role=\"alert\"><div ng-message=\"required\">\nEl nombre es requerido</div></div></md-input-container><md-input-container class=\"md-block\" flex><label>Complemento\n</label><md-select ng-disabled=\"F.readMode\" ng-model=\"complement.type\" name=\"complement_type[$index]\" required>\n<md-option ng-value=\"complementType\" ng-repeat=\"complementType in F.complementTypes\">\n{{\'o.\' + complementType | translate | capitalize}}</md-option></md-select></md-input-container><div layout=\"row\">\n<md-input-container class=\"md-block\" flex><label>Tope</label><input ng-disabled=\"F.readMode\" \nplaceholder=\"0 = sin limites\" min=\"0\" md-minlength=\"0\" minlength=\"0\" type=\"number\" name=\"complement_limit[$index]\" \nng-model=\"complement.limit\"></md-input-container><div><md-switch ng-disabled=\"F.readMode\" \naria-label=\"active complement\" class=\"md-secondary pr-5\" ng-model=\"complement.active\" ng-false-value=\"0\">Activado\n</md-switch></div><div><md-switch ng-disabled=\"F.readMode\" aria-label=\"active complement\" class=\"md-secondary\" \nng-model=\"complement.disableCalc\" ng-false-value=\"0\">Deshabilitar Calculo</md-switch></div><md-input-container \nlayout-gt-xs=\"nogrow\"><md-button ng-disabled=\"F.readMode\" ng-click=\"removeComplement($index)\" \nclass=\"md-primary md-raised\" aria-label=\"Remove complement\"><md-tooltip md-direction=\"left\">Borrar Complemento\n</md-tooltip><md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button></md-input-container></div>\n</div><div layout=\"column\" class=\"idsConcept\"><h4 class=\"placeholder\">Conceptos</h4><ids-object \nmodel=\"complement.concepts\" items=\"nitConcepts\" payrolls=\"payrollsData\" read-only=\"F.readMode\" allow-order=\"true\" \nobject-name=\"concepts\" form=\"form\" show-on-report=\"true\" show-hidden-column=\"true\"></ids-object></div><h4 \nclass=\"placeholder\">Incidencias</h4><div class=\"concept-incidences\"><div class=\"idsConcept\"><ids-object \nmodel=\"complement.incidences\" items=\"incidencesTypes\" read-only=\"F.readMode\" allow-order=\"true\" object-name=\"concepts\" \nform=\"form\" show-hidden-column=\"false\"></ids-object></div></div><div layout=\"column\" class=\"idsConcept\"><h4 \nclass=\"placeholder\">Totales</h4><ids-object model=\"complement.totals\" items=\"allSchemaConcepts\" read-only=\"F.readMode\" \nallow-order=\"true\" object-name=\"totals\" form=\"form\" input-field-name=\"Campo\" input-field-id=\"field\" \ninput-name=\"Nombre\" input-id=\"name\" input-operation-name=\"Operación\" input-operation-id=\"operation\" \nshow-hidden-column=\"false\"></ids-object></div></div></div></md-tab-body></md-tab><md-tab label=\"otros\"><md-tab-body>\n<div class=\"detail-form-container md-background-bg md-whiteframe-1dp\" layout=\"column\"><div layout=\"row\" \nlayout-align=\"start center\" flex><div flex><h3>Otros Calculos</h3></div><div flex=\"nogrow\"><md-switch \nng-disabled=\"F.readMode\" class=\"md-secondary pr-5\" name=\"processes_otros\" \nng-model=\"paymentSchema.data.processes.others.active\" ng-false-value=\"0\" aria-label=\"otros activado\">Activado\n</md-switch></div><div flex=\"nogrow\"><md-switch ng-disabled=\"F.readMode\" class=\"md-secondary\" \nname=\"processes_otros_disable_calc\" ng-model=\"paymentSchema.data.processes.others.disableCalc\" ng-false-value=\"0\" \naria-label=\"otros disable calculos\">Deshabilitar Calculo</md-switch></div></div><hr><div layout=\"column\" flex \nng-show=\"paymentSchema.data.processes.others.active\"><h4 class=\"placeholder\">Conceptos</h4><div class=\"idsConcept\">\n<ids-object model=\"paymentSchema.data.processes.others.concepts\" items=\"nitConcepts\" read-only=\"F.readMode\" \nallow-order=\"true\" object-name=\"concepts\" form=\"form\" payrolls=\"payrollsData\" show-hidden-column=\"true\"></ids-object>\n</div></div></div></md-tab-body></md-tab></md-tabs></md-content></form></div>");
$templateCache.put("app/main/config/views/paymentSchemas/paymentSchemas.html","<div id=\"paymentSchemas\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div fb-search-bar></div><div class=\"content-card\" layout=\"column\" flex>\n<div class=\"content fullpage-datatable\" layout=\"column\" flex><div table-loader array=\"paymentSchemas\" \nvalidations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"paymentSchemas.length\"><thead md-head md-order=\"order\" \nfix-head><tr md-row><th md-column md-order-by=\"data.name\"><span>Esquema de Pago</span></th></tr></thead><tbody md-body>\n<tr md-row md-auto-select md-select=\"paymentSchema\" md-select-id=\"$id\" \nng-repeat=\"paymentSchema in (F.filteredItems = (paymentSchemas | filter:F.searchText.paymentSchema | orderBy:order)) | limitTo: F.paginate: (currentPage - 1) * F.paginate\">\n<td md-cell><div><h3 class=\"mb-0\"><strong>{{paymentSchema.data.name}}</strong></h3><blockquote \nng-if=\"paymentSchema.description && paymentSchema.description!==\'\'\"><p>{{paymentSchema.description}}</p></blockquote>\n<div class=\"mb-5 mt-5\">REAL: <span class=\"text-boxed font-weight-100\" \nng-repeat=\"(key,concept) in paymentSchema.data.processes.real.concepts\">{{key | nameOfL : L.concepts : key}}<md-icon \nng-if=\"concept.hiddenColumn\" md-font-icon=\"icon-eye-off\"></md-icon><md-icon ng-if=\"!concept.hiddenColumn\" \nmd-font-icon=\"icon-eye\"></md-icon></span></div><div class=\"mb-5 mt-5\" \nng-if=\"paymentSchema.data.processes.fiscal.active\">FISCAL: <span class=\"text-boxed font-weight-100\">\n{{paymentSchema.data.processes.fiscal.incidences | objectsLength }} INCIDENCIAS</span> <span \nclass=\"text-boxed font-weight-100\" ng-repeat=\"(key,concept) in paymentSchema.data.processes.fiscal.concepts\">\n{{key | nameOfL : L.concepts : key}}<md-icon ng-if=\"concept.hiddenColumn\" md-font-icon=\"icon-eye-off\"></md-icon>\n<md-icon ng-if=\"!concept.hiddenColumn\" md-font-icon=\"icon-eye\"></md-icon></span></div><div class=\"mb-5 mt-5\" \nng-repeat=\"complement in paymentSchema.data.processes.complements\">{{complement.name}}: <span \nclass=\"text-boxed font-weight-100\">{{complement.incidences | objectsLength }} INCIDENCIAS</span> <span \nclass=\"text-boxed font-weight-100\" ng-repeat=\"(key,concept) in complement.concepts\">\n{{key | nameOfL : L.concepts : key}}<md-icon ng-if=\"concept.hiddenColumn\" md-font-icon=\"icon-eye-off\"></md-icon>\n<md-icon ng-if=\"!concept.hiddenColumn\" md-font-icon=\"icon-eye\"></md-icon></span></div></div></td></tr></tbody></table>\n</md-table-container><md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" \nng-show=\"paymentSchemas.length\" md-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" \nmd-limit-options=\"F.paginations\" md-page=\"currentPage\" md-on-paginate=\"restartSelected\" \nmd-total=\"{{F.filteredItems.length}}\" md-page-select></md-table-pagination></div></div><md-fab-speed-dial \nmd-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\" \nng-mouseenter=\"isOpen=true\" ng-mouseleave=\"isOpen=false\"><md-fab-trigger><md-button aria-label=\"crud menu\" \nclass=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon></md-button></md-fab-trigger>\n<md-fab-actions><md-button with-permission action=\"read\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" \nng-click=\'R.goToDetail(null, \"read\", {paymentSchemaId: selected[0].$id})\' aria-label=\"view\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Ver</md-tooltip><md-icon \nmd-font-icon=\"icon-eye\" aria-label=\"view\"></md-icon></md-button><md-button with-permission action=\"update\" \naccess=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" \nng-click=\'R.goToDetail(null, \"update\", {paymentSchemaId: selected[0].$id})\' aria-label=\"Edit\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">{{\'EC.EDIT\' | translate}}\n</md-tooltip><md-icon md-font-icon=\"icon-pencil\" aria-label=\"update\"></md-icon></md-button><md-button with-permission \naction=\"remove\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length\" ng-click=\"delete($event)\" aria-label=\"Delete\" \nclass=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">{{\'EC.REMOVE\' | translate}}</md-tooltip>\n<md-icon md-font-icon=\"icon-delete\" aria-label=\"remove\"></md-icon></md-button><md-button with-permission \naction=\"create\" access=\"{{F.active.menuItem}}\" ng-if=\"!selected.length\" \nng-click=\'R.goToDetail(null, \"update\", {paymentSchemaId: \"new\"})\' aria-label=\"add\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">{{\'EC.ADD\' | translate}}\n</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon></md-button></md-fab-actions>\n</md-fab-speed-dial></div></div>");
$templateCache.put("app/main/config/views/payrollConfigs/payrollConfig.html","<div id=\"payrollConfig\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill><form name=\"form\" \nnovalidate flex layout=\"column\" ng-disabled=\"F.readMode\"><div fb-crud-detail-bar layout=\"nogrow\"></div><md-content \nlayout=\"column\" class=\"content\" flex><div class=\"detail-form-container md-background-bg md-whiteframe-1dp\"><div \nlayout=\"column\" flex><md-input-container class=\"md-block evenPadding\" flex><label>Nómina</label><md-select \nng-model=\"payrollConfig.payroll\" name=\"payroll\" unique-fb ref=\"{{F.active.menuRef}}\" query=\"payroll\" \nfromid=\"{{payrollConfig.$id}}\" required ng-disabled=\"F.readMode\"><md-select-header><input autocomplete=\"off\" \ntype=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"payrollSelectFilter\" \nplaceholder=\"Busque una nómina\"></md-select-header><md-option ng-if=\"payroll.active||!F.addMode\" \nng-value=\"payroll.$id\" ng-class=\'{\"inactiveOption\":!payroll.active}\' \nng-repeat=\"payroll in (F.permissionToAccessAllPayrolls?L.allPayrolls:L.payrolls) | orderBy:\'class\' | filter:payrollSelectFilter\">\n{{payroll.class}} {{payroll.name}}</md-option></md-select><div ng-messages=\"form.payroll.$error\" role=\"alert\"><div \nng-message=\"required\">Nómina es requerido</div><div ng-message=\"unique\">Está nómina ya está registrada</div></div>\n</md-input-container><div class=\"md-block\" flex><fieldset class=\"demo-fieldset\"><legend class=\"demo-legend\">\nTipos de proceso</legend><md-checkbox ng-model=\"payrollConfig.uploadFtpProcess.fiscal\" class=\"mb-0\" \naria-label=\"For Payroll\">Fiscal</md-checkbox><md-checkbox ng-model=\"payrollConfig.uploadFtpProcess.socialPrevision\" \nclass=\"mb-0\" aria-label=\"For Settlement\">Complemento</md-checkbox></fieldset></div></div></div></md-content></form>\n</div>");
$templateCache.put("app/main/config/views/payrollConfigs/payrollConfigs.html","<div id=\"payrollConfigs\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div fb-search-bar></div><div class=\"content-card\" layout=\"column\" flex>\n<div class=\"content fullpage-datatable\" layout=\"column\" flex><div filter-toolbar></div><div table-loader \narray=\"payrollConfigs\" validations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"payrollConfigs.length\"><thead md-head md-order=\"order\" \nfix-head><tr md-row><th md-column md-order-by=\"name\"><span>Nómina</span></th><th md-column md-order-by=\"processes\">\n<span>Procesos</span></th></tr></thead><tbody md-body><tr md-row md-auto-select md-select=\"payrollConfig\" \nmd-select-id=\"$id\" \nng-repeat=\"payrollConfig in (F.filteredItems = (payrollConfigs | filter:F.searchText.payrollConfig | orderBy:order)) | limitTo: F.paginate: (currentPage - 1) * F.paginate\">\n<td md-cell>{{payrollConfig.name = (payrollConfig.payroll | nameOfL:L.allPayrolls:\'N/A\')}}</td><td md-cell><span \nng-repeat=\"(key, value) in payrollConfig.uploadFtpProcess\">\n[{{((\'payrollConfig.\'+(key|uppercase)) | translate) + \' : \' + (value?\'ACTIVO\':\'DESACTIVADO\')}}]</span></td></tr>\n</tbody></table></md-table-container><md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" \nlayout-xs=\"column\" ng-show=\"payrollConfigs.length\" md-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" \nmd-limit-options=\"F.paginations\" md-page=\"currentPage\" md-on-paginate=\"restartSelected\" \nmd-total=\"{{F.filteredItems.length}}\" md-page-select></md-table-pagination></div></div><md-fab-speed-dial \nmd-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\"><md-fab-trigger>\n<md-button aria-label=\"crud menu\" class=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon>\n</md-button></md-fab-trigger><md-fab-actions><md-button with-permission action=\"read\" access=\"{{F.active.menuItem}}\" \nng-if=\"selected.length == 1\" ng-click=\'R.goToDetail(null, \"read\", {payrollConfigId: selected[0].$id})\' \naria-label=\"view\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Ver</md-tooltip>\n<md-icon md-font-icon=\"icon-eye\" aria-label=\"view\"></md-icon></md-button><md-button with-permission action=\"update\" \naccess=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" \nng-click=\'R.goToDetail(null, \"update\", {payrollConfigId: selected[0].$id})\' aria-label=\"edit\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Editar</md-tooltip><md-icon \nmd-font-icon=\"icon-pencil\" aria-label=\"edit\"></md-icon></md-button><md-button with-permission action=\"remove\" \naccess=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" ng-click=\"delete($event)\" aria-label=\"Delete\" \nclass=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">{{\'EC.REMOVE\' | translate}}</md-tooltip>\n<md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button><md-button with-permission \naction=\"create\" access=\"{{F.active.menuItem}}\" ng-if=\"!selected.length\" \nng-click=\'R.goToDetail(null, \"update\", {payrollConfigId: \"new\"})\' aria-label=\"add\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">{{\'EC.ADD\' | translate}}\n</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon></md-button></md-fab-actions>\n</md-fab-speed-dial></div></div>");
$templateCache.put("app/main/config/views/permissions/permissions.html","<div id=\"permissions\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill><form name=\"form\" \nnovalidate flex layout=\"column\" ng-disabled=\"F.readMode\"><md-toolbar class=\"md-tall header md-accent-bg\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button \nclass=\"goto-button md-icon-button\" aria-label=\"Go to permissions\" with-permission action=\"access\" \naccess=\"{{F.active.menuItem}}\" ng-click=\"R.goToList()\" translate translate-attr-aria-label=\"EC.GO_TO\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-security\" aria-label=\"icon security\" class=\"crud-icon\"></md-icon><div layout=\"column\" \nlayout-align=\"start start\"><div class=\"h2\">Permisos</div><div class=\"subtitle secondary-text\"><span>Configuración\n</span></div></div></div></div></md-toolbar><md-content layout=\"column\" class=\"content\" flex><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\"><md-content layout=\"column\"><div layout=\"row\" \nlayout-align=\"end end\"><div flex=\"nogrow\"><md-button with-permission action=\"export\" access=\"{{F.active.menuItem}}\" \nng-click=\"PermCtrl.getPermissionReport()\" aria-label=\"export\" class=\"md-raised md-primary md-hue-2\" flex>\nExportar Permisos<md-icon md-font-icon=\"icon-file-excel\" aria-label=\"export icon\"></md-icon></md-button></div></div>\n<div flex=\"nogrow\"><md-input-container class=\"md-block\" ng-show=\"PermCtrl.groups.length>0\"><label>Grupo</label>\n<md-select ng-model=\"PermCtrl.group\" ng-change=\"PermCtrl.setPermissionsArray()\"><md-select-header><input \nng-model=\"searchGroup\" ng-keydown=\"$event.stopPropagation()\" aria-label=\"Buscar grupo\" type=\"search\" \nplaceholder=\"Buscar grupo\" class=\"md-text\"></md-select-header><md-option ng-value=\"groupP.$id\" \nng-repeat=\'groupP in PermCtrl.groups | filter: searchGroup | orderBy:\"order\"\'>{{groupP.name | capitalize}}</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block\" ng-show=\"PermCtrl.categories.length>0\"><label>\nCategoría</label><md-select ng-model=\"PermCtrl.category\" ng-change=\"PermCtrl.setPermissionsArray()\"><md-select-header>\n<input ng-model=\"searchCategory\" ng-keydown=\"$event.stopPropagation()\" aria-label=\"Buscar Categoría\" type=\"search\" \nplaceholder=\"Buscar Categoría\" class=\"md-text\"></md-select-header><md-option ng-value=\"categoryP\" \nng-repeat=\"categoryP in PermCtrl.categories | filter: searchCategory\">{{\'permission.\' + categoryP | translate}}\n</md-option></md-select></md-input-container><md-input-container class=\"md-block\" ng-show=\"PermCtrl.modules.length>0\">\n<label>Módulo</label><md-select ng-model=\"PermCtrl.module\" ng-change=\"PermCtrl.setPermissionsArray()\">\n<md-select-header><input ng-model=\"searchModule\" ng-keydown=\"$event.stopPropagation()\" aria-label=\"Buscar Modulo\" \ntype=\"search\" placeholder=\"Buscar Modulo\" class=\"md-text\"></md-select-header><md-option \nng-disabled=\"F.menuItems[PermCtrl.category][moduleP].active === false\" ng-value=\"moduleP\" \nng-repeat=\"moduleP in PermCtrl.modules | filter: searchModule\">{{moduleP | menuName}}</md-option></md-select>\n</md-input-container></div><div flex ng-show=\"PermCtrl.modulePerms.length>0\"><hr><md-list><md-subheader \nclass=\"md-no-sticky pointer\">{{module | capitalize}}</md-subheader><div><md-list-item \nng-repeat=\"thisPerm in PermCtrl.modulePerms\"><p>{{\'p.\' + thisPerm | translate}}</p><md-switch class=\"md-secondary\" \nng-model=\"PermCtrl.permissions[PermCtrl.group][PermCtrl.category][PermCtrl.module].permissions[thisPerm]\" \nng-change=\"PermCtrl.savePermission(PermCtrl.group, PermCtrl.category, PermCtrl.module, thisPerm, PermCtrl.permissions[PermCtrl.group][PermCtrl.category][PermCtrl.module].permissions[thisPerm])\">\n</md-switch></md-list-item></div></md-list></div></md-content></div></md-content></form></div>");
$templateCache.put("app/main/config/views/processConfigs/processConfig.html","<div id=\"processConfig\" class=\"page-layout simple tabbed crud-detail\" layout-fill layout=\"row\" \nng-controller=\"ProcessConfigController\"><form name=\"form\" novalidate ng-disabled=\"F.readMode\" layout=\"column\" flex><div\n fb-crud-detail-bar layout=\"nogrow\"></div><md-content flex class=\"content\"><div \nclass=\"detail-form-container md-background-bg md-whiteframe-2dp\" layout=\"column\"><div flex=\"nogrow\" layout=\"column\" \nlayout-gt-xs=\"row\" layout-align=\"start center\"><md-input-container class=\"md-block\" flex flex-gt-xs=\"70\"><label>Nombre\n</label><input ng-disabled=\"F.readMode\" name=\"name\" type=\"text\" ng-model=\"processConfig.name\" class=\"uppercased\" \nng-model-options=\"{ debounce: F.debounceTime }\" required><div ng-messages=\"form.name.$error\" role=\"alert\"><div \nng-message=\"required\">Debe introducir un nombre</div></div></md-input-container><md-input-container class=\"md-block\" \nflex><label>Tipo de operación</label><md-select ng-model=\"processConfig.type\" name=\"type\" required \nng-disabled=\"F.readMode\"><md-option ng-repeat=\"operationType in F.operationTypes\" ng-value=\"operationType.id\" \nng-bind=\"operationType.name\"></md-option></md-select><div ng-messages=\"form.type.$error\" role=\"alert\"><div \nng-message=\"required\">Tipo de operación es requerido</div></div></md-input-container><div><md-checkbox \nng-model=\"processConfig.default\" aria-label=\"Default\">Default</md-checkbox></div></div><div layout=\"column\">\n<md-input-container class=\"md-block\" flex><label>Descripción</label><textarea ng-disabled=\"F.readMode\" \nclass=\"uppercased\" rows=\"3\" name=\"description\" ng-model=\"processConfig.description\" md-maxlength=\"150\" maxlength=\"150\" \nng-model-options=\"{ debounce: F.debounceTime }\"></textarea><div ng-messages=\"form.description.$error\" role=\"alert\"><div\n ng-message=\"maxlength\">La descripción no debe tener más de 150 caracteres</div></div></md-input-container></div><div \nflex><md-button aria-label=\"Add\" ng-click=\"addProcess()\">Agregar Nuevo Proceso<md-icon \nmd-font-icon=\"icon-playlist-plus\"></md-icon></md-button><button ng-if=\"processConfig.processes.length > 1\" \naria-label=\"Remove\" ng-click=\"removeProcess(selectedTab)\"><md-tooltip md-direction=\"top\">Eliminar pestaña actual\n</md-tooltip><md-icon md-font-icon=\"icon-trash\" class=\"white-icon-trash\"></md-icon></button></div><md-tabs \nmd-selected=\"selectedTab\" flex md-dynamic-height><md-tab label=\"{{process.name}}\" \nng-repeat=\"($index,process) in processConfig.processes track by $index\"><md-tab-body><div \nclass=\"md-background-bg md-whiteframe-1dp\" layout=\"column\" style=\"padding-top: 15px\"><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex><label>ID</label><input type=\"text\" name=\"id{{$index}}\" \nng-model-options=\"{ debounce: F.debounceTime }\" ng-model=\"process.id\" required><div \nng-messages=\'form[\"id\"+$index].$error\' ng-show=\'form[\"id\"+$index].$touched || form[\"id\"+$index].$dirty\' role=\"alert\">\n<div ng-message=\"required\">El ID es requerido</div></div></md-input-container><md-input-container class=\"md-block\" \nflex><label>Nombre de configuración</label><input type=\"text\" name=\"name{{$index}}\" \nng-model-options=\"{ debounce: F.debounceTime }\" class=\"uppercased\" ng-model=\"process.name\" required><div \nng-messages=\'form[\"name\"+$index].$error\' ng-show=\'form[\"name\"+$index].$touched || form[\"name\"+$index].$dirty\' \nrole=\"alert\"><div ng-message=\"required\">El nombre es requerido</div></div></md-input-container><md-input-container \nclass=\"md-block\" flex><label>Alias de configuración</label><input type=\"text\" name=\"alias{{$index}}\" \nng-model-options=\"{ debounce: F.debounceTime }\" class=\"uppercased\" ng-model=\"process.alias\"><div \nng-messages=\'form[\"alias\"+$index].$error\' ng-show=\'form[\"alias\"+$index].$touched || form[\"alias\"+$index].$dirty\' \nrole=\"alert\"><div ng-message=\"required\">El nombre es requerido</div></div></md-input-container></div><md-switch \nng-disabled=\"F.readMode\" class=\"md-secondary\" name=\"processes_fiscal_incidences\" ng-model=\"process.defaultIncidences\" \naria-label=\"proceso fiscal\">Incidencias Default</md-switch><h4 class=\"placeholder\">Conceptos</h4><div \nclass=\"idsConcept\"><ids-object model=\"process.concepts\" items=\"nitConcepts\" read-only=\"F.readMode\" allow-order=\"true\" \nobject-name=\"concepts\" form=\"form\" show-on-report=\"true\" show-hidden-column=\"true\"></ids-object></div><h4 \nclass=\"placeholder\">Incidencias</h4><div class=\"concept-incidences\"><div class=\"idsConcept\"><ids-object \nmodel=\"process.incidences\" items=\"incidencesTypes\" read-only=\"F.readMode\" allow-order=\"true\" object-name=\"incidences\" \nform=\"form\" show-hidden-column=\"false\"></ids-object></div></div><div layout=\"column\" class=\"idsConcept\"><h4 \nclass=\"placeholder\">Totales</h4><ids-object model=\"process.totals\" items=\"nitConcepts\" read-only=\"F.readMode\" \nallow-order=\"true\" object-name=\"totals\" form=\"form\" input-field-name=\"Campo\" input-field-id=\"field\" \ninput-name=\"Nombre\" input-id=\"name\" input-operation-name=\"Operación\" input-operation-id=\"operation\" \nshow-hidden-column=\"false\"></ids-object></div></div></md-tab-body></md-tab></md-tabs></div></md-content></form></div>");
$templateCache.put("app/main/config/views/processConfigs/processConfigs.html","<div id=\"processConfigs\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div fb-search-bar></div><div class=\"content-card\" layout=\"column\" flex>\n<div class=\"content fullpage-datatable\" layout=\"column\" flex><div filter-toolbar></div><div table-loader \narray=\"processConfigs\" validations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"processConfigs.length\"><thead md-head md-order=\"order\" \nfix-head><tr md-row><th md-column md-order-by=\"name\"><span>Nombre</span></th><th md-column md-order-by=\"type\"><span>\nTipo de Configuración</span></th></tr></thead><tbody md-body><tr md-row md-auto-select md-select=\"processConfig\" \nmd-select-id=\"$id\" \nng-repeat=\"processConfig in (F.filteredItems = (processConfigs | filter:F.searchText.processConfig | orderBy:order)) | limitTo: F.paginate: (currentPage - 1) * F.paginate\">\n<td md-cell colspan=\"2\"><h3 class=\"mb-0\"><strong>{{processConfig.name}} <small>\n({{(processConfig.type)?((\'processConfig.\'+(processConfig.type|uppercase)) | translate | uppercase) :\'N/A\'}})</small>\n</strong></h3><blockquote ng-if=\"processConfig.description && processConfig.description!==\'\'\"><p>\n{{processConfig.description}}</p></blockquote><div class=\"mb-5 mt-5\" \nng-repeat=\"($index, process) in processConfig.processes\">{{process.name | uppercase}}: <span \nclass=\"text-boxed font-weight-100\">{{process.incidences | objectsLength }} INCIDENCIAS</span> <span \nclass=\"text-boxed font-weight-100\" ng-repeat=\"(key,concept) in process.concepts\">{{key | nameOfL : L.concepts : key}}\n<md-icon ng-if=\"concept.hiddenColumn\" md-font-icon=\"icon-eye-off\"></md-icon><md-icon ng-if=\"!concept.hiddenColumn\" \nmd-font-icon=\"icon-eye\"></md-icon></span></div></td></tr></tbody></table></md-table-container><md-table-pagination \nlayout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" ng-show=\"processConfigs.length\" \nmd-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" md-limit-options=\"F.paginations\" md-page=\"currentPage\" \nmd-on-paginate=\"restartSelected\" md-total=\"{{F.filteredItems.length}}\" md-page-select></md-table-pagination></div>\n</div><md-fab-speed-dial md-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" \nclass=\"ms2-speed-dial bottom right\"><md-fab-trigger><md-button aria-label=\"crud menu\" \nclass=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon></md-button></md-fab-trigger>\n<md-fab-actions><md-button with-permission action=\"read\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" \nng-click=\'R.goToDetail(null, \"read\", {processConfigId: selected[0].$id, payrollId: selected[0].payroll})\' \naria-label=\"view\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Ver</md-tooltip>\n<md-icon md-font-icon=\"icon-eye\" aria-label=\"view\"></md-icon></md-button><md-button with-permission action=\"update\" \naccess=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" \nng-click=\'R.goToDetail(null, \"update\", {processConfigId: selected[0].$id, payrollId: selected[0].payroll})\' \naria-label=\"edit\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Editar\n</md-tooltip><md-icon md-font-icon=\"icon-pencil\" aria-label=\"edit\"></md-icon></md-button><md-button with-permission \naction=\"remove\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" ng-click=\"delete($event)\" \naria-label=\"Delete\" class=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">\n{{\'EC.REMOVE\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button>\n<md-button with-permission action=\"create\" access=\"{{F.active.menuItem}}\" ng-if=\"!selected.length\" \nng-click=\'R.goToDetail(null, \"update\", {processConfigId: \"new\"})\' aria-label=\"add\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">{{\'EC.ADD\' | translate}}\n</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon></md-button></md-fab-actions>\n</md-fab-speed-dial></div></div>");
$templateCache.put("app/main/config/views/profile/profile.html","<div id=\"profile\" class=\"page-layout simple tabbed\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between end\" \nng-init=\"showChangeButton = false\"><div class=\"user-info\" layout=\"column\" layout-align=\"center center\" \nlayout-gt-sm=\"row\" layout-align-gt-sm=\"start center\"><img class=\"profile-image avatar huge\" \nng-src=\"{{F.profile.avatar?F.profile.avatar:\'assets/images/avatars/katherine.jpg\'}}\"><div class=\"name\">\n{{F.profile.data.name}}</div></div><div class=\"actions\" layout=\"row\" layout-align=\"end center\" \nng-init=\"showChangeAvatar = false\"><lf-ng-md-file-input lf-files=\"images\" lf-mimetype=\"image/*\" \nlf-placeholder=\"perfil\" lf-browse-label=\"Buscar imagen\" lf-remove-label=\"Borrar\" lf-filesize=\"2MB\" name=\"avatar\" \nlf-api=\"imageApi\" progress></lf-ng-md-file-input><md-button ng-click=\"replaceAvatar(images)\" ng-show=\"images.length\" \nclass=\"md-raised md-background md-accent md-hue-1\" aria-label=\"Upload Image\"><md-icon md-font-icon=\"icon-upload\">\n</md-icon></md-button></div></div><div class=\"content\" flex><md-tabs md-dynamic-height><md-tab><md-tab-label><span \ntranslate=\"PROFILE.ABOUT\">About</span></md-tab-label><md-tab-body><md-content class=\"about-tab\"><div layout=\"row\" \nlayout-wrap><div class=\"about\" layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"65\"><div \nclass=\"profile-box info-box work md-whiteframe-1dp\" layout=\"column\" ng-if=\"!F.permissionToAccessAllPayrolls\"><header \nclass=\"md-accent-bg\"><div class=\"title\" translate=\"PROFILE.INVOLVED_PAYROLLS\">Involved Payrolls</div></header><div \nclass=\"content\"><div class=\"info-line\" ng-repeat=\"payroll in L.payrolls\"><div class=\"title\"><a \nui-sref=\"app.organization.payrolls.read({firmId: \'{{payroll.$id | getSomethingOfArrayFB:L.allPayrolls:\'firm\'}}\', payrollId:\'{{payroll.$id}}\'})\">\n{{payroll.name}}</a></div></div></div></div><div class=\"profile-box info-box contact md-whiteframe-1dp\" \nlayout=\"column\"><header class=\"md-accent-bg\"><div class=\"title\" translate=\"PROFILE.CONTACT\">Contact Info</div></header>\n<div class=\"content\"><div class=\"info-line\" ng-if=\"F.profile.data.address\"><div class=\"title\" \ntranslate=\"PROFILE.ADDRESS\">Address</div><div class=\"info\">{{F.profile.data.address}}</div></div><div \nclass=\"info-line\" ng-if=\"F.profile.data.phone\"><div class=\"title\" translate=\"PROFILE.TEL\">Tel.</div><div class=\"info\">\n<span>{{F.profile.data.phone}}</span></div></div><div class=\"info-line\" ng-if=\"F.profile.data.name\"><div class=\"title\">\nNombre</div><div class=\"info\"><span>{{F.profile.data.name}}</span></div></div><div class=\"info-line\" \nng-if=\"F.profile.data.email\"><div class=\"title\">Correo</div><div class=\"info\"><span>{{F.profile.data.email}}</span>\n</div></div></div></div></div><div class=\"about-sidebar\" layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"35\">\n<div class=\"profile-box friends md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"title\" translate=\"PROFILE.FRIENDS\">Friends</div></header><div \nclass=\"content\"><md-grid-list md-cols-xs=\"5\" md-cols-sm=\"7\" md-cols-md=\"4\" md-cols-gt-md=\"5\" md-row-height=\"1:1\" \nmd-gutter=\"3px\" md-gutter-gt-sm=\"8px\"><md-grid-tile ng-repeat=\"contact in CF.contacts\"><md-tooltip md-direction=\"left\">\n{{contact.name}}</md-tooltip><img ng-src=\"{{contact.avatar}}\" alt=\"{{contact.name}}\" title=\"{{contact.name}}\" \nstyle=\"object-fit: cover;object-position: center;width: 100%; height: 100%\"></md-grid-tile></md-grid-list></div></div>\n<div class=\"profile-box groups md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"title\" translate=\"PROFILE.JOINED_GROUPS\">Joined Groups</div></header>\n<div class=\"content\"><div class=\"group\" ng-repeat=\"(group, value) in profile.groupsOfUser\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div><div class=\"name\">{{group}}\n</div></div></div><md-button class=\"md-icon-button\" aria-label=\"more\" translate \ntranslate-attr-aria-label=\"PROFILE.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></div></div>\n</div><div class=\"profile-box info-box contact md-whiteframe-1dp\" layout=\"column\"><header class=\"md-warn-bg\"><div \nclass=\"title\" layout=\"row\"><span>Doble factor de autenticación</span> <span flex></span><md-icon \nmd-font-icon=\"icon-lock\"></md-icon></div></header><div class=\"content\"><div class=\"info-line\" ng-if=\"mfa.loading\"><div \nclass=\"info\">Consultando el estado de seguridad...</div></div><div class=\"info-line\" ng-if=\"mfa.loaded\"><div \nclass=\"title\">Estado</div><div class=\"info\">{{mfa.status.enabled ? \'Habilitado\' : \'No habilitado\'}} <span \nng-if=\"mfa.status.enabled\">({{mfa.status.factorCount}} {{mfa.status.factorCount === 1 ? \'factor\' : \'factores\'}})</span>\n</div></div><div class=\"info-line\" ng-if=\"mfa.error\"><div class=\"info\">\nNo fue posible consultar el estado del doble factor.</div></div><md-button class=\"md-raised\" \nng-if=\"mfa.error && !mfa.loading\" ng-click=\"loadMfaStatus()\">Reintentar</md-button><md-button \nclass=\"md-raised md-warn\" ng-if=\"mfa.loaded && mfa.status.enabled\" ng-click=\"showModalDisableMfa($event)\">Deshabilitar\n</md-button></div></div><div class=\"profile-box info-box contact md-whiteframe-1dp\" layout=\"column\" \nng-init=\"showBox = false\"><header class=\"md-warn-bg pointer\" ng-click=\"showBox = !showBox\"><div class=\"title\" \nlayout=\"row\"><span>{{\'PROFILE.PASSWORD_RESET\' | translate}} </span><span flex></span><md-button \nclass=\"md-icon-button noPaddingNoHeight\" aria-label=\"toogle reset\"><md-icon md-font-icon=\"icon-key\"></md-icon>\n</md-button></div></header><div class=\"content\" ng-show=\"showBox\"><div class=\"info-line\"><div class=\"info\">\nLe mandaremos un correo con instrucciones para resetear su password, el enlace caduca en 20 minutos desde que es solicitado\n</div></div><md-button class=\"md-raised md-warn\" ng-click=\"resetPasswordPrompt($event)\" aria-label=\"reset password\">\nResetear</md-button></div></div><div class=\"profile-box info-box contact md-whiteframe-1dp\" layout=\"column\" \nng-init=\"showBox2 = false\"><header class=\"md-warn-bg pointer\" ng-click=\"showBox2 = !showBox2\"><div class=\"title\" \nlayout=\"row\"><span>Cambiar correo </span><span flex></span><md-button class=\"md-icon-button noPaddingNoHeight\" \naria-label=\"toogle set email\"><md-icon md-font-icon=\"icon-at\"></md-icon></md-button></div></header><div \nclass=\"content\" ng-show=\"showBox2\"><form name=\"newEmailForm\" novalidate><div class=\"info-line\"><span>\nPor favor asegurese de tener acceso al correo nuevo ya que de no ser así no podrá recuperar su contraseña en caso de perderla.\n</span><md-input-container class=\"md-block\" flex><label>Nuevo Email</label><input unique-fb ref=\"profiles\" \nquery=\"data/email\" fromid=\"{{F.profile.uid}}\" type=\"email\" name=\"email\" md-maxlength=\"100\" maxlength=\"100\" \nng-model=\"newEmail\" required><div ng-messages=\"newEmailForm.email.$error\" \nng-show=\"newEmailForm.email.$touched || newEmailForm.email.$dirty\" role=\"alert\"><div ng-message=\"maxlength\">\nEmail no debe tener más de 100 caracteres</div><div ng-message=\"required\">Email es requerido</div><div \nng-message=\"unique\">Email ya está registrado</div><div ng-message=\"email\">Email no es válido</div></div>\n</md-input-container></div><md-button class=\"md-raised md-warn\" ng-click=\"changeEmailModal($event)\" \naria-label=\"change email\">Cambiar</md-button></form></div></div></div></div></md-content></md-tab-body></md-tab><md-tab\n disabled=\"disabled\"><md-tab-label><span translate=\"EC.NOTIFICATIONS\">Notifications</span></md-tab-label><md-tab-body>\n<md-content class=\"notifications-tab\"><md-content><md-tabs md-dynamic-height md-border-bottom><md-tab \nlabel=\"No Leidas\"><md-content class=\"md-padding\"><md-list class=\"md-dense\" flex><md-list-item class=\"md-3-line\" \nng-repeat=\'notification in F.notifications.notReaded|orderBy:\"-created_at\"\'><img ng-src=\"{{notification.from.avatar}}\" \nclass=\"md-avatar\" alt=\"{{notification.from.name}}\"><div class=\"md-list-item-text\" layout=\"column\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle\" class=\"icon floatingBullet\" ng-click=\"F.readNotification(notification.$id)\">\n<md-tooltip md-direction=\"left\"><small>Marcar como leida</small></md-tooltip></md-icon><h3>{{notification.title}}</h3>\n<p ng-if=\"notification.link.action && notification.link.action!=\'\'\">{{ notification.from.name }} <small>\n{{notification.link.action}}</small> <a ui-sref=\"{{notification.link.state}}\">{{notification.link.name}}</a></p><p \nng-if=\"!notification.body || notification.body==\'\'\"><small><span am-time-ago=\"notification.created_at\"></span></small>\n</p><p ng-if=\"notification.body && notification.body!=\'\'\"><small>{{ notification.body }}<br><span \nam-time-ago=\"notification.created_at\"></span></small></p></div></md-list-item></md-list></md-content></md-tab><md-tab \nlabel=\"Leidas\"><md-content class=\"md-padding\"><md-list class=\"md-dense\" flex><md-list-item class=\"md-3-line\" \nng-repeat=\'notification in F.notifications.readed.items | orderBy:\"-created_at\" track by notification.$id\'><img \nng-src=\"{{notification.from.avatar}}\" class=\"md-avatar\" alt=\"{{notification.from.name}}\"><div \nclass=\"md-list-item-text\" layout=\"column\"><h3>{{notification.title}}</h3><p \nng-if=\"notification.link.action && notification.link.action!=\'\'\">{{ notification.from.name }} <small>\n{{notification.link.action}}</small> <a ui-sref=\"{{notification.link.state}}\">{{notification.link.name}}</a></p><p \nng-if=\"!notification.body || notification.body==\'\'\"><small><span am-time-ago=\"notification.created_at\"></span></small>\n</p><p ng-if=\"notification.body && notification.body!=\'\'\"><small>{{ notification.body }}<br><span \nam-time-ago=\"notification.created_at\"></span></small></p></div></md-list-item><md-list-item><div layout=\"row\" flex><div\n flex><md-button ng-click=\"F.notifications.readed.loadMore()\" ng-disabled=\"!F.notifications.readed.loadMoreButton\">\n<md-tooltip md-direction=\"left\">Cargar Mas</md-tooltip><md-icon md-font-icon=\"icon-rotate-3d\" aria-label=\"Load More\">\n</md-icon></md-button></div></div></md-list-item></md-list></md-content></md-tab></md-tabs></md-content></md-content>\n</md-tab-body></md-tab><md-tab disabled=\"disabled\"><md-tab-label><span translate=\"EC.ACTIVITY\">Actividad</span>\n</md-tab-label><md-tab-body><md-content class=\"activity-tab\"><activities-records></activities-records></md-content>\n</md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/config/views/sliderImages/sliderImage.html","<div id=\"sliderImage\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill \nng-controller=\"SliderImageController\"><form name=\"form\" novalidate flex layout=\"column\" ng-disabled=\"F.readMode\">\n<md-toolbar class=\"md-tall header md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" \nlayout=\"row\" layout-align=\"start center\" flex><md-button with-permission action=\"access\" \naccess=\"{{F.active.menuItem}}\" class=\"goto-button md-icon-button\" aria-label=\"Go to list\" ng-click=\"R.goToList()\" \ntranslate translate-attr-aria-label=\"EC.GO_TO\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div \nlayout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"{{F.menuItems[F.active.menuParent][F.active.menuName].icon || F.default.icon}}\" class=\"crud-icon\">\n</md-icon><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\">{{F.active.detailObject.data.name}}</div><div\n class=\"subtitle secondary-text\"><span ng-if=\"!F.addMode\">\n{{\'EC.DETAIL_OF\' | translate}} {{F.active.menuObjName + \'.SINGULAR\' | translate}}</span> <span ng-if=\"F.addMode\">\n{{\'EC.CREATE\' | translate}} {{F.active.menuObjName + \'.SINGULAR\' | translate}}</span></div></div></div></div><div>\n<md-button type=\"submit\" ng-if=\"!F.addMode && objectLoaded && !F.readMode\" with-permission action=\"update\" \naccess=\"{{F.active.menuItem}}\" ng-click=\"saveSliderImage(F.active.detailObject)\" \nng-hide=\"form.$pristine && !objectLoaded\" ng-disabled=\"form.$invalid || form.$pristine || loadingProgress\" \nclass=\"md-raised md-background md-fab md-accent md-hue-1\" aria-label=\"Save\"><md-tooltip md-direction=\"left\">\n{{\'EC.SAVE\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-content-save\" aria-label=\"Save\"></md-icon>\n</md-button><md-button type=\"submit\" ng-if=\"F.addMode && objectLoaded\" with-permission action=\"create\" \naccess=\"{{F.active.menuItem}}\" ng-click=\"saveSliderImage(F.active.detailObject)\" \nng-hide=\"form.$pristine && !objectLoaded\" ng-disabled=\"form.$invalid || loadingProgress || noCalendars\" \nclass=\"md-raised md-background md-fab md-accent md-hue-1\" aria-label=\"Add\"><md-tooltip md-direction=\"left\">\n{{\'EC.ADD\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-content-save\" aria-label=\"Add\"></md-icon></md-button>\n</div></md-toolbar><md-content layout=\"column\" class=\"content\" flex><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\"><div flex layout=\"row\"><md-input-container \nclass=\"md-block\" flex><label>Titulo</label><input ms2-autofocus class=\"uppercased\" type=\"text\" name=\"name\" \nng-model=\"sliderImage.name\" ng-model-options=\"{ debounce: F.debounceTime }\" required ng-disabled=\"F.readMode\"><div \nng-messages=\"form.name.$error\" role=\"alert\"><div ng-message=\"required\">Titulo es requerido</div></div>\n</md-input-container></div><div flex><div class=\"upload-button\" layout=\"column\"><span class=\"md-title text-center\">\nImagen</span><lf-ng-md-file-input ng-show=\"!sliderImage.file\" lf-files=\"files\" ng-disabled=\"F.readMode\" \nlf-mimetype=\"image/*\" lf-placeholder=\"Solo PNG, JPG, GIF o PDF - Max. 2MB\" lf-drag-and-drop-label=\"Arrastre aquí\" \nlf-browse-label=\"Buscar\" lf-remove-label=\"Remover\" lf-on-file-remove=\"form.$setDirty();\" lf-filesize=\"5MB\" \nname=\"confirmationFile\" lf-api=\"imageApi\" progress preview drag></lf-ng-md-file-input><div \nng-messages=\"form.confirmationFile.$error\" style=\"color:red\"><div ng-message=\"required\">\nArchivo de confirmación requerido</div><div ng-message=\"maxcount\">Demaciados archivos</div><div ng-message=\"filesize\">\nArchivo demaciado grande</div><div ng-message=\"totalsize\">El peso total es demaciado</div><div ng-message=\"mimetype\">\nTipo de archivo inválido</div></div></div><div layout=\"column\" layout-align=\"center center\" style=\"max-height: 300px\">\n<img flex style=\"object-fit: contain\" ng-show=\'sliderImage.file && sliderImage.file.indexOf(\".pdf\") == -1\' \nng-src=\"{{sliderImage.file}}\" alt=\"Archivo de Confirmación\"></div><div layout=\"row\" layout-align=\"center center\"><div \nflex=\"nogrow\"><md-button class=\"md-primary\" ng-show=\"sliderImage.file\" target=\"_blanc\" ng-href=\"{{sliderImage.file}}\">\n<md-icon md-font-icon=\"icon-file-pdf\" aria-label=\"PDF\"></md-icon>\n{{sliderImage.file.indexOf(\".pdf\") !== -1?\'Archivo Adjunto\':\'Mostrar en otra ventana\'}}</md-button></div><div \nflex=\"nogrow\"><md-button ng-if=\"sliderImage.file || editAllPermission\" with-permission action=\"update\" \naccess=\"{{F.active.menuItem}}\" ng-click=\"removeUpload(F.active.detailObject)\" \nng-show=\"F.active.detailObject[F.active.imageName]\" class=\"md-warn md-raised md-background md-icon-button\" \naria-label=\"Delete file\" ng-disabled=\"loadingProgress \"><md-tooltip md-direction=\"left\">Borrar adjunto</md-tooltip>\n<md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div></div></div></div></md-content></form></div>");
$templateCache.put("app/main/config/views/sliderImages/sliderImages.html","<div id=\"sliderImages\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\" \nng-controller=\"SliderImagesController\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex>\n<div fb-search-bar flex=\"nogrow\"></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><div filter-toolbar flex=\"nogrow\"></div><div table-loader flex \narray=\"sliderImages\" validations=\"validations\"></div><div flex=\"nogrow\" class=\"scrollable\"><div layout=\"row\" \nlayout-wrap=\"\"><div \nng-repeat=\"sliderImage in (F.filteredItems = (sliderImages | filter:F.searchText.sliderImage | orderBy:order)) | limitTo: F.paginate: (currentPage - 1) * F.paginate\" \nflex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"33\" flex-gt-lg=\"25\"><md-card><img ng-src=\"{{sliderImage.file}}\" \nclass=\"md-card-image\" alt=\"Washed Out\"><md-card-actions layout=\"row\" layout-align=\"end center\"><md-button \nwith-permission action=\"read\" access=\"{{F.active.menuItem}}\" \nng-click=\'R.goToDetail(null, \"read\", {sliderImageId: sliderImage.$id})\' aria-label=\"view\" \nclass=\"md-icon-button md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Ver</md-tooltip>\n<md-icon md-font-icon=\"icon-eye\" aria-label=\"view\"></md-icon></md-button><md-button with-permission action=\"update\" \naccess=\"{{F.active.menuItem}}\" ng-click=\'R.goToDetail(null, \"update\", {sliderImageId: sliderImage.$id})\' \naria-label=\"edit\" class=\"md-icon-button md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">\nEditar</md-tooltip><md-icon md-font-icon=\"icon-pencil\" aria-label=\"edit\"></md-icon></md-button><md-button \nwith-permission action=\"remove\" access=\"{{F.active.menuItem}}\" ng-click=\"deleteImages(sliderImage,$event)\" \naria-label=\"Delete\" class=\"md-icon-button md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">\n{{\'EC.REMOVE\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button>\n</md-card-actions></md-card></div></div></div><md-table-pagination flex=\"nogrow\" layout-align=\"start center\" \nlayout-gt-xs=\"row\" layout-xs=\"column\" ng-show=\"sliderImages.length\" md-label=\"{{F.paginationLabel}}\" \nmd-limit=\"F.paginate\" md-limit-options=\"F.paginations\" md-page=\"currentPage\" md-on-paginate=\"restartSelected\" \nmd-total=\"{{F.filteredItems.length}}\" md-page-select></md-table-pagination></div></div><md-fab-speed-dial \nmd-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\"><md-fab-trigger>\n<md-button aria-label=\"crud menu\" class=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon>\n</md-button></md-fab-trigger><md-fab-actions><md-button with-permission action=\"create\" access=\"{{F.active.menuItem}}\" \nng-click=\'R.goToDetail(null, \"update\", {sliderImageId: \"new\"})\' aria-label=\"add\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">{{\'EC.ADD\' | translate}}\n</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon></md-button></md-fab-actions>\n</md-fab-speed-dial></div></div>");
$templateCache.put("app/main/config/views/tickets/ticket.html","<div id=\"ticketS\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill \nng-controller=\"TicketController\"><form name=\"form\" novalidate flex layout=\"column\" ng-disabled=\"F.readMode\"><div \nmongo-crud-detail-bar></div><md-content class=\"content tds-ticket\" flex layout=\"column\"><div class=\"ticket-main\" \nlayout=\"column\" layout-align=\"start stretch\"><div class=\"ticket-top\" layout=\"row\" layout-xs=\"column\" \nlayout-align=\"start stretch\" layout-wrap><div class=\"col-left\" flex flex-gt-sm=\"65\" layout=\"column\"><md-card \nclass=\"card card--details\"><div class=\"card__head ticket-details__head\" layout=\"row\" \nlayout-align=\"space-between center\" layout-wrap><div layout=\"column\"><div class=\"card__title\">Detalles</div><div \nclass=\"card__sub\">Información principal del ticket</div></div><div class=\"ticket-details__badges\" layout=\"row\" \nlayout-align=\"end center\" layout-wrap><div class=\"ticket-details__badge\"><md-icon md-font-icon=\"icon-folder\"></md-icon>\n{{ (F.navigationItems | filter:{_id: ticket.module})[0].title || \'Sin módulo\' }}</div><div \nclass=\"ticket-details__badge\"><md-icon md-font-icon=\"icon-flag\"></md-icon>\n{{ (F.ticketPriority | filter:{id: ticket.priority})[0].name || \'Sin prioridad\' }}</div></div></div><md-card-content \nclass=\"card__body\" layout=\"column\"><md-input-container class=\"md-block\"><label>Título</label><input ms2-autofocus \nclass=\"uppercased\" type=\"text\" name=\"title\" ng-model=\"ticket.title\" ng-model-options=\"{ debounce: F.debounceTime }\" \nrequired ng-disabled=\"F.readMode || !editAllPermission\"><div ng-messages=\"form.title.$error\" role=\"alert\"><div \nng-message=\"required\">Título es requerido</div></div></md-input-container><md-input-container class=\"md-block\"><label>\nDescripción</label><textarea ng-model=\"ticket.description\" name=\"description\" rows=\"7\" required md-select-on-focus \nng-disabled=\"F.readMode || !editAllPermission\"></textarea><div ng-messages=\"form.description.$error\" role=\"alert\"><div \nng-message=\"required\">Descripción es requerido</div></div></md-input-container><div class=\"fields-row\" layout-wrap \nlayout=\"row\" layout-xs=\"row\" layout-align=\"start start\"><md-input-container class=\"md-block\" flex flex-xs=\"100\"><label>\nMódulo</label><md-select ng-model=\"ticket.module\" class=\"filter\" ng-disabled=\"F.readMode || !editAllPermission\">\n<md-select-header><input ng-model=\"searchTerm\" ng-keydown=\"$event.stopPropagation()\" aria-label=\"Buscar módulo\" \ntype=\"search\" placeholder=\"Buscar módulo\" class=\"md-text\"></md-select-header><md-option ng-value=\"nav._id\" \nng-repeat=\"nav in F.navigationItems | filter: searchTerm track by nav._id\"><md-icon ng-if=\"nav.icon\" \nmd-font-icon=\"{{nav.icon}}\"></md-icon>{{nav.title}}</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block\" flex flex-xs=\"100\"><label>Prioridad</label><md-select ng-model=\"ticket.priority\" name=\"priority\" \nrequired ng-disabled=\"F.readMode || !editAllPermission\"><md-option ng-repeat=\"pri in F.ticketPriority\" \nng-value=\"pri.id\">{{pri.name}}</md-option></md-select><div ng-messages=\"form.priority.$error\" role=\"alert\"><div \nng-message=\"required\">Prioridad es requerido</div></div></md-input-container><md-input-container class=\"md-block\" flex \nflex-xs=\"100\"><label>Asignar a usuario</label><md-select ng-model=\"ticket.assignedTo\" name=\"assignedTo\" \nng-disabled=\"F.readMode || !setAssign\"><md-option ng-repeat=\"asign in userAssign\" ng-value=\"asign.uid\">\n{{asign.data.name}}</md-option></md-select><div ng-messages=\"form.priority.$error\" role=\"alert\"><div \nng-message=\"required\">Prioridad es requerido</div></div></md-input-container></div></md-card-content></md-card></div>\n<div class=\"col-right\" flex flex-gt-sm=\"35\" layout=\"column\"><md-card class=\"card card--attach\"><div class=\"card__head\" \nlayout=\"row\" layout-align=\"start center\"><div layout=\"column\"><div class=\"card__title\">Adjunto</div><div \nclass=\"card__sub\">Captura o PDF (máx. 2MB)</div></div></div><md-card-content class=\"card__body\" layout=\"column\"><div \nclass=\"attach-shell\" layout=\"column\" layout-align=\"center stretch\" ng-class=\"{\'attach-shell--has\': !!ticket.files}\">\n<div class=\"attach-drop\" ng-show=\"!ticket.files\" flex><lf-ng-md-file-input lf-files=\"files\" ng-disabled=\"F.readMode\" \nlf-mimetype=\"image/png|image/gif|image/jpg|image/jpeg|application/pdf\" \nlf-placeholder=\"Solo PNG, JPG, GIF o PDF - Max. 2MB\" lf-drag-and-drop-label=\"Arrastre aquí\" lf-browse-label=\"Buscar\" \nlf-remove-label=\"Remover\" lf-on-file-remove=\"form.$setDirty();\" lf-filesize=\"2MB\" name=\"confirmationFile\" \nlf-api=\"imageApi\" progress preview drag></lf-ng-md-file-input><div ng-messages=\"form.confirmationFile.$error\" \nclass=\"attach-errors\"><div ng-message=\"required\">Archivo requerido</div><div ng-message=\"maxcount\">Demasiados archivos\n</div><div ng-message=\"filesize\">Archivo demasiado grande</div><div ng-message=\"totalsize\">El peso total es demasiado\n</div><div ng-message=\"mimetype\">Tipo de archivo inválido</div></div></div><div class=\"attach-preview2\" \nng-if=\"ticket.files\" layout=\"column\" layout-align=\"start stretch\" flex><div class=\"attach-preview2__thumb\" \nlayout=\"column\" layout-align=\"center center\"><img ng-if=\"ticket.files.toLowerCase().indexOf(\'.pdf\') == -1\" \nng-src=\"{{ticket.files}}\" ng-click=\"openTrackingImage(ticket.files || img.preview || img, $event)\" alt=\"Adjunto\"> <a \nclass=\"pdf-badge\" ng-if=\"ticket.files.toLowerCase().indexOf(\'.pdf\') !== -1\" ng-href=\"{{ticket.files}}\" target=\"_blank\" \nrel=\"noopener noreferrer\" layout=\"row\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-file-pdf\"></md-icon>\n<span>Abrir PDF en nueva ventana</span></a></div><div class=\"attach-preview2__actions\" layout=\"row\" \nlayout-align=\"center center\" layout-wrap><md-button ng-disabled=\"F.readMode || !editAllPermission\" with-permission \naction=\"update\" access=\"{{F.active.menuItem}}\" ng-click=\"removeFieldFile(\'files\')\" ng-disabled=\"loadingProgress\">\n<md-icon md-svg-icon=\"/assets/icons/trash.svg\"></md-icon></md-button></div></div></div></md-card-content></md-card>\n</div></div><md-tabs class=\"ticket-tabs\" ng-if=\"!F.addMode\" md-selected=\"taskManager.selectedTab\" md-dynamic-height \nmd-border-bottom><md-tab label=\"Tareas\"><div class=\"ticket-bottom task-manager\" ng-if=\"!F.addMode\" layout=\"row\" \nlayout-align=\"start stretch\"><div flex=\"100\" layout=\"column\"><md-card class=\"card\"><div class=\"card__head\" \nlayout=\"row\" layout-align=\"space-between center\" layout-wrap><div layout=\"column\"><div class=\"card__title\">\nTareas de Project Manager</div><div class=\"card__sub\">\nPuedes agregar una o varias tareas. La edición se realiza directamente en Project Manager.</div></div><div \nlayout=\"row\" layout-align=\"end center\"><md-progress-circular \nng-if=\"taskManager.loadingProjects || taskManager.loadingTasks\" md-mode=\"indeterminate\" md-diameter=\"24\">\n</md-progress-circular><md-button class=\"md-raised md-primary\" \nng-if=\"projectManagerPermissions.createTask && !taskManager.accessDenied\" ng-click=\"openTaskManagerForm($event)\" \nng-disabled=\"taskManager.loadingProjects || !taskManager.projects.length\">Agregar tarea<md-tooltip \nng-if=\"!taskManager.loadingProjects && !taskManager.projects.length\">No hay proyectos relacionados disponibles\n</md-tooltip></md-button></div></div><md-card-content class=\"card__body task-manager__content\"><div \nclass=\"task-manager__notice\" ng-if=\"taskManager.accessDenied\">No tienes permisos para consultar Project Manager.</div>\n<div class=\"task-manager__notice task-manager__secondary\" \nng-if=\"!taskManager.accessDenied && !projectManagerPermissions.createTask\">\nPuedes consultar las tareas, pero no tienes permiso para agregar nuevas.</div><div \nclass=\"task-manager__notice task-manager__secondary\" \nng-if=\"!taskManager.accessDenied && projectManagerPermissions.createTask && !taskManager.loadingProjects && !taskManager.projects.length\">\nNo hay proyectos relacionados disponibles para agregar tareas.</div><div class=\"task-manager__list\" \nng-if=\"!taskManager.accessDenied\"><div class=\"task-manager__empty\" \nng-if=\"!taskManager.loadingTasks && !taskManager.tasks.length\">Este ticket todavía no tiene tareas en Project Manager.\n</div><div class=\"task-manager__item\" ng-repeat=\"task in taskManager.tasks track by (task._id || task.id)\" \nlayout=\"row\" layout-xs=\"column\" layout-align=\"space-between center\"><div layout=\"column\" flex><div \nclass=\"task-manager__title\">{{task.title}}</div><div class=\"task-manager__meta\"><span class=\"task-manager__project\">\n{{taskProjectTitle(task.projectId)}}</span> <span class=\"task-manager__badge\"><span class=\"task-manager__badge-dot\" \nng-style=\"{\'background-color\': taskStatusColor(task)}\"></span> {{task.statusLabel || task.statusKey || \'Sin estado\'}} \n</span><span class=\"task-manager__badge\"><span class=\"task-manager__badge-dot\" \nng-style=\"{\'background-color\': taskPriorityColor(task)}\"></span>\n {{task.priorityLabel || task.priorityKey || \'Sin prioridad\'}}</span></div><div class=\"task-manager__description\" \nng-if=\"task.description\">{{task.description}}</div></div><md-button class=\"md-icon-button md-warn\" \nng-if=\"projectManagerPermissions.deleteTask\" aria-label=\"Eliminar tarea\" \nng-disabled=\"taskManager.deleting[task._id || task.id]\" ng-click=\"deleteTaskManagerTask(task, $event)\"><md-icon \nmd-svg-icon=\"/assets/icons/trash.svg\"></md-icon><md-tooltip>Eliminar tarea</md-tooltip></md-button></div></div>\n</md-card-content></md-card></div></div></md-tab><md-tab label=\"Seguimientos\"><div class=\"ticket-bottom\" \nng-if=\"!F.addMode\" layout=\"row\" layout-align=\"start stretch\"><div flex=\"100\" layout=\"column\"><md-card \nclass=\"card card--trackings\"><div class=\"card__head\" layout=\"row\" layout-align=\"space-between center\" layout-wrap><div \nlayout=\"column\"><div class=\"card__title\">Seguimientos</div><div class=\"card__sub\">Historial y comentarios</div></div>\n<md-button ng-disabled=\"F.readMode || !editAllPermission\" with-permission action=\"addTracking\" \naccess=\"{{F.active.menuItem}}\" ng-click=\"actions.showAddTracking=true\"><md-icon \nmd-svg-icon=\"/assets/icons/message.svg\"></md-icon></md-button></div><md-card-content class=\"card__body\" \nlayout=\"column\"><div class=\"chat\" layout=\"column\"><div class=\"chat__composer\" ng-if=\"actions.showAddTracking\" \nng-paste=\"onTrackingPaste($event)\" layout=\"column\"><div class=\"chat__pending\" \nng-if=\"actions.pendingImages && actions.pendingImages.length\" layout=\"row\" layout-wrap><div class=\"chat__pendingItem\" \nng-repeat=\"img in actions.pendingImages track by $index\"><img ng-src=\"{{img.preview}}\" alt=\"preview\"> <button \ntype=\"button\" class=\"chat__remove\" ng-click=\"removePendingImage($index)\">×</button></div></div><div layout=\"row\" \nlayout-align=\"start center\" layout-wrap=\"nowrap\" class=\"chat__composerRow\"><md-button class=\"md-icon-button\" \naria-label=\"Adjuntar\" ng-disabled=\"F.readMode || !editAllPermission\" ng-click=\"pickTrackingImages()\"><md-icon \nmd-svg-icon=\"/assets/icons/clip.svg\"></md-icon></md-button><input id=\"trackingFileInput\" type=\"file\" accept=\"image/*\" \nmultiple=\"multiple\" style=\"display:none\" onchange=\"angular.element(this).scope().onTrackingFilesSelected(this.files)\">\n<md-input-container flex class=\"chat__input md-block no-margin\" md-no-float><input type=\"text\" name=\"newTracking\" \nng-model=\"actions.newTracking\" placeholder=\"Escribe un seguimiento o pega una captura (Ctrl+V)…\" \nng-keydown=\"onTrackingKeydown($event)\"></md-input-container><md-button class=\"md-icon-button md-primary\" \naria-label=\"Enviar\" ng-disabled=\"(!actions.newTracking && (!actions.pendingImages || !actions.pendingImages.length))\" \nng-click=\"addTracking(actions.newTracking, actions.pendingImages)\"><md-icon md-svg-icon=\"/assets/icons/send.svg\">\n</md-icon></md-button><md-button class=\"md-icon-button\" ng-click=\"actions.showAddTracking=false\"><md-icon \nmd-svg-icon=\"/assets/icons/trash.svg\"></md-icon></md-button></div></div><div class=\"chat__list\" layout=\"column\"><div \nclass=\"chat__empty\" ng-if=\"!ticket.trackings || !ticket.trackings.length\">Aún no hay seguimientos.</div><div \nclass=\"chat__row\" ng-repeat=\"track in ticket.trackings track by $index\" \nng-class=\"{\'chat__row--me\': track.created.by === F.user.uid}\"><div class=\"chat__bubble\" \nng-class=\"{\'chat__bubble--important\': track.important}\" layout=\"column\"><div class=\"chat__name\" \nng-if=\"track.created.by !== F.user.uid\">\n{{track.created.by | getSomethingOfArrayFB: L.profiles:\'name\':track.created.by}}</div><div class=\"chat__text\" \nng-if=\"track.msg\">{{track.msg}}</div><div class=\"chat__media\" \nng-if=\"(track.images && track.images.length) || (track.imagesLocal && track.imagesLocal.length)\"><div \nclass=\"chat__mediaGrid\"><a class=\"chat__imgWrap\" href=\"\" \nng-repeat=\"img in (track.images && track.images.length ? track.images : track.imagesLocal) track by $index\" \nng-click=\"openTrackingImage(img.url || img.preview || img, $event)\"><img ng-src=\"{{img.url || img.preview || img}}\" \nalt=\"imagen\"></a></div></div><div class=\"chat__meta\" layout=\"row\" layout-align=\"end center\"><span class=\"chat__time\">\n{{track.created.atTime | getDateOf}}</span> <span class=\"chat__edited\" ng-if=\"track.edited\">· Editado<md-tooltip>\n{{track.edited.atTime | getDateOf}}</md-tooltip></span><md-button class=\"md-icon-button chat__edit\" \nng-if=\"canEditTracking(track)\" aria-label=\"Editar último seguimiento\" ng-click=\"editTracking(track, $event)\">\n<md-tooltip>Editar último seguimiento</md-tooltip><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></div>\n</div></div></div></div></md-card-content></md-card></div></div></md-tab></md-tabs></div></md-content></form></div>");
$templateCache.put("app/main/config/views/tickets/tickets.html","<div id=\"ticketS\" ng-controller=\"TicketController\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div mongo-search-bar></div><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><div \nlist-filters filters-loaded=\"F.filtersLoaded\" ng-model=\"F.filters[F.active.menuName]\" on-change=\"getThem\" \ncolumns-repeat=\"columnsRepeat\" menu-obj-name=\"{{F.active.menuObjName}}\" model-name=\"{{F.active.menuName}}\" \ninit-filters=\"initFilters\"></div><div table-loader array=\"tickets\" validations=\"validations\"></div><md-table-container \nclass=\"ticketTable__container tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table \nmd-table md-row-select multiple=\"true\" ng-model=\"selected\" class=\"row-border ticketTable\" ng-show=\"tickets.length\">\n<thead md-head md-order=\"F.orderMongo\" fix-head md-on-reorder=\"getThem\" class=\"ticketTable__head\"><tr md-row \nclass=\"ticketTable__headRow\"><th md-column md-order-by=\"title\" class=\"ticketTable__colTitle\"><span>Titulo</span></th>\n<th md-column md-order-by=\"status\" class=\"ticketTable__colStatus\"><span>Status</span></th><th md-column \nmd-order-by=\"priority\" class=\"ticketTable__colPriority\"><span>Prioridad</span></th><th md-column \nclass=\"ticketTable__colModule\"><span>Modulo</span></th><th md-column class=\"ticketTable__colTracking\"><span>\nUltimo seguimiento</span></th><th md-column md-order-by=\"created.by\" class=\"ticketTable__colCreator\"><span>Creado Por\n</span></th><th md-column md-order-by=\"created.atTime\" class=\"ticketTable__colDate\"><span>Fecha de Creación</span></th>\n<th md-column md-order-by=\"assignedTo\" class=\"ticketTable__colDate\"><span>Tarea asignada</span></th></tr></thead><tbody\n md-body class=\"ticketTable__body\"><tr md-row md-auto-select md-select=\"ticket\" md-select-id=\"_id\" \nng-repeat=\"ticket in tickets\" class=\"ticketTable__row\"><td md-cell class=\"ticketTable__cell ticketTable__title\">\n{{ticket.title}}</td><td md-cell class=\"ticketTable__cell ticketTable__status\"><span class=\"ticketChip\" \nng-class=\"{\'is-open\': ticket.status === 1,\'is-progress\': ticket.status === 2,\'is-closed\': ticket.status === 3}\">\n{{ticket.status | getSomethingOfArrayM:F.ticketStatus:\'name\':ticket.status:\'id\'}}</span></td><td md-cell \nclass=\"ticketTable__cell ticketTable__priority\"><span class=\"ticketChip ticketChip--soft\" \nng-class=\"{p-low\': ticket.priority === 1,\'p-med\': ticket.priority === 2,\'p-high\': ticket.priority === 3}\">\n{{ticket.priority | getSomethingOfArrayM:F.ticketPriority:\'name\':ticket.priority:\'id\'}}</span></td><td md-cell \nclass=\"ticketTable__cell ticketTable__module\">\n{{ticket.module | getSomethingOfArrayM:F.navigationItems:\'title\':ticket.module:\'_id\'}}</td><td md-cell \nclass=\"ticketTable__cell ticketTable__tracking\"><md-tooltip class=\"ticketTrackingTooltip\" md-direction=\"top\"><span \nng-bind=\"ticket.trackings[0].msg || \'Sin seguimientos\'\"></span></md-tooltip><span class=\"ticketTable__trackingText\">\n{{ticket.trackings[0].msg?ticket.trackings[0].msg:\'Sin seguimientos\'}}</span></td><td md-cell \nclass=\"ticketTable__cell ticketTable__creator\">\n{{ticket.created.by | getSomethingOfArrayFB: L.profiles:\'name\':ticket.created.by | uppercase}}</td><td md-cell \nclass=\"ticketTable__cell ticketTable__date\">{{ticket.created.atTime | date:\'medium\'}}</td><td md-cell \nclass=\"ticketTable__cell ticketTable__creator\">\n{{ticket.assignedTo | getSomethingOfArrayFB: L.profiles:\'name\': \'No se ha asignado\'}}</td></tr></tbody></table>\n</md-table-container><md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" \nng-show=\"tickets.length\" md-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" md-limit-options=\"F.paginations\" \nmd-page=\"$parent.currentPage\" md-total=\"{{pagination.total}}\" md-on-paginate=\"getThemPagination\" md-page-select>\n</md-table-pagination></div></div><md-fab-speed-dial md-open=\"F.isOpen\" \nmd-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\"><md-fab-trigger><md-button \naria-label=\"crud menu\" class=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon></md-button>\n</md-fab-trigger><md-fab-actions><md-button with-permission action=\"read\" access=\"{{F.active.menuItem}}\" \nng-if=\"selected.length == 1\" ng-click=\'R.goToDetail(null, \"read\", {ticketId: selected[0]._id})\' aria-label=\"view\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Ver</md-tooltip><md-icon \nmd-font-icon=\"icon-eye\" aria-label=\"view\"></md-icon></md-button><md-button with-permission action=\"update\" \naccess=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1 && selected[0].status !== 3\" \nng-click=\"R.goToDetail(selected[0])\" aria-label=\"edit\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip \nmd-direction=\"left\">Editar</md-tooltip><md-icon md-font-icon=\"icon-pencil\" aria-label=\"edit\"></md-icon></md-button>\n<md-button with-permission action=\"remove\" access=\"{{F.active.menuItem}}\" ng-click=\"delete($event)\" \nng-if=\"selected.length\" aria-label=\"Delete\" class=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">\n{{\'EC.REMOVE\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button>\n<md-button with-permission action=\"create\" access=\"{{F.active.menuItem}}\" ng-if=\"!selected.length\" \nng-click=\'R.goToDetail(\"new\")\' aria-label=\"add\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip \nmd-direction=\"left\">{{\'EC.ADD\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon>\n</md-button><md-button with-permission ng-if=\"selected.length && selected[0].status !== 3\" action=\"closeTickets\" \naccess=\"{{F.active.menuItem}}\" ng-click=\"closeTicket(selected)\" aria-label=\"closeTicket\" \nclass=\"md-fab md-raised md-mini pink-900-bg md-hue-2\"><md-tooltip md-direction=\"left\">Cerrar tickets</md-tooltip>\n<md-icon md-svg-src=\"/assets/icons/ticketClose.svg\" aria-label=\"add\"></md-icon></md-button><md-button with-permission \naction=\"export\" access=\"{{F.active.menuItem}}\" \nng-click=\"exportDataToExcel(F.filteredItems,F.active.menuName,currentPage,F.paginate)\" aria-label=\"export\" \nclass=\"md-fab md-raised md-mini md-primary md-hue-2\"><md-tooltip md-direction=\"left\">Exportar a excel</md-tooltip>\n<md-icon md-font-icon=\"icon-file-excel\" aria-label=\"export\"></md-icon></md-button><md-button with-permission \naction=\"copy\" access=\"{{F.active.menuItem}}\" aria-label=\"copy\" ng-click=\"showPayrollModal($event,\'payrolls\')\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">{{\'EC.COPY\' | translate}}\n</md-tooltip><md-icon md-font-icon=\"icon-transfer\" aria-label=\"copy\"></md-icon></md-button><md-button with-permission \naction=\"copy\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length\" aria-label=\"copy\" \nng-click=\"showPayrollModal($event,\'payroll\')\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip \nmd-direction=\"left\">{{\'EC.COPYINCIDENCES\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-transfer\" \naria-label=\"copy\"></md-icon></md-button><md-button with-permission action=\"reopenTicket\" \naccess=\"{{F.active.menuItem}}\" ng-if=\"selected[0].status === 3\" aria-label=\"copy\" ng-click=\"reopenTicket(selected)\" \nclass=\"md-fab md-mini blue-50-bg md-hue-2\"><md-tooltip md-direction=\"left\">{{\'EC.COPYINCIDENCES\' | translate}}\n</md-tooltip><md-icon md-svg-src=\"/assets/icons/reopen.svg\" aria-label=\"add\"></md-icon></md-button></md-fab-actions>\n</md-fab-speed-dial></div></div>");
$templateCache.put("app/main/config/views/users/user.html","<div id=\"user\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill \nng-controller=\"UserController\"><form name=\"form\" novalidate flex layout=\"column\" ng-disabled=\"F.readMode\"><md-toolbar \nclass=\"md-tall header md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" \nlayout-align=\"start center\" flex><md-button with-permission action=\"access\" access=\"{{F.active.menuItem}}\" \nclass=\"goto-button md-icon-button\" aria-label=\"Go to users\" \nng-click=\"R.goToList(F.active.menuName, F.active.menuParams)\" translate translate-attr-aria-label=\"user.GO_TO\"><md-icon\n md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" layout-align=\"start center\"><a \nclass=\"crud-image pointer\" hide-xs ng-click=\"selectedTab = 2\"><img ng-if=\"user.avatar\" ng-src=\"{{user.avatar}}\"> <img \nng-if=\"!user.avatar\" class=\"thumb-image\" ng-src=\"{{F.imagePlaceholder}}\"></a><div layout=\"column\" \nlayout-align=\"start start\"><div class=\"h2\">{{user.data.name}}</div><div class=\"subtitle secondary-text\"><span \nng-if=\"!F.addMode\" translate=\"user.DETAIL\">user Detail</span> <span ng-if=\"F.addMode\" translate=\"user.CREATE\">\nCreate user</span></div></div></div></div><div><md-button ng-if=\"selectedTab == 2\" with-permission action=\"update\" \naccess=\"{{F.active.menuItem}}\" ng-click=\"upload(images, user)\" ng-show=\"images.length && !user.avatar\" \nclass=\"md-raised md-background md-fab md-accent md-hue-1\" aria-label=\"Upload Image\" ng-disabled=\"loadingProgress\">\n<md-tooltip md-direction=\"left\">{{\'EC.UPLOAD_IMAGE\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-upload\">\n</md-icon></md-button><md-button ng-if=\"selectedTab == 2\" with-permission action=\"update\" \naccess=\"{{F.active.menuItem}}\" ng-click=\"removeUpload(user)\" ng-show=\"user.avatar\" \nclass=\"md-warn md-raised md-background md-fab\" aria-label=\"Delete Image\" ng-disabled=\"loadingProgress\"><md-tooltip \nmd-direction=\"left\">{{\'EC.DELETE_IMAGE\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-delete\"></md-icon>\n</md-button><md-button type=\"submit\" ng-if=\"selectedTab !== 2 && !F.addMode && !F.readMode\" with-permission \naction=\"update\" access=\"{{F.active.menuItem}}\" ng-click=\"saveAndMaybeSetGroups(user)\" ng-hide=\"form.$pristine\" \nng-disabled=\"form.$invalid || loadingProgress || !groupsOfUser.length\" \nclass=\"md-raised md-background md-fab md-accent md-hue-1\" aria-label=\"Save user\"><md-tooltip md-direction=\"left\">\n{{\'EC.SAVE\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-content-save\" aria-label=\"Save\"></md-icon>\n</md-button><md-button type=\"submit\" ng-if=\"selectedTab !== 2 && F.addMode\" with-permission action=\"create\" \naccess=\"{{F.active.menuItem}}\" ng-click=\"addAndMaybeSetGroups(user)\" ng-hide=\"form.$pristine\" \nng-disabled=\"form.$invalid || loadingProgress || !groupsOfUser.length\" \nclass=\"md-raised md-background md-fab md-accent md-hue-1\" aria-label=\"Add user\"><md-tooltip md-direction=\"left\">\n{{\'EC.ADD\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-content-save\" aria-label=\"Add\"></md-icon></md-button>\n</div></md-toolbar><md-content layout=\"column\" class=\"content\" flex><md-tabs md-selected=\"selectedTab\" flex \nlayout-fill><md-tab label=\"información\"><md-tab-body><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\"><div layout=\"column\"><md-input-container \nclass=\"md-block\" ng-if=\"F.isDistributor()\" flex><label>Cliente</label><md-select ms2-autofocus \nng-change=\"setAvailableGroups()\" ng-model=\"user.firm\" name=\"firm\" required><md-select-header><input autocomplete=\"off\" \ntype=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"firmSelectFilter\" \nplaceholder=\"Busque un cliente\"></md-select-header><md-option ng-value=\"center.id\" style=\"color: blue\" \nng-repeat=\"center in F.centersData\" ng-bind=\"center.name\"></md-option><md-option ng-value=\"firm.$id\" \nng-repeat=\"firm in L.firms | orderBy:\'name\' | filter:firmSelectFilter\">{{firm.name}}</md-option></md-select><div \nng-messages=\"form.firm.$error\" ng-show=\"form.firm.$touched || form.firm.$dirty\" role=\"alert\"><div \nng-message=\"required\">Cliente es requerido</div></div></md-input-container><md-input-container class=\"md-block\" flex>\n<label>Nombre Completo</label><input ng-disabled=\"F.readMode\" type=\"text\" name=\"name\" ng-model=\"user.data.name\" \nmd-maxlength=\"60\" maxlength=\"60\" autocomplete=\"name\" required><div ng-messages=\"form.name.$error\" \nng-show=\"form.name.$touched || form.name.$dirty\" role=\"alert\"><div ng-message=\"maxlength\">\nNombre Completo no debe tener más de 60 caracteres</div><div ng-message=\"required\">Nombre Completo es requerido</div>\n</div></md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block\" flex><label>Email</label><input\n unique-fb ref=\"profiles\" query=\"data/email\" fromid=\"{{user.$id}}\" type=\"email\" name=\"email\" md-maxlength=\"100\" \nmaxlength=\"100\" ng-model=\"user.data.email\" ng-disabled=\"!F.addMode\" autocomplete=\"email\" required><div \nng-messages=\"form.email.$error\" ng-show=\"form.email.$touched || form.email.$dirty\" role=\"alert\"><div \nng-message=\"maxlength\">Email no debe tener más de 100 caracteres</div><div ng-message=\"required\">Email es requerido\n</div><div ng-message=\"unique\">Email ya está registrado</div><div ng-message=\"email\">Email no es válido</div></div>\n</md-input-container><div flex=\"nogrow\" ng-if=\"!F.addMode && !F.readMode\"><md-button class=\"md-secondary md-raised\" \nng-click=\"showModalChangeEmailDialog($event)\">Cambiar Correo</md-button></div></div><md-input-container \nclass=\"md-block\" ng-if=\"F.addMode\"><label>Contraseña</label><input type=\"password\" name=\"password\" md-maxlength=\"20\" \nmaxlength=\"20\" md-minlength=\"4\" minlength=\"4\" ng-model=\"F.pass\" autocomplete=\"off\" required><div \nng-messages=\"form.password.$error\" ng-show=\"form.password.$touched || form.password.$dirty\" role=\"alert\"><div \nng-message=\"minlength\">Password debe tener al menos 4 caracteres</div><div ng-message=\"maxlength\">\nPassword no debe tener más de 20 caracteres</div><div ng-message=\"required\">Password es requerido</div></div>\n</md-input-container><md-input-container class=\"md-block\"><label>Teléfono</label><input ng-disabled=\"F.readMode\" \ntype=\"text\" name=\"phone\" ng-pattern=\"/^[0-9]{10}$/\" autocomplete=\"phone\" ng-model=\"user.data.phone\"><div \nng-messages=\"form.phone.$error\" ng-show=\"form.phone.$touched || form.phone.$dirty\" role=\"alert\"><div \nng-message=\"pattern\">No es un teléfono válido, debe contener 10 dígitos (0-9)</div></div></md-input-container>\n<md-input-container class=\"md-block\"><label>Dirección</label><textarea ng-disabled=\"F.readMode\" name=\"address\" \nng-model=\"user.data.address\" md-maxlength=\"400\" autocomplete=\"address\" maxlength=\"400\"></textarea><div \nng-messages=\"form.address.$error\" ng-show=\"form.address.$touched || form.address.$dirty\" role=\"alert\"><div \nng-message=\"maxlength\">Dirección no debe tener más de 400 caracteres</div></div></md-input-container></div>\n</md-tab-body></md-tab><md-tab label=\"configuración\"><md-tab-body><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\"><h2 class=\"md-title\">General</h2><md-list>\n<md-list-item ng-if=\"!F.addMode\"><md-icon md-font-icon=\"icon-clipboard-check\"></md-icon><p>Activo</p><md-switch \nclass=\"md-secondary\" name=\"active\" ng-model=\"user.active\" ng-change=\"showDisabledMessage(user.active)\"></md-switch>\n</md-list-item><md-list-item ng-if=\"!F.addMode\"><md-icon ng-class=\"{\'md-primary md-hue-1\': user.emailVerified}\" \nmd-font-icon=\"icon-email-secure\"></md-icon><p>{{(!user.emailVerified) ? \'No \' : \' \'}}Verificado</p></md-list-item>\n<md-list-item ng-if=\"!F.addMode\"><md-icon md-font-icon=\"icon-key-change\"></md-icon><p>Contraseña</p><md-button \nclass=\"md-secondary md-raised\" ng-click=\"showModalSendResetPass($event)\">Enviar correo</md-button><md-button \nclass=\"md-secondary md-raised\" ng-click=\"showModalChangePassword(user.$id,$event)\">Asignar nueva</md-button>\n</md-list-item><md-list-item ng-if=\"!F.addMode && mfa.authorized\"><md-icon md-font-icon=\"icon-lock\" \nng-class=\"{\'md-primary md-hue-1\': mfa.status.enabled}\"></md-icon><p>Doble factor de autenticación <small \nng-if=\"mfa.loaded\">{{mfa.status.enabled ? \'Habilitado\' : \'No habilitado\'}} <span ng-if=\"mfa.status.enabled\">\n({{mfa.status.factorCount}} {{mfa.status.factorCount === 1 ? \'factor\' : \'factores\'}})</span> </small><small \nng-if=\"mfa.loading\">Consultando estado...</small> <small ng-if=\"mfa.error\">No fue posible consultar el estado</small>\n</p><md-progress-circular class=\"md-secondary\" ng-if=\"mfa.loading || mfa.disabling\" md-mode=\"indeterminate\" \nmd-diameter=\"24\"></md-progress-circular><md-button class=\"md-secondary md-raised\" ng-if=\"mfa.error && !mfa.loading\" \nng-click=\"loadMfaStatus()\">Reintentar</md-button><md-button class=\"md-secondary md-raised md-warn\" \nng-if=\"mfa.loaded && mfa.status.enabled\" with-permission action=\"disableMfa\" access=\"config.users\" \nng-disabled=\"mfa.disabling\" ng-click=\"showModalDisableMfa($event)\">Deshabilitar</md-button></md-list-item></md-list><h2\n class=\"md-title\">Grupos</h2><md-chips ng-model=\"groupsOfUser\" ng-change=\"\" md-autocomplete-snap \nmd-on-add=\"setAccessAllPermission()\" md-on-remove=\"setAccessAllPermission()\" md-transform-chip=\"transformChip($chip)\" \nmd-require-match=\"true\"><md-autocomplete md-selected-item=\"groupName\" md-search-text=\"searchGroup\" \nmd-items=\'group in searchGroup|getObjectsLikeTermOfArray:availableGroups:\"name\"\' md-item-text=\"group.name\" \nplaceholder=\"Busque un grupo\"><span md-highlight-text=\"searchGroup\">{{group.name}}</span></md-autocomplete>\n<md-chip-template><span><strong>{{$chip|uppercase}}</strong></span></md-chip-template></md-chips><div \nclass=\"md-chips-messages errorHint\" ng-show=\"!groupsOfUser.length\"><div>El usuario debe tener al menos un grupo</div>\n</div><p class=\"note\">Grupos disponibles: <span ng-repeat=\"group in availableGroups\"><code>{{group.name}}</code></span>\n</p><h2 class=\"md-title\">Nominas y Centros de costo</h2><div ng-if=\"F.addMode\"><code>\nAntes de asignar centros de costos debe guardar al usuario</code></div><div \nng-if=\"userAccessToAllPayrolls && !F.addMode\"><code>Este usuario tiene activo el permiso de acceso a todas las nominas\n</code></div><div ng-if=\"!userAccessToAllPayrolls && !F.addMode\"><md-table-container><table md-table \nclass=\"row-border\"><thead md-head md-order=\"order\"><tr md-row><th md-column width=\"30%\"><div layout=\"row\"><div flex>\n<md-input-container class=\"md-block\"><label>Añadir Nómina</label><md-select class=\"filter\" ng-model=\"newPayroll\" \nplaceholder=\"Nómina\"><md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" \nng-keydown=\"$event.stopPropagation()\" ng-model=\"payrollSelectFilter\" placeholder=\"Busque una nomina\">\n</md-select-header><md-option ng-disabled=\"payroll.$id|getSomethingOfArrayFB:payrollsCcsUser:\'$id\':false\" \nng-if=\"!F.permissionToAccessAllPayrolls\" ng-value=\"payroll\" \nng-repeat=\"payroll in L.payrolls | orderBy:\'name\' | filter:payrollSelectFilter\">{{payroll.name}}</md-option><md-option \nng-disabled=\"payroll.$id|getSomethingOfArrayFB:payrollsCcsUser:\'$id\':false\" ng-if=\"F.permissionToAccessAllPayrolls\" \nng-value=\"payroll\" ng-repeat=\"payroll in L.allPayrolls | orderBy:\'name\' | filter:payrollSelectFilter\">{{payroll.name}}\n</md-option></md-select></md-input-container></div><div flex=\"nogrow\"><md-button class=\"md-icon-button md-primary\" \nng-click=\"addPayrollToUser(newPayroll);newPayroll=null\" ng-disabled=\"!newPayroll\" aria-label=\"Add Payroll\"><md-icon \nmd-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon></md-button></div></div></th><th md-column width=\"70%\"><span>\nCentro de costo</span></th></tr></thead><tbody md-body><tr md-row ng-repeat=\"($index,payroll) in payrollsCcsUser\"><td \nmd-cell width=\"30%\"><md-list><md-list-item class=\"secondary-button-padding\"><p>{{payroll.name}}</p><md-button \nclass=\"md-secondary md-icon-button\" ng-click=\"payrollsCcsUser.splice($index, 1);form.$setDirty();\" \naria-label=\"remove payroll\"><md-icon md-font-icon=\"icon-delete\" aria-label=\"remove\"></md-icon></md-button>\n</md-list-item></md-list></td><td md-cell width=\"70%\"><md-chips ng-model=\"payroll.ccs\" md-autocomplete-snap \nng-disabled=\" !F.addMode\" md-transform-chip=\"transformChip($chip)\" md-require-match=\"true\"><md-autocomplete \nmd-selected-item=\"ccName\" md-search-text=\"searchCc\" md-items=\"cc in getCcsOfPayrolls(searchCc,payroll.$id)\" \nmd-item-text=\"cc.name\" placeholder=\"Busque un centro de costo\"><span md-highlight-text=\"searchCc\">{{cc.name}}</span>\n</md-autocomplete><md-chip-template><span><strong ng-if=\'$chip==\"all\"\'>TODOS</strong> <strong ng-if=\'$chip!=\"all\"\'>\n{{allPayrollsCcs[payroll.$id][$chip].name}}</strong></span></md-chip-template></md-chips></td></tr></tbody></table>\n</md-table-container></div></div></md-tab-body></md-tab><md-tab ng-disabled=\"F.addMode\"><md-tab-label><span \ntranslate=\"user.AVATAR\">User Avatar</span></md-tab-label><md-tab-body><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\"><div class=\"upload-button\" layout=\"column\" \nlayout-align=\"center center\"><h3 ng-hide=\"user.avatar\" class=\"secondary-text\" translate=\"EC.UPLOAD_RULES\">\nOnly PNG & JPG - Max. 2MB</h3><img ng-show=\"user.avatar\" ng-src=\"{{user.avatar}}\" alt=\"Logo\"><lf-ng-md-file-input \nng-show=\"!user.avatar\" lf-files=\"images\" lf-mimetype=\"image/*\" lf-placeholder=\"Imagen\" \nlf-drag-and-drop-label=\"{{\'EC.DROP_TO_UPLOAD\' | translate}}\" lf-browse-label=\"{{\'EC.SEARCH\' | translate}}\" \nlf-remove-label=\"{{\'EC.REMOVE\' | translate}}\" lf-filesize=\"2MB\" name=\"avatar\" lf-api=\"imageApi\" progress preview drag>\n</lf-ng-md-file-input><div ng-messages=\"userForm.logo.$error\" style=\"color:red\"><div ng-message=\"required\">\nThis is required.</div><div ng-message=\"maxcount\">Too many files.</div><div ng-message=\"filesize\">File size too large.\n</div><div ng-message=\"totalsize\">Total size too large.</div><div ng-message=\"mimetype\">Mimetype error.</div></div>\n</div></div></md-tab-body></md-tab><md-tab label=\"Tokens de acceso\" \nng-if=\"F.isAdmin && !F.readMode && (user.uid === F.profile.uid || user.$id === F.profile.uid)\" ng-disabled=\"F.addMode\">\n<md-tab-body><div class=\"auth-tokens-tab-wrapper\" ng-init=\"authTokenContext = {type: \'centerOnly\'}\" \nng-include=\"\'app/main/clients/views/firms/authTokens.html\'\"></div></md-tab-body></md-tab></md-tabs></md-content></form>\n</div>");
$templateCache.put("app/main/config/views/users/users.html","<div id=\"users\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\" ng-controller=\"UsersController\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div fb-search-bar></div><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><div \nfilter-toolbar></div><div table-loader array=\"users\" validations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"users.length\"><thead md-head md-order=\"order\" fix-head>\n<tr md-row><th md-column><span>Avatar</span></th><th md-column md-order-by=\"firm\" ng-if=\"F.isDistributor()\"><span>\nCliente</span></th><th md-column md-order-by=\"data.name\"><span>Nombre</span></th><th md-column \nmd-order-by=\"firstGroupName\"><span>Grupo(s)</span></th><th md-column md-order-by=\"data.email\"><span>Correo</span></th>\n<th md-column md-order-by=\"connected\"><span>Activo</span></th></tr></thead><tbody md-body><tr md-row \nng-class=\'{\"blueC\":F.centers.indexOf(user.firm)>-1}\' md-auto-select md-select=\"user\" md-select-id=\"$id\" \nng-repeat=\"user in (F.filteredItems = (Z.users | filter:F.searchText.user | orderBy:order)) | limitTo: F.paginate: (currentPage - 1) * F.paginate\">\n<td md-cell><img ng-if=\"user.avatar\" class=\"thumb-image\" ng-src=\"{{user.avatar}}\"> <img ng-if=\"!user.avatar\" \nclass=\"thumb-image\" ng-src=\"{{F.imagePlaceholder}}\"></td><td md-cell ng-if=\"F.isDistributor()\">\n{{user[\'firm-name\'] !== \'N/A\' ? user[\'firm-name\'] : user[\'firm-name2\']}}</td><td md-cell>{{user.data.name}}</td><td \nmd-cell><label class=\"text-boxed\" ng-class=\"{\'green-100-bg\':group.accessAll}\" ng-repeat=\"group in user[\'uid-groups\']\">\n{{group.name}}</label></td><td md-cell>{{user.data.email}}</td><td md-cell><div layout=\"row\" \nlayout-align=\"start center\"><active-indicator active=\"user.active\"></active-indicator></div></td></tr></tbody></table>\n</md-table-container><md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" \nng-show=\"users.length\" md-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" md-limit-options=\"F.paginations\" \nmd-page=\"currentPage\" md-on-paginate=\"restartSelected\" md-total=\"{{F.filteredItems.length}}\" md-page-select>\n</md-table-pagination></div></div><md-fab-speed-dial md-open=\"F.isOpen\" \nmd-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\"><md-fab-trigger><md-button \naria-label=\"crud menu\" class=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon></md-button>\n</md-fab-trigger><md-fab-actions><md-button with-permission action=\"read\" access=\"{{F.active.menuItem}}\" \nng-if=\"selected.length == 1\" \nng-click=\'R.goToDetail(null, \"read\", {userId: selected[0].$id, firmId: selected[0].firm})\' aria-label=\"view\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Ver</md-tooltip><md-icon \nmd-font-icon=\"icon-eye\" aria-label=\"view\"></md-icon></md-button><md-button with-permission action=\"update\" \naccess=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" \nng-click=\'R.goToDetail(null, \"update\", {firmId: selected[0].firm, userId: selected[0].$id})\' aria-label=\"Edit\" \nclass=\"md-fab md-raised md-accent md-hue-2 md-mini\"><md-tooltip md-direction=\"left\">{{\'EC.EDIT\' | translate}}\n</md-tooltip><md-icon md-font-icon=\"icon-pencil\" aria-label=\"Edit\"></md-icon></md-button><md-button with-permission \naction=\"remove\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length\" ng-click=\"deActivateUser($event)\" \naria-label=\"Delete\" class=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">\n{{\'EC.REMOVE\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button>\n<md-button with-permission action=\"create\" access=\"{{F.active.menuItem}}\" ng-if=\"!selected.length\" \nng-click=\'R.goToDetail(null, \"update\", {userId: \"new\"})\' aria-label=\"add\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">{{\'EC.ADD\' | translate}}\n</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon></md-button></md-fab-actions>\n</md-fab-speed-dial></div></div>");
$templateCache.put("app/main/employees/views/anniversaryEmployees/anniversaryEmployees.html","<div id=\"{{F.active.menuName}}\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\" \nng-controller=\"EmployeesMovementsController\"><div class=\"top-bg md-accent-bg\"><div with-permission ng-model=\"haveP\" \naction=\"saveSimple\" access=\"{{F.active.menuItem}}\"></div></div><div class=\"center\" layout=\"column\" flex><div \nmongo-search-bar></div><div class=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" \nlayout=\"column\" flex><div list-filters filters-loaded=\"F.filtersLoaded\" ng-model=\"F.filters[F.active.menuName]\" \non-change=\"getThem\" columns-repeat=\"columnsRepeat\" menu-obj-name=\"{{F.active.menuObjName}}\" \nmodel-name=\"{{F.active.menuName}}\" init-filters=\"initFilters\"></div><div table-loader array=\"anniversaryEmployees\" \nvalidations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"anniversaryEmployees.length\"><thead md-head \nmd-order=\"F.orderMongo\" fix-head md-on-reorder=\"getThem\"><tr md-row><th md-column md-order-by=\"data.cc\"><span>\nCentro de Costos</span></th><th md-column md-order-by=\"rp\"><span>RP</span></th><th md-column md-order-by=\"payroll\">\n<span>Nómina</span></th><th md-column md-order-by=\"data.name\"><span>Nombre</span></th><th md-column \nmd-order-by=\"data.name\"><span>Aniversario a cumplir</span></th><th md-column md-order-by=\"data.anniversary.month\">\n<span>Mes de aniversario</span></th><th md-column md-order-by=\"data.anniversary.dateFormat\"><span>Fecha de aniversario\n</span></th></tr></thead><tbody md-body><tr md-row \nng-class=\"{\'inactiveEmployee\': employee.movement.type === 2 || employee.status === 5}\" md-select-id=\"$id\" \nmd-select=\"employee\" ng-repeat=\"employee in anniversaryEmployees\"><td md-cell>{{employee.cc | nameOfL: L.ccs}}</td><td \nmd-cell>{{employee[\'rp-name\']}}</td><td md-cell>{{employee[\'payroll2-class\']}} {{employee[\'payroll-name\']}}</td><td \nmd-cell>{{employee.data.name}}</td><td md-cell>{{employee.data.anniversary.dateFormat | ageOfEmployees}}</td><td \nmd-cell>{{employee.data.anniversary.month | monthName}}</td><td md-cell>{{employee.data.anniversary.dateFormat}}</td>\n</tr></tbody></table></md-table-container><md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" \nlayout-xs=\"column\" ng-show=\"anniversaryEmployees.length\" md-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" \nmd-limit-options=\"F.paginations\" md-page=\"$parent.currentPage\" md-total=\"{{pagination.total}}\" \nmd-on-paginate=\"getThemPagination\" md-page-select></md-table-pagination></div></div><md-fab-speed-dial \nmd-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\"><md-fab-trigger>\n<md-button aria-label=\"crud menu\" class=\"md-fab md-accent\" md-class=\"{\'md-hue-1\': selected.length}\"><md-icon \nmd-font-icon=\"icon-cube\"></md-icon></md-button></md-fab-trigger><md-fab-actions><md-button with-permission \naction=\"export\" access=\"{{F.active.menuItem}}\" \nng-click=\'exportDataToExcelByQuery(anniversaryEmployees,\"anniversaryEmployee\",getParamsObject(),pagination.total,\"catalogs/employees/collection\")\' \naria-label=\"export\" class=\"md-fab md-raised md-mini md-primary md-hue-2\"><md-tooltip md-direction=\"left\">\nExportar a excel</md-tooltip><md-icon md-font-icon=\" icon-file-excel\" aria-label=\"export\"></md-icon></md-button>\n</md-fab-actions></md-fab-speed-dial></div></div>");
$templateCache.put("app/main/employees/views/aniversaryRecords/aniversaryRecord.html","<div id=\"aniversaryRecord\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill \nng-controller=\"EmployeeController\"><form name=\"form\" novalidate flex layout=\"column\" ng-disabled=\"F.readMode\">\n<md-toolbar class=\"md-tall header md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" \nlayout=\"row\" layout-align=\"start center\" flex><md-button class=\"goto-button md-icon-button\" with-permission \naccess=\"{{F.active.menuItem}}\" action=\"access\" aria-label=\"Go to list\" ng-click=\"R.goToList()\" translate \ntranslate-attr-aria-label=\"EC.GO_TO\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" \nlayout-align=\"start center\"><a class=\"crud-image pointer\" hide-xs ng-click=\"selectedTab = 2\"><img \nng-if=\"employee.avatar\" ng-src=\"{{employee.avatar}}\"> <img ng-if=\"!employee.avatar\" class=\"thumb-image\" \nng-src=\"{{F.imagePlaceholder}}\"></a><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\">\nMDS de {{employee.data.name}}</div><div class=\"subtitle secondary-text\"><span ng-if=\"!F.addMode\">\n{{\'EC.DETAIL_OF\' | translate}} Modificación de Salario</span> <span ng-if=\"F.addMode\">\n{{\'EC.CREATE\' | translate}} Modificación de Salario</span></div></div></div></div><div><md-button type=\"submit\" \nng-click=\"apply()\" with-permission action=\"apply\" access=\"{{F.active.menuItem}}\" \nng-disabled=\"form.$invalid || form.$pending || loadingProgress\" \nclass=\"md-raised md-background md-fab md-accent md-hue-1\" aria-label=\"apply mds employee\"><md-tooltip \nmd-direction=\"left\">Aplicar</md-tooltip><md-icon md-font-icon=\"icon-check\" aria-label=\"apply\"></md-icon></md-button>\n</div></md-toolbar><md-content layout=\"column\" class=\"content\"><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\" layout=\"column\"><div form-aniversary></div></div>\n</md-content></form></div>");
$templateCache.put("app/main/employees/views/aniversaryRecords/aniversaryRecords.html","<div id=\"aniversaryRecords\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\" \nng-controller=\"AniversaryRecordsController\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" \nflex><div fb-search-bar></div><div class=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" \nlayout=\"column\" flex><div filter-toolbar></div><div table-loader array=\"Z[F.active.menuName]\" \nvalidations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"F.filteredItems.length\"><thead md-head \nmd-order=\"order\" fix-head><tr md-row><th md-column md-order-by=\"payroll\"><span>Nómina</span></th><th md-column \nmd-order-by=\"nss\"><span>NSS</span></th><th md-column md-order-by=\"name\"><span>Nombre</span></th><th md-column \nmd-order-by=\"enroleDate\"><span>Alta</span></th><th md-column md-order-by=\"seniorityDate\"><span>Antigüedad</span></th>\n<th md-column md-order-by=\"sd\"><span>SD</span></th><th md-column md-order-by=\"sbc\"><span>SBC</span></th><th md-column \nmd-order-by=\"enroleDate\"><span>Años</span></th><th md-column md-order-by=\"factor\"><span>Factor</span></th><th \nmd-column md-order-by=\"newSbc\"><span>Nuevo SBC</span></th></tr></thead><tbody md-body><tr md-row md-auto-select \nmd-select=\"employee\" md-select-id=\"$id\" \nng-repeat=\"employee in (F.filteredItems = (Z[F.active.menuName] | filter:F.searchText[F.active.menuObjName] | orderBy:order)) | limitTo: F.paginate: (currentPage - 1) * F.paginate\">\n<td md-cell>{{employee.payroll | nameOfL:L.allPayrolls}}</td><td md-cell>{{employee.nss}}</td><td md-cell>\n{{employee.name}}</td><td md-cell ng-class=\'{\"strongItem\":!employee.hasSeniorityDate}\'>\n{{employee.enroleDate| date:F.dateFormat}}</td><td md-cell ng-class=\'{\"strongItem\":employee.hasSeniorityDate}\'>\n{{employee.seniorityDate?(employee.seniorityDate| date:F.dateFormat):\'\'}}</td><td md-cell>{{employee.sd | currency}}\n</td><td md-cell>{{employee.sbc | currency}}</td><td md-cell>\n{{( (employee.hasSeniorityDate?employee.seniorityDate:employee.enroleDate) | amDifference : null : \'years\') *(-1)}}\n</td><td md-cell>{{employee.factor}}</td><td md-cell>{{employee.newSbc|currency}}</td></tr></tbody></table>\n</md-table-container><md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" \nng-show=\"F.filteredItems.length\" md-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" \nmd-limit-options=\"F.paginations\" md-page=\"currentPage\" md-on-paginate=\"restartSelected\" \nmd-total=\"{{F.filteredItems.length}}\" md-page-select></md-table-pagination></div></div><md-fab-speed-dial \nmd-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\"><md-fab-trigger>\n<md-button aria-label=\"crud menu\" class=\"md-fab md-accent\" md-class=\"{\'md-hue-1\': selected.length}\"><md-icon \nmd-font-icon=\"icon-cube\"></md-icon></md-button></md-fab-trigger><md-fab-actions><md-button with-permission \naction=\"apply\" access=\"{{F.active.menuItem}}\" ng-show=\"selected.length == 1\" ng-click=\"goToApply(selected[0])\" \naria-label=\"Apply\" class=\"md-fab md-raised md-primary md-mini\"><md-tooltip md-direction=\"left\">Aplicar</md-tooltip>\n<md-icon md-font-icon=\"icon-check\" aria-label=\"apply icon\"></md-icon></md-button></md-fab-actions></md-fab-speed-dial>\n</div></div>");
$templateCache.put("app/main/employees/views/contracts/contract.html","<div id=\"contract\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill \nng-controller=\"ContractController\"><form name=\"form\" novalidate flex layout=\"column\" ng-disabled=\"F.readMode\"><div \nmongo-crud-detail-bar flex=\"nogrow\"></div><md-content layout=\"column\" class=\"content\" flex><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\"><document document=\"contract\" form=\"form\" \nget-extras=\"getExtras\" obj-name=\"F.active.menuObjName\" mobject-loaded=\"mainObjectLoaded\" employee=\"employee\" \non-select-employee=\"validateEmployee\"></document><md-checkbox ng-model=\"contract.active\" ng-if=\"!F.addMode\">Activo\n</md-checkbox></div></md-content></form></div>");
$templateCache.put("app/main/employees/views/contracts/contracts.html","<div id=\"contracts\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\" ng-controller=\"ContractsController\">\n<div class=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div mongo-search-bar></div><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><div \nlist-filters filters-loaded=\"F.filtersLoaded\" ng-model=\"F.filters[F.active.menuName]\" on-change=\"getThem\" \ncolumns-repeat=\"columnsRepeat\" menu-obj-name=\"{{F.active.menuObjName}}\" model-name=\"{{F.active.menuName}}\" \ninit-filters=\"initFilters\"></div><div table-loader array=\"contracts\" validations=\"validations\"></div>\n<md-table-container class=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table \nmd-row-select multiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"contracts.length\"><thead md-head \nmd-order=\"F.orderMongo\" fix-head md-on-reorder=\"getThem\"><tr md-row><th md-column md-order-by=\"employeeName\"><span>\nEmpleado</span></th><th md-column md-order-by=\"payroll-name\"><span>Nomina</span></th><th md-column \nmd-order-by=\"startDate\"><span>Inicio</span></th><th md-column md-order-by=\"startDate\"><span>Duración</span></th><th \nmd-column md-order-by=\"endDate\"><span>Fin</span></th><th md-column md-order-by=\"type\"><span>Tipo de contrato</span>\n</th><th md-column md-order-by=\"valid\"><span>Vigente</span></th></tr></thead><tbody md-body><tr md-row md-auto-select \nmd-select=\"contract\" md-select-id=\"_id\" ng-repeat=\"contract in contracts\"><td md-cell>{{contract[\"employeeName\"]}}</td>\n<td md-cell>{{contract[\"payroll-name\"]}}</td><td md-cell>{{contract.startDate | date:F.dateFormat}}</td><td md-cell>\n{{contract.duration}}</td><td md-cell>{{contract.endDate | date:F.dateFormat}}</td><td md-cell>\n{{contract.documentType | nameOfM : M.documentTypes}}</td><td md-cell><div layout=\"row\" layout-align=\"start center\">\n<active-indicator active=\"contract.active\"></active-indicator></div></td></tr></tbody></table></md-table-container>\n<md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" ng-show=\"contracts.length\" \nmd-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" md-limit-options=\"F.paginations\" md-page=\"$parent.currentPage\" \nmd-total=\"{{pagination.total}}\" md-on-paginate=\"getThemPagination\" md-page-select></md-table-pagination></div></div>\n<md-fab-speed-dial md-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" \nclass=\"ms2-speed-dial bottom right\"><md-fab-trigger><md-button aria-label=\"crud menu\" \nclass=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon></md-button></md-fab-trigger>\n<md-fab-actions><md-button with-permission action=\"update\" access=\"{{F.active.menuItem}}\" \nng-if=\"selected.length == 1 && !selected[0].signed\" ng-click=\"R.goToDetail(selected[0])\" aria-label=\"edit\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Editar</md-tooltip><md-icon \nmd-font-icon=\"icon-pencil\" aria-label=\"edit\"></md-icon></md-button><md-button with-permission action=\"generatePdf\" \naccess=\"{{F.active.menuItem}}\" ng-show=\"selected.length>0\" ng-click=\"printPDF($event)\" aria-label=\"generatePDF\" \nclass=\"md-fab md-raised md-mini md-primary md-hue-3\"><md-tooltip md-direction=\"left\">PDF</md-tooltip><md-icon \nmd-font-icon=\"icon-file-pdf\" aria-label=\"print pdf\"></md-icon></md-button><md-button with-permission action=\"remove\" \naccess=\"{{F.active.menuItem}}\" ng-if=\"selected.length && !(selected|recordsHaveValue:\'signed\':true:\'any\')\" \nng-click=\"delete($event)\" aria-label=\"Delete\" class=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">\n{{\'EC.REMOVE\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button>\n<md-button with-permission action=\"create\" access=\"{{F.active.menuItem}}\" ng-if=\"!selected.length\" \nng-click=\'R.goToDetail(\"new\")\' aria-label=\"add\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip \nmd-direction=\"left\">{{\'EC.ADD\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon>\n</md-button><md-button access=\"{{F.active.menuItem}}\" ng-show=\"selected.length == 1\" \nng-click=\'showDocument(selected[0]._id,\"show\")\' aria-label=\"Read\" class=\"md-fab md-raised md-primary md-mini\">\n<md-tooltip md-direction=\"left\">Ver Contrato</md-tooltip><md-icon md-font-icon=\"icon-book-open\" aria-label=\"read icon\">\n</md-icon></md-button></md-fab-actions></md-fab-speed-dial></div></div>");
$templateCache.put("app/main/employees/views/credits/credit.html","<div id=\"{{F.active.menuObjName}}\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill \nng-controller=\"CreditController\"><form name=\"form\" novalidate flex layout=\"column\" ng-disabled=\"F.readMode\"><md-toolbar\n class=\"md-tall header md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" \nlayout-align=\"start center\" flex><md-button with-permission action=\"access\" access=\"{{F.active.menuItem}}\" \nclass=\"goto-button md-icon-button\" aria-label=\"Go to list\" ng-click=\"R.goToList()\" translate \ntranslate-attr-aria-label=\"EC.GO_TO\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" \nlayout-align=\"start center\"><md-icon \nmd-font-icon=\"{{F.menuItems[F.active.menuParent][F.active.menuName].icon || F.default.icon}}\" class=\"crud-icon\">\n</md-icon><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\">{{F.active.detailObject.data.name}}</div><div\n class=\"subtitle secondary-text\"><span ng-if=\"!F.addMode\">\n{{\'EC.DETAIL_OF\' | translate}} {{F.active.menuObjName + \'.SINGULAR\' | translate}}</span> <span ng-if=\"F.addMode\">\n{{\'EC.CREATE\' | translate}} {{F.active.menuObjName + \'.SINGULAR\' | translate}}</span></div></div></div></div><div>\n<md-button type=\"submit\" ng-if=\"!F.addMode && objectLoaded\" with-permission action=\"update\" \naccess=\"{{F.active.menuItem}}\" ng-click=\"saveAndSetMiniCredit(F.active.detailObject)\" \nng-hide=\"form.$pristine && !objectLoaded\" \nng-disabled=\"form.$invalid || form.$pending || loadingProgress || F.readMode\" \nclass=\"md-raised md-background md-fab md-accent md-hue-1\" aria-label=\"Save\"><md-tooltip md-direction=\"left\">\n{{\'EC.SAVE\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-content-save\" aria-label=\"Save\"></md-icon>\n</md-button><md-button type=\"submit\" ng-if=\"F.addMode && objectLoaded && form.$valid\" with-permission action=\"create\" \naccess=\"{{F.active.menuItem}}\" ng-click=\"createCreditAndNotify(F.active.detailObject)\" \nng-hide=\"form.$pristine && !objectLoaded\" ng-disabled=\"form.$invalid || form.$pending || loadingProgress\" \nclass=\"md-raised md-background md-fab md-accent md-hue-1\" aria-label=\"Add\"><md-tooltip md-direction=\"left\">\n{{\'EC.ADD\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-content-save\" aria-label=\"Add\"></md-icon></md-button>\n<validate-form-button></validate-form-button></div></md-toolbar><md-content layout=\"column\" class=\"content\" flex><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\" layout=\"column\"><div form-credit></div></div>\n</md-content></form></div>");
$templateCache.put("app/main/employees/views/credits/credits.html","<div id=\"{{F.active.menuName}}\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\" \nng-controller=\"CreditsController\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div \nmongo-search-bar></div><div class=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" \nlayout=\"column\" flex><div list-filters filters-loaded=\"F.filtersLoaded\" ng-model=\"F.filters[F.active.menuName]\" \non-change=\"getThem\" columns-repeat=\"columnsRepeat\" menu-obj-name=\"{{F.active.menuObjName}}\" \nmodel-name=\"{{F.active.menuName}}\" init-filters=\"initFilters\"></div><div table-loader array=\"credits\" \nvalidations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"credits.length\"><thead md-head md-order=\"F.orderMongo\" \nfix-head md-on-reorder=\"getThem\"><tr md-row><th md-column><span>Registro Patronal</span></th><th md-column><span>Nómina\n</span></th><th md-column md-order-by=\"data.nss\"><span>NSS</span></th><th md-column md-order-by=\"data.name\"><span>\nEmpleado</span></th><th md-column md-order-by=\"data.type\"><span>Tipo</span></th><th md-column md-order-by=\"data.date\">\n<span>Fecha de Inicio</span></th><th md-column md-order-by=\"data.factor\"><span>Factor</span></th><th md-column \nmd-order-by=\"data.account\"><span>No.</span></th><th md-column md-order-by=\"valid\"><span>Vigente</span></th><th \nmd-column md-order-by=\"data.newFactor\"><span>Nuevo Factor</span></th><th md-column md-order-by=\"data.diffFactor\"><span>\nFactor diferente</span></th><th md-column md-order-by=\"data.untilDate\"><span>Fecha de actualización</span></th></tr>\n</thead><tbody md-body><tr md-row md-auto-select md-select=\"credit\" md-select-id=\"$id\" ng-repeat=\"credit in credits\">\n<td md-cell>{{credit[\'employee-rp\'] | nameOfL:L.rps}}</td><td md-cell>{{credit[\'payroll-name\']}}</td><td md-cell>\n{{credit.data.nss}}</td><td md-cell>{{credit.data.name}}</td><td md-cell>{{credit.data.type}}</td><td md-cell>\n{{credit.data.date|date:F.dateFormat}}</td><td md-cell>{{credit.data.factor}}</td><td md-cell>{{credit.data.account}}\n</td><td md-cell><div layout=\"row\" layout-align=\"start center\"><active-indicator active=\"credit.valid\">\n</active-indicator></div></td><td md-cell>{{credit.data.newFactor}}</td><td md-cell>{{credit.data.diffFactor?\'✓\':\'\'}}\n</td><td md-cell>{{credit.data.untilDate|date:F.dateFormat}}</td></tr></tbody></table></md-table-container>\n<md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" ng-show=\"credits.length\" \nmd-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" md-limit-options=\"F.paginations\" md-page=\"$parent.currentPage\" \nmd-total=\"{{pagination.total}}\" md-on-paginate=\"getThemPagination\" md-page-select></md-table-pagination></div></div>\n<md-fab-speed-dial md-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" \nclass=\"ms2-speed-dial bottom right\"><md-fab-trigger><md-button aria-label=\"crud menu\" class=\"md-fab md-accent\" \nmd-class=\"{\'md-hue-1\': selected.length}\"><md-icon md-font-icon=\"icon-cube\"></md-icon></md-button></md-fab-trigger>\n<md-fab-actions><md-button with-permission action=\"read\" access=\"{{F.active.menuItem}}\" ng-show=\"selected.length == 1\" \nng-click=\'R.goToDetail(selected[0], \"read\", {employeeId: selected[0].employee, creditId: selected[0].$id})\' \naria-label=\"Read\" class=\"md-fab md-raised md-primary md-mini\"><md-tooltip md-direction=\"left\">Ver</md-tooltip><md-icon \nmd-font-icon=\"icon-eye\" aria-label=\"read icon\"></md-icon></md-button><md-button with-permission action=\"export\" \naccess=\"{{F.active.menuItem}}\" \nng-click=\'exportDataToExcelByQuery(credits,\"credits\",getParamsObject(),pagination.total,\"catalogs/credits/collection\")\' \naria-label=\"export\" class=\"md-fab md-raised md-mini md-primary md-hue-2\"><md-tooltip md-direction=\"left\">\nExportar a excel</md-tooltip><md-icon md-font-icon=\" icon-file-excel\" aria-label=\"export\"></md-icon></md-button>\n<md-button with-permission action=\"create\" access=\"{{F.active.menuItem}}\" ng-show=\"!selected.length\" \nng-click=\'R.goToDetail(\"new\", \"create\")\' aria-label=\"add\" class=\"md-fab md-raised md-mini md-accent md-hue-2\">\n<md-tooltip md-direction=\"left\">{{\'EC.ADD\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-plus\" \naria-label=\"add\"></md-icon></md-button><md-button with-permission ng-if=\"selected.length>0\" \naction=\"downloadEmployeeInfonavit\" access=\"{{F.active.menuItem}}\" ng-click=\"getReportInfonavit(selected)\" \naria-label=\"downloadEmployeeInfonavit\" class=\"md-fab md-raised md-mini md-warn-fg\"><md-tooltip md-direction=\"left\">\nDescargar aviso</md-tooltip><md-icon md-svg-src=\"/assets/icons/infonavitpdf.svg\" \naria-label=\"downloadEmployeeInfonavit\"></md-icon></md-button><md-button \nng-show=\"selected.length === 0 || selected[0].data.nss\" with-permission action=\"validateEmployeeInfonavit\" \naccess=\"{{F.active.menuItem}}\" ng-click=\'checkCredit($event, selected, \"validate\")\' \naria-label=\"validateEmployeeInfonavit\" class=\"md-fab md-raised md-mini md-warn-fg\"><md-tooltip md-direction=\"left\">\nVerificar créditos</md-tooltip><md-icon md-svg-src=\"/assets/icons/infonavit.svg\" \naria-label=\"validateEmployeeInfonavit\"></md-icon></md-button><md-button with-permission action=\"create\" \naccess=\"{{F.active.menuItem}}\" ng-show=\"selected.length==1\" ng-click=\"goToDetail(selected[0])\" aria-label=\"add\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">{{\'EC.CLONE\' | translate}}\n</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"clone\"></md-icon></md-button><md-button with-permission \naction=\"disableCredits\" access=\"{{F.active.menuItem}}\" \nng-show=\'selected.length > 0 && (selected|recordsHaveValue:\"valid\":true)\' ng-click=\"disableCredits(selected)\" \naria-label=\"disableCredits\" class=\"md-fab md-raised md-mini md-warn\"><md-tooltip md-direction=\"left\">Desactivar crédito\n</md-tooltip><md-icon md-font-icon=\"icon-link-off\" aria-label=\"disableCredits\"></md-icon></md-button><md-button \nwith-permission action=\"activeCredits\" access=\"{{F.active.menuItem}}\" \nng-show=\"selected.length > 0 && !selected[0].valid\" \nng-click=\'activeCredits(selected) && (selected|recordsHaveValue:\"valid\":false)\' aria-label=\"activeCredits\" \nclass=\"md-fab md-raised md-mini md-green-A400-bg .grey-50-fg\"><md-tooltip md-direction=\"left\">Activar crédito\n</md-tooltip><md-icon md-font-icon=\"icon-link\" aria-label=\"activeCredits\"></md-icon></md-button><md-button \nwith-permission action=\"remove\" access=\"{{F.active.menuItem}}\" ng-show=\"selected.length\" \nng-click=\"deleteWithMiniCredit($event)\" aria-label=\"Delete\" class=\"md-fab md-raised md-warn md-mini\"><md-tooltip \nmd-direction=\"left\">{{\'EC.REMOVE\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\">\n</md-icon></md-button><md-button with-permission action=\"update\" access=\"{{F.active.menuItem}}\" \nng-show=\"selected.length == 1\" \nng-click=\'R.goToDetail(selected[0], \"update\", {employeeId: selected[0].employee, creditId: selected[0].$id})\' \naria-label=\"edit\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Editar\n</md-tooltip><md-icon md-font-icon=\"icon-pencil\" aria-label=\"edit\"></md-icon></md-button><md-button with-permission \naction=\"importCredits\" access=\"{{F.active.menuItem}}\" ng-click=\"importarCredits()\" aria-label=\"edit\" \nclass=\"md-fab md-mini md-red-900-bg md-hue-2\"><md-tooltip md-direction=\"left\">Importart creditos</md-tooltip><md-icon \nmd-svg-src=\"/assets/icons/importCredits.svg\" aria-label=\"edit\"></md-icon></md-button><a with-permission \ntarget=\"_blank\" action=\"notice\" rel=\"noopener noreferrer\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" \nng-href=\'{{\"http://201.134.132.175/PublicacionAvisoWeb/PublicacionAvisoServlet?numcred=\" + selected[0].data.account}}\' \naria-label=\"Notice\" class=\"md-button md-fab md-raised md-mini md-primary\"><md-tooltip md-direction=\"left\">\nAviso de Crédito</md-tooltip><md-icon md-font-icon=\"icon-alert\" aria-label=\"notice\"></md-icon></a></md-fab-actions>\n</md-fab-speed-dial></div></div>");
$templateCache.put("app/main/employees/views/dismissesRecords/dismissesRecord.html","<div id=\"{{F.active.menuObjName}}\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill \nng-controller=\"EmployeeController\"><form name=\"form\" novalidate flex layout=\"column\" ng-disabled=\"F.readMode\">\n<md-toolbar class=\"md-tall header md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" \nlayout=\"row\" layout-align=\"start center\" flex><md-button class=\"goto-button md-icon-button\" \naria-label=\"Go to employees\" ng-click=\"goToList()\" translate translate-attr-aria-label=\"EC.GO_TO\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" layout-align=\"start center\"><a \nclass=\"crud-image pointer\" hide-xs ng-click=\"selectedTab = 2\"><img ng-if=\"employee.avatar\" \nng-src=\"{{employee.avatar}}\"> <img ng-if=\"!employee.avatar\" class=\"thumb-image\" ng-src=\"{{F.imagePlaceholder}}\"></a>\n<div layout=\"column\" layout-align=\"start start\"><div class=\"h2\">Baja de {{employee.data.name}}</div><div \nclass=\"subtitle secondary-text\"><span ng-if=\"!F.addMode\">{{\'EC.DETAIL_OF\' | translate}} Baja</span> <span \nng-if=\"F.addMode\">{{\'EC.CREATE\' | translate}} Baja</span></div></div></div></div><div><md-button \nng-if=\' form.$valid && F.active.menuAction == \"update\" && F.active.menuName == \"dismissesRecords\"\' type=\"submit\" \nng-click=\"saveAndUpdateMovement(movement, employee)\" with-permission action=\"update\" access=\"{{F.active.menuItem}}\" \nng-hide=\"form.$pristine\" ng-disabled=\"form.$invalid || form.$pending || loadingProgress\" \nclass=\"md-raised md-background md-fab md-accent md-hue-1\" aria-label=\"Update employee\"><md-tooltip md-direction=\"left\">\nActualizar baja</md-tooltip><md-icon md-font-icon=\"icon-content-save\" aria-label=\"edit icon\"></md-icon></md-button>\n<md-button ng-if=\"form.$valid\" type=\"submit\" ng-click=\"dismiss(employee)\" with-permission action=\"dismiss\" \naccess=\"{{F.active.menuItem}}\" ng-hide=\"form.$pristine\" ng-disabled=\"form.$invalid || loadingProgress\" \nclass=\"md-raised md-background md-fab md-accent md-hue-1\" aria-label=\"Dismiss employee\"><md-tooltip \nmd-direction=\"left\">Baja</md-tooltip><md-icon md-font-icon=\"icon-account-minus\" aria-label=\"dismiss icon\"></md-icon>\n</md-button><validate-form-button></validate-form-button></div></md-toolbar><md-content layout=\"column\" \nclass=\"content\" flex><div class=\"detail-form-container md-background-bg md-whiteframe-1dp\" layout=\"column\"><div \nform-dismiss></div></div></md-content></form></div>");
$templateCache.put("app/main/employees/views/dismissesRecords/dismissesRecords.html","<div id=\"{{F.active.menuName}}\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\" \nng-controller=\"EmployeesMovementsController\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" \nlayout=\"column\" flex><div fb-search-bar></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><div filter-toolbar></div><div table-loader \narray=\"Z[F.active.menuName]\" validations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"F.filteredItems.length\"><thead md-head \nmd-order=\"order\" fix-head><tr md-row><th md-column md-order-by=\"rp\"><span>RP</span></th><th md-column \nmd-order-by=\"payroll\"><span>Nómina</span></th><th md-column md-order-by=\"data.nss\"><span>NSS</span></th><th md-column \nmd-order-by=\"data.name\"><span>Nombre</span></th><th md-column md-order-by=\"data.curp\"><span>Tipo</span></th><th \nmd-column md-order-by=\"data.salary.sd\"><span>SD</span></th><th md-column md-order-by=\"data.salary.sbc\"><span>SBC</span>\n</th><th md-column md-order-by=\"data.dismissDate\"><span>Fecha</span></th></tr></thead><tbody md-body><tr md-row \nmd-auto-select md-select=\"employee\" md-select-id=\"$id\" \nng-repeat=\"employee in (F.filteredItems = (Z[F.active.menuName] | filter:F.searchText[F.active.menuObjName] | orderBy:order)) | limitTo: F.paginate: (currentPage - 1) * F.paginate\">\n<td md-cell>{{employee.rp | nameOfL:L.rps}}</td><td md-cell>{{employee.payroll | nameOfL:L.allPayrolls}}</td><td \nmd-cell>{{employee.data.nss}}</td><td md-cell>{{employee.data.name}}<md-icon ng-if=\"employee.movement.fromSettlement\" \nmd-font-icon=\"icon-flip-to-front\"></md-icon></td><td md-cell>{{employee.movement.dismissType | nameOfM:M.dismissTypes}}\n</td><td md-cell>{{employee.data.salary.sd | currency}}</td><td md-cell>{{employee.data.salary.sbc | currency}}</td><td\n md-cell>{{employee.data.dismissDate| date:F.dateFormat}}</td></tr></tbody></table></md-table-container>\n<md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" \nng-show=\"F.filteredItems.length\" md-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" \nmd-limit-options=\"F.paginations\" md-page=\"currentPage\" md-on-paginate=\"restartSelected\" \nmd-total=\"{{F.filteredItems.length}}\" md-page-select></md-table-pagination></div></div><md-fab-speed-dial \nmd-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\"><md-fab-trigger>\n<md-button aria-label=\"crud menu\" class=\"md-fab md-accent\" md-class=\"{\'md-hue-1\': selected.length}\"><md-icon \nmd-font-icon=\"icon-cube\"></md-icon></md-button></md-fab-trigger><md-fab-actions><md-button with-permission \naction=\"export\" access=\"{{F.active.menuItem}}\" \nng-click=\"exportDataToExcel(F.filteredItems,F.active.menuName,currentPage,F.paginate)\" aria-label=\"export\" \nclass=\"md-fab md-raised md-mini md-primary md-hue-2\"><md-tooltip md-direction=\"left\">Exportar a excel</md-tooltip>\n<md-icon md-font-icon=\" icon-file-excel\" aria-label=\"export\"></md-icon></md-button><md-button with-permission \naction=\"read\" access=\"{{F.active.menuItem}}\" ng-show=\"selected.length == 1\" \nng-click=\'R.goToDetail(selected[0], \"read\", {employeeId: selected[0].$id, movementId: selected[0].movement.uid})\' \naria-label=\"Read\" class=\"md-fab md-raised md-primary md-mini\"><md-tooltip md-direction=\"left\">Ver</md-tooltip><md-icon \nmd-font-icon=\"icon-eye\" aria-label=\"read icon\"></md-icon></md-button><md-button with-permission action=\"update\" \naccess=\"{{F.active.menuItem}}\" ng-show=\"selected.length == 1\" \nng-click=\'R.goToDetail(null, \"update\", {employeeId: selected[0].$id, movementId: selected[0].movement.uid})\' \naria-label=\"update\" class=\"md-fab md-raised md-primary md-mini\"><md-tooltip md-direction=\"left\">Editar</md-tooltip>\n<md-icon md-font-icon=\"icon-pencil\" aria-label=\"edit icon\"></md-icon></md-button><md-button with-permission \naction=\"sendToIdse\" access=\"{{F.active.menuItem}}\" ng-show=\"selected.length\" ng-click=\"moveEmployees($event, 3)\" \naria-label=\"moveEmployees\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">\nMandar a IDSE</md-tooltip><md-icon md-font-icon=\"icon-arrow-right-bold-hexagon-outline\" aria-label=\"move\"></md-icon>\n</md-button><md-button with-permission action=\"getIdse\" access=\"{{F.active.menuItem}}\" ng-show=\"selected.length\" \nng-click=\'getInterface(\"idse\")\' aria-label=\"getIdse\" class=\"md-fab md-raised md-mini md-primary md-hue-3\"><md-tooltip \nmd-direction=\"left\">IDSE</md-tooltip><md-icon md-svg-src=\"/assets/icons/IDSE.svg\" aria-label=\"idse\"></md-icon>\n</md-button><md-button with-permission action=\"getSua\" access=\"{{F.active.menuItem}}\" ng-show=\"selected.length\" \nng-click=\'getInterface(\"sua\")\' aria-label=\"getSua\" class=\"md-fab md-raised md-mini md-primary md-hue-3\"><md-tooltip \nmd-direction=\"left\">Layout Baja</md-tooltip><md-icon md-svg-src=\"/assets/icons/SUA.svg\" aria-label=\"sua\"></md-icon>\n</md-button><md-button with-permission action=\"sendToUnconfirmed\" access=\"{{F.active.menuItem}}\" \nng-show=\"selected.length\" ng-click=\"sendToUnconfirmedConfirm($event)\" aria-label=\"send to unconfirmed dismisses\" \nclass=\"md-fab md-mini md-warn md-hue-2\"><md-tooltip md-direction=\"left\">Mandar a bajas por confirmar</md-tooltip>\n<md-icon md-font-icon=\"icon-pin\" aria-label=\"cancel\"></md-icon></md-button><md-button with-permission \naction=\"cancelMovement\" access=\"movements.revisions\" ng-show=\"selected.length == 1\" \nng-click=\"cancelLastMovement($event)\" aria-label=\"cancel last movement\" class=\"md-fab md-mini md-warn md-hue-2\">\n<md-tooltip md-direction=\"left\">Cancelar Último Movimiento</md-tooltip><md-icon md-font-icon=\"icon-close\" \naria-label=\"cancel\"></md-icon></md-button></md-fab-actions></md-fab-speed-dial></div></div>");
$templateCache.put("app/main/employees/views/dismissesUnconfirmedRecords/dismissesUnconfirmedRecord.html","<div id=\"{{F.active.menuObjName}}\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill \nng-controller=\"EmployeeController\"><form name=\"form\" novalidate flex layout=\"column\" ng-disabled=\"F.readMode\">\n<md-toolbar class=\"md-tall header md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" \nlayout=\"row\" layout-align=\"start center\" flex><md-button class=\"goto-button md-icon-button\" with-permission \naccess=\"{{F.active.menuItem}}\" action=\"access\" aria-label=\"Go to list\" ng-click=\"R.goToList()\" translate \ntranslate-attr-aria-label=\"EC.GO_TO\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" \nlayout-align=\"start center\"><a class=\"crud-image pointer\" hide-xs ng-click=\"selectedTab = 2\"><img \nng-if=\"employee.avatar\" ng-src=\"{{employee.avatar}}\"> <img ng-if=\"!employee.avatar\" class=\"thumb-image\" \nng-src=\"{{F.imagePlaceholder}}\"></a><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\">\nBaja por confirmar de {{employee.data.name}}</div><div class=\"subtitle secondary-text\"><span ng-if=\"!F.addMode\">\n{{\'EC.DETAIL_OF\' | translate}} Baja</span> <span ng-if=\"F.addMode\">{{\'EC.CREATE\' | translate}} Baja</span></div></div>\n</div></div><div><md-button type=\"submit\" ng-click=\"saveAndUpdateMovement(movement, employee)\" with-permission \naction=\"update\" ng-if=\'F.active.menuAction == \"update\" && F.active.menuName == \"dismissesRecords\"\' \naccess=\"{{F.active.menuItem}}\" ng-hide=\"form.$pristine\" \nng-disabled=\"form.$invalid || form.$pending || loadingProgress\" \nclass=\"md-raised md-background md-fab md-accent md-hue-1\" aria-label=\"Update employee\"><md-tooltip md-direction=\"left\">\nActualizar baja</md-tooltip><md-icon md-font-icon=\"icon-content-save\" aria-label=\"edit icon\"></md-icon></md-button>\n<md-button type=\"submit\" ng-click=\"dismiss(employee)\" with-permission action=\"dismiss\" access=\"{{F.active.menuItem}}\" \nng-hide=\"form.$pristine\" ng-disabled=\"form.$invalid || loadingProgress\" \nclass=\"md-raised md-background md-fab md-accent md-hue-1\" aria-label=\"Dismiss employee\"><md-tooltip \nmd-direction=\"left\">Baja</md-tooltip><md-icon md-font-icon=\"icon-account-minus\" aria-label=\"dismiss icon\"></md-icon>\n</md-button></div></md-toolbar><md-content layout=\"column\" class=\"content\" flex><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\" layout=\"column\"><div form-dismiss></div></div>\n</md-content></form></div>");
$templateCache.put("app/main/employees/views/dismissesUnconfirmedRecords/dismissesUnconfirmedRecords.html","<div id=\"{{F.active.menuName}}\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\" \nng-controller=\"EmployeesMovementsController\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" \nlayout=\"column\" flex><div fb-search-bar></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><div filter-toolbar></div><div table-loader \narray=\"Z[F.active.menuName]\" validations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"F.filteredItems.length\"><thead md-head \nmd-order=\"order\" fix-head><tr md-row><th md-column md-order-by=\"rp\"><span>RP</span></th><th md-column \nmd-order-by=\"payroll\"><span>Nómina</span></th><th md-column md-order-by=\"data.nss\"><span>NSS</span></th><th md-column \nmd-order-by=\"data.name\"><span>Nombre</span></th><th md-column md-order-by=\"data.curp\"><span>Tipo</span></th><th \nmd-column md-order-by=\"data.salary.sd\"><span>SD</span></th><th md-column md-order-by=\"data.salary.sbc\"><span>SBC</span>\n</th><th md-column md-order-by=\"data.dismissDate\"><span>Fecha</span></th></tr></thead><tbody md-body><tr md-row \nmd-auto-select md-select=\"employee\" md-select-id=\"$id\" \nng-repeat=\"employee in (F.filteredItems = (Z[F.active.menuName] | filter:F.searchText[F.active.menuObjName] | orderBy:order)) | limitTo: F.paginate: (currentPage - 1) * F.paginate\">\n<td md-cell>{{employee.rp | nameOfL:L.rps}}</td><td md-cell>{{employee.payroll | nameOfL:L.allPayrolls}}</td><td \nmd-cell>{{employee.data.nss}}</td><td md-cell>{{employee.data.name}}</td><td md-cell>\n{{employee.movement.dismissType | nameOfM:M.dismissTypes}}</td><td md-cell>{{employee.data.salary.sd | currency}}</td>\n<td md-cell>{{employee.data.salary.sbc | currency}}</td><td md-cell>{{employee.data.dismissDate| date:F.dateFormat}}\n</td></tr></tbody></table></md-table-container><md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" \nlayout-xs=\"column\" ng-show=\"F.filteredItems.length\" md-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" \nmd-limit-options=\"F.paginations\" md-page=\"currentPage\" md-on-paginate=\"restartSelected\" \nmd-total=\"{{F.filteredItems.length}}\" md-page-select></md-table-pagination></div></div><md-fab-speed-dial \nmd-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\"><md-fab-trigger>\n<md-button aria-label=\"crud menu\" class=\"md-fab md-accent\" md-class=\"{\'md-hue-1\': selected.length}\"><md-icon \nmd-font-icon=\"icon-cube\"></md-icon></md-button></md-fab-trigger><md-fab-actions><md-button with-permission \naction=\"export\" access=\"{{F.active.menuItem}}\" \nng-click=\"exportDataToExcel(F.filteredItems,F.active.menuName,currentPage,F.paginate)\" aria-label=\"export\" \nclass=\"md-fab md-raised md-mini md-primary md-hue-2\"><md-tooltip md-direction=\"left\">Exportar a excel</md-tooltip>\n<md-icon md-font-icon=\" icon-file-excel\" aria-label=\"export\"></md-icon></md-button><md-button with-permission \naction=\"read\" access=\"{{F.active.menuItem}}\" ng-show=\"selected.length == 1\" \nng-click=\'R.goToDetail(selected[0], \"read\", {employeeId: selected[0].$id, movementId: selected[0].movement.uid})\' \naria-label=\"Read\" class=\"md-fab md-raised md-primary md-mini\"><md-tooltip md-direction=\"left\">Ver</md-tooltip><md-icon \nmd-font-icon=\"icon-eye\" aria-label=\"read icon\"></md-icon></md-button><md-button with-permission action=\"update\" \naccess=\"{{F.active.menuItem}}\" ng-show=\"selected.length == 1\" \nng-click=\'R.goToDetail(null, \"update\", {employeeId: selected[0].$id, movementId: selected[0].movement.uid})\' \naria-label=\"update\" class=\"md-fab md-raised md-primary md-mini\"><md-tooltip md-direction=\"left\">Editar</md-tooltip>\n<md-icon md-font-icon=\"icon-pencil\" aria-label=\"edit icon\"></md-icon></md-button><md-button with-permission \naction=\"returnToDissmisses\" access=\"{{F.active.menuItem}}\" ng-show=\"selected.length\" \nng-click=\"sendToDismissesConfirm($event)\" aria-label=\"send to dismisses\" class=\"md-fab md-mini md-primary md-hue-2\">\n<md-tooltip md-direction=\"left\">Mandar a bajas</md-tooltip><md-icon md-font-icon=\"icon-pin-off\" \naria-label=\"send dismisses\"></md-icon></md-button></md-fab-actions></md-fab-speed-dial></div></div>");
$templateCache.put("app/main/employees/views/documentTypes/documentType.html","<div id=\"documentType\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill \nng-controller=\"DocumentTypeController\"><form name=\"form\" novalidate flex layout=\"column\" ng-disabled=\"F.readMode\"><div \nmongo-crud-detail-bar flex=\"nogrow\"></div><md-content layout=\"column\" class=\"content\" flex><md-tabs \nmd-selected=\"selectedTab\" flex layout-fill><md-tab label=\"Información\"><md-tab-body><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\" layout=\"column\"><md-card class=\"layout-card\"><div \nlayout=\"row\" layout-xs=\"column\"><md-input-container class=\"md-block no-errors-spacer\" flex class=\"md-block\"><label>\nNombre</label><input ng-disabled=\"F.readMode\" ms2-autofocus placeholder=\"Nombre\" class=\"uppercased\" type=\"text\" \nname=\"name\" ng-model=\"documentType.name\" required md-maxlength=\"100\" ng-model-options=\"{ debounce: F.debounceTime }\" \nmaxlength=\"100\"><div ng-messages=\"form.name.$error\" role=\"alert\"><div ng-message=\"required\">Nombre es requerido</div>\n<div ng-message=\"maxlength\">Nombre no debe tener más de 100 caracteres</div></div></md-input-container>\n<md-input-container flex class=\"md-block no-errors-spacer\"><label>Llave</label><input ng-disabled=\"F.readMode\" \nplaceholder=\"Llave\" type=\"text\" name=\"key\" ng-required=\"documentType.type!==\'contract\'\" ng-model=\"documentType.key\">\n<div ng-messages=\"form.key.$error\" role=\"alert\"><div ng-message=\"required\">Llave es requerida</div></div>\n</md-input-container><md-input-container flex class=\"md-block no-errors-spacer\"><label>Tipo de documento</label>\n<md-select ng-disabled=\"F.readMode\" name=\"type\" ng-model=\"documentType.type\" required><md-select-header><input \nautocomplete=\"off\" type=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"typeSelectFilter\" \nplaceholder=\"Busque un tipo de documento\"></md-select-header><md-option ng-value=\"document.id\" \nng-repeat=\"document in (F.documentTypes | filter : typeSelectFilter) track by document.id\">{{document.name}}\n</md-option></md-select><div class=\"md-errors-spacer\"></div><div ng-messages=\"form.type.$error\" \nng-show=\"form.type.$touched || form.type.$dirty\" role=\"alert\"><div ng-message=\"required\">Tipo de documento es requerido\n</div></div></md-input-container></div><div layout=\"row\"><md-input-container flex class=\"md-block no-errors-spacer\">\n<label>Cliente</label><md-select ng-disabled=\"F.readMode\" name=\"firm\" ng-model=\"documentType.firm\" required>\n<md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" \nng-model=\"firmSelectFilter\" placeholder=\"Busque un cliente\"></md-select-header><md-option value=\"global\">Global\n</md-option><md-option ng-value=\"firm.$id\" ng-repeat=\"firm in L.firms | orderBy:\'name\' | filter:firmSelectFilter\">\n{{firm.name}}</md-option></md-select><div class=\"md-errors-spacer\"></div><div ng-messages=\"form.firm.$error\" \nng-show=\"form.firm.$touched || form.firm.$dirty\" role=\"alert\"><div ng-message=\"required\">Cliente es requerido</div>\n</div></md-input-container><md-input-container flex-xs=\"100\" flex=\"30\" class=\"md-block no-errors-spacer\"><label>\nContenido</label><md-select ng-disabled=\"F.readMode\" name=\"contentType\" ng-model=\"documentType.contentType\" required>\n<md-option value=\"template\">Template</md-option><md-option value=\"file\">Archivo</md-option></md-select><div \nclass=\"md-errors-spacer\"></div><div ng-messages=\"form.contentType.$error\" \nng-show=\"form.contentType.$touched || form.contentType.$dirty\" role=\"alert\"><div ng-message=\"required\">\nTipo de contenido es requerido</div></div></md-input-container><md-input-container flex \nng-if=\'documentType.type===\"contract\"\' class=\"md-block no-errors-spacer\"><label>Contrato SAT</label><md-select \nng-disabled=\"F.readMode\" name=\"satContractType\" \nng-change=\"setData(documentType.satContractType,F.contractSatTypes,documentType,\'satContractType\')\" \nng-model=\"documentType.satContractType\"><md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" \nng-keydown=\"$event.stopPropagation()\" ng-model=\"typeSatSelectFilter\" placeholder=\"Seleccione un tipo de contrato SAT\">\n</md-select-header><md-option>Ninguno</md-option><md-option ng-value=\"contractType.id\" \nng-repeat=\"contractType in (F.contractSatTypes | filter : typeSatSelectFilter) track by contractType.id\">\n{{contractType.id}} - {{contractType.name}}</md-option></md-select><div class=\"md-errors-spacer\"></div><div \nng-messages=\"form.satContractType.$error\" ng-show=\"form.satContractType.$touched || form.satContractType.$dirty\" \nrole=\"alert\"><div ng-message=\"required\">Tipo de contrato SAT es requerido</div></div></md-input-container></div>\n<md-switch ng-model=\"documentType.allowMany\" ng-if=\"[\'generalsRequired\',\'generals\'].indexOf(documentType.type)>-1\" \naria-label=\" Permitir Varios\" ng-if=\'[\"generals\",\"generalRequired\"].indexOf(documentType.type) > -1\'>Permitir Varios\n</md-switch></md-card></div></md-tab-body></md-tab><md-tab label=\"Contrato\" \nng-if=\"documentType.contentType ===\'template\'\"><md-tab-body><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\" layout=\"column\"><div><md-card class=\"layout-card\">\n<md-card-title class=\"pb-0 pt-0\"><div><h3>Campos de contrato disponibles</h3></div></md-card-title><md-card-content \nclass=\"mb-0 pb-0 pr-0\" flex=\"nogrow\"><div class=\"chip\" flex=\"nogrow\" ng-repeat=\"fields in specifics\"><div \nclass=\"chip-content\">{{fields}}</div></div><md-chips ng-model=\"documentType.notRequiredFields\" md-autocomplete-snap \nclass=\"mt-10\" ng-disabled=\" !F.addMode\" md-transform-chip=\"transformChip($chip)\" md-require-match=\"true\">\n<md-autocomplete md-search-text=\"searchVariable\" class=\"custom-template\" \nmd-items=\"item in specifics | filter: searchVariable\" md-item-text=\"item\" \nplaceholder=\"Selecciona los campos no requeridos\"><span md-highlight-text=\"searchVariable\">{{item}}</span>\n</md-autocomplete></md-chips><md-switch ng-model=\"documentType.editionMode\" aria-label=\"Modo Edicion\">Modo edición\n</md-switch></md-card-content></md-card></div><md-card class=\"layout-card\"><md-card-content><md-input-container \nclass=\"md-block\"><label>Estilos</label><textarea ng-disabled=\"F.readMode\" style=\"max-height: 300px;overflow: auto\" \nplaceholder=\"Estilos\" name=\"styles\" rows=\"10\" ng-model=\"documentType.styles\" required></textarea><div \nng-messages=\"form.styles.$error\" role=\"alert\"></div></md-input-container></md-card-content></md-card><md-card \nclass=\"layout-card\"><md-card-content><div text-angular required ng-model=\"documentType.content\"></div>\n</md-card-content></md-card></div></md-tab-body></md-tab><md-tab label=\"Campos\" \nng-if=\"documentType.contentType ===\'template\'\"><md-tab-body><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\"><md-card class=\"layout-card\"><fieldset><legend>\nCampos Personalizados<md-button ng-click=\"addElement(documentType,\'fields\',{})\" aria-label=\"Add\" \nclass=\"md-icon-button\"><md-icon md-font-icon=\"icon-plus-circle-outline\"></md-icon></md-button></legend><div \nng-repeat=\"($index,field) in documentType.fields\" flex class=\"noErrorSpaces\"><div layout=\"row\" \nlayout-align=\"end start\"><div flex=\"nogrow\"><md-button aria-label=\"Delete\" class=\"md-icon-button\" \nng-click=\"documentType.fields.splice($index,1);form.$setDirty();\"><md-icon md-font-icon=\"icon-trash\"></md-icon>\n</md-button><md-button ng-disabled=\"$first\" aria-label=\"Move Up\" class=\"md-icon-button\" \nng-click=\"documentType.fields.splice($index-1,0,documentType.fields.splice($index,1)[0]);form.$setDirty();\"><md-icon \nmd-font-icon=\"icon-arrow-up-bold-hexagon-outline\"></md-icon></md-button><md-button ng-disabled=\"$last\" \naria-label=\"Move Down\" class=\"md-icon-button\" \nng-click=\"documentType.fields.splice($index+1,0,documentType.fields.splice($index,1)[0]);form.$setDirty();\"><md-icon \nmd-font-icon=\"icon-arrow-down-bold-hexagon-outline\"></md-icon></md-button></div></div><div layout=\"row\" layout-wrap>\n<md-input-container flex flex-xs=\"100\" class=\"md-block mb-0\"><label>ID</label><input type=\"text\" name=\"id-{{$index}}\" \nng-model=\"field.id\" required><div ng-messages=\'form[\"id-\"+$index].$error\' role=\"alert\"><div ng-message=\"required\">\nEste dato es requerido</div></div></md-input-container><md-input-container flex flex-xs=\"100\" class=\"md-block mb-0\">\n<label>Nombre</label><input type=\"text\" name=\"label-{{$index}}\" ng-model=\"field.label\" required><div \nng-messages=\'form[\"label-\"+$index].$error\' role=\"alert\"><div ng-message=\"required\">Este dato es requerido</div></div>\n</md-input-container><md-input-container flex flex-xs=\"100\" class=\"md-block mb-0\"><label>Tamaño</label><input \ntype=\"text\" name=\"width-{{$index}}\" ng-model=\"field.width\"></md-input-container><md-input-container flex flex-xs=\"100\" \nclass=\"md-block mb-0\"><label>Tipo de campo</label><md-select ng-model=\"field.type\" name=\"type-{{$index}}\" required>\n<md-option ng-value=\"inputType.id\" ng-repeat=\"inputType in F.inputTypes\">{{inputType.value}}</md-option></md-select>\n<div ng-messages=\'form[\"type-\"+$index].$error\' role=\"alert\"><div ng-message=\"required\">Este dato es requerido</div>\n</div></md-input-container><div flex=\"100\" layout=\"column\" ng-if=\"field.type===\'select\'\"><fieldset><legend>Valores\n<md-button ng-click=\"addElement(field,\'values\',{})\" aria-label=\"Add\" class=\"md-icon-button\"><md-icon \nmd-font-icon=\"icon-plus-circle-outline\"></md-icon></md-button></legend><div \nng-repeat=\"($index2,value) in field.values\" layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" \nflex=\"33\" class=\"md-block mb-0\"><label>ID Valor</label><input type=\"text\" required name=\"id-{{$index}}-{{$index2}}\" \nng-model=\"value.id\"><div ng-messages=\'form[\"id-\"+$index+\"-\"+$index2].$error\' role=\"alert\"><div ng-message=\"required\">\nEste dato es requerido</div></div></md-input-container><md-input-container flex=\"100\" flex=\"33\" class=\"md-block mb-0\">\n<label>Nombre</label><input type=\"text\" required name=\"name-{{$index}}-{{$index2}}\" ng-model=\"value.name\"><div \nng-messages=\'form[\"name-\"+$index+\"-\"+$index2].$error\' role=\"alert\"><div ng-message=\"required\">Este dato es requerido\n</div></div></md-input-container><md-input-container flex=\"100\" flex=\"33\" class=\"md-block mb-0\"><label>Descripción\n</label><input type=\"text\" name=\"description-{{$index}}-{{$index2}}\" ng-model=\"value.description\"><div \nng-messages=\'form[\"description-\"+$index+\"-\"+$index2].$error\' role=\"alert\"><div ng-message=\"required\">\nEste dato es requerido</div></div></md-input-container></div></fieldset></div><div flex=\"100\"></div><md-input-container\n flex=\"25\" flex-xs=\"50\" class=\"md-block mb-0\" ng-if=\"field.type===\'autocompleteM\'\"><label>Catalogo</label><input \ntype=\"text\" name=\"catalog-{{$index}}\" ng-model=\"field.catalog\" required><div \nng-messages=\'form[\"catalog-\"+$index].$error\' role=\"alert\"><div ng-message=\"required\">Este dato es requerido</div></div>\n</md-input-container><md-input-container flex=\"25\" flex-xs=\"50\" class=\"md-block mb-0\" \nng-if=\"field.type===\'autocompleteM\'\"><label>Campos a consultar</label><input type=\"text\" name=\"query-{{$index}}\" \nng-model=\"field.query\" required><div ng-messages=\'form[\"query-\"+$index].$error\' role=\"alert\"><div \nng-message=\"required\">Este dato es requerido</div></div></md-input-container><md-input-container flex=\"25\" \nflex-xs=\"50\" class=\"md-block mb-0\" ng-if=\"field.type===\'autocompleteM\'\"><label>Campos a regresar</label><input \ntype=\"text\" name=\"project-{{$index}}\" ng-model=\"field.project\" required><div \nng-messages=\'form[\"project-\"+$index].$error\' role=\"alert\"><div ng-message=\"required\">Este dato es requerido</div></div>\n</md-input-container><md-input-container flex=\"25\" flex-xs=\"50\" class=\"md-block mb-0\" \nng-if=\"field.type===\'autocompleteM\'\"><label>Campo a mostrar</label><input type=\"text\" name=\"itemName-{{$index}}\" \nng-model=\"field.itemName\" required><div ng-messages=\'form[\"itemName-\"+$index].$error\' role=\"alert\"><div \nng-message=\"required\">Este dato es requerido</div></div></md-input-container><md-input-container flex=\"50\" \nflex-xs=\"100\" class=\"md-block mb-0\" ng-if=\"[\'select\',\'autocompleteM\'].indexOf(field.type)==-1\"><label>Valor default\n</label><input type=\"text\" name=\"defaultValue-{{$index}}\" ng-model=\"field.defaultValue\"><div \nng-messages=\'form[\"defaultValue-\"+$index].$error\' role=\"alert\"><div ng-message=\"required\">Este dato es requerido</div>\n</div></md-input-container><md-input-container flex=\"50\" flex-xs=\"100\" class=\"md-block mb-0\"><label>Validación</label>\n<input type=\"text\" name=\"validation-{{$index}}\" ng-model=\"field.validation\"><div \nng-messages=\'form[\"validation-\"+$index].$error\' role=\"alert\"><div ng-message=\"required\">Este dato es requerido</div>\n</div></md-input-container><md-input-container ng-if=\"field.type!==\'autocompleteM\'\" flex flex-xs=\"100\" \nclass=\"md-block mb-0\"><label>Mínimo</label><input type=\"number\" name=\"min-{{$index}}\" ng-model=\"field.min\">\n</md-input-container><md-input-container ng-if=\"field.type!==\'autocompleteM\'\" flex flex-xs=\"100\" class=\"md-block mb-0\">\n<label>Maximo</label><input type=\"number\" name=\"max-{{$index}}\" ng-model=\"field.max\"></md-input-container><div \nflex=\"nogrow\" flex-xs=\"100\" class=\"pl-5 pr-5\"><md-switch ng-model=\"field.required\" aria-label=\"Requerido\">Requerido\n</md-switch></div><div flex=\"nogrow\" flex-xs=\"100\" class=\"pl-5 pr-5\"><md-switch ng-model=\"field.readonly\" \naria-label=\"Solo lectura\">Solo lectura</md-switch></div><div ng-if=\"field.type===\'text\'\" flex=\"nogrow\" flex-xs=\"100\" \nclass=\"pl-5 pr-5\"><md-switch ng-model=\"field.allowLowerCase\" aria-label=\"Solo lectura\">Permitir minúsculas</md-switch>\n</div></div><hr ng-if=\"!$last\"></div></fieldset></md-card></div></md-tab-body></md-tab></md-tabs></md-content></form>\n</div>");
$templateCache.put("app/main/employees/views/documentTypes/documentTypes.html","<div id=\"documentTypes\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div mongo-search-bar></div><div class=\"content-card\" layout=\"column\" \nflex><div class=\"content fullpage-datatable\" layout=\"column\" flex><div list-filters filters-loaded=\"F.filtersLoaded\" \nng-model=\"F.filters[F.active.menuName]\" on-change=\"getThem\" columns-repeat=\"columnsRepeat\" \nmenu-obj-name=\"{{F.active.menuObjName}}\" model-name=\"{{F.active.menuName}}\" init-filters=\"initFilters\"></div><div \ntable-loader array=\"documentTypes\" validations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"documentTypes.length\"><thead md-head \nmd-order=\"F.orderMongo\" fix-head md-on-reorder=\"getThem\"><tr md-row><th md-column md-order-by=\"name\"><span>Nombre\n</span></th><th md-column md-order-by=\"key\"><span>Llave</span></th><th md-column md-order-by=\"type\"><span>Tipo</span>\n</th><th md-column md-order-by=\"allowMany\"><span>Permitir Varios</span></th><th md-column md-order-by=\"firm\"><span>\nEmpresa</span></th></tr></thead><tbody md-body><tr md-row md-auto-select md-select=\"documentType\" md-select-id=\"_id\" \nng-repeat=\"documentType in documentTypes\"><td md-cell>{{documentType.name}}</td><td md-cell>{{documentType.key}}</td>\n<td md-cell>{{documentType.type | getSomethingOfArrayFB : F.documentTypes : \'name\' : undefined : \'id\'}}</td><td \nmd-cell>{{documentType.allowMany?\'Si\':\'No\'}}</td><td md-cell>\n{{documentType.firm === \'global\' ? \'GLOBAL\' : (documentType.firm | getSomethingOfArrayFB : L.firms : \'name\' : \'S/E\')}}\n</td></tr></tbody></table></md-table-container><md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" \nlayout-xs=\"column\" ng-show=\"documentTypes.length\" md-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" \nmd-limit-options=\"F.paginations\" md-page=\"currentPage\" md-total=\"{{pagination.total}}\" \nmd-on-paginate=\"getThemPagination\" md-page-select></md-table-pagination></div></div><md-fab-speed-dial \nmd-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\"><md-fab-trigger>\n<md-button aria-label=\"crud menu\" class=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon>\n</md-button></md-fab-trigger><md-fab-actions><md-button with-permission action=\"update\" access=\"{{F.active.menuItem}}\" \nng-if=\"selected.length == 1\" ng-click=\"R.goToDetail(selected[0])\" aria-label=\"edit\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Editar</md-tooltip><md-icon \nmd-font-icon=\"icon-pencil\" aria-label=\"edit\"></md-icon></md-button><md-button with-permission action=\"remove\" \naccess=\"{{F.active.menuItem}}\" ng-if=\"selected.length\" ng-click=\"delete($event)\" aria-label=\"Delete\" \nclass=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">{{\'EC.REMOVE\' | translate}}</md-tooltip>\n<md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button><md-button with-permission \naction=\"create\" access=\"{{F.active.menuItem}}\" ng-if=\"!selected.length\" ng-click=\'R.goToDetail(\"new\")\' \naria-label=\"add\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">\n{{\'EC.ADD\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon></md-button>\n</md-fab-actions></md-fab-speed-dial></div></div>");
$templateCache.put("app/main/employees/views/documents/document.html","<div class=\"document\"><md-autocomplete flex required md-items=\"item in searchEmployeeForDocument(searchEmployee)\" \nmd-search-text=\"searchEmployee\" md-selected-item=\"employee\" md-selected-item-change=\"employeeSelected(employee,true)\" \nmd-item-text=\"item.data.name\" md-no-cache=\"true\" md-require-match=\"true\" md-min-length=\"4\" \nmd-menu-class=\"customEmployeeDocument\" md-menu-class=\"autocomplete-employee-template\" \nmd-input-name=\"autocompleteField\" md-floating-label=\"Empleado\" md-escape-options=\"clear\"><md-item-template><span \nmd-highlight-text=\"searchEmployee\">{{item.data.nss?item.data.nss+\' - \':\'\'}}{{item.data.name}}</span></md-item-template>\n<div ng-messages=\"form.autocompleteField.$error\" ng-if=\"form.autocompleteField.$touched\"><div ng-message=\"required\">\nDebe seleccionar un empleado.</div><div ng-message=\"md-require-match\">Seleccione un empleado lista.</div></div>\n</md-autocomplete><div layout-gt-xs=\"row\" layout=\"column\"><md-input-container flex class=\"md-block\"><label>Nómina\n</label><input type=\"text\" name=\"payroll\" ng-model=\"payroll.name\" disabled=\"true\" required><div \nng-messages=\"form.payroll.$error\" ng-show=\"form.payroll.$touched || form.payroll.$dirty\" role=\"alert\"><div \nng-message=\"required\">Nomina es requerido</div></div></md-input-container><md-input-container flex class=\"md-block\">\n<label>Tipo de documento</label><md-select ng-model=\"document.documentType\" name=\"documentType\" required \nng-change=\"getExtras()\" ng-disabled=\'readMode || objName===\"contract\"\'><md-option value=\"\">Ninguno</md-option>\n<md-option ng-value=\"type._id\" ng-repeat=\"type in objTypes\">{{type.name}}</md-option></md-select><div \nng-messages=\"form.documentType.$error\" role=\"alert\"><div ng-message=\"required\">Tipo de documento es requerido</div>\n</div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><custom-fields flex fields=\"fields\" \nmain-object=\"document\" form=\"form\"></custom-fields></div><md-input-container flex=\"100\" class=\"md-block\"><label>\nComentarios</label><textarea ng-disabled=\"readMode\" class=\"uppercased\" rows=\"3\" name=\"comments\" \nng-model=\"document.comments\" md-maxlength=\"350\" maxlength=\"350\" notdeletespecialcharts=\"true\" \nng-model-options=\"{ debounce: 1000 }\"></textarea><div ng-messages=\"form.comments.$error\" role=\"alert\"><div \nng-message=\"maxlength\">Comentarios no debe tener más de 350 caracteres</div></div></md-input-container></div>");
$templateCache.put("app/main/employees/views/employeeBirths/employeeBirth.html","<div id=\"contract\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill \nng-controller=\"EmployeesMovementsController\"><form name=\"form\" novalidate flex layout=\"column\" \nng-disabled=\"F.readMode\"><div mongo-crud-detail-bar flex=\"nogrow\"></div><md-content layout=\"column\" class=\"content\" \nflex><div class=\"detail-form-container md-background-bg md-whiteframe-1dp\"><document document=\"contract\" form=\"form\" \nget-extras=\"getExtras\" obj-name=\"F.active.menuObjName\" mobject-loaded=\"mainObjectLoaded\" employee=\"employee\" \non-select-employee=\"validateEmployee\"></document><md-checkbox ng-model=\"contract.active\" ng-if=\"!F.addMode\">Activo\n</md-checkbox></div></md-content></form></div>");
$templateCache.put("app/main/employees/views/employeeBirths/employeeBirths.html","<div id=\"{{F.active.menuName}}\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\" \nng-controller=\"EmployeesMovementsController\"><div class=\"top-bg md-accent-bg\"><div with-permission ng-model=\"haveP\" \naction=\"saveSimple\" access=\"{{F.active.menuItem}}\"></div></div><div class=\"center\" layout=\"column\" flex><div \nmongo-search-bar></div><div class=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" \nlayout=\"column\" flex><div list-filters filters-loaded=\"F.filtersLoaded\" ng-model=\"F.filters[F.active.menuName]\" \non-change=\"getThem\" columns-repeat=\"columnsRepeat\" menu-obj-name=\"{{F.active.menuObjName}}\" \nmodel-name=\"{{F.active.menuName}}\" init-filters=\"initFilters\"></div><div table-loader array=\"employeeBirths\" \nvalidations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"employeeBirths.length\"><thead md-head \nmd-order=\"F.orderMongo\" fix-head md-on-reorder=\"getThem\"><tr md-row><th md-column md-order-by=\"data.cc\"><span>\nCentro de Costos</span></th><th md-column md-order-by=\"rp\"><span>RP</span></th><th md-column md-order-by=\"payroll\">\n<span>Nómina</span></th><th md-column md-order-by=\"data.name\"><span>Nombre</span></th><th md-column \nmd-order-by=\"data.name\"><span>Edad a cumplir</span></th><th md-column md-order-by=\"data.info.birth.month\"><span>\nMes de cumpleaños</span></th><th md-column md-order-by=\"data.info.birth.dateFormat\"><span>Fecha de cumpleaños</span>\n</th></tr></thead><tbody md-body><tr md-row \nng-class=\"{\'inactiveEmployee\': employee.movement.type === 2 || employee.status === 5}\" md-select-id=\"$id\" \nmd-select=\"employee\" ng-repeat=\"employee in employeeBirths\"><td md-cell>{{employee.cc | nameOfL: L.ccs}}</td><td \nmd-cell>{{employee[\'rp-name\']}}</td><td md-cell>{{employee[\'payroll2-class\']}} {{employee[\'payroll-name\']}}</td><td \nmd-cell>{{employee.data.name}}</td><td md-cell>{{employee.data.info.birth.dateFormat | ageOfEmployees}}</td><td \nmd-cell>{{employee.data.info.birth.month | monthName}}</td><td md-cell>{{employee.data.info.birth.dateFormat}}</td>\n</tr></tbody></table></md-table-container><md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" \nlayout-xs=\"column\" ng-show=\"employeeBirths.length\" md-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" \nmd-limit-options=\"F.paginations\" md-page=\"$parent.currentPage\" md-total=\"{{pagination.total}}\" \nmd-on-paginate=\"getThemPagination\" md-page-select></md-table-pagination></div></div><md-fab-speed-dial \nmd-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\"><md-fab-trigger>\n<md-button aria-label=\"crud menu\" class=\"md-fab md-accent\" md-class=\"{\'md-hue-1\': selected.length}\"><md-icon \nmd-font-icon=\"icon-cube\"></md-icon></md-button></md-fab-trigger><md-fab-actions><md-button with-permission \naction=\"export\" access=\"{{F.active.menuItem}}\" \nng-click=\'exportDataToExcelByQuery(employeeBirths,\"birthEmployees\",getParamsObject(),pagination.total,\"catalogs/employees/collection\")\' \naria-label=\"export\" class=\"md-fab md-raised md-mini md-primary md-hue-2\"><md-tooltip md-direction=\"left\">\nExportar a excel</md-tooltip><md-icon md-font-icon=\" icon-file-excel\" aria-label=\"export\"></md-icon></md-button>\n</md-fab-actions></md-fab-speed-dial></div></div>");
$templateCache.put("app/main/employees/views/employeeFiles/employeeFile.html","<div id=\"employeeFile\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill \nng-controller=\"EmployeeFileController as efctrl\"><form name=\"form\" novalidate flex layout=\"column\" \nng-disabled=\"F.readMode\"><md-toolbar class=\"md-tall header md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button with-permission action=\"access\" \naccess=\"{{F.active.menuItem}}\" class=\"goto-button md-icon-button\" aria-label=\"Go to employeeFiles\" \nng-click=\"R.goToList()\" translate translate-attr-aria-label=\"EC.GO_TO\"><md-icon md-font-icon=\"icon-arrow-left\">\n</md-icon></md-button><div layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"{{F.menuItems.clients.employeeFiles.icon || F.default.icon}}\" class=\"crud-icon\"></md-icon><div \nlayout=\"column\" layout-align=\"start start\"><div class=\"h2\">{{efctrl.employee.data.name}}</div><div \nclass=\"subtitle secondary-text\"><span ng-if=\"!F.addMode\">\n{{\'EC.DETAIL_OF\' | translate}} {{\'employeeFile.SINGULAR\' | translate}}</span> <span ng-if=\"F.addMode\">\n{{\'EC.CREATE\' | translate}} {{\'employeeFile.SINGULAR\' | translate}}</span></div></div></div></div></md-toolbar>\n<md-content layout=\"column\" class=\"content\" flex><div class=\"detail-form-container md-background-bg md-whiteframe-1dp\" \nlayout=\"column\"><md-autocomplete class=\"md-block\" flex md-min-length=\"2\" md-selected-item=\"efctrl.employee\" \nmd-search-text=\"efctrl.searchEmployee\" \nmd-selected-item-change=\"efctrl.employeeFile.employeeId=efctrl.employee.fid;efctrl.loadEmployee(efctrl.employee)\" \nmd-item-text=\"item.data.name\" md-delay=\"500\" \nmd-items=\'item in autocompleteListM(efctrl.searchEmployee, \"employees\",[\"data.name\",\"data.nss\"],{project:{data:1,firm:1,fid:1,status:1}})\' \nmd-require-match=\"true\" md-select-on-match=\"true\" md-match-case-insensitive=\"true\" placeholder=\"Empleado\" \nmd-no-cache=\"true\" ng-init=\"efctrl.searchEmployee=efctrl.employee.data.name\" md-floating-label=\"Empleado\" required>\n<md-item-template><span md-highlight-text=\"searchEmployee\" ng-class=\"{\'inactiveOption\': (item.status==5)}\">\n{{item.data.nss?item.data.nss+\' - \':\'\'}}{{item.data.name}}</span></md-item-template><md-not-found>No hay registros\n</md-not-found></md-autocomplete><fieldset ng-if=\"efctrl.employeeFile.employeeId\"><legend>Archivos<md-button \nng-if=\"!efctrl.showUpload\" ng-click=\"efctrl.showUpload=true\" aria-label=\"Add\" class=\"md-icon-button\"><md-icon \nmd-font-icon=\"icon-plus-circle-outline\"></md-icon></md-button><md-button ng-if=\"efctrl.showUpload\" \nng-click=\"efctrl.showUpload=false\" aria-label=\"Remove\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-cancel\">\n</md-icon></md-button></legend><h2 ng-if=\"efctrl.docs.length===0 && !efctrl.showUpload\">\nNo hay ningún documento del empleado</h2><div ng-if=\"efctrl.showUpload\" flex><md-input-container class=\"md-block\" \nflex=\"nogrow\"><label>Tipo de documento</label><md-select ng-disabled=\"F.readMode\" name=\"documentType\" \nng-model=\"efctrl.employeeFile.documentType\" required><md-select-header><input autocomplete=\"off\" type=\"search\" \nclass=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"documentTypeSelectFilter\" \nplaceholder=\"Busque una tipo de documento\"></md-select-header><md-option \nng-class=\"{\'text-bold\':docType.type===\'generalsRequired\'}\" \nng-disabled=\"efctrl.exists(docType.key,docType.allowMany,efctrl.docs)\" ng-value=\"docType.key\" \nng-repeat=\"docType in efctrl.docTypes | orderBy:[\'-type\',\'name\'] | filter : documentTypeSelectFilter\">{{docType.name}}\n<strong ng-if=\"docType.type===\'generalsRequired\'\">*</strong></md-option></md-select><div \nng-messages=\"form.documentType.$error\" role=\"alert\"><div ng-message=\"required\">Debe seleccionar el tipo de documento\n</div></div></md-input-container><div layout=\"row\"><div flex><lf-ng-md-file-input lf-files=\"efctrl.files\" \nlf-placeholder=\"Selecciona un archivo\" lf-drag-and-drop-label=\"Max: 2MB\" lf-browse-label=\"{{\'EC.search\' | translate}}\" \nlf-remove-label=\"{{\'EC.remove\' | translate}}\" lf-filesize=\"4MB\" lf-required lf-mimetype=\"application/pdf\" \naccept=\"application/pdf\" name=\"fileToUpload\" lf-api=\"efctrl.fileToUpload\"></lf-ng-md-file-input><div \nng-messages=\"form.fileToUpload.$error\" style=\"color:red\"><div ng-message=\"required\">Archivo requerido</div><div \nng-message=\"maxcount\">Demasiados archivos</div><div ng-message=\"filesize\">Archivo demasiado grande</div><div \nng-message=\"totalsize\">Espacio total demasiado grande</div><div ng-message=\"mimetype\">Formato de archivo no valido\n</div></div></div><div flex=\"nogrow\" layout=\"row\"><div flex=\"nogrow\"><md-button ng-if=\"!efctrl.uploading\" \nng-disabled=\"form.$invalid \" ng-click=\"efctrl.uploadFile(efctrl.files,efctrl.employeeFile)\" \nclass=\"md-fab md-mini md-accent\" aria-label=\"upload\"><md-icon md-font-icon=\"icon-briefcase-upload\"></md-icon>\n</md-button></div><div flex=\"nogrow\" ng-if=\"efctrl.uploading\"><md-progress-circular class=\"md-hue-1\" \nmd-diameter=\"40px\"></md-progress-circular></div></div></div></div><div ng-repeat=\"doc in (efctrl.docs | groupFiles)\" \nflex><div><h2 class=\"mb-0 mt-0\">\n{{doc.documentType | getSomethingOfArrayFB : efctrl.docTypes: \'name\' : doc.documentType : \'key\'}}<md-button \nng-if=\"doc.moreFiles.length>0\" ng-click=\"doc.showMore=!doc.showMore\" aria-label=\"Add\" \nclass=\"md-fab md-mini md-primary md-hue-2\">{{doc.moreFiles.length}}+</md-button></h2><div layout=\"row\" \nlayout-align=\"center center\"><div flex><h4 class=\"mb-0 mt-0\">Subido el: {{doc.created.atTime| date : F.dateFormat}}\n</h4></div><div flex=\"nogrow\"><md-button class=\"md-fab md-mini md-primary\" aria-label=\"download\" target=\"_blanc\" \nng-href=\"{{doc.url}}\"><md-icon md-font-icon=\"icon-attachment\"></md-icon></md-button><md-button with-permission \naction=\"remove\" access=\"{{F.active.menuItem}}\" ng-click=\"efctrl.deleteFile($event,doc)\" class=\"md-fab md-mini md-warn\" \naria-label=\"delete\"><md-icon md-font-icon=\"icon-bitbucket\"></md-icon></md-button></div></div><div \nclass=\"animate-fade-in-out\" ng-if=\"doc.showMore\" ng-repeat=\"otherDoc in doc.moreFiles\"><div layout=\"row\" \nlayout-align=\"center center\"><div flex><h4 class=\"mb-0 mt-0\">\nSubido el: {{otherDoc.created.atTime| date : F.dateFormat}}</h4></div><div flex=\"nogrow\"><md-button \nclass=\"md-fab md-mini md-primary\" aria-label=\"download\" target=\"_blanc\" ng-href=\"{{otherDoc.url}}\"><md-icon \nmd-font-icon=\"icon-attachment\"></md-icon></md-button><md-button ng-click=\"efctrl.deleteFile($event,otherDoc)\" \nclass=\"md-fab md-mini md-warn\" with-permission action=\"remove\" access=\"{{F.active.menuItem}}\" aria-label=\"delete\">\n<md-icon md-font-icon=\"icon-bitbucket\"></md-icon></md-button></div></div></div></div><hr ng-if=\"!$last\"></div>\n</fieldset></div></md-content></form></div>");
$templateCache.put("app/main/employees/views/employeeFiles/employeeFiles.html","<div id=\"{{F.active.menuName}}\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\" \nng-controller=\"EmployeeFilesController as efsctrl\"><div class=\"top-bg md-accent-bg\"><div with-permission \nng-model=\"haveP\" action=\"saveSimple\" access=\"{{F.active.menuItem}}\"></div></div><div class=\"center\" layout=\"column\" \nflex><div mongo-search-bar></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><div list-filters filters-loaded=\"F.filtersLoaded\" \nng-model=\"F.filters[F.active.menuName]\" on-change=\"getThem\" columns-repeat=\"columnsRepeat\" \nmenu-obj-name=\"{{F.active.menuObjName}}\" model-name=\"{{F.active.menuName}}\" init-filters=\"initFilters\"></div><div \ntable-loader array=\"employeeFiles\" validations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"employeeFiles.length\"><thead md-head \nmd-order=\"F.orderMongo\" fix-head md-on-reorder=\"getThem\"><tr md-row><th md-column md-order-by=\"rp\"><span>RP</span></th>\n<th md-column md-order-by=\"payroll\"><span>Nómina</span></th><th md-column md-order-by=\"data.name\"><span>Nombre</span>\n</th><th md-column md-order-by=\"completedDocs\" style=\"text-align:center\">Documentación Completa</th><th md-column \nng-repeat=\"doc in M.documentTypes\"><div class=\"text-center\"><span ng-bind=\"doc.name\"></span></div></th></tr></thead>\n<tbody md-body><tr md-row ng-class=\"{\'inactiveEmployee\': employee.movement.type == 2 || employee.status == 5}\" \nmd-auto-select md-select=\"employee\" md-select-id=\"$id\" ng-repeat=\"employee in employeeFiles\"><td md-cell>\n{{employee[\'rp-name\']}}</td><td md-cell>{{employee[\'payroll-name\']}}</td><td md-cell>{{employee.data.name}}</td><td \nmd-cell><div class=\"text-center\">{{employee.completedDocs?\'Si\':\'No\'}}</div></td><td md-cell \nng-repeat=\"doc in M.documentTypes\"><div class=\"text-center\"><md-button ng-if=\"employee.files[doc.key]\" \nclass=\"md-icon-button\" aria-label=\"More\" ng-click=\"efsctrl.getDownloadUrl(employee.files[doc.key],employee.$id)\">\n<md-icon class=\"green-900-fg\" md-font-icon=\"icon-check\"></md-icon></md-button><md-button \nng-if=\"!employee.files[doc.key]\" class=\"md-icon-button\" aria-label=\"More\"><md-icon class=\"red-900-fg\" \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></td></tr></tbody></table></md-table-container>\n<md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" ng-show=\"employeeFiles.length\" \nmd-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" md-limit-options=\"F.paginations\" md-page=\"$parent.currentPage\" \nmd-total=\"{{pagination.total}}\" md-on-paginate=\"getThemPagination\" md-page-select></md-table-pagination></div></div>\n<md-fab-speed-dial md-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" \nclass=\"ms2-speed-dial bottom right\"><md-fab-trigger><md-button aria-label=\"crud menu\" class=\"md-fab md-accent\" \nmd-class=\"{\'md-hue-1\': selected.length}\"><md-icon md-font-icon=\"icon-cube\"></md-icon></md-button></md-fab-trigger>\n<md-fab-actions><md-button with-permission action=\"export\" access=\"{{F.active.menuItem}}\" \nng-click=\'exportDataToExcelByQuery(employeeFiles,\"employeeFiles\",getParamsObject(),pagination.total,\"catalogs/employees/collection\",\"models/employees/employeeDataFile\")\' \naria-label=\"export\" class=\"md-fab md-raised md-mini md-primary md-hue-2\"><md-tooltip md-direction=\"left\">\nExportar a excel</md-tooltip><md-icon md-font-icon=\"icon-file-excel\" aria-label=\"export icon\"></md-icon></md-button>\n<md-button with-permission action=\"read\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" \nng-click=\'R.goToDetail(null, \"read\", {employeeId: selected[0].$id})\' aria-label=\"view\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Ver</md-tooltip><md-icon \nmd-font-icon=\"icon-eye\" aria-label=\"view\"></md-icon></md-button><md-button with-permission action=\"update\" \naccess=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" \nng-click=\'R.goToDetail(null, \"update\", {employeeId: selected[0].$id})\' aria-label=\"edit\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Editar</md-tooltip><md-icon \nmd-font-icon=\"icon-pencil\" aria-label=\"edit\"></md-icon></md-button><md-button with-permission action=\"remove\" \naccess=\"{{F.active.menuItem}}\" ng-if=\"selected.length\" ng-click=\"delete($event)\" aria-label=\"Delete\" \nclass=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">{{\'EC.REMOVE\' | translate}}</md-tooltip>\n<md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button><md-button with-permission \naction=\"create\" access=\"{{F.active.menuItem}}\" ng-if=\"!selected.length\" \nng-click=\'R.goToDetail(null, \"update\", {employeeId: \"new\"})\' aria-label=\"add\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">{{\'EC.ADD\' | translate}}\n</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon></md-button><md-button \naction=\"uploadManyFiles\" access=\"{{F.active.menuItem}}\" ng-click=\"efsctrl.openUploadManyFiles($event)\" \naria-label=\"edit\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">\nSubir varios archivos</md-tooltip><md-icon md-font-icon=\"icon-file-cloud\" aria-label=\"edit\"></md-icon></md-button>\n</md-fab-actions></md-fab-speed-dial></div></div>");
$templateCache.put("app/main/employees/views/employees/employee.html","<div id=\"{{F.active.menuObjName}}\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill \nng-controller=\"EmployeeController\"><form name=\"form\" novalidate flex layout=\"column\" ng-disabled=\"F.readMode\">\n<md-toolbar class=\"md-tall header md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" \nlayout=\"row\" layout-align=\"start center\" flex><md-button class=\"goto-button md-icon-button\" \naria-label=\"Go to employees\" ng-click=\"goToList()\" translate translate-attr-aria-label=\"EC.GO_TO\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" layout-align=\"start center\"><a \nclass=\"crud-image pointer\" hide-xs ng-click=\"selectedTab = 2\"><img ng-if=\"employee.avatar\" \nng-src=\"{{employee.avatar}}\"> <img ng-if=\"!employee.avatar\" class=\"thumb-image\" ng-src=\"{{F.imagePlaceholder}}\"></a>\n<div layout=\"column\" layout-align=\"start start\"><div class=\"h2\" ng-if=\"!F.addMode\">Edicion de {{employee.data.name}}\n</div><div class=\"h2\" ng-if=\"F.addMode\">Alta de Empleado</div><div class=\"subtitle secondary-text\"><span \nng-if=\"!F.addMode\">{{\'EC.DETAIL_OF\' | translate}} Alta</span> <span ng-if=\"F.addMode\">\n{{\'EC.CREATE\' | translate}} de Empleado</span></div></div></div></div><div><md-button type=\"submit\" \nng-if=\"!F.addMode && form.$valid\" with-permission action=\"update\" access=\"{{F.active.menuItem}}\" \nng-click=\"saveEmployee(employee)\" ng-hide=\"form.$pristine\" \nng-disabled=\"form.$invalid || form.$pending || loadingProgress || employee.disabled || F.readMode\" \nclass=\"md-raised md-background md-fab md-accent md-hue-1\" aria-label=\"Save employee\"><md-tooltip md-direction=\"left\">\n{{\'EC.SAVE\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-content-save\" aria-label=\"Save\"></md-icon>\n</md-button><md-button type=\"submit\" ng-if=\"F.addMode && form.$valid\" with-permission action=\"enrole\" \naccess=\"{{F.active.menuItem}}\" ng-click=\"enrole(employee)\" ng-hide=\"form.$pristine\" \nng-disabled=\"form.$invalid || form.$pending || loadingProgress || employee.disabled\" \nclass=\"md-raised md-background md-fab md-accent md-hue-1\" aria-label=\"enrole employee\"><md-tooltip md-direction=\"left\">\nAlta</md-tooltip><md-icon md-font-icon=\"icon-account-plus\" aria-label=\"Enrole icon\"></md-icon></md-button>\n<validate-form-button></validate-form-button></div></md-toolbar><md-content layout=\"column\" class=\"content\" flex>\n<md-tabs md-selected=\"selectedTab\" flex md-dynamic-height class=\"scrollable\"><md-tab label=\"Info\" \nng-if=\"F.addMode || F.active.menuName==\'enroles\' || (F.active.menuName==\'employees\' && F.active.menuAction==\'read\')\">\n<md-tab-body><div class=\"detail-form-container md-background-bg md-whiteframe-1dp\" layout=\"column\"><div form-info>\n</div></div></md-tab-body></md-tab><md-tab label=\"Info\" ng-if=\"F.active.menuAction==\'update\'\"><md-tab-body><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\" layout=\"column\"><div form-info-simple></div></div>\n</md-tab-body></md-tab><md-tab label=\"Domicilio\" \nng-if=\"F.addMode || F.active.menuName==\'enroles\' || (F.active.menuName==\'employees\' && F.active.menuAction==\'read\') || F.active.menuAction==\'update\'\">\n<md-tab-body><div class=\"detail-form-container md-background-bg md-whiteframe-1dp\"><div form-location></div></div>\n</md-tab-body></md-tab><md-tab label=\"Otros\" ng-if=\"F.active.menuAction==\'update\' || F.active.menuAction==\'enrole\'\">\n<md-tab-body><div class=\"detail-form-container md-background-bg md-whiteframe-1dp\"><div form-worker></div></div>\n</md-tab-body></md-tab><md-tab label=\"CFDI 4.0\" \nng-if=\"F.addMode || F.active.menuName==\'enroles\' || (F.active.menuName==\'employees\' && F.active.menuAction==\'read\') || F.active.menuAction==\'update\'\">\n<md-tab-body><div class=\"detail-form-container md-background-bg md-whiteframe-1dp\"><div form-sat></div></div>\n</md-tab-body></md-tab><md-tab label=\"Beneficios\"><md-tab-body><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\"><div form-benefits-employee></div></div></md-tab-body>\n</md-tab><md-tab label=\"Extras\" ng-if=\"F.active.menuAction==\'enrole\' && F.active.menuName==\'employees\'\"><md-tab-body>\n<div class=\"detail-form-container md-background-bg md-whiteframe-1dp\"><div form-extras></div></div></md-tab-body>\n</md-tab><md-tab label=\"Servicios especializados\" \nng-if=\"F.active.menuAction==\'update\' && L[\'companiesOf-\'+employee.rp] && L[\'companiesOf-\'+employee.rp].length>1\">\n<md-tab-body><div class=\"detail-form-container md-background-bg md-whiteframe-1dp\"><div form-special-services></div>\n</div></md-tab-body></md-tab><md-tab label=\"Campos Extras\" ng-if=\"employee.firm\"><md-tab-body><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\"><div form-extra-fields></div></div></md-tab-body>\n</md-tab></md-tabs></md-content></form></div>");
$templateCache.put("app/main/employees/views/employees/employees copy.html","<div id=\"employees\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\" \nng-controller=\"EmployeesMovementsController\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" \nlayout=\"column\" flex><div fb-search-bar-2></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><div filter-toolbar></div><div table-loader array=\"employees\" \nvalidations=\"validations\"></div><md-table-container class=\"tableHeaderMarginOld\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"employees.length\"><thead md-head \nmd-order=\"F.orderMongo\" fix-head md-on-reorder=\"getThem\"><tr md-row><th md-column md-order-by=\"rp\" \ntitle=\"{{R.fields[F.active.menuName].rp.title}}\"><span>RP</span></th><th md-column md-order-by=\"payroll\" \ntitle=\"{{R.fields[F.active.menuName].payroll.title}}\"><span>Nomina</span></th><th md-column md-order-by=\"data.nss\" \ntitle=\"{{R.fields[F.active.menuName].nss.title}}\"><span>NSS</span></th><th md-column md-order-by=\"data.name\" \ntitle=\"{{R.fields[F.active.menuName].name.title}}\"><span>Nombre</span></th><th md-column md-order-by=\"data.salary.sd\" \ntitle=\"{{R.fields[F.active.menuName].sd.title}}\"><span>SD</span></th><th md-column md-order-by=\"data.salary.sbc\" \ntitle=\"{{R.fields[F.active.menuName].sbc.title}}\"><span>SBC</span></th><th md-column md-order-by=\"data.enroleDate\" \ntitle=\"{{R.fields[F.active.menuName].enroleDate.title}}\"><span>Alta</span></th><th md-column \nmd-order-by=\"data.mdsDate\" title=\"{{R.fields[F.active.menuName].mdsDate.title}}\"><span>MDS</span></th><th md-column \nmd-order-by=\"data.dismissDate\" title=\"{{R.fields[F.active.menuName].dismissDate.title}}\"><span \ntitle=\"Fecha de última baja\">Baja</span></th><th md-column md-order-by=\"status\" \ntitle=\"{{R.fields[F.active.menuName].status.title}}\"><span>Status</span></th><th md-column \nmd-order-by=\"{{column.path}}\" ng-repeat=\"column in columnsRepeat\" ng-show=\"column.show\">{{column.name}}</th></tr>\n</thead><tbody md-body><tr md-row ng-class=\"{\'inactiveEmployee\': employee.movement.type == 2 || employee.status == 5}\" \nmd-auto-select md-select=\"employee\" md-select-id=\"$id\" ng-repeat=\"employee in employees\"><td md-cell>\n{{employee.rp | nameOfL:L.rps}}</td><td md-cell>\n{{employee.payroll | getSomethingOfArrayFB:L.allPayrolls:\'class\'}} {{employee.payroll | nameOfL: L.allPayrolls}}</td>\n<td md-cell>{{employee.data.nss}}</td><td md-cell>{{employee.data.name}}</td><td md-cell>\n{{employee.data.salary.sd | currency}}</td><td md-cell>{{employee.data.salary.sbc | currency}}</td><td md-cell>\n{{employee.data.enroleDate| date:F.dateFormat}}</td><td md-cell>{{employee.data.mdsDate| date:F.dateFormat}}</td><td \nmd-cell>{{employee.data.dismissDate| date:F.dateFormat}}</td><td md-cell>{{employee | employeeStatusName}}</td><td \nmd-cell ng-repeat=\"column in columnsRepeat\" ng-show=\"column.show\"><div layout=\"row\" layout-align=\"start center\"><div \nflex>{{employee | getValueOfRecord: column}}</div><div flex=\"nogrow\"><md-button ng-if=\"column.editable(employee)\" \nclass=\"md-icon-button\" ng-click=\"openModalEdit($event,column,employee)\" aria-label=\"More\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon></md-button></div></div></td></tr></tbody></table></md-table-container>\n<md-table-pagination layout-align=\"start center\" ng-show=\"employees.length\" md-label=\"{{F.paginationLabel}}\" \nmd-limit=\"F.paginate\" md-limit-options=\"F.paginations\" md-page=\"F.currentPageMongo\" md-total=\"{{pagination.total}}\" \nmd-on-paginate=\"getThemPagination\" md-page-select></md-table-pagination></div></div><md-fab-speed-dial \nmd-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\"><md-fab-trigger>\n<md-button aria-label=\"crud menu\" class=\"md-fab md-accent\" md-class=\"{\'md-hue-1\': selected.length}\"><md-tooltip \nmd-direction=\"left\">Acciones</md-tooltip><md-icon md-font-icon=\"icon-cube\"></md-icon></md-button></md-fab-trigger>\n<md-fab-actions><md-button with-permission action=\"export\" access=\"{{F.active.menuItem}}\" \nng-click=\'exportDataToExcelByQuery(employees,\"employees\",getQuerys(),pagination.total)\' aria-label=\"export\" \nclass=\"md-fab md-raised md-mini md-primary md-hue-2\"><md-tooltip md-direction=\"left\">Exportar a excel</md-tooltip>\n<md-icon md-font-icon=\" icon-file-excel\" aria-label=\"export\"></md-icon></md-button><md-button with-permission \naction=\"read\" access=\"{{F.active.menuItem}}\" ng-show=\"selected.length == 1\" \nng-click=\'R.goToDetail(null, \"read\", {movementId: selected[0].movement.uid, employeeId: selected[0].$id, payrollId: selected[0].payroll})\' \naria-label=\"Read\" class=\"md-fab md-raised md-primary md-mini\"><md-tooltip md-direction=\"left\">Ver</md-tooltip><md-icon \nmd-font-icon=\"icon-eye\" aria-label=\"read icon\"></md-icon></md-button><md-button with-permission action=\"remove\" \naccess=\"{{F.active.menuItem}}\" ng-show=\"selected.length\" ng-click=\"checkAndDeleteEmployeesAndMovements($event)\" \naria-label=\"Delete\" class=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">\n{{\'EC.REMOVE\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-delete\" aria-label=\"remove icon\"></md-icon>\n</md-button><md-button with-permission action=\"enrole\" access=\"{{F.active.menuItem}}\" ng-show=\"!selected.length\" \nng-click=\'R.goToDetail(null, \"enrole\", {movementId: \"new\", employeeId: \"new\"})\' aria-label=\"enrole\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Alta</md-tooltip><md-icon \nmd-font-icon=\"icon-account-plus\" aria-label=\"enrole icon\"></md-icon></md-button><md-button with-permission \naction=\"dismiss\" access=\"{{F.active.menuItem}}\" \nng-show=\"(selected[0].status==4 || (selected[0].status==3&&[6,7,8,10].indexOf(selected[0].movement.type)!=-1)) && selected.length==1\" \nng-click=\'R.goToDetail(null, \"dismiss\", {movementId: \"new\", employeeId: selected[0].$id, payrollId: selected[0].payroll})\' \naria-label=\"Dismiss Employee\" class=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">Baja\n</md-tooltip><md-icon md-font-icon=\"icon-account-minus\" aria-label=\"dismiss icon\"></md-icon></md-button><md-button \nwith-permission action=\"reEntry\" access=\"{{F.active.menuItem}}\" \nng-show=\"(selected[0].status==5 || (selected[0].status==3&&[2].indexOf(selected[0].movement.type)!=-1)) && selected.length==1\" \nng-click=\'R.goToDetail(null, \"reEntry\", {movementId: \"new\", employeeId: selected[0].$id, payrollId: selected[0].payroll})\' \naria-label=\"Reentry Employee\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">\nReingreso</md-tooltip><md-icon md-font-icon=\"icon-account-plus\" aria-label=\"reentry icon\"></md-icon></md-button>\n<md-button with-permission action=\"mds\" access=\"{{F.active.menuItem}}\" \nng-show=\"(selected[0].status==4 || (selected[0].status==3&&[6,7,8,10].indexOf(selected[0].movement.type)!=-1)) && selected.length==1 && selected[0].data.nss\" \nng-click=\'R.goToDetail(null, \"mds\", {movementId: \"new\", employeeId: selected[0].$id, payrollId: selected[0].payroll})\' \naria-label=\"mds\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">\nModificación de Salario</md-tooltip><md-icon md-font-icon=\"icon-currency-usd\" aria-label=\"mds\"></md-icon></md-button>\n<md-button with-permission action=\"especialEdit\" access=\"{{F.active.menuItem}}\" ng-show=\"selected.length == 1\" \nng-click=\'R.goToDetail(selected[0], \"especialEdit\", {movementId: selected[0].movement.uid, employeeId: selected[0].$id, payrollId: selected[0].payroll})\' \naria-label=\"especialEdit\" class=\"md-fab md-raised md-mini md-primary md-hue-3\"><md-tooltip md-direction=\"left\">\nEdición Especial</md-tooltip><md-icon md-font-icon=\"icon-auto-fix\" aria-label=\"especialEdit icon\"></md-icon>\n</md-button><md-button with-permission action=\"update\" access=\"{{F.active.menuItem}}\" ng-show=\"selected.length == 1\" \nng-click=\'R.goToDetail(selected[0], \"update\", {movementId: selected[0].movement.uid, employeeId: selected[0].$id, payrollId: selected[0].payroll})\' \naria-label=\"update\" class=\"md-fab md-raised md-mini md-primary md-hue-2\"><md-tooltip md-direction=\"left\">Editar\n</md-tooltip><md-icon md-font-icon=\"icon-pencil\" aria-label=\"edit\"></md-icon></md-button><md-button with-permission \naction=\"dismissMany\" access=\"{{F.active.menuItem}}\" \nng-if=\"selected.length>1 && !(selected|recordsHaveValue:\'movement.type\':2:\'any\')\" \nng-click=\'sendManyToAction($event,\"dismiss\")\' aria-label=\"Dismiss Employees\" class=\"md-fab md-raised md-warn md-mini\">\n<md-tooltip md-direction=\"left\">Baja Masiva</md-tooltip><md-icon md-svg-src=\"/assets/icons/account-multiple-minus.svg\" \naria-label=\"dismiss icon\"></md-icon></md-button><md-button with-permission action=\"reentryMany\" \naccess=\"{{F.active.menuItem}}\" \nng-if=\"selected.length>1 && (selected|recordsHaveValue:\'payroll\') && (selected|recordsHaveValue:\'movement.type\':2)\" \nng-click=\'sendManyToAction($event,\"reentry\")\' aria-label=\"Reentry Employees\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Reingresos Masivos</md-tooltip>\n<md-icon md-font-icon=\"icon-account-multiple-plus\" aria-label=\"reentry icon\"></md-icon></md-button><md-button \nwith-permission action=\"moveToPayroll\" access=\"{{F.active.menuItem}}\" \nng-if=\"selected.length && !(selected|recordsHaveValue:\'movement.type\':2:\'any\') && ((selected|recordsHaveValue:\'rp-rp\':\'00000000000\')||!(selected|recordsHaveValue:\'rp-rp\':\'00000000000\':\'any\'))\" \nng-click=\'sendManyToAction($event,\"changePayroll\")\' aria-label=\"Change Payroll Employees\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Mover a Nomina</md-tooltip><md-icon\n md-font-icon=\"icon-transfer\" aria-label=\"transfer icon\"></md-icon></md-button><md-button with-permission \naction=\"review\" access=\"movements.revisions\" \nng-if=\"selected.length && !(selected|recordsHaveValue:\'movement.type\':2:\'any\') && !(selected|recordsHaveValue:\'status\':1:\'any\')\" \nng-click=\'sendManyToAction($event,\"registerEmitAccount\")\' aria-label=\"Register Emit Account Employees\" \nclass=\"md-fab md-raised md-mini md-primary md-hue-2\"><md-tooltip md-direction=\"left\">Generar/Registrar cuenta\n</md-tooltip><md-icon md-font-icon=\"icon-bank\" aria-label=\"bank icon\"></md-icon></md-button></md-fab-actions>\n</md-fab-speed-dial></div></div>");
$templateCache.put("app/main/employees/views/employees/employees.html","<div id=\"employees\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\" \nng-controller=\"EmployeesMovementsController\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" \nlayout=\"column\" flex><div mongo-search-bar></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><div list-filters filters-loaded=\"F.filtersLoaded\" \nng-model=\"F.filters[F.active.menuName]\" on-change=\"getThem\" columns-repeat=\"columnsRepeat\" \nmenu-obj-name=\"{{F.active.menuObjName}}\" model-name=\"{{F.active.menuName}}\" init-filters=\"initFilters\"></div><div \ntable-loader array=\"employees\" validations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"employees.length\"><thead md-head \nmd-order=\"F.orderMongo\" fix-head md-on-reorder=\"getThem\"><tr md-row><th md-column md-order-by=\"rp\" \ntitle=\"{{R.fields[F.active.menuName].rp.title}}\"><span>RP</span></th><th md-column md-order-by=\"payroll\" \ntitle=\"{{R.fields[F.active.menuName].payroll.title}}\"><span>Nomina</span></th><th md-column md-order-by=\"data.nss\" \ntitle=\"{{R.fields[F.active.menuName].nss.title}}\"><span>NSS</span></th><th md-column md-order-by=\"data.name\" \ntitle=\"{{R.fields[F.active.menuName].name.title}}\"><span>Nombre</span></th><th md-column md-order-by=\"data.salary.sd\" \ntitle=\"{{R.fields[F.active.menuName].sd.title}}\"><span>SD</span></th><th md-column md-order-by=\"data.salary.sbc\" \ntitle=\"{{R.fields[F.active.menuName].sbc.title}}\"><span>SBC</span></th><th md-column md-order-by=\"data.enroleDate\" \ntitle=\"{{R.fields[F.active.menuName].enroleDate.title}}\"><span>Alta</span></th><th md-column \nmd-order-by=\"data.mdsDate\" title=\"{{R.fields[F.active.menuName].mdsDate.title}}\"><span>MDS</span></th><th md-column \nmd-order-by=\"data.dismissDate\" title=\"{{R.fields[F.active.menuName].dismissDate.title}}\"><span \ntitle=\"Fecha de última baja\">Baja</span></th><th md-column md-order-by=\"status\" \ntitle=\"{{R.fields[F.active.menuName].status.title}}\"><span>Status</span></th><th md-column \nmd-order-by=\"{{column.path}}\" ng-repeat=\"column in columnsRepeat\" ng-show=\"column.show\">{{column.name}}</th></tr>\n</thead><tbody md-body><tr md-row ng-class=\"{\'inactiveEmployee\': employee.movement.type == 2 || employee.status == 5}\" \nmd-auto-select md-select=\"employee\" md-select-id=\"$id\" ng-repeat=\"employee in employees\"><td md-cell>\n{{employee[\'rp2-name\']}}</td><td md-cell>{{employee[\'payroll2-class\']}} {{employee[\'payroll-name\']}}</td><td md-cell>\n{{employee.data.nss}}</td><td md-cell>{{employee.data.name}}</td><td md-cell>{{employee.data.salary.sd | currency}}\n</td><td md-cell>{{employee.data.salary.sbc | currency}}</td><td md-cell>\n{{employee.data.enroleDate| date:F.dateFormat}}</td><td md-cell>{{employee.data.mdsDate| date:F.dateFormat}}</td><td \nmd-cell>{{employee.data.dismissDate| date:F.dateFormat}}</td><td md-cell>{{employee | employeeStatusName}}</td><td \nmd-cell ng-repeat=\"column in columnsRepeat\" ng-show=\"column.show\"><div layout=\"row\" layout-align=\"start center\"><div \nflex>{{employee | getValueOfRecord: column}}</div><div flex=\"nogrow\"><md-button with-permission action=\"update\" \naccess=\"{{F.active.menuItem}}\" ng-if=\"column.editable(employee)\" class=\"md-icon-button\" \nng-click=\"openModalEdit($event,column,employee)\" aria-label=\"More\"><md-icon md-font-icon=\"icon-pencil\"></md-icon>\n</md-button></div></div></td></tr></tbody></table></md-table-container><md-table-pagination \nlayout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" ng-show=\"employees.length\" \nmd-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" md-limit-options=\"F.paginations\" md-page=\"$parent.currentPage\" \nmd-total=\"{{pagination.total}}\" md-on-paginate=\"getThemPagination\" md-page-select></md-table-pagination></div></div>\n<md-fab-speed-dial md-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" \nclass=\"ms2-speed-dial bottom right\"><md-fab-trigger><md-button aria-label=\"crud menu\" class=\"md-fab md-accent\" \nmd-class=\"{\'md-hue-1\': selected.length}\"><md-tooltip md-direction=\"left\">Acciones</md-tooltip><md-icon \nmd-font-icon=\"icon-cube\"></md-icon></md-button></md-fab-trigger><md-fab-actions><md-button with-permission \naction=\"exportv2\" access=\"{{F.active.menuItem}}\" \nng-click=\'exportData(employees,\"employees\",\"employeesv2\",\"mongo\",getParamsObject(),pagination.total,\"|\",1,0,\"txt\")\' \naria-label=\"export\" class=\"md-fab md-raised md-mini md-primary md-hue-2\"><md-tooltip md-direction=\"left\">\nExportar datos SAT</md-tooltip><md-icon md-font-icon=\" icon-file-excel\" aria-label=\"export\"></md-icon></md-button>\n<md-button with-permission action=\"export\" access=\"{{F.active.menuItem}}\" \nng-click=\'exportDataToExcelByQuery(employees,\"employees\",getParamsObject(),pagination.total,\"catalogs/employees/collection\")\' \naria-label=\"export\" class=\"md-fab md-raised md-mini md-primary md-hue-2\"><md-tooltip md-direction=\"left\">\nExportar a excel</md-tooltip><md-icon md-font-icon=\" icon-file-excel\" aria-label=\"export\"></md-icon></md-button>\n<md-button with-permission action=\"read\" access=\"{{F.active.menuItem}}\" ng-show=\"selected.length == 1\" \nng-click=\'R.goToDetail(null, \"read\", {movementId: selected[0].movement.uid, employeeId: selected[0].$id, payrollId: selected[0].payroll})\' \naria-label=\"Read\" class=\"md-fab md-raised md-primary md-mini\"><md-tooltip md-direction=\"left\">Ver</md-tooltip><md-icon \nmd-font-icon=\"icon-eye\" aria-label=\"read icon\"></md-icon></md-button><md-button with-permission action=\"remove\" \naccess=\"{{F.active.menuItem}}\" ng-show=\"selected.length\" ng-click=\"checkAndDeleteEmployeesAndMovements($event)\" \naria-label=\"Delete\" class=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">\n{{\'EC.REMOVE\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-delete\" aria-label=\"remove icon\"></md-icon>\n</md-button><md-button with-permission action=\"enrole\" access=\"{{F.active.menuItem}}\" ng-show=\"!selected.length\" \nng-click=\'R.goToDetail(null, \"enrole\", {movementId: \"new\", employeeId: \"new\"})\' aria-label=\"enrole\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Alta</md-tooltip><md-icon \nmd-font-icon=\"icon-account-plus\" aria-label=\"enrole icon\"></md-icon></md-button><md-button with-permission \naction=\"askIA\" access=\"{{F.active.menuItem}}\" ng-show=\"!selected.length\" ng-click=\"ask()\" aria-label=\"enrole\" \nclass=\"md-fab md-raised md-mini blue-900-bg md-hue-2\"><md-tooltip md-direction=\"left\">Pregunta a la AI</md-tooltip>\n<md-icon md-svg-src=\"/assets/icons/data5.svg\" style=\"width: 30px; height: 35px\" aria-label=\"enrole icon\"></md-icon>\n</md-button><md-button with-permission action=\"dismiss\" access=\"{{F.active.menuItem}}\" \nng-show=\"(selected[0].status==4 || (selected[0].status==3&&[6,7,8,10].indexOf(selected[0].movement.type)!=-1)) && selected.length==1\" \nng-click=\'R.goToDetail(null, \"dismiss\", {movementId: \"new\", employeeId: selected[0].$id, payrollId: selected[0].payroll})\' \naria-label=\"Dismiss Employee\" class=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">Baja\n</md-tooltip><md-icon md-font-icon=\"icon-account-minus\" aria-label=\"dismiss icon\"></md-icon></md-button><md-button \nwith-permission action=\"reEntry\" access=\"{{F.active.menuItem}}\" \nng-show=\"(selected[0].status==5 || (selected[0].status==3&&[2].indexOf(selected[0].movement.type)!=-1)) && selected.length==1\" \nng-click=\'R.goToDetail(null, \"reEntry\", {movementId: \"new\", employeeId: selected[0].$id, payrollId: selected[0].payroll})\' \naria-label=\"Reentry Employee\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">\nReingreso</md-tooltip><md-icon md-font-icon=\"icon-account-plus\" aria-label=\"reentry icon\"></md-icon></md-button>\n<md-button with-permission action=\"mds\" access=\"{{F.active.menuItem}}\" \nng-show=\"(selected[0].status==4 || (selected[0].status==3&&[6,7,8,10].indexOf(selected[0].movement.type)!=-1)) && selected.length==1 && selected[0].data.nss\" \nng-click=\'R.goToDetail(null, \"mds\", {movementId: \"new\", employeeId: selected[0].$id, payrollId: selected[0].payroll})\' \naria-label=\"mds\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">\nModificación de Salario</md-tooltip><md-icon md-font-icon=\"icon-currency-usd\" aria-label=\"mds\"></md-icon></md-button>\n<md-button with-permission action=\"especialEdit\" access=\"{{F.active.menuItem}}\" ng-show=\"selected.length == 1\" \nng-click=\'R.goToDetail(selected[0], \"especialEdit\", {movementId: selected[0].movement.uid, employeeId: selected[0].$id, payrollId: selected[0].payroll})\' \naria-label=\"especialEdit\" class=\"md-fab md-raised md-mini md-primary md-hue-3\"><md-tooltip md-direction=\"left\">\nEdición Especial</md-tooltip><md-icon md-font-icon=\"icon-auto-fix\" aria-label=\"especialEdit icon\"></md-icon>\n</md-button><md-button with-permission action=\"update\" access=\"{{F.active.menuItem}}\" ng-show=\"selected.length == 1\" \nng-click=\'R.goToDetail(selected[0], \"update\", {movementId: selected[0].movement.uid, employeeId: selected[0].$id, payrollId: selected[0].payroll})\' \naria-label=\"update\" class=\"md-fab md-raised md-mini md-primary md-hue-2\"><md-tooltip md-direction=\"left\">Editar\n</md-tooltip><md-icon md-font-icon=\"icon-pencil\" aria-label=\"edit\"></md-icon></md-button><md-button with-permission \naction=\"dismissMany\" access=\"{{F.active.menuItem}}\" \nng-if=\"selected.length>1 && !(selected|recordsHaveValue:\'movement.type\':2:\'any\')\" \nng-click=\'sendManyToAction($event,\"dismiss\")\' aria-label=\"Dismiss Employees\" class=\"md-fab md-raised md-warn md-mini\">\n<md-tooltip md-direction=\"left\">Baja Masiva</md-tooltip><md-icon md-svg-src=\"/assets/icons/account-multiple-minus.svg\" \naria-label=\"dismiss icon\"></md-icon></md-button><md-button with-permission action=\"reentryMany\" \naccess=\"{{F.active.menuItem}}\" \nng-if=\"selected.length>1 && (selected|recordsHaveValue:\'payroll\') && (selected|recordsHaveValue:\'movement.type\':2)\" \nng-click=\'sendManyToAction($event,\"reentry\")\' aria-label=\"Reentry Employees\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Reingresos Masivos</md-tooltip>\n<md-icon md-font-icon=\"icon-account-multiple-plus\" aria-label=\"reentry icon\"></md-icon></md-button><md-button \nng-if=\"selected.length > 0 && (selected|recordsHaveValue:\'firm-syncOptions.geoVictoria\': true)\" \nng-click=\"asyncIntegrations(selected, \'geoVictoria\', $event)\" with-permission action=\"syncGeovictoria\" \naccess=\"{{F.active.menuItem}}\" aria-label=\"sync Employees\" class=\"md-fab md-raised md-mini md-hue-2\"><md-tooltip \nmd-direction=\"left\">Sincronización con geoVictoria</md-tooltip><md-icon md-svg-src=\"/assets/images/geo3.svg\" \naria-label=\"reentry geoVictoria\"></md-icon></md-button><md-button \nng-if=\"selected.length > 0 && (selected|recordsHaveValue:\'firm-syncOptions.buk\': true)\" \nng-click=\"asyncIntegrations(selected, \'buk\', $event)\" aria-label=\"sync Employees\" with-permission action=\"syncBuk\" \naccess=\"{{F.active.menuItem}}\" class=\"md-fab md-raised md-mini md-hue-2\"><md-tooltip md-direction=\"left\">\nSincronización con buk</md-tooltip><md-icon md-svg-src=\"/assets/images/buksv.svg\" aria-label=\"sync buk\"></md-icon>\n</md-button><md-button ng-if=\"selected.length > 0 && (selected|recordsHaveValue:\'firm-syncOptions.humand\': true)\" \nng-click=\"asyncIntegrations(selected, \'humand\', $event)\" aria-label=\"sync Employees\" with-permission \naction=\"syncHumand\" access=\"{{F.active.menuItem}}\" class=\"md-fab md-raised md-mini md-hue-2\" \nstyle=\"background-color: #003382\"><md-tooltip md-direction=\"left\">Sincronización con humand</md-tooltip><md-icon \nmd-svg-src=\"/assets/images/hum.svg\" aria-label=\"sync humand\"></md-icon></md-button><md-button ng-if=\"selected.length\" \nwith-permission action=\"disableValidations\" access=\"{{F.active.menuItem}}\" \nng-click=\"disableValidationsForEmployees(selected, $event)\" aria-label=\"disabledValidations\" \nclass=\"md-fab md-raised md-mini md-hue-2\" style=\"background-color: #ffffff\"><md-tooltip md-direction=\"left\">\nDesactivar Validaciones</md-tooltip><md-icon md-svg-src=\"/assets/icons/disabledValidations.svg\" \naria-label=\"disabledValidations\"></md-icon></md-button><md-button with-permission action=\"moveToPayroll\" \naccess=\"{{F.active.menuItem}}\" \nng-if=\"selected.length && !(selected|recordsHaveValue:\'movement.type\':2:\'any\') && ((selected|recordsHaveValue:\'rp-rp\':\'00000000000\')||!(selected|recordsHaveValue:\'rp-rp\':\'00000000000\':\'any\'))\" \nng-click=\'sendManyToAction($event,\"changePayroll\")\' aria-label=\"Change Payroll Employees\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Mover a Nomina</md-tooltip><md-icon\n md-font-icon=\"icon-transfer\" aria-label=\"transfer icon\"></md-icon></md-button><md-button with-permission \naction=\"import\" access=\"{{F.active.menuItem}}\" ng-show=\"!selected.length\" ng-click=\"importEmployeesModal($event)\" \naria-label=\"importEmployees\" class=\"md-fab md-raised md-mini md-primary md-hue-3\"><md-tooltip md-direction=\"left\">\nAñadir campos adicionales de empleados</md-tooltip><md-icon md-font-icon=\"icon-import\" aria-label=\"import employees\">\n</md-icon></md-button><md-button with-permission action=\"genRegAccount\" access=\"{{F.active.menuItem}}\" \nng-if=\"selected.length && !(selected|recordsHaveValue:\'movement.type\':2:\'any\') && !(selected|recordsHaveValue:\'status\':1:\'any\')\" \nng-click=\'sendManyToAction($event,\"registerEmitAccount\")\' aria-label=\"Register Emit Account Employees\" \nclass=\"md-fab md-raised md-mini md-primary md-hue-2\"><md-tooltip md-direction=\"left\">Generar/Registrar cuenta\n</md-tooltip><md-icon md-font-icon=\"icon-bank\" aria-label=\"bank icon\"></md-icon></md-button><md-button with-permission \naction=\"syncEmployee\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length>0\" \nng-click=\"showSyncConfirmationModal($event)\" aria-label=\"Sync with GeoVictoria\" \nclass=\"md-fab md-raised md-mini md-primary\"><md-tooltip md-direction=\"left\">Sincronizar con Control de Asistencia\n</md-tooltip><md-icon md-font-icon=\" icon-sync\" aria-label=\" icon-sync\"></md-icon></md-button></md-fab-actions>\n</md-fab-speed-dial></div></div>");
$templateCache.put("app/main/employees/views/employees/reentry.html","<div id=\"employee\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill \nng-controller=\"EmployeeController\"><form name=\"form\" novalidate flex layout=\"column\" ng-disabled=\"F.readMode\">\n<md-toolbar class=\"md-tall header md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" \nlayout=\"row\" layout-align=\"start center\" flex><md-button class=\"goto-button md-icon-button\" \naria-label=\"Go to employees\" ng-click=\"R.goToList(F.active.menuName, F.active.menuParams)\" translate \ntranslate-attr-aria-label=\"EC.GO_TO\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" \nlayout-align=\"start center\"><a class=\"crud-image pointer\" hide-xs ng-click=\"selectedTab = 2\"><img \nng-if=\"employee.avatar\" ng-src=\"{{employee.avatar}}\"> <img ng-if=\"!employee.avatar\" class=\"thumb-image\" \nng-src=\"{{F.imagePlaceholder}}\"></a><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\">\nReingreso de {{employee.data.name}}</div><div class=\"subtitle secondary-text\"><span ng-if=\"!F.addMode\">\n{{\'EC.DETAIL_OF\' | translate}} Reingreso</span> <span ng-if=\"F.addMode\">{{\'EC.CREATE\' | translate}} Reingreso</span>\n</div></div></div></div><div><md-button type=\"submit\" ng-if=\"!F.readMode && form.$valid\" with-permission \naction=\"reEntry\" access=\"{{F.active.menuItem}}\" ng-click=\"reEntry(employee)\" ng-hide=\"form.$pristine\" \nng-disabled=\"form.$invalid || loadingProgress || employee.disabled\" \nclass=\"md-raised md-background md-fab md-accent md-hue-1\" aria-label=\"Add employee\"><md-tooltip md-direction=\"left\">\nAlta</md-tooltip><md-icon md-font-icon=\"icon-content-save\" aria-label=\"Reentry\"></md-icon></md-button>\n<validate-form-button></validate-form-button></div></md-toolbar><md-content layout=\"column\" class=\"content\" flex>\n<md-tabs md-selected=\"selectedTab\" flex md-dynamic-height class=\"scrollable\"><md-tab label=\"Info\"><md-tab-body><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\" layout=\"column\"><div form-info></div></div>\n</md-tab-body></md-tab><md-tab label=\"Domicilio\"><md-tab-body><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\"><div form-location></div></div></md-tab-body></md-tab>\n<md-tab label=\"Otros\"><md-tab-body><div class=\"detail-form-container md-background-bg md-whiteframe-1dp\"><div \nform-worker></div></div></md-tab-body></md-tab><md-tab label=\"CFDI 4.0\"><md-tab-body><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\"><div form-sat></div></div></md-tab-body></md-tab>\n<md-tab label=\"Beneficios\"><md-tab-body><div class=\"detail-form-container md-background-bg md-whiteframe-1dp\"><div \nform-benefits-employee></div></div></md-tab-body></md-tab></md-tabs></md-content></form></div>");
$templateCache.put("app/main/employees/views/employees/special.html","<div id=\"employee\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill \nng-controller=\"EmployeeController\"><form name=\"form\" novalidate flex layout=\"column\" ng-disabled=\"F.readMode\">\n<md-toolbar class=\"md-tall header md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" \nlayout=\"row\" layout-align=\"start center\" flex><md-button class=\"goto-button md-icon-button\" \naria-label=\"Go to employees\" ng-click=\"R.goToList(F.active.menuName, F.active.menuParams)\" translate \ntranslate-attr-aria-label=\"EC.GO_TO\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" \nlayout-align=\"start center\"><a class=\"crud-image pointer\" hide-xs ng-click=\"selectedTab = 2\"><img \nng-if=\"employee.avatar\" ng-src=\"{{employee.avatar}}\"> <img ng-if=\"!employee.avatar\" class=\"thumb-image\" \nng-src=\"{{F.imagePlaceholder}}\"></a><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\">\nEdición especial de empleado {{employee.data.name}}</div><div class=\"subtitle secondary-text\"><span ng-if=\"!F.addMode\">\n{{\'EC.DETAIL_OF\' | translate}} {{\'employee.SINGULAR\' | translate}}</span> <span ng-if=\"F.addMode\">\n{{\'EC.CREATE\' | translate}} {{\'employee.SINGULAR\' | translate}}</span></div></div></div></div><div><md-button \nng-click=\"saveSpecial(employee, movement, $event)\" ng-if=\"form.$valid\" with-permission action=\"especialEdit\" \naccess=\"{{F.active.menuItem}}\" ng-hide=\"form.$pristine\" \nng-disabled=\"form.$invalid || form.$pending || loadingProgress\" \nclass=\"md-raised md-background md-fab md-accent md-hue-1\" aria-label=\"Save employee\"><md-tooltip md-direction=\"left\">\n{{\'EC.SAVE\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-content-save\" aria-label=\"Save\"></md-icon>\n</md-button><validate-form-button></validate-form-button></div></md-toolbar><md-content layout=\"column\" \nclass=\"content\" flex><md-tabs md-selected=\"selectedTab\" flex md-dynamic-height class=\"scrollable\"><md-tab \nlabel=\"Movimiento\" ng-if=\"movement.data\"><md-tab-body><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\"><div form-special-movement></div></div></md-tab-body>\n</md-tab><md-tab label=\"Últimas Fechas\"><md-tab-body><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\"><div form-date-movement></div></div></md-tab-body>\n</md-tab><md-tab label=\"Salud\"><md-tab-body><div class=\"detail-form-container md-background-bg md-whiteframe-1dp\"><div \nform-health></div></div></md-tab-body></md-tab><md-tab label=\"Info\"><md-tab-body><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\" layout=\"column\"><div form-info></div></div>\n</md-tab-body></md-tab><md-tab label=\"Domicilio\"><md-tab-body><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\"><div form-location></div></div></md-tab-body></md-tab>\n<md-tab label=\"Otros\"><md-tab-body><div class=\"detail-form-container md-background-bg md-whiteframe-1dp\"><div \nform-worker></div></div></md-tab-body></md-tab><md-tab label=\"Beneficios\"><md-tab-body><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\"><div form-benefits-employee></div></div></md-tab-body>\n</md-tab><md-tab label=\"Salarios\"><md-tab-body><div class=\"detail-form-container md-background-bg md-whiteframe-1dp\">\n<div form-salaries></div></div></md-tab-body></md-tab><md-tab label=\"Extras\"><md-tab-body><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\"><div form-extras></div></div></md-tab-body></md-tab>\n<md-tab label=\"CFDI 4.0\"><md-tab-body><div class=\"detail-form-container md-background-bg md-whiteframe-1dp\"><div \nform-sat></div></div></md-tab-body></md-tab><md-tab label=\"Servicios especializados\" \nng-if=\"L[\'companiesOf-\'+employee.rp] && L[\'companiesOf-\'+employee.rp].length>1\"><md-tab-body><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\"><div form-special-services></div></div></md-tab-body>\n</md-tab><md-tab label=\"Campos Extras\" ng-if=\"extraFields.length>0\"><md-tab-body><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\"><div form-extra-fields></div></div></md-tab-body>\n</md-tab></md-tabs></md-content></form></div>");
$templateCache.put("app/main/employees/views/employeesVacationsRecords/employeesVacationsRecord.html","<div id=\"employeesVacationsRecord\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill \nng-controller=\"EmployeesVacationsRecordController as efctrl\"><form name=\"form\" novalidate flex layout=\"column\" \nng-disabled=\"F.readMode\"><md-toolbar class=\"md-tall header md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button with-permission action=\"access\" \naccess=\"{{F.active.menuItem}}\" class=\"goto-button md-icon-button\" aria-label=\"Go to employeesVacationsRecords\" \nng-click=\"R.goToList()\" translate translate-attr-aria-label=\"EC.GO_TO\"><md-icon md-font-icon=\"icon-arrow-left\">\n</md-icon></md-button><div layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"{{F.menuItems.clients.employeesVacationsRecords.icon || F.default.icon}}\" class=\"crud-icon\"></md-icon>\n<div layout=\"column\" layout-align=\"start start\"><div class=\"h2\">{{efctrl.employee.data.name}}</div><div \nclass=\"subtitle secondary-text\"><span ng-if=\"!F.addMode\">\n{{\'EC.DETAIL_OF\' | translate}} {{\'employeesVacationsRecord.SINGULAR\' | translate}}</span> <span ng-if=\"F.addMode\">\n{{\'EC.CREATE\' | translate}} {{\'employeesVacationsRecord.SINGULAR\' | translate}}</span></div></div></div></div>\n</md-toolbar><md-content layout=\"column\" class=\"content\" flex><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\" layout=\"column\"><md-autocomplete class=\"md-block\" \nflex md-min-length=\"2\" md-selected-item=\"efctrl.employee\" md-search-text=\"efctrl.searchEmployee\" \nmd-selected-item-change=\"efctrl.employeesVacationsRecord.employeeId=efctrl.employee.fid;efctrl.loadEvents(efctrl.employee)\" \nmd-item-text=\"item.data.name\" md-delay=\"500\" \nmd-items=\'item in autocompleteListM(efctrl.searchEmployee, \"employees\",[\"data.name\",\"data.nss\",\"employeeVacations\"],{project:{data:1,firm:1,fid:1,status:1}})\' \nmd-require-match=\"true\" md-select-on-match=\"true\" md-match-case-insensitive=\"true\" placeholder=\"Empleado\" \nmd-no-cache=\"true\" ng-init=\"efctrl.searchEmployee=efctrl.employee.data.name\" md-floating-label=\"Empleado\" required>\n<md-item-template><span md-highlight-text=\"searchEmployee\" ng-class=\"{\'inactiveOption\': (item.status==5)}\">\n{{item.data.nss?item.data.nss+\' - \':\'\'}}{{item.data.name}}</span></md-item-template><md-not-found>No hay registros\n</md-not-found></md-autocomplete><fieldset ng-if=\"efctrl.employeesVacationsRecord.employeeId\"><legend>Eventos<md-button\n ng-if=\"!efctrl.showAddEvent\" ng-click=\"efctrl.fireAddEvent(true)\" with-permission action=\"create\" \naccess=\"{{F.active.menuItem}}\" aria-label=\"Add\" class=\"md-icon-button\"><md-icon \nmd-font-icon=\"icon-plus-circle-outline\"></md-icon></md-button><md-button ng-if=\"efctrl.showAddEvent\" \nng-click=\"efctrl.fireAddEvent(false)\" aria-label=\"Remove\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-cancel\">\n</md-icon></md-button><md-button with-permission action=\"generatePdf\" ng-if=\"efctrl.vacationsEvents.length\" \naccess=\"{{F.active.menuItem}}\" ng-click=\'efctrl.exportVacations(\"pdf\")\' aria-label=\"generatePDF\" \nclass=\"md-icon-button md-primary md-hue-3\" flex><md-tooltip>Descargar PDF</md-tooltip><md-icon \nmd-font-icon=\"icon-file-pdf\" aria-label=\"print pdf\"></md-icon></md-button><md-button with-permission action=\"export\" \nng-if=\"efctrl.vacationsEvents.length\" access=\"{{F.active.menuItem}}\" ng-click=\'efctrl.exportVacations(\"xls\")\' \naria-label=\"export\" class=\"md-icon-button md-primary md-hue-2\" flex><md-tooltip>Descargar Excel</md-tooltip><md-icon \nmd-font-icon=\"icon-file-excel\" aria-label=\"export icon\"></md-icon></md-button></legend><h2 \nng-if=\"efctrl.vacationsEvents.length === 0 && !efctrl.showAddEvent\">No hay ningún documento del empleado</h2><div \nng-if=\"efctrl.showAddEvent\" layout=\"row\" flex><md-input-container class=\"md-block\" flex><label>Tipo de evento</label>\n<md-select ng-disabled=\"F.readMode\" name=\"eventType\" ng-change=\"efctrl.setAnniversaries(efctrl.eventType)\" \nng-model=\"efctrl.eventType\" required><md-option ng-value=\"eventType\" ng-repeat=\"eventType in efctrl.eventsTypes\">\n{{eventType.name}}</md-option></md-select><div ng-messages=\"form.eventType.$error\" role=\"alert\"><div \nng-message=\"required\">Debe seleccionar el tipo de documento</div></div></md-input-container><md-input-container \nclass=\"md-block date-picker\" flex ng-if=\"efctrl.eventType.id!==\'anniversary\'\"><label>Fecha</label><md-datepicker \nng-disabled=\"F.readMode\" md-hide-icons=\"triangle\" input-date-miliseconds md-min-date=\"efctrl.minDate\" \nng-model=\"efctrl.eventDate\" name=\"eventDate\" required class=\"md-block\"></md-datepicker><div \nng-messages=\"form.eventDate.$error\" role=\"alert\"><div ng-message=\"required\">Fecha del evento es requerida</div></div>\n</md-input-container><md-input-container class=\"md-block\" flex ng-if=\"efctrl.eventType.id===\'anniversary\'\"><label>\nAniversario</label><md-select ng-disabled=\"F.readMode\" name=\"eventDate\" ng-model=\"efctrl.eventDate\" required><md-option\n ng-repeat=\"anniversary in efctrl.anniversaries\" ng-value=\"anniversary\">{{anniversary.year}}</md-option></md-select>\n<div ng-messages=\"form.eventDate.$error\" role=\"alert\"><div ng-message=\"required\">Debe seleccionar el aniversario</div>\n</div></md-input-container><md-input-container class=\"md-block\" flex><label>Cantidad</label><input type=\"number\" \nname=\"qty\" ng-model=\"efctrl.qty\"><div ng-messages=\"form.qty.$error\" role=\"alert\"><div ng-message=\"required\">\nDebe ingresar una cantidad</div></div></md-input-container><md-input-container class=\"md-block\" flex \nng-if=\"efctrl.eventType.id===\'adjustment\'\"><label>Tipo</label><md-select ng-disabled=\"F.readMode\" \nname=\"adjustmentType\" ng-model=\"efctrl.adjustmentType\" required><md-option ng-value=\"\'earned\'\">Ganadas</md-option>\n<md-option ng-value=\"\'enjoyed\'\">Disfrutadas</md-option></md-select><div ng-messages=\"form.eventDate.$error\" \nrole=\"alert\"><div ng-message=\"required\">Debe seleccionar el aniversario</div></div></md-input-container><div><md-button\n class=\"md-raised md-primary\" ng-click=\"efctrl.addEvent()\" ng-disabled=\"form.$invalid || loadingProgress\">Añadir evento\n</md-button></div></div><div ng-if=\"efctrl.vacationsEvents.length > 0\"><table class=\"table miniTable\" fixed-header>\n<thead><tr class=\"fix1\"><th>Fecha</th><th>Evento</th><th>Derecho a Gozo</th><th>Acumulados</th><th>Pendientes Der. Gozo\n</th><th>Disfrutadas</th><th>Total Disfrutadas</th><th>Vencidas</th><th>Total vencidas</th><th>Total</th><th>&nbsp;\n</th></tr></thead><tbody><tr ng-repeat=\"event in efctrl.vacationsEvents\"><td ng-bind=\"event.date|date\"></td><td><span \nng-bind=\"event.event===\'Aniversario\'?event.anniversaryNumber+\'º \':\'\'\"></span><span ng-bind=\"event.event\"></span></td>\n<td ng-bind=\"event.earned\"></td><td ng-bind=\"event.earnedTotal\"></td><td><span ng-if=\"event.earned>0\">{{event.pending}}\n</span></td><td ng-bind=\"event.enjoyed\"></td><td ng-bind=\"event.enjoyedTotal\"></td><td ng-bind=\"event.prescribed\"></td>\n<td ng-bind=\"event.prescribedTotal\"></td><td ng-bind=\"event.total\"></td><td><button ng-if=\"event.fixed\" \nwith-permission action=\"remove\" access=\"{{F.active.menuItem}}\" aria-label=\"not delete event\" \nng-click=\"efctrl.deleteEvent(event.date)\"><md-icon md-font-icon=\"icon-trash\"></md-icon></button></td></tr></tbody>\n</table></div></fieldset></div></md-content></form></div>");
$templateCache.put("app/main/employees/views/employeesVacationsRecords/employeesVacationsRecords.html","<div id=\"{{F.active.menuName}}\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\" \nng-controller=\"EmployeesVacationsRecordsController as evrCtrl\"><div class=\"top-bg md-accent-bg\"><div with-permission \nng-model=\"haveP\" action=\"saveSimple\" access=\"{{F.active.menuItem}}\"></div></div><div class=\"center\" layout=\"column\" \nflex><div mongo-search-bar></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><div list-filters filters-loaded=\"F.filtersLoaded\" \nng-model=\"F.filters[F.active.menuName]\" on-change=\"getThem\" columns-repeat=\"columnsRepeat\" \nmenu-obj-name=\"{{F.active.menuObjName}}\" model-name=\"{{F.active.menuName}}\" init-filters=\"initFilters\"></div><div \ntable-loader array=\"employeesVacationsRecords\" validations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"employeesVacationsRecords.length\"><thead md-head \nmd-order=\"F.orderMongo\" fix-head md-on-reorder=\"getThem\"><tr md-row><th md-column md-order-by=\"rp\"><span>RP</span></th>\n<th md-column md-order-by=\"payroll\"><span>Nómina</span></th><th md-column md-order-by=\"data.name\"><span>Nombre</span>\n</th><th md-column md-order-by=\"enroleDate\"><span>Alta</span></th><th md-column md-order-by=\"seniorityDate\"><span>\nAntigüedad</span></th><th md-column md-order-by=\"data.lastHolEv.event\"><span>Ultimo Mov</span></th><th md-column \nmd-order-by=\"data.lastHolEv.date\"><span>Fecha Mov</span></th><th md-column md-order-by=\"data.lastHolEv.enjoyedTotal\">\n<span>Total Disfrutadas</span></th><th md-column md-order-by=\"data.lastHolEv.earnedTotal\"><span>Total Ganadas</span>\n</th><th md-column md-order-by=\"data.lastHolEv.total\"><span>Total Pendientes</span></th></tr></thead><tbody md-body><tr\n md-row ng-class=\"{\'inactiveEmployee\': employee.movement.type == 2 || employee.status == 5}\" md-auto-select \nmd-select=\"employee\" md-select-id=\"$id\" ng-repeat=\"employee in employeesVacationsRecords\"><td md-cell>\n{{employee[\'rp-name\']}}</td><td md-cell>{{employee[\'payroll-name\']}}</td><td md-cell>{{employee.data.name}}</td><td \nmd-cell ng-class=\'{\"strongItem\":!employee.hasSeniorityDate}\'>{{employee.data.enroleDate | date:F.dateFormat}}</td><td \nmd-cell ng-class=\'{\"strongItem\":employee.hasSeniorityDate}\'>\n{{employee.data.seniorityDate ? (employee.data.seniorityDate| date:F.dateFormat) : \'\'}}</td><td md-cell>\n{{employee.data.lastHolEv.event}}</td><td md-cell>{{employee.data.lastHolEv.date | date:F.dateFormat}}</td><td md-cell>\n{{employee.data.lastHolEv.enjoyedTotal}}</td><td md-cell>{{employee.data.lastHolEv.earnedTotal}}</td><td md-cell>\n{{employee.data.lastHolEv.total}}</td></tr></tbody></table></md-table-container><md-table-pagination \nlayout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" ng-show=\"employeesVacationsRecords.length\" \nmd-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" md-limit-options=\"F.paginations\" md-page=\"$parent.currentPage\" \nmd-total=\"{{pagination.total}}\" md-on-paginate=\"getThemPagination\" md-page-select></md-table-pagination></div></div>\n<md-fab-speed-dial md-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" \nclass=\"ms2-speed-dial bottom right\"><md-fab-trigger><md-button aria-label=\"crud menu\" class=\"md-fab md-accent\" \nmd-class=\"{\'md-hue-1\': selected.length}\"><md-icon md-font-icon=\"icon-cube\"></md-icon></md-button></md-fab-trigger>\n<md-fab-actions><md-button with-permission action=\"export\" access=\"{{F.active.menuItem}}\" ng-show=\"selected.length\" \nng-click=\"evrCtrl.generateFile($event, selected, true)\" aria-label=\"export\" \nclass=\"md-fab md-raised md-mini md-primary md-hue-2\"><md-tooltip md-direction=\"left\">Exportar a excel</md-tooltip>\n<md-icon md-font-icon=\"icon-file-excel\" aria-label=\"export icon\"></md-icon></md-button><md-button with-permission \naction=\"exportv2\" access=\"{{F.active.menuItem}}\" \nng-click=\'exportDataToExcelByQuery(employeesVacationsRecords,\"vacationsRecords\",getParamsObject(),pagination.total,\"catalogs/employees/collection\")\' \naria-label=\"export\" class=\"md-fab md-raised md-mini md-primary md-hue-2\"><md-tooltip md-direction=\"left\" \nclass=\"md-red-50-bg\">Exportar concentrado</md-tooltip><md-icon md-font-icon=\" icon-file-excel\" aria-label=\"export\">\n</md-icon></md-button><md-button with-permission action=\"generatePdf\" access=\"{{F.active.menuItem}}\" \nng-show=\"selected.length\" ng-click=\"evrCtrl.generateFile($event, selected)\" aria-label=\"generatePDF\" \nclass=\"md-fab md-raised md-mini md-primary md-hue-3\"><md-tooltip md-direction=\"left\">PDF</md-tooltip><md-icon \nmd-font-icon=\"icon-file-pdf\" aria-label=\"print pdf\"></md-icon></md-button><md-button with-permission action=\"read\" \naccess=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" \nng-click=\'R.goToDetail(null, \"read\", {employeeId: selected[0].$id})\' aria-label=\"view\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Ver</md-tooltip><md-icon \nmd-font-icon=\"icon-eye\" aria-label=\"view\"></md-icon></md-button><md-button with-permission action=\"update\" \naccess=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" \nng-click=\'R.goToDetail(null, \"update\", {employeeId: selected[0].$id})\' aria-label=\"edit\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Editar</md-tooltip><md-icon \nmd-font-icon=\"icon-pencil\" aria-label=\"edit\"></md-icon></md-button><md-button with-permission \naction=\"balanceEmployeeVacationHumand\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length > 0\" \nng-click=\"vacationsRecordsHumand($event, selected)\" aria-label=\"edit\" class=\"md-fab md-mini md-hue-2\" \nstyle=\"background-color: #003382\"><md-tooltip md-direction=\"left\">Ajustar vacaciones Humand</md-tooltip><md-icon \nmd-svg-src=\"/assets/images/hum.svg\" aria-label=\"edit\"></md-icon></md-button><md-button action=\"import\" \naccess=\"{{F.active.menuItem}}\" ng-show=\"!selected.length\" ng-click=\"evrCtrl.importEventsModal($event)\" \naria-label=\"importEvents\" class=\"md-fab md-raised md-mini md-primary md-hue-3\"><md-tooltip md-direction=\"left\">\nImportar Eventos</md-tooltip><md-icon md-font-icon=\"icon-import\" aria-label=\"import events\"></md-icon></md-button>\n</md-fab-actions></md-fab-speed-dial></div></div>");
$templateCache.put("app/main/employees/views/enroleAccounts/enroleAccounts.html","<div id=\"{{F.active.menuName}}\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\" \nng-controller=\"EnroleAccountsController\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" \nflex><div fb-search-bar></div><div class=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" \nlayout=\"column\" flex><div filter-toolbar></div><div table-loader array=\"Z.enroleAccounts\" validations=\"validations\">\n</div><md-table-container class=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table \nmd-table md-row-select multiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"F.filteredItems.length\"><thead \nmd-head md-order=\"order\" fix-head><tr md-row><th md-column md-order-by=\"payroll\"><span>Nómina</span></th><th md-column \nmd-order-by=\"data.name\"><span>Nombre</span></th><th md-column md-order-by=\"data.curp\"><span>CURP</span></th><th \nmd-column md-order-by=\"data.cards[0].emit\"><span>Genera Cuenta</span></th><th md-column \nmd-order-by=\"data.cards[0].bank\"><span>Banco</span></th><th md-column><span>Emisora</span></th><th md-column \nmd-order-by=\"data.cards[0].number\"><span>Tarjeta o Cuenta</span></th><th md-column \nmd-order-by=\"data.cards[0].created.atTime\"><span>Fecha de Solicitud</span></th><th md-column \nmd-order-by=\"data.enroleDate\"><span>Fecha de Alta</span></th><th md-column md-order-by=\"{{column.path}}\" \nng-repeat=\"column in columnsRepeat\" ng-show=\"column.show\">{{column.name}}</th></tr></thead><tbody md-body><tr md-row \nmd-auto-select md-select=\"employee\" md-select-id=\"$id\" \nng-repeat=\"employee in (F.filteredItems = (Z.enroleAccounts | filter:F.searchText[F.active.menuObjName] | orderBy:order)) | limitTo: F.paginate: (currentPage - 1) * F.paginate\">\n<td md-cell><span ng-bind=\"employee[\'payroll-name\']\"></span></td><td md-cell><span ng-bind=\"employee.data.name\"></span>\n</td><td md-cell><span ng-bind=\"employee.data.curp\"></span></td><td md-cell><span \nng-bind=\"employee.data.cards[0].emit?\'Si\':\'No\'\"></span></td><td md-cell><span \nng-bind=\"employee.data.cards[0].bank|getSomethingOfArrayM:M.banks:\'name\':false:\'_id\'\"></span></td><td><span \nng-bind=\"employee.issuer_register\"></span></td><td md-cell><span ng-bind=\"employee.data.cards[0].number\"></span></td>\n<td md-cell><span ng-bind=\"employee.data.cards[0].created.atTime|date:F.dateFormat\"></span></td><td md-cell><span \nng-bind=\"employee.data.enroleDate|date:F.dateFormat\"></span></td><td md-cell ng-repeat=\"column in columnsRepeat\" \nng-show=\"column.show\"><div layout=\"row\" layout-align=\"start center\"><div flex \nng-bind=\"employee | getValueOfRecord: column\"></div><div flex=\"nogrow\"><md-button ng-if=\"column.editable(employee)\" \nclass=\"md-icon-button\" ng-click=\"openModalEdit($event,column,employee)\" aria-label=\"More\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon></md-button></div></div></td></tr></tbody></table></md-table-container>\n<md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" \nng-show=\"F.filteredItems.length\" md-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" \nmd-limit-options=\"F.paginations\" md-page=\"currentPage\" md-on-paginate=\"restartSelected\" \nmd-total=\"{{F.filteredItems.length}}\" md-page-select></md-table-pagination></div></div><md-fab-speed-dial \nmd-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\"><md-fab-trigger>\n<md-button aria-label=\"crud menu\" class=\"md-fab md-accent\" md-class=\"{\'md-hue-1\': selected.length}\"><md-icon \nmd-font-icon=\"icon-cube\"></md-icon></md-button></md-fab-trigger><md-fab-actions><md-button with-permission \naction=\"export\" access=\"{{F.active.menuItem}}\" \nng-click=\"exportDataToExcel(F.filteredItems,F.active.menuName,currentPage,F.paginate)\" aria-label=\"export\" \nclass=\"md-fab md-raised md-mini md-primary md-hue-2\"><md-tooltip md-direction=\"left\">Exportar a excel</md-tooltip>\n<md-icon md-font-icon=\"icon-file-excel\" aria-label=\"export\"></md-icon></md-button><md-button with-permission \naction=\"enroleAccounts\" access=\"{{F.active.menuItem}}\" ng-show=\"selected.length\" ng-click=\"enroleAccounts($event)\" \naria-label=\"execute accounts enrole\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip \nmd-direction=\"left\">Archivar</md-tooltip><md-icon md-font-icon=\"icon-archive\" aria-label=\"enrole accounts\"></md-icon>\n</md-button><md-button with-permission action=\"cancelAccounts\" access=\"{{F.active.menuItem}}\" \nng-show=\"selected.length\" ng-click=\"cancelAccounts($event,selected)\" aria-label=\"cancel Accounts\" \nclass=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">Rechazar Solicitud</md-tooltip><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"cancel accounts\"></md-icon></md-button><md-button with-permission \naction=\"importAccounts\" access=\"{{F.active.menuItem}}\" ng-show=\"!selected.length\" ng-click=\"importAccounts($event)\" \naria-label=\"importVariables\" class=\"md-fab md-raised md-mini md-primary md-hue-3\"><md-tooltip md-direction=\"left\">\nImportar Cuentas</md-tooltip><md-icon md-font-icon=\"icon-import\" aria-label=\"import variables\"></md-icon></md-button>\n<div ng-repeat=\"bank in M.banks\"><md-button ng-if=\"bank.hasLayout\" with-permission action=\"getLayout\" \naccess=\"{{F.active.menuItem}}\" ng-show=\"selected.length && checkLayout(selected,bank)\" \nng-click=\"getInterface($event,bank)\" aria-label=\"print Layout For Bank\" class=\"md-fab md-raised md-mini\"><md-tooltip \nmd-direction=\"left\">Layout para {{bank.name}}</md-tooltip><md-icon ng-if=\"bank.icon\" md-svg-src=\"{{bank.icon}}\">\n</md-icon><md-icon ng-if=\"!bank.icon\" md-font-icon=\"icon-credit-card-multiple\"></md-icon></md-button></div>\n</md-fab-actions></md-fab-speed-dial></div></div>");
$templateCache.put("app/main/employees/views/enroles/enrole.html","<div id=\"{{F.active.menuObjName}}\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill \nng-controller=\"EmployeeController\"><form name=\"form\" novalidate flex layout=\"column\" ng-disabled=\"F.readMode\">\n<md-toolbar class=\"md-tall header md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" \nlayout=\"row\" layout-align=\"start center\" flex><md-button class=\"goto-button md-icon-button\" \naria-label=\"Go to employees\" ng-click=\"goToList()\" translate translate-attr-aria-label=\"EC.GO_TO\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" layout-align=\"start center\"><a \nclass=\"crud-image pointer\" hide-xs ng-click=\"selectedTab = 2\"><img ng-if=\"employee.avatar\" \nng-src=\"{{employee.avatar}}\"> <img ng-if=\"!employee.avatar\" class=\"thumb-image\" ng-src=\"{{F.imagePlaceholder}}\"></a>\n<div layout=\"column\" layout-align=\"start start\"><div class=\"h2\">Alta de Empleado</div><div \nclass=\"subtitle secondary-text\"><span ng-if=\"!F.addMode\">{{\'EC.DETAIL_OF\' | translate}} Alta</span> <span \nng-if=\"F.addMode\">{{\'EC.CREATE\' | translate}} Alta</span></div></div></div></div><div><md-button type=\"submit\" \nng-if=\"form.$valid\" ng-click=\"saveAndUpdateMovement(movement, employee)\" with-permission action=\"update\" \naccess=\"{{F.active.menuItem}}\" ng-hide=\"form.$pristine\" \nng-disabled=\"form.$invalid || form.$pending || loadingProgress\" ng-if=\'F.active.menuAction == \"update\" && !F.readMode\' \nclass=\"md-raised md-background md-fab md-accent md-hue-1\" aria-label=\"update employee\"><md-tooltip md-direction=\"left\">\nActualizar Alta</md-tooltip><md-icon md-font-icon=\"icon-content-save\" aria-label=\"save\"></md-icon></md-button>\n<validate-form-button></validate-form-button><md-button type=\"submit\" ng-if=\"F.addMode\" with-permission \naction=\"enrole\" access=\"{{F.active.menuItem}}\" ng-click=\"enrole(employee)\" ng-hide=\"form.$pristine\" \nng-disabled=\"form.$invalid || form.$pending || loadingProgress\" \nclass=\"md-raised md-background md-fab md-accent md-hue-1\" aria-label=\"enrole employee\"><md-tooltip md-direction=\"left\">\nAlta</md-tooltip><md-icon md-font-icon=\"icon-account-plus\" aria-label=\"Enrole icon\"></md-icon></md-button></div>\n</md-toolbar><md-content layout=\"column\" class=\"content\"><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\" layout=\"column\" ng-if=\"employee.status!=2\"><div \nform-fast-enrole></div></div><md-tabs md-selected=\"selectedTab\" flex md-dynamic-height layout-fill \nng-if=\"employee.status==2\" class=\"scrollable\"><md-tab label=\"Movimiento\"><md-tab-body><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\" flex layout=\"column\"><div form-fast-enrole></div>\n</div></md-tab-body></md-tab><md-tab label=\"Otros\"><md-tab-body><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\" flex layout-fill=\"column\"><div form-worker></div>\n</div></md-tab-body></md-tab><md-tab label=\"Beneficios\"><md-tab-body><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\"><div form-benefits-employee></div></div></md-tab-body>\n</md-tab><md-tab label=\"Campos Extras\" ng-if=\"extraFields.length>0\"><md-tab-body><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\"><div form-extra-fields></div></div></md-tab-body>\n</md-tab></md-tabs></md-content></form></div>");
$templateCache.put("app/main/employees/views/enroles/enroles.html","<div id=\"{{F.active.menuName}}\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\" \nng-controller=\"EmployeesMovementsController\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" \nlayout=\"column\" flex><div fb-search-bar></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><div filter-toolbar></div><div table-loader array=\"Z.enroles\" \nvalidations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"F.filteredItems.length\"><thead md-head \nmd-order=\"order\" fix-head><tr md-row><th md-column md-order-by=\"rp\"><span>RP</span></th><th md-column \nmd-order-by=\'\"pc-class\"\'><span>Nómina</span></th><th md-column md-order-by=\"data.nss\"><span>NSS</span></th><th \nmd-column md-order-by=\"data.name\"><span>Nombre</span></th><th md-column md-order-by=\"data.info.birth.date\"><span>Edad\n</span></th><th md-column md-order-by=\"data.curp\"><span>CURP</span></th><th md-column md-order-by=\"data.salary.sd\">\n<span>SD</span></th><th md-column md-order-by=\"data.salary.sbc\"><span>SBC</span></th><th md-column \nmd-order-by=\"movement.type\"><span>Movto</span></th><th md-column md-order-by=\"data.enroleDate\"><span>Alta</span></th>\n</tr></thead><tbody md-body><tr md-row md-auto-select md-select=\"employee\" md-select-id=\"$id\" \nng-repeat=\"employee in (F.filteredItems = (Z.enroles | filter:F.searchText[F.active.menuObjName] | orderBy:order)) | limitTo: F.paginate: (currentPage - 1) * F.paginate\">\n<td md-cell>{{employee.rp | nameOfL: L.rps}}</td><td md-cell>[{{employee[\'pc-class\']}}] {{employee[\'payroll-name\']}}\n</td><td md-cell>{{employee.data.nss}}</td><td md-cell>{{employee.data.name}}</td><td md-cell \nng-class=\"(employee.data.info.birth.date | timeDiff:false:\'years\')>59?\'overAgeEmployee\':\'\'\">\n{{employee.data.info.birth.date | timeDiff:false:\'years\'}}</td><td md-cell>{{employee.data.curp}}</td><td md-cell>\n{{employee.data.salary.sd | currency}}</td><td md-cell>{{employee.data.salary.sbc | currency}}</td><td md-cell>\n{{employee.movement.type | typeName}}</td><td md-cell>{{employee.data.enroleDate | date:F.dateFormat}}</td></tr>\n</tbody></table></md-table-container><md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" \nlayout-xs=\"column\" ng-show=\"F.filteredItems.length\" md-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" \nmd-limit-options=\"F.paginations\" md-page=\"currentPage\" md-on-paginate=\"restartSelected\" \nmd-total=\"{{F.filteredItems.length}}\" md-page-select></md-table-pagination></div></div><md-fab-speed-dial \nmd-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\"><md-fab-trigger>\n<md-button aria-label=\"crud menu\" class=\"md-fab md-accent\" md-class=\"{\'md-hue-1\': selected.length}\"><md-icon \nmd-font-icon=\"icon-cube\"></md-icon></md-button></md-fab-trigger><md-fab-actions><md-button with-permission \naction=\"export\" access=\"{{F.active.menuItem}}\" \nng-click=\"exportDataToExcel(F.filteredItems,F.active.menuName,currentPage,F.paginate)\" aria-label=\"export\" \nclass=\"md-fab md-raised md-mini md-primary md-hue-2\"><md-tooltip md-direction=\"left\">Exportar a excel</md-tooltip>\n<md-icon md-font-icon=\"icon-file-excel\" aria-label=\"export\"></md-icon></md-button><md-button with-permission \naction=\"read\" access=\"{{F.active.menuItem}}\" ng-show=\"selected.length == 1\" \nng-click=\'R.goToDetail(selected[0], \"read\", {movementId: selected[0].movement.uid, employeeId: selected[0].$id, employee: selected[0]})\' \naria-label=\"Read\" class=\"md-fab md-raised md-primary md-mini\"><md-tooltip md-direction=\"left\">Ver</md-tooltip><md-icon \nmd-font-icon=\"icon-eye\" aria-label=\"read icon\"></md-icon></md-button><md-button with-permission action=\"update\" \naccess=\"{{F.active.menuItem}}\" ng-show=\"selected.length == 1\" \nng-click=\'R.goToDetail(null, \"update\", {employeeId: selected[0].$id, movementId: selected[0].movement.uid})\' \naria-label=\"Update\" class=\"md-fab md-raised md-primary md-mini\"><md-tooltip md-direction=\"left\">Editar</md-tooltip>\n<md-icon md-font-icon=\"icon-pencil\" aria-label=\"edit icon\"></md-icon></md-button><md-button with-permission \naction=\"sendToIdse\" access=\"{{F.active.menuItem}}\" ng-show=\"selected.length\" ng-click=\"moveEmployees($event, 3)\" \naria-label=\"moveEmployees\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">\nMandar a IDSE, si el movimiento solo es para previsi&oacute;n, se archiva automatic&aacute;mente</md-tooltip><md-icon \nmd-font-icon=\"icon-arrow-right-bold-hexagon-outline\" aria-label=\"move\"></md-icon></md-button><md-button \nwith-permission action=\"getIdse\" access=\"{{F.active.menuItem}}\" ng-show=\"selected.length\" \nng-click=\'getInterface(\"idse\")\' aria-label=\"getIdse\" class=\"md-fab md-raised md-mini md-primary md-hue-3\"><md-tooltip \nmd-direction=\"left\">IDSE</md-tooltip><md-icon md-svg-src=\"/assets/icons/IDSE.svg\" aria-label=\"idse\"></md-icon>\n</md-button><md-button with-permission action=\"getSua\" access=\"{{F.active.menuItem}}\" ng-show=\"selected.length\" \nng-click=\'getInterface(\"sua\")\' aria-label=\"getSua\" class=\"md-fab md-raised md-mini md-primary md-hue-3\"><md-tooltip \nmd-direction=\"left\">Layout Alta o Reingreso</md-tooltip><md-icon md-svg-src=\"/assets/icons/SUA.svg\" aria-label=\"sua\">\n</md-icon></md-button><md-button with-permission action=\"getSua\" access=\"{{F.active.menuItem}}\" \nng-show=\"selected.length\" ng-click=\'getInterface(\"sua\",{forceEnrole:true})\' aria-label=\"getSua\" \nclass=\"md-fab md-raised md-mini md-primary md-hue-3\"><md-tooltip md-direction=\"left\">Layout Forzar Alta</md-tooltip>\n<md-icon md-svg-src=\"/assets/icons/SUA.svg\" aria-label=\"sua\"></md-icon></md-button><md-button with-permission \naction=\"cancelMovement\" access=\"movements.revisions\" ng-show=\"selected.length == 1\" \nng-click=\"cancelLastMovement($event)\" aria-label=\"cancel last movement\" class=\"md-fab md-mini md-warn md-hue-2\">\n<md-tooltip md-direction=\"left\">Cancelar Último Movimiento</md-tooltip><md-icon md-font-icon=\"icon-close\" \naria-label=\"cancel\"></md-icon></md-button></md-fab-actions></md-fab-speed-dial></div></div>");
$templateCache.put("app/main/employees/views/groupings/grouping.html","<div id=\"grouping\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" ng-controller=\"GroupingController\" \nlayout-fill><form name=\"form\" novalidate flex layout=\"column\" ng-disabled=\"F.readMode\"><md-toolbar \nclass=\"md-tall header md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" \nlayout-align=\"start center\" flex><md-button with-permission action=\"access\" access=\"{{F.active.menuItem}}\" \nclass=\"goto-button md-icon-button\" aria-label=\"Go to incidences\" ng-click=\"R.goToList()\" translate \ntranslate-attr-aria-label=\"EC.GO_TO\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"{{F.menuItems.captures.groupings.icon || F.default.icon}}\" \nclass=\"crud-icon\"></md-icon><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\">{{grouping.name}}</div><div\n class=\"subtitle secondary-text\"><span ng-if=\"!F.addMode\">\n{{\'EC.DETAIL_OF\' | translate}} {{\'grouping.SINGULAR\' | translate}}</span> <span ng-if=\"F.addMode\">\n{{\'EC.CREATE\' | translate}} {{\'grouping.SINGULAR\' | translate}}</span></div></div></div></div><div><md-button \ntype=\"submit\" ng-if=\"F.addMode\" with-permission action=\"create\" access=\"{{F.active.menuItem}}\" \nng-click=\"addAndCreateGroupings(grouping)\" ng-hide=\"form.$pristine\" \nng-disabled=\"form.$invalid || loadingProgress || !(employees.length > 0)\" \nclass=\"md-raised md-background md-fab md-accent md-hue-1\" aria-label=\"Add Groupings\"><md-tooltip md-direction=\"left\">\n{{\'EC.ADD\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-content-save\" aria-label=\"Add\"></md-icon></md-button>\n<md-button type=\"submit\" ng-if=\"!F.addMode && !F.readMode\" with-permission action=\"update\" \naccess=\"{{F.active.menuItem}}\" ng-click=\"saveAndSetGroupings(grouping)\" ng-hide=\"form.$pristine\" \nng-disabled=\"form.$invalid || loadingProgress || !(employees.length > 0)\" \nclass=\"md-raised md-background md-fab md-accent md-hue-1\" aria-label=\"Save Groupings\"><md-tooltip md-direction=\"left\">\n{{\'EC.SAVE\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-content-save\" aria-label=\"Add\"></md-icon></md-button>\n</div></md-toolbar><md-content layout=\"column\" class=\"content\" flex><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\" flex=\"grow\"><div layout=\"row\" layout-xs=\"column\">\n<md-input-container flex><label>Clave</label><input ng-model=\"grouping.key\" type=\"text\" \nng-model-options=\"{ debounce: F.debounceTime }\" name=\"key\" remove-space \nng-keypress=\"removeSpaces($event, grouping.key)\" \nng-change=\"validateField(grouping.key, \'key\', grouping.$id, form, true)\" ng-disabled=\"F.readMode\" required><div \nng-messages=\"form.key.$error\"><div ng-message=\"required\">Es requerido!</div><div ng-message=\"validationError\">\nEste valor ya existe</div></div></md-input-container><md-input-container flex><label>Nombre</label><input \nng-model=\"grouping.name\" type=\"text\" ng-model-options=\"{ debounce: F.debounceTime }\" name=\"name\" class=\"uppercased\" \nng-change=\"validateField(grouping.name, \'name\', grouping.$id, form)\" ng-disabled=\"F.readMode\" required><div \nng-messages=\"form.name.$error\"><div ng-message=\"required\">Es requerido!</div><div ng-message=\"validationError\">\nEste valor ya existe</div></div></md-input-container></div><div layout=\"column\"><md-input-container flex><label>\nDescripción</label><textarea ng-model=\"grouping.description\" rows=\"4\" ng-disabled=\"F.readMode\"></textarea>\n</md-input-container><div flex class=\"md-block\" layout=\"row\"><md-autocomplete class=\"md-block\" flex md-min-length=\"2\" \nmd-selected-item=\"employeeSelected\" md-search-text=\"searchQuery\" md-selected-item-change=\"employeeId=item.$id\" \nmd-item-text=\"item.data.name\" md-delay=\"500\" md-items=\"item in listsEmployees(searchQuery,L.userCcs[F.profile.uid])\" \nmd-select-on-match=\"true\" md-match-case-insensitive=\"true\" placeholder=\"Empleado\" md-no-cache=\"true\" \nmd-floating-label=\"Empleado\" ng-disabled=\"F.readMode\"><md-item-template><span md-highlight-text=\"searchQuery\" \nstyle=\"display: block\" ng-click=\"addEmployees(item.$id)\" ng-class=\"{\'inactiveOption\': (item.status==5)}\">\n{{item.data.nss?item.data.nss+\' - \':\'\'}}{{item.data.name}}</span></md-item-template><md-not-found>No hay registros\n</md-not-found></md-autocomplete><div flex=\"nogrow\"><md-button class=\"md-icon-button\" \nng-disabled=\"!employeeSelected || !F.addMode\" aria-label=\"Add Employees\" ng-click=\"addEmployees(employeeId)\"><md-icon \nmd-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon></md-button></div></div></div><div><div flex class=\"md-block\" \nng-if=\"employees.length > 0\"><md-table-container><table md-table class=\"row-border table-employees\"><thead md-head \nmd-order=\"order\"><tr md-row><th md-column md-order-by=\"$id\"><span>ID</span></th><th md-column md-order-by=\"name\"><span>\nEmpleado</span></th><th md-column md-order-by=\"nss\"><span>NSS</span></th><th md-column><span>Accion</span></th></tr>\n</thead><tbody md-body><tr md-row md-auto-select ng-repeat=\"($index, employee) in employees | orderBy: order\"><td \nmd-cell>{{employee.$id}}</td><td md-cell>{{employee.name}}</td><td md-cell>{{employee.nss}}</td><td md-cell><md-button \nng-disabled=\"F.readMode\" class=\"md-icon-button\" aria-label=\"Remove Employees\" \nng-click=\"removeEmployee(employee.$id, $index)\"><md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon>\n</md-button></td></tr></tbody></table></md-table-container></div></div></div></md-content></form></div>");
$templateCache.put("app/main/employees/views/groupings/groupings.html","<div id=\"groupings\" class=\"page-layout carded fullwidth crud-index\" ng-controller=\"GroupingsController\" layout=\"row\">\n<div class=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div fb-search-bar></div><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><div \nfilter-toolbar></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"groupings.length\"><thead md-head md-order=\"order\" \nfix-head><tr md-row><th md-column md-order-by=\"key\"><span>Clave</span></th><th md-column md-order-by=\"name\"><span>\nNombre</span></th><th md-column md-order-by=\"description\"><span>Descripción</span></th><th md-column \nmd-order-by=\"employees\"><span>Empleados</span></th></tr></thead><tbody md-body><tr md-row md-auto-select \nmd-select=\"grouping\" md-select-id=\"$id\" \nng-repeat=\"grouping in (F.filteredItems = (groupings | filter:F.searchText.grouping | orderBy:order)) | limitTo: F.paginate: (currentPage - 1) * F.paginate\">\n<td md-cell>{{grouping.key}}</td><td md-cell>{{grouping.name}}</td><td md-cell><span class=\"text-truncate\">\n{{grouping.description}}</span></td><td md-cell>{{grouping.employees | objectsLength}}</td></tr></tbody></table>\n</md-table-container><md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" \nng-show=\"groupings.length\" md-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" md-limit-options=\"F.paginations\" \nmd-page=\"currentPage\" md-on-paginate=\"restartSelected\" md-total=\"{{F.filteredItems.length}}\" md-page-select>\n</md-table-pagination></div></div><md-fab-speed-dial md-open=\"F.isOpen\" \nmd-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\"><md-fab-trigger><md-button \naria-label=\"crud menu\" class=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon></md-button>\n</md-fab-trigger><md-fab-actions><md-button with-permission action=\"read\" access=\"{{F.active.menuItem}}\" \nng-if=\"selected.length == 1\" ng-click=\"showEmployees($event, selected[0])\" aria-label=\"view\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Ver Empleados</md-tooltip><md-icon \nmd-font-icon=\"icon-person-box\"></md-icon></md-button><md-button with-permission action=\"read\" \naccess=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" \nng-click=\'R.goToDetail(null, \"read\", {groupingId: selected[0].$id})\' aria-label=\"view\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Ver</md-tooltip><md-icon \nmd-font-icon=\"icon-eye\" aria-label=\"view\"></md-icon></md-button><md-button with-permission action=\"update\" \naccess=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" \nng-click=\'R.goToDetail(null, \"update\", {groupingId: selected[0].$id})\' aria-label=\"edit\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Editar</md-tooltip><md-icon \nmd-font-icon=\"icon-pencil\" aria-label=\"edit\"></md-icon></md-button><md-button with-permission action=\"remove\" \naccess=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" ng-click=\"delete($event)\" aria-label=\"Delete\" \nclass=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">{{\'EC.REMOVE\' | translate}}</md-tooltip>\n<md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button><md-button with-permission \naction=\"create\" access=\"{{F.active.menuItem}}\" ng-if=\"!selected.length\" \nng-click=\'R.goToDetail(null, \"update\", {groupingId: \"new\"})\' aria-label=\"add\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">{{\'EC.ADD\' | translate}}\n</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon></md-button></md-fab-actions>\n</md-fab-speed-dial></div></div>");
$templateCache.put("app/main/employees/views/healthcareRecords/healthcareRecords.html","<div id=\"{{F.active.menuName}}\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\" \nng-controller=\"EmployeesMovementsController\"><div class=\"top-bg md-accent-bg\"><div with-permission ng-model=\"haveP\" \naction=\"saveSimple\" access=\"{{F.active.menuItem}}\"></div></div><div class=\"center\" layout=\"column\" flex><div \nmongo-search-bar></div><div class=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" \nlayout=\"column\" flex><div list-filters filters-loaded=\"F.filtersLoaded\" ng-model=\"F.filters[F.active.menuName]\" \non-change=\"getThem\" columns-repeat=\"columnsRepeat\" menu-obj-name=\"{{F.active.menuObjName}}\" \nmodel-name=\"{{F.active.menuName}}\" init-filters=\"initFilters\"></div><div table-loader array=\"healthcareRecords\" \nvalidations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"healthcareRecords.length\"><thead md-head \nmd-order=\"F.orderMongo\" fix-head md-on-reorder=\"getThem\"><tr md-row><th md-column \nmd-order-by=\"data.health.certificate\"><span>Certificado</span></th><th md-column md-order-by=\"rp\"><span>RP</span></th>\n<th md-column md-order-by=\"payroll\"><span>Nómina</span></th><th md-column md-order-by=\"data.name\"><span>Nombre</span>\n</th><th md-column md-order-by=\"data.info.emails[0].email\"><span>Correo</span></th><th md-column \nmd-order-by=\"data.health.initDate\"><span>Alta Salud</span></th><th md-column md-order-by=\"data.health.endDate\"><span>\nBaja Salud</span></th></tr></thead><tbody md-body><tr md-row md-select=\"employee\" \nng-class=\"{\'inactiveEmployee\': employee.movement.type == 2 || employee.status == 5}\" \nng-repeat=\"employee in healthcareRecords\"><td md-cell><md-input-container md-no-float \nng-if=\"haveP && !employee.data.health.certificate\"><ng-form name=\"healthCertificateForm\"><input type=\"number\" \nplaceholder=\"No. Certificado\" name=\"healthCertificate\" min=\"0\" ng-model=\"employee.data.health.certificate\" \nng-model-options=\"{ debounce: F.debounceTime*2 }\" unique-fb ref=\"{{F.active.menuRef}}\" query=\"data/health/certificate\" \nfromid=\"{{employee.$id}}\" \nng-change=\'C.saveSimple(employee.$id, employee.data.health.certificate, \"data/health/certificate\", \"employees\")\'><div \nng-messages=\"healthCertificateForm.healthCertificate.$error\" \nng-show=\"(healthCertificateForm.healthCertificate.$error && !healthCertificateForm.healthCertificate.$pristine) || (healthCertificateForm.healthCertificate.$error && employee.data.health.certificate)\" \nrole=\"alert\"><div ng-message=\"unique\">Certificado yá está registrado</div><div ng-message=\"min\">Certificado no válido\n</div></div></ng-form></md-input-container><span ng-if=\"!haveP||employee.data.health.certificate\">\n{{employee.data.health.certificate}} <span class=\"righted pointer\"><md-icon ng-if=\"haveP\" md-font-icon=\"icon-reload\" \naria-label=\"reload\" ng-click=\"employee.data.health.certificate = null\"></md-icon></span></span></td><td md-cell>\n{{employee[\'rp-name\']}}</td><td md-cell>{{employee[\'payroll-name\']}}</td><td md-cell>{{employee.data.name}}</td><td \nmd-cell>{{employee.data.info.emails[0].email}}</td><td md-cell>{{employee.data.health.initDate|date:F.dateFormat}}</td>\n<td md-cell>{{employee.data.health.endDate|date:F.dateFormat}}</td></tr></tbody></table></md-table-container>\n<md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" \nng-show=\"healthcareRecords.length\" md-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" \nmd-limit-options=\"F.paginations\" md-page=\"$parent.currentPage\" md-total=\"{{pagination.total}}\" \nmd-on-paginate=\"getThemPagination\" md-page-select></md-table-pagination></div></div><md-fab-speed-dial \nmd-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\"><md-fab-trigger>\n<md-button aria-label=\"crud menu\" class=\"md-fab md-accent\" md-class=\"{\'md-hue-1\': selected.length}\"><md-icon \nmd-font-icon=\"icon-cube\"></md-icon></md-button></md-fab-trigger><md-fab-actions><md-button with-permission \naction=\"exportAll\" access=\"{{F.active.menuItem}}\" ng-show=\"!selected.length\" ng-click=\"getExportAll()\" \naria-label=\"export all\" class=\"md-fab md-raised md-mini md-primary md-hue-1\"><md-tooltip md-direction=\"left\">\nExportar todos los registros a excel</md-tooltip><md-icon md-font-icon=\"icon-spreadsheet\" aria-label=\"export all icon\">\n</md-icon></md-button><md-button with-permission action=\"export\" access=\"{{F.active.menuItem}}\" \nng-click=\'exportDataToExcelByQuery(healthcareRecords,\"healthcareRecords\",getParamsObject(),pagination.total,\"catalogs/employees/collection\")\' \naria-label=\"export\" class=\"md-fab md-raised md-mini md-primary md-hue-2\"><md-tooltip md-direction=\"left\">\nExportar a excel</md-tooltip><md-icon md-font-icon=\"icon-file-excel\" aria-label=\"export icon\"></md-icon></md-button>\n<md-button with-permission action=\"read\" access=\"{{F.active.menuItem}}\" ng-show=\"selected.length == 1\" \nng-click=\'R.goToDetail(selected[0], \"read\", {employeeId: selected[0].$id, movementId: selected[0].movement.uid})\' \naria-label=\"Read\" class=\"md-fab md-raised md-primary md-mini\"><md-tooltip md-direction=\"left\">Ver</md-tooltip><md-icon \nmd-font-icon=\"icon-eye\" aria-label=\"read icon\"></md-icon></md-button><md-button with-permission action=\"healthBenefit\" \naccess=\"{{F.active.menuItem}}\" ng-click=\"checkHealthBenefit()\" aria-label=\"Read\" \nclass=\"md-fab md-raised md-primary md-mini\"><md-tooltip md-direction=\"left\">Checar beneficio de salud</md-tooltip>\n<md-icon md-font-icon=\"icon-hospital\" aria-label=\"read icon\"></md-icon></md-button></md-fab-actions>\n</md-fab-speed-dial></div></div>");
$templateCache.put("app/main/employees/views/healthcareRecords/healthcareRecords_old.html","<div id=\"{{F.active.menuName}}\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\" \nng-controller=\"EmployeesMovementsController\"><div class=\"top-bg md-accent-bg\"><div with-permission ng-model=\"haveP\" \naction=\"saveSimple\" access=\"{{F.active.menuItem}}\"></div></div><div class=\"center\" layout=\"column\" flex><div \nfb-search-bar-2></div><div class=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" \nlayout=\"column\" flex><div filter-toolbar></div><div table-loader array=\"employees\" validations=\"validations\"></div>\n<md-table-container class=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table \nmd-row-select multiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"employees.length\"><thead md-head \nmd-order=\"F.orderMongo\" fix-head md-on-reorder=\"getThem\"><tr md-row><th md-column \nmd-order-by=\"data.health.certificate\"><span>Certificado</span></th><th md-column md-order-by=\"rp\"><span>RP</span></th>\n<th md-column md-order-by=\"payroll\"><span>Nómina</span></th><th md-column md-order-by=\"data.name\"><span>Nombre</span>\n</th><th md-column md-order-by=\"data.info.emails[0].email\"><span>Correo</span></th><th md-column \nmd-order-by=\"data.health.initDate\"><span>Alta Salud</span></th><th md-column md-order-by=\"data.health.endDate\"><span>\nBaja Salud</span></th></tr></thead><tbody md-body><tr md-row md-select=\"employee\" \nng-class=\"{\'inactiveEmployee\': employee.movement.type == 2 || employee.status == 5}\" ng-repeat=\"employee in employees\">\n<td md-cell><md-input-container md-no-float ng-if=\"haveP && !employee.data.health.certificate\"><ng-form \nname=\"healthCertificateForm\"><input type=\"number\" placeholder=\"No. Certificado\" name=\"healthCertificate\" min=\"0\" \nng-model=\"employee.data.health.certificate\" ng-model-options=\"{ debounce: F.debounceTime*2 }\" unique-fb \nref=\"{{F.active.menuRef}}\" query=\"data/health/certificate\" fromid=\"{{employee.$id}}\" \nng-change=\'C.saveSimple(employee.$id, employee.data.health.certificate, \"data/health/certificate\", \"employees\")\'><div \nng-messages=\"healthCertificateForm.healthCertificate.$error\" \nng-show=\"(healthCertificateForm.healthCertificate.$error && !healthCertificateForm.healthCertificate.$pristine) || (healthCertificateForm.healthCertificate.$error && employee.data.health.certificate)\" \nrole=\"alert\"><div ng-message=\"unique\">Certificado yá está registrado</div><div ng-message=\"min\">Certificado no válido\n</div></div></ng-form></md-input-container><span ng-if=\"!haveP||employee.data.health.certificate\">\n{{employee.data.health.certificate}} <span class=\"righted pointer\"><md-icon ng-if=\"haveP\" md-font-icon=\"icon-reload\" \naria-label=\"reload\" ng-click=\"employee.data.health.certificate = null\"></md-icon></span></span></td><td md-cell>\n{{employee.rp|nameOfL:L.rps}}</td><td md-cell>{{employee.payroll|nameOfL:L.allPayrolls}}</td><td md-cell>\n{{employee.data.name}}</td><td md-cell>{{employee.data.info.emails[0].email}}</td><td md-cell>\n{{employee.data.health.initDate|date:F.dateFormat}}</td><td md-cell>{{employee.data.health.endDate|date:F.dateFormat}}\n</td></tr></tbody></table></md-table-container><md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" \nlayout-xs=\"column\" ng-show=\"employees.length\" md-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" \nmd-limit-options=\"F.paginations\" md-page=\"F.currentPageMongo\" md-total=\"{{pagination.total}}\" \nmd-on-paginate=\"getThemPagination\" md-page-select></md-table-pagination></div></div><md-fab-speed-dial \nmd-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\"><md-fab-trigger>\n<md-button aria-label=\"crud menu\" class=\"md-fab md-accent\" md-class=\"{\'md-hue-1\': selected.length}\"><md-icon \nmd-font-icon=\"icon-cube\"></md-icon></md-button></md-fab-trigger><md-fab-actions><md-button with-permission \naction=\"exportAll\" access=\"{{F.active.menuItem}}\" ng-show=\"!selected.length\" ng-click=\"getExportAll()\" \naria-label=\"export all\" class=\"md-fab md-raised md-mini md-primary md-hue-1\"><md-tooltip md-direction=\"left\">\nExportar todos los registros a excel</md-tooltip><md-icon md-font-icon=\"icon-spreadsheet\" aria-label=\"export all icon\">\n</md-icon></md-button><md-button with-permission action=\"export\" access=\"{{F.active.menuItem}}\" \nng-click=\'exportDataToExcelByQuery(employees,\"healthcareRecords\",getQuerys(),pagination.total,\"catalogs/employees/collection\")\' \naria-label=\"export\" class=\"md-fab md-raised md-mini md-primary md-hue-2\"><md-tooltip md-direction=\"left\">\nExportar a excel</md-tooltip><md-icon md-font-icon=\"icon-file-excel\" aria-label=\"export icon\"></md-icon></md-button>\n<md-button with-permission action=\"read\" access=\"{{F.active.menuItem}}\" ng-show=\"selected.length == 1\" \nng-click=\'R.goToDetail(selected[0], \"read\", {employeeId: selected[0].$id, movementId: selected[0].movement.uid})\' \naria-label=\"Read\" class=\"md-fab md-raised md-primary md-mini\"><md-tooltip md-direction=\"left\">Ver</md-tooltip><md-icon \nmd-font-icon=\"icon-eye\" aria-label=\"read icon\"></md-icon></md-button><md-button with-permission action=\"healthBenefit\" \naccess=\"{{F.active.menuItem}}\" ng-click=\"checkHealthBenefit()\" aria-label=\"Read\" \nclass=\"md-fab md-raised md-primary md-mini\"><md-tooltip md-direction=\"left\">Checar beneficio de salud</md-tooltip>\n<md-icon md-font-icon=\"icon-hospital\" aria-label=\"read icon\"></md-icon></md-button></md-fab-actions>\n</md-fab-speed-dial></div></div>");
$templateCache.put("app/main/employees/views/idseRecords/idseRecords.html","<div id=\"{{F.active.menuName}}\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\" \nng-controller=\"EmployeesMovementsController\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" \nlayout=\"column\" flex><div fb-search-bar></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><div filter-toolbar></div><div table-loader \narray=\"Z.idseRecords\" validations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"F.filteredItems.length\"><thead md-head \nmd-order=\"order\" fix-head><tr md-row><th md-column md-order-by=\"received.batch\"><span>Lote</span></th><th md-column \nmd-order-by=\"payroll\"><span>Nómina</span></th><th md-column md-order-by=\"rp\"><span>RP</span></th><th md-column \nmd-order-by=\"info.nss\"><span>NSS</span></th><th md-column md-order-by=\"info.name\"><span>Nombre</span></th><th \nmd-column md-order-by=\"data.type\"><span>Mvto</span></th><th md-column md-order-by=\"sbc\"><span>SBC</span></th><th \nmd-column md-order-by=\"date\"><span>Fecha</span></th><th md-column md-order-by=\"received.atTime\"><span>Fecha Recibido\n</span></th></tr></thead><tbody md-body><tr md-row md-auto-select md-select=\"movement\" md-select-id=\"$id\" \nng-repeat=\"movement in (F.filteredItems = (Z.idseRecords | filter:F.searchText[F.active.menuObjName] | orderBy:order)) | limitTo: F.paginate: (currentPage - 1) * F.paginate\">\n<td md-cell>{{movement.received.batch}}</td><td md-cell>{{movement.payroll | nameOfL:L.allPayrolls}}</td><td md-cell>\n{{movement.rp | nameOfL:L.rps}}</td><td md-cell>{{movement.info.nss}}</td><td md-cell>{{movement.info.name}}</td><td \nmd-cell>{{movement.data.type | typeName}}</td><td md-cell>{{movement.data.sbc | currency}}</td><td md-cell>\n{{movement.data.date | date:\'dd/MM/yyyy\'}}</td><td md-cell>{{movement.received.atTime | date:\'dd/MM/yyyy\'}}</td></tr>\n</tbody></table></md-table-container><md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" \nlayout-xs=\"column\" ng-show=\"F.filteredItems.length\" md-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" \nmd-limit-options=\"F.paginations\" md-page=\"currentPage\" md-on-paginate=\"restartSelected\" \nmd-total=\"{{F.filteredItems.length}}\" md-page-select></md-table-pagination></div></div><md-fab-speed-dial \nmd-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\"><md-fab-trigger>\n<md-button aria-label=\"crud menu\" class=\"md-fab md-accent\" md-class=\"{\'md-hue-1\': selected.length}\"><md-icon \nmd-font-icon=\"icon-cube\"></md-icon></md-button></md-fab-trigger><md-fab-actions><md-button with-permission \naction=\"export\" access=\"{{F.active.menuItem}}\" \nng-click=\"exportDataToExcel(F.filteredItems,F.active.menuName,currentPage,F.paginate,true)\" aria-label=\"export\" \nclass=\"md-fab md-raised md-mini md-primary md-hue-2\"><md-tooltip md-direction=\"left\">Exportar a excel</md-tooltip>\n<md-icon md-font-icon=\" icon-file-excel\" aria-label=\"export\"></md-icon></md-button><md-button with-permission \naction=\"read\" access=\"{{F.active.menuItem}}\" ng-show=\"selected.length == 1\" \nng-click=\'R.goToDetail(selected[0], \"read\", {employeeId: selected[0].employee, movementId:selected[0].$id})\' \naria-label=\"Read\" class=\"md-fab md-raised md-primary md-mini\"><md-tooltip md-direction=\"left\">Ver</md-tooltip><md-icon \nmd-font-icon=\"icon-eye\" aria-label=\"read icon\"></md-icon></md-button><md-button with-permission action=\"archive\" \naccess=\"{{F.active.menuItem}}\" ng-show=\"selected.length\" ng-click=\"moveMovements($event, 4)\" \naria-label=\"archiveMovements\" class=\"md-fab md-raised md-mini md-primary md-hue-3\"><md-tooltip md-direction=\"left\">\nArchivar Movimientos</md-tooltip><md-icon md-font-icon=\"icon-archive\" aria-label=\"archive movements\"></md-icon>\n</md-button><md-button action=\"sendToIdse\" access=\"{{F.active.menuItem}}\" ng-show=\"selected.length\" \nng-click=\"returnToSending($event, 2)\" aria-label=\"moveEmployees\" class=\"md-fab md-raised md-mini md-accent md-hue-2\">\n<md-tooltip md-direction=\"left\">Regresar a enviando</md-tooltip><md-icon \nmd-font-icon=\"icon-arrow-right-bold-hexagon-outline\" aria-label=\"move\"></md-icon></md-button></md-fab-actions>\n</md-fab-speed-dial></div></div>");
$templateCache.put("app/main/employees/views/idseAutoRecords/dialogArchivate.html","<md-dialog><md-toolbar><div class=\"md-toolbar-tools\"><h2>Recibir {{ctrl.selected}} Movimiento(s)</h2><md-button \nclass=\"md-icon-button\" ng-click=\"ctrl.close()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close Dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"p-0\"><form name=\"movementForm\" ng-submit=\"answer(noLote)\" \nng-disabled=\"movementForm.$invalid\" novalidate><div class=\"md-dialog-content\"><div layout-gt-xs=\"row\" flex><h2>\n¿Seguro que desea archivar este movimiento?</h2></div></div></form></md-dialog-content><md-dialog-actions layout=\"row\">\n<span flex></span><md-button ng-click=\"ctrl.close()\" class=\"md-raised md-accent\">Cancelar</md-button><md-button \nng-click=\"ctrl.archived(ctrl.noLote)\" class=\"md-raised md-primary\" ng-disabled=\"movementForm.$invalid\">OK</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/employees/views/idseAutoRecords/idseAutoRecord.html","<div id=\"employee\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill \nng-controller=\"EmployeeController\"><form name=\"form\" novalidate flex layout=\"column\" ng-disabled=\"F.readMode\">\n<md-toolbar class=\"md-tall header md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" \nlayout=\"row\" layout-align=\"start center\" flex><md-button class=\"goto-button md-icon-button\" \naria-label=\"Go to employees\" ng-click=\"R.goToList(F.active.menuName, F.active.menuParams)\" translate \ntranslate-attr-aria-label=\"EC.GO_TO\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" \nlayout-align=\"start center\"><a class=\"crud-image pointer\" hide-xs ng-click=\"selectedTab = 2\"><img \nng-if=\"employee.avatar\" ng-src=\"{{employee.avatar}}\"> <img ng-if=\"!employee.avatar\" class=\"thumb-image\" \nng-src=\"{{F.imagePlaceholder}}\"></a><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\">\nEdición {{employee.data.name}}</div><div class=\"subtitle secondary-text\"><span ng-if=\"!F.addMode\">\n{{\'EC.DETAIL_OF\' | translate}} {{\'employee.SINGULAR\' | translate}}</span> <span ng-if=\"F.addMode\">\n{{\'EC.CREATE\' | translate}} {{\'employee.SINGULAR\' | translate}}</span></div></div></div></div><div><md-button \ntype=\"submit\" ng-if=\"form.$valid\" ng-click=\"saveIdseAutoRecords()\" with-permission action=\"update\" \naccess=\"{{F.active.menuItem}}\" ng-hide=\"form.$pristine\" \nng-disabled=\"form.$invalid || form.$pending || loadingProgress\" \nclass=\"md-raised md-background md-fab md-accent md-hue-1\" aria-label=\"update employee\"><md-tooltip md-direction=\"left\">\nActualizar Movimiento</md-tooltip><md-icon md-font-icon=\"icon-content-save\" aria-label=\"save\"></md-icon></md-button>\n<validate-form-button></validate-form-button></div></md-toolbar><md-content layout=\"column\" class=\"content\" flex>\n<md-tabs md-selected=\"selectedTab\" flex md-dynamic-height class=\"scrollable\"><md-tab label=\"Movimiento\" \nng-if=\"movement.data\"><md-tab-body><div class=\"detail-form-container md-background-bg md-whiteframe-1dp\"><div \nform-special-movement></div><div form-fast-enrole ng-if=\"[6,8].indexOf(movement.data.type)>-1\"></div></div>\n</md-tab-body></md-tab><md-tab label=\"Otros\" ng-if=\"[6,8].indexOf(movement.data.type)>-1\"><md-tab-body><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\" flex layout-fill=\"column\"><div form-worker></div>\n</div></md-tab-body></md-tab></md-tabs></md-content></form></div>");
$templateCache.put("app/main/employees/views/idseAutoRecords/idseAutoRecords.html","<div id=\"idseAutoRecords\" class=\"page-layout carded fullwidth crud-index\" ng-controller=\"IdseAutoRecordsController\" \nlayout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div mongo-search-bar>\n</div><div class=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex>\n<md-tabs ng-if=\"tabs\" md-selected=\"F.selectedTab\"><md-tab ng-repeat=\"tab in tabs\" label=\"{{tab.title}}\" \nmd-on-select=\"$parent.setTabName(tab.name)\"></md-tab></md-tabs><div list-filters filters-loaded=\"F.filtersLoaded\" \nng-model=\"F.filters[F.active.menuName]\" on-change=\"getThem\" tab-name=\"tabName\" tab-config=\"tabs[tabName]\" \ncolumns-repeat=\"columnsRepeat\" menu-obj-name=\"{{F.active.menuObjName}}\" model-name=\"{{F.active.menuName}}\" \ninit-filters=\"initFilters\"></div><div table-loader array=\"idseAutoRecords\" validations=\"validations\"></div>\n<md-table-container class=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table \nmd-row-select multiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"idseAutoRecords.length\"><thead md-head \nmd-order=\"F.orderMongo\" fix-head md-on-reorder=\"getThem\"><tr md-row><th md-column md-order-by=\"rp\">RP</th><th \nmd-column md-order-by=\"payroll\">Nómina</th><th md-column md-order-by=\"info.nss\">NSS</th><th md-column \nmd-order-by=\"info.name\">Nombre</th><th md-column md-order-by=\"data.type\" \nng-if=\"[\'enroleRecord\',\'idseRecord\',\'acceptedRecord\',\'deniedRecord\'].indexOf(tabs[tabName].name) > -1\">Tipo</th><th \nmd-column md-order-by=\"data.received.batch\" \nng-if=\"[\'idseRecord\',\'acceptedRecord\',\'deniedRecord\'].indexOf(tabs[tabName].name) > -1\">Lote</th><th md-column \nmd-order-by=\"data.date\">Fecha</th><th md-column md-order-by=\"data.sd\">SD</th><th md-column md-order-by=\"data.sbc\">SBC\n</th><th md-column md-order-by=\"received.atTime\" ng-if=\"[\'idseRecord\'].indexOf(tabs[tabName].name) > -1\"><span>\nFecha Recibido</span></th><th md-column md-order-by=\"archived.atTime\" \nng-if=\"[\'acceptedRecord\'].indexOf(tabs[tabName].name) > -1\">Fecha Archivado</th><th md-column \nmd-order-by=\"rejected.atTime\" ng-if=\"[\'deniedRecord\'].indexOf(tabs[tabName].name) > -1\">Fecha Rechazado</th><th \nmd-column md-order-by=\"rejected.msg\" ng-if=\"[\'deniedRecord\'].indexOf(tabs[tabName].name) > -1\">Error</th></tr></thead>\n<tbody md-body><tr md-row md-auto-select md-select=\"idseAutoRecord\" md-select-id=\"_id\" \nng-repeat=\"idseAutoRecord in idseAutoRecords\"><td md-cell ng-bind=\"idseAutoRecord[\'rp-rp\']\"></td><td md-cell \nng-bind=\"idseAutoRecord[\'payroll-name\']\"></td><td md-cell ng-bind=\"idseAutoRecord.info.nss\"></td><td md-cell>\n{{idseAutoRecord.info.name}}<md-icon ng-if=\"idseAutoRecord.data.type === 2 && idseAutoRecord.data.fromSettlement\" \nmd-font-icon=\"icon-flip-to-front\"></md-icon></td><td md-cell ng-bind=\"idseAutoRecord.data.type | typeName\" \nng-if=\"[\'enroleRecord\',\'idseRecord\',\'acceptedRecord\',\'deniedRecord\'].indexOf(tabs[tabName].name) > -1\"></td><td \nmd-cell ng-bind=\"idseAutoRecord.received.batch || idseAutoRecord.received.batchTemp\" \nng-if=\"[\'idseRecord\',\'acceptedRecord\',\'deniedRecord\'].indexOf(tabs[tabName].name) > -1\"></td><td md-cell \nng-bind=\"idseAutoRecord.data.date | date : F.dateFormat\"></td><td md-cell ng-bind=\"idseAutoRecord.data.sd\"></td><td \nmd-cell ng-bind=\"idseAutoRecord.data.sbc\"></td><td md-cell \nng-bind=\"idseAutoRecord.received.atTime | date: \'dd/MM/yyyy hh:mm a\'\" \nng-if=\"[\'idseRecord\'].indexOf(tabs[tabName].name) > -1\"></td><td md-cell \nng-bind=\"(idseAutoRecord.archived.date || idseAutoRecord.archived.atTime) | date : \'dd/MM/yyyy hh:mm a\'\" \nng-if=\"[\'acceptedRecord\'].indexOf(tabs[tabName].name) > -1\"></td><td md-cell \nng-bind=\"idseAutoRecord.rejected.atTime | date : F.dateFormat\" \nng-if=\"[\'deniedRecord\'].indexOf(tabs[tabName].name) > -1\"></td><td md-cell ng-bind=\"idseAutoRecord.rejected.msg\" \nng-if=\"[\'deniedRecord\'].indexOf(tabs[tabName].name) > -1\"></td></tr></tbody></table></md-table-container>\n<md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" \nng-show=\"idseAutoRecords.length\" md-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" \nmd-limit-options=\"F.paginations\" md-page=\"$parent.currentPage\" md-total=\"{{pagination.total}}\" \nmd-on-paginate=\"getThemPagination\" md-page-select></md-table-pagination></div></div><md-fab-speed-dial \nmd-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\"><md-fab-trigger>\n<md-button aria-label=\"crud menu\" class=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon>\n</md-button></md-fab-trigger><md-fab-actions><md-button with-permission action=\"archived\" \naccess=\"{{F.active.menuItem}}\" ng-show=\"selected.length\" \nng-if=\"selected.length > 0 && [\'enroleRecord\',\'dismissRecord\', \'mdsRecord\'].indexOf(tabs[tabName].name) > -1\" \nng-click=\"archivedMovement($event,selected, 4)\" aria-label=\"moveEmployees\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Archivar movimientos</md-tooltip>\n<md-icon md-font-icon=\"icon-arrow-right-bold-hexagon-outline\" aria-label=\"move\"></md-icon></md-button><md-button \nwith-permission action=\"getSua\" access=\"{{F.active.menuItem}}\" ng-click=\"getSuaInterface(selected)\" \nng-if=\"selected.length > 0 && [\'idseRecord\',\'acceptedRecord\'].indexOf(tabs[tabName].name) === -1\" aria-label=\"getSua\" \nclass=\"md-fab md-raised md-mini md-primary md-hue-3\"><md-tooltip md-direction=\"left\">Layout Movimiento</md-tooltip>\n<md-icon md-svg-src=\"/assets/icons/SUA.svg\" aria-label=\"sua\"></md-icon></md-button><md-button with-permission \naction=\"sendMovementsV2\" access=\"movements.idseAutoRecords\" \nng-show=\"selected.length > 0 && [\'enroleRecord\',\'mdsRecord\',\'dismissRecord\'].indexOf(tabs[tabName].name) > -1 || (\'deniedRecord\'===tabs[tabName].name && !(selected|recordsHaveValue:\'received.batch\':\'#anyValue#\':true))\" \naria-label=\"send movements to IDSE\" ng-click=\"sendMovements($event, selected, true)\" \nclass=\"md-fab md-raised md-mini md-primary md-hue-3\"><md-tooltip md-direction=\"left\">Enviar IDSE V2</md-tooltip>\n<md-icon md-svg-src=\"/assets/icons/IDSE.svg\" aria-label=\"idse\"></md-icon></md-button><md-button with-permission \naction=\"sendMovementsV2\" access=\"movements.idseAutoRecords\" \nng-show=\"selected.length > 0 && \'deniedRecord\'===tabs[tabName].name && (selected[0].received.batch?true:false) && (selected|recordsHaveValue:\'received.batch\':selected[0].received.batch)\" \naria-label=\"send movements to IDSE\" ng-click=\"sendMovements($event, selected, true, selected[0].received.batch)\" \nclass=\"md-fab md-raised md-mini md-primary md-hue-3\"><md-tooltip md-direction=\"left\">Recibir IDSE V2</md-tooltip>\n<md-icon md-svg-src=\"/assets/icons/IDSE.svg\" aria-label=\"idse\"></md-icon></md-button><md-button with-permission \naction=\"sendMovements\" access=\"movements.idseAutoRecords\" \nng-if=\"selected.length > 0 && [\'enroleRecord\',\'mdsRecord\',\'dismissRecord\'].indexOf(tabs[tabName].name) > -1\" \naria-label=\"send movements to IDSE\" ng-click=\"sendMovements($event,selected)\" \nclass=\"md-fab md-raised md-mini md-primary md-hue-3\"><md-tooltip md-direction=\"left\">Enviar IDSE</md-tooltip><md-icon \nmd-svg-src=\"/assets/icons/IDSE.svg\" aria-label=\"idse\"></md-icon></md-button><md-button with-permission \naction=\"getResponseFromIdse\" access=\"movements.idseAutoRecords\" \nng-if=\"selected.length > 0 && [\'idseRecord\'].indexOf(tabs[tabName].name) > -1\" aria-label=\"send movements to IDSE\" \nng-click=\"getResponseOfMovements($event,selected)\" class=\"md-fab md-raised md-mini md-primary md-hue-3\"><md-tooltip \nmd-direction=\"left\">Recibir IDSE</md-tooltip><md-icon md-svg-src=\"/assets/icons/IDSE.svg\" aria-label=\"idse\"></md-icon>\n</md-button><md-button with-permission action=\"getResponseFromIdseV2\" access=\"movements.idseAutoRecords\" \nng-if=\"selected.length > 0 && [\'idseRecord\'].indexOf(tabs[tabName].name) > -1\" aria-label=\"send movements to IDSE\" \nng-click=\"getResponseOfMovements($event,selected,true)\" class=\"md-fab md-raised md-mini md-primary md-hue-3\">\n<md-tooltip md-direction=\"left\">Recibir IDSE V2</md-tooltip><md-icon md-svg-src=\"/assets/icons/IDSE.svg\" \naria-label=\"idse\"></md-icon></md-button><md-button with-permission action=\"generatePdfMovement\" \naccess=\"{{F.active.menuItem}}\" ng-if=\"selected.length > 0 && [\'acceptedRecord\'].indexOf(tabs[tabName].name) > -1\" \nng-click=\"printPDF($event)\" aria-label=\"generatePDF\" class=\"md-fab md-raised md-mini md-primary md-hue-3\"><md-tooltip \nmd-direction=\"left\">PDF</md-tooltip><md-icon md-font-icon=\"icon-file-pdf\" aria-label=\"print pdf\"></md-icon></md-button>\n<md-button with-permission action=\"export\" access=\"{{F.active.menuItem}}\" \nng-click=\'exportDataToExcelByQuery(idseAutoRecords,F.active.menuName,getParamsObject(),pagination.total,\"catalogs/movements/collection\")\' \naria-label=\"export\" class=\"md-fab md-raised md-mini md-primary md-hue-2\"><md-tooltip md-direction=\"left\">\nExportar a excel</md-tooltip><md-icon md-font-icon=\" icon-file-excel\" aria-label=\"export\"></md-icon></md-button>\n<md-button with-permission action=\"read\" access=\"{{F.active.menuItem}}\" \nng-if=\"selected.length === 1 && [\'enroleRecord\',\'mdsRecord\',\'dismissRecord\'].indexOf(tabs[tabName].name) > -1\" \nng-click=\'goToDetail(\"read\", selected[0])\' aria-label=\"Read\" class=\"md-fab md-raised md-primary md-mini\"><md-tooltip \nmd-direction=\"left\">Ver</md-tooltip><md-icon md-font-icon=\"icon-eye\" aria-label=\"read icon\"></md-icon></md-button>\n<md-button with-permission action=\"cancelMovement\" access=\"{{F.active.menuItem}}\" ng-show=\"selected.length > 0\" \nng-click=\"cancelLastMovement($event,selected)\" aria-label=\"cancel last movement\" \nclass=\"md-fab md-mini md-warn md-hue-2\"><md-tooltip md-direction=\"left\">Cancelar Último Movimiento</md-tooltip><md-icon\n md-font-icon=\"icon-close\" aria-label=\"cancel\"></md-icon></md-button><md-button with-permission action=\"update\" \naccess=\"{{F.active.menuItem}}\" \nng-show=\"selected.length === 1 && [\'enroleRecord\',\'mdsRecord\',\'dismissRecord\'].indexOf(tabs[tabName].name) > -1\" \nng-click=\'goToDetail(\"update\", selected[0])\' aria-label=\"update\" class=\"md-fab md-raised md-primary md-mini\">\n<md-tooltip md-direction=\"left\">Editar</md-tooltip><md-icon md-font-icon=\"icon-pencil\" aria-label=\"edit icon\">\n</md-icon></md-button><md-button with-permission action=\"update\" access=\"{{F.active.menuItem}}\" \nng-show=\"selected.length === 1 && [\'deniedRecord\'].indexOf(tabs[tabName].name) > -1\" \nng-click=\'R.goToDetail(null, \"update\", {employeeId:selected[0].employee, movementId:selected[0].fid})\' \naria-label=\"update\" class=\"md-fab md-raised md-primary md-mini\"><md-tooltip md-direction=\"left\">Editar</md-tooltip>\n<md-icon md-font-icon=\"icon-pencil\" aria-label=\"edit icon\"></md-icon></md-button><md-button with-permission \naction=\"sendToUnconfirmed\" access=\"{{F.active.menuItem}}\" \nng-show=\"selected.length === 1 && [\'dismissRecord\'].indexOf(tabs[tabName].name) > -1\" \nng-click=\"showModalSendToUnconfirmed($event)\" aria-label=\"send to unconfirmed dismisses\" \nclass=\"md-fab md-mini md-warn md-hue-2\"><md-tooltip md-direction=\"left\">Mandar a bajas por confirmar</md-tooltip>\n<md-icon md-font-icon=\"icon-pin\" aria-label=\"cancel\"></md-icon></md-button></md-fab-actions></md-fab-speed-dial></div>\n</div>");
$templateCache.put("app/main/employees/views/kardexEmployees/kardexEmployee copy.html","<div id=\"kardexEmployee\" ng-controller=\"KardexEmployeeController\"><md-toolbar layout-gt-xs=\"row\" \nlayout-align=\"space-between center\" style=\"min-height: auto;height:auto!important; color: white\"><div class=\"white-fg\" \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"goto-button md-icon-button\" aria-label=\"Go to employees\" \nng-click=\"R.goToList(F.active.menuName, F.active.menuParams)\" translate translate-attr-aria-label=\"EC.GO_TO\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><div flex=\"nogrow\" class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-account-circle\" class=\"crud-icon\"></md-icon><span>\n{{employee.data.name}}</span></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex md-padding \nng-if=\"!F.active.disableSearchBar\"><div flex=\"nogrow\"><md-button ng-disabled=\"!F.search[F.active.menuObjName]\" \nclass=\"md-fab md-mini md-primary\" aria-label=\"search button\" type=\"submit\" ng-click=\'getThem(false,\"from searchbar\")\'>\n<md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button></div><md-autocomplete class=\"md-block\" flex \nmd-min-length=\"2\" md-selected-item=\"employeeSelected\" md-search-text=\"searchEmployee\" \nmd-selected-item-change=\"loadEmployee(employeeSelected)\" md-item-text=\"item.data.name\" md-delay=\"500\" \nmd-items=\'item in autocompleteListM(searchEmployee, \"employees\",[\"data.name\",\"data.nss\"],{project:{data:1,fid:1}})\' \nmd-require-match=\"true\" md-select-on-match=\"true\" md-match-case-insensitive=\"true\" placeholder=\"Empleado\" \nmd-no-cache=\"true\" md-floating-label=\"Empleado\" required><md-item-template><span md-highlight-text=\"searchEmployee\" \nng-class=\"{\'inactiveOption\': (item.status==5)}\">{{item.data.nss?item.data.nss+\' - \':\'\'}}{{item.data.name}}</span>\n</md-item-template><md-not-found>No hay registros</md-not-found></md-autocomplete></div></md-toolbar><div \nlayout-gt-xs=\"row\" layout-xs=\"column\" layout-gt-md=\"row\" layout-md=\"row\" layout-gt-sm=\"row\" layout-sm=\"column\" \nlayout-gt-lg=\"row\" layout-lg=\"row\" flex flex-xs=\"100\" flex-sm=\"100\" flex-lg=\"100\" flex-md=\"100\" \nclass=\"white-500-bg mt-30\" style=\"border-radius: 20px; border-color: rgb(229, 229, 229); border-style: solid\"><div \nlayout=\"column\" layout-wrap flex=\"30\" layout-align-sm=\"center center\" flex-xs=\"100\" flex-sm=\"100\"><div class=\"p-10\" \nlayout=\"row\" flex-xs=\"100\" flex-sm=\"100\" layout-align=\"center start\"><div layout=\"row\" flex-xs=\"100\" flex=\"100\" \nlayout-align=\"center center\" class=\"white-500-bg\" \nstyle=\"border-radius: 20px;border-color: rgb(229, 229, 229);border-style: solid\"><div layout=\"column\" flex-xs=\"100\" \nlayout-align=\"center center\"><div layout=\"row\" layout-align=\"center none\" class=\"mt-5\"><img ng-src=\"{{avatarImage}}\" \nstyle=\"border-radius: 50%\" alt=\"Imagen del avatar\" class=\"rounded-circle w-130\"></div><div layout=\"row\" \nlayout-align=\"center center\" class=\"mt-10\"><div class=\"blue-900-fg font-size-16\" ng-if=\"employee.data.name \">\nNOMBRE: {{employee.data.name}}</div></div><div layout=\"column\" layout-align=\"center none\" class=\"mt-5\"><div \nlayout=\"row\" layout-align=\"center none\" class=\"mt-5\"><div class=\"blue-900-fg font-size-16\">NOMINA: <span>{{nomina}} \n</span></div></div><div layout=\"row\" layout-align=\"center none\" class=\"mt-5\"><div class=\"blue-900-fg font-size-16\">\nCENTRO DE COSTOS: <span>{{employee.payroll | getSomethingOfArrayFB: L.ccs : \'name\' : \'No se encontró\': \'payroll\'}}\n</span></div></div><div layout=\"row\" layout-align=\"center none\" class=\"mt-5\"><div class=\"blue-900-fg font-size-16\">\nPUESTO: <span>{{position}}</span></div></div><div layout=\"row\" layout-align=\"center none\" class=\"mt-5\"><div \nclass=\"blue-900-fg font-size-16\">REGIMEN PATRONAL: <span>\n{{employee.rp | getSomethingOfArrayFB: L.ccs : \'name\' : \'No se encontró\': \'rp_id\' }}</span></div></div></div></div>\n</div></div><div class=\"p-10\" flex-xs=\"100\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\" flex=\"100\" \nlayout-align=\"center center\" class=\"white-500-bg\" \nstyle=\"border-radius: 20px; border-color: rgb(229, 229, 229);border-style: solid\"><div layout=\"column\" class=\"mt-20\" \nflex=\"50\" layout-align=\"center center\"><div class=\"blue-900-fg font-size-16\">ANTIGÜEDAD</div><md-icon \nmd-font-icon=\"icon-alarm\" aria-label=\"export\" class=\"blue-700-fg\"></md-icon><div style=\"font-weight: bold\" \nclass=\"blue-900-fg font-size-16\">\n{{ employee.data.seniorityDate ? (employee.data.seniorityDate | date:F.dateFormat) : (employee.data.enroleDate | date:F.dateFormat) }}\n</div><div class=\"mt-10 blue-900-fg font-size-16\">SUELDO DIARIO</div><md-icon md-font-icon=\"icon-alarm\" \naria-label=\"export\" class=\"blue-700-fg\"></md-icon><div style=\"font-weight: bold\" class=\"blue-900-fg font-size-16\">\n{{employee.data.salary.sd | currency}}</div><div class=\"mt-10 blue-900-fg font-size-16\">SUELDO DIARIO REAL</div>\n<md-icon md-font-icon=\"icon-alarm\" aria-label=\"export\" class=\"blue-700-fg\"></md-icon><div style=\"font-weight: bold\" \nclass=\"blue-900-fg font-size-16\">{{employee.data.salary.sdr | currency}}</div><div \nclass=\"mt-10 text-center blue-900-fg font-size-16\">SUELDO BASE COTIZACIÓN</div><md-icon md-font-icon=\"icon-alarm\" \naria-label=\"export\" class=\"blue-700-fg\"></md-icon><div style=\"font-weight: bold\" class=\"blue-900-fg font-size-16\">\n{{employee.data.salary.sbc | currency}}</div><div class=\"mt-10 blue-900-fg font-size-16\">SUELDO BRUTO</div><md-icon \nmd-font-icon=\"icon-alarm\" aria-label=\"export\" class=\"blue-700-fg\"></md-icon><div style=\"font-weight: bold\" \nclass=\"blue-900-fg font-size-16\">NA</div><div class=\"mt-10 blue-900-fg font-size-16\">FACTOR INTEGRACIÓN</div><md-icon \nmd-font-icon=\"icon-alarm\" aria-label=\"export\" class=\"blue-700-fg\"></md-icon><div style=\"font-weight: bold\" \nclass=\"blue-900-fg font-size-16 mb-20\">{{employee.data.if?(employee.data.if):(\'No hay información\')}}</div></div><div \nlayout=\"column\" class=\"mt-20\" flex=\"50\" layout-align=\"center center\"><div class=\"blue-900-fg font-size-16\">\nAÑOS EN LA EMPRESA</div><md-icon md-font-icon=\"icon-alarm\" aria-label=\"export\" class=\"blue-700-fg\"></md-icon><div \nstyle=\"font-weight: bold\" class=\"blue-900-fg font-size-16\">\n{{employee.data.b.ry?(employee.data.b.ry | number):(\'No se encontró\')}}</div><div \nclass=\"mt-10 blue-900-fg font-size-16\">DIAS TRABAJADOS</div><md-icon md-font-icon=\"icon-alarm\" aria-label=\"export\" \nclass=\"blue-700-fg\"></md-icon><div style=\"font-weight: bold\" class=\"blue-900-fg font-size-16\">\n{{employee.data.seniorityDate | getWorkedDays: employee.data.enroleDate}}</div><div \nclass=\"mt-10 blue-900-fg font-size-16\">ANIVERSARIOS</div><md-icon md-font-icon=\"icon-alarm\" aria-label=\"export\" \nclass=\"blue-700-fg\"></md-icon><div style=\"font-weight: bold\" class=\"blue-900-fg font-size-16\">\n{{employee.data.lastHolEv.anniversaryNumber?(employee.data.lastHolEv.anniversaryNumber):(\'No se encontró\')}}</div><div \nclass=\"mt-10 blue-900-fg font-size-16\">VACACIONES</div><md-icon md-font-icon=\"icon-alarm\" aria-label=\"export\" \nclass=\"blue-700-fg\"></md-icon><div style=\"font-weight: bold\" class=\"blue-900-fg font-size-16\">\n{{employee.data.lastHolEv.total}} Dias</div><div class=\"mt-10 blue-900-fg font-size-16\">AGUINALDO</div><md-icon \nmd-font-icon=\"icon-alarm\" aria-label=\"export\" class=\"blue-700-fg\"></md-icon><div style=\"font-weight: bold\" \nclass=\"blue-900-fg font-size-16\">{{employee.data.b.c}} Dias</div><div class=\"mt-10 blue-900-fg font-size-16\">\nPRIMA VACACIONAL</div><md-icon md-font-icon=\"icon-alarm\" aria-label=\"export\" class=\"blue-700-fg\"></md-icon><div \nstyle=\"font-weight: bold\" class=\"blue-900-fg font-size-16 mb-20\">{{employee.data.b.p}}%</div></div></div></div></div>\n<div flex=\"100\" flex-xs=\"100\" layout=\"column\" class=\"mt-20\"><div ng-cloak flex=\"100\" flex-xs=\"100\"><md-content \nstyle=\"border-radius: 20px; border-color: rgb(229, 229, 229); border-style: solid\"><md-tabs md-dynamic-height \nmd-border-bottom md-selected=\"selectedTab\" class=\"md-white-bg\"><div class=\"margin-top-15 red-100-bg\"><md-tab \nlabel=\"INFORMACIÓN\" md-on-select=\"setTabName(\'information\')\"><md-content class=\"md-padding white-500-bg\"><div \nclass=\"font-size-20 margin-bottom-10\">INFORMACIÓN PERSONAL<md-icon md-font-icon=\"icon-people\" aria-label=\"export\" \nclass=\"blue-700-fg\"></md-icon></div><div layout-gt-xs=\"row\" layout-xs=\"column\" class=\"margin-top-20\" \nlayout-align=\"space-between start\"><div class=\"blue-900-fg font-size-16\" flex=\"25\" flex-xs=\"50\">RFC<md-icon \nmd-font-icon=\"icon-check-circle\" aria-label=\"export\" class=\"blue-700-fg\"></md-icon><div style=\"font-weight: bold\" \nclass=\"blue-900-fg font-size-16\">{{employee.data.rfc}}</div></div><div class=\"blue-900-fg font-size-16\" flex=\"25\" \nflex-xs=\"50\">CURP<md-icon md-font-icon=\"icon-check-circle\" aria-label=\"export\" class=\"blue-700-fg\"></md-icon><div \nstyle=\"font-weight: bold\" class=\"blue-900-fg font-size-16\">{{curp}}</div></div><div class=\"blue-900-fg font-size-16\" \nflex=\"25\" flex-xs=\"50\">FECHA DE NACIMIENTO<md-icon md-font-icon=\"icon-check-circle\" aria-label=\"export\" \nclass=\"blue-700-fg\"></md-icon><div style=\"font-weight: bold\" class=\"blue-900-fg font-size-16\">\n{{nacimiento | date:F.dateFormat}}</div></div><div class=\"blue-900-fg font-size-16\" flex=\"25\" flex-xs=\"50\">NSS<md-icon \nmd-font-icon=\"icon-check-circle\" aria-label=\"export\" class=\"blue-700-fg\"></md-icon><div style=\"font-weight: bold\" \nclass=\"blue-900-fg font-size-16\">{{employee.data.nss}}</div></div></div><div layout-gt-xs=\"row\" layout-xs=\"column\" \nlayout-align=\"space-between start\" class=\"margin-top-30\"><div class=\"blue-900-fg font-size-16\" flex=\"25\" flex-xs=\"50\">\nESTADO CIVIL<md-icon md-font-icon=\"icon-check-circle\" aria-label=\"export\" class=\"blue-700-fg\"></md-icon><div \nstyle=\"font-weight: bold\" class=\"blue-900-fg font-size-16\">{{employee.data.maritalStatus}}</div></div><div \nclass=\"blue-900-fg font-size-16\" flex=\"25\" flex-xs=\"50\">CÓDIGO POSTAL<md-icon md-font-icon=\"icon-check-circle\" \naria-label=\"export\" class=\"blue-700-fg\"></md-icon><div style=\"font-weight: bold\" class=\"blue-900-fg font-size-16\">\n{{employee.data.info.residence.address.zipCode?(employee.data.info.residence.address.zipCode): (\'No se encontró información\')}}\n</div></div><div class=\"blue-900-fg font-size-16\" flex=\"25\" flex-xs=\"50\">ESTADO<md-icon \nmd-font-icon=\"icon-check-circle\" aria-label=\"export\" class=\"blue-700-fg\"></md-icon><div style=\"font-weight: bold\" \nclass=\"blue-900-fg font-size-16\">{{employee.data.info.residence.state | nameOfM : M.states}}</div></div><div \nclass=\"blue-900-fg font-size-16\" flex=\"25\" flex-xs=\"50\">CIUDAD<md-icon md-font-icon=\"icon-check-circle\" \naria-label=\"export\" class=\"blue-700-fg\"></md-icon><div style=\"font-weight: bold\" class=\"blue-900-fg font-size-16\">\n{{codigoPostal?(codigoPostal):(\'SIN CIUDAD\')}}</div></div></div><div layout-gt-xs=\"row\" layout-xs=\"column\" \nlayout-align=\"space-between start\" class=\"margin-top-30\"><div class=\"blue-900-fg font-size-16\" flex=\"25\" flex-xs=\"50\">\nCOLONIA<md-icon md-font-icon=\"icon-check-circle\" aria-label=\"export\" class=\"blue-700-fg\"></md-icon><div \nstyle=\"font-weight: bold\" class=\"blue-900-fg font-size-16\">{{employee.data.info.residence.address.neighborhood}}</div>\n</div><div class=\"blue-900-fg font-size-16\" flex=\"25\" flex-xs=\"50\">TIPOS DE VIA<md-icon \nmd-font-icon=\"icon-check-circle\" aria-label=\"export\" class=\"blue-700-fg\"></md-icon><div style=\"font-weight: bold\" \nclass=\"blue-900-fg font-size-16\">{{employee.data.info.residence.address.streetType | nameOfM : M.streetTypes}}</div>\n</div><div class=\"blue-900-fg font-size-16\" flex=\"25\" flex-xs=\"50\">CALLE<md-icon md-font-icon=\"icon-check-circle\" \naria-label=\"export\" class=\"blue-700-fg\"></md-icon><div style=\"font-weight: bold\" class=\"blue-900-fg font-size-16\">\n{{employee.data.info.residence.address.street}}</div></div><div class=\"blue-900-fg font-size-16\" flex=\"25\" \nflex-xs=\"50\">FRACCIONAMIENTO<md-icon md-font-icon=\"icon-check-circle\" aria-label=\"export\" class=\"blue-700-fg\">\n</md-icon><div style=\"font-weight: bold\" class=\"blue-900-fg font-size-16\">N/A</div></div></div><div layout-gt-xs=\"row\" \nlayout-xs=\"column\" layout-align=\"space-between start\" class=\"margin-top-30\"><div class=\"blue-900-fg font-size-16\" \nflex=\"25\" flex-xs=\"50\">NO. EXTERIOR<md-icon md-font-icon=\"icon-check-circle\" aria-label=\"export\" class=\"blue-700-fg\">\n</md-icon><div style=\"font-weight: bold\" class=\"blue-900-fg font-size-16\">\n{{employee.data.info.residence.address.externalNumber}}</div></div><div class=\"blue-900-fg font-size-16\" flex=\"25\" \nflex-xs=\"50\">NO. INTERIOR<md-icon md-font-icon=\"icon-check-circle\" aria-label=\"export\" class=\"blue-700-fg\"></md-icon>\n<div style=\"font-weight: bold\" class=\"blue-900-fg font-size-16\">\n{{employee.data.info.residence.address.internalNumber?(employee.data.info.residence.address.internalNumber):(\'No se encontró la información\')}}\n</div></div><div class=\"blue-900-fg font-size-16\" flex=\"25\" flex-xs=\"50\">REFERENCIA<md-icon \nmd-font-icon=\"icon-check-circle\" aria-label=\"export\" class=\"blue-700-fg\"></md-icon><div style=\"font-weight: bold\" \nclass=\"blue-900-fg font-size-16\">\n{{employee.data.info.residence.address.reference?(employee.data.info.residence.address.reference):(\'No se encontró la información\')}}\n</div></div></div><div layout-gt-xs=\"row\" layout-xs=\"column\" layout-align=\"space-between start\" class=\"margin-top-30\">\n<div class=\"blue-900-fg font-size-16\" flex=\"10\" flex-xs=\"50\">Comentarios:</div><div flex=\"100\" \nstyle=\"font-weight: bold\" class=\"blue-900-fg font-size-16\">\n{{employee.data.jobDescription? (employee.data.jobDescription): (\'No hay comentarios\')}}</div></div><div \nclass=\"font-size-20 margin-bottom-10 margin-top-10\">BENEFICIARIOS<md-icon md-font-icon=\"icon-people\" \naria-label=\"export\" class=\"blue-700-fg\"></md-icon></div><div layout-gt-xs=\"row\" layout-xs=\"column\" \nlayout-align=\"space-between start\" ng-repeat=\"beneficiario in employee.data.info.beneficiaries\" class=\"margin-top-30\">\n<div class=\"blue-900-fg font-size-16\" flex=\"25\" flex-xs=\"50\">NOMBRE<md-icon md-font-icon=\"icon-check-circle\" \naria-label=\"export\" class=\"blue-700-fg\"></md-icon><div style=\"font-weight: bold\" class=\"blue-900-fg font-size-16\">\n{{beneficiario.name}}</div></div><div class=\"blue-900-fg font-size-16\" flex=\"25\" flex-xs=\"50\">PARENTESCO<md-icon \nmd-font-icon=\"icon-check-circle\" aria-label=\"export\" class=\"blue-700-fg\"></md-icon><div style=\"font-weight: bold\" \nclass=\"blue-900-fg font-size-16\">{{beneficiario.relationship}}</div></div><div class=\"blue-900-fg font-size-16\" \nflex=\"25\" flex-xs=\"50\">PORCENTAJE<md-icon md-font-icon=\"icon-check-circle\" aria-label=\"export\" class=\"blue-700-fg\">\n</md-icon><div style=\"font-weight: bold\" class=\"blue-900-fg font-size-16\">\n{{beneficiario.percent?(beneficiario.percent):(\'No se encontré información\')}}</div></div></div><div \nclass=\"font-size-20 margin-bottom-10 margin-top-10\">CUENTAS REGISTRADAS<md-icon md-font-icon=\"icon-people\" \naria-label=\"export\" class=\"blue-700-fg\"></md-icon></div><div layout-gt-xs=\"row\" layout-xs=\"column\" \nlayout-align=\"space-between start\" ng-repeat=\"card in employee.data.cards\" class=\"margin-top-30\"><div \nclass=\"blue-900-fg font-size-16\" flex=\"25\" flex-xs=\"50\">CUENTA O CLABE<md-icon md-font-icon=\"icon-check-circle\" \naria-label=\"export\" class=\"blue-700-fg\"></md-icon><div style=\"font-weight: bold\" class=\"blue-900-fg font-size-16\">\n{{card.emmit?card.account:card.number}}</div></div><div class=\"blue-900-fg font-size-16\" flex=\"25\" flex-xs=\"50\">BANCO\n<md-icon md-font-icon=\"icon-check-circle\" aria-label=\"export\" class=\"blue-700-fg\"></md-icon><div \nstyle=\"font-weight: bold\" class=\"blue-900-fg font-size-16\">{{card.bank | nameOfM : M.banks }}</div></div><div \nclass=\"blue-900-fg font-size-16\" flex=\"25\" flex-xs=\"50\">PROCESO<md-icon md-font-icon=\"icon-check-circle\" \naria-label=\"export\" class=\"blue-700-fg\"></md-icon><div style=\"font-weight: bold\" class=\"blue-900-fg font-size-16\">\n{{card.process?(card.process):(\'No se encontré la información\')}}</div></div></div><div \nclass=\"font-size-20 margin-bottom-10 margin-top-10\">CORREOS<md-icon md-font-icon=\"icon-people\" aria-label=\"export\" \nclass=\"blue-700-fg\"></md-icon></div><div layout-gt-xs=\"row\" layout-xs=\"column\" layout-align=\"space-between start\" \nng-repeat=\"correo in employee.data.info.emails\" class=\"margin-top-30\"><div class=\"blue-900-fg font-size-16\" flex=\"25\" \nflex-xs=\"50\">CORREO<md-icon md-font-icon=\"icon-check-circle\" aria-label=\"export\" class=\"blue-700-fg\"></md-icon><div \nstyle=\"font-weight: bold\" class=\"blue-900-fg font-size-16\">{{correo.email}}</div></div><div \nclass=\"blue-900-fg font-size-16\" flex=\"25\" flex-xs=\"50\">TIPO<md-icon md-font-icon=\"icon-check-circle\" \naria-label=\"export\" class=\"blue-700-fg\"></md-icon><div style=\"font-weight: bold\" class=\"blue-900-fg font-size-16\">\n{{correo.type}}</div></div></div><div class=\"font-size-20 margin-bottom-10 margin-top-10\">TELÉFONOS<md-icon \nmd-font-icon=\"icon-people\" aria-label=\"export\" class=\"blue-700-fg\"></md-icon></div><div layout-gt-xs=\"row\" \nlayout-xs=\"column\" layout-align=\"space-between start\" ng-repeat=\"phone in employee.data.info.phones\" \nclass=\"margin-top-30\"><div class=\"blue-900-fg font-size-16\" flex=\"25\" flex-xs=\"50\">TELÉFONO<md-icon \nmd-font-icon=\"icon-check-circle\" aria-label=\"export\" class=\"blue-700-fg\"></md-icon><div style=\"font-weight: bold\" \nclass=\"blue-900-fg font-size-16\">{{phone.phone}}</div></div><div class=\"blue-900-fg font-size-16\" flex=\"25\" \nflex-xs=\"50\">TIPO<md-icon md-font-icon=\"icon-check-circle\" aria-label=\"export\" class=\"blue-700-fg\"></md-icon><div \nstyle=\"font-weight: bold\" class=\"blue-900-fg font-size-16\">{{phone.type}}</div></div></div></md-content></md-tab>\n<md-tab label=\"INFORMACIÓN EXTRA\" md-on-select=\"setTabName(\'extraInformation\')\"><md-content \nclass=\"md-padding white-500-bg\"><h1>ESTA EN DESARROLLO<md-icon md-font-icon=\"icon-people\" aria-label=\"export\" \nclass=\"blue-700-fg\"></md-icon></h1></md-content></md-tab><md-tab label=\"MOVIMIENTOS\" \nmd-on-select=\"setTabName(\'movements\')\" ng-click=\"cargarMovimientos()\"><md-content class=\"md-padding white-500-bg\"><div \nclass=\"font-size-20 margin-bottom-10\">MOVIMIENTO DEL EMPLEADO<md-icon md-font-icon=\"icon-people\" aria-label=\"export\" \nclass=\"blue-700-fg\"></md-icon></div><div layout-gt-xs=\"row\" layout-xs=\"column\" layout-align=\"space-between start\" \nclass=\"margin-top-20\"><div class=\"blue-900-fg font-size-16\" flex=\"25\" flex-xs=\"50\">UMF<md-icon \nmd-font-icon=\"icon-check-circle\" aria-label=\"export\" class=\"blue-700-fg\"></md-icon><div style=\"font-weight: bold\" \nclass=\"blue-900-fg font-size-16\">{{employee.data.health.umf}}</div></div><div class=\"blue-900-fg font-size-16\" \nflex=\"25\" flex-xs=\"50\">FECHA DE ALTA<md-icon md-font-icon=\"icon-check-circle\" aria-label=\"export\" class=\"blue-700-fg\">\n</md-icon><div style=\"font-weight: bold\" class=\"blue-900-fg font-size-16\">\n{{employee.data.enroleDate| date:F.dateFormat}}</div></div><div class=\"blue-900-fg font-size-16\" flex=\"25\" \nflex-xs=\"50\">FECHA DE MDS<md-icon md-font-icon=\"icon-check-circle\" aria-label=\"export\" class=\"blue-700-fg\"></md-icon>\n<div style=\"font-weight: bold\" class=\"blue-900-fg font-size-16\">{{employee.data.mdsDate| date:F.dateFormat}}</div>\n</div><div class=\"blue-900-fg font-size-16\" flex=\"25\" flex-xs=\"50\">FECHA DE BAJA<md-icon \nmd-font-icon=\"icon-check-circle\" aria-label=\"export\" class=\"blue-700-fg\"></md-icon><div style=\"font-weight: bold\" \nclass=\"blue-900-fg font-size-16\">{{employee.data.dismissDate| date:F.dateFormat}}</div></div></div><div \nlayout-gt-xs=\"row\" layout-xs=\"column\" layout-align=\"space-between start\" class=\"margin-top-20\"><div \nclass=\"blue-900-fg font-size-16\" flex=\"25\" flex-xs=\"50\">TIPO DE TRABAJADOR<md-icon md-font-icon=\"icon-check-circle\" \naria-label=\"export\" class=\"blue-700-fg\"></md-icon><div style=\"font-weight: bold\" class=\"blue-900-fg font-size-16\">\n{{employee.data.workerType | getSomethingOfArrayFB: M.workerTypes : \'name\' : \'No se encontró\': \'humansiteCode\'}}</div>\n</div><div class=\"blue-900-fg font-size-16\" flex=\"25\" flex-xs=\"50\">JORNADA<md-icon md-font-icon=\"icon-check-circle\" \naria-label=\"export\" class=\"blue-700-fg\"></md-icon><div style=\"font-weight: bold\" class=\"blue-900-fg font-size-16\">\n{{employee.data.workDay | getSomethingOfArrayFB: M.workDays : \'name\' : \'No se encontró\': \'humansiteCode\'}}</div></div>\n<div class=\"blue-900-fg font-size-16\" flex=\"25\" flex-xs=\"50\">TIPO DE SALARIO<md-icon md-font-icon=\"icon-check-circle\" \naria-label=\"export\" class=\"blue-700-fg\"></md-icon><div style=\"font-weight: bold\" class=\"blue-900-fg font-size-16\">\n{{employee.movement.salaryType | getSomethingOfArrayFB: M.salaryTypes : \'name\' : \'No se encontró\': \'humansiteCode\'}}\n</div></div><div class=\"blue-900-fg font-size-16\" flex=\"25\" flex-xs=\"50\">TIPO DE CONTRATO<md-icon \nmd-font-icon=\"icon-check-circle\" aria-label=\"export\" class=\"blue-700-fg\"></md-icon><div style=\"font-weight: bold\" \nclass=\"blue-900-fg font-size-16\">{{employee.contractType}}</div></div></div><div layout-gt-xs=\"row\" layout-xs=\"column\" \nlayout-align=\"space-between start\" class=\"margin-top-30\"><div class=\"blue-900-fg font-size-16\" flex=\"20\" flex-xs=\"50\">\nDescripción de las actividades y funciones</div><div style=\"font-weight: bold\" flex=\"90\" \nclass=\"blue-900-fg font-size-16\">{{employee.data.jobDescription?(employee.data.jobDescription): (\'Sin comentarios\')}}\n</div></div><div class=\"font-size-20 margin-bottom-10 margin-top-10\">ULTIMO MOVIMIENTO<md-icon \nmd-font-icon=\"icon-people\" aria-label=\"export\" class=\"blue-700-fg\"></md-icon></div><div layout-gt-xs=\"row\" \nlayout-xs=\"column\" layout-align=\"space-between start\" class=\"margin-top-30\"><div class=\"blue-900-fg font-size-16\" \nflex=\"25\" flex-xs=\"50\">ESTATUS<md-icon md-font-icon=\"icon-check-circle\" aria-label=\"export\" class=\"blue-700-fg\">\n</md-icon><div style=\"font-weight: bold\" class=\"blue-900-fg font-size-16\">{{movement.status | movementStatusName}}\n</div></div><div class=\"blue-900-fg font-size-16\" flex=\"25\" flex-xs=\"50\">TIPO DE MOVIMIENTO<md-icon \nmd-font-icon=\"icon-check-circle\" aria-label=\"export\" class=\"blue-700-fg\"></md-icon><div style=\"font-weight: bold\" \nclass=\"blue-900-fg font-size-16\">{{movement.data.type | typeName}}</div></div><div class=\"blue-900-fg font-size-16\" \nflex=\"25\" flex-xs=\"50\">LOTE<md-icon md-font-icon=\"icon-check-circle\" aria-label=\"export\" class=\"blue-700-fg\"></md-icon>\n<div style=\"font-weight: bold\" class=\"blue-900-fg font-size-16\">{{movement.received.batch}}</div></div><div \nclass=\"blue-900-fg font-size-16\" flex=\"25\" flex-xs=\"50\">FECHA ARCHIVADO<md-icon md-font-icon=\"icon-check-circle\" \naria-label=\"export\" class=\"blue-700-fg\"></md-icon><div style=\"font-weight: bold\" class=\"blue-900-fg font-size-16\">\n{{movement.archived.date | date:F.dateFormat}}</div></div></div><div layout-gt-xs=\"row\" layout-xs=\"column\" \nlayout-align=\"space-between start\" class=\"margin-top-30\"><div class=\"blue-900-fg font-size-16\" flex=\"10\" flex-xs=\"50\">\nComentarios:</div><div style=\"font-weight: bold\" flex=\"90\" class=\"blue-900-fg font-size-16\">NA</div></div><div \nclass=\"font-size-20 margin-bottom-10 margin-top-10\">LISTADO DE MOVIMIENTO<md-icon md-font-icon=\"icon-people\" \naria-label=\"export\" class=\"blue-700-fg\"></md-icon></div><div layout-gt-xs=\"row\" layout-xs=\"column\" \nlayout-align=\"space-between start\" ng-repeat=\"movimiento in movimientos\" class=\"margin-top-30\"><div \nclass=\"blue-900-fg font-size-16\" flex=\"25\" flex-xs=\"50\">FECHA<md-icon md-font-icon=\"icon-check-circle\" \naria-label=\"export\" class=\"blue-700-fg\"></md-icon><div style=\"font-weight: bold\" class=\"blue-900-fg font-size-16\">\n{{movimiento.date | date:F.dateFormat}}</div></div><div class=\"blue-900-fg font-size-16\" flex=\"25\" flex-xs=\"50\">TIPO\n<md-icon md-font-icon=\"icon-check-circle\" aria-label=\"export\" class=\"blue-700-fg\"></md-icon><div \nstyle=\"font-weight: bold\" class=\"blue-900-fg font-size-16\">{{movimiento.type | typeName}}</div></div><div \nclass=\"blue-900-fg font-size-16\" flex=\"25\" flex-xs=\"50\">SD<md-icon md-font-icon=\"icon-check-circle\" \naria-label=\"export\" class=\"blue-700-fg\"></md-icon><div style=\"font-weight: bold\" class=\"blue-900-fg font-size-16\">\n{{movimiento.sd | currency}}</div></div><div class=\"blue-900-fg font-size-16\" flex=\"25\" flex-xs=\"50\">SBC<md-icon \nmd-font-icon=\"icon-check-circle\" aria-label=\"export\" class=\"blue-700-fg\"></md-icon><div style=\"font-weight: bold\" \nclass=\"blue-900-fg font-size-16\">{{movimiento.sbc | currency}}</div></div><div class=\"blue-900-fg font-size-16\" \nflex=\"25\" flex-xs=\"50\">ESTATUS<md-icon md-font-icon=\"icon-check-circle\" aria-label=\"export\" class=\"blue-700-fg\">\n</md-icon><div style=\"font-weight: bold\" class=\"blue-900-fg font-size-16\">{{movimiento.status | movementStatusName}}\n</div></div></div></md-content></md-tab><md-tab label=\"SERVICIOS ESPECIALIZADOS\" \nmd-on-select=\"setTabName(\'specialServices\')\" ng-if=\"employee.specialServices\"><md-content \nclass=\"md-padding white-500-bg\"><div class=\"font-size-20 margin-bottom-10\">SERVICIOS ESPECIALIZADOS<md-icon \nmd-font-icon=\"icon-people\" aria-label=\"export\" class=\"blue-700-fg\"></md-icon></div><div layout-gt-xs=\"row\" \nlayout-xs=\"column\" layout-align=\"space-between start\" ng-repeat=\"serviciosEspeciales in employee.specialServices\" \nclass=\"margin-top-30\"><div class=\"blue-900-fg font-size-16\" flex=\"25\" flex-xs=\"50\">RFC EMPRESA<md-icon \nmd-font-icon=\"icon-check-circle\" aria-label=\"export\" class=\"blue-700-fg\"></md-icon><div style=\"font-weight: bold\" \nclass=\"blue-900-fg font-size-16\">{{serviciosEspeciales.rfc}}</div></div><div class=\"blue-900-fg font-size-16\" \nflex=\"25\" flex-xs=\"50\">PORCENTAJE<md-icon md-font-icon=\"icon-check-circle\" aria-label=\"export\" class=\"blue-700-fg\">\n</md-icon><div style=\"font-weight: bold\" class=\"blue-900-fg font-size-16\">{{serviciosEspeciales.percent}}%</div></div>\n</div></md-content></md-tab><md-tab label=\"CRÉDITOS\" md-on-select=\"setTabName(\'credits\')\" ng-click=\"cargarCreditos()\">\n<md-content class=\"md-padding white-500-bg\"><div class=\"font-size-20 margin-bottom-10\">CRÉDITOS DEL EMPLEADO<md-icon \nmd-font-icon=\"icon-people\" aria-label=\"export\" class=\"blue-700-fg\"></md-icon></div><div layout-gt-xs=\"row\" \nlayout-xs=\"column\" layout-align=\"space-between start\" ng-repeat=\"credits in credits\" class=\"margin-top-30\"><div \nclass=\"blue-900-fg font-size-16\" flex=\"25\" flex-xs=\"50\">FECHA<md-icon md-font-icon=\"icon-check-circle\" \naria-label=\"export\" class=\"blue-700-fg\"></md-icon><div style=\"font-weight: bold\" class=\"blue-900-fg font-size-16\">\n{{credits.data.date| date:F.dateFormat}}</div></div><div class=\"blue-900-fg font-size-16\" flex=\"25\" flex-xs=\"50\">Cuenta\n<md-icon md-font-icon=\"icon-check-circle\" aria-label=\"export\" class=\"blue-700-fg\"></md-icon><div \nstyle=\"font-weight: bold\" class=\"blue-900-fg font-size-16\">{{credits.data.account}}</div></div><div \nclass=\"blue-900-fg font-size-16\" flex=\"25\" flex-xs=\"50\">Factor<md-icon md-font-icon=\"icon-check-circle\" \naria-label=\"export\" class=\"blue-700-fg\"></md-icon><div style=\"font-weight: bold\" class=\"blue-900-fg font-size-16\">\n{{credits.data.factor}}</div></div><div class=\"blue-900-fg font-size-16\" flex=\"25\" flex-xs=\"50\">Tipo<md-icon \nmd-font-icon=\"icon-check-circle\" aria-label=\"export\" class=\"blue-700-fg\"></md-icon><div style=\"font-weight: bold\" \nclass=\"blue-900-fg font-size-16\">{{credits.data.type}}</div></div></div></md-content></md-tab><md-tab \nlabel=\"SALUD.COM\" ng-if=\"employee.data.health.benefit\"><md-content class=\"md-padding white-500-bg\"><div \nclass=\"font-size-20 margin-bottom-10\">SALUD.COM<md-icon md-font-icon=\"icon-people\" aria-label=\"export\" \nclass=\"blue-700-fg\"></md-icon></div><div layout-gt-xs=\"row\" layout-xs=\"column\" layout-align=\"space-between start\" \nclass=\"margin-top-30\"><div class=\"blue-900-fg font-size-16\" flex=\"25\" flex-xs=\"50\">ALTA SALUD<md-icon \nmd-font-icon=\"icon-check-circle\" aria-label=\"export\" class=\"blue-700-fg\"></md-icon><div style=\"font-weight: bold\" \nclass=\"blue-900-fg font-size-16\">{{employee.data.health.initDate | date:F.dateFormat}}</div></div><div \nclass=\"blue-900-fg font-size-16\" flex=\"25\" flex-xs=\"50\">CERTIFICADO<md-icon md-font-icon=\"icon-check-circle\" \naria-label=\"export\" class=\"blue-700-fg\"></md-icon><div style=\"font-weight: bold\" class=\"blue-900-fg font-size-16\">\n{{employee.data.health.certificate}}</div></div></div></md-content></md-tab><md-tab label=\"EXPEDIENTE\" \nmd-on-select=\"setTabName(\'files\')\" ng-click=\"descargarExpediente()\"><md-content class=\"md-padding white-500-bg\"><div \nclass=\"font-size-20 margin-bottom-10\">EXPEDIENTE DEL EMPLEADO<md-icon md-font-icon=\"icon-people\" aria-label=\"export\" \nclass=\"blue-700-fg\"></md-icon></div><div layout-gt-xs=\"row\" layout-xs=\"column\" layout-align=\"space-between start\" \nng-repeat=\"expediente in files\" class=\"margin-top-30\"><div class=\"blue-900-fg font-size-16\" flex=\"80\" flex-xs=\"50\">\nNOMBRE DEL ARCHIVO<md-icon md-font-icon=\"icon-check-circle\" aria-label=\"export\" class=\"blue-700-fg\"></md-icon><div \nstyle=\"font-weight: bold\" class=\"blue-900-fg font-size-16\">{{expediente.documentType}}</div></div><div \nclass=\"blue-900-fg font-size-16 mt-10\" flex=\"25\" flex-xs=\"100\"><div style=\"font-weight: bold\" \nclass=\"blue-900-fg font-size-16\"><a ng-href=\"{{expediente.url}}\" class=\"bn63\" target=\"_blank\">Ver</a></div></div><div \nclass=\"blue-900-fg font-size-16 mt-10\" flex=\"15\" flex-xs=\"100\"><div style=\"font-weight: bold\" \nclass=\"blue-900-fg font-size-16\"><a ng-click=\"descargarDocumento(expediente.url)\" class=\"bn62\">Descargar</a></div>\n</div></div></md-content></md-tab></div><md-tab label=\"INCIDENCIAS\" md-on-select=\"setTabName(\'incidences\')\" \nng-click=\"cargarIncidencias()\"><md-content class=\"md-padding white-500-bg\"><div class=\"font-size-20 margin-bottom-10\">\nINCIDENCIAS DEL EMPLEADO<md-icon md-font-icon=\"icon-people\" aria-label=\"export\" class=\"blue-700-fg\"></md-icon></div>\n<div layout-gt-xs=\"row\" layout-xs=\"column\" layout-align=\"space-between start\" ng-repeat=\"incidencia in incidencias\" \nclass=\"margin-top-30\"><div class=\"blue-900-fg font-size-16\" flex=\"25\" flex-xs=\"50\">NOMINA<md-icon \nmd-font-icon=\"icon-check-circle\" aria-label=\"export\" class=\"blue-700-fg\"></md-icon><div style=\"font-weight: bold\" \nclass=\"blue-900-fg font-size-16\">\n{{incidencia.nomina | nameOfL :(F.permissionToAccessAllPayrolls?(L.allPayrolls):(L.payrolls))}}</div></div><div \nclass=\"blue-900-fg font-size-16\" flex=\"25\" flex-xs=\"50\">FECHA<md-icon md-font-icon=\"icon-check-circle\" \naria-label=\"export\" class=\"blue-700-fg\"></md-icon><div style=\"font-weight: bold\" class=\"blue-900-fg font-size-16\">\n{{incidencia.date | date:F.dateFormat}}</div></div><div class=\"blue-900-fg font-size-16\" flex=\"25\" flex-xs=\"50\">\nTIPO DE INCIDENCIAS<md-icon md-font-icon=\"icon-check-circle\" aria-label=\"export\" class=\"blue-700-fg\"></md-icon><div \nstyle=\"font-weight: bold\" class=\"blue-900-fg font-size-16\">{{incidencia.type | nameOfL :L.concepts}}</div></div><div \nclass=\"blue-900-fg font-size-16\" flex=\"25\" flex-xs=\"50\">CANTIDAD<md-icon md-font-icon=\"icon-check-circle\" \naria-label=\"export\" class=\"blue-700-fg\"></md-icon><div style=\"font-weight: bold\" class=\"blue-900-fg font-size-16\">\n{{incidencia.cantidad}}</div></div></div></md-content></md-tab><md-tab label=\"VACACIONES\" \nmd-on-select=\"setTabName(\'vacations\')\" ng-click=\"cargarVacaciones()\"><md-content class=\"md-padding white-500-bg\"><div \nclass=\"font-size-20 margin-bottom-10\">VACACIONES DEL EMPLEADO<md-icon md-font-icon=\"icon-people\" aria-label=\"export\" \nclass=\"blue-700-fg\"></md-icon></div><div layout-gt-xs=\"row\" layout-xs=\"column\" layout-align=\"space-between start\" \nclass=\"margin-top-30\"><div class=\"blue-900-fg font-size-16\" flex=\"25\" flex-xs=\"50\">ULTIMO MOVIMIENTO<md-icon \nmd-font-icon=\"icon-check-circle\" aria-label=\"export\" class=\"blue-700-fg\"></md-icon><div style=\"font-weight: bold\" \nclass=\"blue-900-fg font-size-16\">{{employee.data.lastHolEv.event}}</div></div><div class=\"blue-900-fg font-size-16\" \nflex=\"25\" flex-xs=\"50\">FECHA MOVIMIENTO<md-icon md-font-icon=\"icon-check-circle\" aria-label=\"export\" \nclass=\"blue-700-fg\"></md-icon><div style=\"font-weight: bold\" class=\"blue-900-fg font-size-16\">\n{{employee.data.lastHolEv.date | date:F.dateFormat}}</div></div><div class=\"blue-900-fg font-size-16\" flex=\"25\" \nflex-xs=\"50\">TOTAL DISFRUTADAS<md-icon md-font-icon=\"icon-check-circle\" aria-label=\"export\" class=\"blue-700-fg\">\n</md-icon><div style=\"font-weight: bold\" class=\"blue-900-fg font-size-16\">{{employee.data.lastHolEv.enjoyedTotal}}\n</div></div><div class=\"blue-900-fg font-size-16\" flex=\"25\" flex-xs=\"50\">TOTAL GANADAS<md-icon \nmd-font-icon=\"icon-check-circle\" aria-label=\"export\" class=\"blue-700-fg\"></md-icon><div style=\"font-weight: bold\" \nclass=\"blue-900-fg font-size-16\">{{employee.data.lastHolEv.earnedTotal}}</div></div><div \nclass=\"blue-900-fg font-size-16\" flex=\"25\" flex-xs=\"50\">TOTAL PENDIENTES<md-icon md-font-icon=\"icon-check-circle\" \naria-label=\"export\" class=\"blue-700-fg\"></md-icon><div style=\"font-weight: bold\" class=\"blue-900-fg font-size-16\">\n{{employee.data.lastHolEv.total}}</div></div></div><br><div class=\"font-size-20 margin-bottom-10 margin-top-15\">EVENTOS\n<md-icon md-font-icon=\"icon-people\" aria-label=\"export\" class=\"blue-700-fg\"></md-icon></div><div layout-gt-xs=\"row\" \nlayout-xs=\"column\" ng-repeat=\"event in vacations\" class=\"margin-top-30\"><table class=\"table miniTable\"><thead><tr><th \nclass=\"blue-700-fg font-size-16\">Fecha</th><th class=\"blue-700-fg font-size-16\">Evento</th><th \nclass=\"blue-700-fg font-size-16\">Derecho a Gozo</th><th class=\"blue-700-fg font-size-16\">Acumulados</th><th \nclass=\"blue-700-fg font-size-16\">Pendientes Der. Gozo</th><th class=\"blue-700-fg font-size-16\">Disfrutadas</th><th \nclass=\"blue-700-fg font-size-16\">Total Disfrutadas</th><th class=\"blue-700-fg font-size-16\">Vencidas</th><th \nclass=\"blue-700-fg font-size-16\">Total vencidas</th><th class=\"blue-700-fg font-size-16\">Total</th><th \nclass=\"blue-700-fg font-size-16\">&nbsp;</th></tr></thead><tbody><tr><td class=\"blue-900-fg\" style=\"font-weight: bold\" \nng-bind=\"event.date|date\"></td><td class=\"blue-900-fg\" style=\"font-weight: bold\"><span \nng-bind=\"event.event===\'Aniversario\'?event.anniversaryNumber+\'º \':\'\'\"></span><span ng-bind=\"event.event\"></span></td>\n<td class=\"blue-900-fg\" style=\"font-weight: bold\" ng-bind=\"event.earned\"></td><td class=\"blue-900-fg\" \nstyle=\"font-weight: bold\" ng-bind=\"event.earnedTotal\"></td><td class=\"blue-900-fg\" style=\"font-weight: bold\"><span \nng-if=\"event.earned>0\">{{event.pending}}</span></td><td class=\"blue-900-fg\" style=\"font-weight: bold\" \nng-bind=\"event.enjoyed\"></td><td class=\"blue-900-fg\" style=\"font-weight: bold\" ng-bind=\"event.enjoyedTotal\"></td><td \nclass=\"blue-900-fg\" style=\"font-weight: bold\" ng-bind=\"event.prescribed\"></td><td class=\"blue-900-fg\" \nstyle=\"font-weight: bold\" ng-bind=\"event.prescribedTotal\"></td><td class=\"blue-900-fg\" style=\"font-weight: bold\" \nng-bind=\"event.total\"></td></tr></tbody></table></div></md-content></md-tab><md-tab label=\"CÁLCULOS\" \nmd-on-select=\"setTabName(\'calculations\')\" flex-xs=\"100\" layout-wrap><md-content flex-xs=\"100\" flex=\"100\" layout-wrap>\n<h1>ESTA EN DESARROLLO<md-icon md-font-icon=\"icon-people\" aria-label=\"export\" class=\"blue-700-fg\"></md-icon></h1>\n</md-content></md-tab></md-tabs></md-content></div></div></div></div>");
$templateCache.put("app/main/employees/views/kardexEmployees/kardexEmployee.html","<div id=\"kardexid\" ng-controller=\"KardexEmployeeController\" style=\"background-color: #f8f7f7\"><div \nclass=\"full-page-container\"><h1 class=\"titleBlue\">Perfil del Empleado</h1><div><div class=\"employee-profile\"><div \nclass=\"profile-container\"><img ng-src=\"{{employee.data.photoEmployee || avatarImage}}\" \nng-click=\"photoEmployee($event)\" alt=\"Foto de perfil\" class=\"profile-image\"></div><div class=\"profile-info\"><h2 \nstyle=\"line-height: 1\"><strong>{{employee.data.name}}</strong></h2><p style=\"line-height: 0.5\">Nómina: {{nomina}}</p><p\n style=\"line-height: 1\">\nCentro de costos: {{employee.payroll | getSomethingOfArrayFB: L.ccs : \'name\' : \'No se encontró\': \'payroll\'}}</p><p \nstyle=\"line-height: 1\"><strong>Puesto: {{position}}</strong></p><p style=\"line-height: 0.5\"><strong>\nRegistro Patronal: {{employee.rp | getSomethingOfArrayFB: L.ccs : \'name\' : \'No se encontró\': \'rp_id\'}}</strong></p>\n</div><div layout=\"row\" class=\"profile-details\" style=\"display: flex; justify-content: space-between\"><div \nflex-order=\"-1\"><div style=\"margin-left: 2%\"><p style=\"line-height: 1\"><strong>Antigüedad:</strong> <strong \nstyle=\"color: #f59d24\">\n{{ employee.data.seniorityDate ? (employee.data.seniorityDate | date:F.dateFormat) : (employee.data.enroleDate | date:F.dateFormat) }}\n</strong></p><p class=\"sd\" ng-if=\"employee.data.salary.sdr\"><strong>Sueldo Diario Real: </strong><strong>\n{{employee.data.salary.sdr | currency}}</strong></p><p style=\"line-height: 1\" ng-if=\"employee.data.salary.sd\"><strong>\nSueldo Diario: </strong><strong>{{employee.data.salary.sd | currency}}</strong></p><p class=\"sd\" \nng-if=\"employee.data.salary.sbc\"><strong>\nSueldo Base Cotización: {{employee.data.salary.sbc ? (employee.data.salary.sbc | currency) : (\'NA\')}}</strong></p>\n</div></div><div flex-order=\"1\" flex-order-gt-md=\"3\"><p style=\"line-height: 1\"><strong>\nAños en la Empresa: {{employeeYearsCompany}}</strong></p><p style=\"line-height: 1\"><strong>\nAguinaldo: {{employee.data.b.c}}</strong></p><p style=\"line-height: 1\"><strong>\nSaldo de vacaciones: {{employee.data.lastHolEv.total}}</strong></p><p style=\"line-height: 1\"><strong>\nPrima vacacional: {{employee.data.currentBenefits.p}}</strong></p></div><div flex-order=\"1\" flex-order-gt-md=\"3\">\n<md-button class=\"md-primary-none printPage\" ng-click=\"printPage()\" aria-label=\"botón para imprimir\"><md-icon \nmd-font-icon=\"icon-printer\" style=\"color: #285d9c\"></md-icon></md-button></div></div></div><md-tabs class=\"tabsStyle\" \nmd-center-tabs=\"true\" md-selected=\"selectedIndex\" md-no-ink-bar><md-tab label=\"Información\" \nmd-on-select=\"setTabName(\'information\')\"></md-tab><md-tab label=\"Movimientos\" md-on-select=\"setTabName(\'movimientos\')\" \nng-click=\"cargarMovimientos()\"></md-tab><md-tab label=\"Créditos\" md-on-select=\"setTabName(\'creditos\')\"></md-tab><md-tab\n label=\"Expedientes\" ng-click=\"descargarExpediente()\" md-on-select=\"setTabName(\'expedientes\')\"></md-tab><md-tab \nlabel=\"Incapacidades\" ng-click=\"cargarIncidencias()\" md-on-select=\"setTabName(\'incidencias\')\"></md-tab><md-tab \nlabel=\"Contratos\" ng-click=\"contratos1()\" md-on-select=\"setTabName(\'contratos\')\"></md-tab></md-tabs><div \nng-if=\"currentTab === \'information\'\"><div class=\"slide-animate\" ng-include=\"informacion.url\"></div></div><div \nng-if=\"currentTab === \'movimientos\'\"><div class=\"slide-animate\" ng-include=\"movimiento.url\"></div></div><div \nng-if=\"currentTab === \'creditos\'\"><div class=\"slide-animate\" ng-include=\"creditos.url\"></div></div><div \nng-if=\"currentTab === \'expedientes\'\"><div class=\"slide-animate\" ng-include=\"expedientes.url\"></div></div><div \nng-if=\"currentTab === \'incidencias\'\"><div class=\"slide-animate\" ng-include=\"incidencias111.url\"></div></div><div \nng-if=\"currentTab === \'contratos\'\"><div class=\"slide-animate\" ng-include=\"contratos.url\"></div></div></div></div></div>");
$templateCache.put("app/main/employees/views/kardexEmployees/kardexEmployees.html","<div id=\"kardexEmployees\" ng-controller=\"KardexEmployeesController\" class=\"pl-15 pr-15 layout-fill\" layout=\"column\">\n<div flex=\"nogrow\" layout=\"row\" layout-wrap><div flex=\"100\" flex-gt-sm=\"66\" flex-gt-md=\"75\" flex-gt-lg=\"80\" \nlayout=\"row\" layout-align=\"center center\" class=\"padding-lf3\"><div flex class=\"mt-10\"><h1 class=\"titleKardex m-0\">\nKardex de Empleados <span style=\"font-size: 14px; color: black\"># Registros: {{pagination.total}}</span></h1><h2 \nclass=\"m-0\" style=\"font-size: 14px\">Dashboard / RH</h2></div><div flex=\"nogrow\" layout=\"row\"><div flex><md-button \nclass=\"md-block md-raised noMinWidth m-0\" ng-class=\"{\'viewActive\':view===\'cards\'}\" ng-click=\"setView(\'cards\')\"><md-icon\n md-font-icon=\"icon-table\" aria-label=\"read icon\"></md-icon></md-button></div><div class=\"m-5\" flex=\"nogrow\"></div><div\n flex><md-button class=\"md-block md-raised noMinWidth m-0\" ng-class=\"{\'viewActive\':view===\'table\'}\" \nng-click=\"setView(\'table\')\"><md-icon md-font-icon=\"icon-view-list\" aria-label=\"read icon\"></md-icon></md-button></div>\n</div></div></div><div flex=\"nogrow\" class=\"filter-bar\" layout=\"column\" layout-align-gt-sm=\"start center\" \nlayout-gt-sm=\"row\"><div flex=\"100\" layout-wrap flex-gt-sm=\"66\" flex-gt-md=\"75\" flex-gt-lg=\"80\" layout=\"row\" \nclass=\"padding-lf3\"><div flex=\"50\" flex-gt-sm=\"25\"><md-input-container class=\"md-block mb-0 mt-10 no-errors-spacer\" \nmd-no-float><input type=\"text\" class=\"custom-search-input uppercased\" name=\"text\" aria-label=\"search\" \nid=\"{{F.active.menuObjName}}s-search\" translate translate-attr-placeholder=\"EC.SEARCH\" \nng-change=\"getThem(false,\'from input searchbar\')\" ng-model-options=\"{ debounce: F.debounceTime }\" \nng-model=\"F.search[F.active.menuObjName]\"></md-input-container></div><div flex=\"50\" flex-gt-sm=\"25\"><md-input-container\n class=\"md-block mb-0 mt-10\" md-no-float><md-select ng-change=\"getThem()\" ng-model=\"F.filters.kardexEmployees.payroll\" \nplaceholder=\"Nómina\"><md-select-header><input autocomplete=\"off\" type=\"search\" id=\"searchPayroll\" \naria-label=\"nomina filter\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"payrollSelectFilter\" \nplaceholder=\"Busque una nómina\"></md-select-header><md-option ng-value=\"\">Todas</md-option><md-option \nng-class=\"{\'inactiveOption\': !payroll.active}\" ng-value=\"payroll.$id\" \nng-repeat=\"payroll in payrolls | orderBy:\'name\' | filter:payrollSelectFilter\" ng-bind=\"payroll.class+\' \'+payroll.name\">\n</md-option></md-select></md-input-container></div><div flex=\"50\" flex-gt-sm=\"25\"><md-input-container \nclass=\"md-block mb-0 mt-10\" md-no-float><md-select ng-change=\"getThem()\" ng-model=\"F.filters.kardexEmployees.status\" \nplaceholder=\"Estatus\" multiple=\"multiple\"><md-option ng-value=\"status.id\" \nng-repeat=\"status in F.employeeStatatuss | orderBy:\'name\' | filter:statusSelectFilter\">{{status.name}}</md-option>\n</md-select></md-input-container></div><div flex=\"50\" flex-gt-sm=\"25\"><md-input-container class=\"md-block mb-0 mt-10\" \nmd-no-float><md-select ng-change=\"getThem()\" ng-model=\"F.filters.kardexEmployees[\'data.photoEmployee\']\" \nplaceholder=\"Con imagen\"><md-option ng-value=\"\">Todos</md-option><md-option value=\'{\"$exists\":true}\'>Con imagen\n</md-option><md-option value=\'{\"$exists\":false}\'>Sin imagen</md-option></md-select></md-input-container></div></div>\n<div flex=\"100\" flex-gt-sm=\"33\" flex-gt-md=\"25\" flex-gt-lg=\"20\" layout=\"row\" class=\"padding-lf3\"><div flex=\"50\">\n<md-button class=\"buttonFilter m-0\" ng-click=\"getThem()\"><md-icon md-font-icon=\"icon-reload\" \nclass=\"icon light-blue-50-fg\" aria-label=\"read icon\"></md-icon></md-button></div><div flex=\"nogrow\" class=\"m-5\"></div>\n<div flex=\"50\"><md-button class=\"buttonFilter m-0\" ng-click=\"deleteFilters()\"><md-icon \nmd-font-icon=\"icon-filter-remove-outline\" class=\"icon light-blue-50-fg\" aria-label=\"read icon\"></md-icon></md-button>\n</div></div></div><div flex=\"nogrow\" class=\"view-container mt-10\" ng-include=\"templates[view]\"></div><div \nflex=\"nogrow\" class=\"paginator-container\"><md-table-pagination ng-show=\"kardexEmployees.length\" \nmd-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginateV2\" md-limit-options=\"paginations\" md-page=\"$parent.currentPage\" \nmd-total=\"{{pagination.total}}\" md-on-paginate=\"getThemPagination\" md-page-select></md-table-pagination></div></div>");
$templateCache.put("app/main/employees/views/kardexEmployees/kardexPhoto.html","<md-dialog id=\"kardexPhoto\" flex=\"80\" flex-gt-xs=\"50\" flex-gt-sm=\"40\" flex-gt-md=\"30\" flex-gt-lg=\"20\"><form \nname=\"form\" ng-cloak><md-toolbar><div class=\"md-toolbar-tools\"><h2>Subir Foto del Empleado</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"p-5\"><div flex=\"nogrow\"><lf-ng-md-file-input \nlf-files=\"files\" lf-browse-label=\"Buscar\" lf-remove-label=\"Eliminar\" lf-drag-and-drop-label=\"Previsualizar Foto\" \nlf-mimetype=\"image/png|image/gif|image/jpg|image/jpeg\" lf-placeholder=\"Solo PNG, JPG o GIF - Max. 2MB\" \nlf-filesize=\"2MB\" lf-required accept=\"image/png,image/gif,image/jpg,image/jpeg\" name=\"photoProfile\" drag preview \nclass=\"custom-file-input\"></lf-ng-md-file-input><div ng-messages=\"form.photoProfile.$error\" style=\"color:red\"><div \nng-message=\"required\">Seleccione un archivo.</div><div ng-message=\"filesize\">Archivo demasiado grande.</div><div \nng-message=\"mimetype\">Formato de archivo no válido.</div></div></div></md-dialog-content><md-dialog-actions><md-button \nclass=\"md-raised md-primary md-light-green-800-bg md-block\" ng-if=\"photoEmployees\" ng-click=\"downlandImg()\">\nDescargar Imagen Actual</md-button><md-button class=\"md-raised md-primary md-block\" \nng-disabled=\"form.photoProfile.$invalid\" ng-click=\"ok()\">Actualizar Imagen</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/employees/views/logs/logs.html","<div id=\"logs\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div\n class=\"center\" layout=\"column\" flex><div mongo-search-bar></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><div list-filters filters-loaded=\"F.filtersLoaded\" \nng-model=\"F.filters[F.active.menuName]\" on-change=\"getThem\" columns-repeat=\"columnsRepeat\" \nmenu-obj-name=\"{{F.active.menuObjName}}\" model-name=\"{{F.active.menuName}}\" init-filters=\"initFilters\"></div><div \ntable-loader array=\"logs\" validations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table multiple=\"true\" \nng-model=\"selected\" class=\"row-border\" ng-show=\"logs.length\" ms-responsive-table><thead md-head \nmd-order=\"F.orderMongo\" md-on-reorder=\"getThem\"><tr md-row><th md-column md-order-by=\"from.by\" title=\"\"><span>Usuario\n</span></th><th md-column md-order-by=\"from.atTime\" title=\"\"><span>Fecha</span></th><th md-column md-order-by=\"action\" \ntitle=\"\"><span>Accion</span></th><th md-column md-order-by=\"ref\" title=\"\"><span>Elemento</span></th><th md-column \ntitle=\"\"><span>Datos</span></th></tr></thead><tbody md-body><tr md-row md-auto-select md-select=\"log\" \nmd-select-id=\"$id\" class=\"log\" ng-repeat=\"log in logs\"><td md-cell>{{log[\'fromBy-data/name\'] || log.from.by}}</td><td \nmd-cell>{{log.from.atTime |date:\'short\'}}</td><td md-cell>{{\'l.\' + log.action | translate}}</td><td md-cell>\n{{log.ref | interpretLogRef }}<br><small>{{log.ref}}</small></td><td md-cell \nng-if=\"log.v!=\'2.0\' || [\'create\',\'add\',\'remove\',\'delete\'].indexOf(log.action) > -1\"><div class=\"pt-5 pb-5 rowData\" \nng-class=\"{\r\n                                            \'text-strike\':[\'remove\',\'delete\'].indexOf(log.action) > -1,\r\n                                            \'red-700-fg\':[\'remove\',\'delete\'].indexOf(log.action) > -1,\r\n                                            \'blue-700-fg\':[\'remove\',\'delete\'].indexOf(log.action) === -1,\r\n                                        }\">\n<p class=\"noMargin text-semibold wrapper2\" ng-repeat=\"row in log.dataArray\"><span ng-bind=\"row.key+\':\'\" \nclass=\"md-primary-fg\"></span> <span ng-bind=\"row.value | json\"></span></p></div></td><td md-cell \nng-if=\"log.v==\'2.0\' && [\'create\',\'add\',\'remove\',\'delete\', \'sendNotificationEmail\'].indexOf(log.action) === -1\"><div \nclass=\"pt-5 pb-5 rowData\"><p ng-repeat=\"row in log.data\" class=\"noMargin text-semibold wrapper2\"><span \nng-repeat=\"($index,path) in row.path track by $index\" class=\"md-primary-fg\" \nng-bind=\"$index === row.path.length-1 && (!row.index) ? ((\'log.\' + path) | tdsTranslate : row.path[$index-1]) + \':\' :((\'log.\' + path) | tdsTranslate : row.path[$index-1]) + \'/\'\">\n</span> <span ng-if=\"row.index\" class=\"md-primary-fg\" ng-bind=\"row.index+\':\'\"></span> <span ng-if=\"row.item.rhs\" \nclass=\"blue-700-fg\" ng-bind=\"row.item.rhs|json\"></span> <span ng-if=\"row.lhs !== undefined\" \nclass=\"text-strike red-700-fg\" ng-bind=\"row.lhs | translateFilter : row.path | json\"></span> <span class=\"blue-700-fg\" \nng-if=\"row.rhs !== undefined && [\'create\',\'add\'].indexOf(log.action)==-1\" \nng-bind=\"row.rhs | translateFilter : row.path | json\"></span></p></div></td></tr></tbody></table></md-table-container>\n<md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" ng-show=\"logs.length\" \nmd-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" md-limit-options=\"F.paginations\" md-page=\"currentPage\" \nmd-total=\"{{pagination.total}}\" md-on-paginate=\"getThemPagination\" md-page-select></md-table-pagination></div></div>\n</div></div>");
$templateCache.put("app/main/employees/views/importImms/importMovementImms.html","<md-dialog aria-label=\"Import Incidences Geo\" id=\"importMovementImms\" class=\"modern-wizard-dialog\" ng-cloak><form \nname=\"stepper\" ms-stepper layout=\"column\" layout-fill ng-submit=\"impCtrl.guardarSeleccionados()\" \nng-model=\"impCtrl.stepper\" novalidate><ms-stepper-step ng-form=\"step1\" step=\"1\" step-title=\"\'Seleccionar empleados\'\">\n<div ng-include=\"\'app/main/employees/views/importImms/step1.html\'\" layout=\"column\" layout-fill></div></ms-stepper-step>\n<ms-stepper-step ng-form=\"step2\" step=\"2\" step-title=\"\'Verifica la información\'\"><div \nng-include=\"\'app/main/employees/views/importImms/step2.html\'\" layout=\"column\" layout-fill></div></ms-stepper-step>\n<ms-stepper-step ng-form=\"step3\" step=\"3\" step-title=\"\'Edita los movimientos\'\"><div \nng-include=\"\'app/main/employees/views/importImms/step3.html\'\" layout=\"column\" layout-fill></div></ms-stepper-step>\n</form></md-dialog>");
$templateCache.put("app/main/employees/views/importImms/step1.html","<div layout=\"column\" layout-fill style=\"min-height: 400px\"><div layout=\"row\" layout-sm=\"column\" layout-gap=\"20px\" \nclass=\"filter-section\"><md-input-container flex=\"50\" flex-sm=\"100\" class=\"md-block\"><label>Seleccionar Nómina</label>\n<md-select class=\"filter\" ng-change=\"impCtrl.getRp(impCtrl.payroll)\" ng-model=\"impCtrl.payroll\" placeholder=\"Nómina\">\n<md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" \nng-model=\"payrollSelectFilter\" placeholder=\"Busque una nomina\"></md-select-header><md-option \nng-if=\"F.permissionToAccessAllPayrolls\" ng-value=\"payroll.$id\" ng-class=\"{\'inactiveOption\': !payroll.active}\" \nng-repeat=\"payroll in impCtrl.payrolls | orderBy : [\'-active\',\'name\'] | filter:payrollSelectFilter\">\n{{payroll.class}} {{payroll.name}}</md-option></md-select></md-input-container><md-input-container flex=\"50\" \nflex-sm=\"100\" class=\"md-block\"><label>Registro Patronal (RP)</label><md-select ng-model=\"impCtrl.rp\" \nng-change=\"impCtrl.getEmployees(impCtrl.payroll, impCtrl.rp)\"><md-option ng-value=\"opt.$id\" \nng-repeat=\"opt in impCtrl.rpData\">{{ opt.data.name }} - {{ opt.data.shortName }}</md-option></md-select>\n</md-input-container></div><div layout=\"row\" layout-align=\"start center\" class=\"search-actions-bar\"><md-autocomplete \nflex md-selected-item=\"impCtrl.selectedEmployee\" md-search-text=\"impCtrl.searchText\" \nmd-selected-item-change=\"impCtrl.selectedItemChange(item)\" md-items=\"item in impCtrl.querySearch(impCtrl.searchText)\" \nmd-item-text=\"item.displayName\" md-min-length=\"0\" md-delay=\"200\" placeholder=\"Buscar por Nombre o NSS...\">\n<md-item-template><span md-highlight-text=\"impCtrl.searchText\" md-highlight-flags=\"^i\">{{item.displayName}} </span>\n<small style=\"color:#999; margin-left:10px; font-size:11px\">({{item.displayNss}})</small></md-item-template>\n</md-autocomplete><md-button class=\"md-raised md-primary btn-add-all\" ng-click=\"impCtrl.addAllEmployees()\" \nng-disabled=\"impCtrl.allEmployees.length === 0\"><md-icon md-font-icon=\"icon-plus\"></md-icon>Agregar Activos</md-button>\n</div><input type=\"hidden\" ng-model=\"impCtrl.dataP\" ng-if=\"impCtrl.addedEmployees.length === 0\" required><div \nclass=\"table-container md-whiteframe-1dp\" flex><div class=\"table-responsive-wrapper\"><table class=\"styled-table\">\n<thead><tr><th width=\"40%\">Empleado</th><th width=\"25%\">NSS</th><th width=\"20%\">RFC</th><th width=\"15%\" \nclass=\"text-center\">Eliminar</th></tr></thead><tbody><tr ng-if=\"impCtrl.addedEmployees.length === 0\"><td colspan=\"4\" \nclass=\"empty-state\"><p>No has seleccionado empleados aún.</p></td></tr><tr ng-repeat=\"emp in impCtrl.addedEmployees\">\n<td><div class=\"employee-info\"><span class=\"emp-name\">{{ emp.displayName }}</span> <small class=\"emp-dept\">\n{{ emp.center || emp._id | limitTo:8 }}</small></div></td><td>{{ emp.displayNss }}</td><td>{{ emp.data.rfc || \'---\' }}\n</td><td class=\"text-center\"><md-button class=\"md-icon-button md-warn delete-btn\" \nng-click=\"impCtrl.removeEmployee(emp)\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></td></tr></tbody>\n</table></div></div><div class=\"selection-alert md-whiteframe-1dp\" layout=\"row\" layout-align=\"start center\" \nng-if=\"impCtrl.addedEmployees.length > 0\"><div class=\"alert-icon-box\"><md-icon md-svg-src=\"/assets/icons/user.svg\">\n</md-icon></div><div class=\"alert-text\"><span class=\"count\">{{impCtrl.addedEmployees.length}}</span> <span \nclass=\"label\">empleados listos para importar.</span></div></div></div>");
$templateCache.put("app/main/employees/views/importImms/step2.html","<div class=\"results-container\"><md-card ng-repeat=\"empleado in impCtrl.processResults\" \nng-class=\"{\'card-selected\': (empleado.historial | filter:{isSelected: true}).length > 0}\" class=\"employee-result-card\">\n<md-card-header ng-click=\"empleado.expanded = !empleado.expanded\" class=\"expandable-header\"><md-card-avatar><md-icon \nclass=\"md-avatar-icon\" ng-class=\"impCtrl.getStatusClass(empleado.ultimoStatus)\" \nmd-svg-src=\"{{ empleado.ultimoStatus === 2 ? \'/assets/icons/bajaUser.svg\' : \'/assets/icons/activoUser.svg\' }}\">\n</md-icon></md-card-avatar><md-card-header-text><div layout=\"row\" layout-align=\"start center\"><span class=\"md-title\">\n{{ empleado.name }}</span> <span class=\"selection-badge fade-in\" \nng-if=\"(empleado.historial | filter:{isSelected: true}).length > 0\"><md-icon md-svg-src=\"/assets/icons/true.svg\">\n</md-icon>{{ (empleado.historial | filter:{isSelected: true}).length }} Seleccionados</span></div><span \nclass=\"md-subhead\">NSS: {{ empleado.nss }}</span></md-card-header-text><md-button class=\"md-icon-button\"><md-icon \nng-class=\"{\'rotated\': empleado.expanded}\" md-font-icon=\"{{empleado.expanded ? \'icon-eye-off\' : \'icon-eye\'}}\"></md-icon>\n</md-button></md-card-header><md-card-content ng-show=\"empleado.expanded\" class=\"card-details-content\"><md-divider>\n</md-divider><div class=\"table-responsive-wrapper\"><table class=\"detail-table\"><thead><tr><th width=\"5%\" \nclass=\"text-center\"><md-icon class=\"icon-header\" md-font-icon=\"icon-select\"></md-icon></th><th>Fecha</th><th>Tipo</th>\n<th>SBC</th><th>Tipo_sal</th><th>Huella digital</th><th>Folio / Lote</th></tr></thead><tbody><tr \nng-repeat=\"mov in empleado.historial\"><td class=\"text-center checkbox-cell\"><md-checkbox ng-model=\"mov.isSelected\" \nstyle=\"margin-bottom: 25px\" aria-label=\"Seleccionar movimiento\" class=\"md-primary no-margin-checkbox\"></md-checkbox>\n</td><td style=\"font-weight: 800\">{{ mov.fecha | date:\'dd-MM-yyyy\' }}</td><td><span class=\"badge\" \nng-class=\"impCtrl.getStatusClass(mov.movto)\">{{ impCtrl.getMovtoLabel(mov.movto) }}</span></td><td>$ {{ mov.sbc }}</td>\n<td class=\"text-center\">{{mov.tipo_sal}}</td><td>{{mov.huella_digital}}</td><td style=\"font-size: 11px\"><div><b>Folio:\n</b> {{ mov.numero_folio }}</div><div style=\"font-weight:900\">Lote: {{ mov.lote }}</div></td></tr></tbody></table>\n</div></md-card-content></md-card></div>");
$templateCache.put("app/main/employees/views/importImms/step3.html","<div class=\"results-container\"><div ng-if=\"impCtrl.employeesClean.length > 0\"><md-subheader class=\"md-primary\">\nRegistros Válidos para Importar</md-subheader><md-card ng-repeat=\"empleado in impCtrl.employeesClean\" \nclass=\"employee-result-card card-selected\"><md-card-header ng-click=\"empleado.expanded = !empleado.expanded\" \nclass=\"expandable-header\" style=\"cursor: pointer\"><md-card-avatar><md-icon class=\"md-avatar-icon\" \nng-class=\"impCtrl.getStatusClass(empleado.ultimoStatus)\" \nmd-svg-src=\"{{ empleado.ultimoStatus === 2 ? \'/assets/icons/bajaUser.svg\' : \'/assets/icons/activoUser.svg\' }}\">\n</md-icon></md-card-avatar><md-card-header-text><div layout=\"row\" layout-align=\"start center\"><span class=\"md-title\">\n{{ empleado.name }}</span> <span class=\"selection-badge fade-in\">{{ empleado.movimientos.length }} registros</span>\n</div><span class=\"md-subhead\">NSS: {{ empleado.nss }}</span></md-card-header-text><md-button class=\"md-icon-button\">\n<md-icon ng-class=\"{\'rotated\': empleado.expanded}\" md-font-icon=\"{{empleado.expanded ? \'icon-eye-off\' : \'icon-eye\'}}\">\n</md-icon></md-button></md-card-header><md-card-content ng-show=\"empleado.expanded\" class=\"card-details-content\">\n<md-divider></md-divider><div class=\"table-responsive-wrapper\"><table class=\"detail-table\"><thead><tr><th \nclass=\"text-center\">Fecha Movimiento</th><th width=\"90\">Tipo</th><th class=\"text-center\" width=\"10\">Sd</th><th \nclass=\"text-center\" width=\"10\">SBC</th><th class=\"text-center\" width=\"5\">Tipo Sal</th><th class=\"text-center\" \nwidth=\"5\">Tipo Trab</th><th class=\"text-center\" width=\"5\" ng-if=\"impCtrl.bajaT\">C Baja</th><th class=\"text-center\">\nPosicion</th></tr></thead><tbody><tr ng-repeat=\"mov in empleado.movimientos\" \nng-class=\"{\'duplicate-row\': mov.isDuplicated}\"><td class=\"text-center\"><span>{{mov.fechaObj|date:F.dateFormat}}</span>\n</td><td><label class=\"badge\" ng-class=\"impCtrl.getStatusClass(mov.movto)\">{{ impCtrl.getMovtoLabel(mov.movto) }}\n</label></td><td class=\"text-center\"><md-input-container md-no-float class=\"md-block compact-input\"><input \nng-model=\"mov.sd\" aria-label=\"sd\"></md-input-container></td><td class=\"text-center\"><span>{{mov.sbc}}</span></td><td \nclass=\"text-center\"><label>{{mov.tipo_sal}}</label></td><td class=\"text-center\"><label>{{mov.tipo_trab}}</label></td>\n<td class=\"text-center\" ng-if=\"impCtrl.bajaT\"><label>{{mov.c_baja}}</label></td><td><label>{{empleado.position}}\n</label></td></tr></tbody></table></div></md-card-content></md-card></div><div \nng-if=\"impCtrl.areAllMovementsDuplicated()\" \nstyle=\"background-color: #fff3cd; color: #856404; padding: 15px; border: 1px solid #ffeeba; border-radius: 4px; margin-bottom: 20px; text-align: center\">\n<div layout=\"row\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-alert-circle\" \nstyle=\"color: #856404; margin-right: 10px\"></md-icon><span class=\"md-subhead\" style=\"font-weight: bold\">\nTodos los movimientos seleccionados ya existen en el sistema. No hay registros nuevos para importar.</span></div></div>\n<div ng-if=\"impCtrl.employeesWithDuplicates.length > 0\"></div></div>");
$templateCache.put("app/main/employees/views/loans/input-comments.html","<md-edit-dialog><div layout=\"column\" class=\"tableEditDialog\"><form name=\"editDialog\" layout=\"column\" \nng-submit=\"submit(model)\"><md-input-container class=\"md-block date-picker no-float\" flex md-no-float><input \naria-label=\"Incidence comments\" type=\"text\" placeholder=\"{{placeholder}}\" ng-model=\"model\" name=\"input\">\n</md-input-container></form></div></md-edit-dialog>");
$templateCache.put("app/main/employees/views/loans/input-date.html","<md-edit-dialog><div layout=\"column\" class=\"tableEditDialog\"><form name=\"editDialog\" layout=\"column\" \nng-submit=\"submit(model)\"><md-input-container class=\"md-block date-picker no-float\" flex><md-datepicker \nmd-min-date=\"minDate\" md-hide-icons=\"calendar\" input-date-miliseconds aria-label=\"Incidence date\" ng-model=\"model\" \nname=\"input\" validate-incidence ng-change=\"submit()\" required></md-datepicker><div \nng-messages=\"editDialog.input.$error\" ng-if=\"editDialog.input.$touched || editDialog.input.$dirty\" role=\"alert\"><div \nng-message=\"required\">Requerido</div><div ng-message=\"mindate\">Fecha no puede estar en periodo cerrado</div><div \nng-message=\"min\">Fecha no puede estar en periodo cerrado</div><div ng-message=\"availablePeriod\">Periodo no disponible\n</div></div></md-input-container></form></div></md-edit-dialog>");
$templateCache.put("app/main/employees/views/loans/loan.html","<div id=\"{{F.active.menuObjName}}\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill \nng-controller=\"LoanController\"><form name=\"form\" novalidate flex layout=\"column\" ng-disabled=\"F.readMode\"><md-toolbar \nclass=\"md-tall header md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" \nlayout-align=\"start center\" flex><md-button with-permission action=\"access\" access=\"{{F.active.menuItem}}\" \nclass=\"goto-button md-icon-button\" aria-label=\"Go to list\" ng-click=\"R.goToList()\" translate \ntranslate-attr-aria-label=\"EC.GO_TO\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" \nlayout-align=\"start center\"><md-icon \nmd-font-icon=\"{{F.menuItems[F.active.menuParent][F.active.menuName].icon || F.default.icon}}\" class=\"crud-icon\">\n</md-icon><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\">{{F.active.detailObject.data.name}}</div><div\n class=\"subtitle secondary-text\"><span ng-if=\"!F.addMode\">\n{{\'EC.DETAIL_OF\' | translate}} {{F.active.menuObjName + \'.SINGULAR\' | translate}}</span> <span ng-if=\"F.addMode\">\n{{\'EC.CREATE\' | translate}} {{F.active.menuObjName + \'.SINGULAR\' | translate}}</span></div></div></div></div><div>\n<md-button type=\"submit\" ng-if=\"!F.addMode && objectLoaded\" with-permission action=\"update\" \naccess=\"{{F.active.menuItem}}\" ng-click=\"saveLoan(F.active.detailObject)\" ng-hide=\"form.$pristine && !objectLoaded\" \nng-disabled=\"form.$invalid || loadingProgress || !validIncidences\" \nclass=\"md-raised md-background md-fab md-accent md-hue-1\" aria-label=\"Save\"><md-tooltip md-direction=\"left\">\n{{\'EC.SAVE\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-content-save\" aria-label=\"Save\"></md-icon>\n</md-button><md-button type=\"submit\" ng-if=\"F.addMode && objectLoaded\" with-permission action=\"create\" \naccess=\"{{F.active.menuItem}}\" ng-click=\"saveLoan(F.active.detailObject)\" ng-hide=\"form.$pristine && !objectLoaded\" \nng-disabled=\"form.$invalid || loadingProgress || !validIncidences\" \nclass=\"md-raised md-background md-fab md-accent md-hue-1\" aria-label=\"Add\"><md-tooltip md-direction=\"left\">\n{{\'EC.ADD\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-content-save\" aria-label=\"Add\"></md-icon></md-button>\n</div></md-toolbar><md-content layout-fill class=\"content\" flex><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\" layout=\"column\"><div form-loan></div></div>\n</md-content></form></div>");
$templateCache.put("app/main/employees/views/loans/loans.html","<div id=\"{{F.active.menuName}}\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\" \nng-controller=\"LoansController\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div \nfb-search-bar></div><div class=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" \nlayout=\"column\" flex><div filter-toolbar></div><div table-loader array=\"Z[F.active.menuName]\" \nvalidations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"F.filteredItems.length\" ng-init=\'order = \"-data.date\"\'>\n<thead md-head md-order=\"order\" fix-head><tr md-row><th md-column md-order-by=\"payroll\"><span>\n{{\'loan.PAYROLL\' | translate}}</span></th><th md-column md-order-by=\"employee-name\"><span>\n{{\'loan.EMPLOYEE\' | translate}}</span></th><th md-column md-order-by=\"data.date\"><span>{{\'loan.STARTDATE\' | translate}}\n</span></th><th md-column md-order-by=\"incidencesType-name\"><span>{{\'loan.CONCEPT\' | translate}}</span></th><th \nmd-column md-order-by=\"data.amount\"><span>{{\'loan.TOTALAMOUNT\' | translate}}</span></th><th md-column \nmd-order-by=\"data.amountPeriod\"><span>{{\'loan.AMOUNTPERPERIOD\' | translate}}</span></th><th md-column \nmd-order-by=\"data.balance\"><span>{{\'loan.PENDINGAMOUNT\' | translate}}</span></th><th md-column md-order-by=\"valid\">\n<span>{{\'loan.VALID\' | translate}}</span></th></tr></thead><tbody md-body><tr md-row md-auto-select md-select=\"loan\" \nmd-select-id=\"$id\" \nng-repeat=\"loan in (F.filteredItems = (Z[F.active.menuName] | filter:F.searchText[F.active.menuObjName] | orderBy:order)) | limitTo: F.paginate: (currentPage - 1) * F.paginate\">\n<td md-cell>{{loan.payroll | nameOfL:L.allPayrolls}}</td><td md-cell>{{loan[\"employee-name\"]}}</td><td md-cell>\n{{loan.data.date|date:F.dateFormat}}</td><td md-cell>{{loan[\"incidencesType-name\"]}}</td><td md-cell>\n{{loan.data.amount|currency}}</td><td md-cell>{{loan.data.periodAmount|currency}}</td><td md-cell>\n{{(loan.data.amount-(loan.data.paid||0))|currency}}</td><td md-cell><div layout=\"row\" layout-align=\"start center\">\n<active-indicator active=\"loan.valid\"></active-indicator></div></td></tr></tbody></table></md-table-container>\n<md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" \nng-show=\"F.filteredItems.length\" md-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" \nmd-limit-options=\"F.paginations\" md-page=\"currentPage\" md-on-paginate=\"restartSelected\" \nmd-total=\"{{F.filteredItems.length}}\" md-page-select></md-table-pagination></div></div><md-fab-speed-dial \nmd-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\"><md-fab-trigger>\n<md-button aria-label=\"crud menu\" class=\"md-fab md-accent\" md-class=\"{\'md-hue-1\': selected.length}\"><md-icon \nmd-font-icon=\"icon-cube\"></md-icon></md-button></md-fab-trigger><md-fab-actions><md-button with-permission \naction=\"export\" access=\"{{F.active.menuItem}}\" \nng-click=\'exportDataToExcel(F.filteredItems,\"loans\",currentPage,F.paginate)\' aria-label=\"export\" \nclass=\"md-fab md-raised md-mini md-primary md-hue-2\"><md-tooltip md-direction=\"left\">Exportar a excel</md-tooltip>\n<md-icon md-font-icon=\" icon-file-excel\" aria-label=\"export\"></md-icon></md-button><md-button with-permission \naction=\"generateExcel\" access=\"{{F.active.menuItem}}\" ng-show=\"selected.length\" \nng-click=\"generateFile($event, selected, true)\" aria-label=\"export\" \nclass=\"md-fab md-raised md-mini md-primary md-hue-2\"><md-tooltip md-direction=\"left\">Generar reporte detallado en excel\n</md-tooltip><md-icon md-font-icon=\"icon-file-excel\" aria-label=\"export icon\"></md-icon></md-button><md-button \nwith-permission action=\"read\" access=\"{{F.active.menuItem}}\" ng-show=\"selected.length == 1\" \nng-click=\'R.goToDetail(selected[0], \"read\", {employeeId: selected[0].employee, loanId: selected[0].$id})\' \naria-label=\"Read\" class=\"md-fab md-raised md-primary md-mini\"><md-tooltip md-direction=\"left\">Ver</md-tooltip><md-icon \nmd-font-icon=\"icon-eye\" aria-label=\"read icon\"></md-icon></md-button><md-button with-permission action=\"create\" \naccess=\"{{F.active.menuItem}}\" ng-show=\"!selected.length\" ng-click=\'R.goToDetail(\"new\", \"create\")\' aria-label=\"add\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">{{\'EC.ADD\' | translate}}\n</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon></md-button><md-button with-permission \naction=\"remove\" access=\"{{F.active.menuItem}}\" ng-show=\"selected.length\" ng-click=\"deleteLoans($event)\" \naria-label=\"Delete\" class=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">\n{{\'EC.REMOVE\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button>\n<md-button with-permission action=\"update\" access=\"{{F.active.menuItem}}\" ng-show=\"selected.length == 1\" \nng-click=\'R.goToDetail(selected[0], \"update\", {employeeId: selected[0].employee, loanId: selected[0].$id})\' \naria-label=\"edit\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Editar\n</md-tooltip><md-icon md-font-icon=\"icon-pencil\" aria-label=\"edit\"></md-icon></md-button></md-fab-actions>\n</md-fab-speed-dial></div></div>");
$templateCache.put("app/main/employees/views/mdsRecords/mdsRecord.html","<div id=\"mdsRecord\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill \nng-controller=\"EmployeeController\"><form name=\"form\" novalidate flex layout=\"column\" ng-disabled=\"F.readMode\">\n<md-toolbar class=\"md-tall header md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" \nlayout=\"row\" layout-align=\"start center\" flex><md-button class=\"goto-button md-icon-button\" \naria-label=\"Go to employees\" ng-click=\"goToList()\" translate translate-attr-aria-label=\"EC.GO_TO\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" layout-align=\"start center\"><a \nclass=\"crud-image pointer\" hide-xs ng-click=\"selectedTab = 2\"><img ng-if=\"employee.avatar\" \nng-src=\"{{employee.avatar}}\"> <img ng-if=\"!employee.avatar\" class=\"thumb-image\" ng-src=\"{{F.imagePlaceholder}}\"></a>\n<div layout=\"column\" layout-align=\"start start\"><div class=\"h2\">MDS de {{employee.data.name}}</div><div \nclass=\"subtitle secondary-text\"><span ng-if=\"!F.addMode\">{{\'EC.DETAIL_OF\' | translate}} Modificación de Salario</span> \n<span ng-if=\"F.addMode\">{{\'EC.CREATE\' | translate}} Modificación de Salario</span></div></div></div></div><div>\n<md-button type=\"submit\" ng-click=\"mds()\" with-permission action=\"mds\" access=\"captures.employees\" \nng-hide=\"form.$pristine\" ng-disabled=\"form.$invalid || loadingProgress\" \nng-if=\'employee.data.nss && F.active.menuAction == \"mds\" && form.$valid\' \nclass=\"md-raised md-background md-fab md-accent md-hue-1\" aria-label=\"mds employee\"><md-tooltip md-direction=\"left\">\nMandar MDS</md-tooltip><md-icon md-font-icon=\"icon-currency-usd\" aria-label=\"mds\"></md-icon></md-button><md-button \ntype=\"submit\" ng-if=\'form.$valid && F.active.menuAction == \"update\"\' \nng-click=\"saveAndUpdateMovement(movement, employee)\" with-permission action=\"update\" access=\"{{F.active.menuItem}}\" \nng-hide=\"form.$pristine\" ng-disabled=\"form.$invalid || form.$pending || loadingProgress || F.readMode\" \nclass=\"md-raised md-background md-fab md-accent md-hue-1\" aria-label=\"update mds employee\"><md-tooltip \nmd-direction=\"left\">Actualizar MDS</md-tooltip><md-icon md-font-icon=\"icon-content-save\" aria-label=\"save\"></md-icon>\n</md-button><validate-form-button></validate-form-button></div></md-toolbar><md-content layout=\"column\" \nclass=\"content\"><div class=\"detail-form-container md-background-bg md-whiteframe-1dp\" ng-if=\"employee.status!=2\" \nlayout=\"column\"><div form-mds></div></div><md-tabs md-selected=\"selectedTab\" flex md-dynamic-height layout-fill \nng-if=\"employee.status==2\" class=\"scrollable\"><md-tab label=\"Movimiento\"><md-tab-body><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\" layout=\"column\"><div form-mds></div></div>\n</md-tab-body></md-tab><md-tab label=\"Otros\"><md-tab-body><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\" flex layout-fill=\"column\"><div form-worker></div>\n</div></md-tab-body></md-tab><md-tab label=\"Beneficios\"><md-tab-body><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\"><div form-benefits-employee></div></div></md-tab-body>\n</md-tab></md-tabs></md-content></form></div>");
$templateCache.put("app/main/employees/views/mdsRecords/mdsRecords.html","<div id=\"{{F.active.menuName}}\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\" \nng-controller=\"EmployeesMovementsController\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" \nlayout=\"column\" flex><div fb-search-bar></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><div filter-toolbar></div><div table-loader \narray=\"Z[F.active.menuName]\" validations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"F.filteredItems.length\"><thead md-head \nmd-order=\"order\" fix-head><tr md-row><th md-column md-order-by=\"rp\"><span>RP</span></th><th md-column \nmd-order-by=\'\"pc-class\"\'><span>Nómina</span></th><th md-column md-order-by=\"data.nss\"><span>NSS</span></th><th \nmd-column md-order-by=\"data.name\"><span>Nombre</span></th><th md-column md-order-by=\"movement.sd\"><span>SD</span></th>\n<th md-column md-order-by=\"movement.sbc\"><span>SBC</span></th><th md-column md-order-by=\"data.mdsDate\"><span>MDS</span>\n</th></tr></thead><tbody md-body><tr md-row ng-class=\"{\'onlySdMovement\': employee.movement.onlySd}\" md-auto-select \nmd-select=\"employee\" md-select-id=\"$id\" \nng-repeat=\"employee in (F.filteredItems = (Z[F.active.menuName] | filter:F.searchText[F.active.menuObjName] | orderBy:order)) | limitTo: F.paginate: (currentPage - 1) * F.paginate\">\n<td md-cell>{{employee.rp | nameOfL:L.rps}}</td><td md-cell>[{{employee[\'pc-class\']}}] {{employee[\'payroll-name\']}}\n</td><td md-cell>{{employee.data.nss}}</td><td md-cell>{{employee.data.name}}</td><td md-cell \nng-if=\"employee.data.salary.sd != employee.movement.sd\">\n{{employee.data.salary.sd | currency}} > {{employee.movement.sd | currency}}</td><td md-cell class=\"blueC\" \nng-if=\"employee.data.salary.sd == employee.movement.sd\">{{employee.data.salary.sd | currency}}</td><td md-cell \nng-if=\"employee.data.salary.sbc != employee.movement.sbc\">\n{{employee.data.salary.sbc | currency}} > {{employee.movement.sbc | currency}}</td><td md-cell class=\"blueC\" \nng-if=\"employee.data.salary.sbc == employee.movement.sbc\">{{employee.data.salary.sbc | currency}}</td><td md-cell>\n{{employee.movement.date | date:\'dd/MM/yyyy\'}}</td></tr></tbody></table></md-table-container><md-table-pagination \nlayout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" ng-show=\"F.filteredItems.length\" \nmd-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" md-limit-options=\"F.paginations\" md-page=\"currentPage\" \nmd-on-paginate=\"restartSelected\" md-total=\"{{F.filteredItems.length}}\" md-page-select></md-table-pagination></div>\n</div><md-fab-speed-dial md-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" \nclass=\"ms2-speed-dial bottom right\"><md-fab-trigger><md-button aria-label=\"crud menu\" class=\"md-fab md-accent\" \nmd-class=\"{\'md-hue-1\': selected.length}\"><md-icon md-font-icon=\"icon-cube\"></md-icon></md-button></md-fab-trigger>\n<md-fab-actions><md-button with-permission action=\"export\" access=\"{{F.active.menuItem}}\" \nng-click=\"exportDataToExcel(F.filteredItems,F.active.menuName,currentPage,F.paginate)\" aria-label=\"export\" \nclass=\"md-fab md-raised md-mini md-primary md-hue-2\"><md-tooltip md-direction=\"left\">Exportar a excel</md-tooltip>\n<md-icon md-font-icon=\" icon-file-excel\" aria-label=\"export\"></md-icon></md-button><md-button with-permission \naction=\"read\" access=\"{{F.active.menuItem}}\" ng-show=\"selected.length == 1\" \nng-click=\'R.goToDetail(null, \"read\", {employeeId: selected[0].$id, movementId: selected[0].movement.uid})\' \naria-label=\"Read\" class=\"md-fab md-raised md-primary md-mini\"><md-tooltip md-direction=\"left\">Ver</md-tooltip><md-icon \nmd-font-icon=\"icon-eye\" aria-label=\"read icon\"></md-icon></md-button><md-button with-permission action=\"update\" \naccess=\"{{F.active.menuItem}}\" ng-show=\"selected.length == 1\" \nng-click=\'R.goToDetail(null, \"update\", {employeeId: selected[0].$id, movementId: selected[0].movement.uid})\' \naria-label=\"Update\" class=\"md-fab md-raised md-primary md-mini\"><md-tooltip md-direction=\"left\">Editar</md-tooltip>\n<md-icon md-font-icon=\"icon-pencil\" aria-label=\"edit icon\"></md-icon></md-button><md-button with-permission \naction=\"sendToIdse\" access=\"{{F.active.menuItem}}\" ng-show=\"selected.length\" ng-click=\"moveEmployees($event, 3)\" \naria-label=\"moveEmployees\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">\nMandar a IDSE, si el movimiento solo es para n&oacute;mina, se archiva autom&aacute;ticamente</md-tooltip><md-icon \nmd-font-icon=\"icon-arrow-right-bold-hexagon-outline\" aria-label=\"move\"></md-icon></md-button><md-button \nwith-permission action=\"getIdse\" access=\"{{F.active.menuItem}}\" \nng-show=\'selected.length && !(selected|recordsHaveValue:\"movement.onlySd\":true:\"any\")\' ng-click=\'getInterface(\"idse\")\' \naria-label=\"getIdse\" class=\"md-fab md-raised md-mini md-primary md-hue-3\"><md-tooltip md-direction=\"left\">IDSE\n</md-tooltip><md-icon md-svg-src=\"/assets/icons/IDSE.svg\" aria-label=\"idse\"></md-icon></md-button><md-button \nwith-permission action=\"getSua\" access=\"{{F.active.menuItem}}\" \nng-show=\'selected.length && !(selected|recordsHaveValue:\"movement.onlySd\":true:\"any\")\' ng-click=\'getInterface(\"sua\")\' \naria-label=\"getSua\" class=\"md-fab md-raised md-mini md-primary md-hue-3\"><md-tooltip md-direction=\"left\">Layout MDS\n</md-tooltip><md-icon md-svg-src=\"/assets/icons/SUA.svg\" aria-label=\"sua\"></md-icon></md-button><md-button \nwith-permission action=\"cancelMovement\" access=\"movements.revisions\" ng-show=\"selected.length == 1\" \nng-click=\"cancelLastMovement($event)\" aria-label=\"cancel last movement\" class=\"md-fab md-mini md-warn md-hue-2\">\n<md-tooltip md-direction=\"left\">Cancelar Último Movimiento</md-tooltip><md-icon md-font-icon=\"icon-close\" \naria-label=\"cancel\"></md-icon></md-button></md-fab-actions></md-fab-speed-dial></div></div>");
$templateCache.put("app/main/employees/views/noEmployees/noEmployees.html","<div id=\"{{F.active.menuName}}\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\" \nng-controller=\"EmployeesMovementsController\"><div class=\"top-bg md-accent-bg\"><div with-permission ng-model=\"haveP\" \naction=\"saveSimple\" access=\"{{F.active.menuItem}}\"></div></div><div class=\"center\" layout=\"column\" flex><div \nmongo-search-bar></div><div class=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" \nlayout=\"column\" flex><div list-filters filters-loaded=\"F.filtersLoaded\" ng-model=\"F.filters[F.active.menuName]\" \non-change=\"getThem\" columns-repeat=\"columnsRepeat\" menu-obj-name=\"{{F.active.menuObjName}}\" \nmodel-name=\"{{F.active.menuName}}\" init-filters=\"initFilters\"></div><div table-loader array=\"noEmployees\" \nvalidations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"noEmployees.length\"><thead md-head \nmd-order=\"F.orderMongo\" fix-head md-on-reorder=\"getThem\"><tr md-row><th md-column md-order-by=\"rp\"><span>RP</span></th>\n<th md-column md-order-by=\"payroll\"><span>Nómina</span></th><th md-column md-order-by=\"data.nss\"><span>NSS</span></th>\n<th md-column md-order-by=\"data.name\"><span>Nombre</span></th><th md-column md-order-by=\"data.employeeNumber\"><span>\nNo. Empleado</span></th></tr></thead><tbody md-body><tr md-row \nng-class=\"{\'inactiveEmployee\': employee.movement.type == 2 || employee.status == 5}\" md-select-id=\"$id\" \nmd-select=\"employee\" ng-repeat=\"employee in noEmployees\"><td md-cell>{{employee[\'rp-name\']}}</td><td md-cell>\n{{employee[\'payroll2-class\']}} {{employee[\'payroll-name\']}}</td><td md-cell>{{employee.data.nss}}</td><td md-cell>\n{{employee.data.name}}</td><td md-cell><div layout=\"row\"><md-input-container flex md-no-float \nng-if=\"haveP && !employee.data.employeeNumber\"><ng-form name=\"noEmployeeForm\"><input type=\"number\" \nplaceholder=\"No. Empleado\" name=\"employeeNumber\" ng-model=\"employee.data.employeeNumber\" \nng-model-options=\"{ debounce: F.debounceTime*2 }\" unique-fb max=\"35000\" md-max=\"35000\" ref=\"{{F.active.menuRef}}\" \nquery=\"data/employeeNumber\" fromid=\"{{employee.$id}}\" \nng-change=\'C.saveSimple(employee.$id, employee.data.employeeNumber, \"data/employeeNumber\", \"employees\",null,true)\'><div\n ng-messages=\"noEmployeeForm.employeeNumber.$error\" \nng-show=\"(noEmployeeForm.employeeNumber.$error && !noEmployeeForm.employeeNumber.$pristine) || (noEmployeeForm.employeeNumber.$error && employee.data.employeeNumber)\" \nrole=\"alert\"><div ng-message=\"unique\">Número de empleado ya está registrado</div><div ng-message=\"max\">\nNúmero de empleado no puede exceder 35000</div></div></ng-form></md-input-container><span flex \nng-if=\"!haveP||employee.data.employeeNumber\">{{employee.data.employeeNumber}} <span class=\"righted pointer\"><md-icon \nng-if=\"haveP\" md-font-icon=\"icon-reload\" aria-label=\"reload\" ng-click=\"employee.data.employeeNumber = null\"></md-icon>\n</span></span></div></td></tr></tbody></table></md-table-container><md-table-pagination layout-align=\"start center\" \nlayout-gt-xs=\"row\" layout-xs=\"column\" ng-show=\"noEmployees.length\" md-label=\"{{F.paginationLabel}}\" \nmd-limit=\"F.paginate\" md-limit-options=\"F.paginations\" md-page=\"$parent.currentPage\" md-total=\"{{pagination.total}}\" \nmd-on-paginate=\"getThemPagination\" md-page-select></md-table-pagination></div></div><md-fab-speed-dial \nmd-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\"><md-fab-trigger>\n<md-button aria-label=\"crud menu\" class=\"md-fab md-accent\" md-class=\"{\'md-hue-1\': selected.length}\"><md-icon \nmd-font-icon=\"icon-cube\"></md-icon></md-button></md-fab-trigger><md-fab-actions><md-button with-permission \naction=\"export\" access=\"{{F.active.menuItem}}\" \nng-click=\'exportDataToExcelByQuery(noEmployees,\"employees\",getParamsObject(),pagination.total,\"catalogs/employees/collection\")\' \naria-label=\"export\" class=\"md-fab md-raised md-mini md-primary md-hue-2\"><md-tooltip md-direction=\"left\">\nExportar a excel</md-tooltip><md-icon md-font-icon=\" icon-file-excel\" aria-label=\"export\"></md-icon></md-button>\n<md-button with-permission action=\"read\" access=\"{{F.active.menuItem}}\" ng-show=\"selected.length == 1\" \nng-click=\'R.goToDetail(selected[0], \"read\", {employeeId: selected[0].$id, movementId: selected[0].movement.uid})\' \naria-label=\"Read\" class=\"md-fab md-raised md-primary md-mini\"><md-tooltip md-direction=\"left\">Ver</md-tooltip><md-icon \nmd-font-icon=\"icon-eye\" aria-label=\"read icon\"></md-icon></md-button></md-fab-actions></md-fab-speed-dial></div></div>");
$templateCache.put("app/main/employees/views/movements/movement-historic.html","<div id=\"{{F.active.menuObjName}}\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill \nng-controller=\"HistoricMovementController\"><form name=\"form\" novalidate flex layout=\"column\" ng-disabled=\"F.readMode\">\n<md-toolbar class=\"md-tall header md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" \nlayout=\"row\" layout-align=\"start center\" flex><md-button with-permission action=\"access\" \naccess=\"{{F.active.menuItem}}\" class=\"goto-button md-icon-button\" aria-label=\"Go to list\" ng-click=\"R.goToList()\" \ntranslate translate-attr-aria-label=\"EC.GO_TO\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div \nlayout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"{{F.menuItems[F.active.menuParent][F.active.menuName].icon || F.default.icon}}\" class=\"crud-icon\">\n</md-icon><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\">{{F.active.detailObject.data.name}}</div><div\n class=\"subtitle secondary-text\"><span ng-if=\"!F.addMode\">\n{{\'EC.DETAIL_OF\' | translate}} {{F.active.menuObjName + \'.SINGULAR\' | translate}}</span> <span ng-if=\"F.addMode\">\n{{\'EC.CREATE\' | translate}} {{F.active.menuObjName + \'.SINGULAR\' | translate}}</span></div></div></div></div><div>\n<md-button type=\"submit\" ng-if=\"F.addMode && objectLoaded\" with-permission action=\"createHistoricMovement\" \naccess=\"{{F.active.menuItem}}\" ng-click=\"createHistoricMovement(F.active.detailObject)\" \nng-hide=\"form.$pristine && !objectLoaded\" ng-disabled=\"form.$invalid || loadingProgress\" \nclass=\"md-raised md-background md-fab md-accent md-hue-1\" aria-label=\"create historic movement\"><md-tooltip \nmd-direction=\"left\">Crear Movimiento Histórico</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"create\">\n</md-icon></md-button></div></md-toolbar><md-content layout=\"column\" class=\"content\" flex><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\"><div><code flex>\nEl movimiento creado se agregará al histórico tendrá status 4 y no se asignará ningúna variable al empleado. No se validan datos por lo que debe de tener cuidado de subir solo movimientos previamente analizados.\n</code><div layout-gt-xs=\"row\" flex><md-input-container class=\"md-block evenPadding\" flex><label>Nómina</label>\n<md-select ng-model=\"movement.payroll\" name=\"payroll\" required ng-disabled=\"F.readMode\"><md-select-header><input \nautocomplete=\"off\" type=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"payrollSelectFilter\" \nplaceholder=\"Busque una nómina\"></md-select-header><md-option ng-if=\"!F.permissionToAccessAllPayrolls\" \nng-value=\"payroll.$id\" ng-repeat=\"payroll in L.payrolls | orderBy:\'name\' | filter:payrollSelectFilter\">{{payroll.name}}\n</md-option><md-option ng-if=\"F.permissionToAccessAllPayrolls\" ng-value=\"payroll.$id\" \nng-repeat=\"payroll in L.allPayrolls | orderBy:\'name\' | filter:payrollSelectFilter\">{{payroll.name}}</md-option>\n</md-select><div ng-messages=\"form.payroll.$error\" ng-show=\"form.payroll.$touched || form.payroll.$dirty\" role=\"alert\">\n<div ng-message=\"required\">Nómina es requerido</div></div></md-input-container><md-input-container \nclass=\"md-block evenPadding\" flex><label>Registro Patronal</label><md-autocomplete md-min-length=\"2\" \nmd-selected-item=\"rpSelected\" md-search-text=\"searchRP\" md-selected-item-change=\"movement.rp=item0.$id\" \nmd-items=\'item0 in autocompleteList(searchRP,\"rps/all\")\' md-item-text=\"item0.name\" md-require-match=\"true\" \nmd-select-on-match=\"true\" md-match-case-insensitive=\"true\"><md-item-template><span md-highlight-text=\"searchRP\">\n{{item0.name}}</span></md-item-template><md-not-found>No hay registros</md-not-found></md-autocomplete>\n</md-input-container><md-input-container class=\"md-block\" flex><label>Empleado</label><md-autocomplete \nmd-min-length=\"2\" md-selected-item=\"employeeSelected\" md-search-text=\"searchEmployee\" md-delay=\"500\" \nmd-selected-item-change=\"movement.employee=item.$id\" \nmd-items=\'item in autocompleteList(searchEmployee,\"employees/all\")\' md-item-text=\"item.name\" md-require-match=\"true\" \nmd-select-on-match=\"true\" md-match-case-insensitive=\"true\"><md-item-template><span md-highlight-text=\"searchEmployee\">\n{{item.name}}</span></md-item-template><md-not-found>No hay registros</md-not-found></md-autocomplete>\n</md-input-container></div><div layout-gt-xs=\"row\" flex><md-input-container class=\"md-block evenPadding\" \nflex-gt-xs=\"25\"><label>Status</label><md-select class=\"filter\" ng-model=\"movement.status\" name=\"status\" \nplaceholder=\"Status\" disabled=\"disabled\" required><md-select-header><input autocomplete=\"off\" type=\"search\" \nclass=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"statusSelectFilter\" \nplaceholder=\"Busque un status de movimiento\"></md-select-header><md-option ng-if=\"status.id !== 5\" \nng-value=\"status.id\" ng-repeat=\"status in F.employeeStatatuss | orderBy:\'id\' | filter:statusSelectFilter\">\n{{status.id}} : {{status.name}}</md-option></md-select><div ng-messages=\"form.status.$error\" \nng-show=\"form.status.$touched || form.status.$dirty\" role=\"alert\"><div ng-message=\"required\">Status es requerido</div>\n</div></md-input-container><md-input-container class=\"md-block evenPadding\" flex-gt-xs=\"25\" \nng-if=\"movement.status >= 3\"><label>Lote</label><input type=\"text\" name=\"batch\" maxlength=\"9\" ng-pattern=\"\" \nng-model=\"movement.received.batch\" md-minlength=\"9\" md-maxlength=\"9\" maxlength=\"9\" pattern=\"([0-9]{9})\" required><div \nng-messages=\"form.batch.$error\" ng-show=\"form.batch.$touched || form.batch.$dirty\" role=\"alert\"><div \nng-message=\"required\">Lote es requerido</div><div ng-message=\"pattern\">Número de Lote debe tener [9] números del (0-9)\n</div></div></md-input-container><md-input-container class=\"md-block evenPadding\" flex-gt-xs=\"50\"><label>\nTipo de Movimiento</label><md-select name=\"movementType\" class=\"filter\" ng-model=\"movement.data.type\" \nplaceholder=\"Tipo de movimiento\" required><md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" \nng-keydown=\"$event.stopPropagation()\" ng-model=\"movementTypeSelectFilter\" placeholder=\"Busque un tipo de movimiento\">\n</md-select-header><md-option ng-if=\"[6,10].indexOf(movementType.id) == -1\" ng-value=\"movementType.id\" \nng-repeat=\"movementType in F.movementTypes | orderBy:\'name\' | filter:movementTypeSelectFilter\">{{movementType.name}}\n</md-option></md-select><div ng-messages=\"form.movementType.$error\" \nng-show=\"form.movementType.$touched || form.movementType.$dirty\" role=\"alert\"><div ng-message=\"required\">\nTipo de Movimiento es requerido</div></div></md-input-container></div><md-checkbox name=\"bySystem\" ng-model=\"bySystem\">\nMovimiento de Sistema</md-checkbox><div layout-gt-xs=\"row\" flex><md-input-container class=\"md-block date-picker\" flex \nng-if=\"movement.data.type == 8\"><label>Fecha de Reingreso</label><md-datepicker md-hide-icons=\"triangle\" \nmd-current-view=\"{{F.dateView}}\" input-date-miliseconds required md-max-date=\"maxDate\" ng-model=\"movement.data.date\" \nname=\"movementDate\" class=\"md-block\"></md-datepicker><div ng-messages=\"form.movementDate.$error\" \nng-show=\"form.movementDate.$touched || form.movementDate.$dirty\" role=\"alert\"><div ng-message=\"required\">\nFecha de Reingreso es requerido</div><div ng-message=\"maxdate\">Fecha de Reingreso debe ser antes de {{maxDate | date}}\n</div></div></md-input-container><md-input-container class=\"md-block\" flex \nng-if=\"[7,2].indexOf(movement.data.type) == -1\"><label>Comentarios del Movimiento</label><textarea class=\"uppercased\" \nname=\"comments\" ng-model=\"movement.data.comments\" md-maxlength=\"350\" maxlength=\"350\" \nng-model-options=\"{ debounce: F.debounceTime }\"></textarea><div ng-messages=\"form.comments.$error\" \nng-show=\"form.comments.$touched || form.comments.$dirty\" role=\"alert\"><div ng-message=\"maxlength\">\nComentarios no debe tener más de 350 caracteres</div></div></md-input-container></div><div flex layout-gt-xs=\"row\">\n<md-input-container class=\"md-block\" flex><label>UMF</label><input type=\"text\" name=\"umf\" ng-model=\"movement.info.umf\">\n</md-input-container><md-input-container class=\"md-block\" flex ng-if=\"[2,8].indexOf(movement.data.type) !== -1\"><label>\nSD</label><input type=\"number\" step=\"any\" name=\"sd\" ng-model=\"movement.data.sd\" ng-disabled=\"F.readMode\" required \nng-model-options=\"{ debounce: F.debounceTime }\"><div ng-messages=\"form.sd.$error\" \nng-show=\"form.sd.$touched || form.sd.$dirty\" role=\"alert\"><div ng-message=\"required\">Sueldo Diario es requerido</div>\n</div></md-input-container><md-input-container class=\"md-block\" flex ng-if=\"[2,8].indexOf(movement.data.type) !== -1\">\n<label>SBC</label><input type=\"number\" step=\"any\" name=\"sbc\" round-number=\"2\" ng-model=\"movement.data.sbc\" required>\n<div ng-messages=\"form.sbc.$error\" ng-show=\"form.sbc.$touched || form.sbc.$dirty\" role=\"alert\"><div \nng-message=\"required\">Sueldo Base Cotización es requerido</div></div></md-input-container></div><code flex \nng-if=\"employee\">Datos actuales del empleado</code><div ng-if=\"movement.data.type == 8\" flex layout-gt-xs=\"row\">\n<md-input-container class=\"md-block evenPadding\" flex><label>Nómina</label><md-select ng-model=\"employee.payroll\" \nname=\"payroll\" disabled=\"disabled\"><md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" \nng-keydown=\"$event.stopPropagation()\" ng-model=\"payrollSelectFilter\" placeholder=\"Busque una nómina\">\n</md-select-header><md-option ng-if=\"!F.permissionToAccessAllPayrolls\" ng-value=\"payroll.$id\" \nng-repeat=\"payroll in L.payrolls | orderBy:\'name\' | filter:payrollSelectFilter\">{{payroll.name}}</md-option><md-option \nng-if=\"F.permissionToAccessAllPayrolls\" ng-value=\"payroll.$id\" \nng-repeat=\"payroll in L.allPayrolls | orderBy:\'name\' | filter:payrollSelectFilter\">{{payroll.name}}</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block\" flex><label>Nombre</label><input type=\"text\" \nng-model=\"employee.data.name\" disabled=\"disabled\"></md-input-container><md-input-container \nclass=\"md-block date-picker\" flex><label>Fecha de Alta en IMSS</label><md-datepicker md-hide-icons=\"triangle\" \nng-model=\"employee.data.enroleDate\" input-date-miliseconds class=\"md-block\" disabled=\"disabled\"></md-datepicker>\n</md-input-container></div><div ng-if=\"movement.data.type == 2\" form-dismiss></div><div \nng-if=\"movement.data.type == 7\" form-mds></div><div flex layout-gt-xs=\"row\"><md-input-container \nclass=\"md-block evenPadding\" flex><label>Tipo de trabajador</label><md-select ng-model=\"movement.data.workerType\" \nname=\"workerType\" required ng-disabled=\"F.readMode\"><md-select-header><input autocomplete=\"off\" type=\"search\" \nclass=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"workerTypeSelectFilter\" \nplaceholder=\"Busque un tipo de trabajador\"></md-select-header><md-option ng-value=\"workerType.humansiteCode\" \nng-repeat=\"workerType in M.workerTypes | orderBy:\'name\' | filter:workerTypeSelectFilter\">{{workerType.name}}\n</md-option></md-select><div ng-messages=\"form.workerType.$error\" \nng-show=\"form.workerType.$touched || form.workerType.$dirty\" role=\"alert\"><div ng-message=\"required\">\nTípo de trabajador es requerido</div></div></md-input-container><md-input-container class=\"md-block evenPadding\" flex>\n<label>Jornada</label><md-select ng-model=\"movement.data.workDay\" name=\"workDay\" required ng-disabled=\"F.readMode\">\n<md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" \nng-model=\"workDaySelectFilter\" placeholder=\"Busque una jornada\"></md-select-header><md-option \nng-value=\"workDay.humansiteCode\" ng-repeat=\"workDay in M.workDays | orderBy:\'name\' | filter:workDaySelectFilter\">\n{{workDay.name}}</md-option></md-select><div ng-messages=\"form.workDay.$error\" \nng-show=\"form.workDay.$touched || form.workDay.$dirty\" role=\"alert\"><div ng-message=\"required\">Jornada es requerido\n</div></div></md-input-container><md-input-container class=\"md-block evenPadding\" flex><label>Tipo de salario</label>\n<md-select ng-model=\"movement.data.salaryType\" name=\"salaryType\" required ng-disabled=\"F.readMode\"><md-select-header>\n<input autocomplete=\"off\" type=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" \nng-model=\"salaryTypeSelectFilter\" placeholder=\"Busque un tipo de salario\"></md-select-header><md-option \nng-value=\"salaryType.humansiteCode\" \nng-repeat=\"salaryType in M.salaryTypes | orderBy:\'name\' | filter:salaryTypeSelectFilter\">{{salaryType.name}}\n</md-option></md-select><div ng-messages=\"form.salaryType.$error\" \nng-show=\"form.salaryType.$touched || form.salaryType.$dirty\" role=\"alert\"><div ng-message=\"required\">\nTípo de salario es requerido</div></div></md-input-container></div></div></div></md-content></form></div>");
$templateCache.put("app/main/employees/views/movements/movement.html","<div id=\"{{F.active.menuObjName}}\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill \nng-controller=\"EmployeeController\"><form name=\"form\" novalidate flex layout=\"column\" ng-disabled=\"F.readMode\">\n<md-toolbar class=\"md-tall header md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" \nlayout=\"row\" layout-align=\"start center\" flex><md-button with-permission action=\"access\" \naccess=\"{{F.active.menuItem}}\" class=\"goto-button md-icon-button\" aria-label=\"Go to list\" ng-click=\"R.goToList()\" \ntranslate translate-attr-aria-label=\"EC.GO_TO\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div \nlayout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"{{F.menuItems[F.active.menuParent][F.active.menuName].icon || F.default.icon}}\" class=\"crud-icon\">\n</md-icon><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\">{{F.active.detailObject.data.name}}</div><div\n class=\"subtitle secondary-text\"><span ng-if=\"!F.addMode\">\n{{\'EC.DETAIL_OF\' | translate}} {{F.active.menuObjName + \'.SINGULAR\' | translate}}</span> <span ng-if=\"F.addMode\">\n{{\'EC.CREATE\' | translate}} {{F.active.menuObjName + \'.SINGULAR\' | translate}}</span></div></div></div></div><div>\n<md-button ng-if=\"selectedTab == R.states.fb[F.active.menuName].images\" with-permission action=\"update\" \naccess=\"{{F.active.menuItem}}\" ng-click=\"upload(images, F.active.detailObject)\" \nng-show=\"images.length && !F.active.detailObject[F.active.imageName]\" \nclass=\"md-raised md-background md-fab md-accent md-hue-1\" aria-label=\"Upload image\" \nng-disabled=\"loadingProgress||F.readMode\"><md-tooltip md-direction=\"left\">{{\'EC.UPLOAD_IMAGE\' | translate}}\n</md-tooltip><md-icon md-font-icon=\"icon-upload\"></md-icon></md-button><md-button \nng-if=\"selectedTab == R.states.fb[F.active.menuName].images\" with-permission action=\"update\" \naccess=\"{{F.active.menuItem}}\" ng-click=\"removeUpload(F.active.detailObject)\" \nng-show=\"F.active.detailObject[F.active.imageName]\" class=\"md-warn md-raised md-background md-fab\" \naria-label=\"Delete image\" ng-disabled=\"loadingProgress||F.readMode\"><md-tooltip md-direction=\"left\">\n{{\'EC.DELETE_IMAGE\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button><md-button \ntype=\"submit\" ng-if=\"!F.addMode && objectLoaded && !F.readMode && form.$valid\" with-permission action=\"update\" \naccess=\"{{F.active.menuItem}}\" ng-click=\"saveMiniMovements(F.active.detailObject)\" \nng-hide=\"form.$pristine && !objectLoaded\" \nng-disabled=\"form.$invalid || form.$pending || loadingProgress || F.readMode\" \nclass=\"md-raised md-background md-fab md-accent md-hue-1\" aria-label=\"Save\"><md-tooltip md-direction=\"left\">Editar\n</md-tooltip><md-icon md-font-icon=\"icon-content-save\" aria-label=\"Save\"></md-icon></md-button><validate-form-button>\n</validate-form-button><md-button type=\"submit\" ng-if=\"F.addMode && objectLoaded\" with-permission action=\"create\" \naccess=\"{{F.active.menuItem}}\" ng-click=\"add(F.active.detailObject)\" ng-hide=\"form.$pristine && !objectLoaded\" \nng-disabled=\"form.$invalid || form.$pending || loadingProgress\" \nclass=\"md-raised md-background md-fab md-accent md-hue-1\" aria-label=\"Add\"><md-tooltip md-direction=\"left\">\n{{\'EC.ADD\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-content-save\" aria-label=\"Add\"></md-icon></md-button>\n</div></md-toolbar><md-content layout=\"column\" class=\"content\" flex><md-tabs flex md-dynamic-height class=\"scrollable\">\n<md-tab label=\"Movimiento\"><md-tab-body><div class=\"detail-form-container md-background-bg md-whiteframe-1dp\" \nlayout=\"column\"><div form-special-movement></div><div ng-if=\"movement.data.type == 6 || movement.data.type == 8\" \nform-salaries></div><div ng-if=\"movement.data.type == 6 || movement.data.type == 8\" layout-gt-xs=\"row\" flex>\n<md-input-container class=\"md-block\" flex><label>Comentarios</label><textarea ng-disabled=\"F.readMode\" \nclass=\"uppercased\" rows=\"3\" name=\"comments\" ng-model=\"movement.data.comments\" md-maxlength=\"350\" maxlength=\"350\" \nnotdeletespecialcharts=\"true\" ng-model-options=\"{ debounce: F.debounceTime }\"></textarea><div \nng-messages=\"form.comments.$error\" ng-show=\"form.comments.$touched || form.comments.$dirty\" role=\"alert\"><div \nng-message=\"maxlength\">Comentarios no debe tener más de 350 caracteres</div></div></md-input-container></div></div>\n</md-tab-body></md-tab><md-tab label=\"Informacion del empleado\"><md-tab-body><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\" layout=\"column\"><div layout-gt-xs=\"row\" flex>\n<md-input-container class=\"md-block evenPadding\" flex><label>Nómina</label><md-select ng-model=\"employee.payroll\" \nname=\"payroll\" required ng-disabled=\"F.readMode\"><md-select-header><input autocomplete=\"off\" type=\"search\" \nclass=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"payrollSelectFilter\" placeholder=\"Busque una nómina\">\n</md-select-header><md-option ng-if=\"payroll.active||!F.addMode\" ng-value=\"payroll.$id\" ng-disabled=\"!payroll.active\" \nng-repeat=\"payroll in (F.permissionToAccessAllPayrolls?L.allPayrolls:L.payrolls) | orderBy:\'name\' | filter:payrollSelectFilter\">\n{{payroll.name}}</md-option></md-select><div ng-messages=\"form.payroll.$error\" \nng-show=\"form.payroll.$touched || form.payroll.$dirty\" role=\"alert\"><div ng-message=\"required\">Nómina es requerido\n</div></div></md-input-container><md-input-container class=\"md-block evenPadding\" flex><label>Centro de Costo</label>\n<md-select ng-model=\"employee.cc\" name=\"cc\" required ng-disabled=\"F.readMode\"><md-select-header><input \nautocomplete=\"off\" type=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"ccSelectFilter\" \nplaceholder=\"Busque un centro de costo\"></md-select-header><md-option \nng-if=\'!F.permissionToAccessAllPayrolls && (cc.valid || (!F.addMode&&F.active.menuAction!=\"reEntry\"))\' \nng-value=\"cc.$id\" \nng-repeat=\"cc in L.payrollCcs[employee.payroll] | filterUserCcs:L.userCcs[F.profile.uid] | orderBy:\'name\' | filter:ccSelectFilter\">\n{{cc.name}} <small>[{{L.rpCcs[cc.rp_id].name}}]</small></md-option><md-option \nng-if=\'F.permissionToAccessAllPayrolls && (cc.valid || (!F.addMode&&F.active.menuAction!=\"reEntry\"))\' \nng-value=\"cc.$id\" ng-repeat=\"cc in L.payrollCcs[employee.payroll] | orderBy:\'name\' | filter:ccSelectFilter\">\n{{cc.name}} <small>[{{L.rpCcs[cc.rp_id].name}}]</small></md-option></md-select><div ng-messages=\"form.cc.$error\" \nng-show=\"form.cc.$touched || form.cc.$dirty\" role=\"alert\"><div ng-message=\"required\">Centro de Costo es requerido</div>\n</div></md-input-container><md-input-container class=\"md-block\" flex><label>Registro Patronal</label><md-select \nng-disabled=\"F.readMode\" name=\"rp\" ng-model=\"employee.rp\" required><md-select-header><input autocomplete=\"off\" \ntype=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"rpSelectFilter\" \nplaceholder=\"Busque un registro patronal\"></md-select-header><md-option ng-if=\"rp.active || !F.addMode\" \nng-disabled=\"!rp.active\" ng-value=\"rp.$id\" ng-repeat=\"rp in L.rps | orderBy:\'name\' | filter:rpSelectFilter\">{{rp.name}}\n</md-option></md-select><div ng-messages=\"form.rp.$error\" ng-show=\"form.rp.$touched || form.rp.$dirty\" role=\"alert\">\n<div ng-message=\"required\">Registro Patronal es requerido</div></div></md-input-container></div><div \nlayout-gt-xs=\"row\" flex><md-input-container class=\"md-block\" flex><label>Apellido Paterno</label><input \nng-disabled=\"F.readMode\" class=\"uppercased\" type=\"text\" name=\"paternalSurname\" \nng-model=\"employee.data.info.paternalSurname\" md-maxlength=\"30\" maxlength=\"30\" notdeletethese=\'[\".\",\"-\",\"&#39;\"]\' \nng-model-options=\"{ debounce: F.debounceTime }\" required><div ng-messages=\"form.paternalSurname.$error\" \nng-show=\"form.paternalSurname.$touched || form.paternalSurname.$dirty\" role=\"alert\"><div ng-message=\"required\">\nApellido Paterno es requerido</div><div ng-message=\"maxlength\">Apellido Paterno no debe tener más de 30 caracteres\n</div></div></md-input-container><md-input-container class=\"md-block\" flex><label>Apellido Materno</label><input \nng-disabled=\"F.readMode\" class=\"uppercased\" type=\"text\" name=\"maternalSurname\" \nng-model=\"employee.data.info.maternalSurname\" md-maxlength=\"30\" maxlength=\"30\" notdeletethese=\'[\".\",\"-\",\"&#39;\"]\' \nng-model-options=\"{ debounce: F.debounceTime }\"><div ng-messages=\"form.maternalSurname.$error\" \nng-show=\"form.maternalSurname.$touched || form.maternalSurname.$dirty\" role=\"alert\"><div ng-message=\"maxlength\">\nApellido Materno no debe tener más de 30 caracteres</div></div></md-input-container><md-input-container \nclass=\"md-block\" flex><label>Nombre(s)</label><input ng-disabled=\"F.readMode\" class=\"uppercased\" type=\"text\" \nname=\"names\" ng-model=\"employee.data.info.names\" required md-maxlength=\"40\" maxlength=\"40\" \nnotdeletethese=\'[\".\",\"-\",\"&#39;\"]\' ng-model-options=\"{ debounce: F.debounceTime }\"><div \nng-messages=\"form.names.$error\" ng-show=\"form.names.$touched || form.names.$dirty\" role=\"alert\"><div \nng-message=\"required\">Nombre(s) es requerido</div><div ng-message=\"maxlength\">\nNombre(s) no debe tener más de 40 caracteres</div></div></md-input-container><md-input-container class=\"md-block\" flex>\n<label>NSS</label><input nss class=\"uppercased\" unique-mongo-v2 catalog=\"employees\" includecenter=\"true\" \nignorevalidationpath=\"uniqueNss\" field=\"data.nss\" ref=\"catalogs/employees/collection\" query=\"data/nss\" \nfromid=\"{{employee.$id}}\" type=\"text\" name=\"nss\" ng-model=\"employee.data.nss\" md-maxlength=\"11\" maxlength=\"11\" \npattern=\"([0-9]{11})\" ng-required=\"fiscalMovement\" ng-disabled=\"!fiscalMovement\" \nng-model-options=\"{ debounce: F.debounceTime }\"><div ng-messages=\"form.nss.$error\" \nng-show=\"(form.nss.$error && !form.nss.$pristine) || (form.nss.$error && employee.data.nss)\" role=\"alert\"><div \nng-message=\"nss\">NSS no tiene un formato válido</div><div ng-message=\"required\">NSS es requerido</div><div \nng-message=\"unique\">NSS ya está registrado</div></div></md-input-container></div><div \nng-if=\"movement.data.type == 6 || movement.data.type == 8 || movement.data.type == 7\" form-worker></div></div>\n</md-tab-body></md-tab></md-tabs></md-content></form></div>");
$templateCache.put("app/main/employees/views/movements/movementReceipt.html","<!DOCTYPE html PUBLIC \"-//W3C//DTD XHTML 1.0 Transitional//EN\" \"http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd\">\n<html xmlns=\"http://www.w3.org/1999/xhtml\" xml:lang=\"es\" lang=\"es\"><head><title>\nMódulo de Movimientos Afiliatorios :: IDSE :: Instituto Mexicano del Seguro Social</title><meta http-equiv=\"Expires\" \ncontent=\"-1\"><meta http-equiv=\"content-type\" content=\"text/html; charset=UTF-8\"><meta http-equiv=\"Cache-Control\" \ncontent=\"no-cache\"><style>\n#text,\r\n		body {\r\n			font-family: Verdana, Arial\r\n		}\r\n		\r\n		#tp_menus,\r\n		#tp_tituloimss {\r\n			background-color: #FEA620\r\n		}\r\n		\r\n		#tp_contacto,\r\n		#tp_inicio,\r\n		#tp_inicio1,\r\n		#tp_relleno {\r\n			background-color: #5B5B5B\r\n		}\r\n		\r\n		#tp_contacto,\r\n		#tp_inicio,\r\n		#tp_inicio1,\r\n		#tp_tituloimss {\r\n			float: left;\r\n			height: 20px;\r\n			padding-top: 3px\r\n		}\r\n		\r\n		#tp_cuerpo,\r\n		#tp_cuerpo1 {\r\n			min-height: 400px;\r\n			width: 100%\r\n		}\r\n		\r\n		#tp_contacto,\r\n		#tp_inicio,\r\n		#tp_inicio1,\r\n		#tp_pieDePaginaPhantom,\r\n		#tp_piecontenido,\r\n		#tp_tituloimss {\r\n			text-align: center;\r\n			color: #fff\r\n		}\r\n		\r\n		#tp_breadcrumbs,\r\n		#tp_contenedor,\r\n		#tp_contenedor_pdf,\r\n		#tp_cuerpo,\r\n		#tp_cuerpo1,\r\n		#tp_pieactualizacion {\r\n			text-align: left;\r\n			position: relative\r\n		}\r\n		\r\n		body,\r\n		form {\r\n			margin: 0;\r\n			padding: 0\r\n		}\r\n		\r\n		h1,\r\n		h2,\r\n		h3,\r\n		h4,\r\n		h5,\r\n		h6 {\r\n			text-transform: none;\r\n			margin-bottom: .3em\r\n		}\r\n		\r\n		#tp_breadcrumbs a:hover,\r\n		#tp_menus a:hover,\r\n		#tp_pie a:hover,\r\n		a:hover {\r\n			text-decoration: underline\r\n		}\r\n		\r\n		body {\r\n			background-color: #fff;\r\n			color: #000;\r\n			font-size: 12px\r\n		}\r\n		\r\n		#text {\r\n			font-size: 10px\r\n		}\r\n		\r\n		h1,\r\n		h2 {\r\n			font-family: Verdana, Arial, Helvetica, sans-serif\r\n		}\r\n		\r\n		#tp_contenedor,\r\n		#tp_contenedor_pdf {\r\n			width: 781px\r\n		}\r\n		\r\n		#tp_encabezado,\r\n		#tp_pie {\r\n			width: 100%;\r\n			position: relative\r\n		}\r\n		\r\n		#tp_logos {\r\n			width: 100%;\r\n			height: 63px;\r\n			position: relative\r\n		}\r\n		\r\n		#tp_logoimss {\r\n			float: left\r\n		}\r\n		\r\n		#tp_cuadros,\r\n		#tp_escudo {\r\n			float: right\r\n		}\r\n		\r\n		#tp_menus {\r\n			width: 100%;\r\n			height: 20px;\r\n			position: relative\r\n		}\r\n		\r\n		#tp_tituloimss {\r\n			width: 325px\r\n		}\r\n		\r\n		#tp_relleno {\r\n			float: left;\r\n			height: 20px\r\n		}\r\n		\r\n		#tp_contacto,\r\n		#tp_inicio {\r\n			padding-left: 10px;\r\n			padding-right: 10px;\r\n			border-right: 1px Solid #f90\r\n		}\r\n		\r\n		#tp_encabezadobajo {\r\n			width: 100%;\r\n			position: relative;\r\n			background-color: #1F6C64;\r\n			height: 10px;\r\n			margin-bottom: 5px\r\n		}\r\n		\r\n		#tp_cuerpo {\r\n			margin-bottom: 5px;\r\n			padding-bottom: 20px\r\n		}\r\n		\r\n		#tp_cuerpo1 {\r\n			margin-bottom: 0\r\n		}\r\n		\r\n		#tp_breadcrumbs {\r\n			width: 100%;\r\n			min-height: 20px\r\n		}\r\n		\r\n		#tp_piealto {\r\n			width: 100%;\r\n			position: relative;\r\n			background-color: #ffa620;\r\n			height: 10px\r\n		}\r\n		\r\n		#tp_piecontenido {\r\n			width: 100%;\r\n			font-size: 10px\r\n		}\r\n		\r\n		#tp_pieDePaginaPhantom {\r\n			width: 100%;\r\n			font-size: 5px\r\n		}\r\n		\r\n		#tp_pieactualizacion {\r\n			width: 770px;\r\n			bottom: 60px;\r\n			padding-left: 10px;\r\n			font-size: 10px;\r\n			color: #888\r\n		}\r\n		\r\n		a:active,\r\n		a:link,\r\n		a:visited {\r\n			text-decoration: none;\r\n			color: #157164\r\n		}\r\n		\r\n		a:hover {\r\n			color: #157164\r\n		}\r\n		\r\n		h1,\r\n		h2,\r\n		h3 {\r\n			margin-left: 0\r\n		}\r\n		\r\n		h1 {\r\n			font-size: 1.2em;\r\n			line-height: 1em\r\n		}\r\n		\r\n		h2 {\r\n			font-size: 1.1em\r\n		}\r\n		\r\n		h3,\r\n		h4,\r\n		h5,\r\n		h6 {\r\n			font-family: Verdana, Arial, Helvetica, sans-serif;\r\n			font-size: 1em\r\n		}\r\n		\r\n		h4,\r\n		h5,\r\n		h6 {\r\n			margin-top: .5em;\r\n			margin-left: 2%\r\n		}\r\n		\r\n		h6 {\r\n			font-style: italic\r\n		}\r\n		\r\n		h1.encabezado {\r\n			width: 90%;\r\n			min-height: 15px;\r\n			text-align: right;\r\n			vertical-align: middle;\r\n			background-color: #fa0;\r\n			color: #fff;\r\n			background-image: url(/imss/resources/images/plantilla/encabezado.gif);\r\n			text-transform: uppercase;\r\n			font-size: 12px;\r\n			padding: 5px 4% 5px 6%\r\n		}\r\n		\r\n		.tituloimss {\r\n			font-size: 13px;\r\n			font-family: Verdana;\r\n			color: #fff\r\n		}\r\n		\r\n		#tp_menus a:active,\r\n		#tp_menus a:hover,\r\n		#tp_menus a:link,\r\n		#tp_menus a:visited {\r\n			color: #fff;\r\n			font-size: 12px\r\n		}\r\n		\r\n		#tp_breadcrumbs {\r\n			font-size: 10px;\r\n			font-family: Verdana;\r\n			color: #666\r\n		}\r\n		\r\n		#tp_breadcrumbs a:active,\r\n		#tp_breadcrumbs a:link,\r\n		#tp_breadcrumbs a:visited {\r\n			font-size: 10px;\r\n			font-family: Verdana;\r\n			color: #157164\r\n		}\r\n		\r\n		#tp_breadcrumbs a:hover {\r\n			font-size: 10px;\r\n			font-family: Verdana;\r\n			color: #157164\r\n		}\r\n		\r\n		#tp_pie a:hover,\r\n		table.menu th,\r\n		table.tabla th,\r\n		table.tablaverde th {\r\n			color: #fff;\r\n			font-weight: 700\r\n		}\r\n		\r\n		#tp_pie a:active,\r\n		#tp_pie a:link,\r\n		#tp_pie a:visited {\r\n			color: #fff;\r\n			font-size: 10px;\r\n			font-weight: 700\r\n		}\r\n		\r\n		#tp_pie a:hover {\r\n			font-size: 10px\r\n		}\r\n		\r\n		table.tabla {\r\n			border: 1px solid #ea7825\r\n		}\r\n		\r\n		table.tabla th {\r\n			background-color: #ea7825;\r\n			padding: 5px\r\n		}\r\n		\r\n		table.tabla td {\r\n			padding: 3px\r\n		}\r\n		\r\n		table.tabla .par {\r\n			background-color: #fff8f2\r\n		}\r\n		\r\n		table.tabla .impar {\r\n			background-color: #fdf0e7\r\n		}\r\n		\r\n		table.tablaverde {\r\n			border: 1px solid #157164;\r\n			padding: 3px\r\n		}\r\n		\r\n		table.tablaverde th {\r\n			background-color: #157164;\r\n			padding: 5px\r\n		}\r\n		\r\n		table.tablaverde td {\r\n			padding: 3px\r\n		}\r\n		\r\n		table.tablaverde .par {\r\n			background-color: #f2fff2\r\n		}\r\n		\r\n		table.tablaverde .impar {\r\n			background-color: #e7ffe7\r\n		}\r\n		\r\n		table.menu {\r\n			border: 1px solid #ea7825\r\n		}\r\n		\r\n		table.menu th {\r\n			background-color: #ea7825;\r\n			padding: 5px\r\n		}\r\n		\r\n		table.menu td {\r\n			padding: 5px 5px 5px 15px\r\n		}\r\n		\r\n		table.menu a:link,\r\n		table.menu a:visited {\r\n			text-decoration: none;\r\n			color: #ea7825;\r\n			font-weight: 700\r\n		}\r\n		\r\n		table.menu a:hover {\r\n			text-decoration: underline;\r\n			color: #fe9020;\r\n			font-weight: 700\r\n		}\r\n		\r\n		table.menu a:active {\r\n			text-decoration: none;\r\n			color: #ea7825;\r\n			font-weight: 700\r\n		}\r\n		\r\n		table.menu .par {\r\n			background-color: #fff8f2\r\n		}\r\n		\r\n		table.menu .impar {\r\n			background-color: #fdf0e7\r\n		}\n</style></head><body><center><div id=\"tp_contenedor\"><div id=\"tp_encabezado\"><div id=\"tp_logos\"><div id=\"tp_logoimss\">\n<img height=\"63\" alt=\"Logo del IMSS\" \nsrc=\"data:image/png;base64,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\" \nwidth=\"328\"></div><div id=\"tp_escudo\"><img height=\"63\" alt=\"Escudo Nacional\" \nsrc=\"data:image/png;base64,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\">\n</div><div id=\"tp_cuadros\"><img height=\"63px\" border=\"0\" alt=\"Cuadros decorativos\" \nsrc=\"data:image/png;base64,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\">\n</div></div><div id=\"tp_menus\"><div class=\"tituloimss\" id=\"tp_tituloimss\">www.<span style=\"FONT-WEIGHT: bold\">imss\n</span>.gob.mx</div><div id=\"tp_inicio\" style=\"width: 70px\"></div><div id=\"tp_inicio\"><a>Inicio</a></div><div \nid=\"tp_contacto\"><a>Contacto y Directorios</a></div><div id=\"tp_relleno\" style=\"width: 88px\"></div></div></div><div \nid=\"tp_encabezadobajo\"></div><div id=\"tp_cuerpo\"><div id=\"tp_breadcrumbs\"><table cellspacing=\"0\" cellpadding=\"0\" \nborder=\"0\" width=\"100%\"><tbody><tr><td width=\"50%\"><table cellspacing=\"0\" cellpadding=\"0\" border=\"0\"><tbody><tr><td><a>\nInicio</a></td><td>&nbsp;-&nbsp;</td><td><a>IDSE</a></td><td>&nbsp;-&nbsp;</td><td><a>Menú IDSE</a></td><td>\n&nbsp;-&nbsp;</td><td><a>Movimientos afiliatorios</a></td></tr></tbody></table></td><td width=\"50%\"><table \ncellspacing=\"0\" cellpadding=\"0\" border=\"0\" width=\"100%\"><tbody><tr><td align=\"right\"><a>Salir</a></td></tr></tbody>\n</table></td></tr></tbody></table></div><br><table width=\"100%\" border=\"0\" cellspacing=\"0\" cellpadding=\"0\" \nalign=\"center\"><tbody><tr><td align=\"right\"><b>L016005310 - COMERCIALIZACION DE SERVICIOS ESTRATEGICOS Y FISCA<br>\nSM 45 MZ 1 LT 16 CSA 1 AV DEL SOL</b></td></tr></tbody></table><a onmouseover=\"window.status=\'\'\"><img \nsrc=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAF4AAAAeCAYAAACliqkCAAAAAXNSR0IArs4c6QAAAAlwSFlzAAAOxAAADsQBlSsOGwAAAVlpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IlhNUCBDb3JlIDUuNC4wIj4KICAgPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICAgICAgPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIKICAgICAgICAgICAgeG1sbnM6dGlmZj0iaHR0cDovL25zLmFkb2JlLmNvbS90aWZmLzEuMC8iPgogICAgICAgICA8dGlmZjpPcmllbnRhdGlvbj4xPC90aWZmOk9yaWVudGF0aW9uPgogICAgICA8L3JkZjpEZXNjcmlwdGlvbj4KICAgPC9yZGY6UkRGPgo8L3g6eG1wbWV0YT4KTMInWQAAAcRJREFUaAXtmY1pAzEMhZPSGbphF+ggXaAbdom2r/CB0Fm261yjuyCDsayfp+cXEQK5fv2sS627K/B0947V8FeBEj5pEEr4Ej5JgaS2NfElfJICSW1r4kv4JAWS2tbEl/BJCiS1nZr4l7fXi3at/RR4HkHdKnhU//n+MWr90PHuxEeirSgiodmq3xN7hU92TTjxXpj/nlDfT8L4nq0cm0dcddZWDnfZrBl8mzPCIN7qT0/OpvAAkGSb49vzpJ/tI582viinxYNcYtzBkl8+bXytHOo5yeXuMawfOzo3wkPAFrR8Nu5tT1Bxj9HK8Tir91uwxTOq92+I+EX1Nn8jvA3uaYsMxCNixPfsa7F6+JYfeZZnz2d7zNob4S0BQCwBfCsn2HpEC7PlW+kT1YzwiSNyxDPC/4u/+asGAgBBhPstJ9gjTMV7Ob3YDL8ePhxncFZzrr3/XP3jVgiB4Wu9n7t9SFSjHMWoIc/fLRYx66NOvlE8ypEfHDC4KxatrvAqAkz2DKDy7rXgdjReM+9vftXYwjM+yvI/qj2c+CMRZ8Itp7MOxqmEt4Kf3R5+1Zz9gUflX8InfTIlfAmfpEBS25r4JOG/AWCEzYUbKum6AAAAAElFTkSuQmCC\" \nalt=\"Regresar\" border=\"0\"></a><h1 class=\"encabezado\">Movimientos Afiliatorios</h1><br><form name=\"forma\" \naction=\"/imss/ArchivoReporteDetallado.idse\"><input type=\"hidden\" name=\"loteID\" value=\"179716509\"> <input type=\"hidden\" \nname=\"paginaActual\" value=\"\"> <input type=\"hidden\" name=\"referer\" \nvalue=\"http://idse.imss.gob.mx/imss/AfiliaResultados.idse\"><table width=\"90%\" border=\"0\" align=\"center\" \ncellpadding=\"2\" cellspacing=\"0\" class=\"tabla\"><tr><th colspan=\"2\">&nbsp;Confirmaci&oacute;n de movimientos #179716509\n</th></tr><tr class=\"impar\"><td align=\"right\" colspan=\"2\" valign=\"middle\"><strong>Fecha:</strong>\n 20 de Diciembre de 2016</td></tr><tr class=\"par\"><td><b>Registro patronal:</b></td><td valign=\"top\" width=\"752\">\n<select name=\"patronConsulta\" onchange=\"cambioPagina(\'1\')\"><option value=\"L016005310\" selected=\"selected\">L016005310\n</option></select></td></tr><tr class=\"impar\"><td valign=\"top\"><b>Nombre:</b></td><td valign=\"top\">\nCOMERCIALIZACION DE SERVICIOS ESTRATEGICOS Y FISCA</td></tr><tr class=\"par\"><td valign=\"top\"><b>Mostrar movimientos: \n</b></td><td valign=\"top\"><input type=\"radio\" name=\"movProcesadosErroneos\" value=\"1\" checked=\"checked\" \nonclick=\"cambioPagina(\'1\')\">Todos <input type=\"radio\" name=\"movProcesadosErroneos\" value=\"3\" \nonclick=\"cambioPagina(\'1\')\">Operados <input type=\"radio\" name=\"movProcesadosErroneos\" value=\"2\" \nonclick=\"cambioPagina(\'1\')\">Erroneos</td></tr><tr><th colspan=\"2\">IDSE-03: RESPUESTA AL PATR&Oacute;N</th></tr><tr><td \nclass=\"par\" colspan=\"2\"><table width=\"90%\" border=\"0\" align=\"center\" cellpadding=\"2\" cellspacing=\"0\" \nclass=\"tablaverde\"><tr><th colspan=\"4\" align=\"center\">Mvtos recibidos por el IMSS</th><th colspan=\"4\" align=\"center\">\nOperados</th><th colspan=\"4\" align=\"center\">Errores</th></tr><tr><th align=\"center\">BAJ</th><th align=\"center\">MOD</th>\n<th align=\"center\">REI</th><th align=\"center\">TOT</th><th align=\"center\">BAJ</th><th align=\"center\">MOD</th><th \nalign=\"center\">REI</th><th align=\"center\">TOT</th><th align=\"center\">BAJ</th><th align=\"center\">MOD</th><th \nalign=\"center\">REI</th><th align=\"center\">TOT</th></tr><tr class=\"par\"><td align=\"center\" style=\"font-size: 10px\">1\n</td><td align=\"center\" style=\"font-size: 10px\">0</td><td align=\"center\" style=\"font-size: 10px\">0</td><td \nalign=\"center\" style=\"font-size: 10px\">1</td><td align=\"center\" style=\"font-size: 10px\">1</td><td align=\"center\" \nstyle=\"font-size: 10px\">0</td><td align=\"center\" style=\"font-size: 10px\">0</td><td align=\"center\" \nstyle=\"font-size: 10px\">1</td><td align=\"center\" style=\"font-size: 10px\">0</td><td align=\"center\" \nstyle=\"font-size: 10px\">0</td><td align=\"center\" style=\"font-size: 10px\">0</td><td align=\"center\" \nstyle=\"font-size: 10px\">0</td></tr></table></td></tr><tr><th colspan=\"2\">\nAFIL06: RELACI&Oacute;N DE MOVIMIENTOS OPERADOS</th></tr><tr><td class=\"par\" colspan=\"2\"><table width=\"90%\" border=\"0\" \nalign=\"center\" cellpadding=\"2\" cellspacing=\"0\" class=\"tablaverde\"><tr><th align=\"center\">T-Mov</th><th align=\"center\">\nN&uacute;m. sel Seg. Social</th><th align=\"center\">Nombre del asegurado</th><th align=\"center\">Sal-Base</th><th \nalign=\"center\">ID-EX</th><th align=\"center\">UMF</th><th align=\"center\">T-Sal</th><th align=\"center\">Jornada Reducida\n</th><th align=\"center\">Fecha mov.</th><th align=\"center\">T-Trab</th><th align=\"center\">Cve-Baja</th></tr><tr \nclass=\"par\"><td align=\"center\" style=\"font-size: 10px\">2</td><td align=\"center\" style=\"font-size: 10px\">82988069652\n</td><td align=\"center\" style=\"font-size: 10px\">AKE CEN OBDULIA MARIA MARGARITA</td><td align=\"center\" \nstyle=\"font-size: 10px\">0.00</td><td align=\"center\" style=\"font-size: 10px\">NO</td><td align=\"center\" \nstyle=\"font-size: 10px\">000</td><td align=\"center\" style=\"font-size: 10px\">0</td><td align=\"center\" \nstyle=\"font-size: 10px\">0</td><td align=\"center\" style=\"font-size: 10px\">17/dic/16</td><td align=\"center\" \nstyle=\"font-size: 10px\">0</td><td align=\"center\" style=\"font-size: 10px\">2-SEPARACION VOLUNTARIA</td></tr></table></td>\n</tr><tr><td align=\"right\" class=\"impar\" colspan=\"2\"><input type=\"submit\" value=\"Guardar archivo\"></td></tr></table>\n</form></div><br><br><div id=\"tp_pieDePaginaPhantom\"></div><div id=\"tp_piealto\"></div><div id=\"tp_pie\" \nstyle=\"BACKGROUND-COLOR: #1f6c64\"><div id=\"tp_piecontenido\">\nAlgunos derechos reservados IMSS | Reforma 476, Col. Ju&aacute;rez, M&eacute;xico DF |Tel. 01 800 6232323&nbsp;| <a>\nAcerca del Portal </a>| <a href=\"/imss/descargas/Ley002.pdf\" target=\"_blank\">Avisos Legales</a></div></div><div \nid=\"tp_pieactualizacion\" style=\"right: 5px\"><table width=\"95%\" border=\"0\" cellspacing=\"0\" cellpadding=\"0\"><tbody><tr \nvalign=\"bottom\"><td align=\"left\">Última modificación: 08/11/2011, 12:00 hrs.</td><td align=\"right\">\nPara poder ver los documentos necesitas instalar <a target=\"_blank\"><img \nsrc=\"data:image/png;base64,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\" \nwidth=\"80\" height=\"30\" border=\"0\" alt=\"Instalar Adobe Reader\"></a></td></tr></tbody></table></div></div></center>\n</body></html>");
$templateCache.put("app/main/employees/views/movements/movements.html","<div id=\"movements\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\" ng-controller=\"MovementsController\">\n<div class=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div mongo-search-bar></div><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><div \nlist-filters filters-loaded=\"F.filtersLoaded\" ng-model=\"F.filters[F.active.menuName]\" on-change=\"getThem\" \ntab-name=\"tabName\" tab-config=\"tabs[tabName]\" columns-repeat=\"columnsRepeat\" menu-obj-name=\"{{F.active.menuObjName}}\" \nmodel-name=\"{{F.active.menuName}}\" init-filters=\"initFilters\"></div><div table-loader array=\"movements\" \nvalidations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"movements.length\"><thead md-head \nmd-order=\"F.orderMongo\" fix-head md-on-reorder=\"getThem\"><tr md-row><th md-column md-order-by=\"rp\"><span>RP</span></th>\n<th md-column md-order-by=\"payroll\"><span>Nómina</span></th><th md-column md-order-by=\"info.nss\"><span>NSS</span></th>\n<th md-column md-order-by=\"employee\"><span>Empleado</span></th><th md-column md-order-by=\"data.type\"><span>Tipo</span>\n</th><th md-column md-order-by=\"data.sd\"><span>SD</span></th><th md-column md-order-by=\"data.sbc\"><span>SBC</span></th>\n<th md-column md-order-by=\"data.date\"><span>Fecha</span></th><th md-column md-order-by=\"status\"><span>Status</span>\n</th><th md-column ng-repeat=\"column in columnsRepeat\" ng-show=\"column.show\">{{column.name}}</th></tr></thead><tbody \nmd-body><tr ng-class=\"{\'inProcessMovement\':!movement[\'fid-pdfPrintable\']}\" md-row md-auto-select md-select=\"movement\" \nmd-select-id=\"$id\" ng-repeat=\"($index, movement) in movements\"><td md-cell>{{movement[\'rp-name\']}}</td><td md-cell>\n[{{movement[\'payroll2-class\']}}] {{movement[\'payroll-name\']}}</td><td md-cell>{{movement.info.nss}}</td><td md-cell>\n{{movement.info.name}}</td><td md-cell>{{movement.data.type | typeName}}</td><td md-cell>\n{{movement.data.sd | currency}}</td><td md-cell>{{movement.data.sbc | currency}}</td><td md-cell>\n{{movement.data.date| date:F.dateFormat}}</td><td md-cell>{{movement.status | movementStatusName}}</td><td md-cell \nng-repeat=\"column in columnsRepeat\" ng-show=\"column.show\">{{movement | getValueOfRecord: column}}</td></tr></tbody>\n</table></md-table-container><md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" \nng-show=\"movements.length\" md-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" md-limit-options=\"F.paginations\" \nmd-page=\"$parent.currentPage\" md-total=\"{{pagination.total}}\" md-on-paginate=\"getThemPagination\" md-page-select>\n</md-table-pagination></div></div><md-fab-speed-dial md-open=\"F.isOpen\" \nmd-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\"><md-fab-trigger><md-button \naria-label=\"crud menu\" class=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon></md-button>\n</md-fab-trigger><md-fab-actions><md-button with-permission action=\"export\" access=\"{{F.active.menuItem}}\" \nng-click=\'exportDataToExcelByQuery(movements,F.active.menuName,getParamsObject(),pagination.total,\"catalogs/movements/collection\")\' \naria-label=\"export\" class=\"md-fab md-raised md-mini md-primary md-hue-2\"><md-tooltip md-direction=\"left\">\nExportar a excel</md-tooltip><md-icon md-font-icon=\" icon-file-excel\" aria-label=\"export\"></md-icon></md-button>\n<md-button with-permission action=\"generatePdfMovement\" access=\"{{F.active.menuItem}}\" \nng-show=\"selected.length>0 && (selected|recordsHaveValue:\'fid-pdfPrintable\':1)\" ng-click=\"printPDF($event)\" \naria-label=\"generatePDF\" class=\"md-fab md-raised md-mini md-primary md-hue-3\"><md-tooltip md-direction=\"left\">PDF\n</md-tooltip><md-icon md-font-icon=\"icon-file-pdf\" aria-label=\"print pdf\"></md-icon></md-button><md-button \nwith-permission action=\"read\" access=\"{{F.active.menuItem}}\" ng-show=\"selected.length == 1\" \nng-click=\'R.goToDetail(null, \"read\", {movementId: selected[0].$id, employeeId: selected[0].employee, payroll: selected[0].payroll})\' \naria-label=\"Read\" class=\"md-fab md-raised md-primary md-mini\"><md-tooltip md-direction=\"left\">Ver</md-tooltip><md-icon \nmd-font-icon=\"icon-eye\" aria-label=\"read icon\"></md-icon></md-button><md-button with-permission action=\"update\" \naccess=\"{{F.active.menuItem}}\" ng-show=\"selected.length == 1\" \nng-click=\'R.goToDetail(null, \"update\", {movementId: selected[0].$id, employeeId: selected[0].employee, payroll: selected[0].payroll})\' \naria-label=\"edit\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Editar\n</md-tooltip><md-icon md-font-icon=\"icon-pencil\" aria-label=\"edit\"></md-icon></md-button><md-button with-permission \naction=\"remove\" access=\"{{F.active.menuItem}}\" ng-show=\"selected.length\" ng-click=\"deleteMovements($event)\" \naria-label=\"Delete\" class=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">\n{{\'EC.REMOVE\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button>\n<md-button with-permission action=\"createHistoricMovement\" access=\"{{F.active.menuItem}}\" ng-show=\"!selected.length\" \nng-click=\'R.goToDetail(\"new\", \"createHistoricMovement\", {movementId: \"new\"})\' \naria-label=\"go to create historic movement\" class=\"md-fab md-raised md-mini md-warn md-hue-2\"><md-tooltip \nmd-direction=\"left\">Crear movimiento histórico</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"create icon\">\n</md-icon></md-button><md-button with-permission action=\"setMovementOfEmployee\" access=\"{{F.active.menuItem}}\" \nng-show=\"selected.length==1\" ng-click=\"confirmSetMovement($event,selected)\" \naria-label=\"go to create historic movement\" class=\"md-fab md-raised md-mini md-hue-2\"><md-tooltip md-direction=\"left\">\nEstablecer como ultimo movimiento</md-tooltip><md-icon md-font-icon=\"icon-arrange-bring-forward\" \naria-label=\"set as main movement\"></md-icon></md-button><md-button ng-if=\"selected.length === 0\" with-permission \naction=\"getMovementsImmsEmployees\" access=\"{{F.active.menuItem}}\" ng-click=\"importMovementsEmployees($event)\" \naria-label=\"Sync with GeoVictoria\" class=\"md-fab md-mini\" style=\"background-color: rgb(4, 4, 4)\"><md-tooltip \nmd-direction=\"left\">Importar movientos del imms</md-tooltip><md-icon md-svg-src=\"/assets/icons/historicalMovement.svg\" \naria-label=\" icon-sync\"></md-icon></md-button></md-fab-actions></md-fab-speed-dial></div></div>");
$templateCache.put("app/main/employees/views/personalInfoEmployees/personalInfoEmployee.html","<div id=\"{{F.active.menuObjName}}\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill \nng-controller=\"EmployeeController\"><form name=\"form\" novalidate flex layout=\"column\" ng-disabled=\"F.readMode\">\n<md-toolbar class=\"md-tall header md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" \nlayout=\"row\" layout-align=\"start center\" flex><md-button class=\"goto-button md-icon-button\" \naria-label=\"Go to employees\" ng-click=\"R.goToList(F.active.menuName, F.active.menuParams)\" translate \ntranslate-attr-aria-label=\"EC.GO_TO\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" \nlayout-align=\"start center\"><a class=\"crud-image pointer\" hide-xs ng-click=\"selectedTab = 2\"><img \nng-if=\"employee.avatar\" ng-src=\"{{employee.avatar}}\"> <img ng-if=\"!employee.avatar\" class=\"thumb-image\" \nng-src=\"{{F.imagePlaceholder}}\"></a><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\" ng-if=\"!F.addMode\">\nDatos personales de {{employee.data.name}}</div><div class=\"subtitle secondary-text\"><span ng-if=\"!F.addMode\">\n{{\'EC.DETAIL_OF\' | translate}} Alta</span> <span ng-if=\"F.addMode\">{{\'EC.CREATE\' | translate}} de Empleado</span></div>\n</div></div></div><div><md-button type=\"submit\" ng-if=\"!F.addMode && form.$valid\" with-permission action=\"update\" \naccess=\"{{F.active.menuItem}}\" ng-click=\"saveEmployee(employee)\" ng-hide=\"form.$pristine\" \nng-disabled=\"form.$invalid || form.$pending || loadingProgress || employee.disabled || F.readMode\" \nclass=\"md-raised md-background md-fab md-accent md-hue-1\" aria-label=\"Save employee\"><md-tooltip md-direction=\"left\">\n{{\'EC.SAVE\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-content-save\" aria-label=\"Save\"></md-icon>\n</md-button><validate-form-button></validate-form-button></div></md-toolbar><md-content layout=\"column\" \nclass=\"content\" flex><md-tabs md-selected=\"selectedTab\" flex md-dynamic-height class=\"scrollable\"><md-tab \nlabel=\"Domicilio\"><md-tab-body><div class=\"detail-form-container md-background-bg md-whiteframe-1dp\"><div \nform-location></div></div></md-tab-body></md-tab><md-tab label=\"Extras\"><md-tab-body><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\"><div form-extras></div></div></md-tab-body></md-tab>\n<md-tab label=\"Campos Extras\" ng-if=\"extraFields.length>0\"><md-tab-body><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\"><div form-extra-fields></div></div></md-tab-body>\n</md-tab></md-tabs></md-content></form></div>");
$templateCache.put("app/main/employees/views/personalInfoEmployees/personalInfoEmployees.html","<div id=\"{{F.active.menuName}}\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\"><div \nclass=\"top-bg md-accent-bg\"><div with-permission ng-model=\"haveP\" action=\"saveSimple\" access=\"{{F.active.menuItem}}\">\n</div></div><div class=\"center\" layout=\"column\" flex><div mongo-search-bar></div><div class=\"content-card\" \nlayout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><div list-filters \nfilters-loaded=\"F.filtersLoaded\" ng-model=\"F.filters[F.active.menuName]\" on-change=\"getThem\" \ncolumns-repeat=\"columnsRepeat\" menu-obj-name=\"{{F.active.menuObjName}}\" model-name=\"{{F.active.menuName}}\" \ninit-filters=\"initFilters\"></div><div table-loader array=\"personalInfoEmployees\" validations=\"validations\"></div>\n<md-table-container class=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table \nmd-row-select multiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"personalInfoEmployees.length\"><thead \nmd-head md-order=\"F.orderMongo\" fix-head md-on-reorder=\"getThem\"><tr md-row><th md-column md-order-by=\"rp\"><span>RP\n</span></th><th md-column md-order-by=\"payroll\"><span>Nómina</span></th><th md-column md-order-by=\"data.name\"><span>\nNombre</span></th></tr></thead><tbody md-body><tr md-row \nng-class=\"{\'inactiveEmployee\': employee.movement.type == 2 || employee.status == 5}\" md-auto-select \nmd-select=\"employee\" md-select-id=\"$id\" ng-repeat=\"employee in personalInfoEmployees\"><td md-cell>\n{{employee[\'rp-name\']}}</td><td md-cell>{{employee[\'payroll-name\']}}</td><td md-cell>{{employee.data.name}}</td></tr>\n</tbody></table></md-table-container><md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" \nlayout-xs=\"column\" ng-show=\"personalInfoEmployees.length\" md-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" \nmd-limit-options=\"F.paginations\" md-page=\"currentPage\" md-total=\"{{pagination.total}}\" \nmd-on-paginate=\"getThemPagination\" md-page-select></md-table-pagination></div></div><md-fab-speed-dial \nmd-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\"><md-fab-trigger>\n<md-button aria-label=\"crud menu\" class=\"md-fab md-accent\" md-class=\"{\'md-hue-1\': selected.length}\"><md-icon \nmd-font-icon=\"icon-cube\"></md-icon></md-button></md-fab-trigger><md-fab-actions><md-button with-permission \naction=\"export\" access=\"{{F.active.menuItem}}\" \nng-click=\'exportDataToExcelByQuery(personalInfoEmployees,\"personalInfoEmployees\",getParamsObject(),pagination.total,\"catalogs/employees/collection\")\' \naria-label=\"export\" class=\"md-fab md-raised md-mini md-primary md-hue-2\"><md-tooltip md-direction=\"left\">\nExportar a excel</md-tooltip><md-icon md-font-icon=\"icon-file-excel\" aria-label=\"export icon\"></md-icon></md-button>\n<md-button with-permission action=\"read\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" \nng-click=\'R.goToDetail(null, \"read\", {employeeId: selected[0].$id})\' aria-label=\"view\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Ver</md-tooltip><md-icon \nmd-font-icon=\"icon-eye\" aria-label=\"view\"></md-icon></md-button><md-button with-permission action=\"update\" \naccess=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" \nng-click=\'R.goToDetail(null, \"update\", {employeeId: selected[0].$id,movementId:selected[0].movement.uid})\' \naria-label=\"edit\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">Editar\n</md-tooltip><md-icon md-font-icon=\"icon-pencil\" aria-label=\"edit\"></md-icon></md-button><md-button with-permission \naction=\"remove\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length\" ng-click=\"delete($event)\" aria-label=\"Delete\" \nclass=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">{{\'EC.REMOVE\' | translate}}</md-tooltip>\n<md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button><md-button with-permission \naction=\"create\" access=\"{{F.active.menuItem}}\" ng-if=\"!selected.length\" \nng-click=\'R.goToDetail(null, \"update\", {employeeId: \"new\"})\' aria-label=\"add\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">{{\'EC.ADD\' | translate}}\n</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon></md-button></md-fab-actions>\n</md-fab-speed-dial></div></div>");
$templateCache.put("app/main/employees/views/realSalaryRecords/realSalaryRecords.html","<div id=\"{{F.active.menuName}}\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\" \nng-controller=\"EmployeesMovementsController\"><div class=\"top-bg md-accent-bg\"><div with-permission ng-model=\"haveP\" \naction=\"saveSimple\" access=\"{{F.active.menuItem}}\"></div></div><div class=\"center\" layout=\"column\" flex><div \nmongo-search-bar></div><div class=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" \nlayout=\"column\" flex><div list-filters filters-loaded=\"F.filtersLoaded\" ng-model=\"F.filters[F.active.menuName]\" \non-change=\"getThem\" columns-repeat=\"columnsRepeat\" menu-obj-name=\"{{F.active.menuObjName}}\" \nmodel-name=\"{{F.active.menuName}}\" init-filters=\"initFilters\"></div><div table-loader array=\"realSalaryRecords\" \nvalidations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><form name=\"realSalaryForm\"><table \nmd-table md-row-select multiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"realSalaryRecords.length\"><thead\n md-head md-order=\"F.orderMongo\" fix-head md-on-reorder=\"getThem\"><tr md-row><th md-column \nmd-order-by=\"data.employeeNumber\"><span>No. Empleado</span></th><th md-column md-order-by=\"data.nss\"><span>NSS</span>\n</th><th md-column md-order-by=\"data.name\"><span>Nombre</span></th><th md-column md-order-by=\"data.salary.sd\"><span>SD\n</span></th><th md-column md-order-by=\"data.salary.sbc\"><span>SBC</span></th><th md-column \nmd-order-by=\"data.salary.sdr\"><span>Sueldo Real</span></th></tr></thead><tbody md-body><tr md-row \nng-class=\"{\'inactiveEmployee\': employee.movement.type == 2 || employee.status == 5}\" md-select-id=\"$id\" \nmd-select=\"employee\" ng-repeat=\"employee in realSalaryRecords\"><td md-cell>{{employee.data.employeeNumber}}</td><td \nmd-cell>{{employee.data.nss}}</td><td md-cell>{{employee.data.name}}</td><td md-cell>\n{{employee.data.salary.sd|currency}}</td><td md-cell>{{employee.data.salary.sbc|currency}}</td><td md-cell><div \nlayout=\"row\"><span flex ng-if=\"!employee.editMode\">{{employee.data.salary.sdr | currency : undefined: 5}}</span><div \nflex=\"nogrow\" ng-if=\"haveP\" layout=\"row\"><md-input-container flex class=\"md-block\" ng-if=\"employee.editMode\" \nmd-no-float><input type=\"number\" step=\"any\" min=\"0\" name=\"realSalary{{employee.$id}}\" placeholder=\"Salario Real\" \nng-model=\"employee.data.salary.sdr\"></md-input-container><md-icon flex=\"nogrow\" ng-if=\"!employee.editMode\" \nclass=\"pointer\" md-font-icon=\"icon-pencil\" aria-label=\"pencil\" ng-click=\"employee.editMode=true\"></md-icon><md-icon \nflex=\"nogrow\" ng-if=\'employee.editMode && realSalaryForm[\"realSalary\"+employee.$id].$valid\' class=\"pointer\" \nmd-font-icon=\"icon-content-save\" aria-label=\"save\" \nng-click=\'C.saveSimple(employee.$id, employee.data.salary.sdr, [\"data/salary/sdr\", \"movement/sdr\"],\"employees\",undefined, undefined, undefined, \"catalogs/movements/collection/\"+employee.movement.uid+\"/data/sdr\");employee.editMode=false\'>\n</md-icon><md-icon flex=\"nogrow\" ng-if=\'employee.editMode && realSalaryForm[\"realSalary\"+employee.$id].$invalid\' \nng-disabled=\"realSalaryForm[\'realSalary\'+employee.$id].$invalid\" class=\"pointer grey-300-fg\" \nmd-font-icon=\"icon-content-save\" aria-label=\"save\"></md-icon></div></div></td></tr></tbody></table></form>\n</md-table-container><md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" \nng-show=\"realSalaryRecords.length\" md-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" \nmd-limit-options=\"F.paginations\" md-page=\"$parent.currentPage\" md-total=\"{{pagination.total}}\" \nmd-on-paginate=\"getThemPagination\" md-page-select></md-table-pagination></div></div><md-fab-speed-dial \nmd-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\"><md-fab-trigger>\n<md-button aria-label=\"crud menu\" class=\"md-fab md-accent\" md-class=\"{\'md-hue-1\': selected.length}\"><md-icon \nmd-font-icon=\"icon-cube\"></md-icon></md-button></md-fab-trigger><md-fab-actions><md-button with-permission \naction=\"export\" access=\"{{F.active.menuItem}}\" \nng-click=\'exportDataToExcelByQuery(realSalaryRecords,F.active.menuName,getParamsObject(),pagination.total,\"catalogs/employees/collection\")\' \naria-label=\"export\" class=\"md-fab md-raised md-mini md-primary md-hue-2\"><md-tooltip md-direction=\"left\">\nExportar a excel</md-tooltip><md-icon md-font-icon=\" icon-file-excel\" aria-label=\"export\"></md-icon></md-button>\n<md-button with-permission action=\"read\" access=\"{{F.active.menuItem}}\" ng-show=\"selected.length == 1\" \nng-click=\'R.goToDetail(selected[0], \"read\", {employeeId: selected[0].$id, movementId: selected[0].movement.uid})\' \naria-label=\"Read\" class=\"md-fab md-raised md-primary md-mini\"><md-tooltip md-direction=\"left\">Ver</md-tooltip><md-icon \nmd-font-icon=\"icon-eye\" aria-label=\"read icon\"></md-icon></md-button></md-fab-actions></md-fab-speed-dial></div></div>");
$templateCache.put("app/main/employees/views/realSalaryRecords/realSalaryRecords_old.html","<div id=\"{{F.active.menuName}}\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\" \nng-controller=\"EmployeesMovementsController\"><div class=\"top-bg md-accent-bg\"><div with-permission ng-model=\"haveP\" \naction=\"saveSimple\" access=\"{{F.active.menuItem}}\"></div></div><div class=\"center\" layout=\"column\" flex><div \nfb-search-bar></div><div class=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" \nlayout=\"column\" flex><div filter-toolbar></div><div table-loader array=\"employees\" validations=\"validations\"></div>\n<md-table-container class=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table \nmd-row-select multiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"employees.length\"><thead md-head \nmd-order=\"F.orderMongo\" fix-head md-on-reorder=\"getThem\"><tr md-row><th md-column md-order-by=\"data.employeeNumber\">\n<span>No. Empleado</span></th><th md-column md-order-by=\"data.nss\"><span>NSS</span></th><th md-column \nmd-order-by=\"data.name\"><span>Nombre</span></th><th md-column md-order-by=\"data.salary.sd\"><span>SD</span></th><th \nmd-column md-order-by=\"data.salary.sbc\"><span>SBC</span></th><th md-column md-order-by=\"data.salary.sdr\"><span>\nSueldo Real</span></th></tr></thead><tbody md-body><tr md-row \nng-class=\"{\'inactiveEmployee\': employee.movement.type == 2 || employee.status == 5}\" ng-repeat=\"employee in employees\">\n<td md-cell>{{employee.data.employeeNumber}}</td><td md-cell>{{employee.data.nss}}</td><td md-cell>\n{{employee.data.name}}</td><td md-cell>{{employee.data.salary.sd | currency}}</td><td md-cell>\n{{employee.data.salary.sbc | currency}}</td><td md-cell><md-input-container md-no-float \nng-if=\"haveP && !employee.data.salary.sdr\"><md-form name=\"realSalaryForm\"><input type=\"number\" step=\"any\" \nname=\"realSalary\" placeholder=\"Salario Real\" ng-model=\"employee.data.salary.sdr\" \nng-model-options=\"{ debounce: F.debounceTime*2 }\" \nng-change=\'C.saveSimple(employee.$id, employee.data.salary.sdr, [\"data/salary/sdr\", \"movement/sdr\"],\"employees\",undefined, undefined, undefined, \"catalogs/movements/collection/\"+employee.movement.uid+\"/data/sdr\")\'>\n</md-form></md-input-container><span ng-if=\"!haveP||employee.data.salary.sdr\">\n{{employee.data.salary.sdr | currency:undefined:5}} <span class=\"righted pointer\"><md-icon ng-if=\"haveP\" \nmd-font-icon=\"icon-reload\" aria-label=\"reload\" ng-click=\"employee.data.salary.sdr = null\"></md-icon></span></span></td>\n</tr></tbody></table></md-table-container><md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" \nlayout-xs=\"column\" ng-show=\"employees.length\" md-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" \nmd-limit-options=\"F.paginations\" md-page=\"F.currentPageMongo\" md-total=\"{{pagination.total}}\" \nmd-on-paginate=\"getThemPagination\" md-page-select></md-table-pagination></div></div><md-fab-speed-dial \nmd-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\"><md-fab-trigger>\n<md-button aria-label=\"crud menu\" class=\"md-fab md-accent\" md-class=\"{\'md-hue-1\': selected.length}\"><md-icon \nmd-font-icon=\"icon-cube\"></md-icon></md-button></md-fab-trigger><md-fab-actions><md-button with-permission \naction=\"export\" access=\"{{F.active.menuItem}}\" \nng-click=\'exportDataToExcelByQuery(Z[F.active.menuName],F.active.menuName,getQuerys(),pagination.total,\"catalogs/employees/collection\")\' \naria-label=\"export\" class=\"md-fab md-raised md-mini md-primary md-hue-2\"><md-tooltip md-direction=\"left\">\nExportar a excel</md-tooltip><md-icon md-font-icon=\" icon-file-excel\" aria-label=\"export\"></md-icon></md-button>\n<md-button with-permission action=\"read\" access=\"{{F.active.menuItem}}\" ng-show=\"selected.length == 1\" \nng-click=\'R.goToDetail(selected[0], \"read\", {employeeId: selected[0].$id, movementId: selected[0].movement.uid})\' \naria-label=\"Read\" class=\"md-fab md-raised md-primary md-mini\"><md-tooltip md-direction=\"left\">Ver</md-tooltip><md-icon \nmd-font-icon=\"icon-eye\" aria-label=\"read icon\"></md-icon></md-button></md-fab-actions></md-fab-speed-dial></div></div>");
$templateCache.put("app/main/employees/views/revisions/revision.html","<div id=\"{{F.active.menuObjName}}\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill \nng-controller=\"RevisionController\"><form name=\"form\" novalidate flex layout=\"column\" ng-disabled=\"F.readMode\">\n<md-toolbar class=\"md-tall header md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" \nlayout=\"row\" layout-align=\"start center\" flex><md-button class=\"goto-button md-icon-button\" with-permission \naccess=\"{{F.active.menuItem}}\" action=\"access\" aria-label=\"Go to list\" ng-click=\"goToList()\" translate \ntranslate-attr-aria-label=\"EC.GO_TO\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" \nlayout-align=\"start center\"><a class=\"crud-image pointer\" hide-xs ng-click=\"selectedTab = 2\"><img \nng-if=\"employee.avatar\" ng-src=\"{{employee.avatar}}\"> <img ng-if=\"!employee.avatar\" class=\"thumb-image\" \nng-src=\"{{F.imagePlaceholder}}\"></a><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\">\nRevisión de {{employee.data.name}}</div><div class=\"subtitle secondary-text\"><span>\nMovimiento de {{employee.movement.type | typeName | capitalize}}</span></div></div></div></div><div><md-button \nng-click=\"save(employee)\" with-permission action=\"update\" access=\"{{F.active.menuItem}}\" \nng-disabled=\"form.$invalid || loadingProgress\" class=\"md-raised md-background md-fab md-accent md-hue-1\" \naria-label=\"Save employee\"><md-tooltip md-direction=\"left\">{{\'EC.SAVE\' | translate}}</md-tooltip><md-icon \nmd-font-icon=\"icon-content-save\" aria-label=\"Save\"></md-icon></md-button><md-button type=\"submit\" ng-if=\"form.$valid\" \nng-click=\"approve(employee, movement)\" with-permission action=\"review\" access=\"{{F.active.menuItem}}\" \nng-disabled=\"form.$invalid || form.$pending || loadingProgress\" \nclass=\"md-raised md-background md-fab md-accent md-hue-1\" aria-label=\"Review employee\"><md-tooltip md-direction=\"left\">\nAprobar Revisión</md-tooltip><md-icon md-font-icon=\"icon-clipboard-check\" aria-label=\"Approve\"></md-icon></md-button>\n<validate-form-button></validate-form-button></div></md-toolbar><md-content layout=\"column\" class=\"content\" flex><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\" layout=\"column\" ng-if=\"employee.movement.type == 7\">\n<div form-mds></div></div><div class=\"detail-form-container md-background-bg md-whiteframe-1dp\" layout=\"column\" \nng-if=\"employee.movement.type == 2\"><div form-dismiss></div></div><md-tabs md-selected=\"selectedTab\" flex \nmd-dynamic-height layout-fill ng-if=\"employee.movement.type == 6 || employee.movement.type == 8\" class=\"scrollable\">\n<md-tab label=\"Info\"><md-tab-body><div class=\"detail-form-container md-background-bg md-whiteframe-1dp\" \nlayout=\"column\"><div form-info></div></div></md-tab-body></md-tab><md-tab label=\"CFDI 4.0\"><md-tab-body><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\" flex layout-fill layout=\"column\"><div form-sat></div>\n</div></md-tab-body></md-tab><md-tab label=\"Otros\"><md-tab-body><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\" flex layout-fill=\"column\"><div form-worker></div>\n</div></md-tab-body></md-tab><md-tab label=\"Beneficios\"><md-tab-body><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\"><div form-benefits-employee></div></div></md-tab-body>\n</md-tab><md-tab label=\"Salarios\"><md-tab-body><div class=\"detail-form-container md-background-bg md-whiteframe-1dp\" \nlayout=\"column\"><div form-salaries></div><div form-revision-enrole></div></div></md-tab-body></md-tab><md-tab \nlabel=\"Servicios especializados\" ng-if=\"L[\'companiesOf-\'+employee.rp] && L[\'companiesOf-\'+employee.rp].length>1\">\n<md-tab-body><div class=\"detail-form-container md-background-bg md-whiteframe-1dp\"><div form-special-services></div>\n</div></md-tab-body></md-tab><md-tab label=\"Campos Extras\" ng-if=\"extraFields.length>0\"><md-tab-body><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\"><div form-extra-fields></div></div></md-tab-body>\n</md-tab></md-tabs></md-content></form></div>");
$templateCache.put("app/main/employees/views/revisions/revisions.html","<div id=\"{{F.active.menuName}}\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\" \nng-controller=\"EmployeesMovementsController\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" \nlayout=\"column\" flex><div fb-search-bar></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><div filter-toolbar></div><div table-loader \narray=\"Z[F.active.menuName]\" validations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"F.filteredItems.length\"><thead md-head \nmd-order=\"order\" fix-head><tr md-row><th md-column md-order-by=\"payroll\"><span>Nómina</span></th><th md-column \nmd-order-by=\"data.nss\"><span>NSS</span></th><th md-column md-order-by=\"data.name\"><span>Nombre</span></th><th \nmd-column md-order-by=\"movement.date\"><span>Fecha</span></th><th md-column md-order-by=\"movement.type\"><span>Mvto\n</span></th></tr></thead><tbody md-body><tr md-row md-auto-select md-select=\"employee\" md-select-id=\"$id\" \nng-repeat=\"employee in (F.filteredItems = (Z[F.active.menuName] | filter:F.searchText[F.active.menuObjName] | orderBy:order)) | limitTo: F.paginate: (currentPage - 1) * F.paginate\">\n<td md-cell>{{employee.payroll | nameOfL:L.allPayrolls}}</td><td md-cell>{{employee.data.nss}}</td><td md-cell>\n{{employee.data.name}}</td><td md-cell>{{employee.movement.date| date:F.dateFormat}}</td><td md-cell>\n{{employee.movement.type | typeName}}</td></tr></tbody></table></md-table-container><md-table-pagination \nlayout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" ng-show=\"F.filteredItems.length\" \nmd-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" md-limit-options=\"F.paginations\" md-page=\"currentPage\" \nmd-on-paginate=\"restartSelected\" md-total=\"{{F.filteredItems.length}}\" md-page-select></md-table-pagination></div>\n</div><md-fab-speed-dial md-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" \nclass=\"ms2-speed-dial bottom right\"><md-fab-trigger><md-button aria-label=\"crud menu\" class=\"md-fab md-accent\" \nmd-class=\"{\'md-hue-1\': selected.length}\"><md-icon md-font-icon=\"icon-cube\"></md-icon></md-button></md-fab-trigger>\n<md-fab-actions><md-button with-permission action=\"export\" access=\"{{F.active.menuItem}}\" \nng-click=\"exportDataToExcel(F.filteredItems,F.active.menuName,currentPage,F.paginate)\" aria-label=\"export\" \nclass=\"md-fab md-raised md-mini md-primary md-hue-2\"><md-tooltip md-direction=\"left\">Exportar a excel</md-tooltip>\n<md-icon md-font-icon=\" icon-file-excel\" aria-label=\"export\"></md-icon></md-button><md-button with-permission \naction=\"review\" access=\"{{F.active.menuItem}}\" ng-show=\"selected.length == 1\" \nng-click=\'R.goToDetail(selected[0], \"review\", {movementId: selected[0].movement.uid, employeeId: selected[0].$id})\' \naria-label=\"review movement\" class=\"md-fab md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">\nRevisar Movimiento</md-tooltip><md-icon md-font-icon=\"icon-account-check\" aria-label=\"review\"></md-icon></md-button>\n<md-button with-permission action=\"cancelMovement\" access=\"{{F.active.menuItem}}\" ng-show=\"selected.length == 1\" \nng-click=\"cancelLastMovement($event)\" aria-label=\"cancel last movement\" class=\"md-fab md-mini md-warn md-hue-2\">\n<md-tooltip md-direction=\"left\">Cancelar Último Movimiento</md-tooltip><md-icon md-font-icon=\"icon-close\" \naria-label=\"cancel\"></md-icon></md-button></md-fab-actions></md-fab-speed-dial></div></div>");
$templateCache.put("app/main/employees/views/saludRecords/saludRecord.html","<div id=\"saludRecord\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill><form name=\"form\" \nnovalidate flex layout=\"column\" ng-disabled=\"F.readMode\"><div mongo-crud-detail-bar flex=\"nogrow\"></div><md-content \nlayout=\"column\" class=\"content\" flex><div class=\"detail-form-container md-background-bg md-whiteframe-1dp\"><document \ndocument=\"saludRecord\" form=\"form\" mobject-loaded=\"mainObjectLoaded\"></document></div></md-content></form></div>");
$templateCache.put("app/main/employees/views/saludRecords/saludRecords.html","<div id=\"saludRecords\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div mongo-search-bar></div><div class=\"content-card\" layout=\"column\" \nflex><div class=\"content fullpage-datatable\" layout=\"column\" flex><div table-loader array=\"saludRecords\" \nvalidations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"saludRecords.length\"><thead md-head \nmd-order=\"F.orderMongo\" fix-head md-on-reorder=\"getThem\"><tr md-row><th md-column md-order-by=\"employee-name\"><span>\nEmpleado</span></th><th md-column md-order-by=\"payroll-name\"><span>Nomina</span></th><th md-column \nmd-order-by=\"starDate\"><span>Inicio</span></th><th md-column md-order-by=\"type\"><span>Tipo de contrato</span></th></tr>\n</thead><tbody md-body><tr md-row md-auto-select md-select=\"saludRecord\" md-select-id=\"_id\" \nng-repeat=\"saludRecord in saludRecords\"><td md-cell>{{saludRecord[\"employee-name\"]}}</td><td md-cell>\n{{saludRecord[\"payroll-name\"]}}</td><td md-cell>{{saludRecord.startDate | date:F.dateFormat}}</td><td md-cell>\n{{saludRecord.documentType | nameOfM : M.documentTypes}}</td></tr></tbody></table></md-table-container>\n<md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" ng-show=\"saludRecords.length\" \nmd-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" md-limit-options=\"F.paginations\" md-page=\"currentPage\" \nmd-total=\"{{pagination.total}}\" md-on-paginate=\"getThemPagination\" md-page-select></md-table-pagination></div></div>\n<md-fab-speed-dial md-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" \nclass=\"ms2-speed-dial bottom right\"><md-fab-trigger><md-button aria-label=\"crud menu\" \nclass=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon></md-button></md-fab-trigger>\n<md-fab-actions><md-button with-permission action=\"update\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" \nng-click=\"R.goToDetail(selected[0])\" aria-label=\"edit\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip \nmd-direction=\"left\">Editar</md-tooltip><md-icon md-font-icon=\"icon-pencil\" aria-label=\"edit\"></md-icon></md-button>\n<md-button with-permission action=\"remove\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length\" \nng-click=\"delete($event)\" aria-label=\"Delete\" class=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">\n{{\'EC.REMOVE\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button>\n<md-button with-permission action=\"create\" access=\"{{F.active.menuItem}}\" ng-if=\"!selected.length\" \nng-click=\'R.goToDetail(\"new\")\' aria-label=\"add\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip \nmd-direction=\"left\">{{\'EC.ADD\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon>\n</md-button><md-button access=\"{{F.active.menuItem}}\" ng-show=\"selected.length == 1\" \nng-click=\'showDocument(selected[0]._id,\"show\")\' aria-label=\"Read\" class=\"md-fab md-raised md-primary md-mini\">\n<md-tooltip md-direction=\"left\">Ver Contrato</md-tooltip><md-icon md-font-icon=\"icon-book-open\" aria-label=\"read icon\">\n</md-icon></md-button><md-button access=\"{{F.active.menuItem}}\" ng-show=\"selected.length == 1 && !selected[0].signed\" \nng-click=\'showDocument(selected[0]._id,\"sign\")\' aria-label=\"Read\" class=\"md-fab md-raised md-primary md-mini\">\n<md-tooltip md-direction=\"left\">Firmar contrato</md-tooltip><md-icon md-font-icon=\"icon-check\" aria-label=\"read icon\">\n</md-icon></md-button></md-fab-actions></md-fab-speed-dial></div></div>");
$templateCache.put("app/main/employees/views/variables/variables.html","<div id=\"{{F.active.menuName}}\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\" \nng-controller=\"EmployeesMovementsController\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" \nlayout=\"column\" flex><div fb-search-bar></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><div filter-toolbar></div><div table-loader \narray=\"Z[F.active.menuName]\" validations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"F.filteredItems.length\"><thead md-head \nmd-order=\"order\" fix-head><tr md-row><th md-column md-order-by=\"rp\"><span>RP</span></th><th md-column \nmd-order-by=\"payroll\"><span>Nómina</span></th><th md-column md-order-by=\"data.nss\"><span>NSS</span></th><th md-column \nmd-order-by=\"data.name\"><span>Nombre</span></th><th md-column md-order-by=\"movement.sd\"><span>SD</span></th><th \nmd-column md-order-by=\"movement.sbc\"><span>SBC</span></th><th md-column md-order-by=\"data.mdsDate\"><span>MDS</span>\n</th><th md-column md-order-by=\"movement.salaryType\"><span>Tipo de Salario</span></th></tr></thead><tbody md-body><tr \nmd-row md-auto-select md-select=\"employee\" md-select-id=\"$id\" \nng-repeat=\"employee in (F.filteredItems = (Z[F.active.menuName] | filter:F.searchText[F.active.menuObjName] | orderBy:order)) | limitTo: F.paginate: (currentPage - 1) * F.paginate\">\n<td md-cell>{{employee.rp | nameOfL:L.rps}}</td><td md-cell>{{employee.payroll | nameOfL:L.allPayrolls}}</td><td \nmd-cell>{{employee.data.nss}}</td><td md-cell>{{employee.data.name}}</td><td md-cell>\n{{employee.movement.oldSd | currency}} > {{employee.data.salary.sd | currency}}</td><td md-cell>\n{{employee.movement.oldSbc | currency}} > {{employee.data.salary.sbc | currency}}</td><td md-cell>\n{{employee.movement.date | date:\'dd/MM/yyyy\'}}</td><td md-cell>\n{{employee.movement.salaryType | getSomethingOfArrayM:M.salaryTypes:\'name\':\'N/A\':\'humansiteCode\'}}</td></tr></tbody>\n</table></md-table-container><md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" \nng-show=\"F.filteredItems.length\" md-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" \nmd-limit-options=\"F.paginations\" md-page=\"currentPage\" md-on-paginate=\"restartSelected\" \nmd-total=\"{{F.filteredItems.length}}\" md-page-select></md-table-pagination></div></div><md-fab-speed-dial \nmd-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\"><md-fab-trigger>\n<md-button aria-label=\"crud menu\" class=\"md-fab md-accent\" md-class=\"{\'md-hue-1\': selected.length}\"><md-icon \nmd-font-icon=\"icon-cube\"></md-icon></md-button></md-fab-trigger><md-fab-actions><md-button with-permission \naction=\"getSua\" access=\"{{F.active.menuItem}}\" ng-show=\"selected.length\" ng-click=\'getInterface(\"sua\")\' \naria-label=\"getSua\" class=\"md-fab md-raised md-mini md-primary md-hue-3\"><md-tooltip md-direction=\"left\">\nLayout Variable</md-tooltip><md-icon md-svg-src=\"/assets/icons/SUA.svg\" aria-label=\"sua\"></md-icon></md-button>\n<md-button with-permission action=\"getIdse\" access=\"{{F.active.menuItem}}\" ng-show=\"selected.length\" \nng-click=\'getInterface(\"idse\")\' aria-label=\"getIdse\" class=\"md-fab md-raised md-mini md-primary md-hue-3\"><md-tooltip \nmd-direction=\"left\">IDSE</md-tooltip><md-icon md-svg-src=\"/assets/icons/IDSE.svg\" aria-label=\"idse\"></md-icon>\n</md-button><md-button with-permission action=\"sendToIdse\" access=\"{{F.active.menuItem}}\" ng-show=\"selected.length\" \nng-click=\"moveEmployees($event, 3)\" aria-label=\"moveEmployees\" class=\"md-fab md-raised md-mini md-accent md-hue-2\">\n<md-tooltip md-direction=\"left\">Mandar a IDSE</md-tooltip><md-icon \nmd-font-icon=\"icon-arrow-right-bold-hexagon-outline\" aria-label=\"move\"></md-icon></md-button><md-button \nwith-permission action=\"importVariables\" access=\"{{F.active.menuItem}}\" ng-show=\"!selected.length\" \nng-click=\"importVariablesModal($event)\" aria-label=\"importVariables\" \nclass=\"md-fab md-raised md-mini md-primary md-hue-3\"><md-tooltip md-direction=\"left\">Importar Variables</md-tooltip>\n<md-icon md-font-icon=\"icon-import\" aria-label=\"import variables\"></md-icon></md-button><md-button with-permission \naction=\"read\" access=\"{{F.active.menuItem}}\" ng-show=\"selected.length == 1\" \nng-click=\'R.goToDetail(selected[0], \"read\", {employeeId: selected[0].$id, movementId: selected[0].movement.uid})\' \naria-label=\"Read\" class=\"md-fab md-raised md-primary md-mini\"><md-tooltip md-direction=\"left\">Ver</md-tooltip><md-icon \nmd-font-icon=\"icon-eye\" aria-label=\"read icon\"></md-icon></md-button><md-button with-permission \naction=\"cancelVariables\" access=\"{{F.active.menuItem}}\" ng-show=\"selected.length\" ng-click=\"cancelVariables($event)\" \naria-label=\"cancel last movement\" class=\"md-fab md-mini md-warn md-hue-2\"><md-tooltip md-direction=\"left\">\nCancelar Variable</md-tooltip><md-icon md-font-icon=\"icon-close\" aria-label=\"cancel\"></md-icon></md-button>\n</md-fab-actions></md-fab-speed-dial></div></div>");
$templateCache.put("app/main/pages/auth/forgot-password/forgot-password.html","<div id=\"forgot-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div class=\"background-image\"></div><div \nid=\"forgot-password-form-wrapper\" layout=\"column\" layout-align=\"center center\"><div id=\"forgot-password-form\" \nclass=\"md-whiteframe-8dp\"><div class=\"logo\"><img ng-src=\"{{F.centerData.loadingBar || \'logo_tds.png\'}}\" \nalt=\"{{F.centerData.loadingText || \'TDSystem Software\'}}\"></div><div class=\"title\" translate=\"FORGOTPASSWORD.TITLE\">\nRecover your password</div><form name=\"forgotPasswordForm\" novalidate><md-input-container class=\"md-block\" md-no-float>\n<input type=\"email\" name=\"email\" ng-model=\"vm.email\" placeholder=\"Email address\" translate \ntranslate-attr-placeholder=\"FORGOTPASSWORD.EMAIL_ADRESS\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"forgotPasswordForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"FORGOTPASSWORD.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span \ntranslate=\"FORGOTPASSWORD.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div></div>\n</md-input-container><md-button type=\"submit\" class=\"md-raised md-accent submit-button resetButton\" \naria-label=\"RESET MY PASSWORD\" ng-disabled=\"forgotPasswordForm.$invalid || forgotPasswordForm.$pristine\" \ntranslate=\"FORGOTPASSWORD.SEND_RESET_LINK\" translate-attr-aria-label=\"FORGOTPASSWORD.SEND_RESET_LINK\" \nng-click=\"sendResetPassword(vm.email)\">SEND RESET LINK</md-button></form><div class=\"login\" layout=\"row\" \nlayout-align=\"center center\"><a class=\"link\" ui-sref=\"app.pages_auth_login\" translate=\"FORGOTPASSWORD.GO_BACK\">\nGo back to login</a></div></div></div></div>");
$templateCache.put("app/main/pages/auth/lock/lock.html","<div id=\"lock\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"lock-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"lock-form\" class=\"md-whiteframe-8dp\"><div layout=\"row\" \nlayout-align=\"start center\" layout-sm=\"column\" layout-align-sm=\"center center\"><div class=\"avatar-container\"><img \nclass=\"avatar big\" src=\"assets/images/avatars/katherine.jpg\"><md-icon md-font-icon=\"icon-lock\" \nclass=\"md-warn-fg s36 md-hue-2\"></md-icon></div><div flex layout=\"column\" layout-align=\"start\" \nlayout-align-sm=\"center center\"><div class=\"title\" translate=\"LOCK.TITLE\">Your session is locked</div><div \nclass=\"subtitle\" translate=\"LOCK.SUBTITLE\">Due to inactivity, your session is locked. Enter your password to continue.\n</div></div></div><form name=\"lockForm\" novalidate ng-submit=\"login()\"><md-input-container class=\"md-block\" \nmd-no-float><input ng-model=\"form.username\" placeholder=\"Username\" translate \ntranslate-attr-placeholder=\"LOCK.USERNAME\" disabled=\"disabled\"></md-input-container><md-input-container \nclass=\"md-block\" md-no-float><input type=\"password\" name=\"password\" ng-model=\"form.password\" placeholder=\"Password\" \ntranslate translate-attr-placeholder=\"LOCK.PASSWORD\" required><div ng-messages=\"lockForm.password.$error\" role=\"alert\">\n<div ng-message=\"required\"><span translate=\"LOCK.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div>\n</div></md-input-container><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"UNLOCK\" \nng-disabled=\"lockForm.$invalid || lockForm.$pristine\" translate=\"LOCK.UNLOCK\" translate-attr-aria-label=\"LOCK.UNLOCK\">\nUNLOCK</md-button></form><div class=\"message\"><a ui-sref=\"app.pages_auth_login\" class=\"md-accent-color\"><span \ntranslate=\"LOCK.ARE_YOU_NOT\">Are you not</span><span> {{F.userBlocked.name}}</span></a></div></div></div></div>");
$templateCache.put("app/main/pages/auth/login/login.html","<div id=\"login-v2\" layout=\"row\" layout-align=\"start\"><video class=\"introVideo\" ng-if=\"F.centerData.introVideo\" \ndata-aid=\"HEADER_VIDEO\" type=\"video/mp4\" autoplay=\"\" loop=\"\" muted=\"\" playsinline=\"\" \nng-src=\"{{F.centerData.introVideo}}\"></video><div id=\"login-v2-intro\" flex hide show-gt-sm \nstyle=\"background: url(\'{{F.centerData.background_image || \'/assets/images/backgrounds/login.jpg\'}}\') no-repeat center center;background-size: cover\">\n<div class=\"title\" translate=\"LOGIN.INTRO_TITLE\" style=\"color:{{F.centerData.welcome_color || \'black\'}}\">\nTDSystem Software le da la bienvenida</div></div><div id=\"login-v2-form-wrapper\" \nclass=\"flex-scrollable md-whiteframe-8dp\" ms-scroll><div id=\"login-v2-form\"><div class=\"logo\"><img \nng-src=\"{{F.centerData.logo || \'logo_tds.png\'}}\" alt=\"{{F.centerData.loadingText || \'TDSystem Software\'}}\"></div><div \nclass=\"title\" translate=\"LOGIN.TITLE\">Log in to your account</div><form name=\"loginForm\" novalidate \nng-submit=\"login()\"><md-input-container class=\"md-block\"><label translate=\"LOGIN.EMAIL\"></label><input type=\"email\" \nname=\"email\" ng-model=\"credentials.email\" placeholder=\"Email\" translate \ntranslate-attr-placeholder=\"LOGIN.INSERT_EMAIL\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"loginForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"LOGIN.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span \ntranslate=\"LOGIN.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div></div></md-input-container>\n<md-input-container class=\"md-block\"><label translate=\"LOGIN.PASSWORD\"></label><input type=\"password\" name=\"password\" \nng-model=\"credentials.password\" placeholder=\"Password\" translate translate-attr-placeholder=\"LOGIN.INSERT_PASSWORD\" \nrequired><div ng-messages=\"loginForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"LOGIN.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div></md-input-container><div \nclass=\"remember-forgot-password\" layout=\"row\" layout-sm=\"column\" layout-align=\"space-between center\"><md-checkbox \nclass=\"remember-me\" ng-model=\"rememberUser\" aria-label=\"Remember Me\"><span translate=\"LOGIN.REMEMBER_ME\">Remember Me\n</span></md-checkbox><a ui-sref=\"app.pages_auth_forgot-password\" class=\"forgot-password md-accent-color\" \ntranslate=\"LOGIN.FORGOT_PASSWORD\">Forgot Password?</a></div><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" aria-label=\"LOG IN\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\" \ntranslate=\"LOGIN.LOG_IN\" translate-attr-aria-label=\"LOGIN.LOG_IN\">LOG IN</md-button></form><div layout=\"row\" \nlayout-align=\"center center\"><md-progress-circular ng-show=\"loading\" class=\"md-accent md-hue-1\" md-diameter=\"80px\">\n</md-progress-circular></div></div></div></div>");
$templateCache.put("app/main/pages/auth/register/register.html","<div id=\"register-v2\" layout=\"row\" layout-align=\"start\"><div id=\"register-v2-intro\" flex hide show-gt-sm><div \nclass=\"logo md-accent-bg\"><span>TDSystem Software</span></div><div class=\"title\" translate=\"REGISTER_V2.INTRO_TITLE\">\nWelcome to TDSystem Software!</div><div class=\"description\" translate=\"REGISTER_V2.INTRO_DESCRIPTION\">\nLorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus ullamcorper nisl erat, vel convallis elit fermentum pellentesque. Sed mollis velit facilisis facilisis viverra.\n</div></div><div id=\"register-v2-form-wrapper\" class=\"flex-scrollable md-whiteframe-8dp\" layout=\"column\" flex \nms-scroll><div id=\"register-v2-form\"><div class=\"logo md-accent-bg\" hide-gt-sm><span>F</span></div><div class=\"title\" \ntranslate=\"REGISTER_V2.TITLE\">Create an account</div><div class=\"description\" translate=\"REGISTER_V2.DESCRIPTION\">\nSed mollis velit facilisis facilisis viverra</div><form name=\"registerForm\" novalidate><md-input-container \nclass=\"md-block\" md-no-float><input name=\"username\" ng-model=\"form.username\" placeholder=\"Name\" translate \ntranslate-attr-placeholder=\"REGISTER_V2.NAME\" required><div ng-messages=\"registerForm.username.$error\" role=\"alert\">\n<div ng-message=\"required\"><span translate=\"REGISTER_V2.ERRORS.USERNAME_REQUIRED\">Username field is required</span>\n</div></div></md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"email\" name=\"email\" \nng-model=\"form.email\" placeholder=\"Email\" translate translate-attr-placeholder=\"REGISTER_V2.EMAIL\" \nng-pattern=\"/^.+@.+\\..+$/\" required><div ng-messages=\"registerForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span translate=\"REGISTER_V2.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div \nng-message=\"pattern\"><span translate=\"REGISTER_V2.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span>\n</div></div></md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"password\" \nname=\"password\" ng-model=\"form.password\" placeholder=\"Password\" translate \ntranslate-attr-placeholder=\"REGISTER_V2.PASSWORD\" required><div ng-messages=\"registerForm.password.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"REGISTER_V2.ERRORS.PASSWORD_REQUIRED\">\nPassword field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float>\n<input type=\"password\" name=\"passwordConfirm\" ng-model=\"form.passwordConfirm\" placeholder=\"Password (Confirm)\" \ntranslate translate-attr-placeholder=\"REGISTER_V2.PASSWORD_CONFIRM\" required><div \nng-messages=\"registerForm.passwordConfirm.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"REGISTER_V2.ERRORS.PASSWORD_CONFIRM_REQUIRED\">Password (Confirm) field is required</span></div></div>\n</md-input-container><div class=\"terms\" layout=\"row\" layout-align=\"center center\"><md-checkbox name=\"terms\" \nng-model=\"data.cb1\" aria-label=\"I read and accept\" required></md-checkbox><div layout=\"row\" layout-sm=\"column\" \nlayout-align=\"start center\"><span translate=\"REGISTER_V2.READ_ACCEPT\">I read and accept</span> <a href=\"#\" \nclass=\"md-accent-color\" translate=\"REGISTER_V2.TERMS_COND\">terms and conditions</a></div></div><md-button \ntype=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"CREATE MY ACCOUNT\" \nng-disabled=\"registerForm.$invalid || registerForm.$pristine\" translate=\"REGISTER_V2.CREATE_ACCOUNT\" \ntranslate-attr-aria-label=\"REGISTER_V2.CREATE_ACCOUNT\">CREATE MY ACCOUNT</md-button></form><div class=\"login\" \nlayout=\"row\" layout-sm=\"column\" layout-align=\"center center\"><span class=\"text\" translate=\"REGISTER_V2.ALREADY_HAVE\">\nAlready have an account?</span> <a class=\"link\" ui-sref=\"app.pages_auth_login\" translate=\"REGISTER_V2.LOGIN\">Log in</a>\n</div></div></div></div>");
$templateCache.put("app/main/pages/auth/reset-password/reset-password.html","<div id=\"reset-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"reset-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"reset-password-form\" class=\"md-whiteframe-8dp\"><div \nclass=\"logo md-accent-bg\"><span>F</span></div><div class=\"title\" translate=\"RESETPASSWORD.TITLE\">Reset your password\n</div><form name=\"resetPasswordForm\" novalidate><md-input-container class=\"md-block\" md-no-float><input type=\"email\" \nname=\"email\" ng-model=\"form.email\" placeholder=\"Email address\" translate \ntranslate-attr-placeholder=\"RESETPASSWORD.EMAIL_ADRESS\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"resetPasswordForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"RESETPASSWORD.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span \ntranslate=\"RESETPASSWORD.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"password\" \nng-model=\"form.password\" placeholder=\"Password\" translate translate-attr-placeholder=\"RESETPASSWORD.PASSWORD\" required>\n<div ng-messages=\"registerForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"RESETPASSWORD.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"passwordConfirm\" \nng-model=\"form.passwordConfirm\" placeholder=\"Password (Confirm)\" translate \ntranslate-attr-placeholder=\"RESETPASSWORD.PASSWORD_CONFIRM\" required><div \nng-messages=\"resetPasswordForm.passwordConfirm.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"RESETPASSWORD.ERRORS.PASSWORD_CONFIRM_REQUIRED\">Password (Confirm) field is required</span></div></div>\n</md-input-container><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" \naria-label=\"UPDATE MY PASSWORD\" ng-disabled=\"resetPasswordForm.$invalid || resetPasswordForm.$pristine\" \ntranslate=\"RESETPASSWORD.UPDATE_PASSWORD\" translate-attr-aria-label=\"RESETPASSWORD.UPDATE_PASSWORD\">RESET MY PASSWORD\n</md-button></form></div></div></div>");
$templateCache.put("app/main/pages/auth/token-login/token-login.html","<div id=\"token-login\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div class=\"background-image\"></div><div \nid=\"forgot-password-form-wrapper\" layout=\"column\" layout-align=\"center center\"><div id=\"forgot-password-form\"><div \nclass=\"logo\"><img ng-src=\"{{F.centerData.loadingBar || \'logo_tds.png\'}}\" \nalt=\"{{F.centerData.loadingText || \'TDSystem Software\'}}\"></div></div></div></div>");
$templateCache.put("app/main/pages/errors/404/error-404.html","<div id=\"error-404\" layout=\"column\" layout-align=\"center center\"><div class=\"content\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"error-code\" translate=\"ERROR404.CODE\">404</div><div class=\"message\" \ntranslate=\"ERROR404.MESSAGE\">Sorry but we couldn’t find the page you are looking for</div><div \nclass=\"search md-whiteframe-1dp\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"icon s24\"></md-icon><input ng-model=\"search\" type=\"text\" placeholder=\"Search for anything\" translate \ntranslate-attr-placeholder=\"ERROR404.SEARCH\" flex></div><a class=\"back-link md-accent-color\" href=\"/\" \ntranslate=\"ERROR404.GO_BACK\">Go back to dashboard</a></div></div>");
$templateCache.put("app/main/pages/errors/500/error-500.html","<div id=\"error-500\" layout=\"column\" layout-align=\"center center\"><div class=\"content\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"error-code\" translate=\"ERROR500.CODE\">500</div><div class=\"message\" \ntranslate=\"ERROR500.MESSAGE\">Well, you broke the internet!</div><div class=\"sub-message\" \ntranslate=\"ERROR500.SUBMESSAGE\">Just kidding, looks like we have an internal issue, please try again in couple minutes\n</div><a class=\"report-link md-accent-color\" href=\"/\" translate=\"ERROR500.REPORT\">Report this problem</a></div></div>");
$templateCache.put("app/main/pages/errors/403/error-403.html","<div id=\"error-404\" layout=\"column\" layout-align=\"center center\"><div class=\"content\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"error-code\" translate=\"ERROR403.CODE\">403</div><div class=\"message\" \ntranslate=\"ERROR403.MESSAGE\">No tiene permiso suficiente para acceder a esta ruta.</div><a \nclass=\"back-link md-accent-color\" ng-click=\"R.back()\">Regresar</a></div></div>");
$templateCache.put("app/main/system/views/actions/action.html","<div id=\"module\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill><form name=\"form\" \nnovalidate flex layout=\"column\" ng-disabled=\"F.readMode\"><div mongo-crud-detail-bar></div><md-content layout=\"column\" \nclass=\"content\" flex><div class=\"detail-form-container md-background-bg md-whiteframe-1dp\" layout=\"column\" flex><div \nlayout=\"row\"><md-input-container class=\"md-block\" flex md-no-float><md-select ms2-autofocus ng-model=\"action.module\" \nplaceholder=\"Módulo\" required><md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" \nng-keydown=\"$event.stopPropagation()\" ng-model=\"moduleSelectFilter\" placeholder=\"Busque un Módulo\"></md-select-header>\n<md-option ng-value=\"module._id\" ng-repeat=\"module in M.modules | orderBy:\'name\' | filter:moduleSelectFilter\">\n{{module.name}}</md-option></md-select></md-input-container></div><div layout=\"row\"><md-input-container \nclass=\"md-block\" flex><label>Nombre</label><input class=\"uppercased\" type=\"text\" name=\"name\" ng-model=\"action.name\" \nmd-maxlength=\"60\" maxlength=\"60\" required></md-input-container><md-input-container class=\"md-block\" flex><label>Clave\n</label><input type=\"text\" name=\"key\" ng-model=\"action.key\" md-maxlength=\"60\" maxlength=\"60\" required>\n</md-input-container></div></div></md-content></form></div>");
$templateCache.put("app/main/system/views/actions/actions.html","<div id=\"actions\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div mongo-search-bar></div><div class=\"content-card\" layout=\"column\" flex>\n<div class=\"content fullpage-datatable\" layout=\"column\" flex><div table-loader array=\"actions\" \nvalidations=\"validations\"></div><md-table-container ng-show=\"actions.length\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\"><thead md-head md-order=\"order\" fix-head \nmd-on-reorder=\"getThem\"><tr md-row><th md-column md-order-by=\"action\"><span>Módulo</span></th><th md-column \nmd-order-by=\"name\"><span>Nombre</span></th><th md-column md-order-by=\"key\"><span>Clave</span></th></tr></thead><tbody \nmd-body><tr md-row md-auto-select md-select=\"action\" md-select-id=\"_id\" ng-repeat=\"action in actions\"><td md-cell>\n{{action.module | nameOfM:M.modules}}</td><td md-cell>{{action.name}}</td><td md-cell>{{action.key}}</td></tr></tbody>\n</table></md-table-container><md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" \nng-show=\"actions.length\" md-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" md-limit-options=\"F.paginations\" \nmd-page=\"currentPage\" md-total=\"{{pagination.total}}\" md-on-paginate=\"getThemPagination\" md-page-select>\n</md-table-pagination></div></div><md-fab-speed-dial md-open=\"F.isOpen\" \nmd-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\"><md-fab-trigger><md-button \naria-label=\"crud menu\" class=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon></md-button>\n</md-fab-trigger><md-fab-actions><md-button with-permission action=\"update\" access=\"{{F.active.menuItem}}\" \nng-if=\"selected.length == 1\" ng-click=\"R.goToDetail(selected[0])\" aria-label=\"Edit\" \nclass=\"md-fab md-raised md-primary md-mini\"><md-tooltip md-direction=\"left\">{{\'EC.EDIT\' | translate}}</md-tooltip>\n<md-icon md-font-icon=\"icon-pencil\" aria-label=\"Edit\"></md-icon></md-button><md-button with-permission action=\"remove\" \naccess=\"{{F.active.menuItem}}\" ng-if=\"selected.length\" ng-click=\"delete($event)\" aria-label=\"Delete\" \nclass=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">{{\'EC.REMOVE\' | translate}}</md-tooltip>\n<md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button><md-button with-permission \naction=\"create\" access=\"{{F.active.menuItem}}\" ng-if=\"!selected.length\" ng-click=\'R.goToDetail(\"new\")\' \naria-label=\"add\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">\n{{\'EC.ADD\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon></md-button>\n</md-fab-actions></md-fab-speed-dial></div></div>");
$templateCache.put("app/main/system/views/modules/module.html","<div id=\"module\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill><form name=\"form\" \nnovalidate flex layout=\"column\" ng-disabled=\"F.readMode\"><div mongo-crud-detail-bar></div><md-content layout=\"column\" \nclass=\"content\" flex><div class=\"detail-form-container md-background-bg md-whiteframe-1dp\"><md-input-container \nclass=\"md-block\"><label>Nombre</label><input ms2-autofocus class=\"uppercased\" type=\"text\" name=\"name\" \nng-model=\"module.name\" md-maxlength=\"60\" maxlength=\"60\" required></md-input-container></div></md-content></form></div>");
$templateCache.put("app/main/system/views/modules/modules.html","<div id=\"modules\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div mongo-search-bar></div><div class=\"content-card\" layout=\"column\" flex>\n<div class=\"content fullpage-datatable\" layout=\"column\" flex><div table-loader array=\"modules\" \nvalidations=\"validations\"></div><md-table-container ng-show=\"modules.length\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\"><thead md-head md-order=\"order\" fix-head \nmd-on-reorder=\"getThem\"><tr md-row><th md-column md-order-by=\"name\"><span>Nombre</span></th></tr></thead><tbody \nmd-body><tr md-row md-auto-select md-select=\"module\" md-select-id=\"_id\" ng-repeat=\"module in modules\"><td md-cell>\n{{module.name}}</td></tr></tbody></table></md-table-container><md-table-pagination layout-align=\"start center\" \nlayout-gt-xs=\"row\" layout-xs=\"column\" ng-show=\"modules.length\" md-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" \nmd-limit-options=\"F.paginations\" md-page=\"currentPage\" md-total=\"{{pagination.total}}\" \nmd-on-paginate=\"getThemPagination\" md-page-select></md-table-pagination></div></div><md-fab-speed-dial \nmd-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" class=\"ms2-speed-dial bottom right\"><md-fab-trigger>\n<md-button aria-label=\"crud menu\" class=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon>\n</md-button></md-fab-trigger><md-fab-actions><md-button with-permission action=\"update\" access=\"{{F.active.menuItem}}\" \nng-if=\"selected.length == 1\" ng-click=\"R.goToDetail(selected[0])\" aria-label=\"Edit\" \nclass=\"md-fab md-raised md-primary md-mini\"><md-tooltip md-direction=\"left\">{{\'EC.EDIT\' | translate}}</md-tooltip>\n<md-icon md-font-icon=\"icon-pencil\" aria-label=\"Edit\"></md-icon></md-button><md-button with-permission action=\"remove\" \naccess=\"{{F.active.menuItem}}\" ng-if=\"selected.length\" ng-click=\"delete($event)\" aria-label=\"Delete\" \nclass=\"md-fab md-raised md-warn md-mini\"><md-tooltip md-direction=\"left\">{{\'EC.REMOVE\' | translate}}</md-tooltip>\n<md-icon md-font-icon=\"icon-delete\" aria-label=\"Remove\"></md-icon></md-button><md-button with-permission \naction=\"create\" access=\"{{F.active.menuItem}}\" ng-if=\"!selected.length\" ng-click=\'R.goToDetail(\"new\")\' \naria-label=\"add\" class=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">\n{{\'EC.ADD\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon></md-button>\n</md-fab-actions></md-fab-speed-dial></div></div>");
$templateCache.put("app/main/system/views/statusRecords/statusRecord.html","<div id=\"module\" class=\"page-layout simple tabbed crud-detail\" layout=\"column\" layout-fill><form name=\"form\" \nnovalidate flex layout=\"column\" ng-disabled=\"F.readMode\"><div mongo-crud-detail-bar></div><md-content layout=\"column\" \nclass=\"content\" flex><div class=\"detail-form-container md-background-bg md-whiteframe-1dp\"><div layout=\"row\">\n<md-input-container class=\"md-block\" flex md-no-float><md-select ms2-autofocus ng-model=\"statusRecord.module\" \nplaceholder=\"Módulo\" required><md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" \nng-keydown=\"$event.stopPropagation()\" ng-model=\"moduleSelectFilter\" placeholder=\"Busque un Módulo\"></md-select-header>\n<md-option ng-value=\"module._id\" ng-repeat=\"module in M.modules | orderBy:\'name\' | filter:moduleSelectFilter\">\n{{module.name}}</md-option></md-select></md-input-container></div><div layout=\"row\"><md-input-container \nclass=\"md-block\" flex><label>Nombre</label><input class=\"uppercased\" type=\"text\" name=\"name\" \nng-model=\"statusRecord.name\" md-maxlength=\"60\" maxlength=\"60\" required></md-input-container><md-input-container \nclass=\"md-block\" flex><label>Valor</label><input type=\"number\" name=\"value\" ng-model=\"statusRecord.value\" required>\n</md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block\" flex><label>Descripción</label>\n<textarea name=\"description\" ng-model=\"statusRecord.description\"></textarea></md-input-container></div></div>\n</md-content></form></div>");
$templateCache.put("app/main/system/views/statusRecords/statusRecords.html","<div id=\"statusRecords\" class=\"page-layout carded fullwidth crud-index\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div mongo-search-bar></div><div class=\"content-card\" layout=\"column\" \nflex><div class=\"content fullpage-datatable\" layout=\"column\" flex><div table-loader array=\"statusRecords\" \nvalidations=\"validations\"></div><md-table-container ng-show=\"statusRecords.length\" ng-init=\'order = \"value\"\'><table \nmd-table md-row-select multiple=\"true\" ng-model=\"selected\" class=\"row-border\"><thead md-head md-order=\"order\" fix-head \nmd-on-reorder=\"getThem\"><tr md-row><th md-column md-order-by=\"module\"><span>Módulo</span></th><th md-column \nmd-order-by=\"name\"><span>Nombre</span></th><th md-column md-order-by=\"value\"><span>Status</span></th></tr></thead>\n<tbody md-body><tr md-row md-auto-select md-select=\"statusRecord\" md-select-id=\"_id\" \nng-repeat=\"statusRecord in statusRecords\"><td md-cell>{{statusRecord.module | nameOfM:M.modules}}</td><td md-cell>\n{{statusRecord.name}}</td><td md-cell>{{statusRecord.value}}</td></tr></tbody></table></md-table-container>\n<md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" ng-show=\"statusRecords.length\" \nmd-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" md-limit-options=\"F.paginations\" md-page=\"currentPage\" \nmd-total=\"{{pagination.total}}\" md-on-paginate=\"getThemPagination\" md-page-select></md-table-pagination></div></div>\n<md-fab-speed-dial md-open=\"F.isOpen\" md-direction=\"{{F.speedSelectedDialDirection}}\" \nclass=\"ms2-speed-dial bottom right\"><md-fab-trigger><md-button aria-label=\"crud menu\" \nclass=\"md-fab md-accent md-hue-1\"><md-icon md-font-icon=\"icon-cube\"></md-icon></md-button></md-fab-trigger>\n<md-fab-actions><md-button with-permission action=\"update\" access=\"{{F.active.menuItem}}\" ng-if=\"selected.length == 1\" \nng-click=\"R.goToDetail(selected[0])\" aria-label=\"Edit\" class=\"md-fab md-raised md-primary md-mini\"><md-tooltip \nmd-direction=\"left\">{{\'EC.EDIT\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-pencil\" aria-label=\"Edit\">\n</md-icon></md-button><md-button with-permission action=\"remove\" access=\"{{F.active.menuItem}}\" \nng-if=\"selected.length\" ng-click=\"delete($event)\" aria-label=\"Delete\" class=\"md-fab md-raised md-warn md-mini\">\n<md-tooltip md-direction=\"left\">{{\'EC.REMOVE\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-delete\" \naria-label=\"Remove\"></md-icon></md-button><md-button with-permission action=\"create\" access=\"{{F.active.menuItem}}\" \nng-if=\"!selected.length\" ng-click=\'R.goToDetail(\"new\")\' aria-label=\"add\" \nclass=\"md-fab md-raised md-mini md-accent md-hue-2\"><md-tooltip md-direction=\"left\">{{\'EC.ADD\' | translate}}\n</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon></md-button></md-fab-actions>\n</md-fab-speed-dial></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps | filter:MsStepper.filterHiddenStep\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"step md-accent-bg\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{$index + 1}} </span>\n<span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\">\n{{step.stepTitle}}</div><div class=\"subtitle\" ng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div>\n</md-button></div></div><div class=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"md-accent md-raised\" \nng-disabled=\"MsStepper.isFirstStep()||loading\" ng-click=\"MsStepper.gotoPreviousStep()\">Anterior</md-button><div \nclass=\"ms-stepper-dots\"><span ng-repeat=\"step in MsStepper.steps\" ng-hide=\"MsStepper.isStepHidden(step.stepNumber)\" \nng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\"></span></div><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)||loading\" ng-click=\"MsStepper.gotoNextStep()\">\nSiguiente</md-button><md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" \nng-if=\"MsStepper.isLastStep()\" ng-disabled=\"!MsStepper.isFormValid()||loading\">Aplicar</md-button><md-button \nclass=\"md-accent md-raised md-warn\" ng-disabled=\"loading\" ng-click=\"close()\">Cancelar</md-button></div></div>");
$templateCache.put("app/core/directives/ms-navigation/dialogs/cif-validator/cif-validator.html","<md-dialog aria-label=\"rfc validator\" id=\"cifValidatorDialog\"><form name=\"form\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h1 class=\"data\">Validador de Cédula de Identificación Fiscal</h1><span flex></span><md-button\n class=\"md-icon-button\" ng-click=\"cifValidCtrl.close()\"><md-icon md-font-icon=\"icon-cancel\" aria-label=\"cancel\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content><div ng-if=\"!cifValidCtrl.cifData\"><div \nclass=\"text-center\"><img src=\"assets/images/ejemploCif.jpg\"></div><md-input-container class=\"md-block\"><label>RFC\n</label><input type=\"text\" rfc name=\"rfc\" class=\"uppercased\" ng-model=\"cifValidCtrl.data.rfc\" required><div \nng-messages=\"form.rfc.$error\" role=\"alert\"><div ng-message=\"required\">El rfc es requerido</div><div ng-message=\"rfc\">\nEl formato del rfc no es válido</div></div></md-input-container><md-input-container class=\"md-block\"><label>CIF ID\n</label><input type=\"text\" name=\"cifId\" ng-model=\"cifValidCtrl.data.cif\" required><div ng-messages=\"form.cifId.$error\" \nrole=\"alert\"><div ng-message=\"required\">El cif es requerido</div></div></md-input-container></div><div \nng-if=\"cifValidCtrl.cifData && cifValidCtrl.cifData.valid\" layout=\"column\" layout-align=\"center center\"><div flex><img \nsrc=\"sat.webp\" class=\"w-50 h-50\"> <img src=\"bien.webp\" class=\"w-50 h-50\"></div><div flex><h3><strong>\nEl cif proporcionado es válido</strong></h3></div><div flex class=\"cifData\"><div layout=\"row\"><div flex=\"25\" \nclass=\"strong\"><strong>Nombre:</strong></div><div flex>{{cifValidCtrl.cifData.data.name}}</div></div><div layout=\"row\">\n<div flex=\"25\" class=\"strong\"><strong>RFC:</strong></div><div flex>{{cifValidCtrl.cifData.data.rfc}}</div></div><div \nlayout=\"row\"><div flex=\"25\" class=\"strong\"><strong>CP:</strong></div><div flex>{{cifValidCtrl.cifData.data.cp}}</div>\n</div><div layout=\"row\"><div flex=\"25\" class=\"strong\"><strong>Regimen:</strong></div><div flex>\n{{cifValidCtrl.cifData.data.regime}}</div></div></div></div><div \nng-if=\"cifValidCtrl.cifData && (!cifValidCtrl.cifData.valid)\" layout=\"column\" layout-align=\"center center\"><div flex>\n<img src=\"sat.webp\" class=\"w-50 h-50\"> <img src=\"na.webp\" class=\"w-50 h-50\"></div><div flex><h3><strong>\n{{cifValidCtrl.cifData.msg}}</strong></h3></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-disabled=\"form.$invalid\" ng-if=\"!cifValidCtrl.cifData\" ng-click=\"cifValidCtrl.validarCif()\" \nclass=\"md-raised md-primary\">Consultar</md-button><md-button ng-if=\"cifValidCtrl.cifData\" \nng-click=\"cifValidCtrl.reset()\" class=\"md-raised md-primary\">Nueva Búsqueda</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/core/directives/ms-navigation/dialogs/rfc-validator/rfc-validator.html","<md-dialog id=\"rfcValidatorDialog\" class=\"rounded\"><form name=\"form\" ng-cloak><md-toolbar><div \nclass=\"md-toolbar-tools\"><h1>Validador de rfc, nombre y código postal</h1><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"rfcValidCtrl.close()\"><md-icon md-font-icon=\"icon-cancel\" aria-label=\"cancel\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content><div ng-if=\"!rfcValidCtrl.rfcData\"><md-input-container \nclass=\"md-block\" flex><label>Nombre(s)</label><input type=\"text\" name=\"name\" class=\"uppercased\" \nng-model=\"rfcValidCtrl.names\" required><div ng-messages=\"form.name.$error\" role=\"alert\"><div ng-message=\"required\">\nEl nombre completo es requerido</div></div></md-input-container><md-input-container class=\"md-block\" flex><label>\nApellido paterno</label><input type=\"text\" name=\"paternalSurname\" class=\"uppercased\" \nng-required=\"!rfcValidCtrl.maternalSurname\" ng-model=\"rfcValidCtrl.paternalSurname\"><div \nng-messages=\"form.paternalSurname.$error\" role=\"alert\"><div ng-message=\"required\">El apellido paterno es requerido\n</div></div></md-input-container><md-input-container class=\"md-block\" flex><label>Apellido materno</label><input \ntype=\"text\" name=\"maternalSurname\" ng-required=\"!rfcValidCtrl.paternalSurname\" class=\"uppercased\" \nng-model=\"rfcValidCtrl.maternalSurname\"><div ng-messages=\"form.maternalSurname.$error\" role=\"alert\"><div \nng-message=\"required\">El apellido materno es requerido</div></div></md-input-container><md-input-container \nclass=\"md-block\" flex><label>RFC</label><input type=\"text\" name=\"rfc\" class=\"uppercased\" ng-model=\"rfcValidCtrl.rfc\" \nrequired><div ng-messages=\"form.rfc.$error\" role=\"alert\"><div ng-message=\"required\">El rfc completo es requerido</div>\n</div></md-input-container><md-input-container class=\"md-block\" flex><label>Código postal</label><input type=\"text\" \nname=\"cp\" ng-model=\"rfcValidCtrl.cp\" required><div ng-messages=\"form.cp.$error\" role=\"alert\"><div \nng-message=\"required\">El cp completo es requerido</div></div></md-input-container></div><div \nng-if=\"rfcValidCtrl.rfcData && rfcValidCtrl.rfcData.valid\" layout=\"column\" layout-align=\"center center\"><div flex><img \nsrc=\"sat.webp\" class=\"w-50 h-50\"> <img src=\"bien.webp\" class=\"w-50 h-50\"></div><div flex><h3>\nLa cédula de Identificacion fiscal es valida</h3></div></div><div \nng-if=\"rfcValidCtrl.rfcData && (!rfcValidCtrl.rfcData.valid)\" layout=\"column\" layout-align=\"center center\"><div flex>\n<img src=\"sat.webp\" class=\"w-50 h-50\"> <img src=\"na.webp\" class=\"w-50 h-50\"></div><div flex><h3><strong>\n{{rfcValidCtrl.rfcData.msg}}</strong></h3></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-disabled=\"form.$invalid\" ng-if=\"!rfcValidCtrl.rfcData\" ng-click=\"rfcValidCtrl.validarRfc()\" \nclass=\"md-raised md-primary\">Consultar</md-button><md-button ng-if=\"rfcValidCtrl.rfcData\" \nng-click=\"rfcValidCtrl.reset()\" class=\"md-raised md-primary\">Nueva Búsqueda</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/apps/chat/sidenavs/left/left-sidenav.html","<div ng-show=\"leftSidenavView === \'contacts\'\" class=\"view contacts-view animate-slide-left\" \nng-include=\"\'app/main/apps/chat/sidenavs/left/views/contacts/contacts-view.html\'\" layout=\"column\" flex></div><div \nng-show=\"leftSidenavView ===\'user\'\" class=\"view user-view animate-slide-left\" \nng-include=\"\'app/main/apps/chat/sidenavs/left/views/user/user-view.html\'\" layout=\"column\" flex></div><div \nng-hide=\"leftSidenavView\" class=\"view chats-view animate-slide-right\" \nng-include=\"\'app/main/apps/chat/sidenavs/left/views/chats/chats-view.html\'\" layout=\"column\" flex></div>");
$templateCache.put("app/main/apps/chat/sidenavs/right/right-sidenav.html","<div class=\"view contact-view\" ng-include=\"\'app/main/apps/chat/sidenavs/right/views/contact/contact-view.html\'\" \nlayout=\"column\" flex></div>");
$templateCache.put("app/main/apps/calendar/dialogs/event-detail/event-detail-dialog.html","<md-dialog class=\"event-detail-dialog\" aria-label=\"New Message\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\"><span class=\"title\">{{calendarEvent.title}}</span> <span flex></span><md-button \nclass=\"edit-event-button md-fab md-warn\" ng-click=\"editEvent(calendarEvent)\" aria-label=\"Edit event\" translate \ntranslate-attr-aria-label=\"CALENDAR.EDIT_EVENT\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div class=\"event-details\" layout=\"column\"><div class=\"event-detail-row\" \nlayout=\"row\" layout-align=\"start start\"><md-icon md-font-icon=\"icon-clock\"></md-icon><div layout=\"column\" flex><span \nclass=\"h4\">{{calendarEvent.start.format(\'MMMM Do YYYY, h:mm:ss a\')}} <span ng-if=\"calendarEvent.end\">-</span>\n {{calendarEvent.end.format(\'MMMM Do YYYY, h:mm:ss a\')}}</span> <span class=\"secondary-text\">\n{{calendarEvent.repeat || \'Does not repeat\'}}</span></div></div><div class=\"event-detail-row\" layout=\"row\" \nlayout-align=\"start start\"><md-icon md-font-icon=\"icon-bell-ring-outline\"></md-icon><div layout=\"column\" flex><span \nclass=\"h4\" translate=\"CALENDAR.30_MIN_BEFORE\">30 minutes before</span> <span class=\"h4\" \ntranslate=\"CALENDAR.15_MIN_BEFORE\">15 minutes before</span> <span class=\"h4\" translate=\"CALENDAR.30_MIN_LATER\">\n30 minutes later</span></div></div><div class=\"event-detail-row\" layout=\"row\" layout-align=\"start start\"><md-icon \nmd-font-icon=\"icon-map-marker\"></md-icon><div layout=\"column\" flex><span class=\"h4\">Istanbul, Turkey</span></div></div>\n<div class=\"event-detail-row\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-account\"></md-icon>\n<div layout=\"row\" flex><img src=\"assets/images/avatars/alice.jpg\" class=\"avatar\" alt=\"alice\"> <img \nsrc=\"assets/images/avatars/joyce.jpg\" class=\"avatar\" alt=\"joyce\"> <img src=\"assets/images/avatars/vincent.jpg\" \nclass=\"avatar\" alt=\"vincent\"></div></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/apps/calendar/dialogs/event-form/event-form-dialog.html","<md-dialog class=\"event-form-dialog\" aria-label=\"New Message\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{dialogTitle}}</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><md-input-container \nclass=\"md-block\"><label translate=\"CALENDAR.TITLE\">Title</label><input name=\"title\" ng-model=\"calendarEvent.title\" \nrequired><div ng-messages=\"eventForm.title.$error\" ng-show=\"eventForm.title.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"CALENDAR.ERRORS.TITLE_REQUIRED\">Title field is required</span></div></div>\n</md-input-container><md-list class=\"all-day\"><md-list-item><p translate=\"CALENDAR.ALL_DAY\">All Day</p><md-switch \nclass=\"md-secondary\" ng-model=\"calendarEvent.allday\" aria-label=\"All day\" translate \ntranslate-attr-aria-label=\"CALENDAR.ALL_DAY\"></md-switch></md-list-item></md-list><div layout=\"row\" class=\"date-row\">\n<md-datepicker md-hide-icons=\"triangle\" ng-model=\"calendarEvent.start\" md-placeholder=\"Start Date\"></md-datepicker>\n<md-input-container flex md-no-float><input ng-model=\"calendarEvent.startTime\" placeholder=\"Start Time\" translate \ntranslate-attr-placeholder=\"CALENDAR.START_TIME\"></md-input-container></div><div layout=\"row\" class=\"date-row\">\n<md-datepicker md-hide-icons=\"triangle\" ng-model=\"calendarEvent.end\" md-placeholder=\"End Date\"></md-datepicker>\n<md-input-container flex md-no-float><input ng-model=\"calendarEvent.endTime\" placeholder=\"End Time\" translate \ntranslate-attr-placeholder=\"CALENDAR.END_TIME\"></md-input-container></div><md-input-container class=\"md-block\" flex>\n<label translate=\"CALENDAR.REPEAT\">Repeat</label><input ng-model=\"calendarEvent.repeat\"></md-input-container>\n<md-input-container class=\"md-block\" flex><label translate=\"CALENDAR.LOCATION\">Location</label><input \nng-model=\"calendarEvent.location\"></md-input-container><div class=\"notifications\" layout=\"column\"><div class=\"title\" \ntranslate=\"CALENDAR.NOTIFICATIONS\">Notifications</div><md-select ng-model=\"notification\" placeholder=\"Notification\" \nng-repeat=\"notification in calendarEvent.notifications\"><md-option ng-repeat=\"opt in notifications\" value=\"{{opt}}\">\n{{opt}}</md-option></md-select><md-button aria-label=\"+ Add Another Notification\" \ntranslate=\"CALENDAR.ADD_NOTIFICATION\" translate-attr-aria-label=\"CALENDAR.ADD_NOTIFICATION\">+ Add Another Notification\n</md-button></div><md-input-container flex class=\"md-block textarea-container\"><label translate=\"CALENDAR.NOTES\">Notes\n</label><textarea ng-model=\"task.notes\" md-maxlength=\"250\" maxlength=\"250\"></textarea></md-input-container>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><md-button \nng-click=\"saveEvent()\" class=\"save-button md-accent md-raised\" aria-label=\"SAVE\" \nng-disabled=\"eventForm.$invalid || eventForm.$pristine\" translate=\"CALENDAR.SAVE\" \ntranslate-attr-aria-label=\"CALENDAR.SAVE\">SAVE</md-button><md-button class=\"md-icon-button\" aria-label=\"Delete\" \ntranslate translate-attr-aria-label=\"CALENDAR.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span \ntranslate=\"CALENDAR.DELETE\">Delete</span></md-tooltip></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/contacts/dialogs/contact/contact-dialog.html","<md-dialog class=\"contact-dialog\" aria-label=\"New Task\"><form name=\"contactForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div class=\"md-toolbar-tools md-toolbar-tools-middle\" \nflex layout=\"column\" layout-align=\"center center\"><div layout=\"column\" layout-align=\"center center\"><img \nng-src=\"{{vm.contact.avatar}}\" class=\"md-avatar avatar contact-avatar huge\" alt=\"{{vm.contact.name}}\"><div \nclass=\"contact-name\">{{vm.contact.name}}</div></div></div><div class=\"md-toolbar-tools md-toolbar-tools-bottom\" \nlayout=\"row\" layout-align=\"center center\"><div flex layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.toggleInArray(vm.contact.id, vm.user.starred)\" aria-label=\"Toggle starred\" \ntranslate translate-attr-aria-label=\"CONTACTS.TOGGLE_STARRED\"><md-icon \nng-if=\"vm.exists(vm.contact.id,vm.user.starred)\" md-font-icon=\"icon-star\" class=\"amber-fg\"></md-icon><md-icon \nng-if=\"!vm.exists(vm.contact.id,vm.user.starred)\" md-font-icon=\"icon-star-outline\"></md-icon></md-button><md-menu>\n<md-button class=\"md-icon-button\" aria-label=\"More\" translate translate-attr-aria-label=\"TODO.MORE\"><md-icon \nmd-font-icon=\"icon-account-multiple-plus\" ng-click=\"$mdOpenMenu($event)\"></md-icon></md-button><md-menu-content \nwidth=\"3\"><md-list-item ng-if=\"vm.user.groups\" ng-repeat=\"group in vm.user.groups\" \nng-click=\"vm.toggleInArray(vm.contact.id,group.contactIds)\"><p class=\"pl-8\" \nng-style=\"vm.exists(vm.contact.id,group.contactIds) && {\'font-weight\':\'500\'}\">{{group.name}}</p></md-list-item>\n</md-menu-content></md-menu></div></div></md-toolbar><md-dialog-content ms-scroll><md-input-container \nclass=\"md-icon-float md-block\"><label translate=\"CONTACTS.NAME_REQUIRED\">Name (required)</label><md-icon \nmd-font-icon=\"icon-account\" class=\"name\"></md-icon><input ng-model=\"vm.contact.name\" type=\"text\" ng-required>\n</md-input-container><md-input-container class=\"md-icon-float md-block\"><label translate=\"CONTACTS.LAST_NAME\">Last name\n</label><md-icon></md-icon><input ng-model=\"vm.contact.lastName\" type=\"text\"></md-input-container><md-input-container \nclass=\"md-icon-float md-block\"><label translate=\"CONTACTS.NICKNAME\">Nickname</label><md-icon></md-icon><input \nng-model=\"vm.contact.nickname\" type=\"text\"></md-input-container><div ng-if=\"!vm.allFields\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent\" ng-click=\"vm.allFields = true\" \ntranslate=\"CONTACTS.SHOW_ALL_FIELDS\">Show All Fields</md-button></div><div ng-if=\"vm.allFields\"><md-input-container \nclass=\"md-block\"><md-icon md-font-icon=\"icon-phone\"></md-icon><input ng-model=\"vm.contact.phone\" type=\"text\" \nplaceholder=\"Phone number\" translate translate-attr-placeholder=\"CONTACTS.PHONE_NUMBER\"></md-input-container>\n<md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-email\" class=\"email\"></md-icon><input \nng-model=\"vm.contact.email\" type=\"email\" placeholder=\"Email\" translate translate-attr-placeholder=\"CONTACTS.EMAIL\">\n</md-input-container><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-domain\"></md-icon><input \nng-model=\"vm.contact.company\" type=\"text\" placeholder=\"Company\" translate \ntranslate-attr-placeholder=\"CONTACTS.COMPANY\"></md-input-container><md-input-container class=\"md-block\"><md-icon \nmd-font-icon=\"icon-worker\"></md-icon><input ng-model=\"vm.contact.jobTitle\" type=\"text\" placeholder=\"Job title\" \ntranslate translate-attr-placeholder=\"CONTACTS.JOB_TITLE\"></md-input-container><md-datepicker md-hide-icons=\"triangle\" \nclass=\"birthday-input\" ng-model=\"vm.contact.birthday\" md-placeholder=\"Birthday\" ng-required=\"false\"></md-datepicker>\n<md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-home\"></md-icon><input ng-model=\"vm.contact.address\" \ntype=\"text\" placeholder=\"Address\" translate translate-attr-placeholder=\"CONTACTS.ADDRESS\"></md-input-container><div \nlayout=\"row\" class=\"md-block textarea-wrapper\" layout-align=\"start start\"><md-icon md-font-icon=\"icon-note\"></md-icon>\n<md-input-container flex><label translate translate-attr-placeholder=\"CONTACTS.NOTES\">Notes</label><textarea \nng-model=\"vm.contact.notes\" type=\"text\"></textarea></md-input-container></div><div layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent\" ng-click=\"vm.allFields = false\" \ntranslate=\"CONTACTS.FEWER_FIELDS\">Fewer Fields</md-button></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \ntype=\"submit\" ng-if=\"!vm.newContact\" ng-click=\"vm.saveContact()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"contactForm.$invalid || contactForm.$pristine\" aria-label=\"SAVE\" translate=\"CONTACTS.SAVE\" \ntranslate-attr-aria-label=\"CONTACTS.SAVE\">SAVE</md-button><md-button type=\"submit\" ng-if=\"vm.newContact\" \nng-click=\"vm.addNewContact()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"contactForm.$invalid || contactForm.$pristine\" aria-label=\"Add Task\" translate=\"CONTACTS.ADD_CONTACT\" \ntranslate-attr-aria-label=\"CONTACTS.ADD_CONTACT\">ADD CONTACT</md-button></div><div layout=\"row\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.deleteContactConfirm($event)\" aria-label=\"Delete\" translate \ntranslate-attr-aria-label=\"CONTACTS.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span \ntranslate=\"CONTACTS.DELETE\">DELETE</span></md-tooltip></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/contacts/sidenavs/main/main-sidenav.html","<div class=\"header md-padding\" layout=\"row\" layout-align=\"start center\"><img ng-src=\"{{vm.user.avatar}}\" \nclass=\"md-avatar avatar mr-16\" alt=\"{{vm.user.name}}\"> <span class=\"font-weight-500 font-size-14\">{{vm.user.name}}\n</span></div><md-divider></md-divider><div ms-scroll class=\"content\"><md-list><md-list-item \nng-click=\"vm.filterChange(\'all\')\" ng-class=\"{\'selected\':vm.listType ===\'all\'}\"><p translate=\"CONTACTS.ALL_CONTACTS\">\nAll contacts</p></md-list-item><md-list-item ng-click=\"vm.filterChange(\'frequent\')\" \nng-class=\"{\'selected\':vm.listType ===\'frequent\'}\"><p translate=\"CONTACTS.FREQUENTLY_CONTACTED\">Frequently contacted</p>\n</md-list-item><md-list-item ng-click=\"vm.filterChange(\'starred\')\" ng-class=\"{\'selected\':vm.listType ===\'starred\'}\"><p \ntranslate=\"CONTACTS.STARRED_CONTACTS\">Starred contacts</p></md-list-item><md-divider></md-divider><md-subheader \nclass=\"md-no-sticky\">Groups</md-subheader><md-list-item ng-if=\"vm.user.groups\" ng-repeat=\"group in vm.user.groups\" \nng-click=\"vm.filterChange(group)\" ng-class=\"{\'selected\':vm.listType.name === group.name}\"><p class=\"pl-8\">\n{{group.name}}</p></md-list-item><md-list-item class=\"new-group-form\" ng-show=\"newListForm.$visible\"><p class=\"pl-8\" \neditable-text=\"vm.newGroupName\" e-form=\"newListForm\" onaftersave=\"vm.addNewGroup()\"></p></md-list-item><md-list-item \nclass=\"\" ng-click=\"newListForm.$show()\" ng-hide=\"newListForm.$visible\"><p class=\"pl-8 md-accent-fg\" \ntranslate=\"CONTACTS.NEW_GROUP\">New Group</p></md-list-item></md-list></div>");
$templateCache.put("app/main/apps/dashboards/project/widgets/counter.html","<ms-widget flippable=\"true\" layout=\"column\"><ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{\'widgets.\' + widget.name | translate}}</div>\n<md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"flipWidget()\" aria-label=\"Flip widget\">Detalles</md-button></md-menu-item></md-menu-content></md-menu></div>\n<div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"orange-fg font-size-72 line-height-72\">{{count.total}}</div><div class=\"h3 secondary-text font-weight-500\">\n{{\'widgetData.\'+count.label|translate}}</div></div><div class=\"p-16 grey-50-bg border-top\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">otracosa:</span> <span class=\"h4 ml-8\">78\n</span></div></ms-widget-front><ms-widget-back class=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button \nclass=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\">\n</md-icon></md-button></div><div>{{\'widgetDetail.\'+count.label|translate}}</div></ms-widget-back></ms-widget>");
$templateCache.put("app/main/apps/dashboards/project/widgets/multiple-widget.html","<div ng-class=\'{\r\n        \"counter\": widget.directive==\"counterWidget\"\r\n    }\'><counter-widget \nng-if=\'widget.directive==\"counterWidget\"\' widget=\"widget\"></counter-widget><pie-graph-widget \nng-if=\'widget.directive==\"pieGraph\"\' widget=\"widget\"></pie-graph-widget><line-graph-widget \nng-if=\'widget.directive==\"lineGraph\"\' widget=\"widget\"></line-graph-widget><div operations-status-by-range-widget \nng-if=\'widget.directive==\"operationsStatusByRange\"\'></div><div operations-status-progress-by-range-dashboard-widget \nng-if=\'widget.directive==\"operationsStatusProgressByRange\"\'></div></div>");
$templateCache.put("app/main/apps/dashboards/project/widgets/operations-progress-by-status-dashboard-widget.html","<ms-widget layout=\"{{styles.layout}}\" flex=\"{{styles.flex}}\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ms-responsive-table-wrapper\"><table class=\"simple\" ms-responsive-table><thead><tr><th>Nómina</th><th \nng-repeat=\"status in F.operationStatatuss\" ng-if=\"status.id != 0\"><md-button class=\"md-icon-button\" \naria-label=\"{{status.name | uppercase}}\"><md-tooltip md-direction=\"top\">{{status.name | uppercase}}</md-tooltip>\n<md-icon md-font-icon=\"{{status.icon}}\"></md-icon></md-button></th></tr></thead><tbody><tr \nng-repeat=\"operation in operationsFiltered|orderBy:\'period\'\"><td>{{operation.payroll|nameOfL:dashboardPayrolls}}<br>\n<small>Periodo {{operation.period}}</small></td><td ng-repeat=\"status in F.operationStatatuss \" ng-if=\"status.id != 0\">\n<md-button ng-if=\"operation.status >= status.id\" class=\"md-icon-button md-primary md-hue-2\" aria-label=\"ok\"><md-tooltip\n md-direction=\"top\">Se completó este status</md-tooltip><md-icon md-font-icon=\"icon-check-circle\"></md-icon>\n</md-button></td></tr></tbody></table></div></ms-widget-front></ms-widget>");
$templateCache.put("app/main/apps/file-manager/views/grid/grid-view.html","<div class=\"grid-view\" layout=\"column\"><div class=\"folders\" layout=\"row\" layout-wrap><div \nclass=\"md-background-bg md-hue-1 md-whiteframe-1dp item folder\" ng-click=\"vm.select(folder)\" \nng-repeat=\"folder in vm.folders | filter:global.search\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" class=\"title\" layout-align=\"start center\"><span class=\"file-icon\"><i md-font-icon=\"icon-{{folder.type}}\">\n</i> </span><span class=\"name\">{{folder.name}}</span></div><div class=\"show-details\" hide-gt-md><md-button \nclass=\"md-icon-button sidenav-toggle\" aria-label=\"Details\" translate translate-attr-aria-label=\"FM.DETAILS\"><md-icon \nmd-font-icon=\"icon-information-outline\" ng-click=\"vm.toggleDetails(folder)\"></md-icon></md-button></div></div></div>\n<div class=\"files\" layout=\"row\" layout-wrap><div ng-click=\"vm.select(file)\" class=\"md-whiteframe-1dp item file\" \nng-repeat=\"file in vm.files | filter:global.search\" layout=\"column\"><div class=\"preview\"><img \nng-src=\"{{file.preview}}\"></div><div class=\"bottom md-background-bg md-hue-1\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" class=\"title\" layout-align=\"start center\" flex><span \nclass=\"file-icon\"><i md-font-icon=\"icon-{{file.type}}\"></i> </span><span class=\"name\">{{file.name}}</span></div><div \nclass=\"show-details\" hide-gt-md><md-button class=\"md-icon-button sidenav-toggle\" aria-label=\"Details\" translate \ntranslate-attr-aria-label=\"FM.DETAILS\"><md-icon md-font-icon=\"icon-information-outline\" \nng-click=\"vm.toggleDetails(file)\"></md-icon></md-button></div></div></div></div></div>");
$templateCache.put("app/main/apps/file-manager/views/list/list-view.html","<table class=\"simple list-view\"><thead><tr><th></th><th translate=\"FM.NAME\">Name</th><th hide show-gt-sm \ntranslate=\"FM.TYPE\">Type</th><th hide-xs translate=\"FM.OWNER\">Owner</th><th hide-xs translate=\"FM.SIZE\">Size</th><th \nhide show-gt-md translate=\"FM.LAST_MODIFIED\">Last Modified</th><th hide-gt-md></th></tr></thead><tbody><tr \nng-repeat=\"folder in vm.folders | filter:global.search\" ng-click=\"vm.select(folder)\" \nng-class=\"{\'selected\' : vm.selected === folder}\"><td class=\"file-icon\"><i class=\"icon-{{folder.type}}\"></i></td><td \nclass=\"name\">{{folder.name}}</td><td class=\"type\" hide show-gt-sm>{{folder.type}}</td><td class=\"owner\" hide-xs>\n{{folder.owner}}</td><td class=\"size\" hide-xs>{{folder.size === \'\' ? \'-\': folder.size}}</td><td class=\"last-modified\" \nhide show-gt-md>{{folder.modified}}</td><td class=\"show-details\" hide-gt-md><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleDetails(folder)\" aria-label=\"Toggle details sidenav\"><md-icon \nmd-font-icon=\"icon-information-outline\"></md-icon></md-button></td></tr><tr \nng-repeat=\"file in vm.files | filter:global.search\" ng-click=\"vm.select(file)\" \nng-class=\"{\'selected\' : vm.selected === file}\"><td class=\"file-icon\"><i class=\"icon-{{file.type}}\"></i></td><td \nclass=\"name\">{{file.name}}</td><td class=\"type\" hide show-gt-sm>{{file.type}}</td><td class=\"owner\" hide-xs>\n{{file.owner}}</td><td class=\"size\" hide-xs>{{file.size === \'\' ? \'-\': file.size}}</td><td class=\"last-modified\" hide \nshow-gt-md>{{file.modified}}</td><td class=\"show-details\" hide-gt-md><md-button class=\"md-icon-button sidenav-toggle\" \nng-click=\"vm.toggleDetails(file)\" aria-label=\"Details\" translate translate-attr-aria-label=\"FM.DETAILS\"><md-icon \nmd-font-icon=\"icon-information-outline\"></md-icon></md-button></td></tr></tbody></table>");
$templateCache.put("app/main/apps/notes/directives/ms-note-form/ms-note-form.html","<form ng-submit=\"MsNoteForm.submit()\" ng-class=\"MsNoteForm.note.color\"><div ng-if=\"MsNoteForm.note.image\" \nclass=\"image-wrapper\"><img class=\"md-card-image\" ng-src=\"{{MsNoteForm.note.image}}\"><md-button \nclass=\"md-fab md-mini delete-image-button\" ng-click=\"MsNoteForm.deleteImage()\" aria-label=\"delete image\" translate \ntranslate-attr-aria-label=\"NOTES.DELETE_IMAGE\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div><input \ntype=\"text\" class=\"note-title-input\" placeholder=\"Title\" ng-model=\"MsNoteForm.note.title\" \nng-class=\"MsNoteForm.note.color\"><md-input-container md-no-float ng-class=\"MsNoteForm.note.color\"><textarea \ntype=\"text\" class=\"note-description-textarea\" placeholder=\"Take a note..\" translate \ntranslate-attr-placeholder=\"NOTES.TAKE_A_NOTE\" ng-model=\"MsNoteForm.note.description\">\r\n    </textarea>\n</md-input-container><md-list class=\"checklist\" ng-if=\"MsNoteForm.note.checklist.length > 0\"><md-divider></md-divider>\n<md-list-item ng-repeat=\"item in MsNoteForm.note.checklist\"><md-checkbox ng-model=\"item.checked\" \naria-label=\"toggle check\"></md-checkbox><p ng-class=\"{\'text-strike md-secondary-text\':item.checked}\">{{item.text}}</p>\n<md-icon ng-click=\"$event.preventDefault();$event.stopPropagation();MsNoteForm.deleteCheckItem(item)\" \nclass=\"md-secondary\" md-font-icon=\"icon-close-circle\" aria-label=\"remove\"></md-icon><md-divider></md-divider>\n</md-list-item></md-list><div class=\"checklist-form\" \nng-if=\"MsNoteForm.note.checklist.length > 0 || MsNoteForm.checkListForm\" layout=\"row\" layout-align=\"space-between end\">\n<md-input-container class=\"\" md-no-float flex><input id=\"new-checklist-item-input\" type=\"text\" placeholder=\"List item\" \nng-model=\"MsNoteForm.newCheckListItem\" \nng-keydown=\"$event.keyCode === 13 ? $event.preventDefault() + MsNoteForm.addChecklistItem():\'\';\"></md-input-container>\n<md-button class=\"md-icon-button\" ng-click=\"MsNoteForm.addChecklistItem()\" aria-label=\"add\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button></div><div class=\"labels\" ng-if=\"MsNoteForm.note.labels.length > 0\" \nlayout=\"row\" layout-wrap layout-align=\"end start\"><div class=\"label\" ng-repeat=\"labelId in MsNoteForm.note.labels\" \nng-class=\"MsNoteForm.labels.getById(labelId).color\">{{MsNoteForm.labels.getById(labelId).name}}</div></div><div \nng-if=\"MsNoteForm.type ===\'edit\'\" class=\"date text-right p-16\">{{MsNoteForm.note.time | altDate}}</div><div \nclass=\"footer\" layout-gt-xs=\"row\" layout-align-gt-xs=\"space-between center\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"actions\" layout=\"row\" layout-align=\"center center\" layout-wrap><div \nid=\"image-uploader\" flow-init=\"MsNoteForm.ngFlowOptions\" flow-name=\"MsNoteForm.ngFlow.flow\" \nflow-files-submitted=\"MsNoteForm.upload()\" flow-file-success=\"MsNoteForm.imageSuccess($file, $message)\" \nflow-complete=\"MsNoteForm.uploadComplete()\" flow-file-added=\"!!{svg:1,png:1,gif:1,jpg:1,jpeg:1}[$file.getExtension()]\">\n<md-button flow-btn class=\"add-img-button md-icon-button\" aria-label=\"Add image\" translate \ntranslate-attr-aria-label=\"NOTES.ADD_IMAGE\"><md-icon md-font-icon=\"icon-file-image-box\" class=\"s20\"></md-icon>\n</md-button></div><md-button class=\"md-icon-button\" aria-label=\"checklist\" ng-click=\"MsNoteForm.checklistFormToggle()\">\n<md-icon md-font-icon=\"icon-checkbox-multiple-marked\" class=\"s20\"></md-icon></md-button><md-menu class=\"label-menu\">\n<md-button class=\"md-icon-button\" aria-label=\"Label\" translate translate-attr-aria-label=\"NOTES.LABEL\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-origin md-font-icon=\"icon-label\" class=\"s20\"></md-icon></md-button>\n<md-menu-content class=\"notes-labels-menu-content\" width=\"4\" ms-scroll><md-menu-item><md-input-container \nclass=\"no-errors-spacer\" md-no-float><input placeholder=\"Search labels...\" type=\"text\" \nng-model=\"MsNoteForm.labelSearchText\" autocomplete=\"off\" translate-attr-palceholder=\"NOTES.SEARCH_LABELS\">\n</md-input-container></md-menu-item><md-menu-item class=\"label\" \nng-repeat=\"label in MsNoteForm.labels | filter: MsNoteForm.labelSearchText\"><md-button class=\"label-toggle-button\" \nmd-prevent-menu-close ng-class=\"label.color\" ng-click=\"MsNoteForm.toggleInArray(label.id, MsNoteForm.note.labels)\" \naria-label=\"Toggle Label\" translate translate-attr-aria-label=\"NOTES.TOGGLE_LABEL\"><div layout=\"row\" \nlayout-align=\"space-between center\"><span>{{label.name}}</span> <i \nng-if=\"MsNoteForm.exists(label.id, MsNoteForm.note.labels)\" class=\"icon-check s16\"></i></div></md-button>\n</md-menu-item></md-menu-content></md-menu><md-button class=\"md-icon-button\" ng-click=\"MsNoteForm.toggleArchive()\" \naria-label=\"archive\"><md-icon md-font-icon=\"icon-archive\" class=\"s20\"></md-icon></md-button><ms-material-color-picker \nng-model=\"MsNoteForm.note.color\"><md-button class=\"md-icon-button\" aria-label=\"color\"><md-icon \nmd-font-icon=\"icon-palette\" class=\"s20\"></md-icon></md-button></ms-material-color-picker><md-datepicker \nmd-hide-icons=\"triangle\" class=\"reminder\" ng-model=\"MsNoteForm.note.reminder\" md-placeholder=\"Add reminder\" \nms-datepicker-fix></md-datepicker></div><div layout=\"row\" layout-align=\"end center\"><md-button \nng-if=\"MsNoteForm.type ===\'edit\'\" ng-click=\"MsNoteForm.deleteNote()\" class=\"md-icon-button\" aria-label=\"delete note\">\n<md-icon md-font-icon=\"icon-delete\"></md-icon></md-button><md-button ng-if=\"MsNoteForm.type ===\'edit\'\" type=\"submit\" \ntranslate=\"NOTES.SAVE\" ng-disabled=\"MsNoteForm.isNotValid()\">Save</md-button><md-button \nng-if=\"MsNoteForm.type ===\'new\'\" type=\"submit\" translate=\"NOTES.ADD\" ng-disabled=\"MsNoteForm.isNotValid()\">Add\n</md-button></div></div></form>");
$templateCache.put("app/main/apps/notes/directives/ms-new-note/ms-new-note.html","<ms-note-form note-type=\"\'new\'\"></ms-note-form><div ms-new-note-button class=\"new-note-button\"><span \ntranslate=\"NOTES.TAKE_A_NOTE\">Take a note..</span></div>");
$templateCache.put("app/main/apps/notes/directives/ms-note-item/ms-note-item.html","<md-card ng-class=\"MsNoteItem.note.color\"><img ng-if=\"MsNoteItem.note.image\" class=\"md-card-image\" \nng-src=\"{{MsNoteItem.note.image}}\"><md-card-content><md-card-title ng-if=\"MsNoteItem.note.title\"><md-card-title-text>\n{{MsNoteItem.note.title}}</md-card-title-text></md-card-title><md-description ng-if=\"MsNoteItem.note.description\">\n<span>{{MsNoteItem.note.description}}</span></md-description><div ng-if=\"MsNoteItem.note.checklist.length > 0\" \nclass=\"checklist\"><div class=\"checklist-item\" ng-repeat=\"checkItem in  MsNoteItem.note.checklist\" layout=\"row\" \nlayout-align=\"start center\"><md-checkbox ng-model=\"checkItem.checked\" \nng-click=\"$event.preventDefault();$event.stopPropagation()\" aria-label=\"{{checkItem.text}}\"></md-checkbox><span \nclass=\"text-truncate\" ng-class=\"{\'text-strike md-secondary-text\':checkItem.checked}\" flex>{{checkItem.text}}</span>\n</div></div><div class=\"labels\" ng-if=\"MsNoteItem.note.labels.length > 0\" layout=\"row\" layout-wrap \nlayout-align=\"end start\"><div class=\"label\" ng-repeat=\"labelId in MsNoteItem.note.labels\" \nng-click=\"$event.preventDefault();$event.stopPropagation();vm.filterChange(vm.labels.getById(labelId))\" \nng-class=\"vm.labels.getById(labelId).color\">{{vm.labels.getById(labelId).name}}</div></div><div \nng-if=\"vm.noteListType ===\'reminders\' && MsNoteItem.note.reminder\" class=\"reminder secondary-text text-right\"><md-icon \nmd-font-icon=\"icon-bell\" class=\"s16 mr-8\"></md-icon><span>{{MsNoteItem.note.reminder | altDate}}</span></div>\n</md-card-content></md-card>");
$templateCache.put("app/main/apps/file-manager/sidenavs/details/details-sidenav.html","<div class=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"end center\"><md-button class=\"md-icon-button\" ng-click=\"vm.delete()\" aria-label=\"Delete\" translate \ntranslate-attr-aria-label=\"FM.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span \ntranslate=\"FM.DELETE\">Delete</span></md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"Download\" \ntranslate translate-attr-aria-label=\"FM.DOWNLOAD\"><md-icon md-font-icon=\"icon-download\"></md-icon><md-tooltip><span \ntranslate=\"FM.DOWNLOAD\">Download</span></md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" \ntranslate translate-attr-aria-label=\"FM.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon><md-tooltip><span \ntranslate=\"FM.MORE\">More</span></md-tooltip></md-button></div><div><div class=\"title\">{{vm.selected.name}}</div><div \nclass=\"subtitle secondary-text\"><span translate=\"FM.EDITED\">Edited</span>: {{vm.selected.modified}}</div></div></div>\n<md-content class=\"content\" flex ms-scroll><div class=\"file-details\"><div class=\"preview file-icon\" layout=\"row\" \nlayout-align=\"center center\"><i class=\"icon-{{vm.selected.type}} s48\"></i></div><md-list class=\"offline-switch\">\n<md-list-item><p translate=\"FM.AVAILABLE_OFFLINE\">Available Offline</p><md-switch class=\"md-secondary\" \nng-model=\"vm.selected.offline\" aria-label=\"Toggle offline\" translate translate-attr-aria-label=\"FM.TOOGLE_OFFLINE\">\n</md-switch></md-list-item></md-list><div class=\"title\" translate=\"FM.INFO\">Info</div><table><tr class=\"type\"><th \ntranslate=\"FM.TYPE\">Type</th><td>{{vm.selected.type}}</td></tr><tr class=\"size\"><th translate=\"FM.SIZE\">Size</th><td>\n{{vm.selected.size === \'\' ? \'-\': vm.selected.size}}</td></tr><tr class=\"location\"><th translate=\"FM.LOCATION\">Location\n</th><td>{{vm.selected.location}}</td></tr><tr class=\"owner\"><th translate=\"FM.OWNER\">Owner</th><td>\n{{vm.selected.owner}}</td></tr><tr class=\"modified\"><th translate=\"FM.MODIFIED\">Modified</th><td>\n{{vm.selected.modified}}</td></tr><tr class=\"opened\"><th translate=\"FM.OPENED\">Opened</th><td>{{vm.selected.opened}}\n</td></tr><tr class=\"created\"><th translate=\"FM.CREATED\">Created</th><td>{{vm.selected.created}}</td></tr></table>\n</div></md-content>");
$templateCache.put("app/main/apps/file-manager/sidenavs/main/main-sidenav.html","<div class=\"header\" layout=\"column\" layout-align=\"space-between start\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-folder\" class=\"icon s24\"></md-icon>\n</span><span class=\"logo-text\" translate=\"FM.FILE_MANAGER\">File Manager</span></div><div class=\"account\"><div \nclass=\"title\">John Doe</div><md-select class=\"account-selection simplified\" ng-model=\"vm.selectedAccount\" \nplaceholder=\"Select Account\"><md-option ng-repeat=\"(provider, address) in vm.accounts\" value=\"{{provider}}\">{{address}}\n</md-option></md-select></div></div><div class=\"content\"><div class=\"navigation-simple\" layout=\"column\"><md-button \nclass=\"item\" aria-label=\"inbox\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-folder\" class=\"s16\"></md-icon><div class=\"title\" translate=\"FM.MY_FILES\">My Files</div></div>\n</md-button><md-button class=\"item\" aria-label=\"starred\"><div class=\"context\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-star\" class=\"s16\"></md-icon><div class=\"title\" translate=\"FM.STARRED\">Starred</div></div>\n</md-button><md-button class=\"item\" aria-label=\"starred\"><div class=\"context\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-folder-account\" class=\"s16\"></md-icon><div class=\"title\" translate=\"FM.SHARRED_WITH_ME\">\nSharred with me</div></div></md-button><md-button class=\"item\" aria-label=\"starred\"><div class=\"context\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-clock\" class=\"s16\"></md-icon><div class=\"title\" \ntranslate=\"FM.RECENT\">Recent</div></div></md-button><md-button class=\"item\" aria-label=\"starred\"><div class=\"context\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"s16\"></md-icon><div\n class=\"title\" translate=\"FM.OFFLINE\">Offline</div></div></md-button></div></div>");
$templateCache.put("app/main/apps/notes/sidenavs/main/main-sidenav.html","<div ms-scroll class=\"content\"><md-list><md-list-item ng-click=\"vm.filterChange(\'notes\')\" \nng-class=\"{\'selected\':vm.listType ===\'notes\'}\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-lightbulb\" class=\"mr-16\"></md-icon><span translate=\"NOTES.NOTES\">Notes</span></div></md-list-item>\n<md-list-item ng-click=\"vm.filterChange(\'reminders\')\" ng-class=\"{\'selected\':vm.listType ===\'reminders\'}\"><div \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-bell\" class=\"mr-16\"></md-icon><span \ntranslate=\"NOTES.REMINDERS\">Reminders</span></div></md-list-item><md-divider></md-divider><md-subheader \nclass=\"md-no-sticky\"><span translate=\"NOTES.LABELS\">Labels</span></md-subheader><md-list-item \nng-repeat=\"label in vm.labels\" ng-class=\"{\'selected\':vm.noteListType.name === label.name}\" class=\"label\" layout=\"row\" \nlayout-align=\"start center\" flex><ms-material-color-picker ng-model=\"label.color\"><md-icon class=\"mr-16\" \nmd-font-icon=\"icon-label\" ng-style=\"{color:$selectedColor.bgColorValue}\"></md-icon></ms-material-color-picker><span \nclass=\"label-name text-transclude\" flex ng-hide=\"editLabelForm.$visible\" ng-click=\"vm.filterChange(label)\">\n{{label.name}} </span><span flex editable-text=\"label.name\" e-form=\"editLabelForm\" ng-show=\"editLabelForm.$visible\">\n{{label.name}}</span><md-button class=\"md-icon-button\" ng-hide=\"editLabelForm.$visible\" \nng-click=\"editLabelForm.$show()\" aria-label=\"edit label\"><md-icon md-font-icon=\"icon-pencil\" class=\"s16\"></md-icon>\n</md-button><md-button class=\"md-icon-button\" ng-hide=\"editLabelForm.$visible\" \nng-click=\"vm.deleteLabel($event, label)\" aria-label=\"delete label\"><md-icon md-font-icon=\"icon-delete\" class=\"s16\">\n</md-icon></md-button></md-list-item><md-list-item class=\"new-label-form\" ng-show=\"newLabelForm.$visible\"><p \neditable-text=\"vm.newLabel.name\" e-form=\"newLabelForm\" onaftersave=\"vm.addNewLabel(vm.newLabel)\"></p></md-list-item>\n<md-list-item class=\"\" ng-click=\"newLabelForm.$show()\" ng-hide=\"newLabelForm.$visible\"><p class=\"md-accent-fg\" \ntranslate=\"NOTES.NEW_LABEL\">New Label</p></md-list-item><md-divider></md-divider><md-list-item \nng-click=\"vm.filterChange(\'archive\')\" ng-class=\"{\'selected\':vm.listType ===\'archive\'}\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-archive\" class=\"mr-16\"></md-icon><span \ntranslate=\"NOTES.ARCHIVE\">Archive</span></div></md-list-item></md-list></div>");
$templateCache.put("app/main/apps/todo/dialogs/task/task-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"taskForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between\"><span \nclass=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll><md-input-container class=\"md-block\"><label translate=\"TODO.TITLE\">Title</label><input name=\"title\" \nng-model=\"vm.task.title\" required><div ng-messages=\"taskForm.title.$error\" ng-show=\"taskForm.title.$touched\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"TODO.ERRORS.TITLE_REQUIRED\">Title field is required</span>\n</div></div></md-input-container><div class=\"tags\"><label translate=\"TODO.TAGS\">Tags</label><md-chips \nng-model=\"vm.task.tags\" md-transform-chip=\"vm.newTag($chip)\"><md-chip-template><span ng-if=\"$chip.color\" class=\"color\" \nng-style=\"{\'background-color\':$chip.color}\"></span> <span>{{$chip.label}}</span></md-chip-template></md-chips></div>\n<div layout-xs=\"column\" layout=\"row\"><div flex class=\"date-container\"><label translate=\"TODO.START_DATE\">Start Date\n</label><md-datepicker md-hide-icons=\"triangle\" flex ng-model=\"vm.task.startDate\" md-placeholder=\"Start Date\">\n</md-datepicker></div><div flex class=\"date-container\"><label translate=\"TODO.DUE_DATE\">Due Date</label><md-datepicker \nmd-hide-icons=\"triangle\" flex ng-model=\"vm.task.dueDate\" md-placeholder=\"Due Date\"></md-datepicker></div></div><div \nclass=\"notes\"><label translate=\"TODO.NOTES\">Notes</label><text-angular ng-model=\"vm.task.notes\"></text-angular></div>\n<div class=\"attachment-list\"><div class=\"attachment\" layout=\"row\" layout-align=\"space-between center\"><div><span \nclass=\"filename\">attachment-2.doc</span> <span class=\"size\">(12 Kb)</span></div><md-button class=\"md-icon-button\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"delete attachment\" class=\"s16\"></md-icon></md-button></div><div \nclass=\"attachment\" layout=\"row\" layout-align=\"space-between center\"><div><span class=\"filename\">attachment-1.jpg</span>\n <span class=\"size\">(350 Kb)</span></div><md-button class=\"md-icon-button\" aria-label=\"Delete attachment\" translate \ntranslate-attr-aria-label=\"TODO.DELETE_ATTACHMENT\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon>\n</md-button></div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" ng-if=\"!vm.newTask\" ng-click=\"vm.saveTask()\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"taskForm.$invalid || taskForm.$pristine\" aria-label=\"SAVE\" \ntranslate=\"TODO.SAVE\" translate-attr-aria-label=\"TODO.SAVE\">SAVE</md-button><md-button type=\"submit\" \nng-if=\"vm.newTask\" ng-click=\"vm.addNewTask()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"taskForm.$invalid || taskForm.$pristine\" aria-label=\"Add Task\" translate=\"TODO.ADD_TASK\" \ntranslate-attr-aria-label=\"TODO.ADD_TASK\">ADD TASK</md-button><md-button class=\"md-icon-button\" \naria-label=\"Attach file\" translate translate-attr-aria-label=\"TODO.ATTACH_FILE\"><md-icon md-font-icon=\"icon-paperclip\">\n</md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"Insert picture\" translate \ntranslate-attr-aria-label=\"TODO.INSERT_PICTURE\"><md-icon md-font-icon=\"icon-file-image-box\"></md-icon></md-button>\n</div><div layout=\"row\"><md-button class=\"md-icon-button\" ng-click=\"vm.deleteTask($event)\" aria-label=\"Delete\" \ntranslate translate-attr-aria-label=\"TODO.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span \ntranslate=\"TODO.DELETE\">DELETE</span></md-tooltip></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/todo/sidenavs/main/main-sidenav.html","<div class=\"header\" layout=\"column\" layout-align=\"space-between\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-checkbox-marked\" class=\"s24\"></md-icon>\n</span><span class=\"logo-text\" translate=\"TODO.TO_DO\">To-Do</span></div><md-select \nclass=\"project-selection simplified\" ng-model=\"vm.selectedProject\" placeholder=\"Select Project\"><md-option \nng-repeat=\"(project, title) in vm.projects\" value=\"{{project}}\">{{title}}</md-option></md-select></div><md-content \nclass=\"content\" flex ms-scroll><div class=\"add-task-button\"><md-button class=\"md-accent md-raised\" \nng-click=\"vm.openTaskDialog($event)\" aria-label=\"ADD TASK\" translate=\"TODO.ADD_TASK\" \ntranslate-attr-aria-label=\"TODO.ADD_TASK\">ADD TASK</md-button></div><div class=\"navigation-simple\" layout=\"column\">\n<md-button class=\"item\" aria-label=\"All Tasks\" translate translate-attr-aria-label=\"TODO.ALL_TASKS\" \nng-class=\"{\'selected\':vm.showAllTasks}\" ng-click=\"vm.resetFilters()\"><div layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-view-headline\" class=\"s16\"></md-icon><span class=\"title\" translate=\"TODO.ALL_TASKS\">\nAll Tasks</span></div></md-button><div class=\"item subheader\" translate=\"TODO.FILTERS\">Filters</div><md-button \nclass=\"item\" aria-label=\"Starred\" translate translate-attr-aria-label=\"TODO.STARRED\" \nng-click=\"vm.toggleFilterWithEmpty(\'starred\')\" ng-class=\"{\'selected\':vm.taskFilters.starred}\"><md-icon \nmd-font-icon=\"icon-star\" class=\"s16\"></md-icon><span class=\"title\" translate=\"TODO.STARRED\">Starred</span></md-button>\n<md-button class=\"item\" aria-label=\"Priority\" translate translate-attr-aria-label=\"TODO.PRIORITY\" \nng-click=\"vm.toggleFilterWithEmpty(\'important\')\" ng-class=\"{\'selected\':vm.taskFilters.important}\"><md-icon \nmd-font-icon=\"icon-alert-circle\" class=\"s16\"></md-icon><span class=\"title\" translate=\"TODO.PRIORITY\">Priority</span>\n</md-button><md-button class=\"item\" aria-label=\"Scheduled\" translate translate-attr-aria-label=\"TODO.SCHEDULED\" \nng-click=\"vm.toggleFilterWithEmpty(\'dueDate\')\" ng-class=\"{\'selected\':vm.taskFilters.dueDate}\"><md-icon \nmd-font-icon=\"icon-clock\" class=\"s16\"></md-icon><span class=\"title\" translate=\"TODO.SCHEDULED\">Scheduled</span>\n</md-button><md-button class=\"item\" aria-label=\"Today\" translate translate-attr-aria-label=\"TODO.TODAY\" \nng-click=\"vm.toggleFilterWithEmpty(\'startDate\')\" ng-class=\"{\'selected\':vm.taskFilters.startDate}\"><md-icon \nmd-font-icon=\"icon-calendar-today\" class=\"s16\"></md-icon><span class=\"title\" translate=\"TODO.TODAY\">Today</span>\n</md-button><md-button class=\"item\" aria-label=\"Done\" translate translate-attr-aria-label=\"TODO.DONE\" \nng-click=\"vm.toggleFilterWithEmpty(\'completed\')\" ng-class=\"{\'selected\':vm.taskFilters.completed}\"><md-icon \nmd-font-icon=\"icon-check\" class=\"s16\"></md-icon><span class=\"title\" translate=\"TODO.DONE\">Done</span></md-button>\n<md-button class=\"item\" aria-label=\"Deleted\" translate translate-attr-aria-label=\"TODO.DELETED\" \nng-click=\"vm.toggleFilter(\'deleted\')\" ng-class=\"{\'selected\':vm.taskFilters.deleted}\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"s16\"></md-icon><span class=\"title\" translate=\"TODO.DELETED\">Deleted</span>\n</md-button><div class=\"item subheader\" translate=\"TODO.TAGS\">Tags</div><md-button class=\"tag item\" \naria-label=\"tag {{tag.label}}\" ng-repeat=\"tag in vm.tags\" ng-click=\"vm.toggleTagFilter(tag)\" \nng-class=\"{\'selected\':vm.isTagFilterExists(tag)}\"><md-icon md-font-icon=\"icon-label\" class=\"s16\" \nng-style=\"{\'color\' : tag.color}\"></md-icon><span class=\"title\">{{tag.label}}</span></md-button></div></md-content>");
$templateCache.put("app/main/apps/todo/views/list/list-view.html","<div class=\"todo-items\" ng-sortable=\"vm.sortableOptions\" ng-model=\"vm.tasks\" \nng-class=\"{\'sortable\': vm.taskOrder === \'\'}\"><div class=\"todo-item\" md-ink-ripple layout=\"row\" \nlayout-align=\"start center\" ng-click=\"vm.openTaskDialog($event, task)\" \nng-repeat=\"task in vm.tasks | orderBy:vm.taskOrder:vm.taskOrderDescending | filter:global.search | filter:vm.taskFilters.search | filterByTags:vm.taskFilters.tags | filter:{\'completed\': vm.taskFilters.completed} | filter:{\'deleted\': vm.taskFilters.deleted} | filter:{\'important\': vm.taskFilters.important} | filter:{\'starred\':vm.taskFilters.starred} | filter:vm.filterByStartDate | filter:vm.filterByDueDate track by $index\" \nng-class=\"{\'starred\': task.starred, \'selected\': task.selected, \'completed\': task.completed}\"><div class=\"handle\" \nng-click=\"vm.preventDefault($event)\"><md-icon md-font-icon=\"icon-drag-vertical\" class=\"icon\"></md-icon></div>\n<md-checkbox class=\"no-label\" ng-checked=\"task.completed\" ng-click=\"vm.toggleCompleted(task, $event)\" \naria-label=\"{{task.completed ? \'Not completed\' : \'Completed\'}}\"></md-checkbox><div layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"info\" flex><div class=\"title\">{{task.title}}</div><div class=\"notes\">\n{{task.notes}}</div><div class=\"tags\" layout=\"row\" layout-align=\"start center\" layout-wrap><div class=\"tag\" \nlayout=\"row\" layout-align=\"start center\" data-ng-repeat=\"tag in task.tags\"><div class=\"tag-color\" \nng-style=\"{\'background-color\': tag.color}\"></div><div class=\"tag-label\">{{tag.label}}</div></div></div></div><div \nclass=\"buttons\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-alert-circle\" \nclass=\"is-important red-600-fg\" ng-if=\"task.important\"></md-icon><md-icon md-font-icon=\"icon-star\" \nclass=\"is-starred amber-600-fg\" ng-if=\"task.starred\"></md-icon><md-menu><md-button class=\"md-icon-button\" \naria-label=\"More\" translate translate-attr-aria-label=\"TODO.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\" \nng-click=\"$mdOpenMenu($event)\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"task.completed = !task.completed\" aria-label=\"Toggle done\" translate-attr-aria-label=\"TODO.TOGGLE_DONE\">\n<md-icon ng-class=\"task.completed === false ? \'grey-fg\' : \'blue-fg\'\" md-font-icon=\"icon-checkbox-marked-circle\" \nclass=\"s18\"></md-icon><span ng-show=\"!task.completed\" translate=\"TODO.MARK_AS_DONE\">Mark as done</span> <span \nng-show=\"task.completed\" translate=\"TODO.MARK_AS_UNDONE\">Mark as undone</span></md-button></md-menu-item><md-menu-item>\n<md-button ng-click=\"task.important = !task.important\" aria-label=\"Toggle important\" \ntranslate-attr-aria-label=\"TODO.TOGGLE_IMPORTANT\"><md-icon \nng-class=\"task.important === false ? \'grey-fg\' : \'red-600-fg\'\" md-font-icon=\"icon-alert-circle\" class=\"s18\"></md-icon>\n<span ng-show=\"!task.important\" translate=\"TODO.MARK_AS_IMPORTANT\">Mark as important</span> <span \nng-show=\"task.important\" translate=\"TODO.REMOVE_IMPORTANT\">Remove important</span></md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"task.starred = !task.starred\" aria-label=\"Toggle star\" \ntranslate-attr-aria-label=\"TODO.TOGGLE_STAR\"><md-icon ng-class=\"task.starred === false ? \'grey-fg\' : \'amber-600-fg\'\" \nmd-font-icon=\"icon-star\" class=\"s18\"></md-icon><span ng-show=\"!task.starred\" translate=\"TODO.ADD_STAR\">Add star</span> \n<span ng-show=\"task.starred\" translate=\"TODO.REMOVE_STAR\">Remove star</span></md-button></md-menu-item>\n</md-menu-content></md-menu></div></div></div></div>");
$templateCache.put("app/main/clients/views/batchRecords/dialog/batch-record-modal.html","<md-dialog aria-label=\"Batch Record Detail\" id=\"batchRecordModal\"><form name=\"form\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Envió y recepción de Movimientos</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"btCtrl.cancel()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div layout=\"column\" layout-gt-xs=\"row\" layout-wrap><md-input-container \nclass=\"md-block no-errors-spacer mb-0\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"33\"><label>Estatus</label><md-select \nng-model=\"btCtrl.batchRecord.status\" name=\"status\" required><md-option ng-value=\"$index\" \nng-repeat=\"($index,status) in btCtrl.statusBatchRecords\">{{status}}</md-option></md-select><div \nng-messages=\"form.status.$error\" role=\"alert\"><div ng-message=\"required\">Estatus es requerido</div></div>\n</md-input-container><md-input-container class=\"md-block no-errors-spacer mb-0\" flex=\"100\" flex-gt-xs=\"50\" \nflex-gt-sm=\"33\"><label>Estatus cola</label><md-select ng-model=\"btCtrl.batchRecord.queueStatus\" name=\"queueStatus\" \nrequired><md-option ng-value=\"$index\" ng-repeat=\"($index,statusQueue) in btCtrl.statusQueueBatchRecords\">\n{{statusQueue}}</md-option></md-select><div ng-messages=\"form.queueStatus.$error\" role=\"alert\"><div \nng-message=\"required\">Estatus cola es requerido</div></div></md-input-container><md-input-container \nclass=\"md-block no-errors-spacer mb-0\" flex=\"100\" flex-gt-sm=\"33\"><label>Lote</label><input \nng-model=\"btCtrl.batchRecord.batch\" ng-required=\"[1,2].indexOf(btCtrl.batchRecord.status)>-1\" name=\"batch\"><div \nng-messages=\"form.batch.$error\"><div ng-message=\"required\">Lote es requerido</div></div></md-input-container>\n<md-input-container flex=\"100\" flex-gt-sm=\"50\" class=\"md-block date-picker2 no-errors-spacer mb-0\"><label>\nFecha de recibido</label><md-datepicker md-hide-icons=\"calendar\" \nng-required=\"[1,2].indexOf(btCtrl.batchRecord.status)>-1\" input-date-miliseconds \nng-model=\"btCtrl.batchRecord.receivedDate\" name=\"receivedDate\" class=\"md-block\"></md-datepicker><div \nng-messages=\"form.receivedDate.$error\"><div ng-message=\"required\">Fecha es requerido</div></div></md-input-container>\n<md-input-container flex=\"100\" flex-gt-sm=\"50\" class=\"md-block date-picker2 no-errors-spacer mb-0\"><label>\nFecha de archivado</label><md-datepicker md-hide-icons=\"calendar\" input-date-miliseconds \nng-model=\"btCtrl.batchRecord.archivedDate\" name=\"archivedDate\" class=\"md-block\"></md-datepicker></md-input-container>\n<md-input-container flex=\"100\" flex-gt-sm=\"33\" class=\"md-block no-errors-spacer mb-0\"><label>Certificado</label><input \nng-model=\"btCtrl.batchRecord.certificate\" name=\"certificate\"></md-input-container><md-input-container flex=\"100\" \nflex-gt-sm=\"33\" class=\"md-block no-errors-spacer mb-0\"><label>Huella Digital</label><input \nng-model=\"btCtrl.batchRecord.digitalPrint\" name=\"digitalPrint\"></md-input-container><md-input-container flex=\"100\" \nflex-gt-sm=\"33\" class=\"md-block no-errors-spacer mb-0\"><label>Folio</label><input ng-model=\"btCtrl.batchRecord.folio\" \nname=\"folio\"></md-input-container><md-input-container flex=\"100\" class=\"md-block no-errors-spacer mb-0\"><label>\nFolio Digital</label><input ng-model=\"btCtrl.batchRecord.digitalStamp\" name=\"digitalStamp\"></md-input-container><div \nflex=\"100\" layout=\"row\"><md-input-container flex class=\"md-block no-errors-spacer mb-0\"><label>URL Notificación</label>\n<input ng-model=\"btCtrl.batchRecord.notificationUrl\" name=\"notificationUrl\"></md-input-container><div flex=\"nogrow\">\n<md-button class=\"md-raised\" ng-click=\"btCtrl.fireWebhook(btCtrl.batchRecord.fid)\" aria-label=\"Send notification\" \nng-disabled=\"!btCtrl.batchRecord.notificationUrl\"><md-tooltip>Enviar notificación</md-tooltip><md-icon \nmd-font-icon=\"icon-send\"></md-icon></md-button></div></div><div flex=\"100\" ng-if=\"btCtrl.batchRecord.sended\"><h5 \nclass=\"m-0\">Ultima notificación enviada:{{btCtrl.batchRecord.sended | date : \'dd/MM/yyyy hh:mm a\'}}</h5></div></div>\n<div ng-if=\"btCtrl.batchRecord.error\"><h3 class=\"red-700-fg text-center\"><md-icon md-font-icon=\"icon-alert-circle\" \nclass=\"red-700-fg\"></md-icon>{{btCtrl.batchRecord.error}}</h3></div><fieldset ng-if=\"btCtrl.tasks.length > 0\"><legend>\nTareas pendientes o con errores</legend><h4 ng-class=\"{\'red-800-fg\':task.failedReason}\" class=\"m-0\" \nng-repeat=\"task in btCtrl.tasks\">Ejecución: {{task.executionTime | date : \'dd/MM/yyyy hh:mm a\'}} <span \nng-if=\"task.failedReason\">Error: {{task.failedReason}}</span></h4></fieldset><div layout=\"row\" \nlayout-align=\"space-between center\"><div flex><md-checkbox class=\"mt-5\" ng-model=\"addTask\" aria-label=\"addTask\">\nEjecutar tarea</md-checkbox></div><div flex=\"nogrow\"><md-switch ng-model=\"btCtrl.batchRecord.archived\" \naria-label=\"archived\">Archivado</md-switch></div></div><fieldset><legend>Movimientos</legend><div class=\"batchDetail\" \nng-class=\"{\'red-800-fg\':batchDetail.error}\" ng-repeat=\"($index,batchDetail) in btCtrl.batchDetails\"><div><label>Nombre:\n</label><span>{{batchDetail.nss}} - {{batchDetail.name}} ({{batchDetail.curp}})</span></div><div><label>Sueldo:</label>\n<span>\n{{batchDetail.sbc | currency}} {{batchDetail.salaryType | getSomethingOfArrayFB : btCtrl.salaryTypes : \'name\' : \'S/N\' : \'humansiteCode\'}}\n</span></div><div><label>Tipo de trabajador:</label><span>\n{{batchDetail.workerType | getSomethingOfArrayFB : btCtrl.workerTypes : \'name\' : \'S/N\' : \'humansiteCode\'}} - {{batchDetail.workDay | getSomethingOfArrayFB : btCtrl.workDays : \'name\' : \'S/N\' : \'humansiteCode\'}}\n</span></div><div><label>UMF:</label><span>{{batchDetail.umf}}</span></div><div><label>Movimiento:</label><span>\n{{batchDetail.movementType | typeName}} {{batchDetail.date | date : \'dd/MM/yyyy\'}} {{batchDetail.dismissTypeCode ? (batchDetail.dismissTypeCode | getSomethingOfArrayFB : btCtrl.dismissTypes : \'name\' : \'S/N\' : \'humansiteCode\') : \"\"}}\n</span></div><div ng-if=\"batchDetail.error\">{{batchDetail.error}}</div><hr ng-if=\"!$last\"></div></fieldset>\n</md-dialog-content><md-dialog-actions layout=\"row\" ng-if=\"form.$dirty\"><span flex></span><md-button \nng-click=\"btCtrl.save(btCtrl.batchRecord,addTask)\" ng-disabled=\"form.$invalid\">Guardar</md-button></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/clients/views/folios/dialogs/form-folio.html","<md-dialog id=\"foliosDialog\" aria-label=\"Create Folio\"><form name=\"folioData\" novalidate ng-cloak><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Generar folio(s)</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"close()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><md-input-container class=\"md-block\"><label>Nómina</label><md-select \nng-model=\"payroll\" name=\"payroll\" ng-change=\"getIssuers(payroll)\" required><md-select-header><input autocomplete=\"off\" \ntype=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"payrollSelectFilter\" \nplaceholder=\"Busque una nómina\"></md-select-header><md-option \nng-if=\"!F.permissionToAccessAllPayrolls && payroll.active\" ng-value=\"payroll.$id\" \nng-repeat=\"payroll in L.payrolls | orderBy:\'name\' | filter:payrollSelectFilter\">{{payroll.name}}</md-option><md-option \nng-if=\"F.permissionToAccessAllPayrolls && payroll.active\" ng-value=\"payroll.$id\" \nng-repeat=\"payroll in L.allPayrolls | orderBy:\'name\' | filter:payrollSelectFilter\">{{payroll.name}}</md-option>\n</md-select></md-input-container><fieldset class=\"demo-fieldset\"><legend class=\"demo-legend\">Procesos</legend><div \nlayout=\"row\" layout-wrap flex><div flex-xs flex=\"50\"><md-checkbox aria-label=\"Select All\" ng-checked=\"isChecked()\" \nmd-indeterminate=\"isIndeterminate()\" ng-click=\"toggleAll()\"><span ng-if=\"isChecked()\">NINGUNO</span> <span \nng-if=\"!isChecked()\">TODOS</span></md-checkbox></div><div class=\"demo-select-all-checkboxes\" flex=\"100\" \nng-repeat=\"item in items\"><md-checkbox ng-checked=\"exists(item, selected)\" ng-click=\"toggle(item, selected)\">\n{{ issuersName[item].name }} [{{ issuersName[item].proccess }}]</md-checkbox></div></div></fieldset><hr \nng-if=\"generating && !folio.folios\"><div class=\"container\" ng-if=\"generating && !folio.folios\"><md-progress-linear \nmd-mode=\"query\"></md-progress-linear><div class=\"bottom-block\"><span>Generando...</span></div></div><div \nng-if=\"folio.folios\"><p ng-repeat=\"issuer in folio.folios\">{{issuer.process}}: <strong>{{issuer.issuer}}</strong>\n Folio: <strong>{{issuer.folio}}</strong></p></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nclass=\"md-accent md-raised md-primary\" ng-if=\"!generating && !folio.folios\" \nng-disabled=\"folioData.$invalid || selected.length==0\" ng-click=\"generate(selected)\">Generar Folio(s)<md-icon \nmd-font-icon=\"icon-send\" aria-label=\"send\"></md-icon></md-button><md-button class=\"md-accent md-raised md-primary\" \nng-if=\"generating\" ng-click=\"close()\">Cerrar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/clients/views/incidencesRequests/forms/incidence-modal.html","<div flex><div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex><label>Tipo de Incidencia</label><md-select\n ms2-autofocus ng-if=\"!allowShow.payroll\" ng-disabled=\"action==\'edit\'\" ng-model=\"incidence.incidenceType\" \nname=\"incidenceType\" ng-change=\"checkIfValid(incidence.date, incidence.incidenceType, incidence.value)\" required>\n<md-select-header><input type=\"text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"incidenceTypeSelectFilter\" \nplaceholder=\"Busque un tipo de incidencia\"></md-select-header><md-option \nng-if=\"!incidenceType.automatic && !incidenceType.requireConfirmation\" ng-value=\"incidenceType.$id\" \nng-repeat=\"incidenceType in incidencesTypesForPayroll | orderBy:\'name\' | filter:incidenceTypeSelectFilter\">\n{{incidenceType.name}}</md-option></md-select><div ng-messages=\"form.incidenceType.$error\" \nng-show=\"form.incidenceType.$touched || form.incidenceType.$dirty\" role=\"alert\"><div ng-message=\"required\">\nTipo de Incidencia es requerido</div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container \nclass=\"md-block date-picker\" flex=\"50\"><label>Fecha</label><md-datepicker md-min-date=\"F.minIncidenceRequestDate\" \nmd-max-date=\"F.maxIncidenceRequestDate\" md-hide-icons=\"triangle\" \nng-change=\"checkIfValid(incidence.date, incidence.incidenceType, incidence.value)\" input-date-miliseconds \nng-model=\"incidence.date\" name=\"date\" required></md-datepicker><div ng-messages=\"form.date.$error\" \nng-show=\"form.date.$touched || form.date.$dirty\" role=\"alert\"><div ng-message=\"required\">\nFecha de la incidencia es requerida</div><div ng-message=\"mindate\">\nFecha de la incidencia debe ser a partir de {{F.minIncidenceRequestDate | date}}</div><div ng-message=\"min\">\nFecha de la incidencia debe ser a partir de {{F.minIncidenceRequestDate | date}}</div><div ng-message=\"maxdate\">\nFecha de la incidencia debe ser antes de {{F.maxIncidenceRequestDate | date}}</div></div></md-input-container>\n<md-input-container class=\"md-block\" flex=\"nogrow\"><label>Año</label><input type=\"number\" \nng-model=\"incidence.calendar\" name=\"calendar\" required disabled=\"disabled\"></md-input-container><md-input-container \nclass=\"md-block\" flex=\"nogrow\"><label>Periodo</label><input type=\"number\" ng-model=\"incidence.period\" name=\"period\" \nrequired disabled=\"disabled\"></md-input-container></div><div layout-gt-xs=\"row\" ng-if=\"!noCalendars\">\n<md-input-container class=\"md-block\" flex=\"30\" \nng-if=\"!incidenceType.noEditValue && incidenceType.inputType===\'integer\' && incidenceType.allowNegative\"><label>\nCantidad</label><input nd-disabled=\"!F.addMode\" type=\"number\" name=\"value\" max=\"{{maxAllowed}}\" \nng-change=\"checkIfValid(incidence.date, incidence.incidenceType, incidence.value)\" \nng-model-options=\"{ debounce: F.debounceTime }\" ng-model=\"incidence.value\" step=\"1\" required><div \nng-messages=\"form.value.$error\" ng-show=\"form.value.$touched || form.value.$dirty\" role=\"alert\"><div \nng-message=\"required\">Cantidad es requerido</div><div ng-message=\"max\">\nDebe insertar un numero menor o igual a {{maxAllowed}}</div><div ng-message=\"step\">No se admiten decimales</div></div>\n</md-input-container><md-input-container class=\"md-block\" flex=\"30\" \nng-if=\"!incidenceType.noEditValue && incidenceType.inputType!==\'integer\' && incidenceType.allowNegative\"><label>\nCantidad</label><input nd-disabled=\"!F.addMode\" type=\"number\" name=\"value\" max=\"{{maxAllowed}}\" \nng-change=\"checkIfValid(incidence.date, incidence.incidenceType, incidence.value)\" \nng-model-options=\"{ debounce: F.debounceTime }\" ng-model=\"incidence.value\" step=\"0.01\" required><div \nng-messages=\"form.value.$error\" ng-show=\"form.value.$touched || form.value.$dirty\" role=\"alert\"><div \nng-message=\"required\">Cantidad es requerido</div><div ng-message=\"max\">\nDebe insertar un numero menor o igual a {{maxAllowed}}</div></div></md-input-container><md-input-container \nclass=\"md-block\" flex=\"30\" \nng-if=\"!incidenceType.noEditValue && incidenceType.inputType===\'integer\' && !incidenceType.allowNegative\"><label>\nCantidad</label><input nd-disabled=\"!F.addMode\" type=\"number\" name=\"value\" max=\"{{maxAllowed}}\" min=\"0\" \nng-change=\"checkIfValid(incidence.date, incidence.incidenceType, incidence.value)\" \nng-model-options=\"{ debounce: F.debounceTime }\" ng-model=\"incidence.value\" step=\"1\" required><div \nng-messages=\"form.value.$error\" ng-show=\"form.value.$touched || form.value.$dirty\" role=\"alert\"><div \nng-message=\"required\">Cantidad es requerido</div><div ng-message=\"max\">\nDebe insertar un numero menor o igual a {{maxAllowed}}</div><div ng-message=\"min\">Solo se aceptan números positivos\n</div><div ng-message=\"step\">No se admiten decimales</div></div></md-input-container><md-input-container \nclass=\"md-block\" flex=\"30\" \nng-if=\"!incidenceType.noEditValue && incidenceType.inputType!==\'integer\' && !incidenceType.allowNegative\"><label>\nCantidad</label><input nd-disabled=\"!F.addMode\" type=\"number\" name=\"value\" max=\"{{maxAllowed}}\" min=\"0\" \nng-change=\"checkIfValid(incidence.date, incidence.incidenceType, incidence.value)\" \nng-model-options=\"{ debounce: F.debounceTime }\" ng-model=\"incidence.value\" step=\"0.01\" required><div \nng-messages=\"form.value.$error\" ng-show=\"form.value.$touched || form.value.$dirty\" role=\"alert\"><div \nng-message=\"required\">Cantidad es requerido</div><div ng-message=\"min\">Solo se aceptan números positivos</div><div \nng-message=\"max\">Debe insertar un numero menor o igual a {{maxAllowed}}</div></div></md-input-container>\n<md-input-container class=\"md-block\" flex><label>Comentario</label><textarea class=\"uppercased\" \nng-model-options=\"{ debounce: F.debounceTime }\" name=\"comments\" ng-model=\"incidence.comments\" md-maxlength=\"250\" \nmaxlength=\"250\"></textarea><div ng-messages=\"form.comments.$error\" \nng-show=\"form.comments.$touched || form.comments.$dirty\" role=\"alert\"><div ng-message=\"maxlength\">\nComentario no debe tener más de 250 caracteres</div></div></md-input-container></div></div>");
$templateCache.put("app/main/clients/views/incidencesRequests/forms/incidencesRequest.html","<div flex><div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex><label>Nómina</label><md-select \nms2-autofocus ng-disabled=\"!F.addMode\" ng-model=\"incidencesRequest.payroll\" name=\"payroll\" required><md-select-header>\n<input type=\"text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"payrollSelectFilter\" \nplaceholder=\"Busque una nomina\"></md-select-header><md-option ng-if=\"!F.permissionToAccessAllPayrolls\" \nng-value=\"payroll.$id\" ng-disabled=\"!payroll.active\" \nng-repeat=\"payroll in L.payrolls | orderBy:\'name\' | filter:payrollSelectFilter\">{{payroll.name}}</md-option><md-option \nng-if=\"F.permissionToAccessAllPayrolls\" ng-value=\"payroll.$id\" ng-disabled=\"!payroll.active\" \nng-repeat=\"payroll in L.allPayrolls | orderBy:\'name\' | filter:payrollSelectFilter\">{{payroll.name}}</md-option>\n</md-select><div ng-messages=\"form.payroll.$error\" ng-show=\"form.payroll.$touched || form.payroll.$dirty\" role=\"alert\">\n<div ng-message=\"required\">Nómina es requerido</div></div></md-input-container><md-input-container class=\"md-block\" \nflex=\"40\" ng-if=\"!noCalendars\"><label>Tipo de Incidencia</label><md-select \nng-disabled=\"!F.addMode||!incidencesRequest.payroll||incidencesRequest.payroll==\'global\'\" \nng-model=\"incidencesRequest.incidenceType\" name=\"incidenceType\" required><md-select-header><input type=\"text\" \nng-keydown=\"$event.stopPropagation()\" ng-model=\"incidenceTypeSelectFilter\" placeholder=\"Busque un tipo de incidencia\">\n</md-select-header><md-option \nng-if=\"incidenceType.allowManual && !incidenceType.automatic && !incidenceType.requireConfirmation && incidenceType.processes.payroll\" \nng-value=\"incidenceType.$id\" \nng-repeat=\"incidenceType in incidencesTypes | orderBy:\'name\' | filter:incidenceTypeSelectFilter\">{{incidenceType.name}}\n</md-option></md-select><div ng-messages=\"form.incidenceType.$error\" \nng-show=\"form.incidenceType.$touched || form.incidenceType.$dirty\" role=\"alert\"><div ng-message=\"required\">\nTipo de Incidencia es requerido</div></div></md-input-container><md-input-container class=\"md-input-has-placeholder\" \nflex=\"nogrow\" ng-if=\"!noCalendars\"><md-checkbox ng-disabled=\"!F.addMode\" ng-model=\"incidencesRequest.allPayroll\" \naria-label=\"Toda la nomina\" ng-change=\"employeeSelected = (incidencesRequest.allPayroll) ? null : employeeSelected\" \nng-false-value=\"0\">Toda la nómina</md-checkbox></md-input-container></div><div layout-gt-xs=\"row\" ng-if=\"!noCalendars\">\n<md-input-container class=\"md-block date-picker\" flex><label>Fecha</label><md-datepicker ng-disabled=\"!F.addMode\" \nmd-min-date=\"F.minIncidenceRequestDate\" md-max-date=\"F.maxIncidenceRequestDate\" md-hide-icons=\"triangle\" \nng-change=\"getPeriod(incidencesRequest.payroll, incidencesRequest.date)\" input-date-miliseconds \nng-model=\"incidencesRequest.date\" name=\"date\" required></md-datepicker><div ng-messages=\"form.date.$error\" \nng-show=\"form.date.$touched || form.date.$dirty\" role=\"alert\"><div ng-message=\"required\">\nFecha de la incidencia es requerida</div><div ng-message=\"mindate\">\nFecha de la incidencia debe ser a partir de {{F.minIncidenceRequestDate | date}}</div><div ng-message=\"min\">\nFecha de la incidencia debe ser a partir de {{F.minIncidenceRequestDate | date}}</div><div ng-message=\"maxdate\">\nFecha de la incidencia debe ser antes de {{F.maxIncidenceRequestDate | date}}</div></div></md-input-container>\n<md-input-container class=\"md-block\" flex=\"nogrow\"><label>Año</label><input type=\"number\" \nng-model=\"incidencesRequest.calendar\" name=\"calendar\" required disabled=\"disabled\"></md-input-container>\n<md-input-container class=\"md-block\" flex=\"nogrow\"><label>Periodo</label><input type=\"number\" \nng-model=\"incidencesRequest.period\" name=\"period\" required disabled=\"disabled\"></md-input-container></div><div \nlayout-gt-xs=\"row\" ng-if=\"!noCalendars\"><md-input-container class=\"md-block\" flex=\"30\"><label>Cantidad</label><input \nnd-disabled=\"!F.addMode\" type=\"number\" name=\"value\" ng-model=\"incidencesRequest.value\" required><div \nng-messages=\"form.value.$error\" ng-show=\"form.value.$touched || form.value.$dirty\" role=\"alert\"><div \nng-message=\"required\">Cantidad es requerido</div></div></md-input-container><md-input-container class=\"md-block\" flex>\n<label>Comentario</label><textarea ng-disabled=\"!F.addMode\" class=\"uppercased\" \nng-model-options=\"{ debounce: F.debounceTime }\" name=\"comments\" ng-model=\"incidencesRequest.comments\" \nmd-maxlength=\"250\" maxlength=\"250\"></textarea><div ng-messages=\"form.comments.$error\" \nng-show=\"form.comments.$touched || form.comments.$dirty\" role=\"alert\"><div ng-message=\"maxlength\">\nComentario no debe tener más de 250 caracteres</div></div></md-input-container></div><div layout=\"column\" \nng-if=\"incidencesRequest.payroll && !noCalendars\"><div flex class=\"md-block\" layout=\"row\" layout-align=\"start center\">\n<md-input-container flex><md-icon count-icon array=\"activeEmployees\"></md-icon><label>Empleado</label><md-select \nng-disabled=\"!F.addMode||incidencesRequest.allPayroll\" ms2-autofocus ng-required=\"!incidencesRequest.allPayroll\" \nng-model=\"employeeSelected\" name=\"employee\"><md-select-header><input type=\"text\" ng-keydown=\"$event.stopPropagation()\" \nng-model=\"employeeSelectFilter\" placeholder=\"Busque un empleado\"></md-select-header><md-option ng-value=\"employee.$id\" \nng-repeat=\"employee in activeEmployees | orderBy:\'name\' | filter:employeeSelectFilter\">\n{{employee.data.nss}} {{employee.data.name}}</md-option></md-select></md-input-container><div flex=\"nogrow\"><md-button \nclass=\"md-icon-button\" ng-if=\"!incidencesRequest.allPayroll\" \nng-disabled=\"!employeeSelected || !incidencesRequest.period || !incidencesRequest.value || !incidencesRequest.incidenceType || !F.addMode\" \naria-label=\"Add Incidence\" \nng-click=\"addIncidence({c:incidencesRequest.comments, d:incidencesRequest.date, e:employeeSelected,it:incidencesRequest.incidenceType,v:incidencesRequest.value,add:true,s:0})\">\n<md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon></md-button><md-button class=\"md-icon-button\" \nng-if=\"incidencesRequest.allPayroll\" \nng-disabled=\"!incidencesRequest.period || !incidencesRequest.value || !incidencesRequest.incidenceType || !F.addMode\" \naria-label=\"Add Incidence\" ng-click=\"addIncidenceForAllPayroll()\"><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\">\n</md-icon></md-button></div></div><div flex class=\"md-block\" \nng-if=\"(incidencesRequest.incidences|getTotalValideIncidences)\"><md-table-container><table md-table class=\"row-border\">\n<thead md-head md-order=\"order\"><tr md-row><th md-column md-order-by=\"it\"><span>Incidencia</span></th><th md-column \nmd-order-by=\"d\"><span>Fecha</span></th><th md-column md-order-by=\"p\"><span>Periodo</span></th><th md-column \nmd-order-by=\"e\"><span>Empleado</span></th><th md-column><span>Comentario</span></th><th md-column md-order-by=\"v\">\n<span>Cantidad</span></th><th md-column><span>Accion</span></th></tr></thead><tbody md-body><tr md-row md-auto-select \nng-repeat=\"incidence in (incidencesRequest.incidences|objsToArray)| orderBy: order\" ng-if=\"!incidence.remove\"><td \nmd-cell>{{incidence.it|getSomethingOfArrayFB:incidencesTypes:\"name\":\"N/A\"}}</td><td md-cell>\n{{incidence.d|date:F.dateFormat}}</td><td md-cell>{{incidence.p}}</td><td md-cell>\n{{incidence.e|getSomethingOfArrayFB:employees:\"data.name\":\"N/A\"}}</td><td md-cell>{{incidence.c}}</td><td md-cell>\n{{incidence.v}}</td><td md-cell><md-button class=\"md-icon-button\" aria-label=\"Remove Incidences\" \nng-disabled=\"!F.addMode\" ng-click=\"removeIncidence(incidence.$id)\"><md-icon md-font-icon=\"icon-delete\" \naria-label=\"Remove\"></md-icon></md-button></td></tr></tbody></table></md-table-container></div></div></div>");
$templateCache.put("app/main/clients/views/incidences/dialogs/import-incidences-geo.html","<md-dialog aria-label=\"Import Incidences Geo\" id=\"importIncidencesGeoDialog\" flex=\"100\" flex-gt-sm=\"90\"><form \nname=\"stepper\" ms-stepper ng-submit=\"impIncGeoCtrl.applyIncidences()\" ng-model=\"impIncGeoCtrl.stepper\" novalidate>\n<ms-stepper-step ng-form=\"step1\" step=\"1\" step-title=\"\'Obtener la incidencias\'\"><div \nng-include=\"\'app/main/clients/views/incidences/dialogs/step-update1.html\'\"></div></ms-stepper-step><ms-stepper-step \nng-form=\"step2\" step=\"2\" step-title=\"\'Verifica la información\'\"><div \nng-include=\"\'app/main/clients/views/incidences/dialogs/step-update2.html\'\"></div></ms-stepper-step><ms-stepper-step \nng-form=\"step3\" step=\"3\" step-title=\"\'Aplica la información\'\"><div \nng-include=\"\'app/main/clients/views/incidences/dialogs/step-update3.html\'\"></div></ms-stepper-step></form></md-dialog>");
$templateCache.put("app/main/clients/views/incidences/dialogs/import-incidences.html","<md-dialog aria-label=\"Import Variables\"><form name=\"stepper\" ms-stepper ng-submit=\"applyIncidences()\" \nng-model=\"stepper\" novalidate><ms-stepper-step ng-form=\"step1\" step=\"1\" step-title=\"\'Sube el archivo\'\"><div \nng-include=\"\'app/main/clients/views/incidences/dialogs/step-1.html\'\"></div></ms-stepper-step><ms-stepper-step \nng-form=\"step2\" step=\"2\" step-title=\"\'Verifica y aplica la información\'\"><div \nng-include=\"\'app/main/clients/views/incidences/dialogs/step-2.html\'\"></div></ms-stepper-step></form></md-dialog>");
$templateCache.put("app/main/clients/views/incidences/dialogs/step-1.html","<div class=\"md-inline-form\"><div flex><div ng-if=\"loading\"><md-progress-linear md-mode=\"indeterminate\">\n</md-progress-linear><span class=\"md-subhead\">Cargando..</span></div><md-input-container class=\"md-block evenPadding\" \nflex><label>Nómina</label><md-select ng-model=\"payroll\" name=\"payroll\" required><md-select-header><input \nautocomplete=\"off\" type=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"payrollSelectFilter\" \nplaceholder=\"Busque una nómina\"></md-select-header><md-option ng-value=\"payroll.$id\" ng-if=\"payroll.active\" \nng-repeat=\"payroll in (F.permissionToAccessAllPayrolls?L.allPayrolls:L.payrolls) | orderBy:\'class\' | filter:payrollSelectFilter\">\n{{payroll.class}} {{payroll.name}}</md-option></md-select><div ng-messages=\"form.payroll.$error\" role=\"alert\"><div \nng-message=\"required\">Nómina es requerido</div></div></md-input-container><md-input-container \nclass=\"md-block evenPadding\" flex md-no-float><label>Tipo de operación</label><md-select ng-model=\"operationType\" \nng-disabled=\"!payroll\" placeholder=\"Tipo de operación\" ng-change=\"getOperations(operationType,payroll)\"><md-option \nng-value=\"undefined\">Ordinaria</md-option><md-option ng-value=\'\"chrisBonusRecord\"\'>Aguinaldo</md-option><md-option \nng-value=\'\"ptuRecord\"\'>PTU</md-option><md-option ng-value=\'\"special\"\'>Especial</md-option><md-option \nng-value=\'\"extraordinary\"\'>Extraordinaria</md-option><md-option ng-value=\'\"ptuDistributionRecord\"\'>Distribución PTU\n</md-option></md-select></md-input-container><md-input-container class=\"md-block evenPadding\" flex \nng-show=\"operationType\"><label>Operación</label><md-select ng-model=\"operationId\" name=\"operationId\" \nng-required=\"operationType\"><md-option ng-value=\"operation.fid\" ng-repeat=\"operation in operations\">\n{{operationType === \'ptuDistributionRecord\' ? \'Calendario:\' + operation.calendar : \'Periodo:\' + operation.specialPeriod}}, Empleado(s):{{operation.employees | objectsLength : 0}}, Fecha de creación:{{operation.created.atTime | date: F.dateFormat}}\n</md-option></md-select><div ng-messages=\"form.operationId.$error\" role=\"alert\"><div ng-message=\"required\">\nOperación es requerido</div></div></md-input-container><div layout=\"row\" layout-align=\"center start\"><div flex>\n<lf-ng-md-file-input lf-files=\"filesArray\" lf-placeholder=\"Selecciona el archivo csv\" \nlf-drag-and-drop-label=\"csv - Max: 10MB\" lf-browse-label=\"{{\'EC.search\' | translate}}\" \nlf-remove-label=\"{{\'EC.remove\' | translate}}\" lf-filesize=\"10MB\" lf-required lf-mimetype=\"text/csv\" accept=\"text/csv\" \nname=\"variablesFile\" lf-api=\"csvApi\"></lf-ng-md-file-input><div ng-messages=\"step1.variablesFile.$error\" \nstyle=\"color:red\"><div ng-message=\"required\">Archivo requerido</div><div ng-message=\"maxcount\">Demasiados archivos\n</div><div ng-message=\"filesize\">Archivo demasiado grande</div><div ng-message=\"totalsize\">\nEspacio total demasiado grande</div><div ng-message=\"mimetype\">Formato de archivo no valido</div></div></div><div \nflex=\"nogrow\"><md-button ng-disabled=\"step1.variablesFile.$invalid || !payroll || (operationType && !operationId)\" \nng-click=\"uploadCsv(filesArray,payroll,operationType,operationId)\" aria-label=\"Upload File\" \nclass=\"md-fab md-mini md-accent md-hue-2\"><md-icon md-font-icon=\"icon-upload\" aria-label=\"Upload\"></md-icon><md-tooltip\n md-direction=\"right\">Subir Archivo</md-tooltip></md-button></div></div><input name=\"data\" required ng-model=\"data\" \nrequired type=\"hidden\"><div flex=\"no-grow\" layout=\"row\"><span flex></span> <a class=\"downloadLink\" target=\"_blanc\" \nhref=\"assets/csv/import-incidences-blanc.csv\">descargar template<md-icon md-font-icon=\"icon-file-excel\" \naria-label=\"download variables template\"></md-icon></a></div></div><code flex ng-if=\"!variables.file\">\nCampos necesarios: Numero de Empleado, Clave de incidencia, Fecha, Cantidad</code></div>");
$templateCache.put("app/main/clients/views/incidences/dialogs/step-2.html","<div class=\"md-inline-form\" flex layout=\"column\"><div ng-if=\"loading\" flex><md-progress-linear md-mode=\"indeterminate\">\n</md-progress-linear><span class=\"md-subhead\">Cargando..</span></div><div ng-show=\"false\"><md-checkbox \nng-model=\"hasAnyValid\" required></md-checkbox></div><div flex><table class=\"simple incidencesImport\" style=\"zoom: .8\">\n<thead><tr><th>Empleado</th><th>Incidencia</th><th style=\"max-width: 200px\">Fecha</th><th>Cantidad</th><th>Nómina</th>\n<th>Calendario</th><th>Periodo</th></tr></thead><tbody><tr \nng-repeat=\"record in data | orderBy : [\'-errors\',\'recordNumber\'] | limitTo: pagination.limit : (pagination.page - 1) * pagination.limit\">\n<td class=\"text-bold\"><md-button ng-if=\"record.errors.length>0\" aria-label=\"Upload File\" \nclass=\"md-icon-button md-warn md-hue-2 no-margin\"><md-icon md-font-icon=\"icon-sim-alert\" aria-label=\"Upload\"></md-icon>\n<md-tooltip md-direction=\"right\"><label ng-repeat=\"error in record.errors\">{{error}},</label></md-tooltip></md-button>\n<md-button style=\"zoom: .8\" ng-if=\"!record.errors.length && !record.applied\" aria-label=\"Upload File\" \nclass=\"md-icon-button md-primary no-margin\"><md-icon md-font-icon=\"icon-checkbox-marked\" aria-label=\"Upload\"></md-icon>\n<md-tooltip md-direction=\"right\">Sin problemas</md-tooltip></md-button><md-button style=\"zoom: .8\" \nng-if=\"record.applied\" aria-label=\"Upload File\" class=\"md-icon-button md-primary md-hue-2 no-margin\"><md-icon \nmd-font-icon=\" icon-check-all\" aria-label=\"Upload\"></md-icon><md-tooltip md-direction=\"right\">Aplicado</md-tooltip>\n</md-button>{{record.employee.data.name || \"No encontrado\"}}({{record.recordNumber}})</td><td>\n{{record.incidenceType.name || \"No encontrado\"}}</td><td style=\"max-width: 100px\"><span class=\"text-truncate\">\n{{record.Fecha}}</span></td><td>{{record.Cantidad}}</td><td>{{record.payroll|nameOfL:L.allPayrolls}}</td><td>\n{{record.calendar}}</td><td>{{record.period}}</td></tr></tbody></table><md-table-pagination layout-align=\"center\" \nlayout-gt-xs=\"row\" layout-xs=\"column\" ng-show=\"data.length\" md-label=\"{{F.paginationLabel}}\" \nmd-limit=\"pagination.limit\" md-limit-options=\"pagination.limitOption\" md-page=\"pagination.page\" \nmd-total=\"{{data.length}}\" md-on-paginate=\"restartSelected\" md-page-select></md-table-pagination><input \nname=\"secondStep\" required ng-model=\"secondStep\" required type=\"hidden\"></div></div>");
$templateCache.put("app/main/clients/views/incidences/dialogs/step-update1.html","<div class=\"md-inline-form\"><div ng-if=\"impIncGeoCtrl.loading\"><md-progress-linear md-mode=\"indeterminate\">\n</md-progress-linear><span class=\"md-subhead\">Cargando..</span></div><md-input-container class=\"md-block m-0\"><label>\nNómina</label><md-select ng-model=\"impIncGeoCtrl.payroll\" name=\"impIncGeoCtrl.payroll\" required \nng-change=\"impIncGeoCtrl.getPayrollData(impIncGeoCtrl.payroll)\"><md-select-header><input autocomplete=\"off\" \ntype=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"payrollSelectFilter\" \nplaceholder=\"Busque una nómina\"></md-select-header><md-option ng-value=\"payroll.$id\" ng-if=\"payroll.active\" \naria-hidden=\"nomina\" \nng-repeat=\"payroll in (F.permissionToAccessAllPayrolls?L.allPayrolls:L.payrolls) | orderBy:\'class\' | filter:payrollSelectFilter\">\n{{payroll.class}} {{payroll.name}}</md-option></md-select><div ng-messages=\"form.payroll.$error\" role=\"alert\"><div \nng-message=\"required\">Nómina es requerido</div></div></md-input-container><h3 ng-if=\"impIncGeoCtrl.periodData\"><strong>\nPeriodo: </strong>\n{{impIncGeoCtrl.currentOperation.period}} - {{impIncGeoCtrl.currentOperation.calendar}}[{{impIncGeoCtrl.periodData.start | date : F.formatDate}} - {{impIncGeoCtrl.periodData.end | date : F.formatDate}}]\n</h3><div layout=\"row\" class=\"md-block evenPadding m-0\" layout-wrap layout-align=\"center start\"><md-input-container \nclass=\"md-block date-picker mt-0 mb-0\" flex=\"50\"><md-datepicker ng-model=\"impIncGeoCtrl.initConsulta\" \ninput-date-miliseconds md-hide-icons=\"triangle\" name=\"initConsulta\" required \nng-change=\"impIncGeoCtrl.updateEndConsulta(impIncGeoCtrl.initConsulta);\" \nng-disabled=\"!impIncGeoCtrl.canChangeInitDate\" md-placeholder=\"Ingresar fecha inicio\"></md-datepicker>\n</md-input-container><md-input-container flex=\"50\" class=\"md-block date-picker mt-0 mb-0\"><md-datepicker \nng-model=\"impIncGeoCtrl.endConsulta\" input-date-miliseconds md-hide-icons=\"triangle\" name=\"endConsulta\" required \nmd-min-date=\"impIncGeoCtrl.minDate\" md-placeholder=\"Ingresar fecha fin\"></md-datepicker></md-input-container></div><div\n layout=\"row\" class=\"mt-0\"><span flex></span> <a class=\"downloadLink\" ng-click=\"impIncGeoCtrl.getIdIncidences()\">\nDescargar incidencias GeoVictoria<md-icon md-font-icon=\"icon-file-excel\" aria-label=\"download incidencias GeoVictoria\">\n</md-icon></a></div><div ng-if=\"impIncGeoCtrl.geoRecords.length>0\" style=\"max-height: 300px; overflow-y: auto\"><md-list\n class=\"md-dense\"><md-subheader class=\"md-no-sticky\">Importaciones anteriores</md-subheader><md-list-item \nng-repeat=\"($index,geoRecord) in impIncGeoCtrl.geoRecords | orderBy : \'-created.atTime\'\"><p flex><strong>\nPeriodo:{{geoRecord.period}} ({{geoRecord.calendar}})</strong>\n #{{geoRecord.numberIncidence}} Registro(s) [{{geoRecord.initDate| date : F.formatDate}} - {{geoRecord.endDate| date : F.formatDate}}] {{ importAccuRecord.created.atTime | date : F.dateFormat }}\n</p><span ng-if=\"geoRecord.showConfirm\" flex=\"nogrow\">¿Desea eliminar esta importación?</span><md-icon with-permission \naction=\"deleteImportIncidencesGeo\" access=\"{{F.active.menuItem}}\" md-font-icon=\"icon-trash\" \nng-if=\"!geoRecord.showConfirm && $index===0\" ng-disabled=\"impIncGeoCtrl.loading\" ng-click=\"geoRecord.showConfirm=true\" \naria-label=\"delete import options\" class=\"md-secondary md-hue-3\"></md-icon><md-icon md-font-icon=\"icon-check\" \nng-if=\"geoRecord.showConfirm\" ng-disabled=\"impIncGeoCtrl.loading\" ng-click=\"impIncGeoCtrl.deleteGeoRecord(geoRecord)\" \naria-label=\"delete import\" class=\"md-secondary md-accent md-hue-2\"></md-icon><md-icon md-font-icon=\"icon-close\" \nng-if=\"geoRecord.showConfirm\" ng-disabled=\"impIncGeoCtrl.loading\" ng-click=\"geoRecord.showConfirm=false\" \naria-label=\"delete import\" class=\"md-secondary md-warn md-hue-2\"></md-icon></md-list-item></md-list></div></div>");
$templateCache.put("app/main/clients/views/incidences/dialogs/step-update2.html","<div class=\"md-inline-form\"><div ng-if=\"impIncGeoCtrl.loading\"><md-progress-linear md-mode=\"indeterminate\">\n</md-progress-linear><span class=\"md-subhead\">Cargando..</span></div><div class=\"text-center pt-0 pb-10\"><span \nng-if=\"impIncGeoCtrl.periodData\"><strong>Periodo: </strong>\n{{impIncGeoCtrl.currentOperation.period}} - {{impIncGeoCtrl.currentOperation.calendar}}[{{impIncGeoCtrl.periodData.start | date : F.formatDate}} - {{impIncGeoCtrl.periodData.end | date : F.formatDate}}] \n</span><span ng-if=\"impIncGeoCtrl.periodData\"><strong>Fechas Consultadas: </strong>\n{{impIncGeoCtrl.initConsulta | date : F.formatDate}} - {{impIncGeoCtrl.endConsulta | date : F.formatDate}}</span></div>\n<div class=\"table-container tables-geo-incidences\"><div ng-if=\"impIncGeoCtrl.founded.length > 0\"><div \nclass=\"text-center\"><h2 class=\"m-0\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"green-700-fg\"></md-icon>\nIncidencias por aplicar en el sistema</h2></div><table class=\"simple incidencesImportGeo\"><thead><tr \nclass=\"md-grey-A100-bg\"><th class=\"grey-900-fg text-center\">Nombre del empleado</th><th \nclass=\"grey-900-fg text-center\">Fecha incidencia</th><th class=\"grey-900-fg text-center\">Incidencia reloj</th><th \nclass=\"grey-900-fg text-center\">Incidencia del sistema</th><th class=\"grey-900-fg text-center\">Acción</th></tr></thead>\n<tbody><tr ng-repeat=\"incidence in impIncGeoCtrl.founded track by $index\" class=\"green-700-fg\" \nng-class=\"{\'grey-400-fg\':incidence.notSync}\"><td class=\"text-center\">{{incidence.employeeName}}</td><td \nclass=\"text-center\"><span style=\"white-space: nowrap\">\n{{incidence.geoDate | date:F.dateFormat}} ➡️ {{(incidence.systemDate | date:F.dateFormat) ? (incidence.systemDate | date:F.dateFormat):(\'No se puede asignar fecha\')}}\n</span></td><td class=\"text-center\">{{incidence.geoIncTypeName}}{{incidence.value?\' - \'+incidence.value:\'\'}}</td><td \nclass=\"text-center\">{{incidence.systemIncTypeName}}</td><td class=\"text-center\"><div layout=\"row\" \nlayout-align=\"center center\"><div flex=\"nogrow\" ng-if=\"incidence.type===\'accepted\' && !incidence.editComment\"><md-icon \nng-disable=\"impIncGeoCtrl.loading\" ng-click=\"impIncGeoCtrl.addRemoveToAccepted($index,\'remove\')\" \naria-label=\"removeFromAccepted\" md-font-icon=\"icon-playlist-minus\"><md-tooltip md-direction=\"top\">Quitar incidencia\n</md-tooltip></md-icon></div><div flex=\"nogrow\" \nng-if=\"incidence.type!==\'accepted\' && !incidence.notSync && !incidence.editComment\"><md-icon \nng-disable=\"impIncGeoCtrl.loading\" ng-click=\"incidence.notSync=true;\" aria-label=\"disable sync\" \nmd-font-icon=\"icon-sync-off\"><md-tooltip md-direction=\"top\">No sincronizar incidencia</md-tooltip></md-icon></div><div \nflex=\"nogrow\" ng-if=\"incidence.type!==\'accepted\' && incidence.notSync && !incidence.editComment\"><md-icon \nng-disable=\"impIncGeoCtrl.loading\" ng-click=\"incidence.notSync=false;\" aria-label=\"enable sync\" \nmd-font-icon=\"icon-sync\"><md-tooltip md-direction=\"top\">Sincronizar incidencia</md-tooltip></md-icon></div><div \nflex=\"nogrow\" ng-if=\"incidence.editComment\" layout=\"row\"><md-input-container md-no-float class=\"no-errors-spacer\">\n<input type=\"text\" ng-model=\"incidence.comment\" placeholder=\"Agregar comentario\"></md-input-container><md-icon \nng-disable=\"impIncGeoCtrl.loading\" ng-click=\"incidence.editComment=false\" aria-label=\"save comment\" \nmd-font-icon=\"icon-check\"><md-tooltip md-direction=\"top\">Guardar</md-tooltip></md-icon></div><div flex=\"nogrow\" \nng-if=\"!incidence.editComment\"><md-icon ng-disable=\"impIncGeoCtrl.loading\" ng-click=\"incidence.editComment=true\" \naria-label=\"edit comment\" md-font-icon=\"icon-tooltip-edit\" class=\"grey-400-fg cursor-pointer\" \nng-class=\"{\'grey-900-fg\':incidence.comment}\"><md-tooltip md-direction=\"top\">{{incidence.comment||\'Editar comentario\'}}\n</md-tooltip></md-icon></div></div></td></tr></tbody></table></div><div ng-if=\"impIncGeoCtrl.notFounded.length > 0\">\n<div class=\"text-center\"><h2 class=\"mb-0\"><md-icon md-font-icon=\"icon-window-close\" class=\"red-700-fg\"></md-icon>\nIncidencias con problemas</h2></div><table class=\"simple incidencesImportGeo\"><thead><tr class=\"md-grey-A100-bg\"><th \nclass=\"grey-900-fg text-center\">Nombre del empleado</th><th class=\"grey-900-fg text-center\">Fecha incidencia</th><th \nclass=\"grey-900-fg text-center\">Incidencia reloj</th><th class=\"grey-900-fg text-center\">Error</th></tr></thead><tbody>\n<tr ng-repeat=\"incidence in impIncGeoCtrl.notFounded\" class=\"red-700-fg\"><td class=\"text-center\">\n{{incidence.employeeName}}</td><td class=\"text-center\">{{incidence.geoDate | date:F.dateFormat}}</td><td \nclass=\"text-center\">{{incidence.geoIncTypeName}}{{incidence.value?\' - \'+incidence.value:\'\'}}</td><td \nclass=\"text-center\">{{incidence.error||\'Incidencia no encontrada\'}}</td></tr></tbody></table></div><div \nng-if=\"impIncGeoCtrl.incapacities.length > 0\"><div class=\"text-center\"><h2 class=\"mb-0\"><md-icon \nmd-font-icon=\"icon-alert-circle\" class=\"blue-700-fg\"></md-icon>Se encontraron incapacidades en sistema</h2></div><table\n class=\"simple incidencesImportGeo\"><thead><tr class=\"md-grey-A100-bg\"><th class=\"grey-900-fg text-center\">\nNombre del empleado</th><th class=\"grey-900-fg text-center\">Fecha incidencia</th><th class=\"grey-900-fg text-center\">\nIncidencia reloj</th><th class=\"grey-900-fg text-center\">Incidencia del sistema</th></tr></thead><tbody><tr \nng-repeat=\"incidence in impIncGeoCtrl.incapacities\" class=\"blue-700-fg\"><td class=\"text-center\">\n{{incidence.employeeName}}</td><td class=\"text-center\">{{incidence.geoDate | date:F.dateFormat}}</td><td \nclass=\"text-center\">{{incidence.geoIncTypeName}}{{incidence.value?\' - \'+incidence.value:\'\'}}</td><td \nclass=\"text-center\">{{incidence.systemIncTypeName}}</td></tr></tbody></table></div><div \nng-if=\"impIncGeoCtrl.nextIncidences.length > 0\"><div class=\"text-center\"><h2 class=\"mb-0\"><md-icon \nmd-font-icon=\"icon-shape-plus\"></md-icon>Incidencias futuras</h2></div><table class=\"simple incidencesImportGeo\">\n<thead><tr class=\"md-grey-A100-bg\"><th class=\"grey-900-fg text-center\">Nombre del empleado</th><th \nclass=\"grey-900-fg text-center\">Fecha incidencia</th><th class=\"grey-900-fg text-center\">Incidencia reloj</th><th \nclass=\"grey-900-fg text-center\">Acción</th></tr></thead><tbody><tr \nng-repeat=\"($index,incidence) in impIncGeoCtrl.nextIncidences\" \nng-class=\"{\r\n                            \'red-700-fg\':incidence.type===\'error\',\r\n                            \'blue-700-fg\':incidence.type===\'incapacity\',\r\n                            \'green-700-fg\':incidence.type===\'accepted\'\r\n                        }\">\n<td class=\"text-center\">{{incidence.employeeName}}</td><td class=\"text-center\">\n{{incidence.geoDate | date:F.dateFormat}}</td><td class=\"text-center\">\n{{incidence.geoIncTypeName}}{{incidence.value?\' - \'+incidence.value:\'\'}}</td><td class=\"text-center\">\n{{incidence.error}}<md-icon ng-if=\"incidence.type===\'accepted\'\" ng-disable=\"impIncGeoCtrl.loading\" \nng-click=\"impIncGeoCtrl.addRemoveToAccepted($index,\'add\')\" aria-label=\"addToAccepted\" \nclass=\"green-700-fg cursor-pointer\" md-font-icon=\"icon-redo-variant\"><md-tooltip md-direction=\"top\">\nAñadir incidencia a sincronización</md-tooltip></md-icon></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/clients/views/incidences/dialogs/step-update3.html","<div class=\"md-inline-form\" layout=\"column\"><div ng-if=\"impIncGeoCtrl.loading\" flex layout=\"row\" \nlayout-align=\"center center\"><md-progress-linear md-mode=\"indeterminate\"></md-progress-linear><span class=\"md-subhead\" \nstyle=\"margin-left: 10px\">Aplicando...</span></div><div flex layout=\"column\" layout-align=\"center center\" \nstyle=\"overflow-x: auto\"><h2>¿Desea aplicar <b>{{impIncGeoCtrl.totalIncidencesToApply}}</b> incidencias?</h2></div>\n</div>");
$templateCache.put("app/main/clients/views/newoperation/dialogs/bill-employees-confirm.html","<md-dialog aria-label=\"confirm bill\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 ng-bind=\"BillEmpConfCtrl.title\">\n</h2></div></md-toolbar><md-dialog-content><h3 ng-bind=\"BillEmpConfCtrl.msg\"></h3><md-checkbox \nng-if=\"BillEmpConfCtrl.reBill\" ng-init=\"false\" ng-model=\"BillEmpConfCtrl.updateEmployeeData\" \naria-label=\"Update Employee Data\"><strong>Actualizar información del empleado</strong><br><span>\nAl seleccionar esta opción se actualizarán los datos del receptor <em>\n(NumSeguridadSocial, FechaInicioRelLaboral, NumEmpleado, Departamento, Puesto, Banco, CuentaBancaria, SalarioBaseCotApor, SalarioDiarioIntegrado)\n</em> con la información actual del empleado en el sistema</span></md-checkbox></md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button class=\"md-accent md-raised md-warn\" ng-click=\"BillEmpConfCtrl.cancel()\">Cancelar</md-button>\n<md-button class=\"md-accent md-raised md-primary\" ng-click=\"BillEmpConfCtrl.bill(BillEmpConfCtrl.updateEmployeeData)\" \nng-disabled=\"form.$invalid\">{{BillEmpConfCtrl.reBill?\'Re-timbrar\':\'Timbrar\'}}</md-button></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/clients/views/newoperation/dialogs/bottom-calculations.html","<md-bottom-sheet class=\"md-list md-has-header bottomList showCalculations headToolbar\" \nng-class=\"{\'full-height\':F.fullHeight}\"><div class=\"filterToolbar\"><div class=\"md-toolbar-tools\"><h3 flex \nclass=\"title\" md-truncate>Cálculos de {{employees[employeeIndex].data.name}} {{vm.nuevo}}</h3><md-button \nclass=\"md-icon-button\" aria-label=\"next\" ng-if=\"!F.fullHeight\" \nng-click=\"F.fullHeight=true;saveFullHeight(F.fullHeight)\"><md-icon md-font-icon=\"icon-arrow-expand\" \naria-label=\"order alphabetical\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"next\" \nng-if=\"F.fullHeight\" ng-click=\"F.fullHeight=false;saveFullHeight(F.fullHeight)\"><md-icon \nmd-font-icon=\"icon-arrow-collapse\" aria-label=\"order alphabetical\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"previous\" ng-click=\"setEmployee(-1)\" ng-disabled=\"employeeIndex==0\"><md-icon \nmd-font-icon=\"icon-arrow-left\" aria-label=\"previous calculation\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"next\" ng-click=\"setEmployee(1)\" ng-disabled=\"employeeIndex==employees.length-1\">\n<md-icon md-font-icon=\"icon-arrow-right\" aria-label=\"next calculation\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" ng-click=\"hideModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close Dialog\"></md-icon>\n</md-button></div><header layout=\"row\"><div flex><md-input-container md-no-float class=\"md-block no-margin\"><input \nplaceholder=\"Filtrar Calculo\" name=\"calculo\" type=\"text\" ng-model-options=\"{ debounce: F.debounceTime }\" \nclass=\"whitePlaceholder\" ng-model=\"filterCalculation\" aria-label=\"filter calculation\" ng-change=\"setCalculations();\">\n</md-input-container></div><div flex=\"nogrow\"><md-button ng-if=\'order==\"order\"\' class=\"md-icon-button\" \naria-label=\"next\" ng-click=\"setOrder(\'name\')\"><md-icon md-font-icon=\"icon-sort-alphabetical\" \naria-label=\"order alphabetical\"></md-icon></md-button><md-button ng-if=\'order==\"name\"\' class=\"md-icon-button\" \naria-label=\"next\" ng-click=\"setOrder(\'order\')\"><md-icon md-font-icon=\"icon-sort\" aria-label=\"order by process\">\n</md-icon></md-button><md-button ng-if=\'view==\"cards\"\' class=\"md-icon-button\" aria-label=\"next\" \nng-click=\"setView(\'table\')\"><md-icon md-font-icon=\"icon-view-list\" aria-label=\"view list\"></md-icon></md-button>\n<md-button ng-if=\'view==\"table\"\' class=\"md-icon-button\" aria-label=\"next\" ng-click=\"setView(\'cards\')\"><md-icon \nmd-font-icon=\"icon-view-module\" aria-label=\"view cards\"></md-icon></md-button><md-button \nng-if=\"view===\'cards\' && !F.allCalculationsOpened\" class=\"md-icon-button\" aria-label=\"view\" \nng-click=\"setViewCalculations(true)\"><md-icon md-font-icon=\"icon-eye\" aria-label=\"view sub calculations\"></md-icon>\n</md-button><md-button ng-if=\"view===\'cards\' && F.allCalculationsOpened\" class=\"md-icon-button\" aria-label=\"view\" \nng-click=\"setViewCalculations(false)\"><md-icon md-font-icon=\"icon-eye-off\" aria-label=\"view sub calculations\">\n</md-icon></md-button><md-button with-permission action=\"showHiddenCalculations\" access=\"{{F.active.menuItem}}\" \nng-if=\"view===\'cards\' && !F.showAllCalculations\" class=\"md-icon-button\" aria-label=\"view\" \nng-click=\"F.showAllCalculations=true\"><md-icon md-font-icon=\"icon-playlist-plus\" aria-label=\"view sub calculations\">\n</md-icon></md-button><md-button with-permission action=\"showHiddenCalculations\" access=\"{{F.active.menuItem}}\" \nng-if=\"view===\'cards\' && F.showAllCalculations\" class=\"md-icon-button\" aria-label=\"view\" \nng-click=\"F.showAllCalculations=false\"><md-icon md-font-icon=\"icon-playlist-minus\" aria-label=\"view sub calculations\">\n</md-icon></md-button></div></header></div><md-content layout-fill stop-touch-event><table id=\"list_calculations\" \nng-if=\"view==\'table\'\"><tbody class=\"calculation\"><tr ng-repeat=\"($index,calculation) in calculations\" \nng-if=\"!calculation.hc\"><td>{{(calculation.name)? calculation.name : \'S/N\'}}</td><td><div layout=\"row\" \nlayout-align=\"center center\"><div flex class=\"text-right\">\n{{(calculation.value.formatted)? calculation.value.formatted : (calculation.value.result | currency)}}</div><div \nflex=\"nogrow\"><md-button ng-disabled=\"!calculation.showBottomEyes\" class=\"md-icon-button\" aria-label=\"view\" \nng-click=\"openCalc($event, $index)\"><md-icon md-font-icon=\"icon-eye\" aria-label=\"view sub calculations\"></md-icon>\n</md-button></div></div></td></tr></tbody></table><div layout=\"row\" ng-if=\"view==\'cards\'\" layout-wrap><div \nflex-xs=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"33\" flex-gt-lg=\"25\" flex-gt-xl=\"20\" layout=\"column\" \nng-repeat=\"($index,calculation) in calculations\" ng-if=\"!calculation.hc\"><md-card><div layout=\"row\"><md-card-header \nflex><md-card-header-text><span class=\"md-title\">\n{{(calculation.value.formatted)? calculation.value.formatted : (calculation.value.result | currency)}}</span> <span \nclass=\"md-subhead\">{{(calculation.name)? calculation.name : \'S/N\'}}</span></md-card-header-text></md-card-header>\n<md-card-actions flex=\"nogrow\" layout=\"row\" layout-align=\"end center\"><md-button \nng-if=\"!calculation.showData && calculation.showBottomEyes\" class=\"md-icon-button\" aria-label=\"view\" \nng-click=\"calculation.showData=true;setAllCalculationViewStatus();\"><md-icon md-font-icon=\"icon-eye\" \naria-label=\"view sub calculations\"></md-icon></md-button><md-button \nng-if=\"calculation.showData && calculation.showBottomEyes\" class=\"md-icon-button\" aria-label=\"view\" \nng-click=\"calculation.showData=false;setAllCalculationViewStatus();\"><md-icon md-font-icon=\"icon-eye-off\" \naria-label=\"view sub calculations\"></md-icon></md-button></md-card-actions></div><md-card-content \nng-if=\"calculation.showData\"><div flex><div ng-if=\"calculation.data\"><b>CONCEPTO</b> =<table class=\"modal-calculation\">\n<thead><tr><th>Concepto</th><th>Valor</th></tr></thead><tbody><tr ng-repeat=\"(key, value) in calculation.data\"><td>\n{{concepts[key].name}}</td><td>{{value | currency}}</td></tr></tbody></table></div><div \nng-repeat=\"value in calculation\" \nng-if=\"value.name && (F.showAllCalculations || (!value.hidden)) && value.name !== \'Total\' && value.name !== \'total\' && value.name !== \'TOTAL\'\">\n<label for=\"Calculations\" ng-if=\"value.formatted\"><b>{{value.name | uppercase}}</b> = {{value.formatted}}</label><label\n ng-if=\"value.name && value.fields && (value.result | objectsLength) > 0\"><b>{{value.name}}</b> =</label><hr \nng-if=\"value.ilb\"><table for=\"Calculations\" \nng-if=\"!value.formatted && value.fields && (value.result | objectsLength) > 0\" class=\"modal-calculation\"><thead><tr><th\n ng-repeat=\"field in value.fields\">{{field.n}}</th></tr></thead><tbody><tr ng-repeat=\"row in value.result\"><td \nng-repeat=\"field in value.fields\"><label ng-if=\"field.t==\'date\'\">{{row[field.p] | date}}</label><label \nng-if=\"field.t==\'boolean\' && row[field.p]\"><md-icon class=\"green-fg\" md-font-icon=\"icon-check\" aria-label=\"Confirm\">\n</md-icon></label><label ng-if=\"field.t === \'currency\'\">{{row[field.p] | currency}}</label><label ng-if=\"!field.t\">\n{{row[field.p]}}</label></td></tr></tbody></table></div></div></md-card-content></md-card></div></div></md-content>\n</md-bottom-sheet>");
$templateCache.put("app/main/clients/views/newoperation/dialogs/bottom-incidences.html","<md-bottom-sheet class=\"md-list bottomList noPaddingBotomSheet showIncidences headToolbar\"><div class=\"filterToolbar\">\n<div class=\"md-toolbar-tools\"><h3 flex class=\"title\">Incidencias de {{employees[employeeIndex].data.name}}</h3>\n<md-button class=\"md-icon-button\" aria-label=\"previous\" flex=\"nogrow\" ng-click=\"setEmployee(-1)\" \nng-disabled=\"employeeIndex==0\"><md-icon md-font-icon=\"icon-arrow-left\" aria-label=\"previus employee\"></md-icon>\n</md-button><md-button class=\"md-icon-button\" aria-label=\"next\" flex=\"nogrow\" ng-click=\"setEmployee(1)\" \nng-disabled=\"employeeIndex==employees.length-1\"><md-icon md-font-icon=\"icon-arrow-right\" aria-label=\"next employee\">\n</md-icon></md-button><md-button class=\"md-icon-button\" ng-click=\"hideModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close Dialog\"></md-icon></md-button></div><div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" \nflex md-no-float><input id=\"incidences-search\" placeholder=\"Buscar Incidencia\" class=\"whitePlaceholder\" \nng-model-options=\"{ debounce: F.debounceTime }\" type=\"text\" name=\"searchIncidences\" ng-model=\"incidencesFilter\" \nng-change=\"executeIncidenceFilter()\"></md-input-container><md-button \nng-if=\"!readOnlyMode && operation.status<opStatusNotCalc && operation.employees[employees[employeeIndex].$id].status<nextEmployeeStatus\" \nclass=\"md-icon-button\" flex=\"nogrow\" aria-label=\"filter data\" ng-click=\"openObject(event,null,\'add\')\"><md-icon \nmd-font-icon=\"icon-plus\" aria-label=\"reload-filters\"></md-icon></md-button><md-button \nng-if=\"!readOnlyMode && operation.status<opStatusNotCalc && operation.employees[employees[employeeIndex].$id].status<nextEmployeeStatus\" \nng-disabled=\"!selectedIncidences.length == 1\" class=\"md-icon-button\" flex=\"nogrow\" aria-label=\"filter data\" \nng-click=\"deleteIncidence($event, selectedIncidences)\"><md-icon md-font-icon=\"icon-delete\" \naria-label=\"delete incidence\"></md-icon></md-button><md-button \nng-if=\"!readOnlyMode && operation.status<opStatusNotCalc && operation.employees[employees[employeeIndex].$id].status<nextEmployeeStatus\" \nng-disabled=\"!(selectedIncidences.length == 1) || selectedIncidences[0].type === \'system\'\" class=\"md-icon-button\" \nflex=\"nogrow\" aria-label=\"filter data\" ng-click=\"openObject($event,selectedIncidences[0],\'edit\')\"><md-icon \nmd-font-icon=\"icon-pencil\" aria-label=\"edit incidence\"></md-icon></md-button></div></div><md-content layout-fill \nstop-touch-event><div layout=\"row\" layout-align=\"center center\" \nng-show=\"!allEmployees[employees[employeeIndex].$id].incidences.length\"><h3>Sin incidencas</h3></div><div flex><table \nid=\"list_incidences\" ng-if=\"allEmployees[employees[employeeIndex].$id].incidences.length > 0\"><thead><tr \nng-if=\"employeeIncidences.length > 0\"><th><span>Incidencia</span></th><th><span>Fecha</span></th><th><span>Valor</span>\n</th><th><span>Comentario</span></th><th><span>Naturaleza</span></th><th><span>Tipo</span></th></tr></thead><tbody><tr \nng-disabled=\"incidence.type==\'constant\' || incidence.type==\'fast\'|| incidence.type==\'system\'\" \nng-repeat=\"incidence in employeeIncidences  track by incidence.$id\"><td><input class=\"checked\" \naria-label=\"select employee\" ng-disabled=\"incidence.type === \'system\'\" \nng-checked=\"check(incidence, selectedIncidences)\" type=\"checkbox\" ng-click=\"show(incidence, selectedIncidences)\">\n<label>{{incidence.incidenceName}}</label></td><td>{{incidence.date|date:\'mediumDate\'}}</td><td>{{incidence.value}}\n</td><td>{{incidence.comments}}</td><td>{{incidence.natureName}}</td><td>{{incidence.typeName}}</td></tr></tbody>\n</table></div></md-content></md-bottom-sheet>");
$templateCache.put("app/main/clients/views/newoperation/dialogs/calculations.html","<md-dialog class=\"customDialog calculationsModal\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 flex>Cálculos de \n<small>{{ calculation.name }}</small></h2><div flex=\"nogrow\" layout=\"row\" layout-align=\"end start\"><md-button \nclass=\"md-icon-button\" aria-label=\"previous\" flex=\"nogrow\" ng-click=\"changeCalculation(-1)\" \nng-disabled=\"indexCalculation==0\"><md-icon md-font-icon=\"icon-arrow-left\" aria-label=\"previus calculation\"></md-icon>\n</md-button><md-button class=\"md-icon-button\" aria-label=\"next\" flex=\"nogrow\" ng-click=\"changeCalculation(1)\" \nng-disabled=\"indexCalculation==calculations.length-1\"><md-icon md-font-icon=\"icon-arrow-right\" \naria-label=\"next calculation\"></md-icon></md-button></div><md-button class=\"md-icon-button\" ng-click=\"cancel()\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Close Dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><div class=\"md-dialog-content\" layout=\"column\"><div flex><h3 class=\"title\" ng-if=\"active\">Datos</h3>\n<div ng-if=\"calculation.data\"><b>CONCEPTO</b> =<table class=\"modal-calculation\"><thead><tr><th>Concepto</th><th>Valor\n</th></tr></thead><tbody><tr ng-repeat=\"(key, value) in calculation.data\"><td>{{concepts[key].name}}</td><td>\n{{value | currency}}</td></tr></tbody></table></div><div ng-repeat=\"value in calculation\" \nng-if=\"value.name && !value.hidden && value.name !== \'Total\' && value.name !== \'total\' && value.name !== \'TOTAL\'\">\n<label for=\"Calculations\" ng-if=\"value.formatted\"><b>{{value.name | uppercase}}</b> = {{value.formatted}}</label><label\n ng-if=\"value.name && value.fields && (value.result | objectsLength) > 0\"><b>{{value.name}}</b> =</label><table \nfor=\"Calculations\" ng-if=\"!value.formatted && value.fields && (value.result | objectsLength) > 0\" \nclass=\"modal-calculation\"><thead><tr><th ng-repeat=\"field in value.fields\">{{field.n}}</th></tr></thead><tbody><tr \nng-repeat=\"row in value.result\"><td ng-repeat=\"field in value.fields\"><label ng-if=\"field.t==\'date\'\">\n{{row[field.p] | date}}</label><label ng-if=\"field.t==\'boolean\' && row[field.p]\"><md-icon class=\"green-fg\" \nmd-font-icon=\"icon-check\" aria-label=\"Confirm\"></md-icon></label><label ng-if=\"field.t === \'currency\'\">\n{{row[field.p] | currency}}</label><label ng-if=\"!field.t\">{{row[field.p]}}</label></td></tr></tbody></table></div><br \nng-if=\"active\"><label><b for=\"Total\">TOTAL = </b>{{calculation.value.formatted}}</label></div></div>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/clients/views/newoperation/dialogs/close-operation.html","<md-dialog aria-label=\"Register Emit Employees\" class=\"close-operation\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nSe actualizará operación a \"{{ConfOpeCtrl.statusName.name}}\"</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"ConfOpeCtrl.hide()\" ng-if=\"!ConfOpeCtrl.retry\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content><div><h3 class=\"mt-0\">\nAño {{(ConfOpeCtrl.calendar)?ConfOpeCtrl.calendar:ConfOpeCtrl.operation.calendar}} - Periodo {{ConfOpeCtrl.period.period}}\n</h3><h3 ng-if=\"ConfOpeCtrl.operationType===\'ordinary\'\">Fecha: de <b>{{ConfOpeCtrl.period.start | date:\'mediumDate\'}}\n</b> a <b>{{ConfOpeCtrl.period.end | date:\'mediumDate\'}}</b></h3><h3 \nng-if=\"[\'special\',\'extraordinary\',\'asimilated\',\'ptuRecord\'].indexOf(ConfOpeCtrl.operationType) > -1\">Fecha: <b>\n{{ConfOpeCtrl.operation.specialDate | date:\'mediumDate\'}}</b></h3><p>{{ConfOpeCtrl.statusName.msg}}</p><p \nng-if=\"ConfOpeCtrl.comments\"><b>Comentario:</b> {{ConfOpeCtrl.comments}}</p></div><form flex name=\"form\"><div \nng-show=\"ConfOpeCtrl.showPeriod && ConfOpeCtrl.operationStatus >= 3\"><fieldset><legend>\nSeleccione el periodo en el que se va a acumular la operación</legend><md-input-container class=\"md-block\"><label>\nPeriodo</label><md-select ng-model=\"ConfOpeCtrl.periodSelected\" ng-required=\"ConfOpeCtrl.showPeriod\" name=\"date\" \nng-change=\"ConfOpeCtrl.setMinMaxPaymentDate(ConfOpeCtrl.periodSelected,true)\"><md-option ng-value=\"period\" \nng-repeat=\"period in ConfOpeCtrl.periods track by period.$id\">\nPeriodo {{period.period}} - {{period.start|date:\'mediumDate\'}} - {{period.end|date:\'mediumDate\'}}</md-option>\n</md-select><div ng-messages=\"form.date.$error\" role=\"alert\"><div ng-message=\"required\">El periodo es requerido</div>\n</div></md-input-container></fieldset></div><div \nng-show=\"ConfOpeCtrl.operationStatus >= 3 && ConfOpeCtrl.showPaymentDate\"><fieldset><legend>\nSeleccione la fecha de pago, esta debe estar en el rango en el cual se va a acumular</legend><md-input-container \nclass=\"md-block date-picker mb-0\" flex><label>Fecha de pago</label><md-datepicker md-hide-icons=\"triangle\" \nmd-current-view=\"{{ConfOpeCtrl.dateView}}\" input-date-miliseconds ng-model=\"ConfOpeCtrl.paymentDate\" \nname=\"paymentDate\" md-min-date=\"ConfOpeCtrl.minPaymentDate\" md-max-date=\"ConfOpeCtrl.maxPaymentDate\" class=\"md-block\">\n</md-datepicker><div ng-messages=\"form.paymentDate.$error\" role=\"alert\"><div ng-message=\"min\">\nFecha de Alta debe ser a partir de {{ConfOpeCtrl.minPaymentDate | date}}</div><div ng-message=\"max\">\nFecha de Alta debe ser antes de {{ConfOpeCtrl.maxPaymentDate | date}}</div><div ng-message=\"mindate\">\nFecha de Alta debe ser a partir de {{ConfOpeCtrl.minPaymentDate | date}}</div><div ng-message=\"maxdate\">\nFecha de Alta debe ser antes de {{ConfOpeCtrl.maxPaymentDate | date}}</div></div></md-input-container></fieldset></div>\n<md-input-container class=\"md-block mb-0\" flex><label>Comentarios</label><textarea \nng-model=\"ConfOpeCtrl.rewriteComments\" name=\"comments\" aria-label=\"comments for dispersion\"></textarea>\n</md-input-container><div class=\"redC\">{{ConfOpeCtrl.message}}</div><div \nng-if=\"ConfOpeCtrl.operationType===\'settlement\' && ConfOpeCtrl.operationStatus >= 3\" flex layout=\"row\" \nlayout-align=\"start center\"><md-checkbox ng-model=\"ConfOpeCtrl.generateDismissMovement\" \naria-label=\"generateDismissMovement\">Generar movimiento de Baja</md-checkbox></div><div \nng-if=\"ConfOpeCtrl.pendingEmployees.length > 0\" flex layout=\"column\"><md-input-container class=\"md-block\"><label>\nTipo de apertura</label><md-select ng-model=\"ConfOpeCtrl.type\" required name=\"type\" placeholder=\"Tipo de apertura\">\n<md-option ng-value=\'\"all\"\'>Todos</md-option><md-option ng-value=\'\"some\"\'>Algunos</md-option></md-select>\n</md-input-container><div ng-if=\"ConfOpeCtrl.type === \'some\'\"><div flex=\"100\" layout=\"row\" layout-align=\"start center\">\n<div flex=\"30\"><md-checkbox ng-model=\"ConfOpeCtrl.pending.selectedAllEmployee\" class=\"mb-0 pb-0\" \nng-click=\"ConfOpeCtrl.selectedAll(ConfOpeCtrl.pending.selectedAllEmployee)\" aria-label=\"Oculto\">Seleccionar todo\n</md-checkbox></div><div flex=\"70\"><md-input-container class=\"md-block no-errors-spacer\"><input type=\"text\" \nplaceholder=\"Buscar Empleado\" ng-model-options=\"{ debounce: F.debounceTime }\" ng-model=\"ConfOpeCtrl.searchEmployee\">\n</md-input-container></div></div><table class=\"default-table\"><thead><tr><th>Nombre</th><th>Estatus</th></tr></thead>\n<tbody class=\"calculation\"><tr \nng-repeat=\"($index,employee) in ConfOpeCtrl.pendingEmployees | filter:{ data: { name: ConfOpeCtrl.searchEmployee } }\">\n<td class=\"left\"><input class=\"checked\" aria-label=\"select employee\" \nng-checked=\"ConfOpeCtrl.exists(employee, ConfOpeCtrl.selected)\" type=\"checkbox\" ng-model=\"employees\" \nng-change=\"ConfOpeCtrl.toggle(employee, ConfOpeCtrl.selected)\"><label ng-bind=\"employee.data.name\"></label></td><td>\n{{ConfOpeCtrl.statusName.name}}</td></tr></tbody></table></div></div></form></md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button class=\"md-accent md-raised md-warn\" ng-click=\"ConfOpeCtrl.cancel()\" \nng-disabled=\"ConfOpeCtrl.disableButtons\">Cancelar</md-button><md-button class=\"md-accent md-raised md-primary\" \nng-click=\"ConfOpeCtrl.confirm(ConfOpeCtrl.rewriteComments,ConfOpeCtrl.generateDismissMovement)\" \nng-if=\"!ConfOpeCtrl.retry\" \nng-disabled=\"ConfOpeCtrl.disableButtons  || form.$invalid || ((ConfOpeCtrl.pendingEmployees ? true : false) && ConfOpeCtrl.type === \'some\' && ConfOpeCtrl.selected.length === 0)\">\n{{ConfOpeCtrl.msg}}</md-button><md-button class=\"md-accent md-raised md-primary\" \nng-click=\"ConfOpeCtrl.confirm(ConfOpeCtrl.rewriteComments,ConfOpeCtrl.generateDismissMovement)\" \nng-if=\"ConfOpeCtrl.retry\" ng-disabled=\"ConfOpeCtrl.disableButtons || form.$invalid\">Reintentar</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/clients/views/newoperation/dialogs/companiesRecords.html","<md-dialog aria-label=\"Select date to bill\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Seleccionar empresa</h2>\n</div></md-toolbar><md-dialog-content><form name=\"form\"><md-input-container class=\"md-block\" md-no-float><label>Empresa\n</label><md-select ng-model=\"companiesRecordId\" placeholder=\"Empresa\" required><md-select-header><input \nautocomplete=\"off\" type=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" \nng-model=\"companiesRecordSelectFilter\" placeholder=\"Busque una Empresa\"></md-select-header><md-option \nng-value=\"companiesRecord.$id \" \nng-repeat=\"companiesRecord in L.companiesRecords | orderBy:\'name\' | filter:companiesRecordSelectFilter\">\n{{companiesRecord.name}}</md-option></md-select></md-input-container></form></md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button class=\"md-accent md-raised md-warn\" ng-click=\"cancel()\">Cancelar</md-button><md-button \nclass=\"md-accent md-raised md-primary\" ng-click=\"confirm()\" ng-disabled=\"form.$invalid\">Aceptar</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/clients/views/newoperation/dialogs/date.html","<md-dialog id=\"dateModalBank\" aria-label=\"modal add date of operation\" class=\"modal-add-date\"><form name=\"form\" \nnovalidate ng-disabled=\"readOnlyMode\"><md-toolbar class=\"date-modal-toolbar\"><div class=\"md-toolbar-tools\"><div \nclass=\"title-wrap\" flex><div class=\"title\">Completa los datos para descargar</div><div class=\"subtitle\" \nng-if=\"bank && bank.name\">Banco: <strong>{{bank.name}}</strong></div></div><md-button class=\"md-icon-button close-btn\" \nng-click=\"cancel()\" aria-label=\"Cerrar\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close Dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"date-modal-content\"><div class=\"md-dialog-content\"><div \nclass=\"empty-state\" ng-if=\"!modalFields || !modalFields.length\">No hay campos requeridos para este banco.</div><div \nclass=\"fields-grid\" layout=\"column\" ng-if=\"modalFields && modalFields.length\"><div class=\"field-card\" \nng-repeat=\"f in modalFields track by f.id\"><div ng-switch=\"f.type\"><md-input-container class=\"md-block\" \nng-switch-when=\"text\"><label>{{f.label}}</label><input type=\"text\" name=\"{{ \'field_\' + f.id }}\" ng-model=\"model[f.id]\" \nng-required=\"!!f.required\" ng-minlength=\"f.min\" ng-maxlength=\"f.max\" maxlength=\"{{f.max || undefined}}\" \nng-attr-pattern=\"{{ f.pattern || undefined }}\" autocomplete=\"off\"><div ng-messages=\"form[(\'field_\' + f.id)].$error\" \nng-show=\"form[(\'field_\' + f.id)].$touched || form[(\'field_\' + f.id)].$dirty\" role=\"alert\"><div ng-message=\"required\">\n{{f.label}} es requerido</div><div ng-message=\"minlength\">Mínimo {{f.min}} caracteres</div><div ng-message=\"maxlength\">\nMáximo {{f.max}} caracteres</div><div ng-message=\"pattern\">\n{{ f.patternMsg || (f.label + \' tiene un formato inválido\') }}</div></div></md-input-container><md-input-container \nclass=\"md-block\" ng-switch-when=\"number\"><label>{{f.label}}</label><input type=\"number\" name=\"{{ \'field_\' + f.id }}\" \nng-model=\"model[f.id]\" ng-required=\"!!f.required\" min=\"{{f.min || undefined}}\" max=\"{{f.max || undefined}}\" step=\"1\">\n<div ng-messages=\"form[(\'field_\' + f.id)].$error\" \nng-show=\"form[(\'field_\' + f.id)].$touched || form[(\'field_\' + f.id)].$dirty\" role=\"alert\"><div ng-message=\"required\">\n{{f.label}} es requerido</div><div ng-message=\"min\">Debe ser ≥ {{f.min}}</div><div ng-message=\"max\">\nDebe ser ≤ {{f.max}}</div><div ng-message=\"number\">Debe ser numérico</div></div></md-input-container>\n<md-input-container class=\"md-block date-picker no-errors-spacer\" ng-switch-when=\"date\"><label>{{f.label}}</label>\n<md-datepicker md-hide-icons=\"triangle\" input-date-miliseconds ng-model=\"model[f.id]\" name=\"{{ \'field_\' + f.id }}\" \nng-required=\"!!f.required\"></md-datepicker><div class=\"date-hint\" ng-if=\"minDate || maxDate\">Rango permitido: <span \nng-if=\"minDate\">{{minDate | date:\'dd/MM/yyyy\'}}</span> <span ng-if=\"minDate && maxDate\">- </span><span ng-if=\"maxDate\">\n{{maxDate | date:\'dd/MM/yyyy\'}}</span></div></md-input-container><div class=\"unsupported\" ng-switch-default>\nTipo no soportado: <strong>{{f.type}}</strong></div></div></div></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" class=\"date-modal-actions\"><span flex></span><md-button class=\"md-raised md-accent download-btn\" \nng-click=\"layoutBanks(model)\" ng-disabled=\"form.$invalid || loadingProgress\" aria-label=\"Descargar\"><md-icon \nmd-font-icon=\"icon-download\" aria-label=\"Download\"></md-icon><span>Descargar</span></md-button></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/clients/views/newoperation/dialogs/downloadBillConfirmation.html","<md-dialog aria-label=\"Select date to bill\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Generar Recibo</h2></div>\n</md-toolbar><md-dialog-content><h3>\nDeseas generar el recibo de {{downloadBillCtrl.billType}} para {{downloadBillCtrl.employeesCount}} empleados(s)</h3>\n<form name=\"form\"><md-checkbox ng-model=\"downloadBillCtrl.withCopy\" aria-label=\"with copy\">Con copia</md-checkbox>\n</form></md-dialog-content><md-dialog-actions layout=\"row\"><md-button class=\"md-accent md-raised md-warn\" \nng-click=\"downloadBillCtrl.cancel()\">Cancelar</md-button><md-button class=\"md-accent md-raised md-primary\" \nng-click=\"downloadBillCtrl.confirm(downloadBillCtrl.withCopy)\" ng-disabled=\"form.$invalid\">Descargar</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/clients/views/newoperation/dialogs/excluded-employee.html","<md-dialog aria-label=\"excluded employees\"><md-toolbar><div class=\"md-toolbar-tools\"><span flex>Empleados excluidos\n</span></div></md-toolbar><md-dialog-content><div class=\"table-responsive\" ng-if=\"eemdCtrl.employees.length>0\"><table \nclass=\"default-table\"><thead><tr><th>Nombre</th><th>Acción</th></tr></thead><tbody><tr \nng-repeat=\"($index,employee) in eemdCtrl.employees\"><td>{{employee.name}}</td><td><button \nng-click=\"eemdCtrl.removeEmployeeFromExcluded($index)\" \nng-disabled=\"eemdCtrl.operationIsClosed || !eemdCtrl.permissionToExcludeEmployees\" class=\"md-button md-icon-button\" \naria-label=\"Delete\"><md-icon md-font-icon=\"icon-trash\" class=\"white-icon-trash\"></md-icon></button></td></tr></tbody>\n</table></div><h2 ng-if=\"eemdCtrl.employees.length===0\">No hay empleados excluidos</h2><div \nng-if=\"!eemdCtrl.employees\" layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\"><md-progress-circular \nmd-diameter=\"80px\" md-mode=\"indeterminate\"></md-progress-circular></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"end end\"><md-button ng-if=\"eemdCtrl.showSaveButton\" \nng-click=\"eemdCtrl.saveExcludedEmployees()\" class=\"save-button md-raised md-accent\" aria-label=\"SAVE\">Guardar\n</md-button><md-button ng-click=\"eemdCtrl.saveExcludedEmployees()\" class=\"save-button md-raised md-warn\" \naria-label=\"CANCEL\">Cancelar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/clients/views/newoperation/dialogs/export-accs.html","<md-dialog id=\"exportAccs\" aria-label=\"Modal exportación de pólizas\" flex=\"50\" flex-xs=\"100\" flex-sm=\"60\" flex-md=\"50\" \nflex-lg=\"30\" flex-gt-lg=\"25\"><form name=\"form\"><md-toolbar class=\"md-primary toolbar-animated\"><div \nclass=\"md-toolbar-tools\"><h2 class=\"dialog-title\" flex>Generación de póliza contable</h2><md-button \nclass=\"md-icon-button close-btn\" aria-label=\"Cerrar\" ng-click=\"eacmCtrl.cancel()\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content layout=\"column\" class=\"dialog-content-animated\">\n<md-table-container><table md-table class=\"modern-table\"><tbody md-body><tr ng-repeat=\"data in eacmCtrl.dataToExport\" \nclass=\"row-hover-animated\"><td><div layout=\"row\" layout-align=\"center start\" class=\"download-row\" flex><div><strong>\n{{data.processName}}</strong> <em class=\"periodo-text\">Periodo: {{data.period}}</em></div><div><md-progress-circular \nng-if=\"(data.downloading) || (data.downloadingLayout)\" md-mode=\"indeterminate\" md-diameter=\"24\" \nstyle=\"margin: 0 10px; text-align: center\" class=\"md-accent\"></md-progress-circular><md-button with-permission \naction=\"layoutCompaq\" access=\"{{F.active.menuItem}}\" \nng-show=\"(!data.downloadingLayout && !data.downloading) && (data.process ===\'fiscal\' ? eacmCtrl.statusTimbre[data.operationId] === 6 : true) && data.access\" \nclass=\"download-btn\" style=\"height: 50px; width: 50px\" ng-click=\"eacmCtrl.downlandLayout(data)\"><md-icon \nmd-svg-src=\"/assets/icons/contpaqi.svg\" style=\"height: 60px; width: 60px; text-align: center\"></md-icon><md-tooltip \nmd-direction=\"top\">Descargar layout</md-tooltip></md-button><md-button \nng-show=\"!data.downloading && !data.downloadingLayout\" class=\"download-btn\" style=\"height: 50px; width: 50px\" \nng-click=\"eacmCtrl.downloadAccs(data)\"><md-icon md-svg-src=\"/assets/icons/accountCC.svg\" \nstyle=\"height: 30px; width: 30px\"></md-icon><md-tooltip md-direction=\"top\">Descargar póliza</md-tooltip></md-button>\n</div></div></td></tr></tbody></table></md-table-container></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/clients/views/newoperation/dialogs/incidence.html","<md-dialog aria-label=\"modal incidence for employee\"><form name=\"form\" novalidate ng-disabled=\"readOnlyMode\">\n<md-toolbar><div class=\"md-toolbar-tools\"><h2 flex>{{(action==\"edit\")?\'Actualizar\':\'Agregar\'}} incidencia de <small>\n{{employees[employeeIndex].data.name}}</small></h2><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close Dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div \nclass=\"md-dialog-content\"><div form-incidence-modal></div></div></md-dialog-content><md-dialog-actions layout=\"row\">\n<md-button ng-if=\'action==\"edit\"\' ng-click=\"saveIncidence(incidence)\" ng-hide=\"form.$pristine\" \nng-disabled=\"form.$invalid || loadingProgress\" class=\"md-raised md-background md-accent md-hue-1\" \naria-label=\"Save incidence\"><md-tooltip md-direction=\"left\">{{\'EC.SAVE\' | translate}}</md-tooltip><md-icon \nmd-font-icon=\"icon-content-save\" aria-label=\"Save\"></md-icon></md-button><md-button ng-if=\'action==\"add\"\' \nng-click=\"addIncidence(incidence)\" ng-hide=\"form.$pristine\" ng-disabled=\"form.$invalid || loadingProgress\" \nclass=\"md-raised md-background md-accent md-hue-1\" aria-label=\"Add incidence\"><md-tooltip md-direction=\"left\">\n{{\'EC.ADD\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon></md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/clients/views/newoperation/dialogs/ptu-distribution.html","<md-dialog aria-label=\"modal Special Payrolls\" id=\"ptuDistributionDialog\" flex=\"100\" flex-gt-md=\"80\" flex-gt-lg=\"70\" \nflex-gt-xs=\"90\"><form name=\"form\" style=\"min-width: 500px\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 flex>\nDistribución PTU</h2><md-button class=\"md-icon-button\" ng-click=\"pdmCtrl.cancel()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close Dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"p-15\"><div \nclass=\"detail-form-container md-background-bg modern-container\"><md-card class=\"md-whiteframe-3dp\" style=\"width:auto\">\n<md-card class=\"input-card\" flex=\"100\" layout=\"row\" layout-align=\"start center\"><md-input-container \nclass=\"md-block m-0 no-errors-spacer\" flex=\"70\"><label>Empresa</label><md-select \nng-model=\"pdmCtrl.operation.companiesRecordId\" ng-change=\"pdmCtrl.loadEmployees();pdmCtrl.loadIncidences();\" required \nplaceholder=\"Empresa\"><md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" \nng-keydown=\"$event.stopPropagation()\" ng-model=\"companiesRecordOneSelectFilter\" placeholder=\"Busque una Empresa\">\n</md-select-header><md-option ng-value=\"companiesRecord.$id \" \nng-repeat=\"companiesRecord in L.companiesRecords | orderBy:\'name\' | filter:companiesRecordOneSelectFilter\">\n{{companiesRecord.name}}</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block m-0 no-errors-spacer\" required flex=\"30\"><label>Calendario</label><md-select \nng-model=\"pdmCtrl.operation.calendar\" ng-change=\"pdmCtrl.loadEmployees()\" placeholder=\"Calendario\"><md-option \nng-value=\"2022\">2022</md-option><md-option ng-value=\"2023\">2023</md-option><md-option ng-value=\"2024\">2024</md-option>\n<md-option ng-value=\"2025\">2025</md-option></md-select><div ng-messages=\"form.calendar.$error\" role=\"alert\"><div \nng-message=\"required\">La fecha es requerido</div></div></md-input-container></md-card><md-card \nclass=\"input-card mt-15 mb-15\" flex=\"100\" layout=\"row\" layout-align=\"start center\"><md-input-container \nclass=\"md-block m-0 no-errors-spacer\" flex=\"33\"><label>Monto a distribuir</label><input type=\"number\" step=\"any\" \nrequired ng-model-options=\"{ debounce: pdmCtrl.debounceTime }\" ng-change=\"pdmCtrl.calculateFactors()\" \nname=\"totalAmount\" min=\".00001\" ng-model=\"pdmCtrl.operation.totalAmount\"><div ng-messages=\"form.sdr.$error\" \nrole=\"alert\"><div ng-message=\"required\">Monto a distribuir</div></div></md-input-container><md-input-container \nclass=\"md-block m-0 no-errors-spacer\" flex=\"33\"><label>\nFactor x dia {{pdmCtrl.operation.totalDays ? \"(Total: \"+pdmCtrl.operation.totalDays+\")\" : \"\"}}</label><input \ntype=\"number\" step=\"any\" required name=\"dayFactor\" min=\".00001\" ng-model=\"pdmCtrl.operation.dayFactor\"><div \nng-messages=\"form.sdr.$error\" role=\"alert\"><div ng-message=\"required\">Factor x dia es requerido</div></div>\n</md-input-container><md-input-container class=\"md-block m-0 no-errors-spacer\" flex=\"33\"><label>\nFactor x ingresos {{pdmCtrl.operation.totalSalary ? \"(Total: \"+pdmCtrl.operation.totalSalary+\")\" : \"\"}}</label><input \ntype=\"number\" step=\"any\" required name=\"salaryFactor\" min=\".00001\" ng-model=\"pdmCtrl.operation.salaryFactor\"><div \nng-messages=\"form.sdr.$error\" role=\"alert\"><div ng-message=\"required\">Factor x ingresos es requerido</div></div>\n</md-input-container></md-card><md-card class=\"input-card mt-15\" flex=\"100\" layout=\"row\" layout-align=\"start center\">\n<md-input-container class=\"md-block m-0 no-errors-spacer\" flex=\"100\"><label>Procesos de configuración</label><md-select\n ng-model=\"pdmCtrl.operation.processConfigId\" name=\"processConfigId\" required><md-select-header><input \nautocomplete=\"off\" type=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" \nng-model=\"processesSelectFilter\" placeholder=\"Busque un proceso\"></md-select-header><md-option \nng-value=\"processConfig.id\" \nng-repeat=\"processConfig in pdmCtrl.processesConfig | orderBy:\'name\' | filter:processesSelectFilter\">\n{{processConfig.name}}</md-option></md-select><div ng-messages=\"form.processConfig.$error\" role=\"alert\"><div \nng-message=\"required\">El proceso de configuración es requerido</div></div></md-input-container></md-card></md-card>\n</div><div class=\"detail-form-container md-background-bg modern-container\"><md-card class=\"md-whiteframe-3dp\" \nstyle=\"width:auto\"><div layout=\"row\" ng-if=\"pdmCtrl.operation.totalAmount && pdmCtrl.operation.calendar\" \nlayout-align=\"start start\" flex=\"100\"><div flex=\"30\"><div class=\"sticky-header\"><md-card-title class=\"pb-1\">\n<md-card-title-text><span class=\"font-weight-600 pl-2\">Ausentismos a descontar</span></md-card-title-text>\n</md-card-title></div><div class=\"scrollable-panel\"><md-card class=\"input-card\" flex=\"100\" layout=\"column\" \nlayout-align=\"start start\"><div class=\"animate-fade-in-out\"><div ng-repeat=\"incidence in pdmCtrl.payrollIncidences\" \nflex=\"100\"><md-checkbox ng-model=\"pdmCtrl.operation.absencesToCheck[incidence.fid]\" aria-label=\"{{incidence.name}}\" \nng-change=\"pdmCtrl.calculateFactors()\" class=\"md-caption\">{{incidence.name}} ({{incidence.id_human}})</md-checkbox>\n</div></div></md-card></div></div><div flex=\"70\"><div class=\"table-container\"><table class=\"custom-table\"><thead><tr>\n<th>Empleado <span class=\"text-boxed md-orange-A400-bg orange-50-fg\">{{pdmCtrl.operation.employees | objectsLength}}\n</span> <button ng-click=\"pdmCtrl.loadEmployees()\" class=\"md-icon-button\" aria-label=\"reload\"><md-tooltip>\nCargar empleados nuevamente</md-tooltip><md-icon md-font-icon=\"icon-account-search\"></md-icon></button></th><th \nstyle=\"text-align: center\">Días trabajados</th><th style=\"text-align: center\">Ingreso Anual</th><th \nstyle=\"text-align: center\">Acciones</th></tr></thead><tbody><tr \nng-repeat=\"(key, employee) in pdmCtrl.operation.employees\" class=\"animate-slide-left\"><td>{{employee.name}}</td><td \nclass=\"text-center\">{{employee.totalDaysNoAbs||(employee.workedDays-(employee.daysToDiscount||0))}}</td><td><div \nlayout=\"row\" layout-align=\"start center\"><div flex ng-if=\"pdmCtrl.editEmployees[employee.employeeId].totalSalary\">\n<md-input-container class=\"md-block p-0\" md-no-float><input type=\"number\" required min=\"0\" \nname=\"{{employee.employeeId+\'totalSalary\'}}\" ng-model=\"employee.totalSalary\" placeholder=\"Ingreso Anual\" form><div \nng-messages=\'form[employee.employeeId+\"totalSalary\"].$error\' role=\"alert\"><div ng-message=\"required\">\nEl ingreso anual es requerido</div><div ng-message=\"min\">El ingreso anual deber ser mayor a 0</div></div>\n</md-input-container></div><div flex style=\"text-align: center\" \nng-if=\"!pdmCtrl.editEmployees[employee.employeeId].totalSalary\"><span style=\"text-align: center\">\n{{employee.totalSalary | currency}}</span></div></div></td><td class=\"text-center\" layout=\"row\" \nlayout-align=\"center center\"><div flex=\"nogrow\" style=\"text-align: center\"><button \nng-if=\" !pdmCtrl.editEmployees[employee.employeeId].totalSalary\" \nng-click=\"pdmCtrl.editEmployees[employee.employeeId].totalSalary=true;\" class=\"md-icon-button md-primary\" \naria-label=\"Edit\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></button> <button \nng-if=\"pdmCtrl.editEmployees[employee.employeeId].totalSalary\" ng-disabled=\"!employee.totalSalary\" \nng-click=\"pdmCtrl.editEmployees[employee.employeeId].totalSalary=false;pdmCtrl.calculateFactors();\" \nclass=\"md-icon-button md-primary\" aria-label=\"Save\"><md-icon md-font-icon=\"icon-content-save\"></md-icon></button></div>\n<div flex=\"nogrow\" style=\"text-align: center\"><button ng-click=\"pdmCtrl.removeEmployee(key)\" \nclass=\"md-icon-button md-primary\" aria-label=\"Delete\"><md-icon md-font-icon=\"icon-trash\" class=\"white-icon-trash\">\n</md-icon></button></div></td></tr></tbody></table></div></div></div></md-card></div></md-dialog-content>\n<md-dialog-actions><md-button ng-click=\"pdmCtrl.saveOperation(pdmCtrl.operation)\" ng-disabled=\"form.$invalid\" \nclass=\"md-primary\">Guardar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/clients/views/newoperation/dialogs/select-period.html","<md-dialog aria-label=\"Select date to bill\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Seleccionar periodo</h2>\n</div></md-toolbar><md-dialog-content><div><h3 class=\"mt-0\">\nSeleccione el periodo en el que se va a acumular la operación</h3></div><form name=\"form\"><md-input-container \nclass=\"md-block\"><label>Periodo</label><md-select ng-model=\"period\" required placeholder=\"Seleccione un periodo\">\n<md-option ng-value=\"period\" ng-repeat=\"period in periods\">\nPeriodo {{period.period}} - {{period.start|date:\'mediumDate\'}} - {{period.end|date:\'mediumDate\'}}</md-option>\n</md-select></md-input-container></form></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nclass=\"md-accent md-raised md-warn\" ng-click=\"cancel()\">Cancelar</md-button><md-button \nclass=\"md-accent md-raised md-primary\" ng-click=\"hide()\" ng-disabled=\"form.$invalid\">Timbrar Finiquito</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/clients/views/newoperation/dialogs/settlements.html","<md-dialog aria-label=\"modal Settlements\" class=\"settlements\" style=\"width: 700px\"><form name=\"form\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2 flex>Finiquitos</h2><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close Dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div \nclass=\"md-dialog-content\"><div form-dismiss></div><md-input-container class=\"md-block\" \nng-if=\"userHasPermissionProcessesConfig && !processConfigError\" flex><label>Procesos de configuración</label><md-select\n ng-model=\"employee.processConfig\" name=\"processConfig\" ng-change=\"setConcepts(employee.processConfig)\" required>\n<md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" \nng-model=\"processesSelectFilter\" placeholder=\"Busque un proceso\"></md-select-header><md-option \nng-value=\"processConfig.id\" \nng-repeat=\"processConfig in processesConfig | orderBy:\'name\' | filter:processesSelectFilter track by processConfig.id\">\n{{processConfig.name}}</md-option></md-select><div ng-messages=\"form.processConfig.$error\" role=\"alert\"><div \nng-message=\"required\">El proceso de configuración es requerido</div></div></md-input-container><div flex=\"nogrow\">\n<md-radio-group ng-model=\"employee.disableMonthlyBase\" aria-labelledby=\"disableMonthlyBase\"><md-radio-button \nng-value=\"undefined\">\nConsiderar acumulados del mes de la fecha de baja(se tomaran en cuenta los datos de las operaciones cerradas)\n</md-radio-button><md-radio-button ng-value=\"true\">\nNo considerar acumulados (Solo se tomaran los ingresos de este finiquito)</md-radio-button></md-radio-group></div><div \nflex ng-if=\"employee.processConfig && !processConfigError\"><md-checkbox ng-model=\"employee.incidences[item.$id]\" \nng-change=\"checkHasChristmasBonusF(employee.incidences,employee.payroll)\" \nng-repeat=\"item in processObj[employee.processConfig]\" aria-label=\"hiddenColumn\">{{item.name}}</md-checkbox></div>\n<fieldset ng-if=\"settlementHasChristmasBonusF\" class=\"absence-discount-options\"><legend>Descontar ausentismos</legend>\n<div layout=\"row\" layout-wrap><div ng-repeat=\"item in settlementIncidences\" flex=\"nogrow\" class=\"mr-5\"><md-checkbox \nng-model=\"employee.absencesToCheck[item.fid]\" aria-label=\"hiddenColumn\">{{item.name}}</md-checkbox></div></div>\n</fieldset><div flex><div layout-gt-xs><div flex=\"nogrow\"><md-button \nng-disabled=\"form.pending || form.$invalid || loadingProgress && !employee.payroll && !employee.data.enroleDate\" \nng-click=\'saveSettlements(employee, movement, \"settlements\")\' class=\"md-primary md-raised btn-add\" \naria-label=\"Add item\"><md-tooltip md-direction=\"top\">{{\'EC.SAVE\' | translate}}</md-tooltip><md-icon \nmd-font-icon=\"icon-content-save\" aria-label=\"Save\"></md-icon></md-button></div></div></div></div></md-dialog-content>\n</form></md-dialog>");
$templateCache.put("app/main/clients/views/newoperation/dialogs/special-payrolls.html","<md-dialog aria-label=\"modal Special Payrolls\" class=\"special-payrolls\"><form name=\"form\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2 flex>{{opeConfig.title}}</h2><md-button class=\"md-icon-button\" ng-click=\"cancel()\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Close Dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><div class=\"md-dialog-content\"><div flex><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container\n class=\"md-block mb-0 no-errors-spacer\" flex><label>Nómina</label><md-select ng-model=\"special.payroll\" name=\"payroll\" \nrequired ng-change=\"loadList(special.payroll,special.specialDate)\" \nng-disabled=\"F.readMode || (specialPayrolls | objectsLength) > 0\"><md-select-header><input autocomplete=\"off\" \ntype=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"payrollSelectFilter\" \nplaceholder=\"Busque una nómina\"></md-select-header><md-option ng-if=\"payroll.active||(!F.addMode)\" \nng-value=\"payroll.$id\" ng-class=\'{\"inactiveOption\":!payroll.active}\' ng-disabled=\"!payroll.active\" \nng-repeat=\"payroll in (F.permissionToAccessAllPayrolls?L.allPayrolls:L.payrolls) | orderBy:\'class\' | filter:payrollSelectFilter\">\n{{payroll.class}} {{payroll.name}}</md-option></md-select><div ng-messages=\"form.payroll.$error\" role=\"alert\"><div \nng-message=\"required\">Nómina es requerido</div></div></md-input-container><md-input-container \nclass=\"md-block date-picker mb-0 no-errors-spacer h-auto\" flex=\"nogrow\"><label>Fecha</label><md-datepicker \nmd-hide-icons=\"triangle\" ng-model=\"special.specialDate\" ng-change=\"loadList(special.payroll, special.specialDate)\" \nmd-min-date=\"minDate\" md-max-date=\"maxDate\" ng-disabled=\"disableDate\" required input-date-miliseconds \nng-change=\"addPeriod(special.payroll, special.specialDate)\" name=\"specialDate\" class=\"md-block\"></md-datepicker><div \nng-messages=\"form.specialDate.$error\" role=\"alert\"><div ng-message=\"required\">La fecha es requerido</div></div>\n</md-input-container></div><h3 ng-if=\"special.period\"><em>Calendario: <strong>{{special.calendar}}</strong> Periodo: \n<strong>{{special.period}}</strong></em></h3><div layout=\"column\"><md-input-container class=\"md-block mb-0\" flex>\n<label>Procesos de configuración</label><md-select ng-model=\"special.processConfig\" \nng-change=\"setConcepts(special.processConfig)\" name=\"processConfig\" required><md-select-header><input \nautocomplete=\"off\" type=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" \nng-model=\"processesSelectFilter\" placeholder=\"Busque un proceso\"></md-select-header><md-option \nng-value=\"processConfig.id\" \nng-repeat=\"processConfig in processesConfig | orderBy:\'name\' | filter:processesSelectFilter\">{{processConfig.name}}\n</md-option></md-select><div ng-messages=\"form.processConfig.$error\" role=\"alert\"><div ng-message=\"required\">\nEl proceso de configuración es requerido</div></div></md-input-container></div><div layout=\"column\" \nlayout-align=\"start start\" ng-if=\"type === \'chrisBonusRecord\' && payrollIncidences.length > 0\"><label \nclass=\"md-caption\">Ausentismos a descontar</label><div layout=\"row\" layout-wrap><div \nng-repeat=\"incidence in payrollIncidences\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"33\" flex-gt-lg=\"20\"><md-checkbox \nng-model=\"special.absencesToCheck[incidence.fid]\" aria-label=\"{{incidence.name}}\" class=\"md-body-1\">\n{{incidence.name}} ({{incidence.id_human}})</md-checkbox></div></div></div><div layout-gt-xs=\"row\"><md-input-container \nclass=\"md-block\" flex><label>Empleado</label><md-select ng-model=\"special.employee\" name=\"employee\" \nng-disabled=\"F.readMode\"><md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" \nng-keydown=\"$event.stopPropagation()\" ng-model=\"employeeSelectFilter\" placeholder=\"Seleccione un empleado\">\n</md-select-header><md-option ng-value=\"employee.fid\" ng-disabled=\"employee.hidden\" \nng-class=\"{\'inactiveOption\': employee.status == 5}\" ng-repeat=\"employee in employees | filter:employeeSelectFilter\">\n{{employee.data.name}}</md-option></md-select></md-input-container><div flex=\"nogrow\"><md-button \nng-disabled=\"readMode || !special.employee\" ng-click=\"addEmployee(employees, special.employee)\" \nclass=\"md-primary md-raised mt-add\" aria-label=\"Add item\"><md-tooltip md-direction=\"top\">Agregar</md-tooltip><md-icon \nmd-font-icon=\"icon-plus\" aria-label=\"Add\"></md-icon></md-button><md-button \nng-disabled=\"readMode || !employees || employees.length===0\" ng-click=\"setAllEmployees()\" \nclass=\"md-primary md-raised mt-add\" aria-label=\"Add all\"><md-tooltip md-direction=\"top\">\nAgregar todos los empleados activos</md-tooltip><md-icon md-font-icon=\"icon-account-multiple-plus\" \naria-label=\"Add All\"></md-icon></md-button></div></div><div class=\"table-responsive\"><table for=\"payrolls\" \nng-if=\"(specialPayrolls | objectsLength) > 0\" class=\"default-table\"><thead><tr><th>Empleado</th><th>Acción</th></tr>\n</thead><tbody><tr ng-class=\"{\'inProcessMovement\':value.status >= 3}\" ng-repeat=\"(key, value) in specialPayrolls\"><td>\n{{value.name}}</td><td><button ng-click=\"removeEmployee(key)\" ng-disabled=\"value.status >= 3\" class=\"md-icon-button\" \naria-label=\"Delete\"><md-tooltip md-direction=\"right\" ng-if=\"value.status >= 3\">Empleado cerrado</md-tooltip><md-icon \nmd-font-icon=\"icon-trash\" class=\"white-icon-trash\"></md-icon></button></td></tr></tbody></table></div><div \nclass=\"btn-save\" ng-if=\"(specialPayrolls | objectsLength) !== 0\"><md-button \nng-click=\'saveSpecialPayrolls(specialPayrolls, special, \"special\")\' \nng-disabled=\"(form.pending || form.$invalid || loadingProgress || loadingPeriod) && !special.specialDate\" \nclass=\"md-primary md-raised btn-add\" aria-label=\"Add item\"><md-tooltip md-direction=\"top\">{{\'EC.SAVE\' | translate}}\n</md-tooltip><md-icon md-font-icon=\"icon-content-save\" aria-label=\"Save\"></md-icon></md-button></div></div></div>\n</md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/clients/views/newoperation/tabs/fiscal.html","<div ng-if=\"fiscalEmployees.length && firstFinished\" flex style=\"overflow: auto\"><div class=\"paginationSection\">\n<md-table-pagination md-limit=\"myLimitFiscal\" md-page=\"myPageFiscal\" md-total=\"{{fiscalEmployees.length}}\" \nmd-limit-options=\"paginationFis\" md-label=\"{{F.paginationLabel}}\" md-page-select></md-table-pagination></div><table \nng-if=\"fiscalEmployees.length\" id=\"table_sabana\" class=\"row-border\"><thead><tr><th><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"padding-left-5\" flex=\"nogrow\"><input class=\"checked\" \naria-label=\"select employee\" ng-checked=\"F.allAreSelected(fiscalEmployees, selected, \'$id\')\" type=\"checkbox\" \nng-click=\"F.toggleAll(fiscalEmployees, selected, \'$id\')\"></div><span flex=\"nogrow\">NOMBRE</span><div flex \nclass=\"text-right\"><md-button class=\"md-icon-button md-primary\" aria-label=\"Settings\" \nng-click=\"setNextOrder(\'data.name\',order)\"><md-icon md-font-icon=\"icon-filter-variant\" aria-label=\"Order by Date\" \nng-if=\"order!==\'data.name\'&&order!=\'-data.name\'\"></md-icon><md-icon md-font-icon=\"icon-arrow-down\" \naria-label=\"Order Descendent\" ng-if=\"order==\'data.name\'\"></md-icon><md-icon md-font-icon=\"icon-arrow-up\" \naria-label=\"Order Ascendent\" ng-if=\"order==\'-data.name\'\"></md-icon></md-button></div></div></th><th \nng-repeat=\"($index,x) in pro.concepts | orderBy: [\'order\',\'name\'] track by $index\" ng-if=\"!x.hiddenColumn\"><span \nng-if=\"x.conceptType !== \'incidenceType\'\" \nng-class=\"{\'blueC\':x.nature === \'perception\', \'redC\':x.nature === \'deduction\'}\" ng-bind=\"x.name\"></span> <span \nng-if=\"x.conceptType === \'incidenceType\'\" \nng-class=\"{\'blueC\': x.nature === \'perception\', \'redC\': x.nature === \'deduction\'}\" ng-bind=\"x.name\"></span></th></tr>\n</thead><tbody><tr ng-hide=\"employee.hide\" \nng-repeat=\"employee in fiscalEmployees | orderBy: order | limitTo: myLimitFiscal: (myPageFiscal - 1) * myLimitFiscal track by employee.$id\">\n<td class=\"text-left\"><input class=\"checked\" aria-label=\"select employee\" ng-checked=\"exists(employee, selected)\" \ntype=\"checkbox\" ng-click=\"toggle(employee, selected)\"><label ng-bind=\"employee.data.name\"></label><span \nng-if=\"operation.employees[employee.$id].billId\" class=\"greenC doneMark\">✓</span><md-button class=\"md-icon-button\" \nng-class=\"{\'md-warn\':operation.employees[employee.$id].status==4}\" ng-if=\"operation.employees[employee.$id].errorMsg\" \naria-label=\"error msg\"><md-tooltip md-direction=\"right\">{{operation.employees[employee.$id].errorMsg}}</md-tooltip>\n<md-icon md-font-icon=\"icon-alert\"></md-icon></md-button><md-button class=\"md-icon-button md-warn\" \nng-if=\"operation.employees[employee.$id].cancelError\" \nng-click=\"directCancel(operation.employees[employee.$id].cancelBill)\" aria-label=\"error msg\"><md-tooltip \nmd-direction=\"right\">{{operation.employees[employee.$id].cancelError}}</md-tooltip><md-icon \nmd-font-icon=\"icon-sim-alert\"></md-icon></md-button></td><td \nng-repeat=\"($index,x) in pro.concepts | orderBy: [\'order\',\'name\']  track by $index\" ng-if=\"!x.hiddenColumn\"><label \nng-if=\"x.type!=\'fast\' && x.conceptType === \'incidenceType\'\"><span \nng-class=\"{\'blueC\':x.nature === \'perception\', \'redC\':x.nature === \'deduction\'}\" \nng-bind=\"calculations[employee.$id][x.key].fiscalValue.formatted?calculations[employee.$id][x.key].fiscalValue.formatted:(0|currency)\">\n</span></label><label ng-if=\"x.conceptType !== \'incidenceType\'\" \nng-class=\"{\'blueC\':x.nature === \'perception\', \'redC\':x.nature === \'deduction\'}\" \nng-bind=\"calculations[employee.$id][x.key].value.formatted?calculations[employee.$id][x.key].value.formatted:(0|currency)\">\n</label></td></tr></tbody><tfoot><tr class=\"totales\"><th></th><th \nng-repeat=\"($index,x) in pro.concepts | orderBy: [\'order\',\'name\'] track by $index\" ng-if=\"!x.hiddenColumn\"><span \nng-if=\"operationTotals[x.$id].type === \'currency\' && x.conceptType === \'currency\' && x.showTotal\" \nng-bind=\"operationTotals[x.$id].value | currency\"></span> <span \nng-if=\"operationTotals[x.$id].type !== \'currency\' && x.conceptType === \'currency\' && x.showTotal\" \nng-bind=\"operationTotals[x.$id].value\"></span> <span \nng-if=\"operationTotals[x.$id].type === \'currency\' && x.conceptType !== \'incidenceType\' && x.showTotal\" \nng-bind=\"operationTotals[x.$id].value | currency\"></span> <span \nng-if=\"operationTotals[x.$id].type !== \'currency\' && x.conceptType !== \'incidenceType\' && x.showTotal\" \nng-bind=\"operationTotals[x.$id].value\"></span> <span \nng-if=\"operationTotals[x.$id].type === \'currency\' && x.conceptType===\'incidenceType\'\" \nng-class=\"{\'blueC\':x.nature === \'perception\', \'redC\': x.nature === \'deduction\'}\" \nng-bind=\"operationTotals[x.$id].fiscalValue | currency\"></span> <span \nng-if=\"operationTotals[x.$id].type !== \'currency\' && x.conceptType===\'incidenceType\'\" \nng-class=\"{\'blueC\':x.nature === \'perception\', \'redC\': x.nature === \'deduction\'}\" \nng-bind=\"operationTotals[x.$id].fiscalValue\"></span></th></tr></tfoot></table></div>");
$templateCache.put("app/main/clients/views/newoperation/tabs/others.html","<div ng-if=\"operationEmployees.length && firstFinished\" flex style=\"overflow: auto\"><div class=\"paginationSection\">\n<md-table-pagination md-limit=\"myLimitOperation\" md-page=\"myPageOperation\" md-total=\"{{operationEmployees.length}}\" \nmd-limit-options=\"paginationOpe\" md-label=\"{{F.paginationLabel}}\" md-page-select></md-table-pagination></div><table \nng-if=\"operationEmployees.length\" id=\"table_sabana\" class=\"row-border\"><thead><tr><th class=\"text-left\"><label \nclass=\"pl-10\">Nombre</label></th><th ng-repeat=\"($index,x) in pro.concepts | orderBy: \'order\' track by $index\" \nng-if=\"!x.hiddenColumn\"><span ng-if=\"x.conceptType !== \'incidenceType\'\" ng-bind=\"x.name\"></span> <span \nng-if=\"x.conceptType === \'incidenceType\'\" \nng-class=\"{\'blueC\': x.nature === \'perception\', \'redC\': x.nature === \'deduction\'}\" ng-bind=\"x.name\"></span></th></tr>\n</thead><tbody><tr ng-hide=\"employee.hide\" \nng-repeat=\"employee in operationEmployees | orderBy: order | limitTo: myLimitOperation: (myPageOperation - 1) * myLimitOperation track by employee.$id\">\n<td class=\"text-left\"><input class=\"checked\" aria-label=\"select employee\" ng-checked=\"exists(employee, selected)\" \ntype=\"checkbox\" ng-click=\"toggle(employee, selected)\"><label ng-bind=\"employee.data.name\"></label></td><td \nng-repeat=\"($index,x) in pro.concepts | orderBy: \'order\' track by $index\" ng-if=\"!x.hiddenColumn\"><label \nng-if=\"x.type!=\'fast\' && x.conceptType === \'incidenceType\'\"><span \nng-class=\"{\'blueC\':x.nature === \'perception\', \'redC\':x.nature === \'deduction\'}\" \nng-bind=\"calculations[employee.$id][x.key].socialPrevisionValue.formatted?calculations[employee.$id][x.key].socialPrevisionValue.formatted:(0|currency)\">\n</span></label><label ng-if=\"x.conceptType !== \'incidenceType\'\" \nng-bind=\"calculations[employee.$id][x.key].value.formatted?calculations[employee.$id][x.key].value.formatted:(0|currency)\">\n</label></td></tr></tbody><tfoot><tr class=\"totales\"><th></th><th \nng-repeat=\"($index,x) in pro.concepts | orderBy: \'order\' track by $index\" ng-if=\"!x.hiddenColumn\"><span \nng-if=\"x.conceptType !== \'incidenceType\' && x.showTotal\" ng-bind=\"operationTotals[x.$id].value\"></span> <span \nng-if=\"x.conceptType===\'incidenceType\'\" \nng-class=\"{\'blueC\':x.nature === \'perception\', \'redC\': x.nature === \'deduction\'}\" \nng-bind=\"operationTotals[x.$id].socialPrevision\"></span></th></tr></tfoot></table></div>");
$templateCache.put("app/main/clients/views/newoperation/tabs/real.html","<div ng-if=\"operationEmployees.length && firstFinished\" flex style=\"overflow: auto\"><div class=\"paginationSection\">\n<md-table-pagination md-limit=\"myLimitOperation\" md-page=\"myPageOperation\" md-total=\"{{operationEmployees.length}}\" \nmd-limit-options=\"paginationOpe\" md-label=\"{{F.paginationLabel}}\" md-page-select></md-table-pagination></div><table \nng-if=\"operationEmployees.length\" id=\"table_sabana\" class=\"row-border\"><thead><tr><th><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"padding-left-5\" flex=\"nogrow\"><input class=\"checked\" \naria-label=\"select employee\" ng-checked=\"F.allAreSelected(operationEmployees, selected, \'$id\')\" type=\"checkbox\" \nng-click=\"F.toggleAll(operationEmployees, selected, \'$id\')\"></div><span flex=\"nogrow\">NOMBRE</span><div flex \nclass=\"text-right\"><md-button class=\"md-icon-button md-primary\" aria-label=\"Settings\" \nng-click=\"setNextOrder(\'data.name\',order)\"><md-icon md-font-icon=\"icon-filter-variant\" aria-label=\"Order by Date\" \nng-if=\"order!==\'data.name\'&&order!=\'-data.name\'\"></md-icon><md-icon md-font-icon=\"icon-arrow-down\" \naria-label=\"Order Descendent\" ng-if=\"order==\'data.name\'\"></md-icon><md-icon md-font-icon=\"icon-arrow-up\" \naria-label=\"Order Ascendent\" ng-if=\"order==\'-data.name\'\"></md-icon></md-button></div></div></th><th \nng-repeat=\"($index,x) in pro.concepts | orderBy: [\'order\',\'name\'] track by $index\" ng-if=\"!x.hiddenColumn\"><span \nng-if=\"x.conceptType !== \'incidenceType\'\" \nng-class=\"{\'blueC\':x.nature === \'perception\', \'redC\':x.nature === \'deduction\'}\" ng-bind=\"x.name\"></span> <span \nng-if=\"x.type === \'normal\'\" ng-class=\"{\'blueC\':x.nature === \'perception\', \'redC\':x.nature === \'deduction\'}\" \nng-bind=\"x.name\"></span> <span ng-if=\"x.type === \'fast\'\" \nng-class=\"{\'greenC\':x.nature === \'perception\', \'orangeC\':x.nature === \'deduction\'}\" ng-bind=\"x.name\"></span></th></tr>\n</thead><tbody><tr ng-hide=\"employee.hide\" \nng-repeat=\"employee in operationEmployees | orderBy: order | limitTo: myLimitOperation: (myPageOperation - 1) * myLimitOperation track by employee.$id\">\n<td class=\"text-left\"><input class=\"checked\" aria-label=\"select employee\" ng-checked=\"exists(employee, selected)\" \ntype=\"checkbox\" ng-click=\"toggle(employee, selected)\"><label ng-bind=\"employee.data.name\"></label><md-icon \nmd-font-icon=\"icon-lock-outline\" ng-if=\"operation.employees[employee.$id].status >= 3\"></md-icon><span \nng-if=\"operation.employees[employee.$id].status === operation.status && operation.status < 3\" class=\"greenC doneMark\">✓\n</span></td><td ng-repeat=\"($index,x) in pro.concepts | orderBy: [\'order\',\'name\']  track by $index\" \nng-if=\"!x.hiddenColumn\"><md-input-container \nng-if=\'operation.employees[employee.$id].status < 3 && x.type==\"fast\" && x.inputType==\"currency\"\' md-no-float><input \nignore-mouse-wheel validate-incidences-qty \nng-class=\"{\'greenC\':x.type === \'fast\' && x.nature === \'perception\', \'orangeC\':x.type === \'fast\' && x.nature === \'deduction\'}\" \nng-model-options=\"{ debounce: 1500 }\" ng-model=\"fastIncidences[employee.$id][x.$id]\" \nmin=\"{{x.allowNegative?undefined:0}}\" max-incidences=\"calculations[employee.$id][x.key].availableFast.result\" \naria-label=\"incidence value\" tabindex=\"{{$index+1}}000\" \nng-readonly=\"operation.employees[employee.$id].status >= nextEmployeeStatus\" \nng-change=\"saveFastIncidence(employee.$id,x.$id,fastIncidences[employee.$id][x.$id])\" placeholder=\"$\" type=\"number\">\n</md-input-container><md-input-container \nng-if=\'operation.employees[employee.$id].status < 3 && x.type==\"fast\" && x.inputType==\"float\"\' md-no-float><input \nignore-mouse-wheel validate-incidences-qty \nng-class=\"{\'greenC\':x.type === \'fast\' && x.nature === \'perception\', \'orangeC\':x.type === \'fast\' && x.nature === \'deduction\'}\" \nng-model-options=\"{ debounce: 1500}\" ng-model=\"fastIncidences[employee.$id][x.$id]\" \nmin=\"{{x.allowNegative?undefined:0}}\" max-incidences=\"calculations[employee.$id][x.key].availableFast.result\" \naria-label=\"incidence value\" ng-readonly=\"operation.employees[employee.$id].status >= nextEmployeeStatus\" \ntabindex=\"{{$index+1}}000\" ng-change=\"saveFastIncidence(employee.$id,x.$id,fastIncidences[employee.$id][x.$id])\" \nplaceholder=\"0\" type=\"number\"></md-input-container><md-input-container \nng-if=\'operation.employees[employee.$id].status < 3 && x.type==\"fast\" && x.inputType==\"integer\"\' md-no-float><input \nignore-mouse-wheel validate-incidences-qty \nng-class=\"{\'greenC\':x.type === \'fast\' && x.nature === \'perception\', \'orangeC\':x.type === \'fast\' && x.nature === \'deduction\'}\" \nng-model-options=\"{ debounce:1500 }\" ng-model=\"fastIncidences[employee.$id][x.$id]\" \nmin=\"{{x.allowNegative?undefined:0}}\" max-incidences=\"calculations[employee.$id][x.key].availableFast.result\" \naria-label=\"incidence value\" ng-readonly=\"operation.employees[employee.$id].status >= nextEmployeeStatus\" \ntabindex=\"{{$index+1}}000\" ng-change=\"saveFastIncidence(employee.$id,x.$id,fastIncidences[employee.$id][x.$id])\" \nplaceholder=\"0\" step=\"1\" type=\"number\"></md-input-container><label \nng-if=\"operation.employees[employee.$id].status >= 3 && x.type==\'fast\'\" \nng-class=\"{\'greenC\':x.type === \'fast\' && x.nature === \'perception\', \'orangeC\':x.type === \'fast\' && x.nature === \'deduction\'}\">\n<span ng-if=\"calculations[employee.$id][x.key].fastIncidences.formatted\" \nng-bind=\"calculations[employee.$id][x.key].fastIncidences.formatted\"></span> <span \nng-if=\"!calculations[employee.$id][x.key].fastIncidences.formatted && x.inputType==\'currency\'\">$0.00 </span><span \nng-if=\"!calculations[employee.$id][x.key].fastIncidences.formatted && x.inputType!=\'currency\'\">0</span></label><label \nng-if=\"x.type!=\'fast\' && x.conceptType === \'incidenceType\'\"><span \nng-if=\"calculations[employee.$id][x.key].valueNormal.result!==calculations[employee.$id][x.key].normalIncidences.result && !x.hiddenField\" \nng-class=\"{\'orangeC\':x.nature === \'deduction\', \'greenC\':x.nature === \'perception\'}\" \nng-bind=\"calculations[employee.$id][x.key].normalIncidences.formatted+\'->\'\"></span> <span \nng-if=\"calculations[employee.$id][x.key].rejectedIncidences.result > 0\" class=\"show-rejected-incidences\"><div \naria-label=\"Show Rejected Incidences\"><md-tooltip md-direction=\"left\">Este concepto tiene incidencia rechazada\n</md-tooltip><md-icon md-font-icon=\"icon-alert\" aria-label=\"Show Rejected Incidences\"></md-icon></div></span><span \nng-class=\"{\'blueC\':x.nature === \'perception\', \'redC\':x.nature === \'deduction\'}\" \nng-if=\"calculations[employee.$id][x.key].valueNormal.formatted\" \nng-bind=\"calculations[employee.$id][x.key].valueNormal.formatted\"></span> <span \nng-class=\"{\'blueC\':x.nature === \'perception\', \'redC\':x.nature === \'deduction\'}\" \nng-if=\"!calculations[employee.$id][x.key].valueNormal.formatted && x.inputType==\'currency\'\">$0.00 </span><span \nng-class=\"{\'blueC\':x.nature === \'perception\', \'redC\':x.nature === \'deduction\'}\" \nng-if=\"!calculations[employee.$id][x.key].valueNormal.formatted && x.inputType!=\'currency\'\">0</span></label><label \nng-if=\"x.conceptType !== \'incidenceType\'\" \nng-class=\"{\'blueC\':x.nature === \'perception\', \'redC\':x.nature === \'deduction\'}\"><span \nng-if=\"calculations[employee.$id][x.key].value.formatted\" ng-bind=\"calculations[employee.$id][x.key].value.formatted\">\n</span> <span ng-if=\"!calculations[employee.$id][x.key].value.formatted && x.inputType==\'currency\'\">$0.00 </span><span \nng-if=\"!calculations[employee.$id][x.key].value.formatted && x.inputType!=\'currency\'\">0</span></label></td></tr>\n</tbody><tfoot><tr class=\"totales\"><th></th><th \nng-repeat=\"($index,x) in pro.concepts | orderBy: [\'order\',\'name\'] track by $index\" ng-if=\"!x.hiddenColumn\"><span \nng-if=\"operationTotals[x.$id].type === \'currency\' && x.conceptType !== \'incidenceType\' && x.showTotal\" \nng-bind=\"operationTotals[x.$id].value | currency\"></span> <span \nng-if=\"operationTotals[x.$id].type !== \'currency\' && x.conceptType !== \'incidenceType\' && x.showTotal\" \nng-bind=\"operationTotals[x.$id].value\"></span> <span \nng-if=\"operationTotals[x.$id].type === \'currency\' && x.type === \'normal\' && x.showTotal\" \nng-class=\"{\'blueC\':x.nature === \'perception\', \'redC\':x.nature === \'deduction\'}\" \nng-bind=\"operationTotals[x.$id].normal | currency\"></span> <span \nng-if=\"operationTotals[x.$id].type !== \'currency\' && x.type === \'normal\' && x.showTotal\" \nng-class=\"{\'blueC\':x.nature === \'perception\', \'redC\':x.nature === \'deduction\'}\" \nng-bind=\"operationTotals[x.$id].normal\"></span> <span \nng-if=\"operationTotals[x.$id].type === \'currency\' && x.type === \'fast\' && x.showTotal\" \nng-class=\"{\'greenC\':x.nature === \'perception\', \'orangeC\':x.nature === \'deduction\'}\" \nng-bind=\"operationTotals[x.$id].fast | currency\"></span> <span \nng-if=\"operationTotals[x.$id].type !== \'currency\' && x.type === \'fast\' && x.showTotal\" \nng-class=\"{\'greenC\':x.nature === \'perception\', \'orangeC\':x.nature === \'deduction\'}\" \nng-bind=\"operationTotals[x.$id].fast\"></span></th></tr></tfoot></table></div>");
$templateCache.put("app/main/clients/views/newoperation/tabs/rejectedIncidences.html","<div flex style=\"overflow: auto\"><table id=\"table_sabana\" class=\"row-border\" ng-if=\"rejectedIncidences.length\"><thead>\n<tr><th class=\"text-left\"><label class=\"pl-10\">Empleado</label></th><th class=\"text-left\"><label class=\"pl-10\">\nIncidencia</label></th><th class=\"text-left\"><label class=\"pl-10\">Monto</label></th></tr></thead><tbody><tr \nng-repeat=\"incidence in rejectedIncidences\"><td class=\"text-left\">{{incidence.employeeName}}</td><td class=\"text-left\">\n{{incidence.name}}</td><td class=\"text-left\">{{incidence.qty}}</td></tr></tbody></table><div table-loader \narray=\"rejectedIncidences\" validations=\"validations.rejected\"></div></div>");
$templateCache.put("app/main/clients/views/newoperation/tabs/socialPrevision.html","<div ng-if=\"operationEmployees.length && firstFinished\" flex style=\"overflow: auto\"><div class=\"paginationSection\">\n<md-table-pagination md-limit=\"myLimitOperation\" md-page=\"myPageOperation\" md-total=\"{{operationEmployees.length}}\" \nmd-limit-options=\"paginationOpe\" md-label=\"{{F.paginationLabel}}\" md-page-select></md-table-pagination></div><table \nng-if=\"operationEmployees.length\" id=\"table_sabana\" class=\"row-border\"><thead><tr><th><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"padding-left-5\" flex=\"nogrow\"><input class=\"checked\" \naria-label=\"select employee\" ng-checked=\"F.allAreSelected(operationEmployees, selected, \'$id\')\" type=\"checkbox\" \nng-click=\"F.toggleAll(operationEmployees, selected, \'$id\')\"></div><span flex=\"nogrow\">NOMBRE</span><div flex \nclass=\"text-right\"><md-button class=\"md-icon-button md-primary\" aria-label=\"Settings\" \nng-click=\"setNextOrder(\'data.name\',order)\"><md-icon md-font-icon=\"icon-filter-variant\" aria-label=\"Order by Date\" \nng-if=\"order!==\'data.name\'&&order!=\'-data.name\'\"></md-icon><md-icon md-font-icon=\"icon-arrow-down\" \naria-label=\"Order Descendent\" ng-if=\"order==\'data.name\'\"></md-icon><md-icon md-font-icon=\"icon-arrow-up\" \naria-label=\"Order Ascendent\" ng-if=\"order==\'-data.name\'\"></md-icon></md-button></div></div></th><th \nng-repeat=\"($index,x) in pro.concepts | orderBy: [\'order\',\'name\'] track by $index\" ng-if=\"!x.hiddenColumn\"><span \nng-if=\"x.conceptType !== \'incidenceType\'\" ng-bind=\"x.name\"></span> <span ng-if=\"x.conceptType === \'incidenceType\'\" \nng-class=\"{\'blueC\': x.nature === \'perception\', \'redC\': x.nature === \'deduction\'}\" ng-bind=\"x.name\"></span></th></tr>\n</thead><tbody><tr ng-hide=\"employee.hide\" \nng-repeat=\"employee in operationEmployees | orderBy: order  | limitTo: myLimitOperation: (myPageOperation - 1) * myLimitOperation track by employee.$id\">\n<td class=\"text-left\"><input class=\"checked\" aria-label=\"select employee\" ng-checked=\"exists(employee, selected)\" \ntype=\"checkbox\" ng-click=\"toggle(employee, selected)\"><label ng-bind=\"employee.data.name\"></label></td><td \nng-repeat=\"($index,x) in pro.concepts | orderBy: [\'order\',\'name\'] track by $index\" ng-if=\"!x.hiddenColumn\"><label \nng-if=\"x.type!=\'fast\' && x.conceptType === \'incidenceType\'\"><span \nng-class=\"{\'blueC\':x.nature === \'perception\', \'redC\':x.nature === \'deduction\'}\" \nng-bind=\"calculations[employee.$id][x.key].socialPrevisionValue.formatted?calculations[employee.$id][x.key].socialPrevisionValue.formatted:(0|currency)\">\n</span></label><label ng-if=\"x.conceptType !== \'incidenceType\'\" \nng-bind=\"calculations[employee.$id][x.key].value.formatted?calculations[employee.$id][x.key].value.formatted:(0|currency)\">\n</label></td></tr></tbody><tfoot><tr class=\"totales\"><th></th><th \nng-repeat=\"($index,x) in pro.concepts | orderBy: [\'order\',\'name\'] track by $index\" ng-if=\"!x.hiddenColumn\"><span \nng-if=\"operationTotals[x.$id].type === \'currency\' && x.conceptType === \'currency\' && x.showTotal\" \nng-bind=\"operationTotals[x.$id].value | currency\"></span> <span \nng-if=\"operationTotals[x.$id].type !== \'currency\' && x.conceptType === \'currency\' && x.showTotal\" \nng-bind=\"operationTotals[x.$id].value\"></span> <span \nng-if=\"operationTotals[x.$id].type === \'currency\' && x.conceptType !== \'incidenceType\' && x.showTotal\" \nng-bind=\"operationTotals[x.$id].value | currency\"></span> <span \nng-if=\"operationTotals[x.$id].type !== \'currency\' && x.conceptType !== \'incidenceType\' && x.showTotal\" \nng-bind=\"operationTotals[x.$id].value\"></span> <span \nng-if=\"operationTotals[x.$id].type === \'currency\' && x.conceptType===\'incidenceType\'\" \nng-class=\"{\'blueC\':x.nature === \'perception\', \'redC\': x.nature === \'deduction\'}\" \nng-bind=\"operationTotals[x.$id].socialPrevisionValue | currency\"></span> <span \nng-if=\"operationTotals[x.$id].type !== \'currency\' && x.conceptType===\'incidenceType\'\" \nng-class=\"{\'blueC\':x.nature === \'perception\', \'redC\': x.nature === \'deduction\'}\" \nng-bind=\"operationTotals[x.$id].socialPrevisionValue\"></span></th></tr></tfoot></table></div>");
$templateCache.put("app/main/clients/views/operation/dialogs/ask-payment-confirmation.html","<md-dialog class=\"customDialog\" id=\"reviewDialog\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 flex>\nPedir Confirmación de Pago</h2><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close Dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div \nclass=\"md-dialog-content\" layout=\"column\"><div flex layout=\"column\"><h3 flex>\nAño {{calendar}} - Periodo {{periodNumber}}</h3><h3 flex>Desde {{period.start | date}} - Hasta {{period.end | date}}\n</h3><div flex layout-gt-sm=\"row\" layout-align=\"space-between center\"><div flex-gt-sm=\"50\" \nclass=\"md-whiteframe-15dp preBill\"><h2>Pre-factura</h2><h3 class=\"orangeC\">\nTotal a Cubrir para Nómina: {{dispersion.preBill.bruteTotal | currency}}</h3><h3>\nTotal Gasto Administrativo: {{dispersion.preBill.feeTotal | currency}}</h3><h3>\nSub-Total: {{dispersion.preBill.subTotal | currency}}</h3><h3>IVA: {{dispersion.preBill.iva | currency}}</h3><h3 \nclass=\"blueC\">Total a Pagar por Cliente: {{dispersion.preBill.total | currency}}</h3></div><div flex-gt-sm=\"40\">\n<md-input-container class=\"md-block\" flex><label>Comentarios previos</label><textarea \nng-model=\"dispersion.data.comments\" aria-label=\"comments for dispersion\" disabled=\"disabled\"></textarea>\n</md-input-container><md-input-container class=\"md-block\" flex><label>Comentarios de la revisión del ejecutivo</label>\n<textarea ng-model=\"operation.reviewed.comments\" aria-label=\"comments for pre-facture\" disabled=\"disabled\"></textarea>\n</md-input-container><md-input-container class=\"md-block\" flex><label>Comentarios para el pago</label><textarea \nng-model=\"operation.authorized.comments\" aria-label=\"comments for pre-facture\" disabled=\"disabled\"></textarea>\n</md-input-container><md-input-container class=\"md-block\" ng-show=\"!operation.payed.referenceFile\" flex><label>\nReferencia</label><input ng-model=\"operation.payed.reference\" type=\"text\" name=\"reference\" aria-label=\"reference\" \nplaceholde=\"Referencia del pago\"></md-input-container></div></div><p flex md-padding md-accent md-hue-3 class=\"help\">\nAl pedir confirmación del pago, usted deberá haber adjuntado una foto legible o documento pdf con el comprobante del pago o haber llenado la entrada de \"REFERENCIA\".\n<br></p></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><a md-button target=\"_blanc\" \nng-href=\"{{operation.payed.referenceFile}}\" with-permission action=\"viewPayment\" access=\"{{F.active.menuItem}}\" \nng-if=\"operation.payed.referenceFile\" aria-label=\"view payment\" class=\"md-raised md-background md-primary md-hue-3\">\n<md-icon md-font-icon=\"icon-eye\" aria-label=\"view payment\"></md-icon><span>Ver Pago</span></a><md-button \nng-disabled=\"!operation.payed.referenceFile && !operation.payed.reference\" with-permission \naction=\"askPaymentConfirmation\" access=\"{{F.active.menuItem}}\" ng-if=\"operation.status == 4\" \nng-click=\"moveOperation(operation, 5);\" aria-label=\"ask payment confirmation\" \nclass=\"md-raised md-background md-primary md-hue-1\"><md-icon md-font-icon=\"icon-briefcase-checked\" \naria-label=\"ask payment\"></md-icon><span>Pedir Autorización del Pago</span></md-button><md-button with-permission \naction=\"uploadPayment\" access=\"{{F.active.menuItem}}\" ng-if=\"operation.status == 4 && !operation.payed.referenceFile\" \nng-click=\"uploadPaymentModal($event)\" aria-label=\"send employees to pre-bill revision\" \nclass=\"md-raised md-background md-accent md-hue-1\"><md-icon md-font-icon=\"icon-send\" aria-label=\"send to revision\">\n</md-icon><span>Subir Comprobante de Pago</span></md-button><md-button ng-if=\"operation.payed.referenceFile\" \nng-click=\"removeUpload(operation)\" class=\"md-raised md-background md-warn md-hue-2\" aria-label=\"Delete\"><span>\nBorrar Comprobante de Pago</span></md-button><md-button ng-click=\"cancel()\" \nclass=\"md-raised md-background md-warn md-hue-1\" aria-label=\"Cancelar\"><span>Cerrar</span></md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/clients/views/operation/dialogs/bottom-calculations.html","<md-bottom-sheet class=\"md-list md-has-header bottomList\"><md-subheader ng-cloak><div layout=\"column\" \nlayout-align-gt-xs=\"start center\" layout-gt-xs=\"row\"><div flex layout=\"row\"><h3 flex class=\"no-margin\">\nCalculos de {{employees[employeeIndex].data.name}} <small>[{{tabName}}]</small></h3></div><div flex=\"nogrow\" \nlayout=\"row\" layout-align=\"end start\"><md-button class=\"md-icon-button\" aria-label=\"previous\" flex=\"nogrow\" \nng-click=\"employeeIndex=employeeIndex-1\" ng-disabled=\"employeeIndex==0\"><md-icon md-font-icon=\"icon-arrow-left\" \naria-label=\"previus employee\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"next\" flex=\"nogrow\" \nng-click=\"employeeIndex=employeeIndex+1\" ng-disabled=\"employeeIndex==employees.length-1\"><md-icon \nmd-font-icon=\"icon-arrow-right\" aria-label=\"next employee\"></md-icon></md-button></div></div></md-subheader><md-content\n layout-fill stop-touch-event><md-table-container><table md-table class=\"row-border\"><thead md-head md-order=\"order\" \nfix-head><tr md-row><th md-column><span>Cálculo</span></th><th md-column><span>Valor</span></th><th md-column><span>\nDatos</span></th></tr></thead><tbody md-body><tr md-row \nng-repeat=\'calculation in employees[employeeIndex].calculations[process]|orderObjectBy:\"value.weight\"\'><td md-cell>\n{{ calculation.value.name|uppercase }}</td><td md-cell><span ng-show=\"calculation.value.type == \'currency\'\">\n{{ calculation.value.total | currency }}</span> <span ng-show=\"calculation.value.type == \'int\'\">\n{{ calculation.value.total }}</span> <span ng-show=\"calculation.value.type == \'float\'\">\n{{ calculation.value.total | number:2 }}</span></td><td md-cell><md-button class=\"md-icon-button\" aria-label=\"view\" \nng-click=\"openCalc($event, calculation)\"><md-icon md-font-icon=\"icon-eye\" aria-label=\"view sub calculations\"></md-icon>\n</md-button></td></tr></tbody></table></md-table-container></md-content></md-bottom-sheet>");
$templateCache.put("app/main/clients/views/operation/dialogs/bottom-incidences.html","<md-bottom-sheet class=\"md-list bottomList noPaddingBotomSheet\"><div class=\"filterToolbar\"><h3>\nIncidencias de {{employee.data.name}}</h3><div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex \nmd-no-float><input id=\"incidences-search\" placeholder=\"Buscar Incidencia\" class=\"uppercased whitePlaceholder\" \nng-model-options=\"{ debounce: F.debounceTime }\" type=\"text\" name=\"searchIncidences\" ng-model=\"incidencesFilter\">\n</md-input-container><md-button \nng-if=\"!readOnlyMode && operation.status<opStatusNotCalc && operation.employees[employee.$id].status<nextEmployeeStatus\" \nclass=\"md-icon-button\" flex=\"nogrow\" aria-label=\"filter data\" ng-click=\"openObject(event,null,\'add\')\"><md-icon \nmd-font-icon=\"icon-plus\" aria-label=\"reload-filters\"></md-icon></md-button><md-button \nng-if=\"!readOnlyMode && operation.status<opStatusNotCalc && operation.employees[employee.$id].status<nextEmployeeStatus\" \nng-disabled=\"!selected.length\" class=\"md-icon-button\" flex=\"nogrow\" aria-label=\"filter data\" \nng-click=\"deleteIncidence($event)\"><md-icon md-font-icon=\"icon-delete\" aria-label=\"delete incidence\"></md-icon>\n</md-button><md-button \nng-if=\"!readOnlyMode && operation.status<opStatusNotCalc && operation.employees[employee.$id].status<nextEmployeeStatus\" \nng-disabled=\"!(selected.length==1)\" class=\"md-icon-button\" flex=\"nogrow\" aria-label=\"filter data\" \nng-click=\"openObject($event,selected[0],\'edit\')\"><md-icon md-font-icon=\"icon-pencil\" aria-label=\"edit incidence\">\n</md-icon></md-button></div></div><md-content layout-fill stop-touch-event><div layout=\"row\" \nlayout-align=\"center center\" ng-show=\"!employeeIncidences.length\"><h3>Sin incidencas</h3></div><md-table-container \nng-show=\"employeeIncidences.length\"><table md-table md-row-select multiple=\"true\" ng-model=\"selected\" \nclass=\"row-border\" ng-init=\'order = \"date\"\'><thead md-head md-order=\"order\"><tr md-row><th md-column \nmd-order-by=\"name\"><span>Incidencia</span></th><th md-column md-order-by=\"date\"><span>Fecha</span></th><th md-column \nmd-numeric md-order-by=\"value\"><span>Valor</span></th><th md-column md-order-by=\"comments\"><span>Comentario</span></th>\n<th md-column md-order-by=\"nature\"><span>Naturaleza</span></th><th md-column md-order-by=\"typeName\"><span>Tipo</span>\n</th></tr></thead><tbody md-body><tr \nng-disabled=\"incidence.type==\'constant\' || incidence.type==\'fast\'|| incidence.type==\'system\'\" md-row md-auto-select \nmd-select=\"incidence\" md-select-id=\"$id\" \nng-repeat=\"incidence in employeeIncidences|orderBy:order|filter:incidencesFilter\"><td md-cell>\n{{incidence.name=(incidence.incidenceType | getSomethingOfArrayFB:F.incidencesTypes:\'name\':false)}}</td><td md-cell>\n{{incidence.date|date:\'mediumDate\'}}</td><td md-cell>{{incidence.value}}</td><td md-cell>{{incidence.comments}}</td><td\n md-cell>{{(\'c.\'+incidence.nature) | translate | capitalize}}</td><td md-cell>\n{{incidence.typeName=(incidence.type | incidenceTypeName)}}</td></tr></tbody></table></md-table-container></md-content>\n</md-bottom-sheet>");
$templateCache.put("app/main/clients/views/operation/dialogs/calculations.html","<md-dialog class=\"customDialog calculationsModal\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 flex>Cálculos de \n<small>{{ calculation.value.name }}</small></h2><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close Dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div \nclass=\"md-dialog-content\" layout=\"column\"><div flex layout=\"column\" ng-if=\"calculation.formulas\"><h3 flex>Fórmulas</h3>\n<div flex ng-repeat=\"formula in calculation.formulas\"><code>{{ formula }}</code></div></div><div flex layout=\"column\" \nng-if=\"calculation.formula\"><h3 flex>Fórmula</h3><div flex><code>{{ calculation.formula }}</code></div></div><div flex \nclass=\"data\" layout=\"column\" ng-if=\"calculation.data\"><h3 flex>Datos</h3><div flex \nng-if=\"[\'totalWithoutFast\',\'totalOnlyFast\'].indexOf(datoName)==-1\" ng-repeat=\"(datoName, dato) in calculation.data\">\n<strong>{{ \'c.\' + datoName | translate }}</strong> = <span ng-if=\"!isArray(dato)\">{{ dato }}</span><div \nng-if=\"isArray(dato) == 1\"><table class=\"simple row-border\"><thead><tr><th><span>Incidencia</span></th><th><span>Valor\n</span></th></tr></thead><tbody><tr ng-repeat=\"incidence in dato\"><td>\n{{ incidence.incidenceType | getSomethingOfArrayFB: F.incidencesTypes:\'name\':false }}</td><td><span>\n{{ incidence.value }}</span></td></tr></tbody></table></div><div ng-if=\'isArray(dato) == \"calculations\"\'><table \nclass=\"simple row-border\"><thead><tr><th><span>Incidencia</span></th><th><span>Valor</span></th></tr></thead><tbody><tr\n ng-repeat=\"incidence in (dato|objsToArray)\"><td>\n{{incidence.$id | getSomethingOfArrayFB: F.incidencesTypes:\'name\':false }}</td><td><span>{{ incidence.value }}</span>\n</td></tr></tbody></table></div><div ng-if=\'isArray(dato) == \"movements\"\'><table class=\"simple row-border\"><thead><tr>\n<th><span>Fecha</span></th><th><span>Tipo</span></th><th><span>Status</span></th></tr></thead><tbody><tr \nng-repeat=\"movement in dato\"><td>{{ (movement.d || movement.data.date) | date }}</td><td>\n{{ (movement.t || movement.data.type) | typeName }}</td><td>{{ (movement.s || movement.status) | movementStatusName }}\n</td></tr></tbody></table></div><div ng-if=\'isArray(dato) == \"days\"\'><table class=\"simple row-border\"><thead><tr><th>\n<span>Inicio</span></th><th><span>Fin</span></th><th><span>Días</span></th></tr></thead><tbody><tr \nng-repeat=\"day in dato\"><td>{{ day.start | date }}</td><td>{{ day.end | date }}</td><td>{{ day.daysWorked }}</td></tr>\n</tbody></table></div><div ng-if=\'isArray(dato) == \"salaries\"\'><table class=\"simple row-border\"><thead><tr><th><span>\nFecha</span></th><th><span>SDR</span></th><th><span>SD</span></th><th><span>SBC</span></th></tr></thead><tbody><tr \nng-repeat=\"salary in dato\"><td>{{ salary.start | date }}</td><td>{{ salary.sdr | currency }}</td><td>\n{{ salary.sd | currency }}</td><td>{{ salary.sbc | currency }}</td></tr></tbody></table></div><div \nng-if=\'isArray(dato) == \"gravable\"\'><table class=\"simple row-border\"><thead><tr><th><span>Regla</span></th><th><span>\nIncidencia</span></th><th><span>Excento</span></th><th><span>Gravado</span></th></tr></thead><tbody><tr \nng-repeat=\"gravable in dato.amounts\"><td>{{ gravable.ruleName }}</td><td>{{ gravable.incidenceName }}</td><td>\n{{ gravable.exempt | currency }}</td><td>{{ gravable.taxed | currency}}</td></tr></tbody></table></div></div></div><hr>\n<div flex class=\"data\"><label><strong class=\"GreenC\">Total = </strong>{{calculation.value.total|currency}}</label><br>\n<label ng-if=\"calculation.value.toOtherProccess\"><strong class=\"blueC\">En otro proceso = </strong>\n{{calculation.value.toOtherProccess|currency}}</label><br><label ng-if=\"calculation.value.rejected\"><strong \nclass=\"redC\">Rechazado = </strong>{{calculation.value.rejected|currency}}</label><br></div></div></md-dialog-content>\n</md-dialog>");
$templateCache.put("app/main/clients/views/operation/dialogs/import-calculations.html","<md-dialog stop-touch-event aria-label=\"Import Calculations\" class=\"importDialog\"><form name=\"stepper\" \nclass=\"importEmployees\" ms-stepper ng-submit=\"importCalculations.applyCalculations(companiesRecord)\" \nng-model=\"stepper\" novalidate><ms-stepper-step ng-form=\"step1\" step=\"1\" step-title=\"\'Sube el archivo\'\"><div \nng-include=\"\'app/main/clients/views/operation/dialogs/step-1.html\'\"></div></ms-stepper-step><ms-stepper-step \nng-form=\"step2\" step=\"2\" step-title=\"\'Conceptos a exportar\'\"><div \nng-include=\"\'app/main/clients/views/operation/dialogs/step-2.html\'\"></div></ms-stepper-step><ms-stepper-step \nclass=\"noAutoH\" ng-form=\"step3\" step=\"3\" step-title=\"\'Verifica y aplica la información\'\"><div \nng-include=\"\'app/main/clients/views/operation/dialogs/step-3.html\'\"></div></ms-stepper-step></form></md-dialog>");
$templateCache.put("app/main/clients/views/operation/dialogs/incidence.html","<md-dialog aria-label=\"modal incidence for employee\"><form name=\"form\" novalidate ng-disabled=\"readOnlyMode\">\n<md-toolbar><div class=\"md-toolbar-tools\"><h2 flex>{{(action==\"edit\")?\'Actualizar\':\'Agregar\'}} incidencia de <small>\n{{employee.data.name}}</small></h2><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close Dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div \nclass=\"md-dialog-content\"><div form-incidence-modal></div></div></md-dialog-content><md-dialog-actions layout=\"row\">\n<md-button ng-if=\'action==\"edit\"\' ng-click=\"saveIncidence(incidence)\" ng-hide=\"form.$pristine\" \nng-disabled=\"form.$invalid || loadingProgress\" class=\"md-raised md-background md-accent md-hue-1\" \naria-label=\"Save incidence\"><md-tooltip md-direction=\"left\">{{\'EC.SAVE\' | translate}}</md-tooltip><md-icon \nmd-font-icon=\"icon-content-save\" aria-label=\"Save\"></md-icon></md-button><md-button ng-if=\'action==\"add\"\' \nng-click=\"addIncidence(incidence)\" ng-hide=\"form.$pristine\" ng-disabled=\"form.$invalid || loadingProgress\" \nclass=\"md-raised md-background md-accent md-hue-1\" aria-label=\"Add incidence\"><md-tooltip md-direction=\"left\">\n{{\'EC.ADD\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-label=\"add\"></md-icon></md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/clients/views/operation/dialogs/review.html","<md-dialog class=\"customDialog\" id=\"reviewDialog\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 flex>\nRevisión de Operación</h2><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close Dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\" \nlayout=\"column\"><div flex layout=\"column\"><h3 flex>Año {{calendar}} - Periodo {{periodNumber}}</h3><h3 flex>\nDesde {{period.start | date}} - Hasta {{period.end | date}}</h3><md-subheader class=\"md-no-sticky\">\n{{countObj(dispersion.employees)}} empleado(s) de {{employeesF.length}}</md-subheader><md-table-container><table \nmd-table class=\"row-border\"><thead md-head><tr md-row><th md-column><span>Empleado</span></th><th md-column><span>\nSueldo Total</span></th><th md-column><span>Gasto Administrativo</span></th><th md-column><span>Total</span></th></tr>\n</thead><tbody md-body><tr md-row \nng-repeat=\"employee in employeesF | onlyDispersionEmployees:dispersion:hideNotSelected\"><td md-cell>\n{{ employee.data.name }}</td><td md-cell>{{ dispersion.employees[employee.$id].totals.toBill.brute | currency }}</td>\n<td md-cell>{{ dispersion.employees[employee.$id].totals.toBill.fee | currency }}</td><td md-cell>\n{{ dispersion.employees[employee.$id].totals.toBill.net | currency }}</td></tr><tr md-row \nng-repeat=\"employee in employeesF | onlyDispersionEmployees:dispersion:hideNotSelected:1\"><td md-cell colspan=\"4\"><span\n class=\"redC\">{{ employee.data.name }}</span></td></tr></tbody></table></md-table-container><div flex \nlayout-gt-sm=\"row\" layout-align=\"space-between center\"><div flex-gt-sm=\"50\" class=\"md-whiteframe-15dp preBill\"><h2>\nPre-factura</h2><h3 class=\"orangeC\">Total a Cubrir para Nómina: {{dispersion.preBill.bruteTotal | currency}}</h3><h3>\nTotal Gasto Administrativo: {{dispersion.preBill.feeTotal | currency}}</h3><h3>\nSub-Total: {{dispersion.preBill.subTotal | currency}}</h3><h3>IVA: {{dispersion.preBill.iva | currency}}</h3><h3 \nclass=\"blueC\">Total a Pagar por Cliente: {{dispersion.preBill.total | currency}}</h3></div><div flex-gt-sm=\"40\">\n<md-input-container class=\"md-block\" flex><label>Comentarios del cliente</label><textarea \nng-model=\"dispersion.data.comments\" aria-label=\"comments for dispersion\" disabled=\"disabled\"></textarea>\n</md-input-container><md-input-container class=\"md-block\" flex><label>Comentarios de la revisión para el cliente\n</label><textarea ng-model=\"operation.reviewed.comments\" aria-label=\"comments for pre-facture\"></textarea>\n</md-input-container></div></div><p flex md-padding md-accent md-hue-3 class=\"help\">\nRevisión de operaciones, incidencias y pre-factura. Al mandarle al cliente la pre-factura el cliente solo necesita confirmarla para iniciar el proceso de pago. Al subir un comprobante de pago, se podrá dispersar la operación.\n<br><small><strong>Los empleados en rojo no se fueron registrados por el cliente para ésta operación.</strong></small>\n</p></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button with-permission action=\"cancel\" \naccess=\"{{F.active.menuItem}}\" ng-if=\"operation.status == 2\" \nng-click=\"moveBackOperation(operation, 1, operation.reviewed.comments,false,true,0,0,0);cancel();\" \naria-label=\"send employeesrevision\" class=\"md-raised md-background md-warn md-hue-2\"><md-icon \nmd-font-icon=\"icon-arrow-left\" aria-label=\"not aprove\"></md-icon><span>Cancelar</span></md-button><md-button \nwith-permission action=\"sendPreBill\" access=\"{{F.active.menuItem}}\" ng-if=\"operation.status == 2\" \nng-click=\"moveOperation(operation, 3);cancel();\" aria-label=\"send employees to pre-bill revision\" \nclass=\"md-raised md-background md-accent md-hue-1\"><md-icon md-font-icon=\"icon-send\" aria-label=\"send to revision\">\n</md-icon><span>Mandar Prefactura</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/clients/views/operation/dialogs/send-to-review.html","<md-dialog class=\"customDialog\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 flex>Mandar a revisión</h2><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close Dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\" layout=\"column\"><div flex \nlayout=\"column\"><h3 flex>Año {{calendar}} - Periodo {{periodNumber}}</h3><h3 flex>\nDesde {{period.start | date}} - Hasta {{period.end | date}}</h3><p flex md-padding md-accent md-hue-3 class=\"help\">\nSe mandarán las incidencias a Revisión de un ejecutivo, el cual le mandará el correo con la prefactura y podrá entonces registrar su pago para continuar con el proceso de dispersión.\n<br></p><div flex layout-gt-sm=\"row\"><div flex><md-input-container class=\"md-block\" flex><label>Comentarios</label>\n<textarea ng-model=\"comments\" aria-label=\"comments for dispersion\"></textarea></md-input-container></div></div></div>\n</div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button with-permission action=\"sendToReview\" \naccess=\"{{F.active.menuItem}}\" ng-if=\"employeesF.length && (operation.status == 1||operation.status == 2)\" \nng-click=\"sendToReview(operation, employeesF, comments);cancel();\" aria-label=\"send employees to revision\" \nclass=\"md-raised md-background md-primary md-hue-1\"><md-icon md-font-icon=\"icon-send\" aria-label=\"send to revision\">\n</md-icon><span>Mandar</span></md-button><md-button ng-click=\"cancel()\" \nclass=\"md-raised md-background md-warn md-hue-1\" aria-label=\"Cancelar\"><span>Cancelar</span></md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/clients/views/operation/dialogs/step-1.html","<div class=\"md-inline-form\"><div flex><div ng-if=\"importCalculations.loading\"><md-progress-linear \nmd-mode=\"indeterminate\"></md-progress-linear><span class=\"md-subhead\">Cargando..</span></div><md-input-container \nclass=\"md-block evenPadding\" flex><label>Empresa</label><md-select ng-model=\"importCalculations.companiesRecord\" \nname=\"companiesRecord\" required><md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" \nng-keydown=\"$event.stopPropagation()\" ng-model=\"companiesRecordSelectFilter\" placeholder=\"Busque una empresa\">\n</md-select-header><md-option ng-value=\"companiesRecord.$id\" \nng-repeat=\"companiesRecord in L.companiesRecords | orderBy:\'class\' | filter:companiesRecordSelectFilter\">\n{{companiesRecord.name}}</md-option></md-select><div ng-messages=\"step1.companiesRecord.$error\" role=\"alert\"><div \nng-message=\"required\">Empresa es requerido</div></div></md-input-container><md-input-container \nclass=\"md-block evenPadding\" flex md-no-float><md-select ng-model=\"importCalculations.operationType\" \nplaceholder=\"Tipo de operación\" name=\"operationType\"><md-option ng-value=\"undefined\">Ordinaria</md-option><md-option \nng-value=\"thisOperationType.id\" ng-repeat=\"thisOperationType in F.operationTypes\">{{thisOperationType.name}}\n</md-option></md-select><div ng-messages=\"step1.operationType.$error\" role=\"alert\"><div ng-message=\"required\">\nTipo de operación</div></div></md-input-container><div><lf-ng-md-file-input lf-files=\"importCalculations.filesArray\" \nlf-placeholder=\"Selecciona el archivo csv\" lf-drag-and-drop-label=\"csv - Max: 10MB\" \nlf-browse-label=\"{{\'EC.search\' | translate}}\" lf-remove-label=\"{{\'EC.remove\' | translate}}\" lf-filesize=\"10MB\" \nlf-required lf-mimetype=\"text/csv\" accept=\"text/csv\" name=\"operationFile\" lf-api=\"csvApi\"></lf-ng-md-file-input><div \nng-messages=\"step1.operationFile.$error\" style=\"color:red\"><div ng-message=\"required\">Archivo requerido</div><div \nng-message=\"maxcount\">Demasiados archivos</div><div ng-message=\"filesize\">Archivo demasiado grande</div><div \nng-message=\"totalsize\">Espacio total demasiado grande</div><div ng-message=\"mimetype\">Formato de archivo no valido\n</div></div></div><div flex=\"no-grow\" layout=\"row\"><span flex></span> <a class=\"downloadLink\" target=\"_blanc\" \nhref=\"assets/csv/import-calculations-blanc.csv\">descargar template<md-icon md-font-icon=\"icon-file-excel\" \naria-label=\"download variables template\"></md-icon></a></div></div><code flex ng-if=\"!operationFile\">\nCampos necesarios: Numero de Empleado, Fecha, Nomina, Conceptos.....</code></div>");
$templateCache.put("app/main/clients/views/operation/dialogs/step-2.html","<div><div ng-if=\"importCalculations.loading\"><md-progress-linear md-mode=\"indeterminate\"></md-progress-linear><span \nclass=\"md-subhead\">Cargando..</span></div><div style=\"max-height: 550px;overflow: auto\"><table \nclass=\"simple passiveTouch\"><thead class=\"stickyHeader\"><tr><th><h3>Campo</h3></th><th><h3>Concepto</h3></th><th><h3>\nCampo</h3></th></tr></thead><tbody><tr ng-if=\"head.editable\" ng-repeat=\"($index,head) in importCalculations.headers\">\n<td ng-bind=\"head.rowName\"></td><td><md-input-container class=\"md-block\" md-no-float><md-select \nng-model-options=\"{trackBy: \'$value.key\'}\" ng-model=\"head.key\" required name=\"concept{{$index}}\" \nplaceholder=\"Concepto\"><md-select-header><input ng-model=\"searchConcept\" aria-label=\"search concept\" \nng-keydown=\"$event.stopPropagation()\" type=\"search\"></md-select-header><md-option ng-value=\"concept.key\" \nng-repeat=\"concept in importCalculations.allConcepts | filter : searchConcept\">{{ concept.name }}</md-option>\n</md-select><div ng-messages=\'step2[\"concept\"+$index].$error\' role=\"alert\"><div ng-message=\"required\">\nCampo es requerido</div></div></md-input-container></td><td><md-input-container class=\"md-block\" md-no-float><md-select\n ng-model-options=\"{trackBy: \'$value.key\'}\" ng-model=\"head.field\" required name=\"field{{$index}}\" placeholder=\"Campo\">\n<md-select-header><input ng-model=\"searchField\" aria-label=\"search field\" ng-keydown=\"$event.stopPropagation()\" \ntype=\"search\"></md-select-header><md-option ng-value=\"field.id\" \nng-repeat=\"field in importCalculations.allConceptsByKey[head.key].fields | filter : searchField\">{{ field.name }}\n</md-option></md-select><div ng-messages=\'step2[\"field\"+$index].$error\' role=\"alert\"><div ng-message=\"required\">\nCampo es requerido</div></div></md-input-container></td></tr></tbody></table></div></div>");
$templateCache.put("app/main/clients/views/operation/dialogs/step-3.html","<div><div ng-if=\"loading\"><md-progress-linear md-mode=\"indeterminate\"></md-progress-linear><span class=\"md-subhead\">\nCargando..</span></div><div style=\"max-height: 500px;overflow: auto\"><table class=\"simple employeeCalculationsTable\">\n<thead class=\"stickyHeader\"><tr><th class=\"stickyColumn\"><div layout=\"row\"><div flex=\"nogrow\"><md-button \nclass=\"md-fab md-icon-button md-mini md-primary no-margin no-padding\" aria-label=\"search button\" disabled=\"true\" \ntype=\"submit\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button></div><input flex type=\"text\" \nplaceholder=\"Buscar Empleado\" ng-model-options=\"{ debounce: F.debounceTime }\" ng-model=\"importSearch\"></div></th><th>\nNómina</th><th>Fecha</th><th ng-if=\'[\"Empleado\",\"Fecha\",\"Nomina\"].indexOf(head.rowName) === -1\' \nng-repeat=\"head in importCalculations.headers\">{{head.rowName}}<br><small>\n{{head.editable?head.key+\' - \'+ head.field:\'\'}}</small></th></tr></thead><tbody><tr \nng-repeat=\"record in importCalculations.data | filter : importSearch | orderBy : [\'-errors\',\'recordNumber\']\"><td \nclass=\"text-bold text-left nobreak stickyColumn\"><md-button ng-if=\"record.errors.length>0\" aria-label=\"Upload File\" \nclass=\"md-icon-button md-warn md-hue-2 no-margin no-padding nospacebutton\"><md-icon md-font-icon=\"icon-sim-alert\" \naria-label=\"Upload\"></md-icon><md-tooltip md-direction=\"right\"><label ng-repeat=\"error in record.errors\">{{error}},\n</label></md-tooltip></md-button><md-button ng-if=\"!record.errors.length && !record.applied\" aria-label=\"Upload File\" \nclass=\"md-icon-button md-primary no-margin no-padding nospacebutton\"><md-icon md-font-icon=\"icon-checkbox-marked\" \naria-label=\"Upload\"></md-icon><md-tooltip md-direction=\"right\">Sin problemas</md-tooltip></md-button><md-button \nng-if=\"record.applied\" aria-label=\"Upload File\" \nclass=\"md-icon-button md-primary md-hue-2 no-margin no-padding nospacebutton\"><md-icon md-font-icon=\" icon-check-all\" \naria-label=\"Upload\"></md-icon><md-tooltip md-direction=\"right\">Aplicado</md-tooltip></md-button>\n{{record.employee.data.name || \"No encontrado\"}}({{record.recordNumber}})</td><td style=\"text-align: center\">\n{{record.Nomina}}</td><td style=\"text-align: center\">{{record.FechaM.format(\'DD-MM-YYYY\')}}</td><td \nng-repeat=\"head in importCalculations.headers\" ng-if=\'[\"Empleado\",\"Fecha\",\"Nomina\"].indexOf(head.rowName) === -1\' \nstyle=\"text-align: center\">{{record[head.rowName] || 0}}</td></tr></tbody></table></div></div>");
$templateCache.put("app/main/clients/views/operation/dialogs/upload-payment.html","<md-dialog class=\"customDialog\" id=\"reviewDialog\"><form name=\"fileForm\" novalidate flex layout=\"column\"><md-toolbar>\n<div class=\"md-toolbar-tools\"><h2 flex>Subir Comprobante de Pago</h2><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close Dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div class=\"md-dialog-content\" layout=\"column\"><div flex layout=\"column\"><h3 flex>\nAño {{calendar}} - Periodo {{periodNumber}}</h3><h3 flex>Desde {{period.start | date}} - Hasta {{period.end | date}}\n</h3><div flex layout-gt-sm=\"row\" layout-align=\"space-between center\"><div flex-gt-sm=\"50\" \nclass=\"md-whiteframe-15dp preBill\"><h2>Pre-factura</h2><h3 class=\"orangeC\">\nTotal a Cubrir para Nómina: {{dispersion.preBill.bruteTotal | currency}}</h3><h3>\nTotal Gasto Administrativo: {{dispersion.preBill.feeTotal | currency}}</h3><h3>\nSub-Total: {{dispersion.preBill.subTotal | currency}}</h3><h3>IVA: {{dispersion.preBill.iva | currency}}</h3><h3 \nclass=\"blueC\">Total a Pagar por Cliente: {{dispersion.preBill.total | currency}}</h3></div><div flex-gt-sm=\"40\"><div \nclass=\"upload-button\" layout=\"column\" layout-align=\"center center\"><h3 ng-hide=\"operation.payed.referenceFile\" \nclass=\"secondary-text\">PNG, JPG, PDF</h3><lf-ng-md-file-input ng-show=\"!operation.payed.referenceFile\" \nlf-files=\"files\" required lf-placeholder=\"Imagen o PDF\" lf-drag-and-drop-label=\"{{\'EC.DROP_TO_UPLOAD\' | translate}}\" \nlf-browse-label=\"{{\'EC.SEARCH\' | translate}}\" lf-remove-label=\"{{\'EC.REMOVE\' | translate}}\" name=\"payment\" \nlf-api=\"filesApi\" progress preview drag></lf-ng-md-file-input><div ng-messages=\"filesForm.payment.$error\" \nstyle=\"color:red\"><div ng-message=\"required\">This is required.</div><div ng-message=\"maxcount\">Too many files.</div>\n<div ng-message=\"filesize\">File size too large.</div><div ng-message=\"totalsize\">Total size too large.</div><div \nng-message=\"mimetype\">Mimetype error.</div></div></div></div></div><p flex md-padding md-accent md-hue-3 class=\"help\">\nFavor de adjuntar una foto legible o documento pdf con el comprobante del pago o haber llenado la entrada de \"REFERENCIA\". Éste paso le permitirá pedir la confirmación del pago y así proseguir con la dispersión.\n<br></p></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-disabled=\"!files.length\" \nwith-permission action=\"uploadPayment\" access=\"{{F.active.menuItem}}\" \nng-if=\"operation.status == 4 && !operation.payed.referenceFile\" ng-click=\"upload(files, operation);\" \naria-label=\"upload payment confirmation\" class=\"md-raised md-background md-primary md-hue-2\"><md-icon \nmd-font-icon=\"icon-briefcase-checked\" aria-label=\"ask payment\"></md-icon><span>Subir Archivo del Pago</span>\n</md-button><a md-button target=\"_blanc\" ng-href=\"{{operation.payed.referenceFile}}\" with-permission \naction=\"viewPayment\" access=\"{{F.active.menuItem}}\" ng-if=\"operation.payed.referenceFile\" aria-label=\"view payment\" \nclass=\"md-raised md-background md-primary md-hue-3\"><md-icon md-font-icon=\"icon-eye\" aria-label=\"view payment\">\n</md-icon><span>Ver Pago</span></a><md-button \nng-disabled=\"!operation.payed.referenceFile && !operation.payed.reference\" with-permission \naction=\"askPaymentConfirmation\" access=\"{{F.active.menuItem}}\" ng-if=\"operation.status == 4\" \nng-click=\"moveOperation(operation, 5);\" aria-label=\"ask payment confirmation\" \nclass=\"md-raised md-background md-primary md-hue-1\"><md-icon md-font-icon=\"icon-briefcase-checked\" \naria-label=\"ask payment\"></md-icon><span>Pedir Autorización del Pago</span></md-button><md-button \nng-if=\"operation.payed.referenceFile\" ng-click=\"removeUpload(operation)\" \nclass=\"md-raised md-background md-warn md-hue-2\" aria-label=\"Delete\"><span>Borrar Comprobante de Pago</span>\n</md-button><md-button ng-click=\"cancel()\" class=\"md-raised md-background md-warn md-hue-1\" aria-label=\"Cancelar\">\n<span>Cerrar</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/clients/views/operation/dialogs/view-payment.html","<md-dialog class=\"customDialog\" id=\"reviewDialog\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 flex>\nVer Comprobante de Pago</h2><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close Dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\" \nlayout=\"column\"><div flex layout=\"column\"><h3 flex>Año {{calendar}} - Periodo {{periodNumber}}</h3><h3 flex>\nDesde {{period.start | date}} - Hasta {{period.end | date}}</h3><div flex layout-gt-sm=\"row\" \nlayout-align=\"space-between center\"><div flex-gt-sm=\"50\" class=\"md-whiteframe-15dp preBill\"><h2>Pre-factura</h2><h3 \nclass=\"orangeC\">Total a Cubrir para Nómina: {{dispersion.preBill.bruteTotal | currency}}</h3><h3>\nTotal Gasto Administrativo: {{dispersion.preBill.feeTotal | currency}}</h3><h3>\nSub-Total: {{dispersion.preBill.subTotal | currency}}</h3><h3>IVA: {{dispersion.preBill.iva | currency}}</h3><h3 \nclass=\"blueC\">Total a Pagar por Cliente: {{dispersion.preBill.total | currency}}</h3></div><div flex-gt-sm=\"40\">\n<md-input-container class=\"md-block\" flex><label>Comentarios previos</label><textarea \nng-model=\"dispersion.data.comments\" aria-label=\"comments for dispersion\" disabled=\"disabled\"></textarea>\n</md-input-container><md-input-container class=\"md-block\" flex><label>Comentarios de la revisión del ejecutivo</label>\n<textarea ng-model=\"operation.reviewed.comments\" aria-label=\"comments for pre-facture\" disabled=\"disabled\"></textarea>\n</md-input-container><md-input-container class=\"md-block\" flex><label>Comentarios para el pago</label><textarea \nng-model=\"operation.authorized.comments\" aria-label=\"comments for pre-facture\"></textarea></md-input-container>\n<md-input-container class=\"md-block\" ng-show=\"!operation.payed.referenceFile\" flex><label>Referencia</label><input \nng-model=\"operation.payed.reference\" type=\"text\" name=\"reference\" aria-label=\"reference\" \nplaceholde=\"Referencia del pago\" disabled=\"disabled\"></md-input-container></div></div><p flex md-padding md-accent \nmd-hue-3 class=\"help\">Al confirmar el pago se podrá iniciar el proceso de dispersión.<br></p></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><a md-button target=\"_blanc\" \nng-href=\"{{operation.payed.referenceFile}}\" with-permission action=\"viewPayment\" access=\"{{F.active.menuItem}}\" \nng-if=\"operation.payed.referenceFile\" aria-label=\"view payment\" class=\"md-raised md-background md-primary md-hue-3\">\n<md-icon md-font-icon=\"icon-eye\" aria-label=\"view payment\"></md-icon><span>Ver Archivo de Pago</span></a><md-button \nwith-permission action=\"askPaymentConfirmation\" access=\"{{F.active.menuItem}}\" ng-if=\"operation.status == 5\" \nng-click=\"moveOperation(operation, 6);cancel();\" aria-label=\"payment confirmation\" \nclass=\"md-raised md-background md-primary md-hue-2\"><md-icon md-font-icon=\"icon-spellcheck\" \naria-label=\"confirm payment\"></md-icon><span>Confirmar Pago</span></md-button><md-button ng-click=\"cancel()\" \nclass=\"md-raised md-background md-warn md-hue-1\" aria-label=\"Cancelar\"><span>Cerrar</span></md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/clients/views/operation/dialogs/view-prebill.html","<md-dialog class=\"customDialog\" id=\"reviewDialog\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 flex>\nRevisión y Autorización de Pre-Factura</h2><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close Dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div \nclass=\"md-dialog-content\" layout=\"column\"><div flex layout=\"column\"><h3 flex>\nAño {{calendar}} - Periodo {{periodNumber}}</h3><h3 flex>Desde {{period.start | date}} - Hasta {{period.end | date}}\n</h3><md-subheader class=\"md-no-sticky\">{{countObj(dispersion.employees)}} empleado(s) de {{employeesF.length}}\n</md-subheader><md-table-container><table md-table class=\"row-border\"><thead md-head><tr md-row><th md-column><span>\nEmpleado</span></th><th md-column><span>Sueldo Total</span></th><th md-column><span>Gasto Administrativo</span></th><th\n md-column><span>Total</span></th></tr></thead><tbody md-body><tr md-row \nng-repeat=\"employee in employeesF | onlyDispersionEmployees:dispersion:hideNotSelected\"><td md-cell>\n{{ employee.data.name }}</td><td md-cell>{{ dispersion.employees[employee.$id].totals.toBill.brute | currency }}</td>\n<td md-cell>{{ dispersion.employees[employee.$id].totals.toBill.fee | currency }}</td><td md-cell>\n{{ dispersion.employees[employee.$id].totals.toBill.net | currency }}</td></tr><tr md-row \nng-repeat=\"employee in employeesF | onlyDispersionEmployees:dispersion:hideNotSelected:1\"><td md-cell colspan=\"4\"><span\n class=\"redC\">{{ employee.data.name }}</span></td></tr></tbody></table></md-table-container><div flex \nlayout-gt-sm=\"row\" layout-align=\"space-between center\"><div flex-gt-sm=\"50\" class=\"md-whiteframe-15dp preBill\"><h2>\nPre-factura</h2><h3 class=\"orangeC\">Total a Cubrir para Nómina: {{dispersion.preBill.bruteTotal | currency}}</h3><h3>\nTotal Gasto Administrativo: {{dispersion.preBill.feeTotal | currency}}</h3><h3>\nSub-Total: {{dispersion.preBill.subTotal | currency}}</h3><h3>IVA: {{dispersion.preBill.iva | currency}}</h3><h3 \nclass=\"blueC\">Total a Pagar por Cliente: {{dispersion.preBill.total | currency}}</h3></div><div flex-gt-sm=\"40\">\n<md-input-container class=\"md-block\" flex><label>Comentarios previos</label><textarea \nng-model=\"dispersion.data.comments\" aria-label=\"comments for dispersion\" disabled=\"disabled\"></textarea>\n</md-input-container><md-input-container class=\"md-block\" flex><label>Comentarios de la revisión del ejecutivo</label>\n<textarea ng-model=\"operation.reviewed.comments\" aria-label=\"comments for pre-facture\" disabled=\"disabled\"></textarea>\n</md-input-container></div></div><p flex md-padding md-accent md-hue-3 class=\"help\">\nAl confirmar la pre-factura inicia el proceso de pago. Deberá hacer el depósito o transferencia del monto total antes de la fecha límite.\n<br>Fecha límite de tu pago: {{period.end|getOperationDates|date:\'mediumDate\'}}<br><small><strong>\nLos empleados en rojo no se fueron registrados por el cliente para ésta operación.</strong></small></p></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button with-permission action=\"authorizePreBill\" \naccess=\"{{F.active.menuItem}}\" ng-if=\"operation.status == 3\" ng-click=\"authorizePreBill(operation, comments);\" \naria-label=\"approve dispersion\" class=\"md-raised md-background md-primary md-hue-1\"><md-icon \nmd-font-icon=\"icon-check-all\" aria-label=\"authorize pre-bill\"></md-icon><span>Autorizar Pre-Factura</span></md-button>\n<md-button with-permission action=\"uploadPayment\" access=\"{{F.active.menuItem}}\" ng-if=\"operation.status == 4\" \nng-click=\"uploadPaymentModal($event)\" aria-label=\"send employees to pre-bill revision\" \nclass=\"md-raised md-background md-accent md-hue-1\"><md-icon md-font-icon=\"icon-send\" aria-label=\"send to revision\">\n</md-icon><span>Subir Comprobante de Pago</span></md-button><md-button ng-click=\"cancel()\" \nclass=\"md-raised md-background md-warn md-hue-1\" aria-label=\"Cancelar\"><span>Cerrar</span></md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/clients/views/operation/tabs/complement-extraordinary.html","<md-tab-body layout=\"column\"><div class=\"filterToolbar md-padding\"><div layout=\"row\" \nlayout-align=\"space-between center\"><md-input-container class=\"md-block\" flex md-no-float><label>Filtrar Empleado\n</label><input class=\"search-input\" type=\"text\" flex ng-model=\"search.employee\"></md-input-container><md-menu \nng-if=\"!readOnlyMode\"><md-button class=\"md-icon-button\" aria-label=\"show-hide columns\" \nng-click=\"openMenu($mdOpenMenu, $event)\"><md-tooltip md-direction=\"left\">Ocultar o Mostrar Columnas</md-tooltip>\n<md-icon md-font-icon=\"icon-eye\" aria-label=\"columns\"></md-icon></md-button><md-menu-content width=\"4\"><md-menu-item \nng-repeat=\"column in F.columns[complementName]\"><md-button ng-click=\"toggleColumn($event, column)\"><div layout=\"row\" \nflex><p flex>{{column.name}}</p><md-icon class=\"md-hue-2\" ng-class=\'{\"md-primary\":column.show}\' \nmd-font-icon=\"icon-eye\" aria-label=\"column\"></md-icon></div></md-button></md-menu-item></md-menu-content></md-menu>\n</div></div><div table-loader array=\"employeesF\" validations=\"validations\"></div><md-table-container \nng-show=\"employeesF.length\" flex class=\"max-height-data-table\"><table md-table md-row-select=\"!hideNotSelected\" \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\"><thead md-head md-order=\"order\" fix-head><tr md-row><th \ncolspan=\"{{hideNotSelected ? 1 : 2}}\" class=\"centered\">Empleado</th><th \ncolspan=\"{{F.columns[complementName] | shownColumns | countObject}}\" class=\"centered\">Complemento</th><th colspan=\"1\" \nclass=\"centered\">Totales</th></tr><tr md-row><th md-column md-order-by=\"data.name\"><span>Nombre</span></th><th \nmd-column md-order-by=\"calculations[complementName].limit.value.total\" ng-show=\"F.columns[complementName].limit.show\">\n<span>Límite</span></th><th md-column md-order-by=\"calculations[complementName].gravableBase.value.total\" \nng-show=\"F.columns[complementName].gravableBase.show\"><span>Base Gravable</span></th><th md-column \nmd-order-by=\"calculations[complementName][incidenceId].value.total\" \nng-show=\"F.columns[complementName][incidenceId].show\" \nng-repeat=\"(incidenceId, incidenceByType) in complementIncidences[complementName]\"><span>\n{{\'o.\' + incidenceId | translate | capitalize}}</span></th><th md-column \nmd-order-by=\"calculations[complementName].isr.value.total\"><span>ISR</span></th><th md-column \nmd-order-by=\"calculations[complementName].netComplement.value.total\"><span>Neto</span></th></tr></thead><tbody md-body>\n<tr md-row md-select=\"employee\" md-select-id=\"$id\" \nng-repeat=\"employee in employeesF | onlyDispersionEmployees:dispersion:hideNotSelected | filter:search.employee | orderBy:order\">\n<td md-cell>{{employee.data.name}}</td><td md-cell ng-show=\"F.columns[complementName].limit.show\"><span sheet-limit \npayment-schema=\"paymentSchema\" complement=\"complementName\" ng-model=\"employee.calculations[complementName].limit\">\n{{employee.calculations[complementName].limit.value.total | currency}}</span></td><td md-cell \nng-show=\"F.columns[complementName].gravableBase.show\"><span sheet-gravable-base-complement \nreal-net=\"employee.calculations.REAL.netRealSalary.value.total\" \nfiscal-net=\"employee.calculations.FISCAL.netSalary.value.total\" \ncomplement-limit=\"employee.calculations[complementName].limit.value.total\" \nfiscal-limit=\"employee.calculations.FISCAL.limit.value.total\" \nasimilated-total=\"employee.calculations[tbName].asimilated.value.total\" \nsocial-prevision-total=\"employee.calculations[tbName].socialPrevision.value.total\" \nng-model=\"employee.calculations[complementName].gravableBase\">\n{{employee.calculations[complementName].gravableBase.value.total | currency}}</span></td><td md-cell \nng-show=\"F.columns[complementName][incidenceId].show\" \nng-repeat=\"(incidenceId, incidenceByType) in complementIncidences[complementName]\"><span sheet-asimilated \nng-if=\'incidenceId == \"asimilated\"\' gravable-base=\"employee.calculations[complementName].gravableBase.value.total\" \nng-model=\"employee.calculations[complementName].asimilated\">\n{{employee.calculations[complementName].asimilated.value.total | currency}} </span><span sheet-social-prevision \nng-if=\'incidenceId == \"socialPrevision\"\' \ngravable-base=\"employee.calculations[complementName].gravableBase.value.total\" \nreal-net=\"employee.calculations.REAL.netRealSalary.value.total\" \nfiscal-net=\"employee.calculations.FISCAL.netSalary.value.total\" \nng-model=\"employee.calculations[complementName].socialPrevision\">\n{{employee.calculations[complementName].socialPrevision.value.total | currency}}</span></td><td md-cell \nng-show=\"F.columns[complementName].isr.show\"><span sheet-complement-isr \ngravable-base=\"employee.calculations[complementName].gravableBase.value.total\" \nng-model=\"employee.calculations[complementName].isr\">\n{{employee.calculations[complementName].isr.value.total | currency}}</span></td><td md-cell><span \nsheet-total-complement gravable-base=\"employee.calculations[complementName].gravableBase.value.total\" \ncomplement-isr=\"employee.calculations[complementName].isr.value.total\" \ncomplement-limit=\"employee.calculations[complementName].limit.value.total\" \nng-model=\"employee.calculations[complementName].netComplement\">\n{{employee.calculations[complementName].netComplement.value.total}}</span></td></tr></tbody></table>\n</md-table-container></md-tab-body>");
$templateCache.put("app/main/clients/views/operation/tabs/complement-ordinary.html","<md-tab-body id=\"table_sabana\" layout=\"column\" flex><div class=\"filterToolbar no-paddingTB\" flex=\"nogrow\"><div \nlayout=\"row\" layout-align=\"space-between center\"><md-input-container class=\"md-block\" flex md-no-float><input \nclass=\"search-input whitePlaceholder\" placeholder=\"Filtrar Empleado\" type=\"text\" flex ng-model=\"search.employee\">\n</md-input-container><md-input-container ng-if=\"operationCcs.length>1\" class=\"md-block\" flex=\"nogrow\" md-no-float>\n<md-select ng-model=\"search.cc\" placeholder=\"Centro de costo\"><md-option value=\"\"><em>Todos</em></md-option><md-option \nng-repeat=\"cc in operationCcs\" ng-value=\"cc.$id\">{{cc.data.name}}</md-option></md-select></md-input-container></div>\n</div><div table-loader array=\"employeesF\" validations=\"validations\"></div><div \nclass=\"operationTableContainer max-height-data-table\" ng-show=\"employeesF.length\" flex><table \nclass=\"row-border paddingTable\"><thead><tr><th class=\"text-left\"><span>Nombre</span></th><th><span>{{process.name}}\n</span></th><th ng-if=\"!F.complementIncidenceTypeData[incidenceId].forSalary\" \nng-repeat=\'(incidenceId, incidenceByType) in complementProccess[\"fixIncidences\" + process.type + \"P\"]\'><span \nclass=\"greenC\">{{incidenceId | getComplementData:\"name\":incidenceId}}</span></th><th><span>Total Percepciones</span>\n</th><th ng-if=\"!F.complementIncidenceTypeData[incidenceId].forSalary\" \nng-repeat=\'(incidenceId, incidenceByType) in complementProccess[\"fixIncidences\" + process.type + \"D\"]\'><span \nclass=\"redC\">{{incidenceId | getComplementData:\"name\":incidenceId}}</span></th><th><span>Total Deducciones</span></th>\n<th><span>Sueldo Neto</span></th></tr></thead><tbody><tr ng-hide=\"employee.hide\" \nng-repeat=\"employee in realEmployees |  filterHide:search.employee:search.cc\"><td class=\"text-left employeeName\"><input\n ng-if=\"readyToBalance\" aria-label=\"select employee\" ng-checked=\"exists(employee, selected)\" type=\"checkbox\" \nng-click=\"toggle(employee, selected)\"> <span ng-bind=\"employee.data.name\"></span></td><td><span \nng-if=\'process.type == \"socialPrevision\"\' sheet-social-prevision \ntotal-salary=\"employee.calculations.REAL.salary.value.total\" \nfiscal-salary=\"fiscalEmployees[F.fiscalEmployeesIds[employee.$id]].calculations.FISCAL[fiscalSalaryIncidence.$id].value.total\" \nreturned-concepts=\"fiscalEmployees[F.fiscalEmployeesIds[employee.$id]].calculations.FISCAL\" \ncalculations-results=\"F.fixIncidences[process.type][complementSalaryIncidence[process.type]._id][employee.$id]\" \nemployee-id=\"employee.$id\" not-calculate=\"operation.status>=opStatusNotCalc\" \ndataloaded=\"[F.operationDataNeeded.FISCAL[employee.$id].seventh,F.operationDataNeeded.FISCAL[employee.$id].eigth]\" \nconstants=\"constantIncidences.affectIncidenceProperty[employee.$id]\" directive-functions=\"directiveFunctions\" \nprocess=\"{{process.type}}\" ng-model=\"employee.calculations[process.type].socialPrevision\">\n{{employee.calculations[process.type].socialPrevision.value.total | currency}}</span></td><td \nng-if=\"!F.complementIncidenceTypeData[incidenceId].forSalary\" \nng-repeat=\'(incidenceId, incidenceByType) in complementProccess[\"fixIncidences\" + process.type + \"P\"]\'><span \nng-if=\"!F.complementIncidenceTypeData[incidenceId].directive && (F.fixIncidences[process.type][incidenceId][employee.$id]|objectsLength:true)\" \nclass=\"greenC\" sheet-simple-complement incidences=\"allComplementIncidencesByType[incidenceId][employee.$id]\" \ncalculations-results=\"F.fixIncidences[process.type][incidenceId][employee.$id]\" incidence-id=\"incidenceId\" \ncomplement-incidences-types=\"M.complementIncidencesTypes\" \nconstants-by-value=\"constantIncidences.affectIncidenceValueFiscal[incidenceId][employee.$id]\" \nemployee-id=\"employee.$id\" payroll=\"payroll\" operation=\"operation\" minimum-variables=\"minimumVariables\" \numa-record=\"umaRecord\" nfd-record=\"nfdRecord\" calc-fields=\"L.calcFields\" employee=\"employee\" \nnot-calculate=\"operation.status>=opStatusNotCalc\" \ndataloaded=\"[F.operationDataNeeded[process.type][employee.$id].second]\" \nconstants=\"constantIncidences.affectIncidenceProperty[employee.$id]\" directive-functions=\"directiveFunctions\" \nprocess=\"{{process.type}}\" nature=\"perception\" ng-model=\"employee.calculations[process.type][incidenceId]\">\n{{employee.calculations[process.type][incidenceId].value.total|currency}} </span><span \nng-if=\"!(F.fixIncidences[process.type][incidenceId][employee.$id]|objectsLength)\" class=\"greenC\"><span \nng-if=\'F.complementIncidenceTypeData[incidenceId].affect!=\"days\"\'>{{0|currency}}</span> <span \nng-if=\'F.complementIncidenceTypeData[incidenceId].affect==\"days\"\'>0</span></span></td><td><span sheet-perceptions-real \nemployee-id=\"employee.$id\" not-calculate=\"operation.status>=opStatusNotCalc\" \ndataloaded=\"[F.operationDataNeeded[process.type][employee.$id].third,F.operationDataNeeded[process.type][employee.$id].second]\" \ncalculations=\"employee.calculations[process.type]\" directive-functions=\"directiveFunctions\" process=\"{{process.type}}\" \nng-model=\"employee.calculations[process.type].perceptions\">\n{{employee.calculations[process.type].perceptions.data.onlyIncidencesAmount | currency}}</span></td><td \nng-if=\"!F.complementIncidenceTypeData[incidenceId].forSalary\" \nng-repeat=\'(incidenceId, incidenceByType) in complementProccess[\"fixIncidences\" + process.type + \"D\"]\'><span \nng-if=\"!F.complementIncidenceTypeData[incidenceId].directive && (F.fixIncidences[process.type][incidenceId][employee.$id]|objectsLength:true)\" \nclass=\"redC\" sheet-simple-complement incidences=\"allComplementIncidencesByType[incidenceId][employee.$id]\" \ncalculations-results=\"F.fixIncidences[process.type][incidenceId][employee.$id]\" incidence-id=\"incidenceId\" \ncomplement-incidences-types=\"M.complementIncidencesTypes\" \nconstants-by-value=\"constantIncidences.affectIncidenceValueFiscal[incidenceId][employee.$id]\" \nemployee-id=\"employee.$id\" payroll=\"payroll\" operation=\"operation\" minimum-variables=\"minimumVariables\" \numa-record=\"umaRecord\" nfd-record=\"nfdRecord\" calc-fields=\"L.calcFields\" employee=\"employee\" \nneed-to-balance=\"readyToBalance && (employee.calculations[process.type].netSalary.value.total < 0 || (employee.calculations[process.type].netSalary.value.total > 0 && (F.balancedIncidences[process.type][employee.$id]|anyIsBalanced:F.fixIncidences[process.type][incidenceId][employee.$id]:true)))\" \nexceeded=\"employee.calculations[process.type].netSalary.value.total\" not-calculate=\"operation.status>=opStatusNotCalc\" \ndataloaded=\"[F.operationDataNeeded[process.type][employee.$id].second]\" \nconstants=\"constantIncidences.affectIncidenceProperty[employee.$id]\" directive-functions=\"directiveFunctions\" \nprocess=\"{{process.type}}\" nature=\"deduction\" employee-calculations=\"employee.calculations[process.type]\" \nng-model=\"employee.calculations[process.type][incidenceId]\">\n{{employee.calculations[process.type][incidenceId].value.total|currency}} </span><span \nng-if=\"!(F.fixIncidences[process.type][incidenceId][employee.$id]|objectsLength)\" class=\"redC\"><span \nng-if=\'F.complementIncidenceTypeData[incidenceId].affect!=\"days\"\'>{{0|currency}}</span> <span \nng-if=\'F.complementIncidenceTypeData[incidenceId].affect==\"days\"\'>0</span></span></td><td><span sheet-deductions-real \nemployee-id=\"employee.$id\" not-calculate=\"operation.status>=opStatusNotCalc\" \ndataloaded=\"[F.operationDataNeeded[process.type][employee.$id].third,F.operationDataNeeded[process.type][employee.$id].second]\" \ncalculations=\"employee.calculations[process.type]\" directive-functions=\"directiveFunctions\" process=\"{{process.type}}\" \nng-model=\"employee.calculations[process.type].deductions\">\n-{{employee.calculations[process.type].deductions.data.onlyIncidencesAmount | currency}}</span></td><td><strong \nsheet-total-complement total-perceptions=\"employee.calculations[process.type].perceptions.value.total\" \ntotal-deductions=\"employee.calculations[process.type].deductions.value.total\" employee-id=\"employee.$id\" \nnot-calculate=\"operation.status>=opStatusNotCalc\" \ndataloaded=\"[F.operationDataNeeded[process.type][employee.$id].sixth]\" directive-functions=\"directiveFunctions\" \nprocess=\"{{process.type}}\" ng-model=\"employee.calculations[process.type].netSalary\">\n{{employee.calculations[process.type].netSalary.value.total | currency}}</strong></td></tr></tbody></table></div>\n</md-tab-body>");
$templateCache.put("app/main/clients/views/operation/tabs/fiscal-extraordinary.html","<md-tab-body layout=\"column\"><div class=\"filterToolbar md-padding\"><div layout=\"row\" \nlayout-align=\"space-between center\"><md-input-container class=\"md-block\" flex md-no-float><label>Filtrar Empleado\n</label><input class=\"search-input\" type=\"text\" flex ng-model=\"search.employee\"></md-input-container><md-menu \nng-if=\"!readOnlyMode\"><md-button class=\"md-icon-button\" aria-label=\"show-hide columns\" \nng-click=\"openMenu($mdOpenMenu, $event)\"><md-tooltip md-direction=\"left\">Ocultar o Mostrar Columnas</md-tooltip>\n<md-icon md-font-icon=\"icon-eye\" aria-label=\"columns\"></md-icon></md-button><md-menu-content width=\"4\"><md-menu-item \nng-repeat=\"column in F.columns.FISCAL\"><md-button ng-click=\"toggleColumn($event, column)\"><div layout=\"row\" flex><p \nflex>{{column.name}}</p><md-icon class=\"md-hue-2\" ng-class=\'{\"md-primary\":column.show}\' md-font-icon=\"icon-eye\" \naria-label=\"column\"></md-icon></div></md-button></md-menu-item></md-menu-content></md-menu></div></div><div \ntable-loader array=\"employeesF\" validations=\"validations\"></div><md-table-container ng-show=\"employeesF.length\" flex \nclass=\"max-height-data-table\"><table md-table md-row-select=\"!hideNotSelected\" multiple=\"true\" ng-model=\"selected\" \nclass=\"row-border\"><thead md-head md-order=\"order\" fix-head><tr md-row><th colspan=\"{{hideNotSelected ? 1 : 2}}\" \nclass=\"centered\">Empleado</th><th ng-if=\"countObj(defaultFiscalIncidences)\" \ncolspan=\"{{defaultFiscalIncidences | countObject}}\" class=\"centered\">Incidencias Automáticas</th><th \nng-if=\"countObj(fiscalIncidences)\" colspan=\"{{fiscalIncidences | countObject}}\" class=\"centered\">\nIncidencias del Periodó</th><th colspan=\"2\" class=\"centered\">Acumulados</th><th colspan=\"1\" class=\"centered\">Totales\n</th></tr><tr md-row><th md-column md-order-by=\"data.name\"><span>Nombre</span></th><th \nng-show=\"F.columns.FISCAL[incidenceId].show\" md-column \nng-repeat=\"(incidenceId, incidenceByType) in defaultFiscalIncidences | perceptions\"><span class=\"greenC\">\n{{incidenceId | getSomethingOfArrayM: M.incidencesTypes:\'name\':false:\'_id\'}}</span></th><th \nng-show=\"F.columns.FISCAL[incidenceId].show\" md-column \nng-repeat=\"(incidenceId, incidenceByType) in defaultFiscalIncidences | deductions\"><span class=\"orangeC\">\n{{incidenceId | getSomethingOfArrayM: M.incidencesTypes:\'name\':false:\'_id\'}}</span></th><th \nng-show=\"F.columns.FISCAL[incidenceId].show\" md-column \nng-repeat=\"(incidenceId, incidenceByType) in fiscalIncidences | perceptions\"><span class=\"blueC\">\n{{incidenceId | getSomethingOfArrayM: M.incidencesTypes:\'name\':false:\'_id\'}}</span></th><th \nng-show=\"F.columns.FISCAL[incidenceId].show\" md-column \nng-repeat=\"(incidenceId, incidenceByType) in fiscalIncidences | deductions\"><span class=\"redC\">\n{{incidenceId | getSomethingOfArrayM: M.incidencesTypes:\'name\':false:\'_id\'}}</span></th><th md-column><span>\nTotal de Percepciones</span></th><th md-column><span>Total de Deducciones</span></th><th md-column><strong>Sueldo Neto\n</strong></th></tr></thead><tbody md-body><tr md-row md-select=\"employee\" md-select-id=\"$id\" \nng-repeat=\"employee in employeesF | onlyDispersionEmployees:dispersion:hideNotSelected | filter:search.employee | orderBy:order\">\n<td md-cell>{{employee.data.name}}</td><td md-cell ng-show=\"F.columns.FISCAL[incidenceId].show\" \nng-repeat=\"(incidenceId, incidenceByType) in defaultFiscalIncidences | perceptions\"><span ng-if=\'incidenceId == \"001\"\' \nsheet-total-salary sd=\"employee.data.salary.sd\" worked-days=\"employee.calculations.FISCAL.workedDays\" \nng-model=\"employee.calculations.FISCAL[incidenceId]\"><span class=\"greenC\">\n{{employee.calculations.FISCAL[incidenceId].data.salary | currency}}</span> -> <span class=\"blueC\">\n{{employee.calculations.FISCAL[incidenceId].value.total | currency}}</span> </span><span ng-if=\'incidenceId == \"017\"\' \nclass=\"greenC\" sheet-subsidy gravable-base=\"employee.calculations.FISCAL.gravableBase.value.total\" \nmensualization-factor=\"operation.mensualizationFactor\" \nworked-days=\"employee.calculations.FISCAL.workedDays.value.total\" \nisr-of-period=\'employee.calculations.FISCAL[\"044\"].data.isrOfPeriod\' \nng-model=\"employee.calculations.FISCAL[incidenceId]\">\n{{employee.calculations.FISCAL[incidenceId].value.total | currency}} </span><span ng-if=\'incidenceId == \"027\"\' \nsheet-imss-boss class=\"greenC\" smdf=\"73.04\" worked-days=\"employee.calculations.FISCAL.workedDays.value.total\" \nsbc=\"employee.data.salary.sbc\" calendar-year=\"calendar\" ng-model=\"employee.calculations.FISCAL[incidenceId]\">\n{{employee.calculations.FISCAL[incidenceId].value.total | currency}}</span></td><td md-cell \nng-show=\"F.columns.FISCAL[incidenceId].show\" \nng-repeat=\"(incidenceId, incidenceByType) in defaultFiscalIncidences | deductions\"><span ng-if=\'incidenceId == \"043\"\' \nsheet-imss-worker class=\"orangeC\" smdf=\"73.04\" worked-days=\"employee.calculations.FISCAL.workedDays.value.total\" \nsbc=\"employee.data.salary.sbc\" calendar-year=\"calendar\" ng-model=\"employee.calculations.FISCAL[incidenceId]\">\n{{employee.calculations.FISCAL[incidenceId].value.total | currency}} </span><span ng-if=\'incidenceId == \"044\"\' \nclass=\"orangeC\" sheet-isr gravable-base=\"employee.calculations.FISCAL.gravableBase.value.total\" \nworked-days=\"employee.calculations.FISCAL.workedDays.value.total\" \nmensualization-factor=\"operation.mensualizationFactor\" \nsubsidy-of-period=\'employee.calculations.FISCAL[\"017\"].data.subsidyOfPeriod\' \nng-model=\"employee.calculations.FISCAL[incidenceId]\">\n{{employee.calculations.FISCAL[incidenceId].value.total | currency}}</span></td><td md-cell \nng-show=\"F.columns.FISCAL[incidenceId].show\" \nng-repeat=\"(incidenceId, incidenceByType) in fiscalIncidences | perceptions\"><span ng-if=\'incidenceId == \"002\"\' \nsheet-christmas-bonus ng-model=\"employee.calculations.FISCAL[incidenceId]\"><span class=\"blueC\">\n{{employee.calculations.FISCAL[incidenceId].value.total}}</span> </span><span ng-if=\'incidenceId == \"003\"\' sheet-ptu \nng-model=\"employee.calculations.FISCAL[incidenceId]\"><span class=\"blueC\">\n{{employee.calculations.FISCAL[incidenceId].value.total}}</span> </span><span ng-if=\'incidenceId == \"011\"\' \nsheet-ensure-life-bonus ng-model=\"employee.calculations.FISCAL[incidenceId]\"><span class=\"blueC\">\n{{employee.calculations.FISCAL[incidenceId].value.total}}</span> </span><span ng-if=\'incidenceId == \"014\"\' \nsheet-incapacity-subsidy ng-model=\"employee.calculations.FISCAL[incidenceId]\"><span class=\"blueC\">\n{{employee.calculations.FISCAL[incidenceId].value.total}}</span> </span><span ng-if=\'incidenceId == \"021\"\' \nsheet-holiday-bonus ng-model=\"employee.calculations.FISCAL[incidenceId]\"><span class=\"blueC\">\n{{employee.calculations.FISCAL[incidenceId].value.total}}</span> </span><span ng-if=\'incidenceId == \"039\"\' \nsheet-retirement ng-model=\"employee.calculations.FISCAL[incidenceId]\"><span class=\"blueC\">\n{{employee.calculations.FISCAL[incidenceId].value.total}}</span> </span><span ng-if=\'incidenceId == \"040\"\' \nsheet-federal-income-by-own ng-model=\"employee.calculations.FISCAL[incidenceId]\"><span class=\"blueC\">\n{{employee.calculations.FISCAL[incidenceId].value.total}}</span> </span><span ng-if=\'incidenceId == \"041\"\' \nsheet-federal-income-by-federal ng-model=\"employee.calculations.FISCAL[incidenceId]\"><span class=\"blueC\">\n{{employee.calculations.FISCAL[incidenceId].value.total}}</span> </span><span ng-if=\'incidenceId == \"042\"\' \nsheet-federal-income-by-own-federal ng-model=\"employee.calculations.FISCAL[incidenceId]\"><span class=\"blueC\">\n{{employee.calculations.FISCAL[incidenceId].value.total}}</span> </span><span ng-if=\'incidenceId == \"019\"\' \nsheet-extra-hours incidences=\"incidenceByType[employee.$id]\" sd=\"employee.data.salary.sd\" period=\"periodNumber\" \nng-model=\"employee.calculations.FISCAL[incidenceId]\"><span class=\"greenC\">\n{{employee.calculations.FISCAL[incidenceId].data.extraHours}}</span> -> <span class=\"blueC\">\n{{employee.calculations.FISCAL[incidenceId].value.total | currency}}</span> </span><span ng-if=\'incidenceId == \"020\"\' \nsheet-sunday-bonus ng-model=\"employee.calculations.FISCAL[incidenceId]\"><span class=\"blueC\">\n{{employee.calculations.FISCAL[incidenceId].value.total}}</span> </span><span ng-if=\'incidenceId == \"022\"\' \nsheet-antiquity-bonus ng-model=\"employee.calculations.FISCAL[incidenceId]\"><span class=\"blueC\">\n{{employee.calculations.FISCAL[incidenceId].value.total}}</span> </span><span \nng-if=\"F.complexIncidencesMap.simple.perceptions.indexOf(incidenceId) !== -1\" sheet-simple-perception class=\"blueC\" \nincidences=\"incidencesByType[incidenceId][employee.$id]\" employeeid=\"employee.$id\" \nng-model=\"employee.calculations.FISCAL[incidenceId]\"><span \nng-if=\'employee.calculations.FISCAL[incidenceId].value.type == \"currency\"\'>\n{{ employee.calculations.FISCAL[incidenceId].value.total | currency}}</span> <span \nng-if=\'employee.calculations.FISCAL[incidenceId].value.type == \"int\"\'>\n{{ employee.calculations.FISCAL[incidenceId].value.total}}</span> <span \nng-if=\'employee.calculations.FISCAL[incidenceId].value.type == \"arrayInt\"\'>\n{{ employee.calculations.FISCAL[incidenceId].value.total | calculateTotal}}</span> <span \nng-if=\'employee.calculations.FISCAL[incidenceId].value.type == \"arrayCurrency\"\'>\n{{ employee.calculations.FISCAL[incidenceId].value.total | calculateTotal | currency}}</span></span></td><td md-cell \nng-show=\"F.columns.FISCAL[incidenceId].show\" \nng-repeat=\"(incidenceId, incidenceByType) in fiscalIncidences | deductions\"><span ng-if=\'incidenceId == \"052\"\' \nsheet-house-credit ng-model=\"employee.calculations.FISCAL[incidenceId]\"><span class=\"redC\">\n{{employee.calculations.FISCAL[incidenceId].value.total}}</span> </span><span ng-if=\'incidenceId == \"053\"\' \nsheet-infonacot ng-model=\"employee.calculations.FISCAL[incidenceId]\"><span class=\"redC\">\n{{employee.calculations.FISCAL[incidenceId].value.total}}</span> </span><span ng-if=\'incidenceId == \"048\"\' \nsheet-incapacity-discount ng-model=\"employee.calculations.FISCAL[incidenceId]\"><span class=\"redC\">\n{{employee.calculations.FISCAL[incidenceId].value.total}}</span> </span><span ng-if=\'incidenceId == \"054\"\' \nsheet-pay-advance ng-model=\"employee.calculations.FISCAL[incidenceId]\"><span class=\"redC\">\n{{employee.calculations.FISCAL[incidenceId].value.total}}</span> </span><span ng-if=\'incidenceId == \"062\"\' \nsheet-absences sd=\"employee.data.salary.sd\" incidences=\"incidenceByType[employee.$id]\" \nng-model=\"employee.calculations.FISCAL[incidenceId]\"><span class=\"orangeC\">\n{{employee.calculations.FISCAL[incidenceId].data.days}}</span> -> <span class=\"redC\">\n{{employee.calculations.FISCAL[incidenceId].value.total | currency}}</span> </span><span \nng-if=\"F.complexIncidencesMap.simple.deductions.indexOf(incidenceId) !== -1\" sheet-simple-deduction class=\"redC\" \nincidences=\"incidencesByType[incidenceId][employee.$id]\" ng-model=\"employee.calculations.FISCAL[incidenceId]\">- <span \nng-if=\'employee.calculations.FISCAL[incidenceId].value.type == \"currency\"\'>\n{{ employee.calculations.FISCAL[incidenceId].value.total | currency}}</span> <span \nng-if=\'employee.calculations.FISCAL[incidenceId].value.type == \"int\"\'>\n{{ employee.calculations.FISCAL[incidenceId].value.total}}</span> <span \nng-if=\'employee.calculations.FISCAL[incidenceId].value.type == \"arrayInt\"\'>\n{{ employee.calculations.FISCAL[incidenceId].value.total | calculateTotal}}</span> <span \nng-if=\'employee.calculations.FISCAL[incidenceId].value.type == \"arrayCurrency\"\'>\n{{ employee.calculations.FISCAL[incidenceId].value.total | calculateTotal | currency}}</span></span></td><td md-cell>\n<span sheet-perceptions-fiscal sd=\"employee.data.salary.sd\" perceptions=\"perceptions[employee.$id]\" \nsubsidy=\'employee.calculations.FISCAL[\"017\"].value.total\' \nbase-fiscal-salary=\"employee.calculations.FISCAL.gravableBase.data.baseFiscalSalary\" \nng-model=\"employee.calculations.FISCAL.perceptions\">\n{{employee.calculations.FISCAL.perceptions.data.totalPerceptions | currency}}</span></td><td md-cell><span \nsheet-deductions-fiscal sd=\"employee.data.salary.sd\" isr=\'employee.calculations.FISCAL[\"044\"].value.total\' \ndeductions=\"deductions[employee.$id]\" ng-model=\"employee.calculations.FISCAL.deductions\">\n-{{employee.calculations.FISCAL.deductions.data.totalDeductions | currency}}</span></td><td md-cell><strong \nsheet-total-fiscal base-fiscal-salary=\"employee.calculations.FISCAL.gravableBase.data.baseFiscalSalary\" \nisr=\'employee.calculations.FISCAL[\"044\"].value.total\' subsidy=\'employee.calculations.FISCAL[\"017\"].value.total\' \nng-model=\"employee.calculations.FISCAL.netSalary\">{{employee.calculations.FISCAL.netSalary.value.total | currency}}\n</strong></td></tr></tbody></table></md-table-container></md-tab-body>");
$templateCache.put("app/main/clients/views/operation/tabs/fiscal-ordinary.html","<md-tab-body id=\"table_sabana\" layout=\"column\" flex><div class=\"filterToolbar no-paddingTB\" flex=\"nogrow\"><div \nlayout=\"row\" layout-align=\"space-between center\"><md-input-container class=\"md-block\" flex md-no-float><input \nclass=\"search-input whitePlaceholder\" placeholder=\"Filtrar Empleado\" type=\"text\" flex ng-model=\"search.employee\">\n</md-input-container><md-input-container ng-if=\"operationCcs.length>1\" class=\"md-block\" flex=\"nogrow\" md-no-float>\n<md-select ng-model=\"search.cc\" placeholder=\"Centro de costo\"><md-option value=\"\"><em>Todos</em></md-option><md-option \nng-repeat=\"cc in operationCcs\" ng-value=\"cc.$id\">{{cc.data.name}}</md-option></md-select></md-input-container></div>\n</div><div table-loader array=\"fiscalEmployees\" validations=\"validations\"></div><div \nclass=\"operationTableContainer max-height-data-table\" ng-show=\"fiscalEmployees.length\" flex><table \nclass=\"row-border paddingTable\"><thead><tr><th class=\"text-left\"><span>Nombre</span></th><th><span>Días Trabajados\n</span></th><th><span>Sueldo Diario</span></th><th \nng-repeat=\"(incidenceId, incidenceByType) in F.defaultFiscalIncidencesP\"><span class=\"greenC\">\n{{F.incidenceTypeData[incidenceId].name}}</span></th><th \nng-repeat=\"(incidenceId, incidenceByType) in  fixIncidencesFiscalP\"><span class=\"blueC\">\n{{F.incidenceTypeData[incidenceId].name}}</span></th><th><span>Total de Percepciones</span></th><th \nng-repeat=\"(incidenceId, incidenceByType) in F.defaultFiscalIncidencesD\"><span class=\"orangeC\">\n{{F.incidenceTypeData[incidenceId].name}}</span></th><th \nng-repeat=\"(incidenceId, incidenceByType) in fixIncidencesFiscalD\"><span class=\"redC\">\n{{F.incidenceTypeData[incidenceId].name}}</span></th><th><span>Total de Deducciones</span></th><th><strong>Sueldo Neto\n</strong></th></tr></thead><tbody><tr ng-hide=\"employee.hide\" \nng-repeat=\"employee in fiscalEmployees| filterHide:search.employee:search.cc\"><td class=\"text-left employeeName\"><input\n ng-if=\"readyToBalance\" aria-label=\"select employee\" ng-checked=\"exists(employee, selected)\" type=\"checkbox\" \nng-click=\"toggle(employee, selected)\"> <span ng-bind=\"employee.data.name\"></span></td><td><span sheet-worked-days \nperiod=\"period\" deductions=\"deductionsFiscal[employee.$id]\" perceptions=\"perceptionsFiscal[employee.$id]\" \nincidences-types=\"F.incidencesTypes\" movements=\"employee.movements\" payroll=\"payroll\" employee-id=\"employee.$id\" \nnot-calculate=\"operation.status>=opStatusNotCalc\" \ndataloaded=\"[F.operationDataNeeded.REAL.first, F.operationDataNeeded.REAL[employee.$id].seventh]\" \nconstants=\"constantIncidences.affectIncidenceProperty[employee.$id]\" directive-functions=\"directiveFunctions\" \nprocess=\"FISCAL\" ng-model=\"employee.calculations.FISCAL.workedDays\">\n{{employee.calculations.FISCAL.workedDays.value.totalFormat}} </span><span sheet-gravable-base \ncalculations=\"employee.calculations.FISCAL\" sd=\"employee.data.salary.sd\" \nworked-days=\"employee.calculations.FISCAL.workedDays\" exempt-taxed-concepts=\"exemptTaxedConcepts\" \nincidences-types=\"F.incidencesTypes\" mensualization-factor=\"operation.mensualizationFactor\" employee-id=\"employee.$id\" \nnot-calculate=\"operation.status>=opStatusNotCalc\" \ndataloaded=\"[F.operationDataNeeded.REAL.first, F.operationDataNeeded.FISCAL[employee.$id].seventh]\" \nconstants=\"constantIncidences.affectIncidenceProperty[employee.$id]\" calc-fields=\"L.calcFields\" employee=\"employee\" \npayroll=\"payroll\" operation=\"operation\" uma-record=\"umaRecord\" directive-functions=\"directiveFunctions\" \nprocess=\"FISCAL\" ng-model=\"employee.calculations.FISCAL.gravableBase\"></span></td><td><span sheet-daily-salary \nsalary=\"employee.data.salary\" worked-days=\"employee.calculations.FISCAL.workedDays\" period=\"period\" \ndeductions=\"deductionsFiscal[employee.$id]\" salary-type=\"sd\" employee-id=\"employee.$id\" \nnot-calculate=\"operation.status>=opStatusNotCalc\" dataloaded=\"[F.operationDataNeeded.FISCAL[employee.$id].second]\" \nconstants=\"constantIncidences.affectIncidenceProperty[employee.$id]\" directive-functions=\"directiveFunctions\" \nprocess=\"FISCAL\" ng-model=\"employee.calculations.FISCAL.daily_salary\">\n{{employee.calculations.FISCAL.daily_salary.value.totalFormat}}</span></td><td \nng-repeat=\"(incidenceId, incidenceByType) in F.defaultFiscalIncidencesP\"><span \nng-if=\'F.incidenceTypeData[incidenceId].directive == \"001PF\"\' sheet-total-salary class=\"greenC\" \nsd=\"employee.data.salary.sd\" worked-days=\"employee.calculations.FISCAL.workedDays\" \ndaily-salary=\"employee.calculations.FISCAL.daily_salary\" employee-id=\"employee.$id\" \nnot-calculate=\"operation.status>=opStatusNotCalc\" dataloaded=\"[F.operationDataNeeded.FISCAL[employee.$id].third]\" \ndirective-functions=\"directiveFunctions\" process=\"FISCAL\" ng-model=\"employee.calculations.FISCAL[incidenceId]\">\n{{employee.calculations.FISCAL[incidenceId].value.totalFormat}} </span><span \nng-if=\'F.incidenceTypeData[incidenceId].directive  == \"002PF\"\' sheet-subsidy class=\"greenC\" \ngravable-base=\"employee.calculations.FISCAL.gravableBase.value[isrIncidence.$id]\" \nmensualization-factor=\"operation.mensualizationFactor\" \nworked-days=\"employee.calculations.FISCAL.workedDays.value.total\" \nisr-of-period=\"employee.calculations.FISCAL[isrIncidence.$id].data.isrOfPeriod\" employee-id=\"employee.$id\" \nnot-calculate=\"operation.status>=opStatusNotCalc\" dataloaded=\"[F.operationDataNeeded.FISCAL[employee.$id].fourth]\" \nconstants=\"constantIncidences.affectIncidenceProperty[employee.$id]\" directive-functions=\"directiveFunctions\" \nexceeded=\"employee.calculations.FISCAL.netSalary.value.total\" process=\"FISCAL\" incidence-id=\"incidenceId\" \nemployee-calculations=\"employee.calculations.FISCAL\" ng-model=\"employee.calculations.FISCAL[incidenceId]\">\n{{employee.calculations.FISCAL[incidenceId].value.total | currency}}</span></td><td \nng-repeat=\"(incidenceId, incidenceByType) in  fixIncidencesFiscalP\"><span \nng-if=\'(F.fixIncidences.fiscal[incidenceId][employee.$id]|objectsLength:true) && F.incidenceTypeData[incidenceId].directive == \"019PR\" && F.directivesMap[F.incidenceTypeData[incidenceId].directive].processes.FISCAL\' \nsheet-extra-hours incidences=\"allFiscalIncidencesByType[incidenceId][employee.$id]\" sd=\"employee.data.salary.sd\" \ncalculations-results=\"F.fixIncidences.fiscal[incidenceId][employee.$id]\" period=\"period\" incidence-id=\"incidenceId\" \nincidences-types=\"F.incidencesTypes\" employee-id=\"employee.$id\" not-calculate=\"operation.status>=opStatusNotCalc\" \ndataloaded=\"[F.operationDataNeeded.REAL[employee.$id].fourth]\" \nconstants=\"constantIncidences.affectIncidenceProperty[employee.$id]\" directive-functions=\"directiveFunctions\" \nprocess=\"FISCAL\" ng-model=\"employee.calculations.FISCAL[incidenceId]\"><span class=\"greenC\">\n{{employee.calculations.FISCAL[incidenceId].value.value}}</span> <span>-> </span><span class=\"blueC\">\n{{employee.calculations.FISCAL[incidenceId].value.totalFormat}}</span> </span><span \nng-if=\"(F.fixIncidences.fiscal[incidenceId][employee.$id]|objectsLength:true) && (!F.incidenceTypeData[incidenceId].directive || !F.directivesMap[F.incidenceTypeData[incidenceId].directive].processes.FISCAL)\" \nclass=\"blueC\" sheet-simple-fiscal incidences=\"allFiscalIncidencesByType[incidenceId][employee.$id]\" \ncalculations-results=\"F.fixIncidences.fiscal[incidenceId][employee.$id]\" incidence-id=\"incidenceId\" \nincidences-types=\"F.incidencesTypes\" \nconstants-by-value=\"constantIncidences.affectIncidenceValueFiscal[incidenceId][employee.$id]\" \nemployee-id=\"employee.$id\" payroll=\"payroll\" operation=\"operation\" minimum-variables=\"minimumVariables\" \numa-record=\"umaRecord\" nfd-record=\"nfdRecord\" calc-fields=\"L.calcFields\" employee=\"employee\" \nnot-calculate=\"operation.status>=opStatusNotCalc\" dataloaded=\"[F.operationDataNeeded.FISCAL[employee.$id].fourth]\" \nconstants=\"constantIncidences.affectIncidenceProperty[employee.$id]\" directive-functions=\"directiveFunctions\" \nexceeded=\"employee.calculations.FISCAL.netSalary.value.total\" process=\"FISCAL\" \nnature=\"{{F.incidenceTypeData[incidenceId].nature}}\" employee-calculations=\"employee.calculations.FISCAL\" \nng-model=\"employee.calculations.FISCAL[incidenceId]\">\n{{employee.calculations.FISCAL[incidenceId].value.total|currency}} </span><span \nng-if=\"!(F.fixIncidences.fiscal[incidenceId][employee.$id]|objectsLength)\" class=\"blueC\"><span \nng-if=\'F.incidenceTypeData[incidenceId].affect==\"salary\"\'>{{0|currency}}</span> <span \nng-if=\'F.incidenceTypeData[incidenceId].affect==\"days\"\'>0</span></span></td><td><span sheet-perceptions-real \nemployee-id=\"employee.$id\" not-calculate=\"operation.status>=opStatusNotCalc\" \ndataloaded=\"[F.operationDataNeeded.FISCAL[employee.$id].fourth,F.operationDataNeeded.FISCAL[employee.$id].fifth]\" \ncalculations=\"employee.calculations.FISCAL\" constants=\"constantIncidences.affectIncidenceProperty[employee.$id]\" \ndirective-functions=\"directiveFunctions\" process=\"FISCAL\" ng-model=\"employee.calculations.FISCAL.perceptions\">\n{{employee.calculations.FISCAL.perceptions.data.onlyIncidencesAmount | currency}}</span></td><td \nng-repeat=\"(incidenceId, incidenceByType) in F.defaultFiscalIncidencesD\"><span \nng-if=\'F.incidenceTypeData[incidenceId].directive == \"001DF\"\' sheet-imss-worker class=\"orangeC\" calendar=\"calendar\" \nimss-records=\"M.imssRecords\" sbc=\"employee.data.salary.sbc\" \nworked-days=\"employee.calculations.FISCAL.workedDays.data.naturalWorkedDays\" employee-id=\"employee.$id\" \nminimum-variables=\"minimumVariables\" uma-record=\"umaRecord\" not-calculate=\"operation.status>=opStatusNotCalc\" \ndataloaded=\"[F.operationDataNeeded.FISCAL[employee.$id].fourth]\" \nconstants=\"constantIncidences.affectIncidenceProperty[employee.$id]\" \ncalculations-results=\"employee[fiscal+\'-\'+incidenceId]\" directive-functions=\"directiveFunctions\" \nneed-to-balance=\"readyToBalance && (employee.calculations.FISCAL.netSalary.value.total < 0 || (employee.calculations.FISCAL.netSalary.value.total > 0 && (F.balancedIncidences.FISCAL[employee.$id]|anyIsBalanced:employee[fiscal+\'-\'+incidenceId])))\" \nexceeded=\"employee.calculations.FISCAL.netSalary.value.total\" process=\"FISCAL\" incidence-id=\"incidenceId\" \nemployee-calculations=\"employee.calculations.FISCAL\" ng-model=\"employee.calculations.FISCAL[incidenceId]\">\n{{employee.calculations.FISCAL[incidenceId].value.total | currency}} </span><span \nng-if=\'F.incidenceTypeData[incidenceId].directive == \"002DF\"\' sheet-isr class=\"orangeC\" \ngravable-base=\"employee.calculations.FISCAL.gravableBase.value[incidenceId]\" \nworked-days=\"employee.calculations.FISCAL.workedDays.value.total\" \nmensualization-factor=\"operation.mensualizationFactor\" \nsubsidy-of-period=\"employee.calculations.FISCAL[subsidyIncidence.$id].data.subsidyOfPeriod\" employee-id=\"employee.$id\" \nnot-calculate=\"operation.status>=opStatusNotCalc\" dataloaded=\"[F.operationDataNeeded.FISCAL[employee.$id].fourth]\" \nconstants=\"constantIncidences.affectIncidenceProperty[employee.$id]\" \ncalculations-results=\"employee[fiscal+\'-\'+incidenceId]\" directive-functions=\"directiveFunctions\" \nneed-to-balance=\"readyToBalance && (employee.calculations.FISCAL.netSalary.value.total < 0 || (employee.calculations.FISCAL.netSalary.value.total > 0 && (F.balancedIncidences.FISCAL[employee.$id]|anyIsBalanced:employee[fiscal+\'-\'+incidenceId])))\" \nexceeded=\"employee.calculations.FISCAL.netSalary.value.total\" process=\"FISCAL\" incidence-id=\"incidenceId\" \nemployee-calculations=\"employee.calculations.FISCAL\" ng-model=\"employee.calculations.FISCAL[incidenceId]\">\n{{employee.calculations.FISCAL[incidenceId].value.total | currency}}</span></td><td \nng-repeat=\"(incidenceId, incidenceByType) in fixIncidencesFiscalD\"><span \nng-if=\"(F.fixIncidences.fiscal[incidenceId][employee.$id]|objectsLength)\" sheet-simple-fiscal class=\"redC\" \nincidences=\"allFiscalIncidencesByType[incidenceId][employee.$id]\" \ncalculations-results=\"F.fixIncidences.fiscal[incidenceId][employee.$id]\" \nconstants-by-value=\"constantIncidences.affectIncidenceValueFiscal[incidenceId][employee.$id]\" \nincidence-id=\"incidenceId\" incidences-types=\"F.incidencesTypes\" employee-id=\"employee.$id\" payroll=\"payroll\" \noperation=\"operation\" minimum-variables=\"minimumVariables\" uma-record=\"umaRecord\" nfd-record=\"nfdRecord\" \ncalc-fields=\"L.calcFields\" employee=\"employee\" not-calculate=\"operation.status>=opStatusNotCalc\" \ndataloaded=\"[F.operationDataNeeded.FISCAL[employee.$id].fourth]\" \nconstants=\"constantIncidences.affectIncidenceProperty[employee.$id]\" directive-functions=\"directiveFunctions\" \nneed-to-balance=\"readyToBalance && (employee.calculations.FISCAL.netSalary.value.total < 0 || (employee.calculations.FISCAL.netSalary.value.total > 0 && (F.balancedIncidences.FISCAL[employee.$id]|anyIsBalanced:F.fixIncidences.fiscal[incidenceId][employee.$id])))\" \nexceeded=\"employee.calculations.FISCAL.netSalary.value.total\" process=\"FISCAL\" \nnature=\"{{F.incidenceTypeData[incidenceId].nature}}\" employee-calculations=\"employee.calculations.FISCAL\" \nng-model=\"employee.calculations.FISCAL[incidenceId]\">\n{{employee.calculations.FISCAL[incidenceId].value.total | currency}} </span><span \nng-if=\"!(F.fixIncidences.fiscal[incidenceId][employee.$id]|objectsLength)\" class=\"redC\"><span \nng-if=\'F.incidenceTypeData[incidenceId].affect==\"salary\"\'>{{0|currency}}</span> <span \nng-if=\'F.incidenceTypeData[incidenceId].affect==\"days\"\'>0</span></span></td><td><span sheet-deductions-real \nemployee-id=\"employee.$id\" not-calculate=\"operation.status>=opStatusNotCalc\" \ndataloaded=\"[F.operationDataNeeded.FISCAL[employee.$id].fourth,F.operationDataNeeded.FISCAL[employee.$id].fifth]\" \ncalculations=\"employee.calculations.FISCAL\" constants=\"constantIncidences.affectIncidenceProperty[employee.$id]\" \ndirective-functions=\"directiveFunctions\" process=\"FISCAL\" ng-model=\"employee.calculations.FISCAL.deductions\">\n-{{employee.calculations.FISCAL.deductions.data.onlyIncidencesAmount | currency}}</span></td><td><strong \nsheet-total-fiscal perceptions=\"employee.calculations.FISCAL.perceptions.value.total\" \ndeductions=\"employee.calculations.FISCAL.deductions.value.total\" employee-id=\"employee.$id\" \nnot-calculate=\"operation.status>=opStatusNotCalc\" dataloaded=\"[F.operationDataNeeded.FISCAL[employee.$id].sixth]\" \nconstants=\"constantIncidences.affectIncidenceProperty[employee.$id]\" directive-functions=\"directiveFunctions\" \nprocess=\"FISCAL\" ng-model=\"employee.calculations.FISCAL.netSalary\">\n{{employee.calculations.FISCAL.netSalary.value.total | currency}}</strong></td></tr></tbody></table></div>\n</md-tab-body>");
$templateCache.put("app/main/clients/views/operation/tabs/real-extraordinary.html","<md-tab-body layout=\"column\"><div class=\"filterToolbar md-padding\"><div layout=\"row\" \nlayout-align=\"space-between center\"><md-input-container class=\"md-block\" flex md-no-float><label>Filtrar Empleado\n</label><input class=\"search-input\" type=\"text\" flex ng-model=\"search.employee\"></md-input-container><md-menu \nng-if=\"!readOnlyMode\"><md-button class=\"md-icon-button\" aria-label=\"add fast incidence\" \nng-click=\"openMenu($mdOpenMenu, $event)\"><md-tooltip md-direction=\"left\">Agregar Incidencia Rápida</md-tooltip><md-icon\n md-font-icon=\"icon-plus\" aria-label=\"fast incidence\"></md-icon></md-button><md-menu-content width=\"4\"><md-menu-item \nng-repeat=\"incidenceT in M.incidencesTypes | fastIncidences\"><md-button \nng-class=\'{\"md-warn\":incidenceT.nature==\"deduction\",\"md-primary\":incidenceT.nature==\"perception\"}\' \nng-disabled=\"fastIncidenceUsed(incidenceT._id)\" ng-click=\"addFastIncidenceColumn(incidenceT, tabName)\">\n{{incidenceT.name}}</md-button></md-menu-item></md-menu-content></md-menu></div></div><div table-loader \narray=\"employeesF\" validations=\"validations\"></div><md-table-container ng-show=\"employeesF.length\" flex \nclass=\"max-height-data-table\"><table md-table md-row-select=\"!hideNotSelected\" multiple=\"true\" ng-model=\"selected\" \nclass=\"row-border\"><thead md-head md-order=\"order\" fix-head><tr md-row><th colspan=\"{{hideNotSelected ? 1 : 2}}\" \nclass=\"centered\">Empleado</th><th ng-if=\"countObj(normalIncidencesByType)\" \ncolspan=\"{{normalIncidencesByType | countObject}}\" class=\"centered\">Incidencias del Periodo</th><th \nng-if=\"countObj(fastIncidencesByType)\" colspan=\"{{fastIncidencesByType | countObject}}\" class=\"centered\">\nIncidencias Rápidas</th><th colspan=\"2\" class=\"centered\">Acumulados</th><th colspan=\"1\" class=\"centered\">Totales</th>\n</tr><tr md-row><th md-column md-order-by=\"data.name\"><span>Nombre</span></th><th md-column \nng-repeat=\"(incidenceId, incidenceByType) in normalIncidencesByType | deductions\"><span class=\"redC\">\n{{incidenceId | getSomethingOfArrayM: M.incidencesTypes:\'name\':false:\'_id\'}}</span></th><th md-column \nng-repeat=\"(incidenceId, incidenceByType) in normalIncidencesByType | perceptions\"><span class=\"blueC\">\n{{incidenceId | getSomethingOfArrayM: M.incidencesTypes:\'name\':false:\'_id\'}}</span></th><th md-column \nng-repeat=\"(incidenceId, incidenceByType) in fastIncidencesByType | deductions\"><span class=\"orangeC\">\n{{incidenceId | getSomethingOfArrayM: M.incidencesTypes:\'name\':false:\'_id\'}}</span></th><th md-column \nng-repeat=\"(incidenceId, incidenceByType) in fastIncidencesByType | perceptions\"><span class=\"greenC\">\n{{incidenceId | getSomethingOfArrayM: M.incidencesTypes:\'name\':false:\'_id\'}}</span></th><th md-column><span>\nTotal de Percepciones</span></th><th md-column><span>Total de Deducciones</span></th><th md-column><strong>\nSueldo Neto Real</strong></th></tr></thead><tbody md-body><tr md-row md-select=\"employee\" md-select-id=\"$id\" \nng-repeat=\"employee in employeesF | onlyDispersionEmployees:dispersion:hideNotSelected | filter:search.employee | orderBy:order\">\n<td md-cell>{{employee.data.name}}</td><td md-cell \nng-repeat=\"(incidenceId, incidenceByType) in normalIncidencesByType | deductions\"><span class=\"redC\" \nng-if=\'incidenceAffect(incidenceId, \"salary\")\'>-{{incidenceByType[employee.$id] | calculateTotal | currency}}</span> \n<span class=\"redC\" ng-if=\'incidenceAffect(incidenceId, \"days\")\'>\n-{{incidenceByType[employee.$id] | calculateTotal}} dia(s)</span></td><td md-cell \nng-repeat=\"(incidenceId, incidenceByType) in normalIncidencesByType | perceptions\"><span class=\"blueC\" \nng-if=\'incidenceAffect(incidenceId, \"salary\")\'>+{{incidenceByType[employee.$id] | calculateTotal | currency}}</span> \n<span class=\"blueC\" ng-if=\'incidenceAffect(incidenceId, \"days\")\'>\n+{{incidenceByType[employee.$id] | calculateTotal}} dia(s)</span></td><td md-cell \nng-repeat=\"(incidenceId, fastIncidenceByType) in fastIncidencesByType | deductions\"><span ng-if=\"operation.status > 1\">\n<span class=\"orangeC\" ng-if=\'incidenceAffect(incidenceId, \"salary\")\'>\n-{{fastIncidenceByType[employee.$id].value| currency}}</span> <span class=\"orangeC\" \nng-if=\'incidenceAffect(incidenceId, \"days\")\'>-{{fastIncidenceByType[employee.$id].value}} dia(s)</span></span>\n<md-input-container ng-if=\"operation.status < 2\" md-no-float><input ng-if=\'incidenceAffect(incidenceId, \"salary\")\' \ntype=\"text\" class=\"orangeC\" ng-model=\"fastIncidenceByType[employee.$id].value\" placeholder=\"$\" \nng-disabled=\"readOnlyMode\" ng-change=\"saveFastIncidence(fastIncidenceByType[employee.$id],employee.$id,incidenceId)\" \nng-model-options=\"{ debounce: F.debounceTime }\" tabindex=\"{{$index+1}}00\"> <input \nng-if=\'incidenceAffect(incidenceId, \"days\")\' type=\"text\" class=\"orangeC\" \nng-model=\"fastIncidenceByType[employee.$id].value\" ng-disabled=\"readOnlyMode\" placeholder=\"dia(s)\" \nng-change=\"saveFastIncidence(fastIncidenceByType[employee.$id],employee.$id,incidenceId)\" \nng-model-options=\"{ debounce: F.debounceTime }\" tabindex=\"{{$index+1}}00\"></md-input-container></td><td md-cell \nng-repeat=\"(incidenceId, fastIncidenceByType) in fastIncidencesByType | perceptions\"><span \nng-if=\"operation.status > 1\"><span class=\"greenC\" ng-if=\'incidenceAffect(incidenceId, \"salary\")\'>\n-{{fastIncidenceByType[employee.$id].value | currency}}</span> <span class=\"greenC\" \nng-if=\'incidenceAffect(incidenceId, \"days\")\'>-{{fastIncidenceByType[employee.$id].value}} dia(s)</span></span>\n<md-input-container ng-if=\"operation.status < 2\" md-no-float><input ng-if=\'incidenceAffect(incidenceId, \"salary\")\' \ntype=\"text\" class=\"greenC\" ng-model=\"fastIncidenceByType[employee.$id].value\" ng-disabled=\"readOnlyMode\" \nplaceholder=\"$\" ng-change=\"saveFastIncidence(fastIncidenceByType[employee.$id],employee.$id,incidenceId)\" \nng-model-options=\"{ debounce: F.debounceTime }\" tabindex=\"{{$index+1}}000\"> <input \nng-if=\'incidenceAffect(incidenceId, \"days\")\' type=\"text\" class=\"greenC\" \nng-model=\"fastIncidenceByType[employee.$id].value\" ng-disabled=\"readOnlyMode\" placeholder=\"dia(s)\" \nng-change=\"saveFastIncidence(fastIncidenceByType[employee.$id],employee.$id,incidenceId)\" \nng-model-options=\"{ debounce: F.debounceTime }\" tabindex=\"{{$index+1}}000\"></md-input-container></td><td md-cell><span \nsheet-perceptions-real sdr=\"employee.data.salary.sdr\" perceptions=\"perceptions[employee.$id]\" \nng-model=\"employee.calculations.REAL.perceptions\">\n{{employee.calculations.REAL.perceptions.data.totalPerceptions | currency}}</span></td><td md-cell><span \nsheet-deductions-real sdr=\"employee.data.salary.sdr\" deductions=\"deductions[employee.$id]\" \nng-model=\"employee.calculations.REAL.deductions\">\n-{{employee.calculations.REAL.deductions.data.totalDeductions | currency}}</span></td><td md-cell><strong \nsheet-total-real base-real-salary=\"employee.calculations.REAL.baseRealSalary.value.total\" \ntotal-perceptions=\"employee.calculations.REAL.perceptions.data.totalPerceptions\" \ntotal-deductions=\"employee.calculations.REAL.deductions.data.totalDeductions\" \nng-model=\"employee.calculations.REAL.netRealSalary\">{{employee.calculations.REAL.netRealSalary.value.total | currency}}\n</strong></td></tr></tbody></table></md-table-container></md-tab-body>");
$templateCache.put("app/main/clients/views/operation/tabs/real-ordinary.html","<md-tab-body id=\"table_sabana\" layout=\"column\" flex><div class=\"filterToolbar no-paddingTB\" flex=\"nogrow\"><div \nlayout=\"row\" layout-align=\"space-between center\"><md-input-container class=\"md-block\" flex md-no-float><input \nng-model-options=\"{ debounce: F.debounceTime }\" placeholder=\"Filtrar Empleados\" class=\"search-input whitePlaceholder\" \ntype=\"text\" flex ng-model=\"search.employee\"></md-input-container><md-input-container ng-if=\"operationCcs.length>1\" \nclass=\"md-block\" flex=\"nogrow\" md-no-float><md-select ng-model=\"search.cc\" placeholder=\"Centro de costo\"><md-option \nvalue=\"\"><em>Todos</em></md-option><md-option ng-repeat=\"cc in operationCcs\" ng-value=\"cc.$id\">{{cc.data.name}}\n</md-option></md-select></md-input-container><md-menu \nng-if=\"!readOnlyMode && operation.status < opStatusNotCalc && operationStatusByEmployees < nextOperationStatus\" \nflex=\"nogrow\"><md-button class=\"md-icon-button\" aria-label=\"add fast incidence\" \nng-click=\"openMenu($mdOpenMenu, $event)\"><md-tooltip md-direction=\"left\">Agregar Incidencia Rápida</md-tooltip><md-icon\n md-font-icon=\"icon-plus\" aria-label=\"fast incidence\"></md-icon></md-button><md-menu-content width=\"4\"><md-menu-item \nlayout-padding><md-input-container class=\"md-block\"><label>Filtrar Incidencias</label><input type=\"text\" \nng-model=\"fastIncidencesFilter\"></md-input-container></md-menu-item><md-menu-item \nng-repeat=\'incidenceT in F.incidencesTypes | fastIncidences | filter:fastIncidencesFilter | orderBy:\"name\" | orderBy:\"-nature\"\'>\n<md-button ng-class=\'{\"md-warn\":incidenceT.nature==\"deduction\",\"md-primary\":incidenceT.nature==\"perception\"}\' \nng-disabled=\"fastIncidenceUsed(incidenceT.$id)\" ng-click=\"addFastIncidenceColumn(incidenceT, tabName)\">\n{{incidenceT.name}}</md-button></md-menu-item></md-menu-content></md-menu><md-input-container \nng-if=\"!readOnlyMode && operation.status < opStatusNotCalc && operationStatusByEmployees<nextOperationStatus\" \nflex=\"nogrow\"><md-checkbox name=\"notCalculate\" ng-model=\"F.notCalculate\" ng-change=\"keepCalculating(F.notCalculate)\">\nNo calcular</md-checkbox></md-input-container></div></div><div table-loader array=\"employeesF\" \nvalidations=\"validations\"></div><div class=\"operationTableContainer max-height-data-table\" ng-show=\"employeesF.length\" \nflex><table class=\"row-border\"><thead><tr><th class=\"noPadding\"><div layout=\"row\" layout-align=\"start center\"><span \nflex=\"nogrow\">Nombre</span><div flex class=\"text-right\"><md-button class=\"md-icon-button md-primary\" \naria-label=\"Settings\" ng-click=\"setNextOrder(\'data.name\',order)\"><md-icon md-font-icon=\"icon-filter-variant\" \naria-label=\"Order by Date\" ng-if=\"order!==\'data.name\'&&order!=\'-data.name\'\"></md-icon><md-icon \nmd-font-icon=\"icon-arrow-down\" aria-label=\"Order Descendent\" ng-if=\"order==\'data.name\'\"></md-icon><md-icon \nmd-font-icon=\"icon-arrow-up\" aria-label=\"Order Ascendent\" ng-if=\"order==\'-data.name\'\"></md-icon></md-button></div>\n</div></th><th><span>Dias trabajados</span></th><th><span>SDR</span></th><th><span>Sueldo</span></th><th \nclass=\"incidenceTitle\" ng-repeat=\"(incidenceId, incidenceByType) in normalIncidencesByTypeP\"><span class=\"blueC\" \nng-bind=\"F.incidenceTypeData[incidenceId].name\"></span></th><th class=\"incidenceTitle\" \nng-repeat=\"(incidenceId, incidenceByType) in fastIncidencesByTypeP\"><div layout=\"row\" layout-align=\"start center\"><div \nflex><span class=\"greenC\" ng-bind=\"F.incidenceTypeData[incidenceId].name\"></span></div><div flex=\"nogrow\"><md-button \nng-if=\"(fastIncidencesByType[incidenceId]|checkAllowDeleteFastIncidence)\" ng-click=\"deleteFastIncidences(incidenceId)\" \nclass=\"md-mini md-icon-button shrink-2x\" aria-label=\"Delete\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Delete fast incidence\"></md-icon></md-button></div></div></th><th><span>Total de Percepciones</span></th>\n<th class=\"incidenceTitle\" ng-repeat=\"(incidenceId, incidenceByType) in normalIncidencesByTypeD\"><span class=\"redC\" \nng-bind=\"F.incidenceTypeData[incidenceId].name\"></span></th><th class=\"incidenceTitle\" \nng-repeat=\"(incidenceId, incidenceByType) in fastIncidencesByTypeD\"><span class=\"orangeC\" \nng-bind=\"F.incidenceTypeData[incidenceId].name\"></span><md-button \nng-if=\"(fastIncidencesByType[incidenceId]|checkAllowDeleteFastIncidence)\" ng-click=\"deleteFastIncidences(incidenceId)\" \nclass=\"md-icon-button\" aria-label=\"Delete\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Delete fast incidence\">\n</md-icon></md-button></th><th><span>Total de Deducciones</span></th><th><strong>Sueldo Neto Real</strong></th></tr>\n</thead><tbody ng-if=\"operationDataNeeded\"><tr ng-hide=\"employee.hide\" ng-class=\"{\'fixedRow\':$index==1}\" \nng-repeat=\"($index,employee) in realEmployees | filterHide:search.employee:search.cc\"><td \nclass=\"text-left employeeName\"><input ng-if=\"readyToBalance\" aria-label=\"select employee\" \nng-checked=\"exists(employee, selected)\" type=\"checkbox\" ng-click=\"toggle(employee, selected)\"> <span \nng-bind=\"employee.data.name\"></span> <span ng-if=\"operation.status<2 && operation.employees[employee.$id].status>0\" \nclass=\"greenC doneMark\">✓</span></td><td><span sheet-worked-days period=\"period\" deductions=\"deductions[employee.$id]\" \nperceptions=\"perceptions[employee.$id]\" incidences-types=\"F.incidencesTypes\" movements=\"employee.movements\" \npayroll=\"payroll\" employee-id=\"employee.$id\" not-calculate=\"operation.status>=opStatusNotCalc\" \ndataloaded=\"[F.operationDataNeeded.REAL.first]\" constants=\"constantIncidences.affectIncidenceProperty[employee.$id]\" \ndirective-functions=\"directiveFunctions\" process=\"REAL\" ng-model=\"employee.calculations.REAL.workedDays\"><span \nng-bind=\"employee.calculations.REAL.workedDays.value.totalFormat\"></span></span></td><td><span sheet-daily-salary \nsalary=\"employee.data.salary\" worked-days=\"employee.calculations.REAL.workedDays\" period=\"period\" \ndeductions=\"deductions[employee.$id]\" salary-type=\"sdr\" employee-id=\"employee.$id\" \nnot-calculate=\"operation.status>=opStatusNotCalc\" dataloaded=\"[F.operationDataNeeded.REAL[employee.$id].second]\" \nconstants=\"constantIncidences.affectIncidenceProperty[employee.$id]\" directive-functions=\"directiveFunctions\" \nprocess=\"REAL\" ng-model=\"employee.calculations.REAL.daily_salary\"><span \nng-bind=\"employee.calculations.REAL.daily_salary.value.totalFormat\"></span></span></td><td><span sheet-total-salary \nsdr=\"employee.data.salary.sdr\" worked-days=\"employee.calculations.REAL.workedDays\" \ndaily-salary=\"employee.calculations.REAL.daily_salary\" employee-id=\"employee.$id\" \nnot-calculate=\"operation.status>=opStatusNotCalc\" dataloaded=\"[F.operationDataNeeded.REAL[employee.$id].third]\" \nconstants=\"constantIncidences.affectIncidenceProperty[employee.$id]\" directive-functions=\"directiveFunctions\" \nprocess=\"REAL\" ng-model=\"employee.calculations.REAL.salary\"><span \nng-bind=\"employee.calculations.REAL.salary.value.totalFormat\"></span></span></td><td \nng-repeat=\"(incidenceId, incidenceByType) in normalIncidencesByTypeP\"><span \nng-if=\'F.activeDirectiveMap[incidenceId][employee.$id].active==\"normal\" && F.incidenceTypeData[incidenceId].directive == \"019PR\"\' \nsheet-extra-hours incidences=\"allIncidencesByType[incidenceId][employee.$id]\" sd=\"employee.data.salary.sdr\" \nperiod=\"period\" incidence-id=\"incidenceId\" incidences-types=\"F.incidencesTypes\" employee-id=\"employee.$id\" \nnot-calculate=\"operation.status>=opStatusNotCalc\" dataloaded=\"[F.operationDataNeeded.REAL[employee.$id].fourth]\" \nconstants=\"constantIncidences.affectIncidenceProperty[employee.$id]\" directive-functions=\"directiveFunctions\" \nprocess=\"REAL\" ng-model=\"employee.calculations.REAL[incidenceId]\"><span \nng-bind=\"employee.calculations.REAL[incidenceId].value.normalValue\" class=\"greenC\"></span> <span>-></span> <span \nng-bind=\"employee.calculations.REAL[incidenceId].value.normalTotalFormat\" class=\"blueC\"></span> </span><span \nng-if=\'F.activeDirectiveMap[incidenceId][employee.$id].active==\"normal\" && F.incidenceTypeData[incidenceId].directive == \"001PRV\"\' \nsheet-holidays incidences=\"allIncidencesByType[incidenceId][employee.$id]\" incidence-id=\"incidenceId\" \nincidences-types=\"F.incidencesTypes\" sd=\"employee.data.salary.sdr\" employee-id=\"employee.$id\" \nnot-calculate=\"operation.status>=opStatusNotCalc\" dataloaded=\"[F.operationDataNeeded.REAL[employee.$id].fourth]\" \nconstants=\"constantIncidences.affectIncidenceProperty[employee.$id]\" directive-functions=\"directiveFunctions\" \nprocess=\"REAL\" ng-model=\"employee.calculations.REAL[incidenceId]\"><span \nng-bind=\"employee.calculations.REAL[incidenceId].value.normalValue\" class=\"greenC\"></span> <span>-></span> <span \nng-bind=\"employee.calculations.REAL[incidenceId].value.normalTotalFormat\" class=\"blueC\"></span> </span><span \nng-if=\'F.activeDirectiveMap[incidenceId][employee.$id].active==\"normal\" && !(F.incidenceTypeData[incidenceId].directive) && F.incidenceTypeData[incidenceId].affect==\"salary\"\' \nsheet-simple-perception incidences=\"allIncidencesByType[incidenceId][employee.$id]\" incidence-id=\"incidenceId\" \nincidences-types=\"F.incidencesTypes\" \nconstants-by-value=\"constantIncidences.affectIncidenceValue[incidenceId][employee.$id]\" \nconstants-by-total=\"constantIncidences.affectIncidenceTotal[incidenceId][employee.$id]\" calc-fields=\"L.calcFields\" \nemployee=\"employee\" payroll=\"payroll\" operation=\"operation\" minimum-variables=\"minimumVariables\" \numa-record=\"umaRecord\" nfd-record=\"nfdRecord\" employee-id=\"employee.$id\" \nnot-calculate=\"operation.status>=opStatusNotCalc\" dataloaded=\"[F.operationDataNeeded.REAL[employee.$id].fourth]\" \nconstants=\"constantIncidences.affectIncidenceProperty[employee.$id]\" directive-functions=\"directiveFunctions\" \nprocess=\"REAL\" ng-model=\"employee.calculations.REAL[incidenceId]\"><span class=\"greenC\" \nng-if=\"F.incidenceTypeData[incidenceId].customCalc\"><span \nng-bind=\"employee.calculations.REAL[incidenceId].value.normalValue\"></span>--> </span><span \nng-bind=\"employee.calculations.REAL[incidenceId].value.normalTotalFormat\" class=\"blueC\"></span> </span><span \nng-if=\'F.activeDirectiveMap[incidenceId][employee.$id].active==\"normal\" && !(F.incidenceTypeData[incidenceId].directive) && F.incidenceTypeData[incidenceId].affect==\"days\"\' \nsheet-simple-perception-day incidences=\"allIncidencesByType[incidenceId][employee.$id]\" incidence-id=\"incidenceId\" \nincidences-types=\"F.incidencesTypes\" sd=\"employee.data.salary.sdr\" \nconstants-by-value=\"constantIncidences.affectIncidenceValue[incidenceId][employee.$id]\" \nconstants-by-total=\"constantIncidences.affectIncidenceTotal[incidenceId][employee.$id]\" calc-fields=\"L.calcFields\" \nconstants=\"constantIncidences.affectIncidenceProperty[employee.$id]\" employee=\"employee\" payroll=\"payroll\" \noperation=\"operation\" minimum-variables=\"minimumVariables\" uma-record=\"umaRecord\" nfd-record=\"nfdRecord\" \nemployee-id=\"employee.$id\" not-calculate=\"operation.status>=opStatusNotCalc\" \ndataloaded=\"[F.operationDataNeeded.REAL[employee.$id].fourth]\" \nconstants=\"constantIncidences.affectIncidenceProperty[employee.$id]\" directive-functions=\"directiveFunctions\" \nprocess=\"REAL\" ng-model=\"employee.calculations.REAL[incidenceId]\"><span \nng-bind=\"employee.calculations.REAL[incidenceId].value.normalValue\" class=\"greenC\"></span> <span>-></span> <span \nng-bind=\"employee.calculations.REAL[incidenceId].value.normalTotalFormat\" class=\"blueC\"></span> </span><span \nng-if=\'F.activeDirectiveMap[incidenceId][employee.$id].active==\"none\"||F.activeDirectiveMap[incidenceId][employee.$id].active==\"fast\"\' \nclass=\"blueC\"><span ng-if=\'F.incidenceTypeData[incidenceId].affect==\"salary\"\'>{{0|currency}}</span> <span \nng-if=\'F.incidenceTypeData[incidenceId].affect==\"days\"\'>0</span></span></td><td \nng-class=\"{\'withInput\':operation.status < 3 && operation.employees[employee.$id].status<nextEmployeeStatus}\" \nng-repeat=\"(incidenceId, fastIncidenceByType) in fastIncidencesByTypeP\"><span ng-show=\"false\" \nng-if=\'F.activeDirectiveMap[incidenceId][employee.$id].active==\"fast\" && F.incidenceTypeData[incidenceId].directive == \"019PR\"\' \nsheet-extra-hours incidences=\"allIncidencesByType[incidenceId][employee.$id]\" incidence-id=\"incidenceId\" \nincidences-types=\"F.incidencesTypes\" sd=\"employee.data.salary.sdr\" period=\"period\" employee-id=\"employee.$id\" \nnot-calculate=\"operation.status>=opStatusNotCalc\" constants=\"constantIncidences.affectIncidenceProperty[employee.$id]\" \ndirective-functions=\"directiveFunctions\" dataloaded=\"[F.operationDataNeeded.REAL[employee.$id].fourth]\" process=\"REAL\" \nng-model=\"employee.calculations.REAL[incidenceId]\"></span><span ng-show=\"false\" \nng-if=\'F.activeDirectiveMap[incidenceId][employee.$id].active==\"fast\" && F.incidenceTypeData[incidenceId].directive == \"001PRV\"\' \nsheet-holidays incidences=\"allIncidencesByType[incidenceId][employee.$id]\" incidence-id=\"incidenceId\" \nincidences-types=\"F.incidencesTypes\" sd=\"employee.data.salary.sdr\" employee-id=\"employee.$id\" \nnot-calculate=\"operation.status>=opStatusNotCalc\" dataloaded=\"[F.operationDataNeeded.REAL[employee.$id].fourth]\" \nconstants=\"constantIncidences.affectIncidenceProperty[employee.$id]\" directive-functions=\"directiveFunctions\" \nprocess=\"REAL\" ng-model=\"employee.calculations.REAL[incidenceId]\"></span><span ng-show=\"false\" \nng-if=\'F.activeDirectiveMap[incidenceId][employee.$id].active==\"fast\" && !(F.incidenceTypeData[incidenceId].directive) && F.incidenceTypeData[incidenceId].affect==\"salary\"\' \nsheet-simple-perception incidences=\"allIncidencesByType[incidenceId][employee.$id]\" incidence-id=\"incidenceId\" \nincidences-types=\"F.incidencesTypes\" \nconstants-by-value=\"constantIncidences.affectIncidenceValue[incidenceId][employee.$id]\" \nconstants-by-total=\"constantIncidences.affectIncidenceTotal[incidenceId][employee.$id]\" \nconstants=\"constantIncidences.affectIncidenceProperty[employee.$id]\" calc-fields=\"L.calcFields\" class=\"greenC\" \nemployee=\"employee\" payroll=\"payroll\" operation=\"operation\" minimum-variables=\"minimumVariables\" \numa-record=\"umaRecord\" nfd-record=\"nfdRecord\" employee-id=\"employee.$id\" \nnot-calculate=\"operation.status>=opStatusNotCalc\" dataloaded=\"[F.operationDataNeeded.REAL[employee.$id].fourth]\" \ndirective-functions=\"directiveFunctions\" process=\"REAL\" ng-model=\"employee.calculations.REAL[incidenceId]\"></span><span\n ng-show=\"false\" \nng-if=\'F.activeDirectiveMap[incidenceId][employee.$id].active==\"fast\" && !(F.incidenceTypeData[incidenceId].directive) && F.incidenceTypeData[incidenceId].affect==\"days\"\' \nsheet-simple-perception-day incidences=\"allIncidencesByType[incidenceId][employee.$id]\" incidence-id=\"incidenceId\" \nincidences-types=\"F.incidencesTypes\" sd=\"employee.data.salary.sdr\" \nconstants-by-value=\"constantIncidences.affectIncidenceValue[incidenceId][employee.$id]\" \nconstants-by-total=\"constantIncidences.affectIncidenceTotal[incidenceId][employee.$id]\" employee=\"employee\" \npayroll=\"payroll\" operation=\"operation\" minimum-variables=\"minimumVariables\" uma-record=\"umaRecord\" \nnfd-record=\"nfdRecord\" calc-fields=\"L.calcFields\" employee-id=\"employee.$id\" \nnot-calculate=\"operation.status>=opStatusNotCalc\" dataloaded=\"[F.operationDataNeeded.REAL[employee.$id].fourth]\" \nconstants=\"constantIncidences.affectIncidenceProperty[employee.$id]\" directive-functions=\"directiveFunctions\" \nprocess=\"REAL\" ng-model=\"employee.calculations.REAL[incidenceId]\"></span><span \nng-if=\"operation.status>=opStatusNotCalc || operation.employees[employee.$id].status>=nextEmployeeStatus\"><span \nclass=\"greenC\" ng-if=\'F.incidenceTypeData[incidenceId].affect==\"days\"\'>\n{{fastIncidenceByType[employee.$id].value}} dia(s)</span> <span class=\"greenC\" \nng-if=\'F.incidenceTypeData[incidenceId].affect==\"salary\" && !F.incidenceTypeData[incidenceId].customCalc\'>\n{{fastIncidenceByType[employee.$id].value | currency}}</span> <span class=\"greenC\" \nng-if=\'F.incidenceTypeData[incidenceId].affect==\"salary\" && F.incidenceTypeData[incidenceId].customCalc\'>\n{{fastIncidenceByType[employee.$id].value | number}}</span></span><md-input-container \nng-if=\"operation.status < 3 && operation.employees[employee.$id].status<nextEmployeeStatus\" md-no-float><input \nng-if=\'F.incidenceTypeData[incidenceId].affect==\"days\"\' type=\"number\" ignore-mouse-wheel min=\"0\" class=\"greenC\" \nng-model=\"fastIncidenceByType[employee.$id].value\" ng-disabled=\"readOnlyMode\" placeholder=\"dia(s)\" \naria-label=\"incidence value\" \nng-change=\"saveFastIncidence(fastIncidenceByType[employee.$id],employee.$id,incidenceId,employee.calculations.REAL.workedDays.data.activeDays,F.incidencesByEmployee[employee.$id])\" \nng-model-options=\"{ debounce: F.debounceTime }\" tabindex=\"{{$index+1}}000\"> <input \nng-if=\'F.incidenceTypeData[incidenceId].affect==\"salary\" && !F.incidenceTypeData[incidenceId].customCalc\' \ntype=\"number\" ignore-mouse-wheel min=\"0\" class=\"greenC\" ng-model=\"fastIncidenceByType[employee.$id].value\" \nng-disabled=\"readOnlyMode\" placeholder=\"$\" aria-label=\"incidence value\" \nng-change=\"saveFastIncidence(fastIncidenceByType[employee.$id],employee.$id,incidenceId,employee.calculations.REAL.workedDays.data.activeDays,F.incidencesByEmployee[employee.$id])\" \nng-model-options=\"{ debounce: F.debounceTime }\" tabindex=\"{{$index+1}}000\"> <input \nng-if=\'F.incidenceTypeData[incidenceId].affect==\"salary\" && F.incidenceTypeData[incidenceId].customCalc\' type=\"number\" \nignore-mouse-wheel min=\"0\" class=\"greenC\" ng-model=\"fastIncidenceByType[employee.$id].value\" \nng-disabled=\"readOnlyMode\" placeholder=\"$\" aria-label=\"incidence value\" \nng-change=\"saveFastIncidence(fastIncidenceByType[employee.$id],employee.$id,incidenceId,employee.calculations.REAL.workedDays.data.activeDays,F.incidencesByEmployee[employee.$id])\" \nng-model-options=\"{ debounce: F.debounceTime }\" tabindex=\"{{$index+1}}000\"></md-input-container></td><td><span \nsheet-perceptions-real calculations=\"employee.calculations.REAL\" employee-id=\"employee.$id\" \nnot-calculate=\"operation.status>=opStatusNotCalc\" \ndataloaded=\"[F.operationDataNeeded.REAL[employee.$id].fourth,F.operationDataNeeded.REAL[employee.$id].fifth]\" \nconstants=\"constantIncidences.affectIncidenceProperty[employee.$id]\" directive-functions=\"directiveFunctions\" \nprocess=\"REAL\" ng-model=\"employee.calculations.REAL.perceptions\">\n{{employee.calculations.REAL.perceptions.data.onlyIncidencesAmount | currency}}</span></td><td \nng-repeat=\"(incidenceId, incidenceByType) in normalIncidencesByTypeD\"><span \nng-if=\'F.activeDirectiveMap[incidenceId][employee.$id].active==\"normal\" && F.incidenceTypeData[incidenceId].directive == \"010DR\"\' \nsheet-employee-infonavit credit=\"employee.credit\" incidence-id=\"incidenceId\" operation=\"operationData\" \ndaily-salary=\"employee.calculations.REAL.daily_salary\" incidences-types=\"F.incidencesTypes\" employee-id=\"employee.$id\" \nincidences=\"allIncidencesByType[incidenceId][employee.$id]\" not-calculate=\"operation.status>=opStatusNotCalc\" \ndataloaded=\"[F.operationDataNeeded.REAL[employee.$id].fourth]\" \nconstants=\"constantIncidences.affectIncidenceProperty[employee.$id]\" nfd-record=\"nfdRecord\" \ndirective-functions=\"directiveFunctions\" process=\"REAL\" employee-name=\"employee.data.name\" \nng-model=\"employee.calculations.REAL[incidenceId]\"><span class=\"redC\">-</span> <span class=\"redC\" \nng-bind=\"employee.calculations.REAL[incidenceId].value.totalFormat\"></span> </span><span \nng-if=\'F.activeDirectiveMap[incidenceId][employee.$id].active==\"normal\" && F.incidenceTypeData[incidenceId].directive == \"001DRF\"\' \nsheet-absences class=\"redC\" sd=\"employee.data.salary.sdr\" incidence-id=\"incidenceId\" \nincidences-types=\"F.incidencesTypes\" incidences=\"allIncidencesByType[incidenceId][employee.$id]\" \nemployee-id=\"employee.$id\" not-calculate=\"operation.status>=opStatusNotCalc\" \ndataloaded=\"[F.operationDataNeeded.REAL[employee.$id].fourth]\" \nconstants=\"constantIncidences.affectIncidenceProperty[employee.$id]\" directive-functions=\"directiveFunctions\" \nprocess=\"REAL\" ng-model=\"employee.calculations.REAL[incidenceId]\"><span>-</span> <span \nng-bind=\"employee.calculations.REAL[incidenceId].value.normalTotal\"></span> <span>dias(s)</span> </span><span \nng-if=\'F.activeDirectiveMap[incidenceId][employee.$id].active==\"normal\" && !(F.incidenceTypeData[incidenceId].directive)\' \nsheet-simple-deduction incidences=\"allIncidencesByType[incidenceId][employee.$id]\" incidence-id=\"incidenceId\" \nincidences-types=\"F.incidencesTypes\" \nconstants-by-value=\"constantIncidences.affectIncidenceValue[incidenceId][employee.$id]\" \nconstants-by-total=\"constantIncidences.affectIncidenceTotal[incidenceId][employee.$id]\" calc-fields=\"L.calcFields\" \nemployee=\"employee\" payroll=\"payroll\" operation=\"operation\" minimum-variables=\"minimumVariables\" \numa-record=\"umaRecord\" nfd-record=\"nfdRecord\" employee-id=\"employee.$id\" \nnot-calculate=\"operation.status>=opStatusNotCalc\" dataloaded=\"[F.operationDataNeeded.REAL[employee.$id].fourth]\" \nconstants=\"constantIncidences.affectIncidenceProperty[employee.$id]\" directive-functions=\"directiveFunctions\" \nprocess=\"REAL\" ng-model=\"employee.calculations.REAL[incidenceId]\"><span class=\"orangeC\" \nng-if=\"F.incidenceTypeData[incidenceId].customCalc\"><span ng-bind=\"normalValue\"></span> <span>-> </span></span><span \nclass=\"redC\">-</span> <span class=\"redC\" ng-bind=\"employee.calculations.REAL[incidenceId].value.normalTotalFormat\">\n</span> <span class=\"redC\" ng-if=\'F.incidenceTypeData[incidenceId].affect==\"days\"\'>dia(s)</span> </span><span \nng-if=\'F.activeDirectiveMap[incidenceId][employee.$id].active==\"none\"||F.activeDirectiveMap[incidenceId][employee.$id].active==\"fast\"\' \nclass=\"redC\"><span ng-if=\'F.incidenceTypeData[incidenceId].affect==\"salary\"\'>{{0|currency}}</span> <span \nng-if=\'F.incidenceTypeData[incidenceId].affect==\"days\"\'>0</span></span></td><td \nng-class=\"{\'withInput\':operation.status < 3 && operation.employees[employee.$id].status<nextEmployeeStatus}\" \nng-repeat=\"(incidenceId, fastIncidenceByType) in fastIncidencesByTypeD\"><span ng-show=\"false\" \nng-if=\'F.activeDirectiveMap[incidenceId][employee.$id].active==\"fast\" && F.incidenceTypeData[incidenceId].directive == \"001DRF\"\' \nsheet-absences sd=\"employee.data.salary.sdr\" incidence-id=\"incidenceId\" incidences-types=\"F.incidencesTypes\" \nincidences=\"allIncidencesByType[incidenceId][employee.$id]\" employee-id=\"employee.$id\" \nnot-calculate=\"operation.status>=opStatusNotCalc\" dataloaded=\"[F.operationDataNeeded.REAL[employee.$id].fourth]\" \nconstants=\"constantIncidences.affectIncidenceProperty[employee.$id]\" directive-functions=\"directiveFunctions\" \nprocess=\"REAL\" ng-model=\"employee.calculations.REAL[incidenceId]\"></span><span ng-show=\"false\" \nng-if=\'F.activeDirectiveMap[incidenceId][employee.$id].active==\"fast\" && !(F.incidenceTypeData[incidenceId].directive)\' \nsheet-simple-deduction class=\"orangeC\" incidences=\"allIncidencesByType[incidenceId][employee.$id]\" \nincidences-types=\"F.incidencesTypes\" incidence-id=\"incidenceId\" \nconstants-by-value=\"constantIncidences.affectIncidenceValue[incidenceId][employee.$id]\" \nconstants-by-total=\"constantIncidences.affectIncidenceTotal[incidenceId][employee.$id]\" calc-fields=\"L.calcFields\" \nemployee=\"employee\" payroll=\"payroll\" operation=\"operation\" minimum-variables=\"minimumVariables\" \numa-record=\"umaRecord\" nfd-record=\"nfdRecord\" employee-id=\"employee.$id\" \nnot-calculate=\"operation.status>=opStatusNotCalc\" dataloaded=\"[F.operationDataNeeded.REAL[employee.$id].fourth]\" \nconstants=\"constantIncidences.affectIncidenceProperty[employee.$id]\" directive-functions=\"directiveFunctions\" \nprocess=\"REAL\" ng-model=\"employee.calculations.REAL[incidenceId]\"></span><span \nng-if=\"operation.status>=opStatusNotCalc || operation.employees[employee.$id].status>=nextEmployeeStatus\"><span \nclass=\"orangeC\" ng-if=\'F.incidenceTypeData[incidenceId].affect==\"days\"\'>\n{{fastIncidenceByType[employee.$id].value}} dia(s)</span> <span class=\"orangeC\" \nng-if=\'F.incidenceTypeData[incidenceId].affect==\"salary\" && !F.incidenceTypeData[incidenceId].customCalc\'>\n{{fastIncidenceByType[employee.$id].value| currency}}</span> <span class=\"orangeC\" \nng-if=\'F.incidenceTypeData[incidenceId].affect==\"salary\" && F.incidenceTypeData[incidenceId].customCalc\'>\n{{fastIncidenceByType[employee.$id].value}}</span></span><md-input-container \nng-if=\"operation.status<opStatusNotCalc && operation.employees[employee.$id].status<nextEmployeeStatus\" md-no-float>\n<input ng-if=\'F.incidenceTypeData[incidenceId].affect==\"days\"\' type=\"number\" ignore-mouse-wheel class=\"orangeC\" \nng-model=\"fastIncidenceByType[employee.$id].value\" ng-disabled=\"readOnlyMode\" placeholder=\"dia(s)\" min=\"0\" \nmax=\"{{employee.calculations.REAL.workedDays.data.realWorkedDays-employee.calculations.REAL.workedDays.data.holidays-employee.calculations.REAL.workedDays.data.normalAbscences}}\" \nng-change=\"saveFastIncidence(fastIncidenceByType[employee.$id],employee.$id,incidenceId,employee.calculations.REAL.workedDays.data.activeDays,F.incidencesByEmployee[employee.$id])\" \nng-model-options=\"{ debounce: F.debounceTime }\" tabindex=\"{{$index+1}}00\"> <input \nng-if=\'F.incidenceTypeData[incidenceId].affect==\"salary\" && !F.incidenceTypeData[incidenceId].customCalc\' \ntype=\"number\" ignore-mouse-wheel class=\"orangeC\" min=\"0\" ng-model=\"fastIncidenceByType[employee.$id].value\" \nplaceholder=\"$\" ng-disabled=\"readOnlyMode\" aria-label=\"incidence value\" \nng-change=\"saveFastIncidence(fastIncidenceByType[employee.$id],employee.$id,incidenceId,employee.calculations.REAL.workedDays.data.activeDays,F.incidencesByEmployee[employee.$id])\" \nng-model-options=\"{ debounce: F.debounceTime }\" tabindex=\"{{$index+1}}00\"> <input \nng-if=\'F.incidenceTypeData[incidenceId].affect==\"salary\" && F.incidenceTypeData[incidenceId].customCalc\' type=\"number\" \nignore-mouse-wheel class=\"orangeC\" min=\"0\" ng-model=\"fastIncidenceByType[employee.$id].value\" \nng-disabled=\"readOnlyMode\" aria-label=\"incidence value\" \nng-change=\"saveFastIncidence(fastIncidenceByType[employee.$id],employee.$id,incidenceId,employee.calculations.REAL.workedDays.data.activeDays,F.incidencesByEmployee[employee.$id])\" \nng-model-options=\"{ debounce: F.debounceTime }\" tabindex=\"{{$index+1}}000\"></md-input-container></td><td><span \nsheet-deductions-real calculations=\"employee.calculations.REAL\" employee-id=\"employee.$id\" \nnot-calculate=\"operation.status>=opStatusNotCalc\" \ndataloaded=\"[F.operationDataNeeded.REAL[employee.$id].fourth,F.operationDataNeeded.REAL[employee.$id].fifth]\" \nconstants=\"constantIncidences.affectIncidenceProperty[employee.$id]\" directive-functions=\"directiveFunctions\" \nprocess=\"REAL\" ng-model=\"employee.calculations.REAL.deductions\">\n-{{employee.calculations.REAL.deductions.data.onlyIncidencesAmount | currency}}</span></td><td><strong \nsheet-total-real base-real-salary=\"employee.calculations.REAL.salary.value.total\" \ntotal-perceptions=\"employee.calculations.REAL.perceptions.value.total\" \ntotal-deductions=\"employee.calculations.REAL.deductions.value.total\" employee-id=\"employee.$id\" \nnot-calculate=\"operation.status>=opStatusNotCalc\" dataloaded=\"[F.operationDataNeeded.REAL[employee.$id].sixth]\" \nconstants=\"constantIncidences.affectIncidenceProperty[employee.$id]\" directive-functions=\"directiveFunctions\" \nprocess=\"REAL\" ng-model=\"employee.calculations.REAL.netRealSalary\">\n{{employee.calculations.REAL.netRealSalary.value.total | currency}}</strong></td></tr></tbody><tfoot><tr \nclass=\"totales\"><th colspan=\"1\">Totales</th><th colspan=\"2\"></th><th colspan=\"1\">\n{{employeesF|getTotalOfArrayField:\'calculations.REAL.salary.value.total\'|currency}}</th><th \nng-repeat=\"(incidenceId, incidenceByType) in normalIncidencesByTypeP\"><span class=\"blueC\">\n{{F.incidenceTypeData[incidenceId].showTotal?((employeesF|getTotalOfArrayField:\'calculations.REAL.\'+incidenceId+\'.value.normalTotal\')|currency):\"&nbsp;\"}}\n</span></th><th ng-repeat=\"(incidenceId, incidenceByType) in fastIncidencesByTypeP\"><span class=\"greenC\">\n{{F.incidenceTypeData[incidenceId].showTotal?((employeesF|getTotalOfArrayField:\'calculations.REAL.\'+incidenceId+\'.value.fastTotal\')|currency):\"&nbsp;\"}}\n</span></th><th>{{employeesF|getTotalOfArrayField:\'calculations.REAL.perceptions.data.onlyIncidencesAmount\'|currency}}\n</th><th ng-repeat=\"(incidenceId, incidenceByType) in normalIncidencesByTypeD\"><span class=\"redC\" \nng-if=\'!(F.incidenceTypeData[incidenceId].affect==\"days\")\'>\n{{F.incidenceTypeData[incidenceId].showTotal?((employeesF|getTotalOfArrayField:\'calculations.REAL.\'+incidenceId+\'.value.normalTotal\')|currency):\"&nbsp;\"}} \n</span><span class=\"redC\" ng-if=\'F.incidenceTypeData[incidenceId].affect==\"days\"\'>\n{{F.incidenceTypeData[incidenceId].showTotal?(employeesF|getTotalOfArrayField:\'calculations.REAL.\'+incidenceId+\'.value.normalTotal\') + \" dia(s)\":\"&nbsp;\"}}\n</span></th><th ng-repeat=\"(incidenceId, incidenceByType) in fastIncidencesByTypeD\"><span class=\"orangeC\" \nng-if=\'!(F.incidenceTypeData[incidenceId].affect==\"days\")\'>\n{{F.incidenceTypeData[incidenceId].showTotal?((employeesF|getTotalOfArrayField:\'calculations.REAL.\'+incidenceId+\'.value.fastTotal\')|currency):\"&nbsp;\"}} \n</span><span class=\"orangeC\" ng-if=\'F.incidenceTypeData[incidenceId].affect==\"days\"\'>\n{{F.incidenceTypeData[incidenceId].showTotal?(employeesF|getTotalOfArrayField:\'calculations.REAL.\'+incidenceId+\'.value.fastTotal\') + \" dia(s)\":\"&nbsp;\"}}\n</span></th><th>{{employeesF|getTotalOfArrayField:\'calculations.REAL.deductions.data.onlyIncidencesAmount\'|currency}}\n</th><th>{{employeesF|getTotalOfArrayField:\'calculations.REAL.netRealSalary.value.total\'|currency}}</th></tr></tfoot>\n</table></div></md-tab-body>");
$templateCache.put("app/main/clients/views/operation/tabs/rejected-incidences.html","<md-tab-body id=\"table_rejected_incidences\" layout=\"column\"><div class=\"filterToolbar no-paddingTB\"><div layout=\"row\" \nlayout-align=\"space-between center\"><md-input-container class=\"md-block\" flex md-no-float><input \nng-model-options=\"{ debounce: F.debounceTime }\" placeholder=\"Filtrar Empleados\" class=\"search-input whitePlaceholder\" \ntype=\"text\" flex ng-model=\"search.employee\"></md-input-container></div></div><div><md-table-container \nclass=\"max-height-data-table\"><table md-table md-row-select=\"false\" multiple=\"false\" ng-model=\"selected\" \nclass=\"row-border\"><thead md-head md-order=\"order\" fix-head><tr md-row><th md-column md-order-by=\"data.name\" \nclass=\"text-left\"><span>Nombre</span></th><th md-column><span>Incidencia</span></th><th md-column><span>Monto</span>\n</th></tr></thead><tbody md-body \nng-repeat=\"incidences in (rejectedIncidences=(F.fixIncidences.rejectedIncidences|objsToArray)) | orderBy:order\"><tr \nmd-row ng-repeat=\"(key,incidence) in incidences\"><td style=\"padding:10px\">\n{{incidences.$id|getSomethingOfArrayFB:employeesF:\"data.name\"}}</td><td>{{F.incidenceTypeData[key].name}}</td><td>\n{{incidence.value}}</td></tr></tbody></table></md-table-container><div style=\"clear:both\"></div></div></md-tab-body>");
$templateCache.put("app/main/clients/views/operations/dialogs/bottom-list-grid.html","<md-bottom-sheet class=\"md-list md-has-header bottomList\"><md-subheader ng-cloak><span flex>\nOperaciones del Periodo {{calendarYear}}-{{period.period}}</span><md-button \nng-click=\'addOperationModal($event, calendarYear, period.period, \"ordinary\")\' ng-if=\"!operations.length\" \nclass=\"md-icon-button md-fav md-primary md-hue-2 md-mini\" aria-label=\"Agregar Operación\"><md-tooltip \nmd-direction=\"top\">Agregar Operación Ordinaria</md-tooltip><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button>\n</md-subheader><md-content layout-fill stop-touch-event><md-table-container><table md-table id=\"OperationsOfPeriod\" \nclass=\"row-border\"><thead md-head><tr md-row><th md-column><span>Operación</span></th><th md-column \nclass=\"iconTableCell\" ng-repeat=\"status in F.operationStatatuss\" ng-if=\"status.id != 0\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" aria-label=\"{{status.name | uppercase}}\"><md-tooltip \nmd-direction=\"top\">{{status.name | uppercase}}</md-tooltip><md-icon md-font-icon=\"{{status.icon}}\"></md-icon>\n</md-button></div></th><th md-column><span>Acciones</span></th></tr></thead><tbody md-body><tr md-row \nng-repeat=\"operation in operations\"><td md-cell><a ng-if=\"operation.status\" \nng-click=\'allowToAcces(operation,allOperations,3)?goToOperation(operation, \"ordinary\"):\"\"\'>\n{{\'t.\' + operation.type | translate}} - {{operation.$id}} </a><span ng-if=\"!operation.status\" \nclass=\"operationCancelled\">{{\'t.\' + operation.type | translate}} - {{operation.$id}}</span></td><td md-cell \nclass=\"iconTableCell textCentered\" colspan=\"10\" ng-if=\"!operation.status\">Operación Cancelada</td><td md-cell \nclass=\"iconTableCell\" ng-repeat=\"status in F.operationStatatuss\" ng-if=\"status.id !== 0 && operation.status !== 0\"><div\n layout=\"row\" layout-align=\"start center\"><md-button ng-if=\"operation.status >= status.id\" \nclass=\"md-icon-button md-primary md-hue-2\" aria-label=\"ok\"><md-tooltip md-direction=\"top\">Se completo este status\n</md-tooltip><md-icon md-font-icon=\"icon-check-circle\"></md-icon></md-button><md-button \nng-if=\"operation.status < status.id && (period.start|isGratherThan:today)\" class=\"md-icon-button\" aria-label=\"waiting\">\n<md-tooltip md-direction=\"top\">Esperando</md-tooltip><md-icon md-font-icon=\"icon-checkbox-blank-circle-outline\">\n</md-icon></md-button><md-button ng-if=\"operation.status < status.id && !(period.start | isGratherThan:today)\" \nclass=\"md-icon-button md-warn md-hue-2\" aria-label=\"atention needed\"><md-tooltip md-direction=\"top\">\nRequiere atencion de usuario</md-tooltip><md-icon md-font-icon=\"icon-alert\"></md-icon></md-button></div></td><td \nmd-cell><div layout=\"row\" layout-align=\"start center\"><md-menu target mode with md-offset \nmd-position-mode=\"target-right target\"><md-button aria-label=\"open operation single actions\" class=\"md-icon-button\" \nng-click=\"openOperationMenu($mdOpenMenu, $event)\"><md-icon md-font-icon=\"icon-menu-down\" aria-label=\"options icon\">\n</md-icon></md-button><md-menu-content width=\"4\"><md-menu-item><md-button \nng-disabled=\"operation.status < 6 || operation.status != 0 || !(period.start | isGratherThan:today)\" with-permission \naction=\"cancel\" access=\"{{F.active.menuItem}}\" ng-click=\"cancelOperationModal($event, operation)\" aria-label=\"cancel\">\n<md-icon md-font-icon=\"icon-close\"></md-icon>Cancelar</md-button></md-menu-item><md-menu-item><md-button \nng-disabled=\"operation.dispersion\" class=\"btnHasTooltip\" with-permission action=\"remove\" \naccess=\"{{F.active.menuItem}}\" ng-click=\"removeModal($event, operation)\" aria-label=\"cancel\"><md-tooltip \nmd-direction=\"left\" ng-if=\"operation.dispersion\">\nLa operación tiene una dispersión asociada, por lo tanto no podrá ser borrada</md-tooltip><md-icon \nmd-font-icon=\"icon-delete\"></md-icon><span flex>Borrar</span></md-button></md-menu-item></md-menu-content></md-menu>\n</div></td></tr></tbody></table></md-table-container></md-content></md-bottom-sheet>");
$templateCache.put("app/main/clients/views/operations/dialogs/change-period.html","<md-dialog aria-label=\"Change Period Operation\" class=\"close-operation\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nMover acumulados de la operación</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"hide()\" \nng-if=\"!retry\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><div><h3 class=\"mt-0\">Periodo actual de acumulados {{(calendar)?calendar:operation.calendar}}</h3>\n<h3>Calendario: <b>{{operation.calendar}}</b> Periodo: <b>{{operation.period}}</b></h3></div><div><form name=\"form\">\n<fieldset><legend>Seleccione el periodo en el que se va a acumular la operación</legend><md-input-container \nclass=\"md-block\"><label>Periodo</label><md-select ng-model=\"periodSelected\" required name=\"date\" \nng-change=\"setMinMaxPaymentDate(periodSelected,true)\" placeholder=\"Seleccione un periodo\"><md-option ng-value=\"period\" \nng-repeat=\"period in periods track by period.accuDate\">Periodo {{period.period}} <strong>[{{period.calendar}}]</strong>\n - {{period.start|date:\'mediumDate\'}} - {{period.end|date:\'mediumDate\'}}</md-option></md-select><div \nng-messages=\"form.date.$error\" role=\"alert\"><div ng-message=\"required\">El periodo es requerido</div></div>\n</md-input-container></fieldset><fieldset><legend>\nSeleccione la fecha de pago, esta debe estar en el rango en el cual se va a acumular</legend><md-input-container \nclass=\"md-block date-picker mb-0\" flex><label>Fecha de pago</label><md-datepicker md-hide-icons=\"triangle\" \nmd-current-view=\"{{F.dateView}}\" input-date-miliseconds ng-model=\"changePeriod.paymentDate\" name=\"paymentDate\" \nmd-min-date=\"minPaymentDate\" md-max-date=\"maxPaymentDate\" class=\"md-block\"></md-datepicker><div \nng-messages=\"form.paymentDate.$error\" role=\"alert\"><div ng-message=\"min\">\nFecha de Alta debe ser a partir de {{minPaymentDate | date}}</div><div ng-message=\"max\">\nFecha de Alta debe ser antes de {{maxPaymentDate | date}}</div><div ng-message=\"mindate\">\nFecha de Alta debe ser a partir de {{minPaymentDate | date}}</div><div ng-message=\"maxdate\">\nFecha de Alta debe ser antes de {{maxPaymentDate | date}}</div></div></md-input-container></fieldset></form></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button class=\"md-accent md-raised md-warn\" ng-click=\"cancel()\" \nng-disabled=\"disableButtons\">Cancelar</md-button><md-button class=\"md-accent md-raised md-primary\" \nng-click=\"moveCalculations(periodSelected,changePeriod.paymentDate)\" ng-disabled=\"form.$invalid || disableButtons\">\nAceptar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/clients/views/operations/dialogs/close-operation.html","<md-dialog aria-label=\"modal Close Operation\" class=\"settlements\" style=\"width: 350px\"><form name=\"form\"><md-toolbar>\n<div class=\"md-toolbar-tools\"><h2 flex>Fecha de cierre de la operación</h2><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close Dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><md-input-container class=\"md-block date-picker\" flex>\n<label>Fecha de cierre</label><md-datepicker md-hide-icons=\"triangle\" md-current-view=\"{{F.dateView}}\" \ninput-date-miliseconds required ng-model=\"operation.date\" name=\"date\" md-min-date=\"minDate\" md-max-date=\"maxDate\" \nng-disabled=\"F.readMode\" class=\"md-block\"></md-datepicker><div ng-messages=\"form.date.$error\" \nng-show=\"form.date.$touched || form.date.$dirty\" role=\"alert\"><div ng-message=\"required\">Fecha de cierre es requerido\n</div></div></md-input-container><div flex><div layout-gt-xs><div flex=\"nogrow\"><md-button \nng-disabled=\"form.pending || form.$invalid || loadingProgress\" ng-click=\"save(operation)\" \nclass=\"md-primary md-raised btn-add\" aria-label=\"Add item\"><md-tooltip md-direction=\"top\">{{\'EC.SAVE\' | translate}}\n</md-tooltip><md-icon md-font-icon=\"icon-content-save\" aria-label=\"Save\"></md-icon></md-button></div></div></div></div>\n</md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/clients/views/operations/dialogs/employees-dispersion.html","<md-dialog><form name=\"form\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 flex>Generar Layout</h2><md-button \nclass=\"md-icon-button\" ng-click=\"close()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close Dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><md-input-container class=\"md-block evenPadding\" flex><label>Proceso\n</label><md-select ng-model=\"employeesDispersion.process\" ng-change=\"employeesDispersion.getBanks()\" name=\"process\" \nrequired><md-option ng-value=\"process\" ng-repeat=\"process in employeesDispersion.processes\">{{process.name}}\n</md-option></md-select><div ng-messages=\"form.process.$error\" role=\"alert\"><div ng-message=\"required\">\nProceso es requerido</div></div></md-input-container><md-input-container class=\"md-block evenPadding\" flex><label>\nCuenta</label><md-select ng-model=\"employeesDispersion.bankAccount\" name=\"bankAccount\" \nng-change=\"employeesDispersion.addDateIfNeeded(employeesDispersion.bankAccount)\" required><md-option \nng-value=\"bankAccount\" ng-repeat=\"bankAccount in employeesDispersion.payrollBanks\">\n{{bankAccount.name}} {{bankAccount.isSpei?\' SPEI\':\'\'}}</md-option></md-select><div \nng-messages=\"form.bankAccount.$error\" role=\"alert\"><div ng-message=\"required\">Banco es requerido</div></div>\n</md-input-container><md-input-container class=\"md-block date-picker mb-0\" flex ng-if=\"employeesDispersion.dateNeeded\">\n<label>Fecha</label><md-datepicker md-min-date=\"employeesDispersion.minDate\" md-hide-icons=\"triangle\" \ninput-date-miliseconds ng-model=\"employeesDispersion.applicationDate\" name=\"applicationDate\" \nmd-date-filter=\"employeesDispersion.onlyWeekendsPredicate\" required></md-datepicker><div \nng-messages=\"form.applicationDate.$error\" role=\"alert\"><div ng-message=\"required\">La fecha es requerida</div></div>\n</md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" layout=\"end center\"><md-button \nng-disabled=\"form.$invalid || employeesDispersion.loading\" ng-click=\"employeesDispersion.generateDispersionLayout()\">\nGenerar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/clients/views/operations/dialogs/forceBills.html","<md-dialog id=\"ForceBills\" flex=\"30\" flex-xs=\"100\" flex-sm=\"50\" flex-md=\"40\" flex-lg=\"35\"><form name=\"form\" novalidate \nng-cloak><md-toolbar ng-if=\"cpyctrl.employeeError.length > 0\"><h2 class=\"text-left pl-10\">\n¿Está seguro de que desea marcar esta operación como timbrada?</h2></md-toolbar><md-dialog-content><md-table-container \nng-if=\"cpyctrl.employeeError.length > 0\"><table md-table class=\"custom-table\"><thead md-head><tr><th><span>\nNombre del empleado</span></th><th><span>Error</span></th></tr></thead><tbody md-body><tr \nng-repeat=\"error in cpyctrl.employeeError\"><td>{{error.name}}</td><td>{{error.error}}<md-tooltip md-direction=\"top\">\n<span>{{error.msgError}}</span></md-tooltip></td></tr></tbody></table></md-table-container><div \nng-if=\"cpyctrl.employeeError.length === 0\"><h1 style=\"text-align: center\">\nNo se puede marcar la operación como timbrada.</h1></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"end center\"><div flex=\"nogrow\" ng-if=\"cpyctrl.employeeError.length > 0\" class=\"mr-4\"><img \nsrc=\"adver.gif\" width=\"40px\" height=\"40px\" alt=\"\"><md-button class=\"md-raised md-primary\" \nng-click=\"cpyctrl.saveBills()\">Guardar</md-button></div><div flex=\"nogrow\"><md-button class=\"md-raised\" \nng-click=\"cpyctrl.close()\">Cancelar</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/clients/views/operations/dialogs/import-calculationsv2.html","<md-dialog stop-touch-event aria-label=\"Import Calculations\" class=\"importDialog\"><form name=\"stepper\" \nclass=\"importEmployees\" ms-stepper ng-submit=\"impCalcCtrl.applyCalculations()\" ng-model=\"stepper\" novalidate><div \nng-if=\"impCalcCtrl.loading\"><md-progress-linear md-mode=\"indeterminate\"></md-progress-linear><span class=\"md-subhead\">\nCargando..</span></div><div><ms-stepper-step ng-form=\"step1\" step=\"1\" step-title=\"\'Sube el archivo\'\"><div \nng-include=\"\'app/main/clients/views/operations/dialogs/step-1.html\'\"></div></ms-stepper-step><ms-stepper-step \nng-form=\"step2\" step=\"2\" step-title=\"\'Conceptos a exportar\'\"><div \nng-include=\"\'app/main/clients/views/operations/dialogs/step-2.html\'\"></div></ms-stepper-step></div></form></md-dialog>");
$templateCache.put("app/main/clients/views/operations/dialogs/step-1.html","<div class=\"md-inline-form\"><div style=\"max-height: 500px;overflow: auto\"><md-input-container \nclass=\"md-block no-errors-spacer\"><label>Empresa</label><md-select ng-model=\"impCalcCtrl.companiesRecord\" \nname=\"companiesRecord\" required><md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" \nng-keydown=\"$event.stopPropagation()\" ng-model=\"companiesRecordSelectFilter\" placeholder=\"Busque una empresa\">\n</md-select-header><md-option ng-value=\"companiesRecord.$id\" \nng-repeat=\"companiesRecord in impCalcCtrl.L.companiesRecords | orderBy:\'class\' | filter:companiesRecordSelectFilter\">\n{{companiesRecord.name}}</md-option></md-select><div ng-messages=\"step1.companiesRecord.$error\" role=\"alert\"><div \nng-message=\"required\">Empresa es requerido</div></div></md-input-container><md-input-container \nclass=\"md-block no-errors-spacer\"><label>Nomina</label><md-select ng-model=\"impCalcCtrl.payroll\" name=\"payroll\" \nng-change=\"impCalcCtrl.checkOtherExports(impCalcCtrl.payroll)\" required><md-select-header><input autocomplete=\"off\" \ntype=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"payrollSelectFilter\" \nplaceholder=\"Busque una nomina\"></md-select-header><md-option ng-if=\"!impCalcCtrl.permissionToAccessAllPayrolls\" \nng-class=\"{\'inactiveOption\': !payroll.active}\" ng-value=\"payroll.$id\" \nng-repeat=\"payroll in impCalcCtrl.L.payrolls | orderBy:\'name\' | filter:payrollSelectFilter\" \nng-bind=\"payroll.class+\' \'+payroll.name\"></md-option><md-option ng-if=\"impCalcCtrl.permissionToAccessAllPayrolls\" \nng-class=\"{\'inactiveOption\': !payroll.active}\" ng-value=\"payroll.$id\" \nng-repeat=\"payroll in impCalcCtrl.L.allPayrolls | orderBy:\'name\' | filter:payrollSelectFilter\" \nng-bind=\"payroll.class+\' \'+payroll.name\"></md-option></md-select><div ng-messages=\"step1.payroll.$error\" role=\"alert\">\n<div ng-message=\"required\">Nomina es requerido</div></div></md-input-container><md-input-container \nclass=\"md-block no-errors-spacer\"><md-select ng-model=\"impCalcCtrl.operationType\" placeholder=\"Tipo de operación\" \nname=\"operationType\"><md-option ng-value=\"undefined\">Ordinaria</md-option><md-option ng-value=\"thisOperationType.id\" \nng-repeat=\"thisOperationType in impCalcCtrl.operationTypes\">{{thisOperationType.name}}</md-option></md-select><div \nng-messages=\"step1.operationType.$error\" role=\"alert\"><div ng-message=\"required\">Tipo de operación</div></div>\n</md-input-container><div><lf-ng-md-file-input lf-files=\"impCalcCtrl.filesArray\" \nlf-placeholder=\"Selecciona el archivo csv\" lf-drag-and-drop-label=\"csv - Max: 10MB\" \nlf-browse-label=\"{{\'EC.search\' | translate}}\" lf-remove-label=\"{{\'EC.remove\' | translate}}\" lf-filesize=\"10MB\" \nlf-required accept=\"text/csv\" lf-mimetype=\"text/csv\" name=\"operationFile\" lf-api=\"csvApi\"></lf-ng-md-file-input><div \nng-messages=\"step1.operationFile.$error\" style=\"color:red\"><div ng-message=\"required\">Archivo requerido</div><div \nng-message=\"maxcount\">Demasiados archivos</div><div ng-message=\"filesize\">Archivo demasiado grande</div><div \nng-message=\"totalsize\">Espacio total demasiado grande</div><div ng-message=\"mimetype\">Formato de archivo no valido\n</div></div></div><div layout=\"row\"><span flex></span> <a class=\"downloadLink\" target=\"_blanc\" \nhref=\"assets/csv/import-calculations-v2-blanc.csv\">Descargar template<md-icon md-font-icon=\"icon-file-excel\" \naria-label=\"download variables template\"></md-icon></a></div><code style=\"text-align: justify\" ng-if=\"!operationFile\">\nEmpleado, Fecha, Dias_trabajados, Sueldo, Subsidio_Entregado, Subsidio_Reportado, ISR, ISR_PTU, CYV, IMSS_No_CYV, Base_Gravable, Percepcion/Gravado, Percepcion/Exento, Deduccion/TotalD, Neto\n</code><md-list ng-if=\"impCalcCtrl.importAccuRecords.length>0\" class=\"md-dense\"><md-subheader class=\"md-no-sticky\">\nExportaciones anteriores</md-subheader><md-list-item \nng-repeat=\"importAccuRecord in impCalcCtrl.importAccuRecords | orderBy : \'-created.atTime\'\"><p flex><strong>\n{{importAccuRecord.companiesRecordName}}</strong>\n {{importAccuRecord.total}} Registro(s) [{{importAccuRecord.accuDate}}] {{ importAccuRecord.created.atTime | date:impCalcCtrl.dateFormat }}\n</p><span ng-if=\"importAccuRecord.showConfirm\" flex=\"nogrow\">¿Desea eliminar esta importación?</span><md-icon \nmd-font-icon=\"icon-trash\" ng-if=\"!importAccuRecord.showConfirm\" ng-click=\"importAccuRecord.showConfirm=true\" \naria-label=\"delete import options\" class=\"md-secondary md-hue-3\"></md-icon><md-icon md-font-icon=\"icon-check\" \nng-if=\"importAccuRecord.showConfirm\" ng-disabled=\"impCalcCtrl.loading\" \nng-click=\"impCalcCtrl.deleteImport(importAccuRecord)\" aria-label=\"delete import\" \nclass=\"md-secondary md-accent md-hue-2\"></md-icon><md-icon md-font-icon=\"icon-close\" \nng-if=\"importAccuRecord.showConfirm\" ng-disabled=\"impCalcCtrl.loading\" ng-click=\"importAccuRecord.showConfirm=false\" \naria-label=\"delete import\" class=\"md-secondary md-warn md-hue-2\"></md-icon></md-list-item></md-list></div></div>");
$templateCache.put("app/main/clients/views/operations/dialogs/step-2.html","<div><input type=\"hidden\" name=\"headersHasError\" ng-model=\"headersHasError\" ng-required=\"impCalcCtrl.headersError\"><div\n style=\"max-height: 500px;overflow: auto\"><table class=\"simple employeeCalculationsTable\"><thead class=\"stickyHeader\">\n<tr><th class=\"stickyColumn\"><div layout=\"row\"><div flex=\"nogrow\"><md-button \nclass=\"md-fab md-icon-button md-mini md-primary no-margin no-padding\" aria-label=\"search button\" disabled=\"true\" \ntype=\"submit\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button></div><input flex type=\"text\" \nplaceholder=\"Buscar Empleado\" ng-model-options=\"{ debounce: F.debounceTime }\" ng-model=\"importSearch\"></div></th><th>\nFecha</th><th ng-repeat=\"head in impCalcCtrl.headers\" ng-if=\'[\"Empleado\",\"Fecha\"].indexOf(head.name) === -1\'><md-button\n ng-if=\"head.error\" class=\"md-icon-button md-warn md-hue-2 no-margin no-padding nospacebutton\"><md-icon \nmd-font-icon=\"icon-alert\" aria-label=\"alert\"></md-icon><md-tooltip md-direction=\"bottom\">{{head.error}}</md-tooltip>\n</md-button>{{head.name}}</th></tr></thead><tbody><tr \nng-repeat=\"record in impCalcCtrl.data | filter : importSearch | orderBy : [\'-errors\',\'recordNumber\']\"><td \nclass=\"text-bold text-left nobreak stickyColumn\"><md-button ng-if=\"record.errors.length>0\" aria-label=\"Upload File\" \nclass=\"md-icon-button md-warn md-hue-2 no-margin no-padding nospacebutton\"><md-icon md-font-icon=\"icon-sim-alert\" \naria-label=\"Upload\"></md-icon><md-tooltip md-direction=\"right\"><label ng-repeat=\"error in record.errors\">{{error}},\n</label></md-tooltip></md-button><md-button ng-if=\"!record.errors.length && !record.applied\" aria-label=\"Upload File\" \nclass=\"md-icon-button md-primary no-margin no-padding nospacebutton\"><md-icon md-font-icon=\"icon-checkbox-marked\" \naria-label=\"Upload\"></md-icon><md-tooltip md-direction=\"right\">Sin problemas</md-tooltip></md-button><md-button \nng-if=\"record.applied\" aria-label=\"Upload File\" \nclass=\"md-icon-button md-primary md-hue-2 no-margin no-padding nospacebutton\"><md-icon md-font-icon=\" icon-check-all\" \naria-label=\"Upload\"></md-icon><md-tooltip md-direction=\"right\">Aplicado</md-tooltip></md-button>\n{{record.employee.data.name || \"No encontrado\"}}({{record.recordNumber}})</td><td>{{record.Fecha.format(\'DD-MM-YYYY\')}}\n</td><td ng-repeat=\"head in impCalcCtrl.headers\" ng-if=\'[\"Empleado\",\"Fecha\"].indexOf(head.name) === -1\' \nstyle=\"text-align: center\">{{record[head.name] || 0}}</td></tr></tbody></table></div></div>");
$templateCache.put("app/main/clients/views/operations/filters/calendars.html","<md-input-container class=\"md-block\" flex md-no-float><label>Calendario</label><md-select \nng-model=\"F.search.operations.calendar\" class=\"filter\" required><md-select-header><input autocomplete=\"off\" \ntype=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"calendarSelectFilter\" \nplaceholder=\"Busque un calendario\"></md-select-header><md-option ng-value=\"calendar.data.year\" \nng-repeat=\"calendar in calendars | orderBy:\'data.year\' | filter:calendarSelectFilter\">{{calendar.data.year}}\n</md-option></md-select></md-input-container>");
$templateCache.put("app/main/clients/views/operations/filters/periods.html","<md-input-container class=\"md-block\" flex md-no-float><label>Periodo</label><md-select \nng-model=\"F.search.operations.period\" class=\"filter\" required><md-option ng-value=\"false\">Todos</md-option><md-option \nng-class=\'{\"md-warn\":!period.active}\' ng-value=\"period.period\" ng-repeat=\"period in periods\">\n{{period.period}}: {{period.start| date:F.dateFormat}}-{{period.end| date:F.dateFormat}}</md-option></md-select>\n</md-input-container>");
$templateCache.put("app/main/clients/views/operations/filters/status.html","<md-input-container class=\"md-block\" flex md-no-float><md-select class=\"filter\" ng-model=\"F.search.operations.status\" \nplaceholder=\"Status\"><md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" \nng-keydown=\"$event.stopPropagation()\" ng-model=\"statusSelectFilter\" placeholder=\"Busque un Status\"></md-select-header>\n<md-option ng-value=\"status.id\" ng-repeat=\"status in F.operationStatatuss | orderBy:\'id\' | filter:statusSelectFilter\">\n{{status.name}}</md-option></md-select></md-input-container>");
$templateCache.put("app/main/clients/views/operations/tabs/advAndLoanOpes.html","<div class=\"table-responsive\"><table class=\"table-default\" ng-if=\"data.advAndLoanOpes.items.length > 0\"><thead><tr><th>\nNómina</th><th>Empleados</th><th>Periodo</th><th>Periodo Cierre</th><th>Status</th></tr></thead><tbody><tr \nng-repeat=\"advAndLoanOpe in data.advAndLoanOpes.items | filter:F.search.operation | limitTo: (F.search.$payroll?pagination.advAndLoanOpes.limit:data.advAndLoanOpes.items.length): (F.search.$payroll?(pagination.advAndLoanOpes.page - 1) * pagination.advAndLoanOpes.limit : 0) track by advAndLoanOpe.$id\">\n<td><input class=\"checked\" aria-label=\"select employee\" ng-checked=\"exists(advAndLoanOpe, selected)\" type=\"checkbox\" \nng-click=\"toggle(advAndLoanOpe, selected)\">\n {{advAndLoanOpe.payroll | getSomethingOfArrayFB : L.allPayrolls : \'class\'}} {{advAndLoanOpe.payroll | nameOfL:L.allPayrolls}}\n</td><td>{{advAndLoanOpe.employees | objectsLength}}</td><td>\n{{advAndLoanOpe.specialPeriod}} - {{advAndLoanOpe.calendar}}</td><td>\n{{advAndLoanOpe.accuPeriod || advAndLoanOpe.period}} - {{advAndLoanOpe.calendar}}</td><td><md-icon \nmd-font-icon=\'{{advAndLoanOpe.status | nameOfStatusOperation:\"icon\"}}\'></md-icon><span>\n{{advAndLoanOpe.status | nameOfStatusOperation}}</span></td></tr></tbody><tfoot \nng-if=\"!data.advAndLoanOpes.forPayroll\"><tr><td colspan=\"4\" class=\"text-center\"><md-button \nng-disabled=\"!data.advAndLoanOpes.loadMoreButton\" ng-click=\"getMoreResults()\">{{initialLoadMoreText}}</md-button></td>\n</tr></tfoot></table><div ng-if=\"data.advAndLoanOpes.forPayroll && data.advAndLoanOpes.items.length > 0\">\n<md-table-pagination layout-align=\"center\" layout-gt-xs=\"row\" layout-xs=\"column\" md-label=\"{{F.paginationLabel}}\" \nmd-limit=\"pagination.advAndLoanOpes.limit\" md-limit-options=\"pagination.advAndLoanOpes.limitOption\" \nmd-page=\"pagination.advAndLoanOpes.page\" md-total=\"{{data[tabName].items.length}}\" md-page-select>\n</md-table-pagination></div><div ng-show=\"data.advAndLoanOpes.items.length === 0\" layout-align=\"center center\" \nclass=\"md-accent noData\"><h1 class=\"md-subhead\">No hay registros de operaciones</h1></div></div>");
$templateCache.put("app/main/clients/views/operations/tabs/asimilated.html","<div class=\"table-responsive\"><table class=\"table-default\" ng-if=\"data.asimilated.items.length > 0\"><thead><tr><th>\nNómina</th><th>Empleados</th><th>Periodo</th><th>Periodo Cierre</th><th>Status</th></tr></thead><tbody><tr \nng-repeat=\"special in data.asimilated.items | filter:F.search.operation | limitTo: (F.search.$payroll?pagination.asimilated.limit:data.asimilated.items.length): (F.search.$payroll?(pagination.asimilated.page - 1) * pagination.asimilated.limit : 0) track by special.$id\">\n<td><input class=\"checked\" aria-label=\"select employee\" ng-checked=\"exists(special, selected)\" type=\"checkbox\" \nng-click=\"toggle(special, selected)\">\n {{special.payroll | getSomethingOfArrayFB : L.allPayrolls : \'class\'}} {{special.payroll | nameOfL:L.allPayrolls}}</td>\n<td>{{special.employees | objectsLength}}</td><td>{{special.specialPeriod}} - {{special.calendar}}</td><td>\n{{special.accuPeriod || special.period}} - {{special.calendar}}</td><td><md-icon \nmd-font-icon=\'{{special.status | nameOfStatusOperation:\"icon\"}}\'></md-icon><span>\n{{special.status | nameOfStatusOperation}}</span></td></tr></tbody><tfoot ng-if=\"!data.asimilated.forPayroll\"><tr><td \ncolspan=\"4\" class=\"text-center\"><md-button ng-disabled=\"!data.asimilated.loadMoreButton\" ng-click=\"getMoreResults()\">\n{{initialLoadMoreText}}</md-button></td></tr></tfoot></table><div \nng-if=\"data.asimilated.forPayroll && data.asimilated.items.length > 0\"><md-table-pagination layout-align=\"center\" \nlayout-gt-xs=\"row\" layout-xs=\"column\" md-label=\"{{F.paginationLabel}}\" md-limit=\"pagination.asimilated.limit\" \nmd-limit-options=\"pagination.asimilated.limitOption\" md-page=\"pagination.asimilated.page\" \nmd-total=\"{{data[tabName].items.length}}\" md-page-select></md-table-pagination></div><div \nng-show=\"data.asimilated.items.length === 0\" layout-align=\"center center\" class=\"md-accent noData\"><h1 \nclass=\"md-subhead\">No hay registros de nóminas especiales</h1></div></div>");
$templateCache.put("app/main/clients/views/operations/tabs/extraordinary.html","<md-tab-body layout=\"column\"><div class=\"filterToolbar md-padding\"><div layout-gt-xs=\"row\" \nlayout-align=\"space-between center\"><div filter-operations-calendars></div><div filter-operations-status></div></div>\n</div><div table-loader array=\"operations[tabName]\" validations=\"validations.operations[tabName]\"></div>\n<md-table-container class=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table \nmd-row-select multiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"operations[tabName].length\"><thead \nmd-head md-order=\"order\" fix-head><tr md-row><th md-column><span>Creada</span></th><th md-column><span>Actualizada\n</span></th><th md-column md-order-by=\"status\"><span>Status</span></th></tr></thead><tbody md-body><tr md-row \nmd-auto-select md-select=\"operation\" md-select-id=\"$id\" \nng-repeat=\"operation in (F.filteredItemsO[tabName] = (operations[tabName] | operationsOfPeriod:F.search.operations.period | filter:F.search.operation | orderBy:order)) | limitTo: F.paginate: (currentPageO[tabName] - 1) * F.paginate\">\n<td md-cell>{{operation.created.atTime | date}}</td><td md-cell><span flex>{{operation.updated.atTime | date}}</span> \n<small class=\"blueC\">por {{operation.updated.by | getSomethingOfArrayFB:CF.contacts:\'name\':false:\'id\'}}</small></td><td\n md-cell><md-icon md-font-icon=\'{{operation.status | nameOfStatusOperation:\"icon\"}}\'></md-icon><span>\n{{operation.status | nameOfStatusOperation}}</span></td></tr></tbody></table></md-table-container><md-table-pagination \nlayout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" ng-show=\"operations[tabName].length\" \nmd-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" md-limit-options=\"F.paginations\" \nmd-page=\"currentPageO[tabName]\" md-total=\"{{F.filteredItemsO[tabName].length}}\" md-page-select></md-table-pagination>\n</md-tab-body>");
$templateCache.put("app/main/clients/views/operations/tabs/ordinariesDoIt.html","<div class=\"table-responsive\"><table class=\"table-default\" ng-if=\"data.ordinariesDoIt.items.length > 0\"><thead><tr><th>\nNómina</th><th>Empleados</th><th>Periodo</th><th>Periodo Cierre</th><th>Status</th></tr></thead><tbody><tr \nng-repeat=\"ordinary in data.ordinariesDoIt.items | filter:F.search.operation | orderBy : orderBy : [\'payroll\',\'-period\'] | limitTo: pagination.ordinariesDoIt.limit:(pagination.ordinariesDoIt.page - 1) * pagination.ordinariesDoIt.limit track by ordinary.$id\">\n<td><input class=\"checked\" aria-label=\"select employee\" ng-checked=\"exists(ordinary, selected)\" type=\"checkbox\" \nng-click=\"toggle(ordinary, selected)\">\n {{ordinary.payroll | getSomethingOfArrayFB : L.allPayrolls : \'class\'}} {{ordinary.payroll | nameOfL:L.allPayrolls}}\n</td><td>{{ordinary.employees | objectsLength}}</td><td>{{ordinary.period}} - {{ordinary.calendar}}</td><td>\n{{ordinary.accuPeriod || ordinary.period}} - {{ordinary.calendar}}</td><td><md-icon \nmd-font-icon=\'{{ordinary.status | nameOfStatusOperation:\"icon\"}}\'></md-icon><span>\n{{ordinary.status | nameOfStatusOperation}}</span></td></tr></tbody></table><div><md-table-pagination \nlayout-align=\"center\" layout-gt-xs=\"row\" layout-xs=\"column\" ng-show=\"data[tabName].items.length\" \nmd-label=\"{{F.paginationLabel}}\" md-limit=\"pagination.ordinariesDoIt.limit\" \nmd-limit-options=\"pagination.ordinariesDoIt.limitOption\" md-page=\"pagination.ordinariesDoIt.page\" \nmd-total=\"{{data[tabName].items.length}}\" md-on-paginate=\"restartSelected\" md-page-select></md-table-pagination></div>\n<div ng-show=\"data.ordinariesDoIt.items.length === 0 && !loadingProgress\" layout-align=\"center center\" \nclass=\"md-accent noData\"><h1 class=\"md-subhead\">No hay registros de finiquitos cerrados</h1></div></div>");
$templateCache.put("app/main/clients/views/operations/tabs/ordinary.html","<md-tab-body layout=\"column\"><div class=\"filterToolbar md-padding\"><div layout-gt-xs=\"row\" \nlayout-align=\"space-between center\"><div filter-operations-calendars></div></div></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"operations[tabName].length\"><thead md-head \nmd-order=\"order\" fix-head><tr md-row><th md-column><span>Periodo</span></th><th md-column><span>Empleados</span></th>\n<th md-column md-order-by=\"status\"><span>Status</span></th></tr></thead><tbody md-body><tr \nng-class=\"(operation.status|getSomethingOfArrayFB:F.operationStatatuss:\'class\':\' \':\'id\')\" md-row md-auto-select \nmd-select=\"operation\" md-select-id=\"$id\" \nng-repeat=\"operation in (F.filteredItemsO[tabName] = (operations[tabName] | filter:F.search.operation | orderBy:order)) | limitTo: F.paginate: (currentPageO[tabName] - 1) * F.paginate\">\n<td md-cell>{{operation.period}}</td><td md-cell>{{operation.employees | objectsLength}}</td><td md-cell><md-icon \nmd-font-icon=\'{{operation.status | nameOfStatusOperation:\"icon\"}}\'></md-icon><span>\n{{operation.status | nameOfStatusOperation}}</span></td></tr></tbody></table></md-table-container><md-table-pagination \nlayout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" ng-show=\"operations[tabName].length\" \nmd-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" md-limit-options=\"F.paginations\" \nmd-page=\"currentPageO[tabName]\" md-total=\"{{operations[tabName].length}}\" md-page-select></md-table-pagination>\n</md-tab-body>");
$templateCache.put("app/main/clients/views/operations/tabs/settlements.html","<div class=\"table-responsive\"><table class=\"table-default\" ng-if=\"data.settlements.items.length > 0\"><thead><tr><th>\nNombre</th><th>Nómina</th><th>Fecha de Movimiento</th><th>Periodo Cierre</th><th>Status</th></tr></thead><tbody><tr \nng-repeat=\"settlement in data.settlements.items | filter:F.search.operation | orderBy : \'-created.atTime\' | limitTo: (F.search.$payroll?pagination.settlements.limit:data.settlements.items.length): (F.search.$payroll?(pagination.settlements.page - 1) * pagination.settlements.limit : 0)  track by settlement.$id\">\n<td><input class=\"checked\" aria-label=\"select employee\" ng-checked=\"exists(settlement, selected)\" type=\"checkbox\" \nng-click=\"toggle(settlement, selected)\"><label ng-bind=\"settlement.employees | getFromObjectField:\'name\':\'\'\"></label>\n</td><td>{{settlement.payroll | nameOfL:L.allPayrolls}}</td><td>\n{{settlement.dateFormatted=(settlement.movement.date | date:F.dateFormat)}}</td><td>\n{{settlement.calendar?settlement.calendar+\" - \"+settlement.period+\" [\"+(settlement.start|date)+\"]\":\"\"}}</td><td>\n<md-icon md-font-icon=\'{{settlement.status | nameOfStatusOperation:\"icon\"}}\'></md-icon><span>\n{{settlement.status | nameOfStatusOperation}}</span></td></tr></tbody><tfoot ng-if=\"!data.settlements.forPayroll\"><tr>\n<td colspan=\"4\" class=\"text-center\"><md-button ng-disabled=\"!data.settlements.loadMoreButton\" \nng-click=\"getMoreResults()\">{{initialLoadMoreText}}</md-button></td></tr></tfoot></table><div \nng-if=\"data.settlements.forPayroll && data.settlements.items.length > 0\"><md-table-pagination layout-align=\"center\" \nlayout-gt-xs=\"row\" layout-xs=\"column\" ng-show=\"data[tabName].items.length\" md-label=\"{{F.paginationLabel}}\" \nmd-limit=\"pagination.settlements.limit\" md-limit-options=\"pagination.settlements.limitOption\" \nmd-page=\"pagination.settlements.page\" md-total=\"{{data[tabName].items.length}}\" md-on-paginate=\"restartSelected\" \nmd-page-select></md-table-pagination></div><div ng-show=\"data.settlements.items.length === 0 && !loadingProgress\" \nlayout-align=\"center center\" class=\"md-accent noData\"><h1 class=\"md-subhead\">No hay registros de finiquitos</h1></div>\n</div>");
$templateCache.put("app/main/clients/views/operations/tabs/specials.html","<div class=\"table-responsive\"><table class=\"table-default\" ng-if=\"data.specials.items.length > 0\"><thead><tr><th>Nómina\n</th><th>Empleados</th><th>Periodo</th><th>Periodo Cierre</th><th>Status</th></tr></thead><tbody><tr \nng-repeat=\"special in data.specials.items | filter:F.search.operation | limitTo: (F.search.$payroll?pagination.specials.limit:data.specials.items.length): (F.search.$payroll?(pagination.specials.page - 1) * pagination.specials.limit : 0) track by special.$id\">\n<td><input class=\"checked\" aria-label=\"select employee\" ng-checked=\"exists(special, selected)\" type=\"checkbox\" \nng-click=\"toggle(special, selected)\">\n {{special.payroll | getSomethingOfArrayFB : L.allPayrolls : \'class\'}} {{special.payroll | nameOfL:L.allPayrolls}}</td>\n<td>{{special.employees | objectsLength}}</td><td>{{special.specialPeriod}} - {{special.calendar}}</td><td>\n{{special.accuPeriod || special.period}} - {{special.calendar}}</td><td><md-icon \nmd-font-icon=\'{{special.status | nameOfStatusOperation:\"icon\"}}\'></md-icon><span>\n{{special.status | nameOfStatusOperation}}</span></td></tr></tbody><tfoot ng-if=\"!data.specials.forPayroll\"><tr><td \ncolspan=\"4\" class=\"text-center\"><md-button ng-disabled=\"!data.specials.loadMoreButton\" ng-click=\"getMoreResults()\">\n{{initialLoadMoreText}}</md-button></td></tr></tfoot></table><div \nng-if=\"data.specials.forPayroll && data.specials.items.length > 0\"><md-table-pagination layout-align=\"center\" \nlayout-gt-xs=\"row\" layout-xs=\"column\" md-label=\"{{F.paginationLabel}}\" md-limit=\"pagination.specials.limit\" \nmd-limit-options=\"pagination.specials.limitOption\" md-page=\"pagination.specials.page\" \nmd-total=\"{{data[tabName].items.length}}\" md-page-select></md-table-pagination></div><div \nng-show=\"data.specials.items.length === 0\" layout-align=\"center center\" class=\"md-accent noData\"><h1 \nclass=\"md-subhead\">No hay registros de nóminas especiales</h1></div></div>");
$templateCache.put("app/main/clients/views/operations/tabs/travelExpensesOpe.html","<div class=\"table-responsive\"><table class=\"table-default\" ng-if=\"data.travelExpensesOpe.items.length > 0\"><thead><tr>\n<th>Nómina</th><th>Empleados</th><th>Periodo</th><th>Periodo Cierre</th><th>Status</th></tr></thead><tbody><tr \nng-repeat=\"travelExpensesOpe in data.travelExpensesOpe.items | filter:F.search.operation | limitTo: (F.search.$payroll?pagination.travelExpensesOpe.limit:data.travelExpensesOpe.items.length): (F.search.$payroll?(pagination.travelExpensesOpe.page - 1) * pagination.travelExpensesOpe.limit : 0) track by travelExpensesOpe.$id\">\n<td><input class=\"checked\" aria-label=\"select employee\" ng-checked=\"exists(travelExpensesOpe, selected)\" \ntype=\"checkbox\" ng-click=\"toggle(travelExpensesOpe, selected)\">\n {{travelExpensesOpe.payroll | getSomethingOfArrayFB : L.allPayrolls : \'class\'}} {{travelExpensesOpe.payroll | nameOfL:L.allPayrolls}}\n</td><td>{{travelExpensesOpe.employees | objectsLength}}</td><td>\n{{travelExpensesOpe.specialPeriod}} - {{travelExpensesOpe.calendar}}</td><td>\n{{travelExpensesOpe.accuPeriod || travelExpensesOpe.period}} - {{travelExpensesOpe.calendar}}</td><td><md-icon \nmd-font-icon=\'{{travelExpensesOpe.status | nameOfStatusOperation:\"icon\"}}\'></md-icon><span>\n{{travelExpensesOpe.status | nameOfStatusOperation}}</span></td></tr></tbody><tfoot \nng-if=\"!data.travelExpensesOpe.forPayroll\"><tr><td colspan=\"4\" class=\"text-center\"><md-button \nng-disabled=\"!data.travelExpensesOpe.loadMoreButton\" ng-click=\"getMoreResults()\">{{initialLoadMoreText}}</md-button>\n</td></tr></tfoot></table><div ng-if=\"data.travelExpensesOpe.forPayroll && data.travelExpensesOpe.items.length > 0\">\n<md-table-pagination layout-align=\"center\" layout-gt-xs=\"row\" layout-xs=\"column\" md-label=\"{{F.paginationLabel}}\" \nmd-limit=\"pagination.travelExpensesOpe.limit\" md-limit-options=\"pagination.travelExpensesOpe.limitOption\" \nmd-page=\"pagination.travelExpensesOpe.page\" md-total=\"{{data[tabName].items.length}}\" md-page-select>\n</md-table-pagination></div><div ng-show=\"data.travelExpensesOpe.items.length === 0\" layout-align=\"center center\" \nclass=\"md-accent noData\"><h1 class=\"md-subhead\">No hay registros de operaciones</h1></div></div>");
$templateCache.put("app/main/clients/views/payrollCalendars/dialogs/importCalendar.html","<md-dialog aria-label=\"Import Variables\"><form name=\"ctrl.stepper\" ms-stepper ng-submit=\"ctrl.applyCalendar()\" \nng-model=\"ctrl.stepper\" novalidate><ms-stepper-step ng-form=\"step1\" step=\"1\" step-title=\"\'Selecciona los campos\'\"><div \nng-include=\"\'app/main/clients/views/payrollCalendars/dialogs/step1.html\'\"></div></ms-stepper-step><ms-stepper-step \nng-form=\"step2\" step=\"2\" step-title=\"\'Verificar información del calendario\'\"><div \nng-include=\"\'app/main/clients/views/payrollCalendars/dialogs/step2.html\'\"></div></ms-stepper-step><ms-stepper-step \nng-form=\"step3\" step=\"3\" step-title=\"\'Aplicar la información\'\"><div \nng-include=\"\'app/main/clients/views/payrollCalendars/dialogs/step3.html\'\"></div></ms-stepper-step></form></md-dialog>");
$templateCache.put("app/main/clients/views/payrollCalendars/dialogs/step1.html","<div class=\"md-inline-form\"><div flex><div ng-if=\"ctrl.loading\"><md-progress-linear md-mode=\"indeterminate\">\n</md-progress-linear><span class=\"md-subhead\">Cargando..</span></div><md-input-container class=\"md-block evenPadding\" \nflex><label>Nómina</label><md-select ng-model=\"payroll\" name=\"payroll\" ng-change=\"ctrl.getPeriods(payroll)\" required>\n<md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" \nng-model=\"payrollSelectFilter\" placeholder=\"Busque una nómina\"></md-select-header><md-option ng-value=\"payroll.$id\" \nng-if=\"payroll.active\" \nng-repeat=\"payroll in (F.permissionToAccessAllPayrolls?L.allPayrolls:L.payrolls) | orderBy:\'class\' | filter:payrollSelectFilter\">\n{{payroll.class}} {{payroll.name}}</md-option></md-select><div ng-messages=\"form.payroll.$error\" role=\"alert\"><div \nng-message=\"required\">Nómina es requerido</div></div></md-input-container><div layout=\"row\" \nlayout-align=\"center start\"><div flex><lf-ng-md-file-input ng-disabled=\"activeCalendar\" lf-files=\"ctrl.filesArray\" \nlf-placeholder=\"Selecciona el archivo csv\" lf-drag-and-drop-label=\"csv - Max: 10MB\" \nlf-browse-label=\"{{\'EC.search\' | translate}}\" lf-remove-label=\"{{\'EC.remove\' | translate}}\" lf-filesize=\"10MB\" \nlf-required lf-mimetype=\"text/csv\" accept=\"text/csv\" name=\"variablesFile\" lf-api=\"csvApi\"></lf-ng-md-file-input><div \nng-messages=\"step1.variablesFile.$error\" style=\"color:red\"><div ng-message=\"required\">Archivo requerido</div><div \nng-message=\"maxcount\">Demasiados archivos</div><div ng-message=\"filesize\">Archivo demasiado grande</div><div \nng-message=\"totalsize\">Espacio total demasiado grande</div><div ng-message=\"mimetype\">Formato de archivo no valido\n</div></div></div></div><div flex=\"no-grow\" layout=\"row\"><span flex></span> <a class=\"downloadLink\" target=\"_blanc\" \nhref=\"assets/csv/import-custom-calendar.csv\">descargar template<md-icon md-font-icon=\"icon-file-excel\" \naria-label=\"download variables template\"></md-icon></a></div></div></div>");
$templateCache.put("app/main/clients/views/payrollCalendars/dialogs/step2.html","<div><div ng-if=\"ctrl.loading\"><md-progress-linear md-mode=\"indeterminate\"></md-progress-linear><span \nclass=\"md-subhead\">Cargando..</span></div><div style=\"max-height: 550px;overflow: auto\"><table class=\"simple\"><thead \nclass=\"stickyHeader\"><tr><th>Periodo</th><th>Inicio</th><th>Fin</th><th>Fecha acumulado</th><th>Ajuste</th><th>Dias\n</th><th>Acumulado</th><th>Factor</th><th>Año</th></tr></thead><tbody><tr ng-repeat=\"data in ctrl.headers\"><td \nclass=\"blue-900-fg\">{{data.periodo}}</td><td>{{data.inicio}}</td><td>{{data.fin}}</td><td>{{data.fechaAcumulado}}</td>\n<td>{{ data.ajuste === true || data.ajuste === \'si\' ? \'✅\' : \'❌\' }}</td><td>{{data.days}}</td><td>{{data.accumulator}}\n</td><td>{{data.factor}}</td><td>{{data.year}}</td></tr></tbody></table></div></div>");
$templateCache.put("app/main/clients/views/payrollCalendars/dialogs/step3.html","<div class=\"md-inline-form\" flex layout=\"column\"><div ng-if=\"ctrl.loading\" flex layout=\"row\" \nlayout-align=\"center center\"><md-progress-linear md-mode=\"indeterminate\"></md-progress-linear><span class=\"md-subhead\" \nstyle=\"margin-left: 10px\">Cargando..</span></div><div flex layout=\"column\" layout-align=\"center center\" \nstyle=\"overflow-x: auto\"><h2>¿Desea aplicar este calendario a la nomina {{ctrl.namePayroll}}?</h2></div></div>");
$templateCache.put("app/main/clients/views/reports/dialogs/reports.html","<md-dialog aria-label=\"modal Settlements\" style=\"min-width: 600px\" id=\"reportsModal\"><form name=\"form\"><md-toolbar \nclass=\"md-menu-toolbar\"><div class=\"md-toolbar-tools\"><h2 flex><md-icon md-font-icon=\"icon-file-document-box\" \nstyle=\"color:white; margin-right:10px\"></md-icon>{{data.name}}</h2><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-font-icon=\"icon-close\" style=\"color: white\" aria-label=\"Close Dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"content-bg\"><div class=\"md-dialog-content\" layout=\"column\">\n<div ng-repeat=\"($index, param) in data.params track by $index\" flex=\"nogrow\" class=\"card-param\"><div \nclass=\"param-header\" ng-class=\"{\'mb-10\':!(param.type === \'fromList\' && [\'autocomplete\'].indexOf(param.listType)>-1)}\" \nng-if=\"[\'check\'].indexOf(param.type)==-1\"><strong ng-bind=\"param.name\"></strong></div><md-input-container \nng-if=\"param.type === \'manualList\'\" class=\"md-block mt-0 mb-0 no-errors-spacer\" flex md-no-float><md-select \nng-model=\"reports[param.field]\" name=\"manualList{{$index}}\" placeholder=\"{{param.placeholder || \'Seleccionar\'}}\" \nng-required=\"param.required\"><md-option ng-value=\"undefined\" ng-if=\"param.none\">Ninguno</md-option><md-option \nng-value=\"items.id\" ng-selected=\"items.selected\" \nng-repeat=\"items in param.fields | orderBy:[\'name\',\'data.name\'] track by items.id\">{{items.name}}</md-option>\n</md-select><div class=\"md-errors-spacer\"></div><div ng-messages=\'form[\"manualList\"+$index].$error\' role=\"alert\"><div \nng-message=\"required\">El campo es requerido</div></div></md-input-container><div ng-if=\"param.type === \'check\'\">\n<md-checkbox ng-model=\"reports[param.field]\" aria-label=\"{{param.name}}\" class=\"md-primary no-margin\">{{param.name}}\n</md-checkbox></div><div ng-if=\'param.type === \"inputNumber\"\' layout=\"row\"><md-input-container \nclass=\"md-block no-errors-spacer\" flex md-no-float><input type=\"number\" ng-model=\"reports[param.field]\" \nplaceholder=\"{{param.placeholder}}\" ng-required=\"param.required\" ng-model-options=\"{ debounce: F.debounceTime }\"><div \nng-messages=\"form[param.name].$error\" ng-show=\"form[param.name].$touched || form[param.name].$dirty\" role=\"alert\"><div \nng-message=\"required\">Requerido</div></div></md-input-container></div><div ng-if=\"param.type === \'radioOptions\'\">\n<md-radio-group ng-model=\"reports[param.field]\"><md-radio-button ng-value=\"undefined\">\n{{param.noSelectionLabel || \'Sin seleccionar\'}}</md-radio-button><md-radio-button ng-repeat=\"option in param.options\" \nng-value=\"option.value\">{{ option.label }}</md-radio-button></md-radio-group></div><md-input-container \nng-if=\'param.type === \"dateInput\"\' class=\"md-block date-picker no-errors-spacer\" md-no-float><md-datepicker \nmd-hide-icons=\"triangle\" md-current-view=\"{{F.dateView}}\" input-date-miliseconds ng-required=\"param.required\" \nmd-placeholder=\"{{param.placeholder}}\" input-aria-describedby=\"{{param.placeholder}}\" \ninput-aria-labelledby=\"{{param.placeholder}}\" name=\"{{param.field}}\" class=\"md-block\"></md-datepicker><div \nng-messages=\"form[param.field].$error\" ng-show=\"form[param.field].$touched || form[param.field].$dirty\" role=\"alert\">\n<div ng-message=\"required\">Fecha es requerido</div></div></md-input-container><div ng-if=\'param.type === \"dateRange\"\' \nlayout=\"row\" layout-xs=\"column\" layout-gap=\"20px\"><md-input-container class=\"md-block date-picker no-errors-spacer\" \nflex md-no-float><md-datepicker md-hide-icons=\"triangle\" md-current-view=\"{{F.dateView}}\" input-date-miliseconds \nng-required=\"param.required\" ng-model=\"reports.from\" name=\'{{param.name+\"from\"}}\' md-placeholder=\"Desde\" \nmd-min-date=\"fromMinDate\" md-max-date=\"fromMaxDate\" ng-change=\"checkDate()\" \ninput-aria-describedby=\"{{param.name}}-from\" input-aria-labelledby=\"{{param.name}}-from \" class=\"md-block\">\n</md-datepicker><div ng-messages=\'form[param.name+\"from\"].$error\' \nng-show=\'form[param.name+\"from\"].$touched || form[param.name+\"from\"].$dirty\' role=\"alert\"><div ng-message=\"required\">\nDesde es requerido</div></div></md-input-container><md-input-container class=\"md-block date-picker no-errors-spacer\" \nflex md-no-float><md-datepicker md-hide-icons=\"triangle\" md-current-view=\"{{F.dateView}}\" input-date-miliseconds \nng-required=\"param.required\" md-placeholder=\"Hasta\" ng-model=\"reports.to\" name=\'{{param.name+\"to\"}}\' \nmd-min-date=\"toMinDate\" md-max-date=\"toMaxDate\" ng-change=\"checkDate()\" input-aria-describedby=\"{{param.name}}-to\" \ninput-aria-labelledby=\"{{param.name}}-to\" class=\"md-block\"></md-datepicker><div \nng-messages=\'form[param.name+\"to\"].$error\' ng-show=\'form[param.name+\"to\"].$touched || form[param.name+\"to\"].$dirty\' \nrole=\"alert\"><div ng-message=\"required\">Hasta es requerido</div></div></md-input-container></div><div \nng-if=\"param.type === \'fromList\' && param.listType===\'autocomplete\'\" class=\"mb-5\" flex><md-chips \nng-model=\"reports[param.field]\" ng-if=\"!param.query\" md-autocomplete-snap md-transform-chip=\"transformChip($chip)\" \nmd-require-match=\"true\" ng-required=\"param.required\" input-aria-label=\"autocompleteTitle\"><md-autocomplete \nmd-selected-item=\"selectedItem\" class=\"custom-template\" md-search-text=\"searchText\" md-min-length=\"0\" \nmd-items=\"item in filterList(fromList[param.list],\'name\',searchText,param.paramsToWatch,reports)\" md-no-cache \nmd-item-text=\"item.name\" placeholder=\"{{param.searchLabel}}\" md-dropdown-position=\"bottom\" \ninput-aria-describedby=\"autocompleteTitle\"><span md-highlight-text=\"ctrl.searchText\">{{item.name}}</span>\n</md-autocomplete><md-chip-template><span><strong>{{$chip|getSomethingOfArrayFB:fromList[param.list]:\"name\"}}</strong>\n</span></md-chip-template></md-chips><md-chips ng-model=\"autoCompleteOptions[param.field]\" ng-if=\"param.query\" \nmd-on-add=\"setModelFromAutocomplete(param.field,autoCompleteOptions[param.field],\'$id\')\" \nmd-on-remove=\"setModelFromAutocomplete(param.field,autoCompleteOptions[param.field],\'$id\')\" md-autocomplete-snap \nmd-transform-chip=\"transformChip($chip,true)\" md-require-match=\"true\" input-aria-label=\"autocompleteTitle\" \nng-required=\"param.required\"><md-autocomplete md-selected-item=\"selectedItem\" class=\"custom-template\" \nmd-search-text=\"searchText\" md-min-length=\"5\" \nmd-items=\"item in autocompleteListM(searchText, param.query, param.queryFields, param.extraQueries, param.transform, param.includeCenterQuery)\" \nmd-no-cache md-item-text=\"item.name\" placeholder=\"{{param.searchLabel}}\" md-dropdown-position=\"bottom\" \ninput-aria-describedby=\"autocompleteTitle\"><span md-highlight-text=\"searchText\">{{item.name}}</span></md-autocomplete>\n<md-chip-template><span><strong>{{$chip.name}}</strong></span></md-chip-template></md-chips></div><md-input-container \nng-if=\"param.type === \'fromList\' && param.listType!==\'autocomplete\'\" class=\"md-block no-errors-spacer\" flex \nmd-no-float><md-select ng-model=\"reports[param.field]\" name=\"{{param.field}}\" \nplaceholder=\"{{param.placeholder || \'Seleccionar\'}}\" ng-required=\"param.required\"><md-select-header \nclass=\"search-header\"><input autocomplete=\"off\" type=\"search\" class=\"header-search-box\" \nng-keydown=\"$event.stopPropagation()\" ng-model=\"searchText\" placeholder=\"Buscar...\"></md-select-header><md-option \nng-value=\"items.$id\" \nng-repeat=\"items in fromList[param.list] | orderBy:[\'name\',\'data.name\'] | searchSpecific:searchText:[\'name\', \'data.businessNameShort\'] track by items.$id\" \nng-class=\"{\'inactiveOption\': !items.active}\">{{(items.data) ? items.data.name : items.name}}</md-option></md-select>\n<div class=\"md-errors-spacer\"></div><div ng-messages=\"form[param.field].$error\" role=\"alert\"><div \nng-message=\"required\">El campo es requerido</div></div></md-input-container><div ng-if=\'param.type === \"dateIsn\"\' \nlayout=\"row\" layout-xs=\"column\" layout-gap=\"15px\"><md-input-container class=\"md-block no-errors-spacer\" flex \nmd-no-float><label>Mes Inicio</label><md-select ng-model=\"reports.monthInit\" ng-required=\"param.required\" \nplaceholder=\"Mes inicio\"><md-option ng-repeat=\"month in months\" ng-value=\"month.value\">{{ month.label }}</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block no-errors-spacer\" flex md-no-float><label>Mes Fin\n</label><md-select ng-model=\"reports.monthEnd\" ng-required=\"param.required\" placeholder=\"Mes fin\"><md-option \nng-repeat=\"month in months\" ng-value=\"month.value\">{{ month.label }}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block no-errors-spacer\" flex md-no-float><label>Año</label><md-select \nng-model=\"reports.year\" ng-required=\"param.required\" placeholder=\"Selecciona un año\"><md-option \nng-repeat=\"year in years\" ng-value=\"year\">{{ year }}</md-option></md-select></md-input-container></div><div \nng-if=\'param.type === \"discountIsn\"\' layout=\"row\" class=\"info-alert-box\"><md-checkbox ng-model=\"reports.discountIsn\" \naria-label=\"Checkbox 2\" class=\"md-primary md-align-top-left no-margin\" flex><span class=\"text-justify\">\nAdherirse a los decretos de beneficios fiscales, estímulos o exenciones vigentes en el estado correspondiente, a fin de aprovechar los incentivos disponibles.\n</span></md-checkbox></div><div ng-if=\'param.type === \"dateRangeIsn\"\' layout=\"row\" layout-gap=\"20px\">\n<md-input-container class=\"md-block no-errors-spacer\" flex md-no-float><label>Mes</label><md-select \nng-model=\"reports.month\" placeholder=\"Selecciona un mes\"><md-option ng-repeat=\"month in months\" ng-value=\"month.value\">\n{{ month.label }}</md-option></md-select></md-input-container><md-input-container class=\"md-block no-errors-spacer\" \nflex md-no-float><label>Año</label><md-select ng-model=\"reports.year\" placeholder=\"Selecciona un año\"><md-option \nng-repeat=\"year in years\" ng-value=\"year\">{{ year }}</md-option></md-select></md-input-container></div><div \nng-if=\"param.type === \'dateOnlyYears\'\"><md-input-container class=\"md-block date-picker no-errors-spacer\" flex \nmd-no-float><label>Año</label><md-select ng-model=\"reports.year\" placeholder=\"Selecciona un año\"><md-option \nng-repeat=\"year in yearsAnniversary\" ng-value=\"year\">{{ year }}</md-option></md-select></md-input-container></div>\n</div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\"><md-button \nng-disabled=\"form.pending || form.$invalid || loadingProgress\" ng-click=\"downloadManyReports(reports)\" \nclass=\"md-raised md-primary btn-download\" aria-label=\"Add item\">Descargar<md-icon \nmd-font-icon=\"icon-arrow-down-bold-circle-outline\" aria-label=\"Download\" style=\"margin-left:5px\"></md-icon></md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/clients/views/xmlSatMetas/dialogs/request.html","<md-dialog aria-label=\"Get from SAT params\" flex=\"80\" flex-gt-xs=\"50\" flex-gt-sm=\"33\" flex-gt-md=\"30\" flex-gt-lg=\"25\">\n<form name=\"form\" novalidate><md-toolbar><div class=\"md-toolbar-tools\"><span class=\"title\">Obtener recibos del SAT\n</span><div flex></div><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><md-input-container class=\"md-block m-0\"><label>Empresa</label><md-icon \nmd-font-icon=\"icon-domain\"></md-icon><md-select ng-model=\"params.companiesRecordIds\" multiple=\"multiple\" \nname=\"companiesRecord\" required><md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" \nng-keydown=\"$event.stopPropagation()\" ng-model=\"companiesRecordsFilter\" placeholder=\"Buscar empresa\">\n</md-select-header><md-option ng-value=\"item.$id\" \nng-repeat=\"item in companiesRecords | filter : companiesRecordsFilter\" ng-class=\"{\'inactiveOption\': !item.active}\">\n{{item.name}}</md-option></md-select><div ng-messages=\"form.companiesRecord.$error\" role=\"alert\"><div \nng-message=\"required\">El campo es requerido</div></div></md-input-container><div layout=\"row\"><div flex=\"50\">\n<md-input-container class=\"md-block date-picker m-0\" flex><label>Fecha de inicio</label><md-datepicker \nmd-hide-icons=\"triangle\" md-current-view=\"{{F.dateView}}\" required input-date-miliseconds ng-model=\"params.startDate\" \nname=\"startDate\" class=\"md-block\"></md-datepicker><div ng-messages=\"form.startDate.$error\" \nng-show=\"form.startDate.$touched || form.startDate.$dirty\" role=\"alert\"><div ng-message=\"starDate\">\nFecha de fin es requerido</div></div></md-input-container></div><div flex=\"50\"><md-input-container \nclass=\"md-block date-picker m-0\" flex><label>Fecha de fin</label><md-datepicker md-hide-icons=\"triangle\" \nmd-current-view=\"{{F.dateView}}\" input-date-miliseconds required ng-model=\"params.endDate\" name=\"endDate\" \nclass=\"md-block\"></md-datepicker><div ng-messages=\"form.endDate.$error\" \nng-show=\"form.endDate.$touched || form.endDate.$dirty\" role=\"alert\"><div ng-message=\"required\">\nFecha de fin es requerido</div></div></md-input-container></div></div><div layout=\"row\"><div flex=\"50\"><md-switch \nclass=\"m-0\" ng-model=\"params.emitted\" aria-label=\"Switch 2\">Emitido</md-switch></div><div flex=\"50\"><md-switch \nclass=\"m-0\" ng-model=\"params.cancel\" aria-label=\"Switch 2\">Cancelado</md-switch></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"end end\"><div layout=\"row\"><md-button type=\"submit\" \nng-click=\"makeRequest(params)\" class=\"send-button md-accent md-raised\" ng-disabled=\"form.$invalid || form.$pristine\">\nSolicitar</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/clients/views/xmlSatMetas/dialogs/responseXmlDialog.html","<md-dialog id=\"responseXmlDialog\" class=\"retry-sat-dialog\" aria-label=\"Reintentar SAT\"><form ng-cloak name=\"form\" \nnovalidate><md-toolbar class=\"retry-sat-toolbar\"><div class=\"md-toolbar-tools\"><h2>¿Reintentar consulta SAT?</h2></div>\n</md-toolbar><md-dialog-content class=\"retry-sat-content\" layout=\"column\">\nSe van a reintentar las tareas seleccionadas las acciones a realizar son las siguientes:<ul><li>\nSi no tiene un requestId, se realizara la misma consulta con las mismas fechas</li><li>\nSi ya se tiene un requestId pero no el(los) responseId(s) se intentara obtener el(los) responseId(s)</li><li>\nSi ya tiene requestId y responseId(s) se intentara hacer la descarga de los xml</li></ul></md-dialog-content>\n<md-dialog-actions class=\"retry-sat-actions\" layout=\"row\" layout-align=\"end center\"><md-button \nng-click=\"rpsCtrl.close()\">Cancelar</md-button><md-button class=\"md-primary md-raised\" ng-disabled=\"form.$invalid\" \nng-click=\"rpsCtrl.answer()\">Aceptar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/config/views/benefits/forms/form-benefit.html","<div><div layout-gt-xs=\"row\"><div flex-gt-xs=\"50\"><md-input-container class=\"md-block\"><label>Porcentaje de prima\n</label><input type=\"number\" ignore-mouse-wheel ng-name=\"prime\" ng-model=\"benefit.prime\" \nng-disabled=\"(employee && !employee.customBenefits) || F.readMode\" ng-model-options=\"{ debounce: F.debounceTime }\" \nmin=\"0\" required><div ng-messages=\"form.prime.$error\" role=\"alert\"><div ng-message=\"min\">\nDebe ser un porcentaje mayor a 0</div></div></md-input-container><table-values \ntable-of-values=\"benefit.christmasBonusTable\" default-value=\"benefit.christmasBonus\" label=\"Dias de aguinaldo\" \nedit-mode=\"editChristmasBonusTable\" form-disabled=\"(employee && !employee.customBenefits) || F.readMode\" \nhelp-text=\"Establezca los dias de aguinaldos por año que recibira el empleado, para establecer rangos solo introduzca el ultimo año al que se aplicaran estos dias, el ultimo registro se utilizara para los años en adelante\" \nform=\"form\"></table-values><table-values table-of-values=\"benefit.holidaysTable\" \ndefault-value=\"benefit.holidaysDefault\" label=\"Vacaciones\" show-label-allways=\"true\" edit-mode=\"editHolidayTable\" \nform-disabled=\'(employee && !employee.customBenefits) || F.readMode || benefit.holidays==\"default\"\' \nhelp-text=\"Establezca los dias de vacaciones por año que recibira el empleado, para establecer rangos solo introduzca el ultimo año al que se aplicaran esos dias, el ultimo registro se utilizara para los años en adelante\" \nform=\"form\"><md-radio-group ng-model=\"benefit.holidays\" layout-gt-xs=\"row\" ng-change=\"holidaysHasChange()\" \nng-disabled=\"F.readMode || (employee && !employee.customBenefits)\"><md-radio-button value=\"default\" \naria-label=\"default\">Default</md-radio-button><md-radio-button value=\"custom\" aria-label=\"personalizado\">Personalizado\n</md-radio-button></md-radio-group></table-values></div><div flex-gt-xs=\"50\"><div \nng-class=\"{\'isFieldset\':benefit.hasOthers}\"><div ng-class=\"{\'isLegend\':benefit.hasOthers}\"><md-checkbox \nng-model=\"benefit.hasOthers\" aria-label=\"hasOthers\" ng-disabled=\"F.readMode || (employee && !employee.customBenefits)\">\nOtros Beneficios</md-checkbox></div><div ng-if=\"benefit.hasOthers\"><table class=\"simple miniTable fixedTable\"><thead>\n<tr><th style=\"text-align: center\">Prestacion</th><th style=\"text-align: center\">Factor</th><th \nstyle=\"text-align: center\" class=\"iconbutton\">&nbsp;</th></tr></thead><tbody><tr ng-repeat=\"other in benefit.others\">\n<td class=\"half valigntop\"><md-input-container class=\"md-block\" flex=\"nogrow\" md-no-float><input \nng-disabled=\"F.readMode || (employee && !employee.customBenefits)\" type=\"text\" name=\"name{{$index}}\" \nplaceholder=\"Nombre\" ng-model-options=\"{ debounce: F.debounceTime }\" ng-model=\"other.name\" \nng-model-options=\"{ debounce: F.debounceTime }\" required><div ng-messages=\'form[\"name\"+$index].$error\' \nng-show=\'form[\"name\"+$index].$touched || form[\"name\"+$index].$dirty\' role=\"alert\"><div ng-message=\"required\">\nIngrese el nombre de la prestaci&oacute;n</div></div></md-input-container></td><td class=\"half valigntop\">\n<md-input-container class=\"md-block\" flex=\"nogrow\" md-no-float><input \nng-disabled=\"F.readMode || (employee && !employee.customBenefits)\" type=\"number\" ignore-mouse-wheel \nname=\"factor{{$index}}\" ng-model-options=\"{ debounce: F.debounceTime }\" ng-model=\"other.factor\" placeholder=\"Factor\" \nrequired><div ng-messages=\'form[\"factor\"+$index].$error\' \nng-show=\'form[\"factor\"+$index].$touched || form[\"factor\"+$index].$dirty\' role=\"alert\"><div ng-message=\"required\">\nEl factor es requerido</div></div></md-input-container></td><td class=\"iconbutton\"><md-button class=\"md-icon-button\" \naria-label=\"Delere record\" ng-click=\"benefit.others.splice($index,1);form.$setDirty();\"><md-tooltip \nng-if=\"benefit.others.length>1\" md-direction=\"top\">Eliminar Registro</md-tooltip><md-icon md-font-icon=\"icon-trash\" \naria-label=\"delete\"></md-icon></md-button></td></tr><tr><td colspan=\"3\" class=\"lastRow\"><md-button \nclass=\"md-icon-button\" aria-label=\"add record\" ng-click=\"F.addObjectToArray(benefit,\'others\')\"><md-tooltip \nmd-direction=\"top\">Añadir Registro</md-tooltip><md-icon md-font-icon=\"icon-table-row-plus-after\" \naria-label=\"add record\"></md-icon></md-button></td></tr></tbody></table></div></div><factor-table benefit=\"benefit\" \nemployee=\"employee\" factor-selected=\"factorSelected\"></factor-table></div></div></div>");
$templateCache.put("app/main/config/views/concepts/dialogs/available-fields.html","<md-dialog aria-label=\"List dialog\" class=\"available-fields\"><md-dialog-content><div><div flex layout=\"row\"><h3 \nclass=\"mt-0\"><b>Campos disponibles</b></h3></div><section layout=\"column\" layout-fill><div class=\"head-filters\" \nng-click=\"toggleAvailableFields(\'filters\')\"><span>Filtros</span><md-icon md-font-icon=\"icon-chevron-right icon-right\">\n</md-icon></div><div class=\"body-filters\"><md-button layout-margin class=\"md-whiteframe-1dp btn-filters\" \nng-repeat=\"filter in filters\">[{{filter.name}}]</md-button></div></section><md-divider></md-divider><section \nlayout=\"column\" layout-wrap layout-fill><div class=\"head-calcFields\" ng-click=\"toggleAvailableFields(\'calcFields\')\">\n<span>Campos de Calculo</span><md-icon md-font-icon=\"icon-chevron-right icon-right\"></md-icon></div><div \nclass=\"body-calcFields\"><md-button layout-margin class=\"md-whiteframe-1dp btn-calcFields\" \nng-repeat=\"calcField in calcFields\">[{{calcField.name}}]</md-button></div></section><md-divider></md-divider><section \nlayout=\"column\" layout-wrap layout-fill class=\"pb-10\"><div class=\"head-concepts\" \nng-click=\"toggleAvailableFields(\'concepts\')\"><span>Campos de Concepto</span><md-icon \nmd-font-icon=\"icon-chevron-right icon-right\"></md-icon></div><div class=\"body-concepts\"><md-button layout-margin \nclass=\"md-whiteframe-1dp btn-concepts\" ng-repeat=\"concept in listsConcepts\">[{{concept.name}}]</md-button></div>\n</section></div></md-dialog-content><md-dialog-actions><md-button ng-click=\"closeDialog()\" \nclass=\"md-primary md-button md-tds-theme md-ink-ripple md-raised\">CERRAR</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/config/views/concepts/dialogs/copy-concepts-relations.html","<md-dialog aria-label=\"Register Emit Employees\" class=\"close-operation\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nRelación de Conceptos</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"hide()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div>\n<h3 class=\"mt-0\">Los siguientes conceptos están relacionados, desea actualizarlos</h3></div><form novalidate flex \nlayout=\"column\"><div class=\"demo-select-all-checkboxes\" ng-repeat=\"item in items track by item.$id\"><md-checkbox \nng-checked=\"exists(item, selected)\" ng-click=\"toggle(item, selected)\">\n{{ item.name }} - [{{item.payroll | getSomethingOfArrayFB:payrolls:\"name\":\"N/A\":\"$id\"}}] - {{item.key}}</md-checkbox>\n</div></form></md-dialog-content><md-dialog-actions layout=\"row\"><md-button class=\"md-accent md-raised md-warn\" \nng-click=\"cancel()\">Cancelar</md-button><md-button class=\"md-accent md-raised md-primary\" ng-click=\"confirm(selected)\" \nng-disabled=\"selected.length===0\">Actualizar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/config/views/concepts/dialogs/copy-concepts.html","<md-dialog><form name=\"payrollSelectorForm\" ng-cloak><md-toolbar><div class=\"md-toolbar-tools\"><h2>Copiar Concepto</h2>\n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-font-icon=\"icon-window-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\">\n<div><div layout=\"row\"><md-input-container class=\"md-block mt-0 pt-0\" flex><label>Nómina Destino</label><md-select \nng-model=\"listPayroll\" name=\"payrollId\" ng-change=\"disabledId(listPayroll)\"><md-select-header><input \nautocomplete=\"off\" type=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" \nng-model=\"destinationPayrollSelectFilter\" placeholder=\"Busque una nómina\"></md-select-header><md-option \nng-if=\"payrollId.indexOf(payroll.$id)===-1\" ng-disabled=\"payroll.disabled\" ng-value=\"payroll.$id\" \nng-repeat=\"payroll in payrolls | orderBy:\'name\' | filter:destinationPayrollSelectFilter track by payroll.$id\">\n{{payroll.name}}</md-option></md-select><div ng-messages=\"payrollSelectorForm.payrollId.$error\"><div \nng-message=\"required\">Seleccionar nómina destino</div></div></md-input-container><div flex=\"nogrow\"><button \nng-disabled=\"!listPayroll || listPayroll.length===0\" class=\"md-icon-button\" ng-click=\"addFields(listPayroll)\" \naria-label=\"Add\"><md-tooltip md-direction=\"top\">Agregar mas nóminas</md-tooltip><md-icon md-font-icon=\"icon-plus\">\n</md-icon></button></div></div><div layout-gt-xs=\"row\" layout=\"column\" ng-if=\"destinationPayroll.length>0\"><table \nclass=\"default-table\"><thead><tr><th>Nómina</th><th>Acción</th></tr></thead><tbody \nng-repeat=\"item in destinationPayroll track by item.payrollId\"><tr><td>\n{{item.payrollId | getSomethingOfArrayFB:payrolls:\"name\":\"No se encontró\":\"$id\"}}</td><td class=\"text-center\"><button \nng-click=\"removeFields($index, item.payrollId)\" class=\"md-icon-button\" aria-label=\"Delete\"><md-icon \nmd-font-icon=\"icon-trash\"></md-icon></button></td></tr></tbody></table></div></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button class=\"md-accent md-raised md-primary\" \nng-disabled=\"payrollSelectorForm.$invalid || loadingProgress || payrollSelectorForm.$pristine || (destinationPayroll.length===0 && listPayroll.length===0)\" \nng-click=\"copyConcepts(destinationPayroll)\">Copiar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/config/views/constant/forms/affect-incidence-property.html","<div layout=\"column\" flex><div flex layout=\"row\"><h3>Afectación de Propiedad de Cálculo de Incidencía</h3></div><div \nflex layout-gt-sm=\"row\" layout=\"row\"><md-input-container class=\"md-block\" flex md-no-float><md-select ms2-autofocus \nng-model=\"constant.affectProperty.property\" placeholder=\"Propiedad\" required><md-option ng-if=\"property.allowAssign\" \nng-value=\"property.$id\" ng-repeat=\"property in L.calcFields\">{{property.name | translate}}</md-option></md-select>\n</md-input-container><md-input-container flex><label>Valor</label><input type=\"number\" \nng-model=\"constant.affectProperty.value\" required></md-input-container></div><code class=\"help\" \nng-if=\'constant.affectProperty.operator == \"calcule\"\'>Para cálculo libre usar la variable $total, ej: ($total-45)*100\n</code></div>");
$templateCache.put("app/main/config/views/constant/forms/affect-incidence-total.html","<div layout=\"column\" flex><div flex layout=\"row\"><h3>Afectación de Incidencía</h3></div><div flex layout-gt-sm=\"row\" \nlayout=\"row\"><md-input-container class=\"md-block\" flex md-no-float><md-select ms2-autofocus \nng-model=\"constant.affect.operator\" placeholder=\"Operador\" required><md-option ng-value=\'\"equalTo\"\'>Igualar a\n</md-option><md-option ng-value=\'\"percentOf\"\'>Porcentaje de</md-option><md-option ng-value=\'\"sumTo\"\'>Sumar a\n</md-option><md-option ng-value=\'\"restTo\"\'>Restar a</md-option><md-option ng-value=\'\"mutiply\"\'>Multiplicar</md-option>\n<md-option ng-value=\'\"divide\"\'>Dividir</md-option><md-option ng-value=\'\"calcule\"\'>Calcular</md-option></md-select>\n</md-input-container><md-input-container flex><label>Valor</label><input type=\"text\" ng-model=\"constant.affect.value\" \nrequired></md-input-container></div><code class=\"help\" ng-if=\'constant.affect.operator == \"calcule\"\'>\nPara cálculo libre usar la variable $total, ej: ($total-45)*100</code></div>");
$templateCache.put("app/main/config/views/constant/forms/affect-incidence-value.html","<div layout=\"column\" flex><div flex layout=\"row\"><h3>Afectación de Incidencía</h3></div><div flex layout-gt-xs=\"row\" \nlayout=\"column\"><md-input-container class=\"md-block no-margin\" flex flex-gt-xs=\"nogrow\" md-no-float><md-select \nms2-autofocus ng-model=\"constant.affect.operator\" placeholder=\"Operador\" required><md-option ng-value=\'\"equalTo\"\'>\nIgualar a</md-option><md-option ng-value=\'\"percentOf\"\'>Porcentaje de</md-option><md-option ng-value=\'\"sumTo\"\'>Sumar a\n</md-option><md-option ng-value=\'\"restTo\"\'>Restar a</md-option><md-option ng-value=\'\"mutiply\"\'>Multiplicar</md-option>\n<md-option ng-value=\'\"divide\"\'>Dividir</md-option><md-option ng-value=\'\"calcule\"\'>Calcular</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block no-margin\" flex><label>Valor</label><input \nng-if=\'constant.affect.operator != \"calcule\"\' type=\"text\" ng-model=\"constant.affect.value\" name=\"value\" required> \n<input ng-if=\'constant.affect.operator == \"calcule\"\' valid-constant-formule calc-fields=\"L.calcFields\" name=\"value\" \ntype=\"text\" ng-model=\"constant.affect.value\" ng-model-options=\"{ debounce: F.debounceTime }\" \nng-click=\"getCursorPos($event,\'value\')\" ng-keyup=\"getCursorPos($event,\'value\')\" required><div \nng-messages=\"form.value.$error\" ng-show=\"form.value.$touched || form.value.$dirty\" role=\"alert\"><div \nng-message=\"valid\">La formula no es valida</div></div></md-input-container></div><div flex layout-gt-xs=\"row\" \nlayout=\"column\" ng-if=\"constant.incidencesType|getSomethingOfArrayFB:allIncidences:\'satIncidencesType\':false\">\n<md-input-container class=\"md-block no-margin\" flex flex-gt-xs=\"nogrow\"><md-switch md-invert class=\"md-primary\" \nname=\"differentFiscalCalc\" ng-disabled=\"F.readMode\" ng-model=\"constant.affect.differentFiscalCalc\" \naria-label=\"Different fiscal calculation\">Diferente calculo fiscal</md-switch></md-input-container></div><div flex \nlayout-gt-xs=\"row\" layout=\"column\"><md-input-container class=\"md-block no-margin\" flex flex-gt-xs=\"nogrow\" md-no-float \nng-if=\"constant.affect.differentFiscalCalc\"><md-select ng-model=\"constant.affect.fiscalOperator\" \nplaceholder=\"Operador\" \nng-init=\"constant.affect.fiscalOperator?constant.affect.fiscalOperator:constant.affect.fiscalOperator=constant.affect.operator\" \nrequired><md-option ng-value=\'\"equalTo\"\'>Igualar a</md-option><md-option ng-value=\'\"percentOf\"\'>Porcentaje de\n</md-option><md-option ng-value=\'\"sumTo\"\'>Sumar a</md-option><md-option ng-value=\'\"restTo\"\'>Restar a</md-option>\n<md-option ng-value=\'\"mutiply\"\'>Multiplicar</md-option><md-option ng-value=\'\"divide\"\'>Dividir</md-option><md-option \nng-value=\'\"calcule\"\'>Calcular</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block no-margin\" flex ng-if=\"constant.affect.differentFiscalCalc\"><label>Valor</label><input \nng-if=\'constant.affect.fiscalOperator != \"calcule\"\' type=\"text\" ng-model=\"constant.affect.fiscalValue\" \nname=\"fiscalValue\" required \nng-init=\"constant.affect.fiscalValue?constant.affect.fiscalValue:constant.affect.fiscalValue=constant.affect.value\"> \n<input ng-if=\'constant.affect.fiscalOperator == \"calcule\"\' valid-constant-formule calc-fields=\"L.calcFields\" \nname=\"fiscalValue\" type=\"text\" ng-model=\"constant.affect.fiscalValue\" ng-model-options=\"{ debounce: F.debounceTime }\" \nng-init=\"constant.affect.fiscalValue?constant.affect.fiscalValue:constant.affect.fiscalValue=constant.affect.value\" \nng-click=\"getCursorPos($event,\'fiscalValue\')\" ng-keyup=\"getCursorPos($event,\'fiscalValue\')\" required><div \nng-messages=\"form.fiscalValue.$error\" ng-show=\"form.fiscalValue.$touched || form.fiscalValue.$dirty\" role=\"alert\"><div \nng-message=\"valid\">La formula no es valida</div></div></md-input-container></div><code class=\"help\" \nng-if=\'constant.affect.operator == \"calcule\"\'>\nPara cálculo libre usar la variable $valor, ej: ($valor-45)*100. tambien puedes utilizar los campos disponibles en la parte de abajo para hacer calculos mas complejos\n</code><div flex layout=\"row\" ng-if=\'constant.affect.operator == \"calcule\"\'><h3>Campos disponibles</h3></div><div \nng-if=\'constant.affect.operator == \"calcule\"\' layout=\"row\" layout-padding layout-wrap layout-fill><md-button \nlayout-margin class=\"md-whiteframe-1dp\" ng-repeat=\"calcField in L.calcFields\" \nng-click=\"setCalFieldValue(calcField,fieldValue)\">[{{calcField.name}}]</md-button></div></div>");
$templateCache.put("app/main/config/views/constant/forms/automatic-apply.html","<div layout=\"column\" flex><div flex layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex md-no-float><md-select\n ms2-autofocus ng-model=\"constant.automaticApply.each\" placeholder=\"Cada\" required><md-option ng-value=\'\"period\"\'>\nPeriodo</md-option></md-select></md-input-container><md-input-container ng-if=\'constant.automaticApply.each == \"days\"\' \nflex><label>Días</label><input type=\"number\" ng-model=\"constant.automaticApply.days\" required></md-input-container>\n<md-input-container flex><label>Valor</label><input type=\"text\" ng-model=\"constant.automaticApply.value\" required>\n</md-input-container></div><div flex layout-gt-sm=\"row\"><md-input-container flex class=\"md-block date-picker\"><label>\nDesde</label><md-datepicker md-hide-icons=\"triangle\" input-date-miliseconds md-min-date=\"minDate\" \nng-model=\"constant.automaticApply.from\" name=\"from\" class=\"md-block\"></md-datepicker></md-input-container>\n<md-input-container flex class=\"md-block date-picker\"><label>Hasta</label><md-datepicker md-hide-icons=\"triangle\" \ninput-date-miliseconds md-min-date=\"minDate\" ng-model=\"constant.automaticApply.to\" name=\"to\" class=\"md-block\">\n</md-datepicker></md-input-container></div><code class=\"help\" \nng-if=\"!constant.automaticApply.from || !constant.automaticApply.to\"><p ng-show=\"!constant.automaticApply.from\">\nSi no se selecciona una fecha de inicio, se aplicará automaticamente a partir del próximo periodo aplicable.</p><p \nng-show=\"!constant.automaticApply.to\">\nSi no se selecciona una fecha de fin, se aplicará automaticamente infinitamente cada periodo aplicable.</p></code>\n</div>");
$templateCache.put("app/main/config/views/constant/forms/not-apply.html","<div layout-gt-sm=\"row\" flex><md-input-container class=\"md-input-has-placeholder md-block\" flex><label>No aplicar\n</label><br><md-checkbox ng-model=\"constant.notApply.automatic\" aria-label=\"Incidencias Automáticas\" \nng-true-value=\"true\" class=\"md-warn md-align-bottom-left\">Incidencias Automáticas</md-checkbox><md-checkbox \nng-model=\"constant.notApply.manual\" aria-label=\"Incidencias Manuales\" ng-true-value=\"true\" \nclass=\"md-warn md-align-bottom-left\">Incidencias Manuales y por Request</md-checkbox><md-checkbox \nng-model=\"constant.notApply.fast\" aria-label=\"Incidencias Rápidas\" ng-true-value=\"true\" \nclass=\"md-warn md-align-bottom-left\">Incidencias Rápidas (solo en sábana)</md-checkbox></md-input-container></div>");
$templateCache.put("app/main/config/views/constants/filters/ccs.html","<md-input-container class=\"md-block\" flex md-no-float><label>CC</label><md-select \nng-change=\"changeMainRef(F.search.constants.cc)\" ng-model=\"F.search.constants.cc\" class=\"filter\" required>\n<md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" \nng-model=\"ccSelectFilter\" placeholder=\"Busque un centro de costo\"></md-select-header><md-option \nng-if=\'F.active.menuAction == \"list\"\' ng-value=\'\"all\"\'>TODOS</md-option><md-option ng-value=\"cc.$id\" \nng-repeat=\"cc in ccs |  orderBy : [\'-valid\',\'name\'] | filter:ccSelectFilter\">{{cc.name}}</md-option></md-select>\n</md-input-container>");
$templateCache.put("app/main/config/views/constants/filters/clients.html","<md-input-container class=\"md-block\" flex md-no-float><label>Cliente</label><md-select \nng-model=\"F.search.constants.client\" class=\"filter\" required><md-select-header><input autocomplete=\"off\" type=\"search\" \nclass=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"clientSelectFilter\" placeholder=\"Busque un cliente\">\n</md-select-header><md-option ng-value=\"client.$id\" \nng-repeat=\"client in clients | orderBy:\'name\' | filter:clientSelectFilter\">{{client.name}}</md-option></md-select>\n</md-input-container>");
$templateCache.put("app/main/config/views/constants/filters/employees.html","<md-input-container class=\"md-block\" flex md-no-float><label>Empleado</label><md-select \nng-change=\"changeMainRef(F.search.constants.employee)\" ng-model=\"F.search.constants.employee\" class=\"filter\" required>\n<md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" \nng-model=\"employeeSelectFilter\" placeholder=\"Busque un empleado\"></md-select-header><md-option \nng-if=\'F.active.menuAction == \"list\"\' ng-value=\'\"all\"\'>TODOS</md-option><md-option ng-value=\"employee.$id\" \nng-repeat=\"employee in employees | orderBy:\'name\' | filter:employeeSelectFilter\">{{employee.nss}} - {{employee.name}}\n</md-option></md-select></md-input-container>");
$templateCache.put("app/main/config/views/constants/filters/payrolls.html","<md-input-container class=\"md-block\" flex md-no-float><label>Nómina</label><md-select \nng-change=\"changeMainRef(F.search.constants.payroll)\" ng-model=\"F.search.constants.payroll\" class=\"filter\" required>\n<md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" \nng-model=\"payrollSelectFilter\" placeholder=\"Busque una nómina\"></md-select-header><md-option \nng-if=\"!F.permissionToAccessAllPayrolls\" ng-value=\"payroll.$id\" ng-disabled=\"!payroll.active\" \nng-repeat=\"payroll in L.payrolls | orderBy : [\'-active\',\'name\'] | filter:payrollSelectFilter\">{{payroll.name}}\n</md-option><md-option ng-if=\"F.permissionToAccessAllPayrolls\" ng-value=\"payroll.$id\" ng-disabled=\"!payroll.active\" \nng-repeat=\"payroll in L.allPayrolls | orderBy : [\'-active\',\'name\'] | filter:payrollSelectFilter\">{{payroll.name}}\n</md-option></md-select></md-input-container>");
$templateCache.put("app/main/config/views/constants/filters/placesofwork.html","<md-input-container class=\"md-block\" flex md-no-float><label>Lugar de Trabajo</label><md-select \nng-change=\"changeMainRef(F.search.constants.placeOfWork)\" ng-model=\"F.search.constants.placeOfWork\" class=\"filter\" \nrequired><md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" \nng-keydown=\"$event.stopPropagation()\" ng-model=\"placeOfWorkSelectFilter\" placeholder=\"Busque un lugar de trabajo\">\n</md-select-header><md-option ng-value=\"placeOfWork._id\" \nng-repeat=\"placeOfWork in M.placesOfWorkRecords | orderBy:\'name\' | filter:placeOfWorkSelectFilter\">{{placeOfWork.name}}\n</md-option></md-select></md-input-container>");
$templateCache.put("app/main/config/views/constants/tabs/cc.html","<md-tab-body><div class=\"filterToolbar md-padding\"><div layout-gt-xs=\"row\" layout-align=\"space-between center\"><div \nfilter-constants-payrolls></div><div filter-constants-ccs></div></div></div><div table-loader array=\"constantsF\" \nvalidations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"constantsF.length\"><thead md-head md-order=\"order\" \nfix-head><tr md-row><th md-column><span>Centro de Costo</span></th><th md-column><span>Tipo de incidencia/Campo</span>\n</th><th md-column md-order-by=\"type\"><span>Tipo de constante</span></th><th md-column><span>Valores</span></th></tr>\n</thead><tbody md-body><tr md-row md-auto-select md-select=\"constant\" md-select-id=\"$id\" \nng-repeat=\'constant in (F.filteredItems = (constantsF | filterByPropName:F.search.constant:\"incidencesType\":allIncidences | orderBy:order)) | limitTo: F.paginate: (currentPage - 1) * F.paginate\'>\n<td md-cell>{{constant.cc|nameOfL:ccs}}</td><td md-cell ng-if=\"constant.type==\'affectIncidenceProperty\'\">\n{{constant.affectProperty.property | nameOfL:L.calcFields}}</td><td md-cell \nng-if=\"constant.type!=\'affectIncidenceProperty\'\">{{constant.incidencesType | nameOfL:allIncidences}}</td><td md-cell>\n{{F.constantTypes[constant.type].name}}</td><td md-cell ng-if=\'constant.type == \"automaticApply\"\'>Cada: <b \nng-if=\'constant.each == \"days\"\'>{{constant.automaticApply.days}}</b>\n {{\'c.\' + constant.automaticApply.each | translate}} Desde: <span ng-if=\"constant.automaticApply.from\">\n{{constant.automaticApply.from | date}}</span> <span ng-if=\"!constant.automaticApply.from\">Próximo periodo aplicable\n</span> Hasta: <span ng-if=\"constant.automaticApply.to\">{{constant.automaticApply.to | date}}</span> <span \nng-if=\"!constant.automaticApply.to\">Sin terminación</span></td><td md-cell ng-if=\'constant.type == \"notApply\"\'>\nIncidencias <b ng-if=\"constant.notApply.automatic\">Automáticas </b><b ng-if=\"constant.notApply.manual\">Manuales </b><b \nng-if=\"constant.notApply.fast\">Rápidas</b></td><td md-cell \nng-if=\'constant.type == \"affectIncidenceValue\"||constant.type == \"affectIncidenceTotal\"\'><b>\n{{\'o.\' + constant.affect.operator | translate}} </b><span>{{constant.affect.value}}</span></td><td md-cell \nng-if=\'constant.type == \"affectIncidenceProperty\"\'>{{constant.affectProperty.value}}</td></tr></tbody></table>\n</md-table-container><md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" \nng-show=\"constantsF.length\" md-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" md-limit-options=\"F.paginations\" \nmd-page=\"currentPage\" md-on-paginate=\"restartSelected\" md-total=\"{{F.filteredItems.length}}\" md-page-select>\n</md-table-pagination></md-tab-body>");
$templateCache.put("app/main/config/views/constants/tabs/employee.html","<md-tab-body><div class=\"filterToolbar md-padding\"><div layout-gt-xs=\"row\" layout-align=\"space-between center\"><div \nfilter-constants-payrolls></div><div filter-constants-employees></div></div></div><div table-loader array=\"constantsF\" \nvalidations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"constantsF.length\"><thead md-head md-order=\"order\" \nfix-head><tr md-row><th md-column><span>Tipo de incidencia/Campo</span></th><th md-column md-order-by=\"type\"><span>\nTipo de constante</span></th><th md-column><span>Valores</span></th></tr></thead><tbody md-body><tr md-row \nmd-auto-select md-select=\"constant\" md-select-id=\"$id\" \nng-repeat=\'constant in (F.filteredItems = (constantsF | filterByPropName:F.search.constant:\"incidencesType\":allIncidences | orderBy:order)) | limitTo: F.paginate: (currentPage - 1) * F.paginate\'>\n<td md-cell>{{constant.employee|nameOfL:employees}}</td><td md-cell ng-if=\"constant.type==\'affectIncidenceProperty\'\">\n{{constant.affectProperty.property | nameOfL:L.calcFields}}</td><td md-cell \nng-if=\"constant.type!=\'affectIncidenceProperty\'\">{{constant.incidencesType | nameOfL:allIncidences}}</td><td md-cell>\n{{F.constantTypes[constant.type].name}}</td><td md-cell ng-if=\'constant.type == \"automaticApply\"\'>Cada: <b \nng-if=\'constant.each == \"days\"\'>{{constant.automaticApply.days}}</b>\n {{\'c.\' + constant.automaticApply.each | translate}} Desde: <span ng-if=\"constant.automaticApply.from\">\n{{constant.automaticApply.from | date}}</span> <span ng-if=\"!constant.automaticApply.from\">Próximo periodo aplicable\n</span> Hasta: <span ng-if=\"constant.automaticApply.to\">{{constant.automaticApply.to | date}}</span> <span \nng-if=\"!constant.automaticApply.to\">Sin terminación</span></td><td md-cell ng-if=\'constant.type == \"notApply\"\'>\nIncidencias <b ng-if=\"constant.notApply.automatic\">Automáticas </b><b ng-if=\"constant.notApply.manual\">Manuales </b><b \nng-if=\"constant.notApply.fast\">Rápidas</b></td><td md-cell \nng-if=\'constant.type == \"affectIncidenceValue\"||constant.type == \"affectIncidenceTotal\"\'><b>\n{{\'o.\' + constant.affect.operator | translate}} </b><span>{{constant.affect.value}}</span></td><td md-cell \nng-if=\'constant.type == \"affectIncidenceProperty\"\'>{{constant.affectProperty.value}}</td></tr></tbody></table>\n</md-table-container><md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" \nng-show=\"constantsF.length\" md-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" md-limit-options=\"F.paginations\" \nmd-page=\"currentPage\" md-on-paginate=\"restartSelected\" md-total=\"{{F.filteredItems.length}}\" md-page-select>\n</md-table-pagination></md-tab-body>");
$templateCache.put("app/main/config/views/constants/tabs/general.html","<md-tab-body><div table-loader array=\"constantsF\" validations=\"validations\"></div><md-table-container \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table md-row-select \nmultiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"constantsF.length\"><thead md-head md-order=\"order\" \nfix-head><tr md-row><th md-column><span>Tipo de incidencia/Campo</span></th><th md-column md-order-by=\"type\"><span>\nTipo de constante</span></th><th md-column><span>Valores</span></th></tr></thead><tbody md-body><tr md-row \nmd-auto-select md-select=\"constant\" md-select-id=\"$id\" \nng-repeat=\'constant in (F.filteredItems = (constantsF | filterByPropName:F.search.constant:\"incidencesType\":allIncidences | orderBy:order)) | limitTo: F.paginate: (currentPage - 1) * F.paginate\'>\n<td md-cell ng-if=\"constant.type==\'affectIncidenceProperty\'\">\n{{constant.affectProperty.property | nameOfL:L.calcFields}}</td><td md-cell \nng-if=\"constant.type!=\'affectIncidenceProperty\'\">{{constant.incidencesType | nameOfL:allIncidences}}</td><td md-cell>\n{{F.constantTypes[constant.type].name}}</td><td md-cell ng-if=\'constant.type == \"automaticApply\"\'>Cada: <b \nng-if=\'constant.each == \"days\"\'>{{constant.automaticApply.days}}</b>\n {{\'c.\' + constant.automaticApply.each | translate}} Desde: <span ng-if=\"constant.automaticApply.from\">\n{{constant.automaticApply.from | date}}</span> <span ng-if=\"!constant.automaticApply.from\">Próximo periodo aplicable\n</span> Hasta: <span ng-if=\"constant.automaticApply.to\">{{constant.automaticApply.to | date}}</span> <span \nng-if=\"!constant.automaticApply.to\">Sin terminación</span></td><td md-cell ng-if=\'constant.type == \"notApply\"\'>\nIncidencias <b ng-if=\"constant.notApply.automatic\">Automáticas </b><b ng-if=\"constant.notApply.manual\">Manuales </b><b \nng-if=\"constant.notApply.fast\">Rápidas</b></td><td md-cell \nng-if=\'constant.type == \"affectIncidenceValue\"|| constant.type == \"affectIncidenceTotal\"\'><b>\n{{\'o.\' + constant.affect.operator | translate}} </b><span>{{constant.affect.value}}</span></td><td md-cell \nng-if=\'constant.type == \"affectIncidenceProperty\"\'>{{constant.affectProperty.value}}</td></tr></tbody></table>\n</md-table-container><md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" \nng-show=\"constantsF.length\" md-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" md-limit-options=\"F.paginations\" \nmd-page=\"currentPage\" md-on-paginate=\"restartSelected\" md-total=\"{{F.filteredItems.length}}\" md-page-select>\n</md-table-pagination></md-tab-body>");
$templateCache.put("app/main/config/views/constants/tabs/payroll.html","<md-tab-body><div class=\"filterToolbar md-padding\"><div layout-gt-xs=\"row\" layout-align=\"space-between center\"><div \nfilter-constants-payrolls></div></div></div><div table-loader array=\"constantsF\" validations=\"validations\"></div>\n<md-table-container class=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table \nmd-row-select multiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"constantsF.length\"><thead md-head \nmd-order=\"order\" fix-head><tr md-row><th md-column><span>Tipo de incidencia/Campo</span></th><th md-column \nmd-order-by=\"type\"><span>Tipo de constante</span></th><th md-column><span>Valores</span></th></tr></thead><tbody \nmd-body><tr md-row md-auto-select md-select=\"constant\" md-select-id=\"$id\" \nng-repeat=\'constant in (F.filteredItems = (constantsF | filterByPropName:F.search.constant:\"incidencesType\":allIncidences | orderBy:order)) | limitTo: F.paginate: (currentPage - 1) * F.paginate\'>\n<td md-cell ng-if=\"constant.type==\'affectIncidenceProperty\'\">\n{{constant.affectProperty.property | nameOfL:L.calcFields}}</td><td md-cell \nng-if=\"constant.type!=\'affectIncidenceProperty\'\">{{constant.incidencesType | nameOfL:allIncidences}}</td><td md-cell>\n{{F.constantTypes[constant.type].name}}</td><td md-cell ng-if=\'constant.type == \"automaticApply\"\'>Cada: <b \nng-if=\'constant.each == \"days\"\'>{{constant.automaticApply.days}}</b>\n {{\'c.\' + constant.automaticApply.each | translate}} Desde: <span ng-if=\"constant.automaticApply.from\">\n{{constant.automaticApply.from | date}}</span> <span ng-if=\"!constant.automaticApply.from\">Próximo periodo aplicable\n</span> Hasta: <span ng-if=\"constant.automaticApply.to\">{{constant.automaticApply.to | date}}</span> <span \nng-if=\"!constant.automaticApply.to\">Sin terminación</span></td><td md-cell ng-if=\'constant.type == \"notApply\"\'>\nIncidencias <b ng-if=\"constant.notApply.automatic\">Automáticas </b><b ng-if=\"constant.notApply.manual\">Manuales </b><b \nng-if=\"constant.notApply.fast\">Rápidas</b></td><td md-cell \nng-if=\'constant.type == \"affectIncidenceTotal\"||constant.type == \"affectIncidenceValue\"\'><b>\n{{\'o.\' + constant.affect.operator | translate}} </b><span>{{constant.affect.value}}</span></td><td md-cell \nng-if=\'constant.type == \"affectIncidenceProperty\"\'>{{constant.affectProperty.value}}</td></tr></tbody></table>\n</md-table-container><md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" layout-xs=\"column\" \nng-show=\"constantsF.length\" md-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" md-limit-options=\"F.paginations\" \nmd-page=\"currentPage\" md-on-paginate=\"restartSelected\" md-total=\"{{F.filteredItems.length}}\" md-page-select>\n</md-table-pagination></md-tab-body>");
$templateCache.put("app/main/config/views/constants/tabs/place-of-work.html","<md-tab-body><div class=\"filterToolbar md-padding\"><div layout-gt-xs=\"row\" layout-align=\"space-between center\"><div \nfilter-constants-placesofwork></div></div></div><div table-loader array=\"constantsF\" validations=\"validations\"></div>\n<md-table-container class=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table \nmd-row-select multiple=\"true\" ng-model=\"selected\" class=\"row-border\" ng-show=\"constantsF.length\"><thead md-head \nmd-order=\"order\" fix-head><tr md-row><th md-column md-order-by=\"concept\"><span>Tipo de incidencia</span></th><th \nmd-column md-order-by=\"type\"><span>Tipo de constante</span></th><th md-column><span>Valores</span></th></tr></thead>\n<tbody md-body><tr md-row md-auto-select md-select=\"constant\" md-select-id=\"$id\" \nng-repeat=\"constant in (F.filteredItems = (constantsF | filter:F.searchText.constant | orderBy:order)) | limitTo: F.paginate: (currentPage - 1) * F.paginate\">\n<td md-cell ng-if=\"constant.type==\'affectIncidenceProperty\'\">\n{{constant.affectProperty.property | nameOfL:L.calcFields}}</td><td md-cell \nng-if=\"constant.type!=\'affectIncidenceProperty\'\">{{constant.incidencesType | nameOfL:allIncidences}}</td><td md-cell>\n{{F.constantTypes[constant.type].name}}</td><td md-cell ng-if=\'constant.type == \"automaticApply\"\'>Cada: <b \nng-if=\'constant.each == \"days\"\'>{{constant.automaticApply.days}}</b>\n {{\'c.\' + constant.automaticApply.each | translate}} Desde: <span ng-if=\"constant.automaticApply.from\">\n{{constant.automaticApply.from | date}}</span> <span ng-if=\"!constant.automaticApply.from\">Próximo periodo aplicable\n</span> Hasta: <span ng-if=\"constant.automaticApply.to\">{{constant.automaticApply.to | date}}</span> <span \nng-if=\"!constant.automaticApply.to\">Sin terminación</span></td><td md-cell ng-if=\'constant.type == \"notApply\"\'>\nIncidencias <b ng-if=\"constant.notApply.automatic\">Automáticas </b><b ng-if=\"constant.notApply.manual\">Manuales </b><b \nng-if=\"constant.notApply.fast\">Rápidas</b></td><td md-cell \nng-if=\'constant.type == \"affectIncidenceValue\" || constant.type == \"affectIncidenceTotal\" \'><b>\n{{\'o.\' + constant.affect.operator | translate}} </b><span>{{constant.affect.value}}</span></td><td md-cell \nng-if=\'constant.type == \"affectIncidenceProperty\"\'><span>{{\'o.\' + constant.affectProperty.property | translate}}</span>\n <b>{{\'o.\' + constant.affectProperty.operator | translate}} </b><span>{{constant.affectProperty.value}}</span></td>\n</tr></tbody></table></md-table-container><md-table-pagination layout-align=\"start center\" layout-gt-xs=\"row\" \nlayout-xs=\"column\" ng-show=\"constantsF.length\" md-label=\"{{F.paginationLabel}}\" md-limit=\"F.paginate\" \nmd-limit-options=\"F.paginations\" md-page=\"currentPage\" md-on-paginate=\"restartSelected\" \nmd-total=\"{{F.filteredItems.length}}\" md-page-select></md-table-pagination></md-tab-body>");
$templateCache.put("app/main/config/views/imports/dialogs/validation-row.html","<md-dialog class=\"customDialog\" id=\"validationDialog\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 flex>\nDetalle de Validación de {{iType|importTypeName:1}}</h2><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close Dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div \nclass=\"md-dialog-content\" layout=\"column\"><div flex layout=\"column\"><div flex layout-gt-sm=\"row\" \nlayout-align=\"space-between center\"><ul class=\"infoUl\"><li ng-repeat=\"(field, validation) in row.config.validations\">\n<strong>{{field}}:</strong> {{validation}} <a ng-if=\'field == \"id\" && iType == \"employees\"\' ng-click=\"cancel()\" \nui-sref=\'app.captures.employees.read({ employeeId: row[field + \"-unique\"].new, movementId: null})\' class=\"righted\">\n<md-icon md-font-icon=\"icon-info\" aria-label=\"info\"></md-icon>{{iType|importTypeName:1}} Registrado </a><a \nng-if=\'field == \"id\" && iType == \"movements\"\' ng-click=\"cancel()\" \nui-sref=\'app.movements.movements.read({ movementId: row[field + \"-unique\"].new, employeeId: null})\' class=\"righted\">\n<md-icon md-font-icon=\"icon-info\" aria-label=\"info\"></md-icon>{{iType|importTypeName:1}} previamente registrado</a>\n</li></ul><p ng-if=\'row[\"rp-rp\"]==\"00000000000\" && type == \"info\"\'>\nEl empleado esta asignado a un registro patronal no fiscal, por lo que si no tiene un movimiento histórico de alta, es recomendable activar la creación de un movimiento de alta por default.\n</p><p ng-if=\'row[\"rp-rp\"]!=\"00000000000\" && type == \"info\" && !row.id && row.estatus == 1\'>\nEl empleado no tiene id y está en status 1, por lo que es recomendable activar la creación de un movimiento de alta.\n</p></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-if=\'type == \"info\" && !row.config.createMovement && row[\"rp-rp\"]==\"00000000000\"\' \nng-click=\"createMovement(row, true);cancel();\" class=\"md-raised md-background md-primary md-hue-2\" \naria-label=\"Especial Yes\"><span>Crear Movimiento Default</span></md-button><md-button \nng-if=\'type == \"info\" && row.config.createMovement && row[\"rp-rp\"]==\"00000000000\"\' \nng-click=\"createMovement(row, false);cancel();\" class=\"md-raised md-background md-warn md-hue-3\" \naria-label=\"Especial No\"><span>No Crear Movimiento Default</span></md-button><md-button \nng-if=\'type == \"info\" && !row.config.createMovementType && row[\"rp-rp\"]!=\"00000000000\" && row.estatus == 1\' \nng-click=\"createMovementType(row, true);cancel();\" class=\"md-raised md-background md-primary md-hue-2\" \naria-label=\"Especial Yes\"><span>Crear Movimiento Inicial</span></md-button><md-button \nng-if=\'type == \"info\" && row.config.createMovementType && row[\"rp-rp\"]!=\"00000000000\" && row.estatus == 1\' \nng-click=\"createMovementType(row, false);cancel();\" class=\"md-raised md-background md-warn md-hue-3\" \naria-label=\"Especial No\"><span>No Crear Movimiento Inicial</span></md-button><md-button \nng-if=\"!row.config.permiteException && !row.config.valid\" ng-click=\"permiteException(row, true);cancel();\" \nclass=\"md-raised md-background md-warn md-hue-2\" aria-label=\"Exception\"><span>Permitir Excepciones</span></md-button>\n<md-button ng-if=\"row.config.permiteException && !row.config.valid\" ng-click=\"permiteException(row, false);cancel();\" \nclass=\"md-raised md-background md-accent md-hue-2\" aria-label=\"Exception\"><span>No Permitir Excepciones</span>\n</md-button><md-button ng-click=\"removeRow(row);cancel();\" class=\"md-raised md-background md-warn md-hue-2\" \naria-label=\"Delete\"><span>Borrar Registro</span></md-button><md-button ng-click=\"cancel()\" \nclass=\"md-raised md-background md-warn md-hue-1\" aria-label=\"Cancelar\"><span>Cerrar</span></md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/config/views/incidences-types/dialogs/payrollSelector.html","<md-dialog aria-label=\"Mango (Fruit)\"><form name=\"payrollSelectorForm\" ng-cloak><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Copiar {{selected.length}} Incidencias Seleccionadas</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-font-icon=\"icon-window-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><div layout-gt-xs=\"row\" \nlayout=\"column\"><md-input-container class=\"md-block\" flex><label>Nómina Destino</label><md-select \nng-model=\"destinationPayroll\" required name=\"destinationPayroll\"><md-select-header><input autocomplete=\"off\" \ntype=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"destinationPayrollSelectFilter\" \nplaceholder=\"Busque una nómina\"></md-select-header><md-option ng-if=\"!F.permissionToAccessAllPayrolls\" \nng-disabled=\"(payroll.$id == originPayroll)\" ng-value=\"payroll.$id\" \nng-repeat=\"payroll in L.payrolls | orderBy:\'name\' | filter:destinationPayrollSelectFilter\">{{payroll.name}}</md-option>\n<md-option ng-if=\"F.permissionToAccessAllPayrolls\" ng-disabled=\"(payroll.$id == originPayroll)\" ng-value=\"payroll.$id\" \nng-repeat=\"payroll in L.allPayrolls | orderBy:\'name\' | filter:destinationPayrollSelectFilter\">{{payroll.name}}\n</md-option></md-select><div ng-messages=\"payrollSelectorForm.destinationPayroll.$error\"><div ng-message=\"required\">\nSeleccionar nómina destino</div></div></md-input-container></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button ng-disabled=\"payrollSelectorForm.$invalid || loadingProgress || payrollSelectorForm.$pristine\" \nng-click=\"copySelectedIncidences(destinationPayroll)\">Copiar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/config/views/incidences-types/dialogs/payrollsSelector.html","<md-dialog aria-label=\"Mango (Fruit)\"><form name=\"payrollSelectorForm\" ng-cloak><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Clonar Incidencias</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-font-icon=\"icon-window-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><div layout-gt-xs=\"row\" layout=\"column\">\n<md-input-container class=\"md-block\" flex><label>Nómina Origen</label><md-select ng-model=\"originPayroll\" required \nname=\"originPayroll\"><md-select-header><input autocomplete=\"off\" type=\"search\" class=\"md-text\" \nng-keydown=\"$event.stopPropagation()\" ng-model=\"originPayrollSelectFilter\" placeholder=\"Busque una nómina\">\n</md-select-header><md-option ng-if=\"!F.permissionToAccessAllPayrolls\" ng-value=\"payroll.$id\" \nng-repeat=\"payroll in L.payrolls | orderBy:\'name\' | filter:originPayrollSelectFilter\">{{payroll.name}}</md-option>\n<md-option ng-if=\"F.permissionToAccessAllPayrolls\" ng-value=\"payroll.$id\" \nng-repeat=\"payroll in L.allPayrolls | orderBy:\'name\' | filter:originPayrollSelectFilter\">{{payroll.name}}</md-option>\n</md-select><div ng-messages=\"payrollSelectorForm.originPayroll.$error\"><div ng-message=\"required\">\nSeleccionar nómina origen</div></div></md-input-container><md-input-container class=\"md-block\" flex><label>\nNómina Destino</label><md-select ng-model=\"destinationPayroll\" required name=\"destinationPayroll\"><md-select-header>\n<input autocomplete=\"off\" type=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" \nng-model=\"destinationPayrollSelectFilter\" placeholder=\"Busque una nómina\"></md-select-header><md-option \nng-if=\"!F.permissionToAccessAllPayrolls\" ng-disabled=\"(payroll.$id == originPayroll)\" ng-value=\"payroll.$id\" \nng-repeat=\"payroll in L.payrolls | orderBy:\'name\' | filter:destinationPayrollSelectFilter\">{{payroll.name}}</md-option>\n<md-option ng-if=\"F.permissionToAccessAllPayrolls\" ng-disabled=\"(payroll.$id == originPayroll)\" ng-value=\"payroll.$id\" \nng-repeat=\"payroll in L.allPayrolls | orderBy:\'name\' | filter:destinationPayrollSelectFilter\">{{payroll.name}}\n</md-option></md-select><div ng-messages=\"payrollSelectorForm.destinationPayroll.$error\"><div ng-message=\"required\">\nSeleccionar nómina destino</div></div></md-input-container></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button ng-disabled=\"payrollSelectorForm.$invalid || loadingProgress || payrollSelectorForm.$pristine\" \nng-click=\"copyIncidences(originPayroll,destinationPayroll)\">Copiar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/config/views/operationConstants/dialogs/import-operation-constants.html","<md-dialog stop-touch-event aria-label=\"Import Operation Constants\" id=\"dialogImportContant\"><form name=\"stepper\" \nclass=\"importEmployees\" ms-stepper ng-submit=\"impOpeConstCtrl.applyCalculations()\" ng-model=\"stepper\" novalidate><div \nng-if=\"impOpeConstCtrl.loading\"><md-progress-linear md-mode=\"indeterminate\"></md-progress-linear><span \nclass=\"md-subhead\">Cargando..</span></div><div><ms-stepper-step ng-form=\"step1\" step=\"1\" \nstep-title=\"\'Sube el archivo\'\"><div ng-include=\"\'app/main/config/views/operationConstants/dialogs/step-1.html\'\"></div>\n</ms-stepper-step><ms-stepper-step ng-form=\"step2\" step=\"2\" step-title=\"\'Conceptos a exportar\'\"><div \nng-include=\"\'app/main/config/views/operationConstants/dialogs/step-2.html\'\"></div></ms-stepper-step></div></form>\n</md-dialog>");
$templateCache.put("app/main/config/views/operationConstants/dialogs/step-1.html","<div id=\"dialogImportContant\" class=\"import-constants\"><div class=\"import-constants__card\"><div \nclass=\"import-constants__header\" layout=\"row\" layout-align=\"start center\"><div class=\"import-constants__titleWrap\" \nflex><div class=\"import-constants__title\">Importar constantes (CSV)</div><div class=\"import-constants__subtitle\">\nSube tu archivo CSV o descarga el template para llenarlo correctamente.</div></div></div><div \nclass=\"import-constants__body\"><div class=\"import-constants__section\"><div class=\"import-constants__label\">Archivo CSV\n</div><lf-ng-md-file-input lf-files=\"impOpeConstCtrl.filesArray\" lf-placeholder=\"Selecciona el archivo .csv\" \nlf-drag-and-drop-label=\"Arrastra y suelta aquí (Max: 10MB)\" lf-browse-label=\"{{\'EC.search\' | translate}}\" \nlf-remove-label=\"{{\'EC.remove\' | translate}}\" lf-filesize=\"10MB\" lf-required accept=\"text/csv\" lf-mimetype=\"text/csv\" \nname=\"operationFile\" lf-api=\"csvApi\"></lf-ng-md-file-input><div class=\"import-constants__errors\" \nng-messages=\"step1.operationFile.$error\"><div ng-message=\"required\">Archivo requerido</div><div ng-message=\"maxcount\">\nDemasiados archivos</div><div ng-message=\"filesize\">Archivo demasiado grande</div><div ng-message=\"totalsize\">\nEspacio total demasiado grande</div><div ng-message=\"mimetype\">Formato de archivo no válido (usa CSV)</div></div><div \nclass=\"import-constants__actions\" layout=\"row\" layout-align=\"end center\"><a class=\"import-constants__download\" \ntarget=\"_blank\" href=\"assets/csv/import-operation-constants-blanc.csv\"><md-icon md-font-icon=\"icon-file-excel\" \naria-label=\"download template\"></md-icon><span>Descargar template</span></a></div></div><div \nclass=\"import-constants__help\"><div class=\"import-constants__helpTitle\" layout=\"row\" layout-align=\"end center\"><div>\n<md-icon md-font-icon=\"icon-information-outline\" aria-label=\"info\"></md-icon></div><span>Instrucciones rápidas</span>\n</div><div class=\"import-constants__helpBlock\"><div class=\"import-constants__helpHeading\">Campos obligatorios</div><div\n class=\"import-constants__chips\"><span class=\"chip\">Tipo_constante</span> <span class=\"chip\">Aplicar_a</span> <span \nclass=\"chip\">Tipo_aplicacion</span> <span class=\"chip\">Elemento</span> <span class=\"chip\">Valor</span></div></div><br>\n<div class=\"import-constants__helpBlock\"><div class=\"import-constants__helpHeading\">Qué significa cada columna</div>\n<div class=\"import-constants__table\"><div class=\"import-constants__row import-constants__row--head\"><div>Columna</div>\n<div>Descripción</div><div>Valores</div></div><div class=\"import-constants__row\"><div class=\"key\">Tipo_aplicacion</div>\n<div>Define a qué nivel se aplica.</div><div class=\"val\">1 Nómina · 2 Centro de costo · 3 Empleado</div></div><div \nclass=\"import-constants__row\"><div class=\"key\">Aplicar_a</div><div>Referencia según el tipo de aplicación.</div><div \nclass=\"val\">Clase nómina · Id Centro de costo · Numero de empleado</div></div><div class=\"import-constants__row\"><div \nclass=\"key\">Tipo_constante</div><div>Tipo de regla para la constante.</div><div class=\"val\">\n1 Aplicar automatico · 2 No aplicar · 3 Campo personalizado</div></div><div class=\"import-constants__row\"><div \nclass=\"key\">Elemento</div><div>Elemento a afectar.</div><div class=\"val\">ID incidencia · Llave campo personalizado\n</div></div><div class=\"import-constants__row\"><div class=\"key\">Periodicidad</div><div>Solo si <b>Tipo_constante = 1\n</b>.</div><div class=\"val\">\n1 periodo · 2 Fin del mes · 3 Inicio del mes · 4 Cumpleaños de empleado · 5 Aniversario de empleado</div></div><div \nclass=\"import-constants__row\"><div class=\"key\">Valor</div><div>Valor final de la constante.</div><div class=\"val\">Valor\n</div></div></div><div class=\"import-constants__note\">\nTip: respeta los encabezados del template (mismos nombres) y evita espacios extra.</div></div></div></div></div></div>");
$templateCache.put("app/main/config/views/operationConstants/dialogs/step-2.html","<div id=\"dialogImportContant\" class=\"import-constants\"><div class=\"import-constants__tableCard\"><div \nclass=\"import-constants__tableTop\" layout=\"row\" layout-align=\"space-between center\" layout-wrap><div \nclass=\"import-constants__tableTitleWrap\"><div class=\"import-constants__tableTitle\">Vista previa de importación</div>\n<div class=\"import-constants__tableSubtitle\">Revisa errores antes de aplicar. Puedes buscar por constante/elemento.\n</div></div><div class=\"import-constants__search\" layout=\"row\" layout-align=\"start center\"><md-icon \nclass=\"import-constants__searchIcon\" md-font-icon=\"icon-magnify\" aria-label=\"buscar\"></md-icon><input type=\"text\" \nplaceholder=\"Buscar Elemento\" ng-model-options=\"{ debounce: F.debounceTime }\" ng-model=\"importSearch\"></div></div><div \nclass=\"import-constants__tableScroll\"><table class=\"import-constants__table\"><thead><tr><th class=\"col-sticky-left\">\nElemento (registro)</th><th>Tipo de aplicación</th><th>Periodicidad</th><th>Elemento</th><th class=\"col-right\">Valor\n</th></tr></thead><tbody><tr \nng-repeat=\"record in impOpeConstCtrl.data | filter : importSearch | orderBy : [\'-errors\',\'recordNumber\']\" \nng-class=\"{\'row-has-error\': record.errors.length>0, \'row-applied\': record.applied}\"><td \nclass=\"col-sticky-left cell-strong\"><span class=\"status\" \nng-class=\"{\r\n                      \'status--error\': record.errors.length>0,\r\n                      \'status--ok\': !record.errors.length && !record.applied,\r\n                      \'status--applied\': record.applied\r\n                    }\">\n<md-icon ng-if=\"record.errors.length>0\" md-font-icon=\"icon-sim-alert\" aria-label=\"error\"></md-icon><md-icon \nng-if=\"!record.errors.length && !record.applied\" md-font-icon=\"icon-checkbox-marked\" aria-label=\"ok\"></md-icon><md-icon\n ng-if=\"record.applied\" md-font-icon=\"icon-check-all\" aria-label=\"aplicado\"></md-icon><md-tooltip md-direction=\"right\" \nng-if=\"record.errors.length>0\"><div class=\"tooltip-list\"><div ng-repeat=\"error in record.errors\">{{error}}</div></div>\n</md-tooltip><md-tooltip md-direction=\"right\" ng-if=\"!record.errors.length && !record.applied\">Sin problemas\n</md-tooltip><md-tooltip md-direction=\"right\" ng-if=\"record.applied\">Aplicado</md-tooltip></span><div \nclass=\"cell-main\"><div class=\"cell-title\">{{record.elementToApply.name || \"No encontrado\"}} <span class=\"muted\">\n(#{{record.recordNumber}})</span></div><div class=\"cell-sub\" ng-if=\"record.fid\">Se actualizará este registro</div>\n</div></td><td>{{impOpeConstCtrl.applicationTypes[record.Tipo_constante] || \'No válido\'}}</td><td>\n{{record.periodicity? (record.periodicity | getSomethingOfArrayFB:impOpeConstCtrl.constanPeriods:\'name\':record.periodicity:\'id\'):\'No aplica para este tipo de aplicacion\'}}\n</td><td>{{record.constant.name || \"N/A\"}}</td><td class=\"col-right\">{{record.value || \"N/V\"}}</td></tr></tbody>\n</table></div></div></div>");
$templateCache.put("app/main/config/views/tickets/forms/form-ticket.html","<div flex layout=\"column\"><div flex=\"nogrow\" layout-gt-xs=\"row\" layout=\"column\"><div flex=\"nogrow\" flex-gt-xs=\"66\" \nclass=\"pr-8\"><md-input-container class=\"md-block\"><label>Titulo</label><input ms2-autofocus class=\"uppercased\" \ntype=\"text\" name=\"title\" ng-model=\"ticket.title\" ng-model-options=\"{ debounce: F.debounceTime }\" required \nng-disabled=\"F.readMode || !editAllPermission\"><div ng-messages=\"form.title.$error\" role=\"alert\"><div \nng-message=\"required\">Titulo es requerido</div></div></md-input-container><md-input-container class=\"md-block\"><label>\nDescripción</label><textarea ng-model=\"ticket.description\" name=\"description\" rows=\"5\" required md-select-on-focus \nng-disabled=\"F.readMode  || !editAllPermission\"></textarea><div ng-messages=\"form.description.$error\" role=\"alert\"><div\n ng-message=\"required\">Descripción es requerido</div></div></md-input-container><div flex=\"nogrow\" layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex><label>Modulo</label><md-select ng-model=\"ticket.module\" \nclass=\"filter\" ng-disabled=\"F.readMode  || !editAllPermission\"><md-select-header><input ng-model=\"searchTerm\" \nng-keydown=\"$event.stopPropagation()\" aria-label=\"Buscar modulo\" type=\"search\" placeholder=\"Buscar Modulo\" \nclass=\"md-text\"></md-select-header><md-option ng-value=\"nav._id\" \nng-repeat=\"nav in F.navigationItems | filter: searchTerm track by nav._id\"><md-icon ng-if=\"nav.icon\" \nmd-font-icon=\"{{nav.icon}}\"></md-icon>{{nav.title}}</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block\" flex ng-disabled=\"F.readMode  \"><label>Prioridad</label><md-select ng-model=\"ticket.priority\" \nname=\"priority\" required ng-disabled=\"F.readMode || !editAllPermission\"><md-option \nng-repeat=\"pri in F.ticketPriority \" ng-value=\"pri.id\">{{pri.name}}</md-option></md-select><div \nng-messages=\"form.priority.$error\" role=\"alert\"><div ng-message=\"required\">Prioridad es requerido</div></div>\n</md-input-container></div></div><div flex=\"nogrow\" flex-gt-xs=\"33\"><div class=\"upload-button\" layout=\"column\"><span \nclass=\"md-title text-center\">Captura de pantalla</span><lf-ng-md-file-input ng-show=\"!ticket.file\" lf-files=\"files\" \nng-disabled=\"F.readMode\" lf-mimetype=\"image/png|image/gif|image/jpg|image/jpeg|application/pdf\" \nlf-placeholder=\"Solo PNG, JPG, GIF o PDF - Max. 2MB\" lf-drag-and-drop-label=\"Arrastre aquí\" lf-browse-label=\"Buscar\" \nlf-remove-label=\"Remover\" lf-on-file-remove=\"form.$setDirty();\" lf-filesize=\"2MB\" name=\"confirmationFile\" \nlf-api=\"imageApi\" progress preview drag></lf-ng-md-file-input><div ng-messages=\"form.confirmationFile.$error\" \nstyle=\"color:red\"><div ng-message=\"required\">Archivo de confirmación requerido</div><div ng-message=\"maxcount\">\nDemaciados archivos</div><div ng-message=\"filesize\">Archivo demaciado grande</div><div ng-message=\"totalsize\">\nEl peso total es demaciado</div><div ng-message=\"mimetype\">Tipo de archivo inválido</div></div></div><div \nlayout=\"column\" layout-align=\"center center\" style=\"max-height: 300px\"><img flex style=\"object-fit: contain\" \nng-show=\'ticket.file && ticket.file.indexOf(\".pdf\") == -1\' ng-src=\"{{ticket.file}}\" alt=\"Archivo de Confirmación\">\n</div><div layout=\"row\" layout-align=\"center center\"><div flex=\"nogrow\"><md-button class=\"md-primary\" \nng-show=\"ticket.file\" target=\"_blanc\" ng-href=\"{{ticket.file}}\"><md-icon md-font-icon=\"icon-file-pdf\" aria-label=\"PDF\">\n</md-icon>{{ticket.file.indexOf(\".pdf\") !== -1?\'Archivo Adjunto\':\'Mostrar en otra ventana\'}}</md-button></div><div \nflex=\"nogrow\"><md-button ng-if=\"ticket.file || editAllPermission\" with-permission action=\"update\" \naccess=\"{{F.active.menuItem}}\" ng-click=\"removeUpload(F.active.detailObject)\" \nng-show=\"F.active.detailObject[F.active.imageName]\" class=\"md-warn md-raised md-background md-icon-button\" \naria-label=\"Delete file\" ng-disabled=\"loadingProgress \"><md-tooltip md-direction=\"left\">Borrar adjunto</md-tooltip>\n<md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div></div></div></div><div flex><div layout=\"column\" \nlayout-gt-xs=\"row\"><span class=\"md-title\" flex>Seguimientos</span><div flex flex-gt-xs=\"nogrow\"><md-button \nng-if=\"!F.addMode\" with-permission action=\"addTracking\" access=\"{{F.active.menuItem}}\" class=\"md-primary\" \nng-click=\"actions.showAddTracking=true\">Añadir Seguimiento</md-button></div></div><div layout=\"column\" \nlayout-gt-xs=\"row\" ng-if=\"actions.showAddTracking\" layout-align=\"start center\"><div flex><md-input-container \nclass=\"md-block\" md-no-float><input type=\"text\" name=\"newTracking\" ng-model=\"actions.newTracking\" required \nplaceholder=\"Nuevo seguimiento\"><div ng-messages=\"form.newTracking.$error\" role=\"alert\"><div ng-message=\"required\">\nDebe insertar un mensaje</div></div></md-input-container></div><div flex flex-gt-xs=\"nogrow\"><md-button \nclass=\"md-icon-button\" ng-disabled=\"!actions.newTracking\" ng-click=\"addTracking(actions.newTracking)\" \naria-label=\"Save\"><md-icon md-font-icon=\"icon-content-save\"></md-icon></md-button></div><div flex flex-gt-xs=\"nogrow\">\n<md-button class=\"md-icon-button\" aria-label=\"Cancel\" ng-click=\"actions.showAddTracking=false\"><md-icon \nmd-font-icon=\"icon-cancel\"></md-icon></md-button></div></div><div><blockquote \nng-repeat=\"($index,track) in ticket.trackings | orderBy :\'-created.atTime\'\" class=\"pt-5 pb-8\" \nng-class=\"{\'reverse\':($index%2),\'md-grey-300-bg\':!track.important,\'md-blue-grey-300-bg\':track.important}\"><p \nstyle=\"word-break:break-all\">{{track.msg}}</p><footer>\n{{track.created.by | getSomethingOfArrayFB: L.profiles:\'name\':track.created.by}} - {{track.created.atTime | getDateOf}}\n</footer></blockquote></div></div></div>");
$templateCache.put("app/main/config/views/tickets/dialogs/task-manager-task.dialog.html","<md-dialog class=\"task-manager-dialog\" aria-label=\"Crear nueva tarea\"><div class=\"task-manager-dialog__header\" \nlayout=\"row\" layout-align=\"space-between center\"><div><div class=\"task-manager-dialog__title\">Crear nueva tarea</div>\n<div class=\"task-manager-dialog__subtitle\">Se relacionará automáticamente con este ticket.</div></div><md-button \nclass=\"md-icon-button\" aria-label=\"Cerrar\" ng-disabled=\"taskManager.saving\" ng-click=\"cancelTaskManagerForm()\"><md-icon\n md-font-icon=\"icon-close\"></md-icon></md-button></div><md-dialog-content><div \nclass=\"md-dialog-content task-manager-dialog__content\"><div class=\"task-manager-dialog__row\" layout=\"row\" \nlayout-xs=\"column\"><div class=\"task-manager-dialog__control\" flex=\"50\" flex-xs=\"100\"><label>Proyecto</label><md-select \nng-model=\"taskManager.project\" ng-change=\"onTaskProjectChange()\" ng-disabled=\"taskManager.saving\" \naria-label=\"Proyecto\"><md-option ng-repeat=\"project in taskManager.projects track by project._id\" ng-value=\"project\">\n{{project.title}}</md-option></md-select></div><div class=\"task-manager-dialog__control\" flex=\"50\" flex-xs=\"100\">\n<label>Sección</label><md-select ng-model=\"taskManager.sectionId\" \nng-disabled=\"!taskManager.project || taskManager.loadingSections || taskManager.saving\" aria-label=\"Sección\"><md-option\n ng-repeat=\"section in taskManager.sections track by section._id\" ng-value=\"section._id\">{{section.title}}</md-option>\n</md-select><div class=\"task-manager__hint\" \nng-if=\"taskManager.project && !taskManager.loadingSections && !taskManager.sections.length\">\nEl proyecto no tiene secciones disponibles.</div></div></div><div class=\"task-manager-dialog__control\"><label>Título\n</label><input type=\"text\" ng-model=\"taskManager.title\" ng-disabled=\"taskManager.saving\" maxlength=\"250\" \nplaceholder=\"Describe brevemente la tarea\"></div><div class=\"task-manager-dialog__control\"><label>Descripción</label>\n<textarea ng-model=\"taskManager.description\" ng-disabled=\"taskManager.saving\" rows=\"4\" maxlength=\"5000\" \nplaceholder=\"Agrega los detalles, requisitos u objetivos de la tarea\"></textarea></div><div \nclass=\"task-manager-dialog__control task-manager-dialog__priority\"><label>Prioridad</label><div \nclass=\"task-manager-dialog__priority-options\" layout=\"row\"><button type=\"button\" \nng-repeat=\"priority in taskManager.priorities track by priority.key\" ng-click=\"taskManager.priorityKey = priority.key\" \nng-disabled=\"!taskManager.project || taskManager.saving\" \nng-class=\"{\'is-selected\': taskManager.priorityKey === priority.key}\" \nng-style=\"taskManager.priorityKey === priority.key ? {\'border-color\': priority.color || \'#0d3a73\'} : {}\"><span \nclass=\"task-manager-dialog__catalog-dot\" ng-style=\"{\'background-color\': priority.color || \'#F59E0B\'}\"></span>\n {{priority.label}}</button></div></div></div></md-dialog-content><md-dialog-actions \nclass=\"task-manager-dialog__actions\" layout=\"row\" layout-align=\"end center\"><md-button \nng-click=\"cancelTaskManagerForm()\" ng-disabled=\"taskManager.saving\">Cancelar</md-button><md-button \nclass=\"md-raised md-primary\" ng-click=\"createTaskManagerTask()\" \nng-disabled=\"taskManager.saving || !taskManager.project || !taskManager.sectionId || !taskManager.priorityKey || !taskManager.title\">\n<md-progress-circular ng-if=\"taskManager.saving\" class=\"task-manager__button-progress\" md-mode=\"indeterminate\" \nmd-diameter=\"18\"></md-progress-circular><span ng-if=\"!taskManager.saving\">Crear tarea</span></md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/config/views/users/dialogs/changePassword.html","<md-dialog aria-label=\"Password Change\"><md-toolbar style=\"height:auto!important\"><div class=\"md-toolbar-tools\"><h2 \nflex>Asignar nueva contraseña</h2><md-button class=\"md-icon-button\" ng-click=\"changePassCtrl.closeDialog()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close Dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><form \nname=\"changePassCtrl.passwordForm\" id=\"passportForm\"><div layout=\"row\"><md-input-container flex><label>Contraseña\n</label><input name=\"password\" type=\"password\" autocomplete=\"new-password\" ng-change=\"changePassCtrl.validatePass()\" \nrequired ng-model=\"changePassCtrl.password\"><div ng-messages=\"changePassCtrl.passwordForm.password.$error\"><div \nng-message=\"required\">Ingrese la contraseña.</div><div ng-message=\"unmatch\">Las contraseñas no coinciden.</div></div>\n</md-input-container></div><div layout=\"row\"><md-input-container flex><label>Repetir Contraseña</label><input \nname=\"repassword\" type=\"password\" autocomplete=\"new-password\" ng-change=\"changePassCtrl.validatePass()\" required \nng-model=\"changePassCtrl.repassword\"><div ng-messages=\"changePassCtrl.passwordForm.repassword.$error\"><div \nng-message=\"required\">Repita la contraseña.</div><div ng-message=\"unmatch\">Las contraseñas no coinciden.</div></div>\n</md-input-container></div></form></md-dialog-content><md-dialog-actions><md-button \nng-disabled=\"changePassCtrl.passwordForm.$invalid \" ng-click=\"changePassCtrl.doIt()\" class=\"md-primary\">Aceptar\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/employees/views/credits/dialogsImportCredits/importCredits.html","<md-dialog id=\"importCreditsStyle\" aria-label=\"Importar créditos\" class=\"imp-dialog\" ng-cloak><md-toolbar><div \nclass=\"dialog-header\"><div class=\"title-wrap\"><md-icon md-svg-src=\"/assets/icons/csvIcon.svg\"></md-icon><div><h2 \nclass=\"dialog-title\">Importar créditos</h2><p class=\"subtitle\">Wizard de importación</p></div></div><md-button \nclass=\"md-icon-button\" aria-label=\"Cerrar\" ng-click=\"impCredCtrl.close()\"><md-icon md-svg-icon=\"close\"></md-icon>\n</md-button></div></md-toolbar><form name=\"impCredCtrl.stepper\" ms-stepper ng-model=\"impCredCtrl.stepper\" \nng-submit=\"impCredCtrl.import()\" novalidate><ms-stepper-step ng-form=\"step1\" step=\"1\" step-title=\"\'Sube tu CSV\'\"><div \nng-include=\"\'app/main/employees/views/credits/dialogsImportCredits/step1.html\'\"></div></ms-stepper-step>\n<ms-stepper-step ng-form=\"step2\" step=\"2\" step-title=\"\'Confirmación\'\"><div \nng-include=\"\'app/main/employees/views/credits/dialogsImportCredits/step3.html\'\"></div></ms-stepper-step></form>\n</md-dialog>");
$templateCache.put("app/main/employees/views/credits/dialogsImportCredits/step1.html","<section class=\"spec\"><md-icon md-svg-src=\"/assets/icons/filecode.svg\"></md-icon><div><p>Estructura requerida: <code>\nclaseNomina,numeroEmpleado,fechaDeInicio,tipoCredito,factorCredito,numeroCredito,comentarios</code> — <strong>\nfecha_de_inicio</strong> en <b>YYYY-MM-DD</b>.</p></div></section><section class=\"toolbar\"><input id=\"csvFileInput\" \ntype=\"file\" accept=\".csv,text/csv\" class=\"file-input\" \nonchange=\"angular.element(this).scope().impCredCtrl.onFilePicked(this.files)\"><label for=\"csvFileInput\" \nclass=\"file-cta md-elevation-z2\" tabindex=\"0\" role=\"button\"><md-icon md-svg-src=\"/assets/icons/select.svg\"></md-icon>\n<span>Seleccionar CSV</span></label><md-button class=\"ghost\" ng-click=\"impCredCtrl.downloadTemplate()\"><md-icon \nmd-svg-src=\"/assets/icons/downloadCsv.svg\"></md-icon>Descargar template CSV</md-button><div class=\"spacer\"></div><div \nclass=\"chips\"><span class=\"chip chip-ok\"><md-icon md-svg-icon=\"/assets/icons/true.svg\"></md-icon>\nVálidas: {{impCredCtrl.stats.valid}}</span> <span class=\"chip chip-bad\" \nng-class=\"{\'pulse\': impCredCtrl.errors.length}\"><md-icon md-svg-icon=\"/assets/icons/errorsSync.svg\"></md-icon>\nErrores: {{impCredCtrl.stats.errors}}</span></div></section><section class=\"errors\" ng-if=\"impCredCtrl.errors.length\">\n<div class=\"errors-header\" layout=\"row\" layout-align=\"start center\"><strong>\n❌ {{impCredCtrl.errors.length}} error(es) detectado(s)</strong></div><ul><li \nng-repeat=\"e in impCredCtrl.errors track by $index\"><span class=\"row\">Numero de empleado no existe: </span><span>\n{{e.error}}</span></li></ul></section><section class=\"table-wrap\" ng-if=\"impCredCtrl.preview\"><table \nclass=\"preview-table\"><thead><tr><th>🔹</th><th>Clase de nomina</th><th>Numero de empleados</th><th>Nombre Empleado\n</th><th>Fecha de inicio</th><th>Tipo de credito</th><th class=\"right\">Factor de credito</th><th>Numero de credito</th>\n<th>Comentarios</th><th>¿Activar?</th></tr></thead><tbody><tr ng-repeat=\"r in impCredCtrl.valid track by $index\"><td>\n{{$index + 1}}</td><td>{{r.payroll}}</td><td>{{r.numberEmployee}}</td><td>{{r.name}}</td><td>{{r.dateInit}}</td><td>\n{{r.typeCredit}}</td><td class=\"right\">{{r.factorCredit}}</td><td>{{r.numeroCredito}}</td><td class=\"truncate\" \ntitle=\"{{r.comentarios}}\">{{r.comentarios}}</td><td><span class=\"badge\" ng-class=\"r.validCredit ? \'on\':\'off\'\">\n{{r.validCredit ? \'Sí\':\'No\'}}</span></td></tr></tbody></table></section>");
$templateCache.put("app/main/employees/views/credits/dialogsImportCredits/step2.html","<section class=\"info-row\"><md-icon md-svg-icon=\"group\"></md-icon><div><h3>\nSe importaran {{impCredCtrl.valid.length}}, empleados</h3><p>Desea confirmar?.</p></div></section>");
$templateCache.put("app/main/employees/views/credits/dialogsImportCredits/step3.html","<section class=\"confirm-card\" ng-if=\"impCredCtrl.valid.length\"><md-icon md-svg-icon=\"/assets/icons/true.svg\"></md-icon>\n<div class=\"confirm-texts\"><h3>Se importarán <span class=\"highlight\">{{impCredCtrl.valid.length}}</span> empleado(s)\n</h3><p>¿Desea confirmar esta operación?</p></div></section><section class=\"discard-card\" \nng-if=\"!impCredCtrl.valid.length\"><md-icon md-svg-icon=\"/assets/icons/errorsSync.svg\"></md-icon><div \nclass=\"discard-texts\"><h3>Se importarán <span class=\"highlight\">{{impCredCtrl.valid.length}}</span> empleado(s)</h3><p>\n¿Desea confirmar esta operación?</p></div></section>");
$templateCache.put("app/main/employees/views/credits/dialogs/checkCredit.html","<md-dialog id=\"checkCredit\" flex=\"{{(chCredCtrl.action === \'download\') && (!chCredCtrl.creditData)? 90 : \'nogrow\'}}\" \nflex-gt-xs=\"{{(chCredCtrl.action === \'download\') && (!chCredCtrl.creditData)? 60 : \'nogrow\'}}\" \nflex-gt-sm=\"{{(chCredCtrl.action === \'download\') && (!chCredCtrl.creditData)? 40 : \'nogrow\'}}\" \nflex-gt-md=\"{{(chCredCtrl.action === \'download\') && (!chCredCtrl.creditData)? 40 : \'nogrow\'}}\" \nflex-gt-lg=\"{{(chCredCtrl.action === \'download\') && (!chCredCtrl.creditData)? 30 : \'nogrow\'}}\"><form ng-cloak \nname=\"form\"><md-toolbar><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"center center\" flex><h2>\n{{chCredCtrl.title}}</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"chCredCtrl.close()\"><md-icon \nmd-font-icon=\"icon-cancel\" aria-label=\"cancel\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div \nng-if=\"chCredCtrl.creditData && chCredCtrl.action===\'validate\'\" layout=\"column\" layout-align=\"center center\"><div \nng-if=\"chCredCtrl.creditData.credit\" flex=\"nogrow\"><md-icon md-font-icon=\"icon-checkbox-marked-circle-outline\" \naria-label=\"success\"></md-icon><span style=\"color: green\"><b>Si cuenta con crédito Infonavit</b></span></div><div \nng-if=\"!chCredCtrl.creditData.credit\" flex=\"nogrow\"><md-icon md-font-icon=\"icon-alert\" aria-label=\"alert\"></md-icon>\n<span style=\"color: red\"><b>No tiene crédito Infonavit</b></span></div></div><div class=\"creditData\"><div \nng-if=\"chCredCtrl.creditData && chCredCtrl.creditData.credit\"><table style=\"margin:auto\" \nng-class=\"{\'widerHeader\':chCredCtrl.action !== \'validate\'}\"><tr layout=\"row\" ng-if=\"chCredCtrl.action !== \'validate\'\">\n<td>Empleado:</td><td>{{chCredCtrl.creditData.data.name}}</td></tr><tr layout=\"row\" \nng-if=\"chCredCtrl.action !== \'validate\'\"><td>NSS:</td><td>{{chCredCtrl.creditData.data.nss}}</td></tr><tr layout=\"row\">\n<td>Nº de crédito:</td><td>{{chCredCtrl.creditData.data.account}}</td></tr><tr layout=\"row\"><td>Fecha de inicio:</td>\n<td>{{chCredCtrl.creditData.data.initDate}}</td></tr><tr layout=\"row\" ng-if=\"chCredCtrl.action === \'validate\'\"><td>\nProducto:</td><td>{{chCredCtrl.creditData.data.product}}</td></tr><tr layout=\"row\" \nng-if=\"chCredCtrl.action === \'validate\'\"><td>Estado:</td><td>{{chCredCtrl.creditData.data.status}}</td></tr><tr \nlayout=\"row\" ng-show=\"chCredCtrl.action!==\'validate\'\"><td>Factor:</td><td>{{chCredCtrl.creditData.data.factor}}</td>\n</tr><tr layout=\"row\" ng-show=\"chCredCtrl.action!==\'validate\'\"><td>Monto de amortización:</td><td>\n{{chCredCtrl.creditData.data.amortizationAmount}}</td></tr></table></div><div \nng-if=\"chCredCtrl.creditData && (!chCredCtrl.creditData.credit)\"><table \nstyle=\"text-align: justify; width: 100%; height: 100%\"><tr><td class=\"text-center w-100\">Mensajes: <b>\n{{chCredCtrl.creditData.msg}}</b></td></tr></table></div></div><div \nng-if=\"(!chCredCtrl.creditData) && chCredCtrl.action === \'validate\'\"><md-input-container class=\"md-block\" flex><label>\nNSS</label><input nss class=\"uppercased\" type=\"text\" name=\"nss\" ng-model=\"chCredCtrl.valueToSearch\" required><div \nng-messages=\"form.nss.$error\" role=\"alert\"><div ng-message=\"required\">NSS es requerido</div></div></md-input-container>\n</div><div ng-if=\"(!chCredCtrl.creditData) && chCredCtrl.action !== \'validate\'\"><md-autocomplete md-min-length=\"5\" \nmd-input-name=\"autocompleteField\" md-no-cache=\"true\" md-selected-item=\"chCredCtrl.selectedEmployee\" \nmd-selected-item-change=\"chCredCtrl.valueToSearch=chCredCtrl.selectedEmployee.$id\" \nmd-search-text=\"chCredCtrl.searchEmployee\" \nmd-items=\'employee in chCredCtrl.autocompleteListM(chCredCtrl.searchEmployee, \"employees\", [\"data.name\",\"data.nss\"])\' \nmd-escape-options=\"clear\" md-item-text=\"employee.data.name\" md-clear-button=\"true\" md-require-match=\"true\" \nplaceholder=\"Busque un empleado por nss o nombre\" input-aria-describedby=\"Search an employee\"><md-item-template><span \nmd-highlight-text=\"chCredCtrl.searchEmployee\">{{employee.data.name}}({{employee.data.nss}})</span></md-item-template>\n<md-not-found>No se encontró empleado con esos datos</md-not-found><div \nng-messages=\"searchForm.autocompleteField.$error\" ng-if=\"searchForm.autocompleteField.$touched\"><div \nng-message=\"md-require-match\">Seleccione un empleado de la lista</div></div></md-autocomplete></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><div ng-if=\"chCredCtrl.creditData.data.file\" flex layout=\"row\" \nlayout-align=\"start start\"><div flex=\"nogrow\"><md-button \nng-click=\"chCredCtrl.descargarAviso(chCredCtrl.creditData.data.file)\" \nclass=\"md-raised md-background md-primary md-hue-3\" aria-label=\"downloadPdf\"><md-icon \nmd-svg-src=\"/assets/icons/infonavitpdf.svg\" aria-label=\"downloadEmployeeInfonavit\"></md-icon>Descargar pdf</md-button>\n</div></div><md-button ng-if=\"!chCredCtrl.creditData\" flex=\"nogrow\" \nng-disabled=\"form.$invalid || loadingProgress || (!chCredCtrl.valueToSearch)\" \nng-click=\"chCredCtrl.checkCredit(chCredCtrl.valueToSearch)\" class=\"md-raised md-background md-accent md-hue-1\" \naria-label=\"search\">Buscar<md-icon md-font-icon=\"icon-account-search\" aria-label=\"downloadEmployeeInfonavit\"></md-icon>\n</md-button><md-button ng-if=\"chCredCtrl.creditData\" flex=\"nogrow\" ng-click=\"chCredCtrl.reset()\" \nclass=\"md-raised md-background md-accent md-hue-1\" aria-label=\"searchAgain\">Nueva Búsqueda<md-icon \nmd-font-icon=\"icon-file-find\" aria-label=\"downloadEmployeeInfonavit\"></md-icon></md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/employees/views/credits/dialogs/disabledCredits.html","<md-dialog id=\"disabledCredits\" aria-label=\"Desactivar crédito\" ng-cloak><form name=\"dcForm\" novalidate><md-toolbar \nclass=\"dc-toolbar\"><div class=\"md-toolbar-tools\"><h2 class=\"dc-title\">Desactivar crédito</h2><span flex></span>\n<md-button class=\"md-icon-button\" aria-label=\"Cerrar\" ng-click=\"dsCtrl.close()\"><md-icon \nmd-font-icon=\"icon-close-circle\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"dc-content\" \nlayout=\"column\"><p class=\"dc-lead\">¿Seguro que deseas desactivar este crédito?</p><p class=\"dc-sub\">\nEsta acción evitará futuros movimientos asociados. Puedes reactivarlo más tarde si lo necesitas.</p><md-checkbox \nclass=\"dc-check\" ng-init=\"dc.ui.settled = false\" ng-model=\"dc.ui.settled\" aria-label=\"Crédito liquidado\"><span>\nCrédito liquidado</span></md-checkbox></md-dialog-content><md-dialog-actions class=\"dc-actions\" layout=\"row\" \nlayout-align=\"end center\"><md-button ng-click=\"dsCtrl.close()\">Cancelar</md-button><md-button \nclass=\"md-raised md-warn\" ng-click=\"dsCtrl.confirmDisable(dc.ui.settled)\">Desactivar</md-button></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/employees/views/employeeFiles/dialogs/upload-many-files.html","<md-dialog aria-label=\"modal upload many files\"><form name=\"form\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 flex>\nSubir archivos masivamente</h2><md-button class=\"md-icon-button\" ng-click=\"upManyCtrl.hide()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close Dialog\"></md-icon></md-button></div></md-toolbar><div \nng-if=\"upManyCtrl.uploading\"><md-progress-linear md-mode=\"indeterminate\"></md-progress-linear><span class=\"md-subhead\">\nCargando..</span></div><md-dialog-content><div ng-show=\"upManyCtrl.showUpload\"><md-input-container class=\"md-block\">\n<label>Nómina</label><md-select ng-model=\"upManyCtrl.payroll\" name=\"payroll\" required \nng-change=\"upManyCtrl.payrollUpdated()\" ng-disabled=\"F.readMode\"><md-select-header><input autocomplete=\"off\" \ntype=\"search\" class=\"md-text\" ng-keydown=\"$event.stopPropagation()\" ng-model=\"payrollSelectFilter\" \nplaceholder=\"Busque una nómina\"></md-select-header><md-option ng-if=\"payroll.active||!F.addMode\" \nng-value=\"payroll.$id\" ng-class=\'{\"inactiveOption\":!payroll.active}\' \nng-repeat=\"payroll in (upManyCtrl.permissionToAccessAllPayrolls?upManyCtrl.allPayrolls:upManyCtrl.payrolls) | orderBy:\'class\' | filter:payrollSelectFilter\">\n{{payroll.class}} {{payroll.name}}</md-option></md-select><div ng-messages=\"form.payroll.$error\" role=\"alert\"><div \nng-message=\"required\">Nómina es requerido</div></div></md-input-container><lf-ng-md-file-input drag \nmultiple=\"multiple\" submit ng-disabled=\"!upManyCtrl.payroll\" lf-files=\"upManyCtrl.massiveFiles\" \nlf-api=\"upManyCtrl.massiveFilesApi\" lf-on-submit-click=\"upManyCtrl.processFiles\" accept=\"application/pdf\" \nlf-filesize=\"4MB\" name=\"filesToUpload\"></lf-ng-md-file-input></div><div flex layout=\"row\" \nlayout-align=\"space-between center\"><code flex=\"85\" ng-if=\"upManyCtrl.showUpload\">\nPara subir los archivos masivamente, seleccione una nómina y arrastre los archivos a la zona de carga. El archivo debe ser en formato PDF y tener la siguiente nomenclatura: Numero Empleado_Llave tipo de documento.pdf ejem: 305011_actaNacimiento.pdf\n</code><div flex-=\"15\"><md-button class=\"downloadLink\" \nng-click=\"upManyCtrl.downlandKeys(\'/interface/getKeys\', upManyCtrl.center)\">descargar llaves<md-icon \nmd-font-icon=\"icon-file-excel\" aria-label=\"download variables template\"></md-icon></md-button></div></div><div \nng-repeat=\"files in upManyCtrl.allFilesByEmployee\"><span class=\"font-weight-700\">{{files.name}}</span> <span>\n{{files.files.length}} Archivo(s)</span><div layout=\"row\" layout-wrap><div \nng-repeat=\"file in files.files | orderBy : [\'data.documentType.name\',\'error\']\" layout=\"row\"><div flex><md-card>\n<md-card-content class=\"text-center p-5\"><div layout=\"row\" layout-align=\"center center\"><div flex=\"nogrow\"><md-tooltip \nng-if=\"file.error\">{{file.error}}</md-tooltip><md-icon ng-style=\"{color: file.error ? \'red\' : \'green\'}\" \nclass=\"icon s40\" md-font-icon=\"icon-file-pdf\"></md-icon></div><div flex style=\"max-width: 150px\"><p \nclass=\"font-weight-900 font-size-12 m-0\">{{file.data.documentType.name}} <span class=\"font-size-14\" \nng-if=\"file.uploaded\">✓</span></p><p class=\"font-size-10 m-0\" style=\"word-wrap: break-word\">{{file.lfFileName}}</p>\n</div></div></md-card-content></md-card></div></div></div></div></md-dialog-content><md-dialog-actions \nng-if=\"!upManyCtrl.showUpload\"><md-button class=\"md-primary\" ng-disabled=\"upManyCtrl.uploading\" \nng-click=\"upManyCtrl.uploadingFiles()\">Subir archivos</md-button></md-dialog-actions><div flex=\"no-grow\" layout=\"row\">\n<span flex></span></div></form></md-dialog>");
$templateCache.put("app/main/employees/views/employees/dialogsEmployees/disableValidationsForEmployees.html","<md-dialog id=\"disableValidationsForEmployees\" aria-label=\"Eliminar validaciones\"><form ng-cloak novalidate><md-toolbar\n class=\"hm-toolbar\"><div class=\"hm-toolbar-wrap\" layout=\"row\" layout-align=\"start center\"><div class=\"hm-title\"><h2 \nclass=\"t1\">Eliminar validaciones</h2><p class=\"t2\">Se eliminaran validaciones para los empleados.</p></div><span flex>\n</span><md-button class=\"md-icon-button\" aria-label=\"Cerrar\" ng-click=\"dsCtrl.cancel()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"hm-content\" \nlayout=\"column\" aria-describedby=\"hm-help\"><section class=\"hm-section\"><header class=\"hm-section-header\" \nlayout=\"column\" layout-sm=\"column\" layout-xs=\"column\" layout-align=\"center center\"><div flex=\"100\"><span class=\"title\">\n<md-icon md-svg-src=\"/assets/icons/disabledValidations.svg\" aria-hidden=\"true\"></md-icon>Eliminacion de validaciones\n</span></div></header><div layout=\"row\" layout-align=\"center center\" class=\"validations-container\"><fieldset \nclass=\"validation-group\" flex=\"50\"><div class=\"mt-3\"><legend>Ignorar errores de formato</legend></div><md-checkbox \nng-model=\"dsCtrl.validations.rfcFormat\" aria-label=\"Ignorar formato de RFC\">Formato de RFC</md-checkbox><br>\n<md-checkbox ng-model=\"dsCtrl.validations.curpFormat\" aria-label=\"Ignorar formato de CURP\">Formato de CURP\n</md-checkbox><br><md-checkbox ng-model=\"dsCtrl.validations.emailRegex\" aria-label=\"Ignorar formato de Email\">\nFormato de Email</md-checkbox></fieldset><fieldset class=\"validation-group\" flex=\"50\"><div class=\"mt-3\"><legend>\nPermitir valores duplicados</legend></div><md-checkbox ng-model=\"dsCtrl.validations.uniqueRfc\" \naria-label=\"Permitir RFC existente\">RFC ya existente</md-checkbox><br><md-checkbox \nng-model=\"dsCtrl.validations.uniqueCurp\" aria-label=\"Permitir CURP existente\">CURP ya existente</md-checkbox><br>\n<md-checkbox ng-model=\"dsCtrl.validations.uniqueNss\" aria-label=\"Permitir NSS existente\">NSS ya existente</md-checkbox>\n</fieldset></div><md-card class=\"hm-alert hm-alert-warn\" id=\"hm-help\"><div><strong>Acción sensible.</strong> <span>\nEsta operación eliminara las validaciones a {{dsCtrl.selected.length}} empleados.</span></div></md-card></section>\n<md-progress-linear class=\"hm-progress\" md-mode=\"indeterminate\" ng-if=\"dsCtrl.loadingBalance\"></md-progress-linear>\n</md-dialog-content><md-dialog-actions layout=\"row\" class=\"hm-actions\"><md-button ng-click=\"dsCtrl.cancel()\">Cerrar\n</md-button><md-button class=\"md-primary md-raised\" ng-click=\"dsCtrl.deleteValidEmployees()\">Confirmar</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/employees/views/employeesVacationsRecords/dialogs/import-events.html","<md-dialog stop-touch-event aria-label=\"Import Calculations\" class=\"importDialog\"><form name=\"stepper\" \nclass=\"importEmployees\" ms-stepper ng-submit=\"impCalcCtrl.saveEvents()\" ng-model=\"stepper\" novalidate><div \nng-if=\"impCalcCtrl.loading\"><md-progress-linear md-mode=\"indeterminate\"></md-progress-linear><span class=\"md-subhead\">\nCargando..</span></div><div><ms-stepper-step ng-form=\"step1\" step=\"1\" step-title=\"\'Sube el archivo\'\"><div \nng-include=\"\'app/main/employees/views/employeesVacationsRecords/dialogs/step-1.html\'\"></div></ms-stepper-step>\n<ms-stepper-step ng-form=\"step2\" step=\"2\" step-title=\"\'Eventos a exportar\'\"><div \nng-include=\"\'app/main/employees/views/employeesVacationsRecords/dialogs/step-2.html\'\"></div></ms-stepper-step></div>\n</form></md-dialog>");
$templateCache.put("app/main/employees/views/employeesVacationsRecords/dialogs/step-1.html","<div class=\"md-inline-form\"><div style=\"max-height: 500px;overflow: auto\"><div><lf-ng-md-file-input \nlf-files=\"impCalcCtrl.filesArray\" lf-placeholder=\"Selecciona el archivo csv\" lf-drag-and-drop-label=\"csv - Max: 10MB\" \nlf-browse-label=\"{{\'EC.search\' | translate}}\" lf-remove-label=\"{{\'EC.remove\' | translate}}\" lf-filesize=\"10MB\" \nlf-required accept=\"text/csv\" lf-mimetype=\"text/csv\" name=\"operationFile\" lf-api=\"csvApi\"></lf-ng-md-file-input><div \nng-messages=\"step1.operationFile.$error\" style=\"color:red\"><div ng-message=\"required\">Archivo requerido</div><div \nng-message=\"maxcount\">Demasiados archivos</div><div ng-message=\"filesize\">Archivo demasiado grande</div><div \nng-message=\"totalsize\">Espacio total demasiado grande</div><div ng-message=\"mimetype\">Formato de archivo no valido\n</div></div></div><div layout=\"row\"><span flex></span> <a class=\"downloadLink\" target=\"_blanc\" \nhref=\"assets/csv/import-events.csv\">Descargar template<md-icon md-font-icon=\"icon-file-excel\" \naria-label=\"download variables template\"></md-icon></a></div><code style=\"text-align: justify\" ng-if=\"!operationFile\">\nEmpleado, Fecha, Evento(1-Aniversario, 2-Prescrito, 3-Ajuste(Ganadas), 4-Ajuste(Disfrutadas)), Cantidad</code></div>\n</div>");
$templateCache.put("app/main/employees/views/employeesVacationsRecords/dialogs/step-2.html","<div><div style=\"max-height: 500px;overflow: auto\"><table class=\"simple employeeCalculationsTable\"><thead \nclass=\"stickyHeader\"><tr><th class=\"stickyColumn\"><div layout=\"row\"><div flex=\"nogrow\"><md-button \nclass=\"md-fab md-icon-button md-mini md-primary no-margin no-padding\" aria-label=\"search button\" disabled=\"true\" \ntype=\"submit\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button></div><input flex type=\"text\" \nplaceholder=\"Buscar Empleado\" ng-model-options=\"{ debounce: F.debounceTime }\" ng-model=\"importSearch\"></div></th><th>\nFecha</th><th>Evento</th><th>Cantidad</th></tr></thead><tbody><tr \nng-repeat=\"record in impCalcCtrl.data | filter : importSearch | orderBy : [\'-errors\',\'recordNumber\']\"><td \nclass=\"text-bold text-left nobreak stickyColumn\"><md-button ng-if=\"record.errors.length>0\" aria-label=\"Upload File\" \nclass=\"md-icon-button md-warn md-hue-2 no-margin no-padding nospacebutton\"><md-icon md-font-icon=\"icon-sim-alert\" \naria-label=\"Upload\"></md-icon><md-tooltip md-direction=\"right\"><label ng-repeat=\"error in record.errors\">\n{{error}}{{$last?\'\':\', \'}}</label></md-tooltip></md-button><md-button ng-if=\"!record.errors.length && !record.applied\" \naria-label=\"Upload File\" class=\"md-icon-button md-primary no-margin no-padding nospacebutton\"><md-icon \nmd-font-icon=\"icon-checkbox-marked\" aria-label=\"Upload\"></md-icon><md-tooltip md-direction=\"right\">Sin problemas\n</md-tooltip></md-button><md-button ng-if=\"record.applied\" aria-label=\"Upload File\" \nclass=\"md-icon-button md-primary md-hue-2 no-margin no-padding nospacebutton\"><md-icon md-font-icon=\" icon-check-all\" \naria-label=\"Upload\"></md-icon><md-tooltip md-direction=\"right\">Aplicado</md-tooltip></md-button>\n{{record.employee.data.name || \"No encontrado\"}}({{record.recordNumber}})</td><td>{{record.Fecha.format(\'DD-MM-YYYY\')}}\n</td><td>{{record.eventType.name}}</td><td>{{record.Cantidad}}</td></tr></tbody></table></div></div>");
$templateCache.put("app/main/employees/views/employeesVacationsRecords/dialogs/vacationsRecordsHumand.html","<md-dialog id=\"humand-vacations-dialog\" aria-label=\"Envío Humand\"><form ng-cloak novalidate><md-toolbar \nclass=\"hm-toolbar\"><div class=\"md-toolbar-tools\"><md-icon class=\"hm-icon\" aria-hidden=\"true\" \nmd-svg-src=\"/assets/icons/vacation.svg\"></md-icon><h2>Balancear vacaciones Humand</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vrCtrl.close()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"hm-content\" layout=\"column\"><p class=\"hm-subtitle\">\n¿Seguro que deseas enviar los registros a Humand? Esta acción usará el estado de sincronización y balance de vacaciones.\n</p><section class=\"hm-section\"><header class=\"hm-section-header\"><span class=\"title\"><md-icon \nmd-svg-src=\"/assets/icons/true.svg\"></md-icon>Match Humand </span><span class=\"badge\">\n{{ (vrCtrl.employeeBalanced||[]).length }}</span></header><div class=\"chip-row\"><div class=\"hm-chip ok\" \nng-repeat=\"item in (vrCtrl.employeeBalanced||[]) | filter:vrCtrl.ui.search track by $index\"><md-icon class=\"dot ok\" \nmd-svg-src=\"/assets/icons/employeeSyncs.svg\"></md-icon><md-tooltip md-direction=\"top\">\nEl saldo de vacaciones coincide entre sistemas.</md-tooltip><span class=\"text\">\n{{ item.data && item.data.name || item.name }} | {{item.data.lastHolEv.total}}</span></div><div class=\"empty\" \nng-if=\"!(vrCtrl.employeeBalanced||[]).length\">Sin registros</div></div></section><section class=\"hm-section\"><header \nclass=\"hm-section-header\"><span class=\"title\"><md-icon md-svg-src=\"/assets/icons/calendarVacation.svg\"></md-icon>\nSincronizados, falta balancear </span><span class=\"badge warn\">{{ (vrCtrl.employeeNotBalanced||[]).length }}</span>\n</header><div class=\"chip-row\"><div class=\"hm-chip warn\" ng-repeat=\"item in (vrCtrl.employeeNotBalanced||[])\"><md-icon \nmd-svg-src=\"/assets/icons/balanceVacation.svg\"></md-icon><span class=\"text\">\n{{ item.data && item.data.name || item.name }} </span>|<md-icon class=\"mdIconChip\" md-svg-src=\"/assets/images/hum.svg\">\n<md-tooltip md-direction=\"top\">El saldo de vacaciones en humand.</md-tooltip></md-icon>{{item.humanDaysHolidays}}\n<md-icon class=\"mdIconChip\" md-svg-src=\"/assets/icons/tdsicon.svg\"><md-tooltip md-direction=\"top\">\nEl saldo de vacaciones en tdsystem.</md-tooltip></md-icon>{{item.data.lastHolEv.total}}</div><div class=\"empty\" \nng-if=\"!(vrCtrl.employeeNotBalanced||[]).length\">Sin registros</div></div></section><section class=\"hm-section\"><header\n class=\"hm-section-header\"><span class=\"title\"><md-icon md-svg-src=\"/assets/icons/errorsSync.svg\"></md-icon>\nNo sincronizados </span><span class=\"badge error\">{{ (vrCtrl.employeeNoSync||[]).length }}</span></header><div \nclass=\"chip-row\"><div class=\"hm-chip error\" \nng-repeat=\"item in (vrCtrl.employeeNoSync||[]) | filter:vrCtrl.ui.search track by $index\"><md-icon class=\"mdIconChip\" \nmd-svg-src=\"/assets/icons/errorUser.svg\"></md-icon><md-tooltip md-direction=\"top\">{{item.errorMessage}}</md-tooltip>\n<div class=\"text\"><div class=\"name\">{{ (item.data && item.data.name) || item.name || (\'ID \' + (item.$id||\'?\')) }}</div>\n<div class=\"sub\">Sincronización pendiente con Humand</div></div></div><div class=\"empty\" \nng-if=\"!(vrCtrl.employeeNoSync||[]).length\">Sin registros</div></div></section></md-dialog-content><md-dialog-actions \nlayout=\"row\" class=\"hm-actions\"><md-button ng-click=\"vrCtrl.close()\">CERRAR</md-button><span flex></span><md-button \nclass=\"md-primary md-raised\" ng-click=\"vrCtrl.sendBalance()\" ng-disabled=\"!vrCtrl.employeeNotBalanced.length > 0\">\nBalancear</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/employees/views/groupings/dialogs/list-employees.html","<md-bottom-sheet class=\"md-list bottomList noPaddingBotomSheet\"><div class=\"filterToolbar\"><h3>Lista de Empleados</h3>\n<p class=\"description\"><span>Descripción: </span>{{employees[0].description}}</p><div layout-gt-xs=\"row\">\n<md-input-container class=\"md-block\" flex md-no-float><input id=\"incidences-search\" placeholder=\"Buscar Empleado\" \nclass=\"uppercased whitePlaceholder\" ng-model-options=\"{ debounce: F.debounceTime }\" type=\"text\" name=\"searchEmployees\" \nng-model=\"employeesFilter\"></md-input-container></div></div><md-content layout-fill stop-touch-event><div layout=\"row\" \nlayout-align=\"center center\" ng-show=\"!employees.length\"><h3>Sin Empleados</h3></div><md-table-container \nng-show=\"employees.length\"><table md-table multiple=\"true\" ng-model=\"selected\" class=\"row-border\"><thead md-head \nmd-order=\"order\"><tr md-row><th md-column md-order-by=\"$id\"><span>ID</span></th><th md-column md-order-by=\"name\"><span>\nEmpleados</span></th><th md-column md-order-by=\"nss\"><span>NSS</span></th></tr></thead><tbody md-body><tr md-row \nmd-auto-select ng-repeat=\"employee in employees | orderBy: order | filter:employeesFilter\"><td md-cell>{{employee.$id}}\n</td><td md-cell>{{employee.name}}</td><td md-cell>{{employee.nss}}</td></tr></tbody></table></md-table-container>\n</md-content></md-bottom-sheet>");
$templateCache.put("app/main/employees/views/kardexEmployees/contentTabs/contratos.html","<div id=\"kardexid\"><div class=\"body\" ng-if=\"infoContract.length>0\"><div layout=\"column\" layout-wrap \nlayout-align=\"center\" class=\"sectionTable\" flex=\"100\"><md-table-container style=\"border: none\"><h2 class=\"titulos\">\nCONTRATOS DEL EMPLEADO</h2><md-progress-linear md-mode=\"indeterminate\" ng-show=\"isLoadingContracts\">\n</md-progress-linear><table md-table style=\"width: 100%\"><thead md-head><tr md-row><th md-column><span>EMPLEADO</span>\n</th><th md-column><span>NOMINA</span></th><th md-column><span>INICIO</span></th><th md-column><span>DURACIÓN</span>\n</th><th md-column><span>FIN</span></th><th md-column><span>TIPO DE CONTRATO</span></th><th md-column><span>\nVER CONTRATOS</span></th></tr></thead><tbody md-body><tr md-row ng-class-even=\"\'even-row\'\" ng-class-odd=\"\'odd-row\'\" \nng-repeat=\"resp in infoContract | orderBy: \'-startDate\'\"><td md-cell><span>{{resp.employeeName}}</span></td><td \nmd-cell><span>{{resp.payroll | nameOfL :(F.permissionToAccessAllPayrolls?(L.allPayrolls):(L.payrolls))}}</span></td><td\n md-cell><span>{{resp.startDate | date:F.dateFormat}}</span></td><td md-cell><span>{{resp.duration}}</span></td><td \nmd-cell><span>{{resp.endDate | date:F.dateFormat}}</span></td><td md-cell><span>\n{{resp.documentType | nameOfM : M.documentTypes}}</span></td><td md-cell><span><md-button \nng-click=\"showDocument(resp._id)\"><md-icon md-font-icon=\"icon-eye\" aria-label=\"clone\"></md-icon></md-button></span>\n</td></tr></tbody></table></md-table-container></div></div><div class=\"body\" ng-if=\"!infoContract.length>0\"><div \nlayout=\"column\" layout-wrap layout-align=\"center\" class=\"sectionTable\" flex=\"100\"><h2 class=\"titulos\">\nNO TIENE CONTRATOS EL EMPLEADO</h2></div></div></div>");
$templateCache.put("app/main/employees/views/kardexEmployees/contentTabs/expedientes.html","<div id=\"kardexid\"><div class=\"body\" ng-if=\"files.length>0\"><div layout=\"column\" layout-wrap layout-align=\"center\" \nclass=\"sectionTable\" flex=\"100\"><md-table-container style=\"border: none\"><h2 class=\"titulos\">EXPEDIENTE DEL EMPLEADO\n</h2><table md-table style=\"width: 100%\"><thead md-head><tr md-row><th md-column><span>TIPO DE DOCUMENTOS</span></th>\n<th md-column><span>VER EXPEDIENTE</span></th><th md-column><span>DESCARGAR EXPEDIENTE</span></th></tr></thead><tbody \nmd-body><tr md-row ng-class-even=\"\'even-row\'\" ng-class-odd=\"\'odd-row\'\" ng-repeat=\"expediente in files\"><td md-cell>\n<span>{{expediente.documentName}} </span></td><td md-cell><span><md-button ng-href=\"{{expediente.url}}\" class=\"bn63\" \ntarget=\"_blank\"><md-icon md-font-icon=\"icon-eye\" aria-label=\"clone\"></md-icon></md-button></span></td><td md-cell>\n<span><md-button ng-click=\"descargarDocumento(expediente.url)\" class=\"bn62\"><md-icon \nmd-font-icon=\"icon-folder-download\" aria-label=\"clone\"></md-icon></md-button></span></td></tr></tbody></table>\n</md-table-container></div></div><div class=\"body\" ng-if=\"!files.length>0\"><div layout=\"column\" layout-wrap \nlayout-align=\"center\" class=\"sectionTable\" flex=\"100\"><h2 class=\"titulos\">NO CUENTA CON EXPEDIENTE EL EMPLEADO</h2>\n</div></div></div>");
$templateCache.put("app/main/employees/views/kardexEmployees/contentTabs/incidense1.html","<div id=\"kardexid\"><div class=\"body\" ng-if=\"incapacityIncidence.length>0\"><div layout=\"column\" layout-wrap \nlayout-align=\"center\" class=\"sectionTable\" flex=\"100\"><md-table-container style=\"border: none\"><md-progress-linear \nmd-mode=\"indeterminate\" ng-show=\"isLoadingIncidences\"></md-progress-linear><table md-table style=\"width: 100%\"><h2 \nclass=\"titulos\">INCIDENCIAS DEL EMPLEADO</h2><thead md-head><tr md-row><th md-column><span>NOMINA</span></th><th \nmd-column><span>FECHA</span></th><th md-column><span>TIPO DE INCAPACIDAD</span></th><th md-column><span>\nTIPO DE INCIDENCIA</span></th><th md-column><span>CANTIDAD</span></th></tr></thead><tbody md-body><tr \nng-repeat=\"incidencia in incapacityIncidence | filter:searchText | orderBy: \'-date\'\" md-row ng-class-even=\"\'even-row\'\" \nng-class-odd=\"\'odd-row\'\"><td md-cell><span>\n{{incidencia.payroll | nameOfL :(F.permissionToAccessAllPayrolls?(L.allPayrolls):(L.payrolls))}} </span></td><td \nmd-cell><span>{{incidencia.date | date:F.dateFormat}}</span></td><td md-cell><span>\n{{incidencia.incapacityType | getSomethingOfArrayFB: F.incapacityTypes:\'name\':\'Sin tipo\':\'id\' }}</span></td><td \nmd-cell><span>{{incidencia.incidenceType | nameOfL :L.concepts}}</span></td><td md-cell><span>{{incidencia.value}}\n</span></td></tr></tbody></table></md-table-container></div></div><div class=\"body\" \nng-if=\"!incapacityIncidence.length>0\"><div layout=\"column\" layout-wrap layout-align=\"center\" class=\"sectionTable\" \nflex=\"100\"><h2 class=\"titulos\">NO TIENE INCAPACIDADES EL EMPLEADO</h2></div></div></div>");
$templateCache.put("app/main/employees/views/kardexEmployees/contentTabs/infomation.html","<div id=\"kardexid\"><div class=\"body\" layout=\"row\" layout-wrap layout-align=\"space-between start\"><div flex=\"47\" \nclass=\"section1\" flex-xs=\"100\" flex-md=\"47\" flex-sm=\"47\"><h2 class=\"titulos\">INFORMACIÓN</h2><div layout=\"row\" \nlayout-wrap><div flex=\"50\" flex-gt=\"35\" flex-gt-md=\"50\" flex-gt-sm=\"35\" class=\"text\">RFC:</div><div flex=\"50\"><strong \nclass=\"orange\">{{employee.data.rfc}}</strong></div></div><div layout=\"row\" layout-wrap><div flex=\"50\" flex-gt=\"35\" \nflex-gt-md=\"50\" flex-gt-sm=\"35\" class=\"text\">Curp:</div><div flex=\"50\" class=\"text\">{{employee.data.curp}}</div></div>\n<div layout=\"row\" layout-wrap><div flex=\"50\" flex-gt=\"35\" flex-gt-md=\"50\" flex-gt-sm=\"35\" class=\"text\">\nFecha de nacimiento:</div><div flex=\"50\" class=\"text\">{{employee.data.info.birth.date | date:F.dateFormat}}</div></div>\n<div layout=\"row\" layout-wrap><div flex=\"50\" flex-gt=\"35\" flex-gt-md=\"50\" flex-gt-sm=\"35\" class=\"text\">NSS:</div><div \nflex=\"50\"><strong class=\"orange\">{{employee.data.nss}}</strong></div></div><div layout=\"row\" layout-wrap><div \nflex=\"50\" flex-gt=\"35\" flex-gt-md=\"50\" flex-gt-sm=\"35\" class=\"text\">Estado civil:</div><div flex=\"50\" class=\"text\">\n{{employee.data.maritalStatus?employee.data.maritalStatus:\'NA\'}}</div></div><div layout=\"row\" layout-wrap><div \nflex=\"50\" flex-gt=\"35\" flex-gt-md=\"50\" flex-gt-sm=\"35\" class=\"text\">Codigo postal:</div><div flex=\"50\" class=\"text\">\n{{employee.data.info.residence.address.zipCode?(employee.data.info.residence.address.zipCode): (\'No se encontró información\')}}\n</div></div><div layout=\"row\" layout-wrap><div flex=\"50\" flex-gt=\"35\" flex-gt-md=\"50\" flex-gt-sm=\"35\" class=\"text\">\nEstado:</div><div flex=\"50\" class=\"text\">{{employee.data.info.residence.state | nameOfM : M.states}}</div></div><div \nlayout=\"row\" layout-wrap><div flex=\"50\" flex-gt=\"35\" flex-gt-md=\"50\" flex-gt-sm=\"35\" class=\"text\">Ciudad:</div><div \nflex=\"50\" class=\"text\">{{codigoPostal?(codigoPostal):(\'SIN CIUDAD\')}}</div></div><div layout=\"row\" layout-wrap><div \nflex=\"50\" flex-gt=\"35\" flex-gt-md=\"50\" flex-gt-sm=\"35\" class=\"text\">Colonia:</div><div flex=\"50\" class=\"text\">\n{{employee.data.info.residence.address.neighborhood}}</div></div><div layout=\"row\" layout-wrap><div flex=\"50\" \nflex-gt=\"35\" flex-gt-md=\"50\" flex-gt-sm=\"35\" class=\"text\">Tipo de via:</div><div flex=\"50\" class=\"text\">\n{{employee.data.info.residence.address.streetType | nameOfM : M.streetTypes}}</div></div><div layout=\"row\" layout-wrap>\n<div flex=\"50\" flex-gt=\"35\" flex-gt-md=\"50\" flex-gt-sm=\"35\" class=\"text\">Calle:</div><div flex=\"50\" class=\"text\">\n{{employee.data.info.residence.address.street}}</div></div><div layout=\"row\" layout-wrap><div flex=\"50\" flex-gt=\"35\" \nflex-gt-md=\"50\" flex-gt-sm=\"35\" class=\"text\">Fraccionamiento:</div><div flex=\"50\" class=\"text\">N/A</div></div><div \nlayout=\"row\" layout-wrap><div flex=\"50\" flex-gt=\"35\" flex-gt-md=\"50\" flex-gt-sm=\"35\" class=\"text\">No. Exterior:</div>\n<div flex=\"50\" class=\"text\">{{employee.data.info.residence.address.externalNumber}}</div></div><div layout=\"row\" \nlayout-wrap><div flex=\"50\" flex-gt=\"35\" flex-gt-md=\"50\" flex-gt-sm=\"35\" class=\"text\">No. Interior:</div><div flex=\"50\" \nclass=\"text\">\n{{employee.data.info.residence.address.internalNumber?(employee.data.info.residence.address.internalNumber):(\'No se encontró la información\')}}\n</div></div><div layout=\"row\" layout-wrap><div flex=\"50\" flex-gt=\"35\" flex-gt-md=\"50\" flex-gt-sm=\"35\" class=\"text\">\nReferencia:</div><div flex=\"50\" class=\"text\">\n{{employee.data.info.residence.address.reference?(employee.data.info.residence.address.reference):(\'No se encontró la información\')}}\n</div></div><div layout=\"row\" layout-wrap><div flex=\"50\" flex-gt=\"35\" flex-gt-md=\"50\" flex-gt-sm=\"35\" class=\"text\">\nComentarios:</div><div flex=\"50\" class=\"text\">\n{{employee.data.jobDescription? (employee.data.jobDescription): (\'No hay comentarios\')}}</div></div></div><div \nflex=\"50\" class=\"section2\" flex-xs=\"100\" flex-md=\"47\" flex-sm=\"47\"><div layout=\"column\" \nng-if=\"!employee.data.info.beneficiaries.length > 0\"><h2 class=\"noInformation\">NO TIENE BENEFICIARIOS</h2></div><div \nlayout=\"column\" ng-if=\"employee.data.info.beneficiaries.length > 0\"><h2 class=\"titulos\">BENEFICIARIOS</h2><div \nng-repeat=\"beneficiario in employee.data.info.beneficiaries\"><div layout=\"row\" layout-wrap><div flex=\"50\" class=\"text\">\nNombre:</div><div flex=\"50\" class=\"orange\"><strong>{{beneficiario.name}}</strong></div></div><div layout=\"row\" \nlayout-wrap><div flex=\"50\" class=\"text\">Parentesco:</div><div flex=\"50\" class=\"text\">{{beneficiario.relationship}}\n</div></div><div layout=\"row\" layout-wrap><div flex=\"50\" class=\"text\">Porcentaje (%):</div><div flex=\"50\" class=\"text\">\n{{beneficiario.percent?(beneficiario.percent):(\'No se encontró información\')}}</div></div></div></div><div \nlayout=\"column\" ng-if=\"!employee.data.cards.length > 0\"><h2 class=\"noInformation\">NO TIENE CUENTAS REGISTRADAS</h2>\n</div><div layout=\"column\" ng-if=\"employee.data.cards.length > 0\"><h2 class=\"titulos\">CUENTA REGISTRADA</h2><div \nng-repeat=\"card in employee.data.cards\"><div layout=\"row\" layout-wrap><div flex=\"50\" class=\"text\">Cuenta o Clabe</div>\n<div flex=\"50\" flex=\"20\" flex-xs=\"20\" flex-md=\"20\" flex-sm=\"20\"><strong class=\"orange\">\n{{card.emmit?card.account:card.number}}</strong></div></div><div layout=\"row\" layout-wrap><div flex=\"50\" class=\"text\">\nBanco</div><div flex=\"50\" flex=\"20\" flex-xs=\"20\" flex-md=\"20\" flex-sm=\"20\" class=\"text\">\n{{card.bank | nameOfM : M.banks }}</div></div><div layout=\"row\" layout-wrap><div flex=\"50\" class=\"text\">Proceso</div>\n<div flex=\"50\" class=\"text\">{{card.process | getSomethingOfArrayFB : F.otherProcs : \'name\' : \'Default\' : \'id\'}}</div>\n</div></div></div><div layout=\"column\" ng-if=\"!employee.data.info.emails.length > 0\"><h2 class=\"noInformation\">\nNO TIENE DATOS DE CONTACTO</h2></div><div layout=\"column\" ng-if=\"employee.data.info.emails.length > 0\"><h2 \nclass=\"titulos\">DATOS DE CONTACTO</h2><div><div layout=\"row\" layout-wrap \nng-repeat=\"correo in employee.data.info.emails\"><div flex=\"50\" class=\"text\">Correo electrónico</div><div flex=\"50\">\n<strong>{{correo.email}}</strong></div><div flex=\"50\" class=\"text\">Tipo:</div><div flex><strong class=\"orange\">\n{{correo.type}} </strong></div></div><div layout=\"row\" layout-wrap ng-repeat=\"phone in employee.data.info.phones\"><div \nflex=\"50\" class=\"text\">Teléfono:</div><div flex=\"50\" class=\"text\">{{phone.phone}}</div><div flex=\"50\" class=\"text\">\nTipo:</div><div flex class=\"text\">{{phone.type}}</div></div></div></div><div layout=\"column\" \nng-if=\"extraFields.length === 0\"><h2 class=\"noInformation\">NO TIENE CAMPOS EXTRAS</h2></div><div layout=\"column\" \nng-if=\"extraFields.length > 0\"><h2 class=\"titulos\">INFORMACIÓN EXTRA</h2><div layout=\"row\" layout-wrap \nng-repeat=\"thisField in extraFields\"><div class=\"text\" flex=\"50\" ng-bind=\"thisField.label\"></div><div class=\"text\" \nflex=\"50\" ng-bind=\"thisField.value\"></div></div></div></div></div></div>");
$templateCache.put("app/main/employees/views/kardexEmployees/contentTabs/movimiento.html","<div id=\"kardexid\"><div class=\"body\" layout=\"row\" layout-wrap layout-align=\"space-between start\"><div flex=\"47\" \nclass=\"section\" flex-xs=\"100\" flex-md=\"100\" flex-sm=\"100\"><h2 class=\"titulos\">MOVIMIENTOS DEL EMPLEADO</h2><div \nlayout=\"row\" layout-wrap><div flex=\"40\" flex-xs=\"50\" flex-md=\"50\" flex-sm=\"50\" class=\"text\">UMF:</div><div flex=\"50\">\n<strong>{{employee.data.health.umf}}</strong></div></div><div layout=\"row\" layout-wrap><div flex=\"40\" flex-xs=\"50\" \nflex-md=\"50\" flex-sm=\"50\" class=\"text\">FECHA DE ALTA:</div><div flex=\"50\"><strong class=\"orange\">\n{{employee.data.enroleDate| date:F.dateFormat}}</strong></div></div><div layout=\"row\" layout-wrap><div flex=\"40\" \nflex-xs=\"50\" flex-md=\"50\" flex-sm=\"50\" class=\"text\">FECHA DE MDS:</div><div flex=\"50\"><strong>\n{{(employee.data.mdsDate| date:F.dateFormat)?(employee.data.mdsDate| date:F.dateFormat):\'No existe\'}}</strong></div>\n</div><div layout=\"row\" layout-wrap><div flex=\"40\" flex-xs=\"50\" flex-md=\"50\" flex-sm=\"50\" class=\"text\">FECHA DE BAJA:\n</div><div flex=\"50\"><strong>\n{{(employee.data.dismissDate| date:F.dateFormat)?(employee.data.dismissDate| date:F.dateFormat):\'No existe\'}}</strong>\n</div></div><div layout=\"row\" layout-wrap><div flex=\"40\" flex-xs=\"50\" flex-md=\"50\" flex-sm=\"50\" class=\"text\">\nTIPO DE TRABAJADOR:</div><div flex=\"50\"><strong>\n{{employee.data.workerType | getSomethingOfArrayFB: M.workerTypes : \'name\' : \'No se encontró\': \'humansiteCode\'}}\n</strong></div></div><div layout=\"row\" layout-wrap><div flex=\"40\" flex-xs=\"50\" flex-md=\"50\" flex-sm=\"50\" class=\"text\">\nJORNADA:</div><div flex=\"50\"><strong>\n{{employee.data.workDay | getSomethingOfArrayFB: M.workDays : \'name\' : \'No se encontró\': \'humansiteCode\'}}</strong>\n</div></div><div layout=\"row\" layout-wrap><div flex=\"40\" flex-xs=\"50\" flex-md=\"50\" flex-sm=\"50\" class=\"text\">\nTIPO DE SALARIO:</div><div flex=\"50\"><strong>\n{{employee.movement.salaryType | getSomethingOfArrayFB: M.salaryTypes : \'name\' : \'No se encontró\': \'humansiteCode\'}}\n</strong></div></div><div layout=\"row\" layout-wrap><div flex=\"40\" flex-xs=\"50\" flex-md=\"50\" flex-sm=\"50\" class=\"text\">\nTIPO DE CONTRATO:</div><div flex=\"50\"><strong>\n{{(employee.contractType | nameOfM : M.documentTypes)?(employee.contractType | nameOfM : M.documentTypes):\'NO TIENE CONTRATO\'}}\n</strong></div></div><div layout=\"row\" layout-wrap><div flex=\"40\" flex-xs=\"50\" flex-md=\"50\" flex-sm=\"50\" class=\"text\">\nDESCRIPCION DE LAS ACTIVIDADES Y FUNCIONES:</div><div flex=\"50\"><strong>\n{{employee.data.jobDescription?(employee.data.jobDescription): (\'Sin comentarios\')}}</strong></div></div></div><div \nflex=\"50\" class=\"section\" flex-xs=\"100\" flex-md=\"100\" flex-sm=\"100\"><h2 class=\"titulos\">ÚlTIMO MOVIMIENTO</h2><div \nlayout=\"row\" layout-wrap><div flex=\"30\" flex-xs=\"35\" flex-md=\"35\" flex-sm=\"35\" class=\"text\">ESTATUS:</div><div \nflex=\"50\"><strong class=\"orange\">{{movement.status | movementStatusName}}</strong></div></div><div layout=\"row\" \nlayout-wrap><div flex=\"30\" flex-xs=\"35\" flex-md=\"35\" flex-sm=\"35\" class=\"text\">TIPO DE MOVIMIENTO:</div><div flex=\"50\">\n<strong>{{movement.data.type | typeName}}</strong></div></div><div layout=\"row\" layout-wrap><div flex=\"30\" \nflex-xs=\"35\" flex-md=\"35\" flex-sm=\"35\" class=\"text\">LOTE:</div><div flex=\"50\"><strong>\n{{movement.received.batch?movement.received.batch:\'Sin información\'}}</strong></div></div><div layout=\"row\" \nlayout-wrap><div flex=\"30\" flex-xs=\"35\" flex-md=\"35\" flex-sm=\"35\" class=\"text\">FECHA DE ARCHIVADO:</div><div flex=\"50\">\n<strong class=\"orange\">\n{{(movement.archived.date | date:F.dateFormat)?(movement.archived.date | date:F.dateFormat):\'Sin información\'}}\n</strong></div></div><div layout=\"row\" layout-wrap style=\"margin-top: 4%\"><div flex=\"30\" flex-xs=\"35\" flex-md=\"35\" \nflex-sm=\"35\" class=\"text\">COMENTARIOS:</div><div flex=\"50\"><strong>\n{{movement.data.comments?movement.data.comments:\'SIN COMENTARIOS\'}}</strong></div></div></div></div><div \nlayout=\"column\" layout-wrap layout-align=\"center\" class=\"sectionTable\" flex=\"100\"><div flex=\"100\"><md-table-container \nstyle=\"border: none\"><h2 class=\"titulos\">LISTADO DE MOVIMIENTOS</h2><md-progress-linear md-mode=\"indeterminate\" \nng-show=\"isLoading\"></md-progress-linear><table md-table style=\"width: 100%\"><thead md-head><tr md-row><th md-column>\n<span>FECHA</span></th><th md-column><span>TIPO</span></th><th md-column><span>SD</span></th><th md-column><span>SBC\n</span></th><th md-column><span>ESTATUS</span></th></tr></thead><tbody md-body><tr md-row \nng-repeat=\"movimiento in movimientos | orderBy: \'-date\'\" ng-class-even=\"\'even-row\'\" ng-class-odd=\"\'odd-row\'\"><td \nmd-cell><span>{{movimiento.date | date:F.dateFormat}}</span></td><td md-cell><span>{{movimiento.type | typeName}}\n</span></td><td md-cell><span>{{movimiento.sd | currency}}</span></td><td md-cell><span>{{movimiento.sbc | currency}}\n</span></td><td md-cell><span>{{movimiento.status | movementStatusName}}</span></td></tr></tbody></table>\n</md-table-container></div></div></div>");
$templateCache.put("app/main/employees/views/kardexEmployees/contentTabs/prestamos.html","<div id=\"kardexid\"><div class=\"body\" layout=\"row\" layout-wrap layout-align=\"space-between start\"><div flex=\"48\" \nng-if=\"infonavitCredits\" class=\"section\" flex-xs=\"100\" flex-md=\"100\" flex-sm=\"100\"><h2 class=\"titulos\">INFONAVIT</h2>\n<div layout=\"row\" layout-wrap><div flex=\"40\" flex-xs=\"50\" flex-md=\"50\" flex-sm=\"50\" class=\"text\">Fecha de crédito:\n</div><div flex=\"50\"><strong>{{infonavitCredits.date | date:F.dateFormat}}</strong></div></div><div layout=\"row\" \nlayout-wrap><div flex=\"40\" flex-xs=\"50\" flex-md=\"50\" flex-sm=\"50\" class=\"text\">Tipo de crédito:</div><div flex=\"50\">\n<strong class=\"orange\">{{infonavitCredits.type}}</strong></div></div><div layout=\"row\" layout-wrap><div flex=\"40\" \nflex-xs=\"50\" flex-md=\"50\" flex-sm=\"50\" class=\"text\">Factor crédito:</div><div flex=\"50\"><strong>\n{{infonavitCredits.factor}}</strong></div></div><div layout=\"row\" layout-wrap><div flex=\"40\" flex-xs=\"50\" flex-md=\"50\" \nflex-sm=\"50\" class=\"text\">Numero de crédito:</div><div flex=\"50\"><strong>{{infonavitCredits.account}}</strong></div>\n</div><div layout=\"row\" layout-wrap><div flex=\"40\" flex-xs=\"50\" flex-md=\"50\" flex-sm=\"50\" class=\"text\">VIGENTE:</div>\n<div flex=\"50\"><md-switch ng-model=\"validCredit\" ng-disabled=\"true\" ng-class=\"{activeDisabled: validCredit}\" \nstyle=\"margin-top: 0%\"></md-switch></div></div></div><div flex=\"48\" ng-if=\"!infonavitCredits\" class=\"section\" \nflex-xs=\"100\" flex-md=\"100\" flex-sm=\"100\"><h2 class=\"titulos\">NO TIENE CRÉDITO INFONAVIT</h2></div><div flex=\"50\" \nclass=\"section\" flex-xs=\"100\" flex-md=\"100\" flex-sm=\"100\" ng-if=\"infonavitCredits.comments\"><div layout=\"row\" \nlayout-wrap><div flex=\"100\"><h2>COMENTARIO:</h2></div><div flex=\"100\"><textarea ng-disabled=\"true\" maxlength=\"150\" \nng-model=\"infonavitCredits.comments\" placeholder=\"Comentarios\" ng-keyup=\"updateCharCount()\">\r\n                    \n</textarea></div></div></div><div flex=\"50\" class=\"section\" flex-xs=\"100\" flex-md=\"100\" flex-sm=\"100\" \nng-if=\"!infonavitCredits.comments\"><div layout=\"row\" layout-wrap><div flex=\"100\"><h2>NO HAY COMENTARIOS</h2></div>\n</div></div></div><div layout=\"column\" layout-wrap layout-align=\"center\" class=\"sectionTable\" \nng-if=\"incidencesLoans !== null\"><div flex=\"100\"><h2 class=\"titulos\">PRÉSTAMOS</h2><md-table-container \nstyle=\"border: none\"><table md-table style=\"width: 100%\"><thead md-head><tr md-row><th md-column><span>Nombre</span>\n</th><th md-column><span>FECHA</span></th><th md-column><span>MONTO</span></th><th md-column><span>Monto por periodo\n</span></th></tr></thead><tbody md-body><tr md-row ng-repeat=\"loans in incidencesLoansArray | orderBy: \'-date\'\" \nng-class-even=\"\'even-row\'\" ng-class-odd=\"\'odd-row\'\"><td md-cell><span>{{loans.nameLoan}}</span></td><td md-cell><span>\n{{loans.date | date:F.dateFormat}}</span></td><td md-cell><span>{{loans.amount | currency}}</span></td><td md-cell>\n<span>{{loans.periodAmount | currency}}</span></td></tr></tbody></table></md-table-container></div></div><div \nlayout=\"column\" layout-wrap ng-if=\"incidencesLoans === null\" layout-align=\"center\" class=\"sectionTable\"><div \nflex=\"100\"><h2 class=\"titulos\">NO TIENE PRESTAMOS EL EMPLEADO</h2></div></div></div>");
$templateCache.put("app/main/employees/views/kardexEmployees/contentTabs/vacaciones.html","<div id=\"kardexid\"><div class=\"body\"><h2 class=\"titulos\">VACACIONES</h2><md-table-container><table md-table \nstyle=\"width: 100%\"><thead md-head><tr md-row><th md-column><span>ULTIMO MOVIMIENTO</span></th><th md-column><span>\nFECHA DE MOVIMIENTO</span></th><th md-column><span>TOTAL DISFRUTADAS</span></th><th md-column><span>TOTAL GANADAS\n</span></th><th md-column><span>TOTAL PENDIENTES</span></th></tr></thead><tbody md-body><tr md-row \nng-class-even=\"\'even-row\'\" ng-class-odd=\"\'odd-row\'\"><td md-cell><span>{{employee.data.lastHolEv.event}}</span></td><td \nmd-cell><span>{{employee.data.lastHolEv.date | date:F.dateFormat}}</span></td><td md-cell><span>\n{{employee.data.lastHolEv.enjoyedTotal}}</span></td><td md-cell><span>{{employee.data.lastHolEv.earnedTotal}}</span>\n</td><td md-cell><span>{{employee.data.lastHolEv.total}}</span></td></tr></tbody></table></md-table-container><h2 \nclass=\"titleBlue\">EVENTOS</h2><md-table-container><table md-table style=\"width: 100%; margin-top: 2%\"><thead md-head>\n<tr md-row><th md-column><span>FECHA</span></th><th md-column><span>EVENTO</span></th><th md-column><span>\nDERECHO A GOZO</span></th><th md-column><span>ACUMULADOS</span></th><th md-column><span>PEND. DERECHO A GOZO</span>\n</th><th md-column><span>DISFRUTADAS</span></th><th md-column><span>TOTAL DISFRUTADAS</span></th><th md-column><span>\nVENCIDAS</span></th><th md-column><span>TOTAL VENCIDAS</span></th><th md-column><span>TOTAL</span></th></tr></thead>\n<tbody md-body><tr ng-repeat=\"event in vacations\" md-row ng-class-even=\"\'even-row\'\" ng-class-odd=\"\'odd-row\'\"><td \nmd-cell><span ng-bind=\"event.date|date\"></span></td><td md-cell><span \nng-bind=\"event.event===\'Aniversario\'?event.anniversaryNumber+\'º \':\'\'\"></span></td><td md-cell><span \nng-bind=\"event.earned\"></span></td><td md-cell><span ng-bind=\"event.earnedTotal\"></span></td><td md-cell><span \nng-if=\"event.earned>0\">{{event.pending}}</span></td><td md-cell><span ng-bind=\"event.enjoyed\"></span></td><td md-cell>\n<span ng-bind=\"event.enjoyedTotal\"></span></td><td md-cell><span ng-bind=\"event.prescribed\"></span></td><td md-cell>\n<span ng-bind=\"event.prescribedTotal\"></span></td><td md-cell><span ng-bind=\"event.total\"></span></td></tr></tbody>\n</table></md-table-container></div></div>");
$templateCache.put("app/main/employees/views/idseAutoRecords/dialogs/sendMovements.html","<md-dialog><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nDesea {{smdCtrl.data.batch?\"recibir\":\"enviar\"}} {{smdCtrl.totalMovements}} movimiento(s) a IDSE</h2><div flex></div>\n<md-button class=\"md-icon-button\" ng-click=\"smdCtrl.cancel()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close Dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div \nclass=\"md-dialog-content noPadding\"><form name=\"form\" novalidate><div><md-switch ng-if=\"smdCtrl.showAddButton\" \nng-model=\"smdCtrl.addBatch\" aria-label=\"add batch\" ng-change=\"smdCtrl.addBatch?\'\':smdCtrl.data={}\">Añadir Lote\n</md-switch><md-input-container ng-if=\"smdCtrl.addBatch\" class=\"md-block no-errors-spacer\"><label>Lote</label><input \ntype=\"text\" required ms2-autofocus md-maxlength=\"9\" maxlength=\"9\" name=\"batch\" ng-model=\"smdCtrl.data.batch\" \nplaceholder=\"Añadir Lote\" ng-pattern=\"/^(?!000000000)\\d{9}$/\"><div ng-messages=\"form.batch.$error\" \nng-show=\"form.batch.$touched || form.batch.$dirty\" role=\"alert\"><div ng-message=\"required\">El campo es requerido</div>\n<div ng-message=\"pattern\">Debe contener exactamente 9 dígitos y no puede ser solo ceros</div></div>\n</md-input-container></div></form></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span>\n<md-button aria-label=\"answer field\" ng-click=\"smdCtrl.answer(smdCtrl.data)\" class=\"md-primary md-hue-2\" \nng-disabled=\"form.$invalid\">{{smdCtrl.data.batch?\"Recibir\":\"Enviar\"}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/employees/views/kardexEmployees/views/cards.html","<div id=\"cards-view-kardexEmployees\" class=\"center content-card\" flex layout=\"column\"><div flex=\"nogrow\" \nclass=\"cards-container\"><div layout=\"row\" layout-wrap><div ng-repeat=\"employee in kardexEmployees\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-sm=\"33\" flex-gt-md=\"25\" flex-gt-lg=\"20\" class=\"card centerif\" \nng-class=\"{\'inactiveEmployee\': employee.movement.type == 2 || employee.status == 5}\" \nng-click=\'R.goToDetail(selected[0], \"read\", {employeeId: employee.$id, movementId: employee.movement.uid})\'><div \nclass=\"photoEmployee\"><img ng-src=\"{{employee.data.photoEmployee || employee.imageDefault}}\" class=\"image\" \nalt=\"Employee Photo\"></div><div class=\"card-info\"><span class=\"names\" ng-class=\"{\'text-red\': employee.status == 5}\">\n{{employee.data.name}}</span><p class=\"nss p-0 mb-5\">{{employee[\'payroll2-class\']}} {{employee[\'payroll-name\']}}</p><p \nclass=\"nss m-0 mt-8 p-0\">NSS: {{employee.data.nss ? employee.data.nss : \'No cuenta con NSS\'}}</p></div></div></div>\n</div></div>");
$templateCache.put("app/main/employees/views/kardexEmployees/views/table.html","<div id=\"table-view-kardexEmployees\" flex layout=\"column\" class=\"page-layout carded fullwidth\"><div flex \nlayout=\"column\" class=\"center\"><div flex layout=\"column\" class=\"content-card\"><md-table-container flex \nclass=\"tableHeaderMarginOld-{{F.paginate>F.filteredItems.length?10:F.paginate}}\"><table md-table multiple=\"true\" \nclass=\"row-border\" ng-show=\"kardexEmployees.length\"><thead md-head md-order=\"F.orderMongo\" fix-head \nmd-on-reorder=\"getThem\"><tr md-row><th md-column md-order-by=\"data.name\"><span>Foto</span></th><th md-column \nmd-order-by=\"data.name\"><span>Nombre</span></th><th md-column md-order-by=\"rp\"><span>Nacimiento</span></th><th \nmd-column md-order-by=\"rp\"><span>Teléfono</span></th><th md-column md-order-by=\"rp\"><span>Email</span></th><th \nmd-column md-order-by=\"data.nss\"><span>NSS</span></th><th md-column md-order-by=\"data.nss\"><span>Nomina</span></th><th \nmd-column md-order-by=\"data.nss\"><span>Centro de Costos</span></th><th md-column md-order-by=\"data.nss\"><span>Puesto\n</span></th></tr></thead><tbody md-body><tr md-row \nng-class=\"{\'inactiveEmployee\': employee.movement.type == 2 || employee.status == 5}\" md-select-id=\"$id\" \nmd-select=\"employee\" ng-repeat=\"employee in kardexEmployees\"><td md-cell id=\"tab\" \nng-click=\'R.goToDetail(selected[0], \"read\", {employeeId: employee.$id, movementId: employee.movement.uid})\'><img \nclass=\"img\" ng-src=\"{{employee.data.photoEmployee || employee.imageDefault}}\"></td><td md-cell \nng-click=\'R.goToDetail(selected[0], \"read\", {employeeId: employee.$id, movementId: employee.movement.uid})\'>\n{{employee.data.name}}</td><td md-cell>{{employee.data.info.birth.date | date:F.dateFormat}}</td><td md-cell>\n{{employee.data.info.phones[0].phone||\'SN\'}}</td><td md-cell>{{employee.data.info.emails[0].email||\'SN\'}}</td><td \nmd-cell>{{employee.data.nss || \'SN\'}}</td><td md-cell>{{employee[\'payroll2-class\']}} {{employee[\'payroll-name\']}}</td>\n<td md-cell>{{employee.cc | nameOfL: L.ccs}}</td><td md-cell>{{employee[\'position-name\'] || \'NA\' }}</td></tr></tbody>\n</table></md-table-container></div></div></div>");
$templateCache.put("app/main/pages/profile/tabs/about/about.html","<div layout=\"row\" layout-wrap><div class=\"about\" layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"65\"><div \nclass=\"profile-box info-box general md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div class=\"title\" \ntranslate=\"PROFILE.GENERAL_INFORMATION\">General Information</div></header><div class=\"content\"><div class=\"info-line\">\n<div class=\"title\" translate=\"PROFILE.GENDER\">Gender</div><div class=\"info\">{{vm.about.general.gender}}</div></div><div\n class=\"info-line\"><div class=\"title\" translate=\"PROFILE.BIRTHDAY\">Birthday</div><div class=\"info\">\n{{vm.about.general.birthday}}</div></div><div class=\"info-line\"><div class=\"title\" translate=\"PROFILE.LOCATIONS\">\nLocations</div><div class=\"info location\" ng-repeat=\"location in vm.about.general.locations\"><span>{{location}}</span>\n<md-icon md-font-icon=\"icon-map-marker\" class=\"s16\"></md-icon></div></div><div class=\"info-line\"><div class=\"title\" \ntranslate=\"PROFILE.ABOUT_ME\">About Me</div><div class=\"info\">{{vm.about.general.about}}</div></div></div></div><div \nclass=\"profile-box info-box work md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div class=\"title\" \ntranslate=\"PROFILE.WORK\">Work</div></header><div class=\"content\"><div class=\"info-line\"><div class=\"title\" \ntranslate=\"PROFILE.OCCUPATION\">Occupation</div><div class=\"info\">{{vm.about.work.occupation}}</div></div><div \nclass=\"info-line\"><div class=\"title\" translate=\"PROFILE.SKILLS\">Skills</div><div class=\"info\">{{vm.about.work.skills}}\n</div></div><div class=\"info-line\"><div class=\"title\" translate=\"PROFILE.JOBS\">Jobs</div><table class=\"info jobs\"><tr \nclass=\"job\" ng-repeat=\"job in vm.about.work.jobs\"><td class=\"company\">{{job.company}}</td><td class=\"date\">{{job.date}}\n</td></tr></table></div></div></div><div class=\"profile-box info-box contact md-whiteframe-1dp\" layout=\"column\"><header\n class=\"md-accent-bg\"><div class=\"title\" translate=\"PROFILE.CONTACT\">Contact</div></header><div class=\"content\"><div \nclass=\"info-line\"><div class=\"title\" translate=\"PROFILE.ADDRESS\">Address</div><div class=\"info\">\n{{vm.about.contact.address}}</div></div><div class=\"info-line\"><div class=\"title\" translate=\"PROFILE.TEL\">Tel.</div>\n<div class=\"info\" ng-repeat=\"tel in vm.about.contact.tel\"><span>{{tel}}</span></div></div><div class=\"info-line\"><div \nclass=\"title\" translate=\"PROFILE.WEBSITE\">Website</div><div class=\"info\" \nng-repeat=\"website in vm.about.contact.websites\"><span>{{website}}</span></div></div><div class=\"info-line\"><div \nclass=\"title\" translate=\"PROFILE.EMAILS\">Emails</div><div class=\"info\" ng-repeat=\"email in vm.about.contact.emails\">\n<span>{{email}}</span></div></div></div></div></div><div class=\"about-sidebar\" layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"35\"><div class=\"profile-box friends md-whiteframe-1dp\" layout=\"column\"><header \nclass=\"md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div class=\"title\" translate=\"PROFILE.FRIENDS\">\nFriends</div><div class=\"more secondary-text\"><span translate=\"PROFILE.SEE\">See</span> <span>454</span> <span \ntranslate=\"PROFILE.MORE\">More</span></div></header><div class=\"content\" layout=\"row\" layout-wrap><div class=\"friend\" \nflex=\"20\" ng-repeat=\"friend in vm.about.friends\"><img ng-src=\"{{friend.avatar}}\"></div></div></div><div \nclass=\"profile-box groups md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"title\" translate=\"PROFILE.JOINED_GROUPS\">Joined Groups</div><div \nclass=\"more secondary-text\"><span translate=\"PROFILE.SEE\">See</span> <span>6</span> <span translate=\"PROFILE.MORE\">More\n</span></div></header><div class=\"content\"><div class=\"group\" ng-repeat=\"group in vm.about.groups\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><img ng-src=\"{{group.logo}}\" \nclass=\"logo\" alt=\"{{group.name}}\"><div><div class=\"name\">{{group.name}}</div><div class=\"category\">{{group.category}}\n</div><div class=\"members\">{{group.members}} people</div></div></div><md-button class=\"md-icon-button\" \naria-label=\"more\" translate translate-attr-aria-label=\"PROFILE.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\">\n</md-icon></md-button></div></div></div></div></div>");
$templateCache.put("app/main/pages/profile/tabs/photos-videos/photos-videos.html","<div class=\"photos-videos\"><div class=\"period\" data-ng-repeat=\"period in vm.photosVideos\"><div class=\"period-title\">\n<span class=\"name\">{{period.name}}</span> <span class=\"info\">{{period.info}}</span></div><div class=\"period-media\" \nlayout=\"row\" layout-wrap><div class=\"media\" ng-repeat=\"media in period.media\"><img class=\"preview\" \nng-src=\"{{media.preview}}\" title=\"{{media.title}}\"><div class=\"title\">{{media.title}}</div></div></div></div></div>");
$templateCache.put("app/main/pages/profile/tabs/timeline/timeline.html","<div layout=\"row\" layout-wrap><div class=\"timeline\" layout=\"column\" flex=\"100\" flex-gt-sm=\"55\" flex-gt-md=\"65\" \nflex-order=\"2\" flex-order-gt-sm=\"1\"><div class=\"profile-box add-post md-whiteframe-1dp\"><div class=\"form\" flex>\n<textarea placeholder=\"Write something..\" translate translate-attr-placeholder=\"PROFILE.WRITE_SOMETHING\"></textarea>\n<footer layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button\" aria-label=\"insert photo\" translate translate-attr-aria-label=\"PROFILE.INSERT_PHOTO\"><md-icon \nmd-font-icon=\"icon-file-image-box\"></md-icon><md-tooltip><span translate=\"PROFILE.INSERT_PHOTO\">insert photo</span>\n</md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"add person\" translate \ntranslate-attr-aria-label=\"PROFILE.ADD_PERSON\"><md-icon md-font-icon=\"icon-person-plus\"></md-icon><md-tooltip><span \ntranslate=\"PROFILE.ADD_PERSON\">add person</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \naria-label=\"add location\" translate translate-attr-aria-label=\"PROFILE.LOCATION\"><md-icon \nmd-font-icon=\"icon-map-marker\"></md-icon><md-tooltip><span translate=\"PROFILE.LOCATION\">add location</span>\n</md-tooltip></md-button></div><md-button ng-click=\"\" class=\"post-button md-accent md-raised\" aria-label=\"POST\" \ntranslate=\"PROFILE.POST\" translate-attr-aria-label=\"PROFILE.POST\">POST</md-button></footer></div></div><md-divider>\n</md-divider><div class=\"timeline-item md-whiteframe-1dp\" ng-repeat=\"post in vm.posts\"><header layout=\"row\" \nlayout-align=\"space-between start\"><div class=\"user\" layout=\"row\" layout-align=\"start center\"><img class=\"avatar\" \nng-src=\"{{post.user.avatar}}\"><div layout=\"column\"><div class=\"title\"><span class=\"username md-accent-color\">\n{{post.user.name}}</span> <span ng-if=\"post.type == \'post\'\" translate=\"PROFILE.TYPE_POST\">posted on your timeline\n</span> <span ng-if=\"post.type == \'something\'\" translate=\"PROFILE.TYPE_SOMETHING\">shared something with you</span> \n<span ng-if=\"post.type == \'video\'\" translate=\"PROFILE.TYPE_VIDEO\">shared a video with you</span> <span \nng-if=\"post.type == \'article\'\" translate=\"PROFILE.TYPE_ARTICLE\">shared an article with you</span></div><div \nclass=\"time\">{{post.time}}</div></div></div><md-button class=\"md-icon-button\" aria-label=\"more\" translate \ntranslate-attr-aria-label=\"PROFILE.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></header><div\n class=\"content\"><div ng-if=\"post.message\" class=\"message\">{{post.message}}</div><div ng-if=\"post.media\" class=\"media\">\n<img ng-if=\"post.media.type === \'image\'\" ng-src=\"{{post.media.preview}}\"><div ng-if=\"post.media.type === \'video\'\" \nng-bind-html=\"post.media.embed | toTrusted\"></div></div><div ng-if=\"post.article\" layout=\"column\" class=\"article\"><div \nclass=\"media\"><img ng-src=\"{{post.article.media.preview}}\"></div><div class=\"title\">{{post.article.title}}</div><div \nclass=\"subtitle\">{{post.article.subtitle}}</div><div class=\"excerpt\">{{post.article.excerpt}}</div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"like-button\"><div layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-heart-outline\" class=\"s16\"></md-icon><span translate=\"PROFILE.LIKE\">Like</span>&nbsp;<span>\n({{post.like}})</span></div></md-button><md-button class=\"share-button\"><div layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-share\" class=\"s16\"></md-icon><span translate=\"PROFILE.SHARE\">Share</span>&nbsp;<span>\n({{post.share}})</span></div></md-button></div></div><footer class=\"\" layout=\"column\" layout-align=\"start start\"><div \nng-if=\"post.comments\" class=\"comment-count\">{{post.comments.length}} comments<md-icon \nmd-font-icon=\"icon-keyboard_arrow_down\"></md-icon></div><div class=\"comment\" layout=\"row\" layout-fill \nng-repeat=\"comment in post.comments\"><img ng-src=\"{{comment.user.avatar}}\" class=\"avatar\"><div flex layout=\"column\">\n<div layout=\"row\" layout-align=\"start center\"><span class=\"username\">{{comment.user.name}}</span> <span class=\"time\">\n{{comment.time}}</span></div><div class=\"message\">{{comment.message}}</div><div class=\"actions\" layout=\"row\" \nlayout-align=\"space-between center\"><a href=\"#\" class=\"reply-button md-accent-color\" translate=\"PROFILE.REPLY\">Reply\n</a><md-icon flex md-font-icon=\"icon-flag\" class=\"report-button s16\"></md-icon></div></div></div><div class=\"reply\" \nlayout=\"row\" layout-fill><img src=\"assets/images/avatars/profile.jpg\" class=\"avatar\"><form flex><textarea \nplaceholder=\"Add a comment...\" translate translate-attr-placeholder=\"PROFILE.ADD_COMMENT\"></textarea><md-button \nng-click=\"\" class=\"post-comment-button md-accent md-raised\" aria-label=\"Post Comment\" translate=\"PROFILE.POST_COMMENT\" \ntranslate-aria-label=\"PROFILE.POST_COMMENT\">Post Comment</md-button></form></div></footer></div></div><div \nclass=\"timeline-sidebar\" layout=\"column\" flex=\"100\" flex-gt-sm=\"45\" flex-gt-md=\"35\" flex-order=\"1\" \nflex-order-gt-sm=\"2\"><div class=\"profile-box latest-activity md-whiteframe-1dp\" layout=\"column\"><header \nclass=\"md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div class=\"title\" \ntranslate=\"PROFILE.LATEST_ACTIVITY\">Latest Activity</div><div class=\"more secondary-text\" translate=\"PROFILE.SEE_ALL\">\nSee All</div></header><div class=\"content\" layout=\"row\" layout-wrap><div class=\"activities\"><div class=\"activity\" \nlayout=\"row\" layout-align=\"start start\" ng-repeat=\"activity in vm.activities\"><img ng-src=\"{{activity.user.avatar}}\" \nclass=\"avatar\" alt=\"{{activity.user.name}}\"><div layout=\"column\"><div><span class=\"username md-accent-color\">\n{{activity.user.name}}</span> <span class=\"message\">{{activity.message}}</span></div><span class=\"time secondary-text\">\n{{activity.time}}</span></div></div></div></div></div></div></div>");
$templateCache.put("app/main/pages/invoice/views/modern/modern.html","<div id=\"invoice\" class=\"modern page-layout blank\" layout=\"row\" ms-scroll><div class=\"invoice-container\"><div \nclass=\"card md-whiteframe-8dp\"><div class=\"header\" layout=\"row\" layout-align=\"space-between start\"><div class=\"ids\" \nlayout=\"column\"><div layout=\"row\" class=\"seller\" layout-align=\"start center\"><div class=\"logo md-accent-bg\" \nlayout=\"row\" layout-align=\"center center\"><div>F</div></div><div class=\"divider\"></div><div class=\"detail\"><div \nclass=\"title\">{{vm.invoice.from.title}}</div><div ng-if=\"vm.invoice.from.address\" class=\"address\">\n{{vm.invoice.from.address}}</div><div ng-if=\"vm.invoice.from.phone\" class=\"phone\"><span translate=\"INVOICE.PHONE\">Phone\n</span>: {{vm.invoice.from.phone}}</div><div ng-if=\"vm.invoice.from.email\" class=\"email\"><span \ntranslate=\"INVOICE.EMAIL\">Email</span>: {{vm.invoice.from.email}}</div><div ng-if=\"vm.invoice.from.website\" \nclass=\"website\"><span translate=\"INVOICE.WEB\">Web</span>: {{vm.invoice.from.website}}</div></div></div><div \nlayout=\"row\" class=\"client\" layout-align=\"start center\"><div class=\"label\" layout=\"row\" layout-align=\"end center\"><div \ntranslate=\"INVOICE.CLIENT\">CLIENT</div></div><div class=\"divider\"></div><div class=\"detail\"><div class=\"title\">\n{{vm.invoice.client.title}}</div><div ng-if=\"vm.invoice.client.address\" class=\"address\">{{vm.invoice.client.address}}\n</div><div ng-if=\"vm.invoice.client.phone\" class=\"phone\"><span translate=\"INVOICE.PHONE\">Phone</span>\n: {{vm.invoice.client.phone}}</div><div ng-if=\"vm.invoice.client.email\" class=\"email\"><span translate=\"INVOICE.EMAIL\">\nEmail</span>: {{vm.invoice.client.email}}</div><div ng-if=\"vm.invoice.client.website\" class=\"website\"><span \ntranslate=\"INVOICE.WEB\">Web</span>: {{vm.invoice.client.website}}</div></div></div></div><table class=\"summary\"><tr \nclass=\"code\"><td class=\"label\" translate=\"INVOICE.INVOICE\">INVOICE</td><td class=\"value\">{{vm.invoice.number}}</td>\n</tr><tr><td class=\"label\" translate=\"INVOICE.INVOICE_DATE\">INVOICE DATE</td><td class=\"value\">{{vm.invoice.date}}</td>\n</tr><tr><td class=\"label\" translate=\"INVOICE.DUE_DATE\">DUE DATE</td><td class=\"value\">{{vm.invoice.dueDate}}</td></tr>\n<tr><td class=\"label\" translate=\"INVOICE.TOTAL_DUE\">TOTAL DUE</td><td class=\"value\">{{vm.invoice.total | currency}}\n</td></tr></table></div><div class=\"content\"><table class=\"simple invoice-table\"><thead><th \ntranslate=\"INVOICE.SERVICE\">SERVICE</th><th translate=\"INVOICE.UNIT\">UNIT</th><th class=\"text-right\" \ntranslate=\"INVOICE.UNIT_PRICE\">UNIT PRICE</th><th class=\"text-right\" translate=\"INVOICE.QUANTITY\">QUANTITY</th><th \nclass=\"text-right\" translate=\"INVOICE.TOTAL\">TOTAL</th></thead><tbody><tr ng-repeat=\"service in vm.invoice.services\">\n<td><div class=\"title\">{{service.title}}</div><div class=\"detail\">{{service.detail}}</div></td><td>{{service.unit}}\n</td><td class=\"text-right\">{{service.unitPrice | currency}}</td><td class=\"text-right\">{{service.quantity}}</td><td \nclass=\"text-right\">{{service.total | currency}}</td></tr></tbody></table><table class=\"simple invoice-table-footer\">\n<tbody><tr class=\"subtotal\"><td translate=\"INVOICE.SUBTOTAL\">SUBTOTAL</td><td>{{vm.invoice.subtotal | currency}}</td>\n</tr><tr class=\"tax\"><td translate=\"INVOICE.TAX\">TAX</td><td>{{vm.invoice.tax | currency}}</td></tr><tr \nclass=\"discount\"><td translate=\"INVOICE.DISCOUNT\">DISCOUNT</td><td>-{{vm.invoice.discount | currency}}</td></tr><tr \nclass=\"total\"><td translate=\"INVOICE.TOTAL\">TOTAL</td><td>{{vm.invoice.total | currency}}</td></tr></tbody></table>\n</div><div class=\"footer\"><div class=\"note\" translate=\"INVOICE.NOTE\">\nPlease pay within 15 days. Thank you for your business.</div><div layout=\"row\" layout-align=\"start start\"><div \nclass=\"logo md-accent-bg\" layout=\"row\" layout-align=\"center center\"><div>F</div></div><div class=\"small-note\" \ntranslate=\"INVOICE.SMALL_NOTE\">\nIn condimentum malesuada efficitur. Mauris volutpat placerat auctor. Ut ac congue dolor. Quisque scelerisque lacus sed feugiat fermentum. Cras aliquet facilisis pellentesque. Nunc hendrerit quam at leo commodo, a suscipit tellus dapibus. Etiam at felis volutpat est mollis lacinia. Mauris placerat sem sit amet velit mollis, in porttitor ex finibus. Proin eu nibh id libero tincidunt lacinia et eget eros.\n</div></div></div></div><div class=\"page-break\"></div></div></div>");
$templateCache.put("app/main/pages/invoice/views/compact/compact.html","<div id=\"invoice\" class=\"compact page-layout blank\" layout=\"row\" ms-scroll><div class=\"invoice-container\"><div \nclass=\"card md-whiteframe-8dp\"><div class=\"header\"><div class=\"invoice-date\">{{vm.invoice.date}}</div><div \nlayout=\"row\" layout-align=\"space-between stretch\"><div class=\"client\"><div class=\"invoice-number\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"title\" translate=\"INVOICE.INVOICE\">INVOICE</span> <span class=\"number\">\n{{vm.invoice.number}}</span></div><div class=\"due-date\" layout=\"row\" layout-align=\"start center\"><span class=\"title\" \ntranslate=\"INVOICE.DUE_DATE\">DUE DATE</span> <span class=\"date\">{{vm.invoice.dueDate}}</span></div><div class=\"info\">\n<div class=\"title\">{{vm.invoice.client.title}}</div><div ng-if=\"vm.invoice.client.address\" class=\"address\">\n{{vm.invoice.client.address}}</div><div ng-if=\"vm.invoice.client.phone\" class=\"phone\">{{vm.invoice.client.phone}}</div>\n<div ng-if=\"vm.invoice.client.email\" class=\"email\">{{vm.invoice.client.email}}</div><div \nng-if=\"vm.invoice.client.website\" class=\"website\">{{vm.invoice.client.website}}</div></div></div><div \nclass=\"issuer md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"center center\"><span>F</span></div><div class=\"info\"><div class=\"title\">{{vm.invoice.from.title}}</div>\n<div ng-if=\"vm.invoice.from.address\" class=\"address\">{{vm.invoice.from.address}}</div><div \nng-if=\"vm.invoice.from.phone\" class=\"phone\">{{vm.invoice.from.phone}}</div><div ng-if=\"vm.invoice.from.email\" \nclass=\"email\">{{vm.invoice.from.email}}</div><div ng-if=\"vm.invoice.from.website\" class=\"website\">\n{{vm.invoice.from.website}}</div></div></div></div></div><div class=\"content\"><table class=\"simple invoice-table\">\n<thead><th translate=\"INVOICE.SERVICE\">SERVICE</th><th translate=\"INVOICE.UNIT\">UNIT</th><th class=\"text-right\" \ntranslate=\"INVOICE.UNIT_PRICE\">UNIT PRICE</th><th class=\"text-right\" translate=\"INVOICE.QUANTITY\">QUANTITY</th><th \nclass=\"text-right\" translate=\"INVOICE.TOTAL\">TOTAL</th></thead><tbody><tr ng-repeat=\"service in vm.invoice.services\">\n<td><div class=\"title\">{{service.title}}</div></td><td>{{service.unit}}</td><td class=\"text-right\">\n{{service.unitPrice | currency}}</td><td class=\"text-right\">{{service.quantity}}</td><td class=\"text-right\">\n{{service.total | currency}}</td></tr><tr ng-repeat=\"service in vm.invoice.services\"><td><div class=\"title\">\n{{service.title}}</div></td><td>{{service.unit}}</td><td class=\"text-right\">{{service.unitPrice | currency}}</td><td \nclass=\"text-right\">{{service.quantity}}</td><td class=\"text-right\">{{service.total | currency}}</td></tr></tbody>\n</table><table class=\"simple invoice-table-footer\"><tbody><tr class=\"subtotal\"><td translate=\"INVOICE.SUBTOTAL\">\nSUBTOTAL</td><td>{{vm.invoice.subtotal | currency}}</td></tr><tr class=\"tax\"><td translate=\"INVOICE.TAX\">TAX</td><td>\n{{vm.invoice.tax | currency}}</td></tr><tr class=\"discount\"><td translate=\"INVOICE.DISCOUNT\">DISCOUNT</td><td>\n-{{vm.invoice.discount | currency}}</td></tr><tr class=\"total\"><td translate=\"INVOICE.TOTAL\">TOTAL</td><td>\n{{vm.invoice.total | currency}}</td></tr></tbody></table></div><div class=\"footer\"><div class=\"note\" \ntranslate=\"INVOICE.NOTE\">Please pay within 15 days. Thank you for your business.</div><div layout=\"row\" \nlayout-align=\"start start\"><div class=\"logo md-accent-bg\" layout=\"row\" layout-align=\"center center\"><div>F</div></div>\n<div class=\"small-note\" translate=\"INVOICE.SMALL_NOTE\">\nIn condimentum malesuada efficitur. Mauris volutpat placerat auctor. Ut ac congue dolor. Quisque scelerisque lacus sed feugiat fermentum. Cras aliquet facilisis pellentesque. Nunc hendrerit quam at leo commodo, a suscipit tellus dapibus. Etiam at felis volutpat est mollis lacinia. Mauris placerat sem sit amet velit mollis, in porttitor ex finibus. Proin eu nibh id libero tincidunt lacinia et eget eros.\n</div></div></div></div><div class=\"page-break\"></div></div></div>");
$templateCache.put("app/main/apps/dashboards/project/widgets/sidebar/now-dashboard-widget.html","<ms-widget flippable=\"false\" class=\"sidenav-widget\"><ms-widget-front><div class=\"p-16 pb-24\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"h1 secondary-text\"><span>{{nowWidget.now.month}}</span></div><div \nclass=\"font-size-72 line-height-88 secondary-text font-weight-400\">{{nowWidget.now.day}}</div><div \nclass=\"h1 secondary-text\"><span>{{nowWidget.now.year}}</span></div></div><md-divider></md-divider></ms-widget-front>\n</ms-widget>");
$templateCache.put("app/main/clients/views/newoperation/controllers/dialog/sendPayrollReceipt.html","<md-dialog id=\"sendPayrollReceipt\" aria-label=\"Enviar recibos a Humand\"><md-toolbar class=\"dc-toolbar\"><div \nclass=\"md-toolbar-tools\"><h2 class=\"dc-title\"><md-icon md-font-icon=\"icon-clipboard-text\"></md-icon><span>\nEnvío de recibos a Humand</span></h2><span flex></span><md-button class=\"md-icon-button dc-close\" aria-label=\"Cerrar\" \nng-click=\"sprCtrl.close()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content class=\"dc-content\" layout=\"column\"><p class=\"dc-lead\">\n¿Seguro que deseas enviar los recibos a Humand?</p><p class=\"dc-sub\">\nEsta acción enviará los recibos de los empleados al sistema Humand.</p><section class=\"dc-section\" \nng-if=\"sprCtrl.sentList && sprCtrl.sentList.length\"><div class=\"dc-section-header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"dc-header-left\" layout=\"row\" layout-align=\"start center\"><h4>\nRecibos ya enviados</h4><span class=\"dc-badge\">{{ sprCtrl.sentList.length }}</span></div></div><div \nclass=\"dc-list dc-list--tight\"><div class=\"dc-list-item\" layout=\"row\" layout-align=\"start start\" \nng-repeat=\"emp in sprCtrl.sentList track by emp.id\"><div flex=\"5\" flex-xs=\"5\"><md-icon \nmd-font-icon=\"icon-check-circle\" class=\"dc-list-icon ok\"></md-icon></div><div class=\"dc-list-text\" flex=\"60\" \nflex-xs=\"nogrow\"><div class=\"dc-list-title\"><span class=\"name-ellipsis\">{{ emp.name }}</span> <span \nclass=\"dc-chip-status ok\" title=\"Enviado\">✅</span></div></div><div flex=\"20\" layout-xs=\"column\" flex-xs=\"20\"><span \nclass=\"dc-pill\" ng-if=\"emp.sent && emp.sent !== true\">{{ emp.sent|date:\'short\' }}</span></div><div \nclass=\"dc-list-actions\" flex-xs=\"5\" flex=\"10\"><button ng-click=\"sprCtrl.resendOne($index, emp)\" \nng-disabled=\"emp._sending\" aria-label=\"Reenviar recibo\"><md-icon md-font-icon=\"icon-refresh\" ng-if=\"!emp._sending\">\n</md-icon><md-progress-circular ng-if=\"emp._sending\" md-mode=\"indeterminate\" md-diameter=\"16\"></md-progress-circular>\n<span ng-if=\"emp._sending\">Enviando…</span></button><md-tooltip md-direction=\"top\" ng-if=\"!emp._sending\">\nReenviar recibo</md-tooltip></div></div></div><p class=\"dc-empty\" \nng-if=\"!sprCtrl.sentList || !sprCtrl.sentList.length\">Aún no hay recibos enviados.</p></section><section \nclass=\"dc-section\"><div class=\"dc-section-header\"><h4>Recibos por enviar</h4><span class=\"dc-badge\" \nng-if=\"sprCtrl.employeesData.length\">{{ sprCtrl.employeesData.length }}</span></div><div class=\"dc-chipset\" \nng-if=\"sprCtrl.employeesData.length\"><span class=\"dc-chip\" \nng-repeat=\"item in sprCtrl.employeesData track by (item.$id || item.id || $index)\"><md-icon \nmd-font-icon=\"icon-account\" class=\"dc-chip-icon\"></md-icon><span class=\"dc-chip-label mono\">{{ item.data.name }}</span>\n<md-progress-circular ng-if=\"item._sending\" md-mode=\"indeterminate\" md-diameter=\"14\"></md-progress-circular><span \nclass=\"dc-chip-status\" style=\"font-size: 20px\" ng-if=\"item._error\" title=\"Error\">⚠️</span><md-tooltip \nmd-direction=\"right\" style=\"font-size: 14px\" ng-if=\"item._error\">{{item._error}}</md-tooltip></span></div><p \nclass=\"dc-empty\" ng-if=\"!sprCtrl.employeesData.length\">Sin empleados pendientes.</p></section><section \nclass=\"dc-section\" ng-if=\"sprCtrl.unsynced && sprCtrl.unsynced.length\"><div class=\"dc-section-header\"><h4>\nNo sincronizados</h4><span class=\"dc-badge\" ng-if=\"sprCtrl.unsynced && sprCtrl.unsynced.length\">\n{{ sprCtrl.unsynced.length }}</span></div><div class=\"dc-chipset\"><span class=\"dc-chip\" \nng-repeat=\"item in sprCtrl.unsynced track by (item.$id || item.id || $index)\"><md-icon \nmd-font-icon=\"icon-alert-circle\" class=\"dc-list-icon md-warn\"></md-icon><span class=\"dc-chip-label mono\">\n{{ item.data.name }}<br><span style=\"font-size: 10px\">Sincronización pendiente con Humand</span></span></span></div><p \nclass=\"dc-empty\" ng-if=\"!sprCtrl.unsynced || !sprCtrl.unsynced.length\">Todo sincronizado ✔</p></section>\n</md-dialog-content><md-dialog-actions class=\"dc-actions\" layout=\"row\" layout-align=\"end center\"><md-button \nng-click=\"sprCtrl.close()\">Cerrar</md-button><md-button class=\"md-primary md-raised\" \nng-disabled=\"sprCtrl.errorSendReceipt\" ng-if=\"sprCtrl.employeesData.length > 0\" \nng-click=\"sprCtrl.confirm(sprCtrl.employeesData)\" aria-label=\"Enviar\">Enviar</md-button></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/config/views/concepts/dialogs/edit-concepts/edit-concepts.html","<md-dialog aria-label=\"Edit Concepts\" flex=\"95\" id=\"editConceptsDialog\"><form ng-cloak><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2 class=\"m-0\">Edición de conceptos</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"ecCtrl.cancel()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"p-15\"><div layout=\"row\" layout-align=\"start center\"><div flex><md-autocomplete \nclass=\"md-block\" flex md-min-length=\"2\" md-selected-item=\"ecCtrl.conceptSelected\" \nmd-search-text=\"ecCtrl.conceptSearchQuery\" md-item-text=\"item.name\" md-delay=\"500\" \nmd-items=\"item in ecCtrl.getConcepts(ecCtrl.conceptSearchQuery)\" md-require-match=\"true\" md-select-on-match=\"true\" \nplaceholder=\"Selecciona un concepto\" md-no-cache=\"true\" md-floating-label=\"Concepto\"><md-item-template><span \nmd-highlight-text=\"searchQuery\">\n{{item.name}} - {{item.center | getSomethingOfArrayFB : ecCtrl.centersData : \'name\' : \'NO CENTER\' : \'id\'}}</span>\n</md-item-template><md-not-found>No hay registros</md-not-found></md-autocomplete></div><div flex=\"nogrow\" \nclass=\"ml-5 mr-5\"><button ng-disabled=\"!ecCtrl.conceptSelected\" \nng-click=\"ecCtrl.addConceptForCompare(ecCtrl.conceptSelected,ecCtrl.addAllConcepts)\" \nclass=\"md-button md-raised md-primary\" aria-label=\"Save\"><md-icon md-font-icon=\"icon-plus\"></md-icon>Añadir</button>\n</div><div flex=\"nogrow\"><md-checkbox ng-model=\"ecCtrl.addAllConcepts\" class=\"mb-0\">Incluir conceptos con esta llave\n</md-checkbox></div></div><div><table class=\"simple table\" id=\"conceptComparisonTable\" \nng-if=\"ecCtrl.conceptsToCompare.length > 0\"><thead><tr><th>Campos</th><th \nng-repeat=\"($indexC,conceptId) in ecCtrl.conceptsToCompare\" class=\"p-5\"><div layout=\"column\"><div flex layout=\"row\">\n<span flex>{{ecCtrl.conceptsLoaded[conceptId].name}} <strong>\n({{ecCtrl.conceptsLoaded[conceptId].center | getSomethingOfArrayFB : ecCtrl.centersData : \'name\' : \'NO CENTER\' : \'id\'}})\n</strong></span><div flex=\"nogrow\"><md-icon md-font-icon=\"icon-trash\" \nng-click=\"ecCtrl.conceptsToCompare.splice($indexC,1);ecCtrl.compareCalculations();\" aria-label=\"delete concept\" \nclass=\"md-secondary md-accent md-hue-2\"><md-tooltip md-direction=\"top\">Eliminar concepto</md-tooltip></md-icon></div>\n<div flex=\"nogrow\"><md-icon ng-if=\"$indexC!==0 && ecCtrl.calcSelected[conceptId]>=0\" \nng-click=\"ecCtrl.setCalculation($indexC)\" aria-label=\"removeFromAccepted\" md-font-icon=\"icon-video-switch\"><md-tooltip \nmd-direction=\"top\">Copiar cálculos</md-tooltip></md-icon></div></div><md-input-container \nclass=\"md-block m-0 no-errors-spacer\" flex md-no-float><md-select ng-model=\"ecCtrl.calcSelected[conceptId]\" \nname=\"calcSelected\" placeholder=\"Selecciona un calculo\" required ng-change=\"ecCtrl.compareCalculations()\"><md-option \nng-value=\"undefined\">Ninguno</md-option><md-option ng-value=\"$index\" \nng-repeat=\"($index,calculation) in ecCtrl.conceptsLoaded[conceptId].calculations\">Calculo {{$index+1}}</md-option>\n</md-select></md-input-container></div></th></tr></thead><tbody><tr ng-repeat=\"($idField,field) in ecCtrl.fields\"><td>\n<label ng-class=\"{\'green-700-fg\':field.same.formule,\'red-700-fg\':!field.same.formule}\">{{field.id}}</label><div><span \nng-repeat=\"(key,value) in field.same\" ng-if=\"key != \'formule\'\" class=\"text-boxed p-1 m-0 mr-5 text-bold\" \nng-class=\"{\'green-300-bg\':value,\'red-300-bg\':!value}\">{{key}}</span></div></td><td class=\"conceptFormule\" \nng-repeat=\"($indexC,conceptId) in ecCtrl.conceptsToCompare\"><p class=\"mb-0 mt-0\" \nng-class=\"{\'green-700-fg\':field.same.formule,\'red-700-fg\':!field.same.formule}\">\n{{field.calculations[conceptId].formule}}</p><p class=\"mb-0\" \nng-class=\"{\'green-700-fg\':field.same.validation,\'red-700-fg\':!field.same.validation}\">\n{{field.calculations[conceptId].validation}}</p></td></tr></tbody></table></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/apps/chat/sidenavs/left/views/chats/chats-view.html","<md-toolbar class=\"md-tall\"><div class=\"md-toolbar-tools md-toolbar-tools-top\"><div class=\"avatar-wrapper\"><img \nng-click=\"toggleLeftSidenavView(\'user\')\" \nng-src=\"{{F.profile.data.avatar?F.profile.data.avatar:\'assets/images/avatars/profile.jpg\'}}\" class=\"md-avatar avatar\" \nalt=\"{{F.profile.data.avatar}}\"><md-menu id=\"user-status-menu\"><i ng-click=\"$mdOpenMenu()\" aria-label=\"profile status\" \nclass=\"icon icon-s16 status\" ng-class=\"F.profile.status\"></i><md-menu-content><md-menu-item><md-button \nng-click=\"setUserStatus(\'online\')\"><div layout=\"row\" layout-align=\"start center\"><i \nclass=\"icon s16 status icon-checkbox-marked-circle mr-8 green-fg\"></i> <span translate=\"CHAT.STATUS_ONLINE\">Online\n</span></div></md-button></md-menu-item><md-menu-item><md-button ng-click=\"setUserStatus(\'away\')\"><div layout=\"row\" \nlayout-align=\"start center\"><i class=\"icon s16 status icon-clock mr-8 yellow-fg\"></i> <span \ntranslate=\"CHAT.STATUS_AWAY\">Away</span></div></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"setUserStatus(\'do-not-disturb\')\"><div layout=\"row\" layout-align=\"start center\"><i \nclass=\"icon s16 status icon-minus-circle mr-8 red-fg\"></i> <span translate=\"CHAT.STATUS_DO_NOT_DISTURB\">Do not disturb\n</span></div></md-button></md-menu-item><md-menu-item><md-button ng-click=\"setUserStatus(\'offline\')\"><div layout=\"row\" \nlayout-align=\"start center\"><i class=\"icon s16 status icon-checkbox-blank-circle-outline mr-8 green-fg\"></i> <span \ntranslate=\"CHAT.STATUS_OFFLINE\">Offline</span></div></md-button></md-menu-item></md-menu-content></md-menu></div>\n<md-menu md-position-mode=\"target-right target\"><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\">\n<md-menu-item><md-button ng-click=\"toggleLeftSidenavView(\'user\')\" translate=\"CHAT.PROFILE\">Profile</md-button>\n</md-menu-item></md-menu-content></md-menu></div><div class=\"md-toolbar-tools md-toolbar-tools-bottom\"><div \nclass=\"search-wrapper md-whiteframe-1dp\" layout=\"row\" layout-align=\"start center\" flex><div class=\"search\" flex \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s18\"></md-icon><input flex \nng-model=\"F.chatSearch\" type=\"text\" placeholder=\"Search or start new chat\" translate=\"\" \ntranslate-attr-placeholder=\"CHAT.CHAT_SEARCH_PLACEHOLDER\"></div></div></div></md-toolbar><md-content flex ms-scroll>\n<md-list class=\"chat-list\"><div ng-show=\"F.chatSearch && filteredChat.length > 0\" class=\"md-accent-fg subheader\" \nng-style=\"{\'transform\':\'translate3d(0px, 0px, 0px)\', \'z-index\': filteredChat.length + filteredContact.length }\" \ntranslate=\"CHAT.CHATS\">CHATS</div><md-list-item class=\"contact md-3-line\" \nng-style=\"{\'transform\': ( F.chatSearch && filteredChat.length > 0 ) ?\'translate3d(0px, \'+($index + 1)* 100+\'%, 0px)\': \'translate3d(0px, \'+$index* 100+\'%, 0px)\', \'z-index\': filteredChat.length + filteredContact.length - $index}\" \nng-repeat=\"($index,chat) in CF.chats | filter: {name: F.chatSearch}  |  orderBy: \'date_updated\' :true | filter:query as filteredChat\" \nng-click=\"getChat(chat.id)\" ng-class=\"{\'unread\':chat.unreaded_msg}\"><div class=\"avatar-wrapper\"><img \nng-src=\"{{chat.avatar}}\" class=\"md-avatar avatar\" alt=\"{{chat.name}}\"> <i class=\"icon icon- s16 status\" \nng-class=\"getFriendStatus(chat.participants)\"></i></div><div class=\"md-list-item-text\"><h3 class=\"name\">{{chat.name}}\n</h3><p class=\"last-message\">{{chat.last_msg}}</p></div><div layout=\"column\" layout-align=\"center end\"><div \nclass=\"last-message-time\">{{chat.last_msg.time | altDate}}</div><div ng-if=\"chat.unreaded_msg\" \nclass=\"md-accent-bg unread-message-count\">{{chat.unreaded_msg}}</div></div><md-divider></md-divider></md-list-item>\n</md-list><md-list class=\"contact-list\"><div ng-show=\"F.chatSearch && filteredContact.length > 0\" \nclass=\"md-accent-fg subheader\" \nng-style=\"{\'transform\': (filteredContact.length > 0 && filteredChat.length > 0 ) ? \'translate3d(0px, \'+(filteredChat.length +1) * 100+\'%, 0px)\':\'translate3d(0px, 0px, 0px)\', \'z-index\': filteredContact.length}\" \ntranslate=\"CHAT.CONTACTS\">CONTACTS</div><md-list-item class=\"contact md-3-line\" ng-show=\"F.chatSearch\" \nng-style=\"{\'transform\': (filteredContact.length > 0 && filteredChat.length > 0 ) ?\'translate3d(0px, \'+(filteredChat.length + $index +2)* 100+\'%, 0px)\': \'translate3d(0px, \'+ ($index + 1)* 100+\'%, 0px)\', \'z-index\': filteredContact.length - $index}\" \nng-repeat=\"contact in CF.contacts  | filter: {name: F.chatSearch} | orderBy: \'name\' :false | filter:query as filteredContact\" \nng-click=\"getChatByContactId(contact.id)\"><div class=\"avatar-wrapper\"><img ng-src=\"{{contact.avatar}}\" \nclass=\"md-avatar avatar\" alt=\"{{contact.name}}\"> <i class=\"icon icon- s16 status\" ng-class=\"contact.status\"></i></div>\n<div class=\"md-list-item-text\"><h3>{{contact.name}}</h3><p class=\"mood\">{{contact.status}}</p></div><md-divider>\n</md-divider></md-list-item></md-list><div ng-hide=\"(filteredChat.length + filteredContact.length) > 0\" \nclass=\"no-results-message\" translate=\"CHAT.NO_RESULTS\">No results..</div></md-content><md-button \nclass=\"md-fab contacts-button\" ng-click=\"toggleLeftSidenavView(\'contacts\')\" aria-label=\"contacts button\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button>");
$templateCache.put("app/main/apps/chat/sidenavs/left/views/contacts/contacts-view.html","<md-toolbar class=\"md-tall md-accent\"><div class=\"md-toolbar-tools md-toolbar-tools-top\"><md-button \nclass=\"md-icon-button\" ng-click=\"toggleLeftSidenavView(false)\" aria-label=\"back button\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><h3><span translate=\"CHAT.CONTACTS\">CONTACTS</span></h3></div><div\n class=\"md-toolbar-tools md-toolbar-tools-bottom\"><div class=\"search-wrapper md-whiteframe-1dp\" layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"search\" flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon s18\"></md-icon><input flex ng-model=\"F.contactSearch\" type=\"text\" \nplaceholder=\"Search contact\" translate=\"\" translate-attr-placeholder=\"CHAT.CONTACTS_SEARCH_PLACEHOLDER\"></div></div>\n</div></md-toolbar><md-content flex ms-scroll><md-list class=\"contact-list\"><md-list-item class=\"contact md-3-line\" \nng-repeat=\"contact in CF.contacts  | filter: {name: F.contactSearch} | orderBy: \'name\' :false | filter:query as filteredContact\" \nng-style=\"{\'transform\': \'translate3d(0px, \'+$index * 100+\'%, 0px)\', \'z-index\': filteredContact.length - $index}\" \nng-click=\"getChatByContactId(contact.id)\"><div class=\"fist-letter md-accent-fg\" \nng-if=\"(filteredContact[$index].name.charAt(0)|uppercase) !== (filteredContact[$index-1].name.charAt(0)|uppercase)\">\n{{contact.name.charAt(0)|uppercase}}</div><div class=\"avatar-wrapper\"><img ng-src=\"{{contact.avatar}}\" \nclass=\"md-avatar avatar\" alt=\"{{contact.name}}\"> <i class=\"icon icon- s16 status\" ng-class=\"contact.status\"></i></div>\n<div class=\"md-list-item-text\"><h3>{{contact.name}}</h3><p class=\"mood\">{{contact.mood}}</p></div></md-list-item>\n</md-list><div ng-if=\"filteredContact.length <= 0\" class=\"no-results-message\" translate=\"CHAT.NO_RESULTS\">No results..\n</div></md-content>");
$templateCache.put("app/main/apps/chat/sidenavs/right/views/contact/contact-view.html","<md-toolbar class=\"md-tall md-accent\"><div class=\"md-toolbar-tools md-toolbar-tools-top\"><div \ntranslate=\"CHAT.CONTACT_INFO\">Contact Info</div><div flex></div><md-button class=\"md-icon-button\" \nng-click=\"$scope.toggleSidenav(\'right-sidenav\')\" aria-label=\"back\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div><div class=\"md-toolbar-tools md-toolbar-tools-bottom\" flex layout=\"column\" \nlayout-align=\"center center\"><div layout=\"column\" layout-align=\"center center\"><img \nng-src=\"{{$scope.contacts.getById($scope.chatContactId).avatar}}\" class=\"md-avatar avatar contact-avatar huge\" \nalt=\"{{$scope.contacts.getById($scope.chatContactId).name}}\"><div class=\"contact-name\">\n{{$scope.contacts.getById($scope.chatContactId).name}}</div></div></div></md-toolbar><md-content flex ms-scroll \nms-padding><md-card><md-card-title translate=\"CHAT.MOOD\">Mood</md-card-title><md-card-content><span class=\"mood\" \nng-if=\"$scope.contacts.getById($scope.chatContactId).mood\">{{$scope.contacts.getById($scope.chatContactId).mood}}\n</span></md-card-content></md-card></md-content>");
$templateCache.put("app/main/apps/chat/sidenavs/left/views/user/user-view.html","<md-toolbar class=\"md-tall md-accent\"><div class=\"md-toolbar-tools md-toolbar-tools-top\"><md-button \nclass=\"md-icon-button\" ng-click=\"toggleLeftSidenavView(false)\" aria-label=\"back\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button></div><div class=\"md-toolbar-tools md-toolbar-tools-bottom\" flex \nlayout=\"column\" layout-align=\"center center\"><div layout=\"column\" layout-align=\"center center\"><img \nng-src=\"{{F.profile.data.avatar?F.profile.data.avatar:\'assets/images/avatars/profile.jpg\'}}\" \nclass=\"md-avatar avatar user-avatar huge\" alt=\"{{F.profile.data.name}}\"><div class=\"user-name\">{{F.profile.data.name}}\n</div></div></div></md-toolbar><md-content flex ms-scroll ms-padding><md-card><md-card-title>Mood</md-card-title>\n<md-card-content><span class=\"mood\" editable-textarea=\"F.profile.data.mood\" e-rows=\"7\" e-cols=\"40\">\n{{F.profile.data.mood || \'CHAT.ENTER_MOOD_MESSAGE\' | translate}}</span></md-card-content></md-card></md-content>");}]);